/*!
 *
 * Bryntum Gantt 4.3.6
 *
 * Copyright(c) 2022 Bryntum AB
 * https://bryntum.com/contact
 * https://bryntum.com/license
 *
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gantt", [], factory);
	else if(typeof exports === 'object')
		exports["gantt"] = factory();
	else
		root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["gantt"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./webpack/webpack.entry.umd.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../node_modules/process/browser.js":
/*!******************************************!*\
  !*** ../node_modules/process/browser.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../node_modules/webpack/buildin/global.js":
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/global.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./lib/ChronoGraph/chrono/CycleResolver.js":
/*!*************************************************!*\
  !*** ./lib/ChronoGraph/chrono/CycleResolver.js ***!
  \*************************************************/
/*! exports provided: CycleResolutionInputChrono */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInputChrono", function() { return CycleResolutionInputChrono; });
/* harmony import */ var _cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
var productName = 'gantt';

 //---------------------------------------------------------------------------------------------------------------------

/**
 * A subclass of [[CycleResolutionInput]] with additional convenience method [[collectInfo]].
 */

class CycleResolutionInputChrono extends _cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolutionInput"] {
  /**
   * This method, given an effect handler, identifier and a variable, will add [[CycleResolutionInput.addPreviousValueFlag|previous value]]
   * and [[CycleResolutionInput.addProposedValueFlag|proposed value]] flags for that variable.
   *
   * @param Y An effect handler function, which is given as a 1st argument of every calculation function
   * @param identifier
   * @param symbol
   */
  collectInfo(Y, identifier, symbol) {
    if (Y(Object(_Effect_js__WEBPACK_IMPORTED_MODULE_1__["PreviousValueOf"])(identifier)) != null) this.addPreviousValueFlag(symbol);
    if (Y(Object(_Effect_js__WEBPACK_IMPORTED_MODULE_1__["HasProposedValue"])(identifier))) this.addProposedValueFlag(symbol);
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Effect.js":
/*!******************************************!*\
  !*** ./lib/ChronoGraph/chrono/Effect.js ***!
  \******************************************/
/*! exports provided: BreakCurrentStackExecution, Effect, ProposedOrPreviousSymbol, ProposedOrPrevious, RejectSymbol, RejectEffect, Reject, TransactionSymbol, GetTransaction, OwnQuarkSymbol, OwnQuark, OwnIdentifierSymbol, OwnIdentifier, WriteSymbol, WriteEffect, Write, WriteSeveralSymbol, WriteSeveralEffect, WriteSeveral, PreviousValueOfSymbol, PreviousValueOfEffect, PreviousValueOf, ProposedValueOfSymbol, ProposedValueOfEffect, ProposedValueOf, HasProposedValueSymbol, HasProposedValueEffect, HasProposedValue, ProposedOrPreviousValueOfSymbol, ProposedOrPreviousValueOfEffect, ProposedOrPreviousValueOf, ProposedArgumentsOfSymbol, ProposedArgumentsOfEffect, ProposedArgumentsOf, UnsafeProposedOrPreviousValueOfSymbol, UnsafeProposedOrPreviousValueOfEffect, UnsafeProposedOrPreviousValueOf, UnsafePreviousValueOfSymbol, UnsafePreviousValueOfEffect, UnsafePreviousValueOf */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreakCurrentStackExecution", function() { return BreakCurrentStackExecution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Effect", function() { return Effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousSymbol", function() { return ProposedOrPreviousSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPrevious", function() { return ProposedOrPrevious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RejectSymbol", function() { return RejectSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RejectEffect", function() { return RejectEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reject", function() { return Reject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionSymbol", function() { return TransactionSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetTransaction", function() { return GetTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnQuarkSymbol", function() { return OwnQuarkSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnQuark", function() { return OwnQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifierSymbol", function() { return OwnIdentifierSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifier", function() { return OwnIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSymbol", function() { return WriteSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteEffect", function() { return WriteEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Write", function() { return Write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralSymbol", function() { return WriteSeveralSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralEffect", function() { return WriteSeveralEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveral", function() { return WriteSeveral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfSymbol", function() { return PreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfEffect", function() { return PreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOf", function() { return PreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfSymbol", function() { return ProposedValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfEffect", function() { return ProposedValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOf", function() { return ProposedValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueSymbol", function() { return HasProposedValueSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueEffect", function() { return HasProposedValueEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValue", function() { return HasProposedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfSymbol", function() { return ProposedOrPreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfEffect", function() { return ProposedOrPreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOf", function() { return ProposedOrPreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfSymbol", function() { return ProposedArgumentsOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfEffect", function() { return ProposedArgumentsOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOf", function() { return ProposedArgumentsOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfSymbol", function() { return UnsafeProposedOrPreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfEffect", function() { return UnsafeProposedOrPreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOf", function() { return UnsafeProposedOrPreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfSymbol", function() { return UnsafePreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfEffect", function() { return UnsafePreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOf", function() { return UnsafePreviousValueOf; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


 //---------------------------------------------------------------------------------------------------------------------

const BreakCurrentStackExecution = Symbol('BreakCurrentStackExecution'); //---------------------------------------------------------------------------------------------------------------------

/**
 * The base class for effect. Effect is some value, that can be send to the "outer" calculation context, using the
 * effect handler function. Effect handler then will process an effect and return some resulting value.
 *
 * ```ts
 * const identifier  = graph.identifier((Y : SyncEffectHandler) : number => {
 *     const proposedValue : number    = Y(ProposedOrPrevious)
 *
 *     const maxValue : number         = Y(max)
 *
 *     return proposedValue <= maxValue ? proposedValue : maxValue
 * })
 * ```
 */

class Effect extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__["prototypeValue"])(true)], Effect.prototype, "sync", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__["prototypeValue"])(true)], Effect.prototype, "pure", void 0); //---------------------------------------------------------------------------------------------------------------------


const ProposedOrPreviousSymbol = Symbol('ProposedOrPreviousSymbol');
/**
 * The constant that represents a request for either user input (proposed value) or previous value of the
 * identifier, currently being calculated.
 *
 * Important note, is that if an identifier yields a `ProposedOrPrevious` effect and its computed value does not match the value of this effect,
 * it will be re-calculated (computation function called) again on the next read. This is because the value of its `ProposedOrPrevious` input changes.
 *
 * ```ts
 * const graph4 = ChronoGraph.new()
 *
 * const max           = graph4.variable(100)
 *
 * const identifier15  = graph4.identifier((Y) : number => {
 *     const proposedValue : number    = Y(ProposedOrPrevious)
 *
 *     const maxValue : number         = Y(max)
 *
 *     return proposedValue <= maxValue ? proposedValue : maxValue
 * })
 *
 * graph4.write(identifier15, 18)
 *
 * const value15_1 = graph4.read(identifier15) // 18
 *
 * graph4.write(identifier15, 180)
 *
 * const value15_2 = graph4.read(identifier15) // 100
 *
 * graph4.write(max, 50)
 *
 * const value15_3 = graph4.read(identifier15) // 50
 * ```
 */

const ProposedOrPrevious = Effect.new({
  handler: ProposedOrPreviousSymbol
}); //---------------------------------------------------------------------------------------------------------------------

const RejectSymbol = Symbol('RejectSymbol');
/**
 * Class for [[Reject]] effect.
 */

class RejectEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = RejectSymbol;
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__["prototypeValue"])(false)], RejectEffect.prototype, "pure", void 0);
/**
 * This is constructor for `RejectEffect` class. If this effect will be yielded during computation the current transaction
 * will be [[ChronoGraph.reject|rejected]].
 *
 * @param reason
 * @constructor
 */


const Reject = reason => RejectEffect.new({
  reason
}); //---------------------------------------------------------------------------------------------------------------------

const TransactionSymbol = Symbol('TransactionSymbol');
const GetTransaction = Effect.new({
  handler: TransactionSymbol
}); //---------------------------------------------------------------------------------------------------------------------

const OwnQuarkSymbol = Symbol('OwnQuarkSymbol');
const OwnQuark = Effect.new({
  handler: OwnQuarkSymbol
}); //---------------------------------------------------------------------------------------------------------------------

const OwnIdentifierSymbol = Symbol('OwnIdentifierSymbol');
const OwnIdentifier = Effect.new({
  handler: OwnIdentifierSymbol
}); //---------------------------------------------------------------------------------------------------------------------

const WriteSymbol = Symbol('WriteSymbol');
class WriteEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = WriteSymbol;
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__["prototypeValue"])(false)], WriteEffect.prototype, "pure", void 0);

const Write = (identifier, proposedValue, ...proposedArgs) => WriteEffect.new({
  identifier,
  proposedArgs: [proposedValue, ...proposedArgs]
});
const WriteSeveralSymbol = Symbol('WriteSeveralSymbol');
class WriteSeveralEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = WriteSeveralSymbol;
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_1__["prototypeValue"])(false)], WriteSeveralEffect.prototype, "pure", void 0);

const WriteSeveral = writes => WriteSeveralEffect.new({
  writes
}); //---------------------------------------------------------------------------------------------------------------------

const PreviousValueOfSymbol = Symbol('PreviousValueOfSymbol');
class PreviousValueOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = PreviousValueOfSymbol;
  }

}
const PreviousValueOf = identifier => PreviousValueOfEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const ProposedValueOfSymbol = Symbol('ProposedValueOfSymbol');
class ProposedValueOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = ProposedValueOfSymbol;
  }

}
const ProposedValueOf = identifier => ProposedValueOfEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const HasProposedValueSymbol = Symbol('HasProposedValueSymbol');
class HasProposedValueEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = HasProposedValueSymbol;
  }

}
const HasProposedValue = identifier => HasProposedValueEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const ProposedOrPreviousValueOfSymbol = Symbol('ProposedOrPreviousValueOfSymbol');
class ProposedOrPreviousValueOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = ProposedOrPreviousValueOfSymbol;
  }

}
const ProposedOrPreviousValueOf = identifier => ProposedOrPreviousValueOfEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const ProposedArgumentsOfSymbol = Symbol('ProposedArgumentsOfSymbol');
class ProposedArgumentsOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = ProposedArgumentsOfSymbol;
  }

}
const ProposedArgumentsOf = identifier => ProposedArgumentsOfEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const UnsafeProposedOrPreviousValueOfSymbol = Symbol('UnsafeProposedOrPreviousValueOfSymbol');
class UnsafeProposedOrPreviousValueOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = UnsafeProposedOrPreviousValueOfSymbol;
  }

}
const UnsafeProposedOrPreviousValueOf = identifier => UnsafeProposedOrPreviousValueOfEffect.new({
  identifier
}); //---------------------------------------------------------------------------------------------------------------------

const UnsafePreviousValueOfSymbol = Symbol('UnsafePreviousValueOfSymbol');
class UnsafePreviousValueOfEffect extends Effect {
  constructor() {
    super(...arguments);
    this.handler = UnsafePreviousValueOfSymbol;
  }

}
const UnsafePreviousValueOf = identifier => UnsafePreviousValueOfEffect.new({
  identifier
});

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Graph.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/chrono/Graph.js ***!
  \*****************************************/
/*! exports provided: CommitZero, Listener, ChronoGraph */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommitZero", function() { return CommitZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Listener", function() { return Listener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoGraph", function() { return ChronoGraph; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _Revision_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Transaction.js */ "./lib/ChronoGraph/chrono/Transaction.js");
var productName = 'gantt';









/**
 * A constant which will be used a commit result, when graph is not available.
 */

const CommitZero = {
  rejectedWith: null
}; //---------------------------------------------------------------------------------------------------------------------

class Listener extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.handlers = [];
  }

  trigger(value) {
    for (let i = 0; i < this.handlers.length; i++) this.handlers[i](value);
  }

} //---------------------------------------------------------------------------------------------------------------------

/**
 * Generic reactive graph. Consists from [[Identifier]]s, depending on each other. This is a low-level representation
 * of the ChronoGraph dataset, it is not "aware" of the entity/relation framework and operates as "just graph".
 *
 * For higher-level (and more convenient) representation, please refer to [[Replica]].
 *
 * An example of usage:
 *
 *     const graph      = ChronoGraph.new({ historyLimit : 10 })
 *
 *     const var1       = graph.variable(1)
 *     const var2       = graph.variable(2)
 *     const iden1      = graph.identifier((Y) => Y(var1) + Y(var2))
 *
 *     graph.read(iden1) // 3
 *
 *     graph.commit()
 *
 *     graph.write(var1, 2)
 *
 *     graph.read(iden1) // 4
 *
 *     graph.reject()
 *
 *     graph.read(var1) // 1
 *     graph.read(iden1) // 3
 *
 */

class ChronoGraph extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.baseRevisionStable = undefined;
    this.baseRevisionTentative = undefined;
    this.baseRevision = _Revision_js__WEBPACK_IMPORTED_MODULE_7__["Revision"].new(); // the revision to follow to, when performing `redo` operation

    this.topRevision = undefined;
    /**
     * Integer value, indicating how many transactions to keep in memory, to be available for [[undo]] call.
     * Default value is 0 - previous transaction is cleared immediately.
     *
     * Increase this config to opt-in for the [[undo]]/[[redo]] functionality.
     */

    this.historyLimit = 0;
    this.listeners = new Map();
    this.$activeTransaction = undefined;
    this.isCommitting = false;
    this.enableProgressNotifications = false;
    this.ongoing = Promise.resolve();
    this._isInitialCommit = true; //-------------------------------------
    // a "cross-platform" trick to avoid specifying the type of the `autoCommitTimeoutId` explicitly

    this.autoCommitTimeoutId = null;
    /**
     * If this option is enabled with `true` value, all data modification calls ([[write]], [[addIdentifier]], [[removeIdentifier]]) will trigger
     * a delayed [[commit]] call (or [[commitAsync]], depending from the [[autoCommitMode]] option).
     */

    this.autoCommit = false;
    /**
     * Indicates the default commit mode, which is used in [[autoCommit]].
     */

    this.autoCommitMode = 'sync';
    this.autoCommitHandler = null;
    this.onWriteDuringCommit = 'throw';
    this.onComputationCycle = 'throw';
    this.transactionClass = _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["Transaction"];
    this.$followingRevision = undefined;
  }

  initialize(...args) {
    super.initialize(...args);
    if (!this.topRevision) this.topRevision = this.baseRevision;

    if (this.autoCommit) {
      this.autoCommitHandler = this.autoCommitMode === 'sync' ? arg => this.commit(arg) : async arg => this.commitAsync(arg);
    }

    this.markAndSweep();
  }
  /**
   * Returns boolean, indicating whether the auto-commit is pending.
   */


  hasPendingAutoCommit() {
    return this.autoCommitTimeoutId !== null;
  }

  get dirty() {
    return this.activeTransaction.dirty;
  }

  clear() {
    this.reject();
    this.unScheduleAutoCommit(); // some stale state - `clear` called at sensitive time

    this.baseRevision.scope && this.baseRevision.scope.clear();
    this.baseRevision.previous = null;
    this.listeners.clear();
    this.topRevision = this.baseRevision;
    this.$followingRevision = undefined;
    this.$activeTransaction = undefined;
    this.markAndSweep();
  }

  *eachReachableRevision() {
    let isBetweenTopBottom = true;
    let counter = 0;

    for (const revision of this.topRevision.previousAxis()) {
      yield [revision, isBetweenTopBottom || counter < this.historyLimit];

      if (revision === this.baseRevision) {
        isBetweenTopBottom = false;
      } else {
        if (!isBetweenTopBottom) counter++;
      }
    }
  }

  get isInitialCommit() {
    return this._isInitialCommit;
  }

  set isInitialCommit(value) {
    this._isInitialCommit = value;
  }

  markAndSweep() {
    let lastReferencedRevision;
    const unreachableRevisions = [];

    for (const [revision, isReachable] of this.eachReachableRevision()) {
      if (isReachable) {
        revision.reachableCount++;
        lastReferencedRevision = revision;
      } else unreachableRevisions.push(revision);

      revision.referenceCount++;
    }

    unreachableRevisions.unshift(lastReferencedRevision);

    for (let i = unreachableRevisions.length - 1; i >= 1 && unreachableRevisions[i].reachableCount === 0; i--) {
      this.compactRevisions(unreachableRevisions[i - 1], unreachableRevisions[i]);
    }
  }

  compactRevisions(newRev, prevRev) {
    if (prevRev.reachableCount > 0 || newRev.previous !== prevRev) throw new Error("Invalid compact operation"); // we can only shred revision if its being referenced maximum 1 time (from the current Checkout instance)

    if (prevRev.referenceCount <= 1) {
      for (const [identifier, entry] of newRev.scope) {
        if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_6__["TombStone"]) {
          prevRev.scope.delete(identifier);
        } else {
          const prevQuark = prevRev.scope.get(identifier);

          if (entry.origin === entry) {
            if (prevQuark) {
              prevQuark.clear();
              prevQuark.clearProperties();
            }
          } else if (prevQuark && entry.origin === prevQuark) {
            entry.mergePreviousOrigin(newRev.scope);
          } else if (identifier.lazy && !entry.origin && prevQuark && prevQuark.origin) {
            // for lazy quarks, that depends on the `ProposedOrPrevious` effect, we need to save the value or proposed value
            // from the previous revision
            entry.startOrigin().proposedValue = prevQuark.origin.value !== undefined ? prevQuark.origin.value : prevQuark.origin.proposedValue;
          }

          entry.previous = undefined;
          prevRev.scope.set(identifier, entry);
        }
      }

      Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["copySetInto"])(newRev.selfDependent, prevRev.selfDependent); // some help for garbage collector
      // this clears the "entries" in the transaction commit result in the "finalizeCommitAsync"
      // newRev.scope.clear()

      newRev.scope = prevRev.scope; // make sure the previous revision won't be used inconsistently

      prevRev.scope = null;
    } // otherwise, we have to copy from it, and keep it intact
    else {
      newRev.scope = new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_1__["concat"])(prevRev.scope, newRev.scope));
      newRev.selfDependent = new Set(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_1__["concat"])(prevRev.selfDependent, newRev.selfDependent));
      prevRev.referenceCount--;
    } // in both cases break the `previous` chain


    newRev.previous = null;
  }

  get followingRevision() {
    if (this.$followingRevision !== undefined) return this.$followingRevision;
    const revisions = Array.from(this.topRevision.previousAxis());
    const entries = [];

    for (let i = revisions.length - 1; i > 0; i--) entries.push([revisions[i], revisions[i - 1]]);

    return this.$followingRevision = new Map(entries);
  }

  get activeTransaction() {
    if (this.$activeTransaction) return this.$activeTransaction;
    return this.$activeTransaction = this.transactionClass.new({
      baseRevision: this.baseRevisionTentative || this.baseRevision,
      graph: this
    });
  }
  /**
   * Creates a new branch of this graph. Only committed data will be "visible" in the new branch.
   *
   * ```ts
   * const graph2 = ChronoGraph.new()
   *
   * const variable13 : Variable<number> = graph2.variable(5)
   *
   * const branch2 = graph2.branch()
   *
   * branch2.write(variable13, 10)
   *
   * const value13_1 = graph2.read(variable13)  // 5
   * const value13_2 = branch2.read(variable13) // 10
   * ```
   *
   * When using the branching feature in [[Replica]], you need to reference the field values by yielding their
   * corresponding identifiers. This is because ChronoGraph need to know in context of which branch
   * the calculation happens and this information is encoded in the outer context. This may improve in the future.
   *
   * ```ts
   * class Author extends Entity.mix(Base) {
   *     @calculate('fullName')
   *     calculateFullName (Y) : string {
   *         return Y(this.$.firstName) + ' ' + Y(this.$.lastName)
   *     }
   *
   *     @calculate('fullName')
   *     * calculateFullName (Y) : CalculationIterator<string> {
   *         return (yield this.$.firstName) + ' ' + (yield this.$.lastName)
   *     }
   * }
   * ```
   *
   * @param config Configuration object for the new graph instance.
   */


  branch(config) {
    const Constructor = this.constructor;
    return Constructor.new(Object.assign({}, config, {
      baseRevision: this.baseRevision
    }));
  }

  propagate(args) {
    return this.commit(args);
  }
  /**
   * Rejects the current changes in the graph and revert it to the state of the previous [[commit]].
   *
   * See also [[RejectEffect]].
   *
   * @param reason Any value, describing why reject has happened
   */


  reject(reason) {
    this.activeTransaction.reject(_Effect_js__WEBPACK_IMPORTED_MODULE_4__["RejectEffect"].new({
      reason
    })); // reject resets the `ongoing` promise (which is possibly rejected because of cycle exception)

    this.ongoing = Promise.resolve();
    this.$activeTransaction = undefined;
    this.baseRevisionTentative = undefined;

    if (this.baseRevisionStable) {
      this.baseRevision = this.baseRevisionStable;
      this.baseRevisionStable = undefined;
    }
  }
  /**
   * Synchronously commit the state of the graph. All potentially changed [[Identifier.lazy|strict]] identifiers
   * will be calculated during this call. If any of such identifiers will be [[Identifier.sync|async]], an exception
   * will be thrown.
   *
   * This call marks a "stable" state of the graph and a transaction border. Using the [[undo]] call one can revert to the previous
   * state.
   *
   * See also [[reject]].
   *
   * @param args
   */


  commit(args) {
    // TODO should have a "while" loop adding extra transactions, similar to `commitAsync`
    this.unScheduleAutoCommit();
    this.baseRevisionStable = this.baseRevision;
    const activeTransaction = this.activeTransaction;
    const transactionCommitResult = activeTransaction.commit(args);
    this.$activeTransaction = undefined;
    const result = this.finalizeCommit(transactionCommitResult);
    this.baseRevisionStable = undefined;
    this.isInitialCommit = false;
    return result;
  }

  async propagateAsync(args) {
    return this.commitAsync(args);
  }
  /**
   * Asynchronously commit the state of the replica. All potentially changed strict identifiers (see [[Identifier.lazy]])
   * will be calculated during this call.
   *
   * This call marks a "stable" state of the graph and a transaction border. Using the [[undo]] call one can revert to the previous
   * state.
   *
   * See also [[reject]].
   *
   * @param args
   */


  async commitAsync(args) {
    if (this.isCommitting) return this.ongoing;
    this.isCommitting = true;
    this.baseRevisionStable = this.baseRevision;
    let result;
    return this.ongoing = this.ongoing.then(() => {
      return this.doCommitAsync(args);
    }).then(res => {
      result = res;
      return res;
    }).finally(() => {
      this.baseRevisionStable = undefined;
      this.baseRevisionTentative = undefined;
      this.isInitialCommit = false;
      this.isCommitting = false;
    });
  }

  async doCommitAsync(args) {
    this.unScheduleAutoCommit();
    const activeTransaction = this.activeTransaction;
    const transactionResult = await activeTransaction.commitAsync(args);
    this.baseRevisionTentative = activeTransaction.candidate;
    this.$activeTransaction = undefined;
    const result = this.finalizeCommit(transactionResult);
    await this.finalizeCommitAsync(transactionResult);
    if (activeTransaction.rejectedWith) activeTransaction.clearRejected();

    if (this.dirty) {
      await this.doCommitAsync(args);
    }

    return result;
  }

  finalizeCommit(transactionResult) {
    const {
      revision,
      entries,
      transaction
    } = transactionResult;

    if (!transaction.rejectedWith) {
      if (revision.previous !== this.baseRevision) throw new Error('Invalid revisions chain'); // dereference all revisions

      for (const [revision, isReachable] of this.eachReachableRevision()) {
        if (isReachable) revision.reachableCount--;
        revision.referenceCount--;
      }

      this.baseRevision = this.topRevision = revision; // activating listeners BEFORE the `markAndSweep`, because in that call, `baseRevision`
      // might be already merged with previous

      for (const [identifier, quarkEntry] of entries) {
        quarkEntry.cleanup(); // ignore "shadowing" and lazy entries

        if (quarkEntry.isShadow() || !quarkEntry.hasValue()) continue;
        const listener = this.listeners.get(identifier);
        if (listener) listener.trigger(quarkEntry.getValue());
      }

      this.$followingRevision = undefined;
      this.markAndSweep();
    } else {
      // `baseRevisionStable` might be already cleared in the `reject` method of the graph
      if (this.baseRevisionStable) this.baseRevision = this.baseRevisionStable;
      this.baseRevisionStable = undefined;
      this.baseRevisionTentative = undefined;
    }

    return {
      rejectedWith: transaction.rejectedWith
    };
  }

  async finalizeCommitAsync(transactionResult) {}

  *onComputationCycleHandler(cycle) {
    const exception = new Error("Computation cycle:\n" + cycle); //@ts-ignore

    exception.cycle = cycle;

    switch (this.onComputationCycle) {
      case 'ignore':
        console.log(exception.message);
        const {
          requestedEntry,
          activeEntry
        } = cycle; // if we ignore the cycle we just continue the calculation with the best possible value

        return activeEntry.continueCalculation(requestedEntry.proposedValue !== undefined ? requestedEntry.proposedValue : requestedEntry.value);

      case 'throw':
        throw exception;

      case 'reject':
        this.reject(exception);
        break;

      case 'warn':
        Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__["warn"])(exception);
        break;
    }
  }

  onComputationCycleHandlerSync(cycle) {
    const exception = new Error("Computation cycle:\n" + cycle); //@ts-ignore

    exception.cycle = cycle;

    switch (this.onComputationCycle) {
      case 'ignore':
        console.log(exception.message);
        const {
          requestedEntry,
          activeEntry
        } = cycle; // if we ignore the cycle we just continue the calculation with the best possible value

        return activeEntry.continueCalculation(requestedEntry.proposedValue !== undefined ? requestedEntry.proposedValue : requestedEntry.value);

      case 'throw':
        throw exception;

      case 'reject':
        this.reject(exception);
        break;

      case 'warn':
        Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__["warn"])(exception);
        break;
    }
  }

  scheduleAutoCommit() {
    // the `&& !this.isCommitting` part was added for the conflicts branch
    // however, it seems to fail several tests
    // commenting for now, to be reviewed later
    if (this.autoCommitTimeoutId === null
    /*&& !this.isCommitting*/
    ) {
      this.autoCommitTimeoutId = setTimeout(this.autoCommitHandler, 10);
    }
  }

  unScheduleAutoCommit() {
    if (this.autoCommitTimeoutId !== null) {
      clearTimeout(this.autoCommitTimeoutId);
      this.autoCommitTimeoutId = null;
    }
  }
  /**
   * Creates a variable identifier with the given initial value and adds it to graph.
   *
   * @param value The initial value. The `undefined` value will be converted to `null`
   */


  variable(value) {
    const variable = Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["VariableC"])(); // always initialize variables with `null`

    return this.addIdentifier(variable, value === undefined ? null : value);
  }
  /**
   * Creates a named variable identifier with the given initial value and adds it to graph.
   *
   * @param name The [[Variable.name]] property of the newly created variable
   * @param value The initial value. The `undefined` value will be converted to `null`
   */


  variableNamed(name, value) {
    const variable = Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["VariableC"])({
      name
    }); // always initialize variables with `null`

    return this.addIdentifier(variable, value === undefined ? null : value);
  }
  /**
   * Creates an identifier based on the given calculation function and adds it to this graph. Depending form the type of the function
   * (sync/generator) either [[CalculatedValueGen]] or [[CalculatedValueSync]] will be created.
   *
   * To have full control on the identifier creation, instantiate it yourself and add to graph using the [[ChronoGraph.addIdentifier]] call.
   *
   * @param calculation The calculation function of the identifier.
   * @param context The [[Identifier.context|context]] property of the newly created identifier
   */


  identifier(calculation, context) {
    const identifier = Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["isGeneratorFunction"])(calculation) ? Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueGenC"])({
      calculation,
      context
    }) : Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueSyncC"])({
      calculation,
      context
    });
    return this.addIdentifier(identifier);
  }
  /**
   * Creates a named identifier based on the given calculation function and adds it to this graph. Depending form the type of the function
   * (sync/generator) either [[CalculatedValueGen]] or [[CalculatedValueSync]] will be created.
   *
   * To have full control on the identifier creation, instantiate it yourself and add to graph using the [[ChronoGraph.addIdentifier]] call.
   *
   * @param name The [[Identifier.name]] property of the newly created identifier
   * @param calculation The calculation function of the identifier.
   * @param context The [[Identifier.context]] property of the newly created identifier
   */


  identifierNamed(name, calculation, context) {
    const identifier = calculation.constructor.name === 'GeneratorFunction' ? Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueGenC"])({
      name,
      calculation,
      context
    }) : Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueSyncC"])({
      name,
      calculation,
      context
    });
    return this.addIdentifier(identifier);
  }
  /**
   * Adds an identifier to this graph. Optionally [[write|writes]] the `proposedValue` to it afterwards.
   *
   * @param identifier
   * @param proposedValue
   * @param args
   */


  addIdentifier(identifier, proposedValue, ...args) {
    if (this.isCommitting) {
      if (this.onWriteDuringCommit === 'throw') throw new Error('Adding identifier during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__["warn"])(new Error('Adding identifier during commit'));
    }

    this.activeTransaction.addIdentifier(identifier, proposedValue, ...args);
    if (this.autoCommit) this.scheduleAutoCommit();
    return identifier;
  }
  /**
   * Removes an identifier from this graph.
   *
   * @param identifier
   */


  removeIdentifier(identifier) {
    if (this.isCommitting) {
      if (this.onWriteDuringCommit === 'throw') throw new Error('Removing identifier during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__["warn"])(new Error('Removinfg identifier during commit'));
    }

    this.activeTransaction.removeIdentifier(identifier);
    this.listeners.delete(identifier);
    if (this.autoCommit) this.scheduleAutoCommit();
  }
  /**
   * Tests, whether this graph has given identifier.
   *
   * @param identifier
   */


  hasIdentifier(identifier) {
    return this.activeTransaction.hasIdentifier(identifier);
  }
  /**
   * Writes a value to the given `identifier`.
   *
   * @param identifier
   * @param proposedValue
   * @param args
   */


  write(identifier, proposedValue, ...args) {
    if (this.isCommitting) {
      if (this.onWriteDuringCommit === 'throw') throw new Error('Write during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_2__["warn"])(new Error('Write during commit'));
    }

    this.activeTransaction.write(identifier, proposedValue, ...args);
    if (this.autoCommit) this.scheduleAutoCommit();
  } // keep if possible?
  // pin (identifier : Identifier) : Quark {
  //     return this.activeTransaction.pin(identifier)
  // }
  // Synchronously read the "previous", "stable" value from the graph. If its a lazy entry, it will be calculated
  // Synchronous read can not calculate lazy asynchronous identifiers and will throw exception
  // Lazy identifiers supposed to be "total" (or accept repeating observes?)


  readPrevious(identifier) {
    return this.activeTransaction.readPrevious(identifier);
  } // Asynchronously read the "previous", "stable" value from the graph. If its a lazy entry, it will be calculated
  // Asynchronous read can calculate both synchornous and asynchronous lazy identifiers.
  // Lazy identifiers supposed to be "total" (or accept repeating observes?)


  readPreviousAsync(identifier) {
    return this.activeTransaction.readPreviousAsync(identifier);
  }
  /**
   * Synchronously read the value of the given identifier from the graph.
   *
   * Synchronous read can not calculate asynchronous identifiers and will throw exception
   *
   * @param identifier
   */


  read(identifier) {
    return this.activeTransaction.read(identifier);
  }
  /**
   * Asynchronously read the value of the given identifier from the graph.
   *
   * Asynchronous read can calculate both synchronous and asynchronous identifiers
   *
   * @param identifier
   */


  readAsync(identifier) {
    return this.activeTransaction.readAsync(identifier);
  }
  /**
   * Read the value of the identifier either synchronously or asynchronously, depending on its type (see [[Identifier.sync]])
   *
   * @param identifier
   */


  get(identifier) {
    return this.activeTransaction.get(identifier);
  } // // read the identifier value, return the proposed value if no "current" value is calculated yet
  // readDirty<T> (identifier : Identifier<T>) : T {
  //     return this.activeTransaction.readDirty(identifier)
  // }
  //
  //
  // // read the identifier value, return the proposed value if no "current" value is calculated yet
  // readDirtyAsync<T> (identifier : Identifier<T>) : Promise<T> {
  //     return this.activeTransaction.readDirtyAsync(identifier)
  // }


  observe(observerFunc, onUpdated) {
    const identifier = this.addIdentifier(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueGen"].new({
      // observers are explicitly eager
      lazy: false,
      calculation: observerFunc
    }));
    this.addListener(identifier, onUpdated);
    return identifier;
  }

  observeContext(observerFunc, context, onUpdated) {
    const identifier = this.addIdentifier(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["CalculatedValueGen"].new({
      // observers are explicitly eager
      lazy: false,
      calculation: observerFunc,
      context: context
    }));
    this.addListener(identifier, onUpdated);
    return identifier;
  }

  addListener(identifier, onUpdated) {
    let listener = this.listeners.get(identifier);

    if (!listener) {
      listener = Listener.new();
      this.listeners.set(identifier, listener);
    }

    listener.handlers.push(onUpdated);
  }
  /**
   * Revert the replica to the state of previous transaction (marked with the [[commit]] call).
   *
   * To enable this feature, you need to opt-in using the [[ChronoGraph.historyLimit|historyLimit]] configuration property.
   *
   * Returns boolean, indicating whether the state transition actually happened.
   */


  undo() {
    const baseRevision = this.baseRevision;
    const previous = baseRevision.previous;
    if (!previous) return false;
    this.baseRevision = previous; // note: all unpropagated "writes" are lost

    this.$activeTransaction = undefined;
    return true;
  }
  /**
   * Advance the replica to the state of next transaction (marked with the [[commit]] call). Only meaningful
   * if a [[ChronoGraph.undo|undo]] call has been made earlier.
   *
   * To enable this feature, you need to opt-in using the [[historyLimit]] configuration property.
   *
   * Returns boolean, indicating whether the state transition actually happened.
   */


  redo() {
    const baseRevision = this.baseRevision;
    if (baseRevision === this.topRevision) return false;
    const nextRevision = this.followingRevision.get(baseRevision);
    this.baseRevision = nextRevision; // note: all unpropagated "writes" are lost

    this.$activeTransaction = undefined;
    return true;
  }

  onPropagationProgressNotification(notification) {}

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["ProposedOrPreviousSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    activeEntry.usedProposedOrPrevious = true;
    const proposedValue = activeEntry.getProposedValue(transaction);
    if (proposedValue !== undefined) return proposedValue; // newly added identifier

    if (!activeEntry.previous) return undefined;
    const identifier = activeEntry.identifier;

    if (identifier.lazy) {
      if (activeEntry.previous.hasValue()) return activeEntry.previous.getValue();
      if (activeEntry.previous.hasProposedValue()) return activeEntry.previous.getProposedValue(transaction);
      return null;
    }

    return transaction.readPrevious(activeEntry.identifier);
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["RejectSymbol"]](effect, transaction) {
    this.reject(effect.reason);
    return _Effect_js__WEBPACK_IMPORTED_MODULE_4__["BreakCurrentStackExecution"];
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["TransactionSymbol"]](effect, transaction) {
    return transaction;
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["OwnQuarkSymbol"]](effect, transaction) {
    return transaction.getActiveEntry();
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["OwnIdentifierSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    return activeEntry.identifier;
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["WriteSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    if (activeEntry.identifier.lazy) throw new Error('Lazy identifiers can not use `Write` effect');
    const writeToHigherLevel = effect.identifier.level > activeEntry.identifier.level;
    if (!writeToHigherLevel) transaction.walkContext.startNewEpoch();
    transaction.write(effect.identifier, ...effect.proposedArgs); // // transaction.writes.push(effect)
    //
    // // const writeTo   = effect.identifier
    // //
    // // writeTo.write.call(writeTo.context || writeTo, writeTo, transaction, null, ...effect.proposedArgs)
    //
    // transaction.onNewWrite()

    return writeToHigherLevel ? undefined : _Effect_js__WEBPACK_IMPORTED_MODULE_4__["BreakCurrentStackExecution"];
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["WriteSeveralSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    if (activeEntry.identifier.lazy) throw new Error('Lazy identifiers can not use `Write` effect');
    let writeToHigherLevel = true; // effect.writes.forEach(writeInfo => {

    effect.writes.forEach(writeInfo => {
      if (writeInfo.identifier.level <= activeEntry.identifier.level && writeToHigherLevel) {
        transaction.walkContext.startNewEpoch();
        writeToHigherLevel = false;
      }

      transaction.write(writeInfo.identifier, ...writeInfo.proposedArgs);
    }); // const identifier    = writeInfo.identifier
    //
    // identifier.write.call(identifier.context || identifier, identifier, transaction, null, ...writeInfo.proposedArgs)
    // })
    // transaction.onNewWrite()

    return writeToHigherLevel ? undefined : _Effect_js__WEBPACK_IMPORTED_MODULE_4__["BreakCurrentStackExecution"];
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["PreviousValueOfSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    const source = effect.identifier;
    transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["EdgeTypePast"]);
    return transaction.readPrevious(source);
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["ProposedValueOfSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    const source = effect.identifier;
    transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["EdgeTypePast"]);
    const quark = transaction.entries.get(source);
    const proposedValue = quark && !quark.isShadow() ? quark.getProposedValue(transaction) : undefined;
    return proposedValue;
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["HasProposedValueSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    const source = effect.identifier;
    transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["EdgeTypePast"]);
    const quark = transaction.entries.get(source);
    return quark ? quark.hasProposedValue() : false;
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["ProposedOrPreviousValueOfSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    const source = effect.identifier;
    transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["EdgeTypePast"]);
    return transaction.readProposedOrPrevious(source);
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["UnsafeProposedOrPreviousValueOfSymbol"]](effect, transaction) {
    return transaction.readProposedOrPrevious(effect.identifier);
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["UnsafePreviousValueOfSymbol"]](effect, transaction) {
    return transaction.readPrevious(effect.identifier);
  }

  [_Effect_js__WEBPACK_IMPORTED_MODULE_4__["ProposedArgumentsOfSymbol"]](effect, transaction) {
    const activeEntry = transaction.getActiveEntry();
    const source = effect.identifier;
    transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_8__["EdgeTypePast"]);
    const quark = transaction.entries.get(source);
    return quark && !quark.isShadow() ? quark.proposedArguments : undefined;
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Identifier.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Identifier.js ***!
  \**********************************************/
/*! exports provided: Levels, Meta, Identifier, IdentifierC, QuarkSync, QuarkGen, Variable, VariableC, CalculatedValueSync, CalculatedValueSyncC, CalculatedValueGen, CalculatedValueGenC, throwUnknownIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Levels", function() { return Levels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Meta", function() { return Meta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Identifier", function() { return Identifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdentifierC", function() { return IdentifierC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuarkSync", function() { return QuarkSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuarkGen", function() { return QuarkGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Variable", function() { return Variable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableC", function() { return VariableC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSync", function() { return CalculatedValueSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSyncC", function() { return CalculatedValueSyncC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGen", function() { return CalculatedValueGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGenC", function() { return CalculatedValueGenC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwUnknownIdentifier", function() { return throwUnknownIdentifier; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





 //---------------------------------------------------------------------------------------------------------------------

/**
Levels of the [[Identifier|identifiers]] as simple integers. Defines the order of calculation, enforced by the following rule -
all lower level identifiers should be already calculated before the calculation of the identifier with the higher level starts.
Because of this, the lower level identifiers can not depend on higher level identifiers.
This rule means that effects from all identifiers of the lower levels will be already processed, when calculating
an identifier of the higher level.
Normally you don't need to specify a level for your identifiers.
*/

var Levels;

(function (Levels) {
  // must be sync
  Levels[Levels["UserInput"] = 0] = "UserInput";
  Levels[Levels["DependsOnlyOnUserInput"] = 1] = "DependsOnlyOnUserInput";
  Levels[Levels["DependsOnlyOnDependsOnlyOnUserInput"] = 2] = "DependsOnlyOnDependsOnlyOnUserInput"; // asynchronicity starts from here

  Levels[Levels["DependsOnSelfKind"] = 3] = "DependsOnSelfKind";
})(Levels || (Levels = {})); //---------------------------------------------------------------------------------------------------------------------

/**
 * The base class for [[Identifier|identifiers]]. It contains only "meta" properties that describes "abstract" identifier.
 * The [[Field]] class inherit from this class.
 *
 * To understand the difference between the "abstract" identifier and the "specific" identifier,
 * imagine a set of instances of the same entity class. Lets say that class has a field "name".
 * All of those instances each will have different "specific" identifiers for the field "name".
 *
 * In the same time, some properties are common for all "specific" identifiers, like [[Meta.equality|equality]], [[Meta.lazy|lazy]] etc.
 * Such properties, that does not change between every "specific" identifier we will call "meta" properties.
 *
 * This class has 2 generic arguments - `ValueT` and `ContextT`. The 1st one defines the type of the identifier's value.
 * The 2nd - the identifier's computation context (synchronous of generator).
 */


class Meta extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * The name of the identifiers. Not an id, does not imply uniqueness.
     */

    this.name = undefined;
    /**
     * Whether this identifier is lazy (`true`) or strict (`false`).
     *
     * Lazy identifiers are calculated on-demand (when read from graph or used by another identifiers).
     *
     * Strict identifiers will be calculated on read or during the [[ChronoGraph.commit|commit]] call.
     */

    this.lazy = false; // no cancels

    this.total = true; // no "nested" writes

    this.pure = true;
    this.proposedValueIsBuilt = false;
  }
  /**
   * The calculation function of the identifier. Its returning value has a generic type, that is converted to a specific type,
   * based on the generic attribute `ContextT`.
   *
   * This function will receive a single argument - current calculation context (effects handler).
   *
   * When using generators, there's no need to use this handler - one can "yield" the value directly, using the `yield` construct.
   *
   * Compare:
   *
   *     class Author extends Entity.mix(Base) {
   *         @field()
   *         firstName       : string
   *         @field()
   *         lastName        : string
   *         @field()
   *         fullName        : string
   *
   *         @calculate('fullName')
   *         * calculateFullName () : ChronoIterator<string> {
   *             return (yield this.$.firstName) + ' ' + (yield this.$.lastName)
   *         }
   *
   *         @calculate('fullName')
   *         calculateFullName (Y) : string {
   *             return Y(this.$.firstName) + ' ' + Y(this.$.lastName)
   *         }
   *     }
   *
   * @param Y
   */


  calculation(Y) {
    throw new Error("Abstract method `calculation` called");
  }
  /**
   * The equality check of the identifier. By default is performed with `===`.
   *
   * @param v1 First value
   * @param v2 Second value
   */


  equality(v1, v2) {
    return v1 === v2;
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(Levels.DependsOnSelfKind)], Meta.prototype, "level", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(true)], Meta.prototype, "sync", void 0); //---------------------------------------------------------------------------------------------------------------------

/**
 * The generic "specific" identifier class (see [[Meta]] for "abstract" properties). This class is generic in the sense that it does not
 * specify the type of the calculation function - it can be either synchronous or generator-based.
 *
 * It is also low-level and generally not supposed to be used directly in the application. Instead, one should
 * declare identifiers as fields (decorated class properties) in the [[Replica|replica]].
 */


class Identifier extends Meta {
  constructor() {
    super(...arguments);
    /**
     * The scope (`this` value) for the calculation function.
     */

    this.context = undefined;
  }

  newQuark(createdAt) {
    // micro-optimization - we don't pass a config object to the `new` constructor
    // but instead assign directly to instance
    const newQuark = this.quarkClass.new();
    newQuark.createdAt = createdAt;
    newQuark.identifier = this;
    newQuark.needToBuildProposedValue = this.proposedValueIsBuilt;
    return newQuark;
  }

  write(me, transaction, quark, proposedValue, ...args) {
    quark = quark || transaction.getWriteTarget(me);
    quark.proposedValue = proposedValue;
    quark.proposedArguments = args.length > 0 ? args : undefined;
  }

  writeToTransaction(transaction, proposedValue, ...args) {
    transaction.write(this, proposedValue, ...args);
  }
  /**
   * Write a value to this identifier, in the context of `graph`.
   *
   * @param graph
   * @param proposedValue
   * @param args
   */


  writeToGraph(graph, proposedValue, ...args) {
    graph.write(this, proposedValue, ...args);
  }
  /**
   * Read the value of this identifier, in the context of `graph`, asynchronously
   * @param graph
   */


  readFromGraphAsync(graph) {
    return graph.readAsync(this);
  }
  /**
   * Read the value of this identifier, in the context of `graph`, synchronously
   * @param graph
   */


  readFromGraph(graph) {
    return graph.read(this);
  }

  readFromTransaction(transaction) {
    return transaction.read(this);
  }

  readFromTransactionAsync(transaction) {
    return transaction.readAsync(this);
  } // readFromGraphDirtySync (graph : CheckoutI) : ValueT {
  //     return graph.readDirty(this)
  // }


  buildProposedValue(me, quark, transaction) {
    return undefined;
  }
  /**
   * Template method, which is called, when this identifier "enters" the graph.
   *
   * @param graph
   */


  enterGraph(graph) {}
  /**
   * Template method, which is called, when this identifier "leaves" the graph.
   *
   * @param graph
   */


  leaveGraph(graph) {}

}
/**
 * Constructor for the [[Identifier]] class. Used only for typization purposes, to be able to specify the generics arguments.
 */

const IdentifierC = config => Identifier.new(config); //@ts-ignore

const QuarkSync = _Quark_js__WEBPACK_IMPORTED_MODULE_4__["Quark"].mix(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_1__["CalculationSync"].mix(Map)); //@ts-ignore

const QuarkGen = _Quark_js__WEBPACK_IMPORTED_MODULE_4__["Quark"].mix(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_1__["CalculationGen"].mix(Map)); //---------------------------------------------------------------------------------------------------------------------

/**
 * Variable is a subclass of [[Identifier]], that does not perform any calculation and instead is always equal to a user-provided value.
 * It is a bit more light-weight
 */

class Variable extends Identifier {
  calculation(YIELD) {
    throw new Error("The 'calculation' method of the variables will never be called. Instead the value will be set directly to quark");
  }

  write(me, transaction, quark, proposedValue, ...args) {
    quark = quark || transaction.getWriteTarget(me);
    quark.value = proposedValue;
    quark.proposedArguments = args.length > 0 ? args : undefined;
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(Levels.UserInput)], Variable.prototype, "level", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(QuarkSync)], Variable.prototype, "quarkClass", void 0);
/**
 * Constructor for the [[Variable]] class. Used only for typization purposes.
 */


function VariableC(...args) {
  return Variable.new(...args);
} //---------------------------------------------------------------------------------------------------------------------

/**
 * Subclass of the [[Identifier]], representing synchronous computation.
 */

class CalculatedValueSync extends Identifier {
  calculation(YIELD) {
    return YIELD(_Effect_js__WEBPACK_IMPORTED_MODULE_3__["ProposedOrPrevious"]);
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(QuarkSync)], CalculatedValueSync.prototype, "quarkClass", void 0);
/**
 * Constructor for the [[CalculatedValueSync]] class. Used only for typization purposes.
 */


function CalculatedValueSyncC(...args) {
  return CalculatedValueSync.new(...args);
} //---------------------------------------------------------------------------------------------------------------------

/**
 * Subclass of the [[Identifier]], representing generator-based computation.
 */

class CalculatedValueGen extends Identifier {
  *calculation(YIELD) {
    return yield _Effect_js__WEBPACK_IMPORTED_MODULE_3__["ProposedOrPrevious"];
  }

}

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(QuarkGen)], CalculatedValueGen.prototype, "quarkClass", void 0);
/**
 * Constructor for the [[CalculatedValueGen]] class. Used only for typization purposes.
 */


function CalculatedValueGenC(...args) {
  return CalculatedValueGen.new(...args);
} //---------------------------------------------------------------------------------------------------------------------

const throwUnknownIdentifier = identifier => {
  throw new Error(`Unknown identifier ${identifier}`);
};

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Quark.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/chrono/Quark.js ***!
  \*****************************************/
/*! exports provided: EdgeType, Quark, TombStone */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeType", function() { return EdgeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Quark", function() { return Quark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TombStone", function() { return TombStone; });
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

var EdgeType;

(function (EdgeType) {
  EdgeType[EdgeType["Normal"] = 1] = "Normal";
  EdgeType[EdgeType["Past"] = 2] = "Past";
})(EdgeType || (EdgeType = {}));

let ORIGIN_ID = 0; //---------------------------------------------------------------------------------------------------------------------

class Quark extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"])([Map], base => class Quark extends base {
  constructor() {
    super(...arguments); // required

    this.createdAt = undefined;
    this.identifier = undefined; // quark state

    this.value = undefined;
    this.proposedValue = undefined;
    this.proposedArguments = undefined;
    this.usedProposedOrPrevious = false; // eof quark state

    this.previous = undefined;
    this.origin = undefined;
    this.originId = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["MIN_SMI"];
    this.needToBuildProposedValue = false;
    this.edgesFlow = 0;
    this.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["NOT_VISITED"];
    this.visitEpoch = 0;
    this.promise = undefined;
    this.$outgoingPast = undefined;
  }

  static new(props) {
    const instance = new this();
    props && Object.assign(instance, props);
    return instance;
  }

  get level() {
    return this.identifier.level;
  }

  get calculation() {
    return this.identifier.calculation;
  }

  get context() {
    return this.identifier.context || this.identifier;
  }

  forceCalculation() {
    this.edgesFlow = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["MAX_SMI"];
  }

  cleanup() {
    this.cleanupCalculation();
  }

  isShadow() {
    return Boolean(this.origin && this.origin !== this);
  }

  resetToEpoch(epoch) {
    this.visitEpoch = epoch;
    this.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["NOT_VISITED"]; // we were clearing the edgeFlow on epoch change, however see `030_propagation_2.t.ts` for a counter-example
    // TODO needs some proper solution for edgesFlow + walk epoch combination

    if (this.edgesFlow < 0) this.edgesFlow = 0;
    this.usedProposedOrPrevious = false;
    this.cleanupCalculation(); // if there's no value, then generally should be no outgoing edges
    // (which indicates that the value has been used somewhere else)
    // but there might be outgoing "past" edges, created if `HasProposedValue`
    // or similar effect has been used on the identifier
    // if (this.value !== undefined) this.clearOutgoing()
    // the `this.value !== undefined` condition above smells very "monkey-patching"
    // it was probably solving some specific problem in Gantt/SchedulerPro
    // (engine tests seems to pass w/o it)
    // in general, should always clear the outgoing edges on new epoch

    this.clearOutgoing();
    this.promise = undefined;

    if (this.origin && this.origin === this) {
      this.proposedArguments = undefined; // only overwrite the proposed value if the actual value has been already calculated
      // otherwise, keep the proposed value as is

      if (this.value !== undefined) {
        this.proposedValue = this.value;
      }

      this.value = undefined;
    } else {
      this.origin = undefined;
      this.value = undefined;
    }

    if (this.identifier.proposedValueIsBuilt && this.proposedValue !== TombStone) {
      this.needToBuildProposedValue = true;
      this.proposedValue = undefined;
    }
  }

  copyFrom(origin) {
    this.value = origin.value;
    this.proposedValue = origin.proposedValue;
    this.proposedArguments = origin.proposedArguments;
    this.usedProposedOrPrevious = origin.usedProposedOrPrevious;
  }

  clearProperties() {
    this.value = undefined;
    this.proposedValue = undefined;
    this.proposedArguments = undefined;
  }

  mergePreviousOrigin(latestScope) {
    const origin = this.origin;
    if (origin !== this.previous) throw new Error("Invalid state");
    this.copyFrom(origin);
    const outgoing = this.getOutgoing();

    for (const [identifier, quark] of origin.getOutgoing()) {
      const ownOutgoing = outgoing.get(identifier);

      if (!ownOutgoing) {
        const latest = latestScope.get(identifier);
        if (!latest || latest.originId === quark.originId) outgoing.set(identifier, latest || quark);
      }
    }

    if (origin.$outgoingPast !== undefined) {
      const outgoingPast = this.getOutgoingPast();

      for (const [identifier, quark] of origin.getOutgoingPast()) {
        const ownOutgoing = outgoingPast.get(identifier);

        if (!ownOutgoing) {
          const latest = latestScope.get(identifier);
          if (!latest || latest.originId === quark.originId) outgoingPast.set(identifier, latest || quark);
        }
      }
    } // changing `origin`, but keeping `originId`


    this.origin = this; // some help for garbage collector

    origin.clearProperties();
    origin.clear();
  } // mergePreviousIntoItself () {
  //     const origin                = this.origin
  //
  //     if (origin === this.previous) {
  //         this.mergePreviousOrigin(this)
  //     } else {
  //
  //     }
  //
  //     // this.copyFrom(origin)
  //     //
  //     // const outgoing              = this.getOutgoing()
  //     //
  //     // for (const [ identifier, quark ] of origin.getOutgoing()) {
  //     //     const ownOutgoing       = outgoing.get(identifier)
  //     //
  //     //     if (!ownOutgoing) {
  //     //         const latest        = latestScope.get(identifier)
  //     //
  //     //         if (!latest || latest.originId === quark.originId) outgoing.set(identifier, latest || quark)
  //     //     }
  //     // }
  //     //
  //     // // changing `origin`, but keeping `originId`
  //     // this.origin                 = this
  //     //
  //     // // some help for garbage collector
  //     // origin.clearProperties()
  //     // origin.clear()
  // }


  setOrigin(origin) {
    this.origin = origin;
    this.originId = origin.originId;
  }

  getOrigin() {
    if (this.origin) return this.origin;
    return this.startOrigin();
  }

  startOrigin() {
    this.originId = ORIGIN_ID++;
    return this.origin = this;
  }

  getOutgoing() {
    return this;
  }

  getOutgoingPast() {
    if (this.$outgoingPast !== undefined) return this.$outgoingPast;
    return this.$outgoingPast = new Map();
  }

  addOutgoingTo(toQuark, type) {
    const outgoing = type === EdgeType.Normal ? this : this.getOutgoingPast();
    outgoing.set(toQuark.identifier, toQuark);
  }

  clearOutgoing() {
    this.clear();
    if (this.$outgoingPast !== undefined) this.$outgoingPast.clear();
  }

  getValue() {
    return this.origin ? this.origin.value : undefined;
  }

  setValue(value) {
    if (this.origin && this.origin !== this) throw new Error('Can not set value to the shadow entry');
    this.getOrigin().value = value; // // @ts-ignore
    // if (value !== TombStone) this.identifier.DATA = value
  }

  hasValue() {
    return this.getValue() !== undefined;
  }

  hasProposedValue() {
    if (this.isShadow()) return false;
    return this.hasProposedValueInner();
  }

  hasProposedValueInner() {
    return this.proposedValue !== undefined;
  } // setProposedValue (value : any) {
  //     if (this.origin && this.origin !== this) throw new Error('Can not set proposed value to the shadow entry')
  //
  //     this.proposedValue = value
  // }


  getProposedValue(transaction) {
    if (this.needToBuildProposedValue) {
      this.needToBuildProposedValue = false;
      this.proposedValue = this.identifier.buildProposedValue.call(this.identifier.context || this.identifier, this.identifier, this, transaction);
    }

    return this.proposedValue;
  } // * outgoingInTheFutureGen (revision : RevisionI) : Generator<Quark, void> {
  //     let current : Quark    = this
  //
  //     while (true) {
  //         for (const outgoing of current.outgoing.keys()) {
  //             if (outgoing === revision.getLatestEntryFor(outgoing.identifier)) yield outgoing
  //         }
  //
  //         if (current.isShadow())
  //             current   = current.previous
  //         else
  //             break
  //     }
  //
  // }


  outgoingInTheFutureCb(revision, forEach) {
    let current = this;

    while (current) {
      for (const outgoing of current.getOutgoing().values()) {
        if (outgoing.originId === revision.getLatestEntryFor(outgoing.identifier).originId) forEach(outgoing);
      }

      if (current.isShadow()) current = current.previous;else current = null;
    }
  }

  outgoingInTheFutureAndPastCb(revision, forEach) {
    let current = this;

    while (current) {
      for (const outgoing of current.getOutgoing().values()) {
        const latestEntry = revision.getLatestEntryFor(outgoing.identifier);
        if (latestEntry && outgoing.originId === latestEntry.originId) forEach(outgoing);
      }

      if (current.$outgoingPast !== undefined) {
        for (const outgoing of current.$outgoingPast.values()) {
          const latestEntry = revision.getLatestEntryFor(outgoing.identifier);
          if (latestEntry && outgoing.originId === latestEntry.originId) forEach(outgoing);
        }
      }

      if (current.isShadow()) current = current.previous;else current = null;
    }
  }

  outgoingInTheFutureAndPastTransactionCb(transaction, forEach) {
    let current = this;

    while (current) {
      for (const outgoing of current.getOutgoing().values()) {
        const latestEntry = transaction.getLatestStableEntryFor(outgoing.identifier);
        if (latestEntry && outgoing.originId === latestEntry.originId) forEach(outgoing);
      }

      if (current.$outgoingPast !== undefined) {
        for (const outgoing of current.$outgoingPast.values()) {
          const latestEntry = transaction.getLatestStableEntryFor(outgoing.identifier);
          if (latestEntry && outgoing.originId === latestEntry.originId) forEach(outgoing);
        }
      }

      if (current.isShadow()) current = current.previous;else current = null;
    }
  } // ignores the "past" edges by design, as they do not form cycles


  outgoingInTheFutureTransactionCb(transaction, forEach) {
    let current = this;

    while (current) {
      for (const outgoing of current.getOutgoing().values()) {
        const latestEntry = transaction.getLatestEntryFor(outgoing.identifier);
        if (latestEntry && outgoing.originId === latestEntry.originId) forEach(outgoing);
      }

      if (current.isShadow()) current = current.previous;else current = null;
    }
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

const TombStone = Symbol('Tombstone');

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Revision.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Revision.js ***!
  \********************************************/
/*! exports provided: Revision */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Revision", function() { return Revision; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
var productName = 'gantt';


let CLOCK = 0;
class Revision extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.createdAt = CLOCK++;
    this.name = 'revision-' + this.createdAt;
    this.previous = undefined;
    this.scope = new Map();
    this.reachableCount = 0;
    this.referenceCount = 0;
    this.selfDependent = new Set();
  }

  getLatestEntryFor(identifier) {
    let revision = this;

    while (revision) {
      const entry = revision.scope.get(identifier);
      if (entry) return entry;
      revision = revision.previous;
    }

    return null;
  }

  hasIdentifier(identifier) {
    const latestEntry = this.getLatestEntryFor(identifier);
    return Boolean(latestEntry && latestEntry.getValue() !== _Quark_js__WEBPACK_IMPORTED_MODULE_1__["TombStone"]);
  }

  *previousAxis() {
    let revision = this;

    while (revision) {
      yield revision;
      revision = revision.previous;
    }
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Transaction.js":
/*!***********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Transaction.js ***!
  \***********************************************/
/*! exports provided: EdgeTypeNormal, EdgeTypePast, Transaction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeTypeNormal", function() { return EdgeTypeNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeTypePast", function() { return EdgeTypePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return Transaction; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _util_LeveledQueue_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/LeveledQueue.js */ "./lib/ChronoGraph/util/LeveledQueue.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _Revision_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./TransactionCycleDetectionWalkContext.js */ "./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js");
/* harmony import */ var _TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./TransactionWalkDepth.js */ "./lib/ChronoGraph/chrono/TransactionWalkDepth.js");
var productName = 'gantt';











 //---------------------------------------------------------------------------------------------------------------------
// weird stack overflow on 1300 deep benchmark, when using `EdgeType.Normal` w/o aliasing it to constant first

const EdgeTypeNormal = _Quark_js__WEBPACK_IMPORTED_MODULE_8__["EdgeType"].Normal;
const EdgeTypePast = _Quark_js__WEBPACK_IMPORTED_MODULE_8__["EdgeType"].Past; //---------------------------------------------------------------------------------------------------------------------

class Transaction extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.baseRevision = undefined;
    this.candidateClass = _Revision_js__WEBPACK_IMPORTED_MODULE_9__["Revision"];
    this.candidate = undefined;
    this.graph = undefined;
    this.isClosed = false;
    this.walkContext = undefined;
    this.entries = new Map(); // // we use 2 different stacks, because they support various effects
    // stackSync               : LeveledQueue<Quark>  = new LeveledQueue()
    // the `stackGen` supports async effects notably

    this.stackGen = new _util_LeveledQueue_js__WEBPACK_IMPORTED_MODULE_5__["LeveledQueue"](); // is used for tracking the active quark entry (quark entry being computed)

    this.activeStack = [];
    this.onEffectSync = undefined;
    this.onEffectAsync = undefined; //---------------------

    this.propagationStartDate = 0;
    this.lastProgressNotificationDate = 0;
    this.startProgressNotificationsAfterMs = 500;
    this.emitProgressNotificationsEveryMs = 200; // TODO auto-adjust this parameter to match the emitProgressNotificationsEveryMs (to avoid calls to time functions)

    this.emitProgressNotificationsEveryCalculations = 100;
    this.plannedTotalIdentifiersToCalculate = 0; // writes                  : WriteInfo[]           = []

    this.ongoing = Promise.resolve();
    this.selfDependedMarked = false;
    this.rejectedWith = undefined;
    this.hasEntryWithProposedValue = false;
    this.hasVariableEntry = false;
  }

  initialize(...args) {
    super.initialize(...args);
    this.walkContext = _TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_11__["TransactionWalkDepth"].new({
      visited: this.entries,
      transaction: this,
      baseRevision: this.baseRevision,
      pushTo: this.stackGen
    });
    if (!this.candidate) this.candidate = this.candidateClass.new({
      previous: this.baseRevision
    }); // the `onEffectSync` should be bound to the `yieldSync` of course, and `yieldSync` should look like:
    //     yieldSync (effect : YieldableValue) : any {
    //         if (effect instanceof Identifier) return this.read(effect)
    //     }
    // however, the latter consumes more stack frames - every read goes through `yieldSync`
    // since `read` is the most used effect anyway, we bind `onEffectSync` to `read` and
    // instead inside of `read` delegate to `yieldSync` for non-identifiers

    this.onEffectSync =
    /*this.onEffectAsync =*/
    this.read.bind(this);
    this.onEffectAsync = this.readAsync.bind(this);
  }

  get dirty() {
    return this.entries.size > 0;
  }

  markSelfDependent() {
    if (this.selfDependedMarked) return;
    this.selfDependedMarked = true;

    for (const selfDependentIden of this.baseRevision.selfDependent) {
      const existing = this.entries.get(selfDependentIden);
      if (existing && existing.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) continue;
      this.touch(selfDependentIden);
    }
  } // onNewWrite () {
  //     this.writes.forEach(writeInfo => {
  //         const identifier    = writeInfo.identifier
  //
  //         identifier.write.call(identifier.context || identifier, identifier, this, null, ...writeInfo.proposedArgs)
  //     })
  //
  //     this.writes.length = 0
  // }


  getActiveEntry() {
    return this.activeStack[this.activeStack.length - 1]; // // `stackSync` is always empty, except when the synchronous "batch" is being processed
    // const activeStack   = this.stackSync.length > 0 ? this.stackSync : this.stackGen
    //
    // return activeStack.last()
  }

  yieldAsync(effect) {
    if (effect instanceof Promise) return effect;
    return this.graph[effect.handler](effect, this);
  } // see the comment for the `onEffectSync`


  yieldSync(effect) {
    if (effect instanceof Promise) {
      throw new Error("Can not yield a promise in the synchronous context");
    }

    return this.graph[effect.handler](effect, this);
  } // this seems to be an optimistic version


  readAsync(identifier) {
    // see the comment for the `onEffectSync`
    if (!(identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Identifier"])) return this.yieldAsync(identifier);
    let entry;
    const activeEntry = this.getActiveEntry();

    if (activeEntry) {
      entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
    } else {
      entry = this.entries.get(identifier);

      if (!entry) {
        const previousEntry = this.baseRevision.getLatestEntryFor(identifier);
        if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
        entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
      }
    }

    if (entry.hasValue()) return entry.getValue();
    if (entry.promise) return entry.promise; //----------------------
    // TODO should use `onReadIdentifier` somehow? to have the same control flow for reading sync/gen identifiers?
    // now need to repeat the logic

    if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation();
    return this.ongoing = entry.promise = this.ongoing.then(() => {
      return (async () => {
        //----------------------
        while (this.stackGen.lowestLevel < identifier.level) {
          await Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["runGeneratorAsyncWithEffect"])(this.onEffectAsync, this.calculateTransitionsStackGen, [this.onEffectAsync, this.stackGen.takeLowestLevel()], this);
        }

        this.markSelfDependent(); // entry might be already calculated (in the `ongoing` promise), so no need to calculate it

        if (entry.getValue() === undefined) return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["runGeneratorAsyncWithEffect"])(this.onEffectAsync, this.calculateTransitionsStackGen, [this.onEffectAsync, [entry]], this);
      })();
    }).then(() => {
      if (this.rejectedWith) throw new Error(`Transaction rejected: ${String(this.rejectedWith.reason)}`); // we clear the promise in the `resetToEpoch` should be enough?
      // entry.promise = undefined
      // TODO review this exception

      if (!entry.hasValue()) throw new Error('Computation cycle. Sync');
      return entry.getValue();
    });
  }

  get(identifier) {
    // see the comment for the `onEffectSync`
    if (!(identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Identifier"])) return this.yieldSync(identifier);
    let entry;
    const activeEntry = this.getActiveEntry();

    if (activeEntry) {
      entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
    } else {
      entry = this.entries.get(identifier);

      if (!entry) {
        const previousEntry = this.baseRevision.getLatestEntryFor(identifier);
        if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
        entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
      }
    }

    const value1 = entry.getValue();
    if (value1 === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier); // the `&& entry.hasValue()` part was added to allow KEEP_TRYING_TO_RESOLVE feature for references

    if (value1 !== undefined && entry.hasValue()) return value1;
    if (entry.promise) return entry.promise; //----------------------
    // TODO should use `onReadIdentifier` somehow? to have the same control flow for reading sync/gen identifiers?
    // now need to repeat the logic

    if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation(); //----------------------

    while (this.stackGen.getLowestLevel() < identifier.level) {
      // here we force the computations for lower level identifiers should be sync
      this.calculateTransitionsStackSync(this.onEffectSync, this.stackGen.takeLowestLevel());
    }

    this.markSelfDependent();

    if (identifier.sync) {
      this.calculateTransitionsStackSync(this.onEffectSync, [entry]);
      const value = entry.getValue(); // TODO review this exception

      if (value === undefined) throw new Error('Cycle during synchronous computation');
      if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
      return value;
    } else {
      const promise = this.ongoing = entry.promise = this.ongoing.then(() => {
        // entry might be already calculated (in the `ongoing` promise), so no need to calculate it
        if (entry.getValue() === undefined) return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["runGeneratorAsyncWithEffect"])(this.onEffectAsync, this.calculateTransitionsStackGen, [this.onEffectAsync, [entry]], this);
      }).then(() => {
        if (this.rejectedWith) throw new Error(`Transaction rejected: ${String(this.rejectedWith.reason)}`); // we clear the promise in the `resetToEpoch` should be enough?
        // entry.promise   = undefined

        const value = entry.getValue(); // TODO review this exception

        if (value === undefined) throw new Error('Computation cycle. Async get');
        if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
        return value; // // TODO review this exception
        // if (!entry.hasValue()) throw new Error('Computation cycle. Async get')
        //
        // return entry.getValue()
      });

      if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_1__["DEBUG"]) {
        // @ts-ignore
        promise.quark = entry;
      }

      return promise; // return runGeneratorAsyncWithEffect(this.onEffectAsync, this.calculateTransitionsStackGen, [ this.onEffectAsync, [ entry ] ], this).then(() => {
      //     const value     = entry.getValue()
      //
      //     // TODO review this exception
      //     if (value === undefined) throw new Error('Cycle during synchronous computation')
      //     if (value === TombStone) throwUnknownIdentifier(identifier)
      //
      //     return value
      // })
    }
  } // this seems to be an optimistic version


  read(identifier) {
    // see the comment for the `onEffectSync`
    if (!(identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Identifier"])) return this.yieldSync(identifier);
    let entry;
    const activeEntry = this.getActiveEntry();

    if (activeEntry) {
      entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
    } else {
      entry = this.entries.get(identifier);

      if (!entry) {
        const previousEntry = this.baseRevision.getLatestEntryFor(identifier);
        if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
        entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
      }
    }

    const value1 = entry.getValue();
    if (value1 === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
    if (value1 !== undefined) return value1; // if (!identifier.sync) throw new Error("Can not calculate asynchronous identifier synchronously")
    // TODO should use `onReadIdentifier` somehow? to have the same control flow for reading sync/gen identifiers?
    // now need to repeat the logic

    if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation(); //----------------------

    while (this.stackGen.getLowestLevel() < identifier.level) {
      this.calculateTransitionsStackSync(this.onEffectSync, this.stackGen.takeLowestLevel());
    } //----------------------


    this.markSelfDependent();
    this.calculateTransitionsStackSync(this.onEffectSync, [entry]);
    const value = entry.getValue(); // TODO review this exception

    if (value === undefined) throw new Error('Cycle during synchronous computation');
    if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifier);
    return value;
  } // semantic is actually - read the most-fresh value


  readCurrentOrProposedOrPrevious(identifier) {
    const dirtyQuark = this.entries.get(identifier);

    if (dirtyQuark) {
      const value = dirtyQuark.getValue();
      if (value !== undefined) return value;
      if (dirtyQuark.proposedValue !== undefined) return dirtyQuark.proposedValue;
    }

    return this.readPrevious(identifier);
  }

  readCurrentOrProposedOrPreviousAsync(identifier) {
    const dirtyQuark = this.entries.get(identifier);

    if (dirtyQuark) {
      const value = dirtyQuark.getValue();
      if (value !== undefined) return value;
      if (dirtyQuark.proposedValue !== undefined) return dirtyQuark.proposedValue;
    }

    return this.readPreviousAsync(identifier);
  }

  readPrevious(identifier) {
    const previousEntry = this.baseRevision.getLatestEntryFor(identifier);
    if (!previousEntry) return undefined;
    const value = previousEntry.getValue();
    return value !== _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"] ? value === undefined && identifier.lazy ? this.read(identifier) : value : undefined;
  }

  readPreviousAsync(identifier) {
    const previousEntry = this.baseRevision.getLatestEntryFor(identifier);
    if (!previousEntry) return undefined;
    const value = previousEntry.getValue();
    return value !== _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"] ? value !== undefined ? value : this.readAsync(identifier) : undefined;
  }

  readProposedOrPrevious(identifier) {
    const dirtyQuark = this.entries.get(identifier);

    if (dirtyQuark && dirtyQuark.proposedValue !== undefined) {
      return dirtyQuark.proposedValue;
    } else {
      return this.readPrevious(identifier);
    }
  }

  readProposedOrPreviousAsync(identifier) {
    const dirtyQuark = this.entries.get(identifier);

    if (dirtyQuark && dirtyQuark.proposedValue !== undefined) {
      return dirtyQuark.proposedValue;
    } else {
      return this.readPreviousAsync(identifier);
    }
  }

  write(identifier, proposedValue, ...args) {
    if (proposedValue === undefined) proposedValue = null; // this.writes.push(WriteEffect.new({
    //     identifier      : identifier,
    //     proposedArgs    : [ proposedValue, ...args ]
    // }))
    //
    // this.onNewWrite()

    identifier.write.call(identifier.context || identifier, identifier, this, null,
    /*this.getWriteTarget(identifier),*/
    proposedValue, ...args);
    const entry = this.entries.get(identifier);
    this.hasVariableEntry = this.hasVariableEntry || !entry.isShadow() && identifier.level === _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Levels"].UserInput;
    this.hasEntryWithProposedValue = this.hasEntryWithProposedValue || entry.hasProposedValue();
  } // acquireQuark<T extends Identifier> (identifier : T) : InstanceType<T[ 'quarkClass' ]> {
  //     return this.touch(identifier).startOrigin() as InstanceType<T[ 'quarkClass' ]>
  // }


  getWriteTarget(identifier) {
    return this.touch(identifier).startOrigin();
  } // return quark if it exists and is non-shadowing, otherwise undefined


  acquireQuarkIfExists(identifier) {
    const entry = this.entries.get(identifier);
    return entry && entry.origin === entry ? entry.origin : undefined;
  }

  touch(identifier) {
    const existingEntry = this.entries.get(identifier);
    if (!existingEntry || existingEntry.visitEpoch < this.walkContext.currentEpoch) this.walkContext.continueFrom([identifier]);
    const entry = existingEntry || this.entries.get(identifier);
    entry.forceCalculation();
    return entry;
  } // touchInvalidate (identifier : Identifier) : Quark {
  //     const existingEntry         = this.entries.get(identifier)
  //
  //     if (existingEntry && existingEntry.hasValue()) {
  //         this.walkContext.startNewEpoch()
  //     }
  //
  //     if (!existingEntry || existingEntry.visitEpoch < this.walkContext.currentEpoch) this.walkContext.continueFrom([ identifier ])
  //
  //     const entry                 = existingEntry || this.entries.get(identifier)
  //
  //     entry.forceCalculation()
  //
  //     return entry
  // }


  hasIdentifier(identifier) {
    const activeEntry = this.entries.get(identifier);
    if (activeEntry && activeEntry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) return false;
    return Boolean(activeEntry || this.baseRevision.getLatestEntryFor(identifier));
  } // this is actually an optimized version of `write`, which skips the graph walk phase
  // (since the identifier is assumed to be new, there should be no dependent quarks)


  addIdentifier(identifier, proposedValue, ...args) {
    // however, the identifier may be already in the transaction, for example if the `write` method
    // of some other identifier writes to this identifier
    let entry = this.entries.get(identifier);
    const isVariable = identifier.level === _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Levels"].UserInput;

    if (!entry) {
      entry = identifier.newQuark(this.baseRevision);
      entry.previous = this.baseRevision.getLatestEntryFor(identifier);
      entry.forceCalculation();
      this.entries.set(identifier, entry);
      if (!identifier.lazy && !isVariable) this.stackGen.push(entry);
      this.hasVariableEntry = this.hasVariableEntry || !entry.isShadow() && isVariable;
      this.hasEntryWithProposedValue = this.hasEntryWithProposedValue || entry.hasProposedValue();
    }

    if (proposedValue !== undefined || isVariable) {
      // TODO change to `this.write()`
      entry.startOrigin();
      identifier.write.call(identifier.context || identifier, identifier, this, entry, proposedValue === undefined && isVariable ? null : proposedValue, ...args);
    } // if we are re-adding the same identifier in the same transaction, clear the TombStone flag


    if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) entry.value = undefined;
    identifier.enterGraph(this.graph);
    return entry;
  }

  removeIdentifier(identifier) {
    identifier.leaveGraph(this.graph);
    const entry = this.touch(identifier).startOrigin();
    entry.setValue(_Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]);
  }

  populateCandidateScopeFromTransitions(candidate, scope) {
    if (candidate.scope.size === 0) {
      // in this branch we can overwrite the whole map
      candidate.scope = scope;
    } else {
      // in this branch candidate's scope already has some content - this is the case for calculating lazy values
      // // TODO benchmark what is faster (for small maps) - `map.forEach(entry => {})` or `for (const entry of map) {}`
      // entries.forEach((entry : QuarkEntry, identifier : Identifier) => {
      //     candidate.scope.set(identifier, entry)
      // })
      for (const [identifier, quark] of scope) {
        if (quark.isShadow()) {
          const latestEntry = candidate.getLatestEntryFor(identifier); // TODO remove the origin/shadowing concepts? this line won't be needed then
          // and we iterate over the edges from "origin" anyway

          quark.getOutgoing().forEach((toQuark, toIdentifier) => latestEntry.getOutgoing().set(toIdentifier, toQuark));
        } else {
          candidate.scope.set(identifier, quark);
        }
      }
    }
  }

  preCommit(args) {
    if (this.isClosed) throw new Error('Can not propagate closed revision');
    this.markSelfDependent();
    this.isClosed = true;
    this.propagationStartDate = Date.now();
    this.plannedTotalIdentifiersToCalculate = this.stackGen.length;
  }

  postCommit() {
    this.populateCandidateScopeFromTransitions(this.candidate, this.entries); // won't be available after next line

    const entries = this.entries; // for some reason need to cleanup the `walkContext` manually, otherwise the extra revisions hangs in memory

    this.walkContext = undefined;
    return {
      revision: this.candidate,
      entries,
      transaction: this
    };
  }

  commit(args) {
    this.preCommit(args);
    this.calculateTransitionsSync(this.onEffectSync); // runGeneratorSyncWithEffect(this.onEffectSync, this.calculateTransitionsStackGen, [ this.onEffectSync, stack ], this)

    return this.postCommit();
  }

  reject(rejection = _Effect_js__WEBPACK_IMPORTED_MODULE_6__["RejectEffect"].new()) {
    this.rejectedWith = rejection;
    this.walkContext = undefined;
  }

  clearRejected() {
    for (const quark of this.entries.values()) {
      quark.cleanup(); // quark.clearOutgoing()
    }

    this.entries.clear();
  } // // propagation that does not use generators at all
  // propagateSync (args? : PropagateArguments) : TransactionPropagateResult {
  //     const stack = this.prePropagate(args)
  //
  //     this.calculateTransitionsStackSync(this.onEffectSync, stack)
  //     // runGeneratorSyncWithEffect(this.onEffectSync, this.calculateTransitionsStackGen, [ this.onEffectSync, stack ], this)
  //
  //     return this.postPropagate()
  // }


  async commitAsync(args) {
    this.preCommit(args);
    return this.ongoing = this.ongoing.then(() => {
      return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["runGeneratorAsyncWithEffect"])(this.onEffectAsync, this.calculateTransitions, [this.onEffectAsync], this);
    }).then(() => {
      return this.postCommit();
    }); // await runGeneratorAsyncWithEffect(this.onEffectAsync, this.calculateTransitions, [ this.onEffectAsync ], this)
    //
    // return this.postCommit()
  }

  getLatestEntryFor(identifier) {
    let entry = this.entries.get(identifier) || this.baseRevision.getLatestEntryFor(identifier);
    if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) return undefined;
    return entry;
  } // check the transaction "entries" first, but only return an entry
  // from that, if it is already calculated, otherwise - take it
  // from the base revision


  getLatestStableEntryFor(identifier) {
    let entry = this.entries.get(identifier);

    if (entry) {
      const value = entry.getValue();
      if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) return undefined;
      return value === undefined ? this.baseRevision.getLatestEntryFor(identifier) : entry;
    } else {
      return this.baseRevision.getLatestEntryFor(identifier);
    }
  }

  addEdge(identifierRead, activeEntry, type) {
    const identifier = activeEntry.identifier;
    if (identifier.level < identifierRead.level) throw new Error('Identifier can not read from higher level identifier');
    let entry = this.entries.get(identifierRead); // creating "shadowing" entry, to store the new edges

    if (!entry) {
      const previousEntry = this.baseRevision.getLatestEntryFor(identifierRead);
      if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifierRead);
      entry = identifierRead.newQuark(this.baseRevision);
      previousEntry.origin && entry.setOrigin(previousEntry.origin);
      entry.previous = previousEntry;
      this.entries.set(identifierRead, entry);
    }

    entry.addOutgoingTo(activeEntry, type);
    return entry;
  }

  onQuarkCalculationCompleted(entry, value) {
    // cleanup the iterator
    entry.cleanup();
    const identifier = entry.identifier;
    const previousEntry = entry.previous; //--------------------

    const sameAsPrevious = Boolean(previousEntry && previousEntry.hasValue() && identifier.equality(value, previousEntry.getValue()));

    if (sameAsPrevious) {
      previousEntry.outgoingInTheFutureAndPastTransactionCb(this, previousOutgoingEntry => {
        const outgoingEntry = this.entries.get(previousOutgoingEntry.identifier);
        if (outgoingEntry) outgoingEntry.edgesFlow--;
      }); // this is a "workaround" for the following problem:
      // there might be several copies of the same quark in the calculation stack, this is normal
      // because if quark is requested by some other quark it is just pushed to the stack,
      // which may already contain this quark
      // then when the quark is calculated (this code) it propagates the `edgesFlow` decrease
      // but next time it will be encountered in the stack, its `edgesFlow` might be decreased by other
      // identifiers, which will trigger another round of `edgesFlow` decrease propagation
      // so we set the `edgesFlow` to MAX_SMI after decrease been propagated to prevent repeated such propagation

      entry.edgesFlow = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["MAX_SMI"];
      entry.setOrigin(previousEntry.origin); // seems not needed anymore?
      // this is to indicate that this entry should be recalculated (origin removed)
      // see `resetToEpoch`

      entry.value = value;
    } else {
      entry.startOrigin();
      entry.setValue(value);
    } //--------------------


    let ignoreSelfDependency = false;

    if (entry.usedProposedOrPrevious) {
      if (entry.proposedValue !== undefined) {
        if (identifier.equality(value, entry.proposedValue)) ignoreSelfDependency = true;
      } else {
        // ignore the uninitialized atoms (`proposedValue` === undefined && !previousEntry)
        // which has been calculated to `null` - we don't consider this as a change
        if (sameAsPrevious || !previousEntry && value === null) ignoreSelfDependency = true;
      }

      if (!ignoreSelfDependency) this.candidate.selfDependent.add(identifier);
    }
  }

  onReadIdentifier(identifierRead, activeEntry, stack) {
    const requestedEntry = this.addEdge(identifierRead, activeEntry, EdgeTypeNormal); // this is a workaround for references with failed resolution problem in gantt
    // those references return `hasValue() === false` even that they actually have value
    // (which is `null` and needed to be recalculated)

    if (requestedEntry.hasValue() || requestedEntry.value !== undefined) {
      const value = requestedEntry.getValue();
      if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_7__["throwUnknownIdentifier"])(identifierRead);
      return activeEntry.continueCalculation(value);
    } else if (requestedEntry.isShadow()) {
      // shadow entry is shadowing a quark w/o value - it is still transitioning or lazy
      // in both cases start new calculation
      requestedEntry.startOrigin();
      requestedEntry.forceCalculation();
      stack.push(requestedEntry);
      return undefined;
    } else {
      if (!requestedEntry.isCalculationStarted()) {
        stack.push(requestedEntry);
        if (!requestedEntry.previous || !requestedEntry.previous.hasValue()) requestedEntry.forceCalculation();
        return undefined;
      } else {
        // cycle - the requested quark has started calculation (means it was encountered in the calculation loop before)
        // but the calculation did not complete yet (even that requested quark is calculated before the current)
        let cycle;
        const walkContext = _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_10__["TransactionCycleDetectionWalkContext"].new({
          transaction: this,

          onCycle(node, stack) {
            cycle = _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_10__["ComputationCycle"].new({
              cycle: Object(_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_2__["cycleInfo"])(stack),
              requestedEntry,
              activeEntry
            });
            return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_2__["OnCycleAction"].Cancel;
          }

        });
        walkContext.startFrom([requestedEntry.identifier]);
        return cycle;
      }
    }
  }

  *calculateTransitions(context) {
    const queue = this.stackGen;

    while (queue.length) {
      // TODO if stack calculation is interrupted with BreakCurrentStackExecution we might be loosing
      // some identifiers from the queue??
      yield* this.calculateTransitionsStackGen(context, queue.takeLowestLevel());
    }
  }

  calculateTransitionsSync(context) {
    const queue = this.stackGen;

    while (queue.length) {
      this.calculateTransitionsStackSync(context, queue.takeLowestLevel());
    }
  } // this method is not decomposed into smaller ones intentionally, as that makes benchmarks worse
  // it seems that overhead of calling few more functions in such tight loop as this outweighs the optimization


  *calculateTransitionsStackGen(context, stack) {
    if (this.rejectedWith) return;
    this.walkContext.startNewEpoch();
    const entries = this.entries;
    const propagationStartDate = this.propagationStartDate;
    const enableProgressNotifications = this.graph ? this.graph.enableProgressNotifications : false;
    let counter = 0;
    const prevActiveStack = this.activeStack;
    this.activeStack = stack;

    while (stack.length && !this.rejectedWith) {
      if (enableProgressNotifications && !(counter++ % this.emitProgressNotificationsEveryCalculations)) {
        const now = Date.now();
        const elapsed = now - propagationStartDate;

        if (elapsed > this.startProgressNotificationsAfterMs) {
          const lastProgressNotificationDate = this.lastProgressNotificationDate;

          if (!lastProgressNotificationDate || now - lastProgressNotificationDate > this.emitProgressNotificationsEveryMs) {
            this.lastProgressNotificationDate = now;
            this.graph.onPropagationProgressNotification({
              total: this.plannedTotalIdentifiersToCalculate,
              remaining: stack.length,
              phase: 'propagating'
            });
            yield Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["delay"])(0);
          }
        }
      }

      const entry = stack[stack.length - 1];
      const identifier = entry.identifier; // TODO can avoid `.get()` call by comparing some another "epoch" counter on the entry

      const ownEntry = entries.get(identifier);

      if (ownEntry !== entry) {
        entry.cleanup();
        stack.pop();
        continue;
      }

      if (entry.edgesFlow == 0) {
        // even if we delete the entry there might be other copies in stack, so reduce the `edgesFlow` to -1
        // to indicate that those are already processed
        entry.edgesFlow--;
        const previousEntry = entry.previous;
        previousEntry && previousEntry.outgoingInTheFutureAndPastTransactionCb(this, outgoing => {
          const outgoingEntry = entries.get(outgoing.identifier);
          if (outgoingEntry) outgoingEntry.edgesFlow--;
        });
      } // the "edgesFlow < 0" indicates that none of the incoming deps of this quark has changed
      // thus we don't need to calculate it, moreover, we can remove the quark from the `entries`
      // to expose the value from the previous revision
      // however, we only do it, when there is a quark from previous revision and it has "origin" (some value)


      if (entry.edgesFlow < 0 && entry.previous && entry.previous.origin) {
        // even if the entry will be deleted from the transaction, we set the correct origin for it
        // this is because there might be other references to this entry in the stack
        // and also the entry may be referenced as dependency of some other quark
        // in such case the correct `originId` will preserve dependency during revisions compactification
        entry.setOrigin(entry.previous.origin); // if there's no outgoing edges we remove the quark

        if (entry.size === 0) {
          entries.delete(identifier);
        } // reduce garbage collection workload


        entry.cleanup();
        stack.pop();
        continue;
      }

      if (
      /*entry.isShadow() ||*/
      entry.hasValue() || entry.proposedValue === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) {
        entry.cleanup();
        stack.pop();
        continue;
      }

      const startedAtEpoch = entry.visitEpoch;
      let iterationResult = entry.isCalculationStarted() ? entry.iterationResult : entry.startCalculation(this.onEffectSync);

      while (iterationResult) {
        const value = iterationResult.value === undefined ? null : iterationResult.value;

        if (entry.isCalculationCompleted()) {
          if (entry.visitEpoch == startedAtEpoch) {
            this.onQuarkCalculationCompleted(entry, value);
          }

          stack.pop();
          break;
        } else if (value instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Identifier"]) {
          const onReadIdentifierResult = this.onReadIdentifier(value, entry, stack); // handle the cycle

          if (onReadIdentifierResult instanceof _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_10__["ComputationCycle"]) {
            this.walkContext.startNewEpoch();
            yield* this.graph.onComputationCycleHandler(onReadIdentifierResult);
            entry.cleanupCalculation();
            iterationResult = undefined;
          } else {
            iterationResult = onReadIdentifierResult;
          }
        } else if (value === _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["SynchronousCalculationStarted"]) {
          // the fact, that we've encountered `SynchronousCalculationStarted` constant can mean 2 things:
          // 1) there's a cycle during synchronous computation (we throw exception in `read` method)
          // 2) some other computation is reading synchronous computation, that has already started
          //    in such case its safe to just unwind the stack
          stack.pop();
          break;
        } else {
          // bypass the unrecognized effect to the outer context
          const effectResult = yield value; // the calculation can be interrupted (`cleanupCalculation`) as a result of the effect (WriteEffect)
          // in such case we can not continue calculation and jare ust exit the inner loop

          if (effectResult === _Effect_js__WEBPACK_IMPORTED_MODULE_6__["BreakCurrentStackExecution"]) break; // // the calculation can be interrupted (`cleanupCalculation`) as a result of the effect (WriteEffect)
          // // in such case we can not continue calculation and just exit the inner loop
          // if (entry.iterationResult)

          if (entry.visitEpoch === startedAtEpoch) {
            iterationResult = entry.continueCalculation(effectResult);
          } else {
            stack.pop();
            break;
          } // else
          //     iterationResult         = null

        }
      }
    }

    this.activeStack = prevActiveStack;
  } // THIS METHOD HAS TO BE KEPT SYNCED WITH THE `calculateTransitionsStackGen` !!!


  calculateTransitionsStackSync(context, stack) {
    if (this.rejectedWith) return;
    this.walkContext.startNewEpoch();
    const entries = this.entries;
    const prevActiveStack = this.activeStack;
    this.activeStack = stack;

    while (stack.length && !this.rejectedWith) {
      const entry = stack[stack.length - 1];
      const identifier = entry.identifier; // TODO can avoid `.get()` call by comparing some another "epoch" counter on the entry

      const ownEntry = entries.get(identifier);

      if (ownEntry !== entry) {
        entry.cleanup();
        stack.pop();
        continue;
      }

      if (entry.edgesFlow == 0) {
        // even if we delete the entry there might be other copies in stack, so reduce the `edgesFlow` to -1
        // to indicate that those are already processed
        entry.edgesFlow--;
        const previousEntry = entry.previous;
        previousEntry && previousEntry.outgoingInTheFutureAndPastTransactionCb(this, outgoing => {
          const outgoingEntry = entries.get(outgoing.identifier);
          if (outgoingEntry) outgoingEntry.edgesFlow--;
        });
      } // the "edgesFlow < 0" indicates that none of the incoming deps of this quark has changed
      // thus we don't need to calculate it, moreover, we can remove the quark from the `entries`
      // to expose the value from the previous revision
      // however, we only do it, when there is a quark from previous revision and it has "origin" (some value)


      if (entry.edgesFlow < 0 && entry.previous && entry.previous.origin) {
        // even if the entry will be deleted from the transaction, we set the correct origin for it
        // this is because there might be other references to this entry in the stack
        // and also the entry may be referenced as dependency of some other quark
        // in such case the correct `originId` will preserve dependency during revisions compactification
        entry.setOrigin(entry.previous.origin); // if there's no outgoing edges we remove the quark

        if (entry.size === 0) {
          entries.delete(identifier);
        } // reduce garbage collection workload


        entry.cleanup();
        stack.pop();
        continue;
      }

      if (
      /*entry.isShadow() ||*/
      entry.hasValue() || entry.proposedValue === _Quark_js__WEBPACK_IMPORTED_MODULE_8__["TombStone"]) {
        entry.cleanup();
        stack.pop();
        continue;
      }

      const startedAtEpoch = entry.visitEpoch;
      let iterationResult = entry.isCalculationStarted() ? entry.iterationResult : entry.startCalculation(this.onEffectSync);

      while (iterationResult) {
        const value = iterationResult.value === undefined ? null : iterationResult.value;

        if (entry.isCalculationCompleted()) {
          if (entry.visitEpoch == startedAtEpoch) {
            this.onQuarkCalculationCompleted(entry, value);
          }

          stack.pop();
          break;
        } else if (value instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_7__["Identifier"]) {
          const onReadIdentifierResult = this.onReadIdentifier(value, entry, stack); // handle the cycle

          if (onReadIdentifierResult instanceof _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_10__["ComputationCycle"]) {
            this.walkContext.startNewEpoch();
            this.graph.onComputationCycleHandlerSync(onReadIdentifierResult);
            entry.cleanupCalculation();
            iterationResult = undefined;
          } else {
            iterationResult = onReadIdentifierResult;
          }
        } else if (value === _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_3__["SynchronousCalculationStarted"]) {
          // the fact, that we've encountered `SynchronousCalculationStarted` constant can mean 2 things:
          // 1) there's a cycle during synchronous computation (we throw exception in `read` method)
          // 2) some other computation is reading synchronous computation, that has already started
          //    in such case its safe to just unwind the stack
          stack.pop();
          break;
        } else {
          // bypass the unrecognized effect to the outer context
          const effectResult = context(value);
          if (effectResult instanceof Promise) throw new Error("Effect resolved to promise in the synchronous context, check that you marked the asynchronous calculations accordingly"); // the calculation can be interrupted (`cleanupCalculation`) as a result of the effect (WriteEffect)
          // in such case we can not continue calculation and just exit the inner loop

          if (effectResult === _Effect_js__WEBPACK_IMPORTED_MODULE_6__["BreakCurrentStackExecution"]) break; // // the calculation can be interrupted (`cleanupCalculation`) as a result of the effect (WriteEffect)
          // // in such case we can not continue calculation and just exit the inner loop
          // if (entry.iterationResult)

          if (entry.visitEpoch === startedAtEpoch) {
            iterationResult = entry.continueCalculation(effectResult);
          } else {
            stack.pop();
            break;
          } // else
          //     iterationResult         = null

        }
      }
    }

    this.activeStack = prevActiveStack;
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js":
/*!************************************************************************!*\
  !*** ./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js ***!
  \************************************************************************/
/*! exports provided: ComputationCycle, TransactionCycleDetectionWalkContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComputationCycle", function() { return ComputationCycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionCycleDetectionWalkContext", function() { return TransactionCycleDetectionWalkContext; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
var productName = 'gantt';

 //---------------------------------------------------------------------------------------------------------------------

class ComputationCycle extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  toString() {
    const cycleIdentifiers = [];
    const cycleEvents = [];
    this.cycle.forEach(({
      name,
      context
    }) => {
      cycleIdentifiers.push(name);
      if (cycleEvents[cycleEvents.length - 1] !== context) cycleEvents.push(context);
    });
    return 'events: \n' + cycleEvents.map(event => '#' + event.id).join(' => ') + '\n\nidentifiers: \n' + cycleIdentifiers.join('\n'); // return this.cycle.map(identifier => {
    //     return identifier.name
    //     // //@ts-ignore
    //     // const sourcePoint : SourceLinePoint      = identifier.SOURCE_POINT
    //     //
    //     // if (!sourcePoint) return identifier.name
    //     //
    //     // const firstEntry       = sourcePoint.stackEntries[ 0 ]
    //     //
    //     // if (firstEntry) {
    //     //     return `${identifier}\n    yielded at ${firstEntry.sourceFile}:${firstEntry.sourceLine}:${firstEntry.sourceCharPos || ''}`
    //     // } else
    //     //     return identifier.name
    // }).join(' => \n')
  }

} //---------------------------------------------------------------------------------------------------------------------

class TransactionCycleDetectionWalkContext extends _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["WalkContext"] {
  constructor() {
    // baseRevision    : Revision                  = undefined
    super(...arguments);
    this.transaction = undefined;
  }

  onCycle(node, stack) {
    return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["OnCycleAction"].Cancel;
  }

  doCollectNext(from, to, toVisit) {
    let visit = this.visited.get(to);

    if (!visit) {
      visit = {
        visitedAt: _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["NOT_VISITED"],
        visitEpoch: this.currentEpoch
      };
      this.visited.set(to, visit);
    }

    toVisit.push({
      node: to,
      from,
      label: undefined
    });
  }

  collectNext(from, toVisit) {
    const latestEntry = this.transaction.getLatestEntryFor(from);

    if (latestEntry) {
      latestEntry.outgoingInTheFutureTransactionCb(this.transaction, outgoingEntry => {
        this.doCollectNext(from, outgoingEntry.identifier, toVisit);
      });
    } // for (const outgoingIdentifier of visitInfo.getOutgoing().keys()) {
    //     this.doCollectNext(from, outgoingIdentifier, toVisit)
    // }

  }

}

/***/ }),

/***/ "./lib/ChronoGraph/chrono/TransactionWalkDepth.js":
/*!********************************************************!*\
  !*** ./lib/ChronoGraph/chrono/TransactionWalkDepth.js ***!
  \********************************************************/
/*! exports provided: TransactionWalkDepth */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionWalkDepth", function() { return TransactionWalkDepth; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

class TransactionWalkDepth extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.visited = new Map();
    this.transaction = undefined;
    this.baseRevision = undefined;
    this.pushTo = undefined;
    this.toVisit = [];
    this.currentEpoch = 0;
  }

  startFrom(sourceNodes) {
    this.continueFrom(sourceNodes);
  }

  continueFrom(sourceNodes) {
    this.toVisit.push.apply(this.toVisit, sourceNodes);
    this.walkDepth();
  }

  startNewEpoch() {
    if (this.toVisit.length) throw new Error("Can not start new walk epoch in the middle of the walk");
    this.currentEpoch++;
  }

  onTopologicalNode(identifier, visitInfo) {
    if (!identifier.lazy && identifier.level !== _Identifier_js__WEBPACK_IMPORTED_MODULE_2__["Levels"].UserInput) this.pushTo.push(visitInfo);
  }

  onCycle(node, stack) {
    return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["OnCycleAction"].Resume;
  } // it is more efficient (=faster) to create new quarks for yet unvisited identifiers
  // in batches, using this method, instead of in normal flow in the `walkDepth` method
  // this is probably because of the CPU context switch between the `this.visited` and `this.baseRevision.getLatestEntryFor`


  doCollectNext(from, to, toVisit) {
    let quark = this.visited.get(to);

    if (!quark) {
      quark = to.newQuark(this.baseRevision);
      quark.visitEpoch = this.currentEpoch;
      this.visited.set(to, quark);
    }

    toVisit.push(to);
  }

  collectNext(from, toVisit, visitInfo) {
    const latestEntry = this.baseRevision.getLatestEntryFor(from);

    if (latestEntry) {
      // since `collectNext` is called exactly once for every node, all quarks
      // will have the `previous` property populated
      visitInfo.previous = latestEntry;
      latestEntry.outgoingInTheFutureAndPastTransactionCb(this.transaction, outgoingEntry => {
        this.doCollectNext(from, outgoingEntry.identifier, toVisit);
      });
    }

    for (const outgoingIdentifier of visitInfo.getOutgoing().keys()) {
      this.doCollectNext(from, outgoingIdentifier, toVisit);
    }

    if (visitInfo.$outgoingPast !== undefined) for (const outgoingIdentifier of visitInfo.getOutgoingPast().keys()) {
      this.doCollectNext(from, outgoingIdentifier, toVisit);
    }
  }

  walkDepth() {
    const visited = this.visited;
    const toVisit = this.toVisit;
    let depth;

    while (depth = toVisit.length) {
      const node = toVisit[depth - 1];
      let visitInfo = visited.get(node);

      if (visitInfo && visitInfo.visitedAt === _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["VISITED_TOPOLOGICALLY"] && visitInfo.visitEpoch === this.currentEpoch) {
        visitInfo.edgesFlow++;
        toVisit.pop();
        continue;
      }

      if (visitInfo && visitInfo.visitEpoch === this.currentEpoch && visitInfo.visitedAt !== _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["NOT_VISITED"]) {
        // it is valid to find itself "visited", but only if visited at the current depth
        // (which indicates stack unwinding)
        // if the node has been visited at earlier depth - its a cycle
        if (visitInfo.visitedAt < depth) {
          // ONLY resume if explicitly returned `Resume`, cancel in all other cases (undefined, etc)
          if (this.onCycle(node, toVisit) !== _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["OnCycleAction"].Resume) break;
          visitInfo.edgesFlow++;
        } else {
          visitInfo.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["VISITED_TOPOLOGICALLY"];
          this.onTopologicalNode(node, visitInfo);
        }

        toVisit.pop();
      } else {
        const lengthBefore = toVisit.length;

        if (!visitInfo) {
          visitInfo = node.newQuark(this.baseRevision);
          visitInfo.visitEpoch = this.currentEpoch;
          visited.set(node, visitInfo);
        }

        this.collectNext(node, toVisit, visitInfo);

        if (visitInfo.visitEpoch < this.currentEpoch) {
          visitInfo.resetToEpoch(this.currentEpoch);
        }

        visitInfo.visitedAt = depth;
        visitInfo.edgesFlow++; // if there's no outgoing edges, node is at topological position
        // it would be enough to just continue the `while` loop and the `onTopologicalNode`
        // would happen on next iteration, but with this "inlining" we save one call to `visited.get()`
        // at the cost of length comparison

        if (toVisit.length === lengthBefore) {
          visitInfo.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_1__["VISITED_TOPOLOGICALLY"];
          this.onTopologicalNode(node, visitInfo);
          toVisit.pop();
        }
      }
    }
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/class/Base.js":
/*!***************************************!*\
  !*** ./lib/ChronoGraph/class/Base.js ***!
  \***************************************/
/*! exports provided: Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return Base; });
var productName = 'gantt'; //---------------------------------------------------------------------------------------------------------------------

/**
 * This is a base class, providing the type-safe static constructor [[new]]. This is very convenient when using
 * [[Mixin|mixins]], as mixins can not have types in the constructors.
 */

class Base {
  /**
   * This method applies its 1st argument (if any) to the current instance using `Object.assign()`.
   *
   * Supposed to be overridden in the subclasses to customize the instance creation process.
   *
   * @param props
   */
  initialize(props) {
    props && Object.assign(this, props);
  }
  /**
   * This is a type-safe static constructor method, accepting a single argument, with the object, corresponding to the
   * class properties. It will generate a compilation error, if unknown property is provided.
   *
   * For example:
   *
   * ```ts
   * class MyClass extends Base {
   *     prop     : string
   * }
   *
   * const instance : MyClass = MyClass.new({ prop : 'prop', wrong : 11 })
   * ```
   *
   * will produce:
   *
   * ```plaintext
   * TS2345: Argument of type '{ prop: string; wrong: number; }' is not assignable to parameter of type 'Partial<MyClass>'.
   * Object literal may only specify known properties, and 'wrong' does not exist in type 'Partial<MyClass>'
   * ```
   *
   * The only thing this constructor does is create an instance and call the [[initialize]] method on it, forwarding
   * the first argument. The customization of instance is supposed to be performed in that method.
   *
   * @param props
   */


  static new(props) {
    const instance = new this();
    instance.initialize(props);
    return instance;
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/class/BetterMixin.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/class/BetterMixin.js ***!
  \**********************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny, Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["identity"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["ZeroBaseClass"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"]; });

/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _Base_js__WEBPACK_IMPORTED_MODULE_1__["Base"]; });

var productName = 'gantt'; // backward compat




/***/ }),

/***/ "./lib/ChronoGraph/class/Mixin.js":
/*!****************************************!*\
  !*** ./lib/ChronoGraph/class/Mixin.js ***!
  \****************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return ZeroBaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return isInstanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return Mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return MixinAny; });
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
var productName = 'gantt';
 //---------------------------------------------------------------------------------------------------------------------

const MixinInstanceOfProperty = Symbol('MixinIdentity');
const MixinStateProperty = Symbol('MixinStateProperty'); //---------------------------------------------------------------------------------------------------------------------

class MixinWalkDepthState {
  constructor() {
    this.baseEl = undefined;
    this.sourceEl = undefined;
    this.$elementsByTopoLevel = undefined;
    this.$topoLevels = undefined;
    this.linearizedByTopoLevelsSource = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["MI"])(this.linearizedByTopoLevels());
  }

  static new(props) {
    const me = new this();
    props && Object.assign(me, props);
    return me;
  }

  get topoLevels() {
    if (this.$topoLevels !== undefined) return this.$topoLevels;
    return this.$topoLevels = this.buildTopoLevels();
  }

  buildTopoLevels() {
    return Array.from(this.elementsByTopoLevel.keys()).sort((level1, level2) => level1 - level2);
  }

  get elementsByTopoLevel() {
    if (this.$elementsByTopoLevel !== undefined) return this.$elementsByTopoLevel;
    return this.$elementsByTopoLevel = this.buildElementsByTopoLevel();
  }

  getOrCreateLevel(map, topoLevel) {
    let elementsAtLevel = map.get(topoLevel);

    if (!elementsAtLevel) {
      elementsAtLevel = [];
      map.set(topoLevel, elementsAtLevel);
    }

    return elementsAtLevel;
  }

  buildElementsByTopoLevel() {
    let maxTopoLevel = 0;
    const baseElements = this.baseEl ? Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.baseEl.walkDepthState.elementsByTopoLevel.values()).concat().toSet() : new Set();
    const map = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.sourceEl.requirements).map(mixin => mixin.walkDepthState.elementsByTopoLevel).concat().reduce((elementsByTopoLevel, [topoLevel, mixins]) => {
      if (topoLevel > maxTopoLevel) maxTopoLevel = topoLevel;
      this.getOrCreateLevel(elementsByTopoLevel, topoLevel).push(mixins);
      return elementsByTopoLevel;
    }, new Map());
    this.getOrCreateLevel(map, maxTopoLevel + 1).push([this.sourceEl]);
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(map).map(([level, elements]) => {
      return [level, Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(elements).concat().uniqueOnly().filter(mixin => !baseElements.has(mixin)).sort((mixin1, mixin2) => mixin1.id - mixin2.id)];
    }).toMap();
  }

  *linearizedByTopoLevels() {
    yield* Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.topoLevels).map(level => this.elementsByTopoLevel.get(level)).concat();
  }

} // Note: 65535 mixins only, because of the hashing function implementation (String.fromCharCode)


let MIXIN_ID = 1; //---------------------------------------------------------------------------------------------------------------------

const identity = a => class extends a {}; // export type IdentityMixin<Base extends object>         = < T extends AnyConstructor<Base>>(base : T) => T
//
// export const IdentityMixin             = <Base extends object>() : IdentityMixin<Base> => identity
//---------------------------------------------------------------------------------------------------------------------

class ZeroBaseClass {} //---------------------------------------------------------------------------------------------------------------------

class MixinState {
  constructor() {
    this.id = MIXIN_ID++;
    this.requirements = [];
    this.baseClass = ZeroBaseClass;
    this.identitySymbol = undefined;
    this.mixinLambda = identity;
    this.walkDepthState = undefined; // private $hash               : MixinHash             = ''

    this.$minimalClass = undefined;
    this.name = '';
  }

  static new(props) {
    const me = new this();
    props && Object.assign(me, props);
    me.walkDepthState = MixinWalkDepthState.new({
      sourceEl: me,
      baseEl: getMixinState(me.baseClass)
    }); //------------------

    const mixinLambda = me.mixinLambda;
    const symbol = me.identitySymbol = Symbol(mixinLambda.name);
    const mixinLambdaWrapper = Object.assign(function (base) {
      const extendedClass = mixinLambda(base);
      extendedClass.prototype[symbol] = true;
      return extendedClass;
    }, {
      [MixinInstanceOfProperty]: symbol,
      [MixinStateProperty]: me
    });
    Object.defineProperty(mixinLambdaWrapper, Symbol.hasInstance, {
      value: isInstanceOfStatic
    });
    me.mixinLambda = mixinLambdaWrapper;
    return me;
  }

  get minimalClass() {
    if (this.$minimalClass !== undefined) return this.$minimalClass;
    return this.$minimalClass = this.buildMinimalClass();
  } // get hash () : MixinHash {
  //     if (this.$hash !== '') return this.$hash
  //
  //     return this.$hash = this.buildHash()
  // }
  // buildHash () : MixinHash {
  //     return String.fromCharCode(...this.walkDepthState.linearizedByTopoLevelsSource.map(mixin => mixin.id))
  // }


  getBaseClassMixinId(baseClass) {
    const constructor = this.constructor;
    const mixinId = constructor.baseClassesIds.get(baseClass);
    if (mixinId !== undefined) return mixinId;
    const newId = MIXIN_ID++;
    constructor.baseClassesIds.set(baseClass, newId);
    return newId;
  }

  buildMinimalClass() {
    const self = this.constructor;
    let baseCls = this.baseClass;
    const minimalClassConstructor = this.walkDepthState.linearizedByTopoLevelsSource.reduce((acc, mixin) => {
      const {
        cls,
        hash
      } = acc;
      const nextHash = hash + String.fromCharCode(mixin.id);
      let wrapperCls = self.minimalClassesByLinearHash.get(nextHash);

      if (!wrapperCls) {
        wrapperCls = mixin.mixinLambda(cls);
        mixin.name = wrapperCls.name;
        self.minimalClassesByLinearHash.set(nextHash, wrapperCls);
      }

      acc.cls = wrapperCls;
      acc.hash = nextHash;
      return acc;
    }, {
      cls: baseCls,
      hash: String.fromCharCode(this.getBaseClassMixinId(baseCls))
    }).cls;
    const minimalClass = Object.assign(minimalClassConstructor, {
      [MixinInstanceOfProperty]: this.identitySymbol,
      [MixinStateProperty]: this,
      mix: this.mixinLambda,
      derive: base => Mixin([minimalClass, base], base => class extends base {}),
      $: this,
      toString: this.toString.bind(this)
    });
    Object.defineProperty(minimalClass, Symbol.hasInstance, {
      value: isInstanceOfStatic
    });
    return minimalClass;
  }

  toString() {
    return this.walkDepthState.linearizedByTopoLevelsSource.reduce((acc, mixin) => `${mixin.name}(${acc})`, this.baseClass.name);
  }

}

MixinState.minimalClassesByLinearHash = new Map();
MixinState.baseClassesIds = new Map(); //endregion type helpers
//---------------------------------------------------------------------------------------------------------------------

const isMixinClass = func => {
  return Object.getPrototypeOf(func.prototype).constructor.hasOwnProperty(MixinStateProperty);
};

const getMixinState = func => {
  return Object.getPrototypeOf(func.prototype).constructor[MixinStateProperty];
}; //---------------------------------------------------------------------------------------------------------------------


const mixin = (required, mixinLambda) => {
  let baseClass;

  if (required.length > 0) {
    const lastRequirement = required[required.length - 1]; // absence of `[ MixinStateProperty ]` indicates its a regular class and not a mixin class
    // avoid assigning ZeroBaseClass - it will be applied as default at the end

    if (!isMixinClass(lastRequirement) && lastRequirement !== ZeroBaseClass) baseClass = lastRequirement;
  }

  const requirements = [];
  required.forEach((requirement, index) => {
    const mixinState = requirement[MixinStateProperty];

    if (mixinState !== undefined) {
      const currentBaseClass = mixinState.baseClass; // ignore ZeroBaseClass - since those are compatible with any other base class

      if (currentBaseClass !== ZeroBaseClass) {
        if (baseClass) {
          // already found a base class from requirements earlier
          if (baseClass !== currentBaseClass) {
            const currentIsSub = currentBaseClass.prototype.isPrototypeOf(baseClass.prototype);
            const currentIsSuper = baseClass.prototype.isPrototypeOf(currentBaseClass.prototype);
            if (!currentIsSub && !currentIsSuper) throw new Error("Base class mismatch");
            baseClass = currentIsSuper ? currentBaseClass : baseClass;
          }
        } else // first base class from requirements
          baseClass = currentBaseClass;
      }

      requirements.push(mixinState);
    } else {
      if (index !== required.length - 1) throw new Error("Base class should be provided as the last element of the requirements array");
    }
  }); //------------------

  const mixinState = MixinState.new({
    requirements,
    mixinLambda: mixinLambda,
    baseClass: baseClass || ZeroBaseClass
  });
  return mixinState.minimalClass;
}; //---------------------------------------------------------------------------------------------------------------------
// this function works both with default mixin class and mixin application function
// it supplied internally as [Symbol.hasInstance] for the default mixin class and mixin application function


const isInstanceOfStatic = function (instance) {
  return Boolean(instance && instance[this[MixinInstanceOfProperty]]);
}; //---------------------------------------------------------------------------------------------------------------------

/**
 * This is the `instanceof` analog for the classes created with [[Mixin]] helper. It also provides [typeguard](https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards).
 *
 * There's no strict need to use it, as the native `instanceof` is also supported for the mixins created with the [[Mixin]] helper and also provides
 * typeguarding.
 *
 * @param instance Any value, normally an instance of the mixin class
 * @param func The constructor function of the class, created with [[Mixin]]
 */


const isInstanceOf = (instance, func) => {
  return Boolean(instance && instance[func[MixinInstanceOfProperty]]);
}; //---------------------------------------------------------------------------------------

/**
 * This function allows you to create mixin classes. Mixin classes solves the well-known problem with "classical" single-class inheritance,
 * in which class hierarchy must form a tree. When using mixins, class hierarchy becomes an arbitrary acyclic graph.
 *
 * Another view on mixins is that, if "classical" class is a point (a vertice of the graph), mixin class is an arrow between the points
 * (an edge in the graph, or rather, a description of the edge).
 *
 * Some background information about the mixin pattern can be found [here](https://mariusschulz.com/blog/typescript-2-2-mixin-classes)
 * and [here](https://www.bryntum.com/blog/the-mixin-pattern-in-typescript-all-you-need-to-know/).
 *
 * The pattern, being described here, is the evolution of the previous work, and main advantage is that it solves the compilation error
 * for circular references.
 *
 * Mixin definition. Requirements
 * ------------------------------
 *
 * The pattern looks like:
 *
 *     class Mixin1 extends Mixin(
 *         [],
 *         (base : AnyConstructor) =>
 *
 *         class Mixin1 extends base {
 *             prop1        : string
 *             method1 () : string {
 *                 return this.prop1
 *             }
 *             static static1 : number
 *         }
 *     ){}
 *
 * The core of the definition above is the mixin lambda - a function which receives a base class as its argument and returns a class,
 * extending the base class with additional properties.
 *
 * The example above creates a mixin `Mixin1` which has no requirements. Requirements are the other mixins,
 * which needs to be included in the base class of this mixin.
 *
 * There's also a special type of the requirement,
 * called "base class requirement". It is optional and can only appear as the last argument of the requirements
 * array. It does not have to be a mixin, created with the `Mixin` function, but can be any JS class. This requirement
 * specifies, that the base class of this mixin should be a subclass of the given class (or that class itself).
 *
 * The requirements of the mixin needs to be listed 3 times:
 * - as an array of constructor functions, in the 1st argument of the `Mixin` function
 * - as an instance type intersection, in the 1st type argument for the [[AnyConstructor]] type
 * - as an static type intersection, in the 2nd type argument for the [[AnyConstructor]] type
 *
 * For example, `Mixin2` requires `Mixin1`:
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) =>
 *
 *         class Mixin2 extends base {
 *         }
 *     ){}
 *
 * And `Mixin3` requires both `Mixin1` and `Mixin2` (even that its redundant, since `Mixin2` already requires `Mixin1`,
 * but suppose we don't know the implementation details of the `Mixin2`):
 *
 *     class Mixin3 extends Mixin(
 *         [ Mixin1, Mixin2 ],
 *         (base : AnyConstructor<Mixin1 & Mixin2, typeof Mixin1 & typeof Mixin2>) =>
 *
 *         class Mixin3 extends base {
 *         }
 *     ){}
 *
 * Now, `Mixin4` requires `Mixin3`, plus, it requires the base class to be `SomeBaseClass`:
 *
 *     class SomeBaseClass {}
 *
 *     class Mixin4 extends Mixin(
 *         [ Mixin3, SomeBaseClass ],
 *         (base : AnyConstructor<
 *             Mixin3 & SomeBaseClass, typeof Mixin3 & typeof SomeBaseClass
 *         >) =>
 *
 *         class Mixin4 extends base {
 *         }
 *     ){}
 *
 * As already briefly mentioned, the requirements are "scanned" deep and included only once. Also all minimal classes are cached -
 * for example the creation of the Mixin3 will reuse the minimal class of the Mixin2 instead of creating a new intermediate class.
 * This means that all edges of the mixin dependencies graph are created only once (up to the base class).
 *
 * Requirements can not form cycles - that will generate both compilation error and run-time stack overflow.
 *
 * The typing for the `Mixin` function will provide a compilation error, if the requirements don't match, e.g. some requirement is
 * listed in the array, but missed in the types. This protects you from trivial mistakes. However, the typing is done up to 10 requirements only.
 * If you need more than 10 requirements for the mixin, use the [[MixinAny]] function, which is an exact analog of `Mixin`, but without
 * this type-level protection for requirements mismatch.
 *
 * It is possible to simplify the type of the `base` argument a bit, by using the [[ClassUnion]] helper. However, it seems in certain edge cases
 * it may lead to compilation errors. If your scenarios are not so complex you should give it a try. Using the [[ClassUnion]] helper, the
 * `Mixin3` can be defined as:
 *
 *     class Mixin3 extends Mixin(
 *         [ Mixin1, Mixin2 ],
 *         (base : ClassUnion<typeof Mixin1, typeof Mixin2>) =>
 *
 *         class Mixin3 extends base {
 *         }
 *     ){}
 *
 * Note, that due to this [issue](https://github.com/Microsoft/TypeScript/issues/7342), if you use decorators in your mixin class,
 * the declaration needs to be slightly more verbose (can not use compact notation for the arrow functions):
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) => {
 *             class Mixin2 extends base {
 *                 @decorator
 *                 prop2 : string
 *             }
 *             return Mixin2
 *         }
 *     ){}
 *
 * As you noticed, the repeating listing of the requirements is somewhat verbose. Suggestions how the pattern can be improved
 * are [very welcomed](mailto:nickolay8@gmail.com).
 *
 * Mixin instantiation. Mixin constructor. `instanceof`
 * --------------------------------
 *
 * You can instantiate any mixin class just by using its constructor:
 *
 *     const instance1 = new Mixin1()
 *     const instance2 = new Mixin2()
 *
 * As explained in details [here](https://mariusschulz.com/blog/typescript-2-2-mixin-classes), mixin constructor should accept variable number of arguments
 * with the `any` type. This is simply because the mixin is supposed to be applicable to any other base class, which may have its own type
 * of the constructor arguments.
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) => {
 *             class Mixin2 extends base {
 *                 prop2 : string
 *
 *                 constructor (...args: any[]) {
 *                     super(...args)
 *                     this.prop2 = ''
 *                 }
 *             }
 *             return Mixin2
 *         }
 *     ){}
 *
 * In other words, its not possible to provide any type-safety for mixin instantiation using regular class constructor.
 *
 * However, if we change the way we create class instances a little, we can get the type-safety back. For that,
 * we need to use a "uniform" class constructor - a constructor which has the same form for all classes. The [[Base]] class
 * provides such constructor as its static [[Base.new|new]] method. The usage of `Base` class is not required - you can use
 * any other base class.
 *
 * The `instanceof` operator works as expected for instances of the mixin classes. It also takes into account all the requirements.
 * For example:
 *
 *     const instance2 = new Mixin2()
 *
 *     const isMixin2 = instance2 instanceof Mixin2 // true
 *     const isMixin1 = instance2 instanceof Mixin1 // true, since Mixin2 requires Mixin1
 *
 * See also [[isInstanceOf]].
 *
 * "Manual" class derivation
 * --------------------------------
 *
 * You have defined a mixin using the `Mixin` function. Now you want to apply it to some base class to get the "specific" class to be able
 * to instantiate it. As described above - you don't have to, you can instantiate it directly.
 *
 * Sometimes however, you still want to derive the class "manually". For that, you can use static methods `mix` and `derive`, available
 * on all mixins.
 *
 * The `mix` method provides a direct access to the mixin lambda. It does not take requirements into account - that's the implementor's responsibility.
 * The `derive` method is something like "accumulated" mixin lambda - mixin lambda with all requirements.
 *
 * Both `mix` and `derive` provide the reasonably typed outcome.
 *
 *     class Mixin1 extends Mixin(
 *         [],
 *         (base : AnyConstructor) =>
 *
 *         class Mixin1 extends base {
 *             prop1        : string
 *         }
 *     ){}
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) =>
 *
 *         class Mixin2 extends base {
 *             prop2        : string
 *         }
 *     ){}
 *
 *     const ManualMixin1 = Mixin1.mix(Object)
 *     const ManualMixin2 = Mixin2.mix(Mixin1.mix(Object))
 *
 *     const AnotherManualMixin1 = Mixin1.derive(Object)
 *     const AnotherManualMixin2 = Mixin2.derive(Object)
 *
 * Generics
 * --------
 *
 * Using generics with mixins is tricky because TypeScript does not have higher-kinded types and type inference for generics. Still some form
 * of generic arguments is possible, using the interface merging trick.
 *
 * Here's the pattern:
 *
 * ```ts
 * class Duplicator<Element> extends Mixin(
 *     [],
 *     (base : AnyConstructor) =>
 *
 *     class Duplicator extends base {
 *         Element                 : any
 *
 *         duplicate (value : this[ 'Element' ]) : this[ 'Element' ][] {
 *             return [ value, value ]
 *         }
 *     }
 * ){}
 *
 * interface Duplicator<Element> {
 *     Element : Element
 * }
 *
 * const dup = new Duplicator<boolean>()
 *
 * dup.duplicate('foo') // TS2345: Argument of type '"foo"' is not assignable to parameter of type 'boolean'.
 * ```
 *
 * In the example above, we've defined a generic argument `Element` for the outer mixin class, but in fact, that argument is not used anywhere in the
 * nested class definition in the mixin lambda. Instead, in the nested class, we define a property `Element`, which plays the role of the
 * generic argument.
 *
 * Mixin class methods then can refer to the generic type as `this[ 'Element' ]`.
 *
 * The generic arguments of the outer and nested classes are tied together in the additional interface declaration, which, by TypeScript rules
 * is merged together with the class definition. In this declaration, we specify that property `Element` has type of the `Element` generic argument.
 *
 * Limitations
 * ---------
 *
 * The most important limitation we found (which affect the old pattern as well) is the compilation error, which will be issued for
 * the private/protected methods, when compiling with declarations emitting (*.d.ts files generation).
 *
 * This is a [well-known problem](https://github.com/microsoft/TypeScript/issues/35822) in the TypeScript world – the *.d.ts files do not represent
 * the internal data structures of the TypeScript compiler well. Instead they use some simplified syntax, optimized for human editing.
 * This is why the compiler may generate false positives in the incremental compilation mode – it uses *.d.ts files internally.
 *
 * This can be a show-stopper for the people that use declaration files (usually for publishing). Keep in mind though, that you can always
 * publish actual TypeScript sources along with the generated JavaScript files, instead of publishing JavaScript + declarations files.
 *
 */

const Mixin = mixin;
/**
 * This is an exact analog of the [[Mixin]] function, but without type-level protection for requirements mismatch.
 * It supports unlimited number of requirements.
 */

const MixinAny = mixin;

/***/ }),

/***/ "./lib/ChronoGraph/class/RequiredProperty.js":
/*!***************************************************!*\
  !*** ./lib/ChronoGraph/class/RequiredProperty.js ***!
  \***************************************************/
/*! exports provided: required, validateRequiredProperties */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "required", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateRequiredProperties", function() { return validateRequiredProperties; });
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
var productName = 'gantt';

const RequiredProperties = Symbol('RequiredProperties');

const emptyFn = () => undefined;

const required = Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_0__["DEBUG_ONLY"])((proto, propertyKey) => {
  let required = proto[RequiredProperties];
  if (!required) required = proto[RequiredProperties] = [];
  required.push(propertyKey);
});
const validateRequiredProperties = Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_0__["DEBUG_ONLY"])(context => {
  const required = context[RequiredProperties];

  if (required) {
    for (let i = 0; i < required.length; i++) if (context[required[i]] === undefined) throw new Error(`Required attribute [${String(required[i])}] is not provided`);
  }
});

/***/ }),

/***/ "./lib/ChronoGraph/collection/Iterator.js":
/*!************************************************!*\
  !*** ./lib/ChronoGraph/collection/Iterator.js ***!
  \************************************************/
/*! exports provided: split, inBatchesBySize, filter, drop, every, some, map, reduce, uniqueOnly, uniqueOnlyBy, reverse, takeWhile, takeUntilIncluding, takeUntilExcluding, concat, concatIterable, ChainedIteratorClass, ChainedIterator, CI, MemoizedIteratorClass, MemoizedIterator, MI */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inBatchesBySize", function() { return inBatchesBySize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return drop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return some; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnly", function() { return uniqueOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnlyBy", function() { return uniqueOnlyBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverse", function() { return reverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return takeWhile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilIncluding", function() { return takeUntilIncluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilExcluding", function() { return takeUntilExcluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatIterable", function() { return concatIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIteratorClass", function() { return ChainedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIterator", function() { return ChainedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CI", function() { return CI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIteratorClass", function() { return MemoizedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIterator", function() { return MemoizedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MI", function() { return MI; });
var productName = 'gantt'; //---------------------------------------------------------------------------------------------------------------------

/**
 * Given a single `Iterable`, returns an array of 2 iterables, mirroring the original one (which should not be used anymore).
 *
 * For example:
 *
 *     const gen = function* () { yield 1; yield 2; yield 3 }
 *
 *     const [ iterable1, iterable2 ] = split(gen())
 *     const [ iter1, iter2 ] = [
 *         iterable1[ Symbol.iterator ](),
 *         iterable2[ Symbol.iterator ]()
 *     ]
 *
 *     iter1.next() // 1
 *     iter2.next() // 1
 *     iter2.next() // 2
 *     iter2.next() // 3
 *     iter1.next() // 2
 *     iter1.next() // 3
 *     iter1.next() // done
 *     iter2.next() // done
 *
 * @param iterable
 */

function split(iterable) {
  const gen1Pending = [];
  const gen2Pending = [];
  let iterator;

  const gen1 = function* () {
    if (!iterator) iterator = iterable[Symbol.iterator]();

    while (true) {
      if (gen1Pending.length) {
        yield* gen1Pending;
        gen1Pending.length = 0;
      }

      if (!iterator) break;
      const {
        value,
        done
      } = iterator.next();

      if (done) {
        iterator = null;
        iterable = null;
        break;
      }

      gen2Pending.push(value);
      yield value;
    }
  };

  const gen2 = function* () {
    if (!iterator) iterator = iterable[Symbol.iterator]();

    while (true) {
      if (gen2Pending.length) {
        yield* gen2Pending;
        gen2Pending.length = 0;
      }

      if (!iterator) break;
      const {
        value,
        done
      } = iterator.next();

      if (done) {
        iterator = null;
        iterable = null;
        break;
      }

      gen1Pending.push(value);
      yield value;
    }
  };

  return [gen1(), gen2()];
} //---------------------------------------------------------------------------------------------------------------------

function* inBatchesBySize(iterator, batchSize) {
  if (batchSize < 0) throw new Error("Batch size needs to a natural number");
  batchSize = batchSize | 0;
  const runningBatch = [];

  for (const el of iterator) {
    if (runningBatch.length === batchSize) {
      yield runningBatch;
      runningBatch.length = 0;
    }

    runningBatch.push(el);
  }

  if (runningBatch.length > 0) yield runningBatch;
} //---------------------------------------------------------------------------------------------------------------------

function* filter(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* drop(iterator, howMany) {
  let i = 0;

  for (const el of iterator) {
    if (++i > howMany) yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function every(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (!func(el, i++)) return false;
  }

  return true;
} //---------------------------------------------------------------------------------------------------------------------

function some(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) return true;
  }

  return false;
} //---------------------------------------------------------------------------------------------------------------------

function* map(iterator, func) {
  let i = 0;

  for (const el of iterator) yield func(el, i++);
} //---------------------------------------------------------------------------------------------------------------------

function reduce(iterator, func, initialAcc) {
  let i = 0;
  let acc = initialAcc;

  for (const el of iterator) {
    acc = func(acc, el, i++);
  }

  return acc;
} //---------------------------------------------------------------------------------------------------------------------

function* uniqueOnly(iterator) {
  const seen = new Set();

  for (const el of iterator) {
    if (!seen.has(el)) {
      seen.add(el);
      yield el;
    }
  }
} //---------------------------------------------------------------------------------------------------------------------

function* uniqueOnlyBy(iterator, func) {
  const seen = new Set();

  for (const el of iterator) {
    const uniqueBy = func(el);

    if (!seen.has(uniqueBy)) {
      seen.add(uniqueBy);
      yield el;
    }
  }
} //---------------------------------------------------------------------------------------------------------------------

function* reverse(iterator) {
  const all = Array.from(iterator);

  for (let i = all.length - 1; i >= 0; i--) yield all[i];
} //---------------------------------------------------------------------------------------------------------------------

function* takeWhile(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) yield el;else return;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* takeUntilIncluding(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    yield el;
    if (func(el, i++)) return;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* takeUntilExcluding(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) return;
    yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* concat(...iterators) {
  for (let i = 0; i < iterators.length; i++) yield* iterators[i];
} //---------------------------------------------------------------------------------------------------------------------

function* concatIterable(iteratorsProducer) {
  for (const iterator of iteratorsProducer) yield* iterator;
} //---------------------------------------------------------------------------------------------------------------------
// just a chained syntax sugar class
// note, that we either use a combination of `this.derive()` + this.iterable (which will clear the `this.iterable`)
// or, use just `this` as iterable, which will also clear the iterator
//

class ChainedIteratorClass {
  constructor(iterable) {
    this.iterable = undefined;
    if (!iterable) throw new Error("Require an iterable instance for chaining");
    this.iterable = iterable;
  }

  derive(iterable) {
    this.iterable = undefined;
    return new ChainedIteratorClass(iterable);
  }

  copy() {
    const [iter1, iter2] = split(this.iterable);
    this.iterable = iter2;
    return new ChainedIteratorClass(iter1);
  }

  split() {
    const [iter1, iter2] = split(this.iterable);
    return [new ChainedIteratorClass(iter1), this.derive(iter2)];
  }

  inBatchesBySize(batchSize) {
    return this.derive(inBatchesBySize(this.iterable, batchSize));
  }

  filter(func) {
    return this.derive(filter(this.iterable, func));
  }

  drop(howMany) {
    return this.derive(drop(this.iterable, howMany));
  }

  map(func) {
    return this.derive(map(this.iterable, func));
  }

  reduce(func, initialAcc) {
    return reduce(this, func, initialAcc);
  }

  concat() {
    //@ts-ignore
    return this.derive(concatIterable(this.iterable));
  }

  uniqueOnly() {
    return this.derive(uniqueOnly(this.iterable));
  }

  uniqueOnlyBy(func) {
    return this.derive(uniqueOnlyBy(this.iterable, func));
  }

  every(func) {
    return every(this, func);
  }

  some(func) {
    return some(this, func);
  }

  takeWhile(func) {
    return this.derive(takeWhile(this.iterable, func));
  }

  *[Symbol.iterator]() {
    let iterable = this.iterable;
    if (!iterable) throw new Error("Chained iterator already exhausted or used to derive the new one"); // practice shows, that cleaning up the iterable after yourself helps garbage collector a lot

    this.iterable = undefined;
    yield* iterable; // yes, we really want to avoid memory leaks

    iterable = undefined;
  }

  toArray() {
    return Array.from(this);
  }

  sort(order) {
    return Array.from(this).sort(order);
  }

  toSet() {
    return new Set(this);
  }

  toMap() {
    //@ts-ignore
    return new Map(this);
  } // toMap<K, V> () : T extends [ K, V ] ? Map<K, V> : never  {
  //     return new Map<K, V>(this.iterable as (T extends [ K, V ] ? Iterable<T> : never)) as (T extends [ K, V ] ? Map<K, V> : never)
  // }


  flush() {
    for (const element of this) {}
  }

  memoize() {
    return new MemoizedIteratorClass(this);
  }

}
const ChainedIterator = iterator => new ChainedIteratorClass(iterator);
const CI = ChainedIterator; //---------------------------------------------------------------------------------------------------------------------

class MemoizedIteratorClass extends ChainedIteratorClass {
  constructor() {
    super(...arguments);
    this.elements = [];
    this.$iterator = undefined;
  }

  set iterable(iterable) {
    this.$iterable = iterable;
  }

  get iterable() {
    return this;
  }

  derive(iterable) {
    return new ChainedIteratorClass(iterable);
  }

  *[Symbol.iterator]() {
    const elements = this.elements;

    if (this.$iterable) {
      if (!this.$iterator) this.$iterator = this.$iterable[Symbol.iterator]();
      let iterator = this.$iterator;
      let alreadyConsumed = elements.length; // yield the 1st batch "efficiently"

      if (alreadyConsumed > 0) yield* elements;

      while (true) {
        if (elements.length > alreadyConsumed) {
          // wonder if `yield* elements.slice(alreadyConsumed)` is more performant or not
          for (let i = alreadyConsumed; i < elements.length; i++) yield elements[i];

          alreadyConsumed = elements.length;
        }

        if (!iterator) break;
        const {
          value,
          done
        } = iterator.next();

        if (done) {
          iterator = this.$iterator = null;
          this.$iterable = null;
        } else {
          elements.push(value);
          alreadyConsumed++;
          yield value;
        }
      }
    } else {
      yield* elements;
    }
  }

}
const MemoizedIterator = iterator => new MemoizedIteratorClass(iterator);
const MI = MemoizedIterator;

/***/ }),

/***/ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js":
/*!*********************************************************!*\
  !*** ./lib/ChronoGraph/cycle_resolver/CycleResolver.js ***!
  \*********************************************************/
/*! exports provided: CalculateProposed, Formula, VariableWalkContext, FormulasCache, CycleDescription, CycleResolution, VariableInputState, CycleResolutionInput, WalkState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculateProposed", function() { return CalculateProposed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Formula", function() { return Formula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableWalkContext", function() { return VariableWalkContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormulasCache", function() { return FormulasCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleDescription", function() { return CycleDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolution", function() { return CycleResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableInputState", function() { return VariableInputState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInput", function() { return CycleResolutionInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkState", function() { return WalkState; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../class/RequiredProperty.js */ "./lib/ChronoGraph/class/RequiredProperty.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let FORMULA_ID = 0; //---------------------------------------------------------------------------------------------------------------------

/**
 * Pre-defined constant formula id. If assigned to some variable, specifies, that this variable should keep the value proposed by user
 * (user input), or, if there's none, its previous value.
 */

const CalculateProposed = FORMULA_ID++; // export const CalculatePure : FormulaId          = FORMULA_ID++
//---------------------------------------------------------------------------------------------------------------------

/**
 * Class, describing a formula, which is part of the cyclic set. Formula just specifies its input variables and output variable,
 * it does not contain actual calculation.
 *
 * It is assumed that formula can only be "activated" if all of its inputs has value. It can be either a value from the previous iteration,
 * a value provided by user, or an output value of some other formula. See [[VariableInputState]] and [[CycleResolutionInput]].
 */

class Formula extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * The id of the formula. It is assigned automatically, should not be changed.
     */

    this.formulaId = FORMULA_ID++;
    /**
     * A set of the input variables for this formula.
     */

    this.inputs = new Set();
  }

} //---------------------------------------------------------------------------------------------------------------------

class VariableWalkContext extends _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_5__["WalkContext"] {
  collectNext(sourceNode, toVisit) {
    if (sourceNode instanceof Formula) {
      toVisit.push({
        node: sourceNode.output,
        from: sourceNode,
        label: undefined
      });
    } else {
      const formulas = this.cache.formulasByInput.get(sourceNode);
      formulas && formulas.forEach(formula => toVisit.push({
        node: formula,
        from: sourceNode,
        label: undefined
      }));
    }
  }

} //---------------------------------------------------------------------------------------------------------------------

class FormulasCache extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"]], base => class FormulasCache extends base {
  constructor() {
    super(...arguments);
    /**
     * A set of variables, which forms cyclic computation
     */

    this.variables = new Set();
    /**
     * A set of formulas, which forms cyclic computation
     */

    this.formulas = new Set();
    this.$formulasByInput = undefined;
    this.$formulasByOutput = undefined;
  }

  get formulasByInput() {
    if (this.$formulasByInput !== undefined) return this.$formulasByInput;
    this.fillCache();
    return this.$formulasByInput;
  }

  get formulasByOutput() {
    if (this.$formulasByOutput !== undefined) return this.$formulasByOutput;
    this.fillCache();
    return this.$formulasByOutput;
  }

  add(formula) {
    this.$formulasByInput = undefined;
    this.$formulasByOutput = undefined;
    this.formulas.add(formula);
  }

  has(formula) {
    return this.formulas.has(formula);
  }

  fillCache() {
    this.$formulasByInput = new Map();
    this.$formulasByOutput = new Map();
    this.formulas.forEach(formula => {
      let formulasByOutput = this.$formulasByOutput.get(formula.output);

      if (!formulasByOutput) {
        formulasByOutput = new Set();
        this.$formulasByOutput.set(formula.output, formulasByOutput);
      }

      formulasByOutput.add(formula);
      formula.inputs.forEach(input => {
        let formulasByInput = this.$formulasByInput.get(input);

        if (!formulasByInput) {
          formulasByInput = new Set();
          this.$formulasByInput.set(input, formulasByInput);
        }

        formulasByInput.add(formula);
      });
    });
  }

  allInputVariables() {
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["uniqueOnly"])(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["concatIterable"])(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["map"])(this.formulas, formula => formula.inputs.values())));
  }

  isCyclic() {
    let isCyclic = false;
    const walkContext = VariableWalkContext.new({
      cache: this,
      onCycle: () => {
        isCyclic = true;
        return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_5__["OnCycleAction"].Cancel;
      }
    });
    walkContext.startFrom(Array.from(this.allInputVariables()));
    return isCyclic;
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

/**
 * Abstract description of the cycle. Does not include the default formula resolution, only variables and formulas. See also [[CycleResolution]].
 */

class CycleDescription extends FormulasCache {} //---------------------------------------------------------------------------------------------------------------------

/**
 * Class describing the cycle resolution process. Requires the abstract cycle [[description]] and a set of default formulas.
 *
 * The resolution is performed with [[CycleResolution.resolve]] method.
 *
 * Resolution are memoized, based on the input. You should generally have a single instance of this class for a single set of default formulas,
 * to accumulate the results and make resolution fast.
 */

class CycleResolution extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * Abstract cycle description for this resolution.
     */

    this.description = undefined;
    /**
     * A set of default formulas for this resolution. Default formulas specifies how the calculation should be performed, if there's no user input
     * for any variable (or there's input for all of them). Also, default formulas are preferred, if several formulas can be chosen to continue the resolution.
     */

    this.defaultResolutionFormulas = new Set();
    this.resolutionsByInputHash = new Map();
  } // the caching space is 3^var_num might need to clear the memory at some time


  clear() {
    this.resolutionsByInputHash.clear();
  }
  /**
   * This method accepts an input object and returns a cycle resolution.
   * Resolution are memoized, based on the input.
   *
   * @param input
   */


  resolve(input) {
    const cached = this.resolutionsByInputHash.get(input.hash);
    if (cached !== undefined) return cached;
    const resolution = this.buildResolution(input);
    this.resolutionsByInputHash.set(input.hash, resolution);
    return resolution;
  }

  buildResolution(input) {
    const walkContext = WalkState.new({
      context: this,
      input
    });
    const allResolutions = Array.from(walkContext.next()).map(state => {
      return {
        resolution: state.asResolution(),
        nbrOfDefaultFormulas: Array.from(state.activatedFormulas.formulas).reduce((count, formula) => state.formulaIsDefault(formula) ? count + 1 : count, 0),
        unCoveredInputWeight: state.unCoveredInputWeight()
      };
    });
    allResolutions.sort((res1, res2) => {
      if (res1.unCoveredInputWeight < res2.unCoveredInputWeight) return -1;
      if (res1.unCoveredInputWeight > res2.unCoveredInputWeight) return 1;
      return res2.nbrOfDefaultFormulas - res1.nbrOfDefaultFormulas;
    });
    if (allResolutions.length > 0) return allResolutions[0].resolution;else debugger; // return default? or all-proposed?
  }

}
/**
 * Enumeration for various states of the input data for variables in the cycle. Individual members corresponds to binary bits and can be set simultaneously, like:
 *
 * ```ts
 * const input : VariableInputState = VariableInputState.HasPreviousValue | VariableInputState.HasProposedValue
 * ```
 */

var VariableInputState;

(function (VariableInputState) {
  VariableInputState[VariableInputState["NoInput"] = 0] = "NoInput";
  /**
   * This bit indicates that variable has some previous value, when resolution starts. It can be any non-`undefined` value, including `null`.
   */

  VariableInputState[VariableInputState["HasPreviousValue"] = 1] = "HasPreviousValue";
  /**
   * This bit indicates that variable has user input, when resolution starts. It can be any non-`undefined` value, including `null`.
   */

  VariableInputState[VariableInputState["HasProposedValue"] = 2] = "HasProposedValue";
  /**
   * This bit indicates, that user intention is to keep this variable unchanged, if that is possible (does not contradict to other user input).
   */

  VariableInputState[VariableInputState["KeepIfPossible"] = 4] = "KeepIfPossible";
})(VariableInputState || (VariableInputState = {})); //---------------------------------------------------------------------------------------------------------------------

/**
 * Class, describing the input data for a set of variables during cycle resolution.
 */


class CycleResolutionInput extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * A cycle resolution instance this input corresponds to.
     */

    this.context = undefined;
    this.input = undefined;
    this.$hash = '';
  }

  get hash() {
    if (this.$hash !== '') return this.$hash;
    return this.$hash = this.buildHash();
  }

  get description() {
    return this.context.description;
  }
  /**
   * Returns the same result as calling [[CycleResolution.resolve]] on this input instance
   */


  get resolution() {
    return this.context.resolve(this);
  }

  initialize(...args) {
    super.initialize(...args);
    Object(_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_2__["validateRequiredProperties"])(this);
    this.input = new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).map(variable => [variable, VariableInputState.NoInput]));
  }

  buildHash() {
    return String.fromCharCode(...Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).inBatchesBySize(5).map(batch => this.batchToCharCode(batch)));
  }

  batchToCharCode(batch) {
    return batch.reduceRight((charCode, variable, index) => charCode | this.input.get(variable) << index * 3, 0);
  } //---------------------

  /**
   * This method sets the [[HasProposedValue]] flag for the specified variable.
   *
   * @param variable
   */


  addProposedValueFlag(variable) {
    if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_4__["DEBUG"]) {
      if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
      if (this.$hash !== '') throw new Error('Already hashed');
    }

    const input = this.input.get(variable);
    this.input.set(variable, input | VariableInputState.HasProposedValue);
  }

  hasProposedValue(variable) {
    return Boolean(this.input.get(variable) & VariableInputState.HasProposedValue);
  }

  hasProposedValueVars() {
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).filter(variable => this.hasProposedValue(variable));
  } //---------------------

  /**
   * This method sets the [[HasPreviousValue]] flag for the specified variable.
   *
   * @param variable
   */


  addPreviousValueFlag(variable) {
    if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_4__["DEBUG"]) {
      if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
      if (this.$hash !== '') throw new Error('Already hashed');
    }

    const input = this.input.get(variable);
    this.input.set(variable, input | VariableInputState.HasPreviousValue);
  }

  hasPreviousValue(variable) {
    return Boolean(this.input.get(variable) & VariableInputState.HasPreviousValue);
  }

  hasPreviousValueVars() {
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).filter(variable => this.hasPreviousValue(variable));
  } //---------------------

  /**
   * This method sets the [[KeepIfPossible]] flag for the specified variable.
   *
   * @param variable
   */


  addKeepIfPossibleFlag(variable) {
    if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_4__["DEBUG"]) {
      if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
      if (this.$hash !== '') throw new Error('Already hashed');
    }

    const input = this.input.get(variable);
    this.input.set(variable, input | VariableInputState.KeepIfPossible);
  }

  keepIfPossible(variable) {
    return Boolean(this.input.get(variable) & VariableInputState.KeepIfPossible);
  }

  keepIfPossibleVars() {
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).filter(variable => this.keepIfPossible(variable));
  }

}

__decorate([_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_2__["required"]], CycleResolutionInput.prototype, "context", void 0); //---------------------------------------------------------------------------------------------------------------------


class WalkState extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.context = undefined;
    this.input = undefined;
    this.previous = undefined;
    this.activatedFormula = undefined;
    this.$activatedFormulas = undefined;
  }

  get activatedFormulas() {
    if (this.$activatedFormulas !== undefined) return this.$activatedFormulas;
    const cache = FormulasCache.new({
      variables: this.description.variables,
      formulas: Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.thisAndPreviousStates()).map(state => state.activatedFormula).toSet()
    });
    return this.$activatedFormulas = cache;
  }

  get description() {
    return this.context.description;
  }

  *thisAndPreviousStates() {
    let current = this;

    while (current && current.activatedFormula) {
      yield current;
      current = current.previous;
    }
  }

  formulaHasProposedValueInInput(formula) {
    return Array.from(formula.inputs).some(variable => this.input.hasProposedValue(variable));
  } // this method counts


  unCoveredInputWeight() {
    const proposedVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["map"])(this.input.hasProposedValueVars(), variable => {
      return {
        variable,
        isProposed: true
      };
    });
    const keepIfPossibleVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["map"])(this.input.keepIfPossibleVars(), variable => {
      return {
        variable,
        isProposed: false
      };
    });
    const allInputVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])([proposedVars, keepIfPossibleVars]).concat().uniqueOnlyBy(el => el.variable);
    return allInputVars.reduce((totalWeight, {
      variable,
      isProposed
    }) => {
      let weight = 0; //-----------------

      const isOverwrittenByFormulas = this.activatedFormulas.formulasByOutput.get(variable);

      if (isOverwrittenByFormulas) {
        const formula = isOverwrittenByFormulas.size === 1 ? Array.from(isOverwrittenByFormulas)[0] : null; // the case, when some user input is overwritten with the default formula should be weighted less than
        // its overwritten with regular formula

        if (formula && this.formulaIsDefault(formula) && this.formulaHasProposedValueInInput(formula)) {
          if (isProposed) weight += 1e6;else weight += 1e4;
        } else {
          if (isProposed) weight += 1e7;else weight += 1e5;
        }
      } //-----------------


      const usedInFormulas = this.activatedFormulas.formulasByInput.get(variable);

      if (!(usedInFormulas && usedInFormulas.size > 0)) {
        if (isProposed) weight += 1e3;else weight += 1e2;
      }

      return totalWeight + weight;
    }, 0);
  }

  preferFormula(formula1, formula2) {
    const allInputsHasProposed1 = this.formulaAllInputsHasProposed(formula1);
    const allInputsHasProposed2 = this.formulaAllInputsHasProposed(formula2);
    if (allInputsHasProposed1 && !allInputsHasProposed2) return -1;
    if (allInputsHasProposed2 && !allInputsHasProposed1) return 1;
    const countInputsWithProposedOrKeep1 = this.formulaCountInputsWithProposedOrKeep(formula1);
    const countInputsWithProposedOrKeep2 = this.formulaCountInputsWithProposedOrKeep(formula2);
    if (countInputsWithProposedOrKeep1 > countInputsWithProposedOrKeep2) return -1;
    if (countInputsWithProposedOrKeep1 < countInputsWithProposedOrKeep2) return 1;
    if (this.formulaIsDefault(formula1) && !this.formulaIsDefault(formula2)) return -1;
    if (this.formulaIsDefault(formula2) && !this.formulaIsDefault(formula1)) return 1;
    return 0;
  }

  formulaIsDefault(formula) {
    return this.context.defaultResolutionFormulas.has(formula);
  }

  formulaCountInputsWithProposedOrKeep(formula) {
    let count = 0;
    Array.from(formula.inputs).forEach(variable => {
      if (this.input.hasProposedValue(variable) || this.input.keepIfPossible(variable)) count++;
    });
    return count;
  }

  formulaAllInputsHasProposedOrKeep(formula) {
    return Array.from(formula.inputs).every(variable => this.input.hasProposedValue(variable) || this.input.keepIfPossible(variable));
  }

  formulaAllInputsHasProposed(formula) {
    return Array.from(formula.inputs).every(variable => this.input.hasProposedValue(variable));
  }

  formulaIsApplicable(formula) {
    const everyFormulaInputHasValue = Array.from(formula.inputs).every(variable => this.input.hasProposedValue(variable) || this.input.hasPreviousValue(variable) || this.activatedFormulas.formulasByOutput.has(variable));
    const cache = FormulasCache.new({
      formulas: new Set(this.activatedFormulas.formulas)
    });
    cache.add(formula);
    return everyFormulaInputHasValue && !cache.isCyclic();
  }

  formulaIsInsignificant(formula) {
    const outputVariableAlreadyCalculated = this.activatedFormulas.formulasByOutput.has(formula.output);
    const outputVariableHasPreviousValue = this.input.hasPreviousValue(formula.output);
    return outputVariableAlreadyCalculated || outputVariableHasPreviousValue && Array.from(formula.inputs).some(variable => !this.input.hasPreviousValue(variable) && !this.input.hasProposedValue(variable));
  }

  unvisitedFormulas() {
    return Array.from(this.description.formulas).filter(formula => !this.activatedFormulas.has(formula));
  }

  *next() {
    const unvisitedFormulas = this.unvisitedFormulas();
    unvisitedFormulas.sort(this.preferFormula.bind(this));
    let isFinal = true;

    for (const formula of unvisitedFormulas) {
      if (!this.formulaIsApplicable(formula) || this.formulaIsInsignificant(formula)) continue;
      const nextState = WalkState.new({
        previous: this,
        context: this.context,
        input: this.input,
        activatedFormula: formula
      });
      yield* nextState.next();
      isFinal = false;
    }

    if (isFinal) yield this;
  }

  asResolution() {
    return new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_3__["CI"])(this.description.variables).map(variable => {
      const formulas = this.activatedFormulas.formulasByOutput.get(variable);

      if (formulas) {
        for (const firstFormula of formulas) {
          return [variable, firstFormula.formulaId];
        }
      }

      return [variable, CalculateProposed];
    }));
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/environment/Debug.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/environment/Debug.js ***!
  \**********************************************/
/*! exports provided: DEBUG, DEBUG_ONLY, debug, warn, StackEntry, SourceLinePoint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEBUG", function() { return DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEBUG_ONLY", function() { return DEBUG_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return debug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StackEntry", function() { return StackEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SourceLinePoint", function() { return SourceLinePoint; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

const DEBUG = false;

const emptyFn = (...args) => undefined;

const DEBUG_ONLY = func => DEBUG ? func : emptyFn;
const debug = DEBUG_ONLY(e => {
  debugger;
}); //---------------------------------------------------------------------------------------------------------------------

const warn = DEBUG_ONLY(e => {
  if (typeof console !== 'undefined') console.warn(e);
}); //---------------------------------------------------------------------------------------------------------------------

class StackEntry extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {} //---------------------------------------------------------------------------------------------------------------------

class SourceLinePoint extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.stackEntries = [];
  }

  static fromError(e) {
    const res = SourceLinePoint.new({
      exception: e,
      stackEntries: parseErrorStack(e.stack)
    });
    return res;
  }

  static fromThisCall() {
    const sourceLinePoint = this.fromError(new Error());
    sourceLinePoint.stackEntries.splice(0, 2);
    return sourceLinePoint;
  }

} //---------------------------------------------------------------------------------------------------------------------
// sample stack
// Error
//     at exceptionCatcher (http://lh/bryntum-suite/SchedulingEngine/lib/ChronoGraph/environment/Debug.js:15:11)
//     at Function.fromCurrentCall (http://lh/bryntum-suite/SchedulingEngine/lib/ChronoGraph/environment/Debug.js:39:38)
//     at Object.get (http://lh/bryntum-suite/SchedulingEngine/lib/ChronoGraph/replica/Entity.js:31:73)
//     at MinimalGanttProject.set (http://lh/bryntum-suite/SchedulingEngine/lib/ChronoGraph/replica/Entity.js:222:23)
//     at MinimalGanttProject.set data [as data] (http://lh/bryntum-suite/SchedulingEngine/lib/Engine/chrono/ChronoModelMixin.js:48:31)
//     at MinimalGanttProject.construct (http://lh/bryntum-suite/SchedulingEngine/lib/Core/data/Model.js:290:17)
//     at MinimalGanttProject.construct (http://lh/bryntum-suite/SchedulingEngine/lib/Core/mixin/Events.js:236:15)
//     at MinimalGanttProject.construct (http://lh/bryntum-suite/SchedulingEngine/lib/Engine/chrono/ChronoModelMixin.js:21:19)
//     at MinimalGanttProject.construct (http://lh/bryntum-suite/SchedulingEngine/lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js:53:19)
//     at new Base (http://lh/bryntum-suite/SchedulingEngine/lib/Core/Base.js:55:14)"

const parseErrorStack = stack => {
  return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_1__["CI"])(Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["matchAll"])(/^   +at\s*(.*?)\s*\((https?:\/\/.*?):(\d+):(\d+)/gm, stack)).map(match => StackEntry.new({
    statement: match[1],
    sourceFile: match[2],
    sourceLine: Number(match[3]),
    sourceCharPos: Number(match[4])
  })).toArray();
};

/***/ }),

/***/ "./lib/ChronoGraph/graph/WalkDepth.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/graph/WalkDepth.js ***!
  \********************************************/
/*! exports provided: OnCycleAction, WalkSource, NOT_VISITED, VISITED_TOPOLOGICALLY, WalkContext, cycleInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OnCycleAction", function() { return OnCycleAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkSource", function() { return WalkSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOT_VISITED", function() { return NOT_VISITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISITED_TOPOLOGICALLY", function() { return VISITED_TOPOLOGICALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkContext", function() { return WalkContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cycleInfo", function() { return cycleInfo; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
var productName = 'gantt';

var OnCycleAction;

(function (OnCycleAction) {
  OnCycleAction["Cancel"] = "Cancel";
  OnCycleAction["Resume"] = "Resume";
})(OnCycleAction || (OnCycleAction = {})); //---------------------------------------------------------------------------------------------------------------------


const WalkSource = Symbol('WalkSource');
const NOT_VISITED = -1;
const VISITED_TOPOLOGICALLY = -2; //---------------------------------------------------------------------------------------------------------------------

class WalkContext extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.visited = new Map();
    this.toVisit = [];
    this.currentEpoch = 0;
  }

  startFrom(sourceNodes) {
    this.continueFrom(sourceNodes);
  }

  continueFrom(sourceNodes) {
    this.toVisit.push.apply(this.toVisit, sourceNodes.map(node => {
      return {
        node: node,
        from: WalkSource,
        label: undefined
      };
    }));
    this.walkDepth();
  }

  onNode(node, walkStep) {}

  onTopologicalNode(node) {}

  onCycle(node, stack) {
    return OnCycleAction.Cancel;
  }

  forEachNext(node, func) {
    throw new Error("Abstract method called");
  }

  collectNext(node, toVisit, visitInfo) {
    throw new Error("Abstract method called");
  }

  getVisitedInfo(node) {
    return this.visited.get(node);
  }

  setVisitedInfo(node, visitedAt, info) {
    if (!info) {
      info = {
        visitedAt,
        visitEpoch: this.currentEpoch
      };
      this.visited.set(node, info);
    } else {
      info.visitedAt = visitedAt;
      info.visitEpoch = this.currentEpoch;
    }

    return info;
  }

  walkDepth() {
    const visited = this.visited;
    const toVisit = this.toVisit;
    let depth;

    while (depth = toVisit.length) {
      const node = toVisit[depth - 1].node;
      const visitedInfo = this.getVisitedInfo(node); // this supports the "ahead-of-time" creation of the "visited" entries, which actually lead to improved benchmarks,
      // so it might be a default

      if (visitedInfo && visitedInfo.visitedAt === VISITED_TOPOLOGICALLY && visitedInfo.visitEpoch === this.currentEpoch) {
        toVisit.pop();
        continue;
      }

      if (visitedInfo && visitedInfo.visitEpoch === this.currentEpoch && visitedInfo.visitedAt !== NOT_VISITED) {
        // it is valid to find itself "visited", but only if visited at the current depth
        // (which indicates stack unwinding)
        // if the node has been visited at earlier depth - its a cycle
        if (visitedInfo.visitedAt < depth) {
          // ONLY resume if explicitly returned `Resume`, cancel in all other cases (undefined, etc)
          if (this.onCycle(node, toVisit) !== OnCycleAction.Resume) break;
        } else {
          visitedInfo.visitedAt = VISITED_TOPOLOGICALLY;
          this.onTopologicalNode(node);
        }

        toVisit.pop();
      } else {
        // if we break here, we can re-enter the loop later
        if (this.onNode(node, toVisit[depth - 1]) === false) break; // first entry to the node

        const visitedInfo2 = this.setVisitedInfo(node, depth, visitedInfo);
        const lengthBefore = toVisit.length;
        this.collectNext(node, toVisit, visitedInfo2); // if there's no outgoing edges, node is at topological position
        // it would be enough to just continue the `while` loop and the `onTopologicalNode`
        // would happen on next iteration, but with this "inlining" we save one call to `visited.get()`
        // at the cost of length comparison

        if (toVisit.length === lengthBefore) {
          visitedInfo2.visitedAt = VISITED_TOPOLOGICALLY;
          this.onTopologicalNode(node);
          toVisit.pop();
        }
      }
    }
  }

} //---------------------------------------------------------------------------------------------------------------------

function cycleInfo(stack) {
  const length = stack.length;
  if (length === 0) return [];
  const cycleSource = stack[length - 1].node;
  const cycle = [cycleSource];
  let current = length - 1;
  let cursor = current;

  while (current >= 0 && stack[current].from !== cycleSource) {
    // going backward in steps, skipping the nodes with identical `from`
    while (current >= 0 && stack[current].from === stack[cursor].from) current--;

    if (current >= 0) {
      // the first node with different `from` will be part of the cycle path
      cycle.push(stack[current].node);
      cursor = current;
    }
  } // no cycle


  if (current < 0) return [];
  cycle.push(cycleSource);
  return cycle.reverse();
}

/***/ }),

/***/ "./lib/ChronoGraph/primitives/Calculation.js":
/*!***************************************************!*\
  !*** ./lib/ChronoGraph/primitives/Calculation.js ***!
  \***************************************************/
/*! exports provided: ContextSync, ContextGen, CalculationGen, SynchronousCalculationStarted, CalculationSync, runGeneratorSyncWithEffect, runGeneratorAsyncWithEffect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextSync", function() { return ContextSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextGen", function() { return ContextGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculationGen", function() { return CalculationGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SynchronousCalculationStarted", function() { return SynchronousCalculationStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculationSync", function() { return CalculationSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runGeneratorSyncWithEffect", function() { return runGeneratorSyncWithEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runGeneratorAsyncWithEffect", function() { return runGeneratorAsyncWithEffect; });
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
var productName = 'gantt';
 //---------------------------------------------------------------------------------------------------------------------

/**
 * Symbol to denote the synchronous calculation context
 */

const ContextSync = Symbol('ContextSync');
/**
 * Symbol to denote the generator calculation context
 */

const ContextGen = Symbol('ContextGen'); //---------------------------------------------------------------------------------------------------------------------

class CalculationGen extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], base => class CalculationGen extends base {
  constructor() {
    super(...arguments);
    this.iterator = undefined;
    this.iterationResult = undefined;
  }

  isCalculationStarted() {
    return Boolean(this.iterator || this.iterationResult);
  }

  isCalculationCompleted() {
    return Boolean(this.iterationResult && this.iterationResult.done);
  }

  get result() {
    return this.iterationResult && this.iterationResult.done ? this.iterationResult.value : undefined;
  }

  startCalculation(onEffect, ...args) {
    const iterator = this.iterator = this.calculation.call(this.context || this, onEffect, ...args);
    return this.iterationResult = iterator.next();
  }

  continueCalculation(value) {
    return this.iterationResult = this.iterator.next(value);
  }

  cleanupCalculation() {
    this.iterationResult = undefined;
    this.iterator = undefined;
  }

  *calculation(onEffect, ...args) {
    throw new Error("Abstract method `calculation` called");
  }

  runSyncWithEffect(onEffect, ...args) {
    this.startCalculation(onEffect, ...args);

    while (!this.isCalculationCompleted()) {
      this.continueCalculation(onEffect(this.iterationResult.value));
    } // help to garbage collector


    this.iterator = undefined;
    return this.result;
  }

  async runAsyncWithEffect(onEffect, ...args) {
    this.startCalculation(onEffect, ...args);

    while (!this.isCalculationCompleted()) {
      this.continueCalculation(await onEffect(this.iterationResult.value));
    } // help to garbage collector


    this.iterator = undefined;
    return this.result;
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

const SynchronousCalculationStarted = Symbol('SynchronousCalculationStarted');
const calculationStartedConstant = {
  value: SynchronousCalculationStarted
};
class CalculationSync extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], base => class CalculationSync extends base {
  constructor() {
    super(...arguments);
    this.iterationResult = undefined;
  }

  isCalculationStarted() {
    return Boolean(this.iterationResult);
  }

  isCalculationCompleted() {
    return Boolean(this.iterationResult && this.iterationResult.done);
  }

  get result() {
    return this.iterationResult && this.iterationResult.done ? this.iterationResult.value : undefined;
  }

  startCalculation(onEffect, ...args) {
    // this assignment allows other code to observe, that calculation has started
    this.iterationResult = calculationStartedConstant;
    return this.iterationResult = {
      done: true,
      value: this.calculation.call(this.context || this, onEffect, ...args)
    };
  }

  continueCalculation(value) {
    throw new Error("Can not continue synchronous calculation");
  }

  cleanupCalculation() {
    this.iterationResult = undefined;
  }

  calculation(onEffect, ...args) {
    throw new Error("Abstract method `calculation` called");
  }

  runSyncWithEffect(onEffect, ...args) {
    this.startCalculation(onEffect, ...args);
    return this.result;
  }

  async runAsyncWithEffect(onEffect, ...args) {
    throw new Error('Can not run synchronous calculation asynchronously');
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

function runGeneratorSyncWithEffect(effect, func, args, scope) {
  const gen = func.apply(scope || null, args);
  let iteration = gen.next();

  while (!iteration.done) {
    iteration = gen.next(effect(iteration.value));
  }

  return iteration.value;
} //---------------------------------------------------------------------------------------------------------------------

async function runGeneratorAsyncWithEffect(effect, func, args, scope) {
  const gen = func.apply(scope || null, args);
  let iteration = gen.next();

  while (!iteration.done) {
    const effectResolution = effect(iteration.value);
    if (effectResolution instanceof Promise) iteration = gen.next(await effectResolution);else iteration = gen.next(effectResolution);
  }

  return iteration.value;
}

/***/ }),

/***/ "./lib/ChronoGraph/replica/Entity.js":
/*!*******************************************!*\
  !*** ./lib/ChronoGraph/replica/Entity.js ***!
  \*******************************************/
/*! exports provided: Entity, createEntityOnPrototype, ensureEntityOnPrototype, generic_field, field, calculate, write, build_proposed */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Entity", function() { return Entity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEntityOnPrototype", function() { return createEntityOnPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ensureEntityOnPrototype", function() { return ensureEntityOnPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generic_field", function() { return generic_field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "field", function() { return field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculate", function() { return calculate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "write", function() { return write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "build_proposed", function() { return build_proposed; });
/* harmony import */ var _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Graph.js */ "./lib/ChronoGraph/chrono/Graph.js");
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../schema/EntityMeta.js */ "./lib/ChronoGraph/schema/EntityMeta.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
var productName = 'gantt';









const isEntityMarker = Symbol('isEntity'); //---------------------------------------------------------------------------------------------------------------------

/**
 * Entity [[Mixin|mixin]]. When applied to some base class (recommended one is [[Base]]), turns it into entity.
 * Entity may have several fields, which are properties decorated with [[field]] decorator.
 *
 * To apply this mixin use the `Entity.mix` property, which represents the mixin lambda.
 *
 * Another decorator, [[calculate]], marks the method, that will be used to calculate the value of field.
 *
 * Example:
 *
 * ```ts
 * class Author extends Entity.mix(Base) {
 *     @field()
 *     firstName       : string
 *     @field()
 *     lastName        : string
 *     @field()
 *     fullName        : string
 *
 *     @calculate('fullName')
 *     calculateFullName () : string {
 *         return this.firstName + ' ' + this.lastName
 *     }
 * }
 * ```
 *
 */

class Entity extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__["Mixin"])([], base => {
  class Entity extends base {
    // marker in the prototype to identify whether the parent class is Entity mixin itself
    // it is not used for `instanceof` purposes and not be confused with the [MixinInstanceOfProperty]
    // (though it is possible to use MixinInstanceOfProperty for this purpose, that would require to
    // make it public
    [isEntityMarker]() {}
    /**
     * An [[EntityMeta]] instance, representing the "meta" information about the entity class. It is shared among all instances
     * of the class.
     */


    get $entity() {
      // this will lazily create an EntityData instance in the prototype
      return createEntityOnPrototype(this.constructor.prototype);
    }
    /**
     * An object, which properties corresponds to the ChronoGraph [[Identifier]]s, created for every field.
     *
     * For example:
     *
     * ```ts
     * class Author extends Entity.mix(Base) {
     *     @field()
     *     firstName       : string
     *     @field()
     *     lastName        : string
     * }
     *
     * const author = Author.new()
     *
     * // identifier for the field `firstName`
     * author.$.firstName
     *
     * const firstName = replica.read(author.$.firstName)
     * ```
     */


    get $() {
      const $ = {};
      this.$entity.forEachField((field, name) => {
        $[name] = this.createFieldIdentifier(field);
      });

      if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__["DEBUG"]) {
        const proxy = new Proxy($, {
          get(entity, property, receiver) {
            if (!entity[property]) Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__["debug"])(new Error(`Attempt to read a missing field ${String(property)} on ${entity}`));
            entity[property].SOURCE_POINT = _environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__["SourceLinePoint"].fromThisCall();
            return entity[property];
          }

        });
        return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["defineProperty"])(this, '$', proxy);
      } else {
        return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["defineProperty"])(this, '$', $);
      }
    }
    /**
     * A graph identifier, that represents the whole entity.
     */


    get $$() {
      return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["defineProperty"])(this, '$$', _Identifier_js__WEBPACK_IMPORTED_MODULE_8__["MinimalEntityIdentifier"].new({
        name: this.$entityName,
        entity: this.$entity,
        calculation: this.calculateSelf,
        context: this,
        self: this
      }));
    }

    get $entityName() {
      return this.constructor.name || this.$entity.name;
    }

    *calculateSelf() {
      return this;
    }

    createFieldIdentifier(field) {
      const name = field.name;
      const entity = this.$entity;
      const constructor = this.constructor;
      const skeleton = entity.$skeleton;
      if (!skeleton[name]) skeleton[name] = constructor.getIdentifierTemplateClass(this, field);
      const identifier = new skeleton[name]();
      identifier.context = this;
      identifier.self = this;
      identifier.name = `${this.$$.name}.$.${field.name}`;
      return identifier;
    }

    forEachFieldIdentifier(func) {
      this.$entity.forEachField((field, name) => func(this.$[name], name));
    }
    /**
     * This method is called when entity is added to some replica.
     *
     * @param replica
     */


    enterGraph(replica) {
      if (this.graph) throw new Error('Already entered replica');
      this.graph = replica;
      replica.addIdentifier(this.$$);
      this.$entity.forEachField((field, name) => {
        const identifier = this.$[name];
        replica.addIdentifier(identifier, identifier.DATA);
        identifier.DATA = undefined;
      });
    }
    /**
     * This method is called when entity is removed from the replica it's been added to.
     */


    leaveGraph(graph) {
      const ownGraph = this.graph;
      const removeFrom = graph || ownGraph;
      if (!removeFrom) return;
      this.$entity.forEachField((field, name) => removeFrom.removeIdentifier(this.$[name]));
      removeFrom.removeIdentifier(this.$$);
      if (removeFrom === ownGraph) this.graph = undefined;
    } // isPropagating () {
    //     return this.getGraph().isPropagating
    // }


    propagate(arg) {
      return this.commit(arg);
    }
    /**
     * This is a convenience method, that just delegates to the [[ChronoGraph.commit]] method of this entity's graph.
     *
     * If there's no graph (entity has not been added to any replica) a [[CommitZero]] constant will be returned.
     */


    commit(arg) {
      const graph = this.graph;
      if (!graph) return _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__["CommitZero"];
      return graph.commit(arg);
    }

    async propagateAsync() {
      return this.commitAsync();
    }
    /**
     * This is a convenience method, that just delegates to the [[ChronoGraph.commitAsync]] method of this entity's graph.
     *
     * If there's no graph (entity has not been added to any replica) a resolved promise with [[CommitZero]] constant will be returned.
     */


    async commitAsync(arg) {
      const graph = this.graph;
      if (!graph) return Promise.resolve(_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__["CommitZero"]);
      return graph.commitAsync(arg);
    }
    /**
     * An [[EntityMeta]] instance, representing the "meta" information about the entity class. It is shared among all instances
     * of the class.
     */


    static get $entity() {
      return ensureEntityOnPrototype(this.prototype);
    }

    static getIdentifierTemplateClass(me, field) {
      const name = field.name;
      const config = {
        name: `${me.$$.name}.$.${name}`,
        field: field
      }; //------------------

      if (field.hasOwnProperty('sync')) config.sync = field.sync;
      if (field.hasOwnProperty('lazy')) config.lazy = field.lazy;
      if (field.hasOwnProperty('equality')) config.equality = field.equality; //------------------

      const calculationFunction = me.$calculations && me[me.$calculations[name]];
      if (calculationFunction) config.calculation = calculationFunction; //------------------

      const writeFunction = me.$writes && me[me.$writes[name]];
      if (writeFunction) config.write = writeFunction; //------------------

      const buildProposedFunction = me.$buildProposed && me[me.$buildProposed[name]];

      if (buildProposedFunction) {
        config.buildProposedValue = buildProposedFunction;
        config.proposedValueIsBuilt = true;
      } //------------------


      const template = field.getIdentifierClass(calculationFunction).new(config);

      const TemplateClass = function () {};

      TemplateClass.prototype = template;
      return TemplateClass;
    } // unfortunately, the better typing:
    // run <Name extends AllowedNames<this, AnyFunction>> (methodName : Name, ...args : Parameters<this[ Name ]>)
    //     : ReturnType<this[ Name ]> extends CalculationIterator<infer Res> ? Res : ReturnType<this[ Name ]>
    // yields "types are exceedingly long and possibly infinite on the application side
    // TODO file a TS bug report


    run(methodName, ...args) {
      const onEffect = effect => {
        if (effect instanceof _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_1__["Identifier"]) return this.graph.read(effect);
        throw new Error("Helper methods can not yield effects during computation");
      };

      return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_4__["runGeneratorSyncWithEffect"])(onEffect, this[methodName], args, this);
    }

    static createPropertyAccessorsFor(fieldName) {
      // idea is to indicate to the v8, that `propertyKey` is a constant and thus
      // it can optimize access by it
      const propertyKey = fieldName;
      const target = this.prototype;
      Object.defineProperty(target, propertyKey, {
        get: function () {
          return this.$[propertyKey].getFromGraph(this.graph);
        },
        set: function (value) {
          this.$[propertyKey].writeToGraph(this.graph, value);
        }
      });
    }

    static createMethodAccessorsFor(fieldName) {
      // idea is to indicate to the v8, that `propertyKey` is a constant and thus
      // it can optimize access by it
      const propertyKey = fieldName;
      const target = this.prototype;
      const getterFnName = `get${Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["uppercaseFirst"])(propertyKey)}`;
      const setterFnName = `set${Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["uppercaseFirst"])(propertyKey)}`;
      const putterFnName = `put${Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["uppercaseFirst"])(propertyKey)}`;

      if (!(getterFnName in target)) {
        target[getterFnName] = function () {
          return this.$[propertyKey].getFromGraph(this.graph);
        };
      }

      if (!(setterFnName in target)) {
        target[setterFnName] = function (value, ...args) {
          this.$[propertyKey].writeToGraph(this.graph, value, ...args);
          return this.graph ? this.graph.autoCommitMode === 'sync' ? this.graph.commit() : this.graph.commitAsync() : Promise.resolve(_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__["CommitZero"]);
        };
      }

      if (!(putterFnName in target)) {
        target[putterFnName] = function (value, ...args) {
          this.$[propertyKey].writeToGraph(this.graph, value, ...args);
        };
      }
    }

  }

  return Entity;
}) {} //---------------------------------------------------------------------------------------------------------------------

const createEntityOnPrototype = proto => {
  let parent = Object.getPrototypeOf(proto); // the `hasOwnProperty` condition will be `true` for the `Entity` mixin itself
  // if the parent is `Entity` mixin, then this is a top-level entity

  return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_7__["defineProperty"])(proto, '$entity', _schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_5__["EntityMeta"].new({
    parentEntity: parent.hasOwnProperty(isEntityMarker) ? null : parent.$entity,
    name: proto.constructor.name
  }));
}; //---------------------------------------------------------------------------------------------------------------------

const ensureEntityOnPrototype = proto => {
  if (!proto.hasOwnProperty('$entity')) createEntityOnPrototype(proto);
  return proto.$entity;
};
/*
 * The "generic" field decorator, in the sense, that it allows specifying both field config and field class.
 * This means it can create any field instance.
 */

const generic_field = (fieldConfig, fieldCls = _schema_Field_js__WEBPACK_IMPORTED_MODULE_6__["Field"]) => {
  return function (target, fieldName) {
    const entity = ensureEntityOnPrototype(target);
    const field = entity.addField(fieldCls.new(Object.assign(fieldConfig || {}, {
      name: fieldName
    })));
    const cons = target.constructor;
    cons.createPropertyAccessorsFor(fieldName);
    cons.createMethodAccessorsFor(fieldName);
  };
}; //---------------------------------------------------------------------------------------------------------------------

/**
 * Field decorator. The type signature is:
 *
 * ```ts
 * field : <T extends typeof Field = typeof Field> (fieldConfig? : Partial<InstanceType<T>>, fieldCls : T | typeof Field = Field) => PropertyDecorator
 * ```
 * Its a function, that accepts field config object and optionally a field class (default is [[Field]]) and returns a property decorator.
 *
 * Example:
 *
 * ```ts
 * const ignoreCaseCompare = (a : string, b : string) : boolean => a.toUpperCase() === b.toUpperCase()
 *
 * class MyField extends Field {}
 *
 * class Author extends Entity.mix(Base) {
 *     @field({ equality : ignoreCaseCompare })
 *     firstName       : string
 *
 *     @field({ lazy : true }, MyField)
 *     lastName       : string
 * }
 * ```
 *
 * For every field, there are generated get and set accessors, with which you can read/write the data:
 *
 * ```ts
 * const author     = Author.new({ firstName : 'Mark' })
 *
 * author.firstName // Mark
 * author.lastName  = 'Twain'
 * ```
 *
 * The getters are basically using [[Replica.get]] and setters [[Replica.write]].
 *
 * Note, that if the identifier is asynchronous, reading from it will return a promise. But, immediately after the [[Replica.commit]] call, getter will return
 * plain value. This is a compromise between the convenience and correctness and this behavior may change (or made configurable) in the future.
 *
 * Additionally to the accessors, the getter and setter methods are generated. The getter method's name is formed as `get` followed by the field name
 * with upper-cased first letter. The setter's name is formed in the same way, with `set` prefix.
 *
 * The getter method is an exact equivalent of the get accessor. The setter method, in addition to data write, immediately after that
 * performs a call to [[Replica.commit]] (or [[Replica.commitAsync]], depending from the [[Replica.autoCommitMode]] option)
 * and return its result.
 *
 * ```ts
 * const author     = Author.new({ firstName : 'Mark' })
 *
 * author.getFirstName() // Mark
 * await author.setLastName('Twain') // issues asynchronous commit
 * ```
 */

const field = generic_field; //---------------------------------------------------------------------------------------------------------------------

/**
 * Decorator for the method, that calculates a value of some field
 *
 * ```ts
 *
 * @entity()
 * class Author extends Entity.mix(Base) {
 *     @field()
 *     firstName       : string
 *     @field()
 *     lastName        : string
 *     @field()
 *     fullName        : string
 *
 *     @calculate('fullName')
 *     calculateFullName () : string {
 *         return this.firstName + ' ' + this.lastName
 *     }
 * }
 * ```
 *
 * @param fieldName The name of the field the decorated method should be "tied" to.
 */

const calculate = function (fieldName) {
  // `target` will be a prototype of the class with Entity mixin
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    let calculations;

    if (!target.$calculations) {
      calculations = target.$calculations = {};
    } else {
      if (!target.hasOwnProperty('$calculations')) {
        calculations = target.$calculations = Object.create(target.$calculations);
      } else calculations = target.$calculations;
    }

    calculations[fieldName] = propertyKey;
  };
}; //---------------------------------------------------------------------------------------------------------------------

const write = function (fieldName) {
  // `target` will be a prototype of the class with Entity mixin
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    let writes;

    if (!target.$writes) {
      writes = target.$writes = {};
    } else {
      if (!target.hasOwnProperty('$writes')) {
        writes = target.$writes = Object.create(target.$writes);
      } else writes = target.$writes;
    }

    writes[fieldName] = propertyKey;
  };
}; //---------------------------------------------------------------------------------------------------------------------

const build_proposed = function (fieldName) {
  // `target` will be a prototype of the class with Entity mixin
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    let buildProposed;

    if (!target.$buildProposed) {
      buildProposed = target.$buildProposed = {};
    } else {
      if (!target.hasOwnProperty('$buildProposed')) {
        buildProposed = target.$buildProposed = Object.create(target.$buildProposed);
      } else buildProposed = target.$buildProposed;
    }

    buildProposed[fieldName] = propertyKey;
  };
};

/***/ }),

/***/ "./lib/ChronoGraph/replica/Identifier.js":
/*!***********************************************!*\
  !*** ./lib/ChronoGraph/replica/Identifier.js ***!
  \***********************************************/
/*! exports provided: FieldIdentifier, MinimalFieldIdentifierSync, MinimalFieldIdentifierGen, MinimalFieldVariable, EntityIdentifier, MinimalEntityIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldIdentifier", function() { return FieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierSync", function() { return MinimalFieldIdentifierSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierGen", function() { return MinimalFieldIdentifierGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldVariable", function() { return MinimalFieldVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityIdentifier", function() { return EntityIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalEntityIdentifier", function() { return MinimalEntityIdentifier; });
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _Replica_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

/**
 * Mixin, for the identifier that represent a field of the entity. Requires the [[Identifier]] (or its subclass)
 * as a base class. See more about mixins: [[Mixin]]
 */

class FieldIdentifier extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Identifier"]], base => class FieldIdentifier extends base {
  constructor() {
    super(...arguments);
    /**
     * Reference to the [[Field]] this identifier represents
     */

    this.field = undefined;
    /**
     * Reference to the [[Entity]] this identifier represents
     */

    this.self = undefined; // temp storage for value for the phase, when identifier is created, but has not joined any graph
    // is cleared during the 1st join to the graph

    this.DATA = undefined;
  } // standaloneQuark     : InstanceType<this[ 'quarkClass' ]>
  // readFromGraphDirtySync (graph : Checkout) {
  //     if (graph)
  //         return graph.readDirty(this)
  //     else
  //         return this.DATA
  // }
  // returns the value itself if there were no affecting writes for it
  // otherwise - promise


  getFromGraph(graph) {
    if (graph) {
      if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_2__["ReadMode"].Current) return graph.get(this);
      if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_2__["ReadMode"].Previous) return graph.activeTransaction.readPrevious(this);
      if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_2__["ReadMode"].ProposedOrPrevious) graph.activeTransaction.readProposedOrPrevious(this);
      return graph.activeTransaction.readCurrentOrProposedOrPrevious(this);
    } else return this.DATA;
  }

  readFromGraph(graph) {
    if (graph) return graph.read(this);else return this.DATA;
  }

  writeToGraph(graph, proposedValue, ...args) {
    if (graph) graph.write(this, proposedValue, ...args);else this.DATA = proposedValue;
  }

  leaveGraph(graph) {
    const entry = graph.activeTransaction.getLatestStableEntryFor(this);
    if (entry) this.DATA = entry.getValue();
    super.leaveGraph(graph);
  }

  toString() {
    return this.name;
  }

}) {}
class MinimalFieldIdentifierSync extends FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["CalculatedValueSync"]) {}
class MinimalFieldIdentifierGen extends FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["CalculatedValueGen"]) {}
class MinimalFieldVariable extends FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Variable"]) {} //---------------------------------------------------------------------------------------------------------------------

/**
 * Mixin, for the identifier that represent an entity as a whole. Requires the [[Identifier]] (or its subclass)
 * as a base class. See more about mixins: [[Mixin]]
 */

class EntityIdentifier extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Identifier"]], base => class EntityIdentifier extends base {
  constructor() {
    super(...arguments);
    /**
     * [[EntityMeta]] instance of the entity this identifier represents
     */

    this.entity = undefined;
    /**
     * Reference to the [[Entity]] this identifier represents
     */

    this.self = undefined;
  } // entity atom is considered changed if any of its incoming atoms has changed
  // this just means if it's calculation method has been called, it should always
  // assign a new value


  equality() {
    return false;
  }

  toString() {
    return `Entity identifier [${this.self}]`;
  }

}) {}
class MinimalEntityIdentifier extends EntityIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["CalculatedValueGen"]) {}

/***/ }),

/***/ "./lib/ChronoGraph/replica/Reference.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/replica/Reference.js ***!
  \**********************************************/
/*! exports provided: ReferenceField, reference, ReferenceIdentifier, MinimalReferenceIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceField", function() { return ReferenceField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reference", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceIdentifier", function() { return ReferenceIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceIdentifier", function() { return MinimalReferenceIdentifier; });
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Entity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






 //---------------------------------------------------------------------------------------------------------------------

/**
 * Mixin, for the identifier that represent a reference field of the entity. Requires the [[Field]] (or its subclass)
 * as a base class. See more about mixins: [[Mixin]]
 */

class ReferenceField extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_schema_Field_js__WEBPACK_IMPORTED_MODULE_2__["Field"]], base => class ReferenceField extends base {
  constructor() {
    super(...arguments);
    this.identifierCls = MinimalReferenceIdentifier;
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

/**
 * Specialized version of the [field](_replica_entity_.html#field) decorator, which should be used to mark the references.
 * All it does is replace the default value of the second argument to the [[ReferenceField]].
 *
 * ```ts
 * class Author extends Person {
 *     @bucket()
 *     books           : Set<Book>
 * }
 *
 * class Book extends Entity.mix(Base) {
 *     @reference({ bucket : 'books' })
 *     writtenBy       : Author
 * }
 * ```
 *
 * @param fieldConfig Object with the configuration properties
 * @param fieldCls Optional. Default value has been changed to [[ReferenceField]]
 */

const reference = (fieldConfig, fieldCls = ReferenceField) => Object(_Entity_js__WEBPACK_IMPORTED_MODULE_4__["generic_field"])(fieldConfig, fieldCls); //---------------------------------------------------------------------------------------------------------------------

class ReferenceIdentifier extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["FieldIdentifier"]], base => {
  class ReferenceIdentifier extends base {
    constructor() {
      super(...arguments);
      this.field = undefined;
      this.proposedValueIsBuilt = true;
    }

    hasBucket() {
      return Boolean(this.field.bucket);
    }

    getBucket(entity) {
      return entity.$[this.field.bucket];
    }

    buildProposedValue(me, quark, transaction) {
      const proposedValue = quark.proposedValue;
      if (proposedValue === null) return null;
      const value = Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["isInstanceOf"])(proposedValue, _Entity_js__WEBPACK_IMPORTED_MODULE_4__["Entity"]) ? proposedValue : me.resolve(proposedValue);

      if (value && me.hasBucket()) {
        me.getBucket(value).addToBucket(transaction, me.self);
      }

      return value;
    }

    resolve(locator) {
      const resolver = this.field.resolver;
      return resolver ? resolver.call(this.self, locator) : null;
    }

    enterGraph(graph) {
      if (this.hasBucket()) {
        const value = graph.activeTransaction.readProposedOrPrevious(this);

        if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_4__["Entity"]) {
          // should probably involve `touchInvalidate` here
          this.getBucket(value).addToBucket(graph.activeTransaction, this.self);
        }
      }

      super.enterGraph(graph);
    }

    leaveGraph(graph) {
      if (this.hasBucket()) {
        // here we only need to remove from the "previous", "stable" bucket, because
        // the calculation for the removed reference won't be called - the possible `proposedValue` of reference will be ignored
        const value = graph.activeTransaction.readProposedOrPrevious(this);

        if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_4__["Entity"]) {
          this.getBucket(value).removeFromBucket(graph.activeTransaction, this.self);
        }
      }

      super.leaveGraph(graph);
    }

    write(me, transaction, q, proposedValue) {
      const quark = q || transaction.acquireQuarkIfExists(me);

      if (me.hasBucket()) {
        if (quark) {
          const prevValue = quark.getValue();

          if (prevValue instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_4__["Entity"]) {
            me.getBucket(prevValue).removeFromBucket(transaction, me.self);
          }
        } else if (transaction.baseRevision.hasIdentifier(me)) {
          const value = transaction.readPrevious(me);

          if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_4__["Entity"]) {
            me.getBucket(value).removeFromBucket(transaction, me.self);
          }
        }
      } // we pass the `q` to super and not `quark`, because we don't do `getWriteTarget` (which increment the epoch)
      // but only `acquireQuarkIfExists` (which does not)


      super.write(me, transaction, q, proposedValue);
    }

  }

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Levels"].DependsOnlyOnUserInput)], ReferenceIdentifier.prototype, "level", void 0);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["QuarkSync"])], ReferenceIdentifier.prototype, "quarkClass", void 0);

  return ReferenceIdentifier;
}) {}
class MinimalReferenceIdentifier extends ReferenceIdentifier.mix(_Identifier_js__WEBPACK_IMPORTED_MODULE_5__["FieldIdentifier"].mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["CalculatedValueSync"])) {}

/***/ }),

/***/ "./lib/ChronoGraph/replica/ReferenceBucket.js":
/*!****************************************************!*\
  !*** ./lib/ChronoGraph/replica/ReferenceBucket.js ***!
  \****************************************************/
/*! exports provided: ReferenceBucketField, bucket, ReferenceBucketQuark, MinimalReferenceBucketQuark, ReferenceBucketIdentifier, MinimalReferenceBucketIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketField", function() { return ReferenceBucketField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bucket", function() { return bucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketQuark", function() { return ReferenceBucketQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketQuark", function() { return MinimalReferenceBucketQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketIdentifier", function() { return ReferenceBucketIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketIdentifier", function() { return MinimalReferenceBucketIdentifier; });
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _chrono_Quark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







 //---------------------------------------------------------------------------------------------------------------------

/**
 * Mixin, for the identifier that represent a reference bucket field of the entity. Requires the [[Field]] (or its subclass)
 * as a base class. See more about mixins: [[Mixin]]
 */

class ReferenceBucketField extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__["Mixin"])([_schema_Field_js__WEBPACK_IMPORTED_MODULE_3__["Field"]], base => class ReferenceBucketField extends base {
  constructor() {
    super(...arguments);
    this.persistent = false;
    this.identifierCls = MinimalReferenceBucketIdentifier; // see comment for `ReferenceBucketIdentifier` declaration
    // identifierCls       : FieldIdentifierConstructor    = ReferenceBucketIdentifier
  }

}) {} //---------------------------------------------------------------------------------------------------------------------

/**
 * Specialized version of the [field](_replica_entity_.html#field) decorator, which should be used to mark the reference buckets.
 * All it does is replace the default value of the second argument to the [[ReferenceBucketField]].
 *
 * ```ts
 * class Author extends Person {
 *     @bucket()
 *     books           : Set<Book>
 * }
 *
 * class Book extends Entity.mix(Base) {
 *     @reference({ bucket : 'books' })
 *     writtenBy       : Author
 * }
 * ```
 *
 * @param fieldConfig Object with the field configuration properties
 * @param fieldCls Optional. Default value has been changed to [[ReferenceBucketField]]
 */

const bucket = (fieldConfig, fieldCls = ReferenceBucketField) => Object(_Entity_js__WEBPACK_IMPORTED_MODULE_5__["generic_field"])(fieldConfig, fieldCls);
var BucketMutationType;

(function (BucketMutationType) {
  BucketMutationType["Add"] = "Add";
  BucketMutationType["Remove"] = "Remove";
})(BucketMutationType || (BucketMutationType = {})); //---------------------------------------------------------------------------------------------------------------------


class ReferenceBucketQuark extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__["Mixin"])([_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_1__["Quark"]], base => class ReferenceBucketQuark extends base {
  constructor() {
    super(...arguments);
    this.mutations = [];
    this.previousValue = undefined;
  }

  hasProposedValueInner() {
    return this.mutations.length > 0;
  }

}) {}
const MinimalReferenceBucketQuark = ReferenceBucketQuark.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["QuarkSync"]); //---------------------------------------------------------------------------------------------------------------------

class ReferenceBucketIdentifier extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_2__["Mixin"])([_Identifier_js__WEBPACK_IMPORTED_MODULE_6__["FieldIdentifier"]], base => {
  // Base class mismatch - should allow subclasses for base class requirements
  // [ FieldIdentifier, CalculatedValueSync ],
  // (base : AnyConstructor<FieldIdentifier & CalculatedValueSync, typeof FieldIdentifier & typeof CalculatedValueSync>) => {
  class ReferenceBucketIdentifier extends base {
    constructor() {
      super(...arguments);
      this.proposedValueIsBuilt = true;
    }

    addToBucket(transaction, entity) {
      const quark = transaction.getWriteTarget(this);
      quark.mutations.push({
        type: BucketMutationType.Add,
        entity
      });
      const baseRevision = transaction.baseRevision;
      if (!quark.previousValue && baseRevision.hasIdentifier(this)) quark.previousValue = transaction.readPrevious(this);
    }

    removeFromBucket(transaction, entity) {
      const preQuark = transaction.entries.get(this); // if bucket is already removed - no need to remove from it

      if (preQuark && preQuark.getValue() === _chrono_Quark_js__WEBPACK_IMPORTED_MODULE_1__["TombStone"]) return;
      const quark = transaction.getWriteTarget(this);
      quark.mutations.push({
        type: BucketMutationType.Remove,
        entity
      });
      const baseRevision = transaction.baseRevision;
      if (!quark.previousValue && baseRevision.hasIdentifier(this)) quark.previousValue = transaction.readPrevious(this);
    }

    buildProposedValue(me, quarkArg, transaction) {
      const quark = quarkArg;
      const newValue = new Set(quark.previousValue);

      for (let i = 0; i < quark.mutations.length; i++) {
        const {
          type,
          entity
        } = quark.mutations[i];

        if (type === BucketMutationType.Remove) {
          newValue.delete(entity);
        } else if (type === BucketMutationType.Add) {
          newValue.add(entity);
        }
      }

      return newValue;
    }

    leaveGraph(graph) {
      super.leaveGraph(graph);
      this.DATA = undefined;
    }

  }

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Levels"].DependsOnlyOnDependsOnlyOnUserInput)], ReferenceBucketIdentifier.prototype, "level", void 0);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["prototypeValue"])(MinimalReferenceBucketQuark)], ReferenceBucketIdentifier.prototype, "quarkClass", void 0);

  return ReferenceBucketIdentifier;
}) {} //---------------------------------------------------------------------------------------------------------------------

class MinimalReferenceBucketIdentifier extends ReferenceBucketIdentifier.mix(_Identifier_js__WEBPACK_IMPORTED_MODULE_6__["FieldIdentifier"].mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["CalculatedValueSync"])) {} // export class MinimalReferenceBucketIdentifier extends ReferenceBucketIdentifier.derive(CalculatedValueSync) {}

/***/ }),

/***/ "./lib/ChronoGraph/replica/Replica.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/replica/Replica.js ***!
  \********************************************/
/*! exports provided: ReadMode, Replica */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadMode", function() { return ReadMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Replica", function() { return Replica; });
/* harmony import */ var _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Graph.js */ "./lib/ChronoGraph/chrono/Graph.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
var productName = 'gantt';


var ReadMode;

(function (ReadMode) {
  ReadMode[ReadMode["Current"] = 0] = "Current";
  ReadMode[ReadMode["Previous"] = 1] = "Previous";
  ReadMode[ReadMode["ProposedOrPrevious"] = 2] = "ProposedOrPrevious";
  ReadMode[ReadMode["CurrentOrProposedOrPrevious"] = 3] = "CurrentOrProposedOrPrevious";
})(ReadMode || (ReadMode = {})); //---------------------------------------------------------------------------------------------------------------------

/**
 * Reactive graph, operating on the set of entities (see [[Entity]] and [[EntityMeta]]), each having a set of fields (see [[Field]]).
 *
 * Entities are mapped to JS classes and fields - to their properties, decorated with [[field]].
 *
 * The calculation function for some field can be mapped to the class method, using the [[calculate]] decorator.
 *
 * An example of usage:
 *
 * ```ts
 * class Author extends Entity.mix(Base) {
 *     @field()
 *     firstName       : string
 *     @field()
 *     lastName        : string
 *     @field()
 *     fullName        : string
 *
 *     @calculate('fullName')
 *     calculateFullName () : string {
 *         return this.firstName + ' ' + this.lastName
 *     }
 * }
 * ```
 */


class Replica extends Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_0__["ChronoGraph"]], base => class Replica extends base {
  constructor() {
    super(...arguments);
    /**
     * Replica re-defines the default value of the `autoCommit` property to `true`.
     */

    this.autoCommit = true;
    this.readMode = ReadMode.Current;
  }
  /**
   * Add entity instance to the replica
   *
   * @param entity
   */


  addEntity(entity) {
    entity.enterGraph(this);
  }
  /**
   * Add several entity instances to the replica
   *
   * @param entity
   */


  addEntities(entities) {
    entities.forEach(entity => this.addEntity(entity));
  }
  /**
   * Remove entity instance from the replica
   *
   * @param entity
   */


  removeEntity(entity) {
    entity.leaveGraph(this);
  }
  /**
   * Remove several entity instances from the replica
   *
   * @param entity
   */


  removeEntities(entities) {
    entities.forEach(entity => this.removeEntity(entity));
  }

}) {}

/***/ }),

/***/ "./lib/ChronoGraph/schema/EntityMeta.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/schema/EntityMeta.js ***!
  \**********************************************/
/*! exports provided: EntityMeta */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityMeta", function() { return EntityMeta; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
var productName = 'gantt';
 //---------------------------------------------------------------------------------------------------------------------

/**
 * This class describes an entity. Entity is simply a collection of [[Field]]s. Entity also may have a parent entity,
 * from which it inherit the fields.
 */

class EntityMeta extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * The name of the entity
     */

    this.name = undefined;
    this.ownFields = new Map();
    this.schema = undefined;
    this.$skeleton = {};
    this.$allFields = undefined;
  }
  /**
   * Checks whether the entity has a field with given name (possibly inherited from parent entity).
   *
   * @param name
   */


  hasField(name) {
    return this.getField(name) !== undefined;
  }
  /**
   * Returns a field with given name (possibly inherited) or `undefined` if there's none.
   *
   * @param name
   */


  getField(name) {
    return this.allFields.get(name);
  }
  /**
   * Adds a field to this entity.
   *
   * @param field
   */


  addField(field) {
    const name = field.name;
    if (!name) throw new Error(`Field must have a name`);
    if (this.ownFields.has(name)) throw new Error(`Field with name [${name}] already exists`);
    field.entity = this;
    this.ownFields.set(name, field);
    return field;
  }

  forEachParent(func) {
    let entity = this;

    while (entity) {
      func(entity);
      entity = entity.parentEntity;
    }
  }

  get allFields() {
    if (this.$allFields !== undefined) return this.$allFields;
    const allFields = new Map();
    const visited = new Set();
    this.forEachParent(entity => {
      entity.ownFields.forEach((field, name) => {
        if (!visited.has(name)) {
          visited.add(name);
          allFields.set(name, field);
        }
      });
    });
    return this.$allFields = allFields;
  }
  /**
   * Iterator for all fields of this entity (including inherited).
   *
   * @param func
   */


  forEachField(func) {
    this.allFields.forEach(func);
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/schema/Field.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/schema/Field.js ***!
  \*****************************************/
/*! exports provided: Field */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

/**
 * This class describes a field of some [[EntityMeta]].
 */

class Field extends _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_0__["Meta"] {
  constructor() {
    super(...arguments);
    /**
     * Boolean flag, indicating whether this field should be persisted
     */

    this.persistent = true;
  }

  getIdentifierClass(calculationFunction) {
    if (this.identifierCls) return this.identifierCls;
    if (!calculationFunction) return _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_1__["MinimalFieldVariable"];
    return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["isGeneratorFunction"])(calculationFunction) ? _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_1__["MinimalFieldIdentifierGen"] : _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_1__["MinimalFieldIdentifierSync"];
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/schema/Schema.js":
/*!******************************************!*\
  !*** ./lib/ChronoGraph/schema/Schema.js ***!
  \******************************************/
/*! exports provided: Schema, entityDecoratorBody, entity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Schema", function() { return Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityDecoratorBody", function() { return entityDecoratorBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entity", function() { return entity; });
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
var productName = 'gantt';

 //---------------------------------------------------------------------------------------------------------------------

/**
 * This class describes a schema. Schemas are not used yet in ChronoGraph.
 *
 * Schema is just a collection of entities ([[EntityMeta]])
 */

class Schema extends _class_Base_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    this.entities = new Map();
  }
  /**
   * Checks whether the schema has an entity with the given name.
   *
   * @param name
   */


  hasEntity(name) {
    return this.entities.has(name);
  }
  /**
   * Returns an entity with the given name or `undefined` if there's no such in this schema
   *
   * @param name
   */


  getEntity(name) {
    return this.entities.get(name);
  }
  /**
   * Adds an entity to the schema.
   * @param entity
   */


  addEntity(entity) {
    const name = entity.name;
    if (!name) throw new Error(`Entity must have a name`);
    if (this.hasEntity(name)) throw new Error(`Entity with name [${String(name)}] already exists`);
    entity.schema = this;
    this.entities.set(name, entity);
    return entity;
  }
  /**
   * Returns a class decorator which can be used to decorate classes as entities.
   */


  getEntityDecorator() {
    // @ts-ignore : https://github.com/Microsoft/TypeScript/issues/29828
    return target => {
      const entity = entityDecoratorBody(target);
      this.addEntity(entity);
      return target;
    };
  }

}
const entityDecoratorBody = target => {
  const name = target.name;
  if (!name) throw new Error(`Can't add entity - the target class has no name`);
  return Object(_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["ensureEntityOnPrototype"])(target.prototype);
};
/**
 * Entity decorator. It is required to be applied only if entity declares no field.
 * If record declares any field, there no strict need to apply this decorator.
 * Its better to do this anyway, for consistency.
 *
 * ```ts
 * @entity()
 * class Author extends Entity.mix(Base) {
 * }
 *
 * @entity()
 * class SpecialAuthor extends Author {
 * }
 * ```
 */

const entity = () => {
  // @ts-ignore : https://github.com/Microsoft/TypeScript/issues/29828
  return target => {
    entityDecoratorBody(target);
    return target;
  };
};

/***/ }),

/***/ "./lib/ChronoGraph/util/Helpers.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/util/Helpers.js ***!
  \*****************************************/
/*! exports provided: MIN_SMI, MAX_SMI, uppercaseFirst, isAtomicValue, typeOf, defineProperty, prototypeValue, copyMapInto, copySetInto, delay, matchAll, allMatches, isGeneratorFunction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_SMI", function() { return MIN_SMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SMI", function() { return MAX_SMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uppercaseFirst", function() { return uppercaseFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAtomicValue", function() { return isAtomicValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeOf", function() { return typeOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineProperty", function() { return defineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prototypeValue", function() { return prototypeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyMapInto", function() { return copyMapInto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copySetInto", function() { return copySetInto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchAll", function() { return matchAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allMatches", function() { return allMatches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGeneratorFunction", function() { return isGeneratorFunction; });
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
var productName = 'gantt'; //---------------------------------------------------------------------------------------------------------------------
// assume 32-bit platform (https://v8.dev/blog/react-cliff)


const MIN_SMI = -Math.pow(2, 30);
const MAX_SMI = Math.pow(2, 30) - 1; //---------------------------------------------------------------------------------------------------------------------

const uppercaseFirst = str => str.slice(0, 1).toUpperCase() + str.slice(1); //---------------------------------------------------------------------------------------------------------------------

const isAtomicValue = value => Object(value) !== value; //---------------------------------------------------------------------------------------------------------------------

const typeOf = value => Object.prototype.toString.call(value).slice(8, -1); //---------------------------------------------------------------------------------------------------------------------

const defineProperty = (target, property, value) => {
  Object.defineProperty(target, property, {
    value,
    enumerable: true,
    configurable: true
  });
  return value;
}; //---------------------------------------------------------------------------------------------------------------------

const prototypeValue = value => {
  return function (target, propertyKey) {
    target[propertyKey] = value;
  };
}; //---------------------------------------------------------------------------------------------------------------------

const copyMapInto = (sourceMap, targetMap) => {
  for (const [key, value] of sourceMap) targetMap.set(key, value);

  return targetMap;
}; //---------------------------------------------------------------------------------------------------------------------

const copySetInto = (sourceSet, targetSet) => {
  for (const value of sourceSet) targetSet.add(value);

  return targetSet;
}; //---------------------------------------------------------------------------------------------------------------------

const delay = timeout => new Promise(resolve => setTimeout(resolve, timeout)); //---------------------------------------------------------------------------------------------------------------------

const matchAll = function* (regexp, testStr) {
  let match;

  while ((match = regexp.exec(testStr)) !== null) {
    yield match;
  }
}; //---------------------------------------------------------------------------------------------------------------------

const allMatches = function (regexp, testStr) {
  return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(matchAll(regexp, testStr)).map(match => Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(match).drop(1)).concat().toArray();
};
let isRegeneratorRuntime = null;
const isGeneratorFunction = function (func) {
  if (isRegeneratorRuntime === null) isRegeneratorRuntime = typeof regeneratorRuntime !== 'undefined';

  if (isRegeneratorRuntime === true) {
    return regeneratorRuntime.isGeneratorFunction(func);
  } else {
    return func.constructor.name === 'GeneratorFunction';
  }
};

/***/ }),

/***/ "./lib/ChronoGraph/util/LeveledQueue.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/util/LeveledQueue.js ***!
  \**********************************************/
/*! exports provided: LeveledQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LeveledQueue", function() { return LeveledQueue; });
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';
 // Leveled LIFO queue

class LeveledQueue {
  constructor() {
    this.length = 0;
    this.levels = [];
    this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"];
  }

  getLowestLevel() {
    for (let i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
      if (this.levels[i]) return this.lowestLevel = i;
    }

    return this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"];
  }

  takeLowestLevel() {
    for (let i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
      const level = this.levels[i];

      if (level) {
        this.length -= level.length;
        this.levels[i] = null;
        this.lowestLevel = i + 1;
        return level;
      }
    }
  } // resetCachedPosition () {
  //     this.lowestLevel               = MAX_SMI
  // }
  // last () {
  //     for (let i = this.lowestLevel !== MAX_SMI ? this.lowestLevel : 0; i < this.levels.length; i++) {
  //         const level     = this.levels[ i ]
  //
  //         if (level && level.length > 0) {
  //             this.lowestLevel   = i
  //
  //             return level[ level.length - 1 ]
  //         }
  //     }
  // }


  pop() {
    for (let i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
      const level = this.levels[i];
      this.lowestLevel = i;

      if (level && level.length > 0) {
        this.length--;
        return level.pop();
      }
    }

    this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_0__["MAX_SMI"];
  }

  push(el) {
    const elLevel = el.level;
    let level = this.levels[elLevel];

    if (!level) {
      // avoid holes in the array
      for (let i = this.levels.length; i < elLevel; i++) this.levels[i] = null;

      level = this.levels[elLevel] = [];
    }

    level.push(el);
    this.length++;
    if (elLevel < this.lowestLevel) this.lowestLevel = elLevel;
  }

  *[Symbol.iterator]() {
    for (let i = 0; i < this.levels.length; i++) {
      const level = this.levels[i];
      if (level) yield* level;
    }
  }

}

/***/ }),

/***/ "./lib/Core/Base.js":
/*!**************************!*\
  !*** ./lib/Core/Base.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Base; });
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Config.js */ "./lib/Core/Config.js");
var productName = 'gantt';
/**
* @module Core/Base
*/







class MetaClass {
  constructor(options) {
    options && Object.assign(this, options);
  }

  getInherited(name, create = true) {
    let ret = this[name]; // We use "in this" to allow the object to be set to null

    if (!(name in this)) {
      var _this$super;

      // If there is no object on this meta class, but there may be one on a super class. If create=false, the
      // idea is that a super class object will be "properly" inherited but otherwise no object will be created.
      ret = (_this$super = this.super) === null || _this$super === void 0 ? void 0 : _this$super.getInherited(name, create);

      if (ret || create) {
        this[name] = ret = Object.create(ret || null);
      }
    }

    return ret;
  }

}

const // Using Object.getPrototypeOf instead of Reflect.getPrototypeOf because:
// 1. The are almost the same, according to the MDN difference is handling getPrototypeOf('string')
// 2. It allows to pass security check in SalesForce environment
{
  getPrototypeOf
} = Object,
      {
  defineProperty
} = Reflect,
      {
  hasOwnProperty
} = Object.prototype,
      metaSymbol = Symbol('classMetaData'),
      mixinTagSymbol = Symbol('mixinTag'),
      originalConfigSymbol = Symbol('originalConfig'),
      createdAtSymbol = Symbol('createdAt'),
      configuringSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.configuring,
      instancePropertiesSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.instanceProperties,
      lazyConfigsSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.lazyConfigs,
      defaultConfigOptions = {
  merge: 'replace',
  simple: true
},
      emptyFn = () => {},
      newMeta = o => new MetaClass(o),
      setupNames = {
  /* foo : 'setupFoo' */
},
      emptyObject = Object.freeze({}),
      emptyArray = Object.freeze([]);
/**
 * Base class for all configurable classes.
 *
 * Subclasses do not have to implement a constructor with its restriction of having to call super()
 * before there is a `this` reference. Subclasses instead implement a `construct` method which is
 * called by the `Base` constructor. This may call its `super` implementation at any time.
 *
 * The `Base` constructor applies all configs to properties of the new instance. The instance
 * will have been configured after the `super.construct(config)` is called.
 *
 * See the Class System documentation in the guides for more information.
 *
 * @abstract
 */


class Base {
  static get isBase() {
    return true;
  }

  get isBase() {
    return true;
  } // defaultConfig & properties made private to not spam all other classes

  /**
   * A class property getter to add additional, special class properties.
   *
   * For example, a class adds a `declarable` class property like so:
   * ```
   *  class Something extends Base {
   *      static get declarable() {
   *          return ['extra'];
   *      }
   *
   *      static setupExtra(cls, meta) {
   *          // use cls.extra
   *      }
   *  }
   * ```
   * A derived class can then specify this property like so:
   * ```
   *  class Derived extends Something {
   *      static get extra() {
   *          // return extra information
   *      }
   *  }
   * ```
   * When the `Derived` class is initialized, the `setupExtra()` method is called and `Derived` is passed as the
   * argument. It is also the `this` pointer, but the parameter is minifiable. The second argument passed is the
   * `$meta` object for the class.
   *
   * Classes are initialized at the first occurrence of the following:
   *
   * - An instance is created
   * - The class `$meta` property is accessed
   *
   * @member {String[]} declarable
   * @static
   * @category Configuration
   * @internal
   */


  static get declarable() {
    return ['declarable',
    /**
     * A class property getter for the configuration properties of the class, which can be overridden by
     * configurations passed at construction time.
     *
     * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
     * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
     * individually and then combine them with those of derived classes.
     *
     * For example, a `Label` might declare a `text` config like so:
     * ```javascript
     *  class Label extends Base {
     *      static get configurable() {
     *          return {
     *              text : null
     *          };
     *      }
     *  }
     * ```
     * The `text` config is automatically inherited by classes derived from Label. By implementing
     * `get configurable()`, derived classes can change the default value of inherited configs, or define new
     * configs, or both.
     *
     * When a config property is declared in this way, the class author can also implement either of two
     * special methods that will be called when the config property is assigned a new value:
     *
     *  - `changeText()`
     *  - `updateText()`
     *
     * In the example above, the `Label` class could implement a `changeText()` method, an `updateText()`
     * method, or both. The generated property setter ensures these methods will be called when the `text`
     * property is assigned.
     *
     * The generated setter (for `text` in this example) performs the following steps:
     *
     *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
     *    `changeText(newText, oldText)`.<br>
     *    Then:
     *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing
     *      further. The assumption is that the changer method has done all that is required.
     *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
     *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
     *    * Update the stored config value in `this._text`.
     *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
     *      `updateText(newText, oldText)`
     *
     * #### Resolving a value from an owner
     * By specifying a value starting with `'up.'` for a config, the config system will resolve that value by
     * examining the ownership hierarchy. It will walk up the hierarchy looking for a property matching the name
     * (or dot separated path) after 'up.'. If one is found, the value will be read and used as the initial
     * value.
     *
     * ```javascript
     * class Parent extends Base {
     *     static get configurable() {
     *         return [
     *           'importantValue'
     *         ]
     *     }
     * }
     *
     * class Child extends Base {
     *     static get configurable() {
     *         return [
     *           'value'
     *         ]
     *     }
     * }
     *
     * const parent = new Parent({
     *     importantValue : 123
     * });
     *
     * const child = new Child({
     *     owner : parent,
     *     // Will be resolved from the owner
     *     value : 'up.importantValue'
     * });
     *
     * console.log(child.value); // logs 123
     * ```
     * Please note that this is for now a one way one time binding, the value will only be read initially and
     * not kept up to date on later changes.
     *
     * #### Value Merging
     * When a config property value is an object, the value declared by the base class is merged with values
     * declared by derived classes and the value passed to the constructor.
     * ```javascript
     *  class Example extends Base {
     *      static get configurable() {
     *          return {
     *              config : {
     *                  foo : 1,
     *                  bar : 2
     *              }
     *          };
     *      }
     *  }
     *
     *  class Example2 extends Example {
     *      static get configurable() {
     *          return {
     *              config : {
     *                  bar : 42,
     *                  zip : 'abc'
     *              }
     *          };
     *      }
     *  }
     *
     *  let ex = new Example2({
     *      config : {
     *          zip : 'xyz'
     *      }
     *  });
     * ```
     * The result of the merge would set `config` to:
     * ```javascript
     *  ex.foo = {
     *      foo : 1,    // from Example
     *      bar : 42,   // from Example2
     *      zip : 'xyz' // from constructor
     *  }
     * ```
     *
     * #### Config Options
     * Some config properties require additional options such as declarative information about the config that
     * may be useful to automate some operation. Consider a `Button`. It could declare that its `text` config
     * affects the rendered HTML by applying a `render` property to the config definition. Its base class could
     * then examine the config definition to find this property.
     *
     * To support this, config options ca be declared like so:
     * ```javascript
     *  class Button extends Widget {
     *      static get configurable() {
     *          return {
     *              text : {
     *                  value   : null,
     *                  $config : {
     *                      render : true
     *                  }
     *              }
     *          };
     *      }
     *  }
     * ```
     * The `$config` property can alternatively be just the names of the options that should be enabled (set
     * to `true`).
     *
     * For example, the following is equivalent to the above:
     * ```javascript
     *  class Button extends Widget {
     *      static get configurable() {
     *          return {
     *              text : {
     *                  value   : null,
     *                  $config : 'render'
     *              }
     *          };
     *  }
     * ```
     *
     * #### Default Value
     * It is common to set a config to a `null` value to take advantage of internal optimizations for `null`
     * values. In most cases the fact that this produces `undefined` as the actual initial value of the config
     * is acceptable. When this is not acceptable, a config can be declared like so:
     * ```javascript
     *  class Widget {
     *      static get configurable() {
     *          return {
     *              disabled : {
     *                  $config : null,
     *                  value   : null,
     *                  default : false
     *              }
     *          };
     *  }
     * ```
     * The `default` property above determines the value of the config while still gaining the benefits of
     * minimal processing due to the `null` value of the `value` property.
     * @member {Object} configurable
     * @static
     * @category Configuration
     * @internal
     */
    'configurable',
    /**
     * A class property getter for the default configuration of the class, which can be overridden by
     * configurations passed at construction time.
     *
     * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
     * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
     * individually and then combine them with those of derived classes.
     *
     * For example, a `Store` might declare its `url` config like so:
     * ```
     *  class Store extends Base {
     *      static get defaultConfig() {
     *          return {
     *              url : null
     *          };
     *      }
     *  }
     * ```
     * The `url` config is automatically inherited by classes derived from Store. By implementing
     * `get defaultConfig()`, derived classes can change the default value of inherited configs, or define new
     * configs, or both. When defining new configs, however, `configurable` is preferred.
     *
     * Config properties introduced to a class by this declaration do not participate in value merging and do
     * not get a generated setter. Config properties introduced by a base class using `configurable` can be
     * set to a different value using `defaultConfig` and in doing so, the values will be merged as appropriate
     * for `configurable`.
     *
     * @member {Object} defaultConfig
     * @static
     * @category Configuration
     * @internal
     */
    'defaultConfig',
    /**
     * A class property getter for the default values of internal properties for this class.
     * @member {Object} properties
     * @static
     * @category Configuration
     * @internal
     */
    'properties',
    /**
     * A class property getter for properties that will be applied to the class prototype.
     * @member {Object} prototypeProperties
     * @static
     * @category Configuration
     * @internal
     */
    'prototypeProperties'];
  }
  /**
   * Base constructor, passes arguments to {@link #function-construct}.
   * @param {...Object} [args] Usually called with a config object, but accepts any params
   * @function constructor
   * @category Lifecycle
   */


  constructor(...args) {
    const me = this,
          C = me.constructor;

    if (me.$meta.class !== C) {
      // This will happen only once for each class. We need to call the C.$meta getter which puts $meta on our
      // prototype. Since that alone would be optimized away (and would generate IDE and lint warnings), we call
      // emptyFn and simply pass the value.
      emptyFn(C.$meta);
    } // Allow subclasses to have a pseudo constructor with "this" already set:


    me.construct(...args);
    me.afterConstruct();
  }
  /**
   * Factory version of the Base constructor. Merges all arguments to create a config object that is passed along to
   * the constructor.
   * @param {...Object} [configs] Allows passing multiple config objects
   * @returns {Core.Base} New instance
   * @private
   */


  static new(...configs) {
    return new this(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge({}, ...configs));
  }
  /**
   * Base implementation applies configuration.
   *
   * Subclasses need only implement this if they have to initialize instance specific
   * properties required by the class. Often a `construct` method is
   * unnecessary. All initialization of incoming configuration properties can be
   * done in a `set propName` implementation.
   * @param {...Object} [args] Usually called with a config object, but accepts any params
   * @category Lifecycle
   */


  construct(...args) {
    // Passing null to base construct means bypass the config system and stack creation (to gain performance)
    if (args[0] !== null) {
      this.configure(...args);
    }

    this.afterConfigure();
  }
  /**
   * Destroys the provided objects by calling their {@link #function-destroy} method.
   * Skips empty values or objects that are already destroyed.
   *
   * ```javascript
   * Base.destroy(myButton, toolbar1, helloWorldMessageBox);
   * ```
   * @param {...Object} [args] Objects to be destroyed
   * @category Lifecycle
   */


  static destroy(...args) {
    const shredder = object => {
      if (object !== null && object !== void 0 && object.destroy) {
        object.destroy();
      } else if (Array.isArray(object)) {
        object.forEach(shredder);
      }
    };

    shredder(args);
  }
  /**
   * Destroys this object. This is primarily accomplished by calling {@link #function-doDestroy}, however, prior to
   * calling `doDestroy`, {@link #property-isDestroying} is set to `true`. After {@link #function-doDestroy} returns,
   * {@link #property-isDestroyed} is set to `true`.
   *
   * Do not override this method in subclasses. To provide class-specific cleanup, implement {@link #function-doDestroy}
   * instead.
   * @category Lifecycle
   */


  destroy() {
    const me = this,
          {
      id
    } = me; // Let everyone know the object is going inert:

    me.isDestroying = true; // Make calling destroy() harmless:

    me.destroy = emptyFn;
    me.doDestroy();
    Object.setPrototypeOf(me, null); // Clear all remaining instance properties.

    for (const key in me) {
      if (key !== 'destroy' && key !== 'isDestroying') {
        delete me[key];
      }
    }

    delete me[originalConfigSymbol]; // Let everyone know the object is inert:

    me.isDestroyed = true;
    me.id = id; // for diagnostic reasons
  }
  /**
   * This method is required to help `unused` getters to survive production build process. Some tools, like angular,
   * will remove `unused` code in production build, making our side-effected getters behind, breaking code heavily.
   * @internal
   * @param getter Getter to evaluate
   */


  _thisIsAUsedExpression(getter) {}

  static get $$name() {
    return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
    hasOwnProperty.call(this, '_$name') && this._$name || this.name;
  }

  get $$name() {
    return this.constructor.$$name;
  }
  /**
   * Base implementation so that all subclasses and mixins may safely call super.startConfigure.
   *
   * This is called by the Base class before setting configuration properties, but after
   * the active initial getters have been set, so all configurations are available.
   *
   * This method allows all classes in the hierarchy to force some configs to be evaluated before others.
   * @internal
   * @category Lifecycle
   * @params {Object} config The configuration object use to set the initial state.
   */


  startConfigure(config) {}
  /**
   * Base implementation so that all subclasses and mixins may safely call super.finishConfigure.
   *
   * This is called by the Base class before exiting the {@link #function-configure} method.
   *
   * At this point, all configs have been applied, but the `isConfiguring` property is still set.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * into the config phase.
   * @internal
   * @category Lifecycle
   * @params {Object} config The configuration object use to set the initial state.
   */


  finishConfigure(config) {}
  /**
   * Base implementation so that all subclasses and mixins may safely call `super.afterConfigure`. This is called by the Base class after the {@link #function-configure} method has been
   * called. At this point, all configs have been applied.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * either before or after the super.afterConstruct();
   * @internal
   * @category Lifecycle
   */


  afterConfigure() {}
  /**
   * Base implementation so that all subclasses and mixins may safely call super.afterConstruct.
   *
   * This is called by the Base class after the {@link #function-construct} method has been
   * called.
   *
   * At this point, all configs have been applied.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * either before or after the super.afterConstruct();
   * @internal
   * @function afterConstructor
   * @category Lifecycle
   */


  afterConstruct() {}
  /**
   * Provides a way of calling callbacks which may have been specified as the _name_ of a function
   * and optionally adds scope resolution.
   *
   * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
   * then the function is resolved in this object. This is useful when configuring listeners
   * at the class level.
   *
   * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
   * using the `owner` property until an object with the named function is present, then the
   * named function is called upon that object.
   *
   * If a named function is not found, an error is thrown. If the function should be only called when present,
   * and may not be present, add a `?` as a suffix.
   *
   * @param {String|Function} fn The function to call, or the name of the function to call.
   * @param {Object} thisObject The `this` object of the function.
   * @param {Object[]} args The argument list to pass.
   * @category Misc
   */


  callback(fn, thisObject, args = emptyArray) {
    // Maintainer: do not make args ...args. This method may acquire more arguments
    const {
      handler,
      thisObj
    } = this.resolveCallback(fn, thisObject === 'this' ? this : thisObject) || emptyObject;
    return handler === null || handler === void 0 ? void 0 : handler.apply(thisObj, args);
  }

  resolveProperty(propertyPath) {
    let thisObj = this;

    while (thisObj) {
      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasPath(thisObj, propertyPath)) {
        return _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getPath(thisObj, propertyPath);
      }

      thisObj = thisObj.owner;
    }

    return undefined;
  }
  /**
   * Provides a way of locating callbacks which may have been specified as the _name_ of a function
   * and optionally adds scope resolution.
   *
   * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
   * then the function is resolved in this object. This is useful when configuring listeners
   * at the class level.
   *
   * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
   * using the `owner` property until an object with the named function is present, then the
   * named function is called upon that object.
   * @param {String|Function} handler The function to call, or the name of the function to call.
   * @param {Object} thisObj The `this` object of the function.
   * @param {Boolean} [enforceCallability = true] Pass `false` if the function may not exist, and a null return value is acceptable.
   * @returns {Object} `{ handler, thisObj }`
   * @category Misc
   */


  resolveCallback(handler, thisObj = this, enforceCallability = true) {
    // It's a string, we find it in its own thisObj
    if (handler.substring) {
      if (handler.endsWith('?')) {
        enforceCallability = false;
        handler = handler.substring(0, handler.length - 1);
      }

      if (handler.startsWith('up.')) {
        handler = handler.substring(3); // Empty loop until we find the function owner

        for (thisObj = this.owner; thisObj && !thisObj[handler]; thisObj = thisObj.owner);

        if (!thisObj) {
          return;
        }
      } else if (handler.startsWith('this.')) {
        handler = handler.substring(5);
        thisObj = this;
      }

      if (!thisObj || !(thisObj instanceof Object)) {
        return;
      }

      if (typeof thisObj[handler] !== 'function') {
        return;
      }

      handler = thisObj[handler];
    }

    return {
      handler,
      thisObj
    };
  }

  bindCallback(inHandler, inThisObj = this) {
    if (inHandler) {
      const {
        handler,
        thisObj
      } = this.resolveCallback(inHandler, inThisObj);

      if (handler) {
        return handler.bind(thisObj);
      }
    }
  }
  /**
   * Delays the execution of the passed function by the passed time quantum, or if the time is omitted
   * or not a number, delays until the next animation frame. Note that this will use
   * {@link Core.mixin.Delayable#function-setTimeout} || {@link Core.mixin.Delayable#function-requestAnimationFrame}
   * if this class mixes in `Delayable`, otherwise it uses the global methods. The function will
   * be called using `this` object as its execution scope.
   * @param {Function} fn The function to call on a delay.
   * @param {Number} [by] The number of milliseconds to delay.
   * @private
   */


  delay(fn, by) {
    // Force scope on the fn if we are not a Delayable
    fn = this.setTimeout ? fn : fn.bind(this);
    const invoker = this.setTimeout ? this : _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global;
    invoker[typeof by === 'number' ? 'setTimeout' : 'requestAnimationFrame'](fn, by);
  }
  /**
   * Classes implement this method to provide custom cleanup logic before calling `super.doDestroy()`. The general
   * pattern is as follows:
   *
   * ```javascript
   *  class Foo extends Base {
   *      doDestroy() {
   *          // perform custom cleanup
   *
   *          super.doDestroy();
   *      }
   *  }
   * ```
   *
   * This method is called by {@link #function-destroy} which also prevents multiple calls from reaching `doDestroy`.
   * Prior to calling `doDestroy`, {@link #property-isDestroying} is set to `true`. Upon return, the object is fully
   * destructed and {@link #property-isDestroyed} is set to `true`.
   *
   * Do not call this method directly. Instead call {@link #function-destroy}.
   * @category Lifecycle
   */


  doDestroy() {
    const me = this,
          {
      nullify
    } = me.$meta;

    if (nullify) {
      for (let i = 0; i < nullify.length; ++i) {
        if (me[nullify[i].field] != null) {
          // if backing property is null/undefined then skip
          me[nullify[i].name] = null; // else, call setter to run through change/update
        }
      }
    }
  }
  /**
   * Destroys the named properties if they have been initialized, and if they have a `destroy` method.
   * Deletes the property from this object. For example:
   *
   *      this.destroyProperties('store', 'resourceStore', 'eventStore', 'dependencyStore', 'assignmentStore');
   *
   * @param {String} properties The names of the properties to destroy.
   * @internal
   * @category Lifecycle
   */


  destroyProperties(...properties) {
    const me = this;
    let key, propertyValue;

    for (key of properties) {
      // If the value has *not* been pulled in from the configuration object yet
      // we must not try to access it, as that will cause the property to be initialized.
      if (key in me && (!me[configuringSymbol] || !me[configuringSymbol][key])) {
        propertyValue = me[key];

        if (propertyValue && propertyValue.destroy) {
          propertyValue.destroy();
        }

        delete me[key];
      }
    }
  }
  /**
   * Called by the Base constructor to apply configs to this instance. This must not be called.
   * @param {Object} config The configuration object from which instance properties are initialized.
   * @private
   * @category Lifecycle
   */


  configure(config = {}) {
    const me = this,
          {
      beforeConfigure
    } = config,
          configs = me.$meta.configs,
          fullConfig = me.getDefaultConfiguration();
    let cfg, key, value;
    me.initialConfig = config; // Important flag for setters to know whether they are being called during
    // configuration when this object is not fully alive, or whether it's being reconfigured.

    me.isConfiguring = true; // Assign any instance properties declared by the class.

    Object.assign(me, me.getProperties()); // Apply configuration to default from class definition. This is safe because it's either chained from or a
    // fork of the class values.

    for (key in config) {
      value = config[key];
      cfg = configs[key];
      fullConfig[key] = cfg ? cfg.merge(value, fullConfig[key], null) : value;
    }

    if (beforeConfigure) {
      delete fullConfig.beforeConfigure; // noinspection JSValidateTypes

      beforeConfigure(me, fullConfig);
    } // Cache me.config for use by get config.


    me.setConfig(me[originalConfigSymbol] = fullConfig, true);
    me.isConfiguring = false;
  }
  /**
   * Returns the value of the specified config property. This is a method to allow
   * property getters to be explicitly called in a way that does not get optimized out.
   *
   * The following triggers the getter call, but optimizers will remove it:
   *
   *      inst.foo;   // also raises "expression has no side-effects" warning
   *
   * Instead, do the following to trigger a getter:
   *
   *      inst.getConfig('foo');
   *
   * @param {String} name
   * @internal
   * @category Configuration
   */


  getConfig(name) {
    return this[name];
  }
  /**
   * Sets configuration options this object with all the properties passed in the parameter object.
   * Timing is taken care of. If the setter of one config is called first, and references
   * the value of another config which has not yet been set, that config will be set just
   * in time, and the *new* value will be used.
   * @param {Object} config An object containing configurations to change.
   * @category Lifecycle
   */


  setConfig(config, isConstructing) {
    const me = this,
          wasConfiguring = me[configuringSymbol],
          configDone = wasConfiguring ? me.configDone : me.configDone = {},
          configs = me.$meta.configs;
    let cfg, key;
    me[instancePropertiesSymbol] = {}; // Cache configuration for use by injected property initializers.

    me[configuringSymbol] = wasConfiguring ? Object.setPrototypeOf(Object.assign({}, config), wasConfiguring) : config; // For each incoming non-null configuration, create a temporary getter which will
    // pull the value in from the initialConfig so that it doesn't matter in
    // which order properties are set. You can access any property at any time.

    for (key in config) {
      // Don't default null configs in unless it's a direct property of the
      // the passed configuration. When used at construct time, defaultConfigs
      // will be prototype-chained onto the config.
      if (config[key] != null || hasOwnProperty.call(config, key)) {
        cfg = configs[key] || _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(key);
        cfg.defineInitter(me, config[key]);

        if (!isConstructing) {
          configDone[key] = false;
        } else if (cfg.lazy) {
          configDone[key] = true;
        }
      } else {
        configDone[key] = true;
      }
    }

    if (isConstructing) {
      me.startConfigure(config);
    } // Set all our properties from the config object.
    // If one of the properties needs to access a property that has not
    // yet been set, the above temporary property will pull it through.
    // Can't use Object.assign because that only uses own properties.
    // config value blocks are prototype chained subclass->superclass


    for (key in config) {
      // Only push the value through if the property initializer is still present.
      // If it gets triggered to pull the configuration value in, it deleted itself.
      if (!configDone[key]) {
        me[key] = config[key];
      }
    }

    if (wasConfiguring) {
      me[configuringSymbol] = wasConfiguring;
    } else {
      delete me[configuringSymbol];
    }

    if (isConstructing) {
      me.finishConfigure(config);
    }

    return me;
  }
  /**
   * Returns `true` if this instance has a non-null value for the specified config. This will not activate a lazy
   * config.
   *
   * @param {String} name The name of the config property.
   * @returns {Boolean}
   * @internal
   */


  hasConfig(name) {
    const me = this,
          lazyConfig = me[lazyConfigsSymbol],
          config = me[configuringSymbol],
          hasValue = me['_' + name] != null,
          hasLazyValue = (lazyConfig === null || lazyConfig === void 0 ? void 0 : lazyConfig[name]) != null,
          hasConfigValue = Boolean(!me.configDone[name] && config && (config[name] != null || hasOwnProperty.call(config, name)));
    return hasValue || hasLazyValue || hasConfigValue;
  }
  /**
   * Ensures that the specified config is initialized if it is needed. If there is a config value specified, and it
   * was initialized by this call, this method returns `true`. If there was a config value specified, and it was
   * already initialized, this method returns `false`. If there was no value specified for the given config, this
   * method returns `null`.
   *
   * This is different than just reading the property because some property getters exist that do not actually just
   * read the config value back, but instead produce some result. Reading such properties to incidentally trigger a
   * possible config initializer can lead to incorrect results. For example, the Combo items config.
   *
   * @param {String} name The name of the config property.
   * @returns {Boolean}
   * @internal
   */


  triggerConfig(name) {
    const {
      configDone
    } = this,
          config = this[configuringSymbol],
          triggered = config && (config[name] != null || hasOwnProperty.call(config, name)) ? !configDone[name] : null;

    if (triggered) {
      this.getConfig(name);
    }

    return triggered;
  }

  onConfigChange() {} // declared above because lint/IDE get angry about not declaring the args...

  /**
   * This method is called when any config changes.
   * @param {Object} info Object containing information regarding the config change.
   * @param {String} info.name The name of the config that changed.
   * @param {*} info.value The new value of the config.
   * @param {*} info.was The previous value of the config.
   * @param {Core.Config} info.config The `Config` object for the changed config property.
   * @method onConfigChange
   * @internal
   * @category Configuration
   */

  /**
   * Returns a *copy* of the full configuration which was used to configure this object.
   * @property {Object}
   * @category Lifecycle
   * @readonly
   */


  get config() {
    const result = {},
          myConfig = this[originalConfigSymbol]; // The configuration was created as a prototype chain of the class hierarchy's
    // defaultConfig values hanging off a copy of the initialConfig object, so
    // we must loop and copy since Object.assign only copies own properties.

    for (const key in myConfig) {
      result[key] = myConfig[key];
    }

    return result;
  }
  /**
   * Registers this class type with its Factory
   */


  static initClass() {
    return this.$meta.class;
  }
  /**
   * The class's {@link #property-$meta-static meta} object.
   * @member {Object} $meta
   * @internal
   * @category Misc
   */

  /**
   * An object owned by this class that does not share properties with its super class.
   *
   * This object may contain other properties which are added as needed and are not documented here.
   *
   * @property {Object} $meta The class meta object.
   * @property {Function} $meta.class The class constructor that owns the meta object.
   * @property {Object} $meta.super The `$meta` object for the super class. This is `null` for `Base`.
   * @property {Object} $meta.config The object holding the default configuration values for this class.
   * @property {Object} $meta.configs An object keyed by config name that holds the defined configs for the class.
   * The value of each property is a {@link Core/Config} instance.
   * @property {Boolean} $meta.forkConfigs This will be `true` if the default configuration values for this class
   * (in the `config` property of the meta object) must be forked to avoid object sharing, or if the object can be
   * passed to `Object.create()` for efficiency.
   * @property {Function[]} $meta.hierarchy The array of classes in the ancestry of this class. This will start with
   * `Base` at index 0 and ends with this class.
   * @property {Function[]} $meta.properties The array of classes that define a "static get properties()" getter.
   * @internal
   * @static
   * @category Misc
   */


  static get $meta() {
    const me = this;
    let meta = me[metaSymbol];

    if (!hasOwnProperty.call(me, metaSymbol)) {
      me[metaSymbol] = meta = newMeta();
      meta.class = me;
      me.setupClass(meta);
    }

    return meta;
  }
  /**
   * This optional class method is called when a class is mixed in using the {@link #function-mixin-static mixin()}
   * method.
   * @internal
   */


  static onClassMixedIn() {// empty
  }
  /**
   * Returns the merge of the `baseConfig` and `config` config objects based on the configs defined by this class.
   * @param {Object} baseConfig The base config or defaults.
   * @param {...Object} configs One or more config objects that takes priority over `baseConfig`.
   * @returns {Object}
   * @internal
   */


  static mergeConfigs(baseConfig, ...configs) {
    const classConfigs = this.$meta.configs,
          result = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(baseConfig) || {};
    let config, i, key, value;

    for (i = 0; i < configs.length; ++i) {
      config = configs[i];

      if (config) {
        for (key in config) {
          value = config[key];

          if (classConfigs[key]) {
            value = classConfigs[key].merge(value, result[key]);
          } else if (result[key] && value) {
            value = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(value, result[key]);
          }

          result[key] = value;
        }
      }
    }

    return result;
  }
  /**
   * Applies one or more `mixins` to this class and returns the produced class constructor.
   *
   * For example, instead of writing this:
   * ```
   *  class A extends Delayable(Events(Localizable(Base))) {
   *      // ...
   *  }
   * ```
   *
   * Using this method, one would write this:
   * ```
   *  class A extends Base.mixin(Localizable, Events, Delayable) {
   *      // ...
   *  }
   * ```
   * If one of the mixins specified has already been mixed into the class, it will be ignored and not mixed in a
   * second time.
   * @param {...Function} mixins
   * @returns {Function}
   */


  static mixin(...mixins) {
    // Starting w/the first class C = this
    let C = this,
        i; // wrap each class C using mixins[i] to produce the next class

    for (i = 0; i < mixins.length; ++i) {
      const mixin = mixins[i],
            // Grab or create a unique Symbol for this mixin so we can tell if we've already mixed it in
      tag = mixin[mixinTagSymbol] || (mixin[mixinTagSymbol] = Symbol('mixinTag'));

      if (C[tag]) {
        continue;
      }

      C = mixin(C);
      C[tag] = true; // properties on the constructor are inherited to subclass constructors...

      if (hasOwnProperty.call(C, 'onClassMixedIn')) {
        C.onClassMixedIn();
      }
    }

    return C;
  }
  /**
   * This method is called only once for any class. This can occur when the first instance is created or when the
   * `$meta` object is first requested.
   * @param {Object} meta The `$meta` object for the class.
   * @internal
   * @category Misc
   */


  static setupClass(meta) {
    var _base$nullify;

    const cls = meta.class,
          // Trigger setupClass on the super class (if it has yet to happen):
    base = getPrototypeOf(cls).$meta,
          name = cls.$$name,
          names = base.names,
          proto = cls.prototype;
    defineProperty(proto, '$meta', {
      value: meta
    });
    Object.assign(meta, {
      super: base,
      config: Object.create(base.config),
      configs: Object.create(base.configs),
      declarables: base.declarables,
      forkConfigs: base.forkConfigs,
      hierarchy: Object.freeze([...base.hierarchy, cls]),
      names: names.includes(name) ? names : Object.freeze([...names, name]),
      properties: base.properties,
      nullify: (_base$nullify = base.nullify) === null || _base$nullify === void 0 ? void 0 : _base$nullify.slice()
    });

    if (names !== meta.names) {
      const is = 'is' + name;

      if (!hasOwnProperty.call(proto, is)) {
        defineProperty(proto, is, {
          value: true
        });
      }

      if (!hasOwnProperty.call(cls, is)) {
        defineProperty(cls, is, {
          value: true
        });
      }
    } // NOTE: we always use meta.declarables because setupDeclarable() can replace the array on the meta object
    // when new declarable properties are added...


    for (let decl, setupName, i = 0; i < meta.declarables.length; ++i) {
      decl = meta.declarables[i];

      if (hasOwnProperty.call(cls, decl)) {
        setupName = setupNames[decl] || (setupNames[decl] = `setup${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(decl)}`);
        cls[setupName](cls, meta);
      }
    }
    /*  Add slash to the front of this line to enable the diagnostic block:
    /**/

  }
  /**
   * This method is called as part of `setupClass()`. It will process the `configurable()` return object and the
   * `defaultConfig` return object.
   * @param {Object} meta The `meta` object for this class.
   * @param {Object} configs The config definition object.
   * @param {Boolean} simple `true` when processing `defaultConfig` and `false` when processing `configurable`.
   * @private
   * @category Configuration
   */


  static setupConfigs(meta, configs, simple) {
    const classConfigValues = meta.config,
          classConfigs = meta.configs,
          cls = meta.class;
    let {
      nullify
    } = meta,
        cfg,
        defaultValue,
        options,
        setDefault,
        value,
        wasNullify;

    for (const name in configs) {
      value = configs[name];

      if (simple) {
        // Using "defaultConfig"
        if (!(cfg = classConfigs[name])) {
          cfg = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(name, defaultConfigOptions);
        } else {
          // The property may be declared in a base class using configurable(), so it may have special
          // merge processing:
          value = cfg.merge(value, classConfigValues[name], meta);
        }
        /*  Add slash to the front of this line to enable the diagnostic block:
        /**/

      } else {
        // Using "configurable"
        defaultValue = options = setDefault = undefined;

        if (value && typeof value === 'object' && '$config' in value) {
          options = value.$config;

          if (options && !_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(options)) {
            options = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].createTruthyKeys(options);
          }

          setDefault = 'default' in value;
          defaultValue = setDefault ? value.default : defaultValue;
          value = value.value;
        }

        if (!(cfg = classConfigs[name])) {
          cfg = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(name, options);
          cfg.define(cls.prototype);
          setDefault = !(cfg.field in cls.prototype); // reduce object shape changes (helps JIT)

          wasNullify = false;
        } else {
          wasNullify = cfg.nullify;

          if (options) {
            // Defined by a base class, but maybe being adjusted by derived.
            cfg = cfg.extend(options); // In the future, we may need to redefine the property here if options affect the descriptor (such
            // as event firing)
          }

          value = cfg.merge(value, classConfigValues[name], meta);
        }

        if (setDefault) {
          cfg.setDefault(cls, defaultValue);
        }

        if (cfg.nullify && !wasNullify) {
          (nullify || (nullify = meta.nullify || (meta.nullify = []))).push(cfg);
        }
      } // If any default properties are *mutable* Objects or Array we need to clone them.
      // so that instances do not share configured values.


      if (value && (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(value) || Array.isArray(value)) && !Object.isFrozen(value)) {
        meta.forkConfigs = true;
      }

      classConfigs[name] = cfg;
      classConfigValues[name] = value;
    }
  }

  static setupConfigurable(cls, meta) {
    cls.setupConfigs(meta, cls.configurable, false);
  }

  static setupDefaultConfig(cls, meta) {
    cls.setupConfigs(meta, cls.defaultConfig, true);
  }

  static setupDeclarable(cls, meta) {
    const declarable = cls.declarable;
    let all = meta.declarables,
        forked,
        i;

    for (i = 0; i < declarable.length; ++i) {
      if (!all.includes(declarable[i])) {
        if (!forked) {
          meta.declarables = forked = all = all.slice();
        }

        all.push(declarable[i]);
      }
    }
  }

  static setupProperties(cls, meta) {
    meta.properties = meta.super.properties.slice();
    meta.properties.push(cls);
    Object.freeze(meta.properties);
  }

  static setupPrototypeProperties(cls) {
    Object.assign(cls.prototype, cls.prototypeProperties);
  }
  /**
   * Gets the full {@link #property-defaultConfig-static} block for this object's entire inheritance chain
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  getDefaultConfiguration() {
    return this.constructor.getDefaultConfiguration();
  }
  /**
   * Gets the full {@link #property-defaultConfig-static} block for the entire inheritance chain for this class
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  static getDefaultConfiguration() {
    const meta = this.$meta,
          config = meta.forkConfigs ? Base.fork(meta.config) : Object.create(meta.config);

    if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTestEnv && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv && config.testConfig && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global.__applyTestConfigs) {
      for (const o in config.testConfig) {
        config[o] = config.testConfig[o];
      }
    }

    return config;
  }

  static fork(obj) {
    let ret = obj,
        key,
        value;

    if (obj && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj) && !Object.isFrozen(obj)) {
      ret = Object.create(obj);

      for (key in obj) {
        value = obj[key];

        if (value) {
          if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(value)) {
            ret[key] = Base.fork(value);
          } else if (Array.isArray(value)) {
            ret[key] = value.slice();
          }
        }
      }
    }

    return ret;
  }
  /**
   * Gets the full {@link #property-properties-static} block for this class's entire inheritance chain
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  getProperties() {
    const // The meta.properties array is an array of classes that define "static get properties()"
    hierarchy = this.$meta.properties,
          result = {}; // TODO: if properties block does not change this could be cached? would speed up loading of big data sets
    //  into grid. The problem is that this call creates new (i.e., non-shared) instances of objects, arrays and
    //  Map objects that apply to each instance. These would all need to be cloned so it may be better to just
    //  call the properties getter each time and let it create new instances of whatever types.
    //for (cls of hierarchy) { // for-of transpiles badly and this is called a lot

    for (let i = 0; i < hierarchy.length; i++) {
      // Gather the class result in top-down order so that subclass properties override superclass properties
      Object.assign(result, hierarchy[i].properties);
    }

    return result;
  }

  static get superclass() {
    return getPrototypeOf(this);
  }
  /**
   * Used by the Widget and GridFeatureManager class internally. Returns the class hierarchy of this object
   * starting from the `topClass` class (which defaults to `Base`).
   *
   * For example `classHierarchy(Widget)` on a Combo would yield `[Widget, Field, TextField, PickerField, Combo]`
   * @param {Function} [topClass] The topmost class constructor to start from.
   * @returns {Function[]} The class hierarchy of this instance.
   * @private
   * @category Configuration
   */


  classHierarchy(topClass) {
    const hierarchy = this.$meta.hierarchy,
          index = topClass ? hierarchy.indexOf(topClass) : 0;
    return index > 0 ? hierarchy.slice(index) : hierarchy;
  }
  /**
   * Checks if an obj is of type using object's $$name property and doing string comparison of the property with the
   * type parameter.
   *
   * @param {String} type
   * @return {Boolean}
   */


  static isOfTypeName(type) {
    return this.$meta.names.includes(type);
  }
  /**
   * Removes all event listeners that were registered with the given `name`.
   * @param {String} name The name of the event listeners to be removed.
   * @category Events
   */


  detachListeners(name) {
    var _detachers;

    let detachers = this.$detachers;
    detachers = (_detachers = detachers) === null || _detachers === void 0 ? void 0 : _detachers[name];

    if (detachers) {
      while (detachers.length) {
        detachers.pop()();
      }
    }
  }
  /**
   * Tracks a detacher function for the specified listener name.
   * @param {String} name The name assigned to the associated listeners.
   * @param {Function} detacher The detacher function.
   * @private
   */


  trackDetacher(name, detacher) {
    const detachers = this.$detachers || (this.$detachers = {}),
          bucket = detachers[name] || (detachers[name] = []);
    bucket.push(detacher);
  }
  /**
   * Removes all detacher functions for the specified `Events` object. This is called
   * by the `removeAllListeners` method on that object which is typically called by its
   * `destroy` invocation.
   * @param {Core.mixin.Events} eventer The `Events` instance to untrack.
   * @private
   */


  untrackDetachers(eventer) {
    const detachers = this.$detachers;

    if (detachers) {
      for (const name in detachers) {
        const bucket = detachers[name];

        for (let i = bucket.length; i-- > 0;) {
          if (bucket[i].eventer === eventer) {
            bucket.splice(i, 1);
          }
        }
      }
    }
  }

}
const proto = Base.prototype; // Informs the standard config setter there is no need to call this fn:

proto.onConfigChange.$nullFn = true;
Base[metaSymbol] = proto.$meta = newMeta({
  class: Base,
  config: Object.freeze({}),
  configs: Object.create(null),
  declarables: Base.declarable,
  forkConfigs: false,
  hierarchy: Object.freeze([Base]),
  names: Object.freeze(['Base']),
  nullify: null,
  properties: Object.freeze([]),
  super: null
}); // Avoid some object shape changes:

Object.assign(proto, {
  $detachers: null,
  configObserver: null,

  /**
   * This property is set to `true` by {@link #function-destroy} after the {@link #function-doDestroy} method returns.
   * It is also one of the few properties that remains on the object after returning from `destroy()`. This property
   * is often checked in code paths that may encounter a destroyed object (like some event handlers) or in the
   * destruction path during cleanup.
   * @member {Boolean}
   * @readonly
   * @category Lifecycle
   */
  isDestroyed: false,

  /**
   * This property is set to `true` on entry to the {@link #function-destroy} method. It remains on the objects after
   * returning from `destroy()`. If {@link #property-isDestroyed} is `true`, this property will also be `true`, so
   * there is no need to test for both (for example, `comp.isDestroying || comp.isDestroyed`).
   * @member {Boolean}
   * @readonly
   * @category Lifecycle
   */
  isDestroying: false
});
_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setVersion('core', '4.3.6');
Base._$name = 'Base';

/***/ }),

/***/ "./lib/Core/Config.js":
/*!****************************!*\
  !*** ./lib/Core/Config.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Config; });
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';
 // We cannot import ObjectHelper because of the import cycle:
//  ObjectHelper -> DateHelper -> LocaleManager -> Base -> us

/**
 * @module Core/Config
 */

const {
  defineProperty,
  getOwnPropertyDescriptor
} = Reflect,
      {
  hasOwnProperty,
  toString
} = Object.prototype,
      instancePropertiesSymbol = Symbol('instanceProperties'),
      configuringSymbol = Symbol('configuring'),
      lazyConfigValues = Symbol('lazyConfigValues'),
      DATE_TYPE = toString.call(new Date()),
      whitespace = /\s+/,
      createClsProps = (result, cls) => {
  result[cls] = 1;
  return result;
};
/**
 * This class holds the description of a config property. Only one instance of this class is needed for each config
 * name (e.g., "text"). If config options are supplied, however, they also contribute to the cached instance.
 *
 * Instances should always be retrieved by calling `Config.get()`.
 *
 * The **Configs** of this class correspond to `options` that can be supplied to the `get()` method. These affect the
 * behavior of the config property in some way, as descried by their respective documentation.
 *
 * This class is not used directly.
 *
 * ## The Setter
 * The primary functionality provided by `Config` is its standard setter. This setter function ensures consistent
 * behavior when modifying config properties.
 *
 * The standard setter algorithm is as follows (using the `'text'` config for illustration):
 *
 *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
 *    `changeText(newText, oldText)`.<br>
 *    Then:
 *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing further. The
 *      assumption is that the changer method has done all that is required.
 *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
 *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
 *    * Update the stored config value in `this._text`.
 *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
 *      `updateText(newText, oldText)`
 *    * If the class defines an `onConfigChange()` method, call it passing an object with the following properties:
 *        - `name` - The config's name
 *        - `value` - The new value
 *        - `was` - The previous value
 *        - `config` - The `Config` instance.
 *
 * NOTE: unlike `changeText()` and `updateText()`, the name of the `onConfigChange()` method is unaffected by the
 * config's name.
 *
 * @internal
 */


class Config {
  /**
   * Returns the `Config` instance for the given `name` and `options`.
   * @param {String} name The name of the config (e.g., 'text' for the text config).
   * @param {Object} [options] Config behavior options.
   * @returns {Core.Config}
   * @internal
   */
  static get(name, options) {
    const {
      cache
    } = this,
          baseCfg = cache[name] || (cache[name] = new Config(name));
    let cfg = baseCfg,
        key;

    if (options) {
      key = Config.makeCacheKey(name, options);

      if (!(cfg = key && cache[key])) {
        cfg = baseCfg.extend(options);

        if (key) {
          cache[key] = cfg;
        }
      }
    }

    return cfg;
  }

  constructor(name) {
    const me = this,
          cap = name[0].toUpperCase() + name.substr(1);
    me.base = me; // so extend()ed configs have a link to the base definition

    me.name = name;
    me.field = '_' + name;
    me.capName = cap;
    me.changer = 'change' + cap;
    me.initializing = 'initializing' + cap;
    me.updater = 'update' + cap;
  }
  /**
   * The descriptor to use with `Reflect.defineProperty()` for defining this config's getter and setter.
   * @property {Object}
   * @private
   */


  get descriptor() {
    let descriptor = this._descriptor;

    if (!descriptor || !hasOwnProperty.call(this, '_descriptor')) {
      // lazily make the descriptor
      this._descriptor = descriptor = this.makeDescriptor();
    }

    return descriptor;
  }
  /**
   * The descriptor to use with `Reflect.defineProperty()` for defining this config's initter.
   * @property {Object}
   * @private
   */


  get initDescriptor() {
    let descriptor = this._initDescriptor;

    if (!descriptor || !hasOwnProperty.call(this, '_initDescriptor')) {
      // lazily make the descriptor
      this._initDescriptor = descriptor = this.makeInitter();
    }

    return descriptor;
  }
  /**
   * This method compares two values for semantic equality. By default, this is based on the `===` operator. This
   * is often overridden for configs that accept `Date` or array values.
   * @param {*} value1
   * @param {*} value2
   * @returns {Boolean}
   * @internal
   */


  equal(value1, value2) {
    return value1 === value2;
  }
  /**
   * Extends this config with a given additional set of options. These objects are just prototype extensions of this
   * instance.
   * @param {Object} options
   * @returns {Core.Config}
   * @internal
   */


  extend(options) {
    const cfg = Object.assign(Object.create(this), options),
          {
      equal,
      merge
    } = options,
          {
      equalityMethods
    } = Config;

    if (typeof equal === 'string') {
      if (equal.endsWith('[]')) {
        cfg.equal = Config.makeArrayEquals(equalityMethods[equal.substr(0, equal.length - 2)]);
      } else {
        cfg.equal = equalityMethods[equal];
      }
    }

    if (typeof merge === 'string') {
      // Base uses { merge : 'replace' } for defaultConfig properties
      cfg.merge = Config.mergeMethods[merge];
    }

    return cfg;
  }
  /**
   * Defines the property on a given target object via `Reflect.defineProperty()`. If the object has its own getter,
   * it will be preserved. It is invalid to define a setter.
   * @param {Object} target
   * @internal
   */


  define(target) {
    const existing = getOwnPropertyDescriptor(target, this.name);
    let descriptor = this.descriptor;

    if (existing && existing.get) {
      descriptor = Object.assign({}, descriptor);
      descriptor.get = existing.get;
    }

    defineProperty(target, this.name, descriptor);
  }
  /**
   * Defines the property initter on the `target`. This is a property getter/setter that propagates the configured
   * value when the property is read.
   * @param {Object} target
   * @param {*} value
   * @internal
   */


  defineInitter(target, value) {
    const {
      name
    } = this,
          properties = target[instancePropertiesSymbol];
    let lazyValues, prop; // If there is an existing property with a getter/setter, *not* a value
    // defined on the object for this config we must call it in our injected getter/setter.

    if (!properties[name] && (
    /* assign */
    prop = getOwnPropertyDescriptor(target, name)) && !('value' in prop)) {
      properties[name] = prop;
    } // Set up a temporary instance property which will pull in the value from the initialConfig if the getter
    // is called first.


    defineProperty(target, name, this.initDescriptor);

    if (this.lazy) {
      lazyValues = target[lazyConfigValues] || (target[lazyConfigValues] = {
        $counter_: 0
      });
      lazyValues[name] = value;
      ++lazyValues.$counter_;
    }
  }
  /**
   * Returns an equality function for arrays of a base type, for example `'date'`.
   * @param {Function} [fn] The function to use to compare array elements. By default, operator `===` is used.
   * @returns {Function}
   * @private
   */


  static makeArrayEquals(fn) {
    return (value1, value2) => {
      let i,
          equal = value1 && value2 && value1.length === (i = value2.length);

      if (equal && Array.isArray(value1) && Array.isArray(value2)) {
        if (fn) {
          while (equal && i-- > 0) {
            equal = fn(value1[i], value2[i]);
          }
        } else {
          while (equal && i-- > 0) {
            equal = value1[i] === value2[i];
          }
        }
      } else {
        equal = fn ? fn(value1, value2) : value1 === value2;
      }

      return equal;
    };
  }
  /**
   * Returns the key to use in the Config `cache`.
   * @param {String} name The name of the config property.
   * @param {Object} options The config property options.
   * @returns {String}
   * @private
   */


  static makeCacheKey(name, options) {
    const keys = Object.keys(options).sort();

    for (let key, type, value, i = keys.length; i-- > 0;) {
      value = options[key = keys[i]];

      if (value == null && value === false) {
        keys.splice(i, 1);
      } else {
        type = typeof value;

        if (type === 'function') {
          return null;
        }

        if (type === 'string') {
          keys[i] = `${key}:"${value}"`;
        } else if (type === 'number') {
          keys[i] = `${key}:${value}`;
        } // that leaves bool and object, but there are no (valid) config options that are objects... so ignore

      }
    }

    return keys.length ? `${name}>${keys.join('|')}` : name; // eg: 'text>render|merge:v => v|bar'
  }
  /**
   * Creates and returns a property descriptor for this config suitable to be passed to `Reflect.defineProperty()`.
   * @returns {Object}
   * @private
   */


  makeDescriptor() {
    const config = this,
          {
      base,
      field,
      changer,
      updater,
      name
    } = config;

    if (base !== config && base.equal === config.equal) {
      // At present only the equal option affects the setter, so all configs can share the
      // descriptor of the base-most config definition unless their equality test fns differ.
      return base.descriptor;
    }

    return {
      get() {
        var _this$configObserver;

        // Allow folks like Widget.compose() to monitor getter calls
        (_this$configObserver = this.configObserver) === null || _this$configObserver === void 0 ? void 0 : _this$configObserver.get(name, this);
        return this[field];
      },

      set(value) {
        const me = this;
        let was = me[field],
            applied,
            newValue; // Resolve values starting with 'up.' by traversing owners to find it

        if (typeof value === 'string') {
          let resolvedValue = value;

          if (value.startsWith('up.')) {
            var _me$owner;

            resolvedValue = (_me$owner = me.owner) === null || _me$owner === void 0 ? void 0 : _me$owner.resolveProperty(value.substr(3));
          } else if (value.startsWith('this.')) {
            resolvedValue = me.resolveProperty(value.substr(5));
          } // TODO: Ignoring functions for now, we need to handle scope to make those work


          if (resolvedValue !== undefined && typeof resolvedValue !== 'function') {
            value = resolvedValue;
          }
        } // If the "changeTitle()" fellow falls off the end, it must have changed all the needful things.
        // Otherwise, it returned the final config value (it may have changed it instead, for example, making
        // an instance from a config object).


        if (me[changer]) {
          applied = (newValue = me[changer](value, was)) === undefined;

          if (!applied) {
            value = newValue;
            was = me[field]; // in case it was modified by the changer fn...
          }
        } // inline the default equal() for better perf:


        if (!applied && !(config.equal === equal ? was === value : config.equal(was, value))) {
          me[field] = value;
          applied = true; // Check for a "syncTitle()" method and call it if present.

          if (me[updater]) {
            me[updater](value, was);
          }
        }

        if (applied && !me.onConfigChange.$nullFn) {
          me.onConfigChange({
            name,
            value,
            was,
            config
          });
        }
      }

    };
  }
  /**
   * Creates and returns a property descriptor for this config's initter suitable to pass to
   * `Reflect.defineProperty()`.
   * @returns {Object}
   * @private
   */


  makeInitter() {
    const config = this;

    if (config !== config.base) {
      if (config.lazy) {
        return config.makeLazyInitter();
      } // At present no other options affect the setter, so all configs can share the descriptor of the base-most
      // config definition.


      return config.base.initDescriptor;
    }

    return config.makeBasicInitter();
  }

  makeBasicInitter() {
    const config = this,
          {
      initializing,
      name
    } = config;
    return {
      configurable: true,

      get() {
        const me = this;
        config.removeInitter(me); // Set the value from the configuration.

        me[initializing] = true;
        me[name] = me[configuringSymbol][name];
        me[initializing] = false; // The property has been *pulled* from the configuration.
        // Prevent the setting loop in configure from setting it again.

        me.configDone[name] = true; // Finally, allow the prototype getter to return the value.

        return me[name];
      },

      set(value) {
        config.removeInitter(this); // The config has been set (some internal code may have called the setter)
        // so prevent it from being called again and overwritten with data from initialConfig.

        this.configDone[name] = true; // Set the property normally (Any prototype setter will be invoked)

        this[name] = value;
      }

    };
  }

  makeLazyInitter() {
    const config = this,
          {
      initializing,
      name
    } = config;
    return {
      configurable: true,

      get() {
        const me = this,
              value = me[lazyConfigValues][name];
        config.removeInitter(me);

        if (!me.isDestroying) {
          // Set the value from the lazy config object.
          me[initializing] = true;
          me[name] = value;
          me[initializing] = false;
        } // Finally, allow the prototype getter to return the value.


        return me[name];
      },

      set(value) {
        config.removeInitter(this); // Set the property normally (Any prototype setter will be invoked)

        this[name] = value;
      }

    };
  }
  /**
   * Removes the property initter and restores the instance to its original form.
   * @param {Object} instance
   * @private
   */


  removeInitter(instance) {
    const {
      name
    } = this,
          instanceProperty = instance[instancePropertiesSymbol][name]; // If we took over from an instance property, replace it

    if (instanceProperty) {
      defineProperty(instance, name, instanceProperty);
    } // Otherwise just delete the instance property who's getter we are in.
    else {
      delete instance[name];
    }

    if (this.lazy) {
      if (! --instance[lazyConfigValues].$counter_) {
        delete instance[lazyConfigValues];
      }
    }
  }

  setDefault(cls, value) {
    defineProperty(cls.prototype, this.field, {
      configurable: true,
      writable: true,
      // or else "this._value = x" will fail
      value
    });
  }
  /**
   * This method combines (merges) two config values. This is called in two cases:
   *
   *  - When a derived class specifies the value of a config defined in a super class.
   *  - When a value is specified in the instance config object.
   *
   * @param {*} newValue In the case of derived classes, this is the config value of the derived class. In the case
   * of the instance config, this is the instance config value.
   * @param {*} currentValue In the case of derived classes, this is the config value of the super class. In the case
   * of the instance config, this is the class config value.
   * @param {Object} meta The class meta object from which the `newValue` is coming. This parameter is `null` if the
   * `newValue` is from an instance configuration.
   * @returns {*}
   * @internal
   */


  merge(newValue, currentValue) {
    if (currentValue && newValue && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(currentValue) && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(newValue)) {
      newValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(currentValue), newValue);
    }

    return newValue;
  }

}
const {
  prototype
} = Config,
      {
  equal
} = prototype;
Config.symbols = {
  configuring: configuringSymbol,
  instanceProperties: instancePropertiesSymbol,
  lazyConfigs: lazyConfigValues
};
/**
 * This object holds `Config` instances keyed by their name. For example:
 * ```
 *  Config.cache = {
 *      disabled : Config.get('disabled'),
 *      text     : Config.get('text'),
 *      title    : Config.get('title')
 *  };
 * ```
 * @member {Object} cache
 * @static
 * @private
 */

Config.cache = Object.create(null); // object w/no properties not even inherited ones

/**
 * This object holds config value equality methods. By default, the `===` operator is used to compare config values for
 * semantic equality. When an `equal` option is specified as a string, that string is used as a key into this object.
 *
 * All equality methods in this object have the same signature as the {@link #function-equal equal()} method.
 *
 * This object has the following equality methods:
 *
 * - `array` : Compares arrays of values using `===` on each element.
 * - `date` : Compares values of `Date` type.
 * - `strict` : The default equal algorithm based on `===` operator.
 * @member {Object} equalityMethods
 * @static
 * @private
 */

Config.equalityMethods = {
  array: Config.makeArrayEquals(),

  date(value1, value2) {
    if (value1 === value2) {
      return true;
    } // see DateHelper.isDate() but cannot import due to circularity


    if (value1 && value2 && toString.call(value1) === DATE_TYPE && toString.call(value2) === DATE_TYPE) {
      // https://jsbench.me/ltkb3vk0ji/1 - getTime is >2x faster vs valueOf/Number/op+
      return value1.getTime() === value2.getTime();
    }

    return false;
  },

  strict: Config.equal = equal
};
/**
 * This object holds config value merge methods. By default, {@link Core.helper.ObjectHelper#function-merge-static} is
 * used to merge object's by their properties. Config merge methods are used to combine config values from derived
 * classes with config values from super classes, as well as instance config values with those of the class.
 *
 * All merge methods in this object have the same signature as the {@link #function-merge merge()} method.
 *
 * This object has the following merge methods:
 *
 * - `distinct`   : Combines arrays of values ensuring that no value is duplicated. When given an object, its truthy
 *   keys are included, while its falsy keys are removed from the result.
 * - `merge`      : The default merge algorithm for `configurable()` properties, based on
 *   {@link Core.helper.ObjectHelper#function-merge-static}.
 * - `items`      : Similar to `merge`, but allows reordering (see `Objects.mergeItems`).
 * - `objects`    : The same as to `merge` except this method promotes `true` to an empty object.
 * - 'classList'  : Incoming strings are converted to an object where the string is a property name with a truthy value.
 * - `replace`    : Always returns `newValue` to replace the super class value with the derived class value, or the
 *   class value with the instance value.
 * @member {Object} mergeMethods
 * @static
 * @private
 */

Config.mergeMethods = {
  distinct(newValue, oldValue) {
    let ret = oldValue ? oldValue.slice() : [];

    if (newValue != null) {
      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(newValue)) {
        if (oldValue === undefined) {
          ret = newValue;
        } else {
          let key, index;

          for (key in newValue) {
            index = ret.indexOf(key);

            if (newValue[key]) {
              if (index < 0) {
                ret.push(key);
              }
            } else if (index > -1) {
              ret.splice(index, 1);
            }
          }
        }
      } else if (Array.isArray(newValue)) {
        newValue.forEach(v => !ret.includes(v) && ret.push(v));
      } else if (!ret.includes(newValue)) {
        ret.push(newValue);
      }
    }

    return ret;
  },

  merge: Config.merge = prototype.merge,

  classList(newValue, oldValue) {
    // 'foo bar' -> { foo : 1, bar : 1 }
    if (typeof newValue === 'string') {
      if (!newValue.length) {
        return oldValue;
      }

      newValue = newValue.split(whitespace).reduce(createClsProps, {});
    }

    return Config.merge(newValue, oldValue);
  },

  objects(newValue, oldValue) {
    return newValue === true ? oldValue || {} : Config.merge(newValue, oldValue);
  },

  replace(newValue) {
    return newValue;
  },

  items(newValue, oldValue) {
    return _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeItems(oldValue, newValue, {
      merge: (oldValue, newValue) => prototype.merge(newValue, oldValue)
    });
  }

};
Object.assign(prototype, {
  _descriptor: null,
  _initDescriptor: null,

  /**
   * A function that compares values for equality. This test is used to determine if the `update` method should be
   * called when the setter is invoked.
   *
   * To handle `Date` values:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              date : {
   *                  $config : {
   *                      equal : 'date'
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateDate(date) {
   *          // date has changed
   *      }
   *  }
   * ```
   *
   * Also useful for some configs:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              bar : {
   *                  $config : {
   *                      equal : ObjectHelper.isEqual
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateBar(value) {
   *          // value has changed
   *      }
   *  }
   * ```
   * @config {Function} equal
   * @internal
   */

  /**
   * Indicates that this config property should not automatically initialize during construction, but instead should
   * wait for the first explicit use of the property getter.
   * @config {Boolean}
   * @default
   * @internal
   */
  lazy: false,

  /**
   * Indicates that this config property should automatically be set to `null` on destroy.
   * @config {Boolean}
   * @default
   * @internal
   */
  nullify: false,

  /**
   * Indicates that this config participates in rendering. This has does not affect the behavior of the property
   * directly, but allows classes that perform rendering to detect which config changes will affect the rendered
   * result.
   * @config {Boolean}
   * @default
   * @internal
   */
  render: false // TODO FUTURES
  // clear   (bool - set to null during cleanup)
  // destroy (bool - destroy value during cleanup)
  // evented (bool - fire event on change / after updater)

});
Config._$name = 'Config';

/***/ }),

/***/ "./lib/Core/GlobalEvents.js":
/*!**********************************!*\
  !*** ./lib/Core/GlobalEvents.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';



/**
 * @module Core/GlobalEvents
 */

const isFloatingWidget = w => w.floating;

const GlobalEvents = new class extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  suspendFocusEvents() {
    focusEventsSuspended = true;
  }

  resumeFocusEvents() {
    focusEventsSuspended = false;
  }

  setupFocusListenersOnce(rootElement, EventHelper) {
    if (rootElement && !GlobalEvents.observedElements.has(rootElement)) {
      GlobalEvents.setupFocusListeners(rootElement, EventHelper);
      GlobalEvents.observedElements.add(rootElement);
    }
  } // This is imported by EventHelper and that makes the call to set up the listeners
  // `detach` argument is required to not setup more listeners than we need to. In case of salesforce we include floatroot
  // inside the webcomponent element and thus don't need default listeners on document. In regular webcomponents demo we
  // don't need to do it, because with multiple components on one page that would force us to make more complex lookups.


  setupFocusListeners(element = document, EventHelper, detach = false) {
    var _detacher;

    const listeners = {
      element,

      touchstart(touchstart) {
        if (!globaltouchStart && touchstart.changedTouches.length === 1) {
          globaltouchStart = touchstart.changedTouches[0];
        } else {
          globaltouchStart = null;
        }
      },

      // Just this one has to be passive: false so that we are allowed to preventDefault
      // if we are part of a contextmenu longpress emulation. Otherwise the gesture will
      // proceed to cause a mousedown event.
      touchend: {
        handler: event => {
          if (globaltouchStart) {
            // If the touchstart was used to synthesize a contextmenu event
            // stop the touch gesture processing right now.
            // Also prevent the conversion of the touch into  click.
            if (globaltouchStart.identifier === EventHelper.contextMenuTouchId) {
              event.stopImmediatePropagation();
              event.preventDefault();
            } else if (event.changedTouches.length === 1 && event.changedTouches[0].identifier === globaltouchStart.identifier) {
              GlobalEvents.trigger('globaltap', {
                event
              });
            }

            globaltouchStart = null;
          }
        },
        passive: false
      },
      mousedown: {
        handler: event => {
          lastInteractionType = 'mouse';

          if (!globaltouchStart) {
            GlobalEvents.trigger('globaltap', {
              event
            });
          }
        },
        passive: false
      },

      keydown() {
        lastInteractionType = 'key';
      },

      keypress() {
        lastInteractionType = 'key';
      },

      focusin(focusin) {
        const {
          Widget
        } = GlobalEvents; // https://app.assembla.com/spaces/bryntum/tickets/5503
        // Caused by the browser scrolling a focused element into view. The browser will do *whatever it takes*
        // to scroll a focused element so that as much of it is in view as possible. Its first point of scrolling will
        // be the float containing element. That must never scroll.
        // TODO: Remove when https://www.w3.org/TR/css-overflow-3/#valdef-overflow-clip is supported.

        Widget.resetFloatRootScroll();

        if (focusEventsSuspended) {
          return;
        }

        const fromElement = !focusin.relatedTarget ? null : focusin.relatedTarget instanceof HTMLElement ? focusin.relatedTarget : document.body,
              toElement = focusin.target || document.body,
              fromWidget = Widget.fromElement(fromElement),
              toWidget = Widget.fromElement(toElement),
              commonAncestor = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getCommonAncestor(fromWidget, toWidget),
              // Flag if the fromElement is DOCUMENT_POSITION_FOLLOWING toElement
        backwards = !!(fromElement && toElement.compareDocumentPosition(fromElement) & 4),
              topVisibleModal = Widget.query(isTopVisibleModal);
        let currentFocus = null;

        if (toElement && toElement !== document.body) {
          currentFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(toElement);
        } else {
          currentFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(document);
        } // If there is a topmost modal, and the focus is moving to somewhere *not* a descendant of that
        // modal, and that somewhere is not in a floater that us *above* that modal (the compareDocumentPosition call),
        // then we enforce modality and sweep focus back into the modal.
        // By default the Container class will yield the first focusable descendant widget's focusEl as its
        // focusEl, so that will be out of the box behaviour for Popups.


        if (topVisibleModal) {
          if (!toWidget || !topVisibleModal.owns(toWidget) && !(topVisibleModal.element.compareDocumentPosition(toWidget.element) & 4 && toWidget.up(isFloatingWidget))) {
            return topVisibleModal.focus();
          }
        }

        let event = createWidgetEvent('focusout', fromElement, focusin.target, fromWidget, toWidget, backwards); // Bubble focusout event up the "from" side of the tree

        for (let target = fromWidget; target && target !== commonAncestor; target = target.owner) {
          if (!target.isDestroying && target.onFocusOut) {
            target.onFocusOut(event); // It is possible for focusout handlers to refocus themselves (editor's invalidAction='block'), so
            // check if the focus is still where it was when we started unless we are in a document
            // loss of focus situation (no target)

            if (focusin.target && currentFocus !== _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(focusin.target)) {
              // If the focus has moved, that movement would have kicked off a nested sequence of focusin/out
              // notifications, so everyone has already been notified... no more to do here.
              return;
            }
          }
        } // Focus is moving upwards to the ancestor widget.
        // Its focus method might delegate focus to a focusable descendant.


        if (commonAncestor && focusin.target === commonAncestor.element) {
          // If one of the handlers above has not moved focus onwards
          // and the common ancestor is a container which delegates
          // focus inwards to a descendant, then give it the opportunity to do that.
          if (!commonAncestor.isDestroying && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(commonAncestor) === toElement && commonAncestor.focusElement && commonAncestor.focusElement !== commonAncestor.element) {
            // If focus is not inside, move focus inside
            if (!commonAncestor.element.contains(currentFocus)) {
              // Wait until out of the focusin handler to move focus on.
              commonAncestor.setTimeout(() => {
                var _commonAncestor$focus;

                return (_commonAncestor$focus = commonAncestor.focus) === null || _commonAncestor$focus === void 0 ? void 0 : _commonAncestor$focus.call(commonAncestor);
              }, 0);
            }
          }
        } // Focus is moving between two branches of a subtree.
        // Bubble focusin event up the "to" side of the tree
        else {
          event = createWidgetEvent('focusin', toElement, fromElement, fromWidget, toWidget, backwards);

          for (let target = toWidget; target && target !== commonAncestor; target = target.owner) {
            if (!target.isDestroying) {
              var _target$onFocusIn, _target;

              (_target$onFocusIn = (_target = target).onFocusIn) === null || _target$onFocusIn === void 0 ? void 0 : _target$onFocusIn.call(_target, event);
            }
          }
        } // Fire element focusmove event. Grid navigation will use  this when cells are focusable.


        const commonAncestorEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getCommonAncestor((fromElement === null || fromElement === void 0 ? void 0 : fromElement.nodeType) === Element.ELEMENT_NODE ? fromElement : null, toElement) || toElement.parentNode;
        event = createWidgetEvent('focusmove', toElement, fromElement, fromWidget, toWidget, backwards, {
          bubbles: true
        });
        commonAncestorEl.dispatchEvent(event);
      },

      focusout(focusout) {
        if (focusEventsSuspended) {
          return;
        }

        if (!focusout.relatedTarget || !GlobalEvents.Widget.fromElement(focusout.relatedTarget)) {
          // When switching between tabs in Salesforce app `relatedTarget` of the focusout event might be not an instance of
          // HTMLElement.
          const target = focusout.relatedTarget && focusout.relatedTarget instanceof HTMLElement ? focusout.relatedTarget : null;
          listeners.focusin({
            target,
            relatedTarget: focusout.target
          });
        }
      },

      capture: true,
      passive: true
    }; // detach previous listeners

    detach && ((_detacher = detacher) === null || _detacher === void 0 ? void 0 : _detacher());
    detacher = EventHelper.on(listeners);
  }

  get lastInteractionType() {
    return lastInteractionType;
  }

}(),
      isTopVisibleModal = w => w.isVisible && w.isTopModal;

GlobalEvents.observedElements = new Set();
/**
 * Fired after the theme is changed
 * @event theme
 * @param {Core.GlobalEvents} source
 * @param {String} theme The new theme name
 */

let globaltouchStart,
    focusEventsSuspended = false,
    lastInteractionType,
    detacher;

function createWidgetEvent(eventName, target, relatedTarget, fromWidget, toWidget, backwards, options) {
  const result = new CustomEvent(eventName, options); // Workaround for Salesforce. They use strict mode and define non-configurable property `target`. We use this
  // CustomEvent as a synthetic one, feels fine to use non-standard handle for target.

  Object.defineProperty(result, '_target', {
    get() {
      return target;
    }

  });
  Object.defineProperty(result, 'relatedTarget', {
    get() {
      return relatedTarget;
    }

  });
  result.fromWidget = fromWidget;
  result.toWidget = toWidget;
  result.backwards = backwards;
  return result;
}
/**
 * A singleton firing global application level events like 'theme'.
 *
 * ```javascript
 * GlobalEvents.on({
 *    theme() {
 *        // react to theme changes here
 *    }
 * });
 * ```
 *
 * @class
 * @singleton
 * @mixes Core/mixin/Events
 */


/* harmony default export */ __webpack_exports__["default"] = (GlobalEvents);

/***/ }),

/***/ "./lib/Core/customElements/WidgetTag.js":
/*!**********************************************!*\
  !*** ./lib/Core/customElements/WidgetTag.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetTag; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';
/**
* @module Core/customElements/WidgetTag
*/





/**
 * A base class for a custom web component element wrapping one {@link Core.widget.Widget}.
 */

class WidgetTag extends (window.customElements ? HTMLElement : Object) {
  /**
   * The widget instance rendered in the shadow root
   * @member {Core.widget.Widget} widget
   */

  /**
   * Path to theme to use within the web component.
   *
   * ```html
   * <bryntum-grid stylesheet="resources/grid.stockholm.css">
   * </bryntum-grid>
   * ```
   *
   * @config {String} stylesheet
   */

  /**
   * Path to folder containing Font Awesome 5 Free.
   *
   * ```html
   * <bryntum-grid fa-path="resources/fonts">
   * </bryntum-grid>
   * ```
   *
   * @config {String} faPath
   */
  connectedCallback() {
    this.setup();
  }

  async setup() {
    const me = this; // Setup just once

    if (me.shadowRoot) {
      return;
    }

    let linkResolver, font;
    const product = me.tagName.substring('BRYNTUM-'.length).toLowerCase(),
          // Only load fa if not already on page, otherwise each instance will load it
    faPath = (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isChrome || !document.fonts.check(`normal 14px "Font Awesome 5 Free"`)) && me.getAttribute('fa-path'),
          themeLink = document.getElementById('bryntum-theme'),
          theme = me.getAttribute('theme') || 'stockholm',
          stylesheet = me.getAttribute('stylesheet') || (themeLink === null || themeLink === void 0 ? void 0 : themeLink.href) || `${product}.${theme}.css`,
          // Go over to the dark side
    shadowRoot = me.attachShadow({
      mode: 'open'
    }),
          // Include css and target div in shadow dom
    link = me.linkTag = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
      tag: 'link',
      rel: 'stylesheet',
      href: stylesheet,
      parent: shadowRoot
    }),
          promises = [new Promise(resolve => {
      linkResolver = resolve;
    })],
          config = {
      appendTo: shadowRoot,
      features: {}
    };
    me.convertDatasetToConfigs(me.dataset, config);

    link.onload = () => linkResolver(); // Load FontAwesome if path was supplied


    if (faPath) {
      // FF cannot use the name "Font Awesome 5 Free", have if fixed in CSS to handle it also without spaces
      font = new FontFace(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox ? 'FontAwesome5Free' : 'Font Awesome 5 Free', `url("${faPath}/fa-solid-900.woff2")`);
      promises.push(font.load());
    }

    await Promise.all(promises);

    if (font) {
      document.fonts.add(font);
    } // Create columns, data and configure features


    for (const tag of me.children) {
      const tagName = tag.tagName;

      if (tagName === 'FEATURE') {
        const name = tag.dataset.name,
              featureConfig = me.convertDatasetToConfigs(tag.dataset);
        delete featureConfig.name;

        if (Object.keys(featureConfig).length) {
          config.features[name] = featureConfig.use === 'false' ? false : featureConfig;
        } else {
          config.features[name] = tag.textContent !== 'false';
        }
      } else if (tagName === 'TBAR' || tagName === 'BBAR') {
        config[tagName.toLowerCase()] = Array.from(tag.children).map(item => me.convertDatasetToConfigs(item.dataset));
      } else if (tagName === 'INLINESTYLE') {
        const style = document.createElement('style');
        style.innerHTML = tag.innerHTML;
        shadowRoot.appendChild(style);
      }
    }

    me.widget = me.createInstance(config);
  }

  convertDatasetToConfigs(dataset, config = {}, ignoreObjects = false) {
    for (const key in dataset) {
      let value = dataset[key];

      if (!ignoreObjects && typeof value === 'string' && value.startsWith('{')) {
        value = this.convertDatasetToConfigs(JSON.parse(value.replace(/'/g, '"')));
      } else {
        var _StringHelper$safeJso;

        value = (_StringHelper$safeJso = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonParse(value)) !== null && _StringHelper$safeJso !== void 0 ? _StringHelper$safeJso : value;
      }

      config[key] = value;
    }

    return config;
  }
  /**
   * Destroys the inner widget instance and cleans up
   */


  destroy() {
    var _sharedTips$tooltip, _sharedTips$tooltip$g, _sharedTips$errorTool;

    const me = this;

    if (!me.widget) {
      // Removed before anything could be created
      return;
    }

    const {
      shadowRoot
    } = me,
          sharedTips = shadowRoot.bryntum,
          constructor = me.widget.constructor,
          floatRoot = shadowRoot.querySelector('.b-float-root');
    sharedTips === null || sharedTips === void 0 ? void 0 : (_sharedTips$tooltip = sharedTips.tooltip) === null || _sharedTips$tooltip === void 0 ? void 0 : (_sharedTips$tooltip$g = _sharedTips$tooltip.get(_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__["default"])) === null || _sharedTips$tooltip$g === void 0 ? void 0 : _sharedTips$tooltip$g.destroy();
    sharedTips === null || sharedTips === void 0 ? void 0 : (_sharedTips$errorTool = sharedTips.errorTooltip) === null || _sharedTips$errorTool === void 0 ? void 0 : _sharedTips$errorTool.destroy();
    me.widget.destroy();
    floatRoot === null || floatRoot === void 0 ? void 0 : floatRoot.remove();
    constructor.removeFloatRoot(floatRoot);
    me.linkTag.remove();
    me.widget = null;
  }

}
WidgetTag._$name = 'WidgetTag';

/***/ }),

/***/ "./lib/Core/data/AjaxStore.js":
/*!************************************!*\
  !*** ./lib/Core/data/AjaxStore.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxStore; });
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';



/**
 * @module Core/data/AjaxStore
 */

const processParamEntry = (paramArray, entry) => {
  if (Array.isArray(entry[1])) {
    entry[1].forEach(value => paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(value)));
  } else {
    paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]));
  }

  return paramArray;
},
      immediatePromise = Promise.resolve();
/**
 * Store that uses the Fetch API to read data from a remote server, and optionally sends synchronization
 * requests to the server containing information about locally created, modified and deleted records.
 *
 * ## Create
 * Posts array of JSON data for newly added records to {@link #config-createUrl}, expects response containing an array of JSON objects
 * in same order with id set (uses Model#idField as id).
 *
 * ## Read
 * Reads array of JSON data from the data packet returned from the {@link #config-readUrl}. Unique id for each row is required.
 * By default looks in field 'id' but can be configured by setting {@link Core.data.Model#property-idField-static}.
 *
 * ## Update
 * Posts array of JSON data containing modified records to {@link #config-updateUrl}. By default, only changed fields and
 * any fields configured with {@link Core.data.field.DataField#config-alwaysWrite} are sent.
 * If you want all fields to always be sent, please see {@link #config-writeAllFields}
 *
 * ## Delete
 * Posts to {@link #config-deleteUrl} with removed records ids (for example id=1,4,7).
 *
 * ```javascript
 * new AjaxStore({
 *   createUrl  : 'php/create',
 *   readUrl    : 'php/read',
 *   updateUrl  : 'php/update',
 *   deleteUrl  : 'php/delete',
 *   modelClass : Customer
 * });
 * ```
 *
 * ## Pagination
 * Configuring an `AjaxStore` with {@link #config-pageParamName} or {@link #config-pageStartParamName} means that the store requests **pages**
 * of data from the remote source, sending the configured {@link #config-pageParamName} or {@link #config-pageStartParamName} to request the page
 * along with the {@link #config-pageSizeParamName}.
 *
 * If `pageParamName` is set, that is passed with the requested page number **(one based)**, along with the {@link #config-pageSizeParamName}.
 *
 * If `pageStartParamName` is set, that is passed with the requested page starting record index **(zero based)**, along with the {@link #config-pageSizeParamName}.
 *
 * ## Remote filtering
 * To specify that filtering is the responsibility of the server, configure the store with
 * `{@link #config-filterParamName}: 'nameOfFilterParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreFilter#function-filter} operation causes the store to
 * reload itself, encoding the filters as JSON representations in the {@link #config-filterParamName} HTTP
 * parameter.
 *
 * The filters will look like this:
 * ```javascript
 * {
 *     "field": "country",
 *     "operator": "=",
 *     "value": "sweden",
 *     "caseSensitive": false
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeFilterParams}
 * into the store which returns the value for the {@link #config-filterParamName} when passed an _Iterable_ of filters.
 *
 * ## Remote sorting
 * To specify that sorting is the responsibility of the server, configure the store with
 * `{@link #config-sortParamName}: 'nameOfSortParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreSort#function-sort} operation causes the store to
 * reload itself, encoding the sorters as JSON representations in the {@link #config-sortParamName} HTTP
 * parameter.
 *
 * The sorters will look like this:
 * ```javascript
 * {
 *     "field": "name",
 *     "ascending": true
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeSorterParams}
 * into the store which returns the value for the {@link #config-sortParamName} when passed an _Iterable_ of sorters.
 *
 * @extends Core/data/Store
 */


class AjaxStore extends _Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // region Events

  /**
   * Fired when a remote request fails, either at the network level, or the server returns a failure, or an invalid response.
   *
   * Note that when a {@link #function-commit} fails, more than one exception event will be triggered. The individual operation,
   * `create`, `update` or `delete` will trigger their own `exception` event, but the encapsulating commit operation will also
   * trigger an `exception` event when all the operations have finished, so if exceptions are going to be handled gracefully,
   * the event's `action` property must be examined, and the constituent operations of the event must be examined.
   * @event exception
   * @param {Core.data.Store} source This Store
   * @param {Boolean} exception `true`
   * @param {String} action Action that failed, `'create'`, `'read'`, `'update'` or `'delete'`. May also be fired
   * with '`commit'` to indicate the failure of an aggregated `create`, `update` and `delete` operation. In this case,
   * the event will contain a property for each operation of the commit named `'create'`, `'update'` and `'delete'`,
   * each containing the individual `exception` events.
   * @param {String} exceptionType The type of failure, `'network'` or `'server'`
   * @param {Response} response the `Response` object
   * @param {Object} json The decoded response object *if the exceptionType is `'server'`*
   */

  /**
   * Fired after committing added records
   * @event commitAdded
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired after committing modified records
   * @event commitModified
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired on successful load
   * @event load
   * @param {Core.data.Store} source This Store
   * @param {Object[]} data Data loaded
   * @param {Response} response the `Response` object
   * @param {Object} json The decoded response object.
   */

  /**
   * Fired on successful load of remote child nodes for a tree node.
   * @event loadChildren
   * @param {Core.data.Store} source This Store
   * @param {Object[]} data Data loaded
   * @param {Object} json The decoded response object.
   */

  /**
   * Fired after committing removed records
   * @event commitRemoved
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired before loading starts. Allows altering parameters and is cancelable
   * @event beforeLoad
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired before loading of remote child nodes of a tree node starts. Allows altering parameters and is cancelable
   * @event beforeLoadChildren
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * When the store {@link #property-isPaged is paged}, this is fired before loading a page and is cancelable
   * @event beforeLoadPage
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired when loading is beginning. This is not cancelable. Parameters in the event may still be
   * mutated at this stage.
   * @event loadStart
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired when loading of remote child nodes into a tree node is beginning. This is not cancelable. Parameters in the event may still be
   * mutated at this stage.
   * @event loadChildrenStart
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired before any remote request is initiated.
   * @event beforeRequest
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing key/value pairs that are passed on the request query string
   * @param {Object} body The body of the request to be posted to the server.
   * @param {String} action Action that is making the request, `'create'`, `'read'`, `'update'` or `'delete'`
   */

  /**
   * Fired after any remote request has finished whether successfully or unsuccessfully.
   * @event afterRequest
   * @param {Boolean} exception `true`. *Only present if the request triggered an exception.*
   * @param {String} action Action that has finished, `'create'`, `'read'`, `'update'` or `'delete'`
   * @param {String} exceptionType The type of failure, `'network'` or `'server'`. *Only present if the request triggered an exception.*
   * @param {Response} response The `Response` object
   * @param {Object} json The decoded response object if there was no `'network'` exception.
   */
  // endregion
  //region Config
  static get defaultConfig() {
    return {
      /**
       * An object containing the HTTP headers to add to each server request issued by this Store.
       * @config {Object}
       * @default
       * @category Remote
       */
      headers: null,

      /**
       * An object containing the Fetch options to pass to each server request issued by this Store. Use this to control if credentials are sent
       * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
       * @config {Object}
       * @default
       * @category Remote
       */
      fetchOptions: null,

      /**
       * Specify `true` to send payloads as form data, `false` to send as regular JSON.
       * @config {Boolean}
       * @default
       * @category Remote
       */
      sendAsFormData: false,

      /**
       * Specify `true` to send all model fields when committing modified records (as opposed to just the modified fields)
       * @config {Boolean}
       * @default
       * @category Remote
       */
      writeAllFields: null,

      /**
       * The name of the HTTP parameter passed to this Store's {@link #config-readUrl} to indicate the node `id` to
       * load when loading child nodes on demand if the node being expanded was created with data containing `children: true`.
       * @config {String}
       * @default
       * @category Remote
       */
      parentIdParamName: 'id',

      /**
       * The optional property name in JSON responses from the server that contains a boolean
       * success/fail status.
       * ```
       * {
       *   "responseMeta" : {
       *   {
       *     "success" : true,
       *     "count" : 100
       *   },
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ]
       * }
       * ```
       *
       * The store would be configured with:
       * ```javascript
       *  {
       *      ...
       *      successDataProperty : 'responseMeta.success',
       *      responseTotalProperty : 'responseMeta.count'
       *      ...
       *  }
       *
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseSuccessProperty: 'success',

      /**
       * The property name in JSON responses from the server that contains the data for the records
       * ```
       * {
       *   "success" : true,
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ]
       * }
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseDataProperty: 'data',

      /**
       * The property name in JSON responses from the server that contains the dataset total size
       * **when this store {@link #property-isPaged is paged}**
       * ```
       * {
       *   "success" : true,
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ],
       *   // The property name used here should match that of 'responseTotalProperty'
       *   "total" : 65535
       * }
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseTotalProperty: 'total',

      /**
       * The name of the HTTP parameter to use to pass any encoded filters when loading data from the server and a filtered response is required.
       *
       * **Note:** When this is set, filters must be defined using a field name, an operator and a value
       * to compare, **not** a comparison function.
       * @config {String}
       * @category Remote
       */
      filterParamName: null,

      /**
       * Set this flag to true if you are filtering remote using restful URLs (e.g. https://nominatim.openstreetmap.org/search/paris?format=json)
       *
       * **Note:** When this is set, the filter string is appended to the readUrl.
       * @config {Boolean}
       * @category Remote
       */
      restfulFilter: false,

      /**
       * The name of the HTTP parameter to use to pass any encoded sorters when loading data from the server and a sorted response is required.
       *
       * **Note:** When this is set, sorters must be defined using a field name and an ascending flag,
       * **not** a sort function.
       * @config {String}
       * @category Remote
       */
      sortParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **one based** page number required.
       * @config {String}
       * @category Paging
       */
      pageParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
       * @config {String}
       * @category Paging
       */
      pageStartParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
       * @config {String}
       * @default
       * @category Paging
       */
      pageSizeParamName: 'pageSize',

      /**
       * When paging of data is requested by setting _either_ the {@link #config-pageParamName} _or_ the {@link #config-pageStartParamName},
       * this is the value to send in the {@link #config-pageSizeParamName}
       * @config {Number}
       * @default
       * @category Paging
       */
      pageSize: 50,

      /**
       * Set to ´true´ to use restful {@link #config-httpMethods}
       * @config {Boolean}
       * @default
       * @category Remote
       */
      useRestfulMethods: false,

      /**
       * The HTTP methods to use for CRUD requests when {@link #config-useRestfulMethods} is enabled.
       *
       * ```
       * new AjaxStore({
       *    useRestfulMethods : true,
       *    httpMethods : {
       *        create : 'POST',
       *        read : 'POST',
       *        update : 'PATCH',
       *        delete : 'DELETE'
       *    }
       * });
       *
       * ```
       * @config {Object}
       * @default
       * @category Remote
       */
      httpMethods: {
        create: 'POST',
        read: 'GET',
        update: 'PUT',
        delete: 'DELETE'
      }
    };
  }

  static get configurable() {
    return {
      /**
       * An object containing key/value pairs that are passed on the request query string.
       * @member {Object} params
       * @category Remote
       */

      /**
       * An object containing key/value pairs that are passed on the request query string.
       * @config {Object}
       * @category Remote
       */
      params: null
    };
  }
  /**
   * Url to post newly created records to.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} createUrl
   * @category CRUD
   */

  /**
   * Url to read data from.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * If the store {@link #property-isPaged is paged}, the total dataset size must be returned
   * in the {@link #config-responseTotalProperty} property:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }],
   *         "total": 65535
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} readUrl
   * @category CRUD
   */

  /**
   * Url to post record modifications to.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} updateUrl
   * @category CRUD
   */

  /**
   * Url for deleting records.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true
   *     }
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} deleteUrl
   * @category CRUD
   */

  /**
   * True to initiate a load when the store is instantiated
   * @config {Boolean} autoLoad
   * @category Common
   */
  //endregion


  afterConstruct(config) {
    super.afterConstruct(config);

    if (this.autoLoad) {
      this.load().catch(() => {});
    }
  }
  /**
   * Returns true if the Store is currently loading
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isLoading() {
    return this._isLoading;
  }
  /**
   * Returns true if the Store is currently committing
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isCommitting() {
    return Boolean(this.commitPromise);
  }

  set pageParamName(pageParamName) {
    if (this.tree) {
      throw new Error('Paging cannot be supported for tree stores');
    }

    if (this.pageStartParamName) {
      throw new Error('Configs pageStartParamName and pageParamName are mutually exclusive');
    }

    this._pageParamName = pageParamName;
  }

  get pageParamName() {
    return this._pageParamName;
  }

  set pageStartParamName(pageStartParamName) {
    if (this.tree) {
      throw new Error('Paging cannot be supported for tree stores');
    }

    if (this.pageParamName) {
      throw new Error('Configs pageParamName and pageStartParamName are mutually exclusive');
    }

    this._pageStartParamName = pageStartParamName;
  }

  get pageStartParamName() {
    return this._pageStartParamName;
  }
  /**
   * Yields true if this Store is loaded page by page. This yields `true` if either of the {@link #config-pageParamName}
   * of {@link #config-pageStartParamName} configs are set.
   * @property {Boolean}
   * @readonly
   * @category Paging
   */


  get isPaged() {
    return this.pageParamName || this.pageStartParamName;
  }
  /**
   * Yields the complete dataset size. If the store is {@link #property-isPaged is paged} this is the value
   * returned in the last loaded data block in the {@link #config-responseTotalProperty} property. Otherwise it is
   * the number of records in the store's underlying storage collection.
   * @property {Number}
   * @readonly
   * @category Paging
   */


  get allCount() {
    return 'remoteTotal' in this ? this.remoteTotal : super.allCount;
  }
  /**
   * **If the store {@link #property-isPaged is paged}**, yields the highest page number in the dataset as calculated from the {@link #config-responseTotalProperty}
   * returned in the last page data block loaded.
   * @property {Number}
   * @readonly
   * @category Paging
   */


  get lastPage() {
    if (this.isPaged) {
      return Math.floor((this.allCount + this.pageSize - 1) / this.pageSize);
    }
  }

  buildQueryString(url, ...paramObjects) {
    const hasParamsInUrl = url.includes('?'),
          queryString = Object.entries(Object.assign({}, ...paramObjects)).reduce(processParamEntry, []).join('&');
    return queryString ? (hasParamsInUrl ? '&' : '?') + queryString : '';
  }

  performSort(silent) {
    const me = this;

    if (me.sortParamName) {
      const {
        groupRecords
      } = me,
            // Current collapsed state for groups
      collapsed = {}; // Temporarily remove group headers, will be re-added after sort

      if (me.isGrouped && groupRecords !== null && groupRecords !== void 0 && groupRecords.length) {
        // TODO: Replace with same logic as used elsewhere
        groupRecords.forEach(r => {
          if (r.meta.collapsed) {
            me.includeGroupRecords(r);
            collapsed[r.id] = true;
          }
        });
      } // TODO: Should we cache lastParams from the load call and use them here?


      return me.internalLoad({}, '', event => {
        me.data = event.data;
        me.afterPerformSort(silent, collapsed);
      });
    } else {
      super.performSort(silent);
    }
  }

  performFilter(silent) {
    const me = this; // For remote filtering, the dataset cannot be preserved. The size may be completely different.
    // This is a reload operation.

    if (me.remoteFilter) {
      const oldCount = me.count,
            {
        filters
      } = me; // load should default to page 1

      me.currentPage = 1; // TODO: Should we cache lastParams from the load call and use them here?

      return me.internalLoad({}, '', event => {
        me.data = event.data;
        me.afterPerformFilter(silent ? null : {
          action: 'filter',
          filters,
          oldCount,
          records: me.storage.values
        });
      });
    } else {
      super.performFilter(silent);
    }
  }
  /**
   * A provided function which creates an array of values for the {@link #config-filterParamName} to pass
   * any filters to the server upon load.
   *
   * By default, this creates a JSON string containing the following properties:
   *
   * ```javascript
   *    [{
   *        field         : <theFieldName>
   *        operator      : May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
   *        value         : The value to compare
   *        caseSensitive : true for case sensitive comparisons
   *    }]
   * ```
   * @param {Core.util.CollectionFilter[]} filters The filters to encode.
   */


  encodeFilterParams(filters) {
    const result = [];

    for (const {
      property,
      operator,
      value,
      caseSensitive
    } of filters) {
      result.push({
        field: property,
        operator,
        value,
        caseSensitive
      });
    }

    return JSON.stringify(result);
  }
  /**
   * A provided function which creates an array of values for the {#config-sortParamName} to pass
   * any sorters to the server upon load.
   *
   * By default, this creates a JSON string containing the following properties:
   *
   * ```javascript
   *    [{
   *        field     : <theFieldName>
   *        ascending : true/false
   *    }]
   * ```
   *
   * @param {Object[]} sorters The sorters to encode.
   */


  encodeSorterParams(sorters) {
    return JSON.stringify(sorters.filter(sorter => !sorter.sortFn).map(sorter => sorter));
  }

  buildReadUrl() {
    const {
      readUrl
    } = this;

    if (this.restfulFilter && this.filters.count) {
      const url = readUrl.endsWith('/') ? readUrl : readUrl + '/';
      return url + this.filters.first.value;
    } else {
      return readUrl;
    }
  }

  internalLoad(params, eventName, successFn) {
    const me = this,
          allParams = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, me.params, params),
          url = me.buildReadUrl(),
          event = {
      action: 'read' + eventName,
      params: allParams,
      url
    };
    return url ? new Promise((resolve, reject) => {
      if (me.trigger('beforeLoad' + eventName, event) === false) {
        return reject(false); // eslint-disable-line
      }

      me._isLoading = true; // This may look redundant, but it allows for two levels of event listening.
      // Granular, where the observer observes only the events of interest, and
      // catch-all, where the observer is interested in all requests.

      me.trigger(`load${eventName}Start`, event);
      me.trigger('beforeRequest', event); // Add filter information to the request parameters

      if (me.filterParamName && me.isFiltered) {
        allParams[me.filterParamName] = me.encodeFilterParams(me.filters.values);
      } // Add sorter information to the request parameters.
      // isSorted includes grouping in its evaluation.


      if (me.sortParamName && me.isSorted) {
        allParams[me.sortParamName] = me.encodeSorterParams(me.groupers ? me.groupers.concat(me.sorters) : me.sorters);
      } // Ensure our next page is passed to the server in the params if not already set.
      // Ensure our page size is always passed.


      if (me.isPaged) {
        if (!(me.pageParamName in allParams || me.pageStartParamName in allParams)) {
          const page = Math.min(me.currentPage || 1, me.allCount ? me.lastPage : Infinity);

          if (me.pageParamName) {
            allParams[me.pageParamName] = page;
          } else {
            allParams[me.pageStartParamName] = (page - 1) * me.pageSize;
          }
        }

        allParams[me.pageSizeParamName] = me.pageSize;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.read;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(event.url + me.buildQueryString(event.url, allParams), _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(async response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseSuccessProperty) !== false,
              remoteTotal = isArray ? null : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseTotalProperty);
        me._isLoading = false;
        event.response = response;
        event.json = data;

        if (success) {
          if (remoteTotal != null) {
            me.remoteTotal = parseInt(remoteTotal, 10);
          } // If we are issuing paged requests, work out what page we are on based
          // on the requested page and the size of the dataset declared.


          if (me.isPaged) {
            if (me.remoteTotal >= 0) {
              const requestedPage = me.pageParamName ? allParams[me.pageParamName] : allParams[me.pageStartParamName] / me.pageSize + 1;
              me.currentPage = Math.min(requestedPage, me.lastPage);
            } else {
              throw new Error('A paged store must receive its responseTotalProperty in each data packet');
            }
          }

          event.data = isArray ? data : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseDataProperty);
          await successFn(event);
          me.trigger('load' + eventName, event);
          resolve(event);
        } else {
          event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          reject(event);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        me._isLoading = false;
        event.exception = true;

        if (responseOrError instanceof Response) {
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        reject(event); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }
  /**
   * Load data from the {@link #config-readUrl}.
   * @param {Object} [params] A hash of parameters to append to querystring (will also append Store#params)
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoad} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoad} handler.
   * @fires beforeLoad
   * @fires loadStart
   * @fires beforeRequest
   * @fires load
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async load(params) {
    const me = this;

    if (me.isPaged) {
      return me.loadPage(me.currentPage || 1, params);
    } else {
      return me.internalLoad(params, '', event => {
        // The set Data setter will trigger the refresh event with { action: 'dataset' }
        me.data = event.data;
      });
    }
  }
  /**
   * Loads children into specified parent record. Parent records id is sent as a param (param name configured with
   * {@link #config-parentIdParamName}.
   * @param {Core.data.Model} parentRecord Parent record
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoadChildren} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoadChildren} handler.
   * @fires beforeLoadChildren
   * @fires loadChildrenStart
   * @fires beforeRequest
   * @fires loadChildren
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async loadChildren(parentRecord) {
    return this.internalLoad({
      [this.parentIdParamName]: parentRecord.id
    }, 'Children', event => {
      event.parentRecord = parentRecord;

      if (parentRecord.children.length) {
        parentRecord.clearChildren(true);
      } // Append received children


      parentRecord.data[parentRecord.constructor.childrenField] = event.data;
      parentRecord.processChildren(parentRecord.stores);
    });
  }
  /**
   * Loads a page of data from the {@link #config-readUrl}.
   * @param {Number} page The *one based* page number to load.
   * @param {Object} params A hash of parameters to append to querystring (will also append Store#params)
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoadPage} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoadPage} handler.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async loadPage(page, params) {
    if (this.allCount) {
      page = Math.min(page, this.lastPage);
    }

    const me = this,
          pageParam = me.pageParamName ? {
      [me.pageParamName]: page
    } : {
      [me.pageStartParamName]: (page - 1) * me.pageSize
    };
    pageParam[me.pageSizeParamName] = me.pageSize;
    return me.internalLoad(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(pageParam, params), 'Page', event => {
      // We go directly to loadPage because paging a tree store is unsupportable.
      // loadPage will trigger the refresh event with { action: 'pageLoad' }
      me.loadData(event.data, 'pageLoad');
    });
  }
  /**
   * If this store {@link #property-isPaged is paged}, and is not already at the {@link #property-lastPage}
   * then this will load the next page of data.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async nextPage(params) {
    return this.isPaged && this.currentPage !== this.lastPage ? this.loadPage(this.currentPage + 1, params) : immediatePromise;
  }
  /**
   * If this store {@link #property-isPaged is paged}, and is not already at the first page
   * then this will load the previous page of data.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async previousPage(params) {
    return this.isPaged && this.currentPage !== 1 ? this.loadPage(this.currentPage - 1, params) : immediatePromise;
  }
  /**
   * Commits all changes (added, modified and removed) using corresponding urls ({@link #config-createUrl},
   * {@link #config-updateUrl} and {@link #config-deleteUrl})
   * @fires beforeCommit
   * @returns {Promise} A Promise which is resolved only if all pending changes (Create, Update and Delete) successfully resolve.
   * Both the resolve and reject functions are passed a `commitState` object which is stored the {@link #event-afterRequest}
   * event for each request. Each event contains the `exception`, `request` and `response` properties eg:
   *
   * ```javascript
   * {
   *      // If *all* commits succeeded
   *      success: true,
   *      changes: {
   *          added: [records...],
   *          modified: [records...],
   *          removed: [records...],
   *      },
   *      added: {
   *          source: theStore,
   *
   *          // Only if the add request triggered an exception
   *          exception: true,
   *
   *          // Only if the add request triggered an exception
   *          exceptionType: 'server', // Or 'network'
   *
   *          response: Response,
   *          json: parsedResponseObject
   *      },
   *      // Same format as added
   *      modified: {},
   *      removed: {}
   * }
   * ```
   *
   * If there were no pending changes, the resolve and reject functions are passed no parameters.
   *
   * Returns `false` if a commit operation is already in progress.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when all the Ajax requests complete and have been processed.
   */


  async commit() {
    const me = this,
          {
      changes
    } = me,
          allPromises = []; // not allowing additional commits while in progress
    // TODO: should queue

    if (me.commitPromise) {
      return false;
    } // No outstanding changes, return a Promise that resolves immediately.


    if (!changes) {
      // Special handling of modified. If only non-persistable fields have been modified, it wont count among
      // `changes`, but still needs to be cleared
      if (me.modified.count) {
        me.modified.forEach(record => record.clearChanges(false));
        me.modified.clear();
      }

      return immediatePromise;
    }

    if (me.trigger('beforeCommit', {
      changes
    }) !== false) {
      // Flag all affected records as being committed
      [...changes.added, ...changes.modified, ...changes.removed].forEach(record => record.meta.committing = true); // Commit was not prevented in beforeCommit listener, so we begin the commit

      me.trigger('commitStart', {
        changes
      });
      const commitState = {
        action: 'commit',
        exception: false,
        changes
      };
      let p = me.commitRemoved(commitState);

      if (p) {
        allPromises.push(p);
      }

      p = me.commitAdded(commitState);

      if (p) {
        allPromises.push(p);
      }

      p = me.commitModified(commitState);

      if (p) {
        allPromises.push(p);
      } // If there were no urls configured, behave as a local store


      if (!allPromises.length) {
        me.modified.forEach(r => r.clearChanges(false));
        me.modified.clear();
        me.added.forEach(r => r.clearChanges(false));
        me.added.clear();
        me.removed.clear();
        me.trigger('commit', {
          changes
        });
        return immediatePromise;
      } // The Promises from the commit methods all resolve whether the request
      // succeeded or not. They each contribute their afterrequest event to the
      // commitState which can be used to detect overall success or failure
      // and granular inspection of which operations succeeded or failed.
      // If there's only one operation, wait for it.
      // If there's more than one operation, we have to wait for allPromises to resolve.


      p = allPromises.length === 1 ? allPromises[0] : Promise.all(allPromises);
      return me.commitPromise = new Promise((resolve, reject) => {
        p.then(() => {
          me.commitPromise = null;

          if (commitState.exception) {
            me.trigger('exception', commitState);
            reject(commitState);
          } else {
            me.trigger('commit', {
              changes
            });
            resolve(commitState);
          }
        }).catch(() => {
          me.commitPromise = null;
          reject(commitState);
        });
      });
    }
  } // Performs background autocommit with reject checking


  doAutoCommit() {
    if (this.suspendCount <= 0) {
      this.commit().catch(commitState => {
        const {
          response
        } = commitState; // Skip throw if response is `ok` or `status` is 500 or 404 and request is successfully parsed
        // These errors are notified by API events

        if (!(response && (response.ok && response.parsedJson || [500, 404].includes(response.status)))) {
          throw commitState;
        }
      });
    }
  } // TODO: need a way to abort commits

  /**
   * Commits added records by posting to {@link #config-createUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `add` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforeRequest
   * @fires commitAdded
   * @fires refresh
   * @fires exception
   * @fires afterRequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitAdded(commitState) {
    const me = this,
          added = me.added,
          event = {
      action: 'create',
      params: me.params
    };
    return added.count && me.createUrl ? new Promise(resolve => {
      const toAdd = added.values.map(r => r.persistableData);
      commitState.create = event;
      let dataToSend = event.body = {
        data: toAdd
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(toAdd));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.create;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.createUrl + me.buildQueryString(me.createUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          // Copy updated fields and updated ID back into records.
          // This also calls clearChanges on each record.
          me.processReturnedData(added.values, isArray ? data : data[me.responseDataProperty]); // Clear down added records cache

          added.clear();
          me.trigger('commitAdded'); // We must signal a full refresh because any number of records could have received any number of field updates
          // back from the server, so a refresh is more efficient than picking through the received updates.

          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          added.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          commitState.exceptionType = event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        added.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }
  /**
   * Commits modified records by posting to {@link #config-updateUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `update` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforeRequest
   * @fires commitModified
   * @fires refresh
   * @fires exception
   * @fires afterRequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitModified(commitState) {
    const me = this,
          // Only include persistable changes
    {
      modified
    } = me.changes,
          event = {
      action: 'update',
      params: me.params
    },
          result = modified.length && me.updateUrl ? new Promise(resolve => {
      // Use the record's modificationData, not modifications.
      // modifications returns a map using *field names*
      // The server will expect a map using the original dataSource properties.
      const modifications = modified.map(record => {
        if (me.writeAllFields) {
          return record.persistableData;
        } else {
          return record.modificationDataToWrite;
        }
      }).filter(el => !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEmpty(el)); // Check if modifications are empty and don't make request

      if (modifications.length === 0) {
        me.modified.clear();
        modified.forEach(r => r.meta.committing = false);
        resolve();
        return;
      }

      commitState.update = event;
      let dataToSend = event.body = {
        data: modifications
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(modifications));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.update;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.updateUrl + me.buildQueryString(me.updateUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          // Copy updated fields and updated ID back into records.
          // This also calls clearChanges on each record.
          me.processReturnedData(modified, isArray ? data : data[me.responseDataProperty], true); // Clear down modified records cache

          me.modified.clear();
          me.trigger('commitModified'); // We must signal a full refresh because any number of records could have received any number of field updates
          // back from the server, so a refresh is more efficient than picking through the received updates.

          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          modified.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        modified.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null; // Also clear non-persistable changes

    if (!modified.length && me.modified.count) {
      me.modified.clear();
    }

    return result;
  }

  processReturnedData(localRecords, returnedData, isUpdating = false) {
    const me = this,
          Model = me.modelClass,
          idDataSource = Model.fieldMap.id.dataSource;
    returnedData.forEach((recData, i) => {
      const record = localRecords[i]; // Must clear changed state before syncId goes through store.onModelChange

      record.clearChanges(false); // Using syncId to update record's id with no flagging the property as modified.

      record.syncId(recData[idDataSource]); // When updating, only want to apply the actual changes and not reapply defaults. When adding, also
      // apply the defaults

      Object.assign(localRecords[i].data, Model.processData(recData, isUpdating));
    });
  }
  /**
   * Commits removed records by posting to {@link #config-deleteUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `delete` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforerequest
   * @fires commitremoved
   * @fires refresh
   * @fires exception
   * @fires afterrequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitRemoved(commitState) {
    const me = this,
          removed = me.removed,
          event = {
      action: 'delete',
      params: me.params
    };
    return removed.count && me.deleteUrl ? new Promise(resolve => {
      commitState.delete = event;
      let dataToSend = event.body = {
        ids: removed.map(r => r.id)
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('id', JSON.stringify(dataToSend.ids));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.delete;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.deleteUrl + me.buildQueryString(me.deleteUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          removed.forEach(record => record.meta.committing = false); // In case used by other store etc.

          removed.clear();
          me.trigger('commitRemoved');
          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          removed.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        removed.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }

  get remoteFilter() {
    return Boolean(this.filterParamName || this.restfulFilter);
  }

}
AjaxStore._$name = 'AjaxStore';

/***/ }),

/***/ "./lib/Core/data/DomDataStore.js":
/*!***************************************!*\
  !*** ./lib/Core/data/DomDataStore.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomDataStore; });
var productName = 'gantt';
/**
* @module Core/data/DomDataStore
*/

/**
 * Stores data on a dom element (by setting element._domData).
 * Instead of using HTML5:s element.dataset, which turned out to be slow.
 * @internal
 */

class DomDataStore {
  /**
   * Get data that is connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {String} [key] The name of the property in the element data to return
   * @returns {Object} Data
   */
  static get(element, key) {
    const result = element._domData || (element._domData = {});
    return key != null ? result[key] : result;
  }
  /**
   * Remove data connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {String} key The name of the property in the element data to remove.
   */


  static remove(element, key) {
    const {
      _domData
    } = element,
          was = _domData === null || _domData === void 0 ? void 0 : _domData[key];
    _domData === null || _domData === void 0 ? true : delete _domData[key];
    return was;
  }
  /**
   * Set data connected to specified element (completely replacing any existing).
   * To update data, use DomDataStore#assign instead.
   * @param {HTMLElement} element DOM element
   * @param {Object|String} data Data object to set, or property name to set
   * @param {*} [value] If the previous parameter was a property name, this is the value to set.
   */


  static set(element, data, value) {
    if (arguments.length === 3) {
      (element._domData || (element._domData = {}))[data] = value;
    } else {
      element._domData = data;
    }
  }
  /**
   * Updates data connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {Object} data Data to assign
   */


  static assign(element, data) {
    Object.assign(element._domData || (element._domData = {}), data);
  }

}
DomDataStore._$name = 'DomDataStore';

/***/ }),

/***/ "./lib/Core/data/Duration.js":
/*!***********************************!*\
  !*** ./lib/Core/data/Duration.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Duration; });
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';

/**
 * @module Core/data/Duration
 */

/**
 * Class which represents a duration object.
 * ```javascript
 * {
 *    unit      : String,
 *    magnitude : Number
 * }
 * ```
 */

class Duration {
  /**
   * Duration constructor.
   * @param {Number} magnitude Duration magnitude value
   * @param {String} unit Duration unit value
   */
  constructor(magnitude, unit) {
    if (typeof magnitude === 'number') {
      this._magnitude = magnitude;
      this._unit = unit;
    } else {
      if (typeof magnitude === 'string') {
        magnitude = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(magnitude);
      }

      if (typeof magnitude === 'object') {
        Object.assign(this, magnitude);
      }
    }
  }
  /**
   * Get/Set numeric magnitude `value`.
   * @property {Number}
   */


  get magnitude() {
    return this._magnitude;
  }

  set magnitude(value) {
    this._magnitude = typeof value === 'number' && value;
  }
  /**
   * Get/Set duration unit to use with the current magnitude value.
   * Valid values are:
   * - "millisecond" - Milliseconds
   * - "second" - Seconds
   * - "minute" - Minutes
   * - "hour" - Hours
   * - "day" - Days
   * - "week" - Weeks
   * - "month" - Months
   * - "quarter" - Quarters
   * - "year"- Years
   *
   * @property {String}
   */


  get unit() {
    return this._unit;
  }

  set unit(value) {
    this._unit = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseTimeUnit(value);
  }

  get isValid() {
    return this._magnitude != null && this._unit;
  }
  /**
   * The `milliseconds` property is a read only property which returns the number of milliseconds in this Duration
   * @property {Number}
   * @readonly
   */


  get milliseconds() {
    // There's no smaller time unit in the Date class than milliseconds, so round any divided values
    return this.isValid ? Math.round(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].asMilliseconds(this._magnitude, this._unit)) : 0;
  }
  /**
   * Returns truthy value if this Duration equals the passed value.
   * @param {Core.data.Duration} value
   * @return {Boolean}
   */


  isEqual(value) {
    return Boolean(value && this.milliseconds === value.milliseconds);
  }

  toString(useAbbreviation) {
    const me = this,
          abbreviationFn = useAbbreviation ? 'getShortNameOfUnit' : 'getLocalizedNameOfUnit';
    return me.isValid ? `${me._magnitude} ${_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][abbreviationFn](me._unit, me._magnitude !== 1)}` : '';
  }

  toJSON() {
    return this.toString();
  }

  valueOf() {
    return this.milliseconds;
  }

}
;
Duration._$name = 'Duration';

/***/ }),

/***/ "./lib/Core/data/Model.js":
/*!********************************!*\
  !*** ./lib/Core/data/Model.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Model; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./stm/mixin/ModelStm.js */ "./lib/Core/data/stm/mixin/ModelStm.js");
/* harmony import */ var _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/TreeNode.js */ "./lib/Core/data/mixin/TreeNode.js");
/* harmony import */ var _field_DataField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./field/ArrayDataField.js */ "./lib/Core/data/field/ArrayDataField.js");
/* harmony import */ var _field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony import */ var _field_DateDataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony import */ var _field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony import */ var _field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony import */ var _field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony import */ var _field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony import */ var _field_StringDataField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






 // The built-in model field types:









const {
  defineProperty
} = Reflect,
      {
  hasOwnProperty
} = Object.prototype,
      _undefined = undefined,
      internalProps = {
  children: 1,
  data: 1,
  meta: 1
},
      abbreviationFields = ['name', 'title', 'text', 'label', 'description'],
      fieldDataTypes = {
  boolean: 1,
  number: 1,
  date: 1,
  object: 1
};
/**
 * @module Core/data/Model
 */

/**
 * A Model is the definition of a record which can be added to (or loaded into) a {@link Core.data.Store}. It defines
 * which fields the data contains and exposes an interface to access and manipulate that data. The Model data is
 * populated through simple a JSON object.
 *
 * By default a Model stores a shallow copy of its raw json, but for records in stores configured with
 * `useRawData: true` it stores the supplied json object as is.
 *
 * ## Defining fields
 *
 * A Model can either define its fields explicitly (see {@link #property-fields-static}) or have them created from its
 * data (see {@link #property-autoExposeFields-static}). This snippet shows a model with 4 fields defined explicitly:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'shoeSize', type : 'number', defaultValue : 11 },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 *
 * The first field (name) has an unspecified type, which means the field's value is held as received with no conversion
 * applied. The second field (birthday) is defined to be a date, which will make the model parse any supplied value into
 * an actual date. The parsing is handled by {@link Core/helper/DateHelper#function-parse-static DateHelper.parse()}
 * using the specified `format`, or if no format is specified using
 * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}.
 *
 * The set of standard field types is as follows:
 *
 *  - {@link Core.data.field.BooleanDataField `boolean`}
 *  - {@link Core.data.field.DateDataField `date`}
 *  - {@link Core.data.field.IntegerDataField `integer`}
 *  - {@link Core.data.field.ObjectDataField `object`}
 *  - {@link Core.data.field.NumberDataField `number`}
 *  - {@link Core.data.field.StringDataField `string`}
 *
 * You can also set a `defaultValue` that will be used if the data does not contain a value for the field:
 *
 * ```javascript
 * { name : 'shoeSize', type : 'number', defaultValue : 11 }
 * ```
 *
 * To create a record from a Model, supply data to its constructor:
 *
 * ```javascript
 * let guy = new Person({
 *     id       : 1,
 *     name     : 'Dude',
 *     birthday : '2014-09-01'
 * });
 * ```
 *
 * If no id is specified, a temporary id will be generated.
 *
 * Please avoid using reserved names for your fields (such as `parent`, `children` and others that are used as Model
 * properties) to avoid possible data collisions and bugs.
 *
 * ## Nested fields
 *
 * Model supports mapping fields to nested data structures using dot `.` separated paths as the `dataSource`. For
 * example given this JSON object:
 *
 * ```json
 * {
 *     name : 'Borje Salming',
 *     team : {
 *         name   : 'Toronto Maple Leafs',
 *         league : 'NHL
 *     }
 * }
 * ```
 *
 * A field can be mapped to the nested team name by using `dataSource : 'team.name'`:
 *
 * ```javascript
 * class Player extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             // Field mapped to a property on a nested object
 *             { name : 'teamName', dataSource : 'team.name' }
 *         ]
 *     }
 * }
 * ```
 *
 * Usage:
 *
 * ```javascript
 * const player = new Player(json);
 *
 * console.log(player.teamName); // > Toronto Maple Leafs
 * player.teamName = 'Detroit Red Wings'; // The name property of the team object is updated
 * ```
 *
 * ### Updating a nested object
 *
 * Note that directly altering a property of the nested object wont register as an update of the record, record does not
 * track changes deeply. If nested fields (as described above) is not enough for your usecase you can map a field
 * directly to the nested object and then assign a shallow copy of it to the record on changes:
 *
 * ```javascript
 * class Player extends Model {
 *     static get fields() {
 *         return [
 *             ...,
 *             // Field mapped directly to the nested object
 *             { name : 'team', type : 'object' }
 *         ]
 *     }
 * }
 *
 * // "External object" to nest
 * const team = {
 *     name   : 'Brynas',
 *     league : 'SHL'
 * }
 *
 * const player = new Player({
 *     name : 'Borje Salming',
 *     team
 * });
 *
 * // This will not flag player as dirty
 * team.league = 'CHL';
 *
 * // Instead you have to reassign the mapped field
 * player.team = { ...player.team };
 * ```
 *
 * ## Persisting fields
 *
 * By default all fields are persisted. If you don't want particular field to get saved to the server, configure it with
 * `persist: false`. In this case field will not be among changes which are sent by
 * {@link Core/data/AjaxStore#function-commit store.commit()}, otherwise its behavior doesn't change.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false }
 *         ];
 *     }
 * }
 * ```
 *
 * ## The `idField`
 * By default Model expects its id to be stored in a field named "id". The name of the field can be customized by
 * setting {@link #property-idField-static}:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false },
 *             { name : 'personId' },
 *             { name : 'birthday', type : 'date' }
 *         ];
 *     }
 * }
 *
 * // Id drawn from 'id' property by default; use custom field here
 * Person.idField = 'personId';
 *
 * let girl = new Person({
 *     personId : 2,
 *     name     : 'Lady',
 *     birthday : '2011-11-05'
 * });
 * ```
 *
 * ## Getting and setting values
 *
 * Fields are used to generate getters and setters on the records. Use them to access or modify values (they are
 * reactive):
 *
 * ```javascript
 * console.log(guy.name);
 * girl.birthday = new Date(2011,10,6);
 * ```
 *
 * NOTE: In an application with multiple different models you should subclass Model, since the prototype is decorated
 * with getters and setters. Otherwise you might get unforeseen collisions.
 *
 * ## Field data mapping
 *
 * By default fields are mapped to data using their name. If you for example have a "name" field it expects data to be
 * `{ name: 'Some name' }`. If you need to map it to some other property, specify `dataSource` in your field definition:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields {
 *         return [
 *             { name : 'name', dataSource : 'TheName' }
 *         ];
 *     }
 * }
 *
 * // This is now OK:
 * let dude = new Person({ TheName : 'Manfred' });
 * console.log(dude.name); // --> Manfred
 * ```
 * ## Field inheritance
 *
 * Fields declared in a derived model class are added to those from its superclass. If a field declared by a derived
 * class has also been declared by its super class, the field properties of the super class are merged with those of
 * the derived class.
 *
 * For example:
 * ```javascript
 *  class Person extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' }
 *          ];
 *      }
 *  }
 *
 *  class User extends Person {
 *      static get fields() {
 *          return [
 *              { name : 'birthday', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 *
 * In the above, the `Person` model declares the `birthday` field as a `date` with a specified `format`. The `User`
 * model extends `Person` and also declares the `birthday` field. This redeclared field only specifies `dataSource`, so
 * all of the other fields are preserved from `Person`. The `User` model also adds a `lastLogin` field.
 *
 * The `User` from above could have been declared like so to achieve the same `fields`:
 *
 * ```javascript
 *  class User extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 *
 * ## Override default values
 *
 * In case you need to define default value for a specific field, or override an existing default value, you can
 * define a new or re-define an existing field definition in {@link #property-fields-static} static getter:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'New person' },
 *             { name : 'birthdate', type : 'date' }
 *         ];
 *     }
 * }
 *
 * class Bot extends Person {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'Bot' } // default value of 'username' field is overridden
 *         ];
 *     }
 * }
 * ```
 *
 * ## Tree API
 *
 * This class mixes in the {@link Core/data/mixin/TreeNode TreeNode} mixin which provides an API for tree related
 * functionality (only relevant if your store is configured to be a {@link Core/data/Store#config-tree tree}).
 *
 * @mixes Core/data/mixin/TreeNode
 * @mixes Core/data/stm/mixin/ModelStm
 */

class Model extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  static get $name() {
    return 'Model';
  }

  static get declarable() {
    return [
    /**
     * Array of defined fields for this model class. Subclasses add new fields by implementing this static
     * getter:
     *
     * ```javascript
     * // Model defining two fields
     * class Person extends Model {
     *     static get fields() {
     *         return [
     *             { name : 'username', defaultValue : 'New person' },
     *             { name : 'birthdate', type : 'date' }
     *         ];
     *     }
     * }
     *
     * // Subclass overriding one of the fields
     * class Bot extends Person {
     *     static get fields() {
     *         return [
     *             // Default value of 'username' field is overridden, any other setting from the parents
     *             // definition is preserved
     *             { name : 'username', defaultValue : 'Bot' }
     *         ];
     *     }
     * }
     * ```
     *
     * Fields in a subclass are merged with those from the parent class, making it easy to override mappings,
     * formats etc.
     *
     * @member {String[]|Object[]|Core.data.field.DataField[]} fields
     * @readonly
     * @static
     * @category Fields
     */
    'fields'];
  }

  static get fields() {
    return [// The index of this item in its parent (respects filtering)
    {
      name: 'parentIndex',
      type: 'number',
      persist: false,
      internal: true
    }];
  }
  /**
   * Template static getter which is supposed to be overridden to define default field values for the Model class.
   * Overrides `defaultValue` config specified by the {@link #property-fields-static} getter.
   * Returns a named object where key is a field name and value is a default value for the field.
   *
   * NOTE: This is a legacy way of defining default values, we recommend using {@link #property-fields-static} moving
   * forward.
   *
   * ```javascript
   * class Person extends Model {
   *     static get fields() {
   *         return [
   *             { name : 'username', defaultValue : 'New person' }
   *         ];
   *     }
   * }
   *
   * class Bot extends Person {
   *     static get defaults() {
   *         return {
   *             username : 'Bot' // default value of 'username' field is overridden
   *         };
   *     }
   * }
   * ```
   *
   * @member {Object} defaults
   * @static
   * @category Fields
   */
  // TODO: deprecate in 5.0 in favor of static fields getter
  // static get defaults() {
  //     return {};
  // }

  /**
   * The name of the data field which provides the ID of instances of this Model.
   * @property {String}
   * @category Fields
   */


  static set idField(idField) {
    this._assignedIdField = true;
    this._idField = idField;
  }

  static get idField() {
    return this._idField;
  }
  /**
   * The name of the data field which holds children of this Model when used in a tree structure
   * ```javascript
   * MyModel.childrenField = 'kids';
   * const parent = new MyModel({
   *     name : 'Dad',
   *     kids : [
   *         { name : 'Daughter' },
   *         { name : 'Son' }
   *     ]
   * });
   * ```
   * @property {String}
   * @category Fields
   */


  static set childrenField(childrenField) {
    this._childrenField = childrenField;
  }

  static get childrenField() {
    if (!this._childrenField) {
      const dataField = this.fieldMap.children;
      this._childrenField = (dataField === null || dataField === void 0 ? void 0 : dataField.dataSource) || 'children';
    }

    return this._childrenField;
  }
  /**
   * Returns index path to this node. This is the index of each node in the node path
   * starting from the topmost parent. (only relevant when its part of a tree store).
   * @returns {Number[]} The index of each node in the path from the topmost parent to this node.
   * @category Parent & children
   * @private
   */


  get indexPath() {
    const indices = [];
    let node = this,
        depth = node.childLevel;

    for (node = this; node && !node.isRoot; node = node.parent) {
      indices[depth--] = node.parentIndex + 1;
    }

    return indices;
  }
  /**
   * Unique identifier for the record. Might be mapped to another dataSource using idField, but always exposed as
   * record.id. Will get a generated value if none is specified in records data.
   * @field {String|Number} id
   * @category Identification
   */
  //region Init

  /**
   * Constructs a new record from the supplied data.
   * @param {Object} [data] Raw data
   * @param {Core.data.Store} [store] Data store
   * @param {Object} [meta] Meta data
   * @privateparam {Boolean} [skipExpose] Skip exposing properties from data
   * @privateparam {Boolean} [forceUseRaw] Force using raw data, used by copy to not clone data twice
   * @function constructor
   * @category Lifecycle
   */


  construct(data = {}, store = null, meta = null, skipExpose = false, forceUseRaw = false) {
    const me = this,
          stores = store ? Array.isArray(store) ? store : [store] : [],
          {
      constructor,
      fieldMap
    } = me; // null passed to Base construct inhibits config processing.

    let configs = null;
    store = stores[0];
    me.meta = _objectSpread(_objectSpread({
      modified: {}
    }, constructor.metaConfig), meta); // Should apply configs?

    if (constructor.applyConfigs) {
      // Extract from data and combine with defaultConfigs
      for (const key in me.getDefaultConfiguration()) {
        if (!configs) {
          // if (first config)
          configs = {};

          if (!me.useRawData || !me.useRawData.enabled) {
            // Shallow copy of data to not mutate incoming object
            data = _objectSpread({}, data);
          }
        } // loop through configs excluding fields


        if (key in data) {
          // Use as config
          configs[key] = data[key]; // Remove from data

          delete data[key];
        }
      }
    }

    super.construct(configs); // make getters/setters for fields, needs to be done before processing data to make sure defaults are available

    if (!skipExpose) {
      constructor.exposeProperties(data);
    } // It's only valid to do this once, on construction of the first instance


    if (!hasOwnProperty.call(constructor, 'idFieldProcessed')) {
      // idField can be overridden from meta, or from the store if we have not had an idField set programmatically
      // and if we have not had an id field defined above the base Model class level.
      let overriddenIdField = me.meta.idField;

      if (!overriddenIdField) {
        // Might have been set to Model after construction but before load
        if (constructor._assignedIdField) {
          overriddenIdField = constructor.idField;
        } // idField on store was deprecated, but should still work to not break code
        // TODO: Remove in 3.0? Or reintroduce it...
        else if (store) {
          overriddenIdField = store.idField;
        }
      } // If it's overridden to something different than we already have, replace the 'id' field in the fieldMap


      if (overriddenIdField && overriddenIdField !== fieldMap.id.dataSource) {
        constructor.addField({
          name: 'id',
          dataSource: overriddenIdField,
          internal: true
        });
      }

      constructor.idFieldProcessed = true;
    } // assign internalId, unique among all records


    me._internalId = Model._internalIdCounter++; // relation code expects store to be available for relation lookup, but actual join done below

    me.stores = [];
    me.unjoinedStores = []; // Superclass constructors may set this in their own way before this is called.

    if (!me.originalData) {
      me.originalData = data;
    }

    me.data = constructor.processData(data, false, store, me, forceUseRaw); // Consider undefined and null as missing id and generate one

    if (me.id == null) {
      // Assign a generated id silently, record should not be considered modified
      me.setData('id', me.generateId(store));
    }

    if (me.data[constructor.childrenField]) {
      me.processChildren(stores);
    }

    me.generation = 0;
  }
  /**
   * Set this property to `true` when adding a record on a conditional basis, that is, it is yet
   * to be confirmed as an addition.
   *
   * When this is set, the {@link #property-isPersistable} value of the record is **false**, and upon being
   * added to a Store it will *not* be eligible to be synced with the server as an added record.
   *
   * Subsequently *clearing* this property means this record will become persistable and eligible
   * for syncing as an added record.
   * @property {Boolean}
   */


  set isCreating(isCreating) {
    const me = this; // A no-change must not have any effect.

    if (Boolean(me.meta.isCreating) !== isCreating) {
      // This flag contributes to the evaluation of isPersistable.
      // A record is not persistable if it isCreating.
      me.meta.isCreating = isCreating; // Owning Stores may have things to do at this lifecycle point

      me.stores.forEach(s => {
        s.onIsCreatingToggle(me, isCreating);
      });
    }
  }

  get isCreating() {
    return Boolean(this.meta.isCreating);
  }
  /**
   * Compares this Model instance to the passed instance. If they are of the same type, and all fields
   * (except, obviously, `id`) are equal, this returns `true`.
   * @param {Core.data.Model} other The record to compare this record with.
   * @returns {Boolean} `true` if the other is of the same class and has all fields equal.
   */


  equals(other) {
    if (other instanceof this.constructor) {
      for (let fields = this.$meta.fields.defs, i = 0, {
        length
      } = fields; i < length; i++) {
        const field = fields[i],
              {
          name
        } = field;

        if (name !== 'id' && !field.isEqual(this[name], other[name])) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  get subclass() {
    return new this.constructor(Object.setPrototypeOf({
      id: _undefined
    }, this.data), this.stores[0], null, true);
  }
  /**
   * Processes raw data, converting values and setting defaults.
   * @private
   * @param {Object} data Raw data
   * @param {Boolean} [ignoreDefaults] Ignore setting default values, used when updating
   * @returns {Object} Processed data
   * @category Fields
   */


  static processData(data, ignoreDefaults = false, store, record, forceUseRaw) {
    const {
      fieldMap,
      defaultValues
    } = this,
          {
      useRawData = {
        enabled: false
      }
    } = store || {},
          // Store configured with useRawData uses the supplied data object, polluting it. When not configured with
    // useRawData it instead makes a copy (intentionally deep, in case data has a prototype chain or contains
    // arrays or objects)
    processed = forceUseRaw || useRawData.enabled ? data : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(data);
    let fieldName;
    ignoreDefaults = ignoreDefaults || useRawData.disableDefaultValue || forceUseRaw;

    if (!ignoreDefaults) {
      for (fieldName in defaultValues) {
        if (processed[fieldName] === _undefined) {
          let defaultValue = defaultValues[fieldName]; // Avoid sharing arrays across instances

          if (Array.isArray(defaultValue)) {
            defaultValue = defaultValue.slice();
          }

          processed[fieldName] = defaultValue;
        }
      }
    }

    if (!useRawData.disableTypeConversion && !forceUseRaw) {
      // Convert field types which need converting
      for (fieldName in fieldMap) {
        const field = fieldMap[fieldName],
              {
          name,
          dataSource
        } = field,
              // Value might have been supplied either using mapped dataSource (when loading JSON etc. for example
        // event.myStartDate) or as field name (from internal code, for example event.startDate). If [name]
        // exists but not [dataSource], use it.
        hasSource = dataSource !== name,
              complex = field.complexMapping,
              sourceExists = hasSource && (complex ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].pathExists(data, dataSource) : dataSource in data),
              useNameForValue = name in data && (!hasSource || !sourceExists),
              convert = !useRawData.disableTypeConversion && field.convert; // Only action field definitions which have a convert function or remap data

        if (useNameForValue || convert) {
          // When ignoringDefaults, do not convert unspecified values
          if (!ignoreDefaults || useNameForValue || sourceExists) {
            const value = useNameForValue ? processed[name] : complex ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(processed, dataSource) : processed[dataSource],
                  converted = convert ? field.convert(value, record) : value;

            if (complex) {
              _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(processed, dataSource, converted);
            } else {
              processed[dataSource] = converted;
            } // Remove [startDate] from internal data holder, only keeping [myStartDate]


            if (hasSource) {
              delete processed[name];
            }
          }
        }
      }
    }

    return processed;
  }

  static setupClass(meta) {
    super.setupClass(meta);

    if (!meta.fields) {
      // Normally setupFields will only run when a Model defines a fields getter, but we want to always run it:
      this.setupFields(this, meta);
    }
  }

  static setupFields(cls, meta) {
    var _base$defs$slice, _base$exposed, _base$ordinals, _base$map, _base$sources;

    const classFields = hasOwnProperty.call(cls, 'fields') && cls.fields,
          base = meta.super.fields,
          fieldsInfo = meta.fields = {
      defs: (_base$defs$slice = base === null || base === void 0 ? void 0 : base.defs.slice()) !== null && _base$defs$slice !== void 0 ? _base$defs$slice : [],
      // Set to true when an instance's data object is run through exposeProperties
      exposedData: false,
      // These objects are all keyed by field name:
      defaults: base ? _objectSpread({}, base.defaults) : {},
      // value=field.defaultValue
      exposed: Object.create((_base$exposed = base === null || base === void 0 ? void 0 : base.exposed) !== null && _base$exposed !== void 0 ? _base$exposed : null),
      // value=true if we've done defineProperty
      ordinals: Object.create((_base$ordinals = base === null || base === void 0 ? void 0 : base.ordinals) !== null && _base$ordinals !== void 0 ? _base$ordinals : null),
      // value=index in the defs array
      map: Object.create((_base$map = base === null || base === void 0 ? void 0 : base.map) !== null && _base$map !== void 0 ? _base$map : null),
      // value=definition object
      sources: Object.create((_base$sources = base === null || base === void 0 ? void 0 : base.sources) !== null && _base$sources !== void 0 ? _base$sources : null) // value=source definition object

    }; // We use Object.create(null) as the base for these maps because some models declare "constructor" as a field
    // NOTE: instead of chaining the defaults, we copy them so the defaults object can be used with Object.assign
    // in other contexts (since it does not copy inherited properties from the prototype chain)
    // Clone the superclass's defaults, and override that with our own defaults.
    // As we find fields with a defaultValue, more defaults may be added

    if (hasOwnProperty.call(cls, 'defaults')) {
      Object.assign(fieldsInfo.defaults, cls.defaults);
    } // Hook up our field maps with the class hierarchy's fieldMaps.
    // We need to be able to look up field definitions by the name, or by the dataSource property name
    // If the idField is overridden at this level, create a new field


    if (hasOwnProperty.call(cls, 'idField')) {
      cls.addField({
        name: 'id',
        dataSource: cls.idField,
        internal: true
      });
      fieldsInfo.exposed[cls.idField] = true;
    } // Process fields defined in the class definition


    if (classFields !== null && classFields !== void 0 && classFields.length) {
      classFields.map(cls.addField, cls);
    }

    cls.exposeRelations();
  }

  static get defaultValues() {
    return this.$meta.fields.defaults;
  }
  /**
   * An array containing all the _defined_ fields for this Model class. This will include all superclass's
   * defined fields.
   * @property {Core.data.field.DataField[]}
   * @static
   * @readonly
   * @category Fields
   */


  static get allFields() {
    return this.$meta.fields.defs;
  }
  /**
   * Same as {@link #property-allFields-static}.
   * @property {Core.data.field.DataField[]}
   * @readonly
   * @category Fields
   */


  get allFields() {
    return this.$meta.fields.defs;
  }
  /**
   * An object containing all the _defined_ fields for this Model class. This will include all superclass's
   * defined fields through its prototype chain. So be aware that `Object.keys` and `Object.entries` will only
   * access this class's defined fields.
   * @property {Object}
   * @static
   * @readonly
   * @category Fields
   */


  static get fieldMap() {
    return this.$meta.fields.map;
  }
  /**
   * Same as {@link #property-fieldMap-static}.
   * @property {Object}
   * @readonly
   * @category Fields
   */


  get fieldMap() {
    return this.$meta.fields.map;
  }

  static get fieldDataSourceMap() {
    return this.$meta.fields.sources;
  }
  /**
   * Makes getters and setters for fields (from definitions and data). Called once when class is defined and once when
   * data is loaded first time.
   * @internal
   * @param {Object} [data] Raw data
   * @category Fields
   */


  static exposeProperties(data) {
    const me = this,
          fieldsInfo = me.$meta.fields; // Process the raw data properties and expose them as fields unless the property name
    // has already been used by the "dataSource" of a defined field.

    if (data && me.autoExposeFields && !fieldsInfo.exposedData) {
      let dataProperty, fieldDef, type;

      for (dataProperty in data) {
        // We need to skip children field because it can be `true` and that would create boolean field.
        // See https://github.com/bryntum/support/issues/2705
        if (!fieldsInfo.exposed[dataProperty] && dataProperty !== me.childrenField) {
          type = Object(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["typeOf"])(data[dataProperty]); // Create a field definition in our fieldMap with the flag that it's from data

          fieldDef = {
            name: dataProperty,
            dataSource: dataProperty,
            fromData: true
          };

          if (fieldDataTypes[type]) {
            fieldDef.type = type;
          }

          me.addField(fieldDef);
        }
      }

      fieldsInfo.exposedData = true;
    }

    me.exposeRelations();
  }
  /**
   * Add a field definition in addition to those predefined in `fields`.
   * @param {String|Object} fieldDef A field name or definition
   * @category Fields
   */


  static addField(fieldDef) {
    if (fieldDef == null) {
      return;
    }

    if (typeof fieldDef === 'string') {
      fieldDef = {
        name: fieldDef
      };
    }

    const me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          {
      ordinals
    } = fieldsInfo,
          propertiesExposed = fieldsInfo.exposed,
          {
      name
    } = fieldDef,
          existing = fieldsInfo.map[name],
          dataSource = fieldDef.dataSource || (fieldDef.dataSource = name);
    let field, key;

    if (!existing || fieldDef.type && fieldDef.type !== existing.type) {
      field = _field_DataField_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(fieldDef);
      field.definedBy = existing ? existing.definedBy : me;
      field.ordinal = existing ? existing.ordinal : ordinals[name] = fieldsInfo.defs.length;
    } else {
      field = Object.create(existing);

      for (key in fieldDef) {
        if (key !== 'type') {
          field[key] = fieldDef[key];
        }
      }
    }

    field.owner = me;
    fieldsInfo.defs[field.ordinal] = field;
    fieldsInfo.map[name] = field;

    if (!fieldsInfo.sources[dataSource]) {
      fieldsInfo.sources[dataSource] = field;
    } // With complex mapping avoid exposing object as model field


    if (dataSource.includes('.')) {
      field.complexMapping = true;
    }

    if (field.complexMapping) {
      // model fields have this set on their prototype...
      propertiesExposed[dataSource.split('.')[0]] = true;
    } else {
      // When iterating through the raw data, if autoExposeFields is set
      // We do not need to create properties for raw property names we've processed here
      propertiesExposed[dataSource] = true;
    } // Maintain an object of defaultValues for fields.


    if ('defaultValue' in field) {
      fieldsInfo.defaults[dataSource] = field.defaultValue;
    } // Create a property on this Model's prototype, named for the defined field name
    // which reads the correct property out of the raw data object.


    if (!internalProps[name]) {
      // Either creates a new accessor or redefines an existing
      field.defineAccessor(me.prototype);
    }

    me._nonPersistableFields = null;
    me._alwaysWriteFields = null;
    return field;
  }
  /**
   * Remove a field definition by name.
   * @param {String} fieldName Field name
   * @category Fields
   */


  static removeField(fieldName) {
    const me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          definition = fieldsInfo.map[fieldName],
          {
      ordinals
    } = fieldsInfo,
          index = ordinals[fieldName];

    if (definition) {
      fieldsInfo.defs.splice(index, 1);
      delete ordinals[fieldName];
      delete fieldsInfo.defaults[fieldName];
      delete fieldsInfo.exposed[fieldName];
      delete fieldsInfo.map[fieldName];
      delete fieldsInfo.sources[definition.dataSource];

      for (const name in ordinals) {
        if (ordinals[name] > index) {
          --ordinals[name];
        }
      } // Note: if field was exposed by superclass, this won't do anything...


      delete me.prototype[fieldName];
    }
  }
  /**
   * Makes getters and setters for related records. Populates a Model#relation array with the relations, to allow it
   * to be modified later when assigning stores.
   * @internal
   * @category Relations
   */


  static exposeRelations() {
    const me = this;

    if (hasOwnProperty.call(me, 'relationsExposed')) {
      return;
    }

    if (me.relationConfig) {
      me.relationsExposed = true;
      me.relations = [];
      me.relationConfig.forEach(relation => {
        me.relations.push(relation);
        const name = relation.relationName; // getter and setter for related object

        if (!Reflect.ownKeys(me.prototype).includes(name)) {
          defineProperty(me.prototype, name, {
            enumerable: true,
            get: function () {
              // noinspection JSPotentiallyInvalidUsageOfClassThis
              return this.getForeign(name);
            },
            set: function (value) {
              // noinspection JSPotentiallyInvalidUsageOfClassThis
              this.setForeign(name, value, relation);
            }
          });
        }
      });
    }
  } //endregion
  //region Fields

  /**
   * Flag checked from Store when loading data that determines if fields found in first records should be exposed in
   * same way as predefined fields.
   * @property {Boolean}
   * @category Fields
   */


  static get autoExposeFields() {
    return true;
  }
  /**
   * Convenience getter to get field definitions from class.
   * @property {Core.data.field.DataField[]}
   * @readonly
   * @category Fields
   */


  get fields() {
    return this.$meta.fields.defs;
  }
  /**
   * Convenience function to get the definition for a field from class.
   * @param {String} fieldName Field name
   * @returns {Core.data.field.DataField}
   * @category Fields
   */


  getFieldDefinition(fieldName) {
    return this.$meta.fields.map[fieldName];
  }

  getFieldDefinitionFromDataSource(dataSource) {
    return this.$meta.fields.sources[dataSource];
  }
  /**
   * Get the names of all fields in data.
   * @property {String[]}
   * @readonly
   * @category Fields
   */


  get fieldNames() {
    return Object.keys(this.data);
  }
  /**
   * Get the definition for a field by name. Caches results.
   * @param {String} fieldName Field name
   * @returns {Core.data.field.DataField} Field definition or null if none found
   * @category Fields
   */


  static getFieldDefinition(fieldName) {
    return this.$meta.fields.map[fieldName];
  }
  /**
   * Returns dataSource configuration for a given field name
   * @param {String} fieldName
   * @returns {String} Field `dataSource` mapping
   * @internal
   */


  static getFieldDataSource(fieldName) {
    return this.getFieldDefinition(fieldName).dataSource;
  }
  /**
   * Get the data source used by specified field. Returns the fieldName if no data source specified.
   * @param {String} fieldName Field name
   * @returns {String}
   * @category Fields
   */


  getDataSource(fieldName) {
    const def = this.constructor.getFieldDefinition(fieldName);
    return (def === null || def === void 0 ? void 0 : def.dataSource) || (def === null || def === void 0 ? void 0 : def.name);
  }
  /**
   * Processes input to a field, converting to expected type.
   * @param {String} fieldName Field dataSource
   * @param {*} value Value to process
   * @returns {*} Converted value
   * @category Fields
   */


  static processField(fieldName, value, record) {
    const field = this.fieldMap[fieldName];
    return field !== null && field !== void 0 && field.convert ? field.convert(value, record) : value;
  } //endregion
  //region Relations

  /**
   * Initializes model relations. Called from store when adding a record.
   * @private
   * @category Relations
   */


  initRelations() {
    const me = this,
          relations = me.constructor.relations;
    if (!relations) return; // TODO: feels strange to have to look at the store for relation config but didn't figure out anything better.
    // TODO: because other option would be to store it on each model instance, not better...

    me.stores.forEach(store => {
      var _store$modelRelations;

      if (!store.modelRelations) {
        store.initRelations();
      } // TODO: not at all tested for multiple stores, can't imagine it works as is


      const relatedRecords = [];
      (_store$modelRelations = store.modelRelations) === null || _store$modelRelations === void 0 ? void 0 : _store$modelRelations.forEach(config => {
        relatedRecords.push({
          related: me.initRelation(config),
          config
        });
      });
      store.updateRecordRelationCache(me, relatedRecords);
    });
  }
  /**
   * Initializes/updates a single relation.
   * @param config Relation config
   * @returns {Core.data.Model} Related record
   * @private
   * @category Relations
   */


  initRelation(config) {
    const me = this,
          keyValue = me.get(config.fieldName),
          foreign = keyValue !== _undefined && typeof config.store !== 'string' && config.store.getById(keyValue),
          placeHolder = {
      id: keyValue,
      placeHolder: true
    };

    if (!me.meta.relationCache) {
      me.meta.relationCache = {};
    } // apparently scheduler tests expect cache to work without matched related record, thus the placeholder


    me.meta.relationCache[config.relationName] = foreign || (keyValue != null ? placeHolder : null);
    return foreign;
  }

  removeRelation(config) {
    // (have to check for existence before deleting to work in Safari)
    if (this.meta.relationCache[config.relationName]) {
      delete this.meta.relationCache[config.relationName];

      if (config.nullFieldOnRemove) {
        // Setting to null silently, to not trigger additional relation behaviour
        this.setData(config.fieldName, null);
      }
    }
  }

  getForeign(name) {
    var _this$meta$relationCa;

    return (_this$meta$relationCa = this.meta.relationCache) === null || _this$meta$relationCa === void 0 ? void 0 : _this$meta$relationCa[name];
  }

  setForeign(name, value, config) {
    const id = Model.asId(value);
    return this.set(config.fieldName, id);
  } //endregion
  //region Get/set values, data handling


  flatGet(fieldName, dataSource) {
    var _this$data$dataSource;

    // NOTE: There is an inlined copy of this fn in DataField, when changing here make sure it is updated too
    // When changes are batched, they get stored by field name, not dataSource
    if (this.batching && fieldName in this.meta.batchChanges) {
      return this.meta.batchChanges[fieldName];
    }

    return (_this$data$dataSource = this.data[dataSource]) !== null && _this$data$dataSource !== void 0 ? _this$data$dataSource : this.data[fieldName];
  }

  complexGet(fieldName, dataSource) {
    // When changes are batched, they get stored by field name, not dataSource
    if (this.batching && fieldName in this.meta.batchChanges) {
      return this.meta.batchChanges[fieldName];
    }

    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this.data, dataSource);
  }
  /**
   * Get value for specified field name. You can also use the generated getters if loading through a Store.
   * If model is currently in batch operation this will return updated batch values which are not applied to Model
   * until endBatch() is called.
   * @param {String} fieldName Field name to get value from
   * @returns {*} Fields value
   * @category Fields
   */


  get(fieldName) {
    if (!fieldName) {
      return;
    }

    const field = this.fieldMap[fieldName]; // Getting property of nested record?

    if (!field && fieldName.includes('.')) {
      return this.complexGet(fieldName, fieldName);
    }

    if (field !== null && field !== void 0 && field.complexMapping) {
      return this.complexGet(fieldName, field.dataSource);
    }

    return this.flatGet(fieldName, (field === null || field === void 0 ? void 0 : field.dataSource) || fieldName);
  }
  /**
   * Internal function used to update a records underlying data block (record.data) while still respecting field
   * mappings. Needed in cases where a field needs setting without triggering any associated behaviour and it has a
   * dataSource with a different name.
   *
   * For example:
   * ```javascript
   * // startDate mapped to data.beginDate
   * { name : 'startDate', dataSource : 'beginDate' }
   *
   * // Some parts of our code needs to update the data block without triggering any of the behaviour associated with
   * // calling set. This would then not update "beginDate":
   * record.data.startDate = xx;
   *
   * // But this would
   * record.setData('startDate', xx);
   * ```
   * @internal
   * @category Editing
   */


  setData(toSet, value) {
    const {
      data,
      fieldMap
    } = this; // Two separate paths for performance reasons
    // setData('name', 'Quicksilver');

    if (typeof toSet === 'string') {
      var _field$dataSource;

      const field = fieldMap[toSet],
            dataSource = (_field$dataSource = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource !== void 0 ? _field$dataSource : toSet;

      if (field !== null && field !== void 0 && field.complexMapping) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, dataSource, value);
      } else {
        data[dataSource] = value;
      }
    } // setData({ name : 'Magneto', power : 'Magnetism' });
    else {
      const keys = Object.keys(toSet);

      for (let i = 0; i < keys.length; i++) {
        var _field$dataSource2;

        const fieldName = keys[i],
              field = fieldMap[fieldName],
              dataSource = (_field$dataSource2 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource2 !== void 0 ? _field$dataSource2 : fieldName;

        if (dataSource) {
          if (field !== null && field !== void 0 && field.complexMapping) {
            _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, dataSource, toSet[fieldName]);
          } else {
            data[dataSource] = toSet[fieldName];
          }
        }
      }
    }
  }
  /**
   * Returns raw data from the encapsulated data object for the passed field name
   * @param {String} fieldName The field to get data for.
   * @returns {*} The raw data value for the field.
   */


  getData(fieldName) {
    var _field$dataSource3;

    const field = this.fieldMap[fieldName],
          dataSource = (_field$dataSource3 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource3 !== void 0 ? _field$dataSource3 : fieldName;

    if (dataSource) {
      if (field !== null && field !== void 0 && field.complexMapping) {
        return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this.data, dataSource);
      }

      return this.data[dataSource];
    }
  }
  /**
   * Silently updates record's id with no flagging the property as modified.
   * Triggers onModelChange event for changed id.
   * @param {String|Number} value id value
   * @private
   */


  syncId(value) {
    const oldValue = this.id;

    if (oldValue !== value) {
      this.setData('id', value);
      const data = {
        id: {
          value,
          oldValue
        }
      };
      this.afterChange(data, data);
    }
  }
  /**
   * Set value for the specified field. You can also use the generated setters if loading through a Store.
   *
   * Setting a single field, supplying name and value:
   *
   * ```javascript
   * record.set('name', 'Clark');
   * ```
   *
   * Setting multiple fields, supplying an object:
   *
   * ```javascript
   * record.set({
   *     name : 'Clark',
   *     city : 'Metropolis'
   * });
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} [value] Value to set
   * @param {Boolean} [silent] Set to true to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @fires Store#idChange
   * @fires Store#update
   * @fires Store#change
   * @category Editing
   */


  set(field, value, silent = false, fromRelationUpdate = false, skipAccessors = false) {
    const me = this; // We use beforeSet/inSet/afterSet approach here because mixin interested in overriding set() method
    // like STM, for example, might be mixed before Model class or after. In general I have no control over this.
    // STM mixed before, so the only option to wrap set() method body is actually to call
    // beforeSet()/afterSet().

    if (me.isBatchUpdating) {
      me.inBatchSet(field, value, silent || me.$silenceBatch);
      return null;
    } else {
      var _me$afterSet;

      const preResult = me.beforeSet ? me.beforeSet(field, value, silent, fromRelationUpdate) : _undefined,
            wasSet = me.inSet(field, value, silent, fromRelationUpdate, skipAccessors);
      (_me$afterSet = me.afterSet) === null || _me$afterSet === void 0 ? void 0 : _me$afterSet.call(me, field, value, silent, fromRelationUpdate, preResult, wasSet);
      return wasSet;
    }
  }

  fieldToKeys(field, value) {
    if (typeof field !== 'string') {
      // will get in trouble when setting same field on multiple models without this
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, field);
    }

    return {
      [field]: value
    };
  }

  inBatchSet(field, value, silent) {
    const me = this,
          {
      meta,
      constructor,
      fieldMap
    } = me,
          wasSet = {};
    let cmp,
        changed = false;

    if (typeof field !== 'string') {
      Object.keys(me.fieldToKeys(field, value)).forEach(key => {
        cmp = fieldMap[key] || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"];
        value = constructor.processField(key, field[key], me); // Store batch changes

        if (!cmp.isEqual(meta.batchChanges[key], value)) {
          wasSet[key] = {
            value,
            oldValue: me.get(key)
          };
          meta.batchChanges[key] = value;
          changed = true;
        }
      });
    } else {
      cmp = fieldMap[field] || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"]; // Minor optimization for engine writing back a lot of changes

      if (!cmp.isEqual(meta.batchChanges[field], value)) {
        wasSet[field] = {
          value,
          oldValue: me.get(field)
        };
        meta.batchChanges[field] = value;
        changed = true;
      }
    } // Callers need to be able to detect changes


    if (changed) {
      me.generation++;

      if (!silent) {
        // Fire batched events for UIs which need to update themselves during batched updates.
        // An example is evenResize feature which batches the changes to the endDate
        // or startDate, but the UI must update during the drag.
        const event = {
          action: 'update',
          record: me,
          records: [me],
          changes: wasSet
        };
        me.stores.forEach(store => {
          store.trigger('batchedUpdate', event);
        });
      }
    }
  }

  inSet(field, value, silent, fromRelationUpdate, skipAccessors = false) {
    const me = this,
          {
      data,
      meta,
      fieldMap,
      constructor
    } = me,
          {
      prototype: myProto,
      childrenField
    } = constructor,
          wasSet = {},
          toSet = me.fieldToKeys(field, value),
          keys = Object.keys(toSet);
    let changed = false; // Give a chance to cancel action before records updated.

    if (!silent && !me.triggerBeforeUpdate(toSet)) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      var _field$dataSource4;

      const key = keys[i]; // Currently not allowed to set children in a TreeNode this way, will be ignored

      if (key === childrenField) {
        continue;
      }

      const field = fieldMap[key],
            cmp = field || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"],
            readOnly = field === null || field === void 0 ? void 0 : field.readOnly,
            mapping = (_field$dataSource4 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource4 !== void 0 ? _field$dataSource4 : key,
            useProp = !skipAccessors && !field && key in myProto,
            oldValue = useProp ? me[mapping] : field !== null && field !== void 0 && field.complexMapping ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(data, mapping) : data[mapping],
            value = constructor.processField(key, toSet[key], me),
            val = toSet[key] = {
        value
      },
            relation = me.getRelationConfig(key);

      if (!readOnly && !cmp.isEqual(oldValue, value)) {
        // Indicate to observers that data has changed.
        me.generation++;
        val.oldValue = oldValue;
        changed = true; // Update `modified` state which is used in sync request

        if (cmp.isEqual(me.meta.modified[key], value)) {
          // Remove changes if values are the same
          Reflect.deleteProperty(meta.modified, key);
        } else if (!me.ignoreBag) {
          // Private flag in engine, speeds initial commit up by not recording changes
          // Cache its original value
          if (!(key in meta.modified)) {
            meta.modified[key] = oldValue;
          }

          if (val.oldValue === _undefined) {
            Reflect.deleteProperty(val, 'oldValue');
          }
        } // The wasSet object keys must be the field *name*, not its dataSource.


        wasSet[key] = val;
        me.applyValue(useProp, mapping, value, skipAccessors, field); // changing foreign key

        if (relation && !fromRelationUpdate) {
          me.initRelation(relation);
          me.stores.forEach(store => store.cacheRelatedRecord(me, value, relation.relationName, val.oldValue));
        }
      }
    }

    if (changed) {
      me.afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
    }

    return changed ? wasSet : null;
  } // Provided as a hook for SchedulingEngine to do what needs to be done which ever way a field value is changed


  applyValue(useProp, key, value, skipAccessors, field) {
    var _field;

    let complexMapping = (_field = field) === null || _field === void 0 ? void 0 : _field.complexMapping; // If we don't have a field, but we have a property defined
    // eg, the fullDuration property defined in TaskModel, then
    // use the property

    if (useProp) {
      this[key] = value;
      return;
    } // Might be setting value of nested object


    if (!field && key.includes('.')) {
      var _field2, _field3;

      const nestedName = key.split('.')[0];
      field = this.constructor.fieldMap[nestedName]; // We use complex mapping if the field's dataSource was defined as such,
      // OR if we are being asked to set using dot notation and field is of Object type.

      complexMapping = ((_field2 = field) === null || _field2 === void 0 ? void 0 : _field2.complexMapping) || ((_field3 = field) === null || _field3 === void 0 ? void 0 : _field3.type) === 'object';
    } // Use complex mapping?


    if (complexMapping) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(this.data, key, value);
    } // Otherwise, push the value through into the data.
    else {
      this.data[key] = value;
    }
  } // skipAccessors argument is used in the engine override


  afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
    this.stores.forEach(store => {
      store.onModelChange(this, toSet, wasSet, silent, fromRelationUpdate);
    });
  }
  /**
   * This yields `true` if this record is eligible for syncing with the server.
   * It can yield `false` if the record is in the middle of a {@link #property-isBatchUpdating batched update},
   * or if it is a {@link #property-isCreating tentative record} yet to be confirmed as a new addition.
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    // Record is not persistable if the owning app is in the middle of a batch update
    // and the record is not flagged as being in the middle of a creation sequence.
    // This means that a "new" record can be added on a conditional basis with its
    // isCreating property set which means it is examplt from being synced until
    // the isCreating flag is cleared.
    return !this.isBatchUpdating && !this.isCreating;
  }
  /**
   * True if this model has any uncommitted changes.
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isModified() {
    return Boolean(this.meta.modified && Object.keys(this.meta.modified).length > 0);
  } // TODO: Make this the behaviour of isModified?


  get hasPersistableChanges() {
    return this.isPersistable && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEmpty(this.rawModificationData);
  }
  /**
   * Returns true if this model has uncommitted changes for the provided field.
   * @param {String} fieldName Field name
   * @returns {Boolean} True if the field is changed
   * @category Editing
   */


  isFieldModified(fieldName) {
    return this.isModified && fieldName in this.meta.modified;
  }
  /**
   * Returns field value that should be persisted, or `undefined` if field is configured with `persist: false`.
   * @param {String|Core.data.field.DataField} nameOrField Name of the field to get value for, or its field definition
   * @private
   * @category Fields
   */


  getFieldPersistentValue(nameOrField) {
    const field = typeof nameOrField === 'string' ? this.getFieldDefinition(nameOrField) : nameOrField,
          name = (field === null || field === void 0 ? void 0 : field.name) || nameOrField;
    let result;

    if (!field || field.persist) {
      result = this[name]; // if serialize function is provided we use it to prepare the persistent value

      if (field !== null && field !== void 0 && field.serialize) {
        result = field.serialize(result, this);
      }
    }

    return result;
  }
  /**
   * Get a map of the modified fields in form of an object. The field *names* are used as the property names
   * in the returned object.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modifications() {
    const data = this.rawModifications;

    if (data && Object.keys(data).length) {
      data[this.constructor.idField] = this.id;
    }

    return data;
  }

  get rawModifications() {
    const me = this,
          data = {};

    if (!me.isModified) {
      return null;
    }

    let keySet = false;
    Object.keys(me.meta.modified).forEach(key => {
      // TODO: isModified will report record as modified even if a modification won't be persisted here. Should it?
      const value = me.getFieldPersistentValue(key);

      if (value !== _undefined) {
        data[key] = value;
        keySet = true;
      }
    });
    return keySet ? data : null;
  }
  /**
   * Get a map of the modified fields in form of an object. The field´s {@link Core.data.field.DataField#config-dataSource}
   * is used as the property name in the returned object. The record´s id is always included.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modificationData() {
    const data = this.rawModificationData; // If there are some persistable field changes, append record id

    if (data && Object.keys(data).length) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, this.constructor.getFieldDefinition(this.constructor.idField).dataSource, this.id);
    }

    return data;
  }
  /**
   * Returns a map of the modified persistable fields
   * @internal
   * @property {Object}
   * @category Editing
   */


  get rawModificationData() {
    const me = this,
          {
      fieldMap
    } = me.constructor,
          data = {};

    if (!me.isModified) {
      return null;
    }

    let keySet = false;
    Object.keys(me.meta.modified).forEach(fieldName => {
      // TODO: isModified will report record as modified even if a modification wont be persisted here. Should it?
      const field = fieldMap[fieldName]; // No field definition means there's no original dataSource to update

      if (field !== null && field !== void 0 && field.persist) {
        const value = me.getFieldPersistentValue(fieldName);

        if (value !== _undefined) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, field.dataSource, value);
          keySet = true;
        }
      }
    });
    return keySet ? data : null;
  }
  /**
   * Get a map of the modified data fields along with any {@link Core/data/field/DataField#config-alwaysWrite} fields, in
   * form of an object. The field´s *dataSource* is used as the property name in the returned object.
   * Used internally by AjaxStore / CrudManager when sending updates.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modificationDataToWrite() {
    const alwaysWriteFields = this.constructor.alwaysWriteFields,
          recordData = this.modificationData;
    alwaysWriteFields.forEach(fieldName => {
      recordData[this.getFieldDefinition(fieldName).dataSource] = this.getFieldPersistentValue(fieldName);
    });
    return recordData;
  }
  /**
   * Returns data for **all** {@link Core.data.field.DataField#config-persist persistable} fields in form of an object, using dataSource if present.
   * @property {Object}
   * @internal
   * @readonly
   * @category Editing
   */


  get persistableData() {
    const me = this,
          data = {};
    me.fields.forEach(field => {
      const value = me.getFieldPersistentValue(field);

      if (value !== _undefined) {
        if (field !== null && field !== void 0 && field.complexMapping) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, field.dataSource, value);
        } else {
          data[field.dataSource] = value;
        }
      }
    });
    return data;
  }
  /**
   * True if this models changes are currently being committed.
   * @property {Boolean}
   * @category Editing
   */


  get isCommitting() {
    return Boolean(this.meta.committing);
  }
  /**
   * Clear stored changes, used on commit. Does not revert changes.
   * @privateparam {Boolean} [removeFromStoreChanges] Update related stores modified collection or not
   * @privateparam {Boolean} [includeDescendants] Set true to clear store descendants
   * @category Editing
   */


  clearChanges(removeFromStoreChanges = true, includeDescendants = true) {
    const me = this,
          {
      meta
    } = me;
    meta.modified = {};
    meta.committing = false;

    if (removeFromStoreChanges) {
      me.stores.forEach(store => {
        store.modified.remove(me);
        store.added.remove(me);

        if (includeDescendants) {
          const descendants = store.collectDescendants(me).all;
          store.added.remove(descendants);
          store.modified.remove(descendants);
        }
      });
    }
  }
  /**
   * Reverts changes in this back to their original values.
   * @privateparam {Boolean} [silent] Specify `true` to not trigger events.
   * @category Editing
   */


  revertChanges(silent = false) {
    this.set(this.meta.modified, _undefined, silent);
  } //endregion
  //region Id

  /**
   * Gets the records internalId. It is assigned during creation, guaranteed to be globally unique among models.
   * @property {Number}
   * @category Identification
   */


  get internalId() {
    return this._internalId;
  }
  /**
   * Returns true if the record is new and has not been persisted (and received a proper id).
   * @property {Boolean}
   * @readonly
   * @category Identification
   */


  get isPhantom() {
    return this.id === '' || this.id == null || this.hasGeneratedId;
  }

  get isModel() {
    return true;
  }
  /**
   * Checks if record has a generated id. New records are assigned a generated id (starting with _generated), which should be
   * replaced on commit.
   * @property {Boolean}
   * @category Identification
   */


  get hasGeneratedId() {
    return typeof this.id === 'string' && this.id.startsWith('_generated');
  }

  static generateId(text = this.$$name) {
    return `_generated${text}${++Model._generatedIdIndex}`;
  }
  /**
   * Generates id for new record which starts with _generated.
   * @category Identification
   */


  generateId() {
    return this.constructor.generateId();
  }
  /**
   * Gets the id of specified model or the value if passed string/Number.
   * @param {Core.data.Model|String|Number} model
   * @returns {String|Number} id
   * @category Identification
   */


  static asId(model) {
    return model !== null && model !== void 0 && model.isModel ? model.id : model;
  } //endregion
  //region JSON

  /**
   * Get the records data as a json string.
   *
   * ```javascript
   * const record = new Model({
   *     title    : 'Hello',
   *     children : [
   *         ...
   *     ]
   * });
   *
   * const jsonString = record.json;
   *
   * //jsonString:
   * '{"title":"Hello","children":[...]}'
   * ```
   *
   * @member {String}
   * @category JSON
   */


  get json() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonStringify(this); // calls our toJSON() method
  }
  /**
   * Used by `JSON.stringify()` to correctly convert this record to json.
   *
   * In most cases no point in calling it directly.
   *
   * ```
   * // This will call `toJSON()`
   * const json = JSON.stringify(record);
   * ```
   *
   * If called manually, the resulting object is a clone of `record.data` + the data of any children:
   *
   * ```
   * const record = new Model({
   *     title    : 'Hello',
   *     children : [
   *         ...
   *     ]
   * });
   *
   * const jsonObject = record.toJSON();
   *
   * // jsonObject:
   * {
   *     title : 'Hello',
   *     children : [
   *         ...
   *     ]
   * }
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    const {
      children
    } = this,
          jsonData = this.persistableData;

    if (children) {
      jsonData[this.constructor.childrenField] = children.map(c => c.toJSON());
    }

    return jsonData;
  }
  /**
   * Represent the record as a string, by default as a JSON string. Tries to use an abbreviated version of the objects
   * data, using id + name/title/text/label/description. If no such field exists, the full data is used.
   *
   * ```javascript
   * const record = new Model({ id : 1, name : 'Steve Rogers', alias : 'Captain America' });
   * console.log(record.toString()); // logs { "id" : 1, "name" : "Steve Rogers" }
   * ```
   *
   * @returns {String}
   */


  toString() {
    const me = this,
          nameField = abbreviationFields.find(field => field in me.constructor.fieldMap),
          data = nameField ? {
      [me.constructor.idField]: me.id,
      [nameField]: me[nameField]
    } : me.data;
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonStringify(data);
  } //endregion
  //region Batch

  /**
   * True if this Model is currently batching its changes.
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isBatchUpdating() {
    return Boolean(this.batching);
  }
  /**
   * Returns `true` if this Model currently has outstanding batched changes for the specified field name.
   * @param {String} fieldName The field name to check for batched updates on.
   * @returns {Boolean}
   */


  hasBatchedChange(fieldName) {
    var _this$meta, _this$meta$batchChang;

    return (_this$meta = this.meta) === null || _this$meta === void 0 ? void 0 : (_this$meta$batchChang = _this$meta.batchChanges) === null || _this$meta$batchChang === void 0 ? void 0 : _this$meta$batchChang[fieldName];
  }
  /**
   * Begin a batch, which stores changes and commits them when the batch ends.
   * Prevents events from being fired during batch.
   *
   * ```javascript
   * record.beginBatch();
   * record.name = 'Mr Smith';
   * record.team = 'Golden Knights';
   * record.endBatch();
   * ```
   *
   * Please note that you can also set multiple fields in a single call using {@link #function-set}, which in many
   * cases can replace using a batch:
   *
   * ```javascript
   * record.set({
   *   name : 'Mr Smith',
   *   team : 'Golden Knights'
   * });
   * ```
   * @category Editing
   * @privateparam {Boolean} silentUpdates Suppress firing the `batchUpdatedEvent`
   */


  beginBatch(silentUpdates = false) {
    const me = this;

    if (!me.batching) {
      me.batching = 0;
      me.meta.batchChanges = {};
    }

    if (silentUpdates) {
      me.$silenceBatch = (me.$silenceBatch || 0) + 1;
    }

    me.batching++;
  }
  /**
   * End a batch, triggering events if data has changed.
   * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @category Editing
  */


  endBatch(silent = false, skipAccessors = false) {
    const me = this,
          {
      parentIdField
    } = me.constructor;

    if (!me.batching) {
      return;
    }

    me.batching--; // Ideally we should track which batch was silenced, but that will complicate code more than what avoiding a few
    // triggered events is worth (this is private and we do not start batches while batches are ongoing in the
    // critical code path in engine)

    me.$silenceBatch && me.$silenceBatch--;

    if (me.batching > 0) {
      return;
    } // Set pending batch changes


    if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEmpty(me.meta.batchChanges)) {
      const batchChanges = _objectSpread({}, me.meta.batchChanges);

      me.meta.batchChanges = null; // Move to its new parent before applying the other changes.

      if (batchChanges[parentIdField]) {
        me.parentId = batchChanges[parentIdField];
        delete batchChanges[parentIdField];
      }

      me.set(batchChanges, _undefined, silent, false, skipAccessors);
    }
  }
  /**
   * Cancels current batch operation. Any changes during the batch are discarded.
   * @category Editing
   */


  cancelBatch() {
    if (this.batching) {
      const me = this,
            {
        batchChanges
      } = me.meta,
            wasSet = {};
      me.batching = null;
      me.meta.batchChanges = null;
      me.generation++;

      if (!me.$silenceBatch) {
        // Create a wasSet describing the revert back from the batched values to the real values.
        Object.entries(batchChanges).forEach(([key, oldValue]) => {
          wasSet[key] = {
            oldValue,
            value: me[key]
          };
        }); // Fire batched events for UIs which need to update themselves during batched updates.
        // An example is evenResize feature which batches the changes to the endDate
        // or startDate, but the UI must update during the drag.

        const event = {
          action: 'update',
          record: me,
          records: [me],
          changes: wasSet
        };
        me.stores.forEach(store => {
          store.trigger('batchedUpdate', event);
        });
      }

      me.$silenceBatch && me.$silenceBatch--;
    }
  } //endregion
  //region Events

  /**
   * Triggers beforeUpdate event for each store and checks if changes can be made from event return value.
   * @param {Object} changes Data changes
   * @returns {Boolean} returns true if data changes are accepted
   * @private
   */


  triggerBeforeUpdate(changes) {
    return !this.stores.some(s => {
      return s.trigger('beforeUpdate', {
        record: this,
        changes
      }) === false;
    });
  } //endregion
  //region Additional functionality

  /**
   * Makes a copy of this model, assigning the specified id or a generated id and also allowing you to pass field values to
   * the created copy.
   *
   * ```
   * const record = new Model({ name : 'Super model', hairColor : 'Brown' });
   * const clone = record.copy({ name : 'Super model clone' });
   * ```
   * @param {Number|String|Object} [newId] The id for the copied instance, or any field values to apply
   * (overriding the values from the source record). If no id provided, one will be auto-generated
   * @param {Number|String} [newId.id] DEPRECATED: Id to set, leave out to use generated id or specify false to also copy id
   * @param {Boolean} [newId.deep] DEPRECATED: true to also clone children (use separate argument)
   * @param {Boolean} [deep] True to also clone children
   * @returns {Core.data.Model} Copy of this model
   * @category Editing
   */


  copy(newId = null, params) {
    const me = this,
          data = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(me.data),
          idField = me.constructor.idField;
    let deep, id; // Chrono model is adding more logic to copy and that logic should be manageable from arguments. So there is
    // option to pass object as a last argument to switch method behavior. Used internally only, shouldn't be public.

    deep = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(params) ? params.deep : params;

    if (newId && typeof newId === 'object') {
      id = newId[idField];

      if ('deep' in newId) {
        deep = newId.deep;
        _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Grid', '5.0.0', '`deep` attribute deprecated, in favor of a separate second parameter'); // Only use id once to avoid collisions

        delete newId[idField];
        delete newId.deep;
      } else {
        Object.assign(data, newId);
      }
    } else {
      id = newId;
    } // Iterate over instance children, because data may not reflect actual children state


    if (deep && me.children) {
      data.children = me.children.map(child => child.copy(undefined, params));
    } else {
      delete data.children;
      delete data.expanded;
    }

    if (newId !== false) {
      // We can use the value from the 'id' property, but as a fallback, generate the id.
      data[idField] = id || me.generateId(me.firstStore);
    } // Force using raw data when creating a copy, since data was cloned above anyway


    const copy = new me.constructor(data, null, null, false, true); // Store original record internal id to lookup from copy later

    copy.originalInternalId = me.internalId;
    return copy;
  }
  /**
   * Removes this record from all stores (and in a tree structure, also from its parent if it has one).
   * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @category Editing
   */


  remove(silent = false) {
    const me = this,
          {
      parent
    } = this; // Remove from parent if we're in a tree structure.
    // This informs the owning store(s)

    if (parent) {
      parent.removeChild(me);
    } // Store handles remove
    else if (me.stores.length) {
      // Not sure what should happen if you try to remove a special row (group row for example), bailing out
      if (!me.isSpecialRow) {
        me.stores.forEach(s => s.remove(me, silent, false, true));
      }
    }
  }
  /**
   * Get the first store that this model is assigned to.
   * @property {Core.data.Store}
   * @readonly
   * @category Misc
   */


  get firstStore() {
    return this.stores.length > 0 && this.stores[0];
  }
  /**
   * Get a relation config by name, from the first store.
   * @param {String} name
   * @returns {Object}
   * @private
   * @category Relations
   */


  getRelationConfig(name) {
    var _this$firstStore, _this$firstStore$mode;

    // using first store for relations, might have to revise later..
    return (_this$firstStore = this.firstStore) === null || _this$firstStore === void 0 ? void 0 : (_this$firstStore$mode = _this$firstStore.modelRelations) === null || _this$firstStore$mode === void 0 ? void 0 : _this$firstStore$mode.find(r => r.fieldName === name);
  } //endregion
  //region Validation

  /**
   * Check if record has valid data. Default implementation returns true, override in your model to do actual validation.
   * @property {Boolean}
   * @category Editing
   */


  get isValid() {
    return true;
  } //endregion
  //region Store

  /**
   * Joins this record and any children to specified store, if not already joined.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @category Misc
   */


  joinStore(store) {
    const me = this,
          {
      stores
    } = me;

    if (!stores.includes(store)) {
      const {
        unjoinedStores
      } = me;
      super.joinStore(store);
      store.register(me);
      stores.push(store);

      if (unjoinedStores.includes(store)) {
        unjoinedStores.splice(unjoinedStores.indexOf(store), 1);
      }

      me.isLoaded && me.children.forEach(child => child.joinStore(store));
      me.initRelations();

      if (store.tree && !me.isRoot) {
        me.instanceMeta(store.id).collapsed = !me.expanded;
      }
    }
  }
  /**
   * Unjoins this record and any children from specified store, if already joined.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @param {Boolean} [isReplacing] `true` if this record is being replaced
   * @category Misc
   */


  unjoinStore(store, isReplacing = false) {
    const me = this,
          {
      stores,
      unjoinedStores
    } = me;

    if (stores.includes(store)) {
      var _ref, _ref$forEach;

      if (!store.isDestroying) {
        store.unregister(me);
        unjoinedStores.push(store);
      } // me.children may === true...
      // If filtered, *all* children must be unjoined when we are.


      (_ref = me.unfilteredChildren || me.children) === null || _ref === void 0 ? void 0 : (_ref$forEach = _ref.forEach) === null || _ref$forEach === void 0 ? void 0 : _ref$forEach.call(_ref, child => child.unjoinStore(store, isReplacing));
      stores.splice(stores.indexOf(store), 1); // keep the cord to allow removed records to reach the store when needed

      super.unjoinStore && super.unjoinStore(store, isReplacing); // remove from relation cache

      store.uncacheRelatedRecord(me);
    }
  }
  /**
   * Returns true if this record is contained in the specified store, or in any store if store param is omitted.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @returns {Boolean}
   * @category Misc
   */


  isPartOfStore(store) {
    if (store) {
      return store.includes(this);
    }

    return this.stores.length > 0;
  }
  /**
   * Returns true if this record is not part of any store.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  get isRemoved() {
    return !this.isPartOfStore();
  } //endregion
  //region Per instance meta

  /**
   * Used to set per external instance meta data. For example useful when using a record in multiple grids to store some state
   * per grid.
   * @param {String|Object} instanceOrId External instance id or the instance itself, if it has id property
   * @private
   * @category Misc
   */


  instanceMeta(instanceOrId) {
    const {
      meta
    } = this,
          id = instanceOrId.id || instanceOrId;

    if (!meta.map) {
      meta.map = {};
    }

    return meta.map[id] || (meta.map[id] = {});
  }

  get isGroupHeader() {
    return 'groupRowFor' in this.meta;
  }

  get isGroupFooter() {
    return 'groupFooterFor' in this.meta;
  }

  get isSpecialRow() {
    return this.meta.specialRow;
  } //endregion


  static get nonPersistableFields() {
    const me = this;

    if (!me._nonPersistableFields) {
      me._nonPersistableFields = {};
      me.allFields.forEach(field => {
        if (!field.persist || field.calculated) {
          me._nonPersistableFields[field.name] = 1;
        }
      });
    }

    return me._nonPersistableFields;
  }

  static get alwaysWriteFields() {
    const me = this;

    if (!me._alwaysWriteFields) {
      me._alwaysWriteFields = [];
      me.allFields.forEach(field => {
        if (field.alwaysWrite) {
          me._alwaysWriteFields.push(field.name);
        }
      });
    }

    return me._alwaysWriteFields;
  }

}
Model._idField = 'id';
Model._internalIdCounter = 1;
Model._assignedIdField = false;
Model._generatedIdIndex = 0;
Model.exposeProperties();
Model._$name = 'Model';

/***/ }),

/***/ "./lib/Core/data/Store.js":
/*!********************************!*\
  !*** ./lib/Core/data/Store.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Store; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_State_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StoreBag.js */ "./lib/Core/data/StoreBag.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/StoreCRUD.js */ "./lib/Core/data/mixin/StoreCRUD.js");
/* harmony import */ var _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixin/StoreFilter.js */ "./lib/Core/data/mixin/StoreFilter.js");
/* harmony import */ var _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/StoreGroup.js */ "./lib/Core/data/mixin/StoreGroup.js");
/* harmony import */ var _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/StoreProxy.js */ "./lib/Core/data/mixin/StoreProxy.js");
/* harmony import */ var _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/StoreRelation.js */ "./lib/Core/data/mixin/StoreRelation.js");
/* harmony import */ var _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./mixin/StoreSum.js */ "./lib/Core/data/mixin/StoreSum.js");
/* harmony import */ var _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./mixin/StoreSearch.js */ "./lib/Core/data/mixin/StoreSearch.js");
/* harmony import */ var _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./mixin/StoreSort.js */ "./lib/Core/data/mixin/StoreSort.js");
/* harmony import */ var _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./mixin/StoreChained.js */ "./lib/Core/data/mixin/StoreChained.js");
/* harmony import */ var _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./mixin/StoreState.js */ "./lib/Core/data/mixin/StoreState.js");
/* harmony import */ var _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./mixin/StoreTree.js */ "./lib/Core/data/mixin/StoreTree.js");
/* harmony import */ var _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./mixin/StoreSync.js */ "./lib/Core/data/mixin/StoreSync.js");
/* harmony import */ var _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./stm/mixin/StoreStm.js */ "./lib/Core/data/stm/mixin/StoreStm.js");
var productName = 'gantt';
/* eslint-disable no-unused-expressions */

























/**
 * @module Core/data/Store
 */

/**
 * The Store represents a data container which holds flat data or tree structures. An item in the Store is often called
 * a ´record´ and it is simply an instance of the {@link Core.data.Model} (or any subclass thereof).
 *
 * Typically you load data into a store to display it in a Grid or a ComboBox. The Store is the backing data component
 * for any component that is showing data in a list style UI.
 *
 * ## Data format
 * Data is store in a JSON array the Store offers an API to edit, filter, group and sort the records.
 *
 * ## Store with flat data
 * To create a flat store simply provide an array of objects that describe your records
 *
 * ```javascript
 * const store = new Store({
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden' },
 *     { id : 2, name : 'Beatles', country : 'UK' }
 *   ]
 * });
 *
 * // retrieve record by id
 * const beatles = store.getById(2);
 * ```
 *
 * ## Store with tree data
 * To create a tree store use `children` property for descendant records
 *
 * ```javascript
 * const store = new Store({
 *   tree: true,
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden', children: [
 *       { id: 2, name: 'Agnetha' },
 *       { id: 3, name: 'Bjorn' },
 *       { id: 4, name: 'Benny' },
 *       { id: 5, name: 'Anni-Frid' }
 *     ]},
 *   ]
 * });
 *
 * // retrieve record by id
 * let benny = store.getById(4);
 * ```
 *
 * Optionally a tree store can consume a flat dataset with nodes that have a `parentId` property. By configuring the
 * store with `tree : true` and `transformFlatData : true`, the flat data is transformed into tree data:
 *
 * ```javascript
 * const store = new Store({
 *   tree              : true,
 *   transformFlatData : true,
 *   data              : [
 *     { id : 1, name : 'ABBA', country : 'Sweden' },
 *     { id : 2, name: 'Agnetha', parentId : 1 },
 *     { id : 3, name: 'Bjorn', parentId : 1 },
 *     { id : 4, name: 'Benny', parentId : 1 },
 *     { id : 5, name: 'Anni-Frid', parentId : 1 }
 *   ]
 * });
 * ```
 *
 * ### Retrieving and consuming JSON
 * For both flat stores or tree stores it is possible to retrieve the data of all records in JSON format:
 *
 * ```javascript
 * const jsonString = store.json;
 *
 * // or
 *
 * const jsonArray = store.toJSON();
 * ```
 *
 * To plug the JSON data back in later:
 *
 * ```javascript
 * store.data = JSON.parse(jsonString);
 *
 * // or
 *
 * store.data = jsonArray;
 * ```
 *
 * ## Sharing stores
 * You cannot directly share a Store between widgets, but the data in a Store can be shared. There are two different
 * approaches depending on your needs, sharing data and chaining stores:
 *
 * ### Shared data
 * To create 2 widgets that share data, you can create 2 separate stores and pass records of the first store as the
 * dataset of the second store.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : combo1.store.records
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * ### Chained stores
 * Another more powerful option to share data between widgets is to create {@link Core.data.mixin.StoreChained chained}
 * stores. The easiest way to create a chained store is to call {@link #function-chain} function.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : combo1.store.chain(),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * A chained store can optionally be created with a filtering function, to only contain a subset of the records from
 * the main store. In addition, the chained store will reflect record removals/additions to the master store, something
 * the shared data approach will not.
 *
 * @mixes Core/mixin/Events
 * @mixes Core/data/mixin/StoreFilter
 * @mixes Core/data/mixin/StoreCRUD
 * @mixes Core/data/mixin/StoreSum
 * @mixes Core/data/mixin/StoreSearch
 * @mixes Core/data/mixin/StoreSort
 * @mixes Core/data/mixin/StoreGroup
 * @mixes Core/data/mixin/StoreChained
 * @mixes Core/data/mixin/StoreState
 * @mixes Core/data/mixin/StoreTree
 * @mixes Core/data/stm/mixin/StoreStm
 * @mixes Core/data/mixin/StoreSync
 *
 * @extends Core/Base
 */

class Store extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_State_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_12__["default"], _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_15__["default"], // Private
_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_13__["default"], _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_19__["default"], _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_21__["default"], _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_23__["default"], _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_14__["default"] // Private for now, thus not mentioned in @mixes block above
) {
  //region Config & properties
  static get $name() {
    return 'Store';
  }

  static get properties() {
    return {
      relationCache: {},
      dependentStoreConfigs: new Map()
    };
  }

  static get configurable() {
    return {
      /**
       * Store's unique identifier.
       *
       * @member {String|Number} id
       * @readonly
       * @category Common
       */

      /**
       * Store's unique identifier. When set the store is added to a store map accessible through
       * `Store.getStore(id)`.
       *
       * @config {String|Number}
       * @category Common
       */
      id: true,

      /**
       * Class used to represent records, should be a subclass of {@link Core.data.Model}.
       *
       * ```javascript
       * class MyModel extends Model {
       *     static get fields() {
       *         return [
       *             'name',
       *             'city',
       *             'company'
       *         ]
       *     }
       * }
       *
       * const store = new Store({
       *     modelClass : MyModel,
       *     data : [
       *         { id : 1, name : 'Mark', city : 'London', company : 'Cool inc' },
       *         ...
       *     ]
       * });
       * ```
       *
       * @config {Core.data.Model}
       * @default
       * @typings {typeof Model}
       * @category Common
       */
      modelClass: _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]
    };
  }

  static get defaultConfig() {
    return {
      /**
       * An array of field definitions used to create a {@link Core.data.Model} (modelClass) subclass. Optional.
       * If the Model already has fields defined, these fields will extend those.
       *
       * ```javascript
       * const store = new Store({
       *     fields : ['name', 'city', 'company'],
       *     data   : [
       *         { id : 1, name : 'Mark', city : 'London', company : 'Cool inc' },
       *         ...
       *     ]
       * });
       * ```
       *
       * See {@link Core.data.Model} for more info on defining fields, changing data source and mapping fields to
       * nested objects.
       *
       * @config {String[]|Object[]|Core.data.field.DataField[]}
       * @category Common
       */
      fields: null,

      /**
       * Automatically detect from set data if used as tree store or flat store
       * @config {Boolean}
       * @default
       * @category Tree
       */
      autoTree: true,

      /**
       * Raw data to load initially.
       *
       * Expects an array of JavaScript objects, with properties matching store's fields (defined on its
       * {@link #config-modelClass model} or in the {@link #config-fields} config).
       *
       * ```javascript
       * const store = new Store({
       *   data : [
       *     { id : 1, name : 'Linda', city : 'NY' },
       *     { id : 2, name : 'Olivia', city : 'Paris' },
       *     ...
       *   ]
       * });
       * ```
       *
       * @config {Object[]|Core.data.Model[]}
       * @category Common
       */
      data: null,

      /**
       * `true` to act as a tree store.
       * @config {Boolean}
       * @category Tree
       */
      tree: false,
      callOnFunctions: true,

      /**
       * A {@link Core.util.Collection Collection}, or Collection config object
       * to use to contain this Store's constituent records.
       * @config {Core.util.Collection|Object}
       * @category Advanced
       */
      storage: null,

      /**
       * Retools the loaded data objects instead of making shallow copies of them. This increases performance but
       * pollutes the incoming data and does not allow remapping of fields (dataSource).
       *
       * Also allows disabling certain steps in data loading, to further improve performance. Either accepts an
       * object with the params described below or `true` which equals `disableDuplicateIdCheck` and
       * `disableTypeConversion`.
       *
       * ```javascript
       * // No duplicate id checking, no type conversions
       * new Store({ useRawData : true });
       *
       * new Store({
       *   // No type conversions only
       *   useRawData : {
       *     disableTypeConversion : true
       *   }
       * });
       * ```
       *
       * @config {Boolean|Object}
       * @param {Boolean} [disableDuplicateIdCheck] Data must not contain duplicate ids, check is bypassed.
       * @param {Boolean} [disableDefaultValue] Default values will not be applied to record fields.
       * @param {Boolean} [disableTypeConversion] No type conversions will be performed on record data.
       * @category Advanced
       */
      useRawData: false,

      /**
       * Specify `false` to prevent loading records without ids, a good practise to enforce when syncing with a
       * backend.
       *
       * By default Store allows loading records without ids, in which case a generated id will be assigned.
       *
       * @config {Boolean}
       * @default true
       * @category Advanced
       */
      allowNoId: true,

      /**
       * Prevent dynamically subclassing the modelClass. It does so by default to not pollute it when exposing
       * properties. Should rarely need to be used.
       * @config {Boolean}
       * @default false
       * @private
       * @category Advanced
       */
      preventSubClassingModel: null
    };
  }

  static get identifiable() {
    return {
      registerGeneratedId: false
    };
  }
  /**
   * Class used to represent records. Defaults to class Model.
   * @member {Core.data.Model} modelClass
   * @typings {typeof Model}
   * @category Records
   */
  //endregion
  //region Events

  /**
   * Fired when the id of a record has changed
   * @event idChange
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {String|Number} oldValue Old id
   * @param {String|Number} value New id
   */

  /**
   * Fired before record is modified in this store.
   * Modification may be vetoed by returning `false` from a handler.
   * @event beforeUpdate
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {Object} changes Modification data
   */

  /**
   * Fired when a record is modified
   * @event update
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {Object} changes Modification data
   */

  /**
   * Fired when one of this Store's constituent records is modified while in
   * {@link Core.data.Model#function-beginBatch batched} state. This may be used to keep
   * UIs up to date while "tentative" changes are made to a record which must not be synced with a server.
   * @event batchedUpdate
   * @private
   */

  /**
   * Fired when the root node is set
   * @event rootChange
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} oldRoot The old root node.
   * @param {Core.data.Model} rootNode The new root node.
   */

  /**
   * Data in the store was changed. This is a catch-all event which is fired for all changes
   * which take place to the store's data.
   *
   * This includes mutation of individual records, adding and removal of records, as well as
   * setting a new data payload using the {@link #property-data} property, sorting, filtering,
   * and calling {@link Core.data.mixin.StoreCRUD#function-removeAll}.
   *
   * Simple databound widgets may use to the `change` event to refresh their UI without having to add multiple
   * listeners to the {@link #event-update}, {@link Core.data.mixin.StoreCRUD#event-add},
   * {@link Core.data.mixin.StoreCRUD#event-remove}, {@link #event-refresh} and
   * {@link Core.data.mixin.StoreCRUD#event-removeAll} events.
   *
   * A more complex databound widget such as a grid may use the more granular events to perform less
   * destructive updates more appropriate to each type of change. The properties will depend upon the value of the
   * `action` property.
   *
   * @event change
   * @param {Core.data.Store} source This Store.
   * @param {String} action Name of action which triggered the change. May be one of:
   * * `'remove'`
   * * `'removeAll'`
   * * `'add'`
   * * `'updatemultiple'`
   * * `'clearchanges'`
   * * `'filter'`
   * * `'update'`
   * * `'dataset'`
   * * `'replace'`
   * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
   * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
   * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
   */
  // NOTE: When updating params above, also update change event in ProjectModelMixin and dataChange in ProjectConsumer

  /**
   * Data in the store has completely changed, such as by a filter, or sort or load operation.
   * @event refresh
   * @param {Core.data.Store} source This Store.
   * @param {Boolean} batch Flag set to `true` when the refresh is triggered by ending a batch
   * @param {String} action Name of action which triggered the change. May be one of:
   * * `'dataset'`
   * * `'sort'`
   * * `'clearchanges'`
   * * `'filter'`
   * * `'create'`
   * * `'update'`
   * * `'delete'`
   * * `'group'`.
   */
  //endregion

  /* break doc comment from next method */
  //region Init


  constructor(...args) {
    super(...args); // When using a Proxy, the Proxy is returned instead of the actual Store

    if (this.objectify) {
      return this.initProxy();
    }
  }

  construct(config = {}) {
    const me = this;
    Object.assign(me, {
      added: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      removed: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      modified: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      idRegister: {},
      internalIdRegister: {}
    });

    if (config.storeId) {
      // avoid changing id when setting storeId:
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].assign({
        id: config.storeId
      }, config); // We cannot remove storeId since it can also be inherited and if so, it will override the id above:
      // delete config.storeId;
    }

    super.construct(config);
    me.initRelations();
  }
  /**
   * Retrieves/creates a store based on the passed config.
   *
   * | Type              | Result                                                                 |
   * |-------------------|------------------------------------------------------------------------|
   * | Core.data.Store   | Returns supplied store as is                                           |
   * | String            | Retrieves an existing store by id                                      |
   * | Object            | Creates a new store using supplied config object                       |
   * | Object[]          | Creates a new store, populated with records created from supplied data |
   * | Core.data.Model[] | Creates a new store, populated with supplied records                   |
   *
   *
   * @param {Core.data.Store|Object|String|Object[]|Core.data.Model[]} config
   * @param {Object} [defaults] Config object to apply when creating a new store for passed data
   * @param {Function} [converterFn] Function called for each data object prior to creating a record from it. The
   * return value is used to create a record.
   * @private
   */


  static from(config, defaults = {}, converterFn = null) {
    // null and store instances pass through
    if (config && !config.isStore) {
      // Passed a string, get store by id
      if (typeof config === 'string') {
        config = Store.getStore(config);
      } // Passed something else, create a store using the input as its data
      else {
        // Array of records or data, pass to converterFn if one is supplied
        if (Array.isArray(config)) {
          if (converterFn) {
            config = config.map(data => data.isModel ? data : converterFn(data));
          }

          config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].assign({}, defaults, {
            data: config
          });
        }

        config = new Store(config);
      }
    }

    return config;
  }

  doDestroy() {
    var _me$_storage, _me$stm, _me$stm$removeStore;

    const me = this,
          allRecords = me.registeredRecords;

    for (let i = allRecords.length - 1, rec; i >= 0; i--) {
      var _rec;

      rec = allRecords[i];

      if (!((_rec = rec) !== null && _rec !== void 0 && _rec.isDestroyed)) {
        rec.unjoinStore(me);
      }
    }

    (_me$_storage = me._storage) === null || _me$_storage === void 0 ? void 0 : _me$_storage.destroy(); // Remove from STM if added there (STM might also have gotten destroyed before us)

    (_me$stm = me.stm) === null || _me$stm === void 0 ? void 0 : (_me$stm$removeStore = _me$stm.removeStore) === null || _me$stm$removeStore === void 0 ? void 0 : _me$stm$removeStore.call(_me$stm, me);

    if (!me.isChained) {
      var _me$rootNode;

      (_me$rootNode = me.rootNode) === null || _me$rootNode === void 0 ? void 0 : _me$rootNode.destroy();
    } // Events superclass fires destroy event.


    super.doDestroy(); //TODO abort any ongoing loads
  }
  /**
   * Stops this store from firing events until {@link #function-endBatch} is called. Multiple calls to `beginBatch`
   * stack up, and will require an equal number of `endBatch` calls to resume events.
   *
   * Upon call of {@link #function-endBatch}, a {@link #event-refresh} event is triggered to allow UIs to
   * update themselves based upon the new state of the store.
   *
   * This is extremely useful when making a large number of changes to a store. It is important not to trigger
   * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
   * store are only updated once at the end of the updates.
   */


  beginBatch() {
    this.suspendEvents();
  }
  /**
   * Ends event suspension started by {@link #function-beginBatch}. Multiple calls to {@link #function-beginBatch}
   * stack up, and will require an equal number of `endBatch` calls to resume events.
   *
   * Upon call of `endBatch`, a {@link #event-refresh} event with `action: batch` is triggered to allow UIs to update
   * themselves based upon the new state of the store.
   *
   * This is extremely useful when making a large number of changes to a store. It is important not to trigger
   * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
   * store are only updated once at the end of the updates.
   */


  endBatch() {
    if (this.resumeEvents()) {
      this.trigger('refresh', {
        action: 'batch',
        data: this.storage.values,
        records: this.storage.values
      });
    }
  }

  set storage(storage) {
    const me = this;

    if (storage !== null && storage !== void 0 && storage.isCollection) {
      me._storage = storage;
    } else {
      me._storage = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_10__["default"](storage);
    }

    me._storage.autoFilter = me.reapplyFilterOnAdd;
    me._storage.autoSort = me.reapplySortersOnAdd; // Join all the constituent records to this Store

    for (const r of me._storage) {
      r.joinStore(me);
    }

    me._storage.on({
      change: 'onDataChange',
      thisObj: me
    });
  }

  get storage() {
    if (!this._storage) {
      this.storage = {};
    }

    return this._storage;
  }
  /**
   * Returns all records (not filtered) from the store.
   * @property {Core.data.Model[]}
   * @readonly
   * @category Records
   */


  get allRecords() {
    const me = this;

    if (me.isTree) {
      const result = me.collectDescendants(me.rootNode, undefined, undefined, {
        unfiltered: true
      }).all;

      if (me.rootVisible) {
        result.unshift(me.rootNode);
      }

      return result;
    } else {
      return me.isGrouped ? me.collectGroupRecords() : me.storage.allValues;
    }
  }
  /**
   * Called by owned record when the record has its {@link Core.data.Model#property-isCreating}
   * property toggled.
   * @param {Core.data.Model} record The record that is being changed.
   * @param {Boolean} isCreating The new value of the {@link Core.data.Model#property-isCreating} property.
   * @internal
   */


  onIsCreatingToggle(record, isCreating) {
    const me = this,
          newlyPersistable = record.isPersistable && !isCreating; // If it's a transient "isCreating" record, waiting to be confirmed as a new entry
    // into the store, then it should *not* be in the added Bag as a syncable record.
    // If we are upgrading it to a permanent record, it *should* be in the added Bag.

    me.added[newlyPersistable ? 'add' : 'remove'](record); // If the record is newly persistable...

    if (newlyPersistable) {
      /**
       * Fired when a temporary record with the {@link Core.data.Model#property-isCreating} property set
       * has been confirmed as a part of this store by having its {@link Core.data.Model#property-isCreating}
       * property cleared.
       * @event addConfirmed
       * @param {Core.data.Store} source This Store.
       * @param {Core.data.Model} record The record confirmed as added.
       */
      me.trigger('addConfirmed', {
        record
      }); // AjaxStore to commit confirmed new record

      if (me.autoCommit) {
        me.doAutoCommit();
      }
    }
  }

  joinRecordsToStore(records) {
    records.forEach(record => {
      record.joinStore(this);
    });
  }
  /**
   * Responds to mutations of the underlying storage Collection
   * @param {Object} event
   * @protected
   */


  onDataChange({
    source: storage,
    action,
    added,
    removed,
    replaced,
    oldCount,
    items,
    from,
    to
  }) {
    const me = this,
          addedCount = added === null || added === void 0 ? void 0 : added.length,
          removedCount = removed === null || removed === void 0 ? void 0 : removed.length;
    let filtersWereReapplied, sortersWereReapplied;
    me._idMap = null;

    if (addedCount) {
      me.joinRecordsToStore(added);
    }

    replaced === null || replaced === void 0 ? void 0 : replaced.forEach(([oldRecord, newRecord]) => {
      oldRecord.unjoinStore(me, true);
      newRecord.joinStore(me);
    }); // Allow mixins to mutate the storage before firing events.
    // StoreGroup does this to introduce group records into the mix.

    super.onDataChange(...arguments); // Join/unjoin incoming/outgoing records unless its as a result of TreeNode operations.
    // If we are a tree, joining is done when nodes are added/removed
    // as child nodes of a joined parent.

    if (!me.isTree) {
      if (addedCount) {
        for (const record of added) {
          // If was removed, remove from `removed` list
          if (me.removed.includes(record)) {
            me.removed.remove(record);
          } // Else add to `added` list
          else {
            me.added.add(record);
          }
        } // Re-evaluate the current *local* filter set silently so that the
        // information we are broadcasting below is up to date.


        filtersWereReapplied = !me.remoteFilter && me.filtered && me.reapplyFilterOnAdd;

        if (filtersWereReapplied) {
          me.filter({
            silent: true
          });
        } // if sortParamName not defined, is not remote sort


        sortersWereReapplied = !me.sortParamName && me.isSorted && me.reapplySortersOnAdd;

        if (sortersWereReapplied) {
          me.sort(null, null, false, true);
        }
      }

      if (removedCount) {
        for (const record of removed) {
          // If app was in the middle of a batched update, cancel the update.
          record.cancelBatch();
          record.unjoinStore(me); // If was newly added, remove from `added` list

          if (me.added.includes(record)) {
            me.added.remove(record);
          } // Else add to `removed` list
          // Unless it's StateTrackingManager reverting the record insertion.
          // Also unless it's a record which was a transient record created by the UI
          // and then the create was canceled at the edit stage.
          else if (!record._undoingInsertion && !record.meta.isCreating) {
            me.removed.add(record);
          }
        }

        me.modified.remove(removed); // Re-evaluate the current *local* filter set silently so that the
        // information we are broadcasting below is up to date.

        filtersWereReapplied = !me.remoteFilter && me.filtered;

        if (filtersWereReapplied) {
          me.filter({
            silent: true
          });
        }
      }
    }

    switch (action) {
      case 'clear':
        // Clear our own relationCache, since we will be empty
        me.relationCache = {}; // Signal to stores that depend on us

        me.updateDependentStores('removeall');
        me.trigger('removeAll');
        me.trigger('change', {
          action: 'removeall'
        });
        break;

      case 'splice':
        if (addedCount) {
          me.updateDependentStores('add', added);
          const // Collection does not handle moves, figure out if and where a record was moved from by checking
          // previous index value stored in meta
          oldIndex = added.reduce((lowest, record) => {
            const {
              previousIndex
            } = record.meta;
            if (previousIndex > -1 && previousIndex < lowest) lowest = previousIndex;
            return lowest;
          }, added[0].meta.previousIndex),
                index = storage.indexOf(added[0], !storage.autoFilter),
                params = {
            records: added,
            index
          }; // Only include param oldIndex when used

          if (oldIndex > -1) {
            params.oldIndex = oldIndex;
          }

          me.trigger('add', params);
          me.trigger('change', Object.assign({
            action: 'add'
          }, params));

          if (filtersWereReapplied) {
            me.triggerFilterEvent({
              action: 'filter',
              filters: me.filters,
              oldCount,
              records: me.storage.allValues
            });
          }

          if (sortersWereReapplied) {
            me.trigger('sort', {
              action: 'sort',
              sorters: me.sorters,
              records: me.storage.allValues
            });
          }
        }

        if (removed.length) {
          me.updateDependentStores('remove', removed);
          me.trigger('remove', {
            records: removed
          });
          me.trigger('change', {
            action: 'remove',
            records: removed
          });
        }

        if (replaced.length) {
          me.trigger('replace', {
            records: replaced,
            all: me.records.length === replaced.length
          });
          me.trigger('change', {
            action: 'replace',
            replaced,
            all: me.records.length === replaced.length
          });
        }

        break;

      case 'filter':
        // Reapply grouping/sorting to make sure unfiltered records get sorted correctly
        if (me.isGrouped || me.isSorted) {
          me.performSort(true);
        }

        break;

      case 'move':
        // silently update parentIndex of records affected
        for (let allRecords = me.storage.allValues, i = Math.min(from, to); i <= Math.max(from, to); i++) {
          allRecords[i].setData('parentIndex', i);
        }
        /**
         * Fired when a block of records has been moved within this Store
         * @event move
         * @param {Core.data.Store} source This Store
         * @param {Core.data.Model} record (DEPRECATED) The first record moved (The
         * {@link Core.data.mixin.StoreCRUD#function-move} API now accepts an array of records to move).
         * @param {Core.data.Model[]} records The records moved.
         * @param {Number} from The index from which the record was removed (applicable only for flat store).
         * @param {Number} to The index at which the record was inserted (applicable only for flat store).
         * @param {Core.data.Model} newParent The new parent record for the dragged records (applicable only for tree stores)
         */


        me.trigger('move', {
          record: items[0],
          records: items,
          from,
          to
        }); // The move was in real data. If we are filtered, the
        // filtered set has to be refreshed.

        if (me.isFiltered) {
          me.performFilter();
        }

        me.trigger('change', {
          action,
          record: items[0],
          records: items,
          from,
          to
        });
        break;
    }
  }

  onDataReplaced(action, data) {
    var _me$afterLoadData;

    const me = this,
          all = me.storage.allValues;

    for (let i = 0; i < all.length; i++) {
      all[i].joinStore(me);
    } // Need to update group records info (headers and footers)


    me.prepareGroupRecords(); // The three operations below, filter, store and sort, all are passed
    // the "silent" parameter meaning they do not fire their own events.
    // The 'refresh' and 'change' events after are used to update UIs.

    if (!me.remoteFilter && me.isFiltered) {
      me.filter({
        silent: true
      });
    } // TODO: groupers must just be promoted to be the primary sorters.


    if (me.isGrouped) {
      me.group(null, null, false, !me.sorters.length, true);
    }

    if (!me.sortParamName && me.sorters.length) {
      me.sort(null, null, false, true);
    } // Check for duplicate ids, unless user guarantees data validity


    if (!me.useRawData.disableDuplicateIdCheck) {
      const idMap = me.idMap;

      if (Object.keys(idMap).length < me.storage.values.length) {
        // idMap has fewer entries than expected, a duplicate id was used. pick idMap apart to find out which
        const collisions = [];
        me.storage.values.forEach(r => idMap[r.id] ? delete idMap[r.id] : collisions.push(r));
        throw new Error(`Id collision on ${collisions.map(r => r.id)}`);
      }
    }

    const event = {
      action,
      data,
      records: me.storage.values
    };
    me.updateDependentStores(action, event.records); // Allow subclasses to postprocess a new dataset

    (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);
    me.trigger('refresh', event);
    me.trigger('change', event);
  }
  /**
   * This is called from Model after mutating any fields so that Stores can take any actions necessary at that point,
   * and distribute mutation event information through events.
   * @param {Core.data.Model} record The record which has just changed
   * @param {Object} toSet A map of the field names and values that were passed to be set
   * @param {Object} wasSet A map of the fields that were set. Each property is a field name, and
   * the property value is an object containing two properties: `oldValue` and `value` eg:
   * ```javascript
   *     {
   *         name {
   *             oldValue : 'Rigel',
   *             value : 'Nigel'
   *         }
   *     }
   *
   * @param {Boolean} silent Do not trigger events
   * @param {Boolean} fromRelationUpdate Update caused by a change in related model
   * @private
   */


  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    const me = this,
          idField = record.constructor.idField,
          event = {
      record,
      records: [record],
      changes: wasSet,
      // Cannot use isBatching, since change is triggered when batching has reached 0
      // (but before it is set to null)
      batch: record.batching != null,
      fromRelationUpdate
    },
          committable = record.ignoreBag ? false : me.updateModifiedBagForRecord(record); // Inform underlying collection of the changes, allowing it to keep any indices up to date

    me.storage.onItemMutation(record, wasSet);

    if (!silent) {
      if (idField in wasSet) {
        const {
          oldValue,
          value
        } = toSet[idField];
        me.updateDependentRecordIds(oldValue, value);
        me.onRecordIdChange({
          record,
          oldValue,
          value
        });
        me.trigger('idChange', {
          store: me,
          record,
          oldValue,
          value
        });
      }

      me.onUpdateRecord(record, wasSet);
      me.trigger('update', event);
      me.trigger('change', Object.assign({
        action: 'update'
      }, event));
    }

    if (me.autoCommit && committable) {
      me.doAutoCommit();
    }
  }

  updateModifiedBagForRecord(record) {
    const me = this;
    let addedToBag = false; // Add or remove from our modified Bag

    if (record.isModified) {
      if (!me.modified.includes(record) && !me.added.includes(record) && record.isPartOfStore(me) && !record.isAutoRoot) {
        // When we add a new model first time and the model is not persistable (for example when the model is not valid),
        // it is not added to the "added" collection (StoreBag), but only joined to the store.
        // So if the record is not added neither to "modified" nor "added",
        // need to check if this record is phantom. If so, add it to the "added", otherwise to the "modified".
        if (record.isPhantom) {
          me.added.add(record);
        } else {
          me.modified.add(record);
        }

        addedToBag = true;
      }
    } else {
      me.modified.remove(record);
    }

    return addedToBag;
  }

  get idMap() {
    const me = this,
          processedRecords = me.storage.values,
          needsRebuild = !me._idMap,
          idMap = me._idMap || (me._idMap = {});

    if (needsRebuild) {
      for (let record, index = 0, visibleIndex = 0; index < processedRecords.length; index++) {
        record = processedRecords[index];
        idMap[record.id] = {
          index,
          visibleIndex,
          record
        };

        if (!record.isSpecialRow) {
          visibleIndex++;
        }
      }
    }

    return idMap;
  }

  changeModelClass(ClassDef) {
    const fields = this.fields; // noinspection JSRedeclarationOfBlockScope

    let ClassDefEx = null; // Ensure our modelClass is exchanged for an extended of modelClass decorated with any configured fields.

    if (fields !== null && fields !== void 0 && fields.length) {
      ClassDefEx = class extends ClassDef {
        static get fields() {
          return fields;
        }

      };
    } // If we expose properties on Model we will pollute all other models, use internal subclass instead
    else if (!this.preventSubClassingModel) {
      ClassDefEx = class extends ClassDef {};
    } else {
      ClassDefEx = ClassDef;
    } // Need to properly expose relations on this new subclass


    ClassDefEx.initClass();
    return ClassDefEx;
  } //endregion
  //region Store id & map
  // Deprecated.
  // TODO: Remove in 2.0 when all references have been removed from Scheduler and Gantt


  set storeId(storeId) {
    this.id = storeId;
  }

  get storeId() {
    return this.id;
  }

  changeId(id, oldId) {
    return super.changeId(id !== true && id, oldId);
  }

  updateId(id, oldId) {
    // Store code always did just evict any other instance by that ID.
    // TODO: Should we tighten this up?
    const duplicate = Store.getById(id);
    duplicate && Store.unregisterInstance(duplicate);
    super.updateId(id, oldId);
  }

  generateAutoId() {
    return Store.generateId(`store-`);
  }

  get tree() {
    return this._tree;
  }

  set tree(tree) {
    this._tree = tree;

    if (tree && !this.rootNode) {
      this.rootNode = this.buildRootNode();
      this.rootNode.isAutoRoot = true;
    }
  } // a hook to build a customized root node


  buildRootNode() {
    return {};
  }
  /**
   * Get a store from the store map by id.
   * @param {String|Number|Object[]} id The id of the store to retrieve, or an array of objects
   * from which to create the contents of a new Store.
   * @returns {Core.data.Store} The store with the specified id
   */


  static getStore(id, storeClass) {
    if (id instanceof Store) {
      return id;
    }

    if (this.getById(id)) {
      return this.getById(id);
    }

    if (Array.isArray(id)) {
      let storeModel;
      const storeData = id.map(item => {
        if (item instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
          storeModel = item.constructor;
        } else if (typeof item === 'string') {
          item = {
            text: item
          };
        } else {}

        return item;
      });
      id = {
        autoCreated: true,
        data: storeData,
        modelClass: storeModel || class extends _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"] {},
        allowNoId: true // String items have no id and are not guaranteed to be unique

      };

      if (!storeClass) {
        storeClass = Store;
      }
    }

    if (storeClass) {
      return new storeClass(id);
    }
  }
  /**
   * Get all registered stores
   * @property {Core.data.Store[]}
   */


  static get stores() {
    return Store.registeredInstances;
  } //endregion
  //region Data

  /**
   * The invisible root node of this tree.
   * @property {Core.data.Model}
   * @readonly
   * @category Tree
   */


  get rootNode() {
    return this.masterStore ? this.masterStore.rootNode : this._rootNode;
  }

  set rootNode(rootNode) {
    var _rootNode$children;

    const me = this,
          oldRoot = me._rootNode; // No change

    if (rootNode === oldRoot) {
      return;
    }

    if (oldRoot) {
      me.clear(true);
    }

    if (rootNode instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
      // We insist that the rootNode is expanded otherwise no children will be added
      rootNode.instanceMeta(me).collapsed = false;
      me._rootNode = rootNode;
    } else {
      me._rootNode = rootNode = new me.modelClass(Object.assign({
        expanded: true,
        [me.modelClass.idField]: `${me.id}-rootNode`
      }, rootNode), me, null, true);
    }

    me._tree = true;
    rootNode.isRoot = true;
    rootNode.joinStore(me); // If there are nodes to be inserted into the flat storage
    // then onNodeAddChild knows how to do that and what events
    // to fire based upon rootNode.isLoading.

    if ((_rootNode$children = rootNode.children) !== null && _rootNode$children !== void 0 && _rootNode$children.length || me.rootVisible) {
      rootNode.isLoading = true;
      me.onNodeAddChild(rootNode, rootNode.children || [], 0);
      rootNode.isLoading = false;
    }

    me.trigger('rootChange', {
      oldRoot,
      rootNode
    });
  }
  /**
   * Sets data in the store.
   *
   * Expects an array of JavaScript objects, with properties matching store's fields (defined on its
   * {@link #config-modelClass model} or in the {@link #config-fields} config).
   *
   * Called on initialization if data is in config otherwise call it yourself after ajax call etc. Can also be used to
   * get the raw original data.
   *
   * ```javascript
   * store.data = [
   *   { id : 1, name : 'Linda', city : 'NY' },
   *   { id : 2, name : 'Olivia', city : 'Paris' },
   *   ...
   * ];
   * ```
   *
   * @property {Object[]}
   * @fires refresh
   * @fires change
   * @category Records
   */


  set data(data) {
    this.setStoreData(data);
  } // For overridability in engine


  setStoreData(data) {
    var _data;

    const me = this,
          {
      idField,
      childrenField
    } = me.modelClass; // Make sure that if the plugins have not been processed yet, we call
    // the temporary property getter which configuration injects to
    // process plugins at this point. Some plugins are required to
    // operate on incoming data.

    me.getConfig('plugins'); // In case data is loaded during configuration before configuredListeners have been processed

    me.processConfiguredListeners(); // Allow data as a "named object", using keys as ids

    if (data && !Array.isArray(data)) {
      data = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].transformNamedObjectToArray(data, idField);
    } // Convert to being a tree store if any of the new rows have a children property


    me.tree = !me.isChained && (me.tree || Boolean(me.autoTree && ((_data = data) === null || _data === void 0 ? void 0 : _data.some(r => r[childrenField])))); // Always load a new dataset initially

    if (!me.syncDataOnLoad || !me._data) {
      me._data = data; // This means load the root node

      if (me.tree) {
        if (me.transformFlatData) {
          data = me.treeifyFlatData(data);
        }

        const root = me.rootNode;
        root.isLoading = true; // clear silently without marking as removed

        me.clear(true); // Append child will detect that this is a dataset operation and trigger sort + events needed

        root.appendChild(data);
        me.updateDependentStores('dataset', [root]);
        root.isLoading = false;

        if (data.length === 0) {
          const event = {
            action: 'dataset',
            data: [],
            records: []
          };
          me.trigger('refresh', event);
          me.trigger('change', event);
        } // we must re-apply filters for the filtered tree store
        else if (me.isFiltered) {
          me.filter();
        }
      } else {
        me.loadData(data);
      } // loading the store discards all tracked changes


      me.added.clear();
      me.removed.clear();
      me.modified.clear();
    } // Sync dataset if configured to do so
    else {
      me.syncDataset(data);
    }
  }

  loadData(data, action = 'dataset') {
    const me = this,
          {
      storage,
      allowNoId
    } = me,
          idField = me.modelClass.fieldMap.id.dataSource; // Need to unregister all groups

    me.removeHeadersAndFooters(me.storage.values);
    me._idMap = null;

    if (data) {
      const isRaw = !(data[0] instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

      if (isRaw) {
        me.modelClass.exposeProperties(data[0]);
        const count = data.length,
              records = new Array(count);

        for (let i = 0; i < count; i++) {
          const recordData = data[i];

          if (!allowNoId && recordData[idField] == null) {
            throw new Error(`Id required but not found on row ${i}`);
          }

          records[i] = me.processRecord(me.createRecord(recordData, true), true);
          records[i].setData('parentIndex', i);
        } // clear without marking as removed


        me.clear(true); // Allow Collection's own filters to work on the Collection by
        // passing the isNewDataset param as true.
        // The storage Collection may have been set up with its own filters
        // while we are doing remote filtering. An example is ComboBox
        // with filterSelected: true. Records which are in the selection are
        // filtered out of visibility using a filter directly in the Combobox's
        // Store's Collection.

        storage.replaceValues({
          values: records,
          isNewDataset: true,
          silent: true
        });
      } else {
        // clear without marking as removed
        me.clear(true);
        storage.replaceValues({
          values: data.slice(),
          isNewDataset: true,
          silent: true
        });
      }

      me.onDataReplaced(action, data);
    } else {
      // clear without marking as removed
      me.clear(true);
      me._data = null;
    }
  }

  get data() {
    return this._data;
  }
  /**
   * Creates an array of records from this store from the `start` to the `end' - 1
   * @param {Number} [start] The index of the first record to return
   * @param {Number} [end] The index *after* the last record to return `(start + length)`
   * @return {Core.data.Model[]} The requested records.
   * @category Records
   */


  getRange(start, end, all = true) {
    return (all ? this.storage.allValues : this.storage.values).slice(start, end);
  }
  /**
   * Creates a model instance, used internally when data is set/added. Override this in a subclass to do your own custom
   * conversion from data to record.
   * @param {Object} data Json data
   * @param {Boolean} [skipExpose] Supply true when batch setting to not expose properties multiple times
   * @category Records
   */


  createRecord(data, skipExpose = false) {
    return new this.modelClass(data, this, null, skipExpose);
  }

  processRecord(record, isDataset = false) {
    return record;
  }

  refreshData() {
    this.filter();
    this.sort();
  }

  onRecordIdChange({
    record,
    oldValue,
    value
  }) {
    const me = this,
          idMap = me._idMap,
          {
      idRegister
    } = me;
    me.storage._indicesInvalid = true;

    if (idMap) {
      delete idMap[oldValue];
      idMap[value] = record;
    }

    me.added.changeId(oldValue, value);
    me.removed.changeId(oldValue, value);
    me.modified.changeId(oldValue, value);
    delete idRegister[oldValue];
    idRegister[value] = record;
    record.index = me.storage.indexOf(record);
  }

  onUpdateRecord(record, changes) {
    const {
      internalId
    } = changes,
          {
      internalIdRegister
    } = this;

    if (internalId) {
      this.storage._indicesInvalid = true;
      delete internalIdRegister[internalId.oldValue];
      internalIdRegister[internalId.value] = record;
    } // Reapply filters when records change?


    if (this.reapplyFilterOnUpdate && this.isFiltered) {
      this.filter();
    }
  }

  get useRawData() {
    return this._useRawData;
  }

  set useRawData(options) {
    if (options === true) {
      this._useRawData = {
        enabled: true,
        disableDuplicateIdCheck: true,
        disableTypeConversion: true,
        disableDefaultValue: false
      };
    } else {
      this._useRawData = options ? Object.assign(options, {
        enabled: true
      }) : {
        enabled: false
      };
    }
  } //endregion
  //region Count

  /**
   * Number of records in the store
   * @param {Boolean} [countProcessed] Count processed (true) or real records (false)
   * @returns {Number} Record count
   * @category Records
   */


  getCount(countProcessed = true) {
    return countProcessed ? this.count : this.originalCount;
  }
  /**
   * Record count, for data records. Not including records added for group headers etc.
   * @property {Number}
   * @readonly
   * @category Records
   */


  get originalCount() {
    var _this$groupRecords;

    return this.storage.totalCount - (((_this$groupRecords = this.groupRecords) === null || _this$groupRecords === void 0 ? void 0 : _this$groupRecords.length) || 0);
  }
  /**
   * Record count, including records added for group headers etc.
   * @property {Number}
   * @readonly
   * @category Records
   */


  get count() {
    return this.storage.count;
  }
  /**
   * Returns the complete dataset size regardless of tree node collapsing or filtering
   * @property {Number}
   * @readonly
   * @category Records
   */


  get allCount() {
    return this.isTree ? this.rootNode.descendantCount : this.storage.totalCount;
  } //endregion
  //region Get record(s)
  // TODO: Implement immutable tag for docs #1206

  /**
   * Returns all "visible" records.
   * **Note:** The returned value **may not** be mutated!
   * @property {Core.data.Model[]}
   * @readonly
   * @immutable
   * @category Records
   */


  get records() {
    return this.storage.values;
  }
  /**
   * Get the first record in the store.
   * @property {Core.data.Model}
   * @readonly
   * @category Records
   */


  get first() {
    return this.storage.values[0];
  }
  /**
   * Get the last record in the store.
   * @property {Core.data.Model}
   * @readonly
   * @category Records
   */


  get last() {
    return this.storage.values[this.storage.values.length - 1];
  }
  /**
   * Get the record at the specified index
   * @param {Number} index Index for the record
   * @returns {Core.data.Model} Record at the specified index
   * @category Records
   */


  getAt(index, all = false) {
    // all means include filtered out records
    return this.storage.getAt(index, all);
  } // These are called by Model#join and Model#unjoin
  // register a record as a findable member keyed by id and internalId


  register(record) {
    const me = this,
          // Test for duplicate IDs on register only when a tree store.
    // loadData does it in the case of a non-tree
    existingRec = me.isTree && me.idRegister[record.id];

    if (existingRec && existingRec !== record) {
      throw new Error(`Id collision on ${record.id}`);
    }

    me.idRegister[record.id] = record;
    me.internalIdRegister[record.internalId] = record;
  }

  unregister(record) {
    delete this.idRegister[record.id];
    delete this.internalIdRegister[record.internalId];
  }

  get registeredRecords() {
    return Object.values(this.idRegister);
  }
  /**
   * Get a record by id. Find the record even if filtered out, part of collapsed group or collapsed node
   * @param {Core.data.Model|String|Number} id Id of record to return.
   * @returns {Core.data.Model} A record with the specified id
   * @category Records
   */


  getById(id) {
    // In case `id` is a record, we use its ID to try to find the record in the store,
    // because if the record is removed from the store it shouldn't be found.
    // if (id instanceof Model) {
    //     id = id.id;
    // }
    if (id !== null && id !== void 0 && id.isModel) {
      return id;
    } //return this.tree ? this.idRegister[id] : this.storage.get(id);


    return this.idRegister[id];
  }
  /**
   * Checks if a record is available, in the sense that it is not filtered out,
   * hidden in a collapsed group or in a collapsed node.
   * @param {Core.data.Model|String|Number} recordOrId Record to check
   * @returns {Boolean}
   * @category Records
   */


  isAvailable(recordOrId) {
    const record = this.getById(recordOrId);
    return record && this.storage.includes(record) || false;
  }
  /**
   * Get a record by internalId.
   * @param {Number} internalId The internalId of the record to return
   * @returns {Core.data.Model} A record with the specified internalId
   * @category Records
   */


  getByInternalId(internalId) {
    return this.internalIdRegister[internalId];
  }
  /**
   * Checks if the specified record is contained in the store
   * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record
   * @returns {Boolean}
   * @category Records
   */


  includes(recordOrId) {
    if (this.isTree) {
      return this.idRegister[_Model_js__WEBPACK_IMPORTED_MODULE_5__["default"].asId(recordOrId)] != null;
    }

    return this.indexOf(recordOrId) > -1;
  } //endregion
  //region Get index

  /**
   * Returns the index of the specified record/id, or `-1` if not found.
   * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record to return the index of.
   * @param {Boolean} [visibleRecords] Pass `true` to find the visible index.
   * as opposed to the dataset index. This omits group header records.
   * @returns {Number} Index for the record/id, or `-1` if not found.
   * @category Records
   */


  indexOf(recordOrId, visibleRecords = false) {
    // Only check records actually in the store ($store is for objectify scenario)
    if (recordOrId !== null && recordOrId !== void 0 && recordOrId.isModel && !recordOrId.stores.includes(this.$store || this)) {
      return -1;
    }

    const id = _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"].asId(recordOrId);

    if (id == null) {
      return -1;
    } // When a tree, indexOf is always in the visible records - filtering is different in trees.


    if (this.isTree) {
      return this.storage.indexOf(id);
    }

    const found = this.idMap[id];
    return found ? found[visibleRecords ? 'visibleIndex' : 'index'] : -1;
  }

  allIndexOf(recordOrId) {
    if (this.isTree) {
      const record = this.getById(recordOrId);
      let result = -1; // Use the tree structure to get the index in tree walk order

      if (record) {
        record.bubble(n => {
          if (n.parent) {
            result += n.parentIndex + 1;
          } else if (n === this.rootNode && this.rootVisible) {
            result += 1;
          }
        });
      }

      return result;
    } else {
      return this.storage.indexOf(recordOrId, true);
    }
  } //endregion
  //region Get values

  /**
   * Returns an array of distinct values for the specified field.
   *
   * ```javascript
   * store.getDistinctValues('age'); // Returns an array of the unique age values
   * ```
   *
   * @param {String} field Field to extract values for
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters
   * @returns {Array} Array of values
   * @category Values
   */


  getDistinctValues(field, searchAllRecords = false) {
    const me = this,
          values = [],
          keys = {};
    let value;
    me.forEach(r => {
      if (!r.isSpecialRow && !r.isRoot) {
        value = r.get(field);
        const primitiveValue = value instanceof Date ? value.getTime() : value;

        if (!keys[primitiveValue]) {
          values.push(value);
          keys[primitiveValue] = 1;
        }
      }
    }, me, searchAllRecords);
    return values;
  }
  /**
   * Counts how many times specified value appears in the store
   * @param {String} field Field to look in
   * @param {*} value Value to look for
   * @returns {Number} Found count
   * @category Values
   */


  getValueCount(field, value) {
    let count = 0;
    this.forEach(r => {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isEqual(r.get(field), value)) count++;
    });
    return count;
  } //endregion
  //region JSON & console

  /**
   * Retrieve or set the data of all records as a JSON string
   *
   * ```javascript
   * const store = new Store({
   *     data : [
   *         { id : 1, name : 'Superman' },
   *         { id : 2, name : 'Batman' }
   *     ]
   * });
   *
   * const jsonString = store.json;
   *
   * //jsonString:
   * '[{"id":1,"name":"Superman"},{"id":2,"name":"Batman"}]
   * ```
   *
   * @property {String}
   */


  set json(json) {
    if (typeof json === 'string') {
      json = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(json);
    }

    this.data = json;
  }

  get json() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonStringify(this);
  }
  /**
   * Pretty printed version of {@link #property-json}
   * @readonly
   * @property {String}
   */


  get formattedJSON() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonStringify(this, null, 4);
  }
  /**
   * Retrieve the data of all records as an array of JSON objects
   *
   * ```javascript
   * const store = new Store({
   *     data : [
   *         { id : 1, name : 'Superman' },
   *         { id : 2, name : 'Batman' }
   *     ]
   * });
   *
   * const jsonArray = store.toJSON();
   *
   * //jsonArray:
   * [{id:1,name:"Superman"},{id:2,name:"Batman"}]
   * ```
   *
   * @returns {Object[]}
   */


  toJSON() {
    // extract entire structure.
    // If we're a tree, then that consists of the payload of the rootNode.
    return (this.isTree ? this.rootNode.children || [] : this).map(record => record.toJSON());
  } //endregion
  //region Iteration & traversing

  /**
   * Iterates over all normal records in store. Omits group header and footer records
   * if this store is grouped.
   * @param {Function} fn A function that is called for each record. Returning false from that function cancels iteration
   * @param {Object} [thisObj] `this` reference for the function
   * @param {Object|Boolean} [options] A boolean for includeFilteredOutRecords, or detailed options for exclude/include records
   * @param {Boolean} [options.includeFilteredOutRecords] True to also include filtered out records
   * @param {Boolean} [options.includeCollapsedGroupRecords] True to also include records from collapsed groups of grouped store
   * @category Iteration
   */


  forEach(fn, thisObj = this, options) {
    // backward compatibility to support includeFilteredOutRecords parameter instead of options
    options = options === undefined ? false : options; // TODO clean up and remove boolean option

    if (typeof options === 'boolean') {
      options = {
        includeFilteredOutRecords: options,
        includeCollapsedGroupRecords: false
      };
    }

    const callback = (r, i) => {
      if (!r.isRoot && !r.isSpecialRow) {
        return fn.call(thisObj, r, i);
      }
    };

    if (this.isTree) {
      this.rootNode.traverseWhile(callback, false, options.includeFilteredOutRecords);
    } else {
      // native forEach cannot be aborted by returning false, have to loop "manually"
      const records = options.includeFilteredOutRecords ? this.storage.allValues : this.storage.values; // grouped store has own tree-like structure, but cannot be handled like a regular tree

      if (this.isGrouped && options.includeCollapsedGroupRecords) {
        for (let i = 0; i < records.length; i++) {
          const record = records[i];

          if (record.groupChildren && record.meta.collapsed === true) {
            for (let j = 0; j < record.groupChildren.length; j++) {
              const rec = record.groupChildren[j];

              if (callback(rec, j) === false) {
                return;
              }
            }
          } else if (callback(record, i) === false) {
            return;
          }
        }
      } else {
        for (let i = 0; i < records.length; i++) {
          if (callback(records[i], i) === false) {
            return;
          }
        }
      }
    }
  }
  /**
   * Equivalent to Array.map(). Creates a new array with the results of calling a provided function on every record
   * @param {Function} fn
   * @returns {Array}
   * @category Iteration
   */


  map(fn, thisObj = this) {
    return this.storage.values.map(fn, thisObj);
  }
  /**
   * Equivalent to Array.reduce(). Applies a function against an accumulator and each record (from left to right) to
   * reduce it to a single value.
   * @param {Function} fn
   * @param {*} initialValue
   * @returns {*}
   * @category Iteration
   */


  reduce(fn, initialValue = [], thisObj = this) {
    if (thisObj !== this) {
      fn = fn.bind(thisObj);
    }

    return this.storage.values.reduce(fn, initialValue, thisObj);
  }
  /**
   * Iterator that allows you to do for (let record of store)
   * @category Iteration
   */


  [Symbol.iterator]() {
    return this.storage.values[Symbol.iterator]();
  }
  /**
   * Traverse all tree nodes (only applicable for Tree Store)
   * @param {Function} fn The function to call on visiting each node.
   * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
   * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
   * @param {Object|Boolean} [options] A boolean for includeFilteredOutRecords, or detailed options for exclude/include records
   * @param {Boolean} [options.includeFilteredOutRecords] True to also include filtered out records
   * @param {Boolean} [options.includeCollapsedGroupRecords] True to also include records from collapsed groups of grouped store
   * @category Traverse
   */


  traverse(fn, topNode = this.rootNode, skipTopNode = topNode === this.rootNode, options) {
    // backward compatibility to support includeFilteredOutRecords parameter instead of options
    options = options === undefined ? false : options; // TODO remove boolean option

    if (typeof options === 'boolean') {
      options = {
        includeFilteredOutRecords: options,
        includeCollapsedGroupRecords: false
      };
    }

    const me = this;

    if (me.isTree) {
      // Allow store.traverse(fn, true) to start from rootNode
      if (typeof topNode === 'boolean') {
        skipTopNode = topNode;
        topNode = me.rootNode;
      }

      if (me.isChained) {
        const passedFn = fn;

        fn = node => {
          if (me.chainedFilterFn(node)) {
            passedFn(node);
          }
        };
      }

      topNode.traverse(fn, skipTopNode, options.includeFilteredOutRecords);
    } else {
      me.forEach(rec => rec.traverse(fn, false, options.includeFilteredOutRecords), me, options);
    }
  }
  /**
   * Traverse all tree nodes while the passed `fn` returns true
   * @param {Function} fn The function to call on visiting each node. Returning `false` from it stops the traverse.
   * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
   * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
   * @category Traverse
   */


  traverseWhile(fn, topNode = this.rootNode, skipTopNode = topNode === this.rootNode) {
    const me = this;

    if (me.isTree) {
      // Allow store.traverse(fn, true) to start from rootNode
      if (typeof topNode === 'boolean') {
        skipTopNode = topNode;
        topNode = me.rootNode;
      }

      if (me.isChained) {
        const passedFn = fn;

        fn = node => {
          if (me.chainedFilterFn(node)) {
            passedFn(node);
          }
        };
      }

      topNode.traverseWhile(fn, skipTopNode);
    } else {
      for (const record of me.storage) {
        if (record.traverse(fn) === false) {
          break;
        }
      }
    }
  }
  /**
   * Finds the next record.
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap=false] Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model} Next record or null if current is the last one
   * @category Traverse
   */


  getNext(recordOrId, wrap = false, skipSpecialRows = false) {
    const me = this,
          records = me.storage.values;
    let idx = me.indexOf(recordOrId);

    if (idx >= records.length - 1) {
      if (wrap) {
        idx = -1;
      } else {
        return null;
      }
    }

    const record = records[idx + 1]; // Skip the result if it's a specialRow and we are told to skip them

    if (skipSpecialRows && record && record.isSpecialRow) {
      return me.getNext(records[idx + 1], wrap, true);
    }

    return record;
  }
  /**
   * Finds the previous record.
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap=false] Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model} Previous record or null if current is the last one
   * @category Traverse
   */


  getPrev(recordOrId, wrap = false, skipSpecialRows = false) {
    const me = this,
          records = me.storage.values;
    let idx = me.indexOf(recordOrId);

    if (idx === 0) {
      if (wrap) {
        idx = records.length;
      } else {
        return null;
      }
    }

    const record = records[idx - 1]; // Skip the result if it's a specialRow and we are told to skip them

    if (skipSpecialRows && record && record.isSpecialRow && idx > 0) {
      return me.getPrev(records[idx - 1], wrap, true);
    }

    return record;
  }
  /**
   * Gets the next or the previous record. Optionally wraps from first -> last and vice versa
   * @param {String|Core.data.Model} recordOrId Record or records id
   * @param {Boolean} next Next (true) or previous (false)
   * @param {Boolean} wrap Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model}
   * @category Traverse
   * @internal
   */


  getAdjacent(recordOrId, next = true, wrap = false, skipSpecialRows = false) {
    return next ? this.getNext(recordOrId, wrap, skipSpecialRows) : this.getPrev(recordOrId, wrap, skipSpecialRows);
  }
  /**
   * Finds the next record among leaves (in a tree structure)
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model} Next record or null if current is the last one
   * @category Traverse
   * @internal
   */


  getNextLeaf(recordOrId, wrap = false) {
    const me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
    let idx = records.indexOf(record);

    if (idx >= records.length - 1) {
      if (wrap) {
        idx = -1;
      } else {
        return null;
      }
    }

    return records[idx + 1];
  }
  /**
   * Finds the previous record among leaves (in a tree structure)
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model} Previous record or null if current is the last one
   * @category Traverse
   * @internal
   */


  getPrevLeaf(recordOrId, wrap = false) {
    const me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
    let idx = records.indexOf(record);

    if (idx === 0) {
      if (wrap) {
        idx = records.length;
      } else {
        return null;
      }
    }

    return records[idx - 1];
  }
  /**
   * Gets the next or the previous record among leaves (in a tree structure). Optionally wraps from first -> last and
   * vice versa
   * @param {String|Core.data.Model} recordOrId Record or record id
   * @param {Boolean} [next] Next (true) or previous (false)
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model}
   * @category Traverse
   * @internal
   */


  getAdjacentLeaf(recordOrId, next = true, wrap = false) {
    return next ? this.getNextLeaf(recordOrId, wrap) : this.getPrevLeaf(recordOrId, wrap);
  } //endregion


}
Store.initClass();
Store._$name = 'Store';

/***/ }),

/***/ "./lib/Core/data/StoreBag.js":
/*!***********************************!*\
  !*** ./lib/Core/data/StoreBag.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreBag; });
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");
var productName = 'gantt';

/**
 * @module Core/data/StoreBag
 */

class StoreBag extends _util_Bag_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  add(...toAdd) {
    if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
      toAdd = toAdd[0];
    } // ignore unpersistable records


    return super.add(...toAdd.filter(record => record.isPersistable));
  }

}
;
StoreBag._$name = 'StoreBag';

/***/ }),

/***/ "./lib/Core/data/field/ArrayDataField.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/field/ArrayDataField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ArrayDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/ArrayDataField
 */

/**
 * This field class handles fields that hold an array. For the field to count as modified, the whole array has to be
 * replaced:
 *
 * ```javascript
 * class Task extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'todo', type : 'array' }
 *         ];
 *     }
 * }
 *
 * const task = new Task({
 *     name : 'Task 1',
 *     todo : [
 *         { text : 'Something', done : false },
 *         { text : 'Some other thing', done : true }
 *     ]
 * };
 *
 * // This wont be detected as a modification
 * task.todo[0].done = true;
 * // task.isModified === false
 *
 * // But this will
 * const todo = task.todo.slice(); // Create a new array with same contents
 * todo[0].done = true;
 * task.todo = todo;
 * // task.isModified === true
 * ```
 *
 * @extends Core/data/field/DataField
 * @classtype array
 */

class ArrayDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ArrayDataField';
  }

  static get type() {
    return 'array';
  }

  isEqual(a, b) {
    return a === b;
  }

}
ArrayDataField.initClass();
ArrayDataField._$name = 'ArrayDataField';

/***/ }),

/***/ "./lib/Core/data/field/BooleanDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/BooleanDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/BooleanDataField
 */

/**
 * This field class handles field of type `Boolean`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'active', type : 'boolean' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'boolean'`, non-null values are promoted to `Boolean` type. This is seldom required,
 * but can be useful if a field value is received as a number but should be treated as a boolean.
 *
 * @extends Core/data/field/DataField
 * @classtype boolean
 */

class BooleanDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'BooleanDataField';
  }

  static get type() {
    return 'boolean';
  }

  static get alias() {
    return 'bool';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Boolean}
       * @default
       */
      nullValue: false
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : Boolean(value);
  }

}
BooleanDataField.initClass();
BooleanDataField._$name = 'BooleanDataField';

/***/ }),

/***/ "./lib/Core/data/field/DataField.js":
/*!******************************************!*\
  !*** ./lib/Core/data/field/DataField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataField; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';



/**
 * @module Core/data/field/DataField
 */

const {
  getOwnPropertyDescriptor
} = Reflect;
/**
 * This is the base class for Model field classes. A field class defines how to handle the data for a particular type
 * of field. Many of these behaviors can be configured on individual field instances.
 *
 * @extends Core/Base
 */

class DataField extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'DataField';
  }

  static get type() {
    return 'auto';
  }

  static get factoryable() {
    return {
      defaultType: 'auto'
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * The name of the field.
       * @config {String} name
       */

      /**
       * The label text for a form item generated for this field. This is also used to create
       * a column header for a {@link #config-column} for this field.
       * @config {String} label
       */

      /**
       * A column config object for a column to display this field in a grid. For simple, atomic
       * data types, such as `date`, `string`, `boolean`, `number` and `integer`, this is optional
       * and the appropriate column type can be inferred.
       *
       * This also provides default values for column configuration if a configured column definition
       * for a grid lacks a property.
       *
       * For complex fields, such as identifiers which link to other records, a more capable
       * column type may be specified, for example a `type : `number'` field may be configured
       * with
       *
       * ```javascript
       * column : 'percent'
       * ```
       * or
       * ```javascript
       * column : {
       *     type : 'percent',
       *     width : 100
       * }
       * ```
       * if it represents a percentage vaue and needs appropriate rendering and editing.
       * @config {String|Object} column
       */

      /**
       * A config object for a widget to edit this field in a form. For simple, atomic
       * data types, such as `date`, `string`, `boolean`, `number` and `integer`, this is optional
       * and the appropriate input widget type can be inferred.
       *
       * For complex fields, such as identifiers which link to other records, a more capable
       * widget may be specified.
       * @config {String|Object} editor
       * @private
       */

      /**
       * A function that compares two values and returns a value < 0 if the first is less than the second, or 0
       * if the values are equal, or a value > 0 if the first is greater than the second.
       * @config {Function}
       * @default
       */
      compare: null,

      /**
       * A function that compares two objects or records using the `compare` function on the properties of each
       * objects based on the `name` of this field.
       * @config {Function}
       * @default
       * @internal
       */
      compareItems: null,

      /**
       * The property in a record's data object that contains the field's value.
       * Defaults to the field's `name`.
       * @config {String}
       * @default
       */
      dataSource: null,

      /**
       * The default value to assign to this field in a record if no value is provided.
       * @config {*} defaultValue
       */

      /**
       * Setting to `true` will ensure this field is included in any update/insert request payload
       * when a Store / Project / CrudManager performs a request.
       * @config {Boolean}
       * @default
       */
      alwaysWrite: false,

      /**
       * Setting to `false` indicates that `null` is not a valid value.
       * @config {Boolean}
       * @default
       */
      nullable: true,

      /**
       * The value to return from {@link #function-print} for a `null` or `undefined` value.
       * @config {String}
       * @default
       */
      nullText: null,

      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {*}
       * @default
       */
      nullValue: undefined,

      /**
       * Set to `false` to exclude this field when saving records to a server.
       * @config {Boolean}
       * @default
       */
      persist: true,

      /**
       * Set to `true` for the field's set accessor to ignore attempts to set this field.
       * @config {Boolean}
       * @default
       */
      readOnly: false,

      /**
       * By default, defined {@link Core.data.Model} fields may be used to create a grid column
       * suitable for diplaying that field in a grid cell. Some fields may not be suitable for
       * features which automatically generate columns for view. These fields are created using
       * `internal : true`. Some examples are the `expanded` and `rowHeight` fields which are used
       * internally.
       * @config {Boolean}
       * @default
       */
      internal: false
    };
  }
  /**
   * The class that first defined this field. Derived classes that override a field do not change this property.
   * @member {Core.data.Model} definedBy
   * @private
   * @readonly
   */

  /**
   * The class that most specifically defined this field. Derived classes that override a field set this property to
   * themselves.
   * @member {Core.data.Model} owner
   * @private
   * @readonly
   */
  // NOTE: Since we create lots of instances, they have no life cycle (they are not destroyed) and are readonly after
  // creation, this class does not use configurable.


  construct(config) {
    const me = this;

    if (config) {
      me.name = config.name; // assign name first for diagnostic reasons

      Object.assign(me, config);
    }

    if (me.compare) {
      // We wrap in this way to allow compareItems() to be used as an array sorter fn (which gets no "this"):
      me.compareItems = (itemA, itemB) => me.compare(itemA === null || itemA === void 0 ? void 0 : itemA[me.name], itemB === null || itemB === void 0 ? void 0 : itemB[me.name]);
    }
  }
  /**
   * This method transforms a data value into the desired form for storage in the record's data object.
   * @method convert
   * @param {*} value The value to convert for storage in a record.
   * @returns {*} The converted value.
   */

  /**
   * This method transforms a data value into the desired form for transmitting to a server.
   * @method serialize
   * @param {*} value The value to serialize
   * @param {Core.data.Model} record The record that contains the value being serialized.
   * @returns {*} The serialized value.
   */

  /**
   * Create getter and setter functions for the specified field name under the specified key.
   * @internal
   */


  defineAccessor(target, force) {
    const {
      name,
      dataSource
    } = this; // Bail out if trying to override a explicitly defined accessor

    if (!force && name in target && target.$meta.hierarchy.some(current => {
      var _getOwnPropertyDescri;

      return ((_getOwnPropertyDescri = getOwnPropertyDescriptor(current.prototype, name)) === null || _getOwnPropertyDescri === void 0 ? void 0 : _getOwnPropertyDescri.enumerable) === false;
    })) {
      return;
    }

    Reflect.defineProperty(target, name, {
      configurable: true,
      // To allow removing it later
      enumerable: true,
      // no arrow functions here, need `this` to change to instance
      get: this.complexMapping ? function () {
        return this.complexGet(name, dataSource);
      } : function () {
        var _this$data$dataSource;

        // Inlined copy of Model#flatGet, to save a fn call since this is hit very often
        // When changes are batched, they get stored by field name, not dataSource
        if (this.batching && name in this.meta.batchChanges) {
          return this.meta.batchChanges[name];
        }

        return (_this$data$dataSource = this.data[dataSource]) !== null && _this$data$dataSource !== void 0 ? _this$data$dataSource : this.data[name];
      },

      // no arrow functions here, need `this` to change to instance
      set(value) {
        // Since the accessor is defined on a base class, we dip into the fields map for the actual
        // calling class to get the correct field definition
        const field = this.$meta.fields.map[name]; // Only set if field is read/write. Privately, we use setData to set its value

        if (!(field && field.readOnly)) {
          this.set(name, value);
        }
      }

    });
  }
  /**
   * Compares two values for this field and returns `true` if they are equal, and `false` if not.
   * @param {*} first The first value to compare for equality.
   * @param {*} second The second value to compare for equality.
   * @returns {Boolean} `true` if `first` and `second` are equal.
   */


  isEqual(first, second) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(first, second);
  }
  /**
   * Returns the given field value as a `String`. If `value` is `null` or `undefined`, the value specified by
   * {@link #config-nullText} is returned.
   * @param {*} value The value to convert to a string.
   * @returns {String}
   */


  print(value) {
    return value == null ? this.nullText : this.printValue(value);
  }
  /**
   * Returns the given, non-null field value as a `String`.
   * @param {*} value The value to convert to a string (will not be `null` or `undefined`).
   * @returns {String}
   * @protected
   */


  printValue(value) {
    return String(value);
  }

}
DataField._$name = 'DataField';

/***/ }),

/***/ "./lib/Core/data/field/DateDataField.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/field/DateDataField.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';



/**
 * @module Core/data/field/DateDataField
 */

/**
 * This field class handles field of type `Date`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'date'`, non-null values are promoted to `Date` type. This is frequently needed due
 * to how date types are serialized to JSON strings.
 *
 * Date fields can have a special `defaultValue` of `'now'` which will convert to the current date/time.
 *
 * @extends Core/data/field/DataField
 * @classtype date
 */

class DateDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DateDataField';
  }

  static get type() {
    return 'date';
  }

  static get prototypeProperties() {
    return {
      /**
       * The format of the date field. *Deprecated*: use {@link #config-format} instead.
       *
       * @config {String} dateFormat
       * @deprecated Use {@link #config-format} instead.
       */

      /**
       * The format of the date field.
       *
       * See {@link Core.helper.DateHelper DateHelper} for details.
       * @config {String} format
       * @default DateHelper.defaultFormat
       */
      format: null
    };
  }

  get dateFormat() {
    return this.format;
  }

  set dateFormat(v) {
    _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Core', '5.0.0', `DateDataField "${this.name}": dateFormat config has been renamed to "format"`);
    this.format = v;
  }

  convert(value) {
    if (value == null) {
      if (!this.nullable) {
        value = this.nullValue;
      }
    } else if (value === 'now') {
      value = new Date();
    } else if (!(value instanceof Date)) {
      // Use configured format, if null/undefined use DateHelpers default format
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultParseFormat); // if parsing has failed, we would like to return `undefined` to indicate the "absence" of data
      // instead of `null` (presence of "empty" data)

      value = value || undefined;
    }

    return value;
  }

  serialize(value) {
    if (value instanceof Date) {
      // Use configured format or DateHelpers default one
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultFormat);
    }

    return value;
  }

  printValue(value) {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultFormat);
  }

}
DateDataField.initClass();
DateDataField._$name = 'DateDataField';

/***/ }),

/***/ "./lib/Core/data/field/IntegerDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/IntegerDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IntegerDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/IntegerDataField
 */

/**
 * This field class handles field of type `Number` with no decimal digits.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'int' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'int'`, non-null values are promoted to `Number` type and decimals are removed using
 * a specified `rounding`. This field type can be useful if a field value is received as a string but should be stored
 * as a number or has a fractional component that must be rounded or truncated.
 *
 * @extends Core/data/field/DataField
 * @classtype integer
 */

class IntegerDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'IntegerDataField';
  }

  static get type() {
    return 'integer';
  }

  static get alias() {
    return 'int';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Number}
       * @default
       */
      nullValue: 0,

      /**
       * The `Math` method to use to ensure fractional component is removed.
       * This can be `'round'` (the default value), `'floor'` or `'ceil'`.
       * @config {String}
       * @default
       */
      rounding: 'round'
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : Math[this.rounding](Number(value));
  }

}
IntegerDataField.initClass();
IntegerDataField._$name = 'IntegerDataField';

/***/ }),

/***/ "./lib/Core/data/field/ModelDataField.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/field/ModelDataField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/ModelDataField
 */

/**
 * This field class handles fields that hold other records.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'model' }
 *         ];
 *     }
 * }
 * ```
 *
 * @internal
 * @extends Core/data/field/DataField
 * @classtype model
 */

class ModelDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ModelDataField';
  }

  static get type() {
    return 'model';
  }

  static get prototypeProperties() {
    return {
      complexMapping: true
    };
  }

  isEqual(first, second) {
    // Check for semantic equality. An instance of the same Model class of the same ID is equal.
    return first && second && second instanceof first.constructor && second.id == first.id;
  }

}
ModelDataField.initClass();
ModelDataField._$name = 'ModelDataField';

/***/ }),

/***/ "./lib/Core/data/field/NumberDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/NumberDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/NumberDataField
 */

/**
 * This field class handles field of type `Number`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'number' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'number'`, non-null values are promoted to `Number` type. This is seldom required, but
 * can be useful if a field value is received as a string but should be treated as a number.
 *
 * @extends Core/data/field/DataField
 * @classtype number
 */

class NumberDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NumberDataField';
  }

  static get type() {
    return 'number';
  }

  static get alias() {
    return 'float';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Number}
       * @default
       */
      nullValue: 0,

      /**
       * The numeric precision of this field. Values are rounded to the specified number of digits. If `null`,
       * the default, no rounding is performed.
       * @config {Number}
       * @default
       */
      precision: null
    };
  }

  convert(value) {
    if (value == null) {
      return this.nullable ? value : this.nullValue;
    }

    value = Number(value);
    let scale = this.precision;

    if (scale) {
      scale = 10 ** scale;
      value = Math.round(value * scale) / scale;
    } else if (scale === 0) {
      value = Math.round(value);
    }

    return value;
  }

}
NumberDataField.initClass();
NumberDataField._$name = 'NumberDataField';

/***/ }),

/***/ "./lib/Core/data/field/ObjectDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/ObjectDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/ObjectDataField
 */

/**
 * This field class handles fields that hold an object.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'object' }
 *         ];
 *     }
 * }
 * ```
 *
 * For the field to count as modified, the whole object has to be replaced:
 *
 * ```javascript
 * person.address = { ...address };
 * ```
 *
 * @extends Core/data/field/DataField
 * @classtype object
 */

class ObjectDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ObjectDataField';
  }

  static get type() {
    return 'object';
  }

  static get prototypeProperties() {
    return {
      complexMapping: true
    };
  }

}
ObjectDataField.initClass();
ObjectDataField._$name = 'ObjectDataField';

/***/ }),

/***/ "./lib/Core/data/field/StringDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/StringDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'gantt';

/**
 * @module Core/data/field/StringDataField
 */

/**
 * This field class handles field of type `String`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'name', type : 'string' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'string'`, non-null values are promoted to `String` type. This is seldom required, but
 * can be useful if a field value is received as a number but should be treated as a string.
 *
 * @extends Core/data/field/DataField
 * @classtype string
 */

class StringDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'StringDataField';
  }

  static get type() {
    return 'string';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {String}
       * @default
       */
      nullValue: ''
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : String(value);
  }

}
StringDataField.initClass();
StringDataField._$name = 'StringDataField';

/***/ }),

/***/ "./lib/Core/data/mixin/StoreCRUD.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreCRUD.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';


/**
 * @module Core/data/mixin/StoreCRUD
 */

/**
 * Mixin for Store that handles modifying records (add, remove etc).
 *
 * @example
 * // add new record to store
 * store.add({ id: 1, team: 'FC Krasnodar' });
 *
 * // remove a record from store, using id
 * store.remove(1);
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreCRUD extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreCRUD';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Commit changes automatically
       * @config {Boolean}
       * @default
       * @category Common
       */
      autoCommit: false
    };
  }

  static get properties() {
    return {
      isRemoving: false,
      suspendCount: 0
    };
  } //endregion
  //region Events

  /**
   * Fired after removing all records
   * @event removeAll
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired before committing changes. Return false from handler to abort commit
   * @event beforeCommit
   * @param {Core.data.Store} source This Store
   * @param {Object} changes Modification data
   */

  /**
   * Fired after committing changes
   * @event commit
   * @param {Core.data.Store} source This Store
   * @param {Object} changes Modification data
   */

  /**
   * Fired before records are removed from this store by the {@link #function-remove} or {@link #function-removeAll}.
   * Also fired when removing a child record in a tree store using {@link Core.data.mixin.TreeNode#function-removeChild}.
   * The remove may be vetoed by returning `false` from a handler.
   * @event beforeRemove
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records The records which are to be removed.
   * @param {Core.data.Model} parent The record from which children are being removed when using a tree store
   * @param {Boolean} isMove Set to `true` if the child node is being removed by
   * {@link Core.data.mixin.TreeNode#function-appendChild appendChild} to be moved
   * _within the same tree_.
   * @param {Boolean} removingAll Set to `true` if the operation is removing the store's entire data set.
   */

  /**
   * Fired before records are added to this store by the {@link #function-add} or {@link #function-insert}. In a tree
   * store, also fired by {@link Core.data.mixin.TreeNode#function-appendChild} and
   * {@link Core.data.mixin.TreeNode#function-insertChild}. The add or insert may be vetoed by returning `false`
   * from a handler.
   * @event beforeAdd
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records The records which are to be added
   * @param {Core.data.Model} parent The parent node when using a tree store
   * @preventable
   */

  /**
   * Fired after adding/inserting record(s). If the record was added to a parent, the `isChild` flag is set on the
   * event. If it was inserted, event contains `index`
   * @event add
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records Added records. In case of tree store, if branch is added, only branch root
   * is returned
   * @param {Core.data.Model[]} [allRecords] Flat list of all added records. In case of tree store, if branch is
   * added, all new records are returned, not only branch root
   * @param {Core.data.Model} [parent] If due to an {@link Core.data.mixin.TreeNode#function-appendChild appendChild}
   * call, this is the parent node added to.
   * @param {Number} [index] Insertion point in the store's {@link Core.data.Store#config-storage Collection}.
   * @param {Number} [oldIndex] Not used for tree stores. The index of the first record moved.
   * @param {Boolean} [isChild] Flag which is set to true if the records are added to a parent record
   * @param {Boolean} [isExpand] Flag which is set to true if records are added to the store by expanding parent
   * @param {Object} [isMove] An object keyed by the ids of the records which were moved from another
   * position in the store, or from another parent node in the store. The ids of moved records will be
   * property names with a value `true`.
   */

  /**
   * Fired when a record has been removed
   * @event remove
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records Removed records. In case of tree store, if branch is removed, only branch root
   * is returned
   * @param {Core.data.Model[]} [allRecords] Flat list of all removed records. In case of tree store, if branch is
   * removed, all removed records are returned, not only branch root
   * @param {Core.data.Model} [parent] If due to a {@link Core.data.mixin.TreeNode#function-removeChild removeChild}
   * call, this is the parent node removed from.
   * @param {Number} [index] Visible index at which record was removed. In case record is removed from the collapsed
   * branch -1 is returned.
   * @param {Boolean} [isChild] Flag which is set to true if the record is added to a parent record
   * @param {Boolean} [isCollapse] Flag which is set to true if records are removed from the store by collapsing parent
   * @param {Boolean} [isMove] Passed as `true` if the remove was part of a move operation within this Store.
   */
  //endregion
  //region Add, insert & remove

  /**
   * Removes a record from this store.
   * @param {String|String[]|Number|Number[]|Core.data.Model|Core.data.Model[]} records Record/array of records (or record ids) to remove
   * @param {Boolean} [silent] Specify `true` to suppress events/autoCommit
   * @returns {Core.data.Model[]} Removed records
   * @fires beforeRemove
   * @fires remove
   * @fires change
   * @category CRUD
   */


  remove(records, silent = false) {
    const me = this,
          {
      storage
    } = me;

    if (records instanceof Set) {
      records = Array.from(records);
    } // Ensure we have an array of records in case we are passed IDs


    records = (Array.isArray(records) ? records : [records]).reduce((result, r) => {
      r = me.getById(r);

      if (r) {
        result.push(r);
      }

      return result;
    }, []);

    if (records.length) {
      // Flag that can be checked in linked store to determine if removal is ongoing
      me.isRemoving = true;

      if (me.tree) {
        // In case it's a set of records from different parents, group them by parent
        const removeChildArgs = records.reduce((result, child) => {
          const parent = child.parent;

          if (parent) {
            if (!result[parent.id]) {
              result[parent.id] = [parent, []];
            }

            result[parent.id][1].push(child);
          }

          return result;
        }, {}); // Remove the records each from their correct parent

        for (const argBlock of Object.values(removeChildArgs)) {
          argBlock[0].removeChild(argBlock[1], false, silent);
        }

        me.isRemoving = false;
        return records;
      } // Ensure that records in collapsed groups are removed and events fired.
      else if (me.isGrouped) {
        const oldCount = storage.count,
              recordsInCollapsedGroups = [],
              changedGroupParents = new Set(); // Collect any records which are in collapsed groups which will not be in the storage
        // Collection, and so will not cause a store change.
        // If we find some, we must fire the event which the store will react to and update itself.

        for (const rec of records) {
          const {
            groupParent
          } = rec.instanceMeta(me);

          if (groupParent && groupParent.meta.collapsed) {
            recordsInCollapsedGroups.push(rec);
          } // Collect group header records which change so they can announce this to cause UI updates.


          _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(groupParent.groupChildren, rec);
          groupParent.meta.childCount--;
          changedGroupParents.add(groupParent);
        } // The changed group parents must announce their changes, otherwise the group headers
        // in a UI will not refresh to reflect the change.


        for (const groupParent of changedGroupParents) {
          if (groupParent.groupChildren.length > 0) {
            me.onModelChange(groupParent, {}, {});
          }
        } // The store must react as if these records in collapsed groups have been removed from storage


        if (recordsInCollapsedGroups.length) {
          storage.trigger('change', {
            action: 'splice',
            removed: recordsInCollapsedGroups,
            added: [],
            replaced: [],
            oldCount
          });
        }
      } // Give chance to veto or take action before records disappear.


      if (!records.length || !silent && me.trigger('beforeRemove', {
        records
      }) === false) {
        me.isRemoving = false;
        return null;
      }

      if (silent) {
        me.suspendEvents();
      }

      storage.remove(records);

      if (silent) {
        me.resumeEvents();
      }

      if (me.autoCommit) {
        me.doAutoCommit();
      }

      me.isRemoving = false;
    }

    return records;
  }
  /**
   * Clears store data. Used by removeAll, separate function for using with chained stores.
   * @private
   * @category CRUD
   */


  clear(isLoading = false) {
    var _me$rootNode, _me$rootNode$unfilter;

    const me = this,
          {
      storage
    } = me; // For tree store, we have to check unfilteredChildren to see if store has contents

    if (me.storage.totalCount || (_me$rootNode = me.rootNode) !== null && _me$rootNode !== void 0 && (_me$rootNode$unfilter = _me$rootNode.unfilteredChildren) !== null && _me$rootNode$unfilter !== void 0 && _me$rootNode$unfilter.length) {
      // Give chance to veto or take action before records disappear.
      if (!isLoading && me.trigger('beforeRemove', {
        records: storage.allValues,
        removingAll: true
      }) === false) {
        return null;
      } // For tree scenario, clean up root node too


      if (me.rootNode) {
        // A chained tree store shares root node with its master store
        if (!me.isChained) {
          me.rootNode.clearChildren(isLoading);
        }
      } else if (isLoading) {
        // If we are loading, we suspend events, and Store#onDataChange won't get to
        // do all this stuff.
        const allRecords = me.registeredRecords;

        for (let i = allRecords.length - 1, rec; i >= 0; i--) {
          rec = allRecords[i];

          if (rec && !rec.isDestroyed) {
            rec.unjoinStore(me);
          }
        }
      }

      if (isLoading) {
        me.removed.clear();
        storage.suspendEvents();
      } // Clearing the storage will trigger 'removeAll' and 'change' if `removing`


      storage.clear();

      if (isLoading) {
        storage.resumeEvents();
      }

      me.added.clear();
      me.modified.clear();
    }
  }
  /**
   * Removes all records from the store.
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Boolean} `true` unless the action was prevented, in which case it returns `false`
   * @fires beforeRemove
   * @fires removeAll
   * @fires change
   * @category CRUD
   */


  removeAll(silent = false) {
    const me = this,
          storage = me.storage;
    let result;
    me.isRemoving = true; // No reaction to the storage Collection's change event.

    if (silent) {
      storage.suspendEvents(); // If silent, the storage Collection won't fire the event we react to
      // to unjoin, and we allow the removing flag in remove() to be true,
      // so *it* will not do the unJoin, so if silent, so do it here.

      const allRecords = me.registeredRecords;

      for (let i = allRecords.length - 1, rec; i >= 0; i--) {
        rec = allRecords[i];

        if (rec && !rec.isDestroyed && !rec.isRoot) {
          rec.unjoinStore(me);
        }
      }
    }

    if (me.tree) {
      result = me.rootNode.clear() !== false;
    } else {
      result = me.clear() !== null;
    }

    if (silent) {
      storage.resumeEvents();
    }

    me.isRemoving = false;
    return result;
  }
  /**
   * Add records to store.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Core.data.Model[]} Added records
   * @fires add
   * @fires change
   * @category CRUD
   */


  add(records, silent = false) {
    const me = this,
          storage = me.storage;

    if (!Array.isArray(records)) {
      records = [records];
    } else if (!records.length) {
      // Adding zero records, bail out
      return;
    }

    me.tree = me.tree || Boolean(me.autoTree && records[0].children);

    if (me.tree) {
      const // Map and not Object to allow keys to keep their type
      parentIdMap = new Map(),
            added = [];
      records.forEach(node => {
        const parentId = node[me.modelClass.parentIdField];

        if (!parentIdMap.has(parentId)) {
          parentIdMap.set(parentId, []);
        }

        parentIdMap.get(parentId).push(node);
      });
      parentIdMap.forEach((nodes, parentId) => {
        const parentNode = parentId == null ? me.rootNode : me.getById(parentId);

        if (!parentNode) {
          throw new Error(`Parent node with id ${parentId} not found, cannot add children.`);
        }

        added.push(...parentNode.appendChild(nodes, silent));
      });
      return added;
    } // Give chance to cancel action before records added.


    if (!silent) {
      if (me.trigger('beforeAdd', {
        records
      }) === false) {
        return null;
      }
    }

    me.tree = me.tree || Boolean(me.autoTree && records[0].children);

    if (me.tree) {
      return me.rootNode.appendChild(records);
    }

    const added = me.processRecords(records);

    if (silent) {
      me.suspendEvents();
    }

    storage.add(added);

    if (silent) {
      me.resumeEvents();
    }

    if (me.autoCommit) {
      me.doAutoCommit();
    }

    return added;
  }

  processRecords(records, onRecordCreated) {
    return records.map(data => {
      const record = this.processRecord(data.isModel ? data : this.createRecord(data));
      onRecordCreated === null || onRecordCreated === void 0 ? void 0 : onRecordCreated.call(this, record);
      return record;
    });
  }
  /**
   * Insert records to store.
   * @param {Number} index Index to insert at
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to insert to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Core.data.Model[]} Inserted records
   * @fires add
   * @fires change
   * @category CRUD
   */


  insert(index, records, silent = false) {
    const me = this,
          storage = me.storage,
          insertBefore = me.getAt(index),
          _records = storage.values,
          removeIndices = [];
    if (!Array.isArray(records)) records = [records]; // Give chance to cancel action before records added.

    if (!silent && me.trigger('beforeAdd', {
      records
    }) === false) {
      return null;
    }

    let isNoop, start, i; // If the records starting at index or (index - 1), are the same sequence
    // that we are being asked to add, this is a no-op.

    if (_records[start = index] === records[0] || _records[start = index - 1] === records[0]) {
      for (isNoop = true, i = 0; isNoop && i < records.length; i++) {
        if (records[i] !== _records[start + i]) {
          isNoop = false;
        }
      }
    }

    if (isNoop) {
      return null;
    }

    const added = me.processRecords(records, record => {
      const removedAtIndex = storage.indexOf(record);

      if (record.children && record.children.length && me.autoTree) {
        me.tree = true;
      } // already in store, do some cleanup


      if (removedAtIndex > -1) {
        if (removedAtIndex < index && insertBefore) index--;
        removeIndices.push(removedAtIndex);
      } // Store previous index to be able to determine that it is a move, since Collection does not handle that


      record.meta.previousIndex = removedAtIndex;
    });

    if (me.tree) {
      const root = me.rootNode;
      return root.insertChild(records, root.children && root.children[index], silent);
    } // Silently remove them, so that they will be inserted into place.
    // Collection is stable by default, and inserting an existing item
    // is a no-op.


    me.suspendEvents();
    me.storage.remove(removeIndices);
    me.resumeEvents();

    if (silent) {
      me.suspendEvents();
    }

    storage.splice(index, 0, ...added);

    if (silent) {
      me.resumeEvents();
    }

    if (me.autoCommit) {
      me.doAutoCommit();
    }

    return added;
  }
  /**
   * Moves a record, or block of records to another location.
   * @param {Core.data.Model|Core.data.Model[]} records The record(s) to move.
   * @param {Core.data.Model} beforeRecord the record to insert the first record(s) before.
   * @fires change
   * @category CRUD
   */


  move(records, beforeRecord) {
    if (this.isTree) {
      beforeRecord.parent.insertChild(records, beforeRecord);
    } else {
      this.storage.move(records, beforeRecord);
    }
  } //endregion
  //region Update multiple


  setMultiple(filterFn, field, value) {
    const me = this,
          records = [],
          changes = [];
    me.forEach(r => {
      if (filterFn(r)) {
        changes.push(r.set(field, value, true));
        records.push(r);
      }
    }); // TODO: should consolidate with update, make it take an array instead? to only have to listen for one event outside of store?

    me.trigger('updateMultiple', {
      records,
      all: me.records.length === records.length
    });
    me.trigger('change', {
      action: 'updatemultiple',
      records,
      all: me.records.length === records.length
    });
    if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
  }

  setAll(field, value) {
    const me = this,
          changes = [];
    me.forEach(r => {
      changes.push(r.set(field, value, true));
    });
    me.trigger('updateMultiple', {
      records: me.records,
      all: true
    });
    me.trigger('change', {
      action: 'updatemultiple',
      records: me.records,
      all: true
    });
    if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
  } //endregion
  //region Commit

  /**
   * Accepts all changes, resets the modification tracking:
   * * Clears change tracking for all records
   * * Clears added
   * * Clears modified
   * * Clears removed
   * Leaves the store in an "unmodified" state.
   * @internal
   */


  acceptChanges() {
    const me = this; // Clear record change tracking

    me.added.forEach(r => r.clearChanges(false));
    me.modified.forEach(r => r.clearChanges(false)); // Clear store change tracking

    me.added.clear();
    me.modified.clear();
    me.removed.clear();
  }
  /**
   * Commits changes, per default only returns changes and resets tracking.
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Object} Changes, see {@link #property-changes}
   * @fires beforeCommit
   * @fires commit
   * @category CRUD
   */


  commit(silent = false) {
    // resets stores tracking of changed records, doesn't store changes, only returns them
    const {
      changes
    } = this;

    if (!silent && this.trigger('beforeCommit', {
      changes
    }) === false) {
      return false;
    }

    this.acceptChanges();

    if (!silent) {
      this.trigger('commit', {
        changes
      });
    }

    return changes;
  }
  /**
   * Reverts all changes in the store (adds removed records back, and removes newly added records).
   * @fires change
   * @fires refresh
   * @category CRUD
   */


  revertChanges() {
    const me = this,
          {
      changes
    } = me;

    if (changes) {
      const event = {
        action: 'clearchanges',
        changes
      };
      me.add(me.removed.values, true);
      me.remove(me.added.values, true);
      me.modified.forEach(r => r.revertChanges(true));
      me.added.clear();
      me.modified.clear();
      me.removed.clear();
      me.trigger('change', event);
      me.trigger('refresh', event);
    }
  }
  /**
   * Get uncommitted changes as an object of added/modified/removed arrays of records.
   *
   * ```javascript
   * // Format:
   * {
   *      added: [], // array of Core.data.Model
   *      modified: [], // array of Core.data.Model
   *      removed: [] // array of Core.data.Model
   * }
   * ```
   *
   * @type {Object}
   * @property {Object} changes
   * @property {Core.data.Model[]} changes.added Records that have been added
   * @property {Core.data.Model[]} changes.modified Records that have changes to persistable fields
   * @property {Core.data.Model[]} changes.removed Records that have been removed
   * @readonly
   * @category Records
   */


  get changes() {
    const me = this,
          // Only include modified records that have persistable changes
    modified = me.modified.values.filter(r => r.rawModifications);
    return me.added.count || modified.length || me.removed.count ? {
      // Slicing to have changes intact when triggering commit
      added: me.added.values.slice(),
      modified,
      removed: me.removed.values.slice()
    } : null;
  }
  /**
   * Setting autoCommit to true automatically commits changes to records.
   * @property {Boolean}
   * @category Records
   */


  get autoCommit() {
    return this._autoCommit;
  }

  set autoCommit(auto) {
    this._autoCommit = auto;

    if (auto && this.changes) {
      this.commit();
    }
  }
  /**
   * Suspends automatic commits upon store changes. Can be called multiple times (it uses an internal counter).
   * @category Records
   */


  suspendAutoCommit() {
    this.suspendCount++;
  }
  /**
   * Resumes automatic commits upon store changes. Will trigger commit if the internal counter is 0.
   * @category Records
   */


  resumeAutoCommit(doCommit = true) {
    this.suspendCount--;

    if (this.autoCommit && doCommit) {
      this.doAutoCommit();
    }
  }

  doAutoCommit() {
    if (this.suspendCount <= 0) {
      this.commit();
    }
  } //endregion
  //region Changes from other store

  /**
   * Applies changes from another store to this store. Useful if cloning records in one store to display in a
   * grid in a popup etc. to reflect back changes.
   * @param {Core.data.Store} otherStore
   * @category CRUD
   */


  applyChangesFromStore(otherStore) {
    const me = this,
          changes = otherStore.changes;
    if (!changes) return;

    if (changes.added) {
      me.add(changes.added);
    }

    if (changes.removed) {
      // Remove using id, otherwise indexOf in remove fn won't yield correct result
      me.remove(changes.removed.map(r => r.id));
    }

    if (changes.modified) {
      changes.modified.forEach(record => {
        const localRecord = me.getById(record.id);
        localRecord.set(record.modifications);
      });
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreChained.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/mixin/StoreChained.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';

 // TODO: turn into plugin instead?

/**
 * @module Core/data/mixin/StoreChained
 */
// Intentionally using one param since we check function.length, don't remove

const returnTrue = rec => true;
/**
 * A chained Store contains a subset of records from a master store. Which records to include is determined by a
 * filtering function, {@link #config-chainedFilterFn}.
 *
 * @example
 * masterStore.makeChained(record => record.percent < 10);
 *
 * // or
 *
 * new Store({
 *   masterStore     : masterStore,
 *   chainedFilterFn : record => record.percent < 10
 * });
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreChained extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreChained';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Function used to filter records in the masterStore into a chained store. If not provided,
       * all records from the masterStore will be included in the chained store.
       * @config {Function}
       * @category Chained store
       */
      chainedFilterFn: null,

      /**
       * Array of fields that should trigger filtering of chained store when the fields are updated.
       * @config {String[]}
       * @category Chained store
       */
      chainedFields: null,

      /**
       * Master store that a chained store gets its records from.
       * @config {Core.data.Store}
       * @category Chained store
       */
      masterStore: null,

      /**
       * Method names calls to which should be relayed to master store.
       * @config {String[]}
       * @category Chained store
       */
      doRelayToMaster: ['add', 'remove', 'insert'],

      /**
       * Method names calls to which shouldn't be relayed to master store.
       * @config {String}
       * @category Chained store
       */
      dontRelayToMaster: [],

      /**
       * Flag showing whether to keep added/removed uncommitted records when filling the store from master.
       * @config {Boolean}
       * @category Chained store
       */
      keepUncommittedChanges: false,

      /**
       * If true, collapsed records in original tree will be excluded from the chained store.
       * @config {Boolean}
       * @category Chained store
       * @internal
       */
      excludeCollapsedRecords: true
    };
  } // All props should be predefined to work properly with objectified stores


  static get properties() {
    return {
      chainedStores: null
    };
  } //endregion


  construct(config) {
    super.construct(config);
    const me = this,
          {
      masterStore
    } = me,
          sort = me.syncOrder ? 'sort' : '';

    if (masterStore) {
      me.methodNamesToRelay.forEach(fnName => me[fnName] = (...params) => me.relayToMaster(fnName, params));

      me.removeAll = (...params) => {
        masterStore.remove(me.getRange(), ...params);
      }; // TODO: prevent other functions?


      masterStore.on({
        // HACK to have chained stores react early in a async events scenario (with engine). Could be turned
        // into a config, but this way one does not have to think about it
        changePreCommit: me.onMasterDataChangedPreCommit,
        change: me.onMasterDataChanged,
        [sort]: me.onMasterDataChanged,
        prio: 1,
        thisObj: me
      });

      if (!masterStore.chainedStores) {
        masterStore.chainedStores = [];
      }

      masterStore.chainedStores.push(me);
      me.fillFromMaster();
    }
  } //region Properties

  /**
   * Is this a chained store?
   * @property {Boolean}
   * @readonly
   * @category Store
   */


  get isChained() {
    return Boolean(this.masterStore);
  }

  set chainedFilterFn(chainedFilterFn) {
    this._chainedFilterFn = this.thisObj ? chainedFilterFn.bind(this.thisObj) : chainedFilterFn;
  }

  get chainedFilterFn() {
    return this._chainedFilterFn || returnTrue;
  }

  get methodNamesToRelay() {
    const doIsArray = Array.isArray(this.doRelayToMaster),
          dontIsArray = Array.isArray(this.dontRelayToMaster);
    return doIsArray && this.doRelayToMaster.filter(name => !dontIsArray || !this.dontRelayToMaster.includes(name)) || [];
  } //endregion
  //region Internal


  updateChainedStores() {
    if (this.chainedStores) {
      this.chainedStores.forEach(store => store.fillFromMaster());
    }
  }
  /**
   * Updates records available in a chained store by filtering the master store records using
   * {@link #config-chainedFilterFn}
   * @category Chained store
   */


  fillFromMaster() {
    const me = this,
          {
      masterStore,
      isTree
    } = me,
          // the || is for BW compat since we had public demos using store.chain(() => true)
    isRecordFilter = me.chainedFilterFn.length > 0 || me.chainedFilterFn.toString().length <= 10;
    let records;

    if (!me.isChained) {
      throw new Error('fillFromMaster only allowed on chained store');
    }

    if (me.keepUncommittedChanges) {
      if (isTree) {
        throw new Error('Cannot use keepUncommittedChanges on a chained tree store');
      }

      if (isRecordFilter) {
        records = masterStore.allRecords.filter(r => !me.removed.includes(r) && !me.added.includes(r) && me.chainedFilterFn(r));
      } else {
        records = me.chainedFilterFn().filter(r => !me.removed.includes(r) && !me.added.includes(r));
      }

      records = me.added.values.filter(r => !me.removed.includes(r)).concat(records);
    } else {
      if (isRecordFilter) {
        records = masterStore.allRecords.filter(me.chainedFilterFn);
      } else {
        records = me.chainedFilterFn();
      }

      if (isTree) {
        // All nodes will be registered
        me.idRegister = {};
        me.internalIdRegister = {}; // *all* owned records have to join, as they would have done if they'd all gone through
        // the appendChild route for this store.

        records.forEach(r => {
          if (r.stores.includes(me)) {
            me.register(r);
          } else {
            r.joinStore(me);
          }
        }); // We exclude collapsed records by default. It's used in Columns Store.
        // Because grid columns is a tree store when subgrid columns is just a chained store of the columns store.
        // And we don't need to include collapsed column.
        // If we need to show collapsed nodes in Combo we need to chain tree store and set `excludeCollapsedRecords` to `false`.

        if (me.excludeCollapsedRecords) {
          const children = me.getChildren(me.rootNode);
          records = me.doIncludeExclude(children, true);
        }
      }
    }

    me.data = records;
  }
  /**
   * Commits changes back to master.
   * - the records deleted from chained store and present in master will be deleted from master
   * - the records added to chained store and missing in master will added to master
   * Internally calls {Store#function-commit commit()}.
   * @returns {Object} Changes, see Store#changes
   * @internal
   */


  commitToMaster() {
    const me = this,
          master = me.masterStore;

    if (!me.isChained) {
      throw new Error('commitToMaster only allowed on chained store');
    }

    master.beginBatch();
    master.remove(me.removed.values);
    master.add(me.added.values);
    master.endBatch();
    return me.commit();
  }
  /**
   * Relays some function calls to the master store
   * @private
   */


  relayToMaster(fnName, params) {
    return this.masterStore[fnName](...params);
  } // HACK, when used with engine the chained store will catch events early (sync) and prevent late (async) listeners


  onMasterDataChangedPreCommit(event) {
    this.onMasterDataChanged(event);
    this.$masterEventhandled = true;
  }
  /**
   * Handles changes in master stores data. Updates the chained store accordingly
   * @private
   */


  onMasterDataChanged({
    action,
    changes,
    $handled,
    isMove
  }) {
    var _this$chainedFields;

    // Handled early in engine store (above), bail out
    if (this.$masterEventhandled) {
      this.$masterEventhandled = false;
      return;
    } // 'move' action triggers a remove event first, we wait for the 'add' - no need to fill twice


    if (isMove && action === 'remove') {
      return;
    } // if a field not defined in chainedFields is changed, ignore the change.
    // there is no need to refilter the store in such cases, the change will be available anyhow since data is
    // shared


    if (action !== 'update' || (_this$chainedFields = this.chainedFields) !== null && _this$chainedFields !== void 0 && _this$chainedFields.some(field => field in changes)) {
      this.fillFromMaster();
    }
  } //endregion
  //region public API

  /**
   * Creates a chained store, a new Store instance that contains a subset of the records from current store.
   * Which records is determined by a filtering function, which is reapplied when data in the base store changes.
   *
   * If this store is a {@link Core.data.mixin.StoreTree#property-isTree tree} store, then the resulting
   * chained store will be a tree store sharing the same root node, but only child nodes which pass
   * the `chainedFilterFn` will be considered when iterating the tree through the methods such as
   * {@link Core.data.Store#function-traverse} or {@link Core.data.Store#function-forEach}.
   *
   * @param {Function} chainedFilterFn Either a filter function called for every record to determine if it should be included
   * (return true / false), or a query function called with no arguments (see example below). Defaults to including all records (fn always returning true)
   * @param {String[]} [chainedFields] Array of fields that trigger filtering when they are updated
   * @param {Object} [config] Additional chained store configuration
   * @returns {Core.data.Store}
   * @example
   * const oldies = store.makeChained(record => record.age > 50);
   * // or use a simple query
   * const ages = store.makeChained(() => store.allRecords.distinct('age')));
   */


  makeChained(chainedFilterFn = returnTrue, chainedFields, config) {
    return new this.constructor(Object.assign(config || {}, {
      tree: false,
      autoTree: false,
      masterStore: this,
      modelClass: this.modelClass,
      chainedFilterFn,
      chainedFields
    }));
  }
  /**
   * Alias for {@link Core.data.Store#function-makeChained}
   * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
   * (return true) or not (return false). Defaults to including all records (fn always returning true)
   * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
   * @param {Object} config Additional chained store configuration
   * @returns {Core.data.Store}
   */


  chain() {
    return this.makeChained(...arguments);
  } //endregion


  doDestroy() {
    var _this$chainedStores;

    // Destroy chained store on master store destroy
    (_this$chainedStores = this.chainedStores) === null || _this$chainedStores === void 0 ? void 0 : _this$chainedStores.forEach(chainedStore => chainedStore.destroy()); // Events superclass fires destroy event.

    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreFilter.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreFilter.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/Collection.js */ "./lib/Core/util/Collection.js");
var productName = 'gantt';




/**
 * @module Core/data/mixin/StoreFilter
 */

/**
 * Mixin for Store that handles filtering.
 * Filters are instances of {@link Core.util.CollectionFilter CollectionFilter} class.
 *
 * - Adding a filter for the same property will replace the current one (unless a unique {@link Core.util.CollectionFilter#config-id Id} is specified),
 * but will not clear any other filters.
 * - Adding a filter through the {@link #function-filterBy} function is ultimate.
 * It will clear all the property based filters and replace the current filterBy function if present.
 * - Removing records from the store does not remove filters!
 * The filters will be reapplied if {@link #config-reapplyFilterOnAdd}/{@link #config-reapplyFilterOnUpdate} are true and you add new records or update current.
 *
 * ```
 * // Add a filter
 * store.filter({
 *     property : 'score',
 *     value    : 10,
 *     operator : '>'
 * });
 *
 * // Add filter as a function
 * store.filter(record => record.score > 10);
 *
 * // Add named filter as a function
 * store.filter({
 *     id : 'my filter',
 *     filterBy : record => record.score > 10
 * });
 *
 * // Replace any filter set with new filters
 * store.filter({
 *     filters : {
 *         property : 'score',
 *         value    : 10,
 *         operator : '>'
 *     },
 *     replace : true
 * });
 *
 * // Remove this one specific filter, leaving any possible others in place.
 * // A filter's id defaults to the property name that it's filtering on.
 * store.removeFilter('score');
 *
 * // Reapply filters without firing an event.
 * // Use if making multiple data mutations with the
 * // intention of updating UIs when all finished.
 * store.filter({
 *     silent : true
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreFilter extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreFilter';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Specify one or more {@link Core.util.CollectionFilter CollectionFilter} config object to apply initially
       * @config {Object|Object[]}
       * @category Filtering
       */
      filters: null,

      /**
       * Specify true to reapply filters when a record is added to the store.
       * @config {Boolean}
       * @default
       * @category Filtering
       */
      reapplyFilterOnAdd: false,

      /**
       * Specify true to reapply filters when a record is updated in the store.
       * @config {Boolean}
       * @default
       * @category Filtering
       */
      reapplyFilterOnUpdate: false
    };
  } //endregion
  //region Events

  /**
   * Fired after applying filters to the store
   * @event filter
   * @param {Core.data.Store} source This Store
   * @param {Core.util.Collection} filters Filters used by this Store
   * @param {Core.data.Model[]} records Filtered records
   */
  //endregion
  //region Properties


  set reapplyFilterOnAdd(enable) {
    this.storage.autoFilter = enable;
  }

  get reapplyFilterOnAdd() {
    return this.storage.autoFilter;
  }
  /**
   * Currently applied filters. A collection of {@link Core.util.CollectionFilter} instances.
   * @type {Core.util.Collection}
   * @readonly
   * @category Sort, group & filter
   */


  set filters(filters) {
    const me = this,
          collection = me.filters;
    collection.clear(); // Invalidate the filtersFunction so that it has to be recalculated upon next access

    me._filtersFunction = null; // If we are being asked to filter, parse the filters.

    if (filters) {
      if (filters.constructor.name === 'Object') {
        for (const f of Object.entries(filters)) {
          // Entry keys are either a field name with its value being the filter value
          // or, there may be one filterBy property which specifies a filering function.
          if (f[0] === 'filterBy' && typeof f[1] === 'function') {
            collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
              filterBy: f[1]
            }));
          } else {
            collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](f[1].constructor.name === 'Object' ? Object.assign({
              property: f[0]
            }, f[1]) : {
              property: f[0],
              value: f[1]
            }));
          }
        }
      } else if (Array.isArray(filters)) {
        // Make sure we are adding CollectionFilters
        collection.add(...filters.map(filterConfig => {
          if (filterConfig instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
            return filterConfig;
          }

          return new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](filterConfig);
        }));
      } else if (filters.isCollection) {
        // Use supplied collection? Opting to use items from it currently
        collection.add(...filters.values);
      } else {
        collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
          filterBy: filters
        }));
      }

      collection.forEach(item => item.owner = me);
    }
  }

  get filters() {
    return this._filters || (this._filters = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      extraKeys: ['property']
    }));
  }

  set filtersFunction(filtersFunction) {
    this._filtersFunction = filtersFunction;
  }

  get filtersFunction() {
    const me = this,
          {
      filters,
      isGrouped
    } = me;

    if (!me._filtersFunction) {
      if (filters.count) {
        const generatedFilterFunction = _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"].generateFiltersFunction(filters);

        me._filtersFunction = candidate => {
          // A group record is filtered in if it has passing groupChildren.
          if (isGrouped && candidate.isSpecialRow) {
            return candidate.groupChildren.some(generatedFilterFunction);
          } else {
            return generatedFilterFunction(candidate);
          }
        };
      } else {
        me._filtersFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].returnTrue;
      }
    }

    return me._filtersFunction;
  }
  /**
   * Check if store is filtered
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isFiltered() {
    return this.filters.values.some(filter => !filter.disabled);
  } //endregion


  traverseFilter(record) {
    const me = this,
          hitsCurrent = !record.isRoot && me.filtersFunction(record),
          children = record.unfilteredChildren || record.children; // leaf, bail out

    if (!children || !children.length) {
      return hitsCurrent;
    }

    if (!record.unfilteredChildren) {
      record.unfilteredChildren = record.children.slice();
    }

    record.children = record.unfilteredChildren.filter(r => {
      return me.traverseFilter(r);
    }); // unfilteredIndex must be set for child elements

    record.updateChildrenIndices(record.unfilteredChildren, true, true); // parentIndex must be set for visible child elements

    record.updateChildrenIndices(record.children, false, true);
    return hitsCurrent || Boolean(record.children.length);
  }

  traverseClearFilter(record) {
    const me = this;

    if (record.unfilteredChildren) {
      record.children = record.unfilteredChildren.slice();
      record.unfilteredChildren = null;
    }

    if (record.children) {
      record.children.forEach(r => me.traverseClearFilter(r));
      record.updateChildrenIndices(record.children, false, true);
    }
  } // TODO: Get rid of this.
  // The Filter feature of a Grid pokes around in the Store to ask this question.


  get latestFilterField() {
    return this.filters.last ? this.filters.last.property : null;
  }
  /**
   * Adds a single filter to the {@link #config-filters} collection. By default, filters are reevaluated
   * and a Store change event fired.
   *
   * If the `silent` parameter is passed as `true`, multiple filters can be added without causing data changes.
   *
   * When the filters are as required, call {@link #function-filter} with no parameters
   * to apply the filters to the store.
   *
   * @param {Object|Function} newFilters A {@link Core.util.CollectionFilter filter} config,
   * or a function to use for filtering.
   * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
   * adding multiple filters.
   * @returns {Core.util.CollectionFilter} The Filter instance that was added.
   * @category Sort, group & filter
   */


  addFilter(filter, silent = false) {
    filter = filter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? filter : new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](filter); // We want notification upon change of field, value or operator

    filter.owner = this; // Collection will replace any already existing filter on the field, unless it has id specified

    this.filters.add(filter);

    if (!silent) {
      this.filter();
    }

    return filter;
  }
  /**
   * Filters the store by **adding** the specified filter(s) to the existing filters collection applied to this Store.
   * If a filter has an {@link Core.util.CollectionFilter#config-id id} specified,
   * or a {@link Core.util.CollectionFilter#config-property property} specified,
   * it will search for corresponding filter(s) in the existing filters first and replace it with a new filter.
   * **It will not remove other filters applied to the store!**
   *
   * To **add** a new filter:
   * ```
   * // Filter using simple object
   * store.filter({
   *     property : 'age',
   *     operator : '>',
   *     value    : 90
   * });
   *
   * // Filter using function
   * store.filter(r => r.age < 90);
   *
   * // Filter using a named filter as a function
   * store.filter({
   *     id : 'my-filter',
   *     filterBy : record => record.score > 10
   * });
   * ```
   *
   * To **remove** a specific filter, but keep other filters applied
   * ```
   * // Remove by filter `id` or `property`. Filter `id` defaults to the `property` name.
   * store.removeFilter('age');
   * store.removeFilter('my-filter');
   * ```
   *
   * To **replace** all existing filters with a new filter
   * ```
   * // Remove all filters and filter using simple object
   * store.filter({
   *     filters : {
   *         property : 'age',
   *         operator : '<',
   *         value    : 90
   *     },
   *     replace : true
   * });
   *
   * // Remove all filters and filter using function
   * store.filter({
   *     filters : r => r.age > 90,
   *     replace : true
   * });
   *
   * // Remove all filters and filter using a named filter as a function
   * store.filter({
   *     filters : {
   *         id : 'my-filter',
   *         filterBy : record => record.score > 10
   *     },
   *     replace : true
   * });
   * ```
   *
   * Basically filters replacing is an equivalent of having two sequenced calls:
   * {@link #function-clearFilters clearFilters} and {@link #function-filter filter}.
   *
   * Call without arguments to reapply filters.
   * ```
   * // Re-filter the store
   * store.filter();
   * ```
   *
   * @param {Object|Object[]|Function} newFilters
   *        A {@link Core.util.CollectionFilter filter} config,
   *        or an array of {@link Core.util.CollectionFilter filter} configs,
   *        or a function to use for filtering,
   *        or a special object like: ```{ replace : true, filters : newFilters }```
   * @param {Boolean} [newFilters.replace]
   *        A flag, indicating whether or not the previous filters should be removed.
   * @param {Boolean} [newFilters.silent]
   *        Set as true to not fire events. UI will not be informed about the changes.
   * @param {Object|Object[]|Function} [newFilters.filters]
   *        If `newFilters` is an object and `replace` property is defined in the `newFilters`,
   *        it means that special object is used and real filter configuration must be nested down to this `filters` property.
   *        It can be:
   *        A {@link Core.util.CollectionFilter filter} config,
   *        or an array of {@link Core.util.CollectionFilter filter} configs,
   *        or a function to use for filtering.
   * @fires filter
   * @fires change
   * @category Sort, group & filter
   */


  filter(newFilters) {
    const me = this,
          {
      filters
    } = me;
    let silent = false;

    if (newFilters) {
      let fieldType = typeof newFilters;

      if (fieldType === 'object') {
        if ('silent' in newFilters || 'replace' in newFilters || newFilters.filters) {
          silent = newFilters.silent;

          if (newFilters.replace) {
            filters.clear();
          }

          newFilters = newFilters.filters;
          fieldType = typeof newFilters;
        }
      } // If it was just a config object containing no filters, this will be null


      if (newFilters) {
        // We will not be informed about Filter mutations while configuring.
        me.isConfiguring = true; // If we provide array of objects looking like :
        //  {
        //      property  : 'fieldName',
        //      value     : 'someValue',
        //      [operator : '>']
        //  }
        //  or ...
        //  {
        //      property : 'fieldName',
        //      filterBy : function (value, record) {
        //          return value > 50;
        //      }
        //  }

        if (Array.isArray(newFilters)) {
          newFilters.forEach(f => me.addFilter(f, true), me);
        } else if (fieldType === 'function') {
          me.addFilter(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](newFilters), true);
        } // Old signature of field name, value with implicit equality test.
        // Not documented, but still tested.
        else if (fieldType === 'string') {
          me.addFilter({
            property: newFilters,
            value: arguments[1]
          }, true);
        } // An object-based filter definition
        else {
          me.addFilter(newFilters, true);
        } // Open up to receiving Filter mutation notifications again


        me.isConfiguring = false; // We added a disabled filter to either no filters, or all disabled filters, so no change.

        if (!me.isFiltered) {
          return;
        }
      }
    } // Invalidate the filtersFunction so that it has to be recalculated upon next access


    me.filtersFunction = null; // Implemented here for local filtering.
    // AjaxStore implements for remote and returns a Promise, so MUST returh the call value.

    return me.performFilter(silent);
  }
  /**
   * Perform filtering according to the {@link #property-filters} Collection.
   * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
   * must not be overridden.
   * @private
   */


  performFilter(silent) {
    const me = this,
          {
      storage,
      filters,
      rootNode
    } = me,
          oldCount = me.count; // Private event, did not need it documented or preventable right now

    me.trigger('beforeFilter', {
      filters
    });

    if (me.tree) {
      if (me.isFiltered) {
        me.traverseFilter(rootNode);
      } else {
        me.traverseClearFilter(rootNode);
      }

      storage.replaceValues({
        values: me.collectDescendants(rootNode).visible,
        silent: true
      });
    } else {
      if (me.isFiltered) {
        // Bring collapsed away records in, to be considered in filtering
        me.isGrouped && me.includeCollapsed();
        storage.addFilter({
          id: 'primary-filter',
          // no-sanity
          filterBy: me.filtersFunction
        }); // Take them back out again after filtering

        me.isGrouped && me.excludeCollapsed();
      } else {
        storage.filters.clear();
      }
    }

    me.afterPerformFilter(silent ? null : {
      action: 'filter',
      filters,
      oldCount,
      records: me.storage.values
    });
  }

  afterPerformFilter(event) {
    this.resetRelationCache();

    if (event) {
      this.triggerFilterEvent(event);
    }
  }

  get filtered() {
    return this.storage.isFiltered;
  } // Used from filter() and StoreCRUD when reapplying filters


  triggerFilterEvent(event) {
    this.trigger('filter', event); // Only fire these events if it's a local filter.
    // If we are configured with filterParamName, the loadData will fire them.

    if (!this.remoteFilter) {
      this.trigger('refresh', event);
      this.trigger('change', event);
    }
  }
  /**
   * *Adds* a function used to filter the store. Alias for calling `filter(fn)`. Return `true` from the function to
   * include record in filtered set
   *
   * ```javascript
   * store.filterBy(record => record.age > 25 && record.name.startsWith('A'));
   * ```
   *
   * @param {Function} fn Function used to test records
   * @category Sort, group & filter
   */


  filterBy(fn) {
    this.filter(fn);
  }
  /**
   * Removes the passed filter, or the filter by the passed ID from the {@link #config-filters} collection.
   * By default, filters are reevaluated and a Store change event fired.
   *
   * If the `silent` parameter is passed as `true`, multiple filters can be removed without causing data changes.
   *
   * When the filters are as required, call {@link #function-filter} with no parameters
   * to apply the filters to the store.
   *
   * ```javascript
   * // Only view top priority events
   * myEventStore.filter({
   *     id       : 'priorityFilter',
   *     property : 'priority',
   *     value    : 1,
   *     operator : '='
   * });
   *
   * // That individual filter can be removed like this
   * myEventStore.removeFilter('priorityFilter');
   *
   * // Add named filter as a function
   * store.filter({
   *     id : 'my filter',
   *     filterBy : record => record.score > 10
   * });
   *
   * // Remove named filter function
   * store.removeFilter('my filter');
   * ```
   *
   * @param {String|Core.util.CollectionFilter} idOrInstance Filter to remove, or ID of the filter to remove. By default,
   * filters are reevaluated and a change event fired.
   * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
   * removing multiple filters.
   * @returns {Core.util.CollectionFilter} The Filter instance that was removed.
   * @category Sort, group & filter
   */


  removeFilter(idOrInstance, silent = false) {
    const me = this,
          filter = idOrInstance instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? idOrInstance : me.filters.get(idOrInstance); // If we have such a filter, remove it.

    if (filter) {
      me.filters.remove(filter); // Invalidate the filtersFunction so that it has to be recalculated upon next access

      me._filtersFunction = null;

      if (!silent) {
        me.filter();
      }

      return filter;
    }
  }
  /**
   * Removes all filters from the store.
   * @category Sort, group & filter
   */


  clearFilters() {
    this.filters.clear();
    this.filter();
  }

  convertFilterToString(field) {
    const filter = this.filters.getBy('property', field);
    return filter && !filter.filterBy ? String(filter) : '';
  }

  doDestroy() {
    var _this$_filters;

    (_this$_filters = this._filters) === null || _this$_filters === void 0 ? void 0 : _this$_filters.destroy();
    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreGroup.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreGroup.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';



/**
 * @module Core/data/mixin/StoreGroup
 */

const resortActions = {
  add: 1,
  replace: 1
};
/**
 * Mixin for Store that handles grouping.
 *
 * ```javascript
 * // simple grouper
 * store.group('city');
 *
 * // grouper as object, descending order
 * store.group({ field : 'city', ascending : false });
 *
 * // using custom sorting function
 * store.group({
 *     field : 'city',
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.city.length < recordB.city.length ? -1 : 1;
 *     }
 * });
 * ```
 *
 * Currently grouping is not supported when using pagination, the underlying store cannot group data that is split into pages.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreGroup extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreGroup';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Initial groupers, specify to have store grouped automatically after initially setting data
       * @config {Object[]}
       * @category Common
       */
      groupers: null
    };
  }

  static get properties() {
    return {
      collapsedGroups: new Set()
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config); // For handling record mutation, *not* add/remove of records.
    // Sorts dataset if necessary.

    this.on('change', this.onDataChanged, this);
  }
  /**
   * Currently used groupers
   * @property {Object[]}
   * @category Sort, group & filter
   */


  get groupers() {
    return this._groupers;
  }

  set groupers(groupers) {
    const me = this,
          {
      storage
    } = me;

    if (groupers !== null && groupers !== void 0 && groupers.length) {
      me._groupers = groupers;
    } else if (me.groupers) {
      delete me._groupers;
      me.includeCollapsed();
      storage.replaceValues({
        values: me.removeHeadersAndFooters(storage._values),
        filteredValues: storage.isFiltered ? me.removeHeadersAndFooters(storage._filteredValues) : null,
        silent: true
      });
      me.group(null, null, null, false);
    } // Need to clear the id map so it gets rebuilt next time its accessed


    me._idMap = null;
  } // Collects group headers/footers on the fly. Not used in any performance sensitive code, but if that need arises
  // it should be cached and invalidated on record remove, add, update, grouping changes, filter and sorting...


  get groupRecords() {
    const groupRecords = [];

    if (this.isGrouped) {
      for (const record of this) {
        if (record.isSpecialRow) {
          groupRecords.push(record);
        }
      }
    }

    return groupRecords;
  } // Temporarily include records from collapsed groups, for example prior to filtering


  includeCollapsed() {
    for (const groupId of this.collapsedGroups) {
      this.expand(this.getById(groupId), false);
    }
  } // Exclude records in collapsed groups, intended to be used after a call to includeCollapsed()


  excludeCollapsed() {
    for (const groupId of this.collapsedGroups) {
      this.collapse(this.getById(groupId));
    }
  }

  onDataChange({
    source: storage,
    action,
    removed
  }) {
    var _super$onDataChange;

    const me = this,
          {
      groupers
    } = me; // Only do grouping transformations if we have groupers to apply.
    // In stores which never use grouping, this code is superfluous and will reduce performance.
    // The else side will simply replace the ungrouped data with itself.

    if (groupers) {
      // When records are added or removed, re-evaluate the group records
      // so that when the events are fired by the super call, the group
      // records are in place.
      if (groupers.length) {
        if (action === 'splice' && removed !== null && removed !== void 0 && removed.length) {
          storage.replaceValues({
            values: me.prepareGroupRecords(),
            silent: true
          });
        }
      } // Remove all group headers and footers
      else {
        storage.replaceValues({
          values: me.removeHeadersAndFooters(storage.values),
          silent: true
        });
      }
    }

    (_super$onDataChange = super.onDataChange) === null || _super$onDataChange === void 0 ? void 0 : _super$onDataChange.call(this, ...arguments);
  } // private function that collapses on the data level
  // TODO: make public and trigger events for grid to react to?


  collapse(groupRecord) {
    if (groupRecord && !groupRecord.meta.collapsed) {
      this.excludeGroupRecords(groupRecord);
      groupRecord.meta.collapsed = true; // Track which groups are collapsed

      this.collapsedGroups.add(groupRecord.id);
      return true;
    }

    return false;
  } // private function that expands on the data level
  // TODO: make public and trigger events for grid to react to?


  expand(groupRecord, updateMap = true) {
    if (groupRecord !== null && groupRecord !== void 0 && groupRecord.meta.collapsed) {
      this.includeGroupRecords(groupRecord);
      groupRecord.meta.collapsed = false; // Optionally track which groups are collapsed (not done when expanding temporarily prior to filtering etc)

      updateMap && this.collapsedGroups.delete(groupRecord.id);
      return true;
    }

    return false;
  }

  removeHeadersAndFooters(records) {
    return records.filter(r => {
      if (r.isSpecialRow) {
        this.unregister(r);
        return false;
      } else {
        return true;
      }
    });
  }

  prepareGroupRecords(sorter) {
    const me = this,
          toCollapse = me.collapsedGroups,
          toExpand = [];
    let records = me.storage.values;

    for (const record of records) {
      if (record.isGroupHeader && (record.meta.collapsed || toCollapse.has(record.id))) {
        toCollapse.add(record.id); // TODO - This line should no longer be needed, try without it when tests pass

        toExpand.push(record);
      }
    }

    for (const record of toExpand) {
      me.includeGroupRecords(record);
    }

    records = me.removeHeadersAndFooters(me.storage.values);

    if (sorter) {
      records = records.sort(sorter);
    }

    if (!me.isGrouped) {
      return records;
    }

    const groupedRecords = [],
          field = me.groupers[0].field;
    let curGroup = null,
        curGroupRecord = null,
        childCount = 0;

    function addFooter() {
      const val = curGroupRecord.meta.groupRowFor,
            id = `group-footer-${typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createId(val)}`,
            footer = me.getById(id) || new me.modelClass({
        id
      }, me, {
        specialRow: true,
        groupFooterFor: val,
        groupRecord: curGroupRecord
      }); // Used by indexOf to determine if part of store

      footer.stores = [me];
      me.register(footer);
      footer.groupChildren = curGroupRecord.groupChildren;

      if (!curGroupRecord.meta.collapsed) {
        groupedRecords.push(footer);
      }

      me.allRecords.push(footer);
      curGroupRecord.groupChildren.push(footer);
      childCount++;
      return footer;
    }

    records.forEach(record => {
      var _record$groupChildren;

      const val = record[field] == undefined ? '__novalue__' : record[field],
            id = `group-header-${typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createId(val)}`; // A group header or footer record of an empty group.
      // Remove from the data

      if (((_record$groupChildren = record.groupChildren) === null || _record$groupChildren === void 0 ? void 0 : _record$groupChildren.length) === 0) {
        me.unregister(record);
        return;
      }

      if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(val, curGroup)) {
        if (curGroupRecord) {
          // also add group footer? used by GroupSummary feature
          if (me.useGroupFooters) {
            addFooter(curGroupRecord);
          }

          curGroupRecord.meta.childCount = childCount;
        }

        curGroupRecord = me.getById(id) || new me.modelClass({
          id
        }, me, {
          specialRow: true,
          groupRowFor: val,
          groupField: field,
          collapsed: toCollapse.has(id)
        }); // Used by indexOf to determine if part of store

        curGroupRecord.stores = [me];
        me.register(curGroupRecord);
        curGroupRecord.groupChildren = [];
        groupedRecords.push(curGroupRecord);
        me.allRecords.push(curGroupRecord);
        curGroup = val;
        childCount = 0;
      }

      record.instanceMeta(me.id).groupParent = curGroupRecord; // Collapse groups that was collapsed earlier

      if (!toCollapse.has(id)) {
        groupedRecords.push(record);
      }

      curGroupRecord.groupChildren.push(record);
      childCount++;
    }); // misses for last group without this

    if (curGroupRecord) {
      // footer for last group
      if (me.useGroupFooters) {
        addFooter();
      }

      curGroupRecord.meta.childCount = childCount;
    }

    return groupedRecords;
  } //endregion
  //region Group and ungroup

  /**
   * Is store currently grouped?
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isGrouped() {
    var _this$groupers;

    return Boolean((_this$groupers = this.groupers) === null || _this$groupers === void 0 ? void 0 : _this$groupers.length);
  }
  /**
   * Group records, either by replacing current sorters or by adding to them.
   * A grouper can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
   * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
   * normal sorting routine. Grouped store **must** always be sorted by the same field.
   *
   * ```javascript
   * // simple grouper
   * store.group('city');
   *
   * // grouper as object, descending order
   * store.group({ field : 'city', ascending : false });
   *
   * // using custom sorting function
   * store.group({
   *     field : 'city',
   *     fn : (recordA, recordB) => {
   *         // apply custom logic, for example:
   *         return recordA.city.length < recordB.city.length ? -1 : 1;
   *     }
   * });
   * ```
   *
   * @param {String|Object} field Field to group by.
   * Can also be a config containing a field to group by and a custom sorting function called `fn`.
   * @param {Boolean} [ascending] Sort order of the group titles
   * @param {Boolean} [add] Add a grouper (true) or use only this grouper (false)
   * @param {Boolean} [performSort] Trigger sort directly, which does the actual grouping
   * @param {Boolean} [silent] Set as true to not fire events
   * @category Sort, group & filter
   * @fires group
   * @fires refresh
   */


  group(field, ascending, add = false, performSort = true, silent = false) {
    const me = this;
    let newGrouper, fn;

    if (field && typeof field === 'object') {
      ascending = field.ascending;
      fn = field.fn;
      field = field.field;
    }

    if (add) {
      me.groupers.push(newGrouper = {
        field,
        ascending,
        complexMapping: field.includes('.')
      });
    } else if (field) {
      if (ascending == null) {
        var _me$groupInfo, _me$groupInfo2;

        ascending = ((_me$groupInfo = me.groupInfo) === null || _me$groupInfo === void 0 ? void 0 : _me$groupInfo.field) === field && ((_me$groupInfo2 = me.groupInfo) === null || _me$groupInfo2 === void 0 ? void 0 : _me$groupInfo2.fn) === fn ? !me.groupInfo.ascending : true;
      }

      me.groupInfo = newGrouper = {
        field,
        ascending,
        fn,
        complexMapping: field.includes('.')
      };
      me.groupers = [me.groupInfo];
    }

    if (newGrouper) {
      const {
        prototype
      } = me.modelClass; // Create a getter for complex field names like "get resource.city"

      if (newGrouper.complexMapping && !Object.prototype.hasOwnProperty.call(prototype, field)) {
        Object.defineProperty(prototype, field, {
          get() {
            return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this, field);
          }

        });
      }
    } // as far as the store is concerned, grouping is just more sorting. so trigger sort


    if (performSort !== false) {
      me.sort(null, null, false, true);
    }

    if (!silent) {
      /**
       * Fired when grouping changes
       * @event group
       * @param {Core.data.Store} source This Store
       * @param {Object[]} groupers Applied groupers
       * @param {Core.data.Model[]} records Grouped records
       */
      me.trigger('group', {
        isGrouped: me.isGrouped,
        groupers: me.groupers,
        records: me.storage.values
      });
      me.trigger('refresh', {
        action: 'group',
        isGrouped: me.isGrouped,
        groupers: me.groupers,
        records: me.storage.values
      });
    }
  } // Internal since UI does not support multi grouping yet

  /**
   * Add a grouping level (a grouper).
   * @param {String} field Field to group by
   * @param {Boolean} ascending Group direction
   * @category Sort, group & filter
   * @internal
   */


  addGrouper(field, ascending = true) {
    this.group(field, ascending, true);
  } // Internal since UI does not support multi grouping yet

  /**
   * Removes a grouping level (a grouper)
   * @param {String} field Grouper to remove
   * @category Sort, group & filter
   * @internal
   */


  removeGrouper(field) {
    const me = this,
          {
      groupers
    } = me,
          index = groupers.findIndex(grouper => grouper.field === field);

    if (index > -1) {
      groupers.splice(index, 1);

      if (!groupers.length) {
        me.clearGroupers();
      } else {
        me.group();
      }
    }
  }
  /**
   * Removes all groupers, turning store grouping off.
   * @category Sort, group & filter
   */


  clearGroupers() {
    this.groupers = null;
  } //endregion
  //region Get and check

  /**
   * Check if a record belongs to a certain group (only for the first grouping level)
   * @param {Core.data.Model} record The Record
   * @param {*} groupValue The group value
   * @returns {Boolean} True if the record belongs to the group, otherwise false
   * @category Sort, group & filter
   */


  isRecordInGroup(record, groupValue) {
    var _this$groupers$;

    if (!this.isGrouped) {
      return null;
    }

    const groupField = (_this$groupers$ = this.groupers[0]) === null || _this$groupers$ === void 0 ? void 0 : _this$groupers$.field;
    return record[groupField] === groupValue && !record.isSpecialRow;
  }

  isInCollapsedGroup(record) {
    const parentGroupRec = record.instanceMeta(this).groupParent;
    return parentGroupRec === null || parentGroupRec === void 0 ? void 0 : parentGroupRec.meta.collapsed;
  }
  /**
   * Returns all records in the group with specified groupValue.
   * @param {*} groupValue
   * @returns {Core.data.Model[]} Records in specified group or null if store not grouped
   * @category Sort, group & filter
   */


  getGroupRecords(groupValue) {
    if (!this.isGrouped) {
      return null;
    }

    return this.storage.values.filter(record => this.isRecordInGroup(record, groupValue));
  }
  /**
   * Get all group titles.
   * @returns {String[]} Group titles
   * @category Sort, group & filter
   */


  getGroupTitles() {
    if (!this.isGrouped) {
      return null;
    }

    return this.getDistinctValues(this.groupers[0].field);
  } //endregion


  onDataChanged({
    changes,
    action
  }) {
    if (this.isGrouped && ( // If an action flagged as requiring resort is performed...
    !changes && resortActions[action] || // ...or if the group field has changes...
    changes && this.groupers.some(grouper => grouper.field in changes))) {
      // ...then re-sort
      this.sort();
    }
  }
  /**
   * Adds or removes records in a group from storage. Used when expanding/collapsing groups.
   * @private
   * @param {Core.data.Model} groupRecord Group which records should be added or removed
   * @param {Boolean} include Include (true) or exclude (false) records
   * @category Grouping
   */


  internalIncludeExcludeGroupRecords(groupRecord, include) {
    const me = this,
          index = me.indexOf(groupRecord),
          {
      id: mapId,
      storage
    } = me,
          {
      meta,
      groupChildren
    } = groupRecord; // Skip if group record is not found, otherwise it removes records from wrong position.
    // Also prevent removing from already collapsed and vice versa

    if (index === -1 || meta.collapsed && !include || !meta.collapsed && include) {
      return;
    }

    groupChildren.forEach(child => child.instanceMeta(mapId).hiddenByCollapse = !include);

    if (include) {
      // Avoid adding record duplicates which may already have been reinserted by clearing filters
      const includeChildren = groupChildren.filter(r => !me.isAvailable(r));
      storage.values.splice(index + 1, 0, ...includeChildren);
    } else {
      storage.values.splice(index + 1, groupChildren.length);
    }

    storage._indicesInvalid = true;
    me._idMap = null;
  }
  /**
   * Removes records in a group from storage. Used when collapsing a group.
   * @private
   * @param groupRecord Group which records should be removed
   * @category Grouping
   */


  excludeGroupRecords(groupRecord) {
    this.internalIncludeExcludeGroupRecords(groupRecord, false);
  }
  /**
   * Adds records in a group to storage. Used when expanding a group.
   * @private
   * @param groupRecord Group which records should be added
   * @category Grouping
   */


  includeGroupRecords(groupRecord) {
    this.internalIncludeExcludeGroupRecords(groupRecord, true);
  }
  /**
   * Collects all group headers + children, whether expanded or not
   * @private
   * @param {Boolean} allRecords True to include filtered out records
   * @param {Boolean} includeHeaders True to also include group headers
   * @returns {Core.data.Model[]}
   */


  collectGroupRecords(allRecords, includeHeaders = true) {
    const records = allRecords ? this.storage.allValues : this.storage.values;
    return records.reduce((records, record) => {
      if (record.isSpecialRow) {
        if (includeHeaders) {
          records.push(record);
        }

        if (record.isGroupHeader) {
          records.push.apply(records, record.groupChildren);
        }
      }

      return records;
    }, []);
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreProxy.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreProxy.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Core/data/mixin/StoreProxy
 */

/**
 * Object-like interaction with a Store by using a Proxy. To enable, configure the store with `objectify : true`.
 *
 * ```javascript
 * const store = new Store({
 *    objectify : true,
 *    data      : [
 *        { id : 'batman', name : 'Bruce' }
 *    ]
 * });
 * ```
 *
 * Access records using their ids as Store properties:
 * ```javascript
 * console.log(store.batman.name); // logs Bruce
 * ```
 *
 * Add records by assigning properties to the Store:
 * ```javascript
 * store.superman = { name : 'Clark' }; // Id will be 'superman'
 * ```
 *
 * Remove records by removing their property:
 * ```javascript
 * delete store.batman;
 * ```
 *
 * Check if a certain id existing in the store by using `in`:
 * ```javascript
 * console.log('superman' in store): // logs true
 * ```
 *
 * Please note that this approach:
 * * Will affect performance slightly, not recommended for larger datasets.
 * * Uses native Proxy, which cannot be polyfilled. Not possible to get it working in IE11.
 * * Preserves predefined Store properties, records cannot use ids that match those.
 * * Might have other limitations preventing the use of it in some scenarios where a normal Store can be used.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreProxy extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * Allow object like interaction with the Store. For example:
       *
       * ```javascript
       * const store = new Store({
       *    objectify : true,
       *    data      : [
       *        { id : 'batman', name : 'Bruce' }
       *    ]
       * });
       *
       * // retrieve using id as property
       * const record = store.batman;
       *
       * // add as property
       * store.superman = { name : 'Clark' };
       *
       * // delete to remove
       * delete store.batman;
       * ``
       *
       * @config {Boolean}
       * @default false
       */
      objectify: null
    };
  }

  initProxy() {
    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.Proxy) {
      throw new Error('Proxy not supported');
    }

    const proxy = new Proxy(this, {
      // Support getting records using `store[id/index]
      get(target, property) {
        // Stores own properties take precedence
        if (property in target) {
          return target[property];
        } // To allow accessing the underlying store


        if (property === '$store') {
          return target;
        } // Then ids


        let record = target.getById(property); // And finally index

        if (!record && !isNaN(parseInt(property))) {
          record = target.getAt(parseInt(property));
        }

        return record;
      },

      // Support adding/replacing records using `store.id = { ...data }`
      set(target, property, value) {
        // Pass through when using names of existing properties or when destroyed/ing
        if (property in target || target.isDestroying) {
          target[property] = value;
        } // Otherwise add/replace a record
        else {
          target.add(_objectSpread({
            [target.modelClass.idField]: property
          }, value));
        }

        return true;
      },

      // Support deleting records using `delete store.id`
      deleteProperty(target, property) {
        // Properties are deleted on destroy
        if (target.isDestroying) {
          delete target[property];
          return true;
        }

        return Boolean(target.remove(property).length);
      },

      // Support `id in store`
      has(target, property) {
        // Actual property
        if (property in target) {
          return true;
        } // Threat { ... } as JSON representation of a record (likely from toString())


        if (property.startsWith('{') && property.endsWith('}')) {
          const data = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonParse(property);
          property = data === null || data === void 0 ? void 0 : data.id;
        }

        return target.includes(property);
      }

    });
    return proxy;
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreRelation.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/mixin/StoreRelation.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';




/**
 * @module Core/data/mixin/StoreRelation
 */

/**
 * Mixin for Store that handles relations with other stores (actually defined on model).
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreRelation extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreRelation';
  } //region Init

  /**
   * Initialized relations, called from constructor
   * @private
   */


  initRelations(reset) {
    const me = this,
          relations = me.modelClass.relations;

    if (reset && me.modelRelations) {
      // reset will reinit all relations, stop listening for store events on existing ones
      me.modelRelations.forEach(relation => {
        relation.storeDetacher && relation.storeDetacher();
      });
    }

    if ((!me.modelRelations || me.modelRelations.length === 0 || reset) && relations) {
      me.modelRelations = []; // foreignKeys is filled when model exposes its properties

      relations && relations.forEach(modelRelationConfig => {
        const config = Object.assign({}, modelRelationConfig),
              relatedStore = typeof config.store === 'string' ? me[config.store] : config.store;
        config.dependentStore = me;
        me.modelRelations.push(config);

        if (relatedStore) {
          config.storeProperty = config.store;
          config.store = relatedStore; // repeated from initRelationStores, needed if stored is assigned late

          const dependentStoreConfigs = relatedStore.dependentStoreConfigs; // Add link to dependent store

          if (dependentStoreConfigs.has(me)) {
            const dependentConfigs = dependentStoreConfigs.get(me); // Remove existing config on reset

            if (reset) {
              const existingConfig = dependentConfigs.find(c => c.relationName === config.relationName);

              if (existingConfig) {
                _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(dependentConfigs, existingConfig);
              }
            }

            dependentConfigs.push(config);
          } else {
            dependentStoreConfigs.set(me, [config]);
          } // if foreign key specifies collectionName the related store should also be configured


          if (config.collectionName) {
            relatedStore.initRelationCollection(config, me);
          }

          if (relatedStore.count > 0) {
            relatedStore.updateDependentStores('dataset', relatedStore.records);
          }
        }
      });
    }
  }
  /**
   * Called from other end of an relation when this store should hold a collection of related records.
   * @private
   * @param config
   * @param collectionStore
   */


  initRelationCollection(config, collectionStore) {
    // TODO: parts of this should move to model?
    const me = this,
          name = config.collectionName;

    if (!me.collectionStores) {
      me.collectionStores = {};
    }

    me.collectionStores[name] = {
      store: collectionStore,
      config: config
    };

    if (!me[name + 'Store']) {
      me[name + 'Store'] = collectionStore;
    }

    if (me.count > 0) {
      me.initModelRelationCollection(name, me.records);
    }
  }

  initModelRelationCollection(name, records) {
    const me = this; // add collection getter to each model

    records.forEach(record => {
      // Needs to work in trees also, if not a tree traverse just calls fn on self
      record.traverse(node => {
        // Add/replace $relatedAssignments (or similar) if assignments already exists on target
        const useName = name in node ? `$related${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(name)}` : name;
        Object.defineProperty(node, useName, {
          enumerable: true,
          configurable: true,
          get: function () {
            return me.getCollection(this, name);
          },
          set: function (value) {
            return me.setCollection(this, name, value);
          }
        });
      });
    });
  } //TODO: Do diff update, this is called on filtering and will be heavy with lots of records

  /**
   * Updates relationCache for all records.
   * @private
   */


  resetRelationCache() {
    this.relationCache = {};
    this.forEach(record => record.initRelations());
  }
  /**
   * Caches related records from related store on the local store.
   * @private
   * @param record Local record
   * @param relations Relations to related store
   */


  updateRecordRelationCache(record, relations) {
    const me = this;
    relations && relations.forEach(relation => {
      // use related records id, or if called before "binding" is complete use foreign key
      const foreignId = relation.related ? relation.related.id : record.get(relation.config.fieldName); // cache on that id, removing previously cached value if any

      foreignId !== undefined && me.cacheRelatedRecord(record, foreignId, relation.config.relationName, foreignId);
    });
  } //endregion
  //region Getters

  /**
   * Returns records the relation cache. Same result as if retrieving the collection on the dependent store, but
   * without the need of accessing that store.
   * @internal
   * @param {String} name
   * @param {Core.data.Model|String|Number} recordOrId
   * @returns {Array}
   */


  getRelationCollection(name, recordOrId) {
    const id = _Model_js__WEBPACK_IMPORTED_MODULE_3__["default"].asId(recordOrId);
    return this.relationCache[name] && this.relationCache[name][id] || [];
  }
  /**
   * Returns records from a collection of related records. Not to be called directly, called from Model getter.
   * TODO: Move to Model?
   * @private
   * @param {Core.data.Model} record
   * @param {String} name
   * @returns {Array}
   */


  getCollection(record, name) {
    const {
      config,
      store
    } = this.collectionStores[name];
    return store.relationCache[config.relationName] && store.relationCache[config.relationName][record.id] || [];
  }
  /**
   * Sets a collection of related records. Will updated the related store and trigger events from it. Not to be called
   * directly, called from Model setter.
   * @private
   */


  setCollection(model, name, records) {
    const {
      config,
      store
    } = this.collectionStores[name];
    if (!store.relationCache[config.relationName]) store.relationCache[config.relationName] = {};
    const old = (store.relationCache[config.relationName][model.id] || []).slice(),
          added = [],
          removed = [];
    store.suspendEvents(); // Remove any related records not in the new collection

    old.forEach(record => {
      if (!records.includes(record)) {
        record[config.fieldName] = null;
        store.remove(record);
        removed.push(record);
      }
    }); // Add records from the new collection not already in store

    records.forEach(record => {
      if (record instanceof _Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
        if (!record.stores.includes(store)) {
          store.add(record);
          added.push(record);
        }
      } else {
        [record] = store.add(record);
        added.push(record);
      } // Init relation


      record[config.fieldName] = model.id;
    });
    store.resumeEvents();

    if (removed.length) {
      store.trigger('remove', {
        records: removed
      });
      store.trigger('change', {
        action: 'remove',
        records: removed
      });
    }

    if (added.length) {
      store.trigger('add', {
        records: added
      });
      store.trigger('change', {
        action: 'add',
        records: added
      });
    }
  } //endregion
  //region Caching

  /**
   * Adds a record to relation cache, optionally removing it if already there.
   * @private
   * @param record
   * @param id
   * @param name
   * @param uncacheId
   */


  cacheRelatedRecord(record, id, name, uncacheId = null) {
    const me = this,
          cache = me.relationCache[name] || (me.relationCache[name] = {});

    if (uncacheId !== null) {
      me.uncacheRelatedRecord(record, name, uncacheId);
    }

    if (id != null) {
      // Only include of not already in relation cache, which might happen when removing and re-adding the same instance
      _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].include(cache[id] || (cache[id] = []), record);
    }
  }
  /**
   * Removes a record from relation cache, for a specific relation (specify relation name and id) or for all relations
   * @private
   * @param record Record to remove from cache
   * @param name Optional, relation name
   * @param id Optional, id
   */


  uncacheRelatedRecord(record, name = null, id = null) {
    const me = this;

    function remove(relationName, relatedId) {
      const cache = me.relationCache[relationName],
            oldCache = cache && cache[relatedId]; // When unjoining a record from a filtered store the relationCache will also be filtered
      // and might give us nothing, in which case we have nothing to clean up and bail out

      if (oldCache) {
        const uncacheIndex = oldCache.indexOf(record);
        uncacheIndex >= 0 && oldCache.splice(uncacheIndex, 1);

        if (oldCache.length === 0) {
          delete cache[relatedId];
        }
      }
    }

    if (id != null) {
      remove(name, id);
    } else {
      if (record.meta.relationCache) {
        Object.entries(record.meta.relationCache).forEach(([relationName, relatedRecord]) => {
          const relatedId = relatedRecord && relatedRecord.id;
          remove(relationName, relatedId);
        });
      }
    }
  }
  /**
   * Updates related stores when store is cleared, a record is removed or added.
   * @private
   * @param {String} action
   * @param {Core.data.Model[]} records
   */


  updateDependentStores(action, records) {
    this.dependentStoreConfigs.forEach(configs => {
      configs.forEach(config => {
        const dependentStore = config.dependentStore,
              cache = dependentStore.relationCache[config.relationName];

        if (action === 'dataset') {
          config.collectionName && this.initModelRelationCollection(config.collectionName, records);
          dependentStore.forEach(record => {
            const foreign = record.initRelation(config);
            foreign && dependentStore.cacheRelatedRecord(record, foreign.id, config.relationName, foreign.id);
          });
          return;
        }

        if (action === 'removeall') {
          dependentStore.forEach(record => {
            record.removeRelation(config);
          });
          delete dependentStore.relationCache[config.relationName];
          return;
        }

        if (action === 'add') {
          config.collectionName && this.initModelRelationCollection(config.collectionName, records);
        }

        if (action === 'add' || action === 'remove') {
          records.forEach(record => {
            const dependentRecords = cache && cache[record.id];

            switch (action) {
              case 'remove':
                // removing related record removes from cache on model and store
                if (dependentRecords) {
                  dependentRecords.forEach(dependentRecord => dependentRecord.removeRelation(config)); // Altered to not delete on self, simplifies taking actions on related records after remove if relation still lives
                  //delete cache[relatedRecord.id];
                } // TODO: Should removing related set foreign key to null? (removing Team sets Player.teamId to null)


                break;

              case 'add':
                // adding a new record in related store checks if any foreign keys match the new id,
                // and if so it sets up the relation
                dependentStore.forEach(dependentRecord => {
                  if (dependentRecord.get(config.fieldName) == record.id) {
                    dependentRecord.initRelation(config);
                    dependentStore.cacheRelatedRecord(dependentRecord, record.id, config.relationName);
                  }
                });
                break;
            }
          });
        }
      });
    });
  }
  /**
   * Updates relation cache and foreign key value when a related objects id is changed.
   * @private
   */


  updateDependentRecordIds(oldValue, value) {
    this.dependentStoreConfigs && this.dependentStoreConfigs.forEach(configs => {
      configs.forEach(config => {
        const dependentStore = config.dependentStore,
              cache = dependentStore.relationCache[config.relationName],
              localRecords = cache && cache[oldValue] && cache[oldValue].slice();
        localRecords && localRecords.forEach(localRecord => {
          // First update cache
          dependentStore.cacheRelatedRecord(localRecord, value, config.relationName, oldValue); // Then update & announce, otherwise relations wont be up to date in listeners

          localRecord.set(config.fieldName, value, false, true);
        });
      });
    });
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSearch.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreSearch.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Core/data/mixin/StoreSearch
 */

const stringFound = (value, find) => String(value).toLowerCase().indexOf(find) !== -1,
      comparisons = {
  string: stringFound,
  number: stringFound,
  boolean: stringFound,
  date: (value, find) => {
    if (value instanceof Date && find instanceof Date) {
      return String(value) === String(find);
    }

    return String(value.getMonth() + 1).indexOf(find) !== -1 || String(value.getDate()).indexOf(find) !== -1 || String(value.getFullYear()).indexOf(find) !== -1;
  },
  object: (value, find) => value === find,
  // typeof null === object
  undefined: (value, find) => value === find
};
/**
 * Mixin for Store that handles searching (multiple records) and finding (single record).
 *
 * @example
 * // find all records that has a field containing the string john
 * let hits = store.search('john');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSearch extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSearch';
  } //region Search (multiple hits)

  /**
   * Find all hits matching the specified input
   * @param {String} find Value to search for
   * @param {Object[]} fields Fields to search value in
   * @returns {Object[]} Array of hits, in the format { index: x, data: record }
   * @category Search
   */


  search(find, fields = null) {
    const records = this.storage.values,
          len = records.length,
          found = [];

    if (find == null) {
      return null;
    }

    if (typeof find === 'string') {
      find = find.toLowerCase();
    }

    let i, record, value, valueType, comparison;

    for (i = 0; i < len; i++) {
      record = records[i];

      for (const key of fields || record.fieldNames) {
        var _comparison;

        value = record[key];
        valueType = value instanceof Date ? 'date' : typeof value;
        comparison = comparisons[valueType];

        if (value && (_comparison = comparison) !== null && _comparison !== void 0 && _comparison(value, find)) {
          found.push({
            index: i,
            data: record,
            field: key,
            id: record.id
          });
        }
      }
    }

    return found;
  }
  /**
   * Find occurrences of the specified `value` in the specified `field` on all records in the store
   * @param {String} field The record field to search in
   * @param {*} value Value to search for
   * @returns {Object[]} Array of hits, in the format { index: x, data: record }
   * @category Search
   */


  findByField(field, value, distinct = false) {
    const records = this.storage.values,
          len = records.length,
          usedValues = new Set(),
          found = [];
    let i, record, fieldValue;

    if (value != null) {
      value = String(value).toLowerCase();
    }

    for (i = 0; i < len; i++) {
      record = records[i];
      fieldValue = record[field];

      if (!distinct || !usedValues.has(fieldValue)) {
        const type = fieldValue instanceof Date ? 'date' : typeof fieldValue,
              comparison = comparisons[type];

        if (value == null && fieldValue === value || value && comparison(fieldValue, value)) {
          found.push({
            id: record.id,
            index: i,
            data: record
          });

          if (distinct) {
            usedValues.add(fieldValue);
          }
        }
      }
    }

    return found;
  } //endregion
  //region Find (single hit)

  /**
   * Finds the first record for which the specified function returns true
   * @param {Function} fn Comparison function, called with record as parameter
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model} Record or undefined if none found
   *
   * @example
   * store.find(record => record.color === 'blue');
   * @category Search
   */


  find(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.find(fn);
  }
  /**
   * Finds the first record for which the specified field has the specified value
   * @param {String} fieldName Field name
   * @param {*} value Value to find
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model} Record or undefined if none found
   * @category Search
   */


  findRecord(fieldName, value, searchAllRecords = false) {
    const matchFn = r => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(r[fieldName], value);

    if (this.isTree) {
      return this.query(matchFn, searchAllRecords)[0];
    }

    return (searchAllRecords ? this.storage.allValues : this.storage.values).find(matchFn);
  }
  /**
   * Searches the Store records using the passed function.
   * @param {Function} fn A function that is called for each record. Return true to indicate a match
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model[]} An array of the matching Records
   * @category Search
   */


  query(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isTree) {
      const matches = [];
      this.traverse(node => {
        if (fn(node)) {
          matches.push(node);
        }
      }, undefined, undefined, searchAllRecords);
      return matches;
    } else if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.filter(fn);
  } //endregion
  //region Others

  /**
   * Returns true if the supplied function returns true for any record in the store
   * @param {Function} fn A function that should return true to indicate a match
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Boolean}
   *
   * @example
   * store.some(record => record.age > 95); // true if any record has age > 95
   * @category Search
   */


  some(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.some(fn);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSort.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSort.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Core/data/mixin/StoreSort
 */

const nestedRe = /\./;
/**
 * Mixin for Store that handles simple sorting as well as multi-level sorting.
 *
 * ```javascript
 * // single sorter
 * store.sort('age');
 *
 * // single sorter as object, descending order
 * store.sort({ field : 'age', ascending : false });
 *
 * // multiple sorters
 * store.sort(['age', 'name']);
 *
 * // using custom sorting function
 * store.sort({
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.name.length < recordB.name.length ? -1 : 1;
 *     }
 * });
 *
 * // using locale specific sort (slow)
 * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSort extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSort';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Initial sorters, format is [{ field: 'name', ascending: false }, ...]
       * @config {Object[]|String[]}
       * @category Common
       */
      sorters: [],

      /**
       * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
       * a locale string or a locale config to enable.
       *
       * Enabling this has big negative impact on sorting
       * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
       *
       * Examples:
       *
       * ```javascript
       * const store = new Store({
       *     // Swedish sorting
       *     useLocaleSort : 'sv-SE'
       * });
       *
       * const store = new Store({
       *     // Swedish sorting with custom casing order
       *     useLocaleSort : {
       *         locale    : 'sv-SE',
       *         caseFirst : 'upper'
       *     }
       * });
       * ```
       *
       * Can also be configured on a per sorter basis:
       *
       * ```javascript
       * store.sort({ field: 'name', useLocaleSort : 'sv-SE' });
       * ```
       *
       * @config {Boolean|String|Object}
       * @default false
       * @category Advanced
       */
      useLocaleSort: null
    };
  }

  static get configurable() {
    return {
      /**
       * Specify true to sort this store after records are added.
       * @config {Boolean}
       * @default
       * @category Sortering
       */
      reapplySortersOnAdd: false
    };
  } //endregion
  //region Events

  /**
   * Fired before sorting
   * @event beforeSort
   * @param {Core.data.Store} source This Store
   * @param {Object[]} sorters Sorter configs
   * @param {Core.data.Model[]} records Records to sort
   */

  /**
   * Fired after sorting
   * @event sort
   * @param {Core.data.Store} source This Store
   * @param {Object[]} sorters Sorter configs
   * @param {Core.data.Model[]} records Sorted records
   */
  //endregion
  //region Properties

  /**
   * Currently applied sorters
   * @member {Object[]} sorters
   * @readonly
   * @category Sort, group & filter
   */

  /**
   * Is store sorted?
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isSorted() {
    return Boolean(this.sorters.length) || this.isGrouped;
  }

  updateReapplySortersOnAdd(enable) {
    this.storage.autoSort = enable;
  } //endregion
  //region Add & remove sorters

  /**
   * Sort records, either by replacing current sorters or by adding to them.
   * A sorter can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
   * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
   * normal sorting routine.
   *
   * ```javascript
   * // single sorter
   * store.sort('age');
   *
   * // single sorter as object, descending order
   * store.sort({ field : 'age', ascending : false });
   *
   * // multiple sorters
   * store.sort(['age', 'name']);
   *
   * // using custom sorting function
   * store.sort((recordA, recordB) => {
   *     // apply custom logic, for example:
   *     return recordA.name.length < recordB.name.length ? -1 : 1;
   * });
   *
   * // using locale specific sort (slow)
   * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
   * ```
   *
   * @param {String|Object[]|Object|Function} field Field to sort by.
   * Can also be an array of {@link Core.util.CollectionSorter sorter} config objects, or a sorting function, or a {@link Core.util.CollectionSorter sorter} config.
   * @param {Boolean} [ascending] Sort order.
   * Applicable when the `field` is a string (if not specified and already sorted by the field, reverts direction),
   * or an object and `ascending` property is not specified for the object. `true` by default.
   * Not applicable when `field` is a function. `ascending` is always `true` in this case.
   * @param {Boolean} [add] If `true`, adds a sorter to the sorters collection.
   * Not applicable when `field` is an array. In this case always replaces active sorters.
   * @param {Boolean} [silent] Set as true to not fire events. UI will not be informed about the changes.
   * @category Sort, group & filter
   * @fires beforeSort
   * @fires sort
   * @fires refresh
   */


  sort(field, ascending, add = false, silent = false) {
    const me = this,
          records = me.allRecords,
          currentSorters = me.sorters ? me.sorters.slice() : [];
    let currentDir = null,
        curSort;

    if (field) {
      if (Array.isArray(field)) {
        // array of strings make fields always be sorted ascending
        me.sorters = field.map(sorter => me.normalizeSorterConfig(sorter, typeof sorter === 'string' ? true : ascending));
      } else {
        const sorter = me.normalizeSorterConfig(field, ascending);

        if (add) {
          curSort = me.getCurrentSorterByField(sorter.field); // Field already among sorters? change sort direction instead of adding new sorter

          if (curSort) {
            currentDir = curSort.ascending;
            curSort.ascending = sorter.ascending;
          } else {
            me.sorters.push(sorter);
          }
        } else {
          me.sorters = [sorter];
        }
      }
    }

    if (!silent && me.trigger('beforeSort', {
      sorters: me.sorters,
      records,
      currentSorters
    }) === false) {
      // Restore sorters
      me.sorters = currentSorters; // Restore sorting direction if toggled

      if (currentDir !== null) {
        curSort.ascending = currentDir;
      }

      return;
    }

    return me.performSort(silent);
  }

  normalizeSorterConfig(field, ascending) {
    const me = this,
          sorter = {
      ascending
    };

    if (typeof field === 'object') {
      var _field$ascending;

      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(sorter, field);

      if (field.fn) {
        delete sorter.fn;
        sorter.sortFn = field.fn;
      }

      sorter.ascending = (_field$ascending = field.ascending) !== null && _field$ascending !== void 0 ? _field$ascending : ascending;
    } else if (typeof field === 'function') {
      sorter.sortFn = field;
    } else {
      sorter.field = field;
    } // sort in opposite direction if not specified and already sorted, default to sorting ascending


    if (sorter.ascending == null) {
      const curSort = me.getCurrentSorterByField(sorter.field);
      sorter.ascending = curSort ? !curSort.ascending : true;
    }

    if (sorter.sortFn == null) {
      var _me$modelClass, _me$modelClass$$meta$;

      const compareItems = (_me$modelClass = me.modelClass) === null || _me$modelClass === void 0 ? void 0 : (_me$modelClass$$meta$ = _me$modelClass.$meta.fields.map[sorter.field]) === null || _me$modelClass$$meta$ === void 0 ? void 0 : _me$modelClass$$meta$.compareItems;

      if (compareItems) {
        // These sorters will be ignored by AjaxStore when remoting...
        sorter.sortFn = compareItems;
      }
    }

    return sorter;
  }

  getCurrentSorterByField(field) {
    return typeof field === 'string' && this.sorters.find(s => s.field === field) || null;
  }
  /**
   * Add a sorting level (a sorter).
   * @param {String|Object[]|Object|Function} field Field to sort by. Can also be an array of sorters, or a sorting
   * function, or a {@link Core.util.CollectionSorter sorter} config.
   * @param {Boolean} [ascending] Sort order (used only if field specified as string)
   * @category Sort, group & filter
   */


  addSorter(field, ascending = true) {
    this.sort(field, ascending, true);
  }
  /**
   * Remove a sorting level (a sorter)
   * @param {String|Function} field Stop sorting by this field (or sorter function)
   * @category Sort, group & filter
   */


  removeSorter(field) {
    const sorterIndex = this.sorters.findIndex(sorter => sorter.field === field || sorter.sortFn === field);

    if (sorterIndex > -1) {
      this.sorters.splice(sorterIndex, 1);
      this.sort();
    }
  }
  /**
   * Removes all sorters, turning store sorting off.
   * @category Sort, group & filter
   */


  clearSorters() {
    if (this.sorters.length) {
      this.sorters.length = 0;
      this.sort();
    }
  } //region
  //region Sorting logic

  /**
   * Creates a function used with Array#sort when sorting the store. Override to use your own custom sorting logic.
   * @param {Object[]} sorters An array of sorter config objects
   * @returns {Function}
   * @category Sort, group & filter
   */


  createSorterFn(sorters) {
    const storeLocaleSort = this.useLocaleSort;
    return (lhs, rhs) => {
      // Cannot use `for ... of` here, breaks a test in IE11 were this fn is called from transpiled test code
      // which leads to iterator symbol mismatch
      for (let i = 0; i < sorters.length; i++) {
        const sorter = sorters[i],
              {
          field,
          ascending = true,
          useLocaleSort = storeLocaleSort
        } = sorter,
              fn = sorter.fn || sorter.sortFn,
              direction = ascending ? 1 : -1;

        if (fn) {
          const val = fn(lhs, rhs);

          if (val !== null) {
            return val * direction;
          }
        }

        const nested = nestedRe.test(field),
              lhsValue = nested ? lhs.get(field) : lhs[field],
              rhsValue = nested ? rhs.get(field) : rhs[field];

        if (lhsValue === rhsValue) {
          continue;
        }

        if (lhsValue == null) {
          return -direction;
        }

        if (rhsValue == null) {
          return direction;
        }

        if (useLocaleSort) {
          // Use systems locale
          if (useLocaleSort === true) {
            return String(lhsValue).localeCompare(rhsValue) * direction;
          } // Use specified locale


          if (typeof useLocaleSort === 'string') {
            return String(lhsValue).localeCompare(rhsValue, useLocaleSort) * direction;
          } // Use locale config


          if (typeof useLocaleSort === 'object') {
            return String(lhsValue).localeCompare(rhsValue, useLocaleSort.locale, useLocaleSort) * direction;
          }
        }

        if (lhsValue > rhsValue) {
          return direction;
        }

        if (lhsValue < rhsValue) {
          return -direction;
        }
      }

      return 0;
    };
  }
  /**
   * Perform sorting according to the {@link #config-sorters} configured.
   * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
   * must not be overridden.
   * @private
   * @category Sort, group & filter
   */


  performSort(silent) {
    const me = this,
          {
      rootNode,
      storage,
      sorters
    } = me,
          sorter = me.createSorterFn(me.isGrouped ? me.groupers.concat(sorters) : sorters);

    if (me.tree) {
      rootNode.traverse(node => {
        if (node.isLoaded && node.isParent) {
          node.children.sort(sorter); // Since child nodes change order their parentIndex needs to be updated.
          // Update is silent, records wont be considered modified because of the sort

          node.updateChildrenIndices(node.children, false, true);
        }
      });
      storage.replaceValues({
        values: me.collectDescendants(rootNode).visible,
        silent: true
      });
    } else if (me.isGrouped) {
      storage.replaceValues({
        values: me.prepareGroupRecords(sorter),
        silent: true
      });
    } else {
      storage.replaceValues({
        values: storage.values.sort(sorter),
        silent: true
      });
    }

    me.afterPerformSort(silent);
  }

  afterPerformSort(silent) {
    const me = this;
    me._idMap = null;

    if (!silent) {
      const event = {
        action: 'sort',
        sorters: me.sorters,
        records: me.allRecords
      };
      me.trigger('sort', event); // Only fire this event if it's a local sort.
      // If we are configured with sortParamName, the loadData will fire it.

      if (!me.sortParamName) {
        me.trigger('refresh', event);
      }
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreState.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreState.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Core/data/mixin/StoreState
 */

/**
 * A Mixin for Store that manages its state.
 *  * **sorters**
 *  * **groupers**
 *  * **filters**: Only serializable filters are saved (filters defined with `property` and `value`).
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreState extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreState';
  }
  /**
   * Get store state. Used by State-plugin to serialize state
   * @private
   * @returns {{ sorters, groupers }}
   */


  getState() {
    const {
      sorters,
      groupers,
      filters
    } = this,
          state = {};

    if (sorters !== null && sorters !== void 0 && sorters.length) {
      state.sorters = sorters.map(sorter => {
        const clone = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].cleanupProperties(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(sorter)); // Remove sorting fns

        delete clone.fn;
        delete clone.sortFn;
        return clone;
      });
    }

    if (groupers !== null && groupers !== void 0 && groupers.length) {
      state.groupers = groupers.slice();
    }

    if (filters !== null && filters !== void 0 && filters.values.length) {
      state.filters = filters.values.map(filter => {
        const clone = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].cleanupProperties(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(filter.config)); // Apply value, needed because of filterable fn reusing instance (so not in config)

        clone.value = filter.value; // Remove default value, no need to store that in state

        if (clone.caseSensitive) {
          delete clone.caseSensitive;
        } // Remove filtering fns
        // delete clone.filterBy; // Cannot remove it, required by export feature


        return clone;
      });
    }

    return state;
  }
  /**
   * Apply store state. Used by State-plugin to restore a previously serialized state
   * @private
   * @param {{ sorters, groupers }} state
   */


  applyState(state) {
    const me = this,
          {
      sorters = [],
      groupers = [],
      filters = []
    } = state;
    me.sorters = sorters.slice();
    me.groupers = groupers.slice();
    me.sort();
    me.filters = filters.filter(filter => filter.property || filter.filterBy);
    me.filter();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSum.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/StoreSum.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/data/mixin/StoreSum
 */

/**
 * Mixin for Store that handles summaries.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSum extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSum';
  }
  /**
   * Returns sum calculated by adding value of specified field for specified records. Defaults to using all records
   * in store
   * @param {String} field Field to summarize by
   * @param {Core.data.Model[]} records Records to summarize, uses all records if unspecified.
   * @returns {Number}
   * @category Sum
   */


  sum(field, records = this.storage.values) {
    if (!records) return 0;
    return records.reduce((sum, record) => {
      if (record.isSpecialRow) return sum;
      const v = Number(record[field]);
      return isNaN(v) ? sum : sum + v;
    }, 0);
  }
  /**
   * Returns min value for the specified field, can be used with Date or Number values. Defaults to look through all records in store
   * @param {String} field Field to find min value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number|Date}
   * @category Sum
   */


  min(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    return records.reduce((min, record) => {
      var _record$field;

      const type = typeof ((_record$field = record[field]) === null || _record$field === void 0 ? void 0 : _record$field.valueOf());
      if (type === 'number' && record[field] < min) min = record[field];
      return min;
    }, records[0][field]);
  }
  /**
   * Returns max value for the specified field, can be used with Date or Number values. Defaults to look through all records in store
   * @param {String} field Field to find max value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number|Date}
   * @category Sum
   */


  max(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    return records.reduce((max, record) => {
      var _record$field2;

      const type = typeof ((_record$field2 = record[field]) === null || _record$field2 === void 0 ? void 0 : _record$field2.valueOf());
      if (type === 'number' && record[field] > max) max = record[field];
      return max;
    }, records[0][field]);
  }
  /**
   * Returns the average value for the specified field. Defaults to look through all records in store
   * @param {String} field Field to calculate average value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number}
   * @category Sum
   */


  average(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    let count = 0;
    const sum = records.reduce((sum, record) => {
      if (record.isSpecialRow) return sum;
      const v = parseFloat(record[field]);

      if (!isNaN(v)) {
        count++;
        return sum + v;
      } else {
        return sum;
      }
    }, 0);
    return count > 0 ? sum / count : 0;
  }
  /**
   * Returns sum by adding value of specified field for records in the group with the specified groupValue.
   * @param {*} groupValue The group to summarize
   * @param {String} field Field to summarize by
   * @returns {Number} Sum or null if store not grouped
   * @category Sum
   */


  groupSum(groupValue, field) {
    return this.sum(field, this.getGroupRecords(groupValue));
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSync.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSync.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/WalkHelper.js */ "./lib/Core/helper/WalkHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/**
 * @module Core/data/mixin/StoreSync
 */

/**
 * Mixin that allows Store to sync a new dataset with its existing records, instead of fully replacing everything.
 * Configure Store with `syncDataOnLoad: true` to activate the functionality. Sync is performed when a new dataset
 * is loaded, either by directly assigning it to `store.data` or by loading it using Ajax (if using an AjaxStore).
 *
 * ```javascript
 * const store = new Store({
 *   syncDataOnLoad : true,
 *   data           : [
 *     { id : 1, name : 'Saitama' },
 *     { id : 2, name : 'Genos' },
 *     { id : 3, name : 'Mumen Rider' }
 *   ]
 * });
 *
 * // Sync a new dataset by assigning to data:
 * store.data = [
 *   { id : 1, name : 'Caped Baldy' },
 *   { id : 4, name : 'Horse-Bone' }
 * ];
 *
 *  // Result : Record 1 updated, record 2 & 3 removed, record 4 added
 * ```
 *
 * For more details, please see {@link #config-syncDataOnLoad}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSync extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSync';
  }

  static get defaultConfig() {
    return {
      /**
       * Configure with `true` to sync loaded data instead of replacing existing with a new dataset.
       *
       * By default (or when configured with `false`) assigning to `store.data` replaces the entire dataset
       * with a new one, creating all new records:
       *
       * ```javascript
       * store.data = [ { id : 1, name : 'Saitama' } ];
       *
       * const first = store.first;
       *
       * store.data = [ { id : 1, name : 'One-Punch man' } ];
       *
       * store.first !== first;
       * ```
       *
       * When configured with `true` the new dataset is instead synced against the old, figuring out what was
       * added, removed and updated:
       *
       * ```javascript
       * store.data = [ { id : 1, name : 'Saitama' } ];
       *
       * const first = store.first;
       *
       * store.data = [ { id : 1, name : 'One-Punch man' } ];
       *
       * store.first === first;
       * ```
       *
       * After the sync, any configured sorters, groupers and filters will be reapplied.
       *
       * The sync operation has a configurable threshold, above which the operation will be treated as a
       * batch/refresh and only trigger a single `refresh` event. If threshold is not reached, individual events
       * will be triggered (single `add`, `remove` and possible multiple `update`). To enable the threshold,
       * supply a config object with a `threshold` property instead of `true`:
       *
       * ```javascript
       * const store = new Store({
       *     syncDataOnLoad : {
       *         threshold : '20%'
       *     }
       * });
       * ```
       *
       * `threshold` accepts numbers or strings. A numeric threshold means number of affected records, while a
       * string is used as a percentage of the whole dataset (appending `%` is optional). By default no threshold
       * is used.
       *
       * @config {Boolean|Object}
       * @default false
       * @category Common
       */
      syncDataOnLoad: null
    };
  }
  /**
   * Syncs a new dataset against the already loaded one, only applying changes.
   * Not intended to be called directly, please configure store with `syncDataOnLoad: true` and assign to
   * `store.data` as usual instead.
   *
   * ```
   * const store = new Store({
   *    syncDataOnLoad : true,
   *    data : [
   *        // initial data
   *    ]
   * });
   *
   * store.data = [ // new data ]; //  Difference between initial data and new data will be applied
   * ```
   *
   * @param {Object[]|Core.data.Model[]} data New dataset, an array of records or data objects
   * @private
   */


  syncDataset(data) {
    const me = this,
          {
      storage
    } = me,
          {
      toAdd,
      toRemove,
      updated
    } = me.tree ? me.syncTreeDataset(data) : me.syncFlatDataset(data);
    let {
      threshold
    } = me.syncDataOnLoad,
        surpassed = false; // Check if threshold is surpassed

    if (threshold) {
      // Any string is treated as a percentage
      if (typeof threshold === 'string') {
        threshold = parseInt(threshold, 10) / 100 * me.count;
      }

      surpassed = toAdd.length + toRemove.length + updated.length > threshold;
    }

    if (me.tree) {
      // Flat data is spliced into/out of the collection, but in a tree it has to be added/removed from store
      // to end up on correct parents
      if (toAdd.length) {
        // Add all new nodes in one go, will be added to correct parent using `parentId`. Triggering multiple times
        const added = me.add(toAdd, surpassed); // parentId was tucked on in syncTreeDataset() to allow the single flat add above, clean it out

        added.forEach(node => node.clearParentId());
      } // Remove in one go, removing from each parent. Triggering multiple times


      me.remove(toRemove, surpassed);
    } else {
      if (surpassed) {
        me.suspendEvents();
      } // Add and remove, will trigger if below threshold/no threshold
      // We cannot simply splice into our Collection because of the extra
      // processing various Store mixins do in add and remove implementations


      me.remove(toRemove);
      me.add(toAdd);

      if (surpassed) {
        me.resumeEvents();
      }
    } // Trigger updates if using threshold, but have not surpassed it. If threshold is not used, the updates
    // are triggered when data is set (avoiding another iteration)


    if (threshold && !surpassed) {
      updated.forEach(({
        record,
        toSet,
        wasSet
      }) => me.onModelChange(record, toSet, wasSet));
    } // Clear change-tracking


    me.acceptChanges();
    const event = {
      added: toAdd,
      removed: toRemove,
      updated,
      thresholdSurpassed: surpassed
    }; // Trigger `batch` if threshold is surpassed, more similar to a batch than a full `dataset`

    if (surpassed) {
      this.trigger('refresh', {
        action: 'batch',
        data: data,
        records: storage.values,
        syncInfo: event
      });
    }

    if (me.isFiltered) {
      // Announced filter
      me.filter();
    }

    if (me.isGrouped) {
      // Announced sort
      me.group();
    } else if (me.isSorted) {
      // Announced sort
      me.sort();
    }

    me.trigger('loadSync', event);
  } // Used by syncDataset()


  syncFlatDataset(data) {
    if (!data) {
      return;
    }

    const me = this,
          idField = me.modelClass.idField,
          toRemove = [],
          toAdd = [],
          updated = [],
          usedIds = {};
    const {
      threshold
    } = me.syncDataOnLoad;
    let hitCount = 0;
    data.forEach(rawData => {
      rawData = rawData.isModel ? rawData.data : rawData;
      const id = rawData[idField],
            record = me.getById(id); // Record exists, might be an update

      if (record) {
        // Update silently if using threshold, otherwise trigger away
        const wasSet = record.set(rawData, null, Boolean(threshold));

        if (wasSet) {
          updated.push({
            record,
            wasSet,
            toSet: rawData
          });
        }

        hitCount++;
      } // Does not exist, add
      else {
        toAdd.push(me.processRecord(me.createRecord(rawData)));
      }

      usedIds[id] = 1;
    }); // Check removals, unless all records were visited above

    if (hitCount < me.allCount) {
      me.forEach(record => {
        if (!usedIds[record.id]) {
          toRemove.push(record);
        }
      });
    }

    return {
      toAdd,
      toRemove,
      updated
    };
  } // Used by syncDataset()


  syncTreeDataset(data) {
    if (!data) {
      return;
    }

    const me = this,
          {
      idField,
      parentIdField
    } = me.modelClass,
          toRemove = [],
          toAdd = [],
          updated = [],
          usedIds = {};

    if (me.transformFlatData) {
      data = me.treeifyFlatData(data);
    }

    const {
      threshold
    } = me.syncDataOnLoad;
    _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].preWalkWithParent({
      isRoot: true,
      children: data
    }, n => n.children, (parent, rawData) => {
      if (parent) {
        const id = rawData[idField],
              node = me.getById(id); // Record exists, might be an update

        if (node) {
          // Update silently if using threshold, otherwise trigger away
          const wasSet = node.set(rawData, null, Boolean(threshold));

          if (wasSet) {
            updated.push({
              record: node,
              wasSet,
              toSet: rawData
            });
          }
        } // Does not exist, add
        else {
          rawData[parentIdField] = parent[idField]; // clear children since they will be pushed separately with preWalkWithParent

          toAdd.push(_objectSpread(_objectSpread({}, rawData), {}, {
            children: []
          }));
        }

        usedIds[id] = 1;
      }
    });
    me.traverse(node => {
      if (!usedIds[node.id]) {
        toRemove.push(node);
      }
    });
    return {
      toAdd,
      toRemove,
      updated
    };
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreTree.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreTree.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/data/mixin/StoreTree
 */

const emptyArray = Object.freeze([]);
/**
 * Mixin for store with tree related functionality. To learn more about working with tree nodes please see the
 * {@link Core/data/mixin/TreeNode} class and [this guide](#Core/guides/data/treedata.md).
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreTree extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreTree';
  }

  static get configurable() {
    return {
      /**
       * Set to `true` to on load transform a flat dataset with raw objects containing `parentId` into the format
       * expected for tree data.
       *
       * Example input format:
       *
       * ```javascript
       * [
       *   { id : 1, name : 'Parent' },
       *   { id : 2, name : 'Child', parentId : 1 }
       * ]
       * ```
       *
       * Will be transformed into:
       *
       * ```javascript
       * [
       *   {
       *     id : 1,
       *     name : 'Parent',
       *     children : [
       *       { id : 2, name : 'Child', parentId : 1 }
       *     ]
       *   }
       * ]
       * ```
       *
       * @config {Boolean}
       * @category Tree
       */
      transformFlatData: null
    };
  } //region Getters

  /**
   * True if this Store is configured to handle tree data (with `tree : true`) or if this is a
   * {@link Core.data.Store#function-makeChained chained store} and the master store is a tree store.
   * @property {Boolean}
   * @readonly
   * @category Tree
   */


  get isTree() {
    return this.tree || this.masterStore && this.masterStore.tree;
  }
  /**
   * Returns all leaf records in a tree store
   * @property {Core.data.Model[]}
   * @category Tree
   */


  get leaves() {
    const me = this,
          result = [];

    if (me.isTree) {
      me.traverse(record => {
        if (record.isLeaf) {
          result.push(record);
        }
      });
      return result;
    } else {
      me.allRecords.forEach(r => {
        if (r.isLeaf) {
          result.push(r);
        }

        r.traverse(record => {
          if (record.isLeaf) {
            result.push(record);
          }
        }, true);
      });
    }

    return result;
  } //endregion
  //region Children

  /**
   * Loads children for a parent node that uses load on demand (when expanding it). Base implementation does nothing,
   * either use AjaxStore which implements it, create your own subclass with an implementation or listen for
   * `toggleNode` and insert records when you have them available.
   * @param {Core.data.Model} parentRecord
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * @category Tree
   */


  async loadChildren(parentRecord) {}
  /**
   * Called from Model when adding children. Not to be called directly, use Model#appendChild() instead.
   * @internal
   * @param {Core.data.mixin.TreeNode} parent
   * @param {Core.data.mixin.TreeNode[]} children
   * @param {Number} index
   * @param {Object} isMove
   * @param {Boolean} [silent]
   * @fires add
   * @fires change
   * @category Tree
   */


  onNodeAddChild(parent, children, index, isMove, silent = false) {
    const me = this,
          isRootLoad = parent === me.rootNode && parent.isLoading,
          {
      storage
    } = me,
          toAddToUI = [],
          toAdd = [],
          previousSibling = children[0].previousSibling;
    let storeInsertionPoint;
    me.collectDescendants(children, toAddToUI, toAdd, {
      inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me))
    }); // Keep CRUD caches up to date unless it's a root load

    if (!isRootLoad && toAdd.length) {
      for (const record of toAdd) {
        // Only considered an add if not modified or moved
        if (!me.modified.includes(record) && !isMove[record.id]) {
          // If was removed, remove from `removed` list
          if (me.removed.includes(record)) {
            me.removed.remove(record);
          } // Else add to `added` list
          else {
            me.added.add(record);
          }
        }
      }
    } // Root node inserted first


    if (isRootLoad && me.rootVisible) {
      toAddToUI.unshift(parent);
      toAdd.unshift(parent);
    }

    if (toAddToUI.length) {
      // Calculate the insertion point into the flat store.
      // If the new node is the first, then it goes after the parent node.
      if (index === 0 || !previousSibling) {
        storeInsertionPoint = storage.indexOf(parent);
      } // Otherwise it has to go after the previous visible node which has
      // to be calculated. See indexOfPreviousVisibleNode for explanation.
      else {
        storeInsertionPoint = storage.indexOf(previousSibling) + previousSibling.getDescendantCount(true, me);
      } // Insert added child nodes at correct location in storage.
      // We must not react to change - we fire the events here.


      storage.suspendEvents();
      me.storage.splice(++storeInsertionPoint, 0, toAddToUI);
      storage.resumeEvents();
    } // Since we do not pass through Store#onDataChange we have to handle relations manually here. And since they are
    // not tied to flat part of store, use all children


    me.updateDependentStores('add', children); // If it's a root level set data op, then signal 'dataset'

    if (isRootLoad && toAddToUI.length) {
      var _me$afterLoadData;

      // If we have initial sorters, perform a silent sort before triggering `dataset`
      // NOTE: Records in toAddToUI will be in the original order, not affected by the sort
      if (me.sorters.length) {
        me.sort(null, null, false, true);
      }

      (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);

      if (!silent) {
        const event = {
          action: 'dataset',
          data: me._data,
          records: toAddToUI
        };
        me.trigger('refresh', event);
        me.trigger('change', event);
      }
    } // Else, continue as before to signal an "isChild" add.
    else if (!silent) {
      const event = {
        action: 'add',
        parent,
        isChild: true,
        isMove,
        records: children,
        allRecords: toAdd,
        index: storeInsertionPoint
      };
      me.trigger('add', event);
      me.trigger('change', event); // Check if any add is actually a move

      if (Object.values(isMove).some(wasMoved => wasMoved)) {
        const event = {
          newParent: parent,
          records: children.filter(record => isMove[record.id])
        };
        me.trigger('move', event);
      }
    }
  }

  onNodeRemoveChild(parent, children, index, flags = {
    isMove: false,
    silent: false,
    unfiltered: false
  }) {
    const me = this,
          {
      storage
    } = me,
          toRemoveFromUI = [],
          toRemove = [],
          {
      isMove,
      silent,
      unfiltered
    } = flags,
          removeUnfiltered = unfiltered && me.isFiltered,
          childrenToRemove = removeUnfiltered && parent.unfilteredChildren ? parent.unfilteredChildren : children;
    me.collectDescendants(childrenToRemove, toRemoveFromUI, toRemove, {
      inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me)),
      unfiltered: removeUnfiltered
    }); // test StoreTree.t.js should fail if the next line replaces the above line
    // me.collectDescendants(children, toRemoveFromUI, toRemove, { inCollapsedBranch : !(parent.isExpanded(me) && parent.ancestorsExpanded(me)) });

    if (!isMove) {
      // Unjoin is recursive, use flat children array
      for (const record of children) {
        record.unjoinStore(me);
      } // Keep CRUD caches up to date


      if (toRemove.length) {
        for (const record of toRemove) {
          if (record.stores.includes(me)) {
            record.unjoinStore(me);
          } // If was newly added, remove from `added` list


          if (me.added.includes(record)) {
            me.added.remove(record);
          } // Else add to `removed` list
          else {
            me.removed.add(record);
          }
        }

        me.modified.remove(toRemove);
      }
    } // Remove removed child nodes at correct location in storage


    if (toRemoveFromUI.length) {
      index = storage.indexOf(toRemoveFromUI[0]); // We must not react to change - we fire the events here.

      if (index > -1) {
        storage.suspendEvents();
        storage.splice(index, toRemoveFromUI.length);
        storage.resumeEvents();
      }
    } else {
      // If nothing is removed from UI (storage) return -1, showing that removed node was in a collapsed branch
      index = -1;
    }

    if (!silent) {
      const event = {
        action: 'remove',
        parent,
        isChild: true,
        isMove,
        records: children,
        allRecords: toRemove,
        index
      };
      me.trigger('remove', event);
      me.trigger('change', event);
    }
  }

  collectDescendants(node, visible = [], all = [], flags = {
    inCollapsedBranch: false,
    unfiltered: false
  }) {
    const me = this,
          {
      inCollapsedBranch,
      unfiltered
    } = flags,
          children = Array.isArray(node) ? node : me.getChildren(node, unfiltered);

    if (children) {
      for (let i = 0, len = children.length, child; i < len; i++) {
        child = children[i];

        if (!inCollapsedBranch) {
          visible.push(child);
        }

        all.push(child);
        me.collectDescendants(child, visible, all, {
          inCollapsedBranch: inCollapsedBranch || !child.isExpanded(me),
          unfiltered
        });
      }
    }

    return {
      visible,
      all
    };
  }
  /**
   * Returns the children of the passed branch node which this store owns. By default, this
   * is the entire `children` array.
   *
   * **If this store {@link Core.data.mixin.StoreChained#property-isChained isChained}**, then
   * this returns only the subset of children which are filtered into this store by the
   * {@link Core.data.mixin.StoreChained#config-chainedFilterFn chainedFilterFn}.
   * @param {Core.data.Model} parent The node to return the children of.
   * @returns {Core.data.Model[]}
   * @category Tree
   */


  getChildren(parent, unfiltered = false) {
    // In case of chained store we need to apply chainedFilterFn to all records
    const children = (unfiltered || this.isChained) && parent.unfilteredChildren || parent.children;
    return children && children.length ? this.isChained ? children.filter(this.chainedFilterFn) : children : emptyArray;
  }
  /**
   * Includes or excludes all records beneath parentRecord in storage. Used when expanding or collapsing
   * nodes.
   * @private
   * @param parentRecord Parent record
   * @param include Include (true) or exclude (false)
   * @category Tree
   */


  internalToggleTreeSubRecords(parentRecord, include) {
    const me = this,
          {
      storage
    } = me,
          index = storage.indexOf(parentRecord),
          children = me.doIncludeExclude(me.getChildren(parentRecord), include); // When expanded a parent node while being filtered, need to update the hidden flag of its children

    if (me.isFiltered && include && parentRecord.unfilteredChildren) {
      me.updateChildrenHiddenState(parentRecord);
    } // If we expanded a node which is yet to load children, the collected children
    // array will be empty, so do not broadcast any change event.
    // If we are collapsing a record which isn't visible (because parent is collapsed) we won't get an index,
    // which is fine since it is already removed from processedRecords


    if (children.length && index !== false) {
      // We must not react to change - we fire the events here with a flag
      // to tell responders that it's due to an expand or collapse.
      storage.suspendEvents();

      if (include) {
        storage.splice(index + 1, 0, ...children);
        const event = {
          action: 'add',
          isExpand: true,
          records: children,
          index: index + 1
        };
        me.trigger('add', event);
        me.trigger('change', event);
      } else {
        storage.splice(index + 1, children.length);
        const event = {
          action: 'remove',
          isCollapse: true,
          records: children,
          index: index + 1
        };
        me.trigger('remove', event);
        me.trigger('change', event);
      }

      storage.resumeEvents();
    }
  } // Updates the hidden flag of its children while store is filtered


  updateChildrenHiddenState(parentRecord) {
    var _parentRecord$unfilte;

    (_parentRecord$unfilte = parentRecord.unfilteredChildren) === null || _parentRecord$unfilte === void 0 ? void 0 : _parentRecord$unfilte.forEach(child => {
      child.instanceMeta(this.id).hidden = false;

      if (!child.isLeaf) {
        this.updateChildrenHiddenState(child);
      }
    });
  }

  doIncludeExclude(children, include, result = []) {
    const me = this,
          childCount = (children === null || children === void 0 ? void 0 : children.length) || 0;

    for (let i = 0; i < childCount; i++) {
      const child = children[i]; // Only consider child nodes who we own.
      // If we are a chained store, skip nodes that are not ours.

      if (!me.isChained || me.chainedFilterFn(child)) {
        const mapMeta = child.instanceMeta(me.id);

        if (include || !mapMeta.hidden) {
          // if including sub-records, add those who are not hidden by a collapsed sub parent
          result.push(child);
        }

        mapMeta.hidden = !include;

        if (child.isExpanded(me)) {
          me.doIncludeExclude(me.getChildren(child), include, result);
        }
      }
    }

    return result;
  }
  /**
   * Collapse an expanded record or expand a collapsed. Optionally forcing a certain state.
   * @param {String|Number|Core.data.Model} idOrRecord Record (the record itself) or id of a record to toggle
   * @param {Boolean} [collapse] Force collapse (true) or expand (false)
   * @returns {Promise}
   * @async
   * @category Tree
   */


  async toggleCollapse(idOrRecord, collapse) {
    const me = this,
          record = me.getById(idOrRecord),
          meta = record.instanceMeta(me);

    if (collapse === undefined) {
      collapse = !meta.collapsed;
    } // Reject if we're in the middle of loading children, or it's a leaf, or it's a no-op


    if (!meta.isLoadingChildren && !record.isLeaf && record.isExpanded(me) === collapse) {
      me.trigger('beforeToggleNode', {
        record,
        collapse
      });
      meta.collapsed = collapse;

      if (meta.collapsed) {
        me.onNodeCollapse(record);
        return true;
      } else {
        me.onNodeExpand(record);
        let success = true; // Children not yet loaded, ask store for them.
        // It will append them. Appending to a node which
        // is expanded will insert the children into the UI.

        if (!record.isLoaded) {
          meta.isLoadingChildren = true;

          try {
            await me.loadChildren(record);
          } catch (exception) {
            // Revert to being collapsed
            meta.collapsed = true;
            success = false;
            me.trigger('loadChildrenException', {
              record,
              exception
            });
          } finally {
            meta.isLoadingChildren = false;
          }
        }

        return success;
      }
    }
  }
  /**
   * Remove all records beneath parentRecord from storage.
   * @private
   * @param parentRecord Parent record
   * @category Tree
   */


  onNodeCollapse(parentRecord) {
    // We don't care about collapse if it's inside a collapsed subtree
    if (parentRecord.ancestorsExpanded(this)) {
      return this.internalToggleTreeSubRecords(parentRecord, false);
    }
  }
  /**
   * Add all records beneath parentRecord from storage.
   * @private
   * @param parentRecord Parent record
   * @category Tree
   */


  onNodeExpand(parentRecord) {
    // We don't care about expand if it's inside a collapsed subtree
    if (parentRecord.ancestorsExpanded(this)) {
      return this.internalToggleTreeSubRecords(parentRecord, true);
    }
  } //endregion
  //region Transform flat data

  /**
   * Transforms flat data containing parent ids into tree data
   * @param {Object[]} data Flat raw data
   * @returns {Object[]} Tree data
   * @private
   */


  transformToTree(data) {
    const {
      parentIdField,
      idField,
      childrenField
    } = this.modelClass,
          parents = new Map(),
          transformed = [];

    for (const node of data) {
      const parentId = node[parentIdField]; // Child, find parent

      if (parentId != null) {
        // Detected parents are kept in a map to no have to iterate to find them each time
        let parent = parents.get(parentId); // Parent not in map, find it and add it (also adds unmatched parents, to not search for
        // them again)

        if (parent === undefined) {
          var _data$find;

          parent = (_data$find = data.find(node => node[idField] === parentId)) !== null && _data$find !== void 0 ? _data$find : null;
          parents.set(parentId, parent);
        } // Parent found, add node as child of it


        if (parent) {
          if (!parent[childrenField]) {
            parent[childrenField] = [];
          }

          parent[childrenField].push(node);
        }
      } // Parent, keep
      else {
        transformed.push(node);
      }
    }

    return transformed;
  } //endregion


  treeifyFlatData(data) {
    const {
      childrenField,
      parentIdField
    } = this.modelClass;
    let hasParentId = false,
        shouldTransform = true; // Configured to transform flat data into tree data, make sure that we have:
    // - raw data without children defined
    // - parentIds

    for (const node of data) {
      if (node.isModel || node[childrenField]) {
        shouldTransform = false;
        break;
      }

      if (node[parentIdField] != null) {
        hasParentId = true;
      }
    }

    if (shouldTransform && hasParentId) {
      data = this.transformToTree(data);
    }

    return data;
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/TreeNode.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/TreeNode.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/data/mixin/TreeNode
 */

/**
 * Mixin for Model with tree node related functionality. This class is mixed into the {@link Core/data/Model} class.
 *
 * ## Adding and removing child nodes
 *
 * ```javascript
 * const parent = store.getById(1),
 *
 * firstBorn = parent.insertChild({
 *     name : 'Child node'
 * }, parent.children[0]); // Insert a child at a specific place in the children array
 *
 * parent.removeChild(parent.children[0]); // Removes a child node
 * parent.appendChild({ name : 'New child node' }); // Appends a child node
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TreeNode extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TreeNode';
  }
  /**
   * This static configuration option allows you to control whether an empty parent task should be converted into a
   * leaf. Enable/disable it for a whole class:
   *
   * ```javascript
   * Model.convertEmptyParentToLeaf = false;
   * ```
   *
   * By specifying `true`, all empty parents will be considered leafs. Can also be assigned a configuration object
   * with with the following Boolean properties to customize the behaviour:
   *
   * * `onLoad` - Apply the transformation on load to any parents without children (`children : []`)
   * * `onRemove` - Apply the transformation when all children have been removed from a parent
   *
   * ```javascript
   * Model.convertEmptyParentToLeaf = {
   *     onLoad   : false,
   *     onRemove : true
   * }
   * ```
   *
   * @property {Boolean|Object}
   * @default false
   * @category Parent & children
   */


  static set convertEmptyParentToLeaf(value) {
    if (value === true) {
      value = {
        onLoad: true,
        onRemove: true
      };
    } else if (value === false) {
      value = {
        onLoad: false,
        onRemove: false
      };
    }

    this._convertEmptyParentToLeaf = value;
  }

  static get convertEmptyParentToLeaf() {
    return this._convertEmptyParentToLeaf || {
      onLoad: false,
      onRemove: false
    };
  }
  /**
   * This is a read-only property providing access to the parent node.
   * @member {Core.data.Model} parent
   * @readonly
   * @category Parent & children
   */

  /**
   * This is a read-only field provided in server synchronization packets to specify
   * which record id is the parent of the record.
   * @readonly
   * @field {String|Number|null} parentId
   * @category Tree
   */

  /**
   * This is a read-only field provided in server synchronization packets to specify
   * which position the node takes in the parent's children array.
   * This index is set on load and gets updated automatically after row reordering, sorting, etc.
   * To save the order, need to persist the field on the server and when data is fetched to be loaded,
   * need to sort by this field.
   * @readonly
   * @field {Number} parentIndex
   * @category Tree
   */


  ingestChildren(childRecord, stores = this.stores) {
    const {
      inProcessChildren,
      constructor: MyClass
    } = this,
          store = stores[0];

    if (childRecord === true) {
      if (inProcessChildren) {
        return true;
      }

      return [];
    }

    if (childRecord) {
      if (!Array.isArray(childRecord)) {
        childRecord = [childRecord];
      }

      const len = childRecord.length,
            result = [];

      for (let i = 0, child; i < len; i++) {
        child = childRecord[i];
        child = child.isModel ? child : store ? store.createRecord(child) : new MyClass(child, null, null, true);
        child = store ? store.processRecord(child) : child;
        result.push(child);
      }

      if (this.children === true && store) {
        const sorter = store.createSorterFn(store.sorters);
        result.sort(sorter);
      }

      return result;
    }
  }
  /**
   * Child nodes. To allow loading children on demand, specify `children : true` in your data. Omit the field for leaf tasks.
   *
   * Note, if the tree store loads data from a remote origin, make sure {@link Core/data/AjaxStore#config-readUrl}
   * is specified, and optionally {@link Core/data/AjaxStore#config-parentIdParamName} is set, otherwise
   * {@link Core/data/Store#function-loadChildren} has to be implemented.
   *
   * @field {Boolean|Object[]|Core.data.Model[]} children
   * @category Parent & children
   */

  /**
   * Called during creation to also turn any children into Models joined to the same stores as this model
   * @internal
   * @category Parent & children
   */


  processChildren(stores = this.stores) {
    const me = this,
          {
      meta
    } = me;
    me.inProcessChildren = true;
    const children = me.ingestChildren(me.data[me.constructor.childrenField], stores);

    if (children) {
      const {
        convertEmptyParentToLeaf
      } = me.constructor,
            shouldConvert = convertEmptyParentToLeaf === true || convertEmptyParentToLeaf.onLoad;

      if (shouldConvert ? children.length : Array.isArray(children)) {
        meta.isLeaf = false; // We are processing a remote load

        if (me.children === true) {
          me.children = [];
        } else if (children.length === 0) {
          me.children = children;
          return;
        }

        me.appendChild(children, false, true);
      } // Flagged for load on demand
      else if (children === true) {
        meta.isLeaf = false;
        me.children = true;
      } // Empty child array, flag is leaf if configured to do so
      else if (!me.isRoot) {
        meta.isLeaf = me.constructor.convertEmptyParentToLeaf.onLoad;
      }
    }

    me.inProcessChildren = false;
  }
  /**
   * This method returns `true` if this record has all expanded ancestors and is therefore
   * eligible for inclusion in a UI.
   * @param {Core.data.Store} [store] Optional store, defaults to nodes first store
   * @returns {Boolean}
   * @readonly
   * @category Parent & children
   * @returns {Boolean}
   */


  ancestorsExpanded(store = this.firstStore) {
    const {
      parent
    } = this;
    return !parent || parent.isExpanded(store) && parent.ancestorsExpanded(store);
  }
  /**
   * Used by stores to assess the record's collapsed/expanded state in that store.
   * @param {Core.data.Store} store
   * @category Parent & children
   * @returns {Boolean}
   */


  isExpanded(store = this.firstStore) {
    const mapMeta = this.instanceMeta(store.id); // Default initial expanded/collapsed state when in the store
    // to the record's original expanded property.

    if (!Object.prototype.hasOwnProperty.call(mapMeta, 'collapsed')) {
      mapMeta.collapsed = !this.expanded;
    }

    return !mapMeta.collapsed;
  } // A read-only property. It provides the initial state upon load
  // The UI's expanded/collapsed state is in the store's meta map.


  get expanded() {
    return this.data.expanded;
  }
  /**
   * Depth in the tree at which this node exists. First visual level of nodes are at level 0, their direct children at
   * level 1 and so on.
   * @property {Number}
   * @readonly
   * @category Parent & children
   */


  get childLevel() {
    let node = this,
        ret = -1;

    while (node && !node.isRoot) {
      ++ret;
      node = node.parent;
    }

    return ret;
  }
  /**
   * Is a leaf node in a tree structure?
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isLeaf() {
    return this.meta.isLeaf !== false && !this.isRoot;
  }
  /**
   * Is a parent node in a tree structure?
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isParent() {
    return !this.isLeaf;
  }
  /**
   * Returns true for parent nodes with children loaded (there might still be no children)
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isLoaded() {
    return this.isParent && Array.isArray(this.children);
  }
  /**
   * Count all children (including sub-children) for a node (in its `firstStore´)
   * @member {Number}
   * @category Parent & children
   */


  get descendantCount() {
    return this.getDescendantCount();
  }
  /**
   * Count visible (expanded) children (including sub-children) for a node (in its `firstStore`)
   * @member {Number}
   * @category Parent & children
   */


  get visibleDescendantCount() {
    return this.getDescendantCount(true);
  }
  /**
   * Count visible (expanded)/all children for this node, optionally specifying for which store.
   * @param {Boolean} [onlyVisible] Specify `true` to only count visible (expanded) children.
   * @param {Core.data.Store} [store] A Store to which this node belongs
   * @returns {Number}
   * @category Parent & children
   */


  getDescendantCount(onlyVisible = false, store = this.firstStore) {
    const children = this.children;

    if (!children || !Array.isArray(children) || onlyVisible && !this.isExpanded(store)) {
      return 0;
    }

    return children.reduce((count, child) => count + child.getDescendantCount(onlyVisible), children.length);
  }
  /**
   * Retrieve all children (by traversing sub nodes)
   * @property {Core.data.Model[]}
   * @category Parent & children
   */


  get allChildren() {
    const children = this.children;
    if (!children) return [];
    return children.reduce((all, child) => {
      all.push(child); // push.apply is faster than push with array spread:
      // https://jsperf.com/push-apply-vs-push-with-array-spread/1

      all.push.apply(all, child.allChildren);
      return all;
    }, []);
  }
  /**
   * Get the first child of this node
   * @property {Core.data.Model}
   * @readonly
   * @category Parent & children
   */


  get firstChild() {
    const children = this.children;
    return (children === null || children === void 0 ? void 0 : children.length) && children[0] || null;
  }
  /**
   * Get the last child of this node
   * @property {Core.data.Model}
   * @readonly
   * @category Parent & children
   */


  get lastChild() {
    const children = this.children;
    return (children === null || children === void 0 ? void 0 : children.length) && children[children.length - 1] || null;
  }
  /**
   * Returns count of all preceding sibling nodes (including their children).
   * @property {Number}
   * @category Parent & children
   */


  get previousSiblingsTotalCount() {
    let task = this.previousSibling,
        count = this.parentIndex;

    while (task) {
      count += task.descendantCount;
      task = task.previousSibling;
    }

    return count;
  }

  get root() {
    var _this$parent;

    return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.root) || this;
  }
  /**
   * Reading this property returns the id of the parent node, if this record is a child of a node.
   *
   * Setting this property appends this record to the record with the passed
   * id **in the same store that this record is already in**.
   *
   * Note that setting this property is **only valid if this record is already
   * part of a tree store**.
   *
   * This is not intended for general use. This is for when a server responds to a record
   * mutation and the server decides to move a record to a new parent. If a `parentId` property
   * is passed in the response data for a record, that record will be moved.
   * @property {Number|String|null}
   * @category Parent & children
   */


  get parentId() {
    return this.parent && !this.parent.isAutoRoot ? this.parent.id : null;
  }

  set parentId(parentId) {
    const me = this,
          {
      parent
    } = me,
          newParent = parentId && me.firstStore.getById(parentId); // Handle exact equality of parent.
    // Also handle one being null and the other being undefined meaning no change.

    if (!(newParent === parent || !parent && !newParent)) {
      // If we are batching, we do not trigger a change immediately.
      // endBatch will set the field which will set the property again.
      if (me.isBatchUpdating) {
        me.meta.batchChanges.parentId = parentId;
      } else {
        if (newParent) {
          newParent.appendChild(me);
        } else {
          me.parent.removeChild(me);
        }
      }
    }
  }

  static set parentIdField(parentIdField) {
    // Maintainer: the "this" references in here reference two different contexts.
    // Outside of the property definition, it's the Model Class.
    // In the getter and setter, it's the record instance.
    this._parentIdField = parentIdField;
    Object.defineProperty(this.prototype, parentIdField, {
      set: function (parentId) {
        // no arrow functions here, need `this` to change to instance
        // noinspection JSPotentiallyInvalidUsageOfClassThis
        this.parentId = parentId;
      },
      get: function () {
        // no arrow functions here, need `this` to change to instance
        // noinspection JSPotentiallyInvalidUsageOfClassThis
        return this.parentId;
      }
    });
  }

  static get parentIdField() {
    return this._parentIdField || 'parentId';
  }
  /**
   * Traverses all child nodes recursively calling the passed function
   * on a target node **before** iterating the child nodes.
   * @param {Function} fn The function to call
   * @param {Boolean} [skipSelf=false] True to ignore self
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   */


  traverse(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const children = (includeFilteredOutRecords ? this.unfilteredChildren : this.children) || this.children;

    if (!skipSelf) {
      fn.call(this, this);
    } // Simply testing whether there is non-zero children length
    // is 10x faster than using this.isLoaded


    for (let i = 0, l = children === null || children === void 0 ? void 0 : children.length; i < l; i++) {
      children[i].traverse(fn, false, includeFilteredOutRecords);
    }
  }
  /**
   * Traverses all child nodes recursively calling the passed function
   * on child nodes of a target **before** calling it it on the node.
   * @param {Function} fn
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   */


  traverseBefore(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const children = (includeFilteredOutRecords ? this.unfilteredChildren : this.children) || this.children; // Simply testing whether there is non-zero children length
    // is 10x faster than using this.isLoaded

    for (let i = 0, l = children === null || children === void 0 ? void 0 : children.length; i < l; i++) {
      children[i].traverse(fn, false, includeFilteredOutRecords);
    }

    if (!skipSelf) {
      fn.call(this, this);
    }
  }
  /**
   * Traverses child nodes recursively while fn returns true
   * @param {Function} fn
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   * @returns {Boolean}
   */


  traverseWhile(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const me = this;
    let goOn = true;

    if (!skipSelf) {
      goOn = fn.call(me, me) !== false;
    }

    if (goOn && me.isLoaded) {
      const children = (includeFilteredOutRecords ? me.unfilteredChildren : me.children) || this.children;
      goOn = children.every(child => child.traverseWhile(fn, false, includeFilteredOutRecords));
    }

    return goOn;
  }
  /**
   * Bubbles up from this node, calling the specified function with each node.
   *
   * @param {Function} fn The function to call for each node
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @category Parent & children
   */


  bubble(fn, skipSelf = false) {
    let me = this;

    if (!skipSelf) {
      fn.call(me, me);
    }

    while (me.parent) {
      me = me.parent;
      fn.call(me, me);
    }
  }
  /**
   * Bubbles up from this node, calling the specified function with each node,
   * while the function returns true.
   *
   * @param {Function} fn The function to call for each node
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @category Parent & children
   * @return {Boolean}
   */


  bubbleWhile(fn, skipSelf = false) {
    let me = this,
        goOn = true;

    if (!skipSelf) {
      goOn = fn.call(me, me);
    }

    while (goOn && me.parent) {
      me = me.parent;
      goOn = fn.call(me, me);
    }

    return goOn;
  }
  /**
   * Checks if this model contain another model as one of it's descendants
   *
   * @param {Core.data.Model|String|Number} childOrId child node or id
   * @category Parent & children
   * @returns {Boolean}
   */


  contains(childOrId) {
    if (childOrId && typeof childOrId === 'object') {
      childOrId = childOrId.id;
    }

    return !this.traverseWhile(node => node.id != childOrId);
  }

  getTopParent(all) {
    let result;

    if (all) {
      result = [];
      this.bubbleWhile(t => {
        result.push(t);
        return t.parent && !t.parent.isRoot;
      });
    } else {
      result = null;
      this.bubbleWhile(t => {
        if (!t.parent) {
          result = t;
        }

        return t.parent && !t.parent.isRoot;
      });
    }

    return result;
  }
  /**
   * Append a child record(s) to any current children.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} childRecord Array of records/data or a single
   * record/data to append
   * @param {Boolean} [silent] Pass `true` to not trigger events during append
   * @returns {Core.data.Model|Core.data.Model[]|null}
   * @category Parent & children
   */


  appendChild(childRecord, silent = false) {
    return this.insertChild(childRecord, null, silent);
  }
  /**
   * Insert a child record(s) before an existing child record.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} childRecord Array of records/data or a single
   * record/data to insert
   * @param {Core.data.Model} [before] Optional record to insert before, leave out to append to the end
   * @param {Boolean} [silent] Pass `true` to not trigger events during append
   * @returns {Core.data.Model|Core.data.Model[]|null}
   * @category Parent & children
   */


  insertChild(childRecord, before = null, silent = false) {
    var _ref, _before$parentIndex, _before, _me$children, _me$beforeInsertChild, _me$afterInsertChild;

    // Handle deprecated signature
    if (typeof childRecord === 'number') {
      const index = childRecord;
      childRecord = before;
      before = this.children[index];
    }

    const me = this,
          wasLeaf = me.isLeaf,
          returnArray = Array.isArray(childRecord);
    if (!Array.isArray(childRecord)) childRecord = [childRecord];

    if (!silent) {
      if (!me.stores.every(s => s.trigger('beforeAdd', {
        records: childRecord,
        parent: me
      }) !== false)) {
        return null;
      }
    } // This call makes child record an array containing Models


    childRecord = me.ingestChildren(childRecord); // NOTE: see comment in Model::set() about before/in/after calls approach.

    const index = (_ref = (_before$parentIndex = (_before = before) === null || _before === void 0 ? void 0 : _before.parentIndex) !== null && _before$parentIndex !== void 0 ? _before$parentIndex : (_me$children = me.children) === null || _me$children === void 0 ? void 0 : _me$children.length) !== null && _ref !== void 0 ? _ref : 0,
          preResult = (_me$beforeInsertChild = me.beforeInsertChild) === null || _me$beforeInsertChild === void 0 ? void 0 : _me$beforeInsertChild.call(me, childRecord),
          inserted = me.internalAppendInsert(childRecord, before, silent); // Turn into a parent if not already one

    if (wasLeaf && inserted.length) {
      me.meta.isLeaf = false;
    } // If we've transitioned to being a branch node, signal a change event
    // so that the UI updates.
    // Not if it's due to root node loading. StoreTree#onNodeAddChild
    // for the rootNode will fire a store refresh.


    if (me.isLeaf !== wasLeaf && !me.root.isLoading && !silent) {
      me.stores.forEach(s => {
        const changes = {
          isLeaf: {
            value: false,
            oldValue: true
          }
        };
        s.trigger('update', {
          record: me,
          changes
        });
        s.trigger('change', {
          action: 'update',
          record: me,
          changes
        });
      });
    }

    (_me$afterInsertChild = me.afterInsertChild) === null || _me$afterInsertChild === void 0 ? void 0 : _me$afterInsertChild.call(me, index, childRecord, preResult, inserted);
    return returnArray || !inserted ? inserted : inserted[0];
  }

  tryInsertChild() {
    return this.insertChild(...arguments);
  }

  internalAppendInsert(recordsToInsert, beforeRecord, silent) {
    const me = this,
          {
      stores,
      root
    } = me,
          {
      firstStore: rootStore
    } = root,
          {
      parentIdField
    } = me.constructor,
          parentId = me.isAutoRoot ? null : me.id,
          isMove = {};
    let isNoop, start, i, newRecordsCloned; // The reference node must be one of our children. If not, fall back to an append.

    if (beforeRecord && beforeRecord.parent !== me) {
      beforeRecord = null;
    } // If the records starting at insertAt or (insertAt - 1), are the same sequence
    // that we are being asked to add, this is a no-op.


    if (me.children) {
      const children = me.children,
            insertAt = beforeRecord ? beforeRecord.parentIndex : children.length;

      if (children[start = insertAt] === recordsToInsert[0] || children[start = insertAt - 1] === recordsToInsert[0]) {
        for (isNoop = true, i = 0; isNoop && i < recordsToInsert.length; i++) {
          if (recordsToInsert[i] !== children[start + i]) {
            isNoop = false;
          }
        }
      }
    } // Fulfill the contract of appendChild/insertChild even if we did not have to do anything.
    // Callers must be able to correctly postprocess the returned value as an array.


    if (isNoop) {
      return recordsToInsert;
    } // Remove incoming child nodes from any current parent.


    for (i = 0; i < recordsToInsert.length; i++) {
      const newRecord = recordsToInsert[i],
            oldParent = newRecord.parent; // Store added should not be modified for adds
      // caused by moving.

      isMove[newRecord.id] = newRecord.root === root; // Check if any descendants of the added node are moves.

      if (rootStore && !root.isLoading) {
        newRecord.traverse(r => {
          if (r.root === root) {
            isMove[r.id] = true;
          }
        });
      } // If the new record has a parent, remove from that parent.
      // This operation may be vetoed by listeners.
      // If it is vetoed, then remove from the newRecords and do not
      // set the parent property


      if ((oldParent === null || oldParent === void 0 ? void 0 : oldParent.removeChild(newRecord, isMove[newRecord.id], silent)) === false) {
        if (!newRecordsCloned) {
          recordsToInsert = recordsToInsert.slice();
          newRecordsCloned = true;
        }

        recordsToInsert.splice(i--, 1);
      } else {
        newRecord.parent = me; // Set parentId directly to data, record.parentId uses a getter to return record.parent.id

        newRecord.data[parentIdField] = parentId;

        if (oldParent) {
          newRecord.meta.oldParentId = oldParent.id;
        }
      }
    } // Still records to insert after beforeRemove listeners may have vetoed some


    if (recordsToInsert.length) {
      if (!Array.isArray(me.children)) {
        me.children = [];
      } // Add to the children


      const insertAt = me.addToChildren(me.children, beforeRecord, recordsToInsert); // When filter is used add to the unfiltered children

      me.addToChildren(me.unfilteredChildren, beforeRecord, recordsToInsert, true);
      stores.forEach(store => {
        if (!store.isChained) {
          recordsToInsert.forEach(record => {
            // Initialize context for newly added records
            record.joinStore(store);
          }); // Add to store (will also add any child records and trigger events)

          store.onNodeAddChild(me, recordsToInsert, insertAt, isMove, silent);
          recordsToInsert.forEach(record => {
            // If we are in the recursive inclusion of children at construction
            // time, or in a store load, that must not be a data modification.
            // Otherwise, we have to signal a change
            if (record.meta.oldParentId != null && !(me.inProcessChildren || me.isLoading)) {
              const toSet = {
                [parentIdField]: parentId,
                [me.getDataSource('parentIndex')]: record.parentIndex
              },
                    wasSet = {},
                    {
                modified,
                oldParentId
              } = record.meta,
                    oldParentIndex = modified.parentIndex;
              delete record.meta.oldParentId;

              if (me.id !== oldParentId) {
                wasSet[parentIdField] = {
                  value: parentId,
                  oldValue: oldParentId
                };
              }

              if (record.parentIndex !== oldParentIndex) {
                wasSet.parentIndex = {
                  value: record.parentIndex,
                  oldValue: oldParentIndex
                };
              } // Changing back to its original value


              if (modified[parentIdField] === me.id) {
                Reflect.deleteProperty(modified, parentIdField);
              } // Cache its original value
              else if (!(parentIdField in modified)) {
                modified[parentIdField] = oldParentId;
              }

              record.afterChange(toSet, wasSet);
            }
          });
        }
      });
    }

    return recordsToInsert;
  }
  /**
   * Remove a child record. Only direct children of this node can be removed, others are ignored.
   * @param {Core.data.Model|Core.data.Model[]} childRecords The record(s) to remove.
   * @param {Boolean} [isMove] Pass `true` if the record is being moved within the same store.
   * @param {Boolean} [silent] Pass `true` to not trigger events during remove.
   * @category Parent & children
   */


  removeChild(childRecords, isMove = false, silent = false) {
    var _me$afterRemoveChild;

    const me = this,
          wasLeaf = me.isLeaf,
          {
      children,
      stores
    } = me;

    if (!Array.isArray(childRecords)) {
      childRecords = [childRecords];
    }

    childRecords = childRecords.filter(r => r.parent === me);

    if (!silent) {
      // Allow store listeners to veto the beforeRemove event
      for (const store of stores) {
        if (!store.isChained) {
          if (store.trigger('beforeRemove', {
            parent: me,
            records: childRecords,
            isMove
          }) === false) {
            return false;
          }
        }
      }
    }

    const preResult = me.beforeRemoveChild ? me.beforeRemoveChild(childRecords, isMove) : undefined;

    for (const childRecord of childRecords) {
      const {
        parentIdField
      } = childRecord.constructor,
            {
        modified
      } = childRecord.meta,
            oldParentId = childRecord.parent ? childRecord.parent.id : null; // Cache its original value

      if (!(parentIdField in modified)) {
        modified[parentIdField] = oldParentId;
      }

      const index = me.removeFromChildren(children, childRecord);
      me.removeFromChildren(me.unfilteredChildren, childRecord, true);
      stores.forEach(store => {
        if (!store.isChained) {
          store.onNodeRemoveChild(me, [childRecord], index, {
            isMove,
            silent
          });
        }
      }); // No need to clean up the node parent info and other meta data in case it is "move" operation. The info will be updated after "insert" operation.

      if (!isMove) {
        childRecord.parent = childRecord.parentIndex = childRecord.unfilteredIndex = childRecord.nextSibling = childRecord.previousSibling = null; // Reset parentId in data, record.parentId uses a getter to return record.parent.id

        childRecord.data[parentIdField] = null;
      }
    } // Convert emptied parent into leaf if configured to do so


    if ((me.unfilteredChildren || children).length === 0 && me.constructor.convertEmptyParentToLeaf.onRemove && !me.isRoot) {
      me.meta.isLeaf = true;
    } // If we've transitioned to being a leaf node, signal a change event
    // so that the UI updates


    if (me.isLeaf !== wasLeaf && !silent) {
      me.stores.forEach(s => {
        const changes = {
          isLeaf: {
            value: true,
            oldValue: false
          }
        };
        s.trigger('update', {
          record: me,
          changes
        });
        s.trigger('change', {
          action: 'update',
          record: me,
          changes
        });
      });
    }

    (_me$afterRemoveChild = me.afterRemoveChild) === null || _me$afterRemoveChild === void 0 ? void 0 : _me$afterRemoveChild.call(me, childRecords, preResult, isMove);
  }

  clearParentId() {
    const me = this;
    Reflect.deleteProperty(me.data, me.parentIdField);
    Reflect.deleteProperty(me.originalData, me.parentIdField);

    if (me.meta.modified) {
      Reflect.deleteProperty(me.meta.modified, me.parentIdField);
    }
  }
  /**
   * Replaces all child nodes with the new node set.
   * @param {Core.data.Model|Core.data.Model[]} childRecords The new child record set.
   * @returns {Core.data.Model[]}
   */


  replaceChildren(newChildren) {
    this.clearChildren();
    this.data[this.constructor.childrenField] = newChildren;
    this.processChildren();
    return this.children;
  }
  /**
   * Removes all child nodes from this node.
   * @param {Boolean} [silent=false] Pass `true` to not fire Store events during the remove.
   * @returns {Core.data.Model[]}
   */


  clearChildren(silent = false) {
    const me = this,
          {
      stores
    } = me,
          children = me.unfilteredChildren || me.children;
    me.children = [];

    if (children && children !== true) {
      stores.forEach(store => {
        if (!store.isChained) {
          // unfiltered:true to unregister children on filtered stores
          store.onNodeRemoveChild(me, children, 0, {
            unfiltered: true,
            silent
          });
        }
      }); // clear unfilteredChildren (must be after the above loop)

      if (me.unfilteredChildren) {
        me.unfilteredChildren = [];
      }
    }
  }
  /**
   * Removes all records from the rootNode
   * @private
   */


  clear() {
    var _me$children2;

    const me = this,
          {
      stores
    } = me,
          children = (_me$children2 = me.children) === null || _me$children2 === void 0 ? void 0 : _me$children2.slice(); // Only allow for root node and if data is present

    if (!me.isRoot || !children) {
      return;
    }

    for (const store of stores) {
      if (!store.isChained) {
        if (store.trigger('beforeRemove', {
          parent: me,
          records: children,
          isMove: false,
          removingAll: true
        }) === false) {
          return false;
        }
      }
    }

    me.children.length = 0;

    if (me.unfilteredChildren) {
      me.unfilteredChildren.length = 0;
    }

    stores.forEach(store => {
      children.forEach(child => {
        if (child.stores.includes(store)) {
          // this will drill down the child, unregistering whole branch
          child.unjoinStore(store);
        }

        child.parent = child.parentIndex = child.nextSibling = child.previousSibling = null;
      });
      store.storage.suspendEvents();
      store.storage.clear();
      store.storage.resumeEvents();
      store.added.clear();
      store.modified.clear();
      store.trigger('removeAll');
      store.trigger('change', {
        action: 'removeall'
      });
    });
  }

  updateChildrenIndices(children, unfiltered = false, silent = false) {
    const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex';
    let previousSibling = null;

    for (let i = 0; i < children.length; i++) {
      const child = children[i],
            oldValue = child[indexName];

      if (indexName === 'parentIndex') {
        // Record should not be considered modified by initial assignment of parentIndex
        if (oldValue === undefined || silent) {
          child.setData('parentIndex', i);
        } // Check to avoid pointless beforeUpdates from inSet
        else if (oldValue !== i) {
          // Silent set, do not want to trigger events from updated indices
          child.set('parentIndex', i, true);
        }
      } else {
        child[indexName] = i;
      }

      if (!unfiltered) {
        child.previousSibling = previousSibling;

        if (previousSibling) {
          previousSibling.nextSibling = child;
        } // Last child never has a nextSibling


        if (i === children.length - 1) {
          child.nextSibling = null;
        }

        previousSibling = child;
      }
    }
  }

  addToChildren(children, beforeRecord, newRecords, unfiltered = false) {
    if (children) {
      const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
            index = beforeRecord ? beforeRecord[indexName] : children.length;
      children.splice(index, 0, ...newRecords);
      this.updateChildrenIndices(children, unfiltered);
      return index;
    }
  }

  removeFromChildren(children, childRecord, unfiltered = false) {
    if (children) {
      const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
            index = childRecord[indexName];

      if (index > -1) {
        children.splice(index, 1);
        this.updateChildrenIndices(children, unfiltered);
      }

      return index;
    }
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/Helpers.js":
/*!**************************************!*\
  !*** ./lib/Core/data/stm/Helpers.js ***!
  \**************************************/
/*! exports provided: resetQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetQueue", function() { return resetQueue; });
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");
var productName = 'gantt';

const resetQueue = (stm, options) => {
  const {
    undo,
    redo
  } = options;
  let newProps;

  if (undo && !redo) {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: stm[_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]].slice(stm.position),
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["POS_PROP"]]: 0
    };
  } else if (redo && !undo) {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: stm[_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]].slice(0, stm.position)
    };
  } else {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["POS_PROP"]]: 0
    };
  }

  ;
  return [newProps, () => {
    stm.notifyStoresAboutQueueReset(options);
  }];
};

/***/ }),

/***/ "./lib/Core/data/stm/Props.js":
/*!************************************!*\
  !*** ./lib/Core/data/stm/Props.js ***!
  \************************************/
/*! exports provided: STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP, PROPS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATE_PROP", function() { return STATE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORES_PROP", function() { return STORES_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUEUE_PROP", function() { return QUEUE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POS_PROP", function() { return POS_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_PROP", function() { return TRANSACTION_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_TIMER_PROP", function() { return TRANSACTION_TIMER_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_RECORD_PROP", function() { return AUTO_RECORD_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROPS", function() { return PROPS; });
var productName = 'gantt';
/**
* @module Core/data/stm/Props.js
* @internal
*/

const STATE_PROP = Symbol('STATE_PROP');
const STORES_PROP = Symbol('STORES_PROP');
const QUEUE_PROP = Symbol('QUEUE_PROP');
const POS_PROP = Symbol('POS_PROP');
const TRANSACTION_PROP = Symbol('TRANSACTION_PROP');
const TRANSACTION_TIMER_PROP = Symbol('TRANSACTION_TIMER_PROP');
const AUTO_RECORD_PROP = Symbol('AUTO_RECORD_PROP');
const PROPS = Object.freeze([STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP]);

/***/ }),

/***/ "./lib/Core/data/stm/StateTrackingManager.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/StateTrackingManager.js ***!
  \***************************************************/
/*! exports provided: makeModelUpdateAction, makeModelInsertChildAction, makeModelRemoveChildAction, makeStoreModelAddAction, makeStoreModelInsertAction, makeStoreModelRemoveAction, makeStoreRemoveAllAction, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelUpdateAction", function() { return makeModelUpdateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelInsertChildAction", function() { return makeModelInsertChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelRemoveChildAction", function() { return makeModelRemoveChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelAddAction", function() { return makeStoreModelAddAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelInsertAction", function() { return makeStoreModelInsertAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelRemoveAction", function() { return makeStoreModelRemoveAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreRemoveAllAction", function() { return makeStoreRemoveAllAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateTrackingManager; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./state/StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./state/DisabledState.js */ "./lib/Core/data/stm/state/DisabledState.js");
/* harmony import */ var _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./state/ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./state/RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./state/RestoringState.js */ "./lib/Core/data/stm/state/RestoringState.js");
/* harmony import */ var _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./state/AutoReadyState.js */ "./lib/Core/data/stm/state/AutoReadyState.js");
/* harmony import */ var _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/AutoRecordingState.js */ "./lib/Core/data/stm/state/AutoRecordingState.js");
/* harmony import */ var _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./state/Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./action/UpdateAction.js */ "./lib/Core/data/stm/action/UpdateAction.js");
/* harmony import */ var _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./action/InsertChildAction.js */ "./lib/Core/data/stm/action/InsertChildAction.js");
/* harmony import */ var _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./action/RemoveChildAction.js */ "./lib/Core/data/stm/action/RemoveChildAction.js");
/* harmony import */ var _action_AddAction_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./action/AddAction.js */ "./lib/Core/data/stm/action/AddAction.js");
/* harmony import */ var _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./action/InsertAction.js */ "./lib/Core/data/stm/action/InsertAction.js");
/* harmony import */ var _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./action/RemoveAction.js */ "./lib/Core/data/stm/action/RemoveAction.js");
/* harmony import */ var _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./action/RemoveAllAction.js */ "./lib/Core/data/stm/action/RemoveAllAction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");
var productName = 'gantt';
/**
* @module Core/data/stm/StateTrackingManager
*/



















const makeModelUpdateAction = (model, newData, oldData) => {
  return new _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
    model,
    newData,
    oldData
  });
};
const makeModelInsertChildAction = (parentModel, insertIndex, childModels, context) => {
  return new _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
    parentModel,
    childModels,
    insertIndex,
    context
  });
};
const makeModelRemoveChildAction = (parentModel, childModels, context) => {
  return new _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
    parentModel,
    childModels,
    context
  });
};
const makeStoreModelAddAction = (store, modelList, silent) => {
  return new _action_AddAction_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
    store,
    modelList,
    silent
  });
};
const makeStoreModelInsertAction = (store, insertIndex, modelList, context, silent) => {
  return new _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
    store,
    insertIndex,
    modelList,
    context,
    silent
  });
};
const makeStoreModelRemoveAction = (store, modelList, context, silent) => {
  return new _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
    store,
    modelList,
    context,
    silent
  });
};
const makeStoreRemoveAllAction = (store, allRecords, silent) => {
  return new _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
    store,
    allRecords,
    silent
  });
};

const stateTransition = (stm, event, ...args) => {
  const oldState = stm.state,
        newState = event.call(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]], stm, ...args);

  if (typeof newState === 'string') {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(newState);
  } else if (newState instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = newState;
  } else if (Array.isArray(newState)) {
    const [state, next] = newState;

    if (typeof state === 'string') {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(state);
    } else if (state instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = state;
    } else if (state && typeof state === 'object') {
      stm = Object.assign(stm, state);
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]);
    }

    if (typeof next === 'function') {
      stateTransition(stm, next, ...args);
    }
  } else if (newState && typeof newState === 'object') {
    stm = Object.assign(stm, newState);
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]);
  }

  if (oldState !== _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] && oldState !== _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"] && newState !== _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] && newState !== _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
    stm.trigger('ready');
  }
};
/**
 * Tracks the state of every store registered via {@link #function-addStore}. It is {@link #config-disabled} by default
 * so remember to call {@link #function-enable} when your stores are registered and initial dataset is loaded.
 * Use {@link #function-undo} / {@link #function-redo} method calls to restore state to a particular
 * point in time
 *
 * ```javascript
 * stm = new StateTrackingManager({
 *     autoRecord : true,
 *     listeners  : {
 *        'recordingstop' : () => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        },
 *        'restoringstop' : ({ stm }) => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        }
 *    },
 *    getTransactionTitle : (transaction) => {
 *        // your custom code to analyze the transaction and return custom transaction title
 *        const lastAction = transaction.queue[transaction.queue.length - 1];
 *
 *        if (lastAction instanceof AddAction) {
 *            let title = 'Add new record';
 *        }
 *
 *        return title;
 *    }
 * });
 *
 * stm.addStore(userStore);
 * stm.addStore(companyStore);
 * stm.addStore(otherStore);
 *
 * stm.enable();
 * ```
 *
 * **Note:** STM currently does not support undoing server side added and saved records.
 * Therefore it's recommended to {@link #function-resetQueue reset the queue}
 * each time a tracked store(s) loads from or saves its changes to the server.
 * If Crud Manager is used it can be done like this:
 * ```javascript
 * crudManager.on({
 *     requestDone() {
 *         stm.resetQueue();
 *     }
 * });
 * ```
 * and in case individual stores are used:
 * ```javascript
 * ajaxStore.on({
 *     afterRequest({ exception }) {
 *         if (!exception) {
 *             stm.resetQueue();
 *         }
 *     }
 * });
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */


class StateTrackingManager extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * Default manager disabled state
       *
       * @config {Boolean}
       * @default
       */
      disabled: true,

      /**
       * Whether to start transaction recording automatically in case the Manager is enabled.
       *
       * In the auto recording mode, the manager waits for the first change in any store being managed and starts a transaction, i.e.
       * records any changes in its monitored stores. The transaction lasts for {@link #config-autoRecordTransactionStopTimeout} and
       * afterwards creates one undo/redo step, including all changes in the stores during that period of time.
       *
       * In non auto recording mode you have to call {@link #function-startTransaction} / {@link #function-stopTransaction} to start and end
       * a transaction.
       *
       * @config {Boolean}
       * @default
       */
      autoRecord: false,

      /**
       * The transaction duration (in ms) for the auto recording mode {@link #config-autoRecord}
       *
       * @config {Number}
       * @default
       */
      autoRecordTransactionStopTimeout: 100,

      /**
       * Store model update action factory
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelUpdateAction: makeModelUpdateAction,

      /**
       * Store insert child model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelInsertChildAction: makeModelInsertChildAction,

      /**
       * Store remove child model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelRemoveChildAction: makeModelRemoveChildAction,

      /**
       * Store add model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelAddAction: makeStoreModelAddAction,

      /**
       * Store insert model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelInsertAction: makeStoreModelInsertAction,

      /**
       * Store remove model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelRemoveAction: makeStoreModelRemoveAction,

      /**
       * Store remove all models action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreRemoveAllAction: makeStoreRemoveAllAction,

      /**
       * Function to create a transaction title if none is provided.
       *
       * The function receives a transaction and should return a title.
       *
       * @config {Function}
       * @default
       */
      getTransactionTitle: null
    };
  }

  construct(...args) {
    const me = this;
    Object.assign(me, {
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]: _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["POS_PROP"]]: 0,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_TIMER_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["AUTO_RECORD_PROP"]]: false
    });
    super.construct(...args);
  } // TODO: This destroys the current state, which makes successive tests fail. Not sure what should be done
  // doDestroy() {
  //     super.doDestroy();
  //     this.destroyProperties(STATE_PROP);
  // }

  /**
   * Gets current state of the manager
   *
   * @property {Core.data.stm.state.StateBase}
   */


  get state() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]];
  }
  /**
   * Gets current undo/redo queue position
   *
   * @property {Number}
   */


  get position() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["POS_PROP"]];
  }
  /**
   * Gets current undo/redo queue length
   *
   * @property {Number}
   */


  get length() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]].length;
  }
  /**
   * Gets all the stores registered in STM
   *
   * @property {Core.data.Store[]}
   */


  get stores() {
    return Array.from(this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]]);
  }
  /**
   * Checks if a store has been added to the manager
   *
   * @param  {Core.data.Store} store
   * @return {Boolean}
   */


  hasStore(store) {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].includes(store);
  }
  /**
   * Adds a store to the manager
   *
   * @param {Core.data.Store} store
   */


  addStore(store) {
    if (!this.hasStore(store)) {
      this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].push(store);
      store.stm = this;
    }
  }
  /**
   * Removes a store from the manager
   *
   * @param {Core.data.Store} store
   */


  removeStore(store) {
    if (this.hasStore(store)) {
      this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]] = this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].filter(s => s !== store);
      store.stm = null;
    }
  }
  /**
   * Calls `fn` for each store registered in STM.
   *
   * @param {Function} fn (store, id) => ...
   */


  forEachStore(fn) {
    this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].forEach(s => fn(s, s.id));
  }
  /**
   * Get/set manager disabled state
   *
   * @property {Boolean}
   */


  get disabled() {
    return this.state === _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_3__["default"];
  }

  set disabled(val) {
    const me = this;

    if (me.disabled != val) {
      if (val) {
        stateTransition(me, me.state.onDisable, me);
      } else {
        stateTransition(me, me.state.onEnable, me);
      }

      me.trigger('stmDisabled', {
        disabled: val
      });
      /**
       * Fired when the disabled state of the STM changes
       *
       * @event disabled
       * @param {Core.data.stm.StateTrackingManager} source
       * @param {Boolean} disabled The current disabled state of the STM
       */

      me.trigger('disabled', {
        disabled: val
      });
    }
  }
  /**
   * Enables manager
   */


  enable() {
    this.disabled = false;
  }
  /**
   * Disables manager
   */


  disable() {
    this.disabled = true;
  }
  /**
   * Checks manager ready state
   * @readonly
   * @property {Boolean}
   */


  get isReady() {
    return this.state === _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] || this.state === _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"];
  }

  waitForReadiness() {
    return this.await('ready', false);
  }
  /**
   * Checks manager recording state
   * @readonly
   * @property {Boolean}
   */


  get isRecording() {
    return this.state === _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_5__["default"] || this.state === _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_8__["default"];
  }
  /**
   * Gets/sets manager auto record option
   *
   * @property {Boolean}
   */


  get autoRecord() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["AUTO_RECORD_PROP"]];
  }

  set autoRecord(value) {
    const me = this;

    if (me.autoRecord != value) {
      if (value) {
        stateTransition(me, me.state.onAutoRecordOn, me);
      } else {
        stateTransition(me, me.state.onAutoRecordOff, me);
      }
    }
  }
  /**
   * Starts undo/redo recording transaction.
   *
   * @param {String} [title=nul]
   */


  startTransaction(title = null) {
    stateTransition(this, this.state.onStartTransaction, title);
  }
  /**
   * Stops undo/redo recording transaction
   *
   * @param {String} [title=null]
   */


  stopTransaction(title = null) {
    stateTransition(this, this.state.onStopTransaction, title);
  }
  /**
   * Stops undo/redo recording transaction after {@link #config-autoRecordTransactionStopTimeout} delay.
   *
   * @private
   */


  stopTransactionDelayed() {
    stateTransition(this, this.state.onStopTransactionDelayed);
  }
  /**
   * Rejects currently recorded transaction.
   */


  rejectTransaction() {
    stateTransition(this, this.state.onRejectTransaction);
  }
  /**
   * Gets currently recording STM transaction.
   * @readonly
   * @property {Core.data.stm.Transaction}
   */


  get transaction() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_PROP"]];
  }
  /**
   * Gets titles of all recorded undo/redo transactions
   * @readonly
   * @property {String[]}
   */


  get queue() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]].map(t => t.title);
  }
  /**
   * Gets manager restoring state.
   * @readonly
   * @property {Boolean}
   */


  get isRestoring() {
    return this.state === _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_6__["default"];
  }
  /**
   * Checks if the manager can undo.
   *
   * @property {Boolean}
   */


  get canUndo() {
    return this.state.canUndo(this);
  }
  /**
   * Checks if the manager can redo.
   *
   * @property {Boolean}
   */


  get canRedo() {
    return this.state.canRedo(this);
  }
  /**
   * Undoes current undo/redo transaction.
   * @param {Number} [steps=1]
   * @returns {Promise} A promise which is resolved when undo action has been performed
   */


  async undo(steps = 1) {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    stateTransition(this, this.state.onUndo, steps);
  }
  /**
   * Undoes all transactions.
   * @returns {Promise} A promise which is resolved when undo actions has been performed
   */


  async undoAll() {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    this.undo(this.length);
  }
  /**
   * Redoes current undo/redo transaction.
   *
   * @param {Number} [steps=1]
   * @returns {Promise} A promise which is resolved when redo action has been performed
   */


  async redo(steps = 1) {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    stateTransition(this, this.state.onRedo, steps);
  }
  /**
   * Redoes all transactions.
   * @returns {Promise} A promise which is resolved when redo actions has been performed
   */


  async redoAll() {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    this.redo(this.length);
  }
  /**
   * Resets undo/redo queue.
   */


  resetQueue(
  /* private */
  options = {
    undo: true,
    redo: true
  }) {
    stateTransition(this, this.state.onResetQueue, options);
  }
  /**
   * Resets undo queue.
   */


  resetUndoQueue() {
    this.resetQueue({
      undo: true
    });
  }
  /**
   * Resets redo queue.
   */


  resetRedoQueue() {
    this.resetQueue({
      redo: true
    });
  }

  notifyStoresAboutStateRecordingStart(transaction) {
    this.forEachStore(store => {
      store.onStmRecordingStart && store.onStmRecordingStart(this, transaction);
    });
    /**
     * Fired upon state recording operation starts.
     *
     * @event recordingStart
     * @param {Core.data.stm.StateTrackingManager} stm
     * @param {Core.data.stm.Transaction} transaction
     */

    this.trigger('recordingStart', {
      stm: this,
      transaction
    });
  }

  notifyStoresAboutStateRecordingStop(transaction, reason) {
    this.forEachStore(store => {
      store.onStmRecordingStop && store.onStmRecordingStop(this, transaction, reason);
    });
    /**
     * Fired upon state recording operation stops.
     *
     * @event recordingStop
     * @param {Core.data.stm.StateTrackingManager} stm
     * @param {Core.data.stm.Transaction} transaction
     * @param {Object} reason Transaction stop reason
     * @param {Boolean} reason.stop Transaction recording has been stopped in a normal way.
     * @param {Boolean} reason.disabled Transaction recording has been stopped due to STM has been disabled.
     * @param {Boolean} reason.rejected Transaction recording has been stopped due to transaction has been rejected.
     */

    this.trigger('recordingStop', {
      stm: this,
      transaction,
      reason
    });
  }

  notifyStoresAboutStateRestoringStart() {
    this.forEachStore(store => {
      store.onStmRestoringStart && store.onStmRestoringStart(this);
    });
    /**
     * Fired upon state restoration operation starts.
     *
     * @event restoringStart
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('restoringStart', {
      stm: this
    });
  }

  notifyStoresAboutStateRestoringStop() {
    this.forEachStore(store => {
      store.onStmRestoringStop && store.onStmRestoringStop(this);
    });
    /**
     * Fired upon state restoration operation stops.
     *
     * @event restoringStop
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('restoringStop', {
      stm: this
    });
  }

  notifyStoresAboutQueueReset(options) {
    this.forEachStore(store => {
      store.onStmQueueReset && store.onStmQueueReset(this, options);
    });
    /**
     * Fired upon state undo/redo queue reset.
     *
     * @event queueReset
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('queueReset', {
      stm: this,
      options
    });
  }
  /**
   * Method to call from model STM mixin upon model update
   *
   * @param {Core.data.Model} model
   * @param {Object} newData
   * @param {Object} oldData
   *
   * @private
   */


  onModelUpdate(model, newData, oldData) {
    stateTransition(this, this.state.onModelUpdate, model, newData, oldData);
  }
  /**
   * Method to call from model STM mixin upon tree model child insertion
   *
   * @param {Core.data.Model} parentModel Parent model
   * @param {Number} index Insertion index
   * @param {Core.data.Model[]} childModels Array of models inserted
   * @param {Map} context Map with inserted models as keys and objects with previous parent,
   *                      and index at previous parent.
   *
   * @private
   */


  onModelInsertChild(parentModel, index, childModels, context) {
    stateTransition(this, this.state.onModelInsertChild, parentModel, index, childModels, context);
  }
  /**
   * Method to call from model STM mixin upon tree model child removal
   *
   * @param {Core.data.Model} parentModel
   * @param {Core.data.Model[]} childModels
   * @param {Map} context
   *
   * @private
   */


  onModelRemoveChild(parentModel, childModels, context) {
    stateTransition(this, this.state.onModelRemoveChild, parentModel, childModels, context);
  }
  /**
   * Method to call from store STM mixin upon store models adding
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} models
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelAdd(store, models, silent) {
    stateTransition(this, this.state.onStoreModelAdd, store, models, silent);
  }
  /**
   * Method to call from store STM mixin upon store models insertion
   *
   * @param {Core.data.Store} store
   * @param {Number} index
   * @param {Core.data.Model[]} models
   * @param {Map} context
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelInsert(store, index, models, context, silent) {
    stateTransition(this, this.state.onStoreModelInsert, store, index, models, context, silent);
  }
  /**
   * Method to call from store STM mixin upon store models removal
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} models
   * @param {Object} context
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelRemove(store, models, context, silent) {
    stateTransition(this, this.state.onStoreModelRemove, store, models, context, silent);
  }
  /**
   * Method to call from store STM mixin upon store clear
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} allRecords
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreRemoveAll(store, allRecords, silent) {
    stateTransition(this, this.state.onStoreRemoveAll, store, allRecords, silent);
  } // UI key event handling


  onUndoKeyPress(event) {
    if (!this.disabled) {
      if (event.shiftKey) {
        if (this.canRedo) {
          event.preventDefault();
          this.redo();
        }
      } else if (this.canUndo) {
        event.preventDefault();
        this.undo();
      }
    }
  }

}
StateTrackingManager._$name = 'StateTrackingManager';

/***/ }),

/***/ "./lib/Core/data/stm/Transaction.js":
/*!******************************************!*\
  !*** ./lib/Core/data/stm/Transaction.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Transaction; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
/**
* @module Core/data/stm/Transaction
*/


const ACTION_QUEUE_PROP = Symbol('ACTION_QUEUE_PROP');
/**
 * STM transaction class, holds list of actions constituting a transaction.
 *
 * A transaction can be undone and redone. Upon undo all the actions being held
 * are undone in reverse order. Upon redo all the actions being held are redone
 * in forward order.
 */

class Transaction extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  get defaultConfig() {
    return {
      /**
       * Transaction title
       *
       * @config {String}
       * @default
       */
      title: null
    };
  }

  construct(...args) {
    this[ACTION_QUEUE_PROP] = [];
    super.construct(...args);
  }
  /**
   * Gets transaction's actions queue
   *
   * @property {Core.data.stm.action.ActionBase[]}
   */


  get queue() {
    return this[ACTION_QUEUE_PROP].slice(0);
  }
  /**
   * Gets transaction's actions queue length
   *
   * @property {Number}
   */


  get length() {
    return this[ACTION_QUEUE_PROP].length;
  }
  /**
   * Adds an action to the transaction.
   *
   * @param {Core.data.stm.action.ActionBase|Object} action
   */


  addAction(action) {
    this[ACTION_QUEUE_PROP].push(action);
  }
  /**
   * Undoes actions held
   */


  undo() {
    const queue = this[ACTION_QUEUE_PROP];

    for (let i = queue.length - 1; i >= 0; --i) {
      queue[i].undo();
    }
  }
  /**
   * Redoes actions held
   */


  redo() {
    const queue = this[ACTION_QUEUE_PROP];

    for (let i = 0, len = queue.length; i < len; ++i) {
      queue[i].redo();
    }
  }

}
Transaction._$name = 'Transaction';

/***/ }),

/***/ "./lib/Core/data/stm/action/ActionBase.js":
/*!************************************************!*\
  !*** ./lib/Core/data/stm/action/ActionBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ActionBase; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/ActionBase
*/



const throwAbstractMethodCall = () => {
  throw new Error('Abstract method call!');
};
/**
 * Base class for STM actions.
 *
 * @abstract
 */


class ActionBase extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Gets the type of the action (stringified class name).
   * @readonly
   * @property {String}
   */
  get type() {
    return this.constructor.name;
  }
  /**
   * Undoes an action
   */


  undo() {
    throwAbstractMethodCall();
  }
  /**
   * Redoes an action
   */


  redo() {
    throwAbstractMethodCall();
  }

}
ActionBase._$name = 'ActionBase';

/***/ }),

/***/ "./lib/Core/data/stm/action/AddAction.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/action/AddAction.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AddAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


/**
 * @module Core/data/stm/action/AddAction
 */

const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
/**
 * Action to record the fact of models adding to a store.
 * @extends Core/data/stm/action/ActionBase
 */

class AddAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been added into.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models added into the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'AddAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  undo() {
    const me = this;
    me.store.remove(me.modelList, me.silent);
  }

  redo() {
    const me = this;
    me.store.add(me.modelList, me.silent);
  }

}
AddAction._$name = 'AddAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


/**
 * @module Core/data/stm/action/InsertAction
 */

const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
const INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models inserting into a store.
 * @extends Core/data/stm/action/ActionBase
 */

class InsertAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been inserted into.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models inserted into the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Index the models have been inserted at.
       *
       * @config {Number}
       * @default
       */
      insertIndex: undefined,

      /**
       * Models move context (if models has been moved), if any.
       * Map this {@link Core/data/Model} instances as keys and their
       * previous index as values
       *
       * @config {Map}
       * @default
       */
      context: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'InsertAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  get insertIndex() {
    return this[INSERT_INDEX_PROP];
  }

  set insertIndex(index) {
    this[INSERT_INDEX_PROP] = index;
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(context) {
    this[CONTEXT_PROP] = context;
  }

  undo() {
    const {
      store,
      modelList,
      context,
      silent
    } = this; // Let's sort models by index such that models with lesser index
    // were inserted back first, thus making valid index of models following.

    modelList.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
      return lhsIndex !== undefined && rhsIndex !== undefined ? lhsIndex - rhsIndex : 0;
    });
    modelList.forEach(m => {
      const index = context.get(m); // Flag the inserted record that we undo to skip adding it to "store.removed"

      m._undoingInsertion = true;

      if (index !== undefined) {
        // Insert at previous index
        store.insert(index, m, silent);
      } else {
        // Just remove
        store.remove(m, silent);
      }

      m._undoingInsertion = false;
    });
  }

  redo() {
    const me = this;
    me.store.insert(me.insertIndex, me.modelList, me.silent);
  }

}
InsertAction._$name = 'InsertAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertChildAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/InsertChildAction
*/


const PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
const CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
const INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of adding a children models into a parent model.
 * @extends Core/data/stm/action/ActionBase
 */

class InsertChildAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a parent model a child model has been added to.
       *
       * @config {Core.data.Model}
       * @default
       */
      parentModel: undefined,

      /**
       * Children models inserted.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      childModels: undefined,

      /**
       * Index a children models are inserted at
       *
       * @config {Number}
       * @default
       */
      insertIndex: undefined,

      /**
       * Map having children models as keys and values containing previous parent
       * of each model and index at the previous parent.
       *
       * @config {Object}
       * @default
       */
      context: undefined
    };
  }

  get type() {
    return 'InsertChildAction';
  }

  get parentModel() {
    return this[PARENT_MODEL_PROP];
  }

  set parentModel(model) {
    this[PARENT_MODEL_PROP] = model;
  }

  get childModels() {
    return this[CHILD_MODELS_PROP];
  }

  set childModels(models) {
    this[CHILD_MODELS_PROP] = models.slice(0);
  }

  get insertIndex() {
    return this[INSERT_INDEX_PROP];
  }

  set insertIndex(index) {
    this[INSERT_INDEX_PROP] = index;
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(ctx) {
    this[CONTEXT_PROP] = ctx;
  }

  undo() {
    const {
      parentModel,
      context,
      childModels
    } = this; // Let's sort models by parent index such that models with lesser index
    // were inserted back first, thus making valid parent index of models following.

    childModels.sort((lhs, rhs) => {
      const {
        lhsParent,
        lhsIndex
      } = context.get(lhs) || {},
            {
        rhsParent,
        rhsIndex
      } = context.get(rhs) || {};
      return lhsParent && lhsParent === rhsParent ? lhsIndex - rhsIndex : 0;
    }); // Now let's re-insert records back to where they were or remove them
    // if they weren't anywhere

    childModels.forEach(m => {
      const {
        parent,
        index
      } = context.get(m) || {};

      if (parent) {
        // If we move within same parent then index must be adjusted
        if (parent === parentModel) {
          let adjustedIndex; // we need to increment index if the node was moved up

          adjustedIndex = index > m.parentIndex ? index + 1 : index; // null index if we need to move to the end

          adjustedIndex = index === parent.children.length - 1 ? null : adjustedIndex; // if insertBefore is undefined the node will be appended to the end

          const insertBefore = parent.children[adjustedIndex];
          parent.insertChild(m, insertBefore);
        } else {
          // Insert at previous index
          parent.insertChild(m, parent.children[index]);
        }
      } else {
        // Just remove
        parentModel.removeChild(m);
      }
    });
  }

  redo() {
    const {
      parentModel,
      insertIndex,
      childModels
    } = this,
          insertBefore = parentModel.children[insertIndex];
    parentModel.insertChild(childModels, insertBefore);
  }

}
InsertChildAction._$name = 'InsertChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/RemoveAction
*/



const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models removed from a store.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been removed from.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models removed from the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Models removing context.
       *
       * @config {Object}
       * @default
       */
      context: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'RemoveAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(context) {
    this[CONTEXT_PROP] = context;
  }

  undo() {
    const {
      store,
      context,
      modelList,
      silent
    } = this; // Let's sort models by index such that models with lesser index
    // were inserted back first, thus making valid index of models following.

    modelList.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs); // Here, in contrast to InsertAction, index is always present

      return lhsIndex - rhsIndex;
    });
    modelList.forEach(m => {
      const index = context.get(m); // Insert at previous index

      store.insert(index, m, silent);
    });
  }

  redo() {
    const me = this;
    me.store.remove(me.modelList, me.silent);
  }

}
RemoveAction._$name = 'RemoveAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAllAction.js":
/*!*****************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAllAction.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAllAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/RemoveAllAction
*/



const STORE_PROP = Symbol('STORE_PROP');
const ALL_RECORDS_PROP = Symbol('ALL_RECORDS_PROP');
/**
 * Action to record store remove all operation.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveAllAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store cleared.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * All store records removed
       *
       * @config {Core.data.Model[]}
       * @default
       */
      allRecords: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'RemoveAllAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get allRecords() {
    return this[ALL_RECORDS_PROP];
  }

  set allRecords(records) {
    this[ALL_RECORDS_PROP] = records.slice(0);
  }

  undo() {
    const {
      store,
      allRecords,
      silent
    } = this;
    store.add(allRecords, silent);
  }

  redo() {
    const me = this;
    me.store.removeAll(me.silent);
  }

}
RemoveAllAction._$name = 'RemoveAllAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveChildAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/RemoveChildAction
*/


const PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
const CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record store remove child operation.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveChildAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a parent model a child model has been removed to.
       *
       * @config {Core.data.Model}
       * @default
       */
      parentModel: undefined,

      /**
       * Children models removed.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      childModels: undefined,

      /**
       * Map having children models as keys and values containing previous parent
       * index at the parent.
       *
       * @config {Object}
       * @default
       */
      context: undefined
    };
  }

  get type() {
    return 'RemoveChildAction';
  }

  get parentModel() {
    return this[PARENT_MODEL_PROP];
  }

  set parentModel(model) {
    this[PARENT_MODEL_PROP] = model;
  }

  get childModels() {
    return this[CHILD_MODELS_PROP];
  }

  set childModels(models) {
    this[CHILD_MODELS_PROP] = models.slice(0);
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(ctx) {
    this[CONTEXT_PROP] = ctx;
  }

  undo() {
    const {
      parentModel,
      context,
      childModels
    } = this; // Let's sort models by parent index such that models with lesser index
    // were inserted back first, thus making valid parent index of models following.

    childModels.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
      return lhsIndex - rhsIndex;
    }); // Now let's re-insert records back to where they were

    childModels.forEach(m => {
      parentModel.insertChild(context.get(m), m);
    });
  }

  redo() {
    this.parentModel.removeChild(this.childModels);
  }

}
RemoveChildAction._$name = 'RemoveChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/UpdateAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/UpdateAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UpdateAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'gantt';
/**
* @module Core/data/stm/action/UpdateAction
*/


const MODEL_PROP = Symbol('MODEL_PROP');
const NEW_DATA_PROP = Symbol('NEW_DATA_PROP');
const OLD_DATA_PROP = Symbol('OLD_DATA_PROP');
/**
 * Action to record the fact that a model has been updated.
 * @extends Core/data/stm/action/ActionBase
 */

class UpdateAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a model which has been updated.
       *
       * @config {Core.data.Model}
       * @default
       */
      model: undefined,

      /**
       * Map of updated properties with new values.
       *
       * @config {Object}
       * @default
       */
      newData: undefined,

      /**
       * Map of updated properties with old values.
       *
       * @config {Object}
       * @default
       */
      oldData: undefined
    };
  }

  get type() {
    return 'UpdateAction';
  }

  get model() {
    return this[MODEL_PROP];
  }

  set model(value) {
    this[MODEL_PROP] = value;
  }

  get newData() {
    return this[NEW_DATA_PROP];
  }

  set newData(value) {
    this[NEW_DATA_PROP] = Object.assign({}, value);
  }

  get oldData() {
    return this[OLD_DATA_PROP];
  }

  set oldData(value) {
    this[OLD_DATA_PROP] = Object.assign({}, value);
  }

  undo() {
    // it seems STM has to use `model.set()` because of `model.inSet` overrides or smth
    // w/o this call, just with `Object.assign()` below, the view is not refreshed
    // Since invoking accessor will just forward change to the engine, we need to pass `skipAccessors = true`
    // to this call to make this change on data level. Engine will be updated below.
    // Covered by TaskEdit.t `autoSync` subtest
    this.model.set(this.oldData, null, null, null, true); // in the same time, engine needs the setters to be activated, since there's some
    // additional logic (for example, invalidate dispatcher)
    // This will make change in the engine

    if (this.model.$) {
      Object.assign(this.model, this.oldData);
    }
  }

  redo() {
    this.model.set(this.newData, null, null, null, true); // see comments above

    if (this.model.$) {
      Object.assign(this.model, this.newData);
    }
  }

}
UpdateAction._$name = 'UpdateAction';

/***/ }),

/***/ "./lib/Core/data/stm/mixin/ModelStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/ModelStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
/**
* @module Core/data/stm/mixin/ModelStm
*/


const STM_PROP = Symbol('STM_PROP'),
      unrecordedFields = {
  // This field's value is a by product of node insertion and must not be recorded here.
  // It's the node insertion operation which is recorded by STM.
  parentIndex: 1
};
/**
 * Mixin making a model compatible with {@link Core/data/stm/StateTrackingManager}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ModelStm extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ModelStm';
  }

  static get defaultConfig() {
    return {
      stm: null
    };
  }

  joinStore(store) {
    // No super on purpose, micro optimization of critical perf path
    // super.joinStore && super.joinStore(store);
    if (!this.stm) {
      this.stm = store.stm;
    }
  }

  unjoinStore(store) {
    if (this.stm === store.stm) {
      this.stm = null;
    }

    super.unjoinStore && super.unjoinStore(store);
  }
  /**
   * Reference to STM manager, if used
   * @member {Core.data.stm.StateTrackingManager}
   * @category Misc
   */


  get stm() {
    return this[STM_PROP];
  }

  set stm(stm) {
    this[STM_PROP] = stm;
  }
  /**
   * Overridden to collect initial data for the fields about to be changed.
   * The method is called from within {@link Core/data/Model#function-set} method.
   *
   * @private
   */


  beforeSet(field, value, silent, fromRelationUpdate) {
    const stm = this.stm;

    if (stm && !stm.disabled && !unrecordedFields[field] && !this.constructor.nonPersistableFields[field]) {
      var _super$beforeSet;

      const preResult = ((_super$beforeSet = super.beforeSet) === null || _super$beforeSet === void 0 ? void 0 : _super$beforeSet.call(this, field, value, silent, fromRelationUpdate)) || [];
      let newDataCandidate, oldDataCandidate;

      if (typeof field == 'object') {
        [newDataCandidate, oldDataCandidate] = Object.keys(field).reduce((data, fName) => {
          data[0][fName] = field[fName];
          data[1][fName] = this.get(fName);
          return data;
        }, [{}, {}]);
      } else {
        newDataCandidate = {
          [field]: value
        };
        oldDataCandidate = {
          [field]: this.get(field)
        };
      }

      preResult.push([newDataCandidate, oldDataCandidate]);
      return preResult;
    }

    return [];
  }
  /**
   * Overridden to store initial data of the changed fields and to notify STM
   * manager about the change action if anything has been changed in result.
   *
   * The method is called from within {@link Core/data/Model#function-set} method.
   *
   * @private
   */


  afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet) {
    const stm = this.stm,
          nonPersistableFields = this.constructor.nonPersistableFields;

    if (stm && !stm.disabled && !unrecordedFields[field] && !nonPersistableFields[field]) {
      const preResult = beforeResult.pop();

      if (wasSet) {
        let shouldRecord;
        const [newDataCandidate, oldDataCandidate] = preResult,
              [newData, oldData] = Object.keys(wasSet).reduce((data, fieldName) => {
          if (!nonPersistableFields[fieldName]) {
            shouldRecord = true;
          }

          data[0][fieldName] = newDataCandidate[fieldName];
          data[1][fieldName] = oldDataCandidate[fieldName];
          return data;
        }, [{}, {}]);

        if (shouldRecord) {
          stm.onModelUpdate(this, newData, oldData);
        }
      }
    } // No super on purpose, micro optimization of critical perf path
    // super.afterSet && super.afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet);

  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to obtain inserted
   * records initial parents and parent index, to be able to restore the state back upon undo.
   *
   * @param {Core.data.Model[]} childRecords
   * @return {Array} Array of results from this call and any of super calls if any.
   *               This result is consumed by {@link #function-afterInsertChild} which pops
   *               from the result array to take only results of this method call and leave
   *               results from super calls untouched.
   *
   * @private
   */


  beforeInsertChild(childRecords) {
    const preResult = super.beforeInsertChild ? super.beforeInsertChild(childRecords) : [];
    const stm = this.stm;

    if (stm && !stm.disabled) {
      preResult.push(childRecords.reduce((result, childRecord) => {
        // We are interested only in records from the same root node.
        // Removing (which is done before insertion) of the records
        // from another root (and store) should
        // be handled by that store STM instance.
        if (childRecord.root === this.root) {
          result.set(childRecord, {
            parent: childRecord.parent,
            index: childRecord.parent ? childRecord.parentIndex : undefined
          });
        }

        return result;
      }, new Map()));
    }

    return preResult;
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to notify {@link Core/data/stm/StateTrackingManager}
   * about children insertion. Provides it with all necessary context information collected
   * in {@link #function-beforeInsertChild} required to undo/redo the action.
   *
   * @private
   */


  afterInsertChild(index, childRecords, beforeResult, inserted) {
    const stm = this.stm;

    if (stm && !stm.disabled) {
      const context = beforeResult.pop();

      if (inserted) {
        stm.onModelInsertChild(this, index, inserted, context);
      }
    }

    super.afterInsertChild && super.afterInsertChild(index, childRecords, beforeResult, inserted);
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to obtain removed
   * records initial parent index, to be able to restore the state back upon undo.
   *
   * @param {Core.data.Model[]} childRecords
   * @param {Boolean} isMove
   * @return {Array} Array of results from this call and any of super calls if any.
   *               This result is consumed by {@link #function-afterRemoveChild} which pops
   *               from the result array to take only results of this method call and leave
   *               results from super calls untouched.
   *
   * @private
   */


  beforeRemoveChild(childRecords, isMove) {
    const preResult = super.beforeRemoveChild ? super.beforeRemoveChild(childRecords, isMove) : [];
    const stm = this.stm; // If it's move then InsertChildAction will handle this case

    if (stm && !stm.disabled && !isMove) {
      // Child records we receive are guaranteed to be direct children
      // of this node, see Core/data/mixin/TreeNode#removeChild method
      // Here we interested in the original index for each child removed,
      // we collect it and store for future use in RemoveChildAction
      preResult.push(childRecords.reduce((result, childRecord) => {
        result.set(childRecord, childRecord.parentIndex);
        return result;
      }, new Map()));
    }

    return preResult;
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to notify {@link Core/data/stm/StateTrackingManager}
   * about children removing. Provides it with all necessary context information collected
   * in {@link #function-beforeRemoveChild} required to undo/redo the action.
   *
   * @private
   */


  afterRemoveChild(childRecords, beforeResult, isMove) {
    const stm = this.stm; // If it's move then InsertChildAction will handle this case

    if (stm && !stm.disabled && !isMove) {
      const context = beforeResult.pop();

      if (childRecords && childRecords.length) {
        stm.onModelRemoveChild(this, childRecords, context);
      }
    }

    super.afterRemoveChild && super.afterRemoveChild(childRecords, beforeResult, isMove);
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/mixin/StoreStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/StoreStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';
/**
* @module Core/data/stm/mixin/StoreStm
*/



const STM_PROP = Symbol('STM_PROP');
/**
 * Store mixin to make it compatible with {@link Core.data.stm.StateTrackingManager}.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreStm extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreStm';
  }

  static get defaultConfig() {
    return {
      /**
       * Reference to STM manager
       *
       * @config {Core.data.stm.StateTrackingManager}
       * @default
       * @category Advanced
       */
      stm: null
    };
  }

  get stm() {
    return this[STM_PROP];
  }

  set stm(stm) {
    const me = this;

    if (me.stm != stm) {
      if (me.stm && me.stm.hasStore(me)) {
        me.stm.removeStore(me);
      }

      me[STM_PROP] = stm;

      if (me.stm && !me.stm.hasStore(me)) {
        me.stm.addStore(me);
      }
    }
  } // Overridden to notify STM about flat add action


  add(records, silent = false) {
    let result;
    const stm = this.stm; // Tree adding is routed via rootNode.appendChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat adding here only, the only data needed to undo/redo the action
      // is the list of records added.
      result = super.add(records, silent); // If adding wasn't vetoed and something has been added then
      // notifying the STM about the fact.

      if (result && result.length) {
        stm.onStoreModelAdd(this, result, silent);
      }
    } else {
      result = super.add(records, silent);
    }

    return result;
  } // Overridden to notify STM about flat insert action


  insert(index, records, silent = false) {
    let result;
    const stm = this.stm; // Tree inserting is routed via rootNode.insertChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat inserting here only, the only data needed to undo/redo the action is:
      // - the list of record inserted
      // - index they are inserted at
      // - index they have been at if they are part of this store already and are moved
      // Here we are getting indices of records which are in this store already
      // not all records might be from this store, some might be new or from another store
      const context = (Array.isArray(records) ? records : [records]).reduce((context, r) => {
        const index = r instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? this.indexOf(r) : undefined;

        if (index !== undefined && index !== -1) {
          context.set(r, index);
        }

        return context;
      }, new Map()); // Result here is the array of Models inserted or undefined,
      // and it might be different from `records` we received as argument.

      result = super.insert(index, records); // Here we check if anything has been actually inserted.
      // The insertion action might be vetoed by event handler or something

      if (result && result.length) {
        // We can't rely on `index` we've got as argument since `result` might
        // differ from records.
        index = this.indexOf(result[0]); // Notifying STM manager about the insertion action providing all
        // the required data to undo/redo.

        stm.onStoreModelInsert(this, index, result, context, silent);
      }
    } else {
      result = super.insert(index, records, silent);
    }

    return result;
  } // Overridden to notify STM about flat removing action


  remove(recordsOrIds, silent = false, fromRemoveChild) {
    let result;
    const stm = this.stm; // Tree removing is routed via rootNode.removeChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat removing here only, the only date needed to undo/redo the actions is:
      // - the list of records removed
      // - their original index to re-insert them back correctly
      const recordsOrIdsNormalized = (Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds]).map(r => this.getById(r)).filter(r => !!r);
      const context = recordsOrIdsNormalized.reduce((context, r) => {
        const index = this.indexOf(r);

        if (index !== undefined && index != -1) {
          context.set(r, index);
        }

        return context;
      }, new Map()); // Calling original store method

      result = super.remove(recordsOrIds, silent, fromRemoveChild); // Here we check if anything has been actually removed.
      // The removing action might be vetoed by event handler or something

      if (result && result.length) {
        stm.onStoreModelRemove(this, result, context, silent);
      }
    } else {
      result = super.remove(recordsOrIds, silent, fromRemoveChild);
    }

    return result;
  } // Overridden to notify STM about flat clear action


  removeAll(silent) {
    const stm = this.stm;
    let result;

    if (stm && !stm.disabled) {
      // Here we are to detect if anything has been removed
      // the only way is to check if store has anything before removing all
      // and has nothing after.
      const {
        tree,
        rootNode,
        allRecords
      } = this,
            wasNotEmpty = allRecords.length,
            // need to store children/records before super method call, otherwise those would report empty list
      records = tree ? rootNode.children.slice() : allRecords.slice();
      result = super.removeAll(silent); // The trick here is to distinguish tree and flat case
      // For the flat case it's simple we just store all records
      // For the tree we are to store root node children only
      // Upon restoring store.add() will do the right thing for the flat case and tree case regardless.

      if (wasNotEmpty && this.count === 0) {
        stm.onStoreRemoveAll(this, records, silent);
      }
    } else {
      result = super.removeAll(silent);
    }

    return result;
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoReadyState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoReadyState.js ***!
  \***************************************************/
/*! exports provided: AutoReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoReadyStateClass", function() { return AutoReadyStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _ReadyState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/AutoReadyState
*/






/**
 * STM transaction autostart ready state class.
 *
 * @internal
 */

class AutoReadyStateClass extends _ReadyState_js__WEBPACK_IMPORTED_MODULE_2__["ReadyStateClass"] {
  onAutoRecordOn() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'readystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction(stm, title) {
    const transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      title: title
    });
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'autorecordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: transaction
    }, () => {
      stm.notifyStoresAboutStateRecordingStart(transaction);
      stm.stopTransactionDelayed();
    }];
  }

  onModelUpdate(stm, model, newData, oldData) {
    stm.startTransaction();
    stm.onModelUpdate(model, newData, oldData);
  }

  onModelInsertChild(stm, parentModel, index, childModels, context) {
    stm.startTransaction();
    stm.onModelInsertChild(parentModel, index, childModels, context);
  }

  onModelRemoveChild(stm, parentModel, childModels, context) {
    stm.startTransaction();
    stm.onModelRemoveChild(parentModel, childModels, context);
  }

  onStoreModelAdd(stm, store, models, silent) {
    stm.startTransaction();
    stm.onStoreModelAdd(store, models, silent);
  }

  onStoreModelInsert(stm, store, index, models, context, silent) {
    stm.startTransaction();
    stm.onStoreModelInsert(store, index, models, silent);
  }

  onStoreModelRemove(stm, store, models, context, silent) {
    stm.startTransaction();
    stm.onStoreModelRemove(store, models, context, silent);
  }

  onStoreRemoveAll(stm, store, allRecords, silent) {
    stm.startTransaction();
    stm.onStoreRemoveAll(store, allRecords, silent);
  }

}
/**
 * STM transaction autostart ready state.
 *
 * @internal
 */

const AutoReadyState = new AutoReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerStmState('autoreadystate', AutoReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoRecordingState.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoRecordingState.js ***!
  \*******************************************************/
/*! exports provided: AutoRecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoRecordingStateClass", function() { return AutoRecordingStateClass; });
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _RecordingState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/AutoRecordingState
*/







/**
 * STM recording state class.
 *
 * @internal
 */

class AutoRecordingStateClass extends _RecordingState_js__WEBPACK_IMPORTED_MODULE_2__["RecordingStateClass"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  onDisable(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]];
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    stm.notifyStoresAboutStateRecordingStop(transaction, {
      disabled: true
    });
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'disabledstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    };
  }

  onAutoRecordOn(stm) {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_1__["throwInvalidMethodCall"])();
  }

  onAutoRecordOff(stm) {
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'recordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["AUTO_RECORD_PROP"]]: false,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    };
  }

  onStopTransaction(stm, title) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]];
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];
    let position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["POS_PROP"]];
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["QUEUE_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    if (transaction.length) {
      if (!transaction.title && !title && stm.getTransactionTitle) {
        transaction.title = stm.getTransactionTitle(transaction);
      } else if (title) {
        transaction.title = title;
      }

      queue[position] = transaction;
      queue.length = ++position;
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'autoreadystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["POS_PROP"]]: position,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    }, () => {
      stm.notifyStoresAboutStateRecordingStop(transaction, {
        stop: true
      });
    }];
  }

  onStopTransactionDelayed(stm) {
    let timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    timer = this.setTimeout(() => {
      stm.stopTransaction();
    }, stm.autoRecordTransactionStopTimeout);
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: AutoRecordingState,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: timer
    };
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_5__["resetQueue"])(stm, options);
  }

  onRejectTransaction(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]],
          timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    }, () => {
      if (transaction.length) {
        transaction.undo();
      }

      return ['autoreadystate', () => {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          rejected: true
        });
      }];
    }];
  }

  onModelUpdate(stm, ...rest) {
    super.onModelUpdate(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onModelInsertChild(stm, ...rest) {
    super.onModelInsertChild(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onModelRemoveChild(stm, ...rest) {
    super.onModelRemoveChild(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelAdd(stm, ...rest) {
    super.onStoreModelAdd(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelInsert(stm, ...rest) {
    super.onStoreModelInsert(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelRemove(stm, ...rest) {
    super.onStoreModelRemove(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreRemoveAll(stm, ...rest) {
    super.onStoreRemoveAll(stm, ...rest);
    stm.stopTransactionDelayed();
  }

}
/**
 * STM recording state.
 *
 * @internal
 */

const AutoRecordingState = new AutoRecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoRecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerStmState('autorecordingstate', AutoRecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/DisabledState.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/state/DisabledState.js ***!
  \**************************************************/
/*! exports provided: DisabledStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisabledStateClass", function() { return DisabledStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/DisabledState
*/





/**
 * STM disabled state class.
 *
 * @internal
 */

class DisabledStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onUndo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRedo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onEnable(stm) {
    return stm.autoRecord ? 'autoreadystate' : 'readystate';
  }

  onDisable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["resetQueue"])(stm, options);
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM disabled state.
 *
 * @internal
 */

const DisabledState = new DisabledStateClass();
/* harmony default export */ __webpack_exports__["default"] = (DisabledState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('disabledstate', DisabledState);

/***/ }),

/***/ "./lib/Core/data/stm/state/ReadyState.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/state/ReadyState.js ***!
  \***********************************************/
/*! exports provided: ReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadyStateClass", function() { return ReadyStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/ReadyState
*/






/**
 * STM ready state class.
 *
 * @internal
 */

class ReadyStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo(stm) {
    //      v
    // |*|*|
    return 0 < stm.position && stm.position <= stm.length;
  }

  canRedo(stm) {
    //  v
    // |*|*|
    return 0 <= stm.position && stm.position < stm.length;
  }

  onUndo(stm, steps) {
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]];
    let curPos = stm.position,
        newPos = Math.max(0, curPos - steps);

    const next = () => {
      stm.notifyStoresAboutStateRestoringStart();

      while (curPos != newPos) {
        queue[--curPos].undo();
      }

      return [stm.autoRecord ? 'autoreadystate' : 'readystate', () => {
        stm.notifyStoresAboutStateRestoringStop();
      }];
    };

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"]]: newPos
    }, next];
  }

  onRedo(stm, steps) {
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]];
    let curPos = stm.position,
        newPos = Math.min(queue.length, curPos + steps);

    const next = () => {
      stm.notifyStoresAboutStateRestoringStart();

      do {
        queue[curPos++].redo();
      } while (curPos != newPos);

      return [stm.autoRecord ? 'autoreadystate' : 'readystate', () => {
        stm.notifyStoresAboutStateRestoringStop();
      }];
    };

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"]]: newPos
    }, next];
  }

  onEnable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onDisable() {
    return 'disabledstate';
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'autoreadystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStartTransaction(stm, title) {
    const transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      title: title
    });
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'recordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["TRANSACTION_PROP"]]: transaction
    }, () => {
      stm.notifyStoresAboutStateRecordingStart(transaction);
    }];
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["resetQueue"])(stm, options);
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM ready state.
 *
 * @internal
 */

let ReadyState = new ReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (ReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerStmState('readystate', ReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/RecordingState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RecordingState.js ***!
  \***************************************************/
/*! exports provided: RecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecordingStateClass", function() { return RecordingStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/RecordingState
*/





/**
 * STM recording state class.
 *
 * @internal
 */

class RecordingStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onEnable() {}

  onDisable(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    stm.notifyStoresAboutStateRecordingStop(transaction, {
      disabled: true
    });
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'disabledstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    };
  }

  onAutoRecordOn(stm) {
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'autorecordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    }, () => {
      stm.stopTransactionDelayed();
    }];
  }

  onAutoRecordOff() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction(stm, title) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    let position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"]];
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"]];

    if (transaction.length) {
      if (!transaction.title && !title && stm.getTransactionTitle) {
        transaction.title = stm.getTransactionTitle(transaction);
      } else if (title) {
        transaction.title = title;
      }

      queue[position] = transaction;
      queue.length = ++position;
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'readystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"]]: position,
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    }, () => {
      stm.notifyStoresAboutStateRecordingStop(transaction, {
        stop: true
      });
    }];
  }

  onRejectTransaction(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    }, () => {
      if (transaction.length) {
        transaction.undo();
      }

      return ['readystate', () => {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          rejected: true
        });
      }];
    }];
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["resetQueue"])(stm, options);
  }

  onModelUpdate(stm, model, newData, oldData) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelUpdateAction(model, newData, oldData));
  }

  onModelInsertChild(stm, parentModel, index, childModel, previousParent, previousIndex) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelInsertChildAction(parentModel, index, childModel, previousParent, previousIndex));
  }

  onModelRemoveChild(stm, parentModel, childModels, context) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelRemoveChildAction(parentModel, childModels, context));
  }

  onStoreModelAdd(stm, store, models, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelAddAction(store, models, silent));
  }

  onStoreModelInsert(stm, store, index, models, context, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelInsertAction(store, index, models, context, silent));
  }

  onStoreModelRemove(stm, store, models, context, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelRemoveAction(store, models, context, silent));
  }

  onStoreRemoveAll(stm, store, allRecords, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreRemoveAllAction(store, allRecords, silent));
  }

}
/**
 * STM recording state.
 *
 * @internal
 */

const RecordingState = new RecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('recordingstate', RecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/Registry.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/state/Registry.js ***!
  \*********************************************/
/*! exports provided: registerStmState, resolveStmState, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStmState", function() { return registerStmState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveStmState", function() { return resolveStmState; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
var productName = 'gantt';

/**
 * @module Core/data/stm/state/Registry
 *
 * Provides map of registered STM states.
 *
 * Needed to remove states circular dependency.
 *
 * @internal
 */

const registry = new Map();
/**
 * Registers STM state class with the given name.
 *
 * @private
 *
 * @param {String} name
 * @param {Core.data.stm.state.StateBase} state
 */

const registerStmState = (name, state) => {
  registry.set(name, state);
};
/**
 * Resolves STM state class with the given name.
 *
 * @private
 *
 * @param {String} name
 * @return {Core.data.stm.state.StateBase} state
 */

const resolveStmState = state => {
  if (typeof state === 'string') {
    state = registry.get(state);
  }

  return state;
}; // UMD/module compatible export
// NOTE: the most compatible way of exporting is:
//       import registry from './Registry.js';
//       { registerStmState, resolveStmState } = registry;
//          or
//       registry.registerStmState(...);

/* harmony default export */ __webpack_exports__["default"] = ({
  registerStmState,
  resolveStmState
});

/***/ }),

/***/ "./lib/Core/data/stm/state/RestoringState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RestoringState.js ***!
  \***************************************************/
/*! exports provided: RestoringStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestoringStateClass", function() { return RestoringStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/RestoringState
*/




/**
 * STM restoring state class.
 *
 * @internal
 */

class RestoringStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onUndo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRedo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onEnable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onDisable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onQueueReset() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM restoring state.
 *
 * @internal
 */

const RestoringState = new RestoringStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RestoringState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('restoringstate', RestoringState);

/***/ }),

/***/ "./lib/Core/data/stm/state/StateBase.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/stm/state/StateBase.js ***!
  \**********************************************/
/*! exports provided: throwAbstractMethodCall, throwInvalidMethodCall, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwAbstractMethodCall", function() { return throwAbstractMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwInvalidMethodCall", function() { return throwInvalidMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateBase; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
/**
* @module Core/data/stm/state/StateBase
*/


const throwAbstractMethodCall = () => {
  throw new Error('Abstract method call!');
};
const throwInvalidMethodCall = () => {
  throw new Error('Method cannot be called at this state!');
};
/**
 * Abstract class for STM states
 *
 * Every on* method should return a state for the STM which it should switch to
 * or throw an exception that this call at this state is illegal.
 *
 * Interface of this class mirrors interface of {@link Core.data.stm.StateTrackingManager}.
 *
 * @abstract
 */

class StateBase extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo(stm) {
    throwAbstractMethodCall();
  }

  canRedo(stm) {
    throwAbstractMethodCall();
  }

  onUndo(stm) {
    throwAbstractMethodCall();
  }

  onRedo(stm) {
    throwAbstractMethodCall();
  }

  onStartTransaction(stm) {
    throwAbstractMethodCall();
  }

  onStopTransaction(stm) {
    throwAbstractMethodCall();
  }

  onStopTransactionDelayed(stm) {
    throwAbstractMethodCall();
  }

  onRejectTransaction(stm) {
    throwAbstractMethodCall();
  }

  onEnable(stm) {
    throwAbstractMethodCall();
  }

  onDisable(stm) {
    throwAbstractMethodCall();
  }

  onAutoRecordOn(stm) {
    throwAbstractMethodCall();
  }

  onAutoRecordOff(stm) {
    throwAbstractMethodCall();
  }

  onResetQueue(stm) {
    throwAbstractMethodCall();
  }

  onModelUpdate(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelAdd(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelInsert(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelRemove(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelRemoveAll(stm) {
    throwAbstractMethodCall();
  }

  onModelInsertChild(stm) {
    throwAbstractMethodCall();
  }

  onModelRemoveChild(stm) {
    throwAbstractMethodCall();
  }

}
StateBase._$name = 'StateBase';

/***/ }),

/***/ "./lib/Core/feature/base/ContextMenuBase.js":
/*!**************************************************!*\
  !*** ./lib/Core/feature/base/ContextMenuBase.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContextMenuBase; });
/* harmony import */ var _mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';








/**
 * @module Core/feature/base/ContextMenuBase
 */

/**
 * Abstract base class used by other context menu features.
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

class ContextMenuBase extends _mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ContextMenuBase';
  } //region Config


  static get configurable() {
    return {
      /**
       * This is a type of the context menu used to generate correct names for methods and events.
       * Should be in camel case. Required to be set in subclass.
       * @config {String}
       * @readonly
       */
      type: null,

      /**
       * Gets the Menu instance that this feature is using.
       * @member {Core.widget.Menu} menu
       * @readonly
       */

      /**
       * A config which will be applied when creating the Menu component.
       * @config {Object}
       */
      menu: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'menu',
          autoShow: false,
          closeAction: 'hide',
          scrollAction: 'hide',
          constrainTo: window
        }
      },

      /**
       * A config which will be applied when creating the Menu component.
       * @config {Object}
       * @deprecated 4.0.5 Use {@link #config-menu} instead.
       */
      menuConfig: null,

      /**
       * {@link Core.widget.Menu Menu} items object containing named child menu items to apply to the feature's
       * provided context menu.
       *
       * This may add extra items as below, but may also remove any of the default items by configuring the name
       * of the item as `false`
       *
       * ```javascript
       * features : {
       *     cellMenu : {
       *         // This object is applied to the Feature's predefined default items
       *         items : {
       *             switchToDog : {
       *                 text : 'Dog',
       *                 icon : 'b-fa b-fa-fw b-fa-dog',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = true;
       *                     contextRecord.cat = false;
       *                 },
       *                 weight : 500     // Make this second from end
       *             },
       *             switchToCat : {
       *                 text : 'Cat',
       *                 icon : 'b-fa b-fa-fw b-fa-cat',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = false;
       *                     contextRecord.cat = true;
       *                 },
       *                 weight : 510     // Make this sink to end
       *             },
       *             add : false // We do not want the "Add" submenu to be available
       *         }
       *     }
       * }
       * ```
       *
       * @config {Object}
       */
      items: {},

      /**
       * Event which is used to show context menu.
       * Available options are: 'contextmenu', 'click', 'dblclick' or `false` to disable.
       * Default value is used from {@link Grid/view/GridBase#config-contextMenuTriggerEvent}
       * @config {String|Boolean}
       */
      triggerEvent: false
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.
  // The contextmenu event is emulated from a taphold gesture on touch platforms.


  static get pluginConfig() {
    return {
      assign: ['showContextMenu'],
      chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
    };
  } //endregion
  //region Init


  construct(...args) {
    var _this$type;

    const config = args[args.length === 1 ? 0 : 1]; // Copy deprecated config into its correct place.

    if (config && 'menuConfig' in config) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].deprecate('Grid', '5.0.0', '`menuConfig` attribute deprecated, in favour of `menu`');
      config.menu = config.menuConfig;
    }

    super.construct(...args);

    if (!((_this$type = this.type) !== null && _this$type !== void 0 && _this$type.length)) {
      throw new Error(`Config 'type' is required to be specified for context menu`);
    }
  } //endregion
  //region Events

  /**
   * This event fires on the owning widget when an item is selected in the context menu.
   * @event contextMenuItem
   * @on-owner
   * @param {Core.widget.Widget} source The owning widget
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   */

  /**
   * This event fires on the owning widget when a check item is toggled in the context menu.
   * @event contextMenuToggleItem
   * @on-owner
   * @param {Core.widget.Widget} source The owning widget
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   * @param {Boolean} checked Checked or not
   */


  onElementContextMenu(event) {
    this.onElementEvent(event);
  }

  onElementClick(event) {
    this.onElementEvent(event);
  }

  onElementDblClick(event) {
    this.onElementEvent(event);
  }

  onElementEvent(event) {
    this.triggerEvent === event.type && this.internalShowContextMenu(event);
  }

  onElementKeyDown(event) {} //endregion
  //region Menu handlers


  internalShowContextMenu(event) {
    const me = this;

    if (me.disabled) {
      return;
    }

    const data = me.getDataFromEvent(event);

    if (me.shouldShowMenu(data)) {
      me.showContextMenu(data);
    }
  }

  getDataFromEvent(event) {
    return {
      event,
      targetElement: this.getTargetElementFromEvent(event)
    };
  }

  getTargetElementFromEvent(event) {
    return event.target;
  }
  /**
   * Shows the context menu.
   * @param {Event} event The initiating event.
   * @param {Object|HTMLElement} [alignSpec] Menu alignment specification, or an element to align to
   * @param {HTMLElement|Core.helper.util.Rectangle} alignSpec.target The Element or Rectangle to align to.
   * @param {Boolean} [alignSpec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
   * @param {Boolean} [alignSpec.overlap] True to allow this to overlap the target.
   * @param {String} alignSpec.align The alignment specification string, `[trbl]n-[trbl]n`.
   * @on-owner
   */


  showContextMenu(domEvent, alignSpec) {
    var _me$_menu;

    const me = this,
          menuContext = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isDOMEvent(domEvent) ? me.getDataFromEvent(domEvent) : domEvent; // If our menu was visible from last invocation, hide it.
    // Apps may need the ${type}MenuShow event which is triggered in onShow.

    (_me$_menu = me._menu) === null || _me$_menu === void 0 ? void 0 : _me$_menu.hide();

    if (me.disabled) {
      return;
    }
    /**
     * @member {Object} menuContext
     * An informational object containing contextual information about the last activation
     * of the context menu. The base properties are listed below. Some subclasses may add extra
     * contextual information such as `eventRecord` and `resourceRecord` to the block.
     * @property {Event} menuContext.event The initiating event.
     * @property {Number[]} menuContext.point The client `X` and `Y` position of the initiating event.
     * @property {HTMLElement} menuContext.targetElement The target to which the menu is being applied.
     * @property {Object} menuContext.items The context menu **configuration** items.
     * @property {Core.data.Model[]} menuContext.selection The record selection in the client (Grid, Scheduler, Gantt or Calendar).
     * @readonly
     */


    me.menuContext = menuContext;
    const {
      type,
      client,
      processItems
    } = me,
          {
      event
    } = menuContext,
          elCenter = event !== null && event !== void 0 ? event : _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(menuContext.targetElement).center;
    _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(menuContext, {
      point: event ? [event.clientX + 1, event.clientY + 1] : [elCenter.x, elCenter.y],
      menu: me,
      items: {},
      selection: me.client.selectedRecords
    }); // Call the chainable method which other features use to add or remove their own menu items.

    me.callChainablePopulateMenuMethod(menuContext); // Merge with user defined items

    _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(menuContext.items, me.baseItems); // Allow user a chance at processing the items and preventing the menu from showing

    if ((!processItems || processItems(menuContext) !== false) && me.hasActiveMenuItems(menuContext)) {
      me.populateItemsWithData(menuContext);
      me.preventDefaultEvent(menuContext); // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to preprocess the event.

      if (me.beforeContextMenuShow(menuContext) !== false) {
        // Trigger event that allows preventing menu or manipulating its items
        if (client.trigger(`${type}MenuBeforeShow`, menuContext) !== false && // TODO: cellContextMenuBeforeShow and headerContextMenuBeforeShow events are deprecated in ContextMenu feature
        client.trigger(`${type}ContextMenuBeforeShow`, menuContext) !== false) {
          var _me$touchMoveDetacher;

          me.menu.items = menuContext.items;

          if (alignSpec) {
            me.menu.showBy(alignSpec);
          } else {
            me.menu.showByPoint(menuContext.point);
          } // Any drag drop type action should hide the menu


          (_me$touchMoveDetacher = me.touchMoveDetacher) === null || _me$touchMoveDetacher === void 0 ? void 0 : _me$touchMoveDetacher.call(me);
          me.touchMoveDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].on({
            element: client.element,
            touchmove: () => me.menu.hide(),
            once: true
          });
        }
      }
    }
  }
  /**
   * Returns the base, configured-in menu items set from the configured items, taking into
   * account the namedItems the feature offers.
   * @property {Object[]}
   * @readonly
   * @internal
   */


  get baseItems() {
    if (!this._baseItems) {
      const me = this,
            {
        namedItems
      } = me,
            baseItems = me._baseItems = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, me.items); // Substitute any named items into any of our items that reference them.

      for (const ref in baseItems) {
        const item = baseItems[ref];

        if (item) {
          // If this class or instance has a "namedItems" object
          // named by this ref, then use it as the basis for the item
          if (namedItems && ref in namedItems) {
            baseItems[ref] = typeof item === 'object' ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(namedItems[ref]), item) : namedItems[ref];
          } else if (item === true) {
            delete baseItems[ref];
          }
        }
      }
    }

    return this._baseItems;
  }
  /**
   * Hides the context menu
   * @internal
   */


  hideContextMenu(animate) {
    var _this$menu;

    (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.hide(animate);
  }

  callChainablePopulateMenuMethod(eventParams) {
    var _this$client$, _this$client;

    // For example `populateCellMenu`
    (_this$client$ = (_this$client = this.client)[`populate${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].capitalize(this.type)}Menu`]) === null || _this$client$ === void 0 ? void 0 : _this$client$.call(_this$client, eventParams);
  }

  createContextMenuEventForElement(targetElement) {
    const targetPoint = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(targetElement).center,
          contextmenuEvent = new MouseEvent(this.triggerEvent, {
      clientX: targetPoint.x,
      clientY: targetPoint.y
    });
    Object.defineProperty(contextmenuEvent, 'target', {
      get() {
        return targetElement;
      }

    });
    return contextmenuEvent;
  }

  hasActiveMenuItems(eventParams) {
    return Object.values(eventParams.items).some(item => item);
  }
  /**
   * Override this function and return `false` to prevent the context menu from being shown. Returns `true` by default.
   * @return {Boolean}
   * @internal
   */


  shouldShowMenu() {
    return true;
  }

  beforeContextMenuShow(eventParams) {}

  populateItemsWithData(eventParams) {}

  preventDefaultEvent(eventParams) {
    var _eventParams$event;

    (_eventParams$event = eventParams.event) === null || _eventParams$event === void 0 ? void 0 : _eventParams$event.preventDefault();
  } //endregion
  //region Configurables


  changeTriggerEvent(triggerEvent) {
    return triggerEvent || this.client.contextMenuTriggerEvent;
  }

  changeMenu(menu, oldMenu) {
    const me = this,
          {
      client,
      type
    } = me;

    if (menu) {
      return _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(oldMenu, menu ? _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].mergeConfigs({
        owner: client,
        rootElement: client.rootElement,

        onItem(itemEvent) {
          client.trigger(`${type}MenuItem`, itemEvent); // TODO: contextMenuItem event is deprecated in ContextMenu feature

          client.trigger('contextMenuItem', itemEvent); // TODO: eventContextMenuItem event and schedulerContextMenuItem event are deprecated

          client.trigger(`${type}ContextMenuItem`, itemEvent);
        },

        onToggle(itemEvent) {
          client.trigger(`${type}MenuToggleItem`, itemEvent); // TODO: contextMenuToggleItem event is deprecated in ContextMenu feature

          client.trigger('contextMenuToggleItem', itemEvent);
        },

        onDestroy() {
          me.menu = null;
        },

        // Load up the item event with the contextual info
        onBeforeItem(itemEvent) {
          Object.assign(itemEvent, me.menuContext);
        },

        onShow({
          source: menu
        }) {
          me.menuContext.menu = menu;
          client.trigger(`${type}MenuShow`, me.menuContext); // TODO: cellContextMenuShow and headerContextMenuShow events are deprecated in ContextMenu feature

          client.trigger(`${type}ContextMenuShow`, me.menuContext);
        }

      }, menu) : null, me);
    } else if (oldMenu !== null && oldMenu !== void 0 && oldMenu.isWidget) {
      oldMenu.destroy();
    }
  } //endregion


}
ContextMenuBase._$name = 'ContextMenuBase';

/***/ }),

/***/ "./lib/Core/helper/AjaxHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/AjaxHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxHelper; });
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var _BrowserHelper$queryS;

var productName = 'gantt';
/**
* @module Core/helper/AjaxHelper
*/



const paramValueRegExp = /^(\w+)=(.*)$/,
      // For CodePens, adjust URLs to be absolute
resourceRoot = ((_BrowserHelper$queryS = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].queryString) === null || _BrowserHelper$queryS === void 0 ? void 0 : _BrowserHelper$queryS.__resourceRoot) || '',
      parseParams = function (paramString) {
  const result = {},
        params = paramString.split('&'); // loop through each 'filter={"field":"name","operator":"=","value":"Sweden","caseSensitive":true}' string
  // So we cannot use .split('=')

  for (const nameValuePair of params) {
    const [match, name, value] = paramValueRegExp.exec(nameValuePair),
          decodedName = decodeURIComponent(name),
          decodedValue = decodeURIComponent(value);

    if (match) {
      let paramValue = result[decodedName];

      if (paramValue) {
        if (!Array.isArray(paramValue)) {
          paramValue = result[decodedName] = [paramValue];
        }

        paramValue.push(decodedValue);
      } else {
        result[decodedName] = decodedValue;
      }
    }
  }

  return result;
};
/**
 * Simplifies Ajax requests. Uses fetch & promises.
 *
 * ```javascript
 * AjaxHelper.get('some-url').then(response => {
 *     // process request response here
 * });
 * ```
 *
 * Uploading file to server via FormData interface.
 * Please visit [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData) for details.
 *
 * ```javascript
 * const formData = new FormData();
 * formData.append('file', 'fileNameToUpload');
 * AjaxHelper.post('file-upload-url', formData).then(response => {
 *     // process request response here
 * });
 * ```
 *
 */


class AjaxHelper {
  /**
   * Make a request (using GET) to the specified url.
   * @param {String} url Url
   * @param {Object} [options] The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */
  static get(url, options) {
    return this.fetch(url, options);
  }
  /**
   * POST data to the specified URL.
   * @param {String} url The URL
   * @param {String|Object|FormData} payload The data to post. If an object is supplied, it will be stringified
   * @param {Object} options The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */


  static post(url, payload, options = {}) {
    if (!(payload instanceof FormData) && !(typeof payload === 'string')) {
      payload = JSON.stringify(payload);
      options.headers = options.headers || {};
      options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/json';
    }

    return this.fetch(url, Object.assign({
      method: 'POST',
      body: payload
    }, options));
  }
  /**
   * Fetch the specified resource using the `fetch` API.
   * @param {String} url object to fetch
   * @param {Object} options The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.method] The request method, e.g., GET, POST
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */


  static fetch(url, options = {}) {
    let controller; // AbortController is not supported by LockerService
    // https://github.com/bryntum/support/issues/3689

    if (typeof AbortController !== 'undefined') {
      controller = new AbortController(); // Need to assign AbortController individually, because IE11 polyfill of the Fetch API deletes 'signal' property on fetchOptions object

      Object.assign(options, {
        abortController: controller,
        signal: controller.signal
      });
    }

    if (!('credentials' in options)) {
      options.credentials = 'include';
    }

    if (options.queryParams) {
      const params = Object.entries(options.queryParams);

      if (params.length) {
        url += (url.includes('?') ? '&' : '?') + params.map(([param, value]) => `${param}=${encodeURIComponent(value)}`).join('&');
      }
    } // Promise that will be resolved either when network request is finished or when json is parsed


    const promise = new Promise((resolve, reject) => {
      fetch(resourceRoot + url, options).then(response => {
        if (options.parseJson) {
          response.json().then(json => {
            response.parsedJson = json;
            resolve(response);
          }).catch(error => {
            response.parsedJson = null;
            response.error = error;
            reject(response);
          });
        } else {
          resolve(response);
        }
      }).catch(error => {
        error.stack = promise.stack; // Unless calling code aborted the request, reject this operation

        if (error.name !== 'AbortError') {
          reject(error);
        }
      });
    });
    promise.stack = new Error().stack;

    promise.abort = function () {
      var _controller;

      (_controller = controller) === null || _controller === void 0 ? void 0 : _controller.abort();
    };

    return promise;
  }
  /**
   * Registers the passed URL to return the passed mocked up Fetch Response object to the
   * AjaxHelper's promise resolve function.
   * @param {String} url The url to return mock data for
   * @param {Object|Function} response A mocked up Fetch Response object which must contain
   * at least a `responseText` property, or a function to which the `url` and a `params` object
   * and the `Fetch` `options` object is passed which returns that.
   * @param {String} response.responseText The data to return.
   * @param {Boolean} [response.synchronous] resolve the Promise immediately
   * @param {Number} [response.delay=100] resolve the Promise after this number of milliseconds.
   */


  static mockUrl(url, response) {
    const me = this;
    (me.mockAjaxMap || (me.mockAjaxMap = {}))[url] = response; // Inject the override into the AjaxHelper instance

    if (!AjaxHelper.originalFetch) {
      AjaxHelper.originalFetch = AjaxHelper.fetch;
    }

    AjaxHelper.fetch = me.mockAjaxFetch.bind(me);
  }

  static mockAjaxFetch(url, options) {
    let urlAndParams = url.split('?'),
        result = this.mockAjaxMap[urlAndParams[0]],
        parsedJson = null;

    if (result) {
      if (typeof result === 'function') {
        result = result(urlAndParams[0], urlAndParams[1] && parseParams(urlAndParams[1]), options);
      }

      try {
        parsedJson = options.parseJson && JSON.parse(result.responseText);
      } catch (error) {
        parsedJson = null;
        result.error = error;
      }

      result = Object.assign({
        status: 200,
        ok: true,
        headers: new Headers(),
        statusText: 'OK',
        url: url,
        parsedJson: parsedJson,
        text: () => new Promise(resolve => {
          resolve(result.responseText);
        }),
        json: () => new Promise(resolve => {
          resolve(parsedJson);
        })
      }, result);
      return new Promise(function (resolve, reject) {
        if (result.synchronous) {
          resolve(result);
        } else {
          setTimeout(function () {
            resolve(result);
          }, 'delay' in result ? result.delay : 100);
        }
      });
    } else {
      return AjaxHelper.originalFetch(url, options);
    }
  }

}
AjaxHelper._$name = 'AjaxHelper';

/***/ }),

/***/ "./lib/Core/helper/ArrayHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/ArrayHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ArrayHelper; });
var productName = 'gantt';
/**
* @module Core/helper/ArrayHelper
*/

/**
 * Helper with useful functions for handling Arrays
 * @internal
 */

class ArrayHelper {
  static clean(array) {
    return array.reduce((res, item) => {
      if (item !== null && item !== undefined && !(Array.isArray(item) && item.length === 0) && item !== '') res.push(item);
      return res;
    }, []);
  }
  /**
   * Similar to [`Array.from()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from)
   * this method creates an array from an `iterable` object. Where `Array.from()` accepts a mapper function as the
   * second argument, this method accepts a `filter` function as its second argment. If a mapper function is also
   * needed, it can be passed as the third argument. Unlike `Array.from()`, if this method is passed `null`, it will
   * return an empty array.
   * @param {Array} iterable The iterable object to convert (must support `for-of` loop iteration).
   * @param {Function} [filter] A function to apply to each item of the `iterable` which must return a truthy value
   * to include that item in the resulting array.
   * @param {Function} [map] A function to apply to each item of the `iterable` that returns the actual value to put
   * into the returned array. If a `filter` is also supplied, this method is only called for those items that pass
   * the filter test.
   * @returns {Array}
   */


  static from(iterable, filter, map) {
    const array = [];

    if (iterable) {
      for (const it of iterable) {
        if (!filter || filter(it)) {
          array.push(map ? map(it) : it);
        }
      }
    }

    return array;
  }
  /**
   * Remove one or more items from an array
   * @param {Array} array Array to remove from
   * @param {Object} items One or more items to remove
   * @returns {Boolean} Returns true if any item was removed
   */


  static remove(array, ...items) {
    let index,
        item,
        removed = false;

    for (let i = 0; i < items.length; i++) {
      item = items[i];

      if ((index = array.indexOf(item)) !== -1) {
        array.splice(index, 1);
        removed = true;
      }
    }

    return removed;
  }
  /*
   * Calculates the insertion index of a passed object into the passed Array according
   * to the passed comparator function. Note that the passed Array *MUST* already be ordered.
   * @param {Object} item The item to calculate the insertion index for.
   * @param {Array} The array into which the item is to be inserted.
   * @param {Function} comparatorFn The comparison function. Must return -1 or 0 or 1.
   * @param {Object} comparatorFn.lhs The left object to compare.
   * @param {Object} comparatorFn.rhs The right object to compare.
   * @param {Number} index The possible correct index to try first before a binary
   * search is instigated.
   */


  static findInsertionIndex(item, array, comparatorFn = this.lexicalCompare, index) {
    const len = array.length;
    let beforeCheck, afterCheck;

    if (index < len) {
      beforeCheck = index > 0 ? comparatorFn(array[index - 1], item) : 0;
      afterCheck = index < len - 1 ? comparatorFn(item, array[index]) : 0;

      if (beforeCheck < 1 && afterCheck < 1) {
        return index;
      }
    }

    return this.binarySearch(array, item, comparatorFn);
  }
  /**
   * Similar to the native Array.find call, but this finds the *last* element in the array for which
   * the passed function returns a truthy value.
   * @param {Object[]} array The array to find in.
   * @param {Function} fn The testing function.
   * @param {Object} [thisObj] The scope (`this` reference) in which to call the function.
   */


  static findLast(array, fn, thisObj) {
    for (let {
      length
    } = array, i = length - 1; i >= 0; i--) {
      if (fn.call(thisObj, array[i], i, array)) {
        return array[i];
      }
    }
  }
  /**
   * This method returns the index that a given item would be inserted into the
   * given (sorted) `array`. Note that the given `item` may or may not be in the
   * array. This method will return the index of where the item *should* be.
   *
   * For example:
   *
   *      var array = [ 'A', 'D', 'G', 'K', 'O', 'R', 'X' ];
   *      var index = ArrayHelper.binarySearch(array, 'E');
   *
   *      console.log('index: ' + index);
   *      // logs "index: 2"
   *
   *      array.splice(index, 0, 'E');
   *
   *      console.log('array : ' + array.join(''));
   *      // logs "array: ADEGKORX"
   *
   * @param {Object[]} array The array to search.
   * @param {Object} item The item that you want to insert into the `array`.
   * @param {Number} [begin=0] The first index in the `array` to consider.
   * @param {Number} [end=array.length] The index that marks the end of the range
   * to consider. The item at this index is *not* considered.
   * @param {Function} [compareFn] The comparison function that matches the sort
   * order of the `array`. The default `compareFn` compares items using less-than
   * and greater-than operators.
   * @return {Number} The index for the given item in the given array based on
   * the passed `compareFn`.
   */


  static binarySearch(array, item, begin = 0, end = array.length, compareFn = this.lexicalCompare) {
    const length = array.length;
    let middle, comparison;

    if (begin instanceof Function) {
      compareFn = begin;
      begin = 0;
    } else if (end instanceof Function) {
      compareFn = end;
      end = length;
    }

    --end;

    while (begin <= end) {
      middle = begin + end >> 1;
      comparison = compareFn(item, array[middle]);

      if (comparison >= 0) {
        begin = middle + 1;
      } else if (comparison < 0) {
        end = middle - 1;
      }
    }

    return begin;
  }

  magnitudeCompare(lhs, rhs) {
    return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
  }

  lexicalCompare(lhs, rhs) {
    lhs = String(lhs);
    rhs = String(rhs);
    return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
  }
  /**
   * Similar to Array.prototype.fill(), but constructs a new array with the specified item count and fills it with
   * clones of the supplied item.
   * @param {Number} count Number of entries to create
   * @param {Object|Array} itemOrArray Item or array of items to clone (uses object spread to create shallow clone)
   * @param {Function} [fn] An optional function that is called for each item added, to allow processing
   * @returns {Array} A new populated array
   */


  static fill(count, itemOrArray = {}, fn = null) {
    const result = [],
          items = Array.isArray(itemOrArray) ? itemOrArray : [itemOrArray];

    for (let i = 0; i < count; i++) {
      for (const item of items) {
        // Using object spread here forces us to use more babel plugins and will make
        // react_typescript demo very difficult to setup
        const processedItem = Object.assign({}, item);

        if (fn) {
          fn(processedItem, i);
        }

        result.push(processedItem);
      }
    }

    return result;
  }
  /**
   * Populates an array with the return value from `fn`.
   * @param {Number} count Number of entries to create
   * @param {Function} fn A function that is called `count` times, return value is added to array
   * @param {Number} fn.index Current index in the array
   * @privateparam {Boolean} [oneBased] Add 1 to the index before calling the fn (making it 1 based)
   * @returns {Array} A new populated array
   */


  static populate(count, fn, oneBased = false) {
    const items = [];

    for (let i = 0; i < count; i++) {
      items.push(fn(i + (oneBased ? 1 : 0)));
    }

    return items;
  }
  /**
   * Pushes `item` on to the `array` if not already included
   * @param {Array}  array Array to push to
   * @param {Object} item Item to push if not already included
   */


  static include(array, item) {
    if (!array.includes(item)) {
      array.push(item);
    }
  }
  /**
   * Returns a new array with the unique items from the supplied array.
   * @param {Array} array Input array
   * @returns {Array} New array with unique items
   */


  static unique(array) {
    return [...new Set(array)];
  } // Wanted to create an indexer on Stores, based on this. But turns out Proxy cannot be transpiled/polyfill for IE11
  // Keeping it for future reference


  static allowNegative(array) {
    // From https://github.com/sindresorhus/negative-array
    return new Proxy(array, {
      get(target, name, receiver) {
        if (typeof name !== 'string') {
          return Reflect.get(target, name, receiver);
        }

        const index = Number(name);

        if (Number.isNaN(index)) {
          return Reflect.get(target, name, receiver);
        }

        return target[index < 0 ? target.length + index : index];
      },

      set(target, name, value, receiver) {
        if (typeof name !== 'string') {
          return Reflect.set(target, name, value, receiver);
        }

        const index = Number(name);

        if (Number.isNaN(index)) {
          return Reflect.set(target, name, value, receiver);
        }

        target[index < 0 ? target.length + index : index] = value;
        return true;
      }

    });
  }

  static delta(a, b, useRelativeNaming = false) {
    // Nicer syntax but about 40% slower (an extra iteration)
    // const
    //     onlyInA = a.filter(item => !b.includes(item)),
    //     onlyInB = b.filter(item => !a.includes(item)),
    //     inBoth  = a.filter(item => b.includes(item));
    // Quick bailout for nonexisting target array
    if (!b) {
      return useRelativeNaming ? {
        toAdd: a,
        toRemove: [],
        toKeep: []
      } : {
        onlyInA: a,
        onlyInB: [],
        inBoth: []
      };
    }

    const onlyInA = [],
          onlyInB = [],
          inBoth = [];

    for (let i = 0; i < a.length; i++) {
      const item = a[i];

      if (b.includes(item)) {
        inBoth.push(item);
      } else {
        onlyInA.push(item);
      }
    }

    for (let i = 0; i < b.length; i++) {
      const item = b[i];

      if (!inBoth.includes(item)) {
        onlyInB.push(item);
      }
    }

    if (useRelativeNaming) {
      return {
        toAdd: onlyInA,
        toRemove: onlyInB,
        toKeep: inBoth
      };
    }

    return {
      onlyInA,
      onlyInB,
      inBoth
    };
  }

} // This has been tested on IE11 but not pre-webkit Edge

(count => {
  const array = new Array(count),
        buckets = {};
  let i, k, unstable, v;

  for (i = 0; i < count; ++i) {
    array[i] = [Math.floor(Math.random() * 3) + 1, i + 1]; // [1..3, 1..count]
  }

  array.sort((a, b) => a[0] - b[0]);

  for (i = 0; i < count && !unstable; ++i) {
    [k, v] = array[i];
    unstable = buckets[k] > v;
    buckets[k] = v;
  }

  if (unstable) {
    const {
      prototype
    } = Array,
          {
      sort: nativeSort
    } = prototype,
          compare = (a, b) => a < b ? -1 : b < a ? 1 : 0,
          sort = function sort(compareFn) {
      const me = this,
            len = me.length;
      let i, temp;

      if (len > 1) {
        temp = new Array(len);

        for (i = len; i-- > 0;) {
          temp[i] = i;
        }

        compareFn = compareFn || compare;
        nativeSort.call(temp, (i1, i2) => compareFn(me[i1], me[i2]) || i1 - i2); // we cannot do this directly into array since we may overwrite an element before putting it into
        // the correct spot:

        for (i = len; i-- > 0;) {
          temp[i] = me[temp[i]];
        }

        for (i = len; i-- > 0;) {
          me[i] = temp[i];
        }
      }

      return me;
    };

    Object.defineProperty(prototype, 'sort', {
      configurable: true,
      value: sort
    });
  } // Edge's JS engine (pre-webkit) has a threshold of 512 before it goes unstable, so use a number beyond that:

})(600);

ArrayHelper._$name = 'ArrayHelper';

/***/ }),

/***/ "./lib/Core/helper/AsyncHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/AsyncHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AsyncHelper; });
var productName = 'gantt';
/**
* @module Core/helper/AsyncHelper
*/

/**
 * A helper class to make asynchronous tasks `await` friendly.
 */

class AsyncHelper {
  /**
   * Returns a promise that resolves on next animation frame.
   * ```
   *  async method() {
   *      // do work
   *      await AsyncHelper.animationFrame();
   *      // do more work
   *  }
   * ```
   * @async
   * @returns {Promise}
   */
  static animationFrame() {
    return new Promise(resolve => {
      requestAnimationFrame(resolve);
    });
  }
  /**
   * Returns a promise that resolves after a specified number of milliseconds.
   * ```
   *  async method() {
   *      await AsyncHelper.sleep(10);
   *      // ...
   *  }
   * ```
   * @async
   * @param {Number} millis The number of milliseconds to sleep.
   * @returns {Promise}
   */


  static sleep(millis) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, millis);
    });
  }
  /**
   * Returns a promise that resolves as soon as possible, allowing the browser to minimally process other messages.
   * This is the shortest possible delay the browser offers, so be aware that it does not necessarily allow the
   * browser to paint or reflow if used in a long loop. It does, however, allow other async methods to execute.
   * ```
   *  async method() {
   *      await AsyncHelper.yield();
   *      // ...
   *  }
   * ```
   * @returns {Promise}
   */


  static yield() {
    return Promise.resolve();
  }

}
AsyncHelper._$name = 'AsyncHelper';

/***/ }),

/***/ "./lib/Core/helper/BrowserHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/BrowserHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrowserHelper; });
var productName = 'gantt';
/**
* @module Core/helper/BrowserHelper
*/

/**
 * Static helper class that does browser or platform detection and provides other helper functions.
 */

class BrowserHelper {
  //region Init
  static cacheFlags(platform = navigator.platform, userAgent = navigator.userAgent) {
    const me = this; // os

    me._isLinux = Boolean(platform.match(/Linux/));
    me._isMac = Boolean(platform.match(/Mac/));
    me._isWindows = Boolean(platform.match(/Win32/)); // browser

    me._isIE11 = Boolean(userAgent.match(/rv:11/));
    me._edgeVersion = me.getVersion(userAgent, /Edge?\/(\d+)\./);
    me._isEdge = me._edgeVersion > 0 && me._edgeVersion < 80;

    if (!me._isEdge) {
      me._edgeVersion = 0;
    } // Edge user agent contain webkit too


    me._isWebkit = Boolean(userAgent.match(/WebKit/)) && !me._isEdge;
    me._firefoxVersion = me.getVersion(userAgent, /Firefox\/(\d+)\./);
    me._isFirefox = me._firefoxVersion > 0;
    me._chromeVersion = !me._isEdge ? me.getVersion(userAgent, /Chrom(?:e|ium)\/(\d+)\./) : 0;
    me._isChrome = me._chromeVersion > 0;
    me._isSafari = Boolean(userAgent.match(/Safari/)) && !me._isChrome && !me._isEdge;
    me._isMobileSafari = Boolean(userAgent.match(/Mobile.*Safari/));
    me._isAndroid = Boolean(userAgent.match(/Android/g));

    try {
      document.querySelector(':scope'); // Scoped queries are not supported for custom element polyfill in firefox
      // https://app.assembla.com/spaces/bryntum/tickets/6781

      me.supportsQueryScope = !me._isFirefox;
    } catch (e) {
      me.supportsQueryScope = false;
    }

    me._supportsPassive = false;

    try {
      // If the browser asks the options object to yield its passive
      // property, we know it supports the object form options object
      // and passive listeners.
      document.addEventListener('__notvalid__', null, {
        get passive() {
          me._supportsPassive = true;
        }

      });
    } catch (e) {}
  } //endregion
  //region Device

  /**
   * Yields `true` if the current browser supports CSS style `overflow:clip`.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get supportsOverflowClip() {
    if (this._supportsOverflowClip == null) {
      const div = document.createElement('div');
      div.style.overflow = 'clip';
      div.style.display = 'none'; // If we're called before DOMContentLoaded, body won't be available.
      // HTML element works for style calcs.

      document.documentElement.appendChild(div);
      this._supportsOverflowClip = div.ownerDocument.defaultView.getComputedStyle(div).getPropertyValue('overflow') === 'clip';
      div.remove();
    }

    return this._supportsOverflowClip;
  }
  /**
   * Yields `true` if the current browser supports CSS style `position:sticky`.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get supportsSticky() {
    // TODO: remove this when IE11 support is dropped. That's the only non-compliant browser.
    return !this._isIE11;
  }
  /**
   * Returns matched version for userAgent.
   * @param {String} versionRe version match regular expression
   * @returns {Number} matched version
   * @readonly
   * @internal
   */


  static getVersion(userAgent, versionRe) {
    const match = userAgent.match(versionRe);
    return match ? parseInt(match[1]) : 0;
  }
  /**
   * Tries to determine if the user is using a touch device.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get isTouchDevice() {
    if ('_isTouchDevice' in this) return this._isTouchDevice;
    return 'ontouchstart' in window || // edge tends to always have this with a value 2
    !this.isEdge && navigator.maxTouchPoints > 0 || // but if env is actually touchable, then window has this class present
    this.isEdge && window.TouchEvent || navigator.msMaxTouchPoints > 0;
  } // Since touch screen detection is unreliable we should allow client to configure it, or detect first touch


  static set isTouchDevice(value) {
    this._isTouchDevice = value;
  }

  static get supportsPointerEvents() {
    return Boolean(window.PointerEvent || window.MSPointerEvent);
  } // Reports true by default for our tests


  static get isHoverableDevice() {
    if (this._isHoverableDevice === undefined) {
      this._isHoverableDevice = window.matchMedia('(any-hover: hover)').matches;
    }

    return this._isHoverableDevice;
  } //endregion
  //region Platform


  static get isBrowserEnv() {
    return typeof window !== 'undefined';
  }
  /**
   * Checks if platform is Mac.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isMac() {
    return this._isMac;
  }
  /**
   * Checks if platform is Windows.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isWindows() {
    return this._isWindows;
  }
  /**
   * Checks if platform is Linux.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isLinux() {
    return this._isLinux;
  }
  /**
   * Checks if platform is Android.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isAndroid() {
    return this._isAndroid;
  } //endregion
  //region Browser

  /**
   * Checks if browser is IE11.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isIE11() {
    return this._isIE11;
  }
  /**
   * Checks if browser is legacy Edge (version <= 18).
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isEdge() {
    return this._isEdge;
  }
  /**
   * Returns the major legacy Edge version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get edgeVersion() {
    return this._edgeVersion;
  }
  /**
   * Checks if browser is Webkit.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isWebkit() {
    return this._isWebkit;
  }
  /**
   * Checks if browser is Chrome or Chromium based browser.
   * Returns truthy value for Edge Chromium.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isChrome() {
    return this._isChrome;
  }
  /**
   * Returns the major Chrome version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get chromeVersion() {
    return this._chromeVersion;
  }
  /**
   * Checks if browser is Firefox.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isFirefox() {
    return this._isFirefox;
  }
  /**
   * Returns the major Firefox version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get firefoxVersion() {
    return this._firefoxVersion;
  }
  /**
   * Checks if browser is Safari.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isSafari() {
    return this._isSafari;
  }
  /**
   * Checks if browser is mobile Safari
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isMobileSafari() {
    return this._isMobileSafari;
  }
  /**
   * Returns `true` if the browser supports passive event listeners.
   * @property {Boolean}
   * @internal
   * @category Browser
   */


  static get supportsPassive() {
    return this._supportsPassive;
  } //endregion
  //region Storage
  // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API


  static get storageAvailable() {
    let storage, x;

    try {
      storage = localStorage;
      x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && ( // everything except Firefox
      e.code === 22 || // Firefox
      e.code === 1014 || // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' || // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0;
    }
  }

  static setLocalStorageItem(key, value) {
    this.storageAvailable && localStorage.setItem(key, value);
  }

  static getLocalStorageItem(key) {
    return this.storageAvailable && localStorage.getItem(key);
  }

  static removeLocalStorageItem(key) {
    this.storageAvailable && localStorage.removeItem(key);
  } //endregion
  //region Helpers

  /**
   * Returns parameter value from search string by parameter name.
   * @param {String} paramName search parameter name
   * @param {*} [defaultValue] default value if parameter not found
   * @param {String} [search] search string. Defaults to `document.location.search`
   * @category Helper
   */


  static searchParam(paramName, defaultValue = null, search = document.location.search) {
    const re = new RegExp(`[?&]${paramName}=?([^&]*)`),
          match = search.match(re);
    return match && match[1] || defaultValue;
  }
  /**
   * Returns cookie by name.
   * @param {String} name cookie name
   * @return {String} cookie string value
   * @category Helper
   */


  static getCookie(name) {
    const nameEq = encodeURIComponent(name) + '=',
          cookieItems = document.cookie.split(';');

    for (let i = 0; i < cookieItems.length; i++) {
      let c = cookieItems[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEq) === 0) {
        return decodeURIComponent(c.substring(nameEq.length, c.length));
      }
    }

    return '';
  }
  /**
   * Triggers a download of a file with the specified name / URL.
   * @param {String} filename The filename of the file to be downloaded
   * @param {String} [url] The URL where the file is to be downloaded from
   * @internal
   * @category Download
   */


  static download(filename, url) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = url || filename;
    a.style.cssText = 'display:none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  /**
   * Triggers a download of a Blob with the specified name.
   * @param {Blob} blob The Blob to be downloaded
   * @param {String} filename The filename of the file to be downloaded
   * @internal
   * @category Download
   */


  static downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    this.download(filename, url);
    window.URL.revokeObjectURL(url);
  }

  static get queryString() {
    // Code could be executed in the Node context
    if (this.isBrowserEnv) {
      var _Object$fromEntries;

      // new URLSearchParams throws in salesforce
      // https://github.com/salesforce/lwc/issues/1812
      const params = new URL(window.location.href).searchParams; // ?. to be nice to users with Chrome versions < 73

      return (_Object$fromEntries = Object.fromEntries) === null || _Object$fromEntries === void 0 ? void 0 : _Object$fromEntries.call(Object, params.entries());
    }
  }

  static get global() {
    return this.isBrowserEnv ? window // eslint-disable-next-line no-undef
    : typeof global !== 'undefined' ? global : globalThis || {};
  }

  static copyToClipboard(code) {
    let success = true;
    const textArea = document.createElement('textarea');
    textArea.value = code;
    textArea.style.height = textArea.style.width = 0;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (e) {
      success = false;
    }

    textArea.remove();
    return success;
  }

  static isBryntumOnline(searchStrings) {
    var _searchStrings;

    searchStrings = Array.isArray(searchStrings) ? searchStrings : [searchStrings];
    return Boolean(/^(www\.)?bryntum\.com/.test(window.location.host) || ((_searchStrings = searchStrings) === null || _searchStrings === void 0 ? void 0 : _searchStrings.some(str => this.queryString[str] != null)));
  } //endregion


}

if (BrowserHelper.isBrowserEnv) {
  BrowserHelper.cacheFlags();
}

BrowserHelper._$name = 'BrowserHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./lib/Core/helper/CSSHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/CSSHelper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CSSHelper; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';

/**
 * @module Core/helper/CSSHelper
 */

/**
 * Provides methods to add and manipulate CSS style rules.
 *
 * Note that this class is incompatible with [CSP](https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP)
 *
 * ```
 * this.criticalRule = CSSHelper.insertRule(`#${this.id} .b-sch-event.critical {background-color:${this.criticalColor}}`);
 * ```
 */

class CSSHelper {
  /**
   * Inserts a CSS style rule based upon the passed text
   * @param {String} cssText The text of the rule including selector and rule body just as it would
   * be specified in a CSS file.
   * @returns {CSSRule} The resulting CSS Rule object if the add was successful.
   */
  static insertRule(cssText) {
    const styleSheet = this.getStyleSheet(document.head),
          oldCount = styleSheet.cssRules.length;
    styleSheet.insertRule(cssText, 0); // Only return element zero if the add was successful.

    if (styleSheet.cssRules.length > oldCount) {
      return styleSheet.cssRules[0];
    }
  }
  /**
   * Looks up the first rule which matched the passed selector.
   * @param {String|Function} selector Either the selector string to exactly match or a function which
   * when passed a required selector, returns `true`.
   * @returns {CSSRule} The first matching CSS Rule object if any found.
   */


  static findRule(selector) {
    let result,
        isFn = typeof selector === 'function'; // Array#find will stop when the function returns true, stop when the inner
    // find call yields a value from the search string.
    // Array#find better: to http://www.andygup.net/fastest-way-to-find-an-item-in-a-javascript-array/

    Array.prototype.find.call(document.head.querySelectorAll('link[rel=stylesheet],style[type*=css]'), element => {
      result = Array.prototype.find.call(element.sheet.rules || element.sheet.cssRules, r => {
        return isFn ? selector(r) : r.selectorText === selector;
      });

      if (result) {
        return true;
      }
    });
    return result;
  }

  static getStyleSheet(parentElement = document.head) {
    if (!parentElement.$bryntumStylesheet) {
      parentElement.$bryntumStylesheet = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        tag: 'style',
        id: 'bryntum-private-styles',
        // no-sanity
        type: 'text/css',
        parent: parentElement
      }).sheet;
    }

    return parentElement.$bryntumStylesheet;
  }

}
CSSHelper._$name = 'CSSHelper';

/***/ }),

/***/ "./lib/Core/helper/DateHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DateHelper.js ***!
  \***************************************/
/*! exports provided: unitMagnitudes, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unitMagnitudes", function() { return unitMagnitudes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateHelper; });
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






const {
  toString
} = Object.prototype,
      DATE_TYPE = toString.call(new Date()),
      // Left-to-right unicode mark (https://www.codetable.net/decimal/8206)
LTRSymbolRegexp = new RegExp('\u200E', 'g'),
      tempDate = new Date(),
      MS_PER_HOUR = 1000 * 60 * 60,
      defaultValue = (value, defValue) => isNaN(value) || value == null ? defValue : value,
      enOrdinalSuffix = number => {
  const hasSpecialCase = ['11', '12', '13'].find(n => number.endsWith(n));
  let suffix = 'th';

  if (!hasSpecialCase) {
    const lastDigit = number[number.length - 1];
    suffix = {
      1: 'st',
      2: 'nd',
      3: 'rd'
    }[lastDigit] || 'th';
  }

  return number + suffix;
},
      useIntlFormat = (name, options, date) => {
  const formatter = intlFormatterCache[name] || (intlFormatterCache[name] = new Intl.DateTimeFormat(locale, options));
  let result = formatter.format(date); // IE11 inserts direction control characters to the string
  // This removes the characters

  if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
    result = result.replace(LTRSymbolRegexp, '');
  }

  return result;
},
      formatTime = (name, options, date, isShort = false) => {
  let strTime = useIntlFormat(name, options, date); // remove "0" from time when has AM/PM (from 01:00 PM to 1:00 PM): https://github.com/bryntum/support/issues/1483

  if (/am|pm/i.test(strTime)) {
    // remove first character only if is 0
    strTime = strTime.replace(/^0/, ''); // if isShort is true, remove minutes if is :00

    if (isShort) {
      strTime = strTime.replace(/:00/, '');
    }
  }

  return strTime;
},
      getDayDiff = (end, start) => Math.floor((end.getTime() - start.getTime() - (end.getTimezoneOffset() - start.getTimezoneOffset()) * validConversions.minute.millisecond) / validConversions.day.millisecond) + 1,
      normalizeDay = day => day >= 0 ? day : day + 7; // These vars are set when changing locale


let locale = 'en-US',
    ordinalSuffix = enOrdinalSuffix,
    // Used to cache used formats, to not have to parse format string each time
formatCache = {},
    intlFormatterCache = {},
    parserCache = {};

const DEFAULT_YEAR = 2020,
      // 2020 is the year that has no issues in Safari and Edge, see: https://github.com/bryntum/support/issues/554
DEFAULT_MONTH = 0,
      DEFAULT_DAY = 1,
      formats = {
  // 1, 2, ... 11, 12
  M: date => date.getMonth() + 1,
  //date.toLocaleDateString(locale, { month : 'numeric' }),
  // 1st, 2nd, 3rd, 4th, ... 11th, 12th
  Mo: date => ordinalSuffix(formats.M(date).toString()),
  // 01, 02, ...
  MM: date => (date.getMonth() + 1).toString().padStart(2, '0'),
  //date.toLocaleDateString(locale, { month : '2-digit' }),
  // Jan, Feb, ...
  MMM: date => useIntlFormat('MMM', {
    month: 'short'
  }, date),
  // January, February, ...
  MMMM: date => useIntlFormat('MMMM', {
    month: 'long'
  }, date),
  // 1, 2, ...
  Q: date => Math.ceil((date.getMonth() + 1) / 3),
  // 1st, 2nd, ...
  Qo: date => ordinalSuffix(formats.Q(date).toString()),
  // 1, 2, ...
  D: date => date.getDate(),
  //date.toLocaleDateString(locale, { day : 'numeric' }),
  // 1st, 2nd, ...
  Do: date => ordinalSuffix(formats.D(date).toString()),
  // 01, 02, ...
  DD: date => date.getDate().toString().padStart(2, '0'),
  //date.toLocaleDateString(locale, { day : '2-digit' }),
  // 1, 2, ..., 365, 365
  DDD: date => Math.ceil((new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0) - new Date(date.getFullYear(), 0, 0, 12, 0, 0)) / validConversions.day.millisecond),
  // 1st, 2nd, ...
  DDDo: date => ordinalSuffix(formats.DDD(date).toString()),
  // 001, 002, ...
  DDDD: date => formats.DDD(date).toString().padStart(3, '0'),
  // 0, 1, ..., 6
  d: date => date.getDay(),
  // 0th, 1st, ...
  do: date => ordinalSuffix(date.getDay().toString()),
  // S, M, ...
  d1: date => useIntlFormat('d1', {
    weekday: 'narrow'
  }, date).substr(0, 1),
  // Su, Mo, ...
  dd: date => formats.ddd(date).substring(0, 2),
  // Sun, Mon, ...
  ddd: date => useIntlFormat('ddd', {
    weekday: 'short'
  }, date),
  // Sunday, Monday, ...
  dddd: date => useIntlFormat('dddd', {
    weekday: 'long'
  }, date),
  e: date => date.getDay(),
  E: date => date.getDay() + 1,
  // ISO week, 1, 2, ...
  W: date => DateHelper.getWeekNumber(date)[1],
  Wo: date => ordinalSuffix(formats.W(date).toString()),
  WW: date => formats.W(date).toString().padStart(2, '0'),
  // 1979, 2018
  Y: date => date.getFullYear(),
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // 79, 18
  YY: date => date.getFullYear() % 100,
  //date.toLocaleDateString(locale, { year : '2-digit' }),
  // 1979, 2018
  YYYY: date => date.getFullYear(),
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // AM, PM
  A: date => date.getHours() < 12 ? 'AM' : 'PM',
  a: date => date.getHours() < 12 ? 'am' : 'pm',
  // 0, 1, ... 23
  H: date => date.getHours(),
  // 00, 01, ...
  HH: date => date.getHours().toString().padStart(2, '0'),
  // 1, 2, ... 12
  h: date => date.getHours() % 12 || 12,
  // 01, 02, ...
  hh: date => formats.h(date).toString().padStart(2, '0'),
  // 1, 2, ... 24
  k: date => date.getHours() || 24,
  // 01, 02, ...
  kk: date => formats.k(date).toString().padStart(2, '0'),
  // Locale specific (0 -> 24 or 1 AM -> 12 PM)
  K: date => formatTime('K', {
    hour: 'numeric'
  }, date),
  // Locale specific (00 -> 24 or 1 AM -> 12 PM)
  KK: date => formatTime('KK', {
    hour: '2-digit'
  }, date),
  // 0, 1, ... 59
  m: date => date.getMinutes(),
  //date.toLocaleTimeString(locale, { minute : 'numeric' }),
  // 00, 01, ...
  mm: date => formats.m(date).toString().padStart(2, '0'),
  // 0, 1, ... 59
  s: date => date.getSeconds(),
  //date.toLocaleTimeString(locale, { second : 'numeric' }),
  // 00, 01, ...
  ss: date => formats.s(date).toString().padStart(2, '0'),
  // 0, 1, ... 9 which are 000, 100, 200 ... 900 in milliseconds
  S: date => Math.floor(date.getMilliseconds() / 100).toString(),
  // 00, 01, ... 99 which are 000, 010, 020 ... 990 in milliseconds
  SS: date => Math.floor(date.getMilliseconds() / 10).toString().padStart(2, '0'),
  // 000, 001, ... 999 in milliseconds
  SSS: date => date.getMilliseconds().toString().padStart(3, '0'),
  z: date => useIntlFormat('z', {
    timeZoneName: 'short'
  }, date),
  zz: date => useIntlFormat('zz', {
    timeZoneName: 'long'
  }, date),
  Z: date => DH.getGMTOffset(date),
  LT: date => formatTime('LT', {
    hour: '2-digit',
    minute: '2-digit'
  }, date),
  // if minutes is 0, doesn't show it
  LST: date => formatTime('LST', {
    hour: 'numeric',
    minute: '2-digit'
  }, date, true),
  LTS: date => formatTime('LTS', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }, date),
  L: date => useIntlFormat('L', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }, date),
  l: date => useIntlFormat('l', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }, date),
  LL: date => useIntlFormat('LL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }, date),
  ll: date => useIntlFormat('ll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }, date),
  LLL: date => useIntlFormat('LLL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }, date),
  lll: date => useIntlFormat('lll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }, date),
  LLLL: date => useIntlFormat('LLLL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    weekday: 'long'
  }, date),
  llll: date => useIntlFormat('llll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    weekday: 'short'
  }, date)
},
      // Want longest keys first, to not stop match at L of LTS etc.
formatKeys = Object.keys(formats).sort((a, b) => b.length - a.length),
      formatRegexp = `^(?:${formatKeys.join('|')})`,
      // return empty object, meaning value cannot be processed to a valuable date part
emptyFn = () => ({}),
      isNumber = str => numberRegex.test(str),
      parseMilliseconds = str => isNumber(str) && {
  milliseconds: parseInt(str.padEnd(3, '0').substring(0, 3))
},
      parsers = {
  YYYY: str => ({
    year: parseInt(str)
  }),
  Y: str => ({
    year: parseInt(str)
  }),
  YY: str => {
    const year = parseInt(str);
    return {
      year: year + (year > 1968 ? 1900 : 2000)
    };
  },
  MM: str => ({
    month: parseInt(str) - 1
  }),
  Mo: str => ({
    month: parseInt(str) - 1
  }),
  DD: str => ({
    date: parseInt(str)
  }),
  M: str => ({
    month: parseInt(str) - 1
  }),
  D: str => ({
    date: parseInt(str)
  }),
  Do: str => ({
    date: parseInt(str)
  }),
  DDD: emptyFn,
  MMM: emptyFn,
  MMMM: emptyFn,
  DDDo: emptyFn,
  DDDD: emptyFn,
  d: emptyFn,
  do: emptyFn,
  d1: emptyFn,
  dd: emptyFn,
  ddd: emptyFn,
  dddd: emptyFn,
  Q: emptyFn,
  Qo: emptyFn,
  W: emptyFn,
  Wo: emptyFn,
  WW: emptyFn,
  e: emptyFn,
  E: emptyFn,
  HH: str => ({
    hours: parseInt(str)
  }),
  hh: str => ({
    hours: parseInt(str)
  }),
  mm: str => ({
    minutes: parseInt(str)
  }),
  H: str => ({
    hours: parseInt(str)
  }),
  m: str => ({
    minutes: parseInt(str)
  }),
  ss: str => ({
    seconds: parseInt(str)
  }),
  s: str => ({
    seconds: parseInt(str)
  }),
  S: parseMilliseconds,
  SS: parseMilliseconds,
  SSS: parseMilliseconds,
  A: str => ({
    amPm: str.toLowerCase()
  }),
  a: str => ({
    amPm: str.toLowerCase()
  }),
  L: 'MM/DD/YYYY',
  LT: 'HH:mm A',
  // Can either be Z (=UTC, 0) or +-HH:MM
  Z: str => {
    if (!str || !timeZoneRegEx.test(str) && str !== 'Z') {
      return null;
    }

    let timeZone = 0; // If string being parsed is more "detailed" than the format specified we can have more chars left,
    // thus check the last (for example HH:mmZ with input HH:mm:ssZ -> ssZ)

    if (str !== 'Z') {
      const matches = timeZoneRegEx.exec(str); // If timezone regexp matches, sting has time zone offset like '+02:00'

      if (matches) {
        const sign = matches[1] === '+' ? 1 : -1,
              hours = parseInt(matches[2]) || 0,
              minutes = parseInt(matches[3]) || 0;
        timeZone = sign * (hours * 60 + minutes);
      } // otherwise we just return current time zone, because there's a Z key in the input
      else {
        timeZone = -1 * new Date().getTimezoneOffset();
      }
    }

    return {
      timeZone
    };
  }
},
      parserKeys = Object.keys(parsers).sort((a, b) => b.length - a.length),
      parserRegexp = new RegExp(`(${parserKeys.join('|')})`),
      // Following regexp includes all formats that should be handled by Date class
localeStrRegExp = new RegExp('(l|LL|ll|LLL|lll|LLLL|llll)'),
      //    ISODateRegExp             = new RegExp('YYYY-MM-DD[T ]HH:mm:ss(.s+)?Z'),
// Some validConversions are negative to show that it's not an exact conversion, just an estimate.
validConversions = {
  // The units below assume:
  // 30 days in a month, 91 days for a quarter and 365 for a year
  // 52 weeks per year, 4 per month, 13 per quarter
  // 3652 days per decade (assuming two of the years will be leap with 366 days)
  decade: {
    decade: 1,
    year: 10,
    quarter: 40,
    month: 120,
    week: 520,
    day: 3652,
    hour: 24 * 3652,
    minute: 1440 * 3652,
    second: 86400 * 3652,
    millisecond: 86400000 * 3652
  },
  year: {
    decade: 0.1,
    year: 1,
    quarter: 4,
    month: 12,
    week: 52,
    day: 365,
    hour: 24 * 365,
    minute: 1440 * 365,
    second: 86400 * 365,
    millisecond: 86400000 * 365
  },
  quarter: {
    decade: 1 / 40,
    year: 1 / 4,
    quarter: 1,
    month: 3,
    week: 4,
    day: 91,
    hour: 24 * 91,
    minute: 1440 * 91,
    second: 86400 * 91,
    millisecond: 86400000 * 91
  },
  month: {
    decade: 1 / 120,
    year: 1 / 12,
    quarter: 1 / 3,
    month: 1,
    week: 4,
    day: -30,
    hour: -24 * 30,
    minute: -1440 * 30,
    second: -86400 * 30,
    millisecond: -86400000 * 30
  },
  week: {
    decade: -1 / 520,
    year: -1 / 52,
    quarter: -1 / 13,
    month: -1 / 4,
    day: 7,
    hour: 168,
    minute: 10080,
    second: 604800,
    millisecond: 604800000
  },
  day: {
    decade: -1 / 3652,
    year: -1 / 365,
    quarter: -1 / 91,
    month: -1 / 30,
    week: 1 / 7,
    hour: 24,
    minute: 1440,
    second: 86400,
    millisecond: 86400000
  },
  hour: {
    decade: -1 / (3652 * 24),
    year: -1 / (365 * 24),
    quarter: -1 / (91 * 24),
    month: -1 / (30 * 24),
    week: 1 / 168,
    day: 1 / 24,
    minute: 60,
    second: 3600,
    millisecond: 3600000
  },
  minute: {
    decade: -1 / (3652 * 1440),
    year: -1 / (365 * 1440),
    quarter: -1 / (91 * 1440),
    month: -1 / (30 * 1440),
    week: 1 / 10080,
    day: 1 / 1440,
    hour: 1 / 60,
    second: 60,
    millisecond: 60000
  },
  second: {
    decade: -1 / (3652 * 86400),
    year: -1 / (365 * 86400),
    quarter: -1 / (91 * 86400),
    month: -1 / (30 * 86400),
    week: 1 / 604800,
    day: 1 / 86400,
    hour: 1 / 3600,
    minute: 1 / 60,
    millisecond: 1000
  },
  millisecond: {
    decade: -1 / (3652 * 86400000),
    year: -1 / (365 * 86400000),
    quarter: -1 / (91 * 86400000),
    month: -1 / (30 * 86400000),
    week: 1 / 604800000,
    day: 1 / 86400000,
    hour: 1 / 3600000,
    minute: 1 / 60000,
    second: 1 / 1000
  }
},
      normalizedUnits = {
  ms: 'millisecond',
  milliseconds: 'millisecond',
  s: 'second',
  seconds: 'second',
  m: 'minute',
  mi: 'minute',
  min: 'minute',
  minutes: 'minute',
  h: 'hour',
  hours: 'hour',
  d: 'day',
  days: 'day',
  w: 'week',
  weeks: 'week',
  M: 'month',
  mo: 'month',
  mon: 'month',
  months: 'month',
  q: 'quarter',
  quarters: 'quarter',
  y: 'year',
  years: 'year',
  dec: 'decade',
  decades: 'decade'
},
      withDecimalsDurationRegex = /^\s*([-+]?\d+(?:[.,]\d*)?|[-+]?(?:[.,]\d+))\s*([^\s]+)?/i,
      noDecimalsDurationRegex = /^\s*([-+]?\d+)(?![.,])\s*([^\s]+)?/i,
      canonicalUnitNames = ['millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year', 'decade'],
      canonicalUnitAbbreviations = [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr'], ['dec']],
      deltaUnits = ['decade', 'year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'],
      // Used when creating a date from an object, to fill in any blanks
dateProperties = ['milliseconds', 'seconds', 'minutes', 'hours', 'date', 'month', 'year'],
      // TODO: Should we provide special number parsing?
parseNumber = n => {
  const result = parseFloat(n);
  return isNaN(result) ? null : result;
},
      numberRegex = /^[0-9]+$/,
      timeZoneRegEx = /([+-])(\d\d):*(\d\d)*$/,
      unitMagnitudes = {
  millisecond: 0,
  second: 1,
  minute: 2,
  hour: 3,
  day: 4,
  week: 5,
  month: 6,
  quarter: 7,
  year: 8,
  decade: 9
},
      snapFns = {
  round(number, step = 1) {
    return Math.round(number / step) * step;
  },

  floor(number, step = 1) {
    return Math.floor(number / step) * step;
  },

  ceil(number, step = 1) {
    return Math.ceil(number / step) * step;
  }

},
      keyCache = {};


/**
 * @module Core/helper/DateHelper
 */

/**
 * Helps with date manipulation, comparison, parsing, formatting etc.
 *
 * ## Parsing strings
 * Use `DateHelper.parse()` to parse strings into dates. It accepts a date string and a format specifier.
 * The format specifier is string built up using the following tokens:
 *
 * | Unit        | Token | Description                       |
 * |-------------|-------|-----------------------------------|
 * | Year        | YYYY  | 2018                              |
 * |             | YY    | < 68 -> 2000, > 68 -> 1900        |
 * | Month       | MM    | 01 - 12                           |
 * | Date        | DD    | 01 - 31                           |
 * | Hour        | HH    | 00 - 23 or 1 - 12                 |
 * | Minute      | mm    | 00 - 59                           |
 * | Second      | ss    | 00 - 59                           |
 * | Millisecond | S     | 0 - 9 [000, 100, 200 .. 900 ]     |
 * |             | SS    | 00 - 99 [000, 010, 020 .. 990 ]   |
 * |             | SSS   | 000 - 999 [000, 001, 002 .. 999 ] |
 * | AM/PM       | A     | AM or PM                          |
 * |             | a     | am or pm                          |
 * | TimeZone    | Z     | Z for UTC or +-HH:mm              |
 * | Predefined  | L     | Long date, MM/DD/YYYY             |
 * |             | LT    | Long time, HH:mm A                |
 *
 * Default parse format is: `'YYYY-MM-DDTHH:mm:ss.SSSZ'` see {@link #property-defaultParseFormat-static}
 *
 * For example:
 * ```
 * DateHelper.parse('2018-11-06', 'YYYY-MM-DD');
 * DateHelper.parse('13:14', 'HH:mm');
 * DateHelper.parse('6/11/18', 'DD/MM/YY');
 * ```
 *
 * ## Formatting dates
 * Use `DateHelper.format()` to create a string from a date using a format specifier. The format specifier is similar to
 * that used when parsing strings. It can use the following tokens (input used for output below is
 * `new Date(2018,8,9,18,7,8,145)`):
 *
 * | Unit                  | Token | Description & output                  |
 * |-----------------------|-------|---------------------------------------|
 * | Year                  | YYYY  | 2018                                  |
 * |                       | YY    | 18                                    |
 * |                       | Y     | 2018                                  |
 * | Quarter               | Q     | 3                                     |
 * |                       | Qo    | 3rd                                   |
 * | Month                 | MMMM  | September                             |
 * |                       | MMM   | Sep                                   |
 * |                       | MM    | 09                                    |
 * |                       | Mo    | 9th                                   |
 * |                       | M     | 9                                     |
 * | Week (iso)            | WW    | 36 (2 digit)                          |
 * |                       | Wo    | 36th                                  |
 * |                       | W     | 36                                    |
 * | Date                  | DDDD  | Day of year, 3 digits                 |
 * |                       | DDDo  | Day of year, ordinal                  |
 * |                       | DDD   | Day of year                           |
 * |                       | DD    | 09                                    |
 * |                       | Do    | 9th                                   |
 * |                       | D     | 9                                     |
 * | Weekday               | dddd  | Sunday                                |
 * |                       | ddd   | Sun                                   |
 * |                       | dd    | Su                                    |
 * |                       | d1    | S                                     |
 * |                       | do    | 0th                                   |
 * |                       | d     | 0                                     |
 * | Hour                  | HH    | 18 (00 - 23)                          |
 * |                       | H     | 18 (0 - 23)                           |
 * |                       | hh    | 06 (00 - 12)                          |
 * |                       | h     | 6 (0 - 12)                            |
 * |                       | KK    | 19 (01 - 24)                          |
 * |                       | K     | 19 (1 - 24)                           |
 * |                       | kk    | 06 or 18, locale determines           |
 * |                       | k     | 6 or 18, locale determines            |
 * | Minute                | mm    | 07                                    |
 * |                       | m     | 7                                     |
 * | Second                | ss    | 08                                    |
 * |                       | s     | 8                                     |
 * | Millisecond           | S     | 1 (100ms)                             |
 * |                       | SS    | 14 (140ms)                            |
 * |                       | SSS   | 145 (145ms)                           |
 * | AM/PM                 | A     | AM or PM                              |
 * |                       | a     | am or pm                              |
 * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
 * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
 * |                       | LST   | Depends on 12 or 24 hour clock        |
 * |                       |       | 12h, H : 1d, m : 0 or 2d              |
 * |                       |       | 24h, H : 2d, m : 2d                   |
 * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
 * |                       | l     | Y: n, M : n, D : n                    |
 * |                       | LL    | Y: n, M : long (l), D : n             |
 * |                       | ll    | Y: n, M : short (s), D : n            |
 * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
 * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
 * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
 * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
 *
 *
 * Default format is: `'YYYY-MM-DDTHH:mm:ssZ'` see {@link #property-defaultFormat-static}
 *
 * For example:
 *
 * ```javascript
 * DateHelper.format(new Date(2018,10,6), 'YYYY-MM-DD'); // 2018-11-06
 * DateHelper.format(new Date(2018,10,6), 'M/D/YY'); // 11/6/18
 * ```
 *
 * Arbitrary text can be embedded in the format string by wrapping it with {}:
 *
 * ```javascript
 * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
 * ```
 *
 * ## Unit names
 * Many DateHelper functions (for example add, as, set) accepts a unit among their params. The following units are
 * available:
 *
 * | Unit        | Aliases                       |
 * |-------------|-------------------------------|
 * | millisecond | millisecond, milliseconds, ms |
 * | second      | second, seconds, s            |
 * | minute      | minute, minutes, m            |
 * | hour        | hour, hours, h                |
 * | day         | day, days, d                  |
 * | week        | week, weeks, w                |
 * | month       | month, months, mon, mo, M     |
 * | quarter     | quarter, quarters, q          |
 * | year        | year, years, y                |
 * | decade      | decade, decades, dec          |
 *
 * For example:
 * ```javascript
 * DateHelper.add(date, 2, 'days');
 * DateHelper.as('hour', 7200, 'seconds');
 * ```
 */

class DateHelper extends Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__["default"])() {
  static get $name() {
    return 'DateHelper';
  } //region Parse & format

  /**
   * Get/set the default format used by `format()` and `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ssZ'`
   * (~ISO 8601 Date and time, `'1962-06-17T09:21:34Z'`).
   * @member {String}
   */


  static set defaultFormat(format) {
    DH._defaultFormat = format;
  }

  static get defaultFormat() {
    return DH._defaultFormat || 'YYYY-MM-DDTHH:mm:ssZ';
  }
  /**
   * Get/set the default format used by `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ss.SSSZ'` or {@link #property-defaultFormat-static}
   * (~ISO 8601 Date and time, `'1962-06-17T09:21:34.123Z'`).
   * @member {String}
   */


  static set defaultParseFormat(parseFormat) {
    this._defaultParseFormat = parseFormat;
  }

  static get defaultParseFormat() {
    return this._defaultParseFormat || this._defaultFormat || 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  }

  static buildParser(format) {
    // Split input format by regexp, which includes predefined patterns. Normally format would have some
    // splitters, like 'YYYY-MM-DD' or 'D/M YYYY' so output will contain matched patterns as well as splitters
    // which would serve as anchors. E.g. provided format is 'D/M!YYYY' and input is `11/6!2019` algorithm would work like:
    // 1. split format by regexp                // ['', 'D', '/', 'M', '!', 'YYYY', '']
    // 2. find splitters                        // ['/', '!']
    // 3. split input by seps, step by step     // ['11', ['6', ['2019']]]
    // Inputs like 'YYYYY' (5*Y) means 'YYYY' + 'Y', because it matches patterns from longer to shorter,
    // but if few patterns describe same unit the last one is applied, for example
    // DH.parse('20182015', 'YYYYY') equals to new Date(2015, 0, 0)
    const parts = format.split(parserRegexp),
          parser = []; // if length of the parts array is 1 - there are no regexps in the input string. thus - no parsers
    // do same if there are patterns matching locale strings (l, ll, LLLL etc.)
    // returning empty array to use new Date() as parser

    if (parts.length === 1 || localeStrRegExp.test(format)) {
      return [];
    } else {
      parts.reduce((prev, curr, index, array) => {
        // ignore first and last empty string
        if (index !== 0 || curr !== '') {
          // if current element matches parser regexp store it as a parser
          if (parserRegexp.test(curr)) {
            const localeParsers = this.localize('L{parsers}') || {},
                  fn = localeParsers[curr] || parsers[curr]; // Z should be last element in the string that matches regexp. Last array element is always either
            // an empty string (if format ends with Z) or splitter (everything that doesn't match regexp after Z)
            // If there is a pattern after Z, then Z index will be lower than length - 2

            if (curr === 'Z' && index < array.length - 2) {
              throw new Error(`Invalid format ${format} TimeZone (Z) must be last token`);
            } // If fn is a string, we found an alias (L, LLL, l etc.).
            // Need to build parsers from mapped format and merge with existing


            if (typeof fn === 'string') {
              // we are going to merge nested parsers with current, some cleanup required:
              // 1. last element is no longer last
              // 2. need to pass last parser to the next step
              const nestedParsers = DH.buildParser(fn),
                    lastItem = nestedParsers.pop();
              delete lastItem.last; // elevate nested parsers

              parser.push(...nestedParsers);
              prev = lastItem;
            } else {
              prev.pattern = curr;
              prev.fn = parsers[curr];
            }
          } // if it doesn't match - we've found a splitter
          else {
            prev.splitter = curr;
            parser.push(prev);
            prev = {};
          }
        } else if (Object.prototype.hasOwnProperty.call(prev, 'pattern')) {
          parser.push(prev);
        }

        return prev;
      }, {});
    }

    parser[parser.length - 1].last = true;
    return parser;
  }
  /**
   * A utility function to create a sortable string key for the passed date or ms timestamp using the `'YYYY-MM-DD'`
   * format.
   * @param {Number|Date} ms The Date instance or ms timestamp to generate a key for
   * @returns {String} Date/timestamp as a string with `'YYYY-M-D'` format
   * @internal
   */


  static makeKey(ms) {
    // Convert Date to ms timestamp
    if (ms.getTime) {
      ms = ms.getTime();
    } // Cache holds ms -> YYYY-MM-DD


    const cached = keyCache[Math.trunc(ms / MS_PER_HOUR)];

    if (cached) {
      return cached;
    }

    tempDate.setTime(ms);
    const month = tempDate.getMonth() + 1,
          date = tempDate.getDate(); // Not using DateHelper.format to save some cycles, hit a lot

    return keyCache[Math.trunc(ms / MS_PER_HOUR)] = `${tempDate.getFullYear()}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`;
  }
  /**
   * A utility function to parse a sortable string to a date date using the `'YYYY-MM-DD'` format.
   * @param {String} key The string to return a date for.
   * @returns {Date} new Date instance
   * @internal
   */


  static parseKey(key) {
    return DH.parse(key, 'YYYY-MM-DD');
  }
  /**
   * Returns a date created from the supplied string using the specified format. Will try to create even if format
   * is left out, by first using the default format (see {@link #property-defaultFormat-static}, by default
   * `YYYY-MM-DDTHH:mm:ssZ`) and then using `new Date(dateString)`.
   * Supported tokens:
   *
   * | Unit        | Token | Description                       |
   * |-------------|-------|-----------------------------------|
   * | Year        | YYYY  | 2018                              |
   * |             | YY    | < 68 -> 2000, > 68 -> 1900        |
   * | Month       | MM    | 01 - 12                           |
   * | Date        | DD    | 01 - 31                           |
   * | Hour        | HH    | 00 - 23 or 1 - 12                 |
   * | Minute      | mm    | 00 - 59                           |
   * | Second      | ss    | 00 - 59                           |
   * | Millisecond | S     | 0 - 9 [000, 100, 200 .. 900 ]     |
   * |             | SS    | 00 - 99 [000, 010, 020 .. 990 ]   |
   * |             | SSS   | 000 - 999 [000, 001, 002 .. 999 ] |
   * | AM/PM       | A     | AM or PM                          |
   * |             | a     | am or pm                          |
   * | TimeZone    | Z     | Z for UTC or +-HH:mm              |
   * | Predefined  | L     | Long date, MM/DD/YYYY             |
   * |             | LT    | Long time, HH:mm A                |
   *
   * Predefined formats and functions used to parse tokens can be localized, see for example the swedish locale SvSE.js
   *
   * NOTE: If no date parameters are provided then `Jan 01 2020` is used as a default date
   *
   * @param {String} dateString Date string
   * @param {String} format Date format (or {@link #property-defaultParseFormat-static} if left out)
   * @returns {Date} new Date instance parsed from the string
   * @category Parse & format
   */


  static parse(dateString, format = DH.defaultParseFormat) {
    if (dateString instanceof Date) {
      return dateString;
    }

    if (typeof dateString !== 'string' || !dateString) {
      return null;
    } // // For ISO 8601 native is faster, but not very forgiving
    // if (format === defaultFormat) {
    //     const dt = new Date(dateString);
    //     if (!isNaN(dt)) {
    //         return dt;
    //     }
    // }


    const config = {
      year: null,
      month: null,
      date: null,
      hours: null,
      minutes: null,
      seconds: null,
      milliseconds: null
    }; // Milliseconds parser is the same for S, SS, SSS

    format = format.replace(/S+/gm, 'SSS');
    let parser = parserCache[format],
        result;

    if (!parser) {
      parser = parserCache[format] = DH.buildParser(format);
    } // Each parser knows its pattern and splitter. It looks for splitter in the
    // input string, takes first substring and tries to process it. Remaining string
    // is passed to the next parser.


    parser.reduce((dateString, parser) => {
      if (parser.last) {
        Object.assign(config, parser.fn(dateString));
      } else {
        let splitAt; // ISO 8601 says that T symbol can be replaced with a space

        if (parser.splitter === 'T' && dateString.indexOf('T') === -1) {
          splitAt = dateString.indexOf(' ');
        } else {
          // If splitter specified find its position, otherwise try to determine pattern length
          splitAt = parser.splitter !== '' ? dateString.indexOf(parser.splitter) : parser.pattern && parser.pattern.length || -1;
        }

        let part, rest; // If splitter is not found in the current string we may be dealing with
        // 1. partial input - in that case we just feed all string to current parser and move on
        // 2. time zone (ssZ - splitter is empty string) and pattern is not specified, see comment below
        // 3. parse milliseconds before Z

        if (splitAt === -1 || parser.pattern === 'SSS' && dateString.match(/^\d+Z$/)) {
          // NOTE: parentheses are required here as + and - signs hold valuable information
          // with parentheses we get array like ['00','+','01:00'], omitting them we won't get
          // regexp match in result, loosing information
          const chunks = dateString.split(/([Z\-+])/); // If splitter is not found in the string, we may be dealing with string that contains info about TZ.
          // For instance, if format contains Z as last arg which is not separated (normally it is not indeed),
          // like 'YYYY-MM-DD HH:mm:ssZ', then second to last parser will have string that it cannot just parse, like
          // '2010-01-01 10:00:00'        -> '00'
          // '2010-01-01 10:00:00Z'       -> '00Z'
          // '2010-01-01 10:00:00-01'     -> '00-01'
          // '2010-01-01 10:00:00+01:30'  -> '00+01:30'
          // this cannot be processed by date parsers, so we need to process that additionally. So we
          // split string by symbols that can be found around timezone info: Z,-,+

          if (chunks.length === 1) {
            part = dateString;
            rest = '';
          } else {
            part = chunks[0];
            rest = `${chunks[1]}${chunks[2]}`;
          }
        } else {
          part = dateString.substring(0, splitAt) || dateString;
          rest = dateString.substring(splitAt + parser.splitter.length);
        }

        if (parser.fn) {
          // Run parser and add result to config on successful parse otherwise continue parsing
          const res = parser.fn(part);

          if (res) {
            Object.assign(config, res);
          } else {
            rest = part + rest;
          }
        }

        return rest;
      }
    }, dateString); // If year is specified date has to be greater than 0

    if (config.year && !config.date) {
      config.date = 1;
    }

    const date = DH.create(config);

    if (date) {
      result = date;
    } else {
      // Last resort, try if native passing can do it
      result = new Date(dateString);
    }

    return result;
  }
  /**
   * Creates a date from a date definition object. The object can have the following properties:
   * - year
   * - month
   * - date (day in month)
   * - hours
   * - minutes
   * - seconds
   * - milliseconds
   * - amPm : 'am' or 'pm', implies 12 hour clock
   * - timeZone : offset from UTC in minutes
   * @param {Object} definition
   * @returns {Date} new Date instance
   * @category Parse & format
   */


  static create(definition) {
    // Shallow clone to not alter input
    const def = _objectSpread({}, definition);

    let invalid = isNaN(def.year),
        useUTC = false; // Not much validation yet, only considered invalid if all properties are null

    if (!invalid) {
      let allNull = true;
      dateProperties.forEach(property => {
        if (!(property in def) || isNaN(def[property])) {
          def[property] = 0;
        }

        allNull = allNull && def[property] === null;
      });
      invalid = allNull;
    }

    if (def.amPm === 'pm') {
      def.hours = def.hours % 12 + 12;
    }

    if ('timeZone' in def) {
      useUTC = true;
      def.minutes -= def.timeZone;
    }

    if (invalid) {
      return null;
    }

    const args = [defaultValue(def.year, DEFAULT_YEAR), defaultValue(def.month, DEFAULT_MONTH), defaultValue(def.date, DEFAULT_DAY), def.hours, def.minutes, def.seconds, def.milliseconds];
    return useUTC ? new Date(Date.UTC(...args)) : new Date(...args);
  }

  static toUTC(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
  }
  /**
   * Converts a date to string with the specified format. Formats heavily inspired by https://momentjs.com.
   * Available formats (input used for output below is `new Date(2018,8,9,18,7,8,145)`):
   *
   * | Unit                  | Token | Description & output                  |
   * |-----------------------|-------|---------------------------------------|
   * | Year                  | YYYY  | 2018                                  |
   * |                       | YY    | 18                                    |
   * |                       | Y     | 2018                                  |
   * | Quarter               | Q     | 3                                     |
   * |                       | Qo    | 3rd                                   |
   * | Month                 | MMMM  | September                             |
   * |                       | MMM   | Sep                                   |
   * |                       | MM    | 09                                    |
   * |                       | Mo    | 9th                                   |
   * |                       | M     | 9                                     |
   * | Week (iso)            | WW    | 36 (2 digit)                          |
   * |                       | Wo    | 36th                                  |
   * |                       | W     | 36                                    |
   * | Date                  | DDDD  | Day of year, 3 digits                 |
   * |                       | DDDo  | Day of year, ordinal                  |
   * |                       | DDD   | Day of year                           |
   * |                       | DD    | 09                                    |
   * |                       | Do    | 9th                                   |
   * |                       | D     | 9                                     |
   * | Weekday               | dddd  | Sunday                                |
   * |                       | ddd   | Sun                                   |
   * |                       | dd    | Su                                    |
   * |                       | d1    | S                                     |
   * |                       | do    | 0th                                   |
   * |                       | d     | 0                                     |
   * | Hour                  | HH    | 18 (00 - 23)                          |
   * |                       | H     | 18 (0 - 23)                           |
   * |                       | hh    | 06 (00 - 12)                          |
   * |                       | h     | 6 (0 - 12)                            |
   * |                       | KK    | 19 (01 - 24)                          |
   * |                       | K     | 19 (1 - 24)                           |
   * |                       | kk    | 06 or 18, locale determines           |
   * |                       | k     | 6 or 18, locale determines            |
   * | Minute                | mm    | 07                                    |
   * |                       | m     | 7                                     |
   * | Second                | ss    | 08                                    |
   * |                       | s     | 8                                     |
   * | Millisecond           | S     | 1 (100ms)                             |
   * |                       | SS    | 14 (140ms)                            |
   * |                       | SSS   | 145 (145ms)                           |
   * | AM/PM                 | A     | AM or PM                              |
   * |                       | a     | am or pm                              |
   * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
   * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
   * |                       | LST   | Depends on 12 or 24 hour clock        |
   * |                       |       | 12h, H : 1d, m : 0 or 2d              |
   * |                       |       | 24h, H : 2d, m : 2d                   |
   * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
   * |                       | l     | Y: n, M : n, D : n                    |
   * |                       | LL    | Y: n, M : long (l), D : n             |
   * |                       | ll    | Y: n, M : short (s), D : n            |
   * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
   * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
   * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
   * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
   *
   * Some examples:
   *
   * ```
   * DateHelper.format(new Date(2019, 7, 16), 'dddd') -> Friday
   * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'HH:mm') --> 14:27
   * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'L HH') --> 2019-07-16 14
   * ```
   *
   * Arbitrary text can be embedded in the format string by wrapping it with {}:
   *
   * ```
   * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
   * ```
   *
   * @param {Date} date Date
   * @param {String} format Desired format (uses `defaultFormat` if left out)
   * @returns {String} Formatted string
   * @category Parse & format
   */


  static format(date, format = DH.defaultFormat) {
    // Bail out if no date or invalid date
    if (!date || isNaN(date)) {
      return null;
    }

    let formatter = formatCache[format],
        output = '';

    if (!formatter) {
      formatter = formatCache[format] = []; // Build formatter array with the steps needed to format the date

      for (let i = 0; i < format.length; i++) {
        // Matches a predefined format?
        const formatMatch = format.substr(i).match(formatRegexp),
              predefined = formatMatch === null || formatMatch === void 0 ? void 0 : formatMatch[0];

        if (predefined) {
          const localeFormats = this.localize('L{formats}') || {},
                fn = localeFormats[predefined] || formats[predefined];
          formatter.push(fn);
          i += predefined.length - 1;
        } // Start of text block? Append it
        else if (format[i] === '{') {
          // Find closing brace
          const index = format.indexOf('}', i + 1); // No closing brace, grab rest of string

          if (index === -1) {
            formatter.push(format.substr(i + 1));
            i = format.length;
          } // Closing brace found
          else {
            formatter.push(format.substring(i + 1, index)); // Carry on after closing brace

            i = index;
          }
        } // Otherwise append to output (for example - / : etc)
        else {
          formatter.push(format[i]);
        }
      }
    }

    formatter.forEach(step => {
      if (typeof step === 'string') {
        output += step;
      } else {
        output += step(date);
      }
    }); // MS inserts a Left-to-right control char between localized date parts, remove it to have the expected string
    // output. Otherwise comparison with typed strings will fail

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      output = output.replace(/\u200E/g, '');
    }

    return output;
  }
  /**
   * Converts the specified amount of desired unit into milliseconds. Can be called by only specifying a unit as the
   * first argument, it then uses amount = 1. For example: asMilliseconds('hour') == asMilliseconds(1, 'hour')
   * @param {Number|String} amount Amount, what of is decided by specifying unit (also takes a unit which implies an amount of 1)
   * @param {String} unit Time unit (s, hour, months etc.)
   * @returns {Number}
   * @category Parse & format
   */


  static asMilliseconds(amount, unit = null) {
    if (typeof amount === 'string') {
      unit = amount;
      amount = 1;
    }

    return DH.as('millisecond', amount, unit);
  }
  /**
   * Converts the passed Date to an accurate number of months passed since the epoch start.
   * @param {Date} time The Date to find the month value of.
   * @returns {Number} The number of months since the system time epoch start. May be a fractional value.
   */


  static asMonths(time) {
    const monthLength = DH.as('ms', DH.daysInMonth(time), 'day'),
          fraction = (time.valueOf() - DH.startOf(time, 'month').valueOf()) / monthLength;
    return time.getYear() * 12 + time.getMonth() + fraction;
  }

  static monthsToDate(months) {
    const intMonths = Math.floor(months),
          fraction = months - intMonths,
          result = new Date(0, intMonths),
          msInMonth = DH.as('ms', DH.daysInMonth(result), 'days');
    result.setTime(result.getTime() + fraction * msInMonth);
    return result;
  }
  /**
   * Converts a millisecond time delta to a human readable form. For example `1000 * 60 * 60 * 50`
   * milliseconds would be rendered as "2 days, 2 hours"
   * @param {Number} delta The millisecond delta value.
   * @param {Object} [options] Formatting options.
   * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "2d, 2h" for the above example.
   * @param {String} [options.precision] The minimum precision unit.
   * @param {String} [options.separator] The separator to use
   * @param {Boolean} [options.asString] Pass `false` to return the result as an array, eg ['2d', '2h'] for the above example.
   * @returns {String} Formatted string
   * @category Parse & format
   */


  static formatDelta(delta, options) {
    let abbrev, unitName;

    if (typeof options === 'boolean') {
      abbrev = options;
    } else if (options) {
      abbrev = options.abbrev;
    }

    const deltaObj = this.getDelta(delta, options),
          result = [],
          sep = (options === null || options === void 0 ? void 0 : options.separator) || (abbrev ? '' : ' ');

    for (unitName in deltaObj) {
      result.push(`${deltaObj[unitName]}${sep}${unitName}`);
    }

    return (options === null || options === void 0 ? void 0 : options.asString) === false ? result : result.join(', ');
  }
  /**
   * Converts a millisecond time delta to an object structure. For example `1000 * 60 * 60 * 50`
   * milliseconds the result would be as:
   * {
   *     day: 2,
   *     hour: 2
   * }
   *
   * @param {Number} delta The millisecond delta value.
   * @param {Object} [options] Formatting options.
   * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "{ d: 2, h: 2 }" for the above example.
   * @param {String} [options.precision] The minimum precision unit.
   * @returns {Object} The object with the values for each unit.
   */


  static getDelta(delta, options) {
    let abbrev, d, done, precision, unitName;

    if (typeof options === 'boolean') {
      abbrev = options;
    } else if (options) {
      abbrev = options.abbrev;
      precision = DH.normalizeUnit(options.precision);
    }

    const result = {},
          getUnit = abbrev ? DH.getShortNameOfUnit : DH.getLocalizedNameOfUnit; // Loop downwards through the magnitude of units from year -> ms

    for (unitName of deltaUnits) {
      d = DH.as(unitName, delta);
      done = precision === unitName;
      d = Math[done ? 'round' : 'floor'](d); // If there's a non-zero integer quantity of this unit, add it to result
      // and subtract from the delta, then go round to next unit down.

      if (d || done && !result.length) {
        result[getUnit.call(DH, unitName, d !== 1)] = d; // TODO 0 is plural in EN but...?

        delta -= DH.as('ms', d, unitName);
      }

      if (done || !delta) {
        break;
      }
    }

    return result;
  }
  /**
   * Converts the specified amount of one unit (fromUnit) into an amount of another unit (toUnit)
   * @param {String} toUnit The name of units to convert to, eg: `'ms'`
   * @param {Number|String} amount The time to convert. Either the magnitude number form
   * or a duration string such as '2d'.
   * @param {String} [fromUnit] If the amount was passed as a number, the units to use to convert from.
   * @returns {Number}
   * @category Parse & format
   */


  static as(toUnit, amount, fromUnit = 'ms') {
    // Allow DH.as('ms', '2d')
    if (typeof amount === 'string') {
      amount = DH.parseDuration(amount);
    } // Allow DH.as('ms', myDurationObject)


    if (typeof amount === 'object') {
      fromUnit = amount.unit;
      amount = amount.magnitude;
    }

    if (toUnit === fromUnit) {
      return amount;
    }

    toUnit = DH.normalizeUnit(toUnit);
    fromUnit = DH.normalizeUnit(fromUnit);

    if (toUnit === fromUnit) {
      return amount;
    } // validConversions[][] can be negative to signal that conversion is not exact, ignore sign here
    else if (unitMagnitudes[fromUnit] > unitMagnitudes[toUnit]) {
      return amount * Math.abs(validConversions[fromUnit][toUnit]);
    } else {
      return amount / Math.abs(validConversions[toUnit][fromUnit]);
    }
  }

  static formatContainsHourInfo(format) {
    const stripEscapeRe = /(\\.)/g,
          hourInfoRe = /([HhKkmSsAa]|LT|L{3,}|l{3,})/;
    return hourInfoRe.test(format.replace(stripEscapeRe, ''));
  }
  /**
   * Returns true for 24 hour format.
   * @param {String} format Date format
   * @returns {Boolean}
   * @category Parse & format
   */


  static is24HourFormat(format) {
    return DH.format(DH.getTime(13, 0, 0), format).includes('13');
  } //endregion
  //region Manipulate

  /**
   * Add days, hours etc. to a date. Always clones the date, original will be left unaffected.
   * @param {Date|String} date Original date
   * @param {Number} amount Amount of days, hours etc
   * @param {String} unit Unit for amount
   * @privateparam {Boolean} [clone] Affect the original
   * @returns {Date} New calculated date
   * @category Manipulate
   */


  static add(date, amount, unit = 'ms', clone = true) {
    let d;

    if (typeof date === 'string') {
      d = DH.parse(date);
    } else if (clone) {
      d = new Date(date.getTime());
    } else {
      d = date;
    }

    if (!unit || amount === 0) {
      return d;
    }

    unit = DH.normalizeUnit(unit);

    switch (unit) {
      case 'millisecond':
        d.setTime(d.getTime() + amount);
        break;

      case 'second':
        d.setTime(d.getTime() + amount * 1000);
        break;

      case 'minute':
        d.setTime(d.getTime() + amount * 60000);
        break;

      case 'hour':
        d.setTime(d.getTime() + amount * 3600000);
        break;

      case 'day':
        // Integer value added, do calendar calculation to correctly handle DST etc.
        if (amount % 1 === 0) {
          d.setDate(d.getDate() + amount);
        } // No browsers support fractional values for dates any longer, do time based calculation
        else {
          d.setTime(d.getTime() + amount * 86400000);
        } // When crossing DST in Brazil, we expect hours to end up the same


        if (d.getHours() === 23 && date.getHours() === 0) {
          d.setHours(d.getHours() + 1);
        }

        break;

      case 'week':
        d.setDate(d.getDate() + amount * 7);
        break;

      case 'month':
        {
          let day = d.getDate();

          if (day > 28) {
            day = Math.min(day, DH.getLastDateOfMonth(DH.add(DH.getFirstDateOfMonth(d), amount, 'month')).getDate());
          }

          d.setDate(day);
          d.setMonth(d.getMonth() + amount);
          break;
        }

      case 'quarter':
        DH.add(d, amount * 3, 'month', false);
        break;

      case 'year':
        d.setFullYear(d.getFullYear() + amount);
        break;

      case 'decade':
        d.setFullYear(d.getFullYear() + amount * 10);
        break;
    }

    return d;
  }
  /**
   * Calculates the difference between two dates, in the specified unit.
   * @param {Date} start First date
   * @param {Date} end Second date
   * @param {String} unit Unit to calculate difference in
   * @param {Boolean} fractional Specify false to round result
   * @returns {Number} Difference in the specified unit
   * @category Manipulate
   */


  static diff(start, end, unit = 'ms', fractional = true) {
    unit = DH.normalizeUnit(unit);
    if (!start || !end) return 0;
    let amount;

    switch (unit) {
      case 'year':
        amount = DH.diff(start, end, 'month') / 12;
        break;

      case 'quarter':
        amount = DH.diff(start, end, 'month') / 3;
        break;

      case 'month':
        amount = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        break;

      case 'week':
        amount = DH.diff(start, end, 'day') / 7;
        break;

      case 'day':
        {
          const dstDiff = start.getTimezoneOffset() - end.getTimezoneOffset();
          amount = (end - start + dstDiff * 60 * 1000) / 86400000;
          break;
        }

      case 'hour':
        amount = (end - start) / 3600000;
        break;

      case 'minute':
        amount = (end - start) / 60000;
        break;

      case 'second':
        amount = (end - start) / 1000;
        break;

      case 'millisecond':
        amount = end - start;
        break;
    }

    return fractional ? amount : Math.round(amount);
  }
  /**
   * Sets the date to the start of the specified unit, by default returning a clone of the date instead of changing it
   * inplace.
   * @param {Date} date Original date
   * @param {String} unit Start of this unit, 'day', 'month' etc.
   * @param {Boolean} clone Manipulate a copy of the date
   * @returns {Date} Manipulated date
   * @category Manipulate
   */


  static startOf(date, unit = 'day', clone = true) {
    if (!date) {
      return null;
    }

    unit = DH.normalizeUnit(unit);

    if (clone) {
      date = DH.clone(date);
    }

    switch (unit) {
      case 'year':
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'quarter':
        date.setMonth((DH.get(date, 'quarter') - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'month':
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'week':
        {
          const delta = date.getDay() - DH.weekStartDay;
          date.setDate(date.getDate() - delta);
          date.setHours(0, 0, 0, 0);
          return date;
        }

      case 'day':
        date.setHours(0, 0, 0, 0);
        return date;
      // Cant use setMinutes(0, 0, 0) etc for DST transitions

      case 'hour':
        date.getMinutes() > 0 && date.setMinutes(0);
      // eslint-disable-next-line no-fallthrough

      case 'minute':
        date.getSeconds() > 0 && date.setSeconds(0);
      // eslint-disable-next-line no-fallthrough

      case 'second':
        date.getMilliseconds() > 0 && date.setMilliseconds(0);
      // eslint-disable-next-line no-fallthrough

      case 'millisecond':
        return date;
    }
  }
  /**
   * Returns the end point of the passed date, that is 00:00:00 of the day after the passed date.
   * @param {Date} date The date to return the end point of.
   */


  static endOf(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  }
  /**
   * Creates a clone of the specified date
   * @param {Date} date Original date
   * @returns {Date} Cloned date
   * @category Manipulate
   */


  static clone(date) {
    return new Date(date.getTime());
  }
  /**
   * Removes time from a date (same as calling #startOf(date, 'day'))
   * @param {Date} date Date to remove time from
   * @param {Boolean} clone Manipulate a copy of the date
   * @returns {Date} Manipulated date
   * @category Manipulate
   */


  static clearTime(date, clone = true) {
    if (!date) {
      return null;
    }

    if (clone) {
      date = new Date(date.getTime());
    }

    date.setHours(0, 0, 0, 0);
    return date;
  }

  static midnight(date, inclusive) {
    let ret = DH.clearTime(date);

    if (inclusive && ret < date) {
      ret = DH.add(ret, 1, 'd');
    }

    return ret;
  }
  /**
   * Returns the elapsed milliseconds from the start of the specified date.
   * @param {Date} date Date to remove date from.
   * @param {String} [as] The time unit to return.
   * @returns {Number} The elapsed milliseconds from the start of the specified date
   * @category Manipulate
   */


  static getTimeOfDay(date, as = 'ms') {
    const t = date.getHours() * validConversions.hour.millisecond + date.getMinutes() * validConversions.minute.millisecond + date.getSeconds() * validConversions.second.millisecond + date.getMilliseconds();
    return as === 'ms' ? t : DH.as(as, t, 'ms');
  }
  /**
   * Sets a part of a date (in place)
   * @param {Date} date Date to manipulate
   * @param {String|Object} unit Part of date to set, for example 'minute'. Or an object like { second: 1, minute: 1 }
   * @param {Number} amount Value to set
   * @returns {Date} Passed date instance modified according to the arguments
   * @category Manipulate
   */


  static set(date, unit, amount) {
    if (!unit) {
      return date;
    }

    if (typeof unit === 'string') {
      switch (DH.normalizeUnit(unit)) {
        case 'millisecond':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getMilliseconds() > 0) {
            date.setMilliseconds(amount);
          }

          break;

        case 'second':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getSeconds() > 0) {
            date.setSeconds(amount);
          }

          break;

        case 'minute':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getMinutes() > 0) {
            date.setMinutes(amount);
          }

          break;

        case 'hour':
          date.setHours(amount);
          break;

        case 'day':
        case 'date':
          date.setDate(amount);
          break;

        case 'week':
          throw new Error('week not implemented');

        case 'month':
          date.setMonth(amount);
          break;

        case 'quarter':
          // Setting quarter = first day of first month of that quarter
          date.setDate(1);
          date.setMonth((amount - 1) * 3);
          break;

        case 'year':
          date.setFullYear(amount);
          break;
      }
    } else {
      Object.entries(unit) // Make sure smallest unit goes first, to not change month before changing day
      .sort((a, b) => unitMagnitudes[a[0]] - unitMagnitudes[b[0]]).forEach(([unit, amount]) => {
        DH.set(date, unit, amount);
      });
    }

    return date;
  }

  static setDateToMidday(date, clone = true) {
    return DH.set(DH.clearTime(date, clone), 'hour', 12);
  }
  /**
   * Constrains the date within a min and a max date
   * @param {Date} date The date to constrain
   * @param {Date} [min] Min date
   * @param {Date} [max] Max date
   * @return {Date} The constrained date
   * @category Manipulate
   */


  static constrain(date, min, max) {
    if (min != null) {
      date = DH.max(date, min);
    }

    return max == null ? date : DH.min(date, max);
  }
  /**
   * Returns time with default year, month, and day (Jan 1, 2020)
   * @param {Number|Date} hours Hours value or the full date to extract the time of.
   * @param {Number} minutes Minutes value
   * @param {Number} seconds Seconds value
   * @param {Number} ms Milliseconds value
   * @returns {Date} A new default date with the time extracted from the given date or from the time values provided individually.
   * @category Manipulate
   */


  static getTime(hours, minutes = 0, seconds = 0, ms = 0) {
    if (hours instanceof Date) {
      ms = hours.getMilliseconds();
      seconds = hours.getSeconds();
      minutes = hours.getMinutes();
      hours = hours.getHours();
    }

    return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, hours, minutes, seconds, ms);
  }
  /**
   * Copies hours, minutes, seconds, milliseconds from one date to another
   *
   * @param {Date} targetDate The target date
   * @param {Date} sourceDate The source date
   * @return {Date} The adjusted target date
   * @category Manipulate
   * @static
   */


  static copyTimeValues(targetDate, sourceDate) {
    targetDate.setHours(sourceDate.getHours());
    targetDate.setMinutes(sourceDate.getMinutes());
    targetDate.setSeconds(sourceDate.getSeconds());
    targetDate.setMilliseconds(sourceDate.getMilliseconds());
    return targetDate;
  } //endregion
  //region Comparison


  static isDST(date) {
    const year = date.getFullYear(),
          jan = new Date(year, 0, 1),
          jul = new Date(year, 6, 1);
    return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }
  /**
   * Determines if a date precedes another.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @returns {Boolean} true if first precedes second, otherwise false
   * @category Comparison
   */


  static isBefore(first, second) {
    return first < second;
  }
  /**
   * Determines if a date succeeds another.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @returns {Boolean} true if first succeeds second, otherwise false
   * @category Comparison
   */


  static isAfter(first, second) {
    return first > second;
  }
  /**
   * Checks if two dates are equal.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @param {String} unit If not given, the comparison will be done up to a millisecond
   * @returns {Boolean} true if the dates are equal
   * @category Comparison
   */


  static isEqual(first, second, unit = null) {
    if (unit === null) {
      // https://jsbench.me/3jk2bom2r3/1
      // https://jsbench.me/ltkb3vk0ji/1 (more flavors) - getTime is >2x faster vs valueOf/Number/op+
      return first && second && first.getTime() === second.getTime();
    }

    return DH.startOf(first, unit) - DH.startOf(second, unit) === 0;
  }
  /**
   * Compares two dates using the specified precision
   * @param {Date} first
   * @param {Date} second
   * @param {String} unit
   * @returns {Number} 0 = equal, -1 first before second, 1 first after second
   * @category Comparison
   */


  static compare(first, second, unit = null) {
    // Unit specified, cut the rest out
    if (unit) {
      first = DH.startOf(first, unit);
      second = DH.startOf(second, unit);
    } // Comparison on ms level


    if (first < second) return -1;
    if (first > second) return 1;
    return 0;
  }

  static isSameDate(first, second) {
    return DH.compare(first, second, 'd') === 0;
  }
  /**
   * Checks if date is the start of specified unit
   * @param {Date} date
   * @param {String} unit
   * @returns {Boolean}
   * @category Comparison
   */


  static isStartOf(date, unit) {
    return DH.isEqual(date, DH.startOf(date, unit));
  }
  /**
   * Checks if this date is >= start and < end.
   * @param {Date} date The source date
   * @param {Date} start Start date
   * @param {Date} end End date
   * @return {Boolean} true if this date falls on or between the given start and end dates.
   * @category Comparison
   */


  static betweenLesser(date, start, end) {
    //return start <= date && date < end;
    return start.getTime() <= date.getTime() && date.getTime() < end.getTime();
  }
  /**
   * Checks if this date is >= start and <= end.
   * @param {Date} date The source date
   * @param {Date} start Start date
   * @param {Date} end End date
   * @return {Boolean} true if this date falls on or between the given start and end dates.
   * @category Comparison
   */


  static betweenLesserEqual(date, start, end) {
    return start.getTime() <= date.getTime() && date.getTime() <= end.getTime();
  }
  /**
   * Returns true if dates intersect
   * @param {Date} date1Start
   * @param {Date} date1End
   * @param {Date} date2Start
   * @param {Date} date2End
   * @return {Boolean} Returns true if dates intersect
   * @category Comparison
   */


  static intersectSpans(date1Start, date1End, date2Start, date2End) {
    return DH.betweenLesser(date1Start, date2Start, date2End) || DH.betweenLesser(date2Start, date1Start, date1End);
  }
  /**
   * Compare two units. Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
   * @param {String} unit1 The 1st unit
   * @param {String} unit2 The 2nd unit
   * @returns {Number} Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
   * @category Comparison
   */


  static compareUnits(unit1, unit2) {
    return Math.sign(unitMagnitudes[unit1] - unitMagnitudes[unit2]);
  }
  /**
   * Returns true if the first time span completely 'covers' the second time span.
   * @example
   * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 4)) ==> true
   * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 6)) ==> false
   * @param {Date} spanStart The start date for initial time span
   * @param {Date} spanEnd The end date for initial time span
   * @param {Date} otherSpanStart The start date for the 2nd time span
   * @param {Date} otherSpanEnd The end date for the 2nd time span
   * @return {Boolean}
   * @category Comparison
   */


  static timeSpanContains(spanStart, spanEnd, otherSpanStart, otherSpanEnd) {
    return otherSpanStart - spanStart >= 0 && spanEnd - otherSpanEnd >= 0;
  } //endregion
  //region Query

  /**
   * Get the first day of week, 0-6 (Sunday-Saturday).
   * This is determined by the current locale's `DateHelper.weekStartDay` parameter.
   * @property {Number}
   * @readonly
   */


  static get weekStartDay() {
    // Cache is reset in applyLocale
    if (DH._weekStartDay == null) {
      // Defaults to 0, should not need to happen in real world scenarios when a locale is always loaded
      DH._weekStartDay = this.localize('L{weekStartDay}') || 0;
    }

    return DH._weekStartDay;
  }
  /**
   * Get non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
   * This is determined by the current locale's `DateHelper.nonWorkingDays` parameter.
   *
   * For example:
   * ```
   * {
   *     0 : true, // Sunday
   *     6 : true  // Saturday
   * }
   * ```
   * @property {Object}
   * @readonly
   */


  static get nonWorkingDays() {
    return _objectSpread({}, this.localize('L{nonWorkingDays}'));
  }
  /**
   * Get non-working days as an array of day indices, 0-6 (Sunday-Saturday).
   * This is determined by the current locale's `DateHelper.nonWorkingDays` parameter.
   *
   * For example:
   * ```
   * [ 0, 6 ] // Sunday & Saturday
   * ```
   * @property {Number[]}
   * @readonly
   * @internal
   */


  static get nonWorkingDaysAsArray() {
    // transform string keys to integers
    return Object.keys(this.nonWorkingDays).map(Number);
  }
  /**
   * Get weekend days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
   * Weekends are days which are declared as weekend days by the selected country and defined by the current locale's `DateHelper.weekends` parameter.
   * To get non-working days see {@link #property-nonWorkingDays-static}.
   *
   * For example:
   * ```
   * {
   *     0 : true, // Sunday
   *     6 : true  // Saturday
   * }
   * ```
   * @property {Object}
   * @readonly
   * @internal
   */


  static get weekends() {
    return _objectSpread({}, this.localize('L{weekends}'));
  }
  /**
   * Get the specified part of a date
   * @param {Date} date
   * @param {String} unit Part of date, hour, minute etc.
   * @returns {Number} The requested part of the specified date
   * @category Query
   */


  static get(date, unit) {
    switch (DH.normalizeUnit(unit)) {
      case 'millisecond':
        return date.getMilliseconds();

      case 'second':
        return date.getSeconds();

      case 'minute':
        return date.getMinutes();

      case 'hour':
        return date.getHours();

      case 'date':
      case 'day':
        // Scheduler has a lot of calculations expecting this to work
        return date.getDate();

      case 'week':
        return formats.W(date);

      case 'month':
        return date.getMonth();

      case 'quarter':
        return Math.floor(date.getMonth() / 3) + 1;

      case 'year':
        return date.getFullYear();
    }

    return null;
  }
  /**
   * Get number of days in the current year for the supplied date.
   * @param {Date} date Date to check
   * @return {Number} Days in year
   * @category Query
   * @internal
   */


  static daysInYear(date) {
    const fullYear = date.getFullYear(),
          duration = new Date(fullYear + 1, 0, 1) - new Date(fullYear, 0, 1);
    return this.as('day', duration);
  }
  /**
   * Get number of days in the current month for the supplied date
   * @param {Date} date Date which month should be checked
   * @returns {Number} Days in month
   * @category Query
   */


  static daysInMonth(date) {
    const d = DH.clone(date);
    d.setDate(1);
    d.setMonth(date.getMonth() + 1);
    d.setDate(0);
    return d.getDate();
  }
  /**
   * Get number of hours in the current day for the supplied date.
   * @param {Date} date Date to check
   * @return {Number} Hours in day
   * @category Query
   * @internal
   */


  static hoursInDay(date) {
    const fullYear = date.getFullYear(),
          month = date.getMonth(),
          day = date.getDate(),
          duration = new Date(fullYear, month, day + 1) - new Date(fullYear, month, day);
    return this.as('hour', duration);
  }
  /**
   * Converts unit related to the date to actual amount of milliseconds in it. Takes into account leap years and
   * different duration of months.
   * @param {Date} date
   * @param {String} unit
   * @return {Number} Returns amount of milliseconds
   * @internal
   */


  static getNormalizedUnitDuration(date, unit) {
    let result;

    switch (unit) {
      case 'month':
        result = DH.asMilliseconds(DH.daysInMonth(date), 'day');
        break;

      case 'year':
        result = DH.asMilliseconds(DH.daysInYear(date), 'day');
        break;

      case 'day':
        result = DH.asMilliseconds(DH.hoursInDay(date), 'hour');
        break;

      default:
        result = DH.asMilliseconds(unit);
    }

    return result;
  }
  /**
   * Get the first date of the month for the supplied date
   * @param {Date} date
   * @returns {Date} New Date instance
   * @category Query
   */


  static getFirstDateOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }
  /**
   * Get the last date of the month for the supplied date
   * @param {Date} date
   * @returns {Date} New Date instance
   * @category Query
   */


  static getLastDateOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }
  /**
   * Get the earliest of two dates
   * @param {Date} first
   * @param {Date} second
   * @returns {Date} Earliest date
   * @category Query
   */


  static min(first, second) {
    return first.getTime() < second.getTime() ? first : second;
  }
  /**
   * Get the latest of two dates
   * @param {Date} first
   * @param {Date} second
   * @returns {Date} Latest date
   * @category Query
   */


  static max(first, second) {
    return first.getTime() > second.getTime() ? first : second;
  }
  /**
   * Get an incremented date. Incrementation based on specified unit and optional amount
   * @param {Date} date
   * @param {String} unit
   * @param {Number} [increment]
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   * @category Query
   */


  static getNext(date, unit, increment = 1, weekStartDay = DH.weekStartDay) {
    if (unit === 'week') {
      const dt = DH.clone(date),
            day = dt.getDay();
      DH.startOf(dt, 'day', false);
      DH.add(dt, weekStartDay - day + 7 * (increment - (weekStartDay <= day ? 0 : 1)), 'day', false); // For south american timezones, midnight does not exist on DST transitions, adjust...

      if (dt.getDay() !== weekStartDay) {
        DH.add(dt, 1, 'hour');
      }

      return dt;
    }

    return DH.startOf(DH.add(date, increment, unit), unit, false);
  }
  /**
   * Checks if date object is valid.
   *
   * For example:
   *
   * ```javascript
   * date = new Date('foo')
   * date instanceof Date // true
   * date.toString() // "Invalid Date"
   * isNaN(date) // true
   * DateHelper.isValidDate(date) // false
   *
   * date = new Date()
   * date instanceof Date // true
   * date.toString() // "Mon Jan 13 2020 18:27:38 GMT+0300 (GMT+03:00)"
   * isNaN(date) // false
   * DateHelper.isValidDate(date) // true
   * ```
   *
   * @param {Date} date
   * @returns {Boolean}
   */


  static isValidDate(date) {
    return DH.isDate(date) && !isNaN(date);
  }
  /**
   * Checks if value is a date object. Allows to recognize date object even from another context,
   * like the top frame when used in an iframe.
   *
   * @param {*} value
   * @returns {Boolean}
   */


  static isDate(value) {
    // see https://jsbench.me/s7kb49w83j/1 (cannot use instanceof cross-frame):
    return value && toString.call(value) === DATE_TYPE;
  }
  /**
   * Get the start of the next day
   * @param {Date} date
   * @param {Boolean} [clone]
   * @param {Boolean} [noNeedToClearTime=false]
   * @returns {Date} Passed Date or new Date instance, depending on the `clone` flag
   * @category Query
   */


  static getStartOfNextDay(date, clone, noNeedToClearTime) {
    let nextDay = DH.add(noNeedToClearTime ? date : DH.clearTime(date, clone), 1, 'day'); // DST case

    if (nextDay.getDate() === date.getDate()) {
      const offsetNextDay = DH.add(DH.clearTime(date, clone), 2, 'day').getTimezoneOffset(),
            offsetDate = date.getTimezoneOffset();
      nextDay = DH.add(nextDay, offsetDate - offsetNextDay, 'minute');
    }

    return nextDay;
  }
  /**
   * Get the end of previous day
   * @param {Date} date
   * @param {Boolean} noNeedToClearTime
   * @returns {Date} New Date instance
   * @category Query
   */


  static getEndOfPreviousDay(date, noNeedToClearTime) {
    const dateOnly = noNeedToClearTime ? date : DH.clearTime(date, true); // dates are different

    if (dateOnly - date) {
      return dateOnly;
    } else {
      return DH.add(dateOnly, -1, 'day');
    }
  }
  /**
   * Returns a string describing the specified week. For example, "39, September 2020" or "40, Sep - Oct 2020".
   * @param {Date} startDate
   * @param {Date} [endDate]
   * @returns {String}
   * @internal
   */


  static getWeekDescription(startDate, endDate = startDate) {
    const monthDesc = startDate.getMonth() === endDate.getMonth() ? DateHelper.format(startDate, 'MMMM') : `${DateHelper.format(startDate, 'MMM')} - ${DateHelper.format(endDate, 'MMM')}`,
          week = DateHelper.getWeekNumber(startDate);
    return `${week[1]}, ${monthDesc} ${week[0]}`;
  }
  /**
   * Get week number for the date.
   * @param {Date} date date
   * @param {Number} weekStartDay first day of week, 0-6 (Sunday-Saturday). Defaults to the {@link #property-weekStartDay-static}.
   * @returns {Number[]} year and week number
   * @category Query
   */


  static getWeekNumber(date, weekStartDay = DateHelper.weekStartDay) {
    const jan01 = new Date(date.getFullYear(), 0, 1),
          dec31 = new Date(date.getFullYear(), 11, 31),
          firstDay = normalizeDay(jan01.getDay() - weekStartDay),
          lastDay = normalizeDay(dec31.getDay() - weekStartDay),
          dayNumber = getDayDiff(date, jan01);
    let weekNumber; // Check if the year starts before the middle of a week

    if (firstDay < 4) {
      weekNumber = Math.floor((dayNumber + firstDay - 1) / 7) + 1;
    } else {
      weekNumber = Math.floor((dayNumber + firstDay - 1) / 7);
    }

    if (weekNumber) {
      let year = date.getFullYear(); // Might be week 1 of next year if the year ends before day 3 (0 based)

      if (weekNumber === 53 && lastDay < 3) {
        year++;
        weekNumber = 1;
      }

      return [year, weekNumber];
    } // We're in week zero which is the last week of the previous year, so ask what
    // week encapsulates 31 Dec in the previous year.


    const lastWeekOfLastYear = DateHelper.getWeekNumber(new Date(date.getFullYear() - 1, 11, 31))[1];
    return [date.getFullYear() - 1, lastWeekOfLastYear];
  } //endregion
  //region Unit helpers

  /**
   * Turns (10, 'day') into '10 days' etc.
   * @param {Number} count Amount of unit
   * @param {String} unit Unit, will be normalizes (days, d -> day etc.)
   * @returns {String}
   * @category Unit helpers
   */


  static formatCount(count, unit) {
    unit = DH.normalizeUnit(unit);
    if (count !== 1) unit += 's';
    return count + ' ' + unit;
  }
  /**
   * Get the ratio between two units ( year, month -> 1/12 )
   * @param {String} baseUnit
   * @param {String} unit
   * @param {Boolean} acceptEstimate If true, process negative values of validConversions. Defaults to false.
   * @returns {Number} Ratio
   * @category Unit helpers
   */


  static getUnitToBaseUnitRatio(baseUnit, unit, acceptEstimate = false) {
    baseUnit = DH.normalizeUnit(baseUnit);
    unit = DH.normalizeUnit(unit);
    if (baseUnit === unit) return 1; // Some validConversions have negative sign to signal that it is not an exact conversion.
    // Ignore those here unless acceptEstimate is provided.

    if (validConversions[baseUnit] && validConversions[baseUnit][unit] && (acceptEstimate || validConversions[baseUnit][unit] > 0)) {
      return 1 / DH.as(unit, 1, baseUnit);
    }

    if (validConversions[unit] && validConversions[unit][baseUnit] && (acceptEstimate || validConversions[unit][baseUnit] > 0)) {
      return DH.as(baseUnit, 1, unit);
    }

    return -1;
  }
  /**
   * Returns a localized abbreviated form of the name of the duration unit.
   * For example in the `EN` locale, for `"qrt"` it will return `"q"`.
   * @param {String} unit Duration unit
   * @return {String}
   * @category Unit helpers
   */


  static getShortNameOfUnit(unit) {
    // Convert abbreviations to the canonical name.
    // See locale file and the applyLocale method below.
    unit = DH.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

    return DH.unitLookup[unit].abbrev;
  }
  /**
   * Returns a localized full name of the duration unit.
   *
   * For for example in the `EN` locale, for `"d"` it will return either
   * `"day"` or `"days"`, depending from the `plural` argument
   *
   * Preserves casing of first letter.
   *
   * @static
   * @param {String} unit Time unit
   * @param {Boolean} [plural] Whether to return a plural name or singular
   * @return {String}
   * @category Unit helpers
   */


  static getLocalizedNameOfUnit(unit, plural = false) {
    const capitalize = unit.charAt(0) === unit.charAt(0).toUpperCase(); // Normalize to not have to have translations for each variation used in code

    unit = DH.normalizeUnit(unit); // Convert abbreviations to the canonical name.
    // See locale file and the applyLocale method below.

    unit = DH.parseTimeUnit(unit); // Translate
    // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

    unit = DH.unitLookup[unit][plural ? 'plural' : 'single']; // Preserve casing of first letter

    if (capitalize) {
      unit = _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(unit);
    }

    return unit;
  }
  /**
   * Normalizes a unit for easier usage in conditionals. For example year, years, y -> year
   * @param {String} unit
   * @returns {String}
   * @category Unit helpers
   */


  static normalizeUnit(unit) {
    if (!unit) {
      return null;
    }

    const unitLower = unit.toLowerCase();

    if (unitLower === 'date') {
      return unitLower;
    }

    return canonicalUnitNames.includes(unitLower) // Already valid
    ? unitLower // Trying specified case first, since we have both "M" for month and "m" for minute
    : normalizedUnits[unit] || normalizedUnits[unitLower];
  }

  static getUnitByName(name) {
    // Allow either a canonical name to be passed, or, if that fails, parse it as a localized name or abbreviation.
    return DH.normalizeUnit(name) || DH.normalizeUnit(DH.parseTimeUnit(name));
  }
  /**
   * Returns a duration of the timeframe in the given unit.
   * @param {Date} start The start date of the timeframe
   * @param {Date} end The end date of the timeframe
   * @param {String} unit Duration unit
   * @return {Number} The duration in the units
   * @category Unit helpers
   * @ignore
   */


  static getDurationInUnit(start, end, unit, doNotRound) {
    return DH.diff(start, end, unit, doNotRound);
  }
  /**
   * Checks if two date units align
   * @private
   * @param {String} majorUnit
   * @param {String} minorUnit
   * @returns {Boolean}
   * @category Unit helpers
   */


  static doesUnitsAlign(majorUnit, minorUnit) {
    // TODO: probably needs some fleshing out to be generally useful, otherwise move to TimeAxisViewModel?
    // Maybe also use getUnitToBaseUnitRatio() for assertion?
    return !(majorUnit !== minorUnit && minorUnit === 'week');
  }

  static getSmallerUnit(unit) {
    return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] - 1] || null;
  }

  static getLargerUnit(unit) {
    return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] + 1] || null;
  }
  /**
   *
   * Rounds the passed Date value to the nearest `increment` value.
   *
   * Optionally may round relative to a certain base time point.
   *
   * For example `DH.round(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would round to 9:45 because that's the nearest integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when rounding to weeks. The configured {@link #property-weekStartDay-static}
   * dictates what the base of a week is.
   *
   * @param {Date} time The time to round
   * @param {String|Number} increment A millisecond value by which to round the time.
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the rounding.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static round(time, increment, base, weekStartDay) {
    return DH.snap('round', time, increment, base, weekStartDay);
  }
  /**
   *
   * Floor the passed Date value to the nearest `increment` value.
   *
   * Optionally may floor relative to a certain base time point.
   *
   * For example `DH.floor(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would floor to 9:15 because that's the closest lower integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when flooring to weeks. The configured {@link #property-weekStartDay-static}
   * dictates what the base of a week is.
   *
   * @param {Date} time The time to floor
   * @param {String|Number} increment A millisecond value by which to floor the time.
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the flooring.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static floor(time, increment, base, weekStartDay) {
    return DH.snap('floor', time, increment, base, weekStartDay);
  }
  /**
   *
   * Ceils the passed Date value to the nearest `increment` value.
   *
   * Optionally may ceil relative to a certain base time point.
   *
   * For example `DH.ceil(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would ceil to 9:45 because that's the closest higher integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when ceiling to weeks. Use weekStartDay argument which default to the configured
   * {@link #property-weekStartDay-static} dictates what the base of a week is
   *
   * @param {Date} time The time to ceil
   * @param {String|Number|Object} increment A numeric millisecond value by which to ceil the time.
   * or a duration in string form eg `'30 min'` or object form : `{unit: "minute", magnitude: 30}`
   * or `{unit: "minute", increment: 30}`
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the ceiling.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static ceil(time, increment, base, weekStartDay) {
    return DH.snap('ceil', time, increment, base, weekStartDay);
  }
  /**
   * Implementation for round, floor and ceil.
   * @internal
   */


  static snap(operation, time, increment, base, weekStartDay = DH.weekStartDay) {
    const snapFn = snapFns[operation];

    if (typeof increment === 'string') {
      increment = DH.parseDuration(increment);
    }

    if (_util_Objects_js__WEBPACK_IMPORTED_MODULE_4__["default"].isObject(increment)) {
      // Allow {unit: "minute", increment: 30} or {unit: "minute", magnitude: 30}
      // parseDuration produces "magnitude". The Scheduler's TimeAxis uses "increment"
      // in its resolution object, so we allow that too.
      const magnitude = increment.magnitude || increment.increment; // increment is in weeks, months, quarters or years, then it can't be handled
      // using millisecond arithmetic.

      switch (increment.unit) {
        case 'week':
          {
            const weekDay = time.getDay(); // weekStartDay gives our base
            // Our base is the start of the week

            base = DH.add(DH.clearTime(time), weekDay >= weekStartDay ? weekStartDay - weekDay : -(weekDay - weekStartDay + 7), 'day');
            return DH[operation](time, `${magnitude * 7} days`, base);
          }

        case 'month':
          {
            // Express the time as a number of months from epoch start.
            // May be a fraction, eg the 15th will be 0.5 through a month.
            time = DH.asMonths(time);
            let resultMonths; // Snap the month count in the way requested

            if (base) {
              base = DH.asMonths(base);
              resultMonths = time + snapFn(time - base, magnitude);
            } else {
              resultMonths = snapFn(time, magnitude);
            } // Convert resulting month value back to a date


            return DH.monthsToDate(resultMonths);
          }

        case 'quarter':
          return DH[operation](time, `${magnitude * 3} months`, base);

        case 'year':
          return DH[operation](time, `${magnitude * 12} months`, base);

        case 'decade':
          // We assume that decades begin with a year divisible by 10
          return DH[operation](time, `${magnitude * 10} years`, base);
      } // Convert to a millisecond value


      increment = DH.as('ms', magnitude, increment.unit);
    } // It's a simple round to milliseconds


    if (base) {
      const tzChange = DH.as('ms', base.getTimezoneOffset() - time.getTimezoneOffset(), 'ms');
      return new Date(base.valueOf() + snapFn(DH.diff(base, time, 'ms') + tzChange, increment));
    } else {
      const offset = time.getTimezoneOffset() * 60 * 1000; // Assuming current TZ is GMT+3
      // new Date(2000, 0, 1) / 86400000      -> 10956.875
      // new Date(2000, 0, 1, 3) / 86400000   -> 10957
      // Before calculation we need to align time value of the current timezone to GMT+0
      // And after calculate we need to adjust time back

      return new Date(snapFn(time.valueOf() - offset, increment) + offset);
    }
  } //endregion
  //region Date picker format

  /**
   * Parses a typed duration value according to locale rules.
   *
   * The value is taken to be a string consisting of the numeric magnitude and the units:
   * - The numeric magnitude can be either an integer or a float value. Both "," and "." are valid decimal separators.
   * - The units may be a recognised unit abbreviation of this locale or the full local unit name.
   *
   * For example:
   * "2d", "2 d", "2 day", "2 days" will be turned into `{ magnitude : 2, unit : "day" }`
   * "2.5d", "2,5 d", "2.5 day", "2,5 days" will be turned into `{ magnitude : 2.5, unit : "day" }`
   *
   * **NOTE:** Doesn't work with complex values like "2 days, 2 hours"
   *
   * @param {String} value The value to parse.
   * @param {Boolean} [allowDecimals=true] Decimals are allowed in the magnitude.
   * @param {String} [defaultUnit] Default unit to use if only magnitude passed.
   * @returns {Object} If successfully parsed, the result contains two properties,
   * `magnitude` being a number, and `unit` being the canonical unit name, *NOT*
   * a localized name. If parsing was unsuccessful, `null` is returned.
   * @category Parse & format
   */


  static parseDuration(value, allowDecimals = true, defaultUnit) {
    var _match$;

    const durationRegEx = allowDecimals ? withDecimalsDurationRegex : noDecimalsDurationRegex,
          match = durationRegEx.exec(value);

    if (value == null || !match) {
      return null;
    }

    const magnitude = parseNumber((_match$ = match[1]) === null || _match$ === void 0 ? void 0 : _match$.replace(',', '.')),
          unit = DH.parseTimeUnit(match[2]) || defaultUnit;

    if (!unit) {
      return null;
    }

    return {
      magnitude,
      unit
    };
  }
  /**
   * Parses a typed unit name, for example `"ms"` or `"hr"` or `"yr"` into the
   * canonical form of the unit name which may be passed to {@link #function-add-static}
   * or {@link #function-diff-static}
   * @param {*} unitName
   * @category Parse & format
   */


  static parseTimeUnit(unitName) {
    // NOTE: In case you get a crash here when running tests, it is caused by missing locale. Build locales
    // using `scripts/build.js locales` to resolve.
    const unitMatch = unitName == null ? null : DH.durationRegEx.exec(unitName.toLowerCase());

    if (!unitMatch) {
      return null;
    } // See which group in the unitAbbrRegEx matched match[2]


    for (let unitOrdinal = 0; unitOrdinal < canonicalUnitNames.length; unitOrdinal++) {
      if (unitMatch[unitOrdinal + 1]) {
        return canonicalUnitNames[unitOrdinal];
      }
    }
  } //endregion
  //region Internal


  static getGMTOffset(date = new Date()) {
    if (!date) {
      return;
    }

    const offsetInMinutes = date.getTimezoneOffset(); // return 'Z' for UTC

    if (!offsetInMinutes) return 'Z';
    return (offsetInMinutes > 0 ? '-' : '+') + Math.abs(Math.trunc(offsetInMinutes / 60)).toString().padStart(2, '0') + ':' + Math.abs(offsetInMinutes % 60).toString().padStart(2, '0');
  }

  static fillDayNames() {
    const tempDate = new Date('2000-01-01T12:00:00'),
          dayNames = DH._dayNames || [],
          dayShortNames = DH._dayShortNames || [];
    dayNames.length = 0;
    dayShortNames.length = 0;

    for (let day = 2; day < 9; day++) {
      tempDate.setDate(day);
      dayNames.push(DH.format(tempDate, 'dddd'));
      dayShortNames.push(DH.format(tempDate, 'ddd'));
    }

    DH._dayNames = dayNames;
    DH._dayShortNames = dayShortNames;
  }

  static getDayNames() {
    return DH._dayNames;
  }

  static getDayName(day) {
    return DH._dayNames[day];
  }

  static getDayShortNames() {
    return DH._dayShortNames;
  }

  static getDayShortName(day) {
    return DH._dayShortNames[day];
  }

  static fillMonthNames() {
    const tempDate = new Date('2000-01-15T12:00:00'),
          monthNames = DH._monthNames || [],
          monthShortNames = DH._monthShortNames || [];
    monthNames.length = 0;
    monthShortNames.length = 0;

    for (let month = 0; month < 12; month++) {
      tempDate.setMonth(month);
      monthNames.push(DH.format(tempDate, 'MMMM'));
      monthShortNames.push(DH.format(tempDate, 'MMM'));
    }

    DH._monthNames = monthNames;
    DH._monthShortNames = monthShortNames;
  }

  static getMonthShortNames() {
    return DH._monthShortNames;
  }

  static getMonthShortName(month) {
    return DH._monthShortNames[month];
  }

  static getMonthNames() {
    return DH._monthNames;
  }

  static getMonthName(month) {
    return DH._monthNames[month];
  }

  static set locale(name) {
    locale = name;
    intlFormatterCache = {};
    formatCache = {};
  }

  static get locale() {
    return locale;
  }

  static setupDurationRegEx(unitNames = [], unitAbbreviations = []) {
    const me = this,
          unitLookup = {};
    let unitAbbrRegEx = '';

    for (let i = 0; i < unitAbbreviations.length; i++) {
      const // for example ['s', 'sec']
      abbreviations = unitAbbreviations[i],
            // for example { single : 'second', plural : 'seconds', abbrev : 's' }
      unitNamesCfg = unitNames[i];
      unitNamesCfg.canonicalUnitName = canonicalUnitNames[i]; // Create a unitLookup object keyed by unit full names
      // both lower and upper case to be able to look up plurals or abbreviations
      // also always include english names, since those are used in sources

      unitLookup[unitNamesCfg.single] = unitLookup[unitNamesCfg.single.toUpperCase()] = unitLookup[unitNamesCfg.canonicalUnitName] = unitLookup[unitNamesCfg.canonicalUnitName.toUpperCase()] = unitNamesCfg;
      unitAbbrRegEx += `${i ? '|' : ''}(`;

      for (let j = 0; j < abbreviations.length; j++) {
        unitAbbrRegEx += `${abbreviations[j]}|`;
      }

      locale = me.localize('L{locale}') || 'en-US';

      if (locale !== 'en-US') {
        // Add canonical values to be able to parse durations specified in configs
        const canonicalAbbreviations = canonicalUnitAbbreviations[i];

        for (let j = 0; j < canonicalAbbreviations.length; j++) {
          unitAbbrRegEx += `${canonicalAbbreviations[j]}|`;
        }
      }

      unitAbbrRegEx += `${unitNamesCfg.single}|${unitNamesCfg.plural}|${unitNamesCfg.canonicalUnitName}|${unitNamesCfg.canonicalUnitName}s)`;
    }

    me.unitLookup = unitLookup;
    me.durationRegEx = new RegExp(`^(?:${unitAbbrRegEx})$`);
  }

  static applyLocale() {
    const me = this,
          unitAbbreviations = me.localize('L{unitAbbreviations}') || [],
          unitNames = me.unitNames = me.localize('L{unitNames}'); // This happens when applying an incomplete locale, as done in Localizable.t.js.
    // Invalid usecase, but return to prevent a crash in that test.

    if (unitNames === 'unitNames') {
      return;
    }

    locale = me.localize('L{locale}') || 'en-US';

    if (locale === 'en-US') {
      // TODO: Include in En locale instead?
      ordinalSuffix = enOrdinalSuffix;
    } else {
      ordinalSuffix = me.localize('L{ordinalSuffix}') || ordinalSuffix;
    }

    formatCache = {};
    parserCache = {};
    intlFormatterCache = {};
    DH._weekStartDay = null;
    DH.setupDurationRegEx(unitNames, unitAbbreviations); // rebuild day/month names cache

    DH.fillDayNames();
    DH.fillMonthNames();
  } //endregion


}
const DH = DateHelper;
DH.useIntlFormat = useIntlFormat; // to use on tests
// Update when changing locale

_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
  locale: 'applyLocale',
  prio: 1000,
  thisObj: DH
}); // Apply default locale

if (_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale) {
  DH.applyLocale();
}

DateHelper._$name = 'DateHelper';

/***/ }),

/***/ "./lib/Core/helper/DomHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/DomHelper.js ***!
  \**************************************/
/*! exports provided: hasLayout, isVisible, isInDocument, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLayout", function() { return hasLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVisible", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInDocument", function() { return isInDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomHelper; });
/* harmony import */ var _AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






 // Point must be imported because it needs to inject itself into the Rectangle class
//import './util/Point.js';
// TODO import VersionHelper from './VersionHelper.js';
// https://app.assembla.com/spaces/bryntum/tickets/7903-rendering-fails
// HACK: this value is required to calculate width if it was configured relative to font size (em) but no element is set

const DEFAULT_FONT_SIZE = 14,
      t0t0 = {
  align: 't0-t0'
},
      // eslint-disable-next-line no-undef
ELEMENT_NODE = Node.ELEMENT_NODE,
      // eslint-disable-next-line no-undef
TEXT_NODE = Node.TEXT_NODE,
      {
  isObject
} = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      // Transform matrix parse Regex. CSS transform computed style looks like this:
// matrix(scaleX(), skewY(), skewX(), scaleY(), translateX(), translateY())
// or
// matrix3d(scaleX(), skewY(), 0, 0, skewX(), scaleY(), 0, 0, 0, 0, 1, 0, translateX(), translateY())
// This is more reliable than using the style literal which may include
// relative styles such as "translateX(-20em)", or not include the translation at all if it's from a CSS rule.
// Use a const so as to only compile RexExp once
// Extract repeating number regexp to simplify next expressions. Available values are: https://developer.mozilla.org/en-US/docs/Web/CSS/number
numberRe = /[+-]?\d*\.?\d+[eE]?-?\d*/g,
      // -2.4492935982947064e-16 should be supported
numberReSrc = numberRe.source,
      translateMatrix2dRe = new RegExp(`matrix\\((?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(${numberReSrc}),\\s?(${numberReSrc})`),
      translateMatrix3dRe = new RegExp(`matrix3d\\((?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(-?\\d*),\\s?(-?\\d*)`),
      translateMatrixRe = new RegExp(`(?:${translateMatrix2dRe.source})|(?:${translateMatrix3dRe.source})`),
      pxTtranslateXRe = new RegExp(`translate(3d|X)?\\((${numberReSrc})px(?:,\\s?(${numberReSrc})px)?`),
      pxTtranslateYRe = new RegExp(`translate(3d|Y)?\\((${numberReSrc})px(?:,\\s?(${numberReSrc})px)?`),
      domIdRe = /^[^a-z]+|[^\w:.-]+/gi,
      whiteSpaceRe = /\s+/,
      semicolonRe = /\s*;\s*/,
      colonRe = /\s*:\s*/,
      digitsRe = /^-?((\d+(\.\d*)?)|(\.?\d+))$/,
      elementPropKey = '$bryntum',
      // A blank value means the expando name is the same as the key in this object, otherwise the key in this object is
// the name of the domConfig property and the value is the name of the DOM element expando property.
elementCreateExpandos = {
  elementData: '',
  for: 'htmlFor',
  retainElement: ''
},
      // DomHelper#createElement properties which require special processing.
// All other configs such as id and type are applied directly to the element.
elementCreateProperties = {
  // these two are handled by being in elementCreateExpands:
  // elementData  : 1,
  // for          : 1,
  tag: 1,
  html: 1,
  text: 1,
  children: 1,
  tooltip: 1,
  style: 1,
  dataset: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  class: 1,
  className: 1,
  unmatched: 1,
  // Used by syncId approach
  onlyChildren: 1,
  // Used by sync to not touch the target element itself,
  listeners: 1,
  compareHtml: 1,
  // Sync,
  syncOptions: 1 // Sync

},
      styleIgnoreProperties = {
  length: 1,
  parentRule: 1,
  style: 1
},
      nativeFocusableTags = {
  BUTTON: 1,
  IFRAME: 1,
  EMBED: 1,
  INPUT: 1,
  OBJECT: 1,
  SELECT: 1,
  TEXTAREA: 1,
  HTML: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? 1 : 0,
  BODY: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? 0 : 1
},
      win = window,
      doc = document,
      emptyObject = {},
      emptyArray = [],
      arraySlice = Array.prototype.slice,
      immediatePromise = Promise.resolve(),
      fontProps = ['font-size', 'font-size-adjust', 'font-style', 'font-weight', 'font-family', 'font-kerning', 'font-stretch', 'line-height', 'text-transform', 'text-decoration', 'letter-spacing', 'word-break'],
      isHiddenWidget = e => e._hidden,
      parentNode = el => el.parentNode || el.host,
      mergeChildren = (dest, src, options) => {
  if (options.key === 'children') {
    // Normally "children" is an array (for which we won't be here, due to isObject check in caller). To
    // maintain declarative order of children as an object, we need some special sauce:
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeItems(dest, src, options);
  }

  return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].blend(dest, src, options);
},
      isVisible = e => {
  const style = e.ownerDocument.defaultView.getComputedStyle(e);
  return style.getPropertyValue('display') !== 'none' && style.getPropertyValue('visibility') !== 'hidden';
},
      getRootNode = doc.documentElement.getRootNode ? el => el.getRootNode() : el => {
  while (el.parentNode) el = el.parentNode;

  return el;
},
      // Both Shadow Root Element and Anchor <a> Element have `host` property.
// https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/host
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/host
// Need make sure `host` is an Element.
isShadowRoot = el => el.host && el.host instanceof Element,
      // Check whether the element has an offsetParent.
// Nodes such as SVG which do not expose such a property must have an ancestor which has an offsetParent.
hasLayout = el => el && (el === doc.body || ('offsetParent' in el ? el.offsetParent : hasLayout(el.parentNode))),
      // Check for node being in document.
// If part of shadow DOM, see if the root's host is in the DOM
isInDocument = el => el && (doc.body.contains(el) || (root = getRootNode(el)) && isShadowRoot(root) && isInDocument(root.host)),
      elementOrConfigToElement = elementOrConfig => {
  if (elementOrConfig instanceof Node) {
    return elementOrConfig;
  }

  if (typeof elementOrConfig === 'string') {
    return DH.createElementFromTemplate(elementOrConfig);
  }

  return DH.createElement(elementOrConfig);
},
      canonicalStyles = Object.create(null),
      canonicalizeStyle = (name, hasUnit) => {
  const entry = canonicalStyles[name] || [_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(name), hasUnit];

  if (!canonicalStyles[name]) {
    canonicalStyles[entry[0]] = canonicalStyles[name] = entry;
  }

  return entry;
},
      getOffsetParent = node => node.ownerSVGElement ? node.ownerSVGElement.parentNode : node.offsetParent;

 // Push the styles that have units into the map:

['top', 'right', 'bottom', 'left', 'width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'borderSpacing', 'borderWidth', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontSize', 'letterSpacing', 'lineHeight', 'outlineWidth', 'textIndent', 'wordSpacing'].forEach(name => canonicalizeStyle(name, true)); // We only do the measurement once, if the value is null

let scrollBarWidth = null,
    idCounter = 0,
    themeInfo = null,
    root,
    templateElement,
    htmlParser;
/**
 * @module Core/helper/DomHelper
 */

/**
 * An object that describes a DOM element. Used for example by {@link #function-createElement-static createElement()}
 * and by {@link Core.helper.DomSync#function-sync-static DomSync.sync()}.
 *
 * ```javascript
 * DomHelper.createElement({
 *    class : {
 *        big   : true,
 *        small : false
 *    },
 *    children : [
 *        { tag : 'img', src : 'img.png' },
 *        { html : '<b style="color: red">Red text</b>' }
 *    ]
 * });
 * ```
 *
 * @typedef {Object} DomConfig
 * @property {String} [tag='div'] Tag name, for example 'span'
 * @property {HTMLElement} [parent] Parent element
 * @property {HTMLElement} [nextSibling] Element's next sibling in the parent element
 * @property {String|Object} [class] CSS classes, as a string or an object (truthy keys will be applied)
 * @property {String|Object} [className] Alias for `class`
 * @property {String|Object} [style] Style, as a string or an object (keys will be hyphenated)
 * @property {Object} [elementData] Data object stored as an expando on the resulting element
 * @property {Object} [dataset] Dataset applied to the resulting element
 * @property {DomConfig[]|DomConfig|String} [children] Child elements, as an array of DomConfigs or an object map thereof or a simple string value to create a text node
 * @property {String} [html] Html string, used as the resulting elements `innerHTML`. Mutually exclusive with the `children` property
 * @property {Object} [tooltip] Tooltip config applied to the resulting element
 * @property {String} [text] Text content, XSS safe when you want to display text in the element. Mutually exclusive with the `children` property
 * @property {String} [id] Element's `id`
 * @property {String} [href] Element's `href`
 * @property {String} [ns] Element's namespace
 * @property {String} [src] Element's `src`
 */

/**
 * Helps with dom querying and manipulation.
 *
 * ```javascript
 * DomHelper.createElement({
 *   tag: 'div',
 *   className: 'parent',
 *   style: 'background: red',
 *   children: [
 *      { tag: 'div', className: 'child' },
 *      { tag: 'div', className: 'child' }
 *   ]
 * });
 * ```
 */

class DomHelper {
  /**
   * Returns `true` if the passed element is focusable either programmatically or through pointer gestures.
   * @param {HTMLElement} element The element to test.
   * @return {Boolean} Returns `true` if the passed element is focusable
   */
  static isFocusable(element, skipAccessibilityCheck = false) {
    if (!skipAccessibilityCheck) {
      // If element is hidden or in a hidden Widget, it's not focusable.
      if (!DH.isVisible(element) || DH.Widget.fromElement(element, isHiddenWidget)) {
        return false;
      }
    }

    const nodeName = element.nodeName;
    /*
     * An element is focusable if:
     *   - It is natively focusable, or
     *   - It is an anchor or link with href attribute, or
     *   - It has a tabIndex, or
     *   - It is an editing host (contenteditable="true")
     */

    return nativeFocusableTags[nodeName] || (nodeName === 'A' || nodeName === 'LINK') && !!element.href || element.getAttribute('tabIndex') != null || element.contentEditable === 'true';
  }
  /**
   * Returns the rectangle of the element which is currently visible in the browser viewport, i.e. user can find it on
   * screen, or `false` if it is scrolled out of view.
   * @param {HTMLElement} target The element to test.
   * @param {Boolean} [whole=false] Whether to check that whole element is visible, not just part of it.
   * If this is passed as true, the result will be a boolean, `true` or `false`.
   * @return {Core.helper.util.Rectangle|Boolean} Returns the rectangle of the element which is currently visible in
   * the browser viewport, or `false` if it is out of view.
   */


  static isInView(target, whole = false, positioned) {
    const top = target.ownerDocument,
          method = whole ? 'contains' : 'intersect',
          offsetParent = getOffsetParent(target),
          opR = positioned && _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(offsetParent);

    if (target === top.body) {
      return _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(top);
    }

    let result = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(target, null, true);

    for (let viewport = offsetParent; result && viewport !== top; viewport = viewport.parentNode) {
      // Skip shadow root node.
      if (viewport.nodeType === Node.DOCUMENT_FRAGMENT_NODE && viewport.host) {
        viewport = viewport.host.parentNode;
      } // When we get to document.body, pass document to Rectangle.inner so that it produces
      // the *viewport* rectangle, not the whole scroll height of the document.


      result = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].inner(viewport === top.body ? top : viewport)[method](result, false, true);
    } // We must use the *viewport* coordinate system to ascertain viewability


    if (result && positioned) {
      result.translate(document.scrollingElement.scrollLeft, document.scrollingElement.scrollTop);
    } // Return rectangle to its positioned coordinate system


    return positioned ? result.translate(-opR.x, -opR.y) : result;
  }
  /**
   * Returns `true` if the passed element is deeply visible. Meaning it is not hidden using `display`
   * or `visibility` and no ancestor node is hidden.
   * @param {HTMLElement} element The element to test.
   * @returns {Boolean} `true` if deeply visible.
   */


  static isVisible(element) {
    const document = element.ownerDocument; // Use the parentNode function so that we can traverse upwards through shadow DOM
    // to correctly ascertain visibility of nodes in web components.

    for (; element; element = parentNode(element)) {
      // Visible if we've reached top of the owning document without finding a hidden Element.
      if (element === document) {
        return true;
      } // Must not evaluate a shadow DOM's root fragment.


      if (element.nodeType === element.ELEMENT_NODE && !isVisible(element)) {
        return false;
      }
    } // We get here if the node is detached.


    return false;
  }
  /**
   * Returns true if DOM Event instance is passed. It is handy to override to support Locker Service.
   * @param event
   * @internal
   * @returns {Boolean}
   */


  static isDOMEvent(event) {
    return event instanceof Event;
  }
  /**
   * Merges specified source DOM config objects into a `dest` object.
   * @param {Object} dest The destination DOM config object.
   * @param {...Object} sources The DOM config objects to merge into `dest`.
   * @returns {Object} The `dest` object.
   * @internal
   */


  static merge(dest, ...sources) {
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].blend(dest, sources, {
      merge: mergeChildren
    });
  }
  /**
   * Updates in-place a DOM config object whose `children` property may be an object instead of the typical array.
   * The keys of such objects become the `reference` property upon conversion.
   *
   * @param {DomConfig} domConfig
   * @param {Function} [namedChildren] A function to call for each named child element.
   * @privateparam {Boolean} [ignoreRefs] Not meant to be manually set, used when recursing.
   * @returns {Object} Returns the altered DOM config
   * @internal
   */


  static normalizeChildren(domConfig, namedChildren, ignoreRefs) {
    var _domConfig$syncOption;

    let children = domConfig === null || domConfig === void 0 ? void 0 : domConfig.children,
        child,
        i,
        name,
        kids,
        ref; // Allow redirecting/opting out of ref ownership in a hierarchy

    if (domConfig !== null && domConfig !== void 0 && (_domConfig$syncOption = domConfig.syncOptions) !== null && _domConfig$syncOption !== void 0 && _domConfig$syncOption.ignoreRefs) {
      ignoreRefs = true;
    }

    if (children && !(domConfig instanceof Node)) {
      if (Array.isArray(children)) {
        for (i = 0; i < children.length; ++i) {
          DomHelper.normalizeChildren(children[i], namedChildren, ignoreRefs);
        }
      } else {
        kids = children;
        domConfig.children = children = [];

        for (name in kids) {
          var _child;

          child = kids[name];

          if ((_child = child) !== null && _child !== void 0 && _child.isWidget) {
            child = child.element;
          } // $ prefix indicates element is not a reference:


          ref = !name.startsWith('$') && !DomHelper.isElement(child);
          ref && (namedChildren === null || namedChildren === void 0 ? void 0 : namedChildren(name,
          /* hoist = */
          !ignoreRefs));

          if (child) {
            if (!(child instanceof Node)) {
              if (child.reference === false) {
                delete child.reference;
              } else if (ref && typeof child !== 'string') {
                child.reference = name;
              }

              DomHelper.normalizeChildren(child, namedChildren, ignoreRefs);
            }

            children.push(child);
          }
        }
      }
    }

    return domConfig;
  }

  static roundPx(px, devicePixelRatio = window.devicePixelRatio || 1) {
    const multiplier = 1 / devicePixelRatio;
    return Math.round(px / multiplier) * multiplier;
  }
  /**
   * Returns true if element has opened shadow root
   * @param {HTMLElement} element Element to check
   * @returns {Boolean}
   */


  static isCustomElement(element) {
    return Boolean(element === null || element === void 0 ? void 0 : element.shadowRoot);
  }
  /**
   * Resolves element from point, checking shadow DOM if required
   * @param {Number} x
   * @param {Number} y
   * @returns {HTMLElement}
   */


  static elementFromPoint(x, y) {
    let el = document.elementFromPoint(x, y); // Try to check shadow dom if it exists

    if (DH.isCustomElement(el)) {
      el = el.shadowRoot.elementFromPoint(x, y) || el;
    }

    return el;
  }
  /**
   * Resolves child element from point __in the passed element's coordinate space__.
   * @param {HTMLElement} parent The element to find the occupying element in.
   * @param {Number|Core.helper.util.Point} x Either the `X` part of a point, or the point to find.
   * @param {Number} [y] The `Y` part of the point.
   * @returns {HTMLElement}
   * @internal
   */


  static childFromPoint(el, x, y,
  /* internal */
  parent = el) {
    const p = y == null ? x : new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](x, y, 0, 0);
    let result = null;
    Array.from(el.children).some(el => {
      if (_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(el, parent).contains(p)) {
        // All rectangles must be relative to the topmost el, so that must be
        // passed down as the "parent" of all Rectangles.
        result = el.children.length && DH.childFromPoint(el, p, null, parent) || el;
        return true;
      }
    });
    return result;
  }
  /**
   * Converts a name/value pair of a style name and its value into the canonical (hyphenated) name of the style
   * property and a value with the `defaultUnit` suffix appended if no unit is already present in the `value`.
   *
   * For example:
   * ```javascript
   *  const [property, value] = DomHelper.unitize('marginLeft', 50);
   *  console.log(property, value);
   * ```
   *
   * ```
   *  > margin-left 50px
   * ```
   * @param {String} name
   * @param {String|Number} value
   * @param {String} [defaultUnit]
   * @returns {String[]}
   * @internal
   */


  static unitize(name, value, defaultUnit = 'px') {
    const [trueName, hasUnits] = canonicalizeStyle(name);

    if (value != null) {
      value = String(value);
      value = hasUnits && digitsRe.test(value) ? value + defaultUnit : value;
    }

    return [trueName, value];
  }
  /**
   * Returns active element checking shadow dom too
   * @readonly
   * @property {HTMLElement}
   */


  static get activeElement() {
    let el = document.activeElement;

    while (el.shadowRoot) {
      el = el.shadowRoot.activeElement;
    }

    return el;
  } // returns active element for DOM tree / shadow DOM tree to which element belongs


  static getActiveElement(element) {
    var _element, _element2, _element2$getRootNode;

    if ((_element = element) !== null && _element !== void 0 && _element.isWidget) {
      element = element.element;
    } // IE11 doesn't support `getRootNode`, so in this case we just fallback to document


    let el = (((_element2 = element) === null || _element2 === void 0 ? void 0 : (_element2$getRootNode = _element2.getRootNode) === null || _element2$getRootNode === void 0 ? void 0 : _element2$getRootNode.call(_element2)) || document).activeElement;

    while ((_el = el) !== null && _el !== void 0 && _el.shadowRoot) {
      var _el;

      el = el.shadowRoot.activeElement;
    }

    return el;
  } // Returns the visible root (either document.body or a web component shadow root)


  static getRootElement(element) {
    var _element$getRootNode;

    const root = (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
    return (root === null || root === void 0 ? void 0 : root.body) || root || element.ownerDocument.body;
  }

  static isValidFloatRootParent(target) {
    return target === document.body || target.constructor.name === 'ShadowRoot';
  }
  /**
   * Returns the `id` of the passed element. Generates a unique `id` if the element does not have one.
   * @param {HTMLElement} element The element to return the `id` of.
   */


  static getId(element) {
    return element.id || (element.id = 'b-element-' + ++idCounter);
  }
  /**
   * Returns common widget/node ancestor for from/to arguments
   * @param {Core.widget.Widget|HTMLElement} from
   * @param {Core.widget.Widget|HTMLElement} to
   * @returns {Core.widget.Widget|HTMLElement}
   * @internal
   */


  static getCommonAncestor(from, to) {
    if (from === to) {
      return from;
    }

    while (from && !((_from = (_from2 = from)[from.isWidget ? 'owns' : 'contains']) !== null && _from !== void 0 && _from.call(_from2, to) || from === to)) {
      var _from, _from2;

      from = from.owner || from.parentNode;
    }

    return from;
  } //region Internal

  /**
   * Internal convenience fn to allow specifying either an element or a CSS selector to retrieve one
   * @private
   * @param {String|HTMLElement} elementOrSelector element or selector to lookup in DOM
   * @returns {HTMLElement}
   */


  static getElement(elementOrSelector) {
    // also used for SVG elements, so need to use more basic class, that is also returned by querySelector
    if (elementOrSelector instanceof Element) {
      return elementOrSelector;
    }

    return doc.querySelector(elementOrSelector);
  }
  /**
   * Sets attributes passed as object to given element
   * @param {String|Element} elementOrSelector
   * @param {Object} attributes
   * @internal
   */


  static setAttributes(elementOrSelector, attributes) {
    const element = DH.getElement(elementOrSelector);

    if (element && attributes) {
      for (const key in attributes) {
        if (attributes[key] != null) {
          element.setAttribute(key, attributes[key]);
        }
      }
    }
  }
  /**
   * Sets a CSS [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length) style value.
   * @param {String|HTMLElement} element The element to set the style in, or, if just the result is required,
   * the style magnitude to return with units added. If a nullish value is passed, an empty string
   * is returned.
   * @param {String} [style] The name of a style property which specifies a [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length)
   * @param {Number|String} [value] The magnitude. If a number is used, the value will be set in `px` units.
   * @returns {String} The style value string.
   */


  static setLength(element, style, value) {
    if (arguments.length === 1) {
      var _element3;

      value = typeof element === 'number' ? `${element}px` : (_element3 = element) !== null && _element3 !== void 0 ? _element3 : '';
    } else {
      var _value;

      element = DH.getElement(element);
      value = element.style[style] = typeof value === 'number' ? `${value}px` : (_value = value) !== null && _value !== void 0 ? _value : '';
    }

    return value;
  }
  /**
   * Returns string percentified and rounded value for setting element's height, width etc.
   * @param {String|Number} value percent value
   * @param {Number} digits number of decimal digits for rounding
   * @return {string} percentified value or empty string if value can not be parsed
   * @internal
   */


  static percentify(value, digits = 2) {
    const mult = Math.pow(10, digits);
    return value == null || value === '' || isNaN(value) ? '' : `${Math.round(value * mult) / mult}%`;
  } //endregion
  //region Children, going down...

  /**
   * Gets the first direct child of `element` that matches `selector`.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {HTMLElement}
   * @category Query children
   */


  static getChild(element, selector) {
    // TODO: Only IE11 doesn't support :scope
    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
      selector = ':scope>' + selector;
    } else {
      const elId = element.id || (element.id = 'b-element-' + ++idCounter);
      selector = `#${elId} > ${selector}`;
    }

    return element.querySelector(selector);
  }
  /**
   * Checks if `element` has any child that matches `selector`.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {Boolean} true if any child matches selector
   * @category Query children
   */


  static hasChild(element, selector) {
    return DH.getChild(element, selector) != null;
  }
  /**
   * Returns all child elements (not necessarily direct children) that matches `selector`.
   *
   * If `selector` starts with `'>'` or `'# '`, then all components of the `selector` must match inside of `element`.
   * Where supported, `:scope` is prepended to the selector (and if `#` was used, it is removed). In other cases,
   * the `id` of the `element` is used to restrict the `selector`. If necessary, the `element` may be assigned a
   * generated `id` to enable this.
   *
   * These are equivalent:
   *
   *      DomHelper.children(el, '# .foo .bar');
   *
   *      el.querySelectorAll(':scope .foo .bar');
   *
   * These are also equivalent:
   *
   *      DomHelper.children(el, '> .foo .bar');
   *
   *      el.querySelectorAll(':scope > .foo .bar');
   *
   * @param {HTMLElement} element The parent element
   * @param {String} selector The CSS selector
   * @returns {HTMLElement[]} Matched elements, somewhere below `element`
   * @category Query children
   */


  static children(element, selector) {
    // a '#' could be '#id' but '# ' (hash and space) is not a valid selector...
    if (selector[0] === '>' || selector.startsWith('# ')) {
      if (selector[0] === '#') {
        selector = selector.substr(2);
      }

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
        selector = ':scope ' + selector;
      } else {
        const elId = element.id || (element.id = 'b-element-' + ++idCounter);
        selector = `#${elId} ${selector}`;
      }
    }

    return Array.from(element.querySelectorAll(selector));
  } // Salesforce doesn't yet support childElementCount. So we relace all native usages with this wrapper and
  // override it for salesforce environment.
  // https://github.com/bryntum/support/issues/3008


  static getChildElementCount(element) {
    return element.childElementCount;
  }
  /**
   * Looks at the specified `element` and all of its children for the one that first matches `selector.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {HTMLElement} Matched element, either element or an element below it
   * @category Query children
   */


  static down(element, selector) {
    if (!element) {
      return null;
    }

    if (element.matches && element.matches(selector)) {
      return element;
    }

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
      selector = ':scope ' + selector;
    } else {
      const elId = element.id || (element.id = 'b-element-' + ++idCounter);
      selector = `#${elId} ${selector}`;
    }

    return element.querySelector(selector);
  }
  /**
   * Checks if childElement is a descendant of parentElement (contained in it or a sub element)
   * @param {HTMLElement} parentElement Parent element
   * @param {HTMLElement} childElement Child element, at any level below parent (includes nested shadow roots)
   * @returns {Boolean}
   * @category Query children
   */


  static isDescendant(parentElement, childElement) {
    // In case of IE11 and parentElement is <html>, HTMLDocument#contains is not supported - fallback to body
    if (!parentElement.contains) {
      parentElement = parentElement.body;
    }

    const parentRoot = DH.getRootElement(parentElement),
          childRoot = DH.getRootElement(childElement);

    if (parentRoot !== childRoot && childRoot.host) {
      return DH.isDescendant(parentRoot, childRoot.host);
    }

    return parentElement.contains(childElement);
  }
  /**
   * Returns the specified element of the given `event`. If the `event` is an `Element`, it is returned. Otherwise,
   * the `eventName` argument is used to retrieve the desired element property from `event` (this defaults to the
   * `'target'` property).
   * @param {Event|Element} event
   * @param {String} [elementName]
   * @returns {Element}
   */


  static getEventElement(event, elementName = 'target') {
    return !event || DH.isElement(event) ? event : event[elementName];
  }
  /**
   * Returns `true` if the provided value is _likely_ a DOM element. If the element can be assured to be from the
   * same document, `instanceof Element` is more reliable.
   * @param {*} value
   * @returns {Boolean}
   */


  static isElement(value) {
    return (value === null || value === void 0 ? void 0 : value.nodeType) === document.ELEMENT_NODE && DH.isNode(value);
  }
  /**
   * Returns `true` if the provided value is _likely_ a DOM node. If the node can be assured to be from the same
   * document, `instanceof Node` is more reliable.
   * @param {*} value
   * @returns {Boolean}
   */


  static isNode(value) {
    // cannot use instanceof across frames. Using it here won't help since we'd need the same logic if it were
    // false... meaning we'd have the same chances of a false-positive.
    return Boolean(value) && typeof value.nodeType === 'number' && !isObject(value);
  }
  /**
   * Iterates over each result returned from `element.querySelectorAll(selector)`. First turns it into an array to
   * work in IE. Can also be called with only two arguments, in which case the first argument is used as selector and
   * document is used as the element.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @param {Function} fn Function called for each found element
   * @category Query children
   */


  static forEachSelector(element, selector, fn) {
    if (typeof element === 'string') {
      // Legacy internal API, no longer valid
      throw new Error('DomHelper.forEachSelector must provide a root element context (for shadow root scenario)');
    }

    DH.children(element, selector).forEach(fn);
  }
  /**
   * Iterates over the direct child elements of the specified element. First turns it into an array to
   * work in IE.
   * @param {HTMLElement} element Parent element
   * @param {Function} fn Function called for each child element
   * @category Query children
   */


  static forEachChild(element, fn) {
    Array.from(element.children).forEach(fn);
  }
  /**
   * Removes each element returned from `element.querySelectorAll(selector)`.
   * @param {HTMLElement} element
   * @param {String} selector
   * @category Query children
   */


  static removeEachSelector(element, selector) {
    DH.forEachSelector(element, selector, child => child.remove());
  }

  static removeClsGlobally(element, ...classes) {
    classes.forEach(cls => DH.forEachSelector(element, '.' + cls, child => child.classList.remove(cls)));
  } //endregion
  //region Parents, going up...


  static isOrphaned(element) {
    return !isInDocument(element);
  }
  /**
   * Looks at the specified element and all of its parents for the one that first matches selector.
   * @param {HTMLElement} element Element
   * @param {String} selector CSS selector
   * @returns {HTMLElement} Matched element, either the passed in element or an element above it
   * @category Query parents
   */


  static up(element, selector) {
    return element && element.closest(selector);
  }

  static getAncestor(element, possibleAncestorParents, outerElement = null) {
    let found = false,
        ancestor,
        parent = element;
    if (!Array.isArray(possibleAncestorParents)) possibleAncestorParents = [possibleAncestorParents];

    while (parent = parent.parentElement) {
      if (possibleAncestorParents.includes(parent)) {
        found = true;
        break;
      }

      if (outerElement && parent === outerElement) break;
      ancestor = parent;
    }

    if (!found) return null;
    return ancestor || element;
  }
  /**
   * Retrieves all parents to the specified element.
   * @param {HTMLElement} element Element
   * @returns {HTMLElement[]} All parent elements, bottom up
   * @category Query parents
   */


  static getParents(element) {
    const parents = [];

    while (element.parentElement) {
      parents.push(element.parentElement);
      element = element.parentElement;
    }

    return parents;
  } //endregion
  //region Creation

  /**
   * Converts the passed id to an id valid for usage as id on a DOM element.
   * @param {String} id
   * @returns {String}
   */


  static makeValidId(id, replaceValue = '') {
    if (id == null) return null;
    return String(id).replace(domIdRe, replaceValue);
  }
  /**
   * Creates an Element, accepts a {@link #typedef-DomConfig} object. Example usage:
   *
   * ```javascript
   * DomHelper.createElement({
   *   tag         : 'table', // defaults to 'div'
   *   className   : 'nacho',
   *   html        : 'I am a nacho',
   *   children    : [ { tag: 'tr', ... }, myDomElement ],
   *   parent      : myExistingElement // Or its id
   *   style       : 'font-weight: bold;color: red',
   *   dataset     : { index: 0, size: 10 },
   *   tooltip     : 'Yay!',
   *   ns          : 'http://www.w3.org/1999/xhtml'
   * });
   * ```
   *
   * @param {DomConfig} config Element config object
   * @param {Boolean|Object} [options] An object specifying creation options. If this is a boolean value, it is
   * understood to be the `returnAll` option. Passing a boolean is deprecated in favor of the `options` object.
   * @param {Boolean} options.ignoreRefs Pass `true` to ignore element references.
   * @param {Boolean} options.returnAll Specify true to return all elements & child elements
   * created as an array.
   * @returns {HTMLElement|HTMLElement[]|Object} Single element or array of elements `returnAll` was set to true.
   * If any elements had a `reference` property, this will be an object containing a reference to
   * all those elements, keyed by the reference name.
   * @category Creation
   */


  static createElement(config = {}, options, ...args) {
    var _options, _options$callback, _config$dataset;

    let returnAll = options,
        element,
        i,
        ignoreChildRefs,
        ignoreRefOption,
        ignoreRefs,
        key,
        name,
        value,
        refOwner,
        refs,
        syncIdField;

    if (typeof returnAll === 'boolean') {
      refs = args[0];
      syncIdField = args[1]; // TODO There are many internal calls that will need refactoring to the object form before we can do this:
      // VersionHelper.deprecate('Core', '4.0.0',
      //     'DH.createElement should be given an options object not the returnAll boolean');

      options = {
        returnAll,
        refs,
        syncIdField
      };
    } else if (options) {
      ignoreRefs = options.ignoreRefs;
      refOwner = options.refOwner;
      refs = options.refs;
      returnAll = options.returnAll;
      syncIdField = options.syncIdField;

      if (ignoreRefs) {
        ignoreChildRefs = true;
        ignoreRefs = ignoreRefs !== 'children';
      }
    }

    if (typeof config.parent === 'string') {
      config.parent = document.getElementById(config.parent);
    } // nextSibling implies a parent


    const parent = config.parent || config.nextSibling && config.nextSibling.parentNode,
          {
      dataset,
      html,
      reference,
      syncOptions,
      text
    } = config;

    if (syncOptions) {
      syncIdField = syncOptions.syncIdField || syncIdField;
      ignoreRefOption = syncOptions.ignoreRefs;

      if (ignoreRefOption) {
        ignoreChildRefs = true;
        ignoreRefs = ignoreRefOption !== 'children';
        options = _objectSpread(_objectSpread({}, options), {}, {
          ignoreRefs: true
        });
      }
    }

    if (ignoreRefs) {
      refOwner = null;
    }

    if (config.ns) {
      element = doc.createElementNS(config.ns, config.tag || 'svg');
    } else {
      element = doc.createElement(config.tag || 'div');
    }

    if (text != null) {
      DH.setInnerText(element, text);
    } else if (html != null) {
      if (html instanceof DocumentFragment) {
        element.appendChild(html);
      } else {
        element.innerHTML = html;
      }
    }

    if (config.tooltip) {
      DH.Widget.attachTooltip(element, config.tooltip);
    }

    if (config.style) {
      DH.applyStyle(element, config.style);
    }

    if (dataset) {
      for (name in dataset) {
        value = dataset[name];

        if (value != null) {
          element.dataset[name] = value;
        }
      }
    }

    if (parent) {
      parent.insertBefore(element, config.nextSibling);
    }

    if (refOwner) {
      // Tag each element created by the refOwner's id to enable DomSync
      element.$refOwnerId = refOwner.id;
    }

    if (reference && !ignoreRefs) {
      // SalesForce platform does not allow custom attributes, but existing code
      // uses querySelector('[reference]'), so bypass it when we can:
      if (refOwner) {
        element.$reference = reference;
        refOwner.attachRef(reference, element, config);
      } else {
        // TODO fixup callers to do the above
        if (!refs) {
          options = Object.assign({}, options);
          options.refs = refs = {};
        }

        refs[reference] = element;
        element.setAttribute('data-reference', reference);
      }
    }

    const className = config.className || config.class,
          // matches DomSync
    keys = Object.keys(config);

    if (className) {
      element.setAttribute('class', _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"].normalize(className));
    }

    for (i = 0; i < keys.length; ++i) {
      name = keys[i];
      value = config[name]; // We have to use setAttribute() for custom attributes to work and this is inline with how DomSync
      // handles attributes. For "expando" properties, however, we have to simply assign them.

      if ((key = elementCreateExpandos[name]) != null) {
        element[key || name] = value;
      } else if (!elementCreateProperties[name] && name && value != null) {
        // if (config.ns) {
        //     element.setAttributeNS(config.ns, name, value);
        // }
        // else {
        //     element.setAttribute(name, value);
        // }
        element.setAttribute(name, value);
      }
    } // Mimic the way DomSync issues callbacks as elements are created (needed by TaskBoard to trigger custom
    // taskRenderer calls as elements get produced).


    (_options = options) === null || _options === void 0 ? void 0 : (_options$callback = _options.callback) === null || _options$callback === void 0 ? void 0 : _options$callback.call(_options, {
      action: 'newElement',
      domConfig: config,
      targetElement: element,
      syncId: refOwner ? reference : options.syncIdField && ((_config$dataset = config.dataset) === null || _config$dataset === void 0 ? void 0 : _config$dataset[options.syncIdField])
    }); // if returnAll is true, use array

    if (returnAll === true) {
      options.returnAll = returnAll = [element];
    } // if it already is an array, add to it (we are probably a child)
    else if (Array.isArray(returnAll)) {
      returnAll.push(element);
    }

    if (config.children) {
      if (syncIdField) {
        // Map syncId -> child element to avoid querying dom later on
        element.syncIdMap = {};
      }

      config.children.forEach(child => {
        // Skip null children, convenient to allow those for usage with Array.map()
        if (child) {
          // Append string children as text nodes
          if (typeof child === 'string') {
            const textNode = document.createTextNode(child);

            if (refOwner) {
              textNode.$refOwnerId = refOwner.id;
            }

            element.appendChild(textNode);
          } // Just append Elements directly.
          else if (isNaN(child.nodeType)) {
            var _config$syncOptions$i, _config$syncOptions, _child$dataset;

            child.parent = element;

            if (!child.ns && config.ns) {
              child.ns = config.ns;
            }

            const childElement = DH.createElement(child, _objectSpread(_objectSpread({}, options), {}, {
              ignoreRefs: (_config$syncOptions$i = (_config$syncOptions = config.syncOptions) === null || _config$syncOptions === void 0 ? void 0 : _config$syncOptions.ignoreRef) !== null && _config$syncOptions$i !== void 0 ? _config$syncOptions$i : ignoreChildRefs
            })),
                  syncId = (_child$dataset = child.dataset) === null || _child$dataset === void 0 ? void 0 : _child$dataset[syncIdField]; // syncId is used with DomHelper.sync to match elements. Populate a map here to make finding them faster

            if (syncId != null) {
              element.syncIdMap[syncId] = childElement;
            } // Do not want to alter the initial config


            delete child.parent;
          } else {
            element.appendChild(child);
          }
        }
      });
    } // Store used config, to be able to compare on sync to determine if changed without hitting dom


    element.lastDomConfig = config; // If references were used, return them in an object
    // If returnAll was specified, return the array
    // By default, return the root element

    return refs || returnAll || element;
  }
  /**
   * Create element(s) from a template (html string). Note that
   * `textNode`s are discarded unless the `raw` option is passed
   * as `true`.
   *
   * If the template has a single root element, then the single element will be returned
   * unless the `array` option is passed as `true`.
   *
   * If there are multiple elements, then an Array will be returned.
   *
   * @param {String} template The HTML string from which to create DOM content
   * @param {Object} [options] An object containing properties to modify how the DOM is created and returned.
   * @param {Boolean} [options.array] `true` to return an array even if there's only one resulting element.
   * @param {Boolean} [options.raw] Return all child nodes, including text nodes.
   * @param {Boolean} [options.fragment] Return a DocumentFragment.
   * @private
   */


  static createElementFromTemplate(template, options = emptyObject) {
    const {
      array,
      raw,
      fragment
    } = options;
    let result; // Use template by preference if it exists. It's faster on most supported platforms
    // https://jsperf.com/domparser-vs-template/

    if (DH.supportsTemplate) {
      (templateElement || (templateElement = doc.createElement('template'))).innerHTML = template;
      result = templateElement.content;

      if (fragment) {
        // The template is reused, so therefore is its fragment.
        // If we release the fragment to a caller, it must be a clone.
        return result.cloneNode(true);
      }
    } else {
      (htmlParser || (htmlParser = new DOMParser())).parseFromString(template, 'text/html');
      result = htmlParser.parseFromString(template, 'text/html').body; // We must return a DocumentFragment.
      // myElement.append(fragment) inserts the contents of the fragment, not the fragment itself.

      if (fragment) {
        // Empty string results in *no document.body* on IE!
        const nodes = result ? result.childNodes : emptyArray;
        result = document.createDocumentFragment();

        while (nodes.length) {
          result.appendChild(nodes[0]);
        }

        return result;
      } // Happens with empty template in IE11
      else if (!result) {
        result = {
          children: [],
          childNodes: []
        };
      }
    } // Raw means all child nodes are returned


    if (raw) {
      result = result.childNodes;
    } // Otherwise, only element nodes
    else {
      result = result.children;
    }

    return result.length === 1 && !array ? result[0] : arraySlice.call(result);
  }
  /**
   * Inserts an `element` at first position in `into`.
   * @param {HTMLElement} into Parent element
   * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
   * @returns {HTMLElement}
   * @category Creation
   */


  static insertFirst(into, element) {
    if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
      element = DH.createElement(element);
    }

    return into.insertBefore(element, into.firstElementChild);
  }
  /**
   * Inserts a `element` before `beforeElement` in `into`.
   * @param {HTMLElement} into Parent element
   * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
   * @param {HTMLElement} beforeElement Element before which passed element should be inserted
   * @returns {HTMLElement}
   * @category Creation
   */


  static insertBefore(into, element, beforeElement) {
    if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
      element = DH.createElement(element);
    }

    return beforeElement ? into.insertBefore(element, beforeElement) : DH.insertFirst(into, element);
  }

  static insertAt(parentElement, newElement, index) {
    const siblings = Array.from(parentElement.children);

    if (index >= siblings.length) {
      return DH.append(parentElement, newElement);
    }

    const beforeElement = siblings[index];
    return DH.insertBefore(parentElement, newElement, beforeElement);
  }
  /**
   * Appends element to parentElement.
   * @param {HTMLElement} parentElement Parent element
   * @param {HTMLElement|Object|String} elementOrConfig Element to insert, or an element config passed on to createElement(), or an html string passed to createElementFromTemplate
   * @returns {HTMLElement}
   * @category Creation
   */


  static append(parentElement, elementOrConfig) {
    if (elementOrConfig.forEach) {
      // Ensure all elements of an Array are HTMLElements.
      // The other implementor of forEach is a NodeList which needs no conversion.
      if (Array.isArray(elementOrConfig)) {
        elementOrConfig = elementOrConfig.map(elementOrConfig => elementOrConfigToElement(elementOrConfig));
      }

      if (parentElement.append) {
        parentElement.append(...elementOrConfig);
      } else {
        const docFrag = document.createDocumentFragment();
        elementOrConfig.forEach(function (child) {
          docFrag.appendChild(child);
        });
        parentElement.appendChild(docFrag);
      }

      return elementOrConfig;
    } else {
      return parentElement.appendChild(elementOrConfigToElement(elementOrConfig));
    }
  } //endregion
  //region Get position

  /**
   * Returns the element's `transform translateX` value in pixels.
   * @param {HTMLElement} element
   * @returns {Number} X transform
   * @category Position, get
   */


  static getTranslateX(element) {
    const transformStyle = element.style.transform;
    let matches = pxTtranslateXRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateX(npx"

    if (matches) {
      return parseFloat(matches[2]);
    } else {
      // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
      matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(element, 'transform'));
      return matches ? parseFloat(matches[1] || matches[3]) : 0;
    }
  }
  /**
   * Returns the element's `transform translateY` value in pixels.
   * @param {HTMLElement} element
   * @returns {Number} Y coordinate
   * @category Position, get
   */


  static getTranslateY(element) {
    const transformStyle = element.style.transform;
    let matches = pxTtranslateYRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateY(npx"

    if (matches) {
      // If it was translateY(npx), use first item in the parens.
      const y = parseFloat(matches[matches[1] === 'Y' ? 2 : 3]); // FF will strip `translate(x, 0)` -> `translate(x)`, so need to check for isNaN also

      return isNaN(y) ? 0 : y;
    } else {
      // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
      matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(element, 'transform'));
      return matches ? parseFloat(matches[2] || matches[4]) : 0;
    }
  }
  /**
   * Gets both X and Y coordinates as an array [x, y]
   * @param {HTMLElement} element
   * @returns {Number[]} [x, y]
   * @category Position, get
   */


  static getTranslateXY(element) {
    return [DH.getTranslateX(element), DH.getTranslateY(element)];
  }
  /**
   * Get elements X offset within a containing element
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number} X offset
   * @category Position, get
   */


  static getOffsetX(element, container = null) {
    return container ? element.getBoundingClientRect().left - container.getBoundingClientRect().left : element.offsetLeft;
  }
  /**
   * Get elements Y offset within a containing element
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number} Y offset
   * @category Position, get
   */


  static getOffsetY(element, container = null) {
    return container ? element.getBoundingClientRect().top - container.getBoundingClientRect().top : element.offsetTop;
  }
  /**
   * Gets elements X and Y offset within containing element as an array [x, y]
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number[]} [x, y]
   * @category Position, get
   */


  static getOffsetXY(element, container = null) {
    return [DH.getOffsetX(element, container), DH.getOffsetY(element, container)];
  }
  /**
   * Focus element without scrolling the element into view.
   * @param {HTMLElement} element
   */


  static focusWithoutScrolling(element) {
    function resetScroll(scrollHierarchy) {
      scrollHierarchy.forEach(({
        element,
        scrollLeft,
        scrollTop
      }) => {
        // Check first to avoid triggering unnecessary `scroll` events
        if (element.scrollLeft !== scrollLeft) {
          element.scrollLeft = scrollLeft;
        }

        if (element.scrollTop !== scrollTop) {
          element.scrollTop = scrollTop;
        }
      });
    } // Check browsers which do support focusOptions
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus


    const preventScrollSupported = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].chromeVersion >= 64 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].firefoxVersion >= 68;

    if (preventScrollSupported) {
      element.focus({
        preventScroll: true
      });
    } else {
      // Examine every parentNode of the target and cache the scrollLeft and scrollTop,
      // and restore all values after the focus has taken place
      const parents = DH.getParents(element),
            scrollHierarchy = parents.map(parent => ({
        element: parent,
        scrollLeft: parent.scrollLeft,
        scrollTop: parent.scrollTop
      }));
      element.focus(); // Reset in sync on IE, async in others

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11) {
        resetScroll(scrollHierarchy);
      } else {
        setTimeout(() => resetScroll(scrollHierarchy), 0);
      }
    }
  }
  /**
   * Get elements X position on page
   * @param {HTMLElement} element
   * @returns {Number}
   * @category Position, get
   */


  static getPageX(element) {
    return element.getBoundingClientRect().left + win.pageXOffset; // no window.scrollX in IE11
  }
  /**
   * Get elements Y position on page
   * @param {HTMLElement} element
   * @returns {Number}
   * @category Position, get
   */


  static getPageY(element) {
    return element.getBoundingClientRect().top + win.pageYOffset; // no window.scrollY in IE11
  }
  /**
   * Returns extremal (min/max) size (height/width) of the element in pixels
   * @param {HTMLElement} element
   * @param {String} style minWidth/minHeight/maxWidth/maxHeight
   * @returns {Number}
   * @internal
   */


  static getExtremalSizePX(element, style) {
    const prop = _StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(style),
          measure = prop.split('-')[1];
    let value = DH.getStyleValue(element, prop);

    if (/%/.test(value)) {
      // Element might be detached from DOM
      if (element.parentElement) {
        value = parseInt(DH.getStyleValue(element.parentElement, measure), 10);
      } else {
        value = NaN;
      }
    } else {
      value = parseInt(value, 10);
    }

    return value;
  } //endregion
  //region Set position

  /**
   * Set element's `scale`.
   * @param {HTMLElement} element
   * @param {Number} scaleX The value by which the element should be scaled in the X axis (0 to 1)
   * @param {Number} [scaleY] The value by which the element should be scaled in the Y axis (0 to 1).
   * Defaults to `scaleX`
   * @category Position, set
   * @internal
   */


  static setScale(element, scaleX, scaleY = scaleX) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/);

    if (t.length > 1) {
      if (t[0].startsWith('matrix3d')) {
        t[0] = `matrix3d(${scaleX}`;
        t[5] = scaleY;
      } else {
        t[0] = `matrix(${scaleX}`;
        t[3] = scaleY;
      }

      element.style.transform = t.join(',');
    } else {
      element.style.transform = `scale(${scaleX}, ${scaleY})`;
    }
  }
  /**
   * Set element's `X` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} x The value by which the element should be translated from its default position.
   * @category Position, set
   */


  static setTranslateX(element, x) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

    x = DH.roundPx(x);

    if (t.length > 1) {
      t[t[0].startsWith('matrix3d') ? 12 : 4] = x;
      element.style.transform = t.join(',');
    } else {
      element.style.transform = `translateX(${x}px)`;
    }
  }
  /**
   * Set element's `Y` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} y  The value by which the element should be translated from its default position.
   * @category Position, set
   */


  static setTranslateY(element, y) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

    y = DH.roundPx(y);

    if (t.length > 1) {
      t[t[0].startsWith('matrix3d') ? 13 : 5] = y;
      element.style.transform = t.join(',') + ')';
    } else {
      element.style.transform = `translateY(${y}px)`;
    }
  }
  /**
   * Set element's style `top`.
   * @param {HTMLElement} element
   * @param {Number|String} y The top position. If numeric, `'px'` is used as the unit.
   * @category Position, set
   */


  static setTop(element, y) {
    DH.setLength(element, 'top', y);
  }
  /**
   * Set element's style `left`.
   * @param {HTMLElement} element
   * @param {Number|String} x The top position. If numeric, `'px'` is used as the unit.
   * @category Position, set
   */


  static setLeft(element, x) {
    DH.setLength(element, 'left', x);
  }
  /**
   * Set elements `X` and `Y` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} [x] The `X translation.
   * @param {Number} [y] The `Y translation.
   * @category Position, set
   */


  static setTranslateXY(element, x, y) {
    if (x == null) {
      return DH.setTranslateY(element, y);
    }

    if (y == null) {
      return DH.setTranslateX(element, x);
    } // Avoid blurry text on non-retina displays


    x = DH.roundPx(x);
    y = DH.roundPx(y);
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/),
          is3d = t[0].startsWith('matrix3d');

    if (t.length > 1) {
      t[is3d ? 12 : 4] = x;
      t[is3d ? 13 : 5] = y;
      element.style.transform = t.join(',') + ')';
    } else {
      element.style.transform = `translate(${x}px, ${y}px)`;
    }
  }
  /**
   * Increase `X` translation
   * @param {HTMLElement} element
   * @param {Number} x The number of pixels by which to increase the element's `X` translation.
   * @category Position, set
   */


  static addTranslateX(element, x) {
    DH.setTranslateX(element, DH.getTranslateX(element) + x);
  }
  /**
   * Increase `Y` position
   * @param {HTMLElement} element
   * @param {Number} y The number of pixels by which to increase the element's `Y` translation.
   * @category Position, set
   */


  static addTranslateY(element, y) {
    DH.setTranslateY(element, DH.getTranslateY(element) + y);
  }
  /**
   * Increase X position
   * @param {HTMLElement} element
   * @param {Number} x
   * @category Position, set
   */


  static addLeft(element, x) {
    DH.setLeft(element, DH.getOffsetX(element) + x);
  }
  /**
   * Increase Y position
   * @param {HTMLElement} element
   * @param {Number} y
   * @category Position, set
   */


  static addTop(element, y) {
    DH.setTop(element, DH.getOffsetY(element) + y);
  }
  /**
   * Align the passed element with the passed target according to the align spec.
   * @param {HTMLElement} element The element to align.
   * @param {HTMLElement|Core.helper.util.Rectangle} target The target element or rectangle to align to
   * @param {Object} alignSpec See {@link Core.helper.util.Rectangle#function-alignTo} Defaults to `{ align : 't0-t0' }`
   * @param {Boolean} [round] Round the calculated Rectangles (for example if dealing with scrolling which
   * is integer based).
   */


  static alignTo(element, target, alignSpec = t0t0, round) {
    target = target instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"] ? target : _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(target, true);
    const elXY = DH.getTranslateXY(element),
          elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, true);

    if (round) {
      elRect.roundPx();
      target.roundPx();
    }

    const targetRect = elRect.alignTo(Object.assign(alignSpec, {
      target
    }));
    DH.setTranslateXY(element, elXY[0] + targetRect.x - elRect.x, elXY[1] + targetRect.y - elRect.y);
  } //endregion
  //region Styles & CSS

  /**
   * Returns a style value or values for the passed element.
   * @param {HTMLElement} element The element to read styles from
   * @param {String|String[]} propName The property or properties to read
   * @param {Boolean} [inline=false] Pass as `true` to read the element's inline style.
   * Note that this could return inaccurate results if CSS rules apply to this element.
   * @return {String|Object} The value or an object containing the values keyed by the requested property name.
   * @category CSS
   */


  static getStyleValue(element, propName, inline, pseudo) {
    const styles = inline ? element.style : element.ownerDocument.defaultView.getComputedStyle(element, pseudo);

    if (Array.isArray(propName)) {
      const result = {};

      for (const prop of propName) {
        result[prop] = styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(prop));
      }

      return result;
    } // Use the elements owning view to get the computed style.
    // Ensure the property name asked for is hyphenated.
    // getPropertyValue doesn't work with camelCase


    return styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(propName));
  }
  /**
   * Returns an object with the parse style values for the top, right, bottom, and left
   * components of the given edge style.
   *
   * The return value is an object with `top`, `right`, `bottom`, and `left` properties
   * for the respective components of the edge style, as well as `width` (the sum of
   * `left` and `right`) and `height` (the sum of `top` and `bottom`).
   *
   * @param {HTMLElement} element
   * @param {String} edgeStyle The element's desired edge style such as 'padding', 'margin',
   * or 'border'.
   * @param {String} [edges='trbl'] A string with one character codes for each edge. Only
   * those edges will be populated in the returned object. By default, all edges will be
   * populated.
   * @returns {Object}
   */


  static getEdgeSize(element, edgeStyle, edges) {
    const suffix = edgeStyle === 'border' ? '-width' : '',
          ret = {
      raw: {}
    };

    for (const edge of ['top', 'right', 'bottom', 'left']) {
      if (!edges || edges.includes(edge[0])) {
        // This produces px units even if the provided style is em or other (i.e.,
        // getComputedStyle normalizes this):
        ret[edge] = parseFloat(ret.raw[edge] = DH.getStyleValue(element, `${edgeStyle}-${edge}${suffix}`));
      }
    } // These may not even be requested (based on "edges") but conditional code here
    // would be wasted since the caller would still need to know not to use them...
    // Replace NaN with 0 to keep calculations correct if they only asked for one side.


    ret.width = (ret.left || 0) + (ret.right || 0);
    ret.height = (ret.top || 0) + (ret.bottom || 0);
    return ret;
  }
  /**
   * Splits a style string up into object form. For example `'font-weight:bold;font-size:150%'`
   * would convert to
   *
   * ```javascript
   * {
   *     font-weight : 'bold',
   *     font-size : '150%'
   * }
   * ```
   * @param {String} style A DOM style string
   * @returns {Object} the style declaration in object form.
   */


  static parseStyle(style) {
    if (typeof style === 'string') {
      const styles = style.split(semicolonRe);
      style = {};

      for (let i = 0, {
        length
      } = styles; i < length; i++) {
        const propVal = styles[i].split(colonRe);
        style[propVal[0]] = propVal[1];
      }
    }

    return style || {};
  }
  /**
   * Applies specified style to the passed element. Style can be an object or a string.
   * @param {HTMLElement} element Target element
   * @param {String|Object} style Style to apply, 'border: 1px solid black' or { border: '1px solid black' }
   * @param {Boolean} [overwrite] Specify `true` to replace style instead of applying changes
   * @category CSS
   */


  static applyStyle(element, style, overwrite = false) {
    if (typeof style === 'string') {
      if (overwrite) {
        // Only assign if either end has any styles, do not want to add empty `style` tag on element
        if (style.length || element.style.cssText.length) {
          element.style.cssText = style;
        }
      } else {
        // Add style so as not to delete configs in style such as width, height, flex etc.
        // If a style is already there, the newest, appended one will take precedence.
        element.style.cssText += style;
      }
    } else if (style) {
      if (overwrite) {
        element.style.cssText = ''; //element.removeAttribute('style');
      } // Has a sub-style block?


      if (style.style) {
        if (typeof style.style === 'string') {
          element.style.cssText = style.style;
        } else {
          style = Object.assign({}, style.style, style);
        }
      }

      let key, value; // Prototype chained objects may be passed, so use direct loop.

      for (key in style) {
        // Ignore readonly properties of the CSSStyleDeclaration object:
        // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
        // Also ignores sub-style blocks, which are applied above
        if (!styleIgnoreProperties[key]) {
          [key, value] = DomHelper.unitize(key, style[key]); // Cannot use element.style[key], wont work with CSS vars

          element.style.setProperty(key, value);
        }
      }
    }
  }

  static getCSSText(style) {
    if (typeof style === 'string') {
      return style;
    }

    let cssText = '';

    for (const key in style) {
      // Ignore readonly properties of the CSSStyleDeclaration object:
      // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
      if (!styleIgnoreProperties[key]) {
        cssText += `${_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(key)}:${style[key]};`;
      }
    }

    return cssText;
  } // For IE11, it doesn't support adding/removing multiple classes at once

  /**
   * Add multiple classes to elements classList. Helper for IE11 which does not support it directly
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @category CSS
   */


  static addClasses(element, classes) {
    for (let i = 0; i < classes.length; i++) {
      element.classList.add(classes[i]);
    }
  }
  /**
   * Remove multiple classes from elements classList. Helper for IE11 which does not support it directly
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @category CSS
   */


  static removeClasses(element, classes) {
    for (let i = 0; i < classes.length; i++) {
      element.classList.remove(classes[i]);
    }
  }
  /**
   * Toggle multiple classes in elements classList. Helper for IE11 which does not support toggling with force or for
   * multiple classes at once.
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @param {Boolean} [force] Specify true to add classes, false to remove. Leave blank to toggle
   * @category CSS
   */


  static toggleClasses(element, classes, force = null) {
    if (!Array.isArray(classes)) {
      classes = [classes];
    }

    if (force === true) {
      DH.addClasses(element, classes);
    } else if (force === false) {
      DH.removeClasses(element, classes);
    } else {
      classes.forEach(cls => element.classList.toggle(cls));
    }
  }
  /**
   * Adds a CSS class to an element during the specified duration
   * @param {HTMLElement} element Target element
   * @param {String} cls CSS class to add temporarily
   * @param {Number} duration Duration in ms, 0 means cls will not be applied
   * @param {Core.mixin.Delayable} delayable The delayable to tie the setTimeout call to
   * @typings delayable -> {typeof Delayable}
   * @category CSS
   */


  static addTemporaryClass(element, cls, duration, delayable = window) {
    if (duration > 0) {
      element.classList.add(cls);
      delayable.setTimeout(() => element.classList.remove(cls), duration);
    }
  }
  /**
   * Reads computed style from the element and returns transition duration for a given property in milliseconds
   * @param {HTMLElement} element Target DOM element
   * @param {String} property Animated property name
   * @returns {Number} Duration in ms
   * @internal
   */


  static getPropertyTransitionDuration(element, property) {
    const style = window.getComputedStyle(element),
          properties = style.transitionProperty.split(', '),
          durations = style.transitionDuration.split(', '),
          index = properties.indexOf(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(property));
    let result;

    if (index !== -1) {
      // get floating value of transition duration in seconds and convert into milliseconds
      result = parseFloat(durations[index]) * 1000;
    }

    return result;
  }
  /**
   * Reads computed style from the element and returns the animation duration for any
   * attached animation in milliseconds
   * @param {HTMLElement} element Target DOM element
   * @returns {Number} Duration in ms
   * @internal
   */


  static getAnimationDuration(element) {
    return parseFloat(DH.getStyleValue(element, 'animation-duration')) * 1000;
  } //endregion
  //region Effects

  /**
   * Highlights the passed element or Rectangle according to the theme's highlighting rules.
   * Usually an animated framing effect.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or Rectangle to highlight.
   */


  static highlight(element, delayable = window) {
    if (element instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
      return element.highlight();
    }

    return new Promise(resolve => {
      delayable.setTimeout(() => {
        element.classList.add('b-fx-highlight');
        delayable.setTimeout(() => {
          element.classList.remove('b-fx-highlight');
          resolve();
        }, 1000);
      }, 0);
    });
  } //endregion
  //region Measuring / Scrollbar

  /**
   * Measures the scrollbar width using a hidden div. Caches result
   * @property {Number}
   * @readonly
   */


  static get scrollBarWidth() {
    // Ensure the measurement is only done once, when the value is null and body is available
    if (scrollBarWidth === null && doc.body) {
      const element = DH.createElement({
        parent: doc.body,
        style: 'position:absolute;top:-999px;width:100px;height:100px;overflow:scroll'
      });
      scrollBarWidth = element.offsetWidth - element.clientWidth;
      element.remove();
    }

    return scrollBarWidth;
  }

  static get scrollBarPadElement() {
    return {
      className: 'b-yscroll-pad',
      children: [{
        className: 'b-yscroll-pad-sizer'
      }]
    };
  }
  /**
   * Resets DomHelper.scrollBarWidth cache, triggering a new measurement next time it is read
   */


  static resetScrollBarWidth() {
    scrollBarWidth = null;
  }
  /**
   * Measures the text width using a hidden div
   * @param {String} text
   * @param {HTMLElement} sourceElement
   * @returns {Number} width
   * @category Measure
   */


  static measureText(text, sourceElement, useHTML = false, parentElement = undefined) {
    const offScreenDiv = DH.getMeasureElement(sourceElement, parentElement);
    offScreenDiv[useHTML ? 'innerHTML' : 'innerText'] = text;
    const result = offScreenDiv.clientWidth;
    offScreenDiv.className = '';
    return result;
  }
  /**
   * Measures a relative size, such as a size specified in `em` units for the passed element.
   * @param {String} size The CSS size value to measure.
   * @param {HTMLElement} sourceElement
   * @param {Boolean} [round] Pass true to return exact width, not rounded value
   * @returns {Number} size The size in pixels of the passed relative measurement.
   * @category Measure
   */


  static measureSize(size, sourceElement, round = true) {
    if (!size) {
      return 0;
    }

    if (typeof size === 'number') {
      return size;
    }

    if (!size.length) {
      return 0;
    }

    if (/^\d+(px)?$/.test(size)) {
      return parseInt(size);
    }

    if (sourceElement) {
      const offScreenDiv = DH.getMeasureElement(sourceElement);
      offScreenDiv.innerHTML = '';
      offScreenDiv.style.width = DH.setLength(size); //const result = BrowserHelper.isIE11 ?  offScreenDiv.offsetWidth : offScreenDiv.clientWidth;

      const result = round ? offScreenDiv.offsetWidth : offScreenDiv.getBoundingClientRect().width;
      offScreenDiv.style.width = offScreenDiv.className = '';
      return result;
    }

    if (/^\d+em$/.test(size)) {
      return parseInt(size) * DEFAULT_FONT_SIZE;
    }

    return isNaN(size) ? 0 : parseInt(size);
  } // parentElement allows measurement to happen inside a specific element, allowing scoped css rules to match


  static getMeasureElement(sourceElement, parentElement = doc.body) {
    const sourceElementStyle = win.getComputedStyle(sourceElement),
          offScreenDiv = parentElement.offScreenDiv = parentElement.offScreenDiv || DH.createElement({
      parent: parentElement,
      style: 'position:fixed;top:-10000px;left:-10000px;visibility:hidden;contain:strict',
      className: 'b-measure-element',
      children: [{
        style: 'white-space:nowrap;display:inline-block;will-change:contents;width:auto;contain:none'
      }]
    }, true)[1];
    fontProps.forEach(prop => {
      if (offScreenDiv.style[prop] !== sourceElementStyle[prop]) {
        offScreenDiv.style[prop] = sourceElementStyle[prop];
      }
    });
    offScreenDiv.className = sourceElement.className; // In case the measure element was moved/removed, re-add it

    if (offScreenDiv.parentElement.parentElement !== parentElement) {
      parentElement.appendChild(offScreenDiv.parentElement);
    }

    return offScreenDiv;
  }
  /**
   * Strips the tags from a html string, returning text content.
   *
   * ```javascript
   * DomHelper.stripTags('<div class="custom"><b>Bold</b><i>Italic</i></div>'); // -> BoldItalic
   * ```
   *
   * @internal
   * @param {String} htmlString HTML string
   * @returns {String} Text content
   */


  static stripTags(htmlString) {
    const // we need to avoid any kind of evaluation of embedded XSS scripts or "web bugs" (img tags that issue
    // GET requests)
    parser = DH.$domParser || (DH.$domParser = new DOMParser()),
          doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent;
  } //endregion
  //region Sync

  /**
   * Sync one source element attributes, children etc. to a target element. Source element can be specified as a html
   * string or an actual HTMLElement.
   *
   * NOTE: This function is superseded by {@link Core/helper/DomSync#function-sync-static DomSync.sync()}, which works
   * with DOM configs. For most usecases, use it instead.
   *
   * @param {String|HTMLElement} sourceElement Source "element" to copy from
   * @param {HTMLElement} targetElement Target element to apply to, can also be specified as part of the config object
   * @returns {HTMLElement} Returns the updated targetElement (which is also updated in place)
   */


  static sync(sourceElement, targetElement) {
    if (typeof sourceElement === 'string') {
      if (sourceElement === '') {
        targetElement.innerHTML = '';
        return;
      } else {
        sourceElement = DH.createElementFromTemplate(sourceElement);
      }
    }

    DH.performSync(sourceElement, targetElement);
    return targetElement;
  } // Internal helper used for recursive syncing


  static performSync(sourceElement, targetElement) {
    // Syncing identical elements is a no-op
    if (sourceElement.outerHTML !== targetElement.outerHTML) {
      DH.syncAttributes(sourceElement, targetElement);
      DH.syncContent(sourceElement, targetElement);
      DH.syncChildren(sourceElement, targetElement);
      return true;
    }

    return false;
  } // Attributes as map { attr : value, ... }, either from an html element or from a config


  static getSyncAttributes(element) {
    const attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
    names = []; // Extract from element

    for (let i = 0; i < element.attributes.length; i++) {
      const attr = element.attributes[i];

      if (attr.specified) {
        const name = attr.name.toLowerCase();
        attributes[name] = attr.value;
        names.push(name);
      }
    }

    return {
      attributes,
      names
    };
  }
  /**
   * Syncs attributes from sourceElement to targetElement.
   * @private
   * @param {HTMLElement} sourceElement
   * @param {HTMLElement} targetElement
   */


  static syncAttributes(sourceElement, targetElement) {
    const // Extract attributes from elements (sourceElement might be a config)
    {
      attributes: sourceAttributes,
      names: sourceNames
    } = DH.getSyncAttributes(sourceElement),
          {
      attributes: targetAttributes,
      names: targetNames
    } = DH.getSyncAttributes(targetElement),
          // Used to ignore data-xx attributes when we will be setting entire dataset
    hasDataset = sourceNames.includes('dataset'),
          // Intersect arrays to determine what needs adding, removing and syncing
    toAdd = sourceNames.filter(attr => !targetNames.includes(attr)),
          toRemove = targetNames.filter(attr => !sourceNames.includes(attr) && (!hasDataset || !attr.startsWith('data-'))),
          toSync = sourceNames.filter(attr => targetNames.includes(attr));

    if (toAdd.length > 0) {
      for (let i = 0; i < toAdd.length; i++) {
        const attr = toAdd[i]; // Style requires special handling

        if (attr === 'style') {
          DH.applyStyle(targetElement, sourceAttributes.style, true);
        } // So does dataset
        else if (attr === 'dataset') {
          Object.assign(targetElement.dataset, sourceAttributes.dataset);
        } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine)
        else {
          targetElement.setAttribute(attr, sourceAttributes[attr]);
        }
      }
    }

    if (toRemove.length > 0) {
      for (let i = 0; i < toRemove.length; i++) {
        targetElement.removeAttribute(toRemove[i]);
      }
    }

    if (toSync.length > 0) {
      for (let i = 0; i < toSync.length; i++) {
        const attr = toSync[i]; // Set all attributes that has changed, with special handling for style

        if (attr === 'style') {
          // TODO: Check for changes?
          DH.applyStyle(targetElement, sourceAttributes.style, true);
        } // And dataset
        else if (attr === 'dataset') {
          // TODO: Any cost to assigning same values?
          Object.assign(targetElement.dataset, sourceAttributes.dataset);
        } // And class, which might be a DomClassList or an config for a DomClassList
        else if (attr === 'class' && (sourceAttributes.class.isDomClassList || typeof sourceAttributes.class === 'object')) {
          let classList;

          if (sourceAttributes.class.isDomClassList) {
            classList = sourceAttributes.class;
          } else {
            // TODO : Reuse a single DomClassList?
            classList = new _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"](sourceAttributes.class);
          }

          if (!classList.isEqual(targetAttributes.class)) {
            targetElement.setAttribute('class', classList);
          }
        } else if (targetAttributes[attr] !== sourceAttributes[attr]) {
          targetElement.setAttribute(attr, sourceAttributes[attr]);
        }
      }
    }
  }
  /**
   * Sync content (innerText) from sourceElement to targetElement
   * @private
   * @param {HTMLElement} sourceElement
   * @param {HTMLElement} targetElement
   */


  static syncContent(sourceElement, targetElement) {
    if (DH.getChildElementCount(sourceElement) === 0) {
      targetElement.innerText = sourceElement.innerText;
    }
  }

  static setInnerText(targetElement, text) {
    // setting firstChild.data is faster than innerText (and innerHTML),
    // but in some cases the inner node is lost and needs to be recreated
    const firstChild = targetElement.firstChild; // If there's only one text node, just update its value

    if ((firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeType) === Element.TEXT_NODE && targetElement.childNodes.length === 1) {
      firstChild.data = text;
    } else {
      // textContent is supposed to be faster than innerText, since it does not trigger layout
      targetElement.textContent = text;
    }
  }
  /**
   * Sync traversing children
   * @private
   * @param {HTMLElement} sourceElement Source element
   * @param {HTMLElement} targetElement Target element
   */


  static syncChildren(sourceElement, targetElement) {
    const me = this,
          sourceNodes = arraySlice.call(sourceElement.childNodes),
          targetNodes = arraySlice.call(targetElement.childNodes);

    while (sourceNodes.length) {
      const sourceNode = sourceNodes.shift(),
            targetNode = targetNodes.shift(); // only textNodes and elements allowed (no comments)

      if (sourceNode && sourceNode.nodeType !== TEXT_NODE && sourceNode.nodeType !== ELEMENT_NODE) {
        throw new Error(`Source node type ${sourceNode.nodeType} not supported by DomHelper.sync()`);
      }

      if (targetNode && targetNode.nodeType !== TEXT_NODE && targetNode.nodeType !== ELEMENT_NODE) {
        throw new Error(`Target node type ${targetNode.nodeType} not supported by DomHelper.sync()`);
      }

      if (!targetNode) {
        // out of target nodes, add to target
        targetElement.appendChild(sourceNode);
      } else {
        // match node
        if (sourceNode.nodeType === targetNode.nodeType) {
          // same type of node, take action depending on which type
          if (sourceNode.nodeType === TEXT_NODE) {
            // text
            targetNode.data = sourceNode.data;
          } else {
            if (sourceNode.tagName === targetNode.tagName) {
              me.performSync(sourceNode, targetNode);
            } else {
              // new tag, remove targetNode and insert new element
              targetElement.insertBefore(sourceNode, targetNode);
              targetNode.remove();
            }
          }
        } // Trying to set text node as element, use it as innerText
        // (we get this in FF with store mutations and List)
        else if (sourceNode.nodeType === TEXT_NODE && targetNode.nodeType === ELEMENT_NODE) {
          targetElement.innerText = sourceNode.data.trim();
        } else {
          const logElement = sourceNode.parentElement || sourceNode;
          throw new Error(`Currently no support for transforming nodeType.\n${logElement.outerHTML}`);
        }
      }
    } // Out of source nodes, remove remaining target nodes


    targetNodes.forEach(targetNode => {
      targetNode.remove();
    });
  }
  /**
   * Replaces the passed element's `className` with the class names
   * passed in either Array or String format or Object.
   *
   * This method compares the existing class set with the incoming class set and
   * avoids mutating the element's class name set if possible.
   *
   * This can avoid browser style invalidations.
   * @param {HTMLElement} element The element whose class list to synchronize.
   * @param {String[]|String|Object} newClasses The incoming class names to set on the element.
   * @returns {Boolean} `true` if the DOM class list was changed.
   * @category CSS
   */


  static syncClassList(element, newClasses) {
    const classList = element.classList,
          isString = typeof newClasses === 'string',
          newClsArray = isString ? newClasses.trim().split(whiteSpaceRe) : Array.isArray(newClasses) ? newClasses : _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTruthyKeys(newClasses),
          classCount = newClsArray.length;
    let changed = classList.length !== classCount,
        i; // If the incoming and existing class lists are the same length
    // then check that each contains the same names. As soon as
    // we find a non-matching name, we know we have to update the
    // className.

    for (i = 0; !changed && i < classCount; i++) {
      changed = !classList.contains(newClsArray[i]);
    }

    if (changed) {
      element.className = isString ? newClasses : newClsArray.join(' ');
    }

    return changed;
  }
  /**
   * Applies the key state of the passed object or DomClassList to the passed element.
   *
   * Properties with a falsy value mean that property name is *removed* as a class name.
   *
   * Properties with a truthy value mean that property name is *added* as a class name.
   *
   * This is different from {@link #function-syncClassList-static}. That sets the `className` of the element to the
   * sum of all its truthy keys, regardless of what the pre-existing value of the `className` was, and ignoring falsy
   * keys.
   *
   * This _selectively_ updates the classes in the `className`. If there is a truthy key, the name is added. If there
   * is a falsy key, the name is removed.
   * @param {HTMLElement} element The element to apply the class list to .
   * @param {Object|Core.helper.util.DomClassList} classes The classes to add or remove.
   * @returns {Boolean} `true` if the DOM class list was changed.
   * @category CSS
   */


  static updateClassList(element, classes) {
    const {
      classList
    } = element;
    let cls,
        add,
        changed = false;

    for (cls in classes) {
      add = Boolean(classes[cls]);

      if (classList.contains(cls) !== add) {
        classList[add ? 'add' : 'remove'](cls);
        changed = true;
      }
    }

    return changed;
  }
  /**
   * Changes the theme to the passed theme name if possible.
   *
   * Theme names are case insensitive. The `href` used is all lower case.
   *
   * To use this method, the `<link rel="stylesheet">` _must_ use the default,
   * Bryntum-supplied CSS files where the `href` end with `<themeName>.css`, so that
   * it can be found in the document, and switched out for a new link with
   * the a modified `href`. The new `href` will use the same path, just
   * with the `themeName` portion substituted for the new name.
   *
   * If no `<link>` with that name pattern can be found, an error will be thrown.
   *
   * If you use this method, you  must ensure that the theme files are
   * all accessible on your server.
   *
   * Because this is an asynchronous operation, a `Promise` is returned.
   * The theme change event is passed to the success function. If the
   * theme was not changed, because the theme name passed is the current theme,
   * nothing is passed to the success function.
   *
   * The theme change event contains two properties:
   *
   *  - `prev` The previous Theme name.
   *  - `theme` The new Theme name.
   *
   * @param {String} newThemeName the name of the theme that should be applied
   * @privateparam {String} [defaultTheme] Optional, the name of the theme that should be used in case of fail
   * @returns {Promise} A promise who's success callback receives the theme change
   * event if the theme in fact changed. If the theme `href` could not be loaded,
   * the failure callback is called, passing the error event caught.
   */


  static setTheme(newThemeName, defaultTheme) {
    newThemeName = newThemeName.toLowerCase();
    const oldThemeName = DH.getThemeInfo(defaultTheme).name.toLowerCase(),
          oldThemeLink = document.head.querySelector('#bryntum-theme:not([data-loading])') || document.head.querySelector(`[href*="${oldThemeName}.css"]:not([data-loading])`); // Remove any links currently loading

    DH.removeEachSelector(document.head, '#bryntum-theme[data-loading]'); // Theme link href ends with <themeName>.css also there could be a query - css?11111...

    if (!(oldThemeLink !== null && oldThemeLink !== void 0 && oldThemeLink.href.includes(`${oldThemeName}.css`))) {
      throw new Error(`Theme link for ${oldThemeName} not found`);
    } // Do not reapply same theme


    if (oldThemeLink.href.includes(`${newThemeName}.css`)) {
      return immediatePromise;
    }

    return new Promise((resolve, reject) => {
      const newThemeLink = document.createElement('link'),
            nextSibling = oldThemeLink.nextSibling,
            oldThemeName = DH.getThemeInfo(defaultTheme).name.toLowerCase(),
            themeEvent = {
        theme: newThemeName,
        prev: oldThemeName
      },
            onThemeLoad = () => {
        delete newThemeLink.dataset.loading;
        themeInfo = null;
        oldThemeLink.remove();
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].trigger('theme', themeEvent);
        resolve(themeEvent);
      },
            onThemeLoadError = e => {
        delete newThemeLink.dataset.loading;
        reject(e);
      };

      newThemeLink.rel = 'stylesheet';
      newThemeLink.id = 'bryntum-theme';
      newThemeLink.addEventListener('load', onThemeLoad);
      newThemeLink.addEventListener('error', onThemeLoadError);
      newThemeLink.dataset.loading = 'true';
      newThemeLink.href = oldThemeLink.href.replace(oldThemeName, newThemeName);
      nextSibling.parentNode.insertBefore(newThemeLink, nextSibling);
    });
  }
  /**
   * A theme information object about the current theme.
   *
   * Currently this has only one property:
   *
   *   - `name` The current theme name.
   * @property {Object}
   * @readonly
   */


  static get themeInfo() {
    return DomHelper.getThemeInfo();
  }
  /**
   * A theme information object about the current theme.
   *
   * Currently this has only one property:
   *
   *   - `name` The current theme name.
   * @param {String} defaultTheme the name of the theme used as backup value in case of fail
   * @returns {Object} info, currently it contains only one property - 'name'.
   * @private
   */


  static getThemeInfo(defaultTheme) {
    if (!themeInfo) {
      const // The content it creates for 'b-theme-info' is described in corresponding theme in Core/resources/sass/themes
      // for example in Core/resources/sass/themes/material.scss
      // ```
      // .b-theme-info:before {
      //     content : '{"name":"Material"}';
      // }
      // ```
      testDiv = DH.createElement({
        parent: document.body,
        className: 'b-theme-info'
      }),
            // Need to be a pseudo element for Edge to report content correctly
      themeData = DH.getStyleValue(testDiv, 'content', false, ':before');

      if (themeData) {
        // themeData could be invalid JSON string in case there is no content rule
        try {
          themeInfo = JSON.parse(themeData.replace(/^["']|["']$|\\/g, ''));
        } catch (e) {
          themeInfo = null;
        }
      } // CSS file has to be loaded to make the themeInfo available, so fallback to the default theme name


      themeInfo = themeInfo || (defaultTheme ? {
        name: defaultTheme
      } : null);
      testDiv.remove();
    }

    return themeInfo;
  } //endregion
  //region Transition


  static async transition({
    element: outerElement,
    selector = '[data-dom-transition]',
    duration,
    action,
    thisObj = this,
    addTransition = {},
    removeTransition = {}
  }) {
    const scrollers = new Set(),
          beforeElements = Array.from(outerElement.querySelectorAll(selector)),
          beforeMap = new Map(beforeElements.map(element => {
      let depth = 0,
          parent = element.parentElement;

      while (parent && parent !== outerElement) {
        depth++;
        parent = parent.parentElement;
      }

      element.$depth = depth; // Store scrolling elements and their current scroll pos, for restoring later

      if (element.scrollHeight > element.offsetHeight && getComputedStyle(element).overflow === 'auto') {
        element.$scrollTop = element.scrollTop;
        scrollers.add(element);
      } // Intersect our bounds with parents, to trim away overflow


      const {
        parentElement
      } = element,
            globalBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, outerElement),
            localBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, parentElement),
            style = getComputedStyle(parentElement),
            borderLeftWidth = parseFloat(style.borderLeftWidth);

      if (borderLeftWidth) {
        globalBounds.left -= borderLeftWidth;
        localBounds.left -= borderLeftWidth;
      }

      return [element.id, {
        element,
        globalBounds,
        localBounds,
        depth,
        parentElement
      }];
    }));
    action.call(thisObj);
    const afterElements = Array.from(outerElement.querySelectorAll(selector)),
          afterMap = new Map(afterElements.map(element => {
      const globalBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, outerElement),
            localBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, element.parentElement),
            style = window.getComputedStyle(element.parentElement),
            borderLeftWidth = parseFloat(style.borderLeftWidth);

      if (borderLeftWidth) {
        globalBounds.left -= borderLeftWidth;
        localBounds.left -= borderLeftWidth;
      }

      return [element.id, {
        element,
        globalBounds,
        localBounds
      }];
    })),
          styleProps = ['position', 'top', 'left', 'width', 'height', 'padding', 'margin', 'zIndex', 'minWidth', 'minHeight', 'opacity', 'overflow']; // Convert to absolute layout, iterating elements remaining after action

    for (const [id, before] of beforeMap) {
      // We match before vs after on id and not actual element, allowing adding a new element with the same id to
      // transition from the old (which was removed or released). To match what will happen when DomSyncing with
      // multiple containing elements (columns in TaskBoard)
      const after = afterMap.get(id);

      if (after) {
        const {
          element
        } = after,
              {
          style,
          parentElement
        } = element,
              // Need to keep explicit zIndex to keep above other stuff
        zIndex = parseInt(DomHelper.getStyleValue(element, 'zIndex')),
              {
          globalBounds,
          localBounds,
          depth,
          parentElement: beforeParent
        } = before,
              parentChanged = beforeParent !== parentElement; // Store initial state, in case element has a style prop we need to restore later

        _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.$initial = {
          parentElement
        }, style, styleProps); // Prevent transition during the process, forced further down instead
        // element.remove();

        let bounds; // Action moved element to another parent, move it to the outer element to allow transitioning to the
        // new parent. Also use coordinates relative to that element

        if (parentChanged) {
          after.bounds = after.globalBounds;
          bounds = globalBounds;
          outerElement.appendChild(element);
        } // Keep element in current parent if it was not moved during the action call above.
        // Need to use coords relative to the parent
        else {
          after.bounds = after.localBounds;
          bounds = localBounds;
          beforeParent.appendChild(element);
        }

        let overflow = 'hidden'; // Looks weird with content sticking out if height is transitioned

        if (scrollers.has(element)) {
          element.$scrollPlaceholder = DomHelper.createElement({
            parent: element,
            style: {
              height: element.scrollHeight
            }
          });
          overflow = 'auto';
        } // Move element back to where it started


        Object.assign(style, {
          position: 'absolute',
          top: `${bounds.top}px`,
          left: `${bounds.left}px`,
          width: `${bounds.width}px`,
          height: `${bounds.height}px`,
          minWidth: 0,
          minHeight: 0,
          padding: 0,
          margin: 0,
          zIndex: depth + (zIndex || 0),
          overflow
        });
        after.processed = true;
      } // Existed before but not after = removed
      else {
        const {
          element,
          localBounds: bounds,
          depth,
          parentElement
        } = before;
        element.$initial = {
          removed: true
        };
        Object.assign(element.style, {
          position: 'absolute',
          top: `${bounds.top}px`,
          left: `${bounds.left}px`,
          width: `${bounds.width}px`,
          height: `${bounds.height}px`,
          minWidth: 0,
          minHeight: 0,
          padding: 0,
          margin: 0,
          zIndex: depth,
          overflow: 'hidden' // Looks weird with content sticking out if height is transitioned

        });
        parentElement.appendChild(element); // Inject among non-removed elements to have it transition away

        afterMap.set(id, {
          element,
          bounds,
          removed: true,
          processed: true
        });
        afterElements.push(element);
      }
    } // Handle new elements


    for (const [, after] of afterMap) {
      if (!after.processed) {
        const {
          element
        } = after,
              {
          style,
          parentElement
        } = element,
              bounds = after.bounds = after.localBounds;
        element.classList.add('b-dom-transition-adding');
        _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.$initial = {
          parentElement
        }, style, styleProps); // Props in `addTransition` will be transitioned

        Object.assign(style, {
          position: 'absolute',
          top: addTransition.top ? 0 : `${bounds.top}px`,
          left: addTransition.left ? 0 : `${bounds.left}px`,
          width: addTransition.width ? 0 : `${bounds.width}px`,
          height: addTransition.height ? 0 : `${bounds.height}px`,
          opacity: addTransition.opacity ? 0 : null,
          zIndex: parentElement.$depth + 1,
          overflow: 'hidden' // Looks weird with content sticking out if height is transitioned

        });
      }
    } // Restore scroll after modifying layout


    for (const element of scrollers) {
      element.scrollTop = element.$scrollTop;
    } // Enable transitions


    outerElement.classList.add('b-dom-transition'); // Trigger layout, to be able to transition below

    outerElement.firstElementChild.offsetWidth; // Transition to new layout

    for (const [, {
      element,
      bounds: afterBounds,
      removed
    }] of afterMap) {
      if (removed) {
        Object.assign(element.style, {
          top: removeTransition.top ? 0 : `${afterBounds.top}px`,
          left: removeTransition.left ? 0 : `${afterBounds.left}px`,
          width: removeTransition.width ? 0 : `${afterBounds.width}px`,
          height: removeTransition.height ? 0 : `${afterBounds.height}px`,
          opacity: removeTransition.opacity ? 0 : element.$initial.opacity
        });
      } else {
        Object.assign(element.style, {
          top: `${afterBounds.top}px`,
          left: `${afterBounds.left}px`,
          width: `${afterBounds.width}px`,
          height: `${afterBounds.height}px`,
          opacity: element.$initial.opacity
        });
      }
    } // Wait for transition to finish


    await _AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].sleep(duration);
    outerElement.classList.remove('b-dom-transition'); // Restore layout after transition

    for (const element of afterElements) {
      if (element.$initial) {
        if (element.$initial.removed) {
          element.remove();
        } else {
          _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.style, element.$initial, styleProps);

          if (element.$scrollPlaceholder) {
            element.$scrollPlaceholder.remove();
            delete element.$scrollPlaceholder;
          }

          element.classList.remove('b-dom-transition-adding');
          element.$initial.parentElement.appendChild(element);
        }
      }
    } // Restore scroll positions last when all layout is restored


    for (const element of scrollers) {
      element.scrollTop = element.$scrollTop;
      delete element.$scrollTop;
    }
  } //endregion


  static async loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  static isNamedColor(color) {
    return color && !/^(#|hsl|rgb)/.test(color);
  }

}
const DH = DomHelper;
let clearTouchTimer;

const clearTouchEvent = () => DH.isTouchEvent = false,
      setTouchEvent = () => {
  DH.isTouchEvent = true; // Jump round the click delay

  clearTimeout(clearTouchTimer);
  clearTouchTimer = setTimeout(clearTouchEvent, 400);
}; // Set event type flags so that mousedown and click handlers can know whether a touch gesture was used.
// This is used. This must stay until we have a unified DOM event system which handles both touch and mouse events.


doc.addEventListener('touchstart', setTouchEvent, true);
doc.addEventListener('touchend', setTouchEvent, true);
DH.canonicalStyles = canonicalStyles;
DH.supportsTemplate = 'content' in doc.createElement('template');
DH.elementPropKey = elementPropKey;
DH.numberRe = numberRe; //region Polyfills
// TODO: include babels polyfills instead of keeping own?

if (!('children' in Node.prototype)) {
  const elementFilter = node => node.nodeType === node.ELEMENT_NODE;

  Object.defineProperty(Node.prototype, 'children', {
    get: function () {
      return Array.prototype.filter.call(this.childNodes, elementFilter);
    }
  });
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    const matches = (this.document || this.ownerDocument).querySelectorAll(s);
    let i = matches.length; // eslint-disable-next-line no-empty

    while (--i >= 0 && matches.item(i) !== this) {}

    return i > -1;
  };
}

if (win.Element && !Element.prototype.closest) {
  Node.prototype.closest = Element.prototype.closest = function (s) {
    let el = this;
    if (!doc.documentElement.contains(el)) return null;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === el.ELEMENT_NODE);

    return null;
  };
} else {
  // It's crazy that closest is not already on the Node interface!
  // Note that some Node types (eg DocumentFragment) do not have a parentNode.
  Node.prototype.closest = function (selector) {
    var _this$parentNode;

    return (_this$parentNode = this.parentNode) === null || _this$parentNode === void 0 ? void 0 : _this$parentNode.closest(selector);
  };
} // from MDN (public domain): https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove


(function (arr) {
  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
      return;
    }

    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode && this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]); // IE11 polyfill


if (!SVGElement.prototype.contains) {
  SVGElement.prototype.contains = function (node) {
    do {
      if (this === node) {
        return true;
      }

      node = node.parentNode;
    } while (node);

    return false;
  };
} // IE11 polyfill for Event constructors


if (typeof win.CustomEvent !== 'function') {
  let evt, constructor;

  win.CustomEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    evt = doc.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  constructor.prototype = win.Event.prototype;

  win.MouseEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    evt = doc.createEvent('MouseEvents');
    evt.initMouseEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.detail, params.screenX, params.screenY, params.clientX, params.clientY, false, false, false, false, 0, document);
    return evt;
  };

  constructor.prototype = win.Event.prototype;

  win.KeyboardEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    const modifiers = `${params.shiftKey ? 'Shift ' : ''}${params.ctrlKey ? 'Control' : ''}`;
    evt = doc.createEvent('KeyboardEvent');
    evt.initKeyboardEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.key, params.location, modifiers, false, '');
    return evt;
  };

  constructor.prototype = win.Event.prototype;
} //endregion
// https://gist.github.com/brettz9/4093766


if (!Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset').get) {
  const propDescriptor = {
    enumerable: true,
    get: function () {
      'use strict';

      let i,
          that = this,
          map = {},
          attrVal,
          attrName,
          propName,
          attribute,
          attributes = this.attributes,
          attsLength = attributes.length,
          toUpperCase = function (n0) {
        return n0.charAt(1).toUpperCase();
      },
          getter = function () {
        return this;
      },
          setter = function (attrName, value) {
        return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
      };

      for (i = 0; i < attsLength; i++) {
        var _attribute;

        attribute = attributes[i]; // Fix: This test really should allow any XML Name without
        //         colons (and non-uppercase for XHTML)

        if ((_attribute = attribute) !== null && _attribute !== void 0 && _attribute.name && /^data-\w[\w-]*$/.test(attribute.name)) {
          attrVal = attribute.value;
          attrName = attribute.name; // Change to CamelCase

          propName = attrName.substr(5).replace(/-./g, toUpperCase);
          Object.defineProperty(map, propName, {
            enumerable: this.enumerable,
            get: getter.bind(attrVal || ''),
            set: setter.bind(that, attrName)
          });
        }
      }

      return map;
    }
  }; // FF enumerates over element's dataset, but not
  // SVGElement.prototype.dataset; IE9 iterates over both

  Object.defineProperty(SVGElement.prototype, 'dataset', propDescriptor);
} // Polyfill to allow an array to be passed to classList.add/remove


const {
  add: nativeAdd,
  remove: nativeRemove
} = DOMTokenList.prototype;

DOMTokenList.prototype.add = function (cls) {
  if (Array.isArray(cls)) {
    cls.forEach(c => nativeAdd.call(this, c));
  } else {
    nativeAdd.call(this, ...arguments);
  }
};

DOMTokenList.prototype.remove = function (cls) {
  if (Array.isArray(cls)) {
    cls.forEach(c => nativeRemove.call(this, c));
  } else {
    nativeRemove.call(this, ...arguments);
  }
}; // CTRL/+ and  CTRL/- zoom gestures must invalidate the scrollbar width.
// Window resize is triggered by this operation on Blink (Chrome & Edge), Firefox and Safari.


window.addEventListener('resize', () => scrollBarWidth = null);
DomHelper._$name = 'DomHelper';

/***/ }),

/***/ "./lib/Core/helper/DomSync.js":
/*!************************************!*\
  !*** ./lib/Core/helper/DomSync.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomSync; });
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';





/**
 * @module Core/helper/DomSync
 */

const arraySlice = Array.prototype.slice,
      emptyArray = Object.freeze([]),
      emptyObject = Object.freeze({}),
      htmlRe = /[&<]/,
      // tests if setInnerText is equivalent to innerHTML
{
  getPrototypeOf
} = Object,
      {
  toString
} = Object.prototype,
      {
  isEqual,
  isObject
} = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"],
      // Attributes used during creation that should not be compared
checkEqualityIgnore = {
  parent: 1,
  elementData: 1,
  ns: 1,
  syncOptions: 1
},
      makeCheckEqualityOptions = () => ({
  ignore: checkEqualityIgnore,
  refsFound: new Set()
}),
      isClass = {
  class: 1,
  className: 1,
  classname: 1
},
      simpleTypes = {
  bigint: 1,
  boolean: 1,
  function: 1,
  number: 1,
  // object
  string: 1,
  symbol: 1 // undefined

},
      // Attributes to ignore on sync
syncIgnoreAttributes = {
  tag: 1,
  html: 1,
  text: 1,
  children: 1,
  tooltip: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  elementData: 1,
  retainElement: 1,
  compareHtml: 1,
  syncOptions: 1,
  listeners: 1,
  isReleased: 1,
  null: 1,
  '': 1
};

const addAndCacheCls = (cls, lastDomConfig) => {
  const propertyName = 'className' in lastDomConfig ? 'className' : 'class',
        propertyValue = lastDomConfig[propertyName];

  if (propertyValue) {
    if (typeof propertyValue === 'string') {
      const value = propertyValue.split(' ');

      if (!value.includes(cls)) {
        value.push(cls);
        lastDomConfig[propertyName] = value.join(' ');
      }
    } else if (Array.isArray(propertyValue)) {
      if (!propertyValue.includes(cls)) {
        propertyValue.push(cls);
      }
    } else if (propertyValue.isDomClassList) {
      propertyValue.add(cls);
    } else if (_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(propertyValue)) {
      propertyValue[cls] = 1;
    }
  }
};

const removeAndUncacheCls = (cls, lastDomConfig) => {
  const propertyName = 'className' in lastDomConfig ? 'className' : 'class',
        propertyValue = lastDomConfig[propertyName];

  if (propertyValue) {
    if (typeof propertyValue === 'string') {
      const value = propertyValue.split(' ');

      if (value.includes(cls)) {
        value.splice(value.indexOf(cls), 1);
        lastDomConfig[propertyName] = value.join(' ');
      }
    } else if (Array.isArray(propertyValue)) {
      if (propertyValue.includes(cls)) {
        propertyValue.splice(propertyValue.indexOf(cls), 1);
      }
    } else if (propertyValue.isDomClassList) {
      propertyValue.remove(cls);
    } else if (_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(propertyValue)) {
      delete propertyValue[cls];
    }
  }
};
/**
 * A utility class for syncing DOM config objects to DOM elements. Syncing compares the new config with the previously
 * used for that element, only applying the difference. Very much like a virtual DOM approach on a per element basis
 * (element + its children).
 *
 * Usage example:
 *
 * ```javascript
 * DomSync.sync({
 *     domConfig: {
 *         className : 'b-outer',
 *         children : [
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 1',
 *                 dataset   : {
 *                     custom : true
 *                 }
 *             },
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 2',
 *                 style     : {
 *                     fontWeight : 'bold',
 *                     color      : 'blue'
 *                 }
 *             }
 *         ]
 *     },
 *     targetElement : target
 * });
 * ```
 */


class DomSync {
  /**
   * Compares two DOM configs or properties of such objects for equality.
   * @param {Object} is The new value.
   * @param {Object} was The old value.
   * @param {Object} options An object with various options to control the comparison.
   * @param {Object} options.ignore An object containing names of attributes to ignore having `true` value.
   * @param {Map} options.equalityCache A map that can be used to record equality results for objects to avoid
   * recomputing the result for the same objects.
   * @param {Set} options.refsFound A Set that must be populated with the values of any `reference` properties found.
   * @param {Boolean|String} [ignoreRefs] Pass `true` to ignore `reference` properties on domConfigs. Pass `'children'`
   * to ignore `reference` properties only on child element configs.
   * @returns {Boolean}
   * @private
   */
  static checkEquality(is, was, options, ignoreRefs) {
    if (is === was) {
      return true;
    } // For purposes of DomSync, null and undefined are equivalent


    if (is == null) {
      return was == null;
    }

    if (!is || !was) {
      return false; // false since is !== was and is != null (we get here if was == null)
    }

    const typeA = typeof is,
          typeB = typeof was;

    if (typeA !== typeB || simpleTypes[typeA]) {
      // only test simpleTypes[typeA] since typeA === typeB
      return false;
    } // a and b are distinct objects or maybe arrays


    let cache = options.equalityCache || (options.equalityCache = new Map()),
        ignoreChildRefs = Boolean(ignoreRefs),
        equal,
        i,
        ignore,
        ignoreRefOpt,
        key,
        syncOptions,
        val; // We must cache results based on both sides of the comparison. If we only cache the result of "is" vs
    // any other value, we get failures in SchedulerWithAutoCommitStore.t.js

    cache = cache.get(is) || cache.set(is, new Map()).get(is);
    equal = cache.get(was);

    if (equal === undefined) {
      equal = true;

      if (getPrototypeOf(is) !== getPrototypeOf(was) || is instanceof Node) {
        // Two Nodes are not equal since they are !==
        equal = false;
      } else if (Array.isArray(is)) {
        // Since we have === prototypes, we know that "was" is also an array
        i = is.length;

        if (i !== was.length) {
          equal = false;
        } else {
          while (i-- > 0) {
            if (!DomSync.checkEquality(is[i], was[i], options, ignoreChildRefs)) {
              equal = false;
              break;
            }
          }
        }
      } else {
        var _syncOptions;

        syncOptions = is.syncOptions;
        ignoreRefOpt = (_syncOptions = syncOptions) === null || _syncOptions === void 0 ? void 0 : _syncOptions.ignoreRefs;

        if (ignoreRefOpt) {
          ignoreChildRefs = true;
          ignoreRefs = ignoreRefOpt !== 'children';
        }

        ignore = options.ignore || emptyObject; // We have 2 objects w/same prototype and that are not HTML nodes
        // https://jsbench.me/n2kgfre1r5/1 - profiles for-in-object loops vs for loop over keys array
        // fwiw, the smaller the object, the greater the benefit of for-in loop

        for (key in was) {
          if (!ignore[key] && !(key in is) && !(ignoreRefs && key === 'reference')) {
            equal = false;
            break;
          }
        }

        if (equal) {
          if (toString.call(was) === '[object Date]') {
            // Since we have === prototypes, we know that "was" is also a Date
            equal = is.getTime() === was.getTime();
          } else {
            for (key in is) {
              if (!ignore[key] && !(ignoreRefs && key === 'reference')) {
                if (!(key in was)) {
                  equal = false;
                  break;
                }

                val = is[key]; // Per Johan:
                //  Not sure we still use DocumentFragment. Used to be part of event rendering earlier,
                //  but I think I have refactored it away. Worth checking
                //  ...
                //  Not finding any usages
                //
                // DocumentFragment, compare separately supplied html
                // if (key === 'html' && typeof val !== 'string' && `compareHtml` in is) {
                //     if (is.compareHtml === was.compareHtml) {
                //         continue;
                //     }
                // }

                if (!DomSync.checkEquality(val, was[key], options, ignoreChildRefs)) {
                  equal = false;
                  break;
                }
              }
            }
          }
        }
      }

      if (!ignoreRefs && isObject(is) && is.reference) {
        var _options$refsFound;

        // We need to track object w/reference properties to know what reference elements may have
        // been removed since we may skip synchronizing them.
        (_options$refsFound = options.refsFound) === null || _options$refsFound === void 0 ? void 0 : _options$refsFound.add(is.reference);
      }

      cache.set(was, equal);
    }

    return equal;
  }
  /**
   * Sync a DOM config to a target element
   * @param {Object} options Options object
   * @param {DomConfig} options.domConfig A DOM config object
   * @param {HTMLElement} options.targetElement Target element to apply to
   * @param {Boolean} [options.strict=false] Specify `true` to limit synchronization to only the values set by
   * previous calls. Styles and classes placed directly on the DOM elements by other means will not be affected.
   * @param {String} [options.syncIdField] Field in dataset to use to match elements for re-usage
   * @param {String|String[]} [options.affected] The references affected by a partial sync.
   * @param {Function} [options.callback] A function that will be called on element re-usage, creation and similar
   * @param {Boolean} [options.configEquality] A function that will be called to compare an incoming config to
   * the last config applied to the `targetElement`. This function returns `true` if the passed values are equal and
   * `false` otherwise.
   * @returns {HTMLElement} Returns the updated target element (which is also updated in place)
   */


  static sync(options) {
    const optionsIn = options,
          {
      refOwner
    } = options,
          refsWas = refOwner === null || refOwner === void 0 ? void 0 : refOwner.byRef,
          checkEqualityOptions = makeCheckEqualityOptions();
    let affected = options.affected,
        i,
        ref,
        targetNode,
        lastDomConfig;

    if (typeof affected === 'string') {
      affected = [affected];
    } // NOTE: it is possible to reenter this method in at least the following way:
    //   - sync() causes a focus change by manipulating the activeElement.
    //   - a focus/blur/focusin/out event causes a widget config to initiate a recompose.
    //   - the event also triggers code that forces the recompose to flush (e.g., by using a reference el).


    options = _objectSpread(_objectSpread({}, options), {}, {
      checkEqualityOptions
    });

    if (refOwner) {
      // We always rebuild the byRef map on each call
      refOwner.byRef = {};

      if (affected) {
        // We need to preserve all previously rendered refs that are not going to be affected by this partial
        // update...
        for (ref in refsWas) {
          if (!affected.includes(ref)) {
            refOwner.byRef[ref] = refsWas[ref];
          }
        }
      }

      options.refsWas = refsWas;
    } // performSync() returns false if nothing was done because the configs were equal... we bend the rules on
    // modifying input objects so we can return this potentially important detail to our caller:


    optionsIn.changed = DomSync.performSync(options, options.targetElement);

    if (refOwner) {
      if (!affected) {
        affected = Object.keys(refsWas);
      }

      for (i = 0; i < affected.length; ++i) {
        ref = affected[i];
        targetNode = refsWas[ref];

        if (checkEqualityOptions.refsFound.has(ref) || targetNode.retainElement) {
          refOwner.byRef[ref] = targetNode;
        } else {
          lastDomConfig = targetNode.lastDomConfig;
          targetNode.remove();
          refOwner.detachRef(ref, targetNode, lastDomConfig);
        }
      }
    }

    return options.targetElement;
  }

  static performSync(options, targetElement) {
    const {
      domConfig,
      callback
    } = options,
          {
      lastDomConfig
    } = targetElement,
          configIsEqual = options.configEquality || DomSync.checkEquality;

    if (!configIsEqual(domConfig, lastDomConfig, options.checkEqualityOptions, options.ignoreRefs)) {
      if (domConfig) {
        // Sync without affecting the containing element?
        if (!domConfig.onlyChildren) {
          DomSync.syncAttributes(domConfig, targetElement, options);
          DomSync.syncContent(domConfig, targetElement);
        }

        DomSync.syncChildren(options, targetElement);
      } // Allow null to clear html
      else {
        targetElement.innerHTML = null;
        targetElement.syncIdMap = null;
      } // Cache the config on the target for future comparison


      targetElement.lastDomConfig = !(domConfig !== null && domConfig !== void 0 && domConfig.onlyChildren && lastDomConfig) ? domConfig : _objectSpread(_objectSpread({}, lastDomConfig), {}, {
        children: domConfig.children
      });
      return true;
    } else {
      // Sync took no action, notify the world
      callback === null || callback === void 0 ? void 0 : callback({
        action: 'none',
        domConfig,
        targetElement
      });
    }

    return false;
  } //region Attributes


  static syncDataset(domConfig, targetElement) {
    const {
      lastDomConfig
    } = targetElement,
          sameConfig = domConfig === lastDomConfig,
          source = Object.keys(domConfig.dataset),
          target = lastDomConfig && lastDomConfig.dataset && Object.keys(lastDomConfig.dataset),
          delta = _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].delta(source, target);
    let attr, i, name, value; // New attributes in dataset

    for (i = 0; i < delta.onlyInA.length; i++) {
      attr = delta.onlyInA[i];
      value = domConfig.dataset[attr]; // Prevent data-property="null" or data-property="undefined"

      if (value != null) {
        targetElement.setAttribute(`data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(attr)}`, value);
      }
    } // Might have changed


    for (i = 0; i < delta.inBoth.length; i++) {
      attr = delta.inBoth[i];
      value = domConfig.dataset[attr]; // Intentional != since dataset is always string but want numbers to match
      // noinspection EqualityComparisonWithCoercionJS

      if (sameConfig || value != lastDomConfig.dataset[attr]) {
        name = `data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(attr)}`;

        if (value == null) {
          targetElement.removeAttribute(name);
        } else {
          targetElement.setAttribute(name, value);
        }
      }
    } // Removed


    for (i = 0; i < delta.onlyInB.length; i++) {
      targetElement.removeAttribute(`data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(delta.onlyInB[i])}`);
    }
  }
  /**
   * Adds CSS classes to the element and to the cache.
   * @param {Core.helper.util.DomClassList|String|String[]|Object} cls
   * @param {HTMLElement} targetElement A previously DomSynced element
   * @internal
   */


  static addCls(cls, targetElement) {
    const {
      lastDomConfig
    } = targetElement;
    cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'array');
    cls.forEach(cls => {
      targetElement.classList.add(cls);
      addAndCacheCls(cls, lastDomConfig);
    });
  }
  /**
   * Adds CSS classes from the element and from the cache.
   * @param {Core.helper.util.DomClassList|String|String[]|Object} cls
   * @param {HTMLElement} targetElement A previously DomSynced element
   * @internal
   */


  static removeCls(cls, targetElement) {
    const {
      lastDomConfig
    } = targetElement;
    cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'array');
    cls.forEach(cls => {
      targetElement.classList.remove(cls);
      removeAndUncacheCls(cls, lastDomConfig);
    });
  }

  static syncClassList(domConfig, targetElement, lastDomConfig) {
    let cls = domConfig.className || domConfig.class,
        c,
        currentClasses,
        i,
        k,
        keep,
        last;

    if (lastDomConfig) {
      // NOTE: The following reads the DOM to determine classes that may have been added by other means. This
      //  diff is only enabled when "strict" is used (see our callers)
      currentClasses = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(targetElement, 'array');
      cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'object');
      last = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(lastDomConfig.className || lastDomConfig.class, 'object');
      keep = [];

      for (i = 0, k = currentClasses.length; i < k; ++i) {
        c = currentClasses[i]; // We want to keep classes not in cls if we didn't add them last time

        if (cls[c] || !(c in last)) {
          last[c] = 1;
          keep.push(c);
        }
      }

      for (c in cls) {
        if (!last[c]) {
          keep.push(c);
        }
      }

      cls = keep.join(' ');
    } else {
      cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls); // to string
    }

    targetElement.setAttribute('class', cls);
  } // Attributes as map { attr : value, ... }


  static getSyncAttributes(domConfig) {
    const attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
    names = []; // On a first sync, there are no domConfig on the target element yet

    if (domConfig) {
      Object.keys(domConfig).forEach(attr => {
        if (!syncIgnoreAttributes[attr]) {
          const name = attr.toLowerCase();
          attributes[name] = domConfig[attr];
          names.push(name);
        }
      });
    }

    return {
      attributes,
      names
    };
  }

  static syncAttributes(domConfig, targetElement, options) {
    const {
      lastDomConfig
    } = targetElement,
          // If the same config has come through, due to configEquality, we must update all attrs.
    sameConfig = domConfig === lastDomConfig,
          sourceSyncAttrs = DomSync.getSyncAttributes(domConfig),
          // Extract attributes from elements (sourceElement might be a config)
    {
      attributes: sourceAttributes,
      names: sourceNames
    } = sourceSyncAttrs,
          {
      attributes: targetAttributes,
      names: targetNames
    } = sameConfig ? sourceSyncAttrs : DomSync.getSyncAttributes(lastDomConfig),
          // Intersect arrays to determine what needs adding, removing and syncing
    {
      onlyInA: toAdd,
      onlyInB: toRemove,
      inBoth: toSync
    } = sameConfig ? {
      onlyInA: emptyArray,
      onlyInB: emptyArray,
      inBoth: sourceNames
    } : _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].delta(sourceNames, targetNames);
    let attr, i; // Add new attributes

    for (i = 0; i < toAdd.length; i++) {
      attr = toAdd[i];
      const sourceAttr = sourceAttributes[attr]; // Style requires special handling

      if (attr === 'style' && sourceAttr != null) {
        // TODO: Do diff style apply also instead of this replace
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, sourceAttr, true);
      } // So does dataset
      else if (attr === 'dataset') {
        DomSync.syncDataset(domConfig, targetElement);
      } // And class, which might be an object
      else if (isClass[attr]) {
        DomSync.syncClassList(domConfig, targetElement);
      } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine),
      // unless they are undefined in which case they are ignored to not get `href="undefined"` etc
      else if (sourceAttr != null) {
        targetElement.setAttribute(attr, sourceAttr);
      }
    } // Removed no longer used attributes


    for (i = 0; i < toRemove.length; i++) {
      targetElement.removeAttribute(toRemove[i]);
    } // TODO: toAdd and toSync are growing very alike, consider merging
    // Sync values for all other attributes


    for (i = 0; i < toSync.length; i++) {
      attr = toSync[i];
      const sourceAttr = sourceAttributes[attr],
            targetAttr = targetAttributes[attr]; // Attribute value null means remove attribute

      if (sourceAttr == null) {
        targetElement.removeAttribute(attr);
      } // Set all attributes that has changed, with special handling for style.
      else if (attr === 'style') {
        if (options.strict) {
          if (sameConfig) {
            DomSync.syncStyles(targetElement, sourceAttr);
          } else if (!isEqual(sourceAttr, targetAttr, true)) {
            DomSync.syncStyles(targetElement, sourceAttr, targetAttr);
          }
        } else if (sameConfig || !isEqual(sourceAttr, targetAttr, true)) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, sourceAttr, true);
        }
      } // And dataset
      else if (attr === 'dataset') {
        DomSync.syncDataset(domConfig, targetElement);
      } // And class, which might be an object
      else if (isClass[attr]) {
        DomSync.syncClassList(domConfig, targetElement, options.strict && targetElement.lastDomConfig);
      } else if (sameConfig || sourceAttr !== targetAttr) {
        targetElement.setAttribute(attr, sourceAttr);
      }
    }
  }

  static syncStyles(targetElement, sourceAttr, targetAttr) {
    let styles, key, value;

    if (!targetAttr) {
      styles = sourceAttr;
    } else {
      styles = {}; // Style could be a string so we parse it to object to iterate over it's properties correctly

      sourceAttr = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseStyle(sourceAttr);
      targetAttr = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseStyle(targetAttr);

      if (sourceAttr) {
        for (key in sourceAttr) {
          value = sourceAttr[key];

          if (targetAttr[key] !== value) {
            styles[key] = value;
          }
        }
      }

      for (key in targetAttr) {
        if (!(key in sourceAttr)) {
          styles[key] = '';
        }
      }
    }

    _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, styles);
  } //endregion
  //region Content


  static syncContent(domConfig, targetElement) {
    const {
      html,
      text
    } = domConfig,
          content = text !== null && text !== void 0 ? text : html; // elementData holds custom data that we want to attach to the element (not visible in dom)

    if (domConfig.elementData) {
      targetElement.elementData = domConfig.elementData;
    } // Apply html from config


    if (content instanceof DocumentFragment) {
      // If given a DocumentFragment, replace content with it
      if (targetElement.childNodes.length === 1 && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(targetElement) === 0 && content.childNodes.length === 1 && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(content) === 0) {
        // Syncing a textNode to a textNode? Use shortcut
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setInnerText(targetElement, content.firstChild.data);
      } else {
        targetElement.innerHTML = '';
        targetElement.appendChild(content);
      }
    } // If content is likely html we set innerHTML
    else if (html != null && htmlRe.test(html)) {
      targetElement.innerHTML = String(html); // convert numbers to strings
    } else if (content != null) {
      var _lastDomConfig$childr;

      const {
        lastDomConfig
      } = targetElement; // If element had children or actual html content in last sync we force innerHTML to get rid of them

      if (lastDomConfig !== null && lastDomConfig !== void 0 && (_lastDomConfig$childr = lastDomConfig.children) !== null && _lastDomConfig$childr !== void 0 && _lastDomConfig$childr.length || lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.html && htmlRe.test(targetElement.lastDomConfig.html)) {
        targetElement.innerHTML = content;
      } // Otherwise we try to update the text as cheaply as possible (node data if possible)
      else {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setInnerText(targetElement, String(content));
      }
    }
  }

  static insertTextNode(text, targetElement, callback, refOwner, beforeElement = null) {
    const newNode = document.createTextNode(text);
    targetElement.insertBefore(newNode, beforeElement);

    if (refOwner) {
      newNode.$refOwnerId = refOwner.id;
    }

    callback === null || callback === void 0 ? void 0 : callback({
      action: 'newNode',
      domConfig: text,
      targetElement: newNode
    });
  }

  static insertElement(domConfig, targetElement, targetNode, refOwner, syncIdMap, syncId, options) {
    var _options$callback;

    // Create a new element
    const newElement = options.ns ? document.createElementNS(options.ns, domConfig.tag || 'svg') : document.createElement(domConfig.tag || 'div'); // Insert (or append if no targetNode)

    targetElement.insertBefore(newElement, targetNode); // Sync to it

    DomSync.performSync(options, newElement);

    if (syncId != null) {
      syncIdMap[syncId] = newElement;
    }

    if (refOwner) {
      newElement.$refOwnerId = refOwner.id;

      if (syncId) {
        newElement.$reference = syncId;
        refOwner.attachRef(syncId, newElement, domConfig);
      }
    }

    (_options$callback = options.callback) === null || _options$callback === void 0 ? void 0 : _options$callback.call(options, {
      action: 'newElement',
      domConfig,
      targetElement: newElement,
      syncId
    });
  } //endregion
  //region Children


  static syncChildren(options, targetElement) {
    var _domConfig$html, _syncOptions$ignoreRe;

    let {
      // eslint-disable-next-line prefer-const
      domConfig,
      syncIdField,
      callback,
      releaseThreshold,
      configEquality,
      ns,
      refOwner,
      refsWas,
      strict,
      checkEqualityOptions,
      ignoreRefs
    } = options,
        syncOptions = domConfig.syncOptions || {},
        // eslint-disable-line prefer-const
    cleanupNodes = null,
        index,
        nextNode,
        syncId; // Having specified html or text replaces all inner content, no point in syncing

    if ((_domConfig$html = domConfig.html) !== null && _domConfig$html !== void 0 ? _domConfig$html : domConfig.text) {
      return;
    } // This will affect the whole subtree since this goes into syncChildOptions (we convert 'children' to true
    // here because we are only processing the children):


    ignoreRefs = Boolean((_syncOptions$ignoreRe = syncOptions.ignoreRefs) !== null && _syncOptions$ignoreRe !== void 0 ? _syncOptions$ignoreRe : ignoreRefs);

    if (ignoreRefs) {
      refOwner = refsWas = null;
    }

    if ('strict' in syncOptions) {
      strict = syncOptions.strict;
    }

    const // Always repopulate the map, since elements might get used by other syncId below
    newSyncIdMap = refOwner ? refOwner.byRef : {},
          sourceConfigs = arraySlice.call(domConfig.children || []),
          targetNodes = arraySlice.call(targetElement.childNodes),
          syncIdMap = refsWas || targetElement.syncIdMap || {},
          releasedIdMap = targetElement.releasedIdMap || {},
          nextTarget = remove => {
      // Recursive calls to performSync can teleport elements around the DOM tree (when we are given
      // the DOM nodes in the domConfig), so be sure to skip over any elements that are no longer children
      // of our targetElement
      while (targetNodes.length && targetNodes[0].parentNode !== targetElement) {
        targetNodes.shift();
      }

      return (remove ? targetNodes.shift() : targetNodes[0]) || null;
    }; // Each level can optionally specify its own syncIdField, strict and callback, if left out parent levels will be used


    syncIdField = syncOptions.syncIdField || syncIdField;
    strict = syncOptions.strict || strict;
    callback = syncOptions.callback || callback;
    configEquality = syncOptions.configEquality || configEquality; // Make sure releaseThreshold 0 is respected...

    releaseThreshold = 'releaseThreshold' in syncOptions ? syncOptions.releaseThreshold : releaseThreshold;

    if (syncIdField) {
      targetElement.syncIdMap = newSyncIdMap;
    } // Settings to use in all syncs below


    const syncChildOptions = {
      checkEqualityOptions: checkEqualityOptions || makeCheckEqualityOptions(),
      ignoreRefs,
      refOwner,
      refsWas,
      strict,
      syncIdField,
      releaseThreshold,
      callback,
      configEquality
    };

    while (sourceConfigs.length) {
      const sourceConfig = sourceConfigs.shift();
      syncId = null; // Allowing null, convenient when using Array.map() to generate children

      if (!sourceConfig) {
        continue;
      }

      if (sourceConfig instanceof Node) {
        nextNode = nextTarget(); // Widgets may supply the element of another widget in their rendering... just insert it and move on

        if (sourceConfig !== nextNode) {
          targetElement.insertBefore(sourceConfig, nextNode);
        }

        index = targetNodes.indexOf(sourceConfig);

        if (index > -1) {
          targetNodes.splice(index, 1);
        }

        continue;
      }

      const isTextNode = typeof sourceConfig === 'string'; // Used in all syncs

      syncChildOptions.domConfig = sourceConfig;
      syncChildOptions.ns = sourceConfig.ns || ns;

      if (!isTextNode) {
        // If syncIdField was supplied, we should first try to reuse element with
        // matching "id"
        if (refOwner) {
          syncId = sourceConfig.reference;
        } else if (syncIdField && sourceConfig.dataset) {
          syncId = sourceConfig.dataset[syncIdField];
        } // We have an id to look for


        if (syncId != null && !sourceConfig.unmatched) {
          // Find any matching element, either in use or previously released
          const syncTargetElement = syncIdMap[syncId] || releasedIdMap[syncId];

          if (syncTargetElement) {
            const {
              lastDomConfig
            } = syncTargetElement; // Just relink if flagged with `retainElement` (for example during dragging)

            if (syncTargetElement.retainElement) {// DomSync.relinkElements(syncChildOptions.domConfig, syncTargetElement);
            } // Otherwise sync with the matched element
            else if (DomSync.performSync(syncChildOptions, syncTargetElement)) {
              var _callback;

              // Sync took some action, notify the world
              (_callback = callback) === null || _callback === void 0 ? void 0 : _callback({
                action: 'reuseOwnElement',
                domConfig: sourceConfig,
                targetElement: syncTargetElement,
                lastDomConfig,
                syncId
              });
            } // Since it wont sync above when flagged to be retained, we need to apply the flag here


            if (sourceConfig.retainElement) {
              syncTargetElement.retainElement = true;
            } // Cache the element on the syncIdMap for faster retrieval later


            newSyncIdMap[syncId] = syncTargetElement; // Remove target from targetElements & release tracking, no-one else is allowed to sync with it

            _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].remove(targetNodes, syncTargetElement);
            delete releasedIdMap[syncId];
            syncTargetElement.isReleased = false;
            nextNode = nextTarget();

            if (syncTargetElement.parentNode !== targetElement || strict && syncTargetElement.nextSibling !== nextNode) {
              targetElement.insertBefore(syncTargetElement, nextNode);
            }
          } else if (strict) {
            DomSync.insertElement(sourceConfig, targetElement, nextTarget(), refOwner, newSyncIdMap, syncId, syncChildOptions);
          } else {
            // No match, move to end of queue to not steal some one else's element
            sourceConfigs.push(sourceConfig); // Also flag as unmatched to know that when we reach this element again

            sourceConfig.unmatched = true;
          } // Node handled, carry on with next one


          continue;
        } // Avoid polluting the config object when done


        if (sourceConfig.unmatched) {
          delete sourceConfig.unmatched;
        }
      } // Skip over any retained elements


      let beforeNode = null,
          targetNode = null,
          cleanupNode;

      while (!targetNode && (cleanupNode = nextTarget(true))) {
        if (refOwner) {
          // When syncing for a refOwner, foreign elements are skipped.
          if (cleanupNode.$refOwnerId !== refOwner.id) {
            continue;
          }

          if (cleanupNode.$reference) {
            // In refOwner mode we always pass strict:true, so this won't happen... but if it did, the
            // idea is that ref els do not get cleaned up until the end of the sync process.
            if (!strict) {
              continue;
            } // Since we want to maintain DOM order, this ref el marks the spot where to insert. We also
            // don't want to put it into cleanupNodes (see above). We cannot reuse ref els.


            beforeNode = cleanupNode;
            break;
          } // The element is owned by this refOwner and not assigned a reference...
          // We can reuse it


          targetNode = cleanupNode;
        } else if (!cleanupNode.retainElement) {
          targetNode = cleanupNode;
        }

        if (!targetNode) {
          (cleanupNodes || (cleanupNodes = [])).push(cleanupNode);
        }
      }

      if (beforeNode || !targetNode) {
        if (isTextNode) {
          DomSync.insertTextNode(sourceConfig, targetElement, callback, refOwner, beforeNode);
        } else {
          // Will append if beforeNode === null
          DomSync.insertElement(sourceConfig, targetElement, beforeNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
        }
      } // We have targets left
      else {
        // Matching element tag, sync it
        if (!isTextNode && targetNode.nodeType === Node.ELEMENT_NODE && (sourceConfig.tag || 'div').toLowerCase() === targetNode.tagName.toLowerCase()) {
          var _lastDomConfig$datase, _callback2;

          const {
            lastDomConfig
          } = targetNode,
                result = DomSync.performSync(syncChildOptions, targetNode); // Remove reused element from release tracking

          if (syncIdField && (lastDomConfig === null || lastDomConfig === void 0 ? void 0 : (_lastDomConfig$datase = lastDomConfig.dataset) === null || _lastDomConfig$datase === void 0 ? void 0 : _lastDomConfig$datase[syncIdField]) != null) {
            delete releasedIdMap[lastDomConfig.dataset[syncIdField]];
          }

          if (syncId != null) {
            newSyncIdMap[syncId] = targetNode;
          }

          targetNode.isReleased = false; // Only use callback if sync succeeded (anything changed)

          result && ((_callback2 = callback) === null || _callback2 === void 0 ? void 0 : _callback2({
            action: 'reuseElement',
            domConfig: sourceConfig,
            targetElement: targetNode,
            lastDomConfig,
            syncId
          }));
        } // Text node to text node, change text :)
        else if (isTextNode && targetNode.nodeType === Node.TEXT_NODE) {
          targetNode.data = sourceConfig; // Not using callback for updating text of node, have no usecase for it currently
        } // Not matching, replace it
        else {
          if (isTextNode) {
            DomSync.insertTextNode(sourceConfig, targetElement, callback, refOwner, targetNode);
          } else {
            // Will insert
            DomSync.insertElement(sourceConfig, targetElement, targetNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
          }

          targetNode.remove();
        }
      }
    } // while (sourceConfigs.length)
    // Out of source nodes, remove remaining target nodes


    while (nextNode = nextTarget(true)) {
      // Any remaining nodes that belong to this refOwner need to be cleaned up. If
      // they have an assigned reference, however, they will be handled at the very
      // end of the sync process since those elements can move in the node hierarchy.
      if (!refOwner || nextNode.$refOwnerId === refOwner.id && !nextNode.$reference) {
        (cleanupNodes || (cleanupNodes = [])).push(nextNode);
      }
    }

    if (cleanupNodes) {
      DomSync.syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField);
    }
  }

  static syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField) {
    let releaseCount = 0,
        ref;

    for (const targetNode of cleanupNodes) {
      const {
        lastDomConfig
      } = targetNode; // Element might be retained, hands off (for example while dragging)

      if (!targetNode.retainElement) {
        // When using syncId to reuse elements, "release" left over elements instead of removing them, up to a
        // limit specified as releaseThreshold, above which elements are removed instead
        if (!refOwner && syncIdField && (releaseThreshold == null || releaseCount < releaseThreshold)) {
          // Prevent releasing already released element
          if (!targetNode.isReleased) {
            targetNode.className = 'b-released';
            targetNode.isReleased = true; // Store released element in syncIdMap, to facilitate reusing it for self later

            if (lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.dataset) {
              if (!targetElement.releasedIdMap) {
                targetElement.releasedIdMap = {};
              }

              targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]] = targetNode;
            }

            callback === null || callback === void 0 ? void 0 : callback({
              action: 'releaseElement',
              domConfig: lastDomConfig,
              lastDomConfig,
              targetElement: targetNode
            }); // Done after callback on purpose, to allow checking old className

            if (lastDomConfig) {
              // Make sure lastDomConfig differs even from the same domConfig applied again
              // Do not want to discard it completely since it is needed for diff when reused later
              lastDomConfig.isReleased = true; // To force reapply of classes on reuse

              if (lastDomConfig.className) {
                lastDomConfig.className = 'b-released';
              }

              if (lastDomConfig.class) {
                lastDomConfig.class = 'b-released';
              } // Same for style
              // (for elements positioned using style, when moved in a non DomSync way, aka EventDrag)


              if (lastDomConfig.style) {
                lastDomConfig.style = null;
              }
            }
          }

          releaseCount++;
        } // In normal sync mode, remove left overs
        else {
          targetNode.remove();

          if (refOwner) {
            ref = targetNode.$reference;

            if (ref) {
              refOwner.detachRef(ref, targetNode, lastDomConfig);
            }
          } // Remove from "release tracking"


          if (targetElement.releasedIdMap && syncIdField && lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.dataset) {
            delete targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]];
          }

          callback === null || callback === void 0 ? void 0 : callback({
            action: 'removeElement',
            domConfig: targetNode.lastDomConfig,
            lastDomConfig: targetNode.lastDomConfig,
            targetElement: targetNode
          });
        }
      } else if (syncIdField) {
        // Keep retained element in map
        if (lastDomConfig) {
          newSyncIdMap[targetNode.dataset[syncIdField]] = targetNode;
        }
      }
    }
  }
  /**
   * Remove a child element without syncing, for example when dragging an element to some other parent.
   * Removes it both from DOM and the parent elements syncMap
   * @param {HTMLElement} parentElement
   * @param {HTMLElement} childElement
   */


  static removeChild(parentElement, childElement) {
    if (parentElement.contains(childElement)) {
      const syncIdMap = parentElement.syncIdMap;

      if (syncIdMap) {
        const index = Object.values(syncIdMap).indexOf(childElement);

        if (index > -1) {
          delete syncIdMap[Object.keys(syncIdMap)[index]];
        }
      }

      parentElement.removeChild(childElement);
    }
  }
  /**
   * Adds a child element without syncing, making it properly available for later syncs. Useful for example
   * when dragging and dropping an element from some other parent.
   * @param {HTMLElement} parentElement
   * @param {HTMLElement} childElement
   * @param {String|Number} syncId
   */


  static addChild(parentElement, childElement, syncId) {
    parentElement.appendChild(childElement);
    parentElement.syncIdMap[syncId] = childElement;
  }
  /**
   * Get a child element using a dot separated syncIdMap path.
   *
   * ```javascript
   * DomSync.getChild(eventWrap, 'event.percentBar');
   * ```
   *
   * @param {HTMLElement} element "root" element, under which the path starts
   * @param {String} path Dot '.' separated path of syncIdMap entries
   * @returns {HTMLElement} Child element or `null` if path did not match any element
   */


  static getChild(element, path) {
    const syncIds = String(path).split('.');

    for (const id of syncIds) {
      var _element, _element$syncIdMap;

      element = (_element = element) === null || _element === void 0 ? void 0 : (_element$syncIdMap = _element.syncIdMap) === null || _element$syncIdMap === void 0 ? void 0 : _element$syncIdMap[id];

      if (!element) {
        return null;
      }
    }

    return element;
  } //endregion


}
DomSync._$name = 'DomSync';

/***/ }),

/***/ "./lib/Core/helper/DragHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DragHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragHelper; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/DragHelperContainer.js */ "./lib/Core/helper/mixin/DragHelperContainer.js");
/* harmony import */ var _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/DragHelperTranslate.js */ "./lib/Core/helper/mixin/DragHelperTranslate.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';








 //TODO: add touch support
//TODO: add pointer events support

/**
 * @module Core/helper/DragHelper
 */

const rootElementListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: 'onTouchStart',
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * Helps with drag and drop. Supports two modes of dragging:
 * * `container` - moving/rearranging elements within and between specified containers
 * * `translateXY` - repositioning an element withing its container
 *
 * Usage examples:
 * ```
 * // dragging element between containers
 * let dragHelper = new DragHelper({
 *   mode       : 'container',
 *   containers : [ container1, container2 ]
 * });
 *
 * // dragging element within container
 * let dragHelper = new DragHelper({
 *   mode    : 'translateXY',
 *   targetSelector: 'div.movable'
 * });
 * ```
 * In the various Drag event handlers, you will have access to the raw DOM event and some useful `context` of the drag operation:
 *
 * ```
 *  myDrag.on({
 *      drag : ({event , context}) {
 *            // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
 *           const element = context.element;
 *
 *           // The original mousedown element upon which triggered the drag operation
 *           const grabbed = context.grabbed;
 *
 *           // The target under the current mouse / pointer / touch position
 *           const target = context.target;
 *       }
 *  });
 * ```
 *
 * Simple drag drop with a drop target specified:
 * ```javascript
 * export default class MyDrag extends DragHelper {
 *      static get defaultConfig() {
 *          return {
 *              // Don't drag the actual cell element, clone it
 *              cloneTarget        : true,
 *              mode               : 'translateXY',
 *              // Only allow drops on DOM elements with 'yourDropTarget' CSS class specified
 *              dropTargetSelector : '.yourDropTarget',
 *
 *              // Only allow dragging elements with the 'draggable' CSS class
 *              targetSelector : '.draggable'
 *          };
 *      }
 *
 *      construct(config) {
 *          const me = this;
 *
 *          super.construct(config);
 *
 *          me.on({
 *              dragstart : me.onDragStart
 *          });
 *      }
 *
 *      onDragStart({ event, context }) {
 *          const target = context.target;
 *
 *          // Here you identify what you are dragging (an image of a user, grid row in an order table etc) and map it to something in your
 *          // data model. You can store your data on the context object which is available to you in all drag-related events
 *          context.userId = target.dataset.userId;
 *      }
 *
 *      onEquipmentDrop({ context, event }) {
 *          const me = this;
 *
 *          if (context.valid) {
 *              const userId   = context.userId,
 *                    droppedOnTarget = context.target;
 *
 *              console.log(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`, droppedOnTarget);
 *
 *              // Dropped on a scheduled event, display toast
 *              WidgetHelper.toast(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`);
 *
 *              // tell the drag helper the operation is finished
 *              me.context.finalize();
 *          }
 *      }
 *  };
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */

class DragHelper extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * Drag proxy CSS class
       * @config {String}
       * @default
       * @private
       */
      dragProxyCls: 'b-drag-proxy',

      /**
       * CSS class added when drag is invalid
       * @config {String}
       * @default
       */
      invalidCls: 'b-drag-invalid',

      /**
       * CSS class added to the source element in Container drag
       * @config {String}
       * @default
       * @private
       */
      draggingCls: 'b-dragging',

      /**
       * CSS class added to the source element in Container drag
       * @config {String}
       * @default
       * @private
       */
      dropPlaceholderCls: 'b-drop-placeholder',

      /**
       * The amount of pixels to move mouse before it counts as a drag operation
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * The outer element where the drag helper will operate (attach events to it and use as outer limit when looking for ancestors)
       * @config {HTMLElement}
       * @default
       */
      outerElement: document.body,

      /**
       * Outer element that limits where element can be dragged
       * @config {HTMLElement}
       * @default
       */
      dragWithin: null,
      monitoringConfig: null,

      /**
       * Constrain translate drag to dragWithin elements bounds (set to false to allow it to "overlap" edges)
       * @config {Boolean}
       * @default
       */
      constrain: true,

      /**
       * Smallest allowed x when dragging horizontally.
       * @config {Number}
       * @default
       */
      minX: null,

      /**
       * Largest allowed x when dragging horizontally.
       * @config {Number}
       * @default
       */
      maxX: null,

      /**
       * Smallest allowed y when dragging horizontally.
       * @config {Number}
       * @default
       */
      minY: null,

      /**
       * Largest allowed y when dragging horizontally.
       * @config {Number}
       * @default
       */
      maxY: null,

      /**
       * Enabled dragging, specify mode:
       * <table>
       * <tr><td>container<td>Allows reordering elements within one and/or between multiple containers
       * <tr><td>translateXY<td>Allows dragging within a parent container
       * </table>
       * @config {String}
       * @default
       */
      mode: null,

      /**
       * A function that determines if dragging an element is allowed. Gets called with the element as argument,
       * return true to allow dragging or false to prevent.
       * @config {Function}
       * @default
       */
      isElementDraggable: null,

      /**
       * A CSS selector used to determine if dragging an element is allowed.
       * @config {String}
       * @default
       */
      targetSelector: null,

      /**
       * A CSS selector used to determine if a drop is allowed at the current position.
       * @config {String}
       * @default
       */
      dropTargetSelector: null,

      /**
       * Set to true to clone the dragged target, and not move the actual target DOM node.
       * @config {Boolean}
       * @default
       */
      cloneTarget: false,

      /**
       * Set to true to hide the original element while dragging (applicable when `cloneTarget` is true).
       * @config {Boolean}
       * @default
       */
      hideOriginalElement: false,

      /**
       * Containers whose elements can be rearranged (and moved between the containers). Used when
       * mode is set to "container".
       * @config {HTMLElement[]}
       * @default
       */
      containers: null,

      /**
       * A CSS selector used to exclude elements when using container mode
       * @config {String}
       * @default
       */
      ignoreSelector: null,
      startEvent: null,

      /**
       * Configure as `true` to disallow dragging in the `X` axis. The dragged element will only move vertically.
       * @config {Boolean}
       * @default
       */
      lockX: false,

      /**
       * Configure as `true` to disallow dragging in the `Y` axis. The dragged element will only move horizontally.
       * @config {Boolean}
       * @default
       */
      lockY: false,

      /**
       * The amount of milliseconds to wait after a touchstart, before a drag gesture will be allowed to start.
       * @config {Number}
       * @default
       */
      touchStartDelay: 300,

      /**
       * Scroll manager of the target. If specified, scrolling while dragging is supported.
       * @config {Core.util.ScrollManager}
       */
      scrollManager: null,

      /**
       * A method provided to snap coordinates to fixed points as you drag
       * @config {Function}
       * @internal
       */
      snapCoordinates: null,
      // For the abort animation
      transitionDuration: 300,
      clickSwallowDuration: 50,
      ignoreSamePositionDrop: true,
      // for container mode
      floatRootOwner: null,
      testConfig: {
        transitionDuration: 10,
        // In Edge synthetic click events are fired asynchronously and can take considerable
        // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
        // Caught by test EventDrag4.t in Edge
        clickSwallowDuration: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isEdge ? 300 : 50
      }
    };
  } //endregion
  //region Events

  /**
   * Fired before dragging starts, return false to prevent the drag operation.
   * @preventable
   * @event beforeDragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The original element upon which the mousedown event triggered a drag operation
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired when dragging starts.
   * @event dragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
   * @param {HTMLElement} context.grabbed The original element upon which the mousedown event triggered a drag operation
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired while dragging, you can signal that the drop is valid or invalid by setting `context.valid = false;`
   * @event drag
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
   * @param {HTMLElement} context.grabbed The original element upon which the mousedown event triggered a drag operation
   * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
   * @param {MouseEvent} event
   */
  //endregion
  //region Init

  /**
   * Initializes a new DragHelper.
   * @param {Object} config Configuration object, accepts options specified under Configs above
   * @example
   * new DragHelper({
   *   containers: [div1, div2],
   *   isElementDraggable: element => element.className.contains('handle'),
   *   outerElement: topParent,
   *   listeners: {
   *     drop: onDrop,
   *     thisObj: this
   *   }
   * });
   * @function constructor
   */


  construct(config) {
    const me = this;
    super.construct(config);
    me.initListeners();

    if (me.mode === 'container') {
      me.initContainerDrag();
    } else if (me.mode.startsWith('translate')) {
      me.initTranslateDrag();
    }

    me.onScrollManagerScrollCallback = me.onScrollManagerScrollCallback.bind(this);
    me.initialMode = me.mode;
  }

  doDestroy() {
    // Abort dragging
    this.abort(true);
    super.doDestroy();
  }
  /**
   * Initialize listener
   * @private
   */


  initListeners() {
    const dragStartListeners = {
      element: this.outerElement,
      mousedown: rootElementListeners.down,
      thisObj: this
    };

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isTouchDevice) {
      dragStartListeners.touchstart = rootElementListeners.touchstart;
    } // These will be autoDetached upon destroy


    _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on(dragStartListeners);
    _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
      element: window,
      blur: 'onWindowBlur',
      thisObj: this
    });
  } //endregion
  //region Events

  /**
   * Fires after drop. For valid drops, it exposes `context.async` which you can set to true to signal that additional
   * processing is needed before finalizing the drop (such as showing some dialog). When that operation is done, call
   * `context.finalize(true/false)` with a boolean that determines the outcome of the drop.
   * @event drop
   * @param {Core.helper.DragHelper} dragHelper
   * @param {Object} context
   */


  onPointerDown(event) {
    const me = this; // Visibility check is needed because mousedown on a just-created event element
    // will cause the EventEdit to cancel the add, remove the record and hide the element
    // *but* the mousedown event still bubbles to here and that will throw an error.

    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isVisible(event.target)) {
      return;
    } // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if pointerup happened
    // when current window wasn't focused - tab switch or window switch). Also handles the edge case of trying to
    // start a new drag while previous is awaiting finalization, in which case it just bails out.


    if (me.context) {
      return;
    }

    if (me.isElementDraggable && !me.isElementDraggable(event.target, event)) return;
    me.startEvent = event;
    const handled = me.mode === 'container' ? me.grabContainerDrag(event) : me.mode.startsWith('translate') ? me.grabTranslateDrag(event) : false;

    if (handled) {
      const dragListeners = {
        element: document,
        thisObj: me,
        keydown: rootElementListeners.keydown
      };

      if ('touches' in event) {
        dragListeners.touchmove = {
          handler: rootElementListeners.touchmove,
          passive: false // We need to be able to preventDefault on the touchmove

        }; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
        // iOS do fire touchend

        dragListeners.touchend = dragListeners.pointerup = rootElementListeners.touchend;
      } else {
        dragListeners.mousemove = rootElementListeners.move;
        dragListeners.mouseup = rootElementListeners.up;
      } // A listener detacher is returned;


      me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on(dragListeners);

      if (me.dragWithin && me.dragWithin !== me.outerElement && me.outerElement.contains(me.dragWithin)) {
        const box = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].from(me.dragWithin, me.outerElement);
        me.minY = box.top;
        me.maxY = box.bottom;
        me.minX = box.left;
        me.maxX = box.right;
      }
    }
  }
  /**
   * @param event
   * @private
   */


  onTouchStart(event) {
    const me = this; // only allowing one finger for now...

    if (event.touches.length === 1) {
      me.touchStartTimer = me.setTimeout(() => {
        me.touchStartTimer = null;
      }, me.touchStartDelay, 'touchStartDelay');
      me.onPointerDown(event);
    }
  }
  /**
   * Grab draggable element on mouse down.
   * @private
   * @param event
   */


  onMouseDown(event) {
    // only dragging with left mouse button
    if (event.button === 0) {
      this.onPointerDown(event);
    }
  }

  internalMove(event) {
    const me = this,
          {
      context
    } = me,
          distance = _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getDistanceBetween(me.startEvent, event),
          abortTouchDrag = me.touchStartTimer && distance > me.dragThreshold;

    if (abortTouchDrag) {
      me.abort(true);
      return;
    }

    if (!me.touchStartTimer && context && context.element && // Only target Elements, not text nodes
    event.target && event.target.nodeType === Node.ELEMENT_NODE && (context.started || distance >= me.dragThreshold)) {
      if (!context.started) {
        var _me$scrollManager;

        if (me.trigger('beforeDragStart', {
          context,
          event
        }) === false) {
          return me.abort();
        }

        if (me.mode !== 'container') {
          if (me.lockY) {
            me.mode = 'translateX';
          } else if (me.lockX) {
            me.mode = 'translateY';
          } else {
            me.mode = me.initialMode;
          }
        }

        if (context.action.startsWith('translate')) {
          me.startTranslateDrag(event);
        } else if (context.action === 'container') {
          me.startContainerDrag(event);
        }

        context.started = true; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

        (_me$scrollManager = me.scrollManager) === null || _me$scrollManager === void 0 ? void 0 : _me$scrollManager.startMonitoring(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].merge({
          scrollables: [{
            element: me.dragWithin || me.outerElement
          }],
          callback: me.onScrollManagerScrollCallback
        }, me.monitoringConfig)); // Global informational class for when DragHelper is dragging

        context.outermostEl = event.target.closest('.b-outer') || document.body;
        context.outermostEl.classList.add('b-draghelper-active');
        me.trigger('dragStart', {
          context,
          event
        });
      } // to prevent view drag (scroll) on ipad


      if (event.type === 'touchmove') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      me.update(event);
    }
  }

  onScrollManagerScrollCallback(config) {
    var _this$context;

    const {
      lastMouseMoveEvent
    } = this;

    if ((_this$context = this.context) !== null && _this$context !== void 0 && _this$context.element && lastMouseMoveEvent) {
      // Indicate that this is a 'fake' mousemove event as a result of the scrolling
      lastMouseMoveEvent.isScroll = true;
      this.update(lastMouseMoveEvent, config);
    }
  }

  onTouchMove(event) {
    this.internalMove(event);
  }
  /**
   * Move drag element with mouse.
   * @param event
   * @fires beforeDragStart
   * @fires dragStart
   * @private
   */


  onMouseMove(event) {
    this.internalMove(event);
  }
  /**
   * Updates drag, called when an element is grabbed and mouse moves
   * @private
   * @fires drag
   */


  update(event, scrollManagerConfig) {
    const me = this,
          {
      context
    } = me,
          draggingElement = context.dragProxy || context.element,
          scrollingPageElement = document.scrollingElement || document.body; // two different modes used
    // In case of scrolling need to update target element based on [X, Y] of the mouse event

    let target = !event.isScroll ? event.target : _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].elementFromPoint(event.clientX, event.clientY); // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
    // what's under the cursor as easily in touch devices

    if (event.type === 'touchmove') {
      const touch = event.changedTouches[0];
      target = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].elementFromPoint(touch.clientX + scrollingPageElement.scrollLeft, touch.clientY + scrollingPageElement.scrollTop);
    }

    context.target = target;

    if (me.dropTargetSelector) {
      var _target;

      context.valid = Boolean((_target = target) === null || _target === void 0 ? void 0 : _target.closest(me.dropTargetSelector));
    } else {
      // assume valid drop location
      context.valid = true;
    } // Move the drag proxy or dragged element before triggering the drag event


    if (context.action) {
      if (context.action === 'container') {
        me.updateContainerProxy(event, scrollManagerConfig);
      }

      if (context.action.startsWith('translate')) {
        // Note, if you drag an element from Container A to Container B which is scrollable (handled by ScrollManager),
        // and you notice that the proxy element follows the scroll and goes away from the cursor,
        // make sure you set `outerElement` to the container of the source element (Container A)
        // and set `constrain` to `false`.
        me.updateTranslateProxy(event, scrollManagerConfig);
      }
    } // Allow external code to validate the context before updating a container drag


    me.trigger('drag', {
      context,
      event
    }); // Move the placeholder element into its new place.
    // This will see the new state of context if mutated by a drag listener.

    if (context.action === 'container') {
      me.updateContainerDrag(event, scrollManagerConfig);
    } // change to toggle with force when not supporting IE11 any longer


    draggingElement.classList[context.valid ? 'remove' : 'add'](me.invalidCls);
    if (event) me.lastMouseMoveEvent = event;
  }
  /**
   * Abort dragging
   * @fires abort
   */


  abort(silent = false) {
    var _me$scrollManager2, _me$scrollManager2$st;

    const me = this,
          context = me.context;
    (_me$scrollManager2 = me.scrollManager) === null || _me$scrollManager2 === void 0 ? void 0 : (_me$scrollManager2$st = _me$scrollManager2.stopMonitoring) === null || _me$scrollManager2$st === void 0 ? void 0 : _me$scrollManager2$st.call(_me$scrollManager2);

    if (context) {
      // Force a synchronous layout so that transitions from this point will work.
      context.element.getBoundingClientRect(); // Aborted drag not considered valid

      context.valid = false;

      if (context.action === 'container') {
        me.abortContainerDrag(undefined, undefined, silent);
      } else {
        me.abortTranslateDrag(undefined, undefined, silent);
      }
    }

    me.reset();
  } // Empty class implementation. If listeners *are* added, the detacher is added
  // as an instance property. So this is always callable.


  removeListeners() {} // Called when a drag operation is completed, or aborted
  // Removes DOM listeners and resets context


  reset(silent) {
    const me = this,
          context = me.context;

    if (context !== null && context !== void 0 && context.started) {
      context.outermostEl.classList.remove('b-draghelper-active');
    }

    me.removeListeners();
    /**
     * Fired after a drag operation is completed or aborted
     * @event reset
     * @private
     * @param {Core.helper.DragHelper} dragHelper
     */

    if (!silent) {
      me.trigger('reset');
    }

    me.context = me.lastMouseMoveEvent = null;
  }

  onTouchEnd(event) {
    this.onMouseUp(event);
  }
  /**
   * This is a capture listener, only added during drag, which prevents a click gesture
   * propagating from the terminating mouseup gesture
   * @param {MouseEvent} event
   * @private
   */


  onDocumentClick(event) {
    event.stopPropagation();
  }
  /**
   * Drop on mouse up (if dropped on valid target).
   * @param event
   * @private
   */


  onMouseUp(event) {
    const me = this,
          context = me.context;
    me.removeListeners();

    if (context) {
      var _me$scrollManager3;

      (_me$scrollManager3 = me.scrollManager) === null || _me$scrollManager3 === void 0 ? void 0 : _me$scrollManager3.stopMonitoring();

      if (context.action === 'container') {
        me.finishContainerDrag(event);
      } else if (context.started && context.action.startsWith('translate')) {
        me.finishTranslateDrag(event);
      }

      if (context.started) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
          element: document,
          thisObj: me,
          click: rootElementListeners.docclick,
          capture: true,
          expires: me.clickSwallowDuration,
          // In case a click did not ensue, remove the listener
          once: true
        });
      } else {
        me.reset(true);
      }
    }
  }
  /**
   * Cancel on ESC key
   * @param event
   * @private
   */


  onKeyDown(event) {
    if (event.key === 'Escape') this.abort();
  }

  onWindowBlur() {
    // If window blur occurs while we are dragging (tab is switched, another window steals focus from browser)
    // pointer might be released and current window will not know about that. Thus allowing to pointerdown again
    // when focus comes back. In this case we want to let drag helper know that next pointerdown should be ignored.
    if (this.context) {
      this.abort();
    }
  }
  /**
   * Creates the proxy element to be dragged, when using {@link #config-cloneTarget}. Clones the original element by default
   */


  createProxy(element) {
    const clone = element.cloneNode(true);
    clone.removeAttribute('id');
    return clone;
  } //endregion


}
DragHelper._$name = 'DragHelper';

/***/ }),

/***/ "./lib/Core/helper/EventHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/EventHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventHelper; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';







/**
 * @module Core/helper/EventHelper
 */

const touchProperties = ['clientX', 'clientY', 'pageX', 'pageY', 'screenX', 'screenY'],
      isOption = {
  element: 1,
  thisObj: 1,
  once: 1,
  delegate: 1,
  delay: 1,
  capture: 1,
  passive: 1,
  throttled: 1,
  autoDetach: 1,
  expires: 1
},
      ctrlKeyProp = {
  get: () => true
},
      normalizedKeyNames = {
  Spacebar: 'Space',
  Del: 'Delete',
  Esc: 'Escape',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown'
},
      ignoreModifierKeys = {
  Meta: 1,
  Control: 1,
  Alt: 1
},
      // Allow an unsteady finger to jiggle by this much
longpressMoveThreshold = 5;

function getAccessorFromPrototype(target, property) {
  let descriptor, accessor;

  while ((target = Object.getPrototypeOf(target)) && !accessor) {
    descriptor = Object.getOwnPropertyDescriptor(target, property);
    accessor = descriptor && descriptor.get;
  }

  return accessor;
}
/**
 * Utility methods for dealing with Events, normalizing Touch/Pointer/Mouse events.
 */


class EventHelper {
  static normalizeEvent(event) {
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyPropertiesIf(event, event.changedTouches[0] || event.touches[0], touchProperties);
  }
  /**
   * Returns the `[x, y]` coordinates of the event in the viewport coordinate system.
   * @param {Event} event The event
   * @return {Number[]} The coordinate.
   */


  static getXY(event) {
    if (event.touches) {
      event = event.touches[0];
    }

    return [event.clientX, event.clientY];
  }
  /**
   * Returns the pixel distance between two mouse/touch/pointer events.
   * @param {Event} event1 The first event.
   * @param {Event} event2 The second event.
   * @return {Number} The distance in pixels between the two events.
   */


  static getDistanceBetween(event1, event2) {
    const xy1 = EH.getXY(event1),
          xy2 = EH.getXY(event2); // No point in moving this to Point. We are dealing only with number values here.

    return Math.sqrt(Math.pow(xy1[0] - xy2[0], 2) + Math.pow(xy1[1] - xy2[1], 2));
  }
  /**
   * Returns a {@link Core.helper.util.Point} which encapsulates the `pageX/Y` position of the event.
   * May be used in {@link Core.helper.util.Rectangle} events.
   * @param {Event} event A browser mouse/touch/pointer event.
   * @return {Core.helper.util.Point} The page point.
   */


  static getPagePoint(event) {
    return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].Point(event.pageX, event.pageY);
  }
  /**
   * Returns a {@link Core.helper.util.Point} which encapsulates the `clientX/Y` position of the event.
   * May be used in {@link Core.helper.util.Rectangle} events.
   * @param {Event} event A browser mouse/touch/pointer event.
   * @return {Core.helper.util.Point} The page point.
   */


  static getClientPoint(event) {
    return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].Point(event.clientX, event.clientY);
  }
  /**
   * Add a listener or listeners to an element
   * @param {HTMLElement} element The element to add a listener/listeners to.
   * @param {String|Object} eventName Either a string, being the name of the event to listen for,
   * or an options object containing event names and options as keys. See the options parameter
   * for details, or the {@link #function-on-static} method for details.
   * @param {Function} [handler] If the second parameter is a string event name, this is the handler function.
   * @param {Object} [options] If the second parameter is a string event name, this is the options.
   * @param {HTMLElement} options.element The element to add the listener to.
   * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
   * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
   * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
   * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
   * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires:
   * @param {Number|Object} [options.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [options.expires.delay] How long to wait for the event for.
   * @param {String|Function} [options.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @returns {Function} A detacher function which removes all the listeners when called.
   */


  static addListener(element, eventName, handler, options) {
    if (element.nodeType) {
      // All separate params, element, eventName and handler
      if (typeof eventName === 'string') {
        options = Object.assign({
          element,
          [eventName]: handler
        }, options);
      } // element, options
      else {
        options = Object.assign({
          element
        }, eventName);
      }
    } // Just an options object passed
    else {
      options = element;
    }

    return EH.on(options);
  }
  /**
   * Adds a listener or listeners to an element.
   * all property names other than the options listed below are taken to be event names,
   * and the values as handler specs.
   *
   * A handler spec is usually a function reference or the name of a function in the `thisObj`
   * option.
   *
   * But a handler spec may also be an options object containing a `handler` property which is
   * the function or function name, and local options, including `element` and `thisObj`
   * which override the top level options.
   *
   *  Usage example
   *
   * ```javascript
   * construct(config) {
   *     super.construct(config);
   *
   *     // Add auto detaching event handlers to this Widget's reference elements
   *     EventHelper.on({
   *         element : this.iconElement,
   *         click   : '_handleIconClick',
   *         thisObj : this,
   *         contextmenu : {
   *             element : document,
   *             handler : '_handleDocumentContextMenu'
   *         }
   *     });
   * }
   *```
   *
   * The `click` handler on the `iconElement` calls `this._handleIconClick`.
   *
   * The `contextmenu` handler is added to the `document` element, but the `thisObj`
   * is defaulted in from the top `options` and calls `this._handleDocumentContextMenu`.
   *
   * Note that on touch devices, `dblclick` and `contextmenu` events are synthesized.
   * Synthesized events contain a `browserEvent` property containing the final triggering
   * event of the gesture. For example a synthesized `dblclick` event would contain a
   * `browserEvent` property which is the last `touchend` event. A synthetic `contextmenu`
   * event will contain a `browserEvent` property which the longstanding `touchstart` event.
   *
   * @param {Object} options The full listener specification.
   * @param {HTMLElement} options.element The element to add the listener to.
   * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
   * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
   * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
   * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
   * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires.
   * @param {Number} [options.throttled] For rapidly repeating events (Such as `wheel` or `scroll` or `mousemove`)
   * this is the number of milliseconds to delay subsequent handler calls after first invocation which happens immediately.
   * @param {Number|Object} [options.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [options.expires.delay] How long to wait for the event for.
   * @param {String|Function} [options.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @returns {Function} A detacher function which removes all the listeners when called.
   */


  static on(options) {
    const element = options.element,
          thisObj = options.thisObj,
          handlerDetails = [];

    for (const eventName in options) {
      // Only treat it as an event name if it's not a supported option
      if (!isOption[eventName]) {
        let handlerSpec = options[eventName];

        if (typeof handlerSpec !== 'object') {
          handlerSpec = {
            handler: handlerSpec
          };
        }

        const targetElement = handlerSpec.element || element; // If we need to convert taphold to an emulated contextmenu, add a wrapping function
        // in addition to the contextmenu listener. Platforms may support mouse *and* touch.

        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchDevice && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isAndroid) {
          if (eventName === 'contextmenu') {
            handlerDetails.push(EH.addElementListener(targetElement, 'touchstart', {
              handler: EH.createContextMenuWrapper(handlerSpec.handler, handlerSpec.thisObj || thisObj)
            }, options));
          }
        } // Keep track of the real handlers added.
        // addElementLister returns [ element, eventName, addedFunction, capture ]


        handlerDetails.push(EH.addElementListener(targetElement, eventName, handlerSpec, options));
      }
    }

    const detacher = () => {
      for (let handlerSpec, i = 0; i < handlerDetails.length; i++) {
        handlerSpec = handlerDetails[i];
        EH.removeEventListener(handlerSpec[0], handlerSpec[1], handlerSpec[2]);
      }

      handlerDetails.length = 0;
    }; // { autoDetach : true, thisObj : scheduler } means remove all listeners when the scheduler dies.


    if (thisObj && options.autoDetach !== false) {
      thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createInterceptor(thisObj.doDestroy, detacher, thisObj);
    }

    return detacher;
  }
  /**
   * Used internally to add a single event handler to an element.
   * @param {HTMLElement} element The element to add the handler to.
   * @param {String} eventName The name of the event to add a handler for.
   * @param {Function|String|Object} handlerSpec Either a function to call, or
   * the name of a function to call in the `thisObj`, or an object containing
   * the handler local options.
   * @param {Function|String} [handlerSpec.handler] Either a function to call, or
   * the name of a function to call in the `thisObj`.
   * @param {HTMLElement} [handlerSpec.element] Optionally a local element for the listener.
   * @param {Object} [handlerSpec.thisObj] A local `this` specification for the handler.
   * @param {Object} defaults The `options` parameter from the {@link #function-addListener-static} call.
   * @private
   */


  static addElementListener(element, eventName, handlerSpec, defaults) {
    const handler = EH.createHandler(element, eventName, handlerSpec, defaults),
          handlerHasPassive = ('passive' in handlerSpec),
          expires = handlerSpec.expires || defaults.expires;
    let options = handlerSpec.capture || defaults.capture; // If we are passed the passive option and the browser supports it, then convert
    // The capture option into the object options form.

    if ((handlerHasPassive || 'passive' in defaults) && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPassive) {
      options = {
        capture: !!options,
        passive: handlerHasPassive ? handlerSpec.passive : defaults.passive
      };
    }

    element.addEventListener(eventName, handler, options);

    if (expires) {
      // Extract expires : { delay : 100, alt : 'onExpireFn' }
      const thisObj = handlerSpec.thisObj || defaults.thisObj,
            delayable = thisObj !== null && thisObj !== void 0 && thisObj.isDelayable ? thisObj : window,
            {
        alt
      } = expires,
            delay = alt ? expires.delay : expires,
            {
        spec
      } = handler; // expires is not applied with other options in createHandler(), store it here

      spec.expires = expires;
      spec.timerId = delayable[typeof delay === 'number' ? 'setTimeout' : 'requestAnimationFrame'](() => {
        spec.timerId = null;
        EH.removeEventListener(element, eventName, handler); // If we make it here and the handler has not been called, invoke the alt handler

        if (alt && !handler.called) {
          (typeof alt === 'string' ? thisObj[alt] : alt).call(thisObj);
        }
      }, delay, `listener-timer-${performance.now()}`);
    }

    return [element, eventName, handler, options];
  }

  static fixEvent(event) {
    var _event$target, _event$target2, _event$target3, _event$relatedTarget;

    const {
      type
    } = event; // Normalize key names

    if (type.startsWith('key')) {
      const normalizedKeyName = normalizedKeyNames[event.key];

      if (normalizedKeyName) {
        Object.defineProperty(event, 'key', {
          get: () => normalizedKeyName
        });
      } // Polyfill the code property for SPACE because it is not set for synthetic events.


      if (event.key === ' ' && !event.code) {
        Object.defineProperty(event, 'code', {
          get: () => 'Space'
        });
      }
    } // Sync OSX's meta key with the ctrl key. This will only happen on Mac platform.
    // It's read-only, so define a local property to return true for ctrlKey.


    if (event.metaKey && !event.ctrlKey) {
      Object.defineProperty(event, 'ctrlKey', ctrlKeyProp);
    } // When we listen to event on document and get event which bubbled from shadow dom, reading its target would
    // return shadow root element. We need actual element which started the event


    if ((_event$target = event.target) !== null && _event$target !== void 0 && _event$target.shadowRoot && event.composedPath && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11 && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEdge) {
      const targetElement = event.composedPath()[0],
            originalTarget = event.target; // Can there be an event which actually originated from custom element, not its shadow dom?

      if (event.target !== targetElement) {
        Object.defineProperty(event, 'target', {
          get: () => targetElement,
          configurable: true
        }); // Save original target just in case

        Object.defineProperty(event, 'originalTarget', {
          get: () => originalTarget,
          configurable: true
        });
      }
    } // Chrome 78 has a bug where moving out of the left edge of an element can report a mousemove
    // with that element as the target, but offsetX as -1 and moving out the right edge can report
    // that the element is the target but an offset of the offsetWidth. Patch the event until they fix it.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1010528
    // Tested in EventHelper.js


    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isChrome && event.target && 'offsetX' in event) {
      // Wrap reading `offsetX/Y` until this property is actually accessed in the code to avoid forced reflow.
      // To avoid getting infinite loop, property descriptor is looked up in the prototype chain. Should be
      // better than forcing DOM reflow on every single event.
      if (!Object.getOwnPropertyDescriptor(event, 'offsetX')) {
        Object.defineProperty(event, 'offsetX', {
          get: () => {
            const accessor = getAccessorFromPrototype(event, 'offsetX'),
                  offsetX = accessor.call(event),
                  {
              target
            } = event,
                  {
              offsetWidth
            } = target,
                  x = Math.min(Math.max(offsetX, 0), offsetWidth - 1);

            if (offsetX < 0 || offsetX >= offsetWidth) {
              return x;
            }

            return offsetX;
          }
        });
      }

      if (!Object.getOwnPropertyDescriptor(event, 'offsetY')) {
        Object.defineProperty(event, 'offsetY', {
          get: () => {
            const accessor = getAccessorFromPrototype(event, 'offsetY'),
                  offsetY = accessor.call(event),
                  {
              target
            } = event,
                  {
              offsetHeight
            } = target,
                  y = Math.min(Math.max(offsetY, 0), offsetHeight - 1);

            if (offsetY < 0 || offsetY >= offsetHeight) {
              return y;
            }

            return offsetY;
          }
        });
      }
    } // Firefox has a bug where it can report that the target is the #document when mouse is over a pseudo element


    if (((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.nodeType) === Element.DOCUMENT_NODE && 'clientX' in event) {
      const targetElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].elementFromPoint(event.clientX, event.clientY);
      Object.defineProperty(event, 'target', {
        get: () => targetElement
      });
    } // Firefox has a bug where it can report a textNode as an event target/relatedTarget.
    // We standardize this to report the parentElement.


    if (((_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.nodeType) === Element.TEXT_NODE) {
      const targetElement = event.target.parentElement;
      Object.defineProperty(event, 'target', {
        get: () => targetElement
      });
    }

    if (((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.nodeType) === Element.TEXT_NODE) {
      const relatedTargetElement = event.target.parentElement;
      Object.defineProperty(event, 'relatedTarget', {
        get: () => relatedTargetElement
      });
    } // If it's a touch event, move the positional details
    // of touches[0] up to the event.


    if (type.startsWith('touch') && event.touches.length) {
      this.normalizeEvent(event);
    }

    return event;
  }

  static createHandler(element, eventName, handlerSpec, defaults) {
    const delay = handlerSpec.delay || defaults.delay,
          throttled = handlerSpec.throttled || defaults.throttled,
          block = handlerSpec.block || defaults.block,
          once = handlerSpec.once || defaults.once,
          thisObj = handlerSpec.thisObj || defaults.thisObj,
          capture = handlerSpec.capture || defaults.capture,
          delegate = handlerSpec.delegate || defaults.delegate,
          wrappedFn = handlerSpec.handler; //Capture initial conditions in case of destruction of thisObj.
    // Destruction completely wipes the object.
    // Innermost level of wrapping which calls the user's handler.
    // Normalize the event cross-browser, and attempt to normalize touch events.

    let handler = (event, ...args) => {
      // Flag for the expiry timer
      handler.called = true; // When playing a demo using DemoBot, only handle synthetic events

      if (EH.playingDemo && event.isTrusted) {
        return;
      } // If the thisObj is already destroyed, we cannot call the function.
      // If in dev mode, warn the developer with a JS error.


      if (thisObj && thisObj.isDestroyed) {
        // eslint-disable-next-line
        return;
      } // Fix up events to handle various browser inconsistencies


      event = EH.fixEvent(event); // delegate: '.b-field-trigger' only fires when click is in a matching el.
      // currentTarget becomes the delegate.

      if (delegate) {
        var _event$target$closest;

        // Maintainer: In Edge event.target can be an empty object for transitionend events
        const delegatedTarget = ((_event$target$closest = event.target.closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call) && event.target.closest(delegate);

        if (!delegatedTarget) {
          return;
        } // Allow this to be redefined as it bubbles through listeners up the parentNode axis
        // which might have their own delegate settings.


        Object.defineProperty(event, 'currentTarget', {
          get: () => delegatedTarget,
          configurable: true
        });
      }

      (typeof wrappedFn === 'string' ? thisObj[wrappedFn] : wrappedFn).call(thisObj, event, ...args);
    }; // Allow events to be blocked for a certain time


    if (block) {
      const wrappedFn = handler;
      let lastCallTime, lastTarget;

      handler = (e, ...args) => {
        const now = performance.now();

        if (!lastCallTime || e.target !== lastTarget || now - lastCallTime > block) {
          lastTarget = e.target;
          lastCallTime = now;
          wrappedFn(e, ...args);
        }
      };
    } // Go through options, each creates a new handler by wrapping the previous handler to implement the options.
    // Right now, we have delay. Note that it may be zero, so test != null


    if (delay != null) {
      const wrappedFn = handler,
            delayable = thisObj && thisObj.setTimeout ? thisObj : window;

      handler = (...args) => {
        delayable.setTimeout(() => {
          wrappedFn(...args);
        }, delay);
      };
    } // If they specified the throttled option, wrap the handler in a createdThrottled
    // version. Allow the called to specify an alt function to call when the event
    // fires before the buffer time has expired.


    if (throttled != null) {
      let alt,
          buffer = throttled;

      if (throttled.buffer) {
        alt = e => throttled.alt.call(EH, EH.fixEvent(e));

        buffer = throttled.buffer;
      }

      if (thisObj && thisObj.isDelayable) {
        handler = thisObj.throttle(handler, {
          delay: buffer,
          throttled: alt
        });
      } else {
        handler = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createThrottled(handler, buffer, thisObj, null, alt);
      }
    } // This must always be the last option processed so that it is the outermost handler
    // which is the one added to the element and is called immediately so that the
    // handler is removed immediately.
    // TODO: Use the native once option when all browsers support it. Only IE11 doesn't.


    if (once) {
      const wrappedFn = handler;

      handler = (...args) => {
        //element.removeEventListener(eventName, handler, capture);
        EH.removeEventListener(element, eventName, handler);
        wrappedFn(...args);
      };
    } // Only autoDetach here if there's a local thisObj is in the handlerSpec for this one listener.
    // If it's in the defaults, then the "on" method will handle it.


    if (handlerSpec.thisObj && handlerSpec.autoDetach !== false) {
      thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createInterceptor(thisObj.doDestroy, () => EH.removeEventListener(element, eventName, handler), thisObj);
    }

    handler.spec = {
      delay,
      throttled,
      block,
      once,
      thisObj,
      capture,
      delegate
    };
    return handler;
  }

  static removeEventListener(element, eventName, handler) {
    const {
      expires,
      timerId,
      thisObj,
      capture
    } = handler.spec; // Cancel outstanding expires.alt() call when removing the listener

    if (expires !== null && expires !== void 0 && expires.alt && timerId) {
      const delayable = thisObj !== null && thisObj !== void 0 && thisObj.isDelayable ? thisObj : window;
      delayable[typeof expires.delay === 'number' ? 'clearTimeout' : 'cancelAnimationFrame'](timerId);
    }

    element.removeEventListener(eventName, handler, capture);
  }

  static onTransitionEnd({
    element,
    property,
    handler,
    mode = 'transition',
    duration = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][`get${mode === 'transition' ? 'Property' : ''}${_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].capitalize(mode)}Duration`](element, property),
    thisObj = window,
    args = []
  }) {
    let timerId;

    const callbackArgs = [element, property, ...args],
          timerSource = thisObj.isDelayable ? thisObj : window,
          doCallback = () => {
      detacher();

      if (!thisObj.isDestroyed) {
        if (thisObj.callback) {
          thisObj.callback(handler, thisObj, callbackArgs);
        } else {
          handler.apply(thisObj, callbackArgs);
        }
      }
    },
          detacher = EH.on({
      element,

      [`${mode}end`]({
        propertyName,
        target
      }) {
        if (propertyName === property && target === element) {
          if (timerId) {
            timerSource.clearTimeout(timerId);
            timerId = null;
          }

          doCallback();
        }
      }

    }); // If the transition has not signalled its end within duration + 50 milliseconds
    // then give up on it. Remove the listener and call the handler.


    if (duration != null) {
      timerId = timerSource.setTimeout(doCallback, duration + 50);
    }

    return detacher;
  }

  static async waitForTransitionEnd(config) {
    return new Promise(resolve => {
      config.handler = resolve;
      EventHelper.onTransitionEnd(config);
    });
  }
  /**
   * Private function to wrap the passed function. The returned wrapper function to be used as
   * a `touchstart` handler which will call the passed function passing a fabricated `contextmenu`
   * event if there's no `touchend` or `touchmove` after a default of 400ms.
   * @param {String|Function} handler The handler to call.
   * @param {Object} thisObj The owner of the function.
   * @private
   */


  static createContextMenuWrapper(handler, me) {
    return event => {
      // Only attempt conversion to contextmenu if it's a single touch start.
      if (event.touches.length === 1) {
        const tapholdStartTouch = event.touches[0],
              // Dispatch a synthetic "contextmenu" event from the touchpoint in <longPressTime> milliseconds.
        tapholdTimer = setTimeout(() => {
          // Remove the gesture cancelling listeners
          touchMoveRemover();
          const contextmenuEvent = new MouseEvent('contextmenu', tapholdStartTouch);
          Object.defineProperty(contextmenuEvent, 'target', {
            get() {
              return tapholdStartTouch.target;
            }

          });

          if (typeof handler === 'string') {
            handler = me[handler];
          }

          contextmenuEvent.browserEvent = event; // Call the wrapped handler passing the fabricated contextmenu event

          handler.call(me, contextmenuEvent);
          EH.contextMenuTouchId = tapholdStartTouch.identifier;
        }, EH.longPressTime),
              // This is what gets called if the user moves their touchpoint,
        // or releases the touch before <longPressTime>ms is up
        onMoveOrPointerUp = ({
          clientX,
          clientY,
          type
        }) => {
          let cancel = type === 'touchend' || type === 'pointerup'; // for move events, check if we only moved a little

          if (!cancel) {
            const deltaX = Math.abs(clientX - tapholdStartTouch.clientX),
                  deltaY = Math.abs(clientY - tapholdStartTouch.clientY);
            cancel = deltaX >= longpressMoveThreshold || deltaY >= longpressMoveThreshold;
          }

          if (cancel) {
            EH.contextMenuTouchId = null;
            touchMoveRemover();
            clearTimeout(tapholdTimer);
          }
        },
              // Touchmove or touchend before that timer fires cancels the timer and removes these listeners.
        touchMoveRemover = EH.on({
          element: document,
          touchmove: onMoveOrPointerUp,
          touchend: onMoveOrPointerUp,
          pointermove: onMoveOrPointerUp,
          pointerup: onMoveOrPointerUp,
          capture: true
        });
      }
    };
  }
  /**
   * Private function to wrap the passed function. The returned wrapper function to be used as
   * a `touchend` handler which will call the passed function passing a fabricated `dblclick`
   * event if there is a `click` within 300ms.
   * @param {String|Function} handler The handler to call.
   * @param {Object} thisObj The owner of the function.
   * @private
   */


  static createDblClickWrapper(element, handler, me) {
    let startId, secondListenerDetacher, tapholdTimer;
    return () => {
      if (!secondListenerDetacher) {
        secondListenerDetacher = EH.on({
          element,
          // We only get here if a touchstart arrives within 300ms of a click
          touchstart: secondStart => {
            startId = secondStart.changedTouches[0].identifier; // Prevent zoom

            secondStart.preventDefault();
          },
          touchend: secondClick => {
            if (secondClick.changedTouches[0].identifier === startId) {
              secondClick.preventDefault();
              clearTimeout(tapholdTimer);
              startId = secondListenerDetacher = null;
              const targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(secondClick.changedTouches[0].target, null, true),
                    offsetX = secondClick.changedTouches[0].pageX - targetRect.x,
                    offsetY = secondClick.changedTouches[0].pageY - targetRect.y,
                    dblclickEventConfig = Object.assign({
                browserEvent: secondClick
              }, secondClick),
                    dblclickEvent = new MouseEvent('dblclick', dblclickEventConfig);
              Object.defineProperty(dblclickEvent, 'target', {
                get() {
                  return secondClick.target;
                }

              });
              Object.defineProperty(dblclickEvent, 'offsetX', {
                get() {
                  return offsetX;
                }

              });
              Object.defineProperty(dblclickEvent, 'offsetY', {
                get() {
                  return offsetY;
                }

              });

              if (typeof handler === 'string') {
                handler = me[handler];
              } // Call the wrapped handler passing the fabricated dblclick event


              handler.call(me, dblclickEvent);
            }
          },
          once: true
        }); // Cancel the second listener is there's no second click within <dblClickTime> milliseconds.

        tapholdTimer = setTimeout(() => {
          secondListenerDetacher();
          startId = secondListenerDetacher = null;
        }, EH.dblClickTime);
      }
    };
  }

}
const EH = EventHelper;
/**
 * The time in milliseconds for a `taphold` gesture to trigger a `contextmenu` event.
 * @member {Number} [longPressTime=500]
 * @readonly
 * @static
 */

EH.longPressTime = 500;
/**
 * The time in milliseconds within which a second touch tap event triggers a `dblclick` event.
 * @member {Number} [dblClickTime=300]
 * @readonly
 * @static
 */

EH.dblClickTime = 300; // Flag body if last user action used keyboard, used for focus styling etc.

EH.on({
  element: document,

  mousedown({
    target
  }) {
    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTouchEvent) {
      var _rootEl$classList;

      const rootEl = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target);
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = false;
      (_rootEl$classList = rootEl.classList) === null || _rootEl$classList === void 0 ? void 0 : _rootEl$classList.remove('b-using-keyboard');
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].removeClsGlobally(rootEl, 'b-using-keyboard');
    }
  },

  touchmove({
    changedTouches
  }) {
    var _rootEl$classList2;

    const target = changedTouches[0].target,
          rootEl = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target);
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = false;
    (_rootEl$classList2 = rootEl.classList) === null || _rootEl$classList2 === void 0 ? void 0 : _rootEl$classList2.remove('b-using-keyboard');
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].removeClsGlobally(rootEl, 'b-using-keyboard');
  },

  keydown({
    target,
    key
  }) {
    if (!ignoreModifierKeys[key]) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = true;
      const rootElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target); // if shadow root, add to outer children (shadow root itself lacks a classList :( )

      if (rootElement.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        Array.from(rootElement.children).forEach(node => {
          if (node.matches('.b-outer')) {
            node.classList.add('b-using-keyboard');
          }
        });
      } else {
        // document.body
        rootElement.classList.add('b-using-keyboard');
      }
    }
  }

}); // When dragging on a touch device, we need to prevent scrolling from happening.
// Dragging only starts on a touchmove event, by which time it's too late to preventDefault
// on the touchstart event which started it.
// To do this we need a capturing, non-passive touchmove listener at the document level so we can preventDefault.
// This is in lieu of a functioning touch-action style on iOS Safari. When that's fixed, this will not be needed.

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchDevice) {
  EH.on({
    element: document,
    touchmove: event => {
      // If we're touching a b-dragging event, then stop any panning by preventing default.
      if (event.target.closest('.b-dragging')) {
        event.preventDefault();
      }
    },
    passive: false,
    capture: true
  });
}

EventHelper._$name = 'EventHelper';

/***/ }),

/***/ "./lib/Core/helper/FunctionHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/FunctionHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FunctionHelper; });
var productName = 'gantt';
/**
* @module Core/helper/FunctionHelper
*/

const {
  hasOwnProperty
} = Object.prototype;
/**
 * Provides functionality for working with functions
 * @internal
 */

class FunctionHelper {
  /**
   * Inserts a function after the specified `method` is called on an `object`. To remove this hook, invoke the
   * function returned by this method.
   * ```
   *  class A {
   *      method() {
   *          console.log('method');
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.after(instance, 'method', () => { console.log('after') });
   *
   *  instance.method();
   *  > method
   *  > after
   *
   *  detach();
   *  instance.method();
   *  > method
   * ```
   * The value returned by the original method is passed as the first argument to `fn` followed by all the arguments
   * passed by the caller.
   *
   * If `fn` returns a value (not `undefined`), that value is returned from the method call instead of the value
   * returned by the original method.
   * ```
   *  class A {
   *      method(x) {
   *          console.log('method', x);
   *          return x * 2
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.after(instance, 'method', (ret, x) => {
   *      console.log('after', ret, x);
   *      return x / 2;
   *  });
   *
   *  console.log(instance.method(50));
   *  > method 50
   *  > after 100 50
   *  > 25
   *
   *  detach();
   *  console.log(instance.method(50));
   *  > method 50
   *  > 100
   * ```
   *
   * @param {Object} object The object to hook.
   * @param {String} method The name of the method on `object` to hook.
   * @param {Function|String} fn The function or method name (on `thisObj`) to call after `method`.
   * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
   * @param {Object} [options] Additional options
   * @param {Boolean} [options.return=true] Specify `false` to not include the return value of the hooked method as
   * the first argument to `fn`.
   * @returns {Function} The function to call to remove the hook.
   */
  static after(object, method, fn, thisObj, options) {
    const named = typeof fn === 'string',
          withReturn = (options === null || options === void 0 ? void 0 : options.return) !== false,
          hook = (...args) => {
      const // if object.destroy() occurs, our hook will be removed, so this fn won't be called in that case
      origResult = hook.$nextHook.call(object, ...args),
            hookResult = thisObj !== null && thisObj !== void 0 && thisObj.isDestroyed ? undefined : withReturn ? named ? thisObj[fn](origResult, ...args) : fn.call(thisObj, origResult, ...args) : named ? thisObj[fn](...args) : fn.call(thisObj, ...args);
      return hookResult === undefined ? origResult : hookResult;
    };

    return FunctionHelper.hookMethod(object, method, hook);
  }
  /**
   * Inserts a function before the specified `method` is called on an `object`. To remove this hook, invoke the
   * function returned by this method.
   * ```
   *  class A {
   *      method() {
   *          console.log('method');
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.before(instance, 'method', () => { console.log('before') });
   *
   *  instance.method();
   *  > before
   *  > method
   *
   *  detach();
   *  instance.method();
   *  > method
   * ```
   * If `fn` returns `false`, the original method is not invoked and `false` is returned to the caller.
   * ```
   *  class A {
   *      method(x) {
   *          console.log('method', x);
   *          return x * 2;
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.before(instance, 'method', x => {
   *      console.log('before', x);
   *      return false;
   *  });
   *
   *  console.log(instance.method(50));
   *  > before 50
   *  > false
   *
   *  detach();
   *  console.log(instance.method(50));
   *  > method 50
   *  > 100
   * ```
   *
   * @param {Object} object The object to hook.
   * @param {String} method The name of the method on `object` to hook.
   * @param {Function|String} fn The function or method name (on `thisObj`) to call before `method`.
   * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
   * @returns {Function} The function to call to remove the hook.
   */


  static before(object, method, fn, thisObj) {
    const named = typeof fn === 'string',
          hook = (...args) => {
      const ret = thisObj !== null && thisObj !== void 0 && thisObj.isDestroyed ? 0 : named ? thisObj[fn](...args) : fn.call(thisObj, ...args);
      return ret === false ? ret : hook.$nextHook.call(object, ...args);
    };

    return FunctionHelper.hookMethod(object, method, hook);
  }

  static curry(func) {
    return function curried(...args) {
      if (args.length >= func.length) {
        return func.apply(this, args);
      } else {
        return function (...args2) {
          return curried.apply(this, args.concat(args2));
        };
      }
    };
  }

  static bindAll(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'function') {
        obj[key] = obj[key].bind(obj);
      }
    }
  }
  /**
   * Returns a function which calls the passed `interceptor` function first, and the passed `original` after
   * as long as the `interceptor` does not return `false`.
   * @param {Function} original The function to call second.
   * @param {Function} interceptor The function to call first.
   * @param {Object} [thisObj] The `this` reference when the functions are called.
   * @returns The return value from the `original` function **if it was called**, else `false`.
   */


  static createInterceptor(original, interceptor, thisObj) {
    return (...args) => {
      if (interceptor.call(thisObj, ...args) !== false) {
        return original.call(thisObj, ...args);
      }

      return false;
    };
  }
  /**
   * Returns a function which calls the passed `sequence` function after calling
   * the passed `original`.
   * @param {Function} original The function to call first.
   * @param {Function} sequence The function to call second.
   * @param {Object} [thisObj] The `this` reference when the functions are called.
   * @returns The value returned from the sequence if it returned a value, else the return
   * value from the original function.
   */


  static createSequence(original, sequence, thisObj) {
    return (...args) => {
      const origResult = original.call(thisObj, ...args),
            sequenceResult = sequence.call(thisObj, ...args);
      return sequenceResult === undefined ? origResult : sequenceResult;
    };
  }
  /**
   * Create a "debounced" function which will call on the "leading edge" of a timer period.
   * When first invoked will call immediately, but invocations after that inside its buffer
   * period will be rejected, and *one* invocation will be made after the buffer period has expired.
   *
   * This is useful for responding immediately to a first mousemove, but from then on, only
   * calling the action function on a regular timer while the mouse continues to move.
   *
   * @param {Function} fn The function to call.
   * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Array} [extraArgs] The argument list to append to those passed to the function.
   * @param {Function} [alt] A function to call when the invocation is rejected due to buffer time not having expired.
   */


  static createThrottled(fn, buffer, thisObj, extraArgs, alt) {
    let lastCallTime = -Number.MAX_VALUE,
        callArgs,
        timerId;

    const invoke = () => {
      timerId = 0;
      lastCallTime = performance.now();
      callArgs.push.apply(callArgs, extraArgs);
      fn.apply(thisObj, callArgs);
    },
          result = function (...args) {
      const elapsed = performance.now() - lastCallTime;
      callArgs = args; // If it's been more then the buffer period since we invoked, we can call it now

      if (elapsed >= buffer) {
        clearTimeout(timerId);
        invoke();
      } // Otherwise, kick off a timer for the requested period.
      else {
        if (!timerId) {
          timerId = setTimeout(invoke, buffer - elapsed);
        }

        if (alt) {
          callArgs.push.apply(callArgs, extraArgs);
          alt.apply(thisObj, callArgs);
        }
      }
    };

    result.cancel = () => clearTimeout(timerId);

    return result;
  }
  /**
   * Create a "debounced" function which will call on the "trailing edge" of a timer period.
   * When first invoked will wait until the buffer period has expired to call the function, and
   * more calls within that time will restart the timer.
   *
   * This is useful for responding to keystrokes, but deferring action until the user pauses typing.
   *
   * @param {Function} fn The function to call.
   * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Array} [args] The argument list to append to those passed to the function.
   */


  static createBuffered(fn, buffer, thisObj, args) {
    let callArgs, timerId;

    const invoke = () => {
      timerId = 0;
      result.isPending = false;
      callArgs.push.apply(callArgs, args);
      fn.apply(thisObj, callArgs);
    },
          result = function (...args) {
      callArgs = args; // Cancel any impending invocation. It's pushed out for <buffer> ms from each call

      if (timerId) {
        clearTimeout(timerId);
      }

      result.isPending = true;
      timerId = setTimeout(invoke, buffer);
    };

    result.cancel = () => {
      result.isPending = false;
      clearTimeout(timerId);
    };

    return result;
  }

  static hookMethod(object, method, hook) {
    hook.$nextHook = object[method];
    object[method] = hook;
    return () => {
      // Object will have no hooks on the instance if it is destroyed (perhaps other reasons too)
      if (hasOwnProperty.call(object, method)) {
        let f = object[method],
            next;

        if (f === hook) {
          var _Object$getPrototypeO;

          // When this is the outermost hook, we may be the last hook. If $nextHook is found on the object's
          // prototype, simply delete the slot to expose it. Otherwise, there's another hook, so make it the
          // outermost.
          if (((_Object$getPrototypeO = Object.getPrototypeOf(object)) === null || _Object$getPrototypeO === void 0 ? void 0 : _Object$getPrototypeO[method]) === hook.$nextHook) {
            delete object[method];
          } else {
            object[method] = hook.$nextHook;
          }
        } else {
          // Not being the outermost hook means we have outer hooks that should chain to the one we want to
          // remove. Be cautious because the object could be destroyed.
          for (; next = (_f = f) === null || _f === void 0 ? void 0 : _f.$nextHook; f = next) {
            var _f;

            if (next === hook) {
              f.$nextHook = hook.$nextHook;
              break;
            }
          }
        }
      }
    };
  }
  /**
   * Protects the specified `method` on a given `object` such that calling it will not throw exceptions.
   * @param {Object} object The object whose method is to be protected.
   * @param {String} method The name of the method to protect.
   * @param {Function} [handler] An optional function to call for any thrown exceptions.
   * @internal
   */


  static noThrow(object, method, handler) {
    const fn = object[method];

    object[method] = (...args) => {
      try {
        return fn.apply(object, args);
      } catch (e) {
        return handler === null || handler === void 0 ? void 0 : handler(e);
      }
    };
  }

  static returnTrue() {
    return true;
  }

  static animate(duration, fn, thisObj, easing = 'linear') {
    let cancel = false;
    const result = new Promise(resolve => {
      const start = performance.now(),
            iterate = () => {
        const progress = Math.min((performance.now() - start) / duration, 1),
              delayable = thisObj && thisObj.setTimeout ? thisObj : window;

        if (!cancel) {
          if (fn.call(thisObj, this.easingFunctions[easing](progress)) === false) {
            resolve();
          }
        }

        if (cancel || progress === 1) {
          // Push resolution into the next animation frame so that
          // this frame completes before the resolution handler runs.
          delayable.requestAnimationFrame(() => resolve());
        } else {
          delayable.requestAnimationFrame(iterate);
        }
      };

      iterate();
    });

    result.cancel = () => {
      cancel = true;
      return false;
    };

    return result;
  }

}
/* eslint-disable */

const half = 0.5,
      e1 = 1.70158,
      e2 = 7.5625,
      e3 = 1.525,
      e4 = 2 / 2.75,
      e5 = 2.25 / 2.75,
      e6 = 1 / 2.75,
      e7 = 1.5 / 2.75,
      e8 = 2.5 / 2.75,
      e9 = 2.625 / 2.75,
      e10 = 0.75,
      e11 = 0.9375,
      e12 = 0.984375,
      s1 = 1.70158,
      s2 = 1.70158;
FunctionHelper.easingFunctions = {
  linear: t => t,
  easeInQuad: t => Math.pow(t, 2),
  easeOutQuad: t => -(Math.pow(t - 1, 2) - 1),
  easeInOutQuad: t => (t /= half) < 1 ? half * Math.pow(t, 2) : -half * ((t -= 2) * t - 2),
  easeInCubic: t => Math.pow(t, 3),
  easeOutCubic: t => Math.pow(t - 1, 3) + 1,
  easeInOutCubic: t => (t /= half) < 1 ? half * Math.pow(t, 3) : half * (Math.pow(t - 2, 3) + 2),
  easeInQuart: t => Math.pow(t, 4),
  easeOutQuart: t => -(Math.pow(t - 1, 4) - 1),
  easeInOutQuart: t => (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2),
  easeInQuint: t => Math.pow(t, 5),
  easeOutQuint: t => Math.pow(t - 1, 5) + 1,
  easeInOutQuint: t => (t /= half) < 1 ? half * Math.pow(t, 5) : half * (Math.pow(t - 2, 5) + 2),
  easeInSine: t => -Math.cos(t * (Math.PI / 2)) + 1,
  easeOutSine: t => Math.sin(t * (Math.PI / 2)),
  easeInOutSine: t => -half * (Math.cos(Math.PI * t) - 1),
  easeInExpo: t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: t => t === 0 ? 0 : t === 1 ? 1 : (t /= half) < 1 ? half * Math.pow(2, 10 * (t - 1)) : half * (-Math.pow(2, -10 * --t) + 2),
  easeInCirc: t => -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: t => Math.sqrt(1 - Math.pow(t - 1, 2)),
  easeInOutCirc: t => (t /= half) < 1 ? -half * (Math.sqrt(1 - t * t) - 1) : half * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeOutBounce: t => t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12,
  easeInBack: t => t * t * ((e1 + 1) * t - e1),
  easeOutBack: t => (t = t - 1) * t * ((e1 + 1) * t + e1) + 1,
  easeInOutBack: t => {
    let v1 = s1;
    return (t /= half) < 1 ? half * (t * t * (((v1 *= e3) + 1) * t - v1)) : half * ((t -= 2) * t * (((v1 *= e3) + 1) * t + v1) + 2);
  },
  elastic: t => -1 * Math.pow(4, -8 * t) * Math.sin((t * 6 - 1) * (2 * Math.PI) / 2) + 1,
  swingFromTo: t => {
    let v2 = s2;
    return (t /= half) < 1 ? half * (t * t * (((v2 *= e3) + 1) * t - v2)) : half * ((t -= 2) * t * (((v2 *= e3) + 1) * t + v2) + 2);
  },
  swingFrom: t => t * t * ((e1 + 1) * t - e1),
  swingTo: t => (t -= 1) * t * ((e1 + 1) * t + e1) + 1,
  bounce: t => t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12,
  bouncePast: t => t < e6 ? e2 * t * t : t < e4 ? 2 - (e2 * (t -= e7) * t + e10) : t < e8 ? 2 - (e2 * (t -= e5) * t + e11) : 2 - (e2 * (t -= e9) * t + e12),
  easeFromTo: t => (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2),
  easeFrom: t => Math.pow(t, 4),
  easeTo: t => Math.pow(t, 0.25)
};
FunctionHelper._$name = 'FunctionHelper';

/***/ }),

/***/ "./lib/Core/helper/IdHelper.js":
/*!*************************************!*\
  !*** ./lib/Core/helper/IdHelper.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IdHelper; });
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';


/**
 * @module Core/helper/IdHelper
 */
// Id generation should be on a per page basis, not per module

const idCounts = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getPathDefault(_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global, 'bryntum.idCounts', Object.create(null));
/**
 * IdHelper provides unique ID generation.
 *
 * This class is not intended for application use, it is used internally by the Bryntum infrastructure.
 * @internal
 */

class IdHelper {
  /**
   * Generate a new id, using IdHelpers internal counter and a prefix
   * @param {String} prefix Id prefix
   * @returns {String} Generated id
   */
  static generateId(prefix = 'generatedId') {
    // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
    // id's more stable since the counter is on a per-class basis.
    return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
  }

}
IdHelper._$name = 'IdHelper';

/***/ }),

/***/ "./lib/Core/helper/ObjectHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ObjectHelper.js ***!
  \*****************************************/
/*! exports provided: typeOf, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeOf", function() { return typeOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectHelper; });
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';

 // NOTE: This import prevents this module from being imported by Base (or anything Base imports):


const {
  hasOwnProperty
} = Object.prototype;
/**
 * @module Core/helper/ObjectHelper
 */

const typeOf = value => {
  const baseType = typeof value; // If not atomic type, we handle date or null

  if (baseType === 'object') {
    if (value === null) {
      return 'null';
    }

    if (Array.isArray(value)) {
      return 'array';
    }

    if (Object.prototype.toString.call(value) === '[object Date]') {
      return 'date';
    }

    if (value.isBase) {
      return 'instance';
    }
  }

  if (baseType === 'function') {
    if (value.isBase) {
      return 'class';
    }
  }

  return baseType;
};

 // Detect if browser has bad implementation of toFixed()

const toFixedFix = 1.005.toFixed(2) === '1.01' ? null : function (number, fractionDigits) {
  const split = number.toString().split('.'),
        newNumber = +(!split[1] ? split[0] : split.join('.') + '1');
  return number.toFixed.call(newNumber, fractionDigits);
};
/**
 * Helper for Object manipulation.
 */

class ObjectHelper extends _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // These methods are inherited from Objects (an internal class) but need to be documented here for public use.
  // This is primarily because static methods, while inherited by JavaScript classes, are not displayed in derived
  // classes in the docs.

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`. Unlike `Object.assign`, this copy
   * also includes inherited properties.
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method assign
   * @static
   */

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`, only including properties that does
   * not already exist on `dest`. Unlike `Object.assign`, this copy also includes inherited properties.
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method assignIf
   * @static
   */

  /**
   * Creates a deep copy of the `value`. Simple objects ({@link #function-isObject-static}, arrays and `Date` objects
   * are cloned. The enumerable properties of simple objects and the elements of arrays are cloned recursively.
   * @param {*} value The value to clone.
   * @param {Function} [handler] An optional function to call for values of types other than simple object, array or
   * `Date`. This function should return the clone of the `value` passed to it. It is only called for truthy values
   * whose `typeof` equals `'object'`.
   * @param {*} handler.value The value to clone.
   * @returns {*} The cloned value.
   * @method clone
   * @static
   */

  /**
   * Converts a list of names (either a space separated string or an array), into an object with those properties
   * assigned truthy values. The converse of {@link #function-getTruthyKeys-static}.
   * @param {String|String[]} source The list of names to convert to object form.
   * @method createTruthyKeys
   * @static
   */

  /**
   * Gathers the names of properties which have truthy values into an array.
   *
   * This is useful when gathering CSS class names for complex element production.
   * Instead of appending to an array or string which may already contain the
   * name, and instead of contending with space separation and concatenation
   * and conditional execution, just set the properties of an object:
   *
   *     cls = {
   *         [this.selectedCls] : this.isSelected(thing),
   *         [this.dirtyCls] : this.isDirty(thing)
   *     };
   *
   * @param {Object} source Source of keys to gather into an array.
   * @returns {String[]} The keys which had a truthy value.
   * @method getTruthyKeys
   * @static
   */

  /**
   * Gathers the values of properties which are truthy into an array.
   * @param {Object} source Source of values to gather into an array.
   * @returns {String[]} The truthy values from the passed object.
   * @method getTruthyValues
   * @static
   */

  /**
   * Tests whether a passed object has any enumerable properties.
   * @param {Object} object
   * @returns {Boolean} `true` if the passed object has no enumerable properties.
   * @method isEmpty
   * @static
   */

  /**
   * Returns `true` if the `value` is a simple `Object`.
   * @param {Object} value
   * @returns {Boolean} `true` if the `value` is a simple `Object`.
   * @method isObject
   * @static
   */

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`, recursing when the properties of
   * both the source and `dest` are objects.
   * ```
   *  const o = {
   *      a : 1,
   *      b : {
   *          c : 2
   *      }
   *  };
   *  const o2 = {
   *      b : {
   *          d : 3
   *      }
   *  }
   *
   *  console.log(merge(o, o2));
   *
   *  > { a : 1, b : { c : 2, d : 3 } }
   * ```
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method merge
   * @static
   */

  /**
   * Returns the specific type of the given `value`. Unlike the `typeof` operator, this function returns the text
   * from the `Object.prototype.toString` result allowing `Date`, `Array`, `RegExp`, and others to be differentiated.
   * ```
   *  console.log(typeOf(null));
   *  > null
   *
   *  console.log(typeOf({}));
   *  > object
   *
   *  console.log(typeOf([]));
   *  > array
   *
   *  console.log(typeOf(new Date()));
   *  > date
   *
   *  console.log(typeOf(NaN));
   *  > nan
   *
   *  console.log(typeOf(/a/));
   *  > regexp
   * ```
   * @param {*} value
   * @returns {String}
   * @method typeOf
   * @static
   */

  /**
   * Returns value for a given path in the object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {*} Value associated with passed key
   * @method getPath
   * @static
   */

  /**
   * Sets value for a given path in the object
   * @param {Object} object Target object
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @param {*} value Value for a given path
   * @returns {Object} Returns passed object
   * @method setPath
   * @static
   */

  /**
   * Creates a new object where key is a property in array item (`ref` by default) or index in the array and value is array item.
   *
   * From:
   * ```
   * [
   *     {
   *          text : 'foo',
   *          ref : 'fooItem'
   *     },
   *     {
   *          text : 'bar'
   *     }
   * ]
   * ```
   *
   * To:
   * ```
   * {
   *     fooItem : {
   *         text : 'foo',
   *         ref  : 'fooItem'
   *     },
   *     1 : {
   *         text : 'bar'
   *     }
   * }
   * ```
   *
   * @param {Object[]} arrayOfItems Array to transform.
   * @param {String} [prop] Property to read the key from. `ref` by default.
   * @returns {Object} namedItems
   */
  static transformArrayToNamedObject(arrayOfItems, prop = 'ref') {
    const namedItems = {};
    arrayOfItems.forEach((item, index) => {
      const // 0 is valid value, but empty string in not valid
      key = item[prop] != null && item[prop].toString().length ? item[prop] : index;
      namedItems[key] = item;
    });
    return namedItems;
  }
  /**
   * Creates a new array from object values and saves key in a property (`ref` by default) of each item.
   *
   * From:
   * ```
   * {
   *     fooItem : {
   *         text : 'foo'
   *     },
   *     1 : {
   *         text : 'bar'
   *     },
   *     barItem : false // will be ignored
   * }
   * ```
   *
   * To:
   * ```
   * [
   *     {
   *          text : 'foo',
   *          ref : 'fooItem'
   *     },
   *     {
   *          text : 'bar',
   *          ref : 1
   *     }
   * ]
   * ```
   *
   * @param {Object} namedItems Object to transform.
   * @param {String} [prop] Property to save the key to. `ref` by default.
   * @returns {Object[]} arrayOfItems
   */


  static transformNamedObjectToArray(namedItems, prop = 'ref') {
    return Object.keys(namedItems).filter(key => namedItems[key]).map(key => {
      const item = namedItems[key];
      item[prop] = key;
      return item;
    });
  }
  /**
   * Checks if two values are equal. Basically === but special handling of dates.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {*} true if values are equal, otherwise false
   */


  static isEqual(a, b, useIsDeeply = false) {
    // Eliminate null vs undefined mismatch
    if (a === null && b !== null || a === undefined && b !== undefined || b === null && a !== null || b === undefined && a !== undefined) {
      return false;
    } // Covers undefined === undefined and null === null, since mismatches are eliminated above


    if (a == null && b == null) {
      return true;
    } // The same instance should equal itself.


    if (a === b) {
      return true;
    }

    const typeA = typeof a,
          typeB = typeof b;

    if (typeA === typeB) {
      switch (typeA) {
        case 'number':
        case 'string':
        case 'boolean':
          return a === b;
      }

      switch (true) {
        case a instanceof Date && b instanceof Date:
          // faster than calling DateHelper.isEqual
          // https://jsbench.me/3jk2bom2r3/1
          return a.getTime() === b.getTime();

        case Array.isArray(a) && Array.isArray(b):
          return a.length === b.length ? a.every((v, idx) => OH.isEqual(v, b[idx], useIsDeeply)) : false;

        case typeA === 'object' && a.constructor.prototype === b.constructor.prototype:
          return useIsDeeply ? OH.isDeeplyEqual(a, b, useIsDeeply) : JSON.stringify(a) === JSON.stringify(b);
      }
    }

    return String(a) === String(b);
  }
  /**
   * Checks if two objects are deeply equal
   * @param {Object} a
   * @param {Object} b
   * @param {Object} [options] Additional comparison options
   * @param {Object} [options.ignore] Map of property names to ignore when comparing
   * @param {Function} [options.shouldEvaluate] Function used to evaluate if a property should be compared or not.
   * Return false to prevent comparison
   * @param {Function} [options.evaluate] Function used to evaluate equality. Return `true`/`false` as evaluation
   * result or anything else to let `isEqual` handle the comparison
   * @returns {Boolean}
   */


  static isDeeplyEqual(a, b, options = {}) {
    // Same object, equal :)
    if (a === b) {
      return true;
    } // Nothing to compare, not equal


    if (!a || !b) {
      return false;
    } // Property names excluding ignored


    const aKeys = OH.keys(a, options.ignore),
          bKeys = OH.keys(b, options.ignore); // Property count differs, not equal

    if (aKeys.length !== bKeys.length) {
      return false;
    }

    for (let i = 0; i < aKeys.length; i++) {
      const aKey = aKeys[i],
            bKey = bKeys[i]; // Property name differs, not equal

      if (aKey !== bKey) {
        return false;
      }

      const aVal = a[aKey],
            bVal = b[bKey]; // Allow caller to determine if property values should be evaluated or not
      // TODO: Not currently used

      if (options.shouldEvaluate) {
        if (options.shouldEvaluate(aKey, {
          value: aVal,
          object: a
        }, {
          value: bVal,
          object: b
        }) === false) {
          continue;
        }
      } // Allow caller to determine equality of properties


      if (options.evaluate) {
        const result = options.evaluate(aKey, {
          value: aVal,
          object: a
        }, {
          value: bVal,
          object: b
        }); // Not equal

        if (result === false) {
          return false;
        } // Equal, skip isEqual call below


        if (result === true) {
          continue;
        }
      } // Values differ, not equal (also digs deeper)


      if (!OH.isEqual(aVal, bVal, options)) {
        return false;
      }
    } // Found to be equal


    return true;
  }
  /**
   * Checks if value B is partially equal to value A.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if values are partially equal, false otherwise
   */


  static isPartial(a, b) {
    a = String(a).toLowerCase();
    b = String(b).toLowerCase();
    return a.indexOf(b) !== -1;
  }
  /**
   * Checks if value a is smaller than value b.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if a < b
   */


  static isLessThan(a, b) {
    if (a instanceof Date && b instanceof Date) {
      return _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBefore(a, b);
    }

    return a < b;
  }
  /**
   * Checks if value a is bigger than value b.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if a > b
   */


  static isMoreThan(a, b) {
    if (a instanceof Date && b instanceof Date) {
      return _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAfter(a, b);
    }

    return a > b;
  }
  /**
   * Used by the Base class to make deep copies of defaultConfig blocks
   * @private
   */


  static fork(obj) {
    let ret, key, value;

    if (obj && obj.constructor === Object) {
      ret = Object.setPrototypeOf({}, obj);

      for (key in obj) {
        value = obj[key];

        if (value) {
          if (value.constructor === Object) {
            ret[key] = OH.fork(value);
          } else if (value instanceof Array) {
            ret[key] = value.slice();
          }
        }
      }
    } else {
      ret = obj;
    }

    return ret;
  }
  /**
   * Copies the named properties from the `source` parameter into the `dest` parameter.
   * @param {Object} dest The destination into which properties are copied.
   * @param {Object} source The source from which properties are copied.
   * @param {String[]} props The list of property names.
   * @returns The `dest` object.
   */


  static copyProperties(dest, source, props) {
    let prop, i;

    for (i = 0; i < props.length; i++) {
      prop = props[i];

      if (prop in source) {
        dest[prop] = source[prop];
      }
    }

    return dest;
  }
  /**
   * Copies the named properties from the `source` parameter into the `dest` parameter
   * unless the property already exists in the `dest`.
   * @param {Object} dest The destination into which properties are copied.
   * @param {Object} source The source from which properties are copied.
   * @param {String[]} props The list of property names.
   * @returns The `dest` object.
   */


  static copyPropertiesIf(dest, source, props) {
    if (source) {
      for (const prop of props) {
        if (!(prop in dest)) {
          dest[prop] = source[prop];
        }
      }
    }

    return dest;
  }
  /**
   * Returns an array containing the keys and values of all enumerable properties from every prototype level for the
   * object. If `object` is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve entries.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @returns {Array}
   * @internal
   */


  static entries(object, ignore) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push([p, object[p]]);
        }
      }
    }

    return result;
  }
  /**
   * Populates an `object` with the provided `entries`.
   * @param {Array} entries The key/value pairs (2-element arrays).
   * @param {Object} [object={}] The object onto which to add `entries`.
   * @returns {Object} The passed `object` (by default, a newly created object).
   * @internal
   */


  static fromEntries(entries, object) {
    object = object || {};

    if (entries) {
      for (let i = 0; i < entries.length; ++i) {
        object[entries[i][0]] = entries[i][1];
      }
    }

    return object;
  }
  /**
   * Returns an array containing all enumerable property names from every prototype level for the object. If `object`
   * is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve property names.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @param {Function} [mapper] Optional function to call for each non-ignored item. If provided, the result of this
   * function is stored in the returned array. It is called with the array element as the first parameter, and the
   * index in the result array as the second argument (0 for the first, non-ignored element, 1 for the second and so
   * on).
   * @returns {String[]}
   */


  static keys(object, ignore, mapper) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      let index = 0;

      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push(mapper ? mapper(p, index) : p);
          ++index;
        }
      }
    }

    return result;
  }
  /**
   * Returns an array containing the values of all enumerable properties from every prototype level for the object.
   * If `object` is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve values.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @param {Function} [mapper] Optional function to call for each non-ignored item. If provided, the result of this
   * function is stored in the returned array. It is called with the array element as the first parameter, and the
   * index in the result array as the second argument (0 for the first, non-ignored element, 1 for the second and so
   * on).
   * @returns {Array}
   * @internal
   */


  static values(object, ignore, mapper) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      let index = 0;

      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push(mapper ? mapper(object[p], index) : object[p]);
          ++index;
        }
      }
    }

    return result;
  }
  /**
   * Returns an array of a given object's properties names including properties in
   * all superclasses, in the same order as we get with a normal loop.
   * @param {Object} object An object which may have properties in a prototype
   * chain, such as a configuration (These are chained because of inheritance).
   * @returns {String[]} The property names.
   * @deprecated 4.1.0 Use {@link #function-keys-static} instead.
   */


  static allKeys(object) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `keys()`; will be removed in 5.0');
    return ObjectHelper.keys(object);
  } //region Path

  /**
   * Checks if a given path exists in an object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {Boolean} Returns `true` if path exists or `false` if it does not
   */


  static pathExists(object, path) {
    const properties = path.split('.');
    return properties.every(property => {
      if (!object || !(property in object)) {
        return false;
      }

      object = object[property];
      return true;
    });
  }
  /**
   * Creates a simple single level key-value object from complex deep object.
   * @param {Object} object Object to extract path and values from
   * @returns {Object} Key-value object where key is a path to the corresponding value
   * @internal
   *
   * ```javascript
   * // converts deep object
   * {
   *     foo : {
   *         bar : {
   *             test : 1
   *         }
   *     }
   * }
   * // into a single level object
   * {
   *     'foo.bar.test' : 1
   * }
   * ```
   */


  static pathifyKeys(object) {
    const result = {};

    for (const key in object) {
      if (hasOwnProperty.call(object, key)) {
        if (object[key] instanceof Object) {
          const paths = this.pathifyKeys(object[key]);

          for (const path in paths) {
            result[`${key}.${path}`] = paths[path];
          }
        } else {
          result[key] = object[key];
        }
      }
    }

    return result;
  }
  /**
   * Removes value for a given path in the object. Doesn't cleanup empty objects.
   * @param {Object} object
   * @param {String} path Dot-separated path, e.g. `obj.child.someKey`
   * @internal
   */


  static deletePath(object, path) {
    path.split('.').reduce((result, key, index, array) => {
      if (result == null) {
        return null;
      } else if (hasOwnProperty.call(result, key)) {
        if (index === array.length - 1) {
          delete result[key];
        } else {
          return result[key];
        }
      }
    }, object);
  } //endregion


  static coerce(from, to) {
    const fromType = typeOf(from),
          toType = typeOf(to),
          isString = typeof from === 'string';

    if (fromType !== toType) {
      switch (toType) {
        case 'string':
          return String(from);

        case 'number':
          return Number(from);

        case 'boolean':
          // See http://ecma262-5.com/ELS5_HTML.htm#Section_11.9.3 as to why '0'.
          // TL;DR => ('0' == 0), so if given string '0', we must return boolean false.
          return isString && (!from || from === 'false' || from === '0') ? false : Boolean(from);

        case 'null':
          return isString && (!from || from === 'null') ? null : false;

        case 'undefined':
          return isString && (!from || from === 'undefined') ? undefined : false;

        case 'date':
          return isString && isNaN(from) ? _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(from) : Date(Number(from));
      }
    }

    return from;
  }

  static wrapProperty(object, propertyName, newGetter, newSetter, deep = true) {
    const newProperty = {};
    let proto = Object.getPrototypeOf(object),
        existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);

    while (!existingProperty && proto && deep) {
      proto = Object.getPrototypeOf(proto);

      if (proto) {
        existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);
      }
    }

    if (existingProperty) {
      if (existingProperty.set) {
        newProperty.set = v => {
          existingProperty.set.call(object, v); // Must invoke the getter in case "v" has been transformed.

          newSetter && newSetter.call(object, existingProperty.get.call(object));
        };
      } else {
        newProperty.set = newSetter;
      }

      if (existingProperty.get) {
        newProperty.get = () => {
          let result = existingProperty.get.call(object);

          if (newGetter) {
            result = newGetter.call(object, result);
          }

          return result;
        };
      } else {
        newProperty.get = newGetter;
      }
    } else {
      newProperty.set = v => {
        object[`_${propertyName}`] = v;
        newSetter && newSetter.call(object, v);
      };

      newProperty.get = () => {
        let result = object[`_${propertyName}`];

        if (newGetter) {
          result = newGetter.call(object, result);
        }

        return result;
      };
    }

    Object.defineProperty(object, propertyName, newProperty);
  }
  /**
   * Finds a property descriptor for the passed object from all inheritance levels.
   * @param {Object} object The Object whose property to find.
   * @param {String} propertyName The name of the property to find.
   * @returns {Object} An ECMA property descriptor is the property was found, otherwise `null`
   */


  static getPropertyDescriptor(object, propertyName) {
    let result = null;

    for (let o = object; o && !result && !hasOwnProperty.call(o, 'isBase'); o = Object.getPrototypeOf(o)) {
      result = Object.getOwnPropertyDescriptor(o, propertyName);
    }

    return result;
  }
  /**
   * Return `true` if the given `object` defines the specified `property` as defined by
   * [Object.hasOwnProperty](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty).
   * @param {Object} object
   * @param {String} property
   * @returns {Boolean}
   * @internal
   */


  static hasOwn(object, property) {
    // Benefits:
    // - Better compression over direct call to Object.prototype.hasOwnProperty.call(object, property)
    // - Almost as compact as "object.hasOwnProperty()" but still works with Object.create(null) objects
    // - Does not throw if object is null/undefined unlike all forms of hasOwnProperty
    //
    // Even given above, if needed often in a module it is probably still better to use:
    //  const { hasOwnProperty } = Object.prototype;
    // and
    //  hasOwnProperty.call()
    return object ? hasOwnProperty.call(object, property) : false;
  }
  /**
   * Changes the passed object and removes all null and undefined properties from it
   * @param {Object} object Target object
   * @param {Boolean} [keepNull] Pass true to only remove undefined properties
   * @returns {Object} Passed object
   */


  static cleanupProperties(object, keepNull = false) {
    Object.entries(object).forEach(([key, value]) => {
      if (keepNull) {
        value === undefined && delete object[key];
      } else {
        value == null && delete object[key];
      }
    });
    return object;
  }
  /**
   * Changes the passed object and removes all properties from it.
   * Used while mutating when need to keep reference to the object but replace its properties.
   * @param {Object} object Target object
   * @returns {Object} Passed object
   */


  static removeAllProperties(obj) {
    Object.keys(obj).forEach(key => delete obj[key]);
    return obj;
  } //region Assert type

  /**
   * Checks that the supplied value is of the specified type.Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} type Expected type
   * @param {String} name Name of the value, used in error message
   * @param {Boolean} [allowNull] Accept `null` without throwing
   */


  static assertType(value, type, name) {
    const valueType = typeOf(value);

    if (value != null && valueType !== type) {
      throw new Error(`Incorrect type "${valueType}" for ${name}, expected "${type}"`);
    }
  }
  /**
   * Checks that the supplied value is a plain object. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertObject(value, name) {
    OH.assertType(value, 'object', name);
  }
  /**
   * Checks that the supplied value is an instance of a Bryntum class. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertInstance(value, name) {
    OH.assertType(value, 'instance', name);
  }
  /**
   * Checks that the supplied value is a Bryntum class. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertClass(value, name) {
    OH.assertType(value, 'class', name);
  }
  /**
   * Checks that the supplied value is a function. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertFunction(value, name) {
    if (typeof value !== 'function' || value.isBase || value.$$name) {
      throw new Error(`Incorrect type for ${name}, got "${value}" (expected a function)`);
    }
  }
  /**
   * Checks that the supplied value is a number. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertNumber(value, name) {
    const asNumber = Number(value);

    if (typeof value !== 'number' || isNaN(asNumber)) {
      throw new Error(`Incorrect type for ${name}, got "${value}" (expected a Number)`);
    }
  }
  /**
   * Checks that the supplied value is a boolean. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertBoolean(value, name) {
    OH.assertType(value, 'boolean', name);
  }
  /**
   * Checks that the supplied value is a string. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertString(value, name) {
    OH.assertType(value, 'string', name);
  }
  /**
   * Checks that the supplied value is an array. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertArray(value, name) {
    OH.assertType(value, 'array', name);
  } //endregion

  /**
   * Number.toFixed(), with polyfill for browsers that needs it
   * @param {Number} number
   * @param {Number} digits
   * @returns {String} A fixed point string representation of the passed number.
   */


  static toFixed(number, digits) {
    if (toFixedFix) {
      return toFixedFix(number, digits);
    }

    return number.toFixed(digits);
  }
  /**
   * Round the passed number to closest passed step value.
   * @param {Number} number The number to round.
   * @param {Number} [step] The step value to round to.
   * @returns {Number} The number rounded to the closest step.
   */


  static roundTo(number, step = 1) {
    return Math.round(number / step) * step;
  }
  /**
   * Round the passed number to the passed number of decimals.
   * @param {Number} number The number to round.
   * @param {Number} digits The number of decimal places to round to.
   * @returns {Number} The number rounded to the passed number of decimal places.
   */


  static round(number, digits) {
    // Undefined or null means do not round. NOT round to no decimals.
    if (digits == null) {
      return number;
    }

    const factor = 10 ** digits;
    return Math.round(number * factor) / factor;
  }
  /**
   * Returns a non-null entry from a Map for a given key path. This enables a specified defaultValue to be added "just
   * in time" which is returned if the key is not already present.
   * @param {Map} map The Map to find the key in (and potentially add to).
   * @param {String|Number|String[]|Number[]} path Dot-separated path, e.g. 'firstChild.childObject.someKey',
   * or the key path as an array, e.g. ['firstChild', 'childObject', 'someKey'].
   * @param {Object} [defaultValue] Optionally the value to insert if the key is not found.
   */


  static getMapPath(map, path, defaultValue) {
    const keyPath = Array.isArray(path) ? path : typeof path === 'string' ? path.split('.') : [path],
          simpleKey = keyPath.length === 1,
          topKey = keyPath[0],
          topValue = map.has(topKey) ? map.get(topKey) : map.set(topKey, simpleKey ? defaultValue : {}).get(topKey); // If it was a simple key, we are done.

    if (simpleKey) {
      return topValue;
    } // Go down the property path on the top Object, filling entries in until the leaf.


    return OH.getPathDefault(topValue, keyPath.slice(1), defaultValue);
  }

}
const OH = ObjectHelper;
ObjectHelper._$name = 'ObjectHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ResizeHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeHelper; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';






 //TODO: add pointer events support

const documentListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: {
    handler: 'onTouchStart',
    // We preventDefault touchstart so as not to scroll. Must not be passive.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    passive: false
  },
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * @module Core/helper/ResizeHelper
 */

/**
 * Handles resizing of elements using handles. Handles can be actual elements or virtual handles specified as a border
 * area on elements left and right edges.
 *
 * ```
 * // enable resizing all elements with class 'resizable'
 * let resizer = new ResizeHelper({
 *   targetSelector: '.resizable'
 * });
 * ```
 *
 * @mixes Core/mixin/Events
 * @internal
 */

class ResizeHelper extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * CSS class added when resizing
       * @config {String}
       * @default
       */
      resizingCls: 'b-resizing',

      /**
       * The amount of pixels to move mouse before it counts as a drag operation
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * Resizing handle size
       * @config {Number}
       * @default
       */
      handleSize: 10,

      /**
       * Automatically shrink virtual handles when available space < handleSize. The virtual handles will
       * decrease towards width/height 1, reserving space between opposite handles to for example leave room for
       * dragging. To configure reserved space, see {@link #config-reservedSpace}.
       * @config {Boolean}
       * @default false
       */
      dynamicHandleSize: null,
      //

      /**
       * Room in px to leave unoccupied by handles when shrinking them dynamically (see
       * {@link #config-dynamicHandleSize}).
       * @config {Number}
       * @default
       */
      reservedSpace: 10,

      /**
       * Resizing handle size on touch devices
       * @config {Number}
       * @default
       */
      touchHandleSize: 30,

      /**
       * Minimum width when resizing
       * @config {Number}
       * @default
       */
      minWidth: 1,

      /**
       * Max width when resizing.
       * @config {Number}
       * @default
       */
      maxWidth: 0,

      /**
       * Minimum height when resizing
       * @config {Number}
       * @default
       */
      minHeight: 1,

      /**
       * Max height when resizing
       * @config {Number}
       * @default
       */
      maxHeight: 0,
      // outerElement, attach events to it and use as outer limit when looking for ancestors
      outerElement: document.body,

      /**
       * Optional scroller used to read scroll position. If unspecified, the outer element will be used.
       * @config {Core.helper.util.Scroller}
       */
      scroller: null,

      /**
       * Assign a function to determine if a hovered element can be resized or not
       * @config {Function}
       * @default
       */
      allowResize: null,

      /**
       * Outer element that limits where element can be dragged
       * @config {HTMLElement}
       * @default
       */
      dragWithin: null,

      /**
       * A function that determines if dragging an element is allowed. Gets called with the element as argument,
       * return true to allow dragging or false to prevent.
       * @config {Function}
       * @default
       */
      isElementResizable: null,

      /**
       * A CSS selector used to determine if resizing an element is allowed.
       * @config {String}
       * @default
       */
      targetSelector: null,

      /**
       * Use left handle when resizing. Only applies when `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      leftHandle: true,

      /**
       * Use right handle when resizing. Only applies when `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      rightHandle: true,

      /**
       * Use top handle when resizing. Only applies when `direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      topHandle: true,

      /**
       * Use bottom handle when resizing. Only applies when `direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      bottomHandle: true,

      /**
       * A CSS selector used to determine where handles should be "displayed" when resizing. Defaults to
       * targetSelector if unspecified
       * @config {String}
       * @default
       */
      handleSelector: null,

      /**
       * A CSS selector used to determine which inner element contains handles.
       * @config {String}
       * @default
       */
      handleContainerSelector: null,
      startEvent: null,

      /*
       * Optional config object, used by EventResize feature: it appends proxy and has to start resizing immediately
       * @config {Object}
       * @private
       */
      grab: null,

      /**
       * CSS class added when the resize state is invalid
       * @config {String}
       * @default
       */
      invalidCls: 'b-resize-invalid',
      // A number that controls whether or not the element is wide enough for it to make sense to show resize handles
      // e.g. handle width is 10px, so doesn't make sense to show them unless handles on both sides fit
      handleVisibilityThreshold: null,
      // Private config that disables translation when resizing left edge. Useful for example in cases when element
      // being resized is part of a flex layout
      skipTranslate: false,

      /**
       * Direction to resize in, either 'horizontal' or 'vertical'
       * @config {String}
       * @default
       */
      direction: 'horizontal',
      clickSwallowDuration: 50
    };
  } //endregion
  //region Events

  /**
   * Fired while dragging
   * @event resizing
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent} event Browser event
   */

  /**
   * Fired when dragging starts.
   * @event resizeStart
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent|TouchEvent} event Browser event
   */

  /**
   * Fires after resize, and allows for asynchronous finalization by setting 'async' to `true` on the context object.
   * @event resize
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Context about the resize operation. Set 'async' to `true` to indicate asynchronous validation of the resize flow (for showing a confirmation dialog etc)
   */

  /**
   * Fires when a resize is canceled (width is unchanged)
   * @event cancel
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent|TouchEvent} event Browser event
   */
  //endregion
  //region Init


  construct(config) {
    const me = this;
    super.construct(config); // Larger draggable zones on pure touch devices with no mouse

    if (!me.handleSelector && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice) {
      me.handleSize = me.touchHandleSize;
    }

    me.handleVisibilityThreshold = me.handleVisibilityThreshold || 2 * me.handleSize;
    me.initListeners();
    me.initResize();
  }

  doDestroy() {
    this.abort(true);
    super.doDestroy();
  }
  /**
   * Initializes resizing
   * @private
   */


  initResize() {
    const me = this;

    if (!me.isElementResizable && me.targetSelector) {
      me.isElementResizable = element => _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(element, me.targetSelector);
    }

    if (me.grab) {
      const {
        edge,
        element,
        event
      } = me.grab;
      me.startEvent = event;
      const cursorOffset = me.getCursorOffsetToElementEdge(event, element, edge); // emulates mousedown & grabResize

      me.context = {
        element,
        edge,
        valid: true,
        async: false,
        elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
        // extract x from translate
        elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
        // extract x from translate
        newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
        // No change yet on start, but info must be present
        newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
        // No change yet on start, but info must be present
        elementWidth: element.offsetWidth,
        elementHeight: element.offsetHeight,
        cursorOffset,
        startX: event.clientX + cursorOffset.x + me.scrollLeft,
        startY: event.clientY + cursorOffset.y + me.scrollTop,
        finalize: () => {
          var _me$reset;

          return (_me$reset = me.reset) === null || _me$reset === void 0 ? void 0 : _me$reset.call(me);
        }
      };
      element.classList.add(me.resizingCls);
      me.internalStartResize(me.isTouch);
    }
  }
  /**
   * Initialize listeners
   * @private
   */


  initListeners() {
    const me = this,
          dragStartListeners = {
      element: me.outerElement,
      mousedown: documentListeners.down,
      touchstart: documentListeners.touchstart,
      thisObj: me
    };

    if (!me.handleSelector && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice) {
      dragStartListeners.mousemove = {
        handler: documentListeners.move,
        // Filter events for checkResizeHandles so we only get called if the mouse
        // is over one of our targets.
        delegate: me.targetSelector
      }; // We need to clean up when we exit one of our targets

      dragStartListeners.mouseleave = {
        handler: 'onMouseLeaveTarget',
        delegate: me.targetSelector,
        capture: true
      };
    } // These will be autoDetached upon destroy


    me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(dragStartListeners);
  }

  removeListeners() {} //endregion
  //region Scroll helpers


  get scrollLeft() {
    if (this.scroller) {
      return this.scroller.x;
    }

    return this.outerElement.scrollLeft;
  }

  get scrollTop() {
    if (this.scroller) {
      return this.scroller.y;
    }

    return this.outerElement.scrollTop;
  } //endregion
  //region Events


  internalStartResize(isTouch) {
    const me = this,
          dragListeners = {
      element: document,
      keydown: documentListeners.keydown,
      thisObj: me
    };

    if (isTouch) {
      dragListeners.touchmove = documentListeners.touchmove; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
      // iOS do fire touchend

      dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
    } else {
      dragListeners.mousemove = documentListeners.move;
      dragListeners.mouseup = documentListeners.up;
    } // A listener detacher is returned;


    me.removeDragListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(dragListeners);
  } // Empty class implementation. If listeners *are* added, the detacher is added
  // as an instance property. So this is always callable.


  removeDragListeners() {}

  reset() {
    var _this$removeDragListe;

    (_this$removeDragListe = this.removeDragListeners) === null || _this$removeDragListe === void 0 ? void 0 : _this$removeDragListe.call(this);
    this.context = null;
  }

  onPointerDown(isTouch, event) {
    const me = this;
    me.startEvent = event;

    if (!me.isElementResizable || me.isElementResizable(event.target, event)) {
      if (me.grabResizeHandle(isTouch, event)) {
        // Stop event if resize handle was grabbed (resize started)
        event.stopImmediatePropagation();

        if (event.type === 'touchstart') {
          event.preventDefault();
        }

        me.internalStartResize(isTouch);
      }
    }
  }

  onTouchStart(event) {
    // only allowing one finger for now...
    if (event.touches.length > 1) {
      return;
    }

    this.onPointerDown(true, event);
  }
  /**
   * Grab draggable element on mouse down.
   * @private
   * @param {MouseEvent|PointerEvent} event
   */


  onMouseDown(event) {
    // only dragging with left mouse button
    if (event.button !== 0) {
      return;
    }

    this.onPointerDown(false, event);
  }

  internalMove(isTouch, event) {
    const me = this,
          {
      context,
      direction
    } = me;

    if (context !== null && context !== void 0 && context.element && (context.started || _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getDistanceBetween(me.startEvent, event) >= me.dragThreshold)) {
      if (!context.started) {
        var _me$scrollManager;

        (_me$scrollManager = me.scrollManager) === null || _me$scrollManager === void 0 ? void 0 : _me$scrollManager.startMonitoring(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge({
          scrollables: [{
            element: me.dragWithin || me.outerElement,
            // TODO Update this then when we add support for resizing in both directions simultaneously
            direction
          }],
          callback: config => {
            var _me$context;

            return ((_me$context = me.context) === null || _me$context === void 0 ? void 0 : _me$context.element) && me.lastMouseMoveEvent && me.update(me.lastMouseMoveEvent, config);
          }
        }, me.monitoringConfig));
        me.trigger('resizeStart', {
          context,
          event
        });
        context.started = true;
      }

      me.update(event);
    } // If a mousemove, and we are using zones, and not handles, we have to
    // programmatically check whether we are over a handle, and add/remove
    // classes to change the mouse cursor to resize.
    // If we are using handles, their CSS will set the mouse cursor.
    else if (!isTouch && !me.handleSelector) {
      me.checkResizeHandles(event);
    }
  }

  onTouchMove(event) {
    this.internalMove(true, event);
  }
  /**
   * Move grabbed element with mouse.
   * @param {MouseEvent|PointerEvent} event
   * @fires resizestart
   * @private
   */


  onMouseMove(event) {
    this.internalMove(false, event);
  }

  onPointerUp(isTouch, event) {
    var _me$removeDragListene;

    const me = this,
          context = me.context;
    (_me$removeDragListene = me.removeDragListeners) === null || _me$removeDragListene === void 0 ? void 0 : _me$removeDragListene.call(me);

    if (context) {
      var _me$scrollManager2;

      (_me$scrollManager2 = me.scrollManager) === null || _me$scrollManager2 === void 0 ? void 0 : _me$scrollManager2.stopMonitoring();

      if (context.started) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
          element: document,
          thisObj: me,
          click: documentListeners.docclick,
          expires: me.clickSwallowDuration,
          // In case a click did not ensue, remove the listener
          capture: true,
          once: true
        });
      }

      me.finishResize(event);
    } else {
      var _me$reset2;

      (_me$reset2 = me.reset) === null || _me$reset2 === void 0 ? void 0 : _me$reset2.call(me);
    }
  }

  onTouchEnd(event) {
    this.onPointerUp(true, event);
  }
  /**
   * Drop on mouse up (if dropped on valid target).
   * @param {MouseEvent|PointerEvent} event
   * @private
   */


  onMouseUp(event) {
    this.onPointerUp(false, event);
  }
  /**
   * This is a capture listener, only added during drag, which prevents a click gesture
   * propagating from the terminating mouseup gesture
   * @param {MouseEvent} event
   * @private
   */


  onDocumentClick(event) {
    event.stopPropagation();
  }
  /**
   * Cancel on ESC key
   * @param {KeyboardEvent} event
   * @private
   */


  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.abort();
    }
  } //endregion
  //region Grab, update, finish

  /**
   * Updates resize, called when an element is grabbed and mouse moves
   * @private
   * @fires resizing
   */


  update(event) {
    const me = this,
          context = me.context,
          parentRectangle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(me.outerElement); // Calculate the current pointer X. Do not allow overflowing either edge

    context.currentX = Math.max(Math.min(event.clientX + context.cursorOffset.x, parentRectangle.right), parentRectangle.x) + me.scrollLeft;
    context.currentY = Math.max(Math.min(event.clientY + context.cursorOffset.y, parentRectangle.bottom), parentRectangle.y) + me.scrollTop;
    me.updateResize(event);
    me.trigger('resizing', {
      context,
      event
    });
    context.element.classList[context.valid === false ? 'add' : 'remove'](me.invalidCls); // When IE11 support is dropped
    // context.grabbed.classList.toggle(me.invalidCls, context.valid === false);

    if (event) {
      me.lastMouseMoveEvent = event;
    }
  }
  /**
   * Abort dragging
   */


  abort(silent = false) {
    var _me$scrollManager3, _me$scrollManager3$st;

    const me = this;
    (_me$scrollManager3 = me.scrollManager) === null || _me$scrollManager3 === void 0 ? void 0 : (_me$scrollManager3$st = _me$scrollManager3.stopMonitoring) === null || _me$scrollManager3$st === void 0 ? void 0 : _me$scrollManager3$st.call(_me$scrollManager3);

    if (me.context) {
      me.abortResize(null, silent);
    } else if (!me.isDestroyed) {
      me.reset();
    }
  }
  /**
   * Starts resizing, updates ResizeHelper#context with relevant info.
   * @private
   * @param {Boolean} isTouch
   * @param {MouseEvent} event
   * @returns {Boolean} True if handled, false if not
   */


  grabResizeHandle(isTouch, event) {
    const me = this;

    if (me.allowResize && !me.allowResize(event.target, event)) {
      return false;
    }

    const handleSelector = me.handleSelector,
          coordsFrom = event.type === 'touchstart' ? event.changedTouches[0] : event,
          clientX = coordsFrom.clientX,
          clientY = coordsFrom.clientY,
          // go up from "handle" to resizable element
    element = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.targetSelector) : event.target;

    if (element) {
      let edge; // Calculate which edge to resize
      // If there's a handle selector, see if it's anchored on the left or the right

      if (handleSelector) {
        if (event.target.matches(handleSelector)) {
          if (me.direction === 'horizontal') {
            if (event.pageX < _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageX(element) + element.offsetWidth / 2) {
              edge = 'left';
            } else {
              edge = 'right';
            }
          } else {
            if (event.pageY < _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageY(element) + element.offsetHeight / 2) {
              edge = 'top';
            } else {
              edge = 'bottom';
            }
          }
        } else {
          return false;
        }
      } // If we're not using handles, but just active zones
      // then test whether the event position is in an active resize zone.
      else {
        if (me.direction === 'horizontal') {
          if (me.overLeftHandle(event, element)) {
            edge = 'left';
          } else if (me.overRightHandle(event, element)) {
            edge = 'right';
          }
        } else {
          if (me.overTopHandle(event, element)) {
            edge = 'top';
          } else if (me.overBottomHandle(event, element)) {
            edge = 'bottom';
          }
        }

        if (!edge) {
          me.context = null; // not over an edge, abort

          return false;
        }
      } // If resizing is initiated by a touch, we must preventDefault on the touchstart
      // so that scrolling is not invoked when dragging. This is in lieu of a functioning
      // touch-action style on iOS Safari. When that's fixed, this will not be needed.


      if (event.type === 'touchstart') {
        event.preventDefault();
      }

      const cursorOffset = me.getCursorOffsetToElementEdge(coordsFrom, element, edge);

      if (me.trigger('beforeResizeStart', {
        element,
        event
      }) !== false) {
        // store initial size
        me.context = {
          element,
          edge,
          isTouch,
          valid: true,
          async: false,
          direction: me.direction,
          elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
          // extract x from translate
          elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
          // extract y from translate
          newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
          // No change yet on start, but info must be present
          newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
          // No change yet on start, but info must be present
          elementWidth: element.offsetWidth,
          elementHeight: element.offsetHeight,
          cursorOffset,
          startX: clientX + cursorOffset.x + me.scrollLeft,
          startY: clientY + cursorOffset.y + me.scrollTop,
          finalize: () => {
            var _me$reset3;

            return (_me$reset3 = me.reset) === null || _me$reset3 === void 0 ? void 0 : _me$reset3.call(me);
          }
        };
        element.classList.add(me.resizingCls);
        return true;
      }
    }

    return false;
  }

  getCursorOffsetToElementEdge(event, element, edge) {
    const rectEl = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(element);
    let x = 0,
        y = 0;

    switch (edge) {
      case 'left':
        x = rectEl.x - event.clientX; // negative

        break;

      case 'right':
        x = rectEl.x + rectEl.width - event.clientX; // positive

        break;

      case 'top':
        y = rectEl.y - event.clientY; // negative

        break;

      case 'bottom':
        y = rectEl.y + rectEl.height - event.clientY; // positive

        break;
    }

    return {
      x,
      y
    };
  }
  /**
   * Check if mouse is over a resize handle (virtual). If so, highlight.
   * @private
   * @param {MouseEvent} event
   */


  checkResizeHandles(event) {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.targetSelector) : event.target; // mouse over a target element and allowed to resize?

    if (target && (!me.allowResize || me.allowResize(event.target, event))) {
      me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.handleContainerSelector) : event.target;

      if (me.currentElement) {
        let over = false;

        if (me.direction === 'horizontal') {
          over = me.overLeftHandle(event, target) || me.overRightHandle(event, target);
        } else {
          over = me.overTopHandle(event, target) || me.overBottomHandle(event, target);
        }

        if (over) {
          me.highlightHandle(); // over handle
        } else {
          me.unHighlightHandle(); // not over handle
        }
      }
    } else if (me.currentElement) {
      me.unHighlightHandle(); // outside element
    }
  }

  onMouseLeaveTarget(event) {
    const me = this;
    me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.handleContainerSelector) : event.target;

    if (me.currentElement) {
      me.unHighlightHandle();
    }
  }
  /**
   * Updates size of target (on mouse move).
   * @private
   * @param {MouseEvent|PointerEvent} event
   */


  updateResize(event) {
    const me = this,
          context = me.context; // flip which edge is being dragged depending on whether we're to the right or left of the mousedown

    if (me.allowEdgeSwitch) {
      if (me.direction === 'horizontal') {
        context.edge = context.currentX > context.startX ? 'right' : 'left';
      } else {
        context.edge = context.currentY > context.startY ? 'bottom' : 'top';
      }
    }

    const // limit to outerElement if set
    deltaX = context.currentX - context.startX,
          deltaY = context.currentY - context.startY,
          minWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'minWidth') || me.minWidth,
          maxWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'maxWidth') || me.maxWidth,
          minHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'minHeight') || me.minHeight,
          maxHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'maxHeight') || me.maxHeight,
          // dragging right edge right increases width, dragging left edge right decreases width
    sign = context.edge === 'right' || context.edge === 'bottom' ? 1 : -1,
          // new width, not allowed to go below minWidth
    newWidth = context.elementWidth + deltaX * sign,
          newHeight = context.elementHeight + deltaY * sign;
    let width = Math.max(minWidth, newWidth),
        height = Math.max(minHeight, newHeight);

    if (maxWidth > 0) {
      width = Math.min(width, maxWidth);
    }

    if (maxHeight > 0) {
      height = Math.min(height, maxHeight);
    } // remove flex when resizing


    if (context.element.style.flex) {
      context.element.style.flex = '';
    }

    if (me.direction === 'horizontal') {
      context.element.style.width = Math.abs(width) + 'px';
      context.newWidth = width; // when dragging left edge, also update position (so that right edge remains in place)

      if (context.edge === 'left' || width < 0) {
        context.newX = Math.max(Math.min(context.elementStartX + context.elementWidth - me.minWidth, context.elementStartX + deltaX), 0);

        if (!me.skipTranslate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.newX);
        }
      } // When dragging the right edge and we're allowed to flip the drag from left to right
      // through the start point (eg drag event creation) the element must be at its initial X position
      else if (context.edge === 'right' && me.allowEdgeSwitch && !me.skipTranslate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.elementStartX);
      }
    } else {
      context.element.style.height = Math.abs(height) + 'px';
      context.newHeight = height; // when dragging top edge, also update position (so that bottom edge remains in place)

      if (context.edge === 'top' || height < 0) {
        context.newY = Math.max(Math.min(context.elementStartY + context.elementHeight - me.minHeight, context.elementStartY + deltaY), 0);

        if (!me.skipTranslate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.newY);
        }
      } // When dragging the bottom edge and we're allowed to flip the drag from top to bottom
      // through the start point (eg drag event creation) the element must be at its initial Y position
      else if (context.edge === 'bottom' && me.allowEdgeSwitch && !me.skipTranslate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.elementStartY);
      }
    }
  }
  /**
   * Finalizes resize, fires drop.
   * @private
   * @param {MouseEvent|PointerEvent} event
   * @fires resize
   * @fires cancel
   */


  finishResize(event) {
    const me = this,
          context = me.context,
          eventObject = {
      context,
      event
    };
    context.element.classList.remove(me.resizingCls);

    if (context.started) {
      let changed = false;

      if (me.direction === 'horizontal') {
        changed = context.newWidth && context.newWidth !== context.elementWidth;
      } else {
        changed = context.newHeight && context.newHeight !== context.elementHeight;
      }

      me.trigger(changed ? 'resize' : 'cancel', eventObject);

      if (!context.async) {
        context.finalize();
      }
    } else {
      var _me$reset4;

      (_me$reset4 = me.reset) === null || _me$reset4 === void 0 ? void 0 : _me$reset4.call(me);
    }
  }
  /**
   * Abort resizing
   * @private
   * @fires cancel
   */


  abortResize(event = null, silent = false) {
    const me = this,
          context = me.context;
    context.element.classList.remove(me.resizingCls);

    if (me.direction === 'horizontal') {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.elementStartX);
      context.element.style.width = context.elementWidth + 'px';
    } else {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.elementStartY);
      context.element.style.height = context.elementHeight + 'px';
    }

    !silent && me.trigger('cancel', {
      context,
      event
    });

    if (!me.isDestroyed) {
      me.reset();
    }
  } //endregion
  //region Handles
  // /**
  //  * Constrain resize to outerElements bounds
  //  * @private
  //  * @param x
  //  * @returns {*}
  //  */
  // constrainResize(x) {
  //     const me = this;
  //
  //     if (me.outerElement) {
  //         const box = me.outerElement.getBoundingClientRect();
  //         if (x < box.left) x = box.left;
  //         if (x > box.right) x = box.right;
  //     }
  //
  //     return x;
  // }

  /**
   * Highlights handles (applies css that changes cursor).
   * @private
   */


  highlightHandle() {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(me.currentElement, me.targetSelector) : me.currentElement; // over a handle, add cls to change cursor

    me.currentElement.classList.add('b-resize-handle');
    target.classList.add('b-over-resize-handle');
  }
  /**
   * Unhighlight handles (removes css).
   * @private
   */


  unHighlightHandle() {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(me.currentElement, me.targetSelector) : me.currentElement;
    target && target.classList.remove('b-over-resize-handle');
    me.currentElement.classList.remove('b-resize-handle');
    me.currentElement = null;
  }

  overAnyHandle(event, target) {
    return this.overStartHandle(event, target) || this.overEndHandle(event, target);
  }

  overStartHandle(event, target) {
    return this.direction === 'horizontal' ? this.overLeftHandle(event, target) : this.overTopHandle(event, target);
  }

  overEndHandle(event, target) {
    return this.direction === 'horizontal' ? this.overRightHandle(event, target) : this.overBottomHandle(event, target);
  }

  getDynamicHandleSize(opposite, offsetWidth) {
    const handleCount = opposite ? 2 : 1,
          {
      handleSize
    } = this; // Shrink handle size when configured to do so, preserving reserved space between handles

    if (this.dynamicHandleSize && handleSize * handleCount > offsetWidth - this.reservedSpace) {
      return Math.max(Math.floor((offsetWidth - this.reservedSpace) / handleCount), 0);
    }

    return handleSize;
  }
  /**
   * Check if over left handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  overLeftHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target;

    if (me.leftHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const leftHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      leftHandle.width = me.getDynamicHandleSize(me.rightHandle, offsetWidth);
      return leftHandle.width > 0 && leftHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over right handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  overRightHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target;

    if (me.rightHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const rightHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      rightHandle.x = rightHandle.right - me.getDynamicHandleSize(me.leftHandle, offsetWidth);
      return rightHandle.width > 0 && rightHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over top handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over top handle, otherwise false
   */


  overTopHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target;

    if (me.topHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const topHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      topHandle.height = me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
      return topHandle.height > 0 && topHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over bottom handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over bottom handle, otherwise false
   */


  overBottomHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target;

    if (me.bottomHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const bottomHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      bottomHandle.y = bottomHandle.bottom - me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
      return bottomHandle.height > 0 && bottomHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  } //endregion


}
ResizeHelper._$name = 'ResizeHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeMonitor.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/ResizeMonitor.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeMonitor; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';
/* globals ResizeObserver: true */




let resizeFireTimer = null;

const resizedQueue = [],
      isAbsolutelyPositioned = n => {
  var _n$ownerDocument$defa;

  return n.nodeType === n.ELEMENT_NODE && ((_n$ownerDocument$defa = n.ownerDocument.defaultView) === null || _n$ownerDocument$defa === void 0 ? void 0 : _n$ownerDocument$defa.getComputedStyle(n).getPropertyValue('position')) === 'absolute';
};
/**
 * @module Core/helper/ResizeMonitor
 */

/**
 * Allows size monitoring of elements (or optionally a Window instance).
 *
 * ```
 * ResizeMonitor.addResizeListener(
 *   myElement,
 *   element => {
 *      console.log(element, ' changed size');
 *   }
 * );
 * ```
 *
 * @internal
 */


class ResizeMonitor {
  /**
   * Adds a resize listener to the passed element which is called when the element
   * is resized by layout.
   * @param {HTMLElement} element The element to listen for resizing.
   * @param {Function} handler The handling function. Will be passed the element.
   */
  static addResizeListener(element, handler) {
    const me = this;

    if (element === document || element === window) {
      element = document.body;
    }

    if (element.nodeType === element.DOCUMENT_FRAGMENT_NODE) {
      element = element.host;
    }

    if (!element.classList.contains('b-resize-monitored')) {
      element.classList.add('b-resize-monitored');
      element._bResizemonitor = {
        handlers: []
      };
    } // If we're looking at the document, or body, use a window resize listener.


    if (element === document.body) {
      if (!me.hasWindowResizeListener) {
        // Throttle the reaction to window resize to only fire once every 100ms
        window.addEventListener('resize', me.onWindowResize);
        me.hasWindowResizeListener = true;
      }
    } // Regular element - use ResizeObserver by preference
    else if (window.ResizeObserver) {
      if (!me.resizeObserver) {
        me.resizeObserver = new ResizeObserver(me.onElementResize);
      }

      me.resizeObserver.observe(element);
    } // Polyfill ResizeObserver
    else {
      element.classList.add('b-no-resizeobserver');
      const [monitors, expand, shrink] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: element,
        className: 'b-resize-monitors',
        children: [{
          className: 'b-resize-monitor-expand'
        }, {
          className: 'b-resize-monitor-shrink'
        }]
      }, true);
      expand.scrollLeft = expand.scrollTop = shrink.scrollLeft = shrink.scrollTop = 1000000;
      expand.addEventListener('scroll', me.onSizeMonitorScroll, true);
      shrink.addEventListener('scroll', me.onSizeMonitorScroll, true); // Also need to fake a resize-scroll on DOM mutation

      (handler.targetMutationMonitor = new MutationObserver(m => {
        const changedNodes = [];

        for (const mr of m) {
          if (mr.type === 'childList') {
            changedNodes.push.apply(changedNodes, mr.removedNodes);
            changedNodes.push.apply(changedNodes, mr.addedNodes);
          }
        } // If the changed nodes were absolutely positioned, then they won't
        // cause a resize, so return


        if (changedNodes.length > 0 && changedNodes.every(isAbsolutelyPositioned)) {
          return;
        } // HACK!
        // Although expand should be `b-resize-monitor-expand` element, id Edge 18 it might not be the case.
        // SimpleEventEditor.t.js in Scheduler shows this when you dragcreate event. At some point real expand element
        // get removed from DOM and we get smth like `b-sch-event-content` here, which is totally different element.
        // Reference is the same, it passes === check! So this is a sanity check to not trigger resizes when element
        // is incorrect.


        if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) && !expand.classList.contains('b-resize-monitor-expand')) {
          return;
        } // We only want the size monitor listener to trigger, so this event must NOT bubble
        // to any application or other framework listeners.


        expand.dispatchEvent(new CustomEvent('scroll', {
          bubbles: false
        }));
      })).observe(element, {
        childList: true,
        subtree: true
      }); // store reference for easier cleanup later

      handler.monitorElement = monitors;
    }

    element._bResizemonitor.handlers.push(handler);
  }
  /**
   * Removes a resize listener from the passed element.
   * @param {HTMLElement} element The element to listen for resizing.
   * @param {Function} handler The handling function to remove.
   */


  static removeResizeListener(element, handler) {
    if (element) {
      if (element === document || element === window) {
        element = document.body;
      }

      const resizeMonitor = element._bResizemonitor;
      let listenerCount = 0;

      if (resizeMonitor && resizeMonitor.handlers) {
        _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(resizeMonitor.handlers, handler); // See if we should unobserve the element

        listenerCount = resizeMonitor.handlers.length;
      } // Down to no listeners.


      if (!listenerCount) {
        element.classList.remove('b-resize-monitored');

        if (this.resizeObserver) {
          this.resizeObserver.unobserve(element);
        } // Remove the polyfill resize listeners
        else {
          // remove any added elements
          if (handler.monitorElement) {
            handler.monitorElement.remove();
            handler.monitorElement = null;
          } // remove the DOM mutation observer


          if (handler.targetMutationMonitor) {
            handler.targetMutationMonitor.disconnect();
          }
        }
      }
    }
  }

  static onElementResize(entries) {
    for (const resizeObserverEntry of entries) {
      const resizedElement = resizeObserverEntry.target,
            resizeMonitor = resizedElement._bResizemonitor,
            newRect = resizeObserverEntry.contentRect || resizedElement.getBoundingClientRect();

      if (resizedElement.offsetParent) {
        if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
          const oldRect = resizeMonitor.rectangle;
          resizeMonitor.rectangle = newRect;

          for (const resizeHandler of resizeMonitor.handlers) {
            resizeHandler(resizedElement, oldRect, newRect);
          }
        }
      }
    }
  }

  static onSizeMonitorScroll(e) {
    var _document$body;

    // If no body exists or the element has gone, ignore the event; the listener will be removed automatically.
    if ((_document$body = document.body) !== null && _document$body !== void 0 && _document$body.contains(e.target)) {
      e.stopImmediatePropagation();
      const monitorNode = e.target.parentNode,
            resizedElement = monitorNode.parentNode,
            resizeMonitor = resizedElement._bResizemonitor,
            newRect = resizedElement.getBoundingClientRect();

      if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
        resizedQueue.push([resizedElement, resizeMonitor.rectangle, newRect]);
        resizeMonitor.rectangle = newRect;

        if (!resizeFireTimer) {
          resizeFireTimer = requestAnimationFrame(ResizeMonitor.fireResizeEvents);
        }
      }

      monitorNode.firstChild.scrollLeft = monitorNode.firstChild.scrollTop = monitorNode.childNodes[1].scrollTop = monitorNode.childNodes[1].scrollLeft = 1000000;
    }
  }

  static onWindowResize(e) {
    const resizedElement = document.body,
          resizeMonitor = resizedElement._bResizemonitor,
          oldRect = resizeMonitor.rectangle;
    resizeMonitor.rectangle = document.documentElement.getBoundingClientRect();

    for (const resizeHandler of resizeMonitor.handlers) {
      resizeHandler(resizedElement, oldRect, resizeMonitor.rectangle);
    }
  }

  static fireResizeEvents() {
    for (const resizedEntry of resizedQueue) {
      for (const resizeHandler of resizedEntry[0]._bResizemonitor.handlers) {
        // Checking offsetParent to avoid resizing of elements which are not visible or exist in DOM
        if (resizedEntry[0].offsetParent) {
          resizeHandler.apply(this, resizedEntry);
        }
      }
    }

    resizeFireTimer = null;
    resizedQueue.length = 0;
  }

}
ResizeMonitor._$name = 'ResizeMonitor';

/***/ }),

/***/ "./lib/Core/helper/StringHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/StringHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringHelper; });
/* harmony import */ var _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt'; // IMPORTANT - adding imports here can create problems for Base class


/**
 * @module Core/helper/StringHelper
 */

let charsToEncode, entitiesToDecode, htmlEncodeRe, htmlDecodeRe;

const camelLettersRe = /([a-z])([A-Z])/g,
      crlfRe = /[\n\r]/g,
      escapeRegExpRe = /[.*+?^${}()|[\]\\]/g,
      // same as NPM escape-string-regexp
htmlRe = /[&<]/,
      idRe = /(^[^a-z]+[^\w]+)/gi,
      whiteSpaceRe = /\s+/,
      htmlDecoder = (m, captured) => entitiesToDecode[captured.toLowerCase()] || String.fromCharCode(parseInt(captured.substr(2), 10)),
      htmlEncoder = (m, captured) => charsToEncode[captured],
      hyphenateCamelLetters = (all, g1, g2) => {
  return `${g1}-${g2.toLowerCase()}`;
},
      separateCamelLetters = (all, g1, g2) => {
  return `${g1} ${g2.toLowerCase()}`;
},
      replaceNonIdChar = c => {
  if (c) {
    return `_x${[...c].map(ch => ch.charCodeAt(0).toString(16)).join('')}`;
  }

  return '__blank__';
},
      hyphenateCache = {},
      separatedCache = {};
/**
 * Helper for string manipulation.
 */


class StringHelper {
  //region Transform

  /**
   * Capitalizes the first letter of a string, "myString" -> "MyString".
   * @param {String} string The string to capitalize
   * @returns {String} The capitalized string or the value of `string` if falsy.
   * @category String formatting
   */
  static capitalize(string) {
    return string && string[0].toUpperCase() + string.substr(1);
  }
  /**
   * Capitalizes the first letter of a string, "myString" -> "MyString".
   * If the parameter is falsy, `null` is returned.
   * @param {String} string The string to capitalize
   * @returns {String} The capitalized string or `null` if `string` is falsy.
   * @deprecated 4.0 Use {@link #function-capitalize} instead.
   * @category String formatting
   */


  static capitalizeFirstLetter(string) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `capitalize()`, will be removed in 5.0');
    return string ? string[0].toUpperCase() + string.substr(1) : null;
  }
  /**
   * Makes the first letter of a string lowercase, "MyString" -> "myString".
   * If the parameter is falsy, `null` is returned.
   * @param {String} string The string to lowercase.
   * @returns {String} The lowercased string or `null` if `string` is falsy.
   * @deprecated 4.0 Use {@link #function-uncapitalize} instead.
   * @category String formatting
   */


  static lowercaseFirstLetter(string) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `uncapitalize()`, will be removed in 5.0');

    if (!string) {
      return null;
    }

    return string[0].toLowerCase() + string.substr(1);
  }
  /**
   * Makes the first letter of a string lowercase, "MyString" -> "myString".
   * @param {String} string The string to un-capitalize.
   * @returns {String} The un-capitalized string or the value of `string` if falsy.
   * @category String formatting
   */


  static uncapitalize(string) {
    return string && string[0].toLowerCase() + string.substr(1);
  }
  /**
   * Converts the passed camelCased string to a hyphen-separated string. eg "minWidth" -> "min-width"
   * @param {String} string The string to convert.
   * @return {String} The string with adjoining lower and upper case letters
   * separated by hyphens and converted to lower case.
   * @category String formatting
   * @internal
   */


  static hyphenate(string) {
    // Cached since it is used heavily with DomHelper.sync()
    const cached = hyphenateCache[string];

    if (cached) {
      return cached;
    }

    return hyphenateCache[string] = string.replace(camelLettersRe, hyphenateCamelLetters);
  }
  /**
   * Converts the passed camelCased string to a capitalized, space-separated string. eg "startDate" -> "Start date".
   * @param {String} string The string to convert.
   * @return {String} The string with spaces separating words.
   * @category String formatting
   * @internal
   */


  static separate(string) {
    // Cached since it may be used heavily
    const cached = separatedCache[string];

    if (cached) {
      return cached;
    }

    return separatedCache[string] = this.capitalize(string.replace(camelLettersRe, separateCamelLetters));
  }
  /**
   * Creates an alphanumeric identifier from any passed string. Encodes spaces and non-alpha characters.
   * @param {String} inString The string from which to strip non-identifier characters.
   * @return {String}
   * @category Misc
   * @internal
   */


  static createId(inString) {
    return String(inString).replace(idRe, replaceNonIdChar);
  } //endregion
  //region Html


  static escapeRegExp(string, flags) {
    // $& means the whole matched string
    let ret = string.replace(escapeRegExpRe, '\\$&');

    if (flags !== undefined) {
      ret = new RegExp(ret, flags);
    }

    return ret;
  }
  /**
   * This method decodes HTML entities and returns the original HTML.
   *
   * See also {@link #function-encodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   */


  static decodeHtml(str) {
    return str && String(str).replace(htmlDecodeRe, htmlDecoder);
  }
  /**
   * This method encodes HTML entities and returns a string that can be placed in the document and produce the
   * original text rather than be interpreted as HTML. Using this method with user-entered values prevents those
   * values from executing as HTML (i.e., a cross-site scripting or "XSS" security issue).
   *
   * See also {@link #function-decodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   */


  static encodeHtml(str) {
    return str && String(str).replace(htmlEncodeRe, htmlEncoder);
  }
  /**
   * This method is similar to {@link #function-encodeHtml-static} except that `\n` and `\r` characters in the
   * given `str` are replaced by `<br>` tags _after_ first being encoded by {@link #function-encodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   * @internal
   */


  static encodeHtmlBR(str) {
    var _StringHelper$encodeH;

    return (_StringHelper$encodeH = StringHelper.encodeHtml(str)) === null || _StringHelper$encodeH === void 0 ? void 0 : _StringHelper$encodeH.replace(crlfRe, '<br>');
  }
  /**
   * Returns `true` if the provided `text` contains special HTML characters.
   * @param {String} text
   * @returns {Boolean}
   * @category HTML
   * @internal
   */


  static isHtml(text) {
    return typeof text === 'string' && htmlRe.test(text || '');
  }
  /**
   * Initializes HTML entities used by {@link #function-encodeHtml-static} and {@link #function-decodeHtml-static}.
   * @param {Object} [mappings] An object whose keys are characters that should be encoded and values are the HTML
   * entity for the character.
   * @private
   */


  static initHtmlEntities(mappings) {
    mappings = mappings || {
      '&': '&amp;',
      '>': '&gt;',
      '<': '&lt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    const chars = Object.keys(mappings); // Maps '<' to '&lt;'

    charsToEncode = mappings; // Inverts the mapping so we can convert '&lt;' to '<'

    entitiesToDecode = chars.reduce((prev, val) => {
      prev[mappings[val]] = val;
      return prev;
    }, {}); // Creates a regex char set like /([<&>])/g to match the characters that need to be encoded (escaping any of
    // the regex charset special chars '[', ']' and '-'):

    htmlEncodeRe = new RegExp(`([${chars.map(c => '[-]'.includes(c) ? '\\' + c : c).join('')}])`, 'g'); // Creates a regex like /(&lt;|&amp;|&gt;)/ig to match encoded entities... good news is that (valid) HTML
    // entities do not contain any regex special characters:

    htmlDecodeRe = new RegExp(`(${Object.values(mappings).join('|')}|&#[0-9]+;)`, 'ig');
  } //endregion
  //region JSON

  /**
   * Parses JSON inside a try-catch block. Returns null if the string could not be parsed.
   *
   * @param {String} string String to parse
   * @returns {Object} Resulting object or null if parse failed
   * @category JSON
   */


  static safeJsonParse(string) {
    let parsed = null;

    try {
      parsed = JSON.parse(string);
    } catch (e) {}

    return parsed;
  }
  /**
   * Stringifies an object inside a try-catch block. Returns null if an exception is encountered.
   *
   * See [JSON.stringify on MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
   * for more information on the arguments.
   *
   * @param {Object} object The object to stringify
   * @param {Function|String[]|Number[]} [replacer] A function or array of string/number used to determine properties
   * to include in the JSON string
   * @param {String|Number} [space] Number of spaces to indent or string used as whitespace
   * @returns {Object} Resulting object or null if stringify failed
   * @category JSON
   */


  static safeJsonStringify(object, replacer = null, space = null) {
    let result = null;

    try {
      result = JSON.stringify(object, replacer, space);
    } catch (e) {}

    return result;
  } //endregion
  //region Split & join

  /**
   * Joins all given paths together using the separator as a delimiter and normalizes the resulting path.
   * @param paths {Array} array of paths to join
   * @param pathSeparator [{String}] path separator. Default value is '/'
   * @return {String}
   * @category Misc
   * @internal
   */


  static joinPaths(paths, pathSeparator = '/') {
    return paths.join(pathSeparator).replace(new RegExp('\\' + pathSeparator + '+', 'g'), pathSeparator);
  }
  /**
   * Returns the provided string split on whitespace. If the string is empty or consists of only whitespace, the
   * returned array will be empty. If `str` is not a string, it is simply returned. This allows `null` or already
   * split strings (arrays) to be passed through.
   *
   * For example:
   * ```
   *  console.log(StringHelper.split(' abc def xyz   '));
   *  > ['abc', 'def', 'xyz']
   *  console.log(StringHelper.split(''));
   *  > []
   * ```
   * Compare to the standard `split()` method:
   * ```
   *  console.log(' abc def xyz   '.split(/\s+/));
   *  > ['', 'abc', 'def', 'xyz', '']
   *  console.log(''.split(/\s+/));
   *  > ['']
   * ```
   * @param {String} str
   * @param {String|RegExp} delimiter
   * @returns {String[]}
   * @category Misc
   * @internal
   */


  static split(str, delimiter = whiteSpaceRe) {
    let ret = str;

    if (typeof ret === 'string') {
      ret = str.trim(); // w/o trim() whitespace on the ends will give us '' in the array

      ret = ret ? ret.split(delimiter) : []; // also ''.split() = ['']
    }

    return ret;
  } //endregion
  //region XSS

  /**
   * This is a tagged template function that performs HTML encoding on replacement values to avoid XSS (Cross-Site
   * Scripting) attacks.
   *
   * For example:
   *
   * ```javascript
   *  eventRenderer(eventRecord) {
   *      return StringHelper.xss`<span class="${eventRecord.attrib}">${eventRecord.name}</span>`;
   *  }
   * ```
   *
   * See {@link Core.helper.StringHelper#function-encodeHtml-static}.
   */


  static xss(strings, ...values) {
    const buf = [];
    let i = values.length;
    buf[i] = strings[i];

    while (i-- > 0) {
      buf[i] = strings[i] + StringHelper.encodeHtml(values[i]);
    }

    return buf.join('');
  }
  /**
   * This is a tagged template function that performs HTML encoding on replacement values to avoid XSS (Cross-Site
   * Scripting) attacks. Unlike {@link Core.helper.StringHelper#function-xss-static}, this method converts `\n` and
   * `\r` characters into `<br>` tags.
   *
   * For example:
   *
   * ```javascript
   *  eventRenderer(eventRecord) {
   *      return StringHelper.xssBR`<span class="${eventRecord.attrib}">${eventRecord.name}</span>`;
   *  }
   * ```
   *
   * See {@link Core.helper.StringHelper#function-encodeHtmlBR-static}.
   * @internal
   */


  static xssBR(strings, ...values) {
    const buf = [];
    let i = values.length;
    buf[i] = strings[i];

    while (i-- > 0) {
      buf[i] = strings[i] + StringHelper.encodeHtmlBR(values[i]);
    }

    return buf.join('');
  } //endregion


}
StringHelper.initHtmlEntities();
StringHelper._$name = 'StringHelper';

/***/ }),

/***/ "./lib/Core/helper/TemplateHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/TemplateHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateHelper; });
var productName = 'gantt';
/**
* @module Core/helper/TemplateHelper
*/

const tagSpaceRe = />[ \t\r\n]+</g,
      multiSpaceRe = /\s\s+/g;
/**
 * Helper for template strings, use as tag function
 * @example
 * TemplateHelper.tpl`...`
 * @internal
 */

class TemplateHelper {
  /**
   * Tag function for template literals that does some basic cleanup
   * @private
   */
  static tpl(strings, ...values) {
    let count = 0,
        output = values.map((val, i) => {
      // TODO: pad output nicely instead of just trimming away
      let ret = strings[i];

      if (Array.isArray(val)) {
        ret += val.reduce((ack, item) => ack += (typeof item === 'string' ? item.trim() : item) + '\n', '');
      } else {
        if (val === undefined) {
          val = '';
        }

        ret += typeof val === 'string' ? val.trim() : val;
      }

      count++;
      return ret;
    }).join('');

    if (count <= strings.length) {
      output += strings[strings.length - 1];
    } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
    // matches non-breaking spaces which need to be preserved.
    // Also reduce any usage of multiple spaces to single, since they have no value in html


    return output.replace(tagSpaceRe, '><').replace(multiSpaceRe, ' ').trim();
  }
  /**
   * Tag function for template literals that does some basic cleanup. Version for docs that do not remove blank space,
   * to keep code snippets formatting intact.
   * @private
   */


  static docsTpl(strings, ...values) {
    let count = 0,
        output = values.map((val, i) => {
      // TODO: pad output nicely instead of just trimming away
      let str = strings[i],
          ret = str;

      if (Array.isArray(val)) {
        ret += val.reduce((ack, item) => ack += (typeof item === 'string' ? item.trim() : item) + '\n', '');
      } else {
        if (val === undefined) {
          val = '';
        }

        ret += typeof val === 'string' ? val.trim() : val;
      }

      count++;
      return ret;
    }).join('');

    if (count <= strings.length) {
      output += strings[strings.length - 1];
    } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
    // matches non-breaking spaces which need to be preserved.


    return output.replace(tagSpaceRe, '><').trim();
  }

  static repeat(times) {
    return function (...args) {
      return TemplateHelper.tpl(...args).repeat(times);
    };
  }

  static loop(times) {}

}
TemplateHelper._$name = 'TemplateHelper';

/***/ }),

/***/ "./lib/Core/helper/VersionHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/VersionHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VersionHelper; });
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';

/**
 * @module Core/helper/VersionHelper
 */

let isSiesta = false;

try {
  isSiesta = Boolean(_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.parent && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.parent.Siesta || typeof process !== 'undefined' && (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.StartTest || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.Siesta));
} catch (e) {} // Set Default to hoverable device for our tests to run reliably


if (isSiesta) {
  _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"]._isHoverableDevice = true;
}
/**
 * Helper for version handling
 * @private
 * @example
 *
 * VersionHelper.setVersion('grid', '1.5');
 *
 * if (VersionHelper.getVersion('grid').isNewerThan('1.0')) {
 *   ...
 * }
 */


class VersionHelper {
  /**
   * Set version for specified product
   * @private
   * @param {String} product
   * @param {String} version
   */
  static setVersion(product, version) {
    product = product.toLowerCase();
    VH[product] = {
      version,

      isNewerThan(otherVersion) {
        return otherVersion < version;
      },

      isOlderThan(otherVersion) {
        return otherVersion > version;
      }

    };
    let bundleFor = ''; // Var productName is only defined in bundles, it is internal to bundle so not available on window. Used to
    // tell importing combinations of grid/scheduler/gantt bundles apart from loading same bundle twice
    // eslint-disable-next-line no-undef

    if (typeof productName !== 'undefined') {
      // eslint-disable-next-line no-undef
      bundleFor = productName;
    } // Set "global" flag to detect bundle being loaded twice


    const globalKey = `${bundleFor}.${product}${version.replace(/\./g, '-')}`;

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBrowserEnv && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.bryntum.silenceBundleException) {
      if (window.bryntum[globalKey] === true) {
        if (isSiesta) {
          window.BUNDLE_EXCEPTION = true;
        } else {
          throw new Error('Bryntum bundle included twice, check cache-busters and file types (.js).\n' + 'Simultaneous imports from "*.module.js" and "*.umd.js" bundles are not allowed.');
        }
      } else {
        window.bryntum[globalKey] = true;
      }
    }
  }
  /**
   * Get (previously set) version for specified product
   * @private
   * @param {String} product
   */


  static getVersion(product) {
    product = product.toLowerCase();

    if (!VH[product]) {
      throw new Error('No version specified! Please check that you import VersionHelper right into the class from where you call `deprecate` function.');
    }

    return VH[product].version;
  }
  /**
   * Checks the passed product against the passed version using the passed test.
   * @param {String} product The name of the product to test the version of
   * @param {String} version The version to test against
   * @param {String} test The test operator, `<=`, `<`, `=`, `>` or `>=`.
   * @returns {Boolean} `true` if the test passes.
   * @internal
   */


  static checkVersion(product, version, test) {
    const productVersion = VH.getVersion(product);
    let result;

    switch (test) {
      case '<':
        result = productVersion < version;
        break;

      case '<=':
        result = productVersion <= version;
        break;

      case '=':
        result = productVersion === version;
        break;

      case '>=':
        result = productVersion >= version;
        break;

      case '>':
        result = productVersion > version;
        break;
    }

    return result;
  }
  /**
   * Based on a comparison of current product version and the passed version this method either outputs a console.warn
   * or throws an error.
   * @param {String} product The name of the product
   * @param {String} invalidAsOfVersion The version where the offending code is invalid (when any compatibility layer
   * is actually removed).
   * @param {String} message Required! A helpful warning message to show to the developer using a deprecated API.
   * @internal
   */


  static deprecate(product, invalidAsOfVersion, message) {
    const justWarn = VH.checkVersion(product, invalidAsOfVersion, '<');

    if (justWarn) {
      // During the grace period (until the next major release following the deprecated code), just show a console warning
      console.warn(`Deprecation warning: You are using a deprecated API which will change in v${invalidAsOfVersion}. ${message}`);
    } else {
      throw new Error(`Deprecated API use. ${message}`);
    }
  }
  /**
   * Returns truthy value if environment is in testing mode.
   * @returns {Boolean}
   * @internal
   **/


  static get isTestEnv() {
    return isSiesta;
  }

  static get isDebug() {
    let result = false;
    return result;
  }

}
const VH = VersionHelper;

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBrowserEnv) {
  (window.bryntum || (window.bryntum = {})).getVersion = VH.getVersion.bind(VH);
  window.bryntum.checkVersion = VH.checkVersion.bind(VH);
  window.bryntum.deprecate = VH.deprecate.bind(VH);
  window.bryntum.isTestEnv = VH.isTestEnv;
}

VersionHelper._$name = 'VersionHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/process/browser.js */ "../node_modules/process/browser.js")))

/***/ }),

/***/ "./lib/Core/helper/WalkHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/WalkHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WalkHelper; });
var productName = 'gantt';
/**
* @module Core/helper/WalkHelper
*/

/**
 * Tree walking helper
 * @internal
 */

class WalkHelper {
  /**
   * Pre-walks any hierarchical data structure
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */
  static preWalk(data, childrenFn, fn) {
    const walkStack = [data];
    let node, children;

    while (walkStack.length) {
      node = walkStack.pop();
      fn(node);
      children = childrenFn(node);

      if (children) {
        walkStack.push.apply(walkStack, children.slice().reverse());
      }
    }
  }
  /**
   * Pre-walks any hierarchical data structure, passing along a link to the parent node
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry, called with `parent` and `node`
   */


  static preWalkWithParent(data, childrenFn, fn) {
    const walkStack = [{
      node: data,
      parent: null
    }];

    while (walkStack.length) {
      const {
        parent,
        node
      } = walkStack.pop();
      fn(parent, node);
      const children = childrenFn(node);

      if (Array.isArray(children)) {
        walkStack.push(...children.slice().reverse().map(child => ({
          node: child,
          parent: node
        })));
      }
    }
  }
  /**
   * Pre-walk unordered.
   *
   * Like {@link #function-preWalk-static preWalk} but doesn't reverses children before walk,
   * thus children will be walked last child first - first child last
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */


  static preWalkUnordered(data, childrenFn, fn) {
    let walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];
      fn(node);
      children = childrenFn(node);

      if (children) {
        walkStack.splice(walkStack.length - 1, 1, ...children);
      } else {
        walkStack.length = walkStack.length - 1;
      }
    }
  }
  /**
   * Post-walks any hierarchical data structure
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */


  static postWalk(data, childrenFn, fn) {
    let visited = new Map(),
        walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];

      if (visited.has(node)) {
        fn(node);
        walkStack.pop();
      } else {
        children = childrenFn(node);

        if (children) {
          walkStack = walkStack.concat(children.slice().reverse());
        }

        visited.set(node, node);
      }
    }
  }
  /**
   * Pre/Post-walks any hierarchical data structure calling inFn each node when it walks in,
   * and outFn when it walks out.
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} inFn  Function to call on each entry upon enter
   * @param {Function} outFn Function to call on each entry upon exit
   */


  static prePostWalk(data, childrenFn, inFn, outFn) {
    let visited = new Map(),
        walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];

      if (visited.has(node)) {
        outFn(node);
        walkStack.pop();
      } else {
        inFn(node);
        children = childrenFn(node);

        if (children) {
          walkStack = walkStack.concat(children.slice().reverse());
        }

        visited.set(node, node);
      }
    }
  }

}
WalkHelper._$name = 'WalkHelper';

/***/ }),

/***/ "./lib/Core/helper/WidgetHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/WidgetHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetHelper; });
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");
var productName = 'gantt';





/**
 * @module Core/helper/WidgetHelper
 */

/**
 * Helper for creating widgets.
 */

class WidgetHelper {
  //region Querying

  /**
   * Returns the widget with the specified id.
   * @param {String} Id of widget to find
   * @returns {Core.widget.Widget} The widget if any
   * @category Querying
   */
  static getById(id) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].getById(id);
  }
  /**
   * Returns the Widget which owns the passed element (or event).
   * @param {HTMLElement|Event} element The element or event to start from
   * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
   * class name. Or a filter function which returns `true` for the required Widget.
   * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
   * match of the type parameter, or the element to stop at.
   * @returns {Core.widget.Widget} The found Widget or null.
   * @category Querying
   */


  static fromElement(element, type, limit) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromElement(element, type, limit);
  } //endregion
  //region Widgets

  /**
   * Create a widget.
   * @example
   * WidgetHelper.createWidget({
   *   type: 'button',
   *   icon: 'user',
   *   text: 'Edit user'
   * });
   * @param {Object} config Widget config
   * @returns {Object} The widget
   * @category Widgets
   */


  static createWidget(config = {}) {
    return config.isWidget ? config : _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(config);
  }
  /**
   * Appends a widget (array of widgets) to the DOM tree. If config is empty, widgets are appended to the DOM. To
   * append widget to certain position you can pass HTMLElement or its id as config, or as a config, that will be
   * applied to all passed widgets.
   *
   * Usage:
   *
   * ```javascript
   * // Will append button as last item to element with id 'container'
   * let [button] = WidgetHelper.append({ type : 'button' }, 'container');
   *
   * // Same as above, but will add two buttons
   * let [button1, button2] = WidgetHelper.append([
   *     { type : 'button' },
   *     { type : 'button' }
   *     ], { appendTo : 'container' });
   *
   * // Will append two buttons before element with id 'someElement'. Order will be preserved and all widgets will have
   * // additional class 'my-cls'
   * let [button1, button2] = WidgetHelper.append([
   *     { type : 'button' },
   *     { type : 'button' }
   *     ], {
   *         insertBefore : 'someElement',
   *         cls          : 'my-cls'
   *     });
   * ```
   *
   * @param {Object|Object[]} widget Widget config or array of such configs
   * @param {HTMLElement|String|Object} [config] Element (or element id) to which to append the widget or config to apply to all passed widgets
   * @returns {Core.widget.Widget[]} Array or widgets
   * @category Widgets
   */


  static append(widget, config) {
    widget = Array.isArray(widget) && widget || [widget];

    if (config instanceof HTMLElement || typeof config === 'string') {
      config = {
        appendTo: config
      };
    } // We want to fix position to insert into to keep order of passed widgets


    if (config.insertFirst) {
      const target = typeof config.insertFirst === 'string' ? document.getElementById(config.insertFirst) : config.insertFirst;

      if (target.firstChild) {
        config.insertBefore = target.firstChild;
      } else {
        config.appendTo = target;
      }
    }

    return widget.map(item => _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({}, config || {}, item)));
  } //endregion
  //region Popups

  /**
   * Shows a popup (~tooltip) containing widgets connected to specified element.
   * @example
   * WidgetHelper.openPopup(element, {
   *   position: 'bottom center',
   *   items: [
   *      { widgetConfig }
   *   ]
   * });
   * @param {HTMLElement} element Element to connect popup to
   * @param {Object} config Config object, or string to use as html in popup
   * @returns {*|{close, widgets}}
   * @category Popups
   */


  static openPopup(element, config) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
      forElement: element
    }, typeof config === 'string' ? {
      html: config
    } : config), 'popup');
  }
  /**
   * Shows a context menu connected to the specified element.
   * @example
   * WidgetHelper.showContextMenu(element, {
   *   items: [
   *      { id: 'addItem', icon: 'add', text: 'Add' },
   *      ...
   *   ],
   *   onItem: item => alert('Clicked ' + item.text)
   * });
   * @param {HTMLElement|Number[]} element Element (or a coordinate) to show the context menu for
   * @param {Object} config Context menu config, see example
   * @returns {*|{close}}
   * @category Popups
   */


  static showContextMenu(element, config) {
    const me = this;

    if (me.currentContextMenu) {
      me.currentContextMenu.destroy();
    }

    if (element instanceof HTMLElement) {
      config.forElement = element;
    } else if (Array.isArray(element)) {
      config.forElement = {
        target: new _util_Point_js__WEBPACK_IMPORTED_MODULE_4__["default"](...element)
      };
    } else if (element instanceof _util_Point_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
      config.forElement = {
        target: element
      };
    }

    me.currentContextMenu = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(config, 'menu');
    me.currentContextMenu.on('destroy', () => {
      me.currentContextMenu = null;
    });
    return me.currentContextMenu;
  }
  /**
   * Attached a tooltip to the specified element.
   * @example
   * WidgetHelper.attachTooltip(element, {
   *   text: 'Useful information goes here'
   * });
   * @param {HTMLElement} element Element to attach tooltip for
   * @param {String|Object} configOrText Tooltip config or tooltip string, see example and source
   * @returns {Object}
   * @category Popups
   */


  static attachTooltip(element, configOrText) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].attachTooltip(element, configOrText);
  }
  /**
   * Checks if element has tooltip attached
   *
   * @param {HTMLElement} element Element to check
   * @return {Boolean}
   * @category Popups
   */


  static hasTooltipAttached(element) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].resolveType('tooltip').hasTooltipAttached(element);
  }
  /**
   * Destroys any tooltip attached to an element, removes it from the DOM and unregisters any tip related listeners
   * on the element.
   *
   * @param {HTMLElement} element Element to remove tooltip from
   * @category Popups
   */


  static destroyTooltipAttached(element) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].resolveType('tooltip').destroyTooltipAttached(element);
  } //endregion
  //region Mask

  /**
   * Masks the specified element, showing a message in the mask.
   * @param {HTMLElement} element Element to mask
   * @param {String} msg Message to show in the mask
   * @category Mask
   */


  static mask(element, msg = 'Loading') {
    if (element) {
      // Config object normalization
      if (element instanceof HTMLElement) {
        element = {
          target: element,
          text: msg
        };
      }

      return _widget_Mask_js__WEBPACK_IMPORTED_MODULE_3__["default"].mask(element, element.target);
    }
  }
  /**
   * Unmask the specified element.
   * @param {HTMLElement} element
   * @category Mask
   */


  static unmask(element, close = true) {
    if (element.mask) {
      if (close) {
        element.mask.close();
      } else {
        element.mask.hide();
      }
    }
  } //endregion
  //region Toast

  /**
   * Show a toast
   * @param {String} msg message to show in the toast
   * @category Mask
   */


  static toast(msg) {
    return _widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__["default"].show(msg);
  } //endregion


}
WidgetHelper._$name = 'WidgetHelper';

/***/ }),

/***/ "./lib/Core/helper/XMLHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/XMLHelper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return XMLHelper; });
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';


/**
 * @module Core/helper/XMLHelper
 */

/**
 * Helper for XML manipulation.
 */

class XMLHelper {
  /**
   * Convert an javascript object to a XML string.
   *
   * From:
   * ```javascript
   * {
   *     name : 'Task 1',
   *     data : [
   *         {
   *             text : 'foo 1',
   *             ref  : 'fooItem 1'
   *         },
   *         {
   *             text : 'foo 2',
   *             ref  : 'fooItem 2'
   *         }
   *     ]
   * }
   * ```
   *
   * To:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8" standalone="yes"?>
   * <root>
   *     <name>Task 1</name>
   *     <data>
   *         <element>
   *             <text>foo 1</text>
   *             <ref>fooItem 1</ref>
   *         </element>
   *         <element>
   *             <text>foo 2</text>
   *             <ref>fooItem 2</ref>
   *         </element>
   *     </data>
   * </root>
   * ```
   *
   * @param {Object} obj Object to convert.
   * @param {Object} [options] Convert options.
   * @param {String} [options.rootName] Root name for the XML. `root` by default.
   * @param {String} [options.elementName] Element name for each node of the XML. `element` by default.
   * @param {String} [options.xmlns] Add value for xmlns property for the root tag of the XML.
   * @param {Boolean} [options.includeHeader] `false` to not include the header `<?xml version="1.0" encoding="UTF-8"?>` on top of the XML.
   * @param {Boolean} [options.rootElementForArray] `false` to not include a root element for array of items. e.g. for the above example:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8" standalone="yes"?>
   * <root>
   *     <name>Task 1</name>
   *     <element>
   *         <text>foo 1</text>
   *         <ref>fooItem 1</ref>
   *     </element>
   *     <element>
   *         <text>foo 2</text>
   *         <ref>fooItem 2</ref>
   *     </element>
   * </root>
   * ```
   * @returns {String} the XML
   */
  static convertFromObject(obj, options = {}) {
    // override default values
    _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].assignIf(options, {
      rootName: 'root',
      elementName: 'element',
      includeHeader: true,
      rootElementForArray: true
    });
    const {
      rootName,
      elementName,
      includeHeader,
      rootElementForArray
    } = options;
    let {
      xmlns
    } = options;
    xmlns = xmlns ? ` xmlns="${xmlns}"` : '';
    const header = includeHeader ? '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' : '';

    const converter = o => {
      const xmlItems = [];

      for (const key in o) {
        const item = o[key];

        if (Array.isArray(item)) {
          if (rootElementForArray) {
            xmlItems.push(`<${key}>`);
          }

          for (const subItem of item) {
            if (elementName.length) {
              xmlItems.push(`<${elementName}>`);
            } else {
              xmlItems.push(`<${key}>`);
            }

            xmlItems.push(converter(subItem));

            if (elementName.length) {
              xmlItems.push(`</${elementName}>`);
            } else {
              xmlItems.push(`</${key}>`);
            }
          }

          if (rootElementForArray) {
            xmlItems.push(`</${key}>`);
          }
        } else if (_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(item)) {
          xmlItems.push(`<${key}>${converter(item)}</${key}>`);
        } else {
          if (item == null) {
            xmlItems.push(`<${key}/>`);
          } else {
            xmlItems.push(`<${key}>${_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(item)}</${key}>`);
          }
        }
      }

      return xmlItems.join('');
    };

    return `${header}<${rootName}${xmlns}>${converter(obj)}</${rootName}>`;
  }

}
XMLHelper._$name = 'XMLHelper';

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperContainer.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperContainer.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


 // TODO: Use mousedown pos and not center too reposition

/**
 * @module Core/helper/mixin/DragHelperContainer
 */

/**
 * Mixin for DragHelper that handles dragging elements between containers (or rearranging within)
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DragHelperContainer extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DragHelperContainer';
  } //region Init

  /**
   * Initialize container drag mode.
   * @private
   */


  initContainerDrag() {
    const me = this; //use container drag as default mode

    if (!me.mode) me.mode = 'container';
    if (me.mode === 'container' && !me.containers) throw new Error('Container drag mode must specify containers');
  } //endregion
  //region Grab, update, finish

  /**
   * Grab an element which can be dragged between containers.
   * @private
   * @param event
   * @returns {Boolean}
   */


  grabContainerDrag(event) {
    const me = this; // allow specified selectors to prevent drag

    if (!me.ignoreSelector || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, me.ignoreSelector)) {
      // go up from "handle" to draggable element
      const element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getAncestor(event.target, me.containers, me.outerElement);

      if (element) {
        const box = element.getBoundingClientRect();
        me.context = {
          element,
          valid: true,
          action: 'container',
          offsetX: event.pageX - box.left,
          offsetY: event.pageY - box.top,
          originalPosition: {
            parent: element.parentElement,
            prev: element.previousElementSibling,
            next: element.nextElementSibling
          }
        };
      }

      return true;
    }

    return false;
  }
  /**
   * Starts dragging, called when mouse moves first time after grabbing
   * @private
   * @param event
   */


  startContainerDrag(event) {
    var _outerWidgetEl$parent;

    const {
      context,
      floatRootOwner
    } = this,
          {
      element: dragElement
    } = context,
          clonedNode = dragElement.cloneNode(true),
          box = dragElement.getBoundingClientRect(),
          outerWidgetEl = floatRootOwner === null || floatRootOwner === void 0 ? void 0 : floatRootOwner.element.closest('.b-outer'); // init drag proxy

    clonedNode.classList.add(this.dragProxyCls);
    clonedNode.classList.add(this.draggingCls); // Append drag proxy to float root, fall back to root context node

    ((floatRootOwner === null || floatRootOwner === void 0 ? void 0 : floatRootOwner.floatRoot) || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getRootElement(dragElement)).appendChild(clonedNode);
    context.dragProxy = clonedNode; // Always set the proxy element width manually, drag target could be sized with flex or % width

    clonedNode.style.width = box.width + 'px';
    clonedNode.style.height = box.height + 'px';
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(context.dragProxy, box.left, box.top); // style dragged element

    context.dragging = dragElement;
    dragElement.classList.add(this.dropPlaceholderCls); // If element being dragged is also a child of the float root, add +1 to the cloned node z-index

    if (outerWidgetEl !== null && outerWidgetEl !== void 0 && (_outerWidgetEl$parent = outerWidgetEl.parentElement) !== null && _outerWidgetEl$parent !== void 0 && _outerWidgetEl$parent.matches('.b-float-root')) {
      clonedNode.style.zIndex = floatRootOwner.floatRootMaxZIndex + 1;
    }
  }
  /**
   * Move the placeholder element into its new position on valid drag.
   * @private
   * @param event
   */


  updateContainerDrag(event) {
    const me = this,
          context = me.context;
    if (!context.started || !context.targetElement) return;
    const containerElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getAncestor(context.targetElement, me.containers, 'b-gridbase'),
          willLoseFocus = context.dragging && context.dragging.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(context.dragging));

    if (containerElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isDescendant(context.element, containerElement)) {
      // dragging over part of self, do nothing
      return;
    } // The dragging element contains focus, and moving it within the DOM
    // will cause focus loss which might affect an encapsulating autoClose Popup.
    // Prevent focus loss handling during the DOM move.


    if (willLoseFocus) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].suspendFocusEvents();
    }

    if (containerElement && context.valid) {
      me.moveNextTo(containerElement, event);
    } else {
      // dragged outside of containers, revert position
      me.revertPosition();
    }

    if (willLoseFocus) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].resumeFocusEvents();
    }

    event.preventDefault();
  }
  /**
   * Finalize drag, fire drop.
   * @private
   * @param event
   * @fires drop
   */


  finishContainerDrag(event) {
    const me = this,
          context = me.context,
          // extracting variables to make code more readable
    {
      dragging,
      dragProxy,
      valid,
      draggedTo,
      insertBefore,
      originalPosition
    } = context;

    if (dragging) {
      // needs to have a valid target
      context.valid = valid && draggedTo && ( // no drop on self or parent
      dragging !== insertBefore || originalPosition.parent !== draggedTo);

      context.finalize = (valid = context.valid) => {
        // revert if invalid (and context still exists, might have been aborted from outside)
        if (!valid && this.context) {
          me.revertPosition();
        }

        dragging.classList.remove(me.dropPlaceholderCls);
        dragProxy.remove();
        me.reset();
      }; // allow async finalization by setting async to true on context in drop handler,
      // requires implementer to call context.finalize later to finish the drop


      context.async = false;
      me.trigger('drop', {
        context,
        event
      });

      if (!context.async) {
        // finalize immediately
        context.finalize();
      } else {
        context.awaitingFinalization = true;
      }
    }
  }
  /**
   * Aborts a drag operation.
   * @private
   * @param {Boolean} [invalid]
   * @param {Object} [event]
   * @param {Boolean} [silent]
   */


  abortContainerDrag(invalid = false, event = null, silent = false) {
    const me = this,
          context = me.context;

    if (context.dragging) {
      context.dragging.classList.remove(me.dropPlaceholderCls);
      context.dragProxy.remove();
      me.revertPosition();
      me.context = {};
    }

    if (!silent) {
      me.trigger(invalid ? 'drop' : 'abort', {
        context,
        event
      });
    }
  } //endregion
  //region Helpers

  /**
   * Starts a drag operation by creating a proxy and storing which element is being dragged.
   * @private
   */
  // startDrag() {
  //     const context = this.context,
  //           div      = context.element.cloneNode(true);
  //
  //     // init drag proxy
  //     div.classList.add('b-drag-proxy');
  //     document.body.appendChild(div);
  //     context.dragProxy = div;
  //
  //     // style dragged element
  //     context.dragging = context.element;
  //     context.dragging.classList.add('myClass');
  // }

  /**
   * Updates the drag proxy position.
   * @private
   * @param event
   */


  updateContainerProxy(event) {
    const me = this,
          context = me.context,
          proxy = context.dragProxy;
    let newX = event.pageX - context.offsetX,
        newY = event.pageY - context.offsetY;

    if (typeof me.minX === 'number') {
      newX = Math.max(me.minX, newX);
    }

    if (typeof me.maxX === 'number') {
      newX = Math.min(me.maxX - proxy.offsetWidth, newX);
    }

    if (typeof me.minY === 'number') {
      newY = Math.max(me.minY, newY);
    }

    if (typeof me.maxY === 'number') {
      newY = Math.min(me.maxY - proxy.offsetHeight, newY);
    }

    if (me.lockX) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateY(proxy, newY);
    } else if (me.lockY) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateX(proxy, newX);
    } else {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(proxy, newX, newY);
    }

    let targetElement;

    if (event.type === 'touchmove') {
      const touch = event.changedTouches[0];
      targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].elementFromPoint(touch.clientX, touch.clientY);
    } else {
      targetElement = event.target;
    }

    context.targetElement = targetElement;
  }
  /**
   * Positions element being dragged in relation to targetElement.
   * @private
   * @param targetElement
   * @param event
   */


  moveNextTo(targetElement, event) {
    const context = this.context,
          dragElement = context.dragging,
          parent = targetElement.parentElement;

    if (targetElement !== dragElement) {
      // dragged over a container and not over self, calculate where to insert
      const centerX = targetElement.getBoundingClientRect().left + targetElement.offsetWidth / 2;

      if (event.pageX < centerX) {
        // dragged left of target center, insert before
        parent.insertBefore(dragElement, targetElement);
        context.insertBefore = targetElement;
      } else {
        // dragged right of target center, insert after
        if (targetElement.nextElementSibling) {
          // check that not dragged to the immediate left of self. in such case, position should not change
          if (targetElement.nextElementSibling !== dragElement) {
            context.insertBefore = targetElement.nextElementSibling;
            parent.insertBefore(dragElement, targetElement.nextElementSibling);
          } else if (!context.insertBefore && dragElement.parentElement.lastElementChild !== dragElement) {
            // dragged left initially, should stay in place (checked in finishContainerDrag)
            // TODO: or flag as invalid drag? since no change...
            context.insertBefore = targetElement.nextElementSibling;
          }
        } else {
          parent.appendChild(dragElement);
          context.insertBefore = null;
        }
      }

      context.draggedTo = parent;
    }
  }
  /**
   * Moves element being dragged back to its original position.
   * @private
   */


  revertPosition() {
    const context = this.context,
          original = context.originalPosition; // revert to correct location

    if (original.next) {
      const isNoop = original.next && original.next.previousSibling === context.dragging || !original.next && context.dragging === original.parent.lastChild;

      if (!isNoop) {
        original.parent.insertBefore(context.dragging, original.next);
      }
    } else {
      original.parent.appendChild(context.dragging);
    } // no target container


    context.draggedTo = null;
  } //endregion


});

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperTranslate.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperTranslate.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';




/**
 * @module Core/helper/mixin/DragHelperTranslate
 */

const noScroll = {
  pageXOffset: 0,
  pageYOffset: 0
};
/**
 * Mixin for DragHelper that handles repositioning (translating) an element within its container
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DragHelperTranslate extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DragHelperTranslate';
  } //region Init

  /**
   * Initialize translation drag mode.
   * @private
   */


  initTranslateDrag() {
    const me = this;
    me.mode = me.mode || 'translateXY';

    if (!me.isElementDraggable && me.targetSelector) {
      me.isElementDraggable = element => _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, me.targetSelector);
    }
  } //endregion
  //region Grab, update, finish

  /**
   * Grab an element which can be moved using translation.
   * @private
   * @param event
   * @returns {Boolean}
   */


  grabTranslateDrag(event) {
    const me = this,
          element = me.getTarget(event);

    if (element) {
      me.context = {
        valid: true,
        action: me.mode,
        // translateX or translateXY...
        element,
        startPageX: event.pageX,
        startPageY: event.pageY,
        startClientX: event.clientX,
        startClientY: event.clientY
      };
      return true;
    }

    return false;
  }

  getTarget(event) {
    return _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, this.targetSelector);
  }
  /**
   * Start translating, called on first mouse move after dragging
   * @private
   * @param event
   */


  startTranslateDrag(event) {
    const me = this,
          context = me.context,
          {
      relatedElements
    } = context;
    let element = context.dragProxy || context.element;

    if (element && !context.started) {
      const grabbed = element,
            grabbedParent = element.parentElement,
            // When cloning an element to be dragged, we place it in BODY by default
      dragWithin = me.dragWithin = me.dragWithin || me.cloneTarget && document.body,
            outerElement = me.outerElement;

      if (me.cloneTarget) {
        const offsetX = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetX(element, dragWithin),
              offsetY = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetY(element, dragWithin),
              offsetWidth = element.offsetWidth,
              offsetheight = element.offsetHeight;
        element = me.createProxy(element); // Match the grabbed element's size and position.

        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, offsetX, offsetY);
        element.style.width = `${offsetWidth}px`;
        element.style.height = `${offsetheight}px`;
        element.classList.add(me.dragProxyCls);
        dragWithin.appendChild(element);
        grabbed.classList.add('b-drag-original');

        if (me.hideOriginalElement) {
          grabbed.classList.add('b-hidden');
        }
      }

      Object.assign(me.context, {
        // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
        element,
        // The original element upon which the mousedown event triggered a drag operation
        grabbed,
        // The parent of the original element where the pointerdown was detected - to be able to restore after an invalid drop
        grabbedParent,
        // The next sibling of the original element where the pointerdown was detected - to be able to restore after an invalid drop
        grabbedNextSibling: element.nextElementSibling,
        // elements position within parent element
        elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateX(element),
        elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateY(element),
        elementX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetX(element, dragWithin || outerElement),
        elementY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetY(element, dragWithin || outerElement),
        scrollX: 0,
        scrollY: 0,
        scrollManagerElementContainsDragProxy: !me.cloneTarget || dragWithin === outerElement
      });
      element.classList.add(me.draggingCls);

      if (dragWithin) {
        context.parentElement = element.parentElement;

        if (dragWithin !== element.parentElement) {
          dragWithin.appendChild(element);
        }

        me.updateTranslateProxy(event);
      }

      if (relatedElements) {
        relatedElements.forEach(r => {
          r.classList.add(me.draggingCls);
        });
      }
    }
  }
  /**
   * Limit translation to outer bounds and specified constraints
   * @private
   * @param element
   * @param x
   * @param y
   * @returns {{constrainedX: *, constrainedY: *}}
   */


  applyConstraints(element, x, y) {
    const me = this,
          dragWithin = me.dragWithin,
          {
      pageXOffset,
      pageYOffset
    } = dragWithin === document.body ? window : noScroll; // limit to outer elements edges

    if (dragWithin && me.constrain) {
      if (x < 0) x = 0;
      if (x + element.offsetWidth > dragWithin.scrollWidth) x = dragWithin.scrollWidth - element.offsetWidth;
      if (y < 0) y = 0;
      if (y + element.offsetHeight > dragWithin.scrollHeight) y = dragWithin.scrollHeight - element.offsetHeight;
    } // limit horizontally


    if (typeof me.minX === 'number') {
      x = Math.max(me.minX + pageXOffset, x);
    }

    if (typeof me.maxX === 'number') {
      x = Math.min(me.maxX + pageXOffset, x);
    } // limit vertically


    if (typeof me.minY === 'number') {
      y = Math.max(me.minY + pageYOffset, y);
    }

    if (typeof me.maxY === 'number') {
      y = Math.min(me.maxY + pageYOffset, y);
    }

    return {
      constrainedX: x,
      constrainedY: y
    };
  }
  /**
   * Update elements translation on mouse move.
   * @private
   * @param {MouseEvent} event
   * @param {Object} scrollManagerConfig
   */


  updateTranslateProxy(event, scrollManagerConfig) {
    const me = this,
          {
      mode,
      lockX,
      lockY
    } = me,
          context = me.context,
          element = context.dragProxy || context.element,
          {
      relatedElements,
      relatedElDragFromPos
    } = context; // If we are cloning the dragged element outside of the element(s) monitored by the ScrollManager, then no need
    // to take the scrollManager scroll values into account since it is only relevant when dragProxy is inside
    // the Grid (where scroll manager operates).

    if (context.scrollManagerElementContainsDragProxy && scrollManagerConfig) {
      context.scrollX = scrollManagerConfig.getRelativeLeftScroll(element);
      context.scrollY = scrollManagerConfig.getRelativeTopScroll(element);
    }

    context.pageX = event.pageX;
    context.pageY = event.pageY;
    context.clientX = event.clientX;
    context.clientY = event.clientY;
    let newX = context.elementStartX + event.pageX - context.startPageX + context.scrollX,
        newY = context.elementStartY + event.pageY - context.startPageY + context.scrollY; // First let outside world apply snapping

    if (me.snapCoordinates) {
      const snapped = me.snapCoordinates({
        element,
        newX,
        newY
      });
      newX = snapped.x;
      newY = snapped.y;
    } // Now constrain coordinates


    const {
      constrainedX,
      constrainedY
    } = me.applyConstraints(element, newX, newY);

    if (mode === 'translateXY' && !(lockX || lockY)) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, constrainedX, constrainedY);
    } else if (mode === 'translateX' || lockY) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(element, constrainedX);
    } else if (mode === 'translateY' || lockX) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(element, constrainedY);
    }

    if (relatedElements) {
      const deltaX = !lockX && mode !== 'translateY' ? constrainedX - context.elementStartX : 0,
            deltaY = !lockY && mode !== 'translateX' ? constrainedY - context.elementStartY : 0;
      relatedElements.forEach((r, i) => {
        const [x, y] = relatedElDragFromPos[i];
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(r, x + deltaX, y + deltaY);
      });
    }

    context.newX = constrainedX;
    context.newY = constrainedY;
  }
  /**
   * Finalize drag, fire drop.
   * @private
   * @param event
   * @fires drop
   */


  finishTranslateDrag(event) {
    const me = this,
          context = me.context,
          xChanged = Math.round(context.newX) !== Math.round(context.elementStartX),
          yChanged = Math.round(context.newY) !== Math.round(context.elementStartY),
          element = context.dragProxy || context.element,
          {
      relatedElements
    } = context;

    function cleanUp() {
      element.classList.remove(me.invalidCls);
      element.classList.remove(me.draggingCls);

      if (relatedElements) {
        relatedElements.forEach(r => {
          r.classList.remove(me.invalidCls);
          r.classList.remove(me.draggingCls);
        });
      } // If we're currently aborting, the b-hidden CSS class will be removed after animation is complete


      if (!element.classList.contains('b-aborting')) {
        if (me.hideOriginalElement) {
          context.grabbed.classList.remove('b-hidden');
        }

        context.grabbed.classList.remove('b-drag-original');
      }
    }

    if (!me.ignoreSamePositionDrop || me.mode !== 'translateY' && xChanged || me.mode !== 'translateX' && yChanged) {
      if (context.valid === false) {
        me.abortTranslateDrag(true, event);
      } else {
        const targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(me.dragWithin || me.outerElement);

        if (!me.minX && event.pageX < targetRect.left || !me.maxX && event.pageX > targetRect.right || !me.minY && event.pageY < targetRect.top || !me.maxY && event.pageY > targetRect.bottom) {
          // revert location when dropped outside allowed element
          context.valid = false;
          me.abortTranslateDrag(true, event);
        } else {
          context.finalize = (valid = context.valid) => {
            if (context.asyncCleanup) {
              cleanUp();
            } // abort if invalid (and context still exists, might have been aborted from outside)


            if (!valid && me.context) {
              // abort if flagged as invalid, without triggering abort or drop again
              me.abortTranslateDrag(true, null, true);
            } else if (me.cloneTarget || context.dragProxy) {
              element.remove();
            }

            me.reset();
          }; // allow async finalization by setting async to true on context in drop handler,
          // requires implementer to call context.finalize later to finish the drop


          context.async = false;
          me.trigger('drop', {
            context,
            event
          });

          if (!context.async) {
            // finalize immediately
            context.finalize();
          } else {
            context.awaitingFinalization = true;
          }
        }
      }

      if (!context.asyncCleanup) {
        cleanUp();
      }
    } else {
      // no change, abort but not as invalid
      me.abortTranslateDrag(false, event);
    }
  }
  /**
   * Abort translation
   * @private
   * @param invalid
   * @fires abort
   */


  abortTranslateDrag(invalid = false, event = null, silent = false) {
    const me = this,
          context = me.context,
          {
      relatedElements,
      relatedElStartPos,
      grabbed
    } = context,
          element = context.dragProxy || context.element,
          resetEl = me.cloneTarget && me.hideOriginalElement ? grabbed : element;
    let {
      elementStartX,
      elementStartY
    } = context;

    if (element && context.started) {
      // Put the dragged element back where it was
      if (!me.cloneTarget && me.dragWithin && me.dragWithin !== context.grabbedParent) {
        context.grabbedParent.insertBefore(element, context.grabbedNextSibling);
      }

      grabbed.classList.remove('b-hidden'); // Align the now visible grabbed element with the clone, so that it looks like it's
      // sliding back into place when the clone is removed

      if (me.cloneTarget) {
        if (me.hideOriginalElement) {
          [elementStartX, elementStartY] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateXY(grabbed);
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].alignTo(grabbed, element); // The getBoundingClientRect is important. The aligning above must be processed
          // by a forced synchronous layout *before* the b-aborting class is added below.

          resetEl.getBoundingClientRect();
        }

        element.remove();
      } // animated restore of position.


      resetEl.classList.add('b-aborting'); // Move the elements back to their original positions.

      if (me.mode === 'translateXY' && !(me.lockX || me.lockY)) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(resetEl, elementStartX, elementStartY);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, relatedElStartPos[i][0], relatedElStartPos[i][1]);
        });
      }

      if (me.mode === 'translateX' || me.lockY) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(resetEl, elementStartX);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(element, relatedElStartPos[i][0]);
        });
      }

      if (me.mode === 'translateY' || me.lockX) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(resetEl, elementStartY);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(element, relatedElStartPos[i][1]);
        });
      } // TODO change to EventHelper.onTransitionEnd


      me.setTimeout(() => {
        resetEl.classList.remove('b-aborting');
        grabbed.classList.remove('b-dragging');
        grabbed.classList.remove('b-drag-original');

        if (!me.cloneTarget) {
          relatedElements && relatedElements.forEach((element, i) => {
            element.classList.remove('b-aborting');
          });
          element.classList.remove('b-aborting');
          element.classList.remove(me.draggingCls);
          element.classList.remove(me.invalidCls);
        }
      }, me.transitionDuration, undefined, true);

      if (!silent) {
        me.trigger(invalid ? 'drop' : 'abort', {
          context,
          event
        });
      }
    }

    me.reset();
  } //endregion


});

/***/ }),

/***/ "./lib/Core/helper/util/DataGenerator.js":
/*!***********************************************!*\
  !*** ./lib/Core/helper/util/DataGenerator.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataGenerator; });
/* harmony import */ var _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';


/**
 * @module Core/helper/util/DataGenerator
 */

const lorem = ['Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.', 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui atione voluptatem sequi nesciunt.', 'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.', 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?', 'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?'];
/**
 * Generates a pseudo random data for Grid records.
 * Used to provide data in examples.
 */

class DataGenerator {
  //region Random
  static reset() {
    this.rnd.reset();
    this.rndTime.reset();
    this.rndRating.reset();
  } //endregion
  //region Generate data


  static *generate(count, randomHeight = false, initialId = 1) {
    const me = this,
          rnd = me.rnd,
          rndTime = me.rndTime,
          rndRating = me.rndRating,
          rndText = me.rndText,
          firstNames = me.firstNames,
          surNames = me.surNames,
          teams = me.teams,
          foods = me.foods,
          colors = me.colors,
          cities = me.cities;

    for (let i = 0; i < count; i++) {
      const firstName = rnd.fromArray(firstNames),
            surName = rnd.fromArray(surNames),
            name = `${firstName} ${String.fromCharCode(65 + i % 25)} ${surName}`,
            startDay = rnd.nextRandom(60) + 1,
            start = new Date(2019, 0, startDay),
            finish = new Date(2019, 0, startDay + rnd.nextRandom(30) + 2),
            row = {
        id: initialId > -1 ? i + initialId : undefined,
        title: 'Row ' + i,
        name: name,
        firstName: firstName,
        surName: surName,
        city: rnd.fromArray(cities),
        team: rnd.fromArray(cities) + ' ' + rnd.fromArray(teams),
        age: 10 + rnd.nextRandom(80),
        food: rnd.fromArray(foods),
        color: rnd.fromArray(colors),
        score: rnd.nextRandom(100) * 10,
        rank: rnd.nextRandom(100) + 1,
        start: start,
        finish: finish,
        time: _DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTime(rndTime.nextRandom(24), rndTime.nextRandom(12) * 5),
        percent: rnd.nextRandom(100),
        done: rnd.nextRandom(100) < 50,
        rating: rndRating.nextRandom(5),
        relatedTo: Math.min(count - 1, i + initialId + rnd.nextRandom(10)),
        notes: lorem[rndText.nextRandom(7) + 1]
      };

      if (randomHeight) {
        row.rowHeight = rnd.nextRandom(randomHeight === true ? 20 : randomHeight) * 5 + 20;
      }

      yield row;
    }
  }
  /**
   * Generates a pseudo random data for Grid records.
   * @param {Number} count number of records
   * @param {Boolean} randomHeight generate random row height
   * @param {Number} initialId row initial id. Set -1 to disable Id generation. Defaults to 1.
   * @param {Boolean} reset set true to ensure we get the same dataset on consecutive calls. Defaults to true
   * @return {Object[]} generated rows array
   */


  static generateData(count, randomHeight = false, initialId = 1, reset = true) {
    if (reset) this.reset();
    const rows = [],
          number = DataGenerator.overrideRowCount ? DataGenerator.overrideRowCount : count,
          generator = this.generate(number, randomHeight, initialId);

    for (let i = 0; i < number; i++) {
      rows.push(generator.next().value);
    }

    return rows;
  }
  /**
   * Generates a pseudo random data for Grid row.
   * @return {Object} generated row
   */


  static generateRow() {
    return DataGenerator.generateData(1, false, -1, false)[0];
  } //endregion


}
Object.assign(DataGenerator, {
  rnd: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndTime: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndRating: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndText: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  cities: ['Stockholm', 'Barcelona', 'Paris', 'Dubai', 'New York', 'San Francisco', 'Washington', 'Moscow'],
  firstNames: ['Mike', 'Linda', 'Don', 'Karen', 'Doug', 'Jenny', 'Daniel', 'Melissa', 'John', 'Jane', 'Theo', 'Lisa', 'Adam', 'Mary', 'Barbara', 'James', 'David'],
  surNames: ['McGregor', 'Ewans', 'Scott', 'Smith', 'Johnson', 'Adams', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'More', 'Wilson', 'Taylor', 'Anderson', 'Thomas', 'Jackson'],
  teams: ['Lions', 'Eagles', 'Tigers', 'Horses', 'Dogs', 'Cats', 'Panthers', 'Rats', 'Ducks', 'Cougars', 'Hens', 'Roosters'],
  foods: ['Pancake', 'Burger', 'Fish n chips', 'Carbonara', 'Taco', 'Salad', 'Bolognese', 'Mac n cheese', 'Waffles'],
  colors: ['Blue', 'Green', 'Red', 'Yellow', 'Pink', 'Purple', 'Orange', 'Teal', 'Black']
});
DataGenerator._$name = 'DataGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/DemoBot.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/DemoBot.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DemoBot; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';






const knownProps = ['action', 'target', 'to', 'deltaX', 'deltaY', 'x', 'y', 'text'];
class DemoBot extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"])()) {
  static get defaultConfig() {
    return {
      repeat: true,
      outerElement: document.body,
      callOnFunctions: true
    };
  } // expects an outer element (grid.element/scheduler.element) and an array of steps similar to chain steps in siesta


  construct(config) {
    super.construct(config);
    const me = this;

    if (me.widget) {
      me.outerElement = me.widget.element;
      me.widget.playingDemo = true;
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].playingDemo = true;
    Object.assign(me, {
      prevTarget: null,
      currentStep: 0,
      mouse: _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: me.outerElement,
        tag: 'div',
        className: 'simulated-mouse'
      }),
      timeoutId: null,
      innerIntervalId: null,
      mouseOutElements: []
    });
    me.intervalId = me.setInterval(me.nextStep.bind(me), 1000);
    me.outerElement.classList.add('b-playing-demo');
    me.outerElement.addEventListener('click', event => {
      if (event.isTrusted) {
        me.abort();
      }
    });
  }

  doDestroy() {
    this.abort();
  } // stops the bot


  abort(atEnd = false) {
    const me = this;
    me.mouse.style.top = '-100px';
    me.clearInterval(me.intervalId);
    me.timeoutId && me.clearTimeout(me.timeoutId);
    me.innerIntervalId && me.clearInterval(me.innerIntervalId);
    me.outerElement.classList.remove('b-playing-demo');

    if (me.widget) {
      me.widget.playingDemo = false;
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].playingDemo = false;
    me.trigger(atEnd ? 'done' : 'abort');
  } // triggers a synthetic event


  triggerEvent(element, type, data) {
    if (!element) return null;
    let event;

    if (type.startsWith('mouse')) {
      const box = this.mouse.getBoundingClientRect();
      event = new MouseEvent(type, Object.assign({
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: box.left,
        clientY: box.top
      }, data || {}));
    } else {
      event = document.createEvent('Event');
      event.initEvent(type, true, false);
    }

    element.dispatchEvent(event);
    return event;
  } // moves mouse to target in 10 steps, with animated transition between steps


  handleMouseMove(step, target) {
    const me = this,
          mouse = me.mouse;
    mouse.classList.add('quick');
    if (me.mouseDown) mouse.classList.add('drag');
    const mouseBox = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(mouse, me.outerElement),
          x = mouseBox.x,
          y = mouseBox.y;
    let deltaX = 0,
        deltaY = 0;

    if (step.to) {
      if (typeof step.to === 'string') {
        const toElement = me.outerElement.querySelector(step.to);

        if (toElement) {
          const rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(toElement, me.outerElement),
                toX = rect.x + rect.width / 2,
                toY = rect.y + rect.height / 2;
          deltaX = (toX - x) / 10;
          deltaY = (toY - y) / 10;
        }
      } else if (step.to.x) {
        deltaX = (step.to.x - x) / 10;
      } else {
        deltaX = step.to[0] / 10;
        deltaY = step.to[1] / 10;
      }
    } else if (step.deltaX) {
      deltaX = step.deltaX / 10;
    } else if (step.x) {
      deltaX = (step.x - x) / 10;
    }

    if (step.deltaY) {
      deltaY = step.deltaY / 10;
    }

    let i = 0;
    me.innerIntervalId = me.setInterval(() => {
      // Only move mouse if in view and not scrolling
      if (me.shouldPause) {
        return;
      }

      if (i++ === 9) {
        clearInterval(me.innerIntervalId);

        if (step.then) {
          step.then();
        }
      }

      const mouseX = x + deltaX * i,
            mouseY = y + deltaY * i; // Move mouse there also

      mouse.style.left = mouseX + 'px';
      mouse.style.top = mouseY + 'px';
      const mouseBounds = mouse.getBoundingClientRect(),
            clientX = mouseBounds.left,
            clientY = mouseBounds.top,
            eventTarget = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].elementFromPoint(clientX, clientY);

      if (eventTarget !== me.prevTarget) {
        if (me.prevTarget) {
          me.mouseOutElements.push(me.prevTarget);

          if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDescendant(me.mouseOutElements[0], eventTarget)) {
            me.mouseOutElements.forEach(element => me.triggerEvent(element, 'mouseout'));
            me.mouseOutElements.length = 0;
          }
        }

        me.prevTarget = eventTarget;
        me.triggerEvent(eventTarget, 'mouseover');
      }

      me.triggerEvent(eventTarget, step.action, {
        clientX,
        clientY
      });
    }, 50);
  } // target can be a string selector, a function or blank to use last target or outerElement if first time


  getTarget(step) {
    const me = this,
          target = step.target;

    if (!target) {
      return me.prevTarget || me.outerElement;
    }

    if (typeof target === 'function') {
      return target(step);
    }

    return document.querySelector(target);
  } // action can be a function, a string or extracted from a property by scanning for unknown names


  normalizeStep(step) {
    if (step.action) {
      if (typeof step.action === 'function') {
        return step.action(step);
      }

      return step;
    }

    if (typeof step === 'function') {
      step();
      return step;
    } // try to find action among properties


    for (const prop in step) {
      if (Object.hasOwnProperty.call(step, prop) && !knownProps.includes(prop)) {
        step.action = prop.toLowerCase();
        step.to = step[prop];
      }
    }

    if (!step.target && (typeof step.to === 'string' || typeof step.to === 'function')) step.target = step.to;
    return step;
  }

  get isScrolling() {
    const me = this,
          box = me.outerElement.getBoundingClientRect(),
          scrolled = me.lastTop && box.top !== me.lastTop;
    me.lastTop = box.top;
    return scrolled;
  }

  get isInView() {
    const box = this.outerElement.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom > 0;
  }

  get shouldPause() {
    return !this.isInView || this.isScrolling || document.hidden || !document.hasFocus();
  } // process the next step


  nextStep() {
    const me = this; // Only perform step if in view and not scrolling

    if (me.shouldPause) {
      return;
    }

    if (me.currentStep === me.steps.length) {
      if (me.repeat) {
        me.currentStep = 0;
      } else {
        return me.abort(true);
      }
    } // First step, signal to let demo initialize stuff


    if (me.currentStep === 0) {
      me.trigger('initialize');
    }

    const mouse = me.mouse,
          step = me.normalizeStep(me.steps[me.currentStep++]),
          target = me.getTarget(step),
          action = step.action;

    if (target && action) {
      mouse.className = 'simulated-mouse';

      if (action === 'mousemove') {
        me.handleMouseMove(step, target);
      } else {
        // First move mouse into position
        if (target !== me.prevTarget) {
          const rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(target, me.outerElement);
          mouse.style.left = rect.x + rect.width / 2 + 'px';
          mouse.style.top = rect.y + rect.height / 2 + 'px';
        }

        if (action === 'mousedown') {
          me.mouseDown = true;
        }

        if (action === 'mouseup') {
          me.mouseDown = false;
        } // Then trigger action


        me.timeoutId = me.setTimeout(() => {
          me.prevTarget = target; // Animate click etc.

          mouse.classList.add(action);

          if (action === 'type') {
            const field = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"].fromElement(target),
                  parts = step.text.split('|');
            field.value = parts[parts.length === 1 || field.value != parts[0] ? 0 : 1];
          } else {
            me.triggerEvent(target, action);
          }
        }, action === 'type' ? 100 : 550);
      }
    }
  }

}
DemoBot._$name = 'DemoBot';

/***/ }),

/***/ "./lib/Core/helper/util/DomClassList.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/DomClassList.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomClassList; });
/* harmony import */ var _Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';


/**
 * @module Core/helper/util/DomClassList
 */

const // Presence of '[' is likely an "[object Object]" or other bogus stringification
invalidClsRe = /\[|undefined|null/,
      valueSymbol = Symbol('value'),
      lengthSymbol = Symbol('length');
/**
 * This class encapsulates a list of CSS classes which can be set as the `className`
 * on an `HTMLElement`.
 *
 * Properties names set on this class equate to *adding* a class if the property's value
 * is _truthy_, or removing a class if the value is _falsy_.
 *
 * ```javascript
 * const myClassList = new DomClassList('b-test-button');
 *
 * myClassList.add('test-class');
 * myClassList.important = 1;
 *
 * myHtmlElement.className = myClassList; // Sets it to "b-test-button test-class important"
 * ```
 */

class DomClassList {
  static change(cls, add, remove, as = 'string') {
    remove = DomClassList.normalize(remove, 'object');
    const after = DomClassList.normalize(cls, 'array').filter(c => !remove[c]);

    if (add) {
      add = DomClassList.normalize(add, 'array');

      for (let i = 0; i < add.length; ++i) {
        if (!after.includes(add[i])) {
          after.push(add[i]);
        }
      }
    }

    return DomClassList.normalize(after, as);
  }

  static from(classes, returnEmpty) {
    if (classes) {
      if (!classes.isDomClassList) {
        classes = new DomClassList(classes);
      }

      if (!classes.value && !returnEmpty) {
        classes = null;
      }
    }

    return classes || (returnEmpty ? new DomClassList() : null);
  }
  /**
   * Converts a class name of any understood type to a desired form.
   * @param {String|String[]|Object|Set|Map|HTMLElement} cls
   * @param {String} as Pass `'object'` to return an object with the class names as its keys (all keys will have a
   * value of `true`), or pass `'array'` to return an array of class names, or pass `'string'` (the default) to
   * return a space-separated string of class names.
   * @returns {String|String[]|Object}
   * @internal
   */


  static normalize(cls, as = 'string') {
    cls = cls || ''; // promote null to '' to avoid typeof snag

    const type = typeof cls,
          asArray = as === 'array',
          asObject = as === 'object',
          asString = !asArray && !asObject;
    let isString = type === 'string',
        c,
        i,
        ret;

    if (type === 'object') {
      var _cls;

      if (cls.nodeType === Element.ELEMENT_NODE && typeof cls.getAttribute === 'function') {
        cls = cls.getAttribute('class') || ''; // cannot use className for SVG el's

        isString = true;
      } else if ((_cls = cls) !== null && _cls !== void 0 && _cls.isDomClassList) {
        cls = cls.values;
      } else if (cls instanceof DOMTokenList) {
        cls = Array.from(cls);
      } else if (cls instanceof Map) {
        cls = Array.from(cls.keys()).filter(k => cls.get(k));
      } else if (cls instanceof Set) {
        cls = Array.from(cls.values());
      } else if (!Array.isArray(cls)) {
        cls = _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(cls);
      }
    }

    if (isString) {
      // Pass through Set to ensure only unique class names
      cls = [...new Set(_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(cls))];
    } // cls is now an array


    for (i = cls.length; i-- > 0;) {
      c = cls[i];

      if (!c.length) {
        cls.splice(i, 1);
      } else if (c.includes(' ')) {
        cls.splice(i, 1, ..._StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(c));
      }
    }

    if (asArray) {
      ret = cls;
    } else if (asString) {
      ret = cls.join(' ');
    } else {
      ret = Object.create(null);

      for (i = 0; i < cls.length; ++i) {
        ret[cls[i]] = true;
      }
    }

    return ret;
  }
  /**
   * Initializes a new DomClassList.
   * @param {...String|Object} classes The CSS classes as strings or objects.
   * @function constructor
   */


  constructor(...classes) {
    this.process(1, classes);
  } // To gain some speed in DomHelper.sync(), faster than instanceof etc


  get isDomClassList() {
    return true;
  }
  /**
   * Returns a clone of this DomClassList with all the same keys set.
   * @returns {Core.helper.util.DomClassList} A clone of this DomClassList.
   */


  clone() {
    return new DomClassList(this);
  }
  /**
   * Returns a Boolean value, indicating whether this ClassList has the specified CSS class name.
   * @param {String} className CSS class name to check
   * @return {Boolean} true if this ClassList contains the passed CSS class name, false otherwise
   */


  contains(className) {
    if (typeof className === 'string' && className) {
      return Boolean(this[className]);
    }

    return false;
  } // An instance of this class may be assigned directly to an element's className
  // it will be coerced to a string value using this method.


  toString() {
    // Adding space at the end if there is content to make concatenation code simpler in renderers.
    return this.length ? `${this.value} ` : '';
  }

  toJSON() {
    return this.toString();
  }
  /**
   * Analogous to string.trim, returns the string value of this `DomClassList` with no trailing space.
   * @returns {String} A concatenated string value of all the class names in this `DomClassList`
   * separated by spaces.
   */


  trim() {
    return this.value;
  }
  /**
   * Compares this DomClassList to another DomClassList (or class name string of space separated classes).
   * If the same class names (regardless of order) are present, the two are considered equal.
   *
   * So `new DomClassList('foo bar bletch').isEqual('bletch bar foo')` would return `true`
   * @param {Core.helper.util.DomClassList|String} other The `DomClassList` or string of classes to compare to.
   * @returns {Boolean} `true` if the two contain the same class names.
   */


  isEqual(other) {
    const otherClasses = DomClassList.normalize(other, 'array'),
          len = otherClasses.length;

    if (this.length === len) {
      for (let i = 0; i < len; i++) {
        if (!this[otherClasses[i]]) {
          return false;
        }
      }

      return true;
    }

    return false;
  }
  /**
   * Get/set string value.
   * Class names separated with space.
   * @property {String}
   */


  get value() {
    let value = this[valueSymbol],
        keys;

    if (value == null) {
      keys = _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
      this[lengthSymbol] = keys.length;
      this[valueSymbol] = value = keys.join(' ');
    }

    return value;
  }

  set value(value) {
    const me = this,
          keys = Object.keys(me),
          len = keys.length;

    for (let i = 0; i < len; i++) {
      delete me[keys[i]];
    }

    if (value) {
      me.process(1, [value]);
    } else {
      // String value needs recalculating
      delete me[valueSymbol];
    }
  }
  /**
   * Returns string values as an array.
   * @readonly
   * @property {String[]}
   */


  get values() {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
  }

  get length() {
    // Maintainer: We MUST access the value getter to force
    // the value to be calculated if it's currently dirty.
    return this.value ? this[lengthSymbol] : 0;
  }

  process(value, classes) {
    for (let cls, k, i = 0; i < classes.length; i++) {
      if (classes[i]) {
        cls = classes[i];

        if (_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(cls)) {
          // preserve all keys, even falsy ones
          for (k in cls) {
            this[k] = value ? cls[k] : !cls[k];
          }
        } else {
          cls = DomClassList.normalize(classes[i], 'array');

          for (k = 0; k < cls.length; ++k) {
            this[cls[k]] = value;
          }
        }
      }
    } // String value needs recalculating


    delete this[valueSymbol];
    return this;
  }
  /**
   * Adds/removes class names according to the passed object's properties.
   *
   * Properties with truthy values are added.
   * Properties with false values are removed.
   * @param {Object} classList Object containing properties to set/clear
   */


  assign(classList) {
    for (const cls in classList) {
      if (!this[cls] !== !classList[cls]) {
        this[cls] = classList[cls]; // String value needs recalculating

        delete this[valueSymbol];
      }
    }

    return this;
  }
  /**
   * Add CSS class(es)
   * ```
   * myClassList.add('bold', 'small');
   * ```javascript
   * @param {String|String[]|Object} classes CSS classes to add
   */


  add(...classes) {
    return this.process(1, classes);
  }
  /**
   * Remove CSS class(es)
   * ```javascript
   * myClassList.remove('bold', 'small');
   * ```
   * @param {String} classes CSS classes to remove
   */


  remove(...classes) {
    return this.process(0, classes);
  }
  /**
   * Toggles the passed CSS class name.
   * 
   * If the `force` parameter is passed, `true` means add the class name, `false` means remove it.
   *
   * ```javascript
   * myClassList.toggle('bold', isImportant);
   * ```
   * @param {String} className CSS class to toggle
   * @param {Boolean} [force] `true` to add the class, `false` to remove it.
   * @returns {Boolean} `true` if the operation changed the value.
   */


  toggle(className, flag = Boolean(!this[className])) {
    flag = Boolean(flag); // Only disturb the set classwes if we need to.

    if (Boolean(this[className]) !== flag) {
      this[className] = flag; // String value needs recalculating

      delete this[valueSymbol];
      return true;
    }
  }
  /**
   * Analogous to the `String#split` method, but with no delimiter
   * parameter. This method returns an array containing the individual
   * CSS class names set.
   * @returns {String[]} The individual class names in this `DomClassList`
   */


  split() {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
  }

  forEach(fn) {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this).forEach(fn);
  }

}
; // We put this on the prototype and delete it from instances to mark dirty state. This maintains the same shape for
// the instance to help the JIT

DomClassList.prototype[valueSymbol] = null;
DomClassList._$name = 'DomClassList';

/***/ }),

/***/ "./lib/Core/helper/util/Formatter.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Formatter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Formatter; });
var productName = 'gantt';
const hasOwnProperty = Object.prototype.hasOwnProperty;
let cacheKey = null;

function setParser(me, parser) {
  Object.defineProperty(me, 'parser', {
    value: parser
  });
  return parser;
}

class Default {
  constructor(formatter) {
    this.formatter = formatter;
  }

  format(value) {
    return this.formatter.defaultFormat(value);
  }

  parse(value, strict) {
    return this.formatter.defaultParse(value, strict);
  }

  resolvedOptions() {
    return null;
  }

} // This class does not extend Core.Base because instances are not reconfigurable (making
// setConfig harmful) nor destroyable. Instead, they get frozen and cached according to
// their "config" definition.

/**
 * Abstract base class for formatters.
 * @private
 */


class Formatter {
  static get(format) {
    if (format == null) {
      return this.NULL;
    }

    const key = typeof format === 'string' ? format : JSON.stringify(format),
          cache = this.cache;
    let fmt = cache.get(key);

    if (!fmt) {
      cacheKey = key; // this is grabbed by our constructor below...

      fmt = new this(format);
      cache.set(key, fmt);
    }

    return fmt;
  }

  static get cache() {
    return hasOwnProperty.call(this, '_cache') && this._cache || (this._cache = new Map());
  }

  static get NULL() {
    return hasOwnProperty.call(this, '_null') ? this._null : this._null = new this(null);
  }

  constructor(config) {
    const me = this; // This is done in a funny way so as not to complicate the derived constructor's
    // desire to maintain a single argument signature, as well as it's calling of
    // Object.freeze() to ensure immutability in dev mode.

    me.cacheKey = cacheKey;
    cacheKey = null;
    me.initialize();

    if (config === null) {
      me.formatter = new Default(me);
    } else {
      me.configure(config); // Bring locale and other defaulted options back onto this object:

      for (const [key, value] of Object.entries(me.resolvedOptions())) {
        // For some reason (locale-specific perhaps), resolvedOptions returns
        // with 'undefined' in some keys (e.g., min/maximumFractionDigits) when
        // we specified 0.
        //
        // The second check is to only bring back values that we understand.
        if (value != null && key in me.defaults) {
          me[key] = value;
        }
      }
    }
  }

  get parser() {
    // Replace this property w/the actual instance:
    return setParser(this, new this.constructor.Parser(this));
  }

  defaultFormat(value) {
    return value == null ? value : String(value);
  }

  defaultParse(value) {
    return value;
  }

  format(value) {
    return value == null ? value : this.formatter.format(value);
  }

  parse(value, strict) {
    return value == null ? value : this.parser.parse(value, strict);
  }

  parseStrict(value) {
    return this.parse(value, true);
  }

  resolvedOptions() {
    return this.formatter.resolvedOptions();
  }

}
Formatter._$name = 'Formatter';

/***/ }),

/***/ "./lib/Core/helper/util/Fullscreen.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Fullscreen.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fullscreen; });
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';

/**
 * @module Core/helper/util/Fullscreen
 */

/**
 * Encapsulates the functionality related to switching cross-browser to full screen view and back.
 */

class Fullscreen {
  static init() {
    const fnNames = ['fullscreenEnabled', 'requestFullscreen', 'exitFullscreen', 'fullscreenElement'],
          // turns fnNames into function calls to prefixed functions, fullscreenEnabled -> document.mozFullscreenEnabled
    prefixFn = prefix => fnNames.map(fn => {
      let result = prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(fn); // fullscreenEnabled in Firefox is called fullScreenEnabled

      if (prefix === 'moz') {
        result = result.replace('screen', 'Screen'); // #6555 - Crash when clicking full screen button twice
        // firefox doesn't support exitFullScreen method

        if ('mozCancelFullScreen' in document && fn === 'exitFullscreen') {
          result = 'mozCancelFullScreen';
        }
      }

      return result;
    });

    this.functions = 'fullscreenEnabled' in document && fnNames || 'webkitFullscreenEnabled' in document && prefixFn('webkit') || 'mozFullScreenEnabled' in document && prefixFn('moz') || 'msFullscreenEnabled' in document && prefixFn('ms') || [];

    const eventNames = ['fullscreenchange', 'fullscreenerror'],
          msEventNames = ['MSFullscreenChange', 'MSFullscreenError'],
          prefixEvt = prefix => eventNames.map(eventName => prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(eventName));

    this.events = 'fullscreenEnabled' in document && eventNames || 'webkitFullscreenEnabled' in document && prefixEvt('webkit') || 'mozFullscreenEnabled' in document && prefixEvt('moz') || 'msFullscreenEnabled' in document && msEventNames || [];
  }
  /**
   * True if the fullscreen mode is supported and enabled, false otherwise
   * @property {Boolean}
   */


  static get enabled() {
    return document[this.functions[0]];
  }
  /**
   * Request entering the fullscreen mode.
   * @param {HTMLElement} element Element to be displayed fullscreen
   * @returns {Promise} A Promise which is resolved with a value of undefined when the transition to full screen is complete.
   */


  static request(element) {
    return element[this.functions[1]]();
  }
  /**
   * Exit the previously entered fullscreen mode.
   * @returns {Promise} A Promise which is resolved once the user agent has finished exiting full-screen mode
   */


  static exit() {
    return document[this.functions[2]]();
  }
  /**
   * True if fullscreen mode is currently active, false otherwise
   * @property {Boolean}
   */


  static get isFullscreen() {
    return !!this.element;
  }

  static get element() {
    return document[this.functions[3]];
  }
  /**
   * Installs the passed listener to fullscreenchange event
   * @param {Function} fn The listener to install
   */


  static onFullscreenChange(fn) {
    document.addEventListener(this.events[0], fn);
  }
  /**
   * Uninstalls the passed listener from fullscreenchange event
   * @param {Function} fn
   */


  static unFullscreenChange(fn) {
    document.removeEventListener(this.events[0], fn);
  }

}
Fullscreen.init();
Fullscreen._$name = 'Fullscreen';

/***/ }),

/***/ "./lib/Core/helper/util/Navigator.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Navigator.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Navigator; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'gantt';





/**
 * @module Core/helper/util/Navigator
 */

/**
 * A helper class which allows keyboard navigation within the {@link #config-target} element.
 * @private
 */

class Navigator extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * The owning Widget which is using this Navigator.
       * @config {Core.widget.Widget}
       */
      ownerCmp: null,

      /**
       * The encapsulating element in which navigation takes place.
       * @config {HTMLElement}
       */
      target: null,

      /**
       * The element which provides key events for navigation. Optional. Defaults to the {@link #config-target} element.
       * @config {HTMLElement}
       */
      keyEventTarget: null,

      /**
       * An optional key event processor which may preprocess the key event. Returning `null` prevents processing of the event.
       * @config {Function}
       */
      processEvent: null,

      /**
       * A query selector which identifies descendant elements within the {@link #config-target} which are navigable.
       * @config {String}
       */
      itemSelector: null,

      /**
       * The currently focused element within the {@link #config-target}.
       * @config {HTMLElement}
       */
      activeItem: null,

      /**
       * A CSS class name to add to focused elements.
       * @config {String}
       * @default
       */
      focusCls: 'b-active',

      /**
       * An object containing key definitions keys by the key name eg:
       *
       * ```javascript
       *  keys : {
       *      "CTRL+SPACE" : 'onCtrlSpace',
       *      ENTER        : 'onEnterKey'
       *  }```
       *
       * The {@link #config-ownerCmp} is used as the `this` reference and to resolve string method names.
       *
       * Modified key names must be created prepending one or more `'CTRL+'`, `'SHIFT+'`, `'ALT+'`
       * in that order, for example `"CTRL+SHIFT+ENTER" : 'showMenu'`
       * @config {Object}
       * @default
       */
      keys: null,

      /**
       * Configure as `true` to also navigate when the `CTRL` modifier key is used along with
       * navigation keys.
       * @config {Boolean}
       * @default false
       */
      allowCtrlKey: null,

      /**
       * Configure as `true` to also navigate when the `SHIFT` modifier key is used along with
       * navigation keys.
       * @config {Boolean}
       * @default false
       */
      allowShiftKey: null,
      scrollDuration: 50,

      /**
       * Configure as, or set to `true` to disable the processing of keys.
       * @config {Boolean}
       */
      disabled: null,
      testConfig: {
        scrollDuration: 1
      }
    };
  }

  updateOwnerCmp(ownerCmp) {
    if (!this.itemSelector) {
      this.itemSelector = `.${this.ownerCmp.itemCls}`;
    }
  }

  onKeyDown(keyEvent) {
    const me = this,
          {
      ownerCmp,
      itemSelector,
      activeItem,
      itemsTabbable
    } = me,
          {
      target
    } = keyEvent,
          firstItem = me.target.querySelector(itemSelector),
          // Not all key events have 'key'
    keyName = (keyEvent.key || '').trim() || keyEvent.code,
          composedKeyName = `${keyEvent.ctrlKey ? 'CTRL+' : ''}${keyEvent.shiftKey ? 'SHIFT+' : ''}${keyEvent.altKey ? 'ALT+' : ''}${keyName}`,
          validTarget = target.matches(itemSelector) || target === me.keyEventTarget; // Process the key gesture if there are items and we are visible.
    // Also, if key emanated from a valid target element (Not an owned positioned Widget).

    if (!me.disabled && firstItem && me.target.offsetParent && validTarget) {
      // Only set navigation key names if we are *not* using tabbing.
      if (!itemsTabbable) {
        // Detect whether the navigable items flow inline or downwards.
        if (me.inlineFlow == null) {
          const itemContainer = firstItem.parentNode,
                itemPositionStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'position'),
                itemDisplayStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'display'),
                itemFloatStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'float'); // This is how we know that RIGHT and LEFT arrow should be used for next and previous.
          // If inlineFlow is false, we use UP and DOWN. Consider tabs in a tab bar.

          me.inlineFlow = itemPositionStyle === 'absolute' || itemDisplayStyle === 'inline' || itemDisplayStyle === 'inline-block' || itemFloatStyle === 'left' || itemFloatStyle === 'right' || _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(itemContainer, 'display') === 'flex' && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(itemContainer, 'flex-direction') === 'row';
        }

        if (!me.prevKey) {
          if (me.inlineFlow) {
            me.prevKey = 'ArrowLeft';
            me.nextKey = 'ArrowRight';
          } else {
            me.prevKey = 'ArrowUp';
            me.nextKey = 'ArrowDown';
          }
        }
      } // Feed the key event through our configured processor, process the event that returns if any.


      if (me.processEvent) {
        keyEvent = me.processEvent.call(ownerCmp, keyEvent);

        if (!keyEvent) {
          return;
        }
      }

      if (activeItem) {
        switch (keyName) {
          case me.prevKey:
            if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
              return;
            }

            if (keyEvent.shiftKey && !me.allowShiftKey) {
              return;
            }

            keyEvent.preventDefault();
            me.navigatePrevious(keyEvent);
            break;

          case me.nextKey:
            if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
              return;
            }

            if (keyEvent.shiftKey && !me.allowShiftKey) {
              return;
            }

            keyEvent.preventDefault();
            me.navigateNext(keyEvent);
            break;

          default:
            {
              const keyHandler = me.keys && me.keys[composedKeyName];

              if (keyHandler && !me.disabled) {
                me.callback(keyHandler, me.thisObj || ownerCmp, [keyEvent]);
              } // Note that even if this.disabled, the ownerCmp will expect
              // to have its key down handler invoked.
              else if (ownerCmp.onInternalKeyDown) {
                ownerCmp.onInternalKeyDown(keyEvent);
              } // One of the handlers moved focus.
              // This KeyDown should not act upon the new target.
              // For example popped up a Popup and focused its "close" Tool.


              if (_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(target) !== target) {
                keyEvent.preventDefault();
              } // No navigation must take place when items are tabbable.


              if (itemsTabbable) {
                return;
              }
            }
        }
      } else {
        if (itemsTabbable) {
          return;
        }

        me.activeItem = me.previousActiveItem || me.getDefaultNavigationItem(keyEvent);
      }

      if (me.activeItem !== activeItem) {
        /**
         * Fired when a user gesture causes the active item to change _or become `null`_.
         * @event navigate
         * @param {Event} event The browser event which instigated navigation. May be a click or key or focus move event.
         * @param {HTMLElement} item The newly active item, or `null` if focus moved out.
         * @param {HTMLElement} oldItem The previously active item, or `null` if focus is moving in.
         */
        me.triggerNavigate(keyEvent);
      }
    }
  }

  getDefaultNavigationItem(keyEvent) {
    const {
      target,
      itemSelector,
      prevKey,
      nextKey
    } = this; // Navigating backwards from after the component, we default to last item

    if (target.compareDocumentPosition(keyEvent.target) & 4 && keyEvent.key === prevKey) {
      return target.querySelector(`${itemSelector}:last-of-type`);
    } // Navigating forwards from before the component we default to the first item


    if (target.compareDocumentPosition(keyEvent.target) & 2 && keyEvent.key === nextKey) {
      return target.querySelector(`${itemSelector}`);
    }
  }

  navigatePrevious(keyEvent) {
    const me = this,
          previous = me.previous;
    keyEvent.preventDefault();

    if (previous) {
      me.ownerCmp.scrollable.scrollIntoView(previous, {
        animate: me.scrollDuration
      }).then(() => {
        me.activeItem = previous;
        me.triggerNavigate(keyEvent);
      });
    }
  }

  navigateNext(keyEvent) {
    const me = this,
          next = me.next;
    keyEvent.preventDefault();

    if (next) {
      me.ownerCmp.scrollable.scrollIntoView(next, {
        animate: me.scrollDuration
      }).then(() => {
        me.activeItem = next;
        me.triggerNavigate(keyEvent);
      });
    }
  }

  get owner() {
    return this.ownerCmp;
  }

  get previous() {
    return this.getAdjacent(-1);
  }

  get next() {
    return this.getAdjacent(1);
  }
  /**
   * Returns the next or previous navigable element starting from the passed `from` element,
   * navigating in the passed direction.
   * @param {HTMLElement} [from] The start point. Defaults to the current {@link #config-activeItem}
   * @param {Number} [direction=1] The direction. -1 for backwards, else forwards.
   */


  getAdjacent(direction = 1, from = this.activeItem) {
    const treeWalker = this.treeWalker;
    treeWalker.currentNode = from;
    treeWalker[direction < 0 ? 'previousNode' : 'nextNode']();

    if (treeWalker.currentNode !== this.activeItem) {
      return treeWalker.currentNode;
    }
  }

  onTargetFocusIn(focusInEvent) {
    const me = this,
          {
      target
    } = focusInEvent,
          {
      itemsTabbable,
      skipScrollIntoView
    } = me; // Ignore navigating to a focus trap. It will bounce back in

    if (!target.matches('.b-focus-trap')) {
      if (target.matches(me.itemSelector)) {
        // We may need to know this in downstream code.
        // for example set activeItem must not scrollIntoView on click
        me.skipScrollIntoView = true;
        me.activeItem = target;
        me.skipScrollIntoView = skipScrollIntoView; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

        if (me.activeItem && itemsTabbable) {
          me.triggerNavigate(focusInEvent);
        }
      } // Upward focusing from within means a SHIFT+TAB, so go to previous sibling
      // PATCH: IE11 may receive event which related target is not an instance of HTMLElement
      else {
        const toWidget = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(focusInEvent.target); // If we are focusing into an owned widget (such as an Editor), ignore. It will revert focus
        // when it hides.

        if (!toWidget || !me.owner.owns(toWidget)) {
          var _focusInEvent$related, _focusInEvent$related2;

          if (!itemsTabbable && (_focusInEvent$related = focusInEvent.relatedTarget) !== null && _focusInEvent$related !== void 0 && (_focusInEvent$related2 = _focusInEvent$related.matches) !== null && _focusInEvent$related2 !== void 0 && _focusInEvent$related2.call(_focusInEvent$related, me.itemSelector)) {
            var _me$owner$previousSib;

            (_me$owner$previousSib = me.owner.previousSibling) === null || _me$owner$previousSib === void 0 ? void 0 : _me$owner$previousSib.focus();
          }
        }
      }
    }
  }

  onTargetFocusOut(focusOutEvent) {
    const me = this,
          {
      relatedTarget
    } = focusOutEvent; // Ignore navigating to a focus trap. It will bounce back in

    if (!(relatedTarget !== null && relatedTarget !== void 0 && relatedTarget.matches('.b-focus-trap'))) {
      if (!relatedTarget || !me.target.contains(relatedTarget) || !relatedTarget.matches(me.itemSelector)) {
        if (me.activeItem) {
          me.activeItem = null; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

          if (me.itemsTabbable) {
            me.triggerNavigate(focusOutEvent);
          }
        }
      }
    }
  }

  onTargetMouseDown(mouseDownEvent) {
    const me = this,
          target = mouseDownEvent.target.closest(me.itemSelector);
    me.mouseDownEvent = mouseDownEvent; // Mousedown is the focus gesture.
    // This holds true even on touch platforms
    // where the mousedown event is synthesized -
    // preventing default prevents focus on the upcoming touchend.

    if (me.ownerCmp.itemsFocusable === false) {
      me.onFocusGesture(mouseDownEvent);
    } else if (target) {
      mouseDownEvent.preventDefault();
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].focusWithoutScrolling(target);
    }
  }

  onTargetClick(clickEvent) {
    var _me$mouseDownEvent;

    const me = this,
          {
      skipScrollIntoView
    } = me;

    if (me.skipNextClick || (_me$mouseDownEvent = me.mouseDownEvent) !== null && _me$mouseDownEvent !== void 0 && _me$mouseDownEvent.ignoreNavigation) {
      me.skipNextClick = false;
      return;
    }

    if (me.disabled) {
      return;
    } // We may need to know this in downstream code.
    // for example set activeItem must not scrollIntoView on click


    me.skipScrollIntoView = true; // ownerCmp's preprocessing of any navigate event.

    if (me.processEvent) {
      clickEvent = me.processEvent.call(me.ownerCmp, clickEvent);
    }

    if (clickEvent) {
      me.activeItem = clickEvent.target.closest(me.itemSelector);
      me.triggerNavigate(clickEvent);
    }

    me.skipScrollIntoView = skipScrollIntoView;
  } // We have to prevent focus moving from eg, an input field when we mousedown
  // or touchtap a non focusable item when ownerCmp has itemsFocusable: false.
  // If the event was not on an item, we must allow it through to allow Lists
  // to contain other widgets.


  onFocusGesture(event) {
    if (event.target === this.ownerCmp.contentElement || event.target.closest(this.itemSelector) && this.ownerCmp.itemsFocusable === false) {
      event.preventDefault();
    }
  }

  acceptNode(node) {
    return node.offsetParent && node.matches && node.matches(this.itemSelector) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  }

  changeActiveItem(activeItem) {
    if (activeItem != null) {
      // List and Menu's getItem API allows number, or node or record or record id to be passed
      if (this.ownerCmp.getItem) {
        activeItem = this.ownerCmp.getItem(activeItem);
      }
    }

    return activeItem;
  }

  updateActiveItem(activeItem, oldActiveItem) {
    const me = this,
          {
      ownerCmp
    } = me,
          isActive = oldActiveItem && me.target.contains(oldActiveItem);

    if (isActive) {
      me.previousActiveItem = oldActiveItem;
    } // This may be set to null on focusout of the target element.
    // Cannot use truthiness test because index zero may be passed.


    if (activeItem != null) {
      // If the user was able to click the event, they will not expect it to attempt to scroll.
      if (!me.skipScrollIntoView) {
        var _ownerCmp$scrollable;

        (_ownerCmp$scrollable = ownerCmp.scrollable) === null || _ownerCmp$scrollable === void 0 ? void 0 : _ownerCmp$scrollable.scrollIntoView(activeItem, {
          block: 'nearest',
          // If we are being called in response to focus movement, it will already be the document.activeElement
          // so in that case, behave is if we were in non-focusing mode, and just add the focused class.
          focus: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(activeItem) && activeItem !== _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(activeItem),
          silent: me.scrollSilently
        });
      } // No change in active item, do nothing after we've ensured it's fully in view.


      if (activeItem === oldActiveItem && isActive) {
        return;
      }

      if (oldActiveItem) {
        oldActiveItem.classList.remove(me.focusCls);
      }

      activeItem.classList.add(me.focusCls);
      me._activeItem = activeItem;
    } else {
      if (oldActiveItem) {
        oldActiveItem.classList.remove(me.focusCls); // If we are clearing the activeItem, and it's focused, keep focus
        // close by actively reverting it.

        if (oldActiveItem === _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(oldActiveItem)) {
          ownerCmp.revertFocus();
        }
      }

      me._activeItem = null;
    }
  }

  updateTarget(target, oldTarget) {
    const me = this,
          listeners = {
      element: target,
      thisObj: me,
      focusin: 'onTargetFocusIn',
      focusout: 'onTargetFocusOut'
    };

    if (!me.itemsTabbable) {
      // We don't need pointer events if items are tabbable
      listeners.mousedown = 'onTargetMouseDown';
      listeners.click = 'onTargetClick';
    }

    if (!Object.prototype.hasOwnProperty.call(me, 'acceptNode')) {
      me.acceptNode = me.acceptNode.bind(me); // https://github.com/webcomponents/webcomponentsjs/issues/556
      // Work around Internet Explorer wanting a function instead of an object.
      // IE also *requires* this argument where other browsers don't.

      me.acceptNode.acceptNode = me.acceptNode;
    }

    _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(listeners); // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)

    me.treeWalker = me.setupTreeWalker(target, NodeFilter.SHOW_ELEMENT, me.acceptNode, false); // If we were not configured with an outside key event provider (think the input field providing UP/DOWN keys for the dropdown)
    // then use the target element as the source.

    if (!me.keyEventTarget) {
      me.keyEventTarget = target;
    } // If the activeItem gets removed, we must know, and deactivate.


    (me.targetMutationMonitor = new MutationObserver(me.onTargetChildListChange.bind(me))).observe(target, {
      childList: true,
      subtree: true
    });
  }

  setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
    // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)
    return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
  }

  onTargetChildListChange() {
    const activeItem = this.activeItem; // On DOM mutation, if the activeItem got changed, pull the one with the same ID out again.

    if (activeItem) {
      if (this.target.contains(activeItem)) {
        activeItem.classList.add(this.focusCls);
      } else {
        // Passing undefined results in the config setter assuming no-change
        // So we must use null to clear.
        this.activeItem = this.target.querySelector(`${this.itemSelector}[data-id="${activeItem.dataset.id}"]`) || null;
      }
    }
  }

  changeKeyEventTarget(keyEventTarget) {
    this._keyEventTarget = keyEventTarget;
    _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: keyEventTarget,
      keydown: 'onKeyDown',
      thisObj: this
    });
  }

  triggerNavigate(event, item = this.activeItem) {
    var _this$ownerCmp;

    const navEvent = {
      event,
      item,
      oldItem: this.previousActiveItem
    };
    this.trigger('navigate', navEvent);
    (_this$ownerCmp = this.ownerCmp) === null || _this$ownerCmp === void 0 ? void 0 : _this$ownerCmp.trigger('navigate', navEvent);
  }

}
Navigator._$name = 'Navigator';

/***/ }),

/***/ "./lib/Core/helper/util/NumberFormat.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/NumberFormat.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberFormat; });
/* harmony import */ var _Formatter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../localization/En.js */ "./lib/Core/localization/En.js");
var productName = 'gantt';




/**
 * @module Core/helper/util/NumberFormat
 */

const escapeRegExp = _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].escapeRegExp,
      digitsRe = /[\d+-]/g,
      // We cannot pass locale=null:
newFormatter = (locale, config) => new Intl.NumberFormat(locale || undefined, config),
      numFormatRe = /^(?:([$])\s*)?(?:(\d+)>)?\d+(,\d+)?(?:\.((\d*)(?:#*)|[*]))?(?:\s*([%])?)?$/;

class NumberParser {
  constructor(formatter) {
    const me = this,
          locale = formatter.locale,
          // We need a formatter for this locale that has decimals and grouping:
    numFmt = newFormatter(locale, {
      maximumFractionDigits: 3
    }),
          currency = formatter.is.currency ? me._decodeStyle(locale, {
      style: 'currency',
      currency: formatter.currency,
      currencyDisplay: formatter.currencyDisplay
    }) : null,
          percent = formatter.is.percent ? me._decodeStyle(locale, {
      style: 'percent'
    }) : null,
          decimal = numFmt.format(1.2).replace(digitsRe, '')[0],
          grouper = numFmt.format(1e9).replace(digitsRe, '')[0] || '';
    Object.assign(me, {
      currency,
      decimal,
      formatter,
      grouper,
      percent
    });
    me.decimal = decimal;
    me.decimalRe = escapeRegExp(decimal, 'g');
    me.grouper = grouper; // The stripRe removes whitespace, currency text, percent text and grouping chars:

    me.stripRe = new RegExp(`(?:\\s+|${escapeRegExp(grouper)})` + (currency ? `|(?:${escapeRegExp(currency.text)})` : '') + (percent ? `|(?:${escapeRegExp(percent.text)})` : ''), 'g');
  }

  decimalPlaces(value) {
    value = value.replace(this.stripRe, '');
    const dot = value.indexOf(this.decimal) + 1;
    return dot && value.length - dot;
  }

  parse(value, strict) {
    if (typeof value === 'string') {
      value = value.replace(this.stripRe, '').replace(this.decimalRe, '.');
      value = strict ? Number(value) : parseFloat(value);

      if (this.formatter.is.percent) {
        value /= 100;
      }
    } // else, a number is already parsed but could be null...


    return value;
  }

  _decodeStyle(locale, fmtDef) {
    const fmt = newFormatter(locale, fmtDef),
          decFmt = newFormatter(locale, Object.assign(fmt.resolvedOptions(), {
      style: 'decimal'
    })),
          zero = fmt.format(0),
          // = '0%' or '$0.00' in en-US
    zeroDec = decFmt.format(0); // = '0' or '0.00' in en-US

    return {
      suffix: zero.startsWith(zeroDec),
      text: zero.replace(zeroDec, '').trim()
    };
  }

}
/**
 * This class is an enhancement to `Intl.NumberFormat` that has a more flexible
 * constructor as well as other features such as `parse()`.
 *
 * All constructor forms take a single argument. The most common is to pass a format
 * {@link #config-template} string:
 *```
 *  const formatter = new NumberFormat('9,999.99##');
 *```
 * The above is equivalent to:
 *```
 *  const formatter = new Intl.NumberFormat({
 *      useGrouping           : true,
 *      minimumFractionDigits : 2,
 *      maximumFractionDigits : 4
 *  });
 *```
 * The `formatter` created above is used as follows (in the `en-US` locale):
 *```
 *  console.log(formatter.format(12345.54321));
 *  console.log(formatter.format(42));
 *
 *  // 12,345.5432
 *  // 42.00
 *```
 * When a format template is insufficient, a config object can be provided, similar to
 * `Intl.NumberFormat`'s `options` parameter. While all options from `Intl.NumberFormat`
 * are valid properties for this class's config object, additional properties are
 * supported.
 *
 * For example:
 *```
 *  new NumberFormat({
 *      locale      : 'en-US',
 *      template    : '$9,999',
 *      currency    : 'USD',
 *      significant : 5
 *  });
 *```
 * The `locale` option takes the place of the first positional parameter to the
 * `Intl.NumberFormat` constructor. The `template` config is the same string that can be
 * passed by itself.
 *
 * The shorthand properties `fraction`, `integer`, and `significant` set the standard
 * options `minimumFractionDigits`, `maximumFractionDigits`, `minimumIntegerDigits`,
 * `minimumSignificantDigits`, and `maximumSignificantDigits`.
 *
 * NOTE: Instances of `NumberFormat` are immutable after construction.
 *
 * For details about `Intl.NumberFormat` see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat).
 */


class NumberFormat extends _Formatter_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NumberFormat';
  }

  initialize() {
    this._as = {// cacheKey : cachedInstance
    };
    this.is = {
      decimal: false,
      currency: false,
      percent: false,
      null: true,
      from: null
    };
  }

  get truncator() {
    const scale = this.maximumFractionDigits;
    return scale == null ? null : this.as({
      style: 'decimal',
      maximumFractionDigits: Math.min(20, scale + 1)
    }, 'truncator');
  }

  configure(options) {
    const me = this;

    if (typeof options !== 'string') {
      Object.assign(me, options);
    } else {
      me.template = options;
    } // Do not remove. Assertion strings for Localization sanity check.
    // 'L{locale}'
    // 'L{currency}'


    const config = {},
          loc = me.locale ? _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].locales[me.locale] : _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].locale,
          defaults = loc && loc.NumberFormat,
          template = me.template;

    if (defaults) {
      for (const key in defaults) {
        if (me[key] == null && typeof defaults[key] !== 'function') {
          me[key] = defaults[key];
        }
      }
    }

    if (template) {
      const match = numFormatRe.exec(template),
            m2 = match[2],
            m4 = match[4];
      me.useGrouping = !!match[3];
      me.style = match[1] ? 'currency' : match[6] ? 'percent' : 'decimal';

      if (m2) {
        me.integer = +m2;
      }

      if (m4 === '*') {
        me.fraction = [0, 20];
      } else if (m4 != null) {
        me.fraction = [match[5].length, m4.length];
      }
    }

    me._minMax('fraction', true, true);

    me._minMax('integer', true, false);

    me._minMax('significant', false, true);

    for (const key in me.defaults) {
      if (me[key] != null) {
        config[key] = me[key];
      }
    }

    me.is.from = me.from && me.from.is;
    me.is[me.style] = !(me.is.null = false);
    me.formatter = newFormatter(me.locale, config);
  }
  /**
   * Creates a derived `NumberFormat` from this instance, with a different `style`. This is useful for processing
   * currency and percentage styles without the symbols being injected in the formatting.
   *
   * @param {String|Object} change The new style (if a string) or a set of properties to update.
   * @param {String} [cacheAs] A key by which to cache this derived formatter.
   * @returns {Core.helper.util.NumberFormat}
   */


  as(change, cacheAs = null) {
    const config = this.resolvedOptions() || {
      template: '9.*'
    },
          cache = this._as;
    let ret = cacheAs && cache[cacheAs];

    if (!ret) {
      if (typeof change === 'string') {
        config.style = change;
      } else {
        Object.assign(config, change);
      }

      config.from = this;
      ret = new NumberFormat(config);
    }

    if (cacheAs) {
      cache[cacheAs] = ret;
    }

    return ret;
  }

  defaultParse(value, strict) {
    return value == null ? value : strict ? Number(value) : parseFloat(value);
  }
  /**
   * Returns the given `value` formatted in accordance with the specified locale and
   * formatting options.
   *
   * @param {Number} value
   * @returns {String}
   */


  format(value) {
    if (typeof value === 'string') {
      const v = Number(value);
      value = isNaN(v) ? this.parse(value) : v;
    }

    return super.format(value);
  } // The parse() method is inherited but the base class implementation
  // cannot properly document the parameter and return types:

  /**
   * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
   * specified locale and formatting options.
   *
   * If the `value` cannot be parsed, `NaN` is returned.
   *
   * Pass `strict` as `true` to require all text to convert. In essence, the default is
   * in line with JavaScript's `parseFloat` while `strict=true` behaves like the `Number`
   * constructor:
   *```
   *  parseFloat('1.2xx');  // = 1.2
   *  Number('1.2xx')       // = NaN
   *```
   * @method parse
   * @param {String} value
   * @param {Boolean} [strict=false]
   * @returns {Number}
   */

  /**
   * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
   * specified locale and formatting options.
   *
   * If the `value` cannot be parsed, `NaN` is returned.
   *
   * This method simply passes the `value` to `parse()` and passes `true` for the second
   * argument.
   *
   * @method parseStrict
   * @param {String} value
   * @returns {Number}
   */

  /**
   * Returns the given `Number` rounded in accordance with the specified locale and
   * formatting options.
   *
   * @param {Number|String} value
   * @returns {Number}
   */


  round(value) {
    return this.parse(this.format(value));
  }
  /**
   * Returns the given `Number` truncated to the `maximumFractionDigits` in accordance
   * with the specified locale and formatting options.
   *
   * @param {Number|String} value
   * @returns {Number}
   */


  truncate(value) {
    const me = this,
          scale = me.maximumFractionDigits,
          {
      truncator
    } = me;
    let v = me.parse(value),
        dot;

    if (truncator) {
      v = truncator.format(v);
      dot = v.indexOf(truncator.parser.decimal);

      if (dot > -1 && v.length - dot - 1 > scale) {
        v = v.substr(0, dot + scale + 1);
      }

      v = truncator.parse(v);
    }

    return v;
  }

  resolvedOptions() {
    const options = super.resolvedOptions();

    for (const key in options) {
      // For some reason, on TeamCity, tests get undefined for some properties...
      // maybe a locale issue?
      if (options[key] === undefined) {
        options[key] = this[key];
      }
    }

    return options;
  }
  /**
   * Expands the provided shorthand into the "minimum*Digits" and "maximum*Digits".
   * @param {String} name
   * @param {Boolean} setMin
   * @param {Boolean} setMax
   * @private
   */


  _minMax(name, setMin, setMax) {
    const me = this,
          value = me[name];

    if (value != null) {
      const capName = _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name),
            max = `maximum${capName}Digits`,
            min = `minimum${capName}Digits`;

      if (typeof value === 'number') {
        if (setMin) {
          me[min] = value;
        }

        if (setMax) {
          me[max] = value;
        }
      } else {
        me[min] = value[0];
        me[max] = value[1];
      }
    }
  }

}
NumberFormat.Parser = NumberParser;
Object.assign(NumberFormat.prototype, {
  // This object holds only those properties that Intl.NumberFormat accepts in its
  // "options" parameter. Only these options will be copied from the NumberFormat
  // and passed to the Intl.NumberFormat constructor and only these will be copied
  // back from its resolvedOptions:
  defaults: {
    /**
     * The formatting style.
     *
     * Valid values are: `'decimal'` (the default), `'currency'`, and `'percent'`.
     * @config {String}
     * @default
     */
    style: 'decimal',

    /**
     * The currency to use when using `style: 'currency'`. For example, `'USD'` (US dollar)
     * or `'EUR'` for the euro.
     *
     * If not provided, the {@link Core.localization.LocaleManager} default will be used.
     * @config {Boolean}
     */
    currency: null,

    /**
     * The format in which to display the currency value when using `style: 'currency'`.
     *
     * Valid values are: `'symbol'` (the default), `'code'`, and `'name'`.
     * @config {String}
     * @default
     */
    currencyDisplay: 'symbol',

    /**
     * The name of the locale. For example, `'en-US'`. This config is the same as the
     * first argument to the `Intl.NumberFormat` constructor.
     *
     * Defaults to the browser's default locale.
     * @config {String}
     */
    locale: null,

    /**
     * The maximum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    maximumFractionDigits: null,

    /**
     * The minimum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    minimumFractionDigits: null,

    /**
     * The minimum number of digits preceding the decimal.
     *
     * This is more convenient to specify using the {@link #config-integer} config.
     * @config {Number}
     */
    minimumIntegerDigits: null,

    /**
     * The maximum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    maximumSignificantDigits: null,

    /**
     * The minimum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    minimumSignificantDigits: null,

    /**
     * Specify `false` to disable thousands separators.
     * @config {Boolean}
     * @default
     */
    useGrouping: true
  },

  /**
   * Specifies the `minimumFractionDigits` and `minimumFractionDigits` in a compact
   * way. If this value is a `Number`, it sets both the minimum and maximum to that
   * value. If this value is an array, `[0]` sets the minimum and `[1]` sets the
   * maximum.
   * @config {Number|Number[]}
   */
  fraction: null,
  from: null,

  /**
   * An alias for `minimumIntegerDigits`.
   * @config {Number}
   */
  integer: null,

  /**
   * Specifies the `minimumSignificantDigits` and `minimumSignificantDigits` in a compact
   * format. If this value is a `Number`, it sets only the maximum to that value. If this
   * value is an array, `[0]` sets the minimum and `[1]` sets the maximum.
   *
   * If this value (or `minimumSignificantDigits` or `minimumSignificantDigits`) is set,
   * `integer` (and `minimumIntegerDigits`) and `fraction` (and `minimumFractionDigits`
   * and `minimumFractionDigits`) are ignored.
   *
   * @config {Number|Number[]}
   */
  significant: null,

  /**
   * A format template consisting of the following parts:
   *```
   *  [$] [\d+:] \d+ [,\d+] [.\d* [#*] | *] [%]
   *```
   * If the template begins with a `'$'`, the formatter's `style` option is set to
   * `'currency'`. If the template ends with `'%'`, `style` is set to `'percent'`.
   * It is invalid to include both characters. When using `'$'`, the `currency` symbol
   * defaults to what is provided by the {@link Core.localization.LocaleManager}.
   *
   * To set the `minimumIntegerDigits`, the desired minimum comes before the first
   * digits in the template and is followed by a `'>'` (greater-than). For example:
   *```
   *  5>9,999.00
   *```
   * The above sets `minimumIntegerDigits` to 5.
   *
   * The `useGrouping` option is enabled if there is a `','` (comma) present and is
   * disabled otherwise.
   *
   * If there is a `'.'` (decimal) present, it may be followed by either of:
   *
   *  - Zero or more digits which may then be followed by zero or more `'#'` characters.
   *    The number of digits determines the `minimumFractionDigits`, while the total
   *    number of digits and `'#'`s determines the `maximumFractionDigits`.
   *  - A single `'*'` (asterisk) indicating any number of fractional digits (no minimum
   *    or maximum).
   *
   * @config {String}
   */
  template: null
});
Object.assign(NumberFormat.prototype, NumberFormat.prototype.defaults); // TODO is this the "right" way to do this?

_Formatter_js__WEBPACK_IMPORTED_MODULE_0__["default"].number = (format, value) => NumberFormat.format(format, value);

NumberFormat._$name = 'NumberFormat';

/***/ }),

/***/ "./lib/Core/helper/util/Objects.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/Objects.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Objects; });
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt'; // IMPORTANT - adding imports here can create problems for Base class
//  That is why this file was split from ObjectHelper


const {
  toString
} = Object.prototype,
      {
  isFrozen
} = Object,
      afterRe = /\s*<\s*/,
      beforeRe = /\s*>\s*/,
      blendOptions = {},
      typeNameRe = /\[object ([^\]]+)]/,
      typeCache = {},
      emptyObject = Object.freeze({});
/**
 * @module Core/helper/util/Objects
 */
// Static methods are not displayed in derived class documentation. Therefore, since this is an internal class, the
// work around is to copy method documentation to ObjectHelper (the public interface). Also tried making ObjectHelper
// a singleton.

/**
 * Helper for low-level Object manipulation.
 *
 * While documented on {@link Core.helper.ObjectHelper}, the following static methods are implemented by this class:
 *
 * - `{@link Core.helper.ObjectHelper#function-assign-static}`
 * - `{@link Core.helper.ObjectHelper#function-assignIf-static}`
 * - `{@link Core.helper.ObjectHelper#function-clone-static}`
 * - `{@link Core.helper.ObjectHelper#function-createTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyValues-static}`
 * - `{@link Core.helper.ObjectHelper#function-isEmpty-static}`
 * - `{@link Core.helper.ObjectHelper#function-isObject-static}`
 * - `{@link Core.helper.ObjectHelper#function-merge-static}`
 * - `{@link Core.helper.ObjectHelper#function-setPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-typeOf-static}`
 * @internal
 */

class Objects {
  static assign(dest, ...sources) {
    for (let source, key, i = 0; i < sources.length; i++) {
      source = sources[i];

      if (source) {
        for (key in source) {
          dest[key] = source[key];
        }
      }
    }

    return dest;
  }

  static assignIf(dest, ...sources) {
    for (let source, key, i = 0; i < sources.length; i++) {
      source = sources[i];

      if (source) {
        for (key in source) {
          if (!(key in dest) || dest[key] === undefined) {
            dest[key] = source[key];
          }
        }
      }
    }

    return dest;
  }

  static blend(dest, source, options) {
    options = options || blendOptions;
    dest = dest || {};
    const {
      clone = Objects.clone,
      merge = Objects.blend
    } = options;

    if (Array.isArray(source)) {
      if (source.length > 1) {
        source.forEach(s => {
          dest = Objects.blend(dest, s, options);
        });
        return dest;
      }

      source = source[0];
    }

    if (source) {
      let destValue, key, value;

      for (key in source) {
        value = source[key];

        if (value && O.isObject(value)) {
          destValue = dest[key];
          options.key = key;

          if (destValue && O.isObject(destValue)) {
            if (isFrozen(destValue)) {
              dest[key] = destValue = clone(destValue, options);
            }

            value = merge(destValue, value, options);
          } else {
            // We don't need to clone frozen objects, but we do clone mutable objects as they get
            // applied to the dest.
            value = isFrozen(value) ? value : clone(value, options);
          }
        }

        dest[key] = value;
      }
    }

    return dest;
  }

  static clone(value, handler) {
    let cloned = value,
        key;

    if (value && typeof value === 'object') {
      const options = handler && typeof handler === 'object' && handler;

      if (options) {
        // When using blend(), the 2nd argument is the options object, so ignore that case
        handler = null;
      }

      if (O.isObject(value)) {
        cloned = {};

        for (key in value) {
          cloned[key] = O.clone(value[key]);
        }
      } else if (Array.isArray(value)) {
        cloned = []; // Loop backwards to:
        //  1. read source.length once
        //  2. get result array sized on first pass (avoid growing)

        for (key = value.length; key-- > 0;) {
          cloned[key] = O.clone(value[key]);
        }
      } else if (O.isDate(value)) {
        cloned = new Date(value.getTime());
      } else if (handler) {
        // Allow other types to be handled (e.g., DOM nodes).
        cloned = handler(value);
      }
    }

    return cloned;
  }

  static createTruthyKeys(source) {
    const keys = _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].split(source),
          result = keys && {};

    if (keys) {
      for (const key of keys) {
        // StringHelper.split won't return empty keys if passed a string, but we
        // could have been passed a String[]
        if (key) {
          result[key] = true;
        }
      }
    }

    return result;
  }
  /**
   * Returns value for a given path in the object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {*} Value associated with passed key
   */


  static getPath(object, path) {
    return path.split('.').reduce((result, key) => {
      return (result || emptyObject)[key];
    }, object);
  }
  /**
   * Returns value for a given path in the object, placing a passed default value in at the
   * leaf property and filling in undefined properties all the way down.
   * @param {Object} object Object to get path value for.
   * @param {String|Number|String[]|Number[]} path Dot-separated path, e.g. 'firstChild.childObject.someKey',
   * or the key path as an array, e.g. ['firstChild', 'childObject', 'someKey'].
   * @param {*} [defaultValue] Optionally the value to put in as the `someKey` property.
   * @returns {*} Value at the leaf position of the path.
   */


  static getPathDefault(object, path, defaultValue) {
    const keys = Array.isArray(path) ? path : typeof path === 'string' ? path.split('.') : [path],
          length = keys.length - 1;
    return keys.reduce((result, key, index) => {
      if (defaultValue && !(key in result)) {
        // Can't use emptyObject here, we are creating a node in the object tree
        result[key] = index === length ? defaultValue : {};
      }

      return (result || emptyObject)[key];
    }, object);
  }
  /**
   * Determines if the specified path exists
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {Boolean}
   */


  static hasPath(object, path) {
    return path.split('.').every(key => {
      if (key in object) {
        object = object[key];
        return true;
      }

      return false;
    });
  }

  static getTruthyKeys(source) {
    const keys = [];

    for (const key in source) {
      if (source[key]) {
        keys.push(key);
      }
    }

    return keys;
  }

  static getTruthyValues(source) {
    const values = [];

    for (const key in source) {
      if (source[key]) {
        values.push(source[key]);
      }
    }

    return values;
  }

  static isClass(object) {
    var _object$prototype;

    if (typeof object === 'function' && ((_object$prototype = object.prototype) === null || _object$prototype === void 0 ? void 0 : _object$prototype.constructor) === object) {
      // TODO find a way to differentiate function(){} from class{}
      return true;
    }

    return false;
  }

  static isDate(object) {
    // A couple quick rejections but only sure way is typeOf:
    return Boolean(object && object.getUTCDate) && O.typeOf(object) === 'date';
  }
  /**
   * Check if passed object is a Promise or contains `then` method.
   * Used to fix problems with detecting promises in code with `instance of Promise` when
   * Promise class is replaced with any other implementation like `ZoneAwarePromise` in Angular.
   * Related to these issues:
   * https://github.com/bryntum/support/issues/791
   * https://github.com/bryntum/support/issues/2990
   *
   * @param {Object} object object to check
   * @returns {Boolean} truthy value if object is a Promise
   * @internal
   */


  static isPromise(object) {
    if (Promise && Promise.resolve) {
      return Promise.resolve(object) === object || typeof (object === null || object === void 0 ? void 0 : object.then) === 'function';
    }

    throw new Error('Promise not supported in your environment');
  }

  static isEmpty(object) {
    if (object && typeof object === 'object') {
      // eslint-disable-next-line no-unreachable-loop
      for (const p in object) {
        // eslint-disable-line no-unused-vars
        return false;
      }
    }

    return true;
  }

  static isObject(value) {
    const C = value === null || value === void 0 ? void 0 : value.constructor;
    return Boolean(C // Most things have a .constructor property
    ? // An in-frame instance of Object
    C === Object || // Detect cross-frame objects, but exclude instance of custom classes named Object. typeOf(value) is
    // "object" even for instances of a class and typeOf(C) is "function" for all constructors. We'll have
    // to settle for relying on the fact that getPrototypeOf(Object.prototype) === null.
    // NOTE: this issue does come up in Scheduler unit tests at least.
    // NOTE: IE11 does not have C.name === 'Object' for cross-frame objects! So instead of that check we
    //  do a presence check for a method unlikely to be found elsewhere.
    C.getPrototypeOf && C.prototype && !Object.getPrototypeOf(C.prototype) // Since all classes have a constructor property, an object w/o one is likely from Object.create(null). Of
    // course, primitive types do not have ".constructor"
    : value && typeof value === 'object');
  }

  static isInstantiated(object) {
    return object ? typeof object === 'object' && !Objects.isObject(object) : false;
  }

  static merge(dest, ...sources) {
    return Objects.blend(dest, sources);
  }
  /**
   * Merges two "items" objects. An items object is a simple object whose keys act as identifiers and whose values
   * are "item" objects. An item can be any object type. This method is used to merge such objects while maintaining
   * their property order. Special key syntax is used to allow a source object to insert a key before or after a key
   * in the `dest` object.
   *
   * For example:
   * ```javascript
   *  let dest = {
   *      foo : {},
   *      bar : {},
   *      fiz : {}
   *  }
   *
   *  console.log(Object.keys(dest));
   *  > ["foo", "bar", "fiz"]
   *
   *  dest = mergeItems(dest, {
   *      'zip > bar' : {}    // insert "zip" before "bar"
   *      'bar < zap' : {}    // insert "zap" after "bar"
   *  });
   *
   *  console.log(Object.keys(dest));
   *  > ["foo", "zip", "bar", "zap", "fiz"]
   * ```
   *
   * @param {Object} dest The destination object.
   * @param {Object|Object[]} src The source object or array of source objects to merge into `dest`.
   * @param {Object} [options] The function to use to merge items.
   * @param {Function} [options.merge] The function to use to merge items.
   * @returns {Object} The merged object. On ES6 standard browsers, this will be the `dest` object. On IE11 it will
   * be a new object.
   * @internal
   */


  static mergeItems(dest, src, options) {
    options = options || blendOptions;
    let anchor, delta, index, indexMap, key, shuffle, srcVal;
    const {
      merge = Objects.blend,
      rebuild = !Objects.ES6_OBJECT_ORDER
    } = options;
    dest = dest || {};

    if (Array.isArray(src)) {
      src.forEach(s => {
        dest = Objects.mergeItems(dest, s, options);
      });
    } else if (src) {
      // https://2ality.com/2015/10/property-traversal-order-es6.html
      // Bottom line: Object keys are iterated in declared/insertion order... unless the key is an integer or
      // Symbol, but we don't care about those generally.
      for (key in src) {
        srcVal = src[key];
        anchor = null; // Allow a key to be added before or after another:
        //
        //  {
        //      'foo > bar' : {
        //          ...
        //      },
        //      'bar < derp' : {
        //          ...
        //      }
        //  }
        //
        // The goal above is to add a 'foo' key before the existing 'bar' key while adding a 'derp' key after
        // 'bar'.

        if (key.includes('>')) {
          [key, anchor] = key.split(beforeRe);
          delta = 0;
        } else if (key.includes('<')) {
          [anchor, key] = key.split(afterRe);
          delta = 1;
        }

        if (key in dest) {
          // Changing the value of a key does not change its iteration order. Since "key in dest" we can do
          // what we need directly.
          if (srcVal && dest[key] && merge) {
            options.key = key;
            srcVal = merge(dest[key], srcVal, options);
          }

          dest[key] = srcVal;
        } else if (!anchor) {
          var _indexMap;

          dest[key] = srcVal;
          (_indexMap = indexMap) === null || _indexMap === void 0 ? void 0 : _indexMap.set(key, indexMap.size);
        } else {
          // Lazily sprout the item index map. When we first merge an item into an items object, we create this
          // Map to control the ordering. This is because any keys we add would necessarily be iterated after
          // the original properties.
          if (!indexMap) {
            indexMap = new Map();
            index = 0;

            for (const k in dest) {
              indexMap.set(k, index++);
            }
          }

          index = indexMap.get(anchor);
          dest[key] = srcVal;

          if (index == null && delta) {
            index = indexMap.size;
          } else {
            shuffle = !rebuild && (shuffle || []);
            index = (index || 0) + delta; // Adjust all key indices >= index up by 1 to maintain integer indices (required by the above
            // use case).

            for (const item of indexMap) {
              const [k, v] = item;

              if (index <= v) {
                /*
                Consider object w/the following order:
                    {
                        foo : {}',
                        bar : {},
                        baz : {},
                        zip : {},
                        goo : {},
                        fiz : {}
                    }
                The indexMap is:
                    foo : 0
                    bar : 1
                    baz : 2
                    zip : 3
                    goo : 4
                    fiz : 5
                To insert before goo, we populate shuffle thusly (to set up for popping):
                    +-----+-----+
                    | fiz | goo |
                    +-----+-----+
                      0        1
                      =6-5-1   =6-4-1
                */
                shuffle && (shuffle[indexMap.size - v - 1] = k);
                indexMap.set(k, v + 1);
              }
            } // Delete and re-add the keys that should follow the new key to establish the iteration order
            // we need:


            if (shuffle) {
              while (shuffle.length) {
                const k = shuffle.pop(),
                      v = dest[k];
                delete dest[k];
                dest[k] = v;
              }
            }
          }

          indexMap.set(key, index);
        }
      } // IE11 does not fully support the ES6 object order standard. Fortunately, it does support the most
      // basic form of building an object from key/values in the desired order. The behavior observed for IE11
      // is that when a key is deleted and put back, it retains its original position instead of becoming the
      // last key.


      if (rebuild && indexMap) {
        const entries = Array.from(indexMap.entries()).sort((a, b) => a[1] - b[1]),
              old = dest;
        dest = {};

        for (let k, i = 0; i < entries.length; ++i) {
          k = entries[i][0];
          dest[k] = old[k];
        }
      }
    }

    return dest;
  }
  /**
   * Sets value for a given path in the object
   * @param {Object} object Target object
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @param {*} value Value for a given path
   * @returns {Object} Returns passed object
   */


  static setPath(object, path, value) {
    path.split('.').reduce((result, key, index, array) => {
      const isLast = index === array.length - 1;

      if (isLast) {
        return result[key] = value;
      } else if (!(result[key] instanceof Object)) {
        result[key] = {};
      }

      return result[key];
    }, object);
    return object;
  }

  static typeOf(value) {
    let type = typeof value,
        match,
        trueType; // If not atomic type, we handle date or null

    if (type === 'object') {
      if (value === null) {
        type = 'null';
      } else {
        trueType = toString.call(value);

        if (!(type = typeCache[trueType])) {
          match = typeNameRe.exec(trueType);
          typeCache[trueType] = type = match ? match[1].toLowerCase() : trueType;
        }
      }
    } // NaN is the only value that is !== to itself
    else if (value !== value) {
      // eslint-disable-line no-self-compare
      type = 'nan';
    }

    return type;
  }

}
const O = Objects;

O.ES6_OBJECT_ORDER = (() => {
  const o = {
    a: 1,
    b: 2
  };
  o.c = 3; // silly IE! keys should go to the end even if previously present...

  delete o.b;
  o.b = 20;
  const keys = Object.keys(o);
  return keys[1] === 'c';
})();

Objects._$name = 'Objects';

/***/ }),

/***/ "./lib/Core/helper/util/Point.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/util/Point.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Point; });
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';

/**
 * @module Core/helper/util/Point
 */

/**
 * Encapsulates an X,Y coordinate point.
 * @extends Core/helper/util/Rectangle
 */

class Point extends _Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Creates a new Point encapsulating the event's page position.
   * @param {Event} event
   * @return {Core.helper.util.Point}
   * @typings ignore
   */
  static from(event) {
    const touchPoints = event.changedTouches;
    return new Point(touchPoints ? touchPoints[0].screenX : event.screenX, touchPoints ? touchPoints[0].screenY : event.pageY);
  }
  /**
   * Constructs a Point
   * @param x The X coordinate
   * @param y The Y coordinate
   */


  constructor(x, y) {
    super(x, y, 0, 0);
  }
  /**
   * Coerces this Point to be within the passed Rectangle. Translates it into the bounds.
   * @param {Core.helper.util.Rectangle} into The Rectangle into which to coerce this Point.
   */


  constrain(into) {
    this.x = Math.min(Math.max(this.x, into.x), into.right - 1);
    this.y = Math.min(Math.max(this.y, into.y), into.bottom - 1);
    return this;
  }

  toArray() {
    return [this.x, this.y];
  }

} // The Rectangle class uses the Point class, but cannot import it.
// TODO: find a better way of getting a reference to the Point class in Rectangle.
// #8224 - Gantt angular demo doesn't work in production

Object.getPrototypeOf(Point).Point = Point;
Point._$name = 'Point';

/***/ }),

/***/ "./lib/Core/helper/util/Promissory.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Promissory.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Promissory; });
var productName = 'gantt';
/**
* @module Core/helper/util/Promissory
*/

/**
 * Encapsulates a Promise and provides `resolve()` and `reject()` methods.
 *
 * For example:
 * ```
 *  load() {
 *      this.loading = new Promissory();
 *      this.store.load();
 *
 *      return this.loading.promise;
 *  }
 *
 *  onStoreLoad(store, err) {
 *      if (err) {
 *          this.loading.resolve(this);
 *      }
 *      else {
 *          this.loading.reject(err);
 *      }
 *  }
 *
 * ```
 * @internal
 */

class Promissory {
  constructor(fn) {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    if (fn) {
      fn(this);
    }
  }

}
Promissory._$name = 'Promissory';

/***/ }),

/***/ "./lib/Core/helper/util/RandomGenerator.js":
/*!*************************************************!*\
  !*** ./lib/Core/helper/util/RandomGenerator.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RandomGenerator; });
var productName = 'gantt';
/**
* @module Core/helper/util/RandomGenerator
*/

/**
 * Generates pseudo random numbers from predefined sequence of 100 numbers
 */

class RandomGenerator {
  constructor() {
    this.random100 = [46, 2, 36, 46, 54, 59, 18, 20, 71, 55, 88, 98, 13, 61, 61, 40, 2, 15, 3, 32, 51, 45, 64, 25, 81, 85, 54, 13, 57, 49, 64, 22, 81, 94, 0, 62, 17, 7, 11, 2, 33, 99, 85, 26, 83, 83, 96, 26, 20, 89, 91, 38, 26, 13, 11, 79, 32, 30, 5, 51, 70, 7, 5, 56, 58, 77, 37, 89, 40, 80, 78, 59, 26, 36, 8, 51, 60, 23, 86, 5, 11, 96, 64, 94, 87, 64, 4, 78, 17, 85, 35, 0, 90, 86, 23, 55, 53, 9, 35, 59, 29, 2, 64, 42, 8, 49, 43, 73, 6, 53, 38, 9, 39, 31, 32, 40, 49, 13, 78, 68, 20, 99, 24, 78, 35, 91, 73, 46, 67, 76, 89, 69, 30, 69, 25, 3, 4, 55, 1, 65, 66, 76, 83, 19, 67, 1, 95, 24, 54, 45, 56, 40, 67, 92, 72, 4, 69, 8, 47, 50, 27, 2, 38, 9, 14, 83, 12, 14, 62, 95, 22, 47, 35, 18, 38, 14, 86, 64, 68, 61, 52, 69, 39, 93, 20, 73, 32, 52, 74, 6, 56, 68, 99, 29, 24, 92, 40, 67, 6, 72, 31, 41, 91, 53, 80, 55, 33, 97, 97, 99, 18, 20, 5, 27, 82, 84, 61, 78, 27, 67, 7, 42, 75, 95, 91, 25, 63, 21, 70, 36, 46, 0, 1, 45, 84, 6, 86, 15, 10, 62, 96, 94, 10, 23, 93, 83, 94, 47, 5, 29, 29, 52, 51, 37, 77, 96, 43, 72, 43, 14, 54, 14, 72, 52, 4, 39, 15, 26, 68, 28, 25, 76, 60, 50, 22, 40, 72, 74, 68, 58, 8, 48, 40, 62, 52, 24, 9, 26, 47, 44, 49, 96, 7, 77, 90, 45, 76, 47, 5, 86, 1, 36, 18, 42, 19, 90, 34, 23, 70, 32, 69, 79, 0, 99, 57, 80, 72, 21, 19, 72, 85, 68, 4, 40, 86, 62, 0, 63, 4, 11, 69, 31, 78, 31, 21, 78, 29, 84, 13, 53, 57, 10, 26, 50, 24, 30, 90, 42, 51, 96, 93, 21, 99, 23, 81, 0, 89, 43, 86, 63, 93, 19, 54, 71, 92, 36, 4, 95, 37, 99, 60, 29, 23, 50, 68, 95, 57, 95, 77, 53, 99, 78, 75, 12, 92, 47, 23, 14, 0, 41, 98, 11, 34, 64, 26, 90, 50, 23, 38, 31, 74, 76, 16, 76, 66, 23, 22, 72, 48, 50, 20, 36, 37, 58, 5, 43, 49, 64, 81, 30, 8, 21, 98, 75, 60, 17, 50, 42, 27, 38, 90, 74, 45, 68, 67, 27, 31, 15, 58, 76, 41, 99, 23, 98, 53, 98, 56, 19, 79, 2, 4, 38, 96, 24, 65, 51, 43, 42, 41, 60, 46, 7, 90, 65, 3, 27, 63, 99, 51, 44, 86, 1, 54, 40, 15, 74, 3, 81, 51, 63, 87, 79, 84, 72, 22, 38, 96, 95, 33, 41, 21, 99, 21, 69, 7, 49, 40, 52, 41, 6, 91, 19, 76, 40, 54, 17, 33, 11, 11, 0, 1, 32, 94, 33, 13, 18, 45, 7, 85, 61, 42, 54, 45, 72, 78, 96, 17, 9, 80, 87, 41, 96, 66, 0, 8, 59, 18, 21, 2, 28, 64, 75, 97, 32, 80, 86, 97, 97, 55, 2, 73, 75, 11, 89, 67, 58, 70, 76, 12, 46, 64, 17, 22, 97, 25, 35, 93, 57, 82, 46, 57, 61, 31, 74, 27, 4, 32, 85, 53, 86, 53, 53, 42, 5, 28, 50, 65, 63, 70, 61, 73, 37, 13, 80, 7, 34, 22, 3, 26, 6, 62, 78, 12, 56, 87, 41, 58, 64, 31, 27, 45, 35, 18, 66, 62, 43, 89, 69, 94, 93, 33, 74, 2, 43, 85, 37, 82, 41, 74, 9, 15, 44, 33, 42, 65, 19, 1, 49, 78, 12, 29, 9, 78, 7, 55, 12, 45, 40, 33, 16, 86, 14, 52, 16, 73, 76, 0, 98, 75, 91, 78, 46, 99, 95, 90, 69, 78, 45, 62, 55, 37, 88, 49, 77, 27, 83, 38, 73, 39, 1, 75, 40, 65, 83, 54, 95, 7, 73, 4, 30, 26, 36, 89, 21, 5, 95, 11, 14, 87, 45, 36, 21, 77, 55, 5, 66, 51, 98, 48, 62, 74, 58, 23, 82, 30, 28, 19, 53, 89, 76, 98, 8, 34, 70, 28, 54, 16, 52, 35, 93, 54, 54, 72, 49, 18, 93, 72, 90, 71, 73, 15, 60, 38, 80, 76, 53, 70, 39, 69, 25, 5, 31, 61, 46, 6, 54, 34, 31, 52, 33, 36, 79, 76, 44, 29, 28, 38, 1, 66, 2, 90, 91, 1, 76, 78, 31, 55, 37, 71, 2, 3, 38, 85, 0, 95, 42, 2, 39, 57, 87, 61, 77, 98, 2, 24, 80, 48, 27, 47, 71, 15, 7, 49, 60, 86, 3, 2, 29, 38, 54, 36, 59, 83, 27, 47, 9, 36, 42, 8, 73, 85, 9, 16, 73, 60, 39, 12, 43, 25, 23, 29, 28, 47, 40, 77, 20, 89, 22, 30, 41, 59, 96, 19, 56, 20, 76, 73, 39, 46, 72, 40, 47, 37, 52, 29, 79, 37, 39, 50, 41, 87, 66, 17, 75, 31, 45, 26, 88, 70, 11, 90, 40, 74, 9, 32, 65, 72, 61, 6, 93, 54, 15, 84, 22, 99, 47, 10, 96, 4, 84, 19, 85, 73, 45, 25, 16, 8, 94, 99, 39, 28, 26, 68, 87, 48, 1, 65, 86, 46, 86, 7, 60, 82, 45, 75, 38, 56, 41, 35, 30, 86, 91, 97, 85, 45, 5, 14, 69, 85, 96, 37, 18, 26, 16, 38, 16, 1, 44, 94, 85, 58, 60, 20, 5, 47, 52, 41, 50, 71, 43, 42, 67, 64, 38, 65, 83, 99, 78, 96, 33, 20, 98, 24, 6, 2, 25, 16, 16, 44, 63, 24, 68, 56, 49, 91, 15, 59, 99, 27, 43, 34, 28, 36, 45, 1, 10, 19, 54, 26, 75, 17, 88, 96, 63, 24, 71, 93, 72, 97, 66, 87, 18, 86];
    this.randomCache = {};
    this.rndIndex = 0;
  }
  /**
   * Returns next pseudo random integer number from sequence between 0 and max parameter value (99 is maximum value)
   * @param {Number} max max value
   * @returns {Number}
   */


  nextRandom(max) {
    let randomCache = this.randomCache,
        randomNumbers;

    if (randomCache[max]) {
      randomNumbers = randomCache[max];
    } else {
      randomNumbers = this.random100.filter(num => num < max);
      randomCache[max] = randomNumbers;
    }

    return randomNumbers[this.rndIndex++ % randomNumbers.length];
  }
  /**
   * Resets sequence to initial number
   */


  reset() {
    this.rndIndex = 0;
  }
  /**
   * Returns pseudo random array element
   * @param {Array} array input array
   * @returns {*}
   */


  fromArray(array) {
    return array[this.nextRandom(array.length)];
  }

}
RandomGenerator._$name = 'RandomGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/Rectangle.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Rectangle.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Rectangle; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';
/**
* @module Core/helper/util/Rectangle
*/





const allBorders = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'],
      allMargins = ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
      allPaddings = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
      borderNames = {
  t: 'border-top-width',
  r: 'border-right-width',
  b: 'border-bottom-width',
  l: 'border-left-width'
},
      paddingNames = {
  t: 'padding-top',
  r: 'padding-right',
  b: 'padding-bottom',
  l: 'padding-left'
},
      zeroBased = Object.freeze({
  x: 0,
  y: 0
}),
      alignSpecRe = /^([trblc])(\d*)-([trblc])(\d*)$/i,
      alignPointRe = /^([trblc])(\d*)$/i,
      edgeNames = ['top', 'right', 'bottom', 'left'],
      edgeIndices = {
  t: 0,
  r: 1,
  b: 2,
  l: 3
},
      defaultAlignments = ['b-t', 'l-r', 't-b', 'r-l'],
      edgeAligments = {
  bt: 1,
  tb: 1,
  lr: 1,
  rl: 1
},
      zeroOffsets = Object.freeze([0, 0]),
      matchDimensions = ['width', 'height'],
      parseEdges = (top, right = top, bottom = top, left = right) => {
  return Array.isArray(top) ? parseEdges.apply(null, top) : [top, right, bottom, left];
}; // Parse a l0-r0 (That's how Menus align to their owning MenuItem) align spec.


function parseAlign(alignSpec) {
  const parts = alignSpecRe.exec(alignSpec),
        myOffset = parseInt(parts[2] || 50),
        targetOffset = parseInt(parts[4] || 50),
        myEdge = parts[1],
        targetEdge = parts[3],
        edgeAligned = edgeAligments[myEdge + targetEdge]; // Comments assume the Menu's alignSpec of l0-r0 is used.

  return {
    myAlignmentPoint: myEdge + myOffset,
    // l0
    myEdge,
    // l
    myOffset,
    // 0
    targetAlignmentPoint: targetEdge + targetOffset,
    // r0
    targetEdge,
    // r
    targetOffset,
    // 0
    startZone: edgeIndices[targetEdge],
    // 1 - start trying zone 1 in TRBL order
    edgeAligned // Edge-to-edge align requested

  };
} // Takes a result from the above function and flips edges for the axisLock config


function flipAlign(align) {
  return `${edgeNames[(edgeIndices[align.myEdge] + 2) % 4][0]}${align.myOffset}-${edgeNames[(edgeIndices[align.targetEdge] + 2) % 4][0]}${align.targetOffset}`;
}

function createOffsets(offset) {
  if (offset == null) {
    return zeroOffsets;
  } else if (typeof offset === 'number') {
    return [offset, offset];
  }

  return offset;
}
/**
 * Encapsulates rectangular areas for comparison, intersection etc.
 *
 * Note that the `right` and `bottom` properties are *exclusive*.
 *
 */


class Rectangle {
  // Class does not extend Base, so we need to define this
  get isRectangle() {
    return true;
  }
  /**
   * Returns the Rectangle in document based coordinates of the passed element.
   *
   * *Note:* If the element passed is the `document` or `window` the `window`'s
   * rectangle is returned which is always at `[0, 0]` and encompasses the
   * browser's entire document viewport.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static from(element, relativeTo, ignorePageScroll) {
    var _element$namespaceURI;

    if (element.isRectangle) {
      return element;
    }

    if (ignorePageScroll === undefined && typeof relativeTo === 'boolean') {
      ignorePageScroll = relativeTo;
      relativeTo = null;
    }

    if (relativeTo) {
      // TODO: nige should figure out if there is a better solution
      let {
        scrollLeft,
        scrollTop
      } = relativeTo;

      if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSafari) && relativeTo === document.body) {
        scrollLeft = scrollTop = 0;
      }

      relativeTo = Rectangle.from(relativeTo).translate(-scrollLeft, -scrollTop);
    } else {
      relativeTo = zeroBased;
    } // Viewport is denoted by requesting window or document.
    // document.body may overflow the viewport, so this must not be evaluated as the viewport.


    const // If body is 0 height we should treat this case as a viewport
    isViewport = element === document || element === window,
          isSFViewport = element === document.body && document.body.offsetHeight === 0,
          sfElRect = isSFViewport && element.getBoundingClientRect(),
          viewRect = isSFViewport // In Salesforce body and html have 0 height so to get correct viewport vertical size we have to use
    // scrollHeight on html element.
    ? new Rectangle(sfElRect.left, sfElRect.top, sfElRect.width, document.body.parentElement.scrollHeight) : isViewport ? new Rectangle(0, 0, window.innerWidth, window.innerHeight) : element.getBoundingClientRect(),
          scrollOffset = ignorePageScroll || isViewport ? [0, 0] : [window.pageXOffset, window.pageYOffset];
    let scaleX = 0,
        scaleY = 0; // scaleX/Y is required to adjust scaled SVG element bounding rect

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEdge && (_element$namespaceURI = element.namespaceURI) !== null && _element$namespaceURI !== void 0 && _element$namespaceURI.match(/svg/)) {
      var _element$dataset, _element$dataset2;

      scaleX = ((_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.scaleX) || 0;
      scaleY = ((_element$dataset2 = element.dataset) === null || _element$dataset2 === void 0 ? void 0 : _element$dataset2.scaleY) || 0;
    }

    return new Rectangle(viewRect.left + scrollOffset[0] - relativeTo.x + scaleX / 2, viewRect.top + scrollOffset[1] - relativeTo.y + scaleY / 2, viewRect.width - scaleX, viewRect.height - scaleY);
  }
  /**
   * Returns the Rectangle in viewport coordinates of the passed element.
   *
   * *Note:* If the element passed is the `document` or `window` the `window`'s rectangle is returned which is always
   * at `[0, 0]` and encompasses the browser's entire document viewport.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @return {Core.helper.util.Rectangle} The Rectangle in viewport based coordinates. Relative to the _relativeTo_
   * parameter if provided.
   */


  static fromScreen(element, relativeTo) {
    return Rectangle.from(element, relativeTo,
    /* ignorePageScroll = */
    true);
  }
  /**
   * Returns the inner Rectangle (within border) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static inner(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allBorders);
      result.x += parseFloat(borders[borderNames.l]);
      result.y += parseFloat(borders[borderNames.t]);
      result.right -= parseFloat(borders[borderNames.r]);
      result.bottom -= parseFloat(borders[borderNames.b]);
    }

    return result;
  }
  /**
   * Returns the content Rectangle (within border and padding) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static content(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allBorders),
            padding = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allPaddings);
      result.x += parseFloat(borders[borderNames.l]) + parseFloat(padding[paddingNames.l]);
      result.y += parseFloat(borders[borderNames.t]) + parseFloat(padding[paddingNames.t]);
      result.right -= parseFloat(borders[borderNames.r]) + parseFloat(padding[paddingNames.r]);
      result.bottom -= parseFloat(borders[borderNames.b]) + parseFloat(padding[paddingNames.b]);
    }

    return result;
  }
  /**
   * Returns the client Rectangle (within border and padding and scrollbars) in document based coordinates of the
   * passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static client(element, relativeTo, ignorePageScroll = false) {
    const result = this.content(element, relativeTo, ignorePageScroll),
          scrollbarWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].scrollBarWidth;
    let padding;

    if (scrollbarWidth) {
      // Capture width taken by any vertical scrollbar.
      // If there is a vertical scrollbar, shrink the box.
      // TODO: We may have to shrink from the left in RTL mode.
      if (element.scrollHeight > element.clientHeight && _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'overflow-y') !== 'hidden') {
        padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'padding-right'));
        result.right += padding - Math.max(padding, scrollbarWidth);
      } // Capture height taken by any horizontal scrollbar.
      // If there is a horizontal scrollbar, shrink the box.


      if (element.scrollWidth > element.clientWidth && _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'overflow-x') !== 'hidden') {
        padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'padding-bottom'));
        result.bottom += padding - Math.max(padding, scrollbarWidth);
      }
    } // The client region excluding any scrollbars.


    return result;
  }
  /**
   * Returns the outer Rectangle (including margin) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates.
   * Relative to the _relativeTo_ parameter if passed.
   * @internal
   */


  static outer(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const margin = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allMargins);
      result.x -= parseFloat(margin['margin-left']);
      result.y -= parseFloat(margin['margin-top']);
      result.right += parseFloat(margin['margin-right']);
      result.bottom += parseFloat(margin['margin-bottom']);
    }

    return result;
  }
  /**
   * Returns a new rectangle created as the union of all supplied rectangles.
   * @param {Core.helper.util.Rectangle[]} rectangles
   * @return {Core.helper.util.Rectangle}
   */


  static union(...rectangles) {
    let {
      x,
      y,
      right,
      bottom
    } = rectangles[0],
        current;

    if (rectangles.length > 1) {
      for (let i = 1; i < rectangles.length; i++) {
        current = rectangles[i];

        if (current.x < x) {
          x = current.x;
        }

        if (current.y < y) {
          y = current.y;
        }

        if (current.right > right) {
          right = current.right;
        }

        if (current.bottom > bottom) {
          bottom = current.bottom;
        }
      }
    }

    return new Rectangle(x, y, right - x, bottom - y);
  }
  /**
   * Rounds this Rectangle to the pixel resolution of the current display or to the nearest
   * passed unit which defaults to the current display's [`devicePixelRatio`](https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio).
   * @param {Number} [devicePixelRatio] device pixel ratio which defaults to `window.devicePixelRatio`
   */


  roundPx(devicePixelRatio = window.devicePixelRatio || 1) {
    const me = this;
    me._x = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._x, devicePixelRatio);
    me._y = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._y, devicePixelRatio);
    me._width = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._width, devicePixelRatio);
    me._height = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._height, devicePixelRatio);
    return me;
  } // This class doesn't extend Base and extending doesn't seem to be
  // the way to go. Instead we duplicate smallest piece of logic here


  static get $$name() {
    return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
    hasOwnProperty.call(this, '_$name') && this._$name || this.name;
  }

  get $$name() {
    return this.constructor.$$name;
  }
  /**
   * Constructs a Rectangle
   * @param {Number} x The X coordinate
   * @param {Number} y The Y coordinate
   * @param {Number} width The width
   * @param {Number} height The height
   */


  constructor(x, y, width, height) {
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(x, 'Rectangle.x');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(y, 'Rectangle.y');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(width, 'Rectangle.width');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(height, 'Rectangle.height');
    const me = this;
    me._x = x;
    me._y = y;
    me._width = width;
    me._height = height;
  }
  /**
   * Creates a copy of this Rectangle.
   */


  clone() {
    const me = this,
          result = new Rectangle(me.x, me.y, me.width, me.height);
    result.isAlignRectangle = me.isAlignRectangle;
    result.minHeight = me.minHeight;
    result.minWidth = me.minWidth;
    return result;
  }
  /**
   * Returns `true` if this Rectangle wholly contains the passed rectangle.
   *
   * Note that a {@link Core.helper.util.Point} may be passed.
   * @param {Core.helper.util.Rectangle} other The Rectangle to test for containment within this Rectangle
   * @return {Boolean} `true` if the other Rectangle is wholly contained within this Rectangle
   */


  contains(other) {
    const me = this;

    if (other.isRectangle) {
      return other._x >= me._x && other._y >= me._y && other.right <= me.right && other.bottom <= me.bottom;
    } else {
      return false;
    }
  }
  /**
   * Checks if this Rectangle intersects the passed Rectangle
   * @param {Core.helper.util.Rectangle} other The Rectangle to intersect with this.
   * @param {Boolean} [useBoolean] Specify `true` to return a boolean value instead of constructing a new Rectangle
   * @param {Boolean} [allowZeroDimensions] `true` to consider zero-width or zero-hight rectangles as intersecting if coordinates indicate the intersection
   * @return {Core.helper.util.Rectangle|Boolean} Returns the intersection Rectangle or `false` if there is no intersection.
   */


  intersect(other, useBoolean = false, allowZeroDimensions = false) {
    const me = this,
          y = Math.max(me.y, other.y),
          r = Math.min(me.right, other.right),
          b = Math.min(me.bottom, other.bottom),
          x = Math.max(me.x, other.x),
          intersect = allowZeroDimensions ? b >= y && r >= x : b > y && r > x;

    if (intersect) {
      return useBoolean ? true : new Rectangle(x, y, r - x, b - y);
    } else {
      return false;
    }
  }

  equals(other, round = false) {
    const processor = round ? x => Math.round(x) : x => x;
    return other.isRectangle && processor(other.x) === processor(this.x) && processor(other.y) === processor(this.y) && processor(other.width) === processor(this.width) && processor(other.height) === processor(this.height);
  }
  /**
   * Translates this Rectangle by the passed vector. Size is maintained.
   * @param {Number} x The X translation vector.
   * @param {Number} y The Y translation vector.
   * @returns This Rectangle;
   */


  translate(x, y) {
    this._x += x || 0;
    this._y += y || 0;
    return this;
  }
  /**
   * Moves this Rectangle to the passed `x`, `y` position. Size is maintained.
   * @param {Number} x The new X position.
   * @param {Number} y The new Y position.
   * @returns This Rectangle;
   */


  moveTo(x, y) {
    if (x != null) {
      this._x = x;
    }

    if (y != null) {
      this._y = y;
    }

    return this;
  }
  /**
   * Returns the vector which would translate this Rectangle (or Point) to the same position as the other Rectangle (or point)
   * @param {Core.helper.util.Rectangle|Core.helper.util.Point} other The Rectangle or Point to calculate the delta to.
   * @returns {Array} Returns a vector using format `[deltaX, deltaY]`
   * @internal
   */


  getDelta(other) {
    return [other.x - this.x, other.y - this.y];
  }
  /**
   * The center point of this rectangle.
   * @property {Core.helper.util.Point}
   */


  get center() {
    return new Rectangle.Point(this.x + this.width / 2, this.y + this.height / 2);
  }
  /**
   * Get/sets the X coordinate of the Rectangle. Note that this does *not* translate the
   * Rectangle. The requested {@link #property-width} will change.
   * @property {Number}
   */


  set x(x) {
    const xDelta = x - this._x;
    this._x = x;
    this._width -= xDelta;
  }

  get x() {
    return this._x;
  }
  /**
   * Alias for x. To match DOMRect.
   * @property {Number}
   */


  set left(x) {
    this.x = x;
  }

  get left() {
    return this.x;
  }
  /**
   * Alias for y. To match DOMRect.
   * @property {Number}
   */


  set top(y) {
    this.y = y;
  }

  get top() {
    return this.y;
  }
  /**
   * Get/sets the Y coordinate of the Rectangle. Note that this does *not* translate the
   * Rectangle. The requested {@link #property-height} will change.
   * @property {Number}
   */


  set y(y) {
    const yDelta = y - this._y;
    this._y = y;
    this._height -= yDelta;
  }

  get y() {
    return this._y;
  }
  /**
   * Get/sets the width of the Rectangle. Note that the requested {@link #property-right} will change.
   * @property {Number}
   */


  set width(width) {
    this._width = width;
  }

  get width() {
    return this._width;
  }
  /**
   * Get/sets the height of the Rectangle. Note that the requested {@link #property-bottom} will change.
   * @property {Number}
   */


  set height(height) {
    this._height = height;
  }

  get height() {
    return this._height;
  }
  /**
   * Get/sets the right edge of the Rectangle. Note that the requested {@link #property-width} will change.
   *
   * The right edge value is exclusive of the calculated rectangle width. So x=0 and right=10
   * means a width of 10.
   * @property {Number}
   */


  set right(right) {
    this._width = right - this._x;
  }

  get right() {
    return this._x + this._width;
  }
  /**
   * Get/sets the bottom edge of the Rectangle. Note that the requested {@link #property-height} will change.
   *
   * The bottom edge value is exclusive of the calculated rectangle height. So y=0 and bottom=10
   * means a height of 10.
   * @property {Number}
   */


  set bottom(bottom) {
    this._height = bottom - this._y;
  }

  get bottom() {
    return this._y + this._height;
  }

  get area() {
    return this.width * this.height;
  }

  set minWidth(minWidth) {
    const me = this;

    if (isNaN(minWidth)) {
      me._minWidth = null;
    } else {
      me._minWidth = Number(minWidth); // If this is being used as an alignment calculation rectangle, minWidth has a different meaning.
      // It does not mean that the width has to be at least this value. It means that under constraint,
      // it is willing to shrink down to that value before falling back to another align position.

      if (!me.isAlignRectangle) {
        me.width = Math.max(me.width, me._minWidth);
      }
    }
  }

  get minWidth() {
    return this._minWidth;
  }

  set minHeight(minHeight) {
    const me = this;

    if (isNaN(minHeight)) {
      me._minHeight = null;
    } else {
      me._minHeight = Number(minHeight); // If this is being used as an alignment calculation rectangle, minHeight has a different meaning.
      // It does not mean that the height has to be at least this value. It means that under constraint,
      // it is willing to shrink down to that value before falling back to another align position.

      if (!me.isAlignRectangle) {
        me.height = Math.max(me.height, me._minHeight);
      }
    }
  }

  get minHeight() {
    return this._minHeight;
  }
  /**
   * Modifies the bounds of this Rectangle by the specified deltas.
   * @param {Number} x How much to *add* to the x position.
   * @param {Number} y  How much to *add* to the y position.
   * @param {Number} width  How much to add to the width.
   * @param {Number} height  How much to add to the height.
   * @returns This Rectangle
   */


  adjust(x, y, width, height) {
    const me = this;
    me.x += x;
    me.y += y;
    me.width += width;
    me.height += height;
    return me;
  }
  /**
   * Modifies the bounds of this rectangle by expanding them by the specified amount in all directions.
   * The parameters are read the same way as CSS margin values.
   *
   * - If one value is passed, all edges are inflated by that value.
   * - If two values are passed they are top/bottom inflation and left/right inflation.
   * - If four values are passed, that's top, right, bottom, left.
   * @param {Number} amount How much to inflate, or the top value if more than one values passed.
   * @param {Number} right How much to inflate the right side, or both left and right is only two values passed.
   * @param {Number} bottom How much to inflate the bottom side.
   * @param {Number} left How much to inflate the left side.
   * @returns {Core.helper.util.Rectangle} This Rectangle
   * @internal
   */


  inflate(top, right = top, bottom = top, left = right) {
    if (Array.isArray(top)) {
      [top, right, bottom, left] = parseEdges(top);
    }

    return this.adjust(-left, -top, right, bottom);
  }
  /**
   * Modifies the bounds of this rectangle by reducing them by the specified amount in all directions.
   * The parameters are read the same way as CSS margin values.
   *
   * - If one value is passed, all edges are deflated by that value.
   * - If two values are passed they are top/bottom deflation and left/right deflation.
   * - If four values are passed, that's top, right, bottom, left.
   * @param {Number} amount How much to deflate, or the top value if more than one values passed.
   * @param {Number} right How much to deflate the right side, or both left and right is only two values passed.
   * @param {Number} bottom How much to deflate the bottom side.
   * @param {Number} left How much to deflate the left side.
   * @returns {Core.helper.util.Rectangle} This Rectangle
   * @internal
   */


  deflate(top, right = top, bottom = top, left = right) {
    if (Array.isArray(top)) {
      [top, right, bottom, left] = parseEdges(top);
    }

    return this.adjust(left, top, -right, -bottom);
  }
  /**
   * Attempts constrain this Rectangle into the passed Rectangle. If the `strict` parameter is `true`
   * then this method will return `false` if constraint could not be achieved.
   *
   * If this Rectangle has a `minHeight` or `minWidth` property, size will be adjusted while attempting to constrain.
   *
   * Right and bottom are adjusted first leaving the top and bottom sides to "win" in the case that this Rectangle overflows
   * the constrainTo Rectangle.
   * @param {Core.helper.util.Rectangle} constrainTo The Rectangle to constrain this Rectangle into if possible.
   * @param {Boolean} strict Pass `true` to return false, and leave this Rectangle unchanged if constraint
   * could not be achieved.
   * @returns This Rectangle. If `strict` is true, and constraining was not successful, `false`.
   */


  constrainTo(constrainTo, strict) {
    const me = this,
          originalHeight = me.height,
          originalY = me.y,
          minWidth = me.minWidth || me.width,
          minHeight = me.minHeight || me.height;

    if (me.height >= constrainTo.height) {
      // If we're strict, fail if we could *never* fit into available height.
      if (strict && minHeight > constrainTo.height) {
        return false;
      } // If we are >= constrain height, we will have to be at top edge of constrainTo


      me._y = constrainTo.y;
      me.height = constrainTo.height;
    }

    if (me.width >= constrainTo.width) {
      // If we're strict, fail if we could *never* fit into available width.
      if (strict && minWidth > constrainTo.width) {
        // Could not be constrained; undo any previous attempt with height
        me.y = originalY;
        me.height = originalHeight;
        return false;
      } // If we are >= constrain width, we will have to be at left edge of constrainTo


      me._x = constrainTo.x;
      me.width = constrainTo.width;
    }

    let overflow = me.bottom - constrainTo.bottom; // Overflowing the bottom side, translate upwards.

    if (overflow > 0) {
      me.translate(0, -overflow);
    }

    overflow = me.right - constrainTo.right; // Overflowing the right side, translate leftwards.

    if (overflow > 0) {
      me.translate(-overflow);
    }

    overflow = constrainTo.y - me.y; // Now, after possible translation upwards, we overflow the top, translate downwards.

    if (overflow > 0) {
      me.translate(0, overflow);
    }

    overflow = constrainTo.x - me.x; // Now, after possible translation leftwards, we overflow the left, translate rightwards.

    if (overflow > 0) {
      me.translate(overflow);
    }

    return me;
  }
  /**
   * Returns a cloned version of this Rectangle aligned to a target Rectangle, or element or {@link Core.widget.Widget}.
   * @param {Object} spec Alignment specification.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or element or Rectangle to align to.
   * @param {Number[]} [spec.anchorSize] The `[width, height]` of the anchor pointer when in `top` position. The
   * width is the baseline length, and the height is the height of the arrow. If passed, the anchor position
   * will be calculated to be at the centre of the overlap of the two aligned edges and returned in the `anchor`
   * property of the resulting Rectangle:
   *
   *     {
   *         edge: 'top',         // or 'right' or 'bottom' or 'left'
   *         x/y: offset          // dimension to translate and value to translate by.
   *     }
   *
   * @param {Object} [spec.anchorPosition] an `{ x: n, y: n }` anchor translation to be used *if the requested alignment
   * succeeds without violating constraints*. If a fallback alignment is used, the anchor will be centered in the
   * overlap of the aligned edges as usual.
   * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
   * @param {String} spec.align The edge alignment specification string, specifying two points to bring together.
   * The form is `[trblc][n]-[trblc][n]. The `n` is a percentage offset
   * along that edge which defines the alignment point. This is not valid for alignment point `c`.
   * For example `t0-b0' would align this Rectangle's top left corner with the bottom left corner of the `target`.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
   * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
   * to the `minWidth` and `minHeight` properties of this rectangle), then it will try aligning at other edges
   * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
   * @param {Boolean} [spec.axisLock] Specify as a truthy value to fall back to aligning against the opposite
   * edge first if the requested alignment cannot be constrained into the `constrainTo` option. If specified
   * as `'flexible'`, then fallback will continue searching for solutions on the remaining two sides.
   * @param {Boolean} [spec.matchSize] When aligning edge-to-edge, match the length of the aligned-to
   * edge of the target. This is only honored when `axisLock` is enabled and alignment succeeds on the requested axis.
   * If __not__ aligning edge-to-edge, `matchSize` matches both dimensions of the target.
   * @param {Number|Number[]} [spec.offset] The 'x' and 'y' offset values to create an extra margin round the target
   * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
   * towards the target - for example producing the effect of the anchor pointer piercing the target.
   * @param {Number|Number[]} [spec.constrainPadding] The amount of pixels to pad from the `constrainTo` target,
   * either a single value, or an array of values in CSS edge order.
   * @returns {Core.helper.util.Rectangle} A new Rectangle aligned as requested if possible, but if the requested position violates
   * the `constrainTo` Rectangle, the shortest translation from the requested position which obeys constraints will be used.
   */


  alignTo(spec) {
    // The target and constrainTo may be passed as HtmlElements or Widgets.
    // If so, extract the Rectangles without mutating the incoming spec.
    let result = this.clone(),
        {
      target,
      constrainTo,
      constrainPadding,
      matchSize
    } = spec,
        calculatedAnchorPosition,
        zone,
        resultZone,
        constrainingToViewport;

    if (target && !target.isRectangle) {
      target = Rectangle.from(target.element ? target.element : target);
    }

    if (constrainTo) {
      if (!constrainTo.isRectangle) {
        // Viewport is denoted by requesting window or document.
        // document.body may overflow the viewport, so this must not be evaluated as the viewport.
        constrainingToViewport = constrainTo === window || constrainTo === document; // When rectangle is constrained to some element on the page other than window/document, page scroll
        // should not be taken into account

        const ignorePageScroll = 'ignorePageScroll' in spec ? spec.ignorePageScroll : !constrainingToViewport;
        constrainTo = Rectangle.from(constrainTo.element ? constrainTo.element : constrainTo, null, ignorePageScroll);
      } // Shrink the constrainTo Rectangle to account for the constrainPadding


      if (constrainPadding) {
        // An array may be used to specify sides in the CSS standard order.
        // One value means all sides reduce by the same amount.
        constrainPadding = parseEdges(constrainPadding); // If we are aligning to an element which is closer to an edge than the
        // constrainPadding value for that edge, override the constrainPadding so that
        // the visual alignment is maintained.

        constrainPadding[0] = Math.min(constrainPadding[0], target.top);
        constrainPadding[1] = Math.min(constrainPadding[1], constrainTo.right - target.right);
        constrainPadding[2] = Math.min(constrainPadding[0], constrainTo.bottom - target.bottom);
        constrainPadding[3] = Math.min(constrainPadding[0], target.left); // Must clone a passed Rectangle so as not to mutate objects passed in.

        constrainTo = constrainTo.deflate.apply(constrainTo.clone(), constrainPadding);
      }
    }

    const me = this,
          targetOffsets = createOffsets(spec.offset),
          {
      align,
      axisLock,
      anchorSize,
      anchorPosition
    } = spec,
          alignSpec = parseAlign(align),
          position = spec.position || (target && target.$$name === 'Point' ? target : null),
          targetConstrainRect = constrainTo && constrainTo.clone(),
          constraintZones = [],
          zoneOrder = [{
      zone: zone = alignSpec.startZone,
      align
    }],
          matchDimension = matchSize && matchDimensions[alignSpec.startZone & 1],
          originalSize = me[matchDimension]; // Match the size of the edge we are aligning against

    if (matchDimension && axisLock) {
      result[matchDimension] = target[matchDimension];
    } // If we are not aligning to an edge, match both diensions.
    else if (!alignSpec.edgeAligned && matchSize) {
      result.width = target.width;
      result.height = target.height;
    } // Ensure we will fit before trying


    if (constrainTo) {
      result.constrainTo(constrainTo);
    } // If we are aligning edge-to-edge, then plan our fallback strategy when we are constrained.


    if (constrainTo && alignSpec.startZone != null) {
      // Create the list of zone numbers and alignments to try in the preferred order.
      //
      // In the case of axisLock, go through the zones by each axis.
      // So if they asked for t-b, which is zone 2,
      // the array will be [2, 0, 3, 1] (t-b, b-t, r-l, l-r)
      if (axisLock) {
        // First axis flip has to maintain the offset along that axis.
        // so align: l0-r0 has to flip to align: r0-l0. See submenu flipping when
        // constrained to the edge. It flips sides but maintains vertical position.
        zoneOrder.push({
          zone: zone = (zone + 2) % 4,
          align: flipAlign(alignSpec)
        }); // Only try the other axis is axisLock is 'flexible'

        if (axisLock === 'flexible') {
          zoneOrder.push({
            zone: zone = (alignSpec.startZone + 1) % 4,
            align: defaultAlignments[zone]
          });
          zoneOrder.push({
            zone: zone = (zone + 2) % 4,
            align: defaultAlignments[zone]
          });
        }
      } // Go through the zones in order from the requested start.
      // So if they asked for t-b, which is zone 2,
      // the array will be [2, 3, 0, 1] (t-b, r-l, b-t, l-r)
      else {
        for (let i = 1; i < 4; i++) {
          zoneOrder.push({
            zone: zone = (zone + 1) % 4,
            align: defaultAlignments[zone]
          });
        }
      }
    } // Allow them to pass anchorPosition: {x: 10} to indicate that after a fully successful,
    // unconstrained align, the anchor should be 10px from the start.


    if (anchorPosition) {
      const pos = alignSpec.startZone & 1 ? 'y' : 'x';
      calculatedAnchorPosition = {
        [pos]: anchorPosition[pos],
        edge: edgeNames[(alignSpec.startZone + 2) % 4]
      };
    } // Keep the target within reach. If it's way outside, pull it back so that it's only just outside);


    if (targetConstrainRect && target) {
      targetConstrainRect.adjust(-target.width, -target.height, target.width, target.height);
      target.constrainTo(targetConstrainRect);
    } // As part of fallback process when fitting within constraints, result may shrink to our minima


    result.minWidth = me.minWidth;
    result.minHeight = me.minHeight; // We're being commanded to try to align at a position

    if (position) {
      result.moveTo(position.x, position.y);

      if (constrainTo) {
        result.constrainTo(constrainTo);
      }
    } // We're aligning to a Target Rectangle within a ConstrainTo Rectangle, taking into account
    // a possible anchor pointer, or x/y offsets. Here's the situation:
    //
    //                             <-- ConstrainTo Rectangle -->
    //  +-----------------------------------+--------------------+-------------------------+
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |-----------------------------------+--------------------+-------------------------+
    //  |                                   |          ▼         |                         |
    //  |                                   | +----------------+ |                         |
    //  |                                   | |                | |                         |
    //  |                                   | |                | |                         |
    //  |                                   |▶|     Target     |◀|                         |
    //  |                                   | |                | |                         |
    //  |                                   | |                | |                         |
    //  |                                   | +----------------+ |                         |
    //  |                                   |          ▲         |                         |
    //  +-----------------------------------+--------------------+-------------------------|
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  +-----------------------------------+--------------------+-------------------------+
    //
    // Which results in the four possible constraint zones above, which we index in standard CSS order.
    //
    // Top    = 0
    // Right  = 1
    // Bottom = 2
    // Left   = 3
    //
    // If the initially requested alignment is not within the constrainTo rectangle
    // then, calculate these four, and then loop through them, beginning at the requested one,
    // quitting when we find a position which does not violate constraints. This includes
    // shrinking the aligning Rectangle towards its minima to attempt a fit.
    //
    // The final fallback, if there is no position which does not violate constraints
    // is to position in whichever of the four rectangles has the largest area shrinking overflowing
    // dimensions down to minima if specified.
    //
    else {
      // Offsets: If we are using an anchor to move away from the target, use anchor height in both dimensions.
      // It's rotated so that "height" always has the same meaning. It's the height of the arrow.
      const centerAligned = alignSpec.myEdge === 'c' || alignSpec.targetEdge === 'c',
            offsets = anchorSize && !centerAligned ? [anchorSize[1] + targetOffsets[0], anchorSize[1] + targetOffsets[1]] : targetOffsets,
            targetPoint = target.getAlignmentPoint(alignSpec.targetAlignmentPoint, offsets),
            myPoint = result.getAlignmentPoint(alignSpec.myAlignmentPoint);
      result.translate(targetPoint[0] - myPoint[0], targetPoint[1] - myPoint[1]); // If an overlapping position was requested, then we are *not* trying out those four zones.
      // We just respect constraint, and that's it.

      let overlap = result.intersect(target, true); // If we are aligned over our target, we just obey that within any constraint.
      // No complex edge alignment attempts to fall back to.

      if (overlap) {
        if (constrainTo) {
          result.constrainTo(constrainTo);
        }

        resultZone = alignSpec.startZone;
        result.translate(...offsets);
      } // Aligned to outside of our target, and we need to be constrained
      else if (constrainTo && !constrainTo.contains(result)) {
        let requestedResult = result.clone(),
            solutions = [],
            zone,
            largestZone; // Any configured anchorPosition becomes invalid now that we're having to move the resulting zone
        // to some unpredictable new place where it fits. It will have to be calculated based upon where
        // we end up aligning.

        calculatedAnchorPosition = null; // Calculate the four constraint zones illustrated above.
        // Top

        constraintZones[0] = zone = constrainTo.clone();
        zone.bottom = target.y - offsets[1]; // Right

        constraintZones[1] = zone = constrainTo.clone();
        zone.x = target.right + offsets[0]; // Bottom

        constraintZones[2] = zone = constrainTo.clone();
        zone.y = target.bottom + offsets[1]; // Left

        constraintZones[3] = zone = constrainTo.clone();
        zone.right = target.x - offsets[0]; // Start from the preferred edge and see if we are able to constrain to within each rectangle

        for (let i = 0; i < zoneOrder.length; i++) {
          // Revert to incoming dimension for fallback out of axisLock
          if (matchDimension && i == 2) {
            result[matchDimension] = originalSize;
          }

          zone = constraintZones[resultZone = zoneOrder[i].zone]; // Perform unconstrained alignment at the calculated alignment for the zone

          result = result.alignTo({
            target: target,
            offsets: offsets,
            align: zoneOrder[i].align
          }); // If we are able to strictly constrain into this area, then it's one of the possible solutions.
          // We choose the solution which result in the shortest translation from the initial position.

          if (result.constrainTo(zone, true)) {
            solutions.push({
              result: result,
              zone: resultZone
            }); // If this successful constraint is at the requested alignment, or at a fallback
            // alignment which has used min size constraints, then that's the correct solution.
            // If there's no size compromising, we have to pick the shortest translation.

            if (!largestZone || result.width < me.width || result.height < me.height) {
              result.align = zoneOrder[i].align;
              break;
            }
          } // Cache the largest zone we find in case we need the final fallback.


          if (!largestZone || zone.area > largestZone.area) {
            const r = result.clone(); // And just move the result clone into the edge zone

            switch (resultZone) {
              // Top
              case 0:
                r.moveTo(null, zone.bottom - r.height);
                break;
              // Right

              case 1:
                r.moveTo(zone.left);
                break;
              // Bottom

              case 2:
                r.moveTo(null, zone.top);
                break;
              // Left

              case 3:
                r.moveTo(zone.right - r.width);
                break;
            }

            largestZone = {
              area: zone.area,
              result: r,
              zone: resultZone
            };
          }
        } // The loop found at least one solution


        if (solutions.length) {
          // Multiple fallbacks with no axisLock.
          // Use the solution which resulted in the shortest translation distance from the requested alignment.
          if (solutions.length > 1 && !axisLock) {
            solutions.sort((s1, s2) => {
              const s1TranslationDistance = Math.sqrt((requestedResult.x - s1.result.x) ** 2 + (requestedResult.y - s1.result.y) ** 2),
                    s2TranslationDistance = Math.sqrt((requestedResult.x - s2.result.x) ** 2 + (requestedResult.y - s2.result.y) ** 2);
              return s1TranslationDistance - s2TranslationDistance;
            });
          } // Initial success, or axisLock. Use first successful solution.


          result = solutions[0].result;
          resultZone = solutions[0].zone;
        } // No solutions found - use the largest rectangle.
        else {
          result = largestZone.result;
          resultZone = largestZone.zone; // When we are constraining to the viewport, we must still must be constrained,
          // even after we've given up making it align *and* constrain.

          if (constrainingToViewport) {
            result.constrainTo(constrainTo);
          }
        }
      } else {
        resultZone = alignSpec.startZone;
      }

      result.zone = resultZone;
      result.overlap = overlap = result.intersect(target, true); // If they included an anchor, calculate its position along its edge.
      // TODO: Handle the edge overlap being less than anchor width.

      if (anchorSize && !overlap) {
        // If we were passed an anchorPosition, and it has remained valid (meaning the requested
        // alignment succeeded with no constraint), then anchorPosition will be set. If not,
        // we have to calculate it based upon the aligned edge.
        if (!calculatedAnchorPosition) {
          let isLeftOrRight = resultZone & 1,
              start = isLeftOrRight ? 'y' : 'x',
              end = isLeftOrRight ? 'bottom' : 'right',
              startValue = Math.max(target[start], result[start]),
              endValue = Math.min(target[end], result[end]),
              anchorStart = startValue + (endValue - startValue) / 2 - anchorSize[0] / 2,
              anchorEnd = anchorStart + anchorSize[0];

          if (anchorEnd > result[end]) {
            anchorStart -= anchorEnd - result[end];
          }

          if (anchorStart < result[start]) {
            anchorStart += result[start] - anchorStart;
          } // Return an anchor property which will have an x or y property and an edge name onto which the
          // arrow should be aligned.


          calculatedAnchorPosition = {
            [start]: anchorStart - result[start],
            edge: edgeNames[(resultZone + 2) % 4]
          };
        }

        result.anchor = calculatedAnchorPosition;
      }
    }

    return result;
  }
  /**
   * Returns the `[x, y]` position of the specified anchor point of this Rectangle in <edge><offset> format.
   * for example passing "t50" will return the centre point of the top edge, passing "r0" will return the start
   * position of the right edge (the top right corner).
   *
   * Note that the offset defaults to 50, so "t" means the centre of the top edge.
   * @param {String} alignmentPoint The alignment point to calculate. Must match the RegExp `[trbl]\d*`
   * @param {Number[]} margins The `[x, y]` margins to add from the left/right, top/bottom edge.
   * @internal
   */


  getAlignmentPoint(alignmentPoint, margins = zeroOffsets) {
    const me = this,
          parts = alignPointRe.exec(alignmentPoint),
          edge = parts[1].toLowerCase(),
          edgeOffset = Math.min(Math.max(parseInt(parts[2] || 50), 0), 100) / 100;

    switch (edge) {
      case 't':
        return [me.x + me.width * edgeOffset, me.y - margins[1]];

      case 'r':
        return [me.right + margins[0], me.y + me.height * edgeOffset];

      case 'b':
        return [me.x + me.width * edgeOffset, me.bottom + margins[1]];

      case 'l':
        return [me.x - margins[0], me.y + me.height * edgeOffset];

      case 'c':
        {
          return [me.x + me.width / 2, me.y + me.height / 2];
        }
    }
  }
  /**
   * Highlights this Rectangle using the highlighting effect of {@link Core.helper.DomHelper}
   * on a transient element which encapsulates the region's area.
   */


  highlight() {
    const me = this,
          highlightElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
      parent: document.body,
      style: `position:absolute;z-index:9999999;pointer-events:none;
                            left:${me.x}px;top:${me.y}px;width:${me.width}px;height:${me.height}px`
    });
    return _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].highlight(highlightElement).then(() => highlightElement.remove());
  }

  toString(delimiter = ',') {
    return [`${this.top}px`, `${this.right}px`, `${this.bottom}px`, `${this.left}px`].join(delimiter);
  }

}
Rectangle._$name = 'Rectangle';

/***/ }),

/***/ "./lib/Core/helper/util/Scroller.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/util/Scroller.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scroller; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _IdHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _Point_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _DomClassList_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
var productName = 'gantt';












/**
 * @module Core/helper/util/Scroller
 */

const scrollLiterals = {
  true: 'auto',
  false: 'hidden',
  'hidden-scroll': 'auto',
  clip: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].supportsOverflowClip ? 'clip' : 'hidden'
},
      scrollerCls = 'b-widget-scroller',
      defaultScrollOptions = {
  block: 'nearest'
},
      immediatePromise = Promise.resolve(),
      scrollPromise = element => new Promise(resolve => _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
  element,
  scroll: resolve,
  once: true
})),
      xAxis = {
  x: 1
},
      isScrollable = {
  auto: 1,
  scroll: 1
},
      allScroll = {
  overflowX: 'auto',
  overflowY: 'auto'
};
/**
 * Encapsulates scroll functionality for a Widget. All requests for scrolling and scrolling information
 * must go through a Widget's {@link Core.widget.Widget#config-scrollable} property.
 * @mixes Core/mixin/Events
 * @mixes Core/mixin/Delayable
 * @extends Core/Base
 */


class Scroller extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get configurable() {
    return {
      /**
       * The widget which is to scroll.
       * @config {HTMLElement}
       */
      widget: null,

      /**
       * The element which is to scroll. Defaults to the
       * {@link Core.widget.Widget#property-overflowElement} of the configured
       * {@link #config-widget}
       * @config {HTMLElement}
       */
      element: {
        $config: {
          nullify: true
        },
        value: null
      },

      /**
       * How to handle overflowing in the `X` axis.
       * May be:
       * * `'auto'`
       * * `'visible'`
       * * `'hidden'`
       * * `'scroll'`
       * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar,
       * for example a grid header. Only on platforms which support this feature.
       * * `true` - meaning `'auto'`
       * * `false` - meaning `'hidden'`
       * * `clip` - Uses `clip` where supported. Where not supported it uses
       * `hidden` and rolls back any detected scrolls in this dimension.
       * @config {String|Boolean}
       */
      overflowX: null,

      /**
       * How to handle overflowing in the `Y` axis.
       * May be:
       * * `'auto'`
       * * `'visible'`
       * * `'hidden'`
       * * `'scroll'`
       * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar.
       * Only on platforms which support this feature.
       * * `true` - meaning `'auto'`
       * * `false` - meaning `'hidden'`
       * * `clip` - Uses `clip` where supported. Where not supported it uses
       * `hidden` and rolls back any detected scrolls in this dimension.
       * @config {String|Boolean}
       */
      overflowY: null,

      /**
       * If configured as `true`, the {@link #config-element} is not scrolled
       * but is translated using CSS transform when controlled by this class's API.
       * Scroll events are fired when the element is translated.
       * @default
       * @config {Boolean}
       */
      translate: null,
      x: 0,
      y: 0
    };
  }

  static get delayable() {
    return {
      onScrollEnd: {
        type: 'buffer',
        delay: 100
      }
    };
  }
  /**
   * Fired when scrolling happens on this Scroller's element. The event object is a native `scroll` event
   * with the described extra properties injected.
   * @event scroll
   * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
   * @param {Core.helper.util.Scroller} source This Scroller
   */

  /**
   * Fired when scrolling finished on this Scroller's element. The event object is the last native `scroll` event
   * fires by the element with the described extra properties injected.
   * @event scrollend
   * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
   * @param {Core.helper.util.Scroller} source This Scroller
   */

  /**
   * The `overflow-x` setting for the widget. `true` means `'auto'`.
   * @member {Boolean|String} overflowX
   */

  /**
   * The `overflow-y` setting for the widget. `true` means `'auto'`.
   * @member {Boolean|String} overflowY
   */


  syncOverflowState() {
    const {
      element
    } = this,
          classList = new _DomClassList_js__WEBPACK_IMPORTED_MODULE_11__["default"](element.classList),
          x = this.hasOverflowX = element.scrollWidth > element.clientWidth,
          y = this.hasOverflowY = element.scrollHeight > element.clientHeight;
    classList.value = element.classList; // We use classes to indicate presence of overflow. This carries no rules by default.
    // Widget SASS may or may not attach rules or use these to select elements.

    const changed = classList.toggle('b-horizontal-overflow', x) || classList.toggle('b-vertical-overflow', y);

    if (changed) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncClassList(element, classList);

      if (!this.isConfiguring) {
        /**
         * Fired when either the X or the Y axis changes from not showing a space-consuming scrollbar
         * to showing a space-consuming scrollbar or vice-versa.
         *
         * *_Does not fire on platforms which show overlayed scrollbars_*
         * @event overflowChange
         * @param {Boolean} x `true` if the X axis overflow, `false` otherwise.
         * @param {Boolean} y `true` if the Y axis overflow, `false` otherwise.
         * @internal
         */
        this.trigger('overflowChange', {
          x,
          y
        });
      }
    }
  }
  /**
   * Returns `true` if there is overflow in the specified axis.
   * @param {String} [axis='y'] The axis to check scrollbar for. Note that this is subtly different to asking
   * whether an axis is showing a space-consuming scrollbar, see {@link #function-hasScrollbar}.
   * @internal
   */


  hasOverflow(axis = 'y') {
    // If there are no space-consuming scrollbars, we will not be recording overflow
    // state on change of scrollbars (There will be no resize event when overflow state changes).
    // Also, work around Firefox ResizeObserver bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1733042
    // We don't get to update our scroll status when content size causes scrollbar change
    // so FF has to measure each time we're asked about overflow.
    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isFirefox) {
      const dimension = axis === 'y' ? 'Height' : 'Width';
      return this[`scroll${dimension}`] > this[`client${dimension}`];
    } else {
      return this[`hasOverflow${axis.toUpperCase()}`];
    }
  }
  /**
   * Returns `true` if there is a *space-consuming* scrollbar controlling scroll in the specified axis.
   * @param {String} [axis='y'] The axis to check scrollbar for. Note that this is subtly different to asking
   * whether an axis *has any* overflow, see {@link #function-hasOverflow}.
   * @internal
   */


  hasScrollbar(axis = 'y') {
    const {
      element
    } = this;

    if (element && _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) {
      const vertical = axis === 'y',
            dimension = vertical ? 'Width' : 'Height',
            clientSize = element[`client${dimension}`],
            borderSize = parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, `border${vertical ? 'Left' : 'Top'}Width`)) + parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, `border${vertical ? 'Right' : 'Bottom'}Width`)),
            difference = element[`offset${dimension}`] - borderSize - clientSize; // If the difference between the content width and the client width is
      // scrollBarWidth, then we have a scrollbar

      return Math.abs(difference - _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) < 2;
    }
  }
  /**
   * Partners this Scroller with the passed scroller in order to sync the scrolling position in the passed axes
   * @param {Core.helper.util.Scroller} otherScroller
   * @param {String|Object} [axes='x'] `'x'` or `'y'` or `{x: true/false, y: true/false}` axes to sync
   */


  addPartner(otherScroller, axes = xAxis) {
    const me = this;

    if (typeof axes === 'string') {
      axes = {
        [axes]: 1
      };
    }

    if (!me.partners) {
      me.partners = {};
    }

    me.partners[otherScroller.id] = {
      scroller: otherScroller,
      axes
    }; // Initial sync of the other axis to match our current state

    if (axes.x) {
      otherScroller.x = me.x;
    }

    if (axes.y) {
      otherScroller.y = me.y;
    } // It's a mutual relationship - the other scroller partners with us.


    if (!otherScroller.isPartneredWith(me)) {
      otherScroller.addPartner(me, axes);
    }
  }

  eachPartner(fn) {
    const {
      partners
    } = this;

    if (partners) {
      Object.values(partners).forEach(fn);
    }
  }
  /**
   * Breaks the link between this Scroller and the passed Scroller set up by the
   * {@link #function-addPartner} method.
   * @param {Core.helper.util.Scroller} otherScroller The Scroller to unlink from.
   */


  removePartner(otherScroller) {
    if (this.isPartneredWith(otherScroller)) {
      delete this.partners[otherScroller.id];
      otherScroller.removePartner(this);
    }
  }

  isPartneredWith(otherScroller) {
    return Boolean(this.partners && this.partners[otherScroller.id]);
  }
  /**
   * Breaks the link between this Scroller and all other Scrollers set up by the
   * {@link #function-addPartner} method.
   * @internal
   */


  clearPartners() {
    if (this.partners) {
      Object.values(this.partners).forEach(otherScroller => otherScroller.scroller.removePartner(this));
    }
  }
  /**
   * Scrolls the passed element or {@link Core.helper.util.Rectangle} into view according to the passed options.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle in document space to scroll into view.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean|Function} [options.highlight] Set to `true` to highlight the element when it is in view.
   * May be a function which is called passing the element, to provide customized highlighting.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
   */


  async scrollIntoView(element, options = defaultScrollOptions) {
    const me = this,
          {
      isRectangle
    } = element,
          originalRect = isRectangle ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          {
      xDelta,
      yDelta
    } = me.getDeltaTo(element, options),
          result = me.scrollBy(xDelta, yDelta, options);

    if (options.highlight || options.focus) {
      result.then(() => {
        if (isRectangle) {
          element = originalRect.translate(-xDelta, -yDelta);
        }

        if (options.highlight) {
          // Not coercible to a number means its a function or name of a function
          if (isNaN(options.highlight)) {
            (me.widget || me).callback(options.highlight, null, [element]);
          } // Otherwise, it's truthy or falsy
          else {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].highlight(element, me);
          }
        }

        if (options.focus) {
          element.focus();
        }
      });
    }

    return result;
  }
  /**
   * Scrolls the passed element into view according to the passed options.
   * @param {HTMLElement} element The element in document space to scroll into view.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
   */


  static async scrollIntoView(element, options = defaultScrollOptions) {
    const target = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          animate = typeof options === 'object' ? options.animate : options,
          scrollable = Scroller._globalScroller || (Scroller._globalScroller = new Scroller()),
          deltas = [];
    let totalX = 0,
        totalY = 0,
        result; // Build up all the scroll deltas necessary to bring the requested element into view

    for (let ancestor = element.parentNode; ancestor.nodeType === Node.ELEMENT_NODE; ancestor = ancestor.parentNode) {
      if (ancestor === document.body && ancestor !== document.scrollingElement) {
        continue;
      } // The <html> element, althouhgh it scrolls is overflow:visioble by default.


      const style = ancestor === document.scrollingElement ? allScroll : ancestor.ownerDocument.defaultView.getComputedStyle(ancestor); // If the ancestor overflows and scrolls in a dimension we are being asked to scroll in
      // Accumulate a scroll command for the ancestor.

      if (options.y !== false && isScrollable[style.overflowY] && ancestor.scrollHeight > ancestor.clientHeight || options.x !== false && isScrollable[style.overflowX] && ancestor.scrollWidth > ancestor.clientWidth) {
        // Global Scrollable
        scrollable.element = ancestor; // See if the target is outside of this ancestor

        const {
          xDelta,
          yDelta
        } = scrollable.getDeltaTo(target, options);

        if (xDelta || yDelta) {
          deltas.push({
            element: ancestor,
            x: ancestor.scrollLeft,
            y: ancestor.scrollTop,
            xDelta,
            yDelta
          });
          target.translate(-xDelta, -yDelta);
          totalX += xDelta;
          totalY += yDelta;
        }
      }
    } // If scrolling was found to be necessary


    if (deltas.length) {
      const absX = Math.abs(totalX),
            absY = Math.abs(totalY);
      let duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

      if (duration && (absX > 10 || absY > 10)) {
        // For small distances, constrain duration
        if (Math.max(absX, absY) < 50) {
          duration = Math.min(duration, 500);
        }

        result = scrollable.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].animate(duration, progress => {
          const isEnd = progress === 1;

          for (const {
            element,
            x,
            y,
            xDelta,
            yDelta
          } of deltas) {
            scrollable.element = element;

            if (xDelta) {
              scrollable.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
            }

            if (yDelta) {
              scrollable.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
            }
          }
        }, null, animate.easing);
        result.then(() => {
          scrollable.scrollAnimation = null;
        });
      } // No animation
      else {
        for (const {
          element,
          xDelta,
          yDelta
        } of deltas) {
          element.scrollTop += yDelta;
          element.scrollLeft += xDelta;
        }

        result = scrollPromise(deltas[deltas.length - 1].element);
      }
    } else {
      result = immediatePromise;
    } // Postprocess element after scroll.


    if (options.highlight || options.focus) {
      result.then(() => {
        if (options.highlight) {
          // Not coercible to a number means its a function or name of a function
          if (isNaN(options.highlight)) {
            scrollable.callback(options.highlight, null, [element]);
          } // Otherwise, it's truthy or falsy
          else {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].highlight(element, scrollable);
          }
        }

        if (options.focus) {
          element.focus();
        }
      });
    }

    return result;
  }
  /**
   * Scrolls by the passed deltas according to the passed options.
   * @param {Number} [xDelta=0] How far to scroll in the X axis.
   * @param {Number} [yDelta=0] How far to scroll in the Y axis.
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Boolean} [options.silent] Set to `true` to suspend `scroll` events during scrolling.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  async scrollBy(xDelta = 0, yDelta = 0, options = defaultScrollOptions) {
    const me = this,
          animate = typeof options === 'object' ? options.animate : options,
          absX = Math.abs(xDelta),
          absY = Math.abs(yDelta);

    if (me.scrollAnimation) {
      me.scrollAnimation.cancel();
      me.scrollAnimation = null;
    } // Only set the flag if there is going to be scrolling done.
    // It is cleared by the scrollEnd handler, so there must be scrolling.


    if (xDelta || yDelta) {
      me.silent = options.silent;
    }

    let duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

    if (duration && (absX > 10 || absY > 10)) {
      const {
        x,
        y
      } = me;
      let lastX = x,
          lastY = y; // For small distances, constrain duration

      if (Math.max(absX, absY) < 50) {
        duration = Math.min(duration, 500);
      }

      me.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].animate(duration, progress => {
        const isEnd = progress === 1;

        if (xDelta) {
          // If the user, or another process has changed the position since last time, abort.
          // Unless called with the force option to proceed regardless.
          if (me.x !== lastX && !options.force) {
            return me.scrollAnimation && me.scrollAnimation.cancel();
          }

          me.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
        }

        if (yDelta) {
          // If the user, or another process has changed the position since last time, abort.
          // Unless called with the force option to proceed regardless.
          if (me.y !== lastY && !options.force) {
            return me.scrollAnimation && me.scrollAnimation.cancel();
          }

          me.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
        } // Store actual position from DOM


        lastX = me.x;
        lastY = me.y;
      }, me, animate.easing);
      me.element.classList.add('b-scrolling');
      me.scrollAnimation.then(() => {
        if (!me.isDestroyed) {
          me.element.classList.remove('b-scrolling');
          me.scrollAnimation = null;
        }
      });
      return me.scrollAnimation;
    } else {
      if (xDelta | yDelta) {
        me.x += xDelta;
        me.y += yDelta;
        return scrollPromise(me.element);
      }

      return immediatePromise;
    }
  }
  /**
   * Scrolls to the passed position according to the passed options.
   * @param {Number} [toX=0] Where to scroll to in the X axis.
   * @param {Number} [toY=0] Where to scroll to in the Y axis.
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  async scrollTo(toX, toY, options) {
    const {
      x,
      y
    } = this,
          xDelta = toX == null ? 0 : toX - x,
          yDelta = toY == null ? 0 : toY - y;
    return this.scrollBy(xDelta, yDelta, options);
  }

  doDestroy() {
    const me = this;

    if (me._element) {
      me._element.removeEventListener('scroll', me.scrollHandler);

      me.wheelListenerRemover && me.wheelListenerRemover();
    }

    if (me.scrollAnimation) {
      me.scrollAnimation.cancel();
    }

    Object.values(me.partners || {}).forEach(({
      scroller
    }) => scroller.removePartner(me));
    super.doDestroy();
  }
  /**
   * Respond to style changes to monitor scroll *when this Scroller is in `translate: true` mode.*
   * @param {Object[]} mutations The ElementMutation records.
   * @private
   */


  onElMutation(mutations) {
    const me = this,
          [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(me.element); // If the mutation was due to a change in the translateX/Y styles, this is
    // a scroll event, so inform observers and partners

    if (me._x !== -x || me.y !== -y) {
      const scrollEvent = new CustomEvent('scroll', {
        bubbles: true
      });
      Object.defineProperty(scrollEvent, 'target', {
        get: () => me.element
      });
      me.onScroll(scrollEvent);
    }
  }

  onElResize() {
    var _this$owner;

    if ((_this$owner = this.owner) !== null && _this$owner !== void 0 && _this$owner.isAnimating) {
      this.owner.on({
        animationEnd: 'onElResize',
        thisObj: this,
        once: true
      });
    } else {
      this.syncOverflowState();
    }
  }

  onScroll(e) {
    const me = this,
          {
      _x,
      _y,
      element
    } = me;
    let vetoed = 0; // Until overflow:clip is 100% supported just veto (and rollback) scrolls in clipped axes

    if (me.overflowX === 'clip' && element.scrollLeft !== _x) {
      element.scrollLeft = _x;
      ++vetoed;
    }

    if (me.overflowY === 'clip' && element.scrollTop !== _y) {
      element.scrollTop = _y;
      ++vetoed;
    }

    if (vetoed === 2) {
      return;
    }

    if (!me.widget || !me.widget.isDestroyed) {
      // Don't read the value until we have to. The x & y getters will check this flag
      me.positionDirty = true;

      if (!me.element.classList.contains('b-scrolling')) {
        me.element.classList.add('b-scrolling');
      }

      e.widget = me.widget; // If we have the scroll silent flag, do not fire the event.

      if (!me.silent) {
        me.trigger('scroll', e);
      } // Keep partners in sync


      me.syncPartners(); // If this scroll impulse was from a controlling partner, clear that now

      me.controllingPartner = null; // Buffered method will fire in 100ms, unless another scroll event comes round.
      // In which case execution will be pushed out by another 100ms.

      me.onScrollEnd(e);
    }
  }

  syncPartners(force) {
    const me = this; // Keep partners in sync

    if (me.partners) {
      Object.values(me.partners).forEach(({
        axes,
        scroller
      }) => {
        // Don't feed back to the one who's just told us to scroll here.
        // Unless we have assumed command. For example Scheduler timeline infinite scrolling
        // has reset the scroll position and the partner who thinks it's controlling
        // must stay in sync with that reset.
        if (scroller !== me.controllingPartner || force) {
          scroller.sync(me, axes);
        }
      });
    }
  }

  onScrollEnd(e) {
    const me = this;

    if (me.silent) {
      me.silent = false;
    }

    me.trigger('scrollEnd', e); // Controlling partner is required for scrollable not to change its partners on scroll. This method is buffered
    // and landing here essentially means that no scrolling has occurred during the onScrollEnd buffer
    // time. We can safely cleanup controlling partner here.
    // https://github.com/bryntum/support/issues/1095

    me.controllingPartner = null;
    me.element.classList.remove('b-scrolling');
  }
  /**
   * Returns the xDelta and yDelta values in an object from the current scroll position to the
   * passed element or Rectangle.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle to calculate deltas for.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] A margin around the element or rectangle to bring into view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Object} `{ xDelta, yDelta }`
   * @internal
   */


  getDeltaTo(element, options) {
    const me = this; // scroller may belong to a collapsed subgrid widget

    if (!me.viewport) {
      return {
        xDelta: 0,
        yDelta: 0
      };
    }

    const elementRect = element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          block = options.block || 'nearest',
          scrollerRect = me.viewport,
          edgeOffset = options.edgeOffset || 0,
          // Only include the offset round the target is the viewport is big enough to accommodate it.
    xOffset = scrollerRect.width >= elementRect.width + edgeOffset * 2 ? edgeOffset : 0,
          yOffset = scrollerRect.height >= elementRect.height + edgeOffset * 2 ? edgeOffset : 0,
          elRect = elementRect.clone().adjust(-xOffset, -yOffset, xOffset, yOffset).constrainTo(new _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](scrollerRect.x - me.x, scrollerRect.y - me.y, me.scrollWidth, me.scrollHeight)),
          targetRect = elRect.clone();
    let xDelta = 0,
        yDelta = 0;

    if (block === 'start') {
      targetRect.moveTo(scrollerRect.x, scrollerRect.y);
      xDelta = elRect.x - targetRect.x;
      yDelta = elRect.y - targetRect.y;
    } else if (block === 'end') {
      targetRect.translate(scrollerRect.right - targetRect.right, scrollerRect.bottom - targetRect.bottom);
      xDelta = elRect.x - targetRect.x;
      yDelta = elRect.y - targetRect.y;
    } else {
      // Calculate deltas unless the above has done that for non-fitting target
      if (block === 'center') {
        const center = scrollerRect.center;
        targetRect.moveTo(center.x - targetRect.width / 2, center.y - targetRect.height / 2);
        xDelta = xDelta || elRect.x - targetRect.x;
        yDelta = yDelta || elRect.y - targetRect.y;
      } // Use "nearest"
      else {
        // Can't fit width in, scroll what is possible into view so that start is visible.
        if (targetRect.width > scrollerRect.width) {
          xDelta = targetRect.x - scrollerRect.x;
        } // If it's *possible* to scroll to nearest x, calculate the delta
        else {
          if (targetRect.right > scrollerRect.right) {
            xDelta = targetRect.right - scrollerRect.right;
          } else if (targetRect.x < scrollerRect.x) {
            xDelta = targetRect.x - scrollerRect.x;
          }
        } // Can't fit height in, scroll what is possible into view so that start is visible.


        if (targetRect.height > scrollerRect.height) {
          yDelta = targetRect.y - scrollerRect.y;
        } // If it's *possible* to scroll to nearest y, calculate the delta
        else {
          if (targetRect.bottom > scrollerRect.bottom) {
            yDelta = targetRect.bottom - scrollerRect.bottom;
          } else if (targetRect.y < scrollerRect.y) {
            yDelta = targetRect.y - scrollerRect.y;
          }
        }
      }
    } // Do not allow deltas which would produce -ve scrolling or scrolling past the maxX/Y


    return {
      // When calculating how much delta is necessary to scroll the targetRect to the center
      // constrain that to what is *possible*. If what you are trying to scroll into the
      // center is hard against the right edge of the scroll range, then it cannot scroll
      // to the center, and the result must reflect that even though scroll is self limiting.
      // This is because highlighting the requested "element", if that element is in fact
      // a Rectangle, uses a temporary element placed at the requested region which
      // MUST match where the actual scroll has moved the requested region.
      xDelta: options.x === false ? 0 : Math.max(Math.min(Math.round(xDelta), me.maxX - me.x), -me.x),
      yDelta: options.y === false ? 0 : Math.max(Math.min(Math.round(yDelta), me.maxY - me.y), -me.y)
    };
  }
  /**
   * A {@link Core.helper.util.Rectangle Rectangle} describing the bounds of the scrolling viewport.
   * @property {Core.helper.util.Rectangle}
   */


  get viewport() {
    return _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].client(this.element);
  }

  updateElement(element, oldElement) {
    const me = this; // The global Scroller doesn't monitor its element.
    // It's only used for *commanding* scrolls.

    if (me === Scroller._globalScroller) {
      me._element = element;
      me.positionDirty = true;
      return;
    }

    const scrollHandler = me.scrollHandler || (me.scrollHandler = me.onScroll.bind(me)),
          resizeHandler = me.resizeHandler || (me.resizeHandler = me.onElResize.bind(me));

    if (oldElement) {
      if (me.translate) {
        var _me$mutationObserver;

        (_me$mutationObserver = me.mutationObserver) === null || _me$mutationObserver === void 0 ? void 0 : _me$mutationObserver.disconnect(oldElement);
      } else {
        oldElement.removeEventListener('scroll', scrollHandler);
        oldElement.classList.remove(scrollerCls);
        oldElement.style.overflowX = oldElement.style.overflowY = '';
      }

      _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(oldElement, resizeHandler);
    }

    if (element) {
      if (me.translate) {
        if (!me.mutationObserver) {
          me.mutationObserver = new MutationObserver(me.mutationHandler || (me.mutationHandler = me.onElMutation.bind(me)));
        }

        me._x = me._y = 0;

        if (document.contains(element)) {
          const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
          me._x = -x;
          me._y = -y;
        }

        me.mutationObserver.observe(element, {
          attributes: true
        });
      } else {
        element.addEventListener('scroll', scrollHandler);
        element.classList.add(scrollerCls);
      }

      _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element, resizeHandler); // Ensure the overflow configs, which are unable to process themselves
      // in the absence of the element get applied to the newly arrived element.

      if (me.positionDirty) {
        me.updateOverflowX(me.overflowX);
        me.updateOverflowY(me.overflowY);
      } // Keep flags synced fro the start


      me.syncOverflowState(); // Apply initially configured scroll position if we have non-zero positions

      if (me.isConfiguring) {
        me._x && me.updateX(me._x);
        me._y && me.updateY(me._y);
      }
    }

    me.positionDirty = true;
  }
  /**
   * The horizontal scroll position of the widget.
   * @property {Number}
   */


  get x() {
    const me = this,
          {
      element
    } = me;

    if (element && me.positionDirty) {
      if (me.translate) {
        const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
        me._x = -x;
        me._y = -y;
      } else {
        me._x = element.scrollLeft;
        me._y = element.scrollTop;
      }

      me.positionDirty = false;
    }

    return me._x;
  }

  changeX(x) {
    // Only process initial X if we were configured to start at non-zero
    if (!this.isConfiguring || x) {
      return x;
    }

    this._x = x;
  }

  updateX(x) {
    const {
      element,
      widget
    } = this; // When element is outside of DOM, this can have no effect

    if (element && !(widget !== null && widget !== void 0 && widget.isConfiguring)) {
      this.trigger('scrollStart', {
        x
      });

      if (this.translate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(element, -x);
      } else {
        element.scrollLeft = x;
      }
    } // The scroll position will need to be read before we can return it.
    // Do not read it back now, we may not have our element, or if we do,
    // that would cause a forced synchronous layout.


    this.positionDirty = true;
  }

  sync(controllingPartner, axes) {
    const {
      x,
      y
    } = axes;

    if (x != null) {
      if (this.x !== controllingPartner.x) {
        // Only set controlling partner when scroll will actually change. This helps to increase stability of
        // state restoring API.
        this.controllingPartner = controllingPartner;
        this.x = controllingPartner.x;
      }
    }

    if (y != null) {
      if (this.y !== controllingPartner.y) {
        this.controllingPartner = controllingPartner;
        this.y = controllingPartner.y;
      }
    }
  }
  /**
   * The vertical scroll position of the widget.
   * @property {Number}
   */


  get y() {
    const me = this,
          {
      element
    } = me;

    if (element && me.positionDirty) {
      if (me.translate) {
        const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
        me._x = -x;
        me._y = -y;
      } else {
        me._x = element.scrollLeft;
        me._y = element.scrollTop;
      }

      me.positionDirty = false;
    }

    return me._y;
  }

  changeY(y) {
    // Only process initial Y if we were configured to start at non-zero
    if (!this.isConfiguring || y) {
      return y;
    }

    this._y = y;
  }

  updateY(y) {
    const {
      element,
      widget
    } = this; // When element is outside of DOM, this can have no effect

    if (element && !(widget !== null && widget !== void 0 && widget.isConfiguring)) {
      this.trigger('scrollStart', {
        y
      });

      if (this.translate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(element, -y);
      } else {
        element.scrollTop = y;
      }
    } // The scroll position will need to be read before we can return it.
    // Do not read it back now, we may not have our element, or if we do,
    // that would cause a forced synchronous layout.


    this.positionDirty = true;
  }
  /**
   * The maximum `X` scrollable position of the widget.
   * @property {Number}
   * @readonly
   */


  get maxX() {
    return this.scrollWidth - this.clientWidth;
  }
  /**
   * The maximum `Y` scrollable position of the widget.
   * @property {Number}
   * @readonly
   */


  get maxY() {
    return this.scrollHeight - this.clientHeight;
  }

  updateOverflowX(overflowX, oldOverflowX) {
    const {
      element,
      translate
    } = this,
          {
      style,
      classList
    } = element;

    if (oldOverflowX === 'hidden-scroll') {
      classList.remove('b-hide-scroll');
    } // Scroll, but without showing scrollbars.
    // For example a grid header. Only works on platforms which
    // support suppression of scrollbars through CSS.


    if (overflowX === 'hidden-scroll' && !translate) {
      const otherAxisScrollable = isScrollable[style.overflowY]; // Can't do one axis hidden-scroll, and the other scrollable because the b-hide-scroll
      // class hides "all" scrollbars, so we have to make this axis hidden and use a wheel
      // listener to scroll the content.

      if (otherAxisScrollable) {
        overflowX = 'hidden'; // Adds a wheel listener if we don't already have one.

        this.enableWheel();
      } else {
        classList.add('b-hide-scroll');
      }
    }

    if (!translate) {
      style.overflowX = scrollLiterals[overflowX] || overflowX;
    }

    this.positionDirty = !this.isConfiguring;
  }

  updateOverflowY(overflowY, oldOverflowY) {
    const {
      element,
      translate
    } = this,
          {
      style,
      classList
    } = element;

    if (oldOverflowY === 'hidden-scroll') {
      classList.remove('b-hide-scroll');
    } // Scroll, but without showing scrollbars.
    // For example a grid header.
    // On platforms which show space-consuming scrollbars we hide scrollbars
    // and add a 'wheel' listener.


    if (overflowY === 'hidden-scroll' && !translate) {
      const otherAxisScrollable = isScrollable[style.overflowX]; // Can't do one axis hidden-scroll, and the other scrollable because the b-hide-scroll
      // class hides "all" scrollbars, so we have to make this axis hidden and use a wheel
      // listener to scroll the content.

      if (otherAxisScrollable) {
        overflowY = 'hidden'; // Adds a wheel listener if we don't already have one.

        this.enableWheel();
      } else {
        classList.add('b-hide-scroll');
      }
    }

    if (!translate) {
      style.overflowY = scrollLiterals[overflowY] || overflowY;
    }

    this.positionDirty = !this.isConfiguring;
  }

  enableWheel() {
    if (!this.wheelListenerRemover) {
      this.wheelListenerRemover = _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
        element: this.element,
        wheel: 'onWheel',
        thisObj: this
      });
    }
  }

  onWheel(e) {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && this.overflowX === 'hidden-scroll') {
      this.x += e.deltaX;
    } else if (this.overflowY === 'hidden-scroll') {
      this.y += e.deltaY;
    }
  }
  /**
   * The horizontal scroll range of the widget.
   * @property {Number}
   * @readonly
   */


  get scrollWidth() {
    var _this$element$scrollW, _this$element;

    return (_this$element$scrollW = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.scrollWidth) !== null && _this$element$scrollW !== void 0 ? _this$element$scrollW : 0;
  }

  set scrollWidth(scrollWidth) {
    const me = this,
          {
      element
    } = me;
    let stretcher = me.widthStretcher; // "Unsetting" scrollWidth removes the stretcher

    if (stretcher && scrollWidth == null) {
      stretcher.remove();
      me.widthStretcher = null;
    } else if (scrollWidth) {
      if (!stretcher) {
        stretcher = me.widthStretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
          className: 'b-scroller-stretcher b-horizontal-stretcher',
          // Should survive its surroundings being DomSynced
          retainElement: true
        });
      }

      stretcher.style.transform = `translateX(${scrollWidth - 1}px)`;

      if (element && !element.contains(stretcher)) {
        element.insertBefore(stretcher, element.firstElementChild);
      }
    } // Propagate call to partners so they will establish own scroller stretcher


    if (me.propagate !== false) {
      me.eachPartner(({
        scroller
      }) => {
        // Raise a flag on partner to not propagate changes from it further
        scroller.propagate = false;
        scroller.scrollWidth = scrollWidth;
        delete scroller.propagate;
      });
    }

    me.positionDirty = true;
    me.syncOverflowState();
  }

  get scrollHeight() {
    var _this$element$scrollH, _this$element2;

    return (_this$element$scrollH = (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : _this$element2.scrollHeight) !== null && _this$element$scrollH !== void 0 ? _this$element$scrollH : 0;
  }
  /**
   * The vertical scroll range of the widget. May be set to larger than the actual data
   * height to enable virtual scrolling. This is how the grid extends its scroll range
   * while only rendering a small subset of the dataset.
   * @property {Number}
   */


  set scrollHeight(scrollHeight) {
    const me = this,
          stretcher = me.stretcher || (me.stretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
      className: 'b-scroller-stretcher'
    }));
    stretcher.style.transform = `translateY(${scrollHeight - 1}px)`;

    if (me.element && me.element.lastChild !== stretcher) {
      me.element.appendChild(stretcher);
    }

    me.positionDirty = true;
    me.syncOverflowState();
  }
  /**
   * The client width of the widget.
   * @property {Number}
   * @readonly
   */


  get clientWidth() {
    var _this$element3;

    return ((_this$element3 = this.element) === null || _this$element3 === void 0 ? void 0 : _this$element3.clientWidth) || 0;
  }
  /**
   * The client height of the widget.
   * @property {Number}
   * @readonly
   */


  get clientHeight() {
    var _this$element4;

    return ((_this$element4 = this.element) === null || _this$element4 === void 0 ? void 0 : _this$element4.clientHeight) || 0;
  }
  /**
   * The unique ID of this Scroller
   * @property {String}
   * @readonly
   */


  get id() {
    if (!this._id) {
      if (this.widget) {
        this._id = `${this.widget.id}-scroller`;
      } else {
        this._id = _IdHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].generateId('scroller-');
      }
    }

    return this._id;
  }

}
Scroller._$name = 'Scroller';

/***/ }),

/***/ "./lib/Core/localization/En.js":
/*!*************************************!*\
  !*** ./lib/Core/localization/En.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
var productName = 'gantt';
 //<umd>

const localeName = 'En',
      localeDesc = 'English',
      locale = {
  localeName,
  localeDesc,
  // Translations for common words and phrases which are used by all classes.
  Object: {
    Yes: 'Yes',
    No: 'No',
    Cancel: 'Cancel',
    Ok: 'OK'
  },
  //region Widgets
  Combo: {
    noResults: 'No results',
    recordNotCommitted: 'Record could not be addded',
    addNewValue: value => `Add ${value}`
  },
  FilePicker: {
    file: 'File'
  },
  Field: {
    // native input ValidityState statuses
    badInput: 'Invalid field value',
    patternMismatch: 'Value should match a specific pattern',
    rangeOverflow: value => `Value must be less than or equal to ${value.max}`,
    rangeUnderflow: value => `Value must be greater than or equal to ${value.min}`,
    stepMismatch: 'Value should fit the step',
    tooLong: 'Value should be shorter',
    tooShort: 'Value should be longer',
    typeMismatch: 'Value is required to be in a special format',
    valueMissing: 'This field is required',
    invalidValue: 'Invalid field value',
    minimumValueViolation: 'Minimum value violation',
    maximumValueViolation: 'Maximum value violation',
    fieldRequired: 'This field is required',
    validateFilter: 'Value must be selected from the list'
  },
  DateField: {
    invalidDate: 'Invalid date input'
  },
  NumberFormat: {
    locale: 'en-US',
    currency: 'USD'
  },
  DurationField: {
    invalidUnit: 'Invalid unit'
  },
  TimeField: {
    invalidTime: 'Invalid time input'
  },
  List: {
    loading: 'Loading...'
  },
  // needed here due to LoadMaskable
  GridBase: {
    loadMask: 'Loading...',
    syncMask: 'Saving changes, please wait...'
  },
  PagingToolbar: {
    firstPage: 'Go to first page',
    prevPage: 'Go to previous page',
    page: 'Page',
    nextPage: 'Go to next page',
    lastPage: 'Go to last page',
    reload: 'Reload current page',
    noRecords: 'No records to display',
    pageCountTemplate: data => `of ${data.lastPage}`,
    summaryTemplate: data => `Displaying records ${data.start} - ${data.end} of ${data.allCount}`
  },
  PanelCollapser: {
    Collapse: 'Collapse',
    Expand: 'Expand'
  },
  UndoRedo: {
    Undo: 'Undo',
    Redo: 'Redo',
    UndoLastAction: 'Undo last action',
    RedoLastAction: 'Redo last undone action'
  },
  //endregion
  //region Others
  DateHelper: {
    locale: 'en-US',
    weekStartDay: 0,
    // Non-working days which match weekends by default, but can be changed according to schedule needs
    nonWorkingDays: {
      0: true,
      6: true
    },
    // Days considered as weekends by the selected country, but could be working days in the schedule
    weekends: {
      0: true,
      6: true
    },
    unitNames: [{
      single: 'millisecond',
      plural: 'ms',
      abbrev: 'ms'
    }, {
      single: 'second',
      plural: 'seconds',
      abbrev: 's'
    }, {
      single: 'minute',
      plural: 'minutes',
      abbrev: 'min'
    }, {
      single: 'hour',
      plural: 'hours',
      abbrev: 'h'
    }, {
      single: 'day',
      plural: 'days',
      abbrev: 'd'
    }, {
      single: 'week',
      plural: 'weeks',
      abbrev: 'w'
    }, {
      single: 'month',
      plural: 'months',
      abbrev: 'mon'
    }, {
      single: 'quarter',
      plural: 'quarters',
      abbrev: 'q'
    }, {
      single: 'year',
      plural: 'years',
      abbrev: 'yr'
    }, {
      single: 'decade',
      plural: 'decades',
      abbrev: 'dec'
    }],
    // Used to build a RegExp for parsing time units.
    // The full names from above are added into the generated Regexp.
    // So you may type "2 w" or "2 wk" or "2 week" or "2 weeks" into a DurationField.
    // When generating its display value though, it uses the full localized names above.
    unitAbbreviations: [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr'], ['dec']],
    parsers: {
      L: 'MM/DD/YYYY',
      LT: 'HH:mm A'
    },
    ordinalSuffix: number => {
      const hasSpecialCase = ['11', '12', '13'].find(n => number.endsWith(n));
      let suffix = 'th';

      if (!hasSpecialCase) {
        const lastDigit = number[number.length - 1];
        suffix = {
          1: 'st',
          2: 'nd',
          3: 'rd'
        }[lastDigit] || 'th';
      }

      return number + suffix;
    }
  },
  //endregion
  //region Trial
  TrialButton: {
    downloadTrial: 'Download trial'
  },
  TrialPanel: {
    title: 'Please complete fields',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    product: 'Product',
    cancel: 'Cancel',
    submit: 'Submit',
    downloadStarting: 'Download starting, please wait...'
  } //endregion

};
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale(localeName, {
  desc: localeDesc,
  locale: locale
});

/***/ }),

/***/ "./lib/Core/localization/LocaleHelper.js":
/*!***********************************************!*\
  !*** ./lib/Core/localization/LocaleHelper.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LocaleHelper; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
/**
* @module Core/localization/LocaleHelper
*/

/**
 * Provides locale management methods.
 */

class LocaleHelper {
  /**
   * Merges all properties of provided locales into new locale.
   * Locales are merged in order they provided and locales which go later replace same properties of previous locales.
   * @param {...Object} locales Locales to merge
   * @return {Object} Merged locale
   */
  static mergeLocales(...locales) {
    const result = {};
    locales.forEach(locale => {
      Object.keys(locale).forEach(key => {
        if (typeof locale[key] === 'object') {
          result[key] = _objectSpread(_objectSpread({}, result[key]), locale[key]);
        } else {
          result[key] = locale[key];
        }
      });
    });
    return result;
  }
  /**
   * Removes all properties from `locale` that are present in the provided `trimLocale`.
   * @param {Object} locale locales to merge
   * @param {Object} trimLocale locales to merge
   */


  static trimLocale(locale, trimLocale) {
    const remove = (key, subKey) => {
      if (locale[key]) {
        if (subKey) {
          if (locale[key][subKey]) {
            delete locale[key][subKey];
          }
        } else {
          delete locale[key];
        }
      }
    };

    Object.keys(trimLocale).forEach(key => {
      if (Object.keys(trimLocale[key]).length > 0) {
        Object.keys(trimLocale[key]).forEach(subKey => remove(key, subKey));
      } else {
        remove(key);
      }
    });
  }
  /**
   * Put the locale under `window.bryntum.locales` to make sure it can be discovered automatically
   * @param {String} localeName Locale name
   * @param {Object} config Locale config
   */


  static publishLocale(localeName, config) {
    const bryntum = window.bryntum = window.bryntum || {},
          locales = bryntum.locales = bryntum.locales || {}; // Avoid registering locales twice

    locales[localeName] = !locales[localeName] ? config : this.mergeLocales(locales[localeName], config);
  }

}
LocaleHelper._$name = 'LocaleHelper';

/***/ }),

/***/ "./lib/Core/localization/LocaleManager.js":
/*!************************************************!*\
  !*** ./lib/Core/localization/LocaleManager.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';






/**
 * @module Core/localization/LocaleManager
 */
// Documented at the export below, to work for singleton

class LocaleManager extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get defaultConfig() {
    return {
      locales: {},
      // Enable strict locale checking by default for tests
      throwOnMissingLocale: _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isTestEnv
    };
  }

  construct(...args) {
    const me = this;
    super.construct(...args);

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv) {
      const scriptTag = document.querySelector('script[data-default-locale]'),
            {
        locales
      } = window.bryntum || {};

      if (scriptTag) {
        me.defaultLocaleName = scriptTag.dataset.defaultLocale;
      }

      if (locales) {
        Object.keys(locales).forEach(localeName => {
          // keeping this check in case some client tries to use an old locale
          if (!localeName.startsWith('moment')) {
            const locale = locales[localeName];

            if (locale.extends) {
              me.extendLocale(locale.extends, locale);
            } else if (locale.localeName) {
              me.registerLocale(locale.localeName, {
                desc: locale.localeDesc,
                locale: locale
              });
            }
          }
        });

        if (!me.locale) {
          // English locale is built in, no need to apply it here since it will be applied anyway
          if (me.defaultLocaleName !== 'En') {
            // No locale applied, use default or first found
            me.applyLocale(me.defaultLocaleName || Object.keys(me.locales)[0]);
          }
        }
      }
    }
  }

  set locales(localeConfigs) {
    this._locales = localeConfigs;
  }
  /**
   * Get currently registered locales.
   * Returns an object with locale names (`localeName`) as properties.
   *
   * Example:
   * ```
   * const englishLocale = LocaleManager.locales.En;
   * ```
   *
   * this returns registered English locale object.
   * ```
   * {
   *   "desc": "English",
   *   "locale": {
   *     "localeName": "En",
   *     "localeDesc": "English",
   *
   *     ... (localization goes here)
   *
   *   }
   * }
   * ```
   * @readonly
   * @member {Object} locales
   */


  get locales() {
    return this._locales;
  }
  /**
   * Get/set currently used locale. Set a name of a locale to have it applied, or give a locale configuration to
   * have it registered and then applied
   * @member {Object} locale
   * @accepts {String|Object}
   */


  set locale(locale) {
    if (typeof locale === 'string') {
      this.applyLocale(locale);
    } else {
      if (!locale.locale) {
        locale = {
          locale,
          localeName: locale.localeName || 'custom'
        };
      }

      this.registerLocale(locale.localeName, locale);
      this.applyLocale(locale.localeName);
    }
  }

  get locale() {
    return this._locale;
  }
  /**
   * Register a locale to make it available for applying.
   * Registered locales are available in {@link Core.localization.LocaleManager#property-locales}.
   * @param {String} name Name of locale (for example `En` or `SvSE`)
   * @param {Object} config Object with localized properties
   * @function registerLocale
   */


  registerLocale(name, config) {
    var _me$locale;

    const me = this,
          isDefault = me.defaultLocaleName === name,
          isCurrent = ((_me$locale = me.locale) === null || _me$locale === void 0 ? void 0 : _me$locale.localeName) === name,
          isFirst = Object.keys(me.locales).length === 0;
    let currentLocale = me.locales[name]; // Avoid registering the same locale twice and merge configs

    if (!currentLocale) {
      me.locales[name] = config;
      currentLocale = me.locales[name];
    } else {
      if (config.exclude) {
        currentLocale.exclude = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(currentLocale.exclude || {}, config.exclude);
      }

      currentLocale.locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(currentLocale.locale, config.locale);
    } // If we have exclude in locale config we remove excluded on registering locale to avoid merging unwanted locale keys


    if (currentLocale.exclude) {
      _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].trimLocale(currentLocale.locale, currentLocale.exclude);
    } // If no default locale specified, use the first one. otherwise apply the default when it is registered
    // also reapply if current locale is registered again (first grid, then scheduler etc).


    if (isDefault || !me.defaultLocaleName && (isFirst || isCurrent)) {
      me.internalApplyLocale(currentLocale);
    }
  }
  /**
   * Extend an already loaded locale to add additional translations.
   * @param {String} name Name of locale (for example `En` or `SvSE`)
   * @param {Object} config Object with localized properties
   * @function extendLocale
   */


  extendLocale(name, config) {
    var _this$locale;

    const locale = this.locales[name];

    if (!locale) {
      return false;
    }

    locale.locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(locale.locale, config);
    delete locale.locale.extends; // If current loaded locale is the same then apply to reflect changes

    if (((_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.localeName) === name) {
      this.applyLocale(name);
    }

    return true;
  }

  internalApplyLocale(localeConfig) {
    this._locale = localeConfig.locale;
    /**
     * Fires when a locale is applied
     * @event locale
     * @param {Core.localization.LocaleManager} source The Locale manager instance.
     * @param {Object} locale Locale configuration
     */

    this.trigger('locale', localeConfig);
  }
  /**
   * Apply a locale. Locale must be defined in {@link Core.localization.LocaleManager#property-locales}.
   * If it is not loaded it will be loaded using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request and then applied.
   * @param {String} name Name of locale to apply (for example `En` or `SvSE`)
   * @returns {Boolean|Promise}
   * @fires locale
   * @function applyLocale
   */


  applyLocale(name, forceApply = false, ignoreError = false) {
    const me = this,
          localeConfig = me.locales[name];

    if (localeConfig !== null && localeConfig !== void 0 && localeConfig.locale && me._locale === localeConfig.locale && !forceApply) {
      // no need to apply same locale again
      return true;
    } // ignoreError is used in examples where one example might have defined a locale not available in another


    if (!localeConfig) {
      if (ignoreError) {
        return true;
      }

      throw new Error(`Locale ${name} not registered`);
    }

    function internalApply() {
      me.internalApplyLocale(localeConfig);
    }

    if (!localeConfig.locale) {
      return new Promise((resolve, reject) => {
        me.loadLocale(localeConfig.path).then(response => {
          response.text().then(text => {
            // eslint-disable-next-line no-new-func
            const parseLocale = new Function(text);
            parseLocale();

            if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv) {
              localeConfig.locale = window.bryntum.locales[name];
            }

            internalApply();
            resolve(localeConfig);
          });
        }).catch(response => reject(response));
      });
    }

    internalApply();
    return true;
  }
  /**
   * Loads a locale using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request.
   * @private
   * @param {String} path Path to locale file
   * @returns {Promise}
   * @function loadLocale
   */


  loadLocale(path) {
    return _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(path);
  }
  /**
   * Specifies if {@link Core.localization.Localizable#function-L-static Localizable.L()} function would throw error if no localization found in runtime
   * @member {Boolean} throwOnMissingLocale
   * @default false
   */


  set throwOnMissingLocale(value) {
    this._throwOnMissingLocale = value;
  }

  get throwOnMissingLocale() {
    return this._throwOnMissingLocale;
  }

}

const LocaleManagerSingleton = new LocaleManager();
/**
 * Singleton that handles switching locale. Locales can be included on page with `<script type="module">` tags or
 * loaded using ajax. When using script tags the first locale loaded is used per default, if another should be used as
 * default specify it on the script tag for the grid (see example below).
 *
 * ```
 * // Using Ecma 6 modules
 * <script type="module" src="./Core/localization/SvSE.js">
 *
 * // Specify default when using scripts
 * <script src="build/locales/grid.locale.SvSE.js">
 * <script data-default-locale="En" src="build/grid-all.js">
 *
 * import LocaleManager from 'Core/localization/LocaleManager.js';
 * // Set locale using method
 * LocaleManager.applyLocale('SvSE');
 * // Or set locale using property
 * LocaleManager.locale = LocaleManager.locales.SvSE;
 * ```
 *
 * @demo Grid/localization
 * @class
 * @singleton
 */

/* harmony default export */ __webpack_exports__["default"] = (LocaleManagerSingleton);

/***/ }),

/***/ "./lib/Core/localization/Localizable.js":
/*!**********************************************!*\
  !*** ./lib/Core/localization/Localizable.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';



/**
 * @module Core/localization/Localizable
 */

const ObjectProto = Object.getPrototypeOf(Object),
      localeRe = /L{.*?}/g,
      escape = txt => txt.replace(/{(\d+)}/gm, '[[$1]]'),
      unescape = txt => txt.replace(/\[\[(\d+)]]/gm, '{$1}');
/**
 * Mixin that provides localization functionality to a class.
 *
 * ```
 * // Get localized string
 * grid.L('foo');
 * grid.L('L{foo}');
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Localizable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Localizable';
  }

  static get configurable() {
    return {
      /**
       * A class translations of which are used for translating this entity.
       * This is often used when translations of an item are defined on its container class.
       * For example:
       *
       * ```js
       * // Toolbar class that has some predefined items
       * class MyToolbar extends Toolbar {
       *
       *     static get $name() {
       *         return 'MyToolbar';
       *     }
       *
       *     static get defaultConfig() {
       *         return {
       *             // this specifies default configs for the items
       *             defaults : {
       *                 // will tell items to use the toolbar locale
       *                 localeClass : this
       *             },
       *
       *             items : [
       *                 // The toolbar has 2 buttons and translation for their texts will be searched in
       *                 // the toolbar locales
       *                 { text : 'Agree' },
       *                 { text : 'Disagree' }
       *             ]
       *         };
       *     }
       *
       *    ...
       * }
       * ```
       * So if one makes a locale for the `MyToolbar` class that will include `Agree` and `Disagree` string translations:
       * ```js
       *     ...
       *     MyToolbar : {
       *         Agree    : 'Yes, I agree',
       *         Disagree : 'No, I do not agree'
       *     }
       * ```
       * They will be used for the toolbar buttons and the button captions will say `Yes, I agree` and `No, I do not agree`.
       *
       * @config {Core.Base}
       * @typings {typeof Base}
       */
      localeClass: null,

      /**
       * List of properties which values should be translated automatically upon a locale applying.
       * In case there is a need to localize not typical value (not a String value or a field with re-defined setter/getter),
       * you could use 'localeKey' meta configuration.
       * Example:
       * ```js
       *  static get configurable() {
       *     return {
       *          localizableProperties : ['width'],
       *
       *          width : {
       *              value   : '54em', // default value here
       *              $config : {
       *                  localeKey : 'L{editorWidth}' // name of the property that will be used in localization file
       *              }
       *          }
       *      };
       *  }
       * ```
       * @config {String[]}
       */
      localizableProperties: {
        value: [],
        $config: {
          merge: 'distinct'
        }
      }
    };
  }

  static clsName(cls) {
    var _cls$prototype, _cls$prototype2;

    return typeof cls === 'string' ? cls : cls === ObjectProto ? 'Object' : cls.$$name || cls.name || ((_cls$prototype = cls.prototype) === null || _cls$prototype === void 0 ? void 0 : _cls$prototype.$$name) || ((_cls$prototype2 = cls.prototype) === null || _cls$prototype2 === void 0 ? void 0 : _cls$prototype2.name);
  }

  static parseLocaleString(text) {
    var _text;

    const matches = [];
    let m; // Parse locale text in case it's wrapped with L{foo}

    if ((_text = text) !== null && _text !== void 0 && _text.includes('L{')) {
      const re = /L{(.*?)}/g; // Escape fix for {1}, {2} etc. in locale str

      text = escape(text);

      while ((m = re.exec(text)) != null) {
        // Support for parsing class namespace L{Class.foo}
        const classMatch = /((.*?)\.)?(.+)/g.exec(m[1]);
        matches.push({
          match: unescape(m[0]),
          localeKey: unescape(classMatch[3]),
          localeClass: classMatch[2]
        });
      }
    }

    return matches.length > 0 ? matches : [{
      match: text,
      localeKey: text,
      localeClass: undefined
    }];
  }

  construct(config = {}, ...args) {
    // Base class applies configs.
    super.construct(config, ...args);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on('locale', this.updateLocalization, this);
    this.updateLocalization();
  }

  get localeClass() {
    return this._localeClass || null;
  }

  localizeProperty(property) {
    var _me$$meta$configs$pro;

    const me = this,
          currentValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(me, property),
          localeKey = (_me$$meta$configs$pro = me.$meta.configs[property]) === null || _me$$meta$configs$pro === void 0 ? void 0 : _me$$meta$configs$pro.localeKey; // check if localeKey is defined and try to translate it

    if (localeKey) {
      const localizedValue = Localizable.localize(localeKey, null, me.localeClass || me); // if a user set value directly in class definition, his value has a prio

      if (localizedValue && !(property in me.initialConfig)) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me, property, localizedValue);
      }
    } else if (typeof currentValue === 'string') {
      me.originalLocales = me.originalLocales || {};
      let propertyValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(me.originalLocales, property); // If we haven't saved original values yet let's do that

      if (propertyValue === undefined) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me.originalLocales, property, currentValue);
        propertyValue = currentValue;
      } // Doing localization from the original values


      if (propertyValue) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me, property, me.optionalL(propertyValue));
      }
    }
  }
  /**
   * Method that is triggered when applying a locale to the instance
   * (happens on the instance construction steps and when switching to another locale).
   *
   * The method can be overridden to dynamically translate the instance when locale is switched.
   * When overriding the method please make sure you call `super.updateLocalization()`.
   * @category Misc
   */


  updateLocalization() {
    var _this$localizableProp;

    (_this$localizableProp = this.localizableProperties) === null || _this$localizableProp === void 0 ? void 0 : _this$localizableProp.forEach(this.localizeProperty, this);
  }

  static getTranslation(text, templateData, localeCls) {
    const {
      locale
    } = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"];
    let result = null,
        clsName,
        cls;

    if (locale) {
      // Iterate over all found localization entries
      for (const {
        match,
        localeKey,
        localeClass
      } of this.parseLocaleString(text)) {
        const translate = clsName => {
          var _locale$clsName;

          const translation = (_locale$clsName = locale[clsName]) === null || _locale$clsName === void 0 ? void 0 : _locale$clsName[localeKey];

          if (translation) {
            if (typeof translation === 'function') {
              result = templateData != null ? translation(templateData) : translation;
            } else if (typeof translation === 'object' || text === match) {
              result = translation;
            } // Likely string
            else {
              result = (result || text).replace(match, translation);
            } // Might have nested L{, recurse


            if (typeof translation === 'string' && translation.includes('L{')) {
              result = this.getTranslation(translation, templateData, localeCls);
            }
          }

          return translation;
        }; // Translate order
        // 1. Try to translate for current class
        // 2. Try to translate by Class hierarchy traversing prototypes
        // 3. Try to translate if Class is in {Class.foo} format


        let success = false;

        for (cls = localeCls; cls && (clsName = Localizable.clsName(cls)); cls = Object.getPrototypeOf(cls)) {
          if (success = translate(clsName)) {
            break;
          } else if (typeof cls === 'string') {
            break;
          }
        }

        if (!success && localeClass) {
          translate(localeClass);
        }
      }
    }

    return result;
  }
  /**
   * Get localized string, returns `null` if no localized string found.
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @internal
   */


  static localize(text, templateData = undefined, ...localeClasses) {
    var _localeClasses;

    // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself
    if (((_localeClasses = localeClasses) === null || _localeClasses === void 0 ? void 0 : _localeClasses.length) === 0) {
      localeClasses = [this];
    }

    let translation = null;
    localeClasses.some(cls => {
      translation = Localizable.getTranslation(text, templateData, cls);
      return translation != null;
    });
    return translation;
  }
  /**
   * Get localized string, returns value of `text` if no localized string found.
   *
   * If {@link Core.localization.LocaleManager#property-throwOnMissingLocale LocaleManager.throwOnMissingLocale}
   * is `true` then calls to `L()` will throw `Localization is not found for 'text' in 'ClassName'` exception when no
   * localization is found.
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @static
   * @returns {String}
   */


  static L(text, templateData = undefined, ...localeClasses) {
    var _localeClasses2;

    // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself
    if (((_localeClasses2 = localeClasses) === null || _localeClasses2 === void 0 ? void 0 : _localeClasses2.length) === 0) {
      localeClasses = [this];
    }

    const translation = this.localize(text, templateData, ...localeClasses); // Throw error if not localized and text matches `L{foo}`

    if (translation == null && _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale && _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale && text.includes('L{')) {
      throw new Error(`Localization is not found for '${text}' in '${localeClasses.map(cls => Localizable.clsName(cls)).join(', ')}'. ${_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale.localeName ? `Locale : ${_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale.localeName}` : ''}`);
    }

    return translation !== null && translation !== void 0 ? translation : text;
  }
  /**
   * Convenience function that can be called directly on the class that mixes Localizable in
   *
   * ```javascript
   * button.text = grid.L('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @category Misc
   */


  L(text, templateData) {
    const {
      localeClass,
      constructor
    } = this; // If we have a different class set as translations provider
    // pass it first and use the class being translated as a fallback provider

    if (localeClass && Localizable.clsName(localeClass) !== Localizable.clsName(constructor)) {
      return Localizable.L(text, templateData, localeClass, constructor);
    } else {
      return Localizable.L(text, templateData, constructor);
    }
  }
  /**
   * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
   * an error when the translation is missing even if configured with `throwOnMissingLocale`
   *
   * ```javascript
   * button.text = grid.optionalL('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @static
   * @category Misc
   */


  static optionalL(text, templateData = undefined, ...localeClasses) {
    var _localeClasses3;

    const shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale;
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text); // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself

    if (((_localeClasses3 = localeClasses) === null || _localeClasses3 === void 0 ? void 0 : _localeClasses3.length) === 0) {
      localeClasses = [this];
    }

    const result = Localizable.L(text, templateData, ...localeClasses);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow;
    return result;
  }
  /**
   * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
   * an error when the translation is missing even if configured with `throwOnMissingLocale`
   *
   * ```javascript
   * button.text = grid.optionalL('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @category Misc
   * @internal
   */


  optionalL(text, templateData) {
    const shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale;
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text);
    const result = this.L(text, templateData);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow;
    return result;
  }
  /**
   * Get the global LocaleManager
   * @property {Core.localization.LocaleManager}
   * @typings { typeof LocaleManager }
   * @category Misc
   * @readonly
   */


  get localeManager() {
    return _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"];
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Delayable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Delayable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';



const {
  defineProperty
} = Reflect;
let performance;

if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBrowserEnv) {
  performance = window.performance;
} else {
  performance = {
    now() {
      return new Date().getTime();
    }

  };
}
/**
 * @module Core/mixin/Delayable
 */
// Global timeout collections for tests


let globalDelays = null;

if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTestEnv) {
  const bryntum = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global.bryntum || (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global.bryntum = {});
  globalDelays = bryntum.globalDelays = {
    timeouts: new Map(),
    intervals: new Map(),
    animationFrames: new Map(),

    isEmpty(includeIntervals = false) {
      return globalDelays.timeouts.size + globalDelays.animationFrames.size + (includeIntervals ? globalDelays.intervals.size : 0) === 0;
    }

  };
}

const
/**
 * Creates and returns a function that will call the user-supplied `fn`.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} fn The user function to call when the timer fires.
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {Object} options The invoke options.
 * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
 * @param {Object} [options.thisObj] The `this` reference for `fn`.
 * @returns {Function}
 * @private
 */
makeInvoker = (me, fn, wrapFn, options) => {
  const named = typeof fn === 'string',
        appendArgs = options && options.appendArgs || [],
        // The invoker fn is intended to be wired directly to native setTimeout/requestAnimationFrame/etc and so
  // it does not receive any arguments worth passing on to the user's fn. Those come from the original call
  // to the wrapFn.
  invoker = () => {
    wrapFn.timerId = null;
    wrapFn.lastCallTime = performance.now(); // Grab args now and null the stored args out (to avoid leaks):

    const args = wrapFn.args;
    wrapFn.args = null;

    if (named) {
      me[fn](...args, ...appendArgs);
    } else {
      fn.call(me, ...args, ...appendArgs);
    }

    wrapFn.called = true;
    ++wrapFn.calls;
  };

  if (options) {
    me = options.thisObj || me;
  } // We put most everything as properties on the wrapFn so that it can all be inspected in the debugger (unlike
  // closure variables) and expected in tests.


  wrapFn.lastCallTime = -9e9; // performance.now() = 0 at start...

  wrapFn.calls = 0;
  wrapFn.invoker = invoker;
  invoker.wrapFn = wrapFn;
  return invoker;
},

/**
 * Decorates the supported `wrapFn` with additional methods and an `isPending` readonly
 * property. These decorations are available to user code to help manage the scheduling
 * behavior of the buffered function.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {String} cancelFn The name of the function that will cancel a timer.
 * @returns {Function} The `wrapFn` is returned.
 * @private
 */
decorateWrapFn = (me, wrapFn, cancelFn = 'clearTimeout') => {
  wrapFn.cancel = () => {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId); // avoid leaks and cleanup:

      wrapFn.args = wrapFn.timerId = null;
    }
  };

  wrapFn.flush = () => {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId);
      wrapFn.timerId = null; // we don't call cancel() since it also sets args=null

      wrapFn.invoker();
    }
  };

  wrapFn.now = (...args) => {
    wrapFn.cancel();
    wrapFn.args = args;
    wrapFn.invoker();
  };

  wrapFn.resume = all => {
    const n = wrapFn.suspended;
    wrapFn.suspended = all || n < 1 ? 0 : n - 1;
  };

  wrapFn.suspend = () => {
    ++wrapFn.suspended;
  };

  wrapFn.immediate = false;
  wrapFn.suspended = 0;
  wrapFn.timerId = null;
  defineProperty(wrapFn, 'isPending', {
    get() {
      return wrapFn.timerId !== null;
    }

  });
  return wrapFn;
};
/**
 * Tracks setTimeout, setInterval and requestAnimationFrame calls and clears them on destroy.
 *
 * @example
 * someClass.setTimeout(() => console.log('hi'), 200);
 * someClass.setInterval(() => console.log('annoy'), 100);
 * // can also use named timeouts for easier tracking
 * someClass.setTimeout(() => console.log('named'), 300, 'named');
 * someClass.clearTimeout('named');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Delayable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Delayable';
  }

  static get declarable() {
    return [
    /**
     * This class property returns an object that specifies methods to wrap with configurable timer behaviors.
     *
     * It is used like so:
     * ```
     *  class Foo extends Delayable() {
     *      static get delayable() {
     *          return {
     *              expensiveMethod : 500
     *          };
     *      }
     *
     *      expensiveMethod() {
     *          this.things();
     *          this.moreThings();
     *          this.evenMoreThings();
     *      }
     *  }
     * ```
     * With the above in place, consider:
     * ```
     *  let instance = new Foo();
     *
     *  instance.expensiveMethod();
     * ```
     * Instead of the above code immediately calling the `expensiveMethod()`, it will start a timer that will
     * invoke the method 500ms later. Because `expensiveMethod()` is an instance method, each instance of `Foo`
     * will have its own timer.
     *
     * NOTE: Only instance methods are currently supported (i.e., only non-`static` methods).
     *
     * #### Options
     * The value of each key configures how the method will be scheduled. If the value is a number, it is
     * promoted to a config object of `type='buffer'` as in the following:
     * ```
     *  class Foo extends Delayable() {
     *      static get delayable() {
     *          return {
     *              expensiveMethod : {
     *                  type  : 'buffer',
     *                  delay : 500
     *              }
     *          };
     *      }
     *  });
     * ```
     * The `type` property of the config object must be one of three values. Other options can be provided
     * depending on the `type`:
     *
     *  - `buffer`<br>
     *    Other options:
     *     - `delay` (Number) : The number of milliseconds to wait before calling the underlying method. A
     *       value of 0 is equivalent to setting `immediate: true`.
     *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the buffer).
     *  - `raf` (short for "request animation frame")<br>
     *    Other options:
     *     - `cancelOutstanding` (Boolean) : Set to `true` to cancel any pending animation frame requests and
     *       schedule a new one on each call.
     *     - `immediate` (Boolean) : Set to `true` to call immediately.
     *  - `throttle`<br>
     *    Other options:
     *     - `delay` (Number) : The number of milliseconds to wait after each execution before another
     *       execution takes place. A value of 0 is equivalent to setting `immediate: true`.
     *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the throttle).
     *
     * While `immediate: true` can be specified at the class level, it is more typical to set it on the
     * instance's method as described below.
     *
     * #### Delayable Method API
     * Delayable methods have a consistent API to manage their scheduling. This API is added to the methods
     * themselves.
     *
     * For example:
     * ```
     *  let instance = new Foo();
     *
     *  instance.expensiveMethod();         // schedule a call in 500ms
     *  instance.expensiveMethod.isPending; // true
     *  instance.expensiveMethod.cancel();
     *  instance.expensiveMethod.flush();
     *  instance.expensiveMethod.now();
     *
     *  instance.expensiveMethod.delay = 10;
     *  instance.expensiveMethod();         // schedule a call in 10ms
     * ```
     *
     * ##### `isPending` (Boolean, readonly)
     * This boolean property will be `true` if a call has been scheduled, and false otherwise.
     *
     * ##### `cancel()`
     * Cancels a pending call if one has been scheduled. Otherwise this method does nothing.
     *
     * ##### `flush()`
     * Cancels the timer and causes the pending call to execute immediately. If there is no pending call, this
     * method does nothing.
     *
     * ##### `now()`
     * Cancels the timer (if one is pending) and executes the method immediately. If there is no pending call,
     * this method will still call the underlying method.
     *
     * @static
     * @member {Object} delayable
     * @internal
     */
    'delayable'];
  }

  doDestroy() {
    const me = this; // Normally one would expect this call at the end of this method... but in this case we need to run cleanup
    // of this stuff after config nullification since those can trigger delayable method calls.

    super.doDestroy();

    if (me.timeoutIds) {
      me.timeoutIds.forEach((fn, id) => {
        if (typeof fn === 'function') {
          fn();
        }

        clearTimeout(id);

        if (globalDelays) {
          globalDelays.timeouts.delete(id);
        }
      });
      me.timeoutIds = null;
    }

    if (me.timeoutMap) {
      me.timeoutMap.forEach((name, id) => clearTimeout(id));
      me.timeoutMap = null;
    }

    if (me.intervalIds) {
      me.intervalIds.forEach(id => {
        clearInterval(id);

        if (globalDelays) {
          globalDelays.intervals.delete(id);
        }
      });
      me.intervalIds = null;
    }

    if (me.animationFrameIds) {
      me.animationFrameIds.forEach(id => {
        cancelAnimationFrame(id);

        if (globalDelays) {
          globalDelays.animationFrames.delete(id);
        }
      });
      me.animationFrameIds = null;
    }
  }
  /**
   * Check if a named timeout is active
   * @param name
   * @internal
   */


  hasTimeout(name) {
    return !!(this.timeoutMap && this.timeoutMap.has(name));
  }
  /**
   * Same as native setTimeout, but will be cleared automatically on destroy. If a propertyName is supplied it will
   * be used to store the timeout id.
   * @param {Object} timeoutSpec An object containing the details about that function, and the time delay.
   * @param {Function|String} timeoutSpec.fn The function to call, or name of function in this object to call. Used as the `name` parameter if a string.
   * @param {Number} timeoutSpec.delay The milliseconds to delay the call by.
   * @param {Object[]} timeoutSpec.args The arguments to pass.
   * @param {String} [timeoutSpec.name] The name under which to register the timer. Defaults to `fn.name`.
   * @param {Boolean} [timeoutSpec.runOnDestroy] Pass `true` if this function should be executed if the Delayable instance is destroyed while function is scheduled.
   * @param {Boolean} [timeoutSpec.cancelOutstanding] Pass `true` to cancel any outstanding invocation of the passed function.
   * @returns {Number}
   * @internal
   */


  setTimeout({
    fn,
    delay,
    name,
    runOnDestroy,
    cancelOutstanding,
    args
  }) {
    if (arguments.length > 1 || typeof arguments[0] === 'function') {
      [fn, delay, name, runOnDestroy] = arguments;
    }

    if (typeof fn === 'string') {
      name = fn;
    } else if (!name) {
      name = fn.name;
    }

    if (cancelOutstanding) {
      this.clearTimeout(name);
    }

    const me = this,
          timeoutIds = me.timeoutIds || (me.timeoutIds = new Map()),
          timeoutMap = me.timeoutMap || (me.timeoutMap = new Map()),
          timeoutId = setTimeout(() => {
      if (typeof fn === 'string') {
        fn = me[name];
      } // Cleanup before invocation in case fn throws


      timeoutIds && timeoutIds.delete(timeoutId);
      timeoutMap && timeoutMap.delete(name);
      globalDelays && globalDelays.timeouts.delete(timeoutId);
      fn.apply(me, args);
    }, delay);
    timeoutIds.set(timeoutId, runOnDestroy ? fn : true);

    if (globalDelays) {
      globalDelays.timeouts.set(timeoutId, {
        fn,
        delay,
        name
      });
    }

    if (name) {
      timeoutMap.set(name, timeoutId);
    }

    return timeoutId;
  }
  /**
   * clearTimeout wrapper, either call with timeout id as normal clearTimeout or with timeout name (if you specified
   * a name to setTimeout())
   * property to null.
   * @param {Number|String} idOrName timeout id or name
   * @internal
   */


  clearTimeout(idOrName) {
    let id = idOrName;

    if (typeof id === 'string') {
      if (this.timeoutMap) {
        id = this.timeoutMap.get(idOrName);
        this.timeoutMap.delete(idOrName);
      } else {
        return;
      }
    }

    clearTimeout(id);
    this.timeoutIds && this.timeoutIds.delete(id);
    globalDelays && globalDelays.timeouts.delete(id);
  }
  /**
   * clearInterval wrapper
   * @param {Number} id
   * @internal
   */


  clearInterval(id) {
    clearInterval(id);
    this.intervalIds && this.intervalIds.delete(id);
    globalDelays && globalDelays.intervals.delete(id);
  }
  /**
   * Same as native setInterval, but will be cleared automatically on destroy
   * @param fn
   * @param delay
   * @returns {Number}
   * @internal
   */


  setInterval(fn, delay) {
    const intervalId = setInterval(fn, delay);
    (this.intervalIds || (this.intervalIds = new Set())).add(intervalId);
    globalDelays && globalDelays.intervals.set(intervalId, {
      fn,
      delay
    });
    return intervalId;
  }
  /**
   * Relays to native requestAnimationFrame and adds to tracking to have call automatically canceled on destroy.
   * @param {Function} fn
   * @param {Object[]} [extraArgs] The argument list to append to those passed to the function.
   * @param {Object} [thisObj] `this` reference for the function.
   * @returns {Number}
   * @internal
   */


  requestAnimationFrame(fn, extraArgs = [], thisObj = this) {
    const animationFrameIds = this.animationFrameIds || (this.animationFrameIds = new Set()),
          frameId = requestAnimationFrame(() => {
      globalDelays && globalDelays.animationFrames.delete(frameId);
      animationFrameIds.delete(frameId);
      return fn.apply(thisObj, extraArgs);
    });
    animationFrameIds.add(frameId);
    globalDelays && globalDelays.animationFrames.set(frameId, {
      fn,
      extraArgs,
      thisObj
    });
    return frameId;
  }
  /**
   * Creates a function which will execute once, on the next animation frame. However many time it is
   * called in one event run, it will only be scheduled to run once.
   * @param {Function|String} fn The function to call, or name of function in this object to call.
   * @param {Object[]} [args] The argument list to append to those passed to the function.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Boolean} [cancelOutstanding] Cancel any outstanding queued invocation upon call.
   * @internal
   */


  createOnFrame(fn, args = [], thisObj = this, cancelOutstanding) {
    let rafId;

    const result = (...callArgs) => {
      // Cancel if outstanding if requested
      if (rafId && cancelOutstanding) {
        this.cancelAnimationFrame(rafId);
        rafId = null;
      }

      if (!rafId) {
        rafId = this.requestAnimationFrame(() => {
          if (typeof fn === 'string') {
            fn = thisObj[fn];
          }

          rafId = null;
          callArgs.push(...args);
          fn.apply(thisObj, callArgs);
        });
      }
    };

    result.cancel = () => this.cancelAnimationFrame(rafId);

    return result;
  }
  /**
   * Relays to native cancelAnimationFrame and removes from tracking.
   * @param {Number} handle
   * @internal
   */


  cancelAnimationFrame(handle) {
    cancelAnimationFrame(handle);
    this.animationFrameIds && this.animationFrameIds.delete(handle);
    globalDelays && globalDelays.animationFrames.delete(handle);
  }

  async nextAnimationFrame() {
    return new Promise(resolve => this.requestAnimationFrame(resolve));
  }
  /**
   * Wraps a function with another function that delays it specified amount of time, repeated calls to the wrapper
   * resets delay.
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Object|Number} options The delay in milliseconds or an options object.
   * @param {Number} options.delay The delay in milliseconds.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Object} [options.thisObj] The `this` reference for the function.
   * @returns {Function} Wrapped function to call.
   * @internal
   */


  buffer(fn, options) {
    let delay = options;

    if (options && typeof options !== 'number') {
      // if (config object)
      delay = options.delay;
    } else {
      options = null;
    }

    const bufferWrapFn = (...params) => {
      if (bufferWrapFn.suspended) {
        return;
      }

      const {
        delay
      } = bufferWrapFn;
      bufferWrapFn.cancel();
      bufferWrapFn.called = false;
      bufferWrapFn.args = params; // If delay=0, the buffer has been disabled so always call immediately.

      if (bufferWrapFn.immediate || !delay) {
        invoker();
      } else {
        bufferWrapFn.timerId = this.setTimeout(invoker, delay);
      }
    },
          invoker = makeInvoker(this, fn, bufferWrapFn, options);

    bufferWrapFn.delay = delay;
    return decorateWrapFn(this, bufferWrapFn);
  }
  /**
   * Returns a function that when called will schedule a call to `fn` on the next animation frame.
   *
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Boolean|Object} [options] An options object or the `cancelOutstanding` boolean property of it.
   * @param {Boolean} [options.cancelOutstanding] Pass `true` to cancel any pending animation frame requests and
   * schedule a new one on each call to the returned function.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Object} [options.thisObj] The `this` reference for the function.
   * @returns {Function}
   * @internal
   */


  raf(fn, options) {
    // NOTE: This method is only intended for use with `delayable`. It has a signature that is compatible
    // with `buffer()` and `throttle()`. The name is 'raf' to make the following aesthetically pleasing:
    //
    //  class Foo extends Delayable() {
    //      static get delayable() {
    //          return {
    //              bar : 'raf'
    //          };
    //      }
    //  }
    let cancelOutstanding = options;

    if (options && typeof options !== 'boolean') {
      // if (config object)
      cancelOutstanding = options.cancelOutstanding;
    } else {
      options = null;
    }

    const rafWrapFn = (...params) => {
      if (rafWrapFn.suspended) {
        return;
      } // Reschedule the frame on each call if requested


      if (rafWrapFn.cancelOutstanding) {
        rafWrapFn.cancel();
      }

      rafWrapFn.called = false;
      rafWrapFn.args = params;

      if (rafWrapFn.immediate) {
        invoker();
      } else if (!rafWrapFn.isPending) {
        rafWrapFn.timerId = this.requestAnimationFrame(invoker);
      }
    },
          invoker = makeInvoker(this, fn, rafWrapFn, options);

    rafWrapFn.cancelOutstanding = cancelOutstanding;
    return decorateWrapFn(this, rafWrapFn, 'cancelAnimationFrame');
  }
  /**
   * Create a "debounced" function which will call on the "leading edge" of a timer period.
   * When first invoked will call immediately, but invocations after that inside its buffer
   * period will be rejected, and *one* invocation will be made after the buffer period has expired.
   *
   * This is useful for responding immediately to a first mousemove, but from then on, only
   * calling the action function on a regular timer while the mouse continues to move.
   *
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Number|Object} options The milliseconds to wait after each execution before another execution takes place
   * or a object containing options.
   * @param {Object} [options.thisObj] `this` reference for the function.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Function|String} [options.throttled] A function to call when the invocation is delayed due to buffer
   * time not having expired. If this is a string, it is looked up as a method on `this` instance (or `options.thisObj`
   * instead, if provided). When called, the same arguments are passed as would have been passed to `fn`, including
   * any `options.appendArgs`.
   * @internal
   */


  throttle(fn, options) {
    let delay = options,
        throttled;

    if (options && typeof options !== 'number') {
      // if (config object)
      delay = options.delay;
      throttled = options.throttled;
    } else {
      options = null;
    }

    const me = this,
          throttleWrapFn = (...args) => {
      if (throttleWrapFn.suspended) {
        return;
      }

      const {
        delay
      } = throttleWrapFn,
            elapsed = performance.now() - throttleWrapFn.lastCallTime;
      throttleWrapFn.args = args; // If it's been more then the delay period since we invoked, we can call it now.
      // Setting delay=0 effectively disables the throttle (which is the goal)

      if (throttleWrapFn.immediate || elapsed >= delay) {
        me.clearTimeout(throttleWrapFn.timerId);
        invoker();
      } else {
        // Kick off a timer for the requested period.
        if (!throttleWrapFn.isPending) {
          throttleWrapFn.timerId = me.setTimeout(invoker, delay - elapsed);
          throttleWrapFn.called = false;
        }

        if (throttled) {
          // Args have to be stored on the wrapFn for the invoker to pick them up:
          throttled.wrapFn.args = args;
          throttled();
        }
      }
    },
          invoker = makeInvoker(me, fn, throttleWrapFn, options);

    throttleWrapFn.delay = delay;

    if (throttled) {
      // Make an invoker for this callback to handle thisObj and typeof=string etc (pass a dud wrapFn):
      throttled = makeInvoker(me, throttled, () => {}, options);
    }

    return decorateWrapFn(me, throttleWrapFn);
  }

  static setupDelayable(cls) {
    cls.setupDelayableMethods(cls.delayable);
  }
  /**
   * This method initializes the `delayable` methods on this class.
   * @param {Object} delayable The `delayable` property.
   * @param {Function} [cls] This parameter will be used internally to process static methods.
   * @private
   */


  static setupDelayableMethods(delayable, cls = null) {
    const me = this,
          statics = delayable.static,
          target = cls || me.prototype;

    if (statics) {
      // TODO me.setupDelayableMethods(statics, me);
      delete delayable.static;
    }

    for (const name in delayable) {
      let options = delayable[name];
      const implName = name + 'Now',
            type = typeof options;
      target[implName] = target[name];

      if (type === 'number') {
        options = {
          type: 'buffer',
          delay: options
        };
      } else if (type === 'string') {
        options = {
          type: options
        };
      } // For instance methods, we place a getter on the prototype. When the method is first accessed from the
      // prototype, we create an instance-specific version by calling this.buffer()/throttle() (based on the type
      // desired) and set that as the instance-level property.


      defineProperty(target, name, {
        get() {
          const value = this[options.type]((...params) => {
            this[implName](...params);
          }, options);
          defineProperty(this, name, {
            value
          });
          return value;
        }

      });
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Draggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Draggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony import */ var _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
var productName = 'gantt';






/**
 * @module Core/mixin/Draggable
 */

/**
 * Mix this into another class to enable drag/drop support.
 *
 * To use a draggable, it must be associated with an element that contains draggable content:
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement
 *  });
 * ```
 *
 * Once the `dragRootElement` is assigned, any element inside that root is a candidate for dragging. To limit the
 * allowed element, set the {@link #config-dragSelector} config.
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement,
 *      dragSelector    : '.drag-this'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Draggable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Draggable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * The current `DragContext`. This is created immediately on pointerdown but does not become active until
       * some movement occurs. This {@link #config-dragThreshold threshold} is configurable.
       * @member {Core.util.drag.DragContext}
       * @readonly
       */
      dragging: {
        $config: 'nullify',
        value: null
      },

      /**
       * A CSS selector to use to ascend from the {@link #config-dragRootElement} to find the element that will
       * gain the {@link #property-draggingCls} and {@link #property-draggingStartedCls} CSS classes.
       * @config {String}
       */
      draggingClsSelector: null,

      /**
       * The listeners to add to the `document` during a drag.
       * @config {Object}
       * @private
       */
      dragDocumentListeners: {
        element: document,
        keydown: 'onDragKeyDown',
        keyup: 'onDragKeyUp',
        // On mobile, a long-press will (sometimes) trigger a context menu, so we suppress it:
        contextmenu: 'onDragContextMenu',
        // We don't use pointermove/up because they get snared in the "touch-action" vs "pan-x/y" trap and we
        // cannot prevent panning (aka scrolling) in response to move events if we go that way:
        mousemove: 'onDragPointerMove',
        mouseup: 'onDragPointerUp',
        // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired. iOS does
        // fire touchend:
        pointerup: 'onDragPointerUp',
        touchend: 'onDragPointerUp',
        touchmove: {
          handler: 'onDragPointerMove',
          passive: false // We need to be able to preventDefault on the touchmove

        }
      },

      /**
       * A CSS selector to use to ascend from the drag element to find the element that will gain the
       * {@link #property-draggingItemCls} CSS class. If not supplied, the drag element will gain this CSS
       * class.
       * @config {String}
       */
      dragItemSelector: null,

      /**
       * A CSS class to add to items identified by the {@link #config-dragItemSelector} when the mouse
       * enters.
       * @config {String}
       */
      dragItemOverCls: null,

      /**
       * A function to call when the pointer enters a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseEnter
       */

      /**
       * A function to call when the pointer moves inside a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseMove
       */

      /**
       * A function to call when the pointer leaves a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseLeave
       */

      /**
       * Configure as `'x'` to lock dragging to the `X` axis (the drag will only move horizontally) or `'y'`
       * to lock dragging to the `Y` axis (the drag will only move vertically).
       * @config {String}
       */
      dragLock: null,

      /**
       * The minimum distance a drag must move to be considered a drop and not
       * {@link Core.util.drag.DragContext#property-aborted aborted}.
       * @config {Number}
       * @default
       */
      dragMinDistance: 1,

      /**
       * The {@link Core.util.drag.DragProxy drag proxy} is a helper object that can be used to display feedback
       * during a drag.
       * @config {Object|Core.util.drag.DragProxy}
       */
      dragProxy: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * The outer element where dragging will operate (attach events to it and use as root limit when looking
       * for ancestors).
       * @config {HTMLElement}
       */
      dragRootElement: {
        $config: 'nullify',
        value: null
      },

      /**
       * Set to `true` to allow a drag to drop on to the same element from which the drag started.
       * @config {Boolean}
       * @default
       */
      dragSameTargetDrop: false,

      /**
       * A CSS selector used to determine which element(s) can be dragged.
       * @config {String}
       * @default
       */
      dragSelector: null,

      /**
       * The number of milliseconds after a pointerup to ignore click events on the document. This
       * is used to avoid the "up" event itself generating a `click` on the target.
       * @config {Number}
       * @default
       */
      dragSwallowClickTime: 50,

      /**
       * The amount of pixels to move pointer/mouse before it counts as a drag operation.
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * The number of milliseconds that must elapse after a `touchstart` event before it is considered a drag. If
       * movement occurs before this time, the drag is aborted. This is to allow touch swipes and scroll gestures.
       * @config {Number}
       * @default
       */
      dragTouchStartDelay: 300,

      /**
       * The CSS selector to use to identify the closest valid target from the event target.
       * @config {String}
       */
      dropTargetSelector: null,

      /**
       * The {@link #config-dragSelector} item the mouse is currently over.
       * @member {HTMLElement} overItem
       * @readonly
       */
      overItem: null,
      testConfig: {
        // In Edge synthetic click events are fired asynchronously and can take considerable
        // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
        // Caught by test EventDrag4.t in Edge
        dragSwallowClickTime: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge ? 300 : 50
      }
    };
  }

  static get properties() {
    return {
      /**
       * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
       * there) as soon as the pointerdown event occurs.
       * @member {String}
       * @readonly
       */
      draggingCls: 'b-draggable-active',

      /**
       * The CSS class to add to the `body` element as soon as the {@link #config-dragThreshold} is reached and
       * an actual drag is in progress.
       * @member {String}
       * @readonly
       */
      draggingBodyCls: 'b-draghelper-active',
      // match DragHelper since we need the same treatment

      /**
       * The CSS class to add to the element being dragged as soon as the pointerdown event occurs.
       * @member {String}
       * @readonly
       */
      draggingItemCls: 'b-dragging-item',

      /**
       * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
       * there) as soon as the {@link #config-dragThreshold} is reached and an actual drag is in progress.
       * @member {String}
       * @readonly
       */
      draggingStartedCls: 'b-draggable-started',

      /**
       * The CSS class that is added to the {@link #config-dragRootElement}, i.e., `'b-draggable'`.
       * @property {String}
       * @readonly
       */
      draggableCls: 'b-draggable'
    };
  } //endregion
  //region Drag Processing
  // These template methods are implemented by derived classes as desired. There is only one overlap with Droppable's
  // template methods (dragDrop) so that a class can easily mixin both Draggable and Droppable and always distinguish
  // whether it is acting as the source, the target, or both.

  /**
   * This template method is called when the mousedown of a potential drag operation occurs. This happens before the
   * gesture is known to be a drag, meaning the {@link #config-dragThreshold} has not been reached. This method
   * should initialize the {@link Core.util.drag.DragContext} using the {@link Core.util.drag.DragContext#function-set}
   * method. Alternatively, this method may return `false` to prevent the drag operation.
   *
   * *Important:* Because no drag has occurred at the time this method is called, only minimal processing should be
   * done (such as initializing the {@link Core.util.drag.DragContext}). Anything more should be done in the
   * {@link #function-dragStart} method or in response to the {@link #event-dragStart} event which happen only if
   * the user drags the mouse before releasing the mouse button.
   * @param {Core.util.drag.DragContext} drag
   */


  beforeDrag(drag) {
    const {
      dragRootElement,
      dragSelector
    } = this,
          target = dragSelector && drag.element.closest(dragSelector);
    return !dragSelector || Boolean(target && target === dragRootElement || dragRootElement.contains(target));
  }
  /**
   * This template method is called when the drag operation starts. This occurs when the {@link #config-dragThreshold}
   * has been reached.
   * Your implementation may return `false` to prevent the startup of the drag operation.
   * @param {Core.util.drag.DragContext} drag
   */


  dragStart(drag) {// template
  }
  /**
   * This template method is called as the drag moves. This occurs on each mouse/pointer/touchmove event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragOver(drag) {// template
  }
  /**
   * This template method is called when the drag enters a {@link Core.mixin.Droppable target}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragEnterTarget(drag) {// template
  }
  /**
   * This template method is called when the drag leaves a {@link Core.mixin.Droppable target}.
   * @param {Core.util.drag.DragContext} drag
   * @param {Core.mixin.Droppable} oldTarget The previous value of `drag.target`.
   */


  dragLeaveTarget(drag, oldTarget) {// template
  }
  /**
   * This template method is called when the drag operation completes. This occurs on the pointerup event.
   *
   * This method is not called if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragDrop(drag) {// template
  }
  /**
   * This template method is called when the drag operation completes. This occurs on the pointerup event or perhaps
   * a keypress event.
   *
   * This method is always called, even if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragEnd(drag) {// template
  } //endregion
  //region Drag Management
  // These methods are called by the DragContext and generally manage element updates (adding/removing classes) or
  // event firing. In most cases these methods then call a corresponding Drag Processing template method intended
  // for derived classes to implement.


  get activeDrag() {
    const {
      dragging: drag
    } = this;
    return drag !== null && drag !== void 0 && drag.started && !drag.completed ? drag : null;
  }
  /**
   * Return the `Events` instance from which drag events are fired.
   * @internal
   * @property {Core.mixin.Events}
   */


  get dragEventer() {
    return this.trigger ? this : null; // simple Events feature detector
  }

  get draggingClassElement() {
    const {
      draggingClsSelector,
      dragRootElement
    } = this;
    return draggingClsSelector ? dragRootElement === null || dragRootElement === void 0 ? void 0 : dragRootElement.closest(draggingClsSelector) : dragRootElement;
  }

  beginDrag(drag) {
    const {
      draggingCls,
      draggingClassElement
    } = this;

    if (draggingCls && draggingClassElement) {
      draggingClassElement.classList.add(draggingCls);
      drag.cleaners.push(() => draggingClassElement.classList.remove(draggingCls));
    }
  }

  async endDrag(drag) {
    const me = this,
          {
      dragEventer,
      dragProxy
    } = me;

    if (drag.valid) {
      // The implementation may be async. If so, any Promise must always be
      // propagated back to a point which may have to await it
      await me.dragDrop(drag);
    }

    if (me.isDestroyed) {
      return;
    }

    if (drag.pending) {
      drag.destroy();
    } else {
      me.dragEnd(drag);
      dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragEnd(drag);
      /**
       * This event is fired when a drag gesture is completed due to the user aborting it (with the `ESC` key) or
       * if the {@link Core.util.drag.DragContext#function-abort} method was called.
       * @event dragCancel
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      /**
       * This event is fired when a drag gesture is completed successfully.
       *
       * This event is **not** fired if the drag was aborted by the user pressing the `ESC` key or if the
       * {@link Core.util.drag.DragContext#function-abort} method was called.
       * @event drop
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger(drag.valid ? 'drop' : 'dragCancel', {
        drag,
        event: drag.event
      }); // The drag context could have registered finalizers added by the above methods or event. If so, we need to
      // wait for finalization of the drag before we clear our "dragging" config.

      me.finalizeDrag(drag);
    }
  }

  async finalizeDrag(drag) {
    await drag.finalize(); // The doFinalize() method of DragContext is called by the above await... which nulls our "dragging" config
  }

  moveDrag(drag) {
    if (this.dragOver(drag) !== false) {
      const {
        dragEventer,
        dragProxy
      } = this;
      dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragMove(drag);
      /**
       * This event is fired as a drag gesture progresses due to cursor movement.
       * @event drag
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('drag', {
        drag,
        event: drag.event
      });
    }
  }

  setupDragContext(event) {
    const me = this,
          {
      dragItemSelector,
      id
    } = me,
          {
      target
    } = event;
    return {
      event,
      id: id ? `${id}-drag-${me._nextDragId = (me._nextDragId || 0) + 1}` : null,
      itemElement: dragItemSelector ? target.closest(dragItemSelector) : target,
      touchStartDelay: me.dragTouchStartDelay,
      source: me,
      threshold: me.dragThreshold
    };
  }

  startDrag(drag) {
    const {
      draggingStartedCls,
      draggingClassElement,
      draggingItemCls,
      dragEventer,
      dragProxy
    } = this,
          {
      itemElement
    } = drag;
    /**
     * This event is fired prior to starting a drag gesture. This does not occur immediately after the user
     * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
     * movement has taken place.
     *
     * The drag is canceled if a listener returns `false`.
     * @event beforeDragStart
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     * @preventable
     */

    if ((dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('beforeDragStart', {
      drag,
      event: drag.event
    })) === false) {
      return false;
    }

    if (draggingStartedCls && draggingClassElement) {
      draggingClassElement.classList.add(draggingStartedCls);
      drag.cleaners.push(() => draggingClassElement.classList.remove(draggingStartedCls));
    }

    if (draggingItemCls && itemElement) {
      itemElement.classList.add(draggingItemCls);
      drag.cleaners.push(() => itemElement.classList.remove(draggingItemCls));
    }

    dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragStart(drag);
    const result = this.dragStart(drag);

    if (result !== false) {
      /**
       * This event is fired when a drag gesture has started. This does not occur immediately after the user
       * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
       * movement has taken place.
       * @event dragStart
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */
      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('dragStart', {
        drag,
        event: drag.event
      });
    }

    return result;
  }

  trackDrag(drag) {
    var _drag$targetElement;

    const {
      dropTargetSelector
    } = this;
    drag.valid = !(dropTargetSelector && !((_drag$targetElement = drag.targetElement) !== null && _drag$targetElement !== void 0 && _drag$targetElement.closest(dropTargetSelector)));
    this.moveDrag(drag);
  } //endregion
  //region Configs


  configureListeners(drag) {
    const me = this,
          listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
      thisObj: me
    }, me.dragDocumentListeners); // Only listen for the events related to how the drag was initiated:

    if ('touches' in drag.startEvent) {
      delete listeners.mousemove;
      delete listeners.mouseup;
    } else {
      delete listeners.contextmenu;
      delete listeners.touchmove;
      delete listeners.touchend;
      delete listeners.pointerup;
    }

    return listeners;
  } //endregion
  //region Configs


  updateDragging(drag) {
    const me = this;

    if (drag) {
      const listeners = me.configureListeners(drag);
      drag.cleaners.push(_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].on(listeners));
      me.beginDrag(drag);
    }
  }

  changeDragProxy(config, existing) {
    return _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_5__["default"].reconfigure(existing, config, {
      owner: this,
      defaults: {
        owner: this
      }
    });
  }

  updateDragRootElement(rootEl, was) {
    var _me$_dragRootDetacher;

    const me = this,
          {
      draggableCls,
      dragItemSelector,
      onDragItemMouseMove
    } = me;
    was === null || was === void 0 ? void 0 : was.classList.remove(draggableCls);
    (_me$_dragRootDetacher = me._dragRootDetacher) === null || _me$_dragRootDetacher === void 0 ? void 0 : _me$_dragRootDetacher.call(me);

    if (rootEl) {
      const listeners = {
        thisObj: me,
        element: rootEl,
        mousedown: 'onDragMouseDown',
        // We have touchstart listener in place since Siesta/Chrome can send these events even on non-touch
        // devices:
        touchstart: 'onDragTouchStart'
      };

      if (onDragItemMouseMove) {
        listeners.mousemove = {
          delegate: dragItemSelector,
          handler: 'onDragItemMouseMove'
        };
      }

      if (me.dragItemOverCls || onDragItemMouseMove || me.onDragItemMouseEnter || me.onDragItemMouseLeave) {
        Object.assign(listeners, {
          mouseover: {
            delegate: dragItemSelector,
            handler: 'onDragItemMouseOver'
          },
          mouseout: {
            delegate: dragItemSelector,
            handler: 'onDragItemMouseOut'
          }
        });
      }

      rootEl.classList.add(draggableCls);
      me._dragRootDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].on(listeners);
    }
  } //endregion
  //region Events


  onDragItemMouseOver(event) {
    this.overItem = event;
  }

  onDragItemMouseOut(event) {
    if (!this.dragging) {
      this.overItem = event;
    }
  }

  changeOverItem(event) {
    this.enterLeaveEvent = event;

    if (event.type === 'mouseout') {
      var _event$relatedTarget;

      // Must return null, not undefined to unset the overItem property
      return ((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.closest(this.dragItemSelector)) || null;
    } else {
      return event.target.closest(this.dragItemSelector);
    }
  }

  updateOverItem(overItem, oldOverItem) {
    const me = this,
          {
      dragItemOverCls
    } = me;

    if (oldOverItem) {
      var _me$onDragItemMouseLe;

      dragItemOverCls && oldOverItem.classList.remove(dragItemOverCls);
      (_me$onDragItemMouseLe = me.onDragItemMouseLeave) === null || _me$onDragItemMouseLe === void 0 ? void 0 : _me$onDragItemMouseLe.call(me, me.enterLeaveEvent, oldOverItem);
    }

    if (overItem) {
      var _me$onDragItemMouseEn;

      dragItemOverCls && overItem.classList.add(dragItemOverCls);
      (_me$onDragItemMouseEn = me.onDragItemMouseEnter) === null || _me$onDragItemMouseEn === void 0 ? void 0 : _me$onDragItemMouseEn.call(me, me.enterLeaveEvent, overItem);
    }
  }

  onDragContextMenu(event) {
    event.preventDefault();
  }

  onDragKeyDown(event) {
    this.dragging.keyDown(event);
  }

  onDragKeyUp(event) {
    this.dragging.keyUp(event);
  }
  /**
   * Grab draggable element on mouse down.
   * @param {Event} event
   * @private
   */


  onDragMouseDown(event) {
    // only dragging with left mouse button
    if (event.button === 0) {
      this.onDragPointerDown(event);
    }
  }
  /**
   * Grab draggable element on pointerdown.
   * @param {Event} event
   * @private
   */


  onDragPointerDown(event) {
    let {
      dragging: drag
    } = this; // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if user does pointerup
    // outside browser window). Also handles the edge case of trying to start a new drag while previous is awaiting
    // finalization, in which case it just bails out.

    if (!drag) {
      drag = this.setupDragContext(event); // The DragContext consults our beforeDrag handler, and if that succeeds, the Context injects itself into
      // this instance as our draggable ("this.dragging").
      // NOTE: This is not yet an actual drag. At this stage, the context is used to detect movement prior to
      // mouseup (aka "a drag"). Should the requisite amount of movement occur, the drag will be started.

      if (drag) {
        drag = new _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_4__["default"](drag);

        if (drag.begin() === false) {
          drag.destroy();
        }
      }
    } else if (!drag.isFinalizing) {
      drag.abort();
    }
  } // Set by the DragContext in its begin method, and auto-nullified at destruction.


  changeDragging(value, was) {
    was === null || was === void 0 ? void 0 : was.destroy();
    return value;
  }

  onDragPointerMove(event) {
    const {
      dragging: drag
    } = this;

    if (drag && !drag.completed) {
      drag === null || drag === void 0 ? void 0 : drag.move(event);
    }
  }

  onDragPointerUp(event) {
    const {
      dragging: drag
    } = this;

    if (drag && !drag.completed) {
      drag.end(event);
      this.endDrag(drag);
    }
  }
  /**
   * @param {Event} event
   * @private
   */


  onDragTouchStart(event) {
    // only allowing one finger for now...
    if (event.touches.length === 1) {
      this.onDragPointerDown(event);
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Droppable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Droppable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
var productName = 'gantt';


/**
 * @module Core/mixin/Droppable
 */

/**
 * Mix this into another class to enable drop support and receive drops from {@link Core.mixin.Draggable draggables}.
 *
 * There are 4 basic methods that a droppable implements. These methods are called as drag operations occur:
 *
 * ```javascript
 *  class MyDroppable extends Base.mixin(Droppable) {
 *      dragEnter(drag) {
 *          // a drag has entered the drop zone... create some type of drop indicator perhaps
 *      }
 *
 *      dragMove(drag) {
 *          // a drag has changed position... update drop indicators
 *      }
 *
 *      dragDrop(drag) {
 *          // drop has occurred... process data from the drag context
 *      }
 *
 *      dragLeave(drag) {
 *          // the drag has left the drop zone... cleanup indicators
 *      }
 *  }
 * ```
 *
 * Instances of `Droppable` are associated with an element to receive drag operations:
 *
 * ```javascript
 *  let target = new MyDroppable({
 *      dropRootElement : someElement
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Droppable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Droppable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * A selector, which, if specified, narrows the dropability to child elements of the
       * {@link #config-dropRootElement} which match this selector.
       * @config {String}
       */
      droppableSelector: null,

      /**
       * The current `DragContext`. This is set when a drag enters this target. Changing this config causes the
       * {@link #function-dragEnter} and {@link #function-dragLeave} methods to be called. If `dragEnter` returns
       * `false` for a drag, this value will be set to `null`.
       * @member {Core.util.drag.DragContext}
       * @readonly
       */
      dropping: null,

      /**
       * Set this config to the element where drops should be received. When set, the `b-droppable` CSS class is
       * added to the element and the `Droppable` instance is associated with that element so that it can be
       * found by {@link Core.mixin.Draggable draggables}.
       * @config {HTMLElement}
       */
      dropRootElement: {
        $config: 'nullify',
        value: null
      }
    };
  }
  /**
   * Return the `Events` instance from which drop events are fired.
   * @internal
   * @property {Core.mixin.Events}
   */


  get dropEventer() {
    return this.trigger ? this : null; // simple Events feature detector
  }
  /**
   * Returns the CSS class that is added to the {@link #config-dropRootElement}, i.e., `'b-droppable'`.
   * @property {String}
   * @readonly
   */


  get droppableCls() {
    return 'b-droppable';
  } //endregion
  //region Drop Management

  /**
   * This method is called when a drag enters this droppable's `dropRootElement`. In many cases, this method is used
   * to create some sort of drop indicator to provide user feedback.
   *
   * If this method does not return `false`, the {@link #property-dropping} config will retain the given `drag` context
   * which was set prior to this method being called.
   *
   * If this method returns `false`, the drop will not be accepted. Neither {@link #function-dragDrop} nor
   * {@link #function-dragLeave} will be called for this drop. If the drag leaves this target and re-enters, this
   * method will be called again. While `dropping` will already be updated before this method is called, it will be
   * reset to `null` in this case.
   *
   * The base class implementation of this method fires the {@link #event-dragEnter} event.
   * @param {Core.util.drag.DragContext} drag
   * @returns {Boolean}
   */


  dragEnter(drag) {
    var _this$dropEventer;

    /**
     * This event is fired when a drag enters this droppable's `dropRootElement`. It is fired by the droppable's
     * {@link #function-dragEnter} method.
     * @event dragEnter
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer = this.dropEventer) === null || _this$dropEventer === void 0 ? void 0 : _this$dropEventer.trigger('dragEnter', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} moves to a new
   * position. This is typically where drop indicators are updated to reflect the new position.
   *
   * The base class implementation of this method fires the {@link #event-dragMove} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragMove(drag) {
    var _this$dropEventer2;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} moves to a new
     * position. It is fired by the droppable's {@link #function-dragMove} method.
     * @event dragMove
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer2 = this.dropEventer) === null || _this$dropEventer2 === void 0 ? void 0 : _this$dropEventer2.trigger('dragMove', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} has ended with
   * a drop. In addition to any cleanup (since {@link #function-dragLeave} will not be called), this method handles
   * any updates associated with the data from the drag context and the position of the drop.
   *
   * The base class implementation of this method fires the {@link #event-drop} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragDrop(drag) {
    var _this$dropEventer3;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} has ended with
     * a drop. It is fired by the droppable's {@link #function-dragDrop} method.
     *
     * This event is **not** fired when a drag gesture is aborted by the user pressing the `ESC` key or if the
     * {@link Core.util.drag.DragContext#function-abort} method is called.
     * @event drop
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer3 = this.dropEventer) === null || _this$dropEventer3 === void 0 ? void 0 : _this$dropEventer3.trigger('drop', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} leaves this
   * droppable's `dropRootElement`, or the drag is {@link Core.util.drag.DragContext#property-aborted} by the user
   * pressing the `ESC` key, or the {@link Core.util.drag.DragContext#function-abort} method is called.
   *
   * This is the time to cleanup anything created by `dragEnter`.
   *
   * The base class implementation of this method fires the {@link #event-dragLeave} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragLeave(drag) {
    var _this$dropEventer4;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} leaves this
     * droppable's `dropRootElement`. It is fired by the droppable's {@link #function-dragLeave} method.
     * @event dragLeave
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer4 = this.dropEventer) === null || _this$dropEventer4 === void 0 ? void 0 : _this$dropEventer4.trigger('dragLeave', {
      drag,
      event: drag.event
    });
  } //endregion
  //region Configs


  changeDropping(dropping, was) {
    if (dropping !== was) {
      const me = this;

      if (was) {
        if (was.aborted || !was.completed) {
          me.dragLeave(was);
        }
      }

      if (dropping) {
        me._dropping = dropping; // update config value early in case dragEnter et al refer to it

        if (me.dragEnter(dropping) === false) {
          dropping = null;
        }

        me._dropping = was; // restore the value so that updateDropping is called as it should be
      }
    }

    return dropping;
  }

  updateDropRootElement(rootEl, was) {
    const me = this,
          {
      droppableCls
    } = me;
    let droppables, i, removeCls;

    if (was) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(was, 'droppables');
      removeCls = true;

      if (Array.isArray(droppables) && (i = droppables.indexOf(me)) > -1) {
        if (droppables.length < 2) {
          _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(was, 'droppables');
        } else {
          droppables.splice(i, 1);
          droppables.forEach(d => {
            if (droppableCls === d.droppableCls) {
              removeCls = false; // our droppableCls may need to stay
            }
          });
        }
      }

      removeCls && was.classList.remove(droppableCls);
    }

    if (rootEl) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(rootEl, 'droppables');

      if (droppables) {
        droppables.push(me);
      } else {
        _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(rootEl, 'droppables', [me]);
      }

      rootEl.classList.add(droppableCls);
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Events.js":
/*!**********************************!*\
  !*** ./lib/Core/mixin/Events.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';







/**
 * @module Core/mixin/Events
 */

const // Used by the config system to flatten configs from the class hierarchy.
// In this case, a pure merge is not wanted. Listener definitions from
// every class level are collected up into an array.
// addListener iterates any passed array, adding each element.
{
  isArray
} = Array,
      {
  hasOwnProperty
} = Object.prototype,
      // Used to distinguish event names from listener options in addListener object config.
specialProperties = {
  thisObj: 1,
  detachable: 1,
  once: 1,
  detacher: 1,
  prio: 1,
  args: 1,
  expires: 1,
  buffer: 1,
  throttle: 1,
  name: 1
},
      priorityComparator = (a, b) => b.prio - a.prio;
/**
 * Mix this into another class to enable event handling.
 *
 * ## Basic usage
 * Listeners can be added either through config:
 *
 * ```javascript
 * let button = new Button({
 *   listeners: {
 *     click: () => {},
 *     press: () => {},
 *     ...
 *   }
 * });
 * ```
 *
 * *NOTE*: Do not reuse listeners config object, use new every time:
 * ```javascript
 * // wrong
 * let config = { click : () => {} }
 * new Button({
 *     listeners : config
 * })
 * new Button({
 *     listeners : config
 * })
 * // right
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * ```
 *
 * Or by calling on()/addListener():
 *
 * ```javascript
 * let button = new Button();
 *
 * button.addListener('press', () => {});
 * // on is an alias for addListener
 * button.on('click', () => {});
 * ```
 *
 * This style also accepts multiple listeners in same way as when using config:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   press: () => {},
 *   ...
 * });
 * ```
 *
 * ## Options
 * ### Once
 * Listeners can be configured to automatically deregister after first trigger by specifying config option `once`:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   once: true
 * });
 * ```
 *
 * ### Priority
 * Specifying priority affects the order in which listeners are called when triggering an event. Higher priorities will be
 * called before lower. Default value is 0.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   prio: 1
 * });
 * ```
 *
 * ### This reference
 * If desired, you can specify thisObj when configuring listeners. There is no need if you are using arrow functions as
 * listeners, but might be handy in other cases. Of course, you can also use bind to set `this` reference.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   thisObj: this
 * });
 *
 * // or
 *
 * button.on({
 *   click: this.onClick.bind(this)
 * });
 * ```
 *
 * ### Buffering
 * By specifying a `buffer` events that fire frequently can be grouped together and delayed. A handler for the event will be called once only, when no new event has been fired during the specified buffer time:
 *
 * ```javascript
 * button.on({
 *   click  : this.onClick,
 *   buffer : 200 // in milliseconds
 * });
 * ```
 * In this example, if a user clicked the button 6 times very fast (<200ms between each click),
 * the `this.onClick` handler would be called only once 200 milliseconds after the last click.
 *
 * ### Throttling
 * Create a "debounced" function which will call on the "leading edge" of a timer period.
 * When first invoked will call immediately, but invocations after that inside its buffer
 * period will be rejected, and *one* invocation will be made after the buffer period has expired.
 *
 * This is useful for responding immediately to a first mousemove, but from then on, only
 * calling the action function on a regular timer while the mouse continues to move.
 * ```javascript
 * button.on({
 *   click    : this.onClick,
 *   throttle : 200 // in milliseconds
 * });
 * ```
 * In this example, if a user clicked the button 6 times very fast, the `this.onClick` handler would be called once immediately on the first click and a second time 200 milliseconds after the **first** click.
 * So in reality the `click` event handler will be called every 200ms independent of amount of click in a middle, if the event was triggered at least once during the `throttle` timeout.
 *
 * ### Detacher
 * A convenient way of unregistering events is to use a detacher, a function returned when adding listeners that you
 * call later to deregister them. As of version 1.0, detachable defaults to true.
 *
 * ```javascript
 * let detacher = button.on({
 *   click: () => {},
 *   press: () => {},
 *   detachable: true
 * });
 *
 * // when you want to detach, for example in destroy()
 * detacher();
 * ```
 *
 * ### Auto detaching
 * When listeners are bound to a class instance using `thisObj`, the `thisObj`'s `doDestroy` method
 * is overridden to remove the listeners before calling the overridden doDestroy.
 *
 * ```javascript
 * class MyClass extends Base {
 *   construct() {
 *     let button = new Button({
 *       listeners: {
 *         click: () => {},
 *         thisObj: this
 *       }
 *     });
 *   }
 *
 *   doDestroy() {
 *     // clean up stuff
 *   }
 * }
 *
 * let myObj = new MyClass();
 * // clean up, also removes listeners
 * myObj.destroy();
 * ```
 *
 * ### On-functions
 * When mixing Events into another class it can be configured to call on-functions when events are triggered.
 * On-functions are functions named 'onEventName', for example 'onClick', 'onPress' declared on the class triggering
 * the event.
 *
 * ```javascript
 * // mix Events in with on-functions activated
 * let button = new Button({
 *   callOnFunctions: true,
 *
 *   onClick: () => {}
 * });
 *
 * // or add a getter in class declaration
 * ```
 *
 * Returning `false` from an on-function will prevent triggering listeners for the event.
 *
 * ### Catching all events
 * By specifying a listener for {@link #event-catchAll catchAll} a function can be notified when any event is triggered:
 *
 * ```javascript
 * const button = new Button({
 *    listeners : {
 *        catchAll(event) {
 *            // All events on the button will pass through here
 *        }
 *    }
 * });
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Events extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Events';
  } //region Events

  /**
   * Fires before an object is destroyed.
   * @event beforeDestroy
   * @param {Object} source The Object that is being destroyed.
   */

  /**
   * Fires when an object is destroyed.
   * @event destroy
   * @param {Object} source The Object that is being destroyed.
   */

  /**
   * Fires when any other event is fired from the object.
   *
   * **Note**: `catchAll` is fired for both public and private events. Please rely on the public events only.
   * @event catchAll
   * @param {Object} event The Object that contains event details
   * @param {String} event.type The type of the event which is caught by the listener
   */
  //endregion


  static get declarable() {
    return [
    /**
     * The list of deprecated events as an object, where `key` is an event name which is deprecated and
     * `value` is an object which contains values for
     * {@link Core.helper.VersionHelper#function-deprecate-static VersionHelper}:
     * - product {String} The name of the product;
     * - invalidAsOfVersion {String} The version where the offending code is invalid (when any compatibility
     *   layer is actually removed);
     * - message {String} Warning message to show to the developer using a deprecated API;
     *
     * For example:
     *
     * ```javascript
     * return {
     *     click : {
     *         product            : 'Grid',
     *         invalidAsOfVersion : '1.0.0',
     *         message            : 'click is deprecated!'
     *     }
     * }
     * ```
     *
     * @name deprecatedEvents
     * @returns {Object}
     * @static
     * @internal
     */
    'deprecatedEvents'];
  }

  static setupDeprecatedEvents(cls, meta) {
    const all = meta.getInherited('deprecatedEvents'),
          add = cls.deprecatedEvents;

    for (const eventName in add) {
      // Event names are case-insensitive so build our map using toLowerCased names (but keep true case too):
      all[eventName.toLowerCase()] = all[eventName] = add[eventName];
    }
  } //region Config


  static get configurable() {
    return {
      /**
       * The listener set for this object.
       *
       * Listeners can be specified in target class config and they will be merged with any listeners specified in
       * the instantiation config. Class listeners will be fired first:
       *
       * ```javascript
       * class MyStore extends Store({
       *     static get configurable() {
       *         return {
       *             listeners : {
       *                 myCustomEvent() {
       *                 },
       *                 load : {
       *                     prio : 10000,
       *                     fn() { // this load listener handles things first }
       *                 }
       *             }
       *         }
       *     }
       * });
       *
       * let store = new MyStore({
       *   listeners: {
       *     load: () => { // This load listener runs after the class's },
       *     ...
       *   }
       * });
       * ```
       *
       * @config {Object}
       * @category Common
       */
      listeners: {
        value: null,
        $config: {
          merge(newValue, currentValue) {
            if (newValue !== null) {
              if (!newValue) {
                return currentValue;
              }

              if (currentValue) {
                newValue = newValue ? [newValue] : [];
                newValue.push[isArray(currentValue) ? 'apply' : 'call'](newValue, currentValue);
              }
            }

            return newValue;
          }

        }
      },

      /**
       * An object where property names with a truthy value indicate which events should bubble up the ownership
       * hierarchy when triggered.
       *
       * ```javascript
       * const container = new Container({
       *     items : [
       *        { type : 'text', bubbleEvents : { change : true }}
       *     ],
       *
       *     listeners : {
       *         change() {
       *             // Will catch change event from the text field
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object}
       */
      bubbleEvents: null
    };
  }

  destroy() {
    this.trigger('beforeDestroy');
    super.destroy();
  } //endregion
  //region Init


  construct(config, ...args) {
    var _config;

    // Configured listeners use this as the thisObj
    if (this.configuredListeners
    /* assignment */
    = (_config = config) === null || _config === void 0 ? void 0 : _config.listeners) {
      config = _objectSpread({}, config);
      delete config.listeners;
    }

    super.construct(config, ...args); // Apply configured listeners after construction.
    // Note that some classes invoke this during parts of their construction.
    // Store invokes this prior to setting data so that observers are notified of data load.

    this.processConfiguredListeners();
  }

  processConfiguredListeners() {
    // This can only happen once
    if (this.configuredListeners) {
      const me = this,
            {
        isConfiguring
      } = me; // If called from config ingestion during configuration, listeners must be added
      // so temporarily clear the isConfiguring flag.

      me.isConfiguring = false;
      me.listeners = me.configuredListeners;
      me.configuredListeners = null;
      me.isConfiguring = isConfiguring;
    }
  }
  /**
   * Auto detaches listeners registered from start, if set as detachable
   * @internal
   */


  doDestroy() {
    this.trigger('destroy');
    this.removeAllListeners();
    super.doDestroy();
  }

  static setupClass(meta) {
    super.setupClass(meta);
    Events.prototype.onListen.$nullFn = true;
    Events.prototype.onUnlisten.$nullFn = true;
  } //endregion
  //region Listeners

  /**
   * Adds an event listener. This method accepts parameters in the following format:
   *
   * ```javascript
   *  myObject.addListener({
   *      thisObj    : this,          // The this reference for the handlers
   *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
   *      otherevent : {
   *          fn      : 'handlerFnName',
   *          once    : true          // Just this handler is auto-removed on fire
   *      },
   *      yetanother  : {
   *          fn      : 'yetAnotherHandler',
   *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
   *      },
   *      prio        : 100           // Higher prio listeners are called before lower
   *  });
   * ```
   *
   * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
   * When it is destroyed, those listeners are removed.
   *
   * A simpler signature may be used when only adding a listener for one event and no extra options
   * (such as `once` or `delay`) are required:
   *
   * ```javascript
   * myObject.addListener('click', myController.handleClicks, myController);
   * ```
   *
   * The args in this simple case are `eventName`, `handler` and `thisObj`
   *
   * @param {Object|String} config An object containing listener definitions, or the event name to listen for
   * @param {Object} [config.thisObj] The `this` reference for all listeners.
   * (May be overridden if a handler is specified in object form)
   * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
   * @param {Number|Object} [config.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [config.expires.delay] How long to wait for the event for.
   * @param {String|Function} [config.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
   * @param {Number} [config.prio] The priority for all listeners; higher priority listeners are called before lower.
   * @param {Number} [config.buffer] A buffer time in milliseconds to wait after last event trigger to call the handler, to reduce the amount of handler calls for frequent events.
   * @param {Number} [config.throttle] A millisecond timeout value to throttle event triggering. With it specified a handler
   * will be called once immediately and then all following calls during the timeout period will be grouped together into one call once per throttle period.
   * @param {Object|Function} [thisObj] Default `this` reference for all listeners in the config object, or the handler
   * function to call if providing a string as the first arg.
   * @param {Object} [oldThisObj] The `this` reference if the old signature starting with a string event name is used..
   * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
   */


  addListener(config, thisObj, oldThisObj) {
    if (isArray(config)) {
      for (let i = 0, {
        length
      } = config; i < length; i++) {
        this.addListener(config[i], thisObj);
      }

      return;
    }

    const me = this,
          deprecatedEvents = me.$meta.getInherited('deprecatedEvents');

    if (typeof config === 'string') {
      // arguments[2] is thisObj if (eventname, handler, thisObj) form called.
      // Note that the other side of the if compares to undefined, so this will work.
      return me.addListener({
        [config]: thisObj,
        detachable: thisObj.detachable !== false,
        thisObj: oldThisObj
      });
    } else {
      // Capture the default thisObj.
      thisObj = config.thisObj = config.thisObj !== undefined ? config.thisObj : thisObj;

      for (const key in config) {
        if (!specialProperties[key]) {
          // comparing should be case insensitive
          const // comparing should be case insensitive
          eventName = key.toLowerCase(),
                deprecatedEvent = deprecatedEvents === null || deprecatedEvents === void 0 ? void 0 : deprecatedEvents[eventName],
                events = me.eventListeners || (me.eventListeners = {}),
                listenerSpec = config[key],
                expires = listenerSpec.expires || config.expires,
                listener = {
            fn: typeof listenerSpec === 'object' ? listenerSpec.fn : listenerSpec,
            thisObj: listenerSpec.thisObj !== undefined ? listenerSpec.thisObj : thisObj,
            args: listenerSpec.args || config.args,
            prio: listenerSpec.prio !== undefined ? listenerSpec.prio : config.prio !== undefined ? config.prio : 0,
            once: listenerSpec.once !== undefined ? listenerSpec.once : config.once !== undefined ? config.once : false,
            buffer: listenerSpec.buffer || config.buffer,
            throttle: listenerSpec.throttle || config.throttle,
            catchAll: key === 'catchAll'
          };

          if (deprecatedEvent) {
            const {
              product,
              invalidAsOfVersion,
              message
            } = deprecatedEvent;
            _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate(product, invalidAsOfVersion, message);
          }

          if (expires) {
            // Extract expires : { delay : 100, alt : 'onExpireFn' }
            const delayable = me.isDelayable ? me : _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].global,
                  {
              alt
            } = expires,
                  delay = alt ? expires.delay : expires;
            delayable.setTimeout(() => {
              me.un(eventName, listener); // If we make it here and the handler has not been called, invoke the alt handler

              if (alt && !listener.called) {
                me.callback(alt, thisObj);
              }
            }, delay);
          }

          let listeners = events[eventName] || (events[eventName] = []);

          if (listeners.$firing) {
            events[eventName] = listeners = listeners.slice();
          } // Insert listener directly in prio order


          listeners.splice(_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].findInsertionIndex(listener, listeners, priorityComparator, listeners.length), 0, listener);

          if (!me.onListen.$nullFn && listeners.length < 2) {
            me.onListen(eventName);
          }
        }
      }

      if (config.relayAll) {
        me.relayAll(config.relayAll);
      } // Hook into the thisObj's destruction sequence to remove these listeners.
      // Pass the default thisObj in for use when it comes to destruction time.


      if (thisObj && thisObj !== me) {
        me.attachAutoDetacher(config, thisObj);
      }

      const detachable = config.detachable !== false,
            name = config.name,
            destroy = config.expires || detachable || name ? () => {
        // drop listeners if not destroyed yet
        if (!me.isDestroyed) {
          me.removeListener(config, thisObj);
        }
      } : null;

      if (destroy) {
        var _thisObj;

        destroy.eventer = me;
        destroy.listenerName = name;

        if (name && (_thisObj = thisObj) !== null && _thisObj !== void 0 && _thisObj.trackDetacher) {
          thisObj.trackDetacher(name, destroy);
        }

        if (config.expires) {
          me.delay(destroy, config.expires);
        }

        if (detachable) {
          return destroy;
        }
      }
    }
  }
  /**
   * Alias for {@link #function-addListener}. Adds an event listener. This method accepts parameters in the following format:
   *
   * ```javascript
   *  myObject.on({
   *      thisObj    : this,          // The this reference for the handlers
   *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
   *      otherevent : {
   *          fn      : 'handlerFnName',
   *          once    : true          // Just this handler is auto-removed on fire
   *      },
   *      yetanother  : {
   *          fn      : 'yetAnotherHandler',
   *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
   *      },
   *      prio        : 100           // Higher prio listeners are called before lower
   *  });
   * ```
   *
   * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
   * When it is destroyed, those listeners are removed.
   *
   * A simpler signature may be used when only adding a listener for one event and no extra options
   * (such as `once` or `delay`) are required:
   *
   * ```javascript
   * myObject.on('click', myController.handleClicks, myController);
   * ```
   *
   * The args in this simple case are `eventName`, `handler` and `thisObj`
   *
   * @param {Object|String} config An object containing listener definitions.
   * @param {Object} [config.thisObj] The `this` reference for all listeners.
   * (May be overridden if a handler is specified in object form)
   * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
   * @param {Number|Object} [config.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [config.expires.delay] How long to wait for the event for.
   * @param {String|Function} [config.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
   * @param {Object|Function} [thisObj] Default `this` reference for all listeners in the config object.
   * @param {Object} [oldThisObj] The `this` reference if the old signature starting with a string event name is used..
   * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
   */


  on(...args) {
    return this.addListener(...args);
  }
  /**
   * Shorthand for {@link #function-removeListener}
   * @param {Object|String} config A config object or the event name
   * @param {Object|Function} thisObj `this` reference for all listeners, or the listener function
   * @param {Object} oldThisObj `this` The this object for the legacy way of adding listeners
   */


  un(...args) {
    this.removeListener(...args);
  }

  get listeners() {
    return this.eventListeners;
  }

  changeListeners(listeners) {
    // If we are receiving class listeners, add them early, and they do not become
    // the configured listeners, and are not removed by setting listeners during the lifecycle.
    if (this.isConfiguring) {
      if (listeners) {
        this.on(listeners, this);
      }
    } // Setting listeners after config time clears the old set and adds the new.
    // This will initially happen at the tail end of the constructor when config
    // listeners are set.
    else {
      // Configured listeners use this as the thisObj by default.
      // Flatten using Objects.assign because it may have been part of
      // a prototype chained default configuration of another object.
      // eg: the tooltip config of a Widget.
      // listener object blocks from multiple configuration levels are pushed
      // onto an array (see listeners merge function in configurable block above).
      // If this has happened, each entry must be processed like this.
      if (Array.isArray(listeners)) {
        for (let i = 0, l = listeners[0], {
          length
        } = listeners; i < length; l = listeners[++i]) {
          if (!('thisObj' in l)) {
            listeners[i] = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
              thisObj: this
            }, l);
          }
        }
      } else if (listeners && !('thisObj' in listeners)) {
        listeners = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
          thisObj: this
        }, listeners);
      }

      return listeners;
    }
  }

  updateListeners(listeners, oldListeners) {
    // Only configured listeners get here. Class listeners are added by changeListeners.
    oldListeners && this.un(oldListeners);
    listeners && this.on(listeners);
  }
  /**
   * Removes an event listener. Same API signature as {@link #function-addListener}
   * @param {Object|String} config A config object or the event name
   * @param {Object|Function} thisObj `this` reference for all listeners, or the listener function
   * @param {Object} oldThisObj `this` The this object for the legacy way of adding listeners
   */


  removeListener(config, thisObj = config.thisObj, oldThisObj) {
    const me = this;

    if (typeof config === 'string') {
      return me.removeListener({
        [config]: thisObj
      }, oldThisObj);
    }

    Object.entries(config).forEach(([eventName, listenerToRemove]) => {
      if (!specialProperties[eventName]) {
        eventName = eventName.toLowerCase();
        const eventListeners = me.eventListeners,
              index = me.findListener(eventName, listenerToRemove, thisObj);

        if (index >= 0) {
          let listeners = eventListeners[eventName];

          if (listeners.length > 1) {
            if (listeners.$firing) {
              eventListeners[eventName] = listeners = listeners.slice();
            } // NOTE: we cannot untrack any detachers here because we may only be
            // removing some of its listeners


            listeners.splice(index, 1);
          } else {
            delete eventListeners[eventName];

            if (!me.onUnlisten.$nullFn) {
              me.onUnlisten(eventName);
            }
          }
        }
      }
    });

    if (config.thisObj && !config.thisObj.isDestroyed) {
      me.detachAutoDetacher(config);
    }
  }
  /**
   * Finds the index of a particular listener to the named event. Returns `-1` if the passed
   * function/thisObj listener is not present.
   * @param {String} eventName The name of an event to find a listener for.
   * @param {String|Function} listenerToFind The handler function to find.
   * @param {Object} defaultThisObj The `thisObj` for the required listener.
   * @internal
   */


  findListener(eventName, listenerToFind, defaultThisObj) {
    var _this$eventListeners;

    const eventListeners = (_this$eventListeners = this.eventListeners) === null || _this$eventListeners === void 0 ? void 0 : _this$eventListeners[eventName],
          fn = listenerToFind.fn || listenerToFind,
          thisObj = listenerToFind.thisObj || defaultThisObj;

    if (eventListeners) {
      for (let listenerEntry, i = 0, {
        length
      } = eventListeners; i < length; i++) {
        listenerEntry = eventListeners[i];

        if (listenerEntry.fn === fn && listenerEntry.thisObj === thisObj) {
          return i;
        }
      }
    }

    return -1;
  }
  /**
   * Check if any listener is registered for the specified eventName
   * @param {String} eventName
   * @returns {Boolean} `true` if listener is registered, otherwise `false`
   */


  hasListener(eventName) {
    var _this$eventListeners2;

    return Boolean((_this$eventListeners2 = this.eventListeners) === null || _this$eventListeners2 === void 0 ? void 0 : _this$eventListeners2[eventName === null || eventName === void 0 ? void 0 : eventName.toLowerCase()]);
  }
  /**
   * Relays all events through another object that also implements Events mixin. Adds a prefix to the event name
   * before relaying, for example add -> storeAdd
   * ```
   * // Relay all events from store through grid, will make it possible to listen for store events prefixed on grid:
   * 'storeLoad', 'storeChange', 'storeRemoveAll' etc.
   * store.relayAll(grid, 'store');
   *
   * grid.on('storeLoad', () => console.log('Store loaded');
   * ```
   * @param {Core.mixin.Events} through Object to relay the events through, needs to mix Events mixin in
   * @param {String} prefix Prefix to add to event name
   * @param {Boolean} [transformCase] Specify false to prevent making first letter of event name uppercase
   */


  relayAll(through, prefix, transformCase = true) {
    if (!this.relayAllTargets) {
      this.relayAllTargets = [];
    }

    const relayAllTargets = this.relayAllTargets;
    through.on('beforeDestroy', ({
      source
    }) => {
      if (source === through) {
        const configs = relayAllTargets.filter(r => r.through === through);
        configs.forEach(config => _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(relayAllTargets, config));
      }
    });
    relayAllTargets.push({
      through,
      prefix,
      transformCase
    });
  }
  /**
   * Removes all listeners registered to this object
   */


  removeAllListeners() {
    const listeners = this.eventListeners;
    let i, thisObj;

    for (const event in listeners) {
      const bucket = listeners[event]; // We iterate backwards since we call removeListener which will splice out of
      // this array as we go...

      for (i = bucket.length; i-- > 0;) {
        var _thisObj2;

        const cfg = bucket[i];
        this.removeListener(event, cfg);
        thisObj = cfg.thisObj;

        if ((_thisObj2 = thisObj) !== null && _thisObj2 !== void 0 && _thisObj2.untrackDetachers) {
          thisObj.untrackDetachers(this);
        }
      }
    }
  }

  relayEvents(source, eventNames, prefix = '') {
    const listenerConfig = {
      detachable: true
    };
    eventNames.forEach(eventName => {
      listenerConfig[eventName] = (event, ...params) => {
        return this.trigger(prefix + event.type, event, ...params);
      };
    });
    return source.on(listenerConfig);
  }
  /**
   * This method is called when the first listener for an event is added.
   * @param {String} eventName
   * @internal
   */


  onListen() {}
  /**
   * This method is called when the last listener for an event is removed.
   * @param {String} eventName
   * @internal
   */


  onUnlisten() {}

  destructorInterceptor() {
    const {
      autoDetachers,
      target,
      oldDestructor
    } = this; // Remove listeners first, so that they do not fire during destruction.
    // The observable being listened to by the thisObj may already have
    // been destroyed in a clean up sequence

    for (let i = 0; i < autoDetachers.length; i++) {
      const {
        dispatcher,
        config
      } = autoDetachers[i];

      if (!dispatcher.isDestroyed) {
        dispatcher.removeListener(config, target);
      }
    }

    oldDestructor.call(target);
  }
  /**
   * Internal function used to hook destroy() calls when using thisObj
   * @private
   */


  attachAutoDetacher(config, thisObj) {
    const target = config.thisObj || thisObj,
          // If it's a Bryntum Base subclass, hook doDestroy, otherwise, destroy
    destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

    if (destructorName in target) {
      let {
        $autoDetachers
      } = target;

      if (!$autoDetachers) {
        target.$autoDetachers = $autoDetachers = [];
      }

      if (!target.$oldDestructor) {
        target.$oldDestructor = target[destructorName]; // Binding instead of using closure (used to use FunctionHelper.createInterceptor) to not retain target
        // when detaching manually

        target[destructorName] = this.destructorInterceptor.bind({
          autoDetachers: $autoDetachers,
          oldDestructor: target.$oldDestructor,
          target
        });
      }

      $autoDetachers.push({
        config,
        dispatcher: this
      });
    } else {
      target[destructorName] = () => {
        this.removeListener(config);
      };
    }
  }
  /**
   * Internal function used restore hooked destroy() calls when using thisObj
   * @private
   */


  detachAutoDetacher(config) {
    const target = config.thisObj; // Restore old destructor and remove from auto detachers only if we are not called as part of destruction.
    // (Altering $autoDetachers affects destruction iterating over them, breaking it. It is pointless to clean up
    // during destruction anyway, since everything gets removed)

    if (target.$oldDestructor && !target.isDestroying) {
      _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(target.$autoDetachers, target.$autoDetachers.find(detacher => detacher.config === config && detacher.dispatcher === this));

      if (!target.$autoDetachers.length) {
        target['doDestroy' in target ? 'doDestroy' : 'destroy'] = target.$oldDestructor;
        target.$oldDestructor = null;
      }
    }
  } //endregion
  //region Promise based workflow
  // experimental, used in tests to support async/await workflow


  await(eventName, options = {
    checkLog: true,
    resetLog: true,
    args: null
  }) {
    const me = this;

    if (options === false) {
      options = {
        checkLog: false
      };
    }

    const {
      args
    } = options;
    return new Promise(resolve => {
      var _me$_triggered;

      // check if previously triggered?
      if (options.checkLog && (_me$_triggered = me._triggered) !== null && _me$_triggered !== void 0 && _me$_triggered[eventName]) {
        // resolve immediately, no params though...
        resolve(); // reset log to be able to await again

        if (options.resetLog) {
          me.clearLog(eventName);
        }
      } // This branch will listen for events until catches one with specific arguments


      if (args) {
        const detacher = me.on({
          [eventName]: (...params) => {
            const argsOk = Object.keys(args).every(key => {
              return key in params[0] && params[0][key] === args[key];
            });

            if (argsOk) {
              // resolve when event is fired with required arguments
              resolve(...params); // reset log to be able to await again

              if (options.resetLog) {
                me.clearLog(eventName);
              }

              detacher();
            }
          },
          prio: -10000 // Let others do their stuff first

        });
      } else {
        me.on({
          [eventName]: (...params) => {
            // resolve when event is caught
            resolve(...params); // reset log to be able to await again

            if (options.resetLog) {
              me.clearLog(eventName);
            }
          },
          prio: -10000,
          // Let others do their stuff first
          once: true // promises can only be resolved once anyway

        });
      }
    });
  }

  clearLog(eventName) {
    if (this._triggered) {
      if (eventName) {
        delete this._triggered[eventName];
      } else {
        this._triggered = {};
      }
    }
  } //endregion
  //region Trigger

  /**
   * Triggers an event, calling all registered listeners with the supplied arguments. Returning false from any listener
   * makes function return false.
   * @param {String} eventName Event name for which to trigger listeners
   * @param {Object} [param] Single parameter passed on to listeners, source property will be added to it (this)
   * @param {Boolean} [param.bubbles] Pass as `true` to indicate that the event will bubble up the widget
   * ownership hierarchy. For example up a Menu->parent Menu tree, or a Field->Container tree.
   * @returns {Boolean|Promise} Returns false if any listener returned false, or a Promise yielding
   * true / false based on what is returned from the async listener functions, otherwise true
   */


  trigger(eventName, param) {
    var _me$eventListeners, _me$eventListeners2, _me$bubbleEvents, _handlerPromises;

    // TODO: should returning false from a listener really prevent other listeners from executing?
    const me = this,
          name = eventName.toLowerCase(),
          {
      eventsSuspended,
      relayAllTargets,
      callOnFunctions
    } = me;
    let listeners = (_me$eventListeners = me.eventListeners) === null || _me$eventListeners === void 0 ? void 0 : _me$eventListeners[name],
        handlerPromises; // log trigger, used by experimental promise support to resolve immediately when needed

    if (!me._triggered) {
      me._triggered = {};
    }

    me._triggered[eventName] = true;

    if (eventsSuspended) {
      if (eventsSuspended.shouldQueue) {
        eventsSuspended.queue.push(arguments);
      }

      return true;
    } // Include catchall listener for all events.
    // Do not push the catchAll listeners onto the events own listener array.


    if ((_me$eventListeners2 = me.eventListeners) !== null && _me$eventListeners2 !== void 0 && _me$eventListeners2.catchall) {
      (listeners = listeners ? listeners.slice() : []).push(...me.eventListeners.catchall); // The catchAll listeners must honour their prio settings.

      listeners.sort(priorityComparator);
    }

    if (!listeners && !relayAllTargets && !callOnFunctions) {
      return true;
    } // default to include source : this in param


    if (param) {
      if (!('source' in param)) {
        if (Object.isExtensible(param)) {
          param.source = me;
        } else {
          param = Object.setPrototypeOf({
            source: me
          }, param);
        }
      }
    } else {
      param = {
        source: me
      };
    } // Lowercased event name should be the "type" property in keeping with DOM events.


    if (param.type !== name) {
      // Create instance property because "type" is read only
      if (param.constructor !== Object) {
        Reflect.defineProperty(param, 'type', {
          get: () => name
        });
      } else {
        param.type = name;
      }
    } // Bubble according to `bubbleEvents` config if `bubbles` is not explicitly set


    if (!('bubbles' in param) && (_me$bubbleEvents = me.bubbleEvents) !== null && _me$bubbleEvents !== void 0 && _me$bubbleEvents[eventName]) {
      param.bubbles = me.bubbleEvents[eventName];
    }

    if (callOnFunctions) {
      const fnName = 'on' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(eventName);

      if (fnName in me) {
        var _me$pluginFunctionCha;

        let inhibit = me.callback(me[fnName], me, [param]) === false; // See if the called function was injected into the instance
        // masking an implementation in the prototype.
        // we must call the class's implementation after the injected one.
        // unless it's an injected chained function, in which case it will have been called above.
        // Note: The handler may have resulted in destruction.

        if (!me.isDestroyed && hasOwnProperty.call(me, fnName) && !((_me$pluginFunctionCha = me.pluginFunctionChain) !== null && _me$pluginFunctionCha !== void 0 && _me$pluginFunctionCha[fnName])) {
          const myProto = Object.getPrototypeOf(me);

          if (fnName in myProto) {
            inhibit = myProto[fnName].call(me, param) === false || inhibit; // A handler may have resulted in destruction.

            if (me.isDestroyed) {
              return;
            }
          }
        } // Returning false from an on-function prevents further triggering


        if (inhibit) {
          return false;
        }
      }
    }

    if (listeners) {
      let i = 0,
          ret; // Let add/removeListener know that we're using the array to protect against a situation where an event
      // listener changes the listeners when triggering the event.

      listeners.$firing = true; // If any listener resulted in our destruction, abort.

      for (i; i < listeners.length && !me.isDestroyed && ret !== false; i++) {
        const listener = listeners[i];
        let handler,
            thisObj = listener.thisObj; // Listeners that have thisObj are auto removed when thisObj is destroyed. If thisObj is destroyed from
        // a listener we might still end up here, since listeners are sliced and not affected by the removal

        if (!thisObj || !thisObj.isDestroyed) {
          // Flag for the expiry timer
          listener.called = true;

          if (listener.once) {
            me.removeListener(name, listener);
          } // prepare handler function


          if (typeof listener.fn === 'string') {
            if (thisObj) {
              handler = thisObj[listener.fn];
            } // keep looking for the callback in the hierarchy


            if (!handler) {
              const result = me.resolveCallback(listener.fn);
              handler = result.handler;
              thisObj = result.thisObj;
            }
          } else {
            handler = listener.fn;
          } // if `buffer` option is provided, the handler will be wrapped into buffer function,
          // but only once on the first call


          if (listener.buffer) {
            if (!listener.bufferFn) {
              const buffer = Number(listener.buffer);

              if (typeof buffer !== 'number' || isNaN(buffer)) {
                throw new Error(`Incorrect type for buffer, got "${buffer}" (expected a Number)`);
              }

              listener.bufferFn = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createBuffered(handler, buffer, listener.thisObj, listener.args);
            }

            handler = listener.bufferFn;
          } // if `throttle` option is provided, the handler will be called immediately, but all the rest calls
          // that happened during time specified in `throttle`, will be delayed and glued into 1 call


          if (listener.throttle) {
            const throttle = Number(listener.throttle);

            if (typeof throttle !== 'number' || isNaN(throttle)) {
              throw new Error(`Incorrect type for throttle, got "${throttle}" (expected a Number)`);
            }

            if (!listener.throttledFn) {
              listener.throttledFn = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createThrottled(handler, throttle, listener.thisObj, listener.args);
            }

            handler = listener.throttledFn;
          }

          ret = handler.call(thisObj || me, ...(listener.args || []), param);

          if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].isPromise(ret)) {
            // If a handler is async (returns a Promise), then collect all Promises.
            // At the end we return a Promise which encapsulates all returned Promises
            // or, if only one handler was async, *the* Promise.
            // Don't allocate an Array until we have to.
            (handlerPromises || (handlerPromises = [])).push(ret);
          }
        }
      }

      listeners.$firing = false;

      if (ret === false) {
        return ret;
      }
    } // relay all?


    if (relayAllTargets) {
      relayAllTargets.forEach(config => {
        let name = eventName;
        if (config.transformCase) name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(name);
        if (config.prefix) name = config.prefix + name;
        if (config.through.trigger(name, param) === false) return false;
      });
    } // Use DOM standard event property name to indicate that the event
    // bubbles up the owner axis.
    // False from any handler cancels the bubble.
    // Must also avoid owner if any handlers destroyed the owner.


    if (param.bubbles && me.owner && !me.owner.isDestroyed) {
      return me.owner.trigger(eventName, param);
    } // If any handlers were async functions (returned a Promise), then return a Promise
    // which resolves when they all resolve.


    if ((_handlerPromises = handlerPromises) !== null && _handlerPromises !== void 0 && _handlerPromises.length) {
      return new Promise(resolve => {
        Promise.all(handlerPromises).then(promiseResults => {
          const finalResult = !promiseResults.some(result => result === false);
          resolve(finalResult);
        });
      });
    }

    return true;
  }
  /**
   * Prevents events from being triggered until {@link #function-resumeEvents()} is called. Optionally queues events that are triggered while
   * suspended. Multiple calls stack to require matching calls to `resumeEvents()` before actually resuming.
   * @param {Boolean} queue Specify true to queue events triggered while suspended
   */


  suspendEvents(queue = false) {
    const eventsSuspended = this.eventsSuspended || (this.eventsSuspended = {
      shouldQueue: queue,
      queue: [],
      count: 0
    });
    eventsSuspended.count++;
  }
  /**
   * Resume event triggering after a call to {@link #function-suspendEvents()}. If any triggered events were queued they will be triggered.
   * @returns `true` if events have been resumed (multiple calls to suspend require an equal number of resume calls to resume).
   */


  resumeEvents() {
    const suspended = this.eventsSuspended;

    if (suspended) {
      if (--suspended.count === 0) {
        this.eventsSuspended = null;

        if (suspended.shouldQueue) {
          for (const queued of suspended.queue) {
            this.trigger(...queued);
          }
        }
      }
    }

    return !Boolean(this.eventsSuspended);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Factoryable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Factoryable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';




/**
 * @module Core/mixin/Factoryable
 */

const {
  defineProperty
} = Reflect,
      ownerSymbol = Symbol('owner'),
      typeSplitRe = /[\s,]+/;
/**
 * This mixin is applied to base classes of a type that will be dynamically created by type name aliases.
 * ```
 *  class Layout extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              defaultType : 'default'
 *          };
 *      }
 *
 *      static get type() {
 *          return 'default';
 *      }
 *  }
 *
 *  class Fit extends Layout {
 *      static get type() {
 *          return 'fit';
 *      }
 *  }
 * ```
 *
 * Once a family of classes has been defined, instances are created using the `create()` method:
 * ```
 *  const layout = Layout.create(config);
 * ```
 *
 * In the above example, `config` can be a type name (such as "fit") or a config object with a `type` property that
 * holds the type name.
 *
 * Factories can also extend other factories. For example, one factory creates objects that are useful across a wide
 * range of consumers, and a second factory creates objects for a more specialized consumer. If that specialized
 * consumer can also consume objects from the first factory, then the second factory can specify this relationship:
 * ```
 *  class General extends Base.mixin(Factoryable) {
 *      ...
 *  }
 *
 *  class Specialized extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              extends : General,
 *              ...
 *          };
 *      }
 *  }
 * ```
 * The `extends` factoryable option can be either a class that mixes in `Factoryable` or an array of such classes.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Factoryable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Factoryable';
  }

  static get declarable() {
    return [
    /**
     * This property getter returns options that control the factory process. This property getter must be
     * defined by the class that mixes in `Factoryable` in order to initialize the factory properly.
     * ```
     *  static get factoryable() {
     *      return {
     *          defaultType : 'default'
     *      };
     *  }
     * ```
     * If there are no special options to provide, this method can return nothing (`undefined`):
     * ```
     *  static get factoryable() {
     *      // initialize the factory with all default options
     *  }
     * ```
     * @static
     * @member {Object} factoryable
     * @property {Boolean} [factoryable.caseless=true] Specify `false` to use case-sensitive type names. The
     * default is to ignore case.
     * @property {String} [factoryable.defaultType=null] The default type to create when a config object has
     * no `typeKey` property.
     * @property {Function|Function[]} [factoryable.extends] One or more classes that mix in `Factoryable` to
     * use for resolving type names when a type name is not found in this factory.
     * @property {String} [factoryable.typeKey='type'] The name of the property in a config object that holds
     * the type name.
     * @internal
     */
    'factoryable',
    /**
     * One or more additional type name aliases for this class. This can be useful for renaming and maintaining
     * a previous type name.
     * ```
     *  class Fit extends Layout {
     *      static get type() {
     *          return 'fit';
     *      }
     *
     *      static get alias() {
     *          return 'fill';  // deprecated type name (now known as 'fit')
     *      }
     *  }
     * ```
     * @static
     * @member {String|String[]} alias
     * @internal
     */
    'alias',
    /**
     * The (canonical) type name for this class by which instances can be created using the static
     * {@link #function-create-static create()} method.
     * @static
     * @member {String} type
     */
    'type'];
  }
  /**
   * Registers a class (`cls`) associated with the given `type`.
   * @param {String|String[]} type A string, array of strings or a comma-separated string containing the type names
   * for the specified `cls` class.
   * @param {Function} cls The class (constructor function)
   * @param {Boolean} [replace] Pass `true` to overwrite existing registered types. Otherwise, this method will throw
   * an exception if the `type` is already registered with this factory.
   * @internal
   */


  static register(type, cls, replace = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global.__BRYNTUM_EXAMPLE) {
    // `replace` default value is set to true while we are run inside a bryntum demo where code editor changes might
    // lead to same widget class being registered over and over.
    const {
      factoryable
    } = this.initClass(),
          {
      caseless,
      registry
    } = factoryable,
          types = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(type, typeSplitRe); // if type is a string[] it will just be returned

    for (let lower, name, i = 0; i < types.length; ++i) {
      name = types[i];
      lower = caseless ? name.toLowerCase() : name;

      if (!replace && lower in registry) {
        throw new Error(`Type "${name}" already registered with ${factoryable.class.name} factory`);
      } // Ensure class being registered is initialized. (initClass returns the class)


      registry[name] = registry[lower] = cls.initClass();
    }
  }
  /**
   * Returns 'true` if the passed instance is of the passed type or of a derived class.
   * @param {Object} instance The object to test.
   * @param {String} type The type to test against
   */


  static isA(instance, type) {
    return this.isType(instance, type, true);
  }
  /**
   * Returns 'true` if the passed instance is of the passed type.
   * @param {Object} instance The object to test.
   * @param {String} type The type to test against
   * @param {Boolean} [deep] Pass `true` to return `true` if the class is a subclass of the passed type.
   */


  static isType(instance, type, deep) {
    const {
      factoryable
    } = this,
          {
      caseless,
      registry
    } = factoryable,
          typeCls = registry[caseless ? type.toLowerCase() : type]; // If the type to be tested against maps to a class, see if the instance is an instanceof that

    if (typeCls) {
      if (deep) {
        return instance instanceof typeCls;
      }

      return instance.constructor === typeCls;
    }

    return false;
  }

  static setupAlias(cls) {
    cls.register(cls.alias, cls);
  }

  static setupFactoryable(cls, meta) {
    const superClass = meta.super.class;
    let {
      factoryable
    } = cls;
    factoryable = _objectSpread({
      caseless: true,
      defaultType: null,
      extends: superClass.factoryable ? [superClass] : null,
      typeKey: 'type'
    }, factoryable);
    factoryable.class = cls;
    factoryable.registry = Object.create(null);

    if (factoryable.extends && !Array.isArray(factoryable.extends)) {
      factoryable.extends = [factoryable.extends];
    } // Replace the class/static getter with a new one that returns the complete factoryable object:


    defineProperty(cls, 'factoryable', {
      get() {
        return factoryable;
      }

    });
  }

  static setupType(cls) {
    const {
      type
    } = cls;
    cls.register(type, cls); // Copy the static type property onto the prototype as a readonly property:

    defineProperty(cls.prototype, 'type', {
      value: type
    });
  }
  /**
   * Creates an instance from this factory, given the type name or a config object.
   * @param {String|Object} config The type name string or config object.
   * @param {String|Function|Object} [options] Creation options (for details see {@link #function-reconfigure-static}).
   * @returns {Object}
   */


  static create(config, options) {
    return this.reconfigure(null, config, options);
  }
  /**
   * Reconfigures an optional existing instance based on the provided config and returns the correctly configured
   * instance. This will be the `existingInstance` if the `config` does not specify a different type.
   *
   * If `config` is `null` (or simply falsy), this method will destroy the `existingInstance` (if any) and return
   * `null`.
   *
   * If there is no `existingInstance`, the config must specify a type. That is, it must be a string (the type name)
   * or an object containing a `type` property, the `defaultType` must be provided or the factory itself must have
   * a `defaultType` specified (see {@link #property-factoryable-static}).
   *
   * When an `existingInstance` is provided and a type is specified, the instance will be reconfigured via `setConfig`
   * if it is of that type. Otherwise, the `existingInstance` is destroyed (if it is owned by the `options.owner`)
   * and a new instance of the correct type is created.
   *
   * @param {Object} existingInstance The instance to reconfigure. This can be `null`.
   *
   * @param {String|Object} config The type name string or config object.
   *
   * @param {String|Function|Object} [options] Additional options to control the reconfiguration process. If this
   * value is a string or a class constructor, it treated as `options.type`. If this value is an class instance, it
   * is used as the `options.owner`. If this is a function, it is treated as `options.setup`. NOTE: functions declared
   * using the `function` keyword are equivalent to class constructors. Use an arrow function or a class method to
   * avoid this when a `setup` function is intended.
   *
   * @param {String|Function} [options.type] The default type to use if the `config` object does not specify a type.
   *
   * @param {Object} [options.owner] The owner of any created instances. If the `existingInstance` is being replaced,
   * this value determines if the instance will be destroyed.
   *
   * @param {Object} [options.defaults] A config object of default values to use when creating a new instance.
   *
   * @param {Function|String} [options.setup] A function or the name of a method (on the `options.owner`) to call
   * prior to creating a new instance. It is passed the config object that will be used to create the instance. If a
   * truthy value is returned, that value is passed to the constructor instead of the provided config object.
   *
   * @param {Function|String} [options.transform] A function or the name of a method (on the `options.owner`) to call
   * with the raw config object prior to processing and the value it returns replaces the raw value. This function is
   * used to transform strings or arrays (for example) into proper config objects.
   *
   * @param {Function|String} [options.cleanup] A function or the name of a method (on the `options.owner`) to call
   * prior to destroying the `existingInstance`. The `existingInstance` is passed as the sole argument.
   *
   * @returns {Object} The reconfigured instance (either `existingInstance` or a new instance of the desired type)
   */


  static reconfigure(existingInstance, config, options) {
    const me = this,
          {
      factoryable
    } = me,
          {
      typeKey
    } = factoryable;
    let defaultType = options,
        cleanup,
        defaults,
        mergeType,
        owner,
        prepared,
        setup,
        t,
        transform,
        type; // Pick apart the options and set the vars accordingly

    if (options && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isClass(options)) {
      // if (options is not the defaultType)
      defaultType = null;
      t = typeof options;

      if (t === 'function') {
        setup = options;
      } else if (t === 'string') {
        defaultType = options;
      } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(options)) {
        // TODO revert to
        //  ({ cleanup, defaults, owner, setup, type : defaultType } = options);
        //  after this issue is fixed https://github.com/bryntum/bryntum-suite/issues/1457
        cleanup = options.cleanup;
        defaults = options.defaults;
        owner = options.owner;
        setup = options.setup;
        defaultType = options.type;
        transform = options.transform;
      } else {
        owner = options;
      }
    }

    if (transform) {
      config = typeof transform === 'string' ? owner[transform](config) : transform(config);
    }

    type = config; // Figure out config... it's either a type (string), a config object or the actual instance.

    if (typeof type === 'string') {
      config = {};
    } else if (config) {
      if (config === true) {
        config = {};
      }

      if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(config)) {
        // If we are being given an instance (not a config object), discard or destroy the existingInstance
        if (owner && config !== existingInstance && (existingInstance === null || existingInstance === void 0 ? void 0 : existingInstance[ownerSymbol]) === owner) {
          var _cleanup;

          typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup = cleanup) === null || _cleanup === void 0 ? void 0 : _cleanup(existingInstance);
          existingInstance.destroy();
        }

        return config;
      }

      type = config[typeKey];
    }

    type = type && me.resolveType(type); // We've got our orders... make it so...

    if (existingInstance) {
      // We can have a type-less config object when reconfiguring an existing instance, but if we have a type,
      // the existingInstance must be of that type. If !config that means we are nulling out.
      if (config && (!type || existingInstance.constructor === type)) {
        if (typeKey in config) {
          config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
          delete config[typeKey]; // so "type" won't be processed as a config property
        }

        existingInstance.setConfig(config);
        return existingInstance;
      }

      if (owner && existingInstance[ownerSymbol] === owner) {
        var _cleanup2;

        typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup2 = cleanup) === null || _cleanup2 === void 0 ? void 0 : _cleanup2(existingInstance);
        existingInstance.destroy();
      }
    }

    if (config) {
      if (defaults) {
        if (!(mergeType = type)) {
          if (!(mergeType = defaults[typeKey] || defaultType || factoryable.defaultType)) {
            throw new Error(`No default mergeType defined for ${factoryable.class.name} factory`);
          }

          mergeType = me.resolveType(mergeType);
        }

        if (mergeType) {
          // Allow the merge fn of each config to perform the task:
          config = mergeType.mergeConfigs(defaults, config);
        }
      }

      if (setup) {
        prepared = typeof setup === 'string' ? owner[setup](config, type, defaults) : setup(config, type, defaults);

        if (prepared === null) {
          return prepared;
        }

        config = prepared || config;
      }

      if (!type) {
        // One more check on config[typeKey] since the setup() function may have added it...
        if (!(type = config[typeKey] || defaultType || factoryable.defaultType)) {
          throw new Error(`No default type defined for ${factoryable.class.name} factory`);
        }

        type = me.resolveType(type);
      }

      if (defaults && !mergeType) {
        config = type.mergeConfigs(defaults, config);
      }

      if (typeKey in config) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
        delete config[typeKey]; // so "type" won't be processed as a config property
      }

      config = new type(config);

      if (owner) {
        config[ownerSymbol] = owner;
      }
    }

    return config || null;
  }
  /**
   * This method returns the constructor of the class registered for the given type name.
   * @param {String} type The type name to look up.
   * @param {Boolean} [optional] Pass `true` to return `null` if `type` is not found instead of throwing an exception.
   * @returns {Function}
   * @private
   */


  static resolveType(type, optional) {
    if (typeof type !== 'string') {
      return type;
    }

    const {
      factoryable
    } = this,
          bases = factoryable.extends;
    let result = factoryable.registry[factoryable.caseless ? type.toLowerCase() : type],
        i;

    for (i = 0; !result && bases && i < bases.length; ++i) {
      // Pass optional=true to base factory so the error is our own should the lookup fail:
      result = bases[i].resolveType(type,
      /* optional = */
      true);
    }

    if (!result && !optional) {
      throw new Error(`Invalid type name "${type}" passed to ${factoryable.class.name} factory`);
    }

    return result;
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Featureable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Featureable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/**
 * @module Core/mixin/Featureable
 */

/**
 * This mixin provides management of a set of features that can be manipulated via the `features` config.
 *
 * The first step in using `Featureable` is to define the family of features using `Factoryable` to declare a base
 * class for features to extend:
 * ```
 *  class SuperWidgetFeature extends InstancePlugin.mixin(Factoryable) {
 *      static get factoryable() {
 *          //
 *      }
 *  }
 * ```
 *
 * The various feature classes extend the `SuperWidgetFeature` base class and call `initClass()` to register themselves:
 * ```
 *  export default class AmazingSuperWidgetFeature extends SuperWidgetFeature {
 *      static get type() {
 *          return 'amazing';
 *      }
 *  }
 *
 *  AmazingSuperWidgetFeature.initClass();
 * ```
 *
 * A class that supports these features via `Featureable` is declared like so:
 * ```
 *  class SuperWidget extends Widget.mixin(Featureable) {
 *      static get featureable() {
 *          return {
 *              factory : SuperWidgetFeature
 *          };
 *      }
 *
 *      static get configurable() {
 *          return {
 *              // Declare the default features. These can be disabled by setting them to a falsy value. Using
 *              // configurable(), the value defined by this class is merged with values defined by derived classes
 *              // and ultimately the instance.
 *              features : {
 *                  amazing : {
 *                      ...
 *                  }
 *              }
 *          };
 *      }
 *  }
 *```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Featureable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Featureable';
  }

  static get configurable() {
    return {
      /**
       * Specifies the features to create and associated with the instance. The keys of this object are the names
       * of features. The values are config objects for those feature instances.
       *
       * After construction, this property can be used to access the feature instances and even reconfigure them.
       *
       * For example:
       * ```
       *  instance.features.amazing = {
       *      // reconfigure this feature
       *  }
       * ```
       * This can also be done in bulk:
       * ```
       *  instance.features = {
       *      amazing : {
       *          // reconfigure this feature
       *      },
       *      // reconfigure other features
       *  }
       * ```
       * @config {Object}
       */
      features: null
    };
  }

  static get declarable() {
    return [
    /**
     * This property getter returns options that control feature management for the derived class. This
     * property getter must be defined by the class that mixes in `Featureable` in order to initialize the
     * class properly.
     * ```
     *  class SuperWidget extends Widget.mixin(Featureable) {
     *      static get featureable() {
     *          return {
     *              factory : SuperWidgetFeature
     *          };
     *      }
     *      ...
     *  }
     * ```
     * @static
     * @member {Object} featureable
     * @property {Core.mixin.Factoryable} featureable.factory The factoryable class (not one of its instances)
     * that will be used to create feature instances.
     * @property {String} [featureable.ownerName='client'] The config or property to assign on each feature as
     * a reference to its creator, the `Featureable` instance.
     * @internal
     */
    'featureable'];
  }

  static setupFeatureable(cls) {
    const featureable = _objectSpread({
      ownerName: 'client'
    }, cls.featureable);

    featureable.factory.initClass(); // Replace the class/static getter with a new one that returns the complete featureable object:

    Reflect.defineProperty(cls, 'featureable', {
      get() {
        return featureable;
      }

    });
  }

  doDestroy() {
    const features = this.features;
    super.doDestroy();

    for (const name in features) {
      var _feature$destroy;

      const feature = features[name]; // Feature might be false or destroyed already by Grid (EventList mixes in CalendarMixin which has this mixin)

      (_feature$destroy = feature.destroy) === null || _feature$destroy === void 0 ? void 0 : _feature$destroy.call(feature);
    }
  }
  /**
   * Returns `true` if the specified feature is active for this instance and `false` otherwise.
   * @param {String} name The feature name
   * @returns {Boolean}
   */


  hasFeature(name) {
    var _this$features;

    return Boolean((_this$features = this.features) === null || _this$features === void 0 ? void 0 : _this$features[name]);
  }

  changeFeatures(features, was) {
    if (this.isDestroying) {
      return;
    }

    const me = this,
          {
      featureable
    } = me.constructor,
          manager = me.$features || (me.$features = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      configName: 'features',
      factory: featureable.factory,
      owner: me,
      ownerName: featureable.ownerName
    }));
    manager.update(features);

    if (!was) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Finalizable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Finalizable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/mixin/Finalizable
 */

/**
 * This mixin provides an asynchronous completion mechanism. This allows a process to coordinate its async actions
 * (such as Ajax requests or user interaction) with cleanup.
 *
 * Consider a context tracking helper class, for example:
 * ```
 *  class Context extends Base.mixin(Finalizable) {
 *      // ...
 *
 *      async finish() {
 *          this.owner.trigger('finish', {
 *              context : this
 *          });
 *
 *          // Wait for any scheduled finalizer to run...
 *          await this.finalize();
 *      }
 *
 *      doFinalize() {
 *          this.destroy();
 *      }
 *  }
 * ```
 *
 * When the `finish` event is processed, the receiver can register a promise for whatever processing it would like to
 * perform:
 * ```
 *  class Foo {
 *      onFinish({ context }) {
 *          context.finalizer = this.askUser(context);
 *      }
 *
 *      async askUser(context) {
 *          //
 *      }
 *  }
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Finalizable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Finalizable';
  }

  construct(...args) {
    super.construct(...args);
    /**
     * This property can be set any time prior to calling {@link #function-finalize} (i.e., when the
     * {@link #property-isFinalizing} property goes to `true`). When set, this instance will `await` this
     * promise before completing the finalization process by calling {@link #function-doFinalize}.
     * @member {Promise} finalizer
     */

    this.finalizer = null;
    /**
     * This property holds the `Promise` that will resolve when {@link #function-finalize} has completed. It is
     * set when {@link #function-finalize} is called and cleared on return.
     * @member {Boolean} finalizing
     * @readonly
     * @private
     */

    this.finalizing = null;
    /**
     * This property is `true` once the instance completes the {@link #function-finalize} method.
     * @member {Boolean} isFinalized
     * @readonly
     */

    this.isFinalized = false;
    /**
     * This property is set to `true` when {@link #function-finalize} is called.
     * @member {Boolean} isFinalizing
     * @readonly
     */

    this.isFinalizing = false;
  }
  /**
   * This template method is called at the end of {@link #function-finalize}. By default it calls `destroy()`, but
   * can be replaced by the derived class. This can be useful if it is not the `Finalizable` instance that awaits
   * the {@link #function-finalize} method.
   */


  doFinalize() {
    this.destroy();
  }
  /**
   * This method is called (typically by this instance or its owner) to cleanup this instance while possibly first
   * waiting for the {@link #property-finalizer} promise to settle. Once settled, the {@link #function-doFinalize}
   * method is called.
   * @async
   */


  finalize() {
    const me = this;
    let ret = me.finalizing;

    if (!ret && !me.isFinalized) {
      me.isFinalizing = true; // note: we never clear this flag (use isFinalized to know if we're done)
      // If we are called during finalization, we want to return the same promise, so we cache it away.

      me.finalizing = ret = me._awaitFinalizer();
    }

    return ret;
  }

  async _awaitFinalizer() {
    const me = this;

    try {
      await me.finalizer;
    } finally {
      // be sure we clean up even if an exception is thrown by the finalizer...
      me.finalizing = null;
      me.isFinalized = true;
      me.doFinalize();
    }
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Hoverable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Hoverable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';



/**
 * @module Core/mixin/Hoverable
 */

const EDGES = {
  e: 'b-hover-edge',
  t: 'b-hover-top',
  r: 'b-hover-right',
  b: 'b-hover-bottom',
  l: 'b-hover-left'
},
      EDGE_CLASSES = {
  [EDGES.e]: 1,
  [EDGES.t]: 1,
  [EDGES.r]: 1,
  [EDGES.b]: 1,
  [EDGES.l]: 1
},
      ZONES = {
  t: [EDGES.e, EDGES.t],
  r: [EDGES.e, EDGES.r],
  b: [EDGES.e, EDGES.b],
  l: [EDGES.e, EDGES.l],
  tr: [EDGES.e, EDGES.t, EDGES.r],
  bl: [EDGES.e, EDGES.b, EDGES.l],
  tl: [EDGES.e, EDGES.t, EDGES.l],
  br: [EDGES.e, EDGES.b, EDGES.r]
};
/**
 * This mixin provides mouse hover tracking.
 * ```
 *  class Tracker extends Base.mixin(Hoverable) {
 *      hoverEnter(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget will never be null, but leaving may be null
 *      }
 *
 *      hoverLeave(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget may be null, but leaving will never be null
 *      }
 *
 *      hoverMove(event) {
 *          // called when a mousemove is made within a hover target
 *          // this.hoverTarget will never be null
 *      }
 *  }
 *
 *  let tracker = new Tracker({
 *      hoverRootElement : document.body,
 *      hoverSelector    : '.hoverable'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Hoverable extends Target.mixin(_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Hoverable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * A CSS class to add to the {@link #config-hoverTarget target} element.
       * @config {String}
       */
      hoverCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverTarget target} element to enable CSS animations. This class
       * is added after calling {@link #function-hoverEnter}.
       * @config {String}
       */
      hoverAnimationCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverRootElement root} element.
       * @config {String}
       */
      hoverRootCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverRootElement root} element when there is an active
       * {@link #config-hoverTarget target}.
       * @config {String}
       */
      hoverRootActiveCls: null,

      /**
       * The number of milliseconds to delay notification of changes in the {@link #config-hoverTarget}.
       * @config {Number}
       */
      hoverDelay: null,

      /**
       * The current element that the cursor is inside as determined by `mouseover` and `mouseout`. Changes in
       * this config trigger re-evaluation of the {@link #config-hoverSelector} to determine if there is a
       * {@link #config-hoverTarget}.
       * @config {HTMLElement}
       * @private
       */
      hoverElement: null,

      /**
       * An element to ignore. Mouse entry into this element will not trigger a change in either of the
       * {@link #config-hoverElement} or {@link #config-hoverTarget} values.
       * @config {HTMLElement}
       */
      hoverIgnoreElement: null,

      /**
       * This property is a string containing one character for each edge that is hoverable. For example, a
       * value of "tb" indicates that the top and bottom edges are hoverable.
       * @config {String}
       */
      hoverEdges: null,

      /**
       * When {@link #config-hoverEdges} is used, this value determines the size (in pixels) of the edge. When
       * the cursor is within this number of pixels of an edge listed in `hoverEdges`, the appropriate CSS class
       * is added to the {@link #config-hoverTarget}:
       *
       *  - `b-hover-top`
       *  - `b-hover-right`
       *  - `b-hover-bottom`
       *  - `b-hover-left`
       *
       * Depending on the values of `hoverEdges`, it is possible to have at most two of these classes present at
       * any one time (when the cursor is in a corner).
       * @config {Number}
       * @default
       */
      hoverEdgeSize: 10,

      /**
       * The outer element where hover tracking will operate (attach events to it and use as root limit when
       * looking for ancestors).
       *
       * A common choice for this will be `document.body`.
       * @config {HTMLElement}
       */
      hoverRootElement: {
        $config: 'nullify',
        value: null
      },

      /**
       * A selector for the [closest](https://developer.mozilla.org/en-US/docs/Web/API/Element/closest) API to
       * determine the actual element of interest. This selector is used to process changes to the
       * {@link #config-hoverElement} to determine the {@link #config-hoverTarget}.
       * @config {String}
       */
      hoverSelector: null,

      /**
       * The currently active hover target. This will be the same as {@link #config-hoverElement} unless there is
       * a {@link #config-hoverSelector}.
       * @config {HTMLElement}
       */
      hoverTarget: {
        $config: 'nullify',
        value: null
      },

      /**
       * Set to `true` to include tracking of `mousemove` events for the active {@link #config-hoverTarget}. This
       * is required for the {@link #function-hoverMove} method to be called.
       * @config {Boolean}
       * @default false
       */
      hoverTrack: null,

      /**
       * A string value containing one character per active edge (e.g., "tr").
       * @config {String}
       * @private
       */
      hoverZone: null
    };
  }

  static get delayable() {
    return {
      setHoverTarget: 0
    };
  } //endregion
  //region State Handling

  /**
   * This method is called when the cursor enters the {@link #config-hoverTarget}. The `hoverTarget` will not be
   * `null`.
   * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value may be null.
   */


  hoverEnter(leaving) {// template
  }
  /**
   * This method should return true if the given `element` should be ignored. By default, this is `true` if the
   * `element` is contained inside the {@link #config-hoverIgnoreElement}.
   * @param {HTMLElement} element
   * @returns {Boolean}
   * @protected
   */


  hoverIgnore(element) {
    var _this$hoverIgnoreElem;

    return (_this$hoverIgnoreElem = this.hoverIgnoreElement) === null || _this$hoverIgnoreElem === void 0 ? void 0 : _this$hoverIgnoreElem.contains(element);
  }
  /**
   * This method is called when the cursor leaves the {@link #config-hoverTarget}. The `hoverTarget` may be `null`
   * or refer to the new `hoverTarget`
   * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value will not be null.
   */


  hoverLeave(leaving) {// template
  }
  /**
   * This method is called when the mouse moves within a {@link #config-hoverTarget}, but only if enabled by the
   * {@link #config-hoverTrack} config.
   * @param {Event} event
   */


  hoverMove(event) {// template
  } //endregion
  //region Events


  onHoverMouseMove(event) {
    const me = this,
          {
      hoverEdges,
      hoverEdgeSize,
      hoverTarget
    } = me;

    if (hoverTarget) {
      if (hoverEdges) {
        const {
          top,
          left,
          width,
          height,
          right,
          bottom
        } = hoverTarget.getBoundingClientRect(),
              {
          clientX,
          clientY
        } = event,
              centerX = left + width / 2,
              centerY = top + height / 2,
              t = clientY < (hoverEdgeSize ? top + hoverEdgeSize : centerY),
              r = clientX >= (hoverEdgeSize ? right - hoverEdgeSize : centerX),
              b = clientY >= (hoverEdgeSize ? bottom - hoverEdgeSize : centerY),
              l = clientX < (hoverEdgeSize ? left + hoverEdgeSize : centerX),
              tb = t || b ? t ? 't' : 'b' : '',
              rl = r || l ? r ? 'r' : 'l' : '';
        me.hoverZone = (hoverEdges.includes(tb) ? tb : '') + (hoverEdges.includes(rl) ? rl : '');
      }

      me.hoverEvent = event;
      me.hoverTrack && me.hoverMove(event);
    }
  }

  onHoverMouseOver(event) {
    this.hoverEvent = event;
    this.hoverElement = event.target;
  }

  onHoverMouseOut(event) {
    this.hoverEvent = event;
    this.hoverElement = event.relatedTarget;
  } //endregion
  //region Configs
  // hoverDelay


  updateHoverDelay(delay) {
    this.setHoverTarget.delay = delay;
  } // hoverEdges


  changeHoverEdges(edges) {
    return edges === true ? 'trbl' : (edges || '').replace('v', 'tb').replace('h', 'lr');
  }

  updateHoverEdges() {
    this.syncHoverListeners();
  } // hoverElement


  changeHoverElement(element) {
    if (!this.hoverIgnore(element)) {
      return element;
    }
  }

  updateHoverElement(hoverEl) {
    const {
      hoverSelector
    } = this;

    if (hoverSelector) {
      var _hoverEl;

      hoverEl = (_hoverEl = hoverEl) === null || _hoverEl === void 0 ? void 0 : _hoverEl.closest(hoverSelector);
    }

    this.setHoverTarget(hoverEl); // this may be delayed
  } // hoverRootElement


  updateHoverRootElement(rootEl, was) {
    const {
      hoverRootCls
    } = this;

    if (hoverRootCls) {
      was === null || was === void 0 ? void 0 : was.classList.remove(hoverRootCls);
      rootEl === null || rootEl === void 0 ? void 0 : rootEl.classList.add(hoverRootCls);
    }

    this.syncHoverListeners();
  } // hoverTarget


  changeHoverTarget(hoverEl, was) {
    if (was) {
      this.hoverZone = null;
    }

    return hoverEl;
  }

  updateHoverTarget(hoverEl, was) {
    const me = this,
          {
      hoverCls,
      hoverAnimationCls,
      hoverRootActiveCls,
      hoverRootElement
    } = me;

    if (hoverRootActiveCls) {
      hoverRootElement === null || hoverRootElement === void 0 ? void 0 : hoverRootElement.classList[hoverEl ? 'add' : 'remove'](hoverRootActiveCls);
    }

    if (was) {
      hoverCls && was.classList.remove(hoverCls);
      hoverAnimationCls && was.classList.remove(hoverAnimationCls);
      me.hoverLeave(was);
    }

    if (hoverEl) {
      hoverCls && hoverEl.classList.add(hoverCls);
      me.hoverEnter(was);

      if (me.hoverTrack) {
        me.hoverMove(me.hoverEvent);
      }

      if (hoverAnimationCls) {
        hoverEl.getBoundingClientRect(); // force layout so next change starts animation

        hoverEl.classList.add(hoverAnimationCls);
      }
    }
  } // hoverTrack


  updateHoverTrack() {
    this.syncHoverListeners();
  } // hoverZone


  updateHoverZone(zone) {
    const {
      hoverAnimationCls,
      hoverTarget
    } = this;

    if (hoverTarget) {
      const {
        className
      } = hoverTarget,
            cls = _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"].change(className,
      /* add= */
      zone ? ZONES[zone] : null,
      /* remove= */
      EDGE_CLASSES);

      if (className !== cls) {
        hoverTarget.className = cls;

        if (zone && hoverAnimationCls) {
          hoverTarget.classList.remove(hoverAnimationCls);
          hoverTarget.getBoundingClientRect(); // force layout so next change starts animation

          hoverTarget.classList.add(hoverAnimationCls);
        }
      }
    }
  } //endregion
  //region Misc


  setHoverTarget(target) {
    // this method runs later based on the hoverDelay
    this.hoverTarget = target;
  }

  syncHoverListeners() {
    var _me$_hoverRootDetache;

    const me = this,
          element = me.hoverRootElement,
          listeners = {
      element,
      thisObj: me,
      mouseover: 'onHoverMouseOver',
      mouseout: 'onHoverMouseOut'
    };

    if (me.hoverTrack || me.hoverEdges) {
      listeners.mousemove = 'onHoverMouseMove';
    }

    (_me$_hoverRootDetache = me._hoverRootDetacher) === null || _me$_hoverRootDetache === void 0 ? void 0 : _me$_hoverRootDetache.call(me);
    me._hoverRootDetacher = element && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(listeners);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Identifiable.js":
/*!****************************************!*\
  !*** ./lib/Core/mixin/Identifiable.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';



/**
 * @module Core/mixin/Identifiable
 */

const // Id generation should be on a per page basis, not per module
idCounts = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPathDefault(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global, 'bryntum.idCounts', Object.create(null)),
      idTypes = {
  string: 1,
  number: 1
};
/**
 * A mixin which provides identifier services such as auto-creation of `id`s and registration and
 * lookup of instances by `id`.
 *
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Identifiable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Identifiable';
  }

  static get declarable() {
    return ['identifiable'];
  }

  static get configurable() {
    return {
      /**
       * The id of this object.  If not specified one will be generated. Also used for lookups through the
       * static `getById` of the class which mixes this in. An example being {@link Core.widget.Widget}.
       *
       * For a {@link Core.widget.Widget Widget}, this is assigned as the `id` of the DOM
       * {@link Core.widget.Widget#config-element element} and must be unique across all elements
       * in the page's `document`.
       * @config {String}
       * @category Common
       */
      id: ''
    };
  }

  static setupIdentifiable(cls, meta) {
    const {
      identifiable
    } = cls;
    identifiable.idMap = Object.create(null);
    Reflect.defineProperty(cls, 'identifiable', {
      get() {
        return identifiable;
      }

    });
  }

  doDestroy() {
    this.constructor.unregisterInstance(this);
    super.doDestroy();
  }

  changeId(id) {
    return (this.hasGeneratedId
    /* assignment */
    = !id) ? this.generateAutoId() : id;
  }

  updateId(id, oldId) {
    const me = this,
          C = me.constructor;
    oldId && C.unregisterInstance(me, oldId);

    if (!me.hasGeneratedId || C.identifiable.registerGeneratedId !== false) {
      C.registerInstance(me, id);
    }
  }
  /**
   * This method generates an id for this instance.
   * @returns {String}
   * @internal
   */


  generateAutoId() {
    return this.constructor.generateId(`b-${this.$$name.toLowerCase()}-`);
  }

  static get all() {
    // not documented here since type of array is not knowable... documented at mixin target class
    return Object.values(this.identifiable.idMap);
  }
  /**
   * Generate a new id, using an internal counter and a prefix.
   * @param {String} prefix Id prefix
   * @returns {String} Generated id
   */


  static generateId(prefix = 'generatedId') {
    // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
    // id's more stable since the counter is on a per-class basis.
    return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
  }

  static registerInstance(instance, instanceId = instance.id) {
    const {
      idMap
    } = this.identifiable; // Code editor sets `disableThrow` to not get conflicts when loading the same module again

    if (instanceId in idMap && !this.disableThrow) {
      throw new Error('Id ' + instanceId + ' already in use');
    }

    idMap[instanceId] = instance;
  }
  /**
   * Unregister Identifiable instance, normally done on destruction
   * @param {Object} instance Object to unregister
   * @param {String} id The id of the instance to unregister.
   */


  static unregisterInstance(instance, id = instance.id) {
    const {
      idMap
    } = this.identifiable; // ID may be passed, for example if the instance is destroyed and can no longer yield an id.

    if (idTypes[typeof instance]) {
      delete idMap[instance];
    } // Have to check for identity in case another instance by the same id has been created.
    // Allow that to be overridden. Stores have always just evicted the previous owner of their IDs
    else if (idMap[id] === instance) {
      delete idMap[id];
    }
  }

  static getById(id) {
    const idMap = this.identifiable.idMap;

    if (idMap) {
      return idMap[id];
    }
  }

  static get registeredInstances() {
    const idMap = this.identifiable.idMap;
    return idMap ? Object.values(idMap) : [];
  }

});

/***/ }),

/***/ "./lib/Core/mixin/InstancePlugin.js":
/*!******************************************!*\
  !*** ./lib/Core/mixin/InstancePlugin.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InstancePlugin; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
var productName = 'gantt';




/**
 * @module Core/mixin/InstancePlugin
 */

function getDescriptor(me, fnName) {
  const property = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(me), fnName);
  return property && (property.get || property.set) ? property : null;
}
/**
 * Base class for plugins. Published functions will be available from the other class. `this` in published functions is
 * referenced to the plugin, access the other class using `this.client`.
 *
 * Observe that plugin doesn't apply itself on class level but instead on instance level. Plugin is its own instance
 * that can have own functions and data that is not exposed to target class.
 *
 * Functions can be published in four ways:
 *
 * * `assign` (when function is not already available on target)
 * * `before` (when function is already available on target, will be called before original function)
 * * `after` (when function is already available on target, will be called after original function)
 * * `override` (replaces function on target, but old function can be reached)
 *
 * To configure which functions get published and in what way, specify `pluginConfig` getter on plugin:
 *
 * ```
 * class Sort extends InstancePlugin {
 *   static get pluginConfig {
 *      return {
 *          before   : ['init'],
 *          after    : ['destroy', 'onElementClick'],
 *          override : ['render']
 *      };
 *   }
 * }
 * ```
 * @extends Core/Base
 * @mixes Core/localization/Localizable
 * @mixes Core/mixin/Events
 */


class InstancePlugin extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get configurable() {
    return {
      clientListeners: null,

      /**
       * Get/set the plugin/feature `disabled` state.
       * @member {Boolean} disabled
       * @category Common
       */

      /**
       * The plugin/feature `disabled` state.
       *
       * For a feature that is **off** by default that you want to enable later during runtime,
       * configure it with `disabled : true`.
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : {
       *              disabled : true // on and disabled, can be enabled later
       *          }
       *      }
       * });
       *
       * // enable the feature
       * grid.features.featureName.disabled = false;
       * ```
       *
       * If the feature is **off** by default, and you want to include and enable the feature, configure it as `true`:
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : true // on and enabled, can be disabled later
       *      }
       * });
       *
       * // disable the feature
       * grid.features.featureName.disabled = true;
       * ```
       *
       * If the feature is **on** by default, but you want to turn it **off**, configure it as `false`:
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : false // turned off, not included at all
       *      }
       * });
       * ```
       *
       * If the feature is **enabled** by default and you have no need of reconfiguring it,
       * you can omit the feature configuration.
       *
       * @config {Boolean}
       * @default
       * @category Common
       */
      disabled: false
    };
  } //endregion
  //region Init

  /**
   * Call from another instance to add plugins to it.
   * @example
   * InstancePlugin.initPlugins(this, Search, Stripe);
   * @param plugInto Instance to mix into (usually this)
   * @param plugins Classes to plug in
   * @internal
   */


  static initPlugins(plugInto, ...plugins) {
    const property = plugInto.plugins || (plugInto.plugins = {});

    for (const PluginClass of plugins) {
      property[PluginClass.$$name] = new PluginClass(plugInto);
    }
  }
  /**
   * The Widget which was passed into the constructor,
   * which is the Widget we are providing extra services for.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Misc
   */


  get client() {
    return this._client;
  }

  set client(client) {
    this._client = client;
  } // We can act as an owner of a widget, so must be able to participate in focus reversion


  getFocusRevertTarget() {
    var _this$client;

    return (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.getFocusRevertTarget();
  }

  construct(...args) {
    const me = this;
    let [plugInto, config] = args,
        listeners; // When called with one argument (a config object), grab the "client" from the config object.

    if (args.length === 1) {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(plugInto)) {
        config = plugInto;
        plugInto = config.client;
      }
    } // Two args, so client is the first. Ensure the config doesn't contain a client property.
    else {
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
      delete config.client;
    }

    me.client = plugInto;
    super.construct(config);
    me.applyPluginConfig(plugInto);
    listeners = me.clientListeners;

    if (listeners) {
      listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, listeners);
      listeners.thisObj = me;
      plugInto.on(listeners);
    }
  }
  /**
   * Applies config as found in plugInto.pluginConfig, or published all if no config found.
   * @private
   * @param plugInto Target instance to plug into
   */


  applyPluginConfig(plugInto) {
    const me = this,
          config = me.pluginConfig || me.constructor.pluginConfig;

    if (config) {
      const {
        assign,
        chain,
        after,
        before,
        override
      } = config;
      assign && me.applyAssign(plugInto, assign);
      (chain || after) && me.applyChain(plugInto, chain || after);
      before && me.applyChain(plugInto, before, false);
      override && me.applyOverride(plugInto, override);
    }
  }
  /**
   * Applies assigning for specified functions.
   * @private
   * @param plugInto
   * @param fnNames
   */


  applyAssign(plugInto, fnNames) {
    fnNames.forEach(fnName => this.assign(plugInto, fnName));
  }
  /**
   * Applies chaining for specified functions.
   * @private
   * @param plugInto
   * @param functions
   * @param after
   */


  applyChain(plugInto, functions, after = true) {
    if (Array.isArray(functions)) {
      for (const fnName of functions) {
        this.chain(plugInto, fnName, fnName, after);
      }
    } else {
      for (const intoName in functions) {
        this.chain(plugInto, intoName, functions[intoName], after);
      }
    }
  }
  /**
   * Applies override for specified functions.
   * @private
   * @param plugInto
   * @param fnNames
   */


  applyOverride(plugInto, fnNames) {
    const me = this;

    if (!me.overridden) {
      me.overridden = {};
    }

    fnNames.forEach(fnName => {
      if (!me[fnName]) {
        throw new Error(`Trying to chain fn ${plugInto.$$name}#${fnName}, but plugin fn ${me.$$name}#${fnName} does not exist`);
      } // override


      if (typeof plugInto[fnName] === 'function') {
        me.overridden[fnName] = plugInto[fnName].bind(plugInto);
      }

      plugInto[fnName] = me[fnName].bind(me);
    });
  }
  /**
   * Assigns specified functions.
   * @private
   * @param plugInto
   * @param fnName
   */


  assign(plugInto, fnName) {
    const me = this,
          property = getDescriptor(me, fnName);

    if (property) {
      // getter/setter, define corresponding property on target
      Object.defineProperty(plugInto, fnName, {
        configurable: true,
        enumerable: true,
        get: property.get && property.get.bind(me),
        set: property.set && property.set.bind(me)
      });
    } else {
      plugInto[fnName] = me[fnName].bind(me);
    }
  } //endregion
  //region Chaining

  /**
   * Chains functions. When the function is called on the target class all functions in the chain will be called in
   * the order they where added.
   * @private
   * @param plugInto
   * @param intoName
   * @param hookName
   * @param after
   */


  chain(plugInto, intoName, hookName, after = true) {
    const me = this,
          chains = plugInto.pluginFunctionChain || (plugInto.pluginFunctionChain = {}),
          hookFn = me[hookName] && me[hookName].bind(me),
          // Grab the fn so that we won't need our this pointer to call it. This is due
    // to this instance possibly being destroyed by the time a chain call is made.
    functionChainRunner = me.functionChainRunner;

    if (!hookFn) {
      throw new Error(`Trying to chain fn ${plugInto.$$name}#${hookName}, but plugin fn ${me.$$name}#${hookName} does not exist`);
    }

    if (!chains[intoName]) {
      let intoFn = plugInto[intoName];

      if (intoFn) {
        intoFn = intoFn.bind(plugInto);
        intoFn.$this = plugInto;
      }

      chains[intoName] = intoFn ? [intoFn] : [];

      plugInto[intoName] = (...params) => functionChainRunner(chains[intoName], params);
    }

    hookFn.$this = me;
    chains[intoName][after ? 'push' : 'unshift'](hookFn);
  }
  /**
   * Used to run multiple plugged in functions with the same name, see chain above. Returning false from a
   * function will abort chain.
   * @private
   * @param {Array} chain
   * @param {Array} params
   * @returns value returned from last function in chain (or false if any returns false)
   */


  functionChainRunner(chain, params) {
    // NOTE: even though we are an instance method, we must not use our "this" pointer
    // since our instance may be destroyed. We cope with that by receiving parameters
    // for everything we need (so we're just a pure function).
    let fn, i, returnValue; // changed from for..of to try and fix Edge problems

    for (i = 0; i < chain.length; i++) {
      fn = chain[i]; // Feature hooks remain in place even after GridBase loops and destroys its
      // features, so skip over any destroyed features on the chain. In particular,
      // bindStore hooks will be called when GridBase sets store to null.

      if (!fn.$this.isDestroyed) {
        returnValue = fn(...params);

        if (returnValue === false) {
          break;
        }
      }
    }

    return returnValue;
  } //endregion

  /**
   * Called when disabling/enabling the plugin/feature, not intended to be called directly. To enable or disable a
   * plugin/feature, see {@link #property-disabled}.
   *
   * By default removes the cls of the plugin from its client. Override in subclasses to take any other actions necessary.
   */


  doDisable(disable) {
    const me = this,
          {
      constructor
    } = me,
          cls = 'featureClass' in constructor ? constructor.featureClass : `b-${constructor.$$name.toLowerCase()}`; // Some features do not use a cls

    if (cls) {
      var _me$client, _me$client$element;

      (_me$client = me.client) === null || _me$client === void 0 ? void 0 : (_me$client$element = _me$client.element) === null || _me$client$element === void 0 ? void 0 : _me$client$element.classList[disable ? 'remove' : 'add'](cls);
    }

    if (!me.isConfiguring) {
      if (disable) {
        /**
         * Fired when the plugin/feature is disabled.
         * @event disable
         * @param {Core.mixin.InstancePlugin} source
         */
        me.trigger('disable');
      } else {
        /**
         * Fired when the plugin/feature is enabled.
         * @event enable
         * @param {Core.mixin.InstancePlugin} source
         */
        me.trigger('enable');
      }
    }
  }

  updateDisabled(disabled) {
    this.doDisable(disabled);
  }

  throwOverrideIsMissing(data) {
    throw new Error(`Trying to override fn ${data.plugIntoName}#${data.fnName}, but plugin fn ${data.pluginName}#${data.fnName} does not exist`);
  } // Convenience method to read the rootElement from the owner widget


  get rootElement() {
    return this.client.rootElement;
  }

}
InstancePlugin._$name = 'InstancePlugin';

/***/ }),

/***/ "./lib/Core/mixin/LoadMaskable.js":
/*!****************************************!*\
  !*** ./lib/Core/mixin/LoadMaskable.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Core/mixin/LoadMaskable
 */

/**
 * Simple mixin for load masking configs and helper methods.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class LoadMaskable extends Target {
  static get $name() {
    return 'LoadMaskable';
  }

  static get configurable() {
    return {
      /**
       * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
       * when data is loading. The message and optional configuration from the
       * {@link Core.mixin.LoadMaskable#config-loadMask} config take priority over these options, just as they do
       * for `maskDefaults`, respectively.
       *
       * The final mask configuration for a load mask is as if the following were applied:
       *
       * ```
       *  Object.assign({},
       *      widget.maskDefaults,
       *      widget.loadMaskDefaults,
       *      widget.loadMask);
       * ```
       * @config {Object|Core.widget.Mask}
       * @category Masking
       */
      loadMaskDefaults: {
        useTransition: true,
        showDelay: 1000
      },

      /**
       * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
       * when an error occurs loading data.
       *
       * The final mask configuration for an error mask is as if the following were applied:
       *
       * ```
       *  Object.assign({},
       *      widget.maskDefaults,
       *      widget.loadMaskDefaults,
       *      widget.loadMaskError,
       *      errorMessage);
       * ```
       * @config {Object|Core.widget.Mask}
       * @category Masking
       */
      loadMaskError: {
        icon: 'b-icon b-icon-warning',
        autoClose: 3000,
        showDelay: 0
      },

      /**
       * A {@link Core.widget.Mask} config object, or a message to be shown when a store is performing a remote operation,
       * or Crud Manager is loading data from the sever. Set to `null` to disable default load mask.
       *
       * @config {String|Object|null}
       * @default "Loading..."
       * @category Masking
       */
      loadMask: {
        text: 'L{GridBase.loadMask}'
      },

      /**
       * A {@link Core.widget.Mask} config object, or a message to be shown when Crud Manager
       * is persisting changes on the server. Set to `null` to disable default sync mask.
       *
       * This config is similar to {@link Core.mixin.LoadMaskable#config-loadMask} but designed for saving data.
       *
       * To create a custom sync mask need to subscribe to the Crud Manager events and show
       * {@link Core.widget.Mask Mask} on `beforeSend` and hide it on `requestDone` and `requestFail`.
       *
       * To create a custom sync mask, set this config to `null` and subscribe to the CrudManager's events to
       * show or hide the {@link Core.widget.Widget#config-masked mask} as desired.
       *
       * ```javascript
       *  widget.crudManager.on({
       *      loadStart() {
       *          widget.masked = {
       *              text : 'Data is loading...'
       *          };
       *      },
       *      load() {
       *          widget.masked = null;
       *      },
       *      loadCanceled() {
       *          widget.masked = null;
       *      },
       *      syncStart() {
       *          widget.masked = null;
       *      },
       *      sync() {
       *          widget.masked = null;
       *      },
       *      syncCanceled() {
       *          widget.masked = null;
       *      },
       *      requestFail({ response }) {
       *          widget.masked.error = response.message || 'Sync failed';
       *      }
       *  });
       *
       *  store.load();
       * ```
       *
       * @config {String|Object|null}
       * @default "Saving changes, please wait..."
       * @category Masking
       */
      syncMask: {
        text: 'L{GridBase.syncMask}'
      },
      localizableProperties: ['loadMask.text', 'syncMask.text']
    };
  }
  /**
   * Applies the {@link Core.mixin.LoadMaskable#config-loadMask} as the {@link Core.widget.Widget#config-masked mask}
   * for this widget.
   * @internal
   */


  applyLoadMask() {
    const me = this,
          {
      loadMask
    } = me;

    if (loadMask) {
      me.masked = _widget_Mask_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeConfigs(me.loadMaskDefaults, loadMask);
    }
  }
  /**
   * Updates the current {@link Core.widget.Widget#config-masked mask} for this widget to present the specified
   * `error`.
   * @param {String} error The error message to display in the mask.
   * @internal
   */


  applyMaskError(error) {
    const {
      loadMaskError,
      masked
    } = this;

    if (masked) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(masked.errorDefaults, loadMaskError);
      masked.error = error;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Override.js":
/*!************************************!*\
  !*** ./lib/Core/mixin/Override.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Override; });
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';

/**
 * @module Core/mixin/Override
 */

const excludedPropNames = {
  constructor: 1,
  prototype: 1,
  name: 1,
  length: 1,
  arguments: 1,
  caller: 1,
  callee: 1,
  __proto__: 1
};
/**
 * Simplifies overriding class methods by allowing methods from another class to be used as overrides.
 * Overrides are defined as own classes. They must at a minimum contain a static getter named targetClass, which
 * should return the class to override. Apply the override by calling {@link #function-apply-static apply()}.
 *
 * @example
 * class TemplateColumnOverride {
 *   static get target() {
 *     return {
 *             class: TemplateColumn,
 *             product: 'grid',
 *             minVersion: '1.0',
 *             maxVersion: '1.5'
 *     }
 *   }
 *
 *   renderer(renderData) {
 *       // call overridden function (optional)
 *       const value = this._overridden.renderer.call(this, renderData);
 *
 *       return 'HELLO' + value;
 *   }
 * }
 * Override.apply(TemplateColumnOverride);
 */

class Override {
  /**
   * Apply override. We strongly suggest that you at least specify a maxVersion for your overrides.
   * ```
   * class OriginalOverride {
   *     static get target() {
   *         return {
   *             class: Original,
   *             product: 'grid',
   *             minVersion: '1.0',
   *             maxVersion: '1.5'
   *         }
   *     }
   * }
   * ```
   * @param {Object} override An override class definition
   */
  static apply(override) {
    if (!override.target) throw new Error('Override must specify what it overrides, using static getter target');
    if (!override.target.class) throw new Error('Override must specify which class it overrides, using target.class');
    if (!this.shouldApplyOverride(override)) return false;
    const staticKeys = Object.getOwnPropertyNames(override),
          instanceKeys = Object.getOwnPropertyNames(override.prototype);
    staticKeys.splice(staticKeys.indexOf('target'), 1);
    this.internalOverrideAll(override.target.class, staticKeys, override);
    this.internalOverrideAll(override.target.class.prototype, instanceKeys, override.prototype);
    return true;
  }

  static internalOverrideAll(targetClass, properties, overrideDefinition) {
    Reflect.ownKeys(overrideDefinition).forEach(key => {
      if (properties.includes(key) && !excludedPropNames[key]) {
        const desc = Object.getOwnPropertyDescriptor(overrideDefinition, key);
        let currentTargetClass = targetClass;
        let targetProperty = null; // Walk up the prototype chain to find fn, needed for mixin overrides applied to class that has them
        // mixed in

        while (!targetProperty && currentTargetClass) {
          targetProperty = Object.getOwnPropertyDescriptor(currentTargetClass, key);

          if (!targetProperty) {
            currentTargetClass = Object.getPrototypeOf(currentTargetClass);
          }
        }

        if (targetProperty) {
          this.internalOverride(currentTargetClass, key, desc, targetProperty);
        }
      }
    });
  }

  static internalOverride(target, key, desc, targetDesc) {
    const overrides = target._overridden = target._overridden || {};
    overrides[key] = target[key];

    if (targetDesc.get) {
      Object.defineProperty(target, key, {
        enumerable: false,
        configurable: true,
        get: desc.get
      });
    } else {
      target[key] = desc.value;
    }
  }
  /**
   * Checks versions if an override should be applied. Specify version in your overrides target config
   * @param override
   * @returns {Boolean}
   * @example
   * class OriginalOverride {
   *     static get target() {
   *         return {
   *             class: Original,
   *             product: 'grid',
   *             minVersion: '1.0',
   *             maxVersion: '1.5'
   *         }
   *     }
   * }
   * @private
   */


  static shouldApplyOverride(override) {
    const config = override.target; // not using versioning, allow override

    if (!config.maxVersion && !config.minVersion) return true; // must specify product to be able to lookup versions

    if (!config.product) throw new Error('Override must specify product when using versioning'); // override is for older version, disallow

    if (config.maxVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][config.product].isNewerThan(config.maxVersion)) {
      return false;
    } // override is for newer version, disallow


    if (config.minVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][config.product].isOlderThan(config.minVersion)) {
      return false;
    } // override is for current version, allow


    return true;
  }

}
Override._$name = 'Override';

/***/ }),

/***/ "./lib/Core/mixin/Pluggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Pluggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
var productName = 'gantt';


/**
 * @module Core/mixin/Pluggable
 */

/**
 * Enables using plugins for a class by specifying property plugins as an array of plugin classes. If only a single plugin
 * is used, just give the plugin class instead of an array. This class isn't required for using plugins, just makes it
 * easier. Without mixin you can otherwise use `InstancePlugin.initPlugins(this, PluginClass)`.
 *
 * @example
 * new Store({
 *   plugins: [PluginClass, ...]
 * });
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Pluggable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Pluggable';
  }
  /**
   * Specify plugins (an array of classes) in config
   * @config {Function[]} plugins
   * @category Misc
   */

  /**
   * Map of applied plugins
   * @property {Object}
   * @readonly
   * @category Misc
   */


  get plugins() {
    if (!this._plugins) {
      this._plugins = {};
    }

    return this._plugins;
  }

  set plugins(plugins) {
    if (plugins) {
      if (!Array.isArray(plugins)) plugins = [plugins];
      _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"].initPlugins(this, ...plugins);
    }

    this.initPlugins();
  }
  /**
   * Template method which may be implemented in subclasses to initialize any plugins.
   * This method is empty in the `Pluggable` base class.
   * @internal
   */


  initPlugins() {}
  /**
   * Adds plugins to an instance.
   * @param {Function[]} plugins The plugins to add
   */


  addPlugins(...plugins) {
    _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"].initPlugins(this, ...plugins);
  }
  /**
   * Checks if instance has plugin.
   * @param {String|Function} pluginClassOrName Plugin or name to check for
   * @returns {Boolean}
   */


  hasPlugin(pluginClassOrName) {
    return this.getPlugin(pluginClassOrName) != null;
  }
  /**
   * Get a plugin instance.
   * @param {String|Function} pluginClassOrName
   * @returns {Object}
   */


  getPlugin(pluginClassOrName) {
    if (typeof pluginClassOrName === 'function') pluginClassOrName = pluginClassOrName.$$name;
    return this.plugins && this.plugins[pluginClassOrName];
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/State.js":
/*!*********************************!*\
  !*** ./lib/Core/mixin/State.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/mixin/State
 */

/**
 * Mixin that simplifies handling state for an ui component. Classes that uses this mixin must implement `getState()` and
 * `applyState(state)`.
 *
 * ```
 * class MyUIComponent extends State() {
 *   getState() {
 *     return {
 *       this.text,
 *       this.size
 *     }
 *   }
 *
 *   applyState(state) {
 *      this.text = state.text;
 *      this.size = state.size;
 *   }
 * }
 * ```
 *
 * @demo Grid/state
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class State extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'State';
  } //getState() {}
  //applyState(State) {}

  /**
   * Gets or sets a component's state
   * @property {Object}
   * @category Misc
   */


  get state() {
    this._state = this.getState();
    return this._state;
  }

  set state(state) {
    this._state = state;
    this.applyState(state);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/util/Animator.js":
/*!***********************************!*\
  !*** ./lib/Core/util/Animator.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Animator; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
var productName = 'gantt';





/**
 * @module Core/util/Animator
 */

const {
  assign
} = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"],
      now = () => performance.now(),
      nostart = {
  start: false
},
      unitRe = /^[.\d]+([^\d].*)?$/,
      getTransitions = element => {
  const $bryntum = element.$bryntum || (element.$bryntum = {});
  return $bryntum.transitions || ($bryntum.transitions = Object.create(null));
},
      milliseconds = (duration, unit) => {
  if (typeof duration === 'string') {
    var _unitRe$exec;

    unit = (_unitRe$exec = unitRe.exec(duration)) === null || _unitRe$exec === void 0 ? void 0 : _unitRe$exec[1];
    duration = parseFloat(duration);
  } // a number could be sec or ms so guess sec if duration is small


  return duration && duration * (unit === 's' || !unit && duration < 10 ? 1000 : 1);
},
      syncTransitions = element => {
  const all = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].values(getTransitions(element)).filter(a => a.completed == null).map(a => a.toString());
  element.style.transition = all.join(', ');
},
      Anim = Target => class Anim extends Target {
  static get prototypeProperties() {
    return {
      _delay: null,
      _duration: null,
      _retain: null,
      _timing: null,
      _unit: null,
      owner: null,
      reverting: null
    };
  }

  constructor(...args) {
    super(...args);
    this.id = ++idSeed;
  }

  start() {
    this.startTime = now();
  }

  get delay() {
    var _ref, _this$_delay, _this$owner;

    return milliseconds((_ref = (_this$_delay = this._delay) !== null && _this$_delay !== void 0 ? _this$_delay : (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.delay) !== null && _ref !== void 0 ? _ref : 0, this.unit);
  }

  set delay(v) {
    this._delay = v;
  }

  get duration() {
    var _this$_duration;

    const {
      owner,
      unit
    } = this;
    return milliseconds((_this$_duration = this._duration) !== null && _this$_duration !== void 0 ? _this$_duration : owner ? owner.duration : Animator.defaultDuration, unit);
  }

  set duration(v) {
    this._duration = v;
  }

  get elapsed() {
    return now() - this.startTime;
  }

  get remaining() {
    return this.duration - this.elapsed;
  }

  get retain() {
    var _this$_retain, _this$owner2;

    return (_this$_retain = this._retain) !== null && _this$_retain !== void 0 ? _this$_retain : (_this$owner2 = this.owner) === null || _this$owner2 === void 0 ? void 0 : _this$owner2.retain;
  }

  set retain(v) {
    this._retain = v;
  }

  get timing() {
    var _this$_timing, _this$owner3;

    return (_this$_timing = this._timing) !== null && _this$_timing !== void 0 ? _this$_timing : (_this$owner3 = this.owner) === null || _this$owner3 === void 0 ? void 0 : _this$owner3.timing;
  }

  set timing(v) {
    this._timing = v;
  }

  get unit() {
    var _this$_unit, _this$owner4;

    return (_this$_unit = this._unit) !== null && _this$_unit !== void 0 ? _this$_unit : (_this$owner4 = this.owner) === null || _this$owner4 === void 0 ? void 0 : _this$owner4.unit;
  }

  set unit(v) {
    this._unit = v;
  }

};

let idSeed = 0;
/**
 * These objects are passed as values in the config object of an `Animator`. The `property` name is the key in the
 * config object.
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      opacity : {
 *          // AnimatorTransition properties
 *      }
 *  });
 * ```
 * The {@link Core.util.Animator#config-items anim.items} array will contain a single `AnimatorTransition` instance.
 *
 * @typedef {Object} AnimatorTransition
 * @property {Number|String} property The name of the style property from the key in the `Animator` config object (in
 * the above example, this will be `'opacity'`).
 * @property {Boolean} completed This readonly property is set to `true` when the transition completes.
 * @property {Number|String} [delay=0] The delay before starting the transition. Numbers less than 10 are assumed to be
 * seconds (instead of milliseconds) unless the `unit` property is specified.
 * @property {Number|String} [duration=200] The duration of the transition. Numbers less than 10 are assumed to be
 * seconds (instead of milliseconds) unless the `unit` property is specified.
 * @property {Number|String} [from] The value from which to start the transition.
 * @property {Boolean} [retain] Set to `true` to retain the style property value after the transition. This defaults to
 * `true` if a {@link Core.util.Animator#config-finalize} function is not specified.
 * @property {String} [timing='ease-in-out'] The transition
 * [timing function](https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function).
 * @property {Number|String} to The final value to which the transition will animate.
 * @property {String} [unit] The duration/delay unit (either `'s'` or `'ms'`).
 * @internal
 */

class AnimatorTransition extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(Anim) {
  static get $name() {
    return 'AnimatorTransition';
  }

  static get prototypeProperties() {
    return {
      element: null,
      property: null,
      from: null,
      to: null,
      completed: null,
      promissory: null,
      reverting: null
    };
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this,
          {
      element,
      transitions
    } = me;
    let {
      property
    } = me;
    [property, me.to] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].unitize(property, me.to);
    me.from = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].unitize(property, me.from)[1];
    me.promissory = new _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_4__["default"]();
    me.property = property;
    const was = transitions[property];
    transitions[property] = me;
    let {
      from
    } = me;

    if (was) {
      // Remember where we come from. If there was an animation running, its "to" value is where we would have
      // been had it completed.
      me.from = was.to;
      from = null;
      was.destroy();
    }

    if (from === null) {
      from = me.getCurrentStyleValue();

      if (!was) {
        me.from = from;
      }
    } // Set transitioning style's initial value


    element.style[property] = from; // then read the style to ensure transition will animate

    me.getCurrentStyleValue();
  }

  doDestroy() {
    const me = this;
    me.finish(false);

    if (me.completed && !me.retain) {
      me.clearStyle();
    }

    super.doDestroy();
  }

  get promise() {
    var _this$promissory;

    return (_this$promissory = this.promissory) === null || _this$promissory === void 0 ? void 0 : _this$promissory.promise;
  }

  get transitions() {
    return getTransitions(this.element);
  }

  clearStyle() {
    this.setStyle('');
  }

  finish(complete) {
    const me = this,
          {
      transitions,
      promissory,
      property
    } = me;

    if (promissory) {
      me.completed = complete;
      me.promissory = null;
      promissory.resolve(complete);

      if (transitions[property] === me) {
        delete transitions[property];

        if (!complete) {
          // if we are the current transition, this destroy is a cancellation of the animation (not a
          // revert), so remove our transition and clear the style to reset the element.
          syncTransitions(me.element);
          me.clearStyle();
        }
      } else {
        me.completed = false; // this can most likely never happen, but better to be safe
      }
    }
  }

  getCurrentStyleValue() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(this.element, this.property);
  }

  revert() {
    const {
      duration,
      elapsed,
      element,
      from,
      property,
      _retain: retain,
      _timing: timing
    } = this;
    return new AnimatorTransition({
      element,
      property,
      retain,
      timing,
      duration: Math.round(Math.min(duration, elapsed)),
      reverting: this,
      to: from,
      unit: 'ms'
    });
  }

  setStyle(value) {
    this.element.style[this.property] = value;
  }

  start() {
    const me = this,
          {
      delay,
      duration,
      element,
      property
    } = me;
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
      element,
      property,
      duration: delay + duration + 20,
      thisObj: me.owner,
      handler: () => {
        var _me$finish;

        return (_me$finish = me.finish) === null || _me$finish === void 0 ? void 0 : _me$finish.call(me, true);
      } // finish() is gone if destroyed

    });
    super.start();
    me.setStyle(me.to);
  }

  toString() {
    const {
      delay,
      duration,
      property,
      timing
    } = this;
    return `${property} ${duration}ms ${timing || 'ease-in-out'}${delay ? ` ${delay}ms` : ''}`;
  }

}

AnimatorTransition.initClass();
/**
 * Manages one or more {@link AnimatorTransition style transitions} or other `Animator` instances. Unlike typical
 * config objects, the config object for this class is a mixture of config properties and style names that define
 * {@link AnimatorTransition style transitions}.
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      duration : 500,
 *
 *      // style transitions:
 *      opacity : 0
 *  });
 *
 *  await anim.done();
 * ```
 *
 * The static {@link #function-run-static} method is typically used (as above) instead of the `new Animator()` style for
 * brevity (since a manually created `Animator` must also be manually {@link #function-start started}).
 *
 * An `Animator` can be {@link #function-done awaited} and will resolve once all of its transitions and/or child
 * animations complete or are aborted (via `destroy()`).
 *
 * ## Compound Transitions
 * The following custom transitions can present in the `Animator` config object as if they were normal style transitions:
 *
 * - {@link #function-puff-static}
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      marginLeft : -200,
 *      puff       : true   // true for default scale, a number, or config object
 *  });
 * ```
 * @extends Core/Base
 * @internal
 */

class Animator extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(Anim) {
  static get $name() {
    return 'Animator';
  }

  static get prototypeProperties() {
    return {
      /**
       * The optional delay before starting the animation. Numbers less than 10 are assumed to be seconds
       * (instead of milliseconds) unless the `unit` property is specified.
       * @config {Number|String} delay
       */

      /**
       * The duration of the animation. Numbers less than 10 are assumed to be seconds (instead of milliseconds)
       * unless the `unit` property is specified.
       * @config {Number|String} duration
       * @default
       */

      /**
       * The element to animate.
       * @config {HTMLElement} element
       */
      element: null,

      /**
       * A callback function called when the animation completes. This is called after restoring styles to the
       * original values (based on {@link #config-retain}). When this function is provided, `retain` defaults to
       * `false`. By implementing this function, a CSS class can be applied to the {@link #config-element} to
       * give the proper style, while the inline styles are removed (e.g., a hide animation based on opacity).
       *
       * For example:
       * ```javascript
       *  const anim = Animator.run({
       *      element,
       *      duration : 500,
       *      opacity  : 0,
       *
       *      finalize() {
       *          element.classList.add('hidden');
       *      }
       *  });
       *
       *  await anim.done();
       * ```
       * @config {Function} finalize
       */
      finalize: null,

      /**
       * A callback function called when the animation completes. This is called prior to restoring styles to the
       * original values (based on {@link #config-retain}).
       * @config {Function} prefinalize
       * @internal
       */
      prefinalize: null,

      /**
       * Set to `true` to retain the style property values after the animation. This defaults to `true` if a
       * {@link #config-finalize} function is not specified, and `false` otherwise. When a `finalize` function
       * is provided, it is typically to apply a CSS class to achieve the desired styling so that inline styles
       * can be removed.
       * @config {Boolean} retain
       */

      /**
       * The [timing function](https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function) for
       * the animation.
       * @config {String} timing
       * @default 'ease-in-out'
       */

      /**
       * The duration/delay unit (either `'s'` or `'ms'`).
       * @config {String} unit
       */

      /**
       * This readonly property is set to `true` when the animation completes or `false` if the animation is
       * aborted (by calling the `destroy()` method).
       * @member {Boolean} completed
       * @readonly
       */
      completed: null,

      /**
       * An array containing a mixture of `Animator` and/or `AnimatorTransition` objects, depending on what was
       * specified at construction time.
       * @member {Core.util.Animator[]|AnimatorTransition[]} items
       * @readonly
       */

      /**
       * When passed at construction time, `items` can be an array of other `Animator` config objects. This can be
       * used to animate multiple elements and wait for this instance to be {@link #function-done done}.
       * @config {Core.util.Animator[]} items
       */
      items: null
    };
  }

  static register(name, fn) {
    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(name)) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].entries(name).forEach(entry => Animator.register(...entry));
      return;
    }

    Animator.fx[name] = fn;

    Animator[name] = options => {
      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isElement(options)) {
        options = {
          element: options,
          [name]: {}
        };
      } else {
        options = {
          element: options.element,
          [name]: options
        };
        delete options[name].element;
      }

      return Animator.run(options);
    };
  }
  /**
   * A short-hand way to create an `Animator` instance and call its {@link #function-start} method.
   *
   * ```javascript
   *  const anim = Animator.run({
   *      element,
   *      duration : 500,
   *
   *      // style transitions:
   *      opacity : 0
   *  });
   *
   *  await anim.done();
   * ```
   * @param {Core.util.Animator|Object} options A config object for an `Animator` instance.
   * @returns {Core.util.Animator}
   */


  static run(options) {
    return new Animator(options).start();
  }

  constructor(options) {
    var _me$items;

    super(null); // our options is not like a normal config object since is has styles mixed in w/configs

    const me = this,
          items = [],
          properties = {};
    let anim, fx, key, t;

    if (Array.isArray(options)) {
      me.items = options;
    } else {
      for (key in options) {
        (Animator.specialPropsRe.test(key) ? me : properties)[key] = options[key];
      }
    }

    _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].keys(properties).forEach(property => {
      t = properties[property]; // ignore values of null, undefined, false and NaN (NaN !== NaN)

      if (t != null && t !== false && t === t) {
        // eslint-disable-line no-self-compare
        if (!(fx = Animator.fx[property])) {
          t = assign(me.defaults, typeof t === 'object' ? t : {
            to: t
          });
          t.owner = me;
          t.property = property;
          anim = new AnimatorTransition(t);
        } else {
          t = assign(me.defaults, fx(t, me, property));
          t.owner = me;
          anim = new Animator(t);
        }

        items.push(anim);
      }
    }); // me.items can be set if options was an array or if options.items was passed.

    (_me$items = me.items) === null || _me$items === void 0 ? void 0 : _me$items.forEach(item => {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isInstantiated(item)) {
        item.owner = me;
      } else {
        item = assign(me.defaults, item);
        item.owner = me;
        item = new Animator(item);
      }

      items.push(item);
    });
    me.items = items;
    me.promise = (items.length === 1 ? items[0].promise : Promise.all(items.map(it => it.promise))).then(res => {
      var _me$finish2;

      (_me$finish2 = me.finish) === null || _me$finish2 === void 0 ? void 0 : _me$finish2.call(me, res);
      return me.completed || false;
    });
  }

  doDestroy() {
    this.items.forEach(a => a.destroy());
    super.doDestroy();
  }

  get defaults() {
    return {
      element: this.element
    };
  }

  get retain() {
    const {
      _retain,
      finalize,
      owner
    } = this;
    return _retain !== null && _retain !== void 0 ? _retain : finalize ? false : owner ? owner.retain : true;
  }

  set retain(v) {
    super.retain = v;
  }
  /**
   * Returns a `Promise` that resolves to a `Boolean` when this animation completes. The resolved value is that of
   * this instance's {@link #property-completed} property.
   * @returns {Promise}
   * @async
   */


  done() {
    return this.promise;
  }

  finish(complete) {
    var _me$prefinalize, _me$finalize;

    const me = this,
          {
      items
    } = me;
    syncTransitions(me.element);
    me.completed = typeof complete === 'boolean' ? complete : !complete.some(a => !a);
    (_me$prefinalize = me.prefinalize) === null || _me$prefinalize === void 0 ? void 0 : _me$prefinalize.call(me, me.completed, me);

    while (items.length) {
      items.pop().destroy();
    }

    (_me$finalize = me.finalize) === null || _me$finalize === void 0 ? void 0 : _me$finalize.call(me, me.completed, me);
  }

  revert(options) {
    var _options$start;

    const me = this,
          {
      reverting
    } = me,
          start = !options || ((_options$start = options.start) !== null && _options$start !== void 0 ? _options$start : true);
    let anim = me.defaults;

    if (reverting) {
      // If this anim is a revert of some previous anim and that anim had a finalizer, then reverting us should
      // (by default) carry forward the original finalizer:
      if (reverting.finalize) {
        anim.finalize = reverting.finalize;
      }

      if (reverting.prefinalize) {
        anim.prefinalize = reverting.prefinalize;
      }

      anim.retain = reverting._retain;
    }

    anim = assign(anim, options, {
      items: me.items.map(it => it.revert(nostart)),
      reverting: me
    });
    anim = new Animator(anim);
    start && anim.start();
    return anim;
  }
  /**
   * Starts this animation and returns a reference to itself. This method is called automatically by the
   * {@link #function-run-static} method.
   * @returns {Core.util.Animator}
   */


  start() {
    const {
      element,
      items
    } = this;
    super.start();

    if (items.length) {
      syncTransitions(element);
      items.forEach(a => a.start());
    }

    return this;
  }

}
Animator.initClass().Transition = AnimatorTransition;
Animator.specialPropsRe = new RegExp(`^(?:${Object.keys(Animator.prototypeProperties).concat(Object.keys(Animator.superclass.prototypeProperties)).map(s => s[0] === '_' ? s.substr(1) : s).join('|')})$`);
Animator.defaultDuration = 200;
Animator.fx = {};
Animator.register({
  /**
   * A compound animation to achieve `transform: scale()` and `opacity: 0`. The `scale` defaults to 8 but can be set
   * in the `anim` config object.
   *
   * For example
   * ```javascript
   *  const puff = Animator.puff(element);
   *
   *  const puff = Animator.puff({
   *      element,
   *      scale : 12
   *  });
   * ```
   *
   * This compound animation can also be specified in an `Animator` config object along with other style transitions:
   * ```javascript
   *  const anim = Animator.run({
   *      element,
   *      marginLeft : -200,
   *      puff       : true   // true for default scale, a number, or config object
   *  });
   * ```
   * @param {Element|Object|Core.util.Animator} anim The element to animate or the config object containing at least
   * the `element` property. This config object can contain an optional `scale` property to adjust the animation's
   * `transform: scale()` value.
   * @param {Number} [anim.scale=8] The scale value for the `transform:scale()` transition.
   * @returns {Core.util.Animator}
   * @static
   */
  puff(anim) {
    if (anim === true) {
      anim = {};
    } else if (typeof anim !== 'object') {
      // string || number
      anim = {
        transform: `scale(${anim})`
      };
    } else if (anim.scale) {
      anim = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(anim);
      anim.transform = `scale(${anim.scale})`;
      delete anim.scale;
    }

    return assign({
      opacity: 0,
      transform: 'scale(8)'
    }, anim);
  }

});
Animator._$name = 'Animator';

/***/ }),

/***/ "./lib/Core/util/Bag.js":
/*!******************************!*\
  !*** ./lib/Core/util/Bag.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Bag; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Collection.js */ "./lib/Core/util/Collection.js");
var productName = 'gantt';


const nonPrimitives = new WeakMap(),
      safeIndexKey = value => {
  if (value && typeof value === 'object') {
    let substitute = nonPrimitives.get(value);

    if (substitute === undefined) {
      substitute = Symbol('bscik'); // Bryntum safe collection index key

      nonPrimitives.set(value, substitute);
    }

    value = substitute;
  }

  return value;
};
/**
 * @module Core/util/Bag
 */

/**
 * A simple collection class to contain unique, keyed items.
 * @internal
 */


class Bag {
  constructor(config) {
    const me = this;
    me.generation = 0;
    me.items = new Set();
    me.idMap = {};
    me.idProperty = 'id';

    if (config) {
      if (config.idProperty) {
        me.idProperty = config.idProperty;
      }

      if (config.values) {
        me.values = config.values;
      }
    }
  }
  /**
   * Returns the item with the passed `id`.
   *
   * @param {*} id The `id` to find.
   * @returns {Object} The found item, or `undefined`.
   */


  get(key) {
    return this.idMap[safeIndexKey(key)];
  }
  /**
   * The number of items in this Bag.
   * @property {Number}
   * @readonly
   */


  get count() {
    return this.items.size;
  }
  /**
   * Adds the passed item(s) to this Bag. Existing items with the same ID
   * will be replaced.
   * @param {Object|Object[]} toAdd Item(s) to add.
   */


  add(...toAdd) {
    if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
      toAdd = toAdd[0];
    }

    const me = this,
          {
      items,
      idMap,
      idProperty
    } = me,
          len = toAdd.length;

    for (let i = 0; i < len; i++) {
      const item = toAdd[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Not already present

      if (existingItem == null) {
        idMap[key] = item;
        items.add(item);
        me.generation++;
      } // Already present, replace it if different. No generational change.
      // IDs rule.
      else if (existingItem !== item) {
        idMap[key] = item;
        items.delete(existingItem);
        items.add(item);
      }
    }
  }
  /**
   * Removes the passed item(s) from this Bag.
   * @param {Object|Object[]} toRemove Item(s) to remove.
   */


  remove(toRemove) {
    if (!Array.isArray(toRemove)) {
      toRemove = [toRemove];
    }

    const {
      items,
      idMap,
      idProperty
    } = this,
          len = toRemove.length;

    for (let i = 0; i < len; i++) {
      const item = toRemove[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Found natch, so delete it

      if (existingItem != null) {
        items.delete(existingItem);
        delete idMap[key];
        this.generation++;
      }
    }
  }

  clear() {
    this.items.clear();
    this.idMap = {};
    this.generation++;
  }
  /**
   * Returns the number of items in this Bag which elicits a truthy return value from the passed function.
   * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
   * @returns {Number} The number of matched items.
   */


  countOf(fn) {
    let ret = 0,
        item;

    for (item of this.items) {
      if (fn(item)) {
        ++ret;
      }
    }

    return ret;
  }
  /**
   * Change the id of an existing member by mutating its idProperty.
   * @param {String|Number|Object} item The item or id of the item to change.
   * @param {String|Number} newId The id to set in the existing member.
   */


  changeId(item, newId) {
    const me = this,
          {
      idMap,
      idProperty
    } = me,
          oldId = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
          member = me.get(oldId);

    if (member) {
      const existingMember = me.get(newId);

      if (existingMember && member !== existingMember) {
        throw new Error(`Attempt to set item ${oldId} to already existing member's id ${newId}`);
      }

      member[idProperty] = newId;
      delete idMap[oldId];
      idMap[newId] = member;
    }
  }
  /**
   * Returns `true` if this Collection includes an item with the same `id` as the passed item.
   *
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @returns {Boolean} True if the passed item is found.
   */


  includes(item) {
    const key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[this.idProperty]);
    return Boolean(this.idMap[key]);
  }
  /**
   * Extracts the content of this Bag into an array based upon the passed
   * value extraction function.
   * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
   * @param {Object} [thisObj] The `this` reference when the function is called.
   * @returns {Object[]} An array of values extracted from this Bag.
   */


  map(fn, thisObj) {
    const {
      items
    } = this,
          result = new Array(items.size); // Set has no map

    let i = 0;
    items.forEach(item => {
      result[i] = fn.call(thisObj, item, i++, items);
    });
    return result;
  }
  /**
   * Executes the passed function for each item in this Bag, passing in the item.
   * @param {Function} fn The function to execute.
   * @param {Object} [thisObj] The `this` reference when the function is called.
   */


  forEach(fn, thisObj) {
    return this.items.forEach(fn, thisObj);
  }
  /**
   * Returns `nth` item in this Bag which elicits a truthy return value from the provided matcher function `fn`.
   * @param {Function} fn A function which, when passed an item, returns `true` to select the item as a match.
   * @param {Number} [nth=0] The index of the matching item. By default, 0 returns the first item that matches
   * according to `fn`. Negative numbers index for the last item. For example, -1 returns the last matching item,
   * -2 the 2nd to last matching item etc..
   * @returns {Object} The matched item, or `undefined`.
   */


  find(fn, nth = 0) {
    let item, ret;

    if (nth < 0) {
      nth = this.countOf(fn) + nth; // ex: count=10 ... -1 -> 9, -2 -> 8, -3 -> 7, ... -9 -> 1, -10 -> 0
    }

    for (item of this.items) {
      if (fn(item) && !nth--) {
        ret = item;
        break;
      }
    }

    return ret;
  }
  /**
   * Iterator that allows you to do for (let item of bag)
   */


  [Symbol.iterator]() {
    return this.items[Symbol.iterator]();
  }

  indexOf(item, matchFn) {
    let index = -1,
        it;

    for (it of this.items) {
      if (!matchFn || matchFn(it)) {
        ++index;

        if (it === item) {
          return index;
        }
      }
    }

    return -1;
  }
  /**
   * The set of values of this Bag.
   *
   * Setting this property replaces the data set.
   * @property {Object[]}
   */


  get values() {
    return [...this.items];
  }

  set values(values) {
    if (!Array.isArray(values)) {
      values = [values];
    }

    this.clear();
    this.add.apply(this, values);
    this.generation++;
  }
  /**
   * Sort the values of this Bag using the passed comparison function.
   *
   * Setting this property replaces the data set.
   * @param {Function} fn Comparison function which returns -ve, 0, or +ve
   */


  sort(fn) {
    this.values = this.values.sort(fn);
  }

  some(fn, thisObj) {
    return this.values.some(fn, thisObj);
  }

}
Bag._$name = 'Bag';

/***/ }),

/***/ "./lib/Core/util/ClickRepeater.js":
/*!****************************************!*\
  !*** ./lib/Core/util/ClickRepeater.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ClickRepeater; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';




/**
 * @module Core/util/ClickRepeater
 */

/**
 * A helper class, which, when applied to an {@link #config-element} means that a mousedown
 * and hold on that element will, after a configured {@link #config-delay}, begin
 * autorepeating `click` events on that element, starting at a rate of
 * {@link #config-startRate} clicks per second, and over {@link #config-accelerateDuration}
 * milliseconds, accelerate to firing clicks at {@link #config-endRate} times per second.
 *
 * An example of this is used by the {@link Core.widget.NumberField NumberField}'s
 * spinner triggers.
 */

class ClickRepeater extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get configurable() {
    return {
      /**
       * The element on which to fire autorepeating `click` events when the mouse is held down.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * A query selector which specifies subtargets of this ClickRepeater's {@link #config-element}
       * which act as the click auto repeat event targets.
       * @config {String}
       * @default
       */
      delegate: null,

      /**
       * How long in milliSeconds to pause before starting the click repeats.
       * @config {Number}
       * @default
       */
      delay: 500,

      /**
       * Clicks per second to start firing after the initial {@link #config-delay}
       * @config {Number}
       * @default
       */
      startRate: 2,

      /**
       * Clicks per second to fire at top speed, after accelerating over the {@link #config-accelerateDuration}
       * @config {Number}
       * @default
       */
      endRate: 20,

      /**
       * How long in milliseconds to accelerate from the
       * {@link #config-startRate} to the {@link #config-startRate}.
       * @config {Number}
       * @default
       */
      accelerateDuration: 4000,
      pressedCls: 'b-pressed'
    };
  }

  doDestroy() {
    var _this$mousedownRemove;

    (_this$mousedownRemove = this.mousedownRemover) === null || _this$mousedownRemove === void 0 ? void 0 : _this$mousedownRemove.call(this);
    super.doDestroy();
  }

  cancel() {
    var _me$activeElement, _me$acceleration, _me$activeListenerRem;

    const me = this;
    (_me$activeElement = me.activeElement) === null || _me$activeElement === void 0 ? void 0 : _me$activeElement.classList.remove(me.pressedCls);
    me.activeElement = null;
    (_me$acceleration = me.acceleration) === null || _me$acceleration === void 0 ? void 0 : _me$acceleration.cancel();
    me.activeListenerRemover = (_me$activeListenerRem = me.activeListenerRemover) === null || _me$activeListenerRem === void 0 ? void 0 : _me$activeListenerRem.call(me);
    me.clearTimeout('startAutoRepeat');
    me.clearTimeout(me.repeatTimer);
  }

  updateElement(element) {
    var _this$mousedownRemove2;

    (_this$mousedownRemove2 = this.mousedownRemover) === null || _this$mousedownRemove2 === void 0 ? void 0 : _this$mousedownRemove2.call(this);
    this.mousedownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
      element,
      mousedown: 'onMouseDown',
      thisObj: this
    });
  }

  onMouseDown(e) {
    const me = this,
          target = me.delegate ? e.target.closest(me.delegate) : me.element;
    me.cancel();

    if (target) {
      me.activeElement = target;
      me.triggerEvent = e;
      target.classList.add(me.pressedCls);
      me.activeListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        mouseup: {
          element: document,
          handler: 'onMouseUp'
        },
        mousemove: {
          element: target,
          handler: 'onTargetMouseMove'
        },
        mouseleave: {
          element: target,
          handler: 'onTargetMouseLeave'
        },
        mouseenter: {
          element: target,
          handler: 'onTargetMouseEnter'
        },
        thisObj: me
      });
      me.setTimeout('startAutoRepeat', me.delay);
    }
  }

  onMouseUp() {
    this.cancel();
  }

  onTargetMouseLeave() {
    this.activeElement.classList.remove(this.pressedCls);
    this.clearTimeout(this.repeatTimer);
  }

  onTargetMouseEnter(e) {
    const me = this;

    if (!e.buttons) {
      // mostly seen due to breakpoints in click handling, but easy to detect if mouse was released...
      me.cancel();
    } else {
      me.activeElement.classList.add(me.pressedCls);
      me.triggerEvent = e;
      me.fireClick();
    }
  }

  onTargetMouseMove(e) {
    this.triggerEvent = e;
  }

  startAutoRepeat() {
    const me = this;
    me.interval = me.startInterval = 1000 / me.startRate;
    me.accelerationDelta = me.startInterval - 1000 / me.endRate; // Begin animating the interval from 1000/me.startRate to 1000/me.endRate

    me.fireClick();
    me.acceleration = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].animate(me.accelerateDuration, me.nextTick, me, 'easeOutQuad');
  }

  nextTick(progress) {
    this.interval = this.startInterval - this.accelerationDelta * progress;
  }

  fireClick() {
    const me = this,
          clickEvent = new MouseEvent('click', me.triggerEvent);
    me.triggerEvent.target.dispatchEvent(clickEvent);
    me.repeatTimer = me.setTimeout(me.fireClick, me.interval);
  }

}
ClickRepeater._$name = 'ClickRepeater';

/***/ }),

/***/ "./lib/Core/util/Collection.js":
/*!*************************************!*\
  !*** ./lib/Core/util/Collection.js ***!
  \*************************************/
/*! exports provided: default, keyTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Collection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyTypes", function() { return keyTypes; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
var productName = 'gantt';





/**
 * @module Core/util/Collection
 */

const return0 = () => 0,
      reverseNumericSortFn = (a, b) => b - a,
      filteredIndicesProperty = Symbol('filteredIndicesProperty'),
      emptyArray = Object.freeze([]),
      sortEvent = Object.freeze({
  action: 'sort',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
      filterEvent = Object.freeze({
  action: 'filter',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
      keyTypes = {
  string: 1,
  number: 1
}; // Adds a single item to a single index using the specified key


function addItemToIndex(item, index, key) {
  // Unique holds a single entry
  if (index.unique !== false) {
    index.set(key, item);
  } // Non-unique index holds a Set
  else {
    let set = index.get(key); // Add a set if this is the first entry

    if (!set) {
      set = new Set();
      index.set(key, set);
    } // Add entry to the set


    set.add(item);
  }
} // Removes a single item from a single index using the specified key


function removeItemFromIndex(item, index, key) {
  // Unique holds single entry, remove it
  if (index.unique !== false) {
    index.delete(key);
  } else if (index.has(key)) {
    // Remove from set
    index.get(key).delete(item); // Remove turned empty set

    if (!index.get(key).size) {
      index.delete(key);
    }
  }
} // Used to fully build the indices, normal and filtered (if used). Better to do full builds for performance reasons
// when assigning new datasets. For other CRUD operations, indices are kept up to date elsewhere


function doRebuildIndices(values, indices, keyProps, indexCount) {
  for (let i = 0; i < values.length; i++) {
    const item = values[i];

    for (let j = 0; j < indexCount; j++) {
      const keyProp = keyProps[j],
            key = item[keyProp],
            index = indices[keyProp];
      addItemToIndex(item, index, key);
    }
  }
}
/**
 * A class which encapsulates a {@link #function-get keyed},
 * {@link #function-addFilter filterable}, {@link #function-addSorter sortable}
 * collection of objects. Entries may not be atomic data types such as `string` or `number`.
 *
 * The entries are keyed by their `id` which is determined by interrogating the {@link #config-idProperty}.
 *
 * To filter a Collection, add a {@link Core.util.CollectionFilter CollectionFilter}
 * using the {@link #function-addFilter} method. A Filter config object may be specified here
 * which will be promoted to a CollectionFilter instance.
 *
 * To sort a Collection, add a {@link Core.util.CollectionSorter CollectionSorter}
 * using the {@link #function-addSorter} method. A Sorter config object may be specified here
 * which will be promoted to a CollectionSorter instance.
 */


class Collection extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Config
  static get configurable() {
    return {
      /**
       * Specify the name of the property of added objects which provides the lookup key
       * @config {String}
       * @default
       */
      idProperty: 'id',

      /**
       * Specify the names or index configs of properties which are to be indexed for fast lookup.
       *
       * Index configs use the format `{ property : string, unique : boolean }`. Unique indices stores one index
       * per entry, non-unique stores a `Set`. If left out, `unique` defaults to `true`
       *
       * @config {String[]|Object[]}
       */
      extraKeys: null,

      /**
       * Automatically apply filters on item add.
       * @config {Boolean}
       * @default
       */
      autoFilter: true,

      /**
       * Automatically apply sorters on item add.
       * @config {Boolean}
       * @default
       */
      autoSort: true,

      /**
       * A {@link Core.util.CollectionSorter Sorter}, or Sorter config object, or
       * an array of these, to use to sort this Collection.
       * @config {Object[]}
       * @default
       */
      sorters: {
        $config: ['lazy'],
        value: []
      }
    };
  }

  get isCollection() {
    return true;
  } //endregion
  //region Init & destroy


  construct(config) {
    /**
     * A counter which is incremented whenever the Collection is mutated in a meaningful way.
     *
     * If a {@link #function-splice} call results in no net replacement, removal or addition,
     * then the `generation` will not be incremented.
     * @property {Number}
     * @readonly
     */
    this.generation = 0;
    this._values = [];
    super.construct(config);
  }

  doDestroy() {
    var _me$_sorters;

    super.doDestroy();
    const me = this;
    me._values.length = 0;

    if (me.isFiltered) {
      me._filteredValues.length = 0;
      me.filters.destroy();
    } // eslint-disable-next-line no-unused-expressions


    (_me$_sorters = me._sorters) === null || _me$_sorters === void 0 ? void 0 : _me$_sorters.destroy();
  } //endregion
  //region "CRUD"

  /**
   * Clears this collection.
   */


  clear() {
    const me = this,
          removed = me._values.slice();

    if (me.totalCount) {
      me._values.length = 0;

      if (me._filteredValues) {
        me._filteredValues.length = 0;
      }

      me._indicesInvalid = true; // Indicate to observers that data has changed.

      me.generation++;
      me.trigger('change', {
        action: 'clear',
        removed
      });
    }
  }
  /**
   * Replaces the internal `values` array with the passed `values`, or `filteredValues` array with the passed `filteredValues`.
   * If `filteredValues` are not passed explicitly, but storage is filtered, decides internally `values` or `filteredValues` should
   * be replaced by passed `values`.
   *
   * Note that this takes ownership of the array, and the array must not be mutated by outside code.
   *
   * This is an internal utility method, not designed for use by application code.
   *
   * @param {Object} params Values and parameters to replace
   * @param {Object[]} params.values The new `values` array
   * @param {Object[]} [params.filteredValues] The new `filteredValues` array. Applicable only when storage is filtered.
   * @param {Boolean} [params.silent=false] If true, `change` event will not be fired
   * @param {Boolean} [params.isNewDataset=false] If true, `values` is a new dataset
   * @fires change
   * @internal
   */


  replaceValues({
    values,
    filteredValues,
    silent = false,
    isNewDataset = false
  }) {
    const me = this;
    let replacedValues, replacedFilteredValues; // The isNewDataset flag is passed by store#loadData to indicate that it's
    // a new data load, and that local filters can be applied.
    // Other use cases are for purely local updates of an existing dataset such as
    // refreshing the visible data with a values array containing group headers.

    if (me.isFiltered && !isNewDataset) {
      const filteredPassed = Boolean(filteredValues); // If `filteredValues` are missing, take `values` as a source of filtered values

      if (!filteredPassed) {
        filteredValues = values.slice();
        values = null;
      } // otherwise check if non-filtered values are passed together with filtered, and replace them too
      else if (values) {
        replacedValues = me._values;
        me._values = values.slice();
      }

      replacedFilteredValues = me._filteredValues;
      me._filteredValues = filteredValues.slice();
    } else {
      replacedValues = me._values;
      me._values = values.slice();
      filteredValues = null;

      if (me.isFiltered && isNewDataset && me.autoFilter) {
        me._filterFunction = null;
        me._filteredValues = me._values.filter(me.filterFunction);
      } else if (me._filteredValues) {
        me._filteredValues.length = 0;
      }
    }

    me._indicesInvalid = true; // Indicate to observers that data has changed.

    me.generation++;

    if (!silent) {
      me.trigger('change', {
        action: 'replaceValues',
        replacedValues,
        replacedFilteredValues,
        values,
        filteredValues
      });
    }
  }

  set values(values) {
    // Want a full rebuild for new dataset, less costly than doing it per item
    this.invalidateIndices();
    this.splice(0, this._values.length, values);
  }
  /**
   * The set of values of this Collection. If this Collection {@link #property-isFiltered},
   * this yields the filtered data set.
   *
   * Setting this property replaces the data set.
   * @property {Object[]}
   */


  get values() {
    return this.isFiltered ? this._filteredValues : this._values;
  }
  /**
   * Iterator that allows you to do `for (const item of collection)`
   */


  [Symbol.iterator]() {
    return this.values[Symbol.iterator]();
  }
  /**
   * Executes the passed function for each item in this Collection, passing in the item,
   * ths index, and the full item array.
   * @param {Function} fn The function to execute.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to include all items, bypassing filters.
   */


  forEach(fn, ignoreFilters = false) {
    (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).forEach(fn);
  }
  /**
   * Extracts ths content of this Collection into an array based upon the passed
   * value extraction function.
   * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to process an item even if it is filtered out.
   * @returns {Object[]} An array of values extracted from this Collection.
   */


  map(fn, ignoreFilters = false) {
    return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).map(fn);
  }
  /**
   * Returns the first item in this Collection which elicits a *truthy* return value from the passed function.
   * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to include filtered out items.
   * @returns {Object} The matched item, or `undefined`.
   */


  find(fn, ignoreFilters = false) {
    return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).find(fn);
  }

  get first() {
    return this.values[0];
  }

  get last() {
    return this.values[this.count - 1];
  }
  /**
   * The set of all values of this Collection regardless of filters applied.
   * @readonly
   * @property {Object[]}
   */


  get allValues() {
    return this._values;
  }
  /**
   * Adds items to this Collection. Multiple new items may be passed.
   *
   * By default, new items are appended to the existing values.
   *
   * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
   *
   * Any {@link #property-filters} {@link #property-filters} present are re-run.
   *
   * *Note that if application functionality requires add and remove, the
   * {@link #function-splice} operation is preferred as it performs both
   * operations in an atomic manner*
   * @param  {...Object} items The item(s) to add.
   */


  add(...items) {
    if (items.length === 1) {
      this.splice(this._values.length, null, ...items);
    } else {
      this.splice(this._values.length, null, items);
    }
  }
  /**
   * Removes items from this Collection. Multiple items may be passed.
   *
   * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
   *
   * Any {@link #property-filters} {@link #property-filters} present are re-run.
   *
   * *Note that if application functionality requires add and remove, the
   * {@link #function-splice} operation is preferred as it performs both
   * operations in an atomic manner*
   * @param  {...Object} items The item(s) to remove.
   */


  remove(...items) {
    if (items.length === 1) {
      this.splice(0, ...items);
    } else {
      this.splice(0, items);
    }
  }
  /**
   * Moves an individual item, or a block of items to another location.
   * @param {Object|Object[]} items The item/items to move.
   * @param {Object} [beforeItem] the item to insert the first item before. If omitted, the `item`
   * is moved to the end of the Collection.
   * @returns {Number} The new index of the `item`.
   */


  move(items, beforeItem) {
    if (!Array.isArray(items)) {
      items = [items];
    } // Handle the case of move(myItem, myItem). It's a no-op


    while (items.length && items[0] === beforeItem) {
      items.shift();
    }

    if (!items.length) {
      return;
    }

    const me = this,
          {
      _values
    } = me,
          itemIndex = me.indexOf(items[0], true); // move(record, followingrecord) is a no-op

    if (items.length === 1 && _values[itemIndex + 1] === beforeItem) {
      return;
    } // Silently remove the items that are to be inserted before the "beforeItem".


    me.suspendEvents();
    me.remove(items);
    me.resumeEvents();
    const beforeIndex = beforeItem ? me.indexOf(beforeItem, true) : _values.length;

    if (beforeIndex === -1) {
      throw new Error('Collection move beforeItem parameter must be present in Collection');
    }

    _values.splice(beforeIndex, 0, ...items);

    me._indicesInvalid = 1;
    me.trigger('change', {
      action: 'move',
      items,
      from: itemIndex,
      to: beforeIndex
    });
    return beforeIndex;
  }
  /**
   * The core data set mutation method. Removes and adds at the same time. Analogous
   * to the `Array` `splice` method.
   *
   * Note that if items that are specified for removal are also in the `toAdd` array,
   * then those items are *not* removed then appended. They remain in the same position
   * relative to all remaining items.
   *
   * @param {Number} index Index at which to remove a block of items. Only valid if the
   * second, `toRemove` argument is a number.
   * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
   * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
   * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
   */


  splice(index = 0, toRemove, ...toAdd) {
    const me = this,
          idProperty = me.idProperty,
          values = me._values,
          newIds = {},
          removed = [],
          replaced = [],
          oldCount = me.totalCount;
    let added, mutated; // Create an "newIds" map of the new items so remove ops know if it's really a replace
    // {
    //     1234 : true
    // }
    // And an "added" array of the items that need adding (there was not already an entry for the id)
    //

    if (toAdd) {
      if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
        toAdd = toAdd[0];
      } // Check for replacements if we contain any data


      if (oldCount && toAdd.length) {
        // Only risk rebuilding the indices if we are adding
        const idIndex = me.indices[idProperty];
        added = [];

        for (let i = 0; i < toAdd.length; i++) {
          const newItem = toAdd[i],
                id = newItem[idProperty],
                existingItem = idIndex.get(id),
                existingIndex = existingItem ? values.indexOf(existingItem) : -1; // Register incoming id so that removal leaves it be

          newIds[id] = true; // Incoming id is already present.
          // Replace it in place.

          if (existingIndex !== -1) {
            // If incoming is the same object, it's a no-op
            if (values[existingIndex] !== newItem) {
              replaced.push([values[existingIndex], newItem]);
              values[existingIndex] = newItem;
            }
          } else {
            added.push(newItem);
          }
        }
      } // Empty Collection, we simply add what we're passed
      else {
        added = toAdd;
      }
    }

    if (toRemove) {
      // We're removing a chunk starting at index
      if (typeof toRemove === 'number') {
        // Ensure we don't walk off the end if the toRemove count exceeds what we contain
        toRemove = Math.min(toRemove, values.length - index);

        for (let removeIndex = index; toRemove; --toRemove) {
          const id = values[removeIndex][idProperty]; // If the entry here is being replaced, skip the insertion index past it

          if (newIds[id]) {
            index++;
            removeIndex++;
          } // If the id is not among incoming items, remove it
          else {
            removed.push(values[removeIndex]);
            values.splice(removeIndex, 1);
            mutated = true;
          }
        }
      } // We are removing an item/items
      else {
        let contiguous = added.length === 0,
            lastIdx;

        if (!Array.isArray(toRemove)) {
          toRemove = [toRemove];
        } // Create array of index points to remove.
        // They must be in reverse order so that removal leaves following remove indices stable


        const removeIndices = toRemove.reduce((result, item) => {
          const isNumeric = typeof item === 'number',
                idx = isNumeric ? item : me.indexOf(item, true); // Drop out of contiguous mode if we find a non-contiguous record, or a remove *index*

          if (contiguous && (lastIdx != null && idx !== lastIdx + 1 || isNumeric)) {
            contiguous = false;
          } // Do not include indices out of range in our removeIndices


          if (idx >= 0 && idx < oldCount) {
            result.push(idx);
          }

          lastIdx = idx;
          return result;
        }, []).sort(reverseNumericSortFn); // If it's a pure remove of contiguous items with no adds, fast track it.

        if (contiguous) {
          // If reduced to zero by being asked to remove items we do not contain
          // then this is a no-op
          if (removeIndices.length) {
            removed.push.apply(removed, toRemove);
            values.splice(removeIndices[removeIndices.length - 1], removeIndices.length);
            mutated = true;
          }
        } else {
          // Loop through removeIndices splicing each index out of the values
          // unless there's an incoming identical id.
          for (let i = 0; i < removeIndices.length; i++) {
            const removeIndex = removeIndices[i];

            if (removeIndex !== -1) {
              const id = values[removeIndex][idProperty]; // If the id is not among incoming items, remove it

              if (!newIds[id]) {
                removed.unshift(values[removeIndex]);
                values.splice(removeIndex, 1);
                mutated = true;
              }
            }
          }
        }
      } // Update indices only if they have been used


      if (removed.length && !me._indicesInvalid) {
        removed.forEach(me.removeFromIndices, me);
      }
    } // If we collected genuinely new entries, insert them at the splice index


    if (added.length) {
      values.splice(Math.min(index, values.length), 0, ...added);
      mutated = true; // Update indices only if they have been used

      if (!me._indicesInvalid) {
        added.forEach(me.addToIndices, me);
      }
    } // Update indices only if they have been used


    if (replaced.length && !me._indicesInvalid) {
      replaced.forEach(rep => {
        me.removeFromIndices(rep[0]);
        me.addToIndices(rep[1]);
      });
    } // If we either added or removed items, or we did an in-place replace operation
    // then inform all interested parties.


    if (mutated || replaced.length) {
      // Ensure order of values matches the sorters
      if (me.isSorted) {
        me.onSortersChanged();
      } // The sort will also recreate the filteredValues so that it can be in correct sort order
      else if (me.isFiltered) {
        if (me.autoFilter) {
          me.onFiltersChanged();
        } else {
          me._filteredValues.push(...added);
        }
      } // Indicate to observers that data has changed.


      me.generation++;
      /**
       * Fired when items are added, replace or removed
       * @event change
       * @param {String} action The underlying operation which caused data change.
       * May be `'splice'` (meaning an atomic add/remove operation, `'sort'` or `'filter'`)
       * @param {Core.util.Collection} source This Collection.
       * @param {Object[]} removed An array of removed items.
       * @param {Object[]} added An array of added items.
       * @param {Object[]} replaced An array of replacements, each entry of which contains `[oldValue, newValue]`.
       * @param {Number} oldCount The number of items in the full, unfiltered collection prior to the splice operation.
       */

      me.trigger('change', {
        action: 'splice',
        removed,
        added,
        replaced,
        oldCount
      });
    } else {
      /**
       * Fired when a {@link #function-splice} operation is requested but the operation
       * is a no-op and has caused no change to this Collection's dataset. The splice
       * method's parameters are passed for reference.
       * @event noChange
       * @param {Number} index Index at which to remove a block of items.
       * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
       * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
       * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
       */
      me.trigger('noChange', {
        index,
        toRemove,
        toAdd
      });
    }
  }
  /**
   * Change the id of an existing member by mutating its {@link #config-idProperty}.
   * @param {String|Number|Object} item The item or id of the item to change.
   * @param {String|Number} newId The id to set in the existing member.
   */


  changeId(item, newId) {
    const me = this,
          {
      idProperty
    } = me,
          oldId = keyTypes[typeof item] ? item : item[idProperty],
          member = me.get(oldId);

    if (member) {
      const existingMember = me.get(newId);

      if (existingMember && member !== existingMember) {
        throw new Error(`Attempt to set item ${oldId} to already existing member's id ${newId}`);
      }

      me.removeIndexEntry(item, idProperty, oldId);
      me.addIndexEntry(item, idProperty, newId); // Last on purpose, onItemMutation would fail to find the item if its id was changed prior to the call

      member[idProperty] = newId;
    }
  }
  /**
   * Returns the item with the passed `id`. By default, filtered are honoured, and
   * if the item with the requested `id` is filtered out, nothing will be returned.
   *
   * To return the item even if it has been filtered out, pass the second parameter as `true`.
   * @param {*} id The `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
   * @returns {Object} The found item, or `undefined`.
   */


  get(id, ignoreFilters = false) {
    return this.getBy(this.idProperty, id, ignoreFilters);
  }

  getAt(index, ignoreFilters = false) {
    if (this.isFiltered && !ignoreFilters) {
      return this._filteredValues[index];
    } else {
      return this._values[index];
    }
  }
  /**
   * Returns the item with passed property name equal to the passed value. By default,
   * filtered are honoured, and if the item with the requested `id` is filtered out,
   * nothing will be returned.
   *
   * To return the item even if it has been filtered out, pass the third parameter as `true`.
   * @param {String} propertyName The property to test.
   * @param {*} value The value to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
   * @returns {Object} The found item, or `undefined`.
   */


  getBy(propertyName, value, ignoreFilters = false) {
    return this.findItem(propertyName, value, this.isFiltered && ignoreFilters);
  }
  /**
   * The number of items in this collection. Note that this honours filtering.
   * See {@link #property-totalCount};
   * @property {Number}
   * @readonly
   */


  get count() {
    return this.values.length;
  }
  /**
   * The number of items in this collection regardless of filtering.
   * @property {Number}
   * @readonly
   */


  get totalCount() {
    return this._values.length;
  }
  /**
   * The property name used to extract item `id`s from added objects.
   * @member {String} idProperty
   */


  updateIdProperty(idProperty) {
    this.addIndex({
      property: idProperty,
      unique: true
    });
  } //endregion
  //region Sorting

  /**
   * The Collection of {@link Core.util.CollectionSorter Sorters} for this Collection.
   * @member {Core.util.Collection} sorters
   */


  changeSorters(sorters) {
    return new Collection({
      values: Array.isArray(sorters) ? sorters : [sorters],
      listeners: {
        change: 'onSortersChanged',
        thisObj: this
      }
    });
  }
  /**
   * Adds a Sorter to the Collection of Sorters which are operating on this Collection.
   *
   * A Sorter may be an specified as an instantiated {@link Core.util.CollectionSorter
   * CollectionSorter}, or a config object for a CollectionSorter of the form
   *
   *     {
   *         property  : 'age',
   *         direction : 'desc'
   *     }
   *
   * Note that by default, a Sorter *replaces* a Sorter with the same `property` to make
   * it easy to change existing Sorters. A Sorter's `id` is its `property` by default. You
   * can avoid this and add multiple Sorters for one property by configuring Sorters with `id`s.
   *
   * A Sorter may also be specified as a function which compares two objects eg:
   *
   *     (lhs, rhs) => lhs.customerDetails.age - rhs.customerDetails.age
   *
   * @param {Object} sorter A Sorter of Sorter configuration object to add to the Collection
   * of Sorters operating on this Collection.
   * @returns {Core.util.CollectionSorter} The resulting Sorter to make it easy to remove Sorters.
   */


  addSorter(sorter) {
    const result = sorter instanceof _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"] ? sorter : new _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"](sorter);
    this.sorters.add(result);
    return result;
  }
  /**
   * A flag which is `true` if this Collection has active {@link #property-sorters}.
   * @property {Boolean}
   * @readonly
   */


  get isSorted() {
    var _this$_sorters;

    return Boolean((_this$_sorters = this._sorters) === null || _this$_sorters === void 0 ? void 0 : _this$_sorters.count);
  }

  onSortersChanged() {
    const me = this;
    delete me._sortFunction;

    me._values.sort(me.sortFunction);

    me.trigger('change', sortEvent);
  }
  /**
   * A sorter function which encapsulates the {@link Core.util.CollectionSorter Sorters}
   * for this Collection.
   * @property {Function}
   * @readonly
   */


  get sortFunction() {
    if (!this._sortFunction) {
      if (this.isSorted) {
        this._sortFunction = _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"].generateSortFunction(this.sorters.values);
      } else {
        this._sortFunction = return0;
      }
    }

    return this._sortFunction;
  } //endregion
  //region Filtering

  /**
   * The Collection of {@link Core.util.CollectionFilter Filters} for this Collection.
   * @property {Core.util.Collection}
   * @readonly
   */


  get filters() {
    if (!this._filters) {
      this._filters = new Collection({
        listeners: {
          change: 'onFiltersChanged',
          thisObj: this
        }
      });
    }

    return this._filters;
  }
  /**
   * Adds a Filter to the Collection of Filters which are operating on this Collection.
   *
   * A Filter may be an specified as an instantiated {@link Core.util.CollectionFilter
   * CollectionFilter}, or a config object for a CollectionFilter of the form
   *
   *     {
   *         property : 'age',
   *         operator : '>=',
   *         value    : 21
   *     }
   *
   * Note that by default, a Filter *replaces* a Filter with the same `property` to make
   * it easy to change existing Filters. A Filter's `id` is its `property` by default. You
   * can avoid this and add multiple Filters for one property by configuring Filters with `id`s.
   *
   * A Filter may also be specified as a function which filters candidate objects eg:
   *
   *     candidate => candidate.customerDetails.age >= 21
   *
   * @param {Object} filter A Filter or Filter configuration object to add to the Collection
   * of Filters operating on this Collection.
   * @returns {Core.util.CollectionFilter} The resulting Filter to make it easy to remove Filters.
   */


  addFilter(filter) {
    const result = filter instanceof _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"] ? filter : new _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"](filter);
    this.filters.add(result);
    return result;
  }
  /**
   * A flag which is `true` if this Collection has active {@link #property-filters}.
   * @property {Boolean}
   * @readonly
   */


  get isFiltered() {
    return Boolean(this._filters && this._filters.count);
  }

  onFiltersChanged() {
    const me = this;
    me._filterFunction = null;
    me._filteredValues = me._values.filter(me.filterFunction);
    me._indicesInvalid = true;
    me.trigger('change', filterEvent);
  }
  /**
   * A filter function which encapsulates the {@link Core.util.CollectionFilter Filters}
   * for this Collection.
   * @property {Function}
   * @readonly
   */


  get filterFunction() {
    if (!this._filterFunction) {
      if (this.isFiltered) {
        this._filterFunction = _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"].generateFiltersFunction(this.filters.values);
      } else {
        this._filterFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].returnTrue;
      }
    }

    return this._filterFunction;
  } //endregion
  //region Indexing


  changeExtraKeys(extraKeys) {
    const keys = !Array.isArray(extraKeys) ? [extraKeys] : extraKeys; // Normalize to always be an array of index configs

    return keys.map(config => {
      if (typeof config === 'string') {
        return {
          property: config,
          unique: true
        };
      }

      return config;
    });
  }

  updateExtraKeys(extraKeys) {
    for (let i = 0; i < extraKeys.length; i++) {
      this.addIndex(extraKeys[i]);
    }
  }
  /**
   * Adds a lookup index for the passed property name or index config. The index is built lazily when an index is
   * searched
   * @internal
   * @param {Object} indexConfig An index config
   * @param {String} indexConfig.property The property name to add an index for
   * @param {Boolean} [indexConfig.unique] Specify `false` to allow multiple entries of the same index, turning
   *   entries into sets
   */


  addIndex(indexConfig) {
    // Combo without valueField used in some tests -> addIndex(undefined). Safeguarding here
    if (indexConfig) {
      (this._indices || (this._indices = {}))[indexConfig.property] = new Map(); // Piggyback the index config

      Object.assign(this._indices[indexConfig.property], indexConfig); // Indices need a rebuild now.

      this.invalidateIndices();
      /**
       * this.indices is keyed by the property name, and contains the keys linked to an item in the _values array.
       * So collection.add({id : foo, name : 'Nige'}, {id : 'bar', name : 'Faye'}) where collection has had an index
       * added for the "name" property would result in:
       *
       * {
       *     id : Map({
       *         foo : nige,
       *         bar : faye
       *     }),
       *     name : Map({
       *         Nige : nige,
       *         Faye : faye
       *     })
       * }
       */
    }
  }
  /**
   * Return the index of the item with the specified key having the specified value.
   *
   * By default, filtering is taken into account and this returns the index in the filtered dataset if present. To
   * bypass this, pass the third parameter as `true`.
   *
   * Only useful for indices configured with `unique: true`.
   *
   * @param {String} propertyName The name of the property to test.
   * @param {*} value The value to test for.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
   * the original data set if the item is filtered out.
   * @returns {Number} The index of the item or `-1` if not found for unique indices
   */


  findIndex(propertyName, value, ignoreFilters = false) {
    const item = this.findItem(propertyName, value, ignoreFilters);

    if (!item) {
      return -1;
    }

    const values = this.isFiltered && !ignoreFilters ? this._filteredValues : this._values;
    return values.indexOf(item);
  }
  /**
   * Return the item with the specified key having the specified value.
   *
   * By default, filtering is taken into account. To bypass this, pass the third parameter as `true`.
   *
   * For indices configured with `unique: false`, a Set of items will be returned.
   *
   * @param {String} propertyName The name of the property to test.
   * @param {*} value The value to test for.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
   * the original data set if the item is filtered out.
   * @returns {Object|Set} The found item or Set of items or null
   */


  findItem(propertyName, value, ignoreFilters = false) {
    const me = this,
          {
      isFiltered
    } = me,
          index = isFiltered && !ignoreFilters ? me.indices[filteredIndicesProperty][propertyName] : me.indices[propertyName];

    if (index) {
      var _index$get;

      // If the key is a numeric string, cast it to a number and find.
      // Store's idRegister is an object which treats numeric keys as strings
      // but Maps are more picky, so we have to work round that.
      const item = (_index$get = index.get(value)) !== null && _index$get !== void 0 ? _index$get : typeof value === 'string' && value.length && !isNaN(value) && index.get(Number(value)) || null;

      if (item != null) {
        return item;
      }
    } else {
      // Search the filtered values if we are filtered and not ignoring filters
      const values = isFiltered && !ignoreFilters ? me._filteredValues : me._values,
            count = values.length;

      for (let i = 0; i < count; i++) {
        const item = values[i];

        if (item[propertyName] == value) {
          return item;
        }
      }
    }

    return null;
  }

  removeIndex(propertyName) {
    delete this._indices[propertyName];
  }
  /**
   * Returns the index of the item with the same `id` as the passed item.
   *
   * By default, filtering is honoured, so if the item in question has been added, but is currently filtered out of
   * visibility, `-1` will be returned.
   *
   * To find the index in the master, unfiltered dataset, pass the second parameter as `true`;
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
   * @returns {Number} The index of the item, or `-1` if not found.
   */


  indexOf(item, ignoreFilters = false) {
    return this.findIndex(this.idProperty, keyTypes[typeof item] ? item : item[this.idProperty], ignoreFilters);
  }
  /**
   * Returns `true` if this Collection includes an item with the same `id` as the passed item.
   *
   * By default, filtering is honoured, so if the item in question has been added,
   * but is currently filtered out of visibility, `false` will be returned.
   *
   * To query inclusion in the master, unfiltered dataset, pass the second parameter as `true`;
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
   * @returns {Boolean} True if the passed item is found.
   */


  includes(item, ignoreFilters = false) {
    if (Array.isArray(item)) {
      return item.some(item => this.includes(item));
    }

    return Boolean(this.findItem(this.idProperty, keyTypes[typeof item] ? item : item[this.idProperty], ignoreFilters));
  }

  get indices() {
    if (this._indicesInvalid) {
      this.rebuildIndices();
    }

    return this._indices;
  }

  invalidateIndices() {
    this._indicesInvalid = true;
  }
  /**
   * Called when the Collection is mutated and the indices have been flagged as invalid.
   *
   * Rebuilds the indices object to allow lookup by keys.
   * @internal
   */


  rebuildIndices() {
    const me = this,
          isFiltered = me.isFiltered,
          indices = me._indices || (me._indices = {}),
          keyProps = Object.keys(indices),
          indexCount = keyProps.length,
          values = me._values;
    let filteredIndices;

    if (isFiltered) {
      filteredIndices = indices[filteredIndicesProperty] = {};
    } // First, clear indices.


    for (let i = 0; i < indexCount; i++) {
      const index = indices[keyProps[i]];
      index.clear();

      if (isFiltered) {
        let filteredIndex = filteredIndices[keyProps[i]];

        if (filteredIndex) {
          filteredIndex.clear();
        } else {
          filteredIndex = filteredIndices[keyProps[i]] = new Map(); // Piggyback config

          filteredIndex.unique = index.unique;
        }
      }
    }

    doRebuildIndices(values, indices, keyProps, indexCount); // Create a parallel lookup structure into the _filteredValues

    if (isFiltered) {
      doRebuildIndices(me._filteredValues, filteredIndices, keyProps, indexCount);
    }

    me._indicesInvalid = false;
  } // Returns an array with [indices] or [indices, filteredIndices] if filtering is used


  getIndices(propertyName) {
    const indices = [this.indices[propertyName]];

    if (this.isFiltered) {
      indices.push(this.indices[filteredIndicesProperty][propertyName]);
    }

    return indices;
  }
  /**
   * Add an item to all indices
   * @param {*} item Item already available in the Collection
   * @private
   */


  addToIndices(item) {
    Object.keys(this.indices).forEach(propertyName => {
      this.addIndexEntry(item, propertyName, item[propertyName]);
    });
  }
  /**
   * Remove an item from all indices
   * @param {*} item Item already available in the Collection
   * @private
   */


  removeFromIndices(item) {
    Object.keys(this.indices).forEach(propertyName => {
      this.removeIndexEntry(item, propertyName, item[propertyName]);
    });
  }
  /**
   * Remove an entry from an index, and if filtering is used also from the filtered index.
   * @param {*} item Item already available in the Collection
   * @param {String} propertyName Property of the item, will be matched with configured indices
   * @param {*} oldValue Value to remove
   * @private
   */


  removeIndexEntry(item, propertyName, oldValue) {
    this.getIndices(propertyName).forEach(index => removeItemFromIndex(item, index, oldValue));
  }
  /**
   * Add a new entry to an index, and if filtering is used also to the filtered index.
   * @param {*} item Item already available in the Collection
   * @param {String} propertyName Property of the item, will be matched with configured indices
   * @param {*} value Value to store
   * @private
   */


  addIndexEntry(item, propertyName, value) {
    this.getIndices(propertyName).forEach(index => addItemToIndex(item, index, value));
  }
  /**
   * Call externally to update indices on item mutation (from Store)
   * @param {*} item Item already available in the Collection
   * @param {Object} wasSet Uses the `wasSet` format from Store, `{ field : { oldValue, newValue } }`
   * @internal
   */


  onItemMutation(item, wasSet) {
    // Iterate over changes if we have extra indices defined, keeping those indices up to date
    if (!this._indicesInvalid && Object.keys(this.indices).length > 1) {
      Object.keys(wasSet).forEach(propertyName => {
        if (this.indices[propertyName]) {
          const {
            value,
            oldValue
          } = wasSet[propertyName];
          this.removeIndexEntry(item, propertyName, oldValue);
          this.addIndexEntry(item, propertyName, value);
        }
      });
    }
  } //endregion


} // These are used by Bag for the same purpose


Collection._$name = 'Collection';

/***/ }),

/***/ "./lib/Core/util/CollectionFilter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionFilter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionFilter; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'gantt';






/**
 * @module Core/util/CollectionFilter
 */

const nestedValueReducer = (object, path) => object === null || object === void 0 ? void 0 : object[path];
/**
 * A class which encapsulates a single filter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionFilter generally has at least three main properties:
 *
 * * `property` - The name of a property in candidate objects from which to extract the value to test
 * * `value` - The value which  this filter uses to test against.
 * * `operator` - The comparison operator, eg: `'='` or `'>'` etc.
 *
 * Given these three essential values, further configurations may affect how the filter is applied:
 *
 * * `caseSensitive` - If configured as `false`, string comparisons are case insensitive.
 * * `convert` - A function which, when passed the extracted value from the candidate object, returns the value to test.
 *
 * A filter may also be configured with a single `filterBy` property. This function is just passed the raw
 * candidate object and must return `true` or `false`.
 *
 * A CollectionFilter may be configured to encapsulate a single filtering function by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionFilter(candidate => candidate.title.contains('search string'));
 *
 */


class CollectionFilter extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * The value against which to compare the {@link #config-property} of candidate objects.
       * @config {*}
       */
      value: null,

      /**
       * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
       * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`, `'isIncludedIn'`
       * @config {String}
       */
      operator: null,

      /**
       * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
       * accepts a candidate object and returns `true` or `false`
       * @config {Function}
       */
      filterBy: null,

      /**
       * A function which accepts a value extracted from a candidate object using the {@link #config-property} name, and
       * returns the value which the filter should use to compare against its {@link #config-value}.
       * @config {Function}
       */
      convert: null,

      /**
       * Configure as `false` to have string comparisons case insensitive.
       * @config {Boolean}
       */
      caseSensitive: true,

      /**
       * The `id` of this Filter for when used by a {@link Core.util.Collection} Collection.
       * By default the `id` is the {@link #config-property} value.
       * @config {String}
       */
      id: null,
      // Type is required to process the Date value in State API. Store doesn't always know about field type to
      // process filter value, when it applies it from the state, e.g. when you don't declare model field as `date`
      // type but provide a Date instance there. When DateColumn is used to shows this field, it could add date
      // filters to the store. When store is applying state it cannot just infer type, because model doesn't
      // declare it. Only column knows. So to properly process the Date instance for the filter State API would
      // have to process the field additionally, checking model field type and column type. So it is simpler to
      // make Filter to put this information. That way when filter is instantiated by the store, it can gracefully
      // handle value processing, converting date string to the Date instance.
      // Date is the only known value type so far which requires this processing.
      type: null
    };
  }

  static get configurable() {
    return {
      /**
       * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
       * @member {String} property
       */

      /**
       * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
       * @config {String}
       */
      property: null
    };
  }

  construct(config) {
    if (typeof config === 'function') {
      config = {
        filterBy: config
      };
    } // If Filter is created without a type (yet everything except applying state) create one


    if (!config.type) {
      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isDate(config.value)) {
        config.type = 'date';
      } else if (config.value instanceof _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
        config.type = 'duration';
      }
    } // If type already exist, it means we are applying state and should process value
    else {
      if (config.type === 'date') {
        config.value = new Date(config.value);
      } else if (config.type === 'duration') {
        config.value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"](config.value);
      }
    }

    super.construct(config);
  }
  /**
   * When in a Collection (A Collection holds its Filters in a Collection), we need an id.
   * @property {String}
   * @private
   */


  get id() {
    return this._id || (this._id = this.property || CollectionFilter.generateId('b-filter'));
  }

  set id(id) {
    this._id = id;
  }

  onChange(propertyChanged) {
    const me = this; // Inform any owner (eg a Store), that it has to reassess its CollectionFilters

    if (!me.isConfiguring && me.owner && !me.owner.isConfiguring && me.owner.onFilterChanged) {
      me.owner.onFilterChanged(me, propertyChanged);
    }
  }

  get filterBy() {
    return this._filterBy || this.defaultFilterBy;
  }
  /**
   * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
   * accepts a candidate object and returns `true` or `false`
   * @type {Function}
   */


  set filterBy(filterBy) {
    this._filterBy = filterBy;
  }

  defaultFilterBy(candidate) {
    const me = this;
    let candidateValue; // check if is nested property

    if (me._propertyItems.length > 1) {
      // support nested props (https://github.com/bryntum/support/issues/1861)
      candidateValue = me._propertyItems.reduce(nestedValueReducer, candidate);
    } else {
      candidateValue = candidate[me.property];
    }

    return me[me.operator](me.convert(candidateValue));
  }

  updateProperty(property) {
    this._propertyItems = property.split('.'); // Signal to owner about filter change

    this.onChange('property');
  }
  /**
   * The value against which to compare the {@link #config-property} of candidate objects.
   * @type {*}
   */


  set value(value) {
    var _value$valueOf, _value;

    this._value = value;
    value = (_value$valueOf = (_value = value) === null || _value === void 0 ? void 0 : _value.valueOf()) !== null && _value$valueOf !== void 0 ? _value$valueOf : value; // Filter value is a processed value to be used by the comparators. Useful when value is object, like Duration field

    this._filterValue = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value; // Signal to owner about filter change

    this.onChange('value');
  }

  get value() {
    return this._value;
  }

  get filterValue() {
    return this._filterValue;
  }
  /**
   * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
   * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`, `'isIncludedIn'`
   * @type {String}
   */


  set operator(operator) {
    this._operator = operator; // Signal to owner about filter change

    this.onChange('operator');
  }

  get operator() {
    if (this._operator) {
      return this._operator;
    }

    if (Array.isArray(this.filterValue)) {
      return 'isIncludedIn';
    }

    return typeof this.filterValue === 'string' ? '*' : '=';
  }

  convert(value) {
    // This is a workaround for filterbar feature: it always converts input value to string. When date is typed,
    // it is converted into string, and Date.valueOf() would return number. So if we are matching date against string
    // type, we should not convert it.
    if (!(typeof this.filterValue === 'string' && value instanceof Date)) {
      var _value$valueOf2, _value2;

      // if value is a complex type, try to access `value` property to get primitive value
      value = (_value$valueOf2 = (_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.valueOf()) !== null && _value$valueOf2 !== void 0 ? _value$valueOf2 : value;
    }

    value = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value;
    return value;
  }

  filter(candidate) {
    return this.filterBy(candidate);
  }

  startsWith(v) {
    return String(v).startsWith(this.filterValue);
  }

  endsWith(v) {
    return String(v).endsWith(this.filterValue);
  }

  isIncludedIn(v) {
    return this.filterValue.length === 0 || this.filterValue.includes(v);
  }

  '='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '!='(v) {
    return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '>'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isMoreThan(v, this.filterValue);
  }

  '>='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isMoreThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '<'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isLessThan(v, this.filterValue);
  }

  '<='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isLessThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '*'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPartial(v, this.filterValue);
  } // Accepts an array or a Collection


  static generateFiltersFunction(filters) {
    if (!filters || !filters.length && !filters.count) {
      return _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].returnTrue;
    }

    return function (candidate) {
      let match = true;

      for (const filter of filters) {
        // Skip disabled filters
        if (!filter.disabled) {
          match = filter.filter(candidate);
        }

        if (!match) {
          break;
        }
      }

      return match;
    };
  }

}
CollectionFilter._$name = 'CollectionFilter';

/***/ }),

/***/ "./lib/Core/util/CollectionSorter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionSorter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionSorter; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
var productName = 'gantt';


/**
 * @module Core/util/CollectionSorter
 */

/**
 * A class which encapsulates a single sorter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionSorter generally has two properties:
 *
 * * `property` - The name of a property in collection objects by which to sort
 * * `direction` - The sort direction, `'ASC'` or `'DESC'`.
 *
 * It may also be configured with just a {@link #config-sortFn} function which returns the desired comparison
 * result when passed two objects to compare. Note that this does *not* require or use the
 * {@link #config-property} config. Two collection items are passed for comparison.
 *
 * Further configurations may affect how the sorter is applied:
 *
 * * `convert` - A function which, when passed the {@link #config-property} value from
 * a collection object, returns the value to sort by.
 *
 * A CollectionSorter may be configured to encapsulate a {@link #config-sortFn} by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionSorter((lhs, rhs) => {
 *         lhs = lhs.customerDetails.companyName.toLowerCase();
 *         rhs = rhs.customerDetails.companyName.toLowerCase();
 *
 *         if (lhs < rhs) {
 *             return -1;
 *         }
 *         else if (lhs > rhs) {
 *             return 1;
 *         }
 *         else {
 *             return 0;
 *         }
 *     });
 *
 */

class CollectionSorter extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * The name of a property of collection objects which yields the value to sort by.
       * @config {String}
       */
      property: null,

      /**
       * The direction to sort in, `'ASC'` or `'DESC'`
       * @config {String}
       * @default
       */
      direction: 'ASC',

      /**
       * A function which takes the place of using {@link #config-property} and {@link #config-direction}.
       * The function is passed two objects from the collection to compare and must return the comparison result.
       * @config {Function}
       */
      sortFn: null,

      /**
       * When using {@link #config-property}, this may be specified as a function which takes the raw
       * property value and returns the value to actually sort by.
       * @config {Function}
       */
      convert: null,

      /**
       * The `id` of this Sorter for when used by a {@link Core.util.Collection} Collection.
       * By default the `id` is the {@link #config-property} value.
       * @config {String}
       */
      id: null,

      /**
       * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
       * a locale string or a locale config to enable.
       *
       * Enabling this has big negative impact on sorting
       * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
       *
       * ```javascript
       * collection.addSorter({ field: 'name', useLocaleSort : 'sv-SE' });
       * ```
       *
       * @config {Boolean|String|Object}
       * @default false
       */
      useLocaleSort: null
    };
  }

  construct(config) {
    if (typeof config === 'function') {
      config = {
        sortFn: config
      };
    }

    super.construct(config);
  }
  /**
   * When in a Collection (A Collection holds its Sorters in a Collection), we need an id.
   * @property {String}
   * @private
   */


  get id() {
    return this._id || (this._id = this.property || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].generateId('b-sorter'));
  }

  set id(id) {
    this._id = id;
  }

  set sortFn(sortFn) {
    this._sortFn = sortFn;
  }

  get sortFn() {
    if (this._sortFn) {
      return this._sortFn;
    }

    return this.defaultSortFn;
  }
  /**
   * Default sortFn used when no sortFn specified. Uses the {@link #config-property},
   * {@link #config-direction}, and {@link #config-convert}.
   * @private
  */


  defaultSortFn(lhs, rhs) {
    const me = this,
          {
      convert,
      property,
      useLocaleSort
    } = me,
          multiplier = me.direction.toLowerCase() === 'desc' ? -1 : 1;
    lhs = lhs[property];
    rhs = rhs[property];

    if (convert) {
      lhs = convert(lhs);
      rhs = convert(rhs);
    }

    if (useLocaleSort && lhs != null && rhs != null) {
      // Use systems locale
      if (useLocaleSort === true) {
        return String(lhs).localeCompare(rhs);
      } // Use specified locale


      if (typeof useLocaleSort === 'string') {
        return String(lhs).localeCompare(rhs, useLocaleSort);
      } // Use locale config


      if (typeof useLocaleSort === 'object') {
        return String(lhs).localeCompare(rhs, useLocaleSort.locale, useLocaleSort);
      }
    }

    return (lhs > rhs ? 1 : lhs < rhs ? -1 : 0) * multiplier;
  }

  static generateSortFunction(sorters, tieBreaker) {
    const items = sorters.isCollection ? sorters.values : sorters,
          n = items.length;
    return (lhs, rhs) => {
      let comp, i;

      for (i = 0; i < n; ++i) {
        comp = items[i].sortFn(lhs, rhs);

        if (comp) {
          return comp;
        }
      }

      return tieBreaker ? tieBreaker(lhs, rhs) : 0;
    };
  }

}
CollectionSorter._$name = 'CollectionSorter';

/***/ }),

/***/ "./lib/Core/util/DayTime.js":
/*!**********************************!*\
  !*** ./lib/Core/util/DayTime.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DayTime; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';

/**
 * @module Core/util/DayTime
 */

const MILLIS_PER_MINUTE = 60 * 1000,
      MILLIS_PER_HOUR = 60 * MILLIS_PER_MINUTE,
      MILLIS_PER_DAY = 24 * MILLIS_PER_HOUR,
      timeRe = /(\d+)?:?(\d*)/;
/**
 * This class encapsulates time of day calculations.
 *
 * The goal is to describe a "day" (a 24-hour period) that starts at a specific time (other than midnight). In a
 * calendar day view, this would look like this:
 * ```
 *              startShift=0                          startShift='12:00'
 *       00:00  +-------+                      12:00  +-------+
 *              |       |                             |       |
 *       01:00  |- - - -|                      13:00  |- - - -|
 *                 ...                                   ...
 *              |       |                             |       |
 *       08:00  |- - - -|   <-- timeStart -->  20:00  |- - - -|
 *              |       |                             |       |
 *       09:00  |- - - -|                      21:00  |- - - -|
 *              |       |                             |       |
 *       10:00  |- - - -|                      22:00  |- - - -|
 *              |       |                             |       |
 *       11:00  |- - - -|                      23:00  |- - - -|
 *              |       |                             |       |
 *       12:00  |- - - -|                      00:00  |- - - -|
 *              |       |                             |       |
 *       13:00  |- - - -|                      01:00  |- - - -|
 *              |       |                             |       |
 *       14:00  |- - - -|                      02:00  |- - - -|
 *              |       |                             |       |
 *       15:00  |- - - -|                      03:00  |- - - -|
 *              |       |                             |       |
 *       16:00  |- - - -|                      04:00  |- - - -|
 *              |       |                             |       |
 *       17:00  |- - - -|    <-- timeEnd -->   05:00  |- - - -|
 *              |       |                             |       |
 *                 ...                                   ...
 *              |       |                             |       |
 *       23:00  |- - - -|                      11:00  |- - - -|
 *              |       |                             |       |
 *       00:00  +-------+                      12:00  +-------+
 * ```
 * In a horizontal format with X for times to render:
 * ```
 *  startShift = 0
 *
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |   |   |  ...  |   |XXX|XXX|  ...  |XXX|XXX|   |  ...  |   |
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      00  01  02      07  08  09  10      15  16  17  18      23  00
 *                          ^                       ^
 *                      timeStart               timeEnd
 *
 *  startShift = '12:00'
 *
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |   |   |  ...  |   |XXX|XXX|X ... X|XXX|XXX|   |  ...  |   |
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      12  13  14      19  20  21  22      03  04  05  06      11  12
 *                          ^                       ^
 *                      timeStart               timeEnd
 * ```
 * When the day wraps over midnight, it is describing this (note timeEnd < timeStart):
 * ```
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |XXX|XXX|X ... X|XXX|   |   |  ...  |   |   |XXX|X ... X|XXX|
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      00  01  02      04  05  06  07      18  19  20  21      23  00
 *                          ^                       ^
 *                      timeEnd                 timeStart
 * ```
 * @internal
 */

class DayTime {
  /**
   * Returns a string of "HH:MM" for a given time of day in milliseconds.
   * @param {Number} timeOfDay The time of day in milliseconds.
   * @returns {String}
   * @private
   */
  static format(timeOfDay) {
    const h = Math.floor(timeOfDay / MILLIS_PER_HOUR),
          m = Math.floor(timeOfDay / MILLIS_PER_MINUTE) % 60;
    return `${h}:${m < 10 ? '0' : ''}${m}`;
  }
  /**
   * Parses a time of day which may be a number (0-24 for the hour of the day) or a string in "H:MM" format and
   * returns the time of day as a number of milliseconds.
   *
   * If `time` is a `Date` instance, its time of day is returned.
   * @param {Date|Number|String} time
   * @returns {Number}
   * @private
   */


  static parse(time) {
    const type = typeof time;

    if (type === 'string') {
      const match = timeRe.exec(time);
      time = Number(match[1] || 0) * MILLIS_PER_HOUR + Number(match[2] || 0) * MILLIS_PER_MINUTE;
    } else if (type !== 'number') {
      time = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(time);
    } else if (time <= 24) {
      // if number of hours (as provided during config)
      time *= MILLIS_PER_HOUR;
    }

    return Math.min(Math.max(Math.floor(time), 0), MILLIS_PER_DAY);
  }

  constructor(config) {
    let startShift = 0,
        startTime,
        endTime;

    if (config !== null && config !== void 0 && config.isDayView) {
      // These are raw configs in hrs or 'HH:MM' on construction and millis after:
      startShift = config.dayStartShift;
      startTime = config.dayStartTime;
      endTime = config.dayEndTime;
    } else if (typeof config === 'number') {
      startShift = startTime = endTime = config;
    } else if (config) {
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the start time for the day. This is
       * midnight by default.
       * @config {Number|String} startShift
       * @default 0
       */
      startShift = config.startShift;
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the first visible time of day. You can also
       * set this value to a ms timestamp representing time from midnight.
       * @config {Number|String} timeStart
       * @default 0
       */

      startTime = config.timeStart;
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the last visible time of day. You can also
       * set this value to a ms timestamp representing time from midnight.
       * @config {Number|String} timeEnd
       * @default 24
       */

      endTime = config.timeEnd;
    }

    this.startShift = startShift = DayTime.parse(startShift || 0);
    this.timeEnd = (endTime == null ? (startShift + MILLIS_PER_DAY) % MILLIS_PER_DAY : DayTime.parse(endTime)) || MILLIS_PER_DAY;
    this.timeStart = startTime == null ? startShift : DayTime.parse(startTime);
  }

  get startHour() {
    return Math.floor(this.timeStart / MILLIS_PER_HOUR);
  }
  /**
   * The number of milliseconds from the day's `startShift` to its `timeStart`.
   * @member {Number}
   */


  get startTimeOffsetMs() {
    const {
      startShift,
      timeStart
    } = this;
    return timeStart < startShift ? MILLIS_PER_DAY - startShift + timeStart : timeStart - startShift;
  }
  /**
   * The `Date` object for the most recently started, shifted day. The time of this `Date` will be the `startShift`.
   * It is possible for this date to be yesterday on a midnight-based calendar. For example, if the `startShift` is
   * 6PM and the current time is 6AM on May 20, this value will be 6PM of May 19 (the most recently started day).
   * @member {Date}
   */


  get today() {
    return this.startOfDay(new Date());
  }
  /**
   * Returns `Date` object for the nearest (shifted) day ending after the given `date`. The time of this `Date` will
   * be the `startShift`.
   *
   * It is possible for this date to be in the next day on a midnight-based calendar. For example, if the `startShift`
   * is 6PM and `date` is 7PM on May 20, this method will return 6PM of May 21 (the nearest day ending).
   * @param {Date} date The date for which to find the nearest day ending.
   * @returns {Date}
   */


  ceil(date) {
    const ret = this.startOfDay(date);

    if (ret < date) {
      ret.setDate(ret.getDate() + 1);
    }

    return ret;
  }
  /**
   * Returns `true` if the time of day for the given `date` is between `timeStart` and `timeEnd`.
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance to test.
   * @returns {Boolean}
   */


  contains(date) {
    return !this.outside(date);
  }
  /**
   * Returns a "YYYY-MM-DD" string for the given `date`. This value will match the `date` if the time of day is at or
   * after `startShift`, but will be the prior date otherwise.
   * @param {Date|Number} date The date from which to compute the 'YYYY-MM-DD' key.
   * @returns {String}
   */


  dateKey(date) {
    date = this.shiftDate(date, -1);
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].makeKey(date);
  }
  /**
   * Returns a `Date` instance with `startShift` as the time of day and the Y/M/D of the given `date`.
   * @param {Date} date The date's year, month, and day values.
   * @returns {Date}
   */


  dayOfDate(date) {
    return this.shiftDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(date)); // return the Date w/the matching YYYY-MM-DD value
  }
  /**
   * Returns the day of week (0-8) for the given `date`. This value will match the `date` if the time of day is at or
   * after `startShift`, but will be the prior day otherwise.
   * @param {Date|Number} date The date from which to compute the day of week.
   * @returns {Number}
   */


  dayOfWeek(date) {
    date = this.shiftDate(date, -1);
    return date.getDay();
  }
  /**
   * Returns the difference between the time of day of the given `date` and `timeStart` in the specified time `unit`.
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance.
   * @param {String} unit The desired unit of time to return (see {@link Core.helper.DateHelper#function-as-static}).
   * @returns {Number}
   */


  delta(date, unit = 'ms') {
    const {
      timeStart
    } = this,
          time = DayTime.parse(date),
          t = (this.startShift && time < timeStart ? time + MILLIS_PER_DAY : time) - timeStart;
    return unit === 'ms' ? t : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].as(unit, t, 'ms');
  }
  /**
   * Returns the duration of the visible day (between `timeStart` and `timeEnd`) in the specified time `unit`.
   * @param {String} unit The desired unit of time to return (see {@link Core.helper.DateHelper#function-as-static}).
   * @returns {Number}
   */


  duration(unit = 'ms') {
    const {
      timeStart,
      timeEnd
    } = this,
          millis = timeStart < timeEnd ? timeEnd - timeStart : MILLIS_PER_DAY - timeStart + timeEnd;
    return unit === 'ms' ? millis : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].as(unit, millis, 'ms');
  }
  /**
   * Returns `true` if this instance describes the same day as the `other`.
   * @param {Core.util.DayTime} other The other instance to which `this` instance should be tested for equality.
   * @returns {Boolean}
   */


  equals(other) {
    // we only need on "?." operator since we short-circuit
    return this.startShift === (other === null || other === void 0 ? void 0 : other.startShift) && this.timeStart === other.timeStart && this.timeEnd === other.timeEnd;
  }
  /**
   * Returns `true` if the times of day described by `startDate` and `endDate` intersect the visible time of this day.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Boolean}
   */


  intersects(startDate, endDate) {
    const me = this,
          {
      timeStart,
      timeEnd
    } = me,
          [date0, date1] = me._dateRangeArgs(startDate, endDate),
          [start, end] = me.timeRange(date0, date1);

    if (timeStart < timeEnd) {
      if (start < end) {
        return start < timeEnd && timeStart <= end;
      }

      return start < timeEnd || timeStart <= end;
    }

    return !(start < end) || start < timeEnd || timeStart <= end;
  }
  /**
   * Returns `true` if the given date range is contained within one day.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Boolean}
   */


  isIntraDay(startDate, endDate) {
    const me = this,
          [date0, date1] = me._dateRangeArgs(startDate, endDate),
          dayStart = me.startOfDay(date0),
          diff = MILLIS_PER_DAY - _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].diff(dayStart, date1, 'ms'); // Not <= to match isInterDay


    if (diff < 0) {
      return false;
    } // diff > 0 means less than 24hrs, so intraDay... diff==0 means date1 was EOD so we are intraDay if date0 is not
    // also at EOD.


    return diff > 0 || dayStart < date0;
  }
  /**
   * Returns -1, 0, or 1 based on whether the time of day for the given `date` is before `timeStart` (-1), or after
   * `timeEnd` (1), or between these times (0).
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance to test.
   * @returns {Number}
   */


  outside(date) {
    const {
      startShift,
      timeStart,
      timeEnd
    } = this,
          time = DayTime.parse(date);

    if (timeStart < timeEnd) {
      /*
       *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
       *      |   |   |  ...  |   |XXX|XXX|  ...  |XXX|XXX|   |  ...  |   |
       *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
       *      00  01  02      07  08  09  10      15  16  17  18      23  00
       *                          ^                       ^
       *                      timeStart               timeEnd
       */
      if (time < timeStart) {
        return time < startShift ? 1 : -1;
      }

      if (time < timeEnd) {
        return 0;
      }

      return time < startShift ? -1 : 1;
    }
    /*
     *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
     *      |XXX|XXX|X ... X|XXX|   |   |  ...  |   |   |XXX|X ... X|XXX|
     *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
     *      00  01  02      04  05  06  07      18  19  20  21      23  00
     *                          ^                       ^
     *                      timeEnd                 timeStart
     */


    if (time < timeEnd || time >= timeStart) {
      return 0;
    }

    return time < startShift ? 1 : -1;
  }
  /**
   * Returns the given `date` shifted forward (`direction` > 0) or backward (`direction` < 0) by the `startShift`.
   * @param {Number|Date} date The date as a `Date` or the millisecond UTC epoch.
   * @param {Number} direction A value > 0 to shift `date` forward, or < 0 to shift it backwards.
   * @returns {Date}
   */


  shiftDate(date, direction = 1) {
    const {
      startShift
    } = this,
          type = typeof date;
    date = type === 'number' ? new Date(date) : type === 'string' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parse(date) : new Date(date.getTime()); // Not this:
    // return (direction && startShift) ? DH.add(date, (direction > 0) ? startShift : -startShift, 'ms') : date;
    // the DH.add() goes via UTC timestamp and so will not end on the correct time of day when DST is hit

    if (direction && startShift) {
      date.setMilliseconds(direction > 0 ? startShift : -startShift);
    }

    return date;
  }
  /**
   * Returns `Date` object for the nearest started (shifted) day prior to the given `date`. The time of this `Date`
   * will be the `startShift`.
   *
   * It is possible for this date to be in the prior day on a midnight-based calendar. For example, if the `startShift`
   * is 6PM and `date` is 6AM on May 20, this method will return 6PM of May 19 (the nearest started day).
   * @param {Date} date The date for which to find the nearest started day.
   * @returns {Date}
   */


  startOfDay(date) {
    date = this.shiftDate(date, -1);
    date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(date);
    date = this.shiftDate(date);
    return date;
  }
  /**
   * TODO
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Number[]}
   */


  timeRange(startDate, endDate) {
    const [start, end] = this._dateRangeArgs(startDate, endDate);

    return [_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(start), _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(end)];
  }

  toString() {
    const {
      startShift,
      timeEnd,
      timeStart
    } = this,
          suffix = startShift ? `@${DayTime.format(startShift)}` : '',
          prefix = DayTime.format(timeStart);

    if (timeStart === timeEnd) {
      return startShift ? suffix : prefix;
    }

    return `${prefix}-${DayTime.format(timeEnd)}${suffix}`;
  }

  /**
   * Decodes the arguments and returns a pair of `Date` objects for the start and end of the date range.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Date[]}
   * @private
   */
  _dateRangeArgs(startDate, endDate) {
    return startDate.isModel ? [startDate.startDate, startDate.endingDate] : [startDate, endDate];
  }

}
/**
 * The `DayTime` instance representing a canonical calendar day (starting at midnight).
 * @member {Core.util.DayTime} MIDNIGHT
 * @static
 * @readonly
 */

DayTime.MIDNIGHT = new DayTime({
  startShift: 0,
  timeStart: 0,
  timeEnd: 24
});
DayTime.MILLIS_PER_MINUTE = MILLIS_PER_MINUTE;
DayTime.MILLIS_PER_HOUR = MILLIS_PER_HOUR;
DayTime.MILLIS_PER_DAY = MILLIS_PER_DAY;
DayTime._$name = 'DayTime';

/***/ }),

/***/ "./lib/Core/util/DynamicObject.js":
/*!****************************************!*\
  !*** ./lib/Core/util/DynamicObject.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicObject; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Core/util/DynamicObject
 */

const PENDING = Symbol('pendingCreate');
/**
 * This class is used to manage dynamic creation and configuration of individual properties of an object. This pattern
 * is used to allow the names of an object to each represent a dynamically instantiated object. For example, the
 * `features` config of Calendar is defined like so:
 *
 * ```javascript
 *  class Calendar extends ... {
 *      static get configurable() {
 *          return {
 *              features : {
 *                  drag : {
 *                      // configs for Drag feature
 *                  }
 *              }
 *          }
 *      }
 *  }
 * ```
 * This class is used to manage the `features` objects in the above case. The `drag` property value is promoted from
 * the config object defined by the class and user instance on first request. Like config properties themselves, these
 * features may access other features during their initialization. These accesses are trapped by this class to ensure
 * the config object is promoted to an instantiated instance.
 *
 * A {@link #config-factory} is provided to this object to allow it to create instances from names like `'drag'`.
 * @internal
 */

class DynamicObject extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get prototypeProperties() {
    return {
      /**
       * Optional function that will be passed an instance prior to destroying it.
       * @param {String} name The property name in the Dynamic object by which the new instance may be referenced.
       * @param {Object} instance The value of the property.
       * @config {Function}
       */
      cleanup: null,

      /**
       * Optional name of the config property managed by this instance. If changes are made directly, this
       * property is used to run the `onConfigChange` method of the `owner`.
       * @config {String}
       */
      configName: null,

      /**
       * Optional function to call as instances are created. Each new instance is passed to this function.
       * @param {Object} instance The newly created instance.
       * @param {String} key The property name in the dynamic object by which the new instance may be referenced.
       * @config {Function}
       */
      created: null,

      /**
       * The {@link Core.mixin.Factoryable factory} to use to create instances.
       * @config {Object}
       */
      factory: null,

      /**
       * By default, the name of the member is used for the type. Set this config to `true` to also allow the
       * config object for a property to contain a `type` property. Set this to `false` to ignore the name of the
       * member and rely on the {@link #config-factory} to process the config object.
       * @config {Boolean|String}
       * @default
       */
      inferType: 'name',

      /**
       * The owning object to pass along to the instances as the `ownerName` property.
       * @config {Object}
       */
      owner: null,

      /**
       * The property name by which to store the `owner` on each instance.
       * @config {String}
       */
      ownerName: null,

      /**
       * Set to `false` to prevent using a `Proxy` even if that JavaScript platform feature is available. Using
       * a `Proxy` is ideal because it allows for all forms of access to the dynamic properties to be handled
       * instead of only those that have predefined configuration values.
       * @config {Boolean}
       * @private
       */
      proxyable: typeof Proxy !== 'undefined',

      /**
       * Optional function that will be passed a config object prior to instantiating an object. This function
       * can either modify the passed object or return a new object.
       * @param {Object} config The config object used to create the object
       * @param {String} name The property name in the Dynamic object by which the new instance may be referenced.
       * @config {Function}
       */
      setup: null,

      /**
       * Optional function that will be passed a raw config object prior to processing and the value it returns
       * replaces the raw value. This function is used to transform strings or arrays (for example) into proper
       * config objects.
       * @param {*} config The original value of the config object parameter
       * @config {Function}
       */
      transform: null
    };
  }

  static get properties() {
    return {
      /**
       * Holds config objects for each defined object. These are used to hold class and instance config values
       * and use them to create instances on first request, or when `flush()` is called. Further, if the instance
       * is initially assigned instead of retrieved, these values act as the defaults for the instance and are
       * combined with those provided in the assignment.
       * @member {Object} defaults
       * @private
       */
      defaults: {},

      /**
       * This object holds the actual instances that are retrieved by the dynamic accessor or `Proxy`.
       * @member {Object} instances
       * @private
       */
      instances: {},

      /**
       * The object that contains the dynamic accessors for each instance. This object is not used when using a
       * `Proxy`.
       * @member {Object} object
       * @private
       */
      object: Object.create({})
    };
  }
  /**
   * Returns the `Proxy` instance used to manage dynamic assignments. If the JavaScript platform does not support the
   * `Proxy` class, this will be `null`.
   * @property {Proxy}
   * @private
   */


  get proxy() {
    const me = this;
    let proxy = null;

    if (me.proxyable) {
      proxy = new Proxy(me.instances, {
        get(o, name) {
          return me.get(name);
        },

        set(o, name, value) {
          me.set(name, value);
          return true;
        },

        deleteProperty(o, name) {
          me.set(name, null);
          return true;
        }

      });
    } // Replace our getter with the result for quicker future use.


    Reflect.defineProperty(me, 'proxy', {
      configurable: true,
      // allow destroy() to delete it
      value: proxy
    });
    return proxy;
  }
  /**
   * Returns the object that contains the dynamic properties. This may be a `Proxy` instance or an object with getter
   * and setter accessors.
   * @property {Object}
   * @internal
   */


  get target() {
    return this.proxy || this.object;
  }
  /**
   * This method establishes the initial definition of a dynamic property. When using a `Proxy`, this method simply
   * needs to cache away the initial config for use by the getter. When `Proxy` is unavailable, this method will
   * also defined a getter/setter to intercept access to the dynamic property.
   * @param {String} name The name of the dynamic property.
   * @param {Object} config The initial config object for the dynamic property.
   * @private
   */


  define(name, config) {
    const me = this,
          {
      transform
    } = me,
          transformed = transform ? transform(config, name) : config,
          instantiated = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isInstantiated(transformed);
    me.instances[name] = PENDING;

    if (!instantiated) {
      me.setDefaults(name, transformed);
    } // We provide get/set accessors on our `object` so that we can create the instance on first use and provide
    // the correct defaults. The setter also handles reassignment and reconfiguration. These accessors are
    // placed on the prototype of `object` so that we can add/remove the same accessors from `object` itself.
    // This allows users of the object to see the correct number of "own" keys for enumeration.


    me.defineProp(name, true);

    if (instantiated) {
      me.set(name, transformed);
    }
  }
  /**
   * Define the get/set accessors for `name` on our `object` or its prototype.
   * @param {String} name
   * @param {Boolean} [base] Pass `true` to indicate the property should be defined on the prototype.
   * @private
   */


  defineProp(name, base) {
    const me = this,
          {
      object
    } = me;

    if (!me.proxy) {
      Reflect.defineProperty(base ? Object.getPrototypeOf(object) : object, name, {
        configurable: !base,
        enumerable: true,

        get() {
          return me.get(name);
        },

        set(value) {
          return me.set(name, value);
        }

      });
    }
  }
  /**
   * Ensures that all defined members are touched to trigger their creation.
   * @internal
   */


  flush() {
    const me = this; // Iterate the defaults object to loop over all the defined items:

    try {
      var _me$afterConfigureOwn;

      me.updating = true;

      for (const name in me.defaults) {
        me.get(name);
      }

      me.afterConfigureOwner = (_me$afterConfigureOwn = me.afterConfigureOwner) === null || _me$afterConfigureOwn === void 0 ? void 0 : _me$afterConfigureOwn.call(me);
    } finally {
      me.updating = false;
    }
  }
  /**
   * Returns (lazily creating as necessary) the value of a dynamic property given its name.
   * @param {String} name
   * @returns {Object}
   * @private
   */


  get(name) {
    const {
      defaults,
      instances
    } = this;

    if (instances[name] === PENDING) {
      this.set(name, PENDING);
    } // Return null for defined instances that have been nulled out and undefined otherwise:


    return instances[name] || defaults[name] && null;
  }
  /**
   * Sets the value of a dynamic property given its name and value.
   * @param {String} name
   * @param {Object} value
   * @private
   */


  set(name, value) {
    const me = this,
          {
      cleanup,
      configName,
      defaults,
      factory,
      instances,
      owner,
      setup,
      transform,
      updating
    } = me,
          inform = owner && configName && !updating,
          was = instances[name] === PENDING ? null : instances[name],
          instance = factory.reconfigure(was, value === PENDING ? {} : value || null, {
      cleanup: cleanup && (instance => cleanup(instance, name)),
      defaults: defaults[name] || me.setDefaults(name, {}),
      owner: me.owner,
      setup: setup && ((config, type, defaults) => setup(config, name, type, defaults)),
      transform: transform && (config => transform(config, name))
    });

    if (instance !== was) {
      const before = inform && _objectSpread({}, instances);

      instances[name] = instance;

      if (instance) {
        var _me$created;

        me.defineProp(name);
        (_me$created = me.created) === null || _me$created === void 0 ? void 0 : _me$created.call(me, instance, name);
      } else {
        delete me.object[name];
        delete instances[name];
      }

      if (inform) {
        owner.onConfigChange({
          name: configName,
          config: owner.$meta.configs[configName],
          value: me.target,
          was: before
        });
      }
    }
  }
  /**
   * Stores the default config values for use in the factory reconfiguration process.
   * @param {String} name The name and default type of the dynamic property. Depending on {@link #config-inferType},
   * this may not be overridden by a type property in the config object.
   * @param {Object} config The config object.
   * @returns {Object}
   * @private
   */


  setDefaults(name, config) {
    const {
      defaults,
      factory,
      inferType,
      instances,
      owner,
      ownerName
    } = this,
          {
      typeKey
    } = factory.factoryable;
    config = config === true ? {} : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config); // copy props even from prototype

    if (inferType === 'name' || inferType === true && !config[typeKey]) {
      config[typeKey] = name;
    } // Store this object as the "owner" on the config object so instances can access their creating object:


    if (ownerName) {
      config[ownerName] = owner;
    }

    config.beforeConfigure = instance => {
      // Ensure the feature is injected into the features object before initialization so that it is
      // available to call chains from its initialization.
      instances[name] = instance;
    };

    return defaults[name] = config;
  }
  /**
   * Updates the members of `object` based on the provided configuration.
   * @param {Object} members The configuration for the instances of `object`.
   * @internal
   */


  update(members) {
    const me = this,
          {
      owner
    } = me;
    let name, config;

    try {
      me.updating = true;

      if (members) {
        // We prime the features so that if any configuration code accesses a feature, it will self initialize,
        // but if not, they will remain in a primed state until afterConfigure.
        for (name in members) {
          config = members[name];

          if (me.defaults[name]) {
            // if (already defined)
            me.set(name, config);
          } else if (config) {
            me.define(name, config);
          }
        } // NOTE: we leave alone any existing features that were not present in the given object. To remove a
        // feature, you must set it to null or set all features to null.

      } else {
        for (name in me.instances) {
          me.set(name, null);
        }
      }
    } finally {
      me.updating = false;
    }

    if (owner) {
      // Normally we wait for afterConfigure to create all the objects, but if we are being called after that
      // point in the life cycle, we need to flush them out now. We still use the same delay technique in case
      // the user adds multiple properties dynamically.
      if (!owner.isConfiguring) {
        me.flush();
      } else if (!me.afterConfigureOwner) {
        // Since we are being called while the owner isConfiguring, set a hook on owner.afterConfigure() so
        // that we can make good on creating the child objects.
        me.afterConfigureOwner = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].before(owner, 'afterConfigure', 'flush', me);
      }
    }
  }

}
DynamicObject.initClass();
DynamicObject._$name = 'DynamicObject';

/***/ }),

/***/ "./lib/Core/util/Month.js":
/*!********************************!*\
  !*** ./lib/Core/util/Month.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Month; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DayTime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';





/**
 * @module Core/util/Month
 */

/**
 * A class which encapsulates a calendar view of a month, and offers information about
 * the weeks and days within that calendar view.
 * ```
 *   // December 2018 using Monday as week start
 *   const m = new Month({
 *       date         : '2018-12-01',
 *       weekStartDay : 1
 *   });
 *
 *   m.eachWeek((week, dates) => console.log(dates.map(d => d.getDate())))
 * ```
 */

class Month extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * The date which the month should encapsulate. May be a `Date` object, or a
       * `YYYY-MM-DD` format string.
       *
       * Mutating a passed `Date` after initializing a `Month` object has no effect on
       * the `Month` object.
       * @config {Date|String}
       */
      date: {
        $config: {
          equal: 'date'
        },
        value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clearTime(new Date())
      },
      month: null,
      year: null,

      /**
       * The week start day, 0 meaning Sunday, 6 meaning Saturday.
       * Defaults to {@link Core.helper.DateHelper#property-weekStartDay-static}.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * Configure as `true` to have the visibleDayColumnIndex and visibleColumnCount properties
       * respect the configured {@link #config-nonWorkingDays}.
       * @config {Boolean}
       */
      hideNonWorkingDays: null,

      /**
       * Non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
       * Defaults to {@link Core.helper.DateHelper#property-nonWorkingDays-static}.
       * @config {Object}
       */
      nonWorkingDays: null,

      /**
       * Configure as `true` to always have the month encapsulate six weeks.
       * This is useful for UIs which must be a fixed height.
       * @config {Boolean}
       */
      sixWeeks: null
    };
  } //region events

  /**
   * Fired when setting the {@link #config-date} property causes the encapsulated date to change
   * in **any** way, date, week, month or year.
   * @event dateChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */

  /**
   * Fired when setting the {@link #config-date} property causes a change of week. Note that
   * weeks are calculated in the ISO standard form such that if there are fewer than four
   * days in the first week of a year, then that week is owned by the previous year.
   *
   * The {@link #config-weekStartDay} is honoured when making this calculation and this is a
   * locale-specific value which defaults to the ISO standard of 1 (Monday) in provided European
   * locales and 0 (Sunday) in the provided US English locale.
   * @event weekChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */

  /**
   * Fired when setting the {@link #config-date} property causes a change of month. This
   * will fire when changing to the same month in a different year.
   * @event monthChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
  */

  /**
   * Fired when setting the {@link #config-date} property causes a change of year.
   * @event yearChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */
  //endRegion

  /**
   * For use when this Month's `weekStartDay` is non-zero.
   *
   * An array to map the days of the week 0-6 of this Calendar to the canonical day numbers
   * used by the Javascript [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) object.
   * @member {Number[]} canonicalDayNumbers
   * @readonly
   */

  /**
   * An array to map a canonical day number to a *visible* column index.
   * For example, if we have `weekStartDay` as Monday which is 1, and non working days as
   * Wednesday, and `hideNonWorkingDays : true`, then the calendar would look like
   *
   *```
   * ┌────┬────┬────┬────┬────┬────┐
   * | Mo | Tu | Th | Fr | Sa | Su |
   * └────┴────┴────┴────┴────┴────┘
   *```
   *
   * So we'd need this array: `[ 5, 0, 1, undefined, 2, 3, 4]`
   * @member {Number[]} visibleDayColumnIndex
   * @readonly
   */

  /**
   * An array to map a canonical day number to a 0-6 column index.
   * For example, if we have `weekStartDay` as Monday which is 1, then the calendar would look like
   *
   *```
   * ┌────┬────┬────┬────┬────┬────┬────┐
   * | Mo | Tu | We | Th | Fr | Sa | Su |
   * └────┴────┴────┴────┴────┴────┴────┘
   *```
   *
   * So we'd need this array: `[ 6, 0, 1, 2, 3, 4, 5]`
   * @member {Number[]} dayColumnIndex
   * @readonly
   */

  /**
   * The number of visible days in the week as defined by the `nonWorkingDays` and
   * `hideNonWorkingDays` options.
   * @member {Number} weekLength
   * @readonly
   */


  configure(config) {
    super.configure(config);
    this.updateDayNumbers(); // The set is rejected during configuration because everything else has to be set up.

    if (config.date) {
      this.date = config.date;
    }
  }

  changeDate(date) {
    // Date has to be set after we know everything else
    if (this.isConfiguring) {
      return;
    }

    date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].parse(date, 'YYYY-MM-DD') : new Date(date);

    if (isNaN(date)) {
      throw new Error('Month date ingestion must be passed a Date, or a valid YYYY-MM-DD date string');
    }

    return date;
  }

  updateDate(newDate, oldDate) {
    const me = this,
          {
      dayColumnIndex
    } = me,
          monthStart = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getFirstDateOfMonth(newDate),
          monthEnd = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getLastDateOfMonth(monthStart),
          startWeekDay = dayColumnIndex[monthStart.getDay()],
          endWeekDay = dayColumnIndex[monthEnd.getDay()],
          yearChanged = !oldDate || newDate.getFullYear() !== oldDate.getFullYear(),
          // Collect changes as bitwise flags if we have any listeners:
    // 0001 = date has changed.
    // 0010 = week has changed.
    // 0100 = month has changed.
    // 1000 = year has changed.
    // We need this because 10/1/2010 -> 10/1/2011 must fire a dateChange
    // and a monthChange in addition to the yearChange.
    // And 10/1/2010 -> 10/2/2010 must fire a dateChange in addition to the monthChange.
    changes = me.eventListeners && (oldDate ? newDate.getDate() !== oldDate.getDate() | (me.getWeekId(newDate) !== me.getWeekId(oldDate)) << 1 | (newDate.getMonth() !== oldDate.getMonth()) << 2 | yearChanged << 3 : 15); // Keep our properties in sync with reality.
    // Access the private properties directly to avoid recursion.

    me._year = newDate.getFullYear();
    me._month = newDate.getMonth(); // These comments assume ISO standard of Monday as week start day.
    //
    // This is the date of month that is the beginning of the first week row.
    // So this may be -ve. Eg: for Dec 2018, Monday 26th Nov is the first
    // cell on the calendar which is the -4th of December. Note that the 0th
    // of December was 31st of November, so needs -4 to get back to the 26th.

    me.startDayOfMonth = 1 - startWeekDay; // This is the date of month that is the end of the last week row.
    // So this may be > month end. Eg: for Dec 2018, Sunday 6th Jan is the last
    // cell on the calendar which is the 37th of December.

    me.endDayOfMonth = monthEnd.getDate() + (6 - endWeekDay);

    if (me.sixWeeks) {
      me.endDayOfMonth += (6 - me.weekCount) * 7;
    } // Calculate the start point of where we calculate weeks from if we need to.
    // It's either the first "weekStartDay" in this year if this year's
    // first week is last year's, and so should work out as zero,
    // or the "weekStartDay" of the week before, so that dates in the first week
    // the Math.floor(DH.diff(weekBase, date, 'day') / 7) calculates as 1.


    if (!me.weekBase || yearChanged) {
      me.calculateWeekBase();
    }

    if (changes) {
      const event = {
        newDate,
        oldDate,
        changes: {
          d: true,
          w: Boolean(changes & 2),
          m: Boolean(changes & 12),
          y: Boolean(changes & 8)
        }
      }; // If either date, month or year changes, we fire a dateChange

      me.trigger('dateChange', event); // If the week has changed, fire a weekChange

      if (changes & 2) {
        me.trigger('weekChange', event);
      } // If month or year changed, we fire a monthChange


      if (changes & 12) {
        me.trigger('monthChange', event);
      } // If the year has changed, fire a yearChange


      if (changes & 8) {
        me.trigger('yearChange', event);
      }
    }
  }

  calculateWeekBase() {
    const me = this,
          {
      dayColumnIndex
    } = me,
          jan1 = new Date(me.year, 0, 1),
          dec31 = new Date(me.year, 11, 31),
          january = me.month ? me.getOtherMonth(jan1) : me; // First 7 days are in last week of previous year if the year
    // starts after our 4th day of week.

    if (me.dayColumnIndex[jan1.getDay()] > 3) {
      // Week base is calculated from the year start
      me.weekBase = january.startDate;
    } // First 7 days are in week 1 of this year
    else {
      // Week base is the start of week before
      me.weekBase = new Date(me.year, 0, january.startDayOfMonth - 7);
    }

    const dec31Week = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(me.weekBase, dec31, 'day') / 7); // Our year only has a 53rd week if 53rd week ends after our week's 3rd day

    me.has53weeks = dec31Week === 53 && dayColumnIndex[dec31.getDay()] > 2;
  }
  /**
   * Returns the week start date, based on the configured {@link #config-weekStartDay} of the
   * passed week.
   * @param {Number| Number[]} week The week number in the current year, or an array containing
   * `[year, weekOfYear]` for any year.
   *
   * Week numbers greater than the number of weeks in the year just wrap into the following year.
   */


  getWeekStart(week) {
    // Week number n of current year
    if (typeof week === 'number') {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(this.weekBase, Math.max(week, 1) * 7, 'day');
    } // Week n of year nnnn


    const me = this,
          [year, weekOfYear] = week; // nnnn is our year, so we know it

    if (year === me.year) {
      return me.getWeekStart(weekOfYear);
    }

    return me.getOtherMonth(new Date(year, 0, 1)).getWeekStart(weekOfYear);
  }

  getOtherMonth(date) {
    const me = this,
          result = me === otherMonth ? new Month(null) : otherMonth;
    result.configure({
      weekBase: null,
      weekStartDay: me.weekStartDay,
      nonWorkingDays: me.nonWorkingDays,
      hideNonWorkingDays: me.hideNonWorkingDays,
      sixWeeks: me.sixWeeks,
      date: new Date(date.getFullYear(), 0, 1) // Make it easy to calculate its own weekBase

    });
    result.date = date; // in this case, the date config ignores changes w/=== getTime so we have to force the update because we
    // also cleared weekBase above

    result.updateDate(result.date, result.date);
    return result;
  }

  changeYear(year) {
    const newDate = new Date(this.date);
    newDate.setFullYear(year); // changeDate rejects non-changes, otherwise a change event will be emitted

    this.date = newDate;
  }

  changeMonth(month) {
    const newDate = new Date(this.date);
    newDate.setMonth(month); // changeDate rejects non-changes, otherwise a change event will be emitted

    this.date = newDate;
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekStartDay;
  }

  updateWeekStartDay() {
    const me = this;
    me.updateDayNumbers();

    if (!me.isConfiguring && me.date) {
      me.weekBase = null; // force a calculateWeekBase

      me.updateDate(me.date, me.date);
    } // else date will be set soon and weekBase is null so calculateWeekBase will be called by updateDate

  }

  get nonWorkingDays() {
    return this._nonWorkingDays || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].nonWorkingDays;
  }

  changeNonWorkingDays(nonWorkingDays) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assign({}, nonWorkingDays);
  }

  updateNonWorkingDays() {
    this.updateDayNumbers();
  }

  updateHideNonWorkingDays() {
    this.updateDayNumbers();
  }

  updateSixWeeks() {
    if (!this.isConfiguring) {
      this.updateDate(this.date);
    }
  }
  /**
   * The number of days in the calendar for this month. This will always be
   * a multiple of 7, because this represents the number of calendar cells
   * occupied by this month.
   * @property {Number}
   * @readonly
   */


  get dayCount() {
    // So for the example month, Dec 2018 has 42 days, from Mon 26th Nov (-4th Dec) 2018
    // to Sun 6th Jan (37th Dec) 2019
    return this.endDayOfMonth + 1 - this.startDayOfMonth;
  }
  /**
   * The number of weeks in the calendar for this month.
   * @property {Number}
   * @readonly
   */


  get weekCount() {
    return this.dayCount / 7;
  }
  /**
   * The date of the first cell in the calendar view of this month.
   * @property {Date}
   * @readonly
   */


  get startDate() {
    const me = this;

    if (me.year != null && me.month != null && me.startDayOfMonth != null) {
      return new Date(me.year, me.month, me.startDayOfMonth);
    }
  }
  /**
   * The date of the last cell in the calendar view of this month.
   * @property {Date}
   * @readonly
   */


  get endDate() {
    const me = this;

    if (me.year != null && me.month != null && me.startDayOfMonth != null) {
      return new Date(me.year, me.month, me.endDayOfMonth);
    }
  }
  /**
   * Iterates through all calendar cells in this month, calling the passed function for each date.
   * @param {Function} fn The function to call.
   * @param {Date} fn.date The date for the cell.
   */


  eachDay(fn) {
    for (let dayOfMonth = this.startDayOfMonth; dayOfMonth <= this.endDayOfMonth; dayOfMonth++) {
      fn(new Date(this.year, this.month, dayOfMonth));
    }
  }
  /**
   * Iterates through all weeks in this month, calling the passed function
   * for each week.
   * @param {Function} fn The function to call.
   * @param {Number[]} fn.week An array containing `[year, weekNumber]`
   * @param {Date[]} fn.dates The dates for the week.
   */


  eachWeek(fn) {
    const me = this,
          {
      weekCount
    } = me;

    for (let dayOfMonth = me.startDayOfMonth, week = 0; week < weekCount; week++) {
      const weekDates = [],
            weekOfYear = me.getWeekNumber(new Date(me.year, me.month, dayOfMonth));

      for (let day = 0; day < 7; day++, dayOfMonth++) {
        weekDates.push(new Date(me.year, me.month, dayOfMonth));
      }

      fn(weekOfYear, weekDates);
    }
  }
  /**
   * Returns the week of the year for the passed date. This returns an array containing *two* values,
   * the year **and** the week number are returned.
   *
   * The week number is calculated according to ISO rules, meaning that if the first week of the year
   * contains less than four days, it is considered to be the last week of the preceding year.
   *
   * The configured {@link #config-weekStartDay} is honoured in this calculation. So if the weekStartDay
   * is **NOT** the ISO standard of `1`, (Monday), then the weeks do not coincide with ISO weeks.
   * @param {Date} date The date to calculate the week for.
   * @returns {Number[]} A numeric array: `[year, week]`
   */


  getWeekNumber(date) {
    const me = this;
    date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clearTime(date); // If it's a date in another year, use our otherMonth to find the answer.

    if (date.getFullYear() !== me.year) {
      return me.getOtherMonth(new Date(date.getFullYear(), 0, 1)).getWeekNumber(date);
    }

    let weekNo = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(me.weekBase, date, 'day') / 7),
        year = date.getFullYear(); // No week 0. It's the last week of last year

    if (!weekNo) {
      // Week is the week of last year's 31st Dec
      return me.getOtherMonth(new Date(me.year - 1, 0, 1)).getWeekNumber(new Date(me.year, 0, 0));
    } // Only week 53 if year ends before our week's 5th day
    else if (weekNo === 53 && !me.has53weeks) {
      weekNo = 1;
      year++;
    } // 54 wraps round to 2 of next year
    else if (weekNo > 53) {
      weekNo = weekNo % 52;
    } // Return array of year and week number


    return [year, weekNo];
  }

  getWeekId(date) {
    const week = this.getWeekNumber(date);
    return week[0] * 100 + week[1];
  }

  getCellData(date, ownerMonth, dayTime = _DayTime_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIDNIGHT) {
    const me = this,
          day = date.getDay(),
          visibleColumnIndex = me.visibleDayColumnIndex[day],
          isNonWorking = me.nonWorkingDays[day],
          isHiddenDay = me.hideNonWorkingDays && isNonWorking; // Automatically move to required month

    if (date < me.startDate || date > me.endDate) {
      me.month = date.getMonth();
    }

    return {
      day,
      dayTime,
      visibleColumnIndex,
      isNonWorking,
      week: me.getOtherMonth(date).getWeekNumber(date),
      key: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].format(date, 'YYYY-MM-DD'),
      columnIndex: me.dayColumnIndex[day],
      date: new Date(date),
      // These two properties are only significant when used by a CalendarPanel which encapsulates
      // a single month.
      isOtherMonth: Math.sign(date.getMonth() + date.getFullYear() * 12 - (ownerMonth.month + ownerMonth.year * 12)),
      visible: !isHiddenDay && date >= ownerMonth.startDate && date < _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(ownerMonth.endDate, 1, 'day'),
      tomorrow: dayTime.dayOfDate(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(date, 1, 'day')),
      isRowStart: visibleColumnIndex === 0,
      isRowEnd: visibleColumnIndex === me.visibleColumnCount - 1
    };
  }

  updateDayNumbers() {
    const me = this,
          {
      weekStartDay,
      nonWorkingDays,
      hideNonWorkingDays
    } = me,
          dayColumnIndex = me.dayColumnIndex = [],
          canonicalDayNumbers = me.canonicalDayNumbers = [],
          visibleDayColumnIndex = me.visibleDayColumnIndex = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
    // have mapping of internal day number to canonical day number (as used by Date class)
    // and to abbreviated day name like this:
    // canonicalDayNumbers = [1, 2, 3, 4, 5, 6, 0] // Use for translation from our day number to Date class's day number
    //
    // Also, we need a map from canonical day number to *visible* cell index.
    // for example, if we have weekStartDay as Monday which is 1, and non working days as
    // Wednesday, and hideNonWorkingDays:true, then the calendar would look like
    // +----+----+----+----+----+----+
    // | Mo | Tu | Th | Fr | Sa | Su |
    // +----+----+----+----+----+----+
    //
    // So we'd need this array
    // [ 5, 0, 1, undefined, 2, 3, 4]
    // Or think of it as this map:
    // {
    //      1 : 0,
    //      2 : 1,
    //      4 : 2,
    //      5 : 3,
    //      6 : 4,
    //      0 : 5
    // }
    // To be able to ascertain the cell index directly from the canonical day number.
    //
    // We also need a logical column map which would be
    // +----+----+----+----+----+----+----+
    // | Mo | Tu | We | Th | Fr | Sa | Su |
    // +----+----+----+----+----+----+----+
    //
    // So we'd need this array
    // [ 6, 0, 1, 2, 3, 4, 5]
    // Or think of it as this map:
    // {
    //      1 : 0,
    //      2 : 1,
    //      3 : 2
    //      4 : 3,
    //      5 : 4,
    //      6 : 5,
    //      0 : 6
    // }
    // We use this to cache the number of visible columns so that cell renderers can tell whether
    // they are on the last visible column.

    let visibleColumnIndex = 0;

    for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
      const canonicalDay = (weekStartDay + columnIndex) % 7;
      canonicalDayNumbers[columnIndex] = canonicalDay;
      dayColumnIndex[canonicalDay] = columnIndex; // If this day is going to have visible representation, we need to
      // map it to a columnIndex;

      if (!hideNonWorkingDays || !nonWorkingDays[canonicalDay]) {
        visibleDayColumnIndex[canonicalDay] = visibleColumnIndex++;
      }
    }

    me.visibleColumnCount = visibleColumnIndex;
    me.weekLength = hideNonWorkingDays ? 7 - _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].keys(nonWorkingDays).length : 7;
  }

} // Instance needed for internal tasks

const otherMonth = new Month(null);
Month._$name = 'Month';

/***/ }),

/***/ "./lib/Core/util/Parser.js":
/*!*********************************!*\
  !*** ./lib/Core/util/Parser.js ***!
  \*********************************/
/*! exports provided: memo, memoCps, success, failure, isSuccess, resolveParser, succeed, string, bind, seq, alt, regexp, red, runParser, defineParser, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memo", function() { return memo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoCps", function() { return memoCps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "success", function() { return success; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "failure", function() { return failure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSuccess", function() { return isSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveParser", function() { return resolveParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "succeed", function() { return succeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "string", function() { return string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seq", function() { return seq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alt", function() { return alt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regexp", function() { return regexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runParser", function() { return runParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineParser", function() { return defineParser; });
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';
 // The code is based on https://epsil.github.io/gll/ article (MIT license).

/**
 * @module Core/util/Parser
 */
// Tools. Maybe move it to memoization module.

let nextObjectIdentity = 0;
const objectIdentityMap = new WeakMap();

const argsToCacheKey = (...args) => args.map(arg => {
  let result;

  if (arg && typeof arg == 'object' || typeof arg == 'function') {
    result = objectIdentityMap.get(arg);

    if (result === undefined) {
      result = ++nextObjectIdentity;
      objectIdentityMap.set(arg, result);
    }
  } else {
    result = String(arg);
  }

  return result;
}).join('-');
/**
 * Generic memoization function. Wraps `fn` into higher order function which caches `fn` result
 * using stringified arguments as the cache key.
 *
 * @param {Function} fn function to memoize
 */


const memo = fn => {
  const mlist = new Map();
  return (...args) => {
    const mkey = argsToCacheKey(args);
    let result = mlist.get(mkey);

    if (result === undefined) {
      result = fn(...args);
      mlist.set(mkey, result);
    }

    return result;
  };
};
/**
 * Specific memoization function caches `fn` calls. `fn` should receive 2 arguments, the first one
 * is a string, and the second one is a callback which should be called by `fn` with some result.
 * The function returned wraps `fn` and it's callback such that `fn` would be called only once
 * with a particular first argument, other time callback will be called instantly with the result cached.
 *
 * @param {Function} fn function to memoize
 */

const memoCps = fn => {
  const table = new Map(),
        entryContinuations = entry => entry[0],
        entryResults = entry => entry[1],
        pushContinuation = (entry, cont) => entryContinuations(entry).push(cont),
        pushResult = (entry, result) => entryResults(entry).push(result),
        isResultSubsumed = (entry, result) => entryResults(entry).some(r => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isEqual(r, result)),
        makeEntry = () => [[], []],
        isEmptyEntry = entry => !entryResults(entry).length && !entryContinuations(entry).length,
        tableRef = str => {
    let entry = table.get(str);

    if (entry === undefined) {
      entry = makeEntry();
      table.set(str, entry);
    }

    return entry;
  };

  return (str, cont) => {
    const entry = tableRef(str);

    if (isEmptyEntry(entry)) {
      pushContinuation(entry, cont);
      fn(str, result => {
        if (!isResultSubsumed(entry, result)) {
          pushResult(entry, result);
          entryContinuations(entry).forEach(cont => cont(result));
        }
      });
    } else {
      pushContinuation(entry, cont);
      entryResults(entry).forEach(result => cont(result));
    }
  };
}; // End of tools

const SUCCESS = Symbol('success');
const FAILURE = Symbol('failure');
/**
 * Successful parsing result. Represented as array with 3 items:
 * - SUCCESS symbol which can be checked with {@link #function-isSuccess} function.
 * - Parsed payload
 * - Rest string left to parse
 *
 * @typedef {Array} SuccessResult
 */

/**
 * Creates successful parsing result with parsed `val` and unparsed `rest`
 *
 * @param {String} val Parsed value
 * @param {String} rest Unparsed rest
 * @return {SuccessResult}
 */

const success = (val, rest) => [SUCCESS, val, rest];
/**
 * Failure parsing result. Represented as array with 2 items:
 * - FAILURE symbol which can be checked with {@link #function-isSuccess} function
 * - Rest string left to parse
 *
 * @typedef {Array} FailureResult
 */

/**
 * Creates failed parsing result with unparsed `rest`
 *
 * @param {String} rest Unparsed rest
 * @return {FailureResult}
 */

const failure = rest => [FAILURE, rest];
/**
 * Checks if the given parsing `result` is successful
 *
 * @param {SuccessfulResult|FailureResult} result
 */

const isSuccess = result => result.length && result[0] === SUCCESS;
/**
 * Resolves parser when needed. Parser should be resolved if it's defined as a function
 * with no arguments which returns the actual parser function with more then one argument.
 *
 * @param {Function} p Parser factory
 * @return {Function} Combinable parser function
 */

const resolveParser = p => typeof p === 'function' && !p.length ? p() : p;
/**
 * Returns combinable parser which always return successful parsing result with `val`
 * as parsed result and string parsed as `rest`.
 *
 * @param {*} val Successful parsing result parsed payload
 * @return {Function} Combinable parser function
 *
 * @example
 * const sp = succeed('Ok');
 * sp('My string', (r) => console.dir(r)) // Will output successful parsing result with `Ok` payload and `My string` rest.
 */

const succeed = memo(val => memoCps((str, cont) => cont(success(val, str))));
/**
 * Returns combinable parser which succeeds if string parsed starts with `match`. The parsing
 * result will contain `match` as parsed result and rest of the string characters,
 * the ones after `match` as the unparsed rest.
 *
 * @param {String} match String to match
 * @return {Function} Combinable parser function
 *
 * @example
 * const mp = string('My');
 * mp('My string', (r) => console.dir(r)); // Will output successful parsing result with `My` payload and `string` rest.
 */

const string = memo(match => memoCps((str, cont) => {
  const len = Math.min(match.length, str.length),
        head = str.substr(0, len),
        tail = str.substr(len);
  cont(head === match ? success(head, tail) : failure(tail));
}));
/**
 * Binds parser or parser factory with a `fn` function which should receive one string argument
 * and return a combinable parser function.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn A function receiving one string argument and returning combinable parser function.
 *
 * @internal
 */

const bind = (p, fn) => (str, cont) => resolveParser(p)(str, result => {
  if (isSuccess(result)) {
    const [, val, rest] = result;
    fn(val)(rest, cont);
  } else {
    cont(result);
  }
});
/**
 * Combines several combined parser functions or combinable parser factories in sequence such that second starts after first succeeds
 * third after second etc, if first fails then second will not be called and so on.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const ab = seq(string('a'), string('b'));
 * ab('abc', (r) => console.dir(r)); // Will output successful parsing result with `ab` as parsed payload and `c` as the rest.
 */

const seq = memo((...parsers) => {
  const seq2 = memo((a, b) => memoCps(bind(a, x => bind(b, y => succeed([].concat(x, y))))));
  return parsers.reduce(seq2, succeed([]));
});
/**
 * Combines several combined parser functions or combinable parser factories in alteration such that successful parsing result will be passed into
 * a callback if one of those parsers succeeds.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const aorb = alt(string('a'), string('b'));
 * aorb('abc', (r) => console.dir(r)); // Will output successful parsing result with `a` as parsed payload and `bc` as the rest.
 * aorb('bbc', (r) => console.dir(r)); // Will output successfull parsing result with `b` as parsed payload and `bc` as the rest.
 */

const alt = memo((...parsers) => memoCps((str, cont) => parsers.forEach(p => resolveParser(p)(str, cont))));
/**
 * Creates combinable parser which succeeds if string to parse starts from a substring which succeeds for the regular expression
 * `pattern` the parser is created with.
 *
 * @param {String} pattern Regular expression pattern
 * @return {Function} Combinable parser function
 *
 * @example
 * const rp = regexp('a+');
 * rp('aaabb', (r) => console.dir(r)); // Will output successful parsing result with `aaa` as parsed payload and `bb` as the rest.
 */

const regexp = memo(pattern => (str, cont) => {
  const rexp = new RegExp(`^${pattern}`),
        match = rexp.exec(str);

  if (match) {
    const head = match[0],
          tail = str.substr(head.length);
    cont(success(head, tail));
  } else {
    cont(failure(str));
  }
});
/**
 * Creates reducing combinable parser function which should be used to create semantic actions
 * on parsed results.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn Semantic action function should be the same arity as the successful result arity
 *                      of `p` parser.
 * @return {Function} Combinable parser function
 *
 * @example
 * const nump = red(
 *     regexp('\d'),
 *     Number
 * );
 *
 * const plusp = string('+');
 *
 * const sump = red(
 *     seq(nump, plusp, nump),
 *     (a, _, b) => a + b
 * );
 *
 * sump('7+8', (r) => console.dir(r)); // Will return successful parsing result with `15` as parsing payload and `` as rest.
 */

const red = memo((p, fn) => bind(p, (...val) => succeed(fn(...[].concat.apply([], val)))));
/**
 * Runs combinable parsing function returning totally parsed results only, i.e. such results which have
 * parsed the `str` string completely.
 *
 * @param {Function} body Combinable parser function
 * @param {String} str String to parse
 * @return {SuccessfulResult[]} All totally parsed results possible for the given parsing function.
 */

const runParser = (body, str) => {
  const results = [];
  body(str, result => {
    if (isSuccess(result)) {
      const [,, left] = result;

      if (left === '') {
        results.push(result);
      }
    }
  });
  return results;
};
/**
 * Helper function for combinable parser definition supplements combinable parser function
 * returning a higher order function which when called with 2 arguments (string to parse and
 * a callback function) behaves exactly like parser function, but when called with 1 argument
 * it wraps call to parser function with {@link function-runParser} thus returning array of
 * totally parsed results.
 *
 * @param {Function} body Combinable parser function
 */

const defineParser = body => (str, cont) => cont ? resolveParser(body)(str, cont) : runParser(resolveParser(body), str); //Combines exports in an object such that it was possible to export parser utilities
// in UMD/module bundles.

/* harmony default export */ __webpack_exports__["default"] = ({
  memo,
  memoCps,
  success,
  failure,
  isSuccess,
  resolveParser,
  succeed,
  string,
  bind,
  seq,
  alt,
  regexp,
  red,
  runParser,
  defineParser
});

/***/ }),

/***/ "./lib/Core/util/ScrollManager.js":
/*!****************************************!*\
  !*** ./lib/Core/util/ScrollManager.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScrollManager; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';





/**
 * @module Core/util/ScrollManager
 */

/**
 * Monitors the mouse position over an element and scrolls the element if the cursor is close to edges. This is used by
 * various features to scroll the grid section element, for example dragging elements close to edges.
 *
 * ```javascript
 * // Instantiate manager for the container element having overflowing content
 * const manager = new ScrollManager({ element : document.querySelector('.container') });
 *
 * // Start monitoring. When pointer approaches 50px region within monitored element edge, scrolling begins
 * manager.startMonitoring();
 *
 * // Stop monitoring.
 * manager.stopMonitoring();
 * ```
 */

class ScrollManager extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Default config
  static get configurable() {
    return {
      /**
       * Default element to use for scrolling. Can be overridden in calls to `startMonitoring()`.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * Width in pixels of the area at the edges of an element where scrolling should be triggered
       * @config {Number}
       * @default
       */
      zoneWidth: 50,

      /**
       * Scroll speed, higher number is slower. Calculated as "distance from zone edge / scrollSpeed"
       * @config {Number}
       * @default
       */
      scrollSpeed: 5,

      /**
       * The direction(s) to scroll ('horizontal', 'vertical' or 'both')
       * @config {String}
       */
      direction: 'both',

      /**
       * Number of milliseconds to wait before scroll starts when the mouse is moved close to an edge monitored by this scroll manager
       * @config {Number}
       * @default
       */
      startScrollDelay: 500,

      /**
       * Set to true to stop scrolling when pointing device leaves the scrollable element.
       * @config {Boolean}
       * @default
       */
      // https://github.com/bryntum/support/issues/394
      stopScrollWhenPointerOut: false,
      testConfig: {
        scrollSpeed: 2,
        startScrollDelay: 0
      },
      activeScroll: {
        $config: ['lazy'],
        value: {}
      },
      monitoring: {
        $config: ['lazy', 'nullify'],
        value: true
      }
    };
  }

  changeMonitoring(value, was) {
    was === null || was === void 0 ? void 0 : was.clear();
    return new Map();
  } //endregion


  doDestroy() {
    this.stopMonitoring();
    super.doDestroy();
  }
  /**
   * Returns true if some of the monitored elements is being scrolled at the moment.
   * @property {Boolean}
   * @readonly
   */


  get isScrolling() {
    return Object.keys(this.activeScroll).length !== 0;
  } //region Start/stop monitoring

  /**
   * Starts monitoring an element. It will be scrolled if mouse is pressed and within `zoneWidth` pixels from element
   * edge. Supports monitoring multiple elements using `scrollables` option:
   *
   * ```javascript
   * new ScrollManager({ element : '.item' }).startMonitoring({
   *     scrollables : [
   *         {
   *             // Applies config to all elements matching `.item .child-item`
   *             // selector
   *             element : '.child-item',
   *             // Only manage vertical scroll
   *             direction : 'vertical',
   *             // Specific callback for this scrollable. Shared callback is
   *             // ignored.
   *             callback : () => console.log('Specific callback')
   *         },
   *         {
   *             // Instance can be used
   *             element : document.querySelector('.item .child2')
   *             // Direction and callback are not provided, so element will
   *             // be scrollable in horizontal direction and will use shared
   *             // callback
   *         }
   *     ],
   *     direction : 'horizontal',
   *     callback  : () => console.log('Shared callback')
   * })
   * ```
   *
   * @param {Object} config Element which might be scrolled or config { element, callback, thisObj }
   * @param {HTMLElement|String} [config.element] Element or selector. Overrides default element. **Deprecated**: use
   * `scrollables` instead
   * @param {String} [config.direction] Direction to scroll. Overrides default scroll direction
   * @param {Function} [config.callback] Callback to execute on every scroll of the target element.
   *
   * ```javascript
   * startMonitoring({
   *     callback(monitor) {
   *         // Current left and top scroll of the monitored element
   *         console.log(monitor.scrollLeft)
   *         console.log(monitor.scrollTop)
   *         // Scroll position relative to the initial position
   *         console.log(monitor.relativeScrollLeft)
   *         console.log(monitor.relativeScrollTop)
   *     }
   * })
   * ```
   *
   * @param {Object} [config.thisObj] Scope for the callback.
   * @param {Object[]} [config.scrollables] Array of configs if multiple elements should be monitored.
   * @param {HTMLElement|String} [config.scrollables.0.element] Element or selector.
   * @param {String} [config.scrollables.0.direction] Direction to scroll. Overrides upper config object direction.
   * @param {Function} [config.scrollables.0.callback] Callback to execute on every scroll of the target element.
   * Overrides upper config object callback.
   * @returns {Function} Returns function to cleanup instantiated monitors
   * ```javascript
   * const detacher = new ScrollManager({ element }).startMonitoring({ ... });
   * detacher(); // All monitors setup by the previous call are removed
   * ```
   */


  startMonitoring(config = {}) {
    const me = this,
          {
      element,
      direction: defaultDirection
    } = me,
          {
      scrollables = [],
      direction = defaultDirection,
      callback
    } = config,
          attachedElements = [];

    if (config.element) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('core', '5.0.0', '`element` config is deprecated, please use `scrollables` instead.');
      scrollables.push({
        element: config.element
      });
    }

    if (!scrollables.length) {
      scrollables.push({
        element
      });
    }

    scrollables.forEach(scrollable => {
      const target = scrollable.element;

      if (typeof target === 'string') {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEachSelector(element, target, element => {
          me.createMonitor(element, scrollable.direction || direction, scrollable.callback || callback);
          attachedElements.push(element);
        });
      } else {
        me.createMonitor(target, scrollable.direction || direction, scrollable.callback || callback);
        attachedElements.push(target);
      }
    });
    return function detacher() {
      var _me$stopMonitoring;

      // May have been destroyed when DragContext cleaner is called.
      (_me$stopMonitoring = me.stopMonitoring) === null || _me$stopMonitoring === void 0 ? void 0 : _me$stopMonitoring.call(me, attachedElements);
    };
  }

  createMonitor(element, direction, callback) {
    const {
      monitoring
    } = this;

    if (!monitoring.has(element)) {
      monitoring.set(element, new ScrollManagerMonitor({
        scrollManager: this,
        element,
        direction,
        callback
      }));
    }
  }
  /**
   * Stops monitoring an element. If no particular element is given, stop monitoring everything.
   * @param {HTMLElement|HTMLElement[]} [element] Element or array of elements for which monitoring is not desired any
   * more and should stop as soon as possible.
   */


  stopMonitoring(element) {
    const me = this,
          {
      monitoring
    } = me;

    if (element && !Array.isArray(element)) {
      element = [element];
    }

    if (monitoring) {
      // Stop all if no element given
      if (!element) {
        monitoring.forEach(monitor => me.stopMonitoring(monitor.element));
        return;
      }

      element.forEach(element => {
        const monitor = monitoring.get(element); // cant stop nothing...

        if (monitor) {
          monitor.destroy();
          monitoring.delete(element);
        }
      });
    }
  } //endregion

  /*
   * Attempts to reserve given scrolling direction for the given monitor.
   * @param {String} direction 'horizontal' or 'vertical'
   * @param {Object} monitor
   * @returns {Boolean} Returns true in case scroll direction was reserved for given monitor. False otherwise.
   * @private
   */


  requestScroll(direction, monitor) {
    const {
      activeScroll
    } = this;

    if (direction in activeScroll && activeScroll[direction] !== monitor) {
      return false;
    } else {
      activeScroll[direction] = monitor;
      return true;
    }
  }
  /*
   * Releases all scroll directions, blocked by given monitor
   * @param {Object} monitor
   * @private
   */


  releaseScroll(monitor) {
    const {
      activeScroll = {}
    } = this;
    Object.keys(activeScroll).forEach(key => {
      if (activeScroll[key] === monitor) {
        delete activeScroll[key];
      }
    });
  } //#region Scroll position


  getRelativeScroll(element, direction = 'left') {
    let result = 0;
    this.monitoring.forEach((monitor, monitoredElement) => {
      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isDescendant(monitoredElement, element)) {
        result += direction === 'left' ? monitor.scrollRelativeLeft : monitor.scrollRelativeTop;
      }
    });
    return result;
  } //#endregion


}

class ScrollManagerMonitor extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  construct(config) {
    const me = this,
          {
      element
    } = config,
          startScrollLeft = element.scrollLeft,
          startScrollTop = element.scrollTop;
    Object.assign(config, {
      startScrollLeft,
      startScrollTop
    });
    super.construct(config); // listen to mousemove to determine if scroll needed or not

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      scroll: 'onElementScroll',
      mousemove: 'onMouseMove',
      touchmove: 'onMouseMove',
      // Capture pointermove events early to start scrolling from top elements
      capture: true,
      thisObj: me
    }); // `pointerleave` should have `capture: false`, otherwise it works much like `pointerout`

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      pointerleave: 'onPointerLeave',
      thisObj: me
    });
  }

  doDestroy() {
    this.stopScroll();
    super.doDestroy();
  }
  /**
   * Starts scrolling (see #performScroll). Called from onMouseMove.
   * @private
   */


  startScroll() {
    this.scrolling = true;
    this.performScroll();
  }
  /**
   * Stops scrolling. Called from onMouseMove.
   * @private
   */


  stopScroll() {
    const me = this;
    me.scrolling = false;

    if (me.scrollRequested) {
      me.scrollManager.cancelAnimationFrame(me.frameId);
      me.scrollRequested = false;
    }

    me.scrollManager.clearTimeout(me.scrollTimeout);
    me.scrollManager.releaseScroll(me);
    me.scrollTimeout = null;
  }

  onPointerLeave() {
    this.scrollManager.stopScrollWhenPointerOut && this.stopScroll();
  }
  /**
   * Listener for mouse move on monitored element. Determines if scrolling is needed, and if so how fast to scroll.
   * See #zoneWidth & #scrollSpeed configs.
   * @private
   * @param {MouseEvent} event
   */


  onMouseMove(event) {
    const me = this,
          {
      scrollManager
    } = me,
          box = me.element.getBoundingClientRect(),
          width = scrollManager.zoneWidth,
          speed = scrollManager.scrollSpeed; // scroll left, right, up or down?

    me.scrollDeltaX = me.scrollDeltaY = 0;

    if (me.direction !== 'vertical') {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = me.element; // Only start scrolling if it is possible

      if (event.clientX > box.right - width && scrollWidth - scrollLeft - clientWidth >= 1) {
        me.scrollDeltaX = Math.round((width - (box.right - event.clientX)) / speed) + 1;
      } else if (event.clientX < box.left + width && scrollLeft > 0) {
        me.scrollDeltaX = -Math.round((width + (box.left - event.clientX)) / speed) - 1;
      }
    }

    if (me.direction !== 'horizontal') {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = me.element; // Only start scrolling if it is possible

      if (event.clientY > box.bottom - width && scrollHeight - scrollTop - clientHeight >= 1) {
        me.scrollDeltaY = Math.round((width - (box.bottom - event.clientY)) / speed) + 1;
      } else if (event.clientY < box.top + width && scrollTop > 0) {
        me.scrollDeltaY = -Math.round((width + (box.top - event.clientY)) / speed) - 1;
      }
    }

    if (me.scrollDeltaX !== 0 && !scrollManager.requestScroll('horizontal', me)) {
      me.scrollDeltaX = 0;
    }

    if (me.scrollDeltaY !== 0 && !scrollManager.requestScroll('vertical', me)) {
      me.scrollDeltaY = 0;
    }

    if (me.scrollDeltaX === 0 && me.scrollDeltaY === 0) {
      me.stopScroll();
    } else if (!me.scrollTimeout) {
      me.scrollTimeout = scrollManager.setTimeout(() => me.startScroll(), scrollManager.startScrollDelay);
    }
  }
  /**
   * Scrolls by an amount determined by config.scrollDeltaX/Y on each frame. Start/stop by calling #startScroll and
   * #stopScroll.
   * @private
   */


  performScroll() {
    const me = this,
          {
      element
    } = me; // this function is called repeatedly on each frame for as long as scrolling is needed
    // check that scrolling is needed

    if (me.scrolling && !me.scrollRequested) {
      // Scroll the determined amount of pixels if possible
      if (me.scrollDeltaX !== 0) {
        const oldScrollLeft = element.scrollLeft,
              newScrollLeft = Math.min(oldScrollLeft + me.scrollDeltaX, element.scrollWidth - element.clientWidth);

        if (newScrollLeft !== oldScrollLeft) {
          element.scrollLeft = newScrollLeft;
        }
      }

      if (me.scrollDeltaY !== 0) {
        const oldScrollTop = element.scrollTop,
              newScrollTop = Math.min(oldScrollTop + me.scrollDeltaY, element.scrollHeight - element.clientHeight);

        if (newScrollTop !== oldScrollTop) {
          element.scrollTop = newScrollTop;
        }
      } // scroll some more on next frame


      me.scrollRequested = true;
      me.frameId = me.scrollManager.requestAnimationFrame(() => {
        me.scrollRequested = false;
        me.performScroll(me);
      });
    }
  }

  onElementScroll() {
    var _this$config, _this$config$callback;

    (_this$config = this.config) === null || _this$config === void 0 ? void 0 : (_this$config$callback = _this$config.callback) === null || _this$config$callback === void 0 ? void 0 : _this$config$callback.call(this.thisObj || this.scrollManager, this);
  }

  get scrollLeft() {
    return this.element.scrollLeft;
  }

  get scrollTop() {
    return this.verticalElement ? this.verticalElement.scrollTop : this.element.scrollTop;
  }

  get scrollRelativeLeft() {
    return this.scrollLeft - this.startScrollLeft;
  }

  get scrollRelativeTop() {
    return this.scrollTop - this.startScrollTop;
  } // There could be several scrollables controlling different axes. If we want to calculate combined scroll from all
  // those monitors (e.g. for the case when we drag scheduler event in both directions), we should ask scroll manager
  // to iterate over monitored elements and aggregate scroll.


  getRelativeLeftScroll(element) {
    return this.scrollManager.getRelativeScroll(element, 'left');
  }

  getRelativeTopScroll(element) {
    return this.scrollManager.getRelativeScroll(element, 'top');
  }

}

ScrollManager._$name = 'ScrollManager';

/***/ }),

/***/ "./lib/Core/util/drag/DragContext.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/drag/DragContext.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragContext; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';








/**
 * @module Core/util/drag/DragContext
 */

const ABORTED = Symbol('dragAbort'),
      // Drag has been aborted
INIT = Symbol('dragInit'),
      // Button is down but insufficient movement to start the drag
DRAGGING = Symbol('dragDrag'),
      // Button is down and movement has started a drag
DROPPED = Symbol('dragDrop'),
      // Button has been released and drop has occurred
lockDirections = {
  x: 'horizontal',
  y: 'vertical'
};
/**
 * This class is created during drag operations of {@link Core/mixin/Draggable}. It holds the state of an ongoing drag
 * operation.
 * @extends Core/Base
 * @internal
 */

class DragContext extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  static get configurable() {
    return {
      /**
       * The element that will have the {@link Core.mixin.Draggable#property-draggingItemCls}. This element is
       * determined by the {@link Core.mixin.Draggable#config-dragItemSelector}.
       * @config {HTMLElement}
       */
      itemElement: null,

      /**
       * The `ScrollManager` instance to use for scrolling while dragging.
       * @config {Core.util.ScrollManager}
       * @private
       */
      scrollManager: null,

      /**
       * Config for `startMonitoring` call.
       * @config {Object}
       * @private
       */
      monitoringConfig: null,

      /**
       * The source of the drag operation.
       * @config {Core.mixin.Draggable}
       * @default
       * @readonly
       */
      source: null,

      /**
       * The current target of the drag.
       * @member {Core.mixin.Droppable}
       * @readonly
       */
      target: null,

      /**
       * The current target element of the drag.
       * @member {HTMLElement}
       * @private
       */
      targetElement: null,

      /**
       * The minimum distance from the touchstart/mousedown/pointerdown that must be moved to actually start a
       * drag operation.
       * @config {Number}
       * @default
       * @readonly
       */
      threshold: 5,

      /**
       * The minimum amount of time a touch must be maintained before it will initiate a drag. Movement prior to
       * this time will cancel the drag in order to allow touch scrolling.
       * @config {Number}
       * @default
       */
      touchStartDelay: 300
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * The current DOM event being processed.
   * @member {Event} event
   * @readonly
   */


  construct(...args) {
    super.construct(...args);
    const me = this,
          {
      event
    } = me;
    Object.assign(me, {
      /**
       * This property holds the `altKey` state of the most recent event.
       * @member {Boolean}
       */
      altKey: null,

      /**
       * An array of functions to call when cleaning up the context instance.
       * @member {Function[]}
       * @private
       */
      cleaners: [],

      /**
       * This property holds the `ctrlKey` state of the most recent event.
       * @member {Boolean}
       */
      ctrlKey: null,

      /**
       * Container for data associated with the drag. Data items are added by the {@link Core.mixin.Draggable}
       * when the drag starts.
       * @member {Map}
       * @private
       */
      data: new Map(),

      /**
       * The element from which the drag operation started.
       * @member {HTMLElement}
       * @readonly
       */
      element: event.target,

      /**
       * The event that completed the drag (a `mouseup`, `pointerup` or `touchend`).
       * @member {Event}
       * @readonly
       */
      endEvent: null,

      /**
       * The most recent `mousemove`, `pointermove` or `touchmove` event.
       * @member {Event}
       * @private
       */
      lastMoveEvent: null,

      /**
       * This property holds the `metaKey` state of the most recent event.
       * @member {Boolean}
       */
      metaKey: null,

      /**
       * The previous {@link #property-target} of the drag.
       * @member {Core.mixin.Droppable}
       * @readonly
       */
      previousTarget: null,

      /**
       * The scroll actions reported by the {@link #config-scrollManager}.
       * @member {Object}
       * @private
       */
      scrollerAction: null,

      /**
       * This property holds the `shiftKey` state of the most recent event.
       * @member {Boolean}
       */
      shiftKey: null,

      /**
       * This property holds the current state of the drag process.
       *
       * This will be one of the following values:
       *
       *  - `DragContext.STATE.INIT` - The button is down but there is insufficient movement to start the drag.
       *  - `DragContext.STATE.DRAGGING` - The button is down and movement has started the drag.
       *  - `DragContext.STATE.DROPPED` - The button has been released and drop has occurred.
       *  - `DragContext.STATE.ABORTED` - The drag has been aborted (this happens if the user presses the `ESC`
       *    key or if the {@link #function-abort} method is called).
       *
       * @member {Symbol}
       * @readonly
       * @internal
       */
      state: INIT,

      /**
       * The event that started the drag operation.
       * @member {Event}
       * @readonly
       */
      startEvent: event,

      /**
       * The timer that fires when a touch pointermove is allowed to start the drag. A touch pointermove event
       * prior to this will `abort()` the drag to allow touch scrolling.
       * @member {Number}
       * @private
       */
      touchStartTimer: null,

      /**
       * Stores the value from writes to the {@link #property-valid} property.
       * @member {Boolean}
       * @private
       */
      _valid: true
    });

    if ('touches' in event && me.touchStartDelay) {
      me.touchStartTimer = me.setTimeout(() => me.touchStartTimer = null, me.touchStartDelay, 'touchStartDelay');
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: window,
      blur: 'onWindowBlur',
      thisObj: me
    });
  }

  doDestroy() {
    const me = this,
          {
      source,
      target
    } = me;
    me.cleanup();

    if ((target === null || target === void 0 ? void 0 : target.dropping) === me) {
      target.dropping = null;
    }

    if ((source === null || source === void 0 ? void 0 : source.dragging) === me) {
      source.dragging = null;
    }

    super.doDestroy();
  }

  onWindowBlur() {
    if (this.started) {
      this.abort();
    }
  }
  /**
   * This property is `true` if the {@link #function-abort} method was called and `false` otherwise. This
   * is typically because the user pressed the ESC key, however, a drag can be aborted for other reasons.
   * @property {Boolean}
   * @readonly
   */


  get aborted() {
    return this.state === ABORTED;
  }
  /**
   * Returns `true` if the drag has completed either by mouse/pointerup or the {@link #function-abort} method.
   * @property {Boolean}
   * @readonly
   */


  get completed() {
    return this.isDestroying || this.aborted || this.endEvent !== null;
  }
  /**
   * This property is `true` if the drag {@link #config-threshold} has not yet been reached.
   * @property {Boolean}
   * @readonly
   */


  get pending() {
    return this.state === INIT;
  }
  /**
   * This property is `true` if the drag {@link #config-threshold} has been reached and the drag operation is active.
   * @property {Boolean}
   * @readonly
   */


  get started() {
    return this.state !== INIT && !this.aborted;
  }
  /**
   * This property is `true` when the drag is in a valid drop state. This can be set to `false` to indicate the drop
   * is invalid. Setting to `true` does not ensure that the property will be `true` when next read due to other factors
   * that are required to make the drop valid. For example, setting `valid = true` will still return `false` if called
   * before the drag {@link #config-threshold} has not been reached or if the {@link #function-abort} method has been
   * called.
   * @property {Boolean}
   */


  get valid() {
    return this.started && this.targetElement != null && this._valid;
  }

  set valid(v) {
    this._valid = v;
  } //region Data Access

  /**
   * Retrieves a data item from the drag source. This method can only be called after the drag has completed.
   * @param {String|String[]} name The name of the data item.
   * @returns {*}
   * @async
   */


  async get(name) {
    if (this.aborted) {
      throw new Error('Data is not available on aborted drag');
    }

    if (!this.completed) {
      throw new Error('Data is not available until drag completion');
    }

    if (Array.isArray(name)) {
      return Promise.all(name.map(s => this.get(s)));
    }

    let value = this.data.get(name);

    if (typeof value === 'function') {
      value = await value();
      this.data.set(name, value);
    }

    return value;
  }
  /**
   * Returns `true` if the named data item is present.
   * @param {String} name The name of the data item.
   * @returns {Boolean}
   */


  has(name) {
    return this.data.has(name);
  }
  /**
   * Retrieves a data item from the drag source if it is available. This will return `true` for an item that was
   * {@link #function-set} using a renderer function.
   * @param {String|String[]} name The name of the data item.
   * @returns {*}
   */


  peek(name) {
    if (this.aborted) {
      throw new Error('Data is not available on aborted drag');
    }

    if (Array.isArray(name)) {
      return name.map(s => this.peek(s));
    }

    let value = this.data.get(name);

    if (typeof value === 'function') {
      value = true;
    }

    return value;
  }
  /**
   * Sets a data item for the drag. If a function is passed, it is called to render the data only if that data is
   * actually requested via the {@link #function-get} method. A data renderer function can be `async`.
   * @param {String} name The name of the data item.
   * @param {*} value The value of the data item.
   */


  set(name, value) {
    this.data.set(name, value);
  } //endregion
  //region Configs


  changeTarget(target, was) {
    if (target !== was) {
      const me = this;
      me._target = target;
      me.previousTarget = was;

      if (was) {
        was.dropping = null;
      }

      if (target) {
        target.dropping = me; // calls dragEnter/Leave on the target

        if (target.dropping !== me) {
          // if (target did not accept us)
          target = null;
          me.valid = false;
        }
      }

      me._target = was;
    }

    return target;
  }

  updateTarget(target, was) {
    const me = this;

    if (was) {
      me.source.dragLeaveTarget(me, was);
    }

    if (target) {
      me.valid = true; // Always give the target an initial dragMove since feedback/indicators will need to update on move and
      // the lack of a move on entry will just make that a special case.

      target.dragMove(me);
      me.source.dragEnterTarget(me);
    }
  }

  updateTargetElement(targetElement) {
    let droppable, droppables, droppableSelector, i, t; // We interrogate all encapsulating DOM elements to see if we are in a Droppable's element.
    // If we find an element which has Droppables registered for it, we attempt to set each as
    // our target, and go with the first one that accepts us.
    // changeTarget sets target.dropping to this Context, and the target's dragEnter implementation
    // may reject it by returning false.

    for (t = targetElement; t; t = t.parentElement) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].get(t, 'droppables');

      if (droppables) {
        for (i = 0; i < droppables.length; ++i) {
          droppable = droppables[i]; // If the event target is *inside* the Droppable's root, we can ask the Droppable
          // to accept this DragContext.
          // Otherwise we can get a hit on borders.

          if (droppable.dropRootElement.contains(targetElement)) {
            droppableSelector = droppable.droppableSelector; // If the target element is not inside the Droppable's selector, give up.

            if (!droppableSelector || targetElement.closest(`#${_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getId(droppable.dropRootElement)} ${droppableSelector}`)) {
              this.target = droppable; // The found Droppable accepted this DragContext, so we're done -
              // we are using this Droppable.

              if (this.target === droppable) {
                return;
              }
            }
          }
        }
      }
    }
  } //endregion
  //region Operations

  /**
   * Aborts the drag. After calling this method, {@link #property-aborted} will be `true`, {@link #property-valid}
   * will be `false` and {@link #property-completed} will be `true`.
   */


  abort() {
    const me = this,
          {
      element,
      source
    } = me; // Force a synchronous layout so that transitions from this point will work.

    element === null || element === void 0 ? void 0 : element.getBoundingClientRect();

    if (me.state !== DROPPED) {
      me.state = ABORTED;
      me.cleanup();
    }

    source === null || source === void 0 ? void 0 : source.endDrag(me);
  }

  begin() {
    const me = this,
          {
      source
    } = me,
          ret = source.beforeDrag(me);

    if (ret !== false) {
      source.dragging = me;
    }

    return ret;
  }

  cleanup() {
    let cleaner;

    while (cleaner = this.cleaners.pop()) {
      cleaner();
    }
  }

  end(event) {
    const me = this,
          {
      lastMoveEvent: lastEvent,
      target
    } = me,
          {
      dragSwallowClickTime
    } = me.source;
    me.event = me.endEvent = event;
    me.syncFlags();

    if (me.started) {
      if ((lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientX) !== event.clientX || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientY) !== event.clientY || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.target) !== event.target) {
        // Make sure the drop event is preceded by a move to the final position...
        me.track();
      }

      if (dragSwallowClickTime) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
          element: document,
          capture: true,
          expires: dragSwallowClickTime,
          // In case a click did not ensue, remove the listener
          once: true,

          click(event) {
            event.stopPropagation();
          }

        });
      }

      me.state = DROPPED;

      if (target !== me.source) {
        // If we are the target and not also the source, we need to call dragDrop() now. If we are
        // the source, dragDrop() will be called by Draggable.
        target === null || target === void 0 ? void 0 : target.dragDrop(me);
      }
    }
  }

  fakeKey(event, down) {
    const me = this,
          {
      lastMoveEvent
    } = me;

    if (lastMoveEvent && me.element) {
      let changed; // Indicate that this is a 'fake' mousemove event as a result of the keydown

      lastMoveEvent.isKey = true;

      if (event.key === 'Alt') {
        if (me.altKey !== down) {
          me.altKey = down;
          changed = true;
        }
      } else if (event.key === 'Control') {
        if (me.ctrlKey !== down) {
          me.ctrlKey = down;
          changed = true;
        }
      }

      if (changed) {
        me.event = lastMoveEvent;
        me.track();
      }
    }
  }

  keyDown(event) {
    if (!this.completed) {
      if (event.key === 'Escape') {
        this.abort();
      } else if (this.isDragToggleKey(event.key)) {
        this.fakeKey(event, true);
      }
    }
  }

  keyUp(event) {
    if (!this.completed && this.isDragToggleKey(event.key)) {
      this.fakeKey(event, false);
    }
  }

  getDistance(event) {
    return _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDistanceBetween(this.startEvent, event);
  }

  isDragToggleKey(key) {
    return key === 'Control' || key === 'Alt';
  }

  move(event) {
    const me = this,
          {
      target
    } = event,
          distance = me.getDistance(event),
          significant = distance >= me.threshold;
    me.syncFlags();

    if (me.touchStartTimer) {
      if (significant) {
        me.abort();
      }

      return;
    }

    if (target && target.nodeType === Node.ELEMENT_NODE) {
      if (significant && !me.started) {
        me.event = event; // triggers beforeDragStart, dragStart. returning false from beforeDragStart aborts drag

        if (me.start() === false) {
          me.abort();
          return;
        }
      }

      if (me.started) {
        me.lastMoveEvent = me.event = event; // to prevent view drag (scroll) on ipad

        if (event.type === 'touchmove') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        me.track();
      }
    }
  }

  start() {
    const me = this,
          {
      scrollManager,
      monitoringConfig,
      source
    } = me,
          {
      draggingBodyCls: activeCls,
      dragLock
    } = source,
          element =
    /* source.dragWithin || */
    source.dragRootElement;
    me.state = DRAGGING; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

    if (scrollManager) {
      const detacher = scrollManager.startMonitoring(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].merge({
        scrollables: [{
          element
        }],
        direction: lockDirections[dragLock] || dragLock || 'both',

        callback(scrollerAction) {
          const {
            lastMoveEvent
          } = me;

          if (lastMoveEvent && me.element) {
            // Indicate that this is a 'fake' mousemove event as a result of the scrolling
            lastMoveEvent.isScroll = true;
            me.event = lastMoveEvent;
            me.scrollerAction = scrollerAction;
            me.track();
            me.scrollerAction = null;
          }
        }

      }, monitoringConfig));
      me.cleaners.push(detacher);
    } // Global informational class for when DragHelper is dragging


    const rootEl = source.dragRootElement.closest('.b-outer') || document.body;
    rootEl.classList.add(activeCls);
    me.cleaners.push(() => rootEl.classList.remove(activeCls));

    if (source.startDrag(me) === false) {
      me.cleanup();
      return false;
    }
  }

  syncFlags() {
    const me = this,
          {
      event
    } = me;
    me.altKey = event.altKey;
    me.ctrlKey = event.ctrlKey;
    me.metaKey = event.metaKey;
    me.shiftKey = event.shiftKey;
  }

  track() {
    const me = this,
          {
      event,
      source,
      target
    } = me;
    let targetElement = event.target,
        touch; // NOTE: we cannot syncFlags here since we are called to pass along keydown events as movement updates
    // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
    // what's under the cursor as easily in touch devices

    if (event.type === 'touchmove') {
      touch = event.changedTouches[0]; // From MDN:
      //  * clientX/Y - the coordinates of the touch point relative to the left/top edge of the browser viewport,
      //    not including any scroll offset.
      //  * The elementFromPoint() method returns the topmost Element at the specified coordinates (relative to
      //    the viewport).

      targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].elementFromPoint(touch.clientX, touch.clientY);
    }

    me.targetElement = targetElement; // when we change elements, update me.target

    if (target === me.target) {
      // if we have a target and that did not change due to setting targetElement, we need to inform the target
      // of the drag move
      target === null || target === void 0 ? void 0 : target.dragMove(me);
    }

    source.trackDrag(me);
  } //endregion


}
DragContext.prototype.STATE = DragContext.STATE = Object.freeze({
  ABORTED,
  INIT,
  DRAGGING,
  DROPPED
});
DragContext._$name = 'DragContext';

/***/ }),

/***/ "./lib/Core/util/drag/DragProxy.js":
/*!*****************************************!*\
  !*** ./lib/Core/util/drag/DragProxy.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragProxy; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
var productName = 'gantt';


/**
 * @module Core/util/drag/DragProxy
 */

/**
 * Drag proxies are helper classes that represent the object being dragged in some visual way. This is an abstract
 * base with which particular drag proxy classes (such as, {@link Core.util.drag.DragTipProxy} are registered.
 *
 * Derived classes the various template methods of this class to manage their particular form of visual feedback.
 * @extends Core/Base
 * @internal
 */

class DragProxy extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get type() {
    return 'default';
  }

  static get configurable() {
    return {
      /**
       * The currently active `DragContext`. This context will be active prior to be passed to the proxy. This
       * config is set by {@link #function-dragStart} and cleared by {@link #function-dragEnd}.
       * @config {Core.util.drag.DragContext}
       */
      dragging: null
    };
  }

  static get factoryable() {
    return {
      defaultType: DragProxy
    };
  }
  /**
   * The `Draggable` instance that owns this drag proxy.
   * @member {Core.mixin.Draggable} owner
   * @readonly
   */
  //region Configs


  updateDragging(drag, was) {
    if (was) {
      this.close(was);
    }

    if (drag) {
      this.open(drag);
    }
  } //endregion
  //region Operations

  /**
   * This template method is called when {@link #config-dragging} is reset to `null`.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  close(drag) {// template
  }
  /**
   * This template method is called when {@link #config-dragging} is set to a non-`null` value.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  open(drag) {// template
  } //endregion
  //region Drag Processing

  /**
   * This template method is called by the `Draggable` instance when the drag officially starts.
   * This sets the {@link #config-dragging} config to `drag`, which triggers the call to {@link #function-open}.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragStart(drag) {
    this.dragging = drag;
  }
  /**
   * This template method is called by the `Draggable` instance as drag movement occurs.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragMove(drag) {// template
  }
  /**
   * This template method is called by the `Draggable` instance when the drag completes.
   *
   * This sets the {@link #config-dragging} config to `null`, which triggers the call to {@link #function-close}.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragEnd(drag) {
    this.dragging = null;
  } //endregion


}
DragProxy.initClass();
DragProxy._$name = 'DragProxy';

/***/ }),

/***/ "./lib/Core/util/drag/DragTipProxy.js":
/*!********************************************!*\
  !*** ./lib/Core/util/drag/DragTipProxy.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragTipProxy; });
/* harmony import */ var _DragProxy_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';




/**
 * @module Core/util/drag/DragTipProxy
 */

/**
 * This drag proxy manages a {@link #config-tooltip} (or derived class) and aligns the tooltip to the current drag
 * position adjusted by the {@link #config-align} config.
 * @extends Core/util/drag/DragProxy
 * @classtype tip
 * @internal
 */

class DragTipProxy extends _DragProxy_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'tip';
  }

  static get configurable() {
    return {
      /**
       * Controls how the tooltip will be aligned to the current drag position.
       *
       * See {@link Core.helper.util.Rectangle#function-alignTo} for details.
       * @config {String}
       * @default
       */
      align: 't10-b50',

      /**
       * The number of pixels to offset from the drag position.
       * @config {Number}
       * @default
       */
      offset: 20,

      /**
       * The tooltip to be shown, hidden and repositioned to track the drag position.
       * @config {Core.widget.Tooltip}
       */
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'tooltip'
        }
      }
    };
  }

  open() {
    this.getConfig('tooltip'); // trigger creation
  }

  close() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.hide();
  }

  dragMove(drag) {
    const {
      offset,
      tooltip
    } = this,
          {
      event
    } = drag;

    if (tooltip) {
      if (!tooltip.isVisible) {
        tooltip.show();
      }

      tooltip.alignTo({
        align: this.align,
        target: new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"](event.clientX - offset, event.clientY - offset, offset * 2, offset * 2)
      });
    }
  }

  changeTooltip(config, existing) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existing, config,
    /* owner = */
    this);
  }

}
DragTipProxy.initClass();
DragTipProxy._$name = 'DragTipProxy';

/***/ }),

/***/ "./lib/Core/widget/BooleanCombo.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/BooleanCombo.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanCombo; });
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


/**
 * @module Core/widget/BooleanCombo
 * Boolean combo, a combo box with two options corresponding to true or false.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 *
 * @classType booleancombo
 * @extends Core/widget/Combo
 */

class BooleanCombo extends _Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'BooleanCombo';
  }

  static get type() {
    return 'booleancombo';
  } //region Config


  static get configurable() {
    return {
      /**
       * Positive option value
       *
       * @config {*}
       */
      positiveValue: true,

      /**
       * Positive option display value
       *
       * @config {String}
       */
      positiveText: null,

      /**
       * Negative option value
       *
       * @config {*}
       */
      negativeValue: false,

      /**
       * False option display value
       *
       * @config {String}
       */
      negativeText: null,
      store: {
        value: [],
        $config: 'lazy'
      },

      /**
       * Default value
       *
       * @config {*}
       */
      value: false
    };
  } //endregion


  changeStore(store, oldStore) {
    const me = this; // We must call super.changeStore() in order to deduce valueField. We also cannot just pass an array since it
    // will convert to a store and call back here (infinite recursion).

    return super.changeStore(new _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      data: [{
        id: me.positiveValue,
        text: me.positiveText || me.L('L{Object.Yes}')
      }, {
        id: me.negativeValue,
        text: me.negativeText || me.L('L{Object.No}')
      }]
    }), oldStore);
  }

} // Register this widget type with its Factory

BooleanCombo.initClass();
BooleanCombo._$name = 'BooleanCombo';

/***/ }),

/***/ "./lib/Core/widget/Button.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Button.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Button; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






 //TODO: should togglebutton be own class implemented as input type=checkbox?
//TODO: A toggling widget's focusElement should be an opacity:0 input type=checkbox which covers the clickable area.

/**
 * @module Core/widget/Button
 */

const bIcon = /(?:^|\s)b-icon-/,
      bFa = /(?:^|\s)b-fa-/,
      defaultToggleable = Symbol('defaultToggleable'),
      fullConfigKeys = ['items', 'type', 'widgets', 'html', 'listeners'];
/**
 * Button widget, wraps and styles a regular <code>&lt;button&gt;</code> element. Can display text and icon and also
 * allows specifying button {@link #config-color}. Supports different appearances, by setting {@link #config-cls} to one
 * of:
 *
 * * 'b-raised' - Raised buttons
 * * 'b-rounded' - Round buttons
 * * 'b-transparent' - Buttons without border or background
 *
 * ## Default appearance
 *
 * By default buttons uses a flat look in all themes:
 *
 * {@inlineexample Core/widget/ButtonDefault.js}
 *
 * ```javascript
 * // Green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Raised appearance
 *
 * By configuring a button with `cls : 'b-raised'` its appearance change. In Material the button appears raised, in the
 * other themes it is instead filled:
 *
 * {@inlineexample Core/widget/ButtonRaised.js}
 *
 * ```javascript
 * // Raised green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-raised',
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Rounded appearance
 *
 * Configure a button with `cls : 'b-rounded'` to make it round. Works best for icon only buttons or buttons with very
 * short texts:
 *
 * {@inlineexample Core/widget/ButtonRounded.js}
 *
 * ```javascript
 * // Rounded button with icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-raised b-rounded',
 *     icon    : 'b-fa-plus-circle',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Transparent appearance
 *
 * Configure a button with `cls : 'b-transparent'` to display it without border or background:
 *
 * {@inlineexample Core/widget/ButtonTransparent.js}
 * ```javascript
 * // Transparent green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-transparent',
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Button with menu
 *
 * Buttons can also have a menu that is shown on click:
 *
 * {@inlineexample Core/widget/ButtonWithMenu.js}
 *
 * ```javascript
 * // Transparent green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     icon    : 'b-fa-chart',
 *     menu    : {
 *         items : [
 *             {
 *                 text : 'Click me',
 *                 onItem : () => console.log('I was clicked')
 *             }
 *         ]
 *     }
 * });
 * ```
 * @classType button
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 */

class Button extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'Button';
  } // Factoryable type name


  static get type() {
    return 'button';
  }

  static get configurable() {
    return {
      /**
       * Get/set the Button icon
       * @member {String} icon
       */

      /**
       * Button icon class.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       * @config {String}
       */
      icon: null,

      /**
       * The menu icon class to show when the button has a menu. Set to `null` to not show a menu icon.
       *
       * @config {String}
       * @deprecated 4.3.0 Use {@link #config-menuIcon} instead.
       * @default
       */
      menuIconCls: null,

      /**
       * The menu icon class to show when the button has a menu. Set to `null` to not show a menu icon.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * @config {String}
       * @default
       */
      menuIcon: 'b-icon-picker',

      /**
       * Get/set the Button pressed icon
       * @member {String} pressedIcon
       */

      /**
       * Icon class for the buttons pressed state. Only applies to toggle buttons
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       *
       * ```
       * new Button({
       *    // Icon for unpressed button
       *    icon        : 'b-fa-wine-glass',
       *
       *    // Icon for pressed button
       *    pressedIcon : 'b-fa-wine-glass-alt',
       *
       *    // Only applies to toggle buttons
       *    toggleable  : true
       * });
       * ```
       *
       * @config {String}
       */
      pressedIcon: null,

      /**
       * Get/Set the Button icon alignment.
       * May be `'start'` or `'end'`. Defaults to `'start'`
       * @member {String} iconAlign
       */

      /**
       * Button icon alignment. May be `'start'` or `'end'`. Defaults to `'start'`
       * @config {String}
       */
      iconAlign: 'start',

      /**
       * Get/set text displayed on the button.
       * @member {String} text
       */

      /**
       * The button's text.
       * @config {String}
       */
      text: {
        value: null,
        $config: null,
        default: ''
      },

      /**
       * Button color (should have match in button.scss or your custom styling). Valid values in Bryntum themes
       * are:
       * * b-amber
       * * b-blue
       * * b-dark-gray
       * * b-deep-orange
       * * b-gray
       * * b-green
       * * b-indigo
       * * b-lime
       * * b-light-gray
       * * b-light-green
       * * b-orange
       * * b-purple
       * * b-red
       * * b-teal
       * * b-white
       * * b-yellow
       * Combine with specifying `b-raised` for raised/filled style (theme dependent).
       *
       * ```
       * new Button({
       *    color : 'b-teal b-raised'
       * });
       * ```
       *
       * @config {String}
       */
      color: null,

      /**
       * Enabled toggling of the button (stays pressed when pressed).
       * @config {Boolean}
       * @default false
       */
      toggleable: defaultToggleable,

      /**
       * Get/set button pressed state
       * @member {Boolean} pressed
       */

      /**
       * Initially pressed or not. Only applies with `toggleable = true`.
       * ```
       * const toggleButton = new Button({
       *    toggleable : true,
       *    text : 'Enable cool action'
       * });
       * ```
       * @config {Boolean}
       * @default
       */
      pressed: false,

      /**
       * Indicates that this button is part of a group where only one button can be pressed. Assigning a value
       * also sets `toggleable` to `true`.
       *
       * When part of a {@link Core.widget.ButtonGroup}, you can set {@link Core.widget.ButtonGroup#config-toggleGroup}
       * on it as an alternative to on each button. This config can then be used to override that value if needed.
       *
       * ```javascript
       * const yesButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'Yes'
       * });
       *
       * const noButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'No'
       * });
       * ```
       * @config {String}
       */
      toggleGroup: null,
      ripple: {
        radius: 75
      },
      localizableProperties: ['text'],

      /**
       * Returns the instantiated menu widget as configured by {@link #config-menu}.
       * @member {Core.widget.Widget} menu
       */

      /**
       * A submenu configuration object, or an array of MenuItem configuration
       * objects from which to create a submenu which is shown when this button is pressed.
       *
       * Note that this does not have to be a Menu. The `type` config can be used
       * to specify any widget as the submenu.
       *
       * May also be specified as a fully instantiated {@link Core.widget.Widget#config-floating floating Widget}
       * such as a {@link Core/widget/Popup}.
       * @config {Object|Object[]|Core.widget.Widget}
       */
      menu: {
        $config: ['lazy', 'nullify'],
        value: null
      },
      menuDefaults: {
        type: 'menu',
        autoShow: false,
        autoClose: true,
        floating: true,
        scrollAction: 'realign',
        align: 't0-b0'
      },

      /**
       * If provided, turns the button into a link
       * @config {String}
       */
      href: null,

      /**
       * The `target` attribute for the {@link #config-href} config
       * @config {String}
       */
      target: null
    };
  }

  compose() {
    const {
      color,
      href,
      icon,
      iconAlign,
      pressed,
      pressedIcon,
      target,
      text,
      toggleable,
      toggleGroup,
      menuIcon
    } = this,
          hasMenu = this.hasConfig('menu'),
          iconCls = pressed && pressedIcon ? pressedIcon : icon;
    return {
      tag: href ? 'a' : 'button',
      href,
      target,
      class: {
        [`b-icon-align-${iconAlign}`]: icon,
        [color]: Boolean(color),
        'b-pressed': pressed && toggleable,
        'b-text': Boolean(text),
        'b-has-menu': hasMenu
      },
      dataset: {
        group: toggleGroup
      },
      listeners: {
        click: 'onInternalClick'
      },
      children: {
        iconElement: (icon || pressedIcon) && {
          tag: 'i',
          class: _objectSpread(_objectSpread({}, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalize(iconCls, 'object')), {}, {
            'b-icon': bIcon.test(iconCls),
            'b-fa': bFa.test(iconCls)
          })
        },
        label: text && {
          tag: 'label',
          text
        },
        menuIconElement: hasMenu && menuIcon && {
          tag: 'i',
          class: {
            'b-icon': bIcon.test(menuIcon),
            'b-fa': bFa.test(menuIcon),
            'b-button-menu-icon': 1,
            [menuIcon]: 1
          }
        }
      }
    };
  } //endregion


  onHide() {
    var _this$_menu;

    // Stop a menu from being visually orphaned if this button is hidden while its menu is visible
    (_this$_menu = this._menu) === null || _this$_menu === void 0 ? void 0 : _this$_menu.hide();
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   *
   * _Due to the {@link #config-menu} config being a lazy config and only being converted to be a
   * `Menu` instance just before it's shown, the menu will not be part of the iteration before
   * it has been shown once_.
   * @function eachWidget
   * @param {Function} fn A function to execute upon all descendant widgets.
   * Iteration terminates if this function returns `false`.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   */


  get childItems() {
    return this._menu && [this.menu];
  }

  onFocusOut(e) {
    var _this$menu;

    super.onFocusOut(e);
    (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.hide();
  } //region Getters/Setters


  get focusElement() {
    return this.element;
  }

  changeText(text) {
    return text == null ? '' : text;
  }

  changeToggleable(toggleable) {
    if (toggleable === defaultToggleable) {
      return this.toggleGroup || this.config.menu;
    }

    return toggleable;
  }

  changeMenu(menu, oldMenu) {
    const me = this,
          {
      element: forElement
    } = me;

    if (menu) {
      if (menu.isWidget) {
        menu.forElement = forElement;
        menu.owner = me;
      } else {
        // This covers both Array and Object which are valid items config formats.
        // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
        // child items or html property in it, it's the main config
        if (typeof menu === 'object' && !fullConfigKeys.some(key => key in menu)) {
          menu = {
            lazyItems: menu
          };
        }

        menu = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].reconfigure(oldMenu, menu ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge({
          owner: me,
          constrainTo: me.rootElement,
          forElement
        }, me.menuDefaults, menu) : null, me);
      } // We must react to its state change to hidden by becoming unpressed.
      // If we just hid it in the toggle method, this will be a no-op.


      menu.on('hide', () => {
        var _me$toggle;

        return (_me$toggle = me.toggle) === null || _me$toggle === void 0 ? void 0 : _me$toggle.call(me, false);
      });
    } else {
      oldMenu === null || oldMenu === void 0 ? void 0 : oldMenu.destroy();
    }

    return menu;
  }

  updateMenu(menu) {
    // We are toggleable if there's a menu.
    // Pressed means menu visible, not pressed means menu hidden.
    this.toggleable = Boolean(menu);
  }

  updatePressed(pressed) {
    const me = this;

    if (!me.isConfiguring && pressed && me.toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].forEachSelector(me.rootElement, `button[data-group=${me.toggleGroup}]`, btnEl => {
        if (btnEl !== me.element) {
          _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].getById(btnEl.id).toggle(false);
        }
      });
    }
  }

  updateMenuIconCls(cls) {
    _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `menuIcon`');
    this.menuIcon = cls;
  } //endregion
  //region Events

  /**
   * Triggers events when user clicks button
   * @fires click
   * @fires action
   * @internal
   */


  onInternalClick(event) {
    const me = this,
          bryntumEvent = {
      event
    };

    if (me.toggleable) {
      // Clicking the pressed button in a toggle group should do nothing
      if (me.toggleGroup && me.pressed) {
        return;
      }

      me.toggle(!me.pressed); // Edge case in dragfromgrid demo, where toggling mode destroys the Scheduler and thus destroys the toolbar
      // and the button in it

      if (me.isDestroyed) {
        return;
      }
    }
    /**
     * Fires when the button is clicked
     * @event click
     * @param {Core.widget.Button} source The button
     * @param {Event} event DOM event
     */


    me.trigger('click', bryntumEvent);
    /**
     * Fires when the default action is performed (the button is clicked)
     * @event action
     * @param {Core.widget.Button} source The button
     * @param {Event} event DOM event
     */
    // A handler may have resulted in destruction.

    if (!me.isDestroyed) {
      me.trigger('action', bryntumEvent);
    } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction


    if (!me.href) {
      // stop the event since it has been handled
      event.preventDefault();
      event.stopPropagation();
    }
  } //endregion
  //region Misc

  /**
   * Toggle button state (only use with toggleable = true)
   * @param {Boolean} pressed Specify to force a certain toggle state
   * @fires toggle
   */


  toggle(pressed = null) {
    const me = this,
          {
      menu
    } = me;

    if (!me.toggleable) {
      return;
    }

    if (pressed === null) {
      pressed = !me.pressed;
    } // The pressed state is not going to be changed, ignore toggling


    if (me.pressed === pressed) {
      return;
    } // For handlers from the code below to detect and avoid recursion


    me.toggling = true;
    me.pressed = pressed;

    if (menu) {
      var _menu$_minHeight, _menu$_minWidth;

      if (!menu.initialConfig.minWidth) {
        menu.minWidth = me.width;
      } // Menu will shrink and fit inside a 10px inset of viewport.
      // Rectangle.alignTo prioritizes alignment if the target edge is closer to
      // the constrainTo edge than this in order to produce visually correct results.


      menu.align.constrainTo = window;
      menu.align.constrainPadding = 10; // The presence of a number indicates to the align constraining algorithm
      // that it is *willing* to shrink in that dimension. It will never end up this small.
      // Use the properties because the getter will return 0 if not set.

      menu.align.minHeight = (_menu$_minHeight = menu._minHeight) !== null && _menu$_minHeight !== void 0 ? _menu$_minHeight : 100;
      menu.align.minWidth = (_menu$_minWidth = menu._minWidth) !== null && _menu$_minWidth !== void 0 ? _menu$_minWidth : 100;
      menu[pressed ? 'show' : 'hide']();
    }
    /**
     * Fires when the button is toggled (the {@link #property-pressed} state is changed). If the button is part of a
     * {@link #config-toggleGroup} and you need to process the pressed button only, consider using
     * {@link #event-click} event or {@link #event-action} event.
     * @event toggle
     * @param {Core.widget.Button} source Toggled button
     * @param {Boolean} pressed New pressed state
     * @param {Event} event DOM event
     */


    me.trigger('toggle', {
      pressed
    });
    me.toggling = false;
  } //endregion


} // Register this widget type with its Factory

Button.initClass();
Button._$name = 'Button';

/***/ }),

/***/ "./lib/Core/widget/ButtonGroup.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/ButtonGroup.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ButtonGroup; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
var productName = 'gantt';



/**
 * @module Core/widget/ButtonGroup
 */

/**
 * A specialized container that holds buttons, displaying them in a horizontal group with borders adjusted to make them
 * stick together.
 *
 * Trying to add other widgets than buttons will throw an exception.
 *
 * ```javascript
 * new ButtonGroup({
 *     items : [
 *         { icon : 'b-fa b-fa-kiwi-bird' },
 *         { icon : 'b-fa b-fa-kiwi-otter' },
 *         { icon : 'b-fa b-fa-kiwi-rabbit' },
 *         ...
 *     ]
 * });
 * ```
 *
 * @inlineexample Core/widget/ButtonGroup.js
 * @classType buttonGroup
 * @extends Core/widget/Container
 */

class ButtonGroup extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  /**
   * Fires when a button in the group is clicked
   * @event click
   * @param {Core.widget.Button} source Clicked button
   * @param {Event} event DOM event
   */

  /**
   * Fires when the default action is performed on a button in the group (the button is clicked)
   * @event action
   * @param {Core.widget.Button} source Clicked button
   * @param {Event} event DOM event
   */

  /**
   * Fires when a button in the group is toggled (the {@link Core.widget.Button#property-pressed} state is changed).
   * If you need to process the pressed button only, consider using {@link #event-click} event or {@link #event-action} event.
   * @event toggle
   * @param {Core.widget.Button} source Toggled button
   * @param {Boolean} pressed New pressed state
   * @param {Event} event DOM event
   */
  static get $name() {
    return 'ButtonGroup';
  } // Factoryable type name


  static get type() {
    return 'buttongroup';
  }

  static get configurable() {
    return {
      defaultType: 'button',

      /**
       * Custom CSS class to add to element. When using raised buttons (cls 'b-raised' on the buttons), the group
       * will look nicer if you also set that cls on the group.
       *
       * ```
       * new ButtonGroup({
       *   cls : 'b-raised,
       *   items : [
       *       { icon : 'b-fa b-fa-unicorn', cls : 'b-raised' },
       *       ...
       *   ]
       * });
       * ```
       *
       * @config {String}
       * @category CSS
       */
      cls: null,

      /**
       * An array of Buttons or typed Button config objects.
       * @config {Object[]|Core.widget.Button[]}
       */
      items: null,

      /**
       * Default color to apply to all contained buttons, see {@link Core.widget.Button#config-color Button#color}.
       * Individual buttons can override the default.
       * @config {String}
       */
      color: null,

      /**
       * Set to `true` to turn the ButtonGroup into a toggle group, assigning a generated value to each contained
       * buttons {@link Core.widget.Button#config-toggleGroup toggleGroup config}. Individual buttons can
       * override the default.
       * @config {Boolean}
       */
      toggleGroup: null,
      valueSeparator: ',',
      columns: null,
      hideWhenEmpty: true
    };
  }

  onChildAdd(item) {
    super.onChildAdd(item);
    item.on({
      click: 'onItemClick',
      thisObj: this,
      // This needs to run before the 'click' event is relayed by this button group, in such listener
      // the `value` must already be updated
      prio: 10000
    });
  }

  onChildRemove(item) {
    item.un({
      click: 'onItemClick',
      thisObj: this
    });
    super.onChildRemove(item);
  }

  onItemClick() {
    // reset cached value to revalidate next time it's requested
    this._value = null;
  }

  createWidget(widget) {
    const me = this,
          type = me.constructor.resolveType(widget.type || 'button');

    if (type.isButton) {
      if (me.color && !widget.color) {
        widget.color = me.color;
      }

      if (me.toggleGroup && !widget.toggleGroup) {
        if (typeof me.toggleGroup === 'boolean') {
          me.toggleGroup = ButtonGroup.generateId('toggleGroup');
        }

        widget.toggleGroup = me.toggleGroup;
      }
    }

    if (me.columns) {
      widget.width = `${100 / me.columns}%`;
    }

    widget = super.createWidget(widget);
    me.relayEvents(widget, ['click', 'action', 'toggle']);
    return widget;
  }

  updateRotate(rotate) {
    this.eachWidget(btn => {
      if (btn.rotate !== false) {
        btn.rotate = rotate;
      }
    });
  }

  get value() {
    // if we don't have cached value
    // let's calculate it based on item values
    if (!this._value) {
      const values = []; // collect pressed item values

      this.items.forEach(w => {
        if (w.pressed && w.value !== undefined) values.push(w.value);
      }); // build a string

      this._value = values.join(this.valueSeparator);
    }

    return this._value;
  }

  set value(value) {
    if (!Array.isArray(value)) {
      if (value === undefined || value === null) {
        value = [];
      } else if (typeof value == 'string') {
        value = value.split(this.valueSeparator);
      } else {
        value = [value];
      }
    }

    this._value = value; // reflect value on items

    this.items.forEach(w => {
      if (w.value !== undefined) {
        w.pressed = value.indexOf(w.value) > -1;
      }
    });
  }

  get disabled() {
    return super.disabled;
  }

  set disabled(state) {
    super.disabled = state;
    this.items.forEach(w => w.disabled = state);
  }

  get widgetClassList() {
    const classList = super.widgetClassList; // if the buttons should be shown in rows

    this.columns && classList.push('b-columned');
    return classList;
  }

} // Register this widget type with its Factory

ButtonGroup.initClass();
ButtonGroup._$name = 'ButtonGroup';

/***/ }),

/***/ "./lib/Core/widget/CalendarPanel.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/CalendarPanel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarPanel; });
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _util_Month_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Month.js */ "./lib/Core/util/Month.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';







/**
 * @module Core/widget/CalendarPanel
 */

/**
 * A Panel which displays a month of date cells.
 *
 * This is a base class for UI widgets like {@link Core.widget.DatePicker} which need to display a calendar layout
 * and should not be used directly.
 * @extends Core/widget/Panel
 */

class CalendarPanel extends _Panel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CalendarPanel';
  } // Factoryable type name


  static get type() {
    return 'calendarpanel';
  }

  static get configurable() {
    return {
      textContent: false,

      /**
       * Gets or sets the date that orientates the panel to display a particular month.
       * Changing this causes the content to be refreshed.
       * @member {Date} date
       */

      /**
       * The date which this CalendarPanel encapsulates.
       * @config {Date|String}
       */
      date: {
        $config: {
          equal: 'date'
        },
        value: null
      },

      /**
       * A {@link Core.util.Month} Month utility object which encapsulates this Panel's month
       * and provides contextual information and navigation services.
       * @config {Core.util.Month|Object}
       */
      month: {},
      year: null,

      /**
       * The week start day, 0 meaning Sunday, 6 meaning Saturday.
       * Defaults to {@link Core.helper.DateHelper#property-weekStartDay-static}.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * Configure as `true` to always show a six week calendar.
       * @config {Boolean}
       * @default
       */
      sixWeeks: true,

      /**
       * Configure as `true` to show a week number column at the start of the calendar block.
       * @deprecated 4.0.0 Use {@link #config-showWeekColumn} instead.
       * @config {Boolean}
       */
      showWeekNumber: null,

      /**
       * Configure as `true` to show a week number column at the start of the calendar block.
       * @config {Boolean}
       */
      showWeekColumn: null,

      /**
       * Either an array of `Date` objects which are to be disabled, or
       * a function (or the name of a function), which, when passed a `Date` returns `true` if the
       * date is disabled.
       * @config {Function|Date[]|String}
       */
      disabledDates: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate a day header element.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day number conforming to the specified {@link #config-weekStartDay}. Will be in the range 0 to 6.
       *  - weekDay [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The canonical day number where Monday is 0 and Sunday is.
       * @config {Function|String}
       */
      headerRenderer: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate the week cell element at the start of a week row.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - week [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) An array containing `[year, weekNumber]`.
       * @config {Function|String}
       */
      weekRenderer: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate a day cell element.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - date [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The date for the cell.
       *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day for the cell (0 to 6 for Sunday to Saturday).
       *  - rowIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The row index, 0 to month row count (6 if {@link #config-sixWeeks} is `true`).
       *  _ row [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The row element encapsulating the week which the cell is a part of.
       *  - cellIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The cell index in the whole panel. May be from 0 to up to 42.
       *  - columnIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The column index, 0 to 6.
       *  - visibleColumnIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The visible column index taking hidden non working days into account.
       * @config {Function|String}
       */
      cellRenderer: null,

      /**
       * Configure as `true` to render weekends as {@link #config-disabledDates}.
       * @config {Boolean}
       */
      disableWeekends: null,
      hideNonWorkingDays: null,
      hideNonWorkingDaysCls: 'b-hide-nonworking-days',

      /**
       * Non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
       * Defaults to {@link Core.helper.DateHelper#property-nonWorkingDays-static}.
       * @config {Object}
       */
      nonWorkingDays: null,

      /**
       * A config object to create a tooltip which will show on hover of a date cell
       * including disabled, weekend, and "other month" cells.
       *
       * It is the developer's responsibility to hook the `beforeshow` event
       * to either veto the show by returning `false` or provide contextual
       * content for the date.
       *
       * The tip instance will be primed with a `date` property.
       * @config {Object}
       */
      tip: null,
      dayCellCls: 'b-calendar-cell',
      dayHeaderCls: 'b-calendar-day-header',

      /**
       * The class name to add to disabled calendar cells.
       * @config {String}
       * @private
       */
      disabledCls: 'b-disabled-date',

      /**
       * The class name to add to calendar cells which are in the previous or next month.
       * @config {String}
       * @private
       */
      otherMonthCls: 'b-other-month',

      /**
       * The class name to add to calendar cells which are weekend dates.
       * @config {String}
       * @private
       */
      weekendCls: 'b-weekend',

      /**
       * The class name to add to the calendar cell which contains today's date.
       * @config {String}
       * @private
       */
      todayCls: 'b-today',

      /**
       * The class name to add to calendar cells which are {@link #config-nonWorkingDays}.
       * @config {String}
       * @private
       */
      nonWorkingDayCls: 'b-nonworking-day',

      /**
       * The {@link Core.helper.DateHelper DateHelper} format string to format the day names.
       * @config {String}
       * @default
       */
      dayNameFormat: 'ddd',

      /**
       * By default, week rows flex to share available Panel height equally.
       *
       * Set this config if the available height is too small, and the cell height needs
       * to be larger to show events.
       *
       * Setting this config causes the month grid to become scrollable in the `Y` axis.
       *
       * May be specified as a number in which case it will be taken to mean pixels,
       * or a length in standard CSS units.
       * @config {Number|String}
       */
      minRowHeight: {
        $config: ['lazy'],
        value: null
      },

      /**
       * By default, day cells flex to share available Panel width equally.
       *
       * Set this config if the available width is too small, and the cell width needs
       * to be larger to show events.
       *
       * Setting this config causes the month grid to become scrollable in the `X` axis.
       * @config {Number}
       */
      minColumnWidth: {
        $config: ['lazy'],
        value: null
      }
    };
  }

  construct(config) {
    super.construct(config);

    if (!this.refreshCount) {
      this.refresh();
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Invoke the lazy configs when we first hit the visible DOM

    if (firstPaint) {
      // The cell structure must exist for the configs to apply to.
      if (!this.refreshCount) {
        this.refresh();
      }

      this.getConfig('minColumnWidth');
      this.getConfig('minRowHeight');
    }
  }

  get overflowElement() {
    return this.weeksElement;
  }

  doDestroy() {
    var _this$tip;

    (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.destroy();
    super.doDestroy();
  }

  changeMinRowHeight(minRowHeight) {
    // Fall back to 75 on platforms that do not support CSS vars
    const minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(this.element, '--min-row-height'), 10) || 75;
    return isNaN(minRowHeight) ? minRowHeight : Math.max(parseInt(minRowHeight) || 0, minValue);
  }

  updateMinRowHeight(minRowHeight) {
    this.weekElements.forEach(w => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(w, 'minHeight', minRowHeight));
    this.scrollable = {
      overflowY: minRowHeight ? 'auto' : false
    };
  }

  changeMinColumnWidth(minColumnWidth) {
    // Fall back to 75 on platforms that do not support CSS vars
    const minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(this.element, '--min-column-width'), 10) || 75;
    return minColumnWidth == null ? minColumnWidth : Math.max(parseInt(minColumnWidth) || 0, minValue);
  }

  updateMinColumnWidth(minColumnWidth) {
    const me = this;
    me.weekdayCells.forEach(c => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(c, 'minWidth', minColumnWidth));
    me.cellElements.forEach(c => c.matches(`.${me.dayCellCls}`) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(c, 'minWidth', minColumnWidth));
    me.scrollable = {
      overflowX: minColumnWidth ? 'auto' : false
    };
    me.overflowElement.classList[minColumnWidth ? 'add' : 'remove']('b-min-columnwidth');
  }

  getDateFromEvent(domEvent) {
    const element = (domEvent.nodeType === Element.ELEMENT_NODE ? domEvent : domEvent.target).closest(`#${this.id} [data-date]`);

    if (element) {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(element.dataset.date);
    }
  }

  changeTip(tip, existingTip) {
    const me = this;
    return _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].reconfigure(existingTip, tip, {
      owner: me,
      defaults: {
        type: 'tooltip',
        owner: me,
        id: `${me.id}-cell-tip`,
        forElement: me.bodyElement,
        forSelector: `.${me.dayCellCls}`
      }
    });
  }

  updateTip(tip) {
    this.detachListeners('tip');
    tip === null || tip === void 0 ? void 0 : tip.on({
      pointerOver: 'onTipOverCell',
      name: 'tip',
      thisObj: this
    });
  }

  updateElement(element, was) {
    const me = this;
    super.updateElement(element, was);
    me.updateHideNonWorkingDays(me.hideNonWorkingDays);
    me.weekdayCells = Array.from(element.querySelectorAll('.b-calendar-day-header'));
    me.weekElements = Array.from(element.querySelectorAll('.b-calendar-week'));
    me.weekDayElements = Array.from(element.querySelectorAll('.b-calendar-days'));
    me.cellElements = [];

    for (let i = 0, {
      length
    } = me.weekDayElements; i < length; i++) {
      me.cellElements.push(me.weekDayElements[i].previousSibling, ...me.weekDayElements[i].children);
    }
  }

  changeDate(date) {
    date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(date) : new Date(date);

    if (isNaN(date)) {
      throw new Error('CalendarPanel date ingestion must be passed a Date, or a YYYY-MM-DD date string');
    }

    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(date);
  }
  /**
   * The date which this CalendarPanel encapsulates. Setting this causes the
   * content to be refreshed.
   * @property {Date}
   */


  updateDate(value) {
    // We respond to Month change events to update the UI
    this.month.date = value;
  }

  updateDayNameFormat() {
    // 4th June 2000 was a Sunday
    const d = new Date('2000-06-04T12:00:00');
    this.shortDayNames = []; // Collect local shortDayNames in default order.

    for (let date = 4; date < 11; date++) {
      d.setDate(date);
      this.shortDayNames.push(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(d, this.dayNameFormat));
    }
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekStartDay;
  }
  /**
   * Set to 0 for Sunday (the default), 1 for Monday etc.
   *
   * Set to `null` to use the default value from {@link Core/helper/DateHelper}.
   */


  updateWeekStartDay(weekStartDay) {
    const me = this;

    if (me._month) {
      me.month.weekStartDay = weekStartDay;
      me.dayNames = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
      // dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

      for (let i = 0; i < 7; i++) {
        me.dayNames[i] = me.shortDayNames[me.canonicalDayNumbers[i]];
      }

      if (me.refreshCount) {
        me.refresh();
      }
    }
  }

  updateHideNonWorkingDays(hideNonWorkingDays) {
    var _this$scrollable;

    this.contentElement.classList[hideNonWorkingDays ? 'add' : 'remove'](this.hideNonWorkingDaysCls);
    (_this$scrollable = this.scrollable) === null || _this$scrollable === void 0 ? void 0 : _this$scrollable.syncOverflowState();

    if (this._month) {
      this.month.hideNonWorkingDays = hideNonWorkingDays;
    }
  }

  get nonWorkingDays() {
    return this._nonWorkingDays || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].nonWorkingDays;
  }

  changeNonWorkingDays(nonWorkingDays) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, nonWorkingDays);
  }

  updateNonWorkingDays(nonWorkingDays) {
    if (this._month) {
      var _this$scrollable2;

      this.month.nonWorkingDays = nonWorkingDays;
      this.refresh();
      (_this$scrollable2 = this.scrollable) === null || _this$scrollable2 === void 0 ? void 0 : _this$scrollable2.syncOverflowState();
    }
  }

  get visibleDayColumnIndex() {
    return this.month.visibleDayColumnIndex;
  }

  get dayColumnIndex() {
    return this.month.dayColumnIndex;
  }

  get canonicalDayNumbers() {
    return this.month.canonicalDayNumbers;
  }

  get visibleColumnCount() {
    return this.month.visibleColumnCount;
  }

  get weekLength() {
    return this.month.weekLength;
  }
  /**
   * The date of the first day cell in this panel.
   * Note that this may *not* be the first of this panel's current month.
   * @property {Date}
   * @readonly
   */


  get startDate() {
    return this.month.startDate;
  }

  get duration() {
    // The endDate is "exclusive" because it means 00:00:00 of that day.
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(this.month.startDate, this.month.endDate, 'day') + 1;
  }
  /**
   * The end date of this view. Note that in terms of full days, this is exclusive,
   * ie: 2020-01-012 to 2020-01-08 is *seven* days. The end is 00:00:00 on the 8th.
   *
   * Note that this may *not* be the last date of this panel's current month.
   * @property {Date}
   * @readonly
   */


  get endDate() {
    const {
      endDate
    } = this.month;

    if (endDate) {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, 1, 'day');
    }
  }

  changeMonth(month, currentMonth) {
    const me = this;

    if (!(month instanceof _util_Month_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      // Setting month to a number when we already have a Month means
      // just updating the month number of our Month
      if (typeof month === 'number') {
        if (currentMonth) {
          currentMonth.month = month;
          return;
        }

        const date = me.date || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date());
        date.setMonth(month);
        month = {
          date
        };
      }

      month = _util_Month_js__WEBPACK_IMPORTED_MODULE_3__["default"].new({
        weekStartDay: me.weekStartDay,
        nonWorkingDays: me.nonWorkingDays,
        hideNonWorkingDays: me.hideNonWorkingDays,
        sixWeeks: me.sixWeeks
      }, month);
    }

    month.on({
      dateChange: 'onMonthDateChange',
      thisObj: me
    });
    return month;
  }

  onMonthDateChange({
    source: month,
    newDate,
    oldDate,
    changes
  }) {
    const me = this; // Ensure we're always in sync with the data our Month holds

    me.year = month.year;

    if (!me.isConfiguring) {
      // Only refresh if we are in another month
      if (changes.m || changes.y) {
        me.refresh();
      }
      /**
       * Fires when the date of this CalendarPanel is set.
       * @event dateChange
       * @param {Date} value The new date.
       * @param {Date} oldValue The old date.
       * @param {Object} changes An object which contains properties which indicate what part of the date changed.
       * @param {Boolean} changes.d True if the date changed in any way.
       * @param {Boolean} changes.w True if the week changed (including same week in a different year).
       * @param {Boolean} changes.m True if the month changed (including same month in a different year).
       * @param {Boolean} changes.y True if the year changed.
       */


      me.trigger('dateChange', {
        changes,
        value: newDate,
        oldValue: oldDate
      });
    }
  }

  updateYear(year) {
    this.month.year = year;
  }

  updateShowWeekNumber(showWeekNumber) {
    this.updateShowWeekColumn(showWeekNumber);
  }

  updateShowWeekColumn(showWeekColumn) {
    const me = this;
    me.element.classList[showWeekColumn ? 'add' : 'remove']('b-show-week-column');

    if (me.floating) {
      // Must realign because content change might change dimensions
      if (!me.isAligning) {
        me.realign();
      }
    }
  }

  updateSixWeeks(sixWeeks) {
    if (this.month) {
      this.month.sixWeeks = sixWeeks;
      this.refresh();
    }
  }
  /**
   * Refreshes the UI after changing a config that would affect the UI.
   */


  refresh() {
    // This method may be overridden by subclasses to add things like refresh scheduling.
    this.doRefresh();
  }
  /**
   * Implementation of the UI refresh.
   * @private
   */


  doRefresh() {
    // Ensure sub elements are all present
    this.getConfig('element');
    const me = this,
          today = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date()),
          {
      weekElements,
      weekDayElements,
      date,
      month,
      dayCellCls,
      dayHeaderCls,
      disabledCls,
      otherMonthCls,
      weekendCls,
      todayCls,
      nonWorkingDayCls,
      nonWorkingDays,
      canonicalDayNumbers
    } = me; // If we have not been initialized with a current date, use today

    if (!date) {
      me.date = today;
    } // Make sure we've calculated our shortDayNames


    me.getConfig('dayNameFormat');

    for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
      const cell = me.weekdayCells[columnIndex],
            cellDay = me.canonicalDayNumbers[columnIndex],
            cellClassList = {
        [dayHeaderCls]: 1,
        [weekendCls]: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekends[cellDay],
        [nonWorkingDayCls]: nonWorkingDays[cellDay]
      };

      if (me.headerRenderer) {
        cell.innerHTML = '';
        me.callback(me.headerRenderer, me, [cell, columnIndex, cellDay]);
      } else {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setInnerText(cell, me.shortDayNames[cellDay]);
      } // Sync day name cell classes with its calculated status


      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].syncClassList(cell, cellClassList);
      cell.dataset.columnIndex = columnIndex;
      cell.dataset.cellDay = cellDay;
    } // Create cell content


    let rowIndex = 0,
        cellIndex = 0,
        lastWorkingColumn = 6; // Which column is the last working day so it can be tagged with an identifying class

    for (let columnIndex = 6; columnIndex >= 0; columnIndex--) {
      if (!nonWorkingDays[canonicalDayNumbers[columnIndex]]) {
        lastWorkingColumn = columnIndex;
        break;
      }
    }

    month.eachWeek((week, dates) => {
      const weekDayElement = weekDayElements[rowIndex],
            weekCells = [weekDayElement.previousSibling, ...weekDayElement.children]; // Stamp week into week row's dataset

      weekElements[rowIndex].dataset.week = `${week[0]},${week[1]}`; // If we are sixWeeks: false, some trailing rows could have been hidden.

      weekElements[rowIndex].classList.remove('b-hide-display');

      if (me.weekRenderer) {
        me.callback(me.weekRenderer, me, [weekCells[0], week]);
      } else {
        weekCells[0].innerHTML = week[1];
      }

      for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
        const date = dates[columnIndex],
              day = date.getDay(),
              cell = weekCells[columnIndex + 1],
              cellClassList = {
          [dayCellCls]: 1,
          [disabledCls]: me.isDisabledDate(date),
          [otherMonthCls]: date.getMonth() !== month.month,
          [weekendCls]: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekends[day],
          [todayCls]: date.getTime() === today.getTime(),
          [nonWorkingDayCls]: nonWorkingDays[day],
          'b-last-working-day': columnIndex === lastWorkingColumn
        }; // Sync day cell classes with its calculated status

        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].syncClassList(cell, cellClassList);
        cell.dataset.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date);
        cell.dataset.cellIndex = cellIndex;
        cell.dataset.columnIndex = columnIndex; // Since we manipulate the classList/Name directly, we need to trick DomSync's config comparison logic or it
        // may think the class has not changed.

        if (cell.lastDomConfig) {
          delete cell.lastDomConfig.class;
          delete cell.lastDomConfig.className;
        }

        if (me.cellRenderer) {
          me.callback(me.cellRenderer, me, [{
            cell,
            date,
            day,
            row: weekElements[rowIndex],
            rowIndex,
            cellIndex,
            columnIndex,
            visibleColumnIndex: me.visibleDayColumnIndex[day],
            week
          }]);
        } else {
          cell.innerHTML = date.getDate();
        }

        cellIndex++;
      }

      rowIndex++;
    });
    /**
     * The number of rows displayed in this month. If {@link #config-sixWeeks} is not set,
     * this may be from 4 to 6.
     * @member {Number} visibleWeekCount
     * @readonly
     */

    me.visibleWeekCount = rowIndex; // Hide/show trailing week rows depending on our sixWeeks setting

    for (; rowIndex < 6; rowIndex++) {
      weekElements[rowIndex].classList[me.sixWeeks ? 'remove' : 'add']('b-hide-display');
    }

    if (me.floating) {
      // Must realign because content change might change dimensions
      if (!me.isAligning) {
        me.realign();
      }
    }

    me.refreshCount = (me.refreshCount || 0) + 1;
    /**
     * Fires when this CalendarPanel refreshes.
     * @event refresh
     */

    me.trigger('refresh');
  }

  isDisabledDate(date) {
    const day = date.getDay(),
          {
      disabledDates,
      nonWorkingDays
    } = this;

    if (this.disableWeekends && nonWorkingDays[day]) {
      return true;
    }

    if (disabledDates) {
      if (Array.isArray(disabledDates)) {
        date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(date, true);
        return disabledDates.some(d => !(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(d, true) - date));
      } else {
        return this.callback(this.disabledDates, this, [date]);
      }
    }
  }

  get bodyConfig() {
    const result = super.bodyConfig,
          weeksContainerChildren = [];
    result.children = [{
      tag: 'div',
      className: 'b-calendar-row b-calendar-weekdays',
      reference: 'weekdaysHeader',
      children: [{
        class: 'b-week-number-cell'
      }, ..._helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].fill(7, {
        class: this.dayHeaderCls
      }), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarPadElement]
    }, {
      // `notranslate` prevents google translate messing up the DOM, https://github.com/facebook/react/issues/11538
      className: 'b-weeks-container notranslate',
      reference: 'weeksElement',
      children: weeksContainerChildren
    }];

    for (let i = 0; i < 6; i++) {
      const weekRow = {
        className: 'b-calendar-row b-calendar-week',
        children: [{
          className: 'b-week-number-cell'
        }, {
          className: 'b-calendar-days',
          children: [{}, {}, {}, {}, {}, {}, {}],
          syncOptions: {
            ignoreRefs: true,
            strict: false // allow complete replacement of classes w/o matching lastDomConfig

          }
        }]
      };
      weeksContainerChildren.push(weekRow);
    }

    return result;
  }

  get firstVisibleDate() {
    for (const me = this, date = me.month.startDate;; date.setDate(date.getDate() + 1)) {
      if (!me.hideNonWorkingDays || !me.nonWorkingDays[date.getDay()]) {
        return date;
      }
    }
  }

  getCell(date) {
    if (!(typeof date === 'string')) {
      date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date);
    }

    return this.weeksElement.querySelector(`[data-date="${date}"]`);
  }

  onTipOverCell({
    source: tip,
    target
  }) {
    tip.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(target.dataset.date);
  }

  updateLocalization() {
    this.updateDayNameFormat();
    this.updateWeekStartDay(this.weekStartDay);
    super.updateLocalization();
  }

} // Register this widget type with its Factory

CalendarPanel.initClass();
CalendarPanel._$name = 'CalendarPanel';

/***/ }),

/***/ "./lib/Core/widget/Checkbox.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Checkbox.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Checkbox; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




/**
 * @module Core/widget/Checkbox
 */

/**
 * Checkbox field, wraps <code>&lt;input type="checkbox"&gt;</code>.
 * Color can be specified and you can optionally configure {@link #config-text}
 * to display in a label to the right of the checkbox in addition to a standard
 * field {@link #config-label}.
 *
 * {@inlineexample Core/widget/Checkbox.js vertical}
 *
 * This field can be used as an {@link Grid.column.Column#config-editor} for the {@link Grid.column.Column}.
 *
 * @extends Core/widget/Field
 * @classType checkbox
 */

class Checkbox extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Checkbox';
  } // Factoryable type name


  static get type() {
    return 'checkbox';
  } // Factoryable type alias


  static get alias() {
    return 'check';
  }

  static get configurable() {
    return {
      inputType: 'checkbox',

      /**
       * Get/set label
       * @member {String} name
       */

      /**
       * Text to display on checkbox label
       * @config {String}
       */
      text: '',

      /**
       * The checked state. The same as `value`.
       * @config {Boolean} checked
       */

      /**
       * Checkbox color, must have match in CSS
       * @config {String}
       */
      color: null,

      /**
       * Get/set value
       * @member {String} value
       */

      /**
       * Sets input fields value attribute
       * @config {String}
       */
      value: '',
      toggleGroup: null,
      localizableProperties: ['label', 'text']
    };
  } //endregion
  //region Init


  construct(config) {
    // Convert checked to value so that initializing getter can read it if requested prior to trying to set it.
    if ('checked' in config) {
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({}, config); // copy inherited properties unlike Object.assign()

      config.value = config.checked;
      delete config.checked;
    }

    super.construct(config);
    this.syncHasText();
  } // Implementation needed at this level because it has two inner elements in its inputWrap


  get innerElements() {
    return [this.inputElement, {
      tag: 'label',
      class: 'b-checkbox-label',
      for: `${this.id}-input`,
      reference: 'textLabel',
      html: this.text || ''
    }];
  }

  get inputElement() {
    const me = this,
          config = super.inputElement;

    if (me.readOnly) {
      config.disabled = true;
    }

    if (me.toggleGroup) {
      config.dataset = {
        group: me.toggleGroup
      };
    }

    return config;
  } //endregion
  //region Toggle

  /**
   * Get/set checked state. Equivalent to `value` config.
   * @property {Boolean}
   */


  get checked() {
    return this.value;
  }

  set checked(value) {
    this.value = value;
  }

  syncHasText() {
    this.element.classList[this.text ? 'add' : 'remove']('b-text');
  }

  updateText(value) {
    if (this.textLabel) {
      this.syncHasText();
      this.textLabel.innerHTML = value;
    }
  }

  changeValue(value) {
    return value === 'false' ? false : Boolean(value);
  }

  updateValue(value) {
    const me = this,
          changed = me.input.checked !== value;
    me.input.checked = value;

    if (changed && !me.inputting) {
      me.uncheckToggleGroupMembers(); // The change event does not fire on programmatic change of input.

      if (!me.isConfiguring) {
        me.triggerChange(false);
      }
    }
  }

  get inputValueAttr() {
    return 'checked';
  }

  updateColor(value, was) {
    const classes = this.element.classList;

    if (was) {
      classes.remove(was);
    }

    if (value) {
      classes.add(value);
    }
  }

  getToggleGroupMembers() {
    const me = this,
          {
      checked,
      toggleGroup,
      input: checkedElement
    } = me,
          result = [];

    if (checked && toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(me.rootElement, `input[type=checkbox][data-group=${toggleGroup}]`, inputEl => {
        if (inputEl !== checkedElement) {
          const partnerCheckbox = _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromElement(inputEl);
          partnerCheckbox && result.push(partnerCheckbox);
        }
      });
    }

    return result;
  }

  uncheckToggleGroupMembers() {
    if (this.checked && this.toggleGroup) {
      this.getToggleGroupMembers().forEach(widget => widget.checked = false);
    }
  }

  updateReadOnly(readOnly) {
    if (this.input) {
      this.input.disabled = readOnly;
    } // Field and Widget have a say too. Widget adds the class and fires the event


    super.updateReadOnly(readOnly);
  }
  /**
   * Check the box
   */


  check() {
    this.checked = true;
  }
  /**
   * Uncheck the box
   */


  uncheck() {
    this.checked = false;
  }
  /**
   * Toggle checked state. If you want to force a certain state, assign to {@link #property-checked} instead.
   */


  toggle() {
    this.checked = !this.checked;
  } //endregion
  //region Events

  /**
   * Triggers events when user toggles the checkbox
   * @fires beforeChange
   * @fires change
   * @fires action
   * @private
   */


  internalOnChange(event) {
    const me = this;
    me.value = me.input.checked;

    if (!me.inputting) {
      me.inputting = true;
      me.triggerChange(true);
      me.inputting = false;
    }
  }
  /**
   * Triggers events when checked state is changed
   * @fires beforeChange
   * @fires change
   * @fires action
   * @private
   */


  triggerChange(userAction) {
    const me = this,
          {
      checked
    } = me.input;
    /**
     * Fired before checkbox is toggled. Returning false from a listener prevents the checkbox from being toggled.
     * @event beforeChange
     * @preventable
     * @param {Core.widget.Checkbox} source Checkbox
     * @param {Boolean} checked Checked or not
     */

    /**
     * Fired when checkbox is toggled
     * @event change
     * @param {Core.widget.Checkbox} source Checkbox
     * @param {Boolean} checked Checked or not
     */
    // Prevent uncheck if this checkbox is part of a toggleGroup (radio-button mode) ..also ensure the group has
    // visible active members

    const eventObject = {
      checked,
      value: checked,
      userAction,
      valid: true
    },
          prevented = !checked && userAction && me.toggleGroup && me.getToggleGroupMembers().filter(widget => widget.isVisible && !widget.disabled).length || // Since Widget has Events mixed in configured with 'callOnFunctions' this will also call onBeforeChange,
    // onChange and onAction
    me.trigger('beforeChange', eventObject) === false; // If prevented need to rollback the checkbox input

    if (prevented) {
      // Input change is not preventable, so need to revert the changes
      // The change event does not fire on programmatic change of input, so no need to suspend
      me.input.checked = me._value = !checked;
    } else {
      me.triggerFieldChange(eventObject, false);

      if (userAction) {
        me.uncheckToggleGroupMembers();
      }
      /**
       * User performed the default action (toggled the checkbox)
       * @event action
       * @param {Core.widget.Checkbox} source Checkbox
       * @param {Boolean} checked Checked or not
       */


      me.trigger('action', eventObject);
      me.trigger('change', eventObject) === false;
      return true;
    }
  } //endregion


} // Register this widget type with its Factory

Checkbox.initClass();
Checkbox._$name = 'Checkbox';

/***/ }),

/***/ "./lib/Core/widget/ChipView.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/ChipView.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ChipView; });
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
var productName = 'gantt';


/**
 * @module Core/widget/ChipView
 */

/**
 * Displays an inline series of Chips which may be navigated to, selected and deleted.
 * @extends Core/widget/List
 *
 * @classType chipview
 */

class ChipView extends _List_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ChipView';
  } // Factoryable type name


  static get type() {
    return 'chipview';
  }

  static get configurable() {
    return {
      itemCls: 'b-chip',

      /**
       * Configure as `true` to display a clickable close icon after the {@link Core.widget.List#config-itemTpl}.
       * When tapped, the configured {@link #config-closeHandler} is called passing the
       * associated record.
       *
       * Chips may also be selected using the `LEFT` and `RIGHT` arrows (And the `Shift` key to
       * do multiple, contiguous election). Pressing the `DELETE` or `BACKSPACE` key passes the
       * selected records to the {@link #config-closeHandler}
       * @config {Boolean}
       * @default
       */
      closable: true,

      /**
       * A template function, which, when passed a record, returns the markup which
       * encapsulates a chip's icon to be placed before the {@link Core.widget.List#config-itemTpl}.
       * @config {Function}
       */
      iconTpl: null,

      /**
       * If {@link #config-closable} is `true`, this is the name of a callback function
       * to handle what the "close" action means.
       * @config {String|Function}
       */
      closeHandler: null
    };
  }

  itemContentTpl(record, i) {
    const me = this;
    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].tpl`${me.iconTpl ? this.iconTpl(record) : ''}
            ${me.itemTpl(record, i)}
            ${me.closable ? '<div class="b-icon b-close-icon b-icon-clear" data-noselect></div>' : ''}`;
  }

  onInternalKeyDown(event) {
    if (this.closable && this.selected.count && (event.key === 'Delete' || event.key === 'Backspace')) {
      this.callback(this.closeHandler, this.owner, [this.selected.values, {
        isKeyEvent: true
      }]);
    } else {
      super.onInternalKeyDown(event);
    }
  }

  updateClosable(closable) {
    this.element.classList[closable ? 'add' : 'remove']('b-chips-closable');
    this.navigator.disabled = !closable;

    if (!this.isConfiguring) {
      this.refresh();
    }
  }

  onClick(event) {
    const me = this,
          item = event.target.closest(`.${me.itemCls}`);

    if (me.closable && event.target.classList.contains('b-close-icon')) {
      const record = me.store.getAt(parseInt(item.dataset.index));
      me.callback(me.closeHandler, me.owner, [[record]]);
    } else {
      super.onClick(event);
    }
  }

} // Register this widget type with its Factory

ChipView.initClass();
ChipView._$name = 'ChipView';

/***/ }),

/***/ "./lib/Core/widget/Combo.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Combo.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Combo; });
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _ChipView_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';















const errorFieldRequired = 'L{Field.fieldRequired}',
      errorValidateFilter = 'L{Field.validateFilter}',
      errorRecordNotCommitted = 'L{Combo.recordNotCommitted}';
/**
 * @module Core/widget/Combo
 */

/**
 * Combo (dropdown) widget. Consists of a text field with a trigger icon, which displays a List. Can be
 * populated from a Store.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 *
 * Please be aware that when populating the Combo with objects or records you have to configure {@link #config-valueField} and {@link #config-displayField}
 * to point to the correct field names in your data.
 *
 * ### Basic scenarios
 * {@inlineexample Core/widget/Combo.js vertical}
 *
 * ### Multiselect + grouped list
 *
 * {@inlineexample Core/widget/ComboMultiselect.js}
 *
 * ## Snippet: Loading data from simple string array
 * ```javascript
 * const combo = new Combo({
 *     items       : ['Small', 'Smaller', 'Really small', 'Tiny'],
 *     placeholder : 'Pick size of diamond for ring'
 * });
 *```
 *
 * ## Snippet: Loading data from array with item configs
 * ```javascript
 * const combo = new Combo({
 *     items : [{ value: 'a', text: 'First' }, { value: 'z', text: 'Last' }]
 * });
 *```
 *
 * ## Snippet: Loading data from store
 * ```javascript
 * const combo = new Combo({
 *     store        : memberStore,
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *```
 *
 * ## Snippet: Grouped list
 * To group the list contents, simply group your store using {@link Core.data.mixin.StoreGroup#config-groupers}. You
 * can decide if clicking a header should toggle all group children (or if it should do nothing) with the
 * {@link Core.widget.List#config-allowGroupSelect} flag.
 * ```javascript
 * const combo = new Combo({
 *     width            : 400,
 *     displayField     : 'name',
 *     valueField       : 'id',
 *     multiSelect      : true,
 *     picker : {
 *         allowGroupSelect : false,
 *         // Show icon based on group name
 *         groupHeaderTpl   : (record, groupName) => `
 *             <i class="icon-${groupName}"></i>${groupName}
 *         `
 *     },
 *     value : [1, 4],
 *     store : new Store({
 *         fields : [
 *             'type'
 *         ],
 *         groupers : [
 *             { field : 'type', ascending : true }
 *         ],
 *         data : [
 *             { id : 1, name : 'pizza', type : 'food' },
 *             { id : 2, name : 'bacon', type : 'food' },
 *             { id : 3, name : 'egg', type : 'food' },
 *             { id : 4, name : 'Gin tonic', type : 'drinks' },
 *             { id : 5, name : 'Wine', type : 'drinks' },
 *             { id : 6, name : 'Beer', type : 'drinks' }
 *         ]
 *     })
 * });
 *```
 *
 * @extends Core/widget/PickerField
 * @classType combo
 */

class Combo extends _PickerField_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  // Do not remove. Assertion strings for Localization sanity check.
  // 'L{Field.fieldRequired}'
  // 'L{Field.validateFilter}'
  // 'L{recordNotCommitted}
  //region Config
  static get $name() {
    return 'Combo';
  } // Factoryable type name


  static get type() {
    return 'combo';
  } // Factoryable type aliases


  static get alias() {
    return 'combobox,dropdown';
  }

  static get configurable() {
    return {
      /**
       * Optionally a {@link Core.util.CollectionFilter Filter} config object which
       * the combo should use for filtering using the typed value.
       * This may use a `filterBy` property to test its `value` against any field
       * in the passed record.
       * ```javascript
       * {
       *     type          : 'combo',
       *     store         : myStore,
       *     primaryFilter : {
       *         filterBy(record) {
       *             if (this.value == null) {
       *                 return true;
       *             }
       *             const value = this.value.toLowerCase();
       *
       *             // Match typed value with forename or surname
       *             return record.forename.toLowerCase().startsWith(value) || record.surname.toLowerCase().startsWith(value);
       *         }
       *     }
       * }
       * ```
       * @config {Object}
       */
      primaryFilter: {},
      picker: {
        type: 'list',
        floating: true,
        scrollAction: 'realign',
        itemsFocusable: false,
        activateOnMouseover: true,
        align: {
          align: 't0-b0',
          axisLock: true
        },
        maxHeight: 324,
        scrollable: {
          overflowY: true
        },
        autoShow: false,
        focusOnHover: false
      },

      /**
       * Configure as `true` to allow selection of multiple values from the dropdown list.
       *
       * Each value is displayed as a "Chip" to the left of the input area. Chips may be
       * selected using the `LEFT` and `RIGHT` arrow keys and deleted using the `DELETE` key
       * to remove values from the field. There is also a clickable close icon in each chip.
       *
       * Use {@link Core.widget.List#config-toggleAllIfCtrlPressed} to implement "select all" behaviour.
       *
       * ```javascript
       * {
       *     type   : 'combo',
       *     store  : myStore,
       *     picker : {
       *         toggleAllIfCtrlPressed : true
       *     }
       * }
       * ```
       *
       * @config {Boolean}
       * @default false
       */
      multiSelect: null,

      /**
       * Rows to display in the dropdown (list items).
       *
       * If an object, the property names provide the {@link #config-value} for the Combo, and
       * the property values provide the displayed test in the list and input area eg:
       *
       *     items : {
       *         small  : 'Small',
       *         medium : 'Medium',
       *         large  : 'Large'
       *     }
       *
       * If an array, each entry may be
       *  - an object containing properties which must include
       * the {@link #config-valueField} and {@link #config-displayField} which populates the dropdown
       * with text and provides the corresponding field value.
       *  - An array whose first value provides the {@link #config-value} for the Combo and whose
       * second value provides the displayed test in the list and input area.
       *  - An array of values where the {@link #config-valueField} and {@link #config-displayField} are the same.
       *
       * eg:
       *
       *     items : [
       *         {value : 'small',  text : 'Small'},
       *         {value : 'medium', text : 'Medium'},
       *         {value : 'large',  text : 'Large'},
       *     ]
       *
       * or
       *
       *     items : [
       *         ['small',  'Small'],
       *         ['medium', 'Medium'],
       *         ['large',  'Large'],
       *     ]
       *
       * or
       *
       *     items : [ 'Small', 'Medium', 'Large' ]
       *
       * @config {Object[]|String[]|Object}
       */
      items: null,

      /**
       * Get/set store to display items from. Also accepts a Store config object.
       * @member {Core.data.Store} store
       * @accepts {Core.data.Store|Object}
       */

      /**
       * A store used to populate items.
       * @config {Core.data.Store}
       */
      store: null,

      /**
       * Field used for item value when populating from store. Setting this to `null` will
       * yield the selected record as the Combo's {@link #property-value}.
       * @config {String|null}
       */
      valueField: undefined,

      /**
       * Field used for item text when populating from store
       * @config {String}
       */
      displayField: 'text',

      /**
       * Width of picker, defaults to this combo's {@link #config-pickerAlignElement} width
       * @config {Number}
       */
      pickerWidth: null,

      /**
       * The minimum string length to trigger the filtering, only relevant when {@link #config-editable} is `true`.
       *
       * This defaults to `1` in the case of local filtering, but `4` if the
       * {@link #config-filterParamName} is set to cause remote dropdown loading.
       *
       * @config {Number}
       * @default
       */
      minChars: null,
      selected: null,

      /**
       * Template string used to render the list items in the dropdown list
       *
       * ```javascript
       * new Combo({
       *     listItemTpl : ({ text }) => `<div class="combo-color-box ${text}"></div>${text}`,
       *     editable    : false,
       *     items       : [
       *         'Black',
       *         'Green',
       *         'Orange',
       *         'Pink',
       *         'Purple',
       *         'Red',
       *         'Teal'
       *     ]
       * });
       * ```
       *
       * @config {Function}
       * @param {Core.data.Model} record The record representing the item being rendered
       * @returns {String}
       */
      listItemTpl: null,

      /**
       * Template function that can be used to customize the displayed value
       * @param {Core.data.Model} record The record to provide a textual value for.
       * @param {Core.widget.Combo} combo A reference to this Combo.
       * @config {Function}
       * @returns {String}
       */
      displayValueRenderer: null,

      /**
       * CSS class to add to picker
       * @config {String}
       */
      listCls: null,
      triggers: {
        expand: {
          cls: 'b-icon-picker',
          handler: 'onTriggerClick'
        }
      },

      /**
       * If the dropdown is to be populated with a filtered query to a remote server, specify the
       * name of the parameter to pass the typed string here. By default, the string is simply sent
       * as the value of the parameter. For special encoding, configure the combo with {@link #config-encodeFilterParams}
       * @config {String}
       */
      filterParamName: null,

      /**
       * A function which creates an array of values for the {#config-filterParamName} to pass
       * any filters to the server upon load.
       *
       * The default behaviour is just to set the parameter value to the filter's `value`,
       * but the filter can be fully encoded for example:
       *
       * ```javascript
       *    {
       *        encodeFilterParams(filters) {
       *            const result = [];
       *
       *            for (const { property, operator, value, caseSensitive } of filters) {
       *                result.push(JSON.stringify({
       *                    field : property,
       *                    operator,
       *                    value,
       *                    caseSensitive
       *                }));
       *           }
       *        return result;
       *    }
       * ```
       * @config {Function}
       */
      encodeFilterParams: filters => filters.map(f => f.value),

      /**
       * If `false`, filtering will be triggered once you exceed {@link #config-minChars}. To filter only when
       * hitting Enter key, set this to `true`;
       * @config {Boolean}
       */
      filterOnEnter: false,

      /**
       * Configure as `true` to hide the expand trigger. This is automatically set to `true` if
       * remote filtering is enabled by setting the {@link #config-filterParamName} config.
       * @config {Boolean}
       * @default false
       */
      hideTrigger: null,

      /**
       * This implies that the picker will display an anchor pointer, but also means that the picker will align closer
       * to the input field so that the pointer pierces the {@link #config-pickerAlignElement}
       * @config {Boolean}
       * @default false
       */
      overlayAnchor: null,

      /**
       * The delay in milliseconds to wait after the last keystroke before filtering the list.
       *
       * This is a minimum of 300ms for remote filtering to keep network requests manageable, and
       * defaults to 10ms for locally filtered stores.
       * @config {Number}
       * @default
       */
      keyStrokeFilterDelay: null,
      defaultAction: 'select',

      /**
       * How to query the store upon click of the expand trigger. Specify one of these values:
       *
       *  - `'all'` - Clear the filter and display the whole dataset in the dropdown.
       *  - `'last'` - Filter the dataset using the last filter value.
       *  - `null`/any other - Use the value in the input field to filter the dataset.
       *
       * @config {String}
       * @default
       */
      triggerAction: 'all',

      /**
       * Get/sets of the operator type for the combo primary filter.
       *
       * @member {String} filterOperator
       */

      /**
       * The name of an operator type as implemented in {@link Core.util.CollectionFilter#config-operator}
       * to use when filtering the dropdown list based upon the typed value.
       *
       * This defaults to `'startsWith'`, but the `'*'` operator may be used to match all
       * values which _contain_ the typed value.
       *
       * Not used when {@link #config-filterParamName} is set to cause remote dropdown loading.
       * The exact filtering operation is up to the server.
       *
       * @config {String}
       */
      filterOperator: 'startsWith',

      /**
       * Configure as `true` to force case matching when filtering the dropdown list based upon the typed value.
       *
       * @config {Boolean}
       * @default false
       */
      caseSensitive: false,

      /**
       * By default, the picker is hidden on selection in single select mode, and
       * remains to allow more selections when {@link #config-multiSelect} is `true`.
       * Setting this to a `Boolean` value can override that default.
       * @config {Boolean}
       */
      hidePickerOnSelect: null,

      /**
       * A config object to configure the {@link Core.widget.ChipView} to display the
       * selected value set when {@link #config-multiSelect} is `true`.
       *
       * For example the {@link Core.widget.List#config-itemTpl} or
       * {@link Core.widget.ChipView#config-iconTpl} might be configured to display
       * richer chips for selected items.
       * @config {Object}
       */
      chipView: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'combochipview'
        }
      },
      chipStore: {
        $config: ['lazy', 'nullify'],
        value: {}
      },

      /**
       * When {@link #config-multiSelect} is `true`, you may configure `filterSelected` as
       * `true` to hide items in the dropdown when they are added to the selection.
       * It will appear as if the requested item has "moved" into the field's
       * {@link #config-chipView ChipView}.
       *
       * @config {Boolean}
       * @default false
       */
      filterSelected: null,

      /**
       * Text to display in the drop down when there are no items in the underlying store
       * @config {String}
       * @default
       */
      emptyText: null,

      /**
       * Get/sets combo value, selects corresponding item in the list
       * Setting null clears the field.
       *
       * If {@link #config-multiSelect} is `true`, then multiple values may be passed as an array.
       * If the values are records, these become the selected record set held by {@link #property-valueCollection},
       * and the `value` yielded by this field is an array of all the {@link #config-valueField}s from the records.
       * @fires select
       * @fires action
       * @member {Object} value
       */

      /**
       * The initial value of this Combo box. In single select mode (default) it's a simple string value, for
       * {@link #config-multiSelect} mode, it should be an array of record ids.
       * @config {String|Number[]|String[]}
       * @default
       */
      value: null,
      valueCollection: {
        $config: ['nullify', 'lazy'],
        value: {}
      },

      /**
       * `true` to cause the field to be in an invalid state while the typed filter string does not match a record in the store.
       * @config {Boolean}
       * @default
       */
      validateFilter: true,

      /**
       * `true` to clear value typed to a multiselect combo when picker is collapsed
       * @config {Boolean}
       * @default
       */
      clearTextOnPickerHide: true,
      // set to true to destroy the old combo store when it is replaced with a new store
      destroyStore: false,

      /**
       * A key value which, when typed in a {@link #config-multiSelect} Combo, selects the
       * currently active item in the picker, and clears the input field ready for another
       * match to be typed.
       * @config {String}
       * @default
       */
      multiValueSeparator: ',',

      /**
       * If configured as `true`, this means that when an unmatched string is typed into the
       * combo's input field, and `ENTER`, or the {@link #config-multiValueSeparator} is typed,
       * a new record will be created using the typed string as the {@link #config-displayField}.
       *
       * If configured as a function, or the *name* of a function in the owning component
       * hierarchy, the function will be called passing the string and should return the record
       * to add (if any).
       *
       * The new record will be appended to the store, and the value selected.
       *
       * If the Store is an {@link Core.data.AjaxStore}, the new record will be eiligible for
       * syncing to the database through its {@link Core.data.AjaxStore#config-createUrl createUrl}.
       *
       * If the `AjaxStore` is configured to {@link Core.data.AjaxStore#config-autoCommit autoCommit},
       * the record will be synced immediately. If the server does not accept the new addition,
       * the field is placed temporarily into an invalid state with a message that explains this.
       *
       * For example:
       *
       * ```javascript
       *     new Combo({
       *         label : 'Employee name',
       *         store : employees,
       *         createOnUnmatched(name, combo) {
       *             name = validateEmployeeName(name);
       *
       *             if (name) {
       *                 return new Employee({
       *                     name,
       *                     email : generateEmployeeEmail(name)
       *                 });
       *             }
       *             else {
       *                 combo.setError('Invalid new employee name');
       *             }
       *         }
       *     });
       * ```
       * @config {Function|String|Boolean}
       */
      createOnUnmatched: null,

      /**
       * Configure this as `true` to render the dropdown list as a permanently visible list
       * in the document flow immediately below the input area instead of as a popup.
       *
       * This also hides the expand trigger since it is not needed.
       * @config {Boolean}
       * @default false
       */
      inlinePicker: null,
      testConfig: {
        // So that locally filtered tests do not have to wait after type gestures.
        // Note that for remote filtering, we set a min of 300ms
        keyStrokeFilterDelay: 0
      }
    };
  }
  /**
   * A constant value for the {@link #config-triggerAction} config to indicate that clicking the trigger should
   * filter the dataset using the last filter query string, *not* the input field value.
   * @member {String} queryLast
   * @readonly
   * @static
   */


  static get queryLast() {
    return 'last';
  } //endregion


  construct(config) {
    super.construct(...arguments); // Ensure there will always be a store created if Combo is created without items/store

    if (!this.store) {
      this.items = [];
    }

    if (this.filterOnEnter) {
      this.hideTrigger = true;
    }
  }

  startConfigure(config) {
    this.usingRecordAsValue = config.valueField === null;
    super.startConfigure(...arguments);
  }

  afterConfigure() {
    super.afterConfigure();
    const me = this;

    if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].hasOwn(me, '_value')) {
      me._value = me.valueField === me.displayField ? '' : null; // _lastValue should stay keeping an initial value if any

      me._lastValue = me._lastValue || me._value;
    }
  }

  get childItems() {
    const {
      _chipView,
      _picker
    } = this,
          result = [];

    if (_chipView) {
      result.push(_chipView);
    }

    if (_picker) {
      result.push(_picker);
    }

    return result;
  }

  get innerElements() {
    var _this$_chipView;

    const chipViewElement = (_this$_chipView = this._chipView) === null || _this$_chipView === void 0 ? void 0 : _this$_chipView.element,
          // don't trigger chipView create on first compose()
    {
      input,
      inputElement
    } = this;

    if (chipViewElement) {
      // Once the input el is transplanted inside the chipView, normal compose() calls won't sync it, so we
      // have to do so now:
      _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_10__["default"].sync({
        targetElement: input,
        domConfig: inputElement
      });
    }

    return [chipViewElement || inputElement];
  }

  updateInlinePicker(inlinePicker) {
    if (inlinePicker) {
      this.element.classList.add('b-inline-picker'); // Force eager ingestion of picker

      this.getConfig('picker'); // No expand trigger

      this.triggers.expand = null;
      this.pickerVisible = true;
    }
  }

  hidePicker() {
    if (!this.inlinePicker) {
      return super.hidePicker(...arguments);
    }
  }

  changeChipStore(chipStore) {
    if (chipStore && !(chipStore instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
      chipStore = new _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"](_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeConfigs({
        storage: this.valueCollection
      }, chipStore));
    }

    return chipStore;
  }

  updateChipStore(store, was) {
    was === null || was === void 0 ? void 0 : was.destroy();
  }

  changeChipView(chipView, oldChipView) {
    const me = this;
    me.element.classList[chipView ? 'add' : 'remove']('b-uses-chipview');

    if (chipView) {
      const {
        input
      } = me;

      if (!me.chipStore) {
        me.chipStore = {};
      }

      return ComboChipView.reconfigure(oldChipView, chipView, {
        defaults: {
          parent: me,
          insertBefore: input,
          store: me.chipStore,
          closable: !me.readOnly,
          navigator: {
            class: ComboChipNavigator,
            keyEventTarget: input
          }
        }
      });
    }

    oldChipView === null || oldChipView === void 0 ? void 0 : oldChipView.destroy();
  }

  updateChipView(chipView) {
    var _me$_chipViewEventDet;

    const me = this;
    me._chipViewEventDetacher = (_me$_chipViewEventDet = me._chipViewEventDetacher) === null || _me$_chipViewEventDet === void 0 ? void 0 : _me$_chipViewEventDet.call(me);
    me.chipStore = chipView === null || chipView === void 0 ? void 0 : chipView.store;

    if (chipView) {
      // Insert the input field
      chipView.element.appendChild(me.input); // Focus must flow into our field from the ChipView

      me._chipViewEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
        element: chipView.element,
        mousedown: 'onChipViewMousedown',
        thisObj: me
      });
    }
  }

  updateMultiSelect(multiSelect, oldMultiSelect) {
    const me = this,
          {
      input,
      element
    } = me,
          fixValue = !me.isConfiguring;
    let {
      value
    } = me;
    element.classList[multiSelect ? 'add' : 'remove']('b-multiselect');

    if (multiSelect) {
      const {
        chipView
      } = me,
            {
        parentNode
      } = input,
            chipViewEl = chipView === null || chipView === void 0 ? void 0 : chipView.element; // If the input's parentNode is not the chipView's element, we need to restore that DOM arrangement

      if (chipViewEl && chipViewEl !== parentNode) {
        // This is where the chipView is created in the DOM but it may have been removed.
        parentNode.insertBefore(chipViewEl, input);
        chipViewEl.appendChild(input);
        me.chipView.refresh();
      }

      input.value = '';

      if (fixValue && !Array.isArray(value)) {
        value = value ? [value] : null;
      }
    } // else when !multiSelect, if the input's parentNode is the chipView's element, we need to put things back the
    // other way
    else {
      // avoid triggering lazy config if !multiSelect
      const chipView = me._chipView,
            {
        parentNode
      } = input,
            chipViewEl = chipView === null || chipView === void 0 ? void 0 : chipView.element;

      if (chipViewEl === parentNode) {
        // Put the input back in its proper place
        chipViewEl.parentNode.insertBefore(input, chipViewEl); // When no longer multiSelect, remove the chipView from the DOM. We do not destroy it because derived
        // classes or the instance config may have specified chipView config options. If we destroyed it, we could
        // not then properly recreate it.

        chipViewEl.remove();
        element.classList.remove('b-uses-chipview');
      }

      if (fixValue && typeof value !== 'string') {
        value = value && value.length ? value[0] : null;
      }
    }

    if (fixValue) {
      me.value = value;
    }
  }

  onChipViewMousedown(mousedownEvent) {
    mousedownEvent.preventDefault();

    if (!this.containsFocus) {
      this.focus();
    }
  }

  onChipClose(records, options = {}) {
    // Do not clean value collection if input field is not empty - probably text is selected
    // and user just wants to remove it, not the picked values
    if (options.isKeyEvent && this.input.value === '' || !options.isKeyEvent) {
      this._isUserAction = true;
      this.valueCollection.remove(records);
      this._isUserAction = false;
    }
  }

  updateFilterParamName(filterParamName) {
    if (this.hideTrigger !== false) {
      this.hideTrigger = Boolean(filterParamName);
    }
  }

  updateHideTrigger(hideTrigger) {
    this.element.classList[hideTrigger ? 'add' : 'remove']('b-hide-trigger');
  } //region Getters/setters


  updateKeyStrokeFilterDelay(delay) {
    const me = this;

    if (delay) {
      me.filterList = me.buffer(me.doFilter, delay);
    }
  }

  updateReadOnly(readOnly) {
    super.updateReadOnly(...arguments); // Disable closing (removing) chips when we are read-only.

    this._chipView && (this._chipView.closable = !readOnly);
  }

  updateFilterOperator(filterOperator) {
    if (this.primaryFilter) {
      this.primaryFilter.operator = filterOperator;
    }
  }

  get minChars() {
    const minChars = this._minChars;

    if (minChars != null) {
      return minChars;
    } // If it's not actually set, default differently for remote filtering.


    return this.remoteFilter ? 4 : 1;
  }

  get validateFilter() {
    // Do not show the error if the user has the opportunity to add the typed filter string
    return this._validateFilter && !this.createOnUnmatched;
  }

  get items() {
    return this.store.allRecords;
  }
  /**
   * Prepares items to work in attached menu (converts strings to items)
   * @private
   */


  changeItems(items) {
    const me = this;

    if (items == null) {
      if (me.store && !me.store.isItemStore) {
        return;
      }

      items = [];
    }

    if (items instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
      me.store = items;
      return;
    }

    const displayField = me.displayField;
    let itemModel,
        valueField = me.valueField,
        storeData;

    if (Array.isArray(items)) {
      storeData = items.map(item => {
        let result = item;

        if (item instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
          itemModel = item.constructor;

          if (!valueField) {
            me.valueField = valueField = itemModel.idField;
          }
        } else {
          if (typeof item === 'string' || typeof item === 'number') {
            if (!valueField) {
              me.valueField = valueField = me.displayField;
            }

            result = {
              [valueField]: item,
              [displayField]: item
            };
          } else {
            if (!valueField) {
              me.valueField = valueField = 'value';
            }

            if (Array.isArray(item)) {
              result = {
                [valueField]: item[0],
                [displayField]: item[1]
              };
            }
          }
        }

        if (item.selected) {
          me.value = result;
        }

        return result;
      });
    } // Must be a value -> text map
    else {
      if (!valueField) {
        me.valueField = valueField = 'value';
      }

      storeData = [];
      Object.entries(items).forEach(([key, value]) => {
        storeData.push({
          [valueField]: key,
          [displayField]: value
        });
      });
    } // Allow reconfiguring with a new set of items


    if (me.store) {
      me.store.data = storeData;
    } else {
      const valueFieldDefinition = valueField === displayField ? {
        name: 'value',
        dataSource: displayField
      } : valueField;
      me.store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
        isItemStore: true,
        data: storeData,
        idField: valueField,
        modelClass: itemModel || class extends _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
          static get idField() {
            // Need to use instance var and not rely on closure for cases where valueField changes
            // (like first assigning [] and then ['a'] without configured valueField
            return me.valueField;
          }

          static set idField(idField) {
            super.idField = idField;
          }

          static get fields() {
            return [valueFieldDefinition, displayField];
          }

        }
      });
    }
  }

  get value() {
    const me = this,
          {
      valueCollection,
      valueField
    } = me;

    if (valueField == null) {
      return me.multiSelect ? valueCollection.values.slice() : valueCollection.first;
    }

    let value;

    if (me.multiSelect) {
      value = valueCollection.count ? valueCollection.map(r => r[valueField]) : me._lastValue || [];
    } else {
      value = valueCollection.count ? valueCollection.first[valueField] : me._lastValue;
    }

    return value;
  }

  set value(value) {
    super.value = value;
  }

  changeValue(value, oldValue) {
    var _me$hidePickerOnSelec;

    const me = this;

    if (value === oldValue) {
      // Sync without highlight
      me.syncInputFieldValue(true);
      return;
    }

    if (!me.multiSelect && Array.isArray(value) && value.length > 1) {
      throw new Error('Multiple values cannot be set to a non-multiSelect Combo');
    } // This forces promotion of the items config into a Store if it has not already been injected


    me.triggerConfig('items'); // Set an empty items array if no data or store was given

    if (!me.store) {
      me.items = [];
    }

    const {
      valueField,
      displayField,
      store,
      valueCollection,
      _picker
    } = me,
          {
      storage
    } = store,
          hidePicker = (_me$hidePickerOnSelec = me.hidePickerOnSelect) !== null && _me$hidePickerOnSelec !== void 0 ? _me$hidePickerOnSelec : !me.multiSelect,
          isUserAction = me._isUserAction || (_picker === null || _picker === void 0 ? void 0 : _picker._isUserAction) || hidePicker && me.pickerVisible || false; // if not remoteFilter mode and AjaxStore has been used, try again to set a value after first store loading

    if (!me.remoteFilter && store.isAjaxStore && !store.count) {
      store.on('load', () => me.value = value, {
        once: true,
        thisObj: me
      }); // save value to make sure getter returns the correct data fot multiSelect while data loading

      me._lastValue = value;
      return;
    } // It's a remote filter store, so we have to do a filter down to just match(es)
    // and add the result to the valueCollection


    if (me.remoteFilter) {
      // The null case will drop through and be processed as for local just by clearing the valueCollection
      if (value != null) {
        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].isObject(value) || value.isModel) {
          this.store.data = [value];
          this.valueCollection.splice(0, this.valueCollection.count, this.store.first);
        } else {
          const wasConfiguring = me.isConfiguring;
          me.primaryFilter.setConfig({
            value,
            disabled: false
          });
          store.performFilter(true).then(() => {
            const {
              isConfiguring
            } = me; // Carry the wasConfiguring flag from the set value call frame so that
            // if it's the configuring set value, we do not now fire the change event.

            me.isConfiguring = wasConfiguring;
            valueCollection.splice(0, valueCollection.count, store.allRecords);
            me.isConfiguring = isConfiguring;
          });
        }

        return;
      }
    } // Else, if it's a *locally* filtered store, then
    // unfilter it so we can do the value lookup.
    else if (store.filtered) {
      me.primaryFilter.disabled = true;
      store.filter();
    }

    let record;

    if (value != null) {
      // If value is set as an array, make sure to slice it to not mutate original array below
      const arrayPassed = Array.isArray(value),
            values = arrayPassed ? value.slice() : [value];

      for (let i = 0, len = values.length; i < len; i++) {
        let currentValue = values[i];

        if (currentValue instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
          // The required record value may not yet be in the store. Add it if not.
          if (!storage.includes(currentValue)) {
            store.add(currentValue);
          }
        } else {
          const isObject = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isObject(currentValue); // If they passed a data object, match the valueField

          if (isObject) {
            currentValue = currentValue[valueField];
          } // Use the Store Collection's extra indices to quickly find a match.
          // They may not be found if the current valueCollection state and
          // filterSelected mean that some are filtered out, so check in
          // valueCollection if not found in the Store.


          record = storage.getBy(displayField, currentValue) || storage.getBy(valueField, currentValue) || valueCollection.getBy(displayField, currentValue) || valueCollection.getBy(valueField, currentValue); // If it's a potentially non-unique index (such as the by-displayField index)
          // then key lookups yield a Set. Use the first entry as the match.

          if (record instanceof Set) {
            record = [...record][0];
          }

          if (record) {
            // If the incoming value was a matched object, use it to update the record
            if (isObject) {
              record.set(values[i]);
            }

            values[i] = record;
          } else {
            values.splice(i, 1);
            len--;
            i--;
          }
        }
      }

      const noMatches = !values.length; // Remove all old values, add new values in one shot.

      const vcGen = valueCollection.generation;
      valueCollection.splice(0, valueCollection.count, values); // If we got no matches, onValueCollectionChange will set the _value to null.
      // Tests specify that the _value should be set to the incoming unmatched value.
      // Handle the case that an array was passed.

      if (noMatches) {
        me._value = arrayPassed && value.length === 0 ? null : value; // _lastValue has to be updated here to have an actual value for syncInputFieldValue() and syncEmpty() below

        me._lastValue = me._value;
      } // If no change has fed through to onValueCollectionChange, just ensure the input matches.
      // Must be done last so that the fallback of using this._value if the passed value did
      // not match a record can be used.


      if (noMatches || valueCollection.generation === vcGen) {
        me.syncInputFieldValue();
      }

      me.syncEmpty(); // If there were matches, onValueCollectionChange would have triggered the change event.
      // If not, we trigger it here.

      if (noMatches && !me.isConfiguring) {
        me.triggerFieldChange({
          value,
          oldValue,
          userAction: isUserAction,
          valid: me.isValid
        });
      }
    } else {
      if (valueCollection.count) {
        valueCollection.clear();
      } else {
        const oldValue = me._value; // Cache the value for use by our change handler next time, and also so that
        // when get value yields null, the fallback to ._value will be correct

        me._value = null;
        me.syncInputFieldValue();
        me.syncEmpty();

        if (!me.isConfiguring) {
          me.triggerFieldChange({
            value,
            oldValue,
            userAction: isUserAction,
            valid: me.isValid
          });
        }
      }
    }

    me._lastValue = me._value;
  }

  hasChanged(oldValue, newValue) {
    if (this.multiSelect) {
      return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isEqual(oldValue, newValue);
    }

    return super.hasChanged(...arguments);
  }

  onComboStoreChange({
    action
  }) {
    // Local filter-on-type is happening, do not sync the input value.
    if (action !== 'filter') {
      this.syncInputFieldValue(true);
    }
  }

  syncInputFieldValue(skipHighlight) {
    // We only sync the input's value if we are not using the chip view (DependencyField).
    // If we are multiselecting, our value is represented by a ChipView.
    // The ChipView automatically syncs itself with our valueCollection.
    if (!this.usesChipView) {
      super.syncInputFieldValue(skipHighlight);
    }
  }

  get usesChipView() {
    return Boolean(this.multiSelect && this._chipView);
  }
  /**
   * Returns `true` if this field has no selected records.
   * @property {Boolean}
   * @readonly
   */


  get isEmpty() {
    return this.valueCollection.count === 0;
  }

  get inputValue() {
    // This must be evaluated first, and NOT moved to be directly used as the
    // second expression in the ternary. If called during configuration, this
    // will import the configured value from the config object and ensure the
    // value is matched against the store, and that the "selected" property is set.
    const me = this;
    let result = me.selected ? me.selected[me.displayField] : me.value;

    if (me.displayValueRenderer) {
      result = me.callback(me.displayValueRenderer, me, [me.selected, me]);
    }

    return result == null ? '' : result;
  }
  /**
   * A {@link Core/util/Collection} which holds the currently selected records
   * from the store which dictates this field's value.
   *
   * Usually, this will contain one record, the record selected.
   *
   * When {@link #config-multiSelect} is `true`, there may be several records selected.
   * @member {Core.util.Collection} valueCollection
   * @readonly
   */


  changeValueCollection(valueCollection, oldValueCollection) {
    oldValueCollection === null || oldValueCollection === void 0 ? void 0 : oldValueCollection.destroy();

    if (valueCollection) {
      if (!valueCollection.isCollection) {
        valueCollection = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
          listeners: {
            noChange: 'onValueCollectionNoChange',
            change: 'onValueCollectionChange',
            prio: -1000,
            // The ChipView must react to changes first.
            thisObj: this
          }
        });
      }

      return valueCollection;
    }
  }

  changePrimaryFilter(primaryFilter) {
    if (!(primaryFilter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      if (typeof primaryFilter === 'function') {
        primaryFilter = {
          filterBy: primaryFilter
        };
      } // This is the filter that performs filtering on typing.


      primaryFilter = new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__["default"](_objectSpread({
        // Need an id to replace any existing combo filter on the store.
        // Dodge pre-commit hook by quoting property:
        'id': 'primary',
        // eslint-disable-line quote-props
        disabled: true,
        property: this.displayField,
        operator: this.filterOperator,
        caseSensitive: this.caseSensitive
      }, primaryFilter));
    }

    return primaryFilter;
  }

  changeStore(store) {
    if (Array.isArray(store)) {
      this.items = store;
      return;
    }

    if (store) {
      if (typeof store === 'string') {
        store = _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(store);
      } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isObject(store)) {
        store = new (store.readUrl ? _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__["default"] : _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"])(store);
        this.destroyStore = true;
      }

      const me = this,
            remoteFilter = me.remoteFilter || store.restfulFilter,
            {
        filterParamName,
        valueCollection,
        keyStrokeFilterDelay
      } = me,
            storeFilters = [];

      if (remoteFilter && filterParamName) {
        store.filterParamName = filterParamName;

        if (me.encodeFilterParams) {
          store.encodeFilterParams = me.encodeFilterParams;
        }
      } // If no value field provided, read it off of the Store's modelClass
      // Unless we want to use full record as the value


      if (!me.valueField && !me.usingRecordAsValue) {
        me.valueField = store.modelClass.idField;
      }

      storeFilters.push(me.primaryFilter);

      if (remoteFilter) {
        if (me.filterSelected) {
          store.storage.autoFilter = true;
          store.storage.addFilter({
            id: `${me.id}-selected-filter`,
            filterBy: r => !valueCollection.includes(r)
          });
        }
      } else if (me.filterSelected) {
        me.selectedItemsFilter = r => !valueCollection.includes(r);

        storeFilters.push(me.selectedItemsFilter);
        store.reapplyFilterOnAdd = true;
      } // Allow fast lookup in the valueCollection by value or displayed value.
      // We add these now because we are now guaranteed to have inferred
      // displayField and startField from any passed items array items is
      // promoted to a Store.


      valueCollection.addIndex({
        property: me.displayField,
        unique: false
      });
      valueCollection.addIndex({
        property: me.valueField,
        unique: true
      });
      store.filter(storeFilters); // If there's no configured delay, use sensible defaults.
      // AjaxStore, we don't want a network request fired off on every single keystroke.
      // Local store, delay it just a little to save data and DOM churn.

      if (remoteFilter) {
        // We enforce at least a 300ms delay when firing off network requests
        me.keyStrokeFilterDelay = Math.max(300, keyStrokeFilterDelay || 0);
      } else {
        me.keyStrokeFilterDelay = keyStrokeFilterDelay !== null && keyStrokeFilterDelay !== void 0 ? keyStrokeFilterDelay : 10;
      }
    }

    return store;
  }

  updateStore(store, oldStore) {
    const me = this,
          {
      _picker
    } = me;
    let storeListeners;

    if (this.destroyStore && oldStore) {
      oldStore.destroy();
    }

    if (_picker) {
      _picker.store = store;
    } // Allow fast lookup by value or displayed value


    store.storage.addIndex({
      property: me.displayField,
      unique: false
    });
    store.storage.addIndex({
      property: me.valueField,
      unique: true
    });
    storeListeners = {
      filter: 'onStoreFilter'
    };

    if (me.displayValueRenderer) {
      (storeListeners || (storeListeners = {})).change = 'onComboStoreChange';
      me.syncInputFieldValue();
    }

    me.detachListeners('store'); // Make sure we don't hold on to old records when store is changed
    // + update value collection with records from new store

    if (oldStore) {
      const oldValue = me.value;
      me.isConfiguring = true;
      me.value = null;
      me.isConfiguring = false;
      me.value = oldValue;
    }

    if (storeListeners) {
      storeListeners.name = 'store';
      storeListeners.thisObj = me;
      store.on(storeListeners);
    }
  }

  get remoteFilter() {
    var _this$_store;

    // Don't use "this.store" since we need to run during changeStore()
    return Boolean(this.filterParamName || ((_this$_store = this._store) === null || _this$_store === void 0 ? void 0 : _this$_store.restfulFilter));
  }
  /**
   * Get selected record.
   * @property {Core.data.Model[]}
   * @readonly
   */


  get record() {
    return this.selected;
  }
  /**
   * Get the selected record(s).
   * @property {Core.data.Model[]}
   * @readonly
   */


  get records() {
    return this.valueCollection.values.slice();
  }

  get selected() {
    return this.valueCollection.first;
  } //endregion
  //region Value handling

  /**
   * Check if field value is valid
   * @internal
   */


  onEditComplete() {
    const me = this,
          selectionCount = me.valueCollection.count;
    super.onEditComplete(); // Ensure the input area matches the selected value

    if (selectionCount) {
      me.clearError(errorValidateFilter);
      me.syncInputFieldValue();
    }

    if (me.required && !selectionCount) {
      me.setError(errorFieldRequired);
    }
  } //endregion
  //region Events

  /**
   * User clicked trigger icon, toggle list.
   * @private
   */


  onTriggerClick() {
    var _me$triggerAction;

    const me = this; // Bail out if enter key is required to trigger a filter

    if (me.remoteFilter && me.filterOnEnter) {
      return;
    }

    if (me.pickerVisible) {
      me.hidePicker();
    } else {
      if (!me.readOnly && !me.disabled) {
        switch ((_me$triggerAction = me.triggerAction) === null || _me$triggerAction === void 0 ? void 0 : _me$triggerAction.toLowerCase()) {
          case 'all':
            me.doFilter(null);
            break;

          case 'last':
            me.doFilter(me.lastQuery);
            break;

          default:
            me.doFilter(me.input.value);
        }
      }
    }
  }
  /**
   * User types into input field in editable combo, show list and filter it.
   * @private
   */


  internalOnInput(event) {
    const me = this,
          value = me.input.value,
          inputLen = value.length; // IE11 triggers input event on focus for some reason, ignoring it if not editable

    if (!me.editable) {
      return;
    }

    me.syncEmpty();
    me.syncInputWidth();
    me.inputting = true;

    if (me.inlinePicker || inputLen >= me.minChars && !me.filterOnEnter) {
      me.filterList(value);
    } else {
      // During typing, the field is invalid
      if (me.validateFilter && !me.remoteFilter) {
        me[inputLen ? 'setError' : 'clearError'](errorValidateFilter);
      }

      me.hidePicker();
    }

    me.inputting = false;
    /**
     * User typed into the field. Please note that the value attached to this event is the raw input field value and
     * not the combos value
     * @event input
     * @param {Core.widget.Combo} source The combo
     * @param {String} value Raw input value
     */

    me.trigger('input', {
      value,
      event
    });
  }

  syncInputWidth() {
    const me = this;

    if (me.usesChipView) {
      const input = me.input,
            // padding on the input el won't change, so cache the measurement:
      inputPadding = me._inputPadding || (me._inputPadding = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getEdgeSize(input, 'padding', 'lr')),
            value = input.value || '',
            width = // +'W' to avoid text getting clipped or horizontal scrolling
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].measureText(value + 'W', input, false, me.element) + inputPadding.width; // Normally the input is given "flex: 1 1 0px" so it will fill the space
      // so we just need to adjust the flex-basis to ensure the input is at least
      // as long as the text. Since it is also flex-shrink, it will not become
      // any larger than one "row".

      input.style.flex = `1 1 ${Math.ceil(width)}px`;
    }
  } // This is potentially a buffered function to respond to keystrokes in a buffered manner.
  // This only becomes useful as a saving when using remote querying where each filter is an Ajax request.


  filterList(queryString) {
    this.doFilter(queryString);
  }

  doFilter(queryString) {
    var _me$filterPromise;

    const me = this,
          {
      store,
      // Force the lazy config to create picker since the List needs to add its beforeLoad listener
      picker
    } = me,
          disableFilter = queryString == null || queryString === '';
    me.lastQuery = queryString;
    me.primaryFilter.setConfig({
      value: queryString,
      disabled: disableFilter
    });

    if (me.remoteFilter) {
      store.clear(true);
    } // We have the property 'filterPromise' while a filter operation is in flight.


    (_me$filterPromise = me.filterPromise = store.filter()) === null || _me$filterPromise === void 0 ? void 0 : _me$filterPromise.then(() => me.filterPromise = null);

    if (!me.inlinePicker) {
      if (picker !== null && picker !== void 0 && picker.isVisible) {
        // If aligned above, filtering will change its height so will need realigning
        if (picker.lastAlignSpec.zone === 0) {
          picker.realign();
        }
      } else {
        me.showPicker();
      }
    }

    if (store.count) {
      // If we are filtering, activate the first match
      if (!disableFilter) {
        me.picker.navigator.activeItem = 0;
      }
    } // If we were actively *locally* filtering on a string but there were no matches
    // and we are validateFilter: true, then mark as invalid even though we
    // may have an underlying valid selected value.
    else if (!me.remoteFilter && !disableFilter && me.validateFilter) {
      me.setError(errorValidateFilter);
    }
  }

  onStoreFilter({
    source: store
  }) {
    const me = this,
          picker = me._picker,
          dataset = picker === null || picker === void 0 ? void 0 : picker.element.dataset,
          {
      count
    } = store;

    if (me.remoteFilter) {
      // If we are filtering, activate the first match
      if (count) {
        if (picker) {
          picker.navigator.activeItem = 0;
        }
      } // Invalid if no matches after filtering
      else {
        if (me.validateFilter) {
          me.setError(errorValidateFilter);
        }
      } // If we have selection, evict selected items from the newly remote-filtered list


      if (me.filterSelected && me.valueCollection.count) {
        store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
        // then fires its own event. So we have to refresh the picker to hide the selected items.

        if (picker) {
          picker.refresh();
        }
      }
    } // If createOnUnmatched, we add a hint to add the value


    if (me.createOnUnmatched && !count) {
      dataset.addNewValue = me.L('L{addNewValue}')(me.primaryFilter.value);
    } else {
      dataset === null || dataset === void 0 ? true : delete dataset.addNewValue;
    }
  }
  /**
   * This reacts to our {@link #property-valueCollection} being mutated in any way.
   * The `change`, `select` and `action` events are fired here.
   *
   * This could happen in four ways:
   *
   *  - User selected or deselected an item in the dropdown list.
   *  - `set value` changes the content.
   *  - The {@link #config-multiSelect} Chip view (which uses this in its store) deletes a record.
   *  - The application programmatically mutates the {@link #property-valueCollection}.
   *
   * @private
   */


  onValueCollectionChange({
    source: valueCollection
  }) {
    var _me$hidePickerOnSelec2;

    const me = this,
          {
      multiSelect,
      _picker
    } = me,
          hidePicker = (_me$hidePickerOnSelec2 = me.hidePickerOnSelect) !== null && _me$hidePickerOnSelec2 !== void 0 ? _me$hidePickerOnSelec2 : !multiSelect,
          record = multiSelect ? valueCollection.values.slice() : valueCollection.first,
          records = valueCollection.values.slice(),
          isUserAction = me._isUserAction || (_picker === null || _picker === void 0 ? void 0 : _picker._isUserAction) || hidePicker && me.pickerVisible || false,
          oldValue = me._value;

    if (hidePicker) {
      me.hidePicker();
    }

    if (!valueCollection.count && me.required) {
      me.setError(errorFieldRequired);
    } else {
      me.clearError(errorFieldRequired);
      me.clearError(errorValidateFilter);
    }

    if (me.validateFilter && record) {
      me.clearError(errorValidateFilter);
    } // Re-evaluate *local* filtering so that selected items are filtered out of the dropdown.
    // For remote filtering, we programmatically add a filter to the store's storage


    if (me.filterSelected) {
      if (me.remoteFilter) {
        me.store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
        // then fires its own event. So we have to refresh the picker to hide the selected items.

        if (me._picker) {
          me._picker.refresh();
        }
      } else {
        me.store.filter();
      }
    } // Clear the cached value so that there's no fallback when we read back the value below


    me._value = null;
    me._lastValue = null; // Cache the value for use by our change handler next time, and also so that
    // if we just cleared the valueCollection, the fallback to ._value will be correct

    const value = me.cacheCurrentValue(me.value);
    me.syncInputFieldValue();
    me.syncEmpty();

    if (!me.isConfiguring) {
      me.triggerFieldChange({
        value,
        oldValue,
        userAction: isUserAction,
        valid: me.isValid
      });
      /**
       * An item in the list was selected
       * @event select
       * @param {Core.widget.Combo} source The combo
       * @param {Core.data.Model} record Selected record
       * @param {Core.data.Model[]} records Selected records as an array if {@link #config-multiSelect} is `true`
       * @param {Boolean} userAction `true` if the value change is due to user interaction.
       */

      me.trigger('select', {
        record,
        records,
        userAction: isUserAction
      });
      /**
       * Th default action was performed (an item in the list was selected)
       * @event action
       * @param {Core.widget.Combo} source The combo
       * @param {*} value The {@link #config-valueField value} of the selected record
       * @param {Core.data.Model} record Selected record
       * @param {Core.data.Model[]} records Selected records as an array if {@link #config-multiSelect} is `true`
       * @param {Boolean} userAction `true` if the value change is due to user interaction.
       */

      if (me.defaultAction === 'select') {
        me.trigger('action', {
          value,
          record,
          records,
          userAction: isUserAction
        });
      }
    }
  } // Caching a copy of current value, which can be changed by subclasses (see AssignmentField for reference)


  cacheCurrentValue(v) {
    return this._value = v;
  }
  /**
   * This listens for when a record from the list is selected, but is already part of
   * the selection and so the {@link #property-valueCollection} rejects that as a no-op.
   * At this point, the user will still expect the picker to hide.
   * @param {Object} event The noChange event containing the splice parameters
   * @private
   */


  onValueCollectionNoChange({
    toAdd
  }) {
    if (!this.inlinePicker && !this.multiSelect && toAdd.length && this.pickerVisible) {
      this.picker.hide();
    }
  } //endregion
  //region Picker


  showPicker() {
    const me = this,
          {
      picker
    } = me;

    if (me.readOnly || me.inlinePicker) {
      return;
    }

    picker.multiSelect = me.multiSelect;
    super.showPicker(); // Once we have access to the anchor size, overlay the anchor pointer over the target if configured to do so.

    if (me.overlayAnchor && !picker.align.offset) {
      picker.align.offset = -picker.anchorSize[1];
      picker.realign();
    } // Activate and make visible the *single* selected item.
    // Not valid if multiselect because the user's interest will not be focused on any one item.


    if (!me.multiSelect && me.selected) {
      picker.restoreActiveItem(me.selected, true);
    }

    me.input.focus();
  }
  /**
   * Creates default picker widget
   *
   * @internal
   */


  changePicker(picker, oldPicker) {
    var _picker2;

    const me = this,
          pickerWidth = me.pickerWidth || ((_picker2 = picker) === null || _picker2 === void 0 ? void 0 : _picker2.width),
          config = _List_js__WEBPACK_IMPORTED_MODULE_13__["default"].mergeConfigs({
      owner: me,
      store: me.store,
      selected: me.valueCollection,
      multiSelect: me.multiSelect,
      cls: me.listCls,
      displayField: me.displayField,
      forElement: me[me.pickerAlignElement],
      align: {
        matchSize: pickerWidth == null,
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement],
        // Reasonable minimal height to fit few combo items below the combo.
        // When height is not enough, list will appear on top. That works for windows higher than 280px,
        // worrying about shorter windows sounds overkill.
        // We cannot use relative measures here, each combo list item is ~40px high
        minHeight: me.inlinePicker ? null : Math.min(3, me.store.count) * 40
      },
      [me.listItemTpl ? 'itemTpl' : undefined]: me.listItemTpl,
      width: pickerWidth,
      navigator: {
        keyEventTarget: me.input
      }
    }, picker);

    if (me.inlinePicker) {
      Object.assign(config, {
        floating: false,
        align: null,
        activateOnMouseover: false,
        maxHeight: null,
        appendTo: me.element
      });
    }

    picker = _List_js__WEBPACK_IMPORTED_MODULE_13__["default"].reconfigure(oldPicker, picker ? config : null, me);

    if (picker) {
      picker.element.classList.add('b-combo-picker');
      picker.element.dataset.emptyText = me.emptyText || me.L('L{noResults}'); // We have to handle the click on "Add new value" when createOnUnmatched is set
      // because it's not a real list item, it's a repurposing of the .b-empty:after pseudo el.

      picker.on({
        navigate: 'onPickerNavigate',
        thisObj: me
      });
    }

    return picker;
  }

  onPickerNavigate({
    event
  }) {
    // It's a click on the "Add new value" prompt
    if (event.target.matches('[data-add-new-value]')) {
      this.addNewRecord(this.primaryFilter.value);
    }
  }

  onPickerHide() {
    const me = this;
    super.onPickerHide(); // https://app.assembla.com/spaces/bryntum/tickets/7736

    if (me.multiSelect && me.clearTextOnPickerHide) {
      me.input.value = '';
    }
  } //endregion


  async internalOnKeyEvent(keyEvent) {
    const me = this,
          value = me.input.value,
          inputLen = value.length,
          {
      key
    } = keyEvent,
          {
      store,
      _picker: picker,
      multiSelect
    } = me; // Typing the multiValueSeparator character selects the active list item, or
    // if there is no active item, and we are creating new records, creates the selected item.
    // The picker may not be a List with a Navigator.
    // We can only honour this functionality for normal, unoverridden List Pickers.
    // Some subclasses use Grids as pickers.

    if (keyEvent.type === 'keydown' && picker !== null && picker !== void 0 && picker.isVisible && picker.navigator) {
      const {
        activeItem
      } = picker.navigator; // If they type `,` in a multiSelect, it means add the active matched item if any

      if (activeItem && multiSelect && key === me.multiValueSeparator) {
        me.input.value = '';
        me.primaryFilter.setConfig({
          value: '',
          disabled: true
        });
        store.filter();
        picker.onItemClick(activeItem, keyEvent);
        picker.hide();
        keyEvent.preventDefault();
        return;
      } // Else, if there's no matched item and we are creating new records for unmatched keys
      // then `,` and Enter add a new record with the string as the displayField


      if (!activeItem && me.createOnUnmatched && (multiSelect && key === me.multiValueSeparator || key === 'Enter')) {
        keyEvent.preventDefault();
        await me.addNewRecord(value);
        return;
      }
    }

    super.internalOnKeyEvent(...arguments);

    if (keyEvent.type === 'keydown' && key === 'Enter' && me.filterOnEnter && inputLen >= me.minChars) {
      keyEvent.stopPropagation();
      me.filterList(value);
    }
  }

  async addNewRecord(value) {
    const me = this,
          {
      store,
      _picker: picker,
      valueCollection,
      multiSelect,
      primaryFilter
    } = me,
          remoteAutoCommit = store.remoteFilter && store.autoCommit; // We have to wait for remote filtering to finish before we add a new record to the added Bag
    // because store load (filter is a load) clears added records, and if the load returned during
    // the create commit that would invalidate the upcoming create return values by leaving no added
    // records to update with correct new IDs, and so the new record would appear to still
    // be a phantom, and therefore we would throw an error that the server has not accepted the addition..

    if (me.filterPromise) {
      await me.filterPromise;
    } // We can do this early if it's *NOT* a remote filtered, auto-committing AjaxStore.
    // If remote filtered and autoCommit, this will instigate a load which cannot be
    // concurrent with the upcoming auto commit.


    if (!remoteAutoCommit) {
      primaryFilter.setConfig({
        value: '',
        disabled: true
      });
      store.filter();
    }

    const [newRecord] = store.add(me.callback(me.createOnUnmatched, me, [value])); // It's an AjaxStore which is autoCommitting the new record to its createUrl
    // We wait to see if it's successful.

    if (store.isCommitting) {
      let error;

      try {
        await store.commitPromise;
      } catch (exception) {
        var _exception$response, _exception$response$p;

        error = (_exception$response = exception.response) === null || _exception$response === void 0 ? void 0 : (_exception$response$p = _exception$response.parsedJson) === null || _exception$response$p === void 0 ? void 0 : _exception$response$p.error;
      } // If the sync from the server did not return a concrete id, the record gets
      // left as phantom, so we have to remove it.


      if (newRecord.isPhantom) {
        me.clearError();
        me.setError(error || errorRecordNotCommitted, false, true);
        store.remove(newRecord); // AjaxStore adds to its removed Bag here because it clears down the addded Bag even
        // if not all added records were successfully synced, and remove adds to removed Bag
        // if the  record is *not* in the added Bag.

        store.removed.remove(newRecord);
      }
    } // Have to wait until now if its a remote filtered, auto-committing AjaxStore.


    if (remoteAutoCommit) {
      primaryFilter.setConfig({
        value: '',
        disabled: true
      });
      store.filter();
    }

    me.input.value = ''; // If an AjaxStore's sync of the add failed, do not select the new record

    if (store.includes(newRecord)) {
      // Append for multiSelect, or replace for non-multiSelect
      valueCollection.splice(multiSelect ? valueCollection.count : 0, multiSelect ? 0 : valueCollection.count, newRecord);
    }

    picker === null || picker === void 0 ? void 0 : picker.hide();
  }

  changeCreateOnUnmatched(createOnUnmatched) {
    if (createOnUnmatched === true) {
      createOnUnmatched = this.defaultRecordCreater;
    }

    return createOnUnmatched;
  }

  defaultRecordCreater(value) {
    return this.store.createRecord({
      [this.displayField]: value
    });
  }

}

class ComboChipView extends _ChipView_js__WEBPACK_IMPORTED_MODULE_5__["default"] {
  static get $name() {
    return 'ComboChipView';
  }

  static get type() {
    return 'combochipview';
  }

  static get defaultConfig() {
    return {
      closeHandler: 'up.onChipClose',
      itemsFocusable: false,
      multiSelect: true,

      itemTpl(record) {
        return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].encodeHtml(record[this.owner.displayField]);
      },

      scrollable: {
        overflowY: 'auto'
      }
    };
  }

}

class ComboChipNavigator extends _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_12__["default"] {
  static get defaultConfig() {
    return {
      allowShiftKey: true
    };
  }

  onTargetClick(clickEvent) {
    const me = this,
          item = clickEvent.target.closest(me.itemSelector);

    if (item && !clickEvent.shiftKey && !item.contains(clickEvent.target.closest('[data-noselect]'))) {
      me.ownerCmp.selected.clear();
    } // Our own updateActiveItem also selects because on superclass *key* navigation
    // (which is async on scroll end), it sets activeItem, and we select at that time.
    // So set a flag which disables this.


    me.inClickHandler = true;
    me.activeItem = item;
    me.inClickHandler = false;
  }

  onKeyDown(keyEvent) {
    // ENTER does not toggle selectedness in a ChipView.
    // ChipView's selection is bound to navigation.
    if (keyEvent.key !== 'Enter') {
      super.onKeyDown(keyEvent);
    }
  }

  updateActiveItem(activeItem, oldActiveItem) {
    const chipView = this.ownerCmp;
    super.updateActiveItem(activeItem, oldActiveItem); // Selection simply follows navigation in a ChipView

    if (activeItem && !this.inClickHandler) {
      chipView.selected.add(chipView.getRecord(activeItem));
    }
  }

  navigatePrevious(keyEvent) {
    const chipView = this.ownerCmp;

    if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
      chipView.selected.clear();
    }

    if (this.previous) {
      super.navigatePrevious(keyEvent);
    } else {
      this.activeItem = null;
    }
  }

  navigateNext(keyEvent) {
    const chipView = this.ownerCmp; // SHIFT+navigate preserves selection

    if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
      chipView.selected.clear();
    }

    if (this.next) {
      super.navigateNext(keyEvent);
    } else {
      this.activeItem = null;
    }
  }

} // Register this widget type with its Factory


Combo.initClass();
ComboChipView.initClass();
Combo._$name = 'Combo';

/***/ }),

/***/ "./lib/Core/widget/Container.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/Container.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Container; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _layout_Layout_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./layout/Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Ripple_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");
var productName = 'gantt';








/**
 * @module Core/widget/Container
 */

const emptyObject = Object.freeze({}),
      {
  isArray
} = Array,
      returnWeight = i => i.weight,
      // Allowing string weights (used by subgrids for backwards compatibility)
sortByWeight = ({
  weight: a
}, {
  weight: b
}) => {
  if (typeof a === 'string' || typeof b === 'string') {
    return String(a).localeCompare(String(b));
  } // Items without weight sort last


  return (a !== null && a !== void 0 ? a : Number.MAX_SAFE_INTEGER) - (b !== null && b !== void 0 ? b : Number.MAX_SAFE_INTEGER);
},
      isNotHidden = w => w && !w.hidden,
      stylesToCheck = ['display', 'flex-direction'];
/**
 * Widget that can contain other widgets. Layout is flexbox by default, see the {@link #config-layout} config.
 *
 * ```javascript
 * // create a container with two widgets
 * let container = new Container({
 *     items : [
 *         { type : 'text', label : 'Name' },
 *         { type : 'number', label : 'Score' }
 *     ]
 * });
 * ```
 *
 * Containers can have child widgets added, or removed during their lifecycle to accommodate business needs.
 *
 * For example:
 *
 *  ```javascript
 *  myTaskPopup.on({
 *      beforeShow() {
 *          if (task.type === task.MASTER) {
 *              // Insert the childTask multiselect before the masterTask field
 *              myPopup.insert(childTaskMultiselect, masterTaskField)
 *
 *              // We don't need this for master tasks
 *              myPopup.remove(masterTaskField);
 *          }
 *          else {
 *              // Insert the masterTask combo before the childTask multiselect
 *              myPopup.insert(masterTaskField, childTaskMultiselect)
 *
 *              // We don't need this for child tasks
 *              myPopup.remove(childTaskMultiselect);
 *          }
 *      }
 *  });
 * ```
 *
 * @extends Core/widget/Widget
 * @classType container
 * @inlineexample Core/widget/Container.js
 */


class Container extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Container';
  } // Factoryable type name


  static get type() {
    return 'container';
  }

  static get configurable() {
    return {
      /**
       * An object containing typed child widget config objects or Widgets. May also be specified
       * as an array.
       *
       * If configured as an Object, the property names are used as the child component's
       * {@link Core.widget.Widget#config-ref ref} name, and the value is the child component's config object.
       *
       * ```javascript
       *
       *  class MyContainer extends Container {
       *      static get configurable() {
       *          return {
       *              items : {
       *                  details : {
       *                      type : 'panel',
       *                      ....
       *                  },
       *                  button : {
       *                      type : 'button',
       *                      text : 'Save'
       *                  }
       *              }
       *          }
       *      }
       *  }
       *
       *  new MyContainer({
       *      title    : 'Test Container',
       *      floating : true,
       *      centered : true,
       *      width    : 600,
       *      height   : 400,
       *      layout   : 'fit',
       *      items    : {
       *          button : {
       *              disabled : true
       *          },
       *          details : {
       *              title : 'More coolness',
       *              html  : 'Details content'
       *      }
       *  }).show();
       * ```
       *
       * The order of the child widgets is determined by the order they are defined in `items`, but can also be
       * affected by configuring a {@link Core.widget.Widget#config-weight} on one or more widgets.
       *
       * If you want to customize child items of an existing class, you can do this using the child widget
       * 'ref' identifier (useful for reconfiguring Event Editor in Scheduler / Gantt):
       *
       * ```javascript
       *  new MyCustomTabPanel({
       *      items    : {
       *          // Reconfigure tabs
       *          firstTab : {
       *              title : 'My custom title'
       *          },
       *          secretTab : null // hide this tab
       *      }
       *  }).show();
       * ```
       *
       * @config {Object|Object[]|Core.widget.Widget[]}
       * @category Content
       */
      items: null,

      /**
       * An array of {@link #config-items child item} _config objects_ which is to be converted into
       * instances only when this Container is rendered, rather than eagerly at construct time.
       *
       * _This is mutually exclusive with the {@link #config-items} config._
       *
       * @config {Object|Object[]|Core.widget.Widget[]}
       * @category Content
       */
      lazyItems: {
        $config: ['lazy'],
        value: null
      },

      /**
       * A config object containing default settings to apply to all child widgets.
       * @config {Object}
       * @category Content
       */
      defaults: null,
      defaultType: 'widget',

      /**
       * The CSS style properties to apply to the {@link Core.widget.Widget#property-contentElement}.
       *
       * By default, a Container's {@link Core.widget.Widget#property-contentElement} uses flexbox layout, so this
       * config may contain the following properties:
       *
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
       * @config {Object}
       * @category Layout
       */
      layoutStyle: null,

      /**
       * An optional CSS class to add to child items of this container.
       * @config {String}
       * @category CSS
       */
      itemCls: null,

      /**
       * The {@link #config-layout} as an instance of {@link Core.widget.layout.Layout}.
       * This is a helper class which adds and removes child widgets to this Container's
       * DOM and applies CSS classes based upon its requirements.
       *
       * The {@link Core.widget.layout.Card card} layout provides for showing one child
       * widget at a time, and provides a switching API to change which child widget is
       * currently active.
       * @member {Core.widget.layout.Layout} layout
       */

      /**
       * The short name of a helper class which manages rendering and styling of child items.
       *
       * Or a config object which includes a `type` property which specifies which type
       * of layout to use, and how to configure that layout.
       *
       * By default, the only special processing that is applied is that the Container class's
       * {@link #config-itemCls} is added to child items.
       *
       * Containers use CSS flexbox in its default configuration to arrange child items. You may either use the
       * {@link #config-layoutStyle} configuration to tune how child items are layed out, or use one of the built
       * in helper classes which include:
       *
       *  - `fit` A single child item is displayed fitting exactly into the
       *  {@link Core.widget.Widget#property-contentElement}.
       *  - `card` Child items are displayed one at a time, size to fit the
       *  {@link Core.widget.Widget#property-contentElement} and are slid in from the side when activated.
       *  - `box` Child items are layed out using flexbox.
       *
       * For example:
       * ```javascript
       * {
       *     id     : 'myContainer',
       *     // Our child items flow downwards and are stretched to fill our width
       *     layout : {
       *         type       : 'box',
       *         direction  : 'column'
       *         align      : 'stretch'
       *     }
       * }
       * @config {String|Object}
       * @category Layout
       */
      layout: {
        type: 'default'
      },
      // TODO: deprecate namedItems, use items instead

      /**
       * An object containing named config objects which may be referenced by name in any {@link #config-items}
       * object. For example, a specialized {@link Core.widget.Menu Menu} subclass may have a `namedItems` default
       * value defined like this:
       *
       * ```javascript
       *  namedItems : {
       *      removeRow : {
       *          text : 'Remove row',
       *          onItem() {
       *              this.ownerGrid.remove(this.ownerGrid.selectedRecord);
       *          }
       *      }
       *  }
       * ```
       *
       * Then whenever that subclass is instantiated and configured with an {@link #config-items} object, the
       * items may be configured like this:
       *
       * ```javascript
       *  items : {
       *      removeRow : true,   // The referenced namedItem will be applied to this
       *      otherItemRef : {
       *          text : 'Option 2',
       *          onItem() {
       *          }
       *      }
       * }
       * ```
       * @config {Object}
       * @category Content
       */
      namedItems: null,

      /**
       * When set to `true`, this widget is considered as a whole when processing {@link Core.widget.Toolbar}
       * overflow. When `false`, this widget's child items are considered instead.
       * @config {Boolean}
       * @default false
       * @category Layout
       * @internal
       */
      overflowable: {
        value: null,
        default: false,
        $config: null
      },

      /**
       * Specify `true` for a container used to show text markup. It will apply the CSS class `b-text-content`
       * which specifies a default max-width that makes long text more readable.
       *
       * This CSS class is automatically removed if the container adds/defines child Widgets.
       * @config {Boolean}
       * @default
       * @category Content
       */
      textContent: true,

      /**
       * Record whose values will be used to populate fields in the container.
       * @config {Object}
       * @internal
       */
      record: null,
      // NOTE: internal since record is not documented

      /**
       * Update assigned {@link #config-record} automatically on field changes
       * @config {Boolean}
       * @internal
       */
      autoUpdateRecord: null,

      /**
       * Specify `true` to make this container hide when it has no visible children (Either empty
       * or all children hidden).
       *
       * Container will show itself when there are visible children, ie: hidden children are
       * shown, or new visible children are added.
       * @config {Boolean}
       * @default
       * @category Layout
       */
      hideWhenEmpty: null,
      contentElMutationObserver: {
        $config: ['lazy', 'nullify'],
        value: true
      },

      /**
       * Specify `true` to isolate record changes to this container and its ancestors. Prevents record
       * updates from propagating up from here and also prevents record updates from parent from
       * propagating down to us.
       *
       * @config {Boolean}
       * @default false
       * @internal
       */
      isolateFields: false
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * @member {Boolean} initialItems
       * This property is `true` until the container's initial `items` config has been processed. This property
       * is set to `false` by the `updateItems` method.
       * @readonly
       * @internal
       */
      initialItems: true
    };
  }
  /**
   * Sets multiple flexbox settings which affect how child widgets are arranged.
   *
   * By default, Containers use flexbox layout, so this property may contain the following properties:
   *
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
   * @member {Object} layoutStyle
   * @category Layout
   */

  /**
   * The {@link Core.data.Model record} to be applied to the fields contained in this Container. Any descendant
   * widgets of this Container with a `name` property will have its value set to the value of that named property of
   * the record. If no record is passed, the widget has its value set to `null`.
   * @member {Core.data.Model} record
   */


  startConfigure(config) {
    // Set a flag so that code can test for presence of items.
    // Widgets which render child widgets outside of the Container scheme
    // can set this flag (eg Panels with tools and tbar).
    const items = config.items || config.lazyItems;

    if (!(this.hasItems = Boolean(items && (isArray(items) ? items : Object.keys(items)).length))) {
      this.initialItems = false; // we won't be running updateItems, so clear this flag now
    }

    super.startConfigure(config);
  }
  /**
   * Removes the passed child/children from this Container.
   * @param  {...Core.widget.Widget} toRemove The child or children to remove.
   * @returns {Core.widget.Widget|Core.widget.Widget[]} All the removed items. An array if multiple items
   * were removed, otherwise, just the item removed.
   */


  remove(...toRemove) {
    let returnArray = true;

    if (toRemove.length === 1) {
      if (isArray(toRemove[0])) {
        toRemove = toRemove[0];
      } else {
        returnArray = false;
      }
    }

    const me = this,
          {
      _items
    } = me,
          result = [];

    for (let i = 0; i < toRemove.length; i++) {
      const childToRemove = toRemove[i];

      if (_items.includes(childToRemove)) {
        _items.remove(childToRemove);

        me.layout.removeChild(childToRemove);
        result.push(childToRemove);
        me.onChildRemove(childToRemove);
      }
    }

    return returnArray ? result : result[0];
  }
  /**
   * Removes all children from this Container.
   * @returns {Core.widget.Widget[]} All the removed items.
   */


  removeAll() {
    return this.remove(this.items);
  }
  /**
   * Appends the passed widget / widgets or config(s) describing widgets to this Container.
   *
   * If the widgets specify a `weight`, they are inserted at the correct index compared to the existing items weights.
   *
   * @param {Object|Object[]|Core.widget.Widget|Core.widget.Widget[]} toAdd The child or children instances (or config objects) to add.
   * @returns {Core.widget.Widget|Core.widget.Widget[]} All the added widgets. An array if multiple items
   * were added, otherwise just the item added.
   */


  add(...toAdd) {
    const me = this,
          result = [];
    let {
      _items
    } = me,
        returnArray = true,
        childToAdd,
        i,
        index;

    if (toAdd.length === 1) {
      if (isArray(toAdd[0])) {
        toAdd = toAdd[0];
      } else {
        returnArray = false;
      }
    } // Force creation of our items Bag


    if (!_items) {
      me.items = [];
      _items = me._items;
    }

    for (i = 0; i < toAdd.length; i++) {
      var _childToAdd;

      childToAdd = toAdd[i]; // Items with weight are inserted at correct index

      if (((_childToAdd = childToAdd) === null || _childToAdd === void 0 ? void 0 : _childToAdd.weight) != null) {
        // Cannot use cached _items, weights might be unordered in set being added
        index = _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].findInsertionIndex(childToAdd, _items.values, sortByWeight);
        result.push(me.insert(childToAdd, index));
      } // Those without are appended
      else if (childToAdd) {
        if (childToAdd.isWidget) {
          childToAdd.parent = me;
        } else {
          childToAdd = me.createWidget(childToAdd);
        }

        if (!_items.includes(childToAdd)) {
          _items.add(childToAdd);

          me.onChildAdd(childToAdd);
          me.layout.appendChild(childToAdd);
          result.push(childToAdd);
        }
      }
    }

    return returnArray ? result : result[0];
  }
  /**
   * Inserts the passed widget into this Container at the specified position.
   * @param  {Core.widget.Widget} toAdd The child to insert.
   * @param {Number|Core.widget.Widget} index The index to insert at or the existing child to insert before.
   * @returns {Core.widget.Widget} The added widget.
   */


  insert(toAdd, index) {
    // Force creation of our items Bag
    if (!this.items) {
      this.items = [];
    }

    const me = this,
          {
      _items
    } = me;

    if (toAdd instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
      toAdd.parent = me;
    } else {
      toAdd = me.createWidget(toAdd);
    }

    if (_items.includes(index)) {
      index = me.indexOfChild(index);
    }

    index = Math.min(index, _items.count);
    const newValues = _items.values;
    newValues.splice(index, 0, toAdd);
    _items.values = newValues; // Register inserted item

    me.onChildAdd(toAdd);
    me.layout.insertChild(toAdd, index);
    return toAdd;
  }

  indexOfChild(child) {
    return this.items.indexOf(child);
  }

  changeLazyItems(lazyItems) {
    this.items = lazyItems;
    this.layout.renderChildren();
  }

  changeItems(items, oldItems) {
    const me = this,
          newItems = [],
          result = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__["default"]();

    if (isArray(items)) {
      me.processItemsArray(items, newItems);
    } else if (items) {
      me.processItemsObject(items, me.namedItems, newItems);
    } // Allow child items to have a weight to establish their order


    if (newItems.some(returnWeight)) {
      newItems.sort(sortByWeight);
    }

    result.add(newItems); // Remove previous child payload if any

    if (oldItems) {
      oldItems.forEach(w => {
        me.remove(w); // Destroy outgoing-only widgets which we created.

        if (!result.includes(w) && w._createdBy === me) {
          w.destroy();
        }
      });
    }

    return result;
  }

  updateItems(items, oldItems) {
    let index = 0;
    items.forEach(item => {
      // no "index" argument from Bag
      this.onChildAdd(item); // If this is *change* to items from actual old items, when the old items is not a placeholder inserted
      // from very early items access

      if (oldItems && !oldItems.temporary) {
        this.layout.insertChild(item, index);
      }

      ++index;
    });
    this.initialItems = false;
  }

  updateHideWhenEmpty() {
    this.syncChildCount(this.rendered);
  }
  /**
   * A property, which, when *read*, yields an array of the child items of this container in rendered order.
   *
   * This property may also be *set* to change the child items of the container. Just as in the
   * {@link #config-items initial items configuration}, the new value may either be an array of
   * Widgets/Widget configs or an object.
   *
   * If specified as an Object, the property names are used as the child Widget's
   * {@link Core.widget.Widget#config-ref ref} name, and the value is the child Widget/Widget config.
   *
   * When setting this, any items which are *only* in the outgoing child items which were created
   * by this container from raw config objects are destroyed.
   *
   * Usage patterns:
   *
   * ```javascript
   * myContainer.items = {
   *     name : {
   *         type  : 'textfield',
   *         label : 'User name'
   *     },
   *     age : {
   *         type  : 'numberfield',
   *         label : 'User age'
   *     }
   * };
   * ```
   *
   * or
   *
   * ```javascript
   * myContainer.items = [{
   *     ref   : 'name',
   *     type  : 'textfield',
   *     label : 'User name'
   * },
   *     ref   : 'age',
   *     type  : 'numberfield',
   *     label : 'User age'
   * }];
   * ```
   * @property {Core.widget.Widget[]}
   * @accepts {Core.widget.Widget[]|Object}
   */


  get items() {
    const me = this; // If we are being asked for items, ingest lazyItems.

    me.getConfig('lazyItems'); // The documented API for items is an Array.
    // Internal code should access _items

    if (!me._items) {
      // Currently initializing items, flag set by the config system
      if (me.initializingItems) {
        // This is a created array. User may mutate it.
        return [];
      } // Accessing items very early, not set up yet. Need a placeholder


      me._items = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__["default"]();
      me._items.temporary = true;
    } // This is the Collection's array. User may not mutate it.


    return me._items.values;
  }

  processItemsArray(items, result) {
    const len = items.length;
    let i, item;

    for (i = 0; i < len; i++) {
      item = items[i];

      if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
        item.parent = this;
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(item.element, _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].outerCls);
      } else {
        item = this.createWidget(item);
      } // If the widget creation function returns null, nothing to add


      if (item) {
        if (item.ref || item.id) {
          // Add early to widgetMap, to allow using 'up.widgetMap.ref' in later siblings configs
          this.addDescendant(item);
        }

        result.push(item);
      }
    }
  }

  processItemsObject(items, namedItems, result) {
    let item, ref;

    for (ref in items) {
      item = items[ref]; // It might come in as itemRef : false

      if (item) {
        // If this class or instance has a "namedItems" object
        // named by this ref, then use it as the basis for the item
        if (namedItems && ref in namedItems) {
          item = typeof item === 'object' ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(namedItems[ref]), item) : namedItems[ref];
        } // Allow namedItems to be overridden with itemKey : false to indicate unavailability of an item


        if (item) {
          if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
            item.parent = this;
          } else {
            if (item instanceof Object) {
              item.ref = ref;
            }

            item = this.createWidget(item);
          } // If the widget creation function returns null, nothing to add


          if (item) {
            item.ref = ref; // Add early to widgetMap, to allow later siblings to use 'up.'

            this.addDescendant(item);
            result.push(item);
          }
        }
      }
    }
  }

  onChildAdd(item) {
    // Don't just assign the property across since the default value is undefined
    // which means false. Only set to true if we are readOnly
    if (item.innerItem && this.readOnly) {
      item.readOnly = true;
    }

    this.onChildAddLayout(item);

    if (item.ref || item.id) {
      for (let current = this; current; current = current.parent) {
        // Silently add the descendant to the ancestor's widgetMap without kicking off
        // the ancestor's items processing by directly accessing the widgetMap property.
        current.addDescendant(item);
      }
    }

    this.syncChildCount(true);
  }

  onChildAddLayout(item) {
    // Set innerItem=false on an item that should not be managed by the layout...
    if (item.innerItem) {
      // Keep layout informed of child item state
      this.layout.onChildAdd(item);
    }
  }

  onChildHide() {
    this.syncChildCount(true);
  }

  onChildShow() {
    this.syncChildCount(true);
  }

  syncChildCount(enforceHideWhenEmpty) {
    // If called during configuration, the element may not be available because
    // some non-item widgets (eg, Tools) instantiate and declare themselves through
    // onChildAdd before the element is set.
    // But also there may be no items because of     lazyItems.
    // So do the initial sync at render time.
    if (!this.isConfiguring) {
      const me = this,
            {
        childItems,
        hasItems
      } = me,
            {
        length
      } = childItems,
            visibleItems = childItems.filter(isNotHidden),
            {
        length: visibleLength
      } = visibleItems; // Do not toggle visibility on render - we're just here to sync class names.
      // hiding and showing must only depend upon children being dynamically
      // hidden or shown.

      if (me.hideWhenEmpty && enforceHideWhenEmpty) {
        const shouldHide = Boolean(!visibleLength);

        if (Boolean(me._hidden) !== shouldHide) {
          me.hidden = shouldHide;
        }
      }

      for (let i = 0; i < length; i++) {
        childItems[i].element.classList.remove('b-last-visible-child');
        childItems[i].element.classList.remove('b-first-visible-child');
      }

      if (visibleLength) {
        visibleItems[0].element.classList.add('b-first-visible-child');
        visibleItems[visibleLength - 1].element.classList.add('b-last-visible-child');
      } // Keep hasItems property up to date. It's used by the isFocusable getter.


      me.hasItems = Boolean(length);
      me.contentElement.classList[visibleLength ? 'remove' : 'add']('b-no-visible-children'); // Reevaluate whether we should have the b-text-content class

      if (!me.isComposable) {
        me.updateTextContent(me._textContent);
      } else if (hasItems !== me.hasItems) {
        me.recompose();
      }
    }
  }

  syncFlexDirection() {
    const me = this,
          {
      contentElement
    } = me,
          classList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"](contentElement.className),
          styles = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(contentElement, stylesToCheck); // We might not be flexing at all any more.

    classList['b-flex-row'] = classList['b-flex-column'] = 0; // If we are, add a flag class to indicate direction

    if (styles.display === 'flex') {
      classList[`b-flex-${styles['flex-direction']}`] = 1;
    } // Will only mutate the DOM if there are changes to apply.
    // We don't want to cause an infinite loop through our MutationObserver.


    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncClassList(contentElement, classList);
  }

  addDescendant(item) {
    const ref = item.ref || item.id,
          widgetMap = this._widgetMap || (this._widgetMap = {});

    if (!widgetMap[ref]) {
      widgetMap[ref] = item;
    }
  }

  onChildRemove(item) {
    const ref = item.ref || item.id;

    if (ref) {
      for (let current = this; current; current = current.parent) {
        if (current.widgetMap[ref] === item) {
          delete current.widgetMap[ref];
        }
      }
    } // Keep layout informed of child item state


    this.layout.onChildRemove(item);
    this.syncChildCount(true);
  }
  /**
   * An object which contains a map of descendant widgets keyed by their {@link Core.widget.Widget#config-ref ref}.
   * All descendant widgets will be available in the `widgetMap`.
   * @property {Object}
   * @readonly
   * @category Content
   */


  get widgetMap() {
    if (!this._widgetMap) {
      this._widgetMap = {};
    } // Force evaluation of the configured items by the getter
    // so that configs are promoted to widgets and the widgetMap
    // is created, and if there are widgets, populated.


    if (!this.initializingItems) {
      this.getConfig('items');
    }

    return this._widgetMap;
  }

  changeRecord(record) {
    // The config system's non-change vetoing must be bypassed.
    // The record might have changed, or the destination fields may be out of sync.
    this._record = record == null ? emptyObject : null;
    return record;
  }

  updateRecord(record) {
    /**
     * Fired before this container will load record values into its child fields. This is useful if you
     * want to modify the UI before data is loaded (e.g. set some input field to be readonly)
     * @event beforeSetRecord
     * @param {Core.widget.Container} source The container
     * @param {Core.data.Model} record The record
     */
    this.trigger('beforeSetRecord', {
      record
    });
    this.setValues(record, true, !this.$highlight);
  }

  setRecord(record, highlightChanges) {
    this.$highlight = highlightChanges;
    this.record = record;
    this.$highlight = false;
  }
  /**
   * A function called by descendant widgets after they trigger their 'change' event, in reaction to field changes.
   * By default implements the functionality for the `autoUpdateRecord` config.
   *
   * @param {Object} params Normally the event params used when triggering the 'change' event
   * @internal
   */


  onFieldChange({
    source,
    userAction
  }) {
    // When configured with `autoUpdateRecord`, changes from descendant fields/widgets are applied to the loaded
    // record using the fields `name`. Only changes from valid fields will be applied
    if (this.autoUpdateRecord) {
      const {
        record
      } = this,
            {
        name,
        isValid,
        value
      } = source;

      if (record && userAction && name && isValid) {
        record[name] = value;
      }
    }
  }

  getValues(filterFn) {
    const values = {};
    this.eachWidget((widget, control) => {
      // Do not drill down when reaching a container that isolates its fields
      if (widget.isolateFields) {
        control.down = false;
      } else if ('name' in widget && (!filterFn || filterFn(widget))) {
        values[widget.name] = widget.value;
      }
    }, true);
    return values;
  }

  get hasNoChildren() {
    // If we have *uningested* lazyItems, use them to find our items length.
    // In that case we must not cause ingestion of the lazyItems by referencing this.items.
    // If we have items, then only those that are visible have any bearing.
    // Popup also has to consult this property to decide on its CSS classes.
    const me = this,
          {
      items,
      lazyItems
    } = me.initialConfig,
          itemsArray = items && (isArray(items) ? items : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].values(items)),
          lazyItemsArray = lazyItems && (isArray(lazyItems) ? lazyItems : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].values(lazyItems)),
          // avoid triggering items initialization
    whichItems = me.isConfiguring ? lazyItemsArray || itemsArray : me.items;
    return !(whichItems !== null && whichItems !== void 0 && whichItems.filter(isNotHidden).length);
  }

  afterRecompose() {
    this.realign();
  }

  updateTextContent(textContent) {
    const me = this; // Add the text content class if we have no visible immediate item children.

    if (!me.isComposable) {
      me.contentElement.classList[textContent && me.hasNoChildren ? 'add' : 'remove']('b-text-content'); // Depending on CSS settings around how this widget handles text content and widthing
      // we *may* have to realign. Realign only goes ahead if we're visible and floating.

      if (me.rendered) {
        me.realign();
      }
    }
  }

  updateLayoutStyle(layoutStyle) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].applyStyle(this.contentElement, layoutStyle);
  }

  onPaint() {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Bring the lazy config into existence now that we have a layout.

    this.getConfig('contentElMutationObserver');
  }

  changeContentElMutationObserver(contentElMutationObserver, oldContentElMutationObserver) {
    if (oldContentElMutationObserver) {
      // Clear the queue. Any remaining notifications will be undeliverable.
      oldContentElMutationObserver.takeRecords();
      oldContentElMutationObserver.disconnect();
    } // We need to monitor our contentElement for attribute changes.
    // Changes to the inline style, or the classList/className will trigger this.
    // At that point we can sync our layout flag classes.


    if (contentElMutationObserver) {
      // NOTE: Do not hoist the vars, that will pull things in during destruction
      const me = this,
            {
        element,
        contentElement
      } = me;
      contentElMutationObserver = new MutationObserver(mutations => me.onContentElMutation(mutations));
      contentElMutationObserver.observe(contentElement, {
        attributes: true
      }); // If our contentElement is an inner element (eg Panel, Toolbar)
      // then styling might apply from classes on the outer element
      // so monitor that too.

      if (contentElement !== element) {
        contentElMutationObserver.observe(element, {
          attributes: true
        });
      }

      me.syncFlexDirection();
    }

    return contentElMutationObserver;
  }

  onContentElMutation() {
    // We can only do it if we are visible, otherwise the computed style won't work
    // and the classes will be removed.
    if (this.isVisible) {
      this.syncFlexDirection();
    }
  }

  changeLayout(config, existingLayout) {
    return _layout_Layout_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(existingLayout, config, {
      owner: this,
      defaults: {
        owner: this
      }
    });
  } // Items to iterate over


  get childItems() {
    return this.items;
  }
  /**
   * Returns a directly contained widget by id
   * @param {String} id The widget id
   * @returns {Core.widget.Widget}
   */


  getWidgetById(id) {
    return this.widgetMap[id];
  }
  /**
   * This function is called prior to creating widgets, override it in subclasses to allow containers to modify the
   * configuration of each widget. When adding a widget to a container hierarchy each parent containers
   * `processWidgetConfig` will be called. Returning false from the function prevents the widget from being added at
   * all.
   */


  processWidgetConfig(widget) {}
  /**
   * This method combines container {@link #config-defaults}
   * @param {Object} widgetConfig
   * @param {String|Function} [type] The type of widget described by `widgetConfig`.
   * @returns {Object}
   * @internal
   */


  setupWidgetConfig(widgetConfig, type) {
    const me = this; // A string becomes the defaultType (see below) with the html set to the string.

    if (typeof widgetConfig === 'string') {
      widgetConfig = {
        html: widgetConfig
      };
    } // An element is encapsulated by a Widget
    else if (widgetConfig.nodeType === Element.ELEMENT_NODE) {
      widgetConfig = {
        element: widgetConfig,
        id: widgetConfig.id
      };
    }

    if (typeof type === 'string' || !type && (type
    /* assignment */
    = widgetConfig.type)) {
      type = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].resolveType(type, true);
    } // widgetConfig = ObjectHelper.assign({}, me.defaults, widgetConfig, { parent : me });


    widgetConfig = (type || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]).mergeConfigs(me.defaults, widgetConfig, {
      parent: me
    });

    for (let ancestor = widgetConfig.parent; ancestor; ancestor = ancestor.parent) {
      if (ancestor.processWidgetConfig(widgetConfig) === false) {
        return null;
      }
    }

    if (me.trigger('beforeWidgetCreate', {
      widgetConfig
    }) === false) {
      return null;
    }

    return widgetConfig;
  }
  /**
   * This function converts a Widget config object into a Widget.
   * @param {Object} widget A Widget config object.
   * @internal
   */


  createWidget(widget) {
    const result = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(this.setupWidgetConfig(widget), this.defaultType); // If we created a widget from a config object, then upon items replacement
    // we must destroy outgoing widgets.

    result && (result._createdBy = this);
    return result;
  } // Reapply defaults, not used during config


  updateDefaults(defaults, oldDefaults) {
    if (!this.isConfiguring) {
      const entries = Object.entries(defaults);
      this.eachWidget(widget => {
        entries.forEach(([prop, value]) => {
          // Apply defaults only if current value matches the old default
          if (widget[prop] === oldDefaults[prop]) {
            widget[prop] = value;
          }
        });
      }, false);
    }
  }

  render() {
    // Pull in lazyItems at last second
    this.getConfig('lazyItems');
    this.layout.renderChildren(); // If called during configuration, the element may not have been available because
    // some non-item widgets (eg, Tools) instantiate and declare themselves through
    // onChildAdd before the element is set.
    // But also there may have been no items because of lazyItems.
    // So do the initial sync at render time.

    this.syncChildCount();
    super.render(...arguments);
  }

  get focusElement() {
    // Find first focusable descendant widget that is not our close tool.
    const firstFocusable = this.query(this.defaultFocus || (w => w.isFocusable && w.ref !== 'close'));

    if (firstFocusable) {
      return firstFocusable.focusElement;
    }

    return super.focusElement;
  }

  doDestroy() {
    var _this$_items;

    (_this$_items = this._items) === null || _this$_items === void 0 ? void 0 : _this$_items.forEach(widget => {
      var _widget$destroy;

      return (_widget$destroy = widget.destroy) === null || _widget$destroy === void 0 ? void 0 : _widget$destroy.call(widget);
    });
    this.layout.destroy();
    super.doDestroy();
  }
  /**
   * Returns `true` if all contained fields are valid, otherwise `false`
   * @property {Boolean}
   */


  get isValid() {
    let valid = true;
    this.eachWidget(widget => {
      // Touch each widget so that they all update their invalid state. This is important for required fields
      // since they don't initially complain if they start as empty.
      if (widget.isVisible && 'isValid' in widget && !widget.isValid) {
        valid = false;
      }
    }, true);
    return valid;
  }
  /**
   * Retrieves or sets all values from/to contained fields.
   * Accepts and returns a map, using {@link Core.widget.Field#config-name name},
   * {@link Core.widget.Widget#config-ref ref} or {@link Core.widget.Widget#config-id id} (in that order) as keys.
   *
   * ```javascript
   * container.values = {
   *     firstName : 'Clark',
   *     surname : 'Kent'
   * };
   * ```
   *
   * @property {Object}
   */


  get values() {
    const values = {};
    this.eachWidget((widget, control) => {
      // Do not drill down when reaching a container that isolates its fields
      if (widget.isolateFields) {
        control.down = false;
      } else if ('value' in widget) {
        values[widget.name || widget.ref || widget.id] = widget.value;
      }
    }, true);
    return values;
  }

  set values(values) {
    this.setValues(values);
  }
  /**
   * Returns `true` if currently setting values. Allows fields change highlighting to distinguishing between initially
   * setting values and later on changing values.
   * @property {Boolean}
   */


  get isSettingValues() {
    var _this$parent;

    // Fields query their parent, pass the question up in case containers are nested
    return Boolean(this._isSettingValues || ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.isSettingValues));
  }

  setValues(values, onlyName = false, preventHighlight = true) {
    // Flag checked by Field to determine if it should highlight change or not
    this._isSettingValues = {
      preventHighlight
    };
    this.eachWidget((widget, control) => {
      const hec = widget.highlightExternalChange,
            key = onlyName ? widget.name : widget.name || widget.ref || widget.id;

      if ('value' in widget && key) {
        if (preventHighlight) {
          // Don't want a field highlight on mass change
          widget.highlightExternalChange = false;
        } // Setting to null when value not matched clears field


        widget.value = values && key in values ? values[key] : null;
        widget.highlightExternalChange = hec;
      } // Dont drill down when reaching a container that isolates its fields


      if (widget.isolateFields) {
        control.down = false;
      }
    }, true);
    this._isSettingValues = false;
  }

} // Register this widget type with its Factory

Container.initClass();
Container._$name = 'Container';

/***/ }),

/***/ "./lib/Core/widget/DateField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/DateField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateField; });
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _DatePicker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt'; //TODO: picker icon (calendar) should show day number




/**
 * @module Core/widget/DateField
 */

/**
 * Date field widget (text field + date picker).
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.DateColumn DateColumn}.
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * // minimal DateField config with date format specified
 * let dateField = new DateField({
 *   format: 'YYMMDD'
 * });
 *
 * @classType datefield
 * @inlineexample Core/widget/DateField.js
 */

class DateField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'DateField';
  } // Factoryable type name


  static get type() {
    return 'datefield';
  } // Factoryable type alias


  static get alias() {
    return 'date';
  }

  static get configurable() {
    return {
      /**
       * Get / set format for date displayed in field (see {@link Core.helper.DateHelper#function-format-static}
       * for formatting options).
       * @member {String} format
       */

      /**
       * Format for date displayed in field. Defaults to using long date format, as defined by current locale (`L`)
       * @config {String}
       * @default
       */
      format: 'L',
      // same for all languages
      fallbackFormat: 'YYYY-MM-DD',
      timeFormat: 'HH:mm:ss:SSS',

      /**
       * A flag which indicates what time should be used for selected date.
       * `false` by default which means time is reset to midnight.
       *
       * Possible options are:
       * - `false` to reset time to midnight
       * - `true` to keep original time value
       * - `'17:00'` a string which is parsed automatically
       * - `new Date(2020, 0, 1, 17)` a date object to copy time from
       * - `'entered'` to keep time value entered by user (in case {@link #config-format} includes time info)
       *
       * @config {Boolean|Date|String}
       * @default
       */
      keepTime: false,

      /**
       * Format for date in the {@link #config-picker}. Uses localized format per default
       * @config {String}
       */
      pickerFormat: null,

      /**
       * Set to true to first clear time of the field's value before comparing it to the max value
       * @internal
       * @config {Boolean}
       */
      validateDateOnly: null,
      triggers: {
        expand: {
          cls: 'b-icon-calendar',
          handler: 'onTriggerClick',
          weight: 200
        },
        back: {
          cls: 'b-icon b-icon-angle-left b-step-trigger',
          handler: 'onBackClick',
          align: 'start',
          weight: 100
        },
        forward: {
          cls: 'b-icon b-icon-angle-right b-step-trigger',
          handler: 'onForwardClick',
          align: 'end',
          weight: 100
        }
      },
      // An optional extra CSS class to add to the picker container element
      calendarContainerCls: '',

      /**
       * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} min
       * @accepts {String|Date}
       */

      /**
       * Min value
       * @config {String|Date}
       */
      min: null,

      /**
       * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} max
       * @accepts {String|Date}
       */

      /**
       * Max value
       * @config {String|Date}
       */
      max: null,

      /**
       * The `step` property may be set in object form specifying two properties, `magnitude`, a Number, and
       * `unit`, a String.
       *
       * If a Number is passed, the steps's current unit is used (or `day` if no current step set) and just the
       * magnitude is changed.
       *
       * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
       * example `'1d'`, `'1 d'`, `'1 day'`, or `'1 day'`.
       *
       * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
       * @member {Object} step
       * @accepts {String|Number|Object}
       */

      /**
       * Time increment duration value. If specified, `forward` and `back` triggers are displayed.
       * The value is taken to be a string consisting of the numeric magnitude and the units.
       * The units may be a recognised unit abbreviation of this locale or the full local unit name.
       * For example `'1d'` or `'1w'` or `'1 week'`. This may be specified as an object containing
       * two properties: `magnitude`, a Number, and `unit`, a String
       * @config {String|Number|Object}
       */
      step: false,
      stepTriggers: null,

      /**
       * The week start day in the {@link #config-picker}, 0 meaning Sunday, 6 meaning Saturday.
       * Uses localized value per default.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * A config object used to configure the {@link Core.widget.DatePicker datePicker}.
       * ```javascript
       * dateField = new DateField({
       *      picker    : {
       *          multiSelect : true
       *      }
       *  });
       * ```
       * @config {Object}
       */
      picker: {
        type: 'datepicker',
        floating: true,
        scrollAction: 'realign',
        align: {
          align: 't0-b0',
          axisLock: true
        }
      },

      /**
       * Get/set value, which can be set as a Date or a string but always returns a Date. If a string is
       * specified, it will be converted using the specified {@link #config-format}
       * @member {Date} value
       * @accepts {String|Date}
       */

      /**
       * Value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}
       * @config {String|Date}
       */
      value: null
    };
  } //endregion
  //region Init & destroy

  /**
   * Creates default picker widget
   *
   * @internal
   */


  changePicker(picker, oldPicker) {
    const me = this,
          defaults = {
      owner: me,
      forElement: me[me.pickerAlignElement],
      minDate: me.min,
      maxDate: me.max,
      weekStartDay: me._weekStartDay,
      // need to pass the raw value to let the component to use its default value
      align: {
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement]
      },
      onSelectionChange: ({
        selection,
        source: picker
      }) => {
        // We only care about what DatePicker does if it has been opened
        if (picker.isVisible) {
          me._isUserAction = true;
          me._isPickerInput = true;
          me.value = selection[0];
          me._isPickerInput = false;
          me._isUserAction = false;
          picker.hide();
        }
      }
    };

    if (me.calendarContainerCls) {
      defaults.cls = me.calendarContainerCls;
    }

    if (me.value) {
      defaults.value = me.value;
    } else {
      defaults.date = new Date();
    }

    return _DatePicker_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(oldPicker, picker, {
      owner: me,
      defaults
    });
  } //endregion
  //region Click listeners


  get backShiftDate() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.value, -1 * this._step.magnitude, this._step.unit);
  }

  onBackClick() {
    const me = this,
          {
      min
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = me.backShiftDate;

      if (!min || min.getTime() <= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  }

  get forwardShiftDate() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.value, this._step.magnitude, this._step.unit);
  }

  onForwardClick() {
    const me = this,
          {
      max
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = me.forwardShiftDate;

      if (!max || max.getTime() >= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  } //endregion
  //region Toggle picker


  showPicker(focusPicker) {
    if (this.readOnly) {
      return;
    }

    const {
      _picker
    } = this; // If it's already instanced, move it.
    // It will be initialized correctly if not.

    if (_picker) {
      _picker.value = this.value; // In case a subclass uses a min getter (which does not update our min value) - ensure picker is correctly configured,

      _picker.minDate = this.min;
      _picker.maxDate = this.max;
    }

    super.showPicker(focusPicker);
  }

  focusPicker() {
    this.picker.focus();
  } //endregion
  // region Validation


  get isValid() {
    const me = this;
    me.clearError('L{Field.minimumValueViolation}', true);
    me.clearError('L{Field.maximumValueViolation}', true);
    let value = me.value;

    if (value) {
      const {
        min,
        max,
        validateDateOnly
      } = me; // Validation of the date should only care about the date part

      if (validateDateOnly) {
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(value, false);
      }

      if (min && value < min) {
        me.setError('L{Field.minimumValueViolation}', true);
        return false;
      }

      if (max && value > max) {
        me.setError('L{Field.maximumValueViolation}', true);
        return false;
      }
    }

    return super.isValid;
  } //endregion
  //region Getters/setters


  transformDateValue(value) {
    if (value != null) {
      if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isDate(value)) {
        if (typeof value === 'string') {
          // If date cannot be parsed with set format, try fallback - the more general one
          value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, this.format) || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, this.fallbackFormat);
        } else {
          value = new Date(value);
        }
      } // We insist on a *valid* Date as the value


      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(value)) {
        return this.transformTimeValue(value);
      }
    }

    return null;
  }

  transformTimeValue(value) {
    const me = this,
          {
      keepTime
    } = me;
    value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(value);

    if (!keepTime) {
      _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(value, false);
    } // change time if keepTime !== 'entered'
    else if (keepTime !== 'entered') {
      const timeValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(keepTime, me.timeFormat); // if this.keepTime is a valid date or a string describing valid time copy from it

      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(timeValue)) {
        _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, timeValue);
      } // otherwise try to copy from the current value
      else if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(me.value)) {
        _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, me.value);
      }
    } // if keepTime === 'entered' and picker is used apply current value time
    else if (me._isPickerInput && _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(me.value)) {
      _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, me.value);
    } // else don't change time


    return value;
  }

  changeMin(value) {
    return this.transformDateValue(value);
  }

  updateMin(min) {
    const {
      input,
      _picker
    } = this;

    if (input) {
      if (min == null) {
        input.removeAttribute('min');
      } else {
        input.min = min;
      }
    } // See if our lazy config has been realized...


    if (_picker) {
      _picker.minDate = min;
    }

    this.syncInvalid();
  }

  changeMax(value) {
    return this.transformDateValue(value);
  }

  updateMax(max) {
    const {
      input,
      _picker
    } = this;

    if (input) {
      if (max == null) {
        input.removeAttribute('max');
      } else {
        input.max = max;
      }
    }

    if (_picker) {
      _picker.maxDate = max;
    }

    this.syncInvalid();
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekStartDay;
  }

  updateWeekStartDay(weekStartDay) {
    if (this._picker) {
      this._picker.weekStartDay = weekStartDay;
    }
  }

  changeValue(value, oldValue) {
    const me = this,
          newValue = me.transformDateValue(value); // A value we could not parse

    if (value && !newValue) {
      // setError uses localization
      me.setError('L{invalidDate}');
      return;
    }

    me.clearError('L{invalidDate}'); // Reject non-change

    if (me.hasChanged(oldValue, newValue)) {
      return super.changeValue(newValue, oldValue);
    } // But we must fix up the display in case it was an unparseable string
    // and the value therefore did not change.


    if (!me.inputting) {
      me.syncInputFieldValue();
    }
  }

  updateValue(value, oldValue) {
    const picker = this._picker;

    if (picker && !this.inputting) {
      picker.value = value;
    }

    super.updateValue(value, oldValue);
  }

  changeStep(value, was) {
    const type = typeof value;

    if (!value) {
      return null;
    }

    if (type === 'number') {
      value = {
        magnitude: Math.abs(value),
        unit: was ? was.unit : 'day'
      };
    } else if (type === 'string') {
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseDuration(value);
    }

    if (value && value.unit && value.magnitude) {
      if (value.magnitude < 0) {
        value = {
          magnitude: -value.magnitude,
          // Math.abs
          unit: value.unit
        };
      }

      return value;
    }
  }

  updateStep(value) {
    // If a step is configured, show the steppers
    this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
    this.syncInvalid();
  }

  hasChanged(oldValue, newValue) {
    // if both dates are provided and the field does not has time info in its format
    if (oldValue !== null && oldValue !== void 0 && oldValue.getTime && newValue !== null && newValue !== void 0 && newValue.getTime && this.keepTime !== 'entered') {
      // Only compare date part
      return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(oldValue), _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(newValue));
    }

    return super.hasChanged(oldValue && oldValue.getTime(), newValue && newValue.getTime());
  }

  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    const date = this.value;
    return date ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(date, this.format) : '';
  }

  updateFormat() {
    this.syncInputFieldValue(true);
  } //endregion
  //region Localization


  updateLocalization() {
    super.updateLocalization();
    this.syncInputFieldValue(true);
  } //endregion
  //region Other


  internalOnKeyEvent(event) {
    super.internalOnKeyEvent(event);

    if (event.key === 'Enter' && this.isValid) {
      this.picker.hide();
    }
  } //endregion


} // Register this widget type with its Factory

DateField.initClass();
DateField._$name = 'DateField';

/***/ }),

/***/ "./lib/Core/widget/DatePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/DatePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DatePicker; });
/* harmony import */ var _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';







const generateMonthNames = () => _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getMonthNames().map((m, i) => [i, m]),
      yearItems = [],
      middle = new Date().getFullYear();

for (let y = middle - 20; y < middle + 21; y++) {
  yearItems.push(y);
}

class ReadOnlyCombo extends _Combo_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get $name() {
    return 'ReadOnlyCombo';
  }

  static get type() {
    return 'readonlycombo';
  }

  static get configurable() {
    return {
      editable: false,
      inputAttributes: {
        tag: 'div',
        tabIndex: -1
      },
      highlightExternalChange: false,
      triggers: {
        expand: false
      },
      picker: {
        align: {
          align: 't-b',
          axisLock: true,
          matchSize: false
        },
        cls: 'b-readonly-combo-list',
        scrollable: {
          overflowX: false
        }
      }
    };
  }

  onSelect({
    record
  }) {
    this.value = record.value;
  }

  set value(value) {
    const {
      store
    } = this,
          toAdd = []; // the store must contain the value being set.
    // Fill in any gap.

    if (value < store.first.id) {
      for (let y = value; y < store.first.id; y++) {
        toAdd.push({
          text: y
        });
      }
    }

    if (value > store.last.id) {
      for (let y = store.last.id + 1; y <= value; y++) {
        toAdd.push({
          text: y
        });
      }
    }

    store.add(toAdd);
    super.value = value;
    this.input.innerHTML = this.input.value;
  }

  get value() {
    return super.value;
  }

}

ReadOnlyCombo.initClass();
/**
 * @module Core/widget/DatePicker
 */

/**
 * A Panel which can display a month of date cells, which navigates between the cells,
 * fires events upon user selection actions, optionally navigates to other months
 * in response to UI gestures, and optionally displays information about each date cell.
 *
 * This class is used by the {@link Core.widget.DateField} class.
 *
 * {@inlineexample Core/widget/DatePicker.js}
 *
 * ## Custom cell rendering
 * You can easily control the content of each date cell using the {@link #config-cellRenderer}. The example below shows a view
 * typically seen when booking hotel rooms or apartments.
 *
 * {@inlineexample Core/widget/DatePickerCellRenderer.js}
 *
 * @classtype datepicker
 * @extends Core/widget/CalendarPanel
 */

class DatePicker extends _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DatePicker';
  } // Factoryable type name


  static get type() {
    return 'datepicker';
  }

  static get delayable() {
    return {
      refresh: 'raf'
    };
  }

  static get configurable() {
    return {
      /**
       * The date that the user has navigated to using the UI *prior* to setting the widget's
       * value by selecting.
       *
       * This may be changed using keyboard navigation. The {@link Core.widget.CalendarPanel#property-date} is set
       * by pressing `ENTER` when the desired date is reached.
       *
       * Programmatically setting the {@link Core.widget.CalendarPanel#config-date}, or using the UI to select the date
       * by clicking it also sets the `activeDate`
       * @config {Date}
       */
      activeDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },
      focusable: true,
      textContent: false,
      tbar: {
        overflow: null,
        items: [{
          ref: 'prevMonth',
          cls: 'b-icon b-icon-prev',
          onAction: 'up.gotoPrevMonth'
        }, {
          type: 'container',
          flex: 1,
          defaultType: 'readonlycombo',
          cls: 'b-datepicker-title',
          items: [{
            ref: 'monthField',
            cls: 'b-datepicker-monthfield',
            items: generateMonthNames(),
            listeners: {
              select: 'up.onMonthPicked'
            }
          }, {
            ref: 'yearField',
            cls: 'b-datepicker-yearfield',
            items: yearItems,
            listeners: {
              select: 'up.onYearPicked'
            }
          }]
        }, {
          ref: 'nextMonth',
          cls: 'b-icon b-icon-next',
          onAction: 'up.gotoNextMonth'
        }]
      },

      /**
       * The initially selected date.
       * @config {Date}
       * @default
       */
      date: new Date(),

      /**
       * The minimum selectable date. Selection of and navigation to dates prior
       * to this date will not be possible.
       * @config {Date}
       */
      minDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },

      /**
       * The maximum selectable date. Selection of and navigation to dates after
       * this date will not be possible.
       * @config {Date}
       */
      maxDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },

      /**
       * By default, disabled dates cannot be navigated to, and they are skipped over
       * during keyboard navigation. Configure this as `true` to enable navigation to
       * disabled dates.
       * @config {Boolean}
       * @default
       */
      focusDisabledDates: null,

      /**
       * Configure as `true` to enable selecting a single date range by selecting a
       * start and end date. Hold "SHIFT" button to select date range.
       * @config {Boolean}
       * @default
       */
      multiSelect: false,

      /**
       * DEPRECATED - This config is no longer used
       * @deprecated 5.0.0
       * @config {Boolean}
       * @default
       */
      editOnHover: true,

      /**
       * By default, the month and year are editable. Configure this as `false` to prevent that.
       * @config {Boolean}
       * @default
       */
      editMonth: true,

      /**
       * The {@link Core.helper.DateHelper DateHelper} format string to format the day names.
       * @config {String}
       * @default
       */
      dayNameFormat: 'dd'
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * The class name to add to the calendar cell whose date which is outside of the
       * {@link #config-minDate}/{@link #config-maxDate} range.
       * @config {String}
       * @private
       */
      outOfRangeCls: 'b-out-of-range',

      /**
       * The class name to add to the currently focused calendar cell.
       * @config {String}
       * @private
       */
      activeCls: 'b-active-date',

      /**
       * The class name to add to selected calendar cells.
       * @config {String}
       * @private
       */
      selectedCls: 'b-selected-date'
    };
  }
  /**
   * Fires when a date is selected. If {@link #config-multiSelect} is specified, this
   * will fire upon deselection and selection of dates.
   * @event selectionChange
   * @param {Date[]} selection The selected date. If {@link #config-multiSelect} is specified
   * this may be a two element array specifying start and end dates.
   * @param {Boolean} userAction This will be `true` if the change was caused by user interaction
   * as opposed to programmatic setting.
   */

  /* ...disconnect doc comment above from method below... */
  // region Init


  construct(config) {
    const me = this;

    if (config.editOnHover) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Grid', '5.0.0', '`editOnHover` config deprecated, it now has no effect and will be removed in 5.0');
    }

    me.selection = config.date ? [config.date] : [];
    super.construct(config);
    me.externalCellRenderer = me.cellRenderer;
    me.cellRenderer = me.internalCellRenderer;
    me.element.setAttribute('aria-activedescendant', `${me.id}-active-day`);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.weeksElement,
      click: 'onCellClick',
      delegate: `.${me.dayCellCls}:not(.${me.disabledCls}):not(.${me.outOfRangeCls})`,
      thisObj: me
    });
    me.widgetMap.monthField.readOnly = me.widgetMap.yearField.readOnly = !me.editMonth;
  }

  doDestroy() {
    var _this$yearField, _this$monthField;

    (_this$yearField = this.yearField) === null || _this$yearField === void 0 ? void 0 : _this$yearField.destroy();
    (_this$monthField = this.monthField) === null || _this$monthField === void 0 ? void 0 : _this$monthField.destroy();
    super.doDestroy();
  } // endregion


  get focusElement() {
    return this.element;
  }

  internalCellRenderer({
    cell,
    date
  }) {
    var _me$externalCellRende;

    const me = this,
          {
      activeCls,
      selectedCls
    } = me,
          cellClassList = {
      [activeCls]: me.isActiveDate(date),
      [selectedCls]: me.isSelectedDate(date),
      [me.outOfRangeCls]: me.minDate && date < me.minDate || me.maxDate && date > me.maxDate
    };
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].updateClassList(cell, cellClassList);
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].setInnerText(cell, date.getDate());
    cell.setAttribute('aria-label', _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(date, 'MMMM D, YYYY'));

    if (me.isActiveDate(date)) {
      cell.id = `${me.id}-active-day`;
    } else {
      cell.removeAttribute('id');
    }

    (_me$externalCellRende = me.externalCellRenderer) === null || _me$externalCellRende === void 0 ? void 0 : _me$externalCellRende.call(me, ...arguments);
  }

  onCellClick(event) {
    const cell = event.target.closest('[data-date]');
    this.onUIDateSelect(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseKey(cell.dataset.date), event);
  }
  /**
   * Called when the user uses the UI to select the current activeDate. So ENTER when focused
   * or clicking a date cell.
   * @param {Date} date The active date to select
   * @param {Event} event the instigating event, either a `click` event or a `keydown` event.
   * @internal
   */


  onUIDateSelect(date, event) {
    const me = this,
          {
      lastClickedDate,
      selection
    } = me;
    me.activeDate = date;
    me.lastClickedDate = date;

    if (!me.isDisabledDate(date)) {
      me.activatingEvent = event; // Handle multi selecting.
      // * single contiguous date range, eg: an event start and end
      // * multiple discontiguous ranges

      if (me.multiSelect) {
        if (me.multiRange) {// TODO: multiple date ranges
        } else if (!lastClickedDate || !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSameDate(date, lastClickedDate)) {
          if (lastClickedDate && event.shiftKey) {
            selection[1] = date;
            selection.sort();
          } else {
            selection.length = 0;
            selection[0] = date;
          }

          me.trigger('selectionChange', {
            selection,
            userAction: Boolean(event)
          });
        }
      } else {
        if (!me.value || me.value.getTime() !== date.getTime()) {
          me.value = date;
        } else if (me.floating) {
          me.hide();
        }
      }

      me.activatingEvent = null;
    }
  }

  onInternalKeyDown(keyEvent) {
    const me = this,
          keyName = keyEvent.key.trim() || keyEvent.code,
          activeDate = me.activeDate;
    let newDate = new Date(activeDate);

    if (keyName === 'Escape' && me.floating) {
      return me.hide();
    } // Only navigate if not focused on one of our child widgets.
    // We have a prevMonth and nextMonth tool and possibly month and year pickers.


    if (activeDate && keyEvent.target === me.focusElement) {
      do {
        switch (keyName) {
          case 'ArrowLeft':
            // Disable browser use of this key.
            // Ctrl+ArrowLeft navigates back.
            // ArrowLeft scrolls if there is horizontal scroll.
            keyEvent.preventDefault();

            if (keyEvent.ctrlKey) {
              newDate = me.gotoPrevMonth();
            } else {
              newDate.setDate(newDate.getDate() - 1);
            }

            break;

          case 'ArrowUp':
            // Disable browser use of this key.
            // ArrowUp scrolls if there is vertical scroll.
            keyEvent.preventDefault();
            newDate.setDate(newDate.getDate() - 7);
            break;

          case 'ArrowRight':
            // Disable browser use of this key.
            // Ctrl+ArrowRight navigates forwards.
            // ArrowRight scrolls if there is horizontal scroll.
            keyEvent.preventDefault();

            if (keyEvent.ctrlKey) {
              newDate = me.gotoNextMonth();
            } else {
              newDate.setDate(newDate.getDate() + 1);
            }

            break;

          case 'ArrowDown':
            // Disable browser use of this key.
            // ArrowDown scrolls if there is vertical scroll.
            keyEvent.preventDefault();
            newDate.setDate(newDate.getDate() + 7);
            break;

          case 'Enter':
            return me.onUIDateSelect(activeDate, keyEvent);
        }
      } while (me.isDisabledDate(newDate) && !me.focusDisabledDates); // Don't allow navigation to outside of date bounds.


      if (me.minDate && newDate < me.minDate) {
        return;
      }

      if (me.maxDate && newDate > me.maxDate) {
        return;
      }

      me.activeDate = newDate;
    }
  }

  changeMinDate(minDate) {
    return minDate ? this.changeDate(minDate) : null;
  }

  updateMinDate() {
    this.refresh();
  }

  changeMaxDate(maxDate) {
    return maxDate ? this.changeDate(maxDate) : null;
  }

  updateMaxDate() {
    this.refresh();
  }

  updateDate(date) {
    super.updateDate(date);
    this.activeDate = date;
  }

  changeActiveDate(activeDate) {
    activeDate = activeDate ? this.changeDate(activeDate) : this.date || (this.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(new Date()));

    if (isNaN(activeDate)) {
      throw new Error('DatePicker date ingestion must be passed a Date, or a YYYY-MM-DD date string');
    }

    return activeDate;
  }

  updateActiveDate(activeDate) {
    // Month's date setter protects it from non-changes.
    this.month.date = activeDate;
    this.widgetMap.monthField.value = activeDate.getMonth();
    this.widgetMap.yearField.value = activeDate.getFullYear();

    if (!this.isConfiguring) {
      // Must refresh so that the active cell gets a refresh.
      this.refresh();
    }
  }

  set value(value) {
    const me = this,
          {
      selection
    } = me;
    let changed;

    if (value) {
      value = me.changeDate(value, me.value); // Undefined return value means no change

      if (value === undefined) {
        return;
      }

      if (!me.value || value.getTime() !== me.value.getTime()) {
        selection.length = 0;
        selection[0] = value;
        changed = true;
      }

      me.date = value;
    } else {
      changed = selection.length;
      selection.length = 0; // Clearing the value - go to today's calendar

      me.date = new Date();
    }

    if (changed) {
      me.trigger('selectionChange', {
        selection,
        userAction: Boolean(me.activatingEvent)
      });
    }
  }

  get value() {
    return this.selection[this.selection.length - 1];
  }

  gotoPrevMonth() {
    const me = this,
          {
      activeDate
    } = me,
          // Navigate from the activeDate if the activeDate is in the UI.
    baseDate = activeDate && me.getCell(activeDate) ? activeDate : me.date,
          newDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(baseDate, -1, 'month'),
          lastDateOfPrevMonth = new Date(baseDate).setDate(0);

    if (!me.minDate || lastDateOfPrevMonth >= me.minDate) {
      return me.date = newDate;
    }
  }

  gotoNextMonth() {
    const me = this,
          {
      activeDate
    } = me,
          // Navigate from the activeDate if the activeDate is in the UI.
    baseDate = activeDate && me.getCell(activeDate) ? activeDate : me.date,
          newDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(baseDate, 1, 'month'),
          firstDateOfNextMonth = new Date(newDate).setDate(1);

    if (!me.maxDate || firstDateOfNextMonth <= me.maxDate) {
      return me.date = newDate;
    }
  }

  isActiveDate(date) {
    return this.activeDate && this.changeDate(date).getTime() === this.activeDate.getTime();
  }

  isSelectedDate(date) {
    return this.selection.some(d => _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(d, date, 'day'));
  }

  onMonthPicked({
    record,
    userAction
  }) {
    this.activeDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(this.activeDate, record.value - this.activeDate.getMonth(), 'month');

    if (userAction) {
      var _this$focusElement;

      (_this$focusElement = this.focusElement) === null || _this$focusElement === void 0 ? void 0 : _this$focusElement.focus();
    }
  }

  onYearPicked({
    record,
    userAction
  }) {
    const newDate = new Date(this.activeDate);
    newDate.setFullYear(record.value);
    this.activeDate = newDate;

    if (userAction) {
      var _this$focusElement2;

      (_this$focusElement2 = this.focusElement) === null || _this$focusElement2 === void 0 ? void 0 : _this$focusElement2.focus();
    }
  }

  get yearItems() {
    const result = [],
          middle = new Date().getFullYear();

    for (let y = middle - 20; y < middle + 21; y++) {
      result.push(y);
    }

    return result;
  }

  updateLocalization() {
    const monthField = this.widgetMap.monthField,
          newData = generateMonthNames();
    newData[monthField.value].selected = true;
    monthField.items = newData;
    super.updateLocalization();
  }

} // Register this widget type with its Factory

DatePicker.initClass();
DatePicker._$name = 'DatePicker';

/***/ }),

/***/ "./lib/Core/widget/DateTimeField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DateTimeField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateTimeField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _TimeField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _DateField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'gantt';







/**
 * @module Core/widget/DateTimeField
 */

/**
 * A field combining a {@link Core.widget.DateField} and a {@link Core.widget.TimeField}.
 *
 * @extends Core/widget/Field
 * @classtype datetimefield
 * @inlineexample Core/widget/DateTimeField.js
 */

class DateTimeField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get configurable() {
    return {
      /**
       * Returns the TimeField instance
       * @readonly
       * @member {Core.widget.TimeField} timeField
       */

      /**
       * Configuration for {@link Core.widget.TimeField}
       * @config {Object}
       */
      timeField: {},

      /**
       * Returns the DateField instance
       * @readonly
       * @member {Core.widget.DateField} dateField
       */

      /**
       * Configuration for {@link Core.widget.DateField}
       * @config {Object}
       */
      dateField: {
        // To be able to use transformDateValue for parsing without loosing time, a bit of a hack
        keepTime: true,
        step: '1 d'
      },

      /**
       * The week start day in the {@link Core.widget.DateField#config-picker}, 0 meaning Sunday, 6 meaning Saturday.
       * Uses localized value per default.
       *
       * @config {Number}
       */
      weekStartDay: null,
      inputTemplate: () => ''
    };
  }

  static get $name() {
    return 'DateTimeField';
  }

  static get type() {
    return 'datetimefield';
  } // Factoryable type alias


  static get alias() {
    return 'datetime';
  }

  get focusElement() {
    return this.dateField.input;
  } // Implementation needed at this level because it has two inner elements in its inputWrap


  get innerElements() {
    return [this.dateField.element, this.timeField.element];
  } // Each subfield handles its own keystrokes


  internalOnKeyEvent() {} // CellEdit sets this dynamically on its editor field


  updateRevertOnEscape(revertOnEscape) {
    this.timeField.revertOnEscape = revertOnEscape;
    this.dateField.revertOnEscape = revertOnEscape;
  } // Converts the timeField config into a TimeField


  changeTimeField(config) {
    const me = this,
          result = _TimeField_js__WEBPACK_IMPORTED_MODULE_1__["default"].new({
      revertOnEscape: me.revertOnEscape,

      syncInvalid(...args) {
        const updatingInvalid = me.updatingInvalid;
        _TimeField_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.syncInvalid.apply(this, args);
        me.timeField && !updatingInvalid && me.syncInvalid();
      }

    }, config);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: result.element,
      keydown: 'onTimeFieldKeyDown',
      thisObj: me
    }); // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to

    if (me.readOnly) {
      result.readOnly = true;
    }

    return result;
  } // Set up change listener when TimeField is available. Not in timeField config to enable users to supply their own
  // listeners block there


  updateTimeField(timeField) {
    const me = this;
    timeField.on({
      change({
        userAction,
        value
      }) {
        if (userAction && !me.$settingValue) {
          const dateAndTime = me.dateField.value;
          me._isUserAction = true;
          me.value = dateAndTime ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].copyTimeValues(dateAndTime, value) : null;
          me._isUserAction = false;
        }
      },

      thisObj: me
    });
  } // Converts the dateField config into a class based on { type : "..." } provided (DateField by default)


  changeDateField(config) {
    const me = this,
          type = (config === null || config === void 0 ? void 0 : config.type) || 'datefield',
          cls = _Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].resolveType(config.type || 'datefield'),
          result = _Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
      type,
      revertOnEscape: me.revertOnEscape,

      syncInvalid(...args) {
        const updatingInvalid = me.updatingInvalid;
        cls.prototype.syncInvalid.apply(this, args);
        me.dateField && !updatingInvalid && me.syncInvalid();
      }

    }, config));
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: result.element,
      keydown: 'onDateFieldKeyDown',
      thisObj: me
    }); // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to

    if (me.readOnly) {
      result.readOnly = true;
    }

    result.on({
      keydown: ({
        event
      }) => {
        var _this$timeField;

        if (event.key === 'Tab' && !event.shiftKey && (_this$timeField = this.timeField) !== null && _this$timeField !== void 0 && _this$timeField.isVisible) {
          event.stopPropagation();
          event.cancelBubble = true;
        }
      }
    });
    return result;
  }

  get childItems() {
    return [this.dateField, this.timeField];
  } // Set up change listener when DateField is available. Not in dateField config to enable users to supply their own
  // listeners block there


  updateDateField(dateField) {
    const me = this;
    dateField.on({
      change({
        userAction,
        value
      }) {
        if (userAction && !me.$isInternalChange) {
          me._isUserAction = true;
          me.value = value;
          me._isUserAction = false;
        }
      },

      thisObj: me
    });
  }

  updateWeekStartDay(weekStartDay) {
    if (this.dateField) {
      this.dateField.weekStartDay = weekStartDay;
    }
  }

  changeWeekStartDay(value) {
    var _this$dateField$weekS, _this$dateField;

    return typeof value === 'number' ? value : (_this$dateField$weekS = (_this$dateField = this.dateField) === null || _this$dateField === void 0 ? void 0 : _this$dateField.weekStartDay) !== null && _this$dateField$weekS !== void 0 ? _this$dateField$weekS : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekStartDay;
  } // Apply our value to our underlying fields


  syncInputFieldValue(skipHighlight = this.isConfiguring) {
    super.syncInputFieldValue(true);

    if (!skipHighlight && !this.highlightExternalChange) {
      skipHighlight = true;
    }

    const me = this,
          highlightDate = me.dateField.highlightExternalChange,
          highlightTime = me.timeField.highlightExternalChange;
    me.$isInternalChange = true;
    me.dateField.highlightExternalChange = false; // Prevent dateField from keeping its time value
    // TODO: Should be doable without this hack

    me.dateField.value = null;
    me.dateField.highlightExternalChange = highlightDate;

    if (skipHighlight) {
      me.timeField.highlightExternalChange = me.dateField.highlightExternalChange = false;
    }

    me.timeField.value = me.dateField.value = me.inputValue;
    me.dateField.highlightExternalChange = highlightDate;
    me.timeField.highlightExternalChange = highlightTime;
    me.$isInternalChange = false; // Must evaluate after child fields have been updated since our validity state depends on theirs.

    me.syncInvalid();
  }

  onTimeFieldKeyDown(e) {
    const me = this; // we need to handle keydown for composed field manually and before it's done by cellEdit feature

    if (e.key === 'Enter' || e.key === 'Tab') {
      const dateAndTime = me.dateField.value;
      me._isUserAction = true;
      me.value = dateAndTime ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].copyTimeValues(dateAndTime, me.timeField.value) : null;
      me._isUserAction = false;
    }
  }

  onDateFieldKeyDown(e) {
    const me = this;

    if (e.key === 'Tab') {
      e.stopPropagation();
      e.preventDefault();
      me.timeField.focus();
    } // we need to handle keydown for composed field manually and before it's done by cellEdit feature


    if (e.key === 'Enter') {
      me.value = me.dateField.value;
    }
  } // Make us and our underlying fields required


  updateRequired(required, was) {
    this.timeField.required = this.dateField.required = required;
  }

  updateReadOnly(readOnly, was) {
    super.updateReadOnly(readOnly, was);

    if (!this.isConfiguring) {
      this.timeField.readOnly = this.dateField.readOnly = readOnly;
    }
  } // Make us and our underlying fields disabled


  onDisabled(value) {
    this.timeField.disabled = this.dateField.disabled = value;
  }

  focus() {
    this.dateField.focus();
  }

  hasChanged(oldValue, newValue) {
    return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEqual(oldValue, newValue);
  }

  get isValid() {
    return this.timeField.isValid && this.dateField.isValid;
  }

  setError(error, silent) {
    [this.dateField, this.timeField].forEach(f => f.setError(error, silent));
  }

  getErrors() {
    const errors = [...(this.dateField.getErrors() || []), ...(this.timeField.getErrors() || [])];
    return errors.length ? errors : null;
  }

  clearError(error, silent) {
    [this.dateField, this.timeField].forEach(f => f.clearError(error, silent));
  }

  updateInvalid() {
    // use this flag in this level to avoid looping
    this.updatingInvalid = true;
    [this.dateField, this.timeField].forEach(f => f.updateInvalid());
    this.updatingInvalid = false;
  }

}
DateTimeField.initClass();
DateTimeField._$name = 'DateTimeField';

/***/ }),

/***/ "./lib/Core/widget/DisplayField.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/DisplayField.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DisplayField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';


/**
 * @module Core/widget/DisplayField
 */

/**
 * A widget used to show a read only value. Can also use a {@link #config-template template string} to show custom
 * markup inside a Container.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let displayField = new DisplayField({
 *   appendTo : document.body,
 *   label: 'name',
 *   value : 'John Doe',
 *   // or use a template
 *   // template : name => `${name} is the name`
 * });
 *
 * @classType displayField
 * @inlineexample Core/widget/DisplayField.js
 */

class DisplayField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DisplayField';
  } // Factoryable type name


  static get type() {
    return 'displayfield';
  } // Factoryable type alias


  static get alias() {
    return 'display';
  }

  static get configurable() {
    return {
      readOnly: true,
      editable: false,
      cls: 'b-display-field',

      /**
       * A template string used to render the value of this field. Please note you are responsible for encoding
       * any strings protecting against XSS.
       *
       * ```javascript
       * new DisplayField({
       *     appendTo : document.body,
       *     name     : 'age',
       *     label    : 'Age',
       *     template : data => `${data.value} years old`
       * })
       * ```
       * @config {Function}
       */
      template: null
    };
  }

  get focusElement() {// we're not focusable.
  }

  changeReadOnly() {
    return true;
  }

  changeEditable() {
    return false;
  }

  get inputElement() {
    return {
      tag: 'span',
      html: this.template ? this.template(this.value) : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(this.value)
    };
  }

} // Register this widget type with its Factory

DisplayField.initClass();
DisplayField._$name = 'DisplayField';

/***/ }),

/***/ "./lib/Core/widget/DurationField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DurationField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DurationField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'gantt';




/**
 * @module Core/widget/DurationField
 */

/**
 * A specialized field allowing a user to also specify duration unit when editing the duration value.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the `DurationColumn`.
 *
 * @extends Core/widget/TextField
 * @classType durationfield
 * @inlineexample Core/widget/DurationField.js
 */

class DurationField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DurationField';
  } // Factoryable type name


  static get type() {
    return 'durationfield';
  } // Factoryable type alias


  static get alias() {
    return 'duration';
  }

  static get defaultConfig() {
    return {
      /**
       * The `value` config may be set in Object form specifying two properties,
       * `magnitude`, a Number, and `unit`, a String.
       *
       * If a String is passed, it is parsed in accordance with current locale rules.
       * The string is taken to be the numeric magnitude, followed by whitespace, then an abbreviation, or name of
       * the unit.
       * @config {Object|String}
       * @category Common
       */
      value: null,

      /**
       * Step size for spin button clicks.
       * @config {Number}
       * @default
       * @category Common
       */
      step: 1,

      /**
       * The duration unit to use with the current magnitude value.
       * @config {String}
       * @category Common
       */
      unit: null,
      defaultUnit: 'day',

      /**
       * The duration magnitude to use with the current unit value. Can be either an integer or a float value.
       * Both "," and "." are valid decimal separators.
       * @config {Number}
       * @category Common
       */
      magnitude: null,

      /**
       * When set to `true` the field will use short names of unit durations
       * (as returned by {@link Core.helper.DateHelper#function-getShortNameOfUnit-static}) when creating the
       * input field's display value.
       * @config {Boolean}
       * @category Common
       */
      useAbbreviation: false,

      /**
       * Set to `true` to allow negative duration
       * @config {Boolean}
       * @category Common
       */
      allowNegative: false,

      /**
       * The number of decimal places to allow. Defaults to no constraint.
       * @config {Number}
       * @default
       * @category Common
       */
      decimalPrecision: null,
      triggers: {
        spin: {
          type: 'spintrigger'
        }
      },
      nullValue: null
    };
  }
  /**
   * Fired when this field's value changes.
   * @event change
   * @param {Core.data.Duration} value - This field's value
   * @param {Core.data.Duration} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.DurationField} source - This field
   */

  /**
   * User performed default action (typed into this field or hit the triggers).
   * @event action
   * @param {Core.data.Duration} value - This field's value
   * @param {Core.data.Duration} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.DurationField} source - This field
   */


  static get configurable() {
    return {
      /**
       * Minimum duration value (e.g. 1d)
       * @config {String}
       * @category Common
       */
      min: null,

      /**
       * Max duration value (e.g. 10d)
       * @config {String}
       * @category Common
       */
      max: null,

      /**
       * Comma-separated list of units to allow in this field, e.g. "day,hour,year". Leave blank to allow all
       * valid units (the default)
       * @config {String}
       * @category Common
       */
      allowedUnits: null
    };
  }

  changeMin(value) {
    return typeof value === 'string' ? new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](value) : value;
  }

  changeMax(value) {
    return typeof value === 'string' ? new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](value) : value;
  }

  changeAllowedUnits(units) {
    if (typeof units === 'string') {
      units = units.split(',');
    }

    return units;
  }

  updateAllowedUnits(units) {
    this.allowedUnitsRe = new RegExp(`(${units.join('|')})`, 'i');
  }

  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    return this.value == null ? '' : this.calcValue(true).toString(this.useAbbreviation);
  }
  /**
   * Get/Set duration unit to use with the current magnitude value.
   * Valid values are:
   * - "millisecond" - Milliseconds
   * - "second" - Seconds
   * - "minute" - Minutes
   * - "hour" - Hours
   * - "day" - Days
   * - "week" - Weeks
   * - "month" - Months
   * - "quarter" - Quarters
   * - "year"- Years
   *
   * @property {String}
   * @category Common
   */


  set unit(unit) {
    this._unit = unit;
    this.value = this.calcValue();
  }

  get unit() {
    return this._unit;
  }

  get unitWithDefault() {
    return this._unit || DurationField.defaultConfig.defaultUnit;
  }
  /**
   * Get/Set numeric magnitude `value` to use with the current unit value.
   * @property {Number}
   * @category Common
   */


  set magnitude(magnitude) {
    this.clearError('L{invalidUnit}');
    this._magnitude = magnitude;
    super.value = this.calcValue();
  }

  get magnitude() {
    return this._magnitude;
  }

  roundMagnitude(value) {
    return value && this.decimalPrecision != null ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].round(value, this.decimalPrecision) : value;
  }

  get allowDecimals() {
    return this.decimalPrecision !== 0;
  }

  get isValid() {
    const me = this,
          isEmpty = me.value == null || me.value && me.value.magnitude == null;
    return super.isValid && (isEmpty && !me.required || !isEmpty && (me.allowNegative || me.value.magnitude >= 0));
  }

  internalOnChange(event) {
    const me = this,
          value = me.value,
          oldVal = me._lastValue;

    if (me.hasChanged(oldVal, value)) {
      me._lastValue = value;
      me.triggerFieldChange({
        value,
        event,
        userAction: true,
        valid: me.isValid
      });
    }
  }

  onFocusOut(e) {
    this.syncInputFieldValue(true);
    return super.onFocusOut(e);
  }
  /**
   * The `value` property may be set in Object form specifying two properties, `magnitude`, a Number, and `unit`, a
   * String.
   *
   * If a Number is passed, the field's current unit is used and just the magnitude is changed.
   *
   * If a String is passed, it is parsed in accordance with current locale rules. The string is taken to be the
   * numeric magnitude, followed by whitespace, then an abbreviation, or name of the unit.
   *
   * Upon read, the value is always a {@link Core.data.Duration Duration} object containing `magnitude` and `unit`.
   *
   * @property {Core.data.Duration}
   * @accepts {String|Number|Object|Core.data.Duration}
   * @category Common
   */


  set value(value) {
    const me = this;
    let newMagnitude, newUnit;
    this.clearError('L{invalidUnit}');

    if (typeof value === 'number') {
      // A number means preserving existing unit value
      newMagnitude = value;
      newUnit = me._unit;
    } else if (typeof value === 'string') {
      // Parse as a string
      const parsedDuration = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseDuration(value, me.allowDecimals, me.unitWithDefault);

      if (parsedDuration) {
        if (!me.allowedUnitsRe || me.allowedUnitsRe.test(parsedDuration.unit)) {
          newUnit = parsedDuration.unit;
          newMagnitude = parsedDuration.magnitude;
        } else {
          me.setError('L{invalidUnit}');
        }
      }
    } else {
      // Using value object with unit and magnitude
      if (value && 'unit' in value && 'magnitude' in value) {
        newUnit = value.unit;
        newMagnitude = value.magnitude;
      } else {
        newUnit = null;
        newMagnitude = null;
      }
    }

    if (me._magnitude !== newMagnitude || me._unit !== newUnit) {
      me._magnitude = newMagnitude;
      me._unit = newUnit;
      super.value = me.calcValue();
    }
  }

  okMax(value) {
    if (typeof value === 'number') {
      value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        unit: this.unitWithDefault,
        magnitude: value
      });
    }

    return this.max == null || value <= this.max;
  }

  okMin(value) {
    if (typeof value === 'number') {
      value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        unit: this.unitWithDefault,
        magnitude: value
      });
    }

    return this.min == null || value >= this.min;
  }

  get validity() {
    const value = this.value,
          validity = {}; // Assert range for non-empty fields, empty fields will turn invalid if `required: true`

    if (value != null) {
      validity.rangeUnderflow = !this.okMin(value);
      validity.rangeOverflow = !this.okMax(value);
    }

    validity.valid = !validity.rangeUnderflow && !validity.rangeOverflow;
    return validity;
  }

  get value() {
    return super.value;
  }

  calcValue(round = false) {
    const me = this;

    if ((!me._unit || me._magnitude == null) && me.clearable) {
      return null;
    } else {
      return new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](round ? this.roundMagnitude(me._magnitude) : this._magnitude, me.unitWithDefault);
    }
  }

  hasChanged(oldValue, newValue) {
    return newValue && !oldValue || !newValue && oldValue || newValue && oldValue && !oldValue.isEqual(newValue);
  }
  /**
   * The `milliseconds` property is a read only property which returns the number of milliseconds in this field's
   * value
   * @member {Number} milliseconds
   * @readonly
   */


  get milliseconds() {
    // For reasons unknown documenting as @property did not work
    return this.value ? this.value.milliseconds : 0;
  }

  onInternalKeyDown(keyEvent) {
    if (keyEvent.key === 'ArrowUp') {
      this.doSpinUp();
    } else if (keyEvent.key === 'ArrowDown') {
      this.doSpinDown();
    }
  }

  doSpinUp() {
    const me = this;
    let newValue = (me.magnitude || 0) + me.step;
    me._isUserAction = true;

    if (!me.okMin(newValue)) {
      newValue = me.min;
    }

    if (me.okMax(newValue)) {
      me.value = newValue;
    }

    me._isUserAction = false;
  }

  doSpinDown() {
    const me = this;
    let newValue = (me.magnitude || 0) - me.step;

    if (!me.okMax(newValue)) {
      newValue = me.max;
    }

    if (me.okMin(newValue) && (me.allowNegative || (me.magnitude || 0) > 0)) {
      me._isUserAction = true;
      me.value = newValue;
      me._isUserAction = false;
    }
  }

} // Register this widget type with its Factory

DurationField.initClass();
DurationField._$name = 'DurationField';

/***/ }),

/***/ "./lib/Core/widget/Editor.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Editor.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Editor; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _layout_Fit_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./layout/Fit.js */ "./lib/Core/widget/layout/Fit.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';










/**
 * @module Core/widget/Editor
 */

/**
 * Displays an input field, optionally editing a field of a record at a particular position.
 *
 * Offers events to signal edit completion upon `ENTER` or focus loss (if configured to do so),
 * or edit cancellation on `ESC`, or focus loss if configured that way.
 * @extends Core/widget/Container
 *
 * @classType Editor
 */

class Editor extends _Container_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'Editor';
  } // Factoryable type name


  static get type() {
    return 'editor';
  }

  static get configurable() {
    return {
      positioned: true,
      hidden: true,
      layout: 'fit',
      align: {
        align: 't0-t0',
        offset: [0, 0]
      },

      /**
       * A config object, or the `type` string of the widget (usually a {@link Core.widget.Field Field} subclass,
       * i.e. {@link Core.widget.TextField TextField}) which this editor will encapsulate.
       * @config {Object|String}
       * @default
       */
      inputField: 'textfield',

      /**
       * What action should be taken when focus moves out of the editor, either by `TAB` or clicking outside.
       * May be `'complete'` or `'cancel`'. Any other value results in no action being taken upon focus leaving the editor
       * leaving the application to listen for the {@link #event-focusOut focusOut} event.
       * @config {String}
       * @default
       */
      blurAction: 'complete',

      /**
       * The name of the `key` which completes the edit.
       *
       * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
       * @config {String}
       * @default
       */
      completeKey: 'Enter',

      /**
       * The name of the `key` which cancels the edit.
       *
       * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
       * @config {String}
       * @default
       */
      cancelKey: 'Escape',

      /**
       * How to handle a request to complete the edit if the field is invalid. There are three choices:
       *  - `block` The default. The edit is not exited, the field remains focused.
       *  - `allow` Allow the edit to be completed.
       *  - `revert` The field value is reverted and the edit is completed.
       * @config {String}
       * @default
       */
      invalidAction: 'block',

      /**
       * Configure as `true` to have editing complete as soon as the field fires its `change` event.
       * @config {Boolean}
       * @default false
       */
      completeOnChange: null,
      isolateFields: true
    };
  } //endregion
  //region Events

  /**
   * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
   * @event beforeStart
   * @param {Object} value - The value to be edited.
   * @preventable
   */

  /**
   * Fired when an edit operation has begun.
   * @event start
   * @param {Object} value - The starting value of the field.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
   * The completion may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeComplete
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   * @param {Function} [finalize] An async function may be injected into this property
   * which performs asynchronous finalization tasks such as complex validation of confirmation. The
   * value `true` or `false` must be returned.
   * @param {Object} [finalize.context] An object describing the editing context upon requested completion of the edit.
   * @preventable
   */

  /**
   * Edit has been completed, and any associated record or element has been updated.
   * @event complete
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
   * The cancellation may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeCancel
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Event} event - Included if the cancellation was triggered by a DOM event
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   * @preventable
   */

  /**
   * Edit has been canceled without updating the associated record or element.
   * @event cancel
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The value of the field.
   * @param {Event} event - Included if the cancellation was triggered by a DOM event
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fire to relay a `keypress` event from the field.
   * @event keypress
   * @param {Event} event - The key event.
   */
  //endregion


  afterConfigure() {
    const me = this;
    super.afterConfigure();
    me.onTargetSizeChange = me.onTargetSizeChange.bind(me);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
      element: me.element,
      keydown: 'onKeyDown',
      thisObj: me
    });
    me.on({
      hide: 'afterEditorHide',
      thisObj: me
    });
    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      locale: 'onLocaleChange',
      thisObj: me
    });
  }

  onLocaleChange() {
    const {
      inputField
    } = this;

    if (inputField && !inputField.isDestroyed) {
      // All Field subclasses have this method, but if `inputField` is a custom widget,
      // `syncInputFieldValue` has to be implemented
      if (inputField.syncInputFieldValue) {
        inputField.syncInputFieldValue(true);
      } else if (!(inputField instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {}
    }
  }
  /**
   * Start editing
   * @param {Object} editObject An object containing details about what to edit.
   * @param {HTMLElement|Core.helper.util.Rectangle} editObject.target the element or Rectangle to align to.
   * @param {String} [editObject.align=t0-t0] How to align to the target.
   * @param {Boolean} [editObject.matchSize=true] Match editor size to target size.
   * @param {Boolean} [editObject.matchFont=true] Match editor's font-size size to target's font-size.
   * @param {Core.data.Model} [editObject.record] The record to edit.
   * @param {String} [editObject.field] The field name in the record to edit. This defaults to the `name` of the {@link #config-inputField}.
   * Also if record has method set + capitalized field, method will be called, e.g. if record has method named
   * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`, `record.setFoobar(value)` will be called.
   * @param {Object} [editObject.value] The value to edit.
   * @param {Boolean} [editObject.focus=true] Focus the field.
   * @param {Boolean} [editObject.fitTargetContent] Pass `true` to allow the Editor to expand beyond the
   * width of its target element if its content overflows horizontally. This is useful if the editor has
   * triggers to display, such as a combo.
   */


  startEdit({
    target,
    align = this.align,
    hideTarget = false,
    matchSize = true,
    matchFont = true,
    fitTargetContent = false,
    value,
    record,
    field = this.inputField.name,
    focus = true
  }) {
    const me = this,
          {
      inputField
    } = me,
          targetFontSize = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(target, 'font-size'),
          targetFontFamily = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(target, 'font-family');

    if (me.trigger('beforeStart', {
      value
    }) !== false) {
      var _inputField$value$;

      if (record && field) {
        me.record = record;
        me.dataField = field;

        if (value === undefined) {
          value = record[field];
        }
      }

      if (matchSize) {
        if (target instanceof HTMLElement) {
          me.updateSize(target);
        } // If we are editing and sizing based on an element,
        // we need to update editor size if grid cell size changes
        // Removed in 'hide' listener


        if (target instanceof HTMLElement) {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(target, me.onTargetSizeChange);
        }
      }

      if (inputField.input) {
        if (matchFont) {
          inputField.input.style.fontSize = targetFontSize;
          inputField.input.style.fontFamily = targetFontFamily;
        } else {
          inputField.input.style.fontSize = inputField.input.style.fontFamily = '';
        }
      }

      me._isSettingValues = true; // In case our finalize code set it to invalid, start it clear of errors.

      if (inputField.clearError) {
        inputField.clearError();
      }

      inputField.value = value;
      me._isSettingValues = false; // Simplest form is 't0-t0', but may be passed as full object spec.
      // It gets expanded below so must be an object.

      if (typeof align === 'string') {
        align = {
          align
        };
      }

      me.showBy(_objectSpread({
        target
      }, align));

      if (fitTargetContent) {
        // Input doesn't fit, so widen it
        const overflow = inputField.input.scrollWidth - inputField.input.clientWidth;

        if (overflow > 0) {
          me.width += overflow + _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].scrollBarWidth;
        }
      }

      if (focus && me.inputField.focus) {
        me.inputField.focus();
      }

      if (target.nodeType === Element.ELEMENT_NODE) {
        target.classList.add('b-editing');

        if (hideTarget) {
          target.classList.add('b-hide-visibility');
        }
      }

      me.editing = true; // Passed value may have been '10/06/2019', send the live field value to startedit

      me.trigger('start', {
        value: inputField.value
      });

      if (Array.isArray(inputField.value) && inputField.editingRecords && (_inputField$value$ = inputField.value[0]) !== null && _inputField$value$ !== void 0 && _inputField$value$.isModel) {
        // If this editor is editing model instances, save a cloned copy in case fields
        // are changed
        me.oldValue = inputField.value.map(record => record.copy(record.id));
      } else {
        me.oldValue = inputField.value; // If the value from the value getter is an array, we must clone it because
        // if it's the same *instance*, the ObjectHelper.isEqual test in completeEdit
        // will find that there are no changes.

        if (Array.isArray(me.oldValue)) {
          me.oldValue = me.oldValue.slice();
        }
      } // The initialValue is what the revertOnEscape uses by preference before it uses its valueOnFocus.
      // In an Editor, it can focus in and out but still need that correct initial value.


      inputField.initialValue = me.oldValue;
      return true;
    }

    return false;
  }

  refreshEdit() {
    if (this.isVisible) {
      const {
        record,
        dataField,
        inputField
      } = this;

      if (record && dataField) {
        const value = record[dataField]; // Only update the field if the value has changed

        if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(inputField.value, value)) {
          inputField.value = value;
        }
      }
    }
  }

  finishEdit() {
    const {
      target,
      aligningToElement
    } = this.lastAlignSpec;

    if (aligningToElement) {
      target.classList.remove('b-editing');
      target.classList.remove('b-hide-visibility');
    }

    this.editing = false; // Internal event, to be able to destroy etc no matter if completed or cancelled

    this.trigger('finishEdit');
  }

  onKeyDown(event) {
    var _me$trigger;

    const me = this;

    switch (event.key) {
      case me.completeKey:
        me.completeEdit(null, event);
        event.stopImmediatePropagation();
        break;

      case me.cancelKey:
        me.cancelEdit(event);
        event.stopImmediatePropagation();
        break;
    } // In case destroyed by complete or cancel


    (_me$trigger = me.trigger) === null || _me$trigger === void 0 ? void 0 : _me$trigger.call(me, 'keydown', {
      event
    });
  }

  onFocusOut(event) {
    super.onFocusOut(event);
    const me = this;

    if (!me.isFinishing && me.editing) {
      const method = me[`${me.blurAction}Edit`];
      method === null || method === void 0 ? void 0 : method.call(me);
    }
  }
  /**
   * Complete the edit, and, if associated with a record, update the record if possible.
   * If editing is completed, the editor is hidden.
   *
   * If the field is invalid, the `{@link #config-invalidAction}` config is used to decide
   * upon the course of action.
   *
   * If a {@link #event-beforeComplete} handler returns `false` then editing is not completed.
   *
   * If the field's values has not been changed, then editing is terminated through {@link #function-cancelEdit}.
   *
   * @returns `true` if editing ceased, `false` if the editor is still active.
   * @async
   */


  async completeEdit(finalize, triggeredByEvent) {
    const me = this,
          {
      inputField,
      oldValue,
      record
    } = me,
          invalidAction = inputField.invalidAction || (inputField.allowInvalid === false ? 'block' : me.invalidAction),
          {
      value
    } = inputField; // If we are not editing, we should manipulated the field or not fire any events

    if (!me.isVisible) {
      return;
    } // If we're configured not to allow invalid values, refocus the field in case complete was triggered by focusout.


    if (!inputField.isValid && invalidAction !== 'allow') {
      if (invalidAction === 'block') {
        inputField.focus && inputField.focus();
        return false;
      } else if (invalidAction === 'revert') {
        me.cancelEdit(triggeredByEvent);
        return true;
      }
    } // No change means a cancel.
    else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(value, oldValue)) {
      me.cancelEdit(triggeredByEvent);
      return true;
    } // Allow veto of the completion
    else {
      const context = {
        inputField,
        record,
        value,
        oldValue
      };

      if (me.trigger('beforeComplete', context) === false) {
        inputField.focus && inputField.focus();
      } else {
        // CellEdit#onEditorBeforeComplete injects editorContext into the basic context
        if (!finalize) {
          finalize = context.finalize || context.editorContext && context.editorContext.finalize;
        } // Allow async finalization of the editing, implementer may want to show a confirmation popup etc


        if (finalize) {
          let result = await finalize(context);

          if (result === true) {
            me.onEditComplete();
          } else {
            if (inputField.setError) {
              const error = result || inputField.invalidValueError,
                    clearError = () => {
                listeners();
                inputField.clearError(error);
              },
                    listeners = inputField.on({
                change: clearError,
                input: clearError
              }); // Mark as invalid. Because this is decided upon without the knowledge
              // of the field, this state will be rescinded upon the next change of
              // input field.


              inputField.setError(error);
            }

            if (invalidAction === 'block') {
              inputField.focus && inputField.focus();
            } else if (invalidAction === 'revert') {
              inputField.value = oldValue;
              result = true;
            }

            result = false;
          }

          return result;
        } // Successful completion
        else {
          me.onEditComplete();
          return true;
        }
      }
    }

    return false;
  }
  /**
   * Cancel the edit and hide the editor.
   */


  cancelEdit(triggeredByEvent) {
    const me = this,
          {
      inputField,
      oldValue
    } = me,
          {
      value
    } = inputField;

    if (me.editing && !me.isFinishing && me.trigger('beforeCancel', {
      value,
      oldValue,
      event: triggeredByEvent
    }) !== false) {
      // Hiding must not trigger our blurAction
      me.isFinishing = true;
      me.hide();
      me.trigger('cancel', {
        value,
        oldValue,
        event: triggeredByEvent
      });
      me.finishEdit();
      me.isFinishing = false;
    }
  } // Handle updating what needs to be updated.


  onEditComplete() {
    const me = this,
          {
      record,
      dataField,
      inputField,
      oldValue
    } = me,
          {
      value
    } = inputField;

    if (!me.isFinishing) {
      // Hiding must not trigger our blurAction
      me.isFinishing = true;
      me.hide();

      if (record) {
        const setterName = `set${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].capitalize(dataField)}`;

        if (record[setterName]) {
          record[setterName](value);
        } else if (dataField.includes('.')) {
          record.set(dataField, value);
        } else {
          record[dataField] = value;
        }
      }

      me.trigger('complete', {
        value,
        oldValue
      });
      me.finishEdit();
      me.isFinishing = false;
    }
  }

  doDestroy() {
    if (this.createdInputField) {
      this.inputField.destroy();
    }

    super.doDestroy();
  }

  set owner(owner) {
    this._owner = owner;
  } // This is a positioned widget appended to a Widget's contentElement. It may have no owner link.
  // Grab the owner by finding what widget it is inside.


  get owner() {
    return this._owner || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.parentNode);
  }

  changeInputField(inputField, oldInputField) {
    const me = this;

    if (oldInputField) {
      oldInputField.destroy();
    }

    if (typeof inputField === 'string') {
      inputField = {
        type: inputField
      };
    }

    if (!(inputField instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
      inputField = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(inputField);
      me.createdInputField = true; // So we know we can destroy it
    }

    if (me.completeOnChange) {
      inputField.on({
        change: 'onInputFieldChange',
        thisObj: me
      });
    }

    inputField.parent = me;
    return inputField;
  }

  updateInputField(inputField) {
    this.removeAll();
    this.add(inputField);
  }

  get inputField() {
    return this.items[0];
  }

  onInputFieldChange() {
    if (this.containsFocus) {
      this.completeEdit();
    }
  }

  onTargetSizeChange(resizedElement, oldRect, newRect) {
    if (oldRect && newRect) {
      this.updateSize(resizedElement);
    }
  }

  updateSize(targetEl) {
    const rect = targetEl.getBoundingClientRect();
    this.width = rect.width - this.align.offset[0];
    this.height = rect.height;
  }

  afterEditorHide() {
    _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(this.lastAlignSpec.target, this.onTargetSizeChange);
  }

} // Register this widget type with its Factory

Editor.initClass();
Editor._$name = 'Editor';

/***/ }),

/***/ "./lib/Core/widget/Field.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Field.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Field; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
var productName = 'gantt';










/**
 * @module Core/widget/Field
 */

const byWeight = (l, r) => (l.weight || 0) - (r.weight || 0),
      byWeightReverse = (l, r) => (r.weight || 0) - (l.weight || 0),
      emptyArray = [],
      triggerConfigs = {
  align: true,
  weight: true
};
/**
 * Base class for {@link Core.widget.TextField TextField} and {@link Core.widget.NumberField NumberField}. Not to be used directly.
 * All subclasses can be used as editors for the {@link Grid.column.Column Column}. The most popular are:
 * - {@link Core.widget.TextField TextField}
 * - {@link Core.widget.NumberField NumberField}
 * - {@link Core.widget.DateField DateField}
 * - {@link Core.widget.TimeField TimeField}
 * - {@link Core.widget.Combo Combo}
 *
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 * @abstract
 */


class Field extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'Field';
  } // Factoryable type name


  static get type() {
    return 'field';
  }

  static get configurable() {
    return {
      defaultBindProperty: 'value',

      /**
       * @hideconfigs htmlCls, content, tag, scrollable, html
       */

      /**
       * Text to display in empty field.
       * @config {String} placeholder
       */
      placeholder: null,

      /**
       * Gets or sets the value. The returned type will depend upon the Field subclass.
       *
       * `TextField` returns a `String`.
       *
       * `NumberField` returns a `Number`.
       *
       * `DateField` and `TimeField` return a `Date` object, and `null` if the field is empty.
       *
       * `Combo` will return a `String` if configured with `items` as a simple string array.
       * Otherwise it will return the {@link Core.widget.Combo#config-valueField} value from the
       * selected record, or `null` if no selection has been made.
       * @member {*} value
       */

      /**
       * Default value
       * @config {String}
       */
      value: '',

      /**
       * Name of the field which is used as a key to get/set values from/to the field.
       * Used prior to {@link Core.widget.Widget#config-ref ref} and {@link Core.widget.Widget#config-id id} in
       * {@link Core.widget.Container#property-values Container.values}.
       *
       * The config is useful when the field is used in EventEditor or TaskEditor to load/save values automatically.
       * @config {String}
       */
      name: null,

      /**
       * Get/set fields label. Please note that the Field needs to have a label specified from start for this to
       * work, otherwise no element is created.
       * @member {String} label
       */

      /**
       * Label, prepended to field
       * @config {String}
       * @category Label
       */
      label: null,

      /**
       * Label position, either 'before' the field or or 'above' the field
       * @config {String}
       * @default
       * @category Label
       */
      labelPosition: 'before',

      /**
       * CSS class name or class names to add to any configured {@link #config-label}
       * @config {String|Object}
       * @category Label
       */
      labelCls: null,

      /**
       * The labels to add either before or after the input field.
       * Each label may have the following properties:
       * * `html` The label text.
       * * `align` `'start'` or `'end'` which end of the field the label should go.
       * @config {Object}
       * @category Label
       */
      labels: null,

      /**
       * The width to apply to the `<label>` element. If a number is specified, `px` will be used.
       * @config {String|Number}
       * @localizable
       * @category Label
       */
      labelWidth: {
        value: null,
        $config: {
          localeKey: 'L{labelWidth}'
        }
      },

      /**
       * Configure as `true` to indicate that a `null` field value is to be marked as invalid.
       * @config {Boolean}
       * @default false
       */
      required: null,

      /**
       * Show a trigger to clear field, and allow `ESC` key to clear field if this field is
       * not {@link #config-readOnly}. The trigger is available in the {@link #property-triggers} object
       * under the name `clear`. May also be an object which configures the `clear` {@link #property-triggers trigger}.
       * @config {Boolean|Object}
       * @default false
       */
      clearable: null,

      /**
       * If this field is not {@link #config-readOnly}, then setting this option means that pressing
       * the `ESCAPE` key after editing the field will revert the field to the value it had when
       * the user focused the field. If the field is _not_ changed from when focused, the {@link #config-clearable}
       * behaviour will be activated.
       * @config {Boolean}
       * @default false
       */
      revertOnEscape: null,

      /**
       * An optional string to display inside the input field as an overlay. This can be useful for displaying
       * a field's units.
       *
       * This config is ignored if {@link #config-hintHtml} is set.
       *
       * For example:
       * ```javascript
       *  {
       *      type  : 'numberfield',
       *      label : 'Temperature',
       *      hint  : '°C'
       *  }
       * ```
       *
       * This config can be set to a function to dynamically generate the `hint` text:
       * ```javascript
       *  {
       *      type  : 'numberfield',
       *      label : 'Duration',
       *      hint  : ({ value }) => (value === 1) ? 'Day' : 'Days'
       *  }
       * ```
       *
       * The function is passed an object with the following properties:
       *
       *  - `source` A reference to the field instance.
       *  - `value` The current value of the field.
       *
       * A `hint` function will be called when the field changes value.
       *
       * @config {String|Function}
       * @category Label
       */
      hint: null,

      /**
       * This config is similar to {@link #config-hint} except that this config is used to display HTML content.
       * Since this can allow malicious content to be executed, be sure not to include user-entered data or to
       * encode such data (see {@link Core.helper.StringHelper#function-encodeHtml-static}).
       *
       * If this config is set, {@link #config-hint} is ignored.
       *
       * For example:
       * ```javascript
       *  {
       *      type     : 'numberfield',
       *      label    : 'Temperature',
       *      hintHtml : '<i>°C</i>'
       *  }
       * ```
       *
       * This config can be set to a function to dynamically generate the `hintHtml` text:
       * ```javascript
       *  {
       *      type     : 'numberfield',
       *      label    : 'Duration',
       *      hintHtml : ({ value }) => (value === 1) ? '<i>Day</i>' : '<i>Days</i>'
       *  }
       * ```
       *
       * The function is passed an object with the following properties:
       *
       *  - `source` A reference to the field instance.
       *  - `value` The current value of the field.
       *
       * A `hintHtml` function will be called when the field changes value.
       *
       * @config {String|Function}
       * @category Label
       */
      hintHtml: null,

      /**
       * The width to apply to the `<input>` element. If a number is specified, `px` will be used.
       * @config {String|Number}
       * @category Input element
       */
      inputWidth: null,

      /**
       * The delay in milliseconds to wait after the last keystroke before triggering a change event.
       * Set to 0 to not trigger change events from keystrokes (listen for input event instead to have
       * immediate feedback, change will still be triggered on blur)
       * @config {Number}
       * @default
       */
      keyStrokeChangeDelay: 0,

      /**
       * Makes the field unmodifiable by user action. The input area is not editable, and triggers
       * are unresponsive.
       *
       * This is a wider-acting setting than {@link #config-editable} which *only* sets the
       * `readOnly` attribute of the `<input>` field.
       *
       * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
       * modifiable through the UI.
       * @config {Boolean}
       */
      readOnly: null,

      /**
       * Set to false to prevent user from editing the field. For TextFields it is basically the same as setting
       * {@link #config-readOnly}, but for PickerFields there is a distinction where it allows you to pick a value
       * but not to type one in the field.
       *
       * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
       * modifiable through the UI.
       * @config {Boolean}
       * @default true
       */
      editable: true,
      defaultAction: 'change',

      /**
       * The trigger Widgets as specified by the {@link #config-triggers} configuration and the
       * {@link #config-clearable} configuration. Each is a {@link Core.widget.Widget Widget} instance which may
       * be hidden, shown and observed and styled just like any other widget.
       * @member {Object} triggers
       */

      /**
       * The triggers to add either before or after the input field. Each property name is the reference by which
       * an instantiated Trigger Widget may be retrieved from the live `{@link #property-triggers}` property.
       *
       * Each trigger may have the following properties:
       * * `cls` The CSS class to apply.
       * * `handler` A method in the field to call upon click
       * * `align` `'start'` or `'end'` which end of the field the trigger should go.
       * * `weight` (Optional) Higher weighted triggers gravitate towards the input field.
       *
       * ```javascript
       * const textField = new TextField({
       *   triggers : {
       *       check : {
       *           cls : 'b-fa b-fa-check',
       *           handler() {
       *               ...
       *           }
       *       },
       *       ...
       *   }
       * })
       * ```
       *
       * @config {Object}
       */
      triggers: null,

      /**
       * Specify `false` to prevent field from being highlighted when on external value changes
       * @config {Boolean}
       */
      highlightExternalChange: true,
      localizableProperties: ['label', 'title', 'placeholder', 'labelWidth'],

      /**
       * Specify `true` to auto select field contents on focus
       * @config {Boolean}
       * @default
       */
      autoSelect: false,

      /**
       * Sets the native `autocomplete` property of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
       * @config {String}
       * @default
       * @category Input element
       */
      autoComplete: 'off',

      /**
       * Sets the native `spellcheck` property of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck)
       * @config {Boolean}
       * @category Input element
       */
      spellCheck: null,

      /**
       * Sets custom attributes of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes)
       * @config {Object}
       * @default
       * @category Input element
       */
      inputAttributes: null,

      /**
       * Sets the `type` attribute of the underlying input element (password, hidden, date, color, etc).
       * @config {String}
       * @category Input element
       */
      inputType: 'text',

      /**
       * Text alignment for the input field.
       * @config {String}
       * @category Input element
       */
      inputAlign: null,

      /**
       * A list of property names to be set in the underlying input element from properties
       * by the same name in this Field object if the value is not `== null`.
       * @private
       * @category Input element
       */
      attributes: {
        value: ['placeholder', 'autoComplete', 'spellCheck', 'minLength', 'maxLength', 'pattern', 'tabIndex', 'min', 'max'],
        $config: {
          merge: 'distinct'
        }
      },
      nullValue: {
        $config: null,
        value: null,
        default: null // store _value=null on prototype

      },
      updatedClsDuration: 500,
      inputReadOnly: false,
      testConfig: {
        updatedClsDuration: 10
      }
    };
  }

  static get delayable() {
    return {
      highlightChanged: 'raf'
    };
  }

  doDestroy() {
    var _me$inputListenerRemo, _me$keyListenerRemove;

    const me = this,
          {
      triggers
    } = me,
          errorTip = me.isPainted && Field.getSharedErrorTooltip(me.rootElement, true);
    (_me$inputListenerRemo = me.inputListenerRemover) === null || _me$inputListenerRemo === void 0 ? void 0 : _me$inputListenerRemo.call(me);
    (_me$keyListenerRemove = me.keyListenerRemover) === null || _me$keyListenerRemove === void 0 ? void 0 : _me$keyListenerRemove.call(me);
    super.doDestroy();

    if (triggers) {
      for (const t of Object.values(triggers)) {
        t.destroy();
      }
    } // The errorTip references this field, hide it when we die.


    if ((errorTip === null || errorTip === void 0 ? void 0 : errorTip.field) === me) {
      errorTip.hide();
    }
  }

  get invalidValueError() {
    return 'L{invalidValue}';
  }
  /**
   * A singleton error tooltip which activates on hover of invalid fields.
   * before show, it gets a reference to the field and interrogates its
   * active error list to display as the tip content.
   * @member {Core.widget.Tooltip}
   * @readonly
   */


  get errorTip() {
    return this.constructor.getSharedErrorTooltip(this.rootElement);
  }

  static getSharedErrorTooltip(rootElement, doNotCreate) {
    var _rootElement$bryntum;

    let sharedErrorTooltip = (_rootElement$bryntum = rootElement.bryntum) === null || _rootElement$bryntum === void 0 ? void 0 : _rootElement$bryntum.errorTooltip;

    if (!sharedErrorTooltip && !doNotCreate) {
      rootElement.bryntum = rootElement.bryntum || {};
      sharedErrorTooltip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        cls: 'b-field-error-tip',
        forSelector: '.b-field.b-invalid .b-field-inner',
        align: 'l-r',
        scrollAction: 'realign',
        trapFocus: false,
        rootElement,

        onBeforeShow() {
          const tip = this,
                field = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(tip.activeTarget);

          if (field) {
            const errors = field.getErrors();

            if (errors) {
              tip.html = errors.join('<br>');
              tip.field = field;
              return true;
            }
          } // Veto show


          return false;
        }

      });
      rootElement.bryntum.errorTooltip = sharedErrorTooltip;
    }

    return sharedErrorTooltip;
  }
  /**
   * A singleton error tooltip which activates on hover of invalid fields.
   * before show, it gets a reference to the field and interrogates its
   * active error list to display as the tip content.
   *
   * Please note: Not applicable when using widgets inside a shadow root
   * @member {Core.widget.Tooltip}
   * @readonly
   * @static
   */


  static get errorTip() {
    return this.getSharedErrorTooltip(document.body);
  } //endregion
  //region Event

  /**
   * Fired when the user types into this field.
   * @event input
   * @param {Core.widget.Field} source This field.
   * @param {String} value - This field's value
   * @param {Event} event - The triggering DOM event.
   */

  /**
   * Fired when this field's value changes.
   * @event change
   * @param {String} value - This field's value
   * @param {String} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * User performed default action (typed into this field).
   * @event action
   * @param {String} value - This field's value
   * @param {String} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * Fired when this field is {@link #function-clear cleared}.
   *
   * This will be triggered when a user clicks this field's clear {@link #property-triggers trigger}
   * @event clear
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * User clicked one of this field's {@link #property-triggers}
   * @event trigger
   * @param {Core.widget.Field} source This field
   * @param {Core.widget.Widget} trigger The trigger activated by click or touch tap.
   */
  //endregion
  //region Init


  construct(config) {
    super.construct(config);
    const me = this;

    if (me.keyStrokeChangeDelay) {
      me.changeOnKeyStroke = me.buffer(me.internalOnChange, me.keyStrokeChangeDelay);
    }
  }

  onFocusIn(e) {
    const me = this;
    me.valueOnFocus = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clone(me.value);
    me.validOnFocus = !(me.errors && Object.keys(me.errors).length);
    super.onFocusIn(e);
  }

  onFocusOut(e) {
    super.onFocusOut(e); // Required field not flagged with error initially, flag on blur instead for better appearance

    this.syncRequired(); // Check field consistency on blur

    this.onEditComplete();
  }
  /**
   * Template function which may be implemented by subclasses to synchronize
   * input state and validity state upon completion of the edit.
   * @internal
   */


  onEditComplete() {}

  get rootUiClass() {
    return Field;
  }

  compose() {
    // Force evaluation of clearable so triggers include the clearable trigger. We can't bury this inside
    // changeTriggers since there may be no other triggers defined (which would mean changeTriggers would never
    // be run)
    this.getConfig('clearable');

    const {
      id,
      innerElements,
      label,
      labels,
      labelCls,
      readOnly,
      triggers
    } = this,
          triggerInstances = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].values(triggers, (k, v) => !v),
          // The triggers at each end are sorted "gravitationally".
    // Higher weight sorts towards the center which is the input element.
    startTriggers = triggerInstances.filter(t => t.align === 'start').sort(byWeight),
          endTriggers = triggerInstances.filter(t => t.align !== 'start').sort(byWeightReverse),
          setupLabel = lbl => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      tag: 'label',
      for: `${id}-input`,
      class: `b-label b-align-${lbl.align || 'start'}`
    }, lbl);

    return {
      class: {
        'b-has-label': Boolean(label) || (labels === null || labels === void 0 ? void 0 : labels.length),
        'b-has-start-trigger': startTriggers.length,
        'b-readonly': readOnly
      },
      children: [...(labels || emptyArray).filter(t => t && t.align !== 'end').map(setupLabel), (label || null) && setupLabel({
        reference: 'labelElement',
        class: `b-label b-align-start ${labelCls || ''}`,
        html: label
      }), {
        class: 'b-field-inner',
        reference: 'inputWrap',
        children: [...startTriggers.map(t => t.element), ...innerElements, ...endTriggers.map(t => t.element)]
      }, ...(labels || emptyArray).filter(t => (t === null || t === void 0 ? void 0 : t.align) === 'end').map(setupLabel)]
    };
  }

  updateElement(element, was) {
    var _me$keyListenerRemove2;

    const me = this,
          value = me.initialConfig.value,
          {
      input
    } = me;
    super.updateElement(element, was); // Value must be injected into the input element after it has been constructed, not in the
    // initial template, otherwise the caret position will not be as expected.

    if (value != null) {
      me.value = value;
    }

    me.syncEmpty();
    me.updateInputReadOnly(me.inputReadOnly);
    me.syncInvalid();
    const keyEventElement = input || me.focusElement;
    (_me$keyListenerRemove2 = me.keyListenerRemover) === null || _me$keyListenerRemove2 === void 0 ? void 0 : _me$keyListenerRemove2.call(me);
    me.keyListenerRemover = keyEventElement && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: keyEventElement,
      thisObj: me,
      keydown: 'internalOnKeyEvent',
      keypress: 'internalOnKeyEvent',
      keyup: 'internalOnKeyEvent'
    });
  } // Subclasses may implement this.
  // Needed because Checkbox produces an array of two elements as its innerElements


  get innerElements() {
    return [this.inputElement];
  }

  get inputElement() {
    const {
      attributes,
      inputAttributes,
      id,
      inputCls,
      inputType,
      name
    } = this,
          domConfig = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      reference: 'input',
      tag: 'input',
      type: inputType,
      name: name || id,
      id: `${id}-input`,
      retainElement: true // allow the input to be transplanted as in combo/chipView

    }, inputAttributes);

    if (inputCls) {
      domConfig.class = inputCls;
    }

    for (let key, value, i = attributes.length; i-- > 0;) {
      key = attributes[i];
      value = this[key];

      if (value != null) {
        // don't smash properties already in domConfig w/null values...
        domConfig[key] = value;
      }
    }

    return domConfig;
  } //endregion
  //region Focus & select


  get caretPos() {
    return this.textSelection[0];
  }

  set caretPos(value) {
    this.textSelection = value;
  }

  get focusElement() {
    return this.input;
  }

  get textSelection() {
    const input = this.input;
    let ret;

    try {
      ret = [input.selectionStart, input.selectionEnd, input.selectionDirection];
    } catch (e) {
      var _input$value;

      // ignore (some input types cannot do this)
      ret = ((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.length) || 0;
      ret = [ret, ret];
    }

    return ret;
  }

  set textSelection(value) {
    if (typeof value === 'number') {
      this.select(value, value);
    } else {
      this.select(...value);
    }
  }

  get hasTextSelection() {
    const [selectionStart, selectionEnd] = this.textSelection;
    return selectionStart && selectionEnd - selectionStart > 0;
  }
  /**
   * Returns the input value for this field's input element that will be present if
   * the event carrying the given text is allowed to proceed.
   * @param {String} text
   * @returns {String}
   * @private
   */


  getAfterValue(text) {
    const [begin, end] = this.textSelection,
          value = this.input.value;
    return `${value.substr(0, begin)}${text}${value.substr(end || begin)}`;
  }
  /**
   * Selects the field contents. Optionally may be passed a start and end.
   * NOTE: This method is async for IE11
   * @param {Number} [start] The start index from which to select the input.
   * @param {Number} [end] The index at which to end the selection of the input.
   */


  select(start, end) {
    // Use focusElement which is the input field in this class
    // but allows subclasses to use other elements.
    // See, for example, TextAreaField
    const input = this.focusElement;

    if (input.value.length) {
      if (arguments.length === 0) {
        this.selectAll();
        return;
      } // Only allowed to select range in certain element / input types


      if (!this.supportsTextSelection) {
        return; // throw new Error('Trying to select text on an invalid element type');
      }

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
        // this.clearTimeout(this.selectTimeout);
        // HACK: IE focus processing is async and we can't select text until field is focused
        // Getting flaky exception in IE, something timing related. Found no way to detect it so using this
        // workaround for now
        input.focus();
        input.setSelectionRange(start, end); //
        // this.selectTimeout = this.setTimeout(() => {
        //     input && input.setSelectionRange(start, end);
        // }, 10);
      } else {
        input.setSelectionRange(start, end);
      }
    }
  }

  moveCaretToEnd() {
    const input = this.input;

    if (input.createTextRange) {
      const range = input.createTextRange();
      range.collapse(false);
      range.select();
    } else if (this.supportsTextSelection) {
      // Move caret to the end if possible
      this.select(input.value.length, input.value.length);
    }
  }

  selectAll() {
    this.focusElement.select();
  } // called on value changes to update styling of empty vs non-empty field


  syncEmpty() {
    const {
      isEmptyInput,
      isEmpty,
      element,
      clearIcon
    } = this,
          empty = isEmptyInput && isEmpty;

    if (element) {
      if (clearIcon) {
        // IE11...
        clearIcon.classList[empty ? 'add' : 'remove']('b-icon-hidden');
      } // IE11...


      element.classList[empty ? 'add' : 'remove']('b-empty');
    }
  }

  updateHint() {
    this.syncHint();
  }

  updateHintHtml() {
    this.syncHint();
  }

  syncHint() {
    const me = this,
          {
      input,
      hint,
      hintHtml
    } = me,
          parent = input === null || input === void 0 ? void 0 : input.parentElement;

    if (input) {
      let hintValue = hintHtml || hint;
      const hintElement = me.hintElement || hintValue && (me.hintElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].createElement({
        parent,
        className: 'b-field-hint',
        nextSibling: input.nextSibling,
        children: [{
          className: 'b-field-hint-content'
        }]
      }));

      if (hintElement) {
        if (typeof hintValue === 'function') {
          hintValue = hintValue({
            source: me,
            value: me.value
          });
        }

        hintElement.firstChild[hintHtml ? 'innerHTML' : 'textContent'] = hintValue || '';
      }

      me.element.classList[hintValue ? 'remove' : 'add']('b-field-no-hint');
    }
  }

  syncInvalid() {
    this.updatingInvalid = true;
    const {
      isPainted
    } = this;

    if (isPainted) {
      const {
        isValid,
        element,
        inputWrap
      } = this; // errorTip needs Tooltip.listenersTarget to be there
      // otherwise it doesn't setup listeners and cannot notice we mouseover an invalid field

      const errorTip = this.errorTip;
      element.classList[isValid ? 'remove' : 'add']('b-invalid'); // We achieved validity, so ensure the error tip is hidden

      if (isValid) {
        if (errorTip !== null && errorTip !== void 0 && errorTip.isVisible && errorTip.field === this) {
          errorTip.hide();
        }
      } // If the mouse is over, the tip should spring into view
      else if (errorTip && inputWrap.contains(_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"].currentOverElement)) {
        // Already shown by this field's inputWrap, just update content.
        if (errorTip.activeTarget === inputWrap && errorTip.isVisible) {
          errorTip.onBeforeShow();
        } else {
          errorTip.activeTarget = inputWrap;
          errorTip.showBy(inputWrap);
        }
      }
    }

    this.updatingInvalid = false;
  } //endregion
  //region Getters/setters


  updateEditable() {
    this.syncInputReadOnly();
  }

  syncInputReadOnly() {
    this.getConfig('readOnly'); // make sure our config is initialized...
    // but since the readOnly getter conflates disabled into it, we ultimately have to look at _readOnly:

    this.inputReadOnly = this._readOnly || this.editable === false;
  }

  updateInputReadOnly(readOnly) {
    const me = this,
          {
      input,
      inputListenerRemover
    } = me; // Editable refers *ONLY* to the readOnly state of the <input> field within the field.
    // It does *NOT* imply that the field is not modifiable by user interaction.
    // For example, a Combo or DateField may be not editable, but may still be set through the UI.
    // It is the readOnly config which disables user interaction from modifying the field.

    if (input) {
      input.readOnly = readOnly ? 'readOnly' : null;

      if (readOnly) {
        me.inputListenerRemover = inputListenerRemover === null || inputListenerRemover === void 0 ? void 0 : inputListenerRemover();
      } else if (!inputListenerRemover) {
        me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          element: input,
          thisObj: me,
          focus: 'internalOnInputFocus',
          change: 'internalOnChange',
          input: 'internalOnInput'
        });
      }
    }
  }

  changeReadOnly(value) {
    return Boolean(value);
  }

  updateReadOnly(readOnly) {
    this.syncInputReadOnly();
  }

  updateClearable(clearable) {
    const me = this;
    me.getConfig('triggers');
    me.triggers = {
      clear: clearable && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
        cls: 'b-icon-remove',
        weight: 1000,

        handler() {
          me._isUserAction = true;
          me.clear();
          me._isUserAction = false;
        }

      }, clearable) || null
    };
  }

  changeTriggers(triggers, was) {
    const me = this,
          manager = me.$triggers || (me.$triggers = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
      configName: 'triggers',
      factory: Field.Trigger,
      inferType: false,
      // the name of a trigger in the triggers object is not its type
      owner: me,

      created(instance) {
        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (triggerConfigs[name]) {
            me.onConfigChange({
              name: 'triggers',
              value: manager.target
            });
          }
        });
      },

      setup(config, name) {
        config.reference = config.ref = name;
        config.parent = me;
      }

    }));

    if (me.stepTriggers === false && (triggers.back || triggers.forward)) {
      triggers = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({}, triggers);
      delete triggers.back;
      delete triggers.forward;
    }

    manager.update(triggers);

    if (!was) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  }

  updateLabelWidth(newValue) {
    if (this.labelElement) {
      this.labelElement.style.flex = `0 0 ${_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(newValue)}`; // If there's a label width, the input must conform with it, and not try to expand to 100%

      this.inputWrap.style.flexBasis = newValue == null ? '' : 0;
    }
  }

  updateInputWidth(newValue) {
    this.input.style.width = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(newValue); // requires to make "Should support inputWidth with label" test green

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.input.parentElement.style.flexBasis = this.input.style.width;
    }

    this.element.classList.add('b-has-width');
  }

  updateInputAlign(newValue) {
    this.input.style.textAlign = newValue;
  }

  changeLabel(label) {
    return label == null ? '' : label;
  }

  updateLabel(label) {
    // since value is used in template it is not certain that element is available
    // TODO: move the code from template here instead
    if (this.labelElement) {
      // using innerHTML since we sometimes use icons as label
      this.labelElement.innerHTML = label;
    }
  }

  updateLabelPosition(position, oldPosition) {
    const {
      classList
    } = this.element;
    classList.remove(`b-label-${oldPosition}`);
    classList.add(`b-label-${position}`);
  }
  /**
   * Returns true if the field value is valid
   * @type {Boolean}
   * @readonly
   */


  get isValid() {
    const me = this; // Disabled fields are considered valid

    if (!me.disabled) {
      me.syncRequired();

      if (me.errors && Object.keys(me.errors).length) {
        return false;
      }

      const validity = me.validity;

      if (validity) {
        return validity.valid;
      }
    }

    return true;
  }
  /**
   * Returns `true` if this field is empty. That is, if it would violate the {@link #config-required}
   * setting.
   *
   * This may have different definitions in subclasses from simple text fields.
   * @type {Boolean}
   * @readonly
   */


  get isEmpty() {
    return this.value == null || this.value === '';
  }
  /**
   * Returns true if the field's input is empty
   * @type {Boolean}
   * @readonly
   */


  get isEmptyInput() {
    return !this.input || this.input.value == null || this.input.value === '';
  }
  /**
   * Returns the DOM `ValidityState` for this widget's input element, or `null` if there
   * isn't one.
   * @returns {ValidityState}
   * @private
   */


  get validity() {
    const input = this.input;
    return input && input.validity;
  }

  changeValue(value, was) {
    if (value == null) {
      value = this.nullValue;
    } // In cases of arrays, for example, we need to return "was" to pass the === check in the setter to convince
    // the config that, in fact, no change has occurred.


    if (this.hasChanged(was, value)) {
      return value;
    } // When loading a record into a form, an empty value might be loaded into a field, which is not detected as a
    // change. In this scenario it should still be flagged as invalid


    if (value === '') {
      this.syncRequired();
    }

    return was;
  }

  updateValue(value, oldValue) {
    const me = this; // Do not flag with error if configured empty, looks ugly to have fields start red

    if (!me.isConfiguring) {
      me.syncRequired(); // Do not trigger change event during configuration phase
      // or during keyboard input

      if (!me.inputting) {
        // trigger change event, signaling that origin is from set operation,
        // makes it easier to ignore such events in applications that set value on load etc
        me.triggerChange();
      }
    } // lastValue is used for IE to check if a change event should be triggered when pressing ENTER


    if (!me.inputting) {
      me._lastValue = value;
    }

    me.syncInputFieldValue();
  }
  /**
   * Compares this field's value with its previous value. May be overridden in subclasses
   * which have more complex value types. See, for example, {@link Core.widget.DurationField}.
   * @param {*} oldValue
   * @param {*} newValue
   * @private
   */


  hasChanged(oldValue, newValue) {
    return newValue !== oldValue;
  }
  /**
   * Called by the base Field class's `set value` to sync the state of the UI with the field's value.
   *
   * Relies upon the class implementation of `get inputValue` to return a string representation of
   * the value for user consumption and editing.
   * @private
   */


  syncInputFieldValue(skipHighlight = false) {
    const me = this,
          {
      input,
      parent,
      inputValueAttr,
      inputValue
    } = me; // If we are updating from internalOnInput, we must not update the input field

    if (input && !me.inputting && input[inputValueAttr] !== inputValue) {
      // Subclasses may implement their own read only inputValue property.
      input[inputValueAttr] = inputValue; // TODO : This highlighting logic needs extracting/clarifying
      // If it's being manipulated from the outside, highlight it

      if (!me.isConfiguring && !me.containsFocus && me.highlightExternalChange) {
        var _parent$_isSettingVal;

        input.classList.remove('b-field-updated');
        me.clearTimeout('removeUpdatedCls');

        if (!skipHighlight && (!parent || !(parent.isSettingValues || (_parent$_isSettingVal = parent._isSettingValues) !== null && _parent$_isSettingVal !== void 0 && _parent$_isSettingVal.preventHighlight))) {
          me.highlightChanged();
        }
      }
    }

    me.syncEmpty();
    me.syncInvalid();
  }

  highlightChanged() {
    this.input.classList.add('b-field-updated');
    this.setTimeout('removeUpdatedCls', this.updatedClsDuration);
  }

  removeUpdatedCls() {
    this.input.classList.remove('b-field-updated');
  }
  /**
   * A String representation of the value of this field for {@link #function-syncInputFieldValue} to use
   * as the input element's value.
   *
   * Subclasses may override this to create string representations.
   *
   * For example, {@link Core.widget.DateField}'s implementation will format the field date
   * value according to its configured {@link Core.widget.DateField#config-format}. And {@link Core.widget.Combo}'s
   * implementation will return the {@link Core.widget.Combo#config-displayField} of the selected record.
   * @internal
   * @readOnly
   */


  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    return this.value == null ? '' : this.value;
  }

  get inputValueAttr() {
    return 'value';
  }

  get supportsTextSelection() {
    const input = this.focusElement; // Text selection using setSelectionRange is allowed in Chrome for certain elements. Edge supports it even for input[type=number]

    return input && (input.tagName.toLowerCase() === 'textarea' || input.type && (/text|search|password|tel|url/.test(input.type) || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEdge));
  } //endregion
  //region Events


  internalOnInputFocus() {
    const me = this,
          length = me.input.value.length; // Help IE to set caret at the end like the other browsers

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11 && length && !me.autoSelect) {
      me.select(length, length);
    }

    if (me.autoSelect) {
      me.selectAll();
    }
  }
  /**
   * Trigger event when fields input changes
   * @fires change
   * @private
   */


  internalOnChange(event) {
    const me = this; // Don't trigger change if we enter invalid value or if value has not changed (for IE when pressing ENTER)

    if (me.isValid && me.hasChanged(me._lastValue, me.value)) {
      me.triggerChange(event, true);
      me._lastValue = me.value;
    }
  }

  triggerChange(event, userAction = Boolean(this._isUserAction)) {
    const me = this,
          {
      value,
      _lastValue: oldValue,
      // TODO: The `internalOnChange`-path excludes invalid changes, while the `set value`-path includes them
      isValid: valid
    } = me;
    me.syncHint(); // trigger change event, signaling that origin is from user

    me.triggerFieldChange({
      value,
      oldValue,
      event,
      userAction,
      valid
    }); // per default Field triggers action event on change, but might be reconfigured in subclasses (such as Combo)

    if (me.defaultAction === 'change') {
      me.trigger('action', {
        value,
        oldValue,
        event,
        userAction,
        valid
      });
    } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction

  }
  /**
   * Trigger event when user inputs into field
   * @fires input
   * @param event
   * @private
   */


  internalOnInput(event) {
    var _me$changeOnKeyStroke;

    const me = this; // Keep the value synced with the inputValue at all times.

    me.inputting = true;
    me.value = me.input.value;
    me.inputting = false;
    me.trigger('input', {
      value: me.value,
      event
    });
    (_me$changeOnKeyStroke = me.changeOnKeyStroke) === null || _me$changeOnKeyStroke === void 0 ? void 0 : _me$changeOnKeyStroke.call(me, event); // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onInput
  }

  internalOnKeyEvent(event) {
    const me = this,
          {
      value
    } = me;
    let stopEvent = false;

    if (event.type === 'keydown') {
      if (event.key === 'Escape' && !(me.readOnly || me.disabled)) {
        // We can be started with an initialValue which takes precedence over the valueOnFocus.
        // Because in some situations focus can move out and back in after a change which needs
        // to be revertable. For example in cell editing.
        const wasValid = me.isValid,
              initialValue = 'initialValue' in me ? me.initialValue : me.valueOnFocus,
              valueChanged = me.hasChanged(initialValue, value),
              needsInputSync = me.input.value !== String(me.inputValue); // We revert on escape if we are configured to do so AND:
        // We are in an invalid state, or the value has changed, or the displayed value doesn't match the field value.

        if (me.revertOnEscape && (!wasValid || valueChanged || needsInputSync)) {
          if (valueChanged) {
            me.value = initialValue;
          }

          if (needsInputSync) {
            me.syncInputFieldValue(true);
          }

          me.clearError(); // If this processing changed the value back to valid, or
          // the validity state was different to that upon focus
          // then this was a revert operation, so prevent further ESC processing.

          stopEvent = valueChanged && me.isValid || wasValid !== me.validOnFocus;
        } else if (me.clearable && (value || me.input.value)) {
          me.clear();
        }
      } // #5730 - IE11 doesn't trigger "change" event by Enter click
      else if (event.key === 'Enter' && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
        me.internalOnChange(event);
      }
    } // The above processing might have destructive consequences.


    if (!me.isDestroyed) {
      // If the keystroke had the effect of changing the field, prevent other handlers
      // which may mask that effect. Such as ESC exiting some UI context. Keep it contained.
      if (stopEvent) {
        event.stopImmediatePropagation();
      }

      me.trigger(event.type, {
        event
      });
    }
  }
  /**
   * Clears the value of this Field, and triggers the {@link #event-clear} event.
   */


  clear() {
    this.value = this.nullValue;
    this.trigger('clear');
  }
  /**
   * Called when disabled state is changed.
   * Used to add or remove 'b-invalid' class for the invalid field based on current disabled state.
   * @private
   */


  onDisabled() {
    this.syncInvalid();
  } //endregion
  //region Error


  syncRequired() {
    var _me$parent;

    const me = this; // Empty valid if any ancestor Container is setting values

    if (!me.isConfiguring && me.required && me.isEmpty && !((_me$parent = me.parent) !== null && _me$parent !== void 0 && _me$parent.isSettingValues)) {
      me.setError('L{fieldRequired}', me.updatingInvalid);
    } else {
      me.clearError('L{fieldRequired}', me.updatingInvalid);
    }
  }
  /**
   * Adds an error message to the list of errors on this field.
   * By default the field's valid/invalid state is updated; pass
   * `false` as the second parameter to disable that if multiple
   * changes are being made to the error state.
   * @param {String} error A locale string, or message to use as an error message.
   * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
   * @privateparam {Boolean} [temporary=false] Pass as `true` to remove the error upon the next user interaction.
   */


  setError(error, silent, temporary) {
    const me = this; // Error messages are deduplicated by using them as the property names in an object.

    (me.errors || (me.errors = {}))[me.optionalL(error)] = 1;

    if (!silent) {
      me.syncInvalid();
    }

    if (temporary) {
      const clearError = () => {
        me.clearError(error);
        remover();
      },
            remover = me.on({
        keydown: clearError,
        focusOut: clearError
      });
    }
  }
  /**
   * Removes an error message from the list of errors on this field.
   * By default the field's valid/invalid state is updated; pass
   * `false` as the second parameter to disable that if multiple
   * changes are being made to the error state.
   * @param {String} [error] A locale string, or message to remove. If not passed, all errors are cleared.
   * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
   */


  clearError(error, silent) {
    const me = this;

    if (me.errors) {
      if (error) {
        delete this.errors[this.optionalL(error)];
      } else {
        me.errors = {};
      }

      if (!silent) {
        me.syncInvalid();
      }
    }
  }
  /**
   * Returns an array of error messages as set by {@link #function-setError}, or
   * `undefined` if there are currently no errors.
   * @return {String[]} The errors for this field, or `undefined` if there are no errors.
   */


  getErrors() {
    const me = this;

    if (!me.isValid) {
      const validity = me.validity,
            // See possible state names: https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
      stateName = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].keys(validity).find(key => key !== 'valid' && key !== 'customError' && validity[key]),
            errorKeys = me.errors && Object.keys(me.errors);
      let errors;

      if (errorKeys !== null && errorKeys !== void 0 && errorKeys.length) {
        errors = errorKeys;
      } // If custom error message was set using https://developer.mozilla.org/en-US/docs/Web/API/HTMLObjectElement/setCustomValidity
      else if (validity.customError) {
        errors = [me.input.validationMessage];
      } // If invalid state found, translate it
      else if (stateName) {
        // Do not remove. Assertion strings for Localization sanity check.
        // 'L{foo}'
        // 'L{badInput}'
        // 'L{patternMismatch}'
        // 'L{rangeOverflow}'
        // 'L{rangeUnderflow}'
        // 'L{stepMismatch}'
        // 'L{tooLong}'
        // 'L{tooShort}'
        // 'L{typeMismatch}'
        // 'L{valueMissing}'
        errors = [me.L(stateName, {
          // In case min/max limits are present they will be used in the translation
          min: me.min,
          max: me.max
        })];
      } // If built-in state is 'valid' but me.isValid is false, show our invalid message
      else {
        errors = [me.L(me.invalidValueError)];
      }

      if (errors && errors.length > 0) {
        return errors;
      }
    }
  } //endregion


}
/**
 * Base class for field triggers May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Field.
 * @classtype trigger
 * @extends Core/widget/Widget
 */

Field.Trigger = class FieldTrigger extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FieldTrigger';
  }

  static get factoryable() {
    return {
      defaultType: Field.Trigger,
      extends: null
    };
  } // Factoryable type name


  static get type() {
    return 'trigger';
  } // Align is a simple string at this level


  static get configurable() {
    return {
      align: null,
      weight: null
    };
  }

  get field() {
    return this.parent;
  }

  compose() {
    return {
      class: {
        [`b-align-${this.align || 'end'}`]: 1,
        'b-icon': 1
      },
      listeners: {
        click: 'onClick',
        mousedown: 'onMousedown'
      }
    };
  }

  changeAlign(align) {
    return align; // Widget base class converts to an object
  }

  onClick(e) {
    const me = this,
          {
      field
    } = me,
          handler = typeof me.handler === 'function' ? me.handler : field[me.handler];

    if (!(field.disabled || field.readOnly)) {
      if (field.trigger('trigger', {
        trigger: me
      }) !== false) {
        handler === null || handler === void 0 ? void 0 : handler.call(field, e);
      }
    }
  }

  onMousedown(e) {
    const field = this.field,
          isKeyEvent = ('key' in e); // If it's a touch tap on the trigger of an editable, then
    // avoid the keyboard by setting the field to not be editable
    // before focusing the field. Reset to be editable after focusing
    // has happened. Keyboard will not appear.

    if (!isKeyEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isTouchEvent) {
      if (field.editable) {
        field.editable = false;
        field.setTimeout(() => field.editable = true, 500);
      }
    }

    e.preventDefault();

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getActiveElement(field.input) !== field.input) {
      field.focus();
    }
  }

};
Field.SpinTrigger = class SpinTrigger extends Field.Trigger {
  static get $name() {
    return 'SpinTrigger';
  } // Factoryable type name


  static get type() {
    return 'spintrigger';
  }

  static get configurable() {
    return {
      repeat: {
        $config: ['nullify'],
        value: true
      }
    };
  }

  compose() {
    return {
      children: {
        upButton: {
          class: {
            'b-icon': 1,
            'b-spin-up': 1
          }
        },
        downButton: {
          class: {
            'b-icon': 1,
            'b-spin-down': 1
          }
        }
      }
    };
  }

  updateRepeat(repeat) {
    var _this$clickRepeater;

    (_this$clickRepeater = this.clickRepeater) === null || _this$clickRepeater === void 0 ? void 0 : _this$clickRepeater.destroy();
    this.clickRepeater = repeat ? _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_8__["default"].new({
      element: this.element
    }, repeat) : null;
  }

  onClick(e) {
    const me = this,
          {
      field
    } = me;

    if (!(field.disabled || field.readOnly)) {
      if (e.target === me.upButton) {
        field.doSpinUp(e.shiftKey);
      } else if (e.target === me.downButton) {
        field.doSpinDown(e.shiftKey);
      }
    }
  }

}; // Register trigger widgets type with their Factory

Field.Trigger.initClass();
Field.SpinTrigger.initClass();
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(Field.Trigger, 'trigger');
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(Field.SpinTrigger, 'spintrigger');
Field._$name = 'Field';

/***/ }),

/***/ "./lib/Core/widget/FileField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/FileField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FileField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'gantt';

/**
 * @module Core/widget/FileField
 */

/**
 * FileField widget. Wraps native &lt;input type="file"&gt;.
 *
 * {@inlineexample Core/widget/FileField.js vertical}
 *
 * There is a nicer styled wrapper for this field, see {@link Core/widget/FilePicker}
 *
 * @extends Core/widget/Field
 * @classType filefield
 */

class FileField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FileField';
  } // Factoryable type name


  static get type() {
    return 'filefield';
  }

  internalOnChange(event) {
    // Event order is not consistent across browsers:
    //
    //  Chrome/Firefox:             IE11:                       Edge:
    //      internalOnInput             internalOnChange            internalOnChange
    //      internalOnChange            internalOnInput
    //
    // The problem this creates is that the onChange logic expects value != lastValue which is ensured by the
    // onInput handler. In the IE11/Edge sequence, the first change event is ignored, but with a file input that
    // is the only one you get and so the component's change event does not fire. The user has to make a second
    // file selection to get the event to fire.
    //
    // Fortunately, the event sequence for a file input is simple, so we can just force that order here:
    super.internalOnInput(event);
    super.internalOnChange(event);
  }

  internalOnInput() {// ignore -- see internalOnChange above
  }

  static get configurable() {
    return {
      /**
       * Set to true to allow picking multiple files. Note that when set to a truthy value,
       * the field is set to accept multiple files, but the value returned will be
       * an empty string since this is what is rendered into the HTML.
       * @config {Boolean}
       * @default
       */
      multiple: null,

      /**
       * Comma-separated list of file extensions or MIME type to to accept. E.g.
       * ".jpg,.png,.doc" or "image/*". Null by default, allowing all files.
       * @config {String}
       */
      accept: null,
      inputType: 'file',
      attributes: ['multiple', 'accept']
    };
  }
  /**
   * Returns list of selected files
   * @property {FileList}
   * @readonly
   */


  get files() {
    return this.input.files;
  }
  /**
   * Opens browser file picker
   * @internal
   */


  pickFile() {
    this.input.click();
  }

  get multiple() {
    return this._multiple ? '' : null;
  }
  /**
   * Clears field value
   */


  clear() {
    this.input.value = null;
  }

  triggerChange(event) {
    this.triggerFieldChange({
      event,
      value: this.input.value,
      oldValue: this._lastValue,
      userAction: true,
      valid: true
    });
  }

} // Register this widget type with its Factory

FileField.initClass();
FileField._$name = 'FileField';

/***/ }),

/***/ "./lib/Core/widget/FilePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/FilePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilePicker; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _FileField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./FileField.js */ "./lib/Core/widget/FileField.js");
var productName = 'gantt';




/**
 * @module Core/widget/FilePicker
 */

/**
 * File input field wrapped into {@link Core/widget/Button button}. Clicking button opens browser file picker window.
 * When files are chosen, badge appears showing amount of files. Hovering the button shows tip with file names.
 *
 * By default only single file allowed.
 *
 * @extends Core/widget/Container
 * @example
 *
 * let fileField = new FilePicker({
 *   fileFieldConfig : {
 *      multiple : true,
 *      accept   : "image/*"
 *   },
 *   buttonConfig : {
 *       text : 'Pick file...'
 *   }
 * });
 *
 * @classType filepicker
 * @inlineexample Core/widget/FilePicker.js
 */

class FilePicker extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FilePicker';
  } // Factoryable type name


  static get type() {
    return 'filepicker';
  }

  static get defaultConfig() {
    return {
      /**
       * The name of the property to set when a single value is to be applied to this FilePicker. Such as when used
       * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
       * @config {String}
       * @default
       * @category Misc
       */
      defaultBindProperty: 'value',

      /**
       * Fires after user closes file picker dialog.
       * @event change
       * @param {FileList} files List of picked files
       */

      /**
       * Fires when field is cleared with {@link #function-clear} method
       * @event clear
       */

      /**
       * Wrapper button config object. See {@link Core/widget/Button} for list of available configs.
       * @config {Object}
       */
      buttonConfig: null,

      /**
       * Underlying field config object. See {@link Core/widget/FileField} for list of available configs.
       * @config {Object}
       */
      fileFieldConfig: null
    };
  }

  construct(config = {}) {
    const me = this;
    config.items = [Object.assign({
      type: 'button',
      ref: 'fileButton',
      text: 'L{FilePicker.file}',
      localeClass: this
    }, config.buttonConfig), Object.assign({
      type: 'filefield',
      ref: 'fileField',
      style: 'display: none'
    }, config.fileFieldConfig)].concat(config.items || []);
    super.construct(config);
    me.button.on({
      click: me.onButtonClick,
      thisObj: me
    });
    me.fileField.on({
      change: me.onFileFieldChange,
      thisObj: me
    });

    me._thisIsAUsedExpression(me.fileTip);
  }

  get button() {
    return this.widgetMap.fileButton;
  }

  get fileField() {
    return this.widgetMap.fileField;
  }
  /**
   * List of selected files
   * @property {FileList}
   * @readonly
   */


  get files() {
    return this.fileField.files;
  }

  get fileTip() {
    const me = this;
    return me._fileTip || (me._fileTip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      cls: 'b-file-tip',
      forElement: me.button.element,
      showOnHover: true,
      align: 'b-t',
      scrollAction: 'realign',
      listeners: {
        beforeshow() {
          const tip = this,
                files = me.files;

          if (files && files.length) {
            tip.html = `${Array.from(files).map(file => file.name).join('<br>')}`;
            return true;
          } // Veto show


          return false;
        }

      }
    }));
  }
  /**
   * Clears field
   */


  clear() {
    const me = this;
    me.fileField.clear();
    me.button.badge = '';
    me.trigger('clear');
  }

  onButtonClick({
    event
  }) {
    const me = this; // forward click to the file input to open browser file picker
    // me.fileField.input.click();

    me.fileField.pickFile();
    event.preventDefault();
  }

  onFileFieldChange({
    valid
  }) {
    const me = this;
    me.button.badge = me.files.length || '';
    me.triggerFieldChange({
      files: me.files,
      valid
    });
  }

} // Register this widget type with its Factory

FilePicker.initClass();
FilePicker._$name = 'FilePicker';

/***/ }),

/***/ "./lib/Core/widget/FilterField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/FilterField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterField; });
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
var productName = 'gantt';

/**
 * @module Core/widget/FilterField
 */

/**
 * A simple text field for filtering a store.
 *
 * Allows filtering by {@link #config-field field}:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store : eventStore,
 *    field : 'name'
 * });
 * ```
 *
 * Or by using a {@link #config-filterFunction filter function} for greater control/custom logic:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store          : eventStore,
 *    filterFunction : (record, value) => record.name.includes(value)
 * });
 * ```
 *
 * @extends Core/widget/TextField
 * @classType filterfield
 */

class FilterField extends _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FilterField';
  } // Factoryable type name


  static get type() {
    return 'filterfield';
  }

  static get configurable() {
    return {
      /**
       * The model field name to filter by. Can optionally be replaced by {@link #config-filterFunction}
       * @config {String}
       * @category Filtering
       */
      field: null,

      /**
       * The store to filter.
       * @config {Core.data.Store}
       * @category Filtering
       */
      store: null,

      /**
       * Optional filter function to be called with record and value as parameters for store filtering.
       * ```javascript
       * {
       *     type           : 'filterfield',
       *     store          : myStore,
       *     filterFunction : (record, value)  => {
       *        return record.text.includes(value);
       *     }
       * }
       * ```
       * @param {Core.data.Model} record Record for comparison
       * @param {String} value Value to compare with
       * @return {Boolean} Return true if record matches comparison requirements
       * @config {Function}
       * @category Filtering
       */
      filterFunction: null,
      clearable: true,
      keyStrokeChangeDelay: 100,

      onChange({
        value
      }) {
        const {
          store,
          field,
          filterFunction
        } = this;

        if (store) {
          const filterId = `${field || this.id}-Filter`;

          if (value.length === 0) {
            store.removeFilter(filterId);
          } else {
            let filterBy;

            if (filterFunction) {
              filterBy = record => filterFunction(record, value);
            } else {
              // We filter using a RegExp, so quote significant characters
              value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

              filterBy = record => record.get(field).match(new RegExp(value, 'i'));
            } // A filter with an id replaces any previous filter with that id.
            // Leave any other filters which may be in use in place.


            store.filter({
              id: filterId,
              filterBy
            });
          }
        }
      }

    };
  }

  updateValue(value, old) {
    super.updateValue(value, old); // Initial value, apply it

    if (value && this.isConfiguring) {
      this.onChange({
        value
      });
    }
  }

}
;
FilterField.initClass();
FilterField._$name = 'FilterField';

/***/ }),

/***/ "./lib/Core/widget/Label.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Label.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Label; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';

class Label extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  compose() {
    const {
      text,
      html
    } = this;
    return {
      tag: 'label',
      text,
      html
    };
  }

}

_defineProperty(Label, "$name", 'Label');

_defineProperty(Label, "type", 'label');

_defineProperty(Label, "configurable", {
  text: null
});

Label.initClass();
Label._$name = 'Label';

/***/ }),

/***/ "./lib/Core/widget/List.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/List.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return List; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';








/**
 * @module Core/widget/List
 */

const itemRange = document.createRange();
/**
 * Displays a list of items which the user can navigate using the keyboard and select using either pointer gestures or the keyboard.
 * @extends Core/widget/Widget
 *
 * @classType list
 * @inlineexample Core/widget/List.js
 */

class List extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'List';
  } // Factoryable type name


  static get type() {
    return 'list';
  }

  static get configurable() {
    return {
      itemCls: 'b-list-item',
      selectedCls: 'b-selected',
      selectIconCls: 'b-icon-check',

      /**
       * An array of Objects which are converted into records and used to create this
       * List's {@link #config-store}
       * @config {Object[]}
       */
      items: null,

      /**
       * The model field to render into each list item
       * @config {String}
       * @default
       */
      displayField: 'text',

      /**
       * A {@link Core.data.Store} which provides the records which map to List items. Each record is passed through the
       * {@link #config-itemTpl} to produce the DOM structure of the List. May be generated from an array of {@link #config-items}.
       * @config {Object|Core.data.Store}
       */
      store: null,
      navigator: true,
      scrollable: {
        overflowX: false,
        overflowY: true
      },
      itemsFocusable: true,

      /**
       * Configure as `true` to allow multi select and add checkboxes to the items
       * @config {Boolean}
       * @default
       */
      multiSelect: false,

      /**
       * Select/deselect all if `CMD`/`CTRL` is pressed when clicking
       * @config {Boolean}
       * @default false
       */
      toggleAllIfCtrlPressed: false,

      /**
       * Set to `true` to add a "Select all" item to the list to select/unselect all items at once.
       * Only applies when {@link #config-multiSelect} mode is enabled.
       * @config {Boolean|String}
       * @default false
       */
      selectAllItem: false,

      /**
       * Template function which, when passed a record, returns the textual HTML for that item. Defaults to a
       * function returning the value of the record´s {@link #config-displayField}
       * @config {Function} itemTpl
       * @param {Core.data.Model} record The record
       */
      itemTpl(record) {
        let text = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(record[this.displayField]);

        if (text == null || text === '') {
          // Make sure we have some content to fill the item element and have equal height for all items
          text = '&nbsp;';
        }

        return text;
      },

      /**
       * Template function which is passed a group record and the uppercased group field name. The text returned
       * will be rendered as the group header.
       * @config {Function} groupHeaderTpl
       * @param {Core.data.Model} record The record
       * @param {String} groupName The current group name
       */
      groupHeaderTpl: (record, groupName) => {
        let name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(groupName);

        if (name == null || name === '') {
          // Make sure we have some content to fill the item element and have equal height for all items
          name = '&nbsp;';
        }

        return name;
      },

      /**
       * Configure as `true` to allow selecting groups (all the group child records will be toggled). Only
       * applicable when the store is grouped.
       * @config {Boolean}
       * @default
       */
      allowGroupSelect: true,

      /**
       * A {@link Core.util.Collection Collection}, or Collection config object
       * to use to contain this List's selected records.
       * @config {Core.util.Collection|Object}
       */
      selected: {},

      /**
       * Configure as `true` to activate items on mouseover. This is used by the Combo
       * field when using a List as its dropdown.
       * @config {Boolean}
       */
      activateOnMouseover: null
    };
  } //endregion
  //region Events

  /**
   * User activated an item in the list either by pointer or keyboard.
   * The active record, list item index, and the triggering event are passed.
   * @event item
   * @param {Object} record Activated record
   * @param {Number} index List item index
   * @param {Event} event Triggering event
   */
  //endregion


  construct(config, ...args) {
    var _me$store;

    const me = this; // We can be created from a raw array. It becomes our items which we translate to a Store.

    if (Array.isArray(config)) {
      config = {
        items: config
      };
    }

    super.construct(config, ...args);
    const {
      element
    } = me,
          {
      classList
    } = element;

    if (me.multiSelect) {
      classList.add('b-multiselect');
    }

    if ((_me$store = me.store) !== null && _me$store !== void 0 && _me$store.count) {
      me.refresh();
    } else {
      classList.add('b-empty');
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element,
      delegate: me.itemSelector,
      mouseover: 'onMouseOver',
      click: 'onClick',
      thisObj: me
    });
  }

  doDestroy() {
    var _this$navigator;

    this.detachListeners('store');
    (_this$navigator = this.navigator) === null || _this$navigator === void 0 ? void 0 : _this$navigator.destroy();
    super.doDestroy();
  }

  onFocusIn(e) {
    const listItem = e._target.classList.contains(this.itemCls) ? e._target.dataset.id : 0;
    this.restoreActiveItem(this.navigator.previousActiveItem || this.getItem(listItem));
    super.onFocusIn(e);
  }

  contentTpl() {
    const me = this,
          allRecordsTpl = me.store.records.map((record, i) => me.itemWrapperTpl(record, i));

    if (me.multiSelect && me.selectAllItem !== false) {
      allRecordsTpl.unshift(me.selectAllItemTpl());
    }

    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].tpl`${allRecordsTpl}`;
  }

  itemWrapperTpl(record, i) {
    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].tpl`<div class="${this.getItemClasses(record, i)}" data-index="${i}" data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(record.id)}" ${this.itemsFocusable ? 'tabindex="-1"' : ''}>
            ${this.itemContentTpl(record, i)}</div>`;
  }

  itemContentTpl(record, i) {
    if ('groupRowFor' in record.meta) {
      return this.groupHeaderTpl(record, _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].capitalize(record.groupChildren[0][record.meta.groupField]));
    }

    return `${this.itemIconTpl(record, i)}${this.itemTpl(record, i)}`;
  }

  itemIconTpl(record, i) {
    return this.multiSelect ? `<div class="b-selected-icon b-icon ${this.selectIconCls}"></div>` : '';
  }

  selectAllItemTpl() {
    return `<div class="${this.itemCls} b-select-all-item" data-noselect data-select-all data-id="select-all">${this.itemIconTpl()}<div>${this.optionalL('Select All')}</div></div>`;
  }

  getItemClasses(record) {
    var _me$_navigator;

    const me = this,
          activeItem = (_me$_navigator = me._navigator) === null || _me$_navigator === void 0 ? void 0 : _me$_navigator.activeItem,
          isActive = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dataset.id) == record.id,
          groupHeaderCls = 'groupRowFor' in record.meta ? 'b-list-item-group-header' : '',
          isSelected = me.selected.includes(record);
    return `${me.itemCls} ${record.cls || ''} ${isSelected ? me.selectedCls : ''} ${isActive ? me.navigator.focusCls : ''} ${groupHeaderCls}`;
  }

  onBeforeStoreLoad() {
    this.mask(this.L('L{loading}'));
  }

  onAfterStoreRequest() {
    this.unmask();
  }

  onStoreChange({
    source: store,
    action,
    records,
    record,
    changes
  }) {
    const me = this;

    switch (action) {
      // Our refresh listener will pick this up
      case 'dataset':
        return;

      case 'remove':
        me.selected.remove(records);
        break;

      case 'clear':
        me.selected.clear();
        break;

      case 'update':
        {
          const {
            id
          } = changes; // update elements data-id when changing id, to allow refreshItem to find correct element

          if (id) {
            _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setAttributes(me.contentElement.querySelector(`[data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(id.oldValue)}"]`), {
              'data-id': id.value
            });
          }

          me.refreshItem(record);
          return;
        }
    }

    me.refresh();
  }

  onStoreRefresh() {
    this.refresh();
  }

  refresh() {
    const me = this;

    if (me.isVisible) {
      const {
        activeItem
      } = me.navigator; // Ensure that the next call to refresh when not visible queues a refresh

      me.paintListener = null; // IMPORTANT! DO NOT INLINE!
      // This is a fix for issue: https://github.com/bryntum/support/issues/2171
      // Long story short: DomHelper returns document-fragment and first time we insert node, nothing is actually
      // inserted if (and only) fragment is not stored as a variable.

      const node = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElementFromTemplate(me.contentTpl(), {
        fragment: true
      });
      me.clearItems().insertNode(node); // The item elements will be all new, so restore the active item.
      // Navigator will reacquire it by its id.

      if (activeItem) {
        me.restoreActiveItem(activeItem);
      }

      me.refreshCount = (me.refreshCount || 0) + 1;
      me.element.classList[me.store.count > 0 ? 'remove' : 'add']('b-empty');
    } // Only queue a refresh if not already queued
    else if (!me.paintListener) {
      me.paintListener = me.on({
        paint: 'refresh',
        thisObj: me,
        once: true
      });
    }
  }

  clearItems() {
    const me = this,
          firstItem = me.contentElement.querySelector(me.itemSelector),
          lastChild = me.contentElement.lastChild;

    if (firstItem) {
      // Can't use :last-of-type when other elements of same type may be present.
      // Have to pluck the last element of the NodeList.
      const items = me.contentElement.querySelectorAll(`${me.itemSelector}:not(.b-mask)`);
      itemRange.setStartBefore(firstItem);
      itemRange.setEndAfter(items[items.length - 1]);
      itemRange.deleteContents();
    } else {
      // Allow a static set of elements to be at the top of the list
      if (lastChild) {
        itemRange.setStartAfter(lastChild);
        itemRange.setEndAfter(lastChild);
      } else {
        itemRange.setStart(me.contentElement, 0);
        itemRange.setEnd(me.contentElement, 0);
      }
    }

    return itemRange;
  }

  refreshItem(...records) {
    for (const record of records) {
      const item = this.getItem(record); // Maybe a record which is filtered out announces a change.
      // There will be no item.

      if (item) {
        const index = this.store.indexOf(record),
              newItem = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElementFromTemplate(this.itemWrapperTpl(record, index));
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(newItem, item);
      }
    }
  }

  getItem(recordOrId) {
    // Cannot use truthiness test because index zero may be passed.
    if (recordOrId != null) {
      var _recordOrId;

      if (typeof recordOrId === 'number') {
        return this.contentElement.querySelector(`[data-index="${recordOrId}"]`);
      } else if (recordOrId.nodeType === Element.ELEMENT_NODE) {
        recordOrId = recordOrId.dataset.id;
      } // TODO: make navigator works for select all list item


      if (((_recordOrId = recordOrId) === null || _recordOrId === void 0 ? void 0 : _recordOrId.id) != null) {
        recordOrId = recordOrId.id;
      }

      return this.contentElement.querySelector(`[data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(recordOrId)}"]`);
    }
  }

  getRecord(dom) {
    if (dom.target) {
      dom = dom.target;
    }

    dom = dom.closest(this.itemSelector);
    return this.store.getAt(parseInt(dom.dataset.index));
  } //region getters/setters

  /**
   * May be *set* as an array of Objects which are converted into records and used to create this
   * List's {@link #config-store}
   * @member {Object[]} items
   */


  updateItems(items) {
    const me = this;

    if (me.store && me.store.autoCreated) {
      me.store.destroy();
    }

    me.store = _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStore(items);
  }

  updateSelected(selected) {
    if (!(selected && selected instanceof _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
      selected = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__["default"](selected);
    }

    this._selected = selected;
    selected.on({
      change: 'onSelectionChange',
      thisObj: this
    });
  }

  get itemSelector() {
    return `.${this.itemCls}`;
  }
  /**
   * Get the collection of selected records
   * @property {Core.util.Collection}
   * @readonly
   */


  get selected() {
    return this._selected;
  }
  /**
   * Get the backing store, a {@link Core.data.Store} holding the records used to generate list items
   * @property {Core.data.Store}
   * @readonly
   */


  get store() {
    // Ensure any configured items is processed into a store before we try to return it.
    this._thisIsAUsedExpression(this.items);

    return this._store;
  }

  changeStore(store) {
    const me = this;

    if (!(store instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"])) {
      store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"](store);
    }

    me.detachListeners('store');

    if (store) {
      const storeListeners = {
        name: 'store',
        change: 'onStoreChange',
        refresh: 'onStoreRefresh',
        thisObj: me
      };

      if (store.readUrl) {
        storeListeners.beforeLoad = 'onBeforeStoreLoad';
        storeListeners.afterRequest = 'onAfterStoreRequest';
      }

      if (store.isGrouped) {
        me.element.classList.add('b-grouped');
        storeListeners.groupchange = 'onStoreRefresh';
      }

      store.on(storeListeners);
    }

    return store;
  }

  updateStore() {
    this.refresh();
  }

  changeNavigator(navigator) {
    const me = this,
          {
      element
    } = me;

    if (element) {
      navigator = (navigator.class || _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__["default"]).new({
        ownerCmp: me,
        target: element,
        keyEventTarget: element
      }, navigator); // This widget is responsible for relaying keyboard events into the navigator
      // So it must be able to receive focus.

      if (navigator.keyEventTarget === element) {
        element.tabIndex = 0;
      }
    }

    return navigator;
  }

  get minAlignHeight() {
    const lastItem = this.element.lastElementChild,
          minHeight = this.minHeight; // No minHeight specified, always defer to the items height

    if (minHeight != null) {
      return this.store.count ? Math.min(lastItem.offsetTop + lastItem.offsetHeight, minHeight) : 0;
    }
  } //endregion
  //region Hide/Show


  alignTo(...args) {
    // When aligning, if the items total height is less than minHeight, use that.
    super.minHeight = this.minAlignHeight;
    super.alignTo(...args);
  }

  hide(...args) {
    this.navigator.activeItem = null;
    return super.hide(...args);
  }

  show() {
    const {
      refreshCount
    } = this,
          {
      previousActiveItem
    } = this.navigator; // Restore the configured minHeight

    super.minHeight = this._minHeight;
    const retVal = super.show(); // If no refresh on paint took place, we need to restore the activeItem.
    // Refresh does that itself.

    if (this.refreshCount === refreshCount) {
      this.restoreActiveItem(previousActiveItem, true);
    }

    return retVal;
  }
  /**
   * Sets the passed record as the current focused record for keyboard navigation and selection purposes.
   * @param {Core.data.Model} activeItem The item to highlight as the active ("focused") item.
   * @param {String|Boolean} [block='nearest'] The block scroll specification to scroll
   * the item into view. Defaults to `'nearest'` which means a minimal scroll, only if
   * the item is actually out of view. Passing `true` is for when the List is aligned
   * to a picker and the selected item should be scrolled to be close to the picker,
   * however that is aligned. See `Combo.showPicker` for usage.
   * @internal
   */


  restoreActiveItem(activeItem = this.navigator.previousActiveItem, block = 'nearest') {
    const me = this,
          {
      navigator,
      lastAlignSpec
    } = me; // Zero may be passed to select first item, so cannot use truthiness.
    // This won't mean *clear* the active item if any. Falsy means
    // nothing to restore so leave it as is.

    if (activeItem != null) {
      if (typeof block !== 'string') {
        const alignZone = lastAlignSpec ? lastAlignSpec.zone : 1; // Scroll item into view appropriately, meaning closest to any align target.
        // Align zones are T,R,B,L => 0,1,2,3
        // If 1 or 3 (right or left), align nearest.
        // if 0 (above) align end.
        // else, we're below so align start.

        block = alignZone & 1 ? 'nearest' : alignZone ? 'start' : 'end';
      }

      activeItem = me.getItem(activeItem);

      if (activeItem) {
        // If we are aligned to a target, first, scroll the required item to the optimal
        // position to avoid Navigator's default minimal scroll to block: 'nearest'.
        // If we are aligned below a combo, move the point of interest to the top.
        // If we are aligned above a combo, move the point of interest to the bottom.
        me.scrollable.scrollIntoView(activeItem, {
          block
        });
        navigator.activeItem = activeItem;
      }
    }
  } //endregion
  //region Events

  /**
   * Focuses list items on hover.
   * @private
   */


  onMouseOver(event) {
    const me = this,
          itemElement = event.currentTarget; // Activate soon in case they're moving fast over items.

    if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && itemElement && me.navigator && me.activateOnMouseover) {
      me.setTimeout({
        fn: 'handleMouseOver',
        delay: 30,
        args: [itemElement],
        cancelOutstanding: true
      });
    }
  }

  handleMouseOver(itemElement) {
    this.navigator.activeItem = itemElement;
  }
  /**
   * Selects list items on click.
   * @private
   */


  onClick(event) {
    const itemElement = event.target.closest(this.itemSelector);

    if (itemElement) {
      this.onItemClick(itemElement, event);
    }
  }
  /**
   * Key events which are not navigation are delegated up to here by the Navigator
   * @private
   */


  onInternalKeyDown(event) {
    const me = this,
          active = me.navigator.activeItem;

    switch (event.key) {
      case ' ':
        // If it's an input field that's providing events, allow it to process space.
        // Otherwise, it falls through and is processed the same as ENTER to make a click.
        if (event.target.nodeName.toUpperCase() === 'INPUT' && !event.target.readOnly) {
          break; // eslint-disable-line
        }

      case 'Enter':
        // eslint-disable-line
        if (active) {
          this.onItemClick(active, event); // Stop the keydown from bubbling.
          // And stop it from creating a keypress event.
          // No further action should be taken after item selection.

          event.stopImmediatePropagation();
          event.preventDefault();
        }

    }
  } //endregion


  onItemClick(item, event) {
    const me = this,
          index = parseInt(item.dataset.index);
    let record = me.store.getAt(index);
    me._isUserAction = true;

    if (me.allowGroupSelect || record && !record.isSpecialRow) {
      // Clicking on any element with the data-noselect attribute means no selection
      if (!item.contains(event.target.closest('[data-noselect]'))) {
        const selected = me.selected;
        let isSelected = selected.includes(record);

        if (me.multiSelect) {
          if (me.toggleAllIfCtrlPressed && event.ctrlKey) {
            record = me.store.getRange();
          } else if (me.allowGroupSelect && record.isSpecialRow) {
            isSelected = !record.groupChildren.some(rec => !selected.includes(rec));
            record = record.groupChildren;
          }

          selected[isSelected ? 'remove' : 'add'](record);
        } else {
          selected.splice(0, selected.count, record);
        }
      } else if (item.contains(event.target.closest('[data-select-all]'))) {
        me.onSelectAllClick(item, event);
      }
    }

    me.lastClicked = record;
    me.trigger('item', {
      item,
      record,
      index,
      event,
      userAction: true
    });
    me._isUserAction = false;
  }
  /**
   * Handles items being added or removed from the selected Collection
   * @param {Object} changeEvent
   * @private
   */


  onSelectionChange({
    action,
    removed,
    added,
    replaced
  }) {
    const me = this,
          {
      selectedCls,
      unselectedCls
    } = me;
    let record, item;

    if (action === 'clear') {
      for (item of me.element.querySelectorAll(`.${selectedCls}`)) {
        item.classList.remove(selectedCls);
        unselectedCls && item.classList.remove(unselectedCls);
      }
    } else {
      for (record of removed) {
        item = me.getItem(record);
        item && item.classList.remove(selectedCls);
      }

      for (record of added) {
        item = me.getItem(record);
        item && item.classList.add(selectedCls);
      }
    }

    me.selectAllItem && me.updateSelectAllState();
  }

  onSelectAllClick(item, event) {
    const me = this,
          checked = item.classList.contains(me.selectedCls);
    me.selected[checked ? 'remove' : 'add'](me.store.getRange());
  }

  updateSelectAllState() {
    const me = this,
          selectAllEl = me.element.querySelector('.b-select-all-item'),
          allRecordsSelected = me.selected.count === me.store.count,
          action = allRecordsSelected ? 'add' : 'remove';
    selectAllEl.classList[action](me.selectedCls);
  }

} // Register this widget type with its Factory

List.initClass();
List.prototype.navigatorClass = _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__["default"];
List._$name = 'List';

/***/ }),

/***/ "./lib/Core/widget/Mask.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Mask.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Mask; });
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Renderable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Renderable.js */ "./lib/Core/widget/Renderable.js");
var productName = 'gantt';




 //TODO: add loader

/**
 * @module Core/widget/Mask
 */

/**
 * Masks a target element (document.body if none is specified). Call static methods for ease of use or make instance
 * for reusability.
 *
 * @example
 * Mask.mask('hello');
 * Mask.unmask();
 *
 * @inlineexample Core/widget/Mask.js
 *
  * @example
 * // Using progress by calling static method
 * let mask = Mask.mask({
 *   text:'The task is in progress',
 *   progress: 0,
 *   maxProgress: 100
 * }, document.body);
 * let timer = setInterval(()=>{
 *   mask.progress += 5;
 *   if(mask.progress >= mask.maxProgress) {
 *     Mask.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 * @example
 * // Using progress to mask a Bryntum component
 * scheduler.mask({
 *  text:'Loading in progress',
 *   progress: 0,
 *   maxProgress: 100
 * })
 * let timer = setInterval(()=>{
 *   scheduler.masked.progress += 5;
 *   if(scheduler.masked.progress >= scheduler.masked.maxProgress) {
 *     scheduler.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 */

class Mask extends _Renderable_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  //region Config
  static get $name() {
    return 'Mask';
  } // Factoryable type name


  static get type() {
    return 'mask';
  }

  static get configurable() {
    return {
      /**
       * Set this config to trigger an automatic close after the desired delay:
       * ```
       *  mask.autoClose = 2000;
       * ```
       * If the mask has an `owner`, its `onMaskAutoClosing` method is called when the close starts and its
       * `onMaskAutoClose` method is called when the close finishes.
       * @config {Number}
       * @private
       */
      autoClose: null,

      /**
       * The portion of the {@link #config-target} element to be covered by this mask. By default, the mask fully
       * covers the `target`. In some cases, however, it may be desired to only cover the `'body'` (for example,
       * in a grid).
       *
       * This config is set in conjunction with `owner` which implements the method `syncMaskCover`.
       *
       * @config {String}
       * @private
       */
      cover: null,

      /**
       * The icon to show next to the text. Defaults to showing a spinner
       * @config {String}
       * @default
       */
      icon: 'b-icon b-icon-spinner',
      errorDefaults: {
        icon: 'b-icon b-icon-warning',
        autoClose: 3000,
        showDelay: 0
      },

      /**
       * The maximum value of the progress indicator
       * @property {Number}
       */
      maxProgress: null,

      /**
       * Mode: bright, bright-blur, dark or dark-blur
       * @config {String}
       * @default
       */
      mode: 'dark',

      /**
       * Number expressing the progress
       * @property {Number}
       */
      progress: null,
      // The owner is involved in the following features:
      //
      // - The `autoClose` timer calls `onMaskAutoClose`.
      // - The `cover` config calls `syncMaskCover`.
      // - If the `target` is a string, that string names the property of the `owner` that holds the
      //   `HTMLElement` reference.

      /**
       * The owning widget of this mask. This is required if `target` is a string.
       *
       * @config {Object|Core.widget.Widget}
       */
      owner: null,

      /**
       * The element to be masked. If this config is a string, that string is the name of the property of the
       * `owner` that holds the `HTMLElement` that is the actual target of the mask.
       *
       * NOTE: In prior releases, this used to be specified as the `element` config, but that is now, as with
       * `Widget`, the primary element of the mask.
       *
       * @config {String|HTMLElement}
       */
      target: null,

      /**
       * The text (or HTML) to show in mask
       * @config {String}
       */
      text: null,
      // TODO - perhaps a better way to deal w/multiple reasons to mask something would be a mask FIFO behind
      //  the scenes so that only one mask is visible at a time. That would take a bit of tinkering in the
      //  hide/show mechanism but feels like a more natural way to go. In which case, this config would go away
      //  and multiple masks would simply cooperate. https://github.com/bryntum/support/issues/190
      // This property is used to block trial mask removal
      // https://github.com/bryntum/support/issues/2604
      type: null,

      /**
       * The number of milliseconds to delay before making the mask visible. If set, the mask will have an
       * initial `opacity` of 0 but will function in all other ways as a normal mask. Setting this delay can
       * reduce flicker in cases where load operations are typically short (for example, a second or less).
       *
       * @config {Number}
       */
      showDelay: null,
      useTransition: false
    };
  }

  static get delayable() {
    return {
      deferredClose: 0,
      delayedShow: 0
    };
  } //endregion
  //region Init


  construct(config) {
    if (config) {
      let el = config.element,
          cfg; // Upgrade config -> cfg
      // Treat config as readonly, cfg is lazily copied and writable

      if (el) {
        _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Core', '4.0.0', 'Mask "element" config has been renamed to "target"');
        config = cfg = Object.assign({}, config);
        delete cfg.element;
        cfg.target = el;
      }

      el = config.target;

      if (typeof el === 'string') {
        config = cfg = cfg || Object.assign({}, config);
        cfg.target = config.owner[el]; // must supply "owner" in this case
      }
    }

    super.construct(config);

    if (!this.target) {
      this.target = document.body;
    }

    this.show();
  }

  doDestroy() {
    const me = this,
          {
      element
    } = me; // Do not destroy a trial mask

    if (me.type === 'trial') {
      return false;
    }

    if (element) {
      me.element = null;

      if (me.mode.endsWith('blur')) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(element, child => {
          child.classList.remove(`b-masked-${me.mode}`);
        });
      }

      me.target.classList.remove('b-masked');
      me.target[me.maskName] = null;
    }

    super.doDestroy();
  }

  get maskElement() {
    // TODO log on use of deprecated property?
    return this.element;
  }

  get maskName() {
    const type = this.type;
    return `mask${typeof type === 'string' ? type.trim() : ''}`;
  }

  set error(value) {
    this.setConfig(this.errorDefaults);
    this.text = value;
  }

  renderDom() {
    const me = this,
          {
      maxProgress
    } = me;
    return {
      class: {
        'b-mask': 1,
        'b-delayed-show': me.showDelay,
        'b-widget': 1,
        [`b-mask-${me.mode}`]: 1,
        'b-progress': maxProgress,
        'b-prevent-transitions': !me.useTransition
      },
      children: [{
        reference: 'maskContent',
        class: 'b-mask-content b-drawable',
        children: [maxProgress ? {
          reference: 'progressElement',
          class: 'b-mask-progress-bar',
          style: {
            width: `${Math.max(0, Math.min(100, Math.round(me.progress / maxProgress * 100)))}%`
          }
        } : null, {
          reference: 'maskText',
          class: 'b-mask-text',
          html: (me.icon ? `<i class="b-mask-icon ${me.icon}"></i>` : '') + me.text
        }]
      }]
    };
  } //endregion
  //region Static


  static mergeConfigs(...sources) {
    const ret = {};

    for (const src of sources) {
      if (typeof src === 'string') {
        ret.text = src;
      } else {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(ret, src); // not Object.assign!
      }
    }

    return ret;
  }
  /**
   * Shows a mask with the specified message
   * @param {String|Object} text Message
   * @param {HTMLElement} target The element to mask
   * @returns {Core.widget.Mask}
   */


  static mask(text, target = document.body) {
    return new Mask(typeof text !== 'string' ? Object.assign({
      target
    }, text) : {
      target,
      text
    });
  }
  /**
   * Unmask
   * @param {HTMLElement} element Element to unmask
   * @returns {Promise} A promise which is resolved when the mask is gone
   */


  static unmask(element = document.body) {
    return element.mask && element.mask.close();
  } //endregion
  //region Config


  updateAutoClose(delay) {
    const me = this;
    me.deferredClose.cancel();

    if (delay) {
      me.deferredClose.delay = delay;
      me.deferredClose();
    }
  }

  updateCover() {
    const owner = this.owner;

    if (owner && owner.syncMaskCover) {
      owner.syncMaskCover(this);
    }
  }

  updateShowDelay(delay) {
    const delayedShow = this.delayedShow;
    delayedShow.delay = delay;

    if (!delay) {
      delayedShow.flush();
    }
  } //endregion
  //region Show & hide


  deferredClose() {
    const owner = this.owner;
    this.close().then(() => {
      if (owner && owner.onMaskAutoClose) {
        owner.onMaskAutoClose(this);
      }
    });

    if (owner && owner.onMaskAutoClosing) {
      owner.onMaskAutoClosing(this);
    }
  }

  delayedShow() {
    this.classes.remove('b-delayed-show');
  }
  /**
   * Show mask
   */


  show() {
    const me = this,
          {
      element,
      target,
      hiding,
      maskName
    } = me; // We don't do this because we may want to show but automatically close after a
    // brief delay. The order of applying those configs should not be an issue. In
    // other words, to stop the deferredClose, you must set autoClose to falsy.
    // me.deferredClose.cancel();

    if (hiding) {
      // Resolving seems much better than the only other options:
      //  1. Never settling
      //  2. Rejecting
      hiding.resolve(); // This will be nulled out as the promise resolves but that is a race condition
      // compared to the next hide() call.

      me.hiding = null;
      me.clearTimeout('hide');
    }

    if (me.showDelay) {
      element.classList.add('b-delayed-show');
      me.delayedShow();
    }

    element.classList.add('b-visible');
    element.classList.remove('b-hidden');
    target.classList.add('b-masked');

    if (!target[maskName]) {
      target[maskName] = me;
      target.appendChild(element);
    }

    me.shown = true;
    me.trigger('show'); // blur has to blur child elements

    if (me.mode.endsWith('blur')) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(target, child => {
        if (child !== element) {
          child.classList.add(`b-masked-${me.mode}`);
        }
      });
    }
  }
  /**
   * Hide mask
   * @returns {Promise} A promise which is resolved when the mask is hidden, or immediately if already hidden
   */


  hide() {
    const me = this,
          {
      target,
      element
    } = me;
    let hiding = me.hiding;

    if (!hiding) {
      if (!me.shown) {
        return Promise.resolve();
      }

      me.hiding = hiding = new _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
      me.shown = false;
      element.classList.remove('b-visible');
      element.classList.add('b-hidden');
      target.classList.remove('b-masked');

      if (me.mode.endsWith('blur')) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(target, child => {
          if (child !== element) {
            child.classList.remove(`b-masked-${me.mode}`);
          }
        });
      }

      hiding.promise = hiding.promise.then(() => {
        if (me.hiding === hiding) {
          me.hiding = null;
        }
      }); // TODO: use AnimationHelper when available

      me.setTimeout(() => hiding.resolve(), 500, 'hide');
    }

    return hiding.promise;
  }
  /**
   * Close mask (removes it)
   * @returns {Promise} A promise which is resolved when the mask is closed
   */


  close() {
    return this.hide().then(() => {
      this.destroy();
    });
  } //endregion


}
Mask._$name = 'Mask';

/***/ }),

/***/ "./lib/Core/widget/Menu.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Menu.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Menu; });
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'gantt';





const validKeys = {
  ArrowUp: 1,
  ArrowDown: 1,
  ArrowRight: 1,
  ArrowLeft: 1,
  Enter: 1,
  Escape: 1
};
/**
 * @module Core/widget/Menu
 */

/**
 * Menu widget, displays a list of items which the user can select from using mouse or keyboard. Can have submenus.
 *
 * @example
 * let menu = new Menu({
 *     forElement : btn.element,
 *     items      : [
 *         {
 *             icon : 'b-icon b-icon-add',
 *             text : 'Add'
 *         },
 *         {
 *             icon : 'b-icon b-icon-trash',
 *             text : 'Remove'
 *         },
 *         {
 *             icon     : 'b-icon b-icon-lock',
 *             disabled : true,
 *             text     : 'I am disabled'
 *         },
 *         {
 *             text : 'Sub menu',
 *             menu : [{
 *                 icon : 'b-icon b-fa-play',
 *                 text : 'Play'
 *             }]
 *         }
 *     ],
 *     // Method is called for all ancestor levels
 *     onItem({ item }) {
 *         Toast.show('You clicked ' + item.text);
 *     }
 * });
 *
 * @classType menu
 * @inlineexample Core/widget/Menu.js
 *
 * @extends Core/widget/Popup
 */

class Menu extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Menu';
  } // Factoryable type name


  static get type() {
    return 'menu';
  }

  static get configurable() {
    return {
      focusable: true,
      align: 't-b',
      scrollAction: 'hide',

      /**
       * Specify false to prevent the menu from getting focus when hovering items
       * @default
       * @config {Boolean}
       */
      focusOnHover: null,
      // We do need a Scroller so that we can use its API to scroll around.
      // But the overflow flags default to false.
      scrollable: false,
      defaultType: 'menuitem',
      tools: {
        // To get rid of the close tool from Popup
        close: false
      }
    };
  }
  /**
   * Currently open sub menu, if any
   * @member {Core.widget.Menu} currentSubMenu
   * @readonly
   */
  //endregion

  /**
   * A descendant menu item has been activated.
   *
   * Note that this event bubbles up through parents and can be
   * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
   * @event item
   * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
   * @param {Core.widget.Menu} menu - Menu containing the menu item
   */

  /**
   * The checked state of a descendant menu item has changed.
   *
   * Note that this event bubbles up through parents and can be
   * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
   * @event toggle
   * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
   * @param {Core.widget.Menu} menu - Menu containing the menu item
   * @param {Boolean} checked - The _new_ checked state.
   */

  /* break doc comment */
  //region Init


  construct(config) {
    if (Array.isArray(config)) {
      config = {
        lazyItems: config
      };
    }

    super.construct(config);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: this.element,
      click: 'onMouseClick',
      mouseover: 'onMouseOver',
      mouseleave: 'onMouseLeave',
      thisObj: this
    });
  }

  afterShow(resolveFn) {
    // Don't instantiate all our items' subMenus right now.
    // Use our private _menu property which will still be a config item.
    const me = this,
          hasSubmenu = me.items.some(item => Boolean(item._menu)); // afterShow is called before alignment, so this is the correct time
    // to mutate things which will change this Widget's size.

    if (hasSubmenu) {
      me.element.classList.add('b-menu-with-submenu');
    } // Add CSS class to menu if any item has an icon, to allow aligning icon-less items


    const hasIcon = me.items.some(item => item.icon);

    if (hasIcon) {
      me.element.classList.add('b-menu-with-icon');
    }

    super.afterShow(resolveFn);
  }

  createWidget(item) {
    if (typeof item === 'string') {
      item = {
        text: item
      };
    }

    return super.createWidget(item);
  }

  get focusElement() {
    var _me$parentMenu;

    const me = this,
          fromParentMenu = (_me$parentMenu = me.parentMenu) === null || _me$parentMenu === void 0 ? void 0 : _me$parentMenu.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me.parentMenu)),
          firstWidget = me.items[0];

    if (fromParentMenu || !(firstWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      return super.focusElement;
    }

    return me.element;
  } //endregion


  onDocumentMouseDown({
    event
  }) {
    // It's not a click outside if its a click on our owner Menu
    if (!this.parentMenu || !this.parentMenu.owns(event.target)) {
      return super.onDocumentMouseDown(...arguments);
    }
  } //region Show


  hide(animate) {
    const me = this; // We need to be _hidden when any focused descendants try to revertFocus
    // so that they continue to fall back through the getFocusRevertTarget upward chain.

    super.hide(animate);

    if (!me.isVisible) {
      var _me$currentSubMenu, _me$currentSubMenu$hi;

      // Will have no hide method if destroyed
      (_me$currentSubMenu = me.currentSubMenu) === null || _me$currentSubMenu === void 0 ? void 0 : (_me$currentSubMenu$hi = _me$currentSubMenu.hide) === null || _me$currentSubMenu$hi === void 0 ? void 0 : _me$currentSubMenu$hi.call(_me$currentSubMenu, animate);

      if (me.parentMenu) {
        me.parentMenu.currentSubMenu = null;
      }
    }
  }

  show() {
    super.show(...arguments);
    const {
      parentMenu
    } = this;

    if (this.isVisible && parentMenu) {
      parentMenu.currentSubMenu = this;
    }
  } //endregion
  //region Events

  /**
   * Activates a menu item if user clicks on it
   * @private
   */


  onMouseClick(event) {
    const menuItem = event.target.closest('.b-menuitem');

    if (menuItem) {
      this.triggerElement(menuItem, event); // IE / Edge still triggers event listeners that were removed in a listener - prevent this

      event.stopImmediatePropagation();
    }
  }
  /**
   * Activates menu items on hover. On real mouse hover, not on a touchstart.
   * @private
   */


  onMouseOver(event) {
    if (this.focusOnHover !== false) {
      const fromItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.relatedTarget, '.b-widget'),
            toItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, '.b-widget'),
            overItem = _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(toItemElement); // Activate soon in case they're moving fast over items.

      if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTouchEvent && toItemElement && toItemElement !== fromItemElement && overItem.parent === this) {
        this.setTimeout({
          fn: 'handleMouseOver',
          delay: 30,
          args: [overItem],
          cancelOutstanding: true
        });
      }
    }
  }

  handleMouseOver(overItem) {
    overItem.focus();
  } // unselect any menu item if mouse leaves the menu element (unless it enters a child menu)


  onMouseLeave(event) {
    const me = this,
          {
      relatedTarget
    } = event,
          leavingToChild = relatedTarget && me.owns(relatedTarget);
    let targetCmp = relatedTarget && relatedTarget instanceof HTMLElement && _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(relatedTarget),
        shouldHideMenu = !leavingToChild;

    if (targetCmp) {
      while (targetCmp.ownerCmp) {
        targetCmp = targetCmp.ownerCmp;
      } // Or was found and does not belong to current menu DOM tree
      // This condition will not allow possibly existing picker to hide
      // Covered by Menu.t.js


      shouldHideMenu &= !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getAncestor(targetCmp.element, [event.target]);
    }

    if (!leavingToChild && shouldHideMenu) {
      var _me$currentSubMenu2;

      (_me$currentSubMenu2 = me.currentSubMenu) === null || _me$currentSubMenu2 === void 0 ? void 0 : _me$currentSubMenu2.hide(); // Deactivate currently active *menu items* on mouseleave

      if (me.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me)) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me).matches('.b-menuitem')) {
        me.focusElement.focus();
      }
    }
  }
  /**
   * Keyboard navigation. Up/down, close with esc, activate with enter
   * @private
   */


  onInternalKeyDown(event) {
    const sourceWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(event),
          isFromWidget = sourceWidget && sourceWidget !== this && !(sourceWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__["default"]);

    if (event.key === 'Escape') {
      // Only close this menu if the ESC was in a child input Widget
      (isFromWidget ? this : this.rootMenu).close();
      return;
    }

    super.onInternalKeyDown(event); // Do not process keys from certain elements

    if (isFromWidget) {
      return;
    }

    if (validKeys[event.key]) {
      event.preventDefault();
    }

    const el = this.element,
          active = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(el);
    this.navigateFrom(active !== el && el.contains(active) ? active : null, event.key, event);
  }

  navigateFrom(active, key, event) {
    const me = this,
          treeWalker = me.treeWalker,
          item = active && me.getItem(active);
    let toActivate;

    switch (key) {
      case 'ArrowUp':
        treeWalker.currentNode = active || (active = me.bottomFocusTrap);
        treeWalker.previousNode();
        toActivate = treeWalker.currentNode;
        break;

      case 'ArrowDown':
        treeWalker.currentNode = active || (active = me.topFocusTrap);
        treeWalker.nextNode();
        toActivate = treeWalker.currentNode;
        break;

      case ' ':
        if (active && !active.classList.contains('b-disabled')) {
          if (item && item.menu) {
            me.openSubMenu(active, item);
          } else {
            me.triggerElement(active, event);
          }
        }

        break;

      case 'ArrowRight':
        if (active && item && item.menu && !active.classList.contains('b-disabled')) {
          // opening with arrow keys highlights first item (as in menus on mac)
          const openedMenu = me.openSubMenu(active, item); // If show hs not been vetoed, ask it to focus.
          // Container will delegate focus inward if possible.

          if (openedMenu) {
            openedMenu.focus();
          }
        } else {
          treeWalker.currentNode = active || (active = me.topFocusTrap);
          treeWalker.nextNode();
          toActivate = treeWalker.currentNode;
        }

        break;

      case 'ArrowLeft':
        if (me.isSubMenu) {
          me.hide();
        } else if (!active) {
          treeWalker.currentNode = active || (active = me.topFocusTrap);
          treeWalker.nextNode();
          toActivate = treeWalker.currentNode;
        }

        break;

      case 'Enter':
        if (active && !active.classList.contains('b-disabled')) {
          me.triggerElement(active, event);
        }

        break;
    } // Move focus to wherever we have calculated


    if (toActivate) {
      // Previous moved to encapsulating element; wrap from end
      if (toActivate === me.element) {
        me.navigateFrom(me.bottomFocusTrap, 'ArrowUp', event);
      } // Next could not move because we're at the end; wrap from top
      else if (toActivate === active) {
        me.navigateFrom(me.topFocusTrap, 'ArrowDown', event);
      } else {
        toActivate.focus();
      }
    }
  } //endregion
  //region Activate menu item


  getItem(item) {
    // Cannot use truthiness test because index zero may be passed.
    if (item != null) {
      // Access by index
      if (typeof item === 'number') {
        return this.items[item];
      } // Access by element


      if (item.nodeType === Element.ELEMENT_NODE) {
        return _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(item, 'menuitem', this.contentElement);
      } // Access by id


      return this.items.find(c => c.id == item);
    }
  }
  /**
   * Activate a menu item (from its element)
   * @private
   * @fires item
   * @param menuItemElement
   */


  triggerElement(menuItemElement, event) {
    const item = this.getItem(menuItemElement); // If the trigger gesture happened on a non-MenuItem
    // item will be undefined. Do not action on a non-MenuItem
    // or a disabled MenuItem

    if (item && !item.disabled) {
      item.doAction(event);
    }
  }
  /**
   * Returns true if this menu is a sub menu.
   * To find out which menu is the parent, check {@link #property-parentMenu}.
   * @type {Boolean}
   * @readonly
   */


  get isSubMenu() {
    var _this$owner;

    return this === ((_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.menu);
  }
  /**
   * Opens a submenu anchored to a menu item
   * @private
   * @param element
   * @param item
   */


  openSubMenu(element, item) {
    const me = this,
          subMenu = item.menu;

    if (subMenu) {
      if (!subMenu.isVisible) {
        const event = {
          item,
          element
        };

        if (me.trigger('beforeSubMenu', event) === false) {
          return;
        }

        if (item.onBeforeSubMenu && item.onBeforeSubMenu(event) === false) {
          return;
        }

        subMenu.show();
      }

      return me.currentSubMenu = subMenu;
    }
  }
  /**
   * Get/set focused menu item.
   * Shows submenu if newly focused item has a menu and is not disabled.
   * @property {HTMLElement}
   */


  set selectedElement(element) {
    const me = this,
          lastSelected = me._selectedElement;

    if (lastSelected) {
      const lastItem = me.getItem(lastSelected),
            lastItemMenu = lastItem && lastItem.menu;

      if (lastItemMenu) {
        lastItemMenu.hide();
      }

      lastSelected.classList.remove('b-active');
    }

    me._selectedElement = element; // might set to null to deselect

    if (element) {
      const doFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(element);
      element.classList.add('b-active');
      me.scrollable.scrollIntoView(element, {
        animate: !doFocus,
        focus: doFocus
      });
    }
  }

  get selectedElement() {
    return this._selectedElement;
  }

  selectFirst() {
    const treeWalker = this.treeWalker;
    treeWalker.currentNode = this.topFocusTrap;
    treeWalker.nextNode(); // If we are under keyboard control, this must happen in the next
    // animation frame so that the keydown event doesn't fire on the
    // newly focused node.

    this.requestAnimationFrame(() => treeWalker.currentNode.focus());
  } //endregion
  //region Close

  /**
   * Gets the parent Menu if this Menu is a submenu, or `undefined`.
   * @property {Core.widget.Menu}
   */


  get parentMenu() {
    var _result$up;

    const result = this.owner;
    return result && (result.isMenu ? result : (_result$up = result.up) === null || _result$up === void 0 ? void 0 : _result$up.call(result, 'menu'));
  }
  /**
   * Gets this menus root menu, the very first menu shown in a sub menu hierarchy
   * @property {Core.widget.Menu}
   * @private
   */


  get rootMenu() {
    let menu = this;

    while (menu.parentMenu && menu.parentMenu instanceof this.constructor) {
      menu = menu.parentMenu;
    }

    return menu;
  } //endregion


} // Register this widget type with its Factory

Menu.initClass();
Menu._$name = 'Menu';

/***/ }),

/***/ "./lib/Core/widget/MenuItem.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/MenuItem.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MenuItem; });
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Menu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';




/**
 * @module Core/widget/MenuItem
 */

const bIcon = /^b-icon-/,
      bFa = /^b-fa-/;
/**
 * A widget representing a single menu item in a {@link Core.widget.Menu}. May be configured with a
 * {@link #config-checked} state which creates a checkbox which may be toggled. Can also be
 * {@link Core.widget.Widget#config-disabled}, which affects item appearance and blocks interactions.
 *
 * Fires events when activated which bubble up through the parent hierarchy
 * and may be listened for on an ancestor. See {@link Core.widget.Menu Menu}
 * for more details on usage.
 *
 * To add a border below a menuitem, you can set the item´s {@link #config-cls} to `b-separator`.
 *
 * @extends Core/widget/Widget
 * @classType menuitem
 */

class MenuItem extends _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'MenuItem';
  } // Factoryable type name


  static get type() {
    return 'menuitem';
  }

  static get configurable() {
    return {
      /**
       * If configured with a `Boolean` value, a checkbox is displayed
       * as the start icon, and the {@link #event-toggle} event is fired
       * when the checked state changes.
       * @config {Boolean}
       */
      checked: null,

      /**
       * Indicates that this menu item is part of a group where only one can be checked. Assigning a value
       * also sets `toggleable` to `true`.
       * ```
       * const yesButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'Yes'
       * });
       *
       * const noButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'No'
       * });
       * ```
       * @config {String}
       */
      toggleGroup: null,

      /**
       * Returns the instantiated menu widget as configured by {@link #config-menu}.
       * @member {Core.widget.Widget} menu
       * @readonly
       */

      /**
       * A submenu configuration object, or an array of MenuItem configuration
       * objects from which to create a submenu.
       *
       * Configuration object example:
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             menu : {
       *                 // Submenu items
       *                 firstItem : {
       *                     text : 'Sub-item 1',
       *                     onItem({ eventRecord }) {}
       *                 },
       *                 secondItem : {
       *                     text : 'Sub-item 2',
       *                     onItem({ eventRecord }) {}
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * Array of items example:
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             // Submenu items
       *             menu : [
       *                 {
       *                     text : 'Sub-item 1',
       *                     onItem({ eventRecord }) {}
       *                 },
       *                 {
       *                     text : 'Sub-item 2',
       *                     onItem({ eventRecord }) {}
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * Note that this does not have to be a Menu. The `type` config can be used to specify any widget as the submenu.
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             // Submenu items
       *             menu : [
       *                 {
       *                     type  : 'textfield',
       *                     label : 'Type here'
       *                 },
       *                 {
       *                     type : 'button',
       *                     text : 'Confirm'
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object|Object[]}
       */
      menu: {
        value: null,
        $config: ['lazy', 'nullify']
      },

      /**
       * Item icon class.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       * @config {String}
       */
      icon: null,

      /**
       * The text to be displayed in the item
       * @config {String} text
       */

      /**
       * By default, upon activate, non-checkbox menu items will collapse
       * the owning menu hierarchy.
       *
       * Configure this as `false` to cause the menu to persist after
       * activating an item
       * @config {Boolean}
       */
      closeParent: null,

      /**
       * If provided, turns the menu item into a link
       * @config {String}
       */
      href: null,

      /**
       * The `target` attribute for the {@link #config-href} config
       * @config {String}
       */
      target: null,
      localizableProperties: ['text']
    };
  }

  compose() {
    const {
      checked,
      href,
      hasMenu,
      target,
      text
    } = this,
          icon = this.icon || (typeof checked === 'boolean' ? 'b-fw-icon' : '');
    return {
      tag: href ? 'a' : 'div',
      tabIndex: -1,
      href,
      target,
      class: {
        'b-has-submenu': hasMenu
      },
      dataset: {
        group: this.toggleGroup
      },
      children: {
        iconElement: icon && {
          tag: 'i',
          class: _objectSpread({
            'b-fa': bFa.test(icon),
            'b-icon': bIcon.test(icon),
            'b-icon-checked': checked === true,
            'b-icon-unchecked': checked === false,
            'b-menuitem-icon': 1
          }, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__["default"].normalize(icon, 'object'))
        },
        textElement: {
          tag: 'span',
          html: text,
          class: {
            'b-menu-text': 1
          }
        },
        subMenuIcon: hasMenu && {
          tag: 'i',
          class: {
            'b-fw-icon': 1,
            'b-icon-sub-menu': 1
          }
        }
      }
    };
  }
  /**
   * Actions this item. Fires the {@link #event-item} event, and if this
   * if a {@link #config-checked} item, toggles the checked state, firing
   * the {@link #event-toggle} event.
   */


  doAction(event) {
    const item = this,
          menu = this.parent,
          itemEvent = {
      menu,
      item,
      element: item.element,
      bubbles: true
    };

    if (typeof item.checked === 'boolean') {
      const newCheckedState = !item.checked; // Do not allow uncheck in a toggleGroup.
      // A toggleGroup means that one member must always be checked.

      if (!item.toggleGroup || newCheckedState) {
        item.checked = !item.checked;
      }
    } // Give internal handlers a chance to inject extra information before
    // user-supplied "item" handlers see the event.
    // Grid's CellMenu feature, HeaderMenu feature and other context menu features do this.


    item.trigger('beforeItem', itemEvent);
    /**
     * This menu item has been activated.
     *
     * Note that this event bubbles up through parents and can be
     * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
     * @event item
     * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
     * @param {Core.widget.Menu} menu - Menu containing the menu item
     */

    item.trigger('item', itemEvent); // Collapse the owning menu hierarchy if configured to do so

    if (item.closeParent && menu) {
      menu.rootMenu.close(); // Don't prevent links doing their thing

      if (event && !item.href) {
        event.preventDefault();
      }
    }
  }

  get focusElement() {
    return this.element;
  }

  get contentElement() {
    return this.textElement;
  }

  get isFocusable() {
    const focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
    // it must have layout - an offsetParent. Body does not have offsetParent.
    // Disabled menu items are focusable but cannot be activated.
    // https://www.w3.org/TR/wai-aria-practices/#h-note-17

    return focusElement && this.isVisible && (focusElement === document.body || focusElement.offsetParent);
  }

  get hasMenu() {
    return this.hasConfig('menu');
  }

  get childItems() {
    const {
      menu
    } = this;
    return menu ? [menu] : [];
  }

  get text() {
    return this.html;
  }

  set text(text) {
    this.html = text;
  }

  onFocusIn(e) {
    super.onFocusIn(e);

    if (!this.disabled && this.menu) {
      this.openMenu();
    }
  }

  onFocusOut(e) {
    super.onFocusOut(e);
    this.closeMenu();
  }

  openMenu(andFocus) {
    const menu = this.menu;

    if (!this.disabled && menu) {
      menu.focusOnToFront = andFocus;
      menu.show();
    }
  }

  closeMenu() {
    if (this._menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      this.menu.close();
    }
  }

  changeToggleGroup(toggleGroup) {
    if (toggleGroup && typeof this.checked !== 'boolean') {
      this.checked = false;
    }

    return toggleGroup;
  }
  /**
   * Get/sets the checked state of this `MenuItem` and fires the {@link #event-toggle}
   * event upon change.
   *
   * Note that this must be configured as a `Boolean` to enable the checkbox UI.
   * @member {Boolean} checked
   */


  changeChecked(checked, old) {
    if (this.isConfiguring || typeof old === 'boolean') {
      return Boolean(checked);
    }
  }

  updateChecked(checked) {
    const me = this;

    if (!me.isConfiguring) {
      if (me.toggleGroup) {
        me.uncheckToggleGroupMembers();
      }
      /**
       * The checked state of this menu item has changed.
       *
       * Note that this event bubbles up through parents and can be listened for on a top level
       * {@link Core.widget.Menu Menu} for convenience.
       * @event toggle
       * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
       * @param {Core.widget.Menu} menu - Menu containing the menu item
       * @param {Boolean} checked - The _new_ checked state.
       */


      me.trigger('toggle', {
        menu: me.owner,
        item: me,
        element: me.element,
        bubbles: true,
        checked
      });
    }
  }

  getToggleGroupMembers() {
    const me = this,
          {
      checked,
      toggleGroup,
      element
    } = me,
          result = [];

    if (checked && toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEachSelector(me.rootElement, `[data-group=${toggleGroup}]`, otherElement => {
        if (otherElement !== element) {
          const partnerCheckItem = _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"].fromElement(otherElement);
          partnerCheckItem && result.push(partnerCheckItem);
        }
      });
    }

    return result;
  }

  uncheckToggleGroupMembers() {
    if (this.checked && this.toggleGroup) {
      this.getToggleGroupMembers().forEach(widget => widget.checked = false);
    }
  }

  get closeParent() {
    const result = typeof this.checked === 'boolean' ? this._closeParent : this._closeParent !== false;
    return result && !this.hasMenu;
  }

  changeMenu(config, existingMenu) {
    const me = this,
          {
      constrainTo,
      scrollAction
    } = me.owner; // This covers both Array and Object which are valid items config formats.
    // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
    // child items or html property in it, it's the main config

    if (config && typeof config === 'object' && !('items' in config) && !('widgets' in config) && !('html' in config)) {
      config = {
        lazyItems: config
      };
    }

    return _Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existingMenu, config, {
      owner: me,
      defaults: {
        type: 'menu',
        align: 'l0-r0',
        anchor: true,
        autoClose: true,
        autoShow: false,
        cls: 'b-sub-menu',
        // Makes the anchor hoverable to avoid mouseleave
        forElement: me.element,
        owner: me,
        constrainTo,
        scrollAction
      }
    });
  }

} // Register this widget type with its Factory

MenuItem.initClass();
MenuItem._$name = 'MenuItem';

/***/ }),

/***/ "./lib/Core/widget/MessageDialog.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/MessageDialog.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';






/**
 * @module Core/widget/MessageDialog
 */

const items = [{
  ref: 'cancelButton',
  cls: 'b-messagedialog-cancelbutton b-gray',
  text: 'L{Object.Cancel}',
  onClick: 'up.onCancelClick'
}, {
  ref: 'okButton',
  cls: 'b-messagedialog-okbutton b-raised b-blue',
  text: 'L{Object.Ok}',
  onClick: 'up.onOkClick'
}]; // Windows has OK button to the left, Mac / Ubuntu to the right

if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isWindows) {
  items.reverse();
}

class MessageDialogConstructor extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'MessageDialog';
  } // Factoryable type name


  static get type() {
    return 'messagedialog';
  }

  static get configurable() {
    return {
      centered: true,
      modal: true,
      hidden: true,
      autoShow: false,
      closeAction: 'hide',
      title: '\xa0',
      lazyItems: {
        $config: ['lazy'],
        value: [{
          cls: 'b-messagedialog-message',
          ref: 'message'
        }, {
          type: 'textfield',
          cls: 'b-messagedialog-input',
          ref: 'input'
        }]
      },
      showClass: null,
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{Object.Cancel}'
      // 'L{Object.Ok}'
      bbar: {
        overflow: null,
        items
      }
    };
  }

  construct() {
    /**
     * The enum value for the OK button
     * @member {Number} okButton
     * @readOnly
     */
    this.okButton = this.yesButton = 1;
    /**
     * The enum value for the Cancel button
     * @member {Number} cancelButton
     * @readOnly
     */

    this.cancelButton = 3;
    super.construct(...arguments);
  }
  /**
   * Shows a confirm dialog with "Ok" and "Cancel" buttons. The returned promise resolves passing the button identifier
   * of the button that was pressed ({@link #property-okButton} or {@link #property-cancelButton}).
   * @function confirm
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {String|Object} [options.cancelButton] A text or a config object to apply to the Cancel button.
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed
   */


  async confirm() {
    return this.showDialog('confirm', ...arguments);
  }
  /**
   * Shows an alert popup with a message. The returned promise resolves when the button is clicked.
   * @function alert
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed
   */


  async alert() {
    return this.showDialog('alert', ...arguments);
  }
  /**
   * Shows a popup with a basic {@link Core.widget.TextField} along with a message. The returned promise resolves when
   * the dialog is closed and yields an Object with a `button` ({@link #property-okButton} or {@link #property-cancelButton})
   * and a `text` property with the text the user provided
   * @function prompt
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {Object} [options.textField] A config object to apply to the TextField.
   * @param {String|Object} [options.cancelButton] A text or a config object to apply to the Cancel button.
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed. The promise yields an Object with
   * a `button` ({@link #property-okButton} or {@link #property-cancelButton}) and a `text` property with the text the
   * user provided
   */


  async prompt({
    textField
  }) {
    const field = this.widgetMap.input;
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(field, textField);
    field.value = '';
    return this.showDialog('prompt', ...arguments);
  }

  showDialog(mode, {
    message = '',
    title = '\xa0',
    cancelButton,
    okButton,
    rootElement = document.body
  }) {
    const me = this;
    me.rootElement = rootElement; // Ensure our child items are instanced

    me.getConfig('lazyItems');
    me.title = me.optionalL(title);
    me.widgetMap.message.html = me.optionalL(message);
    me.showClass = `b-messagedialog-${mode}`; // Normalize string input to config object

    if (okButton) {
      okButton = typeof okButton === 'string' ? {
        text: okButton
      } : okButton;
    }

    if (cancelButton) {
      cancelButton = typeof cancelButton === 'string' ? {
        text: cancelButton
      } : cancelButton;
    } // Ensure default configs are applied


    okButton = Object.assign({}, me.widgetMap.okButton.initialConfig, okButton);
    cancelButton = Object.assign({}, me.widgetMap.cancelButton.initialConfig, cancelButton); // Ensure strings are localized

    okButton.text = me.optionalL(okButton.text);
    cancelButton.text = me.optionalL(cancelButton.text);
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(me.widgetMap.okButton, okButton);
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(me.widgetMap.cancelButton, cancelButton);
    me.show();
    return me.promise = new Promise(resolve => {
      me.resolve = resolve;
    });
  }

  show() {
    const activeElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getActiveElement(this.element); // So that when we focus, we don't close an autoClose popup, but temporarily become
    // part of its ownership tree.

    this.owner = this.element.contains(activeElement) ? null : MessageDialogConstructor.fromElement(document.activeElement);
    return super.show(...arguments);
  }

  updateShowClass(showClass, oldShowClass) {
    const {
      classList
    } = this.element;

    if (oldShowClass) {
      classList.remove(oldShowClass);
    }

    if (showClass) {
      classList.add(showClass);
    }
  }

  doResolve(value) {
    const me = this,
          {
      resolve
    } = me;

    if (resolve) {
      const isPrompt = me.showClass === 'b-messagedialog-prompt';

      if (isPrompt && value === me.okButton && !me.widgetMap.input.isValid) {
        return;
      }

      me.resolve = me.reject = me.promise = null;
      resolve(isPrompt ? {
        button: value,
        text: me.widgetMap.input.value
      } : value);
      me.hide();
    }
  }

  onInternalKeyDown(event) {
    // Cancel on escape key
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      this.onCancelClick();
    }

    if (event.key === 'Enter') {
      event.stopImmediatePropagation();
      event.preventDefault(); // Needed to not spill over into next MessageDialog if closing this opens another

      this.onOkClick();
    }

    super.onInternalKeyDown(event);
  }

  onOkClick() {
    this.doResolve(MessageDialog.okButton);
  }

  onCancelClick() {
    this.doResolve(MessageDialog.cancelButton);
  }

} // Register this widget type with its Factory


MessageDialogConstructor.initClass();
const MessageDialog = new MessageDialogConstructor();
/**
 * A singleton class which shows common dialogs, similar to the native browser APIs (though these methods do not block the UI thread):
 * - {@link Core.widget.MessageDialog#function-confirm} shows a confirmation dialog with Ok / Cancel buttons
 * - {@link Core.widget.MessageDialog#function-alert} shows an dialog with a message
 * - {@link Core.widget.MessageDialog#function-prompt} shows a dialog with a text input field
 *
 * @class
 * @singleton
 * @inlineexample Core/widget/MessageDialog.js
 * @extends Core/widget/Popup
 */

/* harmony default export */ __webpack_exports__["default"] = (MessageDialog);

/***/ }),

/***/ "./lib/Core/widget/NumberField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/NumberField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
var productName = 'gantt';


/**
 * @module Core/widget/NumberField
 */

/**
 * Number field widget. Similar to native `<input type="number">`, but implemented as `<input type="text">` to support
 * formatting.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 * It is used as the default editor for the {@link Grid/column/NumberColumn},
 * {@link Grid/column/PercentColumn}, {@link Grid/column/AggregateColumn}.
 *
 * ```javascript
 * const number = new NumberField({
 *     min   : 1,
 *     max   : 5,
 *     value : 3
 * });
 * ```
 *
 * @extends Core/widget/Field
 * @classType numberfield
 * @inlineexample Core/widget/NumberField.js
 */

class NumberField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'NumberField';
  } // Factoryable type name


  static get type() {
    return 'numberfield';
  } // Factoryable type alias


  static get alias() {
    return 'number';
  }

  static get configurable() {
    return {
      /**
       * Min value
       * @config {Number}
       */
      min: null,

      /**
       * Max value
       * @config {Number}
       */
      max: null,

      /**
       * Step size for spin button clicks.
       * @member {Number} step
       */

      /**
       * Step size for spin button clicks. Also used when pressing up/down keys in the field.
       * @config {Number}
       * @default
       */
      step: 1,

      /**
       * Large step size, defaults to 10 * `step`. Applied when pressing SHIFT and stepping either by click or
       * using keyboard.
       * @config {Number}
       * @default 10
       */
      largeStep: 0,

      /**
       * Initial value
       * @config {Number}
       */
      value: null,

      /**
       * The format to use for rendering numbers.
       *
       * For example:
       * ```
       *  format: '9,999.00##'
       * ```
       * The above enables digit grouping and will display at least 2 (but no more than 4) fractional digits.
       * @config {String|Object|Core.helper.util.NumberFormat}
       * @default
       */
      format: '',

      /**
       * The number of decimal places to allow. Defaults to no constraint.
       *
       * This config has been replaced by {@link #config-format}. Instead of this:
       *```
       *  decimalPrecision : 3
       *```
       * Use `format`:
       *```
       *  format : '9.###'
       *```
       * To set both `decimalPrecision` and `leadingZeroes` (say to `3`), do this:
       *```
       *  format : '3>9.###'
       *```
       * @config {Number}
       * @default
       * @deprecated 3.1 Use {@link #config-format} instead.
       */
      decimalPrecision: null,

      /**
       * The maximum number of leading zeroes to show. Defaults to no constraint.
       *
       * This config has been replaced by {@link #config-format}. Instead of this:
       *```
       *  leadingZeros : 3
       *```
       * Use `format`:
       *```
       *  format : '3>9'
       *```
       * To set both `leadingZeroes` and `decimalPrecision` (say to `2`), do this:
       *```
       *  format : '3>9.##'
       *```
       * @config {Number}
       * @default
       * @deprecated 3.1 Use {@link #config-format} instead.
       */
      leadingZeroes: null,
      triggers: {
        spin: {
          type: 'spintrigger'
        }
      },

      /**
       * Controls how change events are triggered when stepping the value up or down using either spinners or
       * arrow keys.
       *
       * Configure with:
       * * `true` to trigger a change event per step
       * * `false` to not trigger change while stepping. Will trigger on blur/Enter
       * * A number of milliseconds to buffer the change event, triggering when no steps are performed during that
       *   period of time.
       *
       * @config {Boolean|Number}
       * @default
       */
      changeOnSpin: true,
      // NOTE: using type="number" has several trade-offs:
      //
      // Negatives:
      //   - No access to caretPos/textSelection. This causes anomalies when replacing
      //     the input value with a formatted version of that value (the caret moves to
      //     the end of the input el on each character typed).
      //   - The above also prevents Siesta/synthetic events from mimicking typing.
      //   - Thousand separators cannot be displayed (input.value = '1,000' throws an
      //     exception).
      // Positives:
      //   - On mobile, the virtual keyboard only shows digits et al.
      //   - validity property on DOM node that handles min/max checks.
      //
      // The above may not be exhaustive, but there is not a compelling reason to
      // use type="number" except on mobile.

      /**
       * This can be set to `'number'` to enable the numeric virtual keyboard on
       * mobile devices. Doing so limits this component's ability to handle keystrokes
       * and format properly as the user types, so this is not recommended for
       * desktop applications. This will also limit similar features of automated
       * testing tools that mimic user input.
       * @config {String}
       * @default text
       */
      inputType: null
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    const me = this; // Support for selecting all by double click in empty input area
    // Browsers work differently at this case

    me.input.addEventListener('dblclick', () => {
      me.select();
    });

    if (typeof me.changeOnSpin === 'number') {
      me.bufferedSpinChange = me.buffer(me.triggerChange, me.changeOnSpin);
    }
  } //endregion
  //region Internal functions


  acceptValue(value, rawValue) {
    let accept = !isNaN(value); // https://github.com/bryntum/support/issues/1349
    // Pass through if there is a text selection in the field. This fixes the case when
    // valid value is typed already and we are replacing it by selecting complete string and typing over it.
    // Cannot be tested in siesta, see ticket for more info.

    if (accept && !this.hasTextSelection) {
      accept = false;
      const raw = this.input.value,
            current = parseFloat(raw);

      if (raw !== rawValue) {
        // The new value is out of range, but we accept it if the current value
        // is also problematic. Consider the case where the input is empty and the
        // minimum value is 100. The user must first type "1" and we must accept it
        // if they are to get the opportunity to type the "0"s.
        accept = !this.acceptValue(current, raw); // Also, if we are checking the current value, be sure not to infinitely
        // recurse here.
      }
    }

    return accept;
  }

  okMax(value) {
    return isNaN(this.max) || value <= this.max;
  }

  okMin(value) {
    return isNaN(this.min) || value >= this.min;
  }

  internalOnKeyEvent(e) {
    if (e.type === 'keydown') {
      const me = this,
            key = e.key;
      let block; // Native arrow key spin behaviour differs between browsers, so we replace
      // the native spinners w/our own triggers and handle arrows keys as well.

      if (key === 'ArrowUp') {
        me.doSpinUp(e.shiftKey);
        block = true;
      } else if (key === 'ArrowDown') {
        me.doSpinDown(e.shiftKey);
        block = true;
      } else if (!e.altKey && !e.ctrlKey && key && key.length === 1) {
        // The key property contains the character or key name... so ignore
        // keys that aren't a single character.
        const after = me.getAfterValue(key),
              afterValue = me.formatter.parseStrict(after),
              // no need to check if typing same value or - if negative numbers are allowed
        accepted = afterValue === me.value || after === '-' && (isNaN(me.min) || me.min < 0);
        block = !accepted && !me.acceptValue(afterValue, after);
      }

      if (key === 'Enter' && me._changedBySilentSpin) {
        me.triggerChange(e, true); // reset the flag

        me._changedBySilentSpin = false;
      }

      if (block) {
        e.preventDefault();
      }
    }

    super.internalOnKeyEvent(e);
  }

  doSpinUp(largeStep = false) {
    const me = this;
    let newValue = (me.value || 0) + (largeStep ? me.largeStep : me.step);

    if (!me.okMin(newValue)) {
      newValue = me.min;
    }

    if (me.okMax(newValue)) {
      me.applySpinChange(newValue);
    }
  }

  doSpinDown(largeStep = false) {
    const me = this;
    let newValue = (me.value || 0) - (largeStep ? me.largeStep : me.step);

    if (!me.okMax(newValue)) {
      newValue = me.max;
    }

    if (me.okMin(newValue)) {
      me.applySpinChange(newValue);
    }
  }

  applySpinChange(newValue) {
    const me = this;
    me._isUserAction = true; // Should not trigger change immediately?

    if (me.changeOnSpin !== true) {
      me._changedBySilentSpin = true; // Silence the change

      me.silenceChange = true; // Optionally buffer the change

      me.bufferedSpinChange && me.bufferedSpinChange(null, true);
    }

    me.value = newValue;
    me._isUserAction = false;
    me.silenceChange = false;
  }

  triggerChange() {
    if (!this.silenceChange) {
      super.triggerChange(...arguments);
    }
  }

  onFocusOut(e) {
    super.onFocusOut(...arguments);
    const me = this,
          {
      input
    } = me,
          raw = input.value,
          value = me.formatter.truncate(raw),
          formatted = isNaN(value) ? raw : me.formatValue(value);

    if (raw !== formatted) {
      input.value = formatted;
    }

    if (me._changedBySilentSpin) {
      me.triggerChange(e, true); // reset the flag

      me._changedBySilentSpin = false;
    }
  }

  internalOnInput(event) {
    const me = this,
          {
      formatter,
      input
    } = me,
          {
      parser
    } = formatter,
          raw = input.value,
          decimals = parser.decimalPlaces(raw);

    if (formatter.truncator && decimals) {
      let value = raw;
      const trunc = formatter.truncate(raw);

      if (!isNaN(trunc)) {
        value = me.formatValue(trunc);

        if (parser.decimalPlaces(value) < decimals) {
          // If typing has caused truncation or rounding, reset. To best preserve
          // the caret pos (which is reset by assigning input.value), we grab and
          // restore the distance from the end. This allows special things to format
          // into the string (such as thousands separators) since they always go to
          // the front of the input.
          const pos = raw.length - me.caretPos;
          input.value = value;
          me.caretPos = value.length - pos;
        }
      }
    }

    super.internalOnInput(event);
  }

  formatValue(value) {
    return this.formatter.format(value);
  }

  changeFormat(format) {
    const me = this;

    if (format === '') {
      const {
        leadingZeroes,
        decimalPrecision
      } = me;
      format = leadingZeroes ? `${leadingZeroes}>9` : null;

      if (decimalPrecision != null) {
        format = `${format || ''}9.${'#'.repeat(decimalPrecision)}`;
      } else if (format) {
        // When we only have leadingZeroes, we'll have a format like "4>9", but
        // that will default to 3 decimal digits. Prior behavior implied no limit
        // on decimal digits unless decimalPrecision was specified.
        format += '.*';
      }
    }

    return format;
  }

  get formatter() {
    const me = this,
          format = me.format;
    let formatter = me._formatter;

    if (!formatter || me._lastFormat !== format) {
      formatter = _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(me._lastFormat = format); // TODO use this.formatter.is.from.currency/percent visually...
      // if (!formatter.is.decimal) {
      //     formatter = formatter.as('decimal');
      // }

      me._formatter = formatter;
    }

    return formatter;
  } //endregion
  //region Getters/Setters


  updateStep(step) {
    this.element.classList[step ? 'remove' : 'add']('b-hide-spinner');
    this._step = step;
  }

  changeLargeStep(largeStep) {
    return largeStep || this.step * 10;
  }

  get validity() {
    const value = this.value,
          validity = {}; // Assert range for non-empty fields, empty fields will turn invalid if `required: true`

    if (value != null) {
      validity.rangeUnderflow = !this.okMin(value);
      validity.rangeOverflow = !this.okMax(value);
    }

    validity.valid = !validity.rangeUnderflow && !validity.rangeOverflow;
    return validity;
  }
  /**
   * Get/set the NumberField's value, or `undefined` if the input field is empty
   * @property {Number}
   */


  changeValue(value, was) {
    const me = this;

    if (value || value === 0) {
      let valueIsNaN; // We insist on a number as the value

      if (typeof value !== 'number') {
        value = typeof value === 'string' ? me.formatter.parse(value) : Number(value);
        valueIsNaN = isNaN(value);

        if (valueIsNaN) {
          value = '';
        }
      }

      if (!valueIsNaN && me.format) {
        value = me.formatter.round(value);
      }
    } else {
      value = undefined;
    }

    return super.changeValue(value, was);
  }

  get inputValue() {
    let value = this.value;

    if (value != null && this.format) {
      value = this.formatValue(value);
    }

    return value;
  } //endregion


} // Register this widget type with its Factory

NumberField.initClass();
NumberField._$name = 'NumberField';

/***/ }),

/***/ "./lib/Core/widget/PagingToolbar.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/PagingToolbar.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PagingToolbar; });
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
var productName = 'gantt';

/**
 * @module Core/widget/PagingToolbar
 */

/**
 * A special Toolbar class, which, when attached to an {@link Core.data.AjaxStore AjaxStore}, which has been configured
 * to be {@link Core.data.AjaxStore#property-isPaged paged}, controls the loading of that store to page through the data
 * set.
 *
 * ```javascript
 * new Grid({
 *      bbar : {
 *          type  : 'pagingtoolbar'
 *      }
 * });
 * ```
 *
 * ### Default toolbar items
 *
 * The toolbar provides some default buttons and other items as described below:
 *
 * | Reference              | Weight  Description                                              |
 * |------------------------|--------|---------------------------------------------------------|
 * | `firstPageButton`      | 100    | Go to first page                                        |
 * | `previousPageButton`   | 110    | Go to previous page                                     |
 * | `pageNumber`           | 120    | TextCurrent page number                                 |
 * | `pageCount`            | 130    | Label showing number of pages                           |
 * | `nextPageButton`       | 140    | Go to next page                                         |
 * | `lastPageButton`       | 150    | Go to last page                                         |
 * | `reloadButton`         | 160    | Reload data                                             |
 * | `dataSummary`          | 170    | Summary text                                            |
 *
 * ### Customizing the toolbar items
 *
 * The toolbar items can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the {@link #config-items} config.
 *
 * Adding additional buttons or widgets to the paging toolbar can be done like so:
 *
 * ```javascript
 * bbar : {
 *     type  : 'pagingtoolbar',
 *     items : {
 *         click : {
 *             type : 'button',
 *             text : 'Click me',
 *             weight : 175 // Add after last item
 *         }
 *     }
 * }
 * ```
 *
 * @extends Core/widget/Toolbar
 * @classType toolbar
 */

class PagingToolbar extends _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PagingToolbar';
  } // Factoryable type name


  static get type() {
    return 'pagingtoolbar';
  }

  static get defaultConfig() {
    return {
      /**
       * The {@link Core.data.AjaxStore AjaxStore} that this PagingToolbar is to control.
       * @config {Core.data.AjaxStore}
       */
      store: null,
      defaults: {
        localeClass: this
      },
      items: {
        firstPageButton: {
          onClick: 'up.onFirstPageClick',
          icon: 'b-icon-first',
          weight: 100
        },
        previousPageButton: {
          onClick: 'up.onPreviousPageClick',
          icon: 'b-icon-previous',
          weight: 110
        },
        pageNumber: {
          type: 'numberfield',
          label: 'L{page}',
          min: 1,
          max: 1,
          triggers: null,
          onChange: 'up.onPageNumberChange',
          highlightExternalChange: false,
          weight: 120
        },
        pageCount: {
          type: 'widget',
          cls: 'b-pagecount b-toolbar-text',
          weight: 130
        },
        nextPageButton: {
          onClick: 'up.onNextPageClick',
          icon: 'b-icon-next',
          weight: 140
        },
        lastPageButton: {
          onClick: 'up.onLastPageClick',
          icon: 'b-icon-last',
          weight: 150
        },
        separator: {
          type: 'widget',
          cls: 'b-toolbar-separator',
          weight: 151
        },
        reloadButton: {
          onClick: 'up.onReloadClick',
          icon: 'b-icon-reload',
          weight: 160
        },
        spacer: {
          type: 'widget',
          cls: 'b-toolbar-fill',
          weight: 161
        },
        dataSummary: {
          type: 'widget',
          cls: 'b-toolbar-text',
          weight: 170
        }
      }
    };
  } // Retrieve store from grid when "assigned" to it


  set parent(parent) {
    super.parent = parent;

    if (!this.store) {
      this.store = parent.store;
    }
  }

  get parent() {
    return super.parent;
  }

  set store(store) {
    const me = this,
          listener = {
      beforerequest: 'onStoreBeforeRequest',
      afterrequest: 'onStoreChange',
      change: 'onStoreChange',
      thisObj: me
    };

    if (me.store) {
      me.store.un(listener);
    }

    me._store = store;

    if (store) {
      store.on(listener);

      if (store.isLoading) {
        me.onStoreBeforeRequest();
      }
    }
  }

  get store() {
    return this._store;
  }

  onStoreBeforeRequest() {
    this.eachWidget(w => w.disable());
  }

  updateLocalization() {
    const me = this,
          {
      reloadButton,
      firstPageButton,
      previousPageButton,
      nextPageButton,
      lastPageButton
    } = me.widgetMap;
    firstPageButton.tooltip = me.L('L{firstPage}');
    previousPageButton.tooltip = me.L('L{prevPage}');
    nextPageButton.tooltip = me.L('L{nextPage}');
    lastPageButton.tooltip = me.L('L{lastPage}');
    reloadButton.tooltip = me.L('L{reload}');
    me.updateSummary();
    super.updateLocalization();
  }

  updateSummary() {
    const me = this,
          {
      pageCount,
      dataSummary
    } = me.widgetMap;
    let count, lastPage, start, end, allCount;
    count = lastPage = start = end = allCount = 0;

    if (me.store) {
      const {
        store
      } = me,
            {
        pageSize,
        currentPage
      } = store;
      count = store.count;
      lastPage = store.lastPage;
      allCount = store.allCount;
      start = Math.max(0, (currentPage - 1) * pageSize + 1);
      end = Math.min(allCount, start + pageSize - 1);
    }

    pageCount.html = me.L('L{pageCountTemplate}')({
      lastPage
    });
    dataSummary.html = count ? me.L('L{summaryTemplate}')({
      start,
      end,
      allCount
    }) : me.L('L{noRecords}');
  }

  onStoreChange() {
    const me = this,
          {
      widgetMap,
      store
    } = me,
          {
      count,
      lastPage,
      currentPage
    } = store,
          {
      pageNumber,
      pageCount,
      firstPageButton,
      previousPageButton,
      nextPageButton,
      lastPageButton,
      dataSummary
    } = widgetMap;
    me.eachWidget(w => w.enable());
    pageNumber.value = currentPage;
    pageNumber.max = lastPage;
    dataSummary.disabled = pageNumber.disabled = pageCount.disabled = !count;
    firstPageButton.disabled = previousPageButton.disabled = currentPage <= 1 || !count;
    nextPageButton.disabled = lastPageButton.disabled = currentPage >= lastPage || !count;
    me.updateSummary();
  }

  onPageNumberChange({
    value
  }) {
    if (this.store.currentPage !== value) {
      this.store.loadPage(value);
    }
  }

  onFirstPageClick() {
    this.store.loadPage(1);
  }

  onPreviousPageClick() {
    this.store.previousPage();
  }

  onNextPageClick() {
    this.store.nextPage();
  }

  onLastPageClick() {
    this.store.loadPage(this.store.lastPage);
  }

  onReloadClick() {
    this.store.loadPage(this.store.currentPage);
  }

} // Register this widget type with its Factory

PagingToolbar.initClass();
PagingToolbar._$name = 'PagingToolbar';

/***/ }),

/***/ "./lib/Core/widget/Panel.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Panel.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Panel; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./panel/PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony import */ var _mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';













/**
 * @module Core/widget/Panel
 */

/**
 * An object that describes a Panel's header.
 *
 * @typedef {Object} PanelHeader
 * @property {String|Object} [cls] Additional CSS class or classes to add to the header element.
 * @property {String} [dock="top"] Specify "left", "bottom", or "right" to control panel edge to which the header docks.
 * @property {String} title
 * @property {String} [titleAlign="start"] Specify "center" or "end" to align the panel's title differently.
 */

const acceptNode = e => !e.classList.contains('b-focus-trap') && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isFocusable(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP,
      emptyArray = [],
      emptyObject = {},
      emptySplit = [emptyArray, emptyArray],
      finishBodyWrap = (config, classes, final) => ({
  children: config.children,
  class: _objectSpread(_objectSpread({}, classes), {}, {
    [`b-${config.vertical ? 'v' : 'h'}box`]: 1,
    'b-box-center': 1,
    'b-panel-bar-wrap': !final
  })
}),
      wrapBody = (inner, vertical = false) => ({
  vertical,
  children: inner ? [inner] : []
}),
      barConfigs = {
  dock: 1,
  hidden: 1,
  weight: 1
},
      dockDirection = {
  //       [vertical, before]
  top: [true, true],
  bottom: [true, false],
  left: [false, true],
  right: [false, false]
},
      headerDock = {
  header: 1,
  'pre-header': 1
}; // https://github.com/webcomponents/webcomponentsjs/issues/556
// Work around Internet Explorer wanting a function instead of an object.
// IE also *requires* this argument where other browsers don't.


acceptNode.acceptNode = acceptNode;
/**
 * Panel widget. A general purpose container which may be used to contain child {@link Core.widget.Container#config-items}
 * or {@link Core.widget.Widget#config-html}.
 *
 * Also may dock a {@link #config-header} and {@link #config-footer} either at top/bottom or left/right
 *
 *
 * @example
 * let panel = new Panel({
 *   title   : 'A Test Panel',
 *   items : [
 *     { type : 'text', placeholder: 'Text' },
 *   ],
 *   bbar : [{
 *     text : 'Proceed',
 *     onClick : () => {
 *       alert('Proceeding!');
 *     }
 *   }]
 * });
 *
 * @classType panel
 *
 * @extends Core/widget/Container
 * @inlineexample Core/widget/Panel.js
 */

class Panel extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
  //region Config
  static get $name() {
    return 'Panel';
  } // Factoryable type name


  static get type() {
    return 'panel';
  }

  static get configurable() {
    return {
      localizableProperties: ['title'],

      /**
       * Controls whether the panel is collapsed (the body of the panel is hidden while only the header is
       * visible). Only valid if the panel is {@link #config-collapsible}.
       * @config {Boolean}
       */
      collapsed: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * This config enables collapsibility for the panel. See {@link #config-collapsed}.
       *
       * For example:
       * ```javascript
       *      {
       *          type        : 'panel',
       *          collapsible : true
       *      }
       * ```
       * This is managed by an instance of {@link Core.widget.panel.PanelCollapser} which can be configured if an
       * object is passed for this config property:
       * ```javascript
       *      {
       *          type        : 'panel',
       *          collapsible : {
       *              direction : 'left'
       *          }
       *      }
       * ```
       * @config {Boolean|Core.widget.panel.PanelCollapser}
       */
      collapsible: {
        value: null,
        $config: 'nullify'
      },

      /**
       * Custom CSS classes to add to the panel's body element.
       *
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       *
       * ```javascript
       *  bodyCls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      bodyCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * By default, tabbing within a Panel is not contained, ie you can TAB out of the Panel
       * forwards or backwards.
       * Configure this as `true` to disallow tabbing out of the Panel, and make tabbing circular within this Panel.
       * @config {Boolean}
       * @default false
       * @category Content
       */
      trapFocus: null,

      /**
       * A title to display in the header. Causes creation and docking of a header
       * to the top if no header is configured.
       *
       * If specified, overrides any title configured within the {@link #config-header} configuration.
       * @default
       * @config {String}
       * @category Content
       */
      title: null,

      /**
       * A config {@link PanelHeader object} for the panel's header or a string in place of a `title`.
       *
       * Configuring this as `false` explicitly removes the header bar, overriding any
       * {@link #config-tools} or {@link #config-title} configs.
       * @default
       * @config {String|Boolean|PanelHeader}
       * @category Content
       */
      header: null,

      /**
       * An object containing config defaults for corresponding {@link #config-strips} objects with a matching name.
       *
       * By default, this object contains the keys `'bbar'` and `'tbar'` to provide default config values for the
       * {@link #config-bbar} and {@link #config-tbar} configs.
       *
       * This object also contains a key named `'*'` with default config properties to apply to all strips. This
       * object provides the default `type` (`'toolbar') and {@link Core.widget.Widget#config-dock} (`'top'`)
       * property for strips.
       * @config {Object} stripDefaults
       * @internal
       * @category Content
       */
      stripDefaults: {
        '*': {
          type: 'toolbar',
          dock: 'top'
        },
        bbar: {
          dock: 'bottom',
          weight: -1000
        },
        tbar: {
          weight: -1000
        }
      },

      /**
       * An object containing widgets keyed by name. By default (when no `type` is given), strips are
       * {@link Core.widget.Toolbar toolbars}. If the value assigned to a strip is an array, it is converted to
       * the toolbar's {@link Core.widget.Container#config-items}.
       *
       * The {@link #config-bbar} and {@link #config-tbar} configs are shortcuts for adding toolbars to the
       * panel's `strips`.
       *
       * Strips are arranged based on their {@link Core.widget.Widget#config-dock} and
       * {@link Core.widget.Widget#config-weight} configs.
       *
       * For widgets using a `dock` of `'top'`, `'bottom'`, `'left'`, or `'right'` (an "edge strip"), the higher
       * the `weight` assigned to a widget, the closer that widget will be to the panel body.
       *
       * For widgets with `'header'` or `'pre-header'` for `dock` (a "header strip"), higher `weight` values
       * cause the widget to be placed closer to the panel's title.
       *
       * ```javascript
       *  new Panel({
       *      title : 'Test',
       *      html  : 'Panel strip test',
       *      strips : {
       *          left : [{
       *              text : 'Go'
       *          }]
       *      }
       *  });
       * ```
       * @config {Object} strips
       * @category Content
       */
      strips: {
        value: null,
        $config: 'nullify'
      },
      toolDefaults: {
        close: {
          weight: -1000
        },
        collapse: {
          weight: -990
        }
      },

      /**
       * Config object of a footer. May contain a `dock`, `html` and a `cls` property. A footer is not a widget,
       * but rather plain HTML that follows the last element of the panel's body and {@link #config-strips}.
       *
       * The `dock` property may be `top`, `right`, `bottom` or `left`.
       * @config {Object|String}
       * @default
       * @category Content
       */
      footer: null,

      /**
       * This config is used with {@link Core.widget.panel.PanelCollapserOverlay} to programmatically control the
       * visibility of the panel's body. In this mode of collapse, the body of a collapsed panel is a floating
       * overlay. Setting this config to `true` will show this element, while `false` will hide it.
       * @config {Boolean}
       * @private
       */
      revealed: null,

      /**
       * The tool Widgets as specified by the {@link #config-tools} configuration
       * (and the {@link Core.widget.Popup#config-closable} configuration in the Popup subclass).
       * Each is a {@link Core.widget.Widget Widget} instance which may be hidden, shown and observed and styled
       * just like any other widget.
       * @member {Object} tools
       */

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the `title` in the Panel header. Each
       * property name is the reference by which an instantiated tool may be retrieved from the live
       * `{@link Core.widget.mixin.Toolable#property-tools}` property.
       * @config {Object} tools
       * @category Content
       */

      /**
       * Get toolbar {@link Core.widget.Toolbar} docked to the top of the panel
       * @member {Core.widget.Toolbar} tbar
       * @readonly
       */

      /**
       * A Config object representing the configuration of a {@link Core.widget.Toolbar},
       * or array of config objects representing the child items of a Toolbar.
       *
       * This creates a toolbar docked to the top of the panel immediately below the header.
       * @config {Object[]|Object}
       * @category Content
       */
      tbar: null,

      /**
       * Get toolbar {@link Core.widget.Toolbar} docked to the bottom of the panel
       * @member {Core.widget.Toolbar} bbar
       * @readonly
       */

      /**
       * A Config object representing the configuration of a {@link Core.widget.Toolbar},
       * or array of config objects representing the child items of a Toolbar.
       *
       * This creates a toolbar docked to the bottom of the panel immediately above the footer.
       * @config {Object[]|Object}
       * @category Content
       */
      bbar: null
    };
  } //endregion

  /**
   * A header {@link #config-tools tool} has been clicked.
   * @event toolClick
   * @param {Core.widget.Tool} source - This Panel.
   * @param {Core.widget.Tool} tool - The tool which is being clicked.
   */
  //region Composition


  compose() {
    const me = this,
          {
      collapsible,
      focusable,
      hasItems,
      revealed
    } = me,
          header = me.composeHeader(),
          horz = (header === null || header === void 0 ? void 0 : header.class['b-dock-left']) || (header === null || header === void 0 ? void 0 : header.class['b-dock-right']);
    let body = me.composeBody(),
        key = 'bodyWrapElement';

    if (collapsible) {
      [key, body] = collapsible.wrapCollapser(key, body);
    }

    return {
      tabIndex: hasItems && focusable !== false || focusable ? 0 : null,
      class: {
        [`b-panel-collapsible-${collapsible === null || collapsible === void 0 ? void 0 : collapsible.type}`]: collapsible,
        [`b-panel-collapse-${collapsible === null || collapsible === void 0 ? void 0 : collapsible.collapseDir}`]: collapsible,
        [`b-${horz ? 'h' : 'v'}box`]: 1,
        'b-panel-collapsible': collapsible,
        'b-panel-has-header': header,
        'b-panel-overlay-revealed': revealed
      },
      children: {
        topFocusTrap: {
          tabIndex: 0,
          class: {
            'b-focus-trap': 1
          }
        },
        // Note: we always put header before bodyWrap since it is likely (though untested) to be better for
        // a11y. We use flexbox order to make the right/bottom docking appear correct but it is likely that
        // the DOM order of the <header> element vs (optional) <footer> is important to screen readers.
        headerElement: header,
        [key]: body,
        bottomFocusTrap: {
          tabIndex: 0,
          class: {
            'b-focus-trap': 1
          }
        }
      }
    };
  }

  composeBody() {
    const me = this,
          {
      bodyCls,
      bodyConfig,
      footer,
      uiClassList
    } = me,
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !dockDirection[v === null || v === void 0 ? void 0 : v.dock]).sort(me.byWeightSortFn);
    let bar, before, dock, i, name, vertical, wrap;

    if (footer) {
      dock = footer.dock || 'bottom';
      strips.unshift({
        dock,
        element: {
          tag: 'footer',
          reference: 'footerElement',
          html: typeof footer === 'string' ? footer : footer.html,
          class: _objectSpread(_objectSpread({}, uiClassList), {}, {
            [`b-dock-${dock}`]: 1,
            [`${footer.cls || ''}`]: 1
          })
        }
      });
    }

    if (bodyCls) {
      if (!bodyConfig[name = 'className']) {
        name = 'class';
      }

      bodyConfig[name] = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](bodyConfig[name]).assign(bodyCls);
    }
    /*
        The higher the weight, the closer to the center we place the toolbar. Consider:
            {
                tbar : ...,
                bbar :...,
                strips : {
                    lbar1 : { weight : 10, ... },
                    tbar2 : { weight : 20, ... },
                    lbar2 : { weight : 30, ... },
                    rbar  : { weight : 40, ... }
                }
            }
            +---------------------------------------------------+
            | tbar                                              |
            +---------+-----------------------------------------+
            |         | tbar2                                   |
            |         +---------+----------------------+--------+
            |         |         |                      |        |
            |  lbar1  |         |                      |        |
            |         |  lbar2  |                      |  rbar  |
            |         |         |                      |        |
            |         |         |                      |        |
            +---------+---------+----------------------+--------+
            | bbar                                              |
            +---------------------------------------------------+
     */


    for (i = strips.length; i-- > 0;) {
      bar = strips[i];
      [vertical, before] = dockDirection[bar.dock];

      if (!wrap) {
        wrap = wrapBody(bodyConfig, vertical);
      } else if (wrap.vertical !== vertical) {
        wrap = wrapBody(finishBodyWrap(wrap, uiClassList), vertical);
      }

      wrap.children[before ? 'unshift' : 'push'](bar.element);
    }

    const body = finishBodyWrap(wrap || wrapBody(bodyConfig), uiClassList, true);
    body.class['b-panel-body-wrap'] = 1;
    body.class[`b-${me.$$name.toLowerCase()}-body-wrap`] = 1;
    return body;
  }

  get hasHeader() {
    const {
      header,
      title,
      tools,
      parent
    } = this,
          hasVisibleTools = Object.values(tools || {}).some(tool => !tool.hidden); // Explicitly declared header should always be shown.
    // Implicitly created from title or tools can be suppressed by parent.
    // Explicitly disabled header using false should mean no header at all.

    return header !== false && (header || !(parent !== null && parent !== void 0 && parent.suppressChildHeaders) && (title || hasVisibleTools));
  }

  get rootUiClass() {
    return Panel;
  }

  composeHeader(force) {
    var _me$collapsible;

    const me = this; // Dont add a header unless we have one configured, have a title or have visible tools (or are forced to)

    if (!force && !me.hasHeader) {
      return;
    }

    const header = me.header || {},
          dock = header.dock || 'top',
          [before, after] = me.splitHeaderItems({
      dock,
      as: 'element'
    }),
          classes = me.$meta.hierarchy,
          title = me.composeTitle(header),
          cls = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](_objectSpread({
      [`b-dock-${dock}`]: 1
    }, me.uiClassList), header.cls);
    let i, name;

    for (i = classes.indexOf(Panel); i < classes.length; ++i) {
      name = classes[i].$$name;

      if (name !== 'Grid') {
        cls[`b-${name.toLowerCase()}-header`] = 1;
      }
    }

    const headerConfig = {
      tag: 'header',
      class: cls,
      children: [...before, title, ...after]
    };
    return ((_me$collapsible = me.collapsible) === null || _me$collapsible === void 0 ? void 0 : _me$collapsible.composeHeader(headerConfig)) || headerConfig;
  }

  composeTitle(header) {
    var _this$collapsible;

    const title = typeof header === 'string' ? header : this.title || header.title,
          titleConfig = {
      reference: 'titleElement',
      html: title !== null && title !== void 0 ? title : '\xA0',
      class: _objectSpread({
        [`b-align-${header.titleAlign || 'start'}`]: 1,
        'b-header-title': 1
      }, this.uiClassList)
    };

    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isObject(title)) {
      delete titleConfig.html;
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(titleConfig, title);
    }

    return ((_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.composeTitle(titleConfig)) || titleConfig;
  }

  afterRecompose() {
    var _me$_headerClickDetac;

    super.afterRecompose();
    const me = this,
          {
      headerElement
    } = me;
    (_me$_headerClickDetac = me._headerClickDetacher) === null || _me$_headerClickDetac === void 0 ? void 0 : _me$_headerClickDetac.call(me);
    me._headerClickDetacher = headerElement && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
      element: headerElement,
      // Click might have lead to panel being destroyed (clicking close tool with `hideAction : 'destroy'`)
      click: ev => {
        var _me$trigger;

        return (_me$trigger = me.trigger) === null || _me$trigger === void 0 ? void 0 : _me$trigger.call(me, 'headerClick', {
          event: ev
        });
      }
    });
  }

  onHeaderClick(info) {
    var _this$collapsible2;

    (_this$collapsible2 = this.collapsible) === null || _this$collapsible2 === void 0 ? void 0 : _this$collapsible2.onHeaderClick(info);
  }

  onPaint() {
    var _this$collapsible3;

    super.onPaint();
    (_this$collapsible3 = this.collapsible) === null || _this$collapsible3 === void 0 ? void 0 : _this$collapsible3.onPanelPaint(this);
  }

  splitHeaderItems({
    as,
    overlay,
    dock
  } = emptyObject) {
    const me = this,
          asElement = as === 'element',
          {
      collapsed
    } = me,
          endTools = me.getEndTools({
      overlay
    }),
          startTools = me.getStartTools({
      overlay
    }),
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !headerDock[v === null || v === void 0 ? void 0 : v.dock] && v.isCollapsified(collapsed, overlay));
    let ret = emptySplit,
        after,
        before,
        i;

    if (strips.length + endTools.length + startTools.length) {
      // The "natural" order of equal weight tools/strips is: tool -> strip -> header <- strip <- tool
      ret = [// the problem w/mixing tools and strips is the strip weight needs to do two jobs (one when docked
      // in the body and one when docked in the header)
      before = [...startTools, ...strips.filter(e => e.dock === 'pre-header').sort(me.byWeightSortFn)], after = [...strips.filter(e => e.dock === 'header').sort(me.byWeightReverseSortFn), ...endTools]];

      for (i = 0; i < before.length; ++i) {
        var _before$i$syncRotatio, _before$i;

        dock && ((_before$i$syncRotatio = (_before$i = before[i]).syncRotationToDock) === null || _before$i$syncRotatio === void 0 ? void 0 : _before$i$syncRotatio.call(_before$i, dock));

        if (asElement) {
          before[i] = before[i].element;
        }
      }

      for (i = 0; i < after.length; ++i) {
        var _after$i$syncRotation, _after$i;

        dock && ((_after$i$syncRotation = (_after$i = after[i]).syncRotationToDock) === null || _after$i$syncRotation === void 0 ? void 0 : _after$i$syncRotation.call(_after$i, dock));

        if (asElement) {
          after[i] = after[i].element;
        }
      }
    }

    return ret;
  }

  set bodyConfig(bodyConfig) {
    this._bodyConfig = bodyConfig;
  }

  get bodyConfig() {
    const me = this,
          result = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge({
      reference: 'bodyElement',
      className: _objectSpread(_objectSpread({}, me.getStaticWidgetClasses(Panel, '-content')), {}, {
        'b-box-center': 1,
        'b-text-content': me.textContent && me.hasNoChildren
      })
    }, me._bodyConfig);

    if (me.initializingElement || !me._element) {
      // we cannot use the html config since a getter reads innerHTML
      result.html = me.content || me._html;
    }

    return result;
  } //endregion
  //region Configs


  changeBodyCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(cls);
  }

  changeTbar(bar) {
    this.getConfig('strips');
    this.strips = {
      tbar: bar
    };
    return this.strips.tbar;
  }

  changeBbar(bar) {
    this.getConfig('strips');
    this.strips = {
      bbar: bar
    };
    return this.strips.bbar;
  } // Override to iterate docked Toolbars in the correct order around contained widgets.


  get childItems() {
    var _me$collapsible2;

    const me = this,
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !dockDirection[v === null || v === void 0 ? void 0 : v.dock]).sort(me.byWeightSortFn),
          [before, after] = me.splitHeaderItems(),
          // tools and header strips
    [before2, after2] = ((_me$collapsible2 = me.collapsible) === null || _me$collapsible2 === void 0 ? void 0 : _me$collapsible2.splitHeaderItems()) || emptySplit;
    return [...before, ...before2, ...after, ...after2, ...strips.filter(b => dockDirection[b.dock][1]), // the "before" strips come before the items
    ...(me._items || emptyArray), ...strips.filter(b => !dockDirection[b.dock][1]).reverse()];
  }

  changeStrips(strips, oldStrips) {
    const me = this,
          manager = me.$strips || (me.$strips = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
      configName: 'strips',
      factory: _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      inferType: false,
      // the name of a bar in the strips object is not its type
      owner: me,

      created(instance) {
        var _instance$layout;

        const {
          dock
        } = instance;

        if (!headerDock[dock] && !dockDirection[dock]) {
          throw new Error(`Invalid dock value "${dock}"; must be: top, left, right, bottom, header, or pre-header`);
        }

        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (barConfigs[name]) {
            me.onConfigChange({
              name: 'strips',
              value: manager.target
            });
          }
        });
        instance.innerItem = false;
        me.onChildAdd(instance);
        instance.parent = me; // in case we are given an instanced widget

        (_instance$layout = instance.layout) === null || _instance$layout === void 0 ? void 0 : _instance$layout.renderChildren();

        if (instance.hasItems) {
          me.hasItems = true;
        }
      },

      setup(config, name) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].clone(me.stripDefaults['*']), me.stripDefaults[name], config);
        config.parent = me; // so parent can be accessed during construction

        config.ref = name;
        return config;
      },

      transform(config) {
        if (Array.isArray(config)) {
          config = {
            items: config
          };
        }

        return config || null;
      }

    }));
    manager.update(strips);

    if (!oldStrips) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  } //endregion
  //region Collapse/Expand


  get collapsing() {
    var _this$collapsible4;

    return (_this$collapsible4 = this.collapsible) === null || _this$collapsible4 === void 0 ? void 0 : _this$collapsible4.collapsing;
  }

  get collapsingExpanding() {
    var _this$collapsible5;

    return (_this$collapsible5 = this.collapsible) === null || _this$collapsible5 === void 0 ? void 0 : _this$collapsible5.collapsingExpanding;
  }

  get expanding() {
    var _this$collapsible6;

    return (_this$collapsible6 = this.collapsible) === null || _this$collapsible6 === void 0 ? void 0 : _this$collapsible6.expanding;
  }

  changeCollapsed(value) {
    const me = this,
          {
      collapsible
    } = me;
    value = Boolean(value);

    if (!collapsible || me.changingCollapse) {
      // if (the collapser is asking...)
      return value;
    }

    if (me.isPainted) {
      collapsible === null || collapsible === void 0 ? void 0 : collapsible.collapse({
        animation: null,
        collapsed: value
      });
    }
  }

  changeCollapsible(collapsible, was) {
    this.getConfig('tools');

    if (collapsible) {
      if (collapsible === true) {
        collapsible = {};
      } else if (typeof collapsible === 'string') {
        collapsible = {
          [dockDirection[collapsible] ? 'direction' : 'type']: collapsible
        };
      }
    }

    return _panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_2__["default"].reconfigure(was, collapsible, {
      owner: this,
      defaults: {
        panel: this
      }
    });
  }

  updateCollapsible(collapsible) {
    const me = this,
          tools = collapsible === null || collapsible === void 0 ? void 0 : collapsible.toolsConfig;
    me.tools = {
      collapse: (tools === null || tools === void 0 ? void 0 : tools.collapse) || null,
      recollapse: (tools === null || tools === void 0 ? void 0 : tools.recollapse) || null
    };

    if (me.isPainted && me.collapsed) {
      me._collapsed = 1;
      me.collapsed = true;
    }
  }

  _collapse(collapsed, options) {
    var _this$collapsible7;

    if (options !== true && options !== undefined) {
      // allow expand(false) to be equivalent to collapse(true)
      // or collapse(false) to be equivalent to expand(true)
      if (options === false) {
        collapsed.collapsed = !collapsed.collapsed;
      } else if (typeof options === 'number') {
        collapsed.animation = {
          duration: options
        };
      } else if (options === null) {
        collapsed.animation = options;
      } else if (options === true) {// ignore
      } // Must be an options object...
      else if ('animation' in options) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(collapsed, options);
      } else {
        collapsed.animation = options;
      }
    }

    return (_this$collapsible7 = this.collapsible) === null || _this$collapsible7 === void 0 ? void 0 : _this$collapsible7.collapse(collapsed);
  }

  collapse(options) {
    return this._collapse({
      collapsed: true
    }, options);
  }

  expand(options) {
    return this._collapse({
      collapsed: false
    }, options);
  }

  toggleCollapsed(options) {
    return this.collapsed ? this.expand(options) : this.collapse(options);
  } //endregion
  //region Misc


  get expandedHeaderDock() {
    var _ref, _this$_expandedHeader, _this$initialConfig$h;

    return (_ref = (_this$_expandedHeader = this._expandedHeaderDock) !== null && _this$_expandedHeader !== void 0 ? _this$_expandedHeader : (_this$initialConfig$h = this.initialConfig.header) === null || _this$initialConfig$h === void 0 ? void 0 : _this$initialConfig$h.dock) !== null && _ref !== void 0 ? _ref : 'top';
  }

  set expandedHeaderDock(v) {
    this._expandedHeaderDock = v === null || v === void 0 ? void 0 : v.toLowerCase();
  }

  updateHeader(header) {
    if (!this.changingCollapse) {
      this.expandedHeaderDock = header === null || header === void 0 ? void 0 : header.dock;
    }
  }

  updateTrapFocus(trapFocus) {
    var _me$focusTrapListener;

    const me = this;
    me.element.classList[trapFocus ? 'add' : 'remove']('b-focus-trapped');
    me.focusTrapListener = (_me$focusTrapListener = me.focusTrapListener) === null || _me$focusTrapListener === void 0 ? void 0 : _me$focusTrapListener.call(me);

    if (trapFocus) {
      me.focusTrapListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
        element: me.element,
        focusin: 'onFocusTrapped',
        delegate: '.b-focus-trap',
        thisObj: me
      }); // Create a TreeWalker which visits focusable elements.

      if (!me.treeWalker) {
        me.treeWalker = this.setupTreeWalker(me.element, NodeFilter.SHOW_ELEMENT, acceptNode, false);
      }
    }
  } //#region Max height


  updateMaxHeight(maxHeight) {
    super.updateMaxHeight(maxHeight);

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.bodyWrapElement.style.flex = `1 1 ${maxHeight}px`;
    }
  }

  fixIEMaxHeightBug() {
    const {
      element,
      contentElement,
      bodyWrapElement
    } = this; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
    // propagated onto the contentElement.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(element, 'flex-direction') === 'column') {
      // Release previous height constraint
      contentElement.style.maxHeight = '';
      let availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].client(element).height;
      const siblings = element.childNodes,
            len = siblings.length; // In case there are height-consuming siblings of the contentElement.
      // For example a header/footer. The heights of these must be subtracted.

      for (let i = 0; i < len; i++) {
        const sibling = siblings[i];

        if (sibling !== contentElement && sibling !== bodyWrapElement && !sibling.classList.contains('b-resize-monitors')) {
          availableHeight -= sibling.offsetHeight;
        }
      } // Apply the adjusted height constraint to the contentElement


      this.contentElement.style.maxHeight = `${availableHeight}px`;
    }
  } //#endregion


  setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
    return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
  }

  onFocusTrapped(e) {
    const me = this,
          treeWalker = me.treeWalker; // The only way of focusing these invisible elements is by TAB-ing to them.
    // If we hit the bottom one, wrap to the top.

    if (e.target === me.bottomFocusTrap) {
      treeWalker.currentNode = me.topFocusTrap;
      treeWalker.nextNode();
    } // If we hit the top one, wrap to the bottom.
    else {
      treeWalker.currentNode = me.bottomFocusTrap;
      treeWalker.previousNode();
    }

    me.requestAnimationFrame(() => treeWalker.currentNode.focus());
  }

  get focusElement() {
    // Either use our Containerness to yield the focus element of
    // a descendant or fall back to the encapsulating element.
    return this.hasItems && (super.focusElement || this.element);
  }

  get contentElement() {
    return this.element && this.bodyElement;
  }

  get widgetClassList() {
    const me = this,
          result = super.widgetClassList;

    if (me.hasHeader) {
      var _me$header;

      result.push('b-panel-has-header', `b-header-dock-${((_me$header = me.header) === null || _me$header === void 0 ? void 0 : _me$header.dock) || 'top'}`);
    }

    if (me.tbar) {
      result.push('b-panel-has-top-toolbar');
    }

    if (me.bbar) {
      result.push('b-panel-has-bottom-toolbar');
    }

    return result;
  } //endregion


} // Register this widget type with its Factory

Panel.initClass();
Panel._$name = 'Panel';

/***/ }),

/***/ "./lib/Core/widget/PasswordField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/PasswordField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PasswordField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'gantt';

/**
 * @module Core/widget/PasswordField
 */

/**
 * Password field widget. Wraps native &lt;input type="password"&gt;
 *
 * ```javascript
 * let textField = new PasswordField({
 *     placeholder : 'Enter password'
 * });
 * ```
 *
 * {@inlineexample Core/widget/PasswordField.js}
 * @classType passwordfield
 * @extends Core/widget/Field
 */

class PasswordField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'passwordfield';
  } // Factoryable type alias


  static get alias() {
    return 'password';
  }

  static get $name() {
    return 'PasswordField';
  }

  construct(config = {}) {
    config.inputType = 'password';
    super.construct(...arguments);
    this.element.classList.add('b-textfield');
  }

} // Register this widget type with its Factory

PasswordField.initClass();
PasswordField._$name = 'PasswordField';

/***/ }),

/***/ "./lib/Core/widget/PickerField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/PickerField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PickerField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';




/**
 * @module Core/widget/PickerField
 */

/**
 * Base class used for {@link Core.widget.Combo Combo}, {@link Core.widget.DateField DateField}, and {@link Core.widget.TimeField TimeField}.
 * Displays a picker ({@link Core.widget.List List}, {@link Core.widget.DatePicker DatePicker}) anchored to the field.
 * Not intended to be used directly.
 *
 * This field's subclasses can be used as editors for the {@link Grid.column.Column Column}.
 *
 * When focused by means of *touch* tapping on the trigger element (eg, the down arrow on a Combo)
 * on a tablet, the keyboard will not be shown by default to allow for interaction with the dropdown.
 *
 * A second tap on the input area will then show the keyboard if required.
 *
 * @extends Core/widget/TextField
 * @abstract
 */

class PickerField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'PickerField';
  } // Factoryable type name


  static get type() {
    return 'pickerfield';
  }

  static get configurable() {
    return {
      /**
       * User can edit text in text field (otherwise only pick from attached picker)
       * @config {Boolean}
       * @default
       */
      editable: true,

      /**
       * The name of the element property to which the picker should size and align itself.
       * @config {String}
       * @default element
       */
      pickerAlignElement: 'inputWrap',
      // Does not get set, but prevents PickerFields inheriting value:'' from Field.
      value: null,
      triggers: {
        expand: {
          cls: 'bars'
        }
      },

      /**
       * By default PickerField's picker is transient, and will {@link #function-hidePicker} when the user clicks or
       * taps outside or when focus moves outside picker.
       *
       * Configure as `false` to make picker non-transient.
       * @config {Boolean}
       * @default
       */
      autoClose: true,

      /**
       * Configure as `true` to have the picker expand upon focus enter.
       * @config {Boolean}
       */
      autoExpand: null,

      /**
       * Returns the instantiated picker widget as configured by {@link #config-picker}.
       * @readonly
       * @member {Core.widget.Widget} picker
       */

      /**
       * A config object which is merged into the generated picker configuration to allow specific use cases
       * to override behaviour. For example:
       *
       *     picker: {
       *         align: {
       *             anchor: true
       *         }
       *     }
       *
       * @config {Object}
       */
      picker: {
        value: {
          floating: true
        },
        $config: ['lazy', 'nullify']
      },
      inputType: 'text',
      // We need to realign the picker if we resize (eg a multiSelect Combo's ChipView wrapping)
      monitorResize: true,
      nullValue: null
    };
  } //endregion
  //region Init & destroy


  doDestroy() {
    var _this$globalTapListen;

    // Remove touch keyboard showing listener if we added it
    (_this$globalTapListen = this.globalTapListener) === null || _this$globalTapListen === void 0 ? void 0 : _this$globalTapListen.call(this);
    super.doDestroy();
  }

  updateEditable(editable) {
    const me = this,
          element = me.element;
    super.updateEditable(...arguments);

    if (editable === false) {
      var _me$globalTapListener;

      (_me$globalTapListener = me.globalTapListener) === null || _me$globalTapListener === void 0 ? void 0 : _me$globalTapListener.call(me);
      element.classList.add('b-not-editable');
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.input,
        click: 'onTriggerClick',
        thisObj: me
      });
    } else {
      // In case the field was temporarily set to readOnly="true" to prevent
      // the intrusive keyboard (This happens when tapping the trigger
      // and when focused by the container in response to a touch tap),
      // allow a subsequent touch tap to show the keyboard.
      me.globalTapListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
        globaltap: 'showKeyboard',
        thisObj: me
      });
    }
  } //endregion
  //region Picker

  /* TODO
  changePicker(picker, was) {
      if (was) {
          was.hide();
          was.destroy();
      }
      if (picker && !(picker instanceof Widget)) {
          picker = this.createPicker(picker);
      }
      return picker;
  }
  createPicker() {
      throw new Error('createPicker must be implemented in PickerField subclass implementations');
  }
  */


  changePicker(picker, oldPicker) {
    throw new Error('changePicker(oldPicker, newPicker) must be implemented in PickerField subclass implementations');
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   *
   * _Due to the {@link #config-picker} config being a lazy config and only being converted to be a
   * `List` instance just before it's shown, the picker will not be part of the iteration before
   * it has been shown once_.
   * @function eachWidget
   * @param {Function} fn A function to execute upon all descendant widgets.
   * Iteration terminates if this function returns `false`.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   */


  get childItems() {
    if (this._picker) {
      return [this.picker];
    }
  } //endregion
  //region Events

  /**
   * Check if field value is valid
   * @internal
   */


  onEditComplete() {
    super.onEditComplete();
    this.autoClosePicker();
  }

  onElementResize(resizedElement) {
    const me = this; // If the field changes size while the picker is visible, the picker
    // must be kept in alignment. For example a multiSelect: true
    // ComboBox with a wrapped ChipView.

    if (me.pickerVisible) {
      // Push realignment out to the next AF, because this picker itself may move in
      // response to the element resize, and the picker must realign *after* that happens.
      // For example a multiSelect: true ComboBox with a wrapped ChipView inside
      // a Popup that is aligned *above* an element. When the ChipView gains or
      // loses height, the Popup must realign first, and then the List must align to the
      // new position of the ComboBox.
      me.picker.requestAnimationFrame(me.picker.realign, null, me.picker);
    }

    super.onElementResize(resizedElement);
  }
  /**
   * Allows using arrow keys to open/close list. Relays other keypresses to list if open.
   * @private
   */


  internalOnKeyEvent(event) {
    const me = this;
    let callSuper = true;

    if (event.type === 'keydown' && !me.disabled) {
      if (me.pickerVisible) {
        const {
          picker
        } = me;

        if (event.key === 'Escape') {
          event.stopImmediatePropagation();
          me.hidePicker(); // EC has multiple effects. First stage is hide the picker.
          // If we do this, then the superclass's ESC handling must
          // not be called.

          callSuper = false;
        } else if (picker.onInternalKeyDown) {
          // if picker is visible, give it a shot at the event
          picker.onInternalKeyDown(event);
        } else if (event.key === 'ArrowDown') {
          if (picker.focusable) {
            picker.focus();
          }
        }
      } else if (event.key === 'ArrowDown') {
        // navigator should not react to initial DOWN keypress that triggers the List to show
        event.stopImmediatePropagation(); // If we not prevent default handler page might scroll. Siesta cannot reproduce this behavior, have to
        // leave it untested.
        // https://github.com/bryntum/support/issues/885

        event.preventDefault();
        me.onTriggerClick(event);
      }
    }

    if (callSuper) {
      super.internalOnKeyEvent(event);
    }
  }

  onFocusIn(e) {
    super.onFocusIn(e);

    if (this.autoExpand) {
      // IE triggers an input event on focus.
      // If expand is configured for focus, minChars should be zero.
      this.minChars = 0;
      this.onTriggerClick(e);
    }
  }

  onFocusOut(e) {
    this.autoClosePicker();
    super.onFocusOut(e);
  }
  /**
   * User clicked trigger icon, toggle list.
   * @private
   */


  onTriggerClick(event) {
    if (!this.disabled) {
      // Pass focus flag as true if invoked by a key event
      this.togglePicker('key' in event);
    }
  }
  /**
   * User clicked on an editable input field. If it's a touch event
   * ensure that the keyboard is shown.
   * @private
   */


  showKeyboard({
    event
  }) {
    const input = this.input;

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(input) === input && event.target === input) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].suspendFocusEvents();
      input.blur();
      input.focus();
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].resumeFocusEvents();
    }
  } //endregion
  //region Toggle picker

  /**
   * Toggle the {@link #property-picker} visibility
   * @privateparam {Boolean} [focus] Pass `true` to focus the picker when it gets shown.
   */


  togglePicker(focus) {
    if (this.pickerVisible) {
      this.hidePicker();
    } else {
      this.showPicker(focus);
    }
  }
  /**
   * Show the {@link #property-picker}
   * @privateparam {Boolean} [focus] Pass `true` to focus the picker when it gets shown.
   */


  showPicker(focus) {
    const me = this,
          {
      picker
    } = me;

    if (!me.pickerHideShowListenersAdded) {
      picker.on({
        show: 'onPickerShow',
        hide: 'onPickerHide',
        thisObj: me
      });
      me.pickerHideShowListenersAdded = true;
    }

    picker.autoClose = me.autoClose;
    picker.show(); // Not been vetoed

    if (picker.isVisible) {
      if (focus) {
        me.focusPicker();
      }
    }
  }

  onPickerShow() {
    const me = this;
    me.pickerVisible = true;
    me.element.classList.add('b-open');
    me.trigger('togglePicker', {
      show: true
    });
    me.pickerTapOutRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
      globaltap: 'onPickerTapOut',
      thisObj: me
    });
    me.pickerKeyDownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.picker.element,
      keydown: 'onPickerKeyDown',
      thisObj: me
    });
  }

  onPickerHide() {
    const me = this;
    me.pickerVisible = false;
    me.element.classList.remove('b-open');
    me.trigger('togglePicker', {
      show: false
    });
    me.pickerTapOutRemover && me.pickerTapOutRemover();
    me.pickerKeyDownRemover && me.pickerKeyDownRemover();
  }

  onPickerTapOut({
    event
  }) {
    if (!this.owns(event.target)) {
      this.autoClosePicker();
    }
  }

  onPickerKeyDown(event) {
    if (event.key === 'Tab') {
      const activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(this.input),
            forwardedEvent = new KeyboardEvent('keydown', event); // Offer our own element a shot at the TAB event.
      // Some widgets or plugins may actively navigate.

      this.input.dispatchEvent(forwardedEvent); // Somebody might preventDefault on the synthesized event. We must honour that.
      // For example if we are the field for a cell Editor, and it started an edit on the adjacent cell.

      if (forwardedEvent.defaultPrevented) {
        event.preventDefault();
      } // No listener intervened, point the TAB event at the input,
      // and user agent default navigation will proceed.


      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(this.input) === activeEl) {
        this.input.focus();
      } // Some listener *did* navigate, prevent user agent default.
      else {
        event.preventDefault();
      } // If listeners have not destroyed us, close our picker.


      if (!this.isDestroyed) {
        this.hidePicker();
      }
    }
  } //endregion
  //region Visibility


  autoClosePicker() {
    if (this.autoClose) {
      this.hidePicker();
    }
  }
  /**
   * Hide picker
   */


  hidePicker() {
    if (this.pickerVisible) {
      this.picker.hide();
    }
  }

  focusPicker() {}

  focus() {
    const input = this.input; // If we are focusing an editable PickerField from a touch event, temporarily
    // set it to readOnly to prevent the showing of the intrusive keyboard.
    // It's more likely that a user on a touch device will interact with the picker
    // rather than the input field.
    // A second touch tap on an already focused input will show the keyboard;
    // see the showKeyboard method.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && this.editable) {
      input.readOnly = true;
      this.setTimeout(() => input.readOnly = false, 500);
    }

    super.focus();
  } //endregion


}
PickerField._$name = 'PickerField';

/***/ }),

/***/ "./lib/Core/widget/Popup.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Popup.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Popup; });
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';





/**
 * @module Core/widget/Popup
 */

/**
 * A floating Popup widget, which can contain child {@link Core.widget.Container#config-items widgets} or plain html. Serves as the base class
 * for Menu / Tooltip.
 *
 * @example
 * let popup = new Popup({
 *   forElement : document.querySelector('button'),
 *   items      : [
 *     { type : 'text', placeholder: 'Text' },
 *     { type: 'button', text: 'Okay', style: 'width: 100%', color: 'b-orange'}
 *   ]
 * });
 *
 * @classType popup
 * @inlineexample Core/widget/Popup.js
 *
 * @extends Core/widget/Panel
 */

class Popup extends _Panel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Popup';
  } // Factoryable type name


  static get type() {
    return 'popup';
  }

  static get configurable() {
    return {
      /**
       * Auto show flag for Popup.
       * If truthy then Popup is shown automatically upon hover.
       * @config {Boolean}
       * @default
       */
      autoShow: true,

      /**
       * By default a Popup is transient, and will {@link #function-close} when the user clicks or
       * taps outside its owned widgets and when focus moves outside its owned widgets.
       *
       * **Note**: {@link #config-modal Modal} popups won't {@link #function-close} when focus moves outside even if autoClose is `true`.
       *
       * Configure as `false` to make a Popup non-transient.
       * @config {Boolean}
       * @default
       */
      autoClose: true,

      /**
       * Show popup when user clicks the element that it is anchored to. Cannot be combined with showOnHover
       * @config {Boolean}
       * @default
       */
      showOnClick: false,

      /**
       * DOM element to attach popup.
       * @config {HTMLElement}
       */
      forElement: null,
      monitorResize: true,
      floating: true,
      hidden: true,
      axisLock: true,
      // Flip edges if align violates constrainTo
      hideAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? null : {
        opacity: {
          from: 1,
          to: 0,
          duration: '.3s',
          delay: '0s'
        }
      },
      showAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? null : {
        opacity: {
          from: 0,
          to: 1,
          duration: '.4s',
          delay: '0s'
        }
      },
      stripDefaults: {
        bbar: {
          layout: {
            justify: 'flex-end'
          }
        }
      },
      testConfig: {
        hideAnimation: null,
        showAnimation: null
      },

      /**
       * The action to take when calling the {@link #function-close} method.
       * By default, the popup is hidden.
       *
       * This may be set to `'destroy'` to destroy the popup upon close.
       * @config {String}
       * @default
       */
      closeAction: 'hide',

      /**
       * By default, tabbing within a Popup is circular - that is it does not exit.
       * Configure this as `false` to allow tabbing out of the Popup.
       * @config {Boolean}
       * @default
       */
      trapFocus: true,

      /**
       * By default a Popup is focused when it is shown.
       * Configure this as `false` to prevent automatic focus on show.
       * @config {Boolean}
       * @default
       */
      focusOnToFront: true,

      /**
       * Show a tool in the header to close this Popup, and allow `ESC` close it.
       * The tool is available in the {@link Core.widget.mixin.Toolable#property-tools} object
       * under the name `close`. It uses the CSS class `b-popup-close` to apply a
       * default close icon. This may be customized with your own CSS rules.
       * @default false
       * @config {Boolean}
       */
      closable: null,

      /**
       * Show a tool in the header to maximize this popup
       * @config {Boolean}
       * @default false
       */
      maximizable: null,

      /**
       * Optionally show an opaque mask below this Popup when shown.
       * Configure this as `true` to show the mask.
       *
       * When a Popup is modal, it defaults to being {@link Core.widget.Widget#config-centered centered}.
       * Also it won't {@link #function-close} when focus moves outside even if {@link #config-autoClose} is `true`.
       *
       * May also be an object containing the following properties:
       * * `closeOnMaskTap` Specify as `true` to {@link #function-close} when mask is tapped.
       * The default action is to focus the popup.
       *
       * Usage:
       * ```javascript
       * new Popup({
       *     title  : 'I am modal',
       *     modal  : {
       *         closeOnMaskTap : true
       *     },
       *     height : 100,
       *     width  : 200
       * });
       * ```
       *
       * @default false
       * @config {Boolean}
       */
      modal: null,

      /**
       * Set to `true` to make this widget take all available space in the visible viewport.
       * @member {Boolean} maximized
       * @category Float & align
       */

      /**
       * Set to `true` to make this widget take all available space in the visible viewport.
       * @config {Boolean}
       * @default false
       * @category Float & align
       */
      maximized: null,
      tools: {
        close: {
          cls: 'b-popup-close',
          handler: 'close',
          weight: -1000,
          hidden: true // shown when closable set to true

        },
        maximize: {
          cls: 'b-popup-expand',
          handler: 'toggleMaximized',
          weight: -999,
          hidden: true // shown when maximizable set to true

        }
      },
      highlightReturnedFocus: true
    };
  } //endregion
  //region Init & destroy


  finalizeInit() {
    const me = this;
    me.anchoredTo = me.forElement;
    me.initialAnchor = me.anchor;

    if (me.forElement && me.showOnClick) {
      // disable autoShow if not enabled by config
      if (!me.initialConfig.autoShow) {
        me.autoShow = false;
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.forElement,
        click: 'onElementUserAction',
        thisObj: me
      });
    }

    super.finalizeInit();

    if (me.autoShow) {
      if (me.autoShow === true) {
        me.show();
      } else {
        me.setTimeout(() => me.show(), me.autoShow);
      }
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments);
    const me = this;

    if (me.maximizable && me.headerElement) {
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.headerElement,
        dblclick: me.onHeaderDblClick,
        thisObj: me
      });
    }
  }

  doDestroy() {
    this.syncModalMask();
    super.doDestroy();
  } //endregion


  compose() {
    const {
      hasNoChildren,
      textContent
    } = this;
    return {
      class: {
        // Popup has extra CSS responsibilities at the top level.
        // The CSS needs to know whether it should impose a max-width.
        'b-text-popup': Boolean(textContent && hasNoChildren)
      }
    };
  } //region Show/hide

  /**
   * Performs the configured {@link #config-closeAction} upon this popup.
   * By default, the popup hides. The {@link #config-closeAction} may be
   * configured as `'destroy'`.
   * @fires beforeclose If popup is not hidden
   */


  close() {
    const me = this;
    /**
     * Fired when the {@link #function-close} method is called and the popup is not hidden.
     * May be vetoed by returning `false` from a handler.
     * @event beforeClose
     * @param {Core.widget.Popup} source - This Popup
     */

    if (!me._hidden && me.trigger('beforeClose') !== false || // we should destroy it even if it's hidden just omit beforeclose event
    me._hidden && me.closeAction === 'destroy') {
      // Focus moves unrelated to where the user's attention is upon this gesture.
      // Go into the keyboard mode where the focused widget gets a rendition so that
      // it is obvious where focus now is.
      // Must jump over EventHelper's global mousedown listener which will remove this class.
      if (me.containsFocus && me.highlightReturnedFocus) {
        me.setTimeout(() => me.element.classList.add('b-using-keyboard'), 0);
      }

      return me[me.closeAction]();
    }
  }

  toggleMaximized() {
    this.maximized = !this.maximized;
  }

  updateMaximized(value) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].toggleClasses(this.element, ['b-maximized'], value);
  } //endregion
  //region Events


  onInternalKeyDown(event) {
    // close on escape key
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      this.close(true);
    }
  }

  onDocumentMouseDown({
    event
  }) {
    const me = this,
          {
      owner
    } = me,
          {
      target
    } = event; // If mousedown was on our owning Button, it is that button's responsibility to
    // toggle its pressed state thereby hiding its menu, so prevent the focus move of the mousedown.

    if (event.type !== 'touchend' && owner !== null && owner !== void 0 && owner.isButton && owner._menu === me && owner.element.contains(target)) {
      event.preventDefault();
      return false;
    }

    if (me.modal && target === Popup.modalMask) {
      event.preventDefault();

      if (me.modal.closeOnMaskTap) {
        me.close();
      } else if (!me.containsFocus) {
        me.focus();
      }
    } // in case of outside click and if popup is focused, focusout will trigger closing
    else if (!me.owns(target) && me.autoClose && !me.containsFocus) {
      me.close();
    }
  }

  get isTopModal() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isVisible(Popup.modalMask) && this.element.previousElementSibling === Popup.modalMask;
  }

  onFocusIn(e) {
    const activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(this);
    super.onFocusIn(e); // No event handler has moved focus, and target is outermost el
    // then delegate to the focusElement which for a Container
    // is found by finding the first visible, focusable descendant widget.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(this) === activeEl && e.target === this.element) {
      this.focus();
    }
  }

  onFocusOut(e) {
    // For mobile browsers with virtual keyboard, when pressing Done key, focus should move back to the popup
    // https://github.com/bryntum/support/issues/2903
    const usingVirtualKeyboard = window.visualViewport && window.visualViewport.height < document.documentElement.clientHeight;

    if (!usingVirtualKeyboard && !this.modal && this.autoClose) {
      this.close();
    }

    super.onFocusOut(e);
  }

  onShow() {
    const me = this;

    if (me.autoClose) {
      me.addDocumentMouseDownListener();
    } // TODO: It's the floating "toFront" operation that should handle
    // focusing based on config focusOnToFront.


    if (me.focusOnToFront) {
      me.focus();
    }

    super.onShow && super.onShow(); // Insert the modal mask below this Popup if needed

    me.syncModalMask();
  }

  addDocumentMouseDownListener() {
    if (!this.mouseDownRemover) {
      this.mouseDownRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        globaltap: 'onDocumentMouseDown',
        thisObj: this
      });
    }
  }

  updateModal(modal) {
    // Modal implies that this is floating. Theres no ability for positioned widgets
    // to acquire a modal mask.
    if (modal) {
      this.floating = true;
    }
  }

  syncModalMask() {
    const me = this,
          {
      modal
    } = me; // Note the difference between Popup.modalMask and this.modalMask.
    // this.modalMask syncs the position of the element in the DOM
    // to be below this element. Popup.modalMask just returns the element.

    if (modal && me.isVisible) {
      // If we have not been explicitly positioned, a modal is centered.
      if (typeof me._x !== 'number' && typeof me._y !== 'number') {
        me.centered = true;
      }

      me.modalMask.classList.remove('b-hide-display');
      me.element.classList.add('b-modal');
    } else if (me.isPainted) {
      me.element.classList.remove('b-modal');
      const remainingModals = me.floatRoot.querySelectorAll('.b-modal'),
            topModal = remainingModals.length ? Popup.fromElement(remainingModals[remainingModals.length - 1], 'popup') : null; // If there are any other visible modals, drop the mask to just below the new topmost

      if (topModal) {
        topModal.syncModalMask();
      } else {
        Popup.modalMask.classList.add('b-hide-display');
      }
    }
  }

  onHide() {
    const me = this;

    if (me.mouseDownRemover) {
      me.mouseDownRemover();
      me.mouseDownRemover = null;
    }

    super.onHide && super.onHide(); // Insert the modal mask below the topmost Popup if needed, else hide it

    me.syncModalMask();
  }

  onElementUserAction() {
    this.show();
  }

  onHeaderDblClick() {
    if (this.maximizable) {
      this.toggleMaximized();
    }
  } //endregion


  updateClosable(closable) {
    this.tools.close.hidden = !closable;
  }

  updateMaximizable(maximizable) {
    this.tools.maximize.hidden = !maximizable;
  }
  /**
   * Returns the modal mask element for this Popup correctly positioned just below this Popup.
   * @internal
   */


  get modalMask() {
    const {
      modalMask
    } = Popup;

    if (modalMask.nextElementSibling !== this.element) {
      this.floatRoot.insertBefore(modalMask, this.element);
    }

    return modalMask;
  }
  /**
   * Returns the modal mask element. It does NOT guarantee its placement in the DOM relative
   * to any Popup. To get the modal mask for a particular Popup, use the instance property.
   * @internal
   */


  static get modalMask() {
    if (!this._modalMask) {
      this._modalMask = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        className: 'b-modal-mask b-hide-display'
      }); // Mousewheel should not scroll the body "through" a modal mask.

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: this._modalMask,
        wheel: e => e.preventDefault()
      });
    }

    return this._modalMask;
  }

} // Register this widget type with its Factory

Popup.initClass();
Popup._$name = 'Popup';

/***/ }),

/***/ "./lib/Core/widget/Renderable.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/Renderable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Renderable; });
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';








const {
  defineProperty
} = Reflect;
/**
 * @module Core/widget/Renderable
 */

/**
 * This class provides element rendering and automatic synchronization based on config property changes.
 *```
 *  class Label extends Renderable {
 *      static get configurable() {
 *          return {
 *              text : {
 *                  value: null,
 *
 *                  $config : 'render'
 *              }
 *          };
 *      }
 *
 *      renderDom() {
 *          return {
 *              tag: 'label',
 *              children: [
 *                  this.text
 *              ]
 *          };
 *      }
 *  }
 *```
 * A class can opt to not specify its render configs. In this case, these will be determined automatically, but with
 * some additional cost. This may not be worth considering if only a few instances are ever likely.
 *
 * @private
 */

class Renderable extends _Base_js__WEBPACK_IMPORTED_MODULE_7__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
  static get configurable() {
    return {
      /**
       * The top-level DOM element for this object. This element is produced from the {@link #function-renderDom}
       * method of the derived class. As configs used by `renderDom` change, a synchronization of the DOM is
       * scheduled by calling {@link #function-refreshDom}. This call is made automatically by this class, making
       * it rarely necessary to call `refreshDom` directly.
       * @config {HTMLElement}
       * @category DOM
       */
      element: null
    };
  }

  static get delayable() {
    return {
      refreshDom: 'raf'
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * Returns the Set of configs defined as `render: true`, that is, the configs that determine the rendering (via
   * `renderDom`). If no such configs are defined, this method returns `null`.
   *
   * @returns {Set}
   * @private
   */


  static get renderConfigs() {
    const me = this,
          meta = me.$meta;
    let renderConfigs = meta.renderConfigs,
        configs,
        name;

    if (renderConfigs === undefined) {
      // if (first time for this class)
      renderConfigs = null;
      configs = meta.configs;

      for (name in configs) {
        if (configs[name].render) {
          (renderConfigs || (renderConfigs = new Set())).add(name);
        }
      } // Put $renderConfigs on the prototype so that onConfigChange is as simple as possible:


      meta.renderConfigs = me.prototype.$renderConfigs = renderConfigs;
    }

    return renderConfigs;
  } //region Init


  construct(...args) {
    this.$iid = ++Renderable.$idSeed;
    this.byRef = {};
    super.construct(...args);

    if (this.onDraw !== Renderable.prototype.onDraw) {
      this.initDrawable();
    }
  }

  startConfigure(config) {
    this.element = this.renderContext.renderDom(); // calls changeElement()

    super.startConfigure(config);
  } //endregion
  //region Configs


  get element() {
    // NOTE: We can replace the getter of a config property
    // Asking for the primary el is a good sign that we need to sync the DOM:
    this.refreshDom.flush();
    return this._element;
  }
  /**
   * This is called when the `element` config is assigned (via the setter).
   * @param {HTMLElement} element The new element being assigned.
   * @param {HTMLElement|null} oldElement The old element (previously assigned) or `null`.
   * @returns {HTMLElement}
   * @private
   */


  changeElement(element, oldElement) {
    const me = this;

    if (oldElement) {
      oldElement.remove();
    }

    if (element) {
      element.id = me.id;
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement(element, {
        refOwner: me
      });
    }

    return element;
  }

  updateId(id, oldId) {
    const me = this;

    if (oldId) {
      const element = me.element;
      element.id = id;
      me.fixRefOwnerId(element, id, oldId);
    }
  } //endregion
  //region Misc

  /**
   * Returns the `classList` of this instance's `element`.
   * @property {DOMTokenList}
   */


  get classes() {
    return this.element.classList;
  }
  /**
   * This method fixes the element's `$refOwnerId` when this instance's `id` is changing.
   * @param {HTMLElement} el The element to fix.
   * @param {String} id The new id being assigned.
   * @param {String} oldId The old id (previously assigned).
   * @private
   */


  fixRefOwnerId(el, id, oldId) {
    if (el.$refOwnerId === oldId) {
      el.$refOwnerId = id;
      const ref = el.$reference;

      if (ref) {
        el.id = `${id}-${ref}`;
      }

      for (const c of el.childNodes) {
        this.fixRefOwnerId(c, id, oldId);
      }
    }
  }

  onConfigChange({
    name
  }) {
    // The $renderConfigs Set is either on our prototype (due to renderConfigs getter) or on our instance (due to
    // renderContext getter):
    if (!this.isConfiguring && this.$renderConfigs.has(name)) {
      this.refreshDom();
    }
  } //endregion
  //region Rendering

  /**
   * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @private
   */


  attachRef(name, el, domConfig) {
    const me = this,
          key = '_' + name,
          {
      listeners
    } = domConfig;

    if (!(key in me)) {
      defineProperty(me, name, {
        get() {
          // Asking for a ref el is a good sign that we need to sync the DOM:
          me.refreshDom.flush();
          return me[key];
        },

        set(el) {
          me[key] = el; // Key elements contain owner pointer (Not supported on IE SVG).
          // if (el && el.dataset) {
          //     el.dataset.ownerCmp = me.id;
          // }
        }

      });
    }

    el.id = `${me.id}-${name}`;
    me.byRef[name] = el;
    me[name] = el;

    if (listeners) {
      domConfig.listeners = {
        on: listeners,
        un: _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(Object.assign({
          element: el,
          thisObj: me
        }, listeners))
      };
    }
  }
  /**
   * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @private
   */


  detachRef(name, el, domConfig) {
    if (domConfig.listeners) {
      domConfig.listeners.un();
      domConfig.listeners = null;
    }

    this[name] = null;
    delete this.byRef[name];
  }
  /**
   * This method returns a {@link Core.helper.DomHelper#function-createElement-static} config object that describes
   * the desired elements for this instance.
   *
   * This method is called to produce the initial DOM structure and again as necessary to generate the DOM for the
   * current state. The DOM produced by these subsequent calls is then passed through
   * {@link Core.helper.DomSync#function-sync-static DomSync.sync()} to update the DOM.
   * @returns {Object}
   */


  renderDom() {
    // abstract method provided by derived class
    return {};
  }
  /**
   * This property is the object to use when calling the `renderDom` method. It may evaluate to this instance (if
   * the class declares its render configs) or a helper object to track config usage during the `renderDom` call.
   * @property {Object}
   * @private
   */


  get renderContext() {
    const me = this,
          meta = me.$meta,
          C = me.constructor;
    let renderConfigs = meta.renderConfigs || C.renderConfigs,
        context = me; // If the class author did not declare any configs as render:true, then we make a proxy-like object that can
    // detect getter calls to build that Set. Since the getters may not all trigger on any given rendering, we
    // cannot share this work across instances since they may take different control paths.

    if (!renderConfigs) {
      context = Object.create(me);
      renderConfigs = new Set();

      for (const name in meta.configs) {
        defineProperty(context, name, {
          get() {
            renderConfigs.add(name);
            return me[name];
          }

        });
      } // In order to be substitutable for the Renderable, we need the same method name... we just need to run
      // renderDom w/ our context as "this":


      context.renderDom = () => {
        return me.renderDom.call(context);
      };

      me.$renderConfigs = renderConfigs;
    } // Replace this getter with the actual context so we don't get called again:


    defineProperty(me, 'renderContext', {
      value: context
    });
    return context;
  }
  /**
   * This method synchronized the DOM produced by {@link #function-renderDom} with what was previously produced and
   * updates the elements accordingly.
   *
   * This method is buffered such that calls to it do not immediately execute. To perform the refresh immediately,
   * do this:
   *```
   *  instance.refreshDom.now();
   *```
   * To flush any potential updates to the DOM (and do nothing if there are none), do this:
   *```
   *  instance.refreshDom.flush();
   *```
   * To determine if there are updates to the DOM pending, do this:
   *```
   *  if (instance.refreshDom.isPending) {
   *      ...
   *  }
   *```
   */


  refreshDom() {
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].sync({
      targetElement: this.element,
      domConfig: this.renderContext.renderDom(),
      refOwner: this,
      // This limits the sync() to only removing the classes and styles added by previous renderings. This
      // allows dynamically added styles and classes to be preserved:
      strict: true
    });
  } //endregion


  onListen(eventName) {
    // Only add the b-drawable-el when someone first listens for the draw event since it may never happen...
    if (eventName === 'draw') {
      this.initDrawable();
    }
  }

  initDrawable() {
    const me = this;

    if (!me.intersector) {
      let el = Object.values(me.byRef).find(el => el.classList.contains('b-drawable'));

      if (!el) {
        el = me.element;
        el.classList.add('b-drawable');
      } // TODO Not supported in IE11 even w/polyfills at the moment


      me.intersector = true; // me.intersector = new IntersectionObserver(entries => {
      //     if (!me.isDestroyed) {
      //         entries.forEach(ent => {
      //             if (ent.isIntersecting) {
      //                 me.onDraw({
      //                     count : ++me.drawCounter
      //                 });
      //             }
      //         });
      //     }
      // });
      //
      // me.intersector.observe(el);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        element: _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
          parent: el,
          class: 'b-drawable-el'
        }),

        animationend({
          animationName
        }) {
          if (animationName === 'b-drawable-anim') {
            me.onDraw({
              count: ++me.drawCounter
            });
          }
        }

      });
    }
  }

  onDraw(ev) {
    this.trigger('draw', ev);
  }

}
Renderable.$idSeed = 0;
Object.assign(Renderable.prototype, {
  drawCounter: 0,
  hasGeneratedId: false,
  intersector: null
});
Renderable._$name = 'Renderable';

/***/ }),

/***/ "./lib/Core/widget/Ripple.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Ripple.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Ripple; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';






let lastTouchTime = 0;

const hasRipple = w => w.ripple;

class Ripple extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      old_element: {
        children: [{
          className: 'b-ripple-inner',
          reference: 'rippleElement'
        }]
      },
      element: {
        children: [{
          tag: 'svg',
          class: 'b-ripple-inner',
          reference: 'rippleElement',
          ns: 'http://www.w3.org/2000/svg',
          version: '1.1',
          viewBox: '0 0 100 100',
          children: [{
            reference: 'circleElement',
            tag: 'circle',
            cx: '0',
            cy: '0',
            r: 10
          }]
        }]
      },
      floating: true,
      hideAnimation: false,
      showAnimation: false,
      scrollAction: 'realign',
      color: 'rgba(0,0,0,.3)',
      startRadius: 10,
      radius: 100
    };
  }

  static get $name() {
    return 'Ripple';
  }

  afterConstruct() {
    super.afterConstruct();
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: this.rootElement,
      mousedown: 'onRippleControllingEvent',
      thisObj: this,
      capture: true,
      once: true
    });
  }

  onRippleControllingEvent(event) {
    var _me$listenerDetacher;

    const me = this;
    me.show();
    const rippleAnimation = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(me.circleElement, 'animationName');
    me.hide();
    (_me$listenerDetacher = me.listenerDetacher) === null || _me$listenerDetacher === void 0 ? void 0 : _me$listenerDetacher.call(me); // If our theme supports ripples, add our listeners

    if (rippleAnimation && rippleAnimation !== 'none') {
      me.listenerDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        // Trap all mousedowns and see if the encapsulating Component is configured to ripple
        mousedown: {
          element: me.rootElement,
          capture: true,
          handler: 'onMousedown'
        },
        touchstart: {
          element: me.rootElement,
          capture: true,
          handler: 'onTouchStart'
        },
        // Hide at the end of the ripple
        animationend: {
          element: me.circleElement,
          handler: 'onAnimationEnd'
        },
        thisObj: me
      }); // If this is the first mousedown, start listening to theme changes and trigger ripple manually

      if (event.type === 'mousedown') {
        me.onMousedown(event);
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          theme: 'onRippleControllingEvent',
          thisObj: this
        });
      }
    }
  }

  onTouchStart(event) {
    lastTouchTime = performance.now();
    this.handleTriggerEvent(event);
  }

  onMousedown(event) {
    // We need to prevent a touchend->mousedown simulated mousedown from triggering a ripple.
    // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
    if (performance.now() - lastTouchTime > 200) {
      this.handleTriggerEvent(event);
    }
  }

  handleTriggerEvent(event) {
    const targetWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(event.target, hasRipple);

    if (targetWidget) {
      const rippleCfg = targetWidget.ripple,
            target = rippleCfg.delegate ? event.target.closest(rippleCfg.delegate) : targetWidget.focusElement || targetWidget.element;

      if (target) {
        const ripple = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
          event,
          target,
          radius: this.radius
        }, rippleCfg); // The clip option is specified as a string property name or delegate

        if (typeof ripple.clip === 'string') {
          ripple.clip = targetWidget[ripple.clip] || event.target.closest(ripple.clip); // Not inside an instance of the clip delegate, then no ripple

          if (!ripple.clip) {
            return;
          }
        }

        this.ripple(ripple);
      }
    }
  }

  ripple({
    event,
    point = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getClientPoint(event),
    target = event.target,
    clip = target,
    radius = this.radius,
    color = this.color
  }) {
    this.clip = clip;
    clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(clip, null, true);
    const me = this,
          centreDelta = clip.getDelta(point),
          rippleStyle = me.rippleElement.style,
          circleElement = me.circleElement,
          borderRadius = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(target, 'border-radius');
    me.hide();
    rippleStyle.transform = `translateX(${centreDelta[0]}px) translateY(${centreDelta[1]}px)`;
    rippleStyle.height = rippleStyle.width = `${radius}px`;
    me.element.style.borderRadius = borderRadius;
    circleElement.setAttribute('r', radius);
    circleElement.setAttribute('fill', color); // Show aligned center to center with our clipping region.

    me.showBy({
      target: clip,
      align: 'c-c',
      matchSize: true
    });
  } // When fully expanded, it's all over.


  onAnimationEnd(event) {
    if (event.animationName === 'b-ripple-expand') {
      this.hide();
    }
  }

}
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].RippleClass = Ripple;
Ripple._$name = 'Ripple';

/***/ }),

/***/ "./lib/Core/widget/SlideToggle.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/SlideToggle.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SlideToggle; });
/* harmony import */ var _Checkbox_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Checkbox.js */ "./lib/Core/widget/Checkbox.js");
var productName = 'gantt';

/**
 * @module Core/widget/SlideToggle
 */

/**
 * SlideToggle field is a variation of {@link Core.widget.Checkbox} with a sliding toggle instead of box with check mark.
 * It wraps <code>&lt;input type="checkbox"&gt;</code>.
 * Color can be specified and you can optionally configure {@link #config-text} to display in a label to the right of
 * the toggle in addition to a standard field {@link #config-label}.
 *
 * {@inlineexample Core/widget/SlideToggle.js vertical}
 *
 * This field can be used as an {@link Grid.column.Column#config-editor} for the {@link Grid.column.Column}.
 *
 * @extends Core/widget/Checkbox
 * @classType slidetoggle
 */

class SlideToggle extends _Checkbox_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SlideToggle';
  }

  static get type() {
    return 'slidetoggle';
  }

  static get properties() {
    return {
      toggledCls: 'b-slidetoggle-checked'
    };
  }

  construct(config) {
    if (config !== null && config !== void 0 && config.checked) {
      config.cls = (config.cls || '') + ' ' + this.constructor.properties.toggledCls;
    }

    super.construct(config);
  }

  get innerElements() {
    const innerEls = super.innerElements;
    innerEls.splice(1, 0, this.toggleElement);

    if (this.text) {
      innerEls[innerEls.length - 1].class = 'b-slidetoggle-label';
    } else {
      // Remove label, not used
      innerEls.pop();
    }

    return innerEls;
  }

  get toggleElement() {
    return {
      class: 'b-slidetoggle-toggle',
      reference: 'slideToggle',
      children: [{
        class: 'b-slidetoggle-thumb',
        reference: 'slideThumb'
      }]
    };
  }

  internalOnChange() {
    super.internalOnChange();
    this.element.classList[this.value ? 'add' : 'remove'](this.toggledCls);
  }

}
SlideToggle.initClass();
SlideToggle._$name = 'SlideToggle';

/***/ }),

/***/ "./lib/Core/widget/Slider.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Slider.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Slider; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';



/**
 * @module Core/widget/Slider
 */

/**
 * Wraps native &lt;input type="range"&gt;
 *
 * @extends Core/widget/Widget
 *
 * @example
 * let slider = new Slider({
 *   text: 'Choose value'
 * });
 *
 * @classType slider
 * @inlineexample Core/widget/Slider.js
 */

class Slider extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Slider';
  } // Factoryable type name


  static get type() {
    return 'slider';
  }

  static get configurable() {
    return {
      /**
       * Get/set text. Appends value if Slider.showValue is true
       * @member {String} text
       */

      /**
       * Slider label text
       * @config {String}
       */
      text: null,

      /**
       * Show value in label (appends in () if text is set)
       * @config {Boolean}
       * @default
       */
      showValue: true,

      /**
       * Show the slider value in a tooltip
       * @config {Boolean}
       * @default
       */
      showTooltip: false,

      /**
       * Get/set min value
       * @member {Number} min
       */

      /**
       * Minimum value
       * @config {Number}
       * @default
       */
      min: 0,

      /**
       * Get/set max value
       * @member {Number} max
       */

      /**
       * Maximum value
       * @config {Number}
       * @default
       */
      max: 100,

      /**
       * Get/set step size
       * @member {Number} step
       */

      /**
       * Step size
       * @config {Number}
       * @default
       */
      step: 1,

      /**
       * Get/set value
       * @member {Number} value
       */

      /**
       * Initial value
       * @config {Number}
       */
      value: 50,

      /**
       * Unit to display next to the value, when configured with `showValue : true`
       * @config {String}
       * @default
       */
      unit: null,
      // The value is set in the Light theme. The Material theme will have different value.
      thumbSize: 20,
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'tooltip',
          align: 'b-t',
          anchor: false,
          // No anchor displayed since thumbSize is different for different themes
          axisLock: true
        }
      },
      localizableProperties: ['text']
    };
  } //endregion
  //region Init


  compose() {
    const {
      id,
      min,
      max,
      showValue,
      step,
      text,
      value,
      unit = ''
    } = this,
          inputId = `${id}-input`,
          hasText = Boolean(text || showValue);
    return {
      class: {
        'b-has-label': hasText,
        'b-text': hasText
      },
      children: {
        input: {
          tag: 'input',
          type: 'range',
          id: inputId,
          reference: 'input',
          min,
          max,
          step,
          value,
          listeners: {
            input: 'onInternalInput',
            change: 'onInternalChange',
            mouseover: 'onInternalMouseOver',
            mouseout: 'onInternalMouseOut'
          }
        },
        label: {
          tag: 'label',
          for: inputId,
          html: showValue ? text ? `${text} (${value}${unit})` : value + unit : text
        }
      }
    };
  }

  get focusElement() {
    return this.input;
  }

  get percentProgress() {
    return (this.value - this.min) / (this.max - this.min) * 100;
  } //endregion
  //region Events

  /**
   * Fired while slider thumb is being dragged.
   * @event input
   * @param {Core.widget.Slider} source The slider
   * @param {String} value The value
   */

  /**
   * Fired after the slider value changes (on mouse up following slider interaction).
   * @event change
   * @param {String} value The value
   * @param {Boolean} userAction Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Slider} source The slider
   */

  /* break from doc comment */


  onInternalChange() {
    this.updateUI();
    this.triggerChange(true);
    this.trigger('action', {
      value: this.value
    });
  }

  onInternalInput() {
    this.value = parseInt(this.input.value, 10);
    this.trigger('input', {
      value: this.value
    });
  }

  onInternalMouseOver() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.showBy({
      target: _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(this.input).inflate(this.thumbSize / 2, -this.thumbSize / 2),
      align: `b-t${Math.round(this.percentProgress)}`
    });
  }

  onInternalMouseOut() {
    var _this$tooltip2;

    (_this$tooltip2 = this.tooltip) === null || _this$tooltip2 === void 0 ? void 0 : _this$tooltip2.hide();
  }

  triggerChange(userAction) {
    this.triggerFieldChange({
      value: this.value,
      valid: true,
      userAction
    });
  } //endregion
  //region Config Handling
  // max


  updateMax(max) {
    const me = this;

    if (me.input && me._value > max) {
      me.value = max;
      me.trigger('input', {
        value: me.value
      });
    }
  } // min


  updateMin(min) {
    const me = this;

    if (me.input && me._value < min) {
      me.value = min;
      me.trigger('input', {
        value: me.value
      });
    }
  } // tooltip


  changeTooltip(config, existingTooltip) {
    var _this$unit;

    if (config) {
      config.owner = this;
    }

    return this.showTooltip ? _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existingTooltip, config, {
      owner: this,
      defaults: {
        forElement: this.input,
        html: String(this.value) + ((_this$unit = this.unit) !== null && _this$unit !== void 0 ? _this$unit : '')
      }
    }) : null;
  }

  updateValue(value) {
    const me = this,
          {
      input,
      _tooltip
    } = me;

    if (_tooltip) {
      var _me$unit;

      _tooltip.html = me.value + ((_me$unit = me.unit) !== null && _me$unit !== void 0 ? _me$unit : '');
    }

    if (input && input.value !== String(value)) {
      input.value = value;
      me.triggerChange(false);
    }

    me.updateUI();
  } //endregion
  //region Util


  updateUI() {
    var _me$_tooltip, _me$_tooltip2;

    const me = this; // Don't measure the UI unless we need to

    ((_me$_tooltip = me._tooltip) === null || _me$_tooltip === void 0 ? void 0 : _me$_tooltip.isVisible) && ((_me$_tooltip2 = me._tooltip) === null || _me$_tooltip2 === void 0 ? void 0 : _me$_tooltip2.alignTo({
      target: _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(me.input).inflate(me.thumbSize / 2, -me.thumbSize / 2),
      align: `b-t${Math.round(me.percentProgress)}`
    }));
  } //endregion


} // Register this widget type with its Factory

Slider.initClass();
Slider._$name = 'Slider';

/***/ }),

/***/ "./lib/Core/widget/Splitter.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Splitter.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Splitter; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';




/**
 * @module Core/widget/Splitter
 */

const classesHV = ['b-horizontal', 'b-vertical'],
      hasFlex = el => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el.parentElement, 'display') === 'flex' && (parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el, 'flex-basis'), 10) || parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el, 'flex-grow'), 10)),
      verticality = {
  horizontal: false,
  vertical: true
};
/**
 * A simple splitter widget that resizes the elements next to it or above/below it depending on orientation.
 *
 * @extends Core/widget/Widget
 * @classType splitter
 * @inlineexample Core/widget/Splitter.js
 */


class Splitter extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Splitter';
  } // Factoryable type name


  static get type() {
    return 'splitter';
  }

  static get configurable() {
    return {
      /**
       * Splitter orientation, see {@link #config-orientation}. When set to 'auto' then actually used orientation
       * can be retrieved using {@link #property-currentOrientation}.
       * @member {String} orientation
       * @readonly
       */

      /**
       * The splitters orientation, configurable with 'auto', 'horizontal' or 'vertical'.
       *
       * 'auto' tries to determine the orientation by either checking the `flex-direction` of the parent element
       * or by comparing the positions of the closest sibling elements to the splitter. If they are above and
       * below 'horizontal' is used, if not it uses 'vertical'.
       *
       * ```
       * new Splitter({
       *    orientation : 'horizontal'
       * });
       * ```
       *
       * To receive the actually used orientation when configured with 'auto', see
       * {@link #property-currentOrientation}.
       *
       * @config {String}
       * @default
       */
      orientation: 'auto',
      vertical: null,
      containerElement: {
        $config: 'nullify',
        value: null
      },
      nextNeighbor: {
        $config: 'nullify',
        value: null
      },
      previousNeighbor: {
        $config: 'nullify',
        value: null
      }
    };
  }

  static get delayable() {
    return {
      syncState: 'raf'
    };
  } //endregion
  //region Init & destroy


  doDestroy() {
    var _this$mouseDetacher;

    (_this$mouseDetacher = this.mouseDetacher) === null || _this$mouseDetacher === void 0 ? void 0 : _this$mouseDetacher.call(this);
    super.doDestroy();
  } //endregion
  //region Template & element


  compose() {
    return {
      class: {
        'b-splitter': 1
      },
      listeners: _objectSpread({
        pointerdown: 'onMouseDown',
        mouseenter: 'syncState'
      }, !_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents && {
        mousedown: 'onMouseDown',
        touchstart: 'onMouseDown'
      })
    };
  } //endregion
  //region Orientation

  /**
   * Get actually used orientation, which is either the configured value for `orientation` or if configured with
   * 'auto' the currently used orientation.
   * @property {String}
   * @readonly
   */


  get currentOrientation() {
    return this.vertical ? 'vertical' : 'horizontal';
  }

  get nextWidget() {
    return _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.nextElementSibling, 1);
  }

  get previousWidget() {
    return _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.previousElementSibling, 1);
  }

  updateContainerElement(containerElement) {
    var _me$stateDetector;

    const me = this;
    me.stateDetector = (_me$stateDetector = me.stateDetector) === null || _me$stateDetector === void 0 ? void 0 : _me$stateDetector.disconnect();

    if (containerElement) {
      me.stateDetector = new MutationObserver(() => me.syncState()); // syncState runs on next raf

      me.stateDetector.observe(containerElement, {
        attributes: true,
        // in case style changes flip our orientation (when == 'auto')
        childList: true // watch for our neighbors to render (so we can disable on hidden/collapsed state)

      });
    }
  }

  updateNextNeighbor(next) {
    this.watchNeighbor(next, 'next');
  }

  updatePreviousNeighbor(previous) {
    this.watchNeighbor(previous, 'previous');
  }

  watchNeighbor(neighbor, name) {
    this.detachListeners(name);
    neighbor === null || neighbor === void 0 ? void 0 : neighbor.on({
      name,
      thisObj: this,
      // beforeUpdateDisabled : 'syncState',  // ?
      collapse: 'syncState',
      expand: 'syncState',
      hide: 'syncState',
      show: 'syncState'
    });
  }

  updateOrientation() {
    this.syncState.now();
  }

  updateVertical(vertical) {
    var _this$element;

    const classList = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.classList;
    classList === null || classList === void 0 ? void 0 : classList.add(classesHV[vertical ? 1 : 0]);
    classList === null || classList === void 0 ? void 0 : classList.remove(classesHV[vertical ? 0 : 1]);
  }
  /**
   * Determine orientation when set to `'auto'` and detects neighboring widgets to monitor their hidden/collapsed
   * states.
   * @private
   */


  syncState() {
    var _verticality$me$orien;

    const me = this,
          {
      element,
      nextWidget,
      previousWidget
    } = me;
    let vertical = (_verticality$me$orien = verticality[me.orientation]) !== null && _verticality$me$orien !== void 0 ? _verticality$me$orien : null;
    me.nextNeighbor = nextWidget;
    me.previousNeighbor = previousWidget;
    me.disabled = nextWidget && (nextWidget.collapsible && nextWidget.collapsed || nextWidget.hidden) || previousWidget && (previousWidget.collapsible && previousWidget.collapsed || previousWidget.hidden);

    if (vertical !== null && nextWidget && previousWidget) {
      me.containerElement = null;
    } else {
      // we'll need to monitor parent element child list changes until our neighbors are added to the DOM
      me.containerElement = element.parentElement; // Orientation auto and already rendered, determine orientation to use

      if (me.rendered && element.offsetParent) {
        const flexDirection = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(element.parentElement, 'flex-direction'); // If used in a flex layout, determine orientation from flex-direction

        if (flexDirection) {
          vertical = !flexDirection.startsWith('column');
        } // If used in some other layout, try to determine from sibling elements position
        else {
          const previous = element.previousElementSibling,
                next = element.nextElementSibling;

          if (!previous || !next) {
            // To early in rendering, next sibling not rendered yet
            return;
          }

          const prevRect = previous.getBoundingClientRect(),
                nextRect = next.getBoundingClientRect(),
                topMost = prevRect.top < nextRect.top ? prevRect : nextRect,
                bottomMost = topMost === nextRect ? prevRect : nextRect; // orientation = topMost.top !== bottomMost.top ? 'horizontal' : 'vertical';

          vertical = topMost.top === bottomMost.top;
        }
      }
    }

    me.vertical = vertical;
  } //endregion
  //region Events


  onMouseDown(event) {
    event.preventDefault();

    if (event.touches) {
      event = event.touches[0];
    }

    const me = this,
          {
      element
    } = me,
          prev = element.previousElementSibling,
          next = element.nextElementSibling,
          prevHasFlex = hasFlex(prev),
          nextHasFlex = hasFlex(next),
          flexed = []; // First stop any ongoing drag operation, since we cannot trust that we always get the mouseup event

    me.mouseDetacher && me.mouseDetacher(); // Remember flexed children, to enable maintaining their proportions on resize

    for (const child of element.parentElement.children) {
      if (hasFlex(child) && child !== element) {
        flexed.push({
          element: child,
          width: child.offsetWidth,
          height: child.offsetHeight
        });
      }
    }

    me.context = {
      startX: event.pageX,
      startY: event.pageY,
      prevWidth: prev.offsetWidth,
      prevHeight: prev.offsetHeight,
      nextWidth: next.offsetWidth,
      nextHeight: next.offsetHeight,
      prevHasFlex,
      nextHasFlex,
      flexed,
      prev,
      next
    };
    const events = {
      element: document,
      pointermove: 'onMouseMove',
      pointerup: 'onMouseUp',
      thisObj: me
    };

    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents) {
      events.mousemove = 'onMouseMove';
      events.touchmove = 'onMouseMove';
      events.mouseup = events.touchend = 'onMouseUp';
    }

    me.mouseDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(events);
  }

  onMouseMove(event) {
    const me = this,
          {
      context,
      nextWidget,
      previousWidget
    } = me,
          {
      next,
      prev
    } = context,
          deltaX = event.pageX - context.startX,
          deltaY = event.pageY - context.startY;
    event.preventDefault();
    Object.assign(context, {
      deltaX,
      deltaY
    });

    if (!context.started) {
      context.started = true;
      me.trigger('start', {
        context,
        event
      }); // Convert heights/widths to flex for flexed elements to maintain proportions
      // 100px high -> flex-grow 100

      context.flexed.forEach(flexed => {
        flexed.element.style.flexGrow = me.vertical ? flexed.width : flexed.height; //Remove flex-basis, since it interferes with resizing

        flexed.element.style.flexBasis = '0';
      });
    } // Adjust flex-grow or width/height for splitters closest siblings


    if (me.vertical) {
      const newPrevWidth = context.prevWidth + deltaX,
            newNextWidth = context.nextWidth - deltaX;

      if (context.prevHasFlex) {
        prev.style.flexGrow = newPrevWidth;
      } else if (previousWidget) {
        previousWidget.width = newPrevWidth;
      } else {
        prev.style.width = `${newPrevWidth}px`;
      }

      if (context.nextHasFlex) {
        next.style.flexGrow = newNextWidth;
      } else if (nextWidget) {
        nextWidget.width = newNextWidth;
      } else {
        next.style.width = `${newNextWidth}px`;
      }
    } else {
      const newPrevHeight = context.prevHeight + deltaY,
            newNextHeight = context.nextHeight - deltaY;

      if (context.prevHasFlex) {
        prev.style.flexGrow = newPrevHeight;
      } else if (previousWidget) {
        previousWidget.height = newPrevHeight;
      } else {
        prev.style.height = `${newPrevHeight}px`;
      }

      if (context.nextHasFlex) {
        next.style.flexGrow = newNextHeight;
      } else if (nextWidget) {
        nextWidget.height = newNextHeight;
      } else {
        next.style.height = `${newNextHeight}px`;
      }
    }

    me.trigger('move', {
      context,
      event
    });
  }

  onMouseUp(event) {
    const me = this;
    me.mouseDetacher && me.mouseDetacher();
    me.mouseDetacher = null;

    if (me.context.started) {
      me.trigger('end', {
        context: me.context,
        event
      });
    }

    me.context = null;
  } //endregion


  render() {
    super.render(...arguments);
    this.syncState.now();

    if (this.vertical === null) {
      this.syncState(); // try again on next raf
    }
  }

} // Register this widget type with its Factory

Splitter.initClass();
Splitter._$name = 'Splitter';

/***/ }),

/***/ "./lib/Core/widget/Tab.js":
/*!********************************!*\
  !*** ./lib/Core/widget/Tab.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tab; });
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Core/widget/Tab
 */

/**
 * This widget class is used to present items in a {@link Core.widget.TabPanel} on its {@link Core.widget.TabBar tabBar}.
 * A reference to this widget is stored via the {@link Core.widget.Widget#config-tab} config on the tab panel's items.
 *
 * ```javascript
 * let tabPanel = new TabPanel({
 *  items: [
 *      {
 *          title: 'Settings',
 *          // Tab configs
 *          tab : {
 *              // Show an icon in the tab
 *              icon : 'b-fa b-fa-cog'
 *          },
 *          items: [
 *              ...
 *          ]
 *      }
 *  ]
 * });
 * ```
 * @extends Core/widget/Button
 * @classType tab
 */

class Tab extends _Button_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'Tab';
  } // Factoryable type name


  static get type() {
    return 'tab';
  }

  static get configurable() {
    return {
      /**
       * This config is set to `true` when this tab represents the `activeTab` of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} active
       * @default false
       */
      active: null,

      /**
       * This config is set to the ordinal position of this tab in the {@link Core.widget.TabPanel}. It is managed
       * by the tab panel is not set directly.
       * @config {Number} index
       */
      index: null,

      /**
       * This config is set to `true` when this tab represents the first tab of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} isFirst
       */
      isFirst: null,

      /**
       * This config is set to `true` when this tab represents the last tab of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} isLast
       */
      isLast: null,

      /**
       * The {@link Core.widget.Widget} in the {@link Core.widget.TabPanel} corresponding to this tab. This is
       * managed by the tab panel is not set directly.
       * @config {Core.widget.Widget} item
       */
      item: {
        value: null,
        $config: 'nullify'
      },
      itemCls: null,

      /**
       * The tab panel that owns this tab.
       * @config {Core.widget.TabPanel} tabPanel
       */
      tabPanel: null,

      /**
       * The config property on this tab that will be set to the value of the {@link #config-titleSource} property
       * of this tab's {@link #config-item}.
       *
       * By default, the {@link #config-text} property of the tab is set to the {@link Core.widget.Widget#config-title}
       * property of its {@link #config-item}.
       * @config {String} titleProperty
       * @default
       */
      titleProperty: 'text',

      /**
       * The config property on this tab's {@link #config-item} that is used to set the value of the
       * {@link #config-titleProperty} of this tab.
       *
       * By default, the {@link #config-text} property of the tab is set to the {@link Core.widget.Widget#config-title}
       * property of its {@link #config-item}.
       * @config {String} titleSource
       * @default
       */
      titleSource: 'title'
    };
  }

  compose() {
    const {
      active,
      cls,
      index,
      isFirst,
      isLast
    } = this;
    return {
      tabindex: -1,
      class: _objectSpread({
        'b-tabpanel-tab': 1,
        'b-active': active,
        'b-tab-first': isFirst,
        'b-tab-last': isLast
      }, cls),
      dataset: {
        index
      }
    };
  } //endregion


  updateIndex(index) {
    this.isFirst = !index;
  }

  updateItem(item, was) {
    var _me$itemChangeDetache, _me$itemHideDetacher;

    const me = this;

    if ((was === null || was === void 0 ? void 0 : was.tab) === me) {
      was.tab = null;
    }

    if (item) {
      item.tab = me;
      me[me.titleProperty] = item[me.titleSource];
      me.itemCls = item.cls;
    }

    (_me$itemChangeDetache = me.itemChangeDetacher) === null || _me$itemChangeDetache === void 0 ? void 0 : _me$itemChangeDetache.call(me);
    me.itemChangeDetacher = item && _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].after(item, 'onConfigChange', 'onItemConfigChange', me, {
      return: false
    });
    (_me$itemHideDetacher = me.itemHideDetacher) === null || _me$itemHideDetacher === void 0 ? void 0 : _me$itemHideDetacher.call(me);
    me.itemHideDetacher = item === null || item === void 0 ? void 0 : item.on({
      beforeChangeHidden: 'onItemBeforeChangeHidden',
      beforeHide: 'onItemBeforeHide',
      beforeUpdateDisabled: 'onItemBeforeUpdateDisabled',
      thisObj: me,
      prio: 1000 // We must know before the layout intercepts and activates a sibling

    });
    me.syncMinMax();
  }

  updateItemCls(cls, was) {
    const {
      element
    } = this,
          classList = element && _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(element === null || element === void 0 ? void 0 : element.classList,
    /* returnEmpty= */
    true);

    if (element) {
      classList.remove(was).add(cls);
      element.className = classList.value;
    }
  }

  updateRotate(rotate, was) {
    if (!rotate !== !was) {
      this.syncMinMax();
    }
  }

  syncMinMax() {
    const me = this,
          {
      rotate,
      tabPanel
    } = me; // We have to read the configs directly since there are getters that read the DOM styles:

    let {
      _minWidth: minWidth,
      _minHeight: minHeight,
      _maxWidth: maxWidth,
      _maxHeight: maxHeight
    } = me; // When a tab rotation changes, we need to pivot the min/max width values with the height values

    if (tabPanel) {
      const {
        tabMinWidth,
        tabMaxWidth
      } = tabPanel;

      if (tabMinWidth != null) {
        if (rotate) {
          // if we were previously not rotated, the tabMinWidth may be effecting our minWidth:
          if (minWidth === tabMinWidth) {
            minWidth = null;
          } // noinspection JSSuspiciousNameCombination


          minHeight = tabMinWidth;
        } else {
          // if we were previously rotated, the tabMinWidth may be effecting our minHeight:
          if (minHeight === tabMinWidth) {
            minHeight = null;
          }

          minWidth = tabMinWidth;
        }
      }

      if (tabMaxWidth != null) {
        if (rotate) {
          if (maxWidth === tabMaxWidth) {
            maxWidth = null;
          } // noinspection JSSuspiciousNameCombination


          maxHeight = tabMaxWidth;
        } else {
          if (maxHeight === tabMaxWidth) {
            maxHeight = null;
          }

          maxWidth = tabMaxWidth;
        }
      }

      me.minWidth = minWidth;
      me.minHeight = minHeight;
      me.maxWidth = maxWidth;
      me.maxHeight = maxHeight;
    }
  }

  onItemBeforeChangeHidden({
    source: hidingChild,
    hidden
  }) {
    // If it's a hide/show that is not part of the layout's deactivating/activating, we must hide/show the tab
    if (!hidingChild.$isDeactivating && !hidingChild.$isActivating) {
      const {
        tabPanel
      } = this;
      this.hidden = hidden; // if tab to hide is active, let's active previous visible and enabled tab

      if (hidden && hidingChild === tabPanel.activeItem) {
        tabPanel.activateAvailableTab(hidingChild);
      }
    }
  }

  onItemBeforeHide() {
    // If it's a hide that is not part of the layout's deactivating, we hide the tab
    if (!this.item.$isDeactivating) {
      this.hide();
    }
  }

  onItemBeforeUpdateDisabled({
    source: disablingChild,
    disabled
  }) {
    const {
      tabPanel
    } = this;
    this.disabled = disabled; // if tab to disable is active, let's active previous visible and enabled tab

    if (disablingChild === tabPanel.activeItem) {
      tabPanel.activateAvailableTab(disablingChild);
    }
  }

  onItemConfigChange({
    name,
    value
  }) {
    if (name === this.titleSource) {
      this[this.titleProperty] = value;
    }
  }

} // Register this widget type with its Factory

Tab.initClass();
Tab._$name = 'Tab';

/***/ }),

/***/ "./lib/Core/widget/TabBar.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/TabBar.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabBar; });
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Tab_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Tab.js */ "./lib/Core/widget/Tab.js");
var productName = 'gantt';



/**
 * @module Core/widget/TabBar
 */

const isTab = t => t.isTab;
/**
 * A special toolbar used by {@link Core.widget.TabPanel} to present {@link Core.widget.Tab tabs} for the container's
 * items.
 *
 * The {@link Core.widget.Container#config-items} of a tab bar are typically managed by the tab panel, however,
 * items can be added that do not correspond to items in the tab panel. The {@link Core.widget.Widget#config-weight}
 * config of each tab defaults to 0 or the weight of its corresponding item.
 *
 * @extends Core/widget/Toolbar
 * @classType tabbar
 */


class TabBar extends _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TabBar';
  } // Factoryable type name


  static get type() {
    return 'tabbar';
  }

  static get configurable() {
    return {
      defaultType: 'tab',
      overflow: 'scroll'
    };
  }

  get firstTab() {
    return this.tabAt(0);
  }

  get lastTab() {
    return this.tabAt(-1);
  }

  get tabCount() {
    return this._items.countOf(isTab);
  }

  get tabs() {
    return _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(this._items, isTab);
  }

  compose() {
    return {
      children: {
        toolbarContent: {
          class: {
            'b-tabpanel-tabs': 1
          }
        }
      }
    };
  }

  indexOfTab(tab) {
    return this._items.indexOf(tab, isTab);
  }

  onChildAdd(child) {
    super.onChildAdd(child);

    if (child.index == null) {
      this.syncTabs();
    }
  }

  onChildRemove(child) {
    super.onChildRemove(child);
    this.syncTabs();
  }

  syncTabs() {
    const {
      tabs
    } = this;

    for (let i = 0, n = tabs.length; i < n; ++i) {
      tabs[i].index = i;
      tabs[i].isFirst = !i;
      tabs[i].isLast = i === n - 1;
    }
  }

  tabAt(index) {
    return this._items.find(isTab, index) || null;
  }

} // Register this widget type with its Factory

TabBar.initClass();
TabBar._$name = 'TabBar';

/***/ }),

/***/ "./lib/Core/widget/TabPanel.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/TabPanel.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabPanel; });
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Tab_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Tab.js */ "./lib/Core/widget/Tab.js");
/* harmony import */ var _TabBar_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TabBar.js */ "./lib/Core/widget/TabBar.js");
/* harmony import */ var _layout_Card_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./layout/Card.js */ "./lib/Core/widget/layout/Card.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
var productName = 'gantt';







/**
 * @module Core/widget/TabPanel
 */

/**
 * A tab panel widget which displays a collection of tabs, each of which can contain other widgets (or simple HTML). This
 * widget has a {@link Core.widget.TabBar tab bar} on top of its contents, and each {@link Core.widget.Tab tab} can be
 * customized using the {@link Core.widget.Tab#config-tab} config.
 *
 * @extends Core/widget/Container
 * @example
 * let tabPanel = new TabPanel({
 *  items: [
 *      {
 *          title: 'First',
 *          items: [
 *              { type: 'textfield', label: 'Name' },
 *              ...
 *          ]
 *      }, {
 *          title: 'Settings',
 *          tab : {
 *              // Show an icon in the tab
 *              icon : 'b-fa b-fa-cog'
 *          },
 *          items: [
 *              ...
 *          ]
 *      }
 *  ]
 * });
 *
 * @classType tabpanel
 * @inlineexample Core/widget/TabPanel.js
 */

class TabPanel extends _Panel_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'TabPanel';
  } // Factoryable type name


  static get type() {
    return 'tabpanel';
  } // Factoryable type alias


  static get alias() {
    return 'tabs';
  }

  static get configurable() {
    return {
      /**
       * The index of the initially active tab.
       * @member {Number} activeTab
       */

      /**
       * The index of the initially active tab.
       * @config {Number}
       * @default
       */
      activeTab: 0,

      /**
       * Specifies whether to slide tabs in and out of visibility.
       * @config {Boolean}
       * @default
       */
      animateTabChange: true,

      /**
       * Set the height of all tabs to match the tab with the highest content.
       * @config {Boolean}
       * @default
       */
      autoHeight: false,
      defaultType: 'container',
      itemCls: 'b-tabpanel-item',
      layout: {
        type: 'card'
      },
      // Prevent child panels from displaying a header unless explicitly configured with one
      suppressChildHeaders: true,
      tabBar: {
        type: 'tabbar',
        weight: -2000
      },

      /**
       * Min width of a tab title. 0 means no minimum width. This is default.
       * @config {Number}
       * @default
       */
      tabMinWidth: null,

      /**
       * Max width of a tab title. 0 means no maximum width. This is default.
       * @config {Number}
       * @default
       */
      tabMaxWidth: null
    };
  } //endregion
  //region Init

  /**
   * The active tab index. Setting must be done through {@link #property-activeTab}
   * @property {Number}
   * @readonly
   */


  get activeIndex() {
    return this.layout.activeIndex;
  }
  /**
   * The active child widget. Setting must be done through {@link #property-activeTab}
   * @property {Core.widget.Widget}
   * @readonly
   */


  get activeItem() {
    return this.layout.activeItem;
  }

  get activeTabItemIndex() {
    var _tabBar$tabs$activeTa;

    const {
      activeTab,
      items,
      tabBar
    } = this;
    return items.indexOf((_tabBar$tabs$activeTa = tabBar.tabs[activeTab]) === null || _tabBar$tabs$activeTa === void 0 ? void 0 : _tabBar$tabs$activeTa.item);
  }

  get bodyConfig() {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({
      className: {
        'b-tabpanel-body': 1
      }
    }, super.bodyConfig);
  }

  get focusElement() {
    var _activeTab$tab;

    const activeTab = this.items[this.activeTab || 0];
    return (activeTab === null || activeTab === void 0 ? void 0 : activeTab.focusElement) || (activeTab === null || activeTab === void 0 ? void 0 : (_activeTab$tab = activeTab.tab) === null || _activeTab$tab === void 0 ? void 0 : _activeTab$tab.focusElement);
  }

  get tabPanelBody() {
    return this.bodyElement;
  }

  finalizeInit() {
    super.finalizeInit();
    const me = this,
          {
      activeTab,
      layout
    } = me,
          tabs = me.tabBar.tabs;

    if (activeTab >= 0 && activeTab < tabs.length) {
      layout.activeIndex = me.items.indexOf(tabs[activeTab].item);
    } else {
      throw new Error(`Invalid activeTab ${activeTab} (${tabs.length} tabs)`);
    }

    layout.animateCardChange = me.animateTabChange;
  }

  onChildAdd(child) {
    // The layout will hide inactive new items.
    // And we must add our beforeHide listener *after* call super.
    super.onChildAdd(child);

    if (!this.initialItems) {
      const me = this,
            {
        tabBar
      } = me,
            config = me.makeTabConfig(child),
            // if child.tab === false, config will be null... no tab for this one
      firstTab = config && tabBar.firstTab,
            // if there are no tabs yet, this will be the first so we can skip all the indexing...
      tabBarItems = firstTab && tabBar._items,
            // not all items have tabs but the new child won't have one yet:
      tabItems = firstTab && _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(me._items, it => it.tab || it === child),
            // non-tabs could be in the tabBar, but the tabs must be contiguous:
      index = firstTab ? tabItems.indexOf(child) + tabBarItems.indexOf(firstTab) : 0;

      if (config) {
        if (firstTab && child.weight == null && index < tabBarItems.count - 1) {
          tabBar.insert(config, index);
        } else {
          tabBar.add(config);
        }
      }
    }
  }

  onChildRemove(child) {
    var _child$tab, _child$tab$destroy;

    (_child$tab = child.tab) === null || _child$tab === void 0 ? void 0 : (_child$tab$destroy = _child$tab.destroy) === null || _child$tab$destroy === void 0 ? void 0 : _child$tab$destroy.call(_child$tab); // tab can be false... so child.tab?.destroy() is not enough

    super.onChildRemove(child);
  } //endregion
  //region Tabs


  isDisabledOrHiddenTab(tabIndex) {
    const {
      tabs
    } = this.tabBar,
          tab = tabs === null || tabs === void 0 ? void 0 : tabs[tabIndex];
    return tab && (tab.disabled || tab.hidden);
  }

  findAvailableTab(item, delta = 1) {
    const {
      tabs
    } = this.tabBar,
          tabCount = tabs.length,
          itemIndex = Math.max(0, tabs.indexOf(item.tab));

    if (itemIndex) {
      delta = -delta;
    }

    let activeTab;

    for (let n = 1; n <= tabCount; ++n) {
      //  itemIndex=2, tabCount=5:
      //               n : 1, 2, 3, 4, 5
      //      delta =  1 : 3, 4, 0, 1, 2
      //      delta = -1 : 1, 0, 4, 3, 2
      activeTab = (itemIndex + (delta < 0 ? tabCount : 0) + n * delta) % tabCount;

      if (!this.isDisabledOrHiddenTab(activeTab)) {
        break;
      }
    }

    return activeTab;
  }

  activateAvailableTab(item, delta = 1) {
    this.activeTab = this.findAvailableTab(item, delta);
  }

  changeActiveTab(activeTab) {
    const me = this,
          {
      tabBar
    } = me,
          {
      tabCount
    } = tabBar;

    if (activeTab.isWidget || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(activeTab)) {
      // Must be a child widget, so add if it's not already in our items.
      if (me.items.indexOf(activeTab) === -1) {
        activeTab = me.add(activeTab);
      }

      activeTab = tabBar.indexOfTab(activeTab.tab);
    } else {
      activeTab = parseInt(activeTab, 10);
    }

    if (!me.initialItems && (activeTab < -1 || activeTab >= tabCount)) {
      throw new Error(`Invalid activeTab ${activeTab} (${tabCount} tabs)`);
    }

    if (me.isDisabledOrHiddenTab(activeTab)) {
      activeTab = me.findAvailableTab(activeTab);
    }

    return activeTab;
  }

  updateActiveTab() {
    if (!this.initialItems) {
      const {
        activeTabItemIndex
      } = this;

      if (activeTabItemIndex > -1) {
        this.layout.activeIndex = activeTabItemIndex;
      }
    }
  }

  changeTabBar(bar) {
    this.getConfig('strips');
    this.strips = {
      tabBar: bar
    };
    return this.strips.tabBar;
  }

  makeTabConfig(item) {
    const {
      tab
    } = item,
          config = {
      item,
      type: 'tab',
      tabPanel: this,
      disabled: Boolean(item.disabled),
      hidden: item.initialConfig.hidden,
      weight: item.weight || 0,
      listeners: {
        click: 'onTabClick',
        thisObj: this
      },
      localizableProperties: {
        // our tabs copy their text from the item's title and so are not directly localized
        text: false
      }
    };

    if (tab === false) {
      return null;
    }

    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(tab) ? _Tab_js__WEBPACK_IMPORTED_MODULE_3__["default"].mergeConfigs(config, tab) : config;
  }

  updateItems(items, was) {
    const me = this,
          {
      activeTab,
      initialItems
    } = me;
    let index = 0,
        tabs;
    super.updateItems(items, was);

    if (initialItems) {
      tabs = Array.from(items, it => me.makeTabConfig(it)).filter(it => {
        if (it) {
          it.index = index++;
          return true;
        }
      });

      if (index) {
        tabs[0].isFirst = true;
        tabs[index - 1].isLast = true;
        tabs[activeTab].active = true;
        me.tabBar.add(tabs);
        me.activeTab = activeTab; // now we can validate the activeTab value
      }
    }
  }

  updateTabMinWidth(tabMinWidth) {
    var _this$tabBar;

    (_this$tabBar = this.tabBar) === null || _this$tabBar === void 0 ? void 0 : _this$tabBar.items.forEach(tab => {
      if (tab.isTab) {
        tab.minWidth = tabMinWidth;
      }
    });
  }

  updateTabMaxWidth(tabMaxWidth) {
    var _this$tabBar2;

    (_this$tabBar2 = this.tabBar) === null || _this$tabBar2 === void 0 ? void 0 : _this$tabBar2.items.forEach(tab => {
      if (tab.isTab) {
        tab.maxWidth = tabMaxWidth;
      }
    });
  } //endregion
  //region Auto height


  updateAutoHeight(autoHeight) {
    this.detachListeners('themeAutoHeight');
    autoHeight && _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].on({
      name: 'themeAutoHeight',
      theme: 'internalOnThemeChange',
      thisObj: this
    });
    this.$measureHeight = autoHeight;
  }

  applyAutoHeight() {
    const me = this,
          {
      layout,
      activeTab,
      element
    } = me,
          {
      animateCardChange
    } = layout; // stop animate to change tabs on back stage.

    layout.animateCardChange = false; // override any previously applied height when measuring

    me.height = null; // get the max height comparing all tabs and apply to the tab

    me.height = Math.max(...me.items.map(tab => {
      me.activeTab = tab;
      return element.clientHeight;
    })) + 1; // Go back to initial configs

    me.activeTab = activeTab;
    layout.animateCardChange = animateCardChange;
    me.$measureHeight = false;
  }

  internalOnThemeChange() {
    if (this.isVisible) {
      this.applyAutoHeight();
    } else {
      this.$measureHeight = true;
    }
  } //endregion
  //region Events
  // Called after beforeActiveItemChange has fired and not been vetoed before animation and activeItemChange


  onBeginActiveItemChange(activeItemChangeEvent) {
    const tabs = this.tabBar.tabs,
          {
      activeItem,
      prevActiveItem
    } = activeItemChangeEvent; // Our UI changes immediately, our state must be accurate

    this.activeTab = tabs.indexOf(activeItem === null || activeItem === void 0 ? void 0 : activeItem.tab); // Deactivate previous active tab

    if (prevActiveItem !== null && prevActiveItem !== void 0 && prevActiveItem.tab) {
      prevActiveItem.tab.active = false;
    }

    if (activeItem !== null && activeItem !== void 0 && activeItem.tab) {
      activeItem.tab.active = true;
      activeItem.tab.show();
    }
  } // Auto called because Card layout triggers the beforeActiveItemChange on its owner


  onBeforeActiveItemChange(activeItemChangeEvent) {
    /**
     * The active tab is about to be changed. Return `false` to prevent this.
     * @event beforeTabChange
     * @preventable
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */
    return this.trigger('beforeTabChange', activeItemChangeEvent);
  } // Auto called because Card layout triggers the activeItemChange on its owner


  onActiveItemChange(activeItemChangeEvent) {
    /**
     * The active tab has changed.
     * @event tabChange
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */
    this.trigger('tabChange', activeItemChangeEvent);
  }

  onTabClick(event) {
    this.activeTab = event.source.item;
  }

  onPaint() {
    super.onPaint(...arguments); // Measure tabs on first paint if configured to do so

    if (this.$measureHeight) {
      this.applyAutoHeight();
    }
  } //endregion


} // Register this widget type with its Factory

TabPanel.initClass();
TabPanel._$name = 'TabPanel';

/***/ }),

/***/ "./lib/Core/widget/TextAreaField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/TextAreaField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextAreaField; });
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';



/**
 * @module Core/widget/TextAreaField
 */

/**
 * TextAreaField widget for multiline text input. Wraps a native &lt;textarea&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textAreaField = new TextAreaField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textareafield
 * @inlineexample Core/widget/TextAreaField.js
 */

class TextAreaField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TextAreaField';
  } // Factoryable type name


  static get type() {
    return 'textareafield';
  } // Factoryable type alias


  static get alias() {
    return 'textarea';
  }

  static get configurable() {
    return {
      picker: {
        type: 'widget',
        cls: 'b-textareafield-picker',
        floating: true,
        scrollAction: 'realign',
        align: {
          align: 't-b',
          axisLock: true
        },
        autoShow: false
      },
      triggers: null,
      // Override PickerField. We don't have a trigger by default

      /**
       * Configure as `false` to have the field render as a non-editable picker field which
       * shows a `<textarea>` input when expanded.
       * @config {Boolean}
       * @default
       */
      inline: true,

      /**
       * The resize style to apply to the `<textarea>` element.
       * @config {String}
       * @default
       */
      resize: 'none',
      inputType: null
    };
  }

  startConfigure(config) {
    // Read the inline config which will force evaluation of triggers.
    this.getConfig('inline');
    super.startConfigure(config);
  }

  get inputElement() {
    const result = super.inputElement,
          {
      inline,
      resize
    } = this;

    if (inline) {
      result.tag = 'textarea';
      result.style = (result.style || '') + `;resize:${resize}`;
    } else {
      result.readOnly = 'readonly';
      result.reference = 'displayElement';
    }

    return result;
  }

  get focusElement() {
    return this.inline || this._picker && this._picker.isVisible ? this.input : this.displayElement;
  }

  showPicker() {
    const me = this,
          {
      picker
    } = me; // Block picker if inline

    if (!me.inline) {
      picker.width = me.pickerWidth || me[me.pickerAlignElement].offsetWidth; // Always focus the picker.

      super.showPicker(true);
    }
  }

  focusPicker() {
    this.input.focus();
  }

  onPickerKeyDown(keyEvent) {
    const me = this,
          realInput = me.input;

    switch (keyEvent.key.trim() || keyEvent.code) {
      case 'Escape':
        // TODO: revert value?
        me.picker.hide();
        return;

      case 'Enter':
        if (keyEvent.ctrlKey) {
          me.syncInputFieldValue();
          me.picker.hide();
        }

        break;
    } // Super's onPickerKeyDown fires through this.input, so avoid infinite recursion
    // by redirecting it through the displayElement.


    me.input = me.displayElement;
    const result = super.onPickerKeyDown(keyEvent);
    me.input = realInput;
    return result;
  }

  syncInputFieldValue(skipHighlight) {
    if (this.displayElement) {
      this.displayElement.value = this.inputValue;
    }

    super.syncInputFieldValue(skipHighlight);
  }

  changeValue(value) {
    return value == null ? '' : value;
  }

  updateInline(inline) {
    if (!inline && !this.triggers) {
      this.triggers = {};
    }
  }

  changeTriggers(triggers, was) {
    if (!this.inline) {
      (triggers || (triggers = {})).expand = {
        cls: 'b-icon-picker',
        handler: 'onTriggerClick'
      };
    }

    return super.changeTriggers(triggers, was);
  }

  changePicker(picker, oldPicker) {
    var _picker;

    const me = this,
          pickerWidth = me.pickerWidth || ((_picker = picker) === null || _picker === void 0 ? void 0 : _picker.width);
    picker = TextAreaField.reconfigure(oldPicker, picker ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({
      owner: me,
      forElement: me[me.pickerAlignElement],
      align: {
        matchSize: pickerWidth == null,
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement]
      },
      html: `<textarea id="${me.id + '-input'}" style="resize:${me.resize}">${me.value}</textarea>`
    }, picker) : null, me); // May have been set to null (destroyed)

    if (picker) {
      const input = me.input = picker.element.querySelector(`#${me.id}-input`);
      me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: input,
        thisObj: me,
        focus: 'internalOnInputFocus',
        change: 'internalOnChange',
        input: 'internalOnInput',
        keydown: 'internalOnKeyEvent',
        keypress: 'internalOnKeyEvent',
        keyup: 'internalOnKeyEvent'
      });
    }

    return picker;
  }

} // Register this widget type with its Factory

TextAreaField.initClass();
TextAreaField._$name = 'TextAreaField';

/***/ }),

/***/ "./lib/Core/widget/TextField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TextField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'gantt';
 //TODO: label should be own element

/**
 * @module Core/widget/TextField
 */

/**
 * Textfield widget. Wraps native &lt;input type="text"&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.Column Column}, {@link Grid.column.TemplateColumn TemplateColumn},
 * {@link Grid.column.TreeColumn TreeColumn}, and for other columns if another editor is not specified explicitly,
 * or disabled by setting `false` value.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textField = new TextField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textfield
 * @inlineexample Core/widget/TextField.js
 */

class TextField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'textfield';
  } // Factoryable type alias


  static get alias() {
    return 'text';
  }

  static get configurable() {
    return {
      /**
       * The tab index of the input field
       * @config {Number} tabIndex
       * @category Input element
       */

      /**
       * The min number of characters for the input field
       * @config {Number} minLength
       * @category Field
       */

      /**
       * The max number of characters for the input field
       * @config {Number} maxLength
       * @category Field
       */
      nullValue: ''
    };
  }

  static get $name() {
    return 'TextField';
  }

  construct(config) {
    if ((config === null || config === void 0 ? void 0 : config.inputType) === 'hidden') {
      config.hidden = true;
    }

    super.construct(...arguments);
  }

} // Register this widget type with its Factory

TextField.initClass();
TextField._$name = 'TextField';

/***/ }),

/***/ "./lib/Core/widget/TimeField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TimeField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeField; });
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _TimePicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TimePicker.js */ "./lib/Core/widget/TimePicker.js");
var productName = 'gantt'; //TODO: picker icon (clock) should be clock that shows actual time




/**
 * @module Core/widget/TimeField
 */

/**
 * The time field widget is a text input field with a time picker drop down. It shows left/right arrows to increase or
 * decrease time by the {@link #config-step step value}.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.TimeColumn TimeColumn}.
 *
 * ## Configuring the picker hour / minute fields
 *
 * You can easily configure the fields in the drop down picker, to control the increment of the up/down step arrows:
 *
 * ```javascript
 * new TimeField({
 *     label     : 'Time field',
 *     appendTo  : document.body,
 *     picker    : {
 *         items : {
 *             minute : {
 *                 step : 5
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * let field = new TimeField({
 *   format: 'HH'
 * });
 *
 * @classType timefield
 * @inlineexample Core/widget/TimeField.js
 */

class TimeField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'TimeField';
  } // Factoryable type name


  static get type() {
    return 'timefield';
  } // Factoryable type alias


  static get alias() {
    return 'time';
  }

  static get configurable() {
    return {
      picker: {
        type: 'timepicker',
        floating: true,
        align: {
          align: 't0-b0',
          axisLock: true
        }
      },

      /**
       * Get/Set format for time displayed in field (see {@link Core.helper.DateHelper#function-format-static}
       * for formatting options).
       * @member {String} format
       */

      /**
       * Format for date displayed in field (see Core.helper.DateHelper#function-format-static for formatting
       * options).
       * @config {String}
       * @default
       */
      format: 'LT',
      triggers: {
        expand: {
          align: 'end',
          handler: 'onTriggerClick',
          compose: () => ({
            children: [{
              class: {
                'b-icon-clock-live': 1
              }
            }]
          })
        },
        back: {
          align: 'start',
          cls: 'b-icon b-icon-angle-left b-step-trigger',
          handler: 'onBackClick'
        },
        forward: {
          align: 'end',
          cls: 'b-icon b-icon-angle-right b-step-trigger',
          handler: 'onForwardClick'
        }
      },

      /**
       * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} min
       * @accepts {String|Date}
       */

      /**
       * Min time value
       * @config {String|Date}
       */
      min: null,

      /**
       * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} max
       * @accepts {String|Date}
       */

      /**
       * Max time value
       * @config {String|Date}
       */
      max: null,

      /**
       * The `step` property may be set in Object form specifying two properties, `magnitude`, a Number, and
       * `unit`, a String.
       *
       * If a Number is passed, the steps's current unit is used and just the magnitude is changed.
       *
       * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
       * example `'5m'`, `'5 m'`, `'5 min'`, `'5 minutes'`.
       *
       * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
       * @member {Object} step
       * @accepts {String|Number|Object}
       */

      /**
       * Time increment duration value. Defaults to 5 minutes.
       * The value is taken to be a string consisting of the numeric magnitude and the units.
       * The units may be a recognised unit abbreviation of this locale or the full local unit name.
       * For example `"10m"` or `"5min"` or `"2 hours"`
       * @config {String}
       */
      step: '5m',
      stepTriggers: null,

      /**
       * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}.
       * @member {Date} value
       * @accepts {String|Date}
       */

      /**
       * Value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}
       * @config {String|Date}
       */
      value: null
    };
  } //endregion
  //region Init & destroy


  changePicker(picker, oldPicker) {
    const me = this;
    return _TimePicker_js__WEBPACK_IMPORTED_MODULE_2__["default"].reconfigure(oldPicker, picker, {
      owner: me,
      defaults: {
        forElement: me[me.pickerAlignElement],
        owner: me,
        align: {
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement]
        },

        onTimeChange({
          time
        }) {
          me._isUserAction = true;
          me.value = time;
          me._isUserAction = false;
        }

      }
    });
  } //endregion
  //region Click listeners


  onBackClick() {
    const me = this,
          {
      min
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(me.value, -1 * me.step.magnitude, me.step.unit);

      if (!min || min.getTime() <= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  }

  onForwardClick() {
    const me = this,
          {
      max
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(me.value, me.step.magnitude, me.step.unit);

      if (!max || max.getTime() >= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  } //endregion
  // region Validation


  get isValid() {
    const me = this;
    me.clearError('L{Field.minimumValueViolation}', true);
    me.clearError('L{Field.maximumValueViolation}', true);
    let value = me.value;

    if (value) {
      value = value.getTime();

      if (me._min && me._min.getTime() > value) {
        me.setError('L{Field.minimumValueViolation}', true);
        return false;
      }

      if (me._max && me._max.getTime() < value) {
        me.setError('L{Field.maximumValueViolation}', true);
        return false;
      }
    }

    return super.isValid;
  }

  hasChanged(oldValue, newValue) {
    if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
      // Only care about the time part
      return oldValue.getHours() !== newValue.getHours() || oldValue.getMinutes() !== newValue.getMinutes() || oldValue.getSeconds() !== newValue.getSeconds() || oldValue.getMilliseconds() !== newValue.getMilliseconds();
    }

    return super.hasChanged(oldValue, newValue);
  } //endregion
  //region Toggle picker

  /**
   * Show picker
   */


  showPicker(focusPicker) {
    const me = this,
          {
      picker
    } = me;

    if (me.readOnly) {
      return;
    }

    picker.initialValue = me.value;
    picker.format = me.format;
    picker.maxTime = me.max;
    picker.minTime = me.min; // Show valid time from picker while editor has undefined value

    me.value = picker.value;
    super.showPicker(focusPicker);
  }

  onPickerShow() {
    var _this$pickerKeyDownRe;

    super.onPickerShow(); // Remove PickerField key listener

    this.pickerKeyDownRemover = (_this$pickerKeyDownRe = this.pickerKeyDownRemover) === null || _this$pickerKeyDownRe === void 0 ? void 0 : _this$pickerKeyDownRe.call(this);
  }
  /**
   * Focus time picker
   */


  focusPicker() {
    this.picker.focus();
  } //endregion
  //region Getters/setters


  transformTimeValue(value) {
    if (value != null) {
      if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
        if (typeof value === 'string') {
          value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parse(value, this.format);
        } else {
          value = new Date(value);
        }
      } // We insist on a *valid* Time as the value


      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isValidDate(value)) {
        // Clear date part back to zero so that all we have is the time part of the epoch.
        return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTime(value);
      }
    }

    return null;
  }

  changeMin(value) {
    return this.transformTimeValue(value);
  }

  updateMin(value) {
    const {
      input
    } = this;

    if (input) {
      if (value == null) {
        input.removeAttribute('min');
      } else {
        input.min = value;
      }
    }

    this.syncInvalid();
  }

  changeMax(value) {
    return this.transformTimeValue(value);
  }

  updateMax(value) {
    const {
      input
    } = this;

    if (input) {
      if (value == null) {
        input.removeAttribute('max');
      } else {
        input.max = value;
      }
    }

    this.syncInvalid();
  }

  changeValue(value, was) {
    const me = this,
          newValue = me.transformTimeValue(value); // A value we could not parse

    if (value && !newValue || me.isRequired && value === '') {
      // setError uses localization
      me.setError('L{invalidTime}');
      return;
    }

    me.clearError('L{invalidTime}'); // Reject non-change

    if (me.hasChanged(was, newValue)) {
      return super.changeValue(newValue, was);
    } // But we must fix up the display in case it was an unparseable string
    // and the value therefore did not change.


    if (!me.inputting) {
      me.syncInputFieldValue(true);
    }
  }

  updateValue(value, was) {
    const {
      expand
    } = this.triggers; // This makes to clock icon show correct time

    if (expand && value) {
      expand.element.firstElementChild.style.animationDelay = -((value.getHours() * 60 + value.getMinutes()) / 10) + 's';
    }

    super.updateValue(value, was);
  }

  changeStep(value, was) {
    const type = typeof value;

    if (!value) {
      return null;
    }

    if (type === 'number') {
      value = {
        magnitude: Math.abs(value),
        unit: was ? was.unit : 'hour'
      };
    } else if (type === 'string') {
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(value);
    }

    if (value && value.unit && value.magnitude) {
      if (value.magnitude < 0) {
        value = {
          magnitude: -value.magnitude,
          // Math.abs
          unit: value.unit
        };
      }

      return value;
    }
  }

  updateStep(value) {
    // If a step is configured, show the steppers
    this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
    this.syncInvalid();
  }

  updateFormat() {
    this.syncInputFieldValue(true);
  }

  get inputValue() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(this.value, this.format);
  } //endregion
  //region Localization


  updateLocalization() {
    super.updateLocalization();
    this.syncInputFieldValue(true);
  } //endregion


} // Register this widget type with its Factory

TimeField.initClass();
TimeField._$name = 'TimeField';

/***/ }),

/***/ "./lib/Core/widget/TimePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/TimePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimePicker; });
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _NumberField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./NumberField.js */ "./lib/Core/widget/NumberField.js");
var productName = 'gantt';




/**
 * @module Core/widget/TimePicker
 */

/**
 * A Popup which displays hour and minute number fields and AM/PM switcher buttons for 12 hour time format.
 *
 * ```javascript
 * new TimeField({
 *     label     : 'Time field',
 *     appendTo  : document.body,
 *     // Configure the time picker
 *     picker    : {
 *         items : {
 *             minute : {
 *                 step : 5
 *             }
 *         }
 *     }
 * });
 * ```
 * ## Contained widgets
 *
 * The default widgets contained in this picker are:
 *
 * | Widget ref             | Type                                                                            | Description                                                    |
 * |------------------------|---------------------------------------------------------------------------------|----------------------------------------------------------------|
 * | `hour`                 | {@link Core.widget.NumberField NumberField}                                     | The hour field                                                  |
 * | `minute`               | {@link Core.widget.NumberField NumberField}                                     | The minute field                                                  |
 * | `amButton`             | {@link Core.widget.Button Button}                                               | The am button                                                  |
 * | `pmButton`             | {@link Core.widget.Button Button}                                               | The pm button                                                  |
 *
 * Used internally by the {@link Core.widget.TimeField} class.
 *
 * @classType timepicker
 * @extends Core/widget/Popup
 */

class TimePicker extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TimePicker';
  } // Factoryable type name


  static get type() {
    return 'timepicker';
  }

  static get defaultConfig() {
    return {
      items: {
        hour: {
          type: 'number',
          min: 0,
          max: 23,
          highlightExternalChange: false,
          format: '2>9'
        },
        label: {
          html: '<label>:</label>'
        },
        minute: {
          type: 'number',
          min: 0,
          max: 59,
          highlightExternalChange: false,
          format: '2>9'
        },
        amButton: {
          type: 'button',
          text: 'AM',
          toggleGroup: 'am-pm',
          cls: 'b-blue'
        },
        pmButton: {
          type: 'button',
          text: 'PM',
          toggleGroup: 'am-pm',
          cls: 'b-blue'
        }
      },
      float: '1',
      autoShow: false,
      trapFocus: true,

      /**
       * Default time value
       * @config {Date}
       */
      value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTime(0),

      /**
       * Time format. Used to set appropriate 12/24 hour format to display.
       * See Core.helper.DateHelper#format for formatting options.
       * @config {String}
       */
      format: null
    };
  } //endregion
  //region Init

  /**
   * Fires when a time is changed.
   * @event timeChange
   * @param {Date} time The selected time.
   */


  construct(config) {
    super.construct(config);
    const me = this,
          {
      hour,
      minute,
      amButton,
      pmButton
    } = me.widgetMap;
    me._pm = false;
    hour.on('change', me.onFieldChange, me);
    minute.on('change', me.onFieldChange, me);
    amButton.on('click', me.onAmButtonClick, me);
    pmButton.on('click', me.onPmButtonClick, me);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.element,
      keydown: 'onPickerKeyDown',
      thisObj: me,
      capture: true
    });
    me.refresh();
  } //endregion
  //region Event listeners


  onFieldChange() {
    const me = this;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onAmButtonClick() {
    const me = this;
    me._pm = false;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onPmButtonClick() {
    const me = this;
    me._pm = true;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onPickerKeyDown(keyEvent) {
    const me = this,
          keyName = keyEvent.key && keyEvent.key.trim() || keyEvent.code;

    switch (keyName) {
      case 'Escape':
        // Support for undefined initial time
        me.triggerTimeChange(me._initialValue);
        me.hide();
        keyEvent.preventDefault();
        break;

      case 'Enter':
        me.value = me.pickerToTime();
        me.hide();
        keyEvent.preventDefault();
        break;
    }
  } //endregion
  //region Internal functions


  pickerToTime() {
    const me = this,
          pm = me._pm,
          {
      hour,
      minute
    } = me.widgetMap;
    hour.format = me._is24Hour ? '2>9' : null;
    let hours = hour.value,
        newValue = new Date(me._time);

    if (!me._is24Hour) {
      if (pm && hours < 12) hours = hours + 12;
      if (!pm && hours === 12) hours = 0;
    }

    newValue.setHours(hours);
    newValue.setMinutes(minute.value);

    if (me._min) {
      newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(me._min, newValue);
    }

    if (me._max) {
      newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(me._max, newValue);
    }

    return newValue;
  }

  triggerTimeChange(time) {
    this.trigger('timeChange', {
      time
    });
  } //endregion
  //region Getters / Setters

  /**
   * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set value(newTime) {
    const me = this;
    let changed = false;

    if (!newTime || !me._time) {
      me._time = TimePicker.defaultConfig.value;
      changed = true;
    } else if (newTime.getTime() !== me._time.getTime()) {
      me._time = newTime;
      changed = true;
    }

    if (changed) {
      if (me.isVisible) {
        me.triggerTimeChange(me.value);
      }

      me.refresh();
    }
  }

  get value() {
    return this._time;
  }
  /**
   * Get/Set format for time displayed in field (see Core.helper.DateHelper#format for formatting options)
   * @property {String}
   */


  set format(value) {
    const me = this;
    me._format = value;
    me._is24Hour = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].is24HourFormat(me._format);
    me.refresh();
  }

  get format() {
    return this._format;
  }
  /**
   * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set min(value) {
    this._min = value;
  }

  get min() {
    return this._min;
  }
  /**
   * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set max(value) {
    this._max = value;
  }

  get max() {
    return this._max;
  }
  /**
   * Get/set initial value and value, which can be a Date or a string. If a string is specified,
   * it will be converted using the specified {@link #config-format}. Initial value is restored on Escape click
   * @property {Date}
   * @accepts {Date|String}
   */


  set initialValue(value) {
    this.value = value;
    this._initialValue = value;
  }

  get initialValue() {
    return this._initialValue;
  } //endregion
  //region Display


  refresh() {
    const me = this;

    if (!me.isConfiguring) {
      const {
        hour,
        minute,
        amButton,
        pmButton
      } = me.widgetMap,
            time = me._time,
            is24 = me._is24Hour,
            hours = time.getHours(),
            pm = me._pm = hours >= 12;
      me.element.classList[is24 ? 'add' : 'remove']('b-24h');
      hour.min = is24 ? 0 : 1;
      hour.max = is24 ? 23 : 12;
      hour.value = is24 ? hours : hours % 12 || 12;
      minute.value = time.getMinutes();
      amButton.pressed = !pm;
      pmButton.pressed = pm;
      amButton.hidden = pmButton.hidden = is24;
    }
  } //endregion


} // Register this widget type with its Factory

TimePicker.initClass();
TimePicker._$name = 'TimePicker';

/***/ }),

/***/ "./lib/Core/widget/Toast.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Toast.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toast; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/**
 * @module Core/widget/Toast
 */

/**
 * Basic toast. Toasts are stacked on top of each other
 * @example
 * // simplest possible
 * Toast.show('Just toasting');
 *
 * // with config
 * Toast.show({
 *   html: 'Well toasted',
 *   showProgress: false
 * });
 *
 * // as instance (instance is also returned from Toast.show()
 * let toast = new Toast({
 *   html: 'Not going away',
 *   timeout: 0
 * });
 *
 * toast.show();
 *
 * @classType toast
 * @inlineexample Core/widget/Toast.js
 */

class Toast extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Toast';
  } // Factoryable type name


  static get type() {
    return 'toast';
  }

  static get configurable() {
    return {
      testConfig: {
        destroyTimeout: 1,
        timeout: 100
      },
      floating: true,

      /**
       * Timeout (in ms) until the toast is automatically dismissed. Set to 0 to never hide.
       * @config {Number}
       * @default
       */
      timeout: 2500,
      autoDestroy: null,
      // How long to wait after hide before destruction
      destroyTimeout: 200,

      /**
       * Show a progress bar indicating the time remaining until the toast is dismissed.
       * @config {Boolean}
       * @default
       */
      showProgress: true,

      /**
       * Toast color (should have match in toast.scss or your custom styling).
       * Valid values in Bryntum themes are:
       * * b-amber
       * * b-blue
       * * b-dark-gray
       * * b-deep-orange
       * * b-gray
       * * b-green
       * * b-indigo
       * * b-lime
       * * b-light-gray
       * * b-light-green
       * * b-orange
       * * b-purple
       * * b-red
       * * b-teal
       * * b-white
       * * b-yellow
       *
       * ```
       * new Toast({
       *    color : 'b-blue'
       * });
       * ```
       *
       * @config {String}
       */
      color: null,
      bottomMargin: 20
    };
  }

  compose() {
    const {
      appendTo,
      color,
      html,
      showProgress,
      style,
      timeout
    } = this;
    return {
      parent: appendTo || this.floatRoot,
      class: _objectSpread(_objectSpread({}, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"].normalize(color, 'object')), {}, {
        'b-toast-hide': 1 // toasts start hidden so we can animate them into view

      }),
      html,
      style,
      children: {
        progressElement: showProgress && {
          style: `animation-duration:${timeout / 1000}s;`,
          class: {
            'b-toast-progress': 1
          }
        }
      },
      listeners: {
        click: 'hide'
      }
    };
  }

  doDestroy() {
    this.untoast();
    super.doDestroy();
  }

  get nextBottom() {
    const {
      bottomMargin,
      element
    } = this;
    return parseInt(element.style.bottom, 10) + element.offsetHeight + bottomMargin;
  }
  /**
   * Show the toast
   */


  show() {
    super.show();
    const me = this,
          {
      element
    } = me,
          {
      toasts
    } = Toast;

    if (!toasts.includes(me)) {
      var _toasts$0$nextBottom, _toasts$;

      element.style.bottom = ((_toasts$0$nextBottom = (_toasts$ = toasts[0]) === null || _toasts$ === void 0 ? void 0 : _toasts$.nextBottom) !== null && _toasts$0$nextBottom !== void 0 ? _toasts$0$nextBottom : me.bottomMargin) + 'px';
      toasts.unshift(me);
      element.getBoundingClientRect(); // force layout so that removing b-toast-hide runs our transition

      element.classList.remove('b-toast-hide');

      if (me.timeout > 0) {
        me.hideTimeout = me.setTimeout('hide', me.timeout);
      }
    }
  }
  /**
   * Hide the toast
   */


  hide() {
    const me = this;
    me.untoast();
    me.element.classList.add('b-toast-hide');

    if (me.autoDestroy && !me.destroyTimer) {
      me.destroyTimer = me.setTimeout('destroy', me.destroyTimeout);
    }
  }

  untoast() {
    const {
      toasts
    } = Toast;

    if (toasts.includes(this)) {
      toasts.splice(toasts.indexOf(this), 1);
    }
  }
  /**
   * Hide all visible toasts
   */


  static hideAll() {
    Toast.toasts.slice().reverse().forEach(toast => toast.hide());
  }
  /**
   * Easiest way to show a toast
   * @example
   * Toast.show('Hi');
   * @example
   * Toast.show({
   *   html   : 'Read quickly, please',
   *   timeout: 1000
   * });
   * @param {String|Object} config Message or toast config object
   * @returns {Core.widget.Toast}
   */


  static show(config) {
    const toast = Toast.new({
      autoDestroy: true,
      rootElement: document.body
    }, typeof config === 'string' ? {
      html: config
    } : config);
    toast.show();
    return toast;
  }

}
Toast.toasts = []; // Register this widget type with its Factory

Toast.initClass();
Toast._$name = 'Toast';

/***/ }),

/***/ "./lib/Core/widget/Tool.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Tool.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tool; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
var productName = 'gantt';



/**
 * @module Core/widget/Tool
 */

/**
 * Base class for tools.
 *
 * May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Panel.
 * @extends Core/widget/Widget
 *
 * @classType tool
 */

class Tool extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'Tool';
  } // Factoryable type name


  static get type() {
    return 'tool';
  }

  static get configurable() {
    return {
      /**
       * Specify `'start'` to place the tool before the owner's central element (e.g., the `title` of the panel).
       * @config {String}
       * @default 'end'
       * @category Float & align
       */
      align: {
        value: null,
        $config: {
          merge: 'replace'
        }
      },

      /**
       * The function to call when this tool is clicked. May be a function or function name
       * prepended by `"up."` that is resolvable in an ancestor component (such as an owning
       * Grid, Scheduler, Calendar, Gantt or TaskBoard)
       * @param {Event} handler.event The DOM event which activated the tool.
       * @param {Core.widget.Panel} handler.panel The owning Panel of the tool.
       * @param {Core.widget.Tool} handler.tool The clicked Tool.
       * @config {Function|String} handler
       */

      /**
       * A {@link Core.util.ClickRepeater ClickRepeater} config object to specify how
       * click-and-hold gestures repeat the click action.
       * @config {Object}
       */
      repeat: null,
      ariaLabel: null
    };
  }

  compose() {
    const {
      align,
      ariaLabel
    } = this;
    return {
      tag: 'button',
      class: {
        [`b-align-${align || 'end'}`]: 1,
        'b-icon': 1
      },
      'aria-label': ariaLabel,
      listeners: {
        click: 'onClick'
      }
    };
  }

  get focusElement() {
    return this.element;
  }

  get panel() {
    return this.parent;
  }

  changeAlign(align) {
    return align; // replace Widget.changeAlign
  }

  onClick(e) {
    const {
      handler,
      panel
    } = this; // Safari && FF trigger click on disabled button, Chrome does not. Handling it here

    if (!this.disabled && (panel === null || panel === void 0 ? void 0 : panel.trigger('toolclick', {
      domEvent: e,
      tool: this
    })) !== false) {
      handler && this.callback(handler, panel, [e, panel, this]);
    }
  }

  onInternalKeyDown(keyEvent) {
    const keyName = keyEvent.key.trim() || keyEvent.code; // Don't allow key invocations to bubble and trigger owning
    // widget's key handlers.

    if (keyName === 'Enter') {
      keyEvent.cancelBubble = true;
      keyEvent.stopPropagation();
    }
  }

  updateDisabled(disabled, was) {
    var _this$repeat;

    super.updateDisabled(disabled, was);
    disabled && ((_this$repeat = this.repeat) === null || _this$repeat === void 0 ? void 0 : _this$repeat.cancel());
  }

  changeRepeat(repeat, oldRepeat) {
    oldRepeat === null || oldRepeat === void 0 ? void 0 : oldRepeat.destroy();
    return repeat && _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_1__["default"].new({
      element: this.element
    }, repeat);
  }

} // Register this widget type with its Factory

Tool.initClass();
Tool._$name = 'Tool';

/***/ }),

/***/ "./lib/Core/widget/Toolbar.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Toolbar.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toolbar; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _layout_VBox_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./layout/VBox.js */ "./lib/Core/widget/layout/VBox.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';









/**
 * @module Core/widget/Toolbar
 */

const asElementRefs = {
  refs: 'element'
},
      isToolbar = w => w.isToolbar,
      _axisProps = [{
  box: 'hbox',
  clientSizeProp: 'clientWidth',
  edgeProp: 'right',
  flexDir: 'row',
  horizontal: true,
  max: 'maxX',
  overflow: 'overflowX',
  pos: 'x',
  scrollSize: 'scrollWidth',
  sizeProp: 'width'
}, {
  box: 'vbox',
  clientSizeProp: 'clientHeight',
  edgeProp: 'bottom',
  flexDir: 'column',
  horizontal: false,
  max: 'maxY',
  overflow: 'overflowY',
  pos: 'y',
  scrollSize: 'scrollHeight',
  sizeProp: 'height'
}],
      defaultRepeat = {
  delay: 0,
  startRate: 40,
  endRate: 200,
  accelerateDuration: 500
};
/**
 * A container widget that can contain Buttons or other widgets, and is docked to the bottom or top of
 * a {@link Core.widget.Panel Panel}.
 *
 * @extends Core/widget/Container
 * @classType toolbar
 * @inlineexample Core/widget/Toolbar.js
 */


class Toolbar extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'Toolbar';
  } // Factoryable type name


  static get type() {
    return 'toolbar';
  }

  static get delayable() {
    return {
      syncOverflowVisibility: {
        type: 'raf',
        cancelOutstanding: true
      } // && 50   // restore the "&& 50" here to help when debugging syncOverflowVisibility

    };
  }

  static get configurable() {
    return {
      defaultType: 'button',
      dock: 'top',
      layout: {
        type: 'box'
      },

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the content element (the element in
       * which {@link #config-overflow} occurs). Each property name is the reference by which an instantiated
       * tool may be retrieved from the live `{@link Core.widget.mixin.Toolable#property-tools}` property.
       * @config {Object} tools
       */

      /**
       * How this Toolbar should deal with items that overflow its main axis.
       *
       * Values may be:
       * - `'menu'` A button with a menu is shown and the menu contains the overflowing items.
       * - `'scroll'` The items overflow and mey be scrolled into view using the mouse or scroll buttons.
       * - `null` Disable overflow handling
       *
       * When mode is `'menu'`, clones of overflowing toolbar item are created and added to a Menu. Any config
       * changes to the original toolbar item are propagated to the menu's clone, so disabling a toolbar
       * item will make the clone in the menu disabled.
       *
       * The clone of an input field will propagate its `value` changes back to the original. The
       * overflow button, its menu, and the clones should not be accessed or manipulated by application code.
       *
       * Note that cloned items will be allocated a unique, generated ID because all IDs must be unique,
       * so CSS targeting an element ID will not apply to a clone in the overflow menu.
       *
       * Values may also be specified in object form containing the following properties:
       * @config {String|Object|null} overflow
       * @property {String} overflow.type `'scroll'` or `'menu'`
       * @property {Object} overflow.repeat A config object to reconfigure the {@link Core.util.ClickRepeater ClickRepeater}
       * which controls auto repeat speed when holding down the scroll buttons when `type` is `'scroll'`
       * @property {Function} overflow.filter A filter function which may return a falsy value to prevent toolbar
       * items from being cloned into the overflow menu.
       * @default 'menu'
       */
      overflow: {
        // Wait until first paint to evaluate so that we can read our CSS style.
        // Set to null on destroy which destroys the overflow Tools and Scroller.
        $config: ['lazy', 'nullify'],
        value: {
          type: 'menu'
        }
      },
      toolDefaults: {
        overflowMenuButton: {
          type: 'button',
          hidden: true,
          icon: 'b-icon-menu',
          menuIcon: null,
          defaultCls: {
            'b-overflow-button': 1
          }
        },
        overflowScrollEnd: {
          handler: 'up.onEndScrollClick',
          hidden: true,
          defaultCls: {
            'b-icon-angle-right': 1,
            'b-overflow-button': 1,
            'b-icon': 1
          }
        },
        overflowScrollStart: {
          align: 'start',
          handler: 'up.onStartScrollClick',
          hidden: true,
          defaultCls: {
            'b-icon-angle-left': 1,
            'b-overflow-button': 1,
            'b-icon': 1
          }
        }
      },

      /**
       * Custom CSS class to add to toolbar widgets
       * @config {String}
       * @category CSS
       */
      widgetCls: null
    };
  }

  compose() {
    const me = this,
          {
      axisProps,
      dock
    } = me,
          endToolElementRefs = me.getEndTools(asElementRefs),
          startToolElementRefs = me.getStartTools(asElementRefs);
    return {
      class: {
        [`b-dock-${dock}`]: 1,
        [`b-${dock}-toolbar`]: 1,
        [`b-${axisProps.box}`]: 1
      },
      children: _objectSpread(_objectSpread({}, startToolElementRefs), {}, {
        toolbarContent: {
          class: {
            'b-box-center': 1,
            'b-toolbar-content': 1
          }
        }
      }, endToolElementRefs)
    };
  }

  get axisProps() {
    return _axisProps[this.layout.horizontal ? 0 : 1];
  }

  get contentElement() {
    return this.toolbarContent;
  }

  get overflowMenuButton() {
    var _this$tools;

    return (_this$tools = this.tools) === null || _this$tools === void 0 ? void 0 : _this$tools.overflowMenuButton;
  }

  get overflowType() {
    const {
      overflow
    } = this;
    return typeof overflow === 'string' ? overflow : overflow === null || overflow === void 0 ? void 0 : overflow.type;
  }

  onChildAdd(item) {
    var _item$syncRotationToD;

    super.onChildAdd(item);
    this.processAddedLeafItem(item);
    (_item$syncRotationToD = item.syncRotationToDock) === null || _item$syncRotationToD === void 0 ? void 0 : _item$syncRotationToD.call(item, this.dock);
  }

  processAddedLeafItem(item) {
    // Any configurable config changes in the original are propagated to a possible clone.
    // Also a reevaluation of scroll state may be necessary. Any part of the UI may have changed,
    _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].after(item, 'onConfigChange', this.onLeafItemConfigChange, item); // And all the way down. Eg, hiding a ButtonGroup must schedule a syncOverflowVisibility
    // but also hiding any of its children must also schedule a syncOverflowVisibility

    if (item.isContainer) {
      item.eachWidget(w => this.processAddedLeafItem(w));
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Evaluate the overflow late so that we have access to styles and measurements.

    if (firstPaint) {
      this.getConfig('overflow');
    }
  }

  updateDock(dock) {
    const me = this,
          {
      layout
    } = me,
          {
      vertical
    } = layout;
    layout.vertical = Object(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_6__["canonicalDock"])(dock)[1];

    if (!me.initialItems) {
      if (vertical !== layout.vertical) {
        me.updateOverflow(me.overflow);
      }

      for (const item of me.childItems) {
        var _item$syncRotationToD2;

        (_item$syncRotationToD2 = item.syncRotationToDock) === null || _item$syncRotationToD2 === void 0 ? void 0 : _item$syncRotationToD2.call(item, dock);
      }
    }
  }

  updateOverflow(overflow, oldOverflow) {
    var _me$overflowMenuButto;

    const me = this,
          {
      axisProps,
      contentElement,
      overflowType
    } = me,
          {
      flexDir
    } = axisProps,
          overflowMenu = (_me$overflowMenuButto = me.overflowMenuButton) === null || _me$overflowMenuButto === void 0 ? void 0 : _me$overflowMenuButto._menu,
          overflowTools = {};

    if (overflowMenu) {
      // Save any clones from destruction
      if (overflow) {
        overflowMenu === null || overflowMenu === void 0 ? void 0 : overflowMenu.removeAll();
      } // Break link between original and clone
      else {
        overflowMenu.eachWidget(clone => {
          clone._toolbarOverflowOriginal._toolbarOverflowClone = null;
        });
      }
    }

    if (oldOverflow === 'menu') {
      overflowTools.overflowMenuButton = null;
    } else if (oldOverflow === 'scroll') {
      overflowTools.overflowScrollStart = overflowTools.overflowScrollEnd = null;
    }

    if (overflowType === 'menu') {
      var _me$scrollable;

      // Not needed for menu type overflowing
      (_me$scrollable = me.scrollable) === null || _me$scrollable === void 0 ? void 0 : _me$scrollable.destroy(); // Must allow things like Badges to escape the bounds.

      contentElement.style.overflow = contentElement.style.overflowX = contentElement.style.overflowY = '';
      overflowTools.overflowMenuButton = {
        cls: {
          [`b-${flexDir}-menu`]: 1
        }
      };
    } else if (overflowType === 'scroll') {
      const repeat = typeof overflow === 'object' && (overflow === null || overflow === void 0 ? void 0 : overflow.repeat) || defaultRepeat; // We need a scroller.

      me.scrollable = {
        [axisProps.overflow]: 'hidden-scroll',
        element: contentElement,
        listeners: {
          scroll: 'onContentScroll',
          thisObj: me
        }
      };
      overflowTools.overflowScrollStart = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-start-scroller`]: 1
        }
      };
      overflowTools.overflowScrollEnd = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-end-scroller`]: 1
        }
      };
    }

    me.tools = overflowTools;

    if (overflowType) {
      // Stops items from flex-shrinking down now that we have a way of showing them in full.
      contentElement.classList.add('b-overflow'); // Need to hide/show overflow buttons when necessary

      me.monitorResize = true;
      me.syncOverflowVisibility();
    } else {
      contentElement.classList.remove('b-overflow');
      me.monitorResize = false;
    }
  }

  onContentScroll() {
    this.syncScrollerState();
  }

  onStartScrollClick() {
    this.scrollable[this.axisProps.pos] -= 2;
  }

  onEndScrollClick() {
    this.scrollable[this.axisProps.pos] += 2;
  } // Only called when monitorResize is true, which is only set when we have an overflow mode


  onInternalResize() {
    super.onInternalResize(...arguments); // If it's not the initial undefined->first size from the initial paint, reevaluate overflow

    if (this.isPainted) {
      this.syncOverflowVisibility();
    }
  }

  syncOverflowVisibility() {
    const me = this,
          {
      overflowType,
      contentElement,
      isVisible
    } = me,
          {
      clientSizeProp,
      edgeProp,
      sizeProp
    } = me.axisProps,
          {
      overflowMenuButton,
      overflowScrollStart,
      overflowScrollEnd
    } = me.tools,
          menuOverflow = overflowType === 'menu'; // Method can be called for hidden toolbar (e.g. after event editor is hidden), bail out early in such case

    if (!isVisible || !overflowType) {
      return;
    } // Prevent recursion


    me.inSyncOverflowVisibility = true; // Give the contents a chance to lay out with no scroll tools taking space.

    overflowMenuButton === null || overflowMenuButton === void 0 ? void 0 : overflowMenuButton.hide(); // NOTE: if we hide the scroller buttons that will affect the scroll range and can trigger a scroll. The scroll
    // does not fire synchronously (at least in Chrome) so it cannot be swallowed here.

    let overflowIndex = 0,
        availableSpace,
        itemRect,
        overflowable,
        visibleItems; // Iterate all leaf widgets.
    // Restore only the ones that we hid to visibility so that we can accurately ascertain overflow.
    // Collect all visible leaf widgets. These are what we are interested in hiding and showing.
    // Anything may have changed. Text inside buttons, label of fields, visibility or
    // disabled status. The only way to ascertain overflow is to show them all, and
    // force a synchronous layout by measuring the resulting scrollWidth/Height

    me.eachWidget((item, control) => {
      if (item.floating) {
        control.down = false;
        return;
      } // We want to descend into containers (esp ButtonGroup) but don't want to descend into normal widgets (like
      // button's which may have menus).


      control.down = !(overflowable = item.overflowable);

      if (overflowable && item.innerItem) {
        if (item._toolbarOverflow) {
          // Order is important here. _toolbarOverflow must be set first
          // so that onLeafItemConfigChange doesn't recurse infinitely.
          item.hidden = item._toolbarOverflow = false;
        }

        if (item.isVisible) {
          (visibleItems || (visibleItems = [])).push(item);
          ++overflowIndex;
        }
      }
    });

    if (visibleItems) {
      // Firefox doesn't calculate scrollWidth correctly if overflow is hidden which it has to be.
      itemRect = visibleItems[--overflowIndex].rectangle(contentElement);
      availableSpace = Math.ceil(contentElement[clientSizeProp] + ( // Since we cannot simply hide these to remove their influence, we need to add their width/height to
      // the availableSpace here:
      !overflowScrollStart || overflowScrollStart.hidden ? 0 : overflowScrollStart.rectangle('outer')[sizeProp]) + (!overflowScrollEnd || overflowScrollEnd.hidden ? 0 : overflowScrollEnd.rectangle('outer')[sizeProp]));
    }

    if (visibleItems && Math.floor(itemRect[edgeProp]) > availableSpace) {
      if (menuOverflow) {
        overflowMenuButton.show();
        availableSpace = contentElement[clientSizeProp]; // get the new size of the content area
        // We know the last item's edgeProp overflows, so skip that one and start at the prior item:

        while (overflowIndex-- > 0) {
          itemRect = visibleItems[overflowIndex].rectangle(contentElement);

          if (Math.floor(itemRect[edgeProp]) <= availableSpace) {
            break;
          }
        } // overflowIndex is the index of the item that did not overflow (or -1 if all items overflow)


        me.syncOverflowMenuButton(visibleItems.slice(overflowIndex + 1));
      } else {
        overflowScrollEnd.show();
        overflowScrollStart.show();
        me.syncScrollerState();
      }
    } else if (!menuOverflow) {
      overflowScrollEnd === null || overflowScrollEnd === void 0 ? void 0 : overflowScrollEnd.hide();
      overflowScrollStart === null || overflowScrollStart === void 0 ? void 0 : overflowScrollStart.hide();
    }

    me.inSyncOverflowVisibility = false;
  }

  syncOverflowMenuButton(overflowItems) {
    var _overflowMenuButton$_;

    const me = this,
          {
      axisProps,
      overflowMenuButton
    } = me,
          menu = {
      cls: 'b-toolbar-overflow-menu',
      minWidth: 280,
      items: [],
      align: {
        align: axisProps.horizontal ? 't100-b100' : 'r100-l100',
        axisLock: 'flexible'
      }
    }; // Hide the things that overflow

    for (let overflowingItem, i = 0, {
      length
    } = overflowItems; i < length; i++) {
      overflowingItem = overflowItems[i]; // Cache the width so that we can make it look right in the menu

      overflowingItem._toolbarOverflowWidth = overflowingItem.width; // Order is important here. _toolbarOverflow must be set first
      // so that onLeafItemConfigChange doesn't recurse infinitely.

      overflowingItem._toolbarOverflow = true;
      overflowingItem.hidden = true;
    } // Add clones, or surrogates of the overflowing things to the menu.
    // Input fields will be cloned, buttons will result in a MenuItem.
    // Any Containers


    me.addToMenu(menu, overflowItems.filter(item => me.overflowItemFilter(item)));

    if ((_overflowMenuButton$_ = overflowMenuButton._menu) !== null && _overflowMenuButton$_ !== void 0 && _overflowMenuButton$_.isMenu) {
      const existingMenu = overflowMenuButton.menu,
            {
        toAdd,
        toRemove
      } = _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].delta(menu.items, existingMenu.items, 1);
      existingMenu.remove(toRemove);

      if (existingMenu.items.length) {
        // Insert the ones which we just got too narrow to show at the top of the menu
        for (let i = toAdd.length - 1; i >= 0; i--) {
          existingMenu.insert(toAdd[i], 0);
        }
      } else {
        existingMenu.add(toAdd);
      }
    } else {
      overflowMenuButton.menu = menu;
    }
  }

  syncScrollerState() {
    const me = this,
          {
      axisProps,
      scrollable
    } = me,
          {
      overflowScrollStart,
      overflowScrollEnd
    } = me.tools,
          scrollPos = scrollable[axisProps.pos],
          maxScrollPos = scrollable[axisProps.max];
    overflowScrollStart.disabled = !scrollPos;
    overflowScrollEnd.disabled = Math.ceil(scrollPos) >= maxScrollPos;
  }

  overflowItemFilter(item) {
    const {
      filter
    } = this.overflow;
    return Boolean(filter // Allow user-defined filter
    ? filter.call(this, item) // If no Elements, for example displaying text which will have a Node type 3
    // or a toolbar spacer or separator, then omit it from the menu
    : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getChildElementCount(item.element));
  }

  addToMenu(menu, overflowingItems) {
    const {
      horizontal
    } = this;

    for (let i = 0, {
      length
    } = overflowingItems; i < length; i++) {
      const item = overflowingItems[i];
      let clone = item._toolbarOverflowClone,
          type = item.constructor;

      if (!clone) {
        const config = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(item.initialConfig); // Must not duplicate IDs

        delete config.id; // If the initialConfig was hidden, we must override that

        config.hidden = false; // Item must obey menu's align-items : stretch style.
        // CSS unset not supported on IE11.

        config.width = ''; // Don't allow horizontal flex styles to apply in the vertical
        // layout of the Menu.

        if (horizontal) {
          config.flex = '';
        }

        config.minWidth = item._toolbarOverflowWidth;
        config.type = item.type;
        config._toolbarOverflowOriginal = item; // These properties are things that may be changed frequently from the initialConfig state.

        config.disabled = item.disabled;

        if ('value' in item) {
          config.value = item.value;
        } // Icon-only buttons are not useful in a menu.
        // Use any tooltip text as the button text.


        if (config.type === 'button') {
          // TODO - will look better but need be clever - https://github.com/bryntum/support/issues/2298
          // config.type = type = type.resolveType('menuitem');
          if (!config.text) {
            config.text = item.tooltipText;
          }
        }

        item._toolbarOverflowClone = clone = type.create(config);
        clone.element.style.margin = ''; // Clone's changes must propagate to original.

        if (item.isField) {
          clone.on({
            change: this.onFieldCloneChange
          });
        }
      }

      menu.items.push(clone);
    }
  }

  onFieldCloneChange({
    source,
    value
  }) {
    source._toolbarOverflowOriginal.value = value;
  } // Note that this is called with the thisObj of the tbar item being reconfigured.
  // It propagates the new setting into its toolbar overflow clone.


  onLeafItemConfigChange(origResult, {
    name,
    value
  }) {
    const me = this,
          toolbar = me.up(isToolbar),
          {
      _toolbarOverflowClone
    } = me; // If it's a hide/show, and its in sync with its _toolbarOverflow state, do nothing

    if (toolbar !== null && toolbar !== void 0 && toolbar.inSyncOverflowVisibility || name === 'hidden' && value === me._toolbarOverflow) {
      return;
    } // If the changed item has a clone in the overflow menu, sync the clone


    if (_toolbarOverflowClone) {
      _toolbarOverflowClone[name] = value;
    } // Any part of the UI might have changed shape, so we must reevaluate scroll state.


    if (toolbar !== null && toolbar !== void 0 && toolbar.isPainted && me.ref !== 'overflowMenuButton') {
      if (!(me.isTextField && name === 'value' && (me.containsFocus || _toolbarOverflowClone !== null && _toolbarOverflowClone !== void 0 && _toolbarOverflowClone.containsFocus))) {
        toolbar.syncOverflowVisibility();
      }
    }
  }

  createWidget(widget) {
    if (widget === '->') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-fill'
      };
    } else if (widget === '|') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-separator'
      };
    } else if (typeof widget === 'string') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-text',
        html: widget
      };
    }

    const result = super.createWidget(widget);

    if (this.widgetCls) {
      result.element.classList.add(this.widgetCls);
    }

    return result;
  }

} // Register this widget type with its Factory

Toolbar.initClass();
Toolbar._$name = 'Toolbar';

/***/ }),

/***/ "./lib/Core/widget/Tooltip.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Tooltip.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tooltip; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';










const realignTransitions = {
  left: true,
  right: true,
  top: true,
  bottom: true,
  transform: true
},
      isBoolean = {
  true: 1,
  false: 1
},
      immediatePromise = Promise.resolve();
/**
 * @module Core/widget/Tooltip
 */

/**
 * Tooltip. Easiest way of assigning a tooltip to a widget is by setting {@link Core.widget.Widget#config-tooltip}, see example below.
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : 'Click me and you wont believe what happens next'
 * });
 * ```
 *
 * By default, tooltips of widgets use a singleton Tooltip instance which may be accessed from the
 * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
 * This is configured according to the config object on pointer over.
 *
 * To request a separate instance be created just for this widget, add `newInstance : true`
 * to the configuration:
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : {
 *         html        : 'Click me and you wont believe what happens next',
 *         newInstance : true
 *     }
 * });
 * ```
 *
 * You can ask for the singleton instance to display configured tips for your own DOM structure using
 * `data-btip` element attributes:
 *
 * ```html
 * <button class="my-button" data-btip="Contextual help for my button" data-btip-scroll-action="realign">Hover me</button>
 * ```
 *
 * ## Showing async content
 * To load remote content into a simple tooltip, just load your data in the `beforeShow` listener (but ensure that the {@link #property-activeTarget} is the same when the data arrives)
 *
 * ```javascript
 * new Tooltip({
 *     listeners : {
 *         beforeShow : ({ source : tip }) => tip.html = AjaxHelper.get('someurl').then(response => response.text());
 *     }
 * });
 * ```
 *
 * If you have multiple targets that should show a tooltip when hovered over, look at {@link #config-forSelector} and {@link #config-getHtml}.
 *
 * ```javascript
 * new Tooltip({
 *     forSelector : '.myCssClass',
 *     getHtml     : ({ source : tip }) => AjaxHelper.fetch('data').then(response => response.text())
 * });
 * ```
 *
 * @extends Core/widget/Popup
 * @classType tooltip
 * @inlineexample Core/widget/Tooltip.js
 */

class Tooltip extends _Popup_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Default config
  static get $name() {
    return 'Tooltip';
  } // Factoryable type name


  static get type() {
    return 'tooltip';
  }
  /**
   * Triggered before tooltip widget is shown. Return `false` to prevent the action.
   * @preventable
   * @event beforeShow
   * @param {Core.widget.Tooltip} source The Tooltip
   * @param {Event} source.triggeredByEvent The event that triggered this Tooltip to show.
   */


  static get configurable() {
    return {
      /**
       * Horizontal offset from mouse when {@link #config-anchorToTarget} is `false`
       * @config {Number}
       * @default
       */
      mouseOffsetX: 15,

      /**
       * Vertical offset from mouse when {@link #config-anchorToTarget} is `false`
       * @config {Number}
       * @default
       */
      mouseOffsetY: 15,
      floating: true,

      /**
       * A method, or the *name* of a method called to update the tooltip's content when the
       * cursor is moved over a target. It receives one argument containing context about the
       * tooltip and show operation. The function should return a string, or a Promise yielding
       * a string.
       *
       * ```javascript
       * new Grid({
       *     title    : 'Client list',
       *     appendTo : myElement,
       *     store    : myStore,
       *     columns  : myColumns,
       *     tbar     : {
       *         items : {
       *             text : 'Reload,
       *             tooltip : {
       *                 // Will look in ownership hierarchy for the method
       *                 // which will be found on the grid.
       *                 getHtml : 'up.getReloadButtonTip'
       *             }
       *         }
       *     },
       *     getReloadButtonTip() {
       *         return `Reload ${this.title}`;
       *     }
       * });
       * ```
       * @param {Object} context
       * @param {Core.widget.Tooltip} context.tip The tooltip instance
       * @param {HTMLElement} context.element The Element for which the Tooltip is monitoring mouse movement
       * @param {HTMLElement} context.activeTarget The target element that triggered the show
       * @param {Event} context.event The raw DOM event
       * @return {String|Promise}
       * @config {Function|String}
       */
      getHtml: null,

      /**
       * DOM element to attach tooltip to. By default, the mouse entering this element will kick off a timer
       * (see {@link #config-hoverDelay}) to show itself.
       *
       * If the {@link #config-forSelector} is specified, then mouse entering matching elements within the `forElement`
       * will trigger the show timer to start.
       *
       * Note that when moving from matching element to matching element within the `forElement`, the tooltip
       * will remain visible for {@link #config-hideDelay} milliseconds after exiting one element, so that rapidly
       * entering another matching element will not cause hide+show flicker. To prevent this behaviour configure
       * with `hideDelay: 0`.
       * @config {HTMLElement}
       */
      forElement: null,

      /**
       * By default, once a tooltip is shown aligned as requested, it stays put.
       *
       * Setting this to `true` causes the tooltip to be aligned by the mouse,
       * offset by `[{@link #config-mouseOffsetX}, {@link #config-mouseOffsetY}]` and
       * keeps the tooltip aligned to the mouse maintaining the configured offsets
       * as the mouse moves within its activating element.
       * @config {Boolean}
       * @default false
       */
      trackMouse: null,

      /**
       * By default, a tooltip displays static content. In the Scheduler however, there are
       * plenty of uses cases when the tip content is based on the current mouse position (dragging events, resizing events, schedule hover tip, drag creation of events etc). Set
       * to `true` to update contents on mouse movement.
       * @config {Boolean}
       * @private
       */
      updateContentOnMouseMove: false,

      /**
       * A CSS selector which targets child elements of the {@link #config-forElement} that should produce a tooltip when hovered over.
       * @config {String}
       */
      forSelector: null,

      /**
       * By default, when moving rapidly from target to target, if, when mouseovering
       * a new target, the tip is still visible, the tooltip does not hide, it remains
       * visible, but updates its content however it is configured to do so.
       *
       * Configure `hideOnDelegateChange : true` to have the tip hide, and then trigger
       * a new show delay upon entry of a new target while still visible.
       * @config {Boolean}
       * @default false
       */
      hideOnDelegateChange: null,

      /**
       * Set to true to anchor tooltip to the triggering target. If set to `false`, the tooltip
       * will align to the mouse position. When set to `false`, it will also set `anchor: false`
       * to hide anchor arrow.
       * @config {Boolean}
       * @default true
       */
      anchorToTarget: true,

      /**
       * Show on hover
       * @config {Boolean}
       * @default
       */
      showOnHover: false,

      /**
       * The amount of time to hover before showing
       * @config {Number}
       * @default
       */
      hoverDelay: 500,

      /**
       * Show immediately when created
       * @config {Boolean}
       * @default
       */
      autoShow: false,

      /**
       * The time (in milliseconds) that the Tooltip should stay visible for when it shows over its
       * target. If the tooltip is anchored to its target, then moving the mouse during this time
       * resets the timer so that the tooltip will remain visible.
       *
       * Defaults to `0` which means the Tooltip will persist until the mouse leaves the target.
       * @config {Number}
       * @default
       */
      dismissDelay: 0,

      /**
       * The time (in milliseconds) for which the Tooltip remains visible when the mouse leaves the target.
       *
       * May be configured as `false` to persist visible after the mouse exits the target element. Configure it
       * as 0 to always retrigger `hoverDelay` even when moving mouse inside `fromElement`
       * @config {Number}
       * @default
       */
      hideDelay: 500,

      /**
       * The message to show while an async tooltip is fetching its content.
       * @config {String}
       * @default
       */
      loadingMsg: 'Loading...',

      /**
       * Keep the tooltip open if user hovers it
       * @config {Boolean}
       * @default
       */
      allowOver: false,
      anchor: true,
      align: {
        align: 'b-t',
        // This signals to the align code that this widget is prepared to shrink
        // in height in order to comply with alignTo specifications.
        // Without a minHeight, it is assumed that the height of the widget
        // is inviolable.
        minHeight: 300
      },
      axisLock: true,
      testConfig: {
        hideDelay: 100,
        hoverDelay: 100,
        showAnimation: null,
        hideAnimation: null
      }
    };
  } //endregion
  //region Events

  /**
   * Triggered when a mouseover event is detected on a potential target element.
   * Return false to prevent the action
   * @event pointerOver
   * @param {Core.widget.Tooltip} sourceThe tooltip instance.
   * @param {Event} event The mouseover event.
   */
  //endregion
  //region Properties

  /**
   * The HTML element that triggered this Tooltip to show
   * @readonly
   * @member {HTMLElement} activeTarget
   */
  //endregion
  //region Init & destroy


  afterConfigure() {
    const me = this,
          {
      forSelector
    } = me;

    if (forSelector) {
      me.showOnHover = true;

      if (!me.forElement) {
        if (!me.anchorToTarget) {
          me.trackMouse = true;
        }

        me.forElement = me.rootElement.host || me.rootElement;
      }
    }

    super.afterConfigure(); // There's a triggering element, and we're showing on hover, add the mouse listeners

    if (me.forElement && me.showOnHover) {
      me.pointerOverOutDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.forElement,
        // Using pointerover/pointerout since mouseover events are not fired in Chrome when the native `disabled`
        // attribute is present https://github.com/bryntum/support/issues/3179
        pointerover: 'internalOnPointerOver',
        pointerout: 'internalOnPointerOut',
        thisObj: me
      });
    }

    if (me.allowOver) {
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.element,
        mouseenter: 'onOwnElementMouseEnter',
        mouseleave: 'internalOnPointerOut',
        thisObj: me
      });
    }
  }

  doDestroy() {
    this.pointerOverOutDetacher && this.pointerOverOutDetacher();
    super.doDestroy();
  }

  set focusOnToFront(focusOnToFront) {
    super.focusOnToFront = focusOnToFront;
  }

  get focusOnToFront() {
    // Transient things like tooltips should not focus when invoked by pointer events
    return super.focusOnToFront && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].usingKeyboard;
  }

  get focusElement() {
    const result = super.focusElement;

    if (result !== this.element) {
      return result;
    }
  }

  get anchorToTarget() {
    // We do not anchor to the target if we are tracking the mouse
    return this._anchorToTarget && !this.trackMouse;
  }

  get anchor() {
    // We do not anchor to the target if we are tracking the mouse
    return super.anchor && !this.trackMouse;
  }

  set anchor(anchor) {
    super.anchor = anchor;
  } //endregion
  //region Hovering, show and hide


  onDocumentMouseDown({
    event
  }) {
    const me = this,
          {
      triggeredByEvent
    } = me; // If it's a tap that is caused by the touch that was converted into a mouseover we should not hide.
    // That is if it's a touch and at the same place and within 500ms

    if (triggeredByEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isTouchEvent) {
      if (event.pageX === triggeredByEvent.pageX && event.pageY === triggeredByEvent.pageY && me.activeTarget.contains(event.target) && performance.now() - triggeredByEvent.timeStamp < 500) {
        return;
      }
    }

    me.abortDelayedShow();
    super.onDocumentMouseDown({
      event
    });
  }

  internalOnPointerOver(event) {
    const me = this,
          forElement = me.forElement,
          forSelector = me.forSelector,
          activeTarget = me.activeTarget;
    let newTarget; // Respect our owner's wish to not show when it's disabled

    if (me.disabled || me.owner && !me.owner.showTooltipWhenDisabled && me.owner.disabled) {
      return;
    } // If the mouse moves over this tooltip, it is theoretically a mouseout of its
    // forElement, but allowOver lets us tolerate this ane remain visible.


    if (me.allowOver && me.element.contains(event.target)) {
      return;
    } // There's been a mouseover. If we have a forSelector, we have to check
    // if it's an enter of a matching child


    if (forSelector) {
      // Moving inside a forSelector matching element
      if (activeTarget && activeTarget.contains(event.target) && activeTarget.contains(event.relatedTarget)) {
        return;
      }

      newTarget = event.target.closest(forSelector); // Mouseovers while within a target do nothing

      if (newTarget && event.relatedTarget && event.relatedTarget.closest(forSelector) === newTarget) {
        return;
      }
    } // There's no forSelector, so check if we moved from outside the target
    else if (!forElement.contains(event.relatedTarget)) {
      newTarget = forElement;
    } // Mouseover caused by moving from child to child inside the target
    else {
      return;
    } // If pointer entered the target or a forSelector child, then show.


    if (newTarget) {
      me.handleForElementOver(event, newTarget);
    } // If over a non-forSelector child, behave as in forElement out
    else if (activeTarget) {
      me.handleForElementOut();
    }
  } // Handle a transitioned reposition when the activeTarget moved beneath the pointer.
  // When it comes to an end, if the mouseout has not hidden, then realign at the new position
  // if the activeTarget is still beneath the pointer.


  onTransitionEnd(event) {
    const me = this,
          currOver = Tooltip.currentOverElement;

    if (realignTransitions[event.propertyName]) {
      // Don't realign if the mouse is over this, and is allowed to be over this
      // If user is interacting with this Tooltip, they won't expect it to move.
      if (me.allowOver && me.element.contains(currOver)) {
        return;
      } // If we are still visible, and mouse is still over the activeTarget, realign


      if (me.activeTarget && me.activeTarget.contains(currOver) && !me.trackMouse) {
        me.realign();
      }
    }
  }

  async handleForElementOver(event, newTarget) {
    const me = this; // Vetoed, then behave as is a targetout

    if (me.trigger('pointerOver', {
      event,
      target: newTarget
    }) === false) {
      me.internalOnPointerOut(event);
    } else {
      let abortedHide;
      me.triggeredByEvent = event;
      me.abortDelayedHide(); // Abort any in-flight animated hide, and show immediately.
      // This is needed when allowOver is false (which is the default), and mouseovering
      // hides, but that immediately causes the mouse to be over another delegate
      // which jumps right in here.

      if (!me.hideOnDelegateChange && me.element.classList.contains('b-hiding')) {
        me.element.classList.remove('b-hiding');
        abortedHide = true;
      } // We are over a new target. If we are still visible, we
      // do not want to hide to avoid flickering. But if there is a
      // beforeshow listener which may mutate us, we still have to
      // consult it. If it returns a veto, then we do in fact hide.
      // Under normal circumstances we just alignTo the new target.
      // We must handle the post show tasks like starting the dismiss timer etc.


      if ((abortedHide || me.isVisible) && !me.hideOnDelegateChange) {
        me.updateActiveTarget(newTarget);

        if (me.trigger('beforeShow') === false) {
          return me.hide();
        }

        if (abortedHide) {
          me.show(false);
        }

        const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
          await result;
        } // updateContent may have yielded empty content which hides us


        if (!me.hidden) {
          me.alignTo({
            target: me.anchorToTarget ? newTarget : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
            overlap: !(me.anchorToTarget && me.anchor)
          });
          me.trigger('show');
          me.afterShowByTarget();
        }
      } else {
        if (me.hideOnDelegateChange) {
          // Hide with no animation if we are configured to hide between delegates
          me.hide(false);
        }

        me.updateActiveTarget(newTarget);
        me.delayShow(newTarget);
      }
    }
  }

  async delayShow(target) {
    var _me$currentAnimation;

    const me = this; // Caught in a show animation - cancel it,
    // If we're fading away, that's fine.

    if ((_me$currentAnimation = me.currentAnimation) !== null && _me$currentAnimation !== void 0 && _me$currentAnimation.showing) {
      me.cancelHideShowAnimation();
    }

    if (!me.isVisible && !me.hasTimeout('show')) {
      // Allow hoverDelay:0 or rapid movement from delegate to delegate to show immediately
      if (!me.hoverDelay || me.forSelector && Date.now() - me.lastHidden < me.quickShowInterval) {
        const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
          await result;
        }

        me.showByTarget(target);
      } else {
        // If a mouse down happens during the delay period, we cancel the show
        me.addDocumentMouseDownListener(); // If we're not going to anchor to the hovered element, then we need to keep track
        // of mousemoves until the show happens so we can show where the mouse currently is.

        if (!me.listeningForMouseMove && !me.anchorToTarget) {
          me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
            element: me.rootElement,
            mousemove: 'onMouseMove',
            thisObj: me
          });
        } // If a tap event triggered, do not wait. Show immediately.


        me.setTimeout(async () => {
          if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isOrphaned(target)) {
            const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

            if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
              await result;
            }

            me.showByTarget(target);
          }
        }, !me.triggeredByEvent || me.triggeredByEvent.type === 'pointerover' ? me.hoverDelay : 0, 'show');
      }
    } else if (me.isVisible) {
      me.showByTarget(target);
    }
  }

  updateContent() {
    const me = this;

    if (me.getHtml) {
      const result = me.callback(me.getHtml, me, [{
        tip: me,
        element: me.element,
        activeTarget: me.activeTarget,
        event: me.triggeredByEvent
      }]);
      me.html = result;
      return result;
    }
  } // There are 3 possible scenarios:
  // - Static content
  // - Remote content being loaded (meaning we (possibly) set a loading message as the `html`
  // - Tooltip acts as a Container


  get hasContent() {
    return Boolean(this._html !== '' && typeof this.html === 'string' && this.html.length || this.items.length);
  }

  internalBeforeShow() {
    // In case we update content on mouse move, need to show empty tooltip first
    return (this.updateContentOnMouseMove || this.hasContent) && !this.disabled;
  }
  /**
   * Shows a spinner and a message to indicate an async flow is ongoing
   * @param {String} message The message, defaults to {@link #config-loadingMsg}
   */


  showAsyncMessage(message = this.optionalL(this.loadingMsg)) {
    // TODO: Load masking should ideally use a general Widget ability.
    if (message) {
      this.html = `
                <div class="b-tooltip-loading">
                    <i class="b-icon b-icon-spinner"></i>
                    ${message}
                </div>
            `;
    }
  }

  showByTarget(target) {
    const me = this;

    if (me.mouseMoveRemover) {
      me.mouseMoveRemover();
      me.mouseMoveRemover = null;
    } // Show by the correct thing.
    // If we are not anchored to the target, then it's the current pointer event.
    // Otherwise it's the activeTarget.


    me.showBy({
      target: me.anchorToTarget ? target : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
      overlap: !(me.anchorToTarget && me.anchor)
    });
  }

  afterShowByTarget() {
    const me = this,
          dismissDelay = me.dismissDelay;
    me.abortDelayedShow();

    if (dismissDelay) {
      me.setTimeout('hide', dismissDelay);
    }

    me.toFront();
  }

  updateActiveTarget(newTarget) {
    const me = this,
          lastTarget = me.activeTarget;
    me.activeTarget = newTarget;

    if (!me.isConfiguring) {
      me.trigger('overtarget', {
        newTarget,
        lastTarget
      });
    }
  }

  internalOnPointerOut(event) {
    const me = this,
          toElement = event.relatedTarget; // Edge case: If there is no space to fit the tooltip, and as a result of showing the tooltip - the mouse is over the tooltip
    // Make sure we don't end up in an infinite hide/show loop

    if (me.allowOver && me.element.contains(toElement)) {
      return;
    } // If we were in an allowOver situation and exited
    // into the activeTarget, do nothing; in this situation
    // the tip is treated as if it were part of the target.


    if (me.element.contains(event.target) && me.activeTarget && me.activeTarget.contains(toElement)) {
      return;
    } // We have exited the active target


    if (me.activeTarget && !me.activeTarget.contains(toElement)) {
      me.handleForElementOut();
    }
  }

  handleForElementOut() {
    // Separated from onTargetOut so that subclasses can handle target out in any way.
    const me = this,
          {
      hideDelay
    } = me; // Allow outside world to veto the hide

    if (me.trigger('pointerOut') === false) {
      me.activeTarget = null;
      return;
    }

    me.abortDelayedShow(); // Even if there is a hide timer, it's a *dismiss* timer which hides the tip
    // after a hover time. We begin a new delay on target out.

    if (me.isVisible && hideDelay !== false) {
      me.abortDelayedHide();

      if (hideDelay > 0) {
        me.setTimeout('hide', hideDelay);
      } else {
        // Hide immediately when configured with `hideDelay: 0`. Used by async cell tooltips that always should
        // retrigger `hoverDelay`, to not spam the backend
        me.hide();
      }
    }
  }

  show() {
    const me = this; // If we know what element to show it by, and we are anchoring to it
    // and there's no ambiguity with a selector for sub elements,
    // then show it by our forElement (Unless we're being called from showBy)

    if (me.forElement && me.anchorToTarget && !me.forSelector && !me.inShowBy) {
      me.showByTarget(me.forElement);
    } // All we can do is the basic Widget show.
    else {
      if (me.inShowBy) {
        me.y = -10000;
      }

      super.show();
    }

    me.afterShowByTarget(); // If we've shown, and are tracking the mouse and not anchored to (aligned to) the target, track the mouse

    if (!me.mouseMoveRemover && !me._hidden && (me.trackMouse || me.updateContentOnMouseMove)) {
      me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.rootElement,
        [_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents ? 'pointermove' : 'touchmove']: 'onMouseMove',
        thisObj: me
      });
    }

    if (me.forElement && !me.transitionEndDetacher && !me._hidden) {
      me.transitionEndDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.forElement,
        transitionend: 'onTransitionEnd',
        thisObj: me
      });
    }
  }

  hide(...args) {
    const me = this; // If we are asked to hide, we must always abort any impending show.

    me.abortDelayedShow(); // But if we are in fact visible, go ahead and hide

    if (me.isVisible) {
      me.abortDelayedHide();
      const result = super.hide(...args);
      me.lastHidden = Date.now();
      me.activeTarget = null;

      if (me.mouseMoveRemover) {
        me.mouseMoveRemover();
        me.mouseMoveRemover = null;
      }

      if (me.transitionEndDetacher) {
        me.transitionEndDetacher();
        me.transitionEndDetacher = null;
      }

      me.listeningForMouseMove = false;
      return result;
    } else {
      return immediatePromise;
    }
  }

  abortDelayedShow() {
    const me = this;

    if (me.hasTimeout('show')) {
      // This listener is added in delayShow to make a mousedown abort,
      // So we must remove it here because it's only removed in onHide.
      if (me.mouseDownRemover) {
        me.mouseDownRemover();
        me.mouseDownRemover = null;
      }

      me.clearTimeout('show');

      if (me.mouseMoveRemover) {
        me.mouseMoveRemover();
        me.mouseMoveRemover = null;
      }

      if (me.transitionEndDetacher) {
        me.transitionEndDetacher();
        me.transitionEndDetacher = null;
      }
    }
  }
  /**
   * Stops both timers which may hide this tooltip, the one which counts down from mouseout
   * and the one which counts down from mouseover show for dismissDelay ms
   * @private
   */


  abortDelayedHide() {
    this.clearTimeout('hide');
  }

  realign() {
    const me = this,
          spec = me.lastAlignSpec; // If we are hidden because our align target scrolled, or otherwise
    // moved out of its clipping boundaries, then check if it's moved back in.
    // For example EventDrag might move the element outside of the scheduler
    // SubGrid, which will cause the tip to hide, but then moving it back in
    // must reshow it.

    if (!me.isConfiguring && !me.isVisible && spec !== null && spec !== void 0 && spec.targetOutOfView) {
      // If there is an intersecting Rectangle with the forElement, align
      if (spec.allowTargetOut || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isInView(spec.target, false, me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(me.element, 'position') !== 'fixed')) {
        me.show();
        spec.targetOutOfView = false;
      }
    }

    super.realign();
  }

  alignTo(spec) {
    const me = this;

    if (!me.isVisible) {
      return;
    } // If mouse pointer is over this, do not attempt
    // to call the getHtml method.


    if (spec && !(me.triggeredByEvent && me.element.contains(me.triggeredByEvent.target))) {
      if (spec.nodeType === Node.ELEMENT_NODE) {
        spec = {
          target: spec
        };
      }
    }

    super.alignTo(spec);
  } //endregion
  //region Tooltip contents

  /**
   * Get/set the HTML to display. When specifying HTML, this widget's element will also have `b-html` added to its
   * classList, to allow targeted styling. To create async tooltip and show the {@link #config-loadingMsg}, see code below:
   * For example:
   *
   * ```javascript
   * new Tooltip({
   *     listeners : {
   *         beforeShow : ({ source : tip }) => {
   *             tip.showAsyncMessage();
   *             AjaxHelper.get('someurl').then(response => tip.html = 'Done!');
   *         }
   *     }
   * });
   * ```
   *
   * @member {String} html
   * @category DOM
   */


  changeHtml(htmlOrPromise) {
    const me = this;

    if (htmlOrPromise === false) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].deprecate('Grid', '5.0.0', 'Setting false to indicate loading is deprecated, in favor of `showAsyncMessage`. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/3.0.1 for more information');
      this.showAsyncMessage();
      return;
    }

    if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(htmlOrPromise)) {
      me.showAsyncMessage();
      htmlOrPromise.target = me.activeTarget;
      htmlOrPromise.then(html => {
        // Cursor might have exited the element while loading
        if (htmlOrPromise.target === me.activeTarget) {
          me.html = html;
        }
      });
      return;
    } // Allow objects to pass through, to be used with DomSync


    if (typeof htmlOrPromise !== 'object') {
      // Stringify in case a number was passed in
      htmlOrPromise = htmlOrPromise != null ? me.optionalL(String(htmlOrPromise)) : '';
    }

    return htmlOrPromise;
  }

  updateHtml(value, was) {
    const me = this;
    let empty = value === ''; // As setting empty string as content should hide the tooltip, we don't want to actually update the
    // element innerHTML with blank space during the hide transition, we check _html for emptiness in hasContent

    if (!empty) {
      super.updateHtml(value, was);

      if (me.hasContent) {
        if (me.isVisible) {
          me.realign();
        }

        if (!_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(value)) {
          me.trigger('innerHtmlUpdate');
        }
      } else {
        empty = true;
      }
    }

    if (empty) {
      // Hide empty tooltips
      me.hide();
    }
  } //endregion
  //region Events

  /**
   * Mouse move event listener which updates tooltip
   * @private
   */


  onMouseMove(event) {
    const me = this,
          {
      forElement,
      activeTarget
    } = me,
          x = event.pageX - window.pageXOffset + me.mouseOffsetX,
          y = event.pageY - window.pageYOffset + me.mouseOffsetY,
          // If we are trackMouse: true
    // we must keep out of the way of the mouse by continuing
    // to track if we are on the way out due to a hide timer.
    isHiding = me.hasTimeout('hide'),
          target = event.target; // MouseMove is listened for during the hover show timer wait phase if anchorToTarget is false
    // so that when the timer fires, it can show near the most recent pointer position.
    // It's also listened for after show when we are not anchored to the target and so tracking the mouse.

    /**
     * The DOM event that triggered this tooltip to show
     * @member {Event} triggeredByEvent
     * @readonly
     */

    me.triggeredByEvent = event; // Check that we are still valid to be visible, and if so, track the mouse.

    if (!me._hidden) {
      let hideVetoed;
      const // It's a move within our target
      isWithinTarget = activeTarget === null || activeTarget === void 0 ? void 0 : activeTarget.contains(target),
            // Work out whether we have just exited our target.
      // If we are still *inside* the target, do not test the selector.
      isElementOut = !isWithinTarget && me.forSelector && activeTarget && !isHiding && target.nodeType === Node.ELEMENT_NODE && !target.matches(me.forSelector) && !(me.allowOver && me.element.contains(target)),
            // We need an element we can ask the "contains" question about our target.
      // If we are using window, we need to step down to the documentElement.
      containingElement = forElement !== null && forElement !== void 0 && forElement.document ? forElement.document.documentElement : forElement,
            // If the forElement is a ShadowRoot, it won't implement contains
      // but it does implement compareDocumentPosition.
      forElementContainsTarget = containingElement && (containingElement.contains ? containingElement.contains(target) : containingElement.compareDocumentPosition(target) & 16); // Check whether the element we are over is still a valid delegate matching the forSelector,
      // or it's the tip element, and we're allowOver. If not, we have to hide.
      // nodeType check is for FF on Linux, event.target is sometimes a text node

      if (isElementOut) {
        hideVetoed = me.handleForElementOut();
      } // If we are not hiding due to moving mouse outside our forElement (or hide being vetoed), tooltip stays visible and optionally realigns based on trackMouse setting.


      if (hideVetoed || !isHiding || forElementContainsTarget) {
        // Mousemoves restart the dismiss timer.
        if (me.dismissDelay && !isHiding) {
          me.setTimeout('hide', me.dismissDelay);
        }

        if (me.updateContentOnMouseMove && me.getHtml) {
          me.html = me.callback(me.getHtml, me, [{
            tip: me,
            element: me.element,
            forElement: activeTarget,
            event: event
          }]);

          if (!me.html) {
            // Nothing to display, hide
            me.hide();
            return;
          }
        } // If we're not anchoring to the target, track the mouse


        if (me.trackMouse) {
          me.alignTo({
            position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](x, y),
            ignorePageScroll: true
          });
        }
      }
    }
  }

  onOwnElementMouseEnter(event) {
    this.abortDelayedHide();
  } //endregion


  static getSharedTooltip(rootElement, skipCreating) {
    var _rootElement$bryntum, _rootElement$bryntum$;

    let sharedTooltip = (_rootElement$bryntum = rootElement.bryntum) === null || _rootElement$bryntum === void 0 ? void 0 : (_rootElement$bryntum$ = _rootElement$bryntum.tooltip) === null || _rootElement$bryntum$ === void 0 ? void 0 : _rootElement$bryntum$.get(Tooltip);

    if (!sharedTooltip && !skipCreating) {
      var _rootElement$bryntum2;

      // Store shared tooltips in a map on root element,
      // keyed by the class to work with multiple bundles on page
      if (!((_rootElement$bryntum2 = rootElement.bryntum) !== null && _rootElement$bryntum2 !== void 0 && _rootElement$bryntum2.tooltip)) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setPath(rootElement, 'bryntum.tooltip', new Map());
      }

      const map = rootElement.bryntum.tooltip; // Avoid infinite loop as the Tooltip gets created with rootElement too

      map.set(Tooltip, true);
      sharedTooltip = new Tooltip({
        forElement: rootElement,
        rootElement,
        forSelector: '[data-btip]',
        resetCfg: {},
        isShared: true,
        cls: 'b-tooltip-shared',
        listeners: {
          // Reconfigure on pointerOver
          pointerOver({
            source: me,
            target
          }) {
            // Revert last pointerOver config set to initial setting.
            for (const key in me.resetCfg) {
              if (key === 'listeners') {
                me.un(me.resetCfg[key].set);
              } // Do not reset HTML to "". It causes an unwanted inter-delegate hide.
              // hideOnDelegateChange defaults to false.
              else if (key !== 'html') {
                me[key] = me.resetCfg[key].was;
              }
            }

            me.resetCfg = {};
            const forComponent = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].getById(target.id),
                  // If it's a component's tooltip, configure from the component,
            // Otherwise gather from the dataset
            config = (forComponent === null || forComponent === void 0 ? void 0 : forComponent.tipConfig) || me.gatherDataConfigs(target.dataset); // getById might find an entry with same id in different context, or element might belong to a
            // widget that could not be resolved since it is in another context -> ignore

            if (forComponent && forComponent.element !== target || !forComponent && target.matches('.b-widget') || // Respect our forComponent's wish to not show when it's disabled
            forComponent !== null && forComponent !== void 0 && forComponent.disabled && !forComponent.showTooltipWhenDisabled) {
              return false;
            } // Tooltip must be linked to an activating owner before it shows
            // so that configs which use 'up.propName' will be work as expected.


            me.owner = forComponent;

            for (const key in config) {
              me.resetCfg[key] = {
                set: config[key],
                was: me[key]
              };

              if (key === 'listeners') {
                me.on(config[key]);
              } else {
                me[key] = config[key];
              }
            }
          },

          hide({
            source: me
          }) {
            me.owner = null;
          }

        },

        gatherDataConfigs(dataset) {
          const me = this,
                config = {};

          for (const key in dataset) {
            if (key.startsWith('btip')) {
              if (key.length > 4) {
                const configProp = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].uncapitalize(key.substr(4)); // Snip off "btip" prefix to convert to property name
                // If we have a config by the name, set it

                if (configProp in me.getDefaultConfiguration()) {
                  const value = dataset[key]; // gather the found config value

                  config[configProp] = isBoolean[value] ? value === 'true' : isNaN(value) ? value : parseInt(value, 10);
                }
              } else {
                config.html = dataset[key];
              }
            }
          }

          return config;
        }

      });
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: rootElement,
        mouseenter: event => Tooltip.currentOverElement = event.target,
        capture: true
      });
      map.set(Tooltip, sharedTooltip);
    }

    return sharedTooltip;
  }

} // Register this widget type with its Factory

Tooltip.initClass();
Object.defineProperty(_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"], 'tooltip', {
  get() {
    return Tooltip.getSharedTooltip(document.body);
  }

});
/**
 * Updated dynamically with the current element that the mouse is over. For use when showing a Tooltip
 * from code which is not triggered by a pointer event so that a tooltip can be positioned.
 * @member {HTMLElement} currentOverElement
 * @readonly
 * @static
 */
// Register this widget type with its Factory

_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].Tooltip = Tooltip;
Tooltip._$name = 'Tooltip';

/***/ }),

/***/ "./lib/Core/widget/Widget.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Widget.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Widget; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Config.js */ "./lib/Core/Config.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Fullscreen.js */ "./lib/Core/helper/util/Fullscreen.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Mask_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Mask.js */ "./lib/Core/widget/Mask.js");
var productName = 'gantt';






















 // TODO: Needs more docs

/**
 * @module Core/widget/Widget
 */

const floatRoots = [],
      isTransparent = /transparent|rgba\(0,\s*0,\s*0,\s*0\)/,
      textInputTypes = {
  INPUT: 1,
  TEXTAREA: 1
},
      addElementListeners = (me, element, domConfig, refName) => {
  var _listeners;

  let listeners = domConfig === null || domConfig === void 0 ? void 0 : domConfig.listeners;
  listeners = ((_listeners = listeners) === null || _listeners === void 0 ? void 0 : _listeners.on) || listeners;

  if (listeners) {
    const un = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
      element,
      thisObj: me
    }, listeners));

    if (refName) {
      // The domConfig for refs gets regenerated on each compose() so we cannot use them to store the un
      // functions.
      (me._refListeners || (me._refListeners = Object.create(null)))[refName] = un;
    } else {
      domConfig.listeners = {
        on: listeners,
        un
      };
    }
  }
},
      mergeAnim = (value, was) => {
  // The show/hideAnimation objects can only have one animation property, but it is fine to merge if they have
  // the same property.
  return value && was && was[_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].keys(value)[0]] ? _Config_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(value, was) : value;
},
      // Need braces here. MUST NOT return false
widgetTriggerPaint = w => {
  w.isVisible && w.triggerPaint();
},
      negationPseudo = /^:not\((.+)\)$/,
      nonFlowedPositions = /absolute|fixed/i,
      isScaled = w => w.scale != null,
      {
  hasOwnProperty
} = Object.prototype,
      {
  defineProperty
} = Reflect,
      parseDuration = d => parseFloat(d) * (d.endsWith('ms') ? 1 : 1000),
      immediatePromise = Promise.resolve(),
      alignedClass = ['b-aligned-above', 'b-aligned-right', 'b-aligned-below', 'b-aligned-left'],
      returnFalseProp = {
  configurable: true,

  get() {
    return false;
  }

};
/**
 * Base class for other widgets. The Widget base class simply encapsulates an element, and may optionally contain some
 * specified {@link #config-html}.
 *
 * ## Rendering
 *
 * Subclasses should override the {@link #function-compose} method to return their encapsulating element and internal
 * DOM structure. The `compose()` method returns a {@link Core.helper.DomHelper#function-createElement-static} config
 * object that is* used to create the DOM structure, based on its {@link Core.Base#property-configurable-static}
 * properties:
 *
 * ```javascript
 *  class Button extends Widget {
 *      static get configurable() {
 *          return {
 *              cls  : null,
 *              text : null
 *          };
 *      }
 *
 *      compose() {
 *          const { cls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *              text
 *          };
 *      }
 *  }
 * ```
 *
 * The config properties used by the `compose()` method are auto-detected when the method is first called for a class.
 * All relevant properties must be read, even if they end up not being used so that future changes to these properties
 * will mark the rendering as dirty.
 *
 * When a config property used by `compose()` is modified, the {@link #function-recompose} method is called. Since
 * `recompose()` is a {@link Core.mixin.Delayable#property-delayable-static delayable} method, calling it schedules a
 * delayed call to `compose()` and a DOM update. Accessing the Widget's primary `element` or any reference element
 * property will force the DOM update to occur immediately.
 *
 * ### Child Elements
 *
 * Unlike typical {@link Core.helper.DomHelper#function-createElement-static DOM config} objects, the object returned
 * by `compose()` can use an object to simplify naming:
 *
 * ```javascript
 *  class Button extends Widget {
 *      ...
 *
 *      compose() {
 *          const { cls, iconCls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *
 *              children : {
 *                  iconElement : iconCls && {
 *                      class : {
 *                          'button-icon' : 1,
 *                          [iconCls]     : 1
 *                      }
 *                  },
 *
 *                  textElement : {
 *                      text
 *                  }
 *              }
 *          };
 *      }
 *  }
 * ```
 *
 * The keys of the `children` are [iterated](https://2ality.com/2015/10/property-traversal-order-es6.html) to convert
 * the values into the array required by {@link Core.helper.DomHelper#function-createElement-static}. The names of the
 * properties becomes the `reference` of the element.
 *
 * For example, the above is equivalent to the following:
 *
 * ```javascript
 *  class Button extends Widget {
 *      ...
 *
 *      compose() {
 *          const { cls, iconCls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *
 *              children : [iconCls && {
 *                  reference : 'iconElement',
 *                  class : {
 *                      'button-icon' : 1,
 *                      [iconCls]     : 1
 *                  }
 *              }, {
 *                  reference : 'textElement',
 *                  text
 *              }]
 *          };
 *      }
 *  }
 * ```
 *
 * The object form of `children` is preferred for clarity but also because it facilitates inheritance.
 *
 * ### Inheritance
 *
 * When a derived class implements `compose()`, the object it returns is automatically merged with the object returned
 * by the base class.
 *
 * For example, the following class adds a new child element:
 *
 * ```javascript
 *  class MenuButton extends Button {
 *      ...
 *
 *      compose() {
 *          const { menuCls } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              children : {
 *                  menuElement : {
 *                      class : {
 *                          'button-menu' : 1,
 *                          [menuCls]     : 1
 *                      }
 *                  }
 *              }
 *          };
 *      }
 *  }
 * ```
 *
 * ### Listeners
 *
 * Reference elements may also define event `listeners` in the `compose()` method:
 *
 * ```javascript
 *  class Button extends Widget {
 *      compose() {
 *          const { cls, text } = this;
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *              text,
 *
 *              listeners : {
 *                  click : 'onClick'
 *              }
 *          };
 *      }
 *
 *      onClick(event) {
 *          // handle click event
 *      }
 *  }
 * ```
 *
 * ## Resolving properties
 *
 * Values for a Widgets properties can be resolved from the ownership hierarchy. For example a text field in a toolbar
 * can get its initial value from a property on the container owning the toolbar. This is achieved by prefixing the
 * desired property name with 'up.':
 *
 * ```javascript
 *  const grid = new Grid((
 *      tbar : [{
 *          type  : 'numberfield',
 *          // Fields value will be retrieved from the grids rowHeight property
 *          value : 'up.rowHeight'
 *      }]
 *  });
 * ```
 *
 * NOTE: this is for now a one way one time binding, the value will only be read initially and not kept up to date on
 * later changes.
 *
 * @mixes Core/mixin/Events
 * @mixes Core/localization/Localizable
 * @extends Core/Base
 * @classType widget
 */


class Widget extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_19__["default"]) {
  //region Config

  /**
   * Class name getter.
   * Used when original ES6 class name is minified or mangled during production build.
   * Should be overriden in each class which extends Widget or it descendants.
   *
   * ```javascript
   * class MyNewClass extends Widget {
   *     static get $name() {
   *        return 'MyNewClass';
   *     }
   * }
   * ```
   *
   * @static
   * @member {String} $name
   */
  static get $name() {
    return 'Widget';
  } // Factoryable type name


  static get type() {
    return 'widget';
  }

  static get configurable() {
    return {
      /**
       * Get this widget's encapsulating HTMLElement, which is created along with the widget but added to DOM at
       * render time.
       * @member {HTMLElement} element
       * @readonly
       * @category DOM
       */

      /**
       * A {@link Core.helper.DomHelper#function-createElement-static} config object or HTML string from which to
       * create the Widget's element.
       * @private
       * @config {Object|String}
       * @category DOM
       */
      element: true,
      callOnFunctions: true,

      /**
       * Get/set widgets id
       * @member {String} id
       * @category DOM
       */

      /**
       * Widget id, if not specified one will be generated. Also used for lookups through Widget.getById
       * @config {String}
       * @category DOM
       */
      id: '',

      /**
       * The HTML to display initially or a function returning the markup (called at widget construction time)
       * @config {String|Function}
       * @category DOM
       */
      html: null,

      /**
       * Set HTML content safely, without disturbing sibling elements which may have been
       * added to the {@link #property-contentElement} by plugins and features.
       * When specifying html, this widget's element will also have the {@link #config-htmlCls}
       * added to its classList, to allow targeted styling.
       * @member {String} content
       * @category DOM
       */

      /**
       * The HTML content that coexists with sibling elements which may have been added to the
       * {@link #property-contentElement} by plugins and features.
       * When specifying html, this widget's element will also have the {@link #config-htmlCls}
       * class added to its classList, to allow targeted styling.
       * @config {String} content
       * @category DOM
       */
      content: null,

      /**
       * Custom CSS classes to add to element.
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       * ```javascript
       *  cls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      cls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Custom CSS class name suffixes to apply to the elements rendered by this widget. This may be specified
       * as a space separated string, an array of strings, or as an object in which property names with truthy
       * values are used as the class names.
       *
       * For example, consider a `Panel` with a `ui` config like so:
       *
       * ```javascript
       *  new Panel({
       *      text : 'OK',
       *      ui   : 'light'
       *  });
       * ```
       * This will apply the CSS class `'b-panel-ui-light'` to the main element of the panel as well as its many
       * child elements. This allows simpler CSS selectors to match the child elements of this particular panel
       * UI:
       *
       * ```
       *  .b-panel-content.b-panel-ui-light {
       *      background-color : #eee;
       *  }
       * ```
       * Using the {@link #config-cls cls config} would make matching the content element more complex, and in
       * the presence of {@link Core.widget.Panel#config-strips docked items} and nested panels, impossible to
       * target accurately.
       *
       * @config {String|Object}
       * @category CSS
       */
      ui: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Determines how a {@link Core.widget.Panel#config-collapsed} panel will treat this widget if it resides
       * within the panel's header (for example, as one of its {@link Core.widget.Panel#config-strips} or
       * {@link Core.widget.Panel#config-tools}).
       *
       * Valid options are:
       *  - `null` : The widget will be moved to the overlay when collapsed (the default).
       *  - `false` : The widget will be unaffected when the panel is collapsed.
       *  - `'hide'` : The widget will be hidden when the panel is collapsed.
       *  - `'overlay'` : The widget will only appear in the collapsed panel's overlay header.
       *
       * @config {Boolean|String}
       * @private
       */
      collapsify: null,

      /**
       * Custom CSS classes to add to the {@link #property-contentElement}.
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       * ```javascript
       *  cls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      contentElementCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Custom CSS classes to add to this widget's `element`. This property is typically used internally to
       * assign default CSS classes while allowing `cls` to alter these defaults. It is not recommended that
       * client code set this config but instead should set `cls`.
       *
       * For example, to remove a class defined by `defaultCls` using `cls`, declare the class name as a key with
       * a falsy value:
       *
       * ```javascript
       *  cls : {
       *      'default-class' : false
       *  }
       * ```
       * @config {String|Object|String[]}
       * @internal
       */
      defaultCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Controls the placement of this widget when it is added to a {@link Core.widget.Panel panel's}
       *  {@link Core.widget.Panel#config-strips strips collection}. Typical values for this config are `'top'`,
       * `'bottom'`, `'left'`, or `'right'`, which cause the widget to be placed on that side of the panel's
       * body. Such widgets are called "edge strips".
       *
       * If this config is set to `'header'`, the widget is placed in the panel's header, following the title. If
       * this config is set to `'pre-header'`, the widget is placed before the title. Such widgets are called
       * "header strips".
       *
       * @config {String} dock
       * @category Layout
       */
      dock: null,
      parent: null,

      /**
       * The {@link Core.widget.Tab tab} created for this widget when it is placed in a
       * {@link Core.widget.TabPanel}.
       * @member {Core.widget.Tab} tab
       * @readonly
       * @category Misc
       */

      /**
       * A configuration for the {@link Core.widget.Tab tab} created for this widget when it is placed in a
       * {@link Core.widget.TabPanel}. For example, this config can be used to control the icon of the `tab` for
       * this widget:
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      // other configs...
       *
       *      tab : {
       *          icon : 'b-fa-wrench'
       *      }
       *  }, ... ]
       * ```
       *
       * Another use for this config is to set the tab's {@link Core.widget.mixin.Rotatable#config-rotate} value
       * differently than the default managed by the `TabPanel`:
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      // other configs...
       *
       *      tab : {
       *          rotate : false   // don't rotate even if tabBar is docked left or right
       *      }
       *  }, ... ]
       * ```
       *
       * Set this to `false` to prevent the creation of a `tab` for this widget. In this case, this widget must
       * be {@link #function-show shown} explicitly. The {@link Core.widget.TabPanel#config-activeTab} for the
       * tab panel will be -1 in this situation.
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      tab  : false,    // no tab for this item
       *
       *      // other configs...
       *  }, ... ]
       * ```
       *
       * @config {Boolean|Object} tab
       * @category Misc
       */
      tab: null,

      /**
       * An object specifying attributes to assign to the root element of this widget
       * @internal
       * @config {Object}
       * @category Misc
       */
      elementAttributes: null,

      /**
       * The CSS class(es) to add when HTML content is being applied to this widget.
       * @config {String|Object}
       * @category CSS
       */
      htmlCls: {
        $config: {
          merge: 'classList'
        },
        value: {
          'b-html': 1
        }
      },

      /**
       * Custom style spec to add to element
       * @config {String}
       * @category CSS
       */
      style: null,

      /**
       * Get/set element's disabled state
       * @member {Boolean} disabled
       * @category Misc
       */

      /**
       * Disable or enable the widget. It is similar to {@link #config-readOnly} except a disabled widget
       * cannot be focused, uses a different rendition (usually greyish) and does not allow selecting its value.
       * @default false
       * @config {Boolean}
       * @category Misc
       */
      disabled: null,

      /**
       * Get/set element's readOnly state. This is only valid if the widget is an input
       * field, __or contains input fields at any depth__. Updating this property will trigger
       * a {@link #event-readOnly} event.
       *
       * All descendant input fields follow the widget's setting. If a descendant
       * widget has a readOnly config, that is set.
       * @member {Boolean} readOnly
       * @category Misc
       */

      /**
       * Whether this widget is read-only.  This is only valid if the widget is an input
       * field, __or contains input fields at any depth__.
       *
       * All descendant input fields follow the widget's setting. If a descendant
       * widget has a readOnly config, that is set.
       * @default false
       * @config {Boolean}
       * @category Misc
       */
      readOnly: {
        value: null,
        default: false,
        $config: null
      },

      /**
       * Element (or element id) to adopt as this Widget's encapsulating element. The widget's
       * content will be placed inside this element.
       *
       * If this widget has not been configured with an id, it will adopt the id of the element
       * in order to preserve CSS rules which may apply to the id.
       * @config {HTMLElement|String}
       * @default
       * @category DOM
       */
      adopt: null,

      /**
       * Element (or element id) to append this widgets element to
       * @config {HTMLElement|String}
       * @default
       * @category DOM
       */
      appendTo: null,

      /**
       * Element (or element id) to insert this widget before. If provided, {@link #config-appendTo} config is ignored.
       * @config {HTMLElement|String}
       * @category DOM
       */
      insertBefore: null,

      /**
       * Element (or element id) to append this widget element to, as a first child. If provided, {@link #config-appendTo} config is ignored.
       * @config {HTMLElement|String}
       * @category DOM
       */
      insertFirst: null,

      /**
       * Object to apply to elements dataset (each key will be used as a data-attribute on the element)
       * @config {Object}
       * @category DOM
       */
      dataset: null,

      /**
       * Tooltip for the widget, either as a string or as a Tooltip config object.
       *
       * By default, the Widget will use a single, shared instance to display its tooltip as configured,
       * reconfiguring it to the specification before showing it. Therefore, it may not be permanently
       * mutated by doing things such as adding fixed event listeners.
       *
       * To have this Widget *own* its own `Tooltip` instance, add the property `newInstance : true`
       * to the configuration. In this case, the tooltip's {@link #property-owner} will be this Widget.
       * @config {String|Object}
       * @category Misc
       */
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * Set to false to not show the tooltip when this widget is {@link #property-disabled}
       * @config {Boolean}
       * @default
       */
      showTooltipWhenDisabled: true,

      /**
       * Prevent tooltip from being displayed on touch devices. Useful for example for buttons that display a
       * menu on click etc, since the tooltip would be displayed at the same time.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      preventTooltipOnTouch: null,

      /**
       * Specify true to have widget monitoring its own resize.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      monitorResize: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * Set to `true` to apply the default mask to the widget. Alternatively, this can be the mask message or a
       * {@link Core.widget.Mask} config object.
       * @config {Boolean|String|Object|Core.widget.Mask}
       * @category Misc
       */
      masked: null,

      /**
       * This config object contains the defaults for the {@link Core.widget.Mask} created for the
       * {@link #config-masked} config. Any properties specified in the `masked` config will override these
       * values.
       * @config {Object|Core.widget.Mask}
       * @default
       * @category Misc
       */
      maskDefaults: {
        target: 'element'
      },
      cache: {},

      /**
       * Set to `true` to move the widget out of the document flow and position it
       * absolutely in browser viewport space.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      floating: null,

      /**
       * Set to `true` when a widget is rendered into another widget's  {@link #property-contentElement}, but must not
       * participate in the standard layout of that widget, and must be positioned relatively to that
       * widget's {@link #property-contentElement}.
       *
       * {@link Core.widget.Editor Editor}s are positioned widgets.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      positioned: null,

      /**
       * Only valid if this Widget is {@link #config-floating}
       * Set to `true` to be able to drag a widget freely on the page. Or set to an object with a ´handleSelector´ property which controls when a drag
       * should start.
       *
       * ```javascript
       *
       * draggable : {
       *     handleSelector : ':not(button)'
       * }
       *
       * ```
       *
       * @config {Boolean|Object}
       * @default false
       * @category Float & align
       */
      draggable: null,

      /**
       * _Only valid if this Widget is {@link #config-floating}._
       *
       * How to align this element with its target when {@link #function-showBy} is called
       * passing a simple element as an align target.
       *
       * Either a full alignment config object as passed to {@link #function-showBy}, or for simple
       * cases, the edge alignment string to use.
       *
       * When using a simple string, the format is `'[trblc]n-[trblc]n'` and it specifies our edge and
       * the target edge plus optional offsets from 0 to 100 along the edges to align to.
       *
       * See the {@link #function-showBy} function for more details about using the object form.
       *
       * Once set, this is stored internally in object form.
       * @config {Object|String}
       * @category Float & align
       */
      align: 't-b',
      // NOTE: this config changes meaning in tools and grid columns, so we don't get too clever here (such as
      //  config merge fn that promotes strings to objects)

      /**
       * Only valid if this Widget is {@link #config-floating}
       * Set to `true` to centre the Widget in browser viewport space.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      centered: null,

      /**
       * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
       * Element, Widget or Rectangle to which this Widget is constrained.
       * @config {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle}
       * @default document.body
       * @category Float & align
       */
      constrainTo: undefined,

      /**
       * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
       * `true` to show a connector arrow pointing to the align target.
       * @config {Boolean}
       * @default false
       * @category Float & align
       */
      anchor: null,

      /**
       * The owning Widget of this Widget. If this Widget is directly contained, this will be the containing Widget.
       * If there is a `forElement`, this config will be that element's encapsulating Widget.
       *
       * If this Widget is floating, this config must be specified by the developer.
       * @config {Core.widget.Widget}
       * @category Float & align
       */
      owner: null,

      /**
       * Defines what to do if document is scrolled while Widget is visible (only relevant when floating is set to true).
       * Valid values: ´null´: do nothing, ´hide´: hide the widget or ´realign´: realign to the target if possible.
       * @config {String}
       * @default
       * @category Float & align
       */
      scrollAction: null,

      /**
       * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
       * property should be animated upon hide, and how it should be animated eg:
       *
       * ```javascript
       * {
       *    opacity: {
       *        to : 0,
       *        duration: '10s',
       *        delay: '0s'
       *    }
       * }
       * ```
       *
       * Set to `'false'` to disable animation.
       *
       * @config {Boolean|Object}
       * @category Float & align
       */
      hideAnimation: {
        $config: {
          merge: mergeAnim
        },
        value: null
      },

      /**
       * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
       * property should be animated upon show, and how it should be animated eg:
       *
       * ```javascript
       * {
       *    opacity: {
       *        to : 1,
       *        duration: '10s',
       *        delay: '0s'
       *    }
       * }
       * ```
       *
       * Set to `'false'` to disable animation.
       *
       * @config {Boolean|Object}
       * @category Float & align
       */
      showAnimation: {
        $config: {
          merge: mergeAnim
        },
        value: null
      },

      /**
       * The x position for the widget.
       *
       * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
       *
       * @config {Number}
       * @default
       * @category Float & align
       */
      x: null,

      /**
       * The y position for the widget.
       *
       * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
       *
       * @config {Number}
       * @default
       * @category Float & align
       */
      y: null,

      /**
       * Accessor to the {@link Core.helper.util.Scroller} which can be used
       * to both set and read scroll information.
       * @member {Core.helper.util.Scroller} scrollable
       * @category Layout
       */

      /**
       * Specifies whether (and optionally in which axes) a Widget may scroll. `true` means this widget
       * may scroll in both axes. May be an object containing boolean `overflowX` and `overflowY` properties which are applied
       * to CSS style properties `overflowX` and `overflowY`. If they are boolean, they are translated
       * to CSS overflow properties thus:
       *
       * *`true` -> `'auto'`
       * *`false` -> `'hidden'`
       *
       * After initialization, this property yields a {@link Core.helper.util.Scroller} which may be used
       * to both set and read scroll information.
       *
       * A Widget uses its `get overflowElement` property to select which element is to be scrollable.
       * By default, in the base `Widget` class, this is the Widget's encapsulating element. Subclasses
       * may implement `get overflowElement` to scroll inner elements.
       * @config {Boolean|Object|Core.helper.util.Scroller}
       * @default false
       * @category Scrolling
       */
      scrollable: {
        $config: ['nullify'],
        value: null
      },

      /**
       * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Core.helper.util.Scroller}.
       * @internal
       * @config {Core.helper.util.Scroller}
       * @typings {typeof Scroller}
       * @category Scrolling
       */
      scrollerClass: _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_14__["default"],

      /**
       * The name of the property to set when a single value is to be applied to this Widget. Such as when used
       * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
       * @config {String}
       * @default 'html'
       * @category Misc
       */
      defaultBindProperty: 'html',

      /**
       * Event that should be considered the default action of the widget. When that event is triggered the
       * widget is also expected to trigger an `action` event. Purpose is to allow reacting to most widgets in
       * a coherent way.
       * @private
       * @config {String}
       * @category Misc
       */
      defaultAction: null,

      /**
       * When set to `true`, this widget is considered as a whole when processing {@link Core.widget.Toolbar}
       * overflow. When `false`, this widget's child items are considered instead.
       * @config {Boolean}
       * @default true
       * @category Layout
       * @internal
       */
      overflowable: {
        value: null,
        default: true,
        $config: null
      },

      /**
       * Widget's width, used to set element style.width. Either specify a valid width string or a number, which
       * will get 'px' appended. We recommend using CSS as the primary way to control width, but in some cases
       * this config is convenient.
       * @config {String|Number}
       * @category Layout
       */
      width: null,

      /**
       * Widget's height, used to set element style.height. Either specify a valid height string or a number, which
       * will get 'px' appended. We recommend using CSS as the primary way to control height, but in some cases
       * this config is convenient.
       * @config {String|Number}
       * @category Layout
       */
      height: null,

      /**
       * The element's maxHeight. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      maxHeight: null,

      /**
       * The elements maxWidth. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      maxWidth: null,

      /**
       * The elements minWidth. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      minWidth: null,

      /**
       * The element's minHeight. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      minHeight: null,
      // not public, only used by us in docs
      scaleToFitWidth: null,
      allowGrowWidth: true,
      // only used if scaleToFitWidth is true

      /**
       * Get element's margin property. This may be configured as a single number or a `TRBL` format string.
       * numeric-only values are interpreted as pixels.
       * @member {Number|String} margin
       * @category Layout
       */

      /**
       * Widget's margin. This may be configured as a single number or a `TRBL` format string.
       * numeric-only values are interpreted as pixels.
       * @config {Number|String}
       * @category Layout
       */
      margin: null,

      /**
       * Get element's flex property. This may be configured as a single number or a format string:
       *
       *      <flex-grow> <flex-shrink> <flex-basis>
       *
       * Numeric-only values are interpreted as the `flex-grow` value.
       * @member {Number|String} flex
       * @category Layout
       */

      /**
       * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
       * flexbox layout. This config allows you to set this widget's
       * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex">flex</a> style.
       * This may be configured as a single number or a `<flex-grow> <flex-shrink> <flex-basis>` format string.
       * numeric-only values are interpreted as the `flex-grow` value.
       * @config {Number|String}
       * @category Layout
       */
      flex: null,

      /**
       * A widgets weight determines its position among siblings when added to a {@link Core.widget.Container}.
       * Higher weights go further down.
       * @config {Number}
       * @category Layout
       */
      weight: null,

      /**
       * Get/set this widget's `align-self` flexbox setting. This may be set to modify how this widget is aligned
       * within the cross axis of a flexbox layout container.
       * @member {String} alignSelf
       * @category Layout
       */

      /**
       * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
       * flexbox layout. This config allows you to set this widget's
       * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-self">align-self</a> style.
       * @config {String}
       * @category Layout
       */
      alignSelf: null,

      /**
       * Configure as `true` to have the component display a translucent ripple when its
       * {@link #property-focusElement}, or {@link #property-element} is tapped *if the
       * current theme supports ripples*. Out of the box, only the Material theme supports ripples.
       *
       * This may also be a config object containing the following properties:
       *
       *  - `delegate  ` Optional. A CSS selector to filter which child elements trigger ripples. By default
       * the ripple is clipped to the triggering element.
       *  - `color     ` Optional, default = `#000`. A CSS color name or specification.
       *  - `radius    ` Optional, default is 100. The ending radius of the ripple.
       * Note that it will be clipped by the target element by default.
       *  - `clip      ` A string which describes how to clip the ripple if it is not to be clipped to the default
       * element. Either the property of the widget to use as the clipping element, or a selector to
       * allow clipping to the closest matching ancestor to the target element.
       *
       * eg:
       *```
       *    columns  : [{}...],
       *    ripple   : {
       *        color : 'red',
       *        clip  : '.b-grid-row'
       *    },
       *    ...
       *```
       * @config {Boolean|Object}
       * @category Misc
       */
      ripple: null,

      /**
       * A title to display for the widget. Only in effect when inside a container that uses it (such as TabPanel)
       * @default
       * @config {String}
       * @category DOM
       */
      title: null,
      localizableProperties: ['title'],
      // Set this flag to require element to have a size to be considered visible
      requireSize: false,

      /**
       * An identifier by which this widget will be registered in the {@link Core.widget.Container#property-widgetMap}
       * of all ancestor containers.
       *
       * If omitted, this widget will be registered using its {@link #config-id}. In most cases `ref` is
       * preferable over `id` since `id` is required to be globally unique while `ref` is not.
       *
       * The `ref` value is also added to the elements dataset, to allow targeting it using CSS etc.
       * @default
       * @config {String}
       * @category Misc
       */
      ref: null,

      /**
       * Get/set the widget hidden state.
       *
       * Note: `hidden : false` does *not* mean that this widget is definitely visible.
       * To ascertain visibility, use the {@link #property-isVisible} property.
       * @member {Boolean} hidden
       * @category Visibility
       */

      /**
       * Configure with true to make widget initially hidden.
       * @default false
       * @config {Boolean}
       * @category Layout
       */
      hidden: null,

      /**
       * Text alignment: 'left', 'center' or 'right'. Applied by adding a `b-text-align-xx` class to the widgets
       * element. Blank by default, which does not add any alignment class.
       * @config {String}
       * @category Layout
       */
      textAlign: null,
      // When adding our scroll listeners to hide/realign, we ignore events
      // happening too quickly as a result of the show/align action
      ignoreScrollDuration: 500,

      /**
       * The tag name of this Widget's root element
       * @config {String}
       * @default
       * @category DOM
       */
      tag: 'div',

      /**
       * Set this config to `false` to disable batching DOM updates on animation frames for this widget. This
       * has the effect of synchronously updating the DOM when configs affecting the rendered DOM are modified.
       * Depending on the situation, this could simplify code while increasing time spent updating the DOM.
       * @config {Boolean}
       * @default true
       * @internal
       */
      recomposeAsync: null,

      /**
       * If you are rendering this widget to a shadow root inside a web component, set this config to the shadowRoot
       * @config {ShadowRoot}
       * @default
       * @category Misc
       */
      rootElement: null,
      htmlMutationObserver: {
        $config: ['lazy', 'nullify'],
        value: {
          childList: true,
          subtree: true
        }
      }
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * true if no id was set, will use generated id instead (widget1, ...). Toggle automatically on creation
       * @member {Boolean} hasGeneratedId
       * @private
       * @category Misc
       */
      hasGeneratedId: false,

      /**
       * This readonly property is `true` for normal widgets in the {@link Core.widget.Container#config-items} of
       * a container. It is `false` for special widgets such as a {@link Core.widget.Panel#config-tbar}.
       * @member {Boolean} innerItem
       * @internal
       * @category Misc
       */
      innerItem: true
    };
  }

  static get declarable() {
    return [
    /**
     * This property declares the set of config properties that affect a Widget's rendering, i.e., the configs
     * used by the {@link #function-compose} method.
     *
     * For example:
     * ```javascript
     *  class Button extends Widget {
     *      static get renderConfigs() {
     *          return [ 'cls', 'iconCls', 'text' ];
     *      }
     *  }
     * ```
     *
     * Alternatively this can be an object:
     *
     * ```javascript
     *  class Button extends Widget {
     *      static get renderConfigs() {
     *          return {
     *              cls     : true,
     *              iconCls : true,
     *              text    : true
     *          };
     *      }
     *  }
     * ```
     * @member {Object|String[]} renderConfigs
     * @static
     * @category Configuration
     * @internal
     */
    'renderConfigs'];
  }
  /**
   * An object providing the `record` and `column` for a widget embedded inside a {@link Grid.column.WidgetColumn}
   *
   * ```javascript
   * columns : [
   *    {
   *        type   : 'widget',
   *        widgets: [{
   *            type     : 'button',
   *            icon     : 'b-fa b-fa-trash',
   *            onAction : ({ source : btn }) => btn.cellInfo.record.remove()
   *        }]
   *    }
   * ]
   * ```
   * @readonly
   * @member {Object} cellInfo
   * @property {Core.data.Model} cellInfo.record
   * @property {Grid.column.Column} cellInfo.column
   * @category Misc
   */


  static get delayable() {
    return {
      recompose: 'raf',
      doHideOrRealign: 'raf'
    };
  }

  static get factoryable() {
    return {
      defaultType: 'widget'
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * Returns an array containing all existing Widgets. The returned array is generated by this call and is not an
   * internal structure.
   * @property {Core.widget.Widget[]}
   * @readonly
   * @internal
   */


  static get all() {
    return super.all;
  }
  /**
   * Get/set the {@link #config-recomposeAsync} config for all widgets. Setting this value will set the config for
   * all existing widgets and will be the default value for newly created widgets. Set this value to `null` to disable
   * the default setting for new widgets while leaving existing widgets unaffected.
   * @property {Boolean}
   * @internal
   */


  static get recomposeAsync() {
    return Widget._recomposeAsync;
  }

  static set recomposeAsync(value) {
    Widget._recomposeAsync = value;

    if (value != null) {
      const {
        all
      } = Widget;

      for (let i = 0; i < all.length; ++i) {
        if (all[i].isComposable) {
          all[i].recomposeAsync = value;
        }
      }
    }
  }

  isType(type, deep) {
    return Widget.isType(this, type, deep);
  }

  static setupRenderConfigs(cls, meta) {
    let {
      renderConfigs
    } = cls,
        i;

    if (renderConfigs) {
      const obj = // Once a class declares renderConfigs, those are inherited and augmented:
      meta.getInherited('renderConfigs',
      /* create = */
      false) || // Otherwise, since renderConfigs are declared on this class, we need to create them:
      Object.create(null);

      if (Array.isArray(renderConfigs)) {
        // Ex: renderConfigs: ['cls', 'text']
        for (i = 0; i < renderConfigs.length; ++i) {
          obj[renderConfigs[i]] = true;
        }

        renderConfigs = obj;
      } else {
        // Ex: renderConfigs: { cls : true, text : true }
        renderConfigs = Object.assign(obj, renderConfigs);
      }
    } // else a class may declare renderConfigs=null to re-enable auto detection


    meta.renderConfigs = renderConfigs;
  }
  /**
   * Call once per class for custom widgets to have them register with the `Widget` class, allowing them to be created
   * by type.
   *
   * For example:
   * ```javascript
   * class MyWidget extends Widget {
   *   static get type() {
   *     return 'mywidget';
   *   }
   * }
   * MyWidget.initClass();
   * ```
   * @method initClass
   * @static
   * @category Lifecycle
   */
  //endregion
  //region Init & destroy


  construct(config = {}, ...args) {
    const me = this,
          {
      domSyncCallback
    } = me;
    me._isAnimatingCounter = 0; // Flag so we know when our dimensions have been constrained during alignment

    me.alignConstrained = 0;
    me.byRef = Object.create(null);
    me.callRealign = me.realign.bind(me);
    me.onFullscreenChange = me.onFullscreenChange.bind(me);
    me.domSyncCallback = domSyncCallback.$nullFn ? null : domSyncCallback.bind(me);
    me._isUserAction = false; // Base class applies configs.

    super.construct(config, ...args);
    const {
      recomposeAsync
    } = Widget;

    if (recomposeAsync != null && me.recomposeAsync == null) {
      me.recomposeAsync = recomposeAsync;
    }

    me.finalizeInit();
  }

  startConfigure(config) {
    const me = this,
          // This will run the element change/update process if it was not kicked off by a derived class impl of
    // this method:
    {
      adopt,
      element
    } = me;

    if (adopt) {
      // Adopt the preexisting element as our element before configuration proceeds.
      me.adoptElement(element, adopt, config.id);
      me.updateElement(me._element, element);
    }

    super.startConfigure(config);
  }
  /**
   * Called by the Base constructor after all configs have been applied.
   * @internal
   * @category Lifecycle
   */


  finalizeInit() {
    if (this.insertBefore || this.appendTo || this.insertFirst || this.adopt) {
      this.render();
    }
  }

  doDestroy() {
    const me = this,
          {
      preExistingElements,
      element,
      _refListeners
    } = me;

    if (_refListeners) {
      Object.values(_refListeners, un => un());
      me._refListeners = null;
    }

    if (element) {
      var _Widget$Tooltip, _me$dragEventDetacher, _me$dragOverEventDeta;

      const sharedTooltip = !me._tooltip && me._rootElement && ((_Widget$Tooltip = Widget.Tooltip) === null || _Widget$Tooltip === void 0 ? void 0 : _Widget$Tooltip.getSharedTooltip(me._rootElement, true)); // If we are current user of the shared tooltip, hide it

      if ((sharedTooltip === null || sharedTooltip === void 0 ? void 0 : sharedTooltip.owner) === me) {
        sharedTooltip.owner = null;
        sharedTooltip.hide();
      }

      me.onExitFullscreen(); // If we get destroyed very quickly after a call to show,
      // we must kill the timers which add the realign listeners.

      me.clearTimeout(me.scrollListenerTimeout);
      me.clearTimeout(me.resizeListenerTimeout); // Remove listeners which are only added during the visible phase.
      // In its own method because it's called on hide and destroy.

      me.removeTransientListeners();

      if (me.floating || me.positioned) {
        // Hide without animation, destruction is sync
        me.hide(false);
      } else {
        me.revertFocus();
      }

      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element.parentElement, me.onParentElementResize);
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element, me.onElementResize); // Remove elements *which we own* on destroy,

      if (me.adopt) {
        for (let nodes = Array.from(element.childNodes), i = 0, {
          length
        } = nodes; i < length; i++) {
          const el = nodes[i]; // If it's not preexisting, and not the floatRoot, remove it

          if (!preExistingElements.includes(el) && el !== me.floatRoot) {
            el.remove();
          }
        }

        element.className = me.adoptedElementClassName;
        element.style.cssText = me.adoptedElementCssText;
      } else {
        element.remove();
      }

      (_me$dragEventDetacher = me.dragEventDetacher) === null || _me$dragEventDetacher === void 0 ? void 0 : _me$dragEventDetacher.call(me);
      (_me$dragOverEventDeta = me.dragOverEventDetacher) === null || _me$dragOverEventDeta === void 0 ? void 0 : _me$dragOverEventDeta.call(me);
      me.dragGhost.remove();
    }

    super.doDestroy();
  } //endregion
  //---------------------------------------------------------------------------------------------------------
  //region Render

  /**
   * Returns `true` if this class uses `compose()` to render itself.
   * @returns {Boolean}
   * @internal
   */


  get isComposable() {
    return !this.compose.$nullFn;
  }

  adoptElement(element, adopt, id) {
    const me = this,
          adoptElement = typeof adopt === 'string' ? document.getElementById(adopt) : adopt,
          previousHolder = Widget.fromElement(adoptElement); // If we are taking it over from a previous iteration, destroy the previous holder. This is not officially
    // supported, but CodeEditor relies on it working

    if (previousHolder && previousHolder.adopt && previousHolder !== me) {
      const previousHolderAdopt = typeof previousHolder.adopt === 'string' ? document.getElementById(previousHolder.adopt) : previousHolder.adopt;

      if (previousHolderAdopt === adoptElement) {
        previousHolder.destroy();
      }
    } // On destroy, leave these


    me.preExistingElements = Array.from(adoptElement.childNodes);
    me.adoptedElementClassName = adoptElement.className;
    me.adoptedElementCssText = adoptElement.style.cssText; // Adopt the host element's id if we don't have one so that we do not override
    // it and invalidate any ad-based CSS rules.

    if (adoptElement.id && !id) {
      me.id = element.id = adoptElement.id;
    }

    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncAttributes(element, adoptElement);

    for (let i = 0, {
      length
    } = element.childNodes; i < length; i++) {
      adoptElement.appendChild(element.childNodes[0]);
    }

    delete me._contentRange; // Silently update our element config (do not re-run change/update cycle):

    me._element = adoptElement;
    const domConfig = element.lastDomConfig,
          listeners = domConfig === null || domConfig === void 0 ? void 0 : domConfig.listeners;

    if (listeners && me.isComposable) {
      var _listeners$un;

      (_listeners$un = listeners.un) === null || _listeners$un === void 0 ? void 0 : _listeners$un.call(listeners);
      addElementListeners(me, adoptElement, domConfig);
    } // Maintain DomSync internal state from our original element:


    adoptElement.lastDomConfig = domConfig || adoptElement.lastDomConfig;
    adoptElement.$refOwnerId = me.id;

    if (!me.scaleToFitWidth) {
      me.getConfig('monitorResize');
    }
  }
  /**
   * Defines an element reference accessor on the class prototype. This accessor is used to flush any pending DOM
   * changes prior to accessing such elements.
   * @param {String} name
   * @param {String} key
   * @private
   */


  addRefAccessor(name, key) {
    const {
      prototype
    } = this.constructor;
    defineProperty(prototype, key, {
      writable: true,
      value: null
    });
    defineProperty(prototype, name, {
      get() {
        // Asking for a ref el is a good sign that we need to sync the DOM:
        this.recompose.flush();
        return this[key];
      },

      set(el) {
        this[key] = el;
      }

    });
  }
  /**
   * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} [domConfig] The DOM config object.
   * @internal
   */


  attachRef(name, el, domConfig) {
    const me = this,
          key = '_' + name; // Key elements contain owner pointer if data is supported (Not on IE SVG).

    el.dataset && (el.dataset.ownerCmp = me.id);

    if (me.isComposable) {
      if (!(key in me)) {
        me.addRefAccessor(name, key);
      }

      addElementListeners(me, el, domConfig, name);
    }

    me.byRef[name] = el;
    me[name] = el;
  }
  /**
   * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @internal
   */


  detachRef(name, el, domConfig) {
    const me = this,
          listeners = me._refListeners;

    if (listeners !== null && listeners !== void 0 && listeners[name]) {
      listeners[name]();
      delete listeners[name];
    }

    me[name] = null;
    delete me.byRef[name];
  }
  /**
   * This method is called following an update to the widget's rendered DOM.
   * @internal
   */


  afterRecompose() {// empty
  }
  /**
   * Returns a {@link Core.helper.DomHelper#function-createElement-static} config object that defines this widget's
   * DOM structure. This object should be determined using {@link Core.Base#property-configurable-static} properties
   * to ensure this method is called again if these properties are modified.
   *
   * For more information see {@link Core.widget.Widget class documentation}.
   * @returns {Object}
   */


  compose() {
    const classes = _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalize(this.widgetClassList, 'object');
    return {
      class: classes
    };
  }
  /**
   * This method iterates the class hierarchy from Widget down to the class of this instance and calls any `compose`
   * methods implemented by derived classes.
   * @returns {Object}
   * @private
   */


  doCompose() {
    const me = this,
          {
      $meta: meta
    } = me,
          classes = meta.hierarchy;
    let {
      composers
    } = meta,
        domConfig = null,
        c,
        key,
        firstTime,
        i,
        proto,
        renderConfigs;
    me.recompose.suspend();

    if (!composers) {
      firstTime = true;
      meta.composers = composers = []; // Widget starts the process w/the widgetClassList

      for (i = classes.indexOf(Widget); i < classes.length; ++i) {
        proto = classes[i].prototype;

        if (hasOwnProperty.call(proto, 'compose')) {
          composers.push(proto);
        }
      } // See if the class (or a super class) has declared its `renderConfigs`. If so, we use them.


      if (!(renderConfigs = meta.getInherited('renderConfigs',
      /* create = */
      false))) {
        // If not, we create a Proxy or proxy-like object that can detect getter calls to determine them. While
        // technically the getters may not all trigger on any given rendering, we ignore this due to the high
        // cost of supporting such arbitrary compose() methods. By convention, compose() must read configs
        // consistently.
        renderConfigs = Object.create(null); // On the first composition for this class, watch the config properties that are read to auto populate
        // the renderConfigs:

        me.configObserver = {
          get(name) {
            renderConfigs[name] = true;
          }

        };
      }

      meta.$renderConfigs = renderConfigs;
    } // This loop always runs at least once due to Widget base class, so ret will be assigned here:


    for (i = 0; i < composers.length; ++i) {
      c = composers[i].compose.call(me, domConfig);
      domConfig = domConfig ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(domConfig, c) : c;
    }

    if (hasOwnProperty.call(me, 'compose') && (c = me.compose)) {
      c = c.call(me, domConfig);
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(domConfig, c);
    }

    firstTime && delete me.configObserver; // When converting a children:{} into an array, we take a moment to ensure we have an accessor defined for
    // the element. This is needed if the element is initially unrendered since we need the accessor to flush a
    // pending recompose through just in time via the reference element getter.

    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].normalizeChildren(domConfig, (childName, hoist) => {
      // Only care about refs that should be hoisted up to us
      if (hoist) {
        key = '_' + childName;

        if (!(key in me)) {
          me.addRefAccessor(childName, key);
        }
      }
    });
  }

  get element() {
    // NOTE: We can replace the getter of a config property
    if (this.isComposable && !this.isDestroying) {
      // Asking for the primary el is a good sign that we need to sync the DOM:
      this.recompose.flush();
    }

    return this._element;
  }
  /**
   * Template method called during DOM updates. See {@link Core.helper.DomSync#function-sync-static DomSync.sync()}.
   * @param {Object} info Properties describing the sync action taken.
   * @internal
   */


  domSyncCallback(info) {// bound in construct. Override in subclass
  }

  changeElement(element) {
    const me = this,
          compose = me.isComposable;

    if (compose) {
      element = me.doCompose();
    }

    if (typeof element === 'string') {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(element);
    } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isObject(element)) {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement(element, {
        refOwner: me,
        callback: me.domSyncCallback // mimic DomSync callbacks (needed by TaskBoard)

      });
      me.recompose.resume();
      compose && addElementListeners(me, element, element.lastDomConfig);
    } else if (element.nodeType !== 1) {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(me.template(me));
    }

    element.id = me.id;

    if (me.elementAttributes) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setAttributes(element, me.elementAttributes);
    }

    return element;
  }

  updateElement(element) {
    const me = this,
          {
      className
    } = element,
          {
      contentElement,
      contentElementCls,
      isComposable
    } = me,
          hasChildContent = contentElement !== element,
          namedElements = !isComposable && element.querySelectorAll('[data-reference]'),
          // Start with the hierarchy classes, eg ['b-combo b-pickerfield b-textfield b-widget']
    classes = isComposable ? [] : me.widgetClassList; // a dynamic array that we can safely modify
    // The ui classes need to put on the content element even if isComposable, but widgetClassList contains the
    // ui classes, so we don't need to do that if the main element is the contentElement

    let uiClasses = (hasChildContent || !isComposable) && me.uiClasses;
    className && classes.unshift(className);
    me._hidden && classes.push('b-hidden');
    me._readOnly && classes.push('b-readonly'); // Calling element.remove() when we have the focus can result in a DOMException (notably when a blur/focusout
    // handler reentrancy results in a remove):
    //  DOMException: Failed to execute 'remove' on 'Element': The node to be removed is no longer a child
    //  of this node. Perhaps it was moved in a 'blur' event handler?

    _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].noThrow(element, 'remove'
    /*, () => { debugger; } /**/
    ); // delete "/*" to break on exception

    if (uiClasses) {
      if (contentElementCls !== null && contentElementCls !== void 0 && contentElementCls.value) {
        uiClasses = uiClasses.slice(); // clone cached array

        uiClasses.push(contentElementCls.value);
      }

      uiClasses = uiClasses.join(' ');
    } else {
      uiClasses = contentElementCls === null || contentElementCls === void 0 ? void 0 : contentElementCls.value;
    }

    if (uiClasses) {
      if (hasChildContent) {
        contentElement.className += ' ' + uiClasses;
      } else {
        classes.push(uiClasses);
      }
    } // The environmental classes only need to be added to outermost Widgets.
    // If we have a parent container, that will have them.


    if (!me.parent) {
      const {
        defaultCls
      } = me,
            {
        outerCls
      } = Widget;
      classes.push(...(defaultCls ? outerCls.filter(c => !(c in defaultCls) || defaultCls[c]) : outerCls));
    }

    element.className = classes.join(' ');

    if (namedElements) {
      for (let el, i = 0; i < namedElements.length; ++i) {
        el = namedElements[i];
        me.attachRef(el.getAttribute('data-reference'), el);
        el.removeAttribute('data-reference');
      }
    } // Mutually exclusive with scaleToFitWidth.
    // Observe container element before the cascade down to descendants.
    // Outer elements are expected to fire resize first.
    // It's a lazy config, so this is the time to flush it through to begin monitoring.


    if (!me.adopt && !me.scaleToFitWidth) {
      me.getConfig('monitorResize');
    } // Ensure our content mutation observer keeps us informed of changes by third parties
    // so that our config system can keep up to date.


    if (me._html) {
      me.getConfig('htmlMutationObserver');
    }
  }

  isCollapsified(collapsed, overlay) {
    const {
      collapsify
    } = this; // false => widget is unaffected when the panel is collapsed (always in main header)
    // 'hide' => widget is hidden when the panel is collapsed (but still in main header)

    let ret = !overlay;

    if (collapsify == null) {
      // widget is moved to the overlay when collapsed
      ret = overlay ? collapsed : !collapsed;
    } else if (collapsify === 'overlay') {
      // widget always appears in the overlay
      ret = overlay;
    }

    return Boolean(ret);
  }
  /**
   * Calling this {@link Core.mixin.Delayable#property-delayable-static} method marks this widget as dirty. The DOM
   * will be updated on the next animation frame:
   *
   * ```javascript
   *  widget.recompose();
   *
   *  console.log(widget.recompose.isPending);
   *  > true
   * ```
   *
   * A pending update can be flushed by calling `flush()` (this does nothing if no update is pending):
   *
   * ```javascript
   *  widget.recompose.flush();
   * ```
   *
   * This can be combined in one call to force a DOM update without first scheduling one:
   *
   * ```javascript
   *  widget.recompose.now();
   * ```
   */


  async recompose() {
    const me = this,
          options = {
      targetElement: me.element,
      domConfig: me.doCompose(),
      refOwner: me,
      callback: me.domSyncCallback,
      // This limits the sync() to only removing the classes and styles added by previous renderings. This
      // allows dynamically added styles and classes to be preserved:
      strict: true
    };

    if (me.transitionRecompose) {
      me.isTransitioningDom = true;
      await _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].transition(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
        element: me.element,

        action() {
          _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync(options);
        }

      }, me.transitionRecompose));

      if (me.isDestroyed) {
        return;
      }

      me.isTransitioningDom = false;
      me.trigger('transitionedRecompose');
    } else {
      _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync(options);
    }

    if (options.changed) {
      me.afterRecompose();
    }

    me.recompose.resume();
  }

  render(parentElement = this.appendTo, triggerPaint = true) {
    const me = this,
          {
      element
    } = me;
    me.emptyCache();

    if (me.syncElement && me.currentElement) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync(element, me.currentElement);
    } else {
      var _parentElement;

      let insertBefore = me.insertBefore;

      if (me.insertFirst) {
        parentElement = me.insertFirst;
        insertBefore = parentElement.firstChild;
      }

      if (typeof parentElement === 'string') {
        const id = parentElement;
        parentElement = document.getElementById(parentElement);

        if (!parentElement) {
          throw new Error(`No element found with id '${id}'`);
        }

        if (me.insertFirst) {
          insertBefore = parentElement.firstChild;
        }
      }

      if (insertBefore) {
        if (typeof insertBefore === 'string') {
          const id = insertBefore;
          insertBefore = document.getElementById(insertBefore);

          if (!insertBefore) {
            throw new Error(`No element found with id '${id}'`);
          }
        }

        if (!parentElement) {
          parentElement = insertBefore.parentElement;
        }
      }

      (_parentElement = parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.insertBefore(element, insertBefore);
      me.currentElement = element;
    } // The environmental classes only need to be added to a naked Widget.
    // If we are inside a Widget's element, that will have them.


    if (Widget.fromElement(element.parentElement)) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(element, Widget.outerCls);
    }

    me.rendered = true;

    if (triggerPaint) {
      me.getConfig('contentRange');
      me.triggerPaint();
    }

    me.setupFocusListeners();
  }
  /**
   * A function which, when passed an instance of this Widget, produces a valid HTML string which is compiled
   * to create the encapsulating element for this Widget, and its own internal DOM structure.
   *
   * Note that this just creates the DOM structure that *this* Widget owns. If it contains child widgets
   * (Such as for example a grid), this is not included. The template creates own structure.
   *
   * Certain elements within the generated element can be identified as special elements with a `reference="name"`
   * property. These will be extracted from the element upon creation and injected as the named property into
   * the Widget. For example, a {@link Core.widget.TextField} will have an `input` property which is its
   * `<input>` element.
   * @param {Core.widget.Widget} me The widget for which to produce the initial HTML structure.
   * @internal
   */


  template({
    tag,
    html,
    htmlCls,
    name
  }) {
    const content = html !== null && html !== void 0 && html.call ? html.call(this) : html;
    return `<${tag} class="${content ? htmlCls : ''}" ${name ? `data-name="${name}"` : ''}>${content || ''}</${tag}>`;
  }

  updateRecomposeAsync(async) {
    this.recompose.immediate = !async;
  } //endregion
  //---------------------------------------------------------------------------------------------------------


  onConfigChange({
    name
  }) {
    var _this$$meta$$renderCo;

    // The $renderConfigs object is either on our prototype (due to renderConfigs getter) or on our instance (due
    // to "get composer") unless we are not using compose(), in which case it will be null:
    if (this._element && !this.isDestroying && (_this$$meta$$renderCo = this.$meta.$renderConfigs) !== null && _this$$meta$$renderCo !== void 0 && _this$$meta$$renderCo[name]) {
      this.recompose();
    }
  }
  /**
   * Get widgets elements dataset or assign to it
   * @property {Object}
   * @category DOM
   */


  get dataset() {
    return this.element.dataset;
  }

  changeDataset(dataset) {
    Object.assign(this.dataset, dataset);
  }

  get dragGhost() {
    return this.constructor._dragGhost || (this.constructor._dragGhost = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
      // Safari won't allow dragging an empty node
      html: '\xa0',
      style: 'position:absolute;top:-10000em;left:-10000em'
    }));
  }

  updateParent(parent) {
    const {
      _element: element
    } = this;

    if (element) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"][parent ? 'removeClasses' : 'addClasses'](element, Widget.outerCls);
    }
  }

  get constrainTo() {
    const ret = this._constrainTo;
    return ret === undefined ? window : ret;
  }

  updateCentered(value) {
    const {
      element,
      _anchorElement
    } = this;

    if (value && !this.floating && !this.positioned) {
      throw new Error('`centered` is only relevant when a Widget is `floating` or `positioned`');
    }

    if (value) {
      element.classList.add('b-centered');
      element.style.transform = element.style.left = element.style.top = '';
      _anchorElement === null || _anchorElement === void 0 ? void 0 : _anchorElement.classList.add('b-hide-display');
      element.classList.remove('b-anchored');
    } else {
      element.classList.remove('b-centered');
    }
  }
  /**
   * The child element into which content should be placed. This means where {@link #config-html} should be put,
   * or, for {@link Core.widget.Container Container}s, where child items should be rendered.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get contentElement() {
    return this.element;
  }

  get contentRange() {
    const me = this,
          {
      contentElement
    } = me,
          contentRange = me._contentRange || (me._contentRange = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 ? document.createRange() : new Range()); // Initialize the contentRange if it's collapsed.
    // It gets collapsed if the widget's element is removed from the DOM.

    if (contentRange.collapsed) {
      contentRange.setStart(contentElement, me.contentRangeStartOffset || 0);
      contentRange.setEnd(contentElement, me.contentRangeEndOffset || contentElement.childNodes.length);
    }

    return contentRange;
  }
  /**
   * This method fixes the element's `$refOwnerId` when this instance's `id` is changing.
   * @param {Node} el The element or DOM node to fix.
   * @param {String} id The new id being assigned.
   * @param {String} oldId The old id (previously assigned).
   * @private
   */


  fixRefOwnerId(el, id, oldId) {
    if (el.$refOwnerId === oldId) {
      el.$refOwnerId = id;

      for (let {
        childNodes
      } = el, i = childNodes.length; i-- > 0;) {
        this.fixRefOwnerId(childNodes[i], id, oldId);
      }
    }
  }

  get placement() {
    const me = this,
          {
      element
    } = me;
    let adjRect, placement, rect;

    if (element !== null && element !== void 0 && element.offsetParent && !nonFlowedPositions.test(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position'))) {
      const next = element.nextElementSibling,
            previous = element.previousElementSibling,
            last = !next && previous;
      placement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element.parentElement, 'flex-direction'); // If used in a flex layout, determine orientation from flex-direction

      if (placement) {
        placement = placement.startsWith('row') ? 'h' : 'v';
      } else {
        var _ref;

        adjRect = (_ref = next || previous) === null || _ref === void 0 ? void 0 : _ref.getBoundingClientRect();
        rect = adjRect && element.getBoundingClientRect();
        placement = adjRect && Math.abs(adjRect.top - rect.top) < Math.abs(adjRect.left - rect.left) ? 'h' : 'v'; // if there is another item, check for more horz delta than vert and if so, call it a horz container
      }

      placement += placement === 'h' ? last ? 'r' : 'l' : last ? 'b' : 't';
    }

    return placement;
  }

  updateId(id, oldId) {
    super.updateId(id, oldId);

    if (oldId) {
      // NOTE this happens when we adopt an element w/an assigned id...
      const {
        byRef,
        element
      } = this;

      for (const ref in byRef) {
        byRef[ref].dataset && (byRef[ref].dataset.ownerCmp = id); // SVG elements have no dataset
      }

      element.id = id;
      this.fixRefOwnerId(element, id, oldId);
    }
  }
  /**
   * Get/set widgets elements style. The setter accepts a cssText string or a style config object, the getter always
   * returns a CSSStyleDeclaration
   * @property {CSSStyleDeclaration}
   * @accepts {String|Object|CSSStyleDeclaration}
   * @category DOM
   */


  get style() {
    const {
      element
    } = this;
    return (element === null || element === void 0 ? void 0 : element.ownerDocument.defaultView.getComputedStyle(element)) || this._style;
  }

  updateStyle(style) {
    this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].applyStyle(this.element, style);
  }

  updateTitle(title) {
    if (this.titleElement) {
      this.titleElement.innerHTML = title;
    }
  } //region floating

  /**
   * If this Widget is {@link #config-floating} or {@link #config-positioned}, and visible,
   * aligns the widget according to the passed specification. To stop aligning, call this method without arguments.
   * For details, see the {@link #function-showBy} method.
   * @param {Object} [spec] Alignment options. May be an object as processed by the {@link #function-showBy} method,
   * or an `HTMLElement` to align to using this Widget's {@link #config-align} configuration.
   * @category Float & align
   */


  alignTo(spec) {
    var _anchor;

    const me = this,
          {
      lastAlignSpec,
      element
    } = me,
          {
      offsetParent,
      style,
      classList
    } = element;

    if (lastAlignSpec) {
      // Remove intersection observation from our previous align target element.
      lastAlignSpec.monitorIntersection && me.intersectionObserver.unobserve(lastAlignSpec.target); // Ensure marker class of previous alignment side is removed.

      if (isFinite(lastAlignSpec.zone)) {
        element.classList.remove(alignedClass[lastAlignSpec.zone]);
      }
    }

    if (!spec) {
      me.removeTransientListeners();
      me.anchor = me.lastAlignSpec = null;
      return;
    } // You can "alignTo" an element or a Widget or a Point, and allow our align config.
    // property to specify how.


    if (spec.nodeType === Element.ELEMENT_NODE || spec instanceof Widget || spec.$$name === 'Point') {
      spec = {
        target: spec
      };
    } // Release size constraints so we can align from scratch each time.


    me.releaseSizeConstraints();
    const {
      scrollable,
      constrainTo
    } = me,
          positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') !== 'fixed',
          scale = me.scale || 1,
          passedTarget = spec.target,
          target = passedTarget && (passedTarget.isRectangle ? passedTarget : passedTarget.element || passedTarget),
          myPosition = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? offsetParent : null, true),
          {
      width: startWidth,
      height: startHeight
    } = myPosition,
          aligningToElement = target && target.nodeType === Element.ELEMENT_NODE;
    spec = spec.realignTarget ? spec : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
      aligningToElement,
      constrainTo,
      align: 'b-t',
      // we can end up w/o a value for this if an object replaces a string
      axisLock: me.axisLock,
      anchor: me.anchor
    }, me.align, spec); // As part of fallback process when fitting within constraints, this may shrink to minima specified
    // either on the align spec or the widget itself.

    const minWidth = spec.minWidth || me.minWidth,
          minHeight = spec.minHeight || me.minHeight; // Minima have a different meaning in an alignRectangle.
    // It means that the rectangle is willing to shrink down
    // to that size during constraint, *not* that it can never
    // be smaller than that size.

    myPosition.isAlignRectangle = true;
    minWidth && (myPosition.minWidth = minWidth * scale);
    minHeight && (myPosition.minHeight = minHeight * scale); // This is used by the realign call which may be called either when a global scroll is detected
    // or the constraining element is resized.

    me.lastAlignSpec = spec;

    if (aligningToElement && Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(target.offsetParent)) {
      // Don't destroy the spec which was cached above with the element in it.
      spec = Object.setPrototypeOf({}, spec); // If we are being called from realign, there will be a realignTarget present which is
      // a viewport-based *visible* rectangle. Otherwise translate the element into a browser
      // viewport based Rectangle. Rectangle doesn't have the knowledge that we do to make this
      // decision. Floating alignment all takes place within browser viewport space, not document
      // space.

      spec.target = spec.realignTarget || _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target, positioned ? offsetParent : null, !positioned); // Force the target to have an area so that intersect works.

      spec.target.height = Math.max(spec.target.height, 1);
      spec.target.width = Math.max(spec.target.width, 1); // This is the element which determines our position.
      // This is used in doHideOrRealign to see if a scroll event
      // will have affected our position.

      me.anchoredTo = target;
    } else {
      me.anchoredTo = null;
    }

    if (spec.anchor) {
      spec.anchorSize = me.anchorSize;

      if (!element.contains(me.anchorPathElement)) {
        element.appendChild(me.anchorElement);
      }
    } // If we're positioned, any constrainTo must be a Rectangle in our offsetParent's coordinate space


    if (positioned) {
      // We can't be seen outside our offsetParent, so that's the de-facto costrainTo
      // regardless of what is passed.
      if (offsetParent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(offsetParent, 'overflow') === 'hidden') {
        spec.constrainTo = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(offsetParent).moveTo(0, 0);
      } else if (constrainTo && !constrainTo.isRectangle) {
        const isViewport = constrainTo === document || constrainTo === window;
        spec.constrainTo = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(spec.constrainTo, offsetParent);

        if (isViewport) {
          spec.constrainTo.translate(window.pageXOffset, window.pageYOffset);
        }
      }
    } // Flag to prevent infinite loop when setting html from a beforeAlign listener


    me.isAligning = true; // Allow outside world to modify the suggested position

    me.trigger('beforeAlign', spec);
    me.isAligning = false; // Calculate the best position WRT target rectangle, our rectangle, a constrainTo rectangle
    // and the rectangle of an anchor pointer.

    const result = myPosition.alignTo(spec); // May change if constraint changes our shape, and we have to go round again

    let {
      align,
      anchor,
      x,
      y,
      width,
      height,
      overlap
    } = result; // Which zone, T=0, R=1, B=2, L=3 the result is in

    me.lastAlignSpec.zone = result.zone; // If the alignment specified that we must constrain a dimension in order to
    // fit within our constrainTo, then obey that. If we own a Scroller, then
    // inform it that we do now need to scroll that dimension.
    // These conditions are released upon each alignment call because conditions may change.

    if (height != startHeight) {
      if (!('configuredHeight' in me)) {
        me.configuredHeight = style.height;
      }

      me.height = height / scale;
      me.alignConstrained = me.alignConstrained | 1;

      if (scrollable) {
        scrollable.overflowY = true;
      }
    }

    if (width != startWidth) {
      if (!('configuredWidth' in me)) {
        me.configuredWidth = style.width;
      }

      me.width = width / scale;
      me.alignConstrained = me.alignConstrained | 2;

      if (scrollable) {
        scrollable.overflowX = scrollable.clientWidth > scrollable.scrollWidth;
      }
    } // If either dimension has been constrained, we may have changed shape
    // due to text wrapping/overflowing, so we have to realign at the
    // successful align setting.


    if (align && me.alignConstrained) {
      spec.align = align;
      const newResult = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? offsetParent : null, true).alignTo(spec);
      anchor = newResult.anchor;
      x = newResult.x;
      y = newResult.y;
      width = newResult.width;
      height = newResult.height;
    }

    me.setXY(x, y); // Class indicates which edge of the target this is aligned to: 0, 1, 2, or 3 (TRBL)

    if (!result.overlap && isFinite(result.zone)) {
      classList.add(alignedClass[result.zone]);
    } // If we asked it to also calculate our anchor position, position our anchor.
    // If we're not edge-to-edge aligned with our target, we cannot anchor.


    if ((_anchor = anchor) !== null && _anchor !== void 0 && _anchor.edge) {
      const {
        edge
      } = anchor,
            {
        anchorElement
      } = me,
            elRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element),
            colorMatchPoint = []; // Make the anchor color match the color of the closest adjacent element

      if (edge === 'top' || edge === 'bottom') {
        colorMatchPoint[0] = anchor.x;
        colorMatchPoint[1] = edge === 'top' ? 1 : elRect.height - 1;
      } else {
        colorMatchPoint[0] = edge === 'left' ? 1 : elRect.width - 1;
        colorMatchPoint[1] = anchor.y;
      }

      let colourSource = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].childFromPoint(element, ...colorMatchPoint);

      if (colourSource) {
        let fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'background-color');

        while (fillColour.match(isTransparent) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'position') !== 'absolute') {
          colourSource = colourSource.parentNode;
          fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'background-color');
        }

        if (fillColour.match(isTransparent)) {
          me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
        } else {
          me.anchorPathElement.setAttribute('fill', fillColour);
        }
      }

      anchorElement.classList.remove('b-hide-display');
      anchorElement.style.transform = '';
      anchorElement.className = `b-anchor b-anchor-${edge}`; // Anchor's position needs boosting if we are scaled down

      anchor.x && (anchor.x /= scale);
      anchor.y && (anchor.y /= scale);
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(anchorElement, anchor.x, anchor.y);
      classList.add('b-anchored');
    } else if (me._anchorElement) {
      me.anchorElement.classList.add('b-hide-display');
      classList.remove('b-anchored');
    } // If we are to hide on scroll, we still need to know if the element we are
    // aligned to moves. If we have not been *explicitly* aligned to an element,
    // Use the element at our display position. For example, when a context menu
    // is shown on a grid header, then is the grid header is moved by a scroll
    // event, then we must hide.


    if (me.scrollAction === 'hide' && !aligningToElement) {
      // Our element is over the X, Y point now,
      // elementFromPoint must "see through" it.
      style.pointerEvents = 'none';
      const el = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].elementFromPoint(x, y); // If we own the element at the point, it means we are already visible
      // and have visible descendants, so we must not update the anchoredTo

      if (!me.owns(el)) {
        me.anchoredTo = el;
      }

      style.pointerEvents = '';
    } // If we're aligning to an element, then listen for scrolls so that we can remain aligned.
    // Scrolls can be instigated with no mousedown, so transient floating Widgets can be put
    // out of alignment by scrolls.


    if ((me.scrollAction === 'realign' && aligningToElement || me.scrollAction === 'hide') && !me.documentScrollListener) {
      // Firefox requires a longer timeout to not autohide as the result of a scroll event firing during Menu show
      me.clearTimeout(me.scrollListenerTimeout);
      me.scrollListenerTimeout = me.setTimeout(() => {
        var _target$getRootNode;

        const targetRoot = target === null || target === void 0 ? void 0 : (_target$getRootNode = target.getRootNode) === null || _target$getRootNode === void 0 ? void 0 : _target$getRootNode.call(target); // Realign if the main document detects a scroll.
        // On raf to avoid scroll syncing other elements causing multiple realigns (grids body and header etc)

        me.documentScrollListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(document, 'scroll', 'doHideOrRealign', {
          capture: true,
          thisObj: me
        }); // In case the align target is in a WC, also capture scrolls scoped with in its shadow root

        if (targetRoot && targetRoot !== document) {
          me.targetRootScrollListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(targetRoot, 'scroll', 'doHideOrRealign', {
            capture: true,
            thisObj: me
          });
        }
      }, me.scrollAction === 'hide' ? me.ignoreScrollDuration : 0);
    } // If alignment specified monitorResize add a resize listener to the target so we can stay aligned.


    if (aligningToElement) {
      if (spec.monitorResize && !me.targetResizeListener) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(target, me.callRealign);
        me.targetResizeListener = true;
      } // If configured to monitor intersection, and we are not potentially obscuring
      // it ourselves, and it's not an SVG element, observe its intersection changes.
      // Bug with IntersectionObserver and SVG elements, so omit them:
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1159196


      if (spec.monitorIntersection && !(overlap || target.contains(element) || target.ownerSVGElement)) {
        me.intersectionObserver.observe(target);
      }
    } // Don't try to listen for window resizes to try realigning on Android.
    // That just means the keyboard has been shown.


    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAndroid) {
      if (!me.constrainListeners && !(constrainTo instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
        // Always observe for changes to window size since aligned things
        // will possibly be out of place after a window resize
        me.clearTimeout(me.resizeListenerTimeout);
        me.resizeListenerTimeout = me.setTimeout(() => {
          me.constrainListeners = true;
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(constrainTo || window, me.callRealign);
        }, me.ignoreScrollDuration);
      }
    }
  }

  get intersectionObserver() {
    return this._intersectionObserver || (this._intersectionObserver = new IntersectionObserver(this.onTargetIntersectionchange.bind(this), {
      root: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari ? this.rootElement : this.rootElement.ownerDocument
    }));
  }

  onTargetIntersectionchange(entries) {
    if (!this.isDestroyed) {
      // It may go through several states. Only interrogate the latest.
      const e = entries[entries.length - 1];

      if (!e.isIntersecting) {
        this.onAlignTargetOutOfView(e.target);
      }
    }
  }
  /**
   * This method is called when the {@link #function-alignTo} target element loses intersection with the
   * visible viewport. That means it has been scrolled out of view, or becomes zero size, or hidden or
   * is removed from the DOM.
   *
   * The base class implementation hides by default.
   * @param {HTMLElement} target The alignTo target that is no longer in view.
   * @internal
   */


  onAlignTargetOutOfView(target) {
    this.hide();
    this.lastAlignSpec && (this.lastAlignSpec.targetOutOfView = true);
  }
  /**
   * Called when an element which affects the position of this Widget's
   * {@link #function-alignTo align target} scrolls so that this can realign.
   *
   * If the target has scrolled out of view, then this Widget is hidden.
   * @internal
   */


  realign() {
    const me = this,
          {
      lastAlignSpec
    } = me;

    if (me.isVisible && (me.floating || me.positioned) && lastAlignSpec) {
      if (lastAlignSpec.aligningToElement) {
        const positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'position') !== 'fixed',
              realignTarget = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isInView(lastAlignSpec.target, false, positioned); // If the target that we are realigning to is not in view, we hide, and set the
        // flag in the lastAlignSpec to explain why

        if (!lastAlignSpec.allowTargetOut && (!Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(lastAlignSpec.target) || !realignTarget)) {
          me.hide(); // Hiding *might* destroy if autoClose is set.

          if (!me.isDestroyed) {
            me.lastAlignSpec.targetOutOfView = true;
          }

          return;
        } // We use a different align target when *re*aligning. It's the *visible* rectangle.


        lastAlignSpec.realignTarget = realignTarget;
      }

      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].addTemporaryClass(me.element, 'b-realigning', 300);
      me.alignTo(lastAlignSpec);
    }
  }
  /**
   * Returns the specified bounding rectangle of this widget.
   * @param {String} [which] By default, the rectangle returned is the bounding rectangle that contains the `element`
   * border. Pass any of these values to retrieve various rectangle:
   *  - `'border'` to get the {@link Core.helper.util.Rectangle#function-from-static border rectangle} (the default).
   *  - `'client'` to get the {@link Core.helper.util.Rectangle#function-client-static client rectangle}.
   *  - `'content'` to get the {@link Core.helper.util.Rectangle#function-content-static content rectangle}.
   *  - `'inner'` to get the {@link Core.helper.util.Rectangle#function-inner-static inner rectangle}.
   *  - `'outer'` to get the {@link Core.helper.util.Rectangle#function-outer-static outer rectangle}.
   * @param {HTMLElement|Core.widget.Widget} [relativeTo] Optionally, a parent element or widget in whose space to
   * calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @returns {Core.helper.util.Rectangle}
   * @internal
   */


  rectangle(which, relativeTo, ignorePageScroll) {
    return this.rectangleOf('element', which, relativeTo, ignorePageScroll);
  }
  /**
   * Returns the specified bounding rectangle of the specified child `element` of this widget.
   * @param {String} [element] The child element name.
   * @param {String} [which] By default, the rectangle returned is the bounding rectangle that contains the `element`
   * border. Pass any of these values to retrieve various rectangle:
   *  - `'border'` to get the {@link Core.helper.util.Rectangle#function-from-static border rectangle} (the default).
   *  - `'client'` to get the {@link Core.helper.util.Rectangle#function-client-static client rectangle}.
   *  - `'content'` to get the {@link Core.helper.util.Rectangle#function-content-static content rectangle}.
   *  - `'inner'` to get the {@link Core.helper.util.Rectangle#function-inner-static inner rectangle}.
   *  - `'outer'` to get the {@link Core.helper.util.Rectangle#function-outer-static outer rectangle}.
   * @param {HTMLElement|Core.widget.Widget} [relativeTo] Optionally, a parent element or widget in whose space to
   * calculate the Rectangle. If `element` is not `'element'`, then this defaults to the widget's primary element.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @returns {Core.helper.util.Rectangle}
   * @internal
   */


  rectangleOf(element, which, relativeTo, ignorePageScroll) {
    var _relativeTo;

    if (typeof which !== 'string') {
      ignorePageScroll = relativeTo;
      relativeTo = which;
      which = '';
    } else if (which === 'border') {
      which = '';
    } // which is locked in


    if (typeof relativeTo === 'boolean') {
      ignorePageScroll = relativeTo;
      relativeTo = undefined;
    }

    if (element !== 'element' && relativeTo === undefined) {
      relativeTo = this.element;
    }

    relativeTo = (_relativeTo = relativeTo) !== null && _relativeTo !== void 0 && _relativeTo.isWidget ? relativeTo.element : relativeTo;
    return _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"][which || 'from'](this[element], relativeTo, ignorePageScroll);
  }

  releaseSizeConstraints() {
    const me = this,
          scroller = me.scrollable; // Release constraints so we can align from scratch each time.

    if (me.alignConstrained & 1) {
      me.height = me.configuredHeight;

      if (scroller) {
        scroller.overflowY = scroller.config.overflowY;
      }
    }

    if (me.alignConstrained & 2) {
      me.width = me.configuredWidth;

      if (scroller) {
        scroller.overflowX = scroller.config.overflowX;
      }
    }

    me.alignConstrained = 0;
  }
  /**
   * Only valid for {@link #config-floating} Widgets. Moves to the front of the visual stacking order.
   * @category Float & align
   */


  toFront() {
    const {
      element
    } = this,
          parent = this.floating ? this.floatRoot : this.positioned ? element === null || element === void 0 ? void 0 : element.parentNode : null;

    if (element !== null && element !== void 0 && element.nextSibling) {
      const r = this._toFrontRange || (this._toFrontRange = document.createRange()); // Instead of moving this element (which may contain focus and therefore should not be moved),
      // Lasso all following nodes using a range and insert them before this.
      // If it contained focus, appending it triggers a focusOut event which will not be expected.

      r.setStartBefore(element.nextSibling);
      r.setEndAfter(parent.lastElementChild);
      parent.insertBefore(r.extractContents(), element);
    }
  } //endregion
  //region Getters/setters


  updateRef(ref) {
    this.element.dataset.ref = ref;
  }
  /**
   * The child element which scrolls if any. This means the element used by the {@link #config-scrollable}.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get overflowElement() {
    return this.contentElement;
  }

  get maxHeightElement() {
    return this.element;
  }

  changeAlign(align) {
    return typeof align === 'string' ? {
      align
    } : align;
  }

  changeScrollable(scrollable, oldScrollable) {
    if (typeof scrollable === 'boolean') {
      scrollable = {
        overflowX: scrollable,
        overflowY: scrollable
      };
    }

    if (scrollable) {
      scrollable.element = this.overflowElement;
      scrollable.widget = this;

      if (!scrollable.isScroller) {
        scrollable = oldScrollable ? oldScrollable.setConfig(scrollable) : new this.scrollerClass(scrollable);
      } // Keep overflow indicator classes in sync


      scrollable.syncOverflowState();
    } // Destroy the old scroller if the scroller is being nulled.
    else {
      oldScrollable === null || oldScrollable === void 0 ? void 0 : oldScrollable.destroy();
    }

    return scrollable;
  }
  /**
   * Get/set HTML to display. When specifying HTML, this widget's element will also have the
   * {@link #config-htmlCls} added to its classList, to allow targeted styling.
   * @property {String}
   * @category DOM
   */


  get html() {
    // Maintainer, we cannot use a ternary here, we need the this.initializingElement test to shortcut
    // to the true case to return the _html property to avoid infinite loops.
    if (this.initializingElement || !this.element) {
      return this.content || this._html;
    }

    return this.contentElement.innerHTML;
  }

  updateHtml(html) {
    const me = this,
          isClearing = html == null,
          {
      element,
      contentElement,
      htmlCls
    } = me;

    if (element) {
      // So that our contentElement MutationObserver doesn't react
      me.updatingHtml = true;
      const anchorEl = contentElement === element && me._anchorElement; // Flag class that we are an HTML carrying element

      if (htmlCls) {
        // IE11 doesn't support multiple arguments
        // Salesforce doesn't support passing array
        htmlCls.values.forEach(value => element.classList[isClearing ? 'remove' : 'add'](value));
      } // Setting innerHTML destroys the anchorElement in some browsers
      // so we must temporarily remove it to preserve it.
      // Only if the contentElement is the main element.


      if (anchorEl) {
        me.element.removeChild(anchorEl);
      }

      if (html && typeof html === 'object') {
        _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync({
          domConfig: html,
          targetElement: me.contentElement,
          onlyChildren: true
        });
      } else {
        me.contentElement.innerHTML = isClearing ? '' : html;
      } // Ensure our content mutation observer keeps us informed of changes by third parties
      // so that our config system can keep up to date.


      me.getConfig('htmlMutationObserver');

      if (anchorEl) {
        element.appendChild(anchorEl);
      }

      if (me.isComposable) {
        me.recompose();
      } else if (me.floating || me.positioned) {
        // Must realign because content change might change dimensions
        if (!me.isAligning) {
          me.realign();
        }
      }
    }
  }

  changeHtmlMutationObserver(htmlMutationObserver, was) {
    const me = this,
          {
      contentElement
    } = me; // Clean up old one

    was === null || was === void 0 ? void 0 : was.disconnect(contentElement); // Create MutationObserver

    if (htmlMutationObserver) {
      const result = new MutationObserver(() => {
        if (me.updatingHtml) {
          me.updatingHtml = false;
        } else {
          me._html = contentElement.innerHTML;
        }
      });
      result.observe(contentElement, htmlMutationObserver);
      return result;
    }
  }

  updateContent(html) {
    const me = this,
          isClearing = html == null,
          {
      element,
      htmlCls
    } = me;

    if (element) {
      const {
        contentRange
      } = me; // Flag class that we are an HTML carrying element

      if (htmlCls) {
        // IE11 doesn't support multiple arguments
        // Salesforce doesn't support passing array
        htmlCls.values.forEach(value => element.classList[isClearing ? 'remove' : 'add'](value));
      } // Only works if we are in the DOM


      if (Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["isInDocument"])(element)) {
        // Replace the contents of our content range with the new content
        contentRange.deleteContents();

        if (!isClearing) {
          contentRange.insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(html, {
            fragment: true
          }));
        }
      } else {
        me.contentElement.innerHTML = html;
      } // Cache in case it gets collapsed


      me.contentRangeStartOffset = contentRange.startOffset;
      me.contentRangeEndOffset = contentRange.endOffset; // Must realign because content change might change dimensions

      if ((me.floating || me.positioned) && !me.isAligning) {
        me.realign();
      }
    }
  }

  onThemeChange() {
    var _this$anchorElement;

    // If we have a *visible* anchor element, then a theme change may
    // invalidate it's size or this.defaultAnchorBackgroundColor, so a
    // run through realign (and get anchorSize) will fix that.
    if ((_this$anchorElement = this.anchorElement) !== null && _this$anchorElement !== void 0 && _this$anchorElement.offsetParent) {
      this._anchorSize = null;
      this.realign();
    }
  }
  /**
   * Returns an `[x, y]` array containing the width and height of the anchor arrow used when
   * aligning this Widget to another Widget or element.
   *
   * The height is the height of the arrow when pointing upwards, the width is the width
   * of the baseline.
   * @property {Number[]}
   * @category Float & align
   */


  get anchorSize() {
    const me = this;
    let result = this._anchorSize;

    if (!result) {
      // TODO: Move the anchoring scheme to the Panel class when we have it.
      // These values will be in the SASS and styled into the SVG through the Panel's theme.
      const borderWidth = parseFloat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'border-top-width')),
            borderColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'border-top-color'),
            anchorElement = me.anchorElement,
            {
        className
      } = anchorElement,
            svgEl = anchorElement.firstElementChild,
            pathElement = me.anchorPathElement = svgEl.lastElementChild,
            hidden = me._hidden; // In case we are measuring after the size has been invalidated (such as via theme change)
      // and the widget is shown and aligned left or right. We must measure it in top alignment
      // so as to get the dimensions the right way round.

      anchorElement.className = 'b-anchor b-anchor-top';
      let backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.contentElement, 'background-color'); // If the background colour comes through from the outer element, use that.

      if (backgroundColour.match(isTransparent)) {
        backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'background-color');
      }

      me.defaultAnchorBackgroundColor = backgroundColour;
      result = anchorElement.getBoundingClientRect();
      const [width, height] = result = me._anchorSize = [result.width, result.height]; // Restore orientation

      anchorElement.className = className;
      svgEl.setAttribute('height', height + borderWidth);
      svgEl.setAttribute('width', width);
      pathElement.setAttribute('d', `M0,${height}L${width / 2},0.5L${width},${height}`);

      if (borderWidth) {
        pathElement.setAttribute('stroke-width', borderWidth);
        pathElement.setAttribute('stroke', borderColour);
      }

      result[1] -= borderWidth;

      if (hidden) {
        me.element.classList.add('b-hidden');
      }

      if (!me.themeChangeListener) {
        me.themeChangeListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].on({
          theme: 'onThemeChange',
          thisObj: me
        });
      } // Reset to default in case it has been positioned by a coloured header


      me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
    }

    return result;
  }

  get anchorElement() {
    const me = this;

    if (!me._anchorElement) {
      const useFilter = me.floating && !(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge),
            filterId = `${me.id}-shadow-filter`;
      me._anchorElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        parent: me.element,
        className: 'b-anchor b-anchor-top',
        children: [{
          tag: 'svg',
          ns: 'http://www.w3.org/2000/svg',
          version: '1.1',
          class: 'b-pointer-el',
          children: [useFilter ? {
            tag: 'defs',
            children: [{
              tag: 'filter',
              id: filterId,
              children: [{
                tag: 'feDropShadow',
                dx: 0,
                dy: -1,
                stdDeviation: 1,
                'flood-opacity': 0.2
              }]
            }]
          } : null, {
            tag: 'path',
            [useFilter ? 'filter' : '']: `url(#${filterId})`
          }]
        }]
      });
    }

    return me._anchorElement;
  }

  updateAnchor(anchor) {
    if (this._anchorElement) {
      this._anchorElement.classList[anchor ? 'remove' : 'add']('b-hide-display');
    }
  }

  updateDraggable(draggable) {
    const me = this,
          {
      element
    } = me;

    if (draggable) {
      me.dragEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener({
        element,
        dragstart: 'onWidgetDragStart',
        dragend: 'onWidgetDragEnd',
        thisObj: me
      });
      me.dragDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
        element,

        mousedown(event) {
          const {
            target
          } = event,
                closestWidget = Widget.fromElement(target); // Fix for FF draggable bug https://bugzilla.mozilla.org/show_bug.cgi?id=1189486

          if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, '.b-field-inner') && // Only allow drag to start when the action originates from the widget element itself,
          // or one of its toolbars. https://github.com/bryntum/support/issues/3214
          closestWidget === this || this.strips && Object.values(this.strips).includes(closestWidget)) {
            element.setAttribute('draggable', 'true');
          }
        },

        // Only needed for automatic listener removal on the destroy of the thisObj
        thisObj: me
      });
    } else {
      var _me$dragEventDetacher2, _me$dragOverEventDeta2, _me$dragDetacher;

      (_me$dragEventDetacher2 = me.dragEventDetacher) === null || _me$dragEventDetacher2 === void 0 ? void 0 : _me$dragEventDetacher2.call(me);
      (_me$dragOverEventDeta2 = me.dragOverEventDetacher) === null || _me$dragOverEventDeta2 === void 0 ? void 0 : _me$dragOverEventDeta2.call(me);
      (_me$dragDetacher = me.dragDetacher) === null || _me$dragDetacher === void 0 ? void 0 : _me$dragDetacher.call(me);
    }
  }

  onWidgetDragStart(e) {
    var _ref2;

    const me = this;

    if (!me.validateDragStartEvent(e)) {
      return;
    } // Opt out of auto-alignment on scroll or DOM mutation.


    me.removeTransientListeners();
    const {
      element,
      align,
      constrainTo
    } = me,
          positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') !== 'fixed',
          parentElement = positioned ? element.parentElement : me.rootElement,
          myRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? parentElement : null),
          dragStartX = e.clientX,
          dragStartY = e.clientY,
          scrollingPageElement = document.scrollingElement || document.body,
          [widgetX, widgetY] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getOffsetXY(element, parentElement),
          constrainRect = (_ref2 = positioned ? _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].content(parentElement).moveTo(0, 0) : constrainTo && (constrainTo !== null && constrainTo !== void 0 && constrainTo.isRectangle ? constrainTo : _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(constrainTo))) === null || _ref2 === void 0 ? void 0 : _ref2.deflate(align.constrainPadding || 0),
          dragListeners = {
      element: parentElement,
      dragover: event => {
        // Centered adds positioning rules, it can't be centered during drag.
        element.classList.remove('b-centered'); // Shift our rectangle to the desired point.

        myRect.moveTo(widgetX + event.clientX - dragStartX - (positioned ? 0 : scrollingPageElement.scrollLeft), widgetY + event.clientY - dragStartY - (positioned ? 0 : scrollingPageElement.scrollTop)); // Constrain it if we are configured to be constrained

        if (constrainRect) {
          myRect.constrainTo(constrainRect);
        } // Position using direct DOM access, do not go though the setXY method which clears
        // any centered config. User dragging only moves this show of the widget. Upon next
        // neutral show (with no extra positioning info), a centered widget will show centered again.


        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, myRect.x, myRect.y);
      }
    }; // Stop viewport panning on drag on touch devices

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice) {
      dragListeners.touchmove = e => e.preventDefault();
    }

    me.floatRoot.appendChild(me.dragGhost);
    me.setDragImage(e); // Prevent special cursor from being shown

    e.dataTransfer.effectAllowed = 'none';
    me.dragOverEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(dragListeners); // Various app events (Such as resize or visible child count change) can
    // cause a request to realign, so opt out of anchoring and alignedness
    // until we are next hidden.

    me.alignTo();
  }
  /**
   * Validates a `dragstart` event with respect to the target element. Dragging is not normally
   * initiated when the target is interactive such as an input field or its label, or a button.
   * This may be overridden to provide custom drag start validation.
   * @param {DragEvent} e The `dragstart` event to validate.
   * @returns {Boolean} Return `true` if the drag is to be allowed.
   * @internal
   */


  validateDragStartEvent(e) {
    const me = this,
          {
      element
    } = me,
          actualTarget = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].elementFromPoint(e.clientX, e.clientY),
          // Can't be resolved from the event :/
    {
      handleSelector
    } = me.draggable;

    if (handleSelector) {
      const blacklist = negationPseudo.exec(handleSelector)[1]; // Extract the content of :not()
      // If the selector was :not(), then if we are a descendant of a matching element, it's a no-drag

      if (blacklist) {
        if (actualTarget.closest(`#${element.id} ${blacklist}`)) {
          e.preventDefault();
          return false;
        }
      } // If we are not the descendant of a matching element, it's a no-drag
      else if (!actualTarget.closest(`#${element.id} ${handleSelector}`)) {
        e.preventDefault();
        return false;
      }
    }

    return true;
  }

  setDragImage(e) {
    if (e.dataTransfer.setDragImage) {
      // Firefox requires this to be called before setDragImage
      e.dataTransfer.setData('application/node type', ''); // Override the default HTML5 drag ghost and just drag an empty node.
      // The large offset will cause it to be displayed offscreen on platforms
      // which will not hide drag images (iOS)

      e.dataTransfer.setDragImage(this.dragGhost, -9999, -9999);
    }
  }

  onWidgetDragEnd() {
    this.dragGhost.remove();
    this.dragOverEventDetacher();
    this.element.removeAttribute('draggable');
  }

  changeFloating(value) {
    // Coerce all to boolean so that we have a true/false value
    return Boolean(value);
  }

  changePositioned(value) {
    // Coerce all to boolean so that we have a true/false value
    return Boolean(value);
  }

  updatePositioned(positioned) {
    this.element.classList[positioned ? 'add' : 'remove']('b-positioned');
  }

  getXY() {
    return [_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageX(this.element), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageY(this.element)];
  }
  /**
   * Moves this Widget to the x,y position. Both arguments can be omitted to just set one value.
   *
   * *For {@link #config-floating} Widgets, this is a position in the browser viewport.*
   * *For {@link #config-positioned} Widgets, this is a position in the element it was rendered into.*
   *
   * @param {Number} [x]
   * @param {Number} [y]
   * @category Float & align
   */


  setXY(x, y) {
    const me = this,
          {
      element
    } = me;

    if (me.floating || me.positioned) {
      if (x != null) {
        me._x = x;
        me.centered = false;
      }

      if (y != null) {
        me._y = y;
        me.centered = false;
      } // If we're position:fixed then it is positioned relative to either the viewport
      // or an ancestor which has a transform, perspective of filter property.
      // See https://developer.mozilla.org/en-US/docs/Web/CSS/position.
      // So translate it *relative* to its actual position/


      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') === 'fixed') {
        const r = element.getBoundingClientRect(),
              [cx, cy] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element),
              xDelta = x - r.x,
              yDelta = y - r.y;
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, cx + xDelta, cy + yDelta);
      } else {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, me._x || 0, me._y || 0);
      }
    }
  }
  /**
   * Moves this Widget to the desired x position.
   *
   * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
   * @property {Number}
   * @category Float & align
   */


  get x() {
    return this.getXY()[0];
  }

  changeX(x) {
    this.setXY(x);
  }
  /**
   * Moves this Widget to the desired y position.
   *
   * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
   * @property {Number}
   * @category Float & align
   */


  get y() {
    return this.getXY()[1];
  }

  changeY(y) {
    this.setXY(null, y);
  }
  /**
   * Get elements offsetWidth or sets its style.width, or specified width if element not created yet.
   * @property {Number}
   * @accepts {Number|String}
   * @category Layout
   */


  get width() {
    const me = this,
          element = me.element;

    if (me.monitorResize) {
      // If the width is invalid, read it now.
      if (me._width == null) {
        me._width = element.offsetWidth;
      } // Usually this will be set in onInternalResize


      return me._width;
    } // No monitoring, we have to measure;


    return element.offsetWidth;
  }

  changeWidth(width) {
    const me = this;
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(me.element, 'width', width);
    me._lastWidth = width; // Invalidate the width, so it will be read from the DOM if a read is requested before the resize event

    me._width = null; // Setting width explicitly should reset flex, since it's not flexed anymore

    me._flex = null;
    me.element.style.flex = '';
  }
  /**
   * Get/set elements maxWidth. Getter returns max-width from elements style, which is always a string. Setter accepts
   * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get maxWidth() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.maxWidth, this.element);
  }

  updateMaxWidth(maxWidth) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'maxWidth', maxWidth);
  }
  /**
   * Get/set elements minWidth. Getter returns min-width from elements style, which is always a string. Setter accepts
   * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get minWidth() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.minWidth, this.element);
  }

  updateMinWidth(minWidth) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'minWidth', minWidth);
  }

  updateFlex(flex) {
    // Width must be processed first, because its changer clears flex because flex wins over width;
    // The assumption that the containing element's flex-direction is 'row'
    // seems dodgy.
    this.getConfig('width'); // Default grow to the same as flex and basis to 0.

    if (typeof flex === 'number' || !isNaN(flex)) {
      flex = `${flex} ${flex}`;
    }

    this.element.style.flex = flex;
    this.element.style.width = '';
  }

  updateAlignSelf(alignSelf) {
    this.element.style.alignSelf = alignSelf;
  }

  updateMargin(margin) {
    // Convert eg 1 to "1px 1px 1px 1px" or "0 8px" to "0px 8px 0px 8px"
    this.element.style.margin = this.parseTRBL(margin).join(' ');
  }

  updateTextAlign(align, oldAlign) {
    oldAlign && this.element.classList.remove(`b-text-align-${oldAlign}`);
    this.element.classList.add(`b-text-align-${align}`);
  }

  updatePlaceholder(placeholder) {
    if (this.input) {
      if (placeholder == null) {
        this.input.removeAttribute('placeholder');
      } else {
        this.input.placeholder = placeholder;
      }
    }
  }
  /**
   * Get element's offsetHeight or sets its style.height, or specified height if element no created yet.
   * @property {Number}
   * @accepts {Number|String}
   * @category Layout
   */


  get height() {
    const me = this,
          element = me.element;

    if (me.monitorResize) {
      // If the height is invalid, read it now.
      if (me._height == null) {
        me._height = element.offsetHeight;
      } // Usually this will be set in onInternalResize


      return me._height;
    } // No monitoring, we have to measure;


    return element.offsetHeight;
  }

  changeHeight(height) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'height', height);
    this._lastHeight = height; // Invalidate the height, so it will be read from the DOM if a read is requested before the resize event

    this._height = null;
  }
  /**
   * Get/set element's maxHeight. Getter returns max-height from elements style, which is always a string. Setter
   * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get maxHeight() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.maxHeightElement.style.maxHeight, this.element);
  }

  updateMaxHeight(maxHeight) {
    const me = this,
          {
      element
    } = me;
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(me.maxHeightElement, 'maxHeight', maxHeight); // Flexbox does not handle overflow correctly when a vertically
    // flexed item is constrained by the maxHeight of its containing el.
    // So we have to propagate the maxHeight from the encapsulating element
    // onto the contentElement.

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 && me.contentElement !== element) {
      if (maxHeight == null) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element, me.boundMaxHeightBugHandler);
      } else {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element, me.boundMaxHeightBugHandler || (me.boundMaxHeightBugHandler = me.fixIEMaxHeightBug.bind(me)));

        if (document.body.contains(element)) {
          me.fixIEMaxHeightBug();
        }
      }
    }
  }

  fixIEMaxHeightBug() {
    const {
      element,
      contentElement
    } = this; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
    // propagated onto the contentElement.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'flex-direction') === 'column') {
      // Release previous height constraint
      contentElement.style.maxHeight = '';
      let availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].client(element).height;
      const siblings = element.childNodes,
            len = siblings.length; // In case there are height-consuming siblings of the contentElement.
      // For example a header/footer. The heights of these must be subtracted.

      for (let i = 0; i < len; i++) {
        const sibling = siblings[i];

        if (sibling !== contentElement && !sibling.classList.contains('b-resize-monitors')) {
          availableHeight -= sibling.offsetHeight;
        }
      } // Apply the adjusted height constraint to the contentElement


      this.contentElement.style.maxHeight = `${availableHeight}px`;
    }
  }
  /**
   * Get/set element's minHeight. Getter returns min-height from elements style, which is always a string. Setter
   * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get minHeight() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.minHeight, this.element);
  }

  updateMinHeight(minHeight) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'minHeight', minHeight);
  }

  updateDisabled(disabled) {
    const me = this,
          el = me.element,
          focusEl = me.focusElement;
    me.trigger('beforeUpdateDisabled', {
      disabled
    });
    disabled && me.revertFocus();

    if (el) {
      el.classList[disabled ? 'add' : 'remove']('b-disabled');

      if (focusEl) {
        focusEl.disabled = disabled;
      }
    }

    me.onDisabled(disabled);
  }
  /**
   * Called when disabled state is changed.
   * Override in subclass that needs special handling when being disabled.
   * @param {Boolean} disabled current state
   * @private
   */


  onDisabled(disabled) {}
  /**
   * Disable the widget
   */


  disable() {
    this.disabled = true;
  }
  /**
   * Enable the widget
   */


  enable() {
    this.disabled = false;
  }
  /**
   * Requests fullscreen display for this widget
   * @returns {Promise} A Promise which is resolved with a value of undefined when the transition to full screen is complete.
   */


  requestFullscreen() {
    const me = this,
          // If we are floating, target the float root as the fullscreen element
    result = _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].request(me.floating ? me.floatRoot : me.element);
    _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].onFullscreenChange(me.onFullscreenChange);

    if (!me.floating) {
      me.floatRoot._oldParent = me.floatRoot.parentElement;
      me.element.appendChild(me.floatRoot);
    }

    me.element.classList.add('b-fullscreen');
    return result;
  }
  /**
   * Exits fullscreen mode
   * @returns {Promise} A Promise which is resolved once the user agent has finished exiting full-screen mode
   */


  exitFullscreen() {
    return _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].exit();
  }

  onFullscreenChange() {
    if (!_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].isFullscreen) {
      this.onExitFullscreen();
    }
  }

  onExitFullscreen() {
    var _me$_rootElement;

    const me = this,
          floatRoot = (_me$_rootElement = me._rootElement) === null || _me$_rootElement === void 0 ? void 0 : _me$_rootElement.floatRoot;
    _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].unFullscreenChange(me.onFullscreenChange);
    me.element.classList.remove('b-fullscreen'); // When exiting fullscreen mode or when this widget is destroyed, move floatRoot back to its old parent

    if (me.element.contains(floatRoot) && floatRoot !== null && floatRoot !== void 0 && floatRoot._oldParent) {
      floatRoot._oldParent.appendChild(floatRoot);

      floatRoot._oldParent = null;
    }
  }
  /**
   * Get/set a tooltip on the widget. Accepts a string or tooltip config (specify true (or 'true') to use placeholder
   * as tooltip). When using a string it will configure the tooltip with `textContent: true` which enforces a default
   * max width.
   *
   * By default, this uses a singleton Tooltip instance which may be accessed from the
   * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
   * This is configured according to the config object on pointer over.
   *
   * To request a separate instance be created just for this widget, add `newInstance : true`
   * to the configuration.
   *
   * @property {String|Object}
   * @category Misc
   */


  get tooltip() {
    if (this._tooltip) {
      return this._tooltip;
    } else {
      var _Widget$Tooltip2;

      const tooltip = (_Widget$Tooltip2 = Widget.Tooltip) === null || _Widget$Tooltip2 === void 0 ? void 0 : _Widget$Tooltip2.getSharedTooltip(this.rootElement); // If the shared tooltip is currently in use by us, return it.
      // If it's not in use by us, we don't have a tooltip.

      if (tooltip && tooltip.activeTarget === this._element && tooltip.isVisible) {
        return tooltip;
      }
    }
  } //noinspection JSAnnotator


  changeTooltip(tooltip, oldTooltip) {
    const me = this;

    if (tooltip) {
      if (!(me.preventTooltipOnTouch && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice)) {
        if (!tooltip.isTooltip && tooltip.constructor.name !== 'Object') {
          tooltip = {
            html: typeof tooltip === 'string' ? tooltip : me.placeholder,
            textContent: true
          };
        } // We have to explicitly request a new instance to avoid spam Tooltip instances.
        // If there is an incoming oldTooltip, then we own a newInstance.
        // TODO verify .isTooltip check is needed


        if (oldTooltip !== null && oldTooltip !== void 0 && oldTooltip.isTooltip || tooltip.newInstance) {
          tooltip.type = 'tooltip';
          if (!tooltip.forElement) tooltip.forElement = me.element;
          if (!('showOnHover' in tooltip) && !tooltip.forSelector) tooltip.showOnHover = true;
          if (!('autoClose' in tooltip)) tooltip.autoClose = true;
          tooltip = Widget.reconfigure(oldTooltip, tooltip, me);
        } // The default is that tooltip content and configs from tipConfig
        else {
          me.element.dataset.btip = true;
          me.tipConfig = tooltip; // We do not set our property if we are sharing the singleton

          return;
        }
      }
    } else {
      // If there is an incoming oldTooltip, then we own a newInstance.
      // Only destroy it if it's being set to null. Empty string
      // just means clear its content.
      if (oldTooltip) {
        if (tooltip == null && oldTooltip.isTooltip) {
          oldTooltip.destroy();
        } else {
          // We do not update the property if we are just clearing its content
          oldTooltip.html = null;
          return;
        }
      } // We are sharing, so just clear the btip
      else {
        delete me.element.dataset.btip;
      }
    }

    return tooltip;
  }

  get tooltipText() {
    const tooltip = this._tooltip;

    if (tooltip) {
      return tooltip.isTooltip ? tooltip.contentElement.innerText : typeof tooltip === 'string' ? tooltip : tooltip.html;
    } else if (this.tipConfig) {
      return this.tipConfig.html;
    }
  }
  /**
   * Determines visibility by checking if the Widget is hidden, or any ancestor is hidden and that it has an
   * element which is visible in the DOM
   * @property {Boolean}
   * @category Visibility
   * @readonly
   */


  get isVisible() {
    const me = this,
          {
      element
    } = me; // Added so that we only acquire owner once. `get owner()` *may* have to search DOM

    let owner; // If we are hidden, or destroying, or any ancestors are hidden, we're not visible

    return Boolean(element && !me._hidden && !me.isDestroying && Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["isInDocument"])(element) && (!me.requireSize || Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(element)) && (!(owner = me.containingWidget) || owner.isVisible));
  }
  /**
   * Focuses this widget if it has a focusable element.
   */


  focus() {
    if (this.isFocusable) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(this.focusElement);
    }
  }
  /**
   * Get this widget's primary focus holding element if this widget is itself focusable, or contains focusable widgets.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get focusElement() {// Override in widgets which are focusable.
  }

  get isFocusable() {
    const focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
    // it must have layout - an offsetParent. Body does not have offsetParent.

    return focusElement && this.isVisible && !this.disabled && (focusElement === document.body || focusElement.offsetParent);
  }
  /**
   * Shows this widget
   * @category Visibility
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async show() {
    const me = this,
          {
      showAnimation,
      element,
      floating
    } = me,
          {
      style
    } = element;
    let styleProp, animProps, trigger;

    if (trigger = !me.isVisible) {
      /**
       * Triggered before a widget is shown. Return `false` to prevent the action.
       * @preventable
       * @async
       * @event beforeShow
       * @param {Core.widget.Widget} source The widget being shown.
       */
      trigger = me.trigger('beforeShow');

      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_13__["default"].isPromise(trigger)) {
        trigger = await trigger;
      }
    }

    if (trigger !== false && (!me.internalBeforeShow || me.internalBeforeShow() !== false)) {
      return new Promise(resolve => {
        // Cancel any current hide/show animation
        me.cancelHideShowAnimation(); // Centered config value takes precedence over x and y configs.
        // This also ensures that widgets configured with centered: true
        // and draggable : true will show in the center on next show after
        // being dragged by the user which is the intuitive UX.

        me.updateCentered(me._centered);

        if (floating) {
          const floatRoot = me.floatRoot;

          if (!floatRoot.contains(element)) {
            // Replace this Widget's DOM into the container if it's already rendered
            if (me.rendered) {
              floatRoot.appendChild(me.element);
            } else {
              // Pass triggerPaint as false. The calls will not propagate
              // anyway since we are still hidden.
              me.render(floatRoot, false);
            }
          } // Because we are outside of any owner's element, we need to see if they're scaled so
          // that we match. See scaled examples with tooltips in API docs guides section.


          if (style.transform.includes('scale')) {
            me.scale = null;
            style.transform = style.transformOrigin = '';
          }

          const scaledAncestor = me.closest(isScaled);

          if (scaledAncestor) {
            const {
              scale
            } = scaledAncestor; // Our scale is the same while we are visible and owned by that scaled ancestor.
            // Now floating descendants will follow suit.

            me.scale = scale;
            style.transform = `scale(${scale})`;
            style.transformOrigin = `0 0`;
          }
        }

        me._hidden = false;
        element.classList.remove('b-hidden'); // The changer vetoes the config change and routes here, so we must call this.

        me.onConfigChange({
          name: 'hidden',
          value: false,
          was: true,
          config: me.$meta.configs.hidden
        });

        if (showAnimation) {
          styleProp = Object.keys(showAnimation)[0];
          animProps = showAnimation[styleProp];
          const currentAnimation = me.currentAnimation = {
            showing: true,
            styleProp,
            resolve
          };
          me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

          me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].onTransitionEnd({
            element,
            property: styleProp,
            duration: parseDuration(animProps.duration) + 20,
            handler: () => me.afterHideShowAnimate(currentAnimation),
            thisObj: me
          }); // Setting transition style initial value before showing,
          // then reading the style to ensure transition will animate

          style[styleProp] = animProps.from;
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, styleProp);
          style.transition = `${styleProp} ${animProps.duration} ease ${animProps.delay}`;
          style[styleProp] = animProps.to;
        }

        me.afterShow(!showAnimation && resolve); // Note: popups can be dismissed in the process of focusin/out if an editor has invalidAction='block',
        // so we may be hidden at this point...
        // If we're not being called from showBy, do default aligning unless its centered

        if (!me.inShowBy && (floating || me.positioned) && me.forElement && !me.centered && !me.hidden) {
          me.alignTo(me.forElement);
        }
      });
    } else {
      return Promise.resolve();
    }
  }
  /**
   * Show aligned to another target element or {@link Core.widget.Widget} or {@link Core.helper.util.Rectangle}
   * @param {Object|HTMLElement} spec Alignment specification, or the element to align to using the configured
   * {@link #config-align}.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or Element or Rectangle to align to.
   * @param {Boolean} [spec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
   * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
   * @param {String} spec.align The alignment specification string, `[trblc]n-[trblc]n`. Defaults to this instance's
   * {@link #config-align} setting.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
   * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
   * to the `minWidth` and `minHeight` properties of this spec, or the Widget), then it will try aligning at other edges
   * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
   * @param {Number|Number[]} [spec.constrainPadding] The amount of pixels to pad from the `constrainTo` target,
   * either a single value, or an array of values in CSS edge order.
   * @param {Number} [spec.minHeight] The minimum height this widget may be compressed to when constraining within the `constrainTo` option.
   * @param {Number} [spec.minWidth] The minimum width this widget may be compressed to when constraining within the `constrainTo` option.
   * @param {Boolean} [spec.axisLock] Specify as `true` to fall back to aligning against the opposite
   * edge if the requested alignment cannot be constrained into the `constrainTo` option. Specify as
   * `'flexible'` to allow continuation to try the other edges if a solution cannot be found on the originally requested axis.
   * @param {Boolean} [spec.matchSize] When aligning edge-to-edge, match the length of the aligned-to
   * edge of the target. This is only honored when `axisLock` is enabled and alignment succeeds on the requested axis.
   * If __not__ aligning edge-to-edge, `matchSize` matches both dimensions of the target.
   * Specify as `true` to have this widget's size along the aligned edge match the size of the target's edge.
   * For example, a combobox's dropdown should match the width of the combobox.
   * @param {Number|Number[]} [spec.offset] The offset to create an extra margin round the target
   * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
   * towards the target - for example producing the effect of the anchor pointer piercing the target.
   * @param {Boolean} [spec.monitorResize] Configure as `true` to monitor the element being aligned to for
   * resizing while visible to correct alignment.
   * @category Float & align
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async showBy(spec) {
    const me = this;
    let result;

    if (me.isVisible) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].addTemporaryClass(me.element, 'b-realigning', 300);
    } else {
      // Prevent show from rerouting here.
      me.inShowBy = true;
      result = me.show();
      me.inShowBy = false;
    }

    if (me.isVisible) {
      me.alignTo(spec);
    }

    return result || immediatePromise;
  }
  /**
   * Show this widget anchored to a coordinate
   * @param {Number|Number[]} x The x position (or an array with [x,y] values) to show by
   * @param {Number} [y] The y position to show by
   * @param {Object} [options] See {@link #function-showBy} for reference
   * @category Float & align
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async showByPoint(x, y, options) {
    const xy = arguments.length === 1 ? x : [x, y];
    return this.showBy(Object.assign({
      position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](xy[0] + 1, xy[1] + 1),
      // Override any matchSize that we might have in our align config.
      // Otherwise we are going to be 1px wide/high
      matchSize: false,
      align: 't-b'
    }, options));
  }

  afterShow(resolveFn) {
    var _me$parent, _me$parent$onChildSho;

    const me = this; // This method is injected when maxHeight is set on IE11.
    // Flexbox does not handle overflow correctly when a vertically
    // flexed item is constrained by the maxHeight of its containing el.
    // So we have to propagate the maxHeight from the encapsulating element
    // onto the contentElement.

    if (me.boundMaxHeightBugHandler) {
      me.boundMaxHeightBugHandler();
    }
    /**
     * Triggered after a widget is shown.
     * @event show
     * @param {Core.widget.Widget} source The widget
     */


    me.trigger('show'); // Cache our preferred anchoredness in case it's overridden by a drag.

    me._configuredAnchorState = me.anchor; // Keep any owning container informed about visibility state.
    // It may not be a Container. SubGrid class is still a Widget
    // which contains grid headers.

    (_me$parent = me.parent) === null || _me$parent === void 0 ? void 0 : (_me$parent$onChildSho = _me$parent.onChildShow) === null || _me$parent$onChildSho === void 0 ? void 0 : _me$parent$onChildSho.call(_me$parent);
    me.triggerPaint();
    resolveFn && resolveFn();
  }

  triggerPaint() {
    const me = this,
          {
      element
    } = me,
          firstPaint = !me.isPainted;

    if (me.isVisible) {
      if (firstPaint) {
        // Not for public use, only used in docs
        if (me.scaleToFitWidth && !me.monitorResize) {
          me.onParentElementResize = me.onParentElementResize.bind(me);
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element.parentElement, me.onParentElementResize);
          me.updateScale();
        } // Add a comment to state this is made by Bryntum


        if (!me.hideBryntumDomMessage && (me.isTaskBoardBase || me.isGridBase || me.isCalendar)) {
          element.insertBefore(new Comment('POWERED BY BRYNTUM (https://bryntum.com)'), element.firstChild);
        }
      } // Trigger paint only on immediate children.
      // Each one will call this recursively.
      // paint is triggered in a bottom up manner.


      me.eachWidget(widgetTriggerPaint, false);

      if (firstPaint && me.isVisible) {
        me.rootElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(element); // Make sure the shared tooltip is initialized

        me.getConfig('tooltip'); // Late setup of Ripple

        if (!Widget.Ripple && Widget.RippleClass) {
          Widget.Ripple = new Widget.RippleClass({
            rootElement: me.rootElement
          });
        }
      }
      /**
       * Triggered when a widget which had been in a non-visible state for any reason
       * achieves visibility.
       *
       * A non-visible state *might* mean the widget is hidden and has just been shown.
       *
       * But this event will also fire on widgets when a non-visible (unrendered, or hidden)
       * ancestor achieves visibility, for example a {@link Core.widget.Popup Popup} being shown.
       *
       * TLDR: __This event can fire multiple times__
       * @event paint
       * @param {Core.widget.Widget} source The widget being painted.
       * @param {Boolean} firstPaint `true` if this is the first paint.
       */


      me.isPainted = true;
      me.trigger('paint', {
        firstPaint
      });

      if (firstPaint) {
        // On first paint, we should announce our size immediately.
        // When the real event comes along, onElementResize will reject it because the size will be the same.
        if (me.monitorResize && !me.scaleToFitWidth) {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].onElementResize([{
            target: element
          }]);
        }
      }
    }
  }

  cancelHideShowAnimation() {
    const me = this,
          {
      currentAnimation,
      element
    } = me;

    if (currentAnimation) {
      me.isAnimating = false; // If it is an animated hide that we are aborting, reverse the set of the hidden flag
      // If hide is animated, we only get genuinely hidden at animation end.

      if (element.classList.contains('b-hiding')) {
        element.classList.remove('b-hiding');
        me._hidden = false;
      }

      currentAnimation.detacher();
      currentAnimation.resolve();
      element.style.transition = element.style[currentAnimation.styleProp] = '';
      me.currentAnimation = null;
    }
  }

  afterHideShowAnimate(currentAnimation) {
    // We receive the currentAnimation as understood by the party starting the animation... if that is not the
    // current value of "this.currentAnimation" we can ignore this call.
    const me = this; // If menu is destroyed too soon in Edge, this method will be invoked for destroyed element. Since all of our
    // properties are cleared on destroy, this check will prevent undesired reactions:

    if (currentAnimation === me.currentAnimation) {
      // Ensure cancelHideShowAnimation doesn't think we're aborting before the end.
      me.element.classList.remove('b-hiding');
      me.cancelHideShowAnimation(); // Element must be fully hidden after the animation effect finishes

      if (me._hidden) {
        me.afterHideAnimation();
      }
    }
  }
  /**
   * Temporarily changes the {@link #property-isVisible} to yield `false` regardless of this
   * Widget's true visibility state. This can be useful for suspending operations which rely on
   * the {@link #property-isVisible} property.
   *
   * This increments a counter which {@link #function-resumeVisibility} decrements.
   * @internal
   */


  suspendVisibility() {
    this._visibilitySuspended = (this._visibilitySuspended || 0) + 1;
    Object.defineProperty(this, 'isVisible', returnFalseProp);
  }
  /**
   * Resumes visibility. If the suspension counter is returned to zero by this, then the
   * {@link #event-paint} event is triggered, causing a cascade of `paint` events on all
   * descendants. This can be prevented by passing `false` as the only parameter.
   * @param {Boolean} [triggerPaint=true] Trigger the {@link #event-paint} event.
   * @internal
   */


  resumeVisibility(triggerPaint = true) {
    if (! --this._visibilitySuspended) {
      delete this.isVisible;

      if (triggerPaint) {
        this.triggerPaint();
      }
    }
  }
  /**
   * Hide widget
   * @param {Boolean} animate Pass `true` (default) to animate the hide action
   * @category Visibility
   * @returns {Promise} A promise which is resolved when the widget has been hidden
   */


  hide(animate = true) {
    return new Promise(resolve => {
      const me = this,
            {
        element,
        lastAlignSpec
      } = me,
            {
        style
      } = element,
            hideAnimation = animate && me.hideAnimation; // If we get hidden very quickly after a call to show,
      // we must kill the timers which add the realign listeners.

      me.clearTimeout(me.scrollListenerTimeout);
      me.clearTimeout(me.resizeListenerTimeout);
      /**
       * Triggered before a widget is hidden. Return `false` to prevent the action.
       * @preventable
       * @event beforeHide
       * @param {Core.widget.Widget} source The widget being hidden.
       */
      // replaced check for isVisible with _hidden, need to hide a component not yet in view in EventEditor

      if (!me._hidden && me.trigger('beforeHide') !== false) {
        me._hidden = true; // The flag must be cleared on a normal hide.
        // It's set if we hide due to the target being scrolled out of view.

        if (lastAlignSpec) {
          lastAlignSpec.targetOutOfView = null;

          if (lastAlignSpec.monitorIntersection) {
            me.intersectionObserver.takeRecords();
            me.intersectionObserver.unobserve(lastAlignSpec.target);
          }
        } // The changer vetoes the config change and routes here, so we must call this.


        me.onConfigChange({
          name: 'hidden',
          value: true,
          was: false,
          config: me.$meta.configs.hidden
        });

        if (!element) {
          resolve();
          return;
        }

        if (element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(element))) {
          me.revertFocus(true);
        } // Focus exit causes close if autoClose: true, and if closeAction: 'hide'
        // that might destroy us, so exit now if that happens.


        if (me.isDestroyed) {
          resolve();
          return;
        } // Cancel any current hide/show animation


        me.cancelHideShowAnimation();

        if (hideAnimation) {
          const styleProp = Object.keys(hideAnimation)[0],
                animProps = hideAnimation[styleProp]; // Make sure we are not already at the final value of the hide animation (i.e. calling hide() directly after show())

          if (Number(getComputedStyle(me.element)[styleProp]) !== animProps.to) {
            const currentAnimation = me.currentAnimation = {
              hiding: true,
              styleProp,
              resolve
            }; // Element must behave as though it were not there during
            // the animated hide. This means pointer-events:none

            element.classList.add('b-hiding');
            me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

            me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].onTransitionEnd({
              element,
              property: styleProp,
              duration: parseDuration(animProps.duration) + 20,
              handler: () => me.afterHideShowAnimate(currentAnimation),
              thisObj: me
            }); // Setting transition style initial value before showing,
            // then reading the style to ensure transition will animate

            style[styleProp] = animProps.from;
            _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, styleProp);
            style.transition = `${styleProp} ${animProps.duration} ease ${animProps.delay}`;
            style[styleProp] = animProps.to;
          } else {
            element.classList.add('b-hidden');
          }
        } else {
          element.classList.add('b-hidden');
        } // only supply resolve function if not using animation


        me.afterHide(!hideAnimation && resolve, hideAnimation);
      }
    });
  }

  doHideOrRealign({
    target,
    isTrusted
  }) {
    const me = this,
          {
      anchoredTo,
      lastAlignSpec,
      element
    } = me,
          lastTarget = lastAlignSpec === null || lastAlignSpec === void 0 ? void 0 : lastAlignSpec.target,
          position = lastAlignSpec === null || lastAlignSpec === void 0 ? void 0 : lastAlignSpec.position,
          activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me); // If it's a synthesized scroll event (such as from our ResizeMonitor polyfill), ignore it
    // If we're scrolling because a focused textual input field which we contain is being shifted into view,
    // we must not reposition - we'll just move with the document content.
    // event.target might be missing with LockerService enabled

    if (!isTrusted || !target || target.nodeType === Element.DOCUMENT_NODE && element.contains(activeEl) && textInputTypes[activeEl] && window.innerHeight < document.body.offsetHeight) {
      return;
    } // Scroll is inside this widget, or owned by this widget: no action


    if (target.nodeType === Node.ELEMENT_NODE && (element.contains(target) || me.owns(target))) {
      return;
    } // An element that is not document and does not contain the element we are anchored to was scrolled,
    // probably by scroll syncing header / body of Grid or similar. Ignore


    if ((lastTarget === null || lastTarget === void 0 ? void 0 : lastTarget.nodeType) === Node.ELEMENT_NODE && !target.contains(lastTarget) && target.nodeType !== Element.DOCUMENT_NODE) {
      return;
    } // Store current position if we are to hide on scroll below,
    // used to determine if realigning did actually move us and thus should hide


    const xy = me.scrollAction === 'hide' && me.getXY(); // Perform the realignment

    me.realign(); // Might destroy on hide in realign, so check for isDestroyed.

    if (!me.isDestroyed && me.scrollAction === 'hide') {
      const [newX, newY] = me.getXY(),
            moved = newX !== xy[0] || newY !== xy[1]; // If the scroll caused our position to become invalid, and we either don't know what element
      // we're anchored to (or not anchored to one at all), or the element we're anchored to has been
      // affected by the scroll, we must hide.
      // target might be missing with LockerService enabled

      if ((moved || (lastTarget === null || lastTarget === void 0 ? void 0 : lastTarget.$$name) === 'Point' || position) && (!anchoredTo || target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isDescendant(target, anchoredTo))) {
        me.hide();
      }
    }
  }

  afterHide(resolveFn = null, hideAnimation = this.hideAnimation) {
    var _me$parent2, _me$parent2$onChildHi;

    const me = this; // If a drag caused us to lose our anchor, restore it upon hide.

    me._anchor = me._configuredAnchorState; // Remove listeners which are only added during the visible phase.
    // In its own method because it's called on hide and destroy.

    me.removeTransientListeners(); // Postprocessing to be done after the hideAnimation finishes.
    // If there's no animation, we call it immediately.
    // We set the element to be hidden here, after any animation completes.
    // We also remove floating Widgets from the DOM when they are hidden.

    if (!hideAnimation) {
      me.afterHideAnimation();
    }
    /**
     * Triggered after a widget was hidden
     * @event hide
     * @param {Core.widget.Widget} source The widget
     */


    me.trigger('hide'); // Keep any owning container informed about visibility state.
    // It may not be a Container. SubGrid class is still a Widget
    // which contains grid headers.

    (_me$parent2 = me.parent) === null || _me$parent2 === void 0 ? void 0 : (_me$parent2$onChildHi = _me$parent2.onChildHide) === null || _me$parent2$onChildHi === void 0 ? void 0 : _me$parent2$onChildHi.call(_me$parent2);
    resolveFn && resolveFn(); // cannot do resolveFn?.() since resolveFn can be false
  }

  removeTransientListeners() {
    const me = this;
    me.clearTimeout(me.resizeListenerTimeout);
    me.clearTimeout(me.scrollListenerTimeout);

    if (me.documentScrollListener) {
      me.documentScrollListener();
      me.documentScrollListener = false;
    }

    if (me.rootScrollListener) {
      me.rootScrollListener();
      me.rootScrollListener = false;
    }

    if (me.targetResizeListener) {
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(me.lastAlignSpec.target, me.callRealign);
      me.targetResizeListener = false;
    }

    if (me.constrainListeners) {
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(me.lastAlignSpec.constrainTo || window, me.callRealign);
      me.constrainMutationMonitor && me.constrainMutationMonitor.disconnect();
      me.constrainListeners = false;
    }
  }

  afterHideAnimation() {
    const me = this,
          {
      element
    } = me;

    if (me.floating && me.floatRoot.contains(element)) {
      element.remove();
    } else {
      element.classList.add('b-hidden');
    } // Reset anchor to its default colour after hide


    if (me.defaultAnchorBackgroundColor) {
      // Reset to default in case it has been positioned by a coloured header
      me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
    }
  }

  changeHidden(value) {
    const me = this;
    let ret;

    if (me.isConfiguring) {
      ret = Boolean(value);
      me.element.classList[value ? 'add' : 'remove']('b-hidden');
    } else {
      // These methods are async but set _hidden when they get past the before event, so don't set ret and
      // the setter won't set _hidden automatically.
      me.trigger('beforeChangeHidden', {
        hidden: value
      });

      if (value) {
        me.hide();
      } else {
        me.show();
      }
    }

    return ret;
  }
  /**
   * Get id assigned by user (not generated id)
   * @returns {String}
   * @readonly
   * @private
   * @category Misc
   */


  get assignedId() {
    return this.hasGeneratedId ? null : this.id;
  }
  /**
   * Get the owning Widget of this Widget. If this Widget is directly contained, then the containing
   * Widget is returned. If this Widget is floating, the configured `owner` property is returned.
   * If there is a `forElement`, that element's encapsulating Widget is returned.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get owner() {
    return this.parent || this._owner || this.containingWidget;
  }

  get containingWidget() {
    let result = this.parent;

    if (!result) {
      var _this$forElement, _this$element;

      const owningEl = ((_this$forElement = this.forElement) === null || _this$forElement === void 0 ? void 0 : _this$forElement.nodeType) === Element.ELEMENT_NODE ? this.forElement : (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.parentNode;
      result = (owningEl === null || owningEl === void 0 ? void 0 : owningEl.closest('.b-widget')) && Widget.fromElement(owningEl);
    }

    return result;
  }
  /**
   * Get this Widget's previous sibling in the parent {@link Core.widget.Container Container}, or, if not
   * in a Container, the previous sibling widget in the same _parentElement_.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get previousSibling() {
    return this.getSibling(-1);
  }
  /**
   * Get this Widget's next sibling in the parent {@link Core.widget.Container Container}, or, if not
   * in a Container, the next sibling widget in the same _parentElement_.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get nextSibling() {
    return this.getSibling(1);
  }

  getSibling(increment) {
    const me = this,
          {
      parent
    } = me,
          siblings = parent ? parent.childItems : Array.from(me.element.parentElement.querySelectorAll('.b-widget'));
    return parent ? siblings[siblings.indexOf(me) + increment] : Widget.fromElement(siblings[siblings.indexOf(me.element) + increment]);
  }
  /**
   * Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
   * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
   * `true` when passed the desired ancestor.
   * @param {String|Function} selector A Type identifier or selection function.
   * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
   * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
   * @category Widget hierarchy
   */


  up() {
    const {
      owner
    } = this;

    if (owner) {
      return owner.closest(...arguments);
    }
  }
  /**
   * Starts with this Widget, then Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
   * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
   * `true` when passed the desired ancestor.
   * @param {String|Function} selector A Type identifier or selection function.
   * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
   * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
   * @category Widget hierarchy
   */


  closest(selector, deep, limit) {
    const limitType = typeof limit,
          numericLimit = limitType === 'number',
          selectorLimit = limitType === 'string';

    for (let result = this, steps = 1; result; result = result.owner, steps++) {
      if (Widget.widgetMatches(result, selector, deep)) {
        return result;
      }

      if (numericLimit && steps >= limit) {
        return;
      } else if (selectorLimit && Widget.widgetMatches(result, limit, deep)) {
        return;
      } else if (result === limit) {
        return;
      }
    }
  }
  /**
   * Returns `true` if this Widget owns the passed Element, Event or Widget. This is based on the widget hierarchy,
   * not DOM containment. So an element in a `Combo`'s dropdown list will be owned by the `Combo`.
   * @param {HTMLElement|Event|Core.widget.Widget} target The element event or Widget to test for being
   * within the ownership tree of this Widget.
   * @category Widget hierarchy
   */


  owns(target) {
    if (target) {
      // Passed an event, grab its target
      if (target.eventPhase) {
        target = target.target;
      } // We were passed an HTMLElement


      if (target.nodeType === Element.ELEMENT_NODE) {
        if (this.element.contains(target)) {
          return true;
        }

        target = Widget.fromElement(target);
      }

      while (target) {
        if (target === this) {
          return true;
        }

        target = target.owner;
      }
    }

    return false;
  }
  /**
   * Iterate over all ancestors of this widget.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   * @param {Function} fn Function to execute for all ancestors. Terminate iteration by returning `false`.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   * @category Widget hierarchy
   */


  eachAncestor(fn) {
    let ancestor = this.owner;

    while (ancestor) {
      if (fn(ancestor) === false) {
        return false;
      }

      ancestor = ancestor.owner;
    }

    return true;
  }

  changeMonitorResize(monitorResize, oldMonitorResize) {
    // They are mutually exclusive. scaleToFitWidth disables monitorResize
    const result = this.scaleToFitWidth ? false : Boolean(monitorResize); // null and undefined both mean false. Avoid going through the updater if no change.

    if (result !== Boolean(oldMonitorResize)) {
      return result;
    }
  }

  updateMonitorResize(monitorResize) {
    const me = this;

    if (!hasOwnProperty.call(me, 'onElementResize')) {
      me.onElementResize = me.onElementResize.bind(me);
    }

    _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"][monitorResize ? 'addResizeListener' : 'removeResizeListener'](me.element, me.onElementResize);
  }

  changeReadOnly(readOnly) {
    readOnly = Boolean(readOnly); // It starts as undefined, so if false is passed, that's a no-change.

    if (Boolean(this._readOnly) !== readOnly) {
      return readOnly;
    }
  }

  updateReadOnly(readOnly) {
    var _this$element2;

    // Can be called from the element initialization because of the way Panel is set up.
    // tbar and bbar are instantiated, and their elements added to the gathered element
    // config object, but that can have consequences which can lead here.
    // eslint-disable-next-line no-unused-expressions
    (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : _this$element2.classList[readOnly ? 'add' : 'remove']('b-readonly'); // Do not update  children at configure time.
    // Container will sync its items.

    if (!this.isConfiguring) {
      // Implemented at this level because Widgets can own a descendant tree without being
      // a Container. For example Combos own a ChipView and a List. Buttons own a Menu etc.
      this.eachWidget(widget => {
        if (!('_originalReadOnly' in widget)) {
          // Store initial readOnly/disabled value.
          // the config getter copies the properties in a loop
          // so execute once and cache the value.
          widget._originalReadOnly = widget.config.readOnly || false;
        } // Set if truthy, otherwise reset to initial value


        widget.readOnly = readOnly || widget._originalReadOnly;
      }, false);
      /**
       * Fired when a Widget's read only state is toggled
       * @event readOnly
       * @param {Boolean} readOnly Read only or not
       */

      this.trigger('readOnly', {
        readOnly
      });
    }
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   * @param {Function} fn A function to execute upon each descendant widget.
   * Iteration terminates if this function returns `false`.
   * @param {Core.widget.Widget} fn.widget The current descendant widget.
   * @param {Object} fn.control An object containing recursion control options.
   * @param {Boolean} fn.control.down A copy of the `deep` parameter. This can be adjusted by `fn` to decide which
   * widgets should be recursed. This value will always be the value of `deep` on entry and the value of `control.down`
   * upon return determines the recursion into the current widget.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   * @category Widget hierarchy
   */


  eachWidget(fn, deep = true) {
    const widgets = this.childItems,
          length = (widgets === null || widgets === void 0 ? void 0 : widgets.length) || 0,
          control = {};

    for (let i = 0; i < length; i++) {
      const widget = widgets[i];
      control.down = deep; // Abort if a call returns false

      if (fn(widget, control) === false) {
        return false;
      }

      if (control.down && widget.eachWidget) {
        // Abort if a deep call returns false
        if (widget.eachWidget(fn, deep) === false) {
          return false;
        }
      }
    }

    return true;
  }
  /**
   * Returns an array of all descendant widgets which the passed
   * filter function returns `true` for.
   * @param {Function} filter A function which, when passed a widget,
   * returns `true` to include the widget in the results.
   * @returns {Core.widget.Widget[]} All matching descendant widgets.
   * @category Widget hierarchy
   */


  queryAll(filter) {
    const result = [];
    this.eachWidget(w => {
      if (filter(w)) {
        result.push(w);
      }
    });
    return result;
  }
  /**
   * Returns the first descendant widgets which the passed
   * filter function returns `true` for.
   * @param {Function} filter A function which, when passed a widget,
   * returns `true` to return the widget as the sole result.
   * @returns {Core.widget.Widget} The first matching descendant widget.
   * @category Widget hierarchy
   */


  query(filter) {
    let result = null;
    this.eachWidget(w => {
      if (filter(w)) {
        result = w;
        return false;
      }
    });
    return result;
  }
  /**
   * Get a widget by ref, starts on self and traverses up the owner hierarchy checking `widgetMap` at each level.
   * Not checking the top level widgetMap right away to have some acceptance for duplicate refs.
   * @param {String} ref ref to find
   * @returns {Core.widget.Widget}
   * @internal
   * @category Widget hierarchy
   */


  getWidgetByRef(ref) {
    var _this$widgetMap, _this$owner;

    if (ref instanceof Widget) {
      return ref;
    }

    return (this === null || this === void 0 ? void 0 : (_this$widgetMap = this.widgetMap) === null || _this$widgetMap === void 0 ? void 0 : _this$widgetMap[ref]) || (this === null || this === void 0 ? void 0 : (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.getWidgetByRef(ref));
  }

  onFocusIn(e) {
    const me = this,
          {
      element
    } = me;
    me.containsFocus = true;
    me.focusInEvent = e;
    element.classList.add('b-contains-focus');

    if (element.contains(e._target) && me.onInternalKeyDown && !me.keyDownListenerRemover) {
      me.keyDownListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
        element,
        keydown: 'onInternalKeyDown',
        thisObj: me
      });
    }
    /**
     * Fired when focus enters this Widget.
     * @event focusIn
     * @param {Core.widget.Widget} source - This Widget
     * @param {HTMLElement} fromElement The element which lost focus.
     * @param {HTMLElement} toElement The element which gained focus.
     * @param {Core.widget.Widget} fromWidget The widget which lost focus.
     * @param {Core.widget.Widget} toWidget The widget which gained focus.
     * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
     */


    me.trigger('focusin', e);
  }

  onFocusOut(e) {
    const me = this;

    if (me.keyDownListenerRemover) {
      me.keyDownListenerRemover();
      me.keyDownListenerRemover = null;
    }

    if (!me.isDestroyed) {
      // Focus to nowhere, focus a close relation
      if (!e.relatedTarget) {
        me.revertFocus(!me.isVisible);
      }

      me.containsFocus = false;
      me.element.classList.remove('b-contains-focus');
      /**
       * Fired when focus exits this Widget's ownership tree. This is different from a `blur` event.
       * focus moving from within this Widget's ownership tree, even if there are floating widgets
       * will not trigger this event. This is when focus exits this widget completely.
       * @event focusOut
       * @param {Core.widget.Widget} source - This Widget
       * @param {HTMLElement} fromElement The element which lost focus.
       * @param {HTMLElement} toElement The element which gained focus.
       * @param {Core.widget.Widget} fromWidget The widget which lost focus.
       * @param {Core.widget.Widget} toWidget The widget which gained focus.
       * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
       */

      me.trigger('focusout', e);
    }
  }
  /**
   * Returns a function that will set the focus (`document.activeElement`) to the most consistent element possible
   * based on the focus state at the time this method was called. Derived classes can implement `captureFocusItem()`
   * to refine this process to include logical items (e.g., a grid cell) that would be more stable than DOM element
   * references.
   *
   * If this widget does not contain the focus, the returned function will do nothing.
   * @returns {Function}
   * @internal
   */


  captureFocus() {
    const me = this,
          activeElementWas = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me),
          restore = me.contains(activeElementWas) && me.captureFocusItem(activeElementWas);
    return scrollIntoView => {
      if (restore && !me.isDestroying) {
        const activeElementNow = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me);

        if (activeElementNow !== activeElementWas) {
          restore(scrollIntoView);
        }
      }
    };
  }
  /**
   * This method is called by `captureFocus()` when this widget contains the focus and it returns a function that
   * restores the focus to the correct internal element. The returned function is only called if the current
   * `document.activeElement` is different from the passed `activeElement`.
   *
   * This method can be replaced by derived classes to capture stable identifiers for the currently focused, logical
   * item (for example, a cell of a grid).
   *
   * @param {HTMLElement} activeElement The current `document.activeElement`.
   * @returns {Function} Returns a function that accepts a boolean argument. Defaults to `true`, `false` attempts to
   * focus without scrolling.
   * @internal
   */


  captureFocusItem(activeElement) {
    return (scrollIntoView = true) => {
      if (this.contains(activeElement)) {
        scrollIntoView ? activeElement.focus() : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(activeElement);
      }
    };
  }
  /**
   * Returns `true` if this widget is or contains the specified element or widget.
   * @param {HTMLElement|Core.widget.Widget} elementOrWidget The element or widget
   * @param {Boolean} [strict] Pass `true` to test for strict containment (if `elementOrWidget` is this widget, the
   * return value will be `false`).
   * @returns {Boolean}
   */


  contains(elementOrWidget, strict) {
    const {
      element
    } = this;

    if (elementOrWidget && element) {
      if (elementOrWidget.isWidget) {
        elementOrWidget = elementOrWidget.element;
      } // el.contains(el) === true


      return element.contains(elementOrWidget) && (!strict || element !== elementOrWidget);
    }
  }
  /**
   * If this Widget contains focus, focus is reverted to the source from which it entered if possible,
   * or to a close relative if not.
   * @param {Boolean} [force] Pass as `true` to move focus to the previously focused item, or the
   * closest possible relative even if this widget does not contain focus.
   */


  revertFocus(force) {
    var _me$focusInEvent, _target;

    const me = this,
          activeElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me);
    let target = (_me$focusInEvent = me.focusInEvent) === null || _me$focusInEvent === void 0 ? void 0 : _me$focusInEvent.relatedTarget;

    if (force || me.containsFocus && ((_target = target) === null || _target === void 0 ? void 0 : _target.nodeType) === Element.ELEMENT_NODE && me.element.contains(activeElement)) {
      if (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target)) {
        target = me.getFocusRevertTarget();
      }

      if (target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target)) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(target);
      } else {
        // If we could not find a suitable target to receive focus, we still need to not be focused. Oddly,
        // one cannot do "document.body.focus()" but explicitly calling blur() has that effect. If we do not
        // do this, and we retain the focus, we can have issue w/closeAction=destroy which can cause the blur
        // in afterHideAnimation which then causes that element.remove() to throw DOM exceptions.
        activeElement === null || activeElement === void 0 ? void 0 : activeElement.blur();
      }
    }
  }
  /**
   * This method finds a close sibling (or parent, or parent's sibling etc recursively) to which focus
   * can be directed in the case of revertFocus not having a focusable element from our focusInEvent.
   *
   * This can happen when the "from" component is destroyed or hidden. We should endeavour to prevent
   * focus escaping to `document.body` for accessibility and ease of use, and keep focus close.
   * @internal
   */


  getFocusRevertTarget() {
    const me = this,
          {
      owner,
      focusInEvent
    } = me,
          searchDirection = focusInEvent ? focusInEvent.backwards ? 1 : -1 : -1;
    let target = focusInEvent && focusInEvent.relatedTarget;
    const toComponent = target && Widget.fromElement(target); // If the from element is now not focusable, for example an Editor which hid
    // itself on focus leave, then we have to find a sibling/parent/parent's sibling
    // to take focus. Anything is better than flipping to document.body.

    if (owner && !owner.isDestroyed && (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target) || toComponent && !toComponent.isFocusable)) {
      target = null; // If this widget can have siblings, then find the closest
      // (in the direction focus arrived from) focusable sibling.

      if (owner.eachWidget) {
        const siblings = []; // Collect focusable siblings.
        // With this included so we can find ourselves.

        owner.eachWidget(w => {
          if (w === me || w.isFocusable) {
            siblings.push(w);
          }
        }, false);

        if (siblings.length > 1) {
          const myIndex = siblings.indexOf(me);
          target = siblings[myIndex + searchDirection] || siblings[myIndex - searchDirection];
        }
      } // No focusable siblings found to take focus, try the owner


      if (!target && owner.isFocusable) {
        target = owner;
      } // If non of the above found any related focusable widget,
      // Go through these steps for the owner.


      target = target ? target.focusElement : owner.getFocusRevertTarget();
    }

    return target;
  }
  /**
   * Returns a `DomClassList` computed from the `topMostBase` (e.g., `Widget` or `Panel`) with the given `suffix`
   * appended to each `widgetClass`.
   * @param {Function} topMostBase The top-most base class constructor at which to start gathering classes.
   * @param {String} [suffix] An optional suffix to apply to all widget classes.
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  getStaticWidgetClasses(topMostBase, suffix) {
    const classList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"](),
          hierarchy = this.$meta.hierarchy;
    let cls, i, name, widgetClass, widgetClassProperty;

    for (i = hierarchy.indexOf(topMostBase); i < hierarchy.length; ++i) {
      var _widgetClassProperty;

      cls = hierarchy[i];
      widgetClassProperty = Reflect.getOwnPropertyDescriptor(cls.prototype, 'widgetClass'); // If the Class has its own get widgetClass, call it upon this instance.

      if ((_widgetClassProperty = widgetClassProperty) !== null && _widgetClassProperty !== void 0 && _widgetClassProperty.get) {
        widgetClass = widgetClassProperty.get.call(this);
      } else {
        // All built in widgets should define $name to be safer from minification/obfuscation, but user
        // created might not so fall back to actual name. UMD files use a _$name property
        // which the Base $$name getter uses as a fallback.
        name = hasOwnProperty.call(cls, '$$name') || hasOwnProperty.call(cls, '$name') || hasOwnProperty.call(cls, '_$name') ? cls.$$name : cls.name; // Throw error in case of an obfuscated name or an autogenerated name.
        // These should never be released without a meaningful $name getter.

        if (name.length < 3 || name.includes('$')) {
          // class.$name comes from parent API class which has it
          console.warn(`Class "${name}" extending "${cls.$name}" should have "$name" static getter with no less than 3 chars.`);
        }

        widgetClass = `b-${name.toLowerCase()}`;
      }

      if (widgetClass) {
        classList.add(suffix ? widgetClass + suffix : widgetClass);
      }
    }

    return classList;
  }

  get rootUiClass() {
    return Widget;
  }
  /**
   * Returns the `DomClassList` for this widget's class. This object should not be mutated.
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  get staticClassList() {
    const {
      $meta: meta
    } = this;
    let classList = meta.staticClassList;

    if (!classList) {
      // Compute the class part of the widgetList just once per class (cache it on the $meta object):
      meta.staticClassList = classList = this.getStaticWidgetClasses(Widget); // TODO this should probably be only for outer-most widgets

      _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice && classList.add('b-touch');
    }

    return classList;
  }
  /**
   * Returns the cross-product of the classes `staticClassList` with each `ui` as an array of strings.
   *
   * For example, a Combo with a `ui: 'foo bar'` would produce:
   *
   *      [
   *          'b-widget-foo', 'b-field-foo', 'b-textfield-foo', 'b-pickerfield-foo', 'b-combo-foo',
   *          'b-widget-bar', 'b-field-bar', 'b-textfield-bar', 'b-pickerfield-bar', 'b-combo-bar'
   *      ]
   *
   * @returns {String[]}
   * @internal
   * @category DOM
   */


  get uiClasses() {
    // our result is maintained by updateUi so ensure the ui config has been evaluated:
    this.getConfig('ui');
    return this._uiClasses;
  }
  /**
   * Returns the cross-product of the classes `staticClassList` with each `ui` as a `DomClassList` instance.
   *
   * For example, a Combo with a `ui: 'foo bar'` would produce:
   *
   * ```javascript
   *      new DomClassList({
   *          'b-field-ui-foo'       : 1,
   *          'b-textfield-ui-foo'   : 1,
   *          'b-pickerfield-ui-foo' : 1,
   *          'b-combo-ui-foo'       : 1,
   *
   *          'b-field-ui-bar'       : 1,
   *          'b-textfield-ui-bar'   : 1,
   *          'b-pickerfield-ui-bar' : 1,
   *          'b-combo-ui-bar'       : 1
   *      });
   * ```
   *
   * A Panel with a `ui: 'foo bar'` would produce:
   *
   * ```javascript
   *      new DomClassList({
   *          'b-panel-ui-foo' : 1,
   *          'b-panel-ui-bar' : 1
   *      });
   * ```
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  get uiClassList() {
    // our result is maintained by updateUi so ensure the ui config has been evaluated:
    this.getConfig('ui');
    return this._uiClassList;
  }
  /**
   * Used by the Widget class internally to create CSS classes based on this Widget's
   * inheritance chain to allow styling from each level to apply.
   *
   * For example Combo would yield `"["b-widget", "b-field", "b-textfield", "b-pickerfield", "b-combo"]"`
   *
   * May be implemented in subclasses to add or remove classes from the super.widgetClassList
   * @returns {String[]} The css class list named using the class name.
   * @internal
   * @category DOM
   */


  get widgetClassList() {
    const me = this,
          {
      cls,
      defaultCls,
      uiClasses
    } = me;
    let {
      staticClassList
    } = me,
        classList;

    if (defaultCls || cls) {
      // clone the class-level classList before instance stuff goes on...
      staticClassList = staticClassList.clone();
      defaultCls && staticClassList.assign(defaultCls); // note: these can be falsy keys

      cls && staticClassList.assign(cls);
    }

    classList = staticClassList.values; // a new array of truthy keys...

    uiClasses && classList.push(...uiClasses);
    me.floating && classList.push('b-floating');

    if (me.collapsify === 'hide') {
      classList.push('b-collapsify-hide');
    }

    return classList;
  }

  changeCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeContentElementCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeHtmlCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeDefaultCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls,
    /* returnEmpty */
    true);
  }

  changeUi(ui) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(ui);
  }

  updateUi(ui) {
    var _uiClassList;

    let uiClassList = null,
        cls,
        suffix;

    if (ui) {
      const staticClassList = this.getStaticWidgetClasses(this.rootUiClass);

      for (suffix in ui) {
        if (ui[suffix]) {
          for (cls in staticClassList) {
            if (staticClassList[cls]) {
              (uiClassList || (uiClassList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"]()))[`${cls}-ui-${suffix}`] = 1;
            }
          }
        }
      }
    }

    this._uiClasses = (_uiClassList = uiClassList) === null || _uiClassList === void 0 ? void 0 : _uiClassList.values; // an array of each value

    this._uiClassList = uiClassList;
  } //endregion
  //region Cache

  /**
   * Gets dom elements in the view. Caches the results for faster future calls.
   * @param {String} query CSS selector
   * @param {Boolean} children true to fetch multiple elements
   * @param {HTMLElement} element Element to use as root for the query, defaults to the views outermost element
   * @returns {HTMLElement|HTMLElement[]|null} A single element or an array of elements (if parameter children is set to true)
   * @internal
   * @category DOM
   */


  fromCache(query, children = false, element = this.element) {
    if (!element) return null;
    const me = this;

    if (!me.cache[query]) {
      me.cache[query] = children ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].children(element, query) : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].down(element, query);
    }

    return me.cache[query];
  }
  /**
   * Clear caches, forces all calls to fromCache to requery dom. Called on render/rerender.
   * @internal
   * @category DOM
   */


  emptyCache() {
    this.cache = {};
  } //endregion
  //region Mask


  changeMasked(mask, maskInstance) {
    if (mask === true || mask === '') {
      // empty string don't render well, so promote it to an &nbsp; as well
      mask = '\xA0'; // nbsp
    }

    if (maskInstance) {
      if (typeof mask === 'string') {
        maskInstance.text = mask;
        mask = maskInstance;
      } else if (mask) {
        maskInstance.setConfig(mask);
        mask = maskInstance;
      } else {
        maskInstance.destroy();
      }
    } else if (mask) {
      const Mask = Widget.resolveType('mask');
      mask = Mask.mergeConfigs(this.maskDefaults, mask);
      mask.owner = this;
      mask = Mask.mask(mask);
    }

    return mask || null;
  }

  onMaskAutoClose(mask) {
    if (mask.isDestroyed && mask === this.masked) {
      this.masked = null;
    }
  }
  /**
   * Mask the widget, showing the specified message
   * @param {String|Object} msg Mask message (or a {@link Core.widget.Mask} config object
   * @returns {Core.widget.Mask}
   */


  mask(msg) {
    this.masked = msg;
    return this.masked;
  }
  /**
   * Unmask the widget
   */


  unmask() {
    this.masked = null;
  } //endregion
  //region Monitor resize


  onInternalResize(element, width, height, oldWidth, oldHeight) {
    this._width = element.offsetWidth;
    this._height = element.offsetHeight;
  }

  onElementResize(resizedElement) {
    const me = this,
          {
      element
    } = me,
          oldWidth = me._width,
          oldHeight = me._height,
          newWidth = element.offsetWidth,
          newHeight = element.offsetHeight;

    if (me.floating) {
      me.onFloatingWidgetResize(...arguments);
    }

    if (!me.suspendResizeMonitor && (oldWidth !== newWidth || oldHeight !== newHeight)) {
      me.onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight);
      /**
       * Fired when the encapsulating element of a Widget resizes *only when {@link #config-monitorResize} is `true`*.
       * @event resize
       * @param {Core.widget.Widget} source - This Widget
       * @param {Number} width The new width
       * @param {Number} height The new height
       * @param {Number} oldWidth The old width
       * @param {Number} oldHeight The old height
       */

      me.trigger('resize', {
        width: newWidth,
        height: newHeight,
        oldWidth,
        oldHeight
      });
    }
  }

  onFloatingWidgetResize(resizedElement, lastRect, myRect) {
    const me = this,
          {
      lastAlignSpec,
      constrainTo
    } = me; // If this Popup changes size while we are aligned and we are aligned to
    // a target (not a position), then we might need to realign.

    if (me.isVisible && lastAlignSpec && lastAlignSpec.target) {
      const heightChange = !lastRect || myRect.height !== lastRect.height,
            widthChange = !lastRect || myRect.width !== lastRect.width,
            failsConstraint = constrainTo && !_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(constrainTo).contains(_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(me.element, null, true)); // Only realign if:
      // the height has changed and we are not aligned below, or
      // the width has changed and we are not aligned to the right.

      if (heightChange && lastAlignSpec.zone !== 2 || widthChange && lastAlignSpec.zone !== 1 || failsConstraint) {
        // Must move to next AF because in Chrome, the resize monitor might fire
        // before the element is painted and the anchor color matching
        // scheme cannot work in that case.
        me.requestAnimationFrame(() => me.realign());
      }
    }
  }

  updateScale() {
    const me = this,
          element = me.element,
          parentElement = element.parentElement; // this could be placed elsewhere but want to keep it contained to not spam other code,
    // since this is a very specific use case in our docs

    if (!me.configuredWidth) {
      me.configuredWidth = me.width;
    } // TODO: handle autoHeight, but seems it assigns height to late with current setup
    // We are scaling to fit inside the width, so ensure that we are not the cause of a scrollbar
    // in our current, unscaled state by hiding while we measure the parent's offsetWidth which
    // we are going to scale to.


    element.style.display = 'none';
    const rect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].client(parentElement),
          scale = rect.width / me.configuredWidth,
          adjustedScale = me.scale = me.allowGrowWidth ? Math.min(scale, 1) : scale;
    element.style.transform = `scale(${adjustedScale})`;
    element.style.transformOrigin = 'top left';
    element.style.display = '';

    if (me.allowGrowWidth && scale > 1) {
      // increase width
      me.width = me.configuredWidth * scale;
    }
  }

  onParentElementResize(event) {
    this.updateScale();
  } //endregion

  /**
   * Returns a `TRBL` array of values parse from the passed specification. This can be used to parse`
   * a value list for `margin` or `padding` or `border-width` etc - any CSS value which takes a `TRBL` value.
   * @param {Number|String|String[]} values The `TRBL` value
   * @param {String} [units=px] The units to add to values which are specified as numeric.
   * @internal
   */


  parseTRBL(values, units = 'px') {
    values = values || 0;

    if (typeof values === 'number') {
      return [`${values}${units}`, `${values}${units}`, `${values}${units}`, `${values}${units}`];
    }

    const parts = values.split(' '),
          len = parts.length;

    if (len === 1) {
      parts[1] = parts[2] = parts[3] = parts[0];
    } else if (len === 2) {
      parts[2] = parts[0];
      parts[3] = parts[1];
    } else if (len === 3) {
      parts[3] = parts[1];
    }

    return [isFinite(parts[0]) ? `${parts[0]}${units}` : parts[0], isFinite(parts[1]) ? `${parts[1]}${units}` : parts[2], isFinite(parts[2]) ? `${parts[2]}${units}` : parts[3], isFinite(parts[3]) ? `${parts[3]}${units}` : parts[4]];
  } // Returns root node for this widget, either a document or a shadowRoot


  get documentRoot() {
    var _this$owner2;

    return ((_this$owner2 = this.owner) === null || _this$owner2 === void 0 ? void 0 : _this$owner2.documentRoot) || this.element.getRootNode();
  } // Returns top most DOM element of the visible DOM tree for this widget element, either document.body or a shadowRoot


  get rootElement() {
    const me = this;

    if (!me._rootElement) {
      var _me$owner;

      let root = ((_me$owner = me.owner) === null || _me$owner === void 0 ? void 0 : _me$owner.rootElement) || me.forElement instanceof HTMLElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(me.forElement); // Check element, we may be in the DOM just not visible

      if (!root) {
        const elRoot = me.element instanceof HTMLElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(me.element); // Make sure we got a proper root

        if (elRoot === document.body || elRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
          root = elRoot;
        }
      }

      if (!root) {
        root = document.body;
      }

      me._rootElement = root;
    }

    return me._rootElement;
  }

  get floatRoot() {
    var _me$owner2;

    const me = this,
          rootElement = me.rootElement || ((_me$owner2 = me.owner) === null || _me$owner2 === void 0 ? void 0 : _me$owner2.rootElement);
    let {
      floatRoot
    } = rootElement;

    if (!floatRoot) {
      var _DomHelper$themeInfo;

      const {
        outerCls
      } = Widget,
            themeName = (_DomHelper$themeInfo = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].themeInfo) === null || _DomHelper$themeInfo === void 0 ? void 0 : _DomHelper$themeInfo.name;

      if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isValidFloatRootParent(rootElement)) {
        throw new Error('Attaching float root to wrong root');
      } // When outside of our examples, the body element doesn't get the theme class.
      // The floatRoot must carry it for floating items to be themed.


      if (themeName) {
        outerCls.push(`b-theme-${themeName.toLowerCase()}`);
      }

      floatRoot = rootElement.floatRoot = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        className: `b-float-root ${outerCls.join(' ')}`,
        parent: rootElement
      });
      floatRoots.push(floatRoot); // Make float root immune to keyboard-caused size changes

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAndroid) {
        floatRoot.style.height = `${screen.height}px`;
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
          element: window,
          orientationchange: () => floatRoot.style.height = `${screen.height}px`
        });
      } // Resize float root upon keyboard-caused visual viewport size change
      // https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API


      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice && window.visualViewport) {
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
          element: window.visualViewport,
          resize: ({
            target: viewport
          }) => floatRoot.style.height = `${viewport.height}px`
        });
      } // Keep floatRoot up to date with the theme


      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].on({
        theme: ({
          theme,
          prev
        }) => {
          // TODO handle for all roots
          floatRoot.classList.add(`b-theme-${theme.toLowerCase()}`);
          floatRoot.classList.remove(`b-theme-${prev.toLowerCase()}`);
        }
      });
    } // Angular might shuffle elements around so we have to ensure floatRoot is a child of the right parent
    else if (!rootElement.contains(floatRoot)) {
      // Reattach floatRoot if it was detached
      rootElement.appendChild(floatRoot);
    }

    return floatRoot;
  }

  get floatRootMaxZIndex() {
    let max = 1;
    Array.from(this.floatRoot.children).forEach(child => {
      const zIndex = parseInt(getComputedStyle(child).zIndex || 0, 10);

      if (zIndex > max) {
        max = zIndex;
      }
    });
    return max;
  }

  static resetFloatRootScroll() {
    floatRoots.forEach(floatRoot => floatRoot.scrollTop = floatRoot.scrollLeft = 0);
  }

  static get floatRoots() {
    return floatRoots;
  }

  static removeFloatRoot(floatRoot) {
    floatRoots.splice(floatRoots.indexOf(floatRoot), 1);
  } // CSS classes describing outer-most Widgets to provide styling / behavioral CSS style rules


  static get outerCls() {
    const result = ['b-outer'];

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice) {
      result.push('b-touch-events');
    }

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) {
      result.push('b-visible-scrollbar');
    } else {
      result.push('b-overlay-scrollbar');
    }

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isChrome) {
      result.push('b-chrome');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari) {
      result.push('b-safari');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFirefox) {
      result.push('b-firefox');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      result.push('b-ie');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge) {
      result.push('b-edge');
    } // So that we don't get the polyfill styles applied if we have ResizeMonitor available.
    // The polyfill styles can break certain elements styling.


    if (!window.ResizeObserver) {
      result.push('b-no-resizeobserver');
    }

    return result;
  }

  get isAnimating() {
    return this._isAnimatingCounter > 0;
  }

  set isAnimating(value) {
    const me = this;

    if (me._isAnimatingCounter === 0 && value) {
      me.element.classList.add('b-animating');
      me.trigger('animationStart');
    } else if (me._isAnimatingCounter === 1 && !value) {
      me.element.classList.remove('b-animating');
      me.trigger('animationEnd');
    }

    me._isAnimatingCounter += value ? 1 : -1;
    me._isAnimatingCounter = Math.max(0, me._isAnimatingCounter);
  } // Waits until all transitions are completed


  async waitForAnimations() {
    if (this.isAnimating) {
      await this.await('animationend', {
        checkLog: false
      });
    }
  }
  /**
   * Analogous to document.querySelector, finds the first Bryntum widget matching the passed
   * selector. Right now, only class name (lowercased) selector strings, or
   * a filter function which returns `true` for required object are allowed:
   * ```
   * bryntum.query('grid').destroy();
   * ```
   * @param {String|Function} selector A lowercased class name, or a filter function.
   * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
   *   example 'widget' would then find a Grid
   * @return {Core.widget.Widget} The first matched widget if any.
   * @category Widget hierarchy
   */


  static query(selector, deep = false) {
    const {
      idMap
    } = Widget.identifiable;

    for (const id in idMap) {
      if (Widget.widgetMatches(idMap[id], selector, deep)) {
        return idMap[id];
      }
    }

    return null;
  }
  /**
   * Analogous to document.querySelectorAll, finds all Bryntum widgets matching the passed
   * selector. Right now, only registered widget `type` strings, or a filter function which
   * returns `true` for required object are allowed:
   * ```
   * let allFields = bryntum.queryAll('field', true);
   * ```
   * @param {String|Function} selector A lowercased class name, or a filter function.
   * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
   *   example 'widget' would then find a Grid
   * @return {Core.widget.Widget[]} The first matched widgets if any - an empty array will be returned
   * if no matches are found.
   * @category Widget hierarchy
   */


  static queryAll(selector, deep = false) {
    const {
      idMap
    } = Widget.identifiable,
          result = [];

    for (const id in idMap) {
      if (Widget.widgetMatches(idMap[id], selector, deep)) {
        result.push(idMap[id]);
      }
    }

    return result;
  }
  /**
   * Returns the Widget which owns the passed element (or event).
   * @param {HTMLElement|Event} element The element or event to start from
   * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
   * class name. Or a filter function which returns `true` for the required Widget.
   * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
   * match of the type parameter, or the element to stop at.
   * @return {Core.widget.Widget} The found Widget or null.
   * @category Misc
   */


  static fromElement(element, type, limit) {
    const typeOfType = typeof type; // Check if an event was passed

    if (element && !element.nodeType) {
      element = element.target;
    }

    if (typeOfType === 'number' || type && type.nodeType === Element.ELEMENT_NODE) {
      limit = type;
      type = null;
    }

    let target = element,
        depth = 0,
        topmost,
        cmpId,
        cmp;

    if (typeof limit !== 'number') {
      topmost = limit;
      limit = Number.MAX_VALUE;
    }

    if (typeOfType === 'string') {
      type = type.toLowerCase();
    }

    while (target && target.nodeType === Element.ELEMENT_NODE && depth < limit && target !== topmost) {
      cmpId = target.dataset && target.dataset.ownerCmp || target.id;

      if (cmpId) {
        cmp = Widget.getById(cmpId);

        if (cmp) {
          if (type) {
            if (typeOfType === 'function') {
              if (type(cmp)) {
                return cmp;
              }
            } else if (Widget.widgetMatches(cmp, type, true)) {
              return cmp;
            }
          } else {
            return cmp;
          }
        } // Increment depth on every *Widget* found


        depth++;
      }

      target = target.parentNode;
    }

    return null;
  } // NOTE: Not named `triggerChange` to not conflict with existing fn on Field

  /**
   * Triggers a 'change' event with the supplied params. After triggering it also calls `onFieldChange()` on each
   * ancestor the implements that function, supplying the same set of params.
   * @param {Object} params Event params, used both for triggering and notifying ancestors
   * @param {Boolean} [trigger] `false` to not trigger, only notifying ancestors
   * @internal
   */


  triggerFieldChange(params, trigger = true) {
    if (trigger) {
      this.trigger('change', params);
    }

    this.eachAncestor(ancestor => {
      if (ancestor.onFieldChange) {
        ancestor.onFieldChange(params);
      } // Stop going up when reaching an ancestor that isolates its fields


      if (ancestor.isolateFields) {
        return false;
      }
    });
  } // Sets up the focus listeners, one set for every document root (shadow root or document)


  setupFocusListeners() {
    // Listen to focus events on shadow root to handle focus inside the shadow dom
    _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].setupFocusListenersOnce(this._rootElement, _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
  }

  static widgetMatches(candidate, selector, deep) {
    if (selector === '*') {
      return true;
    }

    if (typeof selector === 'function') {
      return selector(candidate);
    }

    return Widget.isType(candidate, selector, deep);
  }
  /**
   * Attached a tooltip to the specified element.
   * @example
   * Widget.attachTooltip(element, {
   *   text: 'Useful information goes here'
   * });
   * @param {HTMLElement} element Element to attach tooltip for
   * @param {Object|String} configOrText Tooltip config or tooltip string, see example and source
   * @returns {HTMLElement}
   * @category Misc
   */


  static attachTooltip(element, configOrText) {
    if (typeof configOrText === 'string') configOrText = {
      html: configOrText
    }; // TODO: refactor this
    // eslint-disable-next-line no-new

    Widget.create(Object.assign({
      forElement: element
    }, configOrText), 'tooltip');
    return element;
  }

}
const proto = Widget.prototype;
['compose', 'domSyncCallback'].forEach(fn => proto[fn].$nullFn = true); // Register this widget type with its Factory

Widget.initClass();
Widget.register('mask', _Mask_js__WEBPACK_IMPORTED_MODULE_22__["default"]); // These low level classes must not import Widget because that would cause circularity.
// Instead Widget injects a reference to itself into them.

_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].Widget = Widget;
_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].Widget = Widget; // We use the same map to track instances by ID

_Mask_js__WEBPACK_IMPORTED_MODULE_22__["default"].identifiable.idMap = Widget.identifiable.idMap; // Simplify querying widgets by exposing fns in bryntum ns

Object.assign(window.bryntum || (window.bryntum = {}), {
  get: Widget.getById.bind(Widget),
  query: Widget.query,
  queryAll: Widget.queryAll,
  fromElement: Widget.fromElement
});
Widget._$name = 'Widget';

/***/ }),

/***/ "./lib/Core/widget/base/UndoRedoBase.js":
/*!**********************************************!*\
  !*** ./lib/Core/widget/base/UndoRedoBase.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UndoRedoBase; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';


/**
 * @module Core/widget/base/UndoRedoBase
 */

/**
 * Abstract base class used by UndoRedo widgets in Scheduler and TaskBoard.
 *
 * @extends Core/widget/Container
 * @abstract
 */

class UndoRedoBase extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'UndoRedoBase';
  }

  static get type() {
    return 'undoredobase';
  }

  static get configurable() {
    return {
      // Documented on subclasses
      project: null,
      stm: null,

      /**
       * Configure as `true` to show "Undo" and "Redo" as button texts. The buttons always have a tooltip
       * as a hint to the user as to their purpose.
       * @config {Boolean}
       */
      text: null,

      /**
       * Button color for the undo and redo buttons. See {@link Core.widget.Button#config-color}.
       * @config {String}
       */
      color: null,

      /**
       * Configure as `true` to show "0" badge on the undo and redo buttons when they have no actions
       * left to perform. By default when there are no actions, no badge is displayed.
       * @config {Boolean}
       */
      showZeroActionBadge: null,
      cls: 'b-undo-controls b-toolbar',
      layoutStyle: {
        alignItems: 'stretch',
        flexFlow: 'row nowrap',
        overflow: 'visible'
      },
      items: {
        undoBtn: {
          type: 'button',
          icon: 'b-icon-undo',
          tooltip: 'L{UndoRedo.UndoLastAction}',
          onAction: 'up.onUndo' // 'up.' means method is on a parent Widget.

        },
        transactionsCombo: {
          type: 'combo',
          valueField: 'idx',
          editable: false,
          store: {},
          emptyText: 'No items in the undo queue',
          onAction: 'up.onTransactionSelected',
          displayValueRenderer: 'up.transactionsDisplayValueRenderer'
        },
        redoBtn: {
          type: 'button',
          icon: 'b-icon-redo',
          tooltip: 'L{UndoRedo.RedoLastAction}',
          onAction: 'up.onRedo'
        }
      }
    };
  }

  afterConstruct() {
    this.updateUndoRedoControls();
  }

  changeStm(stm) {
    stm.on({
      recordingstop: 'updateUndoRedoControls',
      restoringstop: 'updateUndoRedoControls',
      queueReset: 'updateUndoRedoControls',
      disabled: 'updateUndoRedoControls',
      thisObj: this
    });
    return stm;
  }

  changeItems(items) {
    const {
      undoBtn,
      redoBtn
    } = items;

    if (this.color) {
      undoBtn && (undoBtn.color = this.color);
      redoBtn && (redoBtn.color = this.color);
    }

    if (this.text) {
      undoBtn && (undoBtn.text = 'L{UndoRedo.Undo}');
      redoBtn && (redoBtn.text = 'L{UndoRedo.Redo}');
    }

    return super.changeItems(items);
  }

  updateProject(project) {
    this.stm = project.stm;
  }

  fillUndoRedoCombo() {
    const {
      transactionsCombo
    } = this.widgetMap; // The transactionsCombo may be configured away if only undo and redo buttons are wanted

    transactionsCombo && (transactionsCombo.items = this.stm.queue.map((title, idx) => [idx, title || `Transaction ${idx}`]));
  }

  updateUndoRedoControls() {
    const {
      stm,
      showZeroActionBadge
    } = this,
          {
      undoBtn,
      redoBtn
    } = this.widgetMap;
    undoBtn.badge = stm.position || (showZeroActionBadge ? '0' : '');
    redoBtn.badge = stm.length - stm.position || (showZeroActionBadge ? '0' : '');
    undoBtn.disabled = !stm.canUndo;
    redoBtn.disabled = !stm.canRedo;
    this.fillUndoRedoCombo();
  }

  transactionsDisplayValueRenderer(record, combo) {
    var _this$stm;

    const stmPos = ((_this$stm = this.stm) === null || _this$stm === void 0 ? void 0 : _this$stm.position) || 0;
    return `${stmPos} undo actions / ${combo.store.count - stmPos} redo actions`;
  }

  onUndo() {
    this.stm.canUndo && this.stm.undo();
  }

  onRedo() {
    this.stm.canRedo && this.stm.redo();
  }

  onTransactionSelected(combo) {
    const stm = this.stm,
          value = combo.value;

    if (value >= 0) {
      if (stm.canUndo && value < stm.position) {
        stm.undo(stm.position - value);
      } else if (stm.canRedo && value >= stm.position) {
        stm.redo(value - stm.position + 1);
      }
    }
  }

}
UndoRedoBase._$name = 'UndoRedoBase';

/***/ }),

/***/ "./lib/Core/widget/graph/Histogram.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/graph/Histogram.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Histogram; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';





/**
 * @module Core/widget/graph/Histogram
 */

const ns = 'http://www.w3.org/2000/svg',
      // Outline series must overlay bars
typePrio = {
  bar: 1,
  outline: 2,
  text: 3
},
      byDatasetOrder = (l, r) => parseInt(l.dataset.order, 10) - parseInt(r.dataset.order, 10),
      getField = s => s.field,
      returnFalse = () => false;
/**
 * Displays a simple bar histogram based upon an array of data objects passed in the {@link #config-data} config.
 * @extends Core/widget/Widget
 * @classtype histogram
 */


class Histogram extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'histogram';
  }

  static get $name() {
    return 'Histogram';
  }

  static get defaultConfig() {
    return {
      /**
       * An array of data objects used to drive the histogram. The property/properties used
       * are defined in the {@link #config-series} option.
       * @config {Object[]}
       * @default
       */
      data: null,

      /**
       * The values to represent in bar form.
       * @config {Number[]}
       */
      values: null,

      /**
       * Each item in the array must contain two properties:
       *  - `type` A String, either `'bar'` or `'outline'`
       *  - `field` A String, the name of the property to use from the data objects in the {@link #config-data} option.
       * @config {Object[]}
       */
      series: null,

      /**
       * By default, the bars are scaled based upon the detected max value across all the series.
       * A specific top value to represent the 100% height may be configured.
       * @config {Number}
       */
      topValue: null,
      element: {
        children: [{
          ns,
          tag: 'svg',
          reference: 'svgElement',
          width: '100%',
          height: '100%',
          preserveAspectRatio: 'none',
          children: [{
            ns,
            tag: 'g',
            reference: 'scaledSvgGroup'
          }, {
            ns,
            tag: 'g',
            reference: 'unscaledSvgGroup'
          }]
        }]
      },

      /**
       * By default, all bars are rendered, even those with zero height. Configure this as `true`
       * to omit zero height bars.
       * @config {Number}
       */
      omitZeroHeightBars: null,
      monitorResize: true,

      /**
       * A Function which returns a CSS class name to add to a rectangle element.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getRectClass: null,

      /**
       * A Function which returns the tooltip text to display when hovering a bar.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarTip: null,

      /**
       * A Function which returns the text to render inside a bar.
       * The following parameters are passed:
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarText: null
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    this.scheduleRefresh = this.createOnFrame(this.refresh, [], this, true);
    this.refresh();
  }

  set tip(tip) {
    var _me$tip;

    const me = this;
    (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.destroy();

    if (tip) {
      me._tip = _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
        owner: me,
        forElement: me.svgElement,
        forSelector: 'rect',
        listeners: {
          beforeShow: 'up.onBeforeTipShow'
        }
      }, tip);
    } else {
      me._tip = null;
    }
  }

  onElementResize() {
    super.onElementResize(...arguments);
    const svgRect = this.svgElement.getBoundingClientRect();
    this.scaledSvgGroup.setAttribute('transform', `scale(${svgRect.width} ${svgRect.height})`);
  }

  onBeforeTipShow({
    source: tip
  }) {
    const index = parseInt(tip.activeTarget.dataset.index);
    tip.html = tip.contentTemplate({
      histogram: this,
      index
    });
  }

  set series(value) {
    const me = this,
          series = me._series = {};

    for (const id in value) {
      // Providing
      //
      // "series" : {
      //     "foo" : false
      //     ...
      //
      // disables the "foo" serie (that could be defined on a prototype level for example)
      if (value[id] !== false) {
        const data = series[id] = Object.assign({}, value[id]); // support type & field provided on config prototype level

        if (!data.type && value[id].type) {
          data.type = value[id].type;
        }

        if (!data.field && value[id].field) {
          data.field = value[id].field;
        }

        if (!('order' in series)) {
          data.order = typePrio[data.type];
        }

        data.id = id;
      }
    }

    me.scheduleRefresh();
  }

  get series() {
    return this._series;
  }

  set data(data) {
    const me = this; // TODO:
    // me.topValue = undefined;

    me._data = data; // Calculate the top value from all the series

    if (!me.topValue) {
      const fields = Object.values(me.series).map(getField);

      for (let i = 0, {
        length
      } = data; i < length; i++) {
        for (let j = 0, {
          length
        } = fields; j < length; j++) {
          me.topValue = Math.max(me.topValue || 0, data[i][fields[j]]);
        }
      }
    }

    me.scheduleRefresh();
  }

  get data() {
    return this._data;
  }

  set topValue(value) {
    this._topValue = value;
    this.scheduleRefresh();
  }

  get topValue() {
    return this._topValue;
  } // Must exist from the start because configuration setters call it.
  // Once configured, will be replaced with a function which schedules a refresh for the next animation frame.


  scheduleRefresh() {}

  refresh() {
    const me = this,
          {
      series,
      _tip
    } = me,
          histogramElements = [];

    for (const id in series) {
      const data = series[id],
            elConfig = me[`draw${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(data.type)}`](data);

      if (Array.isArray(elConfig)) {
        histogramElements.push.apply(histogramElements, elConfig);
      } else {
        histogramElements.push(elConfig);
      }
    }

    histogramElements.sort(byDatasetOrder);
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncChildren({
      domConfig: {
        children: histogramElements
      },
      configEquality: returnFalse
    }, me.scaledSvgGroup);
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncChildren({
      domConfig: {
        children: me.drawText()
      }
    }, me.unscaledSvgGroup);

    if (_tip && _tip.isVisible) {
      me.onBeforeTipShow({
        source: _tip
      });
    }
  }

  drawBar(series) {
    const me = this,
          {
      topValue,
      data,
      omitZeroHeightBars,
      barStyle
    } = me,
          {
      field,
      order
    } = series,
          defaultWidth = 1 / data.length,
          children = [];
    let width;

    for (let index = 0, x = 0, {
      length
    } = data; index < length; index++, x += width) {
      const datum = data[index],
            value = datum[field],
            // limit height with topValue otherwise the histogram looks fine
      // yet the bar tooltip picks wrong Y-coordinate and there is an empty space between it and the bar
      height = (value > topValue ? topValue : value) / topValue,
            y = 1 - height,
            rectConfig = datum.rectConfig = {
        ns,
        tag: 'rect',
        dataset: {}
      }; // use either provided width or the calculated value

      width = datum.width || defaultWidth;

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
        // Apparently in Edge height is calculated differently for scaled SVG content, height of the bounding client rect is calculated by formula
        // (height + 1) * scale. So visible height would be getBoundingClientRect().height - verticalScaleValue. In our case
        // verticalScaleValue is same as svgElement height.
        const svgRect = me.svgElement.getBoundingClientRect();
        rectConfig.dataset.scaleX = svgRect.width;
        rectConfig.dataset.scaleY = svgRect.height;
      }

      if (barStyle) {
        rectConfig.style = barStyle;
      } else {
        delete rectConfig.style;
      }

      Object.assign(rectConfig.dataset, {
        index,
        order
      });
      Object.assign(rectConfig, {
        x,
        y,
        width,
        height,
        class: me.callback('getRectClass', me, [series, rectConfig, datum, index])
      });
      const barTip = me.callback('getBarTip', me, [series, rectConfig, datum, index]);

      if (barTip) {
        rectConfig.dataset.btip = barTip;
      } else {
        delete rectConfig.dataset.btip;
      }

      if (height || !omitZeroHeightBars) {
        children.push(rectConfig);
      }
    }

    return children;
  }

  drawOutline(series) {
    const me = this,
          {
      topValue,
      data
    } = me,
          {
      field,
      order
    } = series,
          defaultWidth = 1 / data.length,
          coords = ['M 0,1'],
          result = series.outlineElement || (series.outlineElement = {
      ns,
      tag: 'path',
      dataset: {
        order
      }
    });

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      const svgRect = me.svgElement.getBoundingClientRect(); // Edge doesn't support `vector-effect` style and scales stroke-width too

      result.style = `stroke-width: ${1 / Math.min(svgRect.width, svgRect.height)}px`;
    }

    let barWidth,
        command1 = 'M',
        command2 = 'L';

    for (let i = 0, x = 0, {
      length
    } = data; i < length; i++) {
      const barHeight = 1 - data[i][field] / topValue; // use either provided with or the calculated value

      barWidth = data[i].width || defaultWidth;
      coords.push(`${command1} ${x},${barHeight} ${command2} ${x += barWidth},${barHeight}`);
      command1 = command2 = '';
    } // coords.push('1,1');


    result.d = coords.join(' ');
    return result;
  }

  drawText() {
    const me = this,
          {
      data
    } = me,
          defaultWidth = 1 / data.length,
          y = '100%',
          unscaledSvgGroups = [];

    for (let index = 0, width, x = 0, {
      length
    } = data; index < length; index++, x += width) {
      width = data[index].width || defaultWidth;
      const barText = me.callback('getBarText', me, [data[index], index]);

      if (barText) {
        unscaledSvgGroups.push({
          ns,
          tag: 'text',
          className: 'b-bar-legend',
          html: me.callback('getBarText', me, [data[index], index]),
          x: `${(x + width / 2) * 100}%`,
          y,
          dataset: {
            index
          }
        });
      }
    }

    return unscaledSvgGroups;
  } //endregion
  // Injectable method


  getBarText(datum, index) {
    return '';
  } // Injectable method


  getBarTip(series, rectConfig, datum, index) {} // Injectable method


  getRectClass(series, rectConfig, datum, index) {
    return '';
  }

}
Histogram.initClass();
Histogram._$name = 'Histogram';

/***/ }),

/***/ "./lib/Core/widget/graph/Scale.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/graph/Scale.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scale; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'gantt';


/**
 * @module Core/widget/graph/Scale
 */

const ns = 'http://www.w3.org/2000/svg';
/**
 * Displays a scale with ticks and labels.
 * @extends Core/widget/Widget
 * @classtype scale
 */

class Scale extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'scale';
  }

  static get $name() {
    return 'Scale';
  }

  static get configurable() {
    return {
      scalePoints: null,
      // Padding after the max scale point.
      // Expressed as the share of the height.
      scaleMaxPadding: 0.1,

      /**
       * Configure as `true` to create a horizontal scale. Scales are vertical by default.
       * @config {Boolean}
       */
      horizontal: false,

      /**
       * Side to align the scale to. Defaults to `bottom` for {@link #config-horizontal} Scales
       * and `right` for vertical Scales.
       * @config {String}
       */
      align: {
        value: false,
        $config: {
          merge: 'replace'
        }
      },
      element: {
        children: [{
          ns,
          tag: 'svg',
          reference: 'svgElement',
          width: '100%',
          height: '100%',
          preserveAspectRatio: 'none',
          children: [{
            ns,
            tag: 'g',
            reference: 'scaledSvgGroup',
            children: [{
              ns,
              tag: 'path',
              reference: 'pathElement'
            }]
          }, {
            ns,
            tag: 'g',
            reference: 'unscaledSvgGroup'
          }]
        }]
      },
      monitorResize: true
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    this.scheduleRefresh = this.createOnFrame(this.refresh, [], this, true);
    this.refresh();
  }

  changeAlign(align) {
    if (!align) {
      align = this.horizontal ? 'bottom' : 'right';
    }

    return align;
  }

  updateAlign(align, oldAlign) {
    this.element.classList.remove(`b-align-${oldAlign}`);
    this.element.classList.add(`b-align-${align}`);
  }

  updateHorizontal(horizontal, oldHorizontal) {
    this.element.classList.remove(`b-scale-${oldHorizontal ? 'horizontal' : 'vertical'}`);
    this.element.classList.add(`b-scale-${horizontal ? 'horizontal' : 'vertical'}`);
  }

  onElementResize() {
    super.onElementResize(...arguments);
    this.scheduleRefresh();
  } // Must exist from the start because configuration setters call it.
  // Once configured, will be replaced with a function which schedules a refresh for the next animation frame.


  scheduleRefresh() {}

  refresh() {
    const me = this,
          {
      horizontal,
      width,
      height,
      align,
      scalePoints,
      scaleMaxPadding
    } = me,
          scaleMax = scalePoints[scalePoints.length - 1].value,
          path = [],
          labels = [];
    const posFactor = 1 / (scaleMax + scaleMaxPadding * scaleMax);
    me.scaledSvgGroup.setAttribute('transform', `scale(${horizontal ? width : 1} ${horizontal ? 1 : height})`);

    for (const point of scalePoints) {
      const isLabelStep = Boolean(point.text),
            pos = posFactor * point.value;

      if (isLabelStep) {
        const label = {
          ns,
          tag: 'text',
          className: 'b-scale-tick-label',
          html: point.text,
          dataset: {
            tick: point.value
          }
        };

        if (horizontal) {
          label.x = `${pos * 100}%`;
          label.y = align === 'top' ? '1.6em' : height - 12;
        } else {
          label.x = align === 'left' ? '12' : `${width - 12}`;
          label.y = `${(1 - pos) * 100}%`;
        }

        labels.push(label);
      }

      if (horizontal) {
        if (align === 'top') {
          path.push(`M${pos},0 L${pos},${isLabelStep ? 10 : 5}`);
        } else {
          path.push(`M${pos},${height} L${pos},${height - (isLabelStep ? 10 : 5)}`);
        }
      } else {
        if (align === 'left') {
          path.push(`M0,${1 - pos} L${isLabelStep ? 10 : 5},${1 - pos}`);
        } else {
          path.push(`M${width},${1 - pos} L${width - (isLabelStep ? 10 : 5)},${1 - pos}`);
        }
      }
    }

    me.pathElement.setAttribute('d', path.join(''));
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].syncChildren({
      domConfig: {
        children: labels
      }
    }, me.unscaledSvgGroup);
  } //endregion


}
Scale.initClass();
Scale._$name = 'Scale';

/***/ }),

/***/ "./lib/Core/widget/layout/Box.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/layout/Box.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Box; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
var productName = 'gantt';

/**
 * @module Core/widget/layout/Box
 */

const directionCls = ['b-hbox', 'b-vbox'],
      wrapMap = {
  false: 'nowrap',
  true: 'wrap',
  reverse: 'wrap-reverse'
};
/**
 * A layout that applies `display: flex` to the {@link Core.widget.Widget#property-contentElement contentElement} of
 * its container to layout child items. This defaults to a horizontal layout of items, also known as an `'hbox'`.
 * ```javascript
 *  layout : {
 *      type : 'box'   // or equivalently, 'hbox'
 *  }
 * ```
 * @extends Core/widget/layout/Layout
 */

class Box extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Box';
  }

  static get type() {
    return 'box';
  }

  static get alias() {
    return 'hbox';
  }

  static get configurable() {
    return {
      itemCls: 'b-box-item',

      /**
       * Sets the [align-items](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} align
       * @default 'stretch'
       */
      align: null,

      /**
       * Sets the [align-content](https://developer.mozilla.org/en-US/docs/Web/CSS/align-content) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} contentAlign
       * @default 'normal'
       */
      contentAlign: null,

      /**
       * Sets the [direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * This config is not set directly. Set {@link #config-horizontal}, {@link #config-vertical}, and/or
       * {@link #config-reverse} instead.
       * @config {String} direction
       * @private
       */
      direction: null,

      /**
       * Set this value to `false` to set the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
       * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}
       * to `column`. Or alternatively, set {@link #config-vertical} to `true`.
       * @config {Boolean} horizontal
       * @default
       */
      horizontal: true,

      /**
       * Sets the [justify-content](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} justify
       * @default 'flex-start'
       */
      justify: null,

      /**
       * Set this value to `true` to add `'-reverse'` to the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
       * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * This config combines with {@link #config-horizontal} or {@link #config-vertical} to set the `flex-direction`
       * style.
       * @config {Boolean} reverse
       * @default false
       */
      reverse: null,

      /**
       * Sets the [flex-wrap](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       *
       * The value of `true` is equivalent to `'wrap'`, `false` is equivalent to `'nowrap'`, and `'reverse'` is
       * equivalent to `'wrap-reverse'`.
       *
       * ```javascript
       *  layout : {
       *      type : 'box',
       *      wrap : false        // equivalent to 'nowrap'
       *      wrap : true         // equivalent to 'wrap'
       *      wrap : 'reverse'    // equivalent to 'wrap-reverse'
       *  }
       * ```
       * @config {String|Boolean} wrap
       * @default false
       */
      wrap: null
    };
  }
  /**
   * Set this value to `true` to set the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
   * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}
   * to `column`. Or alternatively, set {@link #config-horizontal} to `false`.
   * @config {Boolean} vertical
   * @default false
   */


  get vertical() {
    return this.horizontal === false;
  }

  set vertical(v) {
    return this.horizontal = !v;
  }

  updateAlign() {
    this.syncConfigStyle('align', 'alignItems');
  }

  updateContentAlign() {
    this.syncConfigStyle('contentAlign', 'alignContent');
  }

  updateDirection() {
    this.syncConfigStyle('direction', 'flexDirection');
  }

  updateHorizontal() {
    var _me$contentElement;

    const me = this,
          classList = (_me$contentElement = me.contentElement) === null || _me$contentElement === void 0 ? void 0 : _me$contentElement.classList,
          vertical = Number(me.vertical);

    if (classList) {
      classList.remove(directionCls[1 - vertical]);
      classList.add(directionCls[vertical]);
    } else {
      me.syncConfigLater('horizontal');
    }

    me.syncDirection();
  }

  updateJustify() {
    this.syncConfigStyle('justify', 'justifyContent');
  }

  updateReverse() {
    this.syncDirection();
  }

  updateWrap() {
    this.syncConfigStyle('wrap', 'flexWrap', wrapMap);
  }

  syncDirection() {
    const me = this,
          {
      reverse
    } = me;
    me.direction = reverse ? `${me.vertical ? 'column' : 'row'}${reverse ? '-reverse' : ''}` : null;
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Box.initClass();
Box._$name = 'Box';

/***/ }),

/***/ "./lib/Core/widget/layout/Card.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/layout/Card.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Card; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';





/**
 * @module Core/widget/layout/Card
 */

const animationClasses = ['b-slide-out-left', 'b-slide-out-right', 'b-slide-in-left', 'b-slide-in-right'];
/**
 * A helper class for containers which must manage multiple child widgets, of which only one may be visible at once such
 * as a {@link Core.widget.TabPanel}. This class offers an active widget switching API, and optional slide-in,
 * slide-out animations from child to child.
 * @extends Core/widget/layout/Layout
 */

class Card extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Card';
  }

  static get type() {
    return 'card';
  }

  static get configurable() {
    return {
      containerCls: 'b-card-container',
      itemCls: 'b-card-item',
      hideChildHeaderCls: 'b-hide-child-headers',

      /**
       * Specifies whether to slide tabs in and out of visibility.
       * @config {Boolean}
       * @default
       */
      animateCardChange: true,

      /**
       * The active child item.
       * @config {Core.widget.Widget}
       */
      activeItem: null,

      /**
       * The active child index.
       * @config {Number}
       */
      activeIndex: null
    };
  }

  onChildAdd(item) {
    super.onChildAdd(item);
    const me = this,
          {
      activeItem,
      owner
    } = me,
          activeIndex = owner.activeIndex != null ? owner.activeIndex : me.activeIndex || 0,
          itemIndex = owner.items.indexOf(item),
          isActive = activeItem != null ? item === activeItem : itemIndex === activeIndex;
    item.on({
      beforeHide: 'onBeforeChildHide',
      beforeShow: 'onBeforeChildShow',
      thisObj: me
    }); // Ensure inactive child items start hidden, and the active one starts shown.
    // Sync our active indicators with reality ready for render.

    if (isActive) {
      item.show();
      me._activeIndex = itemIndex;
      me._activeItem = item;
    } else {
      item.$isDeactivating = true;
      item.hide();
      item.$isDeactivating = false;
    }
  }

  onChildRemove(item) {
    super.onChildRemove(item); // Active child has been removed without setting another child to be active.
    // Choose an immediate sibling to be the new active item

    if (this._activeItem === item) {
      this.activateSiblingOf(item);
    }

    item.un({
      beforeHide: 'onBeforeChildHide',
      beforeShow: 'onBeforeChildShow',
      thisObj: this
    });
  }
  /**
   * Detect external code showing a child. We veto that show and activate it through the API.
   * @internal
   */


  onBeforeChildShow({
    source: showingChild
  }) {
    // Some outside code is showing a child.
    // We must control this, so veto it and activate it in the standard way.
    if (!this.owner.isConfiguring && !showingChild.$isActivating) {
      this.activeItem = showingChild;
      return false;
    }
  }
  /**
   * Detect external code hiding a child. We veto that show and activate an immediate sibling through the API.
   * @internal
   */


  onBeforeChildHide({
    source: hidingChild
  }) {
    // Some outside code is hiding a child.
    // We must control this, so veto it and activate a sibling in the standard way.
    if (!this.owner.isConfiguring && !hidingChild.$isDeactivating) {
      this.activateSiblingOf(hidingChild);
      return false;
    }
  }

  activateSiblingOf(item) {
    const {
      owner
    } = this,
          items = owner.items.slice(),
          removeAt = items.indexOf(item);
    items.splice(removeAt, 1);
    this.activeIndex = Math.min(removeAt, items.length - 1);
  }
  /**
   * Get/set active item, using index or the Widget to activate
   * @param {Core.widget.Widget|Number} activeIndex
   * @param {Number} [prevActiveIndex]
   * @returns {Object} An object describing the card change containing the following properties:
   *
   *  - `prevActiveIndex` The previously active index.
   *  - `prevActiveItem ` The previously active child item.
   *  - `activeIndex    ` The newly active index.
   *  - `activeItem     ` The newly active child item.
   *  - `promise        ` A promise which completes when the slide-in animation finishes and the child item contains
   * focus if it is focusable.
   * @internal
   */


  setActiveItem(activeIndex, prevActiveIndex = this.activeIndex) {
    const me = this,
          {
      owner
    } = me,
          {
      items
    } = owner,
          widgetPassed = activeIndex instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          prevActiveItem = items[prevActiveIndex],
          newActiveItem = owner.items[activeIndex = widgetPassed ? activeIndex = items.indexOf(activeIndex) : parseInt(activeIndex)],
          event = {
      prevActiveIndex,
      prevActiveItem
    }; // There's a child widget at that index to activate and we're not already activating it.

    if (newActiveItem && !newActiveItem.$isActivating && newActiveItem !== prevActiveItem) {
      var _owner$onBeginActiveI;

      const prevItemElement = prevActiveItem && prevActiveItem.element,
            newActiveElement = newActiveItem && newActiveItem.element; // A previous card change is in progress, abort it and clean the items it was operating upon

      if (me.animateDetacher) {
        const abortedEvent = me.animateDetacher.event;
        me.animateDetacher();
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(abortedEvent.prevActiveItem.element, animationClasses);
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(abortedEvent.activeItem.element, animationClasses);
        me.animateDetacher = null;
      }

      event.activeIndex = activeIndex;
      event.activeItem = newActiveItem;
      /**
       * The active item is about to be changed. Return `false` to prevent this.
       * @event beforeActiveItemChange
       * @preventable
       * @on-owner
       * @param {Number} activeIndex - The new active index.
       * @param {Core.widget.Widget} activeItem - The new active child widget.
       * @param {Number} prevActiveIndex - The previous active index.
       * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
       */

      if (owner.trigger('beforeActiveItemChange', event) === false) {
        return null;
      } // Since onBeforeActiveItemChange happens before event handlers run, the activation could be cancelled by
      // a listener, so we do a special hook once we are sure things are going down.
      // We pretend that we have already switched active index so that the owner
      // does not attempt to initiate the change.


      const reset = this._activeIndex !== event.activeIndex;

      if (reset) {
        this._activeIndex = event.activeIndex;
      }

      (_owner$onBeginActiveI = owner.onBeginActiveItemChange) === null || _owner$onBeginActiveI === void 0 ? void 0 : _owner$onBeginActiveI.call(owner, event);

      if (reset) {
        this._activeIndex = event.prevActiveIndex;
      }

      event.promise = new Promise((resolve, reject) => {
        // If there's something to slide out, slide it out, and slide the new item in
        if (prevItemElement && owner.isVisible && me.animateCardChange) {
          // During the card sliding trick, we don't want resize notifications.
          // The outgoing card should be as inert as if it were hidden.
          const wasMonitoringSize = prevActiveItem.monitorResize;
          prevActiveItem.monitorResize = false;
          me.contentElement.style.overflowX = 'hidden'; // The outgoing card must report its isVisible property as false from now on
          // even before we officially hide it.

          prevActiveItem._hidden = true; // Show the item so that it can be slid in.
          // Events will ensue, UIs can react to the show event.
          // The flag is so that our onBeforeChildShow listener can
          // tell if it's part of our orderly activate operation.

          newActiveItem.$isActivating = true;
          newActiveItem.show();
          newActiveItem.$isActivating = false;
          prevItemElement.classList.add(activeIndex > prevActiveIndex ? 'b-slide-out-left' : 'b-slide-out-right');
          newActiveElement.classList.add(activeIndex < prevActiveIndex ? 'b-slide-in-left' : 'b-slide-in-right');
          owner.isAnimating = true; // When the new widget is in place, clean up

          me.animateDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
            mode: 'animation',
            element: newActiveElement,
            // onTransitionEnd protects us from being called
            // after the thisObj is destroyed.
            thisObj: prevActiveItem,

            handler() {
              // Calendar got stuck with `b-animating` in some monkey scenarios, hoisted this to make
              // sure it was not left behind
              owner.isAnimating = false; // if animateDetacher variable has been cleared before this callback,
              // this means race-condition call happened. active item should be called again to
              // prevent unexpected layout behaviour

              if (!me.animateDetacher) {
                me.setActiveItem(activeIndex, prevActiveIndex);
                return;
              }

              me.animateDetacher = null; // Clean incoming widget's animation classes

              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(newActiveElement, animationClasses); // If there's an outgoing item, clean its animation classes and hide it

              if (prevItemElement) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(prevItemElement, animationClasses); // The flag is so that our onBeforeChildHide listener can
                // tell if it's part of our orderly activate operation.

                prevActiveItem.$isDeactivating = true;
                prevActiveItem._hidden = false;
                prevActiveItem.hide();
                prevActiveItem.monitorResize = wasMonitoringSize;
                prevActiveItem.$isDeactivating = false;
              }

              me.contentElement.style.overflowX = '';
              me.onActiveItemChange(event, resolve);
            }

          });
          me.animateDetacher.reject = reject;
          me.animateDetacher.event = event;
        } // Nothing to slide out or we are not animating.
        else {
          // Show the new active items first, so that the hide listener doesn't
          // automatically set a new active item based on active item being hidden.
          // The flag is so that our onBeforeChildShow listener can
          // tell if it's part of our orderly activate operation.
          newActiveItem.$isActivating = true;
          newActiveItem.show(); // focus the new item before lost the component focus when hide the old one
          // (because losing focus closes owner if it is floatable)

          newActiveItem.focus();
          newActiveItem.$isActivating = false;

          if (prevActiveItem) {
            // The flag is so that our onBeforeChildHide listener can
            // tell if it's part of our orderly activate operation.
            prevActiveItem.$isDeactivating = true;
            prevActiveItem.hide();
            prevActiveItem.$isDeactivating = false;
          }

          me.onActiveItemChange(event, resolve);
        }
      });
    }

    return event;
  }

  onActiveItemChange(event, resolve) {
    const me = this;
    me._activeItem = event.activeItem;
    me._activeIndex = event.activeIndex;
    /**
     * The active item has changed.
     * @event activeItemChange
     * @on-owner
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */

    me.owner.trigger('activeItemChange', event); // Note that we have to call focus *after* the element is in its new position
    // because focus({preventScroll:true}) is not supported everywhere
    // and crazy browser scrolling behaviour on focus breaks the animation.

    event.activeItem.focus();
    resolve(event);
  }

  renderChildren() {
    const {
      owner
    } = this; // The usual; not working on IE11

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.animateCardChange = false;
    }

    owner.contentElement.classList[owner.suppressChildHeaders ? 'add' : 'remove'](this.hideChildHeaderCls);
    super.renderChildren();
  }

  changeActiveIndex(activeIndex) {
    const {
      owner
    } = this; // Sanitize it if possible

    return owner.isConfiguring && !owner._items ? activeIndex : Math.min(activeIndex, owner.items.length - 1);
  }

  updateActiveIndex(activeIndex, oldActiveIndex) {
    if (!this.owner.isConfiguring) {
      this.setActiveItem(activeIndex, oldActiveIndex);
    }
  }

  updateActiveItem(activeItem) {
    if (!this.owner.isConfiguring) {
      this.setActiveItem(activeItem, this.activeIndex);
    }
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Card.initClass();
Card._$name = 'Card';

/***/ }),

/***/ "./lib/Core/widget/layout/Fit.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/layout/Fit.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fit; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
var productName = 'gantt';

/**
 * @module Core/widget/layout/Fit
 */

/**
 * A helper class for containers which must manage a single child widget which must fit the container's
 * {@link Core.widget.Widget#property-contentElement contentElement}.
 */

class Fit extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Fit';
  }

  static get type() {
    return 'fit';
  }

  static get configurable() {
    return {
      containerCls: 'b-fit-container',
      itemCls: 'b-fit-item'
    };
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Fit.initClass();
Fit._$name = 'Fit';

/***/ }),

/***/ "./lib/Core/widget/layout/Layout.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/layout/Layout.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Layout; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';




/**
 * @module Core/widget/layout/Layout
 */

/**
  * A helper class used by {@link Core.widget.Container Container}s which renders child widgets to their
  * {@link Core.widget.Widget#property-contentElement}. It also adds the Container's
  * {@link Core.widget.Container#config-itemCls} class to child items.
  *
  * Subclasses may modify the way child widgets are rendered, or may offer APIs for manipulating the child widgets.
  *
  * The {@link Core.widget.layout.Card Card} layout class offers slide-in, slide-out animation of multiple
  * child widgets. {@link Core.widget.TabPanel} uses Card layout.
  */

class Layout extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get type() {
    return 'default';
  }

  static get configurable() {
    return {
      /**
       * The owning Widget.
       * @member {Core.widget.Widget} owner
       * @readonly
       */

      /**
       * @config {Core.widget.Widget} owner
       * @private
       */
      owner: null,

      /**
       * The CSS class which should be added to the owning {@link Core.widget.Container}'s.
       * {@link Core.widget.Widget#property-contentElement}.
       * @config {String}
       */
      containerCls: 'b-auto-container',

      /**
       * The CSS class which should be added to the encapsulating element of child items.
       * @config {String}
       */
      itemCls: null
    };
  }

  static get factoryable() {
    // establish this class as the Factoryable base
    return {
      defaultType: 'default'
    };
  }

  get contentElement() {
    var _this$owner;

    return (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.contentElement;
  }

  onChildAdd(item) {}

  onChildRemove(item) {}

  renderChildren() {
    const me = this,
          {
      owner,
      containerCls,
      itemCls
    } = me,
          {
      contentElement,
      items
    } = owner,
          ownerItemCls = owner.itemCls,
          itemCount = items === null || items === void 0 ? void 0 : items.length;
    contentElement.classList.add('b-content-element');

    if (containerCls) {
      contentElement.classList.add(containerCls);
    } // Need to check that container has widgets, for example TabPanel can have no tabs


    if (itemCount) {
      owner.textContent = false;

      for (let i = 0; i < itemCount; i++) {
        const item = items[i],
              {
          element
        } = item;
        element.dataset.itemIndex = i;

        if (itemCls) {
          element.classList.add(itemCls);
        }

        if (ownerItemCls) {
          element.classList.add(ownerItemCls);
        } // If instantiated by the app developer, external to Container#createWidget
        // a widget will have the b-outer class. Remove that if it' contained.


        element.classList.remove('b-outer'); // Only trigger paint if the owner is itself painted, otherwise
        // the outermost Container will cascade the paint signal down.

        item.render(contentElement, Boolean(owner.isPainted));
      }
    }

    me.syncPendingConfigs();
    me.syncChildCount();
  }

  removeChild(child) {
    const me = this,
          {
      element
    } = child,
          {
      owner,
      itemCls
    } = me,
          {
      contentElement
    } = owner,
          ownerItemCls = owner.itemCls; // Chrome has turned very fussy recently.
    // If the parent does not contain the child to be removed, it throws.

    if (contentElement.contains(element)) {
      element.remove();
    }

    delete element.dataset.itemIndex;

    if (itemCls) {
      element.classList.remove(itemCls);
    }

    if (ownerItemCls) {
      element.classList.remove(ownerItemCls);
    }

    me.fixChildIndices();
    me.syncChildCount();
  }

  appendChild(child) {
    const {
      element
    } = child,
          {
      owner,
      itemCls
    } = this,
          {
      contentElement
    } = owner,
          ownerItemCls = owner.itemCls;
    element.dataset.itemIndex = owner.indexOfChild(child);
    owner.textContent = false;

    if (itemCls) {
      element.classList.add(itemCls);
    }

    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }

    child.render(contentElement, Boolean(owner.isPainted));
    this.syncChildCount();
  }

  insertChild(toAdd, childIndex) {
    const me = this,
          {
      element
    } = toAdd,
          {
      owner,
      itemCls
    } = me,
          {
      contentElement
    } = owner,
          nextSibling = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getChild(contentElement, `[data-item-index="${childIndex}"]`),
          ownerItemCls = owner.itemCls;
    owner.textContent = false;

    if (itemCls) {
      element.classList.add(itemCls);
    }

    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }

    contentElement.insertBefore(element, nextSibling);
    toAdd.render(null, Boolean(owner.isPainted));
    me.fixChildIndices();
    me.syncChildCount();
  }

  fixChildIndices() {
    this.owner.items.forEach((child, index) => {
      child.element.dataset.itemIndex = index;
    });
  }

  syncChildCount() {
    var _owner$contentElement;

    const {
      owner
    } = this,
          {
      length
    } = owner.items; // Special CSS conditions may apply if there's only a single child.

    (_owner$contentElement = owner.contentElement) === null || _owner$contentElement === void 0 ? void 0 : _owner$contentElement.classList[length === 1 ? 'add' : 'remove']('b-single-child');
  }
  /**
   * Registers a layout `config` property that cannot be acted upon at this time but must wait for the `owner` to
   * fully render its elements (in particular the `contentElement`).
   * @param {String} config The name of the config to sync later.
   * @internal
   */


  syncConfigLater(config) {
    const pendingConfigs = this.pendingConfigs || (this.pendingConfigs = []);

    if (!pendingConfigs.includes(config)) {
      pendingConfigs.push(config);
    }
  }
  /**
   * Sets the specified `style` to the value of the config given its `name`.
   * @param {String} name The name of the config with the value to apply to the given `style`.
   * @param {String} style The style property to set on the `contentElement`.
   * @param {Object} [map] An option object to convert the config's value to the `style` value.
   * @internal
   */


  syncConfigStyle(name, style, map) {
    const me = this,
          {
      contentElement
    } = me,
          value = me[name];

    if (contentElement) {
      contentElement.style[style] = (map === null || map === void 0 ? void 0 : map[value]) || value;
    } else {
      me.syncConfigLater(name);
    }
  }

  syncPendingConfigs() {
    const me = this,
          {
      pendingConfigs
    } = me;
    let name;

    if (pendingConfigs) {
      me.pendingConfigs = null;

      while (name
      /* assignment */
      = pendingConfigs.pop()) {
        me[me.$meta.configs[name].updater](me[name]);
      }
    }
  }

}
Layout.initClass();
Layout._$name = 'Layout';

/***/ }),

/***/ "./lib/Core/widget/layout/VBox.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/layout/VBox.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VBox; });
/* harmony import */ var _Box_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Box.js */ "./lib/Core/widget/layout/Box.js");
var productName = 'gantt';

/**
 * @module Core/widget/layout/VBox
 */

/**
 * A {@link Core.widget.layout.Box} layout that defaults to `horizontal : false`.
 *
 * The following:
 * ```javascript
 *  layout : {
 *      type : 'vbox'
 *  }
 * ```
 * Is equivalent to:
 * ```javascript
 *  layout : {
 *      type       : 'box',
 *      horizontal : false
 *  }
 * ```
 * @extends Core/widget/layout/Box
 */

class VBox extends _Box_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'VBox';
  }

  static get type() {
    return 'vbox';
  }

  static get configurable() {
    return {
      horizontal: false
    };
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

VBox.initClass();
VBox._$name = 'VBox';

/***/ }),

/***/ "./lib/Core/widget/mixin/Badge.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/mixin/Badge.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/widget/mixin/Badge
 */

/**
 * Mixin that allows a widget to display a badge (mostly done as css)
 *
 * ```javascript
 * // show badge
 * button.badge = 5;
 *
 * // hide badge
 * button.badge = null;
 * ```
 *
 * @inlineexample Core/widget/Badge.js
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Badge extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Badge';
  }

  static get configurable() {
    return {
      /**
       * Get/sets and display badge, set to null or empty string to hide.
       * @member {String} badge
       * @category Misc
       */

      /**
       * Initial text to show in badge.
       * @config {String} badge
       * @category Misc
       */
      badge: null
    };
  }

  compose() {
    const {
      badge
    } = this;
    return {
      dataset: {
        badge
      },
      class: {
        'b-badge': badge != null && badge !== ''
      }
    };
  }

});

/***/ }),

/***/ "./lib/Core/widget/mixin/KeyMap.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/mixin/KeyMap.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class KeyMap extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    get widgetClass() {}

    performKeyMapAction(keyEvent, bryntumEvent) {
      const {
        keyMap
      } = this;

      if (keyMap) {
        const // Match a defined key combination, such as `Ctrl + Enter`
        keyCombination = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].keys(keyMap).find(keyString => {
          const keys = keyString.split('+'),
                requireShift = keys.includes('Shift'),
                requireCtrl = keys.includes('Ctrl'); // Last key should be the actual key, modifiers in any order before it

          return keys[keys.length - 1].toLowerCase() === keyEvent.key.toLowerCase() && (!keyEvent.ctrlKey && !requireCtrl || requireCtrl) && (!keyEvent.shiftKey && !requireShift || requireShift);
        }),
              // Get the action (fn to call) for that key combination
        action = keyMap[keyCombination];

        if (action) {
          if (typeof action === 'string') {
            this[action](bryntumEvent || keyEvent);
          } else {
            action.call(this);
          }

          return true;
        }
      }

      return false;
    }

  }, _defineProperty(_class, "$name", 'KeyMap'), _defineProperty(_class, "configurable", {
    keyMap: {
      value: null,
      $config: {
        merge: 'objects'
      }
    }
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/LocalizableComboItems.js":
/*!********************************************************!*\
  !*** ./lib/Core/widget/mixin/LocalizableComboItems.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';

/**
 * @module Core/widget/mixin/LocalizableComboItems
 */

/**
 * A mixin that regenerates a combobox items on locale change.
 * @private
 * @mixin
 * @mixinbase Combo
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class LocalizableComboItems extends (Target || _Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'LocalizableComboItems';
  }

  static get defaultConfig() {
    return {
      items: true
    };
  }

  set items(items) {
    if (items === true) {
      items = this.buildLocalizedItems();
    }

    super.items = items;
  }

  get items() {
    return super.items;
  }

  construct(...args) {
    // set a special flag to skip unneeded store translation on construction step
    this.inConstruct = true;
    super.construct(...args);
    this.inConstruct = false;
  }

  buildLocalizedItems() {
    return [];
  }

  updateLocalizedItems() {
    const me = this;

    if (me.store && !me.inConstruct) {
      const {
        value
      } = me; // TODO: just updating new data is not enough ..selected value text is shown wrong :(
      // it seems caused by selected record cache
      // review this code after #9387 is fixed

      me.store.data = me.buildLocalizedItems();
      me.value = null;
      me.value = value;
      me.syncInputFieldValue(true);
    }
  }

  updateLocalization() {
    this.updateLocalizedItems();
    super.updateLocalization();
  }

});

/***/ }),

/***/ "./lib/Core/widget/mixin/Responsive.js":
/*!*********************************************!*\
  !*** ./lib/Core/widget/mixin/Responsive.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/**
 * @module Core/widget/mixin/Responsive
 */

/**
 * A breakpoint definition. Used when defining breakpoints, see {@link #config-breakpoints}.
 *
 * ```javascript
 * {
 *     name    : 'Small',
 *     configs : {
 *         text  : null,
 *         color : 'b-blue'
 *     },
 *     callback() {
 *         console.log('Applied small');
 *     }
 * }
 * ```
 *
 * @typedef Breakpoint
 * @property {String} name Name of the breakpoint
 * @property {Object} [configs] An optional configuration object to apply to the widget when the breakpoint is activated
 * @property {Function} [callback] An optional callback, called when the breakpoint is activated
 */

/**
 * Mixin that simplifies adding responsive behaviour to widgets, by allowing them to define responsive
 * {@link #config-breakpoints} based on max-width/max-height.
 *
 * Each {@link #typedef-Breakpoint brekpoint} can contain configs that are applied to the widget and a callback called
 * when the breakpoint is activated.
 *
 * The mixin triggers an event when switching breakpoints, allowing the application to define its own behaviour. It also
 * uses the name of a breakpoint to apply a CSS class to Widget, for example `small` -> `b-breakpoint-small`.
 *
 * ```javascript
 * class ResponsiveButton extends Button.mixin(Responsive) {}
 *
 * const button = new ResponsiveButton({
 *     breakpoints : {
 *         width : {
 *             // When width drops to 50 or below, hide text and show icon
 *             50 : {
 *                 name    : 'small',
 *                 configs : { text : null, icon : 'b-fa b-fa-plus' },
 *                 callback() {
 *                     console.log('Applied small');
 *                 }
 *             },
 *             // When width is above 50, hide icon and show text
 *             '*' : {
 *                  name    : 'large',
 *                  configs : { text : 'Add', icon : null }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class Responsive extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    changeBreakpoints(breakpoints) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(breakpoints, 'breakpoints'); // Normalize breakpoints

      if (breakpoints !== null && breakpoints !== void 0 && breakpoints.width) {
        Object.keys(breakpoints.width).forEach(key => {
          breakpoints.width[key].maxWidth = key;
        });
      }

      if (breakpoints !== null && breakpoints !== void 0 && breakpoints.height) {
        Object.keys(breakpoints.height).forEach(key => {
          breakpoints.height[key].maxHeight = key;
        });
      }

      return breakpoints;
    }

    updateBreakpoints(breakpoints) {
      if (breakpoints) {
        this.monitorResize = true;
      }
    } // Get a width/height breakpoint for the supplied dimension


    getBreakpoint(levels, dimension) {
      const // Breakpoints as reverse sorted array of numerical widths [NaN for *, 50, 100]
      ascendingLevels = Object.keys(levels).map(l => parseInt(l)).sort(),
            // Find first one larger than current width
      breakpoint = ascendingLevels.find(bp => dimension <= bp); // Return matched breakpoint or * if available and none matched

      return levels[breakpoint !== null && breakpoint !== void 0 ? breakpoint : levels['*'] && '*'];
    } // Apply a breakpoints configs, trigger event and call any callback


    activateBreakpoint(orientation, breakpoint) {
      const me = this,
            prevBreakpoint = me[`current${orientation}Breakpoint`];

      if (breakpoint !== prevBreakpoint) {
        var _breakpoint$callback, _me$recompose;

        me[`current${orientation}Breakpoint`] = breakpoint;
        me.setConfig(breakpoint.configs);
        prevBreakpoint && me.element.classList.remove(`b-breakpoint-${prevBreakpoint.name.toLowerCase()}`);
        me.element.classList.add(`b-breakpoint-${breakpoint.name.toLowerCase()}`);
        /**
         * Triggered when a new max-width based breakpoint is applied.
         * @event responsiveWidthChange
         * @param {Core.widget.Widget} source The widget
         * @param {Breakpoint} breakpoint The applied breakpoint
         * @param {Breakpoint} prevBreakpoint The previously applied breakpoint
         */

        /**
         * Triggered when a new max-height based breakpoint is applied.
         * @event responsiveHeightChange
         * @param {Core.widget.Widget} source The widget
         * @param {Breakpoint} breakpoint The applied breakpoint
         * @param {Breakpoint} prevBreakpoint The previously applied breakpoint
         */

        me.trigger(`responsive${orientation}Change`, {
          breakpoint,
          prevBreakpoint
        });
        (_breakpoint$callback = breakpoint.callback) === null || _breakpoint$callback === void 0 ? void 0 : _breakpoint$callback.call(breakpoint, {
          source: me,
          breakpoint,
          prevBreakpoint
        });
        (_me$recompose = me.recompose) === null || _me$recompose === void 0 ? void 0 : _me$recompose.call(me);
      }
    } // Called on resize to pick and apply a breakpoint, if size changed enough


    applyResponsiveness(width, height) {
      var _me$breakpoints;

      const me = this,
            {
        width: widths,
        height: heights
      } = (_me$breakpoints = me.breakpoints) !== null && _me$breakpoints !== void 0 ? _me$breakpoints : {};

      if (widths) {
        const breakpoint = me.getBreakpoint(widths, width);
        me.activateBreakpoint('Width', breakpoint);
      }

      if (heights) {
        const breakpoint = me.getBreakpoint(heights, height);
        me.activateBreakpoint('Height', breakpoint);
      }
    }

    onInternalResize(element, width, height, oldWidth, oldHeight) {
      super.onInternalResize(element, width, height, oldWidth, oldHeight);
      this.applyResponsiveness(width, height);
    }

  }, _defineProperty(_class, "$name", 'Responsive'), _defineProperty(_class, "configurable", {
    /**
     * Defines responsive breakpoints, based on max-width or max-height.
     *
     * When the widget is resized, the defined breakpoints are queried to find the closest larger or equal
     * breakpoint for both width and height. If the found breakpoint differs from the currently applied, it is
     * applied.
     *
     * Applying a breakpoint triggers an event that applications can catch to react to the change. It also
     * optionally applies a set of configs and calls a configured callback.
     *
     * ```javascript
     * breakpoints : {
     *     width : {
     *         50 : { name : 'small', configs : { text : 'Small', ... } }
     *         100 : { name : 'medium', configs : { text : 'Medium', ... } },
     *         '*' : { name : 'largem', configs : { text : 'Large', ... } }
     *     }
     * }
     * ```
     *
     * @config {Object}
     * @param {Object} width Max-width breakpoints, with keys as numerical widths (or '*' for larger widths than the
     * largest defined one) and the value as a {@link #typedef-Breakpoint breakpoint definition}
     * @param {Object} height Max-height breakpoints, with keys as numerical heights (or '*' for larger widths than
     * the largest defined one) and the value as a {@link #typedef-Breakpoint breakpoint definition}
     */
    breakpoints: null
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/Rotatable.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/mixin/Rotatable.js ***!
  \********************************************/
/*! exports provided: canonicalDock, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canonicalDock", function() { return canonicalDock; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Core/widget/mixin/Rotatable
 */
// we set rotate to 'LEFT' or 'RIGHT' when we auto rotate so we can tell it was (most likely) us:

const autoRotateRe = /^(?:undefined|null|LEFT|RIGHT)$/,
      inverted = {
  TOP: 'BOTTOM',
  RIGHT: 'LEFT',
  BOTTOM: 'TOP',
  LEFT: 'RIGHT'
};
const canonicalDock = dock => {
  const DOCK = dock === null || dock === void 0 ? void 0 : dock.toUpperCase();
  return [DOCK, DOCK === 'LEFT' || DOCK === 'RIGHT'];
};
/**
 * A mixin that provides support for rotating a widget's primary element.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Rotatable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Rotatable';
  }

  static get configurable() {
    return {
      /**
       * Set to `'left'` to rotate the button content 90 degrees counter-clockwise or `'right'` for clockwise.
       * @member {String} rotate
       */

      /**
       * Specify `'left'` to rotate the button content 90 degrees counter-clockwise or `'right'` for clockwise.
       * @config {String} rotate
       */
      rotate: null,
      invertRotate: null
    };
  }

  compose() {
    const {
      rotate
    } = this;
    return {
      class: {
        [`b-rotate-${(rotate || '').toLowerCase()}`]: rotate,
        'b-rotate-vertical': rotate
      }
    };
  }

  syncRotationToDock(dock) {
    if (autoRotateRe.test(String(this.rotate))) {
      const [DOCK, vertical] = canonicalDock(dock);
      this.rotate = vertical ? this.invertRotate ? inverted[DOCK] : DOCK : null;
    }
  }

  get widgetClass() {
    return null;
  }

});

/***/ }),

/***/ "./lib/Core/widget/mixin/Styleable.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/mixin/Styleable.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';




/**
 * @module Core/widget/mixin/Styleable
 */

/**
 * Mixin for widgets that allows manipulating CSS variables. Works by setting style properties of the target widgets
 * element.
 *
 * As part of configuration:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    css : {
 *        cardBorderTop    : '5px solid currentColor',
 *        columnBackground : '#ddd'
 *    }
 * });
 * ```
 *
 * And/or at runtime:
 *
 * ```javascript
 * taskBoard.css.cardBackground = '#333';
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class Styleable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    changeCssVarPrefix(prefix) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertString(prefix, 'prefix');

      if (prefix && !prefix.endsWith('-')) {
        prefix = prefix + '-';
      }

      return prefix || '';
    }

    changeCss(css) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(css, 'css');
      const me = this;

      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.Proxy) {
        throw new Error('Proxy not supported');
      }

      const proxy = new Proxy({}, {
        get(target, property) {
          var _styles$getPropertyVa;

          // TODO: Worth keeping the live css object? Or just overhead if not often used?
          const styles = getComputedStyle(me.element || document.documentElement);
          return (_styles$getPropertyVa = styles.getPropertyValue(`--${me.cssVarPrefix}${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].hyphenate(property)}`)) === null || _styles$getPropertyVa === void 0 ? void 0 : _styles$getPropertyVa.trim();
        },

        set(target, property, value) {
          const element = me.element || document.documentElement;
          element.style.setProperty(`--${me.cssVarPrefix}${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].hyphenate(property)}`, value);
          return true;
        }

      });

      if (css) {
        if (me._element) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(proxy, css);
        } else {
          me.$initialCSS = css;
        }
      }

      return proxy;
    } // Apply any initially supplied CSS when we have an element


    updateElement(element, ...args) {
      super.updateElement(element, ...args);

      if (this.$initialCSS) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(this.css, this.$initialCSS);
      }
    }

    get widgetClass() {}

  }, _defineProperty(_class, "$name", 'Styleable'), _defineProperty(_class, "configurable", {
    /**
     * CSS variable prefix, appended to the keys used in {@link #config-css}.
     *
     * For example:
     *
     * ```javascript
     * {
     *    cssVarPrefix : 'taskboard',
     *
     *    css : {
     *        cardBackground : '#333'
     *    }
     * }
     * ```
     *
     * Results in the css var `--taskboard-card-background` being set to `#333`.
     * @config {String}
     * @category CSS
     */
    cssVarPrefix: '',

    /**
     * Allows runtime manipulating of CSS variables.
     *
     * See {@link #config-css} for more information.
     *
     * ```javascript
     * taskBoard.css.columnBackground = '#ccc';
     *
     * // Will set "--taskboard-column-background : #ccc"
     * ```
     *
     * @member {Proxy} css
     * @category DOM
     */

    /**
     * Initial CSS variables to set.
     *
     * Each key will be applied as a CSS variable to the target elements style. Key names are hyphenated and
     * prefixed with {@link #config-cssVarPrefix} in the process. For example:
     *
     * ```javascript
     * {
     *    cssVarPrefix : 'taskboard',
     *
     *    css : {
     *        cardBackground : '#333'
     *    }
     * }
     * ```
     *
     * Results in the css var `--taskboard-card-background` being set to `#333`.
     *
     * @config {Object}
     * @category CSS
     */
    css: {}
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/Toolable.js":
/*!*******************************************!*\
  !*** ./lib/Core/widget/mixin/Toolable.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony import */ var _Tool_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Tool.js */ "./lib/Core/widget/Tool.js");
var productName = 'gantt';





/**
 * @module Core/widget/mixin/Toolable
 */

const emptyArray = [],
      emptyObject = {},
      toolConfigs = {
  align: 1,
  // hidden : 1,
  weight: 1
};
/**
 * A mixin that manages {@link #config-tools}.
 *
 * @mixin
 * @mixinbase Widget
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Toolable extends (Target || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Toolable';
  }

  static get configurable() {
    return {
      /**
       * The {@link Core.widget.Tool tools} as specified by the {@link #config-tools} configuration. Each is a
       * {@link Core.widget.Tool} instance which may be hidden, shown and observed and styled just like any other
       * widget.
       * @member {Object} tools
       */

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the `title` in the Panel header. Each
       * property name is the reference by which an instantiated tool may be retrieved from the live
       * `{@link #property-tools}` property.
       * @config {Object}
       */
      tools: {
        value: null,
        $config: {
          nullify: true
        }
      },

      /**
       * An object containing config defaults for corresponding {@link #config-tools} objects with a matching name.
       *
       * This object contains a key named `'*'` with default config properties to apply to all tools. This
       * object provides the default `type` (`'tool').
       * @config {Object} toolDefaults
       * @private
       */
      toolDefaults: {
        '*': {
          type: 'tool',
          align: 'end'
        }
      }
    };
  }

  byWeightSortFn(a, b) {
    return (a.weight || 0) - (b.weight || 0);
  }

  byWeightReverseSortFn(a, b) {
    return (b.weight || 0) - (a.weight || 0);
  }

  gatherTools({
    align,
    overlay,
    refs
  } = emptyObject) {
    const {
      collapsed,
      tools
    } = this;
    let ret = [],
        alignment,
        key,
        i,
        item,
        tool;

    for (key in tools) {
      var _ref, _tool$align$align, _tool, _tool$align, _tool2;

      tool = tools[key]; // Tools redefine "align" config to be a simple string, but other widgets promote align config to an align
      // spec object

      alignment = (_ref = (_tool$align$align = (_tool = tool) === null || _tool === void 0 ? void 0 : (_tool$align = _tool.align) === null || _tool$align === void 0 ? void 0 : _tool$align.align) !== null && _tool$align$align !== void 0 ? _tool$align$align : (_tool2 = tool) === null || _tool2 === void 0 ? void 0 : _tool2.align) !== null && _ref !== void 0 ? _ref : 'end';

      if (alignment === align && tool.isCollapsified(collapsed, overlay)) {
        ret.push(tool);
      }
    }

    ret.sort(this[align === 'end' ? 'byWeightReverseSortFn' : 'byWeightSortFn']);

    if (refs) {
      const asWidget = refs === 'widget',
            asRefs = {};

      for (i = 0; i < ret.length; ++i) {
        item = ret[i];
        asRefs[item.ref] = asWidget ? item : item.element;
      }

      ret = asRefs;
    }

    return ret;
  }

  getEndTools({
    overlay,
    refs
  } = emptyObject) {
    return this.gatherTools({
      align: 'end',
      overlay,
      refs
    });
  }

  getStartTools({
    overlay,
    refs
  } = emptyObject) {
    return this.gatherTools({
      align: 'start',
      overlay,
      refs
    });
  }

  get childItems() {
    return [...this.getStartTools(), ...(this._items || emptyArray), ...this.getEndTools()];
  }

  changeTools(tools, oldTools) {
    const me = this,
          manager = me.$tools || (me.$tools = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      configName: 'tools',
      factory: _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"],
      inferType: false,
      // the name of a tool in the tools object is not its type
      owner: me,

      created(instance) {
        var _instance$syncRotatio, _me$header;

        instance.innerItem = false;
        (_instance$syncRotatio = instance.syncRotationToDock) === null || _instance$syncRotatio === void 0 ? void 0 : _instance$syncRotatio.call(instance, (_me$header = me.header) === null || _me$header === void 0 ? void 0 : _me$header.dock);
        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (toolConfigs[name]) {
            me.onConfigChange({
              name: 'tools',
              value: manager.target
            });
          }
        });
        me.onChildAdd(instance);
      },

      setup(config, name) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, me.toolDefaults['*'], me.toolDefaults[name], config);
        config.parent = me; // so parent can be accessed during construction

        config.ref = name;
        return config;
      }

    }));
    manager.update(tools);

    if (!oldTools) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  }

});

/***/ }),

/***/ "./lib/Core/widget/panel/CollapseTool.js":
/*!***********************************************!*\
  !*** ./lib/Core/widget/panel/CollapseTool.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollapseTool; });
/* harmony import */ var _Tool_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Tool.js */ "./lib/Core/widget/Tool.js");
var productName = 'gantt';

/**
 * @module Core/widget/panel/CollapseTool
 */

const autoAlign = panel => panel.collapsed && panel.collapsible.direction === 'right' ? 'start' : 'end';
/**
 * This ensures the correct icon is used to represent the {@link Core.widget.Panel panel's}
 * {@link Core.widget.Panel#config-collapsed} state.
 * @extends Core/widget/Tool
 *
 * @classType collapsetool
 * @internal
 */


class CollapseTool extends _Tool_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CollapseTool';
  } // Factoryable type name


  static get type() {
    return 'collapsetool';
  }

  static get configurable() {
    return {
      /**
       * Set to `false` to disable automatic adjustment of the {@link #config-align} config based on the state
       * of the panel's {@link Core.widget.Panel#config-collapsed} config and the
       * {@link Core.widget.panel.PanelCollapser#config-direction}.
       *
       * If this is set to a function, that function is called passing the owning `Panel` instance and its
       * return value is assigned to the {@link #config-align} config.
       * @config {Boolean|Function}
       * @default
       */
      autoAlign: true,
      collapsed: null,
      collapsify: false,
      // ...unaffected when the panel is collapsed
      direction: 'up'
    };
  }

  compose() {
    const {
      collapsed,
      direction
    } = this;
    return {
      class: {
        [`b-icon-collapse-${direction}`]: 1,
        'b-collapsed': collapsed
      }
    };
  }

  changeAutoAlign(v) {
    return v === true ? autoAlign : v;
  }

  syncAutoAlign() {
    const {
      autoAlign
    } = this;

    if (autoAlign) {
      this.align = autoAlign(this.owner);
    }
  }

  updateAutoAlign() {
    this.syncAutoAlign();
  }

  updateCollapsed() {
    this.syncAutoAlign();
  }

  updateDirection() {
    this.syncAutoAlign();
  }

} // Register this widget type with its Factory

CollapseTool.initClass();
CollapseTool._$name = 'CollapseTool';

/***/ }),

/***/ "./lib/Core/widget/panel/PanelCollapser.js":
/*!*************************************************!*\
  !*** ./lib/Core/widget/panel/PanelCollapser.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelCollapser; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _CollapseTool_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CollapseTool.js */ "./lib/Core/widget/panel/CollapseTool.js");
var productName = 'gantt';








/**
 * @module Core/widget/panel/PanelCollapser
 */

const defaultedDirectionRe = /^(?:UP|DOWN|LEFT|RIGHT)$/,
      emptyArray = [],
      emptySplit = [emptyArray, emptyArray],
      revealerCls = 'b-panel-collapse-revealer',
      sideDockRe = /^(?:left|right)$/i,
      {
  round
} = Math,
      canonicalDirection = ['up', 'down', 'left', 'right'].reduce((o, v) => {
  o[v.toUpperCase()] = o[v] = v;
  return o;
}, {}),
      clipByDock = {
  top: ['top', 'bottom'],
  right: ['right', 'left'],
  bottom: ['bottom', 'top'],
  left: ['left', 'right']
},
      collapseDirectionByPlacement = {
  hl: 'LEFT',
  hr: 'RIGHT',
  vb: 'DOWN',
  vt: 'UP'
},
      crossAxis = {
  h: 'w',
  w: 'h'
},
      dockByDirection = {
  up: 'top',
  right: 'right',
  down: 'bottom',
  left: 'left'
},
      dockIsHorz = {
  top: false,
  right: true,
  bottom: false,
  left: true
},
      directionByDock = {
  top: 'UP',
  right: 'RIGHT',
  bottom: 'DOWN',
  left: 'LEFT'
};
let idSeed = 0;
/**
 * Instances of this class are used to implement the {@link Core.widget.Panel#config-collapsible} config.
 *
 * For example, the following creates an instance of this class:
 *
 * ```javascript
 *      {
 *          type        : 'panel',
 *          collapsible : true
 *      }
 * ```
 * In this mode, a panel will collapse inline, within its container.
 * @classtype inline
 */

class PanelCollapser extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'PanelCollapser';
  } // Factoryable type name


  static get type() {
    return 'inline';
  }

  static get configurable() {
    return {
      /**
       * An animation config object.
       * @config {Object} animation
       * @property {Number} [animation.duration=200] The duration of the animation (in milliseconds).
       */
      animation: {
        duration: 200
      },

      /**
       * Tracks whether or not the panel is collapsed.
       * @config {Boolean}
       * @private
       */
      collapsed: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * Specifies the direction of panel collapse. The default value for this config is determined dynamically
       * based on the {@link Core.widget.Panel#config-header header's} `dock` property and the containing layout's
       * flex direction and, therefore, often does not need to be explicitly specified.
       *
       * This config can be any of the following:
       * - `'up'`
       * - `'down'`
       * - `'left'`
       * - `'right'`
       *
       * @config {String}
       */
      direction: null,

      /**
       * The tooltip to use for the collapse tool when the panel is expanded.
       * @config {String}
       */
      collapseTooltip: 'L{Collapse}',

      /**
       * The tooltip to use for the expand tool when the panel is collapsed.
       * @config {String}
       */
      expandTooltip: 'L{Expand}',
      panel: {
        value: null,
        $config: 'nullify'
      },

      /**
       * To support the panel's collapsed size, a minimum width and height may be assigned to the panel's header,
       * based on this config and the panel's positioning style.
       *
       * When a panel is collapsed it may need to retain the pre-collapse dimension perpendicular to the collapse
       * {@link #config-direction}. For example, the height of a panel that collapses to the left. The dimension
       * parallel to the collapse (the width in this example) may also need to be supported using the pre-collapse
       * size of the panel's header.
       *
       * When this config is set to `true`, or by default when the owning panel is `position: absolute`, both
       * axes are given a minimum size based on the panel's pre-collapse size. When this config is `false`, no
       * minimum sizes will be assigned.
       *
       * This config can also be a string containing the single letters 'w' and/or 'h' indicating which axis/axes
       * of the panel header should be assigned a minimum size. That is, 'w' to assign only a minimum width, 'h'
       * for only a minimum height, or 'wh' to assign both.
       *
       * @config {String|Boolean}
       * @internal
       */
      supportAxis: null,

      /**
       * The collapse/expand tool. The `type` of this instance should not be changed but the tool instance can be
       * configured in other ways via this config property.
       * @config {Object|Core.widget.Tool}
       */
      tool: {
        type: 'collapsetool',

        handler(ev) {
          var _this$collapsible;

          // NOTE: As a tool, our this pointer is the Panel so we use it to access the current collapser
          (_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.onCollapseClick(ev);
        }

      }
    };
  }

  static get factoryable() {
    return {
      defaultType: 'inline'
    };
  }

  get collapsing() {
    return this.collapsingExpanding === 'collapsing';
  }

  get collapsingExpanding() {
    var _this$currentOperatio;

    const state = (_this$currentOperatio = this.currentOperation) === null || _this$currentOperatio === void 0 ? void 0 : _this$currentOperatio.collapsing;
    return state == null ? null : state ? 'collapsing' : 'expanding';
  }

  get currentDock() {
    var _this$panel$header$do, _this$panel, _this$panel$header, _this$panel$header$do2;

    return (_this$panel$header$do = (_this$panel = this.panel) === null || _this$panel === void 0 ? void 0 : (_this$panel$header = _this$panel.header) === null || _this$panel$header === void 0 ? void 0 : (_this$panel$header$do2 = _this$panel$header.dock) === null || _this$panel$header$do2 === void 0 ? void 0 : _this$panel$header$do2.toLowerCase()) !== null && _this$panel$header$do !== void 0 ? _this$panel$header$do : 'top';
  }

  get expanding() {
    return this.collapsingExpanding === 'expanding';
  }

  get collapseTool() {
    var _this$panel2, _this$panel2$tools;

    return (_this$panel2 = this.panel) === null || _this$panel2 === void 0 ? void 0 : (_this$panel2$tools = _this$panel2.tools) === null || _this$panel2$tools === void 0 ? void 0 : _this$panel2$tools.collapse;
  }

  get collapseDim() {
    return sideDockRe.test(this.collapseDir) ? 'width' : 'height';
  }

  getCollapseDir(canonical) {
    let {
      direction,
      panel
    } = this;

    if (!direction || defaultedDirectionRe.test(direction)) {
      const placement = panel === null || panel === void 0 ? void 0 : panel.placement;

      if (placement) {
        direction = collapseDirectionByPlacement[placement];
      } else {
        var _panel$header;

        direction = directionByDock[(panel === null || panel === void 0 ? void 0 : (_panel$header = panel.header) === null || _panel$header === void 0 ? void 0 : _panel$header.dock) || 'top'];
      } // direction in this case will be uppercase so that we can tell later that it was a default value vs a
      // user-defined one

    }

    return canonical ? canonicalDirection[direction] : direction;
  }

  get collapseDir() {
    return this.getCollapseDir(true);
  }

  get collapseDock() {
    const {
      panel
    } = this,
          headerDock = panel.hasHeader && panel.expandedHeaderDock,
          dock = dockByDirection[this.collapseDir];
    return headerDock && dockIsHorz[dock] === dockIsHorz[headerDock] ? headerDock : dock;
  }

  get toolsConfig() {
    const {
      direction,
      tool
    } = this;
    return tool && {
      collapse: _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
        direction: direction.toLowerCase()
      }, tool)
    };
  }

  beforeCollapse(operation) {// TODO
  }

  changeTool(tool) {
    const me = this,
          {
      panel
    } = me;

    if (me.isConfiguring || me.isDestroying || !panel || panel.isDestroying) {
      return tool;
    }

    panel.tools = {
      collapse: tool
    };
  }

  collapse(collapsed) {
    var _collapsed, _currentOperation, _currentOperation$ani, _currentOperation2, _currentOperation2$an;

    const me = this,
          {
      panel
    } = me,
          operation = {
      id: ++idSeed,
      completed: false,
      panel
    };
    let {
      currentOperation
    } = me;
    collapsed = (_collapsed = collapsed) !== null && _collapsed !== void 0 ? _collapsed : true;

    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isObject(collapsed)) {
      operation.collapsed = true;
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign(operation, collapsed);
      collapsed = operation.collapsed;
      delete operation.collapsed;
    }

    operation.collapsing = collapsed;
    operation.previous = (_currentOperation = currentOperation) !== null && _currentOperation !== void 0 ? _currentOperation : null;

    if (collapsed !== me.collapsed) {
      // We aren't in the desired state (yet)
      if (currentOperation) {
        if (currentOperation.collapsing !== collapsed) {
          // we are not heading to the desired state, so revert it:
          operation.animation = currentOperation.animation.revert({
            finalize() {
              var _me$collapseFinalize;

              (_me$collapseFinalize = me.collapseFinalize) === null || _me$collapseFinalize === void 0 ? void 0 : _me$collapseFinalize.call(me, operation, true); // ?. in case we are destroyed
            }

          });
          operation.collapsing = collapsed;
          currentOperation = operation;
        }
      } else {
        // No currentOperation, so this is the first request to change state.
        // don't mutate our parameter or config object
        operation.animation = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].clone(('animation' in operation ? operation : me).animation);

        if (me.beforeCollapse(operation) !== false) {
          if (operation.animation) {
            operation.animation.finalize = complete => {
              var _me$collapseFinalize2;

              return (_me$collapseFinalize2 = me.collapseFinalize) === null || _me$collapseFinalize2 === void 0 ? void 0 : _me$collapseFinalize2.call(me, operation, complete);
            };
          }

          panel.changingCollapse = true;
          me[collapsed ? 'collapseBegin' : 'expandBegin'](operation);

          if (operation.animation) {
            currentOperation = operation;
          } else {
            operation.completed = true;
            me[collapsed ? 'collapseEnd' : 'expandEnd'](operation);
          }

          panel.changingCollapse = false;

          if (!operation.animation) {
            me.onComplete(collapsed ? 'collapse' : 'expand');
          }
        }
      }
    } else if (currentOperation && currentOperation.collapsing !== collapsed) {
      // We are still in the desired state but we are animating to the now undesired state...
      me[collapsed ? 'expandRevert' : 'collapseRevert'](operation); // revert the animation and clear it when done

      operation.animation = currentOperation.animation.revert({
        finalize() {
          var _me$collapseFinalize3;

          (_me$collapseFinalize3 = me.collapseFinalize) === null || _me$collapseFinalize3 === void 0 ? void 0 : _me$collapseFinalize3.call(me, operation, false); // ?. in case we are destroyed
        }

      });
      currentOperation = operation;
    } // else if (currentOperation) we are already reverting


    me.currentOperation = currentOperation;
    return (_currentOperation$ani = (_currentOperation2 = currentOperation) === null || _currentOperation2 === void 0 ? void 0 : (_currentOperation2$an = _currentOperation2.animation) === null || _currentOperation2$an === void 0 ? void 0 : _currentOperation2$an.done()) !== null && _currentOperation$ani !== void 0 ? _currentOperation$ani : Promise.resolve(collapsed === me.collapsed);
  }

  collapseFinalize(operation, complete) {
    const me = this,
          {
      currentOperation,
      panel
    } = me,
          action = panel.collapsed ? 'expand' : 'collapse';

    if (currentOperation === operation) {
      me.currentOperation = null;
      operation.completed = complete;
      panel.changingCollapse = true;
      me[action + 'End'](operation);
      panel.changingCollapse = false;
      complete && me.onComplete(action);
    }
  }

  applyHeaderDock(collapsed, flush = true) {
    const me = this,
          {
      currentDock,
      panel
    } = me,
          dock = collapsed ? me.collapseDock : panel.expandedHeaderDock;

    if (dock !== currentDock && panel.hasHeader) {
      panel.header = {
        dock
      };
      flush && panel.recompose.flush();
    }
  }

  composeHeader(header) {
    header.class[revealerCls] = 1;
    return header;
  }

  composeTitle(title) {
    title.class[revealerCls] = 1;
    return title;
  }

  collapseBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDim,
      collapseTool,
      panel
    } = me,
          {
      element
    } = panel,
          collapseToolClasses = collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList;
    me.configuredWidth = panel._lastWidth;
    me.configuredHeight = panel._lastHeight;
    me.applyHeaderDock(true); // Lock the bodyWrap to its current size while we animate the height of the outer element and clip it. We
    // also leave the bodyWrap locked to its expanded size to avoid crushing the content while collapsed since
    // that could cause virtual rendering widgets to have 0 height to work with and explode or at least waste
    // time adjusting back and forth.

    const panelRect = panel.rectangle(),
          bodyWrapRect = me.lockInnerSize().moveTo(0, 0),
          // we must lockInnerSize even if !animation
    bodyWrapClipRect = bodyWrapRect.clone(),
          clipDir = clipByDock[me.collapseDock];

    if (animation) {
      var _panel$headerElement;

      bodyWrapClipRect[clipDir[0]] = bodyWrapClipRect[clipDir[1]];
      element.classList.add('b-collapsing'); // Flip to collapsed while skipping the animation (via b-collapsing)

      collapseToolClasses === null || collapseToolClasses === void 0 ? void 0 : collapseToolClasses.add('b-collapsed', 'b-collapsing');
      const headerRect = (_panel$headerElement = panel.headerElement) === null || _panel$headerElement === void 0 ? void 0 : _panel$headerElement.getBoundingClientRect();

      if (collapseToolClasses) {
        collapseToolClasses.remove('b-collapsed'); // put the tool back to pre-collapse state

        panel.rectangle(); // force a layout to allow us to enable transitions

        collapseToolClasses.remove('b-collapsing'); // enable transitions

        collapseToolClasses.add('b-collapsed'); // start the tool's transition
      }

      animation.element = element;
      animation.retain = true;
      animation[collapseDim] = {
        from: round(panelRect[collapseDim]),
        to: round((headerRect === null || headerRect === void 0 ? void 0 : headerRect[collapseDim]) || 0)
      }; // While we animate the panel, we also need to clip the bodyWrap or it would be exposed on cases where
      // overflow=visible (like a tooltip w/anchor element)... doubtful we'd collapse such a panel but perhaps
      // there are  (or will be) other reasons to set overflow=visible on the panel.

      animation.items = [{
        element: panel.bodyWrapElement,
        retain: false,
        clip: {
          from: `rect(${bodyWrapRect})`,
          to: `rect(${bodyWrapClipRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__["default"].run(animation);
    }
  }

  collapseEnd(operation) {
    const me = this;
    me.panel.element.classList.remove('b-collapsing');

    if (operation.completed) {
      me.collapsed = true;
    } else {
      me.applyHeaderDock(false);
      me.restoreConfiguredSize();
      me.lockInnerSize(false);
    }
  }

  collapseRevert(operation) {
    var _this$collapseTool;

    (_this$collapseTool = this.collapseTool) === null || _this$collapseTool === void 0 ? void 0 : _this$collapseTool.element.classList.remove('b-collapsed');
  }

  expandBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDim,
      collapseTool,
      panel
    } = me,
          {
      element
    } = panel,
          fromRect = panel.rectangle();
    element.classList.remove('b-collapsed', 'b-collapsing'); // This style is retained by the collapse animation and must be cleared to get a right measurement of the
    // expanded panel

    panel.element.style[collapseDim] = '';
    me.restoreConfiguredSize();
    me.lockInnerSize(false); // unlock the bodyWrap size

    const toRect = panel.rectangle(),
          // Lock the bodyWrap to its current size while we animate the height of the outer element and unclip it:
    bodyWrapRect = me.lockInnerSize().moveTo(0, 0),
          bodyWrapClipRect = bodyWrapRect.clone(),
          clipDir = clipByDock[me.collapseDock];
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.remove('b-collapsed');

    if (animation) {
      bodyWrapClipRect[clipDir[0]] = bodyWrapClipRect[clipDir[1]];
      element.classList.add('b-collapsed', 'b-expanding');
      animation.element = element;
      animation[collapseDim] = {
        from: round(fromRect[collapseDim]),
        to: round(toRect[collapseDim])
      };
      animation.items = [{
        element: panel.bodyWrapElement,
        retain: false,
        clip: {
          from: `rect(${bodyWrapClipRect})`,
          to: `rect(${bodyWrapRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__["default"].run(animation);
    }
  }

  expandEnd(operation) {
    const me = this;
    me.panel.element.classList.remove('b-expanding');

    if (operation.completed) {
      me.collapsed = false;
      me.applyHeaderDock(false);
      me.restoreConfiguredSize();
      me.lockInnerSize(false);
    }
  }

  expandRevert(operation) {
    var _this$collapseTool2;

    (_this$collapseTool2 = this.collapseTool) === null || _this$collapseTool2 === void 0 ? void 0 : _this$collapseTool2.element.classList.add('b-collapsed');
  }

  get innerElement() {
    return this.panel.bodyWrapElement;
  }

  get innerSizeElement() {
    return this.innerElement;
  }

  get supportAxis() {
    let {
      _supportAxis
    } = this;
    const fullSupport = _supportAxis === true;

    if (fullSupport || _supportAxis == null) {
      _supportAxis = this.collapseDim[0]; // 'w' or 'h'

      if (fullSupport || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(this.panel.element, 'position') === 'absolute') {
        _supportAxis += crossAxis[_supportAxis];
      }
    }

    return _supportAxis || '';
  }

  lockInnerSize(lock = true) {
    const me = this,
          {
      innerElement,
      panel
    } = me,
          supportAxis = lock ? me.supportAxis : '',
          panelEl = panel.element,
          headerEl = panel.headerElement,
          headerRect = lock && headerEl && _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(headerEl, panelEl),
          innerRect = lock && _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(me.innerSizeElement, panelEl),
          innerStyle = innerElement.style; // We have to prop up the cross-axis of the panel header in cases where the panel is not receiving a size from
    // its container (an auto layout). Otherwise, the header may shrink in width (when docked top) once the bodyWrap
    // flips to position:absolute... it will not longer be providing a natural size to prop up the panel so we
    // shift that responsibility to the header element while we are collapsed.

    if (headerEl) {
      headerEl.style.minWidth = supportAxis.includes('w') ? `${headerRect.width}px` : '';
      headerEl.style.minHeight = supportAxis.includes('h') ? `${headerRect.height}px` : '';
    } // We must set w/h on the inner element before we flip it to position:absolute to avoid layout changes on items
    // in the panel (like grids)


    innerStyle.width = lock ? `${innerRect.width}px` : '';
    innerStyle.height = lock ? `${innerRect.height}px` : '';
    innerElement.classList[lock ? 'add' : 'remove']('b-panel-collapse-size-locker');
    return innerRect;
  }

  onCollapseClick(e) {
    let collapsed = this.collapsing ? false : this.expanding ? true : !this.collapsed;

    if (e.altKey) {
      collapsed = {
        animation: null,
        collapsed
      };
    }

    this.collapse(collapsed);
  }

  onComplete(action) {
    var _this$panel3;

    (_this$panel3 = this.panel) === null || _this$panel3 === void 0 ? void 0 : _this$panel3.trigger(action);
  }

  onHeaderClick({
    event
  }) {
    if (event.button === 0 && this.panel.collapsed && event.target.classList.contains(revealerCls)) {
      this.onRevealerClick();
    }
  }

  onPanelConfigChange({
    name,
    value
  }) {
    const me = this,
          {
      panel
    } = me;

    if (name === 'collapsed') {
      if (!(value && panel.isConfiguring)) {
        me.collapsed = value;
      }
    } else if (name === 'header' && !panel.changingCollapse) {
      me.syncDirection();
    }
  }

  onPanelPaint() {
    this.syncDirection();
  }

  onRevealerClick() {
    this.panel.expand();
  }

  restoreConfiguredSize(which) {
    var _which;

    const {
      configuredHeight,
      configuredWidth,
      panel
    } = this;
    which = (_which = which) !== null && _which !== void 0 ? _which : 'wh';

    if (configuredWidth != null && which.includes('w')) {
      panel.width = configuredWidth;
    }

    if (configuredHeight != null && which.includes('h')) {
      panel.height = configuredHeight;
    }
  }

  splitHeaderItems() {
    return emptySplit;
  }

  syncDirection() {
    const me = this,
          {
      direction
    } = me;

    if (!direction || defaultedDirectionRe.test(direction)) {
      // getCollapseDir() returns uppercase values when they are being defaulted, so we can tell if the value
      // is from the user (which must be lowercase)
      me.direction = me.getCollapseDir();
    }
  }

  updateCollapsed(collapsed) {
    const {
      collapseTool,
      panel
    } = this;

    if (panel) {
      panel.collapsed = collapsed;
      panel.element.classList[collapsed ? 'add' : 'remove']('b-collapsed');
    }

    if (collapseTool) {
      collapseTool.collapsed = collapsed;
    }
  }

  updateDirection(direction) {
    const {
      collapseTool,
      panel
    } = this;

    if (collapseTool) {
      collapseTool.direction = canonicalDirection[direction];
    }

    if (panel !== null && panel !== void 0 && panel.rendered) {
      panel.recompose();
    }
  }

  updatePanel(panel) {
    var _me$panelChangeDetach, _me$panelListeners;

    const me = this;
    me.syncDirection();
    (_me$panelChangeDetach = me.panelChangeDetacher) === null || _me$panelChangeDetach === void 0 ? void 0 : _me$panelChangeDetach.call(me);
    me.panelChangeDetacher = panel && _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].after(panel, 'onConfigChange', 'onPanelConfigChange', me, {
      return: false
    });
    (_me$panelListeners = me.panelListeners) === null || _me$panelListeners === void 0 ? void 0 : _me$panelListeners.call(me);
    me.panelListeners = panel && !panel.isPainted ? panel.on({
      once: true,

      paint() {
        if (panel.initialConfig.collapsed) {
          panel.collapsed = true;
        }
      }

    }) : null;
  }

  wrapCollapser(key, body) {
    return [key, body];
  }

}
PanelCollapser.maps = {
  clipByDock,
  dockByDirection,
  dockIsHorz
}; // Register this widget type with its Factory

PanelCollapser.initClass();
PanelCollapser._$name = 'PanelCollapser';

/***/ }),

/***/ "./lib/Core/widget/panel/PanelCollapserOverlay.js":
/*!********************************************************!*\
  !*** ./lib/Core/widget/panel/PanelCollapserOverlay.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelCollapserOverlay; });
/* harmony import */ var _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony import */ var _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






/**
 * @module Core/widget/panel/PanelCollapserOverlay
 */

const {
  dockIsHorz
} = _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__["default"].maps,
      clipByDir = {
  up: ['top', 'bottom'],
  right: ['right', 'left'],
  down: ['bottom', 'top'],
  left: ['left', 'right']
},
      collapseExposeEdge = {
  top: 0,
  down: 0,
  left: 1,
  bottom: 2,
  up: 2,
  right: 3
},
      emptyObject = {},
      translateByDir = {
  up: {
    from: `translate(0,0)`,
    to: 'translate(0,-100%)'
  },
  down: {
    from: `translate(0,0)`,
    to: 'translate(0,100%)'
  },
  left: {
    from: `translate(0,0)`,
    to: 'translate(-100%,0)'
  },
  right: {
    from: `translate(0,0)`,
    to: 'translate(100%,0)'
  }
};
/**
 * A panel collapse implementation that adds the ability to reveal the collapsed panel as a floating overlay.
 * @extends Core/widget/panel/PanelCollapser
 * @classtype overlay
 */

class PanelCollapserOverlay extends _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'PanelCollapserOverlay';
  }

  static get type() {
    return 'overlay';
  }

  static get configurable() {
    return {
      /**
       * The number of milliseconds to wait once the mouse leaves a {@link Core.widget.Panel#config-revealed}
       * panel before returning to an unrevealed state. Clicking outside the revealed panel will immediately
       * return the panel to its collapsed state.
       *
       * This may be disabled by configuring {@link #config-autoClose} as `null`.
       *
       * If this value is negative, the panel will not automatically recollapse due to the mouse leaving, however,
       * clicks outside the panel will still recollapse it.
       *
       * If this value is `null`, the panel will not automatically recollapse for either outside clicks or if
       * the mouse leaves the panel.
       * @config {Number}
       * @default
       */
      autoCloseDelay: 1000,

      /**
       * By default, clicking outside the revealed overlay hides the revealed overlay.
       *
       * If the revealed overlay was shown using the {@link #property-recollapseTool}
       * then moving the mouse outside of the revealed overlay hides the revealed overlay.
       *
       * Configure this as `false` to disable auto hiding, making overlayed
       * state permanent, and changeable using the {@link #function-toggleReveal} method.
       * @config {Boolean}
       * @default
       */
      autoClose: true,
      revealing: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * The reveal/hide tool which slides the collapsed panel over the top of the UI.
       * @member {Core.widget.Tool} recollapseTool
       */

      /**
       * The reveal/hide tool which slides the collapsed panel over the top of the UI.
       * 
       * The `type` of this instance should not be changed but the tool instance can be
       * configured in other ways via this config property.
       * @config {Object|Core.widget.Tool}
       */
      recollapseTool: {
        type: 'collapsetool',
        cls: 'b-recollapse',
        collapsify: 'overlay',

        handler() {
          var _this$collapsible;

          // NOTE: As a tool, our this pointer is the Panel so we use it to access the current collapser
          (_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.toggleReveal();
        }

      }
    };
  }

  static get delayable() {
    return {
      doAutoClose: 0
    };
  }

  doAutoClose() {
    this.toggleReveal(false);
  }

  updateAutoCloseDelay(delay) {
    const {
      doAutoClose
    } = this;

    if (!(doAutoClose.suspended = delay == null || delay < 0)) {
      doAutoClose.delay = delay;
      doAutoClose.immediate = !delay;
    }
  }

  changeRecollapseTool(tool) {
    const me = this,
          {
      panel
    } = me;

    if (me.isConfiguring || me.isDestroying || !panel || panel.isDestroying) {
      return tool;
    }

    panel.tools = {
      recollapse: tool
    };
  }

  beforeCollapse(operation) {
    if (super.beforeCollapse(operation) === false) {
      return false;
    }

    if (this.panel.revealed) {
      operation.animation = null;
    }
  }

  applyHeaderDock(collapsed, flush = true) {
    var _this$panel;

    (_this$panel = this.panel) === null || _this$panel === void 0 ? void 0 : _this$panel.recompose();
    super.applyHeaderDock(collapsed, flush);
  }

  collapseBegin(operation) {
    const me = this,
          {
      collapseDir,
      innerElement
    } = me,
          {
      animation
    } = operation,
          {
      collapseTool,
      panel
    } = me;
    me.configuredWidth = panel._lastWidth;
    me.configuredHeight = panel._lastHeight;
    me.applyHeaderDock(true);
    const innerElementRect = me.lockInnerSize();
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.add('b-collapsed');

    if (animation) {
      panel.element.classList.add('b-collapsing');
      innerElementRect.moveTo(0, 0);
      const innerElementClipRect = innerElementRect.clone(),
            clipDir = clipByDir[collapseDir];
      innerElementClipRect[clipDir[0]] = innerElementClipRect[clipDir[1]];
      animation.element = me.innerElement;
      animation.transform = translateByDir[collapseDir];
      animation.items = [{
        element: innerElement,
        clip: {
          from: `rect(${innerElementRect})`,
          to: `rect(${innerElementClipRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__["default"].run(animation);
    }
  }

  onComplete(action) {
    var _me$autoCloseLeaveDet, _me$autoCloseClickDet;

    super.onComplete(action);
    const me = this,
          {
      panel
    } = me,
          {
      element
    } = panel;
    me.autoCloseLeaveDetacher = (_me$autoCloseLeaveDet = me.autoCloseLeaveDetacher) === null || _me$autoCloseLeaveDet === void 0 ? void 0 : _me$autoCloseLeaveDet.call(me);
    me.autoCloseClickDetacher = (_me$autoCloseClickDet = me.autoCloseClickDetacher) === null || _me$autoCloseClickDet === void 0 ? void 0 : _me$autoCloseClickDet.call(me); // The act of hiding the revealed panel ("unrevealing") causes a mouseleave event (once the panel slides out
    // from under the cursor) and that starts the autoClose timer. If the user then reveals the panel again within
    // the 1sec delay (by default), the autoClose timer will still fire and unreveal the panel.

    me.doAutoClose.cancel();

    if (action === 'reveal' && me.autoClose) {
      // Only listen for mouseleave to close if we contain focus.
      // If we do not, then we have been revealed using the API from some other
      // part of the UI, so mouseleave closing would not be appropriate.
      if (panel.containsFocus) {
        me.autoCloseLeaveDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          element,
          mouseenter: ev => {
            me.doAutoClose.cancel();
          },
          mouseleave: ev => {
            me.doAutoClose();
          }
        });
      }

      me.autoCloseClickDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: document.body,
        mousedown: ev => {
          if (ev.target !== element && !element.contains(ev.target) && me.autoCloseDelay != null) {
            var _panel$focusInEvent;

            // Detect the UI element which invoked the reveal.
            // If the panel contains focus, use the "from" element.
            // If not, then the focus is still on the invoking element.
            const invokingElement = panel.containsFocus ? (_panel$focusInEvent = panel.focusInEvent) === null || _panel$focusInEvent === void 0 ? void 0 : _panel$focusInEvent.relatedTarget : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getActiveElement(element);

            if (!invokingElement.contains(ev.target)) {
              me.doAutoClose.now();
            }
          }
        }
      });
    }
  }

  expandBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDir,
      collapseTool,
      innerElement,
      panel
    } = me,
          {
      element
    } = panel;
    element.classList.remove('b-collapsed', 'b-collapsing');
    me.restoreConfiguredSize();
    me.lockInnerSize(false); // unlock the bodyWrap size

    const toRect = me.lockInnerSize().moveTo(0, 0),
          clipRect = toRect.clone(),
          clipDir = clipByDir[collapseDir];
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.remove('b-collapsed');

    if (animation) {
      element.classList.add('b-collapsed', 'b-expanding');
      clipRect[clipDir[0]] = clipRect[clipDir[1]];
      animation.element = innerElement;
      animation.transform = {
        from: translateByDir[collapseDir].to,
        to: translateByDir[collapseDir].from
      };
      animation.clip = {
        from: `rect(${clipRect})`,
        to: `rect(${toRect})`
      };
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__["default"].run(animation);
    }
  }

  expandEnd(operation) {
    super.expandEnd(operation);
    const {
      panel
    } = this;

    if (operation.completed) {
      panel.revealed = false;
    }

    panel.element.classList.remove('b-expanding');
  }

  expandRevert(operation) {
    super.expandRevert(operation);
    this.panel.element.classList.add('b-expanding');
  }

  get innerElement() {
    return this.panel.overlayElement;
  }

  get innerSizeElement() {
    return this.panel.element;
  }

  get toolsConfig() {
    const me = this,
          {
      direction
    } = me,
          config = super.toolsConfig,
          tool = me.recollapseTool;

    if (tool) {
      return _objectSpread(_objectSpread({}, config), {}, {
        recollapse: tool && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
          direction: direction.toLowerCase()
        }, tool)
      });
    }

    return config;
  }

  lockInnerSize(lock = true) {
    const me = this,
          {
      panel
    } = me,
          panelRect = lock && panel.rectangle(),
          // must read this before we call super
    inset = lock ? [0, 0, 0, 0] : '',
          // now we can call super:
    innerRect = super.lockInnerSize(lock); // The panel overlay is visible because we switch to "overflow:visible" in collapsed state. By doing this,
    // however, the header animation undesirably escapes as well. Fortunately, we can use the clip-path to hide
    // this by only allowing the desired side to escape while all other sides remain clipped. Even more fortunate
    // for us is that clip-path is expressed as an inset from the normal rectangle of the element (so we don't
    // need to adjust it if the collapsed panel is resized), and further, unlike CSS path style, clip-path works
    // for all elements not only absolutely positioned ones.

    if (lock) {
      // TODO see if there's a way to read the box-shadow style to pick up the right value (10 is the default)
      inset[collapseExposeEdge[me.collapseDir]] = `-${panelRect[me.collapseDim] + 10}px`;
    }

    panel.element.style.clipPath = lock ? `inset(${inset.join(' ')}` : '';
    return innerRect;
  }

  onOverlayTransitionDone(ev) {
    const me = this,
          {
      panel
    } = me;

    if (ev.srcElement === panel.overlayElement && me.revealing) {
      me.revealing = false;
      me.onComplete(panel.revealed ? 'reveal' : 'unreveal');
    }
  }

  onRevealerClick() {
    this.toggleReveal();
  }

  splitHeaderItems({
    as,
    dock
  } = emptyObject) {
    var _this$panel2;

    return (_this$panel2 = this.panel) === null || _this$panel2 === void 0 ? void 0 : _this$panel2.splitHeaderItems({
      as,
      dock,
      overlay: true
    });
  }
  /**
   * Toggles the revealed state of the Panel to match the passed boolean flag.
   * @param {Boolean} state `true` to reveal the overlay, `false` to hide it.
   */


  toggleReveal(state) {
    const {
      panel
    } = this;

    if (panel.collapsed) {
      if (state == null) {
        state = !panel.revealed;
      }

      if (panel.revealed !== state) {
        this.revealing = true;
        panel.revealed = !panel.revealed;
      }
    }
  }

  updateRevealing(value) {
    const me = this,
          horzDirRe = /left|right/i,
          {
      panel
    } = me,
          dim = horzDirRe.test(me.collapseDir) ? 'height' : 'width';

    if (panel) {
      me.innerElement.style[dim] = panel.rectangle()[dim] + 'px';
      panel.element.classList[value ? 'add' : 'remove']('b-panel-overlay-revealing');
    }
  }

  wrapCollapser(key, body) {
    var _panel$tools;

    const me = this,
          {
      collapseDir,
      panel
    } = me,
          {
      expandedHeaderDock,
      header,
      uiClassList
    } = panel,
          recollapse = (_panel$tools = panel.tools) === null || _panel$tools === void 0 ? void 0 : _panel$tools.recollapse,
          [before, after] = me.splitHeaderItems({
      dock: me.collapseDock,
      as: 'element'
    }),
          horz = dockIsHorz[expandedHeaderDock],
          title = panel.hasHeader ? panel.title || (header === null || header === void 0 ? void 0 : header.title) || '\xA0' : null;

    if (recollapse) {
      recollapse.direction = collapseDir;
    }

    return ['overlayElement', {
      class: _objectSpread(_objectSpread({}, uiClassList), {}, {
        [`b-panel-overlay-header-${expandedHeaderDock}`]: 1,
        [`b-panel-overlay-${collapseDir}`]: 1,
        [`b-${horz ? 'h' : 'v'}box`]: 1,
        'b-panel-overlay': 1,
        'b-box-center': 1
      }),
      listeners: {
        transitionend: ev => me.onOverlayTransitionDone(ev)
      },
      children: {
        overlayHeaderElement: title && {
          tag: 'header',
          class: _objectSpread(_objectSpread({}, uiClassList), {}, {
            [`b-dock-${expandedHeaderDock}`]: 1,
            'b-panel-header': 1,
            'b-panel-overlay-header': 1
          }),
          children: [...before, {
            reference: 'overlayTitleElement',
            html: title,
            class: _objectSpread(_objectSpread({}, uiClassList), {}, {
              [`b-align-${(header === null || header === void 0 ? void 0 : header.titleAlign) || 'start'}`]: 1,
              'b-header-title': 1
            })
          }, ...after]
        },
        [key]: body
      }
    }];
  }

} // Register this widget type with its Factory

PanelCollapserOverlay.initClass();
PanelCollapserOverlay._$name = 'PanelCollapserOverlay';

/***/ }),

/***/ "./lib/Core/widget/trial/TrialButton.js":
/*!**********************************************!*\
  !*** ./lib/Core/widget/trial/TrialButton.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TrialButton; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _TrialPanel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TrialPanel.js */ "./lib/Core/widget/trial/TrialPanel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Core/widget/trial/TrialButton
 */

/**
 * Download trial button.
 *
 * @classType trialbutton
 * @extends Core/widget/Button
 * @internal
 */

class TrialButton extends _widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get configurable() {
    return {
      /**
       * Product identifier.
       * @config {String}
       */
      productId: null,

      /**
       * Store emails using aweber mail list posting.
       * @config {Boolean}
       */
      storeEmail: false,
      hidden: !_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBryntumOnline(['online', 'test']),
      cls: 'b-raised b-green',
      ref: 'downloadTrial',
      icon: 'b-fa-download',
      text: 'L{downloadTrial}',
      menuIcon: null
    };
  }

  construct(...args) {
    super.construct(...args);
    this.menu = new _TrialPanel_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      autoShow: false,
      productId: this.productId,
      storeEmail: this.storeEmail
    });
  }

}

_defineProperty(TrialButton, "$name", 'TrialButton');

_defineProperty(TrialButton, "type", 'trialbutton');

TrialButton.initClass();
TrialButton._$name = 'TrialButton';

/***/ }),

/***/ "./lib/Core/widget/trial/TrialPanel.js":
/*!*********************************************!*\
  !*** ./lib/Core/widget/trial/TrialPanel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TrialPanel; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Toast_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Toast.js */ "./lib/Core/widget/Toast.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';





/**
 * @module Core/widget/trial/TrialPanel
 */

/**
 * Download trial panel.
 *
 * @classType trialpanel
 * @extends Core/widget/Popup
 * @internal
 */

class TrialPanel extends _Popup_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get configurable() {
    return {
      productId: null,
      storeEmail: false,
      width: 400,
      anchor: true,
      title: 'L{title}',
      align: {
        align: 't-b',
        constrainPadding: 20
      },
      defaults: {
        labelWidth: 100
      },
      items: [{
        type: 'textfield',
        localeClass: this,
        label: 'L{name} <sup>*</sup>',
        name: 'name',
        ref: 'nameField',
        required: true
      }, {
        type: 'textfield',
        inputType: 'email',
        localeClass: this,
        label: 'L{email} <sup>*</sup>',
        name: 'email',
        ref: 'emailField',
        required: true
      }, {
        type: 'textfield',
        localeClass: this,
        label: 'L{company} <sup>*</sup>',
        name: 'company',
        ref: 'companyField',
        required: true
      }, {
        type: 'combo',
        localeClass: this,
        label: 'L{product}',
        editable: false,
        ref: 'productField',
        name: 'productId',
        style: 'margin-bottom : 0',
        items: [{
          id: 'calendar',
          // no-sanity
          downloadId: 'calendar-vanilla',
          text: 'Bryntum Calendar'
        }, {
          id: 'gantt',
          // no-sanity
          downloadId: 'gantt-vanilla',
          text: 'Bryntum Gantt'
        }, {
          id: 'grid',
          // no-sanity
          downloadId: 'grid',
          text: 'Bryntum Grid'
        }, {
          id: 'scheduler',
          // no-sanity
          downloadId: 'scheduler-vanilla',
          text: 'Bryntum Scheduler'
        }, {
          id: 'schedulerpro',
          // no-sanity
          downloadId: 'schedulerpro',
          text: 'Bryntum Scheduler Pro'
        }, {
          id: 'taskboard',
          // no-sanity
          downloadId: 'taskboard-vanilla',
          text: 'Bryntum TaskBoard'
        }],
        required: true
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'listNameField',
        name: 'listname'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'trackingField',
        name: 'custom meta_adtracking'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'redirectField',
        name: 'redirect'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_message',
        value: '1'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_required',
        value: 'name,email,custom company'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_forward_vars',
        value: '0'
      }],
      bbar: [{
        localeClass: this,
        text: 'L{cancel}',
        width: '12em',
        onClick: 'up.onCancelClick'
      }, {
        localeClass: this,
        text: 'L{submit}',
        width: '12em',
        cls: 'b-blue b-raised',
        onClick: 'up.onSubmitClick'
      }]
    };
  }

  get bodyConfig() {
    return this.storeEmail ? Object.assign(super.bodyConfig, {
      tag: 'form',
      method: 'post',
      target: 'aweberFrame',
      action: 'https://www.aweber.com/scripts/addlead.pl'
    }) : super.bodyConfig;
  }

  changeProductId(value) {
    this.widgetMap.productField.value = value;
  }

  async onSubmitClick() {
    const me = this;

    if (!me.isValid) {
      return;
    }

    if (me.storeEmail) {
      me.addToMailList();
    }

    await me.triggerDownload();
  }

  addToMailList() {
    const {
      trackingField,
      redirectField,
      listNameField,
      companyField
    } = this.widgetMap,
          {
      productId
    } = this.values;
    trackingField.value = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getCookie('aw');
    redirectField.value = window.location.href;
    companyField.input.name = 'custom company';

    switch (productId) {
      case 'gantt':
        listNameField.value = 'awlist5314739';
        break;

      case 'scheduler':
      case 'schedulerpro':
        listNameField.value = 'awlist5074881';
        break;

      case 'grid':
        listNameField.value = 'awlist5074883';
        break;

      case 'calendar':
        listNameField.value = 'awlist4475287';
        break;
    }

    this.bodyElement.submit();
  }

  async onCancelClick() {
    await this.hide();
  }

  async triggerDownload() {
    const me = this,
          {
      name,
      email,
      company
    } = me.values;
    let productId = me.values.productId;

    switch (productId) {
      case 'gantt':
      case 'scheduler':
      case 'taskboard':
      case 'calendar':
        productId = `${productId}-vanilla`;
        break;
    }

    const a = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
      parent: document.body,
      tag: 'a',
      download: `bryntum-${productId}-trial.zip`,
      href: `/do_download.php?product_id=${productId}&thename=${name}&email=${email}&company=${company}`
    });
    a.click();
    a.parentElement.removeChild(a);
    await me.hide();
    _Toast_js__WEBPACK_IMPORTED_MODULE_4__["default"].show({
      html: me.L('L{downloadStarting}'),
      timeout: 15000
    });

    if (!me.gaScript && !_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTestEnv) {
      me.gaScript = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
        parent: document.head,
        tag: 'script',
        src: 'https://www.googletagmanager.com/gtag/js?id=UA-11046863-1'
      });
      me.gaScript.addEventListener('load', me.trackDownload.bind(me));
    }
  } // Google Analytics


  trackDownload() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    } // gtag('consent', 'default', {
    //     ad_storage        : 'denied',
    //     analytics_storage : 'denied'
    // });


    gtag('event', 'conversion', {
      send_to: 'AW-1042491458/eweSCPibpAEQwtCM8QM',
      value: 1.0,
      currency: 'USD'
    });
    gtag('event', 'Trial download started', {
      value: 1.0,
      currency: 'USD'
    });
  }

} // Register this widget type with its Factory

_defineProperty(TrialPanel, "$name", 'TrialPanel');

_defineProperty(TrialPanel, "type", 'trialpanel');

TrialPanel.initClass();
TrialPanel._$name = 'TrialPanel';

/***/ }),

/***/ "./lib/Core/widget/util/AvatarRendering.js":
/*!*************************************************!*\
  !*** ./lib/Core/widget/util/AvatarRendering.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AvatarRendering; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';





/**
 * @module Core/widget/util/AvatarRendering
 */

/**
 * Internal utility class providing rendering of avatars / resource initials.
 *
 * @internal
 * @extends Core/Base
 */

class AvatarRendering extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AvatarRendering';
  }

  static get configurable() {
    return {
      /**
       * Element used to listen for load errors on. Normally the owning widgets own element.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * Prefix prepended to a supplied color to create a CSS class applied when showing initials.
       * @config {String}
       * @default
       */
      colorPrefix: 'b-sch-',

      /**
       * A tooltip config object to enable using a custom tooltip for the avatars. Listen for `beforeShow` and set
       * your html there.
       * @config {Object}
       */
      tooltip: null
    };
  }

  doDestroy() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.destroy();
    super.doDestroy();
  }

  updateElement(element) {
    // Error listener
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      delegate: '.b-resource-image',
      error: 'onImageErrorEvent',
      thisObj: this,
      capture: true
    });
  }

  changeTooltip(config) {
    return _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
      forElement: this.element,
      forSelector: '.b-resource-avatar',
      cls: 'b-resource-avatar-tooltip'
    }, config);
  }

  get failedUrls() {
    if (!this._failedUrls) {
      this._failedUrls = new Set();
    }

    return this._failedUrls;
  }
  /**
   * Returns a DOM config object containing a resource avatar, icon or resource initials. Display priority in that
   * order.
   * @param {Object} options Avatar options
   * @param {String} options.initials Resource initials
   * @param {String} options.color Background color for initials
   * @param {String} options.iconCls Icon cls
   * @param {String} options.imageUrl Image url
   * @param {String} options.defaultImageUrl Default image url, fallback if image fails to load or there is none
   * specified. Leave out to show initials instead.
   * @param {Object} [options.dataset] Dataset to apply to the resulting element
   * @param {String} [options.alt] Image description
   * @returns {Object}
   * @internal
   */


  getResourceAvatar({
    initials,
    color,
    iconCls,
    imageUrl,
    defaultImageUrl,
    dataset = {},
    alt
  }) {
    return this.getImageConfig(initials, color, imageUrl, defaultImageUrl, dataset, alt) || this.getIconConfig(iconCls, dataset) || this.getResourceInitialsConfig(initials, color, dataset);
  }

  getImageConfig(initials, color, imageUrl, defaultImageUrl, dataset, alt) {
    // Fall back to defaultImageUrl if imageUrl is known to fail
    imageUrl = this.failedUrls.has(imageUrl) ? defaultImageUrl : imageUrl || defaultImageUrl;

    if (imageUrl) {
      return {
        tag: 'img',
        draggable: 'false',
        class: {
          'b-resource-avatar': 1,
          'b-resource-image': 1
        },
        // Prevent iOS from zooming and showing image full screen
        ontouchstart: 'return false',
        alt,
        elementData: {
          defaultImageUrl,
          imageUrl,
          initials,
          color,
          dataset
        },
        src: imageUrl,
        dataset
      };
    }
  }

  getIconConfig(iconCls, dataset) {
    if (iconCls) {
      return iconCls && {
        tag: 'i',
        class: {
          'b-resource-avatar': 1,
          'b-resource-icon': 1,
          [iconCls]: 1
        },
        dataset
      };
    }
  }

  getResourceInitialsConfig(initials, color, dataset) {
    const // eventColor = #FF5555, apply as background-color
    namedColor = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNamedColor(color) && color,
          // eventColor = red, add b-sch-red cls
    hexColor = !namedColor && color;
    return {
      tag: 'div',
      class: {
        'b-resource-avatar': 1,
        'b-resource-initials': 1,
        [`${this.colorPrefix}${namedColor}`]: namedColor
      },
      style: {
        backgroundColor: hexColor || null
      },
      children: [_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(initials)],
      dataset
    };
  }

  onImageErrorEvent({
    target
  }) {
    if (!target.matches('.b-resource-avatar')) {
      return;
    }

    const {
      defaultImageUrl,
      initials,
      color,
      imageUrl,
      dataset
    } = target.elementData;

    if (defaultImageUrl && !target.src.endsWith(defaultImageUrl.replace(/^[./]*/gm, ''))) {
      target.src = defaultImageUrl;
    } else {
      const initialsEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement(this.getResourceInitialsConfig(initials, color, dataset));
      target.parentElement.replaceChild(initialsEl, target);
    } // Remember failed urls, to avoid trying to load them again next time


    this.failedUrls.add(imageUrl);
  }

}
AvatarRendering._$name = 'AvatarRendering';

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/CalendarCache.js ***!
  \**********************************************/
/*! exports provided: CalendarIteratorResult, CalendarCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIteratorResult", function() { return CalendarIteratorResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCache", function() { return CalendarCache; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
var productName = 'gantt';




/**
 * The enum type for result of [[forEachAvailabilityInterval]].
 */

var CalendarIteratorResult;

(function (CalendarIteratorResult) {
  /**
   * Indicates the iteration has completed by iterating the whole given timespan or has reached the MAX_DATE or MIN_DATE.
   */
  CalendarIteratorResult[CalendarIteratorResult["FullRangeIterated"] = 0] = "FullRangeIterated";
  /**
   * Indicates the iteration has been stopped by returning `false` from the iterator.
   */

  CalendarIteratorResult[CalendarIteratorResult["StoppedByIterator"] = 1] = "StoppedByIterator";
  /**
   * Indicates the iteration has exceeded the `maxRange` option
   */

  CalendarIteratorResult[CalendarIteratorResult["MaxCacheExtendCyclesReached"] = 2] = "MaxCacheExtendCyclesReached";
  /**
   * Indicates the iteration has exceeded the `maxRange` option
   */

  CalendarIteratorResult[CalendarIteratorResult["MaxRangeReached"] = 3] = "MaxRangeReached";
})(CalendarIteratorResult || (CalendarIteratorResult = {}));
/**
 * Calendar cache.
 */


class CalendarCache {
  constructor(config) {
    this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"];
    this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"];
    this.intervalsCachingChunkDuration = 30;
    this.intervalsCachingChunkUnit = _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__["TimeUnit"].Day;
    this.maxCacheExtendCycles = 100; // max range for the iteration - 5 years

    this.maxRange = 5 * 12 * 30 * 24 * 60 * 60 * 1000;
    config && Object.assign(this, config);
  }

  includeWrappingRangeFrom(cache, startDate, endDate) {
    cache.ensureCacheFilledForInterval(startDate, endDate);
    this.intervalCache.includeWrappingRange(cache.intervalCache, startDate, endDate);
  } // after this method, we guarantee, that for every point between `startDate` and `endDate` (_inclusive_)
  // we'll have a final representation of the cache, that is, we'll be able to get an interval to which this point belongs
  // _both_ for forward and backward directions


  ensureCacheFilledForInterval(startDate, endDate) {
    const cacheFilledStartDateN = this.cacheFilledStartDate.getTime();
    const cacheFilledEndDateN = this.cacheFilledEndDate.getTime();

    if (cacheFilledStartDateN !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime()) {
      const startDateN = startDate.getTime();
      const endDateN = endDate.getTime();
      if (cacheFilledStartDateN <= startDateN && endDateN <= cacheFilledEndDateN) return; // asked to cache an interval which is to the left from the cached area - extend to the right

      if (endDateN <= cacheFilledStartDateN) {
        endDate = new Date(cacheFilledStartDateN - 1);
      } else if (startDateN >= cacheFilledEndDateN) {
        startDate = new Date(cacheFilledEndDateN + 1);
      } else if (cacheFilledStartDateN <= startDateN && startDateN <= cacheFilledEndDateN) {
        startDate = new Date(cacheFilledEndDateN + 1);
      } else if (cacheFilledStartDateN <= endDateN && endDateN <= cacheFilledEndDateN) {
        endDate = new Date(cacheFilledStartDateN - 1);
      } else {
        this.ensureCacheFilledForInterval(startDate, new Date(cacheFilledStartDateN - 1));
        this.ensureCacheFilledForInterval(new Date(cacheFilledEndDateN + 1), endDate);
        return;
      }
    }

    if (cacheFilledStartDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime() || startDate.getTime() < cacheFilledEndDateN) {
      this.cacheFilledStartDate = startDate;
    }

    if (cacheFilledEndDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"].getTime() || cacheFilledEndDateN < endDate.getTime()) {
      this.cacheFilledEndDate = endDate;
    }

    this.fillCache(startDate, endDate);
  }

  fillCache(_1
  /* startDate */
  , _2
  /* endDate */
  ) {
    throw new Error("Abstract method");
  }

  clear() {
    this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"];
    this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"];
    this.intervalCache.clear();
  }
  /**
   * The core iterator method of the calendar cache.
   *
   * @param options The options for iterator. Should contain at least one of the `startDate`/`endDate` properties
   * which indicates what timespan to examine for availability intervals. If one of boundaries is not provided
   * iterator function should return `false` at some point, to avoid infinite loops.
   *
   * Another recognized option is `isForward`, which indicates the direction in which to iterate through the timespan.
   *
   * Another recognized option is `maxRange`, which indicates the maximum timespan for this iterator (in milliseconds). When iterator
   * exceeds this timespan, the iteration is stopped and [[CalendarIteratorResult.MaxRangeReached]] value is returned.
   * Default value is 5 years.
   *
   * @param func The iterator function to call. It will be called for every distinct set of availability intervals, found
   * in the given timespan. All the intervals, which are "active" for current interval are collected in the 3rd argument
   * for this function. If iterator returns `false` (checked with `===`) the iteration stops.
   *
   * @param scope The scope (`this` value) to execute the iterator in.
   */


  forEachAvailabilityInterval(options, func, scope) {
    var _a;

    scope = scope || this;
    const startDate = options.startDate;
    const endDate = options.endDate;
    const startDateN = startDate && startDate.getTime();
    const endDateN = endDate && endDate.getTime();
    const maxRange = (_a = options.maxRange) !== null && _a !== void 0 ? _a : this.maxRange; // `isForward = true` by default

    const isForward = options.isForward !== false;

    if (isForward ? !startDate : !endDate) {
      throw new Error("At least `startDate` or `endDate` is required, depending from the `isForward` option");
    }

    const intervalCache = this.intervalCache;
    let cacheCursorDate = isForward ? startDate : endDate;
    let cursorDate = isForward ? startDate : endDate;
    const rangeStart = cursorDate.getTime(); // this is generally an endless loop, but we artificially limit it to `maxCacheExtendCycles` iterations
    // to avoid freezing in unforeseen edge cases

    for (let cycle = 1; cycle < this.maxCacheExtendCycles; cycle++) {
      if (isForward) {
        this.ensureCacheFilledForInterval(cacheCursorDate, endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(cacheCursorDate, this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit));
      } else {
        this.ensureCacheFilledForInterval(startDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(cacheCursorDate, -this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit), cacheCursorDate);
      }

      let interval = intervalCache.getIntervalOf(cursorDate, isForward ? _util_Types_js__WEBPACK_IMPORTED_MODULE_3__["EdgeInclusion"].Left : _util_Types_js__WEBPACK_IMPORTED_MODULE_3__["EdgeInclusion"].Right);

      while (interval) {
        const intervalStartDate = interval.startDate;
        const intervalEndDate = interval.endDate; // out of requested range - all done

        if (isForward && endDateN && intervalStartDate.getTime() >= endDateN || !isForward && startDateN && intervalEndDate.getTime() <= startDateN) {
          return CalendarIteratorResult.FullRangeIterated;
        }

        if (isForward && intervalStartDate.getTime() - rangeStart >= maxRange || !isForward && rangeStart - intervalEndDate.getTime() >= maxRange) {
          return CalendarIteratorResult.MaxRangeReached;
        } // we are out of cached area, need to extend the cache


        if (isForward && intervalStartDate.getTime() > this.cacheFilledEndDate.getTime() || !isForward && intervalEndDate.getTime() < this.cacheFilledStartDate.getTime()) {
          break;
        } // save the last processed point, from which we should start after cache will be extended


        cursorDate = isForward ? intervalEndDate : intervalStartDate; // adjust to start / end date limits in iterator

        const countFrom = startDateN && intervalStartDate.getTime() < startDateN ? startDate : intervalStartDate;
        const countTill = endDateN && intervalEndDate.getTime() > endDateN ? endDate : intervalEndDate;

        if (func.call(scope, countFrom, countTill, interval.cacheInterval) === false) {
          // indicates premature exit if iterator returns `false`
          return CalendarIteratorResult.StoppedByIterator;
        }

        interval = isForward ? intervalCache.getNextInterval(interval) : intervalCache.getPrevInterval(interval);
      }

      if (isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime() || !isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"].getTime()) {
        return CalendarIteratorResult.FullRangeIterated;
      }

      cacheCursorDate = isForward ? this.cacheFilledEndDate : this.cacheFilledStartDate;
    }

    return CalendarIteratorResult.MaxCacheExtendCyclesReached;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheInterval.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheInterval.js ***!
  \******************************************************/
/*! exports provided: CalendarCacheInterval */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheInterval", function() { return CalendarCacheInterval; });
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
var productName = 'gantt';

/**
 * A class, that represent a cached set of availability intervals. One can use the [[getIsWorking]] method
 * to determine if this set intervals represents working time or non-working.
 */

class CalendarCacheInterval {
  constructor(config) {
    this.intervals = [];
    config && Object.assign(this, config);
    if (!this.calendar) throw new Error("Required attribute `calendar` is missing");
  }

  includeInterval(interval) {
    if (this.intervals.indexOf(interval) == -1) {
      const copy = this.intervals.slice();
      copy.push(interval);
      return new CalendarCacheInterval({
        intervals: copy,
        calendar: this.calendar
      });
    } else return this;
  }

  combineWith(interval) {
    return new CalendarCacheInterval({
      intervals: this.intervals.concat(interval.intervals),
      calendar: this.calendar
    });
  }
  /**
   * Returns the working status of this intervals set. It is determined as a working status
   * of the most prioritized interval (intervals are prioritized from child to parent)
   */


  getIsWorking() {
    if (this.isWorking != null) return this.isWorking;
    const intervals = this.intervals = this.normalizeIntervals(this.intervals); // return the value of the interval with the highest priority

    return this.isWorking = intervals[0].isWorking;
  }

  normalizeIntervals(intervals) {
    const filtered = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__["stripDuplicates"])(intervals); // sort in decreasing order

    filtered.sort((interval1, interval2) => interval2.getPriorityField() - interval1.getPriorityField());
    return filtered;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheIntervalMultiple.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheIntervalMultiple.js ***!
  \**************************************************************/
/*! exports provided: CalendarCacheIntervalMultiple */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheIntervalMultiple", function() { return CalendarCacheIntervalMultiple; });
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
var productName = 'gantt';

class CalendarCacheIntervalMultiple {
  constructor(config) {
    this.intervalGroups = [];
    config && Object.assign(this, config);
  }

  combineWith(interval) {
    const copy = this.intervalGroups.slice();
    copy.push([interval.calendar, interval]);
    return new CalendarCacheIntervalMultiple({
      intervalGroups: copy
    });
  }

  getIsWorkingForEvery() {
    if (this.isWorkingForEvery != null) return this.isWorkingForEvery;

    for (let [_calendar, intervals] of this.getGroups()) {
      if (!intervals[0].isWorking) return this.isWorkingForEvery = false;
    }

    return this.isWorkingForEvery = true;
  }

  getIsWorkingForSome() {
    if (this.isWorkingForSome != null) return this.isWorkingForSome;

    for (let [_calendar, intervals] of this.getGroups()) {
      if (intervals[0].isWorking) return this.isWorkingForSome = true;
    }

    return this.isWorkingForSome = false;
  }

  getCalendars() {
    this.getGroups();
    return this.calendars;
  }

  isCalendarWorking(calendar) {
    return this.getCalendarsWorkStatus().get(calendar);
  }

  getCalendarsWorkStatus() {
    if (this.calendarsWorkStatus) return this.calendarsWorkStatus;
    const res = new Map();

    for (let [calendar, intervals] of this.getGroups()) {
      // TODO: fix types
      res.set(calendar, intervals[0].isWorking);
    }

    return this.calendarsWorkStatus = res;
  }

  getCalendarsWorking() {
    if (this.calendarsWorking) return this.calendarsWorking;
    const calendars = [];

    for (let [calendar, intervals] of this.getGroups()) {
      // TODO: fix types
      if (intervals[0].isWorking) calendars.push(calendar);
    }

    return this.calendarsWorking = calendars;
  }

  getCalendarsNonWorking() {
    if (this.calendarsNonWorking) return this.calendarsNonWorking;
    const calendars = [];

    for (let [calendar, intervals] of this.getGroups()) {
      // TODO: fix types
      if (!intervals[0].isWorking) calendars.push(calendar);
    }

    return this.calendarsNonWorking = calendars;
  }

  getGroups() {
    if (this.intervalsByCalendar) return this.intervalsByCalendar;
    const calendars = this.calendars = [];
    const intervalsByCalendar = new Map();
    this.intervalGroups.forEach(([calendar, interval]) => {
      let data = intervalsByCalendar.get(calendar);

      if (!data) {
        calendars.push(calendar);
        data = [];
        intervalsByCalendar.set(calendar, data);
      }

      data.push.apply(data, interval.intervals);
    });
    intervalsByCalendar.forEach((intervals, calendar) => {
      const unique = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__["stripDuplicates"])(intervals);
      unique.sort( // sort in decreasing order
      (interval1, interval2) => interval2.getPriorityField() - interval1.getPriorityField());
      intervalsByCalendar.set(calendar, unique);
    });
    return this.intervalsByCalendar = intervalsByCalendar;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheMultiple.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheMultiple.js ***!
  \******************************************************/
/*! exports provided: CalendarCacheMultiple, combineCalendars */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheMultiple", function() { return CalendarCacheMultiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineCalendars", function() { return combineCalendars; });
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
/* harmony import */ var _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CalendarCacheIntervalMultiple.js */ "./lib/Engine/calendar/CalendarCacheIntervalMultiple.js");
/* harmony import */ var _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");
var productName = 'gantt';




/**
 * The calendar cache for combination of multiple calendars
 */

class CalendarCacheMultiple extends _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__["CalendarCache"] {
  constructor(config) {
    super(config);
    this.calendarCaches = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__["stripDuplicates"])(this.calendarCaches);
    this.intervalCache = new _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__["IntervalCache"]({
      emptyInterval: new _CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_2__["CalendarCacheIntervalMultiple"](),
      combineIntervalsFn: (interval1, interval2) => {
        return interval1.combineWith(interval2);
      }
    });
  }

  fillCache(startDate, endDate) {
    this.calendarCaches.forEach(calendarCache => {
      calendarCache.fillCache(startDate, endDate);
      this.includeWrappingRangeFrom(calendarCache, startDate, endDate);
    });
  }

}
const COMBINED_CALENDARS_CACHE = new Map();
const combineCalendars = calendars => {
  const uniqueOnly = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__["stripDuplicates"])(calendars);
  if (uniqueOnly.length === 0) throw new Error("No calendars to combine");
  uniqueOnly.sort((calendar1, calendar2) => {
    if (calendar1.internalId < calendar2.internalId) return -1;else return 1;
  });
  const hash = uniqueOnly.map(calendar => calendar.internalId + '/').join('');
  const versionsHash = uniqueOnly.map(calendar => calendar.version + '/').join('');
  let cached = COMBINED_CALENDARS_CACHE.get(hash);
  let res;
  if (cached && cached.versionsHash === versionsHash) res = cached.cache;else {
    res = new CalendarCacheMultiple({
      calendarCaches: uniqueOnly.map(calendar => calendar.calendarCache)
    }); // COMBINED_CALENDARS_CACHE.set(hash, {
    //     versionsHash    : versionsHash,
    //     cache           : res
    // })
  }
  return res;
};

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheSingle.js":
/*!****************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheSingle.js ***!
  \****************************************************/
/*! exports provided: CalendarCacheSingle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheSingle", function() { return CalendarCacheSingle; });
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CalendarCacheInterval.js */ "./lib/Engine/calendar/CalendarCacheInterval.js");
/* harmony import */ var _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';





class CalendarCacheSingle extends _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__["CalendarCache"] {
  constructor(config) {
    super(config);
    this.staticIntervalsCached = false;
    if (!this.unspecifiedTimeInterval) throw new Error("Required attribute `unspecifiedTimeInterval` is missing");
    this.intervalCache = new _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__["IntervalCache"]({
      emptyInterval: new _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_2__["CalendarCacheInterval"]({
        intervals: [this.unspecifiedTimeInterval],
        calendar: this.calendar
      }),
      combineIntervalsFn: (interval1, interval2) => {
        return interval1.combineWith(interval2);
      }
    });
  }

  fillCache(startDate, endDate) {
    if (!this.staticIntervalsCached) {
      this.cacheStaticIntervals();
      this.staticIntervalsCached = true;
    }

    if (this.parentCache) this.includeWrappingRangeFrom(this.parentCache, startDate, endDate);
    const startDateN = startDate.getTime();
    const endDateN = endDate.getTime();
    if (startDateN > endDateN) throw new Error("Invalid cache fill interval");
    this.forEachRecurrentInterval(interval => {
      const startSchedule = interval.getStartDateSchedule();
      const endSchedule = interval.getEndDateSchedule();
      let wrappingStartDate = startSchedule.prev(1, startDate); // TODO clear time EOD

      let wrappingEndDate = endSchedule === 'EOD' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStartOfNextDay(startSchedule.next(1, endDate), true) : endSchedule.next(1, endDate); // if the `startDate` is an occurrence in the interval's schedule, we need to advance one point prior
      // this is to provide the backward-scheduling information for the `startDate` point

      if (wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingStartDate.getTime() === startDateN) {
        const wrappingStartDates = startSchedule.prev(2, startDate);
        if (wrappingStartDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingStartDates.length === 2) wrappingStartDate = wrappingStartDates[1];
      }

      if (wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingEndDate.getTime() === endDateN) {
        const wrappingEndDates = endSchedule.next(2, endDate);
        if (wrappingEndDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingEndDates.length === 2) wrappingEndDate = wrappingEndDates[1];
      }

      const startDates = startSchedule.next(Infinity, wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? wrappingStartDate : startDate, wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? new Date(wrappingEndDate.getTime() - 1) : endDate); // schedule is empty for the interval of interest, do nothing

      if (startDates === _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER) return; // at this point `startDates` is a non-empty array

      const endDates = endSchedule === 'EOD' ? startDates.map(date => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStartOfNextDay(date, true)) : endSchedule.next(Infinity, new Date(startDates[0].getTime() + 1), wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? wrappingEndDate : endDate);
      if (endDates === _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER) return;

      if (endDates.length > startDates.length) {
        // safe to ignore "extra" end dates
        endDates.length = startDates.length;
      } else if (endDates.length < startDates.length) {
        // monkey patch
        startDates.length = endDates.length; // throw new Error("Recurrent interval inconsistency: " + interval + ", caching startDate: " + startDate + ", caching endDate: " + endDate)
      }

      startDates.forEach((startDate, index) => {
        const recStartDate = startDate;
        const recEndDate = endDates[index]; // if (recStartDate.getTime() > recEndDate.getTime())
        //     throw new Error("Recurrent interval inconsistency: " + interval + ", startDate: " + startDate + ", endDate: " + endDates[ index ])

        this.intervalCache.addInterval(recStartDate, recEndDate, existingCacheInterval => existingCacheInterval.includeInterval(interval));
      });
    });
  }

  clear() {
    this.staticIntervalsCached = false;
    super.clear();
  }

  cacheStaticIntervals() {
    this.forEachStaticInterval(interval => {
      this.intervalCache.addInterval(interval.startDate, interval.endDate, existingCacheInterval => existingCacheInterval.includeInterval(interval));
    });
  }

  forEachStaticInterval(func) {
    this.intervalStore.forEach(interval => {
      if (interval.isStatic()) func(interval);
    });
  }

  forEachRecurrentInterval(func) {
    this.intervalStore.forEach(interval => {
      if (interval.isRecurrent()) func(interval);
    });
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalMixin.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalMixin.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalMixin", function() { return CalendarIntervalMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../quark/model/mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'gantt';



/**
 * This is a calendar interval mixin.
 *
 * Can be either a static time interval (if [[startDate]]/[[endDate]] are specified) or recurrent time interval
 * ([[recurrentStartDate]]/[[recurrentEndDate]]).
 *
 * By default it defines a non-working period ([[isWorking]] field has default value `false`),
 * but can also define an explicit working time, for example to override some previous period.
 *
 * You probably don't need to create instances of this mixin directly, instead you pass its configuration object to the [[AbstractCalendarMixin.addInterval]]
 */

class CalendarIntervalMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CalendarIntervalMixin extends base {
    static get fields() {
      return ['name', {
        name: 'startDate',
        type: 'date',
        format: 'YYYY-MM-DDTHH:mm:ssZ'
      }, {
        name: 'endDate',
        type: 'date',
        format: 'YYYY-MM-DDTHH:mm:ssZ'
      }, 'recurrentStartDate', 'recurrentEndDate', {
        name: 'isWorking',
        type: 'boolean',
        defaultValue: false
      }, {
        name: 'priority',
        type: 'number'
      }];
    }

    getCalendar() {
      return this.stores[0].calendar;
    }

    resetPriority() {
      this.priorityField = null;
      this.getCalendar().getDepth();
    } // not just `getPriority` to avoid clash with auto-generated getter in the subclasses


    getPriorityField() {
      if (this.priorityField != null) return this.priorityField; // 0 - 10000 interval is reserved for "unspecified time" intervals
      // then 10000 - 10100, 10100-10200, ... etc intervals are for the calendars at depth 0, 1, ... etc

      let base = 10000 + this.getCalendar().getDepth() * 100;
      let priority = this.priority;

      if (priority == null) {
        // recurrent intervals are considered "base" and have lower priority
        // static intervals are considered special case overrides and have higher priority
        priority = this.isRecurrent() ? 20 : 30;
      } // intervals from parent calendars will have lower priority


      return this.priorityField = base + priority;
    }
    /**
     * Whether this interval is recurrent (both `recurrentStartDate` and `recurrentEndDate` are present and parsed correctly
     * by the `later` library)
     */


    isRecurrent() {
      return Boolean(this.recurrentStartDate && this.recurrentEndDate && this.getStartDateSchedule() && this.getEndDateSchedule());
    }
    /**
     * Whether this interval is static - both `startDate` and `endDate` are present.
     */


    isStatic() {
      return Boolean(this.startDate && this.endDate);
    }
    /**
     * Helper method to parse recurrentStartDate and recurrentEndDate field values.
     * @param {Object|String} schedule Recurrence schedule
     * @returns {Object} Processed schedule ready to be used by later.schedule() method.
     * @private
     */


    parseDateSchedule(value) {
      let schedule = value;

      if (value && value !== Object(value)) {
        schedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse.text(value);

        if (schedule !== Object(schedule) || schedule.error >= 0) {
          // can be provided as JSON text
          try {
            schedule = JSON.parse(value);
          } catch (e) {
            return null;
          }
        }
      }

      return schedule;
    }

    getStartDateSchedule() {
      if (this.startDateSchedule) return this.startDateSchedule;
      const schedule = this.parseDateSchedule(this.recurrentStartDate);
      return this.startDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].schedule(schedule);
    }

    getEndDateSchedule() {
      if (this.endDateSchedule) return this.endDateSchedule;
      if (this.recurrentEndDate === 'EOD') return 'EOD';
      const schedule = this.parseDateSchedule(this.recurrentEndDate);
      return this.endDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].schedule(schedule);
    }

  }

  return CalendarIntervalMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalStore.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalStore.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalStore", function() { return CalendarIntervalStore; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
/* harmony import */ var _quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../quark/store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';



/*
 * This a collection of {@link #CalendarIntervalMixin} items. Its a dumb collection though, the "real" calendar
 * is a [[AbstractCalendarMixin]] model, which is part of the [[AbstractCalendarManagerStoreMixin]].
 *
 */

class CalendarIntervalStore extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CalendarIntervalStore extends base {
    static get defaultConfig() {
      return {
        modelClass: _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalMixin"]
      };
    }

  }

  return CalendarIntervalStore;
}) {}

/***/ }),

/***/ "./lib/Engine/calendar/IntervalCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/IntervalCache.js ***!
  \**********************************************/
/*! exports provided: IntervalCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalCache", function() { return IntervalCache; });
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
/* harmony import */ var _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./SortedMap.js */ "./lib/Engine/calendar/SortedMap.js");
var productName = 'gantt';



class IntervalCache {
  constructor(config) {
    this.points = new _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["SortedMap"]((a, b) => a.getTime() - b.getTime());
    this.leftInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__["MIN_DATE"];
    this.rightInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__["MAX_DATE"];
    Object.assign(this, config);
    if (this.emptyInterval === undefined || !this.combineIntervalsFn) throw new Error("All of `emptyPoint`, `combineIntervalsFn` are required");
    this.points.set(this.leftInfinityKey, this.emptyInterval);
  }

  size() {
    return this.points.size();
  }

  indexOf(date) {
    return this.points.indexOfKey(date);
  }

  getDateAt(index) {
    return this.points.getKeyAt(index);
  }

  getPointAt(index) {
    return this.points.getValueAt(index);
  }

  getIntervalOf(date, edgeInclusion = _util_Types_js__WEBPACK_IMPORTED_MODULE_1__["EdgeInclusion"].Left) {
    // the `index` here is guaranteed to be > 0, because at index 0 there's a `emptyPoint`
    let {
      found,
      index
    } = this.indexOf(date);
    let startDateIndex;

    if (edgeInclusion === _util_Types_js__WEBPACK_IMPORTED_MODULE_1__["EdgeInclusion"].Left) {
      startDateIndex = found === _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["IndexPosition"].Exact ? index : index - 1;
    } else {
      startDateIndex = index - 1;
    }

    return this.getIntervalWithStartDateIndex(startDateIndex);
  }

  getPrevInterval(interval) {
    if (interval.startDateIndex === 0) return null;
    return this.getIntervalWithStartDateIndex(interval.startDateIndex - 1);
  }

  getNextInterval(interval) {
    if (interval.startDateIndex >= this.size() - 1) return null;
    return this.getIntervalWithStartDateIndex(interval.startDateIndex + 1);
  }

  getIntervalWithStartDateIndex(startDateIndex) {
    return {
      startDateIndex: startDateIndex,
      startDate: this.getDateAt(startDateIndex),
      endDate: startDateIndex + 1 < this.size() ? this.getDateAt(startDateIndex + 1) : this.rightInfinityKey,
      cacheInterval: this.getPointAt(startDateIndex)
    };
  }

  addInterval(startDate, endDate, extendInterval) {
    const points = this.points; // there is always "leftInfinityKey" empty point, so `index >= 0`

    const {
      found,
      index
    } = points.indexOfKey(startDate);
    let curIndex;
    let lastUpdatedPoint;

    if (found == _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["IndexPosition"].Exact) {
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index));
      points.setValueAt(index, inclusion);
      curIndex = index + 1;
    } else {
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index - 1));
      points.insertAt(index, startDate, inclusion);
      curIndex = index + 1;
    }

    while (curIndex < points.size()) {
      const curDate = points.getKeyAt(curIndex);
      if (curDate.getTime() >= endDate.getTime()) break;
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(curIndex));
      points.setValueAt(curIndex, inclusion);
      curIndex++;
    }

    if (curIndex === points.size()) {
      points.insertAt(points.size(), endDate, this.emptyInterval);
    } else {
      const curDate = points.getKeyAt(curIndex);

      if (curDate.getTime() === endDate.getTime()) {// we advanced till some point, which matches `endDate` config
        // this point will setup a new label, no need to add an explicit end date point,
        // we are done, do nothing
      } else {
        points.insertAt(curIndex, endDate, lastUpdatedPoint);
      }
    }
  }

  includeWrappingRange(intervalCache, startDate, endDate) {
    let interval = intervalCache.getIntervalOf(startDate);

    while (interval) {
      this.addInterval(interval.startDate, interval.endDate, existingInterval => this.combineIntervalsFn(existingInterval, interval.cacheInterval));
      if (interval.endDate.getTime() > endDate.getTime()) break;
      interval = intervalCache.getNextInterval(interval);
    }
  }

  getSummary() {
    return this.points.map((label, date) => {
      return {
        label,
        date
      };
    });
  }

  clear() {
    this.points.clear();
    this.points.set(this.leftInfinityKey, this.emptyInterval);
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/SortedMap.js":
/*!******************************************!*\
  !*** ./lib/Engine/calendar/SortedMap.js ***!
  \******************************************/
/*! exports provided: IndexPosition, SortedMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexPosition", function() { return IndexPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortedMap", function() { return SortedMap; });
/* harmony import */ var _util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/BinarySearch.js */ "./lib/Engine/util/BinarySearch.js");
var productName = 'gantt';

var IndexPosition;

(function (IndexPosition) {
  IndexPosition[IndexPosition["Exact"] = 0] = "Exact";
  IndexPosition[IndexPosition["Next"] = 1] = "Next";
})(IndexPosition || (IndexPosition = {})); // TODO store keys and values in a single array of "entries"? less memory movement during insert/delete in theory


class SortedMap {
  constructor(comparator) {
    this.keys = [];
    this.values = [];

    this.comparator = comparator || ((a, b) => a - b);
  }

  set(key, value) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);

    if (search.found) {
      this.values[search.index] = value;
    } else {
      this.keys.splice(search.index, 0, key);
      this.values.splice(search.index, 0, value);
    }

    return search.index;
  } // you need to know what you are doing when using this method


  insertAt(index, key, value) {
    this.keys.splice(index, 0, key);
    this.values.splice(index, 0, value);
  }

  setValueAt(index, value) {
    this.values[index] = value;
  }

  get(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    return search.found ? this.values[search.index] : undefined;
  }

  getEntryAt(index) {
    return index < this.keys.length ? {
      key: this.keys[index],
      value: this.values[index]
    } : undefined;
  }

  getKeyAt(index) {
    return this.keys[index];
  }

  getValueAt(index) {
    return this.values[index];
  }

  delete(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    if (search.found) this.deleteAt(search.index);
  }

  size() {
    return this.keys.length;
  }

  deleteAt(index) {
    this.keys.splice(index, 1);
    this.values.splice(index, 1);
  }

  indexOfKey(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    return {
      found: search.found ? IndexPosition.Exact : IndexPosition.Next,
      index: search.index
    };
  }

  map(func) {
    const keys = this.keys;
    const values = this.values;
    const result = [];

    for (let i = 0; i < keys.length; i++) result.push(func(values[i], keys[i], i));

    return result;
  }

  getAllEntries() {
    return this.map((value, key) => {
      return {
        value,
        key
      };
    });
  }

  clear() {
    this.keys.length = 0;
    this.values.length = 0;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js ***!
  \*************************************************************/
/*! exports provided: UnspecifiedTimeIntervalModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnspecifiedTimeIntervalModel", function() { return UnspecifiedTimeIntervalModel; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
var productName = 'gantt';

 // TODO if we would be doing just:
//      export class UnspecifiedTimeIntervalModel extends CalendarIntervalMixin ...
// then an instance of the `CalendarIntervalMixin` `c` would : `c instanceof UnspecifiedTimeIntervalModel`,
// because it inherit the `hasInstance` symbol
// need to figure out how it can be handled
// Calendar interval model denoting unspecified interval

class UnspecifiedTimeIntervalModel extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalMixin"]], base => {
  const superProto = base.prototype;

  class UnspecifiedTimeIntervalModel extends base {
    // TODO: why it overrides the method, is it configured with calendar instance directly?
    getCalendar() {
      return this.calendar;
    } // NOTE: See parent class implementation for further comments


    getPriorityField() {
      if (this.priorityField != null) return this.priorityField;
      return this.priorityField = this.getCalendar().getDepth();
    }

  }

  return UnspecifiedTimeIntervalModel;
}) {}

/***/ }),

/***/ "./lib/Engine/chrono/ChronoModelMixin.js":
/*!***********************************************!*\
  !*** ./lib/Engine/chrono/ChronoModelMixin.js ***!
  \***********************************************/
/*! exports provided: ChronoModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelMixin", function() { return ChronoModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
var productName = 'gantt';





/**
 * This is a base mixin, which mixes together the ChronoGraph's [Entity](https://bryntum.github.io/chronograph/docs/modules/_src_replica_entity_.html)
 * and the Bryntum Core [Model](https://bryntum.com/docs/grid/api/Core/data/Model)
 *
 * It is used as a very base mixin for all other entities in the project.
 */

class ChronoModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["Entity"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class ChronoModelMixin extends base {
    // This is a marker for Models which have the SchedulingEngine API available.
    get isEntity() {
      return true;
    }

    construct(config, ...args) {
      // this is to force the fields creation, because we need all fields to be created
      // for the `this.getFieldDefinition()` to return correct result
      // @ts-ignore
      this.constructor.exposeProperties(); // Cache original data before we recreate the incoming data here.
      // @ts-ignore

      this.originalData = config = config || {}; // Populate record with all data, it will sort the configs out.
      // By doing this first, we can feed engine the converted values right away. Needed to satisfy tests that
      // use standalone stores, otherwise they will be getting the unconverted values since there is no graph.

      superProto.construct.call(this, config, ...args);
    }
    /**
     * Calculation function that simply returns current ([[ProposedOrPrevious|proposed or previous]]) value of
     * an identifier.
     */


    *userProvidedValue() {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_4__["ProposedOrPrevious"];
    }

    copy(newId = null, deep = null) {
      const copy = superProto.copy.call(this, newId, deep); // If deep is everything but object - use default behavior, which is to invoke accessors
      // If deep is an object, check if it has certain field disabled

      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(deep) && !deep.skipFieldIdentifiers || !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(deep)) {
        this.forEachFieldIdentifier((identifier, fieldName) => {
          copy[fieldName] = this[fieldName];
        });
      }

      return copy;
    }

    applyValue(useProp, key, value, skipAccessors, field) {
      const chronoField = this.$entity.getField(key);
      if (chronoField) useProp = true;

      if (skipAccessors) {
        useProp = false;
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessors, field);
    }

    afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
      const store = this.firstStore; // When model.set({...}) is called and chrono field is modified, afterChange will be invoked twice:
      // 1. call will forward value to the chrono, leaving model.data intact
      // 2. value was changed, so model.afterChange is called too, triggering `update` event on store
      // 3. autoCommit is scheduled
      // 4. autoCommit finalizes, calling endBatch
      // 5. endBatch calls `set` again, passing argument `skipAccessors = true`, which means data will be set to
      // the `model.data` now
      // 6. since value differs in chrono and in model.data, `afterChange` will be called once again
      // Naturally this leads to two identical events being fired for this call:
      // `dependency.set('type', 0)
      //
      // Idea of the fix is to mute events for the first call IF chrono field is in the `wasSet` object
      // Covered by DependencyEdit.t.js

      if (!skipAccessors && !(store.syncDataOnLoad && store.isLoadingData) && Object.keys(wasSet).some(key => this.$entity.getField(key))) {
        // @ts-ignore
        superProto.afterChange.call(this, toSet, wasSet, true, fromRelationUpdate, skipAccessors);
      } else {
        // @ts-ignore
        superProto.afterChange.apply(this, arguments);
      }
    }

    get data() {
      return this._data;
    }

    set data(data) {
      this._data = data; // Have to iterate over defined fields and not keys in supplied data, in case nested mappings are used

      const {
        fields
      } = this;

      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const chronoField = this.$entity.getField(field.name);

        if (chronoField) {
          const value = field.complexMapping ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPath(data, field.dataSource) : data[field.dataSource]; // Use the predefined name for engine (name, startDate)

          this[field.name] = value;
        }
      }
    }

    get $entityName() {
      const className = this.constructor.name || this.$entity.name;
      const id = this.id;
      return `${className}${id != null ? '-' + String(id) : ''}`;
    }

  }

  return ChronoModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/chrono/Conflict.js":
/*!***************************************!*\
  !*** ./lib/Engine/chrono/Conflict.js ***!
  \***************************************/
/*! exports provided: ConflictSymbol, ConflictResolutionResult, ConflictEffect, ConflictResolution */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictSymbol", function() { return ConflictSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictResolutionResult", function() { return ConflictResolutionResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictEffect", function() { return ConflictEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictResolution", function() { return ConflictResolution; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



 //---------------------------------------------------------------------------------------------------------------------

const ConflictSymbol = Symbol('ConflictSymbol');
var ConflictResolutionResult;

(function (ConflictResolutionResult) {
  ConflictResolutionResult["Cancel"] = "Cancel";
  ConflictResolutionResult["Resume"] = "Resume";
})(ConflictResolutionResult || (ConflictResolutionResult = {})); //---------------------------------------------------------------------------------------------------------------------


class ConflictEffect extends _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Effect"] {
  constructor() {
    super(...arguments);
    this.handler = ConflictSymbol;
  }

}

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["prototypeValue"])(false)], ConflictEffect.prototype, "sync", void 0); //---------------------------------------------------------------------------------------------------------------------


class ConflictResolution extends _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Base"] {
  getDescription() {
    throw new Error('Abstract method');
  }

  resolve() {
    throw new Error('Abstract method');
  }

}

/***/ }),

/***/ "./lib/Engine/chrono/ModelFieldAtom.js":
/*!*********************************************!*\
  !*** ./lib/Engine/chrono/ModelFieldAtom.js ***!
  \*********************************************/
/*! exports provided: KEEP_TRYING_TO_RESOLVE, isSerializableEqual, ModelField, ModelReferenceField, ModelBucketField, IsChronoModelSymbol, ChronoModelFieldIdentifier, ChronoModelReferenceFieldQuark, ChronoModelReferenceFieldIdentifier, ChronoModelReferenceBucketFieldIdentifier, MinimalChronoModelFieldIdentifierSync, MinimalChronoModelFieldIdentifierGen, MinimalChronoModelFieldVariable, model_field, injectStaticFieldsProperty, getDecoratedModelFields, dateConverter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEEP_TRYING_TO_RESOLVE", function() { return KEEP_TRYING_TO_RESOLVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSerializableEqual", function() { return isSerializableEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelField", function() { return ModelField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelReferenceField", function() { return ModelReferenceField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelBucketField", function() { return ModelBucketField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsChronoModelSymbol", function() { return IsChronoModelSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelFieldIdentifier", function() { return ChronoModelFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldQuark", function() { return ChronoModelReferenceFieldQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldIdentifier", function() { return ChronoModelReferenceFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceBucketFieldIdentifier", function() { return ChronoModelReferenceBucketFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierSync", function() { return MinimalChronoModelFieldIdentifierSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierGen", function() { return MinimalChronoModelFieldIdentifierGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldVariable", function() { return MinimalChronoModelFieldVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "model_field", function() { return model_field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectStaticFieldsProperty", function() { return injectStaticFieldsProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDecoratedModelFields", function() { return getDecoratedModelFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateConverter", function() { return dateConverter; });
/* harmony import */ var _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../ChronoGraph/replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
/* harmony import */ var _ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../ChronoGraph/replica/Reference.js */ "./lib/ChronoGraph/replica/Reference.js");
/* harmony import */ var _ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../ChronoGraph/replica/ReferenceBucket.js */ "./lib/ChronoGraph/replica/ReferenceBucket.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../ChronoGraph/schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











 //---------------------------------------------------------------------------------------------------------------------

const KEEP_TRYING_TO_RESOLVE = Symbol('KEEP_TRYING_TO_RESOLVE');
const isSerializableEqual = function (oldValue, newValue) {
  return oldValue === newValue || ((newValue === null || newValue === void 0 ? void 0 : newValue.isBase) ? this.serialize(newValue) : newValue) === ((oldValue === null || oldValue === void 0 ? void 0 : oldValue.isBase) ? this.serialize(oldValue) : oldValue);
}; //---------------------------------------------------------------------------------------------------------------------

class ModelField extends _ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_7__["Field"] {
  constructor() {
    super(...arguments);
    this.modelFieldConfig = {};
  }

  getIdentifierClass(calculationFunction) {
    if (this.identifierCls) return this.identifierCls;
    if (!calculationFunction) return MinimalChronoModelFieldVariable;
    return Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__["isGeneratorFunction"])(calculationFunction) ? MinimalChronoModelFieldIdentifierGen : MinimalChronoModelFieldIdentifierSync;
  }

} //---------------------------------------------------------------------------------------------------------------------

class ModelReferenceField extends _ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_4__["ReferenceField"].mix(ModelField) {
  constructor() {
    super(...arguments);
    this.identifierCls = ChronoModelReferenceFieldIdentifier;
  }

} //---------------------------------------------------------------------------------------------------------------------
// it seems we don't need the buckets as Core fields, the `ModelBucketField` can be removed completely

class ModelBucketField extends _ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_5__["ReferenceBucketField"].mix(_ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_7__["Field"]) {
  constructor() {
    super(...arguments);
    this.identifierCls = ChronoModelReferenceBucketFieldIdentifier; // initialize (...args) {
    //     super.initialize(...args)
    //
    //     // the default value is actually shared among all instances (which is ok, since its assumed to be immutable)
    //     this.modelFieldConfig   = Object.assign({ isEqual : () => false, defaultValue : new Set(), persist : false }, this.modelFieldConfig)
    // }
  }

} // eof Fields
// Atoms

const IsChronoModelSymbol = Symbol('IsChronoModelSymbol'); //---------------------------------------------------------------------------------------------------------------------

class ChronoModelFieldIdentifier extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["FieldIdentifier"]], base => {
  const superProto = base.prototype;

  class ChronoModelFieldIdentifier extends base {
    [IsChronoModelSymbol]() {}

    getFromGraph(graph) {
      if (graph) {
        if (graph.readMode === _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_6__["ReadMode"].CurrentOrProposedOrPrevious) {
          if (this.sync) return graph.get(this);else return graph.activeTransaction.readCurrentOrProposedOrPrevious(this);
        }

        return superProto.getFromGraph.call(this, graph);
      } else return this.DATA;
    }

    writeToGraph(graph, proposedValue, ...args) {
      if (graph) {
        superProto.writeToGraph.call(this, graph, proposedValue, ...args);
      } else {
        this.DATA = proposedValue; //@ts-ignore

        this.self.set(this.field.name, proposedValue, false, false, true);
      }
    }

    write(me, transaction, quark, proposedValue, ...args) {
      // convert proposed value if needed
      proposedValue = me.convert(proposedValue);
      superProto.write.call(this, me, transaction, quark, proposedValue, ...args);
    }

    convert(value) {
      const field = this.field;
      const fieldDefinition = this.self.getFieldDefinition(field.name); // use field definition provided "convert" function

      if (fieldDefinition === null || fieldDefinition === void 0 ? void 0 : fieldDefinition.convert) {
        value = fieldDefinition.convert(value); // fallback to atom defined "converter"
      } else if (field.converter) {
        value = field.converter(value, field);
      }

      return value;
    }

    equality(v1, v2) {
      if (v1 instanceof Date && v2 instanceof Date) return v1.getTime() === v2.getTime();
      return v1 === v2;
    }

  }

  __decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__["prototypeValue"])(false)], ChronoModelFieldIdentifier.prototype, "sync", void 0);

  return ChronoModelFieldIdentifier;
}) {} //---------------------------------------------------------------------------------------------------------------------

class ChronoModelReferenceFieldQuark extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_10__["QuarkSync"]], base => {
  const superProto = base.prototype;

  class ChronoModelReferenceFieldQuark extends base {
    setValue(value) {
      superProto.setValue.call(this, value); // keep the copy of value on the identifier itself, to make it available
      // after the identifier is removed from the graph
      //@ts-ignore

      if (value !== _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_0__["TombStone"]) this.identifier.DATA = value;
    }

  }

  return ChronoModelReferenceFieldQuark;
}) {}
class ChronoModelReferenceFieldIdentifier extends _ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_4__["ReferenceIdentifier"].mix(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["MinimalFieldIdentifierSync"])) {
  buildProposedValue(me, q, transaction) {
    const quark = q;
    const proposedValue = quark.proposedValue;

    if (proposedValue === null || proposedValue === undefined) {
      transaction.candidate.failedResolutionReferences.delete(quark.identifier);
      return null;
    }

    if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["isInstanceOf"])(proposedValue, _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["Entity"])) {
      if (me.hasBucket()) me.getBucket(proposedValue).addToBucket(transaction, me.self);
      transaction.candidate.failedResolutionReferences.delete(quark.identifier);
      return proposedValue;
    }

    const resolved = me.resolve(proposedValue);

    if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["isInstanceOf"])(resolved, _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["Entity"])) {
      if (me.hasBucket()) me.getBucket(resolved).addToBucket(transaction, me.self);
      transaction.candidate.failedResolutionReferences.delete(quark.identifier);
      return resolved;
    } else {
      transaction.candidate.failedResolutionReferences.set(quark.identifier, proposedValue);
      return null;
    }
  }

}

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__["prototypeValue"])(true)], ChronoModelReferenceFieldIdentifier.prototype, "sync", void 0);

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__["prototypeValue"])(ChronoModelReferenceFieldQuark)], ChronoModelReferenceFieldIdentifier.prototype, "quarkClass", void 0); //---------------------------------------------------------------------------------------------------------------------


class ChronoModelReferenceBucketFieldIdentifier extends _ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_5__["ReferenceBucketIdentifier"].mix(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["MinimalFieldIdentifierSync"])) {}

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_8__["prototypeValue"])(true)], ChronoModelReferenceBucketFieldIdentifier.prototype, "sync", void 0);

class MinimalChronoModelFieldIdentifierSync extends ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["MinimalFieldIdentifierSync"]) {}
class MinimalChronoModelFieldIdentifierGen extends ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["MinimalFieldIdentifierGen"]) {}
class MinimalChronoModelFieldVariable extends ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["MinimalFieldVariable"]) {} // eof Atoms

const model_field = function (modelFieldConfig = {}, chronoFieldConfig = {}, chronoFieldClass = ModelField) {
  return function (target, propertyKey) {
    const decoratorFn = Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["generic_field"])(Object.assign({
      modelFieldConfig
    }, chronoFieldConfig), chronoFieldClass);
    decoratorFn(target, propertyKey);
    injectStaticFieldsProperty(target.constructor);
  };
};
const injectStaticFieldsProperty = prototype => {
  if (!prototype.hasOwnProperty('fields')) {
    Object.defineProperty(prototype, 'fields', {
      get: function () {
        return getDecoratedModelFields(this);
      }
    });
  }
};
const getDecoratedModelFields = constr => {
  const proto = constr.prototype;
  const result = [];

  if (proto.hasOwnProperty('$entity')) {
    proto.$entity.ownFields.forEach(field => {
      if (field instanceof ModelField) {
        const config = field.modelFieldConfig || {};

        if (!config.convert && field.converter && field.converter !== dateConverter) {
          config.convert = field.converter;
        }

        result.push(Object.assign(config, {
          $chrono: field,
          name: field.name
        }));
      }
    });
  }

  return result;
};
const dateConverter = (date, field) => {
  var _a, _b;

  if (date === null) {
    return null;
  }

  if (!(date instanceof Date)) {
    date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].parse(date, ((_a = field.modelFieldConfig) === null || _a === void 0 ? void 0 : _a.format) || ((_b = field.modelFieldConfig) === null || _b === void 0 ? void 0 : _b.dateFormat) || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].defaultParseFormat);
  } // if parsing has failed, we would like to return `undefined` to indicate the "absence" of data
  // instead of `null` (presence of "empty" data)


  return date || undefined;
};

/***/ }),

/***/ "./lib/Engine/chrono/Replica.js":
/*!**************************************!*\
  !*** ./lib/Engine/chrono/Replica.js ***!
  \**************************************/
/*! exports provided: EngineRevision, EngineTransaction, EngineReplica */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineRevision", function() { return EngineRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineTransaction", function() { return EngineTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineReplica", function() { return EngineReplica; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Transaction.js */ "./lib/ChronoGraph/chrono/Transaction.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _Conflict_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony import */ var _ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';








 //---------------------------------------------------------------------------------------------------------------------

class EngineRevision extends _ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_2__["Revision"] {
  constructor() {
    super(...arguments);
    this.failedResolutionReferences = new Map();
  }

} //---------------------------------------------------------------------------------------------------------------------

class EngineTransaction extends _ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_3__["Transaction"] {
  constructor() {
    super(...arguments);
    this.candidateClass = EngineRevision;
  }

  initialize(...args) {
    super.initialize(...args);
    this.candidate.failedResolutionReferences = new Map(this.baseRevision.failedResolutionReferences);
  }

  addIdentifier(identifier, proposedValue, ...args) {
    this.markFailedResolutionReferences();
    return super.addIdentifier(identifier, proposedValue, ...args);
  }

  markFailedResolutionReferences() {
    this.candidate.failedResolutionReferences.forEach((failedResolutionValue, identifier) => {
      this.write(identifier, failedResolutionValue);
    });
    this.candidate.failedResolutionReferences.clear();
  }

} //---------------------------------------------------------------------------------------------------------------------

/**
 * An extension of [[Replica]], specialized for interaction with [[AbstractProjectMixin|project]].
 */

class EngineReplica extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_4__["Mixin"])([_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_5__["Replica"]], base => {
  const superProto = base.prototype;

  class EngineReplica extends base {
    constructor() {
      super(...arguments);
      this.baseRevision = EngineRevision.new();
      this.transactionClass = EngineTransaction;
      this.autoCommitMode = 'async';
      this.onComputationCycle = 'reject';
      this.silenceInitialCommit = true;
      this.ignoreInitialCommitComputationCycles = true; // commitAsync (args? : CommitArguments) : Promise<CommitResult> {
      //     if (this.project.bufferedCommitAsync.isPending) {
      //         debugger
      //         this.project.bufferedCommitAsync.cancel()
      //     }
      //
      //     return super.commitAsync(args)
      // }
      // async commitAsync () : Promise<CommitResult> {
      //     const project = this.project
      //
      //     let result
      //
      //     // In case we're already propagating the super class throws some exception, to not mangle it I do custom handling
      //     // with events only if we are not propagating. Otherwise just fallback to superclass.
      //     if (!this.isPropagating) {
      //
      //         project.trigger('propagationStart', { dryRun : !!dryRun})
      //
      //         result = await super.commit(onEffect, dryRun)
      //
      //         project.trigger('propagationComplete', { dryRun : !!dryRun, result })
      //     }
      //     else {
      //         result = await super.commit(onEffect, dryRun)
      //     }
      //
      //     return result
      // }
      // commit () {
      //     const project = this.project
      //     const changedAtoms = this.changedAtoms
      //     const records = new Set(changedAtoms.map((atom : FieldAtom | EntityAtom) => atom.self as Model))
      //
      //     records.forEach(r => r.beginBatch())
      //
      //     project.trigger('beforeCommit', { records, changedAtoms })
      //     super.commit()
      //     project.trigger('commit', { records, changedAtoms })
      //
      //     // When there are a lot of changes do not fire any events for individual records. Instead ignore all of them
      //     // and fire one big refresh which is supposed to trigger one view refresh
      //     const silent = records.size > this.projectRefreshThreshold
      //
      //     records.forEach(r => r.endBatch(silent))
      //
      //     if (silent) {
      //         project.trigger('refresh', { records })
      //     }
      // }
      //
      //
      // async onEffect (effect : Effect) : Promise<EffectResolutionResult> {
      //     const project   = this.project
      //
      //     if (effect instanceof Conflict) {
      //         // is there is a "schedulingconflict" event listener we expect resolution option will be picked there
      //         if (project.hasListener('schedulingconflict')) {
      //             return new Promise((resolve, reject) => {
      //                 project.trigger('schedulingconflict', {
      //                     conflict                        : effect,
      //                     continueWithResolutionResult    : resolve
      //                 })
      //             })
      //         // by default we resume the committed changes
      //         } else {
      //             return Promise.resolve(EffectResolutionResult.Resume)
      //         }
      //     } else {
      //         return super.onEffect(effect)
      //     }
      // }
    } // clear () {
    //     this.removeEntity(this.project)
    //
    //     super.clear()
    //
    //     this.addEntity(this.project)
    // }


    get dirty() {
      const activeTransaction = this.activeTransaction;
      return activeTransaction.entries.size > 0 && (activeTransaction.hasVariableEntry || activeTransaction.hasEntryWithProposedValue);
    }

    onPropagationProgressNotification(notification) {
      if (this.enableProgressNotifications && this.project) this.project.trigger('progress', notification);
    } // BW compat: support old async "propagate"


    propagate(args) {
      // @ts-ignore
      return this.commitAsync(args);
    }

    async commitAsync(args) {
      this.project.trigger('beforeCommit');

      if (this.isInitialCommit && this.ignoreInitialCommitComputationCycles) {
        // backup onComputationCycle value to restore it after the commit
        this._onComputationCycle = this._onComputationCycle || this.onComputationCycle; // toggle onComputationCycle to ignore cycles to let the data get into the graph

        this.onComputationCycle = 'ignore';
      }

      const replacedReplicaResult = this.project.beforeCommitAsync();
      if (replacedReplicaResult) return replacedReplicaResult;
      return superProto.commitAsync.call(this, args);
    }

    get isInitialCommit() {
      // let the project defined which commit is "initial"
      return this.project.isInitialCommit || super.isInitialCommit;
    }

    set isInitialCommit(value) {
      super.isInitialCommit = value;
    }

    async finalizeCommitAsync(transactionResult) {
      // the `this.project` may be empty for the branch, where we validate the dependency
      // because if asyncness project might be destroyed when we get here
      const {
        project
      } = this;
      if (!project || project.isDestroyed) return;
      const {
        entries
      } = transactionResult;
      const autoCommitStores = new Set();
      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].global.DEBUG) console.timeEnd('Time to visible');
      const {
        isInitialCommit,
        silenceInitialCommit
      } = this; // apply changes silently if this is initial commit and "silenceInitialCommit" option is enabled

      const silenceCommit = isInitialCommit && silenceInitialCommit;

      if (isInitialCommit) {
        project.isInitialCommitPerformed = true; // restore onComputationCycle back if we toggled it before committing

        if (this.ignoreInitialCommitComputationCycles) this.onComputationCycle = this._onComputationCycle;
      }

      project.isWritingData = true;
      project.hasLoadedDataToCommit = false; // It is triggered earlier because on that stage engine is ready and UI can be drawn.
      // dataReady happens up to like a second later in big datasets. We do not want to wait that long

      project.trigger('refresh', {
        isInitialCommit
      });
      await new Promise(resolve => {
        setTimeout(() => {
          var _a, _b; // TODO: Should use Delayable


          if (!project.isDestroyed && !transactionResult.transaction.rejectedWith) {
            // @ts-ignore
            (_a = project.suspendChangesTracking) === null || _a === void 0 ? void 0 : _a.call(project);
            if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].global.DEBUG) console.time('Finalize propagation');
            const records = new Set();

            for (const quark of entries.values()) {
              const identifier = quark.identifier;
              const quarkValue = quark.getValue();
              const {
                field
              } = identifier;
              if (quark.isShadow() || !identifier[_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_7__["IsChronoModelSymbol"]] || quarkValue === _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_1__["TombStone"] || field instanceof _ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_7__["ModelBucketField"]) continue;
              const record = identifier.self;
              const store = record.firstStore; // Begin batch once

              if (!records.has(record)) {
                record.beginBatch(true);
                records.add(record);
              } // Avoid committing changes during refresh, commit below instead. Suspend once


              if ((store === null || store === void 0 ? void 0 : store.autoCommit) && !autoCommitStores.has(store)) {
                store.suspendAutoCommit();
                autoCommitStores.add(store);
              }

              record.set(field.name, quarkValue);
            }

            for (const record of records) {
              //@ts-ignore
              record.ignoreBag = silenceCommit;
              record.endBatch(silenceCommit, true); //@ts-ignore

              record.ignoreBag = false;
            }

            if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].global.DEBUG) console.timeEnd('Finalize propagation');
            project.trigger('dataReady', {
              records,
              isInitialCommit
            }); // @ts-ignore

            (_b = project.resumeChangesTracking) === null || _b === void 0 ? void 0 : _b.call(project, silenceCommit);
            autoCommitStores.forEach(store => store.resumeAutoCommit()); // clear all changes of the first graph commit

            if (silenceCommit) {
              [project.eventStore, project.dependencyStore, project.resourceStore, project.assignmentStore, project.calendarManagerStore].forEach(store => store.acceptChanges());
            }
          }

          project.isWritingData = false;
          resolve();
        }, 0);
      });
    }

    async [_Conflict_js__WEBPACK_IMPORTED_MODULE_6__["ConflictSymbol"]](effect, transaction) {
      // delegate to project
      return this.project.onSchedulingConflictCall(effect, transaction);
    }

    [_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["RejectSymbol"]](effect, transaction) {
      // on transaction rejected
      return super[_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["RejectSymbol"]](effect, transaction);
    }

  }

  return EngineReplica;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractPartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectGenericMixin", function() { return AbstractPartOfProjectGenericMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
var productName = 'gantt';

/**
 * This a base generic mixin for every class, that belongs to a project.
 *
 * It just provides getter/setter for the `project` property, along with some convenience methods
 * to access the project's stores.
 */

class AbstractPartOfProjectGenericMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectGenericMixin extends base {
    async commitAsync() {
      return this.project.commitAsync();
    }

    set project(project) {
      this.$project = project;
    }

    get project() {
      return this.$project;
    }

    calculateProject() {
      throw new Error("Implement me");
    }
    /**
     * The method to set the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    setProject(project) {
      return this.project = project;
    }
    /**
     * The method to get the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getProject() {
      if (this.project) return this.project;
      return this.setProject(this.calculateProject());
    }
    /**
     * Convenience method to get the instance of the assignment store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getAssignmentStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.assignmentStore;
    }
    /**
     * Convenience method to get the instance of the dependency store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getDependencyStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.dependencyStore;
    }
    /**
     * Convenience method to get the instance of the event store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getEventStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.eventStore;
    }
    /**
     * Convenience method to get the instance of the resource store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getResourceStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.resourceStore;
    }
    /**
     * Convenience method to get the instance of the calendar manager store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getCalendarManagerStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.calendarManagerStore;
    }

  }

  return AbstractPartOfProjectGenericMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js ***!
  \*************************************************************/
/*! exports provided: ChronoPartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectGenericMixin", function() { return ChronoPartOfProjectGenericMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
var productName = 'gantt';


/**
 * This a base generic mixin for every class, that belongs to a chronograph powered project.
 *
 * It just provides getter/setter for the `project` property, along with some convenience methods
 * to access the project's stores.
 */

class ChronoPartOfProjectGenericMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectGenericMixin"]], base => {
  const superProto = base.prototype;

  class ChronoPartOfProjectGenericMixin extends base {
    /**
     * The method to get the `ChronoGraph` instance, this entity belongs to.
     */
    getGraph() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.getGraph();
    } //region Entity getters

    /**
     * Convenience method to get the instance of event by its id.
     */


    getEventById(id) {
      var _a;

      return (_a = this.getEventStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of dependency by its id.
     */


    getDependencyById(id) {
      var _a;

      return (_a = this.getDependencyStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of resource by its id.
     */


    getResourceById(id) {
      var _a;

      return (_a = this.getResourceStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of assignment by its id.
     */


    getAssignmentById(id) {
      var _a;

      return (_a = this.getAssignmentStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of calendar by its id.
     */


    getCalendarById(id) {
      var _a;

      return (_a = this.getCalendarManagerStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
    }

  }

  return ChronoPartOfProjectGenericMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/CorePartOfProjectGenericMixin.js ***!
  \***********************************************************/
/*! exports provided: CorePartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectGenericMixin", function() { return CorePartOfProjectGenericMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
var productName = 'gantt';


/**
 * This a base generic mixin for every class, that belongs to a scheduler_core project.
 *
 * It just provides getter/setter for the `project` property, along with some convenience methods
 * to access the project's stores.
 */

class CorePartOfProjectGenericMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectGenericMixin"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectGenericMixin extends base {
    //region Store getters
    get eventStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.eventStore;
    }

    get resourceStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.resourceStore;
    }

    get assignmentStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore;
    }

    get dependencyStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.dependencyStore;
    }

    get calendarManagerStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.calendarManagerStore;
    } //endregion
    //region Entity getters

    /**
     * Convenience method to get the instance of event by its id.
     */


    getEventById(id) {
      var _a;

      return (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of dependency by its id.
     */


    getDependencyById(id) {
      var _a;

      return (_a = this.dependencyStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of resource by its id.
     */


    getResourceById(id) {
      var _a;

      return (_a = this.resourceStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of assignment by its id.
     */


    getAssignmentById(id) {
      var _a;

      return (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of calendar by its id.
     */


    getCalendarById(id) {
      var _a;

      return (_a = this.calendarManagerStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }

  }

  return CorePartOfProjectGenericMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/Types.js":
/*!***********************************!*\
  !*** ./lib/Engine/quark/Types.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var productName = 'gantt';

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractCalendarMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractCalendarMixin.js ***!
  \*********************************************************/
/*! exports provided: AbstractCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarMixin", function() { return AbstractCalendarMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../calendar/CalendarIntervalStore.js */ "./lib/Engine/calendar/CalendarIntervalStore.js");
/* harmony import */ var _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../calendar/CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../calendar/CalendarCacheSingle.js */ "./lib/Engine/calendar/CalendarCacheSingle.js");
/* harmony import */ var _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../calendar/UnspecifiedTimeIntervalModel.js */ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'gantt';








/**
 * Calendar for project scheduling, mixed by CoreCalendarMixin and BaseCalendarMixin. It is used to mark certain time
 * intervals as "non-working" and ignore them during scheduling.
 *
 * The calendar consists from several [[CalendarIntervalMixin|intervals]]. The intervals can be either static or recurrent.
 */

class AbstractCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CalendarMixin extends base {
    constructor() {
      super(...arguments);
      this.version = 1;
    }

    static get fields() {
      return [{
        name: 'version',
        type: 'number'
      }, 'name', {
        name: 'unspecifiedTimeIsWorking',
        type: 'boolean',
        defaultValue: true
      }, 'intervals'];
    }

    get intervalStoreClass() {
      return _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalStore"];
    }

    afterConstruct() {
      superProto.afterConstruct.call(this); // @ts-ignore

      const modelClass = this.getDefaultConfiguration().calendarIntervalModelClass || this.intervalStoreClass.defaultConfig.modelClass;
      this.intervalStore = new this.intervalStoreClass({
        calendar: this,
        modelClass
      }); // if intervals are provided add them to the this.intervalStore

      if (this.intervals && this.intervals.length) {
        this.addIntervals(this.intervals);
      }
    }

    isDefault() {
      const project = this.getProject();

      if (project) {
        return this === project.defaultCalendar;
      }

      return false;
    } // TODO: move to Model?


    getDepth() {
      return this.childLevel + 1;
    }
    /**
     * The core iterator method of the calendar.
     *
     * @param options The options for iterator. Should contain at least one of the `startDate`/`endDate` properties
     * which indicates what timespan to examine for availability intervals. If one of boundaries is not provided
     * iterator function should return `false` at some point, to avoid infinite loops.
     *
     * Another recognized option is `isForward`, which indicates the direction in which to iterate through the timespan.
     *
     * @param func The iterator function to call. It will be called for every distinct set of availability intervals, found
     * in the given timespan. All the intervals, which are "active" for current interval are collected in the 3rd argument
     * for this function - [[CalendarCacheInterval|calendarCacheInterval]]. If iterator returns `false` (checked with `===`)
     * the iteration stops.
     *
     * @param scope The scope (`this` value) to execute the iterator in.
     */


    forEachAvailabilityInterval(options, func, scope) {
      return this.calendarCache.forEachAvailabilityInterval(options, func, scope);
    }
    /**
     * This method starts at the given `date` and moves forward or backward in time, depending on `isForward`.
     * It stops moving as soon as it accumulates the `durationMs` milliseconds of working time and returns the date
     * at which it has stopped and remaining duration - the [[AccumulateWorkingTimeResult]] object.
     *
     * Normally, the remaining duration will be 0, indicating the full `durationMs` has been accumulated.
     * However, sometimes, calendar might not be able to accumulate enough working time due to various reasons,
     * like if it does not contain enough working time - this case will be indicated with remaining duration bigger than 0.
     *
     * @param date
     * @param durationMs
     * @param isForward
     */


    accumulateWorkingTime(date, durationMs, isForward) {
      // if duration is 0 - return the same date
      if (durationMs === 0) return {
        finalDate: new Date(date),
        remainingDurationInMs: 0
      };
      if (isNaN(durationMs)) throw new Error("Invalid duration");
      let finalDate = date;
      this.forEachAvailabilityInterval(isForward ? {
        startDate: date,
        isForward: true
      } : {
        endDate: date,
        isForward: false
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        let result = true;

        if (calendarCacheInterval.getIsWorking()) {
          let diff = intervalEndDate.getTime() - intervalStartDate.getTime();

          if (this.getProject().adjustDurationToDST) {
            const dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            diff += dstDiff * 60 * 1000;
          }

          if (durationMs <= diff) {
            finalDate = isForward ? new Date(intervalStartDate.getTime() + durationMs) : new Date(intervalEndDate.getTime() - durationMs);
            durationMs = 0;
            result = false;
          } else {
            finalDate = isForward ? intervalEndDate : intervalStartDate;
            durationMs -= diff;
          }
        }

        return result;
      });
      return {
        finalDate: new Date(finalDate),
        remainingDurationInMs: durationMs
      };
    }
    /**
     * Calculate the working time duration between the 2 dates, in milliseconds.
     *
     * @param startDate
     * @param endDate
     */


    calculateDurationMs(startDate, endDate) {
      let duration = 0;
      this.forEachAvailabilityInterval({
        startDate: startDate,
        endDate: endDate
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (calendarCacheInterval.getIsWorking()) {
          duration += intervalEndDate.getTime() - intervalStartDate.getTime();

          if (this.getProject().adjustDurationToDST) {
            const dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            duration += dstDiff * 60 * 1000;
          }
        }
      });
      return duration;
    }
    /**
     * Calculate the end date of the time interval which starts at `startDate` and has `durationMs` working time duration
     * (in milliseconds).
     *
     * @param startDate
     * @param durationMs
     */


    calculateEndDate(startDate, durationMs) {
      // the method goes forward by default ..unless a negative duration provided
      const isForward = durationMs >= 0;
      const res = this.accumulateWorkingTime(startDate, Math.abs(durationMs), isForward);
      return res.remainingDurationInMs === 0 ? res.finalDate : null;
    }
    /**
     * Calculate the start date of the time interval which ends at `endDate` and has `durationMs` working time duration
     * (in milliseconds).
     *
     * @param endDate
     * @param durationMs
     */


    calculateStartDate(endDate, durationMs) {
      // the method goes backwards by default ..unless a negative duration provided
      const isForward = durationMs <= 0;
      const res = this.accumulateWorkingTime(endDate, Math.abs(durationMs), isForward);
      return res.remainingDurationInMs === 0 ? res.finalDate : null;
    }
    /**
     * Returns the earliest point at which a working period of time starts, following the given date.
     * Can be the date itself, if it comes on the working time.
     *
     * @param date The date after which to skip the non-working time.
     * @param isForward Whether the "following" means forward in time or backward.
     */


    skipNonWorkingTime(date, isForward = true) {
      let workingDate;
      const res = this.forEachAvailabilityInterval(isForward ? {
        startDate: date,
        isForward: true
      } : {
        endDate: date,
        isForward: false
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (calendarCacheInterval.getIsWorking()) {
          workingDate = isForward ? intervalStartDate : intervalEndDate;
          return false;
        }
      });
      if (res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIteratorResult"].MaxRangeReached || res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIteratorResult"].FullRangeIterated) return 'empty_calendar';
      return workingDate ? new Date(workingDate) : new Date(date);
    }
    /**
     * This method adds a single [[CalendarIntervalMixin]] to the internal collection of the calendar
     */


    addInterval(interval) {
      return this.addIntervals([interval]);
    }
    /**
     * This method adds an array of [[CalendarIntervalMixin]] to the internal collection of the calendar
     */


    addIntervals(intervals) {
      this.bumpVersion();
      return this.intervalStore.add(intervals);
    }
    /**
     * This method removes all intervals from the internal collection of the calendar
     */


    clearIntervals(silent) {
      if (!silent) {
        this.bumpVersion();
      }

      return this.intervalStore.removeAll(silent);
    }

    bumpVersion() {
      this.clearCache();
      this.version++;
    }

    get calendarCache() {
      if (this.$calendarCache !== undefined) return this.$calendarCache;
      const unspecifiedTimeInterval = new _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_5__["UnspecifiedTimeIntervalModel"]({
        isWorking: this.unspecifiedTimeIsWorking
      });
      unspecifiedTimeInterval.calendar = this;
      return this.$calendarCache = new _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_4__["CalendarCacheSingle"]({
        calendar: this,
        unspecifiedTimeInterval: unspecifiedTimeInterval,
        intervalStore: this.intervalStore,
        parentCache: this.parent && !this.parent.isRoot ? this.parent.calendarCache : null
      });
    }

    clearCache() {
      // not strictly needed, we just help garbage collector
      this.$calendarCache && this.$calendarCache.clear();
      this.$calendarCache = undefined;
    }

    resetPriorityOfAllIntervals() {
      this.traverse(calendar => {
        calendar.intervalStore.forEach(interval => interval.resetPriority());
      });
    }

    insertChild(child, before, silent) {
      let res = superProto.insertChild.call(this, ...arguments);

      if (!Array.isArray(res)) {
        res = [res];
      } // invalidate cache of the child record, since now it should take parent into account


      res.forEach(r => {
        r.bumpVersion();
        r.resetPriorityOfAllIntervals();
      });
      return res;
    }

    joinProject() {
      superProto.joinProject.call(this);
      this.intervalStore.setProject(this.getProject());
    }

    leaveProject() {
      superProto.leaveProject.call(this);
      this.intervalStore.setProject(null);
      this.intervalStore.destroy();
      this.clearCache();
    }

    doDestroy() {
      this.leaveProject();
      super.doDestroy();
    }

    isDayHoliday(day) {
      const startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clearTime(day),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getNext(day, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["TimeUnit"].Day);
      let hasWorkingTime = false;
      this.forEachAvailabilityInterval({
        startDate,
        endDate,
        isForward: true
      }, (_intervalStartDate, _intervalEndDate, calendarCacheInterval) => {
        hasWorkingTime = calendarCacheInterval.getIsWorking();
        return !hasWorkingTime;
      });
      return !hasWorkingTime;
    } // TODO: tests


    getDailyHolidaysRanges(startDate, endDate) {
      const result = [];
      startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clearTime(startDate);

      while (startDate < endDate) {
        if (this.isDayHoliday(startDate)) {
          result.push({
            startDate,
            endDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStartOfNextDay(startDate, true, true)
          });
        }

        startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getNext(startDate, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["TimeUnit"].Day);
      }

      return result;
    }

    getNonWorkingTimeRanges(startDate, endDate) {
      const result = [];
      this.forEachAvailabilityInterval({
        startDate,
        endDate,
        isForward: true
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (!calendarCacheInterval.getIsWorking()) {
          const entry = calendarCacheInterval.intervals[0];
          result.push({
            name: entry.name,
            startDate: intervalStartDate,
            endDate: intervalEndDate
          });
        }
      });
      return result;
    }
    /**
     * Checks if there is a working time interval in the provided time range (or when just startDate is provided,
     * checks if the date is contained inside a working time interval in this calendar)
     * @param startDate
     * @param [endDate]
     */


    isWorkingTime(startDate, endDate) {
      // Can be Date | null | 'empty_calendar'
      const workingTimeStart = this.skipNonWorkingTime(startDate);
      return workingTimeStart && workingTimeStart !== 'empty_calendar' ? endDate ? workingTimeStart < endDate : workingTimeStart.getTime() === startDate.getTime() : false;
    }

  }

  return CalendarMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractHasAssignmentsMixin", function() { return AbstractHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'gantt';


/**
 * This is a mixin enabling events to handle assignments. It is mixed by CoreHasAssignmentsMixin and
 * BaseHasAssignmentsMixin. It provides a collection of all assignments, which reference this event.
 *
 * Doesn't affect scheduling.
 */

class AbstractHasAssignmentsMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class HasAssignmentsMixin extends base {
    /**
     * If a given resource is assigned to this task, returns a [[BaseAssignmentMixin]] instance for it.
     * Otherwise returns `null`
     */
    getAssignmentFor(resource) {
      for (const assignment of this.assigned) {
        if (assignment.resource === resource) return assignment;
      }

      return null;
    }

    isAssignedTo(resource) {
      return Boolean(this.getAssignmentFor(resource));
    }
    /**
     * A method which assigns a resource to the current event
     */


    async assign(resource) {
      const assignmentCls = this.project.assignmentStore.modelClass;
      this.addAssignment(new assignmentCls({
        event: this,
        resource: resource
      }));
      return this.commitAsync();
    }
    /**
     * A method which unassigns a resource from the current event
     */


    async unassign(resource) {
      const assignment = this.getAssignmentFor(resource);
      this.removeAssignment(assignment);
      return this.commitAsync();
    }

    leaveProject() {
      // `this.assigned` will be empty if model is added to project and then removed immediately
      // w/o any propagations
      if (this.assigned) {
        const eventStore = this.getEventStore(); // to batch the assignments removal, we don't remove the assignments right away, but instead
        // add them for the batched removal to the `assignmentsForRemoval` property of the event store

        this.assigned.forEach(assignment => eventStore.assignmentsForRemoval.add(assignment));
      }

      superProto.leaveProject.call(this, ...arguments);
    }

    remove() {
      if (this.parent) {
        // need to get the event store in advance, because after removal the project reference will be cleared (all that is what provide
        // references to all stores
        const eventStore = this.getEventStore();
        superProto.remove.call(this);
        eventStore && eventStore.afterEventRemoval();
      } else {
        return superProto.remove.call(this);
      }
    } // template methods, overridden in scheduling modes mixins
    // should probably be named something like "onEventAssignmentAdded"
    // should be a listener for the `add` event of the assignment store instead


    addAssignment(assignment) {
      this.getProject().assignmentStore.add(assignment);
      return assignment;
    } // should be a listener for the `remove` event of the assignment store instead


    removeAssignment(assignment) {
      this.getProject().assignmentStore.remove(assignment);
      return assignment;
    }

  }

  return HasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractProjectMixin.js":
/*!********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractProjectMixin.js ***!
  \********************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, AbstractProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractProjectMixin", function() { return AbstractProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';




class EventsWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {}
class DelayableWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {}
/**
 * This is an abstract project, which just lists the available stores.
 *
 * The actual project classes are [[SchedulerCoreProjectMixin]], [[SchedulerBasicProjectMixin]],
 * [[SchedulerProProjectMixin]], [[GanttProjectMixin]].
 */

class AbstractProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class AbstractProjectMixin extends base {
    get isRepopulatingStores() {
      return false;
    }

    get isInitialCommit() {
      return !this.isInitialCommitPerformed || this.hasLoadedDataToCommit;
    }

    construct(config = {}) {
      // Define default values for these flags here
      // if defined where declared then TS compiles them this way:
      // constructor() {
      //     super(...arguments)
      //     this.isInitialCommitPerformed   = false
      //     this.isLoadingInlineData        = false
      //     this.isWritingData              = false
      //
      // }
      // which messes the flags values for inline data loading (since it's async)
      this.isInitialCommitPerformed = false;
      this.isLoadingInlineData = false;
      this.isWritingData = false;
      this.hasLoadedDataToCommit = false;
      superProto.construct.call(this, config);
      this.silenceInitialCommit = 'silenceInitialCommit' in config ? config.silenceInitialCommit : true;
      this.adjustDurationToDST = 'adjustDurationToDST' in config ? config.adjustDurationToDST : false;
    } // Template method called when a stores dataset is replaced. Implemented in SchedulerBasicProjectMixin


    repopulateStore(store) {} // Template method called when replica should be repopulated. Implemented in SchedulerBasicProjectMixin


    repopulateReplica() {} // Template method called when a store is attached to the project


    attachStore(store) {} // Template method called when a store is detached to the project


    detachStore(store) {}

    async commitAsync() {
      throw new Error("Abstract method called");
    } // Different implementations for Core and Basic engines


    isEngineReady() {
      throw new Error("Abstract method called");
    }

  }

  return AbstractProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/ConstrainedByParentMixin.js":
/*!******************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/ConstrainedByParentMixin.js ***!
  \******************************************************************/
/*! exports provided: ConstrainedByParentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstrainedByParentMixin", function() { return ConstrainedByParentMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../scheduler_basic/BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
/* harmony import */ var _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_pro/ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin makes the event to "inherit" the constraints from its parent event.
 */

class ConstrainedByParentMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_4__["BaseEventMixin"], _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_5__["HasChildrenMixin"], _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__["ConstrainedEarlyEventMixin"]], base => {
  const superProto = base.prototype;

  class ConstrainedByParentMixin extends base {
    *maybeSkipNonWorkingTime(date, isForward = true) {
      const childEvents = yield this.$.childEvents; // summary tasks are simply aligned by their children so they should not skip non-working time at all

      if (childEvents.size > 0) return date;
      return yield* superProto.maybeSkipNonWorkingTime.call(this, date, isForward);
    }

    *calculateStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateStartDateConstraintIntervals.call(this);
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.startDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals);
      }

      return intervals;
    }

    *calculateEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEndDateConstraintIntervals.call(this);
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.endDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals);
      }

      return intervals;
    }

    *calculateEarlyStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEarlyStartDateConstraintIntervals.call(this);
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.earlyStartDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals); // If the parent is scheduled manually it should still restrict its children (even though it has no a constraint set)
        // so we append an artificial constraining interval

        if ((yield parentEvent.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["Direction"].Forward) {
          intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_2__["DateInterval"].new({
            startDate: yield parentEvent.$.startDate
          }));
        }
      }

      return intervals;
    }

    *calculateEarlyEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEarlyEndDateConstraintIntervals.call(this);
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.earlyEndDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals);
      }

      return intervals;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('startDateConstraintIntervals')], ConstrainedByParentMixin.prototype, "calculateStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('endDateConstraintIntervals')], ConstrainedByParentMixin.prototype, "calculateEndDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('earlyStartDateConstraintIntervals')], ConstrainedByParentMixin.prototype, "calculateEarlyStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('earlyEndDateConstraintIntervals')], ConstrainedByParentMixin.prototype, "calculateEarlyEndDateConstraintIntervals", null);

  return ConstrainedByParentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js":
/*!*******************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js ***!
  \*******************************************************************/
/*! exports provided: ConstrainedLateEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstrainedLateEventMixin", function() { return ConstrainedLateEventMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
/* harmony import */ var _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../scheduler_pro/ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
/* harmony import */ var _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../chrono/Conflict.js */ "./lib/Engine/chrono/Conflict.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides the constraint-based as-late-as-possible scheduling. See the [[ConstrainedEarlyEventMixin]]
 * for the description of the ASAP constraints-based scheduling. See [[GanttProjectMixin]] for more details about
 * forward/backward, ASAP/ALAP scheduling.
 *
 * It also provides the facilities for calculating the event's [[totalSlack]] and the [[critical]] flag.
 *
 * The ALAP-specific constraints are accumulated in [[lateStartDateConstraintIntervals]], [[lateEndDateConstraintIntervals]] fields.
 */

class ConstrainedLateEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["ConstrainedEarlyEventMixin"], _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_8__["HasChildrenMixin"]], base => {
  const superProto = base.prototype;

  class ConstrainedLateEventMixin extends base {
    /**
     * Calculation method for the [[lateStartDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the start date during the ALAP scheduling.
     */
    *calculateLateStartDateConstraintIntervals() {
      const intervals = [];
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.lateStartDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals);
      }

      return intervals;
    }
    /**
     * Calculation method for the [[lateEndDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the end date during the ALAP scheduling.
     */


    *calculateLateEndDateConstraintIntervals() {
      const intervals = [];
      const parentEvent = yield this.$.parentEvent;

      if (parentEvent) {
        // Child inherits its parent task constraints
        const parentIntervals = yield parentEvent.$.lateEndDateConstraintIntervals;
        intervals.push.apply(intervals, parentIntervals); // If the parent is scheduled manually it should still restrict its children (even though it has no a constraint set)
        // so we append an artificial constraining interval

        if ((yield parentEvent.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward) {
          intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["DateInterval"].new({
            endDate: yield parentEvent.$.endDate
          }));
        }
      }

      return intervals;
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[lateStartDate]].
     * Child events roll up their [[lateStartDate]] values to their summary tasks.
     * So a summary task [[lateStartDate]] date gets equal to its minimal child [[lateStartDate]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildLateStartDate(childEvent) {
      return true;
    }

    *calculateMinChildrenLateStartDate() {
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MAX_DATE"];
      const subEventsIterator = yield* this.subEventsIterable();

      for (let childEvent of subEventsIterator) {
        if (!(yield* this.shouldRollupChildLateStartDate(childEvent))) continue;
        let childDate;

        if ((yield childEvent.$.manuallyScheduled) && (yield* childEvent.hasSubEvents())) {
          childDate = yield childEvent.$.minChildrenLateStartDate;
        }

        childDate = childDate || (yield childEvent.$.lateStartDate);
        if (childDate && childDate < result) result = childDate;
      }

      return result.getTime() - _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MAX_DATE"].getTime() ? result : null;
    }

    *calculateLateStartDateRaw() {
      // Manually scheduled task treat its current start date as late start date
      // in case of backward scheduling.
      // Early dates in that case are calculated the same way it happens for automatic tasks
      if ((yield this.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward) {
        return yield this.$.startDate;
      } // Parent task calculate its late start date as minimal late start date of its children


      if (yield* this.hasSubEvents()) {
        return yield this.$.minChildrenLateStartDate;
      }

      if (!(yield* this.isConstrainedLate())) {
        return yield this.$.startDate;
      }

      const startDateConstraintIntervals = yield this.$.lateStartDateConstraintIntervals;
      const endDateConstraintIntervals = yield this.$.lateEndDateConstraintIntervals;
      const effectiveInterval = yield* this.calculateEffectiveConstraintInterval(true, // need to use concat instead of directly mutating the `startDateConstraintIntervals` since that is
      // used as storage for `this.$.lateStartDateConstraintIntervals`
      startDateConstraintIntervals.concat(yield this.$.startDateConstraintIntervals), endDateConstraintIntervals.concat(yield this.$.endDateConstraintIntervals));

      if (effectiveInterval === null) {
        return null;
      } else if (effectiveInterval.isIntervalEmpty()) {
        const conflict = _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_10__["ConflictEffect"].new();

        if ((yield conflict) === _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_10__["ConflictResolutionResult"].Cancel) {
          yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])(conflict);
        } else {
          return null;
        }
      }

      return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(effectiveInterval.endDate) ? effectiveInterval.endDate : null;
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[lateEndDate]].
     * Child events roll up their [[lateEndDate]] values to their summary tasks.
     * So a summary task [[lateEndDate]] gets equal to its maximal child [[lateEndDate]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildLateEndDate(childEvent) {
      return true;
    }

    *calculateMaxChildrenLateEndDate() {
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MIN_DATE"];
      const subEventsIterator = yield* this.subEventsIterable();

      for (let childEvent of subEventsIterator) {
        if (!(yield* this.shouldRollupChildLateEndDate(childEvent))) continue;
        let childDate;

        if ((yield childEvent.$.manuallyScheduled) && (yield* childEvent.hasSubEvents())) {
          childDate = yield childEvent.$.maxChildrenLateEndDate;
        }

        childDate = childDate || (yield childEvent.$.lateEndDate);
        if (childDate && childDate > result) result = childDate;
      }

      return result.getTime() - _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MIN_DATE"].getTime() ? result : null;
    }

    *calculateLateStartDate() {
      return yield this.$.lateStartDateRaw;
    }

    *calculateLateEndDateRaw() {
      // Manually scheduled task treat its current end date as late end date
      // in case of backward scheduling.
      // Early dates in that case are calculated the same way it happens for automatic tasks
      if ((yield this.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward) {
        return yield this.$.endDate;
      } // Parent task calculate its late end date as minimal early end date of its children


      if (yield* this.hasSubEvents()) {
        return yield this.$.maxChildrenLateEndDate;
      }

      if (!(yield* this.isConstrainedLate())) {
        return yield this.$.endDate;
      }

      const startDateConstraintIntervals = yield this.$.lateStartDateConstraintIntervals;
      const endDateConstraintIntervals = yield this.$.lateEndDateConstraintIntervals;
      const effectiveInterval = yield* this.calculateEffectiveConstraintInterval(false, // need to use concat instead of directly mutating the `startDateConstraintIntervals` since that is
      // used as storage for `this.$.lateStartDateConstraintIntervals`
      startDateConstraintIntervals.concat(yield this.$.startDateConstraintIntervals), endDateConstraintIntervals.concat(yield this.$.endDateConstraintIntervals));

      if (effectiveInterval === null) {
        return null;
      } else if (effectiveInterval.isIntervalEmpty()) {
        const conflict = _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_10__["ConflictEffect"].new();

        if ((yield conflict) === _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_10__["ConflictResolutionResult"].Cancel) {
          yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])(conflict);
        } else {
          return null;
        }
      }

      return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(effectiveInterval.endDate) ? effectiveInterval.endDate : null;
    }

    *calculateLateEndDate() {
      const date = yield this.$.lateEndDateRaw;
      return yield* this.maybeSkipNonWorkingTime(date, false);
    }

    *calculateTotalSlack() {
      const earlyStartDate = yield this.$.earlyStartDateRaw;
      const lateStartDate = yield this.$.lateStartDateRaw;
      const earlyEndDate = yield this.$.earlyEndDateRaw;
      const lateEndDate = yield this.$.lateEndDateRaw;
      const slackUnit = yield this.$.slackUnit;
      let endSlack, result;

      if (earlyStartDate && lateStartDate || earlyEndDate && lateEndDate) {
        if (earlyStartDate && lateStartDate) {
          result = yield* this.calculateProjectedDuration(earlyStartDate, lateStartDate, slackUnit);

          if (earlyEndDate && lateEndDate) {
            endSlack = yield* this.calculateProjectedDuration(earlyEndDate, lateEndDate, slackUnit);
            if (endSlack < result) result = endSlack;
          }
        } else if (earlyEndDate && lateEndDate) {
          result = yield* this.calculateProjectedDuration(earlyEndDate, lateEndDate, slackUnit);
        }
      }

      return result;
    }

    *calculateCritical() {
      const totalSlack = yield this.$.totalSlack;
      return totalSlack <= 0;
    }

    *isConstrainedLate() {
      const startDateIntervals = yield this.$.startDateConstraintIntervals;
      const endDateIntervals = yield this.$.endDateConstraintIntervals;
      const lateStartDateConstraintIntervals = yield this.$.lateStartDateConstraintIntervals;
      const lateEndDateConstraintIntervals = yield this.$.lateEndDateConstraintIntervals;
      return Boolean((startDateIntervals === null || startDateIntervals === void 0 ? void 0 : startDateIntervals.length) || (endDateIntervals === null || endDateIntervals === void 0 ? void 0 : endDateIntervals.length) || (lateStartDateConstraintIntervals === null || lateStartDateConstraintIntervals === void 0 ? void 0 : lateStartDateConstraintIntervals.length) || (lateEndDateConstraintIntervals === null || lateEndDateConstraintIntervals === void 0 ? void 0 : lateEndDateConstraintIntervals.length));
    }

    *calculateStartDatePure() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward) {
        // early exit if this mixin is not applicable, but only after(!) the direction check
        // this is because the `isConstrainedLate` yield early constraint intervals, which are generally lazy,
        // depending from the direction
        if (!(yield* this.isConstrainedLate()) || (yield this.$.manuallyScheduled)) {
          return yield* superProto.calculateStartDatePure.call(this);
        }

        return yield this.$.lateStartDate;
      } else {
        return yield* superProto.calculateStartDatePure.call(this);
      }
    }

    *calculateStartDateProposed() {
      const direction = yield this.$.direction;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward:
          // early exit if this mixin is not applicable, but only after(!) the direction check
          // this is because the `isConstrainedLate` yield early constraint intervals, which are generally lazy,
          // depending from the direction
          if (!(yield* this.isConstrainedLate()) || (yield this.$.manuallyScheduled)) {
            return yield* superProto.calculateStartDateProposed.call(this);
          }

          return (yield this.$.lateStartDate) || (yield* superProto.calculateStartDateProposed.call(this));

        default:
          return yield* superProto.calculateStartDateProposed.call(this);
      }
    }

    *calculateEndDatePure() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward) {
        // early exit if this mixin is not applicable, but only after(!) the direction check
        // this is because the `isConstrainedLate` yield early constraint intervals, which are generally lazy,
        // depending from the direction
        if (!(yield* this.isConstrainedLate()) || (yield this.$.manuallyScheduled)) {
          return yield* superProto.calculateEndDatePure.call(this);
        }

        return yield this.$.lateEndDate;
      } else {
        return yield* superProto.calculateEndDatePure.call(this);
      }
    }

    *calculateEndDateProposed() {
      const direction = yield this.$.direction;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Backward:
          // early exit if this mixin is not applicable, but only after(!) the direction check
          // this is because the `isConstrainedLate` yield early constraint intervals, which are generally lazy,
          // depending from the direction
          if (!(yield* this.isConstrainedLate()) || (yield this.$.manuallyScheduled)) {
            return yield* superProto.calculateEndDateProposed.call(this);
          }

          return (yield this.$.lateEndDate) || (yield* superProto.calculateEndDateProposed.call(this));

        default:
          return yield* superProto.calculateEndDateProposed.call(this);
      }
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "minChildrenLateStartDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "lateStartDateRaw", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'date',
    persist: false
  }, {
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"],
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["dateConverter"],
    persistent: false
  })], ConstrainedLateEventMixin.prototype, "lateStartDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "maxChildrenLateEndDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "lateEndDateRaw", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'date',
    persist: false
  }, {
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"],
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["dateConverter"],
    persistent: false
  })], ConstrainedLateEventMixin.prototype, "lateEndDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "lateStartDateConstraintIntervals", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "lateEndDateConstraintIntervals", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'number',
    persist: false
  }, {
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"],
    persistent: false
  })], ConstrainedLateEventMixin.prototype, "totalSlack", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["TimeUnit"].Day,
    persist: false
  }, {
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"],
    converter: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalizeUnit,
    persistent: false
  })], ConstrainedLateEventMixin.prototype, "slackUnit", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'boolean',
    defaultValue: false,
    persist: false
  }, {
    persistent: false,
    lazy: _scheduler_pro_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["EarlyLateLazyness"]
  })], ConstrainedLateEventMixin.prototype, "critical", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateStartDateConstraintIntervals')], ConstrainedLateEventMixin.prototype, "calculateLateStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateEndDateConstraintIntervals')], ConstrainedLateEventMixin.prototype, "calculateLateEndDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('minChildrenLateStartDate')], ConstrainedLateEventMixin.prototype, "calculateMinChildrenLateStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateStartDateRaw')], ConstrainedLateEventMixin.prototype, "calculateLateStartDateRaw", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('maxChildrenLateEndDate')], ConstrainedLateEventMixin.prototype, "calculateMaxChildrenLateEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateStartDate')], ConstrainedLateEventMixin.prototype, "calculateLateStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateEndDateRaw')], ConstrainedLateEventMixin.prototype, "calculateLateEndDateRaw", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('lateEndDate')], ConstrainedLateEventMixin.prototype, "calculateLateEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('totalSlack')], ConstrainedLateEventMixin.prototype, "calculateTotalSlack", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('critical')], ConstrainedLateEventMixin.prototype, "calculateCritical", null);

  return ConstrainedLateEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/GanttAssignmentMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/GanttAssignmentMixin.js ***!
  \**************************************************************/
/*! exports provided: GanttAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GanttAssignmentMixin", function() { return GanttAssignmentMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _scheduler_pro_SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../scheduler_pro/SchedulerProAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * A mixin for the assignment entity at the Gantt level. It adds [[units]] field.
 */

class GanttAssignmentMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_pro_SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__["SchedulerProAssignmentMixin"]], base => {
  const superProto = base.prototype;

  class GanttAssignmentMixin extends base {
    *calculateUnits() {
      const event = yield this.$.event; // if event of assignment presents - we always delegate to it
      // (so that various assignment logic can be overridden by single event mixin)

      if (event) return yield* event.calculateAssignmentUnits(this); // otherwise use proposed or current consistent value

      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('units')], GanttAssignmentMixin.prototype, "calculateUnits", null);

  return GanttAssignmentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/GanttEvent.js":
/*!****************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/GanttEvent.js ***!
  \****************************************************/
/*! exports provided: GanttEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GanttEvent", function() { return GanttEvent; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduler_pro_SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler_pro/SchedulerProEvent.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProEvent.js");
/* harmony import */ var _ConstrainedByParentMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ConstrainedByParentMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedByParentMixin.js");
/* harmony import */ var _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ConstrainedLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js");
/* harmony import */ var _GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GanttHasAssignmentsMixin.js */ "./lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js");
/* harmony import */ var _HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./HasEffortMixin.js */ "./lib/Engine/quark/model/gantt/HasEffortMixin.js");
/* harmony import */ var _HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./HasSchedulingModeMixin.js */ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js");
/* harmony import */ var _ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ScheduledByDependenciesLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js");
/* harmony import */ var _scheduling_modes_FixedDurationMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./scheduling_modes/FixedDurationMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationMixin.js");
/* harmony import */ var _scheduling_modes_FixedEffortMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scheduling_modes/FixedEffortMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortMixin.js");
/* harmony import */ var _scheduling_modes_FixedUnitsMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./scheduling_modes/FixedUnitsMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsMixin.js");
/* harmony import */ var _InactiveEventMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./InactiveEventMixin.js */ "./lib/Engine/quark/model/gantt/InactiveEventMixin.js");
var productName = 'gantt';












/**
 * This is an event class, [[GanttProjectMixin]] is working with.
 * It is constructed as [[SchedulerProEvent]], enhanced with extra functionality.
 */

class GanttEvent extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"])([_scheduler_pro_SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerProEvent"], _ConstrainedByParentMixin_js__WEBPACK_IMPORTED_MODULE_2__["ConstrainedByParentMixin"], _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_3__["ConstrainedLateEventMixin"], _ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_7__["ScheduledByDependenciesLateEventMixin"], _GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_4__["GanttHasAssignmentsMixin"], _HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_5__["HasEffortMixin"], _HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_6__["HasSchedulingModeMixin"], _scheduling_modes_FixedDurationMixin_js__WEBPACK_IMPORTED_MODULE_8__["FixedDurationMixin"], _scheduling_modes_FixedEffortMixin_js__WEBPACK_IMPORTED_MODULE_9__["FixedEffortMixin"], _scheduling_modes_FixedUnitsMixin_js__WEBPACK_IMPORTED_MODULE_10__["FixedUnitsMixin"], _InactiveEventMixin_js__WEBPACK_IMPORTED_MODULE_11__["InactiveEventMixin"]], base => {
  const superProto = base.prototype;

  class GanttEvent extends base {}

  return GanttEvent;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js":
/*!******************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js ***!
  \******************************************************************/
/*! exports provided: GanttHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GanttHasAssignmentsMixin", function() { return GanttHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduler_pro_SchedulerProHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler_pro/SchedulerProHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProHasAssignmentsMixin.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixins enhances the [[SchedulerProHasAssignmentsMixin]] with few helper methods.
 */

class GanttHasAssignmentsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_pro_SchedulerProHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__["SchedulerProHasAssignmentsMixin"]], base => {
  const superProto = base.prototype;

  class GanttHasAssignmentsMixin extends base {
    *hasProposedValueForUnits() {
      const assignments = yield this.$.assigned;

      for (const assignment of assignments) {
        const resource = yield assignment.$.resource;
        if (resource && (yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["HasProposedValue"])(assignment.$.units))) return true;
      }

      return false;
    }

  }

  return GanttHasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/GanttProjectMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/GanttProjectMixin.js ***!
  \***********************************************************/
/*! exports provided: GanttProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GanttProjectMixin", function() { return GanttProjectMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../scheduler_pro/SchedulerProProjectMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js");
/* harmony import */ var _scheduler_pro_SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scheduler_pro/SchedulerProResourceMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js");
/* harmony import */ var _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ConstrainedLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js");
/* harmony import */ var _GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./GanttAssignmentMixin.js */ "./lib/Engine/quark/model/gantt/GanttAssignmentMixin.js");
/* harmony import */ var _GanttEvent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./GanttEvent.js */ "./lib/Engine/quark/model/gantt/GanttEvent.js");
/* harmony import */ var _HasCriticalPathsMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./HasCriticalPathsMixin.js */ "./lib/Engine/quark/model/gantt/HasCriticalPathsMixin.js");
/* harmony import */ var _HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./HasEffortMixin.js */ "./lib/Engine/quark/model/gantt/HasEffortMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














 //---------------------------------------------------------------------------------------------------------------------

/**
 * Gantt project mixin type. At this level, events are called "tasks". All scheduling features from the [[SchedulerProProjectMixin]]
 * are preserved. Additionally, tasks inherit constraints from parent tasks. Tasks also receives the [[HasEffortMixin.effort|effort]] field
 * and [[HasSchedulingModeMixin.schedulingMode|schedulingMode]] field.
 *
 * The base event class for this level is [[GanttEvent]]. The base assignment class is [[GanttAssignmentMixin]].
 *
 * At this level, project can be scheduled in backward direction. This is controlled with the [[direction]] field.
 *
 * * Forward ASAP scheduling
 *
 * This is a default, most-used mode. In this mode, the "base" date is project start date. If it is not provided,
 * it is calculated as the earliest date of all project tasks. Events are scheduled ASAP, based on the "early" constraints
 * (plus "generic" constraints).
 *
 * * Forward ALAP scheduling
 *
 * In this mode, the "base" date is still project start date. If it is not provided,
 * it is calculated as the earliest date of all project tasks.
 *
 * Events are first scheduled ASAP, based on the "early" constraints. This gives the project end date.
 * Now events are scheduled ALAP, using the project end date as the base.
 *
 * The difference between the task position in Forward ASAP and Forward ALAP scheduling is called [[ConstrainedLateEventMixin.totalSlack|"slack"]]
 *
 * * Backward ALAP scheduling
 *
 * This is a "default" backward scheduling. In this mode, the "base" date is project end date. If it is not provided,
 * it is calculated as the latest date of all project tasks. Events are scheduled ALAP, based on the "late" constraints
 * (plus "generic" constraints).
 *
 * * Backward ASAP scheduling
 *
 * In this mode, the "base" date is still project end date. If it is not provided,
 * it is calculated as the latest date of all project tasks.
 *
 * Events are first scheduled ALAP, based on the "late" constraints. This gives the project start date.
 * Now events are scheduled ASAP, using the project start date as the base.
 *
 */

class GanttProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_7__["SchedulerProProjectMixin"], _HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_13__["HasEffortMixin"], _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_9__["ConstrainedLateEventMixin"], _HasCriticalPathsMixin_js__WEBPACK_IMPORTED_MODULE_12__["HasCriticalPathsMixin"]], base => {
  const superProto = base.prototype;

  class GanttProjectMixin extends base {
    constructor() {
      super(...arguments); // this atom is recalculated in every transaction (it is "self dependent")
      // this happens because it is always calculated to the value which is different from
      // proposed value
      // this is a "source of changes" which we use for `project.startDate/endDate` in case
      // scanning the children returned `null`
      // so it will cause the `project.startDate` to always recalculate until it obtain some value

      this.nonEqual = false;
    }

    *calculateNonEqual() {
      return !(yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"]);
    }

    get isGanttProjectMixin() {
      return true;
    } // TODO
    // SchedulerBasicProjectMixin overrides HasChildrenMixin hasSubEvents and subEventsIterable methods
    // so we define the methods here to fix that
    // https://github.com/canonic-epicure/typescript-mixin-class/issues/1


    *hasSubEvents() {
      const childEvents = yield this.$.childEvents;
      return childEvents.size > 0;
    }

    *subEventsIterable() {
      return yield this.$.childEvents;
    }

    *calculateDirection() {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }

    *calculateStartDate() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Forward) {
        let result = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];

        if (!result) {
          result = yield* this.unsafeCalculateInitialMinChildrenStartDateDeep();
          if (!result) yield this.$.nonEqual;
        }

        return result;
      } else if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Backward) {
        const startDate = yield* this.calculateMinChildrenStartDate();
        const endDate = yield this.$.endDate; // Calculated startDate can get after the project endDate
        // (in case its built based on a manually scheduled task that start after the project finishes).
        // We set the project startDate to its endDate value then.

        return startDate && endDate > startDate ? startDate : endDate;
      }
    }

    *calculateEndDate() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Forward) {
        const startDate = yield this.$.startDate;
        const endDate = yield* this.calculateMaxChildrenEndDate(); // Calculated endDate can be before the project startDate
        // (in case its built based on a manually scheduled task that finishes before the project starts).
        // Then it leads to an infinite cycle because of these BaseEventMixin.calculateDurationPure lines:
        //      if (startDate > endDate) {
        //          yield Write(this.$.duration, 0, null)
        //      }
        // So we simply check if the project endDate got earlier than its start date
        // and set endDate to startDate value then.
        // This case is reported in: https://github.com/bryntum/support/issues/3127
        // and asserted by: 031_manually_scheduled.t.ts

        return endDate && endDate > startDate ? endDate : startDate;
      } else if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Backward) {
        let result = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];

        if (!result) {
          result = yield* this.unsafeCalculateInitialMaxChildrenEndDateDeep();
          if (!result) yield this.$.nonEqual;
        }

        return result;
      }
    }

    *shouldRollupChildStartDate(child) {
      // Do not take into account inactive children dates when calculating start date
      return !(yield child.$.inactive);
    }

    *shouldRollupChildEndDate(child) {
      // Do not take into account inactive children dates when calculating start date
      return !(yield child.$.inactive);
    }

    *calculateEarlyStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEarlyStartDateConstraintIntervals.call(this);
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Forward) {
        const startDate = yield this.$.startDate;
        startDate && intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
          startDate
        }));
      } else if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Backward) {
        const startDate = yield this.$.lateStartDate;
        startDate && intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
          startDate
        }));
      }

      return intervals;
    }

    *calculateLateEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateLateEndDateConstraintIntervals.call(this);
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Forward) {
        const endDate = yield this.$.earlyEndDate;
        endDate && intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
          endDate
        }));
      } else if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["Direction"].Backward) {
        const endDate = yield this.$.endDate;
        endDate && intervals.push(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
          endDate
        }));
      }

      return intervals;
    }

    getDefaultEventModelClass() {
      return _GanttEvent_js__WEBPACK_IMPORTED_MODULE_11__["GanttEvent"];
    }

    getDefaultAssignmentModelClass() {
      return _GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_10__["GanttAssignmentMixin"];
    }

    getDefaultResourceModelClass() {
      return _scheduler_pro_SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_8__["SchedulerProResourceMixin"];
    }

    getDefaultEventStoreClass() {
      return _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__["ChronoEventTreeStoreMixin"];
    }

    getType() {
      return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["ProjectType"].Gantt;
    } // this method is only used to calculated "initial" project start date only


    *unsafeCalculateInitialMinChildrenStartDateDeep() {
      const childEvents = yield this.$.childEvents; // note, that we does not yield here, as we want to calculate "initial" project start date
      // which will be used only if there's no user input or explicit setting for it
      // such project date should be calculated as earliest date of all tasks, based on the
      // "initial" data (which includes proposed)

      if (!childEvents.size) return yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(this.$.startDate);
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"],
          child;
      const toProcess = [...childEvents];

      while (child = toProcess.shift()) {
        let childDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(child.$.startDate); // in case a task has no start date but has end date provided - use that value

        if (!childDate) {
          childDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(child.$.endDate);
        }

        if (childDate && childDate < result) result = childDate;
        toProcess.push(...(yield child.$.childEvents));
      }

      return result.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"].getTime() && result.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"].getTime() ? result : null;
    }

    *unsafeCalculateInitialMaxChildrenEndDateDeep() {
      const childEvents = yield this.$.childEvents; // note, that we use "unsafe" ProposedOrPrevious effect here, because we only get into this method
      // if there's no user input for the project end date

      if (!childEvents.size) return yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(this.$.endDate);
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"],
          child;
      const toProcess = [...childEvents];

      while (child = toProcess.shift()) {
        let childDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(child.$.endDate); // in case a task has no end date but has start date provided - use that value

        if (!childDate) {
          childDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["UnsafeProposedOrPreviousValueOf"])(child.$.startDate);
        }

        if (childDate && childDate > result) result = childDate;
        toProcess.push(...(yield child.$.childEvents));
      }

      return result.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"].getTime() && result.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"].getTime() ? result : null;
    }

    getDependencyCycleDetectionIdentifiers(fromEvent, toEvent) {
      return [// @ts-ignore
      toEvent.$.earlyStartDateConstraintIntervals, // @ts-ignore
      toEvent.$.earlyEndDateConstraintIntervals, // @ts-ignore
      toEvent.$.lateEndDateConstraintIntervals, // @ts-ignore
      toEvent.$.lateStartDateConstraintIntervals];
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    equality: () => false
  })], GanttProjectMixin.prototype, "nonEqual", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('nonEqual')], GanttProjectMixin.prototype, "calculateNonEqual", null);

  return GanttProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/HasCriticalPathsMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/HasCriticalPathsMixin.js ***!
  \***************************************************************/
/*! exports provided: HasCriticalPathsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasCriticalPathsMixin", function() { return HasCriticalPathsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * This is a mixin, adding critical path calculation to the event node.
 *
 * Scheduling-wise it adds *criticalPaths* field to an entity mixing it.
 *
 * For more details on the _critical path method_ please check this article: https://en.wikipedia.org/wiki/Critical_path_method
 */

class HasCriticalPathsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_2__["HasChildrenMixin"]], base => {
  const superProto = base.prototype;

  class HasCriticalPathsMixin extends base {
    *calculateCriticalPaths() {
      const paths = [],
            pathsToProcess = [],
            events = yield this.$.childEvents,
            eventsToProcess = [...events],
            projectEndDate = yield this.$.endDate; // First collect events we'll start collecting paths from.
      // We need to start from critical events w/o incoming dependencies

      let event;

      while (event = eventsToProcess.shift()) {
        const childEvents = yield event.$.childEvents,
              eventIsCritical = yield event.$.critical,
              eventIsActive = !(yield event.$.inactive),
              eventEndDate = yield event.$.endDate; // register a new path finishing at the event

        if (eventIsActive && eventEndDate && eventEndDate.getTime() - projectEndDate.getTime() === 0 && eventIsCritical) {
          pathsToProcess.push([{
            event
          }]);
        }

        eventsToProcess.push(...childEvents);
      }

      let path; // fetch paths one by one and process

      while (path = pathsToProcess.shift()) {
        let taskIndex = path.length - 1,
            node; // get the path last event

        while (node = path[taskIndex]) {
          const criticalPredecessorNodes = []; // collect critical successors

          for (const dependency of yield node.event.$.incomingDeps) {
            const event = yield dependency.$.fromEvent; // if we found a critical predecessor

            if (event && (yield dependency.$.active) && !(yield event.$.inactive) && (yield event.$.critical)) {
              criticalPredecessorNodes.push({
                event,
                dependency
              });
            }
          } // if critical predecessor(s) found


          if (criticalPredecessorNodes.length) {
            // make a copy of the path leading part
            const pathCopy = path.slice(); // append the found predecessor to the path

            path.push(criticalPredecessorNodes[0]); // if we found more than one predecessor we start new path as: leading path + predecessor

            for (let i = 1; i < criticalPredecessorNodes.length; i++) {
              pathsToProcess.push(pathCopy.concat(criticalPredecessorNodes[i]));
            } // increment counter to process the predecessor we've appended to the path


            taskIndex++;
          } else {
            // no predecessors -> stop the loop
            taskIndex = -1;
          }
        } // we collected the path backwards so let's reverse it


        paths.push(path.reverse());
      }

      return paths;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])({
    lazy: true
  })], HasCriticalPathsMixin.prototype, "criticalPaths", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('criticalPaths')], HasCriticalPathsMixin.prototype, "calculateCriticalPaths", null);

  return HasCriticalPathsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/HasEffortDispatcher.js ***!
  \*************************************************************/
/*! exports provided: EffortVar, UnitsVar, effortFormula, unitsFormula, endDateByEffortFormula, startDateByEffortFormula, SEDWUDispatcher, SEDWUDispatcherIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EffortVar", function() { return EffortVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsVar", function() { return UnitsVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effortFormula", function() { return effortFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unitsFormula", function() { return unitsFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endDateByEffortFormula", function() { return endDateByEffortFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startDateByEffortFormula", function() { return startDateByEffortFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcher", function() { return SEDWUDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcherIdentifier", function() { return SEDWUDispatcherIdentifier; });
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler_basic/BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
var productName = 'gantt';

 //---------------------------------------------------------------------------------------------------------------------

const EffortVar = Symbol('EffortVar');
const UnitsVar = Symbol('UnitsVar'); //---------------------------------------------------------------------------------------------------------------------

const effortFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["Formula"].new({
  output: EffortVar,
  inputs: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], UnitsVar])
});
const unitsFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["Formula"].new({
  output: UnitsVar,
  inputs: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], EffortVar])
});
const endDateByEffortFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["Formula"].new({
  output: _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"],
  inputs: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], EffortVar, UnitsVar])
});
const startDateByEffortFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["Formula"].new({
  output: _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"],
  inputs: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], EffortVar, UnitsVar])
}); //---------------------------------------------------------------------------------------------------------------------

class SEDWUDispatcher extends _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["SEDDispatcher"] {} //---------------------------------------------------------------------------------------------------------------------

class SEDWUDispatcherIdentifier extends _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["SEDDispatcherIdentifier"] {
  equality(v1, v2) {
    const resolution1 = v1.resolution;
    const resolution2 = v2.resolution;
    return resolution1.get(EffortVar) === resolution2.get(EffortVar) && resolution1.get(UnitsVar) === resolution2.get(UnitsVar) && super.equality(v1, v2);
  }

}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/HasEffortMixin.js":
/*!********************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/HasEffortMixin.js ***!
  \********************************************************/
/*! exports provided: HasEffortMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasEffortMixin", function() { return HasEffortMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
/* harmony import */ var _GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./GanttHasAssignmentsMixin.js */ "./lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides an `effort` field which does not affect scheduling.
 * It also provides various generic methods to schedule task based on effort information. Those are
 * used in other mixins.
 */

class HasEffortMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_7__["GanttHasAssignmentsMixin"], _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_6__["HasChildrenMixin"]], base => {
  const superProto = base.prototype;

  class HasEffortMixin extends base {
    /**
     * Getter for the effort. Can return return effort in given unit, or will use [[effortUnit]].
     *
     * @param unit
     */
    getEffort(unit) {
      const effort = this.effort;
      return unit !== undefined ? this.getProject().convertDuration(effort, this.effortUnit, unit) : effort;
    }

    writeEffort(me, transaction, quark, effort, unit) {
      if (effort < 0) effort = 0;
      if (!transaction.baseRevision.hasIdentifier(me) && effort == null) return;

      if (unit != null && unit !== this.effortUnit) {
        this.$.effortUnit.write.call(this, this.$.effortUnit, transaction, null, unit);
      }

      me.constructor.prototype.write(me, transaction, quark, effort);
    }

    setEffortUnit(_value) {
      throw new Error("Use `setEffort` instead");
    }
    /**
     * The method defines wether the provided child event should roll up its [[effort]] to this summary event or not.
     * If the method returns `true` the child event [[effort]] is summed up
     * when calculating this summary event [[effort]].
     * And if the method returns `false` the child effort is not taken into account.
     * By default the method returns `true` to include all child event [[effort]] values.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event [[effort]] should be included, `false` if not.
     */


    *shouldRollupChildEffort(childEvent) {
      return true;
    }
    /**
     * Helper method to calculate the total effort of all child events.
     */


    *calculateTotalChildrenEffort() {
      const childEvents = yield this.$.childEvents;
      const project = this.getProject();
      let totalEffortMs = 0;

      for (const childEvent of childEvents) {
        if (!(yield* this.shouldRollupChildEffort(childEvent))) continue;
        const childEventEffortUnit = yield childEvent.$.effortUnit;
        totalEffortMs += yield* project.$convertDuration(yield childEvent.$.effort, childEventEffortUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Millisecond);
      }

      return yield* project.$convertDuration(totalEffortMs, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Millisecond, yield this.$.effortUnit);
    }

    *calculateEffort() {
      const childEvents = yield this.$.childEvents;
      if (childEvents.size > 0) return yield* this.calculateTotalChildrenEffort();else {
        const proposed = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
        return proposed !== undefined ? proposed : yield* this.calculateEffortPure();
      }
    }

    *calculateEffortPure() {
      const childEvents = yield this.$.childEvents;
      if (childEvents.size > 0) return yield* this.calculateTotalChildrenEffort();else {
        return yield* this.calculateProjectedEffort(yield this.$.startDate, yield this.$.endDate);
      }
    }

    *calculateEffortProposed() {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }

    *calculateAssignmentUnits(assignment) {
      return yield* this.calculateAssignmentUnitsProposed(assignment);
    }

    *calculateAssignmentUnitsPure(assignment) {
      return yield* this.calculateUnitsByStartEndAndEffort(assignment);
    }

    *calculateAssignmentUnitsProposed(assignment) {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }

    *getBaseOptionsForEffortCalculations() {
      return {
        ignoreResourceCalendars: false
      };
    }

    *calculateProjectedEffort(startDate, endDate) {
      if (startDate == null || endDate == null || startDate > endDate) return null;
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      const totalUnitsByCalendar = new Map();

      for (const [calendar, assignments] of assignmentsByCalendar) {
        let intervalUnits = 0;

        for (const assignment of assignments) {
          intervalUnits += yield assignment.$.units;
        }

        totalUnitsByCalendar.set(calendar, intervalUnits);
      } //----------------------


      let resultN = 0;
      const options = Object.assign(yield* this.getBaseOptionsForEffortCalculations(), {
        startDate,
        endDate
      }); // if event has no assignments we treat that as it has a special, "virtual" assignment with 100 units and
      // the calendar matching the calendar of the task
      // we need to ignore resource calendars in this case, since there's no assigned resources

      if (totalUnitsByCalendar.size === 0) {
        totalUnitsByCalendar.set(yield this.$.effectiveCalendar, 100);
        options.ignoreResourceCalendars = true;
      }

      yield* this.forEachAvailabilityInterval(options, (intervalStart, intervalEnd, calendarCacheIntervalMultiple) => {
        const workCalendars = calendarCacheIntervalMultiple.getCalendarsWorking();
        const intervalStartN = intervalStart.getTime(),
              intervalEndN = intervalEnd.getTime(),
              intervalDuration = intervalEndN - intervalStartN;
        let intervalUnits = 0;

        for (const workingCalendar of workCalendars) {
          // the calendar of the event itself will be in the `workCalendars`, but it
          // will be missing in the `totalUnitsByCalendar` map, which is fine
          intervalUnits += totalUnitsByCalendar.get(workingCalendar) || 0;
        } // Effort = Units * Duration


        resultN += intervalUnits * intervalDuration * 0.01;
      });
      return yield* this.getProject().$convertDuration(resultN, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Millisecond, yield this.$.effortUnit);
    }

    *calculateUnitsByStartEndAndEffort(_assignment) {
      const effort = yield this.$.effort,
            effortUnit = yield this.$.effortUnit,
            effortMS = yield* this.getProject().$convertDuration(effort, effortUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Millisecond);
      let collectedEffort = 0;
      const options = Object.assign(yield* this.getBaseOptionsForEffortCalculations(), {
        startDate: yield this.$.startDate,
        endDate: yield this.$.endDate
      });
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      yield* this.forEachAvailabilityInterval(options, (intervalStart, intervalEnd, calendarCacheIntervalMultiple) => {
        const workCalendars = calendarCacheIntervalMultiple.getCalendarsWorking();
        const intervalStartN = intervalStart.getTime(),
              intervalEndN = intervalEnd.getTime(),
              intervalDuration = intervalEndN - intervalStartN;

        for (const workingCalendar of workCalendars) {
          collectedEffort += (assignmentsByCalendar.has(workingCalendar) ? assignmentsByCalendar.get(workingCalendar).length : 0) * intervalDuration;
        }
      });
      return collectedEffort ? 100 * effortMS / collectedEffort : 100;
    }

    *calculateProjectedXDateByEffort(baseDate, isForward = true) {
      const effort = yield this.$.effort,
            effortUnit = yield this.$.effortUnit,
            effortMS = yield* this.getProject().$convertDuration(effort, effortUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Millisecond);
      if (baseDate == null || effort == null) return null;
      let resultN = baseDate.getTime();
      let leftEffort = effortMS;
      const calendar = yield this.$.effectiveCalendar;
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      const totalUnitsByCalendar = new Map();

      for (const [calendar, assignments] of assignmentsByCalendar) {
        let intervalUnits = 0;

        for (const assignment of assignments) {
          intervalUnits += yield assignment.$.units;
        }

        totalUnitsByCalendar.set(calendar, intervalUnits);
      }

      if (assignmentsByCalendar.size > 0) {
        const options = Object.assign(yield* this.getBaseOptionsForDurationCalculations(), isForward ? {
          startDate: baseDate,
          isForward
        } : {
          endDate: baseDate,
          isForward
        });
        yield* this.forEachAvailabilityInterval(options, (intervalStart, intervalEnd, calendarCacheIntervalMultiple) => {
          const workCalendars = calendarCacheIntervalMultiple.getCalendarsWorking();
          const intervalStartN = intervalStart.getTime(),
                intervalEndN = intervalEnd.getTime(),
                intervalDuration = intervalEndN - intervalStartN;
          let intervalUnits = 0;

          for (const workingCalendar of workCalendars) {
            // the calendar of the event itself will be in the `workCalendars`, but it
            // will be missing in the `totalUnitsByCalendar` map, which is fine
            intervalUnits += totalUnitsByCalendar.get(workingCalendar) || 0;
          } // Effort = Units * Duration


          const intervalEffort = intervalUnits * intervalDuration * 0.01;

          if (intervalEffort >= leftEffort) {
            // resulting date is interval start plus left duration (Duration = Effort / Units)
            resultN = isForward ? intervalStartN + leftEffort / (0.01 * intervalUnits) : intervalEndN - leftEffort / (0.01 * intervalUnits);
            return false;
          } else {
            leftEffort -= intervalEffort;
          }
        });
        return new Date(resultN);
      } else {
        return calendar.accumulateWorkingTime(baseDate, effortMS, isForward).finalDate;
      }
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    'type': 'number'
    /*, defaultValue : 0*/

  })], HasEffortMixin.prototype, "effort", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    'type': 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Hour
  }, {
    converter: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalizeUnit
  })], HasEffortMixin.prototype, "effortUnit", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["write"])('effort')], HasEffortMixin.prototype, "writeEffort", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('effort')], HasEffortMixin.prototype, "calculateEffort", null);

  return HasEffortMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js ***!
  \****************************************************************/
/*! exports provided: HasSchedulingModeMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasSchedulingModeMixin", function() { return HasSchedulingModeMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_basic/BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
/* harmony import */ var _HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./HasEffortMixin.js */ "./lib/Engine/quark/model/gantt/HasEffortMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin serves as a "base class" for the individual scheduling modes mixins: [[FixedDurationMixin]], [[FixedEffortMixin]]
 * and [[FixedUnitsMixin]].
 *
 * Scheduling mode indicates, in which order the duration, effort and assignment units are changed. All these variables
 * are tied together with this invariant (in pseudo-code):
 *
 * ```
 * Effort = Duration * Units
 * ```
 *
 * For example, if we've doubled the effort of the task, we have the choice - we can either double its duration,
 * or double the assignment units, to keep the invariant.
 *
 * We have the same choices for every variable. The scheduling mode
 * basically defines the order in which the "duration", "effort" and "units" variables are updated when one of them changes.
 */

class HasSchedulingModeMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_8__["HasEffortMixin"]], base => {
  const superProto = base.prototype;

  class HasSchedulingModeMixin extends base {
    *calculateSchedulingMode() {
      return (yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"]) || _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal;
    }

    *effectiveSchedulingMode() {
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      return assignmentsByCalendar.size > 0 ? yield this.$.schedulingMode : _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal;
    }

    effectiveSchedulingModeSync(Y) {
      const assignmentsByCalendar = Y(this.$.assignmentsByCalendar);
      return assignmentsByCalendar.size > 0 ? Y(this.$.schedulingMode) : _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal;
    }

    *prepareDispatcher(YIELD) {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const cycleDispatcher = yield* superProto.prepareDispatcher.call(this, YIELD);
        cycleDispatcher.collectInfo(YIELD, this.$.effort, _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["EffortVar"]);
        if (yield* this.hasProposedValueForUnits()) cycleDispatcher.addProposedValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["UnitsVar"]); // units are always available

        cycleDispatcher.addPreviousValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["UnitsVar"]);
        return cycleDispatcher;
      } else {
        return yield* superProto.prepareDispatcher.call(this, YIELD);
      }
    }

    dispatcherClass(Y) {
      const schedulingMode = this.effectiveSchedulingModeSync(Y);

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        return _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["SEDWUDispatcher"];
      } else {
        return superProto.dispatcherClass.call(this, Y);
      }
    }

    buildProposedDispatcher(me, quark, transaction) {
      const dispatcher = superProto.buildProposedDispatcher.call(this, me, quark, transaction); // TODO should check for dispatcher class probably

      dispatcher.addPreviousValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["EffortVar"]);
      dispatcher.addPreviousValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["UnitsVar"]);
      return dispatcher;
    }

    *calculateAssignmentUnits(assignment) {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const dispatch = yield this.$.dispatcher;
        const formulaId = dispatch.resolution.get(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["UnitsVar"]);

        if (formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
          return yield* this.calculateAssignmentUnitsProposed(assignment);
        } else if (formulaId === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["unitsFormula"].formulaId) {
          return yield* this.calculateAssignmentUnitsPure(assignment);
        } else {
          throw new Error("Unknown formula for `units`");
        }
      } else {
        return yield* superProto.calculateAssignmentUnits.call(this, assignment);
      }
    }

    *calculateEffort() {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const dispatch = yield this.$.dispatcher;
        const formulaId = dispatch.resolution.get(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["EffortVar"]);

        if (formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
          return yield* this.calculateEffortProposed();
        } else if (formulaId === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["effortFormula"].formulaId) {
          return yield* this.calculateEffortPure();
        } else {
          throw new Error("Unknown formula for `effort`");
        }
      } else {
        return yield* superProto.calculateEffort.call(this);
      }
    }

    *calculateStartDate() {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const dispatch = yield this.$.dispatcher;
        const formulaId = dispatch.resolution.get(_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["StartDateVar"]);

        if (formulaId === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["startDateByEffortFormula"].formulaId) {
          return yield* this.calculateProjectedXDateByEffort(yield this.$.endDate, false);
        } else {
          return yield* superProto.calculateStartDate.call(this);
        }
      } else {
        return yield* superProto.calculateStartDate.call(this);
      }
    }

    *calculateEndDate() {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode !== _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const dispatch = yield this.$.dispatcher;
        const formulaId = dispatch.resolution.get(_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["EndDateVar"]);

        if (formulaId === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["endDateByEffortFormula"].formulaId) {
          return yield* this.calculateProjectedXDateByEffort(yield this.$.startDate, true);
        } else {
          return yield* superProto.calculateEndDate.call(this);
        }
      } else {
        return yield* superProto.calculateEndDate.call(this);
      }
    }

    *calculateEffectiveDuration() {
      const dispatch = yield this.$.dispatcher;
      const schedulingMode = yield* this.effectiveSchedulingMode();
      const durationResolution = dispatch.resolution.get(_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["DurationVar"]);
      const effortResolution = dispatch.resolution.get(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["EffortVar"]);
      let effectiveDurationToUse;

      if (durationResolution === _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["durationFormula"].formulaId && schedulingMode != _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal) {
        const proposedOrPreviousStartDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.startDate);
        const proposedOrPreviousEndDate = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.endDate);
        const startDateResolution = dispatch.resolution.get(_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["StartDateVar"]);
        const endDateResolution = dispatch.resolution.get(_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_6__["EndDateVar"]);
        const effortDriven = yield this.$.effortDriven;

        if (proposedOrPreviousEndDate && startDateResolution === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["startDateByEffortFormula"].formulaId) {
          effectiveDurationToUse = yield* this.calculateProjectedDuration(yield* this.calculateProjectedXDateByEffort(proposedOrPreviousEndDate, false), proposedOrPreviousEndDate);
        } else if (proposedOrPreviousStartDate && endDateResolution === _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["endDateByEffortFormula"].formulaId) {
          effectiveDurationToUse = yield* this.calculateProjectedDuration(proposedOrPreviousStartDate, yield* this.calculateProjectedXDateByEffort(proposedOrPreviousStartDate, true));
        } else if (proposedOrPreviousStartDate && proposedOrPreviousEndDate || !proposedOrPreviousStartDate && !proposedOrPreviousEndDate) {
          effectiveDurationToUse = yield* superProto.calculateEffectiveDuration.call(this);
        }
      } else effectiveDurationToUse = yield* superProto.calculateEffectiveDuration.call(this);

      return effectiveDurationToUse;
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    'type': 'boolean',
    defaultValue: false
  })], HasSchedulingModeMixin.prototype, "effortDriven", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["SchedulingMode"].Normal
  }, {
    sync: true
  })], HasSchedulingModeMixin.prototype, "schedulingMode", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["field"])({
    identifierCls: _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["SEDWUDispatcherIdentifier"]
  })], HasSchedulingModeMixin.prototype, "dispatcher", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('schedulingMode')], HasSchedulingModeMixin.prototype, "calculateSchedulingMode", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('effort')], HasSchedulingModeMixin.prototype, "calculateEffort", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('startDate')], HasSchedulingModeMixin.prototype, "calculateStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('endDate')], HasSchedulingModeMixin.prototype, "calculateEndDate", null);

  return HasSchedulingModeMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/InactiveEventMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/InactiveEventMixin.js ***!
  \************************************************************/
/*! exports provided: InactiveEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InactiveEventMixin", function() { return InactiveEventMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _gantt_ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../gantt/ScheduledByDependenciesLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





class InactiveEventMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_gantt_ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_3__["ScheduledByDependenciesLateEventMixin"]], base => {
  const superProto = base.prototype;

  class InactiveEventMixin extends base {
    writeInactive(me, transaction, quark, inactive) {
      var _a;

      const isLoading = !transaction.baseRevision.hasIdentifier(me);
      me.constructor.prototype.write.call(this, me, transaction, quark, inactive); // @ts-ignore
      // Apply parent inactive state to children unless we are loading data or undoing/redoing some changes
      // in such cases both parent and children data are supposed to be provided

      if (!isLoading && this.children && !((_a = this.stm) === null || _a === void 0 ? void 0 : _a.state.isRestoringStateClass)) {
        for (const child of this.children) {
          child.inactive = inactive;
        }
      }
    }

    *calculateInactive() {
      const inactive = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"]; // A summary task is active if it has at least one active sub-event

      if (yield* this.hasSubEvents()) {
        const subEvents = yield* this.subEventsIterable();
        let activeCnt = 0;

        for (const subEvent of subEvents) {
          // calculate active sub-events count
          if (!(yield subEvent.$.inactive)) activeCnt++;
        } // inactive if it has no active sub-events


        return !activeCnt;
      }

      return inactive;
    }

    *shouldRollupChildEffort(child) {
      return !(yield child.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildPercentDoneSummaryData(child) {
      return !(yield child.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildStartDate(child) {
      // Do not take into account inactive children dates when calculating
      // their parent start/end dates (unless the parent is also inactive)
      return !(yield child.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildEndDate(child) {
      // Do not take into account inactive children dates when calculating
      // their parent start/end dates (unless the parent is also inactive)
      return !(yield child.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildEarlyStartDate(childEvent) {
      // Do not take into account inactive children dates when calculating
      // their parent start end dates (unless the parent is also inactive)
      return !(yield childEvent.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildEarlyEndDate(childEvent) {
      // Do not take into account inactive children dates when calculating
      // their parent start end dates (unless the parent is also inactive)
      return !(yield childEvent.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildLateStartDate(childEvent) {
      // Do not take into account inactive children dates when calculating
      // their parent start end dates (unless the parent is also inactive)
      return !(yield childEvent.$.inactive) || (yield this.$.inactive);
    }

    *shouldRollupChildLateEndDate(childEvent) {
      // Do not take into account inactive children dates when calculating
      // their parent start end dates (unless the parent is also inactive)
      return !(yield childEvent.$.inactive) || (yield this.$.inactive);
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["write"])('inactive')], InactiveEventMixin.prototype, "writeInactive", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('inactive')], InactiveEventMixin.prototype, "calculateInactive", null);

  return InactiveEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js":
/*!*******************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js ***!
  \*******************************************************************************/
/*! exports provided: ScheduledByDependenciesLateEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduledByDependenciesLateEventMixin", function() { return ScheduledByDependenciesLateEventMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_pro_ScheduledByDependenciesEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_pro/ScheduledByDependenciesEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ScheduledByDependenciesEarlyEventMixin.js");
/* harmony import */ var _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ConstrainedLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin adds support for scheduling event ALAP, by dependencies. All it does is
 * create the "late" constraint interval for every outgoing dependency.
 *
 * See [[ConstrainedEarlyEventMixin]] for more details about constraint-based scheduling.
 * See also [[ScheduledByDependenciesEarlyEventMixin]].
 */

class ScheduledByDependenciesLateEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_pro_ScheduledByDependenciesEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_5__["ScheduledByDependenciesEarlyEventMixin"], _ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_6__["ConstrainedLateEventMixin"]], base => {
  const superProto = base.prototype;

  class ScheduledByDependenciesLateEventMixin extends base {
    *shouldSuccessorAffectScheduling(dependency) {
      const toEvent = yield dependency.$.toEvent; // ignore missing target events and inactive dependencies

      return toEvent && !Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["isAtomicValue"])(toEvent) && (yield dependency.$.active) // and inactive target events (unless this event is also inactive)
      && (!(yield toEvent.$.inactive) || (yield this.$.inactive));
    }

    *calculateLateStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateLateStartDateConstraintIntervals.call(this);
      const project = this.getProject();
      let dependency;

      for (dependency of yield this.$.outgoingDeps) {
        // ignore missing target events and inactive dependencies
        if (!(yield* this.shouldSuccessorAffectScheduling(dependency))) continue;
        const successor = yield dependency.$.toEvent;
        let interval;

        switch (yield dependency.$.type) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].StartToStart:
            const successorStartDate = yield successor.$.lateStartDateRaw;

            if (successorStartDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: null,
                endDate: calendar.calculateStartDate(successorStartDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond))
              });
            }

            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].StartToEnd:
            const successorEndDate = yield successor.$.lateEndDateRaw;

            if (successorEndDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: null,
                endDate: calendar.calculateStartDate(successorEndDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond))
              });
            }

            break;
        }

        interval && intervals.unshift(interval);
      }

      return intervals;
    }

    *calculateLateEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateLateEndDateConstraintIntervals.call(this);
      const project = this.getProject();
      let dependency;

      for (dependency of yield this.$.outgoingDeps) {
        // ignore missing target events and inactive dependencies
        if (!(yield* this.shouldSuccessorAffectScheduling(dependency))) continue;
        const successor = yield dependency.$.toEvent;
        let interval;

        switch (yield dependency.$.type) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].EndToEnd:
            const successorEndDate = yield successor.$.lateEndDateRaw;

            if (successorEndDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: null,
                endDate: calendar.calculateStartDate(successorEndDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond))
              });
            }

            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].EndToStart:
            const successorStartDate = yield successor.$.lateStartDateRaw;

            if (successorStartDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: null,
                endDate: calendar.calculateStartDate(successorStartDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond))
              });
            }

            break;
        }

        interval && intervals.unshift(interval);
      }

      return intervals;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('lateStartDateIntervals')], ScheduledByDependenciesLateEventMixin.prototype, "calculateLateStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('lateEndDateIntervals')], ScheduledByDependenciesLateEventMixin.prototype, "calculateLateEndDateConstraintIntervals", null);

  return ScheduledByDependenciesLateEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationDispatcher.js":
/*!**********************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationDispatcher.js ***!
  \**********************************************************************************/
/*! exports provided: fixedDurationSEDWUGraphDescription, fixedDurationSEDWUForwardNonEffortDriven, fixedDurationSEDWUForwardEffortDriven, fixedDurationSEDWUBackwardNonEffortDriven, fixedDurationSEDWUBackwardEffortDriven */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUGraphDescription", function() { return fixedDurationSEDWUGraphDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardNonEffortDriven", function() { return fixedDurationSEDWUForwardNonEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardEffortDriven", function() { return fixedDurationSEDWUForwardEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardNonEffortDriven", function() { return fixedDurationSEDWUBackwardNonEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardEffortDriven", function() { return fixedDurationSEDWUBackwardEffortDriven; });
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../scheduler_basic/BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

const fixedDurationSEDWUGraphDescription = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleDescription"].new({
  variables: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["DurationVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["EffortVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["UnitsVar"]]),
  formulas: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]])
}); //---------------------------------------------------------------------------------------------------------------------

const fixedDurationSEDWUForwardNonEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedDurationSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]])
});
const fixedDurationSEDWUForwardEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedDurationSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"]])
});
const fixedDurationSEDWUBackwardNonEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedDurationSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]])
});
const fixedDurationSEDWUBackwardEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedDurationSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"]])
});

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationMixin.js":
/*!*****************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationMixin.js ***!
  \*****************************************************************************/
/*! exports provided: FixedDurationMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedDurationMixin", function() { return FixedDurationMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
/* harmony import */ var _HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../HasSchedulingModeMixin.js */ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js");
/* harmony import */ var _FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FixedDurationDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationDispatcher.js");
var productName = 'gantt';





 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides the fixed duration scheduling mode facility. The scheduling mode is controlled with the
 * [[HasSchedulingModeMixin.schedulingMode]] field.
 *
 * See [[HasSchedulingModeMixin]] for more details.
 *
 * In this mode, the duration of the task remains "fixed" as the name suggest. It is changed only if there's no other options,
 * for example if both "effort" and "units" has changed. In other cases, some other variable is updated.
 *
 * If the [[HasSchedulingModeMixin.effortDriven]] flag is enabled, effort variable becomes "fixed" as well, so normally the "units"
 * variable will change. If that flag is disabled, then "effort" will be changed.
 */

class FixedDurationMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__["HasSchedulingModeMixin"]], base => {
  const superProto = base.prototype;

  class FixedDurationMixin extends base {
    *prepareDispatcher(YIELD) {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedDuration) {
        const cycleDispatcher = yield* superProto.prepareDispatcher.call(this, YIELD);
        const effortDriven = yield this.$.effortDriven;
        if (effortDriven) cycleDispatcher.addKeepIfPossibleFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["EffortVar"]);

        if (yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["HasProposedValue"])(this.$.assigned)) {
          // for effort driven case, we treat adding/removing of assignments as changing effort
          // instead of units (this will trigger both, but units formula will win in presence of effort change)
          if (effortDriven) {
            cycleDispatcher.addProposedValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["EffortVar"]);
          } else {
            cycleDispatcher.addProposedValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["UnitsVar"]);
          }
        }

        return cycleDispatcher;
      } else {
        return yield* superProto.prepareDispatcher.call(this, YIELD);
      }
    }

    cycleResolutionContext(Y) {
      const schedulingMode = this.effectiveSchedulingModeSync(Y);

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedDuration) {
        const direction = Y(this.$.direction);
        const effortDriven = Y(this.$.effortDriven);

        if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].Forward || direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].None) {
          return effortDriven ? _FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedDurationSEDWUForwardEffortDriven"] : _FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedDurationSEDWUForwardNonEffortDriven"];
        } else {
          return effortDriven ? _FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedDurationSEDWUBackwardEffortDriven"] : _FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedDurationSEDWUBackwardNonEffortDriven"];
        }
      } else {
        return superProto.cycleResolutionContext.call(this, Y);
      }
    }

    *getBaseOptionsForDurationCalculations() {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedDuration) {
        return {
          ignoreResourceCalendars: true
        };
      } else {
        return yield* superProto.getBaseOptionsForDurationCalculations.call(this);
      }
    }

  }

  return FixedDurationMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortDispatcher.js":
/*!********************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortDispatcher.js ***!
  \********************************************************************************/
/*! exports provided: fixedEffortSEDWUGraphDescription, fixedEffortSEDWUForward, fixedEffortSEDWUBackward */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUGraphDescription", function() { return fixedEffortSEDWUGraphDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUForward", function() { return fixedEffortSEDWUForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUBackward", function() { return fixedEffortSEDWUBackward; });
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../scheduler_basic/BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

const fixedEffortSEDWUGraphDescription = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleDescription"].new({
  variables: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["DurationVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["EffortVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["UnitsVar"]]),
  formulas: new Set([// the order of formulas is important here - the earlier ones are preferred
  _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"]])
}); //---------------------------------------------------------------------------------------------------------------------

const fixedEffortSEDWUForward = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedEffortSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"]])
});
const fixedEffortSEDWUBackward = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedEffortSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"]])
});

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortMixin.js ***!
  \***************************************************************************/
/*! exports provided: FixedEffortMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedEffortMixin", function() { return FixedEffortMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
/* harmony import */ var _HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../HasSchedulingModeMixin.js */ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js");
/* harmony import */ var _FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FixedEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortDispatcher.js");
var productName = 'gantt';





 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides the fixed effort scheduling mode facility. The scheduling mode is controlled with the
 * [[HasSchedulingModeMixin.schedulingMode]] field.
 *
 * See [[HasSchedulingModeMixin]] for more details.
 *
 * In this mode, the effort of the task remains "fixed" as the name suggest. It is changed only if there's no other options,
 * for example if both "duration" and "units" has changed. In other cases, some other variable is updated.
 */

class FixedEffortMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__["HasSchedulingModeMixin"]], base => {
  const superProto = base.prototype;

  class FixedEffortMixin extends base {
    *prepareDispatcher(YIELD) {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedEffort) {
        const cycleDispatcher = yield* superProto.prepareDispatcher.call(this, YIELD);
        if (yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["HasProposedValue"])(this.$.assigned)) cycleDispatcher.addProposedValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["UnitsVar"]);
        cycleDispatcher.addKeepIfPossibleFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["EffortVar"]);
        return cycleDispatcher;
      } else {
        return yield* superProto.prepareDispatcher.call(this, YIELD);
      }
    }

    cycleResolutionContext(Y) {
      const schedulingMode = this.effectiveSchedulingModeSync(Y);

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedEffort) {
        const direction = Y(this.$.direction);
        return direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].Forward || direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].None ? _FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedEffortSEDWUForward"] : _FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedEffortSEDWUBackward"];
      } else {
        return superProto.cycleResolutionContext.call(this, Y);
      }
    }

  }

  return FixedEffortMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsDispatcher.js":
/*!*******************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsDispatcher.js ***!
  \*******************************************************************************/
/*! exports provided: fixedUnitsSEDWUGraphDescription, fixedUnitsSEDWUForwardNonEffortDriven, fixedUnitsSEDWUForwardEffortDriven, fixedUnitsSEDWUBackwardNonEffortDriven, fixedUnitsSEDWUBackwardEffortDriven */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUGraphDescription", function() { return fixedUnitsSEDWUGraphDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardNonEffortDriven", function() { return fixedUnitsSEDWUForwardNonEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardEffortDriven", function() { return fixedUnitsSEDWUForwardEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardNonEffortDriven", function() { return fixedUnitsSEDWUBackwardNonEffortDriven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardEffortDriven", function() { return fixedUnitsSEDWUBackwardEffortDriven; });
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../scheduler_basic/BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
var productName = 'gantt';


 //---------------------------------------------------------------------------------------------------------------------

const fixedUnitsSEDWUGraphDescription = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleDescription"].new({
  variables: new Set([_scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["StartDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["EndDateVar"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["DurationVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["EffortVar"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["UnitsVar"]]),
  formulas: new Set([// the order of formulas is important here - the earlier ones are preferred
  _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"]])
}); //---------------------------------------------------------------------------------------------------------------------

const fixedUnitsSEDWUForwardNonEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedUnitsSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]])
});
const fixedUnitsSEDWUForwardEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedUnitsSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["endDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"]])
});
const fixedUnitsSEDWUBackwardNonEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedUnitsSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]])
});
const fixedUnitsSEDWUBackwardEffortDriven = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolution"].new({
  description: fixedUnitsSEDWUGraphDescription,
  defaultResolutionFormulas: new Set([_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["startDateFormula"], _scheduler_basic_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_1__["durationFormula"]])
});

/***/ }),

/***/ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsMixin.js":
/*!**************************************************************************!*\
  !*** ./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsMixin.js ***!
  \**************************************************************************/
/*! exports provided: FixedUnitsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedUnitsMixin", function() { return FixedUnitsMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
/* harmony import */ var _HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../HasSchedulingModeMixin.js */ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js");
/* harmony import */ var _FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FixedUnitsDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsDispatcher.js");
var productName = 'gantt';





 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides the fixed units scheduling mode facility. The scheduling mode is controlled with the
 * [[HasSchedulingModeMixin.schedulingMode]] field.
 *
 * See [[HasSchedulingModeMixin]] for more details.
 *
 * In this mode, the assignment units of the task's assignments remains "fixed" as the name suggest.
 * Those are changed only if there's no other options, for example if both "duration" and "effort" has changed.
 *
 * If the [[HasSchedulingModeMixin.effortDriven]] flag is enabled, effort variable becomes "fixed" as well, so normally the "duration"
 * variable will change. If that flag is disabled, then "effort" will be changed.
 */

class FixedUnitsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_4__["HasSchedulingModeMixin"]], base => {
  const superProto = base.prototype;

  class FixedUnitsMixin extends base {
    *prepareDispatcher(YIELD) {
      const schedulingMode = yield* this.effectiveSchedulingMode();

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedUnits) {
        const cycleDispatcher = yield* superProto.prepareDispatcher.call(this, YIELD);
        if (yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["HasProposedValue"])(this.$.assigned)) cycleDispatcher.addProposedValueFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["UnitsVar"]);
        if (yield this.$.effortDriven) cycleDispatcher.addKeepIfPossibleFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["EffortVar"]);
        cycleDispatcher.addKeepIfPossibleFlag(_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_3__["UnitsVar"]);
        return cycleDispatcher;
      } else {
        return yield* superProto.prepareDispatcher.call(this, YIELD);
      }
    }

    cycleResolutionContext(Y) {
      const schedulingMode = this.effectiveSchedulingModeSync(Y);

      if (schedulingMode === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedUnits) {
        const direction = Y(this.$.direction);
        const effortDriven = Y(this.$.effortDriven);

        if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].Forward || direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["Direction"].None) {
          return effortDriven ? _FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedUnitsSEDWUForwardEffortDriven"] : _FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedUnitsSEDWUForwardNonEffortDriven"];
        } else {
          return effortDriven ? _FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedUnitsSEDWUBackwardEffortDriven"] : _FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_5__["fixedUnitsSEDWUBackwardNonEffortDriven"];
        }
      } else {
        return superProto.cycleResolutionContext.call(this, Y);
      }
    }

  }

  return FixedUnitsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectModelMixin", function() { return AbstractPartOfProjectModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';





/**
 * This an abstract mixin for every Model that belongs to a project.
 *
 * The model with this mixin, supposes that it will be "joining" a store that is already part of a project,
 * so that such model can take a reference to the project from it.
 *
 * It provides 2 template methods [[joinProject]] and [[leaveProject]], which can be overridden in other mixins.
 */

class AbstractPartOfProjectModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectModelMixin extends base {
    joinStore(store) {
      let joinedProject = false; // Joining a store that is not part of project (for example a chained store) should not affect engine

      if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"])) {
        const project = store.getProject(); // Join directly only if not repopulating the store, in which case we will be joined later after
        // graph has been recreated

        if (project && !project.isRepopulatingStores && !this.getProject()) {
          this.setProject(project);
          joinedProject = true;
        }
      }

      superProto.joinStore.call(this, store);
      if (joinedProject) this.joinProject();
    }

    unjoinStore(store, isReplacing = false) {
      superProto.unjoinStore.call(this, store, isReplacing);
      const project = this.getProject();
      const isLeavingProjectStore = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]) && project === store.getProject(); // Leave project when unjoining from store, but do not bother if the project is being destroyed or if
      // the dataset is being replaced

      if (project && !project.isDestroying && !project.isRepopulatingStores && isLeavingProjectStore) {
        this.leaveProject(isReplacing);
        this.setProject(null);
      } // @ts-ignore


      if (isLeavingProjectStore) this.graph = null;
    }
    /**
     * Template method, which is called when model is joining the project (through joining some store that
     * has already joined the project)
     */


    joinProject() {}
    /**
     * Template method, which is called when model is leaving the project (through leaving some store usually)
     */


    leaveProject(isReplacing = false) {}

    calculateProject() {
      const store = this.stores.find(s => Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(s, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]) && !!s.getProject());
      return store === null || store === void 0 ? void 0 : store.getProject();
    }

    async setAsync(fieldName, value, silent) {
      var _a;

      const result = this.set(fieldName, value, silent);
      await ((_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());
      return result;
    }

    async getAsync(fieldName) {
      var _a;

      await ((_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());
      return this.get(fieldName);
    }

  }

  return AbstractPartOfProjectModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js ***!
  \***********************************************************************/
/*! exports provided: ChronoPartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectModelMixin", function() { return ChronoPartOfProjectModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ChronoPartOfProjectGenericMixin.js */ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js");
/* harmony import */ var _store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../store/mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
var productName = 'gantt';






/**
 * This a base mixin for every Model that belongs to a ChronoGraph powered project.
 *
 * The model with this mixin, supposes that it will be "joining" a store that is already part of a project,
 * so that such model can take a reference to the project from it.
 *
 * It provides 2 template methods [[joinProject]] and [[leaveProject]], which can be overridden in other mixins
 * (they should always call `super` implementation, because it adds/remove the model to/from the ChronoGraph instance)
 */

class ChronoPartOfProjectModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_4__["AbstractPartOfProjectModelMixin"], _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoPartOfProjectGenericMixin"], _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["ChronoModelMixin"]], base => {
  const superProto = base.prototype;

  class ChronoPartOfProjectModelMixin extends base {
    /**
     * Template method, which is called when model is joining the project (through joining some store that
     * has already joined the project)
     */
    joinProject() {
      this.getGraph().addEntity(this);
    }
    /**
     * Template method, which is called when model is leaving the project (through leaving some store usually)
     */


    leaveProject(isReplacing = false) {
      superProto.leaveProject.call(this, isReplacing);
      const replica = this.getGraph();
      replica.removeEntity(this); // @ts-ignore

      this.graph = null;
    }
    /**
     * Returns a [[SchedulerBasicProjectMixin|project]] instance
     */


    getProject() {
      return superProto.getProject.call(this);
    }

    calculateProject() {
      const store = this.stores.find(s => Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_5__["isInstanceOf"])(s, _store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoPartOfProjectStoreMixin"]) && !!s.getProject());
      return store === null || store === void 0 ? void 0 : store.getProject();
    }

  }

  return ChronoPartOfProjectModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectModelMixin", function() { return CorePartOfProjectModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'gantt';




/**
 * This a mixin for every Model that belongs to a scheduler_core project.
 *
 * It adds functions needed to calculate invalidated fields on project commit.
 */

class CorePartOfProjectModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractPartOfProjectModelMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectModelMixin extends base {
    constructor() {
      super(...arguments); // Flag set during calculation

      this.$isCalculating = false; // Proposed changes

      this.$changed = {}; // Value before proposed change, for buckets that need to update data early

      this.$beforeChange = {};
    } // Invalidate record upon joining project, leads to a buffered commit


    joinProject() {
      this.invalidate();
    } // Trigger a buffered commit when leaving the project


    leaveProject(isReplacing = false) {
      var _a;

      superProto.leaveProject.call(this, isReplacing);
      (_a = this.project) === null || _a === void 0 ? void 0 : _a.bufferedCommitAsync();
    }
    /**
     * Invalidates this record, queueing it for calculation on project commit.
     */


    invalidate() {
      var _a;

      (_a = this.project) === null || _a === void 0 ? void 0 : _a.invalidate(this);
    }
    /**
     * Used to retrieve the proposed (before 'dataReady') or current (after 'dataReady') value for a field.
     * If there is no proposed change, it is functionally equal to a normal `record.get()` call.
     */


    getCurrentOrProposed(fieldName) {
      var _a;

      if (fieldName in this.$changed) {
        return this.$changed[fieldName];
      }

      return (_a = this.get(fieldName)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Determines if the specified field has a value or not, value can be either current or proposed.
     */


    hasCurrentOrProposed(fieldName) {
      return this.$changed[fieldName] != null || this.get(fieldName) != null;
    }
    /**
     * Propose changes, to be considered during calculation. Also invalidates the record.
     */


    propose(changes) {
      const keys = Object.keys(changes);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        this.$changed[key] = changes[key];
      }

      this.invalidate();
    }
    /**
     * Similar to propose, but with more options. Mostly used by buckets, since they need data to update early.
     */


    setChanged(field, value, invalidate = true, setData = false) {
      const me = this;
      me.$changed[field] = value; // Buckets need to keep data up to date immediately

      if (setData) {
        if (!(field in me.$beforeChange)) {
          me.$beforeChange[field] = me.get(field);
        }

        me.setData(field, value);
      }

      invalidate && me.invalidate();
    }
    /**
     * Hook called before project refresh, override and calculate required changes in subclasses
     */


    calculateInvalidated() {}
    /**
     * Called after project refresh, before dataReady. Announce updated data
     */


    finalizeInvalidated(silent = false) {
      const me = this;
      me.$isCalculating = true;

      if (!silent) {
        // First silently revert any data change (used by buckets), otherwise it wont be detected by `set()`
        me.setData(me.$beforeChange); // Then do a proper set

        me.set(me.$changed);
      } else {
        me.setData(me.$changed);
      }

      me.$changed = {};
      me.$beforeChange = {};
      me.$isCalculating = false;
    }

  }

  return CorePartOfProjectModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js ***!
  \***********************************************************************/
/*! exports provided: BaseAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAssignmentMixin", function() { return BaseAssignmentMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Base assignment model class. It just contains references to the [[BaseEventMixin|event]] and [[BaseResourceMixin|resource]] being assigned.
 */

class BaseAssignmentMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class BaseAssignmentMixin extends base {}

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({
    bucket: 'assigned',
    resolver: function (id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      serialize: event => event === null || event === void 0 ? void 0 : event.id,
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"],
      persist: false
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelReferenceField"])], BaseAssignmentMixin.prototype, "event", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({
    bucket: 'assigned',
    resolver: function (id) {
      return this.getResourceById(id);
    },
    modelFieldConfig: {
      serialize: resource => resource === null || resource === void 0 ? void 0 : resource.id,
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"],
      persist: false
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelReferenceField"])], BaseAssignmentMixin.prototype, "resource", void 0); // inject "fields" getter override to apply "modelFieldConfig" to "event" & "resource" fields


  Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["injectStaticFieldsProperty"])(BaseAssignmentMixin);
  return BaseAssignmentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js ***!
  \*********************************************************************/
/*! exports provided: BaseCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseCalendarMixin", function() { return BaseCalendarMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






const hasMixin = Symbol('CalendarMixin');
/**
 * The calendar for project scheduling, it is used to mark certain time intervals as "non-working" and ignore them during scheduling.
 *
 * The calendar consists from several [[CalendarIntervalMixin|intervals]]. The intervals can be either static or recurrent.
 */

class BaseCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_4__["AbstractCalendarMixin"], _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class BaseCalendarMixin extends base {
    constructor() {
      super(...arguments);
      this.version = 1; // // this makes the calendar's self-atom to change (and trigger calculation on outgoing edges) on every `version` change
      // * calculateSelf () : CalculationIterator<this> {
      //     yield this.$.version
      //
      //     return this
      // }
    }

    [hasMixin]() {}

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])({
    persistent: false
  })], BaseCalendarMixin.prototype, "version", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["model_field"])({
    type: 'string'
  })], BaseCalendarMixin.prototype, "name", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["model_field"])({
    type: 'boolean',
    defaultValue: true
  })], BaseCalendarMixin.prototype, "unspecifiedTimeIsWorking", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["model_field"])()], BaseCalendarMixin.prototype, "intervals", void 0);

  return BaseCalendarMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js ***!
  \***********************************************************************/
/*! exports provided: BaseDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseDependencyMixin", function() { return BaseDependencyMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Base dependency entity mixin type
 */

class BaseDependencyMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_4__["ChronoPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class BaseDependencyMixin extends base {}

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({
    bucket: 'outgoingDeps',
    resolver: function (id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      persist: true,
      serialize: event => event === null || event === void 0 ? void 0 : event.id,
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"]
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelReferenceField"])], BaseDependencyMixin.prototype, "fromEvent", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({
    bucket: 'incomingDeps',
    resolver: function (id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      persist: true,
      serialize: event => event === null || event === void 0 ? void 0 : event.id,
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"]
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelReferenceField"])], BaseDependencyMixin.prototype, "toEvent", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["model_field"])({
    type: 'int',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["DependencyType"].EndToStart
  })], BaseDependencyMixin.prototype, "type", void 0);

  return BaseDependencyMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js ***!
  \***********************************************************************/
/*! exports provided: Instruction, StartDateVar, EndDateVar, DurationVar, startDateFormula, endDateFormula, durationFormula, SEDGraphDescription, SEDForwardCycleResolutionContext, SEDBackwardCycleResolutionContext, SEDDispatcher, SEDDispatcherIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Instruction", function() { return Instruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StartDateVar", function() { return StartDateVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EndDateVar", function() { return EndDateVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DurationVar", function() { return DurationVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startDateFormula", function() { return startDateFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endDateFormula", function() { return endDateFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "durationFormula", function() { return durationFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDGraphDescription", function() { return SEDGraphDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDForwardCycleResolutionContext", function() { return SEDForwardCycleResolutionContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDBackwardCycleResolutionContext", function() { return SEDBackwardCycleResolutionContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDDispatcher", function() { return SEDDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDDispatcherIdentifier", function() { return SEDDispatcherIdentifier; });
/* harmony import */ var _ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/CycleResolver.js */ "./lib/ChronoGraph/chrono/CycleResolver.js");
/* harmony import */ var _ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
var productName = 'gantt';



 //---------------------------------------------------------------------------------------------------------------------

var Instruction;

(function (Instruction) {
  Instruction["KeepDuration"] = "KeepDuration";
  Instruction["KeepStartDate"] = "KeepStartDate";
  Instruction["KeepEndDate"] = "KeepEndDate";
})(Instruction || (Instruction = {})); //---------------------------------------------------------------------------------------------------------------------


const StartDateVar = Symbol('StartDate');
const EndDateVar = Symbol('EndDate');
const DurationVar = Symbol('Duration'); //---------------------------------------------------------------------------------------------------------------------

const startDateFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["Formula"].new({
  output: StartDateVar,
  inputs: new Set([DurationVar, EndDateVar])
});
const endDateFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["Formula"].new({
  output: EndDateVar,
  inputs: new Set([DurationVar, StartDateVar])
});
const durationFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["Formula"].new({
  output: DurationVar,
  inputs: new Set([StartDateVar, EndDateVar])
}); //---------------------------------------------------------------------------------------------------------------------

const SEDGraphDescription = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CycleDescription"].new({
  variables: new Set([StartDateVar, EndDateVar, DurationVar]),
  formulas: new Set([startDateFormula, endDateFormula, durationFormula])
});
const SEDForwardCycleResolutionContext = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CycleResolution"].new({
  description: SEDGraphDescription,
  defaultResolutionFormulas: new Set([endDateFormula])
});
const SEDBackwardCycleResolutionContext = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CycleResolution"].new({
  description: SEDGraphDescription,
  defaultResolutionFormulas: new Set([startDateFormula])
}); //---------------------------------------------------------------------------------------------------------------------

class SEDDispatcher extends _ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_0__["CycleResolutionInputChrono"] {
  addInstruction(instruction) {
    if (instruction === Instruction.KeepStartDate) this.addKeepIfPossibleFlag(StartDateVar);
    if (instruction === Instruction.KeepEndDate) this.addKeepIfPossibleFlag(EndDateVar);
    if (instruction === Instruction.KeepDuration) this.addKeepIfPossibleFlag(DurationVar);
  }

} //---------------------------------------------------------------------------------------------------------------------

class SEDDispatcherIdentifier extends _ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_3__["FieldIdentifier"].mix(_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_1__["CalculatedValueGen"]) {
  equality(v1, v2) {
    const resolution1 = v1.resolution;
    const resolution2 = v2.resolution;
    return resolution1.get(StartDateVar) === resolution2.get(StartDateVar) && resolution1.get(EndDateVar) === resolution2.get(EndDateVar) && resolution1.get(DurationVar) === resolution2.get(DurationVar);
  }

}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js":
/*!******************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js ***!
  \******************************************************************/
/*! exports provided: BaseEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseEventMixin", function() { return BaseEventMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony import */ var _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};










 //---------------------------------------------------------------------------------------------------------------------

/**
 * Base event entity mixin type.
 *
 * At this level event is only aware about its calendar (which is inherited from project, if not provided).
 * The functionality, related to the dependencies, constraints etc is provided in other mixins.
 *
 * A time interval will be "counted" into the event duration, only if the event's calendar has that interval
 * as working. Otherwise the time is skipped and not counted into event's duration.
 *
 */

class BaseEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__["HasCalendarMixin"]], base => {
  const superProto = base.prototype;

  class BaseEventMixin extends base {
    *calculateDispatcher(YIELD) {
      // this value is not used directly, but it contains a default cycle resolution
      // if we calculate different resolution, dispatcher will be marked dirty
      // on next revision
      const proposed = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
      const cycleDispatcher = yield* this.prepareDispatcher(YIELD); //--------------

      const startDateProposedArgs = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedArgumentsOf"])(this.$.startDate);
      const startInstruction = startDateProposedArgs ? startDateProposedArgs[0] ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepEndDate : undefined;
      if (startInstruction) cycleDispatcher.addInstruction(startInstruction); //--------------

      const endDateProposedArgs = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedArgumentsOf"])(this.$.endDate);
      const endInstruction = endDateProposedArgs ? endDateProposedArgs[0] ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepStartDate : undefined;
      if (endInstruction) cycleDispatcher.addInstruction(endInstruction); //--------------

      const directionValue = yield this.$.direction;
      const durationProposedArgs = yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedArgumentsOf"])(this.$.duration);
      let durationInstruction;

      if (durationProposedArgs) {
        switch (durationProposedArgs[0]) {
          case true:
            durationInstruction = _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepStartDate;
            break;

          case false:
            durationInstruction = _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepEndDate;
            break;
        }
      }

      if (!durationInstruction && cycleDispatcher.hasProposedValue(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["DurationVar"])) {
        durationInstruction = directionValue === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward || directionValue === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].None ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepStartDate : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepEndDate;
      }

      if (durationInstruction) cycleDispatcher.addInstruction(durationInstruction);
      return cycleDispatcher;
    }

    *prepareDispatcher(Y) {
      const dispatcherClass = this.dispatcherClass(Y);
      const cycleDispatcher = dispatcherClass.new({
        context: this.cycleResolutionContext(Y)
      });
      cycleDispatcher.collectInfo(Y, this.$.startDate, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["StartDateVar"]);
      cycleDispatcher.collectInfo(Y, this.$.endDate, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["EndDateVar"]);
      cycleDispatcher.collectInfo(Y, this.$.duration, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["DurationVar"]);
      return cycleDispatcher;
    }

    cycleResolutionContext(Y) {
      const direction = Y(this.$.direction);
      return direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward || direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].None ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["SEDForwardCycleResolutionContext"] : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["SEDBackwardCycleResolutionContext"];
    }

    dispatcherClass(Y) {
      return _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["SEDDispatcher"];
    }

    buildProposedDispatcher(me, quark, transaction) {
      const dispatcher = this.dispatcherClass(transaction.onEffectSync).new({
        context: this.cycleResolutionContext(transaction.onEffectSync)
      });
      dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["StartDateVar"]);
      dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["EndDateVar"]);
      dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["DurationVar"]);
      return dispatcher;
    }
    /**
     * The method skips the event non working time starting from the provided `date` and
     * going either _forward_ or _backward_ in time.
     * It uses the event [[effectiveCalendar|effective calendar]] to detect which time is not working.
     * @param date Date to start skipping from
     * @param isForward Skip direction (`true` to go forward in time, `false` - backwards)
     */


    *skipNonWorkingTime(date, isForward) {
      const calendar = yield this.$.effectiveCalendar;
      if (!date) return null;
      const skippingRes = calendar.skipNonWorkingTime(date, isForward);

      if (skippingRes instanceof Date) {
        return skippingRes;
      } else {
        yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])("Empty calendar");
      }
    }
    /**
     * The method skips the provided amount of the event _working time_
     * starting from the `date` and going either _forward_ or _backward_ in time.
     * It uses the event [[effectiveCalendar|effective calendar]] to detect which time is not working.
     * @param date Date to start skipping from
     * @param isForward Skip direction (`true` to go forward in time, `false` - backwards)
     * @param duration Amount of working time to skip
     * @param unit Units the `duration` value in (if not provided then duration is considered provided in [[durationUnit]])
     */


    *skipWorkingTime(date, isForward, duration, unit) {
      const durationUnit = yield this.$.durationUnit; // Convert duration to duration unit if needed

      if (unit && unit !== durationUnit) {
        duration = yield* this.getProject().$convertDuration(duration, unit, durationUnit);
      }

      return yield* this.calculateProjectedXDateWithDuration(date, isForward, duration);
    } // copied generated method, to avoid compilation error when it is overridden in HasDateConstraintMixin

    /**
     * Sets the event [[startDate|start date]]
     *
     * @param date The new start date to set
     * @param keepDuration Whether the intention is to keep the `duration` field (`keepDuration = true`) or `endDate` (`keepDuration = false`)
     */


    setStartDate(date, keepDuration = true) {
      if (this.graph) {
        this.graph.write(this.$.startDate, date, keepDuration);
        return this.graph.commitAsync();
      } else {
        this.$.startDate.DATA = date;
      }
    }

    writeStartDate(me, transaction, quark, date, keepDuration = true) {
      // we use the approach, that when user sets some atom to `null`
      // that `null` is propagated as a normal valid value through all calculation formulas
      // turning the result of all calculations to `null`
      // this works well, except the initial data load case, when don't want to do such propagation
      // but instead wants to "normalize" the data
      // because of that we ignore the `null` writes, for the initial data load case
      if (!transaction.baseRevision.hasIdentifier(me) && date == null) return;
      const instruction = keepDuration ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["Instruction"].KeepEndDate;
      me.constructor.prototype.write.call(this, me, transaction, quark, date, keepDuration);
    }
    /**
     * The main calculation method for the [[startDate]] field. Delegates to either [[calculateStartDateProposed]]
     * or [[calculateStartDatePure]], depending on the information from [[dispatcher]]
     */


    *calculateStartDate() {
      const dispatch = yield this.$.dispatcher;
      const formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["StartDateVar"]);

      if (formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
        return yield* this.calculateStartDateProposed();
      } else if (formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["startDateFormula"].formulaId) {
        return yield* this.calculateStartDatePure();
      } else {
        throw new Error("Unknown formula for `startDate`");
      }
    }
    /**
     * The "pure" calculation function of the [[startDate]] field. It should calculate the [[startDate]] as if
     * there's no user input for it and no previous value - "purely" based on the values of other fields.
     *
     * At this level it delegates to [[calculateProjectedXDateWithDuration]]
     *
     * See also [[calculateStartDateProposed]].
     */


    *calculateStartDatePure() {
      return yield* this.calculateProjectedXDateWithDuration(yield this.$.endDate, false, yield this.$.duration);
    }
    /**
     * The "proposed" calculation function of the [[startDate]] field. It should calculate the [[startDate]] as if
     * there's a user input for it or a previous value. It can also use the values of other fields to "validate"
     * the "proposed" value.
     *
     * See also [[calculateStartDatePure]]
     */


    *calculateStartDateProposed() {
      const startDate = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
      return yield* this.skipNonWorkingTime(startDate, true);
    }
    /**
     * This method calculates the opposite date of the event.
     *
     * @param baseDate The base date of the event (start or end date)
     * @param isForward Boolean flag, indicating whether the given `baseDate` is start date (`true`) or end date (`false`)
     * @param duration Duration of the event, in its [[durationUnit|durationUnits]]
     */


    *calculateProjectedXDateWithDuration(baseDate, isForward, duration) {
      const durationUnit = yield this.$.durationUnit;
      const calendar = yield this.$.effectiveCalendar;
      const project = this.getProject();
      if (!baseDate || Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_7__["isNotNumber"])(duration)) return null; // calculate forward by default

      isForward = isForward === undefined ? true : isForward;

      if (isForward) {
        return calendar.calculateEndDate(baseDate, yield* project.$convertDuration(duration, durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["TimeUnit"].Millisecond));
      } else {
        return calendar.calculateStartDate(baseDate, yield* project.$convertDuration(duration, durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["TimeUnit"].Millisecond));
      }
    } // copied generated method, to specify the default value for `keepDuration`
    // and to avoid compilation error when it is overridden in HasDateConstraintMixin

    /**
     * Sets the event [[endDate|end date]].
     *
     * @param date The new end date to set
     * @param keepDuration Whether the intention is to keep the `duration` field (`keepDuration = true`) or `startDate` (`keepDuration = false`)
     */


    setEndDate(date, keepDuration = false) {
      if (this.graph) {
        this.graph.write(this.$.endDate, date, keepDuration);
        return this.graph.commitAsync();
      } else {
        this.$.endDate.DATA = date;
      }
    }

    writeEndDate(me, transaction, quark, date, keepDuration = false) {
      if (!transaction.baseRevision.hasIdentifier(me) && date == null) return;
      me.constructor.prototype.write.call(this, me, transaction, quark, date, keepDuration); // TODO: review
      // const instruction : Instruction   = keepDuration ? Instruction.KeepDuration : Instruction.KeepStartDate
      // const dispatcher    = this.$.dispatcher as DispatcherIdentifier
    }
    /**
     * The main calculation method for the [[endDate]] field. Delegates to either [[calculateEndDateProposed]]
     * or [[calculateEndDatePure]], depending on the information from [[dispatcher]]
     */


    *calculateEndDate() {
      const dispatch = yield this.$.dispatcher;
      const formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["EndDateVar"]);

      if (formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
        return yield* this.calculateEndDateProposed();
      } else if (formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["endDateFormula"].formulaId) {
        return yield* this.calculateEndDatePure(); // the "new way" would be
        // return yield* this.calculateProjectedEndDateWithDuration(yield this.$.startDate, yield this.$.duration)
      } else {
        throw new Error("Unknown formula for `endDate`");
      }
    }
    /**
     * The "pure" calculation function of the [[endDate]] field. It should calculate the [[endDate]] as if
     * there's no user input for it and no previous value - "purely" based on the values of other fields.
     *
     * At this level it delegates to [[calculateProjectedXDateWithDuration]]
     *
     * See also [[calculateEndDateProposed]].
     */


    *calculateEndDatePure() {
      return yield* this.calculateProjectedXDateWithDuration(yield this.$.startDate, true, yield this.$.duration);
    }
    /**
     * The "proposed" calculation function of the [[endDate]] field. It should calculate the [[endDate]] as if
     * there's a user input for it or a previous value. It can also use the values of other fields to "validate"
     * the "proposed" value.
     *
     * See also [[calculateEndDatePure]]
     */


    *calculateEndDateProposed() {
      const endDate = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
      return yield* this.skipNonWorkingTime(endDate, false);
    } //endregion
    //region duration

    /**
     * Duration getter. Returns the duration of the event, in the given unit. If unit is not given, returns duration in [[durationUnit]].
     *
     * @param unit
     */


    getDuration(unit) {
      const duration = this.duration;
      return unit !== undefined ? this.getProject().convertDuration(duration, this.durationUnit, unit) : duration;
    }
    /**
     * Duration setter.
     *
     * @param duration The new duration to set.
     * @param unit The unit for new duration. Optional, if missing the [[durationUnit]] value will be used.
     * @param keepStart A boolean flag, indicating, whether the intention is to keep the start date (`true`) or end date (`false`)
     */


    setDuration(duration, unit, keepStart) {
      if (this.graph) {
        // Chronograph started to treat undefined as null, but we need to filter that case
        // https://github.com/bryntum/chronograph/issues/11
        if (duration !== undefined) {
          this.graph.write(this.$.duration, duration, unit, keepStart);
          return this.graph.commitAsync();
        }
      } else {
        const toSet = {
          duration
        };
        this.$.duration.DATA = duration;
        if (unit != null) toSet.durationUnit = this.$.durationUnit.DATA = unit; // Also has to make sure record data is updated in case this detached record is displayed elsewhere

        this.set(toSet);
      }
    }

    setDurationUnit(_value) {
      throw new Error("Use `setDuration` instead");
    }

    writeDuration(me, transaction, quark, duration, unit, keepStart = undefined) {
      if (duration < 0) duration = 0;
      if (!transaction.baseRevision.hasIdentifier(me) && duration == null) return;
      me.constructor.prototype.write.call(this, me, transaction, quark, duration, keepStart);
      if (unit != null) transaction.write(this.$.durationUnit, unit);
    }
    /**
     * The main calculation method for the [[duration]] field. Delegates to either [[calculateDurationProposed]]
     * or [[calculateDurationPure]], depending on the information from [[dispatcher]]
     */


    *calculateDuration() {
      const dispatch = yield this.$.dispatcher;
      const formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["DurationVar"]);

      if (formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
        return yield* this.calculateDurationProposed();
      } else if (formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["durationFormula"].formulaId) {
        return yield* this.calculateDurationPure(); // the "new way" would be
        // return yield* this.calculateProjectedDuration(yield this.$.startDate, yield this.$.endDate)
      } else {
        throw new Error("Unknown formula for `duration`");
      }
    }
    /**
     * The "pure" calculation function of the [[duration]] field. It should calculate the [[duration]] as if
     * there's no user input for it and no previous value - "purely" based on the values of other fields.
     *
     * If start date of event is less or equal then end date (normal case) it delegates to [[calculateProjectedDuration]].
     * Otherwise duration is set to 0.
     *
     * See also [[calculateDurationProposed]].
     */


    *calculateDurationPure() {
      const startDate = yield this.$.startDate;
      const endDate = yield this.$.endDate;
      if (!startDate || !endDate) return null;

      if (startDate > endDate) {
        yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Write"])(this.$.duration, 0, null);
      } else {
        return yield* this.calculateProjectedDuration(startDate, endDate);
      }
    }
    /**
     * The "proposed" calculation function of the [[duration]] field. It should calculate the [[duration]] as if
     * there's a user input for it or a previous value. It can also use the values of other fields to "validate"
     * the "proposed" value.
     *
     * See also [[calculateDurationPure]]
     */


    *calculateDurationProposed() {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }
    /**
     * This method calculates the duration of the given time span, in the provided `durationUnit` or in the [[durationUnit]].
     *
     * @param startDate
     * @param endDate
     * @param durationUnit
     */


    *calculateProjectedDuration(startDate, endDate, durationUnit) {
      if (!startDate || !endDate) return null;
      if (!durationUnit) durationUnit = yield this.$.durationUnit;
      const calendar = yield this.$.effectiveCalendar;
      const project = this.getProject();
      return yield* project.$convertDuration(calendar.calculateDurationMs(startDate, endDate), _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["TimeUnit"].Millisecond, durationUnit);
    } // effective duration is either a "normal" duration, or, if the duration itself is being calculated
    // (so that yielding it will cause a cycle)
    // an "estimated" duration, calculated based on proposed/previous start/end date values


    *calculateEffectiveDuration() {
      const dispatch = yield this.$.dispatcher;
      let effectiveDurationToUse;
      const durationResolution = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["DurationVar"]);

      if (durationResolution === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_2__["CalculateProposed"]) {
        effectiveDurationToUse = yield this.$.duration;
      } else if (durationResolution === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["durationFormula"].formulaId) {
        effectiveDurationToUse = yield* this.calculateProjectedDuration(yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.startDate), yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.endDate));
      }

      return effectiveDurationToUse;
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'date'
  }, {
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["dateConverter"]
  })], BaseEventMixin.prototype, "startDate", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'date'
  }, {
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["dateConverter"]
  })], BaseEventMixin.prototype, "endDate", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'number',
    allowNull: true
  })], BaseEventMixin.prototype, "duration", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["TimeUnit"].Day
  }, {
    converter: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].normalizeUnit
  })], BaseEventMixin.prototype, "durationUnit", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward
  }, {
    sync: true
  })], BaseEventMixin.prototype, "direction", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["field"])({
    identifierCls: _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_8__["SEDDispatcherIdentifier"]
  })], BaseEventMixin.prototype, "dispatcher", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_5__["model_field"])({
    type: 'boolean',
    defaultValue: false
  })], BaseEventMixin.prototype, "manuallyScheduled", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('dispatcher')], BaseEventMixin.prototype, "calculateDispatcher", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["build_proposed"])('dispatcher')], BaseEventMixin.prototype, "buildProposedDispatcher", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["write"])('startDate')], BaseEventMixin.prototype, "writeStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('startDate')], BaseEventMixin.prototype, "calculateStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["write"])('endDate')], BaseEventMixin.prototype, "writeEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('endDate')], BaseEventMixin.prototype, "calculateEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["write"])('duration')], BaseEventMixin.prototype, "writeDuration", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_3__["calculate"])('duration')], BaseEventMixin.prototype, "calculateDuration", null);

  return BaseEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js ***!
  \***************************************************************************/
/*! exports provided: BaseHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseHasAssignmentsMixin", function() { return BaseHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * This is a mixin, which can be applied to the [[BaseEventMixin]]. It provides the collection of all assignments,
 * which reference this event.
 *
 * Doesn't affect scheduling.
 */

class BaseHasAssignmentsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_3__["BaseEventMixin"], _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_4__["AbstractHasAssignmentsMixin"]], base => {
  const superProto = base.prototype;

  class BaseHasAssignmentsMixin extends base {
    get assignments() {
      return this.assigned ? [...this.assigned] : [];
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelBucketField"])], BaseHasAssignmentsMixin.prototype, "assigned", void 0);

  return BaseHasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js ***!
  \*********************************************************************/
/*! exports provided: BaseResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseResourceMixin", function() { return BaseResourceMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * This is a base resource entity.
 */

class BaseResourceMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_4__["HasCalendarMixin"], _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class BaseResourceMixin extends base {
    get assignments() {
      return [...this.assigned];
    }

    leaveProject(isReplacing = false) {
      // `this.assigned` will be empty if model is added to project and then removed immediately
      // w/o any propagations
      // when replacing a resource, the assignments should be left intact
      if (this.assigned && !isReplacing) {
        const resourceStore = this.getResourceStore(); // to batch the assignments removal, we don't remove the assignments right away, but instead
        // add them for the batched removal to the `assignmentsForRemoval` property of the event store

        this.assigned.forEach(assignment => resourceStore.assignmentsForRemoval.add(assignment));
      }

      superProto.leaveProject.call(this);
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelBucketField"])], BaseResourceMixin.prototype, "assigned", void 0);

  return BaseResourceMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js":
/*!******************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js ***!
  \******************************************************************************/
/*! exports provided: ChronoAbstractProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoAbstractProjectMixin", function() { return ChronoAbstractProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony import */ var _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");
var productName = 'gantt';




/**
 * This is an abstract project, which just lists the available stores.
 *
 * The actual project classes are [[SchedulerBasicProjectMixin]], [[SchedulerProProjectMixin]], [[GanttProjectMixin]].
 */

class ChronoAbstractProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["ChronoModelMixin"], _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractProjectMixin"]], base => {
  const superProto = base.prototype;

  class ChronoAbstractProjectMixin extends base {
    getGraph() {
      return this.replica;
    }

    beforeCommitAsync() {
      return null;
    }

    async commitAsync() {
      return this.replica.commitAsync();
    }

    async onSchedulingConflictCall(conflict, transaction) {
      // is there is a "schedulingConflict" event listener we expect resolution option will be picked there
      if (this.hasListener('schedulingConflict')) {
        return new Promise((resolve, reject) => {
          this.trigger('schedulingConflict', {
            continueWithResolutionResult: resolve,
            conflict
          });
        });
      } // by default we cancel the committed changes


      return _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_2__["ConflictResolutionResult"].Cancel;
    }

    setModelCalculations(model, calculations) {
      if (!calculations) return;
      const oldValues = {}; // backup current calculations

      for (const field in calculations) {
        oldValues[field] = model.prototype.$calculations[field];
      } // Patch model prototype settings


      Object.assign(model.prototype.$calculations, calculations);
      return oldValues;
    }

    setRecordCalculations(record, calculations) {
      const oldValues = this.setModelCalculations(record.constructor, calculations);
      const skeleton = record.$entity.$skeleton;
      Object.keys(calculations).forEach(field => {
        skeleton[field].prototype.calculation = record[calculations[field]];
      });
      return oldValues;
    }

    setStoreCalculations(store, calculations) {
      if (!calculations) return; // Rebuild corresponding identifiers

      const record = store.first;

      if (record) {
        return this.setRecordCalculations(record, calculations);
      } else {
        return this.setModelCalculations(store.modelClass, calculations);
      }
    }
    /**
     * Overrides the project owned store identifiers calculation.
     * @param calculations Object providing new identifier calculation function names.
     * The object is grouped by store identifiers. For example below code
     * overrides event `startDate`, `endDate` and `duration` calculation so
     * the fields will always simply return their current values:
     *
     * ```ts
     * // event startDate, endDate and duration will use their userProvidedValue method
     * // which simply returns their current values as-is
     * const oldCalculations = await project.setCalculations({
     *     events : {
     *         startDate : "userProvidedValue",
     *         endDate   : "userProvidedValue",
     *         duration  : "userProvidedValue"
     *     }
     * })
     * ```
     * @returns Promise that resolves with an object having the overridden calculations.
     * The object can be used to toggle the calculations back in the future:
     * ```ts
     * // override event duration calculation
     * const oldCalculations = await project.setCalculations({
     *     events : {
     *         duration  : "userProvidedValue"
     *     }
     * })
     * // revert the duration calculation back
     * project.setCalculations(oldCalculations)
     * ```
     */


    async setCalculations(calculations) {
      await this.commitAsync();
      const oldCalculations = {};
      const stores = {
        tasks: this.eventStore,
        events: this.eventStore,
        dependencies: this.dependencyStore,
        resources: this.resourceStore,
        assignments: this.assignmentStore,
        calendars: this.calendarManagerStore
      };
      Object.keys(stores).forEach(id => {
        // Apply calculation change to every owned store
        if (calculations[id]) {
          oldCalculations[id] = this.setStoreCalculations(stores[id], calculations[id]);
        }
      }); // Apply calculation changes to the project af provided

      let projectCalculations = calculations.project;

      if (projectCalculations) {
        oldCalculations.project = this.setRecordCalculations(this, projectCalculations);
      } // Repopulate replica w/ updated identifiers
      //@ts-ignore


      this.repopulateReplica.now();
      await this.commitAsync(); // return previous calculation settings

      return oldCalculations;
    }

  }

  return ChronoAbstractProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js ***!
  \********************************************************************/
/*! exports provided: HasCalendarMixin, CanCombineCalendarsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasCalendarMixin", function() { return HasCalendarMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CanCombineCalendarsMixin", function() { return CanCombineCalendarsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../calendar/CalendarCacheMultiple.js */ "./lib/Engine/calendar/CalendarCacheMultiple.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * This mixin provides the calendar to any [[ChronoPartOfProjectModelMixin]] it is mixed in.
 *
 * If user provides no calendar, the calendar is taken from the project.
 */

class HasCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_5__["ChronoPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class HasCalendarMixin extends base {
    writeCalendar(me, transaction, quark, calendar) {
      const calendarManagerStore = this.getCalendarManagerStore();
      const cal = calendar; // add calendar to the calendar manager - if the calendar is not there yet

      if (calendar && calendarManagerStore && calendar instanceof _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_6__["BaseCalendarMixin"] && !calendarManagerStore.includes(cal)) {
        calendarManagerStore.add(calendar);
      }

      me.constructor.prototype.write.call(this, me, transaction, quark, calendar);
    }

    resolveCalendar(locator) {
      var _a;

      return (_a = this.getCalendarManagerStore()) === null || _a === void 0 ? void 0 : _a.getById(locator);
    }
    /**
     * Calculation method of the [[effectiveCalendar]]. Takes the calendar from the project, if not provided to the entity explicitly.
     */


    *calculateEffectiveCalendar() {
      let calendar = yield this.$.calendar;

      if (!calendar) {
        const project = this.getProject();
        calendar = yield project.$.effectiveCalendar;
      } // this will create an incoming edge from the calendar's version atom, which changes on calendar's data update


      yield calendar.$.version;
      return calendar;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])({
    equality: () => false
  })], HasCalendarMixin.prototype, "effectiveCalendar", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({
    modelFieldConfig: {
      persist: true,
      serialize: calendar => calendar === null || calendar === void 0 ? void 0 : calendar.id,
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["isSerializableEqual"]
    },
    resolver: function (locator) {
      return this.resolveCalendar(locator);
    },
    sync: true
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["ModelReferenceField"])], HasCalendarMixin.prototype, "calendar", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["write"])('calendar')], HasCalendarMixin.prototype, "writeCalendar", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('effectiveCalendar')], HasCalendarMixin.prototype, "calculateEffectiveCalendar", null); // inject "fields" getter override to apply "modelFieldConfig" to "event" & "resource" fields


  Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["injectStaticFieldsProperty"])(HasCalendarMixin);
  return HasCalendarMixin;
}) {} // TODO handle the calendars deletion

/**
 * This mixin provides the consuming class with the [[combineCalendars]] method, which can combine several calendars.
 */

class CanCombineCalendarsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], base => {
  const superProto = base.prototype;

  class CanCombineCalendars extends base {
    constructor() {
      super(...arguments);
      this.combinedcalendarscache = new Map();
    }
    /**
     * Combines an array of calendars into a single [[CalendarCacheMultiple]], which provides an API similar (but not exactly the same) to [[BaseCalendarMixin]]
     *
     * @param calendars
     */


    combineCalendars(calendars) {
      const uniqueOnly = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_4__["stripDuplicates"])(calendars);
      if (uniqueOnly.length === 0) throw new Error("No calendars to combine");
      uniqueOnly.sort((calendar1, calendar2) => {
        if (calendar1.internalId < calendar2.internalId) return -1;else return 1;
      });
      const hash = uniqueOnly.map(calendar => calendar.internalId + '/').join('');
      const versionsHash = uniqueOnly.map(calendar => calendar.version + '/').join('');
      const cached = this.combinedcalendarscache.get(hash);
      let res;
      if (cached && cached.versionsHash === versionsHash) res = cached.cache;else {
        res = new _calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_2__["CalendarCacheMultiple"]({
          calendarCaches: uniqueOnly.map(calendar => calendar.calendarCache)
        });
        this.combinedcalendarscache.set(hash, {
          versionsHash: versionsHash,
          cache: res
        });
      }
      return res;
    }

  }

  return CanCombineCalendars;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js ***!
  \********************************************************************/
/*! exports provided: HasChildrenMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasChildrenMixin", function() { return HasChildrenMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Reference.js */ "./lib/ChronoGraph/replica/Reference.js");
/* harmony import */ var _ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/ReferenceBucket.js */ "./lib/ChronoGraph/replica/ReferenceBucket.js");
/* harmony import */ var _HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./HasSubEventsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Specialized version of the [[HasSubEventsMixin]]. The event becomes part of the tree structure.
 * It now has reference to the [[parentEvent]] and a collection of [[childEvents]].
 *
 * The abstract methods from the [[HasSubEventsMixin]] are defined to operate on the [[childEvents]] collection.
 */

class HasChildrenMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__["HasSubEventsMixin"]], base => {
  const superProto = base.prototype;

  class HasChildrenMixin extends base {
    *hasSubEvents() {
      const childEvents = yield this.$.childEvents;
      return childEvents.size > 0;
    }

    *subEventsIterable() {
      return yield this.$.childEvents;
    }

    get parent() {
      return this._parent;
    }

    set parent(value) {
      this._parent = value;
      this.parentEvent = value;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_1__["reference"])({
    bucket: 'childEvents'
  })], HasChildrenMixin.prototype, "parentEvent", void 0);

  __decorate([Object(_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_2__["bucket"])()], HasChildrenMixin.prototype, "childEvents", void 0);

  return HasChildrenMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js":
/*!************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js ***!
  \************************************************************************/
/*! exports provided: HasDependenciesMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasDependenciesMixin", function() { return HasDependenciesMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * This is a mixin, providing dependencies "awareness" for the event.
 *
 * Doesn't affect scheduling.
 */

class HasDependenciesMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_3__["BaseEventMixin"]], base => {
  const superProto = base.prototype;

  class HasDependenciesMixin extends base {
    leaveProject() {
      const eventStore = this.getEventStore(); // the buckets may be empty if a model is removed from the project immediately after adding
      // (without propagation)

      if (this.outgoingDeps) {
        this.outgoingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      if (this.incomingDeps) {
        this.incomingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      superProto.leaveProject.call(this);
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelBucketField"])], HasDependenciesMixin.prototype, "outgoingDeps", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["ModelBucketField"])], HasDependenciesMixin.prototype, "incomingDeps", void 0);

  return HasDependenciesMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js ***!
  \*********************************************************************/
/*! exports provided: HasSubEventsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasSubEventsMixin", function() { return HasSubEventsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
var productName = 'gantt';


 // this mixin can be better named `ScheduledBySubEvents`
// it can also be defined as "HasChildrenOnly" - ie has child events, but does not have parent (not part of the tree structure)
// then the `HasChildrenMixin` would be `HasParent`

/**
 * This mixin provides the notion of "sub events" for the [[BaseEventMixin]], which is a bit more general concept
 * of the "child" events. This special notion is required, because the event store can be a flat store, not providing
 * any tree structuring. In the same time, we treat the project instance as a "parent" event for all events in the flat
 * event store - so it accumulates the same aggregation information as other "regular" parent events.
 *
 * The event with this mixin is scheduled according to the "sub events" information - it starts at the earliest date
 * among all sub events and ends at the latest. If there's no "sub events" - it delegates to previous behaviour.
 *
 * Scheduling by children can be disabled by setting [[manuallyScheduled]] flag to `true` which will
 * result [[startDate]] and [[endDate]] fields will keep their provided values.
 */

class HasSubEventsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["BaseEventMixin"]], base => {
  const superProto = base.prototype;

  class HasSubEventsMixin extends base {
    /**
     * The abstract method which should indicate whether this event has sub events
     */
    *hasSubEvents() {
      throw new Error("Abstract method `hasSubEvents` has been called");
    }
    /**
     * The abstract method which should return an Iterable of [[BaseEventMixin]]
     */


    *subEventsIterable() {
      throw new Error("Abstract method `subEventsIterable` has been called");
    }

    *calculateStartDatePure() {
      const manuallyScheduled = yield this.$.manuallyScheduled;
      const hasSubEvents = yield* this.hasSubEvents();

      if (!manuallyScheduled && hasSubEvents) {
        return yield* this.calculateMinChildrenStartDate();
      } else {
        return yield* superProto.calculateStartDatePure.call(this);
      }
    }

    *calculateEndDatePure() {
      const manuallyScheduled = yield this.$.manuallyScheduled;
      const hasSubEvents = yield* this.hasSubEvents();

      if (!manuallyScheduled && hasSubEvents) {
        return yield* this.calculateMaxChildrenEndDate();
      } else {
        return yield* superProto.calculateEndDatePure.call(this);
      }
    }

    *calculateStartDateProposed() {
      const manuallyScheduled = yield this.$.manuallyScheduled;
      const hasSubEvents = yield* this.hasSubEvents();

      if (!manuallyScheduled && hasSubEvents) {
        return yield* this.calculateStartDatePure();
      } else {
        return yield* superProto.calculateStartDateProposed.call(this);
      }
    }

    *calculateEndDateProposed() {
      const manuallyScheduled = yield this.$.manuallyScheduled;
      const hasSubEvents = yield* this.hasSubEvents();

      if (!manuallyScheduled && hasSubEvents) {
        return yield* this.calculateEndDatePure();
      } else {
        return yield* superProto.calculateEndDateProposed.call(this);
      }
    }

    *calculateDurationProposed() {
      const manuallyScheduled = yield this.$.manuallyScheduled;
      const hasSubEvents = yield* this.hasSubEvents();

      if (!manuallyScheduled && hasSubEvents) {
        return yield* this.calculateDurationPure();
      } else {
        return yield* superProto.calculateDurationProposed.call(this);
      }
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[startDate]].
     * Child events roll up their [[startDate]] values to their summary tasks.
     * So a summary task [[startDate|start]] date gets equal to
     * its minimal child [[startDate|start]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildStartDate(child) {
      return true;
    }

    *calculateMinChildrenStartDate() {
      const children = yield* this.subEventsIterable();
      let timestamp = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"].getTime();

      for (const child of children) {
        if (yield* this.shouldRollupChildStartDate(child)) {
          let date = yield child.$.startDate; // if the child has endDate only - use that value

          if (!date) {
            date = yield child.$.endDate;
          }

          if (date && date.getTime() < timestamp) {
            timestamp = date.getTime();
          }
        }
      }

      if (timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"].getTime() || timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"].getTime()) return null;
      return new Date(timestamp);
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[endDate]].
     * Child events roll up their [[endDate]] values to their summary tasks.
     * So a summary task [[endDate|end]] gets equal to its maximal child [[endDate|end]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildEndDate(child) {
      return true;
    }

    *calculateMaxChildrenEndDate() {
      const children = yield* this.subEventsIterable();
      let timestamp = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"].getTime();

      for (const child of children) {
        if (yield* this.shouldRollupChildEndDate(child)) {
          let date = yield child.$.endDate;

          if (!date) {
            date = yield child.$.startDate;
          }

          if (date && date.getTime() > timestamp) {
            timestamp = date.getTime();
          }
        }
      }

      if (timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"].getTime() || timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"].getTime()) return null;
      return new Date(timestamp);
    }

  }

  return HasSubEventsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js ***!
  \***********************************************************************/
/*! exports provided: SchedulerBasicEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerBasicEvent", function() { return SchedulerBasicEvent; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BaseHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js");
/* harmony import */ var _HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./HasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js");
var productName = 'gantt';




/**
 * This is an event class, [[SchedulerBasicProjectMixin]] is working with.
 * It is constructed as [[BaseEventMixin]], enhanced with [[BaseHasAssignmentsMixin]] and [[HasDependenciesMixin]]
 */

class SchedulerBasicEvent extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["BaseEventMixin"], _BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__["BaseHasAssignmentsMixin"], _HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__["HasDependenciesMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerBasicEvent extends base {}

  return SchedulerBasicEvent;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js":
/*!******************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js ***!
  \******************************************************************************/
/*! exports provided: SchedulerBasicProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerBasicProjectMixin", function() { return SchedulerBasicProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/schema/Schema.js */ "./lib/ChronoGraph/schema/Schema.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _chrono_Replica_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../chrono/Replica.js */ "./lib/Engine/chrono/Replica.js");
/* harmony import */ var _scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../scheduling/DurationConverterMixin.js */ "./lib/Engine/scheduling/DurationConverterMixin.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../store/ChronoAssignmentStoreMixin.js */ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js");
/* harmony import */ var _store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../store/ChronoCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js");
/* harmony import */ var _store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../store/ChronoDependencyStoreMixin.js */ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js");
/* harmony import */ var _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../store/ChronoResourceStoreMixin.js */ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js");
/* harmony import */ var _ChronoAbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./ChronoAbstractProjectMixin.js */ "./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js");
/* harmony import */ var _BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
/* harmony import */ var _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./BaseDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");
/* harmony import */ var _HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./HasSubEventsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js");
/* harmony import */ var _SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



























/**
 * Basic Scheduler project mixin type. At this level, events have assignments and dependencies, which both are, however,
 * only visual and do not affect the scheduling.
 */

class SchedulerBasicProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"])([_ChronoAbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__["ChronoAbstractProjectMixin"], _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_19__["BaseEventMixin"], _HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_22__["HasSubEventsMixin"], _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_21__["HasCalendarMixin"], _scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_8__["DurationConverterMixin"], _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_21__["CanCombineCalendarsMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerBasicProjectMixin extends base {
    construct(config = {}) {
      this.enableProgressNotifications = config.enableProgressNotifications; // Expand project by default to make getRange to work

      if (!('expanded' in config)) {
        // @ts-ignore
        config.expanded = true;
      }

      superProto.construct.call(this, config);
      this.repopulateStores = new Set();
      this.ignoreInitialCommitComputationCycles = 'ignoreInitialCommitComputationCycles' in config ? config.ignoreInitialCommitComputationCycles : true;
      if (!this.eventModelClass) this.eventModelClass = this.getDefaultEventModelClass();
      if (!this.eventStoreClass) this.eventStoreClass = this.getDefaultEventStoreClass();
      if (!this.dependencyModelClass) this.dependencyModelClass = this.getDefaultDependencyModelClass();
      if (!this.dependencyStoreClass) this.dependencyStoreClass = this.getDefaultDependencyStoreClass();
      if (!this.resourceModelClass) this.resourceModelClass = this.getDefaultResourceModelClass();
      if (!this.resourceStoreClass) this.resourceStoreClass = this.getDefaultResourceStoreClass();
      if (!this.assignmentModelClass) this.assignmentModelClass = this.getDefaultAssignmentModelClass();
      if (!this.assignmentStoreClass) this.assignmentStoreClass = this.getDefaultAssignmentStoreClass();
      if (!this.calendarModelClass) this.calendarModelClass = this.getDefaultCalendarModelClass();
      if (!this.calendarManagerStoreClass) this.calendarManagerStoreClass = this.getDefaultCalendarManagerStoreClass();
      this.replica = this.createReplica();
      this.replica.addEntity(this); // not part of the CalendarManagerStore intentionally, not persisted

      this.defaultCalendar = new this.calendarModelClass({
        unspecifiedTimeIsWorking: this.unspecifiedTimeIsWorking
      });
      this.defaultCalendar.project = this;
      this.replica.addEntity(this.defaultCalendar);
      const stm = this.stm = new _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_4__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
        disabled: true
      }, this.stm));

      if (this.resetUndoRedoQueuesAfterLoad) {
        this.on({
          load: this.resetStmQueue,
          thisObj: this
        });
      }

      this.stm.on({
        // Propagate on undo/redo
        restoringStop: async () => {
          // Disable STM meanwhile to not pick it up as a new STM transaction
          this.stm.disable();
          await this.commitAsync();

          if (!this.isDestroyed) {
            this.stm.enable();
            this.trigger('stateRestoringDone');
          }
        }
      });
      let reEnableAutoRecord;
      this.on({
        // https://github.com/bryntum/support/issues/1270
        beforeCommit() {
          if (stm.isRecording && stm.autoRecord) {
            reEnableAutoRecord = true; // If auto recording is enabled when we are entering a commit, we need to move autoRecording
            // state to Recording in order to make sure all changes from the project will become a single
            // transaction

            stm.autoRecord = false;
          }
        },

        dataReady() {
          if (reEnableAutoRecord) {
            // This will restore autoRecording state and trigger timer to stop transaction after a delay
            stm.autoRecord = true;
            reEnableAutoRecord = false;
          }
        }

      });
      this.setCalendarManagerStore(this.calendarManagerStore);
      this.setEventStore(this.eventStore);
      this.setDependencyStore(this.dependencyStore);
      this.setResourceStore(this.resourceStore);
      this.setAssignmentStore(this.assignmentStore);
      const hasInlineData = Boolean(this.calendarsData || this.eventsData || this.dependenciesData || this.resourcesData || this.assignmentsData);

      if (hasInlineData) {
        this.loadInlineData({
          calendarsData: this.calendarsData,
          eventsData: this.eventsData,
          dependenciesData: this.dependenciesData,
          resourcesData: this.resourcesData,
          assignmentsData: this.assignmentsData
        });
        delete this.calendarsData;
        delete this.eventsData;
        delete this.dependenciesData;
        delete this.resourcesData;
        delete this.assignmentsData;
      }
    }

    resetStmQueue() {
      const wasDisabled = this.stm.disabled;
      this.stm.disable();
      this.stm.resetQueue();

      if (!wasDisabled) {
        this.stm.enable();
      }
    }

    doDestroy() {
      var _a, _b, _c, _d, _e, _f;

      const me = this;
      (_a = me.eventStore) === null || _a === void 0 ? void 0 : _a.destroy();
      (_b = me.dependencyStore) === null || _b === void 0 ? void 0 : _b.destroy();
      (_c = me.assignmentStore) === null || _c === void 0 ? void 0 : _c.destroy();
      (_d = me.resourceStore) === null || _d === void 0 ? void 0 : _d.destroy();
      (_e = me.calendarManagerStore) === null || _e === void 0 ? void 0 : _e.destroy();
      me.defaultCalendar.destroy();
      me.replica.clear();
      (_f = me.stm) === null || _f === void 0 ? void 0 : _f.destroy();
      superProto.doDestroy.call(this);
    } // Creates a new Replica, used during construction and when repopulating


    createReplica() {
      return _chrono_Replica_js__WEBPACK_IMPORTED_MODULE_7__["EngineReplica"].mix(_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_1__["Replica"]).new({
        project: this,
        schema: _ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_2__["Schema"].new(),
        enableProgressNotifications: this.enableProgressNotifications,
        silenceInitialCommit: this.silenceInitialCommit,
        ignoreInitialCommitComputationCycles: this.ignoreInitialCommitComputationCycles,
        onWriteDuringCommit: 'ignore',
        readMode: _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_1__["ReadMode"].CurrentOrProposedOrPrevious
      });
    }

    *hasSubEvents() {
      return this.getEventStore().count > 0;
    }

    *subEventsIterable() {
      return this.getEventStore().getRange();
    }

    getType() {
      return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_9__["ProjectType"].SchedulerBasic;
    }

    get enableProgressNotifications() {
      return this._enableProgressNotifications;
    }
    /**
     * Enables/disables the calculation progress notifications.
     */


    set enableProgressNotifications(value) {
      this._enableProgressNotifications = value;
      if (this.replica) this.replica.enableProgressNotifications = value;
    }
    /**
     * Returns the default event model class to use
     */


    getDefaultEventModelClass() {
      return _SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_23__["SchedulerBasicEvent"];
    }
    /**
     * Returns the default event store class to use
     */


    getDefaultEventStoreClass() {
      return _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["ChronoEventStoreMixin"];
    }
    /**
     * Returns the default dependency model class to use
     */


    getDefaultDependencyModelClass() {
      return _BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_18__["BaseDependencyMixin"];
    }
    /**
     * Returns the default dependency store class to use
     */


    getDefaultDependencyStoreClass() {
      return _store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["ChronoDependencyStoreMixin"];
    }
    /**
     * Returns the default resource model class to use
     */


    getDefaultResourceModelClass() {
      return _BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_20__["BaseResourceMixin"];
    }
    /**
     * Returns the default resource store class to use
     */


    getDefaultResourceStoreClass() {
      return _store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_14__["ChronoResourceStoreMixin"];
    }
    /**
     * Returns the default assignment model class to use
     */


    getDefaultAssignmentModelClass() {
      return _BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_16__["BaseAssignmentMixin"];
    }
    /**
     * Returns the default assignment store class to use
     */


    getDefaultAssignmentStoreClass() {
      return _store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoAssignmentStoreMixin"];
    }
    /**
     * Returns the default calendar model class to use
     */


    getDefaultCalendarModelClass() {
      return _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_17__["BaseCalendarMixin"];
    }
    /**
     * Returns the default calendar manager store class to use
     */


    getDefaultCalendarManagerStoreClass() {
      return _store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["ChronoCalendarManagerStoreMixin"];
    }
    /**
     * This method loads the "raw" data into the project. The loading is basically happening by
     * assigning the individual data entries to the `data` property of the corresponding store.
     *
     * @param data
     */


    async loadInlineData(data) {
      const {
        calendarManagerStore,
        eventStore,
        dependencyStore,
        assignmentStore,
        resourceStore
      } = this; // Prevent initial commit from happening before inline data is loaded

      this.replica.unScheduleAutoCommit();

      if (this.replica.enableProgressNotifications) {
        // First delay needed to allow assignment of Project -> Gantt to happen before carrying on,
        // to make sure progress listener is in place
        await Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["delay"])(0); // wait till the current propagation completes (if any)
        // otherwise the mask shown due to the next line call will be
        // destroyed as the propagation gets done

        await this.commitAsync();
        this.replica.onPropagationProgressNotification({
          total: 0,
          remaining: 0,
          phase: 'storePopulation'
        }); // Second delay needed to allow mask to appear, not clear why delay(0) is not enough, it works in other
        // places

        await Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["delay"])(50);
      }

      this.isLoadingInlineData = true;

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].global.DEBUG) {
        console.log(`%cInitializing project`, 'font-weight:bold;color:darkgreen;text-transform:uppercase;margin-top: 2em');
        console.time('Time to visible');
        console.time('Populating project');
      }

      if (data.calendarsData) {
        this.repopulateStore(calendarManagerStore);
        calendarManagerStore.data = data.calendarsData;
      }

      if (data.eventsData || data.tasksData) {
        this.repopulateStore(eventStore);
        eventStore.data = data.eventsData || data.tasksData;
      }

      if (data.dependenciesData) {
        this.repopulateStore(dependencyStore);
        dependencyStore.data = data.dependenciesData;
      }

      if (data.resourcesData) {
        this.repopulateStore(resourceStore);
        resourceStore.data = data.resourcesData;
      }

      if (data.assignmentsData) {
        this.repopulateStore(assignmentStore);
        assignmentStore.data = data.assignmentsData;
      }

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].global.DEBUG) console.timeEnd('Populating project');
      const result = await this.commitLoad();
      this.isLoadingInlineData = false;
      return result;
    }

    async commitLoad() {
      // if (BrowserHelper.global.DEBUG) console.time('Initial propagation')
      const result = await this.commitAsync(); // Might have been destroyed during the async operation above

      if (!this.isDestroyed) this.trigger('load');
      return result;
    } //region Repopulate


    get isRepopulatingStores() {
      var _a;

      return Boolean((_a = this.repopulateStores) === null || _a === void 0 ? void 0 : _a.size);
    } // Remember which stores are being repopulated, they dont have to care about unjoining graph later


    repopulateStore(store) {
      if (this.repopulateOnDataset && store.count) {
        if (!this.repopulateStores) this.repopulateStores = new Set();
        this.repopulateStores.add(store); // Trigger buffered repopulate of replica

        this.repopulateReplica();
      }
    } // Creates a new replica, populating it with data from the stores


    repopulateReplica() {
      const {
        calendarManagerStore,
        eventStore,
        dependencyStore,
        assignmentStore,
        resourceStore,
        replica: oldReplica
      } = this; // Unlink all old records that are going to be re-entered into new replica

      this.unlinkStoreRecords(calendarManagerStore, eventStore, dependencyStore, resourceStore, assignmentStore);
      this.unlinkRecord(this);
      this.unlinkRecord(this.defaultCalendar);
      oldReplica.clear();
      const replica = this.replica = this.createReplica(); // Now enter all new and old reused records into the new replica

      replica.addEntity(this);
      replica.addEntity(this.defaultCalendar);
      this.joinStoreRecords(calendarManagerStore, true);
      this.joinStoreRecords(eventStore, true);
      this.joinStoreRecords(dependencyStore, true);
      this.joinStoreRecords(resourceStore, true);
      this.joinStoreRecords(assignmentStore, true);
      this.repopulateStores.clear();
      this.trigger('repopulateReplica');
    } // If there is a commit when we are supposed to replace the replica, we hijack that and commit the new replica


    beforeCommitAsync() {
      //@ts-ignore
      if (this.repopulateReplica.isPending) {
        //@ts-ignore
        this.repopulateReplica.now();
        return this.replica.commitAsync();
      }

      return null;
    } // Unlinks a single record from the graph, writing back identifiers values from the graph to DATA to allow them
    // to enter another replica


    unlinkRecord(record) {
      var _a;

      const {
        activeTransaction
      } = this.replica;
      const {
        $
      } = record;
      const keys = Object.keys($); // Write current values to identifier.DATA, to have correct value entering new replica later

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const identifier = $[key]; // Relations: assignment.event, replace event instance with event id

        if (identifier.field instanceof _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_6__["ModelReferenceField"]) {
          const value = record[key]; // id for records, value for atomics, undefined otherwise

          identifier.DATA = (_a = value === null || value === void 0 ? void 0 : value.id) !== null && _a !== void 0 ? _a : value;
        } // Everything else, use latest value
        else {
          const entry = activeTransaction.getLatestStableEntryFor(identifier);
          if (entry) identifier.DATA = entry.getValue();
        }
      } // Cut the link, to enable joining another replica


      record.graph = null;
    } // Unlinks all records from a store, unless the store has been repopulated


    unlinkStoreRecords(...stores) {
      // Must pass includeFilteredOutRecords and includeCollapsedGroupRecords as true
      // so that we work on full, unfiltered dataset
      stores.forEach(store => store.traverse(record => {
        // Unlink records only in stores that are not repopulated
        // or if store has syncDataOnLoad (in this case records stay in the store so need to unlink them)
        if (!this.repopulateStores.has(store) || store.syncDataOnLoad) {
          this.unlinkRecord(record);
        }
      }, false, false, {
        includeFilteredOutRecords: true,
        includeCollapsedGroupRecords: true
      }));
    } //endregion


    getGraph() {
      return this.replica;
    } // keep this private


    async addEvents(events) {
      this.eventStore.add(events);
      return this.graph.commitAsync();
    } // keep this private


    async addEvent(event) {
      this.eventStore.add(event);
      return this.graph.commitAsync();
    } // keep this private


    includeEvent(event) {
      this.eventStore.add(event);
    } // keep this private


    async removeEvents(events) {
      this.eventStore.remove(events);
      return this.graph.commitAsync();
    } // keep this private


    excludeEvent(event) {
      this.eventStore.remove(event);
    } // keep this private


    async removeEvent(event) {
      this.eventStore.remove(event);
      return this.graph.commitAsync();
    }

    getStm() {
      return this.stm;
    }

    calculateProject() {
      return this;
    }

    *calculateEffectiveCalendar() {
      let calendar = yield this.$.calendar;

      if (calendar) {
        // this will create an incoming edge from the calendar's version atom, which changes on calendar's data update
        yield calendar.$.version;
      } else {
        calendar = this.defaultCalendar;
      }

      return calendar;
    }

    joinStoreRecords(store, skipRoot = false) {
      const fn = record => {
        record.setProject(this);
        record.joinProject();
      }; // Both iteration methods must pass includeFilteredOutRecords as true
      // so that we work on full, unfiltered dataset


      if (store.rootNode) {
        store.rootNode.traverse(fn, skipRoot, true);
      } else {
        store.forEach(fn, null, {
          includeFilteredOutRecords: true,
          includeCollapsedGroupRecords: true
        });
      }
    }

    unjoinStoreRecords(store) {
      const fn = record => {
        record.leaveProject();
        record.setProject(this);
      }; // Both iteration methods must pass includeFilteredOutRecords as true
      // so that we work on full, unfiltered dataset


      if (store.rootNode) {
        store.rootNode.traverse(node => {
          // do not unjoin/leave project for the root node, which is the project itself
          if (node !== store.rootNode) fn(node);
        }, false, true);
      } else {
        store.forEach(fn, null, {
          includeFilteredOutRecords: true,
          includeCollapsedGroupRecords: true
        });
      }
    }
    /**
     * This method sets the event store instance for the project.
     * @param store
     */


    setEventStore(store) {
      const oldEventStore = this.eventStore;

      if (oldEventStore && this.stm.hasStore(oldEventStore)) {
        this.stm.removeStore(oldEventStore);
        this.unjoinStoreRecords(oldEventStore);
        this.detachStore(oldEventStore);
        const assignmentsForRemoval = oldEventStore.assignmentsForRemoval; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldEvent = assignment.event;

          if (oldEvent) {
            const newEvent = store.getById(oldEvent.id);

            if (newEvent) {
              assignment.event = newEvent; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldEventStore.afterEventRemoval();
      }

      if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
        const storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.eventStoreClass;
        this.eventStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
          modelClass: this.eventModelClass,
          project: this,
          stm: this.stm
        }, store || {}));
      } else {
        this.eventStore = store;
        store.setProject(this);
        this.stm.addStore(store); // we've been given an event store from the outside
        // need to change its root node to be the project

        if (store.tree && store.rootNode !== this) {
          this.appendChild(store.rootNode.children || []); // Assigning a new root will make all children join store

          store.rootNode = this;
        } // TODO: Not sure about this, was always performed previously
        else {
          this.joinStoreRecords(store);
        }
      }

      this.attachStore(this.eventStore);
      this.trigger('eventStoreChange', {
        store: this.eventStore
      });
    }
    /**
     * This method sets the dependency store instance for the project.
     * @param store
     */


    setDependencyStore(store) {
      const oldDependencyStore = this.dependencyStore;

      if (oldDependencyStore && this.stm.hasStore(oldDependencyStore)) {
        this.stm.removeStore(oldDependencyStore);
        this.detachStore(oldDependencyStore);
      }

      if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
        const storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.dependencyStoreClass;
        this.dependencyStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
          modelClass: this.dependencyModelClass,
          project: this,
          stm: this.stm
        }, store || {}));
      } else {
        this.dependencyStore = store;
        store.setProject(this);
        this.stm.addStore(store);
        this.joinStoreRecords(store);
      }

      this.attachStore(this.dependencyStore);
      this.trigger('dependencyStoreChange', {
        store: this.dependencyStore
      });
    }
    /**
     * This method sets the resource store instance for the project.
     * @param store
     */


    setResourceStore(store) {
      const oldResourceStore = this.resourceStore;

      if (oldResourceStore && this.stm.hasStore(oldResourceStore)) {
        this.stm.removeStore(oldResourceStore);
        this.unjoinStoreRecords(oldResourceStore);
        this.detachStore(oldResourceStore);
        const assignmentsForRemoval = oldResourceStore.assignmentsForRemoval; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldResource = assignment.resource;

          if (oldResource) {
            const newResource = store.getById(oldResource.id);

            if (newResource) {
              assignment.resource = newResource; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldResourceStore.afterResourceRemoval();
      }

      if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
        const storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.resourceStoreClass;
        this.resourceStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
          modelClass: this.resourceModelClass,
          project: this,
          stm: this.stm
        }, store || {}));
      } else {
        this.resourceStore = store;
        store.setProject(this);
        this.stm.addStore(store);
        this.joinStoreRecords(store);
      }

      this.attachStore(this.resourceStore);
      this.trigger('resourceStoreChange', {
        store: this.resourceStore
      });
    }
    /**
     * This method sets the assignment store instance for the project.
     * @param store
     */


    setAssignmentStore(store) {
      const oldAssignmentStore = this.assignmentStore;

      if (oldAssignmentStore && this.stm.hasStore(oldAssignmentStore)) {
        this.stm.removeStore(oldAssignmentStore);
        this.unjoinStoreRecords(oldAssignmentStore);
        this.detachStore(oldAssignmentStore);
      }

      if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
        const storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.assignmentStoreClass;
        this.assignmentStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
          modelClass: this.assignmentModelClass,
          project: this,
          stm: this.stm
        }, store || {}));
      } else {
        this.assignmentStore = store;
        store.setProject(this);
        this.stm.addStore(store);
        this.joinStoreRecords(store);
      }

      this.attachStore(this.assignmentStore);
      this.trigger('assignmentStoreChange', {
        store: this.assignmentStore
      });
    }
    /**
     * This method sets the calendar manager store instance for the project.
     * @param store
     */


    setCalendarManagerStore(store) {
      const oldCalendarManagerStore = this.calendarManagerStore;

      if (oldCalendarManagerStore && this.stm.hasStore(oldCalendarManagerStore)) {
        this.stm.removeStore(oldCalendarManagerStore);
        this.detachStore(oldCalendarManagerStore);
      }

      if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
        const storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.calendarManagerStoreClass;
        this.calendarManagerStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
          modelClass: this.calendarModelClass,
          project: this,
          stm: this.stm
        }, store || {}));
      } else {
        this.calendarManagerStore = store;

        if (store) {
          store.setProject(this);
          this.stm.addStore(store);
          this.joinStoreRecords(store);
        }
      }

      this.attachStore(this.calendarManagerStore);
      this.trigger('calendarManagerStoreChange', {
        store: this.calendarManagerStore
      });
    } // this does not account for possible scheduling conflicts


    async isValidDependency(...args) {
      return true;
    }

    async tryPropagateWithChanges(changerFn) {
      const stm = this.stm;
      let stmInitiallyDisabled, stmInitiallyAutoRecord;

      const captureStm = () => {
        stmInitiallyDisabled = stm.disabled;
        stmInitiallyAutoRecord = stm.autoRecord;

        if (stmInitiallyDisabled) {
          stm.enable();
        } else {
          if (stmInitiallyAutoRecord) {
            stm.autoRecord = false;
          }

          if (stm.isRecording) {
            stm.stopTransaction();
          }
        }
      };

      const commitStmTransaction = () => {
        stm.stopTransaction();

        if (stmInitiallyDisabled) {
          stm.resetQueue();
        }
      };

      const rejectStmTransaction = () => {
        if (stm.transaction.length) {
          stm.forEachStore(s => s.beginBatch());
          stm.rejectTransaction();
          stm.forEachStore(s => s.endBatch());
        } else {
          stm.stopTransaction();
        }
      };

      const freeStm = () => {
        stm.disabled = stmInitiallyDisabled;
        stm.autoRecord = stmInitiallyAutoRecord;
      };

      captureStm();
      stm.startTransaction(); // In case anything in, or called by the changerFn attempts to propagate.
      // We must only propagate after the changes have been made.
      // this.suspendPropagate()

      changerFn(); // Resume propagation, but do *not* propagate if any propagate calls were attempted during suspension.
      // this.resumePropagate(false)

      let result = true;

      try {
        const commitResult = await this.commitAsync(); // setting "result" to false if the propagation was rejected

        result = !commitResult.rejectedWith;
      } catch (e) {
        // rethrow non-cycle exception
        if (!/cycle/i.test(e)) throw e;
        result = false;
      }

      if (result) {
        commitStmTransaction();
      } else {
        this.replica.reject();
        rejectStmTransaction();
      }

      freeStm();
      return result;
    }

    isEngineReady() {
      const {
        replica
      } = this;
      return !this.isRepopulatingStores && !(replica.dirty && (replica.hasPendingAutoCommit() || replica.isCommitting));
    } // Needed to separate configs from data, for tests to pass. Normally handled in ProjectModel outside of engine


    static get defaultConfig() {
      return {
        assignmentsData: null,
        calendarsData: null,
        dependenciesData: null,
        eventsData: null,
        resourcesData: null,
        // need to distinguish the stores from fields
        // https://bryntum.com/examples/gantt/advanced/index.umd.html
        // bryntum.gantt.ObjectHelper.isEqual({}, new bryntum.gantt.Store()) // true
        eventStore: null,
        resourceStore: null,
        assignmentStore: null,
        dependencyStore: null,
        calendarManagerStore: null,
        eventModelClass: null,
        resourceModelClass: null,
        assignmentModelClass: null,
        dependencyModelClass: null,
        calendarModelClass: null,
        repopulateOnDataset: true
      };
    }

    static get delayable() {
      return {
        repopulateReplica: 10
      };
    }

  }

  SchedulerBasicProjectMixin.applyConfigs = true;

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_6__["model_field"])({
    type: 'boolean',
    defaultValue: true
  })], SchedulerBasicProjectMixin.prototype, "unspecifiedTimeIsWorking", void 0);

  return SchedulerBasicProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentMixin", function() { return CoreAssignmentMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
var productName = 'gantt';




/**
 * Core assignment model class. It just contains references to the [[CoreEventMixin|event]] and [[CoreResourceMixin|resource]] being assigned.
 */

class CoreAssignmentMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreAssignmentMixin extends base {
    // Fields declared in the Model way, existing decorators all assume ChronoGraph is used
    static get fields() {
      return [// isEqual required to properly detect changed resource / event
      {
        name: 'resource',
        isEqual: (a, b) => a === b,
        persist: false
      }, {
        name: 'event',
        isEqual: (a, b) => a === b,
        persist: false
      }];
    } // Resolve early + update indices to have buckets ready before commit


    setChanged(field, value, invalidate) {
      const {
        assignmentStore,
        eventStore,
        resourceStore,
        project
      } = this;
      let update = false;

      if (field === 'event') {
        const event = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? value : eventStore === null || eventStore === void 0 ? void 0 : eventStore.getById(value);
        if (event) update = true;
        value = event || value;
      }

      if (field === 'resource') {
        const resource = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(value, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"]) ? value : resourceStore === null || resourceStore === void 0 ? void 0 : resourceStore.getById(value);
        if (resource) update = true;
        value = resource || value;
      } // Passing true as last arg, bucket expected to work before commit


      superProto.setChanged.call(this, field, value, invalidate, true); // Update on resolve, if this is a single operation and record is part of project (might be standalone record)

      if (assignmentStore && update && !project.isPerformingCommit && !assignmentStore.isLoadingData && !resourceStore.isLoadingData && !assignmentStore.skipInvalidateIndices) {
        assignmentStore.invalidateIndices();
      }
    } // Resolve event and resource when joining project


    joinProject() {
      superProto.joinProject.call(this);
      this.setChanged('event', this.get('event'));
      this.setChanged('resource', this.get('resource'));
    } // Resolved resource & event as part of commit
    // Normally done earlier in setChanged, but stores might not have been available yet at that point


    calculateInvalidated() {
      var _a, _b; // Changed values, should be used instead of current where available


      let {
        event = this.event,
        resource = this.resource
      } = this.$changed;

      if (event !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(event);
        if (resolved) this.setChanged('event', resolved, false);
      }

      if (resource !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"])) {
        const resolved = (_b = this.resourceStore) === null || _b === void 0 ? void 0 : _b.getById(resource);
        if (resolved) this.setChanged('resource', resolved, false);
      }
    } // resourceId and eventId required to be available for new datasets


    finalizeInvalidated(silent) {
      var _a, _b;

      if ((_a = this.$changed.resource) === null || _a === void 0 ? void 0 : _a.isModel) this.$changed.resourceId = this.$changed.resource.id;
      if ((_b = this.$changed.event) === null || _b === void 0 ? void 0 : _b.isModel) this.$changed.eventId = this.$changed.event.id;
      superProto.finalizeInvalidated.call(this, silent);
    } //region Event


    set event(event) {
      this.setChanged('event', event);
    }

    get event() {
      const event = this.get('event'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? event : null;
    } //endregion
    //region Resource


    set resource(resource) {
      this.setChanged('resource', resource);
    }

    get resource() {
      const resource = this.get('resource'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"]) ? resource : null;
    }

  }

  return CoreAssignmentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarMixin", function() { return CoreCalendarMixin; });
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");
var productName = 'gantt';



/**
 * The calendar for project scheduling, it is used to mark certain time intervals as "non-working" and ignore them during scheduling.
 *
 * The calendar consists from several [[CalendarIntervalMixin|intervals]]. The intervals can be either static or recurrent.
 */

class CoreCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractCalendarMixin"], _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreCalendarMixin extends base {}

  return CoreCalendarMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyMixin", function() { return CoreDependencyMixin; });
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
var productName = 'gantt';




class CoreDependencyMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreDependencyMixin extends base {
    static get fields() {
      return [{
        name: 'fromEvent',
        isEqual: (a, b) => a === b,
        persist: false
      }, {
        name: 'toEvent',
        isEqual: (a, b) => a === b,
        persist: false
      }];
    } // Resolve early + update indices to have buckets ready before commit


    setChanged(field, value, invalidate) {
      var _a, _b, _c;

      let update = false;

      if (field === 'fromEvent' || field === 'toEvent') {
        const event = Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? value : (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(value);
        if (event) update = true;
        value = event || value;
      }

      superProto.setChanged.call(this, field, value, invalidate, true);

      if (update && !this.project.isPerformingCommit && !((_b = this.dependencyStore) === null || _b === void 0 ? void 0 : _b.isLoadingData)) {
        // TODO: Improve Collection indexing to handle smaller updates
        (_c = this.dependencyStore) === null || _c === void 0 ? void 0 : _c.invalidateIndices();
      }
    } // Resolve events when joining project


    joinProject() {
      superProto.joinProject.call(this); // Initial values should be considered changed, to be normalized
      // (needs to pass through setChanged for early normalization expected for buckets)

      this.setChanged('fromEvent', this.get('fromEvent'));
      this.setChanged('toEvent', this.get('toEvent'));
    } // Resolved events as part of commit
    // Normally done earlier in setChanged, but stores might not have been available yet at that point


    calculateInvalidated() {
      var _a, _b; // Changed values, should be used instead of current where available


      let {
        fromEvent,
        toEvent
      } = this.$changed;

      if (fromEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(fromEvent);
        if (resolved) this.$changed.fromEvent = resolved;
      }

      if (toEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_b = this.eventStore) === null || _b === void 0 ? void 0 : _b.getById(toEvent);
        if (resolved) this.$changed.toEvent = resolved;
      }
    } //region Events
    // Not using "propose" mechanism from CoreEventMixin, because buckets are expected to be up to date right away


    set fromEvent(fromEvent) {
      this.setChanged('fromEvent', fromEvent);
    }

    get fromEvent() {
      const fromEvent = this.get('fromEvent'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? fromEvent : null;
    }

    set toEvent(toEvent) {
      this.setChanged('toEvent', toEvent);
    }

    get toEvent() {
      const toEvent = this.get('toEvent'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? toEvent : null;
    }

  }

  return CoreDependencyMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventMixin", function() { return CoreEventMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * Core event entity mixin type.
 *
 * At this level event is only aware about its dates
 * The functionality, related to the assignments etc is provided in other mixins.
 */

class CoreEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreEventMixin extends base {
    constructor() {
      super(...arguments);
      this._startDate = null;
      this._endDate = null;
      this._duration = null;
    } // Proper engine defines these fields since they enter graph, thus we need them


    static get fields() {
      return [{
        name: 'startDate',
        type: 'date'
      }, {
        name: 'endDate',
        type: 'date'
      }, {
        name: 'duration',
        type: 'number'
      }, {
        name: 'durationUnit',
        type: 'string',
        defaultValue: 'day'
      }];
    } // Getters return current or proposed value


    get startDate() {
      var _a, _b;

      return (_b = (_a = this._startDate) !== null && _a !== void 0 ? _a : this.get('startDate')) !== null && _b !== void 0 ? _b : null;
    }

    get endDate() {
      var _a, _b;

      return (_b = (_a = this._endDate) !== null && _a !== void 0 ? _a : this.get('endDate')) !== null && _b !== void 0 ? _b : null;
    }

    get duration() {
      var _a, _b;

      return (_b = (_a = this._duration) !== null && _a !== void 0 ? _a : this.get('duration')) !== null && _b !== void 0 ? _b : null;
    } // Route all setting through applyXX (setStartDate, startDate = , set('startDate'), batching)


    set startDate(value) {
      this.proposeStartDate(value);
    }

    set endDate(value) {
      this.proposeEndDate(value);
    }

    set duration(value) {
      this.proposeDuration(value);
    } //region Edge case normalization


    inSet(field, ...args) {
      var _a, _b, _c;

      const me = this;

      if (typeof field !== 'string') {
        const setStartDate = ('startDate' in field);
        const setEndDate = ('endDate' in field);
        const setDuration = ('duration' in field); // When given a start and end date but no duration we expect the duration to be calculated, but if
        // the supplied end date equals the current end date it will be considered a no-op and it will
        // erroneously keep the duration

        if (setStartDate && setEndDate && !setDuration) {
          // @ts-ignore
          const startDate = CoreEventMixin.processField('startDate', field.startDate, me); // @ts-ignore

          const endDate = CoreEventMixin.processField('endDate', field.endDate, me);

          if ((startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== ((_a = me.startDate) === null || _a === void 0 ? void 0 : _a.getTime()) && (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) === ((_b = me.endDate) === null || _b === void 0 ? void 0 : _b.getTime())) {
            me.proposeDuration(null);
            me.proposeEndDate(field.endDate);
          }
        } // When given a duration and end date but no start we expect the duration to be calculated, but if
        // the supplied end date equals the current end date it will be considered a no-op and it will
        // erroneously keep the start date


        if (!setStartDate && setEndDate && setDuration) {
          // @ts-ignore
          const endDate = CoreEventMixin.processField('endDate', field.endDate, me);

          if (field.duration !== me.duration && (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) === ((_c = me.endDate) === null || _c === void 0 ? void 0 : _c.getTime())) {
            me.proposeStartDate(null);
            me.proposeEndDate(field.endDate);
          }
        }
      } // @ts-ignore


      return superProto.inSet.call(me, field, ...args);
    } //endregion
    //region StartDate


    getStartDate() {
      return this.startDate;
    }

    proposeStartDate(startDate, keepDuration = true) {
      this._startDate = startDate;
      this.propose({
        startDate,
        keepDuration
      });
    }

    async setStartDate(startDate, keepDuration = true) {
      var _a;

      this.proposeStartDate(startDate, keepDuration);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    } //endregion
    //region EndDate


    getEndDate() {
      return this.endDate;
    }

    proposeEndDate(endDate, keepDuration = false) {
      this._endDate = endDate;
      this.propose({
        endDate,
        keepDuration
      });
    }

    async setEndDate(endDate, keepDuration = false) {
      var _a;

      this.proposeEndDate(endDate, keepDuration);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    } //endregion
    //region Duration


    getDuration() {
      return this.duration;
    }

    proposeDuration(duration, unit, keepStart = true) {
      this._duration = duration;
      this.propose({
        duration,
        keepStart
      });
      if (unit) this.propose({
        durationUnit: unit
      });
    }

    async setDuration(duration, unit, keepStart = true) {
      var _a;

      this.proposeDuration(duration, unit, keepStart);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    }

    getDurationUnit() {
      return this.durationUnit;
    } //endregion
    // When joining as part of inline data, store is available. If joining through load, it is passed


    joinProject() {
      var _a, _b;

      const me = this;
      const changed = me.$changed;
      const startDate = me.getCurrentOrProposed('startDate');
      const endDate = me.getCurrentOrProposed('endDate');
      const duration = me.getCurrentOrProposed('duration'); // Initial values should be considered changed, to be normalized

      if (startDate != null) changed.startDate = me._startDate = startDate;
      if (endDate != null) changed.endDate = me._endDate = endDate;
      if (duration != null) changed.duration = me._duration = duration; // Resolve assignments when event joins project after load

      if (me.eventStore && !me.eventStore.isLoadingData) {
        const unresolved = (_a = me.assignmentStore) === null || _a === void 0 ? void 0 : _a.storage.findItem('event', null);

        if (unresolved) {
          // To avoid n² iterations over raw assignments we cache them by raw eventId, which saves us
          // some iterations over the storage
          // https://github.com/bryntum/support/issues/3141
          const cachedAssignments = (_b = me.assignmentStore) === null || _b === void 0 ? void 0 : _b.storage.findItem('eventId', me.id);

          if (cachedAssignments) {
            for (const assignment of cachedAssignments) {
              assignment.setChanged('event', me);
            }
          } else {
            for (const assignment of unresolved) {
              if (assignment.getCurrentOrProposed('event') === me.id) {
                assignment.setChanged('event', me);
              }
            }
          }
        }
      }

      superProto.joinProject.call(me);
    } // Mimic how proper engine applies values


    applyValue(useProp, key, value, skipAccessors, field) {
      if (key === 'startDate' || key == 'duration' || key === 'endDate') {
        useProp = true; // Update cached value

        this['_' + key] = value;
      }

      if (skipAccessors) {
        useProp = false;
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessors, field);
    } // Catch changes from batches etc. In which case it is sometimes expected for data to be available directly


    afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
      if (!this.$isCalculating && !skipAccessors) {
        // In certain scenarios data is expected to be available of the bat, messy!
        this.setData(this.$changed);
      }

      superProto.afterChange.call(this, toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
    } // Normalizes dates & duration


    calculateInvalidated() {
      const me = this;
      const changed = me.$changed;
      const changedStart = ('startDate' in changed);
      const changedEnd = ('endDate' in changed);
      const changedDuration = ('duration' in changed);
      const {
        startDate,
        endDate,
        duration,
        keepDuration,
        keepStart
      } = changed;
      let calculate = null; // Only start changed

      if (changedStart && !changedEnd && !changedDuration) {
        // Also null end when nulling start (keeping duration)
        if (startDate === null) {
          changed.endDate = null;
        } // Start after end without keeping duration -> move end to start
        else if (me.hasCurrentOrProposed('endDate') && startDate > me.getCurrentOrProposed('endDate') && !keepDuration) {
          changed.endDate = startDate;
          changed.duration = 0;
        } // Start changed and we either have a duration that we want to keep or no end -> calculate end
        else if (me.hasCurrentOrProposed('duration') && (keepDuration || !me.hasCurrentOrProposed('endDate'))) {
          calculate = 'endDate';
        } // Start change and we have an end already -> calculate duration
        else if (me.hasCurrentOrProposed('endDate')) {
          calculate = 'duration';
        }
      } // Only end changed
      else if (!changedStart && changedEnd && !changedDuration) {
        // Also null start when nulling end (keeping duration)
        if (endDate === null) {
          changed.startDate = null;
        } // End before start without keeping duration -> move start to end
        else if (me.hasCurrentOrProposed('startDate') && endDate < me.getCurrentOrProposed('startDate') && !keepDuration) {
          changed.startDate = endDate;
          changed.duration = 0;
        } // End changed and we either have a duration that we want to keep or no start -> calculate start
        else if (me.hasCurrentOrProposed('duration') && (keepDuration || !me.hasCurrentOrProposed('startDate'))) {
          calculate = 'startDate';
        } // End changed and we have a start already -> calculate duration
        else if (me.hasCurrentOrProposed('startDate')) {
          calculate = 'duration';
        }
      } // Only duration changed
      else if (!changedStart && !changedEnd && changedDuration) {
        // Also null end when nulling duration (keeping start)
        if (duration === null) {
          changed.endDate = null;
        } // Duration changed and we either have a start that we want to keep or no end -> calculate end
        else if (me.hasCurrentOrProposed('startDate') && (keepStart || !me.hasCurrentOrProposed('endDate'))) {
          if (keepStart && changed.duration < 0) {
            changed.duration = 0;
          }

          calculate = 'endDate';
        } // Duration changed and we have an end already -> calculate start
        else if (me.hasCurrentOrProposed('endDate')) {
          calculate = 'startDate';
        }
      } // Start and end change, affect duration
      else if (changedStart && changedEnd && !changedDuration) {
        // Both nulled, null duration
        if (startDate === null && endDate === null) {
          changed.duration = null;
        } // Other cases -> calculate duration
        else {
          calculate = 'duration';
        }
      } // Start and duration change -> calculate end
      else if (changedStart && !changedEnd && changedDuration) {
        calculate = 'endDate';
      } // End and duration changed -> calculate start
      else if (!changedStart && changedEnd && changedDuration) {
        calculate = 'startDate';
      } // All changed -> calculate whichever is null or by default end to be sure things add up
      else if (changedStart && changedEnd && changedDuration) {
        if (duration == null) {
          calculate = 'duration';
        } else if (startDate == null) {
          calculate = 'startDate';
        } else {
          calculate = 'endDate';
        }
      } // Normalize if needed


      const currentOrProposedStartDate = me.getCurrentOrProposed('startDate');
      const currentOrProposedEndDate = me.getCurrentOrProposed('endDate');
      const currentOrProposedDuration = me.getCurrentOrProposed('duration');
      const currentOrProposedDurationUnit = me.getCurrentOrProposed('durationUnit');
      let hourDuration, targetDuration;

      switch (calculate) {
        case 'startDate':
          changed.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(currentOrProposedEndDate, -currentOrProposedDuration, currentOrProposedDurationUnit);
          break;

        case 'endDate':
          // convert proposed duration to hours to safely add over DST
          hourDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as('hour', currentOrProposedDuration, currentOrProposedDurationUnit); // convert calculated duration to task duration in task duration unit

          targetDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(currentOrProposedDurationUnit, hourDuration, 'h');
          changed.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(currentOrProposedStartDate, targetDuration, currentOrProposedDurationUnit);
          break;

        case 'duration':
          // convert proposed duration to hours to safely add over DST
          hourDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(currentOrProposedStartDate, currentOrProposedEndDate, 'h'); // convert calculated duration to task duration in task duration unit

          changed.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(currentOrProposedDurationUnit, hourDuration, 'h');
          break;
      }

      if (changed.startDate !== undefined) this._startDate = changed.startDate;
      if (changed.endDate !== undefined) this._endDate = changed.endDate;
      if (changed.duration !== undefined) this._duration = changed.duration;
      delete changed.keepDuration;
      delete changed.keepStart;
    }

  }

  return CoreEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js":
/*!**************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js ***!
  \**************************************************************************/
/*! exports provided: CoreHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasAssignmentsMixin", function() { return CoreHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");
var productName = 'gantt';




/**
 * This is a mixin, which can be applied to the [[CoreEventMixin]]. It provides the collection of all assignments,
 * which reference this event.
 *
 * Doesn't affect scheduling.
 */

class CoreHasAssignmentsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"], _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractHasAssignmentsMixin"]], base => {
  const superProto = base.prototype;

  class CoreHasAssignmentsMixin extends base {
    get assigned() {
      var _a;

      const assignments = (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getEventsAssignments(this); // Expected to still be able to return assignments when removed from project

      if (!assignments) {
        return this.$cachedAssignments;
      }

      return this.$cachedAssignments = assignments;
    }

    applyValue(useProp, key, value, skipAccessor, field) {
      var _a; // Changing id on an event should update resourceId on its assignments


      if (key === 'id') {
        (_a = this.assigned) === null || _a === void 0 ? void 0 : _a.forEach(assignment => assignment.set('eventId', value));
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
    }

    copy(newId = null, deep = null) {
      const copy = superProto.copy.call(this, newId, deep); // If deep is everything but object - use default behavior, which is to invoke accessors
      // If deep is an object, check if it has certain field disabled

      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(deep) && !deep.skipFieldIdentifiers || !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(deep)) {
        // Copy current assignments, used for occurrences
        copy.$cachedAssignments = this.assigned;
      }

      return copy;
    }

  }

  return CoreHasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js ***!
  \***************************************************************************/
/*! exports provided: CoreHasDependenciesMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasDependenciesMixin", function() { return CoreHasDependenciesMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
var productName = 'gantt';


/**
 * This is a mixin, which can be applied to the [[CoreEventMixin]]. It provides the collection of all dependencies,
 * which reference this event.
 *
 * Doesn't affect scheduling.
 */

class CoreHasDependenciesMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"]], base => {
  const superProto = base.prototype;

  class CoreHasDependenciesMixin extends base {
    get outgoingDeps() {
      return this.project.dependencyStore.getOutgoingDepsForEvent(this);
    }

    get incomingDeps() {
      return this.project.dependencyStore.getIncomingDepsForEvent(this);
    }

    leaveProject() {
      const eventStore = this.eventStore; // the buckets may be empty if a model is removed from the project immediately after adding
      // (without propagation)

      if (this.outgoingDeps) {
        this.outgoingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      if (this.incomingDeps) {
        this.incomingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      superProto.leaveProject.call(this);
    }

  }

  return CoreHasDependenciesMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceMixin", function() { return CoreResourceMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
var productName = 'gantt';


/**
 * Core resource model class.
 */

class CoreResourceMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreResourceMixin extends base {
    get assigned() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getResourcesAssignments(this);
    }

    joinProject() {
      var _a; // Set up assignment -> resource mapping when joining store after assignment (skip during load)
      // (note that there is no resourceStore yet when loading inline data, thus the first part of the condition)


      if (this.resourceStore && !this.resourceStore.isLoadingData) {
        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.query(a => a.get('resource') === this.id).forEach(unresolved => unresolved.setChanged('resource', this));
      }

      superProto.joinProject.call(this);
    }

    leaveProject(isReplacing = false) {
      // `this.assigned` will be empty if model is added to project and then removed immediately
      // w/o any propagations
      // when replacing a resource, the assignments should be left intact
      if (this.assigned && !isReplacing) {
        const resourceStore = this.resourceStore; // to batch the assignments removal, we don't remove the assignments right away, but instead
        // add them for the batched removal to the `assignmentsForRemoval` property of the event store

        this.assigned.forEach(assignment => resourceStore.assignmentsForRemoval.add(assignment));
      }

      superProto.leaveProject.call(this);
    }

    applyValue(useProp, key, value, skipAccessor, field) {
      // Changing id on a resource should update resourceId on its assignments
      // (note that field might not exist, if user supplies data for undefined fields)
      if ((field === null || field === void 0 ? void 0 : field.name) === 'id') {
        this.assigned.forEach(assignment => {
          assignment.set('resourceId', value);
        });
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
    }

  }

  return CoreResourceMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js ***!
  \*********************************************************************/
/*! exports provided: SchedulerCoreEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreEvent", function() { return SchedulerCoreEvent; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js");
/* harmony import */ var _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreHasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js");
var productName = 'gantt';




/**
 * This is an event class, [[SchedulerCoreProjectMixin]] is working with.
 * It is constructed as [[CoreEventMixin]], enhanced with [[CoreHasAssignmentsMixin]] and [[CoreHasDependenciesMixin]]
 */

class SchedulerCoreEvent extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"], _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreHasAssignmentsMixin"], _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreHasDependenciesMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerCoreEvent extends base {}

  return SchedulerCoreEvent;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js":
/*!****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js ***!
  \****************************************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, SchedulerCoreProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreProjectMixin", function() { return SchedulerCoreProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../store/CoreCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony import */ var _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony import */ var _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




















class EventsWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {}
class DelayableWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {}
/**
 * This is a project, implementing _basic scheduling_ as [[SchedulerBasicProjectMixin]] does.
 * Yet this class does not use _chronograph_ based engine.
 */

class SchedulerCoreProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_18__["AbstractProjectMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__["CorePartOfProjectGenericMixin"], EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class SchedulerCoreProjectMixin extends base {
    static get defaultConfig() {
      return {
        stm: {},
        eventStore: {},
        assignmentStore: {},
        resourceStore: {},
        dependencyStore: {},
        calendarManagerStore: {},
        eventModelClass: _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerCoreEvent"],
        assignmentModelClass: _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_7__["CoreAssignmentMixin"],
        resourceModelClass: _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__["CoreResourceMixin"],
        dependencyModelClass: _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_13__["CoreDependencyMixin"],
        calendarModelClass: _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_14__["CoreCalendarMixin"],
        eventStoreClass: _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__["CoreEventStoreMixin"],
        assignmentStoreClass: _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__["CoreAssignmentStoreMixin"],
        resourceStoreClass: _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreResourceStoreMixin"],
        dependencyStoreClass: _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["CoreDependencyStoreMixin"],
        calendarManagerStoreClass: _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__["CoreCalendarManagerStoreMixin"],
        assignmentsData: null,
        calendarsData: null,
        dependenciesData: null,
        eventsData: null,
        resourcesData: null
      };
    } //endregion
    //region Init


    construct(config = {}) {
      // Cannot be created with declaration, because of how TS is compiled to JS. Ends up after `construct()`
      this.$invalidated = new Set(); // Define default values for these flags here
      // if defined where declared then TS compiles them this way:
      // constructor() {
      //     super(...arguments)
      //     this.isPerformingCommit   = false
      //     this.silenceInitialCommit = true
      //     this.ongoing              = Promise.resolve()
      // }
      // which messes the flags values for inline data loading (since it's async)

      this.isPerformingCommit = false;
      this.silenceInitialCommit = true;
      this.ongoing = Promise.resolve();
      superProto.construct.call(this, config); // not part of the CalendarManagerStore intentionally, not persisted

      this.defaultCalendar = new this.calendarManagerStore.modelClass({
        unspecifiedTimeIsWorking: this.unspecifiedTimeIsWorking
      });
      this.defaultCalendar.project = this;
      const {
        calendarsData,
        eventsData,
        dependenciesData,
        resourcesData,
        assignmentsData
      } = this;
      const hasInlineData = Boolean(calendarsData || eventsData || dependenciesData || resourcesData || assignmentsData);

      if (hasInlineData) {
        this.loadInlineData({
          calendarsData,
          eventsData,
          dependenciesData,
          resourcesData,
          assignmentsData
        });
        delete this.calendarsData;
        delete this.eventsData;
        delete this.dependenciesData;
        delete this.resourcesData;
        delete this.assignmentsData;
      } else {
        // Trigger initial commit
        this.bufferedCommitAsync();
      }
    }

    doDestroy() {
      var _a, _b, _c, _d, _e, _f;

      const me = this;
      (_a = me.eventStore) === null || _a === void 0 ? void 0 : _a.destroy();
      (_b = me.dependencyStore) === null || _b === void 0 ? void 0 : _b.destroy();
      (_c = me.assignmentStore) === null || _c === void 0 ? void 0 : _c.destroy();
      (_d = me.resourceStore) === null || _d === void 0 ? void 0 : _d.destroy();
      (_e = me.calendarManagerStore) === null || _e === void 0 ? void 0 : _e.destroy();
      me.defaultCalendar.destroy();
      (_f = me.stm) === null || _f === void 0 ? void 0 : _f.destroy();
      superProto.doDestroy.call(this);
    }
    /**
     * This method loads the "raw" data into the project. The loading is basically happening by
     * assigning the individual data entries to the `data` property of the corresponding store.
     *
     * @param data
     */


    async loadInlineData(data) {
      this.isLoadingInlineData = true;

      if (data.calendarsData) {
        this.calendarManagerStore.data = data.calendarsData;
      }

      if (data.resourcesData) {
        this.resourceStore.data = data.resourcesData;
      }

      if (data.assignmentsData) {
        this.assignmentStore.data = data.assignmentsData;
      }

      if (data.eventsData) {
        this.eventStore.data = data.eventsData;
      }

      if (data.tasksData) {
        this.eventStore.data = data.tasksData;
      }

      if (data.dependenciesData) {
        this.dependencyStore.data = data.dependenciesData;
      }

      await this.commitLoad();
      this.isLoadingInlineData = false;
      return;
    } //endregion
    //region Join


    async commitLoad() {
      await this.commitAsync(); // Might have been destroyed during the async operation above

      if (!this.isDestroyed) this.trigger('load');
    }

    joinStoreRecords(store) {
      const fn = record => {
        record.setProject(this);
        record.joinProject();
      };

      if (store.rootNode) {
        store.rootNode.traverse(fn);
      } else {
        store.forEach(fn);
      }
    }

    unJoinStoreRecords(store) {
      const fn = record => {
        record.leaveProject();
        record.setProject(this);
      };

      if (store.rootNode) {
        store.rootNode.traverse(node => {
          // do not unjoin/leave project for the root node, which is the project itself
          if (node !== store.rootNode) fn(node);
        });
      } else {
        store.forEach(fn);
      }
    } //endregion
    //region EventStore


    resolveStoreAndModelClass(name, config) {
      // storeClass from supplied config or our properties
      const storeClass = (config === null || config === void 0 ? void 0 : config.storeClass) || this[`${name}StoreClass`]; // modelClass from supplied config

      let modelClass = config === null || config === void 0 ? void 0 : config.modelClass;

      if (!modelClass) {
        // or from storeClass.modelClass if customized
        // @ts-ignore
        if (this.getDefaultConfiguration()[`${name}ModelClass`] !== storeClass.getDefaultConfiguration().modelClass) {
          modelClass = storeClass.getDefaultConfiguration().modelClass;
        } // and if none of the above, use from our properties
        else {
          modelClass = this[`${name}ModelClass`];
        }
      }

      return {
        storeClass,
        modelClass
      };
    }

    get eventStore() {
      return this.$eventStore;
    }

    setEventStore(eventStore) {
      this.eventStore = eventStore;
    }

    set eventStore(eventStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$eventStore;
      me.detachStore(oldStore);

      if (!(eventStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('event', eventStore);
        eventStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, eventStore));
      } else {
        eventStore.project = me;
        stm.addStore(eventStore);
        me.joinStoreRecords(eventStore);
      }

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
        const {
          assignmentsForRemoval
        } = oldStore; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldEvent = assignment.event;

          if (oldEvent) {
            const newEvent = eventStore.getById(oldEvent.id);

            if (newEvent) {
              assignment.event = newEvent; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldStore.afterEventRemoval();
      }

      eventStore.setProject(me);
      me.$eventStore = eventStore;
      me.attachStore(eventStore);
      me.trigger('eventStoreChange', {
        store: eventStore
      });
    } //endregion
    //region AssignmentStore


    get assignmentStore() {
      return this.$assignmentStore;
    }

    setAssignmentStore(assignmentStore) {
      this.assignmentStore = assignmentStore;
    }

    set assignmentStore(assignmentStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$assignmentStore;
      me.detachStore(oldStore);

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
      }

      if (!(assignmentStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('assignment', assignmentStore);
        assignmentStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, assignmentStore));
      } else {
        assignmentStore.project = me;
        stm.addStore(assignmentStore);
        me.joinStoreRecords(assignmentStore);
      }

      assignmentStore.setProject(me);
      me.$assignmentStore = assignmentStore;
      me.attachStore(assignmentStore);
      me.trigger('assignmentStoreChange', {
        store: assignmentStore
      });
    } //endregion
    //region ResourceStore


    get resourceStore() {
      return this.$resourceStore;
    }

    setResourceStore(resourceStore) {
      this.resourceStore = resourceStore;
    }

    set resourceStore(resourceStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$resourceStore;
      me.detachStore(oldStore);

      if (!(resourceStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('resource', resourceStore);
        resourceStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, resourceStore));
      } else {
        resourceStore.project = me;
        stm.addStore(resourceStore);
        me.joinStoreRecords(resourceStore);
      }

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
        const {
          assignmentsForRemoval
        } = oldStore; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldResource = assignment.resource;

          if (oldResource) {
            const newResource = resourceStore.getById(oldResource.id);

            if (newResource) {
              assignment.resource = newResource; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldStore.afterResourceRemoval();
      }

      resourceStore.setProject(me);
      me.$resourceStore = resourceStore;
      me.attachStore(resourceStore);
      me.trigger('resourceStoreChange', {
        store: resourceStore
      });
    } //endregion
    //region DependencyStore


    get dependencyStore() {
      return this.$dependencyStore;
    }

    setDependencyStore(dependencyStore) {
      this.dependencyStore = dependencyStore;
    }

    set dependencyStore(dependencyStore) {
      const me = this;
      const oldStore = me.$dependencyStore;
      me.detachStore(oldStore);

      if (!(dependencyStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('dependency', dependencyStore);
        dependencyStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm: me.stm
        }, dependencyStore));
      } else {
        dependencyStore.project = me;
        me.stm.addStore(dependencyStore);
        me.joinStoreRecords(dependencyStore);
      }

      me.$dependencyStore = dependencyStore;
      me.attachStore(dependencyStore);
      me.trigger('dependencyStoreChange', {
        store: dependencyStore
      });
    } //endregion
    //region CalendarManagerStore


    get calendarManagerStore() {
      return this.$calendarManagerStore;
    }

    setCalendarManagerStore(calendarManagerStore) {
      this.calendarManagerStore = calendarManagerStore;
    }

    set calendarManagerStore(calendarManagerStore) {
      const me = this;
      const oldStore = me.$calendarManagerStore;
      me.detachStore(oldStore);

      if (!(calendarManagerStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        // @ts-ignore
        const storeClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.storeClass) || me.calendarManagerStoreClass; // @ts-ignore

        const modelClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.modelClass) || storeClass.getDefaultConfiguration().modelClass || me.calendarModelClass;
        calendarManagerStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm: me.stm
        }, calendarManagerStore));
      } else {
        me.stm.addStore(calendarManagerStore);
      }

      calendarManagerStore.setProject(me);
      me.$calendarManagerStore = calendarManagerStore;
      me.attachStore(calendarManagerStore);
      me.trigger('calendarManagerStoreChange', {
        store: calendarManagerStore
      });
    } //endregion
    //region Calendar


    get calendar() {
      return this.$calendar || this.defaultCalendar;
    }

    set calendar(calendar) {
      this.$calendar = calendar;
    }

    get effectiveCalendar() {
      return this.calendar;
    } //endregion
    //region Add records


    async addEvent(event) {
      this.eventStore.add(event);
      return this.commitAsync();
    }

    async addAssignment(assignment) {
      this.assignmentStore.add(assignment);
      return this.commitAsync();
    }

    async addResource(resource) {
      this.resourceStore.add(resource);
      return this.commitAsync();
    }

    async addDependency(dependency) {
      this.dependencyStore.add(dependency);
      return this.commitAsync();
    } //endregion
    //region Auto commit
    // Buffer commitAsync using setTimeout. Not using `buffer` on purpose, for performance reasons and to better
    // mimic how graph does it


    bufferedCommitAsync() {
      if (!this.hasPendingAutoCommit) {
        this.setTimeout({
          fn: 'commitAsync',
          delay: 10
        });
      }
    }

    get hasPendingAutoCommit() {
      return this.hasTimeout('commitAsync');
    }

    unScheduleAutoCommit() {
      this.clearTimeout('commitAsync');
    } //endregion
    //region Commit


    async commitAsync() {
      if (this.isPerformingCommit) return this.ongoing;
      return this.ongoing = this.doCommitAsync();
    }

    async doCommitAsync() {
      const me = this;
      me.isPerformingCommit = true; // Cancel any outstanding commit

      me.unScheduleAutoCommit();
      await Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_16__["delay"])(0);

      if (!me.isDestroyed) {
        // Calculate all invalidated records, updates their data silently
        for (const record of me.$invalidated) {
          record.calculateInvalidated();
        }

        const {
          isInitialCommit,
          silenceInitialCommit
        } = me; // apply changes silently if this is initial commit and "silenceInitialCommit" option is enabled

        const silenceCommit = isInitialCommit && silenceInitialCommit; // Notify stores that care about commit (internal)

        me.assignmentStore.onCommitAsync();
        me.dependencyStore.onCommitAsync();
        me.isInitialCommitPerformed = true;
        me.hasLoadedDataToCommit = false;
        me.isPerformingCommit = false;
        const stores = [me.assignmentStore, me.dependencyStore, me.eventStore, me.resourceStore, me.calendarManagerStore];
        stores.forEach(store => {
          var _a;

          return (_a = store.suspendAutoCommit) === null || _a === void 0 ? void 0 : _a.call(store);
        });
        me.isWritingData = true; // "Real" project triggers refresh before data is written back to records

        me.trigger('refresh', {
          isInitialCommit
        }); // If we are not announcing changes, take a cheaper path

        if (silenceCommit) {
          for (const record of me.$invalidated) {
            record.finalizeInvalidated(true);
          }
        } else {
          // Two loops looks a bit weird, but needed since editing assignment might affect event etc.
          // And we do only want a single update in the end
          // 1. Start batches and perform all calculations
          for (const record of me.$invalidated) {
            record.beginBatch(true);
            record.finalizeInvalidated();
          } // 2. End batches, announcing changes (unless initial commit)


          for (const record of me.$invalidated) {
            record.endBatch(false, true);
          }
        }

        me.isWritingData = false;
        me.$invalidated.clear(); // Mimic real projects events

        me.trigger('dataReady');
        stores.forEach(store => {
          var _a;

          return (_a = store.resumeAutoCommit) === null || _a === void 0 ? void 0 : _a.call(store);
        });
        return true;
      }
    }

    async propagateAsync() {
      return this.commitAsync();
    } // Called when a record invalidates itself, queues it for calculation


    invalidate(record) {
      this.$invalidated.add(record);
      this.bufferedCommitAsync();
    } // this does not account for possible scheduling conflicts


    async isValidDependency(...args) {
      return true;
    } //endregion
    //region STM


    getStm() {
      return this.stm;
    }
    /**
     * State tracking manager instance the project relies on
     */


    set stm(stm) {
      stm = this.$stm = new _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_17__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
        disabled: true
      }, stm));
      stm.on({
        // Propagate on undo/redo
        restoringStop: async () => {
          // Disable STM meanwhile to not pick it up as a new STM transaction
          stm.disable();
          await this.commitAsync();

          if (!this.isDestroyed) {
            stm.enable();
            this.trigger('stateRestoringDone');
          }
        }
      });
    }

    get stm() {
      return this.$stm;
    } //endregion


    isEngineReady() {
      return !this.hasPendingAutoCommit && !this.isPerformingCommit && this.isInitialCommitPerformed;
    }

  } //region Config


  SchedulerCoreProjectMixin.applyConfigs = true;
  return SchedulerCoreProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js":
/*!****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js ***!
  \****************************************************************************/
/*! exports provided: calculateEffectiveStartDateConstraintInterval, calculateEffectiveEndDateConstraintInterval, EarlyLateLazyness, ConstrainedEarlyEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateEffectiveStartDateConstraintInterval", function() { return calculateEffectiveStartDateConstraintInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateEffectiveEndDateConstraintInterval", function() { return calculateEffectiveEndDateConstraintInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EarlyLateLazyness", function() { return EarlyLateLazyness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstrainedEarlyEventMixin", function() { return ConstrainedEarlyEventMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../chrono/Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _scheduler_basic_HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scheduler_basic/HasSubEventsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









 //---------------------------------------------------------------------------------------------------------------------

const calculateEffectiveStartDateConstraintInterval = function* (event, startDateIntervalIntersection, endDateIntervalIntersection, duration) {
  if (endDateIntervalIntersection.isIntervalEmpty()) return _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["EMPTY_INTERVAL"];
  const startDate = endDateIntervalIntersection.startDateIsFinite() ? yield* event.calculateProjectedXDateWithDuration(endDateIntervalIntersection.startDate, false, duration) : null;
  const endDate = endDateIntervalIntersection.endDateIsFinite() ? yield* event.calculateProjectedXDateWithDuration(endDateIntervalIntersection.endDate, false, duration) : null;
  return Object(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["intersectIntervals"])([startDateIntervalIntersection, _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["DateInterval"].new({
    startDate,
    endDate
  })]);
};
const calculateEffectiveEndDateConstraintInterval = function* (event, startDateIntervalIntersection, endDateIntervalIntersection, duration) {
  if (startDateIntervalIntersection.isIntervalEmpty()) return _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["EMPTY_INTERVAL"];
  const startDate = startDateIntervalIntersection.startDateIsFinite() ? yield* event.calculateProjectedXDateWithDuration(startDateIntervalIntersection.startDate, true, duration) : null;
  const endDate = startDateIntervalIntersection.endDateIsFinite() ? yield* event.calculateProjectedXDateWithDuration(startDateIntervalIntersection.endDate, true, duration) : null;
  return Object(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["intersectIntervals"])([endDateIntervalIntersection, _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["DateInterval"].new({
    startDate,
    endDate
  })]);
};
const EarlyLateLazyness = true; //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin provides the constraint-based scheduling. Event is scheduled according to the set of _constraints_
 * which can be applied to start date or end date.
 *
 * Scheduling by constraints for an event can be disabled by setting its [[manuallyScheduled]] flag to `true`, which will delegate to previous behavior.
 *
 * The constraint is represented with the [[DateInterval]] class, which indicates the "allowed" interval for the
 * point being constrained.
 *
 * Scheduling by constraints algorithm
 * ---------------------------------
 *
 * Constraints for start date are accumulated in the [[earlyStartDateConstraintIntervals]] and [[startDateConstraintIntervals]] fields.
 * Constraints for end date are accumulated in the [[earlyEndDateConstraintIntervals]] and [[endDateConstraintIntervals]] fields.
 *
 * This mixin does not define where the constraints for the event comes from. The constraints are calculated in the field
 * calculation methods, (like [[calculateEarlyStartDateConstraintIntervals]]) which just return empty arrays. Some other mixins
 * may override those methods and can generate actual constraints (the [[ScheduledByDependenciesEarlyEventMixin]] is an example).
 * The "early" fields contains the constraints which are related to scheduling event in the as-soon-as-possible manner.
 * The fields w/o "early" prefix contains the constraints which do not related to the ASAP scheduling.
 *
 * "Early" and "normal" constraints for every date are combined, then intersected, which gives "combined" constraining interval.
 *
 * So at this point we have a "combined" constraining interval for start date and for end date.
 *
 * Then, the interval for start date is shifted on the event duration to the right and this gives an additional constraint for the
 * end date. The similar operation is done with the interval for the end date.
 *
 * After intersection with those additional intervals we receive the final constraining interval for both dates. Since we
 * are using the ASAP scheduling, we just pick the earliest possible date.
 *
 * If any of intervals is empty then we consider it as scheduling conflict, and [[EngineReplica.reject|reject]] the transaction.
 *
 */

class ConstrainedEarlyEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_basic_HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_8__["HasSubEventsMixin"]], base => {
  const superProto = base.prototype;

  class ConstrainedEarlyEventMixin extends base {
    // * validateProposedStartDate (startDate : Date) : CalculationIterator<void> {
    //     // if we have a proposed date let's validate it against registered constraining intervals
    //     if (startDate) {
    //         // need to adjust the proposed date according to the calendar, to avoid unnecessary conflicts
    //         const adjustedProposedDate : Date = yield* this.skipNonWorkingTime(startDate, true)
    //
    //         const startDateIntervals : DateInterval[] = []//yield this.$.combinedStartDateConstraintIntervals
    //
    //         let acc : DateInterval      = DateInterval.new()
    //
    //         for (let interval of startDateIntervals) {
    //             acc                     = acc.intersect(interval)
    //
    //             if (!acc.containsDate(adjustedProposedDate)) {
    //                 // TODO: trigger conflict here
    //                 // yield ProposedDateOutsideOfConstraint.new({
    //                 //     proposedDate        : adjustedProposedDate,
    //                 //     conflictingInterval : interval
    //                 // })
    //             }
    //         }
    //     }
    // }
    //
    //
    // * validateProposedEndDate (endDate : Date) : CalculationIterator<void> {
    //     if (endDate) {
    //         const adjustedProposedDate : Date = yield* this.skipNonWorkingTime(endDate, false)
    //
    //         const endDateIntervals : DateInterval[] = []//yield this.$.combinedEndDateConstraintIntervals
    //
    //         let acc : DateInterval      = DateInterval.new()
    //
    //         for (let interval of endDateIntervals) {
    //             acc                     = acc.intersect(interval)
    //
    //             if (!acc.containsDate(adjustedProposedDate)) {
    //                 // yield ProposedDateOutsideOfConstraint.new({
    //                 //     proposedDate        : adjustedProposedDate,
    //                 //     conflictingInterval : interval
    //                 // })
    //             }
    //         }
    //     }
    // }
    // Skips non-working time if it's needed to the event
    *maybeSkipNonWorkingTime(date, isForward = true) {
      let duration = yield* this.calculateEffectiveDuration();
      return date && duration > 0 ? yield* this.skipNonWorkingTime(date, isForward) : date;
    }

    *calculateEffectiveConstraintInterval(isStartDate, startDateConstraintIntervals, endDateConstraintIntervals) {
      const effectiveDurationToUse = yield* this.calculateEffectiveDuration();

      if (effectiveDurationToUse == null) {
        return null;
      }

      const calculateIntervalFn = isStartDate ? calculateEffectiveStartDateConstraintInterval : calculateEffectiveEndDateConstraintInterval;
      const effectiveInterval = yield* calculateIntervalFn(this, Object(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["intersectIntervals"])(startDateConstraintIntervals), Object(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_5__["intersectIntervals"])(endDateConstraintIntervals), effectiveDurationToUse);
      return effectiveInterval;
    }
    /**
     * Calculation method for the [[startDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the start date.
     */


    *calculateStartDateConstraintIntervals() {
      return [];
    }
    /**
     * Calculation method for the [[endDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the end date.
     */


    *calculateEndDateConstraintIntervals() {
      return [];
    }
    /**
     * Calculation method for the [[earlyStartDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the start date during the ASAP scheduling.
     */


    *calculateEarlyStartDateConstraintIntervals() {
      return [];
    }
    /**
     * Calculation method for the [[earlyEndDateConstraintIntervals]]. Returns empty array by default.
     * Override this method to return some extra constraints for the end date during the ASAP scheduling.
     */


    *calculateEarlyEndDateConstraintIntervals() {
      return [];
    }

    *calculateEarlyEffectiveStartDateInterval() {
      const startDateConstraintIntervals = yield this.$.earlyStartDateConstraintIntervals;
      const endDateConstraintIntervals = yield this.$.earlyEndDateConstraintIntervals;
      return yield* this.calculateEffectiveConstraintInterval(true, // need to use concat instead of directly mutating the `startDateConstraintIntervals` since that is
      // used as storage for `this.$.earlyStartDateConstraintIntervals`
      startDateConstraintIntervals.concat(yield this.$.startDateConstraintIntervals), endDateConstraintIntervals.concat(yield this.$.endDateConstraintIntervals));
    }

    *calculateEarlyEffectiveEndDateInterval() {
      const startDateConstraintIntervals = yield this.$.earlyStartDateConstraintIntervals;
      const endDateConstraintIntervals = yield this.$.earlyEndDateConstraintIntervals;
      return yield* this.calculateEffectiveConstraintInterval(false, // need to use concat instead of directly mutating the `startDateConstraintIntervals` since that is
      // used as storage for `this.$.earlyStartDateConstraintIntervals`
      startDateConstraintIntervals.concat(yield this.$.startDateConstraintIntervals), endDateConstraintIntervals.concat(yield this.$.endDateConstraintIntervals));
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[earlyStartDate]].
     * Child events roll up their [[earlyStartDate]] values to their summary tasks.
     * So a summary task [[earlyStartDate]] date gets equal to its minimal child [[earlyStartDate]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildEarlyStartDate(child) {
      return true;
    }

    *calculateMinChildrenEarlyStartDate() {
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MAX_DATE"];
      const subEventsIterator = yield* this.subEventsIterable();

      for (let childEvent of subEventsIterator) {
        let childDate;
        if (!(yield* this.shouldRollupChildEarlyStartDate(childEvent))) continue;

        if ((yield childEvent.$.manuallyScheduled) && (yield* childEvent.hasSubEvents())) {
          childDate = yield childEvent.$.minChildrenEarlyStartDate;
        }

        childDate = childDate || (yield childEvent.$.earlyStartDate);
        if (childDate && childDate < result) result = childDate;
      }

      return result.getTime() - _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MAX_DATE"].getTime() ? result : null;
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[earlyEndDate]].
     * Child events roll up their [[earlyEndDate]] values to their summary tasks.
     * So a summary task [[earlyEndDate]] gets equal to its maximal child [[earlyEndDate]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildEarlyEndDate(child) {
      return true;
    }

    *calculateMaxChildrenEarlyEndDate() {
      let result = _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MIN_DATE"];
      const subEventsIterator = yield* this.subEventsIterable();

      for (let childEvent of subEventsIterator) {
        let childDate;
        if (!(yield* this.shouldRollupChildEarlyEndDate(childEvent))) continue;

        if ((yield childEvent.$.manuallyScheduled) && (yield* childEvent.hasSubEvents())) {
          childDate = yield childEvent.$.maxChildrenEarlyEndDate;
        }

        childDate = childDate || (yield childEvent.$.earlyEndDate);
        if (childDate && childDate > result) result = childDate;
      }

      return result.getTime() - _util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["MIN_DATE"].getTime() ? result : null;
    }

    *calculateEarlyStartDateRaw() {
      // Manually scheduled task treat its current start date as its early start date
      // in case of forward scheduling.
      // Late dates in that case are calculated the same way it happens for automatic tasks
      if ((yield this.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward) {
        return yield this.$.startDate;
      } // Parent task calculate its early start date as minimal early start date of its children


      if (yield* this.hasSubEvents()) {
        return yield this.$.minChildrenEarlyStartDate;
      }

      if (!(yield* this.isConstrainedEarly())) {
        return yield this.$.startDate;
      }

      const effectiveInterval = yield this.$.earlyEffectiveStartDateInterval;

      if (effectiveInterval === null) {
        return null;
      } else if (effectiveInterval.isIntervalEmpty()) {
        const conflict = _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_3__["ConflictEffect"].new();

        if ((yield conflict) === _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_3__["ConflictResolutionResult"].Cancel) {
          yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])(conflict);
        } else {
          return null;
        }
      }

      return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(effectiveInterval.startDate) ? effectiveInterval.startDate : null;
    }

    *calculateEarlyStartDate() {
      const date = yield this.$.earlyStartDateRaw;
      return yield* this.maybeSkipNonWorkingTime(date, true);
    }

    *calculateEarlyEndDateRaw() {
      // Manually scheduled task treat its current end date as its early end date
      // in case of forward scheduling.
      // Late dates in that case are calculated the same way it happens for automatic tasks
      if ((yield this.$.manuallyScheduled) && (yield this.$.direction) === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward) {
        return yield this.$.endDate;
      } // Parent task calculate its early end date as maximum early end date of its children


      if (yield* this.hasSubEvents()) {
        return yield this.$.maxChildrenEarlyEndDate;
      }

      if (!(yield* this.isConstrainedEarly())) {
        return yield this.$.endDate;
      }

      const effectiveInterval = yield this.$.earlyEffectiveEndDateInterval;

      if (effectiveInterval === null) {
        return null;
      } else if (effectiveInterval.isIntervalEmpty()) {
        const conflict = _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_3__["ConflictEffect"].new();

        if ((yield conflict) === _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_3__["ConflictResolutionResult"].Cancel) {
          yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])(conflict);
        } else {
          return null;
        }
      }

      return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(effectiveInterval.startDate) ? effectiveInterval.startDate : null;
    }

    *calculateEarlyEndDate() {
      return yield this.$.earlyEndDateRaw;
    }

    *isConstrainedEarly() {
      const startDateIntervals = yield this.$.startDateConstraintIntervals;
      const endDateIntervals = yield this.$.endDateConstraintIntervals;
      const earlyStartDateConstraintIntervals = yield this.$.earlyStartDateConstraintIntervals;
      const earlyEndDateConstraintIntervals = yield this.$.earlyEndDateConstraintIntervals;
      return Boolean((startDateIntervals === null || startDateIntervals === void 0 ? void 0 : startDateIntervals.length) || (endDateIntervals === null || endDateIntervals === void 0 ? void 0 : endDateIntervals.length) || (earlyStartDateConstraintIntervals === null || earlyStartDateConstraintIntervals === void 0 ? void 0 : earlyStartDateConstraintIntervals.length) || (earlyEndDateConstraintIntervals === null || earlyEndDateConstraintIntervals === void 0 ? void 0 : earlyEndDateConstraintIntervals.length));
    }

    *calculateStartDatePure() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward) {
        // early exit if this mixin is not applicable, but only after(!) the direction check
        // this is because the `isConstrainedEarly` yield early constraint intervals, which are generally lazy,
        // depending from the direction
        if (!(yield* this.isConstrainedEarly()) || (yield this.$.manuallyScheduled)) {
          return yield* superProto.calculateStartDatePure.call(this);
        }

        return (yield this.$.earlyStartDate) || (yield* superProto.calculateStartDatePure.call(this));
      } else {
        return yield* superProto.calculateStartDatePure.call(this);
      }
    }

    *calculateStartDateProposed() {
      const direction = yield this.$.direction;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward:
          // early exit if this mixin is not applicable, but only after(!) the direction check
          // this is because the `isConstrainedEarly` yield early constraint intervals, which are generally lazy,
          // depending from the direction
          if (!(yield* this.isConstrainedEarly()) || (yield this.$.manuallyScheduled)) {
            return yield* superProto.calculateStartDateProposed.call(this);
          }

          const autoStartDate = yield this.$.earlyStartDate;

          if (autoStartDate) {
            if (Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(autoStartDate)) return autoStartDate;
            const baseSchedulingStartDate = yield* superProto.calculateStartDateProposed.call(this);
            const earlyEffectiveStartDateInterval = yield this.$.earlyEffectiveStartDateInterval;
            if (earlyEffectiveStartDateInterval.containsDate(baseSchedulingStartDate)) return baseSchedulingStartDate;
            return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(earlyEffectiveStartDateInterval.endDate) ? earlyEffectiveStartDateInterval.endDate : baseSchedulingStartDate;
          } else {
            return yield* superProto.calculateStartDateProposed.call(this);
          }

        default:
          return yield* superProto.calculateStartDateProposed.call(this);
      }
    }

    *calculateEndDatePure() {
      const direction = yield this.$.direction;

      if (direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward) {
        // early exit if this mixin is not applicable, but only after(!) the direction check
        // this is because the `isConstrainedEarly` yield early constraint intervals, which are generally lazy,
        // depending from the direction
        if (!(yield* this.isConstrainedEarly()) || (yield this.$.manuallyScheduled)) {
          return yield* superProto.calculateEndDatePure.call(this);
        }

        return (yield this.$.earlyEndDate) || (yield* superProto.calculateEndDatePure.call(this));
      } else {
        return yield* superProto.calculateEndDatePure.call(this);
      }
    }

    *calculateEndDateProposed() {
      const direction = yield this.$.direction;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_6__["Direction"].Forward:
          // early exit if this mixin is not applicable, but only after(!) the direction check
          // this is because the `isConstrainedEarly` yield early constraint intervals, which are generally lazy,
          // depending from the direction
          if (!(yield* this.isConstrainedEarly()) || (yield this.$.manuallyScheduled)) {
            return yield* superProto.calculateEndDateProposed.call(this);
          }

          const autoEndDate = yield this.$.earlyEndDate;

          if (autoEndDate) {
            if (Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(autoEndDate)) return autoEndDate;
            const baseSchedulingEndDate = yield* superProto.calculateEndDateProposed.call(this);
            const earlyEffectiveEndDateInterval = yield this.$.earlyEffectiveEndDateInterval;
            if (earlyEffectiveEndDateInterval.containsDate(baseSchedulingEndDate)) return baseSchedulingEndDate;
            return Object(_util_Constants_js__WEBPACK_IMPORTED_MODULE_7__["isDateFinite"])(earlyEffectiveEndDateInterval.endDate) ? earlyEffectiveEndDateInterval.endDate : baseSchedulingEndDate;
          } else {
            return yield* superProto.calculateEndDateProposed.call(this);
          }

        default:
          return yield* superProto.calculateEndDateProposed.call(this);
      }
    } // // TODO make this method smart in regard of providing conflict resolution information
    // /**
    //  * Finds the intersection of provided intervals.
    //  * If some of the intervals doesn't intersect the methods yields IntervalConflict
    //  * with the interval reference.
    //  * @param intervals Intervals to find intersection of
    //  * @private
    //  */
    // * validateIntervalsIntersection (intervals : DateInterval[]) : CalculationIterator<DateInterval> {
    //     let intersection : DateInterval = DateInterval.new()
    //
    //     for (let interval of intervals) {
    //         intersection = intersection.intersect(interval)
    //
    //         // TODO: trigger conflict here
    //         if (intersection.isIntervalEmpty()) {
    //             // if some interval has no intersection w/ other(s) we throw a conflict
    //             // yield IntervalConflict.new({ conflictingInterval : interval })
    //         }
    //     }
    //
    //     return intersection
    // }
    // * calculateStartDateIntervalsByEndDateIntervals (intervals : DateInterval[]) : CalculationIterator<Date | DateInterval[]> {
    //     let result : DateInterval[] = []
    //     for (let interval of intervals) {
    //         result.push(DateInterval.new({
    //             onRemoveAction    : interval.onRemoveAction,
    //             originDescription : interval.originDescription,
    //             startDate         : interval.startDateIsFinite() ? yield* this.calculateProjectedStartDate(interval.startDate) : null,
    //             endDate           : interval.endDateIsFinite() ? yield* this.calculateProjectedStartDate(interval.endDate) : null,
    //         }))
    //     }
    //     return result
    // }
    // * calculateEndDateIntervalsByStartDateIntervals (intervals : DateInterval[]) : CalculationIterator<Date | DateInterval[]> {
    //     let result : DateInterval[] = []
    //     for (let interval of intervals) {
    //         result.push(DateInterval.new({
    //             onRemoveAction    : interval.onRemoveAction,
    //             originDescription : interval.originDescription,
    //             startDate         : interval.startDateIsFinite() ? yield* this.calculateProjectedEndDate(interval.startDate) : null,
    //             endDate           : interval.endDateIsFinite() ? yield* this.calculateProjectedEndDate(interval.endDate) : null,
    //         }))
    //     }
    //     return result
    // }
    // // Indicates if calculateProjectedStartDate and calculateProjectedStartDate method can calculate values.
    // * canCalculateProjectedXDate () : CalculationIterator<boolean> {
    //     return true
    // //     // need to have duration value
    // //     return !(yield* this.shouldRecalculateDuration())
    // }
    // TODO: add intervals validation
    // @calculate('validInitialIntervals')
    // * calculateValidInitialIntervals () : CalculationIterator<this[ 'validInitialIntervals' ]> {
    //     const startDateIntervals : DateInterval[] = yield this.$.startDateConstraintIntervals
    //     const endDateIntervals : DateInterval[]   = yield this.$.endDateConstraintIntervals
    //     // calculate effective start date constraining interval
    //     let startDateInterval : DateInterval = intersectIntervals(startDateIntervals)
    //     // calculate effective end date constraining interval
    //     let endDateInterval : DateInterval   = intersectIntervals(endDateIntervals)
    //     const canCalculateProjectedXDate = yield* this.canCalculateProjectedXDate()
    //     // if we can't use calculateProjectedStartDate/calculateProjectedEndDate methods then we cannot do anything else -> return
    //     if (!canCalculateProjectedXDate && !startDateInterval.isIntervalEmpty() && !endDateInterval.isIntervalEmpty()) {
    //         return {
    //             startDateInterval,
    //             endDateInterval
    //         }
    //     }
    //     const additionalConstraintForStartDate  = DateInterval.new({
    //         startDate   : endDateInterval.startDateIsFinite() ? yield* this.calculateProjectedStartDate(endDateInterval.startDate) : null,
    //         endDate     : endDateInterval.endDateIsFinite() ? yield* this.calculateProjectedStartDate(endDateInterval.endDate) : null,
    //     })
    //     startDateInterval = startDateInterval.intersect(additionalConstraintForStartDate)
    //     // If no intersection w/ additional interval let's intersects intervals one by one
    //     // and yield Conflict
    //     if (startDateInterval.isIntervalEmpty()) {
    //         const reflectedIntervals = yield* this.calculateStartDateIntervalsByEndDateIntervals(endDateIntervals)
    //         let combinedIntervals
    //         if (startDateIntervals.length > 1) {
    //             combinedIntervals = startDateIntervals
    //                 .slice(0, startDateIntervals.length - 1)
    //                 .concat(reflectedIntervals)
    //                 .concat(startDateIntervals[startDateIntervals.length - 1])
    //         } else {
    //             combinedIntervals = startDateIntervals.concat(reflectedIntervals)
    //         }
    //         yield* this.validateIntervalsIntersection(combinedIntervals)
    //     } else {
    //         const additionalConstraintForEndDate    = DateInterval.new({
    //             startDate   : startDateInterval.startDateIsFinite() ? yield* this.calculateProjectedEndDate(startDateInterval.startDate) : null,
    //             endDate     : startDateInterval.endDateIsFinite() ? yield* this.calculateProjectedEndDate(startDateInterval.endDate) : null,
    //         })
    //         endDateInterval = endDateInterval.intersect(additionalConstraintForEndDate)
    //     }
    //     return {
    //         startDateInterval,
    //         endDateInterval
    //     }
    // }


    *calculateDirection() {
      const project = this.getProject();
      return yield project.$.direction;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "minChildrenEarlyStartDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "earlyStartDateRaw", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'date',
    persist: false
  }, {
    lazy: EarlyLateLazyness,
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["dateConverter"],
    persistent: false
  })], ConstrainedEarlyEventMixin.prototype, "earlyStartDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "maxChildrenEarlyEndDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "earlyEndDateRaw", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'date',
    persist: false
  }, {
    lazy: EarlyLateLazyness,
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["dateConverter"],
    persistent: false
  })], ConstrainedEarlyEventMixin.prototype, "earlyEndDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], ConstrainedEarlyEventMixin.prototype, "startDateConstraintIntervals", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], ConstrainedEarlyEventMixin.prototype, "endDateConstraintIntervals", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "earlyStartDateConstraintIntervals", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])({
    lazy: EarlyLateLazyness
  })], ConstrainedEarlyEventMixin.prototype, "earlyEndDateConstraintIntervals", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], ConstrainedEarlyEventMixin.prototype, "earlyEffectiveStartDateInterval", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], ConstrainedEarlyEventMixin.prototype, "earlyEffectiveEndDateInterval", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('startDateConstraintIntervals')], ConstrainedEarlyEventMixin.prototype, "calculateStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('endDateConstraintIntervals')], ConstrainedEarlyEventMixin.prototype, "calculateEndDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyStartDateConstraintIntervals')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyStartDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyEndDateConstraintIntervals')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyEndDateConstraintIntervals", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyEffectiveStartDateInterval')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyEffectiveStartDateInterval", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyEffectiveEndDateInterval')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyEffectiveEndDateInterval", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('minChildrenEarlyStartDate')], ConstrainedEarlyEventMixin.prototype, "calculateMinChildrenEarlyStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('maxChildrenEarlyEndDate')], ConstrainedEarlyEventMixin.prototype, "calculateMaxChildrenEarlyEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyStartDateRaw')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyStartDateRaw", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyStartDate')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyEndDateRaw')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyEndDateRaw", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('earlyEndDate')], ConstrainedEarlyEventMixin.prototype, "calculateEarlyEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('direction')], ConstrainedEarlyEventMixin.prototype, "calculateDirection", null);

  return ConstrainedEarlyEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/HasDateConstraintMixin.js":
/*!************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/HasDateConstraintMixin.js ***!
  \************************************************************************/
/*! exports provided: HasDateConstraintMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasDateConstraintMixin", function() { return HasDateConstraintMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
/* harmony import */ var _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









/**
 * This mixin implements a date-based based constraint for the event.
 * It provides the following constraint types:
 *
 * - _Start no earlier than (SNET)_ - restricts the event to start on or after the specified date.
 * - _Finish no earlier than (FNET)_ - restricts the event to finish on or after the specified date.
 * - _Start no later than (SNLT)_ - restricts the event to start before (or on) the specified date.
 * - _Finish no later than (FNLT)_ - restricts the event to finish before (or on) the specified date.
 * - _Must start on (MSO)_ - restricts the event to start on the specified date.
 * - _Must finish on (MFO)_ - restricts the event to finish on the specified date.
 *
 * The type of constraint is defined by the [[constraintType]] property. Types has self-descriptive names.
 * There's also [[constraintDate]] with a constraint date.
 *
 */

class HasDateConstraintMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_7__["ConstrainedEarlyEventMixin"], _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_6__["HasChildrenMixin"]], base => {
  const superProto = base.prototype;

  class HasDateConstraint extends base {
    writeStartDate(me, transaction, quark, date, keepDuration = true) {
      // get constraint type that should be used to enforce start date or
      // null if the change cannot be enforced (happens when the task is manually scheduled so no need for enforcement or
      // some constraint is already set)
      const project = this.getProject(); // `writeStartDate` will be called for initial write to the `startDate` at the point of adding it to graph
      // at that time there possibly be no `direction` identifier yet
      // it seems this line relies on the fact, that `direction` field is declared after the `startDate`

      if (transaction.graph.hasIdentifier(this.$.direction) && !(project && project.getStm().isRestoring)) {
        const constrainType = this.getStartDatePinConstraintType();

        if (constrainType) {
          this.constraintType = constrainType;
          this.constraintDate = date;
        }
      }

      return superProto.writeStartDate.call(this, me, transaction, quark, date, keepDuration);
    }

    writeEndDate(me, transaction, quark, date, keepDuration = false) {
      // get constraint type that should be used to enforce End date or
      // null if the change cannot be enforced (happens when the task is manually scheduled so no need for enforcement or
      // some constraint is already set)
      const project = this.getProject();

      if (transaction.graph.hasIdentifier(this.$.direction) && keepDuration && !(project && project.getStm().isRestoring)) {
        const constrainType = this.getEndDatePinConstraintType();

        if (constrainType) {
          this.constraintType = constrainType;
          this.constraintDate = date;
        }
      }

      return superProto.writeEndDate.call(this, me, transaction, quark, date, keepDuration);
    }

    *calculateConstraintType() {
      let constraintType = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"]; // use proposed constraint type if provided and is applicable to the event

      if (!(yield* this.isConstraintTypeApplicable(constraintType))) {
        constraintType = null;
      }

      return constraintType;
    }

    *calculateConstraintDate(Y) {
      let constraintDate = yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
      const constraintType = yield this.$.constraintType;

      if (!constraintType) {
        constraintDate = null;
      } // use proposed constraint date if provided
      else if (!constraintDate) {
        // fill constraint date based on constraint type provided
        constraintDate = this.getConstraintTypeDefaultDate(Y, constraintType);
      }

      return constraintDate;
    }

    getStartDatePinConstraintType() {
      const {
        direction
      } = this;
      if (!this.isTaskPinnableWithConstraint()) return null;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["Direction"].Forward:
          return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoEarlierThan;

        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["Direction"].Backward:
          return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoLaterThan;
      }
    }

    getEndDatePinConstraintType() {
      const {
        direction
      } = this;
      if (!this.isTaskPinnableWithConstraint()) return null;

      switch (direction) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["Direction"].Forward:
          return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoEarlierThan;

        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["Direction"].Backward:
          return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoLaterThan;
      }
    }
    /**
     * Indicates if the task can be pinned with a constraint
     * to enforce its start/end date changes.
     * @private
     */


    isTaskPinnableWithConstraint() {
      const {
        manuallyScheduled,
        constraintType
      } = this;
      let result = false; // we should not pin manually scheduled tasks

      if (!manuallyScheduled) {
        if (constraintType) {
          switch (constraintType) {
            case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoEarlierThan:
            case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoLaterThan:
            case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoEarlierThan:
            case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoLaterThan:
              result = true;
          }
        } // no constraints -> we can pin
        else {
          result = true;
        }
      }

      return result;
    }
    /**
     * Returns default constraint date value for the constraint type provided
     * (either start or end date of the event).
     */


    getConstraintTypeDefaultDate(Y, constraintType) {
      switch (constraintType) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoEarlierThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoLaterThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustStartOn:
          return Y(Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.startDate));

        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoEarlierThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoLaterThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustFinishOn:
          return Y(Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPreviousValueOf"])(this.$.endDate));
      }

      return null;
    }
    /**
     * Returns true if the provided constraint type is applicable to the event.
     *
     * @param {ConstraintType} constraintType Constraint type.
     * @returns `True` if the provided constraint type is applicable (`false` otherwise).
     */


    *isConstraintTypeApplicable(constraintType) {
      const childEvents = yield this.$.childEvents; // Take into account if the event is leaf

      const isSummary = childEvents.size > 0;

      switch (constraintType) {
        // these constraints are applicable to leaves only
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoEarlierThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoLaterThan:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustFinishOn:
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustStartOn:
          return !isSummary;
      }

      return true;
    }
    /**
     * Sets the constraint type (if applicable) and constraining date to the task.
     * @param {ConstraintType}  constraintType   Constraint type.
     * @param {Date}            [constraintDate] Constraint date.
     * @returns Promise<PropagateResult>
     */


    async setConstraint(constraintType, constraintDate) {
      this.constraintType = constraintType;

      if (constraintDate !== undefined) {
        this.constraintDate = constraintDate;
      }

      return this.commitAsync();
    }

    *calculateEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEndDateConstraintIntervals.call(this);
      const constraintType = yield this.$.constraintType;
      const constraintDate = yield this.$.constraintDate;

      if (constraintType && constraintDate) {
        // if constraint type is
        switch (constraintType) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustFinishOn:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              startDate: constraintDate,
              endDate: constraintDate
            }));
            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoEarlierThan:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              startDate: constraintDate
            }));
            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].FinishNoLaterThan:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              endDate: constraintDate
            }));
            break;
        }
      }

      return intervals;
    }

    *calculateStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateStartDateConstraintIntervals.call(this);
      const constraintType = yield this.$.constraintType;
      const constraintDate = yield this.$.constraintDate;

      if (constraintType && constraintDate) {
        // if constraint type is
        switch (constraintType) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].MustStartOn:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              startDate: constraintDate,
              endDate: constraintDate
            }));
            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoEarlierThan:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              startDate: constraintDate
            }));
            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["ConstraintType"].StartNoLaterThan:
            intervals.unshift(_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_4__["DateInterval"].new({
              endDate: constraintDate
            }));
            break;
        }
      }

      return intervals;
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'string'
  }, {
    sync: true
  })], HasDateConstraint.prototype, "constraintType", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'date'
  }, {
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["dateConverter"],
    sync: true
  })], HasDateConstraint.prototype, "constraintDate", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('constraintType')], HasDateConstraint.prototype, "calculateConstraintType", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('constraintDate')], HasDateConstraint.prototype, "calculateConstraintDate", null);

  return HasDateConstraint;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/HasPercentDoneMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/HasPercentDoneMixin.js ***!
  \*********************************************************************/
/*! exports provided: HasPercentDoneMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasPercentDoneMixin", function() { return HasPercentDoneMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/HasChildrenMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasChildrenMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







/* TODO
The percentdone logic calculation is a bit different from the Ext version, in regard of milestones
In Ext, the parent task with milestones only has 100% if all its child milestones have 100%, and 0% otherwise
In engine, the % for milestones is calculated just as average. There are other small nuances too.
Personally I think engine's behavior is more logical and we can change it to Ext version behavior
because we have all data.
*/

/**
 * This mixin provides [[percentDone]] field for the event and methods for its calculation.
 *
 * For the parent events percent done is calculated based on the child events (ignores user input).
 * This behavior is controlled with the [[SchedulerProProjectMixin.autoCalculatePercentDoneForParentTasks]] config option.
 */

class HasPercentDoneMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_basic_HasChildrenMixin_js__WEBPACK_IMPORTED_MODULE_5__["HasChildrenMixin"]], base => {
  const superProto = base.prototype;

  class HasPercentDoneMixin extends base {
    *calculatePercentDone() {
      const childEvents = yield this.$.childEvents;
      const project = this.getProject();
      const autoCalculatePercentDoneForParentTasks = yield project.$.autoCalculatePercentDoneForParentTasks;

      if (childEvents.size && autoCalculatePercentDoneForParentTasks) {
        const summaryData = yield this.$.percentDoneSummaryData;

        if (summaryData.totalDuration > 0) {
          return summaryData.completedDuration / summaryData.totalDuration;
        } else if (summaryData.milestonesNum > 0) {
          return summaryData.milestonesTotalPercentDone / summaryData.milestonesNum;
        } else {
          return null;
        }
      } else {
        return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
      }
    }
    /**
     * The method defines wether the provided child event should be
     * taken into account when calculating this summary event [[percentDone]].
     *
     * If the method returns `true` the child event is taken into account
     * and if the method returns `false` it's not.
     * By default the method returns `true` to include all child events data.
     * @param childEvent Child event to consider.
     * @returns `true` if the provided event should be taken into account, `false` if not.
     */


    *shouldRollupChildPercentDoneSummaryData(childEvent) {
      return true;
    }

    *calculatePercentDoneSummaryData() {
      const childEvents = yield this.$.childEvents;

      if (childEvents.size) {
        let summary = {
          totalDuration: 0,
          completedDuration: 0,
          milestonesNum: 0,
          milestonesTotalPercentDone: 0
        };

        for (const childEvent of childEvents) {
          if (!(yield* this.shouldRollupChildPercentDoneSummaryData(childEvent))) continue;
          const childCompletedDuration = yield childEvent.$.percentDoneSummaryData;

          if (childCompletedDuration) {
            summary.totalDuration += childCompletedDuration.totalDuration;
            summary.completedDuration += childCompletedDuration.completedDuration;
            summary.milestonesNum += childCompletedDuration.milestonesNum;
            summary.milestonesTotalPercentDone += childCompletedDuration.milestonesTotalPercentDone;
          }
        }

        return summary;
      } else {
        const duration = yield this.$.duration;

        if (typeof duration == 'number') {
          const durationInMs = yield* this.getProject().$convertDuration(duration, yield this.$.durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond);
          const percentDone = yield this.$.percentDone;
          return {
            totalDuration: durationInMs,
            completedDuration: durationInMs * percentDone,
            milestonesNum: durationInMs === 0 ? 1 : 0,
            milestonesTotalPercentDone: durationInMs === 0 ? percentDone : 0
          }; // we can't calculate w/o duration
        } else {
          return null;
        }
      }
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'number',
    defaultValue: 0
  })], HasPercentDoneMixin.prototype, "percentDone", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], HasPercentDoneMixin.prototype, "percentDoneSummaryData", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('percentDone')], HasPercentDoneMixin.prototype, "calculatePercentDone", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('percentDoneSummaryData')], HasPercentDoneMixin.prototype, "calculatePercentDoneSummaryData", null);

  return HasPercentDoneMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/ScheduledByDependenciesEarlyEventMixin.js":
/*!****************************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/ScheduledByDependenciesEarlyEventMixin.js ***!
  \****************************************************************************************/
/*! exports provided: ScheduledByDependenciesEarlyEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduledByDependenciesEarlyEventMixin", function() { return ScheduledByDependenciesEarlyEventMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/HasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js");
/* harmony import */ var _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixin adds support for scheduling event ASAP, by dependencies. All it does is
 * create the constraint interval for every incoming dependency. See [[ConstrainedEarlyEventMixin]] for
 * more details about constraint-based scheduling.
 *
 * The supported dependency types are listed in this enum: [[DependencyType]]
 */

class ScheduledByDependenciesEarlyEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__["ConstrainedEarlyEventMixin"], _scheduler_basic_HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_5__["HasDependenciesMixin"]], base => {
  const superProto = base.prototype;

  class ScheduledByDependenciesEarlyEventMixin extends base {
    /**
     * The method defines wether the provided dependency should constrain the successor or not.
     * If the method returns `true` the dependency constrains the successor and does not do that when `false` returned.
     * By default the method returns `true` if the dependency is [[SchedulerProDependencyMixin.active|active]]
     * and if this event is [[inactive|active]] (or both this event and the successor are [[inactive]]).
     *
     * This is used when calculating [[earlyStartDateConstraintIntervals]].
     * @param dependency Dependency to consider.
     * @returns `true` if the dependency should constrain successor, `false` if not.
     */
    *shouldPredecessorAffectScheduling(dependency) {
      const fromEvent = yield dependency.$.fromEvent; // ignore missing from events and inactive dependencies

      return fromEvent && !Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["isAtomicValue"])(fromEvent) && (yield dependency.$.active) // ignore inactive predecessor (unless we both are inactive)
      && (!(yield fromEvent.$.inactive) || (yield this.$.inactive));
    }

    *calculateEarlyStartDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEarlyStartDateConstraintIntervals.call(this);
      const project = this.getProject();

      for (const dependency of yield this.$.incomingDeps) {
        // ignore missing from events and inactive predecessors/dependencies
        if (!(yield* this.shouldPredecessorAffectScheduling(dependency))) continue;
        const fromEvent = yield dependency.$.fromEvent;
        let interval;

        switch (yield dependency.$.type) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].EndToStart:
            const fromEventEndDate = yield fromEvent.$.earlyEndDateRaw;

            if (fromEventEndDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: calendar.calculateEndDate(fromEventEndDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond)),
                endDate: null
              });
            }

            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].StartToStart:
            const fromEventStartDate = yield fromEvent.$.earlyStartDateRaw;

            if (fromEventStartDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: calendar.calculateEndDate(fromEventStartDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond)),
                endDate: null
              });
            }

            break;
        }

        interval && intervals.unshift(interval);
      }

      return intervals;
    }

    *calculateEarlyEndDateConstraintIntervals() {
      const intervals = yield* superProto.calculateEarlyEndDateConstraintIntervals.call(this);
      const project = this.getProject();

      for (const dependency of yield this.$.incomingDeps) {
        // ignore missing from events and inactive dependencies
        if (!(yield* this.shouldPredecessorAffectScheduling(dependency))) continue;
        const fromEvent = yield dependency.$.fromEvent;
        let interval;

        switch (yield dependency.$.type) {
          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].EndToEnd:
            const fromEventEndDate = yield fromEvent.$.earlyEndDateRaw;

            if (fromEventEndDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: calendar.calculateEndDate(fromEventEndDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond)),
                endDate: null
              });
            }

            break;

          case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyType"].StartToEnd:
            const fromEventStartDate = yield fromEvent.$.earlyStartDateRaw;

            if (fromEventStartDate) {
              const lag = yield dependency.$.lag;
              const lagUnit = yield dependency.$.lagUnit;
              const calendar = yield dependency.$.calendar;
              interval = _scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_3__["DateInterval"].new({
                startDate: calendar.calculateEndDate(fromEventStartDate, yield* project.$convertDuration(lag, lagUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond)),
                endDate: null
              });
            }

            break;
        }

        interval && intervals.unshift(interval);
      }

      return intervals;
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_7__["model_field"])({
    type: 'boolean'
  })], ScheduledByDependenciesEarlyEventMixin.prototype, "inactive", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('earlyEndDateIntervals')], ScheduledByDependenciesEarlyEventMixin.prototype, "calculateEarlyEndDateConstraintIntervals", null);

  return ScheduledByDependenciesEarlyEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js":
/*!*****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js ***!
  \*****************************************************************************/
/*! exports provided: SchedulerProAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProAssignmentMixin", function() { return SchedulerProAssignmentMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler_basic/BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




class SchedulerProAssignmentMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_2__["BaseAssignmentMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProAssignmentMixin extends base {}

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_1__["model_field"])({
    type: 'number',
    defaultValue: 100
  })], SchedulerProAssignmentMixin.prototype, "units", void 0);

  return SchedulerProAssignmentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProDependencyMixin.js":
/*!*****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProDependencyMixin.js ***!
  \*****************************************************************************/
/*! exports provided: SchedulerProDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProDependencyMixin", function() { return SchedulerProDependencyMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_basic/BaseDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







 //---------------------------------------------------------------------------------------------------------------------

/**
 * A mixin for the dependency entity at the Scheduler Pro level. It adds [[lag]] and [[lagUnit]] fields.
 *
 * The calendar according to which the lag time is calculated is defined with the
 * [[SchedulerProProjectMixin.dependenciesCalendar|dependenciesCalendar]] config of the project.
 */

class SchedulerProDependencyMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_6__["BaseDependencyMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProDependencyMixin extends base {
    *calculateCalendar() {
      const project = this.getProject();
      const dependenciesCalendar = yield project.$.dependenciesCalendar;
      let calendar;

      switch (dependenciesCalendar) {
        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependenciesCalendar"].Project:
          calendar = yield project.$.effectiveCalendar;
          break;

        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependenciesCalendar"].FromEvent:
          const fromEvent = yield this.$.fromEvent;
          calendar = fromEvent && !Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["isAtomicValue"])(fromEvent) ? yield fromEvent.$.effectiveCalendar : null;
          break;

        case _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependenciesCalendar"].ToEvent:
          const toEvent = yield this.$.toEvent;
          calendar = toEvent && !Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_2__["isAtomicValue"])(toEvent) ? yield toEvent.$.effectiveCalendar : null;
          break;
      } // the only case when there will be no calendar is when there's no either from/to event
      // what to return in such case? use project calendar as "defensive" approach


      if (!calendar) calendar = yield project.$.effectiveCalendar;
      return calendar;
    }
    /**
     * Setter for the [[lag]]. Can also set [[lagUnit]] if second argument is provided.
     *
     * @param lag
     * @param unit
     */


    async setLag(lag, unit) {
      if (this.graph) {
        this.graph.write(this.$.lag, lag, unit);
        return this.graph.commitAsync();
      } else {
        this.$.lag.DATA = lag;
        if (unit != null) this.$.lagUnit.DATA = unit;
      }
    }

    writeLag(me, transaction, quark, lag, unit = undefined) {
      me.constructor.prototype.write.call(this, me, transaction, quark, lag);
      if (unit != null) transaction.write(this.$.lagUnit, unit);
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'number',
    defaultValue: 0
  })], SchedulerProDependencyMixin.prototype, "lag", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["TimeUnit"].Day
  }, {
    converter: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalizeUnit
  })], SchedulerProDependencyMixin.prototype, "lagUnit", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])()], SchedulerProDependencyMixin.prototype, "calendar", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
    type: 'boolean',
    defaultValue: true,
    persist: false
  })], SchedulerProDependencyMixin.prototype, "active", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('calendar')], SchedulerProDependencyMixin.prototype, "calculateCalendar", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["write"])('lag')], SchedulerProDependencyMixin.prototype, "writeLag", null);

  return SchedulerProDependencyMixin;
}) {} // /**
//  * Dependency entity mixin type
//  */
// export type SchedulerProDependencyMixin = Mixin<typeof SchedulerProDependencyMixin>
//
// export interface SchedulerProDependencyMixinI extends Mixin<typeof SchedulerProDependencyMixin> {}
//
// export const BuildSchedulerProDependency = (base) => SchedulerProDependencyMixin(BuildMinimalBaseDependency(base))
//
// export class MinimalSchedulerProDependency extends SchedulerProDependencyMixin(MinimalBaseDependency) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProEvent.js":
/*!*******************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProEvent.js ***!
  \*******************************************************************/
/*! exports provided: SchedulerProEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProEvent", function() { return SchedulerProEvent; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler_basic/SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
/* harmony import */ var _HasDateConstraintMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./HasDateConstraintMixin.js */ "./lib/Engine/quark/model/scheduler_pro/HasDateConstraintMixin.js");
/* harmony import */ var _HasPercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./HasPercentDoneMixin.js */ "./lib/Engine/quark/model/scheduler_pro/HasPercentDoneMixin.js");
/* harmony import */ var _ScheduledByDependenciesEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ScheduledByDependenciesEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ScheduledByDependenciesEarlyEventMixin.js");
/* harmony import */ var _SchedulerProHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SchedulerProHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProHasAssignmentsMixin.js");
var productName = 'gantt';







/**
 * This is an event class, [[SchedulerProProjectMixin]] is working with.
 * It is constructed as [[SchedulerBasicEvent]], enhanced with extra functionality.
 */

class SchedulerProEvent extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerBasicEvent"], _HasDateConstraintMixin_js__WEBPACK_IMPORTED_MODULE_3__["HasDateConstraintMixin"], _HasPercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_4__["HasPercentDoneMixin"], _SchedulerProHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_6__["SchedulerProHasAssignmentsMixin"], _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["ConstrainedEarlyEventMixin"], _ScheduledByDependenciesEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_5__["ScheduledByDependenciesEarlyEventMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProEvent extends base {}

  return SchedulerProEvent;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProHasAssignmentsMixin.js":
/*!*********************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProHasAssignmentsMixin.js ***!
  \*********************************************************************************/
/*! exports provided: SchedulerProHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProHasAssignmentsMixin", function() { return SchedulerProHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../calendar/CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/BaseHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






 //---------------------------------------------------------------------------------------------------------------------

/**
 * This mixins enhances the purely visual [[BaseHasAssignmentsMixin]] with scheduling according
 * to the calendars of the assigned resources.
 *
 * A time interval will be "counted" into the event duration, only if at least one assigned
 * resource has that interval as working time, and the event's own calendar also has that interval
 * as working. Otherwise the time is skipped and not counted into event's duration.
 */

class SchedulerProHasAssignmentsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_basic_BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_5__["BaseHasAssignmentsMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProHasAssignmentsMixin extends base {
    /**
     * A method which assigns a resource to the current event
     */
    async assign(resource, units = 100) {
      const assignmentCls = this.getProject().assignmentStore.modelClass;
      this.addAssignment(new assignmentCls({
        event: this,
        resource: resource,
        units: units
      }));
      return this.commitAsync();
    }

    *forEachAvailabilityInterval(options, func) {
      const calendar = yield this.$.effectiveCalendar;
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      const effectiveCalendarsCombination = yield this.$.effectiveCalendarsCombination;
      return effectiveCalendarsCombination.forEachAvailabilityInterval(options, (startDate, endDate, calendarCacheIntervalMultiple) => {
        const calendarsStatus = calendarCacheIntervalMultiple.getCalendarsWorkStatus();
        const workCalendars = calendarCacheIntervalMultiple.getCalendarsWorking();

        if (calendarsStatus.get(calendar) && (options.ignoreResourceCalendars || workCalendars.some(calendar => assignmentsByCalendar.has(calendar)))) {
          return func(startDate, endDate, calendarCacheIntervalMultiple);
        }
      });
    } // TODO seems this atom is used in single place only - can be merged there


    *calculateEffectiveCalendarsCombination() {
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;
      const calendars = [...assignmentsByCalendar.keys(), yield this.$.effectiveCalendar];
      return this.getProject().combineCalendars(calendars);
    }

    *calculateAssignmentsByCalendar() {
      const assignments = yield this.$.assigned;
      const result = new Map();

      for (const assignment of assignments) {
        const resource = yield assignment.$.resource;

        if (resource) {
          const resourceCalendar = yield resource.$.effectiveCalendar;
          let assignments = result.get(resourceCalendar);

          if (!assignments) {
            assignments = [];
            result.set(resourceCalendar, assignments);
          }

          assignments.push(assignment);
        }
      }

      return result;
    }

    *getBaseOptionsForDurationCalculations() {
      return {
        ignoreResourceCalendars: false
      };
    }

    *skipNonWorkingTime(date, isForward = true) {
      if (!date) return null;
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;

      if (assignmentsByCalendar.size > 0) {
        const options = Object.assign(yield* this.getBaseOptionsForDurationCalculations(), isForward ? {
          startDate: date,
          isForward
        } : {
          endDate: date,
          isForward
        });
        let workingDate;
        const skipRes = yield* this.forEachAvailabilityInterval(options, (startDate, endDate, calendarCacheIntervalMultiple) => {
          workingDate = isForward ? startDate : endDate;
          return false;
        });

        if (skipRes === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_3__["CalendarIteratorResult"].MaxRangeReached || skipRes === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_3__["CalendarIteratorResult"].FullRangeIterated) {
          yield Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["Reject"])("Empty calendar");
        }

        return new Date(workingDate);
      } else {
        return yield* superProto.skipNonWorkingTime.call(this, date, isForward);
      }
    }

    *calculateProjectedDuration(startDate, endDate, durationUnit) {
      if (!startDate || !endDate) {
        return null;
      }

      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;

      if (assignmentsByCalendar.size > 0) {
        const options = Object.assign(yield* this.getBaseOptionsForDurationCalculations(), {
          startDate,
          endDate,
          isForward: true
        });
        let result = 0;
        yield* this.forEachAvailabilityInterval(options, (startDate, endDate) => {
          result += endDate.getTime() - startDate.getTime();
        });
        if (!durationUnit) durationUnit = yield this.$.durationUnit;
        return yield* this.getProject().$convertDuration(result, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond, durationUnit);
      } else {
        return yield* superProto.calculateProjectedDuration.call(this, startDate, endDate, durationUnit);
      }
    }

    *calculateProjectedXDateWithDuration(baseDate, isForward = true, duration) {
      if (duration == null || isNaN(duration) || baseDate == null) return null;
      if (duration == 0) return baseDate;
      const durationUnit = yield this.$.durationUnit;
      const durationMS = yield* this.getProject().$convertDuration(duration, durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Millisecond);
      let resultN = baseDate.getTime();
      let leftDuration = durationMS;
      const calendar = yield this.$.effectiveCalendar;
      const assignmentsByCalendar = yield this.$.assignmentsByCalendar;

      if (assignmentsByCalendar.size > 0) {
        const options = Object.assign(yield* this.getBaseOptionsForDurationCalculations(), isForward ? {
          startDate: baseDate,
          isForward
        } : {
          endDate: baseDate,
          isForward
        });
        yield* this.forEachAvailabilityInterval(options, (intervalStart, intervalEnd, calendarCacheIntervalMultiple) => {
          const intervalStartN = intervalStart.getTime(),
                intervalEndN = intervalEnd.getTime(),
                intervalDuration = intervalEndN - intervalStartN;

          if (intervalDuration >= leftDuration) {
            resultN = isForward ? intervalStartN + leftDuration : intervalEndN - leftDuration;
            return false;
          } else {
            leftDuration -= intervalDuration;

            if (this.getProject().adjustDurationToDST) {
              const dstDiff = intervalStart.getTimezoneOffset() - intervalEnd.getTimezoneOffset();
              leftDuration -= dstDiff * 60 * 1000;
            }
          }
        });
        return new Date(resultN);
      } else {
        return calendar.accumulateWorkingTime(baseDate, durationMS, isForward).finalDate;
      }
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], SchedulerProHasAssignmentsMixin.prototype, "effectiveCalendarsCombination", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["field"])()], SchedulerProHasAssignmentsMixin.prototype, "assignmentsByCalendar", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('effectiveCalendarsCombination')], SchedulerProHasAssignmentsMixin.prototype, "calculateEffectiveCalendarsCombination", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_2__["calculate"])('assignmentsByCalendar')], SchedulerProHasAssignmentsMixin.prototype, "calculateAssignmentsByCalendar", null);

  return SchedulerProHasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js":
/*!**************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js ***!
  \**************************************************************************/
/*! exports provided: SchedulerProProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProProjectMixin", function() { return SchedulerProProjectMixin; });
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../ChronoGraph/collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _scheduler_basic_SchedulerBasicProjectMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/SchedulerBasicProjectMixin.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js");
/* harmony import */ var _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ConstrainedEarlyEventMixin.js */ "./lib/Engine/quark/model/scheduler_pro/ConstrainedEarlyEventMixin.js");
/* harmony import */ var _SchedulerProDependencyMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SchedulerProDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProDependencyMixin.js");
/* harmony import */ var _SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./SchedulerProEvent.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProEvent.js");
/* harmony import */ var _SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./SchedulerProAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js");
/* harmony import */ var _SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./SchedulerProResourceMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











 //---------------------------------------------------------------------------------------------------------------------

/**
 * Scheduler Pro project mixin type. At this level, events are scheduled according to the incoming dependencies
 * and calendars of the assigned resources.
 *
 * The base event class for this level is [[SchedulerProEvent]]. The base dependency class is [[SchedulerProDependencyMixin]]
 */

class SchedulerProProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_scheduler_basic_SchedulerBasicProjectMixin_js__WEBPACK_IMPORTED_MODULE_5__["SchedulerBasicProjectMixin"], _ConstrainedEarlyEventMixin_js__WEBPACK_IMPORTED_MODULE_6__["ConstrainedEarlyEventMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProProjectMixin extends base {
    construct(config = {}) {
      superProto.construct.call(this, config);
      if (!this.resourceAllocationInfoClass) this.resourceAllocationInfoClass = this.getDefaultResourceAllocationInfoClass();
    }

    getDefaultResourceAllocationInfoClass() {
      return _SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__["ResourceAllocationInfo"];
    }

    *calculateDirection() {
      return yield _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_0__["ProposedOrPrevious"];
    }

    getType() {
      return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["ProjectType"].SchedulerPro;
    }

    getDefaultEventModelClass() {
      return _SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_8__["SchedulerProEvent"];
    }

    getDefaultDependencyModelClass() {
      return _SchedulerProDependencyMixin_js__WEBPACK_IMPORTED_MODULE_7__["SchedulerProDependencyMixin"];
    }

    getDefaultAssignmentModelClass() {
      return _SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_9__["SchedulerProAssignmentMixin"];
    }

    getDefaultResourceModelClass() {
      return _SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__["SchedulerProResourceMixin"];
    }
    /**
     * Validates a hypothetical dependency with provided parameters.
     *
     * ```ts
     * // let's check if a EndToStart dependency linking event1 with event2 will be valid
     * const validationResult = await project.validateDependency(event1, event2, DependencyType.EndToStart);
     *
     * switch (validationResult) {
     *     const DependencyValidationResult.CyclicDependency :
     *         console.log('Dependency builds a cycle');
     *         break;
     *
     *     const DependencyValidationResult.DuplicatingDependency :
     *         console.log('Such dependency already exists');
     *         break;
     *
     *     const DependencyValidationResult.NoError :
     *         console.log('Dependency is valid');
     * }
     * ```
     *
     * See also [[isValidDependency]] method for more basic usage.
     *
     * @param fromEvent The dependency predecessor
     * @param toEvent The dependency successor
     * @param type The dependency type
     * @param ignoreDependency Dependencies to ignore while validating. This parameter can be used for example if one plans to change
     * an existing dependency properties and wants to know if the change will lead to an error:
     *
     * ```ts
     * // let's check if changing of the dependency predecessor to newPredecessor will make it invalid
     * const validationResult = await project.validateDependency(newPredecessor, dependency.toEvent, dependency.type, dependency);
     *
     * if (validationResult !== DependencyValidationResult.NoError) console.log("The dependency is invalid");
     * ```
     * @return The validation result
     */


    async validateDependency(fromEvent, toEvent, type, ignoreDependency) {
      let ingoredDependencies;

      if (ignoreDependency) {
        ingoredDependencies = Array.isArray(ignoreDependency) ? ignoreDependency : [ignoreDependency];
      }

      const alreadyLinked = Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_2__["CI"])(fromEvent.outgoingDeps).some(dependency => dependency.toEvent === toEvent && !(ingoredDependencies === null || ingoredDependencies === void 0 ? void 0 : ingoredDependencies.includes(dependency)));
      if (alreadyLinked) return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyValidationResult"].DuplicatingDependency;

      if (await this.isDependencyCyclic(fromEvent, toEvent, type, ingoredDependencies)) {
        return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyValidationResult"].CyclicDependency;
      }

      return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyValidationResult"].NoError;
    }
    /**
     * Validates a hypothetical dependency with provided parameters.
     *
     * ```ts
     * // let's check if a EndToStart dependency linking event1 with event2 will be valid
     * if (await project.isValidDependency(event1, event2, DependencyType.EndToStart)) {
     *     console.log('Dependency is valid');
     * } else {
     *     console.log('Dependency is invalid');
     * }
     * ```
     *
     * See also [[validateDependency]] method for more detailed validation results.
     *
     * @param fromEvent The dependency predecessor
     * @param toEvent The dependency successor
     * @param type The dependency type
     * @param ignoreDependency Dependencies to ignore while validating. This parameter can be used for example if one plans to change
     * an existing dependency properties and wants to know if the change will lead to an error:
     *
     * ```ts
     * // let's check if changing of the dependency predecessor to newPredecessor will make it invalid
     * if (await project.isValidDependency(newPredecessor, dependency.toEvent, dependency.type, dependency)) console.log("The dependency is valid");
     * ```
     * @return The validation result
     */
    // this does not account for possible scheduling conflicts


    async isValidDependency(fromEvent, toEvent, type, ignoreDependency) {
      const validationResult = await this.validateDependency(fromEvent, toEvent, type, ignoreDependency);
      return validationResult === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependencyValidationResult"].NoError;
    }

    getDependencyCycleDetectionIdentifiers(fromEvent, toEvent) {
      return [// @ts-ignore
      toEvent.$.earlyStartDateConstraintIntervals, // @ts-ignore
      toEvent.$.earlyEndDateConstraintIntervals];
    }

    async isDependencyCyclic(fromEvent, toEvent, type, ignoreDependency) {
      const dependencyClass = this.getDependencyStore().modelClass;
      const dependency = new dependencyClass({
        fromEvent,
        toEvent,
        type
      });
      const branch = this.replica.branch({
        autoCommit: false,
        onComputationCycle: 'throw'
      });

      if (ignoreDependency) {
        if (!Array.isArray(ignoreDependency)) {
          ignoreDependency = [ignoreDependency];
        }

        ignoreDependency.forEach(dependency => branch.removeEntity(dependency));
      }

      branch.addEntity(dependency);
      dependency.project = this; // search for identifiers reading of which finds a cycle
      // for (const i of Object.keys(toEvent.$)) {
      //     try {
      //         await branch.readAsync(toEvent.$[i])
      //     } catch (e) {
      //         if (/cycle/i.test(e)) {
      //             // dump found identifier names to console
      //             console.log(i)
      //         }
      //         else
      //             throw e
      //     }
      // }

      try {
        await Promise.all(this.getDependencyCycleDetectionIdentifiers(fromEvent, toEvent).map(i => branch.readAsync(i)));
        return false;
      } catch (e) {
        // return true for the cycle exception and re-throw all others
        if (/cycle/i.test(e)) return true;
        throw e;
      }
    } // work in progress
    // This method validates changes (e.g. type) for existing dependencies (which are already in the store)


    async isValidDependencyModel(dependency, ignoreDependencies) {
      return this.isValidDependency(dependency.fromEvent, dependency.toEvent, dependency.type, ignoreDependencies);
    }

  }

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["DependenciesCalendar"].ToEvent
  })], SchedulerProProjectMixin.prototype, "dependenciesCalendar", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'boolean',
    defaultValue: true
  })], SchedulerProProjectMixin.prototype, "autoCalculatePercentDoneForParentTasks", void 0);

  return SchedulerProProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js ***!
  \***************************************************************************/
/*! exports provided: ResourceAllocationEventRangeCalendarIntervalMixin, ResourceAllocationEventRangeCalendarIntervalStore, ResourceAllocationEventRangeCalendar, ResourceAllocationInterval, ResourceAllocationInfo, SchedulerProResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceAllocationEventRangeCalendarIntervalMixin", function() { return ResourceAllocationEventRangeCalendarIntervalMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceAllocationEventRangeCalendarIntervalStore", function() { return ResourceAllocationEventRangeCalendarIntervalStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceAllocationEventRangeCalendar", function() { return ResourceAllocationEventRangeCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceAllocationInterval", function() { return ResourceAllocationInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceAllocationInfo", function() { return ResourceAllocationInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerProResourceMixin", function() { return SchedulerProResourceMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../calendar/CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
/* harmony import */ var _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../calendar/CalendarIntervalStore.js */ "./lib/Engine/calendar/CalendarIntervalStore.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scheduler_basic/BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scheduler_basic/BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








class ResourceAllocationEventRangeCalendarIntervalMixin extends _calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIntervalMixin"] {
  // @model_field({ type : 'boolean', defaultValue : true })
  // isWorking : boolean
  // Calendar classes not entering graph, thus not using @model_field
  static get fields() {
    return [{
      name: 'isWorking',
      type: 'boolean',
      defaultValue: true
    }];
  }

}
class ResourceAllocationEventRangeCalendarIntervalStore extends _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_3__["CalendarIntervalStore"] {
  static get defaultConfig() {
    return {
      modelClass: ResourceAllocationEventRangeCalendarIntervalMixin
    };
  }

}
class ResourceAllocationEventRangeCalendar extends _scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_5__["BaseCalendarMixin"] {
  get intervalStoreClass() {
    return ResourceAllocationEventRangeCalendarIntervalStore;
  }

}

__decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_4__["model_field"])({
  type: 'boolean',
  defaultValue: false
})], ResourceAllocationEventRangeCalendar.prototype, "unspecifiedTimeIsWorking", void 0);
/**
 * Resource allocation information for a certain tick.
 */


class ResourceAllocationInterval extends _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  constructor() {
    super(...arguments);
    /**
     * Resource assignments ingoing in the [[tick|interval]].
     */

    this.assignments = null;
    /**
     * Resource effort in the [[tick|interval]] in milliseconds.
     */

    this.effort = 0;
    /**
     * Maximum possible resource effort in the [[tick|interval]] in milliseconds.
     */

    this.maxEffort = 0;
    /**
     * Resource utilization level in percent.
     */

    this.units = 0;
    /**
     * Indicates that the resource is over-allocated in the [[tick|interval]].
     * So `true` when [[effort]] is more than [[maxEffort|possible maximum]].
     */

    this.isOverallocated = false;
    /**
     * Indicates that the resource is under-allocated in the [[tick|interval]].
     * So `true` when [[effort]] is less than [[maxEffort|possible maximum]].
     */

    this.isUnderallocated = false;
  }

}
/**
 * Class implementing _resource allocation report_ - a data representing the provided [[resource]]
 * utilization in the provided period of time.
 * The data is grouped by the provided [[ticks|time intervals]]
 */

class ResourceAllocationInfo extends _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["Entity"].mix(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Base"]) {
  initialize(props) {
    props = Object.assign({
      includeInactiveEvents: false
    }, props);
    super.initialize(props);
  }

  *shouldIncludeAssignmentInAllocation(assignment) {
    const event = yield assignment.$.event,
          units = yield assignment.$.units,
          includeInactiveEvents = yield this.$.includeInactiveEvents,
          inactive = event && (yield event.$.inactive),
          // includeInactiveEvents
    startDate = event && (yield event.$.startDate),
          endDate = event && (yield event.$.endDate);
    return Boolean(event && units && startDate && endDate && (includeInactiveEvents || !inactive));
  }

  *calculateAllocation() {
    const result = [],
          ticksCalendar = yield this.ticks,
          //$.ticks,
    resource = yield this.$.resource,
          includeInactiveEvents = yield this.$.includeInactiveEvents,
          assignments = yield resource.$.assigned,
          assignmentsByCalendar = new Map(),
          eventRanges = []; // collect the resource assignments into assignmentsByCalendar map

    for (const assignment of assignments) {
      // skip missing or unscheduled event assignments
      if (!(yield* this.shouldIncludeAssignmentInAllocation(assignment))) continue; // we're going to need up-to-date assignment "units" below in this method ..so we yield it here

      yield assignment.$.units;
      const event = yield assignment.$.event,
            startDate = yield event.$.startDate,
            endDate = yield event.$.endDate;
      eventRanges.push({
        startDate,
        endDate,
        assignment
      });
      const eventCalendar = yield event.$.effectiveCalendar;
      let assignments = assignmentsByCalendar.get(eventCalendar);

      if (!assignments) {
        assignments = [];
        assignmentsByCalendar.set(eventCalendar, assignments);
      }

      assignments.push(assignment);
    }

    const eventRangesCalendar = new ResourceAllocationEventRangeCalendar({
      intervals: eventRanges
    }); // Provide extra calendars:
    // 1) a calendar containing list of ticks to group the resource allocation by
    // 2) a calendar containing list of assigned event start/end ranges
    // 3) assigned task calendars

    const calendars = [ticksCalendar, eventRangesCalendar, ...assignmentsByCalendar.keys()];
    const ticksData = new Map(); // Initialize the resulting array with empty items

    ticksCalendar.intervalStore.forEach(tick => {
      const tickData = ResourceAllocationInterval.new({
        tick,
        resource
      });
      ticksData.set(tick, tickData);
      result.push(tickData);
    });
    let weightedUnitsSum, weightsSum;
    yield* resource.forEachAvailabilityInterval({
      startDate: result[0].tick.startDate,
      endDate: result[result.length - 1].tick.endDate,
      calendars
    }, (intervalStartDate, intervalEndDate, intervalData) => {
      const isWorkingCalendar = intervalData.getCalendarsWorkStatus(); // We are inside a tick interval and it's a working time according
      // to a resource calendar

      if (isWorkingCalendar.get(ticksCalendar)) {
        const tick = intervalData.intervalsByCalendar.get(ticksCalendar)[0],
              intervalDuration = intervalEndDate.getTime() - intervalStartDate.getTime(),
              tickData = ticksData.get(tick),
              tickAssignments = tickData.assignments || new Set();

        if (!tickData.assignments) {
          weightedUnitsSum = 0;
          weightsSum = 0;
        }

        let units = 0,
            duration;
        intervalData.intervalsByCalendar.get(eventRangesCalendar).forEach(interval => {
          const assignment = interval.assignment; // TODO:
          // We don't do yield "assignment.event.*" expressions since we did it previously
          // while looping the assignments because we cannot yield from the iterator callback

          if (assignment && isWorkingCalendar.get(assignment.event.effectiveCalendar)) {
            // constrain the event start/end with the tick borders
            const workingStartDate = Math.max(intervalStartDate.getTime(), assignment.event.startDate.getTime());
            const workingEndDate = Math.min(intervalEndDate.getTime(), assignment.event.endDate.getTime());
            duration = workingEndDate - workingStartDate;
            tickData.effort += duration * assignment.units / 100; // collect total resource usage percent in the current interval

            units += assignment.units;
            tickAssignments.add(assignment);
          }
        });
        tickData.maxEffort += intervalDuration; // if we have assignments running in the interval - calculate average allocation %

        if (units) {
          if (duration) {
            // keep weightedUnitsSum & weightsSum since there might be another intervals in the tick
            weightedUnitsSum += duration * units;
            weightsSum += duration; // "units" weighted arithmetic mean w/ duration values as weights

            tickData.units = weightedUnitsSum / weightsSum;
          } else if (!weightedUnitsSum) {
            tickData.units = units;
          }
        }

        if (tickAssignments.size) {
          tickData.assignments = tickAssignments;
          tickData.isOverallocated = tickData.isOverallocated || units > 100;
          tickData.isUnderallocated = tickData.isUnderallocated || units < 100;
        }
      }
    });
    return result;
  }

}

__decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])()], ResourceAllocationInfo.prototype, "resource", void 0);

__decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])()], ResourceAllocationInfo.prototype, "includeInactiveEvents", void 0);

__decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])()], ResourceAllocationInfo.prototype, "allocation", void 0);

__decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('allocation')], ResourceAllocationInfo.prototype, "calculateAllocation", null);
/**
 * A mixin for the resource entity at the Scheduler Pro level.
 */


class SchedulerProResourceMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_6__["BaseResourceMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerProResourceMixin extends base {
    constructor() {
      super(...arguments);
      this.observers = new Set();
      this.entities = new Set();
    }

    leaveGraph(replica) {
      const {
        graph
      } = this;

      for (const entity of this.entities) {
        graph.removeEntity(entity);
      }

      for (const observer of this.observers) {
        graph.removeIdentifier(observer);
      }

      superProto.leaveGraph.call(this, replica);
    }

    *forEachAvailabilityInterval(options, func) {
      const calendar = yield this.$.effectiveCalendar;
      const effectiveCalendarsCombination = this.getProject().combineCalendars([calendar].concat(options.calendars || []));
      return effectiveCalendarsCombination.forEachAvailabilityInterval(options, (startDate, endDate, calendarCacheIntervalMultiple) => {
        const calendarsStatus = calendarCacheIntervalMultiple.getCalendarsWorkStatus();

        if (calendarsStatus.get(calendar)) {
          return func(startDate, endDate, calendarCacheIntervalMultiple);
        }
      });
    }

  }

  return SchedulerProResourceMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractAssignmentStoreMixin", function() { return AbstractAssignmentStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");
var productName = 'gantt';


 // Shared functionality for CoreAssignmentStore & ChronoAssignmentStore

class AbstractAssignmentStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractAssignmentStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
      this.allAssignmentsForRemoval = false;
    }

    remove(records, silent) {
      this.assignmentsForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_2__["CIFromSetOrArrayOrValue"])(records).toSet();
      const res = superProto.remove.call(this, records);
      this.assignmentsForRemoval.clear();
      return res;
    }

    removeAll(silent) {
      this.allAssignmentsForRemoval = true;
      const res = superProto.removeAll.call(this, silent);
      this.allAssignmentsForRemoval = false;
      return res;
    }

  }

  return AbstractAssignmentStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: AbstractCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarManagerStoreMixin", function() { return AbstractCalendarManagerStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';

 // Shared functionality for CoreCalendarManagerStoreMixin & ChronoCalendarManagerStoreMixin

class AbstractCalendarManagerStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractCalendarManagerStoreMixin extends base {
    // special handling to destroy calendar models as part of destroying this store
    doDestroy() {
      const records = [];
      this.traverse(record => records.push(record));
      super.doDestroy();
      records.forEach(record => record.destroy());
    }

  }

  return AbstractCalendarManagerStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractDependencyStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractDependencyStoreMixin", function() { return AbstractDependencyStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");
var productName = 'gantt';


 // Shared functionality for CoreDependencyStore & ChronoDependencyStore

class AbstractDependencyStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractDependencyStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.dependenciesForRemoval = new Set();
      this.allDependenciesForRemoval = false;
    }

    remove(records, silent) {
      this.dependenciesForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_2__["CIFromSetOrArrayOrValue"])(records).toSet();
      const res = superProto.remove.call(this, records);
      this.dependenciesForRemoval.clear();
      return res;
    }

    removeAll(silent) {
      this.allDependenciesForRemoval = true;
      const res = superProto.removeAll.call(this, silent);
      this.allDependenciesForRemoval = false;
      return res;
    }

  }

  return AbstractDependencyStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: AbstractEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractEventStoreMixin", function() { return AbstractEventStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';

 // Shared functionality for CoreEventStore & ChronoEventStore

class AbstractEventStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractEventStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
      this.dependenciesForRemoval = new Set();
    } // we need `onDataChange` for `syncDataOnLoad` option to work


    onDataChange(event) {
      var _a;

      super.onDataChange(event);
      if ((_a = event.removed) === null || _a === void 0 ? void 0 : _a.length) this.afterEventRemoval();
    } // it seems `onDataChange` is not triggered for `remove` with `silent` flag


    remove(records, silent) {
      const res = superProto.remove.call(this, records);
      this.afterEventRemoval();
      return res;
    } // it seems `onDataChange` is not triggered for `TreeStore#removeAll()`


    removeAll(silent) {
      const res = superProto.removeAll.call(this, silent);
      this.afterEventRemoval();
      return res;
    }

    afterEventRemoval() {
      const {
        assignmentsForRemoval,
        dependenciesForRemoval
      } = this; // Can be called from `set data` during construction

      if (!assignmentsForRemoval) return; // ORDER IS IMPORTANT!
      // First remove assignments

      const assignmentStore = this.getAssignmentStore();

      if (assignmentStore && !assignmentStore.allAssignmentsForRemoval && assignmentsForRemoval.size) {
        const toRemove = [...assignmentsForRemoval].filter(assignment => !assignmentStore.assignmentsForRemoval.has(assignment));
        toRemove.length > 0 && assignmentStore.remove(toRemove);
      }

      assignmentsForRemoval.clear(); // Then remove dependencies

      const dependencyStore = this.getDependencyStore();

      if (dependencyStore && !dependencyStore.allDependenciesForRemoval && dependenciesForRemoval.size) {
        const toRemove = [...dependenciesForRemoval].filter(dependency => !dependencyStore.dependenciesForRemoval.has(dependency));
        toRemove.length > 0 && dependencyStore.remove(toRemove);
      }

      dependenciesForRemoval.clear();
    }

    processRecord(eventRecord, isDataset = false) {
      var _a;

      if (!((_a = this.project) === null || _a === void 0 ? void 0 : _a.isRepopulatingStores)) {
        const existingRecord = this.getById(eventRecord.id);
        const isReplacing = existingRecord && existingRecord !== eventRecord;

        if (isReplacing) {
          // TODO: Type
          //@ts-ignore
          for (const assignment of existingRecord.assigned) {
            assignment.event = eventRecord;
          }
        }
      }

      return eventRecord;
    }

  }

  return AbstractEventStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractResourceStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: AbstractResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractResourceStoreMixin", function() { return AbstractResourceStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';

 // Shared functionality for CoreResourceStore & ChronoResourceStore

class AbstractResourceStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractResourceStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
    } // we need `onDataChange` for `syncDataOnLoad` option to work


    onDataChange(event) {
      var _a;

      super.onDataChange(event);
      if ((_a = event.removed) === null || _a === void 0 ? void 0 : _a.length) this.afterResourceRemoval();
    } // it seems `onDataChange` is not triggered for `remove` with `silent` flag


    remove(records, silent) {
      const res = superProto.remove.call(this, records);
      this.afterResourceRemoval();
      return res;
    } // it seems `onDataChange` is not triggered for `TreeStore#removeAll()`


    removeAll(silent) {
      const res = superProto.removeAll.call(this, silent);
      this.afterResourceRemoval();
      return res;
    }

    afterResourceRemoval() {
      // TODO: Ask nick, have tried making it get correct type by changing AbstractProjectMixin. But no luck
      const assignmentStore = this.getAssignmentStore();

      if (assignmentStore && !assignmentStore.allAssignmentsForRemoval) {
        const assignmentsForRemoval = [...this.assignmentsForRemoval].filter(assignment => !assignmentStore.assignmentsForRemoval.has(assignment));
        assignmentsForRemoval.length > 0 && assignmentStore.remove(assignmentsForRemoval);
      }

      this.assignmentsForRemoval.clear();
    }

    processRecord(resourceRecord, isDataset = false) {
      const existingRecord = this.getById(resourceRecord.id);
      const isReplacing = existingRecord && existingRecord !== resourceRecord;

      if (isReplacing) {
        // TODO: There is no ResourceMixin at the lowest level, cannot type correctly without it
        //@ts-ignore
        for (const assignment of existingRecord.assigned) {
          assignment.resource = resourceRecord;
        }
      }

      return resourceRecord;
    }

  }

  return AbstractResourceStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: ChronoAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoAssignmentStoreMixin", function() { return ChronoAssignmentStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_basic/BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all assignments in the [[SchedulerBasicProjectMixin|project]].
 */

class ChronoAssignmentStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractAssignmentStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoAssignmentStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_1__["BaseAssignmentMixin"]
      };
    }

    set data(value) {
      this.allAssignmentsForRemoval = true;
      super.data = value;
      this.allAssignmentsForRemoval = false;
    }

  }

  return ChronoAssignmentStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js":
/*!*******************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js ***!
  \*******************************************************************/
/*! exports provided: ChronoCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoCalendarManagerStoreMixin", function() { return ChronoCalendarManagerStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_basic/BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all calendars in the [[SchedulerBasicProjectMixin|project]].
 */

class ChronoCalendarManagerStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractCalendarManagerStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoCalendarManagerStoreMixin extends base {
    static get defaultConfig() {
      return {
        tree: true,
        modelClass: _model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_1__["BaseCalendarMixin"]
      };
    }

  }

  return ChronoCalendarManagerStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoDependencyStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: ChronoDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoDependencyStoreMixin", function() { return ChronoDependencyStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");
var productName = 'gantt';



/**
 * A store mixin class, that represent collection of all dependencies in the [[SchedulerBasicProjectMixin|project]].
 */

class ChronoDependencyStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractDependencyStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["ChronoPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoDependencyStoreMixin extends base {
    set data(value) {
      this.allDependenciesForRemoval = true;
      super.data = value;
      this.allDependenciesForRemoval = false;
    }

  }

  return ChronoDependencyStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoEventStoreMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoEventStoreMixin.js ***!
  \*********************************************************/
/*! exports provided: ChronoEventStoreMixin, ChronoEventTreeStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoEventStoreMixin", function() { return ChronoEventStoreMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoEventTreeStoreMixin", function() { return ChronoEventTreeStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_basic/SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all events in the [[SchedulerBasicProjectMixin|project]].
 */

class ChronoEventStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractEventStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoEventStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerBasicEvent"]
      };
    }

    set data(value) {
      super.data = value;
      this.afterEventRemoval();
    }

  }

  return ChronoEventStoreMixin;
}) {}
/**
 * The tree store version of [[ChronoEventStoreMixin]].
 */

class ChronoEventTreeStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([ChronoEventStoreMixin], base => {
  const superProto = base.prototype;

  class ChronoEventTreeStoreMixin extends base {
    buildRootNode() {
      return this.getProject() || {};
    }

    static get defaultConfig() {
      return {
        tree: true
      };
    }

  }

  return ChronoEventTreeStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoResourceStoreMixin.js ***!
  \************************************************************/
/*! exports provided: ChronoResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoResourceStoreMixin", function() { return ChronoResourceStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_basic/BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all resources in the [[SchedulerBasicProjectMixin|project]].
 */

class ChronoResourceStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractResourceStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoResourceStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_1__["BaseResourceMixin"]
      };
    }

  }

  return ChronoResourceStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreAssignmentStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentStoreMixin", function() { return CoreAssignmentStoreMixin; });
/* harmony import */ var _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");
var productName = 'gantt';




const emptySet = new Set();
/**
 * A store mixin class, that represent collection of all assignments in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreAssignmentStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractAssignmentStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreAssignmentStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.skipInvalidateIndices = false;
    }

    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_0__["CoreAssignmentMixin"],
        storage: {
          extraKeys: [{
            property: 'event',
            unique: false
          }, {
            property: 'resource',
            unique: false
          }, {
            property: 'eventId',
            unique: false
          }]
        }
      };
    }

    set data(value) {
      this.allAssignmentsForRemoval = true;
      super.data = value;
      this.allAssignmentsForRemoval = false;
    }

    getEventsAssignments(event) {
      return this.storage.findItem('event', event) || emptySet;
    }

    getResourcesAssignments(resource) {
      return this.storage.findItem('resource', resource) || emptySet;
    }

    updateIndices() {
      this.storage.rebuildIndices();
    }

    invalidateIndices() {
      this.storage.invalidateIndices();
    } // Link events/resources to assignments, called when those stores are populated or joined to project


    linkAssignments(store, modelName) {
      const unresolved = this.count && this.storage.findItem(modelName, null);

      if (unresolved) {
        for (const assignment of unresolved) {
          const record = store.getById(assignment.getCurrentOrProposed(modelName));
          if (record) assignment.setChanged(modelName, record);
        }

        this.invalidateIndices();
      }
    } // Unlink events/resources from assignments, called when those stores are cleared


    unlinkAssignments(modelName) {
      // Invalidate links to events/resources, need to link to new records so set it back to the id (might be resource or resourceId)
      this.forEach(assignment => {
        var _a, _b, _c;

        return assignment.setChanged(modelName, (_c = (_b = (_a = assignment[modelName]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : assignment[modelName]) !== null && _c !== void 0 ? _c : assignment[modelName + 'Id']);
      });
      this.invalidateIndices();
    }

    onCommitAsync() {
      this.updateIndices();
    }

  }

  return CoreAssignmentStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarManagerStoreMixin", function() { return CoreCalendarManagerStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all calendars in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreCalendarManagerStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractCalendarManagerStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreCalendarManagerStoreMixin extends base {
    static get defaultConfig() {
      return {
        tree: true,
        modelClass: _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreCalendarMixin"]
      };
    }

  }

  return CoreCalendarManagerStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreDependencyStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyStoreMixin", function() { return CoreDependencyStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");
var productName = 'gantt';




const emptySet = new Set();
/**
 * A store mixin class, that represent collection of all dependencies in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreDependencyStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractDependencyStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreDependencyStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.dependenciesForRemoval = new Set();
      this.allDependenciesForRemoval = false;
    }

    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreDependencyMixin"],
        storage: {
          extraKeys: [{
            property: 'fromEvent',
            unique: false
          }, {
            property: 'toEvent',
            unique: false
          }]
        }
      };
    }

    getIncomingDepsForEvent(event) {
      return this.storage.findItem('toEvent', event) || emptySet;
    }

    getOutgoingDepsForEvent(event) {
      return this.storage.findItem('fromEvent', event) || emptySet;
    }

    set data(value) {
      this.allDependenciesForRemoval = true;
      super.data = value;
      this.allDependenciesForRemoval = false;
    }

    updateIndices() {
      this.storage.rebuildIndices();
    }

    invalidateIndices() {
      this.storage.invalidateIndices();
    }

    onCommitAsync() {
      this.updateIndices();
    }

  }

  return CoreDependencyStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreEventStoreMixin.js":
/*!*******************************************************!*\
  !*** ./lib/Engine/quark/store/CoreEventStoreMixin.js ***!
  \*******************************************************/
/*! exports provided: CoreEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventStoreMixin", function() { return CoreEventStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all events in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreEventStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractEventStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreEventStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerCoreEvent"]
      };
    }

    joinProject() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
    }

    afterLoadData() {
      var _a;

      this.afterEventRemoval();
      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
    }

  }

  return CoreEventStoreMixin;
}) {} // /**
//  * The tree store version of [[EventStoreMixin]].
//  */
// export class EventTreeStoreMixin extends Mixin(
//     [ EventStoreMixin ],
//     (base : AnyConstructor<EventStoreMixin, typeof EventStoreMixin>) => {
//
//     const superProto : InstanceType<typeof base> = base.prototype
//
//
//         class EventTreeStoreMixin extends base {
//             rootNode            : SchedulerBasicProjectMixin
//
//             buildRootNode () : object {
//                 return this.getProject() || {}
//             }
//
//
//             static get defaultConfig () : object {
//                 return {
//                     tree        : true
//                 }
//             }
//         }
//
//         return EventTreeStoreMixin
//     }){}
//

/***/ }),

/***/ "./lib/Engine/quark/store/CoreResourceStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Engine/quark/store/CoreResourceStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: CoreResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceStoreMixin", function() { return CoreResourceStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");
var productName = 'gantt';




/**
 * A store mixin class, that represent collection of all resources in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreResourceStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractResourceStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreResourceStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreResourceMixin"]
      };
    }

    joinProject() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
    }

    afterLoadData() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
    }

    clear(removing) {
      var _a;

      superProto.clear.call(this, removing);
      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.unlinkAssignments('resource');
    }

  }

  return CoreResourceStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectStoreMixin", function() { return AbstractPartOfProjectStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';



/**
 * This an abstract mixin for every Store, that belongs to a project.
 *
 * The store with this mixin, supposes, that it will be "joining" the project, a reference to which is saved
 * and made available for all models.
 */

class AbstractPartOfProjectStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.isLoadingData = false;
    } //region Async event triggering
    // NOTE: Tested in Scheduler (EventStore.t.js)


    construct(config = {}) {
      config.asyncEvents = {
        add: true,
        remove: true,
        removeAll: true,
        change: true,
        refresh: true,
        replace: true,
        move: true,
        update: true
      };
      return superProto.construct.call(this, config);
    } // Override for event triggering, to allow triggering events before and after some async operation.
    // The "before" events are prefix, the "after" are not.


    trigger(eventName, param) {
      const me = this,
            {
        asyncEvents,
        project
      } = me,
            asyncEvent = asyncEvents === null || asyncEvents === void 0 ? void 0 : asyncEvents[eventName],
            asyncAction = asyncEvent && (asyncEvent === true || asyncEvent[param.action]);

      if (!asyncAction) {
        // Trigger as usual
        return superProto.trigger.call(me, eventName, param);
      } // Trigger prefixed before event


      superProto.trigger.call(me, `${eventName}PreCommit`, Object.assign({}, param)); // Event that did not invalidate engine, for example "update"

      if (!project || project.isEngineReady() && !project.isWritingData) {
        // Trigger "original" event
        superProto.trigger.call(me, eventName, param);
      } else if (!me.eventsSuspended && project) {
        // Instead of making n auto-destroying listeners (which takes enormous amount of time), we make a single
        // one and queue all the events. When dataReady event is triggered we trigger those events
        // https://github.com/bryntum/support/issues/3154
        if (!project.dataReadyDetacher) {
          project.queuedDataReadyEvents = []; // Wait for commit without triggering one, otherwise we would affect commit scheduling

          project.dataReadyDetacher = project.on({
            dataReady() {
              // Trigger "original" event
              this.queuedDataReadyEvents.forEach(([superProto, scope, eventName, param]) => {
                superProto.trigger.call(scope, eventName, param);
              });
              project.queuedDataReadyEvents = null;
              project.dataReadyDetacher();
              project.dataReadyDetacher = null;
            },

            once: true
          });
        }

        project.queuedDataReadyEvents.push([superProto, me, eventName, param]);
      } // No way of handling other return values in this scenario, wont work for preventable events


      return true;
    } //endregion


    calculateProject() {
      // project is supposed to be provided for stores from outside
      return this.project;
    }

    setStoreData(data) {
      var _a; // Loading data sets hasLoadedDataToCommit flag.
      // So we treat the 1st commit after data loading as the initial one


      if (this.project) {
        this.project.hasLoadedDataToCommit = true;
      }

      this.isLoadingData = true;
      superProto.setStoreData.call(this, data);
      this.isLoadingData = false;
      (_a = this.project) === null || _a === void 0 ? void 0 : _a.trigger('storeRefresh', {
        store: this
      });
    } // Override to postpone auto commits to after project commit, makes sure records are unmodified after commit


    async doAutoCommit() {
      if (this.suspendCount <= 0 && this.project && !this.project.isEngineReady()) {
        // TODO: Ask nick about this, I could not get mixin order correct for this to work
        // @ts-ignore
        await this.project.commitAsync();
      }

      superProto.doAutoCommit.call(this);
    }

    async addAsync(records, silent) {
      const result = this.add(records, silent);
      await this.project.commitAsync();
      return result;
    }

    async insertAsync(index, records, silent) {
      const result = this.insert(index, records, silent);
      await this.project.commitAsync();
      return result;
    }

    async loadDataAsync(data) {
      this.data = data;
      await this.project.commitAsync();
    }

  }

  return AbstractPartOfProjectStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js ***!
  \***********************************************************************/
/*! exports provided: ChronoPartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectStoreMixin", function() { return ChronoPartOfProjectStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoPartOfProjectGenericMixin.js */ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js");
/* harmony import */ var _ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ChronoStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';




/**
 * This a base mixin for every Store, that belongs to a ChronoGraph powered project.
 */

class ChronoPartOfProjectStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractPartOfProjectStoreMixin"], _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["ChronoPartOfProjectGenericMixin"], _ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoStoreMixin"]], base => {
  const superProto = base.prototype;

  class ChronoPartOfProjectStoreMixin extends base {
    setStoreData(data) {
      var _a; // Inform project that a store is being repopulated, to avoid expensive unjoins


      (_a = this.project) === null || _a === void 0 ? void 0 : _a.repopulateStore(this);
      superProto.setStoreData.call(this, data);
    }

  }

  return ChronoPartOfProjectStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/ChronoStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/ChronoStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: ChronoStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoStoreMixin", function() { return ChronoStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


class ChronoStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]], base => class ChronoStoreMixin extends base {}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectStoreMixin", function() { return CorePartOfProjectStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'gantt';




/**
 * This a mixin for every Store, that belongs to a scheduler_core project.
 */

class CorePartOfProjectStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractPartOfProjectStoreMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectStoreMixin extends base {
    setProject(project) {
      const result = superProto.setProject.call(this, project);
      if (project) this.joinProject(project);
      return result;
    }

    joinProject(project) {}

    onCommitAsync() {}

  }

  return CorePartOfProjectStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/scheduling/DateInterval.js":
/*!***********************************************!*\
  !*** ./lib/Engine/scheduling/DateInterval.js ***!
  \***********************************************/
/*! exports provided: DateInterval, EMPTY_INTERVAL, intersectIntervals */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateInterval", function() { return DateInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY_INTERVAL", function() { return EMPTY_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectIntervals", function() { return intersectIntervals; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
var productName = 'gantt';



/**
 * General purpose date interval. Contains just 2 properties - [[startDate]] and [[endDate]].
 */

class DateInterval extends _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Base"] {
  initialize(...args) {
    super.initialize(...args);
    if (!this.startDate) this.startDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"];
    if (!this.endDate) this.endDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"];
  }

  equalTo(another) {
    return this.startDate.getTime() === another.startDate.getTime() && this.endDate.getTime() === another.endDate.getTime();
  }

  startDateIsFinite() {
    return !this.isIntervalEmpty() && this.startDate.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"].getTime();
  }

  endDateIsFinite() {
    return !this.isIntervalEmpty() && this.endDate.getTime() !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"].getTime();
  }
  /**
   * Test whether the given time point is within this interval. By default interval is considered to be
   * inclusive on the left side and opened on the right (controlled with `edgeInclusion`).
   *
   * @param date
   * @param edgeInclusion
   */


  containsDate(date, edgeInclusion = _util_Types_js__WEBPACK_IMPORTED_MODULE_2__["EdgeInclusion"].Left) {
    return edgeInclusion === _util_Types_js__WEBPACK_IMPORTED_MODULE_2__["EdgeInclusion"].Left && date >= this.startDate && date < this.endDate || edgeInclusion === _util_Types_js__WEBPACK_IMPORTED_MODULE_2__["EdgeInclusion"].Right && date > this.startDate && date <= this.endDate;
  }

  isIntervalEmpty() {
    return this.startDate > this.endDate;
  }
  /**
   * Intersect this interval with another in the immutable way - returns a new interval.
   * @param another
   */


  intersect(another) {
    const anotherStart = another.startDate;
    const anotherEnd = another.endDate;
    const start = this.startDate;
    const end = this.endDate; // No intersection found

    if (end < anotherStart || start > anotherEnd) {
      // return an empty interval
      return EMPTY_INTERVAL;
    }

    const newStart = new Date(Math.max(start.getTime(), anotherStart.getTime()));
    const newEnd = new Date(Math.min(end.getTime(), anotherEnd.getTime()));
    return this.constructor.new({
      startDate: newStart,
      endDate: newEnd
    });
  }
  /**
   * Intersect this interval with another in the mutable way - updates current interval.
   * @param another
   */


  intersectMut(another) {
    const anotherStart = another.startDate;
    const anotherEnd = another.endDate;
    const start = this.startDate;
    const end = this.endDate; // No intersection found

    if (end < anotherStart || start > anotherEnd) {
      // return an empty interval
      this.startDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"];
      this.endDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"];
      return this;
    }

    this.startDate = new Date(Math.max(start.getTime(), anotherStart.getTime()));
    this.endDate = new Date(Math.min(end.getTime(), anotherEnd.getTime()));
    return this;
  }

}
const EMPTY_INTERVAL = DateInterval.new({
  startDate: _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MAX_DATE"],
  endDate: _util_Constants_js__WEBPACK_IMPORTED_MODULE_1__["MIN_DATE"]
});
/**
 * Intersects the array of intervals. Returns a new interval with result.
 *
 * @param dateIntervals
 */

const intersectIntervals = dateIntervals => {
  return dateIntervals.reduce((acc, currentInterval) => acc.intersectMut(currentInterval), DateInterval.new());
};

/***/ }),

/***/ "./lib/Engine/scheduling/DurationConverterMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/scheduling/DurationConverterMixin.js ***!
  \*********************************************************/
/*! exports provided: DurationConverterMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DurationConverterMixin", function() { return DurationConverterMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
var productName = 'gantt';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * This mixin provides the duration converting functionality - the [[convertDuration]] method. It requires (inherit from) [[ChronoModelMixin]].
 */

class DurationConverterMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoModelMixin"]], base => {
  const superProto = base.prototype;

  class DurationConverterMixin extends base {
    *calculateUnitsInMs() {
      const hoursPerDay = yield this.$.hoursPerDay;
      const daysPerWeek = yield this.$.daysPerWeek;
      const daysPerMonth = yield this.$.daysPerMonth;
      return {
        millisecond: 1,
        second: 1000,
        minute: 60 * 1000,
        hour: 60 * 60 * 1000,
        day: hoursPerDay * 60 * 60 * 1000,
        week: daysPerWeek * hoursPerDay * 60 * 60 * 1000,
        month: daysPerMonth * hoursPerDay * 60 * 60 * 1000,
        quarter: 3 * daysPerMonth * hoursPerDay * 60 * 60 * 1000,
        year: 4 * 3 * daysPerMonth * hoursPerDay * 60 * 60 * 1000
      };
    }
    /**
     * Converts duration value from one time unit to another
     * @param duration Duration value
     * @param fromUnit Duration value time unit
     * @param toUnit   Target time unit to convert the value to
     */


    convertDuration(duration, fromUnit, toUnit) {
      let result = duration;

      if (fromUnit !== toUnit) {
        result = duration * this.unitsInMs[fromUnit] / this.unitsInMs[toUnit];
      }

      return result; // TODO should be just something like:
      // return this.run('$convertDuration', duration, fromUnit, toUnit)
    }

    *$convertDuration(duration, fromUnit, toUnit) {
      if (!fromUnit || !toUnit) throw new Error("Conversion unit not provided");
      const unitsInMs = yield this.$.unitsInMs;
      let result = duration;

      if (fromUnit !== toUnit) {
        result = duration * unitsInMs[fromUnit] / unitsInMs[toUnit];
      }

      return result;
    }

  }

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["field"])()], DurationConverterMixin.prototype, "unitsInMs", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'number',
    defaultValue: 24
  })], DurationConverterMixin.prototype, "hoursPerDay", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'number',
    defaultValue: 7
  })], DurationConverterMixin.prototype, "daysPerWeek", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_3__["model_field"])({
    type: 'number',
    defaultValue: 30
  })], DurationConverterMixin.prototype, "daysPerMonth", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_1__["calculate"])('unitsInMs')], DurationConverterMixin.prototype, "calculateUnitsInMs", null);

  return DurationConverterMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/scheduling/Types.js":
/*!****************************************!*\
  !*** ./lib/Engine/scheduling/Types.js ***!
  \****************************************/
/*! exports provided: TimeUnit, ConstraintType, SchedulingMode, DependencyValidationResult, DependencyType, DependenciesCalendar, ProjectType, Direction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeUnit", function() { return TimeUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstraintType", function() { return ConstraintType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulingMode", function() { return SchedulingMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyValidationResult", function() { return DependencyValidationResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyType", function() { return DependencyType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependenciesCalendar", function() { return DependenciesCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectType", function() { return ProjectType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Direction", function() { return Direction; });
var productName = 'gantt';
/**
* The enumeration for the time units
*/

var TimeUnit;

(function (TimeUnit) {
  TimeUnit["Millisecond"] = "millisecond";
  TimeUnit["Second"] = "second";
  TimeUnit["Minute"] = "minute";
  TimeUnit["Hour"] = "hour";
  TimeUnit["Day"] = "day";
  TimeUnit["Week"] = "week";
  TimeUnit["Month"] = "month";
  TimeUnit["Quarter"] = "quarter";
  TimeUnit["Year"] = "year";
})(TimeUnit || (TimeUnit = {}));
/**
 * The enumeration for the supported constraint types
 */


var ConstraintType;

(function (ConstraintType) {
  /**
   * "Must start on" constraint.
   * Restricts an event to start on a [[HasDateConstraintMixin.constraintDate|specified date]].
   * The constraint cannot be used for a summary event.
   */
  ConstraintType["MustStartOn"] = "muststarton";
  /**
   * "Must finish on" constraint.
   * Restricts an event to finish on a [[HasDateConstraintMixin.constraintDate|specified date]].
   * The constraint cannot be used for a summary event.
   */

  ConstraintType["MustFinishOn"] = "mustfinishon";
  /**
   * "Start no earlier than" constraint.
   * Restricting an event to start on or after a [[HasDateConstraintMixin.constraintDate|specified date]].
   */

  ConstraintType["StartNoEarlierThan"] = "startnoearlierthan";
  /**
   * "Start no later than" constraint.
   * Restricting an event to start on or before a [[HasDateConstraintMixin.constraintDate|specified date]].
   *
   * The constraint cannot be used for a summary task.
   */

  ConstraintType["StartNoLaterThan"] = "startnolaterthan";
  /**
   * "Finish no earlier than" constraint.
   * Restricting an event to finish on or after a [[HasDateConstraintMixin.constraintDate|specified date]].
   *
   * The constraint cannot be used for a summary task.
   */

  ConstraintType["FinishNoEarlierThan"] = "finishnoearlierthan";
  /**
   * "Finish no later than" constraint.
   * Restricting an event to finish on or before a [[HasDateConstraintMixin.constraintDate|specified date]].
   */

  ConstraintType["FinishNoLaterThan"] = "finishnolaterthan";
})(ConstraintType || (ConstraintType = {}));
/**
 * The enumeration for the supported scheduling modes
 */


var SchedulingMode;

(function (SchedulingMode) {
  SchedulingMode["Normal"] = "Normal";
  SchedulingMode["FixedDuration"] = "FixedDuration";
  SchedulingMode["FixedEffort"] = "FixedEffort";
  SchedulingMode["FixedUnits"] = "FixedUnits";
})(SchedulingMode || (SchedulingMode = {}));
/**
 * The enumeration for the dependency validation result
 */


var DependencyValidationResult;

(function (DependencyValidationResult) {
  /**
   * Dependency has no errors
   */
  DependencyValidationResult[DependencyValidationResult["NoError"] = 0] = "NoError";
  /**
   * Indicates that the validated dependency builds a cycle
   */

  DependencyValidationResult[DependencyValidationResult["CyclicDependency"] = 1] = "CyclicDependency";
  /**
   * Indicates that a dependency with the same predecessor and successor as validated one's already exists
   */

  DependencyValidationResult[DependencyValidationResult["DuplicatingDependency"] = 2] = "DuplicatingDependency";
})(DependencyValidationResult || (DependencyValidationResult = {}));
/**
 * The enumeration for the supported dependency types
 */


var DependencyType;

(function (DependencyType) {
  /**
   * Start-to-Start (_SS_)
   *
   * With this dependency type, the succeeding event is delayed to start not earlier than the preceding event starts.
   */
  DependencyType[DependencyType["StartToStart"] = 0] = "StartToStart";
  /**
   * Start-to-Finish (_SF_)
   *
   * The finish of the succeeding event is constrained by the start of the preceding event.
   * So the successor cannot finish before the predecessor starts.
   */

  DependencyType[DependencyType["StartToEnd"] = 1] = "StartToEnd";
  /**
   * Finish-to-Start (_FS_)
   *
   * This type of dependency, restricts the dependent event to not start earlier than the preceding event finishes.
   */

  DependencyType[DependencyType["EndToStart"] = 2] = "EndToStart";
  /**
   * Finish-to-Finish (_FF_)
   *
   * The succeeding event cannot finish before the completion of the preceding event.
   */

  DependencyType[DependencyType["EndToEnd"] = 3] = "EndToEnd";
})(DependencyType || (DependencyType = {}));
/**
 * The enumeration for the supported sources of the calendar for the dependency.
 */


var DependenciesCalendar;

(function (DependenciesCalendar) {
  DependenciesCalendar["Project"] = "Project";
  DependenciesCalendar["FromEvent"] = "FromEvent";
  DependenciesCalendar["ToEvent"] = "ToEvent";
})(DependenciesCalendar || (DependenciesCalendar = {}));
/**
 * Engine provides with different project types, the enumeration describes the types currently available
 */


var ProjectType;

(function (ProjectType) {
  ProjectType[ProjectType["SchedulerBasic"] = 1] = "SchedulerBasic";
  ProjectType[ProjectType["SchedulerPro"] = 2] = "SchedulerPro";
  ProjectType[ProjectType["Gantt"] = 3] = "Gantt";
})(ProjectType || (ProjectType = {}));
/**
 * The enumeration for the scheduling direction
 */


var Direction;

(function (Direction) {
  /**
   * Forward (or As Soon As Possible (ASAP)) scheduling.
   */
  Direction["Forward"] = "Forward";
  /**
   * Backward (or As Late As Possible (ALAP)) scheduling.
   */

  Direction["Backward"] = "Backward";
  Direction["None"] = "None";
})(Direction || (Direction = {}));

/***/ }),

/***/ "./lib/Engine/util/BinarySearch.js":
/*!*****************************************!*\
  !*** ./lib/Engine/util/BinarySearch.js ***!
  \*****************************************/
/*! exports provided: binarySearch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return binarySearch; });
var productName = 'gantt'; // Generic binary search

const binarySearch = (value, array, comparator = (a, b) => a - b) => {
  let left = 0;
  let right = array.length;

  while (left < right) {
    // | 0 to make it integer, faster according to: https://jsperf.com/or-vs-floor/2
    const mid = (left + right) / 2 | 0;
    const compare = comparator(value, array[mid]);
    if (compare === 0) return {
      found: true,
      index: mid
    };else if (compare < 0) right = mid;else left = mid + 1;
  }

  return {
    found: false,
    index: right
  };
};

/***/ }),

/***/ "./lib/Engine/util/Constants.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Constants.js ***!
  \**************************************/
/*! exports provided: MIN_DATE, MAX_DATE, isDateFinite */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_DATE", function() { return MIN_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_DATE", function() { return MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDateFinite", function() { return isDateFinite; });
var productName = 'gantt'; // http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1

/**
 * Minimal date representable with native Date class
 */

const MIN_DATE = new Date(-8640000000000000);
/**
 * Maximal date representable with native Date class
 */

const MAX_DATE = new Date(8640000000000000);
const isDateFinite = date => {
  if (!date) return false;
  const time = date.getTime();
  return time !== MIN_DATE.getTime() && time !== MAX_DATE.getTime();
};

/***/ }),

/***/ "./lib/Engine/util/Functions.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Functions.js ***!
  \**************************************/
/*! exports provided: isNotNumber, CIFromSetOrArrayOrValue, delay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNotNumber", function() { return isNotNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIFromSetOrArrayOrValue", function() { return CIFromSetOrArrayOrValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony import */ var _ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
var productName = 'gantt';

const isNotNumber = value => Number(value) !== value;
const CIFromSetOrArrayOrValue = value => {
  if (value instanceof Set || value instanceof Array) return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(value);
  return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])([value]);
};
const delay = value => new Promise(resolve => setTimeout(resolve, value));

/***/ }),

/***/ "./lib/Engine/util/StripDuplicates.js":
/*!********************************************!*\
  !*** ./lib/Engine/util/StripDuplicates.js ***!
  \********************************************/
/*! exports provided: stripDuplicates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripDuplicates", function() { return stripDuplicates; });
var productName = 'gantt';
const stripDuplicates = array => Array.from(new Set(array));

/***/ }),

/***/ "./lib/Engine/util/Types.js":
/*!**********************************!*\
  !*** ./lib/Engine/util/Types.js ***!
  \**********************************/
/*! exports provided: EdgeInclusion */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeInclusion", function() { return EdgeInclusion; });
var productName = 'gantt';
/**
* The date intervals in the scheduling engine are always inclusive on one end and opened on another.
* The "opened" end is not considered to be a part of the interval.
*
* Depending from the scheduling direction (forward/backward) this property may need to be inverted.
*
* This enum specifies what edge of the interval is inclusive.
*/

var EdgeInclusion;

(function (EdgeInclusion) {
  EdgeInclusion[EdgeInclusion["Left"] = 0] = "Left";
  EdgeInclusion[EdgeInclusion["Right"] = 1] = "Right";
})(EdgeInclusion || (EdgeInclusion = {}));

/***/ }),

/***/ "./lib/Engine/vendor/later/later.js":
/*!******************************************!*\
  !*** ./lib/Engine/vendor/later/later.js ***!
  \******************************************/
/*! exports provided: later, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "later", function() { return later; });
var productName = 'gantt'; // @ts-nocheck

/**
 * The code just copy/pasted from pre-built later.js file and made exported
 *
 * @private
 */

const later = function () {
  "use strict";

  var later = {
    version: "1.2.0"
  };

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement) {
      "use strict";

      if (this == null) {
        throw new TypeError();
      }

      var t = Object(this);
      var len = t.length >>> 0;

      if (len === 0) {
        return -1;
      }

      var n = 0;

      if (arguments.length > 1) {
        n = Number(arguments[1]);

        if (n != n) {
          n = 0;
        } else if (n != 0 && n != Infinity && n != -Infinity) {
          n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
      }

      if (n >= len) {
        return -1;
      }

      var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);

      for (; k < len; k++) {
        if (k in t && t[k] === searchElement) {
          return k;
        }
      }

      return -1;
    };
  }

  if (!String.prototype.trim) {
    String.prototype.trim = function () {
      return this.replace(/^\s+|\s+$/g, "");
    };
  }

  later.array = {};

  later.array.sort = function (arr, zeroIsLast) {
    arr.sort(function (a, b) {
      return +a - +b;
    });

    if (zeroIsLast && arr[0] === 0) {
      arr.push(arr.shift());
    }
  };

  later.array.next = function (val, values, extent) {
    var cur,
        zeroIsLargest = extent[0] !== 0,
        nextIdx = 0;

    for (var i = values.length - 1; i > -1; --i) {
      cur = values[i];

      if (cur === val) {
        return cur;
      }

      if (cur > val || cur === 0 && zeroIsLargest && extent[1] > val) {
        nextIdx = i;
        continue;
      }

      break;
    }

    return values[nextIdx];
  };

  later.array.nextInvalid = function (val, values, extent) {
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next;

    while (next === (values[i] || zeroVal)) {
      next++;

      if (next > max) {
        next = min;
      }

      i++;

      if (i === len) {
        i = 0;
      }

      if (next === start) {
        return undefined;
      }
    }

    return next;
  };

  later.array.prev = function (val, values, extent) {
    var cur,
        len = values.length,
        zeroIsLargest = extent[0] !== 0,
        prevIdx = len - 1;

    for (var i = 0; i < len; i++) {
      cur = values[i];

      if (cur === val) {
        return cur;
      }

      if (cur < val || cur === 0 && zeroIsLargest && extent[1] < val) {
        prevIdx = i;
        continue;
      }

      break;
    }

    return values[prevIdx];
  };

  later.array.prevInvalid = function (val, values, extent) {
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next;

    while (next === (values[i] || zeroVal)) {
      next--;

      if (next < min) {
        next = max;
      }

      i--;

      if (i === -1) {
        i = len - 1;
      }

      if (next === start) {
        return undefined;
      }
    }

    return next;
  };

  later.day = later.D = {
    name: "day",
    range: 86400,
    val: function (d) {
      return d.D || (d.D = later.date.getDate.call(d));
    },
    isValid: function (d, val) {
      return later.D.val(d) === (val || later.D.extent(d)[1]);
    },
    extent: function (d) {
      if (d.DExtent) return d.DExtent;
      var month = later.M.val(d),
          max = later.DAYS_IN_MONTH[month - 1];

      if (month === 2 && later.dy.extent(d)[1] === 366) {
        max = max + 1;
      }

      return d.DExtent = [1, max];
    },
    start: function (d) {
      return d.DStart || (d.DStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d)));
    },
    end: function (d) {
      return d.DEnd || (d.DEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d)));
    },
    next: function (d, val) {
      val = val > later.D.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1];
      val = val > DMax ? 1 : val || DMax;
      return later.date.next(later.Y.val(month), later.M.val(month), val);
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1];
      return later.date.prev(later.Y.val(month), later.M.val(month), val > DMax ? DMax : val || DMax);
    }
  };
  later.dayOfWeekCount = later.dc = {
    name: "day of week count",
    range: 604800,
    val: function (d) {
      return d.dc || (d.dc = Math.floor((later.D.val(d) - 1) / 7) + 1);
    },
    isValid: function (d, val) {
      return later.dc.val(d) === val || val === 0 && later.D.val(d) > later.D.extent(d)[1] - 7;
    },
    extent: function (d) {
      return d.dcExtent || (d.dcExtent = [1, Math.ceil(later.D.extent(d)[1] / 7)]);
    },
    start: function (d) {
      return d.dcStart || (d.dcStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(1, (later.dc.val(d) - 1) * 7 + 1 || 1)));
    },
    end: function (d) {
      return d.dcEnd || (d.dcEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.dc.val(d) * 7, later.D.extent(d)[1])));
    },
    next: function (d, val) {
      val = val > later.dc.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1];
      val = val > dcMax ? 1 : val;
      var next = later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));

      if (next.getTime() <= d.getTime()) {
        month = later.M.next(d, later.M.val(d) + 1);
        return later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
      }

      return next;
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1];
      val = val > dcMax ? dcMax : val || dcMax;
      return later.dc.end(later.date.prev(later.Y.val(month), later.M.val(month), 1 + 7 * (val - 1)));
    }
  };
  later.dayOfWeek = later.dw = later.d = {
    name: "day of week",
    range: 86400,
    val: function (d) {
      return d.dw || (d.dw = later.date.getDay.call(d) + 1);
    },
    isValid: function (d, val) {
      return later.dw.val(d) === (val || 7);
    },
    extent: function () {
      return [1, 7];
    },
    start: function (d) {
      return later.D.start(d);
    },
    end: function (d) {
      return later.D.end(d);
    },
    next: function (d, val) {
      val = val > 7 ? 1 : val || 7;
      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val <= later.dw.val(d) ? 7 : 0));
    },
    prev: function (d, val) {
      val = val > 7 ? 7 : val || 7;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val >= later.dw.val(d) ? -7 : 0));
    }
  };
  later.dayOfYear = later.dy = {
    name: "day of year",
    range: 86400,
    val: function (d) {
      return d.dy || (d.dy = Math.ceil(1 + (later.D.start(d).getTime() - later.Y.start(d).getTime()) / later.DAY));
    },
    isValid: function (d, val) {
      return later.dy.val(d) === (val || later.dy.extent(d)[1]);
    },
    extent: function (d) {
      var year = later.Y.val(d);
      return d.dyExtent || (d.dyExtent = [1, year % 4 ? 365 : 366]);
    },
    start: function (d) {
      return later.D.start(d);
    },
    end: function (d) {
      return later.D.end(d);
    },
    next: function (d, val) {
      val = val > later.dy.extent(d)[1] ? 1 : val;
      var year = later.date.nextRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1];
      val = val > dyMax ? 1 : val || dyMax;
      return later.date.next(later.Y.val(year), later.M.val(year), val);
    },
    prev: function (d, val) {
      var year = later.date.prevRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1];
      val = val > dyMax ? dyMax : val || dyMax;
      return later.date.prev(later.Y.val(year), later.M.val(year), val);
    }
  };
  later.hour = later.h = {
    name: "hour",
    range: 3600,
    val: function (d) {
      return d.h || (d.h = later.date.getHour.call(d));
    },
    isValid: function (d, val) {
      return later.h.val(d) === val;
    },
    extent: function () {
      return [0, 23];
    },
    start: function (d) {
      return d.hStart || (d.hStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
    },
    end: function (d) {
      return d.hEnd || (d.hEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
    },
    next: function (d, val) {
      val = val > 23 ? 0 : val;
      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.h.val(d) ? 1 : 0), val);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), val + 1);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 23 ? 23 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.h.val(d) ? -1 : 0), val);
    }
  };
  later.minute = later.m = {
    name: "minute",
    range: 60,
    val: function (d) {
      return d.m || (d.m = later.date.getMin.call(d));
    },
    isValid: function (d, val) {
      return later.m.val(d) === val;
    },
    extent: function (d) {
      return [0, 59];
    },
    start: function (d) {
      return d.mStart || (d.mStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
    },
    end: function (d) {
      return d.mEnd || (d.mEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
    },
    next: function (d, val) {
      var m = later.m.val(d),
          s = later.s.val(d),
          inc = val > 59 ? 60 - m : val <= m ? 60 - m + val : val - m,
          next = new Date(d.getTime() + inc * later.MIN - s * later.SEC);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 120) * later.MIN - s * later.SEC);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 59 ? 59 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d) + (val >= later.m.val(d) ? -1 : 0), val);
    }
  };
  later.month = later.M = {
    name: "month",
    range: 2629740,
    val: function (d) {
      return d.M || (d.M = later.date.getMonth.call(d) + 1);
    },
    isValid: function (d, val) {
      return later.M.val(d) === (val || 12);
    },
    extent: function () {
      return [1, 12];
    },
    start: function (d) {
      return d.MStart || (d.MStart = later.date.next(later.Y.val(d), later.M.val(d)));
    },
    end: function (d) {
      return d.MEnd || (d.MEnd = later.date.prev(later.Y.val(d), later.M.val(d)));
    },
    next: function (d, val) {
      val = val > 12 ? 1 : val || 12;
      return later.date.next(later.Y.val(d) + (val > later.M.val(d) ? 0 : 1), val);
    },
    prev: function (d, val) {
      val = val > 12 ? 12 : val || 12;
      return later.date.prev(later.Y.val(d) - (val >= later.M.val(d) ? 1 : 0), val);
    }
  };
  later.second = later.s = {
    name: "second",
    range: 1,
    val: function (d) {
      return d.s || (d.s = later.date.getSec.call(d));
    },
    isValid: function (d, val) {
      return later.s.val(d) === val;
    },
    extent: function () {
      return [0, 59];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      var s = later.s.val(d),
          inc = val > 59 ? 60 - s : val <= s ? 60 - s + val : val - s,
          next = new Date(d.getTime() + inc * later.SEC);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 7200) * later.SEC);
      }

      return next;
    },
    prev: function (d, val, cache) {
      val = val > 59 ? 59 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d) + (val >= later.s.val(d) ? -1 : 0), val);
    }
  };
  later.time = later.t = {
    name: "time",
    range: 1,
    val: function (d) {
      return d.t || (d.t = later.h.val(d) * 3600 + later.m.val(d) * 60 + later.s.val(d));
    },
    isValid: function (d, val) {
      return later.t.val(d) === val;
    },
    extent: function () {
      return [0, 86399];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      val = val > 86399 ? 0 : val;
      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.t.val(d) ? 1 : 0), 0, 0, val);

      if (!later.date.isUTC && next.getTime() < d.getTime()) {
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), later.h.val(next), later.m.val(next), val + 7200);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 86399 ? 86399 : val;
      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.t.val(d) ? -1 : 0), 0, 0, val);
    }
  };
  later.weekOfMonth = later.wm = {
    name: "week of month",
    range: 604800,
    val: function (d) {
      return d.wm || (d.wm = (later.D.val(d) + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(d))) / 7);
    },
    isValid: function (d, val) {
      return later.wm.val(d) === (val || later.wm.extent(d)[1]);
    },
    extent: function (d) {
      return d.wmExtent || (d.wmExtent = [1, (later.D.extent(d)[1] + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(later.M.end(d)))) / 7]);
    },
    start: function (d) {
      return d.wmStart || (d.wmStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(later.D.val(d) - later.dw.val(d) + 1, 1)));
    },
    end: function (d) {
      return d.wmEnd || (d.wmEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.D.val(d) + (7 - later.dw.val(d)), later.D.extent(d)[1])));
    },
    next: function (d, val) {
      val = val > later.wm.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1];
      val = val > wmMax ? 1 : val || wmMax;
      return later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2)));
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1];
      val = val > wmMax ? wmMax : val || wmMax;
      return later.wm.end(later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2))));
    }
  };
  later.weekOfYear = later.wy = {
    name: "week of year (ISO)",
    range: 604800,
    val: function (d) {
      if (d.wy) return d.wy;
      var wThur = later.dw.next(later.wy.start(d), 5),
          YThur = later.dw.next(later.Y.prev(wThur, later.Y.val(wThur) - 1), 5);
      return d.wy = 1 + Math.ceil((wThur.getTime() - YThur.getTime()) / later.WEEK);
    },
    isValid: function (d, val) {
      return later.wy.val(d) === (val || later.wy.extent(d)[1]);
    },
    extent: function (d) {
      if (d.wyExtent) return d.wyExtent;
      var year = later.dw.next(later.wy.start(d), 5),
          dwFirst = later.dw.val(later.Y.start(year)),
          dwLast = later.dw.val(later.Y.end(year));
      return d.wyExtent = [1, dwFirst === 5 || dwLast === 5 ? 53 : 52];
    },
    start: function (d) {
      return d.wyStart || (d.wyStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) - (later.dw.val(d) > 1 ? later.dw.val(d) - 2 : 6)));
    },
    end: function (d) {
      return d.wyEnd || (d.wyEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (later.dw.val(d) > 1 ? 8 - later.dw.val(d) : 0)));
    },
    next: function (d, val) {
      val = val > later.wy.extent(d)[1] ? 1 : val;
      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.nextRollover(wyThur, val, later.wy, later.Y);

      if (later.wy.val(year) !== 1) {
        year = later.dw.next(year, 2);
      }

      var wyMax = later.wy.extent(year)[1],
          wyStart = later.wy.start(year);
      val = val > wyMax ? 1 : val || wyMax;
      return later.date.next(later.Y.val(wyStart), later.M.val(wyStart), later.D.val(wyStart) + 7 * (val - 1));
    },
    prev: function (d, val) {
      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.prevRollover(wyThur, val, later.wy, later.Y);

      if (later.wy.val(year) !== 1) {
        year = later.dw.next(year, 2);
      }

      var wyMax = later.wy.extent(year)[1],
          wyEnd = later.wy.end(year);
      val = val > wyMax ? wyMax : val || wyMax;
      return later.wy.end(later.date.next(later.Y.val(wyEnd), later.M.val(wyEnd), later.D.val(wyEnd) + 7 * (val - 1)));
    }
  };
  later.year = later.Y = {
    name: "year",
    range: 31556900,
    val: function (d) {
      return d.Y || (d.Y = later.date.getYear.call(d));
    },
    isValid: function (d, val) {
      return later.Y.val(d) === val;
    },
    extent: function () {
      return [1970, 2099];
    },
    start: function (d) {
      return d.YStart || (d.YStart = later.date.next(later.Y.val(d)));
    },
    end: function (d) {
      return d.YEnd || (d.YEnd = later.date.prev(later.Y.val(d)));
    },
    next: function (d, val) {
      return val > later.Y.val(d) && val <= later.Y.extent()[1] ? later.date.next(val) : later.NEVER;
    },
    prev: function (d, val) {
      return val < later.Y.val(d) && val >= later.Y.extent()[0] ? later.date.prev(val) : later.NEVER;
    }
  };
  later.fullDate = later.fd = {
    name: "full date",
    range: 1,
    val: function (d) {
      return d.fd || (d.fd = d.getTime());
    },
    isValid: function (d, val) {
      return later.fd.val(d) === val;
    },
    extent: function () {
      return [0, 3250368e7];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      return later.fd.val(d) < val ? new Date(val) : later.NEVER;
    },
    prev: function (d, val) {
      return later.fd.val(d) > val ? new Date(val) : later.NEVER;
    }
  };
  later.modifier = {};

  later.modifier.after = later.modifier.a = function (constraint, values) {
    var value = values[0];
    return {
      name: "after " + constraint.name,
      range: (constraint.extent(new Date())[1] - value) * constraint.range,
      val: constraint.val,
      isValid: function (d, val) {
        return this.val(d) >= value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function (startDate, val) {
        if (val != value) val = constraint.extent(startDate)[0];
        return constraint.next(startDate, val);
      },
      prev: function (startDate, val) {
        val = val === value ? constraint.extent(startDate)[1] : value - 1;
        return constraint.prev(startDate, val);
      }
    };
  };

  later.modifier.before = later.modifier.b = function (constraint, values) {
    var value = values[values.length - 1];
    return {
      name: "before " + constraint.name,
      range: constraint.range * (value - 1),
      val: constraint.val,
      isValid: function (d, val) {
        return this.val(d) < value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function (startDate, val) {
        val = val === value ? constraint.extent(startDate)[0] : value;
        return constraint.next(startDate, val);
      },
      prev: function (startDate, val) {
        val = val === value ? value - 1 : constraint.extent(startDate)[1];
        return constraint.prev(startDate, val);
      }
    };
  };

  later.compile = function (schedDef) {
    var constraints = [],
        constraintsLen = 0,
        tickConstraint;

    for (var key in schedDef) {
      var nameParts = key.split("_"),
          name = nameParts[0],
          mod = nameParts[1],
          vals = schedDef[key],
          constraint = mod ? later.modifier[mod](later[name], vals) : later[name];
      constraints.push({
        constraint: constraint,
        vals: vals
      });
      constraintsLen++;
    }

    constraints.sort(function (a, b) {
      var ra = a.constraint.range,
          rb = b.constraint.range;
      return rb < ra ? -1 : rb > ra ? 1 : 0;
    });
    tickConstraint = constraints[constraintsLen - 1].constraint;

    function compareFn(dir) {
      return dir === "next" ? function (a, b) {
        return a.getTime() > b.getTime();
      } : function (a, b) {
        return b.getTime() > a.getTime();
      };
    }

    return {
      start: function (dir, startDate) {
        var next = startDate,
            nextVal = later.array[dir],
            maxAttempts = 1e3,
            done;

        while (maxAttempts-- && !done && next) {
          done = true;

          for (var i = 0; i < constraintsLen; i++) {
            var constraint = constraints[i].constraint,
                curVal = constraint.val(next),
                extent = constraint.extent(next),
                newVal = nextVal(curVal, constraints[i].vals, extent);

            if (!constraint.isValid(next, newVal)) {
              next = constraint[dir](next, newVal);
              done = false;
              break;
            }
          }
        }

        if (next !== later.NEVER) {
          next = dir === "next" ? tickConstraint.start(next) : tickConstraint.end(next);
        }

        return next;
      },
      end: function (dir, startDate) {
        var result,
            nextVal = later.array[dir + "Invalid"],
            compare = compareFn(dir);

        for (var i = constraintsLen - 1; i >= 0; i--) {
          var constraint = constraints[i].constraint,
              curVal = constraint.val(startDate),
              extent = constraint.extent(startDate),
              newVal = nextVal(curVal, constraints[i].vals, extent),
              next;

          if (newVal !== undefined) {
            next = constraint[dir](startDate, newVal);

            if (next && (!result || compare(result, next))) {
              result = next;
            }
          }
        }

        return result;
      },
      tick: function (dir, date) {
        return new Date(dir === "next" ? tickConstraint.end(date).getTime() + later.SEC : tickConstraint.start(date).getTime() - later.SEC);
      },
      tickStart: function (date) {
        return tickConstraint.start(date);
      }
    };
  };

  later.schedule = function (sched) {
    if (!sched) throw new Error("Missing schedule definition.");
    if (!sched.schedules) throw new Error("Definition must include at least one schedule.");
    var schedules = [],
        schedulesLen = sched.schedules.length,
        exceptions = [],
        exceptionsLen = sched.exceptions ? sched.exceptions.length : 0;

    for (var i = 0; i < schedulesLen; i++) {
      schedules.push(later.compile(sched.schedules[i]));
    }

    for (var j = 0; j < exceptionsLen; j++) {
      exceptions.push(later.compile(sched.exceptions[j]));
    }

    function getInstances(dir, count, startDate, endDate, isRange) {
      var compare = compareFn(dir),
          loopCount = count,
          maxAttempts = 1e6,
          schedStarts = [],
          exceptStarts = [],
          next,
          end,
          results = [],
          isForward = dir === "next",
          lastResult,
          rStart = isForward ? 0 : 1,
          rEnd = isForward ? 1 : 0;
      startDate = startDate ? new Date(startDate) : new Date();
      if (!startDate || !startDate.getTime()) throw new Error("Invalid start date.");
      setNextStarts(dir, schedules, schedStarts, startDate);
      setRangeStarts(dir, exceptions, exceptStarts, startDate);

      while (maxAttempts-- && loopCount && (next = findNext(schedStarts, compare))) {
        if (endDate && compare(next, endDate)) {
          break;
        }

        if (exceptionsLen) {
          updateRangeStarts(dir, exceptions, exceptStarts, next);

          if (end = calcRangeOverlap(dir, exceptStarts, next)) {
            updateNextStarts(dir, schedules, schedStarts, end);
            continue;
          }
        }

        if (isRange) {
          var maxEndDate = calcMaxEndDate(exceptStarts, compare);
          end = calcEnd(dir, schedules, schedStarts, next, maxEndDate);
          var r = isForward ? [new Date(Math.max(startDate, next)), end ? new Date(endDate ? Math.min(end, endDate) : end) : undefined] : [end ? new Date(endDate ? Math.max(endDate, end.getTime() + later.SEC) : end.getTime() + later.SEC) : undefined, new Date(Math.min(startDate, next.getTime() + later.SEC))];

          if (lastResult && r[rStart].getTime() === lastResult[rEnd].getTime()) {
            lastResult[rEnd] = r[rEnd];
            loopCount++;
          } else {
            lastResult = r;
            results.push(lastResult);
          }

          if (!end) break;
          updateNextStarts(dir, schedules, schedStarts, end);
        } else {
          results.push(isForward ? new Date(Math.max(startDate, next)) : getStart(schedules, schedStarts, next, endDate));
          tickStarts(dir, schedules, schedStarts, next);
        }

        loopCount--;
      }

      for (var i = 0, len = results.length; i < len; i++) {
        var result = results[i];
        results[i] = Object.prototype.toString.call(result) === "[object Array]" ? [cleanDate(result[0]), cleanDate(result[1])] : cleanDate(result);
      }

      return results.length === 0 ? later.NEVER : count === 1 ? results[0] : results;
    }

    function cleanDate(d) {
      if (d instanceof Date && !isNaN(d.valueOf())) {
        return new Date(d);
      }

      return undefined;
    }

    function setNextStarts(dir, schedArr, startsArr, startDate) {
      for (var i = 0, len = schedArr.length; i < len; i++) {
        startsArr[i] = schedArr[i].start(dir, startDate);
      }
    }

    function updateNextStarts(dir, schedArr, startsArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && !compare(startsArr[i], startDate)) {
          startsArr[i] = schedArr[i].start(dir, startDate);
        }
      }
    }

    function setRangeStarts(dir, schedArr, rangesArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        var nextStart = schedArr[i].start(dir, startDate);

        if (!nextStart) {
          rangesArr[i] = later.NEVER;
        } else {
          rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
        }
      }
    }

    function updateRangeStarts(dir, schedArr, rangesArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (rangesArr[i] && !compare(rangesArr[i][0], startDate)) {
          var nextStart = schedArr[i].start(dir, startDate);

          if (!nextStart) {
            rangesArr[i] = later.NEVER;
          } else {
            rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
          }
        }
      }
    }

    function tickStarts(dir, schedArr, startsArr, startDate) {
      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          startsArr[i] = schedArr[i].start(dir, schedArr[i].tick(dir, startDate));
        }
      }
    }

    function getStart(schedArr, startsArr, startDate, minEndDate) {
      var result;

      for (var i = 0, len = startsArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          var start = schedArr[i].tickStart(startDate);

          if (minEndDate && start < minEndDate) {
            return minEndDate;
          }

          if (!result || start > result) {
            result = start;
          }
        }
      }

      return result;
    }

    function calcRangeOverlap(dir, rangesArr, startDate) {
      var compare = compareFn(dir),
          result;

      for (var i = 0, len = rangesArr.length; i < len; i++) {
        var range = rangesArr[i];

        if (range && !compare(range[0], startDate) && (!range[1] || compare(range[1], startDate))) {
          if (!result || compare(range[1], result)) {
            result = range[1];
          }
        }
      }

      return result;
    }

    function calcMaxEndDate(exceptsArr, compare) {
      var result;

      for (var i = 0, len = exceptsArr.length; i < len; i++) {
        if (exceptsArr[i] && (!result || compare(result, exceptsArr[i][0]))) {
          result = exceptsArr[i][0];
        }
      }

      return result;
    }

    function calcEnd(dir, schedArr, startsArr, startDate, maxEndDate) {
      var compare = compareFn(dir),
          result;

      for (var i = 0, len = schedArr.length; i < len; i++) {
        var start = startsArr[i];

        if (start && start.getTime() === startDate.getTime()) {
          var end = schedArr[i].end(dir, start);

          if (maxEndDate && (!end || compare(end, maxEndDate))) {
            return maxEndDate;
          }

          if (!result || compare(end, result)) {
            result = end;
          }
        }
      }

      return result;
    }

    function compareFn(dir) {
      return dir === "next" ? function (a, b) {
        return !b || a.getTime() > b.getTime();
      } : function (a, b) {
        return !a || b.getTime() > a.getTime();
      };
    }

    function findNext(arr, compare) {
      var next = arr[0];

      for (var i = 1, len = arr.length; i < len; i++) {
        if (arr[i] && compare(next, arr[i])) {
          next = arr[i];
        }
      }

      return next;
    }

    return {
      isValid: function (d) {
        return getInstances("next", 1, d, d) !== later.NEVER;
      },
      next: function (count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate);
      },
      prev: function (count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate);
      },
      nextRange: function (count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate, true);
      },
      prevRange: function (count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate, true);
      }
    };
  };

  later.setTimeout = function (fn, sched) {
    var s = later.schedule(sched),
        t;

    if (fn) {
      scheduleTimeout();
    }

    function scheduleTimeout() {
      var now = Date.now(),
          next = s.next(2, now);

      if (!next[0]) {
        t = undefined;
        return;
      }

      var diff = next[0].getTime() - now;

      if (diff < 1e3) {
        diff = next[1] ? next[1].getTime() - now : 1e3;
      }

      if (diff < 2147483647) {
        t = setTimeout(fn, diff);
      } else {
        t = setTimeout(scheduleTimeout, 2147483647);
      }
    }

    return {
      isDone: function () {
        return !t;
      },
      clear: function () {
        clearTimeout(t);
      }
    };
  };

  later.setInterval = function (fn, sched) {
    if (!fn) {
      return;
    }

    var t = later.setTimeout(scheduleTimeout, sched),
        done = t.isDone();

    function scheduleTimeout() {
      if (!done) {
        fn();
        t = later.setTimeout(scheduleTimeout, sched);
      }
    }

    return {
      isDone: function () {
        return t.isDone();
      },
      clear: function () {
        done = true;
        t.clear();
      }
    };
  };

  later.date = {};

  later.date.timezone = function (useLocalTime) {
    later.date.build = useLocalTime ? function (Y, M, D, h, m, s) {
      return new Date(Y, M, D, h, m, s);
    } : function (Y, M, D, h, m, s) {
      return new Date(Date.UTC(Y, M, D, h, m, s));
    };
    var get = useLocalTime ? "get" : "getUTC",
        d = Date.prototype;
    later.date.getYear = d[get + "FullYear"];
    later.date.getMonth = d[get + "Month"];
    later.date.getDate = d[get + "Date"];
    later.date.getDay = d[get + "Day"];
    later.date.getHour = d[get + "Hours"];
    later.date.getMin = d[get + "Minutes"];
    later.date.getSec = d[get + "Seconds"];
    later.date.isUTC = !useLocalTime;
  };

  later.date.UTC = function () {
    later.date.timezone(false);
  };

  later.date.localTime = function () {
    later.date.timezone(true);
  };

  later.date.UTC();
  later.SEC = 1e3;
  later.MIN = later.SEC * 60;
  later.HOUR = later.MIN * 60;
  later.DAY = later.HOUR * 24;
  later.WEEK = later.DAY * 7;
  later.DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  later.NEVER = 0;

  later.date.next = function (Y, M, D, h, m, s) {
    return later.date.build(Y, M !== undefined ? M - 1 : 0, D !== undefined ? D : 1, h || 0, m || 0, s || 0);
  };

  later.date.nextRollover = function (d, val, constraint, period) {
    var cur = constraint.val(d),
        max = constraint.extent(d)[1];
    return (val || max) <= cur || val > max ? new Date(period.end(d).getTime() + later.SEC) : period.start(d);
  };

  later.date.prev = function (Y, M, D, h, m, s) {
    var len = arguments.length;
    M = len < 2 ? 11 : M - 1;
    D = len < 3 ? later.D.extent(later.date.next(Y, M + 1))[1] : D;
    h = len < 4 ? 23 : h;
    m = len < 5 ? 59 : m;
    s = len < 6 ? 59 : s;
    return later.date.build(Y, M, D, h, m, s);
  };

  later.date.prevRollover = function (d, val, constraint, period) {
    var cur = constraint.val(d);
    return val >= cur || !val ? period.start(period.prev(d, period.val(d) - 1)) : period.start(d);
  };

  later.parse = {};

  later.parse.cron = function (expr, hasSeconds) {
    var NAMES = {
      JAN: 1,
      FEB: 2,
      MAR: 3,
      APR: 4,
      MAY: 5,
      JUN: 6,
      JUL: 7,
      AUG: 8,
      SEP: 9,
      OCT: 10,
      NOV: 11,
      DEC: 12,
      SUN: 1,
      MON: 2,
      TUE: 3,
      WED: 4,
      THU: 5,
      FRI: 6,
      SAT: 7
    };
    var REPLACEMENTS = {
      "* * * * * *": "0/1 * * * * *",
      "@YEARLY": "0 0 1 1 *",
      "@ANNUALLY": "0 0 1 1 *",
      "@MONTHLY": "0 0 1 * *",
      "@WEEKLY": "0 0 * * 0",
      "@DAILY": "0 0 * * *",
      "@HOURLY": "0 * * * *"
    };
    var FIELDS = {
      s: [0, 0, 59],
      m: [1, 0, 59],
      h: [2, 0, 23],
      D: [3, 1, 31],
      M: [4, 1, 12],
      Y: [6, 1970, 2099],
      d: [5, 1, 7, 1]
    };

    function getValue(value, offset, max) {
      return isNaN(value) ? NAMES[value] || null : Math.min(+value + (offset || 0), max || 9999);
    }

    function cloneSchedule(sched) {
      var clone = {},
          field;

      for (field in sched) {
        if (field !== "dc" && field !== "d") {
          clone[field] = sched[field].slice(0);
        }
      }

      return clone;
    }

    function add(sched, name, min, max, inc) {
      var i = min;

      if (!sched[name]) {
        sched[name] = [];
      }

      while (i <= max) {
        if (sched[name].indexOf(i) < 0) {
          sched[name].push(i);
        }

        i += inc || 1;
      }

      sched[name].sort(function (a, b) {
        return a - b;
      });
    }

    function addHash(schedules, curSched, value, hash) {
      if (curSched.d && !curSched.dc || curSched.dc && curSched.dc.indexOf(hash) < 0) {
        schedules.push(cloneSchedule(curSched));
        curSched = schedules[schedules.length - 1];
      }

      add(curSched, "d", value, value);
      add(curSched, "dc", hash, hash);
    }

    function addWeekday(s, curSched, value) {
      var except1 = {},
          except2 = {};

      if (value === 1) {
        add(curSched, "D", 1, 3);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", 2, 2);
        add(except1, "d", NAMES.TUE, NAMES.FRI);
        add(except2, "D", 3, 3);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      } else {
        add(curSched, "D", value - 1, value + 1);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", value - 1, value - 1);
        add(except1, "d", NAMES.MON, NAMES.THU);
        add(except2, "D", value + 1, value + 1);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      }

      s.exceptions.push(except1);
      s.exceptions.push(except2);
    }

    function addRange(item, curSched, name, min, max, offset) {
      var incSplit = item.split("/"),
          inc = +incSplit[1],
          range = incSplit[0];

      if (range !== "*" && range !== "0") {
        var rangeSplit = range.split("-");
        min = getValue(rangeSplit[0], offset, max);
        max = getValue(rangeSplit[1], offset, max) || max;
      }

      add(curSched, name, min, max, inc);
    }

    function parse(item, s, name, min, max, offset) {
      var value,
          split,
          schedules = s.schedules,
          curSched = schedules[schedules.length - 1];

      if (item === "L") {
        item = min - 1;
      }

      if ((value = getValue(item, offset, max)) !== null) {
        add(curSched, name, value, value);
      } else if ((value = getValue(item.replace("W", ""), offset, max)) !== null) {
        addWeekday(s, curSched, value);
      } else if ((value = getValue(item.replace("L", ""), offset, max)) !== null) {
        addHash(schedules, curSched, value, min - 1);
      } else if ((split = item.split("#")).length === 2) {
        value = getValue(split[0], offset, max);
        addHash(schedules, curSched, value, getValue(split[1]));
      } else {
        addRange(item, curSched, name, min, max, offset);
      }
    }

    function isHash(item) {
      return item.indexOf("#") > -1 || item.indexOf("L") > 0;
    }

    function itemSorter(a, b) {
      return isHash(a) && !isHash(b) ? 1 : a - b;
    }

    function parseExpr(expr) {
      var schedule = {
        schedules: [{}],
        exceptions: []
      },
          components = expr.replace(/(\s)+/g, " ").split(" "),
          field,
          f,
          component,
          items;

      for (field in FIELDS) {
        f = FIELDS[field];
        component = components[f[0]];

        if (component && component !== "*" && component !== "?") {
          items = component.split(",").sort(itemSorter);
          var i,
              length = items.length;

          for (i = 0; i < length; i++) {
            parse(items[i], schedule, field, f[1], f[2], f[3]);
          }
        }
      }

      return schedule;
    }

    function prepareExpr(expr) {
      var prepared = expr.toUpperCase();
      return REPLACEMENTS[prepared] || prepared;
    }

    var e = prepareExpr(expr);
    return parseExpr(hasSeconds ? e : "0 " + e);
  };

  later.parse.recur = function () {
    var schedules = [],
        exceptions = [],
        cur,
        curArr = schedules,
        curName,
        values,
        every,
        modifier,
        applyMin,
        applyMax,
        i,
        last;

    function add(name, min, max) {
      name = modifier ? name + "_" + modifier : name;

      if (!cur) {
        curArr.push({});
        cur = curArr[0];
      }

      if (!cur[name]) {
        cur[name] = [];
      }

      curName = cur[name];

      if (every) {
        values = [];

        for (i = min; i <= max; i += every) {
          values.push(i);
        }

        last = {
          n: name,
          x: every,
          c: curName.length,
          m: max
        };
      }

      values = applyMin ? [min] : applyMax ? [max] : values;
      var length = values.length;

      for (i = 0; i < length; i += 1) {
        var val = values[i];

        if (curName.indexOf(val) < 0) {
          curName.push(val);
        }
      }

      values = every = modifier = applyMin = applyMax = 0;
    }

    return {
      schedules: schedules,
      exceptions: exceptions,
      on: function () {
        values = arguments[0] instanceof Array ? arguments[0] : arguments;
        return this;
      },
      every: function (x) {
        every = x || 1;
        return this;
      },
      after: function (x) {
        modifier = "a";
        values = [x];
        return this;
      },
      before: function (x) {
        modifier = "b";
        values = [x];
        return this;
      },
      first: function () {
        applyMin = 1;
        return this;
      },
      last: function () {
        applyMax = 1;
        return this;
      },
      time: function () {
        for (var i = 0, len = values.length; i < len; i++) {
          var split = values[i].split(":");
          if (split.length < 3) split.push(0);
          values[i] = +split[0] * 3600 + +split[1] * 60 + +split[2];
        }

        add("t");
        return this;
      },
      second: function () {
        add("s", 0, 59);
        return this;
      },
      minute: function () {
        add("m", 0, 59);
        return this;
      },
      hour: function () {
        add("h", 0, 23);
        return this;
      },
      dayOfMonth: function () {
        add("D", 1, applyMax ? 0 : 31);
        return this;
      },
      dayOfWeek: function () {
        add("d", 1, 7);
        return this;
      },
      onWeekend: function () {
        values = [1, 7];
        return this.dayOfWeek();
      },
      onWeekday: function () {
        values = [2, 3, 4, 5, 6];
        return this.dayOfWeek();
      },
      dayOfWeekCount: function () {
        add("dc", 1, applyMax ? 0 : 5);
        return this;
      },
      dayOfYear: function () {
        add("dy", 1, applyMax ? 0 : 366);
        return this;
      },
      weekOfMonth: function () {
        add("wm", 1, applyMax ? 0 : 5);
        return this;
      },
      weekOfYear: function () {
        add("wy", 1, applyMax ? 0 : 53);
        return this;
      },
      month: function () {
        add("M", 1, 12);
        return this;
      },
      year: function () {
        add("Y", 1970, 2450);
        return this;
      },
      fullDate: function () {
        for (var i = 0, len = values.length; i < len; i++) {
          values[i] = values[i].getTime();
        }

        add("fd");
        return this;
      },
      customModifier: function (id, vals) {
        var custom = later.modifier[id];
        if (!custom) throw new Error("Custom modifier " + id + " not recognized!");
        modifier = id;
        values = arguments[1] instanceof Array ? arguments[1] : [arguments[1]];
        return this;
      },
      customPeriod: function (id) {
        var custom = later[id];
        if (!custom) throw new Error("Custom time period " + id + " not recognized!");
        add(id, custom.extent(new Date())[0], custom.extent(new Date())[1]);
        return this;
      },
      startingOn: function (start) {
        return this.between(start, last.m);
      },
      between: function (start, end) {
        cur[last.n] = cur[last.n].splice(0, last.c);
        every = last.x;
        add(last.n, start, end);
        return this;
      },
      and: function () {
        cur = curArr[curArr.push({}) - 1];
        return this;
      },
      except: function () {
        curArr = exceptions;
        cur = null;
        return this;
      }
    };
  };

  later.parse.text = function (str) {
    var recur = later.parse.recur,
        pos = 0,
        input = "",
        error;
    var TOKENTYPES = {
      eof: /^$/,
      fullDate: /^(\d\d\d\d-\d\d-\d\dt\d\d:\d\d:\d\d)\b/,
      rank: /^((\d\d\d\d)|([2-5]?1(st)?|[2-5]?2(nd)?|[2-5]?3(rd)?|(0|[1-5]?[4-9]|[1-5]0|1[1-3])(th)?))\b/,
      time: /^((([0]?[1-9]|1[0-2]):[0-5]\d(\s)?(am|pm))|(([0]?\d|1\d|2[0-3]):[0-5]\d))\b/,
      dayName: /^((sun|mon|tue(s)?|wed(nes)?|thu(r(s)?)?|fri|sat(ur)?)(day)?)\b/,
      monthName: /^(jan(uary)?|feb(ruary)?|ma((r(ch)?)?|y)|apr(il)?|ju(ly|ne)|aug(ust)?|oct(ober)?|(sept|nov|dec)(ember)?)\b/,
      yearIndex: /^(\d\d\d\d)\b/,
      every: /^every\b/,
      after: /^after\b/,
      before: /^before\b/,
      second: /^(s|sec(ond)?(s)?)\b/,
      minute: /^(m|min(ute)?(s)?)\b/,
      hour: /^(h|hour(s)?)\b/,
      day: /^(day(s)?( of the month)?)\b/,
      dayInstance: /^day instance\b/,
      dayOfWeek: /^day(s)? of the week\b/,
      dayOfYear: /^day(s)? of the year\b/,
      weekOfYear: /^week(s)?( of the year)?\b/,
      weekOfMonth: /^week(s)? of the month\b/,
      weekday: /^weekday\b/,
      weekend: /^weekend\b/,
      month: /^month(s)?\b/,
      year: /^year(s)?\b/,
      between: /^between (the)?\b/,
      start: /^(start(ing)? (at|on( the)?)?)\b/,
      at: /^(at|@)\b/,
      and: /^(,|and\b)/,
      except: /^(except\b)/,
      also: /(also)\b/,
      first: /^(first)\b/,
      last: /^last\b/,
      "in": /^in\b/,
      of: /^of\b/,
      onthe: /^on the\b/,
      on: /^on\b/,
      through: /(-|^(to|through)\b)/
    };
    var NAMES = {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12,
      sun: 1,
      mon: 2,
      tue: 3,
      wed: 4,
      thu: 5,
      fri: 6,
      sat: 7,
      "1st": 1,
      fir: 1,
      "2nd": 2,
      sec: 2,
      "3rd": 3,
      thi: 3,
      "4th": 4,
      "for": 4
    };

    function t(start, end, text, type) {
      return {
        startPos: start,
        endPos: end,
        text: text,
        type: type
      };
    }

    function peek(expected) {
      var scanTokens = expected instanceof Array ? expected : [expected],
          whiteSpace = /\s+/,
          token,
          curInput,
          m,
          scanToken,
          start,
          len;
      scanTokens.push(whiteSpace);
      start = pos;

      while (!token || token.type === whiteSpace) {
        len = -1;
        curInput = input.substring(start);
        token = t(start, start, input.split(whiteSpace)[0]);
        var i,
            length = scanTokens.length;

        for (i = 0; i < length; i++) {
          scanToken = scanTokens[i];
          m = scanToken.exec(curInput);

          if (m && m.index === 0 && m[0].length > len) {
            len = m[0].length;
            token = t(start, start + len, curInput.substring(0, len), scanToken);
          }
        }

        if (token.type === whiteSpace) {
          start = token.endPos;
        }
      }

      return token;
    }

    function scan(expectedToken) {
      var token = peek(expectedToken);
      pos = token.endPos;
      return token;
    }

    function parseThroughExpr(tokenType) {
      var start = +parseTokenValue(tokenType),
          end = checkAndParse(TOKENTYPES.through) ? +parseTokenValue(tokenType) : start,
          nums = [];

      for (var i = start; i <= end; i++) {
        nums.push(i);
      }

      return nums;
    }

    function parseRanges(tokenType) {
      var nums = parseThroughExpr(tokenType);

      while (checkAndParse(TOKENTYPES.and)) {
        nums = nums.concat(parseThroughExpr(tokenType));
      }

      return nums;
    }

    function parseEvery(r) {
      var num, period, start, end;

      if (checkAndParse(TOKENTYPES.weekend)) {
        r.on(NAMES.sun, NAMES.sat).dayOfWeek();
      } else if (checkAndParse(TOKENTYPES.weekday)) {
        r.on(NAMES.mon, NAMES.tue, NAMES.wed, NAMES.thu, NAMES.fri).dayOfWeek();
      } else {
        num = parseTokenValue(TOKENTYPES.rank);
        r.every(num);
        period = parseTimePeriod(r);

        if (checkAndParse(TOKENTYPES.start)) {
          num = parseTokenValue(TOKENTYPES.rank);
          r.startingOn(num);
          parseToken(period.type);
        } else if (checkAndParse(TOKENTYPES.between)) {
          start = parseTokenValue(TOKENTYPES.rank);

          if (checkAndParse(TOKENTYPES.and)) {
            end = parseTokenValue(TOKENTYPES.rank);
            r.between(start, end);
          }
        }
      }
    }

    function parseOnThe(r) {
      if (checkAndParse(TOKENTYPES.first)) {
        r.first();
      } else if (checkAndParse(TOKENTYPES.last)) {
        r.last();
      } else {
        r.on(parseRanges(TOKENTYPES.rank));
      }

      parseTimePeriod(r);
    }

    function parseScheduleExpr(str) {
      pos = 0;
      input = str;
      error = -1;
      var r = recur();

      while (pos < input.length && error < 0) {
        var token = parseToken([TOKENTYPES.every, TOKENTYPES.after, TOKENTYPES.before, TOKENTYPES.onthe, TOKENTYPES.on, TOKENTYPES.of, TOKENTYPES["in"], TOKENTYPES.at, TOKENTYPES.and, TOKENTYPES.except, TOKENTYPES.also]);

        switch (token.type) {
          case TOKENTYPES.every:
            parseEvery(r);
            break;

          case TOKENTYPES.after:
            if (peek(TOKENTYPES.time).type !== undefined) {
              r.after(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else if (peek(TOKENTYPES.fullDate).type !== undefined) {
              r.after(parseTokenValue(TOKENTYPES.fullDate));
              r.fullDate();
            } else {
              r.after(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }

            break;

          case TOKENTYPES.before:
            if (peek(TOKENTYPES.time).type !== undefined) {
              r.before(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else if (peek(TOKENTYPES.fullDate).type !== undefined) {
              r.before(parseTokenValue(TOKENTYPES.fullDate));
              r.fullDate();
            } else {
              r.before(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }

            break;

          case TOKENTYPES.onthe:
            parseOnThe(r);
            break;

          case TOKENTYPES.on:
            r.on(parseRanges(TOKENTYPES.dayName)).dayOfWeek();
            break;

          case TOKENTYPES.of:
            r.on(parseRanges(TOKENTYPES.monthName)).month();
            break;

          case TOKENTYPES["in"]:
            r.on(parseRanges(TOKENTYPES.yearIndex)).year();
            break;

          case TOKENTYPES.at:
            r.on(parseTokenValue(TOKENTYPES.time)).time();

            while (checkAndParse(TOKENTYPES.and)) {
              r.on(parseTokenValue(TOKENTYPES.time)).time();
            }

            break;

          case TOKENTYPES.and:
            break;

          case TOKENTYPES.also:
            r.and();
            break;

          case TOKENTYPES.except:
            r.except();
            break;

          default:
            error = pos;
        }
      }

      return {
        schedules: r.schedules,
        exceptions: r.exceptions,
        error: error
      };
    }

    function parseTimePeriod(r) {
      var timePeriod = parseToken([TOKENTYPES.second, TOKENTYPES.minute, TOKENTYPES.hour, TOKENTYPES.dayOfYear, TOKENTYPES.dayOfWeek, TOKENTYPES.dayInstance, TOKENTYPES.day, TOKENTYPES.month, TOKENTYPES.year, TOKENTYPES.weekOfMonth, TOKENTYPES.weekOfYear]);

      switch (timePeriod.type) {
        case TOKENTYPES.second:
          r.second();
          break;

        case TOKENTYPES.minute:
          r.minute();
          break;

        case TOKENTYPES.hour:
          r.hour();
          break;

        case TOKENTYPES.dayOfYear:
          r.dayOfYear();
          break;

        case TOKENTYPES.dayOfWeek:
          r.dayOfWeek();
          break;

        case TOKENTYPES.dayInstance:
          r.dayOfWeekCount();
          break;

        case TOKENTYPES.day:
          r.dayOfMonth();
          break;

        case TOKENTYPES.weekOfMonth:
          r.weekOfMonth();
          break;

        case TOKENTYPES.weekOfYear:
          r.weekOfYear();
          break;

        case TOKENTYPES.month:
          r.month();
          break;

        case TOKENTYPES.year:
          r.year();
          break;

        default:
          error = pos;
      }

      return timePeriod;
    }

    function checkAndParse(tokenType) {
      var found = peek(tokenType).type === tokenType;

      if (found) {
        scan(tokenType);
      }

      return found;
    }

    function parseToken(tokenType) {
      var t = scan(tokenType);

      if (t.type) {
        t.text = convertString(t.text, tokenType);
      } else {
        error = pos;
      }

      return t;
    }

    function parseTokenValue(tokenType) {
      return parseToken(tokenType).text;
    }

    function convertString(str, tokenType) {
      var output = str;

      switch (tokenType) {
        case TOKENTYPES.time:
          var parts = str.split(/(:|am|pm)/),
              hour = parts[3] === "pm" && parts[0] < 12 ? parseInt(parts[0], 10) + 12 : parts[0],
              min = parts[2].trim();
          output = (hour.length === 1 ? "0" : "") + hour + ":" + min;
          break;

        case TOKENTYPES.rank:
          output = parseInt(/^\d+/.exec(str)[0], 10);
          break;

        case TOKENTYPES.monthName:
        case TOKENTYPES.dayName:
          output = NAMES[str.substring(0, 3)];
          break;

        case TOKENTYPES.fullDate:
          output = new Date(str.toUpperCase());
          break;
      }

      return output;
    }

    return parseScheduleExpr(str.toLowerCase());
  };

  return later;
}(); // Set the local time mode for "later" library

later.date.localTime();
/* harmony default export */ __webpack_exports__["default"] = (later);

/***/ }),

/***/ "./lib/Gantt/column/AddNewColumn.js":
/*!******************************************!*\
  !*** ./lib/Gantt/column/AddNewColumn.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AddNewColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';




/**
 * @module Gantt/column/AddNewColumn
 */

/**
 * This column allows user to dynamically add columns to the Gantt chart by clicking the column header
 * and picking columns from a combobox.
 *
 * ## Adding a custom column to the combobox
 *
 * In order to appear in the column combobox list a column class have to fulfill these conditions:
 *
 * 1. the class should have a static property `type` with unique string value that will identify the column.
 * 2. the class should be registered with the call to {@link Grid/data/ColumnStore#function-registerColumnType-static ColumnStore.registerColumnType}.
 * 3. the class should have a static property `isGanttColumn` with truthy value.
 * 4. the class should have a static `text` property with column name.
 *
 * For example:
 *
 * ```javascript
 * import ColumnStore from 'gantt-distr/lib/Grid/data/ColumnStore.js';
 * import Column from 'gantt-distr/lib/Grid/column/Column.js';
 *
 * // New column class to display task priority
 * export default class TaskPriorityColumn extends Column {
 *     // unique alias of the column
 *     static get type() {
 *         return 'priority';
 *     }
 *
 *     // indicates that the column should be present in "Add New..." column
 *     static get isGanttColumn() {
 *         return true;
 *     }
 *
 *     static get defaults() {
 *         return {
 *             // the column is mapped to "priority" field of the Task model
 *             field : 'priority',
 *             // the column title
 *             text  : 'Priority'
 *         };
 *     }
 * }
 *
 * // register new column
 * ColumnStore.registerColumnType(TaskPriorityColumn);
 * ```
 *
 * @extends Grid/column/Column
 * @classType addnew
 */

class AddNewColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AddNewColumn';
  }

  static get type() {
    return 'addnew';
  }

  static get defaults() {
    return {
      text: 'L{New Column}',
      cls: 'b-new-column-column',
      draggable: false,
      sortable: false,
      exportable: false,
      field: null,
      editor: null
    };
  }

  doDestroy() {
    var _this$_combo;

    (_this$_combo = this._combo) === null || _this$_combo === void 0 ? void 0 : _this$_combo.destroy();
    super.doDestroy();
  }
  /**
   * Returns the combo box field rendered into the header of this column
   * @property {Core.widget.Combo}
   * @readonly
   */


  get combo() {
    const me = this,
          columns = me.grid.columns;
    return me._combo || (me._combo = new _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      owner: me.grid,
      cls: 'b-new-column-combo',
      placeholder: me.L('L{New Column}'),
      triggers: false,
      autoExpand: true,
      store: me.ganttColumnStore,
      displayField: 'text',
      monitorResize: false,
      picker: {
        align: {
          align: 't0-b0',
          axisLock: true
        },
        minWidth: 200,

        onItem({
          record: columnRecord
        }) {
          const newColumn = new columnRecord.value({
            region: me.region
          }, columns); // Insert the new column before the "New Column" column
          // then focus it to ensure it is in view.

          columns.insert(columns.indexOf(me), newColumn);
          newColumn.element.focus();
        },

        // Column elements are rerendered, so the forElement must be kept up to date
        onBeforeShow() {
          this.forElement = me.element;
        }

      },

      syncInputFieldValue() {
        this.input.value = '';
      },

      listeners: {
        // Keystrokes must not leak up to the Grid where its Navigator will react
        keydown({
          event
        }) {
          event.stopImmediatePropagation();
        }

      }
    }));
  }

  get ganttColumnStore() {
    // Create a store containing the Gantt column classes.
    // A filter ensures that column types which are already
    // present in the grid are not shown.
    return new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      data: Object.values(_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].columnTypes).reduce((result, col) => {
        // We must ensure that the defaultValues property is calculated
        // so that we can detect a text property.
        if (!col.$meta.fields.exposedData) {
          col.exposeProperties({});
        } // To be included, a column must have a static isGanttColumn
        // property which yields a truthy value, and a text value.


        if (col.isGanttColumn && col.text) {
          result.push({
            id: col.type,
            text: col.optionalL(col.text),
            value: col
          });
        }

        return result;
      }, []),
      filters: [// A colRecord is only filtered in if the grid columns do not contain an instance.
      colRecord => !this.grid.columns.some(gridCol => gridCol.constructor === colRecord.value)],
      sorters: [{
        field: 'text'
      }]
    });
  }

  headerRenderer({
    column,
    headerElement
  }) {
    column.combo.render(headerElement);
  }

  onKeyDown(event) {
    if (event.key === 'Enter') {
      this.combo.focus();
    }
  }

  updateLocalization() {
    // reset cached combo to rebuild options store w/ new translated column names
    if (this._combo) {
      this._combo.destroy();

      this._combo = null;
    }

    super.updateLocalization();
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerColumnType(AddNewColumn);
AddNewColumn._$name = 'AddNewColumn';

/***/ }),

/***/ "./lib/Gantt/column/AllColumns.js":
/*!****************************************!*\
  !*** ./lib/Gantt/column/AllColumns.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AddNewColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AddNewColumn.js */ "./lib/Gantt/column/AddNewColumn.js");
/* harmony import */ var _CalendarColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarColumn.js */ "./lib/Gantt/column/CalendarColumn.js");
/* harmony import */ var _ConstraintDateColumn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ConstraintDateColumn.js */ "./lib/Gantt/column/ConstraintDateColumn.js");
/* harmony import */ var _ConstraintTypeColumn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ConstraintTypeColumn.js */ "./lib/Gantt/column/ConstraintTypeColumn.js");
/* harmony import */ var _DeadlineDateColumn_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DeadlineDateColumn.js */ "./lib/Gantt/column/DeadlineDateColumn.js");
/* harmony import */ var _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../SchedulerPro/column/DurationColumn.js */ "./lib/SchedulerPro/column/DurationColumn.js");
/* harmony import */ var _EarlyEndDateColumn_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EarlyEndDateColumn.js */ "./lib/Gantt/column/EarlyEndDateColumn.js");
/* harmony import */ var _EarlyStartDateColumn_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EarlyStartDateColumn.js */ "./lib/Gantt/column/EarlyStartDateColumn.js");
/* harmony import */ var _EffortColumn_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EffortColumn.js */ "./lib/Gantt/column/EffortColumn.js");
/* harmony import */ var _EndDateColumn_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./EndDateColumn.js */ "./lib/Gantt/column/EndDateColumn.js");
/* harmony import */ var _InactiveColumn_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./InactiveColumn.js */ "./lib/Gantt/column/InactiveColumn.js");
/* harmony import */ var _LateEndDateColumn_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./LateEndDateColumn.js */ "./lib/Gantt/column/LateEndDateColumn.js");
/* harmony import */ var _LateStartDateColumn_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./LateStartDateColumn.js */ "./lib/Gantt/column/LateStartDateColumn.js");
/* harmony import */ var _ManuallyScheduledColumn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ManuallyScheduledColumn.js */ "./lib/Gantt/column/ManuallyScheduledColumn.js");
/* harmony import */ var _MilestoneColumn_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./MilestoneColumn.js */ "./lib/Gantt/column/MilestoneColumn.js");
/* harmony import */ var _NameColumn_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./NameColumn.js */ "./lib/Gantt/column/NameColumn.js");
/* harmony import */ var _NoteColumn_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./NoteColumn.js */ "./lib/Gantt/column/NoteColumn.js");
/* harmony import */ var _PercentDoneColumn_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./PercentDoneColumn.js */ "./lib/Gantt/column/PercentDoneColumn.js");
/* harmony import */ var _PredecessorColumn_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./PredecessorColumn.js */ "./lib/Gantt/column/PredecessorColumn.js");
/* harmony import */ var _ResourceAssignmentColumn_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./ResourceAssignmentColumn.js */ "./lib/Gantt/column/ResourceAssignmentColumn.js");
/* harmony import */ var _RollupColumn_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./RollupColumn.js */ "./lib/Gantt/column/RollupColumn.js");
/* harmony import */ var _SchedulingModeColumn_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./SchedulingModeColumn.js */ "./lib/Gantt/column/SchedulingModeColumn.js");
/* harmony import */ var _SequenceColumn_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./SequenceColumn.js */ "./lib/Gantt/column/SequenceColumn.js");
/* harmony import */ var _ShowInTimelineColumn_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./ShowInTimelineColumn.js */ "./lib/Gantt/column/ShowInTimelineColumn.js");
/* harmony import */ var _StartDateColumn_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./StartDateColumn.js */ "./lib/Gantt/column/StartDateColumn.js");
/* harmony import */ var _SuccessorColumn_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./SuccessorColumn.js */ "./lib/Gantt/column/SuccessorColumn.js");
/* harmony import */ var _TotalSlackColumn_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./TotalSlackColumn.js */ "./lib/Gantt/column/TotalSlackColumn.js");
/* harmony import */ var _WBSColumn_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./WBSColumn.js */ "./lib/Gantt/column/WBSColumn.js");
var productName = 'gantt';










 // Not including EventModelColumn on purpose


















/**
 * @module Gantt/column/AllColumns
 *
 * Imports all currently developed Gantt columns and re-exports them in an object.
 * Should be used to import and register all Gantt columns.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  AddNewColumn: _AddNewColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  CalendarColumn: _CalendarColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  ConstraintDateColumn: _ConstraintDateColumn_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  ConstraintTypeColumn: _ConstraintTypeColumn_js__WEBPACK_IMPORTED_MODULE_3__["default"],
  DeadlineDateColumn: _DeadlineDateColumn_js__WEBPACK_IMPORTED_MODULE_4__["default"],
  DurationColumn: _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_5__["default"],
  EarlyEndDateColumn: _EarlyEndDateColumn_js__WEBPACK_IMPORTED_MODULE_6__["default"],
  EarlyStartDateColumn: _EarlyStartDateColumn_js__WEBPACK_IMPORTED_MODULE_7__["default"],
  EffortColumn: _EffortColumn_js__WEBPACK_IMPORTED_MODULE_8__["default"],
  EndDateColumn: _EndDateColumn_js__WEBPACK_IMPORTED_MODULE_9__["default"],
  InactiveColumn: _InactiveColumn_js__WEBPACK_IMPORTED_MODULE_10__["default"],
  LateEndDateColumn: _LateEndDateColumn_js__WEBPACK_IMPORTED_MODULE_11__["default"],
  LateStartDateColumn: _LateStartDateColumn_js__WEBPACK_IMPORTED_MODULE_12__["default"],
  ManuallyScheduledColumn: _ManuallyScheduledColumn_js__WEBPACK_IMPORTED_MODULE_13__["default"],
  MilestoneColumn: _MilestoneColumn_js__WEBPACK_IMPORTED_MODULE_14__["default"],
  NameColumn: _NameColumn_js__WEBPACK_IMPORTED_MODULE_15__["default"],
  NoteColumn: _NoteColumn_js__WEBPACK_IMPORTED_MODULE_16__["default"],
  PercentDoneColumn: _PercentDoneColumn_js__WEBPACK_IMPORTED_MODULE_17__["default"],
  PredecessorColumn: _PredecessorColumn_js__WEBPACK_IMPORTED_MODULE_18__["default"],
  ResourceAssignmentColumn: _ResourceAssignmentColumn_js__WEBPACK_IMPORTED_MODULE_19__["default"],
  RollupColumn: _RollupColumn_js__WEBPACK_IMPORTED_MODULE_20__["default"],
  SchedulingModeColumn: _SchedulingModeColumn_js__WEBPACK_IMPORTED_MODULE_21__["default"],
  SequenceColumn: _SequenceColumn_js__WEBPACK_IMPORTED_MODULE_22__["default"],
  ShowInTimelineColumn: _ShowInTimelineColumn_js__WEBPACK_IMPORTED_MODULE_23__["default"],
  StartDateColumn: _StartDateColumn_js__WEBPACK_IMPORTED_MODULE_24__["default"],
  SuccessorColumn: _SuccessorColumn_js__WEBPACK_IMPORTED_MODULE_25__["default"],
  TotalSlackColumn: _TotalSlackColumn_js__WEBPACK_IMPORTED_MODULE_26__["default"],
  WBSColumn: _WBSColumn_js__WEBPACK_IMPORTED_MODULE_27__["default"]
});

/***/ }),

/***/ "./lib/Gantt/column/CalendarColumn.js":
/*!********************************************!*\
  !*** ./lib/Gantt/column/CalendarColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _widget_CalendarPicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widget/CalendarPicker.js */ "./lib/Gantt/widget/CalendarPicker.js");
var productName = 'gantt';



/**
 * @module Gantt/column/CalendarColumn
 */

/**
 * A column that displays (and allows user to update) the current {@link Gantt.model.CalendarModel calendar} of the task.
 *
 * Default editor is a {@link Gantt.widget.CalendarPicker CalendarPicker}.
 *
 * @extends Grid/column/Column
 * @classType calendar
 */

class CalendarColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CalendarColumn';
  }

  static get type() {
    return 'calendar';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'calendar',
      text: 'L{Calendar}',
      editor: {
        type: _widget_CalendarPicker_js__WEBPACK_IMPORTED_MODULE_2__["default"].type,
        clearable: true,
        allowInvalid: false
      }
    };
  }

  afterConstruct() {
    const me = this;
    super.afterConstruct();
    const project = me.grid.project; // Store default calendar to filter out this value

    me.defaultCalendar = project.defaultCalendar;
    me.refreshCalendars();
    project.calendarManagerStore.on({
      changePreCommit: me.refreshCalendars,
      refresh: me.refreshCalendars,
      thisObj: me
    });
  } // region Events


  refreshCalendars() {
    if (this.editor) {
      const project = this.grid.project;
      this.editor.refreshCalendars(project.calendarManagerStore.getRange());
    }
  } // endregion


  renderer({
    value
  }) {
    if (value !== this.defaultCalendar && (value === null || value === void 0 ? void 0 : value.id) != null) {
      var _model$name;

      const model = this.grid.project.calendarManagerStore.getById(value.id);
      return (_model$name = model === null || model === void 0 ? void 0 : model.name) !== null && _model$name !== void 0 ? _model$name : '';
    }

    return '';
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(CalendarColumn);
CalendarColumn._$name = 'CalendarColumn';

/***/ }),

/***/ "./lib/Gantt/column/ConstraintDateColumn.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/column/ConstraintDateColumn.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ConstraintDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Gantt/column/GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/ConstraintDateColumn
 */

/**
 * A column showing the {@link Gantt.model.TaskModel#field-constraintDate date} of the constraint, applied to the task.
 * The type of the constraint can be displayed with the {@link Gantt/column/ConstraintTypeColumn ConstraintTypeColumn}.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType constraintdate
 */

class ConstraintDateColumn extends _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ConstraintDateColumn';
  }

  static get type() {
    return 'constraintdate';
  }

  static get defaults() {
    return {
      field: 'constraintDate',
      text: 'L{Constraint Date}',
      width: 146
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(ConstraintDateColumn);
ConstraintDateColumn._$name = 'ConstraintDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/ConstraintTypeColumn.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/column/ConstraintTypeColumn.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ConstraintTypeColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _SchedulerPro_widget_ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../SchedulerPro/widget/ConstraintTypePicker.js */ "./lib/SchedulerPro/widget/ConstraintTypePicker.js");
var productName = 'gantt';




/**
 * @module Gantt/column/ConstraintTypeColumn
 */

/**
 * {@link Gantt/model/TaskModel#field-constraintType Constraint type} column.
 *
 * Default editor is a {@link SchedulerPro/widget/ConstraintTypePicker}.
 *
 * The constraint can be one of:
 *
 * - Must start on [date]
 * - Must finish on [date]
 * - Start no earlier than [date]
 * - Start no later than [date]
 * - Finish no earlier than [date]
 * - Finish no later than [date]
 *
 * The date of the constraint can be specified with the {@link Gantt/column/ConstraintDateColumn}
 *
 * @extends Grid/column/Column
 * @classType constrainttype
 */

class ConstraintTypeColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ConstraintTypeColumn';
  }

  static get type() {
    return 'constrainttype';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'constraintType',
      text: 'L{Constraint Type}',
      width: 146,
      editor: {
        type: _SchedulerPro_widget_ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_3__["default"].type,
        clearable: true,
        allowInvalid: false
      },
      filterable: {
        filterField: {
          type: 'constrainttypepicker'
        }
      }
    };
  }

  afterConstruct() {
    const me = this;
    super.afterConstruct();
    me.grid.on({
      startCellEdit: me.onStartCellEdit,
      finishCellEdit: me.onDoneCellEdit,
      cancelCellEdit: me.onDoneCellEdit,
      thisObj: me
    }); // we need to trigger the column refresh **after** the editor locale change
    // to display properly translated constraint types

    _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createSequence(me.editor.updateLocalization, me.onEditorLocaleChange, me);
  }

  onStartCellEdit({
    editorContext: {
      editor,
      record
    }
  }) {
    if (editor.inputField instanceof _SchedulerPro_widget_ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
      /* eslint-disable quote-props */
      editor.inputField.store.addFilter({
        'id': 'isConstraintTypeApplicable',
        filterBy: r => record.run('isConstraintTypeApplicable', r.id)
      });
      /* eslint-enable quote-props */

      this._filterDetacher = () => editor.inputField.store.removeFilter('isConstraintTypeApplicable');
    }
  }

  onDoneCellEdit() {
    this._filterDetacher && this._filterDetacher();
  } // * reactiveRenderer() {
  //     const
  //         value = yield this.record.$.constraintType,
  //         model = this.column.editor.store.getById(value);
  //
  //     return model && model.text || '';
  //
  // }


  renderer({
    value
  }) {
    // id 'none' is the special "None" record, so render empty cell.
    const model = value != null && value !== 'none' && this.editor.store.getById(value);
    return model && model.text || '';
  } // Refreshes the column **after** the editor locale change
  // to display properly translated constraint types


  onEditorLocaleChange() {
    this.grid.refreshColumn(this);
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ConstraintTypeColumn);
ConstraintTypeColumn._$name = 'ConstraintTypeColumn';

/***/ }),

/***/ "./lib/Gantt/column/DeadlineDateColumn.js":
/*!************************************************!*\
  !*** ./lib/Gantt/column/DeadlineDateColumn.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DeadlineDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Gantt/column/GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/DeadlineDateColumn
 */

/**
 * A column showing the {@link Gantt/model/TaskModel#field-deadlineDate} field.
 *
 * Default editor is a {@link Core/widget/DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler/view/mixin/TimelineViewPresets#config-displayDateFormat}
 * will be used as a default value and the format will be dynamically updated while zooming according to the
 * {@link Scheduler/preset/ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType deadlinedate
 */

class DeadlineDateColumn extends _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'DeadlineDateColumn';
  }

  static get type() {
    return 'deadlinedate';
  }

  static get defaults() {
    return {
      field: 'deadlineDate',
      text: 'L{Deadline}',
      width: 146
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(DeadlineDateColumn);
DeadlineDateColumn._$name = 'DeadlineDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/DependencyColumn.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/column/DependencyColumn.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _widget_DependencyField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widget/DependencyField.js */ "./lib/Gantt/widget/DependencyField.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
var productName = 'gantt';





/**
 * @module Gantt/column/DependencyColumn
 */

const hasNoProject = v => !v.project,
      depIsValid = v => v;
/**
 * A column which displays, in textual form, the dependencies which either link to the
 * contextual task from other, preceding tasks, or dependencies which link the
 * contextual task to successor tasks.
 *
 * Default editor is a {@link Gantt/widget/DependencyField}.
 *
 * The {@link Grid/column/Column#config-field} MUST be either `predecessors` or `successors` in order
 * for this column to know what kind of dependency it is showing.
 *
 * By default predecessors and successors have a task ID as a value. But it's configurable and any field may be used to display there (as example: wbsCode or sequenceNumber)
 * using {@link #config-dependencyIdField}
 *
 * @classType dependency
 * @extends Grid/column/Column
 */


class DependencyColumn extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DependencyColumn';
  }

  static get type() {
    return 'dependency';
  }

  static get fields() {
    return [
    /**
     * Delimiter used for displayed value and editor
     * @config {String} delimiter
     */
    {
      name: 'delimiter',
      defaultValue: ';'
    },
    /**
     * A task field (id, wbsCode, sequenceNumber etc) that will be used when displaying and editing linked tasks. Defaults to {@link Gantt/view/GanttBase#config-dependencyIdField}
     * @config {String} dependencyIdField
     */
    {
      name: 'dependencyIdField',
      defaultValue: null
    }];
  }

  static get defaults() {
    return {
      htmlEncode: false,
      width: 120,

      renderer({
        record,
        grid
      }) {
        const dependencyIdField = this.dependencyIdField || grid.dependencyIdField;
        return _widget_DependencyField_js__WEBPACK_IMPORTED_MODULE_2__["default"].dependenciesToString(record[this.field], this.field === 'predecessors' ? 'from' : 'to', this.delimiter, dependencyIdField);
      },

      filterable({
        value,
        record: taskRecord,
        column
      }) {
        const dependencyIdField = column.dependencyIdField || column.grid.dependencyIdField;
        value = value.toLowerCase();
        return taskRecord[`${column.field === 'predecessors' ? 'predecessorTasks' : 'successorTasks'}`].some(linkedTask => {
          var _linkedTask$dependenc;

          return linkedTask && value.includes((_linkedTask$dependenc = linkedTask[dependencyIdField]) === null || _linkedTask$dependenc === void 0 ? void 0 : _linkedTask$dependenc.toString().toLowerCase());
        });
      }

    };
  }

  afterConstruct() {
    super.afterConstruct();
  }

  getFilterableValue(record) {
    return this.renderer({
      record,
      grid: this.grid
    });
  }

  async finalizeCellEdit({
    grid,
    record,
    inputField,
    value,
    oldValue,
    editorContext
  }) {
    if (record && value) {
      value = value.slice();
      const toValidate = value.filter(hasNoProject),
            project = grid.dependencyStore.getProject(),
            oldDependencies = record[this.field];
      await project.commitAsync();
      if (project.isDestroyed) return;
      const results = await Promise.all(toValidate.map(dependency => project.isValidDependencyModel(dependency, oldDependencies)));
      const valid = results.every(depIsValid); // Validation failed; revert the field's value

      if (!valid) {
        inputField.value = oldValue;
        _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_4__["default"].show({
          html: editorContext.column.L('L{Invalid dependency}'),
          rootElement: this.grid.rootElement
        });
      }

      return valid;
    }
  }

  get defaultEditor() {
    const me = this,
          {
      grid
    } = me,
          isPredecessor = me.field === 'predecessors';
    return {
      type: 'dependencyfield',
      grid: grid,
      name: me.field,
      delimiter: me.delimiter,
      dependencyIdField: me.dependencyIdField || grid.dependencyIdField,
      ourSide: isPredecessor ? 'to' : 'from',
      otherSide: isPredecessor ? 'from' : 'to',
      store: grid.eventStore || grid.taskStore,
      dependencyStore: grid.dependencyStore
    };
  } // * reactiveRenderer() {
  //     const
  //         incoming = this.column.field === 'predecessors',
  //         deps = incoming
  //             ? yield this.record.$.incomingDeps
  //             : yield this.record.$.outgoingDeps;
  //
  //     return yield* DependencyField.dependenciesToStringGenerator(deps, incoming ? 'from' : 'to', this.column.delimiter);
  // }


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(DependencyColumn);
DependencyColumn._$name = 'DependencyColumn';

/***/ }),

/***/ "./lib/Gantt/column/EarlyEndDateColumn.js":
/*!************************************************!*\
  !*** ./lib/Gantt/column/EarlyEndDateColumn.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EarlyEndDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/EarlyEndDateColumn
 */

/**
 * A column that displays the task's {@link Gantt.model.TaskModel#field-earlyEndDate early end date}.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType earlyenddate
 */

class EarlyEndDateColumn extends _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'EarlyEndDateColumn';
  }

  static get type() {
    return 'earlyenddate';
  }

  static get defaults() {
    return {
      field: 'earlyEndDate',
      text: 'L{Early End}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(EarlyEndDateColumn);
EarlyEndDateColumn._$name = 'EarlyEndDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/EarlyStartDateColumn.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/column/EarlyStartDateColumn.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EarlyStartDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/EarlyStartDateColumn
 */

/**
 * A column that displays the task's {@link Gantt.model.TaskModel#field-earlyStartDate early start date}.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType earlystartdate
 */

class EarlyStartDateColumn extends _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'EarlyStartDateColumn';
  }

  static get type() {
    return 'earlystartdate';
  }

  static get defaults() {
    return {
      field: 'earlyStartDate',
      text: 'L{Early Start}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(EarlyStartDateColumn);
EarlyStartDateColumn._$name = 'EarlyStartDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/EffortColumn.js":
/*!******************************************!*\
  !*** ./lib/Gantt/column/EffortColumn.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffortColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../SchedulerPro/column/DurationColumn.js */ "./lib/SchedulerPro/column/DurationColumn.js");
/* harmony import */ var _SchedulerPro_widget_EffortField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../SchedulerPro/widget/EffortField.js */ "./lib/SchedulerPro/widget/EffortField.js");
var productName = 'gantt';



/**
 * @module Gantt/column/EffortColumn
 */

/**
 * A column showing the task {@link Gantt.model.TaskModel#field-effort effort} and {@link Gantt.model.TaskModel#field-effortUnit units}.
 * The editor of this column understands the time units, so user can enter "4d" indicating 4 days effort, or "4h" indicating 4 hours, etc.
 * The numeric magnitude can be either an integer or a float value. Both "," and "." are valid decimal separators.
 * For example, you can enter "4.5d" indicating 4.5 days duration, or "4,5h" indicating 4.5 hours.
 *
 * Default editor is a {@link Core.widget.DurationField DurationField}.
 *
 * @extends SchedulerPro/column/DurationColumn
 * @classType effort
 */

class EffortColumn extends _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'EffortColumn';
  }

  static get type() {
    return 'effort';
  } //region Config


  static get defaults() {
    return {
      field: 'fullEffort',
      text: 'L{Effort}'
    };
  } //endregion


  get defaultEditor() {
    return {
      type: _SchedulerPro_widget_EffortField_js__WEBPACK_IMPORTED_MODULE_2__["default"].type,
      name: this.field
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(EffortColumn);
EffortColumn._$name = 'EffortColumn';

/***/ }),

/***/ "./lib/Gantt/column/EndDateColumn.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/column/EndDateColumn.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EndDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Gantt/column/GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
/* harmony import */ var _SchedulerPro_widget_EndDateField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../SchedulerPro/widget/EndDateField.js */ "./lib/SchedulerPro/widget/EndDateField.js");
var productName = 'gantt';



/**
 * @module Gantt/column/EndDateColumn
 */

/**
 * A column that displays (and allows user to update) the task's {@link Gantt.model.TaskModel#field-endDate end date}.
 *
 * Default editor is a {@link SchedulerPro.widget.EndDateField EndDateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType enddate
 */

class EndDateColumn extends _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'EndDateColumn';
  }

  static get type() {
    return 'enddate';
  }

  static get defaults() {
    return {
      field: 'endDate',
      text: 'L{Finish}'
    };
  }

  get defaultEditor() {
    const editorCfg = super.defaultEditor;
    editorCfg.type = 'enddate';
    return editorCfg;
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(EndDateColumn);
EndDateColumn._$name = 'EndDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/EventModeColumn.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/column/EventModeColumn.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventModeColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * A column that displays (and allows user to update) the task's
 * {@link Gantt.model.TaskModel#field-manuallyScheduled manuallyScheduled} field.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/CheckColumn
 * @classType eventmode
 */

class EventModeColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'EventModeColumn';
  }

  static get type() {
    return 'eventmode';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'manuallyScheduled',
      align: 'left',
      text: 'L{Event mode}'
    };
  }

  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-eventmode-cell';
  }

  internalRenderer({
    value,
    cellElement,
    column,
    isExport
  }) {
    super.internalRenderer(...arguments);

    if (isExport) {
      return this.renderText(value);
    } else {
      if (cellElement.widget) {
        cellElement.widget.text = this.renderText(value);
      }
    }
  }

  onCheckboxChange({
    source,
    checked
  }) {
    super.onCheckboxChange(...arguments);
    source.text = this.renderText(checked);
  }

  renderText(value) {
    return value ? this.L('L{Manual}') : this.L('L{Auto}');
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(EventModeColumn);
EventModeColumn._$name = 'EventModeColumn';

/***/ }),

/***/ "./lib/Gantt/column/GanttDateColumn.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/column/GanttDateColumn.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GanttDateColumn; });
/* harmony import */ var _Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/DateColumn.js */ "./lib/Grid/column/DateColumn.js");
var productName = 'gantt';

/**
 * @module Gantt/column/GanttDateColumn
 */

/**
 * Base column class that displays dates, in the `ll` format by default. If set to `null` uses Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat date format} as a default.
 * The format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * By default, this class hides the left/right arrows to modify the date incrementally, you can enable this with the {@link Grid.column.DateColumn#config-step} config
 * of the {@link #config-editor} config.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * @extends Grid/column/DateColumn
 * @abstract
 */

class GanttDateColumn extends _Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      instantUpdate: true,
      width: 130,
      step: null,

      /**
       * The date format used to display dates in this column. If `format` is set to `null`,
       * the current value of the Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used to format the date value.
       * @config {String|null}
       * @category Common
       */
      format: 'll'
    };
  }

  construct(data, store) {
    const me = this;
    me.gantt = store.grid;
    super.construct(data, store); // If a format is specified, always stick to it

    if (me.format) {
      me.explicitFormat = true;
    } // Otherwise adapt to gantt's format when it changes
    else {
      me.gantt.on({
        displayDateFormatChange({
          format
        }) {
          if (!me.explicitFormat) {
            me.set('format', format);
          }
        }

      });
    }
  }

  set format(format) {
    this.explicitFormat = true;
    this.set('format', format);
  }

  get format() {
    return this.explicitFormat && this.data.format || this.gantt.displayDateFormat;
  } // * reactiveRenderer() {
  //     const { column : me, record } = this;
  //
  //     return me.formatValue(yield record.$[me.field]);
  // }


}
GanttDateColumn._$name = 'GanttDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/InactiveColumn.js":
/*!********************************************!*\
  !*** ./lib/Gantt/column/InactiveColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InactiveColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/InactiveColumn
 */

/**
 * A column that displays (and allows user to update) the task's
 * {@link Gantt/model/TaskModel#field-inactive} field.
 *
 * This column uses a {@link Core/widget/Checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/CheckColumn
 * @classType inactive
 */

class InactiveColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'InactiveColumn';
  }

  static get type() {
    return 'inactive';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'inactive',
      text: 'L{Inactive}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(InactiveColumn);
InactiveColumn._$name = 'InactiveColumn';

/***/ }),

/***/ "./lib/Gantt/column/LateEndDateColumn.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/column/LateEndDateColumn.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LateEndDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/LateEndDateColumn
 */

/**
 * A column that displays the task's {@link Gantt.model.TaskModel#field-lateEndDate late end date}.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType lateenddate
 */

class LateEndDateColumn extends _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'LateEndDateColumn';
  }

  static get type() {
    return 'lateenddate';
  }

  static get defaults() {
    return {
      field: 'lateEndDate',
      text: 'L{Late End}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(LateEndDateColumn);
LateEndDateColumn._$name = 'LateEndDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/LateStartDateColumn.js":
/*!*************************************************!*\
  !*** ./lib/Gantt/column/LateStartDateColumn.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LateStartDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/LateStartDateColumn
 */

/**
 * A column that displays the task's {@link Gantt.model.TaskModel#field-lateStartDate late start date}.
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType latestartdate
 */

class LateStartDateColumn extends _GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'LateStartDateColumn';
  }

  static get type() {
    return 'latestartdate';
  }

  static get defaults() {
    return {
      field: 'lateStartDate',
      text: 'L{Late Start}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(LateStartDateColumn);
LateStartDateColumn._$name = 'LateStartDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/ManuallyScheduledColumn.js":
/*!*****************************************************!*\
  !*** ./lib/Gantt/column/ManuallyScheduledColumn.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ManuallyScheduledColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * A column that displays (and allows user to update) the task's
 * {@link Gantt.model.TaskModel#field-manuallyScheduled manuallyScheduled} field.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/CheckColumn
 * @classType manuallyscheduled
 */

class ManuallyScheduledColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ManuallyScheduledColumn';
  }

  static get type() {
    return 'manuallyscheduled';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'manuallyScheduled',
      text: 'L{Manually scheduled}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ManuallyScheduledColumn);
ManuallyScheduledColumn._$name = 'ManuallyScheduledColumn';

/***/ }),

/***/ "./lib/Gantt/column/MilestoneColumn.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/column/MilestoneColumn.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MilestoneColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/MilestoneColumn
 */

/**
 * A Column that indicates whether a task is a milestone. This column uses a {@link Core.widget.Checkbox checkbox} as
 * its editor.
 *
 * @extends Grid/column/CheckColumn
 * @classType milestone
 */

class MilestoneColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'MilestoneColumn';
  }

  static get type() {
    return 'milestone';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'milestone',
      text: 'L{Milestone}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(MilestoneColumn);
MilestoneColumn._$name = 'MilestoneColumn';

/***/ }),

/***/ "./lib/Gantt/column/NameColumn.js":
/*!****************************************!*\
  !*** ./lib/Gantt/column/NameColumn.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NameColumn; });
/* harmony import */ var _Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/NameColumn
 */

/**
 * A tree column showing (and allowing user to edit) the task's {@link Gantt.model.TaskModel#field-name name} field.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * @extends Grid/column/TreeColumn
 * @classType name
 */

class NameColumn extends _Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NameColumn';
  }

  static get type() {
    return 'name';
  }

  static get isGanttColumn() {
    return true;
  } //region Config


  static get defaults() {
    return {
      width: 200,
      field: 'name',
      text: 'L{Name}'
    };
  } //endregion


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(NameColumn);
NameColumn._$name = 'NameColumn';

/***/ }),

/***/ "./lib/Gantt/column/NoteColumn.js":
/*!****************************************!*\
  !*** ./lib/Gantt/column/NoteColumn.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NoteColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
var productName = 'gantt';



/**
 * @module Gantt/column/NoteColumn
 */

/**
 * A column which displays a task's {@link Gantt.model.TaskModel#field-note note} field.
 *
 * Default editor is a {@link Core.widget.TextAreaField TextAreaField}.
 *
 * @extends Grid/column/Column
 * @classType note
 */

class NoteColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NoteColumn';
  }

  static get type() {
    return 'note';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'note',
      text: 'L{Note}',
      width: 150,
      editor: {
        type: 'textareafield',
        inline: false
      }
    };
  }

  renderer({
    value
  }) {
    return (value || '').trim();
  }

  get disableHtmlEncode() {
    return true;
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(NoteColumn);
NoteColumn._$name = 'NoteColumn';

/***/ }),

/***/ "./lib/Gantt/column/PercentDoneColumn.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/column/PercentDoneColumn.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PercentDoneColumn; });
/* harmony import */ var _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
var productName = 'gantt';



/**
 * @module Gantt/column/PercentDoneColumn
 */

/**
 * A column representing the {@link SchedulerPro.model.mixin.PercentDoneMixin#field-percentDone percentDone} field of the task.
 *
 * Default editor is a {@link Core.widget.NumberField NumberField}.
 *
 * @extends Grid/column/NumberColumn
 * @classType percentdone
 */

class PercentDoneColumn extends _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PercentDoneColumn';
  }

  static get type() {
    return 'percentdone';
  }

  static get isGanttColumn() {
    return true;
  } //region Config


  static get fields() {
    return [
    /**
     * Set to `true` to render a circular progress bar to visualize the task progress
     * @config {Boolean} showCircle
     */
    'showCircle'];
  }

  static get defaults() {
    return {
      field: 'percentDone',
      text: 'L{% Done}',
      unit: '%',
      step: 1,
      min: 0,
      max: 100,
      width: 90
    };
  } //endregion


  construct(config) {
    super.construct(...arguments);

    if (this.showCircle) {
      this.htmlEncode = false;
    }
  }

  defaultRenderer({
    record,
    isExport,
    value
  }) {
    value = record.getFormattedPercentDone(value);

    if (isExport) {
      return value;
    }

    if (this.showCircle) {
      return {
        className: {
          'b-percentdone-circle': 1,
          'b-full': value === 100,
          'b-empty': value === 0
        },
        style: {
          '--gantt-percentdone-angle': `${value / 100}turn`
        },
        dataset: {
          value
        }
      };
    }

    return value + this.unit;
  } // formatValue(value) {
  //     if (value <= 99) {
  //         return Math.round(value);
  //     }
  //     else {
  //         return Math.floor(value);
  //     }
  // }
  // * reactiveRenderer() {
  //     const
  //         { column : me, record, client } = this,
  //         value = me.formatValue(yield record.$.percentDone);
  //
  //     if (me.showCircle) {
  //         const size  = client.rowHeight * 0.8;
  //
  //         return {
  //             className : 'b-percentdone-circle',
  //             style     : {
  //                 animationDelay : `-${value - 0.1}s`,
  //                 width          : size,
  //                 height         : size
  //             },
  //             dataset : {
  //                 value
  //             }
  //         };
  //     }
  //
  //     return value + me.unit;
  // }


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(PercentDoneColumn);
PercentDoneColumn._$name = 'PercentDoneColumn';

/***/ }),

/***/ "./lib/Gantt/column/PredecessorColumn.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/column/PredecessorColumn.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PredecessorColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _DependencyColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DependencyColumn.js */ "./lib/Gantt/column/DependencyColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/PredecessorColumn
 */

/**
 * A column which displays, in textual form, the dependencies which link from tasks
 * upon which the contextual task depends.
 *
 * This type of column is editable by default. Default editor is a {@link Gantt/widget/DependencyField}.
 *
 * @classType predecessor
 * @extends Gantt/column/DependencyColumn
 */

class PredecessorColumn extends _DependencyColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'PredecessorColumn';
  }

  static get type() {
    return 'predecessor';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      text: 'L{Predecessors}',
      field: 'predecessors'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(PredecessorColumn);
PredecessorColumn._$name = 'PredecessorColumn';

/***/ }),

/***/ "./lib/Gantt/column/ResourceAssignmentColumn.js":
/*!******************************************************!*\
  !*** ./lib/Gantt/column/ResourceAssignmentColumn.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceAssignmentColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _widget_AssignmentField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widget/AssignmentField.js */ "./lib/Gantt/widget/AssignmentField.js");
/* harmony import */ var _Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';







/**
 * @module Gantt/column/ResourceAssignmentColumn
 */

const resourceNameRegExp = a => a.resourceName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Column allowing resource manipulation (assignment/unassignment/units changing) on a task. In the column cells,
 * assignments are either shown as badges or avatars. To show avatars, set {@link #config-showAvatars} to `true`. When
 * showing avatars there are two options for how to specify image paths:
 *
 * * You may provide a {@link Gantt.view.Gantt#config-resourceImageFolderPath} on your Gantt panel pointing to where
 *   resource images are located. Set the resource image filename in the `image` field of the resource data.
 * * And/or you may provide an `imageUrl` on your record, which then will take precedence when showing images.
 *
 * If a resource has no name, or its image cannot be loaded, the resource initials are rendered. If the resource has
 * an {@link Scheduler/model/mixin/ResourceModelMixin#field-eventColor} specified, it will be used as the background
 * color of the initials.
 *
 * Default editor is a {@link Gantt.widget.AssignmentField AssignmentField}.
 *
 * ## Customizing displayed elements
 *
 * If {@link #config-showAvatars} is false, column will render resource name and utilization wrapped in a
 * small element called _a chip_. Content of the chip can be customized. For example, if you don't want to see percent
 * value, or want to display different resource name, you can specify an {@link #config-itemTpl} config. Please keep in
 * mind that when you start editing the cell, chip will be rendered by the default editor. If you want chips to be
 * consistent, you need to customize the editor too.
 *
 * ```javascript
 * new Gantt({
 *     columns: [
 *         {
 *             type     : 'resourceassignment',
 *             itemTpl  : (assignment) => assignment.resourceName,
 *             editor   : {
 *                 chipView : {
 *                     itemTpl : (assignment) => assignment.resourceName
 *                 }
 *             }
 *         }
 *     ]
 * });
 * ```
 *
 * {@inlineexample Gantt/column/ResourceAssignment.js}
 *
 * @extends Grid/column/Column
 * @classType resourceassignment
 */


class ResourceAssignmentColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceAssignmentColumn';
  }

  static get type() {
    return 'resourceassignment';
  }

  static get isGanttColumn() {
    return true;
  }

  static get fields() {
    return [
    /**
     * True to show a resource avatar for every assignment. Note that you also have to provide a {@link Gantt.view.Gantt#config-resourceImageFolderPath} for where to load images from.
     * And/or you may provide an `imageUrl` on your record, which then will take precedence when showing images.
     * @config {Boolean} showAvatars
     * @category Common
     */
    'showAvatars', 'sideMargin', 'imageSize',
    /**
     * A function which produces the content to put in the resource assignment cell.
     * May be overridden in subclasses, or injected into the column
     * to customize the Chip content.
     *
     * Defaults to returning `${assignment.resourceName} ${assignment.units}%`
     *
     * @param {Gantt.model.AssignmentModel} assignment The assignment
     * @param {Number} index The index - zero based.
     * @config {Function} itemTpl
     * @category Rendering
     */
    {
      name: 'itemTpl',
      defaultValue: assignment => _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].encodeHtml(assignment.toString())
    },
    /**
     * A function which receives data about the resource and returns a html string to be displayed in the tooltip.
     *
     * ```javascript
     * const gantt = new Gantt({
     *     columns : [
     *          {
     *              type          : 'resourceassignment',
     *              showAvatars : true,
     *              avatarTooltipTemplate({ resourceRecord }) {
     *                  return `<b>${resourceRecord.name}</b>`;
     *              }
     *          }
     *     ]
     * });
     * ```
     *
     * This function will be called with an object containing the fields below:
     *
     * @param {Object} data
     * @param {Gantt.model.TaskModel} data.taskRecord Hovered task
     * @param {Gantt.model.ResourceModel} data.resourceRecord Hovered resource
     * @param {Gantt.model.AssignmentModel} data.assignmentRecord Hovered assignment
     * @param {Number} data.overflowCount Number of overflowing resources, only valid for last shown resource
     * @config {Function} avatarTooltipTemplate
     */
    'avatarTooltipTemplate'];
  }

  static get defaults() {
    return {
      field: 'assignments',
      instantUpdate: false,
      text: 'L{Assigned Resources}',
      width: 250,
      cellCls: 'b-resourceassignment-cell',
      showAvatars: false,
      imageSize: 30,
      sideMargin: 20,

      sortable(task1, task2) {
        const a1 = task1.assignments.join(''),
              a2 = task2.assignments.join('');

        if (a1 === a2) {
          return 0;
        }

        return a1 < a2 ? -1 : 1;
      },

      filterable({
        value,
        record
      }) {
        // We're being passed an array of Assignments
        if (Array.isArray(value)) {
          // Shortcut if we're matching no assignments.
          if (!value.length) {
            return Boolean(!record.assignments.length);
          } // Create a multi resource name Regexp, eg /Macy|Lee|George/.


          value = value.map(resourceNameRegExp).join('|');
        }

        const regexp = new RegExp(value, 'gi');
        return record.assignments.some(assignment => regexp.test(assignment.resourceName));
      }

    };
  }

  construct() {
    super.construct(...arguments);
    const me = this,
          {
      grid
    } = me;

    if (me.showAvatars) {
      Object.assign(me, {
        repaintOnResize: true,
        htmlEncode: false,
        renderer: me.rendererWithAvatars,
        avatarRendering: new _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
          element: grid.element,
          tooltip: {
            forSelector: '.b-resourceassignment-cell .b-resource-avatar',
            listeners: {
              beforeShow({
                source: tip
              }) {
                var _me$avatarTooltipTemp, _me$avatarTooltipTemp2;

                const {
                  taskRecord,
                  resourceRecord,
                  assignmentRecord,
                  overflowCount
                } = tip.activeTarget.elementData,
                      tooltip = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].xss`${assignmentRecord.toString()}${overflowCount ? ` (+${overflowCount} ${me.L('L{more resources}')})` : ''}`;
                tip.html = (_me$avatarTooltipTemp = (_me$avatarTooltipTemp2 = me.avatarTooltipTemplate) === null || _me$avatarTooltipTemp2 === void 0 ? void 0 : _me$avatarTooltipTemp2.call(me, {
                  taskRecord,
                  resourceRecord,
                  assignmentRecord,
                  overflowCount
                })) !== null && _me$avatarTooltipTemp !== void 0 ? _me$avatarTooltipTemp : tooltip;
              }

            }
          }
        })
      });
    }

    grid.on({
      beforeCellEditStart: me.onBeforeCellEditStart,
      finishCellEdit: me.onDoneCellEdit,
      cancelCellEdit: me.onDoneCellEdit,
      thisObj: me
    });
    grid.resourceStore.on({
      name: 'resourceStore',
      update: me.onResourceUpdate,
      thisObj: me
    });
  }

  doDestroy() {
    var _this$avatarRendering;

    super.doDestroy();
    (_this$avatarRendering = this.avatarRendering) === null || _this$avatarRendering === void 0 ? void 0 : _this$avatarRendering.destroy();
  }

  get defaultEditor() {
    return {
      type: _widget_AssignmentField_js__WEBPACK_IMPORTED_MODULE_2__["default"].type,
      store: {
        modelClass: this.grid.project.assignmentStore.modelClass
      }
    };
  }

  onBeforeCellEditStart({
    editorContext: {
      record,
      column
    }
  }) {
    const me = this;

    if (column === me) {
      const {
        editor
      } = me;
      editor.resourceImageFolderPath = me.grid.resourceImageFolderPath;
      editor.projectEvent = record;
      me.detachListeners('editorStore');
      editor.store.on({
        name: 'editorStore',
        changesApplied: me.onEditorChangesApplied,
        thisObj: me
      });
    }
  }

  onDoneCellEdit() {
    this.detachListeners('editorStore');
  }

  onEditorChangesApplied() {
    const me = this,
          cellElement = me.grid.getCell({
      id: me.editor.projectEvent.id,
      columnId: me.id
    });

    if (cellElement) {
      me.renderer({
        value: me.editor.projectEvent.assignments,
        cellElement
      });
    }
  }

  onResourceUpdate({
    source
  }) {
    var _source$project;

    // no need for this listener when the gantt is loading data
    if (!((_source$project = source.project) !== null && _source$project !== void 0 && _source$project.propagatingLoadChanges)) {
      this.grid.refreshColumn(this);
    }
  }

  get chipView() {
    const me = this;

    if (!me._chipView) {
      me._chipView = new _Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        cls: 'b-assignment-chipview',
        itemsFocusable: false,
        closable: false,
        itemTpl: me.itemTpl,
        store: {},
        scrollable: {
          overflowX: 'hidden-scroll'
        }
      }); // The List class only refreshes itself when visible, so
      // since this is an offscreen, rendering element
      // we have to fake visibility.

      Object.defineProperty(me.chipView, 'isVisible', {
        get() {
          return true;
        }

      });
    }

    return me._chipView;
  }

  renderer({
    cellElement,
    value,
    isExport
  }) {
    value = value.filter(a => a.resource).sort((lhs, rhs) => lhs.resourceName.localeCompare(rhs.resourceName));

    if (isExport) {
      return value.map(this.itemTpl).join(',');
    } else {
      const {
        chipView
      } = this;
      chipView.store.storage.replaceValues({
        values: value,
        silent: true
      });
      chipView.refresh();
      const chipCloneElement = chipView.element.cloneNode(true);
      chipCloneElement.removeAttribute('id');
      cellElement.innerHTML = '<div class="b-assignment-chipview-wrap"></div>';
      cellElement.firstElementChild.appendChild(chipCloneElement);
    }
  }

  rendererWithAvatars({
    record: taskRecord,
    value,
    isExport
  }) {
    const me = this,
          nbrVisible = Math.floor((me.width - me.sideMargin) / (me.imageSize + 2)),
          overflowCount = value.length > nbrVisible ? value.length - nbrVisible : 0;
    value = value.filter(a => a.resource).sort((lhs, rhs) => lhs.resourceName.localeCompare(rhs.resourceName));

    if (isExport) {
      return value.map(this.itemTpl).join(',');
    }

    return {
      className: 'b-resource-avatar-container',
      children: value.map((assignmentRecord, i) => {
        const {
          resource: resourceRecord
        } = assignmentRecord;

        if (i < nbrVisible) {
          const isLastOverflowing = overflowCount > 0 && i === nbrVisible - 1,
                imgConfig = me.renderImage({
            taskRecord,
            resourceRecord,
            assignmentRecord,
            overflowCount: isLastOverflowing ? overflowCount : 0
          });

          if (isLastOverflowing) {
            return {
              className: 'b-overflow-img',
              children: [imgConfig, {
                tag: 'span',
                className: 'b-overflow-count',
                html: `+${overflowCount}`
              }]
            };
          }

          return imgConfig;
        }
      })
    };
  }

  renderImage({
    taskRecord,
    resourceRecord,
    assignmentRecord,
    overflowCount
  }) {
    const {
      resourceImageFolderPath
    } = this.grid,
          imageUrl = resourceRecord.imageUrl || resourceRecord.image && resourceImageFolderPath && resourceImageFolderPath + resourceRecord.image,
          avatar = this.avatarRendering.getResourceAvatar({
      initials: resourceRecord.initials,
      color: resourceRecord.eventColor,
      iconCls: resourceRecord.iconCls,
      defaultImageUrl: this.defaultAvatar,
      imageUrl
    }); // Some paths in avatarRendering does not yield elementData

    if (!avatar.elementData) {
      avatar.elementData = {};
    }

    Object.assign(avatar.elementData, {
      taskRecord,
      resourceRecord,
      assignmentRecord,
      overflowCount
    });
    return avatar;
  }

  get defaultAvatar() {
    const {
      grid
    } = this;
    return grid.defaultResourceImageName ? grid.resourceImageFolderPath + grid.defaultResourceImageName : '';
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ResourceAssignmentColumn);
ResourceAssignmentColumn._$name = 'ResourceAssignmentColumn';

/***/ }),

/***/ "./lib/Gantt/column/ResourceAssignmentGridResourceColumn.js":
/*!******************************************************************!*\
  !*** ./lib/Gantt/column/ResourceAssignmentGridResourceColumn.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceAssignmentGridResourceColumn; });
/* harmony import */ var _Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/column/ResourceInfoColumn.js */ "./lib/Scheduler/column/ResourceInfoColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/ResourceAssignmentGridResourceColumn.js
 */

/**
 * Column showing the resource name / avatar inside the AssignmentGrid
 *
 * @internal
 * @extends Scheduler/column/ResourceInfoColumn
 * @classType resourceassignment
 */

class ResourceAssignmentGridResourceColumn extends _Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceAssignmentGridResourceColumn';
  }

  static get type() {
    return 'assignmentResource';
  }

  static get defaults() {
    return {
      showEventCount: false,
      cls: 'b-assignmentgrid-resource-column',
      field: 'resourceName',
      flex: 1,
      editor: null,
      useNameAsImageName: false,
      filterable: {
        filterField: {
          placeholder: 'L{AssignmentGrid.Name}',
          triggers: {
            filter: {
              align: 'start',
              cls: 'b-icon b-icon-filter'
            }
          }
        }
      }
    };
  }

  defaultRenderer({
    grid,
    record,
    cellElement,
    value,
    isExport
  }) {
    if (!record.isSpecialRow) {
      record = record.resource;
    }

    return super.defaultRenderer({
      grid,
      record,
      cellElement,
      value,
      isExport
    });
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ResourceAssignmentGridResourceColumn);
ResourceAssignmentGridResourceColumn._$name = 'ResourceAssignmentGridResourceColumn';

/***/ }),

/***/ "./lib/Gantt/column/RollupColumn.js":
/*!******************************************!*\
  !*** ./lib/Gantt/column/RollupColumn.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RollupColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/RollupColumn
 */

/**
 * A column that displays a checkbox to edit the {@link Gantt.model.TaskModel#field-rollup rollup} data field.
 * This field indicates if a task should rollup to its closest parent or not.
 * Requires the {@link Gantt.feature.Rollups Rollups} feature to be enabled.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/CheckColumn
 * @classType rollup
 */

class RollupColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RollupColumn';
  }

  static get type() {
    return 'rollup';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'rollup',
      text: 'L{Rollup}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(RollupColumn);
RollupColumn._$name = 'RollupColumn';

/***/ }),

/***/ "./lib/Gantt/column/SchedulingModeColumn.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/column/SchedulingModeColumn.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulingModeColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _SchedulerPro_widget_SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../SchedulerPro/widget/SchedulingModePicker.js */ "./lib/SchedulerPro/widget/SchedulingModePicker.js");
var productName = 'gantt';




/**
 * @module Gantt/column/SchedulingModeColumn
 */

/**
 * A column which displays a task's scheduling {@link Gantt.model.TaskModel#field-schedulingMode mode} field.
 *
 * Default editor is a {@link SchedulerPro.widget.SchedulingModePicker SchedulingModePicker}.
 *
 * @extends Grid/column/Column
 * @classType schedulingmodecolumn
 */

class SchedulingModeColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SchedulingModeColumn';
  }

  static get type() {
    return 'schedulingmodecolumn';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'schedulingMode',
      text: 'L{Scheduling Mode}',
      editor: {
        type: _SchedulerPro_widget_SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_3__["default"].type,
        allowInvalid: false,
        picker: {
          minWidth: '8.5em'
        }
      }
    };
  }

  afterConstruct() {
    const me = this;
    super.afterConstruct();
    let store; // we need to trigger the column refresh **after** the editor locale change
    // to display properly translated scheduling modes

    if (me.editor) {
      _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createSequence(me.editor.updateLocalization, me.onEditorLocaleChange, me);
      store = me.editor.store;
    } else {
      store = new _SchedulerPro_widget_SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_3__["default"]().store;
    }

    this.store = store;
  }

  renderer({
    value
  }) {
    const model = this.store.getById(value);
    return model && model.text || '';
  } // * reactiveRenderer() {
  //     const
  //         value = yield this.record.$.schedulingMode,
  //         model = this.column.editor.store.getById(value);
  //
  //     return model && model.text || '';
  // }
  // Refreshes the column **after** the editor locale change
  // to display properly translated scheduling modes


  onEditorLocaleChange() {
    this.grid.refreshColumn(this);
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(SchedulingModeColumn);
SchedulingModeColumn._$name = 'SchedulingModeColumn';

/***/ }),

/***/ "./lib/Gantt/column/SequenceColumn.js":
/*!********************************************!*\
  !*** ./lib/Gantt/column/SequenceColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SequenceColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/SequenceColumn
 */

/**
 * A "calculated" column which displays the sequential position of the task in the project.
 *
 * There is no `editor`, since value is read-only.
 *
 * See {@link Gantt.model.TaskModel#property-sequenceNumber} for details.
 *
 * @extends Grid/column/Column
 * @classType sequence
 */

class SequenceColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SequenceColumn';
  }

  static get type() {
    return 'sequence';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'sequenceNumber',
      text: 'L{Sequence}',
      sortable: false,
      groupable: false,
      filterable: false,
      width: 70,
      editor: null
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(SequenceColumn);
SequenceColumn._$name = 'SequenceColumn';

/***/ }),

/***/ "./lib/Gantt/column/ShowInTimelineColumn.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/column/ShowInTimelineColumn.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ShowInTimelineColumn; });
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/ShowInTimelineColumn
 */

/**
 * Column that shows if a task should be shown in the {@link SchedulerPro.widget.Timeline Timeline} widget.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/CheckColumn
 * @classType showintimeline
 */

class ShowInTimelineColumn extends _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ShowInTimelineColumn';
  }

  static get type() {
    return 'showintimeline';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'showInTimeline',
      text: 'L{Show in timeline}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ShowInTimelineColumn);
ShowInTimelineColumn._$name = 'ShowInTimelineColumn';

/***/ }),

/***/ "./lib/Gantt/column/StartDateColumn.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/column/StartDateColumn.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StartDateColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Gantt/column/GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
/* harmony import */ var _SchedulerPro_widget_StartDateField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../SchedulerPro/widget/StartDateField.js */ "./lib/SchedulerPro/widget/StartDateField.js");
var productName = 'gantt';



/**
 * @module Gantt/column/StartDateColumn
 */

/**
 * A column that displays (and allows user to update) the task's {@link Gantt.model.TaskModel#field-startDate start date}.
 *
 * Default editor is a {@link SchedulerPro.widget.StartDateField StartDateField}.
 *
 * If {@link #config-format} is omitted, Gantt's {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat} will be used as a default value and
 * the format will be dynamically updated while zooming according to the {@link Scheduler.preset.ViewPreset#field-displayDateFormat} value specified for the ViewPreset being selected.
 *
 * @extends Gantt/column/GanttDateColumn
 * @classType startdate
 */

class StartDateColumn extends _Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'StartDateColumn';
  }

  static get type() {
    return 'startdate';
  }

  static get defaults() {
    return {
      field: 'startDate',
      text: 'L{Start}'
    };
  }

  get defaultEditor() {
    const editorCfg = super.defaultEditor;
    editorCfg.type = 'startdate';
    return editorCfg;
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(StartDateColumn);
StartDateColumn._$name = 'StartDateColumn';

/***/ }),

/***/ "./lib/Gantt/column/SuccessorColumn.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/column/SuccessorColumn.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SuccessorColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _DependencyColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DependencyColumn.js */ "./lib/Gantt/column/DependencyColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/SuccessorColumn
 */

/**
 * A column which displays, in textual form, the dependencies which link from the
 * contextual to successor tasks.
 *
 * This type of column is editable by default. Default editor is a {@link Gantt/widget/DependencyField}.
 *
 * @classType successor
 * @extends Gantt/column/DependencyColumn
 */

class SuccessorColumn extends _DependencyColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'SuccessorColumn';
  }

  static get type() {
    return 'successor';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      text: 'L{Successors}',
      field: 'successors'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(SuccessorColumn);
SuccessorColumn._$name = 'SuccessorColumn';

/***/ }),

/***/ "./lib/Gantt/column/TimeAxisColumn.js":
/*!********************************************!*\
  !*** ./lib/Gantt/column/TimeAxisColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisColumn; });
/* harmony import */ var _Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/TimeAxisColumn
 */

/**
 * A column containing the timeline "viewport", in which tasks, dependencies etc are drawn.
 * Normally you do not need to interact with or create this column, it is handled by Gantt.
 *
 * @extends Scheduler/column/TimeAxisColumn
 * @typings Scheduler/column/TimeAxisColumn -> Scheduler/column/SchedulerTimeAxisColumn
 */

class TimeAxisColumn extends _Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaults() {
    return {
      /**
       * Set to `false` to disable {@link Gantt.feature.TaskMenu TaskMenu} for the cell elements in this column.
       * @config {Boolean} enableCellContextMenu
       * @default true
       * @category Menu
       */
      enableCellContextMenu: true
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(TimeAxisColumn);
TimeAxisColumn._$name = 'TimeAxisColumn';

/***/ }),

/***/ "./lib/Gantt/column/TotalSlackColumn.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/column/TotalSlackColumn.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TotalSlackColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../SchedulerPro/column/DurationColumn.js */ "./lib/SchedulerPro/column/DurationColumn.js");
var productName = 'gantt';


/**
 * @module Gantt/column/TotalSlackColumn
 */

/**
 * A column that displays the task's {@link Gantt.model.TaskModel#field-totalSlack total slack}.
 *
 * Default editor is a {@link Core.widget.DurationField DurationField}.
 *
 * @extends SchedulerPro/column/DurationColumn
 * @classType totalslack
 */

class TotalSlackColumn extends _SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'TotalSlackColumn';
  }

  static get type() {
    return 'totalslack';
  }

  static get isGanttColumn() {
    return true;
  }

  get durationUnitField() {
    return 'slackUnit';
  }

  static get defaults() {
    return {
      field: 'totalSlack',
      text: 'L{Total Slack}'
    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(TotalSlackColumn);
TotalSlackColumn._$name = 'TotalSlackColumn';

/***/ }),

/***/ "./lib/Gantt/column/WBSColumn.js":
/*!***************************************!*\
  !*** ./lib/Gantt/column/WBSColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WBSColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Gantt/column/WBSColumn
 */

/**
 * A calculated column which displays the _WBS_ (_Work Breakdown Structure_) for the tasks - the position of the task
 * in the project tree structure.
 *
 * While there is no `editor`, since the WBS is a calculated value, there is a `renumber` item in the `headerMenuItems`
 * that allows the user to {@link Gantt.model.TaskModel#function-refreshWbs refresh} the WBS values.
 *
 * @extends Grid/column/Column
 * @classType wbs
 */

class WBSColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'WBSColumn';
  }

  static get type() {
    return 'wbs';
  }

  static get isGanttColumn() {
    return true;
  }

  static get defaults() {
    return {
      field: 'wbsValue',
      text: 'L{WBS}',
      width: 70,
      editor: null,

      filterable({
        value,
        record
      }) {
        // value might be WBS instance
        return record.wbsValue.match(String(value));
      },

      headerMenuItems: {
        renumber: {
          text: 'L{WBSColumn.renumber}',
          icon: 'b-icon-renumber',

          onItem({
            source
          }) {
            source.taskStore.rootNode.refreshWbs();
          }

        }
      },

      // This renderer is required to force string WBS value for TableExporter. zipcelx will call `valueOf` (value + '')
      // which would return padded value.
      renderer({
        value
      }) {
        return String(value);
      }

    };
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(WBSColumn);
WBSColumn._$name = 'WBSColumn';

/***/ }),

/***/ "./lib/Gantt/customElements/GanttTag.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/customElements/GanttTag.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GanttTag; });
/* harmony import */ var _Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/customElements/TimelineBaseTag.js */ "./lib/Scheduler/customElements/TimelineBaseTag.js");
/* harmony import */ var _view_Gantt_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../view/Gantt.js */ "./lib/Gantt/view/Gantt.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/ProjectModel.js */ "./lib/Gantt/model/ProjectModel.js");
var productName = 'gantt';


 //TODO: If we want to improve on this, add settings as attributes, replace data-field with field etc.

/**
 * @module Gantt/customElements/GanttTag
 */

/**
 * Import this file to be able to use the tag `<bryntum-gantt>` to create a Gantt chart.
 *
 * This is more of a proof of concept than a ready to use class. The dataset of the `<data>` and `<bryntum-gantt>`
 * tags is applied to record and Gantt configs respectively, which means that you can pass any documented config
 * there, not only the ones demonstrated here. Dataset attributes are translated as follows:
 *
 *  * `data-view-preset` -> `viewPreset`
 *  * `data-start-date` -> `startDate`
 *  etc.
 *
 * ```html
 * <bryntum-gantt data-view-preset="weekAndDay" data-start-date="2018-04-02" data-end-date="2018-04-09">
 *      <column data-type="name">Name</column>
 *      <project data-load-url="/projectdata">Name</project>
 *      <feature data-name="nonWorkingTime"></feature>
 *      <feature data-name="timeRanges" data-show-current-timeline="true"></feature>
 * </bryntum-gantt>
 * ```
 *
 * To get styling correct, supply the path to the theme you want to use and to the folder that holds Font Awesome:
 *
 * ```html
 * <bryntum-gantt stylesheet="resources/gantt.stockholm.css" fa-path="resources/fonts">
 * </bryntum-gantt>
 * ```
 *
 * NOTE: Remember to call {@link #function-destroy} before removing this web component from the DOM to avoid memory
 * leaks.
 *
 * @demo Gantt/webcomponents
 * @extends Scheduler/customElements/TimelineBaseTag
 */

class GanttTag extends _Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  connectedCallback() {
    this.widgetClass = _view_Gantt_js__WEBPACK_IMPORTED_MODULE_1__["default"];
    this.projectModelClass = _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__["default"];
    super.connectedCallback();
  }

} // Try-catch to make trial work

try {
  window.customElements && window.customElements.define('bryntum-gantt', GanttTag);
} catch (error) {}

GanttTag._$name = 'GanttTag';

/***/ }),

/***/ "./lib/Gantt/data/AssignmentStore.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/data/AssignmentStore.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentStore; });
/* harmony import */ var _SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/data/AssignmentStore.js */ "./lib/SchedulerPro/data/AssignmentStore.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Gantt/model/AssignmentModel.js");
var productName = 'gantt';


/**
 * @module Gantt/data/AssignmentStore
 */

/**
 * A class representing a collection of assignments between tasks in the {@link Gantt.data.TaskStore} and resources
 * in the {@link Gantt.data.ResourceStore}.
 *
 * ```javascript
 * const assignmentStore = new AssignmentStore({
 *      data : [
 *          { "id" : 1, "event" : 11,  "resource" : 1 },
 *          { "id" : 2, "event" : 12,  "resource" : 1 },
 *      ]
 * })
 * ```
 *
 * Contains a collection of the {@link Gantt.model.AssignmentModel} records.
 *
 * @extends SchedulerPro/data/AssignmentStore
 * @typings SchedulerPro/data/AssignmentStore -> SchedulerPro/data/SchedulerProAssignmentStore
 */

class AssignmentStore extends _SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 500,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 400
    };
  }

}
AssignmentStore._$name = 'AssignmentStore';

/***/ }),

/***/ "./lib/Gantt/data/AssignmentsManipulationStore.js":
/*!********************************************************!*\
  !*** ./lib/Gantt/data/AssignmentsManipulationStore.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentsManipulationStore; });
/* harmony import */ var _SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/data/AssignmentStore.js */ "./lib/SchedulerPro/data/AssignmentStore.js");
var productName = 'gantt';

/**
 * @module Gantt/data/AssignmentsManipulationStore
 */

/**
 * Special store class for _single_ task/event assignments manipulation, used by {@link Gantt/widget/AssignmentGrid}
 *
 * Contains a collection of {@link Gantt/model/AssignmentModel} records.
 *
 * @extends Scheduler/data/AssignmentStore
 * @internal
 */

class AssignmentsManipulationStore extends _SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get defaultConfig() {
    return {
      storage: {
        extraKeys: ['resource']
      },
      callOnFunctions: true,

      /**
       * Event model to manipulate assignments of, the event should be part of a project.
       *
       * @config {Gantt.model.TaskModel}
       */
      projectEvent: null,

      /**
       * Flag indicating whether assigned resources should be placed (floated) before unassigned ones.
       *
       * @config {Boolean}
       * @private
       */
      floatAssignedResources: true,

      /**
       * Flag indicating whether assigned resources should be floated live
       *
       * @config {Boolean}
       * @private
       */
      liveFloatAssignedResources: false
    };
  }

  afterConfigure() {
    const me = this;
    super.afterConfigure();
    me.addSorter({
      fn: me.defaultSort.bind(me)
    });
  } //endregion


  get projectEvent() {
    return this._projectEvent;
  }

  set projectEvent(projectEvent) {
    const me = this; // If the event is the same, but some underlying data has changed, we must still update

    if (projectEvent != me._projectEvent || projectEvent && projectEvent.generation !== me._projectEventGeneration) {
      me._projectEvent = projectEvent;
      me._projectEventGeneration = projectEvent.generation;

      if (projectEvent) {
        me.fillFromMaster();
        me.sort();
      } else {
        me.removeAll();
      }
    }
  }

  get floatAssignedResources() {
    return this._floatAssignedResources;
  }

  set floatAssignedResources(value) {
    const me = this;

    if (value !== me.floatAssignedResources) {
      me._floatAssignedResources = value;
      me.sort();
    }
  }
  /**
   * Fills this store from master {@link Gantt/data/ResourceStore resource} store and {@link Gantt/data/AssignmentStore assignment} store.
   * @internal
   */


  fillFromMaster() {
    const me = this,
          projectEvent = me.projectEvent;

    if (projectEvent) {
      const {
        assignmentStore,
        resourceStore
      } = projectEvent,
            storeData = []; // For each excludes group header records - ResourceStore might be grouped externally

      resourceStore.forEach(resource => {
        const existingAssignment = assignmentStore.getAssignmentForEventAndResource(projectEvent, resource),
              data = Object.assign({
          units: 0
        }, existingAssignment === null || existingAssignment === void 0 ? void 0 : existingAssignment.data);
        delete data.id;
        delete data.eventId;
        delete data.resourceId; // handle data mapping cases

        delete data[assignmentStore.modelClass.getFieldDefinition('resource').dataSource];
        delete data[assignmentStore.modelClass.getFieldDefinition('event').dataSource]; // apply resource and event after cleaning data mapping

        Object.assign(data, {
          resource,
          event: projectEvent
        });
        storeData.push(data);
      }, this, {
        includeFilteredOutRecords: true,
        includeCollapsedGroupRecords: true
      });
      me.data = storeData;
    }
  }

  toValueString() {
    const activeAssignments = this.query(a => a.units > 0);
    return activeAssignments.join(', ');
  }

  defaultSort(lhs, rhs) {
    let result = 0;

    if (this.floatAssignedResources) {
      if (!rhs.units && lhs.units) {
        result = -1;
      } else if (!lhs.units && rhs.units) {
        result = 1;
      } else {
        result = lhs.resourceName.localeCompare(rhs.resourceName);
      }
    } else {
      result = lhs.resourceName.localeCompare(rhs.resourceName);
    }

    return result;
  }

  onUpdate({
    changes
  }) {
    const me = this;

    if (!me.isConfiguring) {
      if (Object.hasOwnProperty.call(changes, 'event')) {
        if (me.floatAssignedResources && me.liveFloatAssignedResources) {
          me.sort();
        }
      }
    }
  }

}
AssignmentsManipulationStore._$name = 'AssignmentsManipulationStore';

/***/ }),

/***/ "./lib/Gantt/data/CalendarManagerStore.js":
/*!************************************************!*\
  !*** ./lib/Gantt/data/CalendarManagerStore.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarManagerStore; });
/* harmony import */ var _SchedulerPro_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/data/CalendarManagerStore.js */ "./lib/SchedulerPro/data/CalendarManagerStore.js");
/* harmony import */ var _model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/CalendarModel.js */ "./lib/Gantt/model/CalendarModel.js");
var productName = 'gantt';


/**
 * @module Gantt/data/CalendarManagerStore
 */

/**
 * A class representing the tree of calendars in the Gantt chart. An individual calendar is represented as an instance of the
 * {@link Gantt.model.CalendarModel} class. The store expects the data loaded to be hierarchical. Each parent node should
 * contain its children in a property called 'children'.
 *
 * Please refer to the [calendars guide](#Gantt/guides/basics/calendars.md) for details
 *
 * @extends SchedulerPro/data/CalendarManagerStore
 * @typings SchedulerPro/data/CalendarManagerStore -> SchedulerPro/data/SchedulerProCalendarManagerStore
 */

class CalendarManagerStore extends _SchedulerPro_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      modelClass: _model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
CalendarManagerStore._$name = 'CalendarManagerStore';

/***/ }),

/***/ "./lib/Gantt/data/DependencyStore.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/data/DependencyStore.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyStore; });
/* harmony import */ var _SchedulerPro_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/data/DependencyStore.js */ "./lib/SchedulerPro/data/DependencyStore.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Gantt/model/DependencyModel.js");
var productName = 'gantt';


/**
 * @module Gantt/data/DependencyStore
 */

/**
 * A class representing a collection of dependencies between tasks in the {@link Gantt.data.TaskStore}.
 * Contains a collection of {@link Gantt.model.DependencyModel} records.
 *
 * ```javascript
 * const dependencyStore = new DependencyStore({
 *      data : [
 *         {
 *              "id"       : 1,
 *              "fromTask" : 11,
 *              "toTask"   : 15,
 *              "lag"      : 2
 *          },
 *          {
 *              "id"       : 2,
 *              "fromTask" : 12,
 *              "toTask"   : 15
 *          }
 *      ]
 * })
 * ```
 * @extends SchedulerPro/data/DependencyStore
 * @typings SchedulerPro/data/DependencyStore -> SchedulerPro/data/SchedulerProDependencyStore
 */

class DependencyStore extends _SchedulerPro_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 300,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 500
    };
  }

}
DependencyStore._$name = 'DependencyStore';

/***/ }),

/***/ "./lib/Gantt/data/ResourceStore.js":
/*!*****************************************!*\
  !*** ./lib/Gantt/data/ResourceStore.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceStore; });
/* harmony import */ var _SchedulerPro_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/data/ResourceStore.js */ "./lib/SchedulerPro/data/ResourceStore.js");
/* harmony import */ var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/ResourceModel.js */ "./lib/Gantt/model/ResourceModel.js");
var productName = 'gantt';


/**
 * @module Gantt/data/ResourceStore
 */

/**
 * A class representing the collection of the resources - {@link Gantt.model.ResourceModel} records.
 *
 * ```javascript
 * const resourceStore = new ResourceStore({
 *      data : [
 *          { "id" : 1, "name" : "John Doe" },
 *          { "id" : 2, "name" : "Jane Doe" }
 *      ]
 * })
 * ```
 * @extends SchedulerPro/data/ResourceStore
 * @typings SchedulerPro/data/ResourceStore -> SchedulerPro/data/SchedulerProResourceStore
 */

class ResourceStore extends _SchedulerPro_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 400,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 200
    };
  }

}
ResourceStore._$name = 'ResourceStore';

/***/ }),

/***/ "./lib/Gantt/data/TaskStore.js":
/*!*************************************!*\
  !*** ./lib/Gantt/data/TaskStore.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/TaskModel.js */ "./lib/Gantt/model/TaskModel.js");
/* harmony import */ var _Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Gantt/data/mixin/PartOfProject.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Wbs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Wbs.js */ "./lib/Gantt/data/Wbs.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';







/**
 * @module Gantt/data/TaskStore
 */

const refreshWbsForChildrenOptions = {
  deep: true
},
      wbsAuto = Object.freeze({
  add: true,
  remove: true,
  sort: true
}),
      wbsManual = Object.freeze({
  add: false,
  remove: false,
  sort: false
});
/**
 * An object that describes the actions that should trigger a {@link Gantt.model.TaskModel#function-refreshWbs} to
 * update WBS values. Objects of this type are passed to {@link Gantt.data.TaskStore#config-wbsMode} when the simpler
 * values of `'auto'` or (the default) `'manual'` are not desired.
 *
 * The value `'auto'` is equivalent to all properties of this object being `true`.
 * The value `'manual'` is equivalent to all properties of this object being `false`.
 *
 * @typedef WbsMode
 * @property {Boolean} [add] Set this property to `true` to refresh WBS values when nodes are added.
 * @property {Boolean} [remove] Set this property to `true` to refresh WBS values when nodes are removed.
 * @property {Boolean} [sort] Set this property to `true` to refresh WBS values when nodes are sorted.
 */

/**
 * A class representing the tree of tasks in the Gantt project. An individual task is represented as an instance of the
 * {@link Gantt.model.TaskModel} class. The store expects the data loaded to be hierarchical. Each parent node should
 * contain its children in a property called 'children'.
 *
 * ```javascript
 * const taskStore = new TaskStore({
 *      data : [
 *          {
 *               "id"           : 1000,
 *               "name"         : "Cool project",
 *               "percentDone"  : 50,
 *               "startDate"    : "2019-01-02",
 *               "expanded"     : true,
 *               "children"     : [
 *                   {
 *                       "id"           : 1,
 *                       "name"         : "A leaf node",
 *                       "startDate"    : "2019-01-02",
 *                       "percentDone"  : 50,
 *                       "duration"     : 10,
 *                   }
 *              ]
 *           }
 *      ]
 * });
 * ```
 *
 * @extends Core/data/AjaxStore
 */

class TaskStore extends _Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["ChronoEventTreeStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]).mixin(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  static get defaultConfig() {
    return {
      modelClass: _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @config {Number}
       * @private
       */
      loadPriority: 200,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @config {Number}
       * @private
       */
      syncPriority: 300,
      storeId: 'tasks',
      tree: true
    };
  }

  static get configurable() {
    return {
      /**
       * Set to `'auto'` to automatically update {@link Gantt.model.TaskModel#field-wbsValue} as records in the
       * store are manipulated (e.g., when the user performs drag-and-drop reordering).
       *
       * In manual mode, the WBS value is initialized as the store loads and only altered implicitly by the
       * {@link #function-indent} and {@link #function-outdent} methods. The WBS values are otherwise updated only
       * by an explicit call to {@link Gantt.model.TaskModel#function-refreshWbs}.
       *
       * This can also be a {@link Gantt.data.TaskStore#typedef-WbsMode} object that indicates what operations
       * should automatically {@link Gantt.model.TaskModel#function-refreshWbs refresh} WBS values.
       *
       * The operations that trigger WBS refresh can be enabled explicitly in this object, for example:
       *
       * ```javascript
       *  wbsMode : {
       *      add : true,
       *      remove : true
       *  }
       * ```
       * The above is an opt-in list that enable auto WBS refresh for node add and remove operations (these two
       * operations are associated with dragging to reorder items). No other operation will trigger WBS refresh.
       * At present, this leaves out only the `sort` operation, but if new auto-refreshing operations were added
       * in future releases, those would also not be included.
       *
       * Alternatively, this object can be an opt-out specification if all values are falsy:
       *
       * ```javascript
       *  wbsMode : {
       *      sort : false
       *  }
       * ```
       * The above two examples are (currently) equivalent in outcome. The choice between opt-in or opt-out form
       * is a matter of convenience as well as future-proofing preference.
       *
       * The value `'auto'` is equivalent to all properties being `true`.
       * The value `'manual'` (the default) is equivalent to all properties being `false`.
       * @config {String|WbsMode}
       */
      wbsMode: 'manual'
    };
  }

  changeWbsMode(value) {
    if (value === 'auto') {
      return wbsAuto;
    }

    if (value && typeof value === 'object') {
      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].values(value).every(v => !v)) {
        // if (an opt-out list)
        value = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, wbsAuto, value);
      }

      return value;
    }

    return wbsManual;
  }
  /**
   * For each task in this TaskStore, sets the data in the passed baseline index to the current state of the task.
   * @param {Number} index The index in the baselines list of the baseline to update.
   */


  setBaseline(index) {
    const data = this.storage.values;
    this.forEach(task => task.setBaseline(index));
    this.trigger('refresh', {
      action: 'batch',
      records: data,
      data
    });
  }
  /**
   * Increase the indentation level of one or more tasks in the tree
   * @param {Gantt.model.TaskModel|Gantt.model.TaskModel[]} nodes The nodes to indent.
   * @return {Promise} A promise which yields the result of the operation
   * @fires indent
   * @fires change
   */


  async indent(nodes) {
    const me = this,
          {
      taskStore,
      project
    } = me;
    let result = false;
    nodes = Array.isArray(nodes) ? nodes.slice() : [nodes]; // 1. Filter out project nodes

    nodes = nodes.filter(node => !node.isProjectModel); // 2. Filtering out all nodes which parents are also to be indented as well as the ones having no previous
    //    sibling since such nodes can't be indented

    nodes = nodes.filter(node => {
      let result;
      result = Boolean(node.previousSibling);

      while (result && !node.isRoot) {
        result = !nodes.includes(node.parent);
        node = node.parent;
      }

      return result;
    });
    /**
     * Fired before tasks in the tree are indented. Return `false` from a listener to prevent the indent.
     * @event beforeIndent
     * @preventable
     * @param {Gantt.data.TaskStore} source The task store
     * @param {Gantt.model.TaskModel[]} records Tasks to be indented
     */

    if (nodes.length && taskStore.trigger('beforeIndent', {
      records: nodes
    }) !== false) {
      // 3. Sorting nodes into tree walk order
      nodes.sort((lhs, rhs) => _Wbs_js__WEBPACK_IMPORTED_MODULE_6__["default"].compare(lhs.wbsCode, rhs.wbsCode)); // No events should go to the UI until we have finished the operation successfully

      taskStore.beginBatch(); // Ask the project to try the indent operation

      result = await project.tryPropagateWithChanges(() => {
        for (const node of nodes) {
          const newParent = node.previousSibling;
          newParent.appendChild(node);
          me.toggleCollapse(newParent, false);
        }
      }); // Now show the successful result

      taskStore.endBatch();

      if (result) {
        me.refreshWbsForChildren({
          up: 2,
          // the nodes are now deeper but that move affects their grandparent node's WBS
          nodes
        });
        /**
         * Fired after tasks in the tree are indented
         * @event indent
         * @param {Gantt.data.TaskStore} source The task store
         * @param {Gantt.model.TaskModel[]} records Tasks that got indent
         */

        me.trigger('indent', {
          records: nodes
        });
        me.trigger('change', {
          action: 'indent',
          records: nodes
        });
      }
    }

    return result;
  }
  /**
   * Decrease the indentation level of one or more tasks in the tree
   * @param {Gantt.model.TaskModel|Gantt.model.TaskModel[]} nodes The nodes to outdent.
   * @return {Promise} A promise which yields the result of the operation
   * @fires outdent
   * @fires change
   */


  async outdent(nodes) {
    const me = this,
          {
      taskStore,
      project
    } = me;
    let result = false;
    nodes = Array.isArray(nodes) ? nodes.slice() : [nodes]; // 1. Filter out project nodes

    nodes = nodes.filter(node => !node.isProjectModel); // 2. Filtering out all nodes which parents are also to be outdented as well as the ones having no previous sibling
    //    since such nodes can't be indented

    nodes = nodes.filter(node => {
      let result;
      result = node.parent && !node.parent.isRoot;

      while (result && !node.isRoot) {
        result = !nodes.includes(node.parent);
        node = node.parent;
      }

      return result;
    });
    /**
     * Fired before tasks in the tree are outdented. Return `false` from a listener to prevent the outdent.
     * @event beforeOutdent
     * @preventable
     * @param {Gantt.data.TaskStore} source The task store
     * @param {Gantt.model.TaskModel[]} records Tasks to be outdented
     */

    if (nodes.length && taskStore.trigger('beforeOutdent', {
      records: nodes
    }) !== false) {
      // 3. Sorting nodes into reverse tree walk order
      nodes.sort((lhs, rhs) => _Wbs_js__WEBPACK_IMPORTED_MODULE_6__["default"].compare(lhs.wbsCode, rhs.wbsCode)); // No events should go to the UI until we have finished the operation successfully

      taskStore.beginBatch();
      result = await project.tryPropagateWithChanges(() => {
        for (const node of nodes) {
          const newChildren = node.parent.children.slice(node.parent.children.indexOf(node) + 1);
          node.parent.parent.insertChild(node, node.parent.nextSibling);
          node.appendChild(newChildren);
          me.toggleCollapse(node, false);
        }
      });
      taskStore.endBatch();

      if (result) {
        me.refreshWbsForChildren({
          up: 1,
          // only need to update the (new) parent
          nodes
        });
        /**
         * Fired after tasks in the tree are outdented
         * @event outdent
         * @param {Gantt.data.TaskStore} source The task store
         * @param {Gantt.model.TaskModel[]} records Tasks that got outdent
         */

        me.trigger('outdent', {
          records: nodes
        });
        me.trigger('change', {
          action: 'outdent',
          records: nodes
        });
      }
    }

    return result;
  }

  onNodeAddChild(parent, children, index, isMove, silent = false) {
    super.onNodeAddChild(parent, children, index, isMove, silent);

    if (!this.isLoadingData && this.wbsMode.add) {
      parent.refreshWbs(refreshWbsForChildrenOptions);
    }
  }

  onNodeRemoveChild(parent, children, index, flags = {
    isMove: false,
    silent: false,
    unfiltered: false
  }) {
    super.onNodeRemoveChild(parent, children, index, flags);

    if (this.wbsMode.remove) {
      parent.refreshWbs(refreshWbsForChildrenOptions);
    }
  }

  afterPerformSort(silent) {
    if (this.wbsMode.sort) {
      this.rootNode.refreshWbs(refreshWbsForChildrenOptions);
    }

    super.afterPerformSort(silent);
  }
  /**
   * This method updates the WBS values due to changes in the indentation of a given set of child nodes.
   * @param {Object} options An object containing options in addition to a `nodes` property with the children.
   * @param {Gantt.model.TaskModel[]} options.nodes The array of child record to refresh. This is required.
   * @param {Boolean} [options.silent=false] Pass `true` to update the `wbsValue` silently (no events).
   * @param {Number} [options.up=1] The number of ancestors to ascend when determining the parent(s) to refresh.
   * By default, this value is 1 which indicates the immediate parent of the supplied nodes. This is suitable for
   * outdenting. For indenting, this value should be 2. This is because the previous parent node (now grandparent
   * node) needs to be refreshed, not merely the new parent.
   * @private
   */


  refreshWbsForChildren(options) {
    const nodes = options.nodes,
          opts = _objectSpread(_objectSpread({}, refreshWbsForChildrenOptions), options),
          parents = new Set(),
          up = opts.up || 0;

    let n, parent;
    nodes.forEach(node => {
      for (parent = node, n = up; parent && n; --n) {
        parent = parent.parent;
      }

      parents.add(parent);
    });

    for (parent of parents) {
      parent.refreshWbs(opts);
    }
  }

  getTotalTimeSpan() {
    return {
      startDate: this.getProject().startDate,
      endDate: this.getProject().endDate
    };
  } // Trimmed down version of EventStore.getEvent(), needed when using a Gantt project in Scheduler Pro

  /**
   * Returns an array of tasks a Resource for the date range specified by the `startDate` and `endDate` options.
   *
   * By default, for any date, this includes any task which *intersects* that date.
   *
   * To only include tasks that are fully contained *within* the date range, pass the `allowPartial`
   * option as `false`
   *
   * Example:
   *
   * ```javascript
   *  visibleTasks = taskStore.getEvents({
   *      resourceRecord,
   *      startDate : gantt.timeAxis.startDate,
   *      endDate   : gantt.timeAxis.endDate
   *  });
   * ```
   *
   * @param {Date} [options.startDate] The start date for the range of tasks to include.
   * @param {Date} [options.endDate] The end date for the range of tasks to include.
   * @param {Gantt.model.ResourceModel} options.resourceRecord Resource to return tasks for.
   * @param {Function} [options.filter] A function to filter out tasks which are not required.
   * @returns {Scheduler.model.EventModel[]} Tasks which match the passed configuration.
   * @internal
   */


  getEvents({
    filter,
    resourceRecord,
    startDate,
    // Events which intersect the startDate/endDate
    endDate // will be returned

  }) {
    const me = this;

    if (!me.count) {
      return [];
    }

    const storeFilterFn = me.isFiltered ? eventRecord => me.indexOf(eventRecord) > -1 : null,
          dateFilter = e => e.startDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].intersectSpans(e.startDate, e.endDate || e.startDate, startDate, endDate);

    let events = me.getEventsForResource(resourceRecord); // Events found from the date indices won't be filtered.
    // On the other side, when using getEventForResource we will get all events for
    // the resource even if the EventStore is filtered, handle this by excluding "invisible" events here

    if (storeFilterFn) {
      events = events.filter(storeFilterFn);
    }

    events = events.filter(dateFilter); // filter = filter && onlyAssigned ? e => filter(e) && e.resources.length : onlyAssigned ? e => e.resources.length : filter;

    return filter ? events.filter(filter) : events;
  }

  getEventsForResource(resourceId) {
    const resource = this.resourceStore.getById(resourceId),
          assignments = (resource === null || resource === void 0 ? void 0 : resource.assignments.filter(assignment => assignment.isPartOfStore(this.assignmentStore))) || [],
          events = [];
    assignments.forEach(({
      event
    }) => event && events.push(event));
    return events;
  }
  /**
   * Checks if a date range is allocated or not for a given resource.
   * @param {Date} start The start date
   * @param {Date} end The end date
   * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
   * @param {Scheduler.model.ResourceModel} resource The resource
   * @return {Boolean} True if the timespan is available for the resource
   * @category Resource
   */


  isDateRangeAvailable(start, end, excludeEvent, resource) {
    // NOTE: Also exists in EventStoreMixin.js
    // This should be a collection of unique event records
    const allEvents = new Set(this.getEventsForResource(resource)); // In private mode we can pass an AssignmentModel. In this case, we assume that multi-assignment is used.
    // So we need to make sure that other resources are available for this time too.
    // No matter if the event retrieved from the assignment belongs to the target resource or not.
    // We gather all events from from the resources the event is assigned to except of the one from the assignment record.
    // Note, events from the target resource are added above.

    if (excludeEvent !== null && excludeEvent !== void 0 && excludeEvent.isAssignment) {
      const currentEvent = excludeEvent.event,
            resources = currentEvent.resources;
      resources.forEach(resource => {
        // Ignore events for the resource which is passed as an AssignmentModel to excludeEvent
        if (resource.id !== excludeEvent.resourceId) {
          this.getEventsForResource(resource).forEach(event => allEvents.add(event));
        }
      });
    }

    if (excludeEvent) {
      const eventToRemove = excludeEvent.isAssignment ? excludeEvent.event : excludeEvent;
      allEvents.delete(eventToRemove);
    }

    return !Array.from(allEvents).some(event => event.isScheduled && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].intersectSpans(start, end, event.startDate, event.endDate));
  }

}
TaskStore._$name = 'TaskStore';

/***/ }),

/***/ "./lib/Gantt/data/Wbs.js":
/*!*******************************!*\
  !*** ./lib/Gantt/data/Wbs.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Wbs; });
var productName = 'gantt';
/**
* @module Gantt/data/Wbs
*/

const zeroPad = v => String(v).padStart(6, '0');
/**
 * This class holds a WBS (Work Breakdown Structure) value (e.g., '1.2.1'). This class ensures that such values compare
 * correctly, for example, that '1.2' is less than '1.10' (which do not compare that way as simple text).
 */


class Wbs {
  /**
   * Wbs constructor.
   * @param {String|Number} value The value of WBS
   */
  constructor(value) {
    this.value = value;
    this._padded = null;
  }
  /**
   * The WBS value
   * @readonly
   * @member {String} value
   */


  set value(value) {
    this._value = String(value !== null && value !== void 0 ? value : '');
  }

  get value() {
    return this._value;
  }
  /**
   * Returns a `Wbs` instance given a `value`. If the `value` is already a `Wbs` object, it is returned. Otherwise,
   * a new `Wbs` is created. If `value` is `null` or `undefined`, that value is returned.
   * @param {String|Number|Gantt.data.Wbs} value
   * @returns {Gantt.data.Wbs}
   */


  static from(value) {
    // this must preserve null to be useful as a data field, where a null value means no value present.
    return value == null ? value : value instanceof Wbs ? value : new Wbs(value);
  }
  /**
   * Returns a WBS code where each component is 0-padded on the left to 6 digits. That is "1.2" is padded to be
   * "000001.000002". These values can be compared for proper semantic order (e.g., Wbs.pad('1.2') < Wbs.pad('1.10')).
   * @param {String|Number|Gantt.data.Wbs} value
   * @returns {String}
   * @private
   */


  static pad(value) {
    return value instanceof Wbs ? value.valueOf() : Wbs.split(value).map(zeroPad).join('.');
  }
  /**
   * Returns an array of digits from a given WBS code `value`. If the value cannot be converted, an empty array is
   * returned.
   * @param {String|Number|Gantt.data.Wbs} value
   * @returns {Number[]}
   * @private
   */


  static split(value) {
    let i, ret;

    if (value || value === 0) {
      switch (typeof value) {
        case 'object':
          value = String(value);
        // noinspection FallThroughInSwitchStatementJS

        case 'string':
          // eslint-disable-line no-fallthrough
          ret = value.split('.');

          for (i = ret.length; i-- > 0;) {
            ret[i] = parseInt(ret[i], 10);
          }

          break;

        case 'number':
          ret = [value];
          break;
      }
    }

    return ret || [];
  }
  /**
   * Compares two WBS values, returning 0 if equal, -1 if `lhs` is less than `rhs, or 1 if `lhs` is greater than `rhs`.
   * @param {String|Gantt.data.Wbs} lhs
   * @param {String|Gantt.data.Wbs} rhs
   * @returns {Number}
   */


  static compare(lhs, rhs) {
    if (lhs === rhs) {
      return 0;
    }

    if (!lhs || !rhs) {
      return lhs ? 1 : rhs ? -1 : 0;
    }

    lhs = Wbs.pad(lhs);
    rhs = Wbs.pad(rhs);
    return lhs < rhs ? -1 : rhs < lhs ? 1 : 0;
  }
  /**
   * Appends a sub-level WBS value to this WBS code and returns a `Wbs` instance for it.
   * @param {String|Number} value
   * @returns {Gantt.data.Wbs}
   */


  append(value) {
    const s = this.value;
    return Wbs.from(s ? `${s}.${value}` : value);
  }
  /**
   * Returns truthy value if this Wbs equals the passed value.
   * @param {String|Gantt.data.Wbs} value
   * @return {Boolean}
   */


  isEqual(value) {
    return !Wbs.compare(this, value);
  }
  /**
   * Compares this WBS value with a specified pattern, returning `true` if they match. If the `pattern` is simply a
   * sequence of digits and decimal points (e.g., "1.2"), it is a match if it is a substring of this WBS code (e.g.,
   * "3.1.2.4"). If the `pattern` starts with `*` (e.g., "*.1.2"), it is a match if this WBS code ends with the text
   * following the `*` (e.g., "4.3.1.2"). If the `pattern` ends with `*`, it is a match if this WBS code starts with
   * the text up to the `*`.
   *
   * Some examples:
   * ```
   *  console.log(Wbs.from('1.2.3.4').match('2.3'));
   *  > true
   *  console.log(Wbs.from('1.2.3.4').match('*.4'));
   *  > true
   *  console.log(Wbs.from('1.2.3.4').match('1.2.*'));
   *  > true
   *
   *  console.log(Wbs.from('1.2.3.4').match('2.4'));
   *  > false
   *  console.log(Wbs.from('1.2.3.4').match('*.3'));
   *  > false
   *  console.log(Wbs.from('1.2.3.4').match('2.*'));
   *  > false
   * ```
   * @param {String} pattern A partial WBS code (e.g., "1.2"), optionally starting or ending with `*`.
   * @returns {Boolean}
   */


  match(pattern) {
    let ret = false;

    if (pattern) {
      const wbs = this.value,
            globLeft = pattern[0] === '*',
            globRight = pattern.endsWith('*'),
            n = pattern.length;

      if (globLeft === globRight) {
        // no globs behavior is the same as both globs ('1.2' is the same as '*1.2*')
        ret = wbs.indexOf(globLeft ? pattern.substr(1, n - 2) : pattern) > -1;
      } else if (globLeft) {
        ret = wbs.endsWith(pattern.substr(1));
      } else {
        ret = wbs.startsWith(pattern.substr(0, n - 1));
      }
    }

    return ret;
  }

  toString() {
    return this.value;
  }

  toJSON() {
    return this.toString();
  }

  valueOf() {
    var _this$_padded;

    // the value we return is implicitly used by < and > operators when comparing instances of this type, so we
    // need to return a value that makes "1.2 < 1.10" evaluate as true:
    return (_this$_padded = this._padded) !== null && _this$_padded !== void 0 ? _this$_padded : this._padded = Wbs.pad(this.value);
  }

}
Wbs._$name = 'Wbs';

/***/ }),

/***/ "./lib/Gantt/data/field/WbsField.js":
/*!******************************************!*\
  !*** ./lib/Gantt/data/field/WbsField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WbsField; });
/* harmony import */ var _Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/data/field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _Wbs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Wbs.js */ "./lib/Gantt/data/Wbs.js");
var productName = 'gantt';


/**
 * @module Gantt/data/field/WbsField
 */

/**
 * This class is used for a WBS (Work Breakdown Structure) field. These fields hold a {@link Gantt.data.Wbs}
 * object for their value.
 *
 * @extends Core/data/field/DataField
 */

class WbsField extends _Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'wbs';
  }

  convert(value) {
    return _Wbs_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(value);
  }

  serialize(value) {
    // the wbsValue field is not persistent, so this is likely not going to be called... however, the user could
    // flip that option so we implement this method in case that happens.
    return String(value);
  }

}
WbsField.prototype.compare = _Wbs_js__WEBPACK_IMPORTED_MODULE_1__["default"].compare;
WbsField.initClass();
WbsField._$name = 'WbsField';

/***/ }),

/***/ "./lib/Gantt/data/mixin/PartOfProject.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/data/mixin/PartOfProject.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SchedulerPro_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../SchedulerPro/data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _SchedulerPro_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

var productName = 'gantt';
/**
* @module Gantt/data/mixin/PartOfProject
*/

/**
 * This is a mixin, included in all models and stores of the Gantt project. It provides a common API for accessing
 * all stores of the project.
 *
 * @mixin
 */



/***/ }),

/***/ "./lib/Gantt/feature/Baselines.js":
/*!****************************************!*\
  !*** ./lib/Gantt/feature/Baselines.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Baselines; });
/* harmony import */ var _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/Baselines
 */

const baselineSelector = '.b-task-baseline';
/**
 * Displays a {@link Gantt.model.TaskModel task}'s {@link Gantt.model.TaskModel#field-baselines baselines}
 * below the tasks in the timeline.
 *
 * This feature also optionally shows a tooltip when hovering any of the task's baseline elements. The
 * tooltip's content may be customized
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @inlineexample Gantt/feature/Baselines.js
 * @demo Gantt/baselines
 * @classtype baselines
 * @feature
 */

class Baselines extends _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Baselines';
  } // Default configuration.


  static get defaultConfig() {
    return {
      cls: 'b-gantt-task-tooltip',
      align: 't-b',
      forSelector: baselineSelector,
      recordType: 'baseline'
    };
  }

  static get pluginConfig() {
    return {
      chain: [// onTaskDataGenerated for populating task with baselines
      'onTaskDataGenerated', // onPaint for creating tooltip (in TooltipBase)
      'onPaint']
    };
  } //endregion
  //region Init & destroy


  construct(gantt, config) {
    this.tipId = `${gantt.id}-baselines-tip`;
    this.gantt = gantt;
    super.construct(gantt, config);
  }

  doDisable(disable) {
    const {
      client
    } = this,
          {
      dependencies
    } = client.features; // Hide or show the baseline elements

    client.refreshWithTransition(); // Redraw dependencies *after* elements have animated to new position,
    // and we must clear cache because of position changes.

    if (dependencies) {
      client.setTimeout(() => dependencies.scheduleDraw(true), 300);
    }

    super.doDisable(disable);
  } //endregion
  //region Element & template


  resolveTimeSpanRecord(forElement) {
    const baselineElement = forElement.closest(baselineSelector);
    return baselineElement === null || baselineElement === void 0 ? void 0 : baselineElement.elementData.baseline;
  }
  /**
   * Template (a function accepting event data and returning a string) used to display info in the tooltip.
   * The template will be called with an object as with fields as detailed below
   * @config {Function}
   * @param {Object} data A data block containing the information needed to create tooltip content.
   * @param {Gantt.model.Baseline} data.baseline The Baseline record to display
   * @param {Gantt.model.TaskModel} data.baseline.task The owning task of the baseline.
   * @param {String} data.startClockHtml Predefined HTML to show the start time.
   * @param {String} data.endClockHtml Predefined HTML to show the end time.
   */


  template(data) {
    const me = this,
          {
      baseline
    } = data,
          {
      task
    } = baseline,
          displayDuration = me.client.formatDuration(baseline.duration);
    return `
            <div class="b-gantt-task-title">${task.name} (baseline ${baseline.parentIndex + 1})</div>
            <table>
            <tr><td>${me.L('L{TaskTooltip.Start}')}:</td><td>${data.startClockHtml}</td></tr>
            ${baseline.milestone ? '' : `
                <tr><td>${me.L('L{TaskTooltip.End}')}:</td><td>${data.endClockHtml}</td></tr>
                <tr><td>${me.L('L{TaskTooltip.Duration}')}:</td><td class="b-right">${displayDuration + ' ' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getLocalizedNameOfUnit(baseline.durationUnit, baseline.duration !== 1)}</td></tr>
            `}
            </table>
            `;
  }

  getTaskDOMConfig(taskRecord, top) {
    const baselines = taskRecord.baselines.allRecords;
    return {
      className: {
        'b-baseline-wrap': true
      },
      style: {
        transform: `translateY(${top}px)`
      },
      dataset: {
        // Prefix task id to allow element reusage also for baseline wrap
        taskId: `baselinesFor${taskRecord.id}`
      },
      children: baselines.map((baseline, i) => {
        const baselineBox = this.gantt.taskRendering.getTaskBox(baseline);
        return baselineBox ? {
          className: {
            [baseline.cls]: baseline.cls,
            'b-task-baseline': 1,
            'b-task-baseline-milestone': baseline.milestone
          },
          style: {
            width: baselineBox.width,
            left: baselineBox.left
          },
          dataset: {
            index: i
          },
          elementData: {
            baseline
          }
        } : null;
      }),
      syncOptions: {
        syncIdField: 'index'
      }
    };
  }

  onTaskDataGenerated({
    taskRecord,
    top,
    extraConfigs
  }) {
    if (!this.disabled && taskRecord.hasBaselines) {
      extraConfigs.push(this.getTaskDOMConfig(taskRecord, top));
    }
  } //endregion


}
Baselines._$name = 'Baselines';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Baselines, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/CellEdit.js":
/*!***************************************!*\
  !*** ./lib/Gantt/feature/CellEdit.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellEdit; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/CellEdit
 */

/**
 * Extends the {@link Grid.feature.CellEdit} to encapsulate Gantt functionality. This feature is enabled by <b>default</b>
 *
 * {@inlineexample Gantt/feature/CellEdit.js}
 *
 * Editing can be started by a user by double-clicking an editable cell in the gantt's data grid, or it can be started programmatically
 * by calling {@link Grid/feature/CellEdit#function-startEditing} and providing it with correct cell context.
 *
 * See {@link #function-doAddNewAtEnd}.
 *
 * ## Instant update
 * If {@link Grid.column.Column#config-instantUpdate} on the column is set to true, record will be
 * updated instantly as value in the editor is changed. In combination with
 * {@link Gantt.model.ProjectModel#config-autoSync} it could result in excessive requests to the backend.
 *
 * Instant update is enabled for these columns by default:
 * - {@link SchedulerPro.column.DurationColumn}
 * - {@link Gantt.column.StartDateColumn}
 * - {@link Gantt.column.EndDateColumn}
 * - {@link Gantt.column.ConstraintDateColumn}
 * - {@link Gantt.column.DeadlineDateColumn}
 * - {@link Gantt.column.EarlyStartDateColumn}
 * - {@link Gantt.column.EarlyEndDateColumn}
 * - {@link Gantt.column.LateStartDateColumn}
 * - {@link Gantt.column.LateEndDateColumn}
 *
 * To disable instant update on the column set config to false:
 * ```
 * new Gantt({
 *     columns: [
 *         {
 *             type: 'startdate',
 *             instantUpdate: false
 *         }
 *     ]
 * })
 * ```
 *
 * @extends Grid/feature/CellEdit
 *
 * @classtype cellEdit
 * @feature
 * @typings Grid/feature/CellEdit -> Grid/feature/GridCellEdit
 */

class CellEdit extends _Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    // NOTE: Even though the class name matches the one defined on the base class
    // we need this method in order registerFeature() to work properly
    // (it uses hasOwnProperty when detecting the class name)
    return 'CellEdit';
  } // Default configuration


  static get defaultConfig() {
    return {
      addNewAtEnd: {
        duration: 1
      }
    };
  }

  static get pluginConfig() {
    const cfg = super.pluginConfig;
    cfg.chain = [...cfg.chain, 'onProjectChange'];
    return cfg;
  }

  onProjectChange() {
    // Cancel editing if project is changed
    this.cancelEditing(true);
  } // Provide any editor with access to the current project


  getEditorForCell({
    record
  }) {
    const editor = super.getEditorForCell(...arguments),
          inputField = editor.inputField;
    inputField.project = record.project;
    inputField.eventRecord = record;
    return editor;
  }
  /**
   * Adds a new, empty record at the end of the TaskStore with the initial
   * data specified by the {@link Grid.feature.CellEdit#config-addNewAtEnd} setting.
   *
   * @returns {Promise} Newly added record wrapped in a promise.
   */


  async doAddNewAtEnd() {
    const gantt = this.grid,
          addNewAtEnd = this.addNewAtEnd,
          taskStore = gantt.taskStore; // First finish any ongoing calculations

    await taskStore.getProject().commitAsync();
    const newTask = taskStore.rootNode.appendChild(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
      name: this.L('L{Gantt.New task}'),
      startDate: taskStore.getProject().startDate
    }, addNewAtEnd));
    await taskStore.getProject().commitAsync(); // If the new record was not added due to it being off the end of the rendered block
    // ensure we force it to be there before we attempt to edit it.

    if (!gantt.rowManager.getRowFor(newTask)) {
      gantt.rowManager.displayRecordAtBottom();
    }

    return newTask;
  }

}
CellEdit._$name = 'CellEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(CellEdit, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/CriticalPaths.js":
/*!********************************************!*\
  !*** ./lib/Gantt/feature/CriticalPaths.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CriticalPaths; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/CriticalPaths
 */

/**
 * This feature highlights the project _critical paths_.
 * Every task is important, but only some of them are critical.
 * The critical path is a chain of linked tasks that directly affects the project finish date.
 * If any task on the critical path is late, the whole project is late.
 *
 * For more details on the _critical path method_ please check this article: https://en.wikipedia.org/wiki/Critical_path_method
 *
 * This feature is loaded by default, but the visualization needs to be enabled:
 *
 * ```javascript
 * // let's visualize the project critical paths
 * gantt.features.criticalPaths.disabled = false;
 * ```
 * {@inlineexample Gantt/feature/CriticalPaths.js}
 *
 * If you need to get information about critical paths, you can refer to
 * {@link Gantt/model/ProjectModel#property-criticalPaths} property of the project:
 * ```javascript
 * const paths = gantt.project.criticalPaths;
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Gantt/criticalpaths
 * @classtype criticalPaths
 * @feature
 */

class CriticalPaths extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'CriticalPaths';
  }

  static get defaultConfig() {
    return {
      cls: 'b-gantt-critical-paths',
      criticalDependencyCls: 'b-critical',
      disabled: true
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onTaskDataGenerated']
    };
  } //endregion
  //region Init


  doDisable(disable) {
    if (disable) {
      this.unhighlightCriticalPaths();
    } else {
      this.highlightCriticalPaths();
    }

    super.doDisable(disable);
  }

  getDependenciesFeature() {
    // return dependencies feature only when it's ready
    return this.client.foregroundCanvas && this.client.features.dependencies;
  }

  setupObserver() {
    const me = this,
          {
      project
    } = me.client;
    let dependencies; // destroy previous observer if any

    me.destroyObserver();
    me.criticalPathObserver = project.getGraph().observe(function* () {
      return yield project.$.criticalPaths;
    }, criticalPaths => {
      // if the feature is not disabled
      if (!me.disabled) {
        me.removeCriticalCls(); // check if dependencies feature is there

        if (dependencies = dependencies || me.getDependenciesFeature()) {
          for (const path of criticalPaths) {
            for (const node of path) {
              if (node.dependency) {
                dependencies.highlight(node.dependency, me.criticalDependencyCls);
              }
            }
          }
        }
        /**
         * Fired when critical paths get highlighted.
         *
         * See also: {@link #event-criticalPathsUnhighlighted}
         * @event criticalPathsHighlighted
         */


        me.client.trigger('criticalPathsHighlighted');
      }
    });
  }

  destroyObserver() {
    if (this.criticalPathObserver) {
      this.client.project.getGraph().removeIdentifier(this.criticalPathObserver);
      this.criticalPathObserver = null;
    }
  }

  doDestroy() {
    this.destroyObserver();
    super.doDestroy();
  }

  highlightCriticalPaths() {
    const me = this,
          {
      element
    } = me.client; // the component has cls set means we had CPs rendered so need to clean them

    if (element.classList.contains(me.cls)) {
      me.unhighlightCriticalPaths();
    }

    me.setupObserver(); // add the feature base cls to enable stylesheets

    element.classList.add(me.cls);
  }

  removeCriticalCls() {
    const project = this.client.project,
          dependencies = this.getDependenciesFeature(); // if we have dependencies rendered remove classes from them

    if (dependencies) {
      project.dependencyStore.forEach(dependency => dependencies.unhighlight(dependency, this.criticalDependencyCls));
    }
  }

  unhighlightCriticalPaths() {
    const me = this,
          client = me.client; // destroy criticalPath atom observer

    me.destroyObserver();
    me.removeCriticalCls(); // remove the feature base cls

    client.element.classList.remove(me.cls);
    /**
     * Fired when critical paths get hidden.
     *
     * See also: {@link #event-criticalPathsHighlighted}
     * @event criticalPathsUnhighlighted
     */

    client.trigger('criticalPathsUnhighlighted');
  } //endregion
  // Add DOMConfigs for enabled indicators as `extraConfigs` on the task. Will in the end be added to the task row


  onTaskDataGenerated(renderData) {
    if (!this.disabled) {
      renderData.cls['b-critical'] = renderData.taskRecord.critical;
    }
  }

}
CriticalPaths._$name = 'CriticalPaths';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(CriticalPaths, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/Dependencies.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/feature/Dependencies.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dependencies; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/Dependencies.js */ "./lib/Scheduler/feature/Dependencies.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/DependencyStore.js */ "./lib/Gantt/data/DependencyStore.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model/TaskModel.js */ "./lib/Gantt/model/TaskModel.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
var productName = 'gantt';






/**
 * @module Gantt/feature/Dependencies
 */

const fromBoxSide = ['left', 'left', 'right', 'right'],
      toBoxSide = ['left', 'right', 'left', 'right']; // noinspection JSClosureCompilerSyntax

/**
 * Feature that draws dependencies between tasks. Uses a dependency {@link Gantt.model.ProjectModel#property-dependencyStore store}
 * to determine which dependencies to draw.
 *
 * To customize the dependency tooltip, you can provide the {@link Scheduler.feature.Dependencies#config-tooltip} config and specify a {@link Core.widget.Tooltip#config-getHtml} function.
 * For example:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         dependencies : {
 *             tooltip : {
 *                 getHtml({ activeTarget }) {
 *                     const dependencyModel = gantt.resolveDependencyRecord(activeTarget);
 *
 *                     if (!dependencyModel) return null;
 *
 *                     const { fromEvent, toEvent } = dependencyModel;
 *
 *                     return `${fromEvent.name} (${fromEvent.id}) -> ${toEvent.name} (${toEvent.id})`;
 *                 }
 *             }
 *         }
 *     }
 * }
 * ```
 * This feature is **enabled** by default
 *
 * By default predecessors and successors in columns and the task editor are displayed using task id and name. The id part is configurable, any task field may be used instead (for example wbsCode or sequence number)
 * by {@link Gantt/view/GanttBase#config-dependencyIdField Gantt#dependencyIdField} property.
 * ```javascript
 * const gantt = new Gantt({
 *    dependencyIdField: 'wbsCode',
 *
 *    project,
 *    columns : [
 *        { type : 'name', width : 250 }
 *    ],
 * });
 * ```
 *
 * Also see {@link Gantt/column/DependencyColumn#config-dependencyIdField DependencyColumn#dependencyIdField} to configure columns only if required.
 *
 * {@inlineexample Gantt/guides/gettingstarted/basic.js}
 * @extends Scheduler/feature/Dependencies
 * @typings Scheduler/feature/Dependencies -> Scheduler/feature/SchedulerDependencies
 * @demo Gantt/basic
 * @classtype dependencies
 * @feature
 */

class Dependencies extends _Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'Dependencies';
  }

  static get defaultConfig() {
    return {
      terminalSides: ['left', 'right'],
      storeClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      highlightDependenciesOnEventHover: true
    };
  } //endregion
  //region Init


  construct(gantt, config = {}) {
    const me = this; // Scheduler might be using gantt's feature, when on same page

    if (gantt.isGantt) {
      me.gantt = gantt;
    }

    if (Object.prototype.hasOwnProperty.call(config, 'pathFinderConfig')) {
      if (!Object.prototype.hasOwnProperty.call(config.pathFinderConfig, 'otherHorizontalMargin')) {
        config.pathFinderConfig.otherHorizontalMargin = 0;
      }

      if (!Object.prototype.hasOwnProperty.call(config.pathFinderConfig, 'otherVerticalMargin')) {
        config.pathFinderConfig.otherVerticalMargin = 0;
      }
    } else {
      config.pathFinderConfig = {
        otherHorizontalMargin: 0,
        otherVerticalMargin: 0
      };
    }

    gantt.on({
      projectRefresh: 'onProjectRefresh',
      thisObj: me
    });
    me.added = new Set();
    super.construct(gantt, config);
  } //endregion
  //region Scheduler overrides

  /**
   * Returns the dependency record for a DOM element
   * @function resolveDependencyRecord
   * @param {HTMLElement} element The dependency line element
   * @return {Gantt.model.DependencyModel} The dependency record
   */
  // TaskStore needs some special handling, being the row store in Gantt


  attachToEventStore(store) {
    super.attachToEventStore(store);
    this.detachListeners('taskStore');

    if (store) {
      store.on({
        name: 'taskStore',
        refreshPreCommit: 'onTaskStoreRefresh',
        thisObj: this
      });
    }
  }

  onDependencyChange({
    action,
    record,
    records
  }) {
    // We don't need this listener in case the gantt is loading data
    // since it does (here in onProjectRefresh() method) full dependencies draw in that case
    if (!this.client.project.propagatingLoadChanges) {
      switch (action) {
        case 'add':
          records.forEach(dependencyRecord => this.added.add(dependencyRecord));
          return;
      }

      super.onDependencyChange(...arguments);
    }
  }

  onTaskStoreRefresh({
    action
  }) {
    const me = this;

    switch (action) {
      case 'sort':
        me.scheduleDraw(true);
        break;

      case 'filter':
        // https://github.com/bryntum/support/issues/1815
        // Refresh dependencies after filter
        me.resetGridCache();
        me.scheduleDraw(true);
        break;
    }
  } //endregion
  //region Determining dependencies to draw


  getIteratableDependencyAssignments(dependency) {
    return [null]; // Gantt doesn't use assignments to designated what raw task occupies
  } // Neither task can be hidden for a dependency to be considered visible


  isDependencyVisible(dependency, assignmentData = null) {
    const {
      client
    } = this,
          from = dependency.fromEvent,
          to = dependency.toEvent; // ignore dependency with bad data, the `Object(from) !== from` handles the case
    // when the from is an id of missing task
    // this might change in the future (from will be always either a Task model or undefined)
    // so only the `if (!from || !to) return;` will be needed

    if (!from || !to || Object(from) !== from || Object(to) !== to) return; // assignmentData only used in Scheduler with multi assignment, let it handle the call

    if (!(from instanceof _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]) || assignmentData) {
      return super.isDependencyVisible(dependency, assignmentData);
    } // placeHolder set if either end of the dependency does not exist in store


    return !from.placeHolder && client.store.isAvailable(from) && !to.placeHolder && client.store.isAvailable(to);
  } // Get the bounding box for either the source or the target event


  getBox(dependency, source, assignmentData = null) {
    const taskRecord = this.getTimeSpanRecordFromDependency(dependency, source);

    if (!this.gantt) {
      // Scheduler using gantt's feature (happens when using single bundle)
      if (taskRecord.isEvent || assignmentData) {
        return super.getBox(dependency, source, assignmentData);
      } // Scheduler with taskStore, might not have any resource assigned


      return taskRecord.assignments.length ? this.client.getResourceEventBox(taskRecord, taskRecord.assignments[0].resource, true) : null;
    }

    return this.gantt.getTaskBox(taskRecord, true, true);
  } // Get source or target events resource


  getRowRecordFromDependency(dependency, source) {
    if (!this.gantt) {
      // Scheduler with taskStore, we want the resource
      const taskRecord = this.getTimeSpanRecordFromDependency(dependency, source); // Scheduler using gantt's feature (happens when using single bundle)

      if (taskRecord.isEvent) {
        return super.getRowRecordFromDependency(dependency, source);
      } // Might not have one assigned


      return taskRecord.assignments.length ? taskRecord.assignments[0].resource : null;
    }

    return this.getTimeSpanRecordFromDependency(dependency, source);
  } //endregion
  //region Draw & render


  onProjectRefresh() {
    const {
      added
    } = this; // In Scheduler this happens directly on add, in Gantt it needs to happen after propagate since tasks at each
    // end might move

    if (added.size) {
      for (const dependencyRecord of added) {
        this.addToGridCache(dependencyRecord);
      }

      added.clear();
    } // Need to call super method here to include all the complex logic of `toDrawOnProjectRefresh` map


    super.onProjectRefresh();
    this.scheduleDraw();
  }

  drawLine(canvas, dependency, points, assignmentData = null, cache = true) {
    super.drawLine(canvas, dependency, points, assignmentData);
    const line = super.drawLine(canvas, dependency, points, assignmentData, cache),
          {
      client
    } = this,
          to = dependency.toEvent; // If target event is outside of the view add special CSS class to hide marker (arrow)

    if (!to.milestone && (to.endDate <= client.startDate || client.endDate <= to.startDate) || to.milestone && (to.endDate < client.startDate || client.endDate < to.startDate)) {
      line.classList.add('b-sch-dependency-ends-outside');
    }
  }

  prepareLineDef(dependency, dependencyDrawData, assignmentData = null) {
    const me = this,
          source = me.getTimeSpanRecordFromDependency(dependency, true),
          target = me.getTimeSpanRecordFromDependency(dependency, false),
          type = dependency.type,
          arrowMargin = this.pathFinder.startArrowMargin;
    let startSide = dependency.fromSide,
        endSide = dependency.toSide; // Fallback to view trait if dependency start side is not given

    if (!startSide) {
      switch (true) {
        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].StartToEnd:
          startSide = me.getConnectorStartSide(source);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].StartToStart:
          startSide = me.getConnectorStartSide(source);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].EndToStart:
          startSide = me.getConnectorEndSide(source);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].EndToEnd:
          startSide = me.getConnectorEndSide(source);
          break;

        default:
          throw new Error('Invalid dependency type: ' + type);
      }
    } // Fallback to view trait if dependency end side is not given


    if (!endSide) {
      switch (true) {
        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].StartToEnd:
          endSide = me.getConnectorEndSide(target);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].StartToStart:
          endSide = me.getConnectorStartSide(target);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].EndToStart:
          endSide = me.getConnectorStartSide(target);
          break;

        case type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].EndToEnd:
          endSide = me.getConnectorEndSide(target);
          break;

        default:
          throw new Error('Invalid dependency type: ' + type);
      }
    }

    const {
      startRectangle,
      endRectangle
    } = dependencyDrawData;

    if (type === _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_5__["DependencyType"].EndToStart && // Target box is below source box
    startRectangle.bottom < endRectangle.y && // If source box ends before target box start - draw line to target box top edge
    // Round coordinates to make behavior more consistent on zoomed page
    Math.round(endRectangle.left) >= Math.round(startRectangle.right) && Math.round(endRectangle.right) >= Math.round(startRectangle.right) + arrowMargin) {
      // arrow to left part of top
      endSide = 'top'; // The default entry point for top is the center, but for Gantt Tasks,
      // we join to startArrowMargin inwards from top/left.
      // Milestones always have the top entry point left in the center.

      if (!dependency.toEvent.milestone) {
        endRectangle.right = endRectangle.x + arrowMargin * 2;
      }
    } // append boxes that extend to row boundaries to make sure line is contained there
    // Always consider arrow margin for `otherBoxes`, otherwise, when gap between source and target is less than
    // arrowMargin * 2 (start arrow + end arrow margin), we will have line breaking not on the row boundary


    const sourceRowBox = me.client.getRecordCoords(source, true),
          targetRowBox = me.client.getRecordCoords(target, true),
          // Add vertical box for each task. They are supposed to push line to row boundary
    otherBoxes = [{
      start: startRectangle.x,
      end: startRectangle.right,
      top: sourceRowBox.y,
      bottom: sourceRowBox.y + sourceRowBox.height
    }, {
      start: endRectangle.x,
      end: endRectangle.right,
      top: targetRowBox.y,
      bottom: targetRowBox.y + targetRowBox.height
    }]; // Reversing start/end endpoints generate more Gantt-friendly arrows

    return {
      endBox: {
        start: startRectangle.x,
        end: startRectangle.right,
        top: startRectangle.y,
        bottom: startRectangle.bottom
      },
      startBox: {
        start: endRectangle.x,
        end: endRectangle.right,
        top: endRectangle.y,
        bottom: endRectangle.bottom
      },
      endSide: startSide,
      startSide: endSide,
      boxesReversed: true,
      otherBoxes
    };
  } // onEventChanged({ action, record }) {
  //     switch (action) {
  //         case 'update':
  //             // event updated, redraw its dependencies
  //             return this.drawForTask(record);
  //     }
  // }

  /**
   * Draws all dependencies for the specified task.
   */


  drawForTask(taskRecord) {
    this.drawForTimeSpan(taskRecord);
  }
  /**
   * Sort dependencies with critical dependencies at the end to draw the red path later to avoid gray paths overlap
   * @returns {Map} Dependencies sorted by critical (first non critical)
   * @private
   */


  getSortedDependenciesToRefresh() {
    const criticalFeature = this.client.features.criticalPaths;

    if (criticalFeature && !criticalFeature.disabled) {
      return new Map([...this.dependenciesToRefresh].sort(([{
        fromTask: taskA
      }], [{
        fromTask: taskB
      }]) => (taskA === null || taskA === void 0 ? void 0 : taskA.critical) === (taskB === null || taskB === void 0 ? void 0 : taskB.critical) ? 0 : taskA !== null && taskA !== void 0 && taskA.critical ? 1 : -1));
    } else {
      return this.dependenciesToRefresh;
    }
  } //endregion
  //region Tooltip

  /**
   * Generates html for the tooltip shown when hovering a dependency
   * @param {Object} tooltipConfig
   * @returns {String} Html to display in the tooltip
   * @private
   */


  getHoverTipHtml({
    activeTarget
  }) {
    const me = this,
          dependencyModel = me.resolveDependencyRecord(activeTarget),
          dependencyIdField = me.client.dependencyIdField;

    if (!dependencyModel) {
      return null;
    }

    const {
      fromEvent,
      toEvent
    } = dependencyModel;
    return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].tpl`
             <table class="b-sch-dependency-tooltip">
                <tr>
                    <td>${me.L('L{Dependencies.from}')}: </td>
                    <td>${fromEvent.name} ${fromEvent[dependencyIdField]}</td>
                    <td><div class="b-sch-box b-${fromBoxSide[dependencyModel.type]}"></div></td>
                </tr>
                <tr>
                    <td>${me.L('L{Dependencies.to}')}: </td>
                    <td>${toEvent.name} ${toEvent[dependencyIdField]}</td>
                    <td><div class="b-sch-box b-${toBoxSide[dependencyModel.type]}"></div></td>
                </tr>
            </table>
        `;
  } //endregion
  //region Dependency creation

  /**
   * Create a new dependency from source terminal to target terminal
   * @internal
   */


  async createDependency(data) {
    const me = this,
          {
      source,
      target,
      fromSide,
      toSide
    } = data,
          type = (fromSide === 'left' ? 0 : 2) + (toSide === 'right' ? 1 : 0),
          dependency = me.dependencyStore.add({
      fromEvent: source,
      toEvent: target,
      type
    })[0];
    await me.dependencyStore.project.propagateAsync();
    return dependency;
  } // endregion
  // Add critical path marker which has different color


  createMarkers() {
    super.createMarkers(); // Since Edge and IE11 cannot reverse marker we use one in a
    // required orientation, which exists only in those two browsers

    const endMarker = (this.startMarker || this.endMarker).cloneNode(true);
    endMarker.setAttribute('id', 'arrowEndCritical');
    this.client.svgCanvas.appendChild(endMarker);
  }

}
Dependencies._$name = 'Dependencies';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(Dependencies, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/DependencyEdit.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/feature/DependencyEdit.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyEdit; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/DependencyEdit.js */ "./lib/Scheduler/feature/DependencyEdit.js");
var productName = 'gantt';


/**
 * @module Gantt/feature/DependencyEdit
 */

/**
 * Feature that displays a popup containing fields for editing dependency data.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Scheduler/feature/DependencyEdit
 * @inlineexample Gantt/feature/DependencyEdit.js
 * @typings Scheduler/feature/DependencyEdit -> Scheduler/feature/SchedulerDependencyEdit
 * @demo Gantt/advanced
 * @classtype dependencyEdit
 * @feature
 */

class DependencyEdit extends _Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'DependencyEdit';
  }

  static get defaultConfig() {
    return {
      /**
       * True to show the lag field for the dependency
       * @config {Boolean}
       * @default
       * @category Editor widgets
       */
      showLagField: true
    };
  } //endregion


}
DependencyEdit._$name = 'DependencyEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(DependencyEdit, false);

/***/ }),

/***/ "./lib/Gantt/feature/Indicators.js":
/*!*****************************************!*\
  !*** ./lib/Gantt/feature/Indicators.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Indicators; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';





/**
 * @module Gantt/feature/Indicators
 */

/**
 * The Indicators feature displays indicators (icons) for different dates related to a task in its row. Hovering an
 * indicator will show a tooltip with its name and date(s). The owning task `id` is embedded in the indicator element
 * dataset as `taskRecordId` which can be useful if you want to have custom actions when clicking (showing a menu for example).
 *
 * By default it includes and displays the following indicators (config name):
 * * Early start/end dates (earlyDates)
 * * Late start/end dates (lateDates)
 * * Constraint date (constraintDate)
 * * Deadline date (deadlineDate)
 *
 * {@inlineexample Gantt/feature/Indicators.js}
 *
 * This config will display them all:
 *
 * ```javascript
 * new Gantt({
 *   features : {
 *     indicators : true
 *   }
 * });
 * ```
 *
 * To selectively disable indicators:
 *
 * ```javascript
 * features : {
 *   indicators : {
 *     items : {
 *       earlyDates     : false,
 *       constraintDate : false
 *     }
 *   }
 * }
 * ```
 *
 * They can also be toggled at runtime:
 *
 * ```javascript
 * gantt.features.indicators.items.deadlineDate = true/false;
 * ```
 *
 * The feature also supports adding custom indicators, by adding properties to the `items` config object:
 *
 * ```javascript
 * items : {
 *   lateDates  : false,
 *
 *   // Custom indicator only shown for tasks more than half done
 *   myCustomIndicator : taskRecord => taskRecord.percentDone > 50 ? {
 *      startDate : DateHelper.add(taskRecord.endDate, 2, 'days'),
 *      name : 'My custom indicator',
 *      iconCls : 'b-fa b-fa-alien'
 *   } : null
 * }
 * ```
 *
 * {@inlineexample Gantt/feature/IndicatorsCustom.js}
 *
 * These custom indicators are defined as functions, that accept a task record and return a TimeSpan (or a raw data
 * object). The function will be called for each visible task during rendering, to not show the indicator for certain
 * tasks return `null` from it.
 *
 * When using this feature we recommend that you configure gantt with a larger `rowHeight` + `barMargin` (>15 px), since
 * the indicators are indented to fit below the task bars.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @classType indicators
 * @feature
 * @demo Gantt/indicators
 */

class Indicators extends _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'Indicators';
  }

  static get defaultConfig() {
    return {
      cls: 'b-gantt-task-tooltip',
      // reused on purpose
      forSelector: '.b-indicator',
      recordType: 'indicator',
      hoverDelay: 500,
      defaultIndicators: {
        earlyDates: taskRecord => taskRecord.earlyStartDate && !taskRecord.isMilestone ? {
          startDate: taskRecord.earlyStartDate,
          endDate: taskRecord.earlyEndDate,
          cls: 'b-bottom b-early-dates',
          name: this.L('L{earlyDates}')
        } : null,
        lateDates: taskRecord => taskRecord.lateStartDate && !taskRecord.isMilestone ? {
          startDate: taskRecord.lateStartDate,
          endDate: taskRecord.lateEndDate,
          cls: 'b-bottom b-late-dates',
          name: this.L('L{lateDates}')
        } : null,
        constraintDate: taskRecord => taskRecord.constraintDate ? {
          // Do not remove. Assertion strings for Localization sanity check.
          // 'L{ConstraintTypePicker.none}'
          // 'L{ConstraintTypePicker.muststarton}'
          // 'L{ConstraintTypePicker.mustfinishon}'
          // 'L{ConstraintTypePicker.startnoearlierthan}'
          // 'L{ConstraintTypePicker.startnolaterthan}'
          // 'L{ConstraintTypePicker.finishnoearlierthan}'
          // 'L{ConstraintTypePicker.finishnolaterthan}'
          startDate: taskRecord.constraintDate,
          cls: `b-bottom b-constraint-date b-constraint-type-${taskRecord.constraintType}`,
          name: this.L(`L{ConstraintTypePicker.${taskRecord.constraintType}}`)
        } : null,
        deadlineDate: taskRecord => taskRecord.deadlineDate ? {
          startDate: taskRecord.deadlineDate,
          cls: `b-bottom b-deadline-date`,
          name: this.L('L{deadlineDate}')
        } : null
      },

      /**
       * Used to enable/disable built in indicators and to define custom indicators.
       *
       * ```
       * new Gantt({
       *   features : {
       *     indicators : {
       *       items : {
       *         // Disable deadlineDate indicators
       *         deadlineDate : false,
       *
       *         // Add a custom indicator (called prepare)
       *         prepare : taskRecord => ({
       *            startDate : taskRecord.startDate,
       *            iconCls   : 'b-fa b-fa-magnify',
       *            name      : 'Start task preparations'
       *         })
       *       }
       *     }
       *   }
       * });
       * ```
       *
       * For more information, please see the class description at top.
       *
       * @config {Object}
       * @category Common
       */
      items: null,

      /**
       * A function which receives data about the indicator and returns a string,
       * or a Promise yielding a string (for async tooltips), to be displayed in the tooltip.
       * This method will be called with an object containing the fields below
       * @param {Object} data Indicator data
       * @param {String} data.name Indicator name
       * @param {Date} data.startDate Indicator startDate
       * @param {Date} data.endDate Indicator endDate
       * @param {Gantt.model.TaskModel} data.taskRecord The task to which the indicator belongs
       * @config {Function}
       */
      tooltipTemplate: data => {
        const {
          indicator
        } = data,
              encodedName = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].encodeHtml(indicator.name);

        if (data.endDate) {
          return `
                        ${indicator.name ? `<div class="b-gantt-task-title">${encodedName}</div>` : ''}
                        <table border="0" cellspacing="0" cellpadding="0">
                            <tr><td>${this.L('L{Start}')}:</td><td>${data.startClockHtml}</td></tr>
                            <tr><td>${this.L('L{End}')}:</td><td>${data.endClockHtml}</td></tr>
                        </table>
                    `;
        }

        return `
                    ${indicator.name ? `<div class="b-gantt-task-title">${encodedName}</div>` : ''}
                    ${data.startText}
                `;
      }
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onTaskDataGenerated', 'onPaint']
    };
  } //endregion


  construct(gantt, config = {}) {
    this.tipId = `${gantt.id}-indicators-tip`; // Store items to set manually after config, we do not want to pass them along to the baseclass since it will
    // apply them to the tooltip

    config = Object.assign({}, config);
    const {
      items
    } = config;
    super.construct(gantt, config);
    this.items = items;
  }

  template(...args) {
    return this.tooltipTemplate(...args);
  } // Private setter, not supposed to set it during runtime


  set items(indicators) {
    const me = this; // All indicators, custom + default

    me._indicators = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({}, me.defaultIndicators, indicators); // Accessors to toggle the indicators from the outside

    me._indicatorAccessors = {}; // Keep track of enabled/disabled indicators

    me._indicatorStatus = {};

    for (const name in me._indicators) {
      // Store if indicator is enabled/disabled (enabled if true or fn)
      me._indicatorStatus[name] = Boolean(me._indicators[name]); // If it was configured as true, it means we should use a default implementation

      if (typeof me._indicators[name] !== 'function') {
        me._indicators[name] = me.defaultIndicators[name];
      } // Create accessors so that we can enable/disable on the fly using:
      // gantt.features.indicators.items.deadlineDate = false;


      Object.defineProperty(me._indicatorAccessors, name, {
        enumerable: true,

        get() {
          return me._indicatorStatus[name] ? me._indicators[name] : false;
        },

        set(value) {
          me._indicatorStatus[name] = value;
          me.client.refresh();
        }

      });
    }
  }
  /**
   * Accessors for the indicators that can be used to toggle them at runtime.
   *
   * ```
   * gantt.features.indicators.items.deadlineDate = false;
   * ```
   *
   * @property {Object}
   * @readonly
   * @category Common
   */


  get items() {
    // These accessors are generated in `set items`, allowing runtime enabling/disabling of indicators
    return this._indicatorAccessors;
  } //region Render
  // Map fn that generates a DOMConfig for an indicator


  createIndicatorDOMConfig(indicator, index) {
    const {
      gantt,
      renderData
    } = this,
          {
      taskRecord
    } = renderData,
          {
      cls,
      iconCls
    } = indicator,
          x = gantt.getCoordinateFromDate(indicator.startDate),
          width = indicator.endDate ? gantt.getCoordinateFromDate(indicator.endDate) - x : null,
          classList = cls && cls.isDomClassList ? cls : new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"](cls),
          top = renderData.top || gantt.taskStore.indexOf(taskRecord) * gantt.rowManager.rowOffsetHeight + gantt.resourceMargin,
          height = renderData.height || gantt.rowHeight - gantt.resourceMargin * 2;
    indicator.taskRecord = taskRecord;
    return {
      className: Object.assign(classList, {
        'b-indicator': 1,
        'b-has-icon': indicator.iconCls
      }),
      style: {
        transform: `translate(${x}px, ${top}px)`,
        height,
        width,
        style: indicator.style
      },
      dataset: {
        // For sync
        taskId: `${renderData.taskId}-indicator-${index}`,
        // allow users to look up which task this indicator belongs to
        taskRecordId: renderData.taskId
      },
      children: [iconCls ? {
        tag: 'i',
        className: iconCls
      } : null],
      elementData: indicator
    };
  } // Add DOMConfigs for enabled indicators as `extraConfigs` on the task. Will in the end be added to the task row


  onTaskDataGenerated(renderData) {
    if (this.disabled) {
      return;
    }

    const {
      items
    } = this,
          usedIndicators = []; // Iterate all indicators

    for (const name in items) {
      const indicatorFn = items[name]; // If it is enabled and a function, call it and store the resulting timespan

      if (this._indicatorStatus[name] && typeof indicatorFn === 'function') {
        const timeSpan = indicatorFn(renderData.taskRecord);
        timeSpan && this.client.timeAxis.timeSpanInAxis(timeSpan.startDate, timeSpan.endDate) && usedIndicators.push(timeSpan);
      }
    } // Convert indicator timespans to DOMConfigs for rendering


    renderData.extraConfigs.push(...usedIndicators.map(this.createIndicatorDOMConfig, {
      gantt: this.client,
      renderData
    }));
  } //endregion
  //region Tooltip


  resolveTimeSpanRecord(forElement) {
    return forElement.lastDomConfig.elementData;
  } //endregion


}
Indicators._$name = 'Indicators';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(Indicators, false);

/***/ }),

/***/ "./lib/Gantt/feature/Labels.js":
/*!*************************************!*\
  !*** ./lib/Gantt/feature/Labels.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Labels; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/Labels.js */ "./lib/Scheduler/feature/Labels.js");
var productName = 'gantt';


/**
 * @module Gantt/feature/Labels
 */

/**
 * Specialized version of the Labels feature for Scheduler, that handles labels for tasks in Gantt. See
 * {@link Scheduler/feature/Labels Schedulers Labels feature} for more information.
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Scheduler/feature/Labels
 * @demo Gantt/labels
 * @typings Scheduler/feature/Labels -> Scheduler/feature/SchedulerLabels
 * @classtype labels
 * @feature
 */

class Labels extends _Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'Labels';
  }

  static get pluginConfig() {
    return {
      chain: ['onTaskDataGenerated']
    };
  }

  onTaskDataGenerated(data) {
    this.onEventDataGenerated(data);
  }

}
Labels._$name = 'Labels';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(Labels, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/ProgressLine.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/feature/ProgressLine.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProgressLine; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';






/**
 * @module Gantt/feature/ProgressLine
 */

/**
 *
 * This feature draws project progress line with SVG lines. Requires {@link SchedulerPro/feature/PercentBar} to be enabled (which
 * by default, it is)
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid/view/mixin/GridFeatures}.
 *
 * ```javascript
 * let gantt = new Gantt({
 *     features : {
 *         progressLine : {
 *            statusDate : new Date(2017, 2, 8)
 *         }
 *     }
 * });
 * ```
 *
 * Status date can be changed dynamically:
 *
 * ```javascript
 * gantt.features.progressLine.statusDate = new Date();
 * ```
 *
 * If status date is not in the current Gantt time span, progress line will use view start or end coordinates. This
 * behavior can be customized with {@link #config-drawLineOnlyWhenStatusDateVisible} config. Or you can override {@link #function-shouldDrawProgressLine}
 * method and provide more complex condition.
 *
 * Progress line is a set of SVG <line> elements drawn between all the tasks.
 *
 * {@inlineexample Gantt/feature/ProgressLine.js}
 *
 * @demo Gantt/progressline
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 * @classtype progressLine
 * @feature
 */

class ProgressLine extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  /**
   * Fired when progress line is rendered
   * @event progressLineDrawn
   */
  //region Config
  static get $name() {
    return 'ProgressLine';
  }

  static get defaultConfig() {
    return {
      /**
       * Progress line status date. If not provided, current date is used.
       * @config {Date}
       */
      statusDate: new Date(),

      /**
       * Set to true to hide progress line, when status date is not in the current time axis.
       * @config {Boolean}
       */
      drawLineOnlyWhenStatusDateVisible: false,
      lineCls: 'b-gantt-progress-line',
      containerCls: 'b-progress-line-canvas'
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onPaint']
    };
  } //endregion
  //region Init & destroy


  construct(client, config = {}) {
    const me = this; // Many things may schedule a draw. Ensure it only happens once, on the next frame.
    // And Ensure it really is on the *next* frame after invocation by passing
    // the cancelOutstanding flag.

    me.scheduleDraw = me.createOnFrame('draw', [], me, true);
    super.construct(client, config);
    this.lineSegments = [];
  }

  doDisable(disable) {
    const me = this; // attach/detach listeners

    me.attachToClient(disable ? null : me.client);

    if (me.client.rendered) {
      me.draw();
    }

    super.doDisable(disable);
  } //endregion


  get statusDate() {
    return this._statusDate;
  }
  /**
   * Progress line status date. If not provided, current date is used.
   * @property {Date}
   */


  set statusDate(date) {
    if (date instanceof Date) {
      this._statusDate = date;

      if (!this.disabled) {
        this.scheduleDraw();
      }
    }
  } // cannot use `get svgCanvas` because it will trigger svgCanvas getter on instance too early


  getSVGCanvas() {
    const me = this,
          {
      client
    } = me;

    if (!me._svgCanvas) {
      const svg = me._svgCanvas = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); // To not be touched when syncing tasks to DOM

      svg.retainElement = true;
      svg.classList.add(me.containerCls);
      client.foregroundCanvas.appendChild(svg);
    }

    return me._svgCanvas;
  } // region Event handlers


  attachToProject(project) {
    const me = this;
    me.detachListeners('project');

    if (project) {
      project.on({
        name: 'project',
        refresh: me.onProjectRefresh,
        thisObj: me
      });
    }
  }

  attachToRowManager(rowManager) {
    const me = this;
    me.detachListeners('rowManager');

    if (rowManager) {
      rowManager.on({
        name: 'rowManager',
        translaterow: me.onTranslateRow,
        refresh: me.scheduleDraw,
        rerender: me.scheduleDraw,
        changetotalheight: me.scheduleDraw,
        thisObj: me
      });
    }
  }

  attachToClient(client) {
    const me = this;
    me.detachListeners('client');

    if (client) {
      // dependencies are drawn on scroll, both horizontal and vertical
      client.on({
        name: 'client',
        horizontalscroll: me.scheduleDraw,
        togglenode: me.scheduleDraw,
        taskdrag: me.onTaskDrag,
        taskdragabort: me.scheduleDraw,
        aftertaskdrop: me.scheduleDraw,
        timelineviewportresize: me.scheduleDraw,
        thisObj: me
      });
    }

    me.attachToProject(client === null || client === void 0 ? void 0 : client.project);
    me.attachToRowManager(client === null || client === void 0 ? void 0 : client.rowManager);
  }

  onPaint() {
    this.attachToProject(this.disabled ? null : this.client.project);
  }
  /**
   * Redraws the line when the project propagation is done
   * @private
   */


  onProjectRefresh() {
    this.scheduleDraw();
  }

  onTranslateRow({
    row
  }) {
    // a changetotalheight event is fired after translations, if a rowHeight change is detected here it will redraw
    // the line
    if (row.lastTop >= 0 && row.top !== row.lastTop) {
      this.scheduleDraw();
    }
  } // Refreshing only lines for dragged task to avoid slowing down drag operation


  onTaskDrag({
    taskRecords,
    dragData
  }) {
    taskRecords.forEach(record => {
      this.updateLineForTask(record, {
        [record.id]: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(record.startDate, dragData.timeDiff)
      });
    });
  } // endregion

  /**
   * Returns true if progress line should be drawn
   * @returns {Boolean}
   */


  shouldDrawProgressLine() {
    return !this.client.timeAxisSubGrid.collapsed && !this.disabled && (!this.drawLineOnlyWhenStatusDateVisible || this.client.timeAxis.dateInAxis(this.statusDate));
  }
  /**
   * Returns status date horizontal position relative to the foreground canvas
   * @returns {Number}
   * @private
   */


  getStatusDateX() {
    let {
      statusDate
    } = this;
    const {
      client
    } = this;

    if (!client.timeAxis.dateInAxis(statusDate)) {
      statusDate = statusDate < client.timeAxis.startDate ? client.timeAxis.startDate : client.timeAxis.endDate;
    }

    return client.getCoordinateFromDate(statusDate);
  }
  /**
   * Returns object with status date local coordinate and view x,y coordinates. Used to convert page coordinates to
   * view local.
   * @returns {{statusDateX: Number, viewXY: number[]}}
   * @private
   */


  getRenderData() {
    const statusDateX = this.getStatusDateX(),
          // We refer to the DOM to get status date horizontal coordinate (for segmented tasks which are not supported yet)
    // we need to adjust progress bar element box to view/scroll.
    viewBox = this.client.timeAxisSubGridElement.getBoundingClientRect(),
          viewXY = [this.client.scrollLeft - viewBox.left, -viewBox.top];
    return {
      statusDateX,
      viewXY
    };
  } // region Drawing

  /**
   * Renders the progress line.
   */


  draw() {
    const me = this,
          {
      client
    } = me;
    me.lineSegments.forEach(el => el.remove());
    me.lineSegments = [];

    if (!me.shouldDrawProgressLine()) {
      return;
    }

    if (client.isAnimating) {
      client.on({
        transitionend() {
          me.scheduleDraw();
        },

        once: true
      });
      return;
    }

    const data = me.getRenderData(),
          lines = [];
    client.rowManager.forEach(row => {
      lines.push(...me.getLineSegmentRenderData(row, data));
    }); // Batch rendering to avoid constant layout reflows
    // With batch drawing line takes ~8ms comparing to ~30ms prior

    lines.forEach(line => me.drawLineSegment(line));
    client.trigger('progressLineDrawn');
  }

  segmentBelongsToTask(el, taskRecord) {
    // Use getAttribute to not upset Salesforce LockerService
    return el.getAttribute('data-task-id') == taskRecord.id;
  }
  /**
   * Updates progress line segment for one task
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Object} [renderData] Optional render data, which is an object where keys are task ids and values are
   * new task start date
   * @private
   */


  updateLineForTask(taskRecord, renderData) {
    const me = this;

    if (me.disabled) {
      return;
    }

    const row = me.client.getRowFor(taskRecord);

    if (row) {
      const toRemove = [];
      me.lineSegments.forEach(el => {
        if (me.segmentBelongsToTask(el, taskRecord)) {
          toRemove.push(el);
          el.remove();
        }
      });
      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].remove(me.lineSegments, ...toRemove);
      me.getLineSegmentRenderData(row, me.getRenderData(), renderData).forEach(line => me.drawLineSegment(line));
    }
  }
  /**
   * Draws line for a given row
   * @param {Grid.row.Row} row Row instance
   * @param {Object} data Output from {@link #function-getRenderData} method
   * @param {Object} [renderData] Optional render data, which is an object where keys are task ids and values are
   * new task start date
   * @internal
   */


  getLineSegmentRenderData(row, data, renderData = {}) {
    const me = this,
          {
      statusDateX,
      viewXY
    } = data,
          taskRecord = me.client.getRecordFromElement(row.elements.normal),
          taskId = taskRecord.id,
          lineDefinitions = [];
    let point;

    if (me.isStatusLineTask(taskRecord, renderData[taskRecord.id])) {
      point = me.calculateCoordinateForTask(taskRecord, viewXY); // If multiple rows are affected by event update, it could happen, that point
      // could not be resolved

      point && lineDefinitions.push({
        dataset: {
          taskId
        },
        x1: statusDateX,
        y1: row.top,
        x2: point.x,
        y2: point.y
      }, {
        dataset: {
          taskId
        },
        x1: point.x,
        y1: point.y,
        x2: statusDateX,
        y2: row.bottom
      });
    } // otherwise we render vertical status line


    if (!point) {
      lineDefinitions.push({
        dataset: {
          taskId
        },
        x1: statusDateX,
        y1: row.top,
        x2: statusDateX,
        y2: row.bottom
      });
    }

    return lineDefinitions;
  }
  /**
   * Draws line on svg canvas
   * @param {Object} data Line render data. Output from {@link #function-getLineSegmentRenderData}
   * @return {Element}
   * @internal
   */


  drawLineSegment(data) {
    const me = this;
    me.lineSegments.push(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement(Object.assign({
      tag: 'line',
      ns: 'http://www.w3.org/2000/svg',
      // cannot use className when namespace is provided
      class: me.lineCls,
      parent: me.getSVGCanvas()
    }, data)));
  }
  /**
   * Returns true if task should be connected to the progress line.
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Date} [startDate] Provide to check if task record should be connected to the progress line if it'd
   * start then
   * @returns {Boolean}
   * @internal
   */


  isStatusLineTask(taskRecord, startDate) {
    const statusDate = this.statusDate;
    startDate = startDate || taskRecord.startDate; // task should be visible and not inactive

    return taskRecord && !taskRecord.inactive && this.client.timeAxis.isTimeSpanInAxis(taskRecord) && ( // - is in progress
    taskRecord.isInProgress || // .. or is not started and its start date is before statusDate
    !taskRecord.isStarted && startDate < statusDate || // .. or is finished and its start date is after statusDate
    taskRecord.isCompleted && startDate > statusDate);
  }
  /**
   * This method will calculate point inside task element to be connected with line.
   * @param {Gantt.model.TaskModel} record
   * @param {Number[]} translateBy View xy coordinates to calculate relative point position
   * @returns {Object} Object containing coordinates for point in progress line, or undefined if no progress bar el is found
   * @private
   */


  calculateCoordinateForTask(record, translateBy) {
    const {
      client
    } = this,
          node = client.getElementFromTaskRecord(record),
          isZeroDuration = record.milestone,
          progressBarEl = isZeroDuration ? node : node === null || node === void 0 ? void 0 : node.querySelector('.b-task-percent-bar');

    if (progressBarEl) {
      const box = progressBarEl.getBoundingClientRect(),
            totalSize = client.timeAxisViewModel.totalSize;
      return {
        x: Math.min((isZeroDuration ? box.left : box.right) + translateBy[0], totalSize),
        y: box.top + box.height / 2 + translateBy[1]
      };
    }
  } // endregion


}
ProgressLine._$name = 'ProgressLine';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(ProgressLine);

/***/ }),

/***/ "./lib/Gantt/feature/ProjectLines.js":
/*!*******************************************!*\
  !*** ./lib/Gantt/feature/ProjectLines.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectLines; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony import */ var _Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/ProjectLines
 */

/**
 * This feature draws two vertical lines in the schedule area, indicating project start/end dates.
 *
 * This feature is **enabled** by default
 *
 * {@inlineexample Gantt/guides/gettingstarted/basic.js}
 * @extends Scheduler/feature/TimeRanges
 * @demo Gantt/basic
 * @classtype projectLines
 * @feature
 */

class ProjectLines extends _Scheduler_feature_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'ProjectLines';
  }

  static get defaultConfig() {
    return {
      showHeaderElements: true,
      cls: 'b-gantt-project-line'
    };
  } //endregion
  //region Project


  attachToProject(project) {
    super.attachToProject(project);
    project.on({
      name: 'project',
      refresh: this.onProjectRefresh,
      thisObj: this
    });
  } //endregion
  //region Init
  // We must override the TimeRanges superclass implementation which ingests the client's project's
  // timeRangeStore. We implement our own store


  startConfigure() {}
  /**
   * Called when gantt is painted.
   * @private
   */


  onPaint({
    firstPaint
  }) {
    const me = this;

    if (firstPaint) {
      [me.startDateLine, me.endDateLine] = me.store.add([{
        name: me.L('L{Project Start}')
      }, {
        name: me.L('L{Project End}')
      }]);
      me.updateDateFromProject();
    }

    super.onPaint(...arguments);
  }

  updateLocalization() {
    const me = this;

    if (me.client.rendered) {
      // Updating the store to use proper locale for labels
      me.startDateLine.name = me.L('L{Project Start}');
      me.endDateLine.name = me.L('L{Project End}');
    }
  }

  updateDateFromProject() {
    const {
      project
    } = this.client;
    this.startDateLine.startDate = project.startDate;
    this.endDateLine.startDate = project.endDate;
  } //endregion


  onProjectRefresh() {
    if (this.startDateLine) {
      this.updateDateFromProject();
    }
  }

}
ProjectLines._$name = 'ProjectLines';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ProjectLines, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/Rollups.js":
/*!**************************************!*\
  !*** ./lib/Gantt/feature/Rollups.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Rollups; });
/* harmony import */ var _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/Rollups
 */

const rollupCls = 'b-task-rollup',
      rollupSelector = `.${rollupCls}`;
/**
 * If the task's {@link Gantt/model/TaskModel#field-rollup} data field is set to true, it displays a small bar or diamond below its summary task in the timeline.
 * Each of the rollup elements show a tooltip when hovering it with details of the task.
 * The tooltip content is customizable, see {@link #config-template} config for details.
 *
 * To edit the rollup data field, use {@link Gantt/column/RollupColumn} or a checkbox on Advanced tab of {@link Gantt/widget/TaskEditor}.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid/view/mixin/GridFeatures}.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @inlineexample Gantt/feature/Rollups.js
 * @demo Gantt/rollups
 * @classtype rollups
 * @feature
 */

class Rollups extends _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Rollups';
  } // Default configuration.


  static get defaultConfig() {
    return {
      cls: 'b-gantt-task-tooltip',
      align: 't-b',
      forSelector: rollupSelector
    };
  }

  static get pluginConfig() {
    return {
      chain: [// onTaskDataGenerated for decorating task with rollups
      'onTaskDataGenerated', // render for creating tooltip (in TooltipBase)
      'onPaint']
    };
  } //endregion
  //region Init & destroy


  construct(gantt, config) {
    const me = this;
    me.tipId = `${gantt.id}-rollups-tip`;
    super.construct(gantt, config);
  }

  attachToTaskStore(store) {
    this.detachListeners('taskStore');

    if (store) {
      store.on({
        name: 'taskStore',
        update: 'onStoreUpdateRecord',
        thisObj: this
      });
    }
  }

  doDestroy() {
    this.attachToTaskStore(null);
    super.doDestroy();
  }

  doDisable(disable) {
    const me = this,
          {
      dependencies
    } = me.client.features;

    if (me.tooltip) {
      me.tooltip.disabled = disable;
    } // attach/detach listeners


    me.attachToTaskStore(disable ? null : me.client.taskStore); // Hide or show the rollup elements

    me.client.refresh(); // Redraw dependencies *after* elements have animated to new position,
    // and we must clear cache because of position changes.

    if (dependencies) {
      me.client.setTimeout(() => dependencies.scheduleDraw(true), 300);
    }

    super.doDisable(disable);
  } //endregion


  getTipHtml({
    activeTarget,
    event
  }) {
    const {
      client
    } = this,
          task = client.resolveTaskRecord(activeTarget),
          isMs = _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11,
          elementsFromPointMethod = isMs ? 'msElementsFromPoint' : 'elementsFromPoint',
          rawElements = document[elementsFromPointMethod](event.pageX + window.pageXOffset, event.pageY + window.pageYOffset),
          // MS browsers return NodeList instead of array
    rollupElements = Array.from(rawElements).filter(e => e.classList.contains(rollupCls)).sort((lhs, rhs) => parseInt(lhs.dataset.index, 10) - parseInt(rhs.dataset.index, 10)),
          children = [];

    for (const rollupElement of rollupElements) {
      children.push(task.children[parseInt(rollupElement.dataset.index, 10)]);
    }

    return this.template({
      task,
      children
    });
  }
  /**
   * Template (a function accepting event data and returning a string) used to display info in the tooltip.
   * The template will be called with an object as with fields as detailed below
   * @config {Function}
   * @param {Object} data A data block containing the information needed to create tooltip content.
   * @param {Gantt.model.TaskModel} data.task The summary task to rollup to.
   * @param {Gantt.model.TaskModel[]} data.children The array of rollup tasks.
   */


  template({
    children
  }) {
    const me = this,
          {
      client
    } = me,
          pieces = [];
    children.map((child, index) => {
      const {
        startDate,
        endDate
      } = child,
            startText = client.getFormattedDate(startDate),
            endDateValue = client.getDisplayEndDate(endDate, startDate),
            endText = client.getFormattedDate(endDateValue);
      pieces.push(`<div class="b-gantt-task-title ${index ? 'b-follow-on' : ''}">${child.name}</div><table>`, `<tr><td>${me.L('L{TaskTooltip.Start}')}:</td><td>${me.clockTemplate.template({
        date: startDate,
        text: startText,
        cls: 'b-sch-tooltip-startdate'
      })}</td></tr>`, `<tr><td>${me.L('L{TaskTooltip.End}')}:</td><td>${child.isMilestone ? '' : me.clockTemplate.template({
        date: endDateValue,
        text: endText,
        cls: 'b-sch-tooltip-enddate'
      })}</td></tr></table>`);
    });
    return pieces.join('');
  } //region Events


  onStoreUpdateRecord({
    record,
    changes
  }) {
    // We don't need this listener in case the gantt is loading data
    if (!this.client.project.propagatingLoadChanges) {
      // If it's a size or position change, then sync that parent's rollups
      if (record.parent && (changes.rollup || changes.startDate || changes.endDate)) {
        this.client.taskRendering.redraw(record.parent);
      }
    }
  }

  onTaskDataGenerated({
    taskRecord,
    left,
    wrapperChildren,
    style
  }) {
    if (!this.disabled && taskRecord.isParent) {
      const // Shortest last in DOM, so they are on top in the stacking order so that you can hover
      // them if they overlap with longer ones. Otherwise, they might be below and won't trigger
      // their own mouseover events.
      children = taskRecord.children.slice().sort((lhs, rhs) => rhs.durationMS - lhs.durationMS);
      wrapperChildren.push({
        className: `${rollupCls}-wrap`,
        dataset: {
          taskFeature: 'rollups'
        },
        children: children.map(child => {
          // skip inactive children if the task itself is active
          if (child.rollup && (!child.inactive || taskRecord.inactive)) {
            const positionData = this.client.getSizeAndPosition(child);

            if (!positionData) {
              return null;
            }

            const {
              position,
              width
            } = positionData;
            return {
              dataset: {
                index: child.parentIndex,
                rollupTaskId: child.id
              },
              className: {
                [rollupCls]: rollupCls,
                [child.cls]: child.cls,
                'b-milestone': child.isMilestone,
                'b-inactive': child.inactive
              },
              style: {
                style,
                width: child.isMilestone ? null : width,
                left: position - left
              }
            };
          }

          return null;
        }),
        syncOptions: {
          syncIdField: 'rollupTaskId'
        }
      });
    }
  } //endregion


}
Rollups._$name = 'Rollups';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Rollups, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/Summary.js":
/*!**************************************!*\
  !*** ./lib/Gantt/feature/Summary.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Summary; });
/* harmony import */ var _Scheduler_feature_TimelineSummary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/TimelineSummary.js */ "./lib/Scheduler/feature/TimelineSummary.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';


/**
 * @module Gantt/feature/Summary
 */

/**
 * A feature displaying a summary bar in the grid footer.
 *
 * ## Summaries in the locked grid
 * For regular columns in the locked section - specify type of summary on columns, available types are:
 * <dl class="wide">
 * <dt>sum <dd>Sum of all values in the column
 * <dt>add <dd>Alias for sum
 * <dt>count <dd>Number of rows
 * <dt>countNotEmpty <dd>Number of rows containing a value
 * <dt>average <dd>Average of all values in the column
 * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
 * </dl>
 * Columns can also specify a {@link Grid.column.Column#config-summaryRenderer} to format the calculated sum.
 *
 * ## Summaries in the time axis grid
 *
 * To output summaries in the ticks of the time axis summary bar, either provide a {@link #config-renderer} or use
 * {@link #config-summaries}. The `renderer` method provides the current tick `startDate` and `endDate` which you
 * can use to output the data you want to present in each summary cell.
 *
 * ```javascript
 * features : {
 *     summary     : {
 *         renderer: ({ taskStore, startDate, endDate }) => {
 *             // Find all intersecting task and render the count in each cell
 *             const intersectingTasks = taskStore.query(task => DateHelper.intersectSpans(task.startDate, task.endDate, startDate, endDate));
 *
 *             return intersectingTasks.length;
 *         }
 *     }
 * }
 * ```
 *
 * {@inlineexample Gantt/feature/Summary.js}
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Scheduler/feature/TimelineSummary
 * @classtype summary
 * @feature
 * @demo Gantt/summary
 * @typings Grid/feature/Summary -> Grid/feature/GridSummary
 * @typings Scheduler/feature/Summary -> Scheduler/feature/SchedulerSummary
 */

class Summary extends _Scheduler_feature_TimelineSummary_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Summary';
  }

  static get configurable() {
    return {
      /**
       * Array of summary configs which consists of a label and a {@link #config-renderer} function
       *
       * ```javascript
       * new Gantt({
       *     features : {
       *         summary : {
       *             summaries : [
       *                 {
       *                     label : 'Label',
       *                     renderer : ({ startDate, endDate, taskStore }) => {
       *                         // return display value
       *                         returns '<div>Renderer output</div>';
       *                     }
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object[]}
       */
      summaries: null,

      /**
       * Renderer function for a single time axis tick. Should calculate a sum and return HTML as a result.
       *
       * ```javascript
       * new Gantt({
       *     features : {
       *         summary : {
       *             renderer : ({ startDate, endDate, taskStore }) => {
       *                 // return display value
       *                 returns '<div>Renderer output</div>';
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * @param {Date} startDate Tick start date
       * @param {Date} endDate Tick end date
       * @param {Gantt.data.TaskStore} taskStore Task store
       * @returns {String} Html content
       * @config {Function}
       */
      renderer: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('updateTaskStore');
    return config;
  } //endregion
  //region Init


  construct(gantt, config) {
    super.construct(gantt, config); // Feature might be run from Grid (in docs), should not crash

    if (gantt.isGanttBase) {
      this.updateTaskStore(gantt.taskStore);
    }
  } //endregion
  //region Render


  updateTaskStore(taskStore) {
    this.detachListeners('summaryTaskStore');
    taskStore.on({
      name: 'summaryTaskStore',
      filter: 'updateTimelineSummaries',
      thisObj: this
    });
  }
  /**
   * Updates summaries.
   * @private
   */


  updateTimelineSummaries() {
    const me = this,
          {
      client: timeline
    } = me,
          {
      timeAxis
    } = timeline,
          summaryContainer = me.summaryBarElement;

    if (summaryContainer && timeline.isEngineReady) {
      Array.from(summaryContainer.children).forEach((element, i) => {
        const tick = timeAxis.getAt(i);
        let html = '',
            tipHtml = `<header>${me.L('L{Summary for}', timeline.getFormattedDate(tick.startDate))}</header>`;
        me.summaries.forEach(config => {
          const value = config.renderer({
            startDate: tick.startDate,
            endDate: tick.endDate,
            taskStore: timeline.taskStore,
            resourceStore: timeline.resourceStore,
            element
          }),
                valueHtml = `<div class="b-timeaxis-summary-value">${value !== null && value !== void 0 ? value : '&nbsp;'}</div>`;

          if (me.summaries.length > 1 || value !== '') {
            html += valueHtml;
          }

          tipHtml += `<label>${config.label || ''}</label>` + valueHtml;
        });
        element.innerHTML = html;
        element._tipHtml = tipHtml;
      });
    }
  }

} // Override Grids Summary with this improved version

Summary._$name = 'Summary';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Summary, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskContextMenu.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/feature/TaskContextMenu.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskContextMenu; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/TaskMenu.js */ "./lib/Gantt/feature/TaskMenu.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/TaskContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Gantt.feature.TaskMenu TaskMenu} feature instead.**
 *
 * Displays a context menu for tasks. Items are populated by other features and/or application code.
 * If enabled, {@link Grid.feature.CellMenu} feature is not available. Cell context menu items are handled by this feature.
 *
 * This feature is **off** by default in favor of `TaskMenu`.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @deprecated 4.0.0
 * @extends Gantt/feature/TaskMenu
 * @classtype taskContextMenu
 * @feature
 */

class TaskContextMenu extends _feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'TaskContextMenu';
  }

  construct(gantt, config) {
    super.construct(...arguments);
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Gantt', '5.0.0', '`TaskContextMenu` feature is deprecated, in favor of `TaskMenu` feature. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0#context-menu for more information.'); // If this feature is enabled, need to disable TaskMenu. They are mutually exclusive.

    if (gantt.features.taskMenu) {
      gantt.features.taskMenu.disabled = true;
    } // If deprecated ContextMenu is used


    if (gantt.features.contextMenu) {
      gantt.showRemoveRowInContextMenu = false;
      gantt.features.contextMenu.disableCellContextMenu = true;
    }
  } //endregion
  //region Events

  /**
   * This event fires on the owning Gantt before the context menu is shown for a task. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning false from a listener prevents the menu from
   * being shown.
   * @event taskContextMenuBeforeShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to taskMenuBeforeShow
   * @preventable
   * @param {Gantt.view.Gantt} source
   * @param {Object[]} items Menu item configs
   * @param {Gantt.model.TaskModel} taskRecord Event record for which the menu was triggered
   * @param {HTMLElement} taskElement
   */

  /**
   * This event fires on the owning Gantt when an item is selected in the context menu.
   * @event taskContextMenuItem
   * @on-owner
   * @deprecated 4.0.0 Renamed to taskMenuItem
   * @param {Gantt.view.Gantt} source
   * @param {Core.widget.MenuItem} item
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {HTMLElement} taskElement
   */

  /**
   * This event fires on the owning Gantt after showing the context menu for an event
   * @event taskContextMenuShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to taskMenuShow
   * @param {Gantt.view.Gantt} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Gantt.model.TaskModel} taskRecord Event record for which the menu was triggered
   * @param {HTMLElement} taskElement
   */
  //endregion

  /**
   * Returns Task record associated with current element (row/cell/task element)
   * @param {HTMLElement} element
   * @returns {Gantt.model.TaskModel}
   * @private
   */


  resolveRecord(element) {
    // We may be asked to resolve from a task bar element
    // or a regular grid inner element. Both must lead
    // to the Task.
    return this.client.resolveTaskRecord(element) || this.client.getRecordFromElement(element);
  }
  /**
   * Shows context menu for the provided task. If task is not rendered (outside of time span, or collapsed)
   * menu won't appear.
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Object} [options]
   * @param {HTMLElement} options.targetElement Element to align context menu to
   * @param {HTMLElement} options.eventElement Event element if target is an event, otherwise `null`
   * @param {Event} options.event Browser event. If provided menu will be aligned according to clientX/clientY coordinates.
   * If omitted, context menu will be centered to taskElement
   * @typings Scheduler/feature/EventMenu:showContextMenuFor:eventRecord -> {Scheduler.model.EventModel|Gantt.model.TaskModel}
   */


  showContextMenuFor(taskRecord, {
    targetElement,
    eventElement,
    event
  } = {}) {
    const {
      client
    } = this;

    if (!taskRecord) {
      return;
    }

    if (!targetElement) {
      targetElement = client.getElementFromTaskRecord(taskRecord); // If task record is not rendered, do nothing

      if (!targetElement) {
        return;
      }
    } // If it was a click


    if (event) {
      const cellData = client.getEventData(event); // If click occurs on row border there won't be cell data

      if (!cellData) {
        return;
      }

      const column = client.columns.getById(cellData.columnId); // If target is not a task and column has a flag to disable context menu

      if (!eventElement && column && !column.enableCellContextMenu) {
        return;
      }
    }

    this.showContextMenu({
      menuType: 'task',
      taskElement: targetElement,
      targetElement,
      taskRecord,
      event
    });
  }

}
TaskContextMenu.featureClass = '';
TaskContextMenu._$name = 'TaskContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(TaskContextMenu);

/***/ }),

/***/ "./lib/Gantt/feature/TaskCopyPaste.js":
/*!********************************************!*\
  !*** ./lib/Gantt/feature/TaskCopyPaste.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskCopyPaste; });
/* harmony import */ var _Grid_feature_RowCopyPaste_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/RowCopyPaste.js */ "./lib/Grid/feature/RowCopyPaste.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';


/**
 * @module Gantt/feature/TaskCopyPaste
 */

/**
 * Allow using [Ctrl/CMD + C/X] and [Ctrl/CMD + V] to copy/cut and paste tasks. You can configure how a newly pasted record
 * is named using {@link #function-generateNewName}
 *
 * This feature is **enabled** by default
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskCopyPaste : true
 *     }
 * });
 * ```
 *
 * ## Keyboard shortcuts
 *
 * By default, this feature will react to Ctrl+C, Ctrl+X and Ctrl+V for standard clipboard actions.
 * You can reconfigure the keys used to trigger these actions, see {@link #config-keyMap} for more details.
 *
 * @extends Grid/feature/RowCopyPaste
 * @inlineexample Gantt/feature/TaskCopyPaste.js
 * @classtype taskCopyPaste
 * @feature
 */

class TaskCopyPaste extends _Grid_feature_RowCopyPaste_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TaskCopyPaste';
  }

  static get type() {
    return 'taskCopyPaste';
  }

  static get configurable() {
    return {
      copyRecordText: 'L{copyTask}',
      cutRecordText: 'L{cutTask}',
      pasteRecordText: 'L{pasteTask}'
    };
  }

  construct(gantt, config) {
    super.construct(gantt, config);
    gantt.on({
      beforeRenderTask: 'onBeforeRenderTask',
      thisObj: this
    });
  }

  onBeforeRenderTask({
    renderData
  }) {
    renderData.row.cls['b-cut-row'] = renderData.taskRecord.meta.isCut;
    renderData.cls['b-cut-row'] = renderData.taskRecord.meta.isCut;
  }

  pasteRows(referenceRecord = this.client.selectedRecord) {
    const me = this,
          records = me.clipboardRecords,
          isCut = me._isCut,
          client = me.client;
    /**
     * Fires on the owning Gantt before a paste action is performed, return `false` to prevent the action
     * @event beforePaste
     * @preventable
     * @on-owner
     * @param {Gantt.view.Gantt} source Owner Gantt
     * @param {Gantt.model.TaskModel} referenceRecord The reference task record, the clipboard task records will
     * be pasted above this row.
     * @param {Gantt.model.TaskModel[]} records The records about to be pasted
     * @param {Boolean} isCut `true` if this is a cut action
     */

    if (client.readOnly || !records.length || client.trigger('beforePaste', {
      records,
      referenceRecord,
      isCut
    }) === false) {
      return [];
    } // important to sort selected before copying to rely on indices when extract/apply dependencies and
    // parents since all ids will be cleared after record.copy operation. Sorting itself is required to
    // make sure records will be added in correct order independent of how they were selected


    me.sortByIndex(records);
    const deps = me.extractDependencies(records, isCut),
          parentsMap = me.extractParents(records, isCut),
          recordsToProcess = records.map(rec => {
      if (isCut) {
        // reset record cut state
        rec.meta.isCut = false;
      } else {
        rec = rec.copy();
        rec[me.nameField] = me.generateNewName(rec);
      }

      return rec;
    });

    if (isCut) {
      client.store.move(recordsToProcess, referenceRecord); // reset clipboard

      me._isCut = false;
      me.clipboardRecords = [];
    } else {
      me.insertCopiedRecords(referenceRecord, recordsToProcess);
      client.selectedRecords = recordsToProcess;
    } // re-apply dependencies via copied records only
    // applying dependencies possible only after copied records were added to project


    me.applyDependencies(recordsToProcess, deps); // re-apply hierarchy via copied records only

    me.applyParents(recordsToProcess, parentsMap);
    return recordsToProcess;
  }
  /**
   * Extract dependecies from passed records. The result will include all deps in case of cut operation or
   * only deps via records and not include deps with foreign records.
   * @param {Core.data.Model[]} taskRecords array of records to extract dependencies from
   * @param {Boolean} [isCut] Copy by default, pass 'true' to cut operation.
   * @returns {Object[]} array of dependencies settings via passed records to apply using applyDependencies method
   * @private
   */


  extractDependencies(taskRecords, isCut = false) {
    return taskRecords.map(rec => {
      const deps = [];
      rec.predecessors.forEach(predecessor => {
        if (taskRecords.includes(predecessor.fromEvent)) {
          deps.push({
            fromEvent: taskRecords.indexOf(predecessor.fromEvent)
          });
        } // support foreign dependencies for cut/paste opertion
        else if (isCut) {
          deps.push({
            fromEventId: predecessor.fromEvent.id
          });
        }
      });
      rec.successors.forEach(successor => {
        if (taskRecords.includes(successor.toEvent)) {
          deps.push({
            toEvent: taskRecords.indexOf(successor.toEvent)
          });
        } // support foreign dependencies for cut/paste opertion
        else if (isCut) {
          deps.push({
            toEventId: successor.toEvent.id
          });
        }
      });

      if (isCut) {
        // remove old record dependencies because it will be removed from the store/tree
        rec.dependencies = [];
      }

      return deps;
    });
  }
  /**
   * Apply dependecies to passed records from dependencies array
   * @param {Core.data.Model[]} taskRecords array of records to apply dependencies on
   * @param {Object[]} deps array of dependencies settings, result of extractDependencies method
   * @private
   */


  applyDependencies(taskRecords, deps) {
    taskRecords.forEach((rec, idx) => {
      // update from/to on dependencies with the new record id
      rec.dependencies = deps[idx].map(dep => {
        var _ref, _dep$fromEventId, _taskRecords$dep$from, _ref2, _dep$toEventId, _taskRecords$dep$toEv;

        return {
          fromEvent: (_ref = (_dep$fromEventId = dep.fromEventId) !== null && _dep$fromEventId !== void 0 ? _dep$fromEventId : (_taskRecords$dep$from = taskRecords[dep.fromEvent]) === null || _taskRecords$dep$from === void 0 ? void 0 : _taskRecords$dep$from.id) !== null && _ref !== void 0 ? _ref : rec.id,
          toEvent: (_ref2 = (_dep$toEventId = dep.toEventId) !== null && _dep$toEventId !== void 0 ? _dep$toEventId : (_taskRecords$dep$toEv = taskRecords[dep.toEvent]) === null || _taskRecords$dep$toEv === void 0 ? void 0 : _taskRecords$dep$toEv.id) !== null && _ref2 !== void 0 ? _ref2 : rec.id
        };
      });
    });
  }
  /**
   * Extract parents from passed records. Result will include only hierarchy via copied records.
   * @param {Core.data.Model[]} taskRecords array of records to extract parents from
   * @returns {Object[]} array of parent id settings via passed records to apply using applyParents method
   * @private
   */


  extractParents(taskRecords) {
    return taskRecords.map(rec => {
      if (taskRecords.includes(rec.parent)) {
        return taskRecords.indexOf(rec.parent);
      }
    });
  }
  /**
   * Apply parents to passed records.
   * @param {Core.data.Model[]} taskRecords array of records to apply hierarchy on.
   * @param {Object[]} parentsMap array of parent id settings via passed records, result of extractParents method
   * @private
   */


  applyParents(taskRecords, parentsMap) {
    taskRecords.forEach((rec, idx) => {
      if (!isNaN(parentsMap[idx])) {
        taskRecords[parentsMap[idx]].appendChild(rec);
      }
    });
  }

}
TaskCopyPaste._$name = 'TaskCopyPaste';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TaskCopyPaste, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskDrag.js":
/*!***************************************!*\
  !*** ./lib/Gantt/feature/TaskDrag.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskDrag; });
/* harmony import */ var _Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';





/**
 * @module Gantt/feature/TaskDrag
 */

/**
 * Allows user to drag and drop tasks within Gantt, to change their start date.
 *
 * ## Validating a drag drop operation
 * You can use a custom validator function to decide if drop is allowed:
 *
 * ```javascript
 * let gantt = new Gantt({
 *   features: {
 *     taskDrag: {
 *       validatorFn(taskRecord, startDate) {
 *           return startDate < new Date();
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * ## Customizing the drag drop tooltip
 *
 * To show custom HTML in the tooltip, please see the {@link #config-tooltipTemplate} config. Example:
 *
 * ```javascript
 * features: {
 *     taskDrag: {
 *         // A minimal start date tooltip
 *         tooltipTemplate : ({ taskRecord, startDate }) => {
 *             return DateHelper.format(startDate, 'HH:mm');
 *         }
 *     }
 * }
 * ```
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/base/DragBase
 * @demo Gantt/basic
 * @classtype taskDrag
 * @feature
 */

class TaskDrag extends _Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TaskDrag';
  }

  static get defaultConfig() {
    return {
      /**
       * An empty function by default, but provided so that you can perform custom validation on
       * the item being dragged. This function is called during the drag and drop process and also after the drop is made.
       * Return true if the new position is valid, false to prevent the drag.
       * @param {Gantt.model.TaskModel[]} taskRecords An array of tasks being dragged
       * @param {Date} date The date corresponding to the current mouse position
       * @param {Number} duration The duration of the item being dragged
       * @param {Event} e The event object
       * @return {Boolean}
       * @config {Function}
       */
      validatorFn: (taskRecords, date, duration, e) => true,

      /**
       * `this` reference for the validatorFn
       * @config {Object}
       */
      validatorFnThisObj: null,
      tooltipCls: 'b-gantt-taskdrag-tooltip'
    };
  }
  /**
   * Template used to generate drag tooltip contents.
   * ```
   * const gantt = new Gantt({
   *   features : {
   *     taskDrag : {
   *       tooltipTemplate({taskRecord, startText}) {
   *         return `${taskRecord.name}: ${startText}`
   *       }
   *     }
   *   }
   * });
   * ```
   * @config {Function} tooltipTemplate
   * @param {Object} data Tooltip data
   * @param {Gantt.model.TaskModel} data.taskRecord
   * @param {Boolean} data.valid Currently over a valid drop target or not
   * @param {Date} data.startDate New start date
   * @param {Date} data.endDate New end date
   * @param {String} data.startText [DEPRECATED] Formatted new start date
   * @param {String} data.endText [DEPRECATED] Formatted new end date
   * @param {String} data.startClockHtml [DEPRECATED] Pre-generated HTML to display startDate as clock/calendar
   * @param {String} data.endClockHtml [DEPRECATED] Pre-generated HTML to display endDate as clock/calendar
   * @param {Object} data.dragData [DEPRECATED] Detailed drag context
   * @returns {String}
   */
  //endregion
  //region Events

  /**
   * Fires on the owning Gantt to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  scheduler.on('beforetaskdropfinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * @event beforeTaskDropFinalize
   * @on-owner
   * @param {Gantt.view.Gantt} source Gantt instance
   * @param {Object} context
   * @param {Boolean} context.async Set true to handle dragdrop asynchronously (e.g. to wait for user
   * confirmation)
   * @param {Function} context.finalize Call this method to finalize dragdrop. This method accepts one
   * argument: pass true to update records, or false, to ignore changes
   */

  /**
   * Fires on the owning Gantt after a task drop, regardless if the drop validity
   * @event afterTaskDrop
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel[]} taskRecords
   * @param {Boolean} valid
   */

  /**
   * Fires on the owning Gantt after a valid task drop
   * @event taskDrop
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel[]} taskRecords
   * @param {Boolean} isCopy
   */

  /**
   * Fires on the owning Gantt before task dragging starts. Return false to prevent the action.
   * @event beforeTaskDrag
   * @preventable
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel} taskRecord
   */

  /**
   * Fires on the owning Gantt when task dragging starts
   * @event taskDragStart
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel[]} taskRecords
   */

  /**
   * Fires on the owning Gantt while a task is being dragged
   * @event taskDrag
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel[]} taskRecords
   * @param {Date} startDate
   * @param {Date} endDate
   * @param {Object} dragData
   * @param {Boolean} changed `true` if startDate has changed.
   */
  //endregion
  //region Init


  construct(gantt, config) {
    this.gantt = gantt;
    super.construct(gantt, config);
  }

  get store() {
    return this.gantt.taskStore;
  } //endregion
  //region Drag events


  isElementDraggable(el, event) {
    var _taskResize$isOverAny;

    const {
      gantt
    } = this,
          taskElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(el, gantt.eventSelector),
          {
      taskResize
    } = gantt.features;

    if (!taskElement) {
      return false;
    } // displaying something resizable within the event?
    // if (DomHelper.up(el, gantt.eventSelector).matches('[class$="-handle"]')) {


    if (el.matches('[class$="-handle"]')) {
      return false;
    }

    const taskRecord = gantt.resolveTaskRecord(taskElement);

    if (!taskRecord || !taskRecord.isDraggable) {
      return false;
    } // 1. Check if we are over a virtual resize handle?
    // 2. Milestones cannot be resized
    // 3. Need to ensure we handle case when taskResize is disabled (=== false)


    if (taskRecord.resizable && !taskRecord.isMilestone && taskResize !== null && taskResize !== void 0 && (_taskResize$isOverAny = taskResize.isOverAnyHandle) !== null && _taskResize$isOverAny !== void 0 && _taskResize$isOverAny.call(taskResize, event, taskElement)) {
      return false;
    }

    return true;
  }

  triggerEventDrag(dragData, start) {
    // Trigger the event on every mousemove so that features which need to adjust
    // Such as dependencies and baselines can keep adjusted.
    this.gantt.trigger('taskDrag', {
      taskRecords: dragData.draggedEntities,
      startDate: dragData.startDate,
      endDate: dragData.endDate,
      dragData,
      changed: dragData.startDate - start !== 0
    });
  }

  triggerDragStart(dragData) {
    this.gantt.trigger('taskDragStart', {
      taskRecords: dragData.draggedEntities,
      dragData
    });
  }

  triggerDragAbort(dragData) {
    this.gantt.trigger('taskDragAbort', {
      taskRecords: dragData.draggedEntities,
      context: dragData
    });
  }

  triggerAfterDrop(dragData, valid) {
    this.currentOverClient.trigger('afterTaskDrop', {
      taskRecords: dragData.draggedEntities,
      context: dragData,
      valid
    });
  } //endregion
  //region Drag data


  getProductDragContext(dd) {
    return {
      valid: true
    };
  }

  getMinimalDragData(info) {
    const element = this.getElementFromContext(info),
          taskRecord = this.gantt.resolveTaskRecord(element);
    return {
      taskRecord
    };
  }

  setupProductDragData(info) {
    const me = this,
          gantt = me.gantt,
          element = info.element,
          taskRecord = gantt.resolveTaskRecord(element),
          taskRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element),
          relatedRecords = me.getRelatedRecords(taskRecord) || [],
          dateConstraints = gantt.getDateConstraints(taskRecord),
          eventBarEls = [element];
    me.setupConstraints(gantt.getScheduleRegion(taskRecord), taskRegion, gantt.timeAxisViewModel.snapPixelAmount, Boolean(dateConstraints)); // Collecting additional elements to drag

    relatedRecords.forEach(r => {
      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].include(eventBarEls, gantt.getElementFromTaskRecord(r, false));
    });
    const draggedEntities = [taskRecord, ...relatedRecords];
    return {
      record: taskRecord,
      dateConstraints,
      eventBarEls,
      draggedEntities
    };
  }
  /**
   * Get correct axis coordinate.
   * @private
   * @param {Gantt.model.TaskModel} taskRecord Record being dragged
   * @param {HTMLElement} element Element being dragged
   * @param {Number[]} coord XY coordinates
   * @returns {Number|Number[]} X,Y or XY
   */


  getCoordinate(taskRecord, element, coord) {
    return coord[0];
  } //endregion
  //region Finalize & validation
  // Called from EventDragBase to assert if a drag is valid or not


  checkDragValidity(dragData, event) {
    return this.validatorFn.call(this.validatorFnThisObj || this, dragData.draggedEntities, dragData.startDate, dragData.duration, event);
  }
  /**
   * Checks if a task can be dropped on the specified location
   * @private
   * @returns {Boolean} Valid (true) or invalid (false)
   */


  isValidDrop(dragData) {
    return true;
  }
  /**
   * Update tasks being dragged.
   * @private
   * @param {Object} context Drag data.
   */


  async updateRecords(context) {
    const taskRecord = context.draggedEntities[0],
          oldStartDate = taskRecord.startDate,
          startDate = context.startDate,
          propagatePromise = taskRecord.setStartDate(startDate, true); // Process original dragged record

    await propagatePromise; // If not rejected (the startDate has changed), tell the world there was a successful drop.

    if (taskRecord.startDate - oldStartDate) {
      this.gantt.trigger('taskDrop', {
        taskRecords: context.draggedEntities
      });
    } else {
      this.dragData.valid = false;
    }

    return propagatePromise;
  }

  getRecordElement(task) {
    return this.gantt.getElementFromTaskRecord(task, true);
  } //endregion


}
TaskDrag._$name = 'TaskDrag';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TaskDrag, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskDragCreate.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/feature/TaskDragCreate.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskDragCreate; });
/* harmony import */ var _Scheduler_feature_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/DragCreateBase.js */ "./lib/Scheduler/feature/base/DragCreateBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';




/**
 * @module Gantt/feature/TaskDragCreate
 */

/**
 * A feature that allows the user to schedule tasks by dragging in the empty parts of the gantt timeline row. Note, this feature is only applicable for unscheduled tasks.
 * {@inlineexample Gantt/feature/TaskDragCreate.js}
 *
 *
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/base/DragCreateBase
 * @demo Gantt/advanced
 * @classtype taskDragCreate
 * @feature
 */

class TaskDragCreate extends _Scheduler_feature_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TaskDragCreate';
  }

  static get configurable() {
    return {
      // used by gantt to only allow one task per row
      preventMultiple: true
    };
  } //endregion
  //region Events

  /**
   * Fires on the owning Gantt after the task has been scheduled.
   * @event dragCreateEnd
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {MouseEvent} event The ending mouseup event.
   * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
   */

  /**
   * Fires on the owning Gantt at the beginning of the drag gesture
   * @event beforeDragCreate
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Date} date The datetime associated with the drag start point.
   */

  /**
   * Fires on the owning Gantt after the drag start has created a proxy element.
   * @event dragCreateStart
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {HTMLElement} proxyElement The proxy representing the new event.
   */

  /**
   * Fires on the owning Gantt to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  scheduler.on('beforedragcreatefinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * @event beforeDragCreateFinalize
   * @on-owner
   * @param {Gantt.view.Gantt} source Scheduler instance
   * @param {HTMLElement} proxyElement Proxy element, representing future event
   * @param {Object} context
   * @param {Boolean} context.async Set true to handle drag create asynchronously (e.g. to wait for user
   * confirmation)
   * @param {Function} context.finalize Call this method to finalize drag create. This method accepts one
   * argument: pass true to update records, or false, to ignore changes
   */

  /**
   * Fires on the owning Gantt at the end of the drag create gesture whether or not
   * a task was scheduled by the gesture.
   * @event afterDragCreate
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
   */
  //endregion
  //region Init


  construct(gantt, config) {
    this.gantt = gantt;
    super.construct(gantt, config);
  }

  get store() {
    return this.gantt.taskStore;
  } //endregion
  //region Gantt specific implementation


  setupDragContext(event) {
    var _event$target$closest, _event$target;

    const {
      client
    } = this; // Only mousedown on an empty cell can initiate drag-create

    if ((_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `.${client.timeAxisColumn.cellCls}`)) {
      const taskRecord = client.getRecordFromElement(event.target); // And there must be a task backing the cell.

      if (taskRecord) {
        // Skip the EventResize's setupDragContext. We want the base one.
        const result = Object(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_2__["default"])().prototype.setupDragContext.call(this, event);
        result.scrollManager = client.scrollManager;
        result.taskRecord = result.rowRecord = taskRecord;
        return result;
      }
    }
  }

  startDrag(drag) {
    // This flag must be set in startDrag
    const draggingEnd = this.draggingEnd = drag.event.pageX > drag.startEvent.pageX,
          {
      client
    } = this,
          {
      timeAxis
    } = client,
          {
      mousedownDate,
      taskRecord,
      date
    } = drag;
    client.beginListeningForBatchedUpdates();
    taskRecord.beginBatch();
    taskRecord.set('startDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].floor(draggingEnd ? mousedownDate : date, timeAxis.resolution));
    taskRecord.set('endDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].ceil(draggingEnd ? date : mousedownDate, timeAxis.resolution)); // This presents the task to be scheduled for validation at the proposed mouse/date point
    // If rejected, we have to revert the batched changes

    if (this.handleBeforeDragCreate(drag, taskRecord, drag.event) === false) {
      this.onAborted(drag);
      return false;
    } // Now it will have an element, and that's what we are dragging


    drag.itemElement = drag.element = client.getElementFromTaskRecord(drag.taskRecord);
    return super.startDrag.call(this, drag);
  }

  handleBeforeDragCreate(drag, taskRecord, event) {
    const me = this,
          result = me.gantt.trigger('beforeDragCreate', {
      taskRecord: taskRecord,
      date: drag.mousedownDate,
      event
    }); // Save date constraints

    me.dateConstraints = me.gantt.getDateConstraints(taskRecord);
    return result;
  }

  checkValidity(context, event) {
    const me = this;
    context.taskRecord = me.dragging.taskRecord;
    return me.createValidatorFn.call(me.validatorFnThisObj || me, context, event);
  } // Row is not empty if task is scheduled


  isRowEmpty(taskRecord) {
    return !taskRecord.startDate || !taskRecord.endDate;
  }

  onAborted({
    taskRecord
  }) {
    taskRecord.cancelBatch();
    this.client.endListeningForBatchedUpdates();
  } //endregion


}
TaskDragCreate._$name = 'TaskDragCreate';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TaskDragCreate, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskEdit.js":
/*!***************************************!*\
  !*** ./lib/Gantt/feature/TaskEdit.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEdit; });
/* harmony import */ var _SchedulerPro_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/feature/TaskEdit.js */ "./lib/SchedulerPro/feature/TaskEdit.js");
/* harmony import */ var _widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../widget/TaskEditor.js */ "./lib/Gantt/widget/TaskEditor.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/TaskEdit
 */

/**
 * Feature that displays {@link Gantt/widget/TaskEditor}.
 * The Task editor is a popup containing tabs with fields for editing task data.
 *
 * {@inlineexample Gantt/feature/TaskEdit.js}
 *
 * ## Customizing tabs and their widgets
 *
 * To customize tabs you can:
 *
 * * Reconfigure built in tabs by providing override configs in the {@link #config-items} config.
 * * Remove existing tabs or add your own in the {@link #config-items} config.
 * * Advanced: Reconfigure the whole editor widget using {@link #config-editorConfig} or replace the whole editor using {@link #config-editorClass}.
 *
 * {@inlineexample Gantt/feature/TaskEditCustom.js}
 *
 * To add extra items to a tab you need to specify {@link Core/widget/Container#config-items} for the tab container.
 *
 * {@inlineexample Gantt/feature/TaskEditExtraItems.js}
 *
 * {@region Expand to see Default tabs and fields}
 *
 * The {@link Gantt/widget/TaskEditor Task editor} contains tabs by default. Each tab is a container with built in widgets: text fields, grids, etc.
 *
 * | Tab ref           | Type                                                   | Text         | Weight | Description                                                                         |
 * |-------------------|--------------------------------------------------------|--------------|--------|-------------------------------------------------------------------------------------|
 * | `generalTab`      | {@link SchedulerPro/widget/taskeditor/GeneralTab}      | General      | 100    | Shows basic configuration: name, start/end dates, duration, percent done, effort.   |
 * | `predecessorsTab` | {@link SchedulerPro/widget/taskeditor/PredecessorsTab} | Predecessors | 200    | Shows a grid with incoming dependencies                                             |
 * | `successorsTab`   | {@link SchedulerPro/widget/taskeditor/SuccessorsTab}   | Successors   | 300    | Shows a grid with outgoing dependencies                                             |
 * | `resourcesTab`    | {@link SchedulerPro/widget/taskeditor/ResourcesTab}    | Resources    | 400    | Shows a grid with assigned resources to the selected task                           |
 * | `advancedTab`     | {@link SchedulerPro/widget/taskeditor/AdvancedTab}     | Advanced     | 500    | Shows advanced configuration: assigned calendar, scheduling mode, constraints, etc. |
 * | `notesTab`        | {@link SchedulerPro/widget/taskeditor/NotesTab}        | Notes        | 600    | Shows a text area to add notes to the selected task                                 |
 *
 * ### General tab
 *
 * General tab contains widgets for basic configurations
 *
 * | Widget ref    | Type                                       | Text       | Weight | Description                                                        |
 * |---------------|--------------------------------------------|------------|--------|--------------------------------------------------------------------|
 * | `name`        | {@link Core/widget/TextField}              | Name       | 100    | Task name                                                          |
 * | `percentDone` | {@link Core/widget/NumberField}            | % Complete | 200    | Shows what part of task is done already in percentage              |
 * | `effort`      | {@link SchedulerPro/widget/EffortField}    | Effort     | 300    | Shows how much working time is required to complete the whole task |
 * | `divider`     | {@link Core/widget/Widget}                 |            | 400    | Visual splitter between 2 groups of fields                         |
 * | `startDate`   | {@link SchedulerPro/widget/StartDateField} | Start      | 500    | Shows when the task begins                                         |
 * | `endDate`     | {@link SchedulerPro/widget/EndDateField}   | Finish     | 600    | Shows when the task ends                                           |
 * | `duration`    | {@link Core/widget/DurationField}          | Duration   | 700    | Shows how long the task is                                         |
 *
 * ### Predecessors tab
 *
 * Predecessors tab contains a grid with incoming dependencies and controls to remove/add dependencies
 *
 * | Widget ref | Type                        | Weight | Description                                                                                      |
 * |------------|-----------------------------|--------|--------------------------------------------------------------------------------------------------|
 * | `grid`     | {@link Grid/view/Grid}      | 100    | Shows predecessors task name, dependency type and lag                                            |
 * | `toolbar`  | {@link Core/widget/Toolbar} | 200    | Shows control buttons                                                                            |
 * | \>`add`    | {@link Core/widget/Button}  | 210    | Adds a new dummy predecessor. Then need to select a task from the list in the name column editor |
 * | \>`remove` | {@link Core/widget/Button}  | 220    | Removes selected incoming dependency                                                             |
 *
 * \> - nested items
 *
 * ### Successors tab
 *
 * Successors tab contains a grid with outgoing dependencies and controls to remove/add dependencies
 *
 * | Widget ref | Type                        | Weight | Description                                                                                    |
 * |------------|-----------------------------|--------|------------------------------------------------------------------------------------------------|
 * | `grid`     | {@link Grid/view/Grid}      | 100    | Shows successors task name, dependency type and lag                                            |
 * | `toolbar`  | {@link Core/widget/Toolbar} | 200    | Shows control buttons                                                                          |
 * | \>`add`    | {@link Core/widget/Button}  | 210    | Adds a new dummy successor. Then need to select a task from the list in the name column editor |
 * | \>`remove` | {@link Core/widget/Button}  | 220    | Removes selected outgoing dependency                                                           |
 *
 * \> - nested items
 *
 * ### Resources tab
 *
 * Resources tab contains a grid with assignments
 *
 * | Widget ref | Type                        | Weight | Description                                                                                                                           |
 * |------------|-----------------------------|--------|---------------------------------------------------------------------------------------------------------------------------------------|
 * | `grid`     | {@link Grid/view/Grid}      | 100    | Shows assignments resource name and assigned units (100 means that the assigned resource spends 100% of its working time to the task) |
 * | `toolbar`  | {@link Core/widget/Toolbar} | 200    | Shows control buttons                                                                                                                 |
 * | \>`add`    | {@link Core/widget/Button}  | 210    | Adds a new dummy assignment. Then need to select a resource from the list in the name column editor                                   |
 * | \>`remove` | {@link Core/widget/Button}  | 220    | Removes selected assignment                                                                                                           |
 *
 * \> - nested items
 *
 * ### Advanced tab
 *
 * Advanced tab contains additional task scheduling options
 *
 * | Widget ref               | Type                                             | Weight | Description                                                                                                                  |
 * |--------------------------|--------------------------------------------------|--------|------------------------------------------------------------------------------------------------------------------------------|
 * | `calendarField`          | {@link Core/widget/Combo}                        | 100    | Shows a list of available calendars for this task                                                                            |
 * | `manuallyScheduledField` | {@link Core/widget/Checkbox}                     | 200    | If checked, the task is not considered in scheduling                                                                         |
 * | `schedulingModeField`    | {@link SchedulerPro/widget/SchedulingModePicker} | 300    | Shows a list of available scheduling modes for this task                                                                     |
 * | `effortDrivenField`      | {@link Core/widget/Checkbox}                     | 400    | If checked, the effort of the task is kept intact, and the duration is updated. Works when scheduling mode is "Fixed Units". |
 * | `divider`                | {@link Core/widget/Widget}                       | 500    | Visual splitter between 2 groups of fields                                                                                   |
 * | `constraintTypeField`    | {@link SchedulerPro/widget/ConstraintTypePicker} | 600    | Shows a list of available constraints for this task                                                                          |
 * | `constraintDateField`    | {@link Core/widget/DateField}                    | 700    | Shows a date for the selected constraint type                                                                                |
 * | `rollupField`            | {@link Core/widget/Checkbox}                     | 800    | If checked, shows a bar below the parent task. Works when the "Rollup" feature is enabled.                                   |
 *
 * ### Notes tab
 *
 * Notes tab contains a text area to show notes
 *
 * | Field ref   | Type                              | Weight | Description                                     |
 * |-------------|-----------------------------------|--------|-------------------------------------------------|
 * | `noteField` | {@link Core/widget/TextAreaField} | 100    | Shows a text area to add text notes to the task |
 *
 * {@endregion}
 *
 * ## Removing a built in item
 *
 * To remove a built in tab or widget, specify its `ref` as `false` in the {@link #config-items} config:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab      : {
 *                     items : {
 *                         // Remove "% Complete","Effort", and the divider in the "General" tab
 *                         percentDone : false,
 *                         effort      : false,
 *                         divider     : false
 *                     }
 *                 },
 *                 // Remove all tabs except the "General" tab
 *                 notesTab        : false,
 *                 predecessorsTab : false,
 *                 successorsTab   : false,
 *                 resourcesTab    : false,
 *                 advancedTab     : false
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * The built in buttons are:
 *
 * | Widget ref     | Type                       | Weight | Description                             |
 * |----------------|----------------------------|--------|-----------------------------------------|
 * | `saveButton`   | {@link Core/widget/Button} | 100    | Save event button on the bbar           |
 * | `deleteButton` | {@link Core/widget/Button} | 200    | Delete event button on the bbar         |
 * | `cancelButton` | {@link Core/widget/Button} | 300    | Cancel event editing button on the bbar |
 *
 * Bottom buttons may be hidden using `bbar` config passed to `editorConfig`:
 *
* ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskEdit : {
 *             editorConfig : {
 *                 bbar : {
 *                     items : {
 *                         deleteButton : false
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Customizing a built in item
 *
 * To customize a built in tab or field, use its `ref` as the key in the {@link #config-items} config and specify the configs you want
 * to change (they will be merged with the tabs or fields default configs correspondingly):
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab      : {
 *                     // Rename "General" tab
 *                     title : 'Main',
 *                     items : {
 *                         // Rename "% Complete" field
 *                         percentDone : {
 *                             label : 'Status'
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Adding a custom item
 *
 * To add a custom tab or field, add an entry to the {@link #config-items} config. When you add a field,
 * the `name` property links the input field to a field in the loaded task record:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab : {
 *                     items : {
 *                         // Add new field to the last position
 *                         newGeneralField : {
 *                             type   : 'textfield',
 *                             weight : 710,
 *                             label  : 'New field in General Tab',
 *                             // Name of the field matches data field name, so value is loaded/saved automatically
 *                             name   : 'custom'
 *                         }
 *                     }
 *                 },
 *                 // Add a custom tab to the first position
 *                 newTab     : {
 *                     // Tab is a FormTab by default
 *                     title  : 'New tab',
 *                     weight : 90,
 *                     items  : {
 *                         newTabField : {
 *                             type   : 'textfield',
 *                             weight : 710,
 *                             label  : 'New field in New Tab',
 *                             // Name of the field matches data field name, so value is loaded/saved automatically.
 *                             // In this case it is equal to the Task "name" field.
 *                             name   : 'name'
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * To turn off the Task Editor just simple disable the feature.
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskEdit : false
 *     }
 * })
 * ```
 *
 * For more info on customizing the Task Editor, please see Guides/Customization/Customize task editor
 *
 * @extends SchedulerPro/feature/TaskEdit
 * @demo Gantt/taskeditor
 * @classtype taskEdit
 * @feature
 *
 * @typings SchedulerPro/feature/TaskEdit -> SchedulerPro/feature/SchedulerProTaskEdit
 */

class TaskEdit extends _SchedulerPro_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TaskEdit';
  }

  static get defaultConfig() {
    return {
      /**
       * The event that shall trigger showing the editor. Set to `` or null to disable editing of existing events.
       * @config {String|null}
       * @default
       * @category Editor
       */
      triggerEvent: 'taskdblclick',
      saveAndCloseOnEnter: true,

      /**
       * A configuration object used to configure tabs of the task editor which can be used to
       * customize the built-in tabs without changing the whole {@link #config-editorConfig}.
       *
       * @config {Object}
       * @deprecated 5.0.0 Use `items` instead
       */
      tabsConfig: null,

      /**
       * Class to use as the editor. By default it uses {@link Gantt.widget.TaskEditor}
       * @config {Core.widget.Widget}
       * @typings {typeof Widget}
       * @category Editor
       */
      editorClass: _widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

  static get pluginConfig() {
    return {
      chain: ['populateTaskMenu', 'onTaskEnterKey'],
      assign: ['editTask']
    };
  }
  /**
   * Shows a {@link Gantt/widget/TaskEditor} to edit the passed task. This function is exposed on
   * the Gantt instance and can be called as `gantt.editTask()`.
   * @param {Gantt.model.TaskModel} taskRecord Task to edit
   * @param {HTMLElement} [element] The task element
   * @return {Promise} Promise which resolves after the editor is shown
   * @on-owner
   * @async
   */


  editTask(taskRecord, element) {
    return this.editEvent(taskRecord, null, element);
  }

  onActivateEditor({
    taskRecord,
    taskElement
  }) {
    this.editTask(taskRecord, taskElement);
  }

  getElementFromTaskRecord(taskRecord) {
    return this.client.getElementFromTaskRecord(taskRecord);
  }

  onTaskEnterKey({
    taskRecord
  }) {
    this.editTask(taskRecord);
  } //region Context menu


  populateTaskMenu({
    taskRecord,
    selection,
    items
  }) {
    if (!this.client.readOnly && selection.length <= 1) {
      items.editTask = {
        text: 'L{Gantt.Edit}',
        localeClass: this.client,
        cls: 'b-separator',
        icon: 'b-icon b-icon-edit',
        weight: 100,
        disabled: this.disabled,
        onItem: () => this.editTask(taskRecord)
      };
    }
  } //endregion


  onEventEnterKey({
    taskRecord,
    target
  }) {
    this.editTask(taskRecord);
  }

  scrollTaskIntoView(taskRecord) {
    return this.scrollEventIntoView(taskRecord);
  }

  scrollEventIntoView(eventRecord) {
    return this.client.scrollTaskIntoView(eventRecord);
  }

}
TaskEdit._$name = 'TaskEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(TaskEdit, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskMenu.js":
/*!***************************************!*\
  !*** ./lib/Gantt/feature/TaskMenu.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskMenu; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';



/**
 * @module Gantt/feature/TaskMenu
 */

/**
 * Displays a context menu for tasks. Items are populated by other features and/or application code.
 * Configure it with `false` to disable it completely. If enabled, {@link Grid.feature.CellMenu} feature
 * is not available. Cell context menu items are handled by this feature.
 *
 * ## Default task menu items
 *
 * Here is the list of menu items provided by the Task menu feature and populated by the other features:
 *
 * | Reference             | Text                 | Weight | Feature                                 | Description                                                                      |
 * |-----------------------|----------------------|--------|-----------------------------------------|----------------------------------------------------------------------------------|
 * | `editTask`            | Edit task            | 100    | {@link Gantt.feature.TaskEdit TaskEdit} | Edit the task                                                                    |
 * | `search`*             | Search for value     | 200    | {@link Grid.feature.Search Search}      | Search for cell text                                                             |
 * | `filterDateEquals`*   | On                   | 300    | {@link Grid.feature.Filter Filter}      | Filter by columns field, equal to cell value                                     |
 * | `filterDateBefore`*   | Before               | 310    | {@link Grid.feature.Filter Filter}      | Filter by columns field, less than cell value                                    |
 * | `filterDateAfter`*    | After                | 320    | {@link Grid.feature.Filter Filter}      | Filter by columns field, more than cell value                                    |
 * | `filterNumberEquals`* | Equals               | 300    | {@link Grid.feature.Filter Filter}      | Filter by columns field, equal to cell value                                     |
 * | `filterNumberLess`*   | Less than            | 310    | {@link Grid.feature.Filter Filter}      | Filter by columns field, less than cell value                                    |
 * | `filterNumberMore`*   | More than            | 320    | {@link Grid.feature.Filter Filter}      | Filter by columns field, more than cell value                                    |
 * | `filterStringEquals`* | Equals               | 300    | {@link Grid.feature.Filter Filter}      | Filter by columns field, equal to cell value                                     |
 * | `filterRemove`*       | Remove filter        | 400    | {@link Grid.feature.Filter Filter}      | Stop filtering by selected column field                                          |
 * | `add`                 | Add...               | 500    | *This feature*                          | Submenu for adding tasks                                                         |
 * | \>`addTaskAbove`      | Task above           | 510    | *This feature*                          | Add a new task above the selected task                                           |
 * | \>`addTaskBelow`      | Task below           | 520    | *This feature*                          | Add a new task below the selected task                                           |
 * | \>`milestone`         | Milestone            | 530    | *This feature*                          | Add a new milestone below the selected task                                      |
 * | \>`subtask`           | Subtask              | 540    | *This feature*                          | Add a new task as a child of the current, turning it into a parent               |
 * | \>`successor`         | Successor            | 550    | *This feature*                          | Add a new task below current task, linked using an "end-to-start" dependency     |
 * | \>`predecessor`       | Predecessor          | 560    | *This feature*                          | Add a new task above current task, linked using an "end-to-start" dependency     |
 * | `convertToMilestone`  | Convert to milestone | 600    | *This feature*                          | Turns the selected task into a milestone. Shown for leaf tasks only              |
 * | `indent`              | Indent               | 700    | *This feature*                          | Add the task as a child of its previous sibling, turning that task into a parent |
 * | `outdent`             | Outdent              | 800    | *This feature*                          | Turn the task into a sibling of its parent                                       |
 * | `deleteTask`          | Delete task          | 900    | *This feature*                          | Remove the selected task                                                         |
 *
 * \* - items that are shown for the locked grid cells only
 *
 * \> - first level of submenu
 *
 * ## Customizing the menu items
 *
 * The menu items in the Task menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * To add extra items for all events:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskMenu : {
 *             // Extra items for all events
 *             items : {
 *                 flagTask : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem({taskRecord}) {
 *                         taskRecord.flagged = true;
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Remove menu/submenu items
 *
 * Items can be removed from the menu:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskMenu : {
 *             items : {
 *                 // Hide delete task option
 *                 deleteTask: false,
 *
 *                 // Hide item from the `add` submenu
 *                 add: {
 *                     menu: {
*                          subtask: false
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Manipulate items for specific tasks
 *
 * Items can behave different depending on the type of the task:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         taskMenu : {
 *             // Process items before menu is shown
 *             processItems({ items, taskRecord }) {
 *                  // Push an extra item for conferences
 *                  if (taskRecord.type === 'conference') {
 *                      items.showSessions = {
 *                          text : 'Show sessions',
 *                          ontItem({taskRecord}) {
 *                              // ...
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for secret events
 *                  if (taskRecord.type === 'secret') {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Task menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/EventMenu
 * @demo Gantt/taskmenu
 * @classtype taskMenu
 * @feature
 *
 * @inlineexample Gantt/feature/TaskMenu.js
 */

class TaskMenu extends _Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'TaskMenu';
  }

  static get defaultConfig() {
    return {
      type: 'task',

      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       * features         : {
       *    taskMenu : {
       *         processItems({ items, taskRecord }) {
       *             // Add or hide existing items here as needed
       *             items.myAction = {
       *                 text   : 'Cool action',
       *                 icon   : 'b-fa b-fa-fw b-fa-ban',
       *                 onItem : () => console.log(`Clicked ${eventRecord.name}`),
       *                 weight : 1000 // Move to end
       *             };
       *
       *            if (!eventRecord.allowDelete) {
       *                 items.deleteEvent.hidden = true;
       *             }
       *         }
       *     }
       * },
       * ```
       * @param {Object} context An object with information about the menu being shown
       * @param {Gantt.model.TaskModel} context.taskRecord The record representing the current task
       * @param {Grid.column.Column} context.column The current column
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null
      /**
       * This is a preconfigured set of items used to create the default context menu.
       *
       * ```javascript
       * const gantt = new Gantt({
       *     features : {
       *         taskMenu : {
       *             items : {
       *                 add                 : false,
       *                 convertToMilestone  : false
       *             }
       *         }
       *     }
       * });
       * ```
       * The `items` provided by this feature are listed below. These are the property names which you may
       * configure:
       *
       * - `add` A submenu option containing a `menu` config which contains the following named items:
       *     * `addTaskAbove` Inserts a sibling task above the context task.
       *     * `addTaskBelow` Inserts a sibling task below the context task.
       *     * `milestone` Inserts a sibling milestone below the context task.
       *     * `subtask` Appends a child task to the context task.
       *     * `successor` Adds a sibling task linked by a dependence below the context task.
       *     * `predecessor` Adds a sibling task linked by a dependence above the context task.
       *  - `deleteTask` Deletes the context task.
       *  - `indent` Indents the context task by adding it as a child of its previous sibling.
       *  - `outdent` Outdents the context task by adding it as the final sibling of its parent.
       *  - `convertToMilestone` Converts the context task to a zero duration milestone.
       *
       * See the feature config in the above example for details.
       *
       * @config {Object}
       */

    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateTaskMenu');
    return config;
  } //endregion


  construct(gantt, config = {}) {
    super.construct(...arguments);
    this.gantt = gantt;

    if (gantt.features.cellMenu) {
      console.warn('`CellMenu` feature is ignored, when `TaskMenu` feature is enabled. If you need cell specific menu items, please configure `TaskMenu` feature items instead.');
      gantt.features.cellMenu.disabled = true;
    }
  } //region Events

  /**
   * This event fires on the owning Gantt before the context menu is shown for a task. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning false from a listener prevents the menu from
   * being shown.
   * @event taskMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {Gantt.view.Gantt} source
   * @param {Object[]} items Menu item configs
   * @param {Gantt.model.TaskModel} taskRecord Event record for which the menu was triggered
   * @param {HTMLElement} taskElement
   */

  /**
   * This event fires on the owning Gantt when an item is selected in the context menu.
   * @event taskMenuItem
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Core.widget.MenuItem} item
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {HTMLElement} taskElement
   */

  /**
   * This event fires on the owning Gantt after showing the context menu for an event
   * @event taskMenuShow
   * @on-owner
   * @param {Gantt.view.Gantt} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Gantt.model.TaskModel} taskRecord Event record for which the menu was triggered
   * @param {HTMLElement} taskElement
   */
  //endregion


  getDataFromEvent(event) {
    const {
      client
    } = this,
          targetElement = this.getTargetElementFromEvent(event),
          // to resolve record from a task element or from a grid cell
    taskRecord = client.resolveTaskRecord(targetElement) || client.getRecordFromElement(targetElement),
          taskElement = taskRecord && client.getElementFromTaskRecord(taskRecord, false); // get wrapper;

    return _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      event,
      targetElement,
      taskElement,
      taskRecord
    }, client.getCellDataFromEvent(event));
  }

  callChainablePopulateMenuMethod(eventParams) {
    // When context menu is called for a task cell, need to collect items from features
    // which usually add items to CellMenu in Grid and Scheduler,
    // since CellMenu feature is disabled when TaskMenu feature is enabled.
    if (eventParams.cellData && this.client.populateCellMenu) {
      this.client.populateCellMenu(eventParams);
    }

    super.callChainablePopulateMenuMethod(...arguments);
  }

  shouldShowMenu(eventParams) {
    const {
      column
    } = eventParams;
    return eventParams.taskRecord && (!column || column.enableCellContextMenu !== false);
  }

  getElementFromRecord(record) {
    return this.client.getElementFromTaskRecord(record);
  }

  populateTaskMenu({
    items,
    column,
    selection,
    taskRecord
  }) {
    const {
      client
    } = this,
          // Context menu on the selection offers multi actions on the selection.
    // Context menu on a non-selected record offers single actions on the context record.
    multiSelected = selection.includes(taskRecord) && selection.length > 1;
    items.add = {
      disabled: client.readOnly,
      hidden: multiSelected
    };
    items.convertToMilestone = {
      disabled: client.readOnly,
      hidden: taskRecord.isParent || taskRecord.milestone
    };
    items.indent = {
      disabled: client.readOnly || !taskRecord.previousSibling
    };
    items.outdent = {
      disabled: client.readOnly || taskRecord.parent === this.client.taskStore.rootNode
    };
    items.deleteTask = {
      disabled: client.readOnly
    }; // TaskMenu feature is responsible for cell items

    if (column !== null && column !== void 0 && column.cellMenuItems) {
      _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(items, column.cellMenuItems);
    }
  } // This generates the fixed, unchanging part of the items and is only called once
  // to generate the baseItems of the feature.
  // The dynamic parts which are set by populateEventMenu have this merged into them.


  changeItems(items) {
    const {
      client
    } = this;
    return _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge({
      add: {
        text: 'L{Gantt.Add}',
        cls: 'b-separator',
        icon: 'b-icon-add',
        weight: 500,
        menu: {
          addTaskAbove: {
            text: 'L{Gantt.Task above}',
            weight: 510,
            icon: 'b-icon-up',

            onItem({
              taskRecord
            }) {
              client.addTaskAbove(taskRecord);
            }

          },
          addTaskBelow: {
            text: 'L{Gantt.Task below}',
            weight: 520,
            icon: 'b-icon-down',

            onItem({
              taskRecord
            }) {
              client.addTaskBelow(taskRecord);
            }

          },
          milestone: {
            text: 'L{Gantt.Milestone}',
            weight: 530,
            icon: 'b-icon-milestone',

            onItem({
              taskRecord
            }) {
              client.addMilestoneBelow(taskRecord);
            }

          },
          subtask: {
            text: 'L{Gantt.Sub-task}',
            weight: 540,

            onItem({
              taskRecord
            }) {
              client.addSubtask(taskRecord);
            }

          },
          successor: {
            text: 'L{Gantt.Successor}',
            weight: 550,

            onItem({
              taskRecord
            }) {
              client.addSuccessor(taskRecord);
            }

          },
          predecessor: {
            text: 'L{Gantt.Predecessor}',
            weight: 560,

            onItem({
              taskRecord
            }) {
              client.addPredecessor(taskRecord);
            }

          }
        }
      },
      convertToMilestone: {
        icon: 'b-icon-milestone',
        text: 'L{Gantt.Convert to milestone}',
        weight: 600,

        onItem({
          taskRecord
        }) {
          taskRecord.convertToMilestone();
        }

      },
      indent: {
        text: 'L{Gantt.Indent}',
        icon: 'b-icon-indent',
        weight: 700,

        onItem({
          selection,
          taskRecord
        }) {
          // Context menu on the selection offers multi actions on the selection.
          // Context menu on a non-selected record offers single actions on the context record.
          client.indent(selection.includes(taskRecord) ? selection : taskRecord);
        }

      },
      outdent: {
        text: 'L{Gantt.Outdent}',
        icon: 'b-icon-outdent',
        weight: 800,

        onItem({
          selection,
          taskRecord
        }) {
          // Context menu on the selection offers multi actions on the selection.
          client.outdent(selection.includes(taskRecord) ? selection : taskRecord);
        }

      },
      deleteTask: {
        text: 'L{Gantt.Delete task}',
        icon: 'b-icon-trash',
        cls: 'b-separator',
        weight: 900,

        onItem({
          selection,
          taskRecord
        }) {
          // Context menu on the selection offers multi actions on the selection.
          // Context menu on a non-selected record offers single actions on the context record.
          client.taskStore.remove(selection.includes(taskRecord) ? selection : taskRecord);
        }

      }
    }, items);
  }

}
TaskMenu.featureClass = '';
TaskMenu._$name = 'TaskMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(TaskMenu, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskResize.js":
/*!*****************************************!*\
  !*** ./lib/Gantt/feature/TaskResize.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskResize; });
/* harmony import */ var _Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';


/**
 * @module Gantt/feature/TaskResize
 */

/**
 * Feature that allows resizing a task by dragging its end date. Resizing a task by dragging its start date is not allowed.
 *
 * This feature is **enabled** by default
 *
 * This feature updates the event's `endDate` live in order to leverage the
 * rendering pathway to always yield a correct appearance. The changes are done in
 * {@link Core.data.Model#function-beginBatch batched} mode so that changes do not become
 * eligible for data synchronization or propagation until the operation is completed.
 *
 * ## Customizing the resize tooltip
 *
 * To show custom HTML in the tooltip, please see the {@link #config-tooltipTemplate} config. Example:
 *
 * ```javascript
 * taskResize : {
 *     // A minimal end date tooltip
 *     tooltipTemplate : ({ record, endDate }) => {
 *         return DateHelper.format(endDate, 'MMM D');
 *     }
 * }
 * ```
 *
 * @extends Scheduler/feature/EventResize
 * @demo Gantt/basic
 * @classtype taskResize
 * @feature
 */

class TaskResize extends _Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TaskResize';
  }

  static get configurable() {
    return {
      draggingItemCls: 'b-sch-event-resizing',
      resizingItemInnerCls: null,
      leftHandle: false
    };
  } //region Events

  /**
   * @event beforeEventResize
   * @hide
   */

  /**
   * @event eventResizeStart
   * @hide
   */

  /**
   * @event eventPartialResize
   * @hide
   */

  /**
   * @event beforeEventResizeFinalize
   * @hide
   */

  /**
   * @event eventResizeEnd
   * @hide
   */

  /**
   * Fires on the owning Gantt before resizing starts. Return false to prevent operation
   * @event beforeTaskResize
   * @on-owner
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Event} event
   */

  /**
   * Fires on the owning Gantt when task resizing starts
   * @event taskResizeStart
   * @on-owner
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Event} event
   */

  /**
   * Fires on the owning Gantt on each resize move event
   * @event taskPartialResize
   * @on-owner
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Date} start
   * @param {Date} end
   * @param {HTMLElement} element
   */

  /**
   * Fires on the owning Gantt to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  gantt.on('beforetaskresizefinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * @event beforeTaskResizeFinalize
   * @on-owner
   * @param {Object} data
   * @param {Gantt.view.Gantt} data.source Gantt instance
   * @param {Object} data.context
   * @param {Boolean} data.context.async Set true to handle resize asynchronously (e.g. to wait for user
   * confirmation)
   * @param {Function} data.context.finalize Call this method to finalize resize. This method accepts one
   * argument: pass true to update records, or false, to ignore changes
   */

  /**
   * Fires on the owning Gantt after the resizing gesture has finished.
   * @event taskResizeEnd
   * @on-owner
   * @param {Boolean} changed
   * @param {Gantt.model.TaskModel} taskRecord
   */
  //endregion
  //region Gantt specifics


  checkValidity() {
    // Task resize just does basic validity checks which runs the validatorFn
    return this.basicValidityCheck(...arguments);
  }

  getBeforeResizeParams(context) {
    return {};
  } // Injects Gantt specific data into the drag context


  setupProductResizeContext(context, event) {
    const gantt = this.client,
          taskRecord = gantt.resolveTaskRecord(context.element);
    Object.assign(context, {
      taskRecord,
      eventRecord: taskRecord,
      dateConstraints: gantt.getDateConstraints(taskRecord)
    });
  } //endregion


}
TaskResize._$name = 'TaskResize';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TaskResize, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/TaskTooltip.js":
/*!******************************************!*\
  !*** ./lib/Gantt/feature/TaskTooltip.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskTooltip; });
/* harmony import */ var _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';




/**
 * @module Gantt/feature/TaskTooltip
 */

/**
 * This feature displays a task tooltip on mouse hover. The template of the tooltip is customizable
 * with the {@link #config-template} function.
 *
 *```javascript
 * new Gantt({
 *   features : {
 *     taskTooltip : {
 *         // Tooltip configs can be used here
 *         align : 'l-r' // Align left to right
 *     }
 *   }
 * });
 * ```
 *
 * ## Showing remotely loaded data
 * Loading remote data into the task tooltip is easy. Simply use the {@link #config-template} and return a Promise which yields the content to show.
 * ```javascript
 * new Gantt({
 *   features : {
 *     taskTooltip : {
 *        template : ({ taskRecord }) => AjaxHelper.get(`./fakeServer?name=${taskRecord.name}`).then(response => response.text())
 *     }
 *   }
 * });
 * ```
 *
 * This feature is **enabled** by default.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @demo Gantt/tooltips
 * @classtype taskTooltip
 * @feature
 */

class TaskTooltip extends _Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TaskTooltip';
  }

  static get defaultConfig() {
    return {
      /**
       * Template (a function accepting task data and returning a string) used to display info in the tooltip.
       * The template will be called with an object as with fields as detailed below
       * @param {Object} data
       * @param {Gantt.model.TaskModel} data.taskRecord
       * @param {String} data.startClockHtml
       * @param {String} data.endClockHtml
       * @config {function} template
       */
      template(data) {
        const me = this,
              {
          taskRecord
        } = data,
              displayDuration = me.client.formatDuration(taskRecord.duration, me.decimalPrecision);
        return `
                    ${taskRecord.name ? `<div class="b-gantt-task-title">${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(taskRecord.name)}</div>` : ''}
                    <table border="0" cellspacing="0" cellpadding="0">
                    <tr><td>${me.L('L{Start}')}:</td><td>${data.startClockHtml}</td></tr>
                    ${taskRecord.milestone ? '' : `
                        <tr><td>${me.L('L{End}')}:</td><td>${data.endClockHtml}</td></tr>
                        <tr><td>${me.L('L{Duration}')}:</td><td class="b-right">${displayDuration + ' ' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getLocalizedNameOfUnit(taskRecord.durationUnit, taskRecord.duration !== 1)}</td></tr>
                        <tr><td>${me.L('L{Complete}')}:</td><td class="b-right">${taskRecord.renderedPercentDone}%</td></tr>
                    `}
                    </table>
                `;
      },

      /**
       * Precision of displayed duration, defaults to use {@link Gantt.view.Gantt#config-durationDisplayPrecision}.
       * Specify an integer value to override that setting, or `false` to use raw value
       * @member {Number|Boolean} decimalPrecision
       */

      /**
       * Precision of displayed duration, defaults to use {@link Gantt.view.Gantt#config-durationDisplayPrecision}.
       * Specify an integer value to override that setting, or `false` to use raw value
       * @config {Number|Boolean}
       */
      decimalPrecision: null,
      cls: 'b-gantt-task-tooltip',
      monitorRecordUpdate: true
    };
  }

}
TaskTooltip._$name = 'TaskTooltip';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TaskTooltip, true, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/export/MspExport.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/feature/export/MspExport.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MspExport; });
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/XMLHelper.js */ "./lib/Core/helper/XMLHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






const MIN_DATE = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(new Date(1900, 5, 15)),
      // TODO some early date to safely not intersect w/ some calendar exceptions
taskUnitMap = {
  minute: 3,
  hour: 5,
  day: 7,
  week: 9,
  month: 11
},
      projectUnitMap = {
  minute: 1,
  hour: 2,
  day: 3,
  week: 4,
  month: 5
},
      constraintMap = {
  finishnoearlierthan: 6,
  finishnolaterthan: 7,
  mustfinishon: 3,
  muststarton: 2,
  startnoearlierthan: 4,
  startnolaterthan: 5
},
      typeMap = {
  FixedDuration: 1,
  FixedUnits: 0,
  FixedEffort: 2,
  Normal: 0
},
      dependencyTypeMap = {
  0: 3,
  1: 2,
  2: 1,
  3: 0
};
/**
 * @module Gantt/feature/export/MspExport
 */

/**
 * A feature that allows exporting Gantt to Microsoft Project without involving a server.
 *
 * [Microsoft Project XML specification](https://docs.microsoft.com/en-us/office-project/xml-data-interchange/introduction-to-project-xml-data)
 *
 * This feature supports exporting to an XML format that can be imported by MS Project Professional 2013 / 2019.
 *
 * Here is an example of how to add the feature:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         mspExport : {
 *             // Choose the filename for the exported file
 *             filename : 'Gantt Export'
 *         }
 *     }
 * });
 * ```
 *
 * And how to trigger an export:
 *
 * ```javascript
 * gantt.features.mspExport.export({
 *     filename : 'Gantt Export'
 * })
 * ```
 * @classtype mspExport
 *
 * @extends Core/mixin/InstancePlugin
 * @feature
 * @demo Gantt/msprojectexport
 */

class MspExport extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get $name() {
    return 'MspExport';
  }

  static get configurable() {
    return {
      /**
       * Name of the exported file (including extension)
       * @config {String}
       * @default
       */
      filename: null,

      /**
       * Defines how dates are formatted for MS Project. Information about formats can be found in {@link Core.helper.DateHelper}
       * @config {String}
       * @default
       */
      dateFormat: 'YYYY-MM-DDTHH:mm:ss',

      /**
       * Defines how time is formatted for MSProject. Information about formats can be found in {@link Core.helper.DateHelper}
       * @config {String}
       * @default
       */
      timeFormat: 'HH:mm:ss',

      /**
       * Defines the version used for MSProject (2013 or 2019)
       * @config {Number}
       * @default
       */
      msProjectVersion: 2019
    };
  }
  /**
   * Generate the export data to generate the XML.
   * @returns {Object} Gantt data on MS Project structure to generate the XML
   * @private
   */


  generateExportData() {
    const me = this;
    return _objectSpread(_objectSpread({}, me.getMsProjectConfig()), {}, {
      Calendars: {
        Calendar: me.getCalendarsData()
      },
      Tasks: {
        Task: me.getTasksData()
      },
      Resources: {
        Resource: me.getResourcesData()
      },
      Assignments: {
        Assignment: me.getAssignmentsData()
      }
    });
  }
  /**
   * Generates and downloads the .XML file.
   * @param {Object} [config] Optional configuration object, which overrides the initial settings of the feature/exporter.
   * @param {String} [config.filename] The filename to use
   */


  export(config = {}) {
    const me = this;

    if (me.disabled) {
      return;
    }

    config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assign({}, me.config, config);

    if (!config.filename) {
      config.filename = `${me.client.$$name}.xml`;
    }

    const data = me.generateExportData(config),
          xml = me.convertToXml(data);
    _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].download(config.filename, `data:text/xml;charset=utf-8,${encodeURIComponent(xml)}`);
  }
  /**
   * Convert Object data to XML.
   * @param {Object} data The Object with data.
   * @returns {String} The XML data.
   * @private
   */


  convertToXml(data) {
    return _Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].convertFromObject(data, {
      rootName: 'Project',
      elementName: '',
      xmlns: 'http://schemas.microsoft.com/project',
      rootElementForArray: false
    });
  }
  /**
   * Get the XML configurations in MS Project format.
   * @returns {Object} MS Project configurations for the XML
   * @private
   */


  getMsProjectConfig() {
    const me = this,
          dateFormat = me.dateFormat,
          {
      project
    } = me.client,
          fileName = me.filename || me.client.$$name;
    return {
      CalendarUID: me.getCalendarUID(project.effectiveCalendar),
      CreationDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(new Date(), dateFormat),
      CurrentDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(new Date(), dateFormat),
      DaysPerMonth: project.daysPerMonth,
      FinishDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(project.endDate, dateFormat),
      MinutesPerDay: project.hoursPerDay * 60,
      MinutesPerWeek: project.daysPerWeek * project.hoursPerDay * 60,
      Name: fileName,
      ScheduleFromStart: project.direction === 'Forward' ? 1 : 0,
      StartDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(project.startDate, dateFormat),
      Title: fileName,
      WorkFormat: projectUnitMap[project.effortUnit]
    };
  }
  /**
   * Format Calendars from Gantt to MS Project format.
   * @returns {Array} Calendars array formatted
   * @private
   */


  getCalendarsData() {
    const me = this,
          {
      calendarManagerStore,
      project
    } = me.client,
          {
      effectiveCalendar
    } = project,
          calendars = calendarManagerStore.allRecords || []; // if project's calendar is not included on calendars array, include it

    if (!calendarManagerStore.getByInternalId(effectiveCalendar.internalId)) {
      calendars.push(effectiveCalendar);
    }

    return calendars.map(calendar => ({
      BaseCalendarUID: me.getCalendarUID(calendar.parent),
      IsBaseCalendar: calendar.parentId ? 0 : 1,
      Name: `${calendar.name || calendar.internalId} - imported`,
      UID: me.getCalendarUID(calendar),
      WeekDays: {
        WeekDay: me.formatWeekDays(calendar)
      } //,
      // TODO
      // WorkWeeks : {
      //     WorkWeek : this.formatWorkWeeks(calendar)
      // }

    }));
  }
  /**
   * Format intervals to MS project format for the WeekDays property.
   * @param {Array} Array of intervals data.
   * @returns {Array} Array with data formatted
   * @private
   */


  formatWeekDays(calendar) {
    const {
      timeFormat
    } = this,
          ticks = [],
          daysData = {};
    let startDate = MIN_DATE,
        endDate;

    for (let i = 0; i < 7; i++) {
      // week day index
      const day = startDate.getDay();
      daysData[day] = {
        DayType: day + 1,
        DayWorking: 0
      };
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, 1, 'day'));
      ticks.push({
        startDate,
        endDate
      }); // proceed to next day

      startDate = endDate;
    }

    const // dummy calendar with 7 day borders ..to force forEachAvailabilityInterval to stop on each day start
    dummyCalendar = new calendar.constructor({
      intervals: ticks
    }),
          calendarsCombination = this.client.project.combineCalendars([calendar, dummyCalendar]);
    calendarsCombination.forEachAvailabilityInterval({
      startDate: MIN_DATE,
      endDate
    }, (startDate, endDate, calendarCacheInterval) => {
      const calendarsStatus = calendarCacheInterval.getCalendarsWorkStatus(),
            dayData = daysData[startDate.getDay()]; // if the calendar has working interval for that period

      if (calendarsStatus.get(calendar)) {
        // consider the day as working
        dayData.DayWorking = 1;
        dayData.WorkingTimes = dayData.WorkingTimes || {
          WorkingTime: []
        }; // put that time range

        dayData.WorkingTimes.WorkingTime.push({
          FromTime: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(startDate, timeFormat),
          ToTime: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(endDate, timeFormat)
        });
      }
    });
    return Object.values(daysData);
  }
  /**
   * Format intervals to MS project format for the WorkWeeks property.
   * @param {Array} Array of intervals data.
   * @returns {Array} Array with data formatted
   * @private
   */
  // formatWorkWeeks(calendar) {
  //     // TODO: implement
  // }


  collectProjectTasks(project = this.client.project) {
    const result = [];
    project.taskStore.rootNode.traverse(node => result.push(node), true);
    return result;
  }
  /**
   * Format Tasks from Gantt to MS Project format.
   * @returns {Array} Tasks array formatted
   * @private
   */


  getTasksData() {
    const me = this,
          {
      dateFormat
    } = me,
          {
      project
    } = me.client,
          tasks = me.collectProjectTasks(project);
    return tasks.map(task => {
      const {
        wbsCode
      } = task,
            // filter out broken dependencies
      predecessors = task.predecessors.filter(({
        fromEvent
      }) => fromEvent);
      return {
        CalendarUID: me.getCalendarUID(task.effectiveCalendar),
        ConstraintDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.constraintDate, dateFormat),
        ConstraintType: constraintMap[task.constraintType],
        Deadline: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.deadlineDate, dateFormat),
        Duration: me.convertDurationToMspDuration(task.duration, task.durationUnit),
        DurationFormat: taskUnitMap[task.durationUnit],
        EarlyFinish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.earlyEnd, dateFormat),
        EarlyStart: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.earlyStart, dateFormat),
        EffortDriven: task.effortDriven ? 1 : 0,
        Estimated: 0,
        Finish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.endDate, dateFormat),
        LateFinish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.lateEnd, dateFormat),
        LateStart: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.lateStart, dateFormat),
        Manual: task.manuallyScheduled ? 1 : 0,
        ManualDuration: me.convertDurationToMspDuration(task.duration, task.durationUnit),
        ManualFinish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.endDate, dateFormat),
        ManualStart: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.startDate, dateFormat),
        Milestone: task.isMilestone ? 1 : 0,
        Name: task.name,
        Notes: task.note,
        ProjectExternallyEdited: 0,
        OutlineLevel: wbsCode.split('.').length,
        OutlineNumber: wbsCode,
        // TODO: fix PercentComplete field because the value is missing for some specific tasks after export
        // PercentComplete         : Math.round(task.percentDone),
        PredecessorLink: predecessors.map(predecessor => ({
          LagFormat: taskUnitMap[predecessor.lagUnit],
          LinkLag: project.convertDuration(predecessor.lag, predecessor.lagUnit, 'minute') * 10,
          PredecessorUID: me.getTaskUID(predecessor.fromEvent),
          Type: dependencyTypeMap[predecessor.type]
        })),
        Baseline: task.baselines.map((baseline, index) => ({
          Number: index,
          Finish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(baseline.endDate, dateFormat),
          Start: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(baseline.startDate, dateFormat),
          Duration: me.convertDurationToMspDuration(baseline.duration, baseline.durationUnit)
        })),
        RemainingDuration: me.convertDurationToMspDuration(task.duration, task.durationUnit),
        Rollup: task.rollup ? 1 : 0,
        Start: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(task.startDate, dateFormat),
        Summary: task.isLeaf ? 0 : 1,
        TotalSlack: task.totalSlack,
        Type: task.isLeaf ? typeMap[task.schedulingMode] : 1,
        UID: me.getTaskUID(task),
        WBS: wbsCode,
        Work: me.convertDurationToMspDuration(task.effort, task.effortUnit)
      };
    });
  }

  getTaskUID(task) {
    return task.internalId;
  }

  getCalendarUID(calendar, fallbackValue = -1) {
    return calendar && !calendar.isRoot ? calendar.internalId : fallbackValue;
  }
  /**
   * Format Resources from Gantt to MS Project format.
   * @returns {Array} Resources array formatted
   * @private
   */


  getResourcesData() {
    return this.client.resources.map(resource => ({
      // seems for version 2013 setting the calendar id it breaks so only Project level calendar is importable
      CalendarUID: this.msProjectVersion === 2013 ? null : this.getCalendarUID(resource.effectiveCalendar),
      Name: resource.name,
      UID: resource.id,
      Type: 1
    }));
  }
  /**
   * Format Assignments from Gantt to MS Project format.
   * @returns {Array} Assignments array formatted
   * @private
   */


  getAssignmentsData() {
    // for version 2013 the assignments doesn't work
    if (this.msProjectVersion === 2013) {
      return [];
    }

    return this.client.assignments.map(({
      data,
      event
    }) => ({
      Finish: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(event.endDate, this.dateFormat),
      // TODO it seems we need to provide effort per assignment value ..there is no ready to use field for that yet
      // PercentWorkComplete : Math.round(event.percentDone),
      ResourceUID: data.resource,
      Start: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(event.startDate, this.dateFormat),
      TaskUID: data.event,
      UID: data.id,
      Units: data.units / 100
    }));
  }
  /**
   * Convert to MS Project Span Date Time format.
   * @param {Number} value The value to be converted.
   * @param {String} unit The unit of the value to be converted
   * @returns {String} The value formatted to "PTnHnMnS". E.g: PT10H30M, PT6H20M13S
   * @private
   */


  convertDurationToMspDuration(value, unit) {
    if (value == null) {
      return '';
    }

    const delta = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getDelta(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('ms', value, unit), {
      abbrev: true
    }),
          {
      w: weeks,
      min: mins,
      s: secs
    } = delta;
    let {
      yr: years,
      mon: months,
      d: days,
      h: hours
    } = delta;
    hours = hours || 0; // convert years, months, weeks and days to hours because MS Project work only with hours, minutes and seconds

    if (years) {
      hours += _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('h', years, 'y');
    }

    if (months) {
      hours += _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('h', months, 'month');
    }

    if (weeks) {
      hours += _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('h', weeks, 'w');
    }

    if (days) {
      hours += _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('h', days, 'd');
    }

    return `PT${hours}H${mins || 0}M${secs || 0}S`;
  }

}
MspExport._$name = 'MspExport';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(MspExport, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/export/PdfExport.js":
/*!***********************************************!*\
  !*** ./lib/Gantt/feature/export/PdfExport.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PdfExport; });
/* harmony import */ var _Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Scheduler/feature/export/PdfExport.js */ "./lib/Scheduler/feature/export/PdfExport.js");
/* harmony import */ var _exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exporter/SinglePageExporter.js */ "./lib/Gantt/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./exporter/MultiPageExporter.js */ "./lib/Gantt/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exporter/MultiPageVerticalExporter.js */ "./lib/Gantt/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';





/**
 * @module Gantt/feature/export/PdfExport
 */

/**
 * Generates PDF/PNG files from the Gantt component.
 *
 * <img src="Gantt/gantt-export-dialog.png" style="max-width : 300px" alt="Gantt Export dialog">
 *
 * **NOTE:** Server side is required to make export work!
 *
 * The export server is written in nodejs and it is shipped with our examples. You can find setup instructions in
 * `examples/_shared/server/README.md` and `examples/export/README.md` files.
 *
 * When your server is up and running, it listens to requests. The Export feature sends a request to the specified URL
 * with the HTML fragments. The server generates a PDF (or PNG) file and returns a download link (or binary, depending
 * on {@link #config-sendAsBinary} config). Then the Export feature opens the link in a new tab and the file is
 * automatically downloaded by your browser. This is configurable, see {@link #config-openAfterExport} config.
 *
 * The {@link #config-exportServer} URL must be configured. The URL can be localhost if you start the server locally,
 * or your remote server address.
 *
 * ## Usage
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080' // Required
 *         }
 *     }
 * })
 *
 * // Opens popup allowing to customize export settings
 * gantt.features.pdfExport.showExportDialog();
 *
 * // Simple export
 * gantt.features.pdfExport.export({
 *     // Required, set list of column ids to export
 *     columns : gantt.columns.map(c => c.id)
 * }).then(result => {
 *     // Response instance and response content in JSON
 *     let { response, responseJSON } = result;
 * });
 * ```
 *
 * ## Configuring the export dialog
 *
 * To learn about how to customize the export dialog and its default widgets, please refer to the
 * {@link Scheduler.view.export.SchedulerExportDialog} which provides a 'ref' identifier for each child widget so that
 * you can customize them all based on your requirements.
 *
 * ## Loading resources
 *
 * If you face a problem with loading resources when exporting, the cause might be that the application and the export server are hosted on different servers.
 * This is due to [Cross-Origin Resource Sharing](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) (CORS). There are 2 options how to handle this:
 * - Allow cross origin requests from the server where your export is hosted to the server where your application is hosted;
 * - Copy all resources keeping the folder hierarchy from the server where your application is hosted to the server where your export is hosted
 * and setup paths using {@link Grid.feature.export.PdfExport#config-translateURLsToAbsolute} config and configure the export server to give access to the path:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080',
 *             // '/resources' is hardcoded in WebServer implementation
 *             translateURLsToAbsolute : 'http://localhost:8080/resources'
 *         }
 *     }
 * })
 * ```
 *
 * ```javascript
 * // Following path would be served by this address: http://localhost:8080/resources/
 * node ./src/server.js -h 8080 -r web/application/styles
 * ```
 *
 * where `web/application/styles` is a physical root location of the copied resources, for example:
 *
 * <img src="Grid/export-server-resources.png" style="max-width : 500px" alt="Export server structure with copied resources" />
 *
 * @classtype pdfExport
 *
 * @extends Scheduler/feature/export/PdfExport
 * @feature
 * @typings Scheduler/feature/export/PdfExport -> Scheduler/feature/export/SchedulerPdfExport
 */

class PdfExport extends _Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PdfExport';
  }

  static get defaultConfig() {
    return {
      exporters: [_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_1__["default"], _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_2__["default"], _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_3__["default"]]
    };
  }

}
PdfExport._$name = 'PdfExport';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerFeature(PdfExport, false, 'Gantt');

/***/ }),

/***/ "./lib/Gantt/feature/export/exporter/GanttExporterMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Gantt/feature/export/exporter/GanttExporterMixin.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


/**
 * This mixin overrides event elements handling in similar scheduler mixin. Uses correct element class names and
 * resolves elements in gantt-way.
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (base => class GanttExporterMixin extends base {
  async prepareComponent(config) {
    await super.prepareComponent(config);
    const me = this,
          // Clear cloned gantt element from task elements
    fgCanvasEl = me.element.querySelector('.b-sch-foreground-canvas');
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].removeEachSelector(fgCanvasEl, '.b-gantt-task-wrap');
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].removeEachSelector(fgCanvasEl, '.b-released');
  }

  collectEvents(rows, config) {
    const me = this,
          addedRows = rows.length,
          {
      client
    } = config,
          normalRows = me.exportMeta.subGrids.normal.rows;
    rows.forEach((row, index) => {
      const rowConfig = normalRows[normalRows.length - addedRows + index],
            event = client.store.getAt(row.dataIndex),
            eventsMap = rowConfig[3];

      if (event.isScheduled) {
        const el = client.getElementFromTaskRecord(event, false);

        if (el && !eventsMap.has(event.id)) {
          eventsMap.set(event.id, [el.outerHTML, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(el.firstChild, el.offsetParent)]);
        }
      }
    });
  }

});

/***/ }),

/***/ "./lib/Gantt/feature/export/exporter/MultiPageExporter.js":
/*!****************************************************************!*\
  !*** ./lib/Gantt/feature/export/exporter/MultiPageExporter.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageExporter; });
/* harmony import */ var _Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Scheduler/feature/export/exporter/MultiPageExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttExporterMixin.js */ "./lib/Gantt/feature/export/exporter/GanttExporterMixin.js");
var productName = 'gantt';


class MultiPageExporter extends Object(_GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'MultiPageExporter';
  }

}
MultiPageExporter._$name = 'MultiPageExporter';

/***/ }),

/***/ "./lib/Gantt/feature/export/exporter/MultiPageVerticalExporter.js":
/*!************************************************************************!*\
  !*** ./lib/Gantt/feature/export/exporter/MultiPageVerticalExporter.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageVerticalExporter; });
/* harmony import */ var _Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Scheduler/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttExporterMixin.js */ "./lib/Gantt/feature/export/exporter/GanttExporterMixin.js");
var productName = 'gantt';


class MultiPageVerticalExporter extends Object(_GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'MultiPageVerticalExporter';
  }

}
MultiPageVerticalExporter._$name = 'MultiPageVerticalExporter';

/***/ }),

/***/ "./lib/Gantt/feature/export/exporter/SinglePageExporter.js":
/*!*****************************************************************!*\
  !*** ./lib/Gantt/feature/export/exporter/SinglePageExporter.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SinglePageExporter; });
/* harmony import */ var _Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Scheduler/feature/export/exporter/SinglePageExporter.js */ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GanttExporterMixin.js */ "./lib/Gantt/feature/export/exporter/GanttExporterMixin.js");
var productName = 'gantt';


class SinglePageExporter extends Object(_GanttExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SinglePageExporter';
  }

}
SinglePageExporter._$name = 'SinglePageExporter';

/***/ }),

/***/ "./lib/Gantt/localization/En.js":
/*!**************************************!*\
  !*** ./lib/Gantt/localization/En.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _SchedulerPro_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../SchedulerPro/localization/En.js */ "./lib/SchedulerPro/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
var productName = 'gantt';
 //<umd>



const locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeLocales(_SchedulerPro_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"], {
  //region Common
  Object: {
    Save: 'Save'
  },
  //endregion
  //region Columns
  InactiveColumn: {
    Inactive: 'Inactive'
  },
  AddNewColumn: {
    'New Column': 'New Column'
  },
  CalendarColumn: {
    Calendar: 'Calendar'
  },
  EarlyStartDateColumn: {
    'Early Start': 'Early Start'
  },
  EarlyEndDateColumn: {
    'Early End': 'Early End'
  },
  LateStartDateColumn: {
    'Late Start': 'Late Start'
  },
  LateEndDateColumn: {
    'Late End': 'Late End'
  },
  TotalSlackColumn: {
    'Total Slack': 'Total Slack'
  },
  ConstraintDateColumn: {
    'Constraint Date': 'Constraint Date'
  },
  ConstraintTypeColumn: {
    'Constraint Type': 'Constraint Type'
  },
  DeadlineDateColumn: {
    Deadline: 'Deadline'
  },
  DependencyColumn: {
    'Invalid dependency': 'Invalid dependency found, change reverted'
  },
  DurationColumn: {
    Duration: 'Duration'
  },
  EffortColumn: {
    Effort: 'Effort'
  },
  EndDateColumn: {
    Finish: 'Finish'
  },
  EventModeColumn: {
    'Event mode': 'Event mode',
    Manual: 'Manual',
    Auto: 'Auto'
  },
  ManuallyScheduledColumn: {
    'Manually scheduled': 'Manually scheduled'
  },
  MilestoneColumn: {
    Milestone: 'Milestone'
  },
  NameColumn: {
    Name: 'Name'
  },
  NoteColumn: {
    Note: 'Note'
  },
  PercentDoneColumn: {
    '% Done': '% Done'
  },
  PredecessorColumn: {
    Predecessors: 'Predecessors'
  },
  ResourceAssignmentColumn: {
    'Assigned Resources': 'Assigned Resources',
    'more resources': 'more resources'
  },
  RollupColumn: {
    Rollup: 'Rollup'
  },
  SchedulingModeColumn: {
    'Scheduling Mode': 'Scheduling Mode'
  },
  SequenceColumn: {
    Sequence: 'Sequence'
  },
  ShowInTimelineColumn: {
    'Show in timeline': 'Show in timeline'
  },
  StartDateColumn: {
    Start: 'Start'
  },
  SuccessorColumn: {
    Successors: 'Successors'
  },
  TaskCopyPaste: {
    copyTask: 'Copy',
    cutTask: 'Cut',
    pasteTask: 'Paste'
  },
  WBSColumn: {
    WBS: 'WBS',
    renumber: 'Renumber'
  },
  //endregion
  DependencyField: {
    'invalidDependencyFormat': 'Invalid dependency format'
  },
  ProjectLines: {
    'Project Start': 'Project start',
    'Project End': 'Project end'
  },
  TaskTooltip: {
    Start: 'Start',
    End: 'End',
    Duration: 'Duration',
    Complete: 'Complete'
  },
  AssignmentGrid: {
    Name: 'Resource name',
    Units: 'Units',
    unitsTpl: ({
      value
    }) => value ? value + '%' : ''
  },
  GanttBase: {
    propagating: 'Calculating project',
    storePopulation: 'Loading data'
  },
  Gantt: {
    Edit: 'Edit',
    Indent: 'Indent',
    Outdent: 'Outdent',
    'Convert to milestone': 'Convert to milestone',
    Add: 'Add...',
    'New task': 'New task',
    'New milestone': 'New milestone',
    'Task above': 'Task above',
    'Task below': 'Task below',
    'Delete task': 'Delete',
    Milestone: 'Milestone',
    'Sub-task': 'Subtask',
    Successor: 'Successor',
    Predecessor: 'Predecessor',
    changeRejected: 'Scheduling engine rejected the changes'
  },
  Indicators: {
    earlyDates: 'Early start/end',
    lateDates: 'Late start/end',
    Start: 'Start',
    End: 'End',
    deadlineDate: 'Deadline'
  }
});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
  desc: 'English',
  locale
});

/***/ }),

/***/ "./lib/Gantt/model/AssignmentModel.js":
/*!********************************************!*\
  !*** ./lib/Gantt/model/AssignmentModel.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentModel; });
/* harmony import */ var _SchedulerPro_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/model/AssignmentModel.js */ "./lib/SchedulerPro/model/AssignmentModel.js");
/* harmony import */ var _Engine_quark_model_gantt_GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Engine/quark/model/gantt/GanttAssignmentMixin.js */ "./lib/Engine/quark/model/gantt/GanttAssignmentMixin.js");
/* harmony import */ var _Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
var productName = 'gantt';



/**
 * @module Gantt/model/AssignmentModel
 */

/**
 * This class represent a single assignment of a {@link Gantt.model.ResourceModel resource} to a
 * {@link Gantt.model.TaskModel task} in your gantt chart.
 *
 * @extends SchedulerPro/model/AssignmentModel
 *
 * @typings SchedulerPro/model/AssignmentModel -> SchedulerPro/model/SchedulerProAssignmentModel
 * @uninherit Core/data/mixin/TreeNode
 */

class AssignmentModel extends _Engine_quark_model_gantt_GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_1__["GanttAssignmentMixin"].mix(_SchedulerPro_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Fields
  static get fields() {
    /**
     * The numeric, percent-like value, indicating what is the "contribution level"
     * of the resource availability to the task.
     * Number 100, means that the assigned resource spends 100% of its working time to the task.
     * Number 50 means that the resource spends only half of its available time for the assigned task.
     * @field {Number} units
     */
    return [
    /**
     * Id for event to assign. Note that after load it will be populated with the actual event.
     * @field {Gantt.model.TaskModel} event
     * @accepts {String|Number|Gantt.model.TaskModel}
     */
    {
      name: 'event',
      persist: true,
      serialize: record => record === null || record === void 0 ? void 0 : record.id,
      isEqual: _Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"]
    },
    /**
     * Id for resource to assign to. Note that after load it will be populated with the actual resource.
     * @field {Gantt.model.ResourceModel} resource
     * @accepts {String|Number|Gantt.model.ResourceModel}
     */
    {
      name: 'resource',
      persist: true,
      serialize: record => record === null || record === void 0 ? void 0 : record.id,
      isEqual: _Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_2__["isSerializableEqual"]
    },
    /**
     * Hidden
     * @field {String|Number} eventId
     * @hide
     */
    'eventId',
    /**
     * Hidden
     * @field {String|Number} resourceId
     * @hide
     */
    'resourceId'];
  } //endregion


}
AssignmentModel._$name = 'AssignmentModel';

/***/ }),

/***/ "./lib/Gantt/model/Baseline.js":
/*!*************************************!*\
  !*** ./lib/Gantt/model/Baseline.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Baseline; });
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
var productName = 'gantt';

/**
 * @module Gantt/model/Baseline
 */

/**
 * This class represents a baseline of a Task.
 *
 * @extends Scheduler/model/TimeSpan
 */

class Baseline extends _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Fields
  // TODO: handle persist? defaultValue?
  static get fields() {
    return [
    /**
     * The owning Task of the Baseline
     * @field {Gantt.model.TaskModel} task
     */
    {
      name: 'task',
      persist: false
    }
    /**
     * Start date of the baseline in ISO 8601 format.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     */

    /**
     * End date of the baseline in ISO 8601 format.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     */

    /**
     * An encapsulation of the CSS classes to be added to the rendered baseline element.
     *
     * Always returns a {@link Core.helper.util.DomClassList}, but may still be treated as a string. For
     * granular control of adding and removing individual classes, it is recommended to use the
     * {@link Core.helper.util.DomClassList} API.
     *
     * @field {Core.helper.util.DomClassList} cls
     * @accepts {Core.helper.util.DomClassList|String}
     */
    ];
  } //endregion
  //region Init
  //endregion


  get isBaseline() {
    return true;
  } //region Milestone


  get milestone() {
    // a summary baseline may have zero duration when "recalculateParents" is on
    // and a child baseline has working time on the summary baseline non-working time
    // so we operate start and end date pair here
    if (!this.isLeaf) {
      const {
        startDate,
        endDate
      } = this;

      if (startDate && endDate) {
        return endDate.getTime() === startDate.getTime();
      }
    }

    return this.duration === 0;
  }

  set milestone(value) {
    value ? this.convertToMilestone() : this.convertToRegular();
  }

  async setMilestone(value) {
    return value ? this.convertToMilestone() : this.convertToRegular();
  }
  /**
   * Converts this baseline to a milestone (start date will match the end date).
   *
   * @propagating
   */


  async convertToMilestone() {
    return this.setDuration(0, this.durationUnit, false);
  }
  /**
   * Converts a milestone baseline to a regular baseline with a duration of 1 (keeping current `durationUnit`).
   *
   * @propagating
   */


  async convertToRegular() {
    if (this.milestone) {
      return this.setDuration(1, this.durationUnit, false);
    }
  } //endregion
  // Uses engine to calculate dates and/or duration.


  normalize() {
    const me = this,
          {
      task,
      startDate,
      endDate,
      duration
    } = me,
          hasDuration = duration != null;

    if (!task.graph) {
      super.normalize();
    } else {
      // need to calculate duration (checking first since seemed most likely to happen)
      if (startDate && endDate && !hasDuration) {
        me.setData('duration', task.run('calculateProjectedDuration', startDate, endDate));
      } // need to calculate endDate
      else if (startDate && !endDate && hasDuration) {
        me.setData('endDate', task.run('calculateProjectedXDateWithDuration', startDate, true, duration));
      } // need to calculate startDate
      else if (!startDate && endDate && hasDuration) {
        me.setData('startDate', task.run('calculateProjectedXDateWithDuration', endDate, false, duration));
      }
    }
  }

}
Baseline._$name = 'Baseline';

/***/ }),

/***/ "./lib/Gantt/model/CalendarIntervalModel.js":
/*!**************************************************!*\
  !*** ./lib/Gantt/model/CalendarIntervalModel.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarIntervalModel; });
/* harmony import */ var _SchedulerPro_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/model/CalendarIntervalModel.js */ "./lib/SchedulerPro/model/CalendarIntervalModel.js");
var productName = 'gantt';

/**
 * @module Gantt/model/CalendarIntervalModel
 */

/**
 * This class represents a calendar interval in the Gantt calendar.
 * Every interval can be either recurrent (regularly repeating in time) or static.
 *
 * Please refer to the [calendars guide](#Gantt/guides/basics/calendars.md) for details
 *
 * @extends SchedulerPro/model/CalendarIntervalModel
 *
 * @typings SchedulerPro/model/CalendarIntervalModel -> SchedulerPro/model/SchedulerProCalendarIntervalModel
 */

class CalendarIntervalModel extends _SchedulerPro_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}
CalendarIntervalModel._$name = 'CalendarIntervalModel';

/***/ }),

/***/ "./lib/Gantt/model/CalendarModel.js":
/*!******************************************!*\
  !*** ./lib/Gantt/model/CalendarModel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarModel; });
/* harmony import */ var _SchedulerPro_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/model/CalendarModel.js */ "./lib/SchedulerPro/model/CalendarModel.js");
var productName = 'gantt';

/**
 * @module Gantt/model/CalendarModel
 */

/**
 * This class represents a calendar in the Gantt project. It contains a collection of the {@link SchedulerPro.model.CalendarIntervalModel}.
 * Every interval can be either recurrent (regularly repeating in time) or static.
 *
 * Please refer to the [calendars guide](#Gantt/guides/basics/calendars.md) for details
 *
 * @extends SchedulerPro/model/CalendarModel
 *
 * @typings SchedulerPro/model/CalendarModel -> SchedulerPro/model/SchedulerProCalendarModel
 */

class CalendarModel extends _SchedulerPro_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}
CalendarModel._$name = 'CalendarModel';

/***/ }),

/***/ "./lib/Gantt/model/DependencyModel.js":
/*!********************************************!*\
  !*** ./lib/Gantt/model/DependencyModel.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyModel; });
/* harmony import */ var _SchedulerPro_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/model/DependencyModel.js */ "./lib/SchedulerPro/model/DependencyModel.js");
var productName = 'gantt';

/**
 * @module Gantt/model/DependencyModel
 */

/**
 * This class represents a single dependency between the tasks in your Gantt project.
 *
 * ## Subclassing the Dependency class
 *
 * The name of any field in data can be customized in the subclass, see the example below.
 *
 * ```javascript
 * class MyDependencyModel extends DependencyModel {
 *   static get fields() {
 *     return [
 *       { name: 'to', dataSource : 'targetId' },
 *       { name: 'from', dataSource : 'sourceId' }
 *     ];
 *   }
 * }
 * ```
 * @extends SchedulerPro/model/DependencyModel
 *
 * @typings Scheduler/model/DependencyModel -> Scheduler/model/SchedulerDependencyModel
 * @typings SchedulerPro/model/DependencyModel -> SchedulerPro/model/SchedulerProDependencyModel
 */

class DependencyModel extends _SchedulerPro_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  constructor(...args) {
    const [config] = args;

    if (config !== null && config !== void 0 && config.fromTask) {
      config.fromEvent = config.fromTask;
    }

    if (config !== null && config !== void 0 && config.toTask) {
      config.toEvent = config.toTask;
    }

    super(...args);
  }

  get from() {
    var _this$fromEvent;

    return (_this$fromEvent = this.fromEvent) === null || _this$fromEvent === void 0 ? void 0 : _this$fromEvent.id;
  }
  /**
   * The origin task of this dependency.
   *
   * Accepts multiple formats but always returns an {@link Gantt.model.TaskModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-from} instead.
   *
   * @field {Gantt.model.TaskModel} fromTask
   * @accepts {String|Number|Gantt.model.TaskModel}
   * @category Dependency
   */

  /**
   * The destination task of this dependency.
   *
   * Accepts multiple formats but always returns an {@link Gantt.model.TaskModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-to} instead.
   *
   * @field {Gantt.model.TaskModel} toTask
   * @accepts {String|Number|Gantt.model.TaskModel}
   * @category Dependency
   */


  get fromTask() {
    return this.fromEvent;
  }

  set fromTask(task) {
    this.fromEvent = task;
  }

  get to() {
    var _this$toEvent;

    return (_this$toEvent = this.toEvent) === null || _this$toEvent === void 0 ? void 0 : _this$toEvent.id;
  }

  get toTask() {
    return this.toEvent;
  }

  set toTask(task) {
    this.toEvent = task;
  } // Override persistable getter to prevent sending whole task data but sending only the id only
  // TODO: Remove as part of https://github.com/bryntum/support/issues/1955


  get persistableData() {
    const data = super.persistableData,
          {
      fromTask,
      toTask
    } = data;

    if (fromTask) {
      data.fromTask = fromTask.id;
    }

    if (toTask) {
      data.toTask = toTask.id;
    }

    return data;
  }

}
DependencyModel._$name = 'DependencyModel';

/***/ }),

/***/ "./lib/Gantt/model/ProjectModel.js":
/*!*****************************************!*\
  !*** ./lib/Gantt/model/ProjectModel.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Engine_quark_model_gantt_GanttProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/model/gantt/GanttProjectMixin.js */ "./lib/Engine/quark/model/gantt/GanttProjectMixin.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../data/AssignmentStore.js */ "./lib/Gantt/data/AssignmentStore.js");
/* harmony import */ var _data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../data/CalendarManagerStore.js */ "./lib/Gantt/data/CalendarManagerStore.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../data/DependencyStore.js */ "./lib/Gantt/data/DependencyStore.js");
/* harmony import */ var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../data/ResourceStore.js */ "./lib/Gantt/data/ResourceStore.js");
/* harmony import */ var _data_TaskStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/TaskStore.js */ "./lib/Gantt/data/TaskStore.js");
/* harmony import */ var _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AssignmentModel.js */ "./lib/Gantt/model/AssignmentModel.js");
/* harmony import */ var _CalendarModel_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CalendarModel.js */ "./lib/Gantt/model/CalendarModel.js");
/* harmony import */ var _DependencyModel_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./DependencyModel.js */ "./lib/Gantt/model/DependencyModel.js");
/* harmony import */ var _ResourceModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ResourceModel.js */ "./lib/Gantt/model/ResourceModel.js");
/* harmony import */ var _TaskModel_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./TaskModel.js */ "./lib/Gantt/model/TaskModel.js");
/* harmony import */ var _SchedulerPro_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../SchedulerPro/data/mixin/ProjectCrudManager.js */ "./lib/SchedulerPro/data/mixin/ProjectCrudManager.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
















/**
 * @module Gantt/model/ProjectModel
 */

/**
 * This class represents a global project of your Project plan or Gantt - a central place for all data.
 *
 * It holds and links the stores usually used by Gantt:
 *
 * - {@link Gantt/data/TaskStore}
 * - {@link Gantt/data/ResourceStore}
 * - {@link Gantt/data/AssignmentStore}
 * - {@link Gantt/data/DependencyStore}
 * - {@link Gantt/data/CalendarManagerStore}
 * - {@link #config-timeRangeStore TimeRangeStore}
 *
 * The project uses a scheduling engine to calculate dates, durations and such. It is also responsible for
 * handling references between models, for example to link an task via an assignment to a resource. These operations
 * are asynchronous, a fact that is hidden when working in the Gantt UI but which you must know about when performing
 * operations on the data level.
 *
 * When there is a change to data that requires something else to be recalculated, the project schedules a calculation
 * (a commit) which happens moments later. It is also possible to trigger these calculations directly. This flow
 * illustrates the process:
 *
 * 1. Something changes which requires the project to recalculate, for example adding a new task:
 *
 * ```javascript
 * const [task] = project.taskStore.add({ startDate, endDate });
 * ```
 *
 * 2. A recalculation is scheduled, thus:
 *
 * ```javascript
 * task.duration; // <- Not yet calculated
 * ```
 *
 * 3. Calculate now instead of waiting for the scheduled calculation
 *
 * ```javascript
 * await project.commitAsync();
 *
 * task.duration; // <- Now available
 * ```
 *
 * Please refer to [this guide](#Gantt/guides/data/project_data.md) for more information.
 *
 * ## Built in CrudManager
 *
 * Gantt's project has a {@link Scheduler/crud/AbstractCrudManagerMixin CrudManager} built in. Using it is the recommended way of
 * syncing data between Gantt and a backend. Example usage:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     project : {
 *         // Configure urls used by the built in CrudManager
 *         transport : {
 *             load : {
 *                 url : 'php/load.php'
 *             },
 *             sync : {
 *                 url : 'php/sync.php'
 *             }
 *         }
 *     }
 * });
 *
 * // Load data from the backend
 * gantt.project.load()
 * ```
 *
 * For more information on CrudManager, see Schedulers docs on {@link Scheduler/data/CrudManager}.
 * For a detailed description of the protocol used by CrudManager, please see the
 * [Crud manager guide](#Gantt/guides/data/crud_manager.md)
 *
 * You can access the current Project data changes anytime using the {@link #property-changes} property.
 *
 * ## Working with inline data
 *
 * The project provides an {@link #property-inlineData} getter/setter that can
 * be used to manage data from all Project stores at once. Populating the stores this way can
 * be useful if you do not want to use the CrudManager for server communication but instead load data using Axios
 * or similar.
 *
 * ### Getting data
 * ```javascript
 * const data = gantt.project.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * // Get data from server manually
 * const data = await axios.get('/project?id=12345');
 *
 * // Feed it to the project
 * gantt.project.inlineData = data;
 * ```
 *
 * See also {@link #function-loadInlineData}
 *
 * ### Getting changed records
 *
 * You can access the changes in the current Project dataset anytime using the {@link #property-changes} property. It
 * returns an object with all changes:
 * ```
 * const changes = project.changes;
 *
 * console.log(changes);
 *
 * > {
 *   tasks : {
 *       updated : [{
 *           name : 'My task',
 *           id   : 12
 *       }]
 *   },
 *   assignments : {
 *       added : [{
 *           event      : 12,
 *           resource   : 7,
 *           units      : 100,
 *           $PhantomId : 'abc123'
 *       }]
 *     }
 * };
 * ```
 *
 * ## Monitoring data changes
 *
 * While it is possible to listen for data changes on the projects individual stores, it is sometimes more convenient
 * to have a centralized place to handle all data changes. By listening for the {@link #event-change change event} your
 * code gets notified when data in any of the stores changes. Useful for example to keep an external data model up to
 * date:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     project: {
 *         listeners : {
 *             change({ store, action, records }) {
 *                 const { $name } = store.constructor;
 *
 *                 if (action === 'add') {
 *                     externalDataModel.add($name, records);
 *                 }
 *
 *                 if (action === 'remove') {
 *                     externalDataModel.remove($name, records);
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Processing the data loaded from the server
 *
 * If you want to process the data received from the server after loading, you can use
 * the {@link #event-beforeLoadApply} or {@link #event-beforeSyncApply} events:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     project: {
 *         listeners : {
 *             beforeLoadApply({ response }) {
 *                 // do something with load-response object before it is provided to all the project stores
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core/data/stm/StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). By default, it is only used while
 * editing tasks using the task editor, the editor updates tasks live and uses STM to rollback changes if canceled. But
 * you can enable it to track all project store changes:
 *
 * ```javascript
 * // Enable automatic transaction creation and start recording
 * project.stm.autoRecord = true;
 * project.stm.enable();
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * Check out the `undoredo` demo to see it in action.
 *
 * @extends Core/data/Model
 *
 * @mixes SchedulerPro/data/mixin/ProjectCrudManager
 * @mixes Core/mixin/Events
 *
 * @typings SchedulerPro/model/ProjectModel -> SchedulerPro/model/SchedulerProProjectModel
 */

class ProjectModel extends Object(_SchedulerPro_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Engine_quark_model_gantt_GanttProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__["GanttProjectMixin"].derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  //region Config

  /**
   * Silences propagations caused by the project loading.
   *
   * Applying the loaded data to the project occurs in two basic stages:
   *
   * 1. Data gets into the engine graph which triggers changes propagation
   * 2. The changes caused by the propagation get written to related stores
   *
   * Setting this flag to `true` makes the component perform step 2 silently without triggering events causing reactions on those changes
   * (like sending changes back to the server if `autoSync` is enabled) and keeping stores in unmodified state.
   *
   * This is safe if the loaded data is consistent so propagation doesn't really do any adjustments.
   * By default the system treats the data as consistent so this option is `true`.
   *
   * ```js
   * new Gantt({
   *     project : {
   *         // We want scheduling engine to recalculate the data properly
   *         // so then we could save it back to the server
   *         silenceInitialCommit : false,
   *         ...
   *     }
   *     ...
   * })
   * ```
   *
   * @config {Boolean} silenceInitialCommit
   * @default true
   */

  /**
   * This config manages DST correction in the scheduling engine. It only has effect when DST transition hour is
   * working time. Usually DST transition occurs on Sunday, so with non working weekends the DST correction logic
   * is not involved.
   *
   * If **true**, it will add/remove one hour when calculating duration from start/end dates. For example:
   * Assume weekends are working and on Sunday, 2020-10-25 at 03:00 clocks are set back 1 hour. Assume there is a task:
   *
   * ```javascript
   * {
   *     startDate    : '2020-10-20',
   *     duration     : 10,
   *     durationUnit : 'day'
   * }
   * ```
   * It will end on 2020-10-29 23:00. Because of the DST transition Sunday is actually 25 hours long and when the
   * Gantt project calculates the end date it converts days to hours multiplying by 24. If you're setting duration
   * and want task to end on the end of the day you should manually correct for DST, like so:
   *
   * ```javascript
   * {
   *     startDate    : '2020-10-20',
   *     duration     : 10 * 24 + 1,
   *     durationUnit : 'hour'
   * },
   * ```
   *
   * If task has start and end dates it will correct for DST twice:
   *
   * ```javascript
   * {
   *     startDate    : '2020-10-20',
   *     endDate      : '2020-10-30'
   * }
   * ```
   * This task will end on 2020-10-29 22:00 which is a known quirk.
   *
   * If **false**, the Gantt project will not add DST correction which fixes the quirk mentioned above and such task
   * will end on 2020-10-30 exactly, having hours duration of 10 days * 24 hours + 1 hour.
   *
   * Also, for this task days duration will be a floating point number due to extra (or missing) hour:
   *
   * ```javascript
   * task.getDuration('day')  // 10.041666666666666
   * task.getDuration('hour') // 241
   * ```
   *
   * @config {Boolean} adjustDurationToDST
   * @default false
   */
  // TODO: This config is introduced only to make behavior transition smooth. If nobody complains about it for
  // a couple of releases, it should be removed

  /**
   * Set to `true` to enable calculation progress notifications.
   * When enabled, the project fires {@link #event-progress progress} events and the Gantt chart load mask reacts by showing a progress bar for the Engine calculations.
   *
   * **Note**: Enabling progress notifications will impact calculation performance, since it needs to pause calculations to allow the UI to redraw.
   *
   * @config {Boolean} enableProgressNotifications
   * @category Engine
   */

  /**
   * Enables/disables the calculation progress notifications.
   * @member {Boolean} enableProgressNotifications
   * @category Engine
   */

  /**
   * Fired during the Engine calculation if {@link #config-enableProgressNotifications enableProgressNotifications} config is `true`
   * @event progress
   * @param {Number} total The total number of operations
   * @param {Number} remaining The number of remaining operations
   * @param {String} phase The phase of the calculation, either 'storePopulation' when data is getting loaded, or 'propagating' when data is getting calculated
   */
  static get defaults() {
    return {
      /**
       * The number of hours per day (is used when converting the duration from one unit to another).
       * @field {Number} hoursPerDay
       * @default 24
       */

      /**
       * The number of days per week (is used when converting the duration from one unit to another).
       * @field {Number} daysPerWeek
       * @default 7
       */

      /**
       * The number of days per month (is used when converting the duration from one unit to another).
       * @field {Number} daysPerMonth
       * @default 30
       */

      /**
       * The source of the calendar for dependencies (the calendar used for taking dependencies lag into account).
       * Possible values are:
       *
       * - `ToEvent` - successor calendar will be used (default);
       * - `FromEvent` - predecessor calendar will be used;
       * - `Project` - the project calendar will be used.
       *
       * @field {String} dependenciesCalendar
       * @default 'ToEvent'
       */

      /**
       * The project calendar.
       * @config {String|Object|Gantt.model.CalendarModel} calendar
       */

      /**
       * The project calendar.
       * @field {Gantt.model.CalendarModel} calendar
       */

      /**
       * `true` to enable automatic {@link Gantt/model/TaskModel#field-percentDone % done} calculation for summary tasks,
       * `false` to disable it.
       * @field {Boolean} autoCalculatePercentDoneForParentTasks
       * @default true
       */

      /**
       * State tracking manager instance the project relies on
       * @member {Core.data.stm.StateTrackingManager} stm
       */

      /**
       * The {@link Gantt.data.TaskStore store} holding the tasks information.
       *
       * See also {@link Gantt.model.TaskModel}
       * @member {Gantt.data.TaskStore} eventStore
       * @category Models & Stores
       */

      /**
       * A {@link Gantt.data.TaskStore} instance or a config object.
       * @config {Gantt.data.TaskStore|Object} eventStore
       * @category Models & Stores
       */

      /**
       * An alias for the {@link #property-eventStore}.
       *
       * See also {@link Gantt.model.TaskModel}
       * @member {Gantt.data.TaskStore} taskStore
       * @category Models & Stores
       */

      /**
       * An alias for the {@link #config-eventStore}.
       * @config {Gantt.data.TaskStore|Object} taskStore
       * @category Models & Stores
       */

      /**
       * The {@link Gantt.data.DependencyStore store} holding the dependencies information.
       *
       * See also {@link Gantt.model.DependencyModel}
       * @member {Gantt.data.DependencyStore} dependencyStore
       * @category Models & Stores
       */

      /**
       * A {@link Gantt.data.DependencyStore} instance or a config object.
       * @config {Gantt.data.DependencyStore|Object} dependencyStore
       * @category Models & Stores
       */

      /**
       * The {@link Gantt.data.ResourceStore store} holding the resources that can be assigned to the tasks in the task store.
       *
       * See also {@link Gantt.model.ResourceModel}
       * @member {Gantt.data.ResourceStore} resourceStore
       * @category Models & Stores
       */

      /**
       * A {@link Gantt.data.ResourceStore} instance or a config object.
       * @config {Gantt.data.ResourceStore|Object} resourceStore
       * @category Models & Stores
       */

      /**
       * The {@link Gantt.data.AssignmentStore store} holding the assignments information.
       *
       * See also {@link Gantt.model.AssignmentModel}
       * @member {Gantt.data.AssignmentStore} assignmentStore
       * @category Models & Stores
       */

      /**
       * An {@link Gantt.data.AssignmentStore} instance or a config object.
       * @config {Gantt.data.AssignmentStore|Object} assignmentStore
       * @category Models & Stores
       */

      /**
       * The {@link Gantt.data.CalendarManagerStore store} holding the calendars information.
       *
       * See also {@link Gantt.model.CalendarModel}
       * @member {Gantt.data.CalendarManagerStore} calendarManagerStore
       * @category Models & Stores
       */

      /**
       * A {@link Gantt.data.CalendarManagerStore} instance or a config object.
       * @config {Gantt.data.CalendarManagerStore|Object} calendarManagerStore
       * @category Models & Stores
       */

      /**
       * The {@link Core.data.Store store} containing time ranges to be visualized.
       *
       * See also {@link Scheduler.model.TimeSpan}
       * @member {Core.data.Store} timeRangeStore
       * @category Models & Stores
       */

      /**
       * Returns an array of critical paths.
       * Each _critical path_ is an array of critical path nodes.
       * Each _critical path node_ is an object which contains {@link Gantt/model/TaskModel#field-critical critical task}
       * and {@link Gantt/model/DependencyModel dependency} leading to the next critical path node.
       * Dependency is missing if it is the last critical path node in the critical path.
       * To highlight critical paths, enable {@link Gantt/feature/CriticalPaths} feature.
       *
       * ```javascript
       * // This is an example of critical paths structure
       * [
       *      // First path
       *      [
       *          {
       *              event : Gantt.model.TaskModel
       *              dependency : Gantt.model.DependencyModel
       *          },
       *          {
       *              event : Gantt.model.TaskModel
       *          }
       *      ],
       *      // Second path
       *      [
       *          {
       *              event : Gantt.model.TaskModel
       *          }
       *      ]
       *      // and so on....
       * ]
       * ```
       *
       * For more details on the _critical path method_ theory please check
       * this article: https://en.wikipedia.org/wiki/Critical_path_method
       *
       * @member {Array[]} criticalPaths
       */
      // root should be always expanded
      expanded: true
    };
  }

  static get defaultConfig() {
    return {
      /**
       * Deprecated, use {@link #config-taskModelClass}
       * @deprecated Use {@link #config-taskModelClass}
       * @config {Gantt.model.TaskModel} [eventModelClass]
       * @typings {typeof TaskModel}
       */
      eventModelClass: _TaskModel_js__WEBPACK_IMPORTED_MODULE_14__["default"],

      /**
       * The constructor of the event model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-eventStore}
       *
       * @config {Gantt.model.TaskModel} [taskModelClass]
       * @typings {typeof TaskModel}
       */
      taskModelClass: _TaskModel_js__WEBPACK_IMPORTED_MODULE_14__["default"],

      /**
       * The constructor of the dependency model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-dependencyStore}
       *
       * @config {Gantt.model.DependencyModel} [dependencyModelClass]
       * @typings {typeof DependencyModel}
       */
      dependencyModelClass: _DependencyModel_js__WEBPACK_IMPORTED_MODULE_12__["default"],

      /**
       * The constructor of the resource model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-resourceStore}
       *
       * @config {Gantt.model.ResourceModel} [resourceModelClass]
       * @typings {typeof ResourceModel}
       */
      resourceModelClass: _ResourceModel_js__WEBPACK_IMPORTED_MODULE_13__["default"],

      /**
       * The constructor of the assignment model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-assignmentStore}
       *
       * @config {Gantt.model.AssignmentModel} [assignmentModelClass]
       * @typings {typeof AssignmentModel}
       */
      assignmentModelClass: _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_10__["default"],

      /**
       * The constructor of the calendar model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-calendarManagerStore}
       *
       * @config {Gantt.model.CalendarModel} [calendarModelClass]
       * @typings {typeof CalendarModel}
       */
      calendarModelClass: _CalendarModel_js__WEBPACK_IMPORTED_MODULE_11__["default"],

      /**
       * Deprecated, use {@link #config-taskStoreClass}
       * @deprecated
       * @config {Gantt.data.TaskStore}
       * @typings {typeof TaskStore}
       */
      eventStoreClass: _data_TaskStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],

      /**
       * The constructor to create an task store instance with. Should be a class, subclassing the {@link Gantt.data.TaskStore}
       * @config {Gantt.data.TaskStore}
       * @typings {typeof TaskStore}
       */
      taskStoreClass: _data_TaskStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the {@link Gantt.data.DependencyStore}
       * @config {Gantt.data.DependencyStore}
       * @typings {typeof DependencyStore}
       */
      dependencyStoreClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_7__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the {@link Gantt.data.ResourceStore}
       * @config {Gantt.data.ResourceStore}
       * @typings {typeof ResourceStore}
       */
      resourceStoreClass: _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_8__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the {@link Gantt.data.AssignmentStore}
       * @config {Gantt.data.AssignmentStore}
       * @typings {typeof AssignmentStore}
       */
      assignmentStoreClass: _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_5__["default"],

      /**
       * The constructor to create a calendar store instance with. Should be a class, subclassing the {@link Gantt.data.CalendarManagerStore}
       * @config {Gantt.data.CalendarManagerStore}
       * @typings {typeof CalendarManagerStore}
       */
      calendarManagerStoreClass: _data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_6__["default"],

      /**
       * Start date of the project in the ISO 8601 format. Setting this date will constrain all other tasks in the
       * project to start no earlier than it.
       *
       * If this date is not provided, it will be calculated as the earliest date among all tasks.
       *
       * Note that the field always returns a `Date`.
       *
       * @field {Date} startDate
       * @accepts {String|Date}
       */

      /**
       * End date of the project in the ISO 8601 format.
       *
       * If this date is not provided, it will be calculated as the earliest date among all tasks.
       *
       * Note that the field always returns a `Date`.
       *
       * @field {Date} endDate
       * @accepts {String|Date}
       */

      /**
       * The scheduling direction of the project events.
       * The `Forward` direction corresponds to the As-Soon-As-Possible (ASAP) scheduling,
       * `Backward` - to As-Late-As-Possible (ALAP).
       *
       * @field {String} direction
       * @default 'Forward'
       */

      /**
       * The initial data, to fill the {@link #property-taskStore taskStore} with.
       * Should be an array of {@link Gantt.model.TaskModel TaskModels} or configuration objects.
       *
       * @config {Object[]|Gantt.model.TaskModel[]}
       */
      tasksData: null,
      // What is actually used to hold initial tasks, tasksData is transformed in construct()

      /**
       * Alias to {@link #config-tasksData}.
       *
       * @config {Object[]|Gantt.model.TaskModel[]}
       */
      eventsData: null,

      /**
       * The initial data, to fill the {@link #property-dependencyStore dependencyStore} with.
       * Should be an array of {@link Gantt.model.DependencyModel DependencyModels} or configuration objects.
       *
       * @config {Object[]|Gantt.model.DependencyModel[]}
       */
      dependenciesData: null,

      /**
       * The initial data, to fill the {@link #property-resourceStore resourceStore} with.
       * Should be an array of {@link Gantt.model.ResourceModel ResourceModels} or configuration objects.
       *
       * @config {Object[]|Gantt.model.ResourceModel[]}
       */
      resourcesData: null,

      /**
       * The initial data, to fill the {@link #property-assignmentStore assignmentStore} with.
       * Should be an array of {@link Gantt.model.AssignmentModel AssignmentModels} or configuration objects.
       *
       * @config {Object[]|Gantt.model.AssignmentModel[]}
       */
      assignmentsData: null,

      /**
       * The initial data, to fill the {@link #property-calendarManagerStore calendarManagerStore} with.
       * Should be an array of {@link Gantt.model.CalendarModel CalendarModels} or configuration objects.
       *
       * @config {Object[]|Gantt.model.CalendarModel[]}
       */
      calendarsData: null,

      /**
       * Store that holds time ranges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof) for
       * {@link Scheduler.feature.TimeRanges} feature. A store will be automatically created if none is specified.
       * @config {Object|Core.data.Store}
       */
      timeRangeStore: null,

      /**
       * The initial data, to fill the {@link #property-timeRangeStore timeRangeStore} with.
       * Should be an array of {@link Scheduler.model.TimeSpan TimeSpans} or configuration objects.
       *
       * @config {Object[]|Scheduler.model.TimeSpan[]}
       */
      timeRangesData: null,

      /**
       * Set to `true` to reset the undo/redo queues of the internal {@link Core.data.stm.StateTrackingManager}
       * after the Project has loaded. Defaults to `false`
       * @config {Boolean} resetUndoRedoQueuesAfterLoad
       */
      convertEmptyParentToLeaf: false,
      supportShortSyncResponseNote: 'Note: Please consider enabling "supportShortSyncResponse" option to allow less detailed sync responses (https://bryntum.com/docs/gantt/api/Gantt/model/ProjectModel#config-supportShortSyncResponse)'
    };
  } //endregion
  //region Events

  /**
   * Fired when the engine has finished its calculations and the results has been written back to the records.
   *
   * ```javascript
   * gantt.project.on({
   *     dataReady() {
   *        console.log('Calculations finished');
   *     }
   * });
   *
   * gantt.project.taskStore.first.duration = 10;
   *
   * // At some point a bit later it will log 'Calculations finished'
   * ```
   *
   * @event dataReady
   * @param {Gantt.model.ProjectModel} source The project
   */
  //endregion


  construct(...args) {
    const config = args[0] || {}; // put config to arguments (passed to the parent class "construct")

    args[0] = config;

    if ('tasksData' in config) {
      config.eventsData = config.tasksData;
      delete config.tasksData;
    }

    if ('taskStore' in config) {
      config.eventStore = config.taskStore;
      delete config.taskStore;
    } // Maintain backwards compatibility
    // deafult config will be exposed later and won't be applied if a value is exists,
    // but we should sync eventModelClass/eventStoreClass with taskModelClass/taskStoreClass before all further actions
    // to apply the correct value in all mixins that uses eventModelClass/eventStoreClass properties only


    config.eventModelClass = config.taskModelClass || config.eventModelClass || this.getDefaultConfiguration().taskModelClass || this.defaultEventModelClass;
    config.eventStoreClass = config.taskStoreClass || config.eventStoreClass || this.getDefaultConfiguration().taskStoreClass || this.defaultEventStoreClass;

    if (!config.timeRangeStore) {
      config.timeRangeStore = {
        modelClass: _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_4__["default"],
        storeId: 'timeRanges',
        data: config.timeRangesData || []
      };
    }

    super.construct(...args);
  } //region Attaching stores
  // Attach to a store, relaying its change events


  attachStore(store) {
    store.on({
      name: store.$$name,
      change: 'relayStoreChange',
      thisObj: this
    });
  } // Detach a store, stop relaying its change events


  detachStore(store) {
    store && this.detachListeners(store.$$name);
  }

  relayStoreChange(event) {
    /**
     * Fired when data in any of the projects stores changes.
     *
     * Basically a relayed version of each stores own change event, decorated with which store it originates from.
     * See the {@link Core.data.Store#event-change store change event} documentation for more information.
     *
     * @event change
     * @param {Gantt.model.ProjectModel} source This project
     * @param {Core.data.Store} store Affected store
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
     * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
     * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
     */
    return this.trigger('change', _objectSpread(_objectSpread({
      store: event.source
    }, event), {}, {
      source: this
    }));
  } //endregion


  get defaultEventModelClass() {
    return _TaskModel_js__WEBPACK_IMPORTED_MODULE_14__["default"];
  }

  get defaultEventStoreClass() {
    return _data_TaskStore_js__WEBPACK_IMPORTED_MODULE_9__["default"];
  }

  get taskStore() {
    return this.getEventStore();
  }

  get timeRangeStore() {
    return this._timeRangeStore;
  }

  set timeRangeStore(store) {
    const me = this;
    me.detachStore(me._timeRangeStore);
    me._timeRangeStore = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStore(store, _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]);

    if (!me._timeRangeStore.storeId) {
      me._timeRangeStore.storeId = 'timeRanges';
    }

    me.attachStore(me._timeRangeStore);
  }

  async tryInsertChild() {
    return this.tryPropagateWithChanges(() => {
      this.insertChild(...arguments);
    });
  }
  /**
   * Overrides the project owned store identifiers calculation and
   * launches rescheduling.
   * @method setCalculations
   * @param {Object} calculations Object providing new _engine_ fields calculation function names.
   * The object is grouped by store identifiers. For example below code
   * overrides task {@link Gantt/model/TaskModel#field-startDate}, {@link Gantt/model/TaskModel#field-endDate}
   * and {@link Gantt/model/TaskModel#field-duration} calculation so
   * the fields will always simply return their current values:
   *
   * ```javascript
   * // task startDate, endDate and duration will use their userProvidedValue method
   * // which simply returns their current values as-is
   * const oldCalculations = await project.setCalculations({
   *     tasks : {
   *         startDate : "userProvidedValue",
   *         endDate   : "userProvidedValue",
   *         duration  : "userProvidedValue"
   *     }
   * })
   * ```
   * @returns {Promise} Promise that resolves with an object having the overridden calculations.
   * The object can be used to toggle the calculations back in the future:
   * ```javascript
   * // override event duration calculation
   * const oldCalculations = await project.setCalculations({
   *     events : {
   *         duration  : "userProvidedValue"
   *     }
   * })
   * // revert the duration calculation back
   * project.setCalculations(oldCalculations)
   * ```
   */

  /**
   * Returns a calendar of the project. If task has never been assigned a calendar a project's calendar will be returned.
   *
   * @method getCalendar
   * @returns {Gantt.model.CalendarModel}
   */

  /**
   * Sets the calendar of the project. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setCalendar
   * @param {Gantt.model.CalendarModel} calendar The new calendar.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Causes the scheduling engine to re-evaluate the task data and all associated data and constraints
   * and apply necessary changes.
   * @returns {Promise}
   * @function propagate
   */

  /**
   * Suspend {@link #function-propagate propagation} processing. When propagation is suspended,
   * calls to {@link #function-propagate} do not proceed, instead a propagate call is deferred
   * until a matching {@link #function-resumePropagate} is called.
   * @function suspendPropagate
   */

  /**
   * Resume {@link #function-propagate propagation}. If propagation is resumed (calls may be nested
   * which increments a suspension counter), then if a call to propagate was made during suspension,
   * {@link #function-propagate} is executed.
   * @param {Boolean} [trigger] Pass `false` to inhibit automatic propagation if propagate was requested during suspension.
   * @returns {Promise}
   * @function resumePropagate
   */

  /**
   * Accepts a "data package" consisting of data for the projects stores, which is then loaded into the stores.
   *
   * The package can hold data for EventStore, AssignmentStore, ResourceStore and DependencyStore. It uses the same
   * format as when creating a project with inline data:
   *
   * ```javascript
   * await project.loadInlineData({
   *     eventsData       : [...],
   *     resourcesData    : [...],
   *     assignmentsData  : [...],
   *     dependenciesData : [...]
   * });
   * ```
   *
   * After populating the stores it commits the project, starting its calculations. By awaiting `loadInlineData()` you
   * can be sure that project calculations are finished.
   *
   * @function loadInlineData
   * @param {Object} dataPackage A data package as described above
   * @fires load
   * @async
   */

  /**
   * Project changes (CRUD operations to records in its stores) are automatically committed on a buffer to the
   * underlying graph based calculation engine. The engine performs it calculations async.
   *
   * By calling this function, the commit happens right away. And by awaiting it you are sure that project
   * calculations are finished and that references between records are up to date.
   *
   * The returned promise is resolved with an object. If that object has `rejectedWith` set, there has been a conflict and the calculation failed.
   *
   * ```javascript
   * // Move a task in time
   * taskStore.first.shift(1);
   *
   * // Trigger calculations directly and wait for them to finish
   * const result = await project.commitAsync();
   *
   * if (result.rejectedWith) {
   *     // there was a conflict during the scheduling
   * }
   * ```
   *
   * @async
   * @returns {Promise}
   * @function commitAsync
   */
  //region JSON

  /**
   * Returns the data from the records of the projects stores, in a format that can be consumed by `loadInlineData()`.
   *
   * Used by JSON.stringify to correctly convert this record to json.
   *
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData       : [...],
   *     resourcesData    : [...],
   *     assignmentsData  : [...],
   *     dependenciesData : [...]
   * });
   *
   * const json = project.toJSON();
   *
   * // json:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...]
   * }
   * ```
   *
   * Output can be consumed by `loadInlineData()`:
   *
   * ```javascript
   * const json = project.toJSON();
   *
   * // Plug it back in later
   * project.loadInlineData(json);
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    return {
      eventsData: this.eventStore.toJSON(),
      resourcesData: this.resourceStore.toJSON(),
      dependenciesData: this.dependencyStore.toJSON(),
      assignmentsData: this.assignmentStore.toJSON()
    };
  } //endregion

  /**
   * Get or set project data (records from its stores) as a JSON string.
   *
   * Get a JSON string:
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData       : [...],
   *     resourcesData    : [...],
   *     assignmentsData  : [...],
   *     dependenciesData : [...]
   * });
   *
   * const jsonString = project.json;
   *
   * // jsonString:
   * '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * Set a JSON string (to populate the project stores):
   *
   * ```javascript
   * project.json = '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * @property {String}
   */


  get json() {
    return super.json;
  }

  set json(json) {
    if (typeof json === 'string') {
      json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonParse(json);
    }

    this.loadInlineData(json);
  }
  /**
   * Get or set data of project stores. The returned data is identical to what
   * {@link #function-toJSON} returns:
   *
   * ```javascript
   *
   * const data = scheduler.project.inlineData;
   *
   * // data:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...]
   * }
   *
   *
   * // Plug it back in later
   * scheduler.project.inlineData = data;
   * ```
   *
   * @member {Object} inlineData
   */


  get inlineData() {
    return this.toJSON();
  }

  set inlineData(inlineData) {
    this.json = inlineData;
  }

  afterChange(toSet, wasSet) {
    super.afterChange(...arguments);

    if (wasSet.calendar) {
      this.trigger('calendarChange');
    }
  }

  refreshWbs(options) {
    var _me$unfilteredChildre;

    const me = this,
          children = (_me$unfilteredChildre = me.unfilteredChildren) !== null && _me$unfilteredChildre !== void 0 ? _me$unfilteredChildre : me.children;

    if (children && children.length) {
      var _children$0$refreshWb;

      // We leverage the refreshWbs() method of TaskModel (our children) to do the work. This node does not
      // have a wbsValue, so we pass -1 for the index to skip on to just our children.
      (_children$0$refreshWb = children[0].refreshWbs) === null || _children$0$refreshWb === void 0 ? void 0 : _children$0$refreshWb.call(me, options, -1);
    }
  }

}
ProjectModel.applyConfigs = true; // Ignored to keep autogenerated typescript typings w/o errors, otherwise there'll be 2 EffectResolutionResult definitions

/*
 * @typedef EffectResolutionResult
 * @property {Number} Cancel    Stop propagation
 * @property {Number} Restart   Restart propagation
 * @property {Number} Resume    Resume propagation from current state
 */

ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/Gantt/model/ResourceModel.js":
/*!******************************************!*\
  !*** ./lib/Gantt/model/ResourceModel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceModel; });
/* harmony import */ var _SchedulerPro_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/model/ResourceModel.js */ "./lib/SchedulerPro/model/ResourceModel.js");
var productName = 'gantt';

/**
 * @module Gantt/model/ResourceModel
 */

/**
 * This class represents a single resource in your Gantt project.
 *
 * If you want to add or change some fields, describing resources - subclass this class:
 *
 * ```javascript
 * class MyResourceModel extends ResourceModel {
 *
 *   static get fields() {
 *     return [
 *       { name: 'company', type: 'string' }
 *     ]
 *   }
 * }
 * ```
 *
 * See also: {@link Gantt.model.AssignmentModel}
 * @extends SchedulerPro/model/ResourceModel
 *
 * @typings SchedulerPro/model/ResourceModel -> SchedulerPro/model/SchedulerProResourceModel
 */

class ResourceModel extends _SchedulerPro_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}
ResourceModel._$name = 'ResourceModel';

/***/ }),

/***/ "./lib/Gantt/model/TaskModel.js":
/*!**************************************!*\
  !*** ./lib/Gantt/model/TaskModel.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskModel; });
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _SchedulerPro_model_mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../SchedulerPro/model/mixin/PercentDoneMixin.js */ "./lib/SchedulerPro/model/mixin/PercentDoneMixin.js");
/* harmony import */ var _Engine_quark_model_gantt_GanttEvent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Engine/quark/model/gantt/GanttEvent.js */ "./lib/Engine/quark/model/gantt/GanttEvent.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Gantt/data/mixin/PartOfProject.js");
/* harmony import */ var _Baseline_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Baseline.js */ "./lib/Gantt/model/Baseline.js");
/* harmony import */ var _data_Wbs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../data/Wbs.js */ "./lib/Gantt/data/Wbs.js");
/* harmony import */ var _data_field_WbsField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/field/WbsField.js */ "./lib/Gantt/data/field/WbsField.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';










/**
 * @module Gantt/model/TaskModel
 */

const // A utility function to populate a Task's baseline with the Task's default values
applyBaselineDefaults = (task, baselines) => {
  const {
    startDate,
    durationUnit,
    endDate
  } = task;
  return baselines ? baselines.map((baseline, parentIndex) => {
    // Baseline has its own data if at least two of the following are defined.
    // The remaining data, if incomplete, will be calculated in Baseline normalize() method
    const hasData = +Boolean(baseline.startDate) + Boolean(baseline.endDate) + Boolean(baseline.duration) > 1,
          data = _objectSpread({
      task,
      parentIndex
    }, baseline);

    if (!hasData) {
      Object.assign(data, {
        startDate,
        endDate,
        durationUnit
      });
    }

    return data;
  }) : [];
},
      descendingWbsSorter = s => s.field === 'wbsValue' && !s.ascending,
      isReversed = children => {
  for (let firstChildWbs, childWbs, i = 0, n = children.length; i < n; ++i) {
    childWbs = children[i].wbsValue;

    if (childWbs) {
      if (firstChildWbs) {
        return childWbs < firstChildWbs;
      }

      firstChildWbs = childWbs;
    }
  }

  return false;
},
      // Refresh siblings in depth when it's not initial WBS calculation
refreshWbsOptions = {
  deep: true
},
      // Record should not be considered modified by initial assignment of wbsValue
refreshWbsOnJoinOptions = {
  deep: true,
  silent: true
};
/**
 * This class represents a task in your Gantt project. Extend it to add your own custom task fields and methods.
 *
 * ## Subclassing the TaskModel class
 * To subclass the TaskModel and add extra {@link Core.data.Model#property-fields-static} and API methods, please see
 * the snippet below.
 *
 *```javascript
 * class MyTaskModel extends TaskModel {
 *   static get fields() {
 *       return [
 *           { name: 'importantDate', type: 'date' }
 *       ]
 *   }
 *```
 *
 * After creating your own Task model class, configure the {@link Gantt.model.ProjectModel#config-taskModelClass} on
 * Project to use it:
 *
 *```javascript
 * new Gantt({
 *     project : {
 *         taskModelClass : MyTaskModel
 *     }
 * });
 *```
 *
 * ## Creating a new Task programmatically
 *
 * To create a new task programmatically, simply call the TaskModel constructor and pass in any field values.
 *
 * ```javascript
 * const newTask = new TaskModel({
 *     name          : 'My awesome task',
 *     importantDate : new Date(2022, 0, 1),
 *     percentDone   : 80 // So awesome it's almost done
 *     // ...
 * });
 * ```
 *
 * ## Async scheduling
 *
 * A record created from an {@link Gantt/model/TaskModel} is normally part of a {@link Gantt/data/TaskStore}, which in
 * turn is part of a {@link Gantt/model/ProjectModel project}.
 * When dates or the duration of a task is changed, the project performs async calculations of the other related fields
 * (including the field of other tasks affected by the change).
 * For example if {@link #field-duration} is changed, it will recalculate {@link #field-endDate}.
 *
 * As a result of this being an async operation, the values of other fields are not guaranteed to be up to date
 * immediately after a change. To ensure data is up to date, `await` the calculations to finish.
 *
 * For example, `endDate` is not up to date after this operation:
 *
 * ```javascript
 * taskRecord.duration = 5;
 * // taskRecord.endDate not yet calculated
 * ```
 *
 * But if calculations are awaited it is up to date:
 *
 * ```javascript
 * taskRecord.duration = 5;
 * await taskRecord.project.commitAsync();
 * // endDate is calculated
 * ```
 *
 * In case of multiple changes no need to trigger recalculation after each of them:
 *
 * ```javascript
 * // change taskRecord1 start and duration
 * taskRecord1.startDate = '2021-11-15';
 * taskRecord1.duration = 5;
 * // change taskRecord2 duration
 * taskRecord2.duration = 1;
 * // change taskRecord3 finish date
 * taskRecord3.endDate = '2021-11-17';
 *
 * // now when all changes are done trigger rescheduling
 * await taskRecord.project.commitAsync();
 * ```
 *
 * ## Manually vs automatically scheduled tasks
 *
 * A task can be either **automatically** (default) or **manually** scheduled. This is defined by the
 * {@link #field-manuallyScheduled} field. Manually scheduled tasks are not affected by the automatic scheduling
 * process, which means their start/end dates are meant to be changed by user manually. Such tasks are not shifted
 * by their predecessors nor such summary tasks rollup their children start/end dates.
 * While automatically scheduled tasks start/end dates are calculated by the Gantt.
 *
 * ## Start and end dates
 *
 * For all tasks, the end date is non-inclusive: {@link #field-startDate} <= date < {@link #field-endDate}.
 * Example: a task which starts at 2020/07/18 and has 2 days duration, should have the end date: 2020/07/20, **not**
 * 2018/07/19 23:59:59.
 * The start and end dates of tasks in are *points* on the time axis and if you specify that a task starts
 * 01/01/2020 and has 1 day duration, that means the start point is 01/01/2020 00:00 and end point is 02/01/2020 00:00.
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes SchedulerPro/model/mixin/PercentDoneMixin
 *
 * @extends Scheduler/model/TimeSpan
 */


class TaskModel extends _Engine_quark_model_gantt_GanttEvent_js__WEBPACK_IMPORTED_MODULE_5__["GanttEvent"].derive(_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_3__["default"]).mixin(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_6__["default"], _SchedulerPro_model_mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  //region Fields

  /**
   * This static configuration option allows you to control whether an empty parent task should be converted into a
   * leaf. Enable/disable it for a whole class:
   *
   * ```javascript
   * TaskModel.convertEmptyParentToLeaf = false;
   * ```
   *
   * By specifying `true`, all empty parents will be considered leafs. Can also be assigned a configuration object
   * with with the following Boolean properties to customize the behaviour:
   *
   * * `onLoad` - Apply the transformation on load to any parents without children (`children : []`)
   * * `onRemove` - Apply the transformation when all children have been removed from a parent
   *
   * ```javascript
   * TaskModel.convertEmptyParentToLeaf = {
   *     onLoad   : false,
   *     onRemove : true
   * }
   * ```
   *
   * @member {Boolean|Object} convertEmptyParentToLeaf
   * @default true
   * @static
   * @category Parent & children
   */
  static get fields() {
    return [
    /**
     * Unique identifier of task (mandatory)
     * @field {String|Number} id
     * @category Common
     */

    /**
     * Name of the task
     * @field {String} name
     * @category Common
     */

    /**
     * The initial expanded state for a parent task
     * @field {Boolean} expanded
     * @category Common
     */
    {
      name: 'expanded',
      internal: true
    },
    /**
     * A set of resources assigned to this task
     * @field {Set} assigned
     * @readonly
     * @category Common
     */

    /**
     * Start date of the task in ISO 8601 format
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * End date of the task in ISO 8601 format
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The numeric part of the task duration (the number of units).
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * @field {Number} duration
     * @category Scheduling
     */

    /**
     * An encapsulation of the CSS classes to be added to the rendered event element.
     *
     * Always returns a {@link Core.helper.util.DomClassList}, but may still be treated as a string. For
     * granular control of adding and removing individual classes, it is recommended to use the
     * {@link Core.helper.util.DomClassList} API.
     *
     * @field {Core.helper.util.DomClassList} cls
     * @accepts {Core.helper.util.DomClassList|String} cls
     * @category Styling
     */
    {
      name: 'cls',
      serialize: value => {
        return value.isDomClassList ? value.toString() : value;
      },
      persist: true
    },
    /**
     * The current status of a task, expressed as the percentage completed (integer from 0 to 100)
     *
     * UI fields representing this data field are disabled for summary events.
     * See {@link #function-isEditable} for details.
     *
     * @field {Number} percentDone
     * @category Scheduling
     */

    /**
     * The numeric part of the task effort (the number of units). The effort of the "parent" tasks will be automatically set to the sum
     * of efforts of their "child" tasks
     *
     * UI fields representing this data field are disabled for summary events.
     * See {@link #function-isEditable} for details.
     *
     * @field {Number} effort
     * @category Scheduling
     */

    /**
     * The unit part of the task duration, defaults to "day" (days). Valid values are:
     *
     * - "millisecond" - Milliseconds
     * - "second" - Seconds
     * - "minute" - Minutes
     * - "hour" - Hours
     * - "day" - Days
     * - "week" - Weeks
     * - "month" - Months
     * - "quarter" - Quarters
     * - "year"- Years
     *
     * This field is readonly after creation, to change it use the {@link #function-setDuration} call.
     * @field {String} durationUnit
     * @default "day"
     * @category Scheduling
     */

    /**
     * The unit part of the task's effort, defaults to "h" (hours). Valid values are:
     *
     * - "millisecond" - Milliseconds
     * - "second" - Seconds
     * - "minute" - Minutes
     * - "hour" - Hours
     * - "day" - Days
     * - "week" - Weeks
     * - "month" - Months
     * - "quarter" - Quarters
     * - "year"- Years
     *
     * This field is readonly after creation, to change it use the {@link #function-setEffort} call.
     * @field {String} effortUnit
     * @default "hour"
     * @category Scheduling
     */
    {
      name: 'fullEffort',
      persist: false
    },
    /**
     * The effective calendar used by the task.
     * Returns the task own {@link #field-calendar} if provided or the project {@link Gantt.model.ProjectModel#field-calendar calendar}.
     *
     * @field {Gantt.model.CalendarModel} effectiveCalendar
     * @category Scheduling
     * @calculated
     * @readonly
     */

    /**
     * The calendar, assigned to the task. Allows you to set the time when task can be performed.
     *
     * @field {Gantt.model.CalendarModel} calendar
     * @category Scheduling
     */

    /**
     * The getter will yield a {@link Core.data.Store Store} of {@link Gantt.model.Baseline}s.
     *
     * When constructing a task the baselines will be constructed from an array of
     * {@link Gantt.model.Baseline Baseline} data objects.
     * @field {Object[]} baselines
     * @category Features
     */
    {
      name: 'baselines'
    },
    /**
     * A freetext note about the task.
     * @field {String} note
     * @category Common
     */
    {
      name: 'note',
      type: 'string'
    }, {
      name: 'parentId',
      serialize: (value, record) => {
        const eventStore = record.getEventStore(),
              project = record.getProject(); // By default we send root level tasks "parentId" as NULL

        if (eventStore && eventStore.getById(value) === project) {
          value = null;
        }

        return value;
      }
    },
    /**
     * Field storing the task constraint alias or `null` if not constraint set.
     * Valid values are:
     * - "finishnoearlierthan"
     * - "finishnolaterthan"
     * - "mustfinishon"
     * - "muststarton"
     * - "startnoearlierthan"
     * - "startnolaterthan"
     *
     * @field {String|null} constraintType
     * @category Scheduling
     */

    /**
     * Field defining the constraint boundary date or `null` if {@link #field-constraintType} is `null`.
     * @field {String|Date|null} constraintDate
     * @category Scheduling
     */

    /**
     * When set to `true`, the {@link #field-startDate} of the task will not be changed by any of its incoming
     * dependencies or constraints.
     *
     * @field {Boolean} manuallyScheduled
     * @category Scheduling
     */

    /**
     * When set to `true` the task becomes inactive and stops taking part in the project scheduling (doesn't
     * affect linked tasks, rolls up its attributes and affect its assigned resources allocation).
     *
     * @field {Boolean} inactive
     * @category Scheduling
     */

    /**
     * This field defines the scheduling mode for the task. Based on this field some fields of the task
     * will be "fixed" (should be provided by the user) and some - computed.
     *
     * Possible values are:
     *
     * - `Normal` is the default (and backward compatible) mode. It means the task will be scheduled based on
     * information about its start/end dates, task own calendar (project calendar if there's no one) and
     * calendars of the assigned resources.
     *
     * - `FixedDuration` mode means, that task has fixed start and end dates, but its effort will be computed
     * dynamically, based on the assigned resources information. Typical example of such task is - meeting.
     * Meetings typically have pre-defined start and end dates and the more people are participating in the
     * meeting, the more effort is spent on the task. When duration of such task increases, its effort is
     * increased too (and vice-versa). Note: fixed start and end dates here doesn't mean that a user can't
     * update them via GUI, the only field which won't be editable in GUI is the
     * {@link #field-effort effort field}, it will be calculated according to duration and resources assigned to
     * the task.
     *
     * - `FixedEffort` mode means, that task has fixed effort and computed duration. The more resources will be
     * assigned to this task, the less the duration will be. The typical example will be a "paint the walls"
     * task - several painters will complete it faster.
     *
     * - `FixedUnits` mode means, that the assignment level of all assigned resources will be kept as provided
     * by the user, and either {@link #field-effort} or duration of the task is recalculated, based on the
     * {@link #field-effortDriven} flag.
     *
     * @field {String} schedulingMode
     * @category Scheduling
     */

    /**
     * This boolean flag defines what part of task data should be updated in the `FixedUnits` scheduling mode.
     * If it is `true`, then {@link #field-effort} is kept intact, and duration is updated. If it is `false` -
     * vice-versa.
     *
     * @field {Boolean} effortDriven
     * @default false
     * @category Scheduling
     */

    /**
     * A calculated field storing the _early start date_ of the task.
     * The _early start date_ is the earliest possible date the task can start.
     * This value is calculated based on the earliest dates of the task predecessors and the task own
     * constraints. If the task has no predecessors nor other constraints, its early start date matches the
     * project start date.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} earlyStartDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing the _early end date_ of the task.
     * The _early end date_ is the earliest possible date the task can finish.
     * This value is calculated based on the earliest dates of the task predecessors and the task own
     * constraints. If the task has no predecessors nor other constraints, its early end date matches the
     * project start date plus the task duration.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} earlyEndDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing the _late start date_ of the task.
     * The _late start date_ is the latest possible date the task can start.
     * This value is calculated based on the latest dates of the task successors and the task own constraints.
     * If the task has no successors nor other constraints, its late start date matches the project end date
     * minus the task duration.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} lateStartDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing the _late end date_ of the task.
     * The _late end date_ is the latest possible date the task can finish.
     * This value is calculated based on the latest dates of the task successors and the task own constraints.
     * If the task has no successors nor other constraints, its late end date matches the project end date.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} lateEndDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing the _total slack_ (or _total float_) of the task.
     * The _total slack_ is the amount of working time the task can be delayed without causing a delay
     * to the project end.
     * The value is expressed in {@link #field-slackUnit} units.
     *
     * ```javascript
     * // let output slack info to the console
     * console.log(`The ${task.name} task can be delayed for ${task.totalSlack} ${slackUnit}s`)
     * ```
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     *
     * @field {Number} totalSlack
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing unit for the {@link #field-totalSlack} value.
     * @field {String} slackUnit
     * @default "day"
     * @category Scheduling
     */

    /**
     * A calculated field indicating if the task is _critical_.
     * A task considered _critical_ if its delaying causes the project delay.
     * The field value is calculated based on {@link #field-totalSlack} field value.
     *
     * ```javascript
     * if (task.critical) {
     *     Toast.show(`The ${task.name} is critical!`);
     * }
     * ```
     *
     * @field {Boolean} critical
     * @calculated
     * @readonly
     * @category Scheduling
     */
    // NOTE: These are not actually fields, they are never set during task lifespan and only used by crud manager
    // to send changes to the backend
    // Two fields which specify the relations between "phantom" tasks when they are
    // being sent to the server to be created (e.g. when you create a new task containing a new child task).
    // { name : 'phantomId', type : 'string' },
    // { name : 'phantomParentId', type : 'string' },

    /**
     * Child nodes. To allow loading children on demand, specify `children : true` in your data. Omit the field
     * for leaf tasks.
     *
     * Note, if the task store loads data from a remote origin, make sure {@link Core/data/AjaxStore#config-readUrl}
     * is specified, and optionally {@link Core/data/AjaxStore#config-parentIdParamName} is set, otherwise
     * {@link Core/data/Store#function-loadChildren} has to be implemented.
     *
     * @field {Gantt.model.TaskModel[]} children
     * @accepts {Boolean|Object[]|Gantt.model.TaskModel[]}
     * @category Parent & children
     */
    {
      name: 'children',
      persist: false
    },
    /**
     * Set this to true if this task should be shown in the Timeline widget
     * @field {Boolean} showInTimeline
     * @category Features
     */
    {
      name: 'showInTimeline',
      type: 'boolean'
    },
    /**
     * Set this to true to roll up a task to its closest parent
     * @field {Boolean} rollup
     * @category Features
     */
    {
      name: 'rollup',
      type: 'boolean'
    },
    /**
     * The WBS index (e.g. [2, 1, 3]). This field is automatically calculated and maintained by the store. This
     * calculation can be refreshed by calling {@link #function-refreshWbs}.
     * @deprecated 5.0.0 Use {@link #wbsValue} instead
     * @field {Number[]} wbsIndex
     * @category Scheduling
     */
    {
      name: 'wbsIndex',
      type: 'wbs',
      persist: false
    },
    /**
     * The {@link Gantt.data.Wbs WBS} for this task record. This field is automatically calculated and
     * maintained by the store. This calculation can be refreshed by calling {@link #function-refreshWbs}.
     *
     * To get string representation of the WBS value (e.g. '2.1.3'), use {@link Gantt.data.Wbs#property-value}
     * property.
     *
     * @readonly
     * @field {Gantt.data.Wbs} wbsValue
     * @accepts {Gantt.data.Wbs|String}
     * @category Scheduling
     */
    {
      name: 'wbsValue',
      type: 'wbs',
      persist: false
    },
    /**
     * A deadline date for this task. Does not affect scheduling logic.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} deadlineDate
     * @accepts {String|Date}
     * @category Scheduling
     */
    {
      name: 'deadlineDate',
      type: 'date'
    }, // Override TreeNode parentIndex to make it persistable
    {
      name: 'parentIndex',
      type: 'number',
      persist: true
    },
    /**
     * CSS class specifying an icon to apply to the task row
     * @field {String} iconCls
     * @category Styling
     */
    'iconCls',
    /**
     * CSS class specifying an icon to apply to the task bar
     * @field {String} taskIconCls
     * @category Styling
     */
    'taskIconCls',
    /**
     * Specify false to prevent the event from being dragged (if {@link Gantt/feature/TaskDrag} feature is used)
     * @field {Boolean} draggable
     * @default true
     * @category Interaction
     */
    {
      name: 'draggable',
      type: 'boolean',
      persist: false,
      defaultValue: true
    }, // true or false

    /**
     * Specify false to prevent the task from being resized (if {@link Gantt/feature/TaskResize} feature is
     * used). You can also specify 'start' or 'end' to only allow resizing in one direction
     * @field {Boolean|String} resizable
     * @default true
     * @category Interaction
     */
    {
      name: 'resizable',
      persist: false,
      defaultValue: true
    } // true, false, 'start' or 'end'
    ];
  } //endregion
  //region Config


  static get defaultConfig() {
    return {
      baselineModelClass: _Baseline_js__WEBPACK_IMPORTED_MODULE_7__["default"]
    };
  } //endregion


  endBatch() {
    const {
      isPersistable: wasPersistable
    } = this;
    super.endBatch(...arguments); // If this event newly persistable, its assignments are eligible for syncing.

    if (this.isPersistable && !wasPersistable) {
      this.assignments.forEach(assignment => {
        assignment.stores.forEach(s => {
          s.updateModifiedBagForRecord(assignment);
        });
      });
    }
  }
  /**
   * Returns all predecessor dependencies of this task
   * @member {Gantt.model.DependencyModel[]} predecessors
   * @readonly
   */

  /**
   * Returns all successor dependencies of this task
   * @member {Gantt.model.DependencyModel[]} successors
   * @readonly
   */


  get isTask() {
    return true;
  }

  get isTaskModel() {
    return true;
  } // To pass as an event when using a Gantt project with Scheduler Pro


  get isEvent() {
    return true;
  }

  get wbsIndex() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Gantt', '5.0.0', 'The `wbsIndex` field is deprecated, use `wbsValue` instead');
    return this.wbsCode.split('.').map(v => Number(v));
  }

  set wbsIndex(value) {
    this.wbsCode = value.join('.');
  }

  get wbsCode() {
    return String(this.wbsValue);
  }

  set wbsCode(value) {
    this.wbsValue = _data_Wbs_js__WEBPACK_IMPORTED_MODULE_8__["default"].from(value);
  }

  copy(...args) {
    const copy = super.copy(...args); // Clean wbs but do not mark as dirty

    copy.setData('wbsValue', null);
    return copy;
  }
  /**
   * Propagates changes to the dependent tasks. For example:
   *
   * ```js
   * // double a task duration
   * task.duration *= 2;
   * // call commitAsync() to do further recalculations caused by the duration change
   * task.commitAsync().then(() => console.log('Schedule updated'));
   * ```
   *
   * @method commitAsync
   * @returns {Promise}
   * @propagating
   */

  /**
   * Either activates or deactivates the task depending on the passed value.
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method
   * @name setInactive
   * @param {Boolean} inactive `true` to deactivate the task, `false` to activate it.
   * @returns {Promise}
   * @propagating
   */


  get hasBaselines() {
    var _this$baselinesStore;

    const baselinesField = this.fieldMap.baselines;
    return Boolean(((_this$baselinesStore = this.baselinesStore) === null || _this$baselinesStore === void 0 ? void 0 : _this$baselinesStore.count) || this.originalData[baselinesField.dataSource]);
  }
  /**
   * Applies the start/end dates from the task to the corresponding baseline.
   *
   * ```javascript
   * const task = new TaskModel({
   *      name: 'New task',
   *      startDate: '2019-01-14',
   *      endDate: '2019-01-17',
   *      duration: 3,
   *      baselines: [
   *          // Baseline version 1
   *          {
   *              startDate: '2019-01-13',
   *              endDate: '2019-01-16'
   *          },
   *          // Baseline version 2
   *          {
   *              startDate: '2019-01-14',
   *              endDate: '2019-01-17'
   *          },
   *          // Baseline version 3
   *          {
   *              startDate: '2019-01-15',
   *              endDate: '2019-01-18'
   *          }
   *      ]
   * });
   *
   * // Apply the task's start/end dates to the baseline version 3
   * task.setBaseline(3);
   * ```
   * @param {Number} version The baseline version to update
   */


  setBaseline(version) {
    if (version <= 0) {
      return;
    }

    const me = this,
          {
      baselines
    } = me,
          missingBaselines = version - baselines.count; // Add missing baselines up to the passed version

    if (missingBaselines > 0) {
      baselines.add(applyBaselineDefaults(me, new Array(missingBaselines).fill({})));
    } else {
      baselines.getAt(version - 1).set(applyBaselineDefaults(me, [{}])[0]);
    }
  }

  get baselines() {
    const me = this;

    if (!me.baselinesStore) {
      const baselinesField = this.fieldMap.baselines;
      me.baselinesStore = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
        modelClass: me.constructor.getDefaultConfiguration().baselineModelClass,
        data: applyBaselineDefaults(me, me.originalData[baselinesField.dataSource])
      });
    }

    return me.baselinesStore;
  } // TODO: drop and move to the engine, use outgoingDeps everywhere


  get successors() {
    return Array.from(this.outgoingDeps || []);
  }

  set successors(successors) {
    this.outgoingDeps = successors;
  }

  setSuccessors(successors) {
    this.replaceDependencies(successors, true);
  } // Updates either predecessors or successors with a new array, updating existing dependency records and
  // removing existing dependencies not part of current set


  replaceDependencies(dependencyRecords, isSuccessors) {
    const me = this,
          {
      dependencyStore
    } = me.project,
          updated = new Set(),
          toAdd = new Set(),
          toRemove = [],
          currentSet = isSuccessors ? me.outgoingDeps : me.incomingDeps,
          depsArr = Array.from(currentSet); // TODO: All this collecting is added since chronograph
    // cannot handle removing and adding the same records at the moment.
    // We used to have here simple "removing all current & adding provided" approach
    // Collect already existing instances and new ones

    dependencyRecords.forEach(dependency => {
      const existingDep = depsArr.find(isSuccessors ? dep => dep.toEvent === dependency.toEvent : dep => dep.fromEvent === dependency.fromEvent);

      if (existingDep) {
        updated.add(existingDep);
        const data = Object.assign({}, dependency.data);
        delete data[dependency.constructor.idField];
        existingDep.set(data);
      } else {
        toAdd.add(dependency);
      }
    }); // Collect records that should be removed

    currentSet.forEach(dependency => {
      if (!updated.has(dependency)) {
        toRemove.push(dependency);
      }
    }); // remove records

    toRemove.forEach(dependency => dependencyStore.remove(dependency)); // add new records

    toAdd.forEach(dependency => {
      if (isSuccessors) {
        dependency.fromEvent = me;
      } else {
        dependency.toEvent = me;
      }

      dependencyStore.add(dependency);
    });
    return me.commitAsync();
  } // TODO: drop and move to the engine, use outgoingDeps everywhere


  get predecessors() {
    return Array.from(this.incomingDeps || []);
  }

  set predecessors(predecessors) {
    this.incomingDeps = predecessors;
  }

  setPredecessors(predecessors) {
    this.replaceDependencies(predecessors, false);
  }

  get assignments() {
    return super.assignments;
  }

  set assignments(assignments) {
    const me = this,
          {
      assignmentStore
    } = me.project,
          toAdd = [],
          currentAssignments = me.assignments,
          removedAssignments = currentAssignments.filter(current => !assignments.find(newAss => newAss.resource === current.resource));
    assignmentStore.beginBatch();
    assignments.forEach(assignment => {
      const currentAssignment = assignmentStore.getAssignmentForEventAndResource(this, assignment.resource);

      if (currentAssignment) {
        const clonedData = Object.assign({}, assignment.data);
        delete clonedData.id;
        currentAssignment.set(clonedData);
      } // New one
      else {
        assignment.remove();
        toAdd.push(assignment);
      }
    });
    assignmentStore.remove(removedAssignments);
    assignmentStore.add(toAdd);
    assignmentStore.endBatch();
  } //region Is


  get isDraggable() {
    return this.draggable;
  }

  get isResizable() {
    return this.resizable && !this.milestone && !this.isParent;
  } //endregion
  //region Milestone


  get milestone() {
    // a summary task may have zero duration due to working time periods mismatch w/ its children
    // so we operate start and end date pair here
    if (!this.isLeaf) {
      const {
        startDate,
        endDate
      } = this;

      if (startDate && endDate) {
        return endDate.getTime() === startDate.getTime();
      }
    }

    return this.duration === 0;
  } // override `isMilestone` on TimeSpan model and make it to return the same value what `milestone` returns


  get isMilestone() {
    return this.milestone;
  }

  set milestone(value) {
    value ? this.convertToMilestone() : this.convertToRegular();
  }

  async setMilestone(value) {
    return value ? this.convertToMilestone() : this.convertToRegular();
  }
  /**
   * Converts this task to a milestone (start date will match the end date).
   * @propagating
   */


  async convertToMilestone() {
    return this.setDuration(0, this.durationUnit, false);
  }
  /**
   * Converts the milestone task to a regular task with a duration of 1 (keeping current {@link #field-durationUnit}).
   * @propagating
   */


  async convertToRegular() {
    if (this.milestone) {
      return this.setDuration(1, this.durationUnit, false);
    }
  } //endregion
  //region Dependencies

  /**
   * Returns all dependencies of this task (both incoming and outgoing)
   *
   * @property {Gantt.model.DependencyModel[]}
   */


  get allDependencies() {
    return this.dependencies;
  }

  get dependencies() {
    return [...(this.incomingDeps || []), ...(this.outgoingDeps || [])];
  }

  set dependencies(dependencies) {
    const me = this,
          predecessors = [],
          successors = [];
    dependencies === null || dependencies === void 0 ? void 0 : dependencies.forEach(dependency => {
      if (dependency.fromEvent === me || dependency.fromEvent === me.id) {
        successors.push(dependency);
      } else if (dependency.toEvent === me || dependency.toEvent === me.id) {
        predecessors.push(dependency);
      }
    });
    me.setPredecessors(predecessors);
    me.setSuccessors(successors);
  }
  /**
   * Returns all predecessor tasks of a task
   *
   * @property {Gantt.model.TaskModel[]}
   */


  get predecessorTasks() {
    return [...(this.incomingDeps || [])].map(dependency => dependency.fromEvent);
  }
  /**
   * Returns all successor tasks of a task
   *
   * @readonly
   * @property {Gantt.model.TaskModel[]}
   */


  get successorTasks() {
    return [...(this.outgoingDeps || [])].map(dependency => dependency.toEvent);
  } //endregion
  //region Calculated fields

  /**
   * Returns count of all sibling nodes (including their children).
   * @property {Number}
   */


  get previousSiblingsTotalCount() {
    let task = this.previousSibling,
        count = this.parentIndex;

    while (task) {
      count += task.descendantCount;
      task = task.previousSibling;
    }

    return count;
  }
  /**
   * Returns the sequential number of the task. A sequential number means the ordinal position of the task in the
   * total dataset, regardless of its nesting level and collapse/expand state of any parent tasks. The root node has a
   * sequential number equal to 0.
   *
   * For example, in the following tree data sample sequential numbers are specified in the comments:
   *
   *        root : {
   *            children : [
   *                {   // 1
   *                    leaf : true
   *                },
   *                {       // 2
   *                    children : [
   *                        {   // 3
   *                            children : [
   *                                {   // 4
   *                                    leaf : true
   *                                },
   *                                {   // 5
   *                                    leaf : true
   *                                }
   *                            ]
   *                        }]
   *                },
   *                {   // 6
   *                    leaf : true
   *                }
   *            ]
   *        }
   *
   * If we will collapse some of the parent tasks, sequential number of collapsed tasks won't change.
   *
   * @property {Number}
   */


  get sequenceNumber() {
    let code = 0,
        task = this; // TODO: store keeps allIndex, children are added before parents which makes order wrong. if that is changed
    // TODO: it can be used instead of calculating sequenceNumber

    while (task.parent) {
      code += task.previousSiblingsTotalCount + 1;
      task = task.parent;
    }

    return code;
  } //endregion
  //region Project related methods


  get isSubProject() {
    return false;
  } // TODO: cache project
  // /**
  //  * Returns the {@link Gantt.model.SubProjectModel project} instance, associated with this task if this task belongs to a project
  //  *
  //  * @private
  //  * @internal
  //  * @return {Gantt.model.SubProjectModel} project
  //  */


  get subProject() {
    const me = this;
    let project = null;

    if (me.isProject) {
      // TODO: implement is project
      project = me;
    } else {
      me.bubbleWhile(t => {
        if (t.isProject) {
          project = t;
        }

        return !project;
      });
    }

    return project;
  } //endregion

  /**
   * Property which encapsulates the effort's magnitude and units.
   *
   *
   * UI fields representing this property are disabled for summary events.
   * See {@link #function-isEditable} for details.
   *
   * @property {Core.data.Duration}
   */


  get fullEffort() {
    return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      unit: this.effortUnit,
      magnitude: this.effort
    });
  }

  set fullEffort(effort) {
    this.setEffort(effort.magnitude, effort.unit);
  } //region Scheduler Pro compatibility

  /**
   * Returns all resources assigned to an event.
   *
   * @property {Gantt.model.ResourceModel[]}
   * @readonly
   */


  get resources() {
    // Only include valid resources, to not have nulls in the result
    return this.assignments.reduce((resources, assignment) => {
      assignment.resource && resources.push(assignment.resource);
      return resources;
    }, []);
  } //endregion

  /**
   * A `Set<Gantt.model.DependencyModel>` of the outgoing dependencies for this task
   * @member {Set} outgoingDeps
   * @readonly
   */

  /**
   * A `Set<Gantt.model.DependencyModel>` of the incoming dependencies for this task
   * @member {Set} incomingDeps
   * @readonly
   */

  /**
   * An array of the assignments, related to this task
   * @member {Gantt.model.AssignmentModel[]} assignments
   * @readonly
   */

  /**
   * If given resource is assigned to this task, returns a {@link Gantt.model.AssignmentModel} record.
   * Otherwise returns `null`
   *
   * @method getAssignmentFor
   * @param {Gantt.model.ResourceModel} resource The instance of {@link Gantt.model.ResourceModel}
   *
   * @return {Gantt.model.AssignmentModel|null}
   */

  /**
   * This method assigns a resource to this task.
   *
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method assign
   * @param {Gantt.model.ResourceModel} resource The instance of {@link Gantt.model.ResourceModel}
   * @param {Number} [units=100] The `units` field of the new assignment
   *
   * @returns {Promise}
   * @propagating
   */

  /**
   * This method unassigns a resource from this task.
   *
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method unassign
   * @param {Gantt.model.ResourceModel} resource The instance of {@link Gantt.model.ResourceModel}
   *
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the calendar of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setCalendar
   * @param {Gantt.model.CalendarModel} calendar The new calendar. Provide `null` to return back to the project calendar.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Returns the task calendar.
   *
   * @method getCalendar
   * @returns {Gantt.model.CalendarModel} The task calendar.
   */

  /**
   * Sets the start date of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * Note, that the actually set start date may be adjusted, according to the calendar, by skipping the non-working time forward.
   *
   * @method setStartDate
   * @param {Date} date The new start date.
   * @param {Boolean} [keepDuration=true] Whether to keep the duration (and update the end date), while changing the start date, or vice-versa.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the end date of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * Note, that the actually set end date may be adjusted, according to the calendar, by skipping the non-working time backward.
   *
   * @method setEndDate
   * @param {Date} date The new end date.
   * @param {Boolean} [keepDuration=false] Whether to keep the duration (and update the start date), while changing the end date, or vice-versa.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Updates the duration (and optionally unit) of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setDuration
   * @param {Number} duration New duration value
   * @param {String} [unit] New duration unit
   * @returns {Promise}
   * @propagating
   */

  /**
   * Updates the effort (and optionally unit) of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setEffort
   * @param {Number} effort New effort value
   * @param {String} [unit] New effort unit
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the constraint type and (optionally) constraining date to the task.
   *
   * @method setConstraint
   * @param {String} constraintType Constraint type, please refer to the {@link Gantt.model.TaskModel#field-constraintType} for the valid values.
   * @param {Date}   [constraintDate] Constraint date.
   * @returns {Promise}
   * @propagating
   */
  //region Normalization


  normalize() {// Do nothing, normalization now happens as part of initial propagate and should use calendar anyway
  }

  inSetNormalize(field) {// Do nothing, normalization now happens as part of initial propagate and should use calendar anyway
  }
  /**
   * Not (yet) supported by the underlying scheduling engine
   * @function setStartEndDate
   * @hide
   * @param {Date} start The new start date
   * @param {Date} end The new end date
   */
  //endregion


  joinStore(store) {
    const me = this;

    if (!me.wbsValue) {
      var _me$taskStore, _me$nextSibling, _me$previousSibling;

      if ((_me$taskStore = me.taskStore) !== null && _me$taskStore !== void 0 && _me$taskStore.isLoadingData || !((_me$nextSibling = me.nextSibling) !== null && _me$nextSibling !== void 0 && _me$nextSibling.wbsValue || (_me$previousSibling = me.previousSibling) !== null && _me$previousSibling !== void 0 && _me$previousSibling.wbsValue)) {
        // If we are being loaded or have no siblings, then we can just process this node and its children.
        me.refreshWbs(refreshWbsOnJoinOptions);
      } else {
        // Otherwise, we need to also refresh this node's siblings. Since we only come here if we have a
        // sibling, we can be sure we also have a parent.
        me.parent.refreshWbs(refreshWbsOptions, -1);
      }
    }

    super.joinStore(store);
  }
  /**
   * Refreshes the {@link #field-wbsValue} of this record and its children. This is rarely needed but may be required
   * after a complex series of filtering, inserting, or removing nodes. In particular, removing nodes does create a
   * gap in `wbsValue` values that may be undesirable.
   * @param {Object} [options] A set of options for refreshing.
   * @param {Boolean} [options.deep=true] Pass `false` to not update the `wbsValue` of this node's children.
   * @param {Boolean} [options.silent=false] Pass `true` to update the `wbsValue` silently (no events). This is done
   * at load time since this value represents the clean state. Passing `true` also has the effect of not marking the
   * change as a dirty state on the record, in the case where `wbsValue` has been flagged as `persist: true`.
   * @param {Number} [index] The index of this node in its parent's children array. Pass -1 to ignore this node's
   * `wbsValue` and only operate on children (if `options.deep`).
   */


  refreshWbs(options, index) {
    var _options$deep;

    const me = this,
          {
      parent
    } = me;

    if (parent && index !== -1 && me.fieldMap.wbsValue) {
      var _ref, _index;

      index = ((_ref = (_index = index) !== null && _index !== void 0 ? _index : me.unfilteredIndex) !== null && _ref !== void 0 ? _ref : me.parentIndex) + 1;
      const wbs = parent.isRoot ? new _data_Wbs_js__WEBPACK_IMPORTED_MODULE_8__["default"](index) : parent.wbsValue.append(index);

      if (options !== null && options !== void 0 && options.silent) {
        me.setData('wbsValue', wbs);
      } else {
        me.set('wbsValue', wbs);
      }
    }

    if ((_options$deep = options === null || options === void 0 ? void 0 : options.deep) !== null && _options$deep !== void 0 ? _options$deep : true) {
      var _me$unfilteredChildre;

      const children = (_me$unfilteredChildre = me.unfilteredChildren) !== null && _me$unfilteredChildre !== void 0 ? _me$unfilteredChildre : me.children,
            n = (children === null || children === void 0 ? void 0 : children.length) || 0;

      if (n) {
        var _me$taskStore2, _me$taskStore2$sorter;

        // The array may be reversed, and if it is, then the sorter has been applied and we need to reverse
        // the WBS assignment to match
        const reverse = isReversed(children) && ((_me$taskStore2 = me.taskStore) === null || _me$taskStore2 === void 0 ? void 0 : (_me$taskStore2$sorter = _me$taskStore2.sorters) === null || _me$taskStore2$sorter === void 0 ? void 0 : _me$taskStore2$sorter.findIndex(descendingWbsSorter)) === 0;

        for (let i = 0; i < n; ++i) {
          children[i].refreshWbs(options, reverse ? n - i - 1 : i);
        }
      }
    }
  }

  async tryInsertChild() {
    return this.getProject().tryPropagateWithChanges(() => {
      this.insertChild(...arguments);
    });
  }
  /**
   * Defines if the given task field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines:
   * - {@link #field-earlyStartDate}, {@link #field-earlyEndDate}, {@link #field-lateStartDate},
   * {@link #field-lateEndDate}, {@link #field-totalSlack} as not editable;
   * - {@link #field-effort}, {@link #property-fullEffort}, {@link #field-percentDone} as not editable for summary tasks;
   * - {@link #field-endDate}, {@link #field-duration} and {@link #property-fullDuration} fields
   *   as not editable for summary tasks except the {@link #field-manuallyScheduled manually scheduled} ones.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the task has no such field.
   */


  isEditable(fieldName) {
    switch (fieldName) {
      // r/o fields
      case 'earlyStartDate':
      case 'earlyEndDate':
      case 'lateStartDate':
      case 'lateEndDate':
      case 'totalSlack':
        return false;
      // disable effort & percentDone editing for summary tasks

      case 'effort':
      case 'fullEffort':
      case 'percentDone':
      case 'renderedPercentDone':
        return this.isLeaf;
      // end/duration is allowed to edit for leafs and manually scheduled summaries

      case 'endDate':
      case 'duration':
      case 'fullDuration':
        return this.isLeaf || this.manuallyScheduled;
    }

    return super.isEditable(fieldName);
  }

  isFieldModified(fieldName) {
    if (fieldName === 'fullEffort') {
      return super.isFieldModified('effort') || super.isFieldModified('effortUnit');
    }

    return super.isFieldModified(fieldName);
  }

}
TaskModel.convertEmptyParentToLeaf = true; // TaskModel.$meta.fields.map.wbsCode.defineAccessor(TaskModel.prototype, /* force = */true);

TaskModel._$name = 'TaskModel';

/***/ }),

/***/ "./lib/Gantt/util/ProjectGenerator.js":
/*!********************************************!*\
  !*** ./lib/Gantt/util/ProjectGenerator.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectGenerator; });
/* harmony import */ var _Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
var productName = 'gantt';



/**
 * @module Gantt/util/ProjectGenerator
 */

const today = new Date(),
      firstDateOfThisYear = new Date(today.getFullYear(), 0, 1),
      rnd = new _Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_2__["default"]();

function getNum(id, token) {
  return parseInt('' + id + token);
}
/**
 * An internal utility class which generates sample project data for Examples and Tests.
 */


class ProjectGenerator {
  static async generateAsync(requestedTaskCount, maxProjectSize, progressCallback = null, startDate = firstDateOfThisYear, log = true) {
    const config = {
      startDate,
      tasksData: [],
      dependenciesData: []
    },
          blockCount = Math.ceil(requestedTaskCount / 10),
          projectSize = Math.ceil(maxProjectSize / 10),
          generator = this.generateBlocks(blockCount, projectSize, config.startDate);
    let count = 0,
        duration = 0,
        taskCount = 0,
        dependencyCount = 0;
    log && console.time('generate');

    for (const block of generator) {
      config.tasksData.push(...block.tasksData);
      config.dependenciesData.push(...block.dependenciesData);

      if (block.projectDuration) {
        duration = Math.max(block.projectDuration, duration);
      }

      taskCount += block.taskCount;
      dependencyCount += block.dependencyCount;

      if (++count % 1000 === 0) {
        progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(taskCount, dependencyCount, false);
        await _Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].animationFrame();
      }
    }

    progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(taskCount, dependencyCount, true);
    config.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(config.startDate, Math.max(duration, 30), 'days');
    log && console.timeEnd('generate');
    return config;
  }

  static *generateBlocks(count, projectSize, startDate) {
    let currentId = 1,
        dependencyId = 1,
        projectDuration = 0,
        blockDuration = 0;

    function rndDuration(addToTotal = true) {
      const value = rnd.nextRandom(5) + 2;

      if (addToTotal) {
        blockDuration += value;
      }

      return value;
    } // TODO : Dates/duration should be correct from start to avoid initial normalization of those?


    for (let i = 0; i < count; i++) {
      const blockStartId = currentId,
            block = {
        tasksData: [{
          id: currentId++,
          name: 'Parent ' + blockStartId,
          startDate,
          expanded: true,
          children: [{
            id: currentId++,
            name: 'Sub-parent ' + getNum(blockStartId, 1),
            startDate,
            expanded: true,
            children: [{
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 11),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }, {
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 12),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }, {
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 13),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }, {
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 14),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }]
          }, {
            id: currentId++,
            name: 'Sub-parent ' + getNum(blockStartId, 2),
            startDate,
            //duration    : rndDuration(false),
            //percentDone : rnd.nextRandom(90) + 10,
            expanded: true,
            children: [{
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 21),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }, {
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 22),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }, {
              id: currentId++,
              name: 'Task ' + getNum(blockStartId, 23),
              startDate,
              duration: rndDuration(),
              percentDone: rnd.nextRandom(100)
            }]
          }]
        }],
        dependenciesData: [{
          id: dependencyId++,
          fromEvent: blockStartId + 2,
          toEvent: blockStartId + 3
        }, {
          id: dependencyId++,
          fromEvent: blockStartId + 3,
          toEvent: blockStartId + 4
        }, {
          id: dependencyId++,
          fromEvent: blockStartId + 4,
          toEvent: blockStartId + 5
        }, {
          id: dependencyId++,
          fromEvent: blockStartId + 5,
          toEvent: blockStartId + 7
        }, {
          id: dependencyId++,
          fromEvent: blockStartId + 7,
          toEvent: blockStartId + 8
        }, {
          id: dependencyId++,
          fromEvent: blockStartId + 8,
          toEvent: blockStartId + 9
        }],
        taskCount: 10,
        dependencyCount: 5
      };
      projectDuration += blockDuration;
      blockDuration = 0;
      block.projectDuration = projectDuration;

      if (i % projectSize !== 0) {
        block.dependenciesData.push({
          id: dependencyId++,
          fromEvent: blockStartId - 2,
          toEvent: blockStartId + 2,
          type: 2,
          lag: 0,
          lagUnit: 'd'
        });
        block.dependencyCount++;
      } else {
        projectDuration = 0;
      }

      currentId++;
      yield block;
    }
  }

}
ProjectGenerator._$name = 'ProjectGenerator';

/***/ }),

/***/ "./lib/Gantt/util/ResourceAssignmentParser.js":
/*!****************************************************!*\
  !*** ./lib/Gantt/util/ResourceAssignmentParser.js ***!
  \****************************************************/
/*! exports provided: parse, compose, normalize, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize; });
/* harmony import */ var _Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/util/Parser.js */ "./lib/Core/util/Parser.js");
var productName = 'gantt';

const {
  defineParser,
  alt,
  seq,
  string,
  regexp,
  succeed,
  red,
  isSuccess
} = _Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_0__["default"];
/**
 * @module Gantt/util/ResourceAssignmentParser
 */

/**
 * Consumes string while it won't hit [ or , character, value parsed will be trimmed of spaces
 *
 * Example: Maxim Bazhenov [100%] rest -> Maxim Bazhenov
 */

const resourceNamePEG = defineParser(red(regexp('[^\\[\\,]+'), name => ({
  resourceName: name.trim(),
  units: 100,
  match: name
})));
/**
 * Consumes string while it provides numbers or spaces, value parsed them will be filtered of spaces
 * and just compacted number will be used.
 *
 * Example: 12 34 0 rest -> 12340
 */

const integerPEG = defineParser(red(regexp('[0-9\\s]+'), value => ({
  value: value.split(/\s*/).join(''),
  match: value
})));
/**
 * Consumes one character either (decimal separator) '.' or ','
 *
 * Example: , rest -> ,
 */

const decimalSeparatorPEG = defineParser(red(alt(string('.'), string(',')), value => ({
  value,
  match: value
})));
/**
 * Consumes units number which might be given as:
 * - number with integer, decimal separator and fractional parts
 * - decimal separator and fractional part, so integer part will be considered 0
 * - just integer
 * value parsed will be transformed into Number type
 *
 * Example:
 * 10.2 rest -> 10.2
 * .2 rest -> 0.2
 * 100 rest -> 100
 */

const unitsNumberPEG = defineParser(alt(red(seq(() => integerPEG, () => decimalSeparatorPEG, () => integerPEG), (integer, sep, fractional) => ({
  value: Number(`${integer.value}.${fractional.value}`),
  match: [integer.match, sep.match, fractional.match].join('')
})), red(seq(() => decimalSeparatorPEG, () => integerPEG), (sep, fractional) => ({
  value: Number(`0.${fractional.value}`),
  match: [sep.match, fractional.match].join('')
})), red(() => integerPEG, value => ({
  value: Number(`${value.value}`),
  match: value.match
}))));
/**
 * Consumes units with %, strips spaces between units number and % character.
 *
 * Example:
 * 70.5  % rest -> 70.5
 */

const unitsPersentagePEG = defineParser(alt(red(seq(() => unitsNumberPEG, regexp('\\s*\\%')), (units, perc) => ({
  value: units.value,
  match: [units.match, perc].join('')
})), red(() => unitsNumberPEG, units => ({
  value: units.value,
  match: units.match
}))));
/**
 * Consumes units designation string, which should look like [ units with or without % ].
 * Strips spaces before and after [, ] characters.
 *
 * Example:
 * [ 70.2 % ] rest -> 70.2
 */

const unitsDesignationPEG = defineParser(red(seq(regexp('\\s*\\[\\s*'), () => unitsPersentagePEG, regexp('\\s*\\]')), (startSep, units, endSep) => ({
  units: units.value,
  match: [startSep, units.match, endSep].join('')
})));
/**
 * Consumes just single , character stripping spaces before and after
 *
 * Example:
 *     ,     rest -> ,
 */

const commaPEG = defineParser(red(regexp('\\s*,\\s*'), value => ({
  value,
  match: value
})));
/**
 * Consumes resource assignment string which consists of resources assignment entries separated by , character.
 * Each entry contains following parts:
 * - resource name (mandatory)
 * - units designation (optional, default is 100)
 *
 * Example:
 * Maxim Bazhenov, Mats Bryntse [90], Johan Isaksson [50 %] -> Successful parse result
 *
 * See {@link #function-parse} for parse result analysis
 */

const raPEG = defineParser(alt(seq(() => resourceNamePEG, () => unitsDesignationPEG, alt(seq(() => commaPEG, () => raPEG), succeed(''))), seq(() => resourceNamePEG, alt(seq(() => commaPEG, () => raPEG), succeed('')))));
/**
 * Parses resource assignment string into structured set of objects
 *
 * The string format is: `Resource Name [Units%], Other name, ...` where units part is optional as well as % sign
 *
 * @return {Object} Structured information about parsed assignments
 */

const parse = str => {
  let gotSuccess = false,
      result = [],
      rest = '';
  raPEG(str, possibleResult => {
    if (isSuccess(possibleResult)) {
      const [, structuredResult, unstracturedRest] = possibleResult;

      if (structuredResult.length > result.length) {
        result = structuredResult;
        rest = unstracturedRest;
        gotSuccess = true;
      }
    }
  });
  let position = 0;
  return gotSuccess ? {
    rest,
    assignments: result.reduce((result, part) => {
      let currentResource;

      if (typeof part == 'object') {
        if (Object.prototype.hasOwnProperty.call(part, 'resourceName')) {
          currentResource = Object.assign({
            position
          }, part);
          result.push(currentResource);
        } else {
          currentResource = result[result.length - 1];

          if (Object.prototype.hasOwnProperty.call(part, 'units')) {
            currentResource.units = part.units;
          }

          currentResource.match += part.match;
        }

        position += part.match.length;
      }

      return result;
    }, [])
  } : false;
};
/**
 * Composes parsable string from parse result object
 *
 * @param {Object} result Parse result like object
 * @param {Boolean} [exactIfPossible=false] Set to true to compose exactly like it was given to {@link #function-parse} and if parse result reverse composition information is available.
 * @return {String}
 */

const compose = (parseResult, exactIfPossible = false) => {
  let result = '';

  if (parseResult.assignments) {
    result += parseResult.assignments.reduce((str, {
      resourceName,
      units,
      match
    }) => {
      if (match && exactIfPossible) {
        str += match;
      } else {
        str += (str.length ? ', ' : '') + `${resourceName} [${units}%]`;
      }

      return str;
    }, result);
  }

  if (parseResult.rest) {
    result += parseResult.rest;
  }

  if (!exactIfPossible) {
    result = result.trim();
  }

  return result;
};
/**
 * Normalizes the given string by parsing it and recomposing it back thus omitting all optional parts
 *
 * @param {String} str
 * @return {String}
 */

const normalize = str => compose(parse(str));
/* harmony default export */ __webpack_exports__["default"] = ({
  parse,
  compose,
  normalize
});

/***/ }),

/***/ "./lib/Gantt/view/Gantt.js":
/*!*********************************!*\
  !*** ./lib/Gantt/view/Gantt.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Gantt; });
/* harmony import */ var _GanttBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GanttBase.js */ "./lib/Gantt/view/GanttBase.js");
/* harmony import */ var _Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Grid/feature/RowReorder.js */ "./lib/Grid/feature/RowReorder.js");
/* harmony import */ var _Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Scheduler/feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony import */ var _Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Scheduler/feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony import */ var _Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Scheduler/feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Scheduler/feature/NonWorkingTime.js */ "./lib/Scheduler/feature/NonWorkingTime.js");
/* harmony import */ var _Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony import */ var _Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Scheduler/feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony import */ var _SchedulerPro_feature_PercentBar_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../SchedulerPro/feature/PercentBar.js */ "./lib/SchedulerPro/feature/PercentBar.js");
/* harmony import */ var _feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../feature/CellEdit.js */ "./lib/Gantt/feature/CellEdit.js");
/* harmony import */ var _feature_CriticalPaths_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../feature/CriticalPaths.js */ "./lib/Gantt/feature/CriticalPaths.js");
/* harmony import */ var _feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../feature/Dependencies.js */ "./lib/Gantt/feature/Dependencies.js");
/* harmony import */ var _feature_TaskCopyPaste_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../feature/TaskCopyPaste.js */ "./lib/Gantt/feature/TaskCopyPaste.js");
/* harmony import */ var _feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../feature/TaskDrag.js */ "./lib/Gantt/feature/TaskDrag.js");
/* harmony import */ var _feature_TaskDragCreate_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../feature/TaskDragCreate.js */ "./lib/Gantt/feature/TaskDragCreate.js");
/* harmony import */ var _feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../feature/TaskEdit.js */ "./lib/Gantt/feature/TaskEdit.js");
/* harmony import */ var _feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../feature/TaskMenu.js */ "./lib/Gantt/feature/TaskMenu.js");
/* harmony import */ var _feature_TaskResize_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../feature/TaskResize.js */ "./lib/Gantt/feature/TaskResize.js");
/* harmony import */ var _feature_TaskTooltip_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../feature/TaskTooltip.js */ "./lib/Gantt/feature/TaskTooltip.js");
var productName = 'gantt';
 // Based on thin GridBase, need to pull in default Grid features also











 // For checkbox selection mode




















/**
 * @module Gantt/view/Gantt
 */

/**
 * <h2>Summary</h2>
 * The <b>Gantt</b> widget is the main component that visualizes the project data contained in a
 *  {@link Gantt.model.ProjectModel ProjectModel} instance. The Gantt view is implemented as a TreeGrid consisting
 *  of a left section showing the task hierarchy (or WBS) and a right section showing a graphical representation of the tasks on the time axis.
 *  Task relationships (or "dependencies") are rendered as arrows between the tasks and in the background you can (optionally) render non-working time too.
 *
 * The view is very interactive by default:
 *  * hovering over elements shows informative tooltips
 *  * right-clicking various elements shows context menus
 *  * double-clicking the task name shows an inline editor
 *  * double-clicking a task bar opens a detailed task editor popup
 *  * task bars can be dragged and resized
 *  * task progress can be changed by drag drop
 *  * task dependencies can be created by drag drop
 *
 * The Gantt view is very easy to use and is fully functional with minimal configuration yet
 * it is highly configurable through many configuration options and features.
 *
 * The minimum configuration consists of a {@link #config-project} and {@link Grid.view.Grid#config-columns}.
 * (If you only want to show the "Name" column, you can even omit `columns` as it's the default column set.)
 *
 * {@inlineexample Gantt/view/Gantt.js}
 *
 * <h2>Configuring data for Gantt</h2>
 * The central place for all data visualized in the Gantt chart is the {@link Gantt.model.ProjectModel ProjectModel} instance, passed as the {@link #config-project}
 * configuration option when configuring the Gantt.
 *
 * For details related to the Gantt data structure / updating data / loading and saving data to the server,
 * adding custom fields and other information, please refer to the
 * [Project data guide](#Gantt/guides/data/project_data.md).
 *
 * <h2>Configuring columns</h2>
 * The only mandatory column is the <code>name</code> column which is of type {@link Gantt.column.NameColumn NameColumn}.
 * It is a tree column that shows the project WBS structure, and allows inline editing of the
 * {@link Gantt.model.TaskModel#field-name} field.
 *
 * The Gantt chart ships with lots of predefined columns (such as {@link Gantt.column.PercentDoneColumn PercentDoneColumn}) but you can of course add your own columns too, showing any additional data in your data model.
 *
 * {@inlineexample Gantt/view/GanttColumns.js}
 *
 * <h2>Advanced configurations</h2>
 * Almost any aspect of Bryntum Gantt can be configured. The included examples cover most of the supported configuration options.
 * To see some of the features in action, please click on the links below:
 *
 *  * [Labels](../examples/labels/)
 *  * [Tooltips](../examples/tooltips)
 *  * [Time Ranges](../examples/timeranges/)
 *  * [Resource Picker](../examples/resourceassignment/)
 *  * [Task Menu](../examples/taskmenu/)
 *  * [Task Editor](../examples/taskeditor/)
 *  * [Undo/Redo](../examples/undoredo/)
 *  * [Advanced](../examples/advanced)
 *
 * @extends Gantt/view/GanttBase
 */

class Gantt extends _GanttBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * **This config is not used in the Gantt**
   * @private
   * @config {Scheduler.crud.AbstractCrudManagerMixin} crudManagerClass
   */

  /**
   * **This config is not used in the Gantt. Please use {@link #config-project} config instead**
   * @private
   * @config {Object|Scheduler.crud.AbstractCrudManagerMixin} crudManager
   */
  static get $name() {
    return 'Gantt';
  } // Factoryable type name


  static get type() {
    return 'gantt';
  }

} // Register this widget type with its Factory

Gantt.initClass();
Gantt._$name = 'Gantt';

/***/ }),

/***/ "./lib/Gantt/view/GanttBase.js":
/*!*************************************!*\
  !*** ./lib/Gantt/view/GanttBase.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GanttBase; });
/* harmony import */ var _Scheduler_view_TimelineBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/view/TimelineBase.js */ "./lib/Scheduler/view/TimelineBase.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _orientation_NewTaskRendering_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./orientation/NewTaskRendering.js */ "./lib/Gantt/view/orientation/NewTaskRendering.js");
/* harmony import */ var _Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony import */ var _mixin_GanttDom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/GanttDom.js */ "./lib/Gantt/view/mixin/GanttDom.js");
/* harmony import */ var _mixin_GanttRegions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/GanttRegions.js */ "./lib/Gantt/view/mixin/GanttRegions.js");
/* harmony import */ var _mixin_GanttScroll_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/GanttScroll.js */ "./lib/Gantt/view/mixin/GanttScroll.js");
/* harmony import */ var _mixin_GanttState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mixin/GanttState.js */ "./lib/Gantt/view/mixin/GanttState.js");
/* harmony import */ var _mixin_GanttStores_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/GanttStores.js */ "./lib/Gantt/view/mixin/GanttStores.js");
/* harmony import */ var _mixin_GanttTimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/GanttTimelineDateMapper.js */ "./lib/Gantt/view/mixin/GanttTimelineDateMapper.js");
/* harmony import */ var _mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/TaskNavigation.js */ "./lib/Gantt/view/mixin/TaskNavigation.js");
/* harmony import */ var _Scheduler_view_mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Scheduler/view/mixin/EventNavigation.js */ "./lib/Scheduler/view/mixin/EventNavigation.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Gantt/localization/En.js");
/* harmony import */ var _Gantt_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Gantt/column/TimeAxisColumn.js */ "./lib/Gantt/column/TimeAxisColumn.js");
/* harmony import */ var _Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Grid/feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony import */ var _Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");
/* harmony import */ var _feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../feature/Dependencies.js */ "./lib/Gantt/feature/Dependencies.js");
/* harmony import */ var _column_NameColumn_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../column/NameColumn.js */ "./lib/Gantt/column/NameColumn.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'gantt';














 // Always required features




 //import { ReactiveTimeAxis } from '../../Engine/view/ReactiveTimeAxis.js';







/**
 * @module Gantt/view/GanttBase
 */

const emptyObject = Object.freeze({});
let newTaskCount = 0;
/**
 * A thin base class for {@link Gantt.view.Gantt}. Does not include any features by default, allowing smaller custom
 * built bundles if used in place of {@link Gantt.view.Gantt}.
 *
 * @mixes Gantt/view/mixin/GanttDom
 * @mixes Gantt/view/mixin/GanttRegions
 * @mixes Gantt/view/mixin/GanttScroll
 * @mixes Gantt/view/mixin/GanttState
 * @mixes Gantt/view/mixin/GanttStores
 * @mixes Scheduler/crud/mixin/CrudManagerView
 * @mixes Scheduler/view/mixin/EventNavigation
 * @mixes Gantt/view/mixin/TaskNavigation
 *
 * @features Scheduler/feature/ColumnLines
 * @features Scheduler/feature/EventFilter
 * @features Scheduler/feature/HeaderContextMenu
 * @features Scheduler/feature/HeaderZoom
 * @features Scheduler/feature/Labels
 * @features Scheduler/feature/NonWorkingTime
 * @features Scheduler/feature/Pan
 * @features Scheduler/feature/ScheduleMenu
 * @features Scheduler/feature/ScheduleTooltip
 * @features Scheduler/feature/Summary
 * @features Scheduler/feature/TimeAxisHeaderMenu
 * @features Scheduler/feature/TimeRanges
 *
 * @features SchedulerPro/feature/PercentBar
 *
 * @features Gantt/feature/Baselines
 * @features Gantt/feature/CellEdit
 * @features Gantt/feature/CriticalPaths
 * @features Gantt/feature/Dependencies
 * @features Gantt/feature/DependencyEdit
 * @features Gantt/feature/Indicators
 * @features Gantt/feature/Labels
 * @features Gantt/feature/ProgressLine
 * @features Gantt/feature/ProjectLines
 * @features Gantt/feature/Rollups
 * @features Gantt/feature/Summary
 * @features Gantt/feature/TaskContextMenu
 * @features Gantt/feature/TaskCopyPaste
 * @features Gantt/feature/TaskDrag
 * @features Gantt/feature/TaskDragCreate
 * @features Gantt/feature/TaskEdit
 * @features Gantt/feature/TaskMenu
 * @features Gantt/feature/TaskResize
 * @features Gantt/feature/TaskTooltip
 *
 * @features Gantt/feature/export/MspExport
 * @features Gantt/feature/export/PdfExport
 *
 * @extends Scheduler/view/TimelineBase
 */

class GanttBase extends _Scheduler_view_TimelineBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_GanttDom_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixin_GanttRegions_js__WEBPACK_IMPORTED_MODULE_6__["default"], _mixin_GanttScroll_js__WEBPACK_IMPORTED_MODULE_7__["default"], _mixin_GanttState_js__WEBPACK_IMPORTED_MODULE_8__["default"], _mixin_GanttStores_js__WEBPACK_IMPORTED_MODULE_9__["default"], _mixin_GanttTimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_10__["default"], _Scheduler_view_mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_12__["default"], _mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
  //region Task interaction events

  /**
   * Triggered after a mousedown on a task bar.
   * @event taskMouseDown
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered after a mouseup on a task bar.
   * @event taskMouseUp
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered after a click on a task bar.
   * @event taskClick
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered after a doubleclick on a task.
   * @event taskDblClick
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered after a rightclick (or long press on a touch device) on a task.
   * @event taskContextMenu
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered after a mouseover on a task.
   * @event taskMouseOver
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered for mouseout from a task.
   * @event taskMouseOut
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Gantt.model.TaskModel} taskRecord The Task record
   * @param {MouseEvent} event The native browser event
   */

  /**
   * Triggered when a keydown event is observed if there are selected tasks.
   * @event taskKeyDown
   * @param {Gantt.view.Gantt} source This Gantt
   * @param {Gantt.model.TaskModel} taskRecord Task record
   * @param {KeyboardEvent} event Browser event
   */

  /**
   * Triggered when a keyup event is observed if there are selected tasks.
   * @event taskKeyUp
   * @param {Gantt.view.Gantt} source This Gantt
   * @param {Gantt.model.TaskModel} eventRecord Task record
   * @param {KeyboardEvent} event Browser event
   */
  //endregion
  //region Other events

  /**
   * Task is rendered, its element is available in DOM.
   * @event renderTask
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Object} renderData Task render data
   * @param {Gantt.model.TaskModel} taskRecord Rendered task
   * @param {HTMLElement} element Task element
   */

  /**
   * Task is released, no longer in view/removed. A good spot for cleaning custom things added in a `renderTask`
   * listener up, if needed.
   * @event releaseTask
   * @param {Gantt.view.Gantt} source The Gantt instance
   * @param {Object} renderData Task render data
   * @param {Gantt.model.TaskModel} taskRecord Rendered task
   * @param {HTMLElement} element Task element
   */
  //endregion
  // For documentation & typings purposes

  /**
   * Returns the dependency record for a DOM element
   *
   * *NOTE: Only available when the {@link Gantt/feature/Dependencies Dependencies} feature is enabled.*
   *
   * @function resolveDependencyRecord
   * @param {HTMLElement} element The dependency line element
   * @return {Gantt.model.DependencyModel} The dependency record
   * @category Feature shortcuts
   */
  //endregion
  //region Config
  static get $name() {
    return 'GanttBase';
  } // Factoryable type name


  static get type() {
    return 'ganttbase';
  }

  static get defaultConfig() {
    return {
      /**
       * Get/set the gantt's read-only state. When set to `true`, any UIs for modifying data are disabled.
       * @member {Boolean} readOnly
       */

      /**
       * Configure as `true` to make the gantt read-only, by disabling any UIs for modifying data.
       *
       * __Note that checks MUST always also be applied at the server side.__
       * @config {Boolean} readOnly
       * @default false
       */

      /**
       * A {@link Gantt.model.ProjectModel} instance or a config object. The project holds all Gantt data.
       * @config {Gantt.model.ProjectModel|Object} project
       */

      /**
       * The {@link Gantt.model.ProjectModel} instance containing the data visualized by the Gantt chart.
       * @member {Gantt.model.ProjectModel}
       */
      project: null,

      /**
       * The path for resource images, used by various widgets such as the resource assignment column.
       * @config {String}
       * @category Common
       */
      resourceImageFolderPath: null,

      /**
       * The file name of an image file to use when a resource has no image, or its image cannot be loaded.
       * @config {String}
       * @category Common
       */
      defaultResourceImageName: null,

      /**
       * True to toggle the collapsed/expanded state when clicking a parent task bar.
       * @member {Boolean} toggleParentTasksOnClick
       */

      /**
       * True to toggle the collapsed/expanded state when clicking a parent task bar.
       * @config {Boolean}
       * @default true
       * @category Common
       */
      toggleParentTasksOnClick: true,

      /**
       * True to scroll the task bar into view when clicking a cell, you can also pass a {@link #function-scrollTaskIntoView scroll config}
       * object.
       * @config {Boolean|Object}
       * @category Common
       */
      scrollTaskIntoViewOnCellClick: false,
      // data for the stores, in the topological order
      calendars: null,
      resources: null,
      tasks: null,
      dependencies: null,
      assignments: null,
      eventCls: 'b-gantt-task',
      eventBarTextField: null,
      eventLayout: 'none',
      eventSelectionDisable: true,
      eventColor: null,
      eventStyle: null,
      rowHeight: 45,
      scheduledEventName: 'task',
      eventScrollMode: 'move',
      overScheduledEventClass: 'b-gantt-task-hover',
      mode: 'horizontal',
      //fixedRowHeight          : true, // Not working with exporter, no time to investigate why currently
      timeCellCls: 'b-sch-timeaxis-cell',
      timeCellSelector: '.b-sch-timeaxis-cell',
      // TODO: This will be brought in by the TaskNavigation mixin when it is implemented
      focusCls: 'b-active',

      /**
       * An empty function by default, but provided so that you can override it. This function is called each time
       * a task is rendered into the gantt to render the contents of the task.
       *
       * Returning a string will display it in the task bar, it accepts both plain text or HTML. It is also
       * possible to return a DOM config object which will be synced to the task bars content.
       *
       * ```javascript
       * // using plain string
       * new Gantt({
       *    taskRenderer : ({ taskRecord }) => StringHelper.encodeHtml(taskRecord.name)
       * });
       *
       * // using html string
       * new Gantt({
       *    taskRenderer : ({ taskRecord }) => StringHelper.xss`${taskRecord.id} <b>${taskRecord.name}</b>`
       * });
       *
       * // using DOM config
       * new Gantt({
       *    taskRenderer({ taskRecord }) {
       *       return {
       *           tag  : 'b',
       *           html : StringHelper.encodeHtml(taskRecord.name)
       *       }
       *    }
       * });
       * ```
       *
       * @param {Object} detail An object containing the information needed to render a Task.
       * @param {Gantt.model.TaskModel} detail.taskRecord The task record.
       * @param {Object} detail.tplData DEPRECATED 4.0: Use renderData instead.
       * @param {Object} detail.renderData An object containing details about the task rendering.
       * @param {Core.helper.util.DomClassList|String} detail.renderData.cls An object whose property names represent the CSS class names
       * to be added to the tasks's element. Set a property's value to truthy or falsy to add or remove the class
       * name based on the property name. Using this technique, you do not have to know whether the class is already
       * there, or deal with concatenation.
       * @param {String|Object} detail.renderData.style Inline styles for the task bar DOM element. Use either
       * 'border: 1px solid black' or { border: '1px solid black' }
       * @param {Core.helper.util.DomClassList|String} detail.renderData.wrapperCls An object whose property names represent the CSS class names
       * to be added to the event wrapper element. Set a property's value to truthy or falsy to add or remove the class
       * name based on the property name. Using this technique, you do not have to know whether the class is already
       * there, or deal with concatenation.
       * @param {Core.helper.util.DomClassList|String} detail.renderData.iconCls An object whose property names represent the CSS class
       * names to be added to a task icon element.
       * @param {Scheduler.model.TimeSpan[]|Object[]} indicators An array that can be populated with TimeSpan
       * records or their config objects to have them rendered in the task row
       * @returns {String} A simple string creating the actual HTML
       * @config {Function}
       * @category Scheduled events
       */
      taskRenderer: null,

      /**
       * A task field (id, wbsCode, sequenceNumber etc) that will be used when displaying and editing linked tasks.
       * @config {String} dependencyIdField
       * @default 'id'
       */
      dependencyIdField: 'id',

      /**
       * Returns dates that will constrain resize and drag operations. The method will be called with the
       * task being dragged.
       * @param {Gantt.model.TaskModel} taskRecord The task record being moved or resized.
       * @return {Object} Constraining object containing `start` and `end` constraints. Omitting either
       * will mean that end is not constrained. So you can prevent a resize or move from moving *before*
       * a certain time while not constraining the end date.
       * @return {Date} [return.start] Start date
       * @return {Date} [return.end] End date
       * @config {Function}
       * @category Scheduled events
       */
      getDateConstraints: null
    };
  }

  static get deprecatedEvents() {
    return {
      taskContextMenuBeforeShow: {
        product: 'Gantt',
        invalidAsOfVersion: '5.0.0',
        message: '`taskContextMenuBeforeShow` event is deprecated, in favor of `taskMenuBeforeShow` event. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0 for more information.'
      },
      taskContextMenuShow: {
        product: 'Gantt',
        invalidAsOfVersion: '5.0.0',
        message: '`taskContextMenuShow` event is deprecated, in favor of `taskMenuShow` event. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0 for more information.'
      },
      taskContextMenuItem: {
        product: 'Gantt',
        invalidAsOfVersion: '5.0.0',
        message: '`taskContextMenuItem` event is deprecated, in favor of `taskMenuItem` event. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0 for more information.'
      }
    };
  }

  get isGantt() {
    return true;
  } //endregion
  //region Init


  construct(config) {
    const me = this,
          hasInlineStores = Boolean(config.calendars || config.taskStore || config.dependencyStore || config.resourceStore || config.assignmentStore),
          hasInlineData = Boolean(config.calendars || config.tasks || config.dependencies || config.resources || config.assignments); // TODO: Config system to be enhanced to merge object properties from the hierarchy's
    // defaultConfig set so that each class level could just declare the features it requires.

    if (!config.features) {
      config.features = {};
    } // gantt is always a tree


    if (!('tree' in config.features)) {
      config.features.tree = true;
    } // disable group feature by default


    if (!('group' in config.features)) {
      config.features.group = false;
    }

    const {
      project
    } = config;

    if (project && (hasInlineStores || hasInlineData)) {
      throw new Error('Providing both project and inline data is not supported');
    } // gather all data in the ProjectModel instance


    if (!(project !== null && project !== void 0 && project.isModel)) {
      config.project = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
        calendarsData: config.calendars,
        eventsData: config.tasks,
        dependenciesData: config.dependencies,
        resourcesData: config.resources,
        assignmentsData: config.assignments,
        resourceStore: config.resourceStore,
        eventStore: config.taskStore,
        assignmentStore: config.assignmentStore,
        dependencyStore: config.dependencyStore,
        timeRangeStore: config.timeRangeStore
      }, project);
      delete config.resourceStore;
      delete config.taskStore;
      delete config.assignmentStore;
      delete config.dependencyStore;
      delete config.timeRangeStore;
      delete config.calendars;
      delete config.resources;
      delete config.tasks;
      delete config.assignments;
      delete config.dependencies;
    } // EOF data gathering
    // Add listeners with negative priority to call propagation after rows are rendered
    // project.getEventStore().on({
    //     add     : me.onTaskStoreAddOrRemove,
    //     remove  : me.onTaskStoreAddOrRemove,
    //     prio    : -1,
    //     thisObj : me
    // });
    // If project is already loaded, possibly need to adjust timeline
    // if (project.loaded) {
    //     this.onProjectLoad();
    // }


    super.construct(config); // const { timeAxis } = me;
    //
    // me.reactiveTimeAxis = ReactiveTimeAxis.new({
    //     project,
    //     defaultSpan : timeAxis.defaultSpan,
    //     mainUnit    : timeAxis.mainUnit,
    //     dateRange   : 'startDate' in me.initialConfig ? {
    //         startDate : me.startDate,
    //         endDate   : me.endDate
    //     } : null
    // });
    // project.replica.addEntity(me.reactiveTimeAxis);
    // project.replica.addListener(me.reactiveTimeAxis.$.dateRange, dateRange => {
    //     timeAxis.setTimeSpan(dateRange.startDate, dateRange.endDate);
    // });

    me.on({
      taskclick: 'onTaskBarClick',
      cellClick: 'onNonTimeAxisCellClick'
    });
  }

  get columns() {
    return super.columns;
  }

  set columns(columns) {
    if (columns) {
      let cols = columns;

      if (!Array.isArray(columns)) {
        cols = columns.data; // Need to pull the taskstore in, to make sure any fields added by columns are added to it

        this._thisIsAUsedExpression(this.taskStore);
      } // Always include the name column


      if (!cols.some(column => {
        const constructor = column instanceof _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_20__["default"] ? column.constructor : _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_21__["default"].getColumnClass(column.type) || _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_20__["default"];
        return constructor === _column_NameColumn_js__WEBPACK_IMPORTED_MODULE_18__["default"] || constructor.prototype instanceof _column_NameColumn_js__WEBPACK_IMPORTED_MODULE_18__["default"];
      })) {
        cols.unshift({
          type: 'name'
        });
      }
    }

    super.columns = columns; // this.timeAxisColumn.reactiveRenderer = this.taskRendering.reactiveRenderer;
  } // Overrides TimelineBase to supply taskStore as its store (which is only used in passed events)


  set timeAxisViewModel(timeAxisViewModel) {
    super.timeAxisViewModel = timeAxisViewModel;

    if (this.taskStore) {
      this.timeAxisViewModel.store = this.taskStore;
    }
  }

  get timeAxisViewModel() {
    return super.timeAxisViewModel;
  } //endregion
  //region Events


  resumeRefresh(trigger) {
    super.resumeRefresh(false);

    if (!this.refreshSuspended && trigger) {
      if (!this.rowManager.topRow) {
        // TODO: investigate why we need this
        this.rowManager.reinitialize();
      } else {
        this.refreshWithTransition();
      }
    }
  } // Overriding grids behaviour to ignore individual updates caused by propagation
  // TODO: scheduler doesn't need that code and it shouldn't be needed in gantt too


  onStoreUpdateRecord(params) {
    if (!this.project.isBatchingChanges) {
      let result;
      this.runWithTransition(() => {
        result = super.onStoreUpdateRecord(params);
      });
      return result;
    }
  } // Transition batch changes


  onStoreDataChange(params) {
    this.runWithTransition(() => {
      super.onStoreDataChange(params);
    }, params.action === 'batch');
  } // Do not remove. Assertion strings for Localization sanity check.
  // 'L{storePopulation}' => Loading data
  // 'L{propagating}' => Calculating project


  onProjectProgress({
    total,
    remaining,
    phase = 'propagating'
  }) {
    const me = this;

    if (me.project.enableProgressNotifications) {
      const str = me.L(phase),
            text = total ? `${str} ${Math.round(100 * (total - remaining) / total)}%` : str;

      if (!me.masked) {
        me.mask({
          maxProgress: total,
          useTransition: false,
          text
        });
      }

      me.masked.text = text;

      if (total) {
        // In case total changes...
        me.masked.maxProgress = total;
        me.masked.progress = total - remaining;
      }
    }
  } // Features can hook into this to add to generated task data


  onTaskDataGenerated() {}

  onTaskBarClick({
    taskRecord
  }) {
    if (this.toggleParentTasksOnClick && !taskRecord.isLeaf) {
      this.toggleCollapse(taskRecord);
    }
  }

  onNonTimeAxisCellClick({
    record,
    column
  }) {
    if (column.type !== 'timeAxis' && this.scrollTaskIntoViewOnCellClick && record.isScheduled) {
      this.scrollTaskIntoView(record, this.scrollTaskIntoViewOnCellClick === true ? {
        animate: true,
        block: 'center',
        y: false
      } : this.scrollTaskIntoViewOnCellClick);
    }
  } // Grid row selection change
  // TODO #8301 - EventSelection based on Collection may break it


  triggerChangeEvent(selectionChangeEvent, silent) {
    super.triggerChangeEvent(selectionChangeEvent, silent);
    const me = this;

    function setTaskSelection(record, selected) {
      const taskElement = me.getElementFromTaskRecord(record);

      if (taskElement) {
        _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_24__["default"][selected ? 'addCls' : 'removeCls']('b-task-selected', taskElement);
      }
    }

    if (selectionChangeEvent.mode === 'row') {
      selectionChangeEvent.selected.map(record => setTaskSelection(record, true));
      selectionChangeEvent.deselected.map(record => setTaskSelection(record, false));
    }
  } //endregion
  //region TimelineBase implementations
  // Overrides grid to take project loading into account


  toggleEmptyText() {
    const me = this;

    if (me.bodyContainer) {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].toggleClasses(me.bodyContainer, 'b-grid-empty', !(me.rowManager.rowCount || me.project.isLoadingOrSyncing));
    }
  } // Gantt only has one orientation, but TimelineBase expects this to work to call correct rendering code


  get currentOrientation() {
    const me = this;

    if (!me._currentOrientation) {
      //me.taskRendering = me._currentOrientation = new TaskRendering(me);
      me.taskRendering = me._currentOrientation = new _orientation_NewTaskRendering_js__WEBPACK_IMPORTED_MODULE_3__["default"](me);
    }

    return me._currentOrientation;
  }

  getTimeSpanMouseEventParams(taskElement, event) {
    const taskRecord = this.resolveTaskRecord(taskElement);
    return !taskRecord ? null : {
      taskRecord,
      taskElement,
      event
    };
  }

  getScheduleMouseEventParams(cellData) {
    return {
      taskRecord: this.store.getById(cellData.id)
    };
  } // Used by shared features to resolve an event or task


  resolveTimeSpanRecord(element) {
    return this.resolveTaskRecord(element);
  }

  repaintEventsForResource(taskRecord) {
    this.taskRendering.redraw(taskRecord);
  } //endregion
  //region Feature hooks

  /**
   * Populates the task context menu. Chained in features to add menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown.
   * @param {Gantt.model.TaskModel} options.taskRecord The reference task record
   * @param {Scheduler.model.ResourceModel} options.resourceRecord The context resource.
   * @param {Scheduler.model.AssignmentModel} options.assignmentRecord The context assignment if any.
   * @param {Object} options.items A named object to describe menu items.
   * @internal
   */


  populateTaskMenu() {}

  onVisibleDateRangeChange() {} //endregion
  // region ContextMenu API


  async addTask(referenceTask, options = emptyObject) {
    const me = this,
          {
      milestone,
      above,
      asChild,
      asPredecessor,
      asSuccessor
    } = options,
          project = me.project,
          parent = referenceTask.parent,
          newRecord = referenceTask.copy();

    if (milestone) {
      newRecord.name = `${me.L('L{Gantt.New milestone}')} ${++newTaskCount}`;
    } else {
      newRecord.name = `${me.L('L{Gantt.New task}')} ${++newTaskCount}`;
    }

    if (asChild) {
      referenceTask.insertChild(newRecord, referenceTask.firstChild);
    } else if (above) {
      referenceTask.parent.insertChild(newRecord, referenceTask);
    } else {
      parent.insertChild(newRecord, referenceTask.nextSibling);
    }

    if (milestone) {
      await project.commitAsync();
      await newRecord.convertToMilestone();
    } else {
      await project.commitAsync();
    } // run propagation to handle the new task record
    // and then add a dependency if needed


    if (asSuccessor) {
      me.dependencyStore.add({
        fromEvent: referenceTask,
        toEvent: newRecord,
        type: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_19__["DependencyType"].EndToStart,
        fromSide: 'right',
        toSide: 'left'
      });
    } else if (asPredecessor) {
      me.dependencyStore.add({
        fromEvent: newRecord,
        toEvent: referenceTask,
        type: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_19__["DependencyType"].EndToStart,
        fromSide: 'right',
        toSide: 'left'
      });
    }

    if (asSuccessor || asPredecessor) {
      // run propagation to handle the new dependency
      await project.propagateAsync();
    }

    return newRecord;
  }
  /**
   * Adds a new task above the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addTaskAbove(taskRecord) {
    return this.addTask(taskRecord, {
      above: true
    });
  }
  /**
   * Adds a new task below the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addTaskBelow(taskRecord) {
    return this.addTask(taskRecord);
  }
  /**
   * Adds a new milestone task below the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addMilestoneBelow(taskRecord) {
    return this.addTask(taskRecord, {
      milestone: true
    });
  }
  /**
   * Adds a new sub task to the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addSubtask(taskRecord) {
    const result = this.addTask(taskRecord, {
      asChild: true
    });
    this.toggleCollapse(taskRecord, false);
    return result;
  }
  /**
   * Adds a successor task to the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addSuccessor(taskRecord) {
    return this.addTask(taskRecord, {
      asSuccessor: true
    });
  }
  /**
   * Adds a predecessor task to the passed reference task
   * @async
   * @param {Gantt.model.TaskModel} taskRecord The reference task record
   * @return {Gantt.model.TaskModel} A promise which yields the added task
   */


  addPredecessor(taskRecord) {
    return this.addTask(taskRecord, {
      above: true,
      asPredecessor: true
    });
  }
  /**
   * Increase the indentation level of one or more tasks in the tree
   * @param {Gantt.model.TaskModel[]|Gantt.model.TaskModel} tasks The task(s) to indent.
   * @return {Promise} A promise which resolves if operation is successful
   */


  async indent(nodes) {
    const me = this,
          result = await me.taskStore.indent(nodes); // If `false`, the scheduling engine has found a reason that the operation could not happen.

    if (!result) {
      _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_22__["default"].show({
        rootElement: me.rootElement,
        html: me.L('L{Gantt.changeRejected}')
      });
    }

    return result;
  }
  /**
   * Decrease the indentation level of one or more tasks in the tree
   *
   * @param {Gantt.model.TaskModel[]|Gantt.model.TaskModel} tasks The task(s) to outdent.
   * @return {Promise} A promise which resolves if operation is successful
   */


  async outdent(nodes) {
    const me = this,
          result = await me.taskStore.outdent(nodes); // If `false`, the scheduling engine has found a reason that the operation could not happen.

    if (!result) {
      _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_22__["default"].show({
        rootElement: me.rootElement,
        html: me.L('L{Gantt.changeRejected}')
      });
    }

    return result;
  } // endregion
  // the 4 methods below are required since super cannot be called from GanttDom mixin


  onElementKeyDown(event) {
    super.onElementKeyDown(event);
  }

  onElementKeyUp(event) {
    super.onElementKeyUp(event);
  }

  onElementMouseOver(event) {
    super.onElementMouseOver(event);
  }

  onElementMouseOut(event) {
    super.onElementMouseOut(event);
  }

} // Register this widget type with its Factory

GanttBase.initClass();
_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setVersion('gantt', '4.3.6');
GanttBase._$name = 'GanttBase';

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttDom.js":
/*!******************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttDom.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
var productName = 'gantt';



/**
 * @module Gantt/view/mixin/GanttDom
 */

const hyphenRe = /-/g;
/**
 * Mixin with TaskModel <-> HTMLElement mapping functions
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttDom extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttDom';
  } // Alias for resolveTaskRecord method to satisfy the scheduler naming requirements.


  resolveEventRecord(element) {
    return this.resolveTaskRecord(element);
  }
  /**
   * Returns the task record for a DOM element
   * @param {HTMLElement} element The DOM node to lookup
   * @return {Gantt.model.TaskModel} The task record
   */


  resolveTaskRecord(element) {
    element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, this.eventSelector);

    if (!element) {
      return null;
    }

    return this.taskStore.getById(element.dataset.taskId);
  }
  /**
   * Relays keydown events as taskkeydown if we have a selected task(s).
   * @private
   */


  onElementKeyDown(event) {
    super.onElementKeyDown(event);

    if (this.selectedRecords.length) {
      this.trigger('taskKeyDown', {
        taskRecord: this.selectedRecords
      });
    }
  }
  /**
   * Relays keyup events as taskkeyup if we have a selected task(s).
   * @private
   */


  onElementKeyUp(event) {
    super.onElementKeyUp(event);

    if (this.selectedRecords.length) {
      this.trigger('taskKeyUp', {
        taskRecord: this.selectedRecords
      });
    }
  }
  /**
   * Returns the HTMLElement representing a task record.
   *
   * @param {Gantt.model.TaskModel} taskRecord A task record
   * @param {Boolean} [inner] Specify `false` to return the task wrapper element
   *
   * @return {HTMLElement} The element representing the task record
   */


  getElementFromTaskRecord(taskRecord, inner = true) {
    return this.taskRendering.getElementFromTaskRecord(taskRecord, inner);
  } // alias to make scheduler features applied to Gantt happy
  // TODO: since we have decided to call tasks events then the method
  //       being aliased should be renamed


  getElementFromEventRecord(eventRecord) {
    return this.getElementFromTaskRecord(eventRecord);
  }
  /**
   * Generates the element `id` for an event element. This is used when
   * recycling an event div which has been moved from one resource to
   * another. The event is assigned its new render id *before* being
   * returned to the free pool, so that when the render engine requests
   * a div from the free pool, the same div will be returned and it will
   * smoothly transition to its new position.
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @private
   */


  getEventRenderId(taskRecord) {
    // TODO: use DomHelper.makeValidId or StringHelper.createId. Cannot currently since they strip out ids that only contains numbers
    return `${this.id.toString().replace(hyphenRe, '_')}-${taskRecord.id}`;
  }
  /**
   * In Gantt, the task is the row, so it's valid to resolve a mouse event on a task to the TimeAxisColumn's cell.
   *
   * This method find the cell location of the passed event. It returns an object describing the cell.
   * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
   * @returns {Object} An object containing the following properties:
   * - `cellElement` - The cell element clicked on.
   * - `columnId` - The `id` of the column clicked under.
   * - `record` - The {@link Core.data.Model record} clicked on.
   * - `id` - The `id` of the {@link Core.data.Model record} clicked on.
   * @private
   * @category Events
   */


  getEventData(event) {
    const me = this,
          record = me.resolveTimeSpanRecord(event.target); // If the event was on a task, then we're in one of the the TimeAxisColumn's cells.

    if (record) {
      const cellElement = me.getCell({
        record,
        column: me.timeAxisColumn
      }),
            cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].get(cellElement),
            id = cellData.id,
            columnId = cellData.columnId;
      return {
        cellElement,
        cellData,
        columnId,
        id,
        record,
        cellSelector: {
          id,
          columnId
        }
      };
    } else {
      return super.getEventData(event);
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttRegions.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttRegions.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * @module Gantt/view/mixin/GanttRegions
 */

/**
 * Functions to get regions (bounding boxes) for gantt, tasks etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttRegions extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttRegions';
  }
  /**
   * Gets the region represented by the timeline and optionally only for a single task
   * @param {Gantt.model.TaskModel} taskRecord (optional) The task record
   * @return {Object} The region of the schedule
   */


  getScheduleRegion(taskRecord, local) {
    const me = this,
          element = me.timeAxisSubGridElement;
    let region;

    if (taskRecord) {
      const taskElement = me.getElementFromTaskRecord(taskRecord);
      region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(me.getRowById(taskRecord.id).getElement('normal'));

      if (taskElement) {
        const taskRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(taskElement, element);
        region.y = taskRegion.y;
        region.bottom = taskRegion.bottom;
      } else {
        region.y = region.y + me.barMargin;
        region.bottom = region.bottom - me.barMargin;
      }
    } else {
      // TODO: This is what the bizarre function that was removed here did.
      // The coordinate space needs to be sorted out here!
      region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element).moveTo(null, 0);
      region.width = element.scrollWidth;
      region.y = region.y + me.barMargin;
      region.bottom = region.bottom - me.barMargin;
    }

    const taStart = me.timeAxis.startDate,
          taEnd = me.timeAxis.endDate,
          dateConstraints = me.getDateConstraints(taskRecord) || {
      start: taStart,
      end: taEnd
    },
          top = region.y,
          bottom = region.bottom;
    let startX = me.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].max(taStart, dateConstraints.start)),
        endX = me.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].min(taEnd, dateConstraints.end));

    if (!local) {
      startX = me.translateToPageCoordinate(startX);
      endX = me.translateToPageCoordinate(endX);
    }

    return {
      top,
      right: Math.max(startX, endX),
      bottom,
      left: Math.min(startX, endX)
    };
  }

  translateToPageCoordinate(x) {
    const element = this.timeAxisSubGridElement;
    return x + element.getBoundingClientRect().left - element.scrollLeft;
  } // Decide if a record is inside a collapsed tree node, or inside a collapsed group (using grouping feature)


  isRowVisible(taskRecord) {
    // records in collapsed groups/branches etc are removed from processedRecords
    return this.store.indexOf(taskRecord) >= 0;
  }
  /**
   * Get the region for a specified task
   * @param {Gantt.model.TaskModel} taskRecord
   * @param {Boolean} [includeOutside]
   * @param {Boolean} [inner] Specify true to return the box for the task bar within the wrapper.
   * @returns {Core.helper.util.Rectangle}
   */


  getTaskBox(taskRecord, includeOutside = false, inner = false) {
    return this.taskRendering.getTaskBox(...arguments);
  }

  getSizeAndPosition() {
    return this.taskRendering.getSizeAndPosition(...arguments);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttScroll.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttScroll.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';



/**
 * @module Gantt/view/mixin/GanttScroll
 */

const defaultScrollOptions = {
  block: 'nearest',
  edgeOffset: 20
};
/**
 * Functions for scrolling to tasks, dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttScroll extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttScroll';
  }
  /**
   * Scrolls a task record into the viewport.
   *
   * @param {Gantt.model.TaskModel} taskRecord The task record to scroll into view
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollTaskIntoView(taskRecord, options = defaultScrollOptions) {
    let taskStart = taskRecord.startDate,
        taskEnd = taskRecord.endDate;
    const me = this;

    if (options.edgeOffset == null) {
      options.edgeOffset = 20;
    }

    if (!taskRecord.isScheduled) {
      return this.scrollRowIntoView(taskRecord, options);
    }

    if (me.timeAxisSubGrid.collapsed) {
      return;
    }

    taskStart = taskStart || taskEnd;
    taskEnd = taskEnd || taskStart;
    const taskIsOutside = taskStart < me.timeAxis.startDate | (taskEnd > me.timeAxis.endDate) << 1; // Make sure task is within TimeAxis time span unless extendTimeAxis passed as false.
    // The TaskEdit feature passes false because it must not mutate the TimeAxis.
    // Bitwise flag:
    //  1 === start is before TimeAxis start.
    //  2 === end is after TimeAxis end.

    if (taskIsOutside && options.extendTimeAxis !== false) {
      const currentTimeSpanRange = me.timeAxis.endDate - me.timeAxis.startDate;
      let startAnchorPoint, endAnchorPoint; // Event is too wide, expand the range to encompass it.

      if (taskIsOutside === 3) {
        me.timeAxis.setTimeSpan(new Date(taskStart.valueOf() - currentTimeSpanRange / 2), new Date(taskEnd.getTime() + currentTimeSpanRange / 2));
      } // Event is partially or wholly outside but will fit.
      // Move the TimeAxis to include it. Attempt to maintain visual position.
      else {
        startAnchorPoint = me.getCoordinateFromDate(taskIsOutside & 1 ? taskEnd : taskStart); // Event starts before

        if (taskIsOutside & 1) {
          me.timeAxis.setTimeSpan(new Date(taskStart), new Date(taskStart.valueOf() + currentTimeSpanRange));
        } // Event ends after
        else {
          me.timeAxis.setTimeSpan(new Date(taskEnd.valueOf() - currentTimeSpanRange), new Date(taskEnd));
        } // Restore view to same relative scroll position.


        endAnchorPoint = taskIsOutside & 1 ? me.getCoordinateFromDate(taskEnd) : me.getCoordinateFromDate(taskStart);
        me.timeAxisSubGrid.scrollable.scrollBy(endAnchorPoint - startAnchorPoint);
      }
    } // Establishing element to scroll to


    const el = me.getElementFromTaskRecord(taskRecord);

    if (el) {
      const scroller = me.timeAxisSubGrid.scrollable; // Scroll into view with animation and highlighting if needed.
      // Mute scroll events during the scroll so that event rendering doesn't replace
      // the target element.

      return scroller.scrollIntoView(el, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
        silent: true
      }, options));
    } else {
      // Event not rendered, scroll to calculated location
      return me.scrollUnrenderedTaskIntoView(taskRecord, options);
    }
  }
  /**
   * Scrolls an unrendered task into view. Internal function used from #scrollTaskIntoView.
   * @private
   */


  scrollUnrenderedTaskIntoView(taskRec, options = defaultScrollOptions) {
    if (options.edgeOffset == null) {
      options.edgeOffset = 20;
    }

    const me = this,
          scroller = me.timeAxisSubGrid.scrollable,
          box = me.getTaskBox(taskRec),
          scrollerViewport = scroller.viewport,
          targetRect = box.translate(scrollerViewport.x - scroller.x, scrollerViewport.y - scroller.y);
    let result = scroller.scrollIntoView(targetRect, Object.assign({}, options, {
      highlight: false
    }));

    if (options.highlight || options.focus) {
      const detacher = me.on({
        renderTask({
          taskRecord,
          element
        }) {
          if (taskRecord === taskRec) {
            detacher();
            result = result.then(() => {
              options.highlight && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].highlight(element);
              options.focus && element.focus();
            });
          }
        }

      });
    } else {
      // Task is painter asynchronously after scroll, need to wait for corresponding event from the view
      result = Promise.all([result, new Promise(resolve => {
        const detacher = me.on({
          renderTask({
            taskRecord
          }) {
            if (taskRecord === taskRec) {
              detacher();
              resolve();
            }
          }

        });
      })]);
    }

    return result;
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttState.js":
/*!********************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttState.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Gantt/view/mixin/GanttState
 */

const copyProperties = ['barMargin'];
/**
 * Mixin for Gantt that handles state. It serializes the following gantt properties:
 *
 * * barMargin
 * * tickSize
 * * zoomLevel
 *
 * See {@link Grid.view.mixin.GridState} and {@link Core.mixin.State} for more information on state.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttState extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttState';
  }
  /**
   * Gets or sets gantt's state. Check out {@link Gantt.view.mixin.GanttState GanttState} mixin for details.
   * @member {Object} state
   */

  /**
   * Get gantt's current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
   * selectedRecordId, column states and store state etc.
   * @returns {Object} State object to be serialized
   * @private
   */


  getState() {
    const me = this,
          state = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyProperties(super.getState(), me, copyProperties);
    state.zoomLevel = me.zoomLevel;
    state.zoomLevelOptions = {
      startDate: me.startDate,
      endDate: me.endDate,
      centerDate: me.viewportCenterDate,
      width: me.tickSize
    };
    return state;
  }
  /**
   * Apply previously stored state.
   * @param {Object} state
   * @private
   */


  applyState(state) {
    var _state$store, _state$store2;

    if (state.zoomLevel) {
      this.zoomToLevel(state.zoomLevel, state.zoomLevelOptions);
    }

    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyProperties(this, state, copyProperties); // Applying sorters too early might lead to unexpected results if fields in the incoming dataset will be changed
    // after initial commit
    // state.store might be undefined if responsive level is being applied

    if (!this.project.isInitialCommitPerformed && ((_state$store = state.store) !== null && _state$store !== void 0 && _state$store.sorters || (_state$store2 = state.store) !== null && _state$store2 !== void 0 && _state$store2.filters)) {
      const storeState = state.store;
      this.project.commitAsync().then(() => {
        if (!this.isDestroyed) {
          this.store.state = storeState;
        }
      });
      delete state.store;
    }

    super.applyState(state);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttStores.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttStores.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Scheduler/data/mixin/ProjectConsumer.js */ "./lib/Scheduler/data/mixin/ProjectConsumer.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../model/ProjectModel.js */ "./lib/Gantt/model/ProjectModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';




/**
 * @module Gantt/view/mixin/GanttStores
 */

/**
 * Functions for store assignment and store event listeners.
 * Properties are aliases to corresponding
 * ones of Gantt's {@link Gantt.model.ProjectModel project} instance.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttStores extends Object(_Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttStores';
  } // This is the static definition of the Stores we consume from the project, and
  // which we must provide *TO* the project if we or our CrudManager is configured
  // with them.
  // The property name is the store name, and within that there is the dataname which
  // is the property which provides static data definition. And there is a listeners
  // definition which specifies the listeners *on this object* for each store.
  //
  // To process incoming stores, implement an updateXxxxxStore method such
  // as `updateEventStore(eventStore)`.
  //
  // To process an incoming Project implement `updateProject`. __Note that
  // `super.updateProject(...arguments)` must be called first.__


  static get projectStores() {
    return {
      calendarManagerStore: {},
      resourceStore: {
        dataName: 'resources'
      },
      eventStore: {
        dataName: 'events'
      },
      dependencyStore: {
        dataName: 'dependencies'
      },
      assignmentStore: {
        dataName: 'assignments'
      }
    };
  }

  static get configurable() {
    return {
      // Overridden. ProjectConsumer defaults to Scheduler's ProjectModel
      projectModelClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * Inline tasks, will be loaded into an internally created TaskStore.
       * @config {Gantt.model.TaskModel[]|Object[]}
       * @category Data
       */
      tasks: null,

      /**
       * The {@link Gantt.data.TaskStore} holding the tasks to be rendered into the gantt.
       * @config {Gantt.data.TaskStore}
       * @category Data
       */
      taskStore: null
      /**
       * Inline dependencies, will be loaded into an internally created DependencyStore.
       * @config {Gantt.model.DependencyModel[]|Object[]} dependencies
       * @category Data
       */

      /**
       * The optional {@link Gantt.data.DependencyStore}.
       * @config {Gantt.data.DependencyStore} dependencyStore
       * @category Data
       */

    };
  }

  construct() {
    // queue af calls to trigger on "propagation-is-finished" moments
    this.onRefreshCallsQueue = [];
    super.construct(...arguments);
  }

  updateProject(project, oldProject) {
    super.updateProject(project, oldProject);
    this.detachListeners('ganttStores');
    this.bindCrudManager(project);

    if (project) {
      project.on({
        name: 'ganttStores',
        startApplyResponse: 'onProjectStartApplyResponse',
        refresh: 'internalOnProjectRefresh',
        progress: 'onProjectProgress',
        //commit            : 'onProjectCommit',
        thisObj: this
      });
    }
  }

  get replica() {
    return this.project.replica;
  }

  onProjectStartApplyResponse() {
    this.suspendRefresh();
  }

  internalOnProjectRefresh() {
    const me = this;

    if (me.project.enableProgressNotifications && me.masked) {
      me.unmask();
    }

    if (!me.appliedViewStartDate && !('startDate' in me.initialConfig) && me.project.startDate) {
      var _me$visibleDate;

      const requestedVisibleDate = ((_me$visibleDate = me.visibleDate) === null || _me$visibleDate === void 0 ? void 0 : _me$visibleDate.date) || me.visibleDate,
            {
        startDate,
        endDate
      } = me.project,
            min = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].min(startDate, requestedVisibleDate || startDate),
            max = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].max(endDate, requestedVisibleDate || endDate);
      me.setTimeSpan(min, max, {
        visibleDate: me.visibleDate
      });
      me.appliedViewStartDate = true;
    }

    me.resumeRefresh(true);

    if (!me.suspendRendering) {
      if (me.refreshAfterProjectRefresh) {
        me.refreshWithTransition();
        me.refreshAfterProjectRefresh = false;
      }

      me.trigger('projectRefresh', {
        initial: false
      });
    }
  } //endregion
  //region TaskStore

  /**
   * Get/set tasks, applies to the backing project's EventStore.
   * @property {Gantt.model.TaskModel[]|Object[]}
   * @category Data
   */


  get tasks() {
    return this.project.eventStore.records;
  }

  changeTasks(tasks) {
    const {
      project
    } = this;

    if (this.buildingProjectConfig) {
      // Set the property in the project config object.
      project.eventsData = tasks;
    } else {
      // Live update the project when in use.
      project.eventStore.data = tasks;
    }
  }
  /**
   * Get/set the event store instance of the backing project.
   * @member {Gantt.data.TaskStore} taskStore
   * @category Data
   */


  changeTaskStore(taskStore) {
    const {
      project
    } = this;

    if (this.buildingProjectConfig) {
      // Set the property in the project config object.
      // Must not go through the updater. It's too early to
      // inform host of store change.
      project.eventStore = taskStore;
      return;
    } // Live update the project when in use.


    if (!this.initializingProject) {
      if (project.eventStore !== taskStore) {
        project.setEventStore(taskStore);
        taskStore = project.eventStore;
      }
    }

    return taskStore;
  }

  updateEventStore(eventStore) {
    const me = this;
    eventStore.metaMapId = me.id; // taskStore is used for rows (store) and tasks

    me.taskStore = me.store = me.timeAxisViewModel.store = eventStore;
    me.currentOrientation.bindTaskStore(eventStore); // Occasionally we need to track batched changes.
    // TaskResize requires this as it changes the endDate with task batched.

    eventStore.detachListeners('eventStoreBatchedUpdateListener');
    eventStore.on({
      name: 'eventStoreBatchedUpdateListener',
      batchedUpdate: 'onEventStoreBatchedUpdate',
      thisObj: me
    });
  }
  /**
   * Listener to the batchedUpdate event which fires when a field is changed on a record which
   * is batch updating. Occasionally UIs must keep in sync with batched changes.
   * For example, the TaskResize feature performs batched updating of the startDate/endDate
   * and it tells its client to listen to batchedUpdate.
   * @private
   */


  onEventStoreBatchedUpdate(event) {
    if (this.listenToBatchedUpdates) {
      const wasEnabled = this.enableEventAnimations; // This pathway is used from TaskResize during dragging, so we do not
      // want the size animating. It should follow the pointer in real time.

      this.enableEventAnimations = false;
      this.onStoreUpdateRecord(event);
      this.enableEventAnimations = wasEnabled;
    }
  } //endregion
  //region Internal
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {} //endregion


});

/***/ }),

/***/ "./lib/Gantt/view/mixin/GanttTimelineDateMapper.js":
/*!*********************************************************!*\
  !*** ./lib/Gantt/view/mixin/GanttTimelineDateMapper.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Gantt/view/mixin/GanttTimelineDateMapper
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GanttTimelineDateMapper extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GanttTimelineDateMapper';
  }
  /**
   * Method to get a displayed end date value, see {@link Gantt/view/mixin/GanttTimelineDateMapper#function-getFormattedEndDate} for more info.
   * @private
   * @param {Date} endDate The date to format
   * @param {Date} startDate The start date
   * @return {Date} The date value to display
   */


  getDisplayEndDate(endDate, startDate) {
    return endDate;
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/mixin/TaskNavigation.js":
/*!************************************************!*\
  !*** ./lib/Gantt/view/mixin/TaskNavigation.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


/**
 * @module Gantt/view/mixin/TaskNavigation
 */

/**
 * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TaskNavigation extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TaskNavigation';
  }

  static get defaultConfig() {
    return {
      navigator: {
        inlineFlow: false,
        prevKey: 'ArrowUp',
        nextKey: 'ArrowDown',
        keys: {
          ArrowLeft: () => {},
          ArrowRight: () => {},
          Enter: 'onTaskEnterKey'
        }
      }
    };
  }

  processEvent(event) {
    const me = this,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, me.eventSelector);

    if (!me.navigator.disabled && eventElement) {
      event.taskRecord = event.eventRecord = me.resolveTaskRecord(eventElement);

      if (event.type === 'click') {
        me.selectEvent(event.taskRecord, event.ctrlKey || event.metaKey);
      }
    }

    return event;
  }

  normalizeTarget(event) {
    return event.taskRecord;
  }

  selectEvent(record, preserveSelection = false) {
    // Select row without scrolling any column into view
    this.selectRow({
      record: record.id,
      column: false,
      addToSelection: preserveSelection
    });
  }

  deselectEvent(record) {
    this.deselectRow(record.id);
  }

  getNext(taskRecord) {
    const me = this,
          {
      taskStore
    } = me;

    for (let rowIdx = taskStore.indexOf(taskRecord) + 1; rowIdx < taskStore.count; rowIdx++) {
      const nextTask = taskStore.getAt(rowIdx); // Skip tasks which are outside the TimeAxis

      if (me.isInTimeAxis(nextTask)) {
        return nextTask;
      }
    }
  }

  getPrevious(taskRecord) {
    const me = this,
          {
      taskStore
    } = me;

    for (let rowIdx = taskStore.indexOf(taskRecord) - 1; rowIdx >= 0; rowIdx--) {
      const prevTask = taskStore.getAt(rowIdx); // Skip tasks which are outside the TimeAxis

      if (me.isInTimeAxis(prevTask)) {
        return prevTask;
      }
    }
  }

  set activeEvent(record) {
    this.navigator.activeItem = this.getElementFromTaskRecord(record, false);
  }

  get activeEvent() {
    const {
      activeItem
    } = this.navigator;

    if (activeItem) {
      return this.resolveTaskRecord(activeItem);
    }
  }

  async navigateTo(targetEvent, uiEvent = {}) {
    const me = this;

    if (targetEvent) {
      // No key processing during scroll
      me.navigator.disabled = true;
      await me.scrollTaskIntoView(targetEvent, {
        animate: 100
      }).then(() => {
        me.navigator.disabled = false;
        me.activeEvent = targetEvent;
        me.navigator.trigger('navigate', {
          event: uiEvent,
          item: me.getElementFromTaskRecord(targetEvent, false)
        });
      });
    }
  }

  clearEventSelection() {
    this.deselectAll();
  }

  onTaskEnterKey() {// Empty, to be chained by features (used by TaskEdit)
  } // OVERRIDE for EventNavigation#onDeleteKey


  onDeleteKey(keyEvent) {
    const record = keyEvent.eventRecord;

    if (!this.readOnly && this.enableDeleteKey && record) {
      this.removeEvents([record]);
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Gantt/view/orientation/NewTaskRendering.js":
/*!********************************************************!*\
  !*** ./lib/Gantt/view/orientation/NewTaskRendering.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewTaskRendering; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';






 // TODO: No need to keep this as an "orientation", make it a mixin for Gantt instead

/**
 * @module Gantt/view/orientation/NewTaskRendering
 * @internal
 */

const releaseEventActions = {
  releaseElement: 1,
  // Not used at all at the moment
  reuseElement: 1 // Used by some other element

},
      renderEventActions = {
  newElement: 1,
  reuseOwnElement: 1,
  reuseElement: 1
},
      // Used to render more ticks than actually visible
horizontalTickBuffer = 100;
/**
 * Handles rendering of tasks, using the following strategy:
 *
 * 1. When a row is rendered, it collects a DOM config for its task bar and stores in a map (row -> config)
 * 2. When a rendering pass is done, it syncs the DOM configs from the map to DOM
 *
 * The need for caching with this approach is minimal, only the map needs to be kept up to date with available rows.
 *
 * @internal
 * @extends Core/Base
 */

class NewTaskRendering extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config & Init
  static get properties() {
    return {
      rowMap: new Map()
    };
  }

  construct(gantt) {
    this.gantt = gantt;
    gantt.rowManager.on({
      renderDone: 'onRenderDone',
      removeRows: 'onRemoveRows',
      beforeRowHeight: 'onBeforeRowHeightChange',
      renderRow: 'onRenderRow',
      thisObj: this
    });
    super.construct({});
  }

  init() {} //endregion
  //region View hooks


  bindTaskStore() {}

  refreshRows() {}

  onTimeAxisViewModelUpdate() {
    // Update view bounds
    this.updateFromHorizontalScroll(this.gantt.timeAxisSubGrid.scrollable.x);
  }

  onViewportResize() {}

  onDragAbort() {}

  onBeforeRowHeightChange(event) {
    const {
      gantt
    } = this;

    if (gantt.foregroundCanvas) {
      var _event$height;

      //gantt.element.classList.add('b-notransition');
      gantt.foregroundCanvas.style.fontSize = `${((_event$height = event === null || event === void 0 ? void 0 : event.height) !== null && _event$height !== void 0 ? _event$height : gantt.rowHeight) - gantt.resourceMargin * 2}px`; //gantt.element.classList.remove('b-notransition');
    }
  } //endregion
  //region Region & coordinates


  get visibleDateRange() {
    return this._visibleDateRange;
  } // TODO : Replace calls with generator below


  getTaskBox(taskRecord, includeOutside = false, inner = false) {
    const {
      gantt
    } = this,
          {
      isBatchUpdating
    } = taskRecord,
          startDate = isBatchUpdating ? taskRecord.get('startDate') : taskRecord.startDate,
          endDate = isBatchUpdating ? taskRecord.get('endDate') : taskRecord.endDate;

    if (inner) {
      const innerElement = this.getElementFromTaskRecord(taskRecord);

      if (innerElement) {
        return _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(innerElement, gantt.timeAxisSubGridElement);
      }
    } // A task that gets startDate during initial propagation, which seems not have happened yet.
    // Or a removed task (this fn is also used for baselines). Nothing to render then


    if (!startDate || !endDate || taskRecord.isTask && (gantt.taskStore.isDestroyed || !gantt.taskStore.isAvailable(taskRecord))) {
      return null;
    }

    const positionData = this.getSizeAndPosition(taskRecord, includeOutside, inner);

    if (!positionData) {
      return null;
    }

    const {
      position,
      width
    } = positionData,
          top = gantt.taskStore.indexOf(taskRecord.isBaseline ? taskRecord.task : taskRecord) * gantt.rowManager.rowOffsetHeight + gantt.resourceMargin,
          height = gantt.rowHeight - gantt.resourceMargin * 2,
          bounds = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](position, top, width, height); // Position always correct in Gantt, since there is no stacking

    bounds.layout = true;
    return bounds;
  } // returns an object with `position` + `width`. If task is not inside current time axis, position is -1


  getSizeAndPosition(taskRecord, includeOutside, inner) {
    var _gantt$features$depen;

    const me = this,
          {
      gantt
    } = me,
          {
      timeAxis
    } = gantt,
          viewStart = timeAxis.startDate,
          viewEnd = timeAxis.endDate,
          // Must use Model.get in order to get latest values in case we are inside a batch.
    // TaskResize changes the endDate using batching to enable a tentative change
    // via the batchedUpdate event which is triggered when changing a field in a batch.
    // Fall back to accessor if propagation has not populated date fields.
    taskStart = taskRecord.isBatchUpdating ? taskRecord.get('startDate') : taskRecord.startDate,
          // Might get here before engine has normalized
    taskEnd = taskRecord.isBatchUpdating ? taskRecord.get('endDate') : taskRecord.endDate || (taskRecord.duration != null ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].add(taskStart, taskRecord.duration, taskRecord.durationUnit) : null),
          isMilestone = taskRecord.milestone,
          // Ensure dependencies feature is present (=== false if not)
    horizontalAdjustment = isMilestone ? (_gantt$features$depen = gantt.features.dependencies.pathFinder) === null || _gantt$features$depen === void 0 ? void 0 : _gantt$features$depen.startArrowMargin : 0;
    let startCoordinate, endCoordinate; // Early bailout for tasks that are fully out of timeaxis

    if (!includeOutside && (taskEnd < viewStart || taskStart > viewEnd)) {
      return null;
    } // The calls using `includeOutside` are not used during task rendering, but when rendering dependencies.
    // In those cases the lines are expected to be drawn even to tasks fully out of view, clipped to view bounds


    if (includeOutside && taskStart < viewStart) {
      startCoordinate = gantt.getCoordinateFromDate(viewStart) - horizontalAdjustment;
    } else if (includeOutside && taskStart > viewEnd) {
      startCoordinate = gantt.getCoordinateFromDate(viewEnd) + horizontalAdjustment;
    } // Starts before view and ends in or after view, approximate startCoordinate
    else if (taskStart < viewStart) {
      const // Using seconds instead of ms in a try to not loose to much precision in year views
      pxPerSecond = gantt.timeAxisViewModel.getSingleUnitInPixels('second'),
            secondsOutOfView = (timeAxis.startMS - taskRecord.startDateMS) / 1000,
            // taskRecord.startDateMS is cached in TimeSpan
      pxOutOfView = secondsOutOfView * pxPerSecond;
      startCoordinate = gantt.getCoordinateFromDate(viewStart) - pxOutOfView;
    } // The "normal" case, somewhere in the timeaxis
    else {
      startCoordinate = gantt.getCoordinateFromDate(taskStart);
    }

    if (!isMilestone) {
      // Same logic applies to `includeOutside` for end date, clip to view
      if (includeOutside && taskEnd < viewStart) {
        endCoordinate = gantt.getCoordinateFromDate(viewStart) - horizontalAdjustment;
      } else if (includeOutside && taskEnd > viewEnd) {
        endCoordinate = gantt.getCoordinateFromDate(viewEnd) + horizontalAdjustment;
      } // Starts in or before view and ends outside, approximate end
      else if (taskEnd > viewEnd) {
        const pxPerSecond = gantt.timeAxisViewModel.getSingleUnitInPixels('second'),
              secondsOutOfView = (taskRecord.endDateMS - timeAxis.endMS) / 1000,
              // taskRecord.endDateMS is cached in TimeSpan
        pxOutOfView = secondsOutOfView * pxPerSecond;
        endCoordinate = gantt.getCoordinateFromDate(viewEnd) + pxOutOfView;
      } else {
        endCoordinate = gantt.getCoordinateFromDate(taskEnd);
      }
    }

    let width = isMilestone ? 0 : endCoordinate - startCoordinate; // Requesting diamond width, in viewport space

    if (inner && isMilestone && taskStart > viewStart && taskStart < viewEnd) {
      // By default as wide as it is high
      width = gantt.rowHeight - gantt.resourceMargin * 2;
      startCoordinate -= width / 2;
    }

    if (!includeOutside && startCoordinate + width < 0) {
      return null;
    }

    return {
      position: startCoordinate,
      width
    };
  } // * getTaskBoxReactive(taskRecord, includeOutside = false, inner = false) {
  //     const
  //         me        = this,
  //         { gantt } = me;
  //
  //     if (inner) {
  //         const innerElement = me.getElementFromTaskRecord(taskRecord);
  //         if (innerElement) {
  //             return Rectangle.from(innerElement, gantt.timeAxisSubGridElement);
  //         }
  //     }
  //
  //     // A task that gets startDate during initial propagation, which seems not have happened yet.
  //     // Nothing to render then
  //     if (!(yield taskRecord.$.startDate) || !(yield taskRecord.$.startDate)) {
  //         return null;
  //     }
  //
  //     const
  //         horizontalAdjustment = taskRecord.milestone ? gantt.features.dependencies.pathFinder.startArrowMargin : 0,
  //         viewRange = yield gantt.reactiveTimeAxis.$.dateRange,
  //         viewStart = viewRange.startDate,
  //         viewEnd   = viewRange.endDate,
  //         taskStart = yield taskRecord.$.startDate,
  //         // Might get here before engine has normalized
  //         taskEnd   = yield taskRecord.$.endDate,
  //         top       = gantt.taskStore.indexOf(taskRecord) * gantt.rowManager.rowOffsetHeight + gantt.barMargin,
  //         height    = gantt.rowHeight - gantt.barMargin * 2;
  //
  //     // First time, update time axis to match engine dates
  //     if (!gantt.timeAxis.hasDatesFromEngine) {
  //         gantt.timeAxis.setTimeSpan(viewStart, viewEnd);
  //         gantt.timeAxis.hasDatesFromEngine = true;
  //     }
  //
  //     let start, end = null;
  //
  //     // Clip to viewport
  //     if (includeOutside && taskStart < viewStart) {
  //         start = gantt.getCoordinateFromDate(viewStart) - horizontalAdjustment;
  //     }
  //     else if (includeOutside && taskStart > viewEnd) {
  //         start = gantt.getCoordinateFromDate(viewEnd) + horizontalAdjustment;
  //     }
  //     else {
  //         start = gantt.getCoordinateFromDate(taskStart);
  //     }
  //
  //     // Clip to viewport
  //     if (taskEnd) {
  //         if (includeOutside && taskEnd < viewStart) {
  //             end = gantt.getCoordinateFromDate(viewStart) - horizontalAdjustment;
  //         }
  //         else if (includeOutside && taskEnd > viewEnd) {
  //             end = gantt.getCoordinateFromDate(viewEnd) + horizontalAdjustment;
  //         }
  //         else {
  //             end = gantt.getCoordinateFromDate(taskEnd);
  //         }
  //     }
  //
  //     const width = end - start;
  //
  //     if (start + width < 0) {
  //         return null;
  //     }
  //
  //     return new Rectangle(start, top, width, height);
  // }


  getRowRegion(taskRecord, startDate, endDate) {
    const {
      gantt
    } = this,
          row = gantt.getRowFor(taskRecord); // might not be rendered

    if (!row) {
      return null;
    }

    const rowElement = row.getElement(gantt.timeAxisSubGrid.region),
          taStart = gantt.timeAxis.startDate,
          taEnd = gantt.timeAxis.endDate,
          start = startDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].max(taStart, startDate) : taStart,
          end = endDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].min(taEnd, endDate) : taEnd,
          startX = gantt.getCoordinateFromDate(start),
          endX = gantt.getCoordinateFromDate(end, true, true),
          y = row.top + gantt.scrollTop,
          x = Math.min(startX, endX),
          bottom = y + rowElement.offsetHeight;
    return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](x, y, Math.max(startX, endX) - x, bottom - y);
  }

  getDateFromXY(xy, roundingMethod, local) {
    let coord = xy[0];

    if (!local) {
      coord = this.translateToScheduleCoordinate(coord);
    }

    return this.gantt.timeAxisViewModel.getDateFromPosition(coord, roundingMethod);
  }

  translateToScheduleCoordinate(x) {
    // Get rid of fractional pixels, to not end up with negative fractional values for pos
    const pos = x - Math.floor(this.gantt.timeAxisSubGridElement.getBoundingClientRect().left);
    return pos + this.gantt.scrollLeft;
  }

  translateToPageCoordinate(x) {
    const element = this.gantt.timeAxisSubGridElement;
    return x + element.getBoundingClientRect().left - element.scrollLeft;
  } //endregion
  //region Element <-> Record mapping


  getElementFromTaskRecord(taskRecord, inner = true) {
    const wrapper = this.gantt.foregroundCanvas.syncIdMap[taskRecord.id];
    return inner ? wrapper === null || wrapper === void 0 ? void 0 : wrapper.syncIdMap.task : wrapper;
  } //endregion
  //region Dependency connectors
  // Cannot be moved from this file, called from currentOrientation.xx

  /**
   * Gets displaying item start side
   *
   * @param {Gantt.model.TaskModel} taskRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorStartSide(taskRecord) {
    return 'left';
  }
  /**
   * Gets displaying item end side
   *
   * @param {Gantt.model.TaskModel} taskRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorEndSide(taskRecord) {
    return 'right';
  } //endregion
  //region Rendering


  onRenderRow({
    row,
    record
  }) {
    // indicate inactive task rows
    row.assignCls({
      'b-inactive': record.inactive
    });
  }

  onRemoveRows({
    rows
  }) {
    rows.forEach(row => this.rowMap.delete(row));
    this.onRenderDone();
  } // Update header range on horizontal scroll. No need to draw any tasks, Gantt only cares about vertical scroll


  updateFromHorizontalScroll(scrollLeft) {
    const {
      gantt
    } = this,
          width = gantt.timeAxisSubGrid.width,
          startDate = gantt.getDateFromCoordinate(Math.max(0, scrollLeft - horizontalTickBuffer)),
          endDate = gantt.getDateFromCoordinate(scrollLeft + width + horizontalTickBuffer) || gantt.endDate,
          // Visible date range, determined from scroll with fallback to time axis (needed when zooming leaves
    // scrollLeft "out of range")
    visibleStartDate = gantt.getDateFromCoordinate(scrollLeft) || gantt.startDate,
          visibleEndDate = gantt.getDateFromCoordinate(scrollLeft + width) || gantt.endDate;

    if (visibleStartDate && !gantt._viewPresetChanging) {
      // timeRange start/end dates represent first/last rendered dates which could be outside of the view since
      // buffer is used. We need to additionally resolve actually visible start/end dates.
      this._visibleDateRange = {
        startDate: visibleStartDate,
        endDate: visibleEndDate
      }; // Update timeaxis header making it display the new dates

      const range = gantt.timeView.range = {
        startDate,
        endDate
      };
      gantt.onVisibleDateRangeChange(range);
      gantt.trigger('visibleRangeChange', range);
    }
  }

  populateTaskRenderData(renderData, taskRecord) {
    const me = this,
          {
      gantt
    } = me,
          baselinesDisabled = !!(gantt.features.baselines && gantt.features.baselines.disabled);
    const taskContent = {
      className: 'b-gantt-task-content',
      dataset: {
        taskBarFeature: 'content'
      },
      children: []
    };

    if (renderData) {
      let resizable = taskRecord.isResizable === undefined ? true : taskRecord.isResizable;

      if (renderData.startsOutsideView) {
        if (resizable === true) {
          resizable = 'end';
        } else if (resizable === 'start') {
          resizable = false;
        }
      }

      if (renderData.endsOutsideView) {
        if (resizable === true) {
          resizable = 'start';
        } else if (resizable === 'end') {
          resizable = false;
        }
      }

      Object.assign(renderData, {
        iconCls: new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"](taskRecord.taskIconCls),
        id: gantt.getEventRenderId(taskRecord),
        style: taskRecord.style || '',
        taskId: taskRecord.id,
        // Classes for the wrapping div
        wrapperCls: new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
          [gantt.eventCls + '-wrap']: 1,
          [`${gantt.eventCls}-parent`]: taskRecord.isParent,
          'b-milestone-wrap': taskRecord.milestone,
          'b-inactive': taskRecord.inactive,
          'b-has-baselines': taskRecord.hasBaselines && !baselinesDisabled
        }),
        // Task record cls property is now a DomClassList, so clone it
        // so that it can be manipulated here and by renderers.
        cls: taskRecord.isResourceTimeRange ? new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"]() : taskRecord.cls.clone(),
        // Extra DOMConfigs to add to the tasks row, for example for indicators
        extraConfigs: []
      }); // Gather event element classes as keys to add to the renderData.cls DomClassList.
      // Truthy value means the key will be added as a class name.

      Object.assign(renderData.cls, {
        [gantt.eventCls]: 1,
        [gantt.generatedIdCls]: taskRecord.hasGeneratedId,
        [gantt.dirtyCls]: taskRecord.modifications,
        [gantt.committingCls]: taskRecord.isCommitting,
        [gantt.endsOutsideViewCls]: renderData.endsOutsideView,
        [gantt.startsOutsideViewCls]: renderData.startsOutsideView,
        [gantt.fixedEventCls]: taskRecord.isDraggable === false,
        [`b-sch-event-resizable-${resizable}`]: 1,
        'b-milestone': taskRecord.milestone,
        // 'b-critical'                           : taskRecord.critical,
        'b-task-started': taskRecord.isStarted,
        'b-task-finished': taskRecord.isCompleted,
        'b-task-selected': gantt.selectedRecords.includes(taskRecord)
      });
      const eventStyle = taskRecord.eventStyle || gantt.eventStyle,
            eventColor = taskRecord.eventColor || gantt.eventColor;
      renderData.eventColor = eventColor;
      renderData.eventStyle = eventStyle;

      if (gantt.taskRenderer) {
        // User has specified a renderer fn, either to return a simple string, or an object
        const value = gantt.taskRenderer.call(gantt.taskRendererThisObj || gantt, {
          taskRecord,
          tplData: renderData,
          renderData
        }); // If the user's renderer coerced it into a string, recreate a DomClassList.

        if (typeof renderData.cls === 'string') {
          renderData.cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"](renderData.cls);
        } // Same goes for iconCls


        if (typeof renderData.iconCls === 'string') {
          renderData.iconCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"](renderData.iconCls);
        }

        if (typeof renderData.wrapperCls === 'string') {
          renderData.wrapperCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"](renderData.wrapperCls);
        }

        let childContent = null; // Likely HTML content

        if (_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isHtml(value)) {
          childContent = {
            tag: 'span',
            html: value
          };
        } // DOM config or plain string can be used as is
        else if (typeof value === 'string' || typeof value === 'object') {
          childContent = value;
        } // Other, use string
        else if (value != null) {
          childContent = String(value);
        }

        if (childContent) {
          if (Array.isArray(childContent)) {
            taskContent.children.push(...childContent);
          } else {
            taskContent.children.push(childContent);
          }

          renderData.cls.add('b-has-content');
        }
      } // If there are any iconCls entries...


      renderData.cls['b-sch-event-withicon'] = renderData.iconCls.length; // renderers have last say on style & color

      renderData.wrapperCls[`b-sch-style-${renderData.eventStyle}`] = renderData.eventStyle;

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isNamedColor(renderData.eventColor)) {
        renderData.wrapperCls[`b-sch-color-${renderData.eventColor}`] = renderData.eventColor;
      } else if (renderData.eventColor) {
        renderData.style = `background-color:${renderData.eventColor};` + renderData.style;
      }

      if (renderData.iconCls && renderData.iconCls.length) {
        taskContent.children.unshift({
          tag: 'i',
          className: renderData.iconCls
        });
      } // if we have some children collected or it's a milestone (milestone styling needs content element presence)


      if (taskContent.children.length || taskRecord.milestone) {
        renderData.children.push(taskContent);
      }
    }

    renderData.taskContent = taskContent;
    renderData.wrapperChildren = []; // Method which features may chain in to

    gantt.onTaskDataGenerated(renderData);
  } // * reactiveRenderer() {
  //     const
  //         { client, record : taskRecord, row } = this,
  //         me = client.taskRendering,
  //         box = yield* me.getTaskBoxReactive(taskRecord);
  //
  //     if (!box) {
  //         return;
  //     }
  //
  //     const
  //         data = {
  //             top      : box.top,
  //             left     : box.left,
  //             width    : box.width,
  //             height   : box.height,
  //             taskRecord,
  //             task     : taskRecord, // TODO: Deprecate
  //             row,
  //             children : []
  //         };
  //
  //     me.populateTaskRenderData(data, taskRecord);
  //
  //     const config = {
  //         className : data.wrapperCls,
  //         tabIndex  : '0',
  //         children  : [
  //             {
  //                 className   : data.cls,
  //                 style       : (data.internalStyle || '') + (data.style || ''),
  //                 // Used for cheaper element comparison
  //                 compareHtml : data.taskContent,
  //                 children    : data.children,
  //                 dataset     : {
  //                     // Each feature putting contents in the task wrap should have this to simplify syncing and element
  //                     // retrieval after sync
  //                     taskFeature : 'task'
  //                 }
  //             },
  //             ...data.wrapperChildren
  //         ],
  //         style : {
  //             transform : `translate(${data.left}px, ${data.top}px)`,
  //             // DomHelper appends px to dimensions when using numbers
  //             height    : data.height,
  //             width     : data.width,
  //             zIndex    : data.zIndex
  //         },
  //         dataset : {
  //             taskId : data.taskId
  //         },
  //         // Will not be part of DOM, but attached to the element
  //         elementData : data,
  //         // Dragging etc. flags element as retained, to not reuse/release it during that operation
  //         //retainElement : renderData.record.instanceMeta(this.gantt).retainElement
  //         syncOptions : {
  //             syncIdField      : 'taskFeature',
  //             // Remove instead of release when a feature is disabled
  //             releaseThreshold : 0
  //         }
  //     };
  //
  //     me.gantt.trigger('beforeRenderTask', { renderData : data, domConfig : config });
  //
  //     // Store DOM config
  //     me.rowMap.set(row, config);
  // }
  // Called per row in "view", collect configs


  renderer({
    row,
    record: taskRecord
  }) {
    const me = this,
          box = me.getTaskBox(taskRecord),
          data = {
      taskRecord,
      task: taskRecord,
      // TODO: Deprecate
      row,
      children: []
    };
    let config;

    if (box) {
      Object.assign(data, {
        isTask: true,
        top: box.top,
        left: box.left,
        width: box.width,
        height: box.height
      });
      me.populateTaskRenderData(data, taskRecord);
      config = {
        className: data.wrapperCls,
        tabIndex: '0',
        children: [{
          className: data.cls,
          style: (data.internalStyle || '') + (data.style || ''),
          children: data.children,
          dataset: {
            // Each feature putting contents in the task wrap should have this to simplify syncing and
            // element retrieval after sync
            taskFeature: 'task'
          },
          syncOptions: {
            syncIdField: 'taskBarFeature'
          }
        }, ...data.wrapperChildren],
        style: {
          transform: `translate(${data.left}px, ${data.top}px)`,
          // DomHelper appends px to dimensions when using numbers
          width: data.width,
          zIndex: data.zIndex
        },
        dataset: {
          taskId: data.taskId
        },
        // Will not be part of DOM, but attached to the element
        elementData: data,
        // Options for this level of sync, lower levels can have their own
        syncOptions: {
          syncIdField: 'taskFeature',
          // Remove instead of release when a feature is disabled
          releaseThreshold: 0
        }
      };
      me.gantt.trigger('beforeRenderTask', {
        renderData: data,
        domConfig: config
      });
    } else {
      // Calculate top position, used by Baselines feature to position its elements
      data.top = row.top + me.gantt.resourceMargin; // Task is not visible or is not scheduled (outside bounds of TimeAxis).

      me.populateTaskRenderData(data, taskRecord);
    }

    if (!box && data.extraConfigs.length === 0) {
      me.rowMap.delete(row);
      return;
    } // Store DOM configs


    me.rowMap.set(row, [config, ...data.extraConfigs]);
  } // Called when the current row rendering "pass" is complete, sync collected configs to DOM


  onRenderDone() {
    const {
      gantt
    } = this,
          configs = Array.from(this.rowMap.values()).flat(); // TODO: flat converted by babel?

    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].sync({
      domConfig: {
        onlyChildren: true,
        children: configs
      },
      targetElement: gantt.foregroundCanvas,
      syncIdField: 'taskId',

      // Called by DomHelper when it creates, releases or reuses elements
      callback({
        action,
        domConfig,
        lastDomConfig,
        targetElement: element
      }) {
        // If element is a task wrap, trigger appropriate events
        if (action !== 'none' && domConfig && domConfig.className && domConfig.className[gantt.eventCls + '-wrap']) {
          var _lastDomConfig$elemen, _domConfig$elementDat;

          const // Some actions are considered first a release and then a render (reusing another element).
          // This gives clients code a chance to clean up before reusing an element
          isRelease = releaseEventActions[action],
                isRender = renderEventActions[action]; // If we are reusing an element that was previously released we should not trigger again

          if (isRelease && lastDomConfig !== null && lastDomConfig !== void 0 && (_lastDomConfig$elemen = lastDomConfig.elementData) !== null && _lastDomConfig$elemen !== void 0 && _lastDomConfig$elemen.isTask) {
            const event = {
              renderData: lastDomConfig.elementData,
              taskRecord: lastDomConfig.elementData.taskRecord,
              element
            }; // This event is documented on Gantt

            gantt.trigger('releaseTask', event);
          } // Trigger only for actual tasks, not indicators or baselines


          if (isRender && domConfig !== null && domConfig !== void 0 && (_domConfig$elementDat = domConfig.elementData) !== null && _domConfig$elementDat !== void 0 && _domConfig$elementDat.isTask) {
            const event = {
              renderData: domConfig.elementData,
              taskRecord: domConfig.elementData.taskRecord,
              element
            };
            event.reusingElement = action === 'reuseElement'; // This event is documented on Gantt

            gantt.trigger('renderTask', event);
          }
        }
      }

    });
  } // Redraws a single task by rerendering its cell


  redraw(taskRecord) {
    // Refresh cell, will call `renderer` above and update its DOM config
    if (this.gantt.rowManager.refreshCell(taskRecord, this.gantt.timeAxisColumn.id)) {
      // Update DOM
      this.onRenderDone();
    }
  } //endregion


}
NewTaskRendering._$name = 'NewTaskRendering';

/***/ }),

/***/ "./lib/Gantt/widget/AssignmentField.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/widget/AssignmentField.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentField; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _AssignmentPicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AssignmentPicker.js */ "./lib/Gantt/widget/AssignmentPicker.js");
/* harmony import */ var _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/AssignmentsManipulationStore.js */ "./lib/Gantt/data/AssignmentsManipulationStore.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var productName = 'gantt';






/**
 * @module Gantt/widget/AssignmentField
 */

/**
 * Special field class to edit single event assignments.
 *
 * This field is used as the default editor for the {@link Gantt.column.ResourceAssignmentColumn ResourceAssignmentColumn}
 *
 * {@inlineexample Gantt/widget/AssignmentField.js}
 *
 * ## Customizing the drop down grid
 *
 * The field is a {@link Core/widget/Combo} which has a {@link Gantt/widget/AssignmentGrid} as its picker. Here's a
 * snippet showing how simple it is to configure the grid:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     appendTo                : 'container',
 *     resourceImageFolderPath : '../_shared/images/users/',
 *     columns                 : [
 *         { type : 'name', field : 'name', text : 'Name', width : 250 },
 *         {
 *             type        : 'resourceassignment',
 *             width       : 250,
 *             showAvatars : true,
 *             editor      : {
 *                 type   : 'assignmentfield',
 *                 // The picker config is applied to the Grid
 *                 picker : {
 *                     height   : 350,
 *                     width    : 450,
 *                     features : {
 *                         filterBar  : true,
 *                         group      : 'resource.city',
 *                         headerMenu : false,
 *                         cellMenu   : false
 *                     },
 *                     // The extra columns are concatenated onto the base column set.
 *                     columns : [{
 *                         text       : 'Calendar',
 *                         // Read a nested property (name) from the resource calendar
 *                         field      : 'resource.calendar.name',
 *                         filterable : false,
 *                         editor     : false,
 *                         width      : 85
 *                     }]
 *                 }
 *             }
 *         }
 *     ],
 *
 *     project
 *  });
 * ```
 *
 * @extends Core/widget/Combo
 * @classType 'assignmentfield'
 * @demo Gantt/resourceassignment
 */

class AssignmentField extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AssignmentField';
  } // Factoryable type name


  static get type() {
    return 'assignmentfield';
  } //region Config


  static get configurable() {
    return {
      // Let the editor know that the selectable records are also editable
      editingRecords: true,
      chipView: {
        cls: 'b-assignment-chipview',

        itemTpl(assignment, i) {
          return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].xss`${assignment.resourceName} ${Math.round(assignment.units)}%`;
        },

        scrollable: {
          overflowX: 'hidden-scroll'
        }
      },
      triggers: {
        expand: {
          cls: 'b-icon-down',
          handler: 'onTriggerClick'
        }
      },
      multiSelect: true,
      clearable: false,
      // TODO: change when it's back to editable
      editable: false,
      value: null,

      /**
       * A config object used to configure the {@link Gantt.widget.AssignmentGrid assignment grid}
       * used to select resources to assign.
       *
       * Any `columns` provided are concatenated onto the default column set.
       * @config {Object|Gantt.widget.AssignmentGrid} picker
       */
      picker: {
        type: _AssignmentPicker_js__WEBPACK_IMPORTED_MODULE_2__["default"].type,
        floating: true,
        scrollAction: 'realign'
      },

      /**
       * Width of picker, defaults to this field's {@link Core/widget/PickerField#config-pickerAlignElement} width
       *
       * @config {Number}
       */
      pickerWidth: null,

      /**
       * Event to load resource assignments for.
       * Either event or {@link #config-store store} should be given.
       *
       * @config {Gantt.model.TaskModel}
       */
      projectEvent: null,

      /**
       * Assignment manipulation store to use or it's configuration object.
       * Either store or {@link #config-projectEvent projectEvent} should be given
       *
       * @config {Core.data.Store|Object}
       */
      store: {}
    };
  } //endregion
  // Any change must offer the save/cancel UI since THAT is what actually makes the edit


  onChipClose(records) {
    this.showPicker();
    this.picker.deselectRows(records);
  }

  syncInputFieldValue() {
    super.syncInputFieldValue();

    if (this.store) {
      this.tooltip = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].encodeHtml(this.store.toValueString());
    }
  } //region Picker
  // Override. This field does not have a primary filter, so
  // down arrow/trigger click should just show the picker.


  onTriggerClick(event) {
    if (this.pickerVisible) {
      this.hidePicker();
    } else {
      _Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.showPicker.call(this, event && 'key' in event);
    }
  }

  focusPicker() {
    this.picker.focus();
  }

  changePicker(picker, oldPicker) {
    const me = this;
    return _AssignmentPicker_js__WEBPACK_IMPORTED_MODULE_2__["default"].reconfigure(oldPicker, picker, {
      owner: me,
      defaults: {
        projectEvent: me.projectEvent,
        store: me.store,
        readOnly: me.readOnly,
        owner: me,
        resourceImagePath: me.resourceImageFolderPath,
        forElement: me[me.pickerAlignElement],
        assignments: me.valueCollection,

        onCancelClick() {
          me.value = this.originalSelected;
          this.hide();
        },

        align: {
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement]
        },
        listeners: {
          hide: () => {
            if (!me.isDestroying) {
              me.store.clearFilters();
            }
          }
        }
      }
    });
  } //endregion
  //region Value


  changeProjectEvent(projectEvent) {
    // NOTE: This kind of thing would normally be handled in updateProjectEvent, however, the setter of the
    //  AssignmentManipulationStore pulls double duty and resyncs some fields, even if presented with the same
    //  projectEvent.
    const {
      picker,
      store
    } = this;
    this._projectEvent = projectEvent;

    if (store) {
      store.projectEvent = projectEvent;
    }

    if (picker) {
      picker.projectEvent = projectEvent;
    }

    return projectEvent;
  }

  changeStore(store) {
    if (store && !(store instanceof _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      store = new _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__["default"](store);
    }

    return store;
  }

  updateStore(store) {
    const me = this;
    me.detachListeners('storeMutation');

    if (store instanceof _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
      const {
        projectEvent
      } = store;

      if (projectEvent) {
        me.projectEvent = projectEvent;
      } else {
        // This is to not do the store::fillFromMaster() call, otherwise editor will be unhappy
        store.projectEvent = me.projectEvent;
      }
    }

    store.on({
      name: 'storeMutation',
      change: 'syncInputFieldValue',
      thisObj: me
    });
  } // This return an array of special Assignment records created
  // by the picker / grid


  get value() {
    return super.value;
  }

  set value(assignments) {
    var _assignments;

    // either real (=== currently assigned resources)
    // Or to-be assigned resources coming from the assignment grid
    // Map over to the special assignment records created by the AssignmentGrid store
    assignments = (_assignments = assignments) === null || _assignments === void 0 ? void 0 : _assignments.map(as => {
      const _as$data = as.data,
            _as$constructor$idFie = as.constructor.idField,
            {
        [_as$constructor$idFie]: notUsed,
        event,
        resource,
        eventId,
        resourceId
      } = _as$data,
            data = _objectWithoutProperties(_as$data, [_as$constructor$idFie, "event", "resource", "eventId", "resourceId"].map(_toPropertyKey)),
            ourStoreVersion = this.store.find(a => a.resource === as.resource, true);

      ourStoreVersion === null || ourStoreVersion === void 0 ? void 0 : ourStoreVersion.set(data);
      return ourStoreVersion;
    });
    super.value = assignments;
  }

  hasChanged(initialValue, value) {
    return !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isEqual(initialValue, value);
  } //endregion
  // Override. Picker is completely self-contained. Prevent any
  // field action on its key events.


  onPickerKeyDown(event) {
    const grid = this.picker; // Move "down" into the grid body

    if (event.key === 'ArrowDown' && event.target.compareDocumentPosition(grid.bodyContainer) === document.DOCUMENT_POSITION_FOLLOWING) {
      grid.element.focus();
    }
  } // Caching a copy of each record since the grid picker of this class will allow editing
  // A change to the records will constitute a change of this field


  cacheCurrentValue(records) {
    if (Array.isArray(records)) {
      return this._value = records.map(rec => rec.copy(rec.id));
    }

    return super.cacheCurrentValue(records);
  }

} // Register this widget type with its Factory

AssignmentField.initClass();
AssignmentField._$name = 'AssignmentField';

/***/ }),

/***/ "./lib/Gantt/widget/AssignmentGrid.js":
/*!********************************************!*\
  !*** ./lib/Gantt/widget/AssignmentGrid.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentGrid; });
/* harmony import */ var _Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/view/Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony import */ var _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/column/NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/AssignmentsManipulationStore.js */ "./lib/Gantt/data/AssignmentsManipulationStore.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Gantt/model/AssignmentModel.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _Gantt_localization_En_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Gantt/localization/En.js */ "./lib/Gantt/localization/En.js");
/* harmony import */ var _Gantt_column_ResourceAssignmentGridResourceColumn_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Gantt/column/ResourceAssignmentGridResourceColumn.js */ "./lib/Gantt/column/ResourceAssignmentGridResourceColumn.js");
var productName = 'gantt';









/**
 * @module Gantt/widget/AssignmentGrid
 */

/**
 * This grid visualizes and lets users edit assignments of an {@link #config-projectEvent event}. Used by the
 * {@link Gantt.widget.AssignmentField}. This grid shows one column showing the resource name, and one showing
 * the units assigned. You can add additional columns by providing a {@link Grid.view.Grid#config-columns} array in your grid config.
 *
 * {@inlineexample Gantt/widget/AssignmentGrid.js}
 * @extends Grid/view/Grid
 * @classType assignmentgrid
 */

class AssignmentGrid extends _Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AssignmentGrid';
  } // Factoryable type name


  static get type() {
    return 'assignmentgrid';
  } //region Config


  static get configurable() {
    return {
      // Required by ResourceInfo column
      resourceImageExtension: '.jpg',
      minHeight: 200,

      /**
       * A {@link Grid.column.Column} config object for the resource column. You can pass a `renderer` which
       * gives you access to the `resource` record.
       *
       * @config {Object}
       */
      resourceColumn: {
        type: 'assignmentResource'
      },

      /**
       * A config object for the units column
       *
       * @config {Object}
       */
      unitsColumn: {
        field: 'units',
        type: _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"].type,
        text: 'L{Units}',
        localeClass: this,
        width: 70,
        min: 0,
        max: 100,
        step: 10,
        unit: '%',
        renderer: ({
          value
        }) => this.L('L{unitsTpl}', {
          value: Math.round(value)
        }),
        filterable: false
      }
    };
  }

  static get defaultConfig() {
    return {
      selectionMode: {
        rowCheckboxSelection: true,
        multiSelect: true,
        showCheckAll: true
      },
      // If enabled blocks header checkbox click event
      features: {
        group: false,
        filterBar: true,
        contextMenu: false
      },
      disableGridRowModelWarning: true,

      /**
       * Event model to manipulate assignments of, the task should be part of a task store.
       * Either task or {@link Grid/view/Grid#config-store store} should be given.
       *
       * @config {Gantt.model.TaskModel}
       */
      projectEvent: null
    };
  } //endregion


  construct() {
    super.construct(...arguments);
    this.on('selectionchange', ({
      selected,
      deselected
    }) => {
      selected.forEach(assignment => assignment.units = assignment.units || assignment.getFieldDefinition('units').defaultValue);
      deselected.forEach(assignment => {
        if (this.store.includes(assignment)) {
          assignment.units = 0;
        }
      });
    });
  }

  get projectEvent() {
    const me = this,
          store = me.store;
    let projectEvent = me._projectEvent;

    if (store && projectEvent !== store.projectEvent) {
      projectEvent = me._projectEvent = store.projectEvent;
    }

    return projectEvent;
  }

  set projectEvent(projectEvent) {
    const me = this;
    me._projectEvent = projectEvent;
    me.store.projectEvent = projectEvent;

    if (projectEvent) {
      me.selectedRecords = me.store.query(as => projectEvent.assignments.find(existingAs => existingAs.resource === as.resource));
    }
  }

  get store() {
    return super.store;
  }

  set store(store) {
    const me = this,
          oldStore = me.store;

    if (store && oldStore !== store) {
      var _me$storeDetacher;

      if (!(store instanceof _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
        var _me$_projectEvent;

        store = _data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_3__["default"].new({
          modelClass: ((_me$_projectEvent = me._projectEvent) === null || _me$_projectEvent === void 0 ? void 0 : _me$_projectEvent.assignmentStore.modelClass) || _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__["default"],
          projectEvent: me._projectEvent
        }, store);
      }

      super.store = store;
      (_me$storeDetacher = me.storeDetacher) === null || _me$storeDetacher === void 0 ? void 0 : _me$storeDetacher.call(me);
      me.storeDetacher = store.on('update', me.onAssignmentUpdate, me);
    }
  }

  set columns(columns) {
    if (columns) {
      // Clone is needed to flatten the properties from the prototype chain, the Model class wants data
      // in a flat simple object
      columns.unshift(_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(this.resourceColumn), _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(this.unitsColumn));
    }

    super.columns = columns;
  }

  get columns() {
    return super.columns;
  }

  onAssignmentUpdate({
    record,
    changes
  }) {
    const {
      units
    } = changes; // Sync selection while cell editing

    if (units) {
      if (!units.value) {
        this.deselectRow(record);
      } else if (units.oldValue === 0) {
        this.selectRow({
          record,
          scrollIntoView: false,
          addToSelection: true
        });
      }
    }
  }

} // Register this widget type with its Factory

AssignmentGrid.initClass();
AssignmentGrid._$name = 'AssignmentGrid';

/***/ }),

/***/ "./lib/Gantt/widget/AssignmentPicker.js":
/*!**********************************************!*\
  !*** ./lib/Gantt/widget/AssignmentPicker.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentPicker; });
/* harmony import */ var _AssignmentGrid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AssignmentGrid.js */ "./lib/Gantt/widget/AssignmentGrid.js");
/* harmony import */ var _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';





/**
 * @module Gantt/widget/AssignmentPicker
 */

/**
 * Class for assignment field dropdown, wraps {@link Gantt/widget/AssignmentGrid} within a frame and adds two buttons: Save and Cancel
 * @private
 */

class AssignmentPicker extends _AssignmentGrid_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AssignmentPicker';
  } // Factoryable type name


  static get type() {
    return 'assignmentpicker';
  }

  static get defaultConfig() {
    return {
      /**
       * A config object used to modify the {@link Gantt.widget.AssignmentGrid assignment grid}
       * used to select resources to assign.
       *
       * This config is merged with the configuration of the picker's assignment grid, so features
       * can be added (or default features removed by using `featureName : false`).
       *
       * Any `columns` provided are concatenated onto the default column set.
       * @deprecated 5.0 AssignmentPicker *is* a grid so configure this class directly
       * @config {Object} [grid]
       */
      focusable: true,
      trapFocus: true,
      height: '20em',
      minWidth: '25em',
      bbar: [{
        type: 'button',
        text: this.L('L{Object.Save}'),
        localeClass: this,
        ref: 'saveBtn',
        color: 'b-green'
      }, {
        type: 'button',
        text: this.L('L{Object.Cancel}'),
        localeClass: this,
        ref: 'cancelBtn',
        color: 'b-gray'
      }],

      /**
       * The Event to load resource assignments for.
       * Either an Event or {@link #config-store store} should be given.
       *
       * @config {Gantt.model.TaskModel}
       */
      projectEvent: null,

      /**
       * Store for the picker.
       * Either store or {@link #config-projectEvent projectEvent} should be given
       *
       * @config {Gantt.data.AssignmentsManipulationStore}
       */
      store: null
    };
  }

  configure(config) {
    let gridExtraConfig = config.grid;

    if (gridExtraConfig) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Gantt', '5.0.0', 'The `grid` config is deprecated, you can now set the config properties directly on this AssignmentPicker since it *is* the Grid'); // Columns is an array, and won't merge, so concat it before.

      if (gridExtraConfig.columns) {
        config.columns = gridExtraConfig.columns || []; // We must not mutate config objects owned by outside classes.

        gridExtraConfig = Object.assign({}, gridExtraConfig);
        delete gridExtraConfig.columns;
      } // Merge the AssignmentField's grid config into the default.


      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(config, gridExtraConfig);
    }

    config.selectedRecordCollection = config.assignments;
    super.configure(config);
  }

  show() {
    this.originalSelected = this.selectedRecords.map(a => a.copy());
    return super.show();
  }

  afterConfigure() {
    var _me$bbar$widgetMap$sa, _me$bbar$widgetMap$ca;

    const me = this;
    super.afterConfigure();
    (_me$bbar$widgetMap$sa = me.bbar.widgetMap.saveBtn) === null || _me$bbar$widgetMap$sa === void 0 ? void 0 : _me$bbar$widgetMap$sa.on('click', me.onSaveClick, me);
    (_me$bbar$widgetMap$ca = me.bbar.widgetMap.cancelBtn) === null || _me$bbar$widgetMap$ca === void 0 ? void 0 : _me$bbar$widgetMap$ca.on('click', me.onCancelClick, me);
  } //region Event handlers


  onSaveClick() {
    this.hide();
  }

  onCancelClick() {
    this.hide();
  } //endregion


} // Register this widget type with its Factory

AssignmentPicker.initClass();
AssignmentPicker._$name = 'AssignmentPicker';

/***/ }),

/***/ "./lib/Gantt/widget/CalendarPicker.js":
/*!********************************************!*\
  !*** ./lib/Gantt/widget/CalendarPicker.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarPicker; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


/**
 * @module Gantt/widget/CalendarPicker
 */

/**
 * Combo box preconfigured with possible calendar values.
 *
 * This field can be used as an editor for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Gantt.column.CalendarColumn CalendarColumn}.
 * Note: This picker doesn't support {@link Core/widget/Combo#config-multiSelect multiSelect}
 *
 * {@inlineexample Gantt/widget/CalendarPicker.js}
 * @extends Core/widget/Combo
 * @classType calendarpicker
 */

class CalendarPicker extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CalendarPicker';
  } // Factoryable type name


  static get type() {
    return 'calendarpicker';
  }
  /**
   * Replaces the field store records with the provided ones.
   * @param {Gantt.model.CalendarModel[]} calendars New contents for the widget store.
   */


  refreshCalendars(calendars) {
    this.store.data = calendars.map(c => {
      return {
        id: c.id,
        text: c.name
      };
    });
  }

  get store() {
    if (!this._store) {
      this.store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
    }

    return this._store;
  }

  set store(store) {
    super.store = store;
  }

  get value() {
    return super.value;
  }

  set value(value) {
    if (value) {
      if (value.isDefault && value.isDefault()) {
        value = null;
      } else if (value.id) {
        value = value.id;
      }
    }

    super.value = value;
  }

} // Register this widget type with its Factory

CalendarPicker.initClass();
CalendarPicker._$name = 'CalendarPicker';

/***/ }),

/***/ "./lib/Gantt/widget/DependencyField.js":
/*!*********************************************!*\
  !*** ./lib/Gantt/widget/DependencyField.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyField; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Scheduler/feature/Dependencies.js */ "./lib/Scheduler/feature/Dependencies.js");
var productName = 'gantt';









/**
 * @module Gantt/widget/DependencyField
 */
// Enables toggling of link type for each side

const toggleTypes = {
  from: [2, 3, 0, 1],
  to: [1, 0, 3, 2]
},
      fromTo = {
  from: 1,
  to: 1
},
      buildDependencySuffixRe = () => new RegExp(`(${dependencyTypes.join('|')})?((?:[+-])\\d+[a-z]*)?`, 'i'); // For parsing dependency strings and converting string to type.
// dependencyTypes may be localized in the Gantt class domain
// in which case the Regex is generated from the four local values.
// TODO Move to static class field?


let dependencyTypes = ['SS', 'SF', 'FS', 'FF'],
    dependencySuffixRe = buildDependencySuffixRe();
/**
 * Chooses dependencies, connector sides and lag time for dependencies of a Task.
 *
 * This field can be used as an editor for the {@link Grid/column/Column}.
 * It is used as the default editor for the {@link Gantt/column/DependencyColumn}.
 *
 * The contextual task is the `record` property of this field's {@link Core/widget/Widget#property-owner}.
 *
 * {@inlineexample Gantt/widget/DependencyField.js}
 * @extends Core/widget/Combo
 * @classType predecessor
 */

class DependencyField extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'DependencyField';
  } // Factoryable type name


  static get type() {
    return 'dependencyfield';
  }

  static get configurable() {
    return {
      listCls: 'b-predecessor-list',
      displayField: 'name',
      valueField: 'name',
      picker: {
        floating: true,
        scrollAction: 'realign',
        itemsFocusable: false,
        activateOnMouseover: true,
        align: {
          align: 't0-b0',
          axisLock: true
        },
        maxHeight: 324,
        minHeight: 161,
        scrollable: {
          overflowY: true
        },
        autoShow: false,
        focusOnHover: false
      },

      /**
       * Delimiter between dependency ids in the field
       * @config {String}
       * @default
       */
      delimiter: ';',

      /**
       * The dependency store
       * @config {Gantt.data.DependencyStore}
       * @default
       */
      dependencyStore: null,

      /**
       * The other task's relationship with this field's contextual task.
       * This will be `'from'` if we are editing predecessors, and `'to'` if
       * we are editing successors.
       * @config {String}
       */
      otherSide: null,

      /**
       * This field's contextual task's relationship with the other task.
       * This will be `'to'` if we are editing predecessors, and `'from'` if
       * we are editing successors.
       * @config {String}
       */
      ourSide: null,
      multiSelect: true,
      chipView: null,

      /**
       * A task field (id, wbsCode, sequenceNumber etc) that will be used when displaying and editing linked tasks. Defaults to {@link Gantt/view/GanttBase#config-dependencyIdField Gantt#dependencyIdField}
       * @config {String}
       */
      dependencyIdField: null,

      /**
       * The task whose dependencies are being edited (used to filter out invalid options)
       * @config {String}
       * @internal
       */
      eventRecord: null,

      /**
       * The sorters defining how to sort tasks in the drop down list, defaults to sorting by `name` field ascending.
       * See {@link Core.data.mixin.StoreSort} for more information.
       * @config {Object[]|String[]}
       */
      sorters: [{
        field: 'name'
      }]
    };
  } //endregion


  construct(config) {
    const me = this,
          {
      ourSide,
      otherSide
    } = config;
    me.dependencies = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      extraKeys: otherSide
    });
    me.startCollection = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      extraKeys: otherSide
    });
    super.construct(config);
    me.delimiterRegEx = new RegExp(`\\s*${me.delimiter}\\s*`);

    const localizeDependencies = () => {
      dependencyTypes = me.L('L{DependencyType.short}');
      dependencySuffixRe = buildDependencySuffixRe();
      me.syncInputFieldValue();
    }; // Update when changing locale


    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].on({
      locale: localizeDependencies,
      thisObj: me
    });
    localizeDependencies();
  }

  internalOnInput() {
    // Avoid combo filtering. That's done from our FilterField
    if (this.isValid) {
      this.clearError();
      _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_3__["default"].prototype.internalOnInput.call(this);
    } else {
      this.setError('L{invalidDependencyFormat}');
    }
  }

  onInternalKeyDown(keyEvent) {
    const {
      key
    } = keyEvent; // Don't pass Enter down, that selects when ComboBox passes it down
    // to its list. We want default action on Enter.
    // Our list has its own, built in filter field which provides key events.

    if (key !== 'Enter') {
      super.onInternalKeyDown && super.onInternalKeyDown(keyEvent);
    }

    if (this.pickerVisible && key === 'ArrowDown') {
      this.filterField.focus();
    }
  }

  onTriggerClick() {
    if (this.pickerVisible) {
      super.onTriggerClick();
    } else {
      this.doFilter(this.filterInput ? this.filterInput.value : null);
    }
  }

  changeStore(store) {
    // Filter the store to hide the field's Task
    store = store.makeChained(record => !this.eventRecord || record.id !== this.eventRecord.id, null, {
      excludeCollapsedRecords: false
    });
    store.sort(this.sorters);
    return super.changeStore(store);
  }

  changePicker(picker, oldPicker) {
    const me = this,
          myInput = me.input,
          filterField = me.filterField || (me.filterField = new _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      cls: 'b-dependency-list-filter',
      owner: me,
      clearable: true,
      placeholder: 'Filter',
      triggers: {
        filter: {
          cls: 'b-icon b-icon-filter',
          align: 'start'
        }
      },
      listeners: {
        input({
          value
        }) {
          me.input = filterFieldInput;
          me.filterList(value);
          me.input = myInput;
        },

        clear() {
          me.input = filterFieldInput;
          me.filterList();
          me.input = myInput;
        }

      }
    })),
          filterFieldInput = me.filterInput = filterField.input,
          result = DependencyField.reconfigure(oldPicker, picker ? _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].merge({
      owner: me,
      store: me.store,
      cls: `b-dependency-list ${me.listCls}`,
      itemTpl: me.listItemTpl,
      forElement: me[me.pickerAlignElement],
      align: {
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement]
      },
      navigator: {
        keyEventTarget: filterFieldInput,
        processEvent: e => {
          if (e.key === 'Escape') {
            me.hidePicker();
          } else {
            return e;
          }
        }
      },
      onItem: me.onPredecessorClick.bind(me),
      getItemClasses: function (task) {
        const result = _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.getItemClasses.call(this, task),
              dependency = me.dependencies.getBy(me.otherSide + 'Event', task),
              cls = dependency ? ` b-selected b-${dependency.getConnectorString(1).toLowerCase()}` : '';
        return result + cls;
      }
    }, picker) : null, me); // May have been set to null (destroyed)

    if (result) {
      filterField.render(result.contentElement);
    } // If it has been destroyed, destroy orphaned filterField
    else {
      me.destroyProperties('filterField');
    }

    return result;
  }

  showPicker(focusPicker) {
    // Ensure this field's Task is filtered out.
    // See our set store which owns the chainedFilterFn.
    this.store.fillFromMaster();
    super.showPicker(focusPicker);
  }

  onPickerShow({
    source: picker
  }) {
    const me = this,
          filterField = me.filterField,
          ourInput = me.input;
    picker.minWidth = me[me.pickerAlignElement].offsetWidth;
    picker.contentElement.insertBefore(filterField.element, picker.contentElement.firstChild); // Combo superclass focuses this.input upon picker show.
    // This must focus the filter field, not the predecessor text.

    me.input = me.filterInput;
    super.onPickerShow();
    me.input = ourInput;
  }

  listItemTpl(task) {
    const taskName = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].encodeHtml(task.name),
          idField = this.owner.dependencyIdField && this.owner.dependencyIdField !== task.constructor.idField ? this.owner.dependencyIdField : task.constructor.idField,
          // Don't output generated ids in the list
    taskIdentifier = !task.isPhantom ? String(task[idField]) : '';
    return `<div class="b-predecessor-item-text">${taskName} ${taskIdentifier.length ? `(${taskIdentifier})` : ''}</div>
            <div class="b-sch-box b-from" data-side="from"></div>
            <div class="b-sch-box b-to" data-side="to"></div>`;
  }

  get isValid() {
    return Boolean(!this.task || this.parseDependencies(this.input.value));
  }

  set value(dependencies) {
    const me = this,
          dependenciesCollection = me.dependencies; // Convert strings, eg: '1fs-2h;2ss+1d' to Dependency records

    if (typeof dependencies === 'string') {
      me.input.value = dependencies;
      dependencies = me.parseDependencies(dependencies);

      if (!dependencies) {
        me.syncInvalid();
        return;
      }

      dependencies = dependencies.map(dep => new me.dependencyStore.modelClass(dep));
    } else {
      me.startCollection.clear();
      me.startCollection.values = dependencies;
    }

    dependenciesCollection.clear();
    dependenciesCollection.values = dependencies; // If there has been a change, update the textual value.

    if (!me.inputting) {
      me.syncInputFieldValue();
    }
  }

  get value() {
    return this.dependencies.values;
  }

  get inputValue() {
    return this.constructor.dependenciesToString(this.dependencies.values, this.otherSide, this.delimiter, this.dependencyIdField);
  }

  onPredecessorClick({
    source: list,
    item,
    record: task,
    event
  }) {
    const me = this,
          dependencies = me.dependencies,
          box = event.target.closest('.b-sch-box'),
          side = box && box.dataset.side;
    let dependency = dependencies.getBy(me.otherSide + 'Event', task); // Prevent regular selection continuing after this click handler.

    item.dataset.noselect = true; // Click text to remove predecessor completely

    if (dependency && !box) {
      dependencies.remove(dependency);
    } else {
      // Clicking a connect side box toggles that
      if (dependency) {
        // We must create a clone because the record is "live".
        // Updates to it go back to the UI.
        // Also we cannot really modify record here. When editing will finish editor will compare `toJSON`
        // output of models, which refers to the `model.data` field. And if we modify record instance, change
        // won't go to the data object, it will be kept in the field though. Only way to sync model.data.type and
        // model.type here is to instantiate model with correct data already
        const {
          id,
          type
        } = dependency; // Using private argument here to avoid copying record current values, we're only interested in data object

        dependency = dependency.copy({
          id,
          type: toggleTypes[side][type]
        }, {
          skipFieldIdentifiers: true
        }); // HACK: Above code results having serialized values in `${me.otherSide}Event` field
        // and we expect to find task instance when doing code like:
        //     dependencies.getBy(me.otherSide + 'Event', task)
        // So let's put the task instance there manually.

        dependency[`${me.otherSide}Event`] = task;
        dependency[`${me.ourSide}Event`] = me.task; // Replace the old predecessor link with the new, modified one.
        // Collection will *replace* in-place due to ID matching.

        dependencies.add(dependency);
      } // Create a new dependency to/from the clicked task
      else {
        dependencies.add(me.dependencyStore.createRecord({
          [`${me.otherSide}Event`]: task,
          [`${me.ourSide}Event`]: me.task
        }, true));
      }
    }

    me.syncInputFieldValue();
    list.refresh();
  }

  static dependenciesToString(dependencies, side, delimiter = ';', eventIdField = 'id') {
    const eventField = `${side}Event`;

    const getEventId = dependency => {
      const event = dependency[eventField];
      return event !== null && event !== void 0 && event.isModel ? event[eventIdField] : event || '';
    };

    if (dependencies !== null && dependencies !== void 0 && dependencies.length) {
      const result = dependencies.sort((a, b) => getEventId(a) - getEventId(b)).map(dependency => `${getEventId(dependency)}${_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_8__["default"].getLocalizedDependencyType(dependency.getConnectorString())}${dependency.getLag()}`);
      return result.join(delimiter);
    }

    return '';
  } // static * dependenciesToStringGenerator(dependencies, otherSide, delimiter = ';') {
  //     const result = [];
  //
  //     if (dependencies && dependencies.length) {
  //         for (const dependency of dependencies) {
  //             const
  //                 otherSideEvent = yield dependency.$[otherSide + 'Event'],
  //                 otherSideEventId = otherSideEvent ? otherSideEvent.id : (otherSideEvent || '');
  //
  //             result.push(`${otherSideEventId}${yield dependency.getConnectorString()}${dependency.getLag()}`);
  //         }
  //     }
  //
  //     return result.join(delimiter);
  // }


  get task() {
    var _this$owner;

    return (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.record;
  }

  parseDependencies(value) {
    const me = this,
          task = me.task,
          taskStore = me.store,
          dependencyStore = me.dependencyStore,
          dependencies = value.split(me.delimiterRegEx),
          DependencyModel = dependencyStore.modelClass,
          result = [];

    for (let i = 0; i < dependencies.length; i++) {
      const dependencyText = dependencies[i];

      if (dependencyText) {
        let idLen = dependencyText.length + 1,
            linkedTaskId,
            linkedTask = null;

        for (; idLen && !linkedTask; idLen--) {
          linkedTaskId = dependencyText.substr(0, idLen);
          linkedTask = taskStore.find(task => String(task[me.dependencyIdField]) === linkedTaskId, true);
        }

        if (!linkedTask) {
          return null;
        } // Chop off connector and lag specification, i.e. the "SS-1h" part


        const remainder = dependencyText.substr(idLen + 1),
              // Start the structure of the dependency we are describing
        dependency = {
          // This will be "from" if we're editing predecessors
          // and "to" if we're editing successors
          [`${me.otherSide}Event`]: linkedTask,
          // This will be "to" if we're editing predecessors
          // and "from" if we're editing successors
          [`${me.ourSide}Event`]: task,
          type: DependencyModel.Type.EndToStart
        }; // There's a trailing edge/lag spec

        if (remainder.length) {
          const edgeAndLag = dependencySuffixRe.exec(remainder);

          if (edgeAndLag && (edgeAndLag[1] || edgeAndLag[2])) {
            // The SS/FF bit
            if (edgeAndLag[1]) {
              dependency.type = dependencyTypes.indexOf(edgeAndLag[1].toUpperCase());
            } // The -1h bit


            if (edgeAndLag[2]) {
              const parsedLag = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].parseDuration(edgeAndLag[2], true, task.durationUnit);
              dependency.lag = parsedLag.magnitude;
              dependency.lagUnit = parsedLag.unit;
            }
          } else {
            return null;
          }
        }

        result.push(dependency);
      }
    }

    return result;
  }

  doDestroy() {
    this.dependencies.destroy();
    this.startCollection.destroy();
    super.doDestroy();
  }

}
; // Register this widget type with its Factory

DependencyField.initClass();
DependencyField._$name = 'DependencyField';

/***/ }),

/***/ "./lib/Gantt/widget/TaskEditor.js":
/*!****************************************!*\
  !*** ./lib/Gantt/widget/TaskEditor.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEditor; });
/* harmony import */ var _SchedulerPro_widget_GanttTaskEditor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../SchedulerPro/widget/GanttTaskEditor.js */ "./lib/SchedulerPro/widget/GanttTaskEditor.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';


/**
 * @module Gantt/widget/TaskEditor
 */

/**
 * Provides a UI to edit tasks in a popup dialog. It is implemented as a Tab Panel with
 * several preconfigured built-in tabs. Although the default configuration may be adequate
 * in many cases, the Task Editor is easily configurable.
 *
 * To hide built-in tabs or to add custom tabs, or to append widgets to any of the built-in tabs
 * use the {@link Gantt.feature.TaskEdit#config-items items} config.
 *
 * The Task editor contains tabs by default. Each tab is a container with built in widgets: text fields, grids, etc.
 *
 * | Tab ref           | Text         | Weight | Description                                                                         |
 * |-------------------|--------------|--------|-------------------------------------------------------------------------------------|
 * | `generalTab`      | General      | 100    | Shows basic configuration: name, start/end dates, duration, percent done, effort.   |
 * | `predecessorsTab` | Predecessors | 200    | Shows a grid with incoming dependencies                                             |
 * | `successorsTab`   | Successors   | 300    | Shows a grid with outgoing dependencies                                             |
 * | `resourcesTab`    | Resources    | 400    | Shows a grid with assigned resources to the selected task                           |
 * | `advancedTab`     | Advanced     | 500    | Shows advanced configuration: assigned calendar, scheduling mode, constraints, etc. |
 * | `notesTab`        | Notes        | 600    | Shows a text area to add notes to the selected task                                 |
 *
 *
 * ## Task editor customization example
 *
 * {@inlineexample Gantt/feature/TaskEditCustom.js}
 *
 * @inlineexample Gantt/widget/TaskEditor.js
 * @extends SchedulerPro/widget/GanttTaskEditor
 */

class TaskEditor extends _SchedulerPro_widget_GanttTaskEditor_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'taskeditor';
  }

  static get $name() {
    return 'TaskEditor';
  }

  static get defaultConfig() {
    return {
      cls: 'b-gantt-taskeditor b-schedulerpro-taskeditor'
    };
  }

  afterConfigure() {
    super.afterConfigure();

    if ('durationDecimalPrecision' in this) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('gantt', '5.0.0', '`durationDecimalPrecision` is deprecated, in favor of `durationDisplayPrecision`');
    }
  }

} // Register this widget type with its Factory

TaskEditor.initClass();
TaskEditor._$name = 'TaskEditor';

/***/ }),

/***/ "./lib/Grid/column/ActionColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/ActionColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ActionColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Grid/column/ActionColumn
 */

/**
 * A column that displays actions (clickable icons) in the cell.
 *
 * ```javascript
 * new TreeGrid({
 *     appendTo : document.body,
 *     columns  : [{
 *         type    : 'action',
 *         text    : 'Increase amount',
 *         actions : [{
 *             cls      : 'b-fa b-fa-plus',
 *             renderer : ({ action, record }) => `<i class="b-action-item ${action.cls} b-${record.enabled ? "green" : "red"}-class"></i>`,
 *             visible  : ({ record }) => record.canAdd,
 *             tooltip  : ({ record }) => `<p class="b-nicer-than-default">Add to ${record.name}</p>`,
 *             onClick  : ({ record }) => console.log(`Adding ${record.name}`)
 *         }, {
 *             cls     : 'b-fa b-fa-pencil',
 *             tooltip : 'Edit note',
 *             onClick : ({ record }) => console.log(`Editing ${record.name}`)
 *         }]
 *     }]
 * });
 * ```
 *
 * Actions may be placed in {@link Grid/feature/Group} headers, by setting `actions.showForGroup` to `true`. Those actions will not be shown on normal rows.
 *
 * @extends Grid/column/Column
 *
 * @classType action
 * @inlineexample Grid/column/ActionColumn.js
 */

class ActionColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'action';
  }

  static get fields() {
    return [
    /**
     * An array of action config objects
     * @property {String} actions.cls CSS Class for action icon
     * @property {Function|String} actions.tooltip Tooltip text
     * @property {Core.data.Model} actions.tooltip.record The model instance
     * @property {Function|Boolean} actions.visible Boolean to define the action icon visibility or a callback function to change it dynamically
     * @property {Core.data.Model} actions.visible.record The model instance
     * @property {Function} actions.onClick Callback to handle click action item event
     * @property {Core.data.Model} actions.onClick.record The model instance
     * @property {Boolean} actions.showForGroup Set to true to have action icon visible in group headers only when using the `group` feature
     * @property {Function} actions.renderer A render function used to define the action element. Expected to return a HTML string or a DOM config object.
     * **Note**: when specified, the `cls` action config is ignored. Make sure you add an action icon manually, for example:
     * ```javascript
     * {
     *      type    : 'action',
     *      text    : 'Increase amount',
     *      actions : [{
     *          cls      : 'b-fa b-fa-plus', // this line will be ignored
     *          renderer : ({ record }) => '<i class="b-action-item b-fa b-fa-plus"></i> ' + record.name,
     *          onClick  : ({ record }) => {}
     *      }]
     * }
     * ```
     * @property {Core.data.Model} actions.renderer.record The model instance
     * @config {Object[]} actions List of action configs
     * @category Common
     */
    'actions',
    /**
     * Set true to hide disable actions in this column if the grid is {@link Core.widget.Widget#config-readOnly}
     * @config {Boolean} disableIfGridReadOnly
     * @default
     * @category Common
     */
    {
      name: 'disableIfGridReadOnly',
      defaultValue: false
    }];
  }

  static get defaults() {
    return {
      /**
       * Filtering by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
       * @config {Boolean} filterable
       * @default false
       * @category Interaction
       * @hide
       */
      filterable: false,

      /**
       * Grouping by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
       * @config {Boolean} groupable
       * @default false
       * @category Interaction
       * @hide
       */
      groupable: false,

      /**
       * Sorting by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
       * @config {Boolean} sortable
       * @default false
       * @category Interaction
       * @hide
       */
      sortable: false,

      /**
       * Editor for action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
       * @config {Boolean} editor
       * @default false
       * @category Interaction
       * @hide
       */
      editor: false,

      /**
       * Searching by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
       * @config {Boolean} searchable
       * @default false
       * @category Interaction
       * @hide
       */
      searchable: false,

      /**
       * By default, for action column this flag is switched to `true`, because the content of this column is always HTML.
       * @config {Boolean} htmlEncode
       * @default false
       * @category Misc
       * @hide
       */
      htmlEncode: false,

      /**
       * Set to `true` to allow the column to being drag-resized when the ColumnResize plugin is enabled.
       * @config {Boolean} resizable
       * @default false
       * @category Interaction
       */
      resizable: false,

      /**
       * Column minimal width. If value is Number then minimal width is in pixels.
       * @config {Number|String} minWidth
       * @default 30
       * @category Layout
       */
      minWidth: 30
    };
  }

  get groupHeaderReserved() {
    return true;
  }

  construct(config, store) {
    const me = this;
    me.internalCellCls = 'b-action-cell';
    super.construct(...arguments); // use auto-size only as default behaviour

    if (!config.width && !config.flex) {
      me.grid.on('paint', me.updateAutoWidth, me);
    }

    if (me.disableIfGridReadOnly) {
      me.grid.element.classList.add('b-actioncolumn-readonly');
    }

    me.externalRenderer = me.renderer;
    me.renderer = me.internalRenderer;
  }
  /**
   * Renderer that displays action icon(s) in the cell.
   * @private
   */


  internalRenderer({
    column,
    record,
    callExternalRenderer = true
  }) {
    var _column$actions;

    const inGroupTitle = record && 'groupRowFor' in record.meta;

    if (callExternalRenderer) {
      var _this$externalRendere;

      (_this$externalRendere = this.externalRenderer) === null || _this$externalRendere === void 0 ? void 0 : _this$externalRendere.call(this, ...arguments);
    }

    return {
      className: {
        'b-action-ct': 1
      },
      children: (_column$actions = column.actions) === null || _column$actions === void 0 ? void 0 : _column$actions.map((actionConfig, index) => {
        if ('visible' in actionConfig) {
          if (typeof actionConfig.visible === 'function' && actionConfig.visible({
            record
          }) === false) {
            return '';
          }

          if (actionConfig.visible === false) {
            return '';
          }
        } // check if an action allowed to be shown in case of using grouping


        if (inGroupTitle && !actionConfig.showForGroup || !inGroupTitle && actionConfig.showForGroup) {
          return '';
        }

        let btip;

        if (typeof actionConfig.tooltip === 'function') {
          btip = actionConfig.tooltip({
            record
          });
        } else {
          btip = actionConfig.tooltip || '';
        } // handle custom renderer if it is specified


        if (actionConfig.renderer && typeof actionConfig.renderer === 'function') {
          const customRendererData = actionConfig.renderer({
            index,
            record,
            column,
            tooltip: btip,
            action: actionConfig
          }); // take of set data-index to make onClick handler work stable

          if (typeof customRendererData === 'string') {
            return {
              tag: 'span',
              dataset: {
                index,
                btip
              },
              html: customRendererData
            };
          } else {
            customRendererData.dataset = customRendererData.dataset || {};
            customRendererData.dataset.index = index;
            return customRendererData;
          }
        } else {
          return {
            tag: 'i',
            dataset: {
              index,
              btip
            },
            className: {
              'b-action-item': 1,
              [actionConfig.cls]: actionConfig.cls
            }
          };
        }
      })
    };
  }
  /**
   * Handle icon click and call action handler.
   * @private
   */


  onCellClick({
    grid,
    column,
    record,
    target
  }) {
    var _column$actions2;

    if (column !== this || !target.classList.contains('b-action-item')) {
      return;
    }

    let actionIndex = target.dataset.index; // index may be set in a parent node if user used an html string in his custom renderer
    // and we take care to set this property to support onClick handler

    if (!actionIndex) {
      actionIndex = target.parentElement.dataset && target.parentElement.dataset.index;
    }

    const action = (_column$actions2 = column.actions) === null || _column$actions2 === void 0 ? void 0 : _column$actions2[actionIndex],
          actionHandler = action && action.onClick;

    if (actionHandler) {
      this.callback(actionHandler, column, [{
        record,
        action
      }]);
    }
  }
  /**
   * Update width for actions column to fit content.
   * @private
   */


  updateAutoWidth() {
    var _me$actions;

    const me = this,
          groupActions = []; // header may be disabled, in that case we won't be able to calculate the width properly

    if (!me.element) {
      return;
    }

    let actions = []; // collect group and non group actions to check length later

    (_me$actions = me.actions) === null || _me$actions === void 0 ? void 0 : _me$actions.forEach(actionOriginal => {
      const action = _objectSpread({}, actionOriginal); // remove possible visibility condition to make sure an action will exists in test HTML


      delete action.visible; // group actions shows in different row and never together with non group

      if (action.showForGroup) {
        delete action.showForGroup;
        groupActions.push(action);
      } else {
        actions.push(action);
      }
    }); // use longest actions length to calculate column width

    if (groupActions.length > actions.length) {
      actions = groupActions;
    }

    const actionsHtml = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(me.internalRenderer({
      column: {
        actions
      },
      callExternalRenderer: false
    })).outerHTML;
    me.width = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].measureText(actionsHtml, me.element, true, me.element.parentElement);
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ActionColumn);
ActionColumn.exposeProperties();
ActionColumn._$name = 'ActionColumn';

/***/ }),

/***/ "./lib/Grid/column/AggregateColumn.js":
/*!********************************************!*\
  !*** ./lib/Grid/column/AggregateColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AggregateColumn; });
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
var productName = 'gantt';


/**
 * @module Grid/column/AggregateColumn
 */

/**
 * A column, which, when used as part of a {@link Grid.view.TreeGrid}, aggregates the values of this column's descendants using
 * a configured function which defaults to `sum`.
 *
 * Default editor depends on the data field type. If it is a number, default editor is a {@link Core/widget/NumberField}.
 * Otherwise Default editor is a {@link Core/widget/TextField}.
 *
 * ```javascript
 * const grid = new TreeGrid({
 *     // Custom aggregation handler.
 *     // For test purposes, this just does "sum"
 *     myAggregator(...values) {
 *         let result = 0;
 *
 *         for (let i = 0, { length } = args; i < length; i++) {
 *             result += parseInt(args[i], 10);
 *         }
 *         return result;
 *     },
 *     columns : [
 *         { field : 'name', text : 'Name' },
 *
 *         // Will sum the ages of leaf nodes. This is the default.
 *         { type : 'aggregate', field : 'age', text : 'Age', renderer : ({ value }) => `<b>${value}<b>` },
 *
 *         // Will use AggregateColumn's built-in avg of scores of leaf nodes
 *         { type : 'aggregate', field : 'score', text : 'Score', function : 'avg' },
 *
 *         // Will use the grid's myAggregator function
 *         { type : 'aggregate', field : 'revenue', text : 'Revenue', function : 'up.myAggregator' },
 *     ]
 * });
 * ```
 *
 * @extends Grid/column/NumberColumn
 * @classType aggregate
 */

class AggregateColumn extends _NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get type() {
    return 'aggregate';
  }

  static get fields() {
    return ['function'];
  }

  static get defaults() {
    return {
      /**
       * Math Function name, or function name prepended by `"up."` that is resolvable in an
       * ancestor component (such as the owning Grid, or a hight Container), or a function to
       * use to aggregate child record values for this column, or a function.
       *
       * This Column is provided with a `sum` and `avg` function. The default function is `sum`
       * which is used for the aggregation.
       * @config {Function|String}
       * @category Common
       */
      function: 'sum'
    };
  }

  construct(data, columnStore) {
    this.configuredAlign = 'align' in data;
    this.configuredEditor = 'editor' in data;
    super.construct(...arguments);
    const {
      grid
    } = columnStore; // 'sum' is reserved by Summary feature, so we use a different name 

    if (this.function === 'sum') {
      this.function = 'sumChildren';
    }

    if (grid) {
      this.owner = grid;
      grid.on({
        paint: 'onGridPaint',
        thisObj: this,
        prio: 1000
      });
    }
  }

  onGridPaint({
    source: grid
  }) {
    this.store = grid.store;
  }

  set store(store) {
    const me = this,
          storeListeners = {
      update: 'onRecordUpdate',
      thisObj: me,
      prio: 1000
    },
          oldStore = me._store;

    if (store !== oldStore) {
      if (oldStore) {
        oldStore.un(storeListeners);
      }

      me._store = store;
      const {
        modelClass
      } = store,
            field = modelClass.fieldMap[me.field]; // It's *likely*, but not certain that this will be used for a numeric field.
      // Use numeric defaults unless configured otherwise if so.

      if (field && field.type === 'number') {
        if (!me.configuredAlign) {
          me.align = 'end';
        }

        if (!me.configuredEditor) {
          me.editor = 'number';
        }
      }

      store.on(storeListeners);
    }
  }

  canEdit(record) {
    return record.isLeaf;
  }

  get store() {
    return this._store;
  }

  sumChildren(...args) {
    let result = 0;

    for (let i = 0, {
      length
    } = args; i < length; i++) {
      result += parseInt(args[i] || 0, 10);
    }

    return result;
  }

  avg(...args) {
    let result = 0;
    const {
      length
    } = args;

    for (let i = 0; i < length; i++) {
      result += parseInt(args[i] || 0, 10);
    }

    return result / length;
  }

  onRecordUpdate({
    record,
    changes
  }) {
    const me = this,
          {
      rowManager
    } = me.grid;

    if (me.field in changes) {
      if (record.isLeaf) {
        record.bubble(rec => {
          const row = rowManager.getRowFor(rec);

          if (row) {
            const cellElement = row.getCell(me.field);

            if (cellElement) {
              row.renderCell({
                cellElement,
                record: rec
              });
            }
          }
        }, true);
      }
    }
  }

  getRawValue(record) {
    let value = 0;

    if (record.children) {
      const me = this,
            fn = me.function,
            isMathFn = typeof fn === 'string' && typeof Math[fn] === 'function',
            {
        handler,
        thisObj
      } = isMathFn ? {
        handler: Math[fn],
        thisObj: Math
      } : me.resolveCallback(fn);

      for (let i = 0, {
        length
      } = record.children; i < length; i++) {
        value = handler.call(thisObj, value, me.getRawValue(record.children[i]));
      }

      record.setData(me.field, value);
    } else {
      value = record[this.field];
    }

    return value;
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(AggregateColumn, true);
AggregateColumn.exposeProperties();
AggregateColumn._$name = 'AggregateColumn';

/***/ }),

/***/ "./lib/Grid/column/CheckColumn.js":
/*!****************************************!*\
  !*** ./lib/Grid/column/CheckColumn.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CheckColumn; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _WidgetColumn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WidgetColumn.js */ "./lib/Grid/column/WidgetColumn.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
var productName = 'gantt';




/**
 * @module Grid/column/CheckColumn
 */

/**
 * A column that displays a checkbox in the cell. The value of the backing field is toggled by the checkbox.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 * If you want to hide certain checkboxes, you can use the {@link #config-renderer} method to access the checkbox widget
 * as it is being rendered.
 *
 * @extends Grid/column/WidgetColumn
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         {
 *              type: 'check',
 *              field: 'allow',
 *              // In the column renderer, we get access to the record and CheckBox widget
 *              renderer({ record, widgets }) {
 *                  // Hide checkboxes in certain rows
 *                  widgets[0].hidden = record.readOnly;
 *              }
 *         }
 *     ]
 * });
 *
 * @classType check
 * @inlineexample Grid/column/CheckColumn.js
 */

class CheckColumn extends _WidgetColumn_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get type() {
    return 'check';
  }

  static get fields() {
    return ['checkCls', 'showCheckAll', 'onAfterWidgetSetValue', 'onBeforeWidgetSetValue'];
  }

  static get defaults() {
    return {
      align: 'center',

      /**
       * CSS class name to add to checkbox
       * @config {String}
       * @category Rendering
       */
      checkCls: null,

      /**
       * True to show a checkbox in the column header to be able to select/deselect all rows
       * @config {Boolean}
       */
      showCheckAll: false,
      widgets: [{
        type: 'checkbox',
        valueProperty: 'checked'
      }]
    };
  }

  construct(config, store) {
    var _me$grid;

    super.construct(...arguments);
    const me = this;
    me.externalHeaderRenderer = me.headerRenderer;
    me.externalOnBeforeWidgetSetValue = me.onBeforeWidgetSetValue;
    me.externalOnAfterWidgetSetValue = me.onAfterWidgetSetValue;
    me.onBeforeWidgetSetValue = me.internalOnBeforeWidgetSetValue;
    me.onAfterWidgetSetValue = me.internalOnAfterWidgetSetValue;
    me.headerRenderer = me.internalHeaderRenderer;
    me.internalCellCls = 'b-check-cell';
    (_me$grid = me.grid) === null || _me$grid === void 0 ? void 0 : _me$grid.on({
      destroy: () => {
        var _me$headerCheckbox;

        return (_me$headerCheckbox = me.headerCheckbox) === null || _me$headerCheckbox === void 0 ? void 0 : _me$headerCheckbox.destroy();
      },
      thisObj: me
    });
  }

  internalHeaderRenderer({
    headerElement,
    column
  }) {
    let returnValue;
    headerElement.classList.add('b-check-header');

    if (column.showCheckAll) {
      headerElement.classList.add('b-check-header-with-checkbox');

      if (column.headerCheckbox) {
        headerElement.appendChild(column.headerCheckbox.element);
      } else {
        column.headerCheckbox = new _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
          appendTo: headerElement,
          owner: this.grid,
          listeners: {
            change: 'onCheckAllChange',
            thisObj: column
          }
        });
      }
    } else {
      returnValue = column.headerText;
    }

    returnValue = column.externalHeaderRenderer ? column.externalHeaderRenderer.call(this, ...arguments) : returnValue;
    return column.showCheckAll ? undefined : returnValue;
  }

  updateCheckAllState(value) {
    if (this.headerCheckbox) {
      this.suspendEvents();
      this.headerCheckbox.checked = value;
      this.resumeEvents();
    }
  }

  onCheckAllChange({
    checked
  }) {
    const me = this; // If this column is bound to a field, update all records

    if (me.field) {
      const {
        store
      } = me.grid;
      store.beginBatch();
      store.forEach(record => me.updateRecord(record, me.field, checked));
      store.endBatch();
    }
    /**
     * Fired when the header checkbox is clicked to toggle its checked status.
     * @event toggleAll
     * @param {Grid.column.CheckColumn} source This Column
     * @param {Boolean} checked The checked status of the header checkbox.
     */


    me.trigger('toggleAll', {
      checked
    });
  } //endregion


  internalRenderer({
    value,
    isExport
  }) {
    if (isExport) {
      return value == null ? '' : value;
    }

    return super.internalRenderer(...arguments);
  } //region Widget rendering


  onBeforeWidgetCreate(widgetCfg, event) {
    widgetCfg.cls = this.checkCls;
  }

  onAfterWidgetCreate(widget, event) {
    event.cellElement.widget = widget;
    widget.on({
      beforeChange: 'onBeforeCheckboxChange',
      change: 'onCheckboxChange',
      thisObj: this
    });
  }

  internalOnBeforeWidgetSetValue(widget) {
    var _this$externalOnBefor;

    widget.record = widget.cellInfo.record;
    this.isInitialSet = true;
    (_this$externalOnBefor = this.externalOnBeforeWidgetSetValue) === null || _this$externalOnBefor === void 0 ? void 0 : _this$externalOnBefor.call(this, ...arguments);
  }

  internalOnAfterWidgetSetValue(widget) {
    var _this$externalOnAfter;

    this.isInitialSet = false;
    (_this$externalOnAfter = this.externalOnAfterWidgetSetValue) === null || _this$externalOnAfter === void 0 ? void 0 : _this$externalOnAfter.call(this, ...arguments);
  } //endregion
  //region Events


  onBeforeCheckboxChange({
    source,
    checked
  }) {
    const record = source.cellInfo.record;

    if (this.isSelectionColumn && !this.grid.isSelectable(record)) {
      return false;
    }

    if (!this.isInitialSet) {
      /**
       * Fired when a cell is clicked to toggle its checked status. Returning `false` will prevent status change.
       * @event beforeToggle
       * @param {Grid.column.Column} source This Column
       * @param {Core.data.Model} record The record for the row containing the cell.
       * @param {Boolean} checked The new checked status of the cell.
       */
      return this.trigger('beforeToggle', {
        record,
        checked
      });
    }
  }

  onCheckboxChange({
    source,
    checked
  }) {
    if (!this.isInitialSet) {
      const record = source.cellInfo.record,
            field = this.field;

      if (field) {
        this.updateRecord(record, field, checked);
      }
      /**
       * Fired when a cell is clicked to toggle its checked status.
       * @event toggle
       * @param {Grid.column.Column} source This Column
       * @param {Core.data.Model} record The record for the row containing the cell.
       * @param {Boolean} checked The new checked status of the cell.
       */


      this.trigger('toggle', {
        record,
        checked
      });
    }
  }

  updateRecord(record, field, checked) {
    const setterName = `set${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(field)}`;

    if (record[setterName]) {
      record[setterName](checked);
    } else {
      record.set(field, checked);
    }
  } //endregion


  onCellKeyDown({
    event,
    cellElement
  }) {
    // SPACE key toggles the checkbox
    if (event.key === ' ') {
      const checkbox = cellElement.widget;
      checkbox === null || checkbox === void 0 ? void 0 : checkbox.toggle(); // Prevent native browser scrolling

      event.preventDefault();
    }
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(CheckColumn, true);
CheckColumn._$name = 'CheckColumn';

/***/ }),

/***/ "./lib/Grid/column/Column.js":
/*!***********************************!*\
  !*** ./lib/Grid/column/Column.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Column; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';







/**
 * @module Grid/column/Column
 */

const validWidth = value => typeof value === 'number' || (value === null || value === void 0 ? void 0 : value.endsWith('px'));
/**
 * Base class for other column types, used if no type is specified on a column.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [{
 *     field : 'name',
 *     text  : 'Name'
 *   }, {
 *     text  : 'Hobby',
 *     field : 'others.hobby', // reading nested field data
 *   }, {
 *     type  : 'number', // Will use NumberColumn
 *     field : 'age',
 *     text  : 'Age'
 *   }]
 * });
 * ```
 *
 * ## Column types
 *
 * Grid ships with multiple different column types. Which type to use for a column is specified by the `type` config. The built in types are:
 *
 * * {@link Grid.column.ActionColumn action} - displays actions (clickable icons) in the cell.
 * * {@link Grid.column.AggregateColumn aggregate} - a column, which, when used as part of a Tree, aggregates the values of
 *   this column's descendants using a configured function which defaults to `sum`.
 * * {@link Grid.column.CheckColumn check} - displays a checkbox in the cell.
 * * {@link Grid.column.DateColumn date} - displays a date in the specified format.
 * * {@link Grid.column.NumberColumn number} - a column for showing/editing numbers.
 * * {@link Grid.column.PercentColumn percent} - displays a basic progress bar.
 * * {@link Grid.column.RatingColumn rating} - displays a star rating.
 * * {@link Grid.column.RowNumberColumn rownumber} - displays the row number in each cell.
 * * {@link Grid.column.TemplateColumn template} - uses a template for cell content.
 * * {@link Grid.column.TimeColumn time} - displays a time in the specified format.
 * * {@link Grid.column.TreeColumn tree} - displays a tree structure when using the {@link Grid.feature.Tree tree} feature.
 * * {@link Grid.column.WidgetColumn widget} - displays widgets in the cells.
 *
 * ## Cell renderers
 *
 * You can affect the contents and styling of cells in a column using a {@link Grid.column.Column#config-renderer renderer()} function.
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [
 *   ...
 *     {
 *       field      : 'approved',
 *       text       : 'Approved',
 *       htmlEncode : false, // allow to use HTML code
 *       renderer({ value }) {
 *         return value === true ? '<b>Yes</b>' : '<i>No</i>';
 *       }
 *     }
 *     ...
 *     ]
 * });
 * ```
 *
 * ## Menus
 *
 * You can add custom items to the context menu for a columns header and for its cells, using {@link Grid.column.Column#config-headerMenuItems headerMenuItems} and
 * {@link Grid.column.Column#config-cellMenuItems cellMenuItems}. Here is an example:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [
 *     ...
 *     {
 *       type  : 'number',
 *       field : 'age',
 *       text  : 'Age',
 *       headerMenuItems: [{
 *           text : 'My unique header item',
 *           icon : 'b-fa b-fa-paw',
 *           onItem() { console.log('item clicked'); }
 *       }],
 *       cellMenuItems: [{
 *           text : 'My unique cell item',
 *           icon : 'b-fa b-fa-plus',
 *           onItem() { console.log('item clicked'); }
 *       }]
 *     }
 *   ...
 *   ]
 * });
 * ```
 *
 * @extends Core/data/Model
 * @classType column
 * @mixes Core/mixin/Events
 * @mixes Core/localization/Localizable
 */


class Column extends Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  //region Config
  static get fields() {
    return [//region Common

    /**
     * Get/set header text
     * @member {String} text
     */

    /**
     * Text to display in the header
     * @config {String} text
     * @category Common
     */
    'text',
    /**
     * The {@link Core.data.field.DataField#config-name} of the {@link Core.data.Model data model} field to read data from.
     * @config {String} field
     * @category Common
     */
    'field', // NOTE: This is duplicated in WidgetColumn so remember to change it too if changing the signature of
    // this function

    /**
     * Renderer function, used to format and style the content displayed in the cell. Return the cell text you
     * want to display. Can also affect other aspects of the cell, such as styling.
     *
     * **NOTE:** If you mutate cellElement and you want to prevent cell content to be reset during the rendering,
     * please return `undefined` from the renderer or just omit the `return` statement. If you return a value and
     * the value can be undefined, please make sure you return an empty string to update the cell content. For example:
     *
     * ```javascript
     * new Grid({
     *     columns : [
     *         // Returns an empty string if status field value is undefined
     *         { text : 'Status', renderer : ({ record }) => record.status ?? '' },
     *     ]
     * });
     * ```
     *
     * You can also return a {@link Core.helper.DomHelper#typedef-DomConfig} object describing the markup
     * ```javascript
     * new Grid({
     *     columns : [
     *         {
     *              text : 'Status',
     *              renderer : ({ record }) => {
     *                  return {
     *                      class : 'myClass',
     *                      children : [
     *                          {
     *                              tag : 'i',
     *                              class : 'fa fa-pen'
     *                          },
     *                          {
     *                              tag : 'span',
     *                              html : record.name
     *                          }
     *                      ]
     *                  };
     *              }
     *         }
     *     ]
     * });
     * ```
     *
     * @param {Object} renderData Object containing renderer parameters
     * @param {HTMLElement} [renderData.cellElement] Cell element, for adding CSS classes, styling etc.
     *        Can be `null` in case of export
     * @param {*} renderData.value Value to be displayed in the cell
     * @param {Core.data.Model} renderData.record Record for the row
     * @param {Grid.column.Column} renderData.column This column
     * @param {Grid.view.Grid} renderData.grid This grid
     * @param {Grid.row.Row} [renderData.row] Row object. Can be null in case of export. Use the
     * {@link Grid.row.Row#function-assignCls row's API} to manipulate CSS class names.
     * @param {Object} [renderData.size] Set `size.height` to specify the desired row height for the current row.
     *        Largest specified height is used, falling back to configured {@link Grid/view/Grid#config-rowHeight}
     *        in case none is specified. Can be null in case of export
     * @param {Number} [renderData.size.height] Set this to request a certain row height
     * @param {Number} [renderData.size.configuredHeight] Row height that will be used if none is requested
     * @param {Boolean} [renderData.isExport] True if record is being exported to allow special handling during export
     * @param {Boolean} [renderData.isMeasuring] True if the column is being measured for a `resizeToFitContent`
     *        call. In which case an advanced renderer might need to take different actions.
     * @config {Function} renderer
     * @category Common
     */
    'renderer', //'reactiveRenderer',

    /**
     * Column width. If value is Number then width is in pixels
     * @config {Number|String} width
     * @category Common
     */
    'width',
    /**
     * Gets or sets the column flex weight
     * @member {String} flex
     */

    /**
     * Column width as a flex weight. All columns with flex specified divide the available space (after
     * subtracting fixed widths) between them according to the flex value. Columns that have flex 2 will be
     * twice as wide as those with flex 1 (and so on)
     * @config {Number} flex
     * @category Common
     */
    'flex',
    /**
     * This config sizes a column to fits its content. It is used instead of `width` or `flex`.
     *
     * This config requires the {@link Grid.feature.ColumnAutoWidth} feature which responds to changes in the
     * grid's store and synchronizes the widths' of all `autoWidth` columns.
     *
     * If this config is not a Boolean value, it is passed as the only argument to the `resizeToFitContent`
     * method to constrain the column's width.
     *
     * @config {Boolean|Number|Number[]} autoWidth
     * @category Common
     */
    'autoWidth',
    /**
     * This config enables automatic height for all cells in this column. It is achieved by measuring the height
     * a cell after rendering it to DOM, and then sizing the row using that height (if it is greater than other
     * heights used for the row).
     *
     * Heads up if you render your Grid on page load, if measurement happens before the font you are using is
     * loaded you might get slightly incorrect heights. For browsers that support it (not IE11) we detect that
     * and remeasure when fonts are available.
     *
     * **NOTE:** Enabling this config comes with a pretty big performance hit. To maintain good performance,
     * we recommend not using it. You can still set the height of individual rows manually, either through
     * {@link Grid.data.GridRowModel#field-rowHeight data} or via {@link #config-renderer renderers}.
     *
     * Also note that this setting only works fully as intended with non-flex columns.
     *
     * Manually setting a height from a {@link #config-renderer} in this column will take precedence over this
     * config.
     *
     * @config {Boolean} autoHeight
     * @category Common
     */
    'autoHeight',
    /**
     * Mode to use when measuring the contents of this column in calls to {@link #function-resizeToFitContent}.
     * Available modes are:
     *
     * * 'exact'       - Most precise, renders and measures all cells (Default, slowest)
     * * 'textContent' - Renders all cells but only measures the one with the longest `textContent`
     * * 'value'       - Renders and measures only the cell with the longest data (Fastest)
     * * 'none'/falsy  - Resize to fit content not allowed, a call does nothing
     *
     * @config {String} fitMode
     * @default 'exact'
     * @category Common
     */
    {
      name: 'fitMode',
      defaultValue: 'exact'
    }, //endregion
    //region Interaction

    /**
     * Specify if this column should be editable, and define which editor to use for editing cells in the
     * column. Used when {@link Grid/feature/CellEdit} feature is enabled. The Editor refers to {@link #config-field}
     * for a data source.
     *
     * All subclasses of {@link Core.widget.Field Field} can be used as editors. The most popular are:
     * - {@link Core.widget.TextField TextField}
     * - {@link Core.widget.NumberField NumberField}
     * - {@link Core.widget.DateField DateField}
     * - {@link Core.widget.TimeField TimeField}
     * - {@link Core.widget.Combo Combo}
     *
     * If record has method set + capitalized field, method will be called, e.g. if record has method named
     * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`,
     * `record.setFoobar(value)` will be called.
     *
     * @config {Boolean|String|Object|Core.widget.Field} editor
     * @category Interaction
     */
    {
      name: 'editor',
      defaultValue: {}
    },
    /**
     * A function which is called when a cell edit is requested to finish.
     *
     * This may be an `async` function which performs complex validation. The edit will not
     * complete until it returns `false` to mean the edit cannot be finished, or `true` to go
     * ahead and complete.
     *
     * @param {Object} context An object describing the state of the edit at completion request time.
     * @param {Core.widget.Field} context.inputField The field configured as the column's `editor`.
     * @param {Core.data.Model} context.record The record being edited.
     * @param {*} context.oldValue The old value of the cell.
     * @param {*} context.value The new value of the cell.
     * @param {Grid.view.Grid} context.grid The host grid.
     * @param {Object} context.editorContext The {@link Grid.feature.CellEdit CellEdit} context object.
     * @param {Grid.column.Column} context.editorContext.column The column being edited.
     * @param {Core.data.Model} context.editorContext.record The record being edited.
     * @param {HTMLElement} context.editorContext.cell The cell element hosting the editor.
     * @param {Core.widget.Editor} context.editorContext.editor The floating Editor widget which is hosting the input field.
     * @config {Function} finalizeCellEdit
     * @category Interaction
     */
    'finalizeCellEdit',
    /**
     * Setting this option means that pressing the `ESCAPE` key after editing the field will
     * revert the field to the value it had when the edit began. If the value is _not_ changed
     * from when the edit started, the input field's {@link Core.widget.Field#config-clearable}
     * behaviour will be activated. Finally, the edit will be canceled.
     * @config {Boolean} revertOnEscape
     * @default true
     * @category Interaction
     */
    {
      name: 'revertOnEscape',
      defaultValue: true
    },
    /**
     * How to handle a request to complete a cell edit in this column if the field is invalid.
     * There are three choices:
     *  - `block` The default. The edit is not exited, the field remains focused.
     *  - `allow` Allow the edit to be completed.
     *  - `revert` The field value is reverted and the edit is completed.
     * @config {String} invalidAction
     * @default 'block'
     * @category Interaction
     */
    {
      name: 'invalidAction',
      defaultValue: 'block'
    },
    /**
     * Allow sorting of data in the column. You can pass true/false to enable/disable sorting, or provide a
     * custom sorting function, or a config object for a {@link Core.util.CollectionSorter}
     *
     * ```javascript
     * const grid = new Grid({
     *     columns : [
     *          {
     *              // Disable sorting for this column
     *              sortable : false
     *          },
     *          {
     *              field : 'name',
     *              // Custom sorting for this column
     *              sortable(user1, user2) {
     *                  return user1.name < user2.name ? -1 : 1;
     *              }
     *          },
     *          {
     *              // A config object for a Core.util.CollectionSorter
     *              sortable : {
     *                  property         : 'someField',
     *                  direction        : 'DESC',
     *                  useLocaleCompare : 'sv-SE'
     *              }
     *          }
     *     ]
     * });
     * ```
     * When providing a custom sorting function, if the sort feature is configured with
     * `prioritizeColumns : true` that function will also be used for programmatic sorting of the store:
     *
     * ```javascript
     * const grid = new Grid({
     *     features : {
     *       sort : {
     *           prioritizeColumns : true
     *       }
     *     },
     *
     *     columns : [
     *          {
     *              field : 'name',
     *              // Custom sorting for this column
     *              sortable(user1, user2) {
     *                  return user1.name < user2.name ? -1 : 1;
     *              }
     *          }
     *     ]
     * });
     *
     * // Will use sortable() from the column definition above
     * grid.store.sort('name');
     * ```
     *
     * @config {Boolean|Function|Object} sortable
     * @default true
     * @category Interaction
     */
    {
      name: 'sortable',
      defaultValue: true,

      // Normalize function/object forms
      convert(value, column) {
        if (!value) {
          return false;
        }

        const sorter = {};

        if (typeof value === 'function') {
          // Scope for sortable() expected to be the column
          sorter.sortFn = value.bind(column);
        } else if (typeof value === 'object') {
          Object.assign(sorter, value);

          if (sorter.fn) {
            sorter.sortFn = sorter.fn;
            delete sorter.fn;
          }
        }

        return sorter;
      }

    },
    /**
     * Allow searching in the column (respected by QuickFind and Search features)
     * @config {Boolean} searchable
     * @default true
     * @category Interaction
     */
    {
      name: 'searchable',
      defaultValue: true
    },
    /**
     * Allow filtering data in the column (if {@link Grid.feature.Filter} or {@link Grid.feature.FilterBar}
     * feature is enabled).
     *
     * Also allows passing a custom filtering function that will be called for each record with a single
     * argument of format `{ value, record, [operator] }`. Returning `true` from the function includes the
     * record in the filtered set.
     *
     * Configuration object may be used for {@link Grid.feature.FilterBar} feature to specify `filterField`. See
     * an example in the code snippet below or check {@link Grid.feature.FilterBar} page for more details.
     *
     * ```
     * const grid = new Grid({
     *     columns : [
     *          {
     *              field : 'name',
     *              // Disable filtering for this column
     *              filterable : false
     *          },
     *          {
     *              field : 'age',
     *              // Custom filtering for this column
     *              filterable: ({ value, record }) => Math.abs(record.age - value) < 10
     *          },
     *          {
     *              field : 'start',
     *              // Changing default field type
     *              filterable: {
     *                  filterField : {
     *                      type : 'datetime'
     *                  }
     *              }
     *          },
     *          {
     *              field : 'city',
     *              // Filtering for a value out of a list of values
     *              filterable: {
     *                  filterField : {
     *                      type  : 'combo',
     *                      value : '',
     *                      items : [
     *                          'Paris',
     *                          'Dubai',
     *                          'Moscow',
     *                          'London',
     *                          'New York'
     *                      ]
     *                  }
     *              }
     *          },
     *          {
     *              field : 'score',
     *              filterable : {
     *                  // This filter fn doesn't return 0 values as matching filter 'less than'
     *                  filterFn : ({ record, value, operator, property }) => {
     *                      switch (operator) {
     *                          case '<':
     *                              return record[property] === 0 ? false : record[property] < value;
     *                          case '=':
     *                              return record[property] == value;
     *                          case '>':
     *                              return record[property] > value;
     *                      }
     *                  }
     *              }
     *          }
     *     ]
     * });
     * ```
     *
     * When providing a custom filtering function, if the filter feature is configured with
     * `prioritizeColumns : true` that function will also be used for programmatic filtering of the store:
     *
     * ```javascript
     * const grid = new Grid({
     *     features : {
     *         filter : {
     *             prioritizeColumns : true
     *         }
     *     },
     *
     *     columns : [
     *          {
     *              field : 'age',
     *              // Custom filtering for this column
     *              filterable: ({ value, record }) => Math.abs(record.age - value) < 10
     *          }
     *     ]
     * });
     *
     * // Will use filterable() from the column definition above
     * grid.store.filter({
     *     property : 'age',
     *     value    : 50
     * });
     * ```
     *
     * @config {Boolean|Function|Object} filterable
     * @default true
     * @category Interaction
     */
    {
      name: 'filterable',
      defaultValue: true,

      // Normalize function/object forms
      convert(value) {
        if (!value) {
          return false;
        }

        const filter = {
          columnOwned: true
        };

        if (typeof value === 'function') {
          filter.filterFn = value;
        } else if (typeof value === 'object') {
          Object.assign(filter, value);
        }

        return filter;
      }

    },
    /**
     * Setting this flag to `true` will prevent dropping child columns into a group column
     * @config {Boolean} sealed
     * @default false
     * @category Interaction
     */
    {
      name: 'sealed'
    },
    /**
     * Allow column visibility to be toggled through UI
     * @config {Boolean} hideable
     * @default true
     * @category Interaction
     */
    {
      name: 'hideable',
      defaultValue: true
    },
    /**
     * Set to false to prevent this column header from being dragged
     * @config {Boolean} draggable
     * @category Interaction
     */
    {
      name: 'draggable',
      defaultValue: true
    },
    /**
     * Set to false to prevent grouping by this column
     * @config {Boolean} groupable
     * @category Interaction
     */
    {
      name: 'groupable',
      defaultValue: true
    },
    /**
     * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
     * @config {Boolean} resizable
     * @default true
     * @category Interaction
     */
    {
      name: 'resizable',
      defaultValue: true
    }, //endregion
    //region Rendering

    /**
     * Renderer function for group headers (when using Group feature).
     * @param {Object} renderData
     * @param {HTMLElement} renderData.cellElement Cell element, for adding CSS classes, styling etc.
     * @param {*} renderData.groupRowFor Current group value
     * @param {Core.data.Model} renderData.record Record for the row
     * @param {Core.data.Model[]} renderData.groupRecords Records in the group
     * @param {Grid.column.Column} renderData.column Current rendering column
     * @param {Grid.column.Column} renderData.groupColumn Column that the grid is grouped by
     * @param {Number} renderData.count Number of records in the group
     * @param {Grid.view.Grid} renderData.grid This grid
     * @config {Function} groupRenderer
     * @returns {String} The header grouping text
     * @category Rendering
     */
    'groupRenderer',
    /**
     * Renderer function for the column header.
     * @param {Object} renderData
     * @param {Grid.column.Column} renderData.column This column
     * @param {HTMLElement} renderData.headerElement The header element
     * @config {Function} headerRenderer
     * @category Rendering
     */
    'headerRenderer',
    /**
     * A tooltip string to show when hovering the column header
     * @config {String} tooltip
     * @category Rendering
     */
    'tooltip',
    /**
     * Renderer function for the cell tooltip (used with {@link Grid.feature.CellTooltip} feature). Specify false to prevent
     * tooltip for this column.
     * @param {HTMLElement} cellElement Cell element
     * @param {Core.data.Model} record Record for cell row
     * @param {Grid.column.Column} column Cell column
     * @param {Grid.feature.CellTooltip} cellTooltip Feature instance, used to set tooltip content async
     * @param {MouseEvent} event The event that triggered the tooltip
     * @config {Function} tooltipRenderer
     * @category Rendering
     */
    'tooltipRenderer',
    /**
     * CSS class added to each cell in this column
     * @config {String} cellCls
     * @category Rendering
     */
    'cellCls',
    /**
     * CSS class added to the header of this column
     * @config {String} cls
     * @category Rendering
     */
    'cls',
    /**
     * Get/set header icon class
     * @member {String} icon
     */

    /**
     * Icon to display in header. Specifying an icon will render a `<i>` element with the icon as value for the
     * class attribute
     * @config {String} icon
     * @category Rendering
     */
    'icon', //endregion
    //region Layout

    /**
     * Text align (left, center, right)
     * @config {String} align
     * @category Layout
     */
    'align',
    /**
     * Column minimal width. If value is Number then minimal width is in pixels
     * @config {Number|String} minWidth
     * @default 60
     * @category Layout
     */
    {
      name: 'minWidth',
      defaultValue: 60
    },
    /**
     * Column maximal width. If value is Number then maximal width is in pixels
     * @config {Number|String} maxWidth
     * @category Common
     */
    'maxWidth',
    /**
     * Get/set columns hidden state. Specify `true` to hide the column, `false` to show it.
     * @member {Boolean} hidden
     */

    /**
     * Hide the column from start
     * @config {Boolean} hidden
     * @category Layout
     */
    {
      name: 'hidden',
      defaultValue: false
    },
    /**
     * Convenient way of putting a column in the "locked" region. Same effect as specifying region: 'locked'.
     * If you have defined your own regions (using {@link Grid.view.Grid#config-subGridConfigs}) you should use
     * {@link #config-region} instead of this one.
     * @config {Boolean} locked
     * @default false
     * @category Layout
     */
    {
      name: 'locked'
    },
    /**
     * Region (part of the grid, it can be configured with multiple) where to display the column. Defaults to
     * {@link Grid.view.Grid#config-defaultRegion}.
     * @config {String} region
     * @category Layout
     */
    {
      name: 'region'
    }, //endregion
    // region Menu

    /**
     * Show column picker for the column
     * @config {Boolean} showColumnPicker
     * @default true
     * @category Menu
     */
    {
      name: 'showColumnPicker',
      defaultValue: true
    },
    /**
     * false to prevent showing a context menu on the column header element
     * @config {Boolean} enableHeaderContextMenu
     * @default true
     * @category Menu
     */
    {
      name: 'enableHeaderContextMenu',
      defaultValue: true
    },
    /**
     * Set to `false` to prevent showing a context menu on the cell elements in this column
     * @config {Boolean} enableCellContextMenu
     * @default true
     * @category Menu
     */
    {
      name: 'enableCellContextMenu',
      defaultValue: true
    },
    /**
     * Extra items to show in the header context menu for this column.
     *
     * **Deprecated** to be an array:
     *
     * ```javascript
     * headerMenuItems : [
     *     { text : 'Custom item' }
     * ]
     * ```
     *
     * Now it has to be a named object:
     *
     * ```javascript
     * headerMenuItems : {
     *     customItem : { text : 'Custom item' }
     * }
     * ```
     *
     * @config {Object} headerMenuItems
     * @category Menu
     */
    'headerMenuItems',
    /**
     * Extra items to show in the cell context menu for this column
     *
     * **Deprecated** to be an array:
     *
     * ```javascript
     * cellMenuItems : [
     *     { text : 'Custom item' }
     * ]
     * ```
     *
     * Now it has to be a named object:
     *
     * ```javascript
     * cellMenuItems : {
     *     customItem : { text : 'Custom item' }
     * }
     * ```
     *
     * @config {Object} cellMenuItems
     * @category Menu
     */
    'cellMenuItems', //endregion
    //region Summary

    /**
     * Summary type (when using Summary feature). Valid types are:
     * <dl class="wide">
     * <dt>sum <dd>Sum of all values in the column
     * <dt>add <dd>Alias for sum
     * <dt>count <dd>Number of rows
     * <dt>countNotEmpty <dd>Number of rows containing a value
     * <dt>average <dd>Average of all values in the column
     * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
     * </dl>
     * @config {String} sum
     * @category Summary
     */
    'sum',
    /**
     * Summary configs, use if you need multiple summaries per column. Replaces {@link #config-sum} and
     * {@link #config-summaryRenderer} configs. Accepts an array of objects with the following fields:
     * * sum - Matching {@link #config-sum}
     * * renderer - Matching {@link #config-summaryRenderer}
     * * seed - Initial value when using a function as `sum`
     * @config {Object[]} summaries
     * @category Summary
     */
    'summaries',
    /**
     * Renderer function for summary (when using Summary feature). The renderer is called with an object having
     * the calculated summary `sum` as only member.
     * @config {Function} summaryRenderer
     * @param {Number} summaryRenderer.sum The sum
     * @category Summary
     */
    'summaryRenderer', //endregion
    //region Misc

    /**
     * Column settings at different responsive levels, see responsive demo under examples/
     * @config {Object} responsiveLevels
     * @category Misc
     */
    'responsiveLevels',
    /**
     * Tags, may be used by ColumnPicker feature for grouping columns by tag in the menu
     * @config {String[]} tags
     * @category Misc
     */
    'tags',
    /**
     * Column config to apply to normal config if viewed on a touch device
     * @config {Object} touchConfig
     * @category Misc
     */
    'touchConfig',
    /**
     * When using the tree feature, exactly one column should specify { tree: true }
     * @config {Boolean} tree
     * @category Misc
     */
    'tree',
    /**
     * Determines which type of filtering to use for the column. Usually determined by the column type used,
     * but may be overridden by setting this field.
     * @config {String} filterType
     * @category Misc
     */
    'filterType',
    /**
     * By default, any rendered column cell content is HTML-encoded. Set this flag to `false` disable this and allow rendering html elements
     * @config {Boolean} htmlEncode
     * @default true
     * @category Misc
     */
    {
      name: 'htmlEncode',
      defaultValue: true
    },
    /**
     * By default, the header text is HTML-encoded. Set this flag to `false` disable this and allow html elements in the column header
     * @config {Boolean} htmlEncodeHeaderText
     * @default true
     * @category Misc
     */
    {
      name: 'htmlEncodeHeaderText',
      defaultValue: true
    },
    /**
     * Set to `true`to automatically call DomHelper.sync for html returned from a renderer. Should in most cases
     * be more performant than replacing entire innerHTML of cell and also allows CSS transitions to work. Has
     * no effect unless {@link #config-htmlEncode} is disabled. Returned html must contain a single root element (that can have
     * multiple children). See PercentColumn for example usage.
     * @config {Boolean} autoSyncHtml
     * @default false
     * @category Misc
     */
    {
      name: 'autoSyncHtml',
      defaultValue: false
    }, 'type',
    /**
     * Set to `true` to have the {@link Grid.feature.CellEdit CellEdit} feature update the record being
     * edited live upon field edit instead of when editing is finished by using `TAB` or `ENTER`
     * @config {Boolean} instantUpdate
     * @category Misc
     */
    {
      name: 'instantUpdate',
      defaultValue: false
    }, {
      name: 'repaintOnResize',
      defaultValue: false
    },
    /**
     * An optional query selector to select a sub element within the cell being
     * edited to align a cell editor's `X` position and `width` to.
     * @config {String} editTargetSelector
     * @category Misc
     */
    'editTargetSelector', //endregion
    //region Export

    /**
     * Used by the Export feature. Set to `false` to omit a column from an exported dataset
     * @config {Boolean} exportable
     * @default true
     * @category Export
     */
    {
      name: 'exportable',
      defaultValue: true
    },
    /**
     * Column type which will be used by {@link Grid.util.TableExporter}. See list of available types in TableExporter
     * doc. Returns undefined by default, which means column type should be read from the record field.
     * @config {String} exportedType
     * @category Export
     */
    {
      name: 'exportedType'
    } //endregion
    ];
  } // prevent undefined fields from being exposed, to simplify spotting errors


  static get autoExposeFields() {
    return false;
  } //endregion
  //region Init


  construct(data, store) {
    const me = this;
    me.masterStore = store; // Store might be an array

    if (store) {
      me._grid = Array.isArray(store) ? store[0].grid : store.grid;
    }

    me.localizableProperties = data.localizableProperties || ['text'];

    if (data.localeClass) {
      me.localeClass = data.localeClass;
    }

    super.construct(data, store, null, false); // Default value for region is assigned by the ColumnStore in createRecord(), same for `locked`
    // Allow field : null if the column does not rely on a record field.
    // For example the CheckColumn when used by GridSelection.

    if (me.isLeaf && !('field' in me.data)) {
      me.field = '_' + (me.type || '') + ++Column.emptyCount;
      me.noFieldSpecified = true;
    } // If our field is a dot separated path, we must use ObjectHelper.getPath to extract our value


    me.hasComplexMapping = me.field && me.field.includes('.');

    if (!me.width && !me.flex && !me.children) {
      // Set the width silently because we're in construction.
      me.set({
        width: Column.defaultWidth,
        flex: null
      }, null, true);
    }
  }

  doDestroy() {
    var _this$data, _this$data$editor, _this$data$editor$des;

    (_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$editor = _this$data.editor) === null || _this$data$editor === void 0 ? void 0 : (_this$data$editor$des = _this$data$editor.destroy) === null || _this$data$editor$des === void 0 ? void 0 : _this$data$editor$des.call(_this$data$editor);
    super.doDestroy();
  }

  remove() {
    const {
      subGrid,
      grid
    } = this,
          focusedCell = subGrid && grid && grid.focusedCell; // Prevent errors when removing the column that the owning grid has registered as focused.

    if (focusedCell && focusedCell.columnId === this.id) {
      // Focus is in the grid, navigate before column is removed
      if (grid.owns(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(grid))) {
        grid.navigateRight();
      } // Focus not in the grid, bump the focused cell pointer to the ext visible column.
      else {
        focusedCell.columnId = subGrid.columns.getAdjacentVisibleLeafColumn(this.id, true, true).id;
      }
    }

    super.remove();
  }
  /**
   * Extracts the value from the record specified by this Column's {@link #config-field} specification.
   *
   * This will work if the field is a dot-separated path to access fields in associated records, eg
   *
   * ```javascript
   *  field : 'resource.calendar.name'
   * ```
   *
   * **Note:** This is the raw field value, not the value returned by the {@link #config-renderer}.
   * @param {Core.data.Model} record The record from which to extract the field value.
   * @returns {*} The value of the referenced field if any.
   */


  getRawValue(record) {
    const me = this;

    if (me.hasComplexMapping) {
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getPath(record, me.field);
    } // Engine can change field value to null, in which case cell will render previous record value, before project commit


    return record[me.field];
  }
  /**
   * Extracts the value from the record specified by this Column's {@link #config-field} specification
   * in a format that can be used as a value to match by a {@link Grid.feature.Filter filtering} operation.
   *
   * The default implementation returns the {@link #function-getRawValue} value, but this may be
   * overridden in subclasses.
   * @param {Core.data.Model} record The record from which to extract the field value.
   * @returns {*} The value of the referenced field if any.
   */


  getFilterableValue(record) {
    return this.getRawValue(record);
  } // Create an ownership hierarchy which links columns up to their SubGrid if no owner injected.


  get owner() {
    return this._owner || this.subGrid;
  }

  set owner(owner) {
    this._owner = owner;
  }

  get nextVisibleSibling() {
    // During move from one region to another, nextSibling might not be wired up to the new next sibling in region.
    // (Because the order in master store did not change)
    const region = this.region;
    let next = this.nextSibling;

    while (next && (next.hidden || next.region !== region)) {
      next = next.nextSibling;
    }

    return next;
  }

  get isLastInSubGrid() {
    return !this.nextVisibleSibling && (!this.parent || this.parent.isLastInSubGrid);
  }
  /**
   * The header element for this Column. *Only available after the grid has been rendered*.
   *
   * **Note that column headers are rerendered upon mutation of Column values, so this
   * value is volatile and should not be cached, but should be read whenever needed.**
   * @property {HTMLElement}
   * @readonly
   */


  get element() {
    return this.grid.getHeaderElement(this);
  }
  /**
   * The text wrapping element for this Column. *Only available after the grid has been rendered*.
   *
   * This is the full-width element which *contains* the text-bearing element and any icons.
   *
   * **Note that column headers are rerendered upon mutation of Column values, so this
   * value is volatile and should not be cached, but should be read whenever needed.**
   * @property {HTMLElement}
   * @readonly
   */


  get textWrapper() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.element, '.b-grid-header-text');
  }
  /**
   * The text containing element for this Column. *Only available after the grid has been rendered*.
   *
   * **Note that column headers are rerendered upon mutation of Column values, so this
   * value is volatile and should not be cached, but should be read whenever needed.**
   * @property {HTMLElement}
   * @readonly
   */


  get textElement() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].down(this.element, '.b-grid-header-text-content');
  }
  /**
   * The child element into which content should be placed. This means where any
   * contained widgets such as filter input fields should be rendered. *Only available after the grid has been rendered*.
   *
   * **Note that column headers are rerendered upon mutation of Column values, so this
   * value is volatile and should not be cached, but should be read whenever needed.**
   * @property {HTMLElement}
   * @readonly
   */


  get contentElement() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].down(this.element, '.b-grid-header-children');
  }
  /**
   * The Field to use as editor for this column
   * @private
   * @readonly
   */


  get editor() {
    let editor = this.data.editor;

    if (editor && !(editor instanceof _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"])) {
      // Give frameworks a shot at injecting their own editor, wrapped as a widget
      const result = this.grid.processCellEditor({
        editor,
        field: this.field
      });

      if (result) {
        // Use framework editor
        editor = this.data.editor = result.editor;
      } else {
        if (typeof editor === 'string') {
          editor = {
            type: editor
          };
        } // The two configs, default and configured must be deep merged.


        editor = this.data.editor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge(this.defaultEditor, editor, {
          owner: this.grid
        }));
      }
    }

    return editor;
  }

  set editor(editor) {
    this.data.editor = editor;
  }
  /**
   * A config object specifying the editor to use to edit this column.
   * @private
   * @readonly
   */


  get defaultEditor() {
    return {
      type: 'textfield',
      name: this.field
    };
  }
  /**
   * Default settings for the column, applied in constructor. None by default, override in subclass.
   * @member {Object} defaults
   * @returns {Object}
   * @readonly
   */
  //get defaults() {
  //    return {};
  //}
  //endregion
  //region Properties


  get isFocusable() {
    return this.isLeaf;
  }

  static get type() {
    return 'column';
  }

  static get text() {
    return this.$meta.fields.defaults.text;
  }

  get grid() {
    return this._grid || this.parent && this.parent.grid;
  }

  get locked() {
    return this.data.region === 'locked';
  }

  set locked(locked) {
    this.region = locked ? 'locked' : 'normal';
  } // parent headers cannot be sorted by


  get sortable() {
    return this.isLeaf && this.data.sortable;
  }

  set sortable(sortable) {
    this.set('sortable', sortable);
  } // parent headers cannot be grouped by


  get groupable() {
    return this.isLeaf && this.data.groupable;
  }

  set groupable(groupable) {
    this.set('groupable', groupable);
  }
  /**
   * Returns header text based on {@link #config-htmlEncodeHeaderText} config value.
   * @return {String}
   * @internal
   */


  get headerText() {
    return this.htmlEncodeHeaderText ? _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].encodeHtml(this.text) : this.text;
  } //endregion
  //region Show/hide

  /**
   * Hides this column.
   */


  hide(silent = false) {
    const me = this,
          parent = me.parent; // Reject non-change

    if (!me.hidden) {
      me.hidden = true;

      if (parent && !parent.isRoot) {
        // check if all sub columns are hidden, if so hide parent
        const anyVisible = parent.children.some(child => child.hidden !== true);

        if (!anyVisible && !parent.hidden) {
          silent = true; // hiding parent will trigger event

          parent.hide();
        }
      }

      if (me.children) {
        me.children.forEach(child => child.hide(true));
      }

      if (!silent) {
        me.stores.forEach(store => store.trigger('columnHide', {
          column: me
        }));
      }
    }
  }
  /**
   * Shows this column.
   */


  show(silent = false) {
    const me = this,
          parent = me.parent; // Reject non-change

    if (me.hidden) {
      me.hidden = false;

      if (parent && parent.hidden) {
        parent.show();
      }

      if (me.children) {
        me.children.forEach(child => child.show(true));
      } // event is triggered on chained stores


      if (!silent) {
        me.stores.forEach(store => store.trigger('columnShow', {
          column: me
        }));
      }
    }
  }
  /**
   * Toggles the column visibility.
   * @param {Boolean} force Set to true (visible) or false (hidden) to force a certain state
   */


  toggle(force = null) {
    if (this.hidden && force === undefined || force === true) return this.show();
    if (!this.hidden && force === undefined || force === false) return this.hide();
  } //endregion
  //region Index & id

  /**
   * Generates an id for the column when none is set. Generated ids are 'col1', 'col2' and so on. If a field is
   * specified (as it should be in most cases) the field name is used instead: 'name1', 'age2' ...
   * @private
   * @returns {String}
   */


  generateId() {
    if (!Column.generatedIdIndex) Column.generatedIdIndex = 0;
    return (this.field ? this.field.replace(/\./g, '-') : 'col') + ++Column.generatedIdIndex;
  }
  /**
   * Index among all flattened columns
   * @property {Number}
   * @readOnly
   * @internal
   */


  get allIndex() {
    return this.masterStore.indexOf(this);
  } //endregion
  //region Width

  /**
   * Returns minimal width in pixels for applying to style according to the current `width` and `minWidth`. Used for IE11.
   * @internal
   */


  get calcMinWidth() {
    const {
      width,
      minWidth
    } = this.data;

    if (validWidth(width) && validWidth(minWidth)) {
      return Math.max(parseInt(width) || 0, parseInt(minWidth) || 0);
    } else {
      return width;
    }
  }
  /**
   * Get/set columns width in px. If column uses flex, width will be undefined.
   * Setting a width on a flex column cancels out flex.
   *
   * **NOTE:** Grid might be configured to always stretch the last column, in which case the columns actual width
   * might deviate from the configured width.
   *
   * ```javascript
   * let grid = new Grid({
   *     appendTo : 'container',
   *     height   : 200,
   *     width    : 400,
   *     columns  : [{
   *         text  : 'First column',
   *         width : 100
   *     }, {
   *         text  : 'Last column',
   *         width : 100 // last column in the grid is always stretched to fill the free space
   *     }]
   * });
   *
   * grid.columns.last.element.offsetWidth; // 300 -> this points to the real element width
   * ```
   * @property {Number|String}
   */


  get width() {
    return this.data.width;
  }

  set width(width) {
    const data = {
      width
    };

    if (width && 'flex' in this.data) {
      data.flex = null; // remove flex when setting width to enable resizing flex columns
    }

    this.set(data);
  }

  set flex(flex) {
    const data = {
      flex
    };

    if (flex && 'width' in this.data) {
      data.width = null; // remove width when setting flex
    }

    this.set(data);
  }

  get flex() {
    return this.data.flex;
  } // Private, only used in tests where standalone Headers are created with no grid
  // from which to lookup the associate SubGrid.


  set subGrid(subGrid) {
    this._subGrid = subGrid;
  }
  /**
   * Get the SubGrid to which this column belongs
   * @property {Grid.view.SubGrid}
   * @readonly
   */


  get subGrid() {
    return this._subGrid || (this.grid ? this.grid.getSubGridFromColumn(this) : undefined);
  }
  /**
   * Get the element for the SubGrid to which this column belongs
   * @property {HTMLElement}
   * @readonly
   * @private
   */


  get subGridElement() {
    return this.subGrid.element;
  } // Returns size in pixels for measured value


  measureSize(value) {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].measureSize(value, this.subGrid ? this.subGrid.element : undefined);
  }

  get isVisible() {
    return !this.hidden && (!this.parent || this.parent.isVisible);
  } // This method is used to calculate minimum row width for edge and safari
  // It calculates minimum width of the row taking column hierarchy into account


  calculateMinWidth() {
    const me = this,
          width = me.measureSize(me.width),
          minWidth = me.measureSize(me.minWidth);
    let minChildWidth = 0;

    if (me.children) {
      minChildWidth = me.children.reduce((result, column) => {
        return result + column.calculateMinWidth();
      }, 0);
    }

    return Math.max(width, minWidth, minChildWidth);
  }
  /**
   * Resizes the column to match the widest string in it. By default it also measures the column header, this
   * behaviour can be configured by setting {@link Grid.view.Grid#config-resizeToFitIncludesHeader}.
   *
   * Called internally when you double click the edge between
   * column headers, but can also be called programmatically. For performance reasons it is limited to checking 1000
   * rows surrounding the current viewport.
   *
   * @param {Number|Number[]} widthMin Minimum allowed width. If content width is less than this, this width is used
   * instead. If this parameter is an array, the first element is `widthMin` and the seconds is `widthMax`.
   * @param {Number} widthMax Maximum allowed width. If the content width is greater than this number, this width
   * is used instead.
   */


  resizeToFitContent(widthMin, widthMax, batch = false) {
    const me = this,
          {
      grid,
      element,
      fitMode
    } = me,
          {
      rowManager,
      store
    } = grid,
          {
      count
    } = store;

    if (count <= 0 || me.fitMode === 'none' || !me.fitMode) {
      return;
    }

    const [row] = rowManager.rows,
          {
      rowElement,
      cellElement
    } = grid.beginGridMeasuring();
    let maxWidth = 0,
        start,
        end,
        i,
        record,
        value,
        length,
        longest = {
      length: 0,
      record: null
    }; // Fake element data to be able to use Row#renderCell()

    cellElement._domData = {
      columnId: me.id,
      row,
      rowElement
    }; // Clear cellElement, since it is being reused between columns

    cellElement.innerHTML = ''; // Measure header unless configured not to

    if (grid.resizeToFitIncludesHeader) {
      // Cache the padding
      if (!grid.$headerPadding) {
        const style = window.getComputedStyle(element);
        grid.$headerPadding = parseInt(style.paddingLeft);
      } // Grab the header text content element


      const headerText = element.querySelector('.b-grid-header-text-content'); // Restyle it to shrinkwrap its text, measure and then restore

      headerText.style.cssText = 'flex: none; width: auto';
      maxWidth = headerText.offsetWidth + grid.$headerPadding * 2 + 2; // +2 to avoid overflow ellipsis

      headerText.style.cssText = '';
    } // If it's a very large dataset, measure the maxWidth of the field in the 1000 rows
    // surrounding the rendered block.


    if (count > 1000) {
      start = Math.max(Math.min(rowManager.topIndex + Math.round(rowManager.rowCount / 2) - 500, count - 1000), 0);
      end = start + 1000;
    } else {
      start = 0;
      end = count;
    }

    for (i = start; i < end; i++) {
      record = store.getAt(i);
      value = me.getRawValue(record); // In value mode we determine the record with the longest value, no rendering involved

      if (fitMode === 'value') {
        length = String(value).length;
      } // In exact and textContent modes we have to render the records
      else {
        row.renderCell({
          cellElement,
          record,
          updatingSingleRow: true,
          isMeasuring: true
        }); // Reading textContent is "cheap", it does not require a layout

        if (fitMode === 'textContent') {
          length = cellElement.textContent.length;
        } // Using exact mode, measure the cell = expensive
        else {
          const width = cellElement.offsetWidth;

          if (width > maxWidth) {
            maxWidth = width;
          }
        }
      }

      if (length > longest.length) {
        longest = {
          record,
          length
        };
      }
    } // value mode and textContent mode both required us to render and measure the record determined to be the
    // longest above


    if (fitMode === 'value' || fitMode === 'textContent') {
      row.renderCell({
        cellElement,
        record: longest.record,
        updatingSingleRow: true,
        isMeasuring: true
      });
      maxWidth = Math.max(maxWidth, cellElement.offsetWidth);
    }

    if (Array.isArray(widthMin)) {
      [widthMin, widthMax] = widthMin;
    }

    maxWidth = Math.max(maxWidth, widthMin || 0);
    maxWidth = Math.min(maxWidth, widthMax || 1e6); // 1 million px default max
    // Batch mode saves a little time by not removing the measuring elements between columns

    if (!batch) {
      grid.endGridMeasuring();
    }

    me.width = me.maxWidth ? maxWidth = Math.min(maxWidth, me.maxWidth) : maxWidth;
    return maxWidth;
  } //endregion
  //region State

  /**
   * Get column state, used by State mixin
   * @private
   */


  getState() {
    const me = this,
          state = {
      id: me.id,
      // State should only store column attributes which user can modify via UI (except column index).
      // User can hide column, resize or move it to neighbor region
      [me.flex ? 'flex' : 'width']: me.flex ? me.flex : me.width,
      hidden: me.hidden,
      region: me.region,
      locked: me.locked
    };

    if (me.children) {
      state.children = me.children.map(child => child.getState());
    }

    return state;
  }
  /**
   * Apply state to column, used by State mixin
   * @private
   */


  applyState(state) {
    const me = this;
    me.beginBatch();

    if ('locked' in state) {
      me.locked = state.locked;
    }

    if ('width' in state) {
      me.width = state.width;
    }

    if ('flex' in state) {
      me.flex = state.flex;
    }

    if ('width' in state && me.flex) {
      me.flex = undefined;
    } else if ('flex' in state && me.width) {
      me.width = undefined;
    }

    if ('region' in state) {
      me.region = state.region;
    }

    me.endBatch();

    if ('hidden' in state) {
      me.toggle(state.hidden !== true);
    }
  } //endregion
  //region Other

  /**
   * Refresh the cell for supplied record in this column, if that cell is rendered.
   * @param {Core.data.Model} record Record used to get row to update the cell in
   */


  refreshCell(record) {
    this.grid.rowManager.refreshCell(record, this.id);
  }
  /**
   * Clear cell contents. Base implementation which just sets innerHTML to blank string.
   * Should be overridden in subclasses to clean up for examples widgets.
   * @param {HTMLElement} cellElement
   * @internal
   */


  clearCell(cellElement) {
    cellElement.innerHTML = '';
    delete cellElement._content;
  }
  /**
   * Override in subclasses to allow/prevent editing of certain rows.
   * @param {Core.data.Model} record
   * @internal
   */


  canEdit(record) {
    // the record can decide which column is editable
    if (record.isEditable) {
      const isEditable = record.isEditable(this.field); // returns undefined for unknown field

      if (isEditable !== undefined) {
        return isEditable;
      }
    }

    return true;
  }
  /**
   * Insert a child column(s) before an existing child column. Returns `null` if the parent column is {@link #config-sealed}
   * @param {Core.data.Model|Core.data.Model[]} childColumn Column or array of columns to insert
   * @param {Core.data.Model} [before] Optional column to insert before, leave out to append to the end
   * @param {Boolean} [silent] Pass `true` to not trigger events during insert
   * @returns {Core.data.Model|Core.data.Model[]|null}
   * @category Parent & children
   */


  insertChild(childColumn, before = null, silent = false) {
    return this.sealed && !this.inProcessChildren ? null : super.insertChild(...arguments);
  } //endregion


} // Registered in ColumnStore as we can't have this in Column due to circular dependencies
// ColumnStore.registerColumnType(Column);

Column.emptyCount = 0;
Column.defaultWidth = 100;
Column.exposeProperties();
Column._$name = 'Column';

/***/ }),

/***/ "./lib/Grid/column/DateColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/DateColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * @module Grid/column/DateColumn
 */

/**
 * A column that displays a date in the specified {@link #config-format}. By default `L` format is used, which
 * contains the following info: full year, 2-digit month, and 2-digit day. Depending on the browser locale,
 * the formatted date might look different. [Intl.DateTimeFormat API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat)
 * is used to format the date. Here is an example of possible outputs depending on the browser locale:
 *
 * ```javascript
 * // These options represent `L` format
 * const options = { year : 'numeric', month : '2-digit', day : '2-digit' };
 *
 * new Intl.DateTimeFormat('en-US', options).format(new Date(2021, 6, 1)); // "07/01/2021"
 * new Intl.DateTimeFormat('ru-RU', options).format(new Date(2021, 6, 1)); // "01.07.2021"
 *
 * // Formatting using Bryntum API
 * LocaleManager.applyLocale('En');
 * DateHelper.format(new Date(2021, 6, 1), 'L'); // "07/01/2021"
 * LocaleManager.applyLocale('Ru');
 * DateHelper.format(new Date(2021, 6, 1), 'L'); // "01.07.2021"
 * ```
 *
 * To learn more about available formats check out {@link Core.helper.DateHelper} docs.
 *
 * The {@link Core.data.field.DateDataField field} this column reads data from should be a type of date.
 *
 * Default editor is a {@link Core.widget.DateField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     columns : [
 *          { type: 'date', text: 'Start date', format: 'YYYY-MM-DD', field: 'start' }
 *     ]
 * });
 *
 * @classType date
 * @inlineexample Grid/column/DateColumn.js
 */

class DateColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DateColumn';
  } //region Config


  static get type() {
    return 'date';
  } // Type to use when auto adding field


  static get fieldType() {
    return 'date';
  }

  static get fields() {
    return ['format', 'pickerFormat', 'step'];
  }

  static get defaults() {
    return {
      /**
       * The {@link Core.data.field.DateDataField#config-name} of the data model date field to read data from.
       * @config {String} field
       * @category Common
       */

      /**
       * Date format to convert a given date object into a string to display. By default `L` format is used, which
       * contains the following info: full year, 2-digit month, and 2-digit day. Depending on the browser locale,
       * the formatted date might look different. [Intl.DateTimeFormat API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat)
       * is used to format the date. Here is an example of possible outputs depending on the browser locale:
       *
       * ```javascript
       * // These options represent `L` format
       * const options = { year : 'numeric', month : '2-digit', day : '2-digit' };
       *
       * new Intl.DateTimeFormat('en-US', options).format(new Date(2021, 6, 1)); // "07/01/2021"
       * new Intl.DateTimeFormat('ru-RU', options).format(new Date(2021, 6, 1)); // "01.07.2021"
       *
       * // Formatting using Bryntum API
       * LocaleManager.applyLocale('En');
       * DateHelper.format(new Date(2021, 6, 1), 'L'); // "07/01/2021"
       * LocaleManager.applyLocale('Ru');
       * DateHelper.format(new Date(2021, 6, 1), 'L'); // "01.07.2021"
       * ```
       *
       * To learn more about available formats check out {@link Core.helper.DateHelper} docs.
       *
       * Note, the {@link Core.data.field.DateDataField field} this column reads data from should be a type of date.
       * @config {String}
       * @default
       * @category Common
       */
      format: 'L',

      /**
       * Time increment duration value to apply when clicking the left / right trigger icons. See {@link Core.widget.DateField#config-step} for more information
       * Set to `null` to hide the step triggers.
       * @config {String|Number|Object}
       * @default
       * @category Common
       */
      step: 1,
      minWidth: 85,
      filterType: 'date'
    };
  } //endregion
  //region Init


  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-date-cell';
  } //endregion
  //region Display

  /**
   * Renderer that displays the date with the specified format. Also adds cls 'date-cell' to the cell.
   * @private
   */


  defaultRenderer({
    value
  }) {
    return value ? this.formatValue(value) : '';
  }
  /**
   * Group renderer that displays the date with the specified format.
   * @private
   */


  groupRenderer({
    cellElement,
    groupRowFor
  }) {
    cellElement.innerHTML = this.formatValue(groupRowFor);
  } //endregion
  //region Formatter

  /**
   * Used by both renderer and groupRenderer to do the actual formatting of the date
   * @private
   * @param value
   * @returns {String}
   */


  formatValue(value) {
    // Ideally we should be served a date, but if not make it easier for the user by parsing
    if (typeof value === 'string') {
      value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, this.format || undefined); // null does not use default format
    }

    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(value, this.format || undefined);
  } //endregion
  //region Getters/setters

  /**
   * Get/Set format for date displayed in cell and editor (see {@link Core.helper.DateHelper#function-format-static} for formatting options)
   * @property {String}
   */


  set format(value) {
    const me = this,
          editor = me.data.editor;
    me.set('format', value);

    if (editor) {
      editor.format = me.format;
    }
  }

  get format() {
    return this.get('format');
  }

  get defaultEditor() {
    const me = this;
    return {
      name: me.field,
      type: 'date',
      calendarContainerCls: 'b-grid-cell-editor-related',
      weekStartDay: me.grid.weekStartDay,
      format: me.format,
      step: me.step
    };
  } //endregion


}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(DateColumn, true);
DateColumn.exposeProperties();
DateColumn._$name = 'DateColumn';

/***/ }),

/***/ "./lib/Grid/column/NumberColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/NumberColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




/**
 * @module Grid/column/NumberColumn
 */

/**
 * A column for showing/editing numbers.
 *
 * Default editor is a {@link Core.widget.NumberField NumberField}.
 *
 * @extends Grid/column/Column
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'number', min: 0, max : 100, field: 'score' }
 *     ]
 * });
 *
 * @classType number
 * @inlineexample Grid/column/NumberColumn.js
 */

class NumberColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'number';
  } // Type to use when auto adding field


  static get fieldType() {
    return 'number';
  }

  static get fields() {
    return ['format',
    /**
     * The minimum value for the field used during editing.
     * @config {Number} min
     * @category Common
     */
    'min',
    /**
     * The maximum value for the field used during editing.
     * @config {Number} max
     * @category Common
     */
    'max',
    /**
     * Step size for the field used during editing.
     * @config {Number} step
     * @category Common
     */
    'step',
    /**
     * Large step size for the field used during editing. In effect for `SHIFT + click/arrows`
     * @config {Number} largeStep
     * @category Common
     */
    'largeStep',
    /**
     * Unit to append to displayed value.
     * @config {String} unit
     * @category Common
     */
    'unit'];
  }

  static get defaults() {
    return {
      filterType: 'number',

      /**
       * The format to use for rendering numbers.
       *
       * By default, the locale's default number formatter is used. For `en-US`, the
       * locale default is a maximum of 3 decimal digits, using thousands-based grouping.
       * This would render the number `1234567.98765` as `'1,234,567.988'`.
       *
       * @config {String|Object|Core.helper.util.NumberFormat}
       */
      format: ''
    };
  }

  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-number-cell';
  } //endregion
  //region Init


  get defaultEditor() {
    const {
      format,
      name,
      max,
      min,
      step,
      largeStep,
      align
    } = this; // Remove any undefined configs, to allow config system to use default values instead

    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].cleanupProperties({
      type: 'numberfield',
      format,
      name,
      max,
      min,
      step,
      largeStep,
      textAlign: align
    });
  }

  get formatter() {
    const me = this,
          {
      format
    } = me;
    let formatter = me._formatter;

    if (!formatter || me._lastFormat !== format) {
      me._formatter = formatter = _Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_2__["default"].get(me._lastFormat = format);
    }

    return formatter;
  }
  /**
   * Renderer that displays value + optional unit in the cell
   * @private
   */


  defaultRenderer({
    value
  }) {
    if (value != null) {
      value = this.formatter.format(value);

      if (this.unit) {
        value = `${value}${this.unit}`;
      }
    } else {
      value = '';
    }

    return value;
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(NumberColumn, true);
NumberColumn.exposeProperties();
NumberColumn._$name = 'NumberColumn';

/***/ }),

/***/ "./lib/Grid/column/PercentColumn.js":
/*!******************************************!*\
  !*** ./lib/Grid/column/PercentColumn.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PercentColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Grid/column/PercentColumn
 */

/**
 * A column that display a basic progress bar.
 *
 * Default editor is a {@link Core.widget.NumberField NumberField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'percent', text: 'Progress', data: 'progress' }
 *     ]
 * });
 *
 * @classType percent
 * @inlineexample Grid/column/PercentColumn.js
 */

class PercentColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'percent';
  } // Type to use when auto adding field


  static get fieldType() {
    return 'number';
  }

  static get fields() {
    return ['showValue', 'lowThreshold'];
  }

  static get defaults() {
    return {
      /**
       * PercentColumn uses a {@link Core.widget.NumberField} configured with an allowed interval 0 - 100 as
       * its default editor.
       * @config {Object|String}
       * @default Core.widget.NumberField
       * @category Misc
       */
      editor: {
        type: 'number',
        min: 0,
        max: 100
      },

      /**
       * Set to `true` to render the number value inside the bar, for example "15%"
       * @config {Boolean}
       * @default
       * @category Rendering
       */
      showValue: false,

      /**
       * When below this percentage the bar will have `b-low` CSS class added. By default it turns the bar red.
       * @config {Number}
       * @default
       * @category Rendering
       */
      lowThreshold: 20,
      filterType: 'number',
      htmlEncode: false,
      searchable: false,
      summaryRenderer: sum => `${sum}%`,
      fitMode: false
    };
  }

  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-percent-bar-cell';
  }
  /**
   * Renderer that displays a progress bar in the cell.
   * @private
   */


  defaultRenderer({
    value
  }) {
    value = value || 0;
    return {
      className: 'b-percent-bar-outer',
      children: [{
        tag: 'div',
        className: {
          'b-percent-bar': 1,
          'b-zero': value === 0,
          'b-low': value < this.lowThreshold
        },
        style: {
          width: value + '%'
        },
        children: [this.showValue ? {
          tag: 'span',
          text: value + '%'
        } : undefined]
      }]
    };
  } // Null implementation because the column width drives the width of its content.
  // So the concept of sizing to content is invalid here.


  resizeToFitContent() {}

}
PercentColumn.sum = 'average';
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(PercentColumn, true);
PercentColumn._$name = 'PercentColumn';

/***/ }),

/***/ "./lib/Grid/column/RatingColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/RatingColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RatingColumn; });
/* harmony import */ var _NumberColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';



/**
 * @module Grid/column/RatingColumn
 */

/**
 * A column that displays a star rating. Click a start to set a value, shift+click to unset a single start from the end.
 * Clicking the first and only star toggles it.
 *
 * This column uses a custom widget as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/NumberColumn
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'rating', max : 10, field: 'rating' }
 *     ]
 * });
 *
 * @classType percent
 * @inlineexample Grid/column/RatingColumn.js
 */

class RatingColumn extends _NumberColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'rating';
  } // Type to use when auto adding field


  static get fieldType() {
    return 'number';
  }

  static get fields() {
    return ['emptyIcon', 'filledIcon', 'editable'];
  }

  static get defaults() {
    return {
      min: 0,
      max: 5,

      /**
       * The empty rating icon to show
       * @config {String}
       * @category Rendering
       */
      emptyIcon: 'b-icon b-icon-star',

      /**
       * The filled rating icon to show
       * @config {String}
       * @category Rendering
       */
      filledIcon: 'b-icon b-icon-star',

      /**
       * Allow user to click an icon to change the value
       * @config {Boolean}
       * @category Interaction
       */
      editable: true,
      filterType: 'number',
      searchable: false,
      width: '11.2em',
      htmlEncode: false,
      minWidth: '11.2em',
      editor: false,
      fitMode: 'value'
    };
  }

  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-rating-cell';
  }
  /**
   * Renderer that displays a number of stars in the cell. Also adds CSS class 'b-rating-cell' to the cell.
   * @private
   */


  renderer({
    value
  }) {
    return {
      className: {
        'b-rating-cell-inner': 1,
        'b-not-editable': !this.editable
      },
      children: _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].populate(this.max, i => {
        const filled = i < value;
        return {
          tag: 'i',
          className: {
            'b-rating-icon': true,
            'b-filled': filled,
            'b-empty': !filled,
            [filled ? this.filledIcon : this.emptyIcon]: true
          }
        };
      })
    };
  }

  onCellClick({
    grid,
    column,
    record,
    target,
    event
  }) {
    if (target.classList.contains('b-rating-icon') && !grid.readOnly && column.editable) {
      let starIndex = [].indexOf.call(target.parentNode.childNodes, target);

      if (target.classList.contains('b-filled') && (event.metaKey || event.shiftKey)) {
        starIndex = starIndex - 1;
      } // Clicking first star when it is only one removes it


      if (record.get(column.field) === 1 && starIndex === 0) {
        starIndex = -1;
      }

      record.set(column.field, starIndex + 1);
    }
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(RatingColumn, true);
RatingColumn.exposeProperties();
RatingColumn._$name = 'RatingColumn';

/***/ }),

/***/ "./lib/Grid/column/RowNumberColumn.js":
/*!********************************************!*\
  !*** ./lib/Grid/column/RowNumberColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowNumberColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';



/**
 * @module Grid/column/RowNumberColumn
 */

/**
 * A column that displays the row number in each cell.
 *
 * There is no `editor`, since value is read-only.
 *
 * ```javascript
 * const grid = new Grid({
 *   appendTo : targetElement,
 *   width    : 300,
 *   columns  : [
 *     { type : 'rownumber' }
 *   ]
 * });
 *
 * @extends Grid/column/Column
 *
 * @classType rownumber
 * @inlineexample Grid/column/RowNumberColumn.js
 */

class RowNumberColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaults() {
    return {
      /**
       * @config {Boolean} groupable
       * @hide
       */
      groupable: false,

      /**
       * @config {Boolean} sortable
       * @hide
       */
      sortable: false,

      /**
       * @config {Boolean} filterable
       * @hide
       */
      filterable: false,

      /**
       * @config {Boolean} searchable
       * @hide
       */
      searchable: false,

      /**
       * @config {Boolean} resizable
       * @hide
       */
      resizable: false,
      minWidth: 50,
      width: 50,
      align: 'right',
      text: '#',
      editor: false
    };
  }

  construct(config) {
    super.construct(...arguments);
    const me = this,
          {
      grid
    } = me;
    me.internalCellCls = 'b-row-number-cell';

    if (grid) {
      // Update our width when the store mutates (tests test Columns in isolation with no grid, so we must handle that!)
      grid.on({
        bindStore: 'bindStore',
        thisObj: me
      });
      me.bindStore({
        store: grid.store,
        initial: true
      });

      if (grid.store.count && !grid.rendered) {
        grid.on({
          paint: 'resizeToFitContent',
          thisObj: me,
          once: true
        });
      }
    }
  }

  static get type() {
    return 'rownumber';
  }

  get groupHeaderReserved() {
    return true;
  }

  bindStore({
    store,
    initial
  }) {
    const me = this;
    me.detachListeners('grid');
    store.on({
      name: 'grid',
      [`change${me.grid.asyncEventSuffix}`]: 'onStoreChange',
      thisObj: me
    });

    if (!initial) {
      me.resizeToFitContent();
    }
  }

  onStoreChange({
    action
  }) {
    if (action === 'dataset' || action === 'add' || action === 'remove' || action === 'removeall') {
      this.resizeToFitContent();
    }
  }
  /**
   * Renderer that displays the row number in the cell.
   * @private
   */


  renderer({
    record,
    grid
  }) {
    return record.isSpecialRow ? '' : grid.store.indexOf(record, true) + 1;
  }
  /**
   * Resizes the column to match the widest string in it. Called when you double click the edge between column
   * headers
   */


  resizeToFitContent() {
    const {
      grid
    } = this,
          {
      store
    } = grid,
          {
      count
    } = store;

    if (count && !this.hidden) {
      const cellElement = grid.element.querySelector(`.b-grid-cell[data-column-id="${this.id}"]`); // cellElement might not exist, e.g. when trial is expired

      if (cellElement) {
        const cellPadding = parseInt(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getStyleValue(cellElement, 'padding-left')),
              maxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].measureText(count, cellElement);
        this.width = Math.max(this.minWidth, maxWidth + 2 * cellPadding);
      }
    }
  }

  set flex(f) {}

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(RowNumberColumn, true);
RowNumberColumn._$name = 'RowNumberColumn';

/***/ }),

/***/ "./lib/Grid/column/TemplateColumn.js":
/*!*******************************************!*\
  !*** ./lib/Grid/column/TemplateColumn.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Grid/column/TemplateColumn
 */

/**
 * A column that uses a template for cell content. Any function can be used as template, and the function is passed { value, record, field } properties.
 * It should return a string which will be rendered in the cell.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'template', field: 'age', template: value => `${value} years old` }
 *     ]
 * });
 *
 * @classType template
 * @inlineexample Grid/column/TemplateColumn.js
 */

class TemplateColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get fields() {
    return [
    /**
     * Template function used to generate a value displayed in the cell. Called with arguments { value, record, field }
     * @config {Function} template
     * @category Common
     */
    'template'];
  }

  static get defaults() {
    return {
      htmlEncode: false
    };
  }

  constructor(config, store) {
    super(...arguments);
    const me = this;

    if (!me.template) {
      throw new Error('TemplateColumn needs a template');
    }

    if (typeof me.template !== 'function') {
      throw new Error('TemplateColumn.template must be a function');
    }
  }

  static get type() {
    return 'template';
  }
  /**
   * Renderer that uses a template for cell content.
   * @private
   */


  renderer(renderData) {
    // If it's a special row, such as a group row, we can't use the user's template
    if (!renderData.record.isSpecialRow) {
      return this.template({
        value: renderData.value,
        record: renderData.record,
        field: renderData.column.field
      });
    }
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(TemplateColumn, true);
TemplateColumn.exposeProperties();
TemplateColumn._$name = 'TemplateColumn';

/***/ }),

/***/ "./lib/Grid/column/TimeColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/TimeColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * @module Grid/column/TimeColumn
 */

/**
 * A column that displays a time in the specified format (see {@link Core.helper.DateHelper#function-format-static} for formatting options).
 *
 * Default editor is a {@link Core.widget.TimeField TimeField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *          { type: 'time', text: 'Start time', format: 'HH:mm:ss', data: 'start' }
 *     ]
 * });
 *
 * @classType time
 * @inlineexample Grid/column/TimeColumn.js
 */

class TimeColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'time';
  } // Type to use when auto adding field


  static get fieldType() {
    return 'date';
  }

  static get fields() {
    return ['format'];
  }

  static get defaults() {
    return {
      /**
       * Time format
       * @config {String}
       * @category Common
       */
      format: 'LT',
      minWidth: 140,
      filterType: 'time'
    };
  } //endregion
  //region Init


  constructor(config, store) {
    super(...arguments);
    this.internalCellCls = 'b-time-cell';
  } //endregion
  //region Display

  /**
   * Renderer that displays the time with the specified format. Also adds cls 'b-time-cell' to the cell.
   * @private
   */


  defaultRenderer({
    value
  }) {
    return value ? this.formatValue(value) : '';
  }
  /**
   * Group renderer that displays the time with the specified format.
   * @private
   */


  groupRenderer({
    cellElement,
    groupRowFor
  }) {
    cellElement.innerHTML = this.formatValue(groupRowFor);
  } //endregion
  //region Formatter

  /**
   * Used by both renderer and groupRenderer to do the actual formatting of the time
   * @private
   * @param value
   * @returns {String}
   */


  formatValue(value) {
    const me = this; // Ideally we should be served a time, but if not make it easier for the user by parsing

    if (typeof value === 'string') {
      value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, me.format);
    }

    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(value, me.format);
  } //endregion
  //region Getters/Setters

  /**
   * Get/Set format for time displayed in cell and editor (see {@link Core.helper.DateHelper#function-format-static} for formatting options)
   * @property {String}
   */


  set format(value) {
    const me = this,
          editor = me.editor;
    me.set('format', value);

    if (editor) {
      editor.format = me.format;
    }
  }

  get format() {
    return this.get('format');
  }

  get defaultEditor() {
    return {
      name: this.field,
      type: 'time',
      format: this.format
    };
  } //endregion


}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(TimeColumn, true);
TimeColumn.exposeProperties();
TimeColumn._$name = 'TimeColumn';

/***/ }),

/***/ "./lib/Grid/column/TreeColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/TreeColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TreeColumn; });
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Grid/column/TreeColumn
 */

let currentParentHasIcon = false;
/**
 * A column that displays a tree structure when using the {@link Grid.feature.Tree tree} feature.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * TreeColumn provides configs to define icons for {@link #config-expandIconCls expanded} / {@link #config-collapseIconCls collapsed} nodes,
 * {@link #config-expandedFolderIconCls expanded folder} / {@link #config-collapsedFolderIconCls collapsed folder} nodes and
 * {@link #config-leafIconCls leaf} nodes.
 *
 * When the TreeColumn renders its cells, it will look for two special fields {@link Grid.data.GridRowModel#field-href}
 * and {@link Grid.data.GridRowModel#field-target}. Specifying `href` will produce a link for the TreeNode,
 * and `target` will have the same meaning as in an A tag:
 *
 * ```javascript
 * {
 *    id        : 1,
 *    name      : 'Some external link'
 *    href      : '//www.website.com",
 *    target    : '_blank"
 * }
 * ```
 *
 * @example
 * new TreeGrid({
 *     appendTo : document.body,
 *
 *     columns : [
 *          { type: 'tree', field: 'name' }
 *     ]
 * });
 *
 * @classType tree
 * @extends Grid/column/Column
 * @inlineexample Grid/column/TreeColumn.js
 */

class TreeColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaults() {
    return {
      tree: true,
      hideable: false,
      minWidth: 150
    };
  }

  static get fields() {
    return [
    /**
     * The icon to use for the collapse icon in collapsed state
     * @config {String} expandIconCls
     */
    {
      name: 'expandIconCls',
      defaultValue: 'b-icon b-icon-tree-expand'
    },
    /**
     * The icon to use for the collapse icon in expanded state
     * @config {String} collapseIconCls
     */
    {
      name: 'collapseIconCls',
      defaultValue: 'b-icon b-icon-tree-collapse'
    },
    /**
     * The icon to use for the collapse icon in expanded state
     * @config {String} collapsedFolderIconCls
     */
    {
      name: 'collapsedFolderIconCls'
    },
    /**
     * The icon to use for the collapse icon in expanded state
     * @config {String} expandedFolderIconCls
     */
    {
      name: 'expandedFolderIconCls'
    },
    /**
     * Size of the child indent in em. Resulting indent is indentSize multiplied by child level.
     * @config {Number} indentSize
     * @default 1.7
     */
    {
      name: 'indentSize',
      defaultValue: 1.7
    },
    /**
     * The icon to use for the leaf nodes in the tree
     * @config {String} leafIconCls
     */
    {
      name: 'leafIconCls',
      defaultValue: 'b-icon b-icon-tree-leaf'
    }, {
      name: 'editTargetSelector',
      defaultValue: '.b-tree-cell-value'
    }];
  }

  static get type() {
    return 'tree';
  }

  constructor(config, store) {
    super(...arguments);
    const me = this;
    me.internalCellCls = 'b-tree-cell'; // We handle htmlEncoding in this class rather than relying on the generic Row DOM manipulation
    // since this class requires quite a lot of DOM infrastructure around the actual rendered content

    me.shouldHtmlEncode = me.htmlEncode;
    me.setData('htmlEncode', false); // add tree renderer (which calls original renderer internally)

    if (me.renderer) {
      me.originalRenderer = me.renderer;
    }

    me.renderer = me.treeRenderer.bind(me);
  }
  /**
   * A column renderer that is automatically added to the column with { tree: true }. It adds padding and node icons
   * to the cell to make the grid appear to be a tree. The original renderer is called in the process.
   * @private
   */


  treeRenderer(renderData) {
    const me = this,
          {
      grid,
      column,
      cellElement,
      row,
      record,
      isExport
    } = renderData,
          gridMeta = record.instanceMeta(grid.store),
          innerConfig = {
      className: 'b-tree-cell-value'
    },
          children = [innerConfig],
          result = {
      className: 'b-tree-cell-inner',
      tag: record.href ? 'a' : 'div',
      href: record.href,
      target: record.target,
      children
    },
          rowClasses = {
      'b-tree-parent-row': 0,
      'b-tree-collapsed': 0,
      'b-tree-expanded': 0,
      'b-loading-children': 0
    };
    let outputIsObject,
        iconCls,
        {
      value
    } = renderData;

    if (me.originalRenderer) {
      var _grid$hasFrameworkRen;

      const rendererHtml = me.originalRenderer(renderData),
            // Check if the cell content is going to be rendered by framework
      hasFrameworkRenderer = (_grid$hasFrameworkRen = grid.hasFrameworkRenderer) === null || _grid$hasFrameworkRen === void 0 ? void 0 : _grid$hasFrameworkRen.call(grid, {
        cellContent: rendererHtml,
        column
      });
      outputIsObject = typeof rendererHtml === 'object' && !hasFrameworkRenderer; // Reset the value when framework is responsible for the cell content

      value = hasFrameworkRenderer ? '' : rendererHtml === false ? cellElement.innerHTML : rendererHtml; // Save content to the `rendererHtml` to be used in processCellContent implemented by framework

      renderData.rendererHtml = rendererHtml;
    }

    if (!outputIsObject) {
      var _value;

      value = String((_value = value) !== null && _value !== void 0 ? _value : '');
    }

    if (isExport) {
      return value;
    }

    if (!record.isLeaf) {
      var _record$children;

      const isCollapsed = !record.isExpanded(grid.store),
            expanderIconCls = isCollapsed ? me.expandIconCls : me.collapseIconCls,
            folderIconCls = isCollapsed ? me.collapsedFolderIconCls : me.expandedFolderIconCls;
      rowClasses['b-tree-parent-row'] = 1;
      rowClasses['b-tree-collapsed'] = isCollapsed;
      rowClasses['b-tree-expanded'] = !isCollapsed;
      rowClasses['b-loading-children'] = gridMeta.isLoadingChildren;
      cellElement.classList.add('b-tree-parent-cell');
      children.unshift({
        tag: 'i',
        className: {
          'b-tree-expander': 1,
          [expanderIconCls]: 1,
          'b-empty-parent': !gridMeta.isLoadingChildren && record.children !== true && !((_record$children = record.children) !== null && _record$children !== void 0 && _record$children.length)
        }
      }); // Allow user to customize tree icon or opt out entirely

      currentParentHasIcon = iconCls = renderData.iconCls || record.iconCls || folderIconCls;
    } else {
      // TODO: Cleanup for reusing dom nodes should be done elsewhere, also cleanup selection
      cellElement.classList.add('b-tree-leaf-cell'); // Allow user to customize tree icon or opt out entirely

      iconCls = renderData.iconCls || record.iconCls || me.leafIconCls;
    } // Row can be just a dummy object for example when the renderer is called from Column#resizeToFitContent.
    // Add/remove the various tree node classes.


    if (row.isRow) {
      row.assignCls(rowClasses);
    } // If we are encoding HTML, or there's no raw HTML, we can use the children property
    // with the raw value as a child, and DomSync will create a TextNode from that.


    if (outputIsObject || me.shouldHtmlEncode || !value.includes('<')) {
      if (outputIsObject) {
        Object.assign(innerConfig, value);
      }

      innerConfig.children = innerConfig.children || [];
      innerConfig.children.unshift(iconCls ? {
        tag: 'i',
        className: {
          'b-tree-icon': 1,
          [iconCls]: 1
        }
      } : null, outputIsObject ? null : value);
    } // If we are accepting HTML without encoding it, and there is HTML we must use html property
    else {
      innerConfig.html = `${iconCls ? `<i class="b-tree-icon ${iconCls}"></i>` : ''}${value}`;
    }

    const padding = record.childLevel * me.indentSize + (record.isLeaf ? currentParentHasIcon ? 2.0 : iconCls ? 0.5 : 0.4 : 0);
    result.style = `padding-left:${padding}em`;
    return result;
  }

}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(TreeColumn, true);
TreeColumn.exposeProperties();
TreeColumn._$name = 'TreeColumn';

/***/ }),

/***/ "./lib/Grid/column/WidgetColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/WidgetColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetColumn; });
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt'; //TODO: Currently widgets reuse elements already in cell, but performance would improve if entire widget was reused
//TODO: Leaking widget on rerender of row, since the old one is not destroyed




/**
 * @module Grid/column/WidgetColumn
 */

/**
 * A column that displays widgets in the grid cells. If you use {@link Core.widget.Field Fields} inside this column, the
 * field widget can optionally bind its value to a field in the data model using the {@link Core.widget.Field#config-name}`.
 * This will provide two-way data binding and update the underlying row record as you make changes in the field.
 *
 * There is no `editor` provided. It is the configured widget's responsibility to provide editing if needed.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         {
 *              type: 'widget',
 *              text: 'Name',
 *              widgets: [
 *                  { type: 'textfield', name : 'firstName' },
 *                  { type: 'textfield', name : 'lastName' }
*               ]
 *         }
 *     ]
 * });
 *
 * @classType widget
 * @inlineexample Grid/column/WidgetColumn.js
 */

class WidgetColumn extends _Column_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get type() {
    return 'widget';
  }

  static get fields() {
    return [
    /**
     * An array of {@link Core.widget.Widget} config objects
     * @config {Object[]} widgets
     * @category Common
     */
    'widgets'];
  }
  /**
   * A renderer function, which gives you access to render data like the current `record`, `cellElement` and the
   * {@link #config-widgets} of the column. See {@link #config-renderer}
   * for more information.
   *
   * ```javascript
   * new Grid({
   *     columns : [
   *         {
   *              type: 'check',
   *              field: 'allow',
   *              // In the column renderer, we get access to the record and column widgets
   *              renderer({ record, widgets }) {
   *                  // Hide checkboxes in certain rows
   *                  widgets[0].hidden = record.readOnly;
   *              }
   *         }
   *     ]
   * });
   * ```
   *
   * @param {Object} renderData Object containing renderer parameters
   * @param {HTMLElement|null} [renderData.cellElement] Cell element, for adding CSS classes, styling etc.
   *        Can be `null` in case of export
   * @param {*} renderData.value Value to be displayed in the cell
   * @param {Core.data.Model} renderData.record Record for the row
   * @param {Grid.column.Column} renderData.column This column
   * @param {Core.widget.Widget[]} renderData.widgets An array of the widgets rendered into this cell
   * @param {Grid.view.Grid} renderData.grid This grid
   * @param {Grid.row.Row} [renderData.row] Row object. Can be null in case of export. Use the
   * {@link Grid.row.Row#function-assignCls row's API} to manipulate CSS class names.
   * @param {Object} [renderData.size] Set `size.height` to specify the desired row height for the current row.
   *        Largest specified height is used, falling back to configured {@link Grid/view/Grid#config-rowHeight}
   *        in case none is specified. Can be null in case of export
   * @param {Number} [renderData.size.height] Set this to request a certain row height
   * @param {Number} [renderData.size.configuredHeight] Row height that will be used if none is requested
   * @param {Boolean} [renderData.isExport] True if record is being exported to allow special handling during export
   * @param {Boolean} [renderData.isMeasuring] True if the column is being measured for a `resizeToFitContent`
   *        call. In which case an advanced renderer might need to take different actions.
   * @config {Function} renderer
   * @category Rendering
   */


  static get defaults() {
    return {
      filterable: false,
      sortable: false,
      editor: false,
      searchable: false,
      fitMode: false
    };
  } //endregion
  //region Init / Destroy


  construct(config, store) {
    const me = this;
    me.widgetMap = {};
    me.internalCellCls = 'b-widget-cell';
    super.construct(...arguments);
    me.externalRenderer = me.renderer;
    me.renderer = me.internalRenderer;
  }

  doDestroy() {
    // Destroy all the widgets we created.
    for (const widget of Object.values(this.widgetMap)) {
      widget.destroy && widget.destroy();
    }

    super.doDestroy();
  } //endregion
  //region Render

  /**
   * Renderer that displays a widget in the cell.
   * @param {Object} renderData Render data
   * @param {Grid.column.Column} renderData.column Rendered column
   * @param {Core.data.Model} renderData.record Rendered record
   * @private
   */


  internalRenderer(renderData) {
    var _this$externalRendere;

    const me = this,
          {
      cellElement,
      column,
      record,
      isExport
    } = renderData,
          widgets = column.widgets; // This renderer might be called from subclasses by accident
    // This condition saves us from investigating bug reports

    if (!isExport && widgets) {
      // If there is no widgets yet and we're going to add them,
      // need to make sure there is no content left in the cell after its previous usage
      // by grid features such as grouping feature or so.
      if (!cellElement.widgets) {
        // Reset cell content
        me.clearCell(cellElement);
      }

      cellElement.widgets = renderData.widgets = widgets.map((widgetCfg, i) => {
        var _me$onBeforeWidgetSet, _me$onAfterWidgetSetV;

        let widget, widgetNextSibling; // If cell element already has widgets, check if we need to destroy/remove one

        if (cellElement.widgets) {
          // Current widget
          widget = cellElement.widgets[i]; // Store next element sibling to insert widget to correct position later

          widgetNextSibling = widget.element.nextElementSibling; // If we are not syncing content for present widget, remove it from cell and render again later

          if (widgetCfg.recreate && widget) {
            // destroy widget and remove reference to it
            delete me.widgetMap[widget.id];
            widget.destroy();
            cellElement.widgets[i] = null;
          }
        } // Ensure widget is created if first time through


        if (!widget) {
          me.onBeforeWidgetCreate(widgetCfg, renderData);
          widgetCfg.recomposeAsync = false;
          widget = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].append(widgetCfg, widgetNextSibling ? {
            insertBefore: widgetNextSibling
          } : cellElement)[0];
          me.widgetMap[widget.id] = widget;
          me.onAfterWidgetCreate(widget, renderData);

          if (widget.name) {
            widget.on({
              change: ({
                value
              }) => {
                widget.cellInfo.record[widget.name] = value;
              }
            });
          }
        }

        widget.cellInfo = {
          record,
          column
        };

        if (me.grid && !me.isSelectionColumn) {
          widget.readOnly = me.grid.readOnly;
        }

        if (((_me$onBeforeWidgetSet = me.onBeforeWidgetSetValue) === null || _me$onBeforeWidgetSet === void 0 ? void 0 : _me$onBeforeWidgetSet.call(me, widget, renderData)) !== false) {
          const valueProperty = widgetCfg.valueProperty || 'value' in widget && 'value' || widget.defaultBindProperty;

          if (valueProperty) {
            const value = widget.name ? record[widget.name] : renderData.value;
            widget[valueProperty] = value;
          }
        }

        (_me$onAfterWidgetSetV = me.onAfterWidgetSetValue) === null || _me$onAfterWidgetSetV === void 0 ? void 0 : _me$onAfterWidgetSetV.call(me, widget, renderData);
        return widget;
      });
    }

    if (isExport) {
      return null;
    }

    return (_this$externalRendere = this.externalRenderer) === null || _this$externalRendere === void 0 ? void 0 : _this$externalRendere.call(this, renderData);
  } //endregion
  //region Other

  /**
   * Called before widget is created on rendering
   * @param {Object} widgetCfg Widget config
   * @param {Object} renderData Render data
   * @private
   */


  onBeforeWidgetCreate(widgetCfg, renderData) {}
  /**
   * Called after widget is created on rendering
   * @param {Core.widget.Widget} widget Created widget
   * @param {Object} renderData Render data
   * @private
   */


  onAfterWidgetCreate(widget, renderData) {}
  /**
   * Called before the widget gets its value on rendering. Pass `false` to skip value setting while rendering
   * @preventable
   * @function onBeforeWidgetSetValue
   * @param {Core.widget.Widget} widget Created widget
   * @param {Object} renderData Render data
   * @param {Grid.column.Column} renderData.column Rendered column
   * @param {Core.data.Model} renderData.record Rendered record
   */

  /**
   * Called after the widget gets its value on rendering.
   * @function onAfterWidgetSetValue
   * @param {Core.widget.Widget} widget Created widget
   * @param {Object} renderData Render data
   * @param {Grid.column.Column} renderData.column Rendered column
   * @param {Core.data.Model} renderData.record Rendered record
   */
  // Overrides base implementation to cleanup widgets, for example when a cell is reused as part of group header


  clearCell(cellElement) {
    if (cellElement.widgets) {
      cellElement.widgets.forEach(widget => {
        // Destroy widget and remove reference to it
        delete this.widgetMap[widget.id];
        widget.destroy();
      });
      cellElement.widgets = null;
    } // Even if there is no widgets need to make sure there is no content left, for example after a cell has been reused as part of group header


    super.clearCell(cellElement);
  } // Null implementation because there is no way of ascertaining whether the widgets get their width from
  // the column, or the column shrinkwraps the Widget.
  // Remember that the widget could have a width from a CSS rule which we cannot read.
  // It might have width: 100%, or a flex which would mean it is sized by us, but we cannot read that -
  // getComputedStyle would return the numeric width.


  resizeToFitContent() {} //endregion


}
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerColumnType(WidgetColumn);
WidgetColumn.exposeProperties();
WidgetColumn._$name = 'WidgetColumn';

/***/ }),

/***/ "./lib/Grid/data/ColumnStore.js":
/*!**************************************!*\
  !*** ./lib/Grid/data/ColumnStore.js ***!
  \**************************************/
/*! exports provided: default, columnResizeEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnResizeEvent", function() { return columnResizeEvent; });
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';





/**
 * @module Grid/data/ColumnStore
 */

const columnDefinitions = {
  boolean: {
    type: 'check'
  },
  date: {
    type: 'date'
  },
  integer: {
    type: 'number',
    format: {
      maximumFractionDigits: 0
    }
  },
  number: {
    type: 'number'
  }
};
/**
 * A store specialized in handling columns. Used by the Grid to hold its columns and used as a chained store by each SubGrid
 * to hold theirs. Should not be instanced directly, instead access it through `grid.columns` or `subGrid.columns`
 *
 * ```
 * // resize first column
 * grid.columns.first.width = 200;
 *
 * // remove city column
 * grid.columns.get('city').remove();
 *
 * // add new column
 * grid.columns.add({text : 'New column'});
 *
 * // add new column to specific region (SubGrid)
 * grid.columns.add({text : 'New column', region : 'locked'});
 *
 * // add new column to 'locked' region (SubGrid)
 * grid.columns.add({text : 'New column', locked : true});
 * ```
 *
 * @extends Core/data/Store
 */

class ColumnStore extends Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Events

  /**
   * Fires when a column is shown.
   * @event columnShow
   * @param {Grid.data.ColumnStore} source The store which triggered the event.
   * @param {Grid.column.Column} column The column which status has been changed.
   */

  /**
   * Fires when a column has been hidden.
   * @event columnHide
   * @param {Grid.data.ColumnStore} source The store which triggered the event.
   * @param {Grid.column.Column} column The column which status has been changed.
   */
  //endregion
  static get defaultConfig() {
    return {
      modelClass: _column_Column_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      tree: true,

      /**
       * Automatically adds a field definition to the store used by the Grid when adding a new Column displaying a
       * non-existing field.
       *
       * To enable this behaviour:
       *
       * ```javascript
       * const grid = new Grid({
       *     columns : {
       *         autoAddField : true,
       *         data         : [
       *             // Column definitions here
       *         ]
       *     }
       * }
       *
       * @config {Boolean}
       * @default
       */
      autoAddField: false
    };
  }

  construct(config) {
    const me = this; // Consequences of ColumnStore construction can cause reading of grid.columns
    // so set the property early.

    if (config.grid) {
      config.grid._columnStore = me;
      me.id = `${config.grid.id}-columns`; // Visible columns must be invalidated on expand/collapse

      config.grid.on({
        subGridCollapse: 'clearSubGridCaches',
        subGridExpand: 'clearSubGridCaches',
        thisObj: me
      });
    }

    super.construct(config); // So that we can invalidate cached collections which take computing so that we compute them
    // only when necessary. For example when asking for the visible leaf columns, we do not want
    // to compute that each time.

    me.on({
      change: me.onStoreChange,
      sort: () => me.updateChainedStores(),
      thisObj: me,
      prio: 1
    });
  }

  get modelClass() {
    return this._modelClass;
  }

  set modelClass(ClassDef) {
    this._modelClass = ClassDef;
  }

  doDestroy() {
    const allColumns = [];

    if (!this.isChained) {
      this.traverse(column => allColumns.push(column));
    }

    super.doDestroy(); // Store's destroy unjoins all records. Destroy all columns *after* that.

    if (!this.isChained) {
      allColumns.forEach(column => column.destroy());
    }
  } // Overridden because the flat collection only contains top level columns,
  // not leaves - group columns are *not* expanded.


  getById(id) {
    return super.getById(id) || this.idRegister[id];
  }

  forEach(fn, thisObj = this) {
    // Override to omit root
    this.traverseWhile((n, i) => fn.call(thisObj, n, i), true);
  }

  get totalFixedWidth() {
    let result = 0;

    for (const col of this) {
      if (!col.hidden) {
        // if column has children (grouped header) use they to width increment
        if (col.children) {
          col.children.forEach(childCol => result += this.calculateFixedWidth(childCol));
        } else {
          result += this.calculateFixedWidth(col);
        }
      }
    }

    return result;
  }

  calculateFixedWidth(column) {
    if (column.flex) {
      return column.measureSize(_column_Column_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultWidth);
    } else {
      return Math.max(column.measureSize(column.width), column.measureSize(column.minWidth));
    }
  }
  /**
   * Returns the top level columns. If using grouped columns, this is the top level columns. If no grouped
   * columns are being used, this is the leaf columns.
   * @property {Grid.column.Column[]}
   * @readonly
   */


  get topColumns() {
    return this.isChained ? this.masterStore.rootNode.children.filter(this.chainedFilterFn) : this.rootNode.children;
  }
  /**
   * Returns the visible leaf headers which drive the rows' cell content.
   * @property {Grid.column.Column[]}
   * @readonly
   */


  get visibleColumns() {
    const me = this;

    if (!me._visibleColumns) {
      me._visibleColumns = me.leaves.filter(column => column.isVisible && (!column.subGrid || !column.subGrid.collapsed));
    }

    return me._visibleColumns;
  }

  onStoreChange({
    action,
    changes
  }) {
    // no need to clear cache while resizing, or if column changes name
    if (action === 'update' && !('hidden' in changes)) {
      return;
    }

    this.clearCaches();
  }

  clearSubGridCaches({
    subGrid
  }) {
    subGrid.columns.clearCaches();
    this.clearCaches();
  }

  clearCaches() {
    var _this$masterStore;

    this._visibleColumns = null;
    (_this$masterStore = this.masterStore) === null || _this$masterStore === void 0 ? void 0 : _this$masterStore.clearCaches();
  }

  onMasterDataChanged(event) {
    super.onMasterDataChanged(event); // If master store has changes we also need to clear cached columns, in case a column was hidden
    // no need to clear cache while resizing, or if column changes name

    if (event.action !== 'update' || 'hidden' in event.changes) {
      this.clearCaches();
    }
  }

  getAdjacentVisibleLeafColumn(columnOrId, next = true, wrap = false) {
    const columns = this.visibleColumns,
          column = columnOrId instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? columnOrId : this.getById(columnOrId);
    let idx = columns.indexOf(column) + (next ? 1 : -1); // If we walked off either end, wrap if directed to do so,
    // otherwise, return null;

    if (!columns[idx]) {
      if (wrap) {
        idx = next ? 0 : columns.length - 1;
      } else {
        return null;
      }
    }

    return columns[idx];
  }
  /**
   * Bottom columns are the ones displayed in the bottom row of a grouped header, or all columns if not using a grouped
   * header. They are the columns that actually display any data.
   * @property {Grid.column.Column[]}
   * @readonly
   */


  get bottomColumns() {
    return this.leaves;
  }
  /**
   * Get column by field. To be sure that you are getting exactly the intended column, use {@link Core.data.Store#function-getById Store#getById()} with the
   * columns id instead.
   * @param {String} field Field name
   * @returns {Grid.column.Column}
   */


  get(field) {
    return this.findRecord('field', field, true);
  }
  /**
   * Used internally to create a new record in the store. Creates a column of the correct type by looking up the
   * specified type among registered columns.
   * @private
   */


  createRecord(data) {
    var _store$modelClass, _store$modelClass$fie;

    const {
      grid = {}
    } = this,
          // Some ColumnStore tests lacks Grid
    {
      store
    } = grid,
          dataField = store === null || store === void 0 ? void 0 : (_store$modelClass = store.modelClass) === null || _store$modelClass === void 0 ? void 0 : (_store$modelClass$fie = _store$modelClass.fieldMap) === null || _store$modelClass$fie === void 0 ? void 0 : _store$modelClass$fie[data.field];
    let columnClass = this.modelClass; // Use the DataField's column definition as a default into which the incoming data is merged

    if (dataField !== null && dataField !== void 0 && dataField.column) {
      data = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge({}, dataField.column, data);
    }

    if (data.type) {
      columnClass = ColumnStore.getColumnClass(data.type);

      if (!columnClass) {
        throw new Error(`Column type '${data.type}' not registered`);
      }
    }

    if (data.locked) {
      data.region = 'locked';
      delete data.locked;
    }

    const column = new columnClass(data, this); // Doing this after construction, in case the columnClass has a default value for region (Schedulers
    // TimeAxisColumn has)

    if (!column.data.region) {
      column.data.region = grid.defaultRegion || 'normal';
    } // Add missing fields to Grids stores model


    if (this.autoAddField && !column.noFieldSpecified && store && !dataField) {
      let fieldDefinition = column.field; // Some columns define the type to use for new fields (date, number etc)

      if (column.constructor.fieldType) {
        fieldDefinition = {
          name: column.field,
          type: column.constructor.fieldType
        };
      }

      store.modelClass.addField(fieldDefinition);
    }

    return column;
  }
  /**
   * indexOf extended to also accept a columns field, for backward compatibility.
   * ```
   * grid.columns.indexOf('name');
   * ```
   * @param {Core.data.Model|String} recordOrId
   * @returns {Number}
   */


  indexOf(recordOrId) {
    // TODO: build the need for field away
    const index = super.indexOf(recordOrId);
    if (index > -1) return index; // no record found by id, find by field since old code relies on that instead of id
    // TODO: replace such cases with columns id

    return this.records.findIndex(r => r.field === recordOrId);
  }
  /**
   * Checks if any column uses autoHeight
   * @internal
   * @property {Boolean}
   * @readonly
   */


  get usesAutoHeight() {
    return this.find(column => column.autoHeight);
  }
  /**
   * Checks if any flex column uses autoHeight
   * @internal
   * @property {Boolean}
   * @readonly
   */


  get usesFlexAutoHeight() {
    return this.find(column => column.autoHeight && column.flex != null);
  } //region Column types

  /**
   * Call from custom column to register it with ColumnStore. Required to be able to specify type in column config.
   * @param {Function} columnClass The {@link Grid.column.Column} subclass to register.
   * @param {Boolean} simpleRenderer Pass `true` if its default renderer does *not* use other fields from the passed
   * record than its configured {@link Grid.column.Column#config-field}. This enables more granular cell updating
   * upon record mutation.
   * @example
   * // create and register custom column
   * class CustomColumn {
   *  static get type() {
   *      return 'custom';
   *  }
   * }
   * ColumnStore.registerColumnType(CustomColumn, true);
   * // now possible to specify in column config
   * let grid = new Grid({
   *   columns: [
   *     { type: 'custom', field: 'id' }
   *   ]
   * });
   */


  static registerColumnType(columnClass, simpleRenderer = false) {
    if (!ColumnStore.columnTypes) ColumnStore.columnTypes = {};
    columnClass.simpleRenderer = simpleRenderer;
    ColumnStore.columnTypes[columnClass.type] = columnClass;
  }
  /**
   * Returns registered column class for specified type.
   * @param type Type name
   * @returns {Grid.column.Column}
   * @internal
   */


  static getColumnClass(type) {
    return ColumnStore.columnTypes && ColumnStore.columnTypes[type];
  }
  /**
   * Generates a <strong>new </strong> {@link Grid.column.Column} instance which may be subsequently added to this
   * store to represent the passed {@link Core.data.field.DataField} of the owning Grid's store.
   * @param {Core.data.field.DataField|String} dataField The {@link Core.data.field.DataField field}
   * instance or field name to generate a new {@link Grid.column.Column} for.
   * @param {Object} [defaults] Defaults to apply to the new column.
   * @returns {Grid.column.Column} A new Column which will render and edit the field correctly.
   * @example
   * // Add column for the "team" field.
   * grid.columns.add(grid.columns.generateColumnForField('team', {
   *     width : 200
   * }));
   * @internal
   */


  generateColumnForField(dataField, defaults) {
    if (typeof dataField === 'string' && this.grid) {
      var _this$grid$store;

      dataField = (_this$grid$store = this.grid.store) === null || _this$grid$store === void 0 ? void 0 : _this$grid$store.modelClass.fieldMap[dataField];
    }

    let column = dataField.column || columnDefinitions[dataField.type] || {}; // Upgrade string to be the column tyope

    if (typeof column === 'string') {
      column = {
        type: column
      };
    } // Configure over defaults


    column = Object.assign({
      text: dataField.text || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].separate(dataField.name),
      field: dataField.name
    }, defaults, column); // Special formatting for columns which represent number and integer fields.

    if (dataField.precision != null) {
      column.format.maximumFractionDigits = dataField.precision;
    }

    if (dataField.columnType) {
      column.type = dataField.columnType;
    } // Upgrade object to a Column instance.


    return this.createRecord(column);
  } //endregion


}
/**
 * Custom {@link Grid.data.ColumnStore} event which triggers when a column is resized, i.e. its width has been changed
 *
 * @param {Function} handler
 * @param {Object} [thisObj]
 */

const columnResizeEvent = (handler, thisObj) => ({
  update: ({
    store,
    record,
    changes
  }) => {
    let result = true;

    if ('width' in changes || 'minWidth' in changes || 'maxWidth' in changes || 'flex' in changes) {
      result = handler.call(thisObj, {
        store,
        record,
        changes
      });
    }

    return result;
  }
}); // Can't have this in Column due to circular dependencies

ColumnStore.registerColumnType(_column_Column_js__WEBPACK_IMPORTED_MODULE_1__["default"], true);
ColumnStore._$name = 'ColumnStore';

/***/ }),

/***/ "./lib/Grid/data/GridRowModel.js":
/*!***************************************!*\
  !*** ./lib/Grid/data/GridRowModel.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridRowModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';

/**
 * @module Grid/data/GridRowModel
 */

/**
 * Model extended with some fields related to grid rendering. Used as default model type in the grids store if nothing
 * else is specified.
 *
 * Using this model is optional. If you use a custom model instead and need the functionality of any of the fields
 * below, you just have to remember to add fields with the same name to your model.
 *
 * @extends Core/data/Model
 */

class GridRowModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get fields() {
    return [
    /**
     * Icon for row (used automatically in tree, feel free to use it in renderer in other cases)
     * @field {String} iconCls
     * @category Styling
     */
    {
      name: 'iconCls',
      internal: true
    },
    /**
     * Start expanded or not (only valid for tree data)
     * @field {Boolean} expanded
     * @category Tree
     */
    {
      name: 'expanded',
      internal: true
    },
    /**
     * CSS class (or several classes divided by space) to append to row elements
     * @field {String} cls
     * @category Styling
     */
    {
      name: 'cls',
      internal: true
    },
    /**
     * Used by the default implementation of {@link Grid.view.GridBase#config-getRowHeight} to determine row
     * height. Set it to use another height than the default for a the records row.
     * @field {Number} rowHeight
     * @category Styling
     */
    {
      name: 'rowHeight',
      internal: true
    },
    /**
     * A link to use for this record when rendered into a {@link Grid.column.TreeColumn}.
     * @field {String} href
     * @category Tree
     */
    {
      name: 'href',
      internal: true
    },
    /**
     * The target to use if this tree node provides a value for the {@link #field-href} field.
     * @field {String} target
     * @category Tree
     */
    {
      name: 'target',
      internal: true
    }];
  }

}
GridRowModel.exposeProperties();
GridRowModel._$name = 'GridRowModel';

/***/ }),

/***/ "./lib/Grid/feature/CellEdit.js":
/*!**************************************!*\
  !*** ./lib/Grid/feature/CellEdit.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellEdit; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
var productName = 'gantt'; //TODO: Maybe some more way to stop editing in touch mode (in case grid fills entire page...)













const validNonEditingKeys = {
  Enter: 1,
  F2: 1
},
      validEditingKeys = {
  ArrowUp: 1,
  ArrowDown: 1,
  ArrowLeft: 1,
  ArrowRight: 1,
  Escape: 1,
  Enter: 1,
  Tab: 1,
  F2: 1
};
/**
 * @module Grid/feature/CellEdit
 */

/**
 * Adding this feature to the grid and other Bryntum products which are based on the Grid (i.e. Scheduler, SchedulerPro, and Gantt)
 * enables cell editing. Any subclass of {@link Core.widget.Field Field} can be used
 * as editor for the {@link Grid.column.Column Column}. The most popular are:
 *
 * - {@link Core.widget.TextField TextField}
 * - {@link Core.widget.NumberField NumberField}
 * - {@link Core.widget.DateField DateField}
 * - {@link Core.widget.TimeField TimeField}
 * - {@link Core.widget.Combo Combo}
 *
 * Usage instructions:
 * ## Start editing
 * * Double click on a cell
 * * Press [ENTER] or [F2] with a cell selected
 * * It is also possible to change double click to single click to start editing, using the {@link #config-triggerEvent} config
 *
 * ```javascript
 * new Grid({
 *    features : {
 *        cellEdit : {
 *            triggerEvent : 'cellclick'
 *        }
 *    }
 * });
 * ```
 *
 * ## Instant update
 * If {@link Grid.column.Column#config-instantUpdate} on the column is set to true, record will be
 * updated instantly as value in the editor is changed. In combination with {@link Core.data.Store#config-autoCommit} it
 * could result in excessive requests to the backend.
 * By default instantUpdate is false, but it is enabled for some special columns, such as Duration column in Scheduler
 * Pro and all date columns in Gantt.
 *
 * ## While editing
 * * [ENTER] Finish editing and start editing the same cell in next row
 * * [SHIFT] + [ENTER] Same as above put with previous row
 * * [F2] Finish editing
 * * [CMD/CTRL] + [ENTER] Finish editing
 * * [ESC] By default, first reverts the value back to its original value, next press cancels editing
 * * [TAB] Finish editing and start editing the next cell
 * * [SHIFT] + [TAB] Finish editing and start editing the previous cell
 *
 * Columns specify editor in their configuration. Editor can also by set by using a column type. Columns
 * may also contain these three configurations which affect how their cells are edited:
 * * {@link Grid.column.Column#config-invalidAction}
 * * {@link Grid.column.Column#config-revertOnEscape}
 * * {@link Grid.column.Column#config-finalizeCellEdit}
 *
 * ## Preventing editing of certain cells
 * You can prevent editing on a column by setting `editor` to false:
 *
 * ```javascript
 * new Grid({
 *    columns : [
 *       {
 *          type   : 'number',
 *          text   : 'Age',
 *          field  : 'age',
 *          editor : false
 *       }
 *    ]
 * });
 * ```
 * To prevent editing in a specific cell, listen to the {@link #event-beforeCellEditStart} and return false:
 *
 * ```javascript
 * grid.on('beforeCellEditStart', ({ editorContext }) => {
 *     return editorContext.column.field !== 'id';
 * });
 * ```
 * ## Choosing field on the fly
 * To use an alternative input field to edit a cell, listen to the {@link #event-beforeCellEditStart} and
 * set the `editor` property of the context to the input field you want to use:
 *
 * ```javascript
 * grid.on('beforeCellEditStart', ({ editorContext }) => {
 *     return editorContext.editor = myDateField;
 * });
 * ```
 *
 * ## Loading remote data into a combo box cell editor
 * If you need to prepare or modify the data shown by the cell editor, e.g. load remote data into the store used by a combo,
 * listen to the {@link #event-startCellEdit} event:
 * ```javascript
 * const employeeStore = new AjaxStore({ readUrl : '/cities' }); // A server endpoint returning data like:
 *                                                               // [{ id : 123, name : 'Bob Mc Bob' }, { id : 345, name : 'Lind Mc Foo' }]
 *
 * new Grid({
 *     // Example data including a city field which is an id used to look up entries in the cityStore above
 *     data : [
 *         { id : 1, name : 'Task 1', employeeId : 123 },
 *         { id : 2, name : 'Task 2', employeeId : 345 }
 *     ],
 *     columns : [
 *       {
 *          text   : 'Task',
 *          field  : 'name'
 *       },
 *       {
 *          text   : 'Assigned to',
 *          field  : 'employeeId',
 *          editor : {
 *               type : 'combo',
 *               store : employeeStore,
 *               // specify valueField'/'displayField' to match the data format in the employeeStore store
 *               valueField : 'id',
 *               displayField : 'name'
 *           },
 *           renderer : ({ value }) {
 *                // Use a renderer to show the employee name, which we find by querying employeeStore by the id of the grid record
 *                return employeeStore.getById(value)?.name;
 *           }
 *       }
 *    ],
 *    listeners : {
 *        // When editing, you might want to fetch data for the combo store from a remote resource
 *        startCellEdit({ editorContext }) {
 *            const { record, editor, column } = editorContext;
 *            if (column.field === 'employeeId') {
 *                // Load possible employees to assign to this particular task
 *                editor.inputField.store.load({ task : record.id });
 *            }
 *       }
 *    }
 * });
 * ```
 * This feature is **enabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/celledit
 * @classtype cellEdit
 * @inlineexample Grid/feature/CellEdit.js
 * @feature
 */

class CellEdit extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Config
  static get $name() {
    return 'CellEdit';
  } // Default configuration


  static get defaultConfig() {
    return {
      /**
       * Set to true to select the field text when editing starts
       * @config {Boolean}
       * @default
       */
      autoSelect: true,

      /**
       * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
       * May be `'complete'` or `'cancel`'.
       * @config {String}
       * @default
       */
      blurAction: 'complete',

      /**
       * Set to true to have TAB key on the last cell (and ENTER anywhere in the last row) in the data set create a new record
       * and begin editing it at its first editable cell.
       *
       * If this is configured as an object, it is used as the default data value set for each new record.
       * @config {Boolean|Object}
       * @default
       */
      addNewAtEnd: null,

      /**
       * Set to true to start editing when user starts typing text on a focused cell (as in Excel)
       * @config {Boolean}
       * @default
       */
      autoEdit: false,

      /**
       * Class to use as an editor. Default value: {@link Core.widget.Editor}
       * @config {Core.widget.Widget}
       * @typings {typeof Widget}
       * @internal
       */
      editorClass: _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_5__["default"],

      /**
       * The name of the grid event that will trigger cell editing. Defaults to
       * {@link Grid.view.mixin.GridElementEvents#event-cellDblClick celldblclick} but can be changed to any other event,
       * such as {@link Grid.view.mixin.GridElementEvents#event-cellClick cellclick}.
       *
       * ```javascript
       * features : {
       *     cellEdit : {
       *         triggerEvent : 'cellclick'
       *     }
       * }
       * ```
       *
       * @config {String}
       * @default
       */
      triggerEvent: 'celldblclick',
      focusCellAnimationDuration: false
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      assign: ['startEditing'],
      before: ['onElementKeyDown', 'onElementMouseDown'],
      chain: ['onElementClick', 'bindStore']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    super.construct(grid, config);
    const me = this,
          gridListeners = {
      renderRows: 'onGridRefreshed',
      cellClick: 'onCellClick',
      thisObj: me
    };
    me.grid = grid;

    if (me.triggerEvent !== 'cellclick') {
      gridListeners[me.triggerEvent] = 'onTriggerEditEvent';
    }

    grid.on(gridListeners);
    grid.rowManager.on({
      changeTotalHeight: 'onGridRefreshed',
      thisObj: me
    });
    me.bindStore(grid.store);
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      update: 'onStoreUpdate',
      thisObj: this
    });
  }
  /**
   * Displays a OK / Cancel confirmation dialog box owned by the current Editor. This is intended to be
   * used by {@link Grid.column.Column#config-finalizeCellEdit} implementations. The returned promise resolves passing `true`
   * if the "OK" button is pressed, and `false` if the "Cancel" button is pressed. Typing `ESC` rejects.
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String|Object} [options.cancelButton] A text or a config object to apply to the Cancel button.
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @async
   */


  async confirm(options) {
    let result = true;

    if (this.editorContext) {
      // The input field must not lose containment of focus during this confirmation
      // so temporarily make the MessageDialog a descendant widget.
      _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_7__["default"].owner = this.editorContext.editor.inputField;
      options.rootElement = this.grid.rootElement;
      result = await _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_7__["default"].confirm(options);
      _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_7__["default"].owner = null;
    }

    return result === _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_7__["default"].yesButton;
  }

  doDestroy() {
    // To kill timeouts
    this.grid.columns.allRecords.forEach(column => {
      var _column$_cellEditor;

      (_column$_cellEditor = column._cellEditor) === null || _column$_cellEditor === void 0 ? void 0 : _column$_cellEditor.destroy();
    });
    super.doDestroy();
  }

  doDisable(disable) {
    if (disable) {
      this.cancelEditing(true);
    }

    super.doDisable(disable);
  }

  set disabled(disabled) {
    super.disabled = disabled;
  }

  get disabled() {
    const {
      grid
    } = this;
    return Boolean(super.disabled || grid.disabled || grid.readOnly);
  } //endregion
  //region Editing

  /**
   * Is any cell currently being edited?
   * @readonly
   * @property {Boolean}
   */


  get isEditing() {
    return Boolean(this.editorContext);
  }
  /**
   * Returns the record currently being edited, or `null`
   * @readonly
   * @property {Core.data.Model}
   */


  get activeRecord() {
    var _this$editorContext;

    return ((_this$editorContext = this.editorContext) === null || _this$editorContext === void 0 ? void 0 : _this$editorContext.record) || null;
  }
  /**
   * Internal function to create or get existing editor for specified cell.
   * @private
   * @param cellContext Cell to get or create editor for
   * @returns {Core.widget.Editor} An Editor container which displays the input field.
   * @category Internal
   */


  getEditorForCell({
    cell,
    column,
    selector,
    editor
  }) {
    const me = this,
          {
      grid
    } = me; // Reuse the Editor by caching it on the column.

    let cellEditor = column._cellEditor,
        leftOffset = 0; // Only applicable for tree cells to show editor right of the icons etc
    // Help Editor match size and position

    if (column.editTargetSelector) {
      const editorTarget = cell.querySelector(column.editTargetSelector);
      leftOffset = editorTarget.offsetLeft;
    }

    editor.autoSelect = me.autoSelect;

    if (cellEditor) {
      // Already got the positioned Editor container which carries the input field.
      // just check if the actual field has been changed in a beforeCellEditStart handler.
      // If so, switch it out.
      if (cellEditor.inputField !== editor) {
        cellEditor.remove(cellEditor.items[0]);
        cellEditor.add(editor);
      }

      cellEditor.align.offset[0] = leftOffset;
    } else {
      cellEditor = column._cellEditor = new me.editorClass({
        constrainTo: null,
        cls: 'b-cell-editor',
        inputField: editor,
        blurAction: 'none',
        invalidAction: column.invalidAction,
        completeKey: false,
        cancelKey: false,
        owner: grid,
        align: {
          align: 't0-t0',
          offset: [leftOffset, 0]
        },
        listeners: me.getEditorListeners()
      });
    } // Keep the record synced with the value


    if (column.instantUpdate && !editor.cellEditValueSetter) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].wrapProperty(editor, 'value', null, value => {
        const {
          editorContext
        } = me; // Only tickle the record if the value has changed.

        if (editorContext !== null && editorContext !== void 0 && editorContext.editor.isValid && !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isEqual(editorContext.record[editorContext.column.field], value)) {
          editorContext.record[editorContext.column.field] = value;
        }
      });
      editor.cellEditValueSetter = true;
    }

    Object.assign(cellEditor.element.dataset, {
      rowId: selector.id,
      columnId: selector.columnId,
      field: column.field
    }); // First ESC press reverts

    cellEditor.inputField.revertOnEscape = column.revertOnEscape;
    return me.editor = cellEditor;
  } // Turned into function to allow overriding in Gantt, and make more configurable in general


  getEditorListeners() {
    return {
      focusOut: 'onEditorFocusOut',
      focusIn: 'onEditorFocusIn',
      start: 'onEditorStart',
      beforeComplete: 'onEditorBeforeComplete',
      complete: 'onEditorComplete',
      cancel: 'onEditorCancel',
      thisObj: this
    };
  }

  onEditorStart({
    source: editor
  }) {
    const me = this,
          editorContext = me.editorContext = editor.cellEditorContext;

    if (editorContext) {
      const {
        grid
      } = me,
            {
        cell
      } = editorContext;
      cell.classList.add('b-editing'); // Should move editing to new cell on click, unless click is configured to start editing - in which case it
      // will move anyway

      if (me.triggerEvent !== 'cellclick') {
        grid.on({
          cellclick: 'onCellClickWhileEditing'
        }, me);
      } // Handle tapping outside of the grid element. Use GlobalEvents
      // because it uses a capture:true listener before any other handlers
      // might stop propagation.
      // Cannot use delegate here. A tapped cell will match :not(#body-container)


      me.removeEditingListeners = _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].addListener({
        globaltap: 'onTapOut',
        thisObj: me
      });
      /**
       * Fires on the owning Grid when editing starts
       * @event startCellEdit
       * @on-owner
       * @param {Grid.view.Grid} source Owner grid
       * @param {Object} editorContext Editing context
       * @param {Core.widget.Editor} editorContext.editor The Editor being used.
       * Will contain an `inputField` property which is the field being used to perform the editing.
       * @param {Grid.column.Column} editorContext.column Target column
       * @param {Core.data.Model} editorContext.record Target record
       * @param {HTMLElement} editorContext.cell Target cell
       * @param {*} editorContext.value Cell value
       */

      grid.trigger('startCellEdit', {
        grid,
        editorContext
      });
    }
  }

  onEditorBeforeComplete(context) {
    const {
      grid
    } = this,
          editor = context.source,
          editorContext = editor.cellEditorContext;
    context.grid = grid;
    context.editorContext = editorContext;
    /**
     * Fires on the owning Grid before the cell editing is finished, return false to signal that the value is invalid and editing should not be finalized.
     * @on-owner
     * @event beforeFinishCellEdit
     * @param {Grid.view.Grid} grid Target grid
     * @param {Object} editorContext Editing context
     * @param {Core.widget.Editor} editorContext.editor The Editor being used.
     * Will contain an `inputField` property which is the field being used to perform the editing.
     * @param {Grid.column.Column} editorContext.column Target column
     * @param {Core.data.Model} editorContext.record Target record
     * @param {HTMLElement} editorContext.cell Target cell
     * @param {*} editorContext.value Cell value
     */

    return grid.trigger('beforeFinishCellEdit', context);
  }

  onEditorComplete({
    source: editor
  }) {
    const {
      grid
    } = this,
          editorContext = editor.cellEditorContext; // Ensure the docs below are accurate!

    editorContext.value = editor.inputField.value;
    /**
     * Fires on the owning Grid when cell editing is finished
     * @event finishCellEdit
     * @on-owner
     * @param {Grid.view.Grid} grid Target grid
     * @param {Object} editorContext Editing context
     * @param {Core.widget.Editor} editorContext.editor The Editor being used.
     * Will contain an `inputField` property which is the field being used to perform the editing.
     * @param {Grid.column.Column} editorContext.column Target column
     * @param {Core.data.Model} editorContext.record Target record
     * @param {HTMLElement} editorContext.cell Target cell
     * @param {*} editorContext.value Cell value
     */

    grid.trigger('finishCellEdit', {
      grid,
      editorContext
    });
    this.cleanupAfterEdit(editorContext);
  }

  onEditorCancel({
    event
  }) {
    const {
      editorContext,
      muteEvents,
      grid
    } = this;

    if (editorContext) {
      this.cleanupAfterEdit(editorContext);
    }

    if (!muteEvents) {
      /**
       * Fires on the owning Grid when editing is cancelled
       * @event cancelCellEdit
       * @on-owner
       * @param {Grid.view.Grid} source Owner grid
       * @param {Event} event Included if the cancellation was triggered by a DOM event
       */
      grid.trigger('cancelCellEdit', {
        grid,
        event
      });
    }
  }

  cleanupAfterEdit(editorContext) {
    const me = this,
          {
      editor
    } = editorContext;
    editorContext.cell.classList.remove('b-editing');
    editor.cellEditorContext = me.editorContext = null;
    me.grid.un({
      cellclick: 'onCellClickWhileEditing',
      viewportResize: 'onViewportResizeWhileEditing'
    }, me);
    me.removeEditingListeners(); // MS Edge workaround.
    // At this moment active element is grid.element, but removing editor element still triggers focusout event
    // which is processed by the GlobalEvents, which decides that focus goes to body element. That, in turn, triggers
    // clearFocus on grid navigation, removing focused cell from cache etc, eventually focus actually goes to body.
    // Suspending listener to seamlessly remove element keeping focus where it belongs.
    // NOTE: not reproducible in IFrame, so our tests cannot catch this

    _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].suspendFocusEvents();
    editor.element.remove();
    _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].resumeFocusEvents();
  }
  /**
   * Find the next succeeding or preceding cell which is editable (column.editor != false)
   * @param {Object} cellInfo
   * @param {Boolean} isForward
   * @returns {Object}
   * @private
   * @category Internal
   */


  getAdjacentEditableCell(cellInfo, isForward) {
    const {
      grid
    } = this,
          {
      store,
      columns
    } = grid,
          {
      visibleColumns
    } = columns;
    let rowId = cellInfo.id,
        column = columns.getAdjacentVisibleLeafColumn(cellInfo.columnId, isForward);

    while (rowId) {
      if (column) {
        if (column.editor && column.canEdit(store.getById(rowId))) {
          return {
            id: rowId,
            columnId: column.id
          };
        }

        column = columns.getAdjacentVisibleLeafColumn(column, isForward);
      } else {
        const record = store.getAdjacent(cellInfo.id, isForward, false, true);
        rowId = record === null || record === void 0 ? void 0 : record.id;

        if (record) {
          column = isForward ? visibleColumns[0] : visibleColumns[visibleColumns.length - 1];
        }
      }
    }

    return null;
  }
  /**
   * Adds a new, empty record at the end of the TaskStore with the initial
   * data specified by the {@link Grid.feature.CellEdit#config-addNewAtEnd} setting.
   *
   * @private
   * @returns {Core.data.Model} Newly added record
   */


  doAddNewAtEnd() {
    const newRecordConfig = typeof this.addNewAtEnd === 'object' ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].clone(this.addNewAtEnd) : {},
          {
      grid
    } = this,
          record = grid.store.add(newRecordConfig)[0]; // If the new record was not added due to it being off the end of the rendered block
    // ensure we force it to be there before we attempt to edit it.

    if (!grid.rowManager.getRowFor(record)) {
      grid.rowManager.displayRecordAtBottom();
    }

    return record;
  }
  /**
   * Creates an editing context object for the passed cell context (target cell must be in the DOM).
   *
   * If the referenced cell is editable, an object returned will
   * be returned containing the following properties:
   *
   *     - column
   *     - record
   *     - cell
   *     - value
   *     - selector
   *
   * If the references cell is _not_ editable, `false` will be returned.
   * @param {Object} cellContext an object which encapsulates a cell.
   * @param {String} cellContext.id The record id of the row to edit
   * @param {String} cellContext.columnId The column id of the column to edit
   * @private
   */


  getEditingContext(cellContext) {
    cellContext = this.grid.normalizeCellContext(cellContext);
    const me = this,
          {
      grid
    } = me,
          column = grid.columns.getById(cellContext.columnId),
          record = grid.store.getById(cellContext.id); // Cell must be in the DOM to edit.
    // Cannot edit hidden columns and columns without an editor.
    // Cannot edit special rows (groups etc).

    if (column && column.isVisible && column.editor && record && !record.isSpecialRow && column.canEdit(record)) {
      // If the field name is a complex mapping (instead of using a field name with a dataSource)
      // set it correctly. Row#renderCell gets its contentValue in this way.
      const value = record ? column.getRawValue(record) : record;
      return {
        column,
        record,
        value: value === undefined ? null : value,
        selector: cellContext,
        editor: column.editor
      };
    } else {
      return false;
    }
  }
  /**
   * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
   * This function is exposed on Grid and can thus be called as `grid.startEditing(...)`
   * @param {Object} cellContext Cell specified in format { id: 'x', columnId/column/field: 'xxx' }. See {@link Grid.view.Grid#function-getCell} for details.
   * @fires startCellEdit
   * @returns {Boolean} editingStarted
   * @category Editing
   * @on-owner
   */


  startEditing(cellContext = {}) {
    const me = this; // If disabled no can do.

    if (!me.disabled) {
      const {
        grid
      } = me,
            normalizedContext = grid.normalizeCellContext(cellContext),
            editorContext = me.getEditingContext(normalizedContext); // Cannot edit hidden columns and columns without an editor
      // Cannot edit special rows (groups etc).

      if (!editorContext) {
        return false;
      }

      if (me.editorContext) {
        me.cancelEditing();
      }

      if (grid.store.isTree) {
        grid.expandTo(cellContext.id);
      } // Now that we know we can edit this cell, scroll the record into view and register it as last focusedCell
      // TODO this is potentially async and should be awaited


      grid.focusCell(cellContext);
      editorContext.cell = grid.getCell(cellContext);
      /**
       * Fires on the owning Grid before editing starts, return `false` to prevent editing
       * @event beforeCellEditStart
       * @on-owner
       * @preventable
       * @param {Grid.view.Grid} source Owner grid
       * @param {Object} editorContext Editing context
       * @param {Grid.column.Column} editorContext.column Target column
       * @param {Core.data.Model} editorContext.record Target record
       * @param {HTMLElement} editorContext.cell Target cell
       * @param {Core.widget.Field} editorContext.editor The input field that the column is configured
       * with (see {@link Grid.column.Column#config-field}). This property mey be replaced
       * to be a different {@link Core.widget.Field field} in the handler, to take effect
       * just for the impending edit.
       * @param {Function} [editorContext.finalize] An async function may be injected into this property
       * which performs asynchronous finalization tasks such as complex validation of confirmation. The
       * value `true` or `false` must be returned.
       * @param {Object} [editorContext.finalize.context] An object describing the editing context upon requested completion of the edit.
       * @param {*} editorContext.value Cell value
       */

      if (grid.trigger('beforeCellEditStart', {
        grid,
        editorContext
      }) === false) {
        return false;
      } // Focus grid element to preserve focus inside once editing is started
      // https://app.assembla.com/spaces/bryntum/tickets/8155-grid-cell-not-properly-focused-in-advanced-demo


      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].focusWithoutScrolling(grid.focusElement);
      const editor = editorContext.editor = me.getEditorForCell(editorContext),
            {
        cell,
        record,
        column
      } = editorContext; // Prevent highlight when setting the value in the editor

      editor.inputField.highlightExternalChange = false;
      editor.cellEditorContext = editorContext;
      editor.render(me.grid.getSubGridFromColumn(column).element); // Attempt to start edit.
      // We will set up our context in onEditorStart *if* the start was successful.

      editor.startEdit({
        target: cell,
        field: editor.inputField.name || editorContext.column.field,
        value: editorContext.value,
        record
      });
      return true;
    }

    return false;
  }
  /**
   * Cancel editing, destroys the editor
   * @param {Boolean} silent Pass true to prevent method from firing event
   * @fires cancelCellEdit
   * @category Editing
   */


  cancelEditing(silent = false, triggeredByEvent) {
    const me = this,
          {
      editorContext,
      editor,
      grid
    } = me;

    if (editorContext) {
      // If cancel was not called from onEditorFocusOut, then refocus the grid.
      if (editor.containsFocus) {
        // Kill editorContext before we destroy the editor so that we know we are not editing
        // in ensuing focusout event handling
        me.editorContext = null; // Control focus reversion if we own focus

        if (!grid.isDestroying && editor.inputField.owns(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getActiveElement(grid))) {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].focusWithoutScrolling(grid.focusElement);
        }

        me.editorContext = editorContext;
      }

      me.muteEvents = silent;
      editor.cancelEdit(triggeredByEvent);
      me.muteEvents = false;
    }
  }
  /**
   * Finish editing, update the underlying record and destroy the editor
   * @fires finishCellEdit
   * @category Editing
   * @returns `false` if the edit could not be finished due to the value being invalid or the
   * Editor's `complete` event was vetoed.
   * @async
   */


  async finishEditing() {
    const me = this,
          {
      editorContext
    } = me;
    let result = false;

    if (editorContext) {
      const {
        column
      } = editorContext; // If completeEdit finds that the editor context has a finalize method in it,
      // it will *await* the completion of that method before completing the edit
      // so we must await completeEdit.
      // We can override that finalize method by passing the column's own finalizeCellEdit.
      // Set a flag (promise) indicating that we are in the middle of editing finalization

      me.finishEditingPromise = editorContext.editor.completeEdit(column.bindCallback(column.finalizeCellEdit));
      result = await me.finishEditingPromise; // If grid is animating, wait for it to finish to not start a follow up edit when things are moving
      // (only applies to Scheduler for now, tested in Schedulers CellEdit.t.js)

      await me.grid.waitForAnimations(); // reset the flag

      me.finishEditingPromise = null;
    }

    return result;
  } //endregion
  //region Events

  /**
   * Event handler added when editing is active called when user clicks a cell in the grid during editing.
   * It finishes editing and moves editor to the selected cell instead.
   * @private
   * @category Internal event handling
   */


  async onCellClickWhileEditing({
    event,
    cellSelector
  }) {
    const me = this; // Ignore clicks if async finalization is running

    if (me.finishEditingPromise) {
      return;
    } // Ignore clicks in the editor.


    if (me.editorContext && !me.editorContext.editor.owns(event.target)) {
      if (me.getEditingContext(cellSelector)) {
        // Attempt to finish the current edit.
        // Will return false if the field is invalid.
        if (await me.finishEditing()) {
          me.startEditing(cellSelector);
        } // Previous edit was invalid, return to it.
        else {
          me.grid.focusCell(me.editorContext.selector);
          me.editor.inputField.focus();
        }
      } else {
        me.finishEditing();
      }
    }
  }
  /**
   * Starts editing if user taps selected cell again on touch device. Chained function called when user clicks a cell.
   * @private
   * @category Internal event handling
   */


  onCellClick({
    source: grid,
    cellSelector,
    target,
    event,
    column
  }) {
    if (column.onCellClick) {
      // Columns may provide their own handling of cell editing
      return;
    }

    const selected = grid.focusedCell || {};

    if (target.closest('.b-tree-expander')) {
      this.cancelEditing(undefined, event);
      return false;
    } else if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTouchEvent && cellSelector.id == selected.id && cellSelector.columnId == selected.columnId) {
      this.startEditing(cellSelector);
    } else if (this.triggerEvent === 'cellclick') {
      this.onTriggerEditEvent({
        cellSelector,
        target
      });
    }
  }
  /**
   * Called when the user triggers the edit action in {@link #config-triggerEvent} config. Starts editing.
   * @private
   * @category Internal event handling
   */


  async onTriggerEditEvent({
    cellSelector,
    target
  }) {
    if (target.closest('.b-tree-expander')) {
      return;
    }

    if (this.editorContext) {
      if (!(await this.finishEditing())) {
        return;
      }
    }

    this.startEditing(cellSelector);
  }
  /**
   * Update the input field if underlying data changes during edit.
   * @private
   * @category Internal event handling
   */


  onStoreUpdate({
    changes,
    record
  }) {
    const {
      editorContext
    } = this;

    if (editorContext !== null && editorContext !== void 0 && editorContext.editor.isVisible) {
      if (record === editorContext.record && editorContext.editor.dataField in changes) {
        editorContext.editor.refreshEdit();
      }
    }
  }
  /**
   * Realign editor if grid renders rows while editing is ongoing (as a result to autoCommit or WebSocket data received).
   * @private
   * @category Internal event handling
   */


  onGridRefreshed() {
    const me = this,
          {
      grid
    } = me;

    if (me.editorContext && grid.focusedCell) {
      const cell = grid.getCell(grid.focusedCell);

      if (cell) {
        me.editorContext.editor.showBy(cell);
      } else {
        me.cancelEditing();
      }
    }
  }
  /**
   * Chained function called on key down. [enter] or [f2] starts editing. [enter] also finishes editing and starts
   * editing next row, [f2] also finishes editing without moving to the next row. [esc] cancels editing. [tab]
   * edits next column, [shift] + [tab] edits previous.
   * @param event
   * @private
   * @category Internal event handling
   */


  async onElementKeyDown(event) {
    const me = this; // flagging event with handled = true used to signal that other features should probably not care about it

    if (event.handled || !me.grid.focusElement.contains(event.target)) {
      return;
    }

    if (!me.editorContext) {
      const {
        key
      } = event,
            backspace = key === 'Backspace',
            autoEdit = me.autoEdit && (key.length === 1 || backspace); // enter or f2 to edit, or any character key if autoEdit is enabled

      if ((autoEdit || validNonEditingKeys[key]) && me.grid.focusedCell) {
        if (me.startEditing(me.grid.focusedCell)) {
          const {
            inputField
          } = me.editor,
                {
            input
          } = inputField; // if editing started with a keypress and the editor has an input field, set its value

          if (autoEdit && input) {
            // Simulate a keydown in an input field by setting input value
            // plus running our internal processing of that event
            inputField.internalOnKeyEvent(event);

            if (!event.defaultPrevented) {
              input.value = backspace ? '' : key;
              inputField.internalOnInput(event); // IE11 + Edge put caret at 0 when focusing

              inputField.moveCaretToEnd();
            }
          }
        }

        event.handled = true;
        event.preventDefault();
      }
    } else {
      switch (event.key) {
        case 'Enter':
          me.onEnterKeyPress(event);
          break;

        case 'F2':
          event.preventDefault();
          me.finishEditing();
          break;

        case 'Escape':
          event.stopPropagation();
          event.preventDefault();
          me.cancelEditing(undefined, event);
          break;

        case 'Tab':
          me.onTabKeyPress(event);
          break;
      } // prevent arrow keys from moving editor


      if (validEditingKeys[event.key]) {
        event.handled = true;
      }
    } // We have processed this keystroke, the rest of the Grid's onElementKeyDown chain must not.


    if (event.handled) {
      return false;
    }
  }

  async onEnterKeyPress(event) {
    const me = this,
          {
      grid
    } = me;
    event.preventDefault();
    event.stopPropagation();

    if (await me.finishEditing()) {
      // Might be destroyed during the async operation
      if (me.isDestroyed) {
        return;
      } // Finalizing might have been blocked by an invalid value


      if (!me.isEditing) {
        if (event.ctrlKey || event.metaKey || event.altKey || grid.touch) {
          // Enter in combination with special keys finishes editing
          // On touch Enter always finishes editing. Feels more natural since no tab-key etc.
          return;
        } // Edit previous


        if (event.shiftKey) {
          if (grid.internalNextPrevRow(false, true, event, false)) {
            me.startEditing(grid.focusedCell);
          }
        } // Edit next
        else {
          // If we are at the last editable cell, optionally add a new row
          if (me.addNewAtEnd) {
            var _grid$focusedCell;

            const record = grid.store.getById((_grid$focusedCell = grid.focusedCell) === null || _grid$focusedCell === void 0 ? void 0 : _grid$focusedCell.id);

            if (record === grid.store.last) {
              await me.doAddNewAtEnd();
            }
          }

          if (grid.internalNextPrevRow(true, true)) {
            me.startEditing(grid.focusedCell);
          }
        }
      }
    }
  }

  async onTabKeyPress(event) {
    event.preventDefault();
    const me = this,
          {
      focusedCell
    } = me.grid;

    if (focusedCell) {
      const isForward = !event.shiftKey;
      let cellInfo = me.getAdjacentEditableCell(focusedCell, isForward); // If we are at the last editable cell, optionally add a new row

      if (!cellInfo && isForward && me.addNewAtEnd) {
        const currentEditableFinalizationResult = await me.finishEditing();

        if (currentEditableFinalizationResult === true) {
          await this.doAddNewAtEnd(); // Re-grab the next editable cell

          cellInfo = me.getAdjacentEditableCell(focusedCell, isForward);
        }
      }

      if (cellInfo) {
        let finalizationResult = true;

        if (me.isEditing) {
          finalizationResult = await me.finishEditing();
        }

        if (finalizationResult) {
          me.grid.focusCell(cellInfo, {
            animate: me.focusCellAnimationDuration
          });
          me.startEditing(cellInfo);
        } else {// finishing cell editing was not allowed, current editor value is invalid
        }
      }
    }
  }

  onElementMouseDown(event) {
    // If it's a contextmenu mousedown during cell edit, prevent default
    // because the contextmenu handler will move focus directly to the context menu.
    // If we allow it to go through the grid, the edit will not terminate because
    // that usually means begin editing somewhere else in the grid.
    // TODO: This won't be necessary when cells are the focusable DOM unit.
    if (event.button === 2 && this.editorContext) {
      event.preventDefault();
    }
  }
  /**
   * Cancel editing on widget focusout
   * @private
   */


  onEditorFocusOut(event) {
    const me = this,
          {
      grid,
      editor,
      editorContext
    } = me; // If the editor is not losing focus as a result of its tidying up process
    // And focus is moving to outside of the grid, or back to the initiating cell
    // (which indicates a click on empty space below rows), then explicitly terminate.

    if (editorContext && !editor.isFinishing && editor.inputField.owns(event._target) && (event.toWidget !== grid || grid.isLocationEqual(grid.focusedCell, editorContext.selector))) {
      if (me.blurAction === 'cancel') {
        me.cancelEditing(undefined, event);
      } // if not already in the middle of editing finalization (that could be async)
      else if (!me.finishEditingPromise) {
        me.finishEditing();
      }
    }
  }

  onEditorFocusIn(event) {
    const widget = event.toWidget;

    if (widget === this.editor.inputField) {
      if (this.autoSelect && widget.selectAll && !widget.readOnly && !widget.disabled) {
        widget.selectAll();
      }
    }
  }
  /**
   * Cancel edit on touch outside of grid for mobile Safari (focusout not triggering unless you touch something focusable)
   * @private
   */


  onTapOut({
    event
  }) {
    const me = this;

    if (!me.grid.bodyContainer.contains(event.target)) {
      if (!me.editor.owns(event.target)) {
        if (me.blurAction === 'cancel') {
          me.cancelEditing(undefined, event);
        } else {
          me.finishEditing();
        }
      }
    }
  }
  /**
   * Finish editing if clicking below rows (only applies when grid is higher than rows).
   * @private
   * @category Internal event handling
   */


  onElementClick(event) {
    if (event.target.classList.contains('b-grid-body-container') && this.editorContext) {
      this.finishEditing();
    }
  } //endregion


}
CellEdit._$name = 'CellEdit';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(CellEdit, true);

/***/ }),

/***/ "./lib/Grid/feature/CellMenu.js":
/*!**************************************!*\
  !*** ./lib/Grid/feature/CellMenu.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellMenu; });
/* harmony import */ var _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';




/**
 * @module Grid/feature/CellMenu
 */

/**
 * Right click to display context menu for cells.
 *
 * ### Default cell menu items
 *
 * The Cell menu feature provides only one item by default and all the other items are populated by the other features:
 *
 * | Reference              | Text             | Weight | Feature                            | Description                                           |
 * |------------------------|------------------|--------|------------------------------------|-------------------------------------------------------|
 * | `copy`                 | Copy record      | 100    | {@link Grid.feature.RowCopyPaste RowCopyPaste} | Copy row record                           |
 * | `cut`                  | Cut record       | 110    | {@link Grid.feature.RowCopyPaste RowCopyPaste} | Cut row record                            |
 * | `paste`                | Paste record     | 120    | {@link Grid.feature.RowCopyPaste RowCopyPaste} | Paste copied row records                  |
 * | `search`               | Search for value | 200    | {@link Grid.feature.Search Search} | Search for the selected cell text                     |
 * | `filterDateEquals`     | On               | 300    | {@link Grid.feature.Filter Filter} | Filters by the column field, equal to the cell value  |
 * | `filterDateBefore`     | Before           | 310    | {@link Grid.feature.Filter Filter} | Filters by the column field, less than the cell value |
 * | `filterDateAfter`      | After            | 320    | {@link Grid.feature.Filter Filter} | Filters by the column field, more than the cell value |
 * | `filterNumberEquals`   | Equals           | 300    | {@link Grid.feature.Filter Filter} | Filters by the column field, equal to the cell value  |
 * | `filterNumberLess`     | Less than        | 310    | {@link Grid.feature.Filter Filter} | Filters by the column field, less than the cell value |
 * | `filterNumberMore`     | More than        | 320    | {@link Grid.feature.Filter Filter} | Filters by the column field, more than the cell value |
 * | `filterDurationEquals` | Equals           | 300    | {@link Grid.feature.Filter Filter} | Filters by the column field, equal to the cell value  |
 * | `filterDurationLess`   | Less than        | 310    | {@link Grid.feature.Filter Filter} | Filters by the column field, less than the cell value |
 * | `filterDurationMore`   | More than        | 320    | {@link Grid.feature.Filter Filter} | Filters by the column field, more than the cell value |
 * | `filterStringEquals`   | Equals           | 300    | {@link Grid.feature.Filter Filter} | Filters by the column field, equal to the cell value  |
 * | `filterRemove`         | Remove filter    | 400    | {@link Grid.feature.Filter Filter} | Stops filtering by selected column field              |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Cell menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all columns:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     cellMenu : {
 *       items : {
 *          extraItem : { text: 'My cell item', icon: 'fa fa-bus', weight: 200, onItem : () => ... }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to add items using columns config. See examples below.
 *
 * Add extra items for a single column:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns: [
 *     {
 *       field: 'city',
 *       text: 'City',
 *       cellMenuItems: {
 *         columnItem : { text: 'My unique cell item', icon: 'fa fa-beer', onItem : () => ... }
 *       }
 *     }
 *   ]
 * });
 * ```
 *
 * Remove existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         cellMenu : {
 *             items : {
 *                 removeRow : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         cellMenu : {
 *             items : {
 *                 removeRow : {
 *                     text : 'Throw away',
 *                     icon : 'b-fa b-fa-dumpster'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * It is also possible to manipulate the default items and add new items in the processing function:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     cellMenu : {
 *       processItems({items, record}) {
 *           if (record.cost > 5000) {
 *              items.myItem = { text : 'Split cost' };
 *           }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the ["Customizing the Cell menu and the Header menu"](#Grid/guides/customization/contextmenu.md)
 * guide.
 *
 * This feature is **enabled** by default.
 *
 * @extends Core/feature/base/ContextMenuBase
 * @demo Grid/contextmenu
 * @classtype cellMenu
 * @inlineexample Grid/feature/CellMenu.js
 * @feature
 */

class CellMenu extends _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'CellMenu';
  }

  static get defaultConfig() {
    return {
      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       *   features         : {
       *      cellMenu : {
       *           processItems({ items, record, column }) {
       *               // Add or hide existing items here as needed
       *               items.myAction = {
       *                   text   : 'Cool action',
       *                   icon   : 'b-fa b-fa-fw b-fa-ban',
       *                   onItem : () => console.log(`Clicked ${record.name}`),
       *                   weight : 1000 // Move to end
       *               };
       *
       *               if (!record.allowDelete) {
       *                   items.removeRow.hidden = true;
       *               }
       *           }
       *       }
       *   },
       * ```
       * @param {Object} context An object with information about the menu being shown
       * @param {Core.data.Model} context.record The record representing the current row
       * @param {Grid.column.Column} context.column The current column
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null,

      /**
       * {@link Core.widget.Menu Menu} items object containing named child menu items to apply to the feature's
       * provided context menu.
       *
       * This may add extra items as below, but you can also configure, or remove any of the default items by
       * configuring the name of the item as `false`
       *
       * ```javascript
       * features : {
       *     cellMenu : {
       *         // This object is applied to the Feature's predefined default items
       *         items : {
       *             switchToDog : {
       *                 text : 'Dog',
       *                 icon : 'b-fa b-fa-fw b-fa-dog',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = true;
       *                     contextRecord.cat = false;
       *                 },
       *                 weight : 500     // Make this second from end
       *             },
       *             switchToCat : {
       *                 text : 'Cat',
       *                 icon : 'b-fa b-fa-fw b-fa-cat',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = false;
       *                     contextRecord.cat = true;
       *                 },
       *                 weight : 510     // Make this sink to end
       *             },
       *             removeRow : {
       *                 // Change icon for the delete item
       *                 icon : 'b-fa b-fa-times'
       *             }
       *         }
       *     }
       * }
       * ```
       *
       * @config {Object}
       */
      items: null,
      type: 'cell'
    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateCellMenu');
    return config;
  } //endregion
  //region Events

  /**
   * This event fires on the owning grid before the context menu is shown for a cell.
   * Allows manipulation of the items to show in the same way as in the {@link #config-processItems}.
   *
   * Returning `false` from a listener prevents the menu from being shown.
   *
   * @event cellMenuBeforeShow
   * @preventable
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   */

  /**
   * This event fires on the owning grid after the context menu is shown for a cell.
   * @event cellMenuShow
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   */

  /**
   * This event fires on the owning grid when an item is selected in the cell context menu.
   * @event cellMenuItem
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   */

  /**
   * This event fires on the owning grid when a check item is toggled in the cell context menu.
   * @event cellMenuToggleItem
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   * @param {Boolean} checked Checked or not
   */
  //endregion
  //region Menu handlers


  showContextMenu(eventParams) {
    const me = this,
          {
      cellSelector,
      id,
      event
    } = eventParams; // Process the gesture as navigation so that the use may select/multiselect
    // the items to include in their context menu operation.
    // Also select if not already selected.

    me.client.focusCell(cellSelector, {
      doSelect: !me.client.isSelected(id),
      event
    });
    super.showContextMenu(eventParams);
  }

  shouldShowMenu({
    column
  }) {
    return column && column.enableCellContextMenu !== false;
  }

  getDataFromEvent(event) {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(super.getDataFromEvent(event), this.client.getCellDataFromEvent(event));
  }

  beforeContextMenuShow(eventParams) {
    if (!eventParams.record || eventParams.record.isSpecialRow) {
      eventParams.items.removeRow = false;
    }
  } //endregion
  //region Getters/Setters


  populateCellMenu({
    items,
    column
  }) {
    const {
      client
    } = this;

    if (column !== null && column !== void 0 && column.cellMenuItems) {
      if (Array.isArray(column.cellMenuItems)) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Grid', '5.0.0', '`cellMenuItems` column config specified as an array is deprecated, need to specify the config as a named object. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.');
      } // Array works smoothly since number index turns into a key for named object


      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(items, column.cellMenuItems);
    }

    if (!client.readOnly) {
      items.removeRow = {
        text: 'L{removeRow}',
        localeClass: this,
        icon: 'b-fw-icon b-icon-trash',
        cls: 'b-separator',
        weight: 100,
        onItem: () => client.store.remove(client.selectedRecords)
      };

      if (!client.showRemoveRowInContextMenu) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Grid', '5.0.0', '`showRemoveRowInContextMenu` config is deprecated, in favor of `CellMenu` feature configuration. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.');
        items.removeRow = false;
      }
    }
  }

  get showMenu() {
    return true;
  } //endregion


}
CellMenu.featureClass = '';
CellMenu._$name = 'CellMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(CellMenu, true, ['Grid', 'Scheduler']);
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(CellMenu, false, ['Gantt']);

/***/ }),

/***/ "./lib/Grid/feature/CellTooltip.js":
/*!*****************************************!*\
  !*** ./lib/Grid/feature/CellTooltip.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellTooltip; });
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';





/**
 * @module Grid/feature/CellTooltip
 */

/**
 * Displays a tooltip when hovering cells. To show contents when hovering a cell, you can specify
 * a global {@link #config-tooltipRenderer} function for the feature but you can also define {@link Grid.column.Column#config-tooltipRenderer}
 * for individual columns.
 *
 * Configuration properties passed into this feature are used to configure the {@link Core.widget.Tooltip} instance
 * used.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ## Showing async content
 * Showing remotely loaded content is super easy using the {@link #config-tooltipRenderer}:
 *
 * ```javascript
 * // Async tooltip with some custom settings
 * let grid = new Grid({
 *   features: {
 *     cellTooltip: {
 *       // Time that mouse needs to be over cell before tooltip is shown
 *       hoverDelay : 4000,
 *       // Time after mouse out to hide the tooltip, 0 = instantly
 *       hideDelay  : 0,
 *       // Async tooltip renderer, return a Promise which yields the text content
 *       tooltipRenderer({ record, tip }) => AjaxHelper.get(`tooltip.php?id=${record.id}`).then(response => response.text())
 *     }
 *   }
 * });
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // Column with its own tooltip renderer
 * {
 *   text            : 'Name',
 *   field           : 'name',
 *   tooltipRenderer : ({ record }) => `My name is\xa0<b>${record.name}</b>`
 * }
 *
 * @demo Grid/celltooltip
 * @classtype cellTooltip
 * @inlineexample Grid/feature/CellTooltip.js
 * @feature
 */

class CellTooltip extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'CellTooltip';
  }

  static get defaultConfig() {
    return {
      /**
       * Function called to generate the HTML content for the cell tooltip.
       * The function should return a string (your HTML), or a Promise yielding a string (for remotely loaded content)
       * @config {Function}
       * @param {Object} context
       * @param {HTMLElement} context.cellElement The cell element
       * @param {Core.data.Model} context.record The row record
       * @param {Grid.column.Column} context.column The column
       * @param {Core.widget.Tooltip} context.tip The Tooltip instance
       * @param {Grid.feature.CellTooltip} context.cellTooltip The feature
       * @param {Event} context.event The raw DOM event
       * @return {String|Promise}
       */
      tooltipRenderer: null
    };
  } //endregion
  // region Init


  construct(grid, config) {
    const me = this;
    super.construct(grid, me.processConfig(config));
  }

  initTip() {
    const me = this;
    me.tip = _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_0__["default"].new({
      forElement: me.client.element,
      forSelector: '.b-grid-row:not(.b-group-row) .b-grid-cell',
      hoverDelay: 1000,
      trackMouse: false,
      cls: 'b-celltooltip-tip',
      getHtml: me.getTooltipContent.bind(me),
      listeners: {
        pointerOver: 'onPointerOver',
        thisObj: me
      }
    }, me.initialConfig);
    me.relayEvents(me.tip, ['beforeshow', 'show']);
  }

  onPointerOver({
    target
  }) {
    const column = this.client.getColumnFromElement(target); // Veto onPointerOver if column's tooltipRenderer is false

    return column.tooltipRenderer !== false && Boolean(column.tooltipRenderer || this.tooltipRenderer);
  } // CellTooltip feature handles special config cases, where user can supply a function to use as tooltipRenderer
  // instead of a normal config object


  processConfig(config) {
    if (typeof config === 'function') {
      return {
        tooltipRenderer: config
      };
    }

    return config;
  } // override setConfig to process config before applying it (used mainly from ReactGrid)


  setConfig(config) {
    super.setConfig(this.processConfig(config));
  }

  doDestroy() {
    this.tip && this.tip.destroy();
    super.doDestroy();
  }

  doDisable(disable) {
    if (!disable) {
      this.initTip();
    } else if (this.tip) {
      this.tip.destroy();
      this.tip = null;
    }

    super.doDisable(disable);
  } //endregion
  //region Content

  /**
   * Called from Tooltip to populate it with html.
   * @private
   */


  getTooltipContent({
    tip,
    activeTarget: cellElement,
    event
  }) {
    const me = this,
          record = me.client.getRecordFromElement(cellElement),
          column = me.client.getColumnFromElement(cellElement),
          arg = {
      cellElement,
      record,
      column,
      event,
      tip,
      cellTooltip: me
    };
    let result; // If we have not changed context, we should not change content, unless we have a custom target selector (element within the cell)

    if (!me.forSelector && record === me.lastRecord && column === me.lastColumn) {
      return me.tip._html;
    }

    me.lastRecord = record;
    me.lastColumn = column; // first, use columns tooltipRenderer if any

    if (column.tooltipRenderer) {
      result = column.tooltipRenderer(arg);
    } // secondly, try features renderer (but specifying column.tooltipRenderer as false prevents tooltip in that column)
    else if (me.tooltipRenderer && column.tooltipRenderer !== false) {
      result = me.tooltipRenderer(arg);
    }

    if (result === false) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Grid', '5.0.0', 'Returning false to indicate loading is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/3.0.1 for more information');
    }

    return result;
  } //endregion


}
CellTooltip._$name = 'CellTooltip';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(CellTooltip);

/***/ }),

/***/ "./lib/Grid/feature/ColumnAutoWidth.js":
/*!*********************************************!*\
  !*** ./lib/Grid/feature/ColumnAutoWidth.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnAutoWidth; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';



const storeListenerName = 'store';
/**
 * @module Grid/feature/ColumnAutoWidth
 */

/**
 * Enables the {@link Grid.column.Column#config-autoWidth} config for a grid's columns.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 * @classtype columnAutoWidth
 * @feature
 */

class ColumnAutoWidth extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ColumnAutoWidth';
  } //region Config


  static get configurable() {
    return {
      /**
       * The default `autoWidth` option for columns with `autoWidth: true`. This can
       * be a single number for the minimum column width, or an array of two numbers
       * for the `[minWidth, maxWidth]`.
       * @config {Number|Number[]}
       */
      default: null,

      /**
       * The amount of time (in milliseconds) to delay after a store modification
       * before synchronizing `autoWidth` columns.
       * @config {Number}
       * @default
       */
      delay: 0
    };
  } //endregion
  //region Internals


  static get pluginConfig() {
    return {
      after: {
        bindStore: 'bindStore',
        unbindStore: 'unbindStore',
        renderRows: 'syncAutoWidthColumns',
        onInternalResize: 'onInternalResize'
      },
      assign: ['columnAutoWidthPending', 'syncAutoWidthColumns']
    };
  }

  construct(config) {
    super.construct(config);
    const {
      client: grid
    } = this,
          {
      store
    } = grid; // The initial bindStore can come super early such that our hooks won't catch it:

    if (store) {
      this.bindStore(store);
    }
  }

  doDestroy() {
    this.unbindStore();
    super.doDestroy();
  }

  bindStore(store) {
    this.lastSync = null;
    store.on({
      name: storeListenerName,
      [`change${this.client.asyncEventSuffix}`]: 'onStoreChange'
    }, this);
  }

  unbindStore() {
    this.detachListeners(storeListenerName);
  }

  get columnAutoWidthPending() {
    return this.lastSync === null || this.hasTimeout('syncAutoWidthColumns');
  }

  onStoreChange({
    action
  }) {
    if (action !== 'move') {
      var _me$client$features$c;

      const me = this;
      ++me.storeGeneration; // If we are editing, sync right away so cell editing can align correctly to next cell

      if ((_me$client$features$c = me.client.features.cellEdit) !== null && _me$client$features$c !== void 0 && _me$client$features$c.isEditing) {
        me.syncAutoWidthColumns();
      } else if (!me.hasTimeout('syncAutoWidthColumns')) {
        me.setTimeout('syncAutoWidthColumns', me.delay);
      }
    }
  } // Handle scenario with Grid being inside DIV with display none, and no width. Sync column widths after being shown


  onInternalResize(element, newWidth, newHeight, oldWidth) {
    if (oldWidth === 0) {
      // Force remeasure after we get a width
      this.lastSync = null;
      this.syncAutoWidthColumns();
    }
  }

  syncAutoWidthColumns() {
    const me = this,
          grid = me.client,
          storeGeneration = me.storeGeneration;

    if (me.lastSync !== storeGeneration) {
      me.lastSync = storeGeneration;
      let autoWidth, resizingColumns;

      for (const column of grid.columns.visibleColumns) {
        autoWidth = column.autoWidth;

        if (autoWidth) {
          if (autoWidth === true) {
            autoWidth = me.default;
          }

          grid.resizingColumns = resizingColumns = true;
          column.resizeToFitContent(autoWidth);
        }
      }

      if (resizingColumns) {
        grid.resizingColumns = false;
        grid.afterColumnsResized();
      }
    }

    if (me.hasTimeout('syncAutoWidthColumns')) {
      me.clearTimeout('syncAutoWidthColumns');
    }
  } //endregion


}
ColumnAutoWidth.prototype.storeGeneration = 0;
ColumnAutoWidth._$name = 'ColumnAutoWidth';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(ColumnAutoWidth, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnDragToolbar.js":
/*!***********************************************!*\
  !*** ./lib/Grid/feature/ColumnDragToolbar.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnDragToolbar; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';







/**
 * @module Grid/feature/ColumnDragToolbar
 */

/**
 * Displays a toolbar while dragging column headers. Drop on a button in the toolbar to activate a certain function,
 * for example to group by that column. This feature simplifies certain operations on touch devices.
 *
 * This feature is <strong>disabled</strong> by default, but turned on automatically on touch devices.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @classtype columnDragToolbar
 * @inlineexample Grid/feature/ColumnDragToolbar.js
 * @demo Grid/columndragtoolbar
 * @feature
 */

class ColumnDragToolbar extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Config
  static get $name() {
    return 'ColumnDragToolbar';
  } // Plugin configuration. This plugin chains some of the functions in Grid


  static get pluginConfig() {
    return {
      after: ['render']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    if (grid.features.columnReorder) {
      grid.features.columnReorder.on('beforedestroy', this.onColumnReorderBeforeDestroy, this);
    }

    this.grid = grid;
    super.construct(grid, config);
  }

  doDestroy() {
    const me = this;

    if (me.grid.features.columnReorder && !me.grid.features.columnReorder.isDestroyed) {
      me.detachFromColumnReorder();
    }

    me.element && me.element.remove();
    me.element = null;
    super.doDestroy();
  }

  doDisable(disable) {
    if (this.initialized) {
      if (disable) {
        this.detachFromColumnReorder();
      } else {
        this.init();
      }
    }

    super.doDisable(disable);
  }

  init() {
    const me = this,
          grid = me.grid;

    if (!grid.features.columnReorder) {
      return;
    }

    me.reorderDetacher = grid.features.columnReorder.on({
      gridheaderdragstart({
        context
      }) {
        const column = grid.columns.getById(context.element.dataset.columnId);
        me.showToolbar(column);
      },

      gridheaderdrag: ({
        context
      }) => me.onDrag(context),
      gridheaderabort: () => {
        me.hideToolbar();
      },
      gridheaderdrop: ({
        context
      }) => {
        if (context.valid) {
          me.hideToolbar();
        } else {
          me.onDrop(context);
        }
      },
      thisObj: me
    });
    me.initialized = true;
  }

  onColumnReorderBeforeDestroy() {
    this.detachFromColumnReorder();
  }

  detachFromColumnReorder() {
    const me = this;
    me.grid.features.columnReorder.un('beforedestroy', me.onColumnReorderBeforeDestroy, me);
    me.reorderDetacher && me.reorderDetacher();
    me.reorderDetacher = null;
  }
  /**
   * Initializes this feature on grid render.
   * @private
   */


  render() {
    if (!this.initialized) {
      this.init();
    }
  } //endregion
  //region Toolbar


  showToolbar(column) {
    const me = this,
          buttons = me.grid.getColumnDragToolbarItems(column, []),
          groups = [];
    me.clearTimeout(me.buttonHideTimer);
    buttons.forEach(button => {
      button.text = button.localeClass.L(button.text);
      let group = groups.find(group => group.text === button.group);

      if (!group) {
        group = {
          text: button.localeClass.L(button.group),
          buttons: []
        };
        groups.push(group);
      }

      group.buttons.push(button);
    });
    me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].append(me.grid.element, me.template(groups));
    me.groups = groups;
    me.buttons = buttons;
    me.column = column;
  }

  async hideToolbar() {
    const me = this,
          element = me.element;

    if (element) {
      element.classList.add('b-remove');
      await _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].waitForTransitionEnd({
        element,
        mode: 'animation',
        thisObj: me.client
      });
      element.remove();
      me.element = null;
    }
  } //endregion
  //region Events


  onDrag(info) {
    var _info$targetElement;

    const me = this;

    if (info.dragProxy.getBoundingClientRect().top - me.grid.element.getBoundingClientRect().top > 100) {
      me.element.classList.add('b-closer');
    } else {
      me.element.classList.remove('b-closer');
    }

    if (me.hoveringButton) {
      me.hoveringButton.classList.remove('b-hover');
      me.hoveringButton = null;
    }

    if ((_info$targetElement = info.targetElement) !== null && _info$targetElement !== void 0 && _info$targetElement.closest('.b-columndragtoolbar')) {
      me.element.classList.add('b-hover');
      const button = info.targetElement.closest('.b-columndragtoolbar  .b-target-button:not([data-disabled=true])');

      if (button) {
        button.classList.add('b-hover');
        me.hoveringButton = button;
      }
    } else {
      me.element.classList.remove('b-hover');
    }
  }

  onDrop(info) {
    const me = this;

    if (info.targetElement && info.targetElement.matches('.b-columndragtoolbar .b-target-button:not([data-disabled=true])')) {
      const buttonEl = info.targetElement,
            button = me.buttons.find(button => button.ref === buttonEl.dataset.ref);

      if (button) {
        buttonEl.classList.add('b-activate');
        me.buttonHideTimer = me.setTimeout(() => {
          me.hideToolbar();
          button.onDrop({
            column: me.column
          });
        }, 100);
      }
    } else {
      me.hideToolbar();
    }
  } //endregion


  template(groups) {
    return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].tpl`
            <div class="b-columndragtoolbar">     
            <div class="b-title"></div>          
            ${groups.map(group => _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].tpl`
                <div class="b-group">
                    <div class="b-buttons">
                    ${group.buttons.map(btn => _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].tpl`
                        <div class="b-target-button" data-ref="${btn.ref}" data-disabled="${btn.disabled}">
                            <i class="${btn.icon}"></i>
                            ${btn.text}
                        </div>
                    `)}
                    </div>
                    <div class="b-title">${group.text}</div>
                </div>
            `)}
            </div>`;
  }

}
ColumnDragToolbar.featureClass = 'b-hascolumndragtoolbar'; // used by default on touch devices, can be enabled otherwise

ColumnDragToolbar._$name = 'ColumnDragToolbar';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(ColumnDragToolbar, _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isTouchDevice);

/***/ }),

/***/ "./lib/Grid/feature/ColumnPicker.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/ColumnPicker.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnPicker; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




/**
 * @module Grid/feature/ColumnPicker
 */

/**
 * Displays a column picker (to show/hide columns) in the header context menu. Columns can be displayed in sub menus
 * by region or tag. Grouped headers are displayed as menu hierarchies.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnPicker
 * @inlineexample Grid/feature/ColumnPicker.js
 * @feature
 */

class ColumnPicker extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ColumnPicker';
  }

  static get configurable() {
    return {
      /**
       * Groups columns in the picker by region (each region gets its own sub menu)
       * @config {Boolean}
       * @default
       */
      groupByRegion: false,

      /**
       * Groups columns in the picker by tag, each column may be shown under multiple tags. See
       * {@link Grid.column.Column#config-tags}
       * @config {Boolean}
       * @default
       */
      groupByTag: false,

      /**
       * Configure this as `true` to have the fields from the Grid's {@link Core.data.Store}'s
       * {@link Core.data.Store#config-modelClass} added to the menu to create __new__ columns
       * to display the fields.
       *
       * This may be combined with the {@link Grid.view.mixin.GridState stateful} ability of the grid
       * to create a self-configuring grid.
       * @config {Boolean}
       * @default
       */
      createColumnsFromModel: false,
      menuCls: 'b-column-picker-menu b-sub-menu'
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['populateHeaderMenu', 'getColumnDragToolbarItems']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    this.grid = grid;
    super.construct(grid, config);
  } //endregion
  //region Context menu

  /**
   * Get menu items, either a straight list of columns or sub menus per subgrid
   * @private
   * @param columnStore Column store to traverse
   * @returns {Object[]} Menu item configs
   */


  getColumnPickerItems(columnStore) {
    const me = this,
          {
      createColumnsFromModel
    } = me;
    let result;

    if (me.groupByRegion) {
      // submenus for grids regions
      result = me.grid.regions.map(region => {
        const columns = me.grid.getSubGrid(region).columns.topColumns;
        return {
          text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(region),
          menu: me.buildColumnMenu(columns),
          disabled: columns.length === 0,
          region
        };
      });

      if (createColumnsFromModel) {
        result.push({
          text: me.L('L{newColumns}'),
          menu: me.createAutoColumnItems()
        });
      }
    } else if (me.groupByTag) {
      // submenus for column tags
      const tags = {};
      columnStore.topColumns.forEach(column => {
        column.tags && column.hideable && column.tags.forEach(tag => {
          if (!tags[tag]) {
            tags[tag] = 1;
          }
        });
      }); // TODO: as checkitems, but how to handle toggling? hide a column only when all tags for it are unchecked?

      result = Object.keys(tags).sort().map(tag => ({
        text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(tag),
        menu: me.buildColumnMenu(me.getColumnsForTag(tag)),
        tag,
        onBeforeSubMenu: ({
          item,
          itemEl
        }) => {
          me.refreshTagMenu(item, itemEl);
        }
      }));

      if (createColumnsFromModel) {
        result.push({
          text: me.L('L{newColumns}'),
          menu: me.createAutoColumnItems()
        });
      }
    } else {
      // all columns in same menu
      result = me.buildColumnMenu(columnStore.topColumns);

      if (createColumnsFromModel) {
        result.items.push(..._Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformNamedObjectToArray(me.createAutoColumnItems()));
      }
    }

    return result;
  }

  createAutoColumnItems() {
    const me = this,
          {
      grid
    } = me,
          {
      columns,
      store
    } = grid,
          {
      modelClass
    } = store,
          {
      allFields
    } = modelClass,
          result = {};

    for (let i = 0, {
      length
    } = allFields; i < length; i++) {
      const field = allFields[i],
            fieldName = field.name;

      if (!columns.get(fieldName)) {
        // Don't include system-level "internal" fields from the base Model classes like rowHeight or cls.
        if (!field.internal) {
          result[fieldName] = {
            text: field.text || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].separate(field.name),
            checked: false,
            onToggle: event => {
              const column = columns.get(fieldName);

              if (column) {
                column[event.checked ? 'show' : 'hide']();
              } else {
                columns.add(columns.generateColumnForField(field, {
                  region: me.forColumn.region
                }));
              }

              event.bubbles = false;
            }
          };
        }
      }
    }

    return result;
  }
  /**
   * Get all columns that has the specified tag
   * TODO: if tags are useful from somewhere else, move to ColumnStore
   * @private
   * @param tag
   * @returns {Grid.column.Column[]}
   */


  getColumnsForTag(tag) {
    // TODO: if tags are useful from somewhere else, move to ColumnStore
    return this.grid.columns.records.filter(column => column.tags && column.tags.includes(tag) && column.hideable !== false);
  }
  /**
   * Refreshes checked status for a tag menu. Needed since columns can appear under multiple tags.
   * @private
   */


  refreshTagMenu(item, itemEl) {
    const columns = this.getColumnsForTag(item.tag);
    columns.forEach(column => {
      const subItem = item.items.find(subItem => subItem.column === column);
      if (subItem) subItem.checked = column.hidden !== true;
    });
  }
  /**
   * Traverses columns to build menu items for the column picker.
   * @private
   */


  buildColumnMenu(columns) {
    let currentRegion = columns.length > 0 && columns[0].region;
    const {
      grid
    } = this,
          items = columns.reduce((items, column) => {
      const visibleInRegion = grid.columns.visibleColumns.filter(col => col.region === column.region);

      if (column.hideable !== false) {
        const itemConfig = {
          grid,
          column,
          text: column.headerText,
          checked: column.hidden !== true,
          disabled: column.hidden !== true && visibleInRegion.length === 1,
          cls: column.region !== currentRegion ? 'b-separator' : ''
        };
        currentRegion = column.region;

        if (column.children) {
          itemConfig.menu = this.buildColumnMenu(column.children);
        }

        items.push(itemConfig);
      }

      return items;
    }, []);
    return {
      cls: this.menuCls,
      items
    };
  }
  /**
   * Populates the header context menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    column,
    items
  }) {
    const me = this,
          {
      columns
    } = me.grid;
    /**
     * The column on which the context menu was invoked.
     * @property {Grid.column.Column} forColumn
     * @readonly
     * @private
     */

    me.forColumn = column;

    if (column.showColumnPicker !== false && columns.some(col => col.hideable)) {
      // column picker
      items.columnPicker = {
        text: 'L{columnsMenu}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-columns',
        cls: 'b-separator',
        weight: 200,
        menu: me.getColumnPickerItems(columns),
        onToggle: me.onColumnToggle,
        disabled: me.disabled
      };
    } // menu item for hiding this column


    if (column.hideable !== false) {
      const visibleInRegion = columns.visibleColumns.filter(col => col.region === column.region);
      items.hideColumn = {
        text: 'L{hideColumn}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-hide-column',
        weight: 210,
        disabled: visibleInRegion.length === 1 || me.disabled,
        onItem: () => column.hide()
      };
    }
  }
  /**
   * Handler for column hide/show menu checkitems.
   * @private
   * @param {Object} event The {@link Core.widget.MenuItem#event-toggle} event.
   */


  onColumnToggle({
    menu,
    item,
    checked
  }) {
    if (!!item.column.hidden !== !checked) {
      item.column[checked ? 'show' : 'hide']();
      const {
        grid,
        column
      } = item,
            {
        columns,
        features
      } = grid,
            // Sibling items, needed to disable other item if it is the last one in region
      siblingItems = menu.items,
            // Columns left visible in same region as this items column
      visibleInRegion = columns.visibleColumns.filter(col => col.region === item.column.region),
            // Needed to access "hide-column" item outside of column picker
      // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.
      {
        contextMenu,
        headerMenu
      } = features,
            isOldFeatureUsed = contextMenu && !contextMenu.disabled,
            contextMenuFeature = isOldFeatureUsed ? contextMenu : headerMenu,
            mainMenu = contextMenuFeature && contextMenuFeature[isOldFeatureUsed ? 'currentMenu' : 'menu'],
            hideItem = isOldFeatureUsed ? mainMenu.items.find(item => item.ref === 'hideColumn') : mainMenu.widgetMap.hideColumn; // Do not allow user to hide the last column in any region

      if (visibleInRegion.length === 1) {
        const lastVisibleItem = siblingItems.find(menuItem => menuItem.column === visibleInRegion[0]);

        if (lastVisibleItem) {
          lastVisibleItem.disabled = true;
        } // Also disable "Hide column" item if only one column left in this region


        if (hideItem && column.region === item.column.region) {
          hideItem.disabled = true;
        }
      } // Multiple columns visible, enable "hide-column" and all items for that region
      else {
        visibleInRegion.forEach(col => {
          const siblingItem = siblingItems.find(sibling => sibling.column === col);

          if (siblingItem) {
            siblingItem.disabled = false;
          }
        });

        if (hideItem && column.region === item.column.region) {
          hideItem.disabled = false;
        }
      }

      if (item.menu) {
        // Reflect status in submenu.
        // Cannot use short form () => foo because eachWidget aborts on return of false
        item.menu.eachWidget(subItem => {
          subItem.checked = checked;
        });
      }

      const parentItem = menu.owner;

      if (parentItem && parentItem.column === column.parent) {
        parentItem.checked = siblingItems.some(subItem => subItem.checked === true);
      }
    }
  }
  /**
   * Supply items to ColumnDragToolbar
   * @private
   */


  getColumnDragToolbarItems(column, items) {
    const visibleInRegion = this.grid.columns.visibleColumns.filter(col => col.region === column.region);

    if (column.hideable !== false && visibleInRegion.length > 1) {
      items.push({
        text: 'L{hideColumnShort}',
        ref: 'hideColumn',
        group: 'L{column}',
        localeClass: this,
        icon: 'b-fw-icon b-icon-hide-column',
        weight: 101,
        onDrop: ({
          column
        }) => column.hide()
      });
    }

    return items;
  } //endregion


}
ColumnPicker._$name = 'ColumnPicker';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(ColumnPicker, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnReorder.js":
/*!*******************************************!*\
  !*** ./lib/Grid/feature/ColumnReorder.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnReorder; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'gantt';






/**
 * @module Grid/feature/ColumnReorder
 */

/**
 * Allows user to reorder columns by dragging headers. To get notified about column reorder listen to `change` event
 * on {@link Grid.data.ColumnStore columns} store.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnReorder
 * @inlineexample Grid/feature/ColumnReorder.js
 * @feature
 */

class ColumnReorder extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Init
  static get $name() {
    return 'ColumnReorder';
  }

  construct(grid, config) {
    this.ignoreSelectors = ['.b-grid-header-resize-handle', '.b-field'];
    this.grid = grid;
    super.construct(grid, config);
  }

  doDestroy() {
    var _this$dragHelper;

    (_this$dragHelper = this.dragHelper) === null || _this$dragHelper === void 0 ? void 0 : _this$dragHelper.destroy();
    super.doDestroy();
  }
  /**
   * Initialize drag & drop (called from render)
   * @private
   */


  init() {
    const me = this,
          {
      grid
    } = me,
          gridEl = grid.element,
          containers = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(gridEl, '.b-grid-headers');
    containers.push(..._Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(gridEl, '.b-grid-header-children'));

    if (me.dragHelper) {
      // update the dragHelper with the new set of containers it should operate upon
      me.dragHelper.containers = containers;
    } else {
      me.dragHelper = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        name: 'columnReorder',
        mode: 'container',
        dragThreshold: 10,
        targetSelector: '.b-grid-header',
        floatRootOwner: grid,
        outerElement: gridEl.querySelector('header.b-grid-header-container'),
        containers,

        isElementDraggable(element) {
          const abort = Boolean(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(element, me.ignoreSelectors.join(',')));

          if (abort || me.disabled) {
            return false;
          }

          const columnEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(element, this.targetSelector),
                column = columnEl && grid.columns.getById(columnEl.dataset.columnId),
                isLast = (column === null || column === void 0 ? void 0 : column.childLevel) === 0 && grid.subGrids[column.region].columns.count === 1; // TODO: If we want to prevent dragging last column out of group we can use the code below...

          /*isLast = column.level !== 0
                  // In grouped header, do not allow dragging last remaining child
                  ? column.parent.children.length === 1
                  // Not in a grouped header, do not allow dragging last remaining column
                  : grid.subGrids[column.region].columns.count === 1;*/

          return Boolean(column) && column.draggable !== false && !isLast;
        },

        ignoreSelector: '.b-filter-icon,.b-grid-header-resize-handle',
        listeners: {
          beforeDragStart: me.onBeforeDragStart,
          dragstart: me.onDragStart,
          drag: me.onDrag,
          drop: me.onDrop,
          thisObj: me
        }
      });
      me.relayEvents(me.dragHelper, ['dragStart', 'drag', 'drop', 'abort'], 'gridHeader');
    }
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid


  static get pluginConfig() {
    return {
      after: ['onPaint', 'renderContents']
    };
  } //endregion
  //region Events (drop)


  onDrag({
    context,
    event
  }) {
    const me = this,
          targetHeader = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_5__["default"].fromElement(event.target, 'gridheader'); // If SubGrid is configured with a sealed column set, do not allow moving into it

    if (targetHeader !== null && targetHeader !== void 0 && targetHeader.subGrid.sealedColumns) {
      context.valid = false;
      return;
    } // Require that we drag inside grid header while dragging if we don't have a drag toolbar


    if (!me.grid.features.columnDragToolbar) {
      context.valid = Boolean(event.target.closest('.b-grid-headers'));
    }
  }

  onBeforeDragStart({
    context,
    event
  }) {
    const element = context.element,
          column = context.column = this.client.columns.getById(element.dataset.columnId);
    /**
     * This event is fired prior to starting a column drag gesture. The drag is canceled if a listener returns `false`.
     * @on-owner
     * @event beforeColumnDragStart
     * @param {Grid.view.Grid} source The grid instance.
     * @param {Grid.column.Column} column The dragged column.
     * @param {Event} event The browser event.
     * @preventable
     */

    return this.client.trigger('beforeColumnDragStart', {
      column,
      event
    });
  }

  onDragStart({
    context,
    event
  }) {
    const me = this,
          {
      grid
    } = me,
          {
      column
    } = context;

    if (!grid.features.columnDragToolbar) {
      const headerContainerBox = grid.element.querySelector('.b-grid-header-container').getBoundingClientRect();
      me.dragHelper.minY = headerContainerBox.top;
      me.dragHelper.maxY = headerContainerBox.bottom;
    }

    grid.headerContainer.classList.add('b-dragging-header');
    /**
     * This event is fired when a column drag gesture has started.
     * @on-owner
     * @event columnDragStart
     * @param {Grid.view.Grid} source The grid instance.
     * @param {Grid.column.Column} column The dragged column.
     * @param {Event} event The browser event.
     */

    this.client.trigger('columnDragStart', {
      column,
      event
    });
  }
  /**
   * Handle drop
   * @private
   */


  onDrop({
    context,
    event
  }) {
    if (!context.valid) {
      return this.onInvalidDrop({
        context
      });
    }

    const me = this,
          {
      grid
    } = me,
          element = context.dragging,
          onHeader = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(context.target, '.b-grid-header'),
          onColumn = grid.columns.get(onHeader.dataset.column),
          toRegion = context.draggedTo.dataset.region || onColumn.region,
          sibling = context.insertBefore,
          column = grid.columns.getById(element.dataset.columnId),
          oldParent = column.parent,
          insertBefore = sibling ? grid.columns.getById(sibling.dataset.columnId) : grid.subGrids[toRegion].columns.last.nextSibling;
    let newParent;

    if (insertBefore) {
      newParent = insertBefore.parent;
    } else {
      const groupNode = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(onHeader.parentElement, '.b-grid-header');

      if (groupNode) {
        newParent = grid.columns.getById(groupNode.dataset.columnId);
      } else {
        newParent = grid.columns.rootNode;
      }
    }

    grid.headerContainer.classList.remove('b-dragging-header'); // Clean up element used during drag drop as it will not be removed by Grid when it refreshes its header elements

    element.remove(); // If dropped into its current position in the same SubGrid - abort

    let vetoed = toRegion === column.region && oldParent === newParent && (onColumn === column.previousSibling || insertBefore === column.nextSibling);
    /**
     * This event is fired when a column is dropped, and you can return false from a listener to abort the operation.
     * @event beforeColumnDropFinalize
     * @on-owner
     * @param {Grid.view.Grid} source The grid instance.
     * @param {Grid.column.Column} column The dragged column.
     * @param {Grid.column.Column} insertBefore The column before which the dragged column will be inserted.
     * @param {Grid.column.Column} newParent The new parent column.
     * @param {Event} event The browser event.
     * @preventable
     */

    vetoed = vetoed || this.client.trigger('beforeColumnDropFinalize', {
      column,
      newParent,
      insertBefore,
      event
    }) === false;

    if (!vetoed) {
      // Insert the column into its new place, which might be vetoed if column is sealed
      vetoed = !newParent.insertChild(column, insertBefore);
    }

    if (vetoed) {
      me.dragHelper.abort();
    } else {
      column.region = toRegion; // Check if we should remove last child

      if (oldParent.children.length === 0) {
        oldParent.parent.removeChild(oldParent);
      }
    }
    /**
     * This event is always fired after a column is dropped. The `valid` param is true if the operation was not
     * vetoed and the column was moved in the column store.
     * @event columnDrop
     * @on-owner
     * @param {Grid.view.Grid} source The grid instance.
     * @param {Grid.column.Column} column The dragged column.
     * @param {Grid.column.Column} insertBefore The column before which the the dragged column will be inserted.
     * @param {Grid.column.Column} newParent The new parent column.
     * @param {Boolean} valid true if the operation was not vetoed.
     * @param {Event} event The browser event.
     * @preventable
     */


    this.client.trigger('columnDrop', {
      column,
      newParent,
      insertBefore,
      valid: !vetoed,
      event
    });
  }
  /**
   * Handle invalid drop
   * @private
   */


  onInvalidDrop() {
    this.grid.headerContainer.classList.remove('b-dragging-header');
  } //endregion
  //region Render

  /**
   * Updates DragHelper with updated headers when grid contents is rerendered
   * @private
   */


  renderContents() {
    // columns shown, hidden or reordered
    this.init();
  }
  /**
   * Initializes this feature on grid paint.
   * @private
   */


  onPaint() {
    // always reinit on paint
    this.init();
  } //endregion


}
ColumnReorder.featureClass = 'b-column-reorder';
ColumnReorder._$name = 'ColumnReorder';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(ColumnReorder, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnResize.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/ColumnResize.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnResize; });
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';




/**
 * @module Grid/feature/ColumnResize
 */

/**
 * Enables user to resize columns by dragging a handle on the right hand side of the header. To get notified about column
 * resize listen to `change` event on {@link Grid.data.ColumnStore columns} store.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnResize
 * @inlineexample Grid/feature/ColumnResize.js
 * @feature
 */

class ColumnResize extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ColumnResize';
  }

  static get defaultConfig() {
    return {
      /**
       * Resize all cells below a resizing header during dragging.
       * `'auto'` means `true` on non-mobile platforms.
       * @config {String|Boolean}
       * @default
       */
      liveResize: 'auto'
    };
  } //region Init


  construct(grid, config) {
    const me = this;
    me.grid = grid;
    super.construct(grid, config);
    me.resizer = new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
      name: 'columnResize',
      targetSelector: '.b-grid-header',
      handleSelector: '.b-grid-header-resize-handle',
      outerElement: grid.element,
      listeners: {
        beforeresizestart: me.onBeforeResizeStart,
        resizestart: me.onResizeStart,
        resizing: me.onResizing,
        resize: me.onResize,
        thisObj: me
      }
    });
  } //endregion
  // This plugin needs no functions chaining into the client grid


  static get pluginConfig() {
    return [];
  }

  set liveResize(liveResize) {
    if (liveResize === 'auto') {
      liveResize = !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isMobileSafari;
    }

    this._liveResize = liveResize;
  }

  get liveResize() {
    return this._liveResize;
  }

  doDestroy() {
    this.resizer && this.resizer.destroy();
    super.doDestroy();
  } //region Events


  onBeforeResizeStart() {
    return !this.disabled;
  }

  onResizeStart({
    context
  }) {
    const {
      grid,
      resizer
    } = this,
          column = context.column = grid.columns.getById(context.element.dataset.columnId);
    resizer.minWidth = column.minWidth; // remove minWidth value as it's used as a rendering workaround for IE flexbox bugs

    context.element.style.minWidth = '';
    grid.element.classList.add('b-column-resizing');
  }
  /**
   * Handle drag event - resize the column live unless it's a touch gesture
   * @private
   */


  onResizing({
    context
  }) {
    if (context.valid && this.liveResize) {
      this.grid.resizingColumns = true;
      context.column.width = context.newWidth;
    }
  }
  /**
   * Handle drop event (only used for touch)
   * @private
   */


  onResize({
    context
  }) {
    const {
      grid
    } = this,
          {
      column
    } = context;
    grid.element.classList.remove('b-column-resizing');

    if (context.valid) {
      if (this.liveResize) {
        grid.resizingColumns = false;
        grid.afterColumnsResized();
      } else {
        column.width = context.newWidth;
      } // In case of IE 11 we should calculate flex basis to fix header width
      // covered by ColumnResize.t


      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11 && column.parent && column.parent.flex) {
        const parent = column.parent,
              headerEl = grid.getHeaderElement(parent.id);
        headerEl.style.flexBasis = parent.children.reduce((result, column) => {
          return result + grid.getHeaderElement(column.id).offsetWidth;
        }, 0) + 'px';
      }
    }
  } //endregion


}
ColumnResize._$name = 'ColumnResize';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(ColumnResize, true);

/***/ }),

/***/ "./lib/Grid/feature/ContextMenu.js":
/*!*****************************************!*\
  !*** ./lib/Grid/feature/ContextMenu.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContextMenu; });
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/MenuItem.js */ "./lib/Core/widget/MenuItem.js");
var productName = 'gantt';







/**
 * @module Grid/feature/ContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Grid.feature.CellMenu CellMenu} feature for cell context menu and
 * {@link Grid.feature.HeaderMenu HeaderMenu} feature for header context menu instead.**
 *
 * Right click to display context menu for headers and cells.
 *
 * This feature is **off** by default in favor of `CellMenu` and `HeaderMenu`.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 * @classtype contextMenu
 * @deprecated 4.0.0
 * @feature
 */

class ContextMenu extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  //region Config
  static get $name() {
    return 'ContextMenu';
  }

  static get defaultConfig() {
    return {
      /**
       * Extra items to add to the header context menu. See {@link Core.widget.MenuItem} for more info.
       *
       * ```javascript
       * features : {
       *     contextMenu : {
       *         headerItems : [
       *             { text : 'Header item', onItem : () => ... }
       *         ]
       *     }
       * }
       * ```
       *
       * @config {Object[]}
       */
      headerItems: [],

      /**
       * A function called before displaying the header menu that allows manipulations of its items. Called with a
       * single parameter with format { column, items }. Returning `false` from this function prevents
       * the menu from being shown.
       *
       * ```javascript
       * features : {
       *     contextMenu : {
       *         processHeaderItems({record, items}) {
       *             // Add or remove items here as needed
       *             if (column.field === 'age') {
       *                 items.push({ text: 'Hide youngsters', icon : 'b-fa b-fa-fw b-fa-baby' })
       *             }
       *         }
       *     }
       * }
       * ```
       *
       * @config {Function}
       */
      processHeaderItems: null,

      /**
       * Extra items to add to the cell context menu. See {@link Core.widget.MenuItem} for more info.
       *
       * ```javascript
       * features : {
       *     contextMenu : {
       *         cellItems : [
       *             { text : 'Cell item', onItem : () => ... }
       *         ]
       *     }
       * }
       * ```
       *
       * @config {Object[]}
       */
      cellItems: [],

      /**
       * A function called before displaying the cell menu that allows manipulations of its items. Called with a
       * single parameter with format { record, items }. Returning `false` from this function prevents
       * the menu from being shown.
       *
       * ```javascript
       * features : {
       *     contextMenu : {
       *         processCellItems({record, items}) {
       *             // Add or remove items here as needed
       *             if (record.age > 50) {
       *                 items.push({ text: 'Add extra vacation', icon : 'b-fa b-fa-fw b-fa-umbrella-beach' })
       *             }
       *         }
       *     }
       * }
       * ```
       *
       * @config {Function}
       */
      processCellItems: null,

      /**
       * Event which is used to show context menu.
       * Available options are: 'contextmenu', 'click', 'dblclick'.
       * Default value is used from {@link Grid/view/Grid#config-contextMenuTriggerEvent}
       * @config {String}
       */
      triggerEvent: null,
      // Private config to disable context menu for cells, raised when
      // taskContextMenu is enabled
      disableCellContextMenu: null
    };
  } //endregion
  //region Events

  /**
   * This event fires on the owning Grid before the context menu is shown for a header. Allows manipulation of the items
   * to show in the same way as in `processHeaderItems`. Returning false from a listener prevents the
   * menu from being shown.
   * @event headerContextMenuBeforeShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to headerMenuBeforeShow
   * @preventable
   * @param {Grid.view.Grid} source
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   */

  /**
   * This event fires on the owning Grid after showing the context menu for a header
   * @event headerContextMenuShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to headerMenuShow
   * @preventable
   * @param {Grid.view.Grid} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Grid.column.Column} column Column
   */

  /**
   * This event fires on the owning Grid before the context menu is shown for a cell. Allows manipulation of the items
   * to show in the same way as in `processCellItems`. Returning false from a listener prevents the
   * menu from being shown.
   * @event cellContextMenuBeforeShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to cellMenuBeforeShow
   * @preventable
   * @param {Grid.view.Grid} source
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   */

  /**
   * This event fires on the owning Grid after showing the context menu for a cell
   * @event cellContextMenuShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to cellMenuShow
   * @preventable
   * @param {Grid.view.Grid} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Grid.column.Column} column Column
   * @param {Core.data.Model} record Record
   */

  /**
   * Fired when an item is selected in the context menu.
   * @event contextMenuItem
   * @on-owner
   * @deprecated 4.0.0 Renamed to cellMenuItem and headerMenuItem
   * @param {Grid.view.Grid} grid The grid
   * @param {Object} item Selected menu item
   * @param {Grid.column.Column} column Column
   * @param {HTMLElement} itemEl Menu item element
   */

  /**
   * This event fires on the owning Grid when a check item is toggled in the context menu.
   * @event contextMenuToggleItem
   * @on-owner
   * @deprecated 4.0.0 Renamed to cellMenuToggleItem and headerMenuToggleItem
   * @param {Grid.view.Grid} grid The grid
   * @param {Object} item Selected menu item
   * @param {Grid.column.Column} column Column
   * @param {Boolean} checked Checked or not
   * @param {HTMLElement} itemEl Menu item element
   */
  //endregion
  //region Init


  construct(grid, config) {
    super.construct(grid, config);
    this.grid = grid;
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Grid', '5.0.0', '`ContextMenu` feature is deprecated, in favor of `CellMenu` and `HeaderMenu` features. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/3.1.0 for more information.'); // If this feature is enabled, need to disable CellMenu and HeaderMenu. They are mutually exclusive.

    if (grid.features.cellMenu) {
      grid.features.cellMenu.disabled = true;
    }

    if (grid.features.headerMenu) {
      grid.features.headerMenu.disabled = true;
    }
  }

  doDestroy() {
    if (this.currentMenu) {
      this.currentMenu.destroy();
    }

    super.doDestroy();
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.
  // The contextmenu event is emulated from a taphold gesture on touch platforms.


  static get pluginConfig() {
    return {
      assign: ['showContextMenu'],
      chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
    };
  } //endregion
  //region Events


  onElementContextMenu(event) {
    this.triggerEvent === 'contextmenu' && this.showContextMenu(event);
  }

  onElementClick(event) {
    this.triggerEvent === 'click' && this.showContextMenu(event);
  }

  onElementDblClick(event) {
    this.triggerEvent === 'dblclick' && this.showContextMenu(event);
  }

  onElementKeyDown(event) {
    if (!event.handled && event.target.matches('.b-grid-header.b-depth-0')) {
      switch (event.key) {
        case ' ':
        case 'ArrowDown':
          this.showContextMenu(event);
          break;
      }
    }
  }
  /**
   * Show context menu.
   * @param event
   * @on-owner
   * @private
   */


  showContextMenu(event) {
    if (!this.disabled) {
      const header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, '.b-grid-header'),
            cellData = this.grid.getCellDataFromEvent(event);

      if (header) {
        this.handleHeaderContextMenu(header, event);
      } else if (cellData && !this.disableCellContextMenu) {
        this.handleCellContextMenu(cellData, event);
      }
    }
  }

  handleHeaderContextMenu(header, event) {
    if (header.dataset.column) {
      const me = this,
            grid = me.grid,
            column = grid.columns.getById(header.dataset.columnId);

      if (column.enableHeaderContextMenu !== false) {
        const arrayOfItems = [...me.headerItems, ...(column.headerMenuItems || [])],
              namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformArrayToNamedObject(arrayOfItems),
              menu = {
          owner: me.client,
          constrainTo: document,
          cls: 'b-context-menu',
          scrollAction: 'hide',

          onItem({
            item,
            element
          }) {
            grid.trigger('contextMenuItem', {
              source: grid,
              item,
              column,
              element
            });
          },

          onToggle({
            item,
            checked,
            element
          }) {
            grid.trigger('contextMenuToggleItem', {
              source: grid,
              item,
              column,
              checked,
              element
            });
          },

          onDestroy() {
            // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
            me.currentMenu = null;
          },

          listeners: {
            show({
              source: menu
            }) {
              eventParams.menu = menu;
              grid.trigger('headerContextMenuShow', eventParams);
            }

          }
        }; // `populateHeaderMenu` is chained by mixins, thus each feature can supply items

        grid.populateHeaderMenu({
          column,
          items: namedItems,
          menu
        });
        const items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformNamedObjectToArray(namedItems),
              {
          processHeaderItems
        } = me,
              eventParams = {
          items,
          column,
          event,
          element: header
        };
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(menu, {
          items
        });

        if ((!processHeaderItems || processHeaderItems(eventParams) !== false) && items.length > 0) {
          event.preventDefault();
          items.sort((a, b) => (a.weight || 150) - (b.weight || 150)); // Trigger event that allows preventing menu or manipulating its items

          if (grid.trigger('headerContextMenuBeforeShow', eventParams) !== false) {
            // Align to header element when using arrow down key
            me.currentMenu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].showContextMenu(event.type === 'keydown' ? header : [event.clientX + 1, event.clientY + 1], menu); // Propagate the operating column down to all MenuItem levels
            // Will not override if they are preconfigured with a column.

            me.currentMenu.eachWidget(item => {
              if (!item.column && item instanceof _Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
                item.column = column;
              }
            }, true);
          }
        }
      }
    }
  }

  handleCellContextMenu(cellData, event) {
    const me = this,
          grid = me.grid,
          column = grid.columns.getById(cellData.columnId);

    if (column.enableCellContextMenu !== false) {
      // Process the gesture as navigation so that the use may select/multiselect
      // the items to include in their context menu operation.
      // Also select if not already selected.
      grid.focusCell(cellData.cellSelector, {
        doSelect: !grid.isSelected(cellData.id),
        event
      });
      const record = cellData.record,
            arrayOfItems = [...(me.cellItems || []), ...(column.cellMenuItems || [])],
            namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformArrayToNamedObject(arrayOfItems); // `populateCellMenu` is chained by mixins, thus each feature can supply items

      grid.populateCellMenu({
        column,
        record,
        items: namedItems
      });
      const items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformNamedObjectToArray(namedItems),
            {
        processCellItems
      } = me,
            cell = cellData.cellElement,
            eventParams = {
        items,
        column,
        event,
        record,
        element: cell
      },
            menu = {
        owner: me.client,
        items: items,
        // Load up the item event with the contextual info
        onBeforeItem: itemEvent => {
          Object.assign(itemEvent, eventParams);
        },

        onItem({
          item
        }) {
          grid.trigger('contextMenuItem', {
            source: grid,
            item,
            column,
            record,
            cell
          });
        },

        onClose({
          reason
        }) {
          // return focus to grid when context menu is closed, if not cause by clicking outside of grid
          if (reason !== 'outside') {
            grid.focus();
          }
        },

        onDestroy() {
          // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
          me.currentMenu = null;
        },

        listeners: {
          show({
            source: menu
          }) {
            eventParams.menu = menu;
            grid.trigger('cellContextMenuShow', eventParams);
          }

        }
      };

      if ((!processCellItems || processCellItems(eventParams) !== false) && items.length > 0) {
        items.forEach(item => {
          item.column = column;
          item.record = record;
        });
        event.preventDefault();
        items.sort((a, b) => (a.weight || 150) - (b.weight || 150)); // Trigger event that allows preventing menu or manipulating its items

        if (grid.trigger('cellContextMenuBeforeShow', eventParams) !== false) {
          me.currentMenu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].showContextMenu([event.clientX + 1, event.clientY + 1], menu);
        }
      }
    }
  }
  /**
   * Hides the context menu
   * @internal
   */


  hideContextMenu(animate) {
    var _this$currentMenu;

    (_this$currentMenu = this.currentMenu) === null || _this$currentMenu === void 0 ? void 0 : _this$currentMenu.hide(animate);
  } //endregion
  //region Getters/Setters


  get triggerEvent() {
    return this._triggerEvent || this.client.contextMenuTriggerEvent;
  }

  set triggerEvent(value) {
    this._triggerEvent = value;
  } //endregion


}
ContextMenu.featureClass = '';
ContextMenu._$name = 'ContextMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_5__["default"].registerFeature(ContextMenu);

/***/ }),

/***/ "./lib/Grid/feature/Filter.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Filter.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Filter; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt'; //TODO: Format value in header filter tooltip (see date)












/**
 * @module Grid/feature/Filter
 */

const fieldTypeMap = {
  date: 'date',
  integer: 'number',
  number: 'number',
  string: 'text',
  duration: 'duration'
};
/**
 * Feature that allows filtering of the grid by settings filters on columns. The actual filtering is done by the store.
 * For info on programmatically handling filters, see {@link Core.data.mixin.StoreFilter StoreFilter}.
 *
 * {@inlineexample Grid/feature/Filter.js}
 *
 * ```javascript
 * // Filtering turned on but no default filter
 * const grid = new Grid({
 *   features : {
 *     filter : true
 *   }
 * });
 *
 * // Using default filter
 * const grid = new Grid({
 *   features : {
 *     filter : { property : 'city', value : 'Gavle' }
 *   }
 * });
 * ```
 *
 * A column can supply a custom filtering function as its {@link Grid.column.Column#config-filterable} config. When
 * filtering by that column using the UI that function will be used to determine which records to include. See
 * {@link Grid.column.Column#config-filterable Column#filterable} for more information.
 *
 * ```javascript
 * // Custom filtering function for a column
 * const grid = new Grid({
 *    features : {
 *        filter : true
 *    },
 *
 *    columns: [
 *        {
 *          field      : 'age',
 *          text       : 'Age',
 *          type       : 'number',
 *          // Custom filtering function that checks "greater than" no matter
 *          // which field user filled in :)
 *          filterable : ({ record, value, operator }) => record.age > value
 *        }
 *    ]
 * });
 * ```
 *
 * If this feature is configured with `prioritizeColumns : true`, those functions will also be used when filtering
 * programmatically:
 *
 * ```javascript
 * const grid = new Grid({
 *    features : {
 *        filter : {
 *            prioritizeColumns : true
 *        }
 *    },
 *
 *    columns: [
 *        {
 *          field      : 'age',
 *          text       : 'Age',
 *          type       : 'number',
 *          filterable : ({ record, value, operator }) => record.age > value
 *        }
 *    ]
 * });
 *
 * // Because of the prioritizeColumns config above, any custom filterable function
 * // on a column will be used when programmatically filtering by that columns field
 * grid.store.filter({
 *     property : 'age',
 *     value    : 41
 * });
 * ```
 *
 * You can supply a field config to use for the filtering field displayed for string type columns:
 *
 * ```javascript
 * // For string-type columns you can also replace the filter UI with a custom field:
 * columns: [
 *     {
 *         field : 'city',
 *         // Filtering for a value out of a list of values
 *         filterable: {
 *             filterField : {
 *                 type  : 'combo',
 *                 items : [
 *                     'Paris',
 *                     'Dubai',
 *                     'Moscow',
 *                     'London',
 *                     'New York'
 *                 ]
 *             }
 *         }
 *     }
 * ]
 * ```
 *
 * You can also change default fields, for example this will use {@link Core.widget.DateTimeField} in filter popup:
 * ```javascript
 * columns : [
 *     {
 *         type       : 'date',
 *         field      : 'start',
 *         filterable : {
 *             filterField : {
 *                 type : 'datetime'
 *             }
 *         }
 *     }
 * ]
 * ```
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * **Note:** This feature cannot be used together with {@link Grid.feature.FilterBar FilterBar} feature, they are
 * mutually exclusive.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/filtering
 * @classtype filter
 * @feature
 */

class Filter extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  //region Init
  static get $name() {
    return 'Filter';
  }

  static get configurable() {
    return {
      /**
       * Use custom filtering functions defined on columns also when programmatically filtering by the columns
       * field.
       *
       * ```javascript
       * const grid = new Grid({
       *     columns : [
       *         {
       *             field : 'age',
       *             text : 'Age',
       *             filterable({ record, value }) {
       *               // Custom filtering, return true/false
       *             }
       *         }
       *     ],
       *
       *     features : {
       *         filter : {
       *             prioritizeColumns : true // <--
       *         }
       *     }
       * });
       *
       * // Because of the prioritizeColumns config above, any custom
       * // filterable function on a column will be used when
       * // programmatically filtering by that columns field
       * grid.store.filter({
       *     property : 'age',
       *     value    : 30
       * });
       * ```
       *
       * @config {Boolean}
       * @default
       * @category Common
       */
      prioritizeColumns: false
    };
  }

  construct(grid, config) {
    if (grid.features.filterBar) {
      throw new Error('Grid.feature.Filter feature may not be used together with Grid.feature.FilterBar. These features are mutually exclusive.');
    }

    const me = this;
    me.grid = grid;
    me.closeFilterEditor = me.closeFilterEditor.bind(me);
    super.construct(grid, config);
    me.bindStore(grid.store);

    if (config && typeof config === 'object') {
      const clone = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(config); // Feature accepts a filter config object, need to remove this config

      delete clone.prioritizeColumns;

      if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEmpty(clone)) {
        grid.store.filter(clone, null, grid.isConfiguring);
      }
    }
  }

  doDestroy() {
    var _this$filterTip, _this$filterEditorPop;

    (_this$filterTip = this.filterTip) === null || _this$filterTip === void 0 ? void 0 : _this$filterTip.destroy();
    (_this$filterEditorPop = this.filterEditorPopup) === null || _this$filterEditorPop === void 0 ? void 0 : _this$filterEditorPop.destroy();
    super.doDestroy();
  }

  get store() {
    return this.grid.store;
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      beforeFilter: 'onStoreBeforeFilter',
      filter: 'onStoreFilter',
      thisObj: this
    });
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['renderHeader', 'populateCellMenu', 'populateHeaderMenu', 'onElementClick', 'bindStore']
    };
  } //endregion
  //region Refresh headers

  /**
   * Update headers to match stores filters. Called on store load and grid header render.
   * @param reRenderRows Also refresh rows?
   * @private
   */


  refreshHeaders(reRenderRows) {
    const me = this,
          grid = me.grid,
          element = grid.headerContainer;

    if (element) {
      // remove .latest from all filters, will be applied to actual latest
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(element, '.b-filter-icon.b-latest').forEach(iconElement => iconElement.classList.remove('b-latest'));

      if (!me.filterTip) {
        me.filterTip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
          forElement: element,
          forSelector: '.b-filter-icon',

          getHtml({
            activeTarget
          }) {
            return activeTarget.dataset.filterText;
          }

        });
      }

      if (!grid.store.isFiltered) {
        me.filterTip.hide();
      }

      grid.columns.visibleColumns.forEach(column => {
        if (column.filterable !== false) {
          const columnFilter = me.store.filters.getBy('property', column.field),
                headerEl = column.element;

          if (headerEl) {
            const textEl = column.textWrapper;
            let filterIconEl = textEl === null || textEl === void 0 ? void 0 : textEl.querySelector('.b-filter-icon'),
                filterText;

            if (columnFilter) {
              let value = columnFilter.displayValue || columnFilter.value || '';

              if (column.formatValue) {
                value = column.formatValue(value);
              }

              filterText = me.L('L{filter}') + ': ' + (typeof columnFilter === 'string' ? columnFilter : `${columnFilter.operator} ${value}`);
            } else {
              filterText = me.L('L{applyFilter}');
            }

            if (!filterIconEl) {
              // putting icon in header text to have more options for positioning it
              filterIconEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
                parent: textEl,
                tag: 'div',
                className: 'b-filter-icon',
                dataset: {
                  filterText: filterText
                }
              });
            } else {
              filterIconEl.dataset.filterText = filterText;
            } // latest applied filter distinguished with class to enable highlighting etc.


            if (column.field === me.store.latestFilterField) filterIconEl.classList.add('b-latest');
            headerEl.classList.add('b-filterable');
            headerEl.classList.toggle('b-filter', Boolean(columnFilter));
          }

          column.meta.isFiltered = Boolean(columnFilter);
        }
      });

      if (reRenderRows) {
        grid.refreshRows();
      }
    }
  } //endregion
  //region Filter


  applyFilter(column, config) {
    this.store.filter(_objectSpread(_objectSpread(_objectSpread({}, column.filterable), config), {}, {
      property: column.field
    }));
  }

  removeFilter(column) {
    this.store.removeFilter(column.field);
  } // TODO: break out as own views, registering with Filter the same way columns register with ColumnManager


  getPopupDateItems(column, fieldType, filter, initialValue, store, changeCallback, closeCallback, filterField) {
    const me = this,
          onClose = changeCallback;

    function onClear() {
      me.removeFilter(column);
    }

    function onKeydown({
      event
    }) {
      if (event.key === 'Enter') {
        changeCallback();
      }
    }

    function onChange({
      source,
      value
    }) {
      if (value == null) {
        onClear();
      } else {
        me.clearSiblingsFields(source);
        me.applyFilter(column, {
          operator: source.operator,
          value,
          displayValue: source._value,
          type: 'date'
        });
      }
    }

    return [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'date',
      ref: 'on',
      placeholder: 'L{on}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
      operator: '=',
      onKeydown,
      onChange,
      onClose,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'date',
      ref: 'before',
      placeholder: 'L{before}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-before"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
      operator: '<',
      onKeydown,
      onChange,
      onClose,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'date',
      ref: 'after',
      cls: 'b-last-row',
      placeholder: 'L{after}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-after"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
      operator: '>',
      onKeydown,
      onChange,
      onClose,
      onClear
    }, filterField)];
  }

  getPopupNumberItems(column, fieldType, filter, initialValue, store, changeCallback, closeCallback, filterField) {
    const me = this,
          onEsc = changeCallback;

    function onClear() {
      me.removeFilter(column);
    }

    function onKeydown({
      event
    }) {
      if (event.key === 'Enter') {
        changeCallback();
      }
    }

    function onChange({
      source,
      value
    }) {
      if (value == null) {
        onClear();
      } else {
        me.clearSiblingsFields(source);
        me.applyFilter(column, {
          operator: source.operator,
          value
        });
      }
    }

    return [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'number',
      placeholder: 'L{Filter.equals}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
      operator: '=',
      onKeydown,
      onChange,
      onEsc,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'number',
      placeholder: 'L{lessThan}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-less"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
      operator: '<',
      onKeydown,
      onChange,
      onEsc,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'number',
      cls: 'b-last-row',
      placeholder: 'L{moreThan}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-more"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
      operator: '>',
      onKeydown,
      onChange,
      onEsc,
      onClear
    }, filterField)];
  }

  clearSiblingsFields(sourceField) {
    var _this$filterEditorPop2;

    // TODO: Store filtering allows multiple filters per field (for example age > 50 and age < 80),
    // but the Filter feature only handles a single filter per field.
    // For now, trying to add filter by age > and then for age <,
    // it should clear the previous field since that filter is replaced
    (_this$filterEditorPop2 = this.filterEditorPopup) === null || _this$filterEditorPop2 === void 0 ? void 0 : _this$filterEditorPop2.items.forEach(field => {
      field !== sourceField && (field === null || field === void 0 ? void 0 : field.clear());
    });
  }

  getPopupDurationItems(column, fieldType, filter, initialValue, store, changeCallback, closeCallback, filterField) {
    const me = this,
          onEsc = changeCallback,
          onClear = closeCallback;

    function onChange({
      source,
      value
    }) {
      if (value == null) {
        closeCallback();
      } else {
        me.applyFilter(column, {
          operator: source.operator,
          value: value
        });
        changeCallback();
      }
    }

    return [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'duration',
      placeholder: 'L{Filter.equals}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
      operator: '=',
      onChange,
      onEsc,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'duration',
      placeholder: 'L{lessThan}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-less"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
      operator: '<',
      onChange,
      onEsc,
      onClear
    }, filterField), _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: 'duration',
      cls: 'b-last-row',
      placeholder: 'L{moreThan}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-more"></i>',
      value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
      operator: '>',
      onChange,
      onEsc,
      onClear
    }, filterField)];
  }

  getPopupStringItems(column, fieldType, filter, initialValue, store, changeCallback, closeCallback, filterField) {
    const me = this;
    return [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
      type: fieldType,
      cls: 'b-last-row',
      placeholder: 'L{filter}',
      localeClass: me,
      clearable: true,
      label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
      value: filter ? filter.value || filter : initialValue,
      operator: '*',

      onChange({
        source,
        value
      }) {
        if (value === '') {
          closeCallback();
        } else {
          me.applyFilter(column, {
            operator: source.operator,
            value,
            displayValue: source.displayField && source.records ? source.records.map(rec => rec[source.displayField]).join(', ') : undefined
          }); // Leave multiselect filter combo visible to be able to select many items at once

          if (!source.multiSelect) {
            changeCallback();
          }
        }
      },

      onClose: changeCallback,
      onClear: closeCallback
    }, filterField)];
  }
  /**
   * Get fields to display in filter popup.
   * @param {Grid.column.Column} column Column
   * @param fieldType Type of field, number, date etc.
   * @param filter Current filter filter
   * @param initialValue
   * @param store Grid store
   * @param changeCallback Callback for when filter has changed
   * @param closeCallback Callback for when editor should be closed
   * @param filterField filter field
   * @returns {*}
   * @private
   */


  getPopupItems(column, fieldType, filter, initialValue, store, changeCallback, closeCallback, filterField) {
    switch (fieldType) {
      case 'date':
        return this.getPopupDateItems(...arguments);

      case 'number':
        return this.getPopupNumberItems(...arguments);

      case 'duration':
        return this.getPopupDurationItems(...arguments);

      default:
        return this.getPopupStringItems(...arguments);
    }
  }
  /**
   * Shows a popup where a filter can be edited.
   * @param {Grid.column.Column|String} column Column to show filter editor for
   * @param {*} [value] The initial value of the filter field
   */


  showFilterEditor(column, value) {
    const me = this,
          {
      store
    } = me,
          col = typeof column === 'string' ? me.grid.columns.getById(column) : column,
          headerEl = col.element,
          field = store.modelClass.fieldMap[col.field],
          filter = store.filters.getBy('property', col.field),
          type = col.filterType,
          fieldType = type ? fieldTypeMap[type] : fieldTypeMap[col.type] || field && fieldTypeMap[field.type] || 'text';

    if (col.filterable === false) {
      return;
    } // Destroy previous filter popup


    me.closeFilterEditor();
    const items = me.getPopupItems(col, fieldType, filter, value, store, me.closeFilterEditor, () => {
      me.removeFilter(col);
      me.closeFilterEditor();
    }, col.filterable.filterField); // Localize placeholders

    items.forEach(item => item.placeholder = this.L(item.placeholder));
    me.filterEditorPopup = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].openPopup(headerEl, {
      owner: me.grid,
      width: '16em',
      cls: 'b-filter-popup',
      scrollAction: 'realign',
      items
    });
  }
  /**
   * Close the filter editor.
   */


  closeFilterEditor() {
    var _this$filterEditorPop3;

    // Must defer the destroy because it may be closed by an event like a "change" event where
    // there may be plenty of code left to execute which must not execute on destroyed objects.
    (_this$filterEditorPop3 = this.filterEditorPopup) === null || _this$filterEditorPop3 === void 0 ? void 0 : _this$filterEditorPop3.setTimeout(this.filterEditorPopup.destroy);
    this.filterEditorPopup = null;
  } //endregion
  //region Context menu
  //TODO: break out together with getPopupXXItems() (see comment above)


  populateCellMenuWithDateItems({
    column,
    record,
    items
  }) {
    const property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

    if (type === 'date') {
      const me = this,
            value = record[property],
            filter = operator => {
        me.applyFilter(column, {
          operator,
          value,
          displayValue: column.formatValue ? column.formatValue(value) : value,
          type: 'date'
        });
      };

      items.filterDateEquals = {
        text: 'L{on}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-equal',
        cls: 'b-separator',
        weight: 300,
        disabled: me.disabled,
        onItem: () => filter('=')
      };
      items.filterDateBefore = {
        text: 'L{before}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-before',
        weight: 310,
        disabled: me.disabled,
        onItem: () => filter('<')
      };
      items.filterDateAfter = {
        text: 'L{after}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-after',
        weight: 320,
        disabled: me.disabled,
        onItem: () => filter('>')
      };
    }
  }

  populateCellMenuWithNumberItems({
    column,
    record,
    items
  }) {
    const property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || column.type || (field === null || field === void 0 ? void 0 : field.type);

    if (type === 'number') {
      const me = this,
            value = record[property],
            filter = operator => {
        me.applyFilter(column, {
          operator,
          value
        });
      };

      items.filterNumberEquals = {
        text: 'L{equals}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-equal',
        cls: 'b-separator',
        weight: 300,
        disabled: me.disabled,
        onItem: () => filter('=')
      };
      items.filterNumberLess = {
        text: 'L{lessThan}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-less',
        weight: 310,
        disabled: me.disabled,
        onItem: () => filter('<')
      };
      items.filterNumberMore = {
        text: 'L{moreThan}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-more',
        weight: 320,
        disabled: me.disabled,
        onItem: () => filter('>')
      };
    }
  }

  populateCellMenuWithDurationItems({
    column,
    record,
    items
  }) {
    const property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

    if (type === 'duration') {
      const me = this,
            value = record[property],
            filter = operator => {
        me.applyFilter(column, {
          operator,
          value
        });
      };

      items.filterDurationEquals = {
        text: 'L{equals}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-equal',
        cls: 'b-separator',
        weight: 300,
        disabled: me.disabled,
        onItem: () => filter('=')
      };
      items.filterDurationLess = {
        text: 'L{lessThan}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-less',
        weight: 310,
        disabled: me.disabled,
        onItem: () => filter('<')
      };
      items.filterDurationMore = {
        text: 'L{moreThan}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-more',
        weight: 320,
        disabled: me.disabled,
        onItem: () => filter('>')
      };
    }
  }

  populateCellMenuWithStringItems({
    column,
    record,
    items
  }) {
    const property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

    if (!/(date|number|duration)/.test(type)) {
      var _column$filterable$fi, _column$filterable$fi2;

      const me = this,
            value = column.getFilterableValue(record),
            operator = (_column$filterable$fi = (_column$filterable$fi2 = column.filterable.filterField) === null || _column$filterable$fi2 === void 0 ? void 0 : _column$filterable$fi2.operator) !== null && _column$filterable$fi !== void 0 ? _column$filterable$fi : '*';
      items.filterStringEquals = {
        text: 'L{equals}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-filter-equal',
        cls: 'b-separator',
        weight: 300,
        disabled: me.disabled,
        onItem: () => me.applyFilter(column, {
          value,
          operator
        })
      };
    }
  }
  /**
   * Add menu items for filtering.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Core.data.Model} options.record Record for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateCellMenu({
    column,
    record,
    items
  }) {
    const me = this;

    if (column.filterable !== false) {
      me.populateCellMenuWithDateItems(...arguments);
      me.populateCellMenuWithNumberItems(...arguments);
      me.populateCellMenuWithDurationItems(...arguments);
      me.populateCellMenuWithStringItems(...arguments);

      if (column.meta.isFiltered) {
        items.filterRemove = {
          text: 'L{removeFilter}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-clear',
          cls: 'b-separator',
          weight: 400,
          disabled: me.disabled,
          onItem: () => me.removeFilter(column)
        };
      }
    }
  }
  /**
   * Add menu item for removing filter if column is filtered.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @returns {Object} items Menu items config
   * @internal
   */


  populateHeaderMenu({
    column,
    items
  }) {
    const me = this;

    if (column.meta.isFiltered) {
      items.editFilter = {
        text: 'L{editFilter}',
        localeClass: me,
        weight: 100,
        icon: 'b-fw-icon b-icon-filter',
        cls: 'b-separator',
        disabled: me.disabled,
        onItem: () => me.showFilterEditor(column)
      };
      items.removeFilter = {
        text: 'L{removeFilter}',
        localeClass: me,
        weight: 110,
        icon: 'b-fw-icon b-icon-remove',
        disabled: me.disabled,
        onItem: () => me.removeFilter(column)
      };
    } else if (column.filterable !== false) {
      items.filter = {
        text: 'L{filter}',
        localeClass: me,
        weight: 100,
        icon: 'b-fw-icon b-icon-filter',
        cls: 'b-separator',
        disabled: me.disabled,
        onItem: () => me.showFilterEditor(column)
      };
    }
  } //endregion
  //region Events
  // Intercept filtering by a column that has a custom filtering fn, and inject that fn


  onStoreBeforeFilter({
    filters
  }) {
    const {
      columns
    } = this.client;

    for (let i = 0; i < filters.count; i++) {
      var _column$filterable;

      const filter = filters.getAt(i),
            column = (filter.columnOwned || this.prioritizeColumns) && columns.get(filter.property);

      if (column !== null && column !== void 0 && (_column$filterable = column.filterable) !== null && _column$filterable !== void 0 && _column$filterable.filterFn) {
        // Cache CollectionFilter on the column to not have to recreate on each filter operation
        if (!column.$filter) {
          column.$filter = new _Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
            columnOwned: true,
            property: filter.property,
            operator: filter.operator,
            value: filter.value,

            filterBy(record) {
              return column.filterable.filterFn({
                value: this.value,
                record,
                operator: this.operator,
                property: this.property,
                column
              });
            }

          });
        } // Update value and operator used by filters filtering fn


        column.$filter.value = filter.value;
        column.$filter.displayValue = filter.displayValue;
        column.$filter.operator = filter.operator;
        filters.splice(i, 1, column.$filter);
      }
    }
  }
  /**
   * Store filtered; refresh headers.
   * @private
   */


  onStoreFilter() {
    // Pass false to not refresh rows.
    // Store's refresh event will refresh the rows.
    this.refreshHeaders(false);
  }
  /**
   * Called after headers are rendered, make headers match stores initial sorters
   * @private
   */


  renderHeader() {
    this.refreshHeaders(false);
  }
  /**
   * Called when user clicks on the grid. Only care about clicks on the filter icon.
   * @param {MouseEvent} event
   * @private
   */


  onElementClick(event) {
    const target = event.target;

    if (this.filterEditorPopup) {
      this.closeFilterEditor();
    } // Checks if click is on node expander icon, then toggles expand/collapse


    if (target.classList.contains('b-filter-icon')) {
      const headerEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(target, '.b-grid-header');
      this.showFilterEditor(headerEl.dataset.columnId);
      return false;
    }
  } //endregion


}
Filter._$name = 'Filter';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(Filter);

/***/ }),

/***/ "./lib/Grid/feature/FilterBar.js":
/*!***************************************!*\
  !*** ./lib/Grid/feature/FilterBar.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterBar; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
/* eslint-disable no-unused-expressions */










/**
 * @module Grid/feature/FilterBar
 */

/**
 * Feature that allows filtering of the grid by entering filters on column headers.
 * The actual filtering is done by the store.
 * For info on programmatically handling filters, see {@link Core.data.mixin.StoreFilter StoreFilter}.
 *
 * {@inlineexample Grid/feature/FilterBar.js}
 *
 * ```javascript
 * // filtering turned on but no initial filter
 * const grid = new Grid({
 *   features: {
 *     filterBar : true
 *   }
 * });
 *
 * // using initial filter
 * const grid = new Grid({
 *   features : {
 *     filterBar : { filter: { property : 'city', value : 'Gavle' } }
 *   }
 * });
 * ```
 *
 * ## Enabling filtering for a column
 * The individual filterability of columns is defined by a `filterable` property on the column which defaults to `true`.
 * If `false`, that column is not filterable. Note: If you have multiple columns configured with the same `field` value,
 * assign an {@link Core.data.Model#field-id} to the columns to ensure filters work correctly.
 *
 * The property value may also be a custom filter function.
 *
 * The property value may also be an object which may contain the following two properties:
 *  - **filterFn** : `Function` A custom filtering function
 *  - **filterField** : `Object` A config object for the filter value input field. See {@link Core.widget.TextField} or
 *  the other field widgets for reference.
 *
 * ```javascript
 * // Custom filtering function for a column
 * const grid = new Grid({
 *   features : {
 *     filterBar : true
 *   },
 *
 *   columns: [
 *      {
 *        field      : 'age',
 *        text       : 'Age',
 *        type       : 'number',
 *        // Custom filtering function that checks "greater than"
 *        filterable : ({ record, value }) => record.age > value
 *      },
 *      {
 *        field : 'name',
 *        // Filterable may specify a filterFn and a config for the filtering input field
 *        filterable : {
 *          filterFn : ({ record, value }) => record.name.toLowerCase().indexOf(value.toLowerCase()) !== -1,
 *          filterField : {
 *            emptyText : 'Filter name'
 *          }
 *        }
 *      },
 *      {
 *        field : 'city',
 *        text : 'Visited',
 *        flex : 1,
 *        // Filterable with multiselect combo to pick several items to filter
 *        filterable : {
 *          filterField : {
 *            type        : 'combo',
 *            multiSelect : true,
 *            items       : ['Barcelona', 'Moscow', 'Stockholm']
 *          }
 *        }
 *      }
 *   ]
 * });
 * ```
 *
 * If this feature is configured with `prioritizeColumns : true`, those functions will also be used when filtering
 * programmatically:
 *
 * ```javascript
 * const grid = new Grid({
 *    features : {
 *        filterBar : {
 *            prioritizeColumns : true
 *        }
 *    },
 *
 *    columns: [
 *        {
 *          field      : 'age',
 *          text       : 'Age',
 *          type       : 'number',
 *          // Custom filtering function that checks "greater than" no matter
 *          // which field user filled in :)
 *          filterable : ({ record, value, operator }) => record.age > value
 *        }
 *    ]
 * });
 *
 * // Will be used when filtering programmatically or using the UI
 * grid.store.filter({
 *     property : 'age',
 *     value    : 41
 * });
 * ```
 *
 * ## Filtering using a multiselect combo
 *
 * To filter the grid by choosing values which should match with the store data, use a {@link Core.widget.Combo}, and configure
 * your grid like so:
 *
 * ```javascript
 * const grid = new Grid({
 *    features : {
 *        filterBar : true
 *    },
 *
 *    columns : [
 *        {
 *            id         : 'name',
 *            field      : 'name',
 *            text       : 'Name',
 *            filterable : {
 *                filterField : {
 *                    type         : 'combo',
 *                    multiSelect  : true,
 *                    valueField   : 'name',
 *                    displayField : 'name'
 *                }
 *            }
 *        }
 *    ]
 * });
 * ```
 *
 * You can also filter the {@link Core.widget.Combo} values, for example to filter out empty values. Example:
 *
 * ```javascript
 * const grid = new Grid({
 *    features : {
 *        filterBar : true
 *    },
 *
 *    columns : [
 *        {
 *            text       : 'Airline',
 *            field      : 'airline',
 *            flex       : 1,
 *            filterable : {
 *                filterField : {
 *                    type         : 'combo',
 *                    multiSelect  : true,
 *                    valueField   : 'airline',
 *                    displayField : 'airline',
 *                    store        : {
 *                        filters : {
 *                            // Filter out empty values
 *                            filterBy : record => !!record.airline
 *                        }
 *                    }
 *                }
 *            }
 *        }
 *    ]
 * });
 * ```
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * **Note:** This feature cannot be used together with {@link Grid.feature.Filter filter} feature, they are mutually
 * exclusive.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/filterbar
 * @classtype filterBar
 * @feature
 */

class FilterBar extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'FilterBar';
  }

  static get configurable() {
    return {
      /**
       * Use custom filtering functions defined on columns also when programmatically filtering by the columns
       * field.
       *
       * ```javascript
       * const grid = new Grid({
       *     columns : [
       *         {
       *             field : 'age',
       *             text : 'Age',
       *             filterable({ record, value }) {
       *               // Custom filtering, return true/false
       *             }
       *         }
       *     ],
       *
       *     features : {
       *         filterBar : {
       *             prioritizeColumns : true // <--
       *         }
       *     }
       * });
       *
       * // Because of the prioritizeColumns config above, any custom
       * // filterable function on a column will be used when
       * // programmatically filtering by that columns field
       * grid.store.filter({
       *     property : 'age',
       *     value    : 30
       * });
       * ```
       *
       * @config {Boolean}
       * @default
       * @category Common
       */
      prioritizeColumns: false,

      /**
       * The delay in milliseconds to wait after the last keystroke before applying filters.
       * Set to 0 to not trigger filtering from keystrokes, requires pressing ENTER instead
       * @config {Number}
       * @default
       * @category Common
       */
      keyStrokeFilterDelay: 300,

      /**
       * Toggle compact mode. In this mode the filtering fields are styled to transparently overlay the headers,
       * occupying no additional space.
       * @member {Boolean} compactMode
       * @category Common
       */

      /**
       * Specify `true` to enable compact mode for the filter bar. In this mode the filtering fields are styled
       * to transparently overlay the headers, occupying no additional space.
       * @config {Boolean}
       * @default
       * @category Common
       */
      compactMode: false,
      // Destroying data level filters when we hiding UI is supposed to be optional someday. So far this flag is private
      clearStoreFiltersOnHide: true
    };
  }

  static get pluginConfig() {
    return {
      before: ['onElementKeyDown', 'renderContents'],
      chain: ['afterColumnsChange', 'renderHeader', 'populateHeaderMenu', 'bindStore']
    };
  }

  static get properties() {
    return {
      filterFieldCls: 'b-filter-bar-field',
      filterFieldInputCls: 'b-filter-bar-field-input',
      filterableColumnCls: 'b-filter-bar-enabled',
      filterFieldInputSelector: '.b-filter-bar-field-input',
      filterableColumnSelector: '.b-filter-bar-enabled',
      filterParseRegExp: /^\s*([<>=*])?(.*)$/,
      storeTrackingSuspended: 0
    };
  } //endregion
  //region Init


  construct(grid, config) {
    if (grid.features.filter) {
      throw new Error('Grid.feature.FilterBar feature may not be used together with Grid.feature.Filter, These features are mutually exclusive.');
    }

    const me = this;
    me.grid = grid;
    me.onColumnFilterFieldChange = me.onColumnFilterFieldChange.bind(me);
    super.construct(grid, Array.isArray(config) ? {
      filter: config
    } : config);
    me.bindStore(grid.store);

    if (me.filter) {
      const initialFilters = Array.isArray(me.filter) ? me.filter : [me.filter];
      initialFilters.forEach(config => {
        if (!config.id && config.property) {
          const column = grid.columns.findByField('field', config.property);

          if (column) {
            config.id = column.field;
          }
        }
      }); // assign ids to filter to be able to update them correctly

      grid.store.filter(me.filter);
    }

    me.gridDetacher = grid.on('beforeelementclick', me.onBeforeElementClick, me);
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      beforeFilter: 'onStoreBeforeFilter',
      filter: 'onStoreFilter',
      thisObj: this
    });
  }

  doDestroy() {
    var _this$gridDetacher;

    this.destroyFilterBar();
    (_this$gridDetacher = this.gridDetacher) === null || _this$gridDetacher === void 0 ? void 0 : _this$gridDetacher.call(this);
    super.doDestroy();
  }

  doDisable(disable) {
    const {
      columns
    } = this.grid; // Disable the fields

    columns === null || columns === void 0 ? void 0 : columns.forEach(column => {
      const widget = this.getColumnFilterField(column);

      if (widget) {
        widget.disabled = disable;
      }
    });
    super.doDisable(disable);
  }

  updateCompactMode(value) {
    this.client.headerContainer.classList[value ? 'add' : 'remove']('b-filter-bar-compact');

    for (const prop in this._columnFilters) {
      const field = this._columnFilters[prop];
      field.placeholder = value ? field.column.headerText : null;
    }
  } //endregion
  //region FilterBar


  destroyFilterBar() {
    var _this$grid$columns;

    (_this$grid$columns = this.grid.columns) === null || _this$grid$columns === void 0 ? void 0 : _this$grid$columns.forEach(this.destroyColumnFilterField, this);
  }
  /**
   * Hides the filtering fields.
   */


  hideFilterBar() {
    var _me$grid$columns;

    const me = this; // We don't want to hear back store "filter" event while we're resetting store filters

    me.clearStoreFiltersOnHide && me.suspendStoreTracking(); // Hide the fields, each silently - no updating of the store's filtered state until the end

    (_me$grid$columns = me.grid.columns) === null || _me$grid$columns === void 0 ? void 0 : _me$grid$columns.forEach(col => me.hideColumnFilterField(col, true)); // Now update the filtered state

    me.grid.store.filter();
    me.clearStoreFiltersOnHide && me.resumeStoreTracking();
    me.hidden = true;
  }
  /**
   * Shows the filtering fields.
   */


  showFilterBar() {
    this.renderFilterBar();
    this.hidden = false;
  }
  /**
   * Toggles the filtering fields visibility.
   */


  toggleFilterBar() {
    if (this.hidden) {
      this.showFilterBar();
    } else {
      this.hideFilterBar();
    }
  }
  /**
   * Renders the filtering fields for filterable columns.
   * @private
   */


  renderFilterBar() {
    this.grid.columns.visibleColumns.forEach(column => this.renderColumnFilterField(column));
    this.rendered = true;
  } //endregion
  //region FilterBar fields

  /**
   * Renders text field filter in the provided column header.
   * @param {Grid.column.Column} column Column to render text field filter for.
   * @private
   */


  renderColumnFilterField(column) {
    const me = this,
          {
      grid
    } = me,
          filterable = me.getColumnFilterable(column); // we render fields for filterable columns only

    if (filterable && column.isVisible) {
      const headerEl = column.element,
            filter = grid.store.filters.get(column.id) || grid.store.filters.getBy('property', column.field);
      let widget = me.getColumnFilterField(column); // if we don't haven't created a field yet
      // we build it from scratch

      if (!widget) {
        var _filterable$filterFie;

        const type = `${column.filterType || 'text'}field`,
              externalCls = (_filterable$filterFie = filterable.filterField) === null || _filterable$filterFie === void 0 ? void 0 : _filterable$filterFie.cls;

        if (externalCls) {
          delete filterable.filterField.cls;
        }

        widget = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].append(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
          type,
          cls: {
            [me.filterFieldCls]: 1,
            [externalCls]: externalCls
          },
          // Simplifies debugging / testing
          dataset: {
            column: column.field
          },
          column,
          owner: grid,
          clearable: true,
          name: column.field,
          value: filter && !filter._filterBy && me.buildFilterValue(filter),
          inputCls: me.filterFieldInputCls,
          keyStrokeChangeDelay: me.keyStrokeFilterDelay,
          onChange: me.onColumnFilterFieldChange,
          onClear: me.onColumnFilterFieldChange,
          disabled: me.disabled,
          placeholder: me.compactMode ? column.headerText : null,
          // Also copy formats, DateColumn, TimeColumn etc
          format: column.format
        }, filterable.filterField), headerEl)[0]; // Avoid DomSync cleaning up this widget as it syncs column headers

        widget.element.retainElement = true;
        me.setColumnFilterField(column, widget); // If no data is provided, load values lazily from the grid store upon showing the picker list

        if (widget.isCombo && !widget.store.count) {
          const configuredValue = widget.value,
                refreshData = () => widget.store.data = grid.store.getDistinctValues(column.field, true).map(value => grid.store.modelClass.new({
            [column.field]: value
          }));

          widget.value = null;

          if (!widget.store.isSorted) {
            widget.store.sort({
              field: column.field,
              ascending: true
            });
          }

          widget.picker.on('beforeShow', refreshData);
          refreshData();
          widget.value = configuredValue;
        } // If no initial filter exists but a value was provided to the widget, filter by it


        if (!me.filter && widget.value) {
          me.onColumnFilterFieldChange({
            source: widget,
            value: widget.value
          });
        }
      } // if we have one..
      else {
        // re-apply widget filter
        me.onColumnFilterFieldChange({
          source: widget,
          value: widget.value
        }); // re-append the widget to its parent node (in case the column header was redrawn (happens when resizing columns))

        widget.render(headerEl); // show widget in case it was hidden

        widget.show();
      }

      headerEl.classList.add(me.filterableColumnCls);
    }
  }
  /**
   * Fills in column filter fields with values from the grid store filters.
   * @private
   */


  updateColumnFilterFields() {
    const me = this,
          {
      columns,
      store
    } = me.grid;
    let field, filter; // During this phase we should not respond to field change events.
    // See onColumnFilterFieldChange.

    me._updatingFields = true;

    for (const column of columns.visibleColumns) {
      field = me.getColumnFilterField(column);

      if (field) {
        filter = store.filters.get(column.id) || store.filters.getBy('property', column.field);

        if (filter) {
          // For filtering functions we keep what user typed into the field, we cannot construct a filter
          // string from them
          if (!filter._filterBy) {
            field.value = me.buildFilterValue(filter);
          } else {
            field.value = filter.value;
          }
        } // No filter, clear field
        else {
          field.value = '';
        }
      }
    }

    me._updatingFields = false;
  }

  getColumnFilterable(column) {
    if (!column.isRoot && column.filterable !== false && column.field && column.isLeaf) {
      if (typeof column.filterable === 'function') {
        column.filterable = {
          filterFn: column.filterable
        };
      }

      return column.filterable;
    }
  }

  destroyColumnFilterField(column) {
    const widget = this.getColumnFilterField(column);

    if (widget) {
      this.hideColumnFilterField(column, true); // destroy filter UI field

      widget.destroy(); // remember there is no field bound anymore

      this.setColumnFilterField(column, undefined);
    }
  }

  hideColumnFilterField(column, silent) {
    const me = this,
          {
      store
    } = me.grid,
          columnEl = column.element,
          widget = me.getColumnFilterField(column);

    if (widget) {
      if (!me.isDestroying) {
        // hide field
        widget.hide();
      }

      if (!store.isDestroyed && me.clearStoreFiltersOnHide && column.field) {
        store.removeFilter(column.id, silent);
      }

      columnEl === null || columnEl === void 0 ? void 0 : columnEl.classList.remove(me.filterableColumnCls);
    }
  }
  /**
   * Returns column filter field instance.
   * @param {Grid.column.Column} column Column to get filter field for.
   * @returns {Core.widget.Widget}
   */


  getColumnFilterField(column) {
    var _this$_columnFilters;

    return (_this$_columnFilters = this._columnFilters) === null || _this$_columnFilters === void 0 ? void 0 : _this$_columnFilters[column.id];
  }

  setColumnFilterField(column, widget) {
    this._columnFilters = this._columnFilters || {};
    this._columnFilters[column.data.id] = widget;
  } //endregion
  //region Filters


  parseFilterValue(value) {
    if (Array.isArray(value)) {
      return {
        value
      };
    }

    const match = String(value).match(this.filterParseRegExp);
    return {
      operator: match[1] || '*',
      value: match[2]
    };
  }

  buildFilterValue(filter) {
    return filter.value instanceof Date || Array.isArray(filter.value) ? filter.value : (filter.operator === '*' || filter.operator === 'isIncludedIn' ? '' : filter.operator) + filter.value;
  } //endregion
  // region Events
  // Intercept filtering by a column that has a custom filtering fn, and inject that fn


  onStoreBeforeFilter({
    filters
  }) {
    const {
      columns
    } = this.client;

    for (let i = 0; i < filters.count; i++) {
      var _column$filterable;

      const filter = filters.getAt(i),
            column = (filter.columnOwned || this.prioritizeColumns) && (filter.id && columns.getById(filter.id) || columns.get(filter.property));

      if ((_column$filterable = column.filterable) !== null && _column$filterable !== void 0 && _column$filterable.filterFn) {
        // Cache CollectionFilter on the column to not have to recreate on each filter operation
        if (!column.$filter) {
          column.$filter = new _Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
            columnOwned: true,
            property: filter.property,
            id: column.id,

            filterBy(record) {
              return column.filterable.filterFn({
                value: this.value,
                record,
                property: this.property,
                column
              });
            }

          });
        } // Update value used by filters filtering fn


        column.$filter.value = filter.value;
        filters.splice(i, 1, column.$filter);
      }
    }
  }
  /**
   * Fires when store gets filtered. Refreshes field values in column headers.
   * @private
   */


  onStoreFilter() {
    if (!this.storeTrackingSuspended && this.rendered) {
      this.updateColumnFilterFields();
    }
  }

  afterColumnsChange({
    changes,
    column
  }) {
    // Ignore if columns change while this filter bar is hidden, or if column changeset does not include hidden
    // state
    if (!this.hidden && changes !== null && changes !== void 0 && changes.hidden) {
      const hidden = changes.hidden.value;

      if (hidden) {
        this.destroyColumnFilterField(column);
      } else {
        this.renderColumnFilterField(column);
      }
    }
  }

  suspendStoreTracking() {
    this.storeTrackingSuspended++;
  }

  resumeStoreTracking() {
    this.storeTrackingSuspended--;
  }
  /**
   * Called after headers are rendered, make headers match stores initial sorters
   * @private
   */


  renderHeader() {
    if (!this.hidden) {
      this.renderFilterBar();
    }
  }

  renderContents() {
    // Grid suspends events when restoring state, thus we are not informed about toggled columns and might end up
    // with wrong fields in headers. To prevent that, we remove all field elements here since they are restored in
    // renderColumnFilterField() later anyway
    for (const field of Object.values(this._columnFilters)) {
      field === null || field === void 0 ? void 0 : field.element.remove();
    }
  }

  onElementKeyDown(event) {
    // flagging event with handled = true used to signal that other features should probably not care about it
    if (event.handled) {
      return;
    } // if we are pressing left/right arrow keys while being in a filter editor
    // we set event.handled flag (otherwise other features prevent the event)


    if (event.target.matches(this.filterFieldInputSelector)) {
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowRight':
          event.handled = true;
      }
    }
  }

  onBeforeElementClick({
    event
  }) {
    // prevent other features reacting when clicking a filter field (or any element inside it)
    if (event.target.closest(`.${this.filterFieldCls}`)) {
      return false;
    }
  }
  /**
   * Called when a column text filter field value is changed by user.
   * @param  {Core.widget.TextField} field Filter text field.
   * @param  {String} value New filtering value.
   * @private
   */


  onColumnFilterFieldChange({
    source: field,
    value
  }) {
    const me = this,
          {
      store
    } = me.grid; // Don't respond if we set the value in response to a filter

    if (me._updatingFields) {
      return;
    } // we don't want to hear back store "filter" event
    // so we suspend store tracking


    me.suspendStoreTracking();
    const isClearingFilter = value == null || value === '' || Array.isArray(value) && value.length === 0;

    if (!store.removeFilter(field.column.id, !isClearingFilter)) {
      var _store$filters$get;

      // Fall back to removing it using field name, in case it was added on the store directly
      if (((_store$filters$get = store.filters.get(field.name)) === null || _store$filters$get === void 0 ? void 0 : _store$filters$get.columnOwned) !== true) {
        store.removeFilter(field.name, !isClearingFilter);
      }
    }

    if (!isClearingFilter) {
      store.filter(_objectSpread({
        columnOwned: true,
        property: field.name,
        id: field.column.id
      }, me.parseFilterValue(value)));
    }

    me.resumeStoreTracking();
  } //endregion
  //region Menu items

  /**
   * Adds a menu item to toggle filter bar visibility.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    items
  }) {
    items.toggleFilterBar = {
      text: this.hidden ? 'L{enableFilterBar}' : 'L{disableFilterBar}',
      localeClass: this,
      weight: 120,
      icon: 'b-fw-icon b-icon-filter',
      cls: 'b-separator',
      onItem: () => this.toggleFilterBar()
    };
  } //endregion


}
FilterBar.featureClass = 'b-filter-bar';
FilterBar._$name = 'FilterBar';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(FilterBar);

/***/ }),

/***/ "./lib/Grid/feature/GridFeatureManager.js":
/*!************************************************!*\
  !*** ./lib/Grid/feature/GridFeatureManager.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridFeatureManager; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';

/**
 * @module Grid/feature/GridFeatureManager
 */

const consumerToFeatureMap = new Map(),
      consumerToDefaultFeatureMap = new Map(),
      DEFAULT_FOR_TYPE = 'Grid',
      remapToBase = {
  Grid: 'GridBase',
  Scheduler: 'SchedulerBase',
  SchedulerPro: 'SchedulerProBase',
  Gantt: 'GanttBase'
},
      classNameFix = /\$\d+$/;
/**
 * Static class intended to register and query grid features
 *
 * @class
 */

class GridFeatureManager {
  /**
   * Register a feature class with the Grid. Enables it to be created and configured using config Grid#features.
   * @param {Function} featureClass The feature class constructor to register
   * @param {Boolean} [onByDefault] Specify true to have the feature enabled per default
   * @param {String|String[]} [forType] Specify a type to let the class applying the feature to determine if it should use it
   */
  static registerFeature(featureClass, onByDefault = false, forType = null, as = null) {
    // Our built in features should all define $name to survive minification/obfuscation, but user defined features might not
    as = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].uncapitalize(as || Object.prototype.hasOwnProperty.call(featureClass, '$name') && featureClass.$$name || featureClass.name); // Remove webpack's disambiguation suffix.
    // For example ExcelExporter in Scheduler will be called ExcelExporter$1
    // It must be found as ExcelExporter in the Scheduler's feature Map, so correct the name.

    as = as.replace(classNameFix, '');

    if (!Array.isArray(forType)) {
      forType = [forType || DEFAULT_FOR_TYPE];
    }

    forType.forEach(forType => {
      const type = remapToBase[forType] || forType,
            consumerFeaturesMap = consumerToFeatureMap.get(type) || new Map(),
            consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type) || new Map();
      consumerFeaturesMap.set(as, featureClass);
      consumerDefaultFeaturesMap.set(featureClass, onByDefault);
      consumerToFeatureMap.set(type, consumerFeaturesMap);
      consumerToDefaultFeatureMap.set(type, consumerDefaultFeaturesMap);
    });
  }
  /**
   * Get all the features registered for the given type name in an object where keys are feature names and values are feature constructors.
   *
   * @param {String} [forType]
   * @return {Object}
   */


  static getTypeNameFeatures(forType = DEFAULT_FOR_TYPE) {
    const type = remapToBase[forType] || forType,
          consumerFeaturesMap = consumerToFeatureMap.get(type),
          features = {};

    if (consumerFeaturesMap) {
      consumerFeaturesMap.forEach((featureClass, as) => features[as] = featureClass);
    }

    return features;
  }
  /**
   * Get all the default features registered for the given type name in an object where keys are feature names and values are feature constructors.
   *
   * @param {String} [forType]
   * @return {Object}
   */


  static getTypeNameDefaultFeatures(forType = DEFAULT_FOR_TYPE) {
    const type = remapToBase[forType] || forType,
          consumerFeaturesMap = consumerToFeatureMap.get(type),
          consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type);
    const features = {};

    if (consumerFeaturesMap && consumerDefaultFeaturesMap) {
      consumerFeaturesMap.forEach((featureClass, as) => {
        if (consumerDefaultFeaturesMap.get(featureClass)) {
          features[as] = featureClass;
        }
      });
    }

    return features;
  }
  /**
   * Gets all the features registered for the given instance type name chain. First builds the type name chain then queries for features
   * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
   * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
   *
   * @param {Object} instance
   * @return {Object}
   */


  static getInstanceFeatures(instance) {
    return instance.$meta.names.reduce((features, typeName) => Object.assign(features, this.getTypeNameFeatures(typeName)), {});
  }
  /**
   * Gets all the *default* features registered for the given instance type name chain. First builds the type name chain then queries for features
   * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
   * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
   *
   * @param {Object} instance
   * @return {Object}
   */


  static getInstanceDefaultFeatures(instance) {
    return instance.$meta.names.reduce((features, typeName) => Object.entries(this.getTypeNameFeatures(typeName)).reduce((features, [as, featureClass]) => {
      if (this.isDefaultFeatureForTypeName(featureClass, typeName)) {
        features[as] = featureClass;
      } else {
        delete features[as];
      }

      return features;
    }, features), {});
  }
  /**
   * Checks if the given feature class is default for the type name
   *
   * @param {Core.mixin.InstancePlugin} featureClass Feature to check
   * @param {String} [forType]
   * @return {Boolean}
   */


  static isDefaultFeatureForTypeName(featureClass, forType = DEFAULT_FOR_TYPE) {
    const type = remapToBase[forType] || forType,
          consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type);
    return consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.get(featureClass) || false;
  }
  /**
   * Checks if the given feature class is default for the given instance type name chain. If the feature is not default for the
   * parent type name but it is for the child type name, then the child setting overrides the parent one.
   *
   * @param {Core.mixin.InstancePlugin} featureClass Feature to check
   * @param {String} [forType]
   * @return {Boolean}
   */


  static isDefaultFeatureForInstance(featureClass, instance) {
    //const typeChain = ObjectHelper.getTypeNameChain(instance);
    const typeChain = instance.$meta.names.slice().reverse();
    let result = null;

    for (let i = 0, len = typeChain.length; i < len && result === null; ++i) {
      const consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(typeChain[i]);

      if (consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.has(featureClass)) {
        result = consumerDefaultFeaturesMap.get(featureClass);
      }
    }

    return result || false;
  }
  /**
   * Resets feature registration date, used in tests to reset state after test
   *
   * @internal
   */


  static reset() {
    consumerToFeatureMap.clear();
    consumerToDefaultFeatureMap.clear();
  }

}
GridFeatureManager._$name = 'GridFeatureManager';

/***/ }),

/***/ "./lib/Grid/feature/Group.js":
/*!***********************************!*\
  !*** ./lib/Grid/feature/Group.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Group; });
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt'; //TODO: Expand function?
//TODO: Collapse function?
//TODO: Sorting breaks grouping if some groups are collapsed
//TODO: Grouping via context menu doesn't work







/**
 * @module Grid/feature/Group
 */

/**
 * Enables rendering and handling of row groups. The actual grouping is done in the store, but triggered by [shift] +
 * clicking headers or by using two finger tap (one on header, one anywhere on grid). Groups can be expanded/collapsed
 * by clicking on the group row or pressing [space] when group row is selected.
 * The actual grouping is done by the store, see {@link Core.data.mixin.StoreGroup#function-group}.
 *
 * Grouping by a field performs sorting by the field automatically. It's not possible to prevent sorting.
 * If you group, the records have to be sorted so that records in a group stick together. You can either control sorting
 * direction, or provide a custom sorting function called {@link #config-groupSortFn} to your feature config object.
 *
 * For info on programmatically handling grouping, see {@link Core.data.mixin.StoreGroup StoreGroup}.
 *
 * Currently grouping is not supported when using pagination, the underlying store cannot group data that is split into pages.
 *
 * **Note:** Custom height for group header rows cannot be set with CSS, should instead be defined in a renderer function using the `size` param. See the {@link #config-renderer} config for details.
 *
 * This feature is **enabled** by default.
 *
 * @example
 * // grouping feature is enabled, no default value though
 * let grid = new Grid({
 *     features : {
 *         group : true
 *     }
 * });
 *
 * // use initial grouping
 * let grid = new Grid({
 *     features : {
 *         group : 'city'
 *     }
 * });
 *
 * // default grouper and custom renderer, which will be applied to each cell except the "group" cell
 * let grid = new Grid({
 *   features : {
 *     group : {
 *       field : 'city',
 *       ascending : false,
 *       renderer : ({ isFirstColumn, count, groupRowFor, record }) => isFirstColumn ? `${groupRowFor} (${count})` : ''
 *     }
 *   }
 * });
 *
 * // group using custom sort function
 * let grid = new Grid({
 *     features : {
 *         group       : {
 *             field       : 'city',
 *             groupSortFn : (a, b) => a.city.length < b.city.length ? -1 : 1
 *         }
 *     }
 * });
 *
 * // can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         groupers : [
 *             { field : 'city', ascending : false }
 *         ]
 *     }
 * });
 *
 * // custom sorting function can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         groupers : [{
 *             field : 'city',
 *             fn : (recordA, recordB) => {
 *                 // apply custom logic, for example:
 *                 return recordA.city.length < recordB.city.length ? -1 : 1;
 *             }
 *         }]
 *     }
 * });
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/grouping
 * @classtype group
 * @feature
 *
 * @inlineexample Grid/feature/Group.js
 */

class Group extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  static get $name() {
    return 'Group';
  }

  static get configurable() {
    return {
      /**
       * The name of the record field to group by.
       * @config {String}
       * @default
       */
      field: null,

      /**
       * A function used to sort the groups
       * @config {Function}
       */
      groupSortFn: null,

      /**
       * A function which produces the HTML for a group header.
       * The function is called in the context of this Group feature object.
       * Default group renderer displays the `groupRowFor` and `count`.
       *
       * @config {Function}
       * @property {String} groupRowFor The value of the `field` for the group.
       * @property {Core.data.Model} record The group record representing the group.
       * @property {Object} record.meta Meta data with additional info about the grouping.
       * @property {Array} record.groupChildren The group child records.
       * @property {Number} count Number of records in the group.
       * @property {Grid.column.Column} column The column the renderer runs for.
       * @property {Boolean} isFirstColumn True, if `column` is the first column.
       * If `RowNumberColumn` is the real first column, it's not taken into account.
       * @property {Grid.column.Column} [groupColumn] The column under which the `field` is shown.
       * @property {Object} size Sizing information for the group header row, only `height` is relevant.
       * @property {Number} size.height The height of the row, set this if you want a custom height for the group header row
       * That is UI part, so do not rely on its existence.
       * @default
       */
      renderer: null
    };
  } //region Init


  construct(grid, config) {
    const me = this;

    if (grid.features.tree) {
      return;
    } // groupSummary feature needs to be initialized first, if it is used


    me._thisIsAUsedExpression(grid.features.groupSummary); // process initial config into an actual config object


    config = me.processConfig(config);
    me.grid = grid;
    super.construct(grid, config);
    me.bindStore(grid.store);
    grid.rowManager.on({
      beforeRenderRow: 'onBeforeRenderRow',
      renderCell: 'renderCell',
      // The feature gets to see cells being rendered before the GroupSummary feature
      // because this injects header content into group header rows and adds rendering
      // info to the cells renderData which GroupSummary must comply with.
      prio: 1100,
      thisObj: me
    });
  } // Group feature handles special config cases, where user can supply a string or a group config object
  // instead of a normal config object


  processConfig(config) {
    if (typeof config === 'string') {
      return {
        field: config,
        ascending: null
      };
    }

    return config;
  } // override setConfig to process config before applying it (used mainly from ReactGrid)


  setConfig(config) {
    if (config === null) {
      this.store.clearGroupers();
    } else {
      super.setConfig(this.processConfig(config));
    }
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      group: 'onStoreGroup',
      thisObj: this
    });
  }

  updateRenderer(renderer) {
    this.groupRenderer = renderer;
  }

  updateField(field) {
    this.store.group({
      field,
      ascending: this.ascending,
      fn: this.groupSortFn
    });
  }

  updateGroupSortFn(fn) {
    if (!this.isConfiguring) {
      this.store.group({
        field: this.field,
        ascending: this.ascending,
        fn
      });
    }
  }

  doDestroy() {
    super.doDestroy();
  }

  doDisable(disable) {
    const {
      store
    } = this; // Grouping mostly happens in store, need to clear groupers there to remove headers.
    // Use configured groupers as first sorters to somewhat maintain the order

    if (disable && store.isGrouped) {
      const {
        sorters
      } = store;
      sorters.unshift(...store.groupers);
      store.clearGroupers();
      store.sort(sorters);
    }

    super.doDisable(disable);
  }

  get store() {
    return this.grid.store;
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      assign: ['collapseAll', 'expandAll'],
      chain: ['renderHeader', 'populateHeaderMenu', 'getColumnDragToolbarItems', 'onElementTouchStart', 'onElementClick', 'onElementKeyDown', 'bindStore']
    };
  } //endregion
  //region Expand/collapse

  /**
   * Collapses or expands a group depending on its current state
   * @param {Core.data.Model|String} recordOrId Record or records id for a group row to collapse or expand
   * @param {Boolean} collapse Force collapse (true) or expand (true)
   * @fires togglegroup
   */


  toggleCollapse(recordOrId, collapse) {
    this.internalToggleCollapse(recordOrId, collapse);
  }
  /**
   * Collapses or expands a group depending on its current state
   * @param {Core.data.Model|String} recordOrId Record or records id for a group row to collapse or expand
   * @param {Boolean} collapse Force collapse (true) or expand (true)
   * @param {Boolean} skipRender True to not render rows
   * @internal
   * @fires togglegroup
   */


  internalToggleCollapse(recordOrId, collapse, skipRender = false) {
    const me = this,
          {
      store
    } = me,
          groupRecord = store.getById(recordOrId);

    if (!groupRecord.isGroupHeader) {
      return;
    }

    collapse = collapse === undefined ? !groupRecord.meta.collapsed : collapse;

    if (collapse) {
      store.collapse(groupRecord);
    } else {
      store.expand(groupRecord);
    }
    /**
     * Group expanded or collapsed
     * @event toggleGroup
     * @param groupRecord Group record
     * @param {Boolean} collapse Collapsed (true) or expanded (false)
     */


    me.grid.trigger('toggleGroup', {
      groupRecord,
      collapse
    });

    if (!skipRender) {
      // render from grouprecord and down, no need to touch those above
      me.grid.rowManager.renderFromRecord(groupRecord);
    }
  }
  /**
   * Collapse all groups. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
   * @on-owner
   */


  collapseAll() {
    const me = this;

    if (me.store.isGrouped && !me.disabled) {
      me.store.groupRecords.forEach(r => me.internalToggleCollapse(r, true, true));
      me.grid.refreshRows(true);
    }
  }
  /**
   * Expand all groups. This function is exposed on Grid and can thus be called as `grid.expandAll()`
   * @on-owner
   */


  expandAll() {
    const me = this;

    if (me.store.isGrouped && !me.disabled) {
      me.store.groupRecords.forEach(r => me.internalToggleCollapse(r, false, true));
      me.grid.refreshRows();
    }
  } //endregion
  //region Rendering

  /**
   * Called before rendering row contents, used to reset rows no longer used as group rows
   * @private
   */


  onBeforeRenderRow({
    row
  }) {
    // row.id contains previous record id on before render
    const oldRecord = row.grid.store.getById(row.id); // force update of inner html if this row used for group data

    row.forceInnerHTML = row.forceInnerHTML || (oldRecord === null || oldRecord === void 0 ? void 0 : oldRecord.isGroupHeader);
  }
  /**
   * Called when a cell is rendered, styles the group rows first cell.
   * @private
   */


  renderCell(renderData) {
    const me = this,
          {
      cellElement,
      row,
      column
    } = renderData,
          {
      meta
    } = renderData.record,
          rowClasses = {
      'b-group-row': 0,
      'b-grid-group-collapsed': 0
    };

    if (!me.disabled && me.store.isGrouped) {
      if ('groupRowFor' in meta) {
        // do nothing with action column to make possible using actions for groups
        if (column.type === 'action') {
          return;
        } // let column clear the cell, in case it needs to do some cleanup


        column.clearCell(cellElement); // this is a group row, add css classes

        rowClasses['b-grid-group-collapsed'] = meta.collapsed;
        rowClasses['b-group-row'] = 1;

        if (column === me.groupHeaderColumn) {
          cellElement.classList.add('b-group-title');
        }

        me.buildGroupHeader(renderData);
      } else {
        cellElement.classList.remove('b-group-title');
      }
    } // Still need to sync row classes is disabled or not grouped.
    // Previous b-group-row and b-grid-group-collapsed classes must be removed.


    row.assignCls(rowClasses);
  } // renderData.cellElement is required


  buildGroupHeader(renderData) {
    const me = this,
          {
      record,
      cellElement,
      column,
      persist
    } = renderData,
          {
      grid
    } = me,
          meta = record.meta,
          {
      groupRowFor
    } = meta,
          {
      groupSummary
    } = grid.features,
          // Need to adjust count if group summary is used
    // TODO remove this when grouping has been refactored to not store group headers/footers in the Store
    count = meta.childCount - (groupSummary && groupSummary.target !== 'header' ? 1 : 0);
    let html = null,
        applyDefault = true;

    if (persist || column) {
      const groupColumn = grid.columns.get(meta.groupField),
            isGroupHeaderColumn = renderData.isFirstColumn = column === me.groupHeaderColumn; // First try using columns groupRenderer (might not even have a column if grouping programmatically)

      if (groupColumn !== null && groupColumn !== void 0 && groupColumn.groupRenderer) {
        if (isGroupHeaderColumn) {
          // groupRenderer could return nothing and just apply changes directly to DOM element
          html = groupColumn.groupRenderer(_objectSpread(_objectSpread({}, renderData), {}, {
            groupRowFor,
            groupRecords: record.groupChildren,
            groupColumn,
            count
          }));
          applyDefault = false;
        }
      } // Secondly use features groupRenderer, if configured with one
      else if (me.groupRenderer) {
        // groupRenderer could return nothing and just apply changes directly to DOM element
        html = me.groupRenderer(_objectSpread(_objectSpread({}, renderData), {}, {
          groupRowFor,
          groupRecords: record.groupChildren,
          groupColumn,
          count,
          isFirstColumn: isGroupHeaderColumn
        }));
      } // Third, just display unformatted value and child count (also applied for features groupRenderer that do
      // not output any html of their own)


      if (isGroupHeaderColumn && html == null && applyDefault && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(cellElement) === 0) {
        html = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].encodeHtml(`${groupRowFor === '__novalue__' ? '' : groupRowFor} (${count})`);
      }
    } else if (me.groupRenderer) {
      // groupRenderer could return nothing and just apply changes directly to DOM element
      html = me.groupRenderer(renderData);
    } // Renderers could return nothing and just apply changes directly to DOM element


    if (typeof html === 'string') {
      cellElement.innerHTML = html;
    } else if (typeof html === 'object') {
      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync({
        targetElement: cellElement,
        domConfig: {
          onlyChildren: true,
          children: Array.isArray(html) ? html : [html]
        }
      });
    } // If groupRenderer added elements to the cell, we need to remember that to clear it on re-usage as a normal cell


    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(cellElement) > 0) {
      cellElement._hasHtml = true;
    }

    return cellElement.innerHTML;
  }

  get groupHeaderColumn() {
    return this.grid.columns.visibleColumns.find(column => !column.groupHeaderReserved);
  }
  /**
   * Called when an header is rendered, adds grouping icon if grouped by that column.
   * @private
   * @param headerContainerElement
   */


  renderHeader(headerContainerElement) {
    const {
      store,
      grid
    } = this;

    if (store.isGrouped) {
      // Sorted from start, reflect in rendering
      for (const groupInfo of store.groupers) {
        // Might be grouping by field without column, which is valid
        const column = grid.columns.get(groupInfo.field),
              header = column && grid.getHeaderElement(column.id); // IE11 doesnt support this
        //header && header.classList.add('b-group', groupInfo.ascending ? 'b-asc' : 'b-desc');

        if (header) {
          header.classList.add('b-group');
          header.classList.add(groupInfo.ascending ? 'b-asc' : 'b-desc');
        }
      }
    }
  } //endregion
  //region Context menu

  /**
   * Supply items for headers context menu.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    column,
    items
  }) {
    const me = this;

    if (column.groupable !== false) {
      items.groupAsc = {
        text: 'L{groupAscending}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-group-asc',
        cls: 'b-separator',
        weight: 400,
        disabled: me.disabled,
        onItem: () => me.store.group(column.field, true)
      };
      items.groupDesc = {
        text: 'L{groupDescending}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-group-desc',
        weight: 410,
        disabled: me.disabled,
        onItem: () => me.store.group(column.field, false)
      };
    }

    if (me.store.isGrouped) {
      items.groupRemove = {
        text: 'L{stopGrouping}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-clear',
        cls: column.groupable ? '' : 'b-separator',
        weight: 420,
        disabled: me.disabled,
        onItem: () => me.store.clearGroupers()
      };
    }
  }
  /**
   * Supply items to ColumnDragToolbar
   * @private
   */


  getColumnDragToolbarItems(column, items) {
    var _store$groupers;

    const me = this,
          {
      store,
      disabled
    } = me;
    items.push({
      text: 'L{groupAscendingShort}',
      group: 'L{group}',
      localeClass: me,
      icon: 'b-icon b-icon-group-asc',
      ref: 'groupAsc',
      cls: 'b-separator',
      weight: 110,
      disabled,
      onDrop: ({
        column
      }) => store.group(column.field, true)
    });
    items.push({
      text: 'L{groupDescendingShort}',
      group: 'L{group}',
      localeClass: me,
      icon: 'b-icon b-icon-group-desc',
      ref: 'groupDesc',
      weight: 110,
      disabled,
      onDrop: ({
        column
      }) => store.group(column.field, false)
    });
    const grouped = ((_store$groupers = store.groupers) === null || _store$groupers === void 0 ? void 0 : _store$groupers.some(col => col.field === column.field)) && !disabled;
    items.push({
      text: 'L{stopGroupingShort}',
      group: 'L{group}',
      localeClass: me,
      icon: 'b-icon b-icon-clear',
      ref: 'groupRemove',
      disabled: !grouped,
      weight: 110,
      onDrop: ({
        column
      }) => store.removeGrouper(column.field)
    });
    return items;
  } //endregion
  //region Events - Store

  /**
   * Called when store grouping changes. Reflects on header and rerenders rows.
   * @private
   */


  onStoreGroup({
    groupers
  }) {
    const {
      grid
    } = this,
          {
      element
    } = grid,
          curGroupHeaders = element && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].children(element, '.b-grid-header.b-group');

    if (element) {
      for (const header of curGroupHeaders) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].removeClasses(header, ['b-group', 'b-asc', 'b-desc']);
      }

      if (groupers) {
        for (const groupInfo of groupers) {
          const header = grid.getHeaderElementByField(groupInfo.field);

          if (header) {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].addClasses(header, ['b-group', groupInfo.ascending ? 'b-asc' : 'b-desc']);
          }
        }
      }
    }
  } //endregion
  //region Events - Grid

  /**
   * Store touches when user touches header, used in onElementTouchEnd.
   * @private
   */


  onElementTouchStart(event) {
    const me = this,
          {
      target
    } = event,
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(target, '.b-grid-header'),
          column = header && me.grid.getColumnFromElement(header); // If it's a multi touch, group.

    if (event.touches.length > 1 && column && column.groupable !== false && !me.disabled) {
      me.store.group(column.field);
    }
  }
  /**
   * React to click on headers (to group by that column if [alt] is pressed) and on group rows (expand/collapse).
   * @private
   * @param event
   * @returns {Boolean}
   */


  onElementClick(event) {
    const me = this,
          {
      store
    } = me,
          {
      target
    } = event,
          row = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(target, '.b-group-row'),
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(target, '.b-grid-header'),
          field = header === null || header === void 0 ? void 0 : header.dataset.column; // prevent expand/collapse if disabled or clicked on item with own handler

    if (target.classList.contains('b-resizer') || me.disabled || target.classList.contains('b-action-item')) {
      return;
    } // Header


    if (header && field) {
      var _store$groupers2;

      const columnGrouper = (_store$groupers2 = store.groupers) === null || _store$groupers2 === void 0 ? void 0 : _store$groupers2.find(g => g.field === field); // Store has a grouper for this column's field; flip grouper order

      if (columnGrouper && !event.shiftKey) {
        store.group(field, !columnGrouper.ascending);
        return false;
      } // Group or ungroup
      else if (event.shiftKey) {
        const column = me.grid.columns.get(field);

        if (column.groupable !== false) {
          if (event.altKey) {
            store.removeGrouper(field);
          } else {
            store.group(field);
          }
        }
      }
    } // Anywhere on group-row


    if (row) {
      me.internalToggleCollapse(_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].get(row).id);
      return false;
    }
  }
  /**
   * Toggle groups with [space].
   * @private
   * @param event
   * @returns {*}
   */


  onElementKeyDown(event) {
    const me = this,
          {
      grid
    } = me; // only catch space on grid element, not in editors etc...

    if (!me.disabled && me.store.isGrouped && event.target === grid.focusElement && event.key === ' ' && grid.focusedCell) {
      event.preventDefault();
      me.internalToggleCollapse(grid.focusedCell.id);
    }
  } //endregion


}
Group._$name = 'Group';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(Group, true, ['Grid', 'Scheduler']);

/***/ }),

/***/ "./lib/Grid/feature/GroupSummary.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/GroupSummary.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GroupSummary; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/SummaryFormatter.js */ "./lib/Grid/feature/mixin/SummaryFormatter.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';





/**
 * @module Grid/feature/GroupSummary
 */

/**
 * Displays a summary row as a group footer in a grouped grid. Uses same configuration options on columns as
 * {@link Grid.feature.Summary}.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ```
 * features : {
 *     group        : 'city',
 *     groupSummary : true
 * }
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/groupsummary
 * @classtype groupSummary
 * @feature
 *
 * @inlineexample Grid/feature/GroupSummary.js
 */

class GroupSummary extends Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Init
  static get $name() {
    return 'GroupSummary';
  }

  static get configurable() {
    return {
      /**
       * Set to `true` to have group summaries rendered in the group header when a group is collapsed.
       *
       * Only applies when {@link #config-target} is `'footer'` (the default).
       *
       * @member {Boolean} collapseToHeader
       */

      /**
       * Configure as `true` to have group summaries rendered in the group header when a group is collapsed.
       *
       * ```javascript
       * const grid = new Grid({
       *    features : {
       *        groupSummary : {
       *            collapseToHeader : true
       *        }
       *    }
       * });
       * ```
       *
       * Only applies when {@link #config-target} is `'footer'` (the default).
       *
       * @config {Boolean}
       */
      collapseToHeader: null,

      /**
       * Where to render the group summaries to, either `header` to display them in the group header or `footer`
       * to display them in the group footer (the default).
       *
       * @member {String} target
       */

      /**
       * Where to render the group summaries to, either `header` to display them in the group header or `footer`
       * to display them in the group footer (the default).
       *
       * ```javascript
       * const grid = new Grid({
       *    features : {
       *        groupSummary : {
       *            target : 'header'
       *        }
       *    }
       * });
       * ```
       *
       * @config {String}
       * @default
       */
      target: 'footer'
    };
  }

  construct(grid, config) {
    this.grid = grid;
    super.construct(grid, config);

    if (!grid.features.group) {
      throw new Error('Requires Group feature to work, please enable');
    }

    this.bindStore(grid.store);
    grid.rowManager.on({
      beforeRenderRow: 'onBeforeRenderRow',
      renderCell: 'renderCell',
      // The feature gets to see cells being rendered after the Group feature
      // because the Group feature injects header content into group header rows
      // and adds rendering info to the cells renderData which we must comply with.
      // In particular, it calculates the isFirstColumn flag which it adds to
      // the cell renderData which we interrogate.
      prio: 1000,
      thisObj: this
    });
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      update: 'onStoreUpdate',
      // need to run before grids listener, to flag for full refresh
      prio: 1,
      thisObj: this
    });
  }

  get store() {
    return this.grid.store;
  }

  doDisable(disable) {
    // Toggle footers if needed
    this.updateTarget(this.target);
    super.doDisable(disable);
  }

  changeTarget(target) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assertString(target, 'target');
    return target;
  }

  updateTarget(target) {
    // Flag that will make the Store insert rows for group footers
    this.store.useGroupFooters = !this.disabled && target === 'footer'; // Refresh groups to show/hide footers

    if (!this.isConfiguring) {
      this.store.group();
    }
  }

  changeCollapseToHeader(collapseToHeader) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assertBoolean(collapseToHeader, 'collapseToHeader');
    return collapseToHeader;
  }

  updateCollapseToHeader() {
    if (!this.isConfiguring) {
      this.store.group();
    }
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['bindStore']
    };
  } //endregion
  //region Render

  /**
   * Called before rendering row contents, used to reset rows no longer used as group summary rows
   * @private
   */


  onBeforeRenderRow({
    row,
    record
  }) {
    if (row.isGroupFooter && !('groupFooterFor' in record.meta)) {
      // not a group row.
      row.isGroupFooter = false; // force full "redraw" when rendering cells

      row.forceInnerHTML = true;
    } else if (row.isGroupHeader && !record.meta.collapsed) {
      // remove any summary elements
      row.eachElement(this.removeSummaryElements);
    }
  }

  removeSummaryElements(rowEl) {}
  /**
   * Called when a cell is rendered, styles the group rows first cell.
   * @private
   */


  renderCell({
    column,
    cellElement,
    row,
    record,
    size,
    isFirstColumn
  }) {
    const me = this,
          {
      meta
    } = record,
          {
      rowHeight
    } = me.grid,
          isGroupHeader = ('groupRowFor' in meta),
          isGroupFooter = ('groupFooterFor' in meta),
          targetsHeader = me.target === 'header',
          rowClasses = {
      'b-group-footer': 0,
      'b-header-summary': 0
    },
          isSummaryTarget = // Header cell should have summary content if we are targeting the header or if the group is collapsed
    // and we are configured with collapseToHeader, excluding the first column which holds the group title
    isGroupHeader && (targetsHeader || me.collapseToHeader && meta.collapsed) && !isFirstColumn || // Footer cell should have summary content if we are targeting the footer (wont render if collapsed)
    isGroupFooter && !targetsHeader; // Needed to restore height when summary is no longer displayed

    if (isGroupHeader || isGroupFooter) {
      size.height = rowHeight;
    }

    if (me.store.isGrouped && isSummaryTarget && !me.disabled) {
      // clear cell before add any HTML in it. if the cell contained widgets, they will be properly destroyed.
      column.clearCell(cellElement);
      const groupRecord = isGroupHeader ? record : meta.groupRecord;
      row.isGroupFooter = isGroupFooter;
      row.isGroupHeader = isGroupHeader; // This is a group footer row, add css

      if (isGroupFooter) {
        rowClasses['b-group-footer'] = 1;
      } // This is a group header row, add css
      else {
        rowClasses['b-header-summary'] = 1;
      } // returns height config or count. config format is { height, count }. where `height is in px and should be
      // added to value calculated from `count


      const heightSetting = me.updateSummaryHtml(cellElement, column, groupRecord),
            count = typeof heightSetting === 'number' ? heightSetting : heightSetting.count; // number of summaries returned, use to calculate cell height

      if (count > 1) {
        size.height += meta.collapsed && !targetsHeader ? 0 : count * rowHeight * 0.1;
      } // height config with height specified, added to cell height


      if (heightSetting.height) {
        size.height += heightSetting.height;
      }
    } // Sync row's classes with its status as a group header or footer.


    row.assignCls(rowClasses);
  }

  updateSummaryHtml(cellElement, column, groupRecord) {
    const records = groupRecord.groupChildren.slice(); // Group footers should not be included in summary calculations

    if (records[records.length - 1].isGroupFooter) {
      records.pop();
    }

    const html = this.generateHtml(column, records, 'b-grid-group-summary', groupRecord, groupRecord.meta.groupField, groupRecord.meta.groupRowFor); // First time, set table

    if (!cellElement.children.length) {
      cellElement.innerHTML = html;
    } // Following times, sync changes
    else {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(html, cellElement.firstElementChild);
    } // return summary "count", used to set row height


    return column.summaries ? column.summaries.length : column.sum ? 1 : 0;
  } //endregion
  //region Events

  /**
   * Updates summaries on store changes (except record update, handled below)
   * @private
   */


  onStoreUpdate({
    source: store,
    changes
  }) {
    if (!this.disabled && store.isGrouped) {
      // If a grouping field is among the changes, StoreGroup#onDataChanged will
      // take care of the update by re-sorting.
      if (changes && store.groupers.find(grouper => grouper.field in changes)) {
        return;
      } // only update summary when a field that affects summary is changed
      // TODO: this should maybe be removed, another column might depend on the value for its summary?


      const shouldUpdate = Object.keys(changes).some(field => {
        const colField = this.grid.columns.get(field); // check existence, since a field not used in a column might have changed

        return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
      });

      if (shouldUpdate) {
        this.grid.forceFullRefresh = true;
      }
    }
  } //endregion

  /**
   * Refreshes the summaries
   */


  refresh() {
    this.grid.columns.visibleColumns.forEach(column => {
      if (this.hasSummary(column)) {
        this.grid.refreshColumn(column);
      }
    });
  }

  hasSummary(column) {
    return column.sum || column.summaries;
  }

}
GroupSummary.featureClass = 'b-group-summary';
GroupSummary._$name = 'GroupSummary';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(GroupSummary);

/***/ }),

/***/ "./lib/Grid/feature/HeaderMenu.js":
/*!****************************************!*\
  !*** ./lib/Grid/feature/HeaderMenu.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderMenu; });
/* harmony import */ var _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';




/**
 * @module Grid/feature/HeaderMenu
 */

/**
 * Right click column header or focus it and press SPACE key to show the context menu for headers.
 *
 * ### Default header menu items
 *
 * The Header menu has no default items provided by the `HeaderMenu` feature, but there are other features
 * that populate the header menu with the following items:
 *
 * | Reference         | Text                              | Weight | Feature                                        | Description                                      |
 * |-------------------|-----------------------------------|--------|------------------------------------------------|--------------------------------------------------|
 * | `filter`          | Filter                            | 100    | {@link Grid.feature.Filter Filter}             | Shows the filter popup to add a filter           |
 * | `editFilter`      | Edit filter                       | 100    | {@link Grid.feature.Filter Filter}             | Shows the filter popup to change/remove a filter |
 * | `removeFilter`    | Remove filter                     | 110    | {@link Grid.feature.Filter Filter}             | Stops filtering by selected column field         |
 * | `toggleFilterBar` | Hide filter bar / Show filter bar | 120    | {@link Grid.feature.FilterBar FilterBar}       | Toggles filter bar visibility                    |
 * | `columnPicker`    | Columns                           | 200    | {@link Grid.feature.ColumnPicker ColumnPicker} | Shows a submenu to control columns visibility    |
 * | \>column.id*      | column.text*                      |        | {@link Grid.feature.ColumnPicker ColumnPicker} | Check item to hide/show corresponding column     |
 * | `hideColumn`      | Hide column                       | 210    | {@link Grid.feature.ColumnPicker ColumnPicker} | Hides selected column                            |
 * | `sortAsc`         | Sort ascending                    | 300    | {@link Grid.feature.Sort Sort}                 | Sort by the column field in ascending order      |
 * | `sortDesc`        | Sort descending                   | 310    | {@link Grid.feature.Sort Sort}                 | Sort by the column field in descending order      |
 * | `multiSort`       | Multi sort                        | 320    | {@link Grid.feature.Sort Sort}                 | Shows a submenu to control multi-sorting         |
 * | \>`addSortAsc`    | Add ascending sorting             | 330    | {@link Grid.feature.Sort Sort}                 | Adds ascending sorter using the column field     |
 * | \>`addSortDesc`   | Add descending sorting            | 340    | {@link Grid.feature.Sort Sort}                 | Adds descending sorter using the column field    |
 * | \>`removeSorter`  | Remove sorter                     | 350    | {@link Grid.feature.Sort Sort}                 | Stops sorting by selected column field           |
 * | `groupAsc`        | Group ascending                   | 400    | {@link Grid.feature.Group Group}               | Group by the column field in ascending order     |
 * | `groupDesc`       | Group descending                  | 410    | {@link Grid.feature.Group Group}               | Group by the column field in descending order     |
 * | `groupRemove`     | Stop grouping                     | 420    | {@link Grid.feature.Group Group}               | Stops grouping                                   |
 *
 * \* - items that are generated dynamically
 *
 * \> - first level of submenu
 *
 * ### Customizing the menu items
 *
 * The menu items in the Header menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all columns:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *         extraItem : { text: 'My header item', icon: 'fa fa-car', weight: 200, onItem : () => ... }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to add items using columns config. See examples below.
 *
 * Add extra items for a single column:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns: [
 *     {
 *       field: 'name',
 *       text: 'Name',
 *       headerMenuItems: {
 *         columnItem : { text: 'My unique header item', icon: 'fa fa-flask', onItem : () => ... }
 *       }
 *     }
 *   ]
 * });
 * ```
 *
 * Remove built in item:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *          // Hide 'Stop grouping'
 *          groupRemove : false
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Customize built in item:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *          hideColumn : {
 *              text : 'Bye bye column'
 *          }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to manipulate the default items and add new items in the processing function:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       processItems({items, record}) {
 *           if (record.cost > 5000) {
 *              items.myItem = { text : 'Split cost' };
 *           }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Cell menu and the Header menu" guide.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/feature/base/ContextMenuBase
 * @demo Grid/contextmenu
 * @classtype headerMenu
 * @feature
 *
 * @inlineexample Grid/feature/HeaderMenu.js
 */

class HeaderMenu extends _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'HeaderMenu';
  }

  static get defaultConfig() {
    return {
      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       *   features         : {
       *       headerMenu : {
       *           processItems({ column, items }) {
       *               // Add or hide existing items here as needed
       *               items.myAction = {
       *                   text   : 'Cool action',
       *                   icon   : 'b-fa b-fa-fw b-fa-ban',
       *                   onItem : () => console.log('Some coolness'),
       *                   weight : 300 // Move to end
       *               };
       *
       *               // Hide column picker
       *               items.columnPicker.hidden = true;
       *           }
       *       }
       *   },
       * ```
       * @param {Object} context An object with information about the menu being shown
       * @param {Grid.column.Column} context.column The current column
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null,

      /**
       * This is a preconfigured set of items used to create the default context menu.
       *
       * The `items` provided by this feature are listed in the intro section of this class. You can
       * configure existing items by passing a configuration object to the keyed items.
       *
       * To remove existing
       * items, set corresponding keys to `false`
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         headerMenu : {
       *             items : {
       *                 filter        : false,
       *                 columnPicker  : false
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * See the feature config in the above example for details.
       *
       * @config {Object} items
       */
      items: null,
      type: 'header',
      // private "hack" to provide backward compatibility for deprecated HeaderContextMenu feature in Scheduler
      _showForTimeAxis: false
    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateHeaderMenu');
    return config;
  } //endregion
  //region Events

  /**
   * This event fires on the owning Grid before the context menu is shown for a header.
   * Allows manipulation of the items to show in the same way as in the {@link #config-processItems}.
   *
   * Returning `false` from a listener prevents the menu from being shown.
   *
   * @event headerMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   */

  /**
   * This event fires on the owning Grid after the context menu is shown for a header
   * @event headerMenuShow
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Column
   */

  /**
   * This event fires on the owning Grid when an item is selected in the header context menu.
   * @event headerMenuItem
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {Grid.column.Column} column Column
   */

  /**
   * This event fires on the owning Grid when a check item is toggled in the header context menu.
   * @event headerMenuToggleItem
   * @on-owner
   * @param {Grid.view.Grid} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {Grid.column.Column} column Column
   * @param {Boolean} checked Checked or not
   */
  //endregion


  onElementKeyDown(event) {
    if (!event.handled && event.target.matches('.b-grid-header.b-depth-0')) {
      switch (event.key) {
        case ' ':
          this.internalShowContextMenu(this.createContextMenuEventForElement(event.target));
          break;
      }
    }
  } //region Menu handlers


  shouldShowMenu(eventParams) {
    const {
      column
    } = eventParams; // TODO: remove "this._showForTimeAxis || " when support for HeaderContextMenu feature in Scheduler is dropped.

    return column && column.enableHeaderContextMenu !== false && (this._showForTimeAxis || column !== this.client.timeAxisColumn);
  } // TODO: remove "showContextMenu" override completely when support for HeaderContextMenu feature in Scheduler is dropped.


  showContextMenu({
    column
  }) {
    super.showContextMenu(...arguments);

    if (column === this.client.timeAxisColumn && this.menu) {
      // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
      // The menu should not hide on scroll when for a TimeAxisColumn
      this.menu.scrollAction = 'realign';
    }
  }

  getDataFromEvent(event) {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(super.getDataFromEvent(event), this.client.getHeaderDataFromEvent(event));
  }

  populateHeaderMenu({
    items,
    column
  }) {
    if (column !== null && column !== void 0 && column.headerMenuItems) {
      if (Array.isArray(column.headerMenuItems)) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Grid', '5.0.0', '`headerMenuItems` column config specified as an array is deprecated, need to specify the config as a named object. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.');
      } // Array works smoothly since number index turns into a key for named object


      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(items, column.headerMenuItems);
    }

    return items;
  }

}
HeaderMenu.featureClass = '';
HeaderMenu._$name = 'HeaderMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(HeaderMenu, true);

/***/ }),

/***/ "./lib/Grid/feature/QuickFind.js":
/*!***************************************!*\
  !*** ./lib/Grid/feature/QuickFind.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return QuickFind; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt'; //TODO: Handle date columns
//TODO: Icons to navigate between hits in the header? or in each cell?
//TODO: Icon to clear quickfind in header
//TODO: regex for valid key pressed?





/**
 * @module Grid/feature/QuickFind
 */

/**
 * Feature that allows the user to search in a column by focusing a cell and typing. Navigate between hits using the
 * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable QuickFind
 * let grid = new Grid({
 *   features: {
 *     quickFind: true
 *   }
 * });
 *
 * // navigate to next hit programmatically
 * grid.features.quickFind.gotoNextHit();
 *
 * @demo Grid/quickfind
 * @classtype quickFind
 * @inlineexample Grid/feature/QuickFind.js
 * @feature
 */

class QuickFind extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'QuickFind';
  }

  static get defaultConfig() {
    return {
      mode: 'header',
      find: ''
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onElementKeyDown', 'onElementKeyPress', 'onCellNavigate']
    };
  } //endregion
  //region Init


  static get properties() {
    return {
      hitCls: 'b-quick-hit',
      hitCellCls: 'b-quick-hit-cell',
      hitCellBadgeCls: 'b-quick-hit-cell-badge',
      hitTextCls: 'b-quick-hit-text'
    };
  }

  construct(grid, config) {
    super.construct(grid, config);
    Object.assign(this, {
      grid,
      treeWalker: grid.setupTreeWalker(grid.element, NodeFilter.SHOW_TEXT, () => NodeFilter.FILTER_ACCEPT, false)
    });
  }

  doDisable(disable) {
    if (disable) {
      this.clear();
    }

    super.doDisable(disable);
  }

  get store() {
    return this.grid.store;
  } //endregion
  //region Show/hide QuickFind

  /**
   * Shows a "searchfield" in the header. Triggered automatically when you have a cell focused and start typing.
   * @private
   */


  showQuickFind() {
    const me = this,
          header = me.grid.getHeaderElement(me.columnId);

    if (header) {
      if (!me.headerField) {
        const [element, field, badge] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
          tag: 'div',
          className: 'b-quick-hit-header',
          children: [{
            tag: 'div',
            className: 'b-quick-hit-field'
          }, {
            tag: 'div',
            className: 'b-quick-hit-badge'
          }]
        }, true);

        if (me.mode === 'header') {
          header.appendChild(element);
        } else {
          element.className += ' b-quick-hit-mode-grid';
          me.grid.element.appendChild(element);
        }

        me.headerField = {
          header: element,
          field: field,
          badge: badge,
          colHeader: header
        };
      }

      me.headerField.field.innerHTML = me.find;
      me.headerField.badge.innerHTML = me.found.length;
      header.classList.add('b-quick-find-header');

      if (!me.renderListenerInitialized) {
        me.grid.rowManager.on({
          rendercell: me.renderCell,
          thisObj: me
        });
        me.renderListenerInitialized = true;
      }
    }
  }
  /**
   * Hide the "searchfield" and remove highlighted hits. Called automatically when pressing [esc] or backspacing away
   * the keywords.
   * @private
   */


  hideQuickFind() {
    const me = this,
          {
      grid,
      headerField
    } = me; // rerender cells to remove quick-find markup

    for (const hit of me.prevFound || me.found) {
      const row = grid.getRowById(hit.id);

      if (row) {
        // Need to force replace quick finds markup
        row.forceInnerHTML = true;
        const cellElement = row.getCell(me.columnId);
        cellElement._content = null;
        row.renderCell({
          cellElement,
          record: hit.data
        });
        row.forceInnerHTML = false;
      }
    }

    if (headerField) {
      headerField.header.parentNode.removeChild(headerField.header);
      headerField.colHeader.classList.remove('b-quick-find-header');
      me.headerField = null;
    }

    if (me.renderListenerInitialized) {
      grid.rowManager.un({
        rendercell: me.renderCell
      }, me);
      me.renderListenerInitialized = false;
    }

    grid.trigger('hideQuickFind');
  } //endregion
  //region Search

  /**
   * Performs a search and highlights hits. If find is empty, QuickFind is closed.
   * @param {String} find Text to search for
   * @param {String} columnFieldOrId Column to search
   */


  search(find, columnFieldOrId = this.columnId) {
    const me = this,
          {
      grid
    } = me,
          column = grid.columns.getById(columnFieldOrId) || grid.columns.get(columnFieldOrId),
          found = me.store.findByField(column.field, find);
    let i = 1;
    Object.assign(me, {
      foundMap: {},
      prevFound: me.found,
      found,
      find,
      columnId: column.id,
      findRe: new RegExp(`(\\s+)?(${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].escapeRegExp(String(find))})(\\s+)?`, 'ig')
    });

    if (find) {
      me.showQuickFind();
    } else {
      me.hideQuickFind();
    } // clear old hits


    for (const cellElement of _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(grid.element, `.${me.hitCls}`)) {
      cellElement.classList.remove(me.hitCls, me.hitCellCls);

      if (cellElement._originalContent) {
        cellElement.innerHTML = cellElement._originalContent;
        cellElement._originalContent = null;
      }
    }

    if (!found) {
      return;
    }

    if (found.length > 0) {
      me.gotoClosestHit(grid.focusedCell, found);
    } // highlight hits for visible cells


    for (const hit of found) {
      me.foundMap[hit.id] = i++;
      const row = grid.getRowById(hit.data.id);
      row === null || row === void 0 ? void 0 : row.renderCell({
        cellElement: row.getCell(column.id)
      }); // limit highlighted hits

      if (i > 1000) {
        break;
      }
    }

    grid.trigger('quickFind', {
      find,
      found
    });
  }
  /**
   * Clears and closes QuickFind.
   */


  clear() {
    var _this$found;

    if ((_this$found = this.found) !== null && _this$found !== void 0 && _this$found.length) {
      this.search('');
    }
  }
  /**
   * Number of results found
   * @type {Number}
   * @readonly
   */


  get foundCount() {
    var _this$found$length, _this$found2;

    return (_this$found$length = (_this$found2 = this.found) === null || _this$found2 === void 0 ? void 0 : _this$found2.length) !== null && _this$found$length !== void 0 ? _this$found$length : 0;
  }
  /**
   * Found results (as returned by Store#findByField), an array in format { index: x, data: record }
   * @member {Object[]} found
   * @readonly
   */
  //endregion
  //region Navigation

  /**
   * Go to specified hit.
   * @param {Number} index
   */


  gotoHit(index) {
    const nextHit = this.found[index];

    if (nextHit) {
      this.grid.focusCell({
        columnId: this.columnId,
        id: nextHit.id
      });
    }

    return !!nextHit;
  }

  gotoClosestHit(focusedCell, found) {
    const focusedIndex = focusedCell ? this.grid.store.indexOf(focusedCell.id) : 0,
          foundSorted = found.slice().sort((a, b) => Math.abs(a.index - focusedIndex) - Math.abs(b.index - focusedIndex));
    this.gotoHit(found.indexOf(foundSorted[0]));
  }
  /**
   * Go to the first hit.
   */


  gotoFirstHit() {
    this.gotoHit(0);
  }
  /**
   * Go to the last hit.
   */


  gotoLastHit() {
    this.gotoHit(this.found.length - 1);
  }
  /**
   * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
   */


  gotoNextHit() {
    var _grid$_focusedCell$id, _grid$_focusedCell, _grid$lastFocusedCell;

    const me = this,
          {
      grid
    } = me,
          // start from focused cell, or if focus has left grid use lastFocusedCell
    currentId = (_grid$_focusedCell$id = (_grid$_focusedCell = grid._focusedCell) === null || _grid$_focusedCell === void 0 ? void 0 : _grid$_focusedCell.id) !== null && _grid$_focusedCell$id !== void 0 ? _grid$_focusedCell$id : (_grid$lastFocusedCell = grid.lastFocusedCell) === null || _grid$lastFocusedCell === void 0 ? void 0 : _grid$lastFocusedCell.id,
          currentIndex = grid.store.indexOf(currentId) || 0,
          nextHit = me.found.find(hit => hit.index > currentIndex);

    if (nextHit) {
      grid.focusCell({
        columnId: me.columnId,
        id: nextHit.id
      });
    } else {
      me.gotoFirstHit();
    }
  }
  /**
   * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
   */


  gotoPrevHit() {
    var _grid$_focusedCell$id2, _grid$_focusedCell2, _grid$lastFocusedCell2;

    const me = this,
          {
      grid,
      found
    } = me,
          currentId = (_grid$_focusedCell$id2 = (_grid$_focusedCell2 = grid._focusedCell) === null || _grid$_focusedCell2 === void 0 ? void 0 : _grid$_focusedCell2.id) !== null && _grid$_focusedCell$id2 !== void 0 ? _grid$_focusedCell$id2 : (_grid$lastFocusedCell2 = grid.lastFocusedCell) === null || _grid$lastFocusedCell2 === void 0 ? void 0 : _grid$lastFocusedCell2.id,
          currentIndex = grid.store.indexOf(currentId) || 0;
    let prevHit;

    if (!found.length) {
      return;
    }

    for (let i = found.length - 1; i--; i >= 0) {
      if (found[i].index < currentIndex) {
        prevHit = found[i];
        break;
      }
    }

    if (prevHit) {
      grid.focusCell({
        columnId: me.columnId,
        id: prevHit.id
      });
    } else {
      me.gotoLastHit();
    }
  } //endregion
  //region Render

  /**
   * Called from SubGrid when a cell is rendered.
   * @private
   */


  renderCell({
    cellElement,
    column,
    record
  }) {
    var _me$foundMap;

    const me = this,
          {
      classList
    } = cellElement,
          {
      treeWalker,
      findRe,
      hitTextCls
    } = me,
          hitIndex = me.columnId === column.id && ((_me$foundMap = me.foundMap) === null || _me$foundMap === void 0 ? void 0 : _me$foundMap[record.id]);

    if (hitIndex) {
      // highlight cell
      classList.add(me.hitCls);
      cellElement.isQuickHit = true;
      cellElement._originalContent = cellElement.innerHTML; // if features have added other stuff to the cell, value is in div.b-grid-cell-value
      // highlight in cell if found in innerHTML

      const inner = treeWalker.currentNode = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].down(cellElement, '.b-grid-cell-value,.b-tree-cell-value') || cellElement;

      for (let textNode = treeWalker.nextNode(); textNode && inner.contains(textNode);) {
        const nodeToReplace = textNode,
              textContent = textNode.nodeValue,
              newText = []; // Move onto next text node before we replace the node with a highlight HTML sequence

        textNode = treeWalker.nextNode();
        let offset = findRe.lastIndex; // Convert textContent into an innerHTML string which htmlEncodes the text and embeds
        // a highlighting span which contains the target text.

        for (let match = findRe.exec(textContent); match; match = findRe.exec(textContent)) {
          const preamble = textContent.substring(offset, match.index),
                spaceBefore = match[1] ? '\xa0' : '',
                v = match[2],
                spaceAfter = match[3] ? '\xa0' : '';
          newText.push(`${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(preamble)}${spaceBefore}<span class="${hitTextCls}">${v}</span>${spaceAfter}`);
          offset = findRe.lastIndex;
        }

        newText.push(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(textContent.substring(offset))); // Insert a fragment with each match wrapped with a span.

        nodeToReplace.parentNode.insertBefore(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElementFromTemplate(newText.join(''), {
          fragment: true
        }), nodeToReplace);
        nodeToReplace.remove();
      }

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: cellElement,
        className: me.hitCellBadgeCls,
        text: hitIndex
      });
    }
  } //endregion
  //region Events

  /**
   * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
   * @private
   * @param event KeyboardEvent
   */


  onElementKeyDown(event) {
    const me = this,
          filterFeature = me.grid.features.filter; // Only react to keystrokes on grid cell elements.

    if (me.disabled || event.target.closest('.b-widget:not(.b-gridbase)')) {
      return;
    }

    if (me.find.length > 0) {
      // backspace
      if (event.key === 'Backspace') {
        event.preventDefault();
        me.find = me.find.substr(0, me.find.length - 1);
        me.search(me.find);
      } // escape
      else if (event.key === 'Escape') {
        event.preventDefault();
        me.find = '';
        me.search(me.find);
      } // F3 or CTRL+g
      else if (event.key === 'F3' || event.key.toLowerCase() === 'g' && event.ctrlKey) {
        event.preventDefault();

        if (event.shiftKey) {
          me.gotoPrevHit();
        } else {
          me.gotoNextHit();
        }
      } // Ctrl+Shift+F
      else if (filterFeature && me.columnId && me.foundCount && event.ctrlKey && event.shiftKey && event.key === 'F') {
        me.clear();
        filterFeature.showFilterEditor(me.grid.columns.getById(me.columnId), me.find);
      }
    }
  }
  /**
   * Chained function called on grids keypress event. Handles input for "searchfield".
   * @private
   * @param event
   */


  onElementKeyPress(event) {
    const me = this,
          {
      grid
    } = me; // Only react to keystrokes on grid cell elements

    if (me.disabled || event.target.closest('.b-widget:not(.b-gridbase)') || event.key === 'Enter') {
      return;
    }

    if (grid._focusedCell) {
      const column = grid.columns.getById(grid._focusedCell.columnId); // if trying to search in invalid column, it's a hard failure

      if (column && column.searchable !== false) {
        var _event$key;

        me.columnId = grid._focusedCell.columnId; // Prevent space from scrolling

        if (event.key === ' ') {
          event.preventDefault();
        }

        if (((_event$key = event.key) === null || _event$key === void 0 ? void 0 : _event$key.length) === 1) {
          me.find += event.key;
          me.search(me.find);
        }
      }
    }
  }

  onCellNavigate(grid, fromCellSelector, toCellSelector) {
    const me = this,
          found = me.prevFound || me.found;

    if (found && (!toCellSelector || toCellSelector.columnId !== me.columnId)) {
      me.clear();
    }
  } //endregion


}
QuickFind._$name = 'QuickFind';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(QuickFind);

/***/ }),

/***/ "./lib/Grid/feature/RegionResize.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/RegionResize.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RegionResize; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';



/**
 * @module Grid/feature/RegionResize
 */

/**
 * Makes the splitter between grid section draggable so you can resize grid sections.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable RegionResize
 * let grid = new Grid({
 *   features: {
 *     regionResize: true
 *   }
 * });
 *
 * @demo Grid/features
 * @classtype regionResize
 * @inlineexample Grid/feature/RegionResize.js
 * @feature
 */

class RegionResize extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  // region Init
  static get $name() {
    return 'RegionResize';
  }

  construct(grid, config) {
    this.grid = grid;
    super.construct(grid, config);
  }

  doDestroy() {
    // TODO: Cleanup
    super.doDestroy();
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onElementTouchStart', 'onElementTouchMove', 'onElementTouchEnd', 'onElementMouseDown', 'onElementMouseMove', 'onElementDblClick', 'onElementMouseUp', 'onSubGridCollapse', 'onSubGridExpand', 'render']
    };
  } //endregion


  onElementDblClick(event) {
    const me = this,
          grid = me.grid,
          splitterEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(event.target, '.b-grid-splitter-collapsed'); // If collapsed splitter is dblclicked and region is not expanding
    // It is unlikely that user might dblclick splitter twice and even if he does, nothing should happen.
    // But just in case lets not expand twice.

    if (splitterEl && !me.expanding) {
      me.expanding = true;
      let region = splitterEl.dataset.region,
          subGrid = grid.getSubGrid(region); // Usually collapsed splitter means corresponding region is collapsed. But in case of last two regions one
      // splitter can be collapsed in two directions. So, if corresponding region is expanded then last one is collapsed

      if (!subGrid.collapsed) {
        region = grid.getLastRegions()[1];
        subGrid = grid.getSubGrid(region);
      }

      subGrid.expand().then(() => me.expanding = false);
    }
  } //region Move splitter

  /**
   * Begin moving splitter.
   * @private
   * @param splitterElement Splitter element
   * @param clientX Initial x position from which new width will be calculated on move
   */


  startMove(splitterElement, clientX) {
    const me = this,
          {
      grid
    } = me,
          region = splitterElement.dataset.region,
          gridEl = grid.element,
          nextRegion = grid.regions[grid.regions.indexOf(region) + 1],
          nextSubGrid = grid.getSubGrid(nextRegion),
          splitterSubGrid = grid.getSubGrid(region);
    let subGrid = splitterSubGrid,
        flip = 1;

    if (subGrid.flex != null) {
      // If subgrid has flex, check if next one does not
      if (nextSubGrid.flex == null) {
        subGrid = nextSubGrid;
        flip = -1;
      }
    }

    if (splitterElement.classList.contains('b-grid-splitter-collapsed')) {
      return;
    }

    const availableWidth = subGrid.element.offsetWidth + nextSubGrid.element.offsetWidth;
    me.dragContext = {
      element: splitterElement,
      headerEl: subGrid.header.element,
      subGridEl: subGrid.element,
      subGrid,
      splitterSubGrid,
      originalWidth: subGrid.element.offsetWidth,
      originalX: clientX,
      minWidth: subGrid.minWidth || 0,
      maxWidth: Math.min(availableWidth, subGrid.maxWidth || availableWidth),
      flip
    };
    gridEl.classList.add('b-moving-splitter');
    splitterSubGrid.toggleSplitterCls('b-moving');
  }
  /**
   * Stop moving splitter.
   * @private
   */


  endMove() {
    const dragContext = this.dragContext;

    if (dragContext) {
      this.grid.element.classList.remove('b-moving-splitter');
      dragContext.splitterSubGrid.toggleSplitterCls('b-moving', false);
      this.dragContext = null;
    }
  }

  onCollapseClick(subGrid, splitterEl) {
    const me = this,
          grid = me.grid,
          region = splitterEl.dataset.region,
          regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
    // left one. Check if we are working with last splitter

    if (regions[0] === region) {
      const lastSubGrid = grid.getSubGrid(regions[1]);

      if (lastSubGrid.collapsed) {
        lastSubGrid.expand();
        return;
      }
    }

    subGrid.collapse();
  }

  onExpandClick(subGrid, splitterEl) {
    const me = this,
          grid = me.grid,
          region = splitterEl.dataset.region,
          regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
    // left one. Check if we are working with last splitter

    if (regions[0] === region) {
      if (!subGrid.collapsed) {
        const lastSubGrid = grid.getSubGrid(regions[1]);
        lastSubGrid.collapse();
        return;
      }
    }

    subGrid.expand();
  }
  /**
   * Update splitter position.
   * @private
   * @param newClientX
   */


  updateMove(newClientX) {
    const {
      dragContext
    } = this;

    if (dragContext) {
      const difX = newClientX - dragContext.originalX,
            newWidth = Math.min(dragContext.maxWidth, dragContext.originalWidth + difX * dragContext.flip); // SubGrids monitor their own size and keep any splitters synced

      dragContext.subGrid.width = Math.max(newWidth, dragContext.minWidth);
    }
  } //endregion
  //region Events

  /**
   * Start moving splitter on touch start.
   * @private
   * @param event
   */


  onElementTouchStart(event) {
    const target = event.target.closest('.b-grid-splitter');

    if (target) {
      this.startMove(target, event.touches[0].clientX);
    }
  }
  /**
   * Move splitter on touch move.
   * @private
   * @param event
   */


  onElementTouchMove(event) {
    if (this.dragContext) {
      this.updateMove(event.touches[0].clientX);
      event.preventDefault();
    }
  }
  /**
   * Stop moving splitter on touch end.
   * @private
   * @param event
   */


  onElementTouchEnd(event) {
    if (this.dragContext) {
      this.endMove();
      event.preventDefault();
    }
  }
  /**
   * Start moving splitter on mouse down (on splitter).
   * @private
   * @param event
   */


  onElementMouseDown(event) {
    const me = this,
          target = event.target,
          splitter = target.closest(':not(.b-row-reordering):not(.b-dragging-event):not(.b-dragging-task):not(.b-dragging-header):not(.b-dragselecting) .b-grid-splitter'),
          subGrid = splitter && me.grid.getSubGrid(splitter.dataset.region); // Only care about left clicks, avoids a bug found by monkeys

    if (event.button === 0) {
      // In case of touch screen inner splitter has 100% height and we should handle
      // it as target too
      if (target.classList.contains('b-grid-splitter') || target.classList.contains('b-grid-splitter-inner')) {
        me.startMove(splitter, event.clientX);
      } else if (target.classList.contains('b-icon-collapse-gridregion')) {
        me.onCollapseClick(subGrid, splitter);
      } else if (target.classList.contains('b-icon-expand-gridregion')) {
        me.onExpandClick(subGrid, splitter);
      }
    }
  }
  /**
   * Move splitter on mouse move.
   * @private
   * @param event
   */


  onElementMouseMove(event) {
    if (this.dragContext) {
      this.updateMove(event.clientX);
      event.preventDefault();
    }
  }
  /**
   * Stop moving splitter on mouse up.
   * @private
   * @param event
   */


  onElementMouseUp(event) {
    if (this.dragContext) {
      this.endMove();
      event.preventDefault();
    }
  }

  onSubGridCollapse({
    subGrid
  }) {
    const splitterEl = this.grid.resolveSplitter(subGrid),
          regions = this.grid.getLastRegions(); // if last region was collapsed

    if (regions[1] === subGrid.region) {
      splitterEl.classList.add('b-grid-splitter-allow-collapse');
    }
  }

  onSubGridExpand({
    subGrid
  }) {
    const splitterEl = this.grid.resolveSplitter(subGrid);
    splitterEl.classList.remove('b-grid-splitter-allow-collapse');
  } //endregion


  render() {
    const {
      regions,
      subGrids
    } = this.grid; // Multiple regions, only allow collapsing to the edges by hiding buttons

    if (regions.length > 2) {
      // Only works in a 3 subgrid scenario. To support more subgrids we have to merge splitters or something
      // on collapse. Not going down that path currently...
      subGrids[regions[0]].splitterElement.classList.add('b-left-only');
      subGrids[regions[1]].splitterElement.classList.add('b-right-only');
    }
  }

}
RegionResize.featureClass = 'b-split';
RegionResize._$name = 'RegionResize';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(RegionResize);

/***/ }),

/***/ "./lib/Grid/feature/RowCopyPaste.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/RowCopyPaste.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowCopyPaste; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/mixin/KeyMap.js */ "./lib/Core/widget/mixin/KeyMap.js");
var productName = 'gantt';



/**
 * @module Grid/feature/RowCopyPaste
 */

/**
 * Allow using [Ctrl/CMD + C/X] and [Ctrl/CMD + V] to copy/cut and paste rows. You can configure how a newly pasted record
 * is named using {@link #function-generateNewName}
 *
 * This feature is **enabled** by default
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         rowCopyPaste : true
 *     }
 * });
 * ```
 *
 * ## Keyboard shortcuts
 *
 * By default, this feature will react to Ctrl+C, Ctrl+X and Ctrl+V for standard clipboard actions.
 * You can reconfigure the keys used to trigger these actions, see {@link #config-keyMap} for more details.
 *
 *
 * @extends Core/mixin/InstancePlugin
 * @inlineexample Grid/feature/RowCopyPaste.js
 * @classtype rowCopyPaste
 * @feature
 */

class RowCopyPaste extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'RowCopyPaste';
  }

  static get type() {
    return 'rowCopyPaste';
  }

  static get pluginConfig() {
    return {
      assign: ['copyRows', 'pasteRows'],
      chain: ['onElementKeyDown', 'populateCellMenu']
    };
  }

  static get properties() {
    return {
      clipboardRecords: []
    };
  }

  static get configurable() {
    return {
      /**
       * The field to use as the name field when updating the name of copied records
       * @config {String}
       * @default
       */
      nameField: 'name',

      /**
       * The feature has the following default key mappings during editing:
       *
       * | Keys        | Action       |
       * |-------------|--------------|
       * | Ctrl+C      | copy         |
       * | Ctrl+X      | cut          |
       * | Ctrl+V      | paste        |
       *
       * You can supply your own key map if you want to change any mapping, or set it to `null` to disable all keyboard
       * shortcuts.
       *
       * ```javascript
       * const grid = new Grid({
       *    features : {
       *        rowCopyPaste : {
       *            keyMap : {
       *                // disable cut via keyboard
       *                'Ctrl-X' : null
       *            }
       *        }
       *    }
       * });
       * ```
       *
       * @config {Object}
       */
      keyMap: {
        'Ctrl+C': 'copy',
        'Ctrl+X': 'cut',
        'Ctrl+V': 'paste'
      },
      copyRecordText: 'L{copyRecord}',
      cutRecordText: 'L{cutRecord}',
      pasteRecordText: 'L{pasteRecord}',
      localizableProperties: ['copyRecordText', 'cutRecordText', 'pasteRecordText']
    };
  }

  construct(grid, config) {
    super.construct(grid, config);
    grid.rowManager.on({
      beforeRenderRow: 'onBeforeRenderRow',
      thisObj: this
    });
    this.grid = grid;
  }

  onBeforeRenderRow({
    row,
    record
  }) {
    row.cls['b-cut-row'] = record.meta.isCut;
  }

  onElementKeyDown({
    ctrlKey,
    target,
    key
  }) {
    const me = this,
          cellEdit = me.grid.features.cellEdit; // No action if
    // 1. there is selected text on the page
    // 2. cell editing is active
    // 3. cursor is not in the grid (filter bar etc)

    if (!me.disabled && window.getSelection().toString().length === 0 && (!cellEdit || !cellEdit.isEditing) && target.closest('.b-grid-body-container')) {
      me.performKeyMapAction(...arguments);
    }
  }

  copy() {
    this.copyRows();
  }

  cut() {
    this.copyRows(true);
  }

  paste() {
    this.pasteRows();
  }
  /**
   * Copy or cut rows to clipboard to paste later
   *
   * @fires beforeCopy
   * @param {Boolean} [isCut] Copies by default, pass `true` to cut
   * @category Common
   * @on-owner
   */


  copyRows(isCut = false) {
    const me = this,
          {
      client
    } = me;
    /**
     * Fires on the owning Grid before a copy action is performed, return `false` to prevent the action
     * @event beforeCopy
     * @preventable
     * @on-owner
     * @param {Grid.view.Grid} source Owner grid
     * @param {Core.data.Model[]} records The records about to be copied
     * @param {Boolean} isCut `true` if this is a cut action
     */

    if (client.readOnly || client.trigger('beforeCopy', {
      records: client.selectedRecords,
      isCut
    }) === false) {
      return;
    }

    me._isCut = isCut;
    me.clipboardRecords = client.selectedRecords.slice();
    client.store.forEach(rec => {
      rec.meta.isCut = me._isCut && me.clipboardRecords.includes(rec);
    }); // refresh to call reapply the cls for records where the cut was canceled

    if (isCut) {
      client.refreshRows();
    }
  }
  /**
   * Paste rows above selected or passed record
   *
   * @fires beforePaste
   * @param {Core.data.Model} [record] Paste above this record, or currently selected record if left out
   * @category Common
   * @on-owner
   */


  pasteRows(record) {
    const me = this,
          records = me.clipboardRecords,
          referenceRecord = record || me.client.selectedRecord;
    /**
     * Fires on the owning Grid before a paste action is performed, return `false` to prevent the action
     * @event beforePaste
     * @preventable
     * @on-owner
     * @param {Grid.view.Grid} source Owner grid
     * @param {Core.data.Model} referenceRecord The reference record, the clipboard event records will
     * be pasted above this record
     * @param {Core.data.Model[]} records The records about to be pasted
     * @param {Boolean} isCut `true` if this is a cut action
     */

    if (me.client.readOnly || !records.length || me.client.trigger('beforePaste', {
      records,
      referenceRecord,
      isCut: me._isCut
    }) === false) {
      return [];
    } // sort selected to move records to make sure it will be added in correct order independent of how it was selected.
    // Should be done with real records in the clipboard, after records are copied, all indexes will be changed


    me.sortByIndex(records);
    const recordsToProcess = records.map(rec => {
      if (me._isCut) {
        // reset record cut state
        rec.meta.isCut = false;
      } else {
        rec = rec.copy();
        rec[me.nameField] = me.generateNewName(rec);
      }

      return rec;
    });

    if (me._isCut) {
      me.client.store.move(recordsToProcess, referenceRecord); // reset clipboard

      me._isCut = false;
      me.clipboardRecords = [];
    } else {
      me.insertCopiedRecords(referenceRecord, recordsToProcess);
      me.client.selectedRecords = recordsToProcess;
    }

    return recordsToProcess;
  }
  /**
   * A method used to generate the name for a copy-pasted record. By defaults appends "- 2", "- 3" as a suffix. Override
   * it to provide your own naming of pasted records.
   *
   * @param {Core.data.Model} record The new record being pasted
   * @return {String}
   */


  generateNewName(record) {
    const originalName = record[this.nameField];
    let counter = 2;

    while (this.client.store.findRecord(this.nameField, `${originalName} - ${counter}`)) {
      counter++;
    }

    return `${originalName} - ${counter}`;
  }

  insertCopiedRecords(recordReference, toInsert) {
    const {
      store
    } = this.client;

    if (store.tree) {
      return recordReference.parent.insertChild(toInsert, recordReference.nextSibling);
    } else {
      const idxPaste = store.indexOf(recordReference);
      return store.insert(idxPaste + 1, toInsert);
    }
  }

  populateCellMenu({
    record,
    items
  }) {
    const me = this;

    if (!me.client.readOnly && record && !record.isSpecialRow) {
      items.copy = {
        text: me.copyRecordText,
        localeClass: me,
        icon: 'b-icon b-icon-copy',
        weight: 100,
        onItem: () => me.copyRows()
      };
      items.cut = {
        text: me.cutRecordText,
        localeClass: me,
        icon: 'b-icon b-icon-cut',
        weight: 110,
        onItem: () => me.copyRows(true)
      };

      if (me.clipboardRecords.length) {
        items.paste = {
          text: me.pasteRecordText,
          localeClass: me,
          icon: 'b-icon b-icon-paste',
          weight: 120,
          onItem: () => me.pasteRows(record)
        };
      }
    }
  }
  /**
   * Sort array of records ASC by its indexes stored in indexPath
   * @param {Core.data.Model[]} array array to sort
   * @private
   */


  sortByIndex(array) {
    return array.sort((rec1, rec2) => {
      const idx1 = rec1.indexPath,
            idx2 = rec2.indexPath;

      for (let i = 0; i <= idx1.length; i++) {
        if (idx1[i] < idx2[i]) {
          return -1;
        }

        if (idx1[i] > idx2[i]) {
          return 1;
        }
      }
    });
  }

}
RowCopyPaste.featureClass = 'b-row-copypaste';
RowCopyPaste._$name = 'RowCopyPaste';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(RowCopyPaste, true, 'Grid');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(RowCopyPaste, false, 'Gantt');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(RowCopyPaste, false, 'SchedulerPro');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(RowCopyPaste, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Grid/feature/RowReorder.js":
/*!****************************************!*\
  !*** ./lib/Grid/feature/RowReorder.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowReorder; });
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';
/**
* @module Grid/feature/RowReorder
*/







/**
 * Allows user to reorder rows by dragging them. To get notified about row reorder listen to `change` event
 * on the grid {@link Core.data.Store store}.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 * This feature is **enabled** by default for Gantt.
 *
 * If the grid is set to {@link Grid.view.Grid#config-readOnly}, reordering is disabled. Inside all event listeners you
 * have access a `context` object which has a `record` property (the dragged record).
 *
 * ## Validation
 * You can validate the drag drop flow by listening to the `gridrowdrag` event. Inside this listener you have access the
 * `index` property which is the target drop position.
 * For trees you get access to the `parent` record and `index`, where index means the child index inside the parent.
 *
 * You can also have an async finalization step using the {@link #event-gridRowBeforeDropFinalize}, for showing a
 * confirmation dialog or making a network request to decide if drag operation is valid (see code snippet below)
 *
 * ```
 * features : {
 *     rowReorder : {
 *         listeners : {
 *             gridRowDrag : ({ context }) => {
 *                // Here you have access to context.insertBefore, and additionally context.parent for trees
 *             },
 *
 *             gridRowBeforeDropFinalize : async ({ context }) => {
 *                const result = await MessageDialog.confirm({
 *                    title   : 'Please confirm',
 *                    message : 'Did you want the row here?'
 *                });
 *
 *                // true to accept the drop or false to reject
 *                return result === MessageDialog.yesButton;
 *             }
 *         }
 *     }
 * }
 * ```
 *
 * Note, that this feature uses the concept of "insert before" when choosing a drop point in the data.
 *
 * So the dropped record's position is *before the visual next record's position*.
 *
 * This may look like a pointless distinction, but consider the case when a Store is filtered.
 *
 * The record *above* the drop point may have several filtered out records below it. When unfiltered, the dropped
 * record will be *below* these because of the "insert before" behaviour.
 *
 * ## Behavior with multiple subgrids
 *
 * For grids with multiple subgrids, row reordering is only enabled for the first subgrid.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/rowreordering
 * @classtype rowReorder
 * @feature
 */

class RowReorder extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Events

  /**
   * Fired before dragging starts, return false to prevent the drag operation.
   * @preventable
   * @event gridRowBeforeDragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
   * @param {Core.data.Model[]} context.records The dragged row records
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired when dragging starts.
   * @event gridRowDragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
   * @param {Core.data.Model[]} context.records The dragged row records
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired while the row is being dragged, in the listener function you have access to `context.insertBefore` a grid / tree record, and additionally `context.parent` (a TreeNode) for trees. You can
   * signal that the drop position is valid or invalid by setting `context.valid = false;`
   * @event gridRowDrag
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
   * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
   * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
   * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
   * @param {Core.data.Model[]} context.records The dragged row records
   * @param {MouseEvent} event
   */

  /**
   * Fired before the row drop operation is finalized. You can return false to abort the drop operation, or a
   * Promise yielding `true` / `false` which allows for asynchronous abort (e.g. first show user a confirmation dialog).
   * @event gridRowBeforeDropFinalize
   * @preventable
   * @async
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid
   * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
   * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
   * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
   * @param {Core.data.Model[]} context.records The dragged row records
   * @param {Object[]} context.oldPositionContext An array of objects with information about the previous tree position.
   * Objects contain the record, and its original `parentIndex` and `parentId` values
   * @param {MouseEvent} event
   */

  /**
   * Fired after the row drop operation has completed, regardless of validity
   * @event gridRowDrop
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {Boolean} context.valid true or false depending on whether the drop position was valid
   * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
   * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
   * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
   * @param {Core.data.Model[]} context.records The dragged row records
   * @param {Object[]} context.oldPositionContext An array of objects with information about the previous tree position.
   * Objects contain the record, and its original `parentIndex` and `parentId` values
   * @param {MouseEvent} event
   */

  /**
   * Fired when a row drag operation is aborted
   * @event gridRowAbort
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {MouseEvent} event
   */
  //endregion
  //region Init
  static get $name() {
    return 'RowReorder';
  }

  static get configurable() {
    return {
      /**
       * If hovering over a parent node for this period of a time in a tree, the node will expand
       * @config {Number}
       */
      hoverExpandTimeout: 1000,

      /**
       * The amount of milliseconds to wait after a touchstart, before a drag gesture will be allowed to start.
       * @config {Number}
       * @default
       */
      touchStartDelay: 300
    };
  }

  construct(grid, config) {
    this.grid = grid;
    super.construct(...arguments);
  }

  doDestroy() {
    var _this$dragHelper;

    (_this$dragHelper = this.dragHelper) === null || _this$dragHelper === void 0 ? void 0 : _this$dragHelper.destroy();
    super.doDestroy();
  }
  /**
   * Initialize drag & drop (called from render)
   * @private
   */


  init() {
    const me = this,
          {
      grid
    } = me;
    me.dragHelper = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      name: 'rowReorder',
      mode: 'translateXY',
      cloneTarget: true,
      dragThreshold: 10,
      targetSelector: '.b-grid-row',
      lockX: true,
      transitionDuration: grid.transitionDuration,
      scrollManager: grid.scrollManager,
      dragWithin: grid.element,
      outerElement: me.targetSubGridElement,
      touchStartDelay: me.touchStartDelay,
      monitoringConfig: {
        scrollables: [{
          element: grid.scrollable.element,
          direction: 'vertical'
        }]
      },
      // Since parent nodes can expand after hovering, meaning original drag start position now refers to a different point in the tree
      ignoreSamePositionDrop: false,

      createProxy(element) {
        const clone = element.cloneNode(true),
              container = document.createElement('div');
        clone.removeAttribute('id'); // The containing element will be positioned instead

        clone.style.transform = '';
        container.appendChild(clone);

        if (grid.selectedRecords.length > 1) {
          const clone2 = clone.cloneNode(true);
          clone2.classList.add('b-row-dragging-multiple');
          container.appendChild(clone2);
        }

        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeClsGlobally(container, 'b-selected', 'b-hover', 'b-focused');
        return container;
      },

      listeners: {
        beforedragstart: 'onBeforeDragStart',
        dragstart: 'onDragStart',
        drag: 'onDrag',
        drop: 'onDrop',
        reset: 'onReset',
        prio: 10000,
        // To ensure our listener is run before the relayed listeners (for the outside world)
        thisObj: me
      }
    });
    me.dropIndicator = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
      parent: grid.bodyContainer,
      className: 'b-row-drop-indicator'
    });
    me.relayEvents(me.dragHelper, ['beforeDragStart', 'dragStart', 'drag', 'abort'], 'gridRow');
  } //endregion
  //region Plugin config


  static get pluginConfig() {
    return {
      after: ['onPaint']
    };
  }

  get targetSubGridElement() {
    const targetSubGrid = this.grid.regions[0];
    return this.grid.subGrids[targetSubGrid].element;
  } //endregion
  //region Events (drop)


  onBeforeDragStart({
    context
  }) {
    const me = this,
          grid = me.grid,
          subGridEl = me.targetSubGridElement; // Only dragging enabled in the leftmost grid section

    if (me.disabled || grid.readOnly || !subGridEl.contains(context.element)) {
      return false;
    }

    const records = context.records = grid.selectedRecords.slice().sort((r1, r2) => grid.store.indexOf(r1) - grid.store.indexOf(r2));
    context.startRecord = grid.getRecordFromElement(context.element);
    context.originalRowTop = grid.rowManager.getRowFor(context.startRecord).top; // Backwards compat, @deprecated - remove in 5.0

    context.record = context.startRecord;
    return records.length > 0 && !records.some(rec => rec.isSpecialRow);
  }

  onDragStart({
    context
  }) {
    var _contextMenu$hideCont, _cellMenu$hideContext, _headerMenu$hideConte;

    const me = this,
          {
      cellEdit,
      contextMenu,
      cellMenu,
      headerMenu
    } = me.grid.features;

    if (cellEdit) {
      me.cellEditDisabledState = cellEdit.disabled;
      cellEdit.disabled = true; // prevent editing from being started through keystroke during row reordering
    } // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.


    contextMenu === null || contextMenu === void 0 ? void 0 : (_contextMenu$hideCont = contextMenu.hideContextMenu) === null || _contextMenu$hideCont === void 0 ? void 0 : _contextMenu$hideCont.call(contextMenu, false);
    cellMenu === null || cellMenu === void 0 ? void 0 : (_cellMenu$hideContext = cellMenu.hideContextMenu) === null || _cellMenu$hideContext === void 0 ? void 0 : _cellMenu$hideContext.call(cellMenu, false);
    headerMenu === null || headerMenu === void 0 ? void 0 : (_headerMenu$hideConte = headerMenu.hideContextMenu) === null || _headerMenu$hideConte === void 0 ? void 0 : _headerMenu$hideConte.call(headerMenu, false);
    me.grid.element.classList.add('b-row-reordering');
    const focusedCell = context.element.querySelector('.b-focused');
    focusedCell === null || focusedCell === void 0 ? void 0 : focusedCell.classList.remove('b-focused');
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeClasses(context.element.firstElementChild, ['b-selected', 'b-hover']);
  }

  onDrag({
    context,
    event
  }) {
    const me = this,
          {
      grid
    } = me,
          {
      store,
      rowManager
    } = grid,
          {
      dragWithin
    } = me.dragHelper; // Ignore if user drags outside grid area

    if (!dragWithin.contains(event.target)) {
      context.valid = false;
      return;
    }

    let valid = context.valid,
        row = grid.rowManager.getRowAt(event.clientY),
        overRecord,
        dataIndex,
        after,
        insertBefore;

    if (row) {
      const rowTop = row.top + grid._bodyRectangle.y - grid.scrollable.y,
            middleY = rowTop + row.height / 2;
      dataIndex = row.dataIndex;
      overRecord = store.getAt(dataIndex); // Drop after row below if mouse is in bottom half of hovered row

      after = event.clientY > middleY;
    } // User dragged below last row or above the top row.
    else {
      if (event.clientY < grid._bodyRectangle.y) {
        dataIndex = 0;
        overRecord = store.first;
        after = false;
      } else {
        dataIndex = store.count - 1;
        overRecord = store.last;
        after = true;
      }

      row = grid.rowManager.getRow(dataIndex);
    }

    if (overRecord === me.overRecord && me.after === after) {
      context.valid = me.reorderValid; // nothing's changed

      return;
    }

    me.overRecord = overRecord;
    me.after = after; // Hovering the dragged record. This is a no-op.
    // But still gather the contextual data.

    if (overRecord === context.startRecord) {
      valid = false;
    }

    if (store.tree) {
      insertBefore = after ? overRecord.nextSibling : overRecord; // For trees, prevent moving a parent into its own hierarchy

      if (context.records.some(rec => rec.contains(overRecord))) {
        valid = false;
      }

      if (context.parent) {
        const oldParentRow = rowManager.getRowById(context.parent);
        oldParentRow === null || oldParentRow === void 0 ? void 0 : oldParentRow.removeCls('b-row-reordering-target-parent');
      }

      context.parent = overRecord.parent;

      if (!context.parent.isRoot) {
        const parentRow = rowManager.getRowById(context.parent);
        parentRow === null || parentRow === void 0 ? void 0 : parentRow.addCls('b-row-reordering-target-parent');
      }

      me.clearTimeout(me.hoverTimer);

      if (overRecord && overRecord.isParent && !overRecord.isExpanded(store)) {
        me.hoverTimer = me.setTimeout(() => grid.expand(overRecord), me.hoverExpandTimeout);
      }
    } else {
      insertBefore = after ? store.getAt(dataIndex + 1) : overRecord;
    } // Provide visual clue to user of the drop position


    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateY(me.dropIndicator, row.top + (after ? row.height : 0)); // Public property used for validation

    context.insertBefore = insertBefore;
    context.valid = me.reorderValid = valid;
  }
  /**
   * Handle drop
   * @private
   */


  async onDrop(event) {
    const me = this,
          context = event.context;
    context.valid = context.valid && me.reorderValid;

    if (context.valid) {
      context.asyncCleanup = context.async = true;

      if (me.client.store.tree) {
        // For tree scenario, add context about previous positions of dragged tree nodes
        context.oldPositionContext = context.records.map(record => {
          var _record$parent;

          return {
            record,
            parentId: (_record$parent = record.parent) === null || _record$parent === void 0 ? void 0 : _record$parent.id,
            parentIndex: record.parentIndex
          };
        });
      } // Outside world provided us one or more Promises to wait for


      const result = await me.trigger('gridRowBeforeDropFinalize', event);

      if (result === false) {
        context.valid = false;
      }

      if (!context.valid) {// TODO set correct return position for cloned row
      }

      context.element.classList.add('b-dropping');
      await _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].waitForTransitionEnd({
        element: context.element.firstElementChild,
        property: 'transform',
        thisObj: me.client
      });
      await me.finalizeReorder(context);
    } // already dropped the node, don't have to expand any node hovered anymore
    // (cancelling expand action after timeout)


    me.clearTimeout(me.hoverTimer);
    me.overRecord = me.after = null;
    me.trigger('gridRowDrop', event);
  }

  async finalizeReorder(context) {
    const me = this,
          {
      grid
    } = me,
          {
      store
    } = grid;
    let records = context.records;
    context.valid = context.valid && !records.some(rec => !store.includes(rec));

    if (context.valid) {
      let result;

      if (store.tree) {
        // Remove any selected child records of parent nodes
        records = records.filter(record => !record.parent || !records.includes(record.parent));
        result = await context.parent.tryInsertChild(records, context.insertBefore); // remove reorder cls from preview parent element dropped

        grid.rowManager.forEach(r => r.removeCls('b-row-reordering-target-parent'));
        context.valid = result !== false;
      } else {
        store.move(records, context.insertBefore);
      }

      store.clearSorters();
    }

    context.finalize(context.valid);
    grid.element.classList.remove('b-row-reordering');
  }
  /**
   * Clean up on reset
   * @private
   */


  onReset() {
    const me = this,
          cellEdit = me.grid.features.cellEdit;
    me.grid.element.classList.remove('b-row-reordering');

    if (cellEdit) {
      cellEdit.disabled = me.cellEditDisabledState;
    }

    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeClsGlobally(me.grid.element, 'b-row-reordering-target-parent');
  } //endregion
  //region Render

  /**
   * Updates DragHelper with updated headers when grid contents is rerendered
   * @private
   */


  onPaint() {
    // columns shown, hidden or reordered
    this.init();
  } //endregion


}
RowReorder.featureClass = '';
RowReorder._$name = 'RowReorder';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(RowReorder, false);
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(RowReorder, true, 'Gantt');

/***/ }),

/***/ "./lib/Grid/feature/Search.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Search.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Search; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt'; //TODO: Should listen for store search also, to work the other way around
//TODO: Buggy sometimes, try searching for Barcelona tigers, navigate using buttons
//TODO: Allow regex
//TODO: Optional case sensitive
//TODO: build in UI, popup with keyboard shortcut?







/**
 * @module Grid/feature/Search
 */

/**
 * Feature that allows the user to search the entire grid. Navigate between hits using the
 * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
 *
 * Note that this feature does not include a UI, please build your own and call appropriate methods in the feature. For
 * a demo implementation, see
 * <a href="../examples/search" target="_blank">Search example</a>.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable Search
 * let grid = new Grid({
 *   features: {
 *     search: true
 *   }
 * });
 *
 * // perform search
 * grid.features.search.search('steve');
 *
 * @demo Grid/search
 * @classtype search
 * @inlineexample Grid/feature/Search.js
 * @feature
 */

class Search extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Init
  static get $name() {
    return 'Search';
  }

  static get configurable() {
    return {
      limit: 1000
    };
  }

  static get properties() {
    return {
      hitCls: 'b-search-hit',
      hitCellCls: 'b-search-hit-cell',
      hitCellBadgeCls: 'b-search-hit-cell-badge',
      hitTextCls: 'b-search-hit-text',
      hitColumns: new Set()
    };
  }

  construct(grid, config) {
    const me = this;
    super.construct(grid, config);
    Object.assign(me, {
      grid,
      find: '',
      hitEls: [],
      treeWalker: grid.setupTreeWalker(grid.element, NodeFilter.SHOW_TEXT, () => NodeFilter.FILTER_ACCEPT, false)
    }); // When new nodes appear due to node expand, include them in the search

    grid.on({
      expandNode: 'onTreeNodeExpand',
      thisObj: me
    });
  }

  onTreeNodeExpand() {
    if (this.find) {
      this.requestAnimationFrame(this.search, [this.find, false, true]);
    }
  }

  doDestroy() {
    this.clear(true);
    super.doDestroy();
  }

  doDisable(disable) {
    if (disable) {
      this.clear();
    }

    super.doDisable(disable);
  }

  get store() {
    return this.grid.store;
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['populateCellMenu', 'onElementKeyDown']
    };
  } //endregion
  //region Search

  /**
   * Performs a search and highlights hits.
   * @param {String} find Text to search for
   * @param {Boolean} gotoHit Go to first hit after search
   * @param {Boolean} reapply Pass true to force search
   */


  search(find, gotoHit = true, reapply = false) {
    const me = this; // empty search considered a clear

    if (!find) {
      return me.clear();
    } // searching for same thing again, do nothing


    if (!reapply && find === me.find || me.disabled) {
      return;
    }

    const {
      grid,
      store
    } = me,
          // Only search columns in use
    columns = grid.columns.visibleColumns.filter(col => col.searchable !== false),
          fields = columns.map(col => col.field),
          found = store.search(find, fields);
    let i = 1;
    Object.assign(me, {
      foundMap: {},
      prevFound: me.found,
      found,
      find,
      findRe: new RegExp(`(\\s+)?(${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].escapeRegExp(String(find))})(\\s+)?`, 'ig')
    });
    me.clearHits();

    if (!found) {
      return;
    } // columns from previous search, reset htmlEncode


    me.hitColumns.forEach(col => {
      col.disableHtmlEncode = false;
    });
    me.hitColumns.clear(); // highlight hits for visible cells

    for (const hit of found) {
      me.foundMap[hit.field + '-' + hit.id] = i++; // disable htmlEncode for columns with hits

      const column = grid.columns.get(hit.field);

      if (column && !me.hitColumns.has(column)) {
        column.disableHtmlEncode = true;
        me.hitColumns.add(column);
      } // limit hits


      if (i > me.limit) {
        break;
      }
    }

    if (!me.listenersInitialized) {
      grid.rowManager.on({
        name: 'renderCell',
        renderCell: 'renderCell',
        thisObj: me
      });
      store.on({
        name: 'storeRefresh',
        [`refresh${grid.asyncEventSuffix}`]: 'onStoreRefresh',
        thisObj: me
      });
      me.listenersInitialized = true;
    }

    grid.refreshRows();
    grid.trigger('search', {
      grid,
      find,
      found
    });

    if (gotoHit && !me.isHitFocused) {
      me.gotoNextHit(true);
    }

    return found;
  }

  clearHits() {
    // clear old hits
    for (const cellElement of _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(this.grid.element, '.' + this.hitCls)) {
      // IE11 doesnt support this
      //cell.classList.remove('b-search-hit', 'b-search-hit-cell');
      cellElement.classList.remove(this.hitCls);
      cellElement.classList.remove(this.hitCellCls); // rerender cell to remove search-hit-text

      const row = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].get(cellElement).row; // Need to force replace the markup

      row.forceInnerHTML = true;
      row.renderCell({
        cellElement
      });
      row.forceInnerHTML = false;
    }
  }
  /**
   * Clears search results.
   */


  clear(silent = false) {
    const me = this,
          {
      grid
    } = me;

    if (me.foundMap) {
      delete me.foundMap;
    }

    delete me.find;
    me.clearHits();

    if (me.listenersInitialized) {
      this.detachListeners('renderCell');
      this.detachListeners('storeRefresh');
      me.listenersInitialized = false;
    }

    if (!silent) {
      grid.trigger('clearSearch', {
        grid
      });
    }
  }
  /**
   * Number of results found
   * @readonly
   * @property {Number}
   */


  get foundCount() {
    var _this$found$length, _this$found;

    return (_this$found$length = (_this$found = this.found) === null || _this$found === void 0 ? void 0 : _this$found.length) !== null && _this$found$length !== void 0 ? _this$found$length : 0;
  } //endregion
  //region Navigation

  /**
   * Returns true if focused row is a hit
   * @property {Boolean}
   * @readonly
   */


  get isHitFocused() {
    const me = this,
          {
      grid
    } = me,
          currentIndex = grid.focusedCell ? grid.store.indexOf(grid.focusedCell.id) : -1,
          currentColumn = grid.focusedCell ? grid.columns.getById(grid.focusedCell.columnId) : null;
    return currentIndex !== -1 && me.found.some(hit => hit.index === currentIndex && currentColumn && hit.field === currentColumn.field);
  }
  /**
   * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
   */


  gotoNextHit(fromStart = false) {
    var _me$found;

    const me = this;
    if (!((_me$found = me.found) !== null && _me$found !== void 0 && _me$found.length)) return;
    const {
      grid
    } = me,
          fromCell = grid.focusedCell || grid.lastFocusedCell,
          currentIndex = fromCell && !fromStart ? grid.store.indexOf(fromCell.id) : -1,
          nextHit = me.found.findIndex(hit => hit.index > currentIndex);

    if (nextHit !== -1) {
      me.gotoHit(nextHit);
    }
  }
  /**
   * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
   */


  gotoPrevHit() {
    var _me$found2;

    const me = this;
    if (!((_me$found2 = me.found) !== null && _me$found2 !== void 0 && _me$found2.length)) return;
    const {
      grid,
      found
    } = me,
          fromCell = grid.focusedCell || grid.lastFocusedCell,
          currentIndex = fromCell ? grid.store.indexOf(fromCell.id) : 0;

    for (let i = found.length - 1; i--; i >= 0) {
      const hit = found[i];

      if (hit.index < currentIndex) {
        me.gotoHit(i);
        break;
      }
    }
  }
  /**
   * Go to specified hit.
   * @param {Number} index
   */


  gotoHit(index) {
    const {
      grid
    } = this,
          nextHit = this.found[index];

    if (nextHit) {
      grid.focusCell({
        field: nextHit.field,
        id: nextHit.id
      });
    }

    return Boolean(nextHit);
  }
  /**
   * Go to the first hit.
   */


  gotoFirstHit() {
    this.gotoHit(0);
  }
  /**
   * Go to the last hit.
   */


  gotoLastHit() {
    this.gotoHit(this.found.length - 1);
  } //endregion
  //region Render

  /**
   * Called from SubGrid when a cell is rendered. Highlights search hits.
   * @private
   */


  renderCell({
    cellElement,
    column,
    record,
    value
  }) {
    var _me$foundMap;

    const me = this,
          {
      treeWalker,
      findRe,
      hitTextCls
    } = me,
          hitIndex = (_me$foundMap = me.foundMap) === null || _me$foundMap === void 0 ? void 0 : _me$foundMap[column.field + '-' + record.id];

    if (hitIndex) {
      // highlight cell
      cellElement.classList.add(me.hitCls); // highlight in cell if found in innerHTML

      const inner = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].down(cellElement, '.b-grid-cell-value,.b-tree-cell-value') || cellElement;

      if (String(value).toLowerCase() === String(me.find).toLowerCase()) {
        inner.innerHTML = `<span class="${me.hitTextCls}">${inner.innerHTML}</span><div class="${me.hitCellBadgeCls}">${hitIndex}</div>`;
      } // Replace every occurrence of the text in every descendant text node with a span
      // encapsulating the matched string.
      else {
        treeWalker.currentNode = inner;

        for (let textNode = treeWalker.nextNode(); textNode && inner.contains(textNode);) {
          const nodeToReplace = textNode,
                textContent = textNode.nodeValue,
                newText = []; // Move onto next text node before we replace the node with a highlihght HTML sequence

          textNode = treeWalker.nextNode();
          let offset = findRe.lastIndex; // Convert textContent into an innerHTML string which htmlEncodes the text and embeds
          // a highlighting span which contains the target text.

          for (let match = findRe.exec(textContent); match; match = findRe.exec(textContent)) {
            const preamble = textContent.substring(offset, match.index),
                  spaceBefore = match[1] ? '\xa0' : '',
                  v = match[2],
                  spaceAfter = match[3] ? '\xa0' : '';
            newText.push(`${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].encodeHtml(preamble)}${spaceBefore}<span class="${hitTextCls}">${v}</span>${spaceAfter}`);
            offset = findRe.lastIndex;
          }

          newText.push(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].encodeHtml(textContent.substring(offset))); // Insert a fragment with each match wrapped with a span.

          nodeToReplace.parentNode.insertBefore(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElementFromTemplate(newText.join(''), {
            fragment: true
          }), nodeToReplace);
          nodeToReplace.remove();
        }

        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
          parent: cellElement,
          className: me.hitCellBadgeCls,
          text: hitIndex
        });
      }

      me.hitEls.push(cellElement);
    }
  } //endregion
  //region Context menu

  /**
   * Add search menu item to cell context menu.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Core.data.Model} options.record Record for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateCellMenu({
    column,
    record,
    items
  }) {
    const me = this;

    if (column.searchable) {
      items.search = {
        text: 'L{searchForValue}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-search',
        cls: 'b-separator',
        weight: 200,
        disabled: me.disabled,
        onItem: () => {
          // TODO: Only extract selection from current cell instead? Lazy way for now
          let sel = window.getSelection().toString();

          if (!sel) {
            sel = record[column.field];
          }

          me.search(sel);
        }
      };
    }
  } //endregion
  //region Events

  /**
   * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
   * @private
   * @param event KeyboardEvent
   */


  onElementKeyDown(event) {
    const me = this;

    if (me.find && me.find !== '') {
      if (event.key === 'F3' || event.key.toLowerCase() === 'g' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();

        if (event.shiftKey) {
          me.gotoPrevHit();
        } else {
          me.gotoNextHit();
        }
      }
    }
  }

  onStoreRefresh() {
    this.search(this.find, false, true);
  } //endregion


}
Search.featureClass = 'b-search';
Search._$name = 'Search';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(Search);

/***/ }),

/***/ "./lib/Grid/feature/Sort.js":
/*!**********************************!*\
  !*** ./lib/Grid/feature/Sort.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Sort; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt'; //TODO: Allow multisort using multitouch?
//TODO: UI sort of broken with grouped headers, take a look at groupedheaders demo






/**
 * @module Grid/feature/Sort
 */

/**
 * Allows sorting of grid by clicking (or tapping) headers, also displays which columns grid is sorted by (numbered if
 * using multisort). Use modifier keys for multisorting: ctrl + click to add sorter, ctrl + alt + click to remove sorter.
 * The actual sorting is done by the store, see {@link Core.data.mixin.StoreSort#function-sort Store#sort()}.
 *
 * {@inlineexample Grid/feature/Sort.js}
 *
 * ```javascript
 * // sorting feature is enabled, no default value though
 * const grid = new Grid({
 *     features : {
 *         sort : true
 *     }
 * });
 *
 * // use initial sorting
 * const grid = new Grid({
 *     features : {
 *         sort : 'name'
 *     }
 * });
 *
 * // can also be specified on the store
 * const grid = new Grid({
 *     store : {
 *         sorters : [
 *             { field : 'name', ascending : false }
 *         ]
 *     }
 * });
 *
 * // custom sorting function can also be specified on the store
 * const grid = new Grid({
 *     store : {
 *         sorters : [{
 *             fn : (recordA, recordB) => {
 *                 // apply custom logic, for example:
 *                 return recordA.name.length < recordB.name.length ? -1 : 1;
 *             }
 *         }]
 *     }
 * });
 * ```
 *
 * For info on programmatically handling sorting, see {@link Core.data.mixin.StoreSort StoreSort}:
 *
 * ```javascript
 * const grid = new Grid({ });
 * // Programmatic sorting of the store, Grids rows and UI will be updated
 * grid.store.sort('age');
 * ```
 *
 * Grid columns can define custom sorting functions (see {@link Grid.column.Column#config-sortable Column#sortable}).
 * If this feature is configured with `prioritizeColumns: true`, those functions will also be used when sorting
 * programmatically:
 *
 * ```javascript
 * const grid = new Grid({
 *     columns : [
 *         {
 *             field : 'age',
 *             text : 'Age',
 *             sortable(lhs, rhs) {
 *               // Custom sorting, see Array#sort
 *             }
 *         }
 *     ],
 *
 *     features : {
 *         sort : {
 *             prioritizeColumns : true
 *         }
 *     }
 * });
 *
 * // Sortable fn will also be used when sorting programmatically
 * grid.store.sort('age');
 * ```
 *
 * This feature is **enabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/sorting
 * @classtype sort
 * @feature
 */

class Sort extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  //region Config
  static get $name() {
    return 'Sort';
  }

  static get configurable() {
    return {
      /**
       * Enable multi sort
       * @config {Boolean}
       * @default
       */
      multiSort: true,

      /**
       * Use custom sorting functions defined on columns also when programmatically sorting by the columns field.
       *
       * ```javascript
       * const grid = new Grid({
       *     columns : [
       *         {
       *             field : 'age',
       *             text : 'Age',
       *             sortable(lhs, rhs) {
       *               // Custom sorting, see Array#sort
       *             }
       *         }
       *     ],
       *
       *     features : {
       *         sort : {
       *             prioritizeColumns : true
       *         }
       *     }
       * });
       *
       * grid.store.sort('age');
       * ```
       *
       * @config {Boolean}
       * @default
       */
      prioritizeColumns: false
    };
  }

  static get properties() {
    return {
      ignoreRe: new RegExp([// Stop this feature from having to know the internals of two other optional features.
      'b-grid-header-resize-handle', 'b-filter-icon'].join('|')),
      sortableCls: 'b-sortable',
      sortedCls: 'b-sort',
      sortedAscCls: 'b-asc',
      sortedDescCls: 'b-desc'
    };
  } //endregion
  //region Init


  construct(grid, config) {
    // process initial config into an actual config object
    config = this.processConfig(config);
    this.grid = grid;
    this.bindStore(grid.store);
    super.construct(grid, config);
  } // Sort feature handles special config cases, where user can supply a string or an array of sorters
  // instead of a normal config object


  processConfig(config) {
    if (typeof config === 'string' || Array.isArray(config)) {
      return {
        field: config,
        ascending: null
      };
    }

    return config;
  } // override setConfig to process config before applying it


  setConfig(config) {
    super.setConfig(this.processConfig(config));
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      beforeSort: 'onStoreBeforeSort',
      sort: 'syncHeaderSortState',
      thisObj: this
    });
  }

  set field(field) {
    // Use columns sortable config for initial sorting if it is specified
    const column = this.grid.columns.get(field);

    if (column && typeof column.sortable === 'object') {
      // Normalization of Store & CollectionSorter differences
      column.sortable.field = column.sortable.property || field;
      field = column.sortable;
    }

    this.store.sort(field, this.ascending);
  } // Avoid caching store, it might change


  get store() {
    return this.grid.store;
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onElementClick', 'populateHeaderMenu', 'getColumnDragToolbarItems', 'renderHeader', 'onPaint', 'bindStore']
    };
  } //endregion
  //region Headers

  /**
   * Update headers to match stores sorters (displays sort icon in correct direction on them)
   * @private
   */


  syncHeaderSortState() {
    const me = this,
          {
      grid
    } = me;

    if (!grid.hideHeaders && grid.isPainted) {
      const storeSorters = me.store.sorters,
            sorterCount = storeSorters.length,
            classList = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"]();
      let sorter; // Sync the sortable, sorted, and sortIndex state of each leaf header element

      for (const leafColumn of grid.columns.visibleColumns) {
        var _leafColumn$textWrapp;

        const leafHeader = leafColumn.element,
              // TimeAxisColumn in Scheduler has no textWrapper, since it has custom rendering,
        // but since it cannot be sorted by anyway lets just ignore it
        dataset = (_leafColumn$textWrapp = leafColumn.textWrapper) === null || _leafColumn$textWrapp === void 0 ? void 0 : _leafColumn$textWrapp.dataset; // data-sortIndex is 1-based, and only set if there is > 1 sorter.
        // iOS Safari throws a JS error if the requested delete property is not present.

        (dataset === null || dataset === void 0 ? void 0 : dataset.sortIndex) && delete dataset.sortIndex;
        classList.value = leafHeader.classList;

        if (leafColumn.sortable !== false) {
          classList.add(me.sortableCls);
          sorter = storeSorters.find(sort => sort.field === leafColumn.field || sort.sortFn && sort.sortFn === leafColumn.sortable.sortFn);

          if (sorter) {
            if (sorterCount > 1 && dataset) {
              dataset.sortIndex = storeSorters.indexOf(sorter) + 1;
            }

            classList.add(me.sortedCls);

            if (sorter.ascending) {
              classList.add(me.sortedAscCls);
              classList.remove(me.sortedDescCls);
            } else {
              classList.add(me.sortedDescCls);
              classList.remove(me.sortedAscCls);
            }
          } else {
            classList.remove(me.sortedCls); // Not optimal, but easiest way to make sure sort feature does not remove needed classes.
            // Better solution would be to use different names for sorting and grouping

            if (!classList['b-group']) {
              classList.remove(me.sortedAscCls);
              classList.remove(me.sortedDescCls);
            }
          }
        } else {
          classList.remove(me.sortableCls);
        } // Update the element's classList


        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].syncClassList(leafHeader, classList);
      }
    }
  } //endregion
  //region Context menu

  /**
   * Adds sort menu items to header context menu.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    column,
    items
  }) {
    const me = this,
          {
      store
    } = me,
          sortBy = _objectSpread(_objectSpread({}, column.sortable), {}, {
      field: column.field,
      columnOwned: true
    });

    if (column.sortable !== false) {
      items.sortAsc = {
        text: 'L{sortAscending}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-sort-asc',
        cls: 'b-separator',
        weight: 300,
        disabled: me.disabled,
        onItem: () => store.sort(sortBy, true)
      };
      items.sortDesc = {
        text: 'L{sortDescending}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-sort-desc',
        weight: 310,
        disabled: me.disabled,
        onItem: () => store.sort(sortBy, false)
      };

      if (me.multiSort && me.grid.columns.records.some(col => col.sortable)) {
        const sorter = store.sorters.find(s => s.field === column.field || column.sortable.sortFn && column.sortable.sortFn === s.sortFn);
        items.multiSort = {
          text: 'L{multiSort}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-sort',
          weight: 320,
          disabled: me.disabled,
          menu: {
            addSortAsc: {
              text: sorter ? 'L{toggleSortAscending}' : 'L{addSortAscending}',
              localeClass: me,
              icon: 'b-fw-icon b-icon-sort-asc',
              disabled: sorter && (sorter === null || sorter === void 0 ? void 0 : sorter.ascending),
              weight: 330,
              onItem: () => store.addSorter(sortBy, true)
            },
            addSortDesc: {
              text: sorter ? 'L{toggleSortDescending}' : 'L{addSortDescending}',
              localeClass: me,
              icon: 'b-fw-icon b-icon-sort-desc',
              disabled: sorter && !sorter.ascending,
              weight: 340,
              onItem: () => store.addSorter(sortBy, false)
            },
            removeSorter: {
              text: 'L{removeSorter}',
              localeClass: me,
              icon: 'b-fw-icon b-icon-remove',
              weight: 350,
              disabled: !sorter,
              onItem: () => {
                store.removeSorter(sortBy.field);
              }
            }
          }
        };
      }
    }
  }
  /**
   * Supply items to ColumnDragToolbar
   * @private
   */


  getColumnDragToolbarItems(column, items) {
    const me = this,
          {
      store,
      disabled
    } = me;

    if (column.sortable !== false) {
      const sorter = store.sorters.find(s => s.field === column.field);
      items.push({
        text: 'L{sortAscendingShort}',
        group: 'L{sort}',
        localeClass: me,
        icon: 'b-icon b-icon-sort-asc',
        ref: 'sortAsc',
        cls: 'b-separator',
        weight: 105,
        disabled,
        onDrop: ({
          column
        }) => store.sort(column.field, true)
      }, {
        text: 'L{sortDescendingShort}',
        group: 'L{sort}',
        localeClass: me,
        icon: 'b-icon b-icon-sort-desc',
        ref: 'sortDesc',
        weight: 105,
        disabled,
        onDrop: ({
          column
        }) => store.sort(column.field, false)
      }, {
        text: 'L{addSortAscendingShort}',
        group: 'L{multiSort}',
        localeClass: me,
        icon: 'b-icon b-icon-sort-asc',
        ref: 'multisortAddAsc',
        disabled: disabled || sorter && sorter.ascending,
        weight: 105,
        onDrop: ({
          column
        }) => store.addSorter(column.field, true)
      }, {
        text: 'L{addSortDescendingShort}',
        group: 'L{multiSort}',
        localeClass: me,
        icon: 'b-icon b-icon-sort-desc',
        ref: 'multisortAddDesc',
        disabled: disabled || sorter && !sorter.ascending,
        weight: 105,
        onDrop: ({
          column
        }) => store.addSorter(column.field, false)
      }, {
        text: 'L{removeSorterShort}',
        group: 'L{multiSort}',
        localeClass: me,
        icon: 'b-icon b-icon-remove',
        ref: 'multisortRemove',
        weight: 105,
        disabled: disabled || !sorter,
        onDrop: ({
          column
        }) => store.removeSorter(column.field)
      });
    }

    return items;
  } //endregion
  //region Events
  // Intercept sorting by a column that has a custom sorting fn, and inject that fn


  onStoreBeforeSort({
    sorters
  }) {
    const {
      columns
    } = this.client;

    for (let i = 0; i < sorters.length; i++) {
      var _column$sortable;

      const sorter = sorters[i],
            column = (sorter.columnOwned || this.prioritizeColumns) && columns.get(sorter.field);

      if (column !== null && column !== void 0 && (_column$sortable = column.sortable) !== null && _column$sortable !== void 0 && _column$sortable.sortFn) {
        sorters[i] = _objectSpread(_objectSpread(_objectSpread({}, sorter), column.sortable), {}, {
          columnOwned: true
        });
      }
    }
  }
  /**
   * Clicked on header, sort Store.
   * @private
   */


  onElementClick(event) {
    const me = this,
          store = me.store,
          target = event.target,
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].up(target, '.b-grid-header.b-sortable'),
          field = header === null || header === void 0 ? void 0 : header.dataset.column;

    if (me.ignoreRe.test(target.className) || me.disabled) {
      return;
    } //Header


    if (header && field) {
      const column = me.grid.columns.getById(header.dataset.columnId),
            columnGrouper = store.isGrouped && store.groupers.find(g => g.field === field); // The Group feature will handle the change of the grouper's direction

      if (columnGrouper && !event.shiftKey) {
        return;
      }

      if (column.sortable && !event.shiftKey) {
        if (event.ctrlKey && event.altKey) {
          store.removeSorter(column.field);
        } else {
          const sortBy = {
            columnOwned: true,
            field: column.field
          }; // sortable as a function is handled by onStoreBeforeSort() above

          if (typeof column.sortable === 'object') {
            _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(sortBy, column.sortable);
          }

          store.sort(sortBy, null, event.ctrlKey);
        }
      }
    }
  }
  /**
   * Called when grid headers are rendered, make headers match current sorters.
   * @private
   */


  renderHeader() {
    this.syncHeaderSortState();
  }

  onPaint() {
    this.syncHeaderSortState();
  } //endregion


}
Sort.featureClass = 'b-sort';
Sort._$name = 'Sort';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerFeature(Sort, true);

/***/ }),

/***/ "./lib/Grid/feature/StickyCells.js":
/*!*****************************************!*\
  !*** ./lib/Grid/feature/StickyCells.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StickyCells; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';




/**
 * @module Grid/feature/StickyCells
 */

/**
 * A feature which pins configurable content from a grid row to the top of the grid
 * while the row scrolls off the top but is still visible.
 *
 * As soon as the row becomes too small to contain the content, it is unpinned, and
 * scrolls out naturally, and the following row's configured content becomes pinned.
 *
 * For example:
 *
 * ```javascript
 *     new Grid({
 *         features : {
 *             stickyCells : {
 *                 // Identifies elements to clone and pin to the grid top.
 *                 contentSelector : '.myClassName'
 *             }
 *         }
 *     });
 * ```
 * @extends Core/mixin/InstancePlugin
 * @classtype stickyCells
 * @feature
 */

class StickyCells extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'StickyCells';
  }

  static get defaultConfig() {
    return {
      /**
       * A CSS selector which must identify the content within your grid row which you
       * require to be pinned to the grid while the row if the topmost row, and remains visible.
       * @config {String}
       */
      contentSelector: null,
      currentTopRowCls: 'b-sticky-cells-current-top-row'
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      before: ['renderRows']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    super.construct(grid, config); // We cannot chain our client's onGridScroll because that is now a delayable injected method.

    grid.on({
      scroll: 'onGridScroll',
      thisObj: this
    });
    Object.assign(this, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
      reference: 'element',
      parent: grid.element,
      className: 'b-grid-sticky-row',
      children: [{
        reference: 'contentElement',
        className: 'b-grid-cell'
      }]
    }, false, {})); // Clean these classes from copied cell and row classLists

    this.removeClasses = {
      'b-focused': false,
      'b-hover': false,
      'b-selected': false,
      [this.currentTopRowCls]: false
    };
  }

  renderRows() {
    // Do not leave stranded sticky row visible on data change
    this.element.classList.add('b-hide-visibility');
  }

  onGridScroll() {
    const me = this,
          {
      client: grid,
      element,
      contentElement
    } = me,
          gridViewport = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].client(grid.bodyContainer).roundPx(),
          currentTopRow = grid.rowManager.getRowAt(gridViewport.y),
          topRowChanged = currentTopRow !== me.currentTopRow;

    if (currentTopRow) {
      if (topRowChanged) {
        if (me.currentTopRow) {
          me.currentTopRow.removeCls(me.currentTopRowCls);
          me.currentTopRow.removeCls('b-not-enough-height');
        }

        me.currentTopRow = currentTopRow;
        currentTopRow.addCls(me.currentTopRowCls);
        contentElement.innerHTML = '';
        contentElement.appendChild(me.updateStickyContent());
      } // If the outgoing row is not not too tall, and doesn't *need* the content
      // pinning to the top, hide the sticky row, and make the source sticky
      // elements pin themselves to the bottom of the cell using the b-not-enough-height
      // class to switch them to align-self: flex-end


      const notEnoughHeight = me.currentTopRow.bottom - me.client.scrollable.y <= me.stickyContentHeight;
      me.element.classList[notEnoughHeight ? 'add' : 'remove']('b-hide-visibility');
      me.currentTopRow[notEnoughHeight ? 'addCls' : 'removeCls']('b-not-enough-height'); // Keep sticky row aligned while constrained to the viewport.
      // This keeps it pinned to the top.

      gridViewport.y += me.stickyContentTop;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].alignTo(element, me.stickyEls[0], {
        align: 't0-t0',
        constrainTo: gridViewport
      }, true);
    }

    me.lastProcessedTopRow = currentTopRow;
  }

  updateStickyContent() {
    const me = this,
          {
      currentTopRow,
      removeClasses
    } = me,
          rowClasses = {
      'b-grid-sticky-row': 1
    },
          cellClasses = {},
          stickyContent = me.stickyContent || (me.stickyContent = document.createDocumentFragment()),
          stickyEls = me.stickyEls || (me.stickyEls = []); // Release the sticky state on the previous row's sticky elements

    stickyEls.forEach(e => {
      e.classList.remove('b-sticky-content-el');
    }); // Collect the elements we need to clone from the current top row

    stickyEls.length = 0;
    currentTopRow.eachElement(rowEl => {
      stickyEls.push(...rowEl.querySelectorAll(me.contentSelector));
    }); // Clear the documentFragment which we use to hold our clones

    while (stickyContent.firstChild) {
      stickyContent.remove(stickyContent.firstChild);
    }

    me.stickyContentHeight = 0;
    me.stickyContentTop = 0; // Clone the selected elements and measure them for alignment.

    stickyEls.map(e => {
      // Collect the app classes that may be necessary on the cell and row elements.
      e.closest('.b-grid-cell').classList.forEach(cls => cellClasses[cls] = 1);
      e.closest('.b-grid-row').classList.forEach(cls => rowClasses[cls] = 1); // Clean out grid's classes from the class sets.

      Object.assign(cellClasses, removeClasses);
      Object.assign(rowClasses, removeClasses);
      const eTop = e.offsetTop;
      me.stickyContentTop = Math.max(me.stickyContentTop, eTop); // We need to know how tall the sticky content is

      e.style.alignSelf = 'flex-end';
      me.stickyContentHeight = Math.max(me.stickyContentHeight, me.currentTopRow.height - e.offsetTop + eTop);
      e.style.alignSelf = '';
      const result = e.cloneNode(true); // Tag the content al *after* cloning it.

      e.classList.add('b-sticky-content-el');
      stickyContent.appendChild(result);
      return result;
    });
    cellClasses['b-focused'] = false;
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].syncClassList(me.contentElement, cellClasses);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].syncClassList(me.element, rowClasses);
    return stickyContent;
  }

}
StickyCells._$name = 'StickyCells';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(StickyCells, false);

/***/ }),

/***/ "./lib/Grid/feature/Stripe.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Stripe.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Stripe; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';


/**
 * @module Grid/feature/Stripe
 */

/**
 * Stripes rows, by adding even (b-even) or odd (b-odd) css classes to row elements.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let grid = new Grid({
 *   features: {
 *     stripe: true
 *   }
 * });
 *
 * @demo Grid/columns
 * @classtype stripe
 * @inlineexample Grid/feature/Stripe.js
 * @feature
 */

class Stripe extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Stripe';
  }

  construct(grid, config) {
    super.construct(grid, config);
    grid.on({
      renderrow: 'onRenderRow',
      thisObj: this
    });
  }

  doDisable(disable) {
    if (!this.isConfiguring) {
      // Refresh rows to add/remove even/odd classes
      this.client.refreshRows();
    }

    super.doDisable(disable);
  }
  /**
   * Applies even/odd CSS when row is rendered
   * @param {Grid.row.Row} rowModel
   * @private
   */


  onRenderRow({
    row
  }) {
    const {
      disabled
    } = this,
          even = row.dataIndex % 2 === 0;
    row.assignCls({
      'b-even': !disabled && even,
      'b-odd': !disabled && !even
    });
  }

}
Stripe._$name = 'Stripe';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Stripe);

/***/ }),

/***/ "./lib/Grid/feature/Summary.js":
/*!*************************************!*\
  !*** ./lib/Grid/feature/Summary.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Summary; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/SummaryFormatter.js */ "./lib/Grid/feature/mixin/SummaryFormatter.js");
var productName = 'gantt';




/**
 * @module Grid/feature/Summary
 */

/**
 * Displays a summary row in the grid footer. Specify type of summary on columns, available types are:
 * <dl class="wide">
 * <dt>sum <dd>Sum of all values in the column
 * <dt>add <dd>Alias for sum
 * <dt>count <dd>Number of rows
 * <dt>countNotEmpty <dd>Number of rows containing a value
 * <dt>average <dd>Average of all values in the column
 * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
 * </dl>
 * Columns can also specify a summaryRenderer to format the calculated sum.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ```
 * { text : 'Score', data : 'score', width : 80, sum : true }
 * { text : 'Rank', data : 'rank', width : 80, sum : 'average', summaryRenderer: ({ sum }) => return 'Average rank ' + sum }
 * ```
 *
 * Also it is possible to set up multiple summaries as array of summary configs:
 * ```
 * { text : 'Rank', data : 'rank', summaries : [{ sum : 'average', label : 'Average' }, { sum : 'count', label : 'Count' }] }
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/features
 * @classtype summary
 * @inlineexample Grid/feature/Summary.js
 * @feature
 */

class Summary extends Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Config
  static get configurable() {
    return {
      /**
       * Set to `true` to sum values of selected row records
       * @config {Boolean}
       */
      selectedOnly: null,
      hideFooters: false
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['renderRows', 'bindStore']
    };
  } //endregion
  //region Init


  static get $name() {
    return 'Summary';
  }

  construct(grid, config) {
    this.grid = grid;
    super.construct(grid, config);
    this.bindStore(grid.store);
    grid.hideFooters = this.hideFooters;
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      change: 'onStoreChange',
      thisObj: this
    });
  }

  get store() {
    return this.grid.store;
  }

  doDestroy() {
    super.doDestroy();
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (disable) {
      this.grid.element.classList.add('b-summary-disabled');
    } else {
      this.updateSummaries();
      this.grid.element.classList.remove('b-summary-disabled');
    }
  } //endregion
  //region Render


  renderRows() {
    this.updateSummaries();
  }
  /**
   * Updates summaries. Summaries are displayed as tables in footer (styling left out to keep brief):
   * ```
   * <table>
   *     <tr><td colspan="2">0</td></tr> // { sum : 'min' } Only a calculation, span entire table
   *     <tr><td>Max</td><td>10</td></tr> // { sum : 'max', label: 'Max' } Label + calculation
   *     <tr><td>Max</td><td>10</td></tr> // { sum : 'sum', label: 'Max' } Label + calculation
   * </table>
   * ```
   * @private
   */


  updateSummaries() {
    const me = this,
          {
      grid,
      store
    } = me,
          cells = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].children(grid.element, '.b-grid-footer'),
          selectedOnly = me.selectedOnly && grid.selectedRecords.length > 0,
          records = (store.isFiltered ? store.storage.values : store.allRecords).filter(r => !r.isSpecialRow && (!selectedOnly || grid.isSelected(r))); // reset seeds, to not have ever increasing sums :)

    grid.columns.forEach(column => {
      column.summaries && column.summaries.forEach(config => {
        if ('seed' in config) {
          if (!('initialSeed' in config)) {
            config.initialSeed = config.seed;
          }

          if (['number', 'string', 'date'].includes(typeof config.initialSeed)) {
            config.seed = config.initialSeed;
          } else {
            // create shallow copy
            config.seed = Object.assign({}, config.initialSeed);
          }
        }
      });
    });
    cells.forEach(cellElement => {
      // Skip for special columns like checkbox selection
      if (!cellElement.dataset.column) {
        return;
      }

      const column = grid.columns.get(cellElement.dataset.column),
            html = me.generateHtml(column, records, 'b-grid-footer-summary');

      if (column.summaries ? column.summaries.length : column.sum ? 1 : 0) {
        // First time, set table
        if (!cellElement.children.length) {
          cellElement.innerHTML = html;
        } // Following times, sync changes
        else {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].sync(html, cellElement.firstElementChild);
        }
      }
    });
  } //endregion
  //region Events

  /**
   * Updates summaries on store changes (except record update, handled below)
   * @private
   */


  onStoreChange({
    action,
    changes
  }) {
    let shouldUpdate = true;

    if (this.disabled) {
      return;
    }

    if (action === 'update') {
      // only update summary when a field that affects summary is changed
      // TODO: this should maybe be removed, another column might depend on the value for its summary?
      shouldUpdate = Object.keys(changes).some(field => {
        const colField = this.grid.columns.get(field); // check existence, since a field not used in a column might have changed

        return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
      });
    }

    if (shouldUpdate) {
      this.updateSummaries();
    }
  } //endregion


  updateSelectedOnly(value) {
    const me = this;
    me.detachListeners('selectionChange');

    if (value) {
      me.grid.on({
        name: 'selectionChange',
        selectionChange: me.refresh,
        thisObj: me
      });
    }

    me.refresh();
  }
  /**
   * Refreshes the summaries
   */


  refresh() {
    this.updateSummaries();
  }

}
Summary.featureClass = 'b-summary';
Summary._$name = 'Summary';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(Summary);

/***/ }),

/***/ "./lib/Grid/feature/Tree.js":
/*!**********************************!*\
  !*** ./lib/Grid/feature/Tree.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tree; });
/* harmony import */ var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt'; //TODO: Handle paths? Like expandPath('Parent A/Sub B/Leaf')
//TODO: Dblclick on row (or at least tree cell) should expand/collapse (if not using celleditor)
//TODO: Arrows





/**
 * @module Grid/feature/Tree
 */

const immediatePromise = Promise.resolve();
/**
 * Feature that makes the grid work more like a tree. Included by default in {@link Grid.view.TreeGrid}. Requires
 * exactly one {@link Grid.column.TreeColumn} among grids columns. That column will have its renderer replaced with a
 * tree renderer that adds padding and icon to give the appearance of a tree. The original renderer is preserved and
 * also called.
 *
 * This feature is <strong>disabled</strong> by default. When enabled, the feature cannot be disabled during runtime.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/tree
 * @classtype tree
 * @inlineexample Grid/feature/Tree.js
 * @feature
 */

class Tree extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get $name() {
    return 'Tree';
  }

  static get defaultConfig() {
    return {
      /**
       * Expand parent nodes when clicking on their cell
       * @config {Boolean}
       * @default
       */
      expandOnCellClick: false
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      assign: ['collapseAll', 'expandAll', 'collapse', 'expand', 'expandTo', 'toggleCollapse'],
      before: ['navigateRight', 'navigateLeft'],
      chain: ['onElementClick', 'onElementKeyDown', 'bindStore']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    super.construct(grid, config); // find column

    const me = this,
          treeColumn = grid.columns.find(col => col instanceof _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"]);
    Object.assign(me, {
      grid: grid,
      rowManager: grid.rowManager,
      treeColumn: treeColumn
    });
    grid.store && this.bindStore(grid.store);
  }

  doDisable(disable) {}

  get store() {
    return this.grid.store;
  }

  bindStore(store) {
    this.detachListeners('store');
    store.on({
      name: 'store',
      beforeLoadChildren: 'onBeforeLoadChildren',
      loadChildren: 'onLoadChildren',
      loadChildrenException: 'onLoadChildrenException',
      beforeToggleNode: 'onBeforeToggleNode',
      thisObj: this
    });
  } //endregion
  //region Expand & collapse

  /**
   * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
   * @param {Boolean} [collapse] Force collapse (true) or expand (false)
   * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
   * @returns {Promise}
   * @async
   */


  async toggleCollapse(idOrRecord, collapse, skipRefresh = false) {
    const me = this,
          {
      store,
      grid
    } = me,
          {
      rowManager
    } = grid,
          record = store.getById(idOrRecord),
          meta = record.instanceMeta(store);

    if (await store.toggleCollapse(record, collapse)) {
      const row = rowManager.getRowFor(record);

      if (row) {
        const cellElement = row.getCell(me.treeColumn.id); // Toggle cell's expanded/collapsed state

        cellElement && row.renderCell({
          cellElement,
          record
        });
      } // Add a temporary cls, used by Scheduler & Gantt to prevent transitions on events/tasks
      // Block multiple applications in the case of a recursive collapseAll operation


      if (!me.isTogglingNode) {
        grid.element.classList.add('b-toggling-node');
        me.isTogglingNode = true;
        me.requestAnimationFrame(() => {
          grid.element.classList.remove('b-toggling-node');
          me.isTogglingNode = false;
        });
      }

      grid.trigger(meta.collapsed ? 'collapseNode' : 'expandNode', {
        source: grid,
        record
      });
      grid.trigger('toggleNode', {
        source: grid,
        record,
        collapse: meta.collapsed
      });
    }
  }
  /**
   * Collapse a single node. This function is exposed on Grid and can thus be called as `grid.collapse()`
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
   * @returns {Promise}
   */


  async collapse(idOrRecord) {
    return this.toggleCollapse(idOrRecord, true);
  }
  /**
   * Expand a single node. This function is exposed on Grid and can thus be called as `grid.expand()`
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
   * @returns {Promise}
   */


  async expand(idOrRecord) {
    return this.toggleCollapse(idOrRecord, false);
  }

  onBeforeToggleNode({
    record,
    collapse
  }) {
    this.grid.trigger('beforeToggleNode', {
      record,
      collapse
    });
  }

  onBeforeLoadChildren({
    source: store,
    params
  }) {
    const parent = store.getById(params[store.modelClass.idField]),
          row = this.grid.rowManager.getRowFor(parent);

    if (row) {
      row.addCls('b-loading-children');
    }
  }

  onLoadChildren({
    source: store,
    params
  }) {
    const parent = store.getById(params[store.modelClass.idField]),
          row = this.grid.rowManager.getRowFor(parent);

    if (row) {
      row.removeCls('b-loading-children');
    }
  }

  onLoadChildrenException({
    record
  }) {
    const row = this.grid.rowManager.getRowFor(record);

    if (row) {
      row.removeCls('b-loading-children');
    }
  }
  /**
   * Expand or collapse all nodes, as specified by param, starting at the passed node (which defaults to the root node)
   * @param {Boolean} [collapse] Set to true to collapse, false to expand (defaults to true)
   * @param {Core.data.Model} [topNode] The topmost node from which to cascade a collapse.
   * Defaults to the {@link Core.data.Store#property-rootNode}. Not included in the cascade if
   * the root node is being used.
   * @returns {Promise}
   */


  expandOrCollapseAll(collapse = true, topNode = this.store.rootNode) {
    // TODO: Some logic here and some in the store, keep in same place maybe
    const {
      grid,
      store
    } = this,
          promises = [],
          childRecords = [];
    grid.trigger('beforeToggleAllNodes', {
      source: grid,
      collapse
    }); // Each collapse/expand will trigger events on store, avoid that by suspending

    store.suspendEvents();
    store.traverse(record => {
      const gridMeta = record.instanceMeta(store);

      if (!record.isLeaf) {
        if (collapse && !gridMeta.collapsed) {
          this.toggleCollapse(record, true, true);
          childRecords.push(...record.children);
        } else if (!collapse && gridMeta.collapsed) {
          if (Array.isArray(record.children)) {
            childRecords.push(...record.children);
          }

          promises.push(this.toggleCollapse(record, false, true));
        }
      }
    }, topNode, topNode === store.rootNode);
    store.resumeEvents();
    return (collapse ? immediatePromise : Promise.all(promises)).then(() => {
      // Return to top when collapsing all
      grid.refreshRows(collapse);

      if (childRecords.length) {
        if (collapse) {
          store.trigger('remove', {
            records: childRecords,
            isCollapse: true,
            isCollapseAll: true
          });
        } else {
          store.trigger('add', {
            records: childRecords,
            isExpand: true,
            isExpandAll: true
          });
        }
      }

      grid.trigger('toggleAllNodes', {
        source: grid,
        collapse
      });
    });
  }
  /**
   * Collapse all nodes. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
   * @returns {Promise}
   */


  async collapseAll() {
    return this.expandOrCollapseAll(true);
  }
  /**
   * Expand all nodes. This function is exposed on Grid and can thus be called as `grid.expandAll()`
   * @returns {Promise}
   */


  async expandAll() {
    return this.expandOrCollapseAll(false);
  }
  /**
   * Expands parent nodes to make this node "visible". This function is exposed on Grid and can thus be called as
   * `grid.expandTo()`
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
   * @returns {Promise}
   */


  async expandTo(idOrRecord) {
    const me = this,
          record = me.store.getById(idOrRecord),
          recordMeta = record.instanceMeta(me.store); // Already visible? abort

    if (recordMeta.hiddenByCollapse === false) return; // Expand each parent

    let refreshNeeded = false,
        parent = record.parent;
    const parents = []; // To expand path correctly we need to do it from top
    // so parent record for each record will be in the store already

    while (parent && !parent.isRoot) {
      parents.push(parent);
      parent = parent.parent;
    }

    await parents.reverse().forEach(async parent => {
      if (!me.isDestroyed) {
        if (parent.instanceMeta(me.store).collapsed) {
          refreshNeeded = true;
        }

        await me.toggleCollapse(parent, false, true);
      }
    });

    if (refreshNeeded) {
      me.grid.refreshRows();
    }

    if (!me.isDestroyed) {
      await me.grid.scrollRowIntoView(record);
    }
  } //endregion
  //region Renderer
  //endregion
  //region Events

  /**
   * Called when user clicks somewhere in the grid. Expand/collapse node on icon click.
   * @private
   */


  onElementClick(event) {
    const me = this,
          target = event.target,
          cellData = me.grid.getCellDataFromEvent(event),
          clickedExpander = target.closest('.b-tree-expander'); // Checks if click is on node expander icon, then toggles expand/collapse. Also toggles on entire cell if expandOnCellClick is true

    if (clickedExpander || me.expandOnCellClick && cellData && cellData.record.isParent) {
      clickedExpander && event.preventDefault();
      me.toggleCollapse(cellData.record);
    }
  }
  /**
   * Called on key down in grid. Expand/collapse node on [space]
   * @private
   */


  onElementKeyDown(event) {
    const grid = this.grid; // only catch space on grid element, not in editors etc...

    if (event.target === grid.focusElement && event.key === ' ' && grid.focusedCell) {
      event.preventDefault();
      this.toggleCollapse(grid.focusedCell.id);
    }
  } //endregion


  navigateRight(event) {
    const me = this,
          grid = me.grid,
          cellSelector = grid.focusedCell;

    if (cellSelector) {
      const record = grid.store.getById(cellSelector.id); // shift triggers tree navigation behaviour, also used by default for single column which is tree

      if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
        // on collapsed parent, expand
        if (record.isParent && record.instanceMeta(grid.store).collapsed) {
          me.expand(record);
        } // otherwise go down
        else {
          grid.navigateDown(event);
        }

        return false;
      }
    }
  }

  navigateLeft(event) {
    const me = this,
          grid = me.grid,
          cellSelector = grid.focusedCell;

    if (cellSelector) {
      const record = grid.store.getById(cellSelector.id);

      if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
        // on expanded parent, collapse
        if (record.isParent && !record.instanceMeta(grid.store).collapsed) {
          me.collapse(record);
        } // otherwise go to parent
        else if (record.parent) {
          grid.focusCell({
            id: record.parent.id,
            columnId: cellSelector.columnId
          });
        }

        return false;
      }
    }
  }

}
Tree.featureClass = 'b-tree';
Tree._$name = 'Tree';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(Tree, false, 'Grid');
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(Tree, true, 'TreeGrid');

/***/ }),

/***/ "./lib/Grid/feature/experimental/ExcelExporter.js":
/*!********************************************************!*\
  !*** ./lib/Grid/feature/experimental/ExcelExporter.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExcelExporter; });
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _util_TableExporter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony import */ var _util_BooleanUnicodeSymbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/BooleanUnicodeSymbol.js */ "./lib/Grid/util/BooleanUnicodeSymbol.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';






/**
 * @module Grid/feature/experimental/ExcelExporter
 */

/**
 * **NOTE**: This class requires a 3rd party library to operate.
 *
 * A feature that allows exporting Grid data to Excel without involving the server. It uses {@link Grid.util.TableExporter}
 * class as data provider, [zipcelx library](https://www.npmjs.com/package/zipcelx)
 * forked and adjusted to support [column width config](https://github.com/bryntum/zipcelx/tree/column-width-build)
 * and [Microsoft XML specification](https://msdn.microsoft.com/en-us/library/office/documentformat.openxml.spreadsheet.aspx).
 * Zipcelx should be either in global scope (window) or can be provided with {@link #config-zipcelx} config.
 *
 * ```
 * // Global scope
 * <script src="zipcelx.js"></script>
 *
 * // importing from package
 * import zipcelx from 'zipcelx';
 *
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             zipcelx
 *         }
 *     }
 * })
 * ```
 *
 * Here is an example of how to add the feature:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             // Choose the date format for date fields
 *             dateFormat : 'YYYY-MM-DD HH:mm',
 *
 *             exporterConfig : {
 *                 // Choose the columns to include in the exported file
 *                 columns : ['name', 'role']
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * And how to call it:
 *
 * ```javascript
 * grid.features.excelExporter.export({
 *     filename : 'Export',
 *     exporterConfig : {
 *         columns : [
 *             { text : 'First Name', field : 'firstName', width : 90 },
 *             { text : 'Age', field : 'age', width : 40 },
 *             { text : 'Starts', field : 'start', width : 140 },
 *             { text : 'Ends', field : 'finish', width : 140 }
 *         ]
 *     }
 * })
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/exporttoexcel
 * @classtype excelExporter
 * @feature
 */

class ExcelExporter extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ExcelExporter';
  }

  static get defaultConfig() {
    return {
      /**
       * Name of the exported file
       * @config {String} filename
       * @default
       */
      filename: null,

      /**
       * Defines how date in a cell will be formatted
       * @config {String} dateFormat
       * @default
       */
      dateFormat: 'YYYY-MM-DD',

      /**
       * Exporter class to use as a data provider. {@link Grid.util.TableExporter} by default.
       * @config {Grid.util.TableExporter}
       * @typings {typeof TableExporter}
       * @default
       */
      exporterClass: _util_TableExporter_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * Configuration object for {@link #config-exporterClass exporter class}.
       * @config {Object}
       */
      exporterConfig: null,

      /**
       * Reference to zipcelx library. If not provided, exporter will look in the global scope.
       * @config {Object}
       */
      zipcelx: null,

      /**
       * If this config is true, exporter will convert all empty values to ''. Empty values are:
       * * undefined, null, NaN
       * * Objects/class instances that do not have toString method defined and are stringified to [object Object]
       * * functions
       * @config {Boolean}
       */
      convertEmptyValueToEmptyString: true
    };
  }

  processValue(value) {
    if (value === undefined || value === null || Number.isNaN(value) || typeof value === 'function' || typeof value === 'object' && String(value) === '[object Object]') {
      return '';
    } else {
      return value;
    }
  }

  generateExportData(config) {
    const me = this,
          {
      rows,
      columns
    } = me.exporter.export(config.exporterConfig);
    return {
      rows: rows.map(row => {
        return row.map((value, index) => {
          var _columns$index;

          if (value instanceof Date) {
            value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].format(value, config.dateFormat);
          } else if (typeof value === 'boolean') {
            value = new _util_BooleanUnicodeSymbol_js__WEBPACK_IMPORTED_MODULE_3__["default"](value);
          }

          if (me.convertEmptyValueToEmptyString) {
            value = me.processValue(value);
          }

          const type = ((_columns$index = columns[index]) === null || _columns$index === void 0 ? void 0 : _columns$index.type) === 'number' ? 'number' : 'string';
          return {
            value,
            type
          };
        });
      }),
      columns: columns.map(col => {
        let {
          field,
          value,
          width,
          type
        } = col; // when number column is exported with zipcelx, excel warns that sheet is broken and asks for repair
        // repair works, but having error on open doesn't look acceptable
        // type = type === 'number' ? 'number' : 'string';

        type = 'string';
        return {
          field,
          value,
          width,
          type
        };
      })
    };
  }
  /**
   * Generate and download a .xslx file.
   * @param {Object} config Optional configuration object, which overrides initial settings of the feature/exporter.
   * @returns {Promise} Promise that resolves when the export is completed
   */


  export(config = {}) {
    const me = this,
          zipcelx = me.zipcelx || window.zipcelx;

    if (!zipcelx) {
      throw new Error('ExcelExporter: "zipcelx" library is required');
    }

    if (me.disabled) {
      return;
    }

    config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, me.config, config);

    if (!config.filename) {
      config.filename = me.client.$$name;
    }

    const {
      filename
    } = config,
          {
      rows,
      columns
    } = me.generateExportData(config);
    return zipcelx({
      filename,
      sheet: {
        data: [columns].concat(rows),
        cols: columns
      }
    });
  }

  construct(grid, config) {
    super.construct(grid, config);

    if (!this.zipcelx) {
      if (typeof zipcelx !== 'undefined') {
        this.zipcelx = window.zipcelx;
      }
    }
  }

  get exporter() {
    const me = this;
    return me._exporter || (me._exporter = me.exporterClass.new({
      target: me.client
    }, me.exporterConfig));
  }

}
ExcelExporter._$name = 'ExcelExporter';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ExcelExporter, false, 'Grid');

/***/ }),

/***/ "./lib/Grid/feature/export/PdfExport.js":
/*!**********************************************!*\
  !*** ./lib/Grid/feature/export/PdfExport.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PdfExport; });
/* harmony import */ var _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Utils.js */ "./lib/Grid/feature/export/Utils.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';











/**
 * @module Grid/feature/export/PdfExport
 */

/**
 * Generates PDF/PNG files from the Grid component.
 *
 * **NOTE:** Server side is required to make export work!
 *
 * The export server is written in nodejs and it is shipped with our examples. You can find setup instructions in
 * `examples/_shared/server/README.md` and `examples/export/README.md` files.
 *
 * When your server is up and running, it listens to requests. The Export feature sends a request to the specified URL
 * with the HTML fragments. The server generates a PDF (or PNG) file and returns a download link (or binary, depending
 * on {@link #config-sendAsBinary} config). Then the Export feature opens the link in a new tab and the file is
 * automatically downloaded by your browser. This is configurable, see {@link #config-openAfterExport} config.
 *
 * The {@link #config-exportServer} URL must be configured. The URL can be localhost if you start the server locally,
 * or your remote server address.
 *
 * ## Usage
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080' // Required
 *         }
 *     }
 * })
 *
 * // Opens popup allowing to customize export settings
 * grid.features.pdfExport.showExportDialog();
 *
 * // Simple export
 * grid.features.pdfExport.export({
 *     // Required, set list of column ids to export
 *     columns : grid.columns.map(c => c.id)
 * }).then(result => {
 *     // Response instance and response content in JSON
 *     let { response } = result;
 * });
 * ```
 *
 * ## Exporters
 *
 * There are three exporters available by default: `singlepage`, `multipage` and `multipagevertical`:
 *  * `singlepage` -  generates single page with content scaled to fit the provided {@link #config-paperFormat}
 *  * `multipage` - generates as many pages as required to fit all requested content, unscaled
 *  * `multipagevertical` - a combination of two above: it scales content horizontally to fit into page width and then
 *  puts overflowing content on vertical pages. Like a scroll.
 *
 * ## Loading resources
 *
 * If you face a problem with loading resources when exporting, the cause might be that the application and the export server are hosted on different servers.
 * This is due to [Cross-Origin Resource Sharing](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) (CORS). There are 2 options how to handle this:
 * - Allow cross origin requests from the server where your export is hosted to the server where your application is hosted;
 * - Copy all resources keeping the folder hierarchy from the server where your application is hosted to the server where your export is hosted
 * and setup paths using {@link #config-translateURLsToAbsolute} config and configure the export server to give access to the path:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080',
 *             // '/resources' is hardcoded in WebServer implementation
 *             translateURLsToAbsolute : 'http://localhost:8080/resources'
 *         }
 *     }
 * })
 * ```
 *
 * ```javascript
 * // Following path would be served by this address: http://localhost:8080/resources/
 * node ./src/server.js -h 8080 -r web/application/styles
 * ```
 *
 * where `web/application/styles` is a physical root location of the copied resources, for example:
 *
 * <img src="Grid/export-server-resources.png" style="max-width : 500px" alt="Export server structure with copied resources" />
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/export
 * @classtype pdfExport
 * @feature
 */

class PdfExport extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'PdfExport';
  }

  static get configurable() {
    return {
      dialogClass: _view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_6__["default"],

      /**
       * URL of the print server.
       * @config {String}
       */
      exportServer: undefined,

      /**
       * Returns the instantiated export dialog widget as configured by {@link #config-exportDialog}
       * @member {Grid.view.export.ExportDialog} exportDialog
       */

      /**
       * A config object to apply to the {@link Grid.view.export.ExportDialog} widget.
       * @config {Object}
       */
      exportDialog: {
        value: true,
        $config: ['lazy']
      },

      /**
       * Name of the exported file.
       * @config {String}
       */
      fileName: null,

      /**
       * Format of the exported file, either `pdf` or `png`.
       * @config {String}
       * @default
       * @category Export file config
       */
      fileFormat: 'pdf',

      /**
       * Export server will navigate to this url first and then will change page content to whatever client sent.
       * This option is useful with react dev server, which uses a strict CORS policy.
       * @config {String}
       */
      clientURL: null,

      /**
       * Export paper format. Available options are A1...A5, Legal, Letter.
       * @config {String}
       * @default
       * @category Export file config
       */
      paperFormat: 'A4',

      /**
       * Orientation. Options are `portrait` and `landscape`.
       * @config {String}
       * @default
       * @category Export file config
       */
      orientation: 'portrait',

      /**
       * Specifies which rows to export. `all` for complete set of rows, `visible` for only rows currently visible.
       * @config {String}
       * @category Export file config
       */
      rowsRange: 'all',

      /**
       * Set to true to align row top to the page top on every exported page. Only applied to multipage export.
       * @config {Boolean}
       * @default
       */
      alignRows: false,

      /**
       * Set to true to show column headers on every page. This will also set {@link #config-alignRows} to true.
       * Only applies to MultiPageVertical exporter.
       * @config {Boolean}
       * @default
       */
      repeatHeader: false,

      /**
       * By default subGrid width is changed to fit all exported columns. To keep certain subGrid size specify it
       * in the following form:
       * ```
       * keepRegionSizes : {
       *     locked : true
       * }
       * ```
       * @config {Object}
       * @default
       */
      keepRegionSizes: null,

      /**
       * When exporting large views (hundreds of pages) stringified HTML may exceed browser or server request
       * length limit. This config allows to specify how many pages to send to server in one request.
       * @config {Number}
       * @default
       * @private
       */
      pagesPerRequest: 0,

      /**
       * Config for exporter.
       * @config {Object}
       * @private
       */
      exporterConfig: null,

      /**
       * Type of the exporter to use. Should be one of the configured {@link #config-exporters}
       * @config {String}
       * @default
       */
      exporterType: 'singlepage',

      /**
       * List of exporter classes to use in export feature
       * @config {Grid.feature.export.exporter.Exporter[]}
       * @default
       */
      exporters: [_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_4__["default"], _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_2__["default"], _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_3__["default"]],

      /**
       * `True` to replace all linked CSS files URLs to absolute before passing HTML to the server.
       * When passing a string the current origin of the CSS files URLS will be replaced by the passed origin.
       *
       * For example: css files pointing to /app.css will be translated from current origin to {translateURLsToAbsolute}/app.css
       * @config {Boolean|String}
       * @default
       */
      translateURLsToAbsolute: true,

      /**
       * When true links are converted to absolute by combining current window location (with replaced origin) with
       * resource link.
       * When false links are converted by combining new origin with resource link (for angular)
       * @config {Boolean}
       * @default
       */
      keepPathName: true,

      /**
       * When true, page will attempt to download generated file.
       * @config {Boolean}
       * @default
       */
      openAfterExport: true,

      /**
       * Set to true to receive binary file from the server instead of download link.
       * @config {Boolean}
       * @default
       */
      sendAsBinary: false,

      /**
       * False to open in the current tab, true - in a new tab
       * @config {Boolean}
       * @default
       */
      openInNewTab: false,

      /**
       * A template function used to generate a page header. It is passed an object with ´currentPage´ and `totalPages´ properties.
       *
       * ```javascript
       * let grid = new Grid({
       *     appendTo   : 'container',
       *     features : {
       *         pdfExport : {
       *             exportServer : 'http://localhost:8080/',
       *             headerTpl : ({ currentPage, totalPages }) => `
       *                 <div class="demo-export-header">
       *                     <img src="coolcorp-logo.png"/>
       *                     <dl>
       *                         <dt>Date: ${DateHelper.format(new Date(), 'll LT')}</dt>
       *                         <dd>${totalPages ? `Page: ${currentPage + 1}/${totalPages}` : ''}</dd>
       *                     </dl>
       *                 </div>`
       *          }
       *     }
       * });
       * ```
       * @config {Function}
       */
      headerTpl: null,

      /**
       * A template function used to generate a page footer. It is passed an object with ´currentPage´ and `totalPages´ properties.
       *
       * ```javascript
       * let grid = new Grid({
       *      appendTo   : 'container',
       *      features : {
       *          pdfExport : {
       *              exportServer : 'http://localhost:8080/',
       *              footerTpl    : () => '<div class="demo-export-footer"><h3>© 2020 CoolCorp Inc</h3></div>'
       *          }
       *      }
       * });
       * ```
       * @config {Function}
       */
      footerTpl: null,

      /**
       * An object containing the Fetch options to pass to the export server request. Use this to control if credentials are sent
       * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
       * @config {Object}
       */
      fetchOptions: null,

      /**
       * A message to be shown when Export feature is performing export.
       * @config {String}
       * @default "Generating pages..."
       */
      exportMask: 'L{Generating pages}',

      /**
       * A message to be shown when export is almost done.
       * @config {String}
       * @default "Waiting for response from server..."
       */
      exportProgressMask: 'L{Waiting for response from server}',

      /**
       * Set to false to not show Toast message on export error.
       * @config {Boolean}
       * @default
       */
      showErrorToast: true,
      localizableProperties: ['exportMask', 'exportProgressMask']
    };
  }

  doDestroy() {
    var _this$exportDialog;

    (_this$exportDialog = this.exportDialog) === null || _this$exportDialog === void 0 ? void 0 : _this$exportDialog.destroy();
    this.exportersMap.forEach(exporter => exporter.destroy());
    super.doDestroy();
  }
  /**
   * When export is started from GUI ({@link Grid.view.export.ExportDialog}), export promise can be accessed via
   * this property.
   * @property {Promise|null}
   */


  get currentExportPromise() {
    return this._currentExportPromise;
  }

  set currentExportPromise(value) {
    this._currentExportPromise = value;
  }

  get exportersMap() {
    return this._exportersMap || (this._exportersMap = new Map());
  }

  getExporter(config = {}) {
    const me = this,
          {
      exportersMap
    } = me,
          {
      type
    } = config;
    let exporter;

    if (exportersMap.has(type)) {
      exporter = exportersMap.get(type);
    } else {
      const exporterClass = this.exporters.find(cls => cls.type === type);

      if (!exporterClass) {
        throw new Error(`Exporter type ${type} is not found. Make sure you've configured it`);
      }

      config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].clone(config);
      delete config.type;
      exporter = new exporterClass(config);
      exporter.relayAll(me);
      exportersMap.set(type, exporter);
    }

    return exporter;
  }

  buildRequest(pages, config) {
    return {
      html: JSON.stringify(pages),
      fileFormat: config.fileFormat,
      format: config.paperFormat,
      orientation: config.orientation
    };
  }

  buildExportConfig(config = {}) {
    const me = this,
          {
      client,
      exportServer,
      clientURL,
      fileFormat,
      fileName,
      paperFormat,
      rowsRange,
      alignRows,
      repeatHeader,
      keepRegionSizes,
      orientation,
      translateURLsToAbsolute,
      keepPathName,
      sendAsBinary,
      headerTpl,
      footerTpl
    } = me;

    if (!config.columns) {
      config.columns = client.columns.visibleColumns.filter(column => column.exportable).map(column => column.id);
    }

    const result = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
      client,
      exportServer,
      clientURL,
      fileFormat,
      paperFormat,
      rowsRange,
      alignRows,
      repeatHeader,
      keepRegionSizes,
      orientation,
      translateURLsToAbsolute,
      keepPathName,
      sendAsBinary,
      headerTpl,
      footerTpl,
      exporterType: me.exporterType,
      fileName: fileName || client.$$name
    }, config); // slice columns array to not modify it during export

    result.columns = config.columns.slice(); // Only vertical exporter is supported

    if (result.exporterType !== 'multipagevertical') {
      result.repeatHeader = false;
    } // Align rows by default


    if (!('alignRows' in config) && config.repeatHeader) {
      result.alignRows = true;
    } // Only change this setting if it is default (false) and not provided directly in config


    if (!('keepRegionSizes' in config) && !result.keepRegionSizes) {
      const collapsed = [],
            keepRegionSizes = {}; // If there's at least one collapsed region - lock other region sizes

      client.eachSubGrid(s => s.collapsed && collapsed.push(s.region));

      if (collapsed.length) {
        client.eachSubGrid(s => {
          if (!collapsed.includes(s.region)) {
            keepRegionSizes[s.region] = true;
          }
        });
        result.keepRegionSizes = keepRegionSizes;
      }
    }

    result.exporterConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
      type: result.exporterType,
      translateURLsToAbsolute: result.translateURLsToAbsolute,
      keepPathName: result.keepPathName
    }, result.exporterConfig || {});
    delete result.exporterType;
    delete result.translateURLsToAbsolute;
    delete result.keepPathName;
    return result;
  }
  /**
   * Starts the export process. Accepts a config object which overrides any default configs.
   * **NOTE**. Component should not be interacted with when export is in progress
   *
   * @param {Object} config
   * @param {String[]} config.columns (required) List of column ids to export. E.g.
   *
   * ```javascript
   * grid.features.pdfExport.export({ columns : grid.columns.map(c => c.id) })
   * ```
   * @returns {Promise} Object of the following structure
   * ```
   * {
   *     response // Response instance
   * }
   * ```
   * @async
   */


  async export(config = {}) {
    const me = this,
          {
      client,
      pagesPerRequest
    } = me;
    config = me.buildExportConfig(config);
    let result;
    /**
     * Fires on the owning Grid before export started. Return `false` to cancel the export.
     * @event beforeExport
     * @preventable
     * @on-owner
     * @param {Object} config Export config
     */
    // Fix signature for 4.3.0 - remove ...config
    // https://github.com/bryntum/support/issues/3240

    if (client.trigger('beforeExport', _objectSpread(_objectSpread({}, config), {}, {
      config
    })) !== false) {
      // This mask should be always visible to protect grid from changes even if the mask message is not visible
      // due to the export dialog which is rendered above the grid's mask. The dialog has its own mask which shares the export message.
      client.mask(me.exportMask);

      try {
        const exporter = me.getExporter(config.exporterConfig);

        if (pagesPerRequest === 0) {
          const pages = await exporter.export(config);
          /**
           * Fires when export progress changes
           * @event exportStep
           * @param {Number} progress Current progress, 0-100
           * @param {String} text Optional text to show
           */

          me.trigger('exportStep', {
            progress: 90,
            text: me.exportProgressMask
          });
          const response = await me.receiveExportContent(pages, config);
          result = {
            response
          };
          await me.processExportContent(response, config);
        }
      } catch (error) {
        if (error instanceof Response) {
          result = {
            response: error
          };
        } else {
          result = {
            error
          };
        }

        throw error;
      } finally {
        if (!me.isDestroying) {
          var _me$exportDialog;

          (_me$exportDialog = me.exportDialog) === null || _me$exportDialog === void 0 ? void 0 : _me$exportDialog.close();
          client.unmask(); // Remove event for 4.3.0
          // https://github.com/bryntum/support/issues/3240

          me.trigger('export', result);

          if (me.showErrorToast) {
            if (result.error) {
              _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_8__["default"].show({
                html: me.L('L{Export failed}'),
                rootElement: this.rootElement
              });
            } else if (!result.response.ok) {
              _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_8__["default"].show({
                html: me.L('L{Server error}'),
                rootElement: this.rootElement
              });
            }
          }
          /**
           * Fires on the owning Grid when export has finished
           * @event export
           * @on-owner
           * @param {Response} [response] Optional response, if received
           * @param {Error} [error] Optional error, if exception occurred
           */


          client.trigger('export', result);
        }
      }
    }

    return result;
  }
  /**
   * Sends request to the export server and returns Response instance.
   * @param {Object[]} pages Array of exported pages.
   * @param {String} pages[].html pages HTML of the exported page.
   * @param {Object} config Export config
   * @param {String} config.exportServer URL of the export server.
   * @param {String} config.orientation Page orientation. portrait/landscape.
   * @param {String} config.paperFormat Paper format as supported by puppeteer. A4/A3/...
   * @param {String} config.fileFormat File format. PDF/PNG.
   * @param {String} config.fileName Name to use for the saved file.
   * @param {String} config.clientURL URL to navigate before export. See {@link #config-clientURL}.
   * @param {String} config.sendAsBinary Tells server whether to return binary file instead of download link.
   * @returns {Promise} Returns Response instance
   */


  async receiveExportContent(pages, config) {
    return _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].post(config.exportServer, {
      html: pages,
      orientation: config.orientation,
      format: config.paperFormat,
      fileFormat: config.fileFormat,
      fileName: config.fileName,
      clientURL: config.clientURL,
      sendAsBinary: config.sendAsBinary
    }, Object.assign({
      credentials: 'omit'
    }, this.fetchOptions));
  }
  /**
   * Handles output of the {@link #function-receiveExportContent}. Server response can be of two different types depending
   * on {@link #config-sendAsBinary} config:
   * - `application/json` In this case JSON response contains url of the file to download
   * - `application/octet-stream` In this case response contains stream of file binary data
   *
   * If {@link #config-openAfterExport} is true, this method will try to download content.
   * @param {Response} response
   * @param {Object} config Export config
   * @param {String} config.exportServer URL of the export server.
   * @param {String} config.orientation Page orientation. portrait/landscape.
   * @param {String} config.paperFormat Paper format as supported by puppeteer. A4/A3/...
   * @param {String} config.fileFormat File format. PDF/PNG.
   * @param {String} config.fileName Name to use for the saved file.
   * @param {String} config.clientURL URL to navigate before export. See {@link #config-clientURL}.
   * @param {String} config.sendAsBinary Tells server whether to return binary file instead of download link. See {@link #config-sendAsBinary}
   * @returns {Promise}
   */


  async processExportContent(response, config) {
    const me = this;

    if (response.ok && me.openAfterExport) {
      // Clone Response to not block response stream
      response = response.clone();
      const contentType = response.headers.get('content-type');

      if (contentType.match(/application\/octet-stream/)) {
        const MIMEType = _Utils_js__WEBPACK_IMPORTED_MODULE_10__["FileMIMEType"][config.fileFormat],
              objectURL = await me.responseBlobToObjectURL(response, MIMEType),
              link = me.getDownloadLink(config.fileName, objectURL);
        link.click();
      } else if (contentType.match(/application\/json/)) {
        const responseJSON = await response.json();

        if (responseJSON.success) {
          const link = me.getDownloadLink(config.fileName, responseJSON.url);
          link.click();
        } else {
          _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_8__["default"].show({
            html: responseJSON.msg,
            rootElement: this.rootElement
          });
        }
      }
    }
  }
  /**
   * Creates object URL from response content with given mimeType
   * @param {Response} response Response instance
   * @param {String} mimeType
   * @returns {Promise} Returns string object URL
   * @private
   */


  async responseBlobToObjectURL(response, mimeType) {
    const blob = await response.blob();
    return URL.createObjectURL(blob.slice(0, blob.size, mimeType));
  }
  /**
   * Creates link to download the file.
   * @param {String} name File name
   * @param {String} href URL of the resource
   * @returns HTMLAnchorElement
   * @private
   */


  getDownloadLink(name, href) {
    const link = document.createElement('a');
    link.download = name;
    link.href = href;

    if (this.openInNewTab) {
      link.target = '_blank';
    }

    return link;
  }

  get defaultExportDialogConfig() {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].copyProperties({}, this, ['client', 'exporters', 'exporterType', 'orientation', 'fileFormat', 'paperFormat', 'alignRows', 'rowsRange', 'repeatHeader']);
  }

  changeExportDialog(exportDialog, oldExportDialog) {
    const me = this;
    oldExportDialog === null || oldExportDialog === void 0 ? void 0 : oldExportDialog.destroy();

    if (exportDialog) {
      const config = me.dialogClass.mergeConfigs({
        rootElement: me.rootElement,
        client: me.client,
        items: {
          rowsRangeField: {
            value: me.rowsRange
          },
          exporterTypeField: {
            value: me.exporterType
          },
          orientationField: {
            value: me.orientation
          },
          paperFormatField: {
            value: me.paperFormat
          },
          repeatHeaderField: {
            value: me.repeatHeader
          },
          fileFormatField: {
            value: me.fileFormat
          },
          alignRowsField: {
            checked: me.alignRows
          }
        }
      }, me.defaultExportDialogConfig, exportDialog);
      exportDialog = me.dialogClass.new(config);
      exportDialog.on({
        export: me.onExportButtonClick,
        thisObj: me
      });
    }

    return exportDialog;
  }
  /**
   * Shows {@link Grid.view.export.ExportDialog export dialog}
   * @async
   * @returns {Promise}
   */


  showExportDialog() {
    return this.exportDialog.show();
  }

  onExportButtonClick({
    values
  }) {
    const me = this;
    me.mask = new _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
      progress: 0,
      maxProgress: 100,
      text: me.exportMask,
      target: me.exportDialog.element
    });
    const detacher = me.on({
      exportstep({
        progress,
        text
      }) {
        me.mask.progress = progress;

        if (text != null) {
          me.mask.text = text;
        }
      }

    });
    me.currentExportPromise = me.export(values); // Clear current export promise

    me.currentExportPromise.then(() => {
      me.currentExportPromise = null;
      detacher();
      return me.mask.close();
    });
  }

}
PdfExport._$name = 'PdfExport';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(PdfExport, false, 'Grid'); // Format expected by export server
// const pageFormat = {
//     html       : '',
//     column     : 1,
//     number     : 1,
//     row        : 1,
//     rowsHeight : 1
// };
//
// const format = {
//     fileFormat  : 'pdf',
//     format      : 'A4',
//     orientation : 'portrait',
//     range       : 'complete',
//     html        : { array : JSON.stringify(pageFormat) }
// };

/***/ }),

/***/ "./lib/Grid/feature/export/Utils.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/export/Utils.js ***!
  \******************************************/
/*! exports provided: RowsRange, PaperFormat, Orientation, FileFormat, FileMIMEType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RowsRange", function() { return RowsRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaperFormat", function() { return PaperFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Orientation", function() { return Orientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileFormat", function() { return FileFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileMIMEType", function() { return FileMIMEType; });
var productName = 'gantt';
const RowsRange = {
  all: 'all',
  visible: 'visible'
};
const PaperFormat = {
  A6: {
    width: 4.13,
    height: 5.81
  },
  A5: {
    width: 5.81,
    height: 8.25
  },
  A4: {
    width: 8.25,
    height: 11.69
  },
  A3: {
    width: 11.69,
    height: 16.49
  },
  Legal: {
    width: 8.5,
    height: 14
  },
  Letter: {
    width: 8.5,
    height: 11
  }
};
const Orientation = {
  portrait: 'portrait',
  landscape: 'landscape'
};
const FileFormat = {
  pdf: 'pdf',
  png: 'png'
};
const FileMIMEType = {
  pdf: 'application/pdf',
  png: 'image/png'
};

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/Exporter.js":
/*!******************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/Exporter.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Exporter; });
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';









/**
 * @module Grid/feature/export/exporter/Exporter
 */

/**
 * Base class for all exporters
 * @mixes Core/localization/Localizable
 * @mixes Core/mixin/Events
 */

class Exporter extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_8__["default"])(Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"])(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_2__["default"]))) {
  static get defaultConfig() {
    return {
      /**
       * `True` to replace all linked CSS files URLs to absolute before passing HTML to the server.
       * When passing a string the current origin of the CSS files URLS will be replaced by the passed origin.
       *
       * For example: css files pointing to /app.css will be translated from current origin to {translateURLsToAbsolute}/app.css
       * @config {Boolean|String}
       * @default
       */
      translateURLsToAbsolute: true,

      /**
       * When true links are converted to absolute by combining current window location (with replaced origin) with
       * resource link.
       * When false links are converted by combining new origin with resource link (for angular)
       * @config {Boolean}
       * @default
       */
      keepPathName: true
    };
  }
  /**
   * Template of an extracted page.
   * @param {Object} data Data for the page template
   * @returns {String}
   */


  pageTpl(data) {
    const {
      title,
      header,
      footer,
      styles,
      htmlClasses,
      bodyStyle,
      bodyClasses = [],
      paperHeight,
      paperWidth,
      html
    } = data;
    bodyClasses.push(`b-${this.constructor.type}`); // Other classes needed on outer element.
    // TODO: use the new static Widget.outerCls property when merged with master

    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].scrollBarWidth) {
      bodyClasses.push('b-visible-scrollbar');
    } else {
      bodyClasses.push('b-overlay-scrollbar');
    }

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isChrome) {
      bodyClasses.push('b-chrome');
    } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSafari) {
      bodyClasses.push('b-safari');
    } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFirefox) {
      bodyClasses.push('b-firefox');
    } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEdge) {
      bodyClasses.push('b-edge');
    }

    return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].tpl`
            <!DOCTYPE html>
            <html class="${htmlClasses}" style="width: ${paperWidth}in; height: ${paperHeight}in;">
                <head>
                    <meta content="text/html; charset=UTF-8" http-equiv="Content-Type" />
                    <title>${title}</title>
                    ${styles.join('')}
                </head>
                <body class="b-export ${bodyClasses.join(' ')}" style="width: ${paperWidth}in; height: ${paperHeight}in; ${bodyStyle}">
                    <div class="b-export-content">
                        ${header && `<div class="b-export-header" style="width: 100%">${header}</div>`}
                        <div class="b-export-body"><div class="b-export-viewport">${html}</div></div>
                        ${footer && `<div class="b-export-footer" style="width: 100%">${footer}</div>`}
                    </div>
                </body>
            </html>`;
  }
  /**
   * Returns all style-related tags: `<style>` and `<link rel="stylesheet">`
   * @property {String[]}
   * @readonly
   */


  get stylesheets() {
    const me = this;

    if (me._stylesheets) {
      return me._stylesheets;
    }

    const translate = me.translateURLsToAbsolute,
          origin = window.origin,
          styleSheetNodes = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')),
          styles = [];
    styleSheetNodes.forEach(node => {
      node = node.cloneNode(true); // put absolute URL to node `href` attribute

      if (translate && node.href) {
        let result;

        if (translate === true) {
          result = node.href;
        } // translate is truthy if we are here, which means it is string now
        else {
          if (this.keepPathName) {
            result = node.href.replace(origin, translate);
          } else {
            result = new URL(node.getAttribute('href'), translate);
          }
        }

        node.setAttribute('href', result);
      }

      let styleText; // Empty style tag will be copied in IE, so we need to use cssText

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 && node.styleSheet && /style/i.test(node.tagName)) {
        styleText = `<style type="text/css">${node.styleSheet.cssText}</style>`;
      } else {
        styleText = node.outerHTML;
      }

      if (translate && /style/i.test(node.tagName)) {
        const converter = me.getStyleTagURLConverter(translate);
        styleText = styleText.replace(/url\(['"]?(.+?)['"]?\)/g, converter);
      }

      styles.push(styleText);
    });
    styles.push(`<style>
                body, html {
                    overflow: auto;
                }
                body {
                    position: relative;
                    margin: 0;
                }
            </style>`);
    return me._stylesheets = styles;
  }

  set stylesheets(value) {
    this._stylesheets = value;
  }

  getStyleTagURLConverter(translate) {
    return function (match, url) {
      let result;

      try {
        let base; // Filter out local references, e.g. to svg marker

        if (/^#/.test(url)) {
          result = match;
        } else {
          if (translate === true) {
            base = window.location.href;
          } // translate is truthy if we are here, which means it is string now
          else {
            if (this.keepPathName) {
              base = window.location.href.replace(window.location.origin, translate);
            } else {
              base = translate;
            }
          }

          result = `url('${new URL(url, base).href}')`;
        }
      } catch (e) {
        result = match;
      }

      return result;
    }.bind(this);
  }

  saveState({
    client
  }) {
    this.state = client.state;
    const {
      tbar,
      bbar
    } = client;

    if (tbar) {
      this.state.tbar_hidden = tbar.hidden;
      tbar.hide(false);
    }

    if (bbar) {
      this.state.bbar_hidden = bbar.hidden;
      bbar.hide(false);
    }
  }

  async restoreState({
    client
  }) {
    const promises = [],
          detachers = new Set(),
          {
      tbar,
      bbar
    } = client;
    detachers.add(client.scrollable.on({
      scroll() {
        promises.push(client.scrollable.await('scrollEnd'));
      }

    }));
    client.eachSubGrid(({
      header,
      scrollable
    }) => {
      detachers.add(scrollable.on({
        scroll() {
          promises.push(scrollable.await('scrollEnd'));
        }

      }));
      detachers.add(header.scrollable.on({
        scroll() {
          promises.push(header.scrollable.await('scrollEnd'));
        }

      }));
    });

    if (tbar) {
      tbar.hidden = this.state.tbar_hidden;
      delete this.state.tbar_hidden;
    }

    if (bbar) {
      bbar.hidden = this.state.bbar_hidden;
      delete this.state.bbar_hidden;
    }

    client.state = this.state;
    await Promise.all(promises);
    detachers.forEach(fn => fn());
  }

  beforeExport() {
    // Into this element we will put HTML for export
    this.element = document.createElement('div');
  } //region DOM helpers


  cloneElement(element, target = this.element, clear = true) {
    if (clear) {
      target.innerHTML = '';
    }

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isChrome) {
      target.appendChild(element.cloneNode(true));
    } else {
      target.innerHTML = element.outerHTML;
    }

    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].removeEachSelector(target, '.b-grid-row');
    const maskEl = target.querySelector('.b-gridbase > .b-mask');

    if (maskEl) {
      maskEl.remove();
    }
  }
  /**
   * Appends generated header/footer element to the document body to measure their height
   * @param html
   * @returns {Number}
   * @private
   */


  measureElement(html = '') {
    if (html instanceof HTMLElement) {
      html = html.outerHTML;
    }

    const target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createElement({
      parent: document.body,
      style: {
        visibility: 'hidden',
        position: 'absolute'
      },
      // Add html to measure to a div between two other divs to take margin into account
      html: `<div style="height: 1px"></div>${html}<div style="height: 1px"></div>`
    });
    const result = target.offsetHeight - 2;
    target.remove();
    return result;
  } // Converts local urls to absolute


  prepareHTML(html) {
    if (html instanceof HTMLElement) {
      html = html.outerHTML;
    }

    const target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createElement({
      parent: document.body,
      style: {
        visibility: 'hidden',
        position: 'absolute'
      },
      html
    });
    const elements = target.querySelectorAll('img');

    for (let i = 0, l = elements.length; i < l; i++) {
      elements[i].setAttribute('src', elements[i].src);
    }

    const result = target.innerHTML;
    target.remove();
    return result;
  }

  createPlaceholder(el, clear = true) {
    if (clear) {
      el.innerHTML = '';
    }

    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createElement({
      parent: el,
      id: _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].generateId('export')
    });
  }

  getVirtualScrollerHeight(client) {
    let result = 0; // If overlay scroll is enabled, this will return 0
    // when disabled, it will report proper virtualScrollers element height

    client.eachSubGrid(subGrid => {
      if (subGrid.overflowingHorizontally) {
        result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].scrollBarWidth;
      }
    }); // If there's a visible scrollbar, need to also take border height into account

    return result === 0 ? result : result + 1;
  } //endregion


  inchToPx(value) {
    // 1in = 96px for screens
    // https://developer.mozilla.org/en-US/docs/Web/CSS/length#Absolute_length_units
    return value * 96;
  }

  getScaleValue(base, value) {
    return Math.floor(base * 10000 / value) / 10000;
  }

  getVisibleRowsCount(client) {
    const rowManager = client.rowManager,
          // We cannot rely on `visibleRowCount` property, it is a mere estimate
    firstVisibleIndex = rowManager.rows.indexOf(rowManager.firstVisibleRow),
          lastVisibleIndex = rowManager.rows.indexOf(rowManager.lastVisibleRow);
    let result; // first index could be negative only if there are no rendered rows, in which case we return store count

    if (firstVisibleIndex !== -1) {
      // last visible index could be negative if last actually visible row doesn't reach view bottom, i.e.
      // view is not completely filled with rows
      if (lastVisibleIndex === -1) {
        result = client.store.count - firstVisibleIndex;
      } else {
        // for a zero-based index we need to add 1 to the result
        result = lastVisibleIndex - firstVisibleIndex + 1;
      }
    } else {
      result = client.store.count;
    }

    return result;
  }

  async export(config) {
    const me = this;
    let pages;
    me.beforeExport();
    me.saveState(config);
    await me.prepareComponent(config);

    try {
      pages = await me.getPages(config);
    } finally {
      await me.restoreComponent(config);
      me.stylesheets = null; // https://app.assembla.com/spaces/bryntum/tickets/9400-scrollrowintoview-promise-is-not-reliable/details
      // Restoring scroll might trigger rows repaint on next animation frame. We are
      // waiting for next animation frame in such case. Covered in SinglePage.t.js

      await new Promise(resolve => me.requestAnimationFrame(resolve));
      await me.restoreState(config);
    }

    return pages;
  }

  async getPages(config) {
    const generator = this.pagesExtractor(config),
          pages = [];
    let step;

    while ((step = await generator.next()) && !step.done) {
      pages.push(step.value);
    }

    return pages;
  } // Row buffer has to be adjusted to render complete row set per exported page. See virtual scrolling section in README
  // for more details


  adjustRowBuffer(client) {
    const {
      contentHeight
    } = this.exportMeta,
          {
      rowManager
    } = client;
    this.oldRowManagerConfig = {
      prependRowBuffer: rowManager.prependRowBuffer,
      appendRowBuffer: rowManager.appendRowBuffer
    }; // render 3 times more rows to get enough to fill exported page

    const adjustedRowBuffer = Math.ceil(contentHeight / rowManager.rowOffsetHeight);
    rowManager.prependRowBuffer = adjustedRowBuffer;
    rowManager.appendRowBuffer = adjustedRowBuffer;
    client.renderRows(); // In case we are at the bottom of the view and we are increasing buffer, rowmanager might return to the top row
    // In this case we need to force it to render rows at the current scroll position

    client.rowManager.jumpToPosition(client.scrollable.y);
  }

  restoreRowBuffer(client) {
    client.rowManager.prependRowBuffer = this.oldRowManagerConfig.prependRowBuffer;
    client.rowManager.appendRowBuffer = this.oldRowManagerConfig.appendRowBuffer; // There is no need to force rendering rows here, those would be updated during applyState call on a grid.
    // More precisely - during setRowHeight method.
  }

  async prepareComponent(config) {
    const me = this,
          {
      client,
      columns,
      rowsRange,
      keepRegionSizes
    } = config,
          {
      rowManager
    } = client,
          exportMeta = me.exportMeta = {
      totalWidth: 0,
      totalHeight: 0 - me.getVirtualScrollerHeight(client),
      subGrids: {}
    };
    client.columns.forEach(column => {
      if (columns.includes(column.id)) {
        column.show();
      } else {
        column.hide();
      }
    });

    if (client.rowManager.rowCount > 0) {
      if (rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_6__["RowsRange"].all) {
        exportMeta.firstVisibleDataIndex = rowManager.rows[0].dataIndex;
        await client.scrollRowIntoView(client.store.first, {
          block: 'start'
        });
      } else {
        const firstVisibleDataIndex = exportMeta.firstVisibleDataIndex = rowManager.firstVisibleRow.dataIndex;
        await client.scrollRowIntoView(client.store.getAt(firstVisibleDataIndex), {
          block: 'start'
        });
        config.alignRows = true;
      }
    } // clone whole grid element to the detached container


    this.cloneElement(client.element);
    const {
      element
    } = me;
    client.eachSubGrid(subGrid => {
      var _subGrid$splitterElem;

      const placeHolder = me.createPlaceholder(element.querySelector(`[id="${subGrid.id}"]`), false);
      let width;

      if (keepRegionSizes !== null && keepRegionSizes !== void 0 && keepRegionSizes[subGrid.region]) {
        width = subGrid.element.offsetWidth;
      } else {
        width = subGrid.columns.visibleColumns.reduce((result, column) => {
          if (typeof column.width === 'number') {
            result += column.width;
          } else {
            result += client.getHeaderElement(column.id).offsetWidth;
          }

          return result;
        }, 0);
      }

      exportMeta.totalWidth += width;
      const splitterWidth = ((_subGrid$splitterElem = subGrid.splitterElement) === null || _subGrid$splitterElem === void 0 ? void 0 : _subGrid$splitterElem.offsetWidth) || 0;
      exportMeta.totalWidth += splitterWidth;
      exportMeta.subGrids[subGrid.region] = {
        id: subGrid.id,
        headerId: subGrid.header && subGrid.header.id || null,
        footerId: subGrid.footer && subGrid.footer.id || null,
        rows: [],
        splitterWidth,
        placeHolder,
        width
      };
    });
  }

  prepareExportElement() {
    const me = this,
          {
      element,
      exportMeta
    } = me; // Exporters may change subGrid width, e.g. when specific date range is exported

    Object.values(exportMeta.subGrids).forEach(({
      width,
      id,
      headerId,
      footerId
    }) => {
      [id, headerId, footerId].forEach(id => {
        if (id) {
          const childElement = element.querySelector(`[id="${id}"]`); // SubGrid now always have header & footer, but not always in DOM

          if (childElement) {
            childElement.style.width = `${width}px`;
            childElement.style.flex = '';
          }
        }
      });
    });
    return element.innerHTML;
  }

  async restoreComponent(config) {}

  async scrollRowIntoView(client, index) {
    await client.scrollRowIntoView(client.store.getAt(index), {
      block: 'start'
    }); // #9400 - scrollRowIntoView promise is not reliable

    await new Promise(resolve => this.requestAnimationFrame(resolve));
  }

} // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.

/**
 * Pages generator. Value should be string with exported HTML
 * @param {Object} config
 * @returns {AsyncIterableIterator<{value: String, done: Boolean}>}
 * @private
 */

Exporter.prototype.pagesExtractor = async function* pagesExtractor() {
  yield '';
};

Exporter._$name = 'Exporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/MultiPageExporter.js":
/*!***************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/MultiPageExporter.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageExporter; });
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
var productName = 'gantt';


class MultiPageExporter extends _Exporter_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'MultiPageExporter';
  }

  static get type() {
    return 'multipage';
  }

  static get title() {
    // In case locale is missing exporter is still distinguishable
    return this.L('L{multipage}');
  }

  static get exportingPageText() {
    return 'L{exportingPage}';
  } //region State management


  async stateNextPage({
    client
  }) {
    const {
      exportMeta
    } = this;
    ++exportMeta.currentPage;
    ++exportMeta.verticalPosition;
    delete exportMeta.lastExportedRowBottom; // If current vertical position is greater than max vertical pages, switch to next column

    if (exportMeta.verticalPosition >= exportMeta.verticalPages) {
      exportMeta.verticalPosition = exportMeta.currentPageTopMargin = 0;
      ++exportMeta.horizontalPosition;
      delete exportMeta.lastRowDataIndex;
      await this.scrollRowIntoView(client, exportMeta.firstVisibleDataIndex, {
        block: 'start'
      });
    }
  } //endregion
  //region Preparation


  async prepareComponent(config) {
    await super.prepareComponent(config);
    const me = this,
          {
      exportMeta
    } = me,
          {
      client,
      headerTpl,
      footerTpl,
      alignRows,
      rowsRange
    } = config,
          paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_1__["PaperFormat"][config.paperFormat],
          isPortrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["Orientation"].portrait,
          paperWidth = isPortrait ? paperFormat.width : paperFormat.height,
          paperHeight = isPortrait ? paperFormat.height : paperFormat.width,
          pageWidth = me.inchToPx(paperWidth),
          pageHeight = me.inchToPx(paperHeight),
          horizontalPages = Math.ceil(exportMeta.totalWidth / pageWidth); // To estimate amount of pages correctly we need to know height of the header/footer on every page

    let contentHeight = pageHeight;

    if (headerTpl) {
      contentHeight -= me.measureElement(headerTpl({
        totalWidth: exportMeta.totalWidth,
        totalPages: -1,
        currentPage: -1
      }));
    }

    if (footerTpl) {
      contentHeight -= me.measureElement(footerTpl({
        totalWidth: exportMeta.totalWidth,
        totalPages: -1,
        currentPage: -1
      }));
    }

    let totalHeight,
        verticalPages,
        totalRows = client.store.count;

    if (rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible) {
      totalRows = me.getVisibleRowsCount(client);
      totalHeight = exportMeta.totalHeight + client.height;
    } else {
      totalHeight = exportMeta.totalHeight + client.height - client.bodyHeight + client.scrollable.scrollHeight;
    } // alignRows config specifies if rows should be always fully visible. E.g. if row doesn't fit on the page, it goes
    // to the top of the next page


    if (alignRows && rowsRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible) {
      // we need to estimate amount of vertical pages for case when we only put row on the page if it fits
      // first we need to know how much rows would fit one page, keeping in mind first page also contains header
      // This estimation is loose, because row height might differ much between pages
      const rowHeight = client.rowManager.rowOffsetHeight,
            rowsOnFirstPage = Math.floor((contentHeight - client.headerHeight) / rowHeight),
            rowsPerPage = Math.floor(contentHeight / rowHeight),
            remainingRows = totalRows - rowsOnFirstPage;
      verticalPages = 1 + Math.ceil(remainingRows / rowsPerPage);
    } else {
      verticalPages = Math.ceil(totalHeight / contentHeight);
    }

    Object.assign(exportMeta, {
      paperWidth,
      paperHeight,
      pageWidth,
      pageHeight,
      horizontalPages,
      verticalPages,
      totalHeight,
      contentHeight,
      totalRows,
      totalPages: horizontalPages * verticalPages,
      currentPage: 0,
      verticalPosition: 0,
      horizontalPosition: 0,
      currentPageTopMargin: 0
    });
    this.adjustRowBuffer(client);
  }

  async restoreComponent(config) {
    await super.restoreComponent(config);
    this.restoreRowBuffer(config.client);
  } //endregion


  async buildPage(config) {
    const me = this,
          {
      exportMeta
    } = me,
          {
      client,
      headerTpl,
      footerTpl,
      alignRows,
      rowsRange
    } = config,
          {
      totalWidth,
      totalPages,
      currentPage,
      subGrids,
      currentPageTopMargin,
      verticalPosition,
      totalRows,
      lastRowDataIndex
    } = exportMeta,
          {
      rowManager
    } = client,
          {
      rows
    } = rowManager,
          onlyVisible = rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible; // Rows are stored in shared state object, need to clean it before exporting next page

    Object.values(subGrids).forEach(subGrid => subGrid.rows = []); // With variable row height total height might change after scroll, update it
    // to show content completely on the last page

    if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].all) {
      exportMeta.totalHeight = client.height - client.bodyHeight + client.scrollable.scrollHeight - me.getVirtualScrollerHeight(client);
    }

    let headerHeight = 0,
        footerHeight = 0,
        remainingHeight,
        header,
        footer,
        index;

    if (onlyVisible && lastRowDataIndex != null) {
      if (lastRowDataIndex === rows[rows.length - 1].dataIndex) {
        index = rows.length - 1;
      } else {
        index = rows.findIndex(r => r.dataIndex === lastRowDataIndex);
      }
    } else {
      index = onlyVisible ? rows.findIndex(r => r.bottom > Math.ceil(client.scrollable.y)) : rows.findIndex(r => r.bottom + currentPageTopMargin + client.headerHeight > 0);
    }

    const firstRowIndex = index,
          // This is a portion of the row which is not visible, which means it shouldn't affect remaining height
    // Don't calculate for the first page
    overflowingHeight = onlyVisible || verticalPosition === 0 ? 0 : rows[index].top + currentPageTopMargin + client.headerHeight; // Measure header and footer height

    if (headerTpl) {
      header = me.prepareHTML(headerTpl({
        totalWidth,
        totalPages,
        currentPage
      }));
      headerHeight = me.measureElement(header);
    }

    if (footerTpl) {
      footer = me.prepareHTML(footerTpl({
        totalWidth,
        totalPages,
        currentPage
      }));
      footerHeight = me.measureElement(footer);
    } // Calculate remaining height to fill with rows
    // remainingHeight is height of the page content region to fill. When next row is exported, this heights gets
    // reduced. Since top rows may be partially visible, it would lead to increasing error and eventually to incorrect
    // exported rows for the page


    remainingHeight = exportMeta.pageHeight - headerHeight - footerHeight - overflowingHeight; // first exported page container header

    if (verticalPosition === 0) {
      remainingHeight -= client.headerHeight;
    } // data index of the last collected row


    let lastDataIndex,
        offset = 0;

    while (remainingHeight > 0) {
      const row = rows[index];

      if (alignRows && remainingHeight < row.offsetHeight) {
        offset = -remainingHeight;
        remainingHeight = 0; // If we skip a row save its bottom to meta data in order to align canvases height
        // properly

        me.exportMeta.lastExportedRowBottom = rows[index - 1].bottom;
      } else {
        me.collectRow(row);
        remainingHeight -= row.offsetHeight;
        lastDataIndex = row.dataIndex; // Last row is processed, still need to fill the view

        if (++index === rows.length && remainingHeight > 0) {
          remainingHeight = 0;
        } else if (onlyVisible && index - firstRowIndex === totalRows) {
          remainingHeight = 0;
        }
      }
    }

    const lastRow = rows[index - 1];

    if (lastRow) {
      // Calculate exact grid height according to the the last exported row
      exportMeta.exactGridHeight = lastRow.bottom + client.footerContainer.offsetHeight + client.headerContainer.offsetHeight;
      exportMeta.lastRowDataIndex = lastRow.dataIndex + 1;
    }

    await me.onRowsCollected(rows.slice(firstRowIndex, index), config); // No scrolling required if we are only exporting currently visible rows

    if (onlyVisible) {
      exportMeta.exactGridHeight -= exportMeta.scrollableTopMargin = client.scrollable.y;
    } else {
      // With variable row height row manager might relayout rows to fix position, moving them up or down.
      const detacher = rowManager.on('offsetrows', ({
        offset: value
      }) => offset += value);
      await me.scrollRowIntoView(client, lastDataIndex + 1);
      detacher();
    }

    const html = me.buildPageHtml();
    return {
      html,
      header,
      footer,
      offset
    };
  }

  async onRowsCollected() {}

  collectRow(row) {
    const subGrids = this.exportMeta.subGrids;
    Object.entries(row.elements).forEach(([key, value]) => {
      subGrids[key].rows.push(value.outerHTML);
    });
  }

  buildPageHtml() {
    const me = this,
          {
      subGrids
    } = me.exportMeta; // Now when rows are collected, we need to add them to exported grid

    let html = me.prepareExportElement();
    Object.values(subGrids).forEach(({
      placeHolder,
      rows
    }) => {
      const placeHolderText = placeHolder.outerHTML;
      html = html.replace(placeHolderText, rows.join(''));
    });
    return html;
  }

  prepareExportElement() {
    const me = this,
          {
      element,
      exportMeta
    } = me;

    if (exportMeta.scrollableTopMargin) {
      element.querySelector('.b-grid-vertical-scroller').style.marginTop = `-${exportMeta.scrollableTopMargin}px`;
    }

    return super.prepareExportElement();
  }

} // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.

MultiPageExporter.prototype.pagesExtractor = async function* pagesExtractor(config) {
  const me = this,
        {
    exportMeta,
    stylesheets
  } = me,
        {
    totalWidth,
    totalPages,
    paperWidth,
    paperHeight,
    contentHeight
  } = exportMeta;
  let currentPage;

  while ((currentPage = exportMeta.currentPage) < totalPages) {
    me.trigger('exportStep', {
      text: me.L(MultiPageExporter.exportingPageText, {
        currentPage,
        totalPages
      }),
      progress: Math.round((currentPage + 1) / totalPages * 90)
    });
    const {
      html,
      header,
      footer,
      offset
    } = await me.buildPage(config); // TotalHeight might change in case of variable row heights
    // Move exported content in the visible frame

    const styles = [...stylesheets, `
                <style>
                    #${config.client.id} {
                        height: ${exportMeta.exactGridHeight}px !important;
                        width: ${totalWidth}px !important;
                    }
                    .b-export-body .b-export-viewport {
                        margin-left : ${-paperWidth * exportMeta.horizontalPosition}in;
                        margin-top  : ${exportMeta.currentPageTopMargin}px;
                    }
                </style>
            `]; // when aligning rows, offset gets accumulated, so we need to take it into account

    exportMeta.currentPageTopMargin -= contentHeight + offset;
    await me.stateNextPage(config);
    yield {
      html: me.pageTpl({
        html,
        header,
        footer,
        styles,
        paperWidth,
        paperHeight
      })
    };
  }
};

MultiPageExporter._$name = 'MultiPageExporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js":
/*!***********************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageVerticalExporter; });
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
var productName = 'gantt';


class MultiPageVerticalExporter extends _Exporter_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'MultiPageVerticalExporter';
  }

  static get type() {
    return 'multipagevertical';
  }

  static get title() {
    // In case locale is missing exporter is still distinguishable
    return this.L('L{multipagevertical}');
  }

  static get exportingPageText() {
    return 'L{exportingPage}';
  } //region State management


  async stateNextPage({
    client
  }) {
    const {
      exportMeta
    } = this,
          {
      totalRows,
      processedRows,
      totalPages
    } = exportMeta;
    ++exportMeta.currentPage;
    ++exportMeta.verticalPosition; // With variable row heights it is possible that initial pages estimation is wrong. If we're out but there are
    // more rows to process - continue exporting

    if (exportMeta.currentPage === totalPages && processedRows.size !== totalRows) {
      ++exportMeta.totalPages;
      ++exportMeta.verticalPages;
    }
  } //endregion


  estimateTotalPages(config) {
    const me = this,
          {
      exportMeta
    } = me,
          {
      client,
      headerTpl,
      footerTpl,
      alignRows,
      rowsRange,
      repeatHeader
    } = config,
          {
      pageWidth,
      pageHeight,
      totalWidth
    } = exportMeta,
          scale = me.getScaleValue(pageWidth, totalWidth); // To estimate amount of pages correctly we need to know height of the header/footer on every page

    let totalHeight = 0 - me.getVirtualScrollerHeight(client) + client.height - client.bodyHeight + client.scrollable.scrollHeight,
        // We will be scaling content horizontally, need to adjust content height accordingly
    contentHeight = pageHeight / scale,
        totalRows = client.store.count,
        initialScroll = 0,
        verticalPages;

    if (headerTpl) {
      contentHeight -= me.measureElement(headerTpl({
        totalWidth,
        totalPages: -1,
        currentPage: -1
      }));
    }

    if (footerTpl) {
      contentHeight -= me.measureElement(footerTpl({
        totalWidth,
        totalPages: -1,
        currentPage: -1
      }));
    } // If we are repeating header on every page we have smaller contentHeight


    if (repeatHeader) {
      contentHeight -= client.headerHeight;
      totalHeight -= client.headerHeight;
    }

    if (rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible) {
      const rowManager = client.rowManager,
            firstRow = rowManager.firstVisibleRow,
            lastRow = rowManager.lastVisibleRow;
      initialScroll = firstRow.top;
      totalRows = me.getVisibleRowsCount(client);
      totalHeight = totalHeight - client.scrollable.scrollHeight + lastRow.bottom - firstRow.top;
    } // alignRows config specifies if rows should be always fully visible. E.g. if row doesn't fit on the page, it goes
    // to the top of the next page


    if (alignRows && !repeatHeader && rowsRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible) {
      // we need to estimate amount of vertical pages for case when we only put row on the page if it fits
      // first we need to know how much rows would fit one page, keeping in mind first page also contains header
      // This estimation is loose, because row height might differ much between pages
      const rowHeight = client.rowManager.rowOffsetHeight,
            rowsOnFirstPage = Math.floor((contentHeight - client.headerHeight) / rowHeight),
            rowsPerPage = Math.floor(contentHeight / rowHeight),
            remainingRows = totalRows - rowsOnFirstPage;
      verticalPages = 1 + Math.ceil(remainingRows / rowsPerPage);
    } else {
      verticalPages = Math.ceil(totalHeight / contentHeight);
    }

    Object.assign(exportMeta, {
      scale,
      contentHeight,
      totalRows,
      totalHeight,
      verticalPages,
      initialScroll,
      horizontalPages: 1,
      totalPages: verticalPages
    });
  }

  async prepareComponent(config) {
    await super.prepareComponent(config);
    const me = this,
          {
      exportMeta
    } = me,
          {
      client
    } = config,
          paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_1__["PaperFormat"][config.paperFormat],
          isPortrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["Orientation"].portrait,
          paperWidth = isPortrait ? paperFormat.width : paperFormat.height,
          paperHeight = isPortrait ? paperFormat.height : paperFormat.width,
          pageWidth = me.inchToPx(paperWidth),
          pageHeight = me.inchToPx(paperHeight),
          horizontalPages = 1;
    Object.assign(exportMeta, {
      paperWidth,
      paperHeight,
      pageWidth,
      pageHeight,
      horizontalPages,
      currentPage: 0,
      verticalPosition: 0,
      horizontalPosition: 0,
      currentPageTopMargin: 0,
      processedRows: new Set()
    });
    me.estimateTotalPages(config);
    me.adjustRowBuffer(client);
  }

  async restoreComponent(config) {
    await super.restoreComponent(config);
    this.restoreRowBuffer(config.client);
  }

  async buildPage(config) {
    const me = this,
          {
      exportMeta
    } = me,
          {
      client,
      headerTpl,
      footerTpl,
      alignRows,
      repeatHeader
    } = config,
          {
      totalWidth,
      totalPages,
      currentPage,
      subGrids,
      currentPageTopMargin,
      verticalPosition,
      totalRows,
      contentHeight
    } = exportMeta,
          // If we are repeating header we've already took header height into account when setting content height
    clientHeaderHeight = repeatHeader ? 0 : client.headerHeight,
          {
      rowManager
    } = client,
          {
      rows
    } = rowManager; // Rows are stored in shared state object, need to clean it before exporting next page

    Object.values(subGrids).forEach(subGrid => subGrid.rows = []); // With variable row height total height might change after scroll, update it
    // to show content completely on the last page

    if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].all) {
      exportMeta.totalHeight = client.height - client.bodyHeight + client.scrollable.scrollHeight - me.getVirtualScrollerHeight(client);
    }

    let index = config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible ? rows.findIndex(r => r.bottom > client.scrollable.y) : rows.findIndex(r => r.bottom + currentPageTopMargin + clientHeaderHeight > 0),
        remainingHeight,
        header,
        footer;
    const firstRowIndex = index,
          // This is a portion of the row which is not visible, which means it shouldn't affect remaining height
    // Don't calculate for the first page
    overflowingHeight = verticalPosition === 0 ? 0 : rows[index].top + currentPageTopMargin + clientHeaderHeight; // Measure header and footer height

    if (headerTpl) {
      header = me.prepareHTML(headerTpl({
        totalWidth,
        totalPages,
        currentPage
      }));
    }

    if (footerTpl) {
      footer = me.prepareHTML(footerTpl({
        totalWidth,
        totalPages,
        currentPage
      }));
    } // Calculate remaining height to fill with rows
    // remainingHeight is height of the page content region to fill. When next row is exported, this heights gets
    // reduced. Since top rows may be partially visible, it would lead to increasing error and eventually to incorrect
    // exported rows for the page


    remainingHeight = contentHeight - overflowingHeight; // first exported page container header

    if (verticalPosition === 0) {
      remainingHeight -= clientHeaderHeight;
    } // data index of the last collected row


    let lastDataIndex,
        offset = 0;

    while (remainingHeight > 0) {
      const row = rows[index];

      if (alignRows && remainingHeight < row.offsetHeight) {
        offset = -remainingHeight;
        remainingHeight = 0;
      } else {
        me.collectRow(row);
        remainingHeight -= row.offsetHeight; // only mark row as processed if it fitted without overflow

        if (remainingHeight > 0) {
          // We cannot use simple counter here because some rows appear on 2 pages. Need to track unique identifier
          exportMeta.processedRows.add(row.dataIndex);
        }

        lastDataIndex = row.dataIndex; // Last row is processed, still need to fill the view

        if (++index === rows.length && remainingHeight > 0) {
          remainingHeight = 0;
        } else if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible && index - firstRowIndex === totalRows) {
          remainingHeight = 0;
        }
      }
    }

    const lastRow = rows[index - 1];

    if (lastRow) {
      // Calculate exact grid height according to the the last exported row
      exportMeta.exactGridHeight = lastRow.bottom + client.footerContainer.offsetHeight + client.headerContainer.offsetHeight;
    }

    await me.onRowsCollected(rows.slice(firstRowIndex, index), config); // No scrolling required if we are only exporting currently visible rows

    if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"].visible) {
      exportMeta.scrollableTopMargin = client.scrollable.y;
    } else {
      // With variable row height row manager might relayout rows to fix position, moving them up or down.
      const detacher = rowManager.on('offsetrows', ({
        offset: value
      }) => offset += value);
      await me.scrollRowIntoView(client, lastDataIndex + 1);
      detacher();
    }

    const html = me.buildPageHtml();
    return {
      html,
      header,
      footer,
      offset
    };
  }

  async onRowsCollected() {}

  collectRow(row) {
    const subGrids = this.exportMeta.subGrids;
    Object.entries(row.elements).forEach(([key, value]) => {
      subGrids[key].rows.push(value.outerHTML);
    });
  }

  buildPageHtml() {
    const me = this,
          {
      subGrids
    } = me.exportMeta; // Now when rows are collected, we need to add them to exported grid

    let html = me.prepareExportElement();
    Object.values(subGrids).forEach(({
      placeHolder,
      rows
    }) => {
      const placeHolderText = placeHolder.outerHTML;
      html = html.replace(placeHolderText, rows.join(''));
    });
    return html;
  }

} // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.

MultiPageVerticalExporter.prototype.pagesExtractor = async function* pagesExtractor(config) {
  const me = this,
        {
    exportMeta,
    stylesheets
  } = me,
        {
    totalWidth,
    paperWidth,
    paperHeight,
    contentHeight,
    scale,
    initialScroll
  } = exportMeta;
  let {
    totalPages
  } = exportMeta,
      currentPage;

  while ((currentPage = exportMeta.currentPage) < totalPages) {
    me.trigger('exportStep', {
      text: me.L(MultiPageVerticalExporter.exportingPageText, {
        currentPage,
        totalPages
      }),
      progress: Math.round((currentPage + 1) / totalPages * 90)
    });
    const {
      html,
      header,
      footer,
      offset
    } = await me.buildPage(config); // TotalHeight might change in case of variable row heights
    // Move exported content in the visible frame

    const styles = [...stylesheets, `
                <style>
                    #${config.client.id} {
                        width: ${totalWidth}px !important;
                    }
                    .b-export .b-export-content {
                        transform: scale(${scale});
                        transform-origin: top left;
                        height: auto;
                    }
                </style>
            `];

    if (config.repeatHeader) {
      const gridHeight = exportMeta.exactGridHeight ? `${exportMeta.exactGridHeight + exportMeta.currentPageTopMargin}px` : '100%';
      styles.push(`
                <style>
                    #${config.client.id} {
                        height: ${gridHeight} !important;
                    }
                    .b-export .b-export-content {
                        height: ${100 / scale}%;
                    }
                    .b-export-body {
                        height: 100%;
                        display: flex;
                    }
                    .b-export-viewport {
                        height: 100%;
                    }
                    .b-grid-vertical-scroller {
                        margin-top: ${exportMeta.currentPageTopMargin - initialScroll}px;
                    }
                </style>
                `);
    } else {
      const gridHeight = exportMeta.exactGridHeight || contentHeight - exportMeta.currentPageTopMargin;
      styles.push(`
                <style>
                    #${config.client.id} {
                        height: ${gridHeight}px !important;
                    }
                    .b-export-body {
                        overflow: hidden;
                    }
                    .b-export .b-export-content {
                        height: ${100 / scale}%;
                    }
                    .b-export-body .b-export-viewport {
                        margin-top: ${exportMeta.currentPageTopMargin}px;
                    }
                    .b-grid-vertical-scroller {
                        margin-top: -${initialScroll}px;
                    }
                </style>
                `);
    } // when aligning rows, offset gets accumulated, so we need to take it into account


    exportMeta.currentPageTopMargin -= contentHeight + offset;
    await me.stateNextPage(config);
    ({
      totalPages
    } = exportMeta);
    yield {
      html: me.pageTpl({
        html,
        header,
        footer,
        styles,
        paperWidth,
        paperHeight
      })
    };
  }
};

MultiPageVerticalExporter._$name = 'MultiPageVerticalExporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/SinglePageExporter.js":
/*!****************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/SinglePageExporter.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SinglePageExporter; });
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
var productName = 'gantt';



/**
 * @module Grid/feature/export/exporter/SinglePageExporter
 *
 * A single page export
 *
 * @classType singlepage
 * @extends Grid/feature/export/exporter/Exporter
 */

class SinglePageExporter extends _Exporter_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'SinglePageExporter';
  }

  static get type() {
    return 'singlepage';
  }

  static get title() {
    // In case locale is missing exporter is still distinguishable
    return this.localize('L{singlepage}');
  }

  static get defaultConfig() {
    return {
      /**
       * Set to true to center content horizontally on the page
       * @config {Boolean}
       */
      centerContentHorizontally: false
    };
  }

  async prepareComponent(config) {
    await super.prepareComponent(config);
    Object.assign(this.exportMeta, {
      verticalPages: 1,
      horizontalPages: 1,
      totalPages: 1,
      currentPage: 0,
      verticalPosition: 0,
      horizontalPosition: 0
    });
  }

  async onRowsCollected() {}

  positionRows(rows) {
    let currentTop = 0; // In case of variable row height row vertical position is not guaranteed to increase
    // monotonously. Position row manually instead

    return rows.map(([html, height]) => {
      const result = html.replace(/translate\(\d+px, \d+px\)/, `translate(0px, ${currentTop}px)`);
      currentTop += height;
      return result;
    });
  }

  collectRow(row) {
    const subGrids = this.exportMeta.subGrids;
    Object.entries(row.elements).forEach(([key, value]) => {
      subGrids[key].rows.push([value.outerHTML, row.offsetHeight]);
    });
  }

  buildPageHtml() {
    const me = this,
          {
      subGrids
    } = me.exportMeta; // Now when rows are collected, we need to add them to exported grid

    let html = me.prepareExportElement();
    Object.values(subGrids).forEach(({
      placeHolder,
      rows
    }) => {
      const placeHolderText = placeHolder.outerHTML;
      html = html.replace(placeHolderText, me.positionRows(rows).join(''));
    });
    return html;
  }

} // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.

SinglePageExporter.prototype.pagesExtractor = async function* pagesExtractor(config) {
  // When we prepared grid we stretched it horizontally, now we need to gather all rows
  // There are two ways:
  // 1. set component height to scrollable.scrollHeight value to render all rows at once (maybe a bit more complex
  // if rows have variable height)
  // 2. iterate over rows, scrolling new portion into view once in a while
  // #1 sounds simpler, but that might require too much rendering, let's scroll rows instead
  const me = this,
        {
    client
  } = config,
        {
    rowManager,
    store
  } = client,
        styles = me.stylesheets,
        portrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_2__["Orientation"].portrait,
        paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_2__["PaperFormat"][config.paperFormat],
        paperWidth = portrait ? paperFormat.width : paperFormat.height,
        paperHeight = portrait ? paperFormat.height : paperFormat.width,
        totalRows = config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_2__["RowsRange"].visible && store.count // visibleRowCount is a projection of how much rows will fit the view, which should be
  // maximum amount of exported rows. and there can be less
  ? me.getVisibleRowsCount(client) : store.count;
  let {
    totalHeight,
    totalWidth
  } = me.exportMeta,
      processedRows = 0,
      lastDataIndex = -1,
      header,
      footer;

  if (rowManager.rows.length > 0) {
    if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_2__["RowsRange"].visible) {
      lastDataIndex = rowManager.firstVisibleRow.dataIndex - 1;
    } // Collecting rows


    while (processedRows < totalRows) {
      const rows = rowManager.rows,
            lastRow = rows[rows.length - 1],
            lastProcessedRowIndex = processedRows;
      rows.forEach(row => {
        // When we are scrolling rows will be duplicated even with disabled buffers (e.g. when we are trying to
        // scroll last record into view). So we store last processed row dataIndex (which is always growing
        // sequence) and filter all rows with lower/same dataIndex
        if (row.dataIndex > lastDataIndex && processedRows < totalRows) {
          ++processedRows;
          totalHeight += row.offsetHeight;
          me.collectRow(row);
        }
      }); // Calculate new rows processed in this iteration e.g. to collect events

      const firstNewRowIndex = rows.findIndex(r => r.dataIndex === lastDataIndex + 1),
            lastNewRowIndex = firstNewRowIndex + (processedRows - lastProcessedRowIndex);
      await me.onRowsCollected(rows.slice(firstNewRowIndex, lastNewRowIndex), config);

      if (processedRows < totalRows) {
        lastDataIndex = lastRow.dataIndex;
        await me.scrollRowIntoView(client, lastDataIndex + 1);
      }
    }
  }

  const html = me.buildPageHtml(); // Calculate header height

  totalHeight += client.height - client.bodyHeight;
  const totalClientHeight = totalHeight; // Measure header and footer height

  if (config.headerTpl) {
    header = me.prepareHTML(config.headerTpl({
      totalWidth
    }));
    const height = me.measureElement(header);
    totalHeight += height;
  }

  if (config.footerTpl) {
    footer = me.prepareHTML(config.footerTpl({
      totalWidth
    }));
    const height = me.measureElement(footer);
    totalHeight += height;
  }

  const widthScale = Math.min(1, me.getScaleValue(me.inchToPx(paperWidth), totalWidth)),
        heightScale = Math.min(1, me.getScaleValue(me.inchToPx(paperHeight), totalHeight)),
        scale = Math.min(widthScale, heightScale); // Now add style to stretch grid vertically

  styles.push(`<style>
                #${client.id} {
                    height: ${totalClientHeight}px !important;
                    width: ${totalWidth}px !important;
                }
                .b-export-content {
                    ${me.centerContentHorizontally ? 'left: 50%;' : ''}
                    transform: scale(${scale}) ${me.centerContentHorizontally ? 'translateX(-50%)' : ''};
                    transform-origin: top left;
                    height: ${scale === 1 ? 'inherit' : 'auto !important'};
                }
            </style>`);

  if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isIE11) {
    styles.push(`<style>
                .b-export-body {
                   min-height: ${totalClientHeight}px !important;
                }
         </style>`);
  } // This is a single page exporter so we only yield one page


  yield {
    html: me.pageTpl({
      html,
      header,
      footer,
      styles,
      paperWidth,
      paperHeight
    })
  };
};

SinglePageExporter._$name = 'SinglePageExporter';

/***/ }),

/***/ "./lib/Grid/feature/mixin/SummaryFormatter.js":
/*!****************************************************!*\
  !*** ./lib/Grid/feature/mixin/SummaryFormatter.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Grid/feature/mixin/SummaryFormatter
 */

/**
 * Mixin for Summary and GroupSummary that handles formatting sums.
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SummaryFormatter extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SummaryFormatter';
  }
  /**
   * Calculates sums and returns as a html table
   * @param {Grid.column.Column} column Column to calculate sum for
   * @param {Core.data.Model[]} records Records to include in calculation
   * @param {String} cls CSS class to apply to summary table
   * @param {Core.data.Model} groupRecord current group row record
   * @param {String} groupField Current groups field name
   * @param {String} groupValue Current groups value
   * @returns {String} html content
   */


  generateHtml(column, records, cls, groupRecord, groupField, groupValue) {
    const store = this.store,
          summaries = column.summaries || (column.sum ? [{
      sum: column.sum,
      renderer: column.summaryRenderer
    }] : []);
    let html = `<table class="${cls}">`;
    summaries.forEach(config => {
      let type = config.sum,
          sum = null;
      if (type === true) type = 'sum';

      switch (type) {
        case 'sum':
        case 'add':
          sum = store.sum(column.field, records);
          break;

        case 'max':
          sum = store.max(column.field, records);
          break;

        case 'min':
          sum = store.min(column.field, records);
          break;

        case 'average':
        case 'avg':
          sum = store.average(column.field, records);
          break;

        case 'count':
          sum = records.length;
          break;

        case 'countNotEmpty':
          sum = records.reduce((sum, record) => {
            const value = record[column.field];
            return sum + (value != null ? 1 : 0);
          }, 0);
          break;
      }

      if (typeof type === 'function') {
        sum = records.reduce(type, 'seed' in config ? config.seed : 0);
      }

      if (sum !== null) {
        const valueCls = 'b-grid-summary-value',
              // optional label
        labelHtml = config.label ? `<td class="b-grid-summary-label">${config.label}</td>` : ''; // value to display, either using renderer or as is

        let valueHtml = config.renderer ? config.renderer({
          config,
          sum
        }) : sum,
            summaryHtml;

        if (valueHtml == null) {
          valueHtml = '';
        } // no <td>s in html, wrap it (always the case when not using renderer)


        if (!String(valueHtml).includes('<td>')) {
          summaryHtml = labelHtml // has label, use returned html as value cell
          ? `${labelHtml}<td class="${valueCls}">${valueHtml}</td>` // no label, span entire table
          : `<td colspan="2" class="${valueCls}">${valueHtml}</td>`;
        } // user is in charge of giving correct formatting
        else {
          summaryHtml = valueHtml;
        }

        html += `<tr>${summaryHtml}</tr>`;
      }
    });
    return html + '</table>';
  }

});

/***/ }),

/***/ "./lib/Grid/localization/En.js":
/*!*************************************!*\
  !*** ./lib/Grid/localization/En.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
var productName = 'gantt';
 //<umd>



const locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeLocales(_Core_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"], {
  //region Features
  ColumnPicker: {
    column: 'Column',
    columnsMenu: 'Columns',
    hideColumn: 'Hide column',
    hideColumnShort: 'Hide',
    newColumns: 'New columns'
  },
  Filter: {
    applyFilter: 'Apply filter',
    filter: 'Filter',
    editFilter: 'Edit filter',
    on: 'On',
    before: 'Before',
    after: 'After',
    equals: 'Equals',
    lessThan: 'Less than',
    moreThan: 'More than',
    removeFilter: 'Remove filter'
  },
  FilterBar: {
    enableFilterBar: 'Show filter bar',
    disableFilterBar: 'Hide filter bar'
  },
  Group: {
    group: 'Group',
    groupAscending: 'Group ascending',
    groupDescending: 'Group descending',
    groupAscendingShort: 'Ascending',
    groupDescendingShort: 'Descending',
    stopGrouping: 'Stop grouping',
    stopGroupingShort: 'Stop'
  },
  Search: {
    searchForValue: 'Search for value'
  },
  Sort: {
    sort: 'Sort',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    multiSort: 'Multi sort',
    removeSorter: 'Remove sorter',
    addSortAscending: 'Add ascending sorter',
    addSortDescending: 'Add descending sorter',
    toggleSortAscending: 'Change to ascending',
    toggleSortDescending: 'Change to descending',
    sortAscendingShort: 'Ascending',
    sortDescendingShort: 'Descending',
    removeSorterShort: 'Remove',
    addSortAscendingShort: '+ Ascending',
    addSortDescendingShort: '+ Descending'
  },
  //endregion
  //region Grid
  GridBase: {
    loadFailedMessage: 'Data loading failed!',
    syncFailedMessage: 'Data synchronization failed!',
    unspecifiedFailure: 'Unspecified failure',
    networkFailure: 'Network error',
    parseFailure: 'Failed to parse server response',
    // moved to Core for LoadMaskable:
    // loadMask           : 'Loading...',
    // syncMask           : 'Saving changes, please wait...',
    noRows: 'No records to display',
    moveColumnLeft: 'Move to left section',
    moveColumnRight: 'Move to right section',
    removeRow: 'Delete',
    moveColumnTo: region => `Move column to ${region}`
  },
  CellMenu: {
    removeRow: 'Delete'
  },
  RowCopyPaste: {
    copyRecord: 'Copy',
    cutRecord: 'Cut',
    pasteRecord: 'Paste'
  },
  //endregion
  //region Export
  PdfExport: {
    'Waiting for response from server': 'Waiting for response from server...',
    'Export failed': 'Export failed',
    'Server error': 'Server error',
    'Generating pages': 'Generating pages...'
  },
  ExportDialog: {
    width: '40em',
    labelWidth: '12em',
    exportSettings: 'Export settings',
    export: 'Export',
    exporterType: 'Control pagination',
    cancel: 'Cancel',
    fileFormat: 'File format',
    rows: 'Rows',
    alignRows: 'Align rows',
    columns: 'Columns',
    paperFormat: 'Paper format',
    orientation: 'Orientation',
    repeatHeader: 'Repeat header'
  },
  ExportRowsCombo: {
    all: 'All rows',
    visible: 'Visible rows'
  },
  ExportOrientationCombo: {
    portrait: 'Portrait',
    landscape: 'Landscape'
  },
  SinglePageExporter: {
    singlepage: 'Single page'
  },
  MultiPageExporter: {
    multipage: 'Multiple pages',
    exportingPage: ({
      currentPage,
      totalPages
    }) => `Exporting page ${currentPage}/${totalPages}`
  },
  MultiPageVerticalExporter: {
    multipagevertical: 'Multiple pages (vertical)',
    exportingPage: ({
      currentPage,
      totalPages
    }) => `Exporting page ${currentPage}/${totalPages}`
  } //endregion

});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/Grid/row/Row.js":
/*!*****************************!*\
  !*** ./lib/Grid/row/Row.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Row; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
var productName = 'gantt';







/**
 * @module Grid/row/Row
 */

/**
 * Represents a single rendered row in the grid. Consists of one row element for each SubGrid in use. The grid only
 * creates as many rows as needed to fill the current viewport (and a buffer). As the grid scrolls
 * the rows are repositioned and reused, there is not a one to one relation between rows and records.
 *
 * For normal use cases you should not have to use this class directly. Rely on using renderers instead.
 * @extends Core/Base
 */

class Row extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * When __read__, this a {@link Core.helper.util.DomClassList DomClassList} of class names to be
       * applied to this Row's elements.
       *
       * It can be __set__ using Object notation where each property name with a truthy value is added as
       * a class, or as a regular space-separated string.
       *
       * @member {Core.helper.util.DomClassList} cls
       * @accepts {Core.helper.util.DomClassList|Object}
       */

      /**
       * The class name to initially add to all row elements
       * @config {String|Core.helper.util.DomClassList|Object}
       */
      cls: {
        $config: {
          equal: (c1, c2) => (c1 === null || c1 === void 0 ? void 0 : c1.isDomClassList) && (c2 === null || c2 === void 0 ? void 0 : c2.isDomClassList) && c1.isEqual(c2)
        },
        value: 'b-grid-row'
      }
    };
  } //region Init

  /**
   * Constructs a Row setting its index.
   * @param {Object} config A configuration object which must contain the following two properties:
   * @param {Grid.view.Grid} config.grid The owning Grid.
   * @param {Grid.row.RowManager} config.rowManager The owning RowManager.
   * @param {Number} config.index The index of the row within the RowManager's cache.
   * @function constructor
   * @internal
   */


  construct(config) {
    // Set up defaults and properties
    Object.assign(this, {
      _elements: {},
      _elementsArray: [],
      _cells: {},
      _allCells: [],
      _regions: [],
      lastHeight: 0,
      lastTop: -1,
      _dataIndex: 0,
      _top: 0,
      _height: 0,
      _id: null,
      forceInnerHTML: false,
      isGroupFooter: false
    }, config);
    super.construct();
  }

  doDestroy() {
    const me = this; // No need to clean elements up if the entire thing is being destroyed

    if (!me.rowManager.isDestroying) {
      me.removeElements();

      if (me.rowManager.idMap[me.id] === me) {
        delete me.rowManager.idMap[me.id];
      }
    }

    super.doDestroy();
  } //endregion
  //region Data getters/setters

  /**
   * Get index in RowManagers rows array
   * @property {Number}
   * @readonly
   */


  get index() {
    return this._index;
  }

  set index(index) {
    this._index = index;
  }
  /**
   * Get/set this rows current index in grids store
   * @property {Number}
   */


  get dataIndex() {
    return this._dataIndex;
  }

  set dataIndex(dataIndex) {
    if (this._dataIndex !== dataIndex) {
      this._dataIndex = dataIndex;
      this.eachElement(element => element.dataset.index = dataIndex);
    }
  }
  /**
   * Get/set id for currently rendered record
   * @property {String|Number}
   */


  get id() {
    return this._id;
  }

  set id(id) {
    const me = this,
          idObj = {
      id
    },
          idMap = me.rowManager.idMap;

    if (me._id !== id || idMap[id] !== me) {
      if (idMap[me._id] === me) delete idMap[me._id];
      idMap[id] = me;
      me._id = id;
      me.eachElement(element => {
        _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(element, idObj);
        element.dataset.id = id;
      });
      me.eachCell(cell => _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(cell, idObj));
    }
  } //endregion
  //region Row elements

  /**
   * Add a row element for specified region.
   * @param {String} region Region to add element for
   * @param {HTMLElement} element Element
   * @private
   */


  addElement(region, element) {
    const me = this;
    let cellElement = element.firstElementChild;
    me._elements[region] = element;

    me._elementsArray.push(element);

    me._regions.push(region);

    _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(element, {
      index: me.index
    });
    me._cells[region] = [];

    while (cellElement) {
      me._cells[region].push(cellElement);

      me._allCells.push(cellElement);

      _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(cellElement, {
        column: cellElement.dataset.column,
        // TODO: dataset is slow, read from columnstore using index instead
        columnId: cellElement.dataset.columnId,
        rowElement: cellElement.parentNode,
        row: me
      });
      cellElement = cellElement.nextElementSibling;
    } // making css selectors simpler, dataset has bad performance but it is only set once and never read


    element.dataset.index = me.index;
  }
  /**
   * Get the element for the specified region.
   * @param {String} region
   * @returns {HTMLElement}
   */


  getElement(region) {
    return this._elements[region];
  }
  /**
   * Execute supplied function for each regions element.
   * @param {Function} fn
   */


  eachElement(fn) {
    this._elementsArray.forEach(fn);
  }
  /**
   * Execute supplied function for each cell.
   * @param {Function} fn
   */


  eachCell(fn) {
    this._allCells.forEach(fn);
  }
  /**
   * Row elements (one for each region)
   * @type {HTMLElement[]}
   * @readonly
   */


  get elements() {
    return this._elements;
  } //endregion
  //region Cell elements

  /**
   * Row cell elements
   * @property {HTMLElement[]}
   * @readonly
   */


  get cells() {
    return this._allCells;
  }
  /**
   * Get cell elements for specified region.
   * @param {String} region Region to get elements for
   * @returns {HTMLElement[]} Array of cell elements
   */


  getCells(region) {
    return this._cells[region];
  }
  /**
   * Get the cell element for the specified column.
   * @param {String|Number} columnId Column id
   * @returns {HTMLElement} Cell element
   */


  getCell(columnId) {
    return this._allCells.find(cell => {
      const cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(cell); // cellData will always have String type, use == to handle a column with Number type

      return cellData.columnId == columnId || cellData.column == columnId;
    });
  }

  removeElements(onlyRelease = false) {
    const me = this; // Triggered before the actual remove to allow cleaning up elements etc.

    me.rowManager.trigger('removeRow', {
      row: me
    });

    if (!onlyRelease) {
      me.eachElement(element => element.remove());
    }

    me._elements = {};
    me._cells = {};
    me._elementsArray.length = me._regions.length = me._allCells.length = me.lastHeight = me.height = 0;
    me.lastTop = -1;
  } //endregion
  //region Height

  /**
   * Get/set row height
   * @property {Number}
   */


  get height() {
    return this._height;
  }

  set height(height) {
    this._height = height;
  }
  /**
   * Get row height including border
   * @property {Number}
   */


  get offsetHeight() {
    // me.height is specified height, add border height to it to get cells height to match specified rowHeight
    // border height is measured in Grid#get rowManager
    return this.height + this.grid._rowBorderHeight;
  }
  /**
   * Sync elements height to rows height
   * @private
   */


  updateElementsHeight() {
    const me = this;
    me.rowManager.storeKnownHeight(me.id, me.height); // prevent unnecessary style updates

    if (me.lastHeight !== me.height) {
      this.eachElement(element => element.style.height = `${me.offsetHeight}px`);
      me.lastHeight = me.height;
    }
  } //endregion
  //region CSS

  /**
   * Add css classes to each element.
   * @param {...String|Object|Core.helper.util.DomClassList} classes
   */


  addCls(classes) {
    this.updateCls(this.cls.add(classes));
  }
  /**
   * Remove css classes from each element.
   * @param {...String|Object|Core.helper.util.DomClassList} classes
   */


  removeCls(classes) {
    this.updateCls(this.cls.remove(classes));
  }
  /**
   * Adds/removes class names according to the passed object's properties.
   *
   * Properties with truthy values are added.
   * Properties with false values are removed.
   * @param {Object} classes Object containing properties to set/clear
   */


  assignCls(classes) {
    this.updateCls(this.cls.assign(classes));
  }

  changeCls(cls) {
    return cls !== null && cls !== void 0 && cls.isDomClassList ? cls : new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](cls);
  }

  updateCls(cls) {
    this.eachElement(element => _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncClassList(element, cls));
  } //endregion
  //region Position

  /**
   * Is this the very first row?
   * @property {Boolean}
   * @readonly
   */


  get isFirst() {
    return this.dataIndex === 0;
  }
  /**
   * Row top coordinate
   * @property {Number}
   * @readonly
   */


  get top() {
    return this._top;
  }
  /**
   * Row bottom coordinate
   * @property {Number}
   * @readonly
   */


  get bottom() {
    return this._top + this._height + this.grid._rowBorderHeight;
  }
  /**
   * Sets top coordinate, translating elements position.
   * @param {Number} top Top coordinate
   * @param {Boolean} [silent] Specify `true` to not trigger translation event
   * @internal
   */


  setTop(top, silent) {
    if (this._top !== top) {
      this._top = top;
      this.translateElements(silent);
    }
  }
  /**
   * Sets bottom coordinate, translating elements position.
   * @param {Number} bottom Bottom coordinate
   * @param {Boolean} [silent] Specify `true` to not trigger translation event
   * @private
   */


  setBottom(bottom, silent) {
    this.setTop(bottom - this.offsetHeight, silent);
  }
  /**
   * Sets css transform to position elements at correct top position (translateY)
   * @private
   */


  translateElements(silent) {
    const me = this,
          positionMode = me.grid.positionMode;

    if (me.lastTop !== me.top) {
      me.eachElement(element => {
        const style = element.style;

        if (positionMode === 'translate') {
          style.transform = `translate(0,${me.top}px)`;
        } else if (positionMode === 'translate3d') {
          style.transform = `translate3d(0,${me.top}px,0)`;
        } else if (positionMode === 'position') {
          style.top = `${me.top}px`;
        }
      });

      if (!silent) {
        me.rowManager.trigger('translateRow', {
          row: me
        });
      }

      me.lastTop = me.top;
    }
  }
  /**
   * Moves all row elements up or down and updates model.
   * @param {Number} offsetTop Pixels to offset the elements
   * @private
   */


  offset(offsetTop) {
    let newTop = this._top + offsetTop; // Not allowed to go below zero (won't be reachable on scroll in that case)

    if (newTop < 0) {
      offsetTop -= newTop;
      newTop = 0;
    }

    this.setTop(newTop);
    return offsetTop;
  } //endregion
  //region Render

  /**
   * Renders a record into this rows elements (trigger event that subgrids catch to do the actual rendering).
   * @param {Number} recordIndex
   * @param {Core.data.Model} record
   * @param {Boolean} [updatingSingleRow]
   * @param {Boolean} [batch]
   * @private
   */


  render(recordIndex, record, updatingSingleRow = true, batch = false) {
    var _record, _record2, _maxRequestedHeight;

    const me = this,
          {
      cls,
      cells,
      grid,
      rowManager,
      height: oldHeight,
      _id: oldId
    } = me,
          rowElData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(me._elementsArray[0]),
          rowHeight = rowManager._rowHeight;
    let i = 0,
        cellElement,
        size; // no record specified, try looking up in store (false indicates empty row, don't do lookup

    if (!record && record !== false) {
      record = grid.store.getById(rowElData.id);
      recordIndex = grid.store.indexOf(record);
    } // Now we have acquired a record, see what classes it requires on the


    const rCls = (_record = record) === null || _record === void 0 ? void 0 : _record.cls,
          recordCls = rCls ? rCls.isDomClassList ? rCls : new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](rCls) : null;
    cls.assign({
      'b-grid-row-updating': updatingSingleRow && grid.transitionDuration,
      'b-selected': grid.isSelected((_record2 = record) === null || _record2 === void 0 ? void 0 : _record2.id)
    }); // These are DomClassLists, so they have to have their properties processed by add/remove

    if (me.lastRecordCls) {
      cls.remove(me.lastRecordCls);
    } // Assign our record's cls to the row, and cache the value so it can be removed next time round


    if (recordCls) {
      cls.add(recordCls);
      me.lastRecordCls = Object.assign({}, recordCls);
    } else {
      me.lastRecordCls = null;
    } // Flush any changes to our DomClassList to the Row's DOM


    me.updateCls(cls); // used by GroupSummary feature to clear row before

    rowManager.trigger('beforeRenderRow', {
      row: me,
      record,
      recordIndex,
      oldId
    });

    if (updatingSingleRow && grid.transitionDuration) {
      me.setTimeout(() => {
        cls.remove('b-grid-row-updating');
        me.updateCls(cls);
      }, grid.transitionDuration);
    }

    me.id = record.id;
    me.dataIndex = recordIndex; // Configured height, used as row height if renderers do not specify otherwise

    const height = !grid.fixedRowHeight && grid.getRowHeight(record) || rowHeight; // Max height returned by renderers

    let maxRequestedHeight = me.maxRequestedHeight = null;

    for (i = 0; i < cells.length; i++) {
      cellElement = cells[i];
      size = me.renderCell({
        cellElement,
        record,
        height,
        maxRequestedHeight,
        updatingSingleRow
      });

      if (!rowManager.fixedRowHeight) {
        // We want to make row in all regions as high as the highest cell
        if (size.height != null) {
          me.maxRequestedHeight = maxRequestedHeight = Math.max(maxRequestedHeight, size.height);
        }
      }
    }

    me.height = (_maxRequestedHeight = maxRequestedHeight) !== null && _maxRequestedHeight !== void 0 ? _maxRequestedHeight : height; // Height gets set during render, reflect on elements

    me.updateElementsHeight(); // Rerendering a row might change its height, which forces translation of all following rows

    if (updatingSingleRow) {
      if (oldHeight !== me.height) {
        rowManager.translateFromRow(me, batch);
      }

      rowManager.trigger('updateRow', {
        row: me,
        record,
        recordIndex,
        oldId
      });
      rowManager.trigger('renderDone');
    }

    rowManager.trigger('renderRow', {
      row: me,
      record,
      recordIndex,
      oldId
    });
    me.forceInnerHTML = false;
  }
  /**
   * Renders a single cell, calling features to allow them to hook.
   * @param {Object} options Rendering options
   * @param {HTMLElement} options.cellElement Cell element to render
   * @param {Core.data.Model} options.record Record, fetched from store if undefined
   * @param {Number} [options.height] Configured row height
   * @param {Number} [options.maxRequestedHeight] Maximum proposed row height from renderers
   * @param {Boolean} [options.updatingSingleRow] Rendered as part of updating a single row
   * @param {Boolean} [options.isMeasuring] Rendered as part of a measuring operation
   * @private
   */


  renderCell({
    cellElement,
    record,
    height,
    maxRequestedHeight,
    updatingSingleRow = true,
    isMeasuring = false
  }) {
    var _grid$hasFrameworkRen;

    const me = this,
          {
      grid
    } = me,
          cellElementData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(cellElement),
          column = grid.columns.getById(cellElementData.columnId),
          rowElement = cellElementData.rowElement,
          rowElementData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(rowElement),
          {
      // Avoid two calls to col's getters by gathering these fields.
      internalCellCls,
      cellCls,
      align,
      renderer,
      defaultRenderer,
      id: columnId
    } = column,
          cellContext = {
      columnId,
      id: rowElementData.id
    };

    if (!record) {
      // Clear out row without record
      // Edge case, only happens if groups/tree is collapsed leading to fewer records than row elements
      if (rowElementData.id === null) {
        // setting to ' ' (space) makes it not remove firstChild, thus not breaking
        // when doing real render the next time
        // NOTE: have opted to not clear cell. might be confusing in DOM but simplifies for cells reusing
        // elements internally. Another option would be to have a derenderer per column which is called
        // cell.innerHTML = ' ';
        cellElement.className = 'b-grid-cell';
        return;
      }

      record = grid.store.getById(rowElementData.id);

      if (!record) {
        return;
      }
    }

    let cellContent = column.getRawValue(record);
    const dataField = record.fieldMap[column.field],
          size = {
      configuredHeight: height,
      height: null,
      maxRequestedHeight
    },
          rendererData = {
      cellElement,
      dataField,
      rowElement,
      value: cellContent,
      record,
      column,
      size,
      grid,
      row: cellElementData.row,
      updatingSingleRow,
      isMeasuring
    },
          newCellClass = {
      'b-grid-cell': 1,
      [internalCellCls]: internalCellCls,
      // Check cell CSS should not be applied to group header rows
      [cellCls]: record.isSpecialRow && column.internalCellCls === 'b-check-cell' ? undefined : cellCls,
      'b-cell-dirty': record.isFieldModified(column.field),
      [`b-grid-cell-align-${align}`]: align,
      'b-selected': grid.isSelected(cellContext),
      'b-focused': grid.isFocused(cellContext),
      'b-auto-height': column.autoHeight
    },
          useRenderer = renderer || defaultRenderer; // Hook to allow processing cell before render, used by QuickFind

    grid.beforeRenderCell(rendererData);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncClassList(cellElement, newCellClass);
    let shouldSetContent = true; // By default, `cellContent` is raw value extracted from Record based on Column field.
    // Call `renderer` if present, otherwise set innerHTML directly.

    if (useRenderer) {
      // `cellContent` could be anything here:
      // - null
      // - undefined when nothing is returned, used when column modifies cell content, for example Widget column
      // - number as cell value, to be converted to string
      // - string as cell value
      // - string which contains custom DOM element which is handled by Angular after we render it as cell value
      // - object with special $$typeof property equals to Symbol(react.element) handled by React when JSX is returned
      // - object which has no special properties but understood by Vue because the column is marked as "Vue" column
      // - object that should be passed to the `DomSync.sync` to update the cell content
      cellContent = useRenderer.call(column, rendererData);

      if (cellContent === undefined) {
        shouldSetContent = false;
      }
    } else if (dataField) {
      cellContent = dataField.print(cellContent);
    } // Check if the cell content is going to be rendered by framework


    const hasFrameworkRenderer = (_grid$hasFrameworkRen = grid.hasFrameworkRenderer) === null || _grid$hasFrameworkRen === void 0 ? void 0 : _grid$hasFrameworkRen.call(grid, {
      cellContent,
      column
    }); // This is exceptional case, using framework rendering while grouping is not supported.
    // Need to reset the content in case of JSX is returned from the renderer.
    // Normally, if a renderer returns some content, the Grouping feature will overwrite it with the grouped value.
    // But useRenderer cannot be ignored completely, since a column might want to render additional content to the
    // grouped row. For example, Action Column may render an action button the the grouped row.

    if (hasFrameworkRenderer && record.isSpecialRow) {
      cellContent = '';
    } // If present, framework may decide if it wants our renderer to prerender the cell content or not.
    // In case of normal cells in flat grids, React and Vue perform the full rendering into the root cell element.
    // But in case of tree cell in tree grids, React and Vue require our renderer to prerender internals
    // and they perform rendering into inner "b-tree-cell-value" element. This way we can see our expand controls, bullets, etc.


    const frameworkPerformsFullRendering = hasFrameworkRenderer && !column.data.tree && !record.isSpecialRow; // `shouldSetContent` false means content is already set by the column (i.e. Widget column).
    // `frameworkPerformsFullRendering` true means full cell content is set by framework renderer.

    if (shouldSetContent && !frameworkPerformsFullRendering) {
      const hasObjectContent = cellContent != null && typeof cellContent === 'object',
            hasStringContent = typeof cellContent === 'string',
            text = hasObjectContent || cellContent == null ? '' : String(cellContent); // row might be flagged by GroupSummary to require full "redraw"

      if (me.forceInnerHTML) {
        // To allow minimal updates below, we must remove custom markup inserted by the GroupSummary feature
        cellElement.innerHTML = ''; // Delete cached content value

        delete cellElement._content;
        cellElement.lastDomConfig = null;
      } // display cell contents as text or use actual html?
      // (disableHtmlEncode set by features that decorate cell contents)


      if (!hasObjectContent && column.htmlEncode && !column.disableHtmlEncode) {
        // Set innerText if cell currently has html content (from for example group renderer),
        // always do it on Linux, it does not have firstChild.data
        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isLinux || cellElement._hasHtml) {
          cellElement.innerText = text;
          cellElement._hasHtml = false;
        } else {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setInnerText(cellElement, text);
        }
      } else {
        if (column.autoSyncHtml && (!hasStringContent || _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getChildElementCount(cellElement))) {
          // String content in html column is handled as a html template string
          if (hasStringContent) {
            // update cell with only changed attributes etc.
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(text, cellElement.firstElementChild);
          } // Other content is considered to be a DomHelper config object
          else if (hasObjectContent) {
            _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync({
              domConfig: cellContent,
              targetElement: cellElement
            });
          }
        } // Consider all returned plain objects to be DomHelper configs for cell content
        else if (hasObjectContent) {
          _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync({
            targetElement: cellElement,
            domConfig: {
              onlyChildren: true,
              children: Array.isArray(cellContent) ? cellContent : [cellContent]
            }
          });
        } // Apply text as innerHTML only if it has changed
        else if (cellElement._content !== text) {
          cellElement.innerHTML = cellElement._content = text;
        }
      }
    } // If present, framework renders content into the cell element.
    // Ignore special rows, like grouping.


    if (!record.isSpecialRow) {
      var _grid$processCellCont;

      // processCellContent is implemented in the framework wrappers
      (_grid$processCellCont = grid.processCellContent) === null || _grid$processCellCont === void 0 ? void 0 : _grid$processCellCont.call(grid, {
        cellElementData,
        rendererData,
        // In case of TreeColumn we should prerender inner cell content like expand controls, bullets, etc
        // Then the framework renders the content into the nested "b-tree-cell-value" element.
        // rendererHtml is set in TreeColumn.treeRenderer
        rendererHtml: rendererData.rendererHtml || cellContent
      });
    }

    if (column.autoHeight && size.height == null) {
      cellElement.classList.add('b-measuring-auto-height');
      size.height = cellElement.offsetHeight;
      cellElement.classList.remove('b-measuring-auto-height');
    }

    if (!isMeasuring) {
      // Allow others to affect rendering
      me.rowManager.trigger('renderCell', rendererData);
    }

    return size;
  } //endregion


}
Row._$name = 'Row';

/***/ }),

/***/ "./lib/Grid/row/RowManager.js":
/*!************************************!*\
  !*** ./lib/Grid/row/RowManager.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowManager; });
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Row_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Row.js */ "./lib/Grid/row/Row.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt'; //TODO: Handle vertical resize, add/remove row elements?







/**
 * @module Grid/row/RowManager
 */

/**
 * Virtual representation of the grid, using {@link Grid.row.Row} to represent rows. Plugs into {@link Grid.view.Grid}
 * and exposes the following functions on grid itself:
 * * {@link #function-getRecordCoords()}
 * * {@link #function-getRowById()}
 * * {@link #function-getRow()}
 * * {@link #function-getRowFor()}
 * * {@link #function-getRowFromElement()}
 *
 * @example
 * let row = grid.getRowById(1);
 *
 * @plugin
 * @private
 */

class RowManager extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  // Plugin configuration.
  static get pluginConfig() {
    return {
      chain: ['getRowById', 'getRecordCoords', 'getRow', 'getRowFor', 'getRowFromElement', 'destroy'],
      assign: ['rowHeight', 'topRow', 'bottomRow', 'firstVisibleRow', 'lastVisibleRow', 'firstFullyVisibleRow']
    };
  }

  static get defaultConfig() {
    return {
      /**
       * Number of rows to render above current viewport
       * @config {Number}
       * @default
       */
      prependRowBuffer: 5,

      /**
       * Number of rows to render below current viewport
       * @config {Number}
       * @default
       */
      appendRowBuffer: 5,

      /**
       * Default row height, assigned from Grid at construction (either from config
       * {@link Grid.view.Grid#config-rowHeight} or CSS). Can be set from renderers
       * @config {Number}
       * @default
       */
      rowHeight: null,

      /**
       * Set to `true` to get a small performance boost in applications that uses fixed row height
       * @config {Boolean}
       */
      fixedRowHeight: null,
      autoHeight: false
    };
  }

  static get properties() {
    return {
      idMap: {},
      // TODO: investigate if topIndex can to built away, since topRow is always first in array and has dataIndex??
      topIndex: 0,
      lastScrollTop: 0,
      _rows: [],
      // Record id -> row height mapping
      heightMap: new Map(),
      // Sum of entries in heightMap
      totalKnownHeight: 0,
      // Will be calculated in `estimateTotalHeight()`, as totalKnownHeight + an estimate for unknown rows
      _totalHeight: 0,
      // Average of the known heights, kept up to date when entries in the heightMap are updated
      averageRowHeight: 0,
      scrollTargetRecordId: null,
      refreshDetails: {
        topRowIndex: 0,
        topRowTop: 0
      }
    };
  } //endregion
  //region Init


  construct(config) {
    config.grid._rowManager = this;
    super.construct(config.grid, config);
  } // Chained to grids doDestroy


  doDestroy() {
    // To remove timeouts
    this._rows.forEach(row => row.destroy());

    super.doDestroy();
  }
  /**
   * Initializes the RowManager with Rows to fit specified height.
   * @param {Number} height
   * @param {Boolean} [isRendering]
   * @private
   * @category Init
   */


  initWithHeight(height, isRendering = false) {
    const me = this; // no valid height, make room for all rows

    if (me.autoHeight) {
      height = me.store.allCount * me.preciseRowOffsetHeight;
    }

    me.viewHeight = height;
    me.calculateRowCount(isRendering);
    return height;
  }
  /**
   * Releases all elements (not from dom), calculates how many are needed, creates those and renders
   */


  reinitialize(returnToTop = false) {
    const me = this; // Calculate and correct the amount of rows needed (without triggering render)
    // Rows which are found to be surplus are destroyed.

    me.calculateRowCount(false, true, true); // If our row range is outside of the store's range, force a return to top

    if (me.topIndex + me.rowCount - 1 > me.store.count) {
      returnToTop = true;
    }

    const top = me.topRow && !returnToTop ? me.topRow.top : 0;
    me.scrollTargetRecordId = null;

    if (returnToTop) {
      me.topIndex = me.lastScrollTop = 0;
    }

    const {
      topRow
    } = me;

    if (topRow) {
      // Ensure rendering from the topRow starts at the correct position
      topRow.dataIndex = me.topIndex;
      topRow.setTop(top, true);
    } // Need to estimate height in case we have Grid using autoHeight


    me.estimateTotalHeight();
    me.renderFromRow(topRow);
  } //endregion
  //region Rows

  /**
   * Add or remove rows to fit row count
   * @private
   * @category Rows
   */


  matchRowCount(skipRender = false) {
    const me = this,
          {
      rows,
      grid
    } = me,
          numRows = rows.length,
          delta = numRows - me.rowCount;

    if (delta) {
      if (delta < 0) {
        const newRows = []; // add rows

        for (let index = numRows, dataIndex = numRows ? rows[numRows - 1].dataIndex + 1 : 0; index < me.rowCount; index++, dataIndex++) {
          newRows.push(new _Row_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
            rowManager: me,
            grid,
            index,
            dataIndex
          }));
        }

        rows.push.apply(rows, newRows); // and elements (by triggering event used by SubGrid to add elements)

        me.trigger('addRows', {
          rows: newRows
        });

        if (!skipRender) {
          // render
          me.renderFromRow(rows[Math.max(0, numRows - 1)]);
        }
      } else {
        // remove rows from bottom
        const removedRows = rows.splice(numRows - delta, delta); // trigger event in case some feature needs to cleanup when removing (widget column might be interested)

        me.trigger('removeRows', {
          rows: removedRows
        });
        removedRows.forEach(row => row.destroy()); // no need to rerender or such when removing from bottom. all is good :)
      }
    }
  }
  /**
   * Calculates how many rows fit in the available height (view height)
   * @private
   * @category Rows
   */


  calculateRowCount(skipMatchRowCount = false, allowRowCountShrink = true, skipRender = false) {
    var _me$grid$columns;

    // TODO: replace prependRowBuffer, appendXX with bufferSize
    const me = this,
          {
      store
    } = me,
          visibleRowCount = Math.ceil(me.viewHeight / me.minRowOffsetHeight),
          // Want whole rows
    maxRenderRowCount = visibleRowCount + me.prependRowBuffer + me.appendRowBuffer; // If RowManager is reinitialized in a hidden state the view might not have a height

    if (!((_me$grid$columns = me.grid.columns) !== null && _me$grid$columns !== void 0 && _me$grid$columns.count) || isNaN(visibleRowCount)) {
      me.rowCount = 0;
      return 0;
    } // when for example jumping we do not want to remove excess rows,
    // since we know they are needed at other scroll locations


    if (maxRenderRowCount < me.rowCount && !allowRowCountShrink) {
      return me.rowCount;
    }

    me.visibleRowCount = visibleRowCount;
    me.rowCount = Math.min(store.count, maxRenderRowCount); // No need for more rows than data
    // If the row count doesn't match the calculated, ensure it matches,

    if (!skipMatchRowCount) {
      if (me.rows && me.rowCount !== me.rows.length) {
        me.matchRowCount(skipRender);
      } else if (!me.rowCount) {
        me.trigger('changeTotalHeight', {
          totalHeight: me.totalHeight
        });
      }

      me.grid.toggleEmptyText();
    }

    return me.rowCount;
  }

  removeAllRows() {
    // remove rows from bottom
    const me = this,
          {
      topRow
    } = me,
          result = topRow ? me.refreshDetails = {
      topRowIndex: topRow.dataIndex,
      topRowTop: topRow.top
    } : me.refreshDetails,
          removedRows = me.rows.slice(); // trigger event in case some feature needs to cleanup when removing (widget column might be interested)

    me.trigger('removeRows', {
      rows: removedRows
    });
    me.rows.forEach(row => row.destroy());
    me.rows.length = 0;
    me.idMap = {}; // We return a descriptor of the last rendered block before the remove.
    // This is primarily for a full GridBase#renderContents to be able to perform a correct refresh.

    return result;
  }

  setPosition(refreshDetails) {
    // Sets up the rendering position for the next call to reinitialize
    const {
      topRow
    } = this,
          {
      topRowIndex,
      topRowTop
    } = refreshDetails;
    topRow.setTop(topRowTop);
    topRow.dataIndex = topRowIndex;
  } //endregion
  //region Rows - Getters


  get store() {
    return this.client.store;
  }
  /**
   * Get all Rows
   * @property {Grid.row.Row[]}
   * @readonly
   * @category Rows
   */


  get rows() {
    return this._rows;
  }
  /**
   * Get the Row at specified index. Returns `undefined` if the row index is not rendered.
   * @param {Number} index
   * @returns {Grid.row.Row}
   * @category Rows
   */


  getRow(index) {
    return this.rowCount && this.rows[index - this.topIndex];
  }
  /**
   * Get Row for specified record id
   * @param {Core.data.Model|String|Number} recordOrId Record id (or a record)
   * @returns {Grid.row.Row|null} Found Row or null if record not rendered
   * @category Rows
   */


  getRowById(recordOrId) {
    if (recordOrId && recordOrId.isModel) {
      recordOrId = recordOrId.id;
    }

    return this.idMap[recordOrId];
  }
  /**
   * Get a Row from an HTMLElement
   * @param {HTMLElement} element
   * @returns {Grid.row.Row|null} Found Row or null if record not rendered
   * @category Rows
   */


  getRowFromElement(element) {
    element = element.closest('.b-grid-row');
    return element && this.getRow(element.dataset.index);
  }
  /**
   * Get the row at the specified Y coordinate, which is by default viewport-based.
   * @param {Number} y The `Y` coordinate to find the Row for.
   * @param {Boolean} [local=false] Pass `true` if the `Y` coordinate is local to the SubGrid's element.
   * @returns {Grid.row.Row} Found Row or null if no row is rendered at that point.
   */


  getRowAt(y, local = false) {
    // Make it local.
    if (!local) {
      // Because this is used with event Y positions which are integers, we must
      // round the Rectangle to the closest integer.
      y -= _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(this.grid.bodyContainer, null, true).roundPx(1).top; // Adjust for scrolling

      y += this.grid.scrollable.y;
    }

    y = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].roundPx(y);
    return this.rows.find(r => y >= r.top && y < r.bottom);
  }
  /**
   * Get a Row for either a record, a record id or an HTMLElement
   * @param {HTMLElement|Core.data.Model|String|Number} recordOrId Record or record id or HTMLElement
   * @returns {Grid.row.Row} Found Row or null if record not rendered
   * @category Rows
   */


  getRowFor(recordOrId) {
    if (recordOrId instanceof HTMLElement) {
      return this.getRowFromElement(recordOrId);
    }

    return this.getRowById(recordOrId);
  }
  /**
   * Gets the Row following the specified Row (by index or object). Wraps around the end.
   * @param {Number|Grid.row.Row} indexOrRow index or Row
   * @returns {Grid.row.Row}
   * @category Rows
   */


  getNextRow(indexOrRow) {
    const index = typeof indexOrRow === 'number' ? indexOrRow : indexOrRow.index;
    return this.getRow((index + 1) % this.rowCount);
  }
  /**
   * Get the Row that is currently displayed at top.
   * @property {Grid.row.Row}
   * @readonly
   * @category Rows
   */


  get topRow() {
    return this.rows[0];
  }
  /**
   * Get the Row currently displayed furthest down.
   * @property {Grid.row.Row}
   * @readonly
   * @category Rows
   */


  get bottomRow() {
    // TODO: remove when ticket on making sure rowCount is always up to date is fixed
    const rowCount = Math.min(this.rowCount, this.store.count);
    return this.rows[rowCount - 1];
  }
  /**
   * Get the topmost visible Row
   * @property {Grid.row.Row}
   * @readonly
   * @category Rows
   */


  get firstVisibleRow() {
    // Ceil scroll position to make behavior consistent on a scaled display
    return this.rows.find(r => r.bottom > Math.ceil(this.grid.scrollable.y));
  }

  get firstFullyVisibleRow() {
    // Ceil scroll position to make behavior consistent on a scaled display
    return this.rows.find(r => r.top >= Math.ceil(this.grid.scrollable.y));
  }
  /**
   * Get the last visible Row
   * @property {Grid.row.Row}
   * @readonly
   * @category Rows
   */


  get lastVisibleRow() {
    const grid = this.grid; // We need the last row who's top is inside the scrolling viewport

    return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].findLast(this.rows, r => r.top < grid.scrollable.y + grid.bodyHeight);
  }
  /**
   * Calls offset() for each Row passing along offset parameter
   * @param {Number} offset Pixels to translate Row elements.
   * @private
   * @category Rows
   */


  offsetRows(offset) {
    if (offset !== 0) {
      const {
        rows
      } = this,
            {
        length
      } = rows;

      for (let i = 0; i < length; i++) {
        rows[i].offset(offset);
      }
    }

    this.trigger('offsetRows', {
      offset
    });
  } //endregion
  //region Row height


  get prependBufferHeight() {
    return this.prependRowBuffer * this.rowOffsetHeight;
  }

  get appendBufferHeight() {
    return this.appendRowBuffer * this.rowOffsetHeight;
  } // TODO: should support setting rowHeight in em and then convert internally to pixels. 1em = font-size. Not needed for 1.0

  /**
   * Set a fixed row height (can still be overridden by renderers) or get configured row height. Setting refreshes all rows
   * @type {Number}
   * @on-owner
   * @category Rows
   */


  get rowHeight() {
    return this._rowHeight;
  }

  set rowHeight(height) {
    const me = this,
          {
      grid,
      fixedRowHeight
    } = me,
          oldRowHeight = me.rowHeight;
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assertNumber(height, 'rowHeight');

    if (height < 10) {
      height = 10;
    }

    me.trigger('beforeRowHeight', {
      height
    });
    me.minRowHeight = me._rowHeight = height;

    if (fixedRowHeight) {
      me.averageRowHeight = height;
    }

    if (me.rows.length) {
      const oldY = grid.scrollable.y,
            topRow = me.getRowAt(oldY, true),
            // When changing rowHeight in a scrolled grid, there might no longer be a row at oldY
      edgeOffset = topRow ? topRow.top - oldY : 0;
      let average, oldAverage; // When using fixedRowHeight there is no need to update an average

      if (fixedRowHeight) {
        average = height;
        oldAverage = oldRowHeight;
      } else {
        oldAverage = average = me.averageRowHeight;
        me.clearKnownHeights(); // Scale the average height in proportion to the row height change

        average *= height / oldRowHeight;
      } // Adjust number of rows, since it is only allowed to shrink in refresh()


      me.calculateRowCount(false, true, true); // Reposition the top row since it is used to position the rest

      me.topRow.setTop(me.topRow.dataIndex * (average + grid._rowBorderHeight), true);
      me.refresh();
      const newY = oldY * (average / oldAverage); // Scroll top row to the same position.

      if (newY !== oldY) {
        grid.scrollRowIntoView(topRow.id, {
          block: 'start',
          edgeOffset
        });
      }
    }

    me.trigger('rowHeight', {
      height
    });
  }
  /**
   * Get actually used row height, which includes any border and might be an average if using variable row height.
   * @property {Number}
   */


  get rowOffsetHeight() {
    return Math.floor(this.preciseRowOffsetHeight);
  }

  get preciseRowOffsetHeight() {
    return (this.averageRowHeight || this._rowHeight) + this.grid._rowBorderHeight;
  }

  get minRowOffsetHeight() {
    return (this.minRowHeight || this._rowHeight) + this.grid._rowBorderHeight;
  }
  /*
  * How store CRUD affects the height map:
  *
  * | Operation | Result                            |
  * |-----------|-----------------------------------|
  * | add       | No. Appears on render             |
  * | insert    | No. Appears on render             |
  * | remove    | Remove entry                      |
  * | removeAll | Clear                             |
  * | update    | No                                |
  * | replace   | Height might differ, remove entry |
  * | move      | No                                |
  * | filter    | No                                |
  * | sort      | No                                |
  * | group     | No                                |
  * | dataset   | Clear                             |
  *
  * The above is handled in GridBase
  */

  /**
   * Returns `true` if all rows have a known height. They do if all rows are visited, or if RowManager is configured
   * with `fixedRowHeight`. If so, all tops can be calculated exactly, no guessing needed
   * @property {Boolean}
   * @private
   */


  get allHeightsKnown() {
    return this.fixedRowHeight || this.heightMap.size >= this.store.count;
  }
  /**
   * Store supplied `height` using `id` as key in the height map. Called by `Row` when it gets its height.
   * Keeps `averageRowHeight` and `totalKnownHeight` up to date. Ignored when configured with `fixedRowHeight`
   * @param {String|Number} id
   * @param {Number} height
   * @internal
   */


  storeKnownHeight(id, height) {
    const me = this,
          {
      heightMap
    } = me;

    if (!me.fixedRowHeight) {
      // Decrease know height with old value
      if (heightMap.has(id)) {
        me.totalKnownHeight -= heightMap.get(id);
      } // Height here is "clientHeight"


      heightMap.set(id, height); // And increase with new

      me.totalKnownHeight += height;

      if (height < me.minRowHeight) {
        me.minRowHeight = height;
      }

      me.averageRowHeight = me.totalKnownHeight / heightMap.size;
    }
  }
  /**
   * Get the known or estimated offset height for the specified record id
   * @param {Core.data.Model} record
   * @returns {Number}
   * @private
   */


  getOffsetHeight(record) {
    const me = this;
    return (me.heightMap.get(record.id) || me.grid.getRowHeight(record) || me.averageRowHeight || me.rowHeight) + me.grid._rowBorderHeight;
  }
  /**
   * Invalidate cached height for a record. Removing it from `totalKnownHeight` and factoring it out of
   * `averageRowHeight`.
   * @param {Core.data.Model|Core.data.Model[]} records
   */


  invalidateKnownHeight(records) {
    const me = this;

    if (!me.fixedRowHeight) {
      const {
        heightMap
      } = me;

      if (!Array.isArray(records)) {
        records = [records];
      }

      records.forEach(record => {
        if (record) {
          if (heightMap.has(record.id)) {
            // Known height decreases when invalidating
            me.totalKnownHeight -= heightMap.get(record.id);
            heightMap.delete(record.id);
          }
        }
      });
      me.averageRowHeight = me.totalKnownHeight / heightMap.size;
    }
  }
  /**
   * Invalidates all cached height and resets `averageRowHeight` and `totalKnownHeight`
   */


  clearKnownHeights() {
    this.heightMap.clear();
    this.averageRowHeight = this.totalKnownHeight = 0;
  }
  /**
   * Calculates a row top from its data index. Uses known values from the height map, unknown are substituted with
   * the average row height. When configured with `fixedRowHeight`, it will always calculate a correct value
   * @param {Number} index Index in store
   * @private
   */


  calculateTop(index) {
    // When using fixed row height, life is easy
    if (this.fixedRowHeight) {
      return index * this.rowOffsetHeight;
    }

    const {
      store
    } = this;
    let top = 0; // When not using fixed row height, we make an educated guess at the top. The more rows have been visited, the
    // more correct the guess is (fully correct if all rows visited)

    for (let i = 0; i < index; i++) {
      const record = store.getAt(i);
      top += this.getOffsetHeight(record);
    }

    return Math.floor(top);
  } //endregion
  //region Calculations

  /**
   * Returns top and bottom for rendered row or estimated coordinates for unrendered.
   * @param {Core.data.Model|String|Number} recordOrId Record or record id
   * @param {Boolean} [local] Pass true to get relative record coordinates
   * @param {Boolean} [roughly] Pass true to allow a less exact but cheaper estimate
   * @returns {Core.helper.util.Rectangle} Record bounds with format { x, y, width, height, bottom, right }
   * @category Calculations
   */


  getRecordCoords(recordOrId, local = false, roughly = false) {
    const me = this,
          id = typeof recordOrId === 'string' || typeof recordOrId === 'number' ? recordOrId : recordOrId.id,
          row = me.getRowById(recordOrId);
    let scrollingViewport = me.client._bodyRectangle; // _bodyRectangle is not updated on page/containing element scroll etc. Need to make sure it is correct in case
    // that has happend. This if-statement should be removed when fixing
    // https://app.assembla.com/spaces/bryntum/tickets/6587-cached-_bodyrectangle-should-be-updated-on--quot-external-quot--scroll/details

    if (!local) {
      scrollingViewport = me.client.refreshBodyRectangle();
    } // Rendered? Then we know position for certain


    if (row) {
      return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"](scrollingViewport.x, local ? Math.round(row.top) : Math.round(row.top + scrollingViewport.y - me.client.scrollable.y), scrollingViewport.width, row.offsetHeight);
    }

    return me.getRecordCoordsByIndex(me.store.indexOf(id), local, roughly);
  }
  /**
   * Returns estimated top and bottom coordinates for specified row.
   * @param {Number} recordIndex Record index
   * @param {Boolean} [local]
   * @returns {Core.helper.util.Rectangle} Estimated record bounds with format { x, y, width, height, bottom, right }
   * @category Calculations
   */


  getRecordCoordsByIndex(recordIndex, local = false, roughly = false) {
    const me = this,
          {
      topRow,
      bottomRow
    } = me,
          scrollingViewport = me.client._bodyRectangle,
          {
      id
    } = me.store.getAt(recordIndex),
          // Not using rowOffsetHeight since it floors the value and that rounding might give big errors far down
    height = me.preciseRowOffsetHeight,
          currentTopIndex = topRow.dataIndex,
          currentBottomIndex = bottomRow.dataIndex,
          // Instead of estimating top from the very top, use closest known coordinate. Makes sure a coordinate is not
    // estimated on wrong side of rendered rows, needed to correctly draw dependencies where one event is located
    // on a unrendered row
    calculateFrom = // bottomRow is closest, calculate from it
    recordIndex > currentBottomIndex ? {
      index: recordIndex - currentBottomIndex - 1,
      y: bottomRow.bottom,
      from: 'bottomRow'
    } //  closer to topRow than 0, use topRow
    : recordIndex > currentTopIndex / 2 ? {
      index: recordIndex - currentTopIndex,
      y: topRow.top,
      from: 'topRow'
    } // closer to the very top, use it
    : {
      index: recordIndex,
      y: 0,
      from: 'top'
    },
          top = me.allHeightsKnown && !roughly // All heights are known (all rows visited or fixed row height), get actual top coord
    ? me.calculateTop(recordIndex) // Otherwise estimate
    : Math.floor(calculateFrom.y + calculateFrom.index * height),
          result = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"](scrollingViewport.x, local ? top : top + scrollingViewport.y - me.client.scrollable.y, scrollingViewport.width, // Either known height or average
    Math.floor(me.heightMap.get(id) || height)); // Signal that it's not based on an element, so is only approximate.
    // Grid.scrollRowIntoView will have to go round again using the block options below to ensure it's correct.

    result.virtual = true; // When the block becomes visible, scroll it to the logical position using the scrollIntoView's block
    // option. If it's above, use block: 'start', if below, use block: 'end'.

    result.block = result.bottom < scrollingViewport.y ? 'start' : result.y > scrollingViewport.bottom ? 'end' : 'nearest';
    return result;
  }
  /**
   * Total estimated grid height (used for scroller)
   * @property {Number}
   * @readonly
   * @category Calculations
   */


  get totalHeight() {
    return this._totalHeight;
  } //endregion
  //region Iteration etc.

  /**
   * Calls a function for each Row
   * @param {Function} fn Function that will be called with Row as first parameter
   * @category Iteration
   */


  forEach(fn) {
    this.rows.forEach(fn);
  }
  /**
   * Iterator that allows you to do for (let row of rowManager)
   * @category Iteration
   */


  [Symbol.iterator]() {
    return this.rows[Symbol.iterator]();
  } //endregion
  //region Scrolling & rendering

  /**
   * Refresh a single cell.
   * @param {Core.data.Model} record Record for row holding the cell that should be updated
   * @param {String|Number} columnId Column id to identify the cell within the row
   * @returns {Boolean} Returns `true` if cell was found and refreshed, `false` if not
   */


  refreshCell(record, columnId) {
    const row = this.getRowFor(record);

    if (row) {
      const cellElement = row.getCell(columnId);

      if (cellElement) {
        row.renderCell({
          cellElement
        });
        return true;
      }
    }

    return false;
  }
  /**
   * Renders from the top of the grid, also resetting scroll to top. Used for example when collapsing all groups.
   * @category Scrolling & rendering
   */


  returnToTop() {
    const me = this;
    me.topIndex = 0;
    me.lastScrollTop = 0;

    if (me.topRow) {
      me.topRow.dataIndex = 0; // Force the top row to the top of the scroll range

      me.topRow.setTop(0, true);
    }

    me.refresh(); // Rows rendered from top, make sure grid is scrolled to top also

    me.grid.scrollable.y = 0;
  }
  /**
   * Renders from specified records row and down (used for example when collapsing a group, does not affect rows above).
   * @param {Core.data.Model} record Record of first row to render
   * @category Scrolling & rendering
   */


  renderFromRecord(record) {
    const row = this.getRowById(record.id);

    if (row) {
      this.renderFromRow(row);
    }
  }
  /**
   * Renders from specified row and down (used for example when collapsing a group, does not affect rows above).
   * @param {Grid.row.Row} fromRow First row to render
   * @category Scrolling & rendering
   */


  renderFromRow(fromRow = null) {
    const me = this,
          {
      rows,
      store
    } = me,
          storeCount = store.count; // Calculate row count, adding rows if needed, but do not rerender - we are going to do that below.
    // Bail out if no rows. Allow removing rows if we have more than store have rows

    if (me.calculateRowCount(false, storeCount < rows.length, true) === 0) {
      return;
    }

    let // render from this row
    fromRowIndex = fromRow ? rows.indexOf(fromRow) : 0,
        // starting either from its specified dataIndex or from its index (happens on first render, no dataIndex yet)
    dataIndex = fromRow ? fromRow.dataIndex : rows[0].dataIndex,
        // amount of records after this one in store
    recordsAfter = storeCount - dataIndex - 1,
        // render to this row, either the last row or the row which will hold the last record available
    toRowIndex = Math.min(rows.length - 1, fromRowIndex + recordsAfter),
        // amount of rows which wont be rendered below last record (if we have fewer records than topRow + row count)
    leftOverCount = rows.length - toRowIndex - 1,
        // Start with top correctly just below the previous row's bottom
    top = fromRowIndex > 0 ? rows[fromRowIndex - 1].bottom : rows[fromRowIndex].top,
        row; // _rows array is ordered in display order, just iterate to the end

    for (let i = fromRowIndex; i <= toRowIndex; i++) {
      row = rows[i]; // Needed in scheduler when translating events, happens before render

      row.dataIndex = dataIndex; // Silent translation, render will update contents anyway

      row.setTop(top, true);
      row.render(dataIndex, store.getAt(dataIndex++), false);
      top += row.offsetHeight;
    } // if number for records to display has decreased, for example by collapsing a node, we might get unused rows
    // below bottom. move those to top to not have unused rows laying around


    while (leftOverCount-- > 0) {
      me.displayRecordAtTop();
    } // Renderers might yield a lower row height than the configured, leaving blank space at bottom


    if (me.bottomRow.bottom < me.viewHeight) {
      me.calculateRowCount();
    } // Reestimate total height


    me.estimateTotalHeight(true);
    me.trigger('renderDone');
  }
  /**
   * Renders the passed array (or [Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set)) of {@link Grid.row.Row rows}
   * @param {Grid.row.Row[]|Set} rows The rows to render
   * @category Scrolling & rendering
   */


  renderRows(rows) {
    let oldHeight,
        heightChanged = false;
    rows = Array.from(rows); // Sort topmost row first

    rows.sort((a, b) => a.dataIndex - b.dataIndex); // Render the requested rows.

    for (const row of rows) {
      oldHeight = row.height; // Pass updatingSingleRow as false, so that it does not shuffle following
      // rows downwards on each render. We do that once here after the rows are all refreshed.

      row.render(null, null, false);
      heightChanged |= row.height !== oldHeight;
    } // If this caused a height change, shuffle following rows.


    if (heightChanged) {
      this.translateFromRow(rows[0]);
    }

    this.trigger('renderDone');
  }
  /**
   * Translates all rows after the specified row. Used when a single rows height is changed and the others should
   * rearrange. (Called from Row#render)
   * @param {Grid.row.Row} fromRow
   * @private
   * @category Scrolling & rendering
   */


  translateFromRow(fromRow, batch = false) {
    const me = this;
    let top = fromRow.bottom,
        row,
        index;

    for (index = fromRow.dataIndex + 1, row = me.getRow(index); row; row = me.getRow(++index)) {
      row.setTop(top);
      top += row.offsetHeight;
    } // Reestimate total height


    if (!batch) {
      me.estimateTotalHeight(true);
    }
  }
  /**
   * Rerender all rows
   * @category Scrolling & rendering
   */


  refresh() {
    const me = this,
          {
      topRow
    } = me; // too early

    if (!topRow) {
      return;
    }

    me.idMap = {};
    me.renderFromRow(topRow);
    me.trigger('refresh');
  }
  /**
   * Makes sure that specified record is displayed in view
   * @param newScrollTop Top of visible section
   * @param [forceRecordIndex] Index of record to display at center
   * @private
   * @category Scrolling & rendering
   */


  jumpToPosition(newScrollTop, forceRecordIndex) {
    // There are two very different requirements here.
    // If there is a forceRecordIndex, that takes precedence to get it into the center of the
    // viewport, and wherever we render the calculated row block, we may then *adjust the scrollTop*
    // to get that row to the center.
    //
    // If there's no forceRecordIndex, then the scroll position is the primary objective and
    // we must render what we calculate to be correct at that viewport position.
    const me = this,
          {
      store,
      heightMap
    } = me,
          storeCount = store.count;

    if (me.allHeightsKnown && !me.fixedRowHeight) {
      const top = newScrollTop - me.prependBufferHeight,
            border = me.grid._rowBorderHeight;
      let accumulated = 0,
          targetIndex = 0;

      while (accumulated < top) {
        const record = store.getAt(targetIndex);
        accumulated += heightMap.get(record.id) + border;
        targetIndex++;
      }

      const startIndex = Math.max(Math.min(targetIndex, storeCount - me.rowCount), 0);
      me.lastScrollTop = newScrollTop;
      me.topRow.dataIndex = me.topIndex = startIndex;
      me.topRow.setTop(me.calculateTop(startIndex), false); // render entire buffer

      me.refresh();
    } else {
      const rowHeight = me.preciseRowOffsetHeight,
            // Calculate index of the top of the rendered block.
      // If we are targeting the scrollTop, this will be the top index at the scrollTop minus prepend count.
      // If we are targeting a recordIndex, this will attempt to place that in the center of the rendered block.
      targetIndex = forceRecordIndex == null ? Math.floor(newScrollTop / rowHeight) - me.prependRowBuffer : forceRecordIndex - Math.floor(me.rowCount / 2),
            startIndex = Math.max(Math.min(targetIndex, storeCount - me.rowCount), 0),
            viewportTop = me.client.scrollable.y,
            viewportBottom = Math.min(me.client._bodyRectangle.height + viewportTop + me.appendBufferHeight, me.totalHeight);
      me.lastScrollTop = newScrollTop;
      me.topRow.dataIndex = me.topIndex = startIndex;
      me.topRow.setTop(Math.floor(startIndex * rowHeight), false); // render entire buffer

      me.refresh(); // TODO: It is likely the approach below will be needed for scrolling in opposite direction also, although no
      //   problem encountered yet
      // Not filled all the way down?

      if (me.bottomRow.bottom < viewportBottom) {
        // Might have jumped into a section of low heights. Needs to be done after the refresh, since heights
        // are not known before it
        me.calculateRowCount(false, false, false); // Fill with available rows (might be available above buffer because of var row height), stop if we run out of records :)

        while (me.bottomRow.bottom < viewportBottom && me._rows[me.prependRowBuffer].top < viewportTop && me.bottomRow.dataIndex < storeCount - 1) {
          me.displayRecordAtBottom();
        } // TODO: Block below was not needed for current tests, but if row height in one block is enough smaller
        //  than average row height then we will need to add more rows
        // Still not filled all the way down? Need more rows
        // if (me.bottomRow.bottom < viewportBottom) {
        //     //const localAverage = blockHeight / me.rowCount;
        //     while (me.bottomRow.bottom < viewportBottom) {
        //        me.addRecordAtBottom();
        //     }
        // }

      }

      me.estimateTotalHeight();
    } // If the row index is our priority, then scroll it into the center


    if (forceRecordIndex != null) {
      const {
        scrollable
      } = me.grid,
            targetRow = me.getRow(forceRecordIndex),
            // When coming from a block of high rowHeights to one with much lower we might still miss the target...
      // TODO: Jump again in these cases?
      rowCenter = targetRow && _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(targetRow._elementsArray[0]).center.y,
            viewportCenter = scrollable.viewport.center.y; // Scroll the targetRow into the center of the viewport

      if (targetRow) {
        scrollable.y = newScrollTop = Math.floor(scrollable.y + (rowCenter - viewportCenter));
      }
    }

    return newScrollTop;
  }
  /**
   * Jumps to a position if it is far enough from current position. Otherwise does nothing.
   * @private
   * @category Scrolling & rendering
   */


  warpIfNeeded(newScrollTop) {
    const me = this,
          result = {
      newScrollTop,
      deltaTop: newScrollTop - me.lastScrollTop
    }; // if gap to fill is large enough, better to jump there than to fill row by row

    if (Math.abs(result.deltaTop) > me.rowCount * me.rowOffsetHeight * 3) {
      // no specific record targeted
      let index; // Specific record specified as target of scroll?

      if (me.scrollTargetRecordId) {
        index = me.store.indexOf(me.scrollTargetRecordId); // since scroll is happening async record might have been removed after requesting scroll,
        // in that case we rely on calculated index (as when scrolling without target)
      } // perform the jump and return results


      result.newScrollTop = me.jumpToPosition(newScrollTop, index);
      result.deltaTop = 0; // no extra filling needed
    }

    return result;
  }
  /**
   * Handles virtual rendering (only visible rows + buffer are in dom) for rows
   * @param {Number} newScrollTop The `Y` scroll position for which to render rows.
   * @param {Boolean} [force=false] Pass `true` to update the rendered row block even if the scroll position has not changed.
   * @return {Number} Adjusted height required to fit rows
   * @private
   * @category Scrolling & rendering
   */


  updateRenderedRows(newScrollTop, force, ignoreError = false) {
    const me = this,
          clientRect = me.client._bodyRectangle; // Might be triggered after removing all records, should not crash

    if (me.rowCount === 0) {
      return 0;
    }

    let result = me.totalHeight;

    if (force || // Only react if we have scrolled by one row or more
    Math.abs(newScrollTop - me.lastScrollTop) >= me.rowOffsetHeight || // or if we have a gap at top/bottom (#9375)
    me.topRow.top > newScrollTop || me.bottomRow.bottom < newScrollTop + clientRect.height) {
      // If scrolled by a large amount, jump instead of rendering each row
      const posInfo = me.warpIfNeeded(newScrollTop);
      me.scrollTargetRecordId = null; // Cache the last correct render scrollTop before fill.
      // it can be adjusted to hide row position corrections.

      me.lastScrollTop = posInfo.newScrollTop;

      if (posInfo.deltaTop > 0) {
        // Scrolling down
        me.fillBelow(posInfo.newScrollTop);
      } else if (posInfo.deltaTop < 0) {
        // Scrolling up
        me.fillAbove(posInfo.newScrollTop);
      }

      if (!me.fixedRowHeight && !ignoreError) {
        me.correctError(posInfo, clientRect, newScrollTop);
      } // Calculate the new height based on new content


      result = me.estimateTotalHeight();
    }

    return result;
  }

  correctError(posInfo, clientRect, newScrollTop) {
    const me = this;
    let error = 0; // TODO: Merge with else, does the same calculation
    // When we transition from not knowing all heights to doing so, the old estimate will likely have positioned
    // rows a bit off. Compensate for that here.

    if (me.allHeightsKnown) {
      error = me.topRow.top - me.calculateTop(me.topRow.dataIndex);
    } // If it's a temporary scroll, we can be told to ignore the drift.
    // Apart from that, we must correct keep the rendered block position correct.
    // Otherwise, when rolling upwards after a teleport, we may not be able to reach
    // the top. Some rows may end up at -ve positions.
    else {
      // Only correct the rendered block position if we are in danger of running out of scroll space.
      // That is if we are getting towards the top or bottom of the scroll range.
      if ( // Scrolling up within top zone
      posInfo.deltaTop < 0 && newScrollTop < clientRect.height * 2 || // Scrolling down within bottom zone
      posInfo.deltaTop > 0 && newScrollTop > me.totalHeight - clientRect.height * 2 - 3) {
        // TODO: Calc could be eased more, using distance left to have less effect the further away from top/bottom
        error = me.topRow.top - me.calculateTop(me.topRow.dataIndex); //me.topIndex * me.rowOffsetHeight;
      }
    }

    if (error) {
      // Correct the rendered block position if it's not at the calculated position.
      // Keep the visual position correct by adjusting the scrollTop by the same amount.
      // When variable row heights are used, this will keep the rendered block top correct.
      me.offsetRows(-error);
      me.grid.scrollable.y = me.lastScrollTop = me.grid.scrollable.y - error;
    }
  }
  /**
   * Moves as many rows from the bottom to the top that are needed to fill to current scroll pos.
   * @param newTop Scroll position
   * @private
   * @category Scrolling & rendering
   */


  fillAbove(newTop) {
    const me = this,
          fillHeight = newTop - me.topRow.top - me.prependBufferHeight;
    let accumulatedHeight = 0;

    while (accumulatedHeight > fillHeight && me.topIndex > 0) {
      // We want to show prev record at top of rows
      accumulatedHeight -= me.displayRecordAtTop();
    }

    me.trigger('renderDone');
  }
  /**
   * Moves as many rows from the top to the bottom that are needed to fill to current scroll pos.
   * @param newTop Scroll position
   * @private
   * @category Scrolling & rendering
   */


  fillBelow(newTop) {
    const me = this,
          fillHeight = newTop - me.topRow.top - me.prependBufferHeight,
          recordCount = me.store.count,
          rowCount = me.rowCount;
    let accumulatedHeight = 0; // Repeat until we have filled empty height

    while (accumulatedHeight < fillHeight && // fill empty height
    me.topIndex + rowCount < recordCount && // as long as we have records left
    me.topRow.top + me.topRow.offsetHeight < newTop // and do not move top row fully into view (can happen with var row height)
    ) {
      // We want to show next record at bottom of rows
      accumulatedHeight += me.displayRecordAtBottom();
    }

    me.trigger('renderDone');
  }
  /**
   * Estimates height needed to fit all rows, based on average row height. Also offsets rows if needed to not be above
   * the reachable area of the view.
   * @param {Boolean} [immediate] Specify true to pass the `immediate` flag on to any listeners (probably only Grid
   * cares. Used to bypass buffered element resize)
   * @returns {Number}
   * @private
   * @category Scrolling & rendering
   */


  estimateTotalHeight(immediate = false) {
    const me = this;

    if (me.grid.renderingRows) {
      return;
    }

    const recordCount = me.store.count,
          unknownCount = recordCount - me.heightMap.size,
          {
      bottomRow
    } = me;
    let estimate; // No need to estimate when using fixed row height

    if (me.fixedRowHeight) {
      estimate = recordCount * me.rowOffsetHeight;
    } else {
      estimate = // Known height, from entries in heightMap
      me.totalKnownHeight + // Those heights are "clientHeights", estimate needs to include borders
      me.heightMap.size * me.grid._rowBorderHeight + // Add estimate for rows with unknown height
      unknownCount * me.preciseRowOffsetHeight; // No bottomRow yet if estimating initial height in autoHeight grid

      if (bottomRow && unknownCount) {
        const bottom = bottomRow.bottom; // Too low estimate or reached the end with scroll left, adjust to fit current bottom

        if (bottom > estimate || me.topIndex + me.rowCount >= recordCount && estimate > bottom && bottom > 0) {
          estimate = bottom; // estimate all the way down

          if (bottomRow.dataIndex < recordCount - 1) {
            estimate += (recordCount - 1 - bottomRow.dataIndex) * me.preciseRowOffsetHeight;
          }
        }
      }

      estimate = Math.floor(estimate);
    }

    if (estimate !== me.totalHeight) {
      if (me.trigger('changeTotalHeight', {
        totalHeight: estimate,
        immediate
      }) !== false) {
        me._totalHeight = estimate;
      }
    }

    return estimate;
  }
  /**
   * Moves a row from bottom to top and renders the corresponding record to it.
   * @returns {Number} New row height
   * @private
   * @category Scrolling & rendering
   */


  displayRecordAtTop() {
    const me = this,
          recordIndex = me.topIndex - 1,
          record = me.store.getAt(recordIndex),
          // Row currently rendered at the bottom, the row we want to move
    bottomRow = me.bottomRow,
          bottomRowTop = bottomRow.top;
    me.trigger('beforeTranslateRow', {
      row: bottomRow,
      newRecord: record
    }); // estimated top, for rendering that depends on having top

    bottomRow._top = me.topRow.top - me.getOffsetHeight(record); // if configured with fixed row height, it will be the correct value

    bottomRow.estimatedTop = !me.fixedRowHeight; // Render row

    bottomRow.render(recordIndex, record, false); // Move it to top. Restore top so that the setter won't reject non-change
    // if the estimate happened to be correct.

    bottomRow._top = bottomRowTop;
    bottomRow.setBottom(me.topRow.top);
    bottomRow.estimatedTop = false; // Prev row is now at top

    me.topIndex--; // move to start of array (bottomRow becomes topRow)

    me._rows.unshift(me._rows.pop());

    return bottomRow.offsetHeight;
  }
  /**
   * Moves a row from top to bottom and renders the corresponding record to it.
   * @returns {Number} New row height
   * @private
   * @category Scrolling & rendering
   */


  displayRecordAtBottom() {
    const me = this,
          recordIndex = me.topIndex + me.rowCount,
          record = me.store.getAt(recordIndex),
          // Row currently rendered on the top, the row we want to move
    topRow = me.topRow;
    me.trigger('beforeTranslateRow', {
      row: topRow,
      newRecord: record
    });
    topRow.dataIndex = recordIndex; // Move it to bottom

    topRow.setTop(me.bottomRow.bottom); // Render row

    topRow.render(recordIndex, record, false); // Next row is now at top

    me.topIndex++; // move to end of array (topRow becomes bottomRow)

    me._rows.push(me._rows.shift());

    return topRow.offsetHeight;
  } //endregion


}
RowManager.featureClass = '';
RowManager._$name = 'RowManager';

/***/ }),

/***/ "./lib/Grid/util/BooleanUnicodeSymbol.js":
/*!***********************************************!*\
  !*** ./lib/Grid/util/BooleanUnicodeSymbol.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanUnicodeSymbol; });
var productName = 'gantt';
class BooleanUnicodeSymbol {
  constructor(value) {
    this._value = value;
  }

  get value() {
    return this._value;
  }

  toString() {
    return Boolean(this.value) ? '✓' : '';
  }

}
BooleanUnicodeSymbol._$name = 'BooleanUnicodeSymbol';

/***/ }),

/***/ "./lib/Grid/util/GridScroller.js":
/*!***************************************!*\
  !*** ./lib/Grid/util/GridScroller.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridScroller; });
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
var productName = 'gantt';

/**
 * @module Grid/util/GridScroller
 */

const xAxis = {
  x: 1
};
/**
 * A Scroller subclass which handles scrolling in a grid.
 *
 * If the grid has no parallel scrolling grids (No locked columns), then this functions
 * transparently as a Scroller.
 *
 * If there are locked columns, then scrolling to an _element_ will invoke the scroller
 * of the subgrid which contains that element.
 * @internal
 */

class GridScroller extends _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  addScroller(scroller) {
    (this.xScrollers || (this.xScrollers = [])).push(scroller);
  }

  addPartner(otherScroller, axes = xAxis) {
    if (typeof axes === 'string') {
      axes = {
        [axes]: 1
      };
    } // Link up all our X scrollers


    if (axes.x) {
      this.xScrollers.forEach((scroller, i) => scroller.addPartner(otherScroller.xScrollers[i], 'x'));
    } // We are the only Y scroller


    if (axes.y) {
      super.addPartner(otherScroller, 'y');
    }
  }

  removePartner(otherScroller) {
    this.xScrollers.forEach((scroller, i) => {
      if (!scroller.isDestroyed) {
        scroller.removePartner(otherScroller.xScrollers[i]);
      }
    });
    super.removePartner(otherScroller);
  }

  updateOverflowX(overflowX) {
    this.xScrollers && this.xScrollers.forEach(s => s.overflowX = overflowX);
    this.widget.virtualScrollers.classList[overflowX === false ? 'add' : 'remove']('b-hide-display');
  }

  scrollIntoView(element, options) {
    // If we are after an element, we have to ask the scroller of the SubGrid
    // that the element is in. It will do the X scrolling and delegate the Y
    // scrolling up to this GridScroller.
    if (element.nodeType === Element.ELEMENT_NODE) {
      for (const subGridScroller of this.xScrollers) {
        if (subGridScroller.element.contains(element)) {
          return subGridScroller.scrollIntoView(element, options);
        }
      }
    } else {
      return super.scrollIntoView(element, options);
    }
  }

  set x(x) {
    if (this.xScrollers) {
      this.xScrollers[0].x = x;
    }
  }

  get x() {
    // when trying to scroll grid with no columns xScrollers do not exist
    return this.xScrollers ? this.xScrollers[0].x : 0;
  }

}
GridScroller._$name = 'GridScroller';

/***/ }),

/***/ "./lib/Grid/util/SubGridScroller.js":
/*!******************************************!*\
  !*** ./lib/Grid/util/SubGridScroller.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SubGridScroller; });
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';
/**
* @module Grid/util/SubGridScroller
*/




const immediatePromise = Promise.resolve(),
      defaultScrollOptions = {
  block: 'nearest'
};
/**
 * A Scroller subclass which handles scrolling in a SubGrid. Needs special treatment since the SubGrid itself only
 * allows horizontal scrolling, while the vertical scrolling is done by an outer element containing all subgrids.
 *
 * @internal
 */

class SubGridScroller extends _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // SubGrids do not drive the scrollWidth of their partners (Header and Footer)
  // SubGrids scrollWidth is propagated from the Header by SubGrid.refreshFakeScroll.
  static get configurable() {
    return {
      propagate: false
    };
  }

  scrollIntoView(element, options = defaultScrollOptions) {
    const me = this,
          {
      xDelta,
      yDelta
    } = me.getDeltaTo(element, options),
          result = xDelta || yDelta ? me.scrollBy(xDelta, yDelta, options) : immediatePromise;

    if (options.highlight || options.focus) {
      result.then(() => {
        if (options.highlight) {
          if (element instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
            element.translate(-xDelta, -yDelta).highlight();
          } else {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].highlight(element);
          }
        }

        options.focus && element.focus && element.focus();
      });
    }

    return result;
  }

  scrollBy(xDelta, yDelta, options) {
    const yPromise = yDelta && this.yScroller.scrollBy(0, yDelta, options),
          xPromise = xDelta && super.scrollBy(xDelta, 0, options);

    if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
      const cancelX = xPromise.cancel,
            cancelY = yPromise.cancel; // Set up cross canceling

      xPromise.cancel = yPromise.cancel = () => {
        cancelX();
        cancelY();
      };

      return Promise.all([xPromise, yPromise]);
    }

    return xPromise || yPromise || immediatePromise;
  }

  scrollTo(toX, toY, options) {
    const yPromise = toY != null && this.yScroller.scrollTo(null, toY, options),
          xPromise = toX != null && super.scrollTo(toX, null, options); // Keep partners in sync immediately unless we are going to animate our position.
    // There are potentially three: The header, the footer and the docked fake horizontal scroller.
    // It will be more efficient and maintain correct state doing it now.

    if (!(options && options.animate)) {
      this.syncPartners();
    }

    if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
      const cancelX = xPromise.cancel,
            cancelY = yPromise.cancel; // Set up cross canceling

      xPromise.cancel = yPromise.cancel = () => {
        cancelX();
        cancelY();
      };

      return Promise.all([xPromise, yPromise]);
    }

    return xPromise || yPromise || immediatePromise;
  }

  get viewport() {
    const elementBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(this.element),
          viewport = elementBounds.intersect(_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(this.yScroller.element)); // For 0 height subgrids, viewport will be `false` but we still expect a Rectangle to be returned

    return viewport || new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](elementBounds.x, elementBounds.y, elementBounds.width, 0);
  }

  set y(y) {
    if (this.yScroller) {
      this.yScroller.y = y;
    }
  }

  get y() {
    return this.yScroller ? this.yScroller.y : 0;
  }

  get maxY() {
    return this.yScroller ? this.yScroller.maxY : 0;
  }

  get scrollHeight() {
    return this.yScroller ? this.yScroller.scrollHeight : 0;
  }

  get clientHeight() {
    return this.yScroller ? this.yScroller.clientHeight : 0;
  }

}
SubGridScroller._$name = 'SubGridScroller';

/***/ }),

/***/ "./lib/Grid/util/TableExporter.js":
/*!****************************************!*\
  !*** ./lib/Grid/util/TableExporter.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableExporter; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';



/**
 * @module Grid/util/TableExporter
 */

/**
 * This class transforms grid component into two arrays: rows and columns. Columns array contains objects with
 * meta information about column: field name, column name, width and type of the rendered value, rows array contains
 * arrays of cell values.
 *
 * ```javascript
 * const exporter = new TableExporter({ target : grid });
 * exporter.export()
 *
 * // Output
 * {
 *     columns : [
 *         { field : 'name',     value : 'First name', type : 'string',  width : 100 },
 *         { field : 'surname',  value : 'Last name',  type : 'string',  width : 100 },
 *         { field : 'age',      value : 'Age',        type : 'number',  width : 50  },
 *         { field : 'married',  value : 'Married',    type : 'boolean', width : 50  },
 *         { field : 'children', value : 'Children',   type : 'object',  width : 100 }
 *     ],
 *     rows : [
 *         ['Michael', 'Scott',   40, false, []],
 *         ['Jim',     'Halpert', 30, true,  [...]]
 *     ]
 * }
 * ```
 *
 * ## How data is exported
 *
 * Exporter iterates over store records and processes each record for each column being exported. Exporter uses same
 * approach to retrieve data as column: reading record field, configured on the column, or calling renderer function
 * if one is provided. This means data can be of any type: primitives or objects. So children array in the above code
 * snippet may contain instances of child record class.
 *
 * ## Column renderers
 *
 * Column renderers are commonly used to style the cell, or even render more HTML into it, like {@link Grid.column.WidgetColumn}
 * does. This is not applicable in case of export. Also, given grid uses virtual rendering (only renders visible rows) and
 * exporter iterates over all records, not just visible ones, we cannot provide all data necessary to the renderer. Some
 * arguments, like cellElement and row, wouldn't exist. Thus renderer is called with as much data we have: value,
 * record, column, grid, other {@link Grid.column.Column#config-renderer documented arguments} would be undefined.
 *
 * Exporter adds one more flag for renderer function: isExport. When renderer receives this flag it knows
 * data is being exported and can skip DOM work to return simpler value. Below snippet shows simplified code of the
 * widget column handling export:
 *
 * ```javascript
 * renderer({ isExport }) {
 *     if (isExport) {
 *         return null;
 *     }
 *     else {
 *         // widget rendering routine
 *         ...
 *     }
 * }
 * ```
 *
 * ## Column types
 *
 * Column types are not actually a complete list of JavaScript types (you can get actual type of the cell using typeof) it
 * is a simple and helpful meta information.
 *
 * Available column types are:
 *  * string
 *  * number
 *  * boolean
 *  * date
 *  * object
 *
 * Everything which is not primitive like string/number/bool (or a date) is considered an object. This includes null, undefined,
 * arrays, classes, functions etc.
 *
 * ## Getting column type
 *
 * If existing grid column is used, column type first would be checked with {@link Grid.column.Column#config-exportedType exportedType}
 * config. If exportedType is undefined or column does not exist in grid, type is read from a record field definition.
 * If the field is not defined, object type is used.
 *
 * Configuring exported type:
 *
 * ```javascript
 * new Grid({
 *     columns : [
 *         {
 *             name         : 'Name',
 *             field        : 'name',
 *             exportedType : 'object',
 *             renderer     : ({ value, isExport }) => {
 *                 if (isExport) {
 *                     return { value }; // return value wrapped into object
 *                 }
 *             }
 *     ]
 * })
 * ```
 *
 * @extends Core/Base
 */

class TableExporter extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Target grid instance to export data from
       * @config {Grid.view.Grid} target
       */
      target: null,

      /**
       * Specifies a default column width if no width specified
       * @config {Number} defaultColumnWidth
       * @default
       */
      defaultColumnWidth: 100,

      /**
       * Set to false to export date as it is displayed by Date column formatter
       * @config {Boolean}
       * @default
       */
      exportDateAsInstance: true,

      /**
       * If true and the grid is grouped, shows the grouped value in the first column. True by default.
       * @config {Boolean} showGroupHeader
       * @default
       */
      showGroupHeader: true,

      /**
       * An array of columns configuration used to specify columns width, headers name, and column fields to get the data from.
       * 'field' config is required. If 'text' is missing, it will try to get it retrieved from the grid column or the 'field' config.
       * If 'width' is missing, it will try to get it retrieved from the grid column or {@link #config-defaultColumnWidth} config.
       * If no columns provided the config will be generated from the grid columns.
       *
       * For example:
       * ```javascript
       * columns : [
       *     'firstName', // field
       *     'age', // field
       *     { text : 'Starts', field : 'start', width : 140 },
       *     { text : 'Ends', field : 'finish', width : 140 }
       * ]
       * ```
       *
       * @config {String[]|Object[]} columns
       * @default
       */
      columns: null,

      /**
       * When true and tree is being exported, node names are indented with {@link #config-indentationSymbol}
       * @config {Boolean}
       * @default
       */
      indent: true,

      /**
       * This symbol (four spaces by default) is used to indent node names when {@link #config-indent} is true
       * @config {String}
       * @default
       */
      indentationSymbol: '\u00A0\u00A0\u00A0\u00A0'
    };
  }
  /**
   * Exports grid data according to provided config
   * @param {Object} config
   * @returns {{ rows : Object[][], columns : Object[] }}
   */


  export(config = {}) {
    const me = this;
    config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, me.config, config);
    me.normalizeColumns(config);
    return me.generateExportData(config);
  }

  generateExportData(config) {
    const me = this,
          columns = me.generateColumns(config),
          rows = me.generateRows(config);
    return {
      rows,
      columns
    };
  }

  normalizeColumns(config) {
    // In case columns are provided we need to use normalized config. If those are not provided, we are going
    // to use real columns, possible invoking renderers (we need to pass column instance to the renderer to
    // avoid breaking API too much)
    const columns = config.columns || this.target.columns.visibleColumns.filter(rec => rec.exportable !== false);
    config.columns = columns.map(col => {
      if (typeof col === 'string') {
        return this.target.columns.find(column => column.field === col) || {
          field: col
        };
      } else {
        return col;
      }
    });
  }

  generateColumns(config) {
    return config.columns.map(col => this.processColumn(col, config));
  }

  generateRows(config) {
    const {
      columns
    } = config;

    if (!columns.length) {
      return [];
    }

    const me = this,
          {
      target
    } = me;
    return target.store // although columns are taken from config, it is convenient to provide them as a separate argument
    // because that allows to override set of columns to process
    .map(record => me.processRecord(record, columns, config)) // filter out empty rows
    .filter(cells => cells === null || cells === void 0 ? void 0 : cells.length);
  }

  getColumnType(column, store = this.target.store) {
    let result = column.exportedType || 'object';

    if (column.exportedType === undefined) {
      if (column.field) {
        const fieldDefinition = store.modelClass.getFieldDefinition(column.field);

        if (fieldDefinition && fieldDefinition.type !== 'auto') {
          result = fieldDefinition.type;
        }
      }
    }

    return result;
  }
  /**
   * Extracts export data from the column instance
   * @param {Grid.column.Column} column
   * @param {Object} config
   * @private
   * @returns {Object}
   */


  processColumn(column, config) {
    const me = this,
          {
      target
    } = me,
          {
      defaultColumnWidth
    } = config;
    let {
      field,
      text: value,
      width,
      minWidth
    } = column; // If column is not configured with field, field is generated (see Column.js around line 514).
    // In export we want empty string there

    if (!(field in target.store.modelClass.fieldMap)) {
      field = '';
    } // If name or width is missing try to retrieve them from the grid column and the field, or use default values.


    if (!value || !width) {
      const gridColumn = target.columns.find(col => col.field === field);

      if (!value) {
        value = gridColumn && gridColumn.text || field;
      } // null or undefined


      if (width == null) {
        width = gridColumn && gridColumn.width || defaultColumnWidth;
      }
    }

    width = Math.max(width || defaultColumnWidth, minWidth || defaultColumnWidth);
    return {
      field,
      value,
      width,
      type: me.getColumnType(column)
    };
  }
  /**
   * Extracts export data from the record instance reading supplied column configs
   * @param {Core.data.Model|null} record If null is passed, all columns will be filled with empty strings
   * @param {Grid.column.Column[]} columns
   * @param {Object} config
   * @private
   * @returns {Object[]}
   */


  processRecord(record, columns, config) {
    const {
      target
    } = this,
          {
      showGroupHeader,
      indent,
      indentationSymbol
    } = config;
    let cells;

    if (!record) {
      cells = columns.map(() => '');
    } else if (record.isSpecialRow) {
      if (showGroupHeader && record.meta.groupRowFor) {
        cells = columns.map(column => {
          return target.features.group.buildGroupHeader({
            // Create dummy element to get html from
            cellElement: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(),
            grid: target,
            record,
            column
          });
        });
      }
    } else {
      cells = columns.map(column => {
        var _column$field;

        let value = (_column$field = column.field) !== null && _column$field !== void 0 && _column$field.includes('.') ? record.get(column.field) : record[column.field],
            useRenderer = column.renderer || column.defaultRenderer;

        if (useRenderer && !(value && column.isDateColumn && config.exportDateAsInstance)) {
          value = useRenderer.call(column, {
            value,
            record,
            column,
            grid: target,
            isExport: true
          });
        }

        if (indent && column.tree) {
          value = `${indentationSymbol.repeat(record.childLevel)}${value}`;
        }

        return value;
      });
    }

    return cells;
  }

}
TableExporter._$name = 'TableExporter';

/***/ }),

/***/ "./lib/Grid/view/Bar.js":
/*!******************************!*\
  !*** ./lib/Grid/view/Bar.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Bar; });
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt';



/**
 * @module Grid/view/Bar
 */

/**
 * Base class used by Header and Footer. Holds an element for each column. Not intended to be used directly.
 *
 * @extends Core/widget/Widget
 * @internal
 * @abstract
 */

class Bar extends _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Bar';
  } // Factoryable type name


  static get type() {
    return 'gridbar';
  }

  static get defaultConfig() {
    return {
      htmlCls: '',
      scrollable: {} // We need a scroller, but no dimensions scroll by default

    };
  } //region Init


  get columns() {
    return this._columns || this.subGrid.columns;
  } // Only needed for tests which create standalone Headers with no owning SubGrid.


  set columns(columns) {
    this._columns = columns;
  } //endregion

  /**
   * Fix cell widths (flex or fixed width) after rendering.
   * Not a part of template any longer because of CSP
   * @private
   */


  fixCellWidths() {
    const me = this;
    let hasFlex = false,
        flexBasis; // single header "cell"

    me.columns.traverse(column => {
      const cellEl = me.getBarCellElement(column.id),
            domWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setLength(column.width),
            domMinWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setLength(column.minWidth),
            domMaxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setLength(column.maxWidth);

      if (cellEl) {
        // We have to work round the IE11 bug that flex-basis affects the content-box
        // and any padding is added as extra.
        // TODO: Remove  this when IE11 retires.
        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
          flexBasis = `calc(${domWidth} - ${me.getLrPadding(cellEl)}px)`;
        } else {
          flexBasis = domWidth;
        }

        cellEl.style.maxWidth = domMaxWidth;
        hasFlex = hasFlex || Boolean(column.flex); // Parent column without any specified width and flex should have flex calculated if any child has flex

        if (column.isParent && column.width == null && column.flex == null) {
          const flex = column.children.reduce((result, child) => result += !child.hidden && child.flex || 0, 0); // Do not want to store this flex value on the column since it is always calculated

          cellEl.style.flex = flex > 0 ? `${flex} 0 auto` : '';

          if (flex > 0) {
            // TODO: Figure out a better way of handling this, minWidth on the columns breaks the flexbox
            //  calculation compared to cells, making them misalign
            column.traverse(col => col.data.minWidth = null);
          }
        } // Normal case, set flex, width etc.
        else {
          if (parseInt(column.minWidth) >= 0) {
            cellEl.style.minWidth = domMinWidth;
          } // Clear all the things we might have to set to correct cell widths


          cellEl.style.flex = cellEl.style.flexBasis = cellEl.style.width = '';

          if (column.flex) {
            // If column has children we need to give it
            // flex-shrink: 0, flex-basis: auto so that it always
            // shrinkwraps its children without shrinking
            if (!isNaN(parseInt(column.flex)) && column.children) {
              cellEl.style.flex = `${column.flex} 0 auto`;
            } else {
              cellEl.style.flex = column.flex;
            }
          } else if (parseInt(column.width) >= 0) {
            const parent = column.parent; // Only grid header bar has a notion of group headers
            // Column is a child of an unwidthed group. We have to use width
            // to stretch it.

            if (me.isHeader && !parent.isRoot && !parent.width) {
              cellEl.style.width = domWidth;
            } else {
              // https://app.assembla.com/spaces/bryntum/tickets/8041
              // Column header widths must be set using flex-basis.
              // Using width means that wide widths cause a flexed SubGrid
              // to bust the flex rules.
              // TODO: When IE11 retires, remove calc() hacks to overcome its flexbox bugs.
              // Note that grid in Grid#onColumnsResized and SubGrid#fixCellWidths,
              // cells MUST still be sized using width since rows
              // are absolutely positioned and will not cause the busting out
              // problem, and rows will not stretch to shrinkwrap the cells
              // unless they are widthed with width.
              cellEl.style.flexBasis = flexBasis;
            }
          }
        }

        if (column.height >= 0) {
          cellEl.style.height = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setLength(column.height);
        }
      }
    });
    me.element.classList[hasFlex ? 'add' : 'remove']('b-has-flex');
  }

  getLrPadding(cellEl) {
    if (!this.cellLrPadding) {
      const s = cellEl.ownerDocument.defaultView.getComputedStyle(cellEl);
      this.cellLrPadding = parseInt(s.getPropertyValue('padding-left')) + parseInt(s.getPropertyValue('padding-right')) + parseInt(s.getPropertyValue('border-left-width')) + parseInt(s.getPropertyValue('border-right-width'));
    }

    return this.cellLrPadding;
  }
  /**
   * Get the header or footer cell element for the specified column.
   * @param {String} columnId Column id
   * @returns {HTMLElement} Header or footer element, depending on which subclass is in use.
   * @private
   */


  getBarCellElement(columnId) {
    return this.element.querySelector(`[data-column-id="${columnId}"]`);
  }

} // Register this widget type with its Factory

Bar.initClass();
Bar._$name = 'Bar';

/***/ }),

/***/ "./lib/Grid/view/Footer.js":
/*!*********************************!*\
  !*** ./lib/Grid/view/Footer.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Footer; });
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Bar_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Bar.js */ "./lib/Grid/view/Bar.js");
var productName = 'gantt';

 //import styles from '../../../resources/sass/grid/view/footer.scss';

/**
 * @module Grid/view/Footer
 */

/**
 * Grid footer, used by Summary feature. You should not need to create instances manually.
 *
 * @extends Grid/view/Bar
 * @internal
 */

class Footer extends _Bar_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'Footer';
  } // Factoryable type name


  static get type() {
    return 'gridfooter';
  }

  startConfigure(config) {
    config.scrollable.overflowX = 'hidden-scroll';
    super.startConfigure(config);
  }

  get subGrid() {
    return this._subGrid;
  }

  set subGrid(subGrid) {
    this._subGrid = this.owner = subGrid;
  }

  refreshContent() {
    this.element.firstElementChild.innerHTML = this.contentTemplate();
    this.fixFooterWidths();
  }

  onPaint({
    firstPaint
  }) {
    if (firstPaint) {
      this.refreshContent();
    }
  }

  template() {
    const region = this.subGrid.region;
    return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].tpl`
            <div class="b-grid-footer-scroller b-grid-footer-scroller-${region}">
                <div data-reference="footersElement" class="b-grid-footers b-grid-footers-${region}" data-region="${region}"></div>
            </div>
        `;
  }

  get overflowElement() {
    return this.footersElement;
  } //region Getters

  /**
   * Get the footer cell element for the specified column.
   * @param {String} columnId Column id
   * @returns {HTMLElement} Footer cell element
   */


  getFooter(columnId) {
    return this.getBarCellElement(columnId);
  } //endregion

  /**
   * Footer template. Iterates leaf columns to create content.
   * Style not included because of CSP. Widths are fixed up in
   * {@link #function-fixFooterWidths}
   * @private
   */


  contentTemplate() {
    const me = this;
    return me.columns.visibleColumns.map(column => {
      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].tpl`
                <div
                    class="b-grid-footer ${column.align ? `b-grid-footer-align-${column.align}` : ''} ${column.cls || ''}"
                    data-column="${column.field || ''}" data-column-id="${column.id}" data-all-index="${column.allIndex}"
                    >
                    ${column.footerText || ''}
                </div>`;
    }).join('');
  }
  /**
   * Fix footer widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
   * @private
   */


  fixFooterWidths() {
    this.fixCellWidths();
  }

} // Register this widget type with its Factory

Footer.initClass();
Footer._$name = 'Footer';

/***/ }),

/***/ "./lib/Grid/view/Grid.js":
/*!*******************************!*\
  !*** ./lib/Grid/view/Grid.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Grid; });
/* harmony import */ var _GridBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../feature/ColumnAutoWidth.js */ "./lib/Grid/feature/ColumnAutoWidth.js");
/* harmony import */ var _feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony import */ var _feature_Filter_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _feature_Group_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony import */ var _feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _feature_RowCopyPaste_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../feature/RowCopyPaste.js */ "./lib/Grid/feature/RowCopyPaste.js");
/* harmony import */ var _feature_Sort_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _feature_Stripe_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
var productName = 'gantt'; //region Import

 // import default features (might be able to skip this when draft on dynamic import is implemented)








 // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/3.1.0 for more information.







 // To enable using checkbox selection mode, moved here to not be dragged into GridBase automatically

 //endregion

/**
 * @module Grid/view/Grid
 */

/**
 * The Grid component is a very powerful and performant UI component that shows tabular data (or tree data using the {@link Grid.view.TreeGrid}).
 *
 * <h2>Intro</h2>
 * The Grid widget has a wide range of features and a large API to allow users to work with data efficiently in the browser. The two
 * most important configs are {@link #config-store} and {@link #config-columns}. With the store config, you decide which data to load into the grid.
 * You can work with both in-memory arrays or load data using ajax. See the {@link Core.data.Store} class to learn more about loading data into stores.
 *
 * The columns config accepts an array of {@link Grid.column.Column Column} descriptors defining which fields that will be displayed in the grid.
 * The {@link Grid.column.Column#config-field} property in the column descriptor maps to a field in your dataset. The simplest grid configured with inline data and two columns would
 * look like this:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          columns: [
 *              { field: 'name', text: 'Name' },
 *              { field: 'job', text: 'Job', renderer: ({value}) => value || 'Unemployed' }
 *          ],
 *
 *          data: [
 *              { name: 'Bill', job: 'Retired' },
 *              { name: 'Elon', job: 'Visionary' },
 *              { name: 'Me' }
 *          ]
 *      });
 *
 * {@inlineexample Grid/view/Grid.js}
 * <h2>Features</h2>
 * To avoid the Grid core being bloated, its main features are implemented in separate ´feature´ classes. These can be turned on and off based
 * on your requirements. To configure (or disable) a feature, use the {@link #config-features} object to provide your desired configuration for the features
 * you want to use. Each feature has an ´id´ that you use as a key in the features object:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          features : {
 *              cellEdit     : false,
 *              regionResize : true,
 *              cellTooltip  : {
 *                  tooltipRenderer : (data) => {
 *                  }
 *              },
 *              ...
 *          }
 *      });
 *
 * {@region Column configuration options}
 * A grid contains a number of columns that control how your data is rendered. The simplest option is to simply point a Column to a field in your dataset, or define a custom {@link Grid.column.Column#config-renderer}.
 * The renderer function receives one object parameter containing rendering data for the current cell being rendered.
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          columns: [
 *              {
 *                  field: 'task',
 *                  text: 'Task',
 *                  renderer: (renderData) => {
 *                      const record = renderData.record;
 *
 *                      if (record.percentDone === 100) {
 *                          renderData.cellElement.classList.add('taskDone');
 *                          renderData.cellElement.style.background = 'green';
 *                      }
 *
 *                      return renderData.value;
 *                  }
 *              }
 *          ]
 *      });
 *
 * {@endregion}
 * {@region Grid sections (aka "locked" or "frozen" columns)}
 * The grid can be divided horizontally into individually scrollable sections. This is great if you have lots of columns that
 * don't fit the available width of the screen. To enable this feature, simply mark the columns you want to `lock`.
 * Locked columns are then displayed in their own section to the left of the other columns:
 *
 * ```javascript
 * let grid = new Grid({
 *     appendTo : document.body,
 *     width    : 500,
 *     subGridConfigs : {
 *         // set a fixed locked section width if desired
 *         locked : { width: 300 }
 *     },
 *     columns : [
 *         { field : 'name', text : 'Name', width : 200, locked : true },
 *         { field : 'firstName', text : 'First name', width : 100, locked : true },
 *         { field : 'surName', text : 'Last name', width : 100, locked : true },
 *         { field : 'city', text : 'City', width : 100 },
 *         { type : 'number', field : 'age', text : 'Age', width : 200 },
 *         { field : 'food', text : 'Food', width : 200 }
 *     ]
 * });
 * ```
 *
 * {@inlineexample Grid/view/LockedGrid.js}
 * You can also move columns between sections by using drag and drop, or use the built-in header context menu. If you want to be able to resize the
 * locked grid section, enable the {@link Grid.feature.RegionResize regionResize} feature.
 * {@endregion}
 * {@region Filtering}
 * One important requirement of a good Grid component is the ability to filter large datasets to quickly find what you're looking for. To
 * enable filtering (through the context menu), add the {@link Grid.feature.Filter filter} feature:
 *
 *      let grid = new Grid({
 *          features: {
 *              filter: true
 *          }
 *      });
 *
 * Or activate a default filter at initial rendering:
 *
 *      let grid = new Grid({
 *          features: {
 *              filter: { property : 'city', value : 'New York' }
 *          }
 *      });
 *
 * {@inlineexample Grid/feature/Filter.js}
 * {@endregion}
 * {@region Tooltips}
 * If you have a data models with many fields, and you want to show
 * additional data when hovering over a cell, use the {@link Grid.feature.CellTooltip cellTooltip} feature. To show a tooltip for all cells:
 *
 *      let grid = new Grid({
 *          features: {
 *              cellTooltip: ({value}) => value
 *          }
 *      });
 *
 * {@inlineexample Grid/feature/CellTooltip.js}
 * {@endregion}
 * {@region Inline Editing (default <strong>on</strong>)}
 * To enable inline cell editing in the grid, simply add the {@link Grid.feature.CellEdit cellEdit} feature:
 *
 * ```javascript
 * let grid = new Grid({
 *     appendTo : document.body,
 *
 *     features : {
 *         cellEdit : true
 *     },
 *     columns: [
 *         {
 *             field: 'task',
 *             text: 'Task'
 *         }
 *     ]
 * });
 * ```
 *
 * {@inlineexample Grid/feature/CellEdit.js}
 * {@endregion}
 * {@region Context Menu}
 * Use {@link Grid.feature.CellMenu CellMenu} and {@link Grid.feature.HeaderMenu HeaderMenu}
 * features if you want your users to be able to interact with the data through the context menu:
 *
 * ```javascript
 * let grid = new Grid({
 *     features : {
 *         headerMenu : {
 *             items : {
 *                 showInfo : {
 *                     text   : 'Show info',
 *                     icon   : 'fa fa-info-circle',
 *                     weight : 200,
 *                     onItem : ({ item }) => console.log(item.text)
 *                 }
 *             }
 *         },
 *         cellMenu :  {
 *             items : {
 *                 showOptions : {
 *                     text   : 'Show options',
 *                     icon   : 'fa fa-gear',
 *                     weight : 200
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample Grid/feature/CellMenu.js}
 * {@endregion}
 * {@region Grouping}
 * To group rows by a field in your dataset, use the {@link Grid.feature.Group group} feature.
 * {@inlineexample Grid/feature/Group.js}
 * {@endregion}
 * {@region Searching}
 * When working with lots of data, a quick alternative to filtering is the {@link Grid.feature.Search search} feature. It highlights
 * matching values in the grid as you type.
 * {@inlineexample Grid/feature/Search.js}
 * {@endregion}
 * {@region Loading and saving data}
 * The grid keeps all its data in a {@link Core.data.Store}, which is essentially an Array of {@link Core.data.Model Model} items.
 * You define your own Model representing your data entities and use the Model API to get and set values.
 *
 *      class Person extends Model {}
 *
 *      let person = new Person({
 *          name: 'Steve',
 *          age: 38
 *      });
 *
 *      person.name = 'Linda'; // person object is now `dirty`
 *
 *      let store = new Store({
 *          data : [
 *              { name : 'Don', age : 40 }
 *          ]
 *      });
 *
 *      store.add(person);
 *
 *      console.log(store.count()); // === 2
 *
 *      store.remove(person); // Remove from store
 *
 * When you update a record in a store, it's considered dirty, until you call {@link Core.data.mixin.StoreCRUD#function-commit commit} on the containing Store. You can also configure your Store to commit automatically (like Google docs).
 * If you use an AjaxStore, it will send changes to your server when commit is called.
 *
 * Any changes you make to the Store or its records are immediately reflected in the Grid, so there is no need to tell
 * it to refresh manually.
 *
 * To create a custom load mask, subscribe to the grid's store events and {@link Core.widget.Widget#config-masked mask}
 * on {@link Core.data.AjaxStore#event-beforeRequest} and unmask on {@link Core.data.AjaxStore#event-afterRequest}. The
 * mask can also be used to display error messages if an {@link Core.data.AjaxStore#event-exception} occurs.
 *
 * ```javascript
 *  const grid = new Grid({
 *      loadMask : null
 *  });
 *
 *  grid.store.on({
 *      beforeRequest() {
 *          grid.masked = {
 *              text : 'Data is loading...'
 *          };
 *      },
 *      afterRequest() {
 *          grid.masked = null;
 *      },
 *      exception({ response }) {
 *          grid.masked.error = response.message || 'Load failed';
 *      }
 *  });
 *
 *  store.load();
 * ```
 *
 * To learn more about loading and saving data, please refer to [this guide](#Grid/guides/data/displayingdata.md).
 * {@endregion}
 * {@region Default configs}
 * There is a myriad of configs and features available for Grid, some of them on by default and some of them requiring
 * extra configuration. The code below tries to illustrate the major things that are used by default:
 *
 * ```javascript
 * let grid = new Grid({
 *    // The following features are enabled by default:
 *    features : {
 *        cellEdit      : true,
 *        columnPicker  : true,
 *        columnReorder : true,
 *        columnResize  : true,
 *        cellMenu      : true,
 *        headerMenu    : true,
 *        group         : true,
 *        rowCopyPaste  : true, // Allow using [Ctrl/CMD + C/X] and [Ctrl/CMD + V] to copy/cut and paste rows
 *        sort          : true
 *    },
 *
 *    animateRemovingRows       : true,  // Rows will slide out on removal
 *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height`
 *    columnLines               : true,  // Themes might override it to hide lines anyway
 *    emptyText                 : 'No rows to display',
 *    enableTextSelection       : false, // Not allowed to select text in cells by default,
 *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
 *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
 *    loadMask                  : 'Loading...',
 *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
 *    responsiveLevels : {
 *      small : 400,
 *      medium : 600,
 *      large : '*'
 *    },
 *    rowHeight                  : null,  // Determined using CSS, it will measure rowHeight
 *    showDirty                  : false, // No indicator for changed cells
 * });
 * ```
 * {@endregion}
 * {@region Performance}
 * In general the Grid widget has very good performance and you can try loading any amount of data in the <a target="_blank" href="../examples/bigdataset">bigdataset</a> demo.
 * The overall rendering performance is naturally affected by many other things than
 * the data volume. Other important factors that can impact performance: number of columns, complex cell renderers, locked columns, the number of features enabled
 * and of course the browser (Chrome fastest, IE slowest).
 * {@endregion}
 *
 * @extends Grid/view/GridBase
 *
 * @classType grid
 */

class Grid extends _GridBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Grid';
  } // Factoryable type name


  static get type() {
    return 'grid';
  }

} // Register this widget type with its Factory

Grid.initClass();
Grid._$name = 'Grid';

/***/ }),

/***/ "./lib/Grid/view/GridBase.js":
/*!***********************************!*\
  !*** ./lib/Grid/view/GridBase.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridBase; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/util/ScrollManager.js */ "./lib/Core/util/ScrollManager.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _row_RowManager_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../row/RowManager.js */ "./lib/Grid/row/RowManager.js");
/* harmony import */ var _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../util/GridScroller.js */ "./lib/Grid/util/GridScroller.js");
/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Header.js */ "./lib/Grid/view/Header.js");
/* harmony import */ var _Footer_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Footer.js */ "./lib/Grid/view/Footer.js");
/* harmony import */ var _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./mixin/GridElementEvents.js */ "./lib/Grid/view/mixin/GridElementEvents.js");
/* harmony import */ var _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./mixin/GridFeatures.js */ "./lib/Grid/view/mixin/GridFeatures.js");
/* harmony import */ var _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./mixin/GridNavigation.js */ "./lib/Grid/view/mixin/GridNavigation.js");
/* harmony import */ var _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./mixin/GridResponsive.js */ "./lib/Grid/view/mixin/GridResponsive.js");
/* harmony import */ var _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./mixin/GridSelection.js */ "./lib/Grid/view/mixin/GridSelection.js");
/* harmony import */ var _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./mixin/GridState.js */ "./lib/Grid/view/mixin/GridState.js");
/* harmony import */ var _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./mixin/GridSubGrids.js */ "./lib/Grid/view/mixin/GridSubGrids.js");
/* harmony import */ var _Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/mixin/LoadMaskable.js */ "./lib/Core/mixin/LoadMaskable.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Grid/localization/En.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt'; //region Import

































 // Needed since Grid now has its own localization

 //endregion

/**
 * @module Grid/view/GridBase
 */

const resolvedPromise = new Promise(resolve => resolve()),
      storeListenerName = 'GridBase:store',
      defaultScrollOptions = {
  block: 'nearest',
  inline: 'nearest'
},
      datasetReplaceActions = {
  dataset: 1,
  pageLoad: 1,
  filter: 1
};
/**
 * A thin base class for {@link Grid.view.Grid}. Does not include any features by default, allowing smaller custom built
 * bundles if used in place of {@link Grid.view.Grid}.
 *
 * **NOTE:** In most scenarios you probably want to use Grid instead of GridBase.
 * @extends Core/widget/Panel
 *
 * @mixes Core/mixin/Pluggable
 * @mixes Core/mixin/State
 * @mixes Grid/view/mixin/GridElementEvents
 * @mixes Grid/view/mixin/GridFeatures
 * @mixes Grid/view/mixin/GridResponsive
 * @mixes Grid/view/mixin/GridSelection
 * @mixes Grid/view/mixin/GridState
 * @mixes Grid/view/mixin/GridSubGrids
 * @mixes Core/mixin/LoadMaskable
 *
 * @features Grid/feature/CellEdit
 * @features Grid/feature/CellMenu
 * @features Grid/feature/CellTooltip
 * @features Grid/feature/ColumnAutoWidth
 * @features Grid/feature/ColumnDragToolbar
 * @features Grid/feature/ColumnPicker
 * @features Grid/feature/ColumnReorder
 * @features Grid/feature/ColumnResize
 * @features Grid/feature/ContextMenu
 * @features Grid/feature/Filter
 * @features Grid/feature/FilterBar
 * @features Grid/feature/Group
 * @features Grid/feature/GroupSummary
 * @features Grid/feature/HeaderMenu
 * @features Grid/feature/QuickFind
 * @features Grid/feature/RegionResize
 * @features Grid/feature/RowCopyPaste
 * @features Grid/feature/RowReorder
 * @features Grid/feature/Search
 * @features Grid/feature/Sort
 * @features Grid/feature/StickyCells
 * @features Grid/feature/Stripe
 * @features Grid/feature/Summary
 * @features Grid/feature/Tree
 *
 * @features Grid/feature/experimental/ExcelExporter
 *
 * @features Grid/feature/export/PdfExport
 *
 * @plugins Grid/row/RowManager
 */

class GridBase extends _Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_13__["default"].mixin(_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_16__["default"], _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_24__["default"], _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_25__["default"], _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_26__["default"], _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_27__["default"], _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_28__["default"], _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_29__["default"], _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_30__["default"], _Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_31__["default"]) {
  //region Config
  static get $name() {
    return 'GridBase';
  } // Factoryable type name


  static get type() {
    return 'gridbase';
  }

  static get delayable() {
    return {
      onGridScroll: {
        type: 'raf'
      },
      bufferedAfterColumnsResized: 250,
      bufferedElementResize: 250
    };
  }

  static get configurable() {
    return {
      //region Hidden configs

      /**
       * @hideconfigs autoUpdateRecord, defaults, hideWhenEmpty, itemCls, items, layout, layoutStyle, lazyItems, namedItems, record, textContent, defaultAction, html, htmlCls, tag, textAlign, trapFocus, content, defaultBindProperty, ripple
       */

      /**
       * @hideproperties html, isSettingValues, isValid, items, record, values, content, layoutStyle
       */

      /**
       * @hidefunctions attachTooltip, add, getWidgetById, insert, processWidgetConfig, remove, removeAll
       */
      //endregion

      /**
       * Get/set the grid's read-only state. When set to `true`, any UIs for modifying data are disabled.
       * @member {Boolean} readOnly
       */

      /**
       * Configure as `true` to make the grid read-only, by disabling any UIs for modifying data.
       *
       * __Note that checks MUST always also be applied at the server side.__
       * @config {Boolean} readOnly
       * @default false
       */

      /**
       * Automatically set grids height to fit all rows (no scrolling in the grid). In general you should avoid
       * using `autoHeight: true`, since it will bypass Grids virtual rendering and render all rows at once, which
       * in a larger grid is really bad for performance.
       * @config {Boolean}
       * @default false
       * @category Layout
       */
      autoHeight: null,

      /**
       * Configure this as `true` to allow elements within cells to be styled as `position: sticky`.
       *
       * Columns which contain sticky content will need to be configured with
       *
       * ```javascript
       *    cellCls : 'b-sticky-cell',
       * ```
       *
       * Or a custom renderer can add the class to the passed cell element.
       *
       * It is up to the application author how to style the cell content. It is recommended that
       * a custom renderer create content with CSS class names which the application author
       * will use to apply the `position`, and matching `margin-top` and `top` styles to keep the
       * content stuck at the grid's top.
       *
       * Note that not all browsers support this CSS feature. A cross browser alternative
       * is to use the {link Grid.feature.StickyCells StickyCells} Feature.
       * @config {Boolean}
       * @category Misc
       */
      enableSticky: null,

      /**
       * Set to true to allow text selection in the grid cells
       * @config {Boolean}
       * @default false
       * @category Selection
       */
      enableTextSelection: null,

      /**
       * Set to `true` to stretch the last column in a grid with all fixed width columns
       * to fill extra available space if the grid's width is wider than the sum of all
       * configured column widths.
       * @config {Boolean}
       * @default
       * @category Layout
       */
      fillLastColumn: true,
      // TODO: break out as strategies
      positionMode: 'translate',
      // translate, translate3d, position

      /**
       * Configure as `true` to have the grid show a red "changed" tag in cells who's
       * field value has changed and not yet been committed.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      showDirty: null,

      /**
       * An object containing sub grid configuration objects keyed by a `region` property.
       * By default, grid has a 'locked' region (if configured with locked columns) and a 'normal' region.
       * The 'normal' region defaults to use `flex: 1`.
       *
       * This config can be used to reconfigure the "built in" sub grids or to define your own.
       * ```
       * // Redefining the "built in" regions
       * new Grid({
       *   subGridConfigs : {
       *     locked : { flex : 1 },
       *     normal : { width : 100 }
       *   }
       * });
       *
       * // Defining your own multi region sub grids
       * new Grid({
       *   subGridConfigs : {
       *     left   : { width : 100 },
       *     middle : { flex : 1 },
       *     right  : { width  : 100 }
       *   },
       *
       *   columns : {
       *     { field : 'manufacturer', text: 'Manufacturer', region : 'left' },
       *     { field : 'model', text: 'Model', region : 'middle' },
       *     { field : 'year', text: 'Year', region : 'middle' },
       *     { field : 'sales', text: 'Sales', region : 'right' }
       *   }
       * });
       * ```
       * @config {Object}
       * @category Misc
       */
      subGridConfigs: {
        normal: {
          flex: 1
        }
      },

      /**
       * Store that holds records to display in the grid, or a store config object. If the configuration contains
       * a `readUrl`, an `AjaxStore` will be created.
       *
       * A store will be created if none is specified.
       * @config {Core.data.Store|Object}
       * @category Common
       */
      store: {
        value: {},
        $config: 'nullify'
      },
      rowManager: {
        value: {},
        $config: ['nullify', 'lazy']
      },

      /**
       * Get the ScrollManager used by this Grid.
       * @readonly
       * @member {Core.util.ScrollManager} scrollManager
       * @category Scrolling
       */

      /**
       * Configuration values for the {@link Core.util.ScrollManager} class.
       * @config {Object|Core.util.ScrollManager}
       * @category Scrolling
       */
      scrollManager: {
        value: {},
        $config: ['nullify', 'lazy']
      },

      /**
       * Column definitions for the grid, will be used to create Column instances that are added to a ColumnStore:
       *
       * ```
       * new Grid({
       *   columns : [
       *     { text : 'Alias', field : 'alias' },
       *     { text : 'Superpower', field : 'power' }
       *   ]
       * });
       * ```
       *
       * Also accepts a store config object:
       *
       * ```
       * new Grid({
       *   columns : {
       *     data : [
       *       { text : 'Alias', field : 'alias' },
       *       { text : 'Superpower', field : 'power' }
       *     ],
       *     listeners : {
       *       update() {
       *         // Some update happened
       *       }
       *     }
       *   }
       * });
       * ```
       *
       * This store can be accessed using {@link #property-columns}:
       *
       * ```
       * grid.columns.add({ field : 'column', text : 'New column' });
       * ```
       * @config {Object[]|Object}
       * @category Common
       */
      columns: {
        value: [],
        $config: 'nullify'
      },

      /**
       * Grid's `min-height`. Defaults to `10em` to be sure that the Grid always has a height wherever it is
       * inserted.
       *
       * Can be either a String or a Number (which will have 'px' appended).
       *
       * Note that _reading_ the value will return the numeric value in pixels.
       *
       * @config {String|Number}
       * @category Layout
       */
      minHeight: '10em',
      hideFooters: true,
      contentElMutationObserver: false
    };
  } // Default settings, applied in grids constructor.


  static get defaultConfig() {
    return {
      /**
       * Row height in pixels. When set to null, an empty row will be measured and its height will be used as
       * default row height, enabling it to be controlled using CSS
       * @config {Number}
       * @category Common
       */
      rowHeight: null,

      /**
       * Use fixed row height. Setting this to `true` will configure the underlying RowManager to use fixed row
       * height, which sacrifices the ability to use rows with variable height to gain a fraction better
       * performance.
       *
       * Using this setting also ignores the {@link Grid.view.GridBase#config-getRowHeight} function, and thus any
       * row height set in data. Only Grids configured {@link Grid.view.GridBase#config-rowHeight} is used.
       *
       * @config {Boolean}
       * @category Layout
       */
      fixedRowHeight: null,

      /**
       * A function called for each row to determine its height. It is passed a {@link Core.data.Model record} and
       * expected to return the desired height of that records row. If the function returns a falsy value, Grids
       * configured {@link Grid.view.GridBase#config-rowHeight} is used.
       *
       * The default implementation of this function returns the row height from the records
       * {@link Grid.data.GridRowModel#field-rowHeight rowHeight field}.
       *
       * Override this function to take control over how row heights are determined:
       *
       * ```javascript
       * new Grid({
       *    getRowHeight(record) {
       *        if (record.low) {
       *            return 20;
       *        }
       *        else if (record.high) {
       *            return 60;
       *        }
       *
       *        // Will use grids configured rowHeight
       *        return null;
       *    }
       * });
       * ```
       *
       * NOTE: Height set in a Column renderer takes precedence over the height returned by this function.
       *
       * @config {Function} getRowHeight
       * @param {Core.data.Model} getRowHeight.record Record to determine row height for
       * @returns {Number} Desired row height
       * @category Layout
       */
      // used if no rowHeight specified and none found in CSS. not public since our themes have row height
      // specified and this is more of an internal failsafe
      defaultRowHeight: 45,

      /**
       * Text to display when there is no data to display in the grid
       * @config {String}
       * @default
       * @category Common
       */
      emptyText: 'L{noRows}',

      /**
       * Refresh entire row when a record changes (`true`) or, if possible, only the cells affected (`false`).
       *
       * When this is set to `false`, then if a column uses a renderer, cells in that column will still
       * be updated because it is impossible to know whether the cells value will be affected.
       *
       * If a standard, provided Column class is used with no custom renderer, its cells will only be updated
       * if the column's {@link Grid.column.Column#config-field} is changed.
       * @config {Boolean}
       * @default
       * @category Misc
       */
      fullRowRefresh: true,

      /**
       * True to not create any grid column headers
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      hideHeaders: null,

      /**
       * True to preserve vertical scroll position after loading new data
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      preserveScrollOnDatasetChange: null,

      /**
       * True to preserve focused cell after loading new data
       * @config {Boolean}
       * @default
       * @category Misc
       */
      preserveFocusOnDatasetChange: true,

      /**
       * Show "Remove row" item in context menu (if enabled and grid not read only).
       *
       * **DEPRECATED:** Use cellMenu feature configuration instead:
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         cellMenu : {
       *             items : {
       *                 removeRow : false
       *             }
       *         }
       *     }
       * });
       *
       * Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.
       *
       * @deprecated 4.0.0
       * @config {Boolean}
       * @default
       * @category Misc
       */
      showRemoveRowInContextMenu: true,

      /**
       * Data to set in grids store (a Store will be created if none is specified)
       * @config {Object[]}
       * @category Common
       */
      data: null,

      /**
       * Region to which columns are added when they have none specified
       * @config {String}
       * @default
       * @category Misc
       */
      defaultRegion: 'normal',

      /**
       * true to destroy the store when the grid is destroyed
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      destroyStore: null,

      /**
       * Grids change the `maskDefaults` to cover only their `body` element.
       * @config {Object|Core.widget.Mask}
       * @category Misc
       */
      maskDefaults: {
        cover: 'body',
        target: 'element'
      },

      /**
       * Set to `false` to inhibit column lines
       * @config {Boolean}
       * @default
       * @category Misc
       */
      columnLines: true,

      /**
       * Set to `false` to only measure cell contents when double clicking the edge between column headers.
       * @config {Boolean}
       * @default
       * @category Layout
       */
      resizeToFitIncludesHeader: true,

      /**
       * Set to `false` to prevent remove row animation and remove the delay related to that.
       * @config {Boolean}
       * @default
       * @category Misc
       */
      animateRemovingRows: !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isIE11,
      // IE11 doesn't have reliable firing of transitionend

      /**
       * Set to `true` to not get a warning when using another base class than GridRowModel for your grid data. If
       * you do, and would like to use the full feature set of the grid then include the fields from GridRowModel
       * in your model definition.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      disableGridRowModelWarning: null,
      headerClass: _Header_js__WEBPACK_IMPORTED_MODULE_22__["default"],
      footerClass: _Footer_js__WEBPACK_IMPORTED_MODULE_23__["default"],
      testPerformance: false,
      rowScrollMode: 'move',
      // move, dom, all

      /**
       * Grid monitors window resize by default.
       * @config {Boolean}
       * @default true
       * @category Misc
       */
      monitorResize: true,

      /**
       * An object containing Feature configuration objects (or `true` if no configuration is required)
       * keyed by the Feature class name in all lowercase.
       * @config {Object}
       * @category Common
       */
      features: true,

      /**
       * Configures whether the grid is scrollable in the `Y` axis. This is used to configure a {@link Grid.util.GridScroller}.
       * See the {@link #config-scrollerClass} config option.
       * @config {Boolean|Object|Core.helper.util.Scroller}
       * @category Scrolling
       */
      scrollable: {
        // Just Y for now until we implement a special grid.view.Scroller subclass
        // Which handles the X scrolling of subgrids.
        overflowY: true
      },

      /**
       * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Grid.util.GridScroller}.
       * @config {Core.helper.util.Scroller}
       * @typings {typeof Scroller}
       * @category Scrolling
       */
      scrollerClass: _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_21__["default"],
      refreshSuspended: 0,

      /**
       * Animation transition duration in milliseconds.
       * @config {Number}
       * @default
       * @category Misc
       */
      transitionDuration: 500,

      /**
       * Event which is used to show context menus.
       * Available options are: 'contextmenu', 'click', 'dblclick'.
       * Default value is 'contextmenu'
       * @config {String}
       * @category Misc
       */
      contextMenuTriggerEvent: 'contextmenu',
      localizableProperties: ['emptyText'],
      asyncEventSuffix: ''
    };
  }
  /**
   * Animation transition duration in milliseconds.
   * @member {Number} transitionDuration
   * @category Misc
   */


  static getLKey() {
    return '2897903c-7f52-11ec-a6ac-d094663d5c88';
  }

  static get properties() {
    return {
      _selectedRecords: [],
      _verticalScrollHeight: 0,
      virtualScrollHeight: 0,
      _scrollTop: null
    };
  }

  static get deprecatedEvents() {
    return {
      cellContextMenuBeforeShow: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`cellContextMenuBeforeShow` event is deprecated, in favor of `cellMenuBeforeShow` event. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      },
      cellContextMenuShow: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`cellContextMenuShow` event is deprecated, in favor of `cellMenuShow` event. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      },
      headerContextMenuBeforeShow: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`headerContextMenuBeforeShow` event is deprecated, in favor of `headerMenuBeforeShow` event. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      },
      headerContextMenuShow: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`headerContextMenuShow` event is deprecated, in favor of `headerMenuShow` event. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      },
      contextMenuItem: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`contextMenuItem` event is deprecated, in favor of `cellMenuItem` and `headerMenuItem` events. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      },
      contextMenuToggleItem: {
        product: 'Grid',
        invalidAsOfVersion: '5.0.0',
        message: '`contextMenuToggleItem` event is deprecated, in favor of `cellMenuToggleItem` and `headerMenuToggleItem` events. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.'
      }
    };
  } //endregion
  //region Properties

  /**
   * Get/set the store used by this Grid. The setter accepts Store or a configuration object for a store.
   * If the configuration contains a `readUrl`, an AjaxStore will be created.
   * @member {Core.data.Store} store
   * @accepts {Core.data.Store|Object}
   * @category Common
   */
  //endregion
  //region Init-destroy


  finishConfigure(config) {
    const me = this;
    super.finishConfigure(config); // When locale is applied columns react and change, which triggers `change` event on columns store for each
    // changed column, and every change normally triggers rendering view. This overhead becomes noticeable with
    // larger amount of columns. So we set two listeners to locale events: prioritized listener to be executed first
    // and suspend renderContents method and unprioritized one to resume method and call it immediately.

    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
      locale: 'onBeforeLocaleChange',
      prio: 1,
      thisObj: me
    });
    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
      locale: 'onLocaleChange',
      prio: -1,
      thisObj: me
    });
    _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
      theme: 'onThemeChange',
      thisObj: me
    });
    me.on({
      subGridExpand: 'onSubGridExpand',
      prio: -1,
      thisObj: me
    }); // Buffered for scrolling, to be called

    me.bufferedFixElementHeights = me.buffer('fixElementHeights', 350, me); // Add the extra grid classes to the element

    me.setGridClassList(me.element.classList);
  }

  onSubGridExpand() {
    // Need to rerender all rows, because if the rows were rerendered (by adding a new column to another region for example)
    // while the region was collapsed, cells in the region will be empty.
    this.renderContents();
  }

  onBeforeLocaleChange() {
    this._suspendRenderContentsOnColumnsChanged = true;
  }

  onLocaleChange() {
    this._suspendRenderContentsOnColumnsChanged = false;

    if (this.isPainted) {
      this.renderContents();
    }
  }

  finalizeInit() {
    super.finalizeInit();

    if (this.store.isLoading) {
      // Maybe show loadmask if store is already loading when grid is constructed
      this.onStoreBeforeRequest();
    }
  }

  changeScrollManager(scrollManager, oldScrollManager) {
    oldScrollManager === null || oldScrollManager === void 0 ? void 0 : oldScrollManager.destroy();

    if (scrollManager) {
      return _Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].new({
        element: this.element
      }, scrollManager);
    } else {
      return null;
    }
  }
  /**
   * Cleanup
   * @private
   */


  doDestroy() {
    var _me$scrollManager;

    const me = this;
    me.detachListeners(storeListenerName);
    (_me$scrollManager = me.scrollManager) === null || _me$scrollManager === void 0 ? void 0 : _me$scrollManager.destroy();

    for (const feature of Object.values(me.features)) {
      var _feature$destroy;

      (_feature$destroy = feature.destroy) === null || _feature$destroy === void 0 ? void 0 : _feature$destroy.call(feature);
    }

    me.columns.destroy();
    super.doDestroy();
  }
  /**
   * Adds extra classes to the Grid element after it's been configured.
   * Also iterates through features, thus ensuring they have been initialized.
   * @private
   */


  setGridClassList(classList) {
    const me = this;
    Object.values(me.features).forEach(feature => {
      if (feature.disabled) {
        return;
      }

      let featureClass;

      if (Object.prototype.hasOwnProperty.call(feature.constructor, 'featureClass')) {
        featureClass = feature.constructor.featureClass;
      } else {
        featureClass = `b-${feature instanceof _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? feature.$$name : feature.constructor.name}`;
      }

      if (featureClass) {
        classList.add(featureClass.toLowerCase());
      }
    });
  } //endregion
  //region Functions & events injected by features
  // For documentation & typings purposes
  //region Feature events

  /**
   * Fired before a parent node record toggles its collapsed state. Only applicable when the {@link Grid.feature.Tree} feature is enabled
   * @event beforeToggleNode
   * @param {Grid.view.Grid} source The firing Grid instance.
   * @param {Core.data.Model} record The record being toggled.
   * @param {Boolean} collapse `true` if the node is being collapsed.
   */

  /**
   * Fired after a parent node record toggles its collapsed state. Only applicable when the {@link Grid.feature.Tree} feature is enabled
   * @event toggleNode
   * @param {Core.data.Model} record The record being toggled.
   * @param {Boolean} collapse `true` if the node is being collapsed.
   */

  /**
   * Fired before a parent node record is collapsed. Only applicable when the {@link Grid.feature.Tree} feature is enabled
   * @event collapseNode
   * @param {Grid.view.Grid} source The firing Grid instance.
   * @param {Core.data.Model} record The record which has been collapsed.
   */

  /**
   * Fired after a parent node record is expanded. Only applicable when the {@link Grid.feature.Tree} feature is enabled
   * @event expandNode
   * @param {Grid.view.Grid} source The firing Grid instance.
   * @param {Core.data.Model} record The record which has been expanded.
   */

  /**
   * Fires after a sub grid is collapsed.
   * @event subGridCollapse
   * @param {Grid.view.Grid} source The firing Grid instance
   * @param {Grid.view.SubGrid} subGrid The sub grid instance
   */

  /**
   * Fires after a sub grid is expanded.
   * @event subGridExpand
   * @param {Grid.view.Grid} source The firing Grid instance
   * @param {Grid.view.SubGrid} subGrid The sub grid instance
   */

  /**
   * Fires before a row is rendered.
   * @event beforeRenderRow
   * @param {Grid.view.Grid} source The firing Grid instance.
   * @param {Grid.row.Row} row The row about to be rendered.
   * @param {Core.data.Model} record The record for the row.
   * @param {Number} recordIndex The zero-based index of the record.
   */

  /**
   * Fires after a row is rendered.
   * @event renderRow
   * @param {Grid.view.Grid} source The firing Grid instance.
   * @param {Grid.row.Row} row The row that has been rendered.
   * @param {Core.data.Model} record The record for the row.
   * @param {Number} recordIndex The zero-based index of the record.
   */
  //endregion

  /**
   * Collapse all groups/parent nodes.
   *
   * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function collapseAll
   * @category Feature shortcuts
   */

  /**
   * Expand all groups/parent nodes.
   *
   * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function expandAll
   * @category Feature shortcuts
   */

  /**
   * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
   *
   * *NOTE: Only available when the {@link Grid/feature/CellEdit CellEdit} feature is enabled.*
   *
   * @function startEditing
   * @param {Object} cellContext Cell specified in format `{ id: 'x', columnId/column/field: 'xxx' }`.
   * See {@link Grid.view.Grid#function-getCell} for details.
   * @returns {Boolean}
   * @category Feature shortcuts
   */

  /**
   * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
   *
   * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function toggleCollapse
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
   * @param {Boolean} [collapse] Force collapse (true) or expand (false)
   * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Collapse a single node.
   *
   * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function collapse
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Expand a single node.
   *
   * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function expand
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Expands parent nodes to make this node "visible".
   *
   * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
   *
   * @function expandTo
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
   * @returns {Promise}
   * @category Feature shortcuts
   */
  //endregion
  //region Grid template & elements


  compose() {
    const {
      autoHeight,
      enableSticky,
      enableTextSelection,
      fillLastColumn,
      positionMode,
      showDirty
    } = this;
    return {
      class: {
        [`b-grid-${positionMode}`]: 1,
        'b-enable-sticky': enableSticky,
        'b-grid-notextselection': !enableTextSelection,
        'b-autoheight': autoHeight,
        'b-fill-last-column': fillLastColumn,
        'b-show-dirty': showDirty
      }
    };
  }

  get bodyConfig() {
    const {
      autoHeight,
      hideFooters,
      hideHeaders
    } = this;
    return {
      reference: 'bodyElement',
      className: {
        'b-autoheight': autoHeight,
        'b-grid-panel-body': 1
      },
      children: {
        headerContainer: {
          tag: 'header',
          className: {
            'b-grid-header-container': 1,
            'b-hidden': hideHeaders
          }
        },
        bodyContainer: {
          className: 'b-grid-body-container',
          tabIndex: -1,
          children: {
            verticalScroller: {
              className: 'b-grid-vertical-scroller'
            }
          }
        },
        virtualScrollers: {
          className: 'b-virtual-scrollers b-hide-display',
          style: _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isFirefox ? {
            height: `${_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarWidth}px`
          } : undefined
        },
        footerContainer: {
          tag: 'footer',
          className: {
            'b-grid-footer-container': 1,
            'b-hidden': hideFooters
          }
        }
      }
    };
  }

  get contentElement() {
    return this.verticalScroller;
  }

  get overflowElement() {
    return this.bodyContainer;
  }

  get focusElement() {
    return this.bodyContainer;
  }

  updateHideFooters(hide) {
    var _this$footerContainer;

    (_this$footerContainer = this.footerContainer) === null || _this$footerContainer === void 0 ? void 0 : _this$footerContainer.classList[hide ? 'add' : 'remove']('b-hidden');
  } //endregion
  //region Columns

  /**
   * Get the {@link Grid.data.ColumnStore ColumnStore} used by this Grid.
   *
   * @member {Grid.data.ColumnStore} columns
   * @category Common
   * @readonly
   */


  changeColumns(columns, currentStore) {
    const me = this; // TODO: @johan: reconfiguring, ie changing whole column set should work.
    // Empty, clear or destroy store

    if (!columns && currentStore) {
      // Destroy when Grid is destroyed, if we created the ColumnStore
      if (me.isDestroying) {
        currentStore.owner === me && currentStore.destroy();
      } // Clear if set to falsy value at some other point
      else {
        currentStore.removeAll();
      }

      return currentStore;
    } // Keep store if configured with one


    if (columns.isStore) {
      (currentStore === null || currentStore === void 0 ? void 0 : currentStore.owner) === me && currentStore.destroy();
      columns.grid = me;
      return columns;
    } // Given an array of columns


    if (Array.isArray(columns)) {
      // If we have a store, plug them in
      if (currentStore) {
        currentStore.data = columns;
        return currentStore;
      } // No store, use as data for a new store below


      columns = {
        data: columns
      };
    }

    if (currentStore) {
      throw new Error('Replacing ColumnStore is not supported');
    } // Assuming a store config object


    return _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_18__["default"].new({
      grid: me,
      owner: me
    }, columns);
  }

  updateColumns(columns) {
    const me = this; // changes might be triggered when applying state, before grid is rendered
    // TODO: have this run a lighter weight, non-destructive response.
    // onColumnsChanged is a start, but lots of machinery is hooked to render.

    columns.on({
      change: me.onColumnsChanged,
      sort: me.onColumnsChanged,
      thisObj: me
    });
    columns.on(Object(_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_18__["columnResizeEvent"])(me.onColumnsResized, me)); // Add touch class for touch devices

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isTouchDevice) {
      me.touch = true; // apply touchConfig for columns that defines it

      columns.forEach(column => {
        const {
          touchConfig
        } = column;

        if (touchConfig) {
          column.applyState(touchConfig);
        }
      });
    }
  }

  onColumnsChanged({
    action,
    changes,
    record: column,
    records: addedColumns,
    isMove
  }) {
    const me = this,
          {
      columns,
      checkboxSelectionColumn
    } = me; // this.onPaint will handle changes caused by updateResponsive

    if (!me.isPainted || isMove && action === 'remove') {
      return;
    } // See if we have to create and add new SubGrids to accommodate new columns.


    if (action === 'add') {
      for (const column of addedColumns) {
        const {
          region
        } = column; // See if there's a home for this column, if not, add one

        if (!me.subGrids[region]) {
          me.add(me.createSubGrid(region, me.subGridConfigs[region]));
        }
      }
    }

    if (action === 'update') {
      // Just updating width is already handled in a minimal way.
      if ('width' in changes || 'minWidth' in changes || 'maxWidth' in changes || 'flex' in changes) {
        // Update any leaf columns that want to be repainted on size change
        const region = column.region;
        columns.visibleColumns.forEach(col => {
          if (col.region === region && col.repaintOnResize) {
            me.refreshColumn(col);
          }
        });
        return;
      } // Column toggled, need to recheck if any visible column has flex


      if ('hidden' in changes) {
        const subGrid = me.getSubGridFromColumn(column.id);
        subGrid.header.fixHeaderWidths();
        subGrid.footer.fixFooterWidths();
        subGrid.updateHasFlex();
      }
    } // Might have to add or remove subgrids when assigning a new set of columns or when changing region


    if (action === 'dataset' || action === 'update' && 'region' in changes) {
      const regions = columns.getDistinctValues('region'),
            {
        toRemove,
        toAdd
      } = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].delta(regions, me.regions, true);
      me.remove(toRemove.map(region => me.getSubGrid(region)));
      me.add(toAdd.map(region => me.createSubGrid(region)));
    } // Check if checkbox selection column was removed, if so insert it back as the first column


    if (checkboxSelectionColumn && !columns.includes(checkboxSelectionColumn)) {
      // Insert the checkbox after any rownumber column. If not there, -1 means in at 0.
      const insertIndex = columns.indexOf(columns.findRecord('type', 'rownumber')) + 1;
      columns.insert(insertIndex, checkboxSelectionColumn, true);
    }

    if (!me._suspendRenderContentsOnColumnsChanged) {
      me.renderContents();
    }

    me.afterColumnsChange({
      action,
      changes,
      column
    });
  }

  onColumnsResized({
    changes,
    record: column
  }) {
    const me = this;

    if (me.isConfiguring) {
      return;
    }

    const domWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(column.width),
          domMinWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(column.minWidth),
          domMaxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(column.maxWidth),
          subGrid = me.getSubGridFromColumn(column.id); // Let header and footer fix their own widths

    subGrid.header.fixHeaderWidths();
    subGrid.footer.fixFooterWidths();
    subGrid.updateHasFlex();

    if (!me.cellEls || column !== me.lastColumnResized) {
      me.cellEls = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].children(me.element, `.b-grid-cell[data-column-id="${column.id}"]`);
      me.lastColumnResized = column;
    }

    for (const cell of me.cellEls) {
      if ('width' in changes) {
        // https://app.assembla.com/spaces/bryntum/tickets/8041
        // Although header and footer elements must be sized using flex-basis to avoid the busting out problem,
        // grid cells MUST be sized using width since rows are absolutely positioned and will not cause the
        // busting out problem, and rows will not stretch to shrinkwrap the cells unless they are widthed with
        // width.
        cell.style.width = domWidth; // IE11 calculates flexbox container width based on min-width rather than actual width. When column
        // has width defined greater than minWidth, row may have incorrect width

        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isIE11) {
          cell.style.flex = '';
          cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(column.calcMinWidth);
        }
      }

      if ('minWidth' in changes) {
        cell.style.minWidth = domMinWidth;
      }

      if ('maxWidth' in changes) {
        cell.style.maxWidth = domMaxWidth;
      }

      if ('flex' in changes) {
        var _column$flex;

        cell.style.flex = (_column$flex = column.flex) !== null && _column$flex !== void 0 ? _column$flex : null;
      }
    } // If we're being driven by the ColumnResizer or other bulk column resizer (like
    // ColumnAutoWidth), they will finish up with a call to afterColumnsResized.


    if (!me.resizingColumns) {
      me.afterColumnsResized();
    }
  }

  afterColumnsResized() {
    const me = this;
    me.eachSubGrid(subGrid => {
      if (!subGrid.collapsed) {
        subGrid.fixWidths();
        subGrid.fixRowWidthsInSafariEdge();
      }
    });
    me.lastColumnResized = me.cellEls = null; // Buffer some expensive operations, like updating the fake scrollers

    me.bufferedAfterColumnsResized(); // Must happen immediately, not inside the bufferedAfterColumnsResized

    me.onHeightChange();
  }

  bufferedAfterColumnsResized() {
    // Columns that allow their cell content to drive the row height requires a rerender after resize
    if (this.columns.usesAutoHeight) {
      this.refreshRows();
    }

    this.refreshVirtualScrollbars();
    this.eachSubGrid(subGrid => {
      if (!subGrid.collapsed) {
        subGrid.refreshFakeScroll();
      }
    });
  } // Hook that can be overridden to prepare custom editors, can be used by framework wrappers


  processCellEditor(editorConfig) {}

  bufferedElementResize(element, newWidth, newHeight, oldWidth) {
    // Columns that allow their cell content to drive the row height requires a rerender after element resize
    if (this.isPainted && newWidth !== oldWidth && this.columns.usesFlexAutoHeight) {
      this.refreshRows();
    }
  }

  onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight) {
    // If a flexed subGrid would be flexed *down* by a width reduction, allow it
    // to lay itself out before the refreshVirtualScrollbars called by GridElementEvents
    // asks them whether they are overflowingHorizontally.
    // This is to avoid an unecessary extra layout with a horizontal
    // scrollbar which may be hidden when the subgrid adjusts itself when its ResizeMonitor
    // notification arrives - they are delivered outermost->innermost, we we find out first here.
    // When the actualResizeMonitor notification arrives, it will be a no-op.
    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarWidth && newWidth < oldWidth) {
      this.eachSubGrid(subGrid => {
        if (subGrid.flex) {
          subGrid.onElementResize(subGrid.element);
        }
      });
    }

    super.onInternalResize(...arguments);
    this.bufferedElementResize(...arguments);
  } //endregion
  //region Rows

  /**
   * Get the topmost visible grid row
   * @member {Grid.row.Row} firstVisibleRow
   * @readonly
   * @category Rows
   */

  /**
   * Get the last visible grid row
   * @member {Grid.row.Row} lastVisibleRow
   * @readonly
   * @category Rows
   */

  /**
   * Get the Row that is currently displayed at top.
   * @member {Grid.row.Row} topRow
   * @readonly
   * @category Rows
   * @private
   */

  /**
   * Get the Row currently displayed furthest down.
   * @member {Grid.row.Row} bottomRow
   * @readonly
   * @category Rows
   * @private
   */

  /**
   * Get Row for specified record id.
   * @function getRowById
   * @param {Core.data.Model|String|Number} recordOrId Record id (or a record)
   * @returns {Grid.row.Row} Found Row or null if record not rendered
   * @category Rows
   * @private
   */

  /**
   * Returns top and bottom for rendered row or estimated coordinates for unrendered.
   * @function getRecordCoords
   * @param {Core.data.Model|String|Number} recordOrId Record or record id
   * @returns {Object} Record bounds with format { top, height, bottom }
   * @category Calculations
   * @private
   */

  /**
   * Get the Row at specified index. "Wraps" index if larger than available rows.
   * @function getRow
   * @param {Number} index
   * @returns {Grid.row.Row}
   * @category Rows
   * @private
   */

  /**
   * Get a Row for either a record, a record id or an HTMLElement
   * @function getRowFor
   * @param {HTMLElement|Core.data.Model|String|Number} recordOrId Record or record id or HTMLElement
   * @returns {Grid.row.Row} Found Row or null if record not rendered
   * @category Rows
   * @private
   */

  /**
   * Get a Row from an HTMLElement
   * @function getRowFromElement
   * @param {HTMLElement} element
   * @returns {Grid.row.Row} Found Row or null if record not rendered
   * @category Rows
   * @private
   */


  changeRowManager(rowManager, oldRowManager) {
    const me = this; // Use row height from CSS if not specified in config. Did not want to turn this into a getter/setter for
    // rowHeight since RowManager will plug its implementation into Grid when created below, and after initial
    // configuration that is what should be used

    if (!me._isRowMeasured) {
      me.measureRowHeight();
    }

    oldRowManager === null || oldRowManager === void 0 ? void 0 : oldRowManager.destroy();

    if (rowManager) {
      // RowManager is a plugin, it is configured with its grid as its "client".
      // It uses client.store as its record source.
      const result = _row_RowManager_js__WEBPACK_IMPORTED_MODULE_20__["default"].new({
        grid: me,
        rowHeight: me.rowHeight,
        rowScrollMode: me.rowScrollMode || 'move',
        autoHeight: me.autoHeight,
        fixedRowHeight: me.fixedRowHeight,
        listeners: {
          changeTotalHeight: 'onRowManagerChangeTotalHeight',
          requestScrollChange: 'onRowManagerRequestScrollChange',
          thisObj: me
        }
      }, rowManager); // The grid announces row rendering to allow customization of rows.

      me.relayEvents(result, ['beforeRenderRow', 'renderRow']); // RowManager injects itself as a property into the grid so that the grid
      // can reference it during RowManager's spin-up. We need to undo that now
      // otherwise updaters will not run.

      me._rowManager = null;
      return result;
    }
  } // Default implementation, documented in `defaultConfig`


  getRowHeight(record) {
    return record.rowHeight;
  } //endregion
  //region Store

  /**
   * Hooks up data store listeners
   * @private
   * @category Store
   */


  bindStore(store) {
    const suffix = this.asyncEventSuffix;
    store.on({
      name: storeListenerName,
      [`refresh${suffix}`]: 'onStoreDataChange',
      [`add${suffix}`]: 'onStoreAdd',
      [`remove${suffix}`]: 'onStoreRemove',
      [`move${suffix}`]: 'onStoreMove',
      [`replace${suffix}`]: 'onStoreReplace',
      [`removeAll${suffix}`]: 'onStoreRemoveAll',
      change: 'relayStoreDataChange',
      idChange: 'onStoreRecordIdChange',
      update: 'onStoreUpdateRecord',
      beforeRequest: 'onStoreBeforeRequest',
      afterRequest: 'onStoreAfterRequest',
      exception: 'onStoreException',
      commit: 'onStoreCommit',
      thisObj: this
    });
    super.bindStore(store);
  }

  unbindStore(oldStore) {
    this.detachListeners(storeListenerName);

    if (this.destroyStore) {
      oldStore.destroy();
    }
  }

  changeStore(store) {
    if (store == null) {
      return null;
    }

    if (typeof store === 'string') {
      store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStore(store);
    }

    if (!store.isStore) {
      var _this$initialConfig$f;

      store = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
        data: this.data,
        tree: Boolean((_this$initialConfig$f = this.initialConfig.features) === null || _this$initialConfig$f === void 0 ? void 0 : _this$initialConfig$f.tree)
      }, store);

      if (!store.data) {
        delete store.data;
      } // extend GridRowModel to not pollute it with custom fields (if we have multiple grids on page)


      if (!store.modelClass) {
        store.modelClass = class extends _data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_19__["default"] {};
      }

      store = new (store.readUrl ? _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__["default"] : _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"])(store);
    }

    return store;
  }

  updateStore(store, was) {
    const me = this;

    if (was) {
      me.unbindStore(was);
    }

    if (store) {
      // Deselect all rows when replacing the store, otherwise selection retains old store
      if (was) {
        me.deselectAll();
      }

      me.bindStore(store);
    }

    me.trigger('bindStore', {
      store,
      oldStore: was
    }); // Changing store when painted -> refresh rows to reflect new data

    if (!me.isDestroying && me.isPainted && !me.refreshSuspended) {
      var _me$_rowManager;

      (_me$_rowManager = me._rowManager) === null || _me$_rowManager === void 0 ? void 0 : _me$_rowManager.reinitialize();
    }
  }
  /**
   * Rerenders a cell if a record is updated in the store
   * @private
   * @category Store
   */


  onStoreUpdateRecord({
    source: store,
    record,
    changes
  }) {
    const me = this;

    if (me.forceFullRefresh) {
      // flagged to need full refresh (probably from using GroupSummary)
      me.rowManager.refresh();
      me.forceFullRefresh = false;
    } else {
      let row; // Search for old row if id was changed

      if (record.isFieldModified('id')) {
        row = me.getRowFor(record.meta.modified.id);
      }

      row = row || me.getRowFor(record); // not rendered, bail out

      if (!row) return; // We must refresh the full row if it's a special row which has signalled
      // an update because it has no cells.

      if (me.fullRowRefresh || record.isSpecialRow) {
        const index = store.indexOf(record);

        if (index !== -1) {
          row.render(index, record);
        }
      } else {
        me.columns.visibleColumns.forEach(column => {
          const field = column.field,
                isSafe = column.constructor.simpleRenderer && !Object.prototype.hasOwnProperty.call(column.data, 'renderer'); // If there's a  non-safe renderer, that is a renderer which draws values from elsewhere
          // than just its configured field, that column must be refreshed on every record update.
          // Obviously, if the column's configured field is changed that also means it's refreshed.

          if (!isSafe || changes[field]) {
            const cellElement = row.getCell(field);

            if (cellElement) {
              row.renderCell({
                cellElement,
                record
              });
            }
          }
        });
      }
    }
  }

  refreshFromRowOnStoreAdd(row, context) {
    const me = this,
          {
      rowManager
    } = me;
    rowManager.renderFromRow(row);
    rowManager.trigger('changeTotalHeight', {
      totalHeight: rowManager.totalHeight
    }); // First record? Also update fake scrollers
    // TODO: Consider making empty grid scrollable to not have to do this

    if (me.store.count === 1) {
      me.callEachSubGrid('refreshFakeScroll');
    }
  }

  onMaskAutoClose(mask) {
    super.onMaskAutoClose(mask);
    this.toggleEmptyText();
  }
  /**
   * Refreshes rows when data is added to the store
   * @private
   * @category Store
   */


  onStoreAdd({
    source: store,
    records,
    index,
    oldIndex,
    isChild,
    oldParent,
    isMove,
    isExpandAll
  }) {
    // Do not react if the content has not been rendered
    if (!this.isPainted || isExpandAll) {
      return;
    } // If we move records check if some of their old parents is expanded


    const hasExpandedOldParent = isMove && records.some(record => {
      if (isMove[record.id]) {
        const oldParent = store.getById(record.meta.modified.parentId);
        return oldParent.isExpanded(store) && oldParent.ancestorsExpanded(store);
      }
    }); // If it's the addition of a child to a collapsed zone (and old parents are also collapsed), the UI does not change.

    if (isChild && !records[0].ancestorsExpanded(store) && !hasExpandedOldParent) {
      return;
    }

    this.rowManager.calculateRowCount(false, true, true); // When store is filtered need to update the index value

    if (store.isFiltered) {
      index = store.indexOf(records[0]);
    }

    const me = this,
          {
      rowManager
    } = me,
          {
      topIndex,
      rows,
      rowCount
    } = rowManager,
          bottomIndex = rowManager.topIndex + rowManager.rowCount - 1,
          dataStart = index,
          dataEnd = index + records.length - 1,
          atEnd = bottomIndex >= store.count - records.length - 1; // When moving a node within a tree we might need the redraw to include its old parent and its children. Not worth
    // the complexity of trying to do a partial render for this, rerender all rows to be safe.
    // Moving records within a flat store is handled elsewhere, in onStoreMove
    // TODO: Moving within a tree should also trigger 'move' (https://app.assembla.com/spaces/bryntum/tickets/7270)

    if (oldParent || oldIndex > -1 || isChild && isMove) {
      rowManager.refresh();
    } // Added block starts in our visible block. Render from there downwards.
    else if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
      me.refreshFromRowOnStoreAdd(rows[dataStart - topIndex], ...arguments);
    } // Added block ends in our visible block, render block
    else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
      rowManager.refresh();
    } // If added block is outside of the visible area, no visible change
    // but potentially a change in total dataset height.
    else {
      // If we are against the end of the dataset, and have appended records
      // ensure they are rendered below
      if (atEnd && index > bottomIndex) {
        rowManager.fillBelow(me._scrollTop || 0);
      }

      rowManager.estimateTotalHeight(true);
    }
  }
  /**
   * Responds to exceptions signalled by the store
   * @private
   * @category Store
   */


  onStoreException({
    action,
    type,
    response,
    exceptionType,
    error
  }) {
    const me = this;
    let message;

    switch (type) {
      case 'server':
        message = response.message || me.L('L{unspecifiedFailure}');
        break;

      case 'exception':
        message = exceptionType === 'network' ? me.L('L{networkFailure}') : error && error.message || me.L('L{parseFailure}');
        break;
    } // eslint-disable-next-line


    me.applyMaskError(`<div class="b-grid-load-failure">
                <div class="b-grid-load-fail">${me.L(action === 'read' ? 'L{loadFailedMessage}' : 'L{syncFailedMessage}')}</div>
                <div class="b-grid-load-fail">${response && response.url ? response.url + ' responded with' : ''}</div>
                <div class="b-grid-load-fail">${message}</div>
            </div>`);
  }
  /**
   * Refreshes rows when data is changed in the store
   * @private
   * @category Store
   */


  onStoreDataChange({
    action,
    changes,
    source: store
  }) {
    if (this.refreshSuspended) {
      return;
    }

    const me = this,
          isGroupFieldChange = store.isGrouped && changes && store.groupers.some(grouper => grouper.field in changes); // If the next mixin up the inheritance chain has an implementation, call it

    super.onStoreDataChange && super.onStoreDataChange(...arguments); // If it's new data, the old calculation is invalidated.

    if (action === 'dataset') {
      me.rowManager.clearKnownHeights();
    } // No need to rerender if it's a change of the value of the group field which
    // will be responded to by StoreGroup


    if (me.isPainted && !isGroupFieldChange) {
      // Optionally scroll to top if setting new data or is filtering based on preserveScrollOnDatasetChange setting
      me.renderRows(Boolean(!(action in datasetReplaceActions) || me.preserveScrollOnDatasetChange));
    }

    me.toggleEmptyText();
  }
  /**
   * The hook is called when the id of a record has changed.
   * @private
   * @category Store
   */


  onStoreRecordIdChange() {
    // If the next mixin up the inheritance chain has an implementation, call it
    super.onStoreRecordIdChange && super.onStoreRecordIdChange(...arguments);
  }
  /**
   * Shows a load mask while the connected store is loading
   * @private
   * @category Store
   */


  onStoreBeforeRequest() {
    this.applyLoadMask();
  }
  /**
   * Hides load mask after a load request ends either in success or failure
   * @private
   * @category Store
   */


  onStoreAfterRequest(event) {
    if (this.loadMask && !event.exception) {
      this.masked = null;
      this.toggleEmptyText();
    }
  }

  needsFullRefreshOnStoreRemove() {
    const features = this._features;
    return (features === null || features === void 0 ? void 0 : features.group) && !features.group.disabled || (features === null || features === void 0 ? void 0 : features.groupSummary) && !features.groupSummary.disabled;
  }
  /**
   * Animates removal of record.
   * @private
   * @category Store
   */


  onStoreRemove({
    records,
    isCollapse,
    isChild,
    isMove,
    isCollapseAll
  }) {
    // Do not react if the content has not been rendered,
    // or if it is a move, which will be handled by onStoreAdd
    if (!this.isPainted || isMove || isCollapseAll) {
      return;
    } // GridSelection mixin does its job on records removing


    super.onStoreRemove && super.onStoreRemove(...arguments);
    let topRowIndex = 2 ** 53 - 1;
    const me = this,
          {
      rowManager
    } = me,
          // Gather all visible rows which need to be removed.
    rowsToRemove = records.reduce((result, record) => {
      const row = rowManager.getRowById(record.id);

      if (row) {
        result.push(row); // Rows are repositioned in the array, it matches visual order. Need to find actual index in it

        topRowIndex = Math.min(topRowIndex, rowManager.rows.indexOf(row));
      }

      return result;
    }, []); // Remove cached heights

    rowManager.invalidateKnownHeight(records);

    if (me.animateRemovingRows && rowsToRemove.length && !isCollapse && !isChild) {
      const topRow = rowsToRemove[0];
      me.isAnimating = true; // As soon as first row has disappeared, rerender the view

      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].onTransitionEnd({
        element: topRow._elementsArray[0],
        property: 'left',
        // Detach listener after timeout even if event wasn't fired
        duration: me.transitionDuration,
        thisObj: me,

        handler() {
          me.isAnimating = false;
          rowsToRemove.forEach(row => !row.isDestroyed && row.removeCls('b-removing'));
          rowManager.refresh(); // undocumented internal event for scheduler

          me.trigger('rowRemove');
        }

      });
      rowsToRemove.forEach(row => row.addCls('b-removing'));
    } // Cannot do an update from the affected row and down here. Since group headers might be affected by
    // removing rows we need a full refresh
    else if (me.needsFullRefreshOnStoreRemove(...arguments)) {
      rowManager.refresh();
    } else {
      // Potentially remove rows and change dataset height
      rowManager.calculateRowCount(false, true, true); // If there were rows below which have moved up into place
      // then repurpose them with their new records

      if (rowManager.rows[topRowIndex]) {
        rowManager.renderFromRow(rowManager.rows[topRowIndex]);
      } // If nothing to render below, just update dataset height
      else {
        rowManager.trigger('changeTotalHeight', {
          totalHeight: rowManager.totalHeight
        });
      }

      me.trigger('rowRemove', {
        isCollapse
      });
    }
  }

  onStoreMove({
    from,
    to
  }) {
    const {
      rowManager
    } = this,
          {
      topIndex,
      rowCount
    } = rowManager,
          [dataStart, dataEnd] = [from, to].sort(); // Changed block starts in our visible block. Render from there downwards.

    if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
      rowManager.renderFromRow(rowManager.rows[dataStart - topIndex]);
    } // Changed block ends in our visible block, render block
    else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
      rowManager.refresh();
    } // If changed block is outside of the visible area, this is a no-op

  }

  onStoreReplace({
    records,
    all
  }) {
    const {
      rowManager
    } = this;

    if (all) {
      rowManager.clearKnownHeights();
      rowManager.refresh();
    } else {
      const rows = records.reduce((rows, [, record]) => {
        const row = this.getRowFor(record);

        if (row) {
          rows.push(row);
        }

        return rows;
      }, []); // Heights will be stored on render, but some records might be out of view -> have to invalidate separately

      rowManager.invalidateKnownHeight(records);
      rowManager.renderRows(rows);
    }
  }

  relayStoreDataChange(event) {
    /**
     * Fired when data in the store changes.
     *
     * Basically a relayed version of the store's own change event, decorated with a `store` property.
     * See the {@link Core.data.Store#event-change store change event} documentation for more information.
     *
     * @event dataChange
     * @param {Grid.view.Grid} source Owning grid
     * @param {Core.data.Store} store The originating store
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
     * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
     * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
     */
    if (!this.project) {
      return this.trigger('dataChange', _objectSpread(_objectSpread({}, event), {}, {
        store: event.source,
        source: this
      }));
    }
  }
  /**
   * Rerenders grid when all records have been removed
   * @private
   * @category Store
   */


  onStoreRemoveAll() {
    // GridSelection mixin does its job on records removing
    super.onStoreRemoveAll && super.onStoreRemoveAll(...arguments);

    if (this.isPainted) {
      this.rowManager.clearKnownHeights();
      this.renderRows();
      this.toggleEmptyText();
    }
  } // Refresh dirty cells on commit


  onStoreCommit({
    changes
  }) {
    if (this.showDirty && changes.modified.length) {
      const rows = [];
      changes.modified.forEach(record => {
        const row = this.rowManager.getRowFor(record);
        row && rows.push(row);
      });
      this.rowManager.renderRows(rows);
    }
  }
  /**
   * Convenience functions for getting/setting data in related store
   * @property {Object[]}
   * @category Common
   */


  get data() {
    if (this._store) {
      return this._store.records;
    } else {
      return this._data;
    }
  }

  set data(data) {
    if (this._store) {
      this._store.data = data;
    } else {
      this._data = data;
    }
  }

  get emptyText() {
    return this._emptyText;
  }

  set emptyText(text) {
    this._emptyText = text;
    this.eachSubGrid(subGrid => subGrid.emptyText = text);
  } //endregion
  //region Context menu items

  /**
   * Populates the header context menu. Chained in features to add menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    column,
    items
  }) {
    const me = this,
          {
      subGrids,
      regions
    } = me;
    let first = true;
    Object.entries(subGrids).forEach(([region, subGrid]) => {
      // If SubGrid is configured with a sealed column set, do not allow moving into it
      if (subGrid.sealedColumns) {
        return;
      }

      if (column.draggable && region !== column.region && (!column.parent && subGrids[column.region].columns.count > 1 || column.parent && column.parent.children.length > 1)) {
        const moveRight = subGrid.element.compareDocumentPosition(subGrids[column.region].element) === document.DOCUMENT_POSITION_PRECEDING,
              // With 2 regions, use Move left, Move right. With multiple, include region name
        text = regions.length > 2 ? me.L('L{moveColumnTo}', me.optionalL(region)) : me.L(moveRight ? 'L{moveColumnRight}' : 'L{moveColumnLeft}');
        items[`${region}Region`] = {
          targetSubGrid: region,
          text,
          icon: 'b-fw-icon ' + (moveRight ? 'b-icon-column-move-right' : 'b-icon-column-move-left'),
          cls: first ? 'b-separator' : '',
          onItem: ({
            item
          }) => {
            column.traverse(col => col.region = region); // Changing region will move the column to the correct SubGrid, but we want it to go last

            me.columns.insert(me.columns.indexOf(subGrids[item.targetSubGrid].columns.last) + 1, column);
            me.scrollColumnIntoView(column);
          }
        };
        first = false;
      }
    });
  }
  /**
   * Populates the cell context menu. Chained in features to add menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Core.data.Model} options.record Record for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateCellMenu({
    record,
    items
  }) {
    var _me$features;

    const me = this,
          // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.
    isDeprecatedFeatureUsed = ((_me$features = me.features) === null || _me$features === void 0 ? void 0 : _me$features.contextMenu) && !me.features.contextMenu.disabled;

    if (isDeprecatedFeatureUsed && me.showRemoveRowInContextMenu && !me.readOnly && record && !record.isSpecialRow) {
      items.removeRow = {
        text: 'L{removeRow}',
        localeClass: this,
        icon: 'b-fw-icon b-icon-trash',
        onItem: () => me.store.remove(me.selectedRecords)
      };
    }
  }

  getColumnDragToolbarItems(column, items) {
    return items;
  } //endregion
  //region Getters


  normalizeCellContext(cellContext) {
    const {
      columns,
      store
    } = this; // TODO: should clone instead of modify?
    // TODO: The answer is to use the Grid/util/Location class to robustly encapsulate a record/column intersection
    // And have them immutable, so that to change is to clone, as explained by MaximGB,
    // we want to use columnId for precision, but allow user to specify column name for ease of use...
    // modify cellContext to include columnId in those cases

    if (cellContext instanceof store.modelClass) {
      return {
        record: cellContext,
        id: cellContext.id,
        columnId: columns.visibleColumns[0].id
      };
    }

    if (!('columnId' in cellContext)) {
      if ('field' in cellContext) {
        const column = columns.get(cellContext.field);
        cellContext.columnId = column && column.id;
      } else if ('column' in cellContext) {
        const column = typeof cellContext.column === 'number' ? columns.visibleColumns[cellContext.column] : cellContext.column;
        cellContext.columnId = column && column.id;
      } // Fall back to first leaf column


      if (!('columnId' in cellContext)) {
        cellContext.columnId = columns.visibleColumns[0].id;
      }
    }

    if ('id' in cellContext) {
      // If the context is for an element, but it's stale (for a removed record)
      // then fix it up to refer to the record id at the same index.
      if (cellContext.element && !store.getById(cellContext.id)) {
        // This uses the data-index property to get the row at that index.
        const record = this.getRecordFromElement(cellContext.element); // We have a record at the same index.

        if (record) {
          cellContext.id = record.id;
        }
      }
    } else {
      const record = 'row' in cellContext ? store.getAt(cellContext.row) : cellContext.record;

      if (record) {
        cellContext.id = record.id;
      }
    }

    return cellContext;
  } // TODO: move to RowManager? Or create a CellManager?

  /**
   * Returns a cell if rendered.
   * @param {Object} cellContext { id: rowId, columnId: columnId [,column: column number, field: column field] }
   * @param {Number} [cellContext.row] The row index of the row to access. Exclusive with `id` and 'record'.
   * @param {String|Number} [cellContext.id] The record id of the row to access. Exclusive with `row` and 'record'.
   * @param {Core.data.Model} [cellContext.record] The record of the row to access. Exclusive with `id` and 'row'.
   * @param {Number} [cellContext.column] The column instance or the index of the cell to access.  Exclusive with `columnId`.
   * @param {String|Number} [cellContext.columnId] The column id of the column to access. Exclusive with `column`.
   * @param {String} [cellContext.field] The field of the column to access. Exclusive with `column`.
   * @returns {HTMLElement}
   * @category Getters
   */


  getCell(cellContext) {
    let row,
        result = null;
    cellContext = this.normalizeCellContext(cellContext);

    if ('id' in cellContext) {
      row = this.getRowById(cellContext.id);
    }

    if (row && 'columnId' in cellContext) {
      result = row.getCell(cellContext.columnId);
    }

    return result;
  } //TODO: Should move to ColumnManager? Or Header?

  /**
   * Returns the header element for the column
   * @param {String|Number|Grid.column.Column} columnId or Column instance
   * @returns {HTMLElement} Header element
   * @category Getters
   */


  getHeaderElement(columnId) {
    if (columnId.isModel) {
      columnId = columnId.id;
    }

    return this.fromCache(`.b-grid-header[data-column-id="${columnId}"]`);
  }

  getHeaderElementByField(field) {
    const column = this.columns.get(field);
    return column ? this.getHeaderElement(column) : null;
  }
  /**
   * Body height
   * @property {Number}
   * @readonly
   * @category Layout
   */


  get bodyHeight() {
    return this._bodyHeight;
  }
  /**
   * Header height
   * @property {Number}
   * @readonly
   * @category Layout
   */


  get headerHeight() {
    const me = this; // measure header if rendered and not stored

    if (me.isPainted && !me._headerHeight) {
      me._headerHeight = me.headerContainer.offsetHeight;
    }

    return me._headerHeight;
  }
  /**
   * Searches up from the specified element for a grid row and returns the record associated with that row.
   * @param {HTMLElement} element Element somewhere within a row or the row container element
   * @returns {Core.data.Model} Record for the row
   * @category Getters
   */


  getRecordFromElement(element) {
    const el = element.closest('.b-grid-row');
    if (!el) return null;
    return this.store.getAt(el.dataset.index);
  }
  /**
   * Searches up from specified element for a grid cell or an header and returns the column which the cell belongs to
   * @param {HTMLElement} element Element somewhere in a cell
   * @returns {Grid.column.Column} Column to which the cell belongs
   * @category Getters
   */


  getColumnFromElement(element) {
    const cell = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].up(element, '.b-grid-cell, .b-grid-header');
    if (!cell) return null;

    if (cell.matches('.b-grid-header')) {
      return this.columns.getById(cell.dataset.columnId);
    }

    const cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_2__["default"].get(cell);
    return this.columns.getById(cellData.columnId);
  } // Only added for type checking, since it seems common to get it wrong in react/angular


  updateAutoHeight(autoHeight) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assertBoolean(autoHeight, 'autoHeight');
  }
  /**
   * Toggle column line visibility. End result might be overruled by/differ between themes.
   * @property {Boolean}
   * @category Misc
   */


  get columnLines() {
    return this._columnLines;
  }

  set columnLines(columnLines) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assertBoolean(columnLines, 'columnLines');
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].toggleClasses(this.element, 'b-no-column-lines', !columnLines);
    this._columnLines = columnLines;
  } //endregion
  //region Fix width & height

  /**
   * Sets widths and heights for headers, rows and other parts of the grid as needed
   * @private
   * @category Width & height
   */


  fixSizes() {
    // subGrid width
    this.callEachSubGrid('fixWidths');
  }

  onRowManagerChangeTotalHeight({
    totalHeight,
    immediate
  }) {
    return this.refreshTotalHeight(totalHeight, immediate);
  }
  /**
   * Makes height of vertical scroller match estimated total height of grid. Called when scrolling vertically and
   * when showing/hiding rows.
   * @param {Number} [height] Total height supplied by RowManager
   * @param {Boolean} [immediate] Flag indicating if buffered element sizing should be bypassed
   * @private
   * @category Width & height
   */


  refreshTotalHeight(height = this.rowManager.totalHeight, immediate = false) {
    const me = this; // Veto change of estimated total height while rendering rows or if triggered while in a hidden state

    if (me.renderingRows || !me.isVisible) {
      return false;
    } // TODO: Needed??


    if (me.rowManager.bottomRow) {
      height = Math.max(height, me.rowManager.bottomRow.bottom);
    }

    const scroller = me.scrollable,
          delta = Math.abs(me.virtualScrollHeight - height),
          clientHeight = me._bodyRectangle.height,
          newMaxY = height - clientHeight;

    if (delta) {
      const // We must update immediately if we are nearing the end of the scroll range.
      isCritical = newMaxY - me._scrollTop < clientHeight * 2 || // Or if we have scrolled pass visual height
      me._verticalScrollHeight && me._verticalScrollHeight - clientHeight < me._scrollTop; // Update the true scroll range using the scroller. This will not cause a repaint.

      scroller.scrollHeight = me.virtualScrollHeight = height; // If we are scrolling, put this off because it causes
      // a full document layout and paint.
      // Do not buffer calls for not yet painted grid

      if (me.isPainted && (me.scrolling && !isCritical || delta < 100) && !immediate) {
        me.bufferedFixElementHeights();
      } else {
        me.virtualScrollHeightDirty && me.virtualScrollHeightDirty();
        me.bufferedFixElementHeights.cancel();
        me.fixElementHeights();
      }
    }
  }

  fixElementHeights() {
    const me = this,
          height = me.virtualScrollHeight,
          heightInPx = `${height}px`;
    me._verticalScrollHeight = height;
    me.verticalScroller.style.height = heightInPx;
    me.virtualScrollHeightDirty = false;

    if (me.autoHeight) {
      me.bodyContainer.style.height = heightInPx;
      me._bodyHeight = height;
      me.refreshBodyRectangle();
    }

    me.refreshVirtualScrollbars();
  }

  refreshBodyRectangle() {
    return this._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].client(this.bodyContainer);
  } //endregion
  //region Scroll & virtual rendering


  set scrolling(scrolling) {
    this._scrolling = scrolling;
  }

  get scrolling() {
    return this._scrolling;
  }
  /**
   * Activates automatic scrolling of a subGrid when mouse is moved closed to the edges
   * @param {Grid.view.SubGrid|String} subGrid A subGrid instance or its region name
   */


  enableScrollingCloseToEdges(subGrid) {
    if (typeof subGrid === 'string') {
      subGrid = this.subGrids[subGrid];
    }

    this.scrollManager.startMonitoring({
      scrollables: [{
        element: subGrid.scrollable.element,
        direction: 'horizontal'
      }, {
        element: this.scrollable.element,
        direction: 'vertical'
      }]
    });
  }
  /**
   * Deactivates automatic scrolling of a subGrid when mouse is moved closed to the edges
   * @param {Grid.view.SubGrid|String} subGrid A subGrid instance or its region name
   */


  disableScrollingCloseToEdges(subGrid) {
    if (typeof subGrid === 'string') {
      subGrid = this.subGrids[subGrid];
    }

    this.scrollManager.stopMonitoring([subGrid.element, this.scrollable.element]);
  }
  /**
   * Responds to request from RowManager to adjust scroll position. Happens when jumping to a scroll position with
   * variable row height.
   * @param {Number} bottomMostRowY
   * @private
   * @category Scrolling
   */


  onRowManagerRequestScrollChange({
    bottom
  }) {
    this.scrollable.y = bottom - this.bodyHeight;
  }
  /**
   * Scroll syncing for normal headers & grid + triggers virtual rendering for vertical scroll
   * @private
   * @fires scroll
   * @category Scrolling
   */


  initScroll() {
    const me = this; // This method may be called early, before render calls it, so ensure that it's
    // only executed once.

    if (!me.scrollInitialized) {
      let scrollTop;
      const onScroll = me.createOnFrame(() => {
        scrollTop = me.scrollable.y; // Was getting scroll events in FF where scrollTop was unchanged, ignore those

        if (scrollTop !== me._scrollTop) {
          me._scrollTop = scrollTop;

          if (!me.scrolling) {
            me.scrolling = true;
            me.eachSubGrid(s => s.suspendResizeMonitor = true);
          }

          me.rowManager.updateRenderedRows(scrollTop);
          /**
           * Grid has scrolled vertically
           * @event scroll
           * @param {Grid.view.Grid} source The firing Grid instance.
           * @param {Number} scrollTop The vertical scroll position.
           */

          me.trigger('scroll', {
            scrollTop
          });
        }
      });
      me.scrollInitialized = true;
      me.scrollable.on({
        scroll: onScroll,

        scrollend() {
          me.scrolling = false;
          me.eachSubGrid(s => s.suspendResizeMonitor = false);
        }

      });
      me.callEachSubGrid('initScroll'); // Fixes scroll freezing bug on iPad by putting scroller in its own layer

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isMobileSafari) {
        me.scrollable.element.style.transform = 'translate3d(0, 0, 0)';
      }
    }
  } // TODO: rename to scrollRecordIntoView? Or have an alias?

  /**
   * Scrolls a row into view. If row isn't rendered it tries to calculate position
   * @param {Core.data.Model|String|Number} recordOrId Record or record id
   * @param {Object} [options] How to scroll.
   * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @category Scrolling
   * @returns {Promise} A promise which resolves when the specified row has been scrolled into view.
   */


  async scrollRowIntoView(recordOrId, options = defaultScrollOptions) {
    const me = this,
          blockPosition = options.block || 'nearest',
          {
      rowManager
    } = me,
          record = me.store.getById(recordOrId);

    if (record) {
      let scrollPromise; // check that record is "displayable", not filtered out or hidden by collapse

      if (me.store.indexOf(record) === -1) {
        return resolvedPromise;
      }

      let scroller = me.scrollable,
          recordRect = me.getRecordCoords(record);
      const scrollerRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(scroller.element); // If it was calculated from the index, update the rendered rowScrollMode
      // and scroll to the actual element. Note that this should only be necessary
      // for variableRowHeight.
      // But to "make the tests green", this is a workaround for a buffered rendering
      // bug when teleporting scroll. It does not render the rows at their correct
      // positions. Please do not try to "fix" this. I will do it. NGW

      if (recordRect.virtual) {
        const virtualBlock = recordRect.block,
              innerOptions = blockPosition !== 'nearest' ? options : {
          block: virtualBlock
        }; // Scroll the calculated position **synchronously** to the center of the scrollingViewport
        // and then update the rendered block while asking the RowManager to
        // display the required recordOrId.

        scrollPromise = scroller.scrollIntoView(recordRect, {
          block: 'center'
        });
        rowManager.scrollTargetRecordId = record;
        rowManager.updateRenderedRows(scroller.y, true);
        recordRect = me.getRecordCoords(record);
        rowManager.lastScrollTop = scroller.y;

        if (recordRect.virtual) {
          // bail out to not get caught in infinite loop, since code above is cut out of bundle
          // eslint-disable-next-line no-useless-return,no-unreachable
          return resolvedPromise;
        } // Scroll the target just less than append/prepend buffer height out of view so that the animation looks good


        if (options.animate) {
          // Do not fire scroll events during this scroll sequence - it's a purely cosmetic operation.
          // We are scrolling the desired row out of view merely to *animate scroll* it to the requested position.
          scroller.suspendEvents(); // Scroll to its final position

          if (blockPosition === 'end' || blockPosition === 'nearest' && virtualBlock === 'end') {
            scroller.y -= scrollerRect.bottom - recordRect.bottom;
          } else if (blockPosition === 'start' || blockPosition === 'nearest' && virtualBlock === 'start') {
            scroller.y += recordRect.y - scrollerRect.y;
          } // Ensure rendered block is correct at that position


          rowManager.updateRenderedRows(scroller.y, false, true); // Scroll away from final position to enable a cosmetic scroll to final position

          if (virtualBlock === 'end') {
            scroller.y -= rowManager.appendRowBuffer * rowManager.rowHeight - 1;
          } else {
            scroller.y += rowManager.prependRowBuffer * rowManager.rowHeight - 1;
          } // The row will still be rendered, so scroll it using the scroller directly


          scroller.scrollIntoView(me.getRecordCoords(record), Object.assign({}, options, innerOptions)); // Now we're at the required position, resume events

          scroller.resumeEvents();
        } else {
          var _me$scrollRowIntoView;

          if (!options.recursive) {
            await scrollPromise;
          } // May already be destroyed at this point, hence ?.


          await ((_me$scrollRowIntoView = me.scrollRowIntoView) === null || _me$scrollRowIntoView === void 0 ? void 0 : _me$scrollRowIntoView.call(me, record, Object.assign({
            recursive: true
          }, options, innerOptions)));
        }
      } else {
        let {
          column
        } = options;

        if (column) {
          if (!column.isModel) {
            column = me.columns.getById(column) || me.columns.get(column);
          } // If we are targeting a column, we must use the scroller of that column's SubGrid


          if (column) {
            scroller = me.getSubGridFromColumn(column).scrollable;
            const cellRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(rowManager.getRowFor(record).getCell(column.id));
            recordRect.x = cellRect.x;
            recordRect.width = cellRect.width;
          }
        } // No column, then tell the scroller not to scroll in the X axis
        else {
          options.x = false;
        }

        return scroller.scrollIntoView(recordRect, options);
      }
    }
  }
  /**
   * Scrolls a column into view (if it is not already)
   * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
   * @category Scrolling
   */


  scrollColumnIntoView(column, options) {
    column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_32__["default"] ? column : this.columns.get(column) || this.columns.getById(column) || this.columns.getAt(column);
    return this.getSubGridFromColumn(column).scrollColumnIntoView(column, options);
  } // TODO The API { id: recordId, column: 'columnName' } is not clear: id has to be renamed to `record` or `recordId` to be self-explanatory;

  /**
   * Scrolls a cell into view (if it is not already)
   * @param {Object} cellContext Cell selector { id: recordId, column: 'columnName' }
   * @category Scrolling
   */


  scrollCellIntoView(cellContext, options) {
    return this.scrollRowIntoView(cellContext.id, Object.assign({
      column: cellContext.columnId
    }, typeof options === 'boolean' ? {
      animate: options
    } : options));
  }
  /**
   * Scroll all the way down
   * @returns {Promise} A promise which resolves when the bottom is reached.
   * @category Scrolling
   */


  scrollToBottom(options) {
    // triggers scroll to last record. not using current scroller height because we do not know if it is correct
    return this.scrollRowIntoView(this.store.last, options);
  }
  /**
   * Scroll all the way up
   * @returns {Promise} A promise which resolves when the top is reached.
   * @category Scrolling
   */


  scrollToTop(options) {
    return this.scrollable.scrollBy(0, -this.scrollable.y, options);
  }
  /**
   * Stores the scroll state. Returns an objects with a `scrollTop` number value for the entire grid and a `scrollLeft`
   * object containing a left position scroll value per sub grid.
   * @returns {Object}
   * @category Scrolling
   */


  storeScroll() {
    const me = this,
          state = me.storedScrollState = {
      scrollTop: me.scrollable.y,
      scrollLeft: {}
    }; // TODO: Implement special multi-element Scroller subclass for Grids which
    // encapsulates the x axis only Scrollers of all its SubGrids.

    me.eachSubGrid(subGrid => {
      state.scrollLeft[subGrid.region] = subGrid.scrollable.x;
    });
    return state;
  }
  /**
   * Restore scroll state. If state is not specified, restores the last stored state.
   * @param {Object} [state] Scroll state, optional
   * @category Scrolling
   */


  restoreScroll(state = this.storedScrollState) {
    const me = this; // TODO: Implement special multi-element Scroller subclass for Grids which
    // encapsulates the x axis only Scrollers of all its SubGrids.

    me.eachSubGrid(subGrid => {
      var _subGrid$fakeScroller;

      const x = state.scrollLeft[subGrid.region]; // Force scrollable to set its position to the underlying element in case it was removed and added back to
      // the DOM prior to restoring state

      subGrid.scrollable.updateX(x);
      subGrid.header.scrollable.updateX(x);
      subGrid.footer.scrollable.updateX(x);
      (_subGrid$fakeScroller = subGrid.fakeScroller) === null || _subGrid$fakeScroller === void 0 ? void 0 : _subGrid$fakeScroller.updateX(x);
    });
    me.scrollable.updateY(state.scrollTop);
  } //endregion
  //region Theme & measuring


  beginGridMeasuring() {
    const me = this;

    if (!me.$measureCellElements) {
      me.$measureCellElements = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].createElement({
        // For row height measuring, features are not yet there. Work around that for the stripe feature,
        // which removes borders
        className: 'b-grid-subgrid ' + (!me._isRowMeasured && me.hasFeature('stripe') ? 'b-stripe' : ''),
        reference: 'subGridElement',
        style: {
          position: 'absolute',
          top: '-10000px',
          left: '-100000px',
          visibility: 'hidden',
          contain: 'strict'
        },
        children: [{
          className: 'b-grid-row',
          reference: 'rowElement',
          children: [{
            className: 'b-grid-cell',
            reference: 'cellElement',
            style: {
              width: 'auto',
              contain: _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isFirefox ? 'layout paint' : 'layout style paint'
            }
          }]
        }]
      });
    } // Bring element into life if we get here early, to be able to access verticalScroller below


    me.getConfig('element'); // Temporarily add to where subgrids live, to get have all CSS classes in play

    me.verticalScroller.appendChild(me.$measureCellElements.subGridElement); // Not yet on page, which prevents us from getting style values. Add it to the DOM temporarily

    if (!me.rendered) {
      const targetEl = me.appendTo || me.insertBefore || document.body,
            rootElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getRootElement(typeof targetEl === 'string' ? document.getElementById(targetEl) : targetEl);

      if (!me.adopt || !rootElement.contains(me.element)) {
        rootElement.appendChild(me.element);
        me.$removeAfterMeasuring = true;
      }
    }

    return me.$measureCellElements;
  }

  endGridMeasuring() {
    // Remove grid from DOM if it was added for measuring
    if (this.$removeAfterMeasuring) {
      this.element.remove();
      this.$removeAfterMeasuring = false;
    } // Remove measuring elements from grid


    this.$measureCellElements.subGridElement.remove();
  }
  /**
   * Creates a fake subgrid with one row and measures its height. Result is used as rowHeight.
   * @private
   */


  measureRowHeight() {
    const me = this,
          // Create a fake subgrid with one row, since styling for row is specified on .b-grid-subgrid .b-grid-row
    {
      rowElement
    } = me.beginGridMeasuring(),
          // Use style height or default height from config.
    // Not using clientHeight since it will have some value even if no height specified in CSS
    styles = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(rowElement, ['height', 'border-top-width', 'border-bottom-width']),
          styleHeight = parseInt(styles.height),
          // FF reports border width adjusted to device pixel ration, e.g. on a 150% scaling it would tell 0.6667px width
    // for a 1px border.
    multiplier = _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isFirefox ? devicePixelRatio : 1,
          borderTop = styles['border-top-width'] ? Math.round(multiplier * parseFloat(styles['border-top-width'])) : 0,
          borderBottom = styles['border-bottom-width'] ? Math.round(multiplier * parseFloat(styles['border-bottom-width'])) : 0; // Change rowHeight if specified in styling, also remember that value to replace later if theme changes and
    // user has not explicitly set some other height

    if (me.rowHeight == null || me.rowHeight === me._rowHeightFromStyle) {
      me.rowHeight = !isNaN(styleHeight) && styleHeight ? styleHeight : me.defaultRowHeight;
      me._rowHeightFromStyle = me.rowHeight;
    } // this measurement will be added to rowHeight during rendering, to get correct cell height


    me._rowBorderHeight = borderTop + borderBottom;
    me._isRowMeasured = true;
    me.endGridMeasuring(); // There is a ticket about measuring the actual first row instead:
    // https://app.assembla.com/spaces/bryntum/tickets/5735-measure-first-real-rendered-row-for-rowheight/details
  }
  /**
   * Handler for global theme change event (triggered by shared.js). Remeasures row height.
   * @private
   */


  onThemeChange({
    theme
  }) {
    const me = this; // Can only measure when we are visible, so do it next time we are.

    if (me.isVisible) {
      me.measureRowHeight();
    } // Otherwise wait till next time we get painted (shown, or a hidden ancestor shown)
    else if (me.findListener('paint', 'measureRowHeight', me) === -1) {
      me.on({
        paint: 'measureRowHeight',
        thisObj: me,
        once: true
      });
    }

    me.trigger('theme', {
      theme
    });
  } //endregion
  //region Rendering of rows

  /**
   * Triggers a render of records to all row elements. Call after changing order, grouping etc to reflect changes
   * visually. Preserves scroll.
   * @category Rendering
   */


  refreshRows(returnToTop = false) {
    const {
      element,
      rowManager
    } = this;
    element.classList.add('b-notransition');

    if (returnToTop) {
      rowManager.returnToTop();
    } else {
      rowManager.refresh();
    }

    element.classList.remove('b-notransition');
  }
  /**
   * Triggers a render of all the cells in a column.
   * @param {Grid.column.Column} column
   * @category Rendering
   */


  refreshColumn(column) {
    if (column.isVisible) {
      const {
        field
      } = column;
      this.rowManager.forEach(row => {
        const cellElement = row.getCell(field);
        row.renderCell({
          cellElement
        });
      });
    }
  } //endregion
  //region Render the grid

  /**
   * Recalculates virtual scrollbars widths and scrollWidth
   * @private
   */


  refreshVirtualScrollbars() {
    // NOTE: This was at some point changed to only run on platforms with width-occupying scrollbars, but it needs
    // to run with overlayed scrollbars also to make them show/hide as they should.
    const me = this,
          {
      headerContainer,
      footerContainer,
      virtualScrollers,
      scrollable,
      hasVerticalOverflow
    } = me,
          {
      classList
    } = virtualScrollers,
          hadHorizontalOverflow = !classList.contains('b-hide-display'),
          // We need to ask each subGrid if it has horizontal overflow.
    // If any do, we show the virtual scroller, otherwise we hide it.
    hasHorizontalOverflow = Object.values(me.subGrids).some(subGrid => subGrid.overflowingHorizontally),
          horizontalOverflowChanged = hasHorizontalOverflow !== hadHorizontalOverflow; // If horizontal overflow state changed, the docked horizontal scrollbar's visibility
    //  must be synced to match, and this may cause a height change;

    if (horizontalOverflowChanged) {
      virtualScrollers.classList.toggle('b-hide-display', !hasHorizontalOverflow);
    } // Auto-widthed padding element at end hides or shows to create matching margin.


    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarWidth) {
      // Header will need its extra padding if we have overflow, *OR* if we are overflowY : scroll
      const needsPadding = hasVerticalOverflow || scrollable.overflowY === 'scroll';
      headerContainer.classList.toggle('b-show-yscroll-padding', needsPadding);
      footerContainer.classList.toggle('b-show-yscroll-padding', needsPadding);
      virtualScrollers.classList.toggle('b-show-yscroll-padding', needsPadding); // Do any measuring necessitated by show/hide of the docked horizontal scrollbar
      /// *after* mutating DOM classnames.

      if (horizontalOverflowChanged) {
        // If any subgrids reported they have horizontal overflow, then we have to ask them
        // to sync the widths of the scroll elements inside the docked horizontal scrollbar
        // so that it takes up the required scrollbar width at the bottom of our body element.
        if (hasHorizontalOverflow) {
          me.callEachSubGrid('refreshFakeScroll');
        }

        me.onHeightChange();
      }
    }
  }

  get hasVerticalOverflow() {
    return this.scrollable.hasOverflow('y');
  }
  /**
   * Returns content height calculated from row manager
   * @private
   */


  get contentHeight() {
    const rowManager = this.rowManager;
    return Math.max(rowManager.totalHeight, rowManager.bottomRow ? rowManager.bottomRow.bottom : 0);
  }

  onContentChange() {
    const me = this,
          rowManager = me.rowManager;

    if (me.isVisible) {
      rowManager.estimateTotalHeight();
      me.paintListener = null;
      me.refreshTotalHeight(me.contentHeight);
      me.callEachSubGrid('refreshFakeScroll');
      me.onHeightChange();
    } // If not visible, this operation MUST be done when we become visible.
    // This is announced by the paint event which is triggered when a Widget
    // really gains visibility, ie is shown or rendered, or it's not hidden,
    // and a hidden/non-rendered ancestor is shown or rendered.
    // See Widget#triggerPaint.
    else if (!me.paintListener) {
      me.paintListener = me.on({
        paint: 'onContentChange',
        once: true,
        thisObj: me
      });
    }
  }

  triggerPaint() {
    if (!this.isPainted) {
      this.refreshBodyRectangle();
    }

    super.triggerPaint();
  }

  onHeightChange() {
    const me = this; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

    me.refreshBodyRectangle();
    me._bodyHeight = me.autoHeight ? me.contentHeight : me.bodyContainer.offsetHeight;
  }
  /**
   * Called after headers have been rendered to the headerContainer.
   * This does not do anything, it's just for Features to hook in to.
   * @param {HTMLElement} headerContainer DOM element which contains the headers.
   * @param {HTMLElement} element Grid element
   * @private
   * @category Rendering
   */


  renderHeader(headerContainer, element) {}
  /**
   * Called after footers have been rendered to the footerContainer.
   * This does not do anything, it's just for Features to hook in to.
   * @param {HTMLElement} footerContainer DOM element which contains the footers.
   * @param {HTMLElement} element Grid element
   * @private
   * @category Rendering
   */


  renderFooter(footerContainer, element) {} // Hook for features to react to column changes


  afterColumnsChange() {} // Hook for features to affect cell rendering before renderers are run


  beforeRenderCell() {}

  suspendRefresh() {
    this.refreshSuspended++;
  }

  resumeRefresh(trigger) {
    if (this.refreshSuspended && ! --this.refreshSuspended) {
      if (trigger) {
        this.refreshRows();
      }

      this.trigger('resumeRefresh');
    }
  }
  /**
   * Rerenders all grid rows, completely replacing all row elements with new ones
   * @category Rendering
   */


  renderRows(keepScroll = true) {
    const me = this,
          scrollState = keepScroll && me.storeScroll();

    if (me.refreshSuspended) {
      return;
    }
    /**
     * Grid rows are about to be rendered
     * @event beforeRenderRows
     * @param {Grid.view.Grid} source This grid.
     */


    me.trigger('beforeRenderRows');
    me.renderingRows = true; // This allows us to do things like disable animations on a refresh

    me.element.classList.add('b-grid-refreshing');

    if (!keepScroll) {
      me.scrollable.y = me._scrollTop = 0;
    }

    me.rowManager.reinitialize(!keepScroll);
    /**
     * Grid rows have been rendered
     * @event renderRows
     * @param {Grid.view.Grid} source This grid.
     */

    me.trigger('renderRows');
    me.renderingRows = false;
    me.onContentChange();

    if (keepScroll) {
      me.restoreScroll(scrollState);
    }

    me.element.classList.remove('b-grid-refreshing');
  }
  /**
   * Rerenders the grids rows, headers and footers, completely replacing all row elements with new ones
   * @category Rendering
   */


  renderContents() {
    const me = this,
          {
      element,
      headerContainer,
      footerContainer,
      rowManager
    } = me;
    me.emptyCache(); // columns will be "drawn" on render anyway, bail out

    if (me.isPainted) {
      // reset measured header height, to make next call to get headerHeight measure it
      me._headerHeight = null;
      me.callEachSubGrid('refreshHeader', headerContainer);
      me.callEachSubGrid('refreshFooter', footerContainer); // Note that these are hook methods for features to plug in to. They do not do anything.

      me.renderHeader(headerContainer, element);
      me.renderFooter(footerContainer, element);
      me.fixSizes(); // any elements currently used for rows should be released.
      // actual removal of elements is done in SubGrid#clearRows

      const refreshContext = rowManager.removeAllRows();
      rowManager.calculateRowCount(false, true, true);

      if (rowManager.rowCount) {
        // Sets up the RowManager's position for when renderRows calls RowManager#reinitialize
        // so that it renders the correct data block at the correct position.
        rowManager.setPosition(refreshContext);
        me.renderRows();
      }
    }
  }

  onPaintOverride() {// Internal procedure used for paint method overrides
    // Not used in onPaint() because it may be chained on instance and Override won't be applied
  } // Render rows etc. on first paint, to make sure Grids element has been laid out


  onPaint({
    firstPaint
  }) {
    const me = this;
    super.onPaint({
      firstPaint
    });

    if (me.onPaintOverride() || !firstPaint) {
      return;
    }

    const {
      rowManager,
      store,
      element,
      headerContainer,
      bodyContainer,
      footerContainer
    } = me,
          scrollPad = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarPadElement;
    let columnsChanged,
        maxDepth = 0; // See if updateResponsive changed any columns.

    me.columns.on({
      change: () => columnsChanged = true,
      once: true
    }); // Apply any responsive configs before rendering rows.

    me.updateResponsive(me.width, 0); // If there were any column changes, apply them

    if (columnsChanged) {
      me.callEachSubGrid('refreshHeader', headerContainer);
      me.callEachSubGrid('refreshFooter', footerContainer);
    } // Note that these are hook methods for features to plug in to. They do not do anything.
    // SubGrids take care of their own rendering.


    me.renderHeader(headerContainer, element);
    me.renderFooter(footerContainer, element); // These padding elements are only visible on scrollbar showing platforms.
    // And then, only when the owning element as the b-show-yscroll-padding class added.
    // See refreshVirtualScrollbars where this is synced on the header, footer and scroller elements.

    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].append(headerContainer, scrollPad);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].append(footerContainer, scrollPad);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].append(me.virtualScrollers, scrollPad); // Cached, updated on resize. Used by RowManager and by the subgrids upon their render.
    // Measure after header and footer have been rendered and taken their height share.

    me.refreshBodyRectangle();
    const bodyOffsetHeight = me.bodyContainer.offsetHeight;

    if (me.autoHeight) {
      me._bodyHeight = rowManager.initWithHeight(element.offsetHeight - headerContainer.offsetHeight - footerContainer.offsetHeight, true);
      bodyContainer.style.height = me.bodyHeight + 'px';
    } else {
      me._bodyHeight = bodyOffsetHeight;
      rowManager.initWithHeight(me._bodyHeight, true);
    }

    me.eachSubGrid(subGrid => {
      if (subGrid.header.maxDepth > maxDepth) {
        maxDepth = subGrid.header.maxDepth;
      }
    });
    headerContainer.dataset.maxDepth = maxDepth;
    me.fixSizes();

    if (store.count || !store.isLoading) {
      me.renderRows();
    } // With autoHeight cells we need to refresh rows when fonts are loaded, to get correct measurements


    if (me.columns.usesAutoHeight) {
      const {
        fonts
      } = document;

      if ((fonts === null || fonts === void 0 ? void 0 : fonts.status) !== 'loaded') {
        fonts.ready.then(() => !me.isDestroyed && me.refreshRows());
      }
    }

    me.initScroll();
    me.initInternalEvents();
  }

  render() {
    const me = this; // When displayed inside one of our containers, require a size to be considered visible. Ensures it is painted
    // on display when for example in a tab

    me.requireSize = Boolean(me.owner); // Render as a container. This renders the child SubGrids

    super.render(...arguments);

    if (!me.autoHeight) {
      // Sanity check that main element has been given some sizing styles, unless autoHeight is used in which case
      // it will be sized programmatically instead
      if (me.headerContainer.offsetHeight && !me.bodyContainer.offsetHeight) {
        console.warn('Grid element not sized correctly, please check your CSS styles and review how you size the widget');
      } // Warn if height equals the predefined minHeight, likely that is not what the dev intended


      if (!('minHeight' in me.initialConfig) && !('height' in me.initialConfig) && parseInt(window.getComputedStyle(me.element).minHeight) === me.height) {
        console.warn(`The ${me.$$name} is sized by its predefined minHeight, likely this is not intended. ` + `Please check your CSS and review how you size the widget, or assign a fixed height in the config. ` + `For more information, see the "Basics/Sizing the component" guide in docs.`);
      }
    }
  } //endregion
  //region Masking and Appearance

  /**
   * Show a load mask with a spinner and the specified message. When using an AjaxStore masking and unmasking is
   * handled automatically, but if you are loading data in other ways you can call this function manually when your
   * load starts.
   * ```
   * myLoadFunction() {
   *   // Show mask before initiating loading
   *   grid.maskBody('Loading data');
   *   // Your custom loading code
   *   load.then(() => {
   *      // Hide the mask when loading is finished
   *      grid.unmaskBody();
   *   });
   * }
   * ```
   * @param {String} loadMask Message to show next to the spinner
   * @returns {Core.widget.Mask}
   */


  maskBody(loadMask) {
    const me = this;

    if (me.bodyContainer) {
      // remove any existing mask
      me.unmaskBody();
      const {
        maskElement
      } = me.activeMask = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_12__["default"].mask(loadMask, me.element);
      maskElement.style.marginTop = `${me.bodyContainer.offsetTop}px`;
      maskElement.style.height = `${me.virtualScrollers.offsetTop + me.virtualScrollers.offsetHeight - me.bodyContainer.offsetTop}px`;
      return me.activeMask;
    }
  }
  /**
   * Hide the load mask.
   */


  unmaskBody() {
    const me = this;
    me.loadmaskHideTimer && me.clearTimeout(me.loadmaskHideTimer);
    me.loadmaskHideTimer = null;
    me.activeMask && me.activeMask.destroy();
    me.activeMask = null;
  }

  toggleEmptyText() {
    if (this.bodyContainer) {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].toggleClasses(this.bodyContainer, 'b-grid-empty', !(this.rowManager.rowCount > 0 || this.store.isLoading || this.store.isCommitting));
    }
  } //endregion


} // Register this widget type with its Factory

GridBase.initClass();
_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setVersion('grid', '4.3.6');
GridBase._$name = 'GridBase';

/***/ }),

/***/ "./lib/Grid/view/Header.js":
/*!*********************************!*\
  !*** ./lib/Grid/view/Header.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Header; });
/* harmony import */ var _Bar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Bar.js */ "./lib/Grid/view/Bar.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'gantt';



/**
 * @module Grid/view/Header
 */

/**
 * The Grid header, which contains simple columns but also allows grouped columns. One instance is created and used per SubGrid
 * automatically, you should not need to instantiate this class manually. See {@link Grid.column.Column} for information about
 * column configuration.
 *
 * @extends Grid/view/Bar
 * @internal
 *
 * @inlineexample Grid/view/Header.js
 */

class Header extends _Bar_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Header';
  } // Factoryable type name


  static get type() {
    return 'gridheader';
  }

  startConfigure(config) {
    config.scrollable.overflowX = 'hidden-scroll';
    super.startConfigure(config);
  }

  get subGrid() {
    return this._subGrid;
  }

  set subGrid(subGrid) {
    this._subGrid = this.owner = subGrid;
  }

  get region() {
    var _this$subGrid;

    return (_this$subGrid = this.subGrid) === null || _this$subGrid === void 0 ? void 0 : _this$subGrid.region;
  }

  changeElement(element, was) {
    const {
      region
    } = this; // Columns must be examined for maxDepth

    this.getConfig('columns');
    return super.changeElement({
      className: {
        'b-grid-header-scroller': 1,
        [`b-grid-header-scroller-${region}`]: region
      },
      children: [{
        reference: 'headersElement',
        className: {
          'b-grid-headers': 1,
          [`b-grid-headers-${region}`]: region
        },
        dataset: {
          region,
          reference: 'headersElement',
          maxDepth: this.maxDepth
        }
      }]
    }, was);
  }

  get overflowElement() {
    return this.headersElement;
  }
  /**
   * Recursive column header config creator.
   * Style not included because of CSP. Widths are fixed up in
   * {@link #function-fixHeaderWidths}
   * @private
   */


  getColumnConfig(column) {
    const {
      id,
      align,
      resizable,
      isLeaf,
      isParent,
      isLastInSubGrid,
      cls,
      childLevel,
      field,
      tooltip,
      children,
      isFocusable
    } = column;

    if (column.isVisible) {
      return {
        className: {
          'b-grid-header': 1,
          'b-grid-header-parent': isParent,
          [`b-level-${childLevel}`]: 1,
          [`b-depth-${column.meta.depth}`]: 1,
          [`b-grid-header-align-${align}`]: align,
          'b-grid-header-resizable': resizable && isLeaf,
          [cls]: cls,
          'b-last-parent': isParent && isLastInSubGrid,
          'b-last-leaf': isLeaf && isLastInSubGrid
        },
        [isFocusable ? 'tabIndex' : '']: 0,
        dataset: {
          columnId: id,
          [field ? 'column' : '']: field,
          [tooltip ? 'btip' : '']: tooltip
        },
        children: [{
          className: 'b-grid-header-text',
          children: [{
            className: 'b-grid-header-text-content'
          }]
        }, children ? {
          className: 'b-grid-header-children',
          children: children.map(child => this.getColumnConfig(child))
        } : null, {
          className: 'b-grid-header-resize-handle'
        }]
      };
    }
  } // used by safari to fix flex when rows width shrink below this value


  calculateMinWidthForSafari() {
    let minWidth = 0;
    this.columns.visibleColumns.forEach(column => {
      minWidth += column.calculateMinWidth();
    });
    return minWidth;
  }
  /**
   * Fix header widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
   * @private
   */


  fixHeaderWidths() {
    this.fixCellWidths();
  }

  refreshHeaders() {
    const me = this; // run renderers, not done from template to work more like cell rendering

    me.columns.traverse(column => {
      const headerElement = me.getBarCellElement(column.id);

      if (headerElement) {
        let html = column.headerText;

        if (column.headerRenderer) {
          html = column.headerRenderer.call(column.thisObj || me, {
            column,
            headerElement
          });
        }

        if (column.icon) {
          html = `<i class="${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(column.icon)}"></i>` + (html || '');
        }

        const innerEl = headerElement.querySelector('.b-grid-header-text-content');

        if (innerEl) {
          innerEl.innerHTML = html || '';
        }
      }
    });
    me.fixHeaderWidths();
  }

  get columns() {
    const me = this,
          result = super.columns;

    if (!me.columnsDetacher) {
      // columns is a chained store, it will be repopulated from master when columns change.
      // That action always triggers change with action dataset.
      me.columnsDetacher = result.on({
        change() {
          me.initDepths();
        },

        thisObj: me
      });
      me.initDepths();
    }

    return result;
  }

  set columns(columns) {
    super.columns = columns;
  }
  /**
   * Depths are used for styling of grouped headers. Sets them on meta.
   * @private
   */


  initDepths(columns = this.columns.topColumns, parent = null) {
    const me = this;
    let maxDepth = 0;

    if (parent !== null && parent !== void 0 && parent.meta) {
      parent.meta.depth++;
    }

    for (const column of columns) {
      const {
        meta
      } = column; // TODO: this should maybe move

      meta.depth = 0;

      if (column.children) {
        me.initDepths(column.children.filter(me.columns.chainedFilterFn), column);

        if (meta.depth && parent) {
          parent.meta.depth += meta.depth;
        }
      }

      if (meta.depth > maxDepth) {
        maxDepth = meta.depth;
      }
    }

    if (!parent) {
      me.maxDepth = maxDepth;
    }

    return maxDepth;
  } //endregion
  //region Getters

  /**
   * Get the header cell element for the specified column.
   * @param {String} columnId Column id
   * @returns {HTMLElement} Header cell element
   */


  getHeader(columnId) {
    return this.getBarCellElement(columnId);
  } //endregion


  get contentElement() {
    return this.element.firstElementChild;
  }

  refreshContent() {
    const me = this;
    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].sync({
      domConfig: {
        children: me.columns.topColumns.map(col => me.getColumnConfig(col)),
        onlyChildren: true,
        strict: true,
        syncIdField: 'columnId',
        releaseThreshold: 0
      },
      targetElement: me.contentElement
    });
    me.refreshHeaders();
  }

  onPaint({
    firstPaint
  }) {
    if (firstPaint) {
      this.refreshContent();
    }
  }

} // Register this widget type with its Factory

Header.initClass();
Header._$name = 'Header';

/***/ }),

/***/ "./lib/Grid/view/SubGrid.js":
/*!**********************************!*\
  !*** ./lib/Grid/view/SubGrid.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SubGrid; });
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/SubGridScroller.js */ "./lib/Grid/util/SubGridScroller.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';









/**
 * @module Grid/view/SubGrid
 */

/**
 * A SubGrid is a part of the grid (it has at least one and normally no more than two, called locked and normal). It
 * has its own header, which holds the columns to display rows for in the SubGrid. SubGrids are created by Grid, you
 * should not need to create instances directly.
 *
 * If not configured with a width or flex, the SubGrid will be sized to fit its columns. In this case, if all columns
 * have a fixed width (not using flex) then toggling columns will also affect the width of the SubGrid.
 *
 * @extends Core/widget/Widget
 */

class SubGrid extends _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  //region Config
  static get $name() {
    return 'SubGrid';
  } // Factoryable type name


  static get type() {
    return 'subgrid';
  }
  /**
   * Region (name) for this SubGrid
   * @config {String} region
   */

  /**
   * Column store, a store containing the columns for this SubGrid
   * @config {Grid.data.ColumnStore} columns
   */


  static get defaultConfig() {
    return {
      localizableProperties: ['emptyText'],
      insertRowsBefore: null,
      appendTo: null,
      monitorResize: true,
      headerClass: null,
      footerClass: null,

      /**
       * Set `true` to start subgrid collapsed. To operate collapsed state on subgrid use
       * {@link #function-collapse}/{@link #function-expand} methods.
       * @config {Boolean}
       * @default false
       */
      collapsed: null,
      scrollable: {
        // Each SubGrid only handles scrolling in the X axis.
        // The owning Grid handles the Y axis.
        overflowX: true
      },
      scrollerClass: _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_5__["default"],
      // Will be set to true by GridSubGrids if it calculates the subgrids width based on its columns.
      // Used to determine if hiding a column should affect subgrids width
      hasCalculatedWidth: null,

      /**
       * Set `true` to disable moving columns into or out of this SubGrid.
       * @config {Boolean}
       * @default false
       * @private
       */
      sealedColumns: null,
      emptyText: null
    };
  }

  static get configurable() {
    return {
      element: true,
      header: {},
      footer: {},
      virtualScrollerElement: true,
      splitterElement: true,
      headerSplitter: true,
      scrollerSplitter: true,
      footerSplitter: true,

      /**
       * Set to `false` to prevent this subgrid being resized with the {@link Grid.feature.RegionResize} feature
       * @internal
       * @config {Boolean}
       * @default true
       */
      resizable: null
    };
  } //endregion
  //region Init

  /**
   * SubGrid constructor
   * @param config
   * @private
   */


  construct(config) {
    const me = this;
    super.construct(config);
    this.rowManager.on('addrows', this.onAddRow, this);

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox) {
      const {
        element
      } = me,
            verticalScroller = me.grid.scrollable; // Firefox cannot scroll vertically smoothly when using touch pad. Even a microscopic horizontal touch will
      // abort the vertical scrolling. To counter this we ignore pointer events on the subgrid element temporarily
      // until scroll stops. No test coverage.
      // https://github.com/bryntum/support/issues/3000

      let lastScrollTop = 0;
      element.addEventListener('wheel', ({
        ctrlKey,
        deltaY,
        deltaX
      }) => {
        const isVerticalScroll = Math.abs(deltaY) > Math.abs(deltaX); // Ignore wheel event with Control key pressed - it doesn't scroll, it either zooms scheduler or zooms
        // the page.

        if (!ctrlKey && isVerticalScroll && !me.scrollEndDetacher && verticalScroller.y !== lastScrollTop) {
          element.style.pointerEvents = 'none';
          lastScrollTop = verticalScroller.y;
          me.scrollEndDetacher = verticalScroller.on({
            scrollEnd: async () => {
              lastScrollTop = verticalScroller.y;
              element.style.pointerEvents = '';
              me.scrollEndDetacher = null;
            },
            once: true
          });
        }
      });
    }
  }

  doDestroy() {
    var _me$fakeScroller;

    const me = this;
    me.header.destroy();
    me.footer.destroy();
    (_me$fakeScroller = me.fakeScroller) === null || _me$fakeScroller === void 0 ? void 0 : _me$fakeScroller.destroy();
    me.virtualScrollerElement.remove();
    me.splitterElement.remove();
    me.headerSplitter.remove();
    me.scrollerSplitter.remove();
    me.footerSplitter.remove();
    super.doDestroy();
  }

  get barConfig() {
    const me = this,
          {
      width,
      flex
    } = me.element.style,
          config = {
      subGrid: me,
      parent: me // Contained widgets need to know their parents

    }; // If we have been configured with sizing, construct the Bar in sync.

    if (flex) {
      config.flex = flex;
    } else if (width) {
      config.width = width;
    }

    return config;
  }

  changeHeader(header) {
    return new this.headerClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
      id: this.id + '-header'
    }, this.barConfig, header));
  }

  changeFooter(footer) {
    return new this.footerClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
      id: this.id + '-footer'
    }, this.barConfig, footer));
  } //endregion
  //region Splitters

  /**
   * Toggle (add/remove) class for splitters
   * @param {String} cls class name
   * @param {Boolean} [add] actions. Set to `true` to add class, `false` to remove
   * @private
   */


  toggleSplitterCls(cls, add = true) {
    const me = this,
          splitters = [me.splitterElement, me.headerSplitter, me.footerSplitter, me.scrollerSplitter];
    splitters.forEach(el => el === null || el === void 0 ? void 0 : el.classList[add ? 'add' : 'remove'](cls));
  } //endregion
  //region Template


  changeElement(element, was) {
    const {
      region
    } = this;
    return super.changeElement({
      className: {
        'b-grid-subgrid': 1,
        [`b-grid-subgrid-${region}`]: region,
        'b-grid-horizontal-scroller': 1,
        'b-grid-subgrid-collapsed': this.collapsed
      },
      dataset: {
        region
      }
    }, was);
  }

  get rowElementConfig() {
    return {
      className: 'b-grid-row',
      children: this.columns.visibleColumns.map(column => ({
        className: 'b-grid-cell',
        dataset: {
          column: column.field || '',
          columnId: column.id
        }
      }))
    };
  } // Added to DOM in Grid `get bodyConfig`


  changeVirtualScrollerElement() {
    const references = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
      reference: 'virtualScrollerElement',
      className: 'b-virtual-scroller',
      dataset: {
        region: this.region
      },
      children: [{
        reference: 'virtualScrollerWidth',
        className: 'b-virtual-width'
      }]
    });
    this.virtualScrollerWidth = references.virtualScrollerWidth;
    return references.virtualScrollerElement;
  }

  changeSplitterElement() {
    const references = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
      reference: 'splitterElement',
      className: {
        'b-grid-splitter': 1,
        'b-grid-splitter-collapsed': this.collapsed,
        'b-hide-display': 1 // GridSubGrids determines visibility

      },
      dataset: {
        region: this.region
      },
      children: [{
        className: 'b-grid-splitter-inner b-grid-splitter-main',
        children: [{
          className: 'b-grid-splitter-buttons',
          reference: 'splitterButtons',
          children: [{
            tag: 'i',
            className: 'b-icon b-icon-collapse-gridregion'
          }, {
            tag: 'i',
            className: 'b-icon b-icon-expand-gridregion'
          }]
        }]
      }]
    });
    this.splitterButtons = references.splitterButtons;
    return references.splitterElement;
  }

  get splitterConfig() {
    return {
      className: this.splitterElement.className.trim(),
      children: [{
        className: 'b-grid-splitter-inner'
      }],
      dataset: {
        region: this.region
      }
    };
  }

  changeHeaderSplitter() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(this.splitterConfig);
  }

  changeScrollerSplitter() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(this.splitterConfig);
  }

  changeFooterSplitter() {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(this.splitterConfig);
  }

  hideSplitter() {
    const me = this;
    me.splitterElement.classList.add('b-hide-display');
    me.headerSplitter.classList.add('b-hide-display');
    me.scrollerSplitter.classList.add('b-hide-display');
    me.footerSplitter.classList.add('b-hide-display');
    me.$showingSplitter = false;
  }

  showSplitter() {
    const me = this;
    me.splitterElement.classList.remove('b-hide-display');
    me.headerSplitter.classList.remove('b-hide-display');
    me.scrollerSplitter.classList.remove('b-hide-display');
    me.footerSplitter.classList.remove('b-hide-display');
    me.$showingSplitter = true;
  } //endregion
  //region Render


  render(...args) {
    const me = this;
    super.render(...args); // Unit tests create naked SubGrids so we have to do this.

    if (me.grid) {
      me.updateHasFlex();
      me.element.parentNode.insertBefore(me.splitterElement, me.element.nextElementSibling);
      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
        element: me.grid.element,
        delegate: `.b-grid-splitter[data-region=${me.region}]`,
        mouseover: 'onSplitterMouseOver',
        mouseout: 'onSplitterMouseOut',
        thisObj: me
      });
      me._collapsed && me.collapse();
    }
  }

  refreshHeader() {
    this.header.refreshContent();
  }

  refreshFooter() {
    var _this$footer;

    (_this$footer = this.footer) === null || _this$footer === void 0 ? void 0 : _this$footer.refreshContent();
  } // Override to iterate header and footer.


  eachWidget(fn, deep = true) {
    const me = this,
          widgets = [me.header, me.footer];

    for (let i = 0; i < widgets.length; i++) {
      const widget = widgets[i];

      if (fn(widget) === false) {
        return;
      }

      if (deep && widget.eachWidget) {
        widget.eachWidget(fn, deep);
      }
    }
  } //endregion
  //region Size & resize

  /**
   * Sets cell widths. Cannot be done in template because of CSP
   * @private
   */


  fixCellWidths(rowElement) {
    const {
      visibleColumns
    } = this.columns; // fix cell widths, no longer allowed in template because of CSP

    let cell = rowElement.firstElementChild,
        i = 0;

    while (cell) {
      const column = visibleColumns[i];

      if (column.minWidth) {
        cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setLength(column.minWidth);
      }

      if (column.maxWidth) {
        cell.style.maxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setLength(column.maxWidth);
      } // either flex or width, flex has precedence


      if (column.flex) {
        cell.style.flex = column.flex;
        cell.style.width = '';
      } else if (column.width) {
        // https://app.assembla.com/spaces/bryntum/tickets/8041
        // Although header and footer elements must be sized using flex-basis to avoid the busting out problem,
        // grid cells MUST be sized using width since rows are absolutely positioned and will not cause the
        // busting out problem, and rows will not stretch to shrinkwrap the cells unless they are widthed with
        // width.
        cell.style.width = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setLength(column.width); // IE11 calculates flexbox container width based on min-width rather than actual width. When column
        // has width defined greater than minWidth, row may have incorrect width

        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isIE11) {
          cell.style.flex = '';
          cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setLength(column.calcMinWidth);
        }
      } else {
        cell.style.flex = cell.style.width = cell.style.minWidth = '';
      }

      cell = cell.nextElementSibling;
      i++;
    }
  }

  get totalFixedWidth() {
    return this.columns.totalFixedWidth;
  }
  /**
   * Sets header width and scroller width (if needed, depending on if using flex). Might also change the subgrids
   * width, if it uses a width calculated from its columns.
   * @private
   */


  fixWidths() {
    const me = this,
          {
      element,
      header,
      footer
    } = me;

    if (!me.collapsed) {
      if (me.flex) {
        header.flex = me.flex;

        if (footer) {
          footer.flex = me.flex;
        }

        element.style.flex = me.flex;
      } else {
        // If width is calculated and no column is using flex, check if total width is less than width. If so,
        // recalculate width and bail out of further processing (since setting width will trigger again)
        if (me.hasCalculatedWidth && !me.columns.some(col => !col.hidden && col.flex) && me.totalFixedWidth !== me.width) {
          me.width = me.totalFixedWidth; // Setting width above clears the hasCalculatedWidth flag, but we want to keep it set to react
          // correctly next time

          me.hasCalculatedWidth = true;
          return;
        }

        let totalWidth = me.width;

        if (!totalWidth) {
          totalWidth = 0; // summarize column widths, needed as container width when not using flex widths and for correct
          // overflow check in Edge

          for (const col of me.columns) {
            if (!col.flex && !col.hidden) totalWidth += col.width;
          }
        } // rows are absolutely positioned, meaning that their width won't affect container width
        // hence we must set it, if not using flex


        element.style.width = `${totalWidth}px`;
        header.width = totalWidth;

        if (footer) {
          footer.width = totalWidth;
        }
      }

      me.syncScrollingPartners(false);
    }
  } // Safari/Edge do not shrink cells the same way as chrome & ff does without having a width set on the row


  fixRowWidthsInSafariEdge() {
    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isSafari || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isEdge) {
      const me = this,
            {
        region,
        header
      } = me,
            minWidth = header.calculateMinWidthForSafari(); // fix row widths for safari, it does not size flex cells correctly at small widths otherwise.
      // there should be a css solution, but I have failed to find it

      me.rowManager.forEach(row => {
        // This function runs on resize and rendering a SubGrid triggers a resize. When adding a new SubGrid
        // on the fly elements wont exists for it yet, so ignore...
        const element = row.getElement(region); // it is worth noting that setting a width does not prevent the row from growing beyond that with
        // when making view wider, it is used in flex calculation more like a min-width

        if (element) {
          element.style.width = `${minWidth}px`;
        }
      });
      header.headersElement.style.width = `${minWidth}px`;
    }
  }
  /**
   * Get/set SubGrid width, which also sets header and footer width (if available).
   * @property {Number}
   */


  set width(width) {
    const me = this; // Width explicitly set, remember that

    me.hasCalculatedWidth = false;
    super.width = width;
    me.header.width = width;
    me.footer.width = width; // When we're live, we can't wait until the  throttled resize occurs - it looks bad.

    if (me.isPainted) {
      me.onElementResize();
    }
  }

  get width() {
    return super.width;
  }
  /**
   * Get/set SubGrid flex, which also sets header and footer flex (if available).
   * @property {Number|String}
   */


  set flex(flex) {
    const me = this; // Width explicitly set, remember that

    me.hasCalculatedWidth = false;
    me.header.flex = flex;
    me.footer.flex = flex;
    super.flex = flex; // When we're live, we can't wait until the  throttled resize occurs - it looks bad.

    if (me.isPainted) {
      me.onElementResize();
    }
  }

  get flex() {
    return super.flex;
  }
  /**
   * Called when grid changes size. SubGrid determines if it has changed size and triggers scroll (for virtual
   * rendering in cells to work when resizing etc.)
   * @private
   */


  onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight) {
    const me = this,
          {
      grid
    } = me; // Widget caches dimensions

    super.onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight); // Unit tests create naked SubGrids so we have to do this.

    if (grid) {
      me.syncSplitterButtonPosition();

      if (newWidth !== oldWidth) {
        // trigger scroll, in case anything is done on scroll it needs to be done now also
        grid.trigger('horizontalScroll', {
          subGrid: me,
          grid,
          scrollLeft: me.scrollable.x
        }); // Update virtual scrollers, if they are ready

        me.fakeScroller && me.refreshFakeScroll();
        me.fixRowWidthsInSafariEdge();
      }

      me.trigger('afterInternalResize', me);
    }
  }
  /**
   * Keeps the parallel splitters in the header, footer and fake scroller synced in terms
   * of being collapsed or not.
   * @private
   */


  syncParallelSplitters(collapsed) {
    const me = this,
          {
      grid
    } = me;

    if (me.splitterElement && me.$showingSplitter) {
      me.toggleSplitterCls('b-grid-splitter-collapsed', collapsed);
    } else {
      // If we're the last, we don't own a splitter, we use the previous region's splitter
      const prevGrid = grid.getSubGrid(grid.getPreviousRegion(me.region)); // If there's a splitter before us, sync it with our state.

      if (prevGrid && prevGrid.splitterElement) {
        prevGrid.syncParallelSplitters(collapsed);
      }
    }
  }

  onSplitterMouseOver() {
    const me = this,
          {
      nextSibling
    } = me; // No hover effect when collapsed

    if (!me.collapsed && (!nextSibling || !nextSibling.collapsed)) {
      me.toggleSplitterCls('b-hover');
    }

    me.startSplitterButtonSyncing();
  }

  onSplitterMouseOut() {
    const me = this,
          {
      nextSibling
    } = me;
    me.toggleSplitterCls('b-hover', false);

    if (!me.collapsed && (!nextSibling || !nextSibling.collapsed)) {
      me.stopSplitterButtonSyncing();
    }
  }

  startSplitterButtonSyncing() {
    const me = this;

    if (me.splitterElement) {
      me.syncSplitterButtonPosition();

      if (!me.splitterSyncScrollListener) {
        me.splitterSyncScrollListener = me.grid.scrollable.on({
          scroll: 'syncSplitterButtonPosition',
          thisObj: me
        });
      }
    }
  }

  stopSplitterButtonSyncing() {
    if (this.splitterSyncScrollListener) {
      this.splitterSyncScrollListener();
      this.splitterSyncScrollListener = null;
    }
  }

  syncSplitterButtonPosition() {
    const me = this;
    me.splitterButtons.style.transform = `translateY(${me.grid.scrollable.y + me.grid.bodyHeight / 2 - (me.headerSplitter ? me.grid.headerHeight : 0)}px)`;
  }
  /**
   * Get the "viewport" for the SubGrid as a Rectangle
   * @property {Core.helper.util.Rectangle}
   * @readonly
   */


  get viewRectangle() {
    const {
      scrollable
    } = this;
    return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"](scrollable.x, scrollable.y, this.width || 0, this.rowManager.viewHeight);
  }
  /**
   * Called when updating column widths to apply 'b-has-flex' which is used when fillLastColumn is configured.
   * @internal
   */


  updateHasFlex() {
    const hasFlex = this.columns.visibleColumns.some(column => column.flex);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toggleClasses(this.element, ['b-has-flex'], hasFlex);
  }

  updateResizable(resizable) {
    const me = this;
    [me.splitterElement, me.headerSplitter, me.scrollerSplitter, me.footerSplitter].forEach(splitter => _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toggleClasses(splitter, ['b-disabled'], !resizable));
  }
  /**
   * Resize all columns in the SubGrid to fit their width, according to their configured
   * {@link Grid.column.Column#config-fitMode}
   */


  resizeColumnsToFitContent() {
    this.grid.beginGridMeasuring();
    this.columns.visibleColumns.forEach(column => {
      column.resizeToFitContent(null, null, true);
    });
    this.grid.endGridMeasuring();
  } //endregion
  //region Scroll


  get overflowingHorizontally() {
    const {
      scrollable
    } = this; // This is if *this* subGrid has horizontal overflow
    // +1 is for Edge, it messes up otherwise

    return scrollable.scrollWidth > scrollable.clientWidth + (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isEdge ? 1 : 0);
  }

  get overflowingVertically() {
    const {
      scrollable
    } = this; // This is if *this* subGrid has vertical overflow
    // +1 is for Edge, it messes up otherwise

    return scrollable.scrollHeight > scrollable.clientHeight + (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isEdge ? 1 : 0);
  }
  /**
   * Fixes widths of fake scrollers
   * @private
   */


  refreshFakeScroll() {
    const me = this,
          {
      element,
      virtualScrollerElement,
      virtualScrollerWidth,
      header,
      footer,
      scrollable
    } = me,
          totalFixedWidth = header.scrollable.scrollWidth; // Always use (at least) a fixed scroll width so when grid becomes empty (e.g after filtering with no matches),
    // it maintains scroll-x position
    // https://github.com/bryntum/support/issues/3247

    scrollable.scrollWidth = totalFixedWidth; // Scroller lays out in the same way as subgrid.
    // If we are flexed, the scroller is flexed etc.

    virtualScrollerElement.style.width = element.style.width;
    virtualScrollerElement.style.flex = element.style.flex;

    if (!me.collapsed) {
      if (me.overflowingHorizontally) {
        virtualScrollerWidth.style.width = `${scrollable.scrollWidth || 0}px`;
        header.element.classList.add('b-overflowing');
        footer.element.classList.add('b-overflowing'); // If *any* SubGrids have horizontal overflow, the main grid
        // has to show its virtual horizontal scrollbar.

        me.grid.virtualScrollers.classList.remove('b-hide-display');
      } else {
        virtualScrollerWidth.style.width = 0;
        header.element.classList.remove('b-overflowing');
        footer.element.classList.remove('b-overflowing');
      }
    }
  }
  /**
   * Init scroll syncing for header and footer (if available).
   * @private
   */


  initScroll() {
    const me = this,
          {
      scrollable,
      virtualScrollerElement
    } = me;
    me.syncPartnersOnFrame = me.createOnFrame(me.syncScrollingPartners);

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox) {
      scrollable.element.addEventListener('wheel', event => {
        if (event.deltaX) {
          scrollable.x += event.deltaX;
          event.preventDefault();
        }
      });
    }

    scrollable.yScroller = me.grid.scrollable; // Add our Scroller to the controlling GridScroller

    scrollable.yScroller.addScroller(scrollable); // Create a Scroller for the fake horizontal scrollbar so that it can partner

    me.fakeScroller = new _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
      element: virtualScrollerElement,
      overflowX: true
    }); // Sync scrolling partners (header, footer) when our xScroller reports a scroll.
    // Also fires horizontalscroll

    scrollable.on({
      scroll: 'onSubGridScroll',
      scrollend: 'onSubGridScrollEnd',
      thisObj: me
    });
    scrollable.addPartner(me.fakeScroller, 'x');
    scrollable.addPartner(me.header.scrollable, 'x');
    scrollable.addPartner(me.footer.scrollable, 'x'); // Update virtual scrollers (previously updated too early from onInternalResize)

    me.refreshFakeScroll();
  }

  onSubGridScrollEnd() {
    // If we do not have the direct update flag set which would ensure a sync in each scroll event
    // then ensure syncing happens on scroll end. This is for animated scrolls where the scroll
    // impulses come through animation frames.
    if (!this.forceScrollUpdate) {
      this.syncScrollingPartners();
    }

    this.scrolling = false; // Remove overlaid scrollbar interactivity

    if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollBarWidth) {
      this.grid.virtualScrollers.classList.remove('b-scrolling');
    }
  }

  onSubGridScroll() {
    // Force direct update, without waiting for next animation frame
    // TODO: Only used in Scheduler, could perhaps live in Scheduler specific SubGrid in the future
    if (this.forceScrollUpdate) {
      this.syncScrollingPartners();
      this.forceScrollUpdate = false;
    } else {
      this.syncPartnersOnFrame();
    }
  }

  set scrolling(scrolling) {
    this._scrolling = scrolling;
  }

  get scrolling() {
    return this._scrolling;
  }
  /**
   * This syncs the horizontal scroll position of the header and the footer with
   * the horizontal scroll position of the grid. Usually, this will be called automatically
   * when the grid scrolls. In some cases, such as a refresh caused by column changes
   * it will need to be called from elsewhere.
   * @internal
   */


  syncScrollingPartners(addCls = true) {
    const subGrid = this,
          {
      grid
    } = subGrid;

    if (!subGrid.scrolling && addCls) {
      subGrid.scrolling = true; // Allow interacting with overlaid scrollbar after scrolling starts

      if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollBarWidth) {
        grid.virtualScrollers.classList.add('b-scrolling');
      }
    }

    grid.trigger('horizontalScroll', {
      subGrid,
      grid,
      scrollLeft: subGrid.scrollable.x
    });
  }
  /**
   * Scrolls a column into view (if it is not already). Called by Grid#scrollColumnIntoView, use it instead to not
   * have to care about which SubGrid contains a column.
   * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
   */


  scrollColumnIntoView(column, options) {
    const me = this,
          scroller = me.header.scrollable; // Allow column,column id,or column index to be passed

    column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_4__["default"] ? column : me.columns.get(column) || me.columns.getById(column) || me.columns.getAt(column);

    if (column) {
      // Get the current column header element.
      const columnHeaderElement = me.header.getHeader(column.id);

      if (columnHeaderElement) {
        return scroller.scrollIntoView(_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(columnHeaderElement, null, true), options);
      }
    }
  } //endregion
  //region Rows

  /**
   * Creates elements for the new rows when RowManager has determined that more rows are needed
   * @private
   */


  onAddRow({
    rows
  }) {
    const me = this,
          config = me.rowElementConfig,
          frag = document.createDocumentFragment();
    rows.forEach(row => {
      const rowElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(config);
      frag.appendChild(rowElement);
      row.addElement(me.region, rowElement); // TODO: Stamp the correct width into the cells on creation

      me.fixCellWidths(rowElement);
    });
    me.fixRowWidthsInSafariEdge(); // Put the row elements into the SubGrid en masse.
    // If 2nd param is null, insertBefore appends.

    me.element.insertBefore(frag, me.insertRowsBefore);
  }
  /**
   * Get all row elements for this SubGrid.
   * @property {HTMLElement[]}
   * @readonly
   */


  get rowElements() {
    return this.fromCache('.b-grid-row', true);
  }
  /**
   * Removes all row elements from the subgrids body and empties cache
   * @private
   */


  clearRows() {
    this.emptyCache();
    const all = this.element.querySelectorAll('.b-grid-row'),
          range = document.createRange();

    if (all.length) {
      range.setStartBefore(all[0]);
      range.setEndAfter(all[all.length - 1]);
      range.deleteContents();
    }
  } // only called when RowManager.rowScrollMode = 'dom', which is not intended to be used


  addNewRowElement() {
    const rowElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].append(this.element, this.rowElementConfig);
    this.fixCellWidths(rowElement);
    return rowElement;
  }

  get emptyText() {
    return this._emptyText;
  }

  set emptyText(text) {
    this._emptyText = text;
    this.element.dataset.emptyText = text;
  }

  get store() {
    return this.grid.store;
  }

  get rowManager() {
    var _this$grid;

    return (_this$grid = this.grid) === null || _this$grid === void 0 ? void 0 : _this$grid.rowManager;
  } //endregion
  // region Expand/collapse
  // All usages are commented, uncomment when this is resolved: https://app.assembla.com/spaces/bryntum/tickets/5472


  toggleTransitionClasses(doRemove = false) {
    const me = this,
          grid = me.grid,
          nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)),
          splitter = grid.resolveSplitter(nextRegion);
    nextRegion.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
    nextRegion.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
    me.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
    me.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
    splitter.classList[doRemove ? 'remove' : 'add']('b-grid-splitter-animate');
  }
  /**
   * Get/set collapsed state
   * @property {Boolean}
   */


  get collapsed() {
    return this._collapsed;
  }

  set collapsed(collapsed) {
    if (this.isConfiguring) {
      this._collapsed = collapsed;
    } else {
      if (collapsed) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
  /**
   * Collapses subgrid. If collapsing subgrid is the only one expanded, next subgrid to the right (or previous) will
   * be expanded.
   *
   * @example
   * let locked = grid.getSubGrid('locked');
   * locked.collapse().then(() => {
   *     console.log(locked.collapsed); // Logs 'True'
   * });
   *
   * let normal = grid.getSubGrid('normal');
   * normal.collapse().then(() => {
   *     console.log(locked.collapsed); // Logs 'False'
   *     console.log(normal.collapsed); // Logs 'True'
   * });
   *
   * @async
   * @returns {Promise} A Promise which resolves when this SubGrid is fully collapsed.
   */


  async collapse() {
    const me = this,
          grid = me.grid,
          nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)),
          splitterOwner = me.splitterElement ? me : me.previousSibling; // Count all expanded regions. Grid must have always have at least one expanded

    let expandedRegions = 0;
    grid.eachSubGrid(subGrid => {
      subGrid !== me && !subGrid._collapsed && ++expandedRegions;
    }); // Current region is the only one expanded, expand next region

    if (expandedRegions === 0) {
      // expandPromise = nextRegion.expand();
      await nextRegion.expand();
    }

    return new Promise(resolve => {
      if (!me._beforeCollapseState) {
        me._beforeCollapseState = {};
        let widthChanged = false; // If current width is zero, the resize event will not be fired. In such case we want to trigger callback immediately

        if (me.width) {
          widthChanged = true; // Toggle transition classes here, we will actually change width below
          // me.toggleTransitionClasses();
          // afterinternalresize event is buffered, it will be fired only once after animation is finished
          // and element size is final

          me.on({
            afterinternalresize: () => {
              // me.toggleTransitionClasses(true);
              resolve(me);
            },
            thisObj: me,
            once: true
          });
        } // When trying to collapse region we need its partner to occupy free space. Considering multiple
        // regions, several cases are possible:
        // 1) Both left and right regions have fixed width
        // 2) Left region has fixed width, right region is flexed
        // 3) Left region is flexed, right region has fixed width
        // 4) Both regions are flexed
        //
        // To collapse flexed region we need to remove flex style, remember it somehow and set fixed width.
        // If another region is flexed, it will fill the space. If it has fixed width, we need to increase
        // its width by collapsing region width. Same logic should be applied to headers.
        //
        // Save region width first


        me._beforeCollapseState.width = me.width;
        me._beforeCollapseState.elementWidth = me.element.style.width; // Next region is not flexed, need to make it fill the space

        if (nextRegion.element.style.flex === '') {
          me._beforeCollapseState.nextRegionWidth = nextRegion.width;
          nextRegion.width += me._beforeCollapseState.width;
        } // Current region is flexed, store style to restore on expand


        if (me.element.style.flex !== '') {
          me._beforeCollapseState.flex = me.element.style.flex; // remove flex state to reduce width later

          me.header.element.style.flex = me.element.style.flex = '';
        } // Sets the grid to its collapsed width as defined in SASS: zero


        me.element.classList.add('b-grid-subgrid-collapsed'); // The parallel elements which must be in sync width-wise must know about collapsing

        me.virtualScrollerElement.classList.add('b-collapsed');
        me.header.element.classList.add('b-collapsed');
        me.footer.element.classList.add('b-collapsed');
        me._collapsed = true;
        me.width = '';

        if (!widthChanged) {
          // sync splitters in case subGrid was collapsed by state (https://github.com/bryntum/support/issues/1857)
          me.syncParallelSplitters(true);
          resolve(false);
        }
      }
    }).then(value => {
      if (!me.isDestroyed) {
        if (value !== false) {
          var _splitterOwner$startS;

          me.syncParallelSplitters(true); // Our splitter is permanently visible when collapsed, so keep splitter button set
          // synced in the vertical centre of the view just in time for paint.
          // Uses translateY so will not cause a further layout.

          (_splitterOwner$startS = splitterOwner.startSplitterButtonSyncing) === null || _splitterOwner$startS === void 0 ? void 0 : _splitterOwner$startS.call(splitterOwner);
        }

        me.grid.trigger('subGridCollapse', {
          subGrid: me
        });
      }
    });
  }
  /**
   * Expands subgrid.
   *
   * @example
   * grid.getSubGrid('locked').expand().then(() => console.log('locked grid expanded'));
   *
   * @async
   * @returns {Promise} A Promise which resolves when this SubGrid is fully expanded.
   */


  async expand() {
    const me = this,
          grid = me.grid,
          nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)),
          splitterOwner = me.splitterElement ? me : me.previousSibling;
    return new Promise(resolve => {
      if (me._beforeCollapseState != null) {
        // If current width matches width expected after expand resize event will not be fired. In such case
        // we want to trigger callback immediately
        let widthChanged = false; // See similar clause in collapse method above

        if (me.width !== me._beforeCollapseState.elementWidth) {
          widthChanged = true; // Toggle transition classes here, we will actually change width below
          // me.toggleTransitionClasses();

          me.on({
            afterinternalresize: () => {
              // me.toggleTransitionClasses(true);
              // Delay the resolve to avoid "ResizeObserver loop limit exceeded" errors
              // collapsing the only expanded region and it has to expand its nextRegion
              // before it can collapse.
              me.setTimeout(() => resolve(me), 10);
            },
            thisObj: me,
            once: true
          });
        } // previous region is not flexed, reduce its width as it was increased in collapse


        if (nextRegion.element.style.flex === '') {
          nextRegion.width = me._beforeCollapseState.nextRegionWidth;
        }

        me.element.classList.remove('b-grid-subgrid-collapsed');
        me._collapsed = false; // The parallel elements which must be in sync width-wise must know about collapsing

        me.virtualScrollerElement.classList.remove('b-collapsed');
        me.header.element.classList.remove('b-collapsed');
        me.footer.element.classList.remove('b-collapsed'); // This region used to be flex, let's restore it

        if (me._beforeCollapseState.flex) {
          // Always restore width, restoring flex wont trigger resize otherwise
          me.width = me._beforeCollapseState.width; // Widget flex setting clears style width

          me.header.flex = me.flex = me._beforeCollapseState.flex;
          me.footer.flex = me._beforeCollapseState.flex;
          me._width = null;
        } else {
          me.width = me._beforeCollapseState.elementWidth;
        }

        me.element.classList.remove('b-grid-subgrid-collapsed');
        me._collapsed = false;

        if (!widthChanged) {
          resolve(false);
        }

        delete me._beforeCollapseState;
      }
    }).then(value => {
      if (value !== false) {
        // Our splitter is hidden when expanded, so we no longer need to keep splitter button set
        // synced in the vertical centre of the view.
        splitterOwner.stopSplitterButtonSyncing();
        me.syncParallelSplitters(false);
        me.grid.trigger('subGridExpand', {
          subGrid: me
        });
      }
    });
  } //endregion


} // Register this widget type with its Factory

SubGrid.initClass();
SubGrid._$name = 'SubGrid';

/***/ }),

/***/ "./lib/Grid/view/TreeGrid.js":
/*!***********************************!*\
  !*** ./lib/Grid/view/TreeGrid.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TreeGrid; });
/* harmony import */ var _Grid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony import */ var _feature_Tree_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony import */ var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
var productName = 'gantt';
 // tree feature will be added by default to TreeGrid, but needs to be imported

 // not used here but enables using `type : tree` in a column config (exactly one required)


/**
 * @module Grid/view/TreeGrid
 */

/**
 * A TreeGrid, a Tree combined with a Grid. Must be configured with exactly one {@link Grid.column.TreeColumn} (`type: tree`), but can also have an
 * arbitrary number of other columns. Most features that can be used with Grid also works with TreeGrid, with the
 * exception of the Group feature.
 * @extends Grid/view/Grid
 *
 * @classtype treegrid
 * @inlineexample Grid/view/TreeGrid.js
 */

class TreeGrid extends _Grid_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TreeGrid';
  } // Factoryable type name


  static get type() {
    return 'treegrid';
  }

  static get configurable() {
    return {
      /**
       * The store instance or config object that holds the records to be displayed by this TreeGrid. If assigning
       * a store instance, it must be configured with `tree: true`.
       *
       * A store will be created if none is specified.
       * @config {Core.data.Store|Object} store
       * @category Common
       */
      store: {
        tree: true
      }
    };
  } //region Plugged in functions / inherited configs

  /**
   * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
   *
   * @function toggleCollapse
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
   * @param {Boolean} [collapse] Force collapse (true) or expand (false)
   * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Collapse a single node.
   *
   * @function collapse
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Expand a single node.
   *
   * @function expand
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
   * @returns {Promise}
   * @category Feature shortcuts
   */

  /**
   * Expands parent nodes to make this node "visible".
   *
   * @function expandTo
   * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
   * @returns {Promise}
   * @category Feature shortcuts
   */
  //endregion

  /* disconnect doc comment */
  //region Store


  updateStore(store, was) {
    if (store && !store.tree) {
      throw new Error('TreeGrid requires a Store configured with tree : true');
    }

    super.updateStore(store, was);
  } //endregion


} // Register this widget type with its Factory

TreeGrid.initClass();
TreeGrid._$name = 'TreeGrid';

/***/ }),

/***/ "./lib/Grid/view/export/ExportDialog.js":
/*!**********************************************!*\
  !*** ./lib/Grid/view/export/ExportDialog.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportDialog; });
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./field/ExportRowsCombo.js */ "./lib/Grid/view/export/field/ExportRowsCombo.js");
/* harmony import */ var _field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./field/ExportOrientationCombo.js */ "./lib/Grid/view/export/field/ExportOrientationCombo.js");
/* harmony import */ var _field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
var productName = 'gantt';









function buildComboItems(obj, fn = x => x) {
  return Object.keys(obj).map(key => ({
    id: key,
    text: fn(key)
  }));
}
/**
 * @module Grid/view/export/ExportDialog
 */

/**
 * Dialog window used by the {@link Grid.feature.export.PdfExport pdf export feature}. It allows users to select export
 * options like paper format and columns to export. This dialog contains a number of predefined
 * {@link Core.widget.Field fields} which you can access through the popup's {@link #property-widgetMap}.
 *
 * ## Default widgets
 *
 * The default widgets of this dialog are:
 *
 * | Widget ref             | Type                                     | Weight | Description                                          |
 * |------------------------|------------------------------------------|--------|----------------------------------------------------- |
 * | `columnsField`         | {@link Core.widget.Combo Combo}          | 100    | Choose columns to export                             |
 * | `rowsRangeField`       | {@link Core.widget.Combo Combo}          | 200    | Choose which rows to export                          |
 * | `exporterTypeField`    | {@link Core.widget.Combo Combo}          | 300    | Type of the exporter to use                          |
 * | `alignRowsField`       | {@link Core.widget.Checkbox Checkbox}    | 400    | Align row top to the page top on every exported page |
 * | `repeatHeaderField`    | {@link Core.widget.Checkbox Checkbox}    | 500    | Toggle repeating headers on / off                    |
 * | `fileFormatField`      | {@link Core.widget.Combo Combo}          | 600    | Choose file format                                   |
 * | `paperFormatField`     | {@link Core.widget.Combo Combo}          | 700    | Choose paper format                                  |
 * | `orientationField`     | {@link Core.widget.Combo Combo}          | 800    | Choose orientation                                   |
 *
 * The default buttons are:
 *
 * | Widget ref             | Type                                     | Weight | Description                                          |
 * |------------------------|------------------------------------------|--------|------------------------------------------------------|
 * | `exportButton`         | {@link Core.widget.Button Button}        | 100    | Triggers export                                      |
 * | `cancelButton`         | {@link Core.widget.Button Button}        | 200    | Cancel export                                        |
 *
 * Bottom buttons may be customized using `bbar` config passed to `exportDialog`:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             editorConfig : {
 *                 bbar : {
 *                     items : {
 *                         exportButton : { text : 'Go!' }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 *
 * ## Configuring default widgets
 *
 * Widgets can be customized with {@link Grid.feature.export.PdfExport#config-exportDialog} config:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 items : {
 *                     // hide the field
 *                     orientationField  : { hidden : true },
 *
 *                     // reorder fields
 *                     exporterTypeField : { weight : 150 },
 *
 *                     // change default format in exporter
 *                     fileFormatField   : { value : 'png' }
 *                 }
 *             }
 *         }
 *     }
 * });
 *
 * grid.features.pdfExport.showExportDialog();
 * ```
 *
 * ## Configuring default columns
 *
 * By default all visible columns are selected in the export dialog. This is managed by the
 * {@link #config-autoSelectVisibleColumns} config. To change default selected columns you should disable this config
 * and set field value. Value should be an array of valid column ids (or column instances). This way you can
 * preselect hidden columns:
 *
 * ```javascript
 * const grid = new Grid({
 *     columns : [
 *         { id : 'name', text : 'Name', field : 'name' },
 *         { id : 'age', text : 'Age', field : 'age' },
 *         { id : 'city', text : 'City', field : 'city', hidden : true }
 *     ],
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 autoSelectVisibleColumns : false,
 *                 items : {
 *                     columnsField : { value : ['name', 'city'] }
 *                 }
 *             }
 *         }
 *     }
 * })
 *
 * // This will show export dialog with Name and City columns selected
 * // even though City column is hidden in the UI
 * grid.features.pdfExport.showExportDialog();
 * ```
 *
 * ## Adding fields
 *
 * You can add your own fields to the export dialog. To make such field value acessible to the feature it should follow
 * a specific naming pattern - it should have `ref` config ending with `Field`, see other fields for reference -
 * `orientationField`, `columnsField`, etc. Fields not matching this pattern are ignored. When values are collected from
 * the dialog, `Field` part of the widget reference is removed, so `orientationField` becomes `orientation`, `fooField`
 * becomes `foo`, etc.
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 items : {
 *                     // This field gets into export config
 *                     fooField : {
 *                         type : 'text',
 *                         label : 'Foo',
 *                         value : 'FOO'
 *                     },
 *
 *                     // This one does not, because name doesn't end with `Field`
 *                     bar : {
 *                         type : 'text',
 *                         label : 'Bar',
 *                         value : 'BAR'
 *                     },
 *
 *                     // Add a container widget to wrap some fields together
 *                     myContainer : {
 *                         type : 'container',
 *                         items : {
 *                             // This one gets into config too despite the nesting level
 *                             bazField : {
 *                                 type : 'text',
 *                                 label : 'Baz',
 *                                 value : 'BAZ'
 *                             }
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 *
 * // Assuming export dialog is opened and export triggered with default values
 * // you can receive custom field values here
 * grid.on({
 *     beforeExport({ config }) {
 *         console.log(config.foo) // 'FOO'
 *         console.log(config.bar) // undefined
 *         console.log(config.baz) // 'BAZ'
 *     }
 * });
 * ```
 *
 * ## Configuring widgets at runtime
 *
 * If you don't know column ids before grid instantiation or you want a flexible config, you can change widget values
 * before dialog pops up:
 *
 * ```javascript
 * const grid = new Grid({
 *     columns : [
 *         { id : 'name', text : 'Name', field : 'name' },
 *         { id : 'age', text : 'Age', field : 'age' },
 *         { id : 'city', text : 'City', field : 'city', hidden : true }
 *     ],
 *     features : {
 *         pdfExport : true
 *     }
 * });
 *
 * // Such listener would ignore autoSelectVisibleColumns config. Similar to the snippet
 * // above this will show Name and City columns
 * grid.features.pdfExport.exportDialog.on({
 *     beforeShow() {
 *         this.widgetMap.columnsField.value = ['age', 'city']
 *     }
 * });
 * ```
 *
 * @extends Core/widget/Popup
 */


class ExportDialog extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ExportDialog';
  }

  static get type() {
    return 'exportdialog';
  }

  static get configurable() {
    return {
      autoShow: false,
      autoClose: false,
      closable: true,
      centered: true,

      /**
       * Returns map of values of dialog fields.
       * @member {Object} values
       * @readonly
       */

      /**
       * Grid instance to build export dialog for
       * @config {Grid.view.Grid}
       */
      client: null,

      /**
       * Set to `false` to not preselect all visible columns when the dialog is shown
       * @config {Boolean}
       */
      autoSelectVisibleColumns: true,

      /**
       * Set to `false` to allow using PNG + Multipage config in export dialog
       * @config {Boolean}
       */
      hidePNGMultipageOption: true,
      title: 'L{exportSettings}',
      defaults: {
        localeClass: this
      },
      items: {
        columnsField: {
          type: 'combo',
          label: 'L{ExportDialog.columns}',
          store: {},
          valueField: 'id',
          displayField: 'text',
          multiSelect: true,
          weight: 100
        },
        rowsRangeField: {
          type: 'exportrowscombo',
          label: 'L{ExportDialog.rows}',
          value: 'all',
          weight: 200
        },
        exporterTypeField: {
          type: 'localizablecombo',
          label: 'L{ExportDialog.exporterType}',
          editable: false,
          value: 'singlepage',
          buildLocalizedItems: function () {
            const dialog = this.parent;
            return dialog.exporters.map(exporter => ({
              id: exporter.type,
              text: dialog.optionalL(exporter.title, this)
            }));
          },

          onChange({
            value
          }) {
            this.owner.widgetMap.alignRowsField.hidden = value === 'singlepage';
            this.owner.widgetMap.repeatHeaderField.hidden = value !== 'multipagevertical';
          },

          weight: 300
        },
        alignRowsField: {
          type: 'checkbox',
          label: 'L{ExportDialog.alignRows}',
          checked: false,
          hidden: true,
          weight: 400
        },
        repeatHeaderField: {
          type: 'checkbox',
          label: 'L{ExportDialog.repeatHeader}',
          localeClass: this,
          hidden: true,
          weight: 500
        },
        fileFormatField: {
          type: 'combo',
          label: 'L{ExportDialog.fileFormat}',
          localeClass: this,
          editable: false,
          value: 'pdf',
          items: [],

          onChange({
            value,
            oldValue
          }) {
            const dialog = this.parent;

            if (dialog.hidePNGMultipageOption) {
              const exporterField = dialog.widgetMap.exporterTypeField,
                    exporter = exporterField.store.find(r => r.id === 'singlepage');

              if (value === _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_5__["FileFormat"].png && exporter) {
                this._previousDisabled = exporterField.disabled;
                exporterField.disabled = true;
                this._previousValue = exporterField.value;
                exporterField.value = 'singlepage';
              } else if (oldValue === _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_5__["FileFormat"].png && this._previousValue) {
                exporterField.disabled = this._previousDisabled;
                exporterField.value = this._previousValue;
              }
            }
          },

          weight: 600
        },
        paperFormatField: {
          type: 'combo',
          label: 'L{ExportDialog.paperFormat}',
          editable: false,
          value: 'A4',
          items: [],
          weight: 700
        },
        orientationField: {
          type: 'exportorientationcombo',
          label: 'L{ExportDialog.orientation}',
          value: 'portrait',
          weight: 800
        }
      },
      bbar: {
        defaults: {
          localeClass: this
        },
        items: {
          exportButton: {
            color: 'b-green',
            text: 'L{ExportDialog.export}',
            weight: 100,
            onClick: 'up.onExportClick'
          },
          cancelButton: {
            color: 'b-gray',
            text: 'L{ExportDialog.cancel}',
            weight: 200,
            onClick: 'up.onCancelClick'
          }
        }
      }
    };
  } //endregion


  construct(config = {}) {
    const me = this,
          {
      client
    } = config;

    if (!client) {
      throw new Error('`client` config is required');
    }

    me.columnsStore = client.columns.chain(column => column.isLeaf && column.exportable);
    me.applyInitialValues(config);
    super.construct(config);
    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
      locale: 'onLocaleChange',
      prio: -1,
      thisObj: me
    });
  }

  applyInitialValues(config) {
    const me = this,
          items = config.items = config.items || {};
    config.width = config.width || me.L('L{width}');
    config.defaults = config.defaults || {};
    config.defaults.labelWidth = config.defaults.labelWidth || me.L('L{ExportDialog.labelWidth}');
    items.columnsField = items.columnsField || {};
    items.fileFormatField = items.fileFormatField || {};
    items.paperFormatField = items.paperFormatField || {};
    items.fileFormatField.items = buildComboItems(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_5__["FileFormat"], value => value.toUpperCase());
    items.paperFormatField.items = buildComboItems(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_5__["PaperFormat"]);
    items.columnsField.store = me.columnsStore;
  }

  onBeforeShow() {
    var _super$onBeforeShow;

    const {
      columnsField,
      alignRowsField,
      exporterTypeField,
      repeatHeaderField
    } = this.widgetMap;

    if (this.autoSelectVisibleColumns) {
      columnsField.value = this.columnsStore.query(c => !c.hidden);
    }

    alignRowsField.hidden = exporterTypeField.value === 'singlepage';
    repeatHeaderField.hidden = exporterTypeField.value !== 'multipagevertical';
    (_super$onBeforeShow = super.onBeforeShow) === null || _super$onBeforeShow === void 0 ? void 0 : _super$onBeforeShow.call(this, ...arguments);
  }

  onLocaleChange() {
    const labelWidth = this.L('L{labelWidth}');
    this.width = this.L('L{width}');
    this.eachWidget(widget => {
      if (widget instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
        widget.labelWidth = labelWidth;
      }
    });
  }

  onExportClick() {
    const values = this.values;
    /**
     * Fires when export button is clicked
     * @event export
     * @param {Object} values Object containing config for {@link Grid.feature.export.PdfExport#function-export export()} method
     * @category Export
     */

    this.trigger('export', {
      values
    });
  }

  onCancelClick() {
    /**
     * Fires when cancel button is clicked. Popup will hide itself.
     * @event cancel
     * @category Export
     */
    this.trigger('cancel');
    this.hide();
  }

  get values() {
    const fieldRe = /field/i,
          result = {};
    this.eachWidget(widget => {
      if (fieldRe.test(widget.ref)) {
        result[widget.ref.replace(fieldRe, '')] = widget instanceof _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_6__["default"] ? widget.checked : widget.value;
      }
    });
    return result;
  }

}
ExportDialog.initClass();
ExportDialog._$name = 'ExportDialog';

/***/ }),

/***/ "./lib/Grid/view/export/field/ExportOrientationCombo.js":
/*!**************************************************************!*\
  !*** ./lib/Grid/view/export/field/ExportOrientationCombo.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportOrientationCombo; });
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
var productName = 'gantt';


class ExportOrientationCombo extends _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'ExportOrientationCombo';
  } // Factoryable type name


  static get type() {
    return 'exportorientationcombo';
  }

  static get defaultConfig() {
    return {
      editable: false
    };
  } //endregion


  buildLocalizedItems() {
    const me = this;
    return [{
      id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__["Orientation"].portrait,
      text: me.L('L{portrait}')
    }, {
      id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__["Orientation"].landscape,
      text: me.L('L{landscape}')
    }];
  }

} // Register this widget type with its Factory

ExportOrientationCombo.initClass();
ExportOrientationCombo._$name = 'ExportOrientationCombo';

/***/ }),

/***/ "./lib/Grid/view/export/field/ExportRowsCombo.js":
/*!*******************************************************!*\
  !*** ./lib/Grid/view/export/field/ExportRowsCombo.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportRowsCombo; });
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
var productName = 'gantt';


class ExportRowsCombo extends _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'ExportRowsCombo';
  } // Factoryable type name


  static get type() {
    return 'exportrowscombo';
  }

  static get defaultConfig() {
    return {
      editable: false
    };
  } //endregion


  buildLocalizedItems() {
    const me = this;
    return [{
      id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__["RowsRange"].all,
      text: me.L('L{all}')
    }, {
      id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__["RowsRange"].visible,
      text: me.L('L{visible}')
    }];
  }

} // Register this widget type with its Factory

ExportRowsCombo.initClass();
ExportRowsCombo._$name = 'ExportRowsCombo';

/***/ }),

/***/ "./lib/Grid/view/export/field/LocalizableCombo.js":
/*!********************************************************!*\
  !*** ./lib/Grid/view/export/field/LocalizableCombo.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LocalizableCombo; });
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';


class LocalizableCombo extends Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_0__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'LocalizableCombo';
  } // Factoryable type name


  static get type() {
    return 'localizablecombo';
  }

} // Register this widget type with its Factory

LocalizableCombo.initClass();
LocalizableCombo._$name = 'LocalizableCombo';

/***/ }),

/***/ "./lib/Grid/view/mixin/GridElementEvents.js":
/*!**************************************************!*\
  !*** ./lib/Grid/view/mixin/GridElementEvents.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'gantt'; // We declare consts inside case blocks in this file.

/* eslint-disable no-case-declarations */
//TODO: Should it fire more own events instead and rely less on function chaining?









const gridBodyElementEventHandlers = {
  touchstart: 'onElementTouchStart',
  touchmove: 'onElementTouchMove',
  touchend: 'onElementTouchEnd',
  mouseover: 'onElementMouseOver',
  mouseout: 'onElementMouseOut',
  mousedown: 'onElementMouseDown',
  mousemove: 'onElementMouseMove',
  mouseup: 'onElementMouseUp',
  click: 'onHandleElementClick',
  dblclick: 'onElementDblClick',
  keydown: 'onElementKeyDown',
  keyup: 'onElementKeyUp',
  keypress: 'onElementKeyPress',
  contextmenu: 'onElementContextMenu'
};
/**
 * @module Grid/view/mixin/GridElementEvents
 */

/**
 * Mixin for Grid that handles dom events. Some listeners fire own events but all can be chained by features. None of
 * the functions in this class are indented to be called directly.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridElementEvents extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridElementEvents';
  } //region Config


  static get configurable() {
    return {
      /**
       * Time in ms until a longpress is triggered
       * @config {Number}
       * @default
       * @category Events
       */
      longPressTime: 400,

      /**
       * Set to true to listen for CTRL-Z (CMD-Z on Mac OS) keyboard event and trigger undo (redo when SHIFT is pressed).
       * Only applicable when using a {@link Core.data.stm.StateTrackingManager}.
       * @config {Boolean}
       * @default
       * @category Events
       */
      enableUndoRedoKeys: true
    };
  } //endregion
  //region Events

  /**
   * Fired when user clicks in a grid cell
   * @event cellClick
   * @param {Grid.view.Grid} grid The grid instance
   * @param {Core.data.Model} record The record representing the row
   * @param {Grid.column.Column} column The column to which the cell belongs
   * @param {HTMLElement} cellElement The cell HTML element
   * @param {HTMLElement} target The target element
   * @param {MouseEvent} event The native DOM event
   */

  /**
   * Fired when user double clicks a grid cell
   * @event cellDblClick
   * @param {Grid.view.Grid} grid The grid instance
   * @param {Core.data.Model} record The record representing the row
   * @param {Grid.column.Column} column The column to which the cell belongs
   * @param {HTMLElement} cellElement The cell HTML element
   * @param {HTMLElement} target The target element
   * @param {MouseEvent} event The native DOM event
   */

  /**
   * Fired when user activates contextmenu in a grid cell
   * @event cellContextMenu
   * @param {Grid.view.Grid} grid The grid instance
   * @param {Core.data.Model} record The record representing the row
   * @param {Grid.column.Column} column The column to which the cell belongs
   * @param {HTMLElement} cellElement The cell HTML element
   * @param {HTMLElement} target The target element
   * @param {MouseEvent} event The native DOM event
   */

  /**
   * Fired when user moves the mouse over a grid cell
   * @event cellMouseOver
   * @param {Grid.view.Grid} grid The grid instance
   * @param {Core.data.Model} record The record representing the row
   * @param {Grid.column.Column} column The column to which the cell belongs
   * @param {HTMLElement} cellElement The cell HTML element
   * @param {HTMLElement} target The target element
   * @param {MouseEvent} event The native DOM event
   */

  /**
   * Fired when a user moves the mouse out of a grid cell
   * @event cellMouseOut
   * @param {Grid.view.Grid} grid The grid instance
   * @param {Core.data.Model} record The record representing the row
   * @param {Grid.column.Column} column The column to which the cell belongs
   * @param {HTMLElement} cellElement The cell HTML element
   * @param {HTMLElement} target The target element
   * @param {MouseEvent} event The native DOM event
   */
  //endregion
  //region Event handling

  /**
   * Init listeners for a bunch of dom events. All events are handled by handleEvent().
   * @private
   * @category Events
   */


  initInternalEvents() {
    const handledEvents = Object.keys(gridBodyElementEventHandlers),
          len = handledEvents.length,
          listeners = {
      element: this.bodyElement,
      thisObj: this
    }; // Route all events through handleEvent, so that we can capture this.event
    // before we route to the handlers

    for (let i = 0; i < len; i++) {
      listeners[handledEvents[i]] = 'handleEvent';
    }

    _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on(listeners);
    _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      focus: 'onGridElementFocus',
      element: this.focusElement,
      thisObj: this
    });
  }
  /**
   * This method finds the cell location of the passed event. It returns an object describing the cell.
   * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
   * @returns {Object} An object containing the following properties:
   * - `cellElement` - The cell element clicked on.
   * - `column` - The {@link Grid.column.Column column} clicked under.
   * - `columnId` - The `id` of the {@link Grid.column.Column column} clicked under.
   * - `record` - The {@link Core.data.Model record} clicked on.
   * - `id` - The `id` of the {@link Core.data.Model record} clicked on.
   * @internal
   * @category Events
   */


  getCellDataFromEvent(event) {
    const me = this,
          cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, '.b-grid-cell'); // There is a cell

    if (cellElement) {
      const cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(cellElement),
            {
        id,
        columnId
      } = cellData,
            record = me.store.getById(id),
            column = me.columns.getById(columnId); // Row might not have a record, since we transition record removal
      // https://app.assembla.com/spaces/bryntum/tickets/6805

      return record ? {
        cellElement,
        cellData,
        columnId,
        id,
        record,
        column,
        cellSelector: {
          id,
          columnId
        }
      } : null;
    }
  }
  /**
   * This method finds the header location of the passed event. It returns an object describing the header.
   * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
   * @returns {Object} An object containing the following properties:
   * - `headerElement` - The header element clicked on.
   * - `column` - The {@link Grid.column.Column column} clicked under.
   * - `columnId` - The `id` of the {@link Grid.column.Column column} clicked under.
   * @internal
   * @category Events
   */


  getHeaderDataFromEvent(event) {
    const headerElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, '.b-grid-header'); // There is a header

    if (headerElement) {
      const headerData = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({}, headerElement.dataset),
            {
        columnId
      } = headerData,
            column = this.columns.getById(columnId);
      return column ? {
        headerElement,
        headerData,
        columnId,
        column
      } : null;
    }
  }
  /**
   * Handles all dom events, routing them to correct functions (touchstart -> onElementTouchStart)
   * @param event
   * @private
   * @category Events
   */


  handleEvent(event) {
    if (!this.disabled) {
      if (gridBodyElementEventHandlers[event.type]) {
        this[gridBodyElementEventHandlers[event.type]](event);
      }
    }
  } //endregion
  //region Touch events

  /**
   * Touch start, chain this function in features to handle the event.
   * @param event
   * @category Touch events
   * @internal
   */


  onElementTouchStart(event) {
    const me = this,
          cellData = me.getCellDataFromEvent(event);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchEvent = true;

    if (event.touches.length === 1) {
      me.longPressTimeout = me.setTimeout(() => {
        me.onElementLongPress(event);
        event.preventDefault();
        me.longPressPerformed = true;
      }, me.longPressTime);
    }

    if (cellData && !event.defaultPrevented) {
      me.onFocusGesture(cellData, event);
    }
  }
  /**
   * Touch move, chain this function in features to handle the event.
   * @param event
   * @category Touch events
   * @internal
   */


  onElementTouchMove(event) {
    const me = this;

    if (me.longPressTimeout) {
      me.clearTimeout(me.longPressTimeout);
      me.longPressTimeout = null;
    }
  }
  /**
   * Touch end, chain this function in features to handle the event.
   * @param event
   * @category Touch events
   * @internal
   */


  onElementTouchEnd(event) {
    const me = this;

    if (me.longPressPerformed) {
      if (event.cancelable) {
        event.preventDefault();
      }

      me.longPressPerformed = false;
    }

    if (me.longPressTimeout) {
      me.clearTimeout(me.longPressTimeout);
      me.longPressTimeout = null;
    }
  }

  onElementLongPress(event) {} //endregion
  //region Mouse events
  // Trigger events in same style when clicking, dblclicking and for contextmenu


  triggerCellMouseEvent(name, event) {
    const me = this,
          cellData = me.getCellDataFromEvent(event); // There is a cell

    if (cellData) {
      const column = me.columns.getById(cellData.columnId),
            eventData = {
        grid: me,
        record: cellData.record,
        column,
        cellSelector: cellData.cellSelector,
        cellElement: cellData.cellElement,
        target: event.target,
        event
      };
      me.trigger('cell' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].capitalize(name), eventData);

      if (name === 'click') {
        var _column$onCellClick;

        (_column$onCellClick = column.onCellClick) === null || _column$onCellClick === void 0 ? void 0 : _column$onCellClick.call(column, eventData);
      }
    }
  }
  /**
   * Mouse down, chain this function in features to handle the event.
   * @param event
   * @category Mouse events
   * @internal
   */


  onElementMouseDown(event) {
    const me = this,
          cellData = me.getCellDataFromEvent(event);
    me.skipFocusSelection = true; // If click was on a scrollbar, preventDefault to not steal focus

    if (me.isScrollbarClick(event)) {
      event.preventDefault();
    } else {
      me.triggerCellMouseEvent('mousedown', event); // Browser event unification fires a mousedown on touch tap prior to focus.

      if (cellData && !event.defaultPrevented) {
        me.onFocusGesture(cellData, event);
      }
    }
  }

  isScrollbarClick({
    target,
    x,
    y
  }) {
    if (target.matches('.b-vertical-overflow')) {
      const rect = target.getBoundingClientRect();
      return x > rect.right - _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollBarWidth;
    } else if (target.matches('.b-horizontal-overflow')) {
      const rect = target.getBoundingClientRect();
      return y > rect.bottom - _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollBarWidth;
    }
  }
  /**
   * Mouse move, chain this function in features to handle the event.
   * @param event
   * @category Mouse events
   * @internal
   */


  onElementMouseMove(event) {
    // Keep track of the last mouse position in case, due to OSX sloppy focusing,
    // focus is moved into the browser before a mousedown is delivered.
    // The cached mousemove event will provide the correct target in
    // GridNavigation#onGridElementFocus.
    this.mouseMoveEvent = event;
  }
  /**
   * Mouse up, chain this function in features to handle the event.
   * @param event
   * @category Mouse events
   * @internal
   */


  onElementMouseUp(event) {}
  /**
   * Called before {@link #function-onElementClick}.
   * Fires 'beforeElementClick' event which can return false to cancel further onElementClick actions.
   * @param event
   * @fires beforeElementClick
   * @category Mouse events
   * @internal
   */


  onHandleElementClick(event) {
    if (this.trigger('beforeElementClick', {
      event
    }) !== false) {
      this.onElementClick(event);
    }
  }
  /**
   * Click, select cell on click and also fire 'cellClick' event.
   * Chain this function in features to handle the dom event.
   * @param event
   * @fires cellClick
   * @category Mouse events
   * @internal
   */


  onElementClick(event) {
    const me = this,
          cellData = me.getCellDataFromEvent(event); // There is a cell

    if (cellData) {
      me.triggerCellMouseEvent('click', event); // Clear hover styling when clicking in a row to avoid having it stick around if you keyboard navigate
      // away from it
      // https://app.assembla.com/spaces/bryntum/tickets/5848

      _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(cellData.cellElement).row.removeCls('b-hover');
    }
  }

  onFocusGesture(cellData, event) {
    //TODO: should be able to cancel focusCell from listeners
    if (cellData && !event.target.matches('.b-icon-tree-expand, .b-icon-tree-collapse')) {
      this.focusCell(cellData.cellSelector, {
        scroll: false,
        doSelect: true,
        event
      });
    }
  }
  /**
   * Double click, fires 'cellDblClick' event.
   * Chain this function in features to handle the dom event.
   * @param {Event} event
   * @fires cellDblClick
   * @category Mouse events
   * @internal
   */


  onElementDblClick(event) {
    const {
      target
    } = event;
    this.triggerCellMouseEvent('dblClick', event);

    if (target.classList.contains('b-grid-header-resize-handle')) {
      const header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(target, '.b-grid-header'),
            column = this.columns.getById(header.dataset.columnId);
      column.resizeToFitContent();
    }
  }
  /**
   * Mouse over, adds 'hover' class to elements.
   * @param event
   * @fires mouseOver
   * @category Mouse events
   * @internal
   */


  onElementMouseOver(event) {
    // bail out early if scrolling
    if (!this.scrolling) {
      const cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, '.b-grid-cell');

      if (cellElement) {
        const row = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(cellElement).row; // No hover effect needed if a mouse button is pressed (like when resizing window, region, or resizing something etc).
        // NOTE: 'buttons' not supported in Safari

        if (row && (typeof event.buttons !== 'number' || event.buttons === 0)) {
          this.hoveredRow = row;
        }

        this.triggerCellMouseEvent('mouseOver', event);
      }
      /**
       * Mouse moved in over element in grid
       * @event mouseOver
       * @param {MouseEvent} event The native browser event
       */


      this.trigger('mouseOver', {
        event
      });
    }
  }
  /**
   * Mouse out, removes 'hover' class from elements.
   * @param event
   * @fires mouseOut
   * @category Mouse events
   * @internal
   */


  onElementMouseOut(event) {
    this.hoveredRow = null; // bail out early if scrolling

    if (!this.scrolling) {
      const cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, '.b-grid-cell');

      if (cellElement) {
        this.triggerCellMouseEvent('mouseOut', event);
      }
      /**
       * Mouse moved out from element in grid
       * @event mouseOut
       * @param {MouseEvent} event The native browser event
       */


      this.trigger('mouseOut', {
        event
      });
    }
  }

  set hoveredRow(row) {
    const me = this; // Unhover

    if (me._hoveredRow && !me._hoveredRow.isDestroyed) {
      me._hoveredRow.removeCls('b-hover');

      me._hoveredRow = null;
    } // Hover


    if (row && !me.scrolling) {
      me._hoveredRow = row;
      row.addCls('b-hover');
    }
  } //endregion
  //region Keyboard events

  /**
   * Key down, handles arrow keys for selection.
   * Chain this function in features to handle the dom event.
   * @param event
   * @category Keyboard events
   * @internal
   */


  onElementKeyDown(event) {
    var _me$features$cellEdit;

    const me = this,
          {
      target,
      currentTarget,
      ctrlKey,
      key
    } = event; // flagging event with handled = true used to signal that other features should probably not care about it.
    // for this to work you should specify overrides for onElementKeyDown to be run before this function
    // (see for example CellEdit feature)

    if (event.handled) return; // Read this to refresh cached reference in case this keystroke lead to the removal of current row

    const focusedCell = me.focusedCell,
          stm = me.store.stm;

    if (stm && ctrlKey && key.toLowerCase() === 'z' && me.enableUndoRedoKeys && !((_me$features$cellEdit = me.features.cellEdit) !== null && _me$features$cellEdit !== void 0 && _me$features$cellEdit.isEditing)) {
      stm.onUndoKeyPress(event);
    }

    if (target.matches('.b-grid-header.b-depth-0')) {
      me.handleHeaderKeyDown(event);
    } else if (target === me.focusElement || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isIE11 && currentTarget === me.focusElement) {
      // IE11 Browser check is not placed in EventHelper to maintain built-in delegated functionality
      me.handleViewKeyDown(event); // If a cell is focused and column is interested - call special callback

      if (focusedCell) {
        var _column$onCellKeyDown;

        const cellElement = focusedCell.element,
              column = me.columns.getById(cellElement.dataset.columnId);
        (_column$onCellKeyDown = column.onCellKeyDown) === null || _column$onCellKeyDown === void 0 ? void 0 : _column$onCellKeyDown.call(column, {
          event,
          cellElement
        }); // Trigger column.onCellClick when space bar is pressed

        if (key === ' ' && column.onCellClick) {
          column.onCellClick({
            grid: me,
            column,
            record: me.store.getById(focusedCell.id),
            cellElement,
            target,
            event
          });
        }
      }
    } // If focus is *within* a cell (eg WidgetColumn or CheckColumn), jump up to focus the cell.
    else if (key === 'Escape' && me.isActionableLocation) {
      const focusedCellClone = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clone(focusedCell);
      focusedCellClone.element = null;
      me.focusCell(focusedCellClone);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].focusWithoutScrolling(me.focusElement);
    }
  }

  handleViewKeyDown(event) {
    const me = this;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        return me.navigateLeft(event);

      case 'ArrowRight':
        event.preventDefault();
        return me.navigateRight(event);

      case 'ArrowUp':
        event.preventDefault();
        return me.navigateUp(event);

      case 'ArrowDown':
        event.preventDefault();
        return me.navigateDown(event);
    }
  }

  handleHeaderKeyDown(event) {
    const me = this,
          column = me.columns.getById(event.target.dataset.columnId);
    column.onKeyDown && column.onKeyDown(event);

    switch (event.key) {
      case 'ArrowLeft':
        me.onHeaderLeftKey(column);
        break;

      case 'ArrowRight':
        me.onHeaderRightKey(column);
        break;

      case 'ArrowDown':
        event.preventDefault();
        me.onHeaderDownKey(column);
        break;

      case 'Enter':
        me.onHeaderEnterKey(column);
        break;
    }
  }

  onHeaderLeftKey(column) {
    const prev = this.columns.getAdjacentVisibleLeafColumn(column, false);

    if (prev) {
      this.getHeaderElement(prev.id).focus();
    }
  }

  onHeaderRightKey(column) {
    const next = this.columns.getAdjacentVisibleLeafColumn(column, true);

    if (next) {
      this.getHeaderElement(next.id).focus();
    }
  }

  onHeaderDownKey(column) {
    const row = this.firstFullyVisibleRow;

    if (row) {
      this.focusCell({
        columnId: column.id,
        id: row.id
      });
    }
  }

  onHeaderEnterKey(column) {
    this.getHeaderElement(column.id).click();
  }
  /**
   * Key press, chain this function in features to handle the dom event.
   * @param event
   * @category Keyboard events
   * @internal
   */


  onElementKeyPress(event) {}
  /**
   * Key up, chain this function in features to handle the dom event.
   * @param event
   * @category Keyboard events
   * @internal
   */


  onElementKeyUp(event) {} //endregion
  //region Other events

  /**
   * Context menu, chain this function in features to handle the dom event.
   * In most cases, include ContextMenu feature instead.
   * @param event
   * @category Other events
   * @internal
   */


  onElementContextMenu(event) {
    const me = this,
          cellData = me.getCellDataFromEvent(event); // There is a cell

    if (cellData) {
      me.triggerCellMouseEvent('contextMenu', event); // Focus on tap for touch events.
      // Selection follows from focus.

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchEvent) {
        me.onFocusGesture(cellData, event);
      }
    }
  }
  /**
   * Overrides empty base function in View, called when view is resized.
   * @fires resize
   * @param element
   * @param width
   * @param height
   * @param oldWidth
   * @param oldHeight
   * @category Other events
   * @internal
   */


  onInternalResize(element, width, height, oldWidth, oldHeight) {
    const me = this;

    if (me._devicePixelRatio && me._devicePixelRatio !== window.devicePixelRatio) {
      // Pixel ratio changed, likely because of browser zoom. This affects the relative scrollbar width also
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].resetScrollBarWidth();
    }

    me._devicePixelRatio = window.devicePixelRatio; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

    me._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].client(me.bodyContainer);
    super.onInternalResize(...arguments);

    if (height !== oldHeight) {
      me._bodyHeight = me.bodyContainer.offsetHeight;

      if (me.isPainted) {
        // initial height will be set from render(),
        // it reaches onInternalResize too early when rendering, headers/footers are not sized yet
        me.rowManager.initWithHeight(me._bodyHeight);
      }
    }

    me.refreshVirtualScrollbars();

    if (width !== oldWidth) {
      // Slightly delay to avoid resize loops.
      me.setTimeout(() => {
        if (!me.isDestroyed) {
          me.updateResponsive(width, oldWidth);
        }
      }, 0);
    }
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridFeatures.js":
/*!*********************************************!*\
  !*** ./lib/Grid/view/mixin/GridFeatures.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




/**
 * @module Grid/view/mixin/GridFeatures
 */

const validConfigTypes = {
  string: 1,
  object: 1,
  function: 1 // used by CellTooltip

};
/**
 * Mixin for Grid that handles features. Features are plugins that add functionality to the grid. Feature classes should
 * register with Grid by calling {@link Grid.feature.GridFeatureManager#function-registerFeature-static registerFeature}. This
 * enables features to be specified and configured in grid
 * config.
 *
 * Define which features to use:
 *
 * ```javascript
 * // specify which features to use (note that some features are used by default)
 * const grid = new Grid({
 *   features: {
 *      sort: 'name',
 *      search: true
 *   }
 * });
 * ```
 *
 * Access a feature in use:
 *
 * ```javascript
 * grid.features.search.search('cat');
 * ```
 *
 * Basic example of implementing a feature:
 *
 * ```javascript
 * class MyFeature extends InstancePlugin {
 *
 * }
 *
 * GridFeatures.registerFeature(MyFeature);
 *
 * // using the feature
 * const grid = new Grid({
 *   features: {
 *     myFeature: true
 *   }
 * });
 * ```
 *
 * ## Enable and disable features at runtime
 *
 * Each feature is either "enabled" (included by default), or "off" (excluded completely). You can always check the docs
 * of a specific feature to find out how it is configured by default.
 *
 * Features which are "off" completely are not available and cannot be enabled at runtime.
 *
 * For a feature that is **off** by default that you want to enable later during runtime,
 * configure it with `disabled : true`:
 * ```javascript
 * const grid = new Grid({
 *      featureName : {
 *          disabled : true // on and disabled, can be enabled later
 *      }
 * });
 *
 * // enable the feature
 * grid.featureName.disabled = false;
 * ```
 *
 * If the feature is **off** by default, and you want to include and enable the feature, configure it as `true`:
 * ```javascript
 * const grid = new Grid({
 *      featureName : true // on and enabled, can be disabled later
 * });
 *
 * // disable the feature
 * grid.featureName.disabled = true;
 * ```
 *
 * If the feature is **on** by default, but you want to turn it **off**, configure it as `false`:
 * ```javascript
 * const grid = new Grid({
 *      featureName : false // turned off, not included at all
 * });
 * ```
 *
 * If the feature is **enabled** by default and you have no need of reconfiguring it,
 * you can omit the feature configuration.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridFeatures extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridFeatures';
  } //region Init

  /**
   * Specify which features to use on the grid. Most features accepts a boolean, some also accepts a config object.
   * Please note that if you are not using the bundles you might need to import the features you want to use.
   *
   * ```javascript
   * const grid = new Grid({
   *     features : {
   *         stripe : true,   // Enable stripe feature
   *         sort   : 'name', // Configure sort feature
   *         group  : false   // Disable group feature
   *     }
   * }
   * ```
   *
   * @config {Object} features
   * @category Common
   */

  /**
   * Map of the features available on the grid. Use it to access them on your grid object
   *
   * ```javascript
   * grid.features.group.expandAll();
   * ```
   *
   * @readonly
   * @member {Object} features
   * @category Common
   */


  set features(features) {
    const me = this,
          defaultFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].getInstanceDefaultFeatures(this);
    features = me._features = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({}, features); // default features, enabled unless otherwise specified

    if (defaultFeatures) {
      Object.keys(defaultFeatures).forEach(feature => {
        if (!(feature in features)) {
          features[feature] = true;
        }
      });
    } // We *prime* the features so that if any configuration code accesses a feature, it
    // will self initialize, but if not, they will remain in a primed state until afterConfigure.


    const registeredInstanceFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].getInstanceFeatures(this);

    for (const featureName of Object.keys(features)) {
      const config = features[featureName]; // Create feature initialization property if config is truthy.
      // Config must be a valid configuration value for the feature class.

      if (config) {
        const throwIfError = !window.__bryntum_code_editor_changed; // Feature configs name must start with lowercase letter to be valid

        if (_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].uncapitalize(featureName) !== featureName) {
          const errorMessage = `Invalid feature name '${featureName}', must start with a lowercase letter`;

          if (throwIfError) {
            throw new Error(errorMessage);
          }

          console.error(errorMessage);
          me._errorDuringConfiguration = errorMessage;
        }

        const featureClass = registeredInstanceFeatures[featureName];

        if (!featureClass) {
          const errorMessage = `Feature '${featureName}' not available, make sure you have imported it`;

          if (throwIfError) {
            throw new Error(errorMessage);
          }

          console.error(errorMessage);
          me._errorDuringConfiguration = errorMessage;
          return;
        } // Create a self initializing property on the features object named by the feature name.
        // when accessed, it will create and return the real feature.
        // Now, if some Feature initialization code attempt to access a feature which has not yet been initialized
        // it will be initialized just in time.


        Reflect.defineProperty(features, featureName, me.createFeatureInitializer(features, featureName, featureClass, config));
      }
    }
  }

  get features() {
    return this._features;
  }

  createFeatureInitializer(features, featureName, featureClass, config) {
    const constructorArgs = [this],
          construct = featureClass.prototype.construct; // Only pass config if there is one.
    // The constructor(config = {}) only works for undefined config

    if (validConfigTypes[typeof config]) {
      constructorArgs[1] = config;
    }

    return {
      configurable: true,

      get() {
        // Delete this defined property and replace it with the Feature instance.
        delete features[featureName]; // Ensure the feature is injected into the features object before initialization
        // so that it is available from call chains from its initialization.

        featureClass.prototype.construct = function (...args) {
          features[featureName] = this;
          construct.apply(this, args);
          featureClass.prototype.construct = construct;
        }; // Return the Feature instance


        return new featureClass(...constructorArgs);
      }

    };
  } //endregion
  //region Other stuff

  /**
   * Check if a feature is included
   * @param {String} name Feature name, as registered with `GridFeatureManager.registerFeature()`
   * @returns {Boolean}
   * @category Misc
   */


  hasFeature(name) {
    const {
      features
    } = this;

    if (features) {
      const featureProp = Object.getOwnPropertyDescriptor(this.features, name);

      if (featureProp) {
        // Do not actually force creation of the feature
        return Boolean(featureProp.value || featureProp.get);
      }
    }

    return false;
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridNavigation.js":
/*!***********************************************!*\
  !*** ./lib/Grid/view/mixin/GridNavigation.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'gantt';





/**
 * @module Grid/view/mixin/GridNavigation
 */

const defaultFocusOptions = Object.freeze({
  doSelect: true
}),
      disableScrolling = Object.freeze({
  x: false,
  y: false
});
/**
 * Mixin for Grid that handles cell to cell navigation.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridNavigation extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridNavigation';
  } //region Cell

  /**
   * User navigated to a grid cell
   * @event navigate
   * @param {Grid.view.Grid} grid
   * @param {Object} last focused location
   * @param {Object} location focus moved to
   * @param {Event} [event] The UI event which caused navigation.
   */

  /**
   * Cell selector for focused cell, set to focus a cell or use {@link #function-focusCell}.
   * @property {Object}
   */


  get focusedCell() {
    const result = this._focusedCell;

    if (result && this.getCell(result)) {
      return result;
    }

    this.clearFocus();
  }
  /**
   * This property is `true` if an element _within_ a cell is focused.
   * @property {Boolean}
   * @readonly
   */


  get isActionableLocation() {
    const focusedCell = this._focusedCell;
    return Boolean(focusedCell && focusedCell.element && this.getCell(focusedCell).contains(focusedCell.element));
  }

  set focusedCell(cellSelector) {
    this.focusCell(cellSelector, {
      doSelect: false
    });
  }

  get focusedRecord() {
    if (this._focusedCell) {
      return this.store.getById(this._focusedCell.id);
    }
  }
  /**
   * CSS selector for currently focused cell. Format is "[data-index=index] [data-column-id=columnId]".
   * @property {String}
   * @readonly
   */


  get cellCSSSelector() {
    const me = this,
          cell = me._focusedCell,
          row = cell && me.getRowById(cell.id);
    if (!cell || !row) return '';
    return `[data-index=${row.index}] [data-column-id=${cell.columnId}]`;
  }
  /**
   * Grid element focus, selects first row and cell when grid is focused if none is selected (otherwise user cannot
   * see that grid is focused).
   * Chain this function it features to handle the dom event.
   * @param event
   * @category Other events
   * @internal
   */


  onGridElementFocus(event) {
    // Select first row if none is selected when grid is focused (to show that it has focus)
    const me = this,
          focusOptions = {
      doSelect: false,
      event
    };

    if (me._initialFocusedCellContext) {
      const {
        cellSelector,
        options
      } = me._initialFocusedCellContext;
      me._focusedCell = null;
      me.focusCell(cellSelector, options);
      me._initialFocusedCellContext = null;
    } else if (me._focusedCell) {
      me.focusCell(me._focusedCell, focusOptions);
    } else {
      // If they just clicked in blank space, do not refocus the last focused cell.
      // We focus cell 0, 0 on that gesture.
      const targetContext = me.element.contains(event.relatedTarget) ? null : me.lastFocusedCell;

      if (targetContext) {
        const cell = me.getCell(targetContext); // If we're using lastFocusedCell and the cell is no longer in existence, or not visible
        // or the previously focused record has since been removed.
        // Fallback to reverting to where focus entered the grid from.
        // TODO: CellContext should store the record index
        // to fall back to if the actual record is no longer present.

        if (!cell || !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isVisible(cell) || !me.store.getById(targetContext.id)) {
          me.revertFocus();
          return;
        } // flag to not affect selection


        me.returningFocus = true;
        me.focusCell(targetContext, focusOptions);
        me.returningFocus = false;
      } else if (!me.scrolling && !me.skipFocusSelection && me.store.first) {
        const {
          mouseMoveEvent: evt,
          rowManager: rm,
          _bodyRectangle: r
        } = me,
              defaultRow = evt && rm.getRowAt(Math.min(Math.max(evt.clientY, r.y), r.bottom)) || me.firstFullyVisibleRow,
              focusContext = evt && me.getCellDataFromEvent(evt) || {
          id: defaultRow.id,
          columnId: me.columns.visibleColumns[0].id
        };

        if (me.getCell(focusContext)) {
          me.focusCell(focusContext, focusOptions);
        }
      }
    }

    me.skipFocusSelection = false;
  }

  onFocusOut(event) {
    super.onFocusOut(event);
    this.clearFocus();
  }

  afterHide() {
    super.afterHide(...arguments); // Do not scroll back to the last focused cell/last moused over cell upon reshow

    this.lastFocusedCell = this.mouseMoveEvent = null;
  }
  /**
   * Checks whether or not a cell is focused.
   * @param {Object|String|Number} cellSelector Cell selector { id: x, columnId: xx } or row id
   * @returns {Boolean} true if cell or row is focused, otherwise false
   */


  isFocused(cellSelector) {
    return Boolean(this._focusedCell) && this.isLocationEqual(cellSelector, this._focusedCell);
  }
  /**
   * Navigates to a cell and/or its row (depending on selectionMode)
   * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
   * @param {Object} options Modifier options for how to deal with focusing the cell. These
   * are used as the {@link Core.helper.util.Scroller#function-scrollTo} options.
   * @param {Boolean} [options.doSelect=true] Optionally pass `false` to not continue to selection.
   * @param {Event} [options.event] Optionally pass the UI event which instigated the focus request.
   * @param {Object|Boolean} [options.scroll=true] Pass `false` to not scroll the cell into view, or a
   * scroll options object to affect the scroll.
   * @returns {Object} Cell selector
   * @fires navigate
   */


  focusCell(cellSelector, options = defaultFocusOptions) {
    var _options, _options$event, _Widget$fromElement;

    // Mac OS specific behaviour: when you right click a non-active window, the window does not receive focus, but the context menu is shown.
    // So for Mac OS we treat the right click as a non-focusable action, if window is not active
    if (!document.hasFocus() && _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isMac && ((_options = options) === null || _options === void 0 ? void 0 : (_options$event = _options.event) === null || _options$event === void 0 ? void 0 : _options$event.button) === 2) {
      return;
    }

    const me = this,
          activeElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me); // If we're being passed a context object (as opposed to a record), clone in case we were
    // passed the _focusedCell, and after refresh isLocationEqual needs to detect a difference.

    cellSelector = me.normalizeCellContext(cellSelector === Object ? Object.assign({}, cellSelector) : cellSelector);
    const doSelect = options.doSelect !== false,
          {
      event,
      scroll
    } = options,
          lastFocusedCell = me.lastFocusedCell = me._focusedCell,
          isNotMove = me.isLocationEqual(cellSelector, lastFocusedCell),
          lastCell = lastFocusedCell && me.getCell(lastFocusedCell),
          subGrid = me.getSubGridFromColumn(cellSelector.columnId);
    let cell = me.getCell(cellSelector); // If we're focusing due to a mousedown on a focusable element *within* a cell
    // then we do not "navigate" to the cell - we allow the element to be focused.
    // For example a CheckColumn or WidgetColumn.

    if (event && event.type === 'mousedown') {
      for (let target = event.target; target !== cell; target = target.parentElement) {
        if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(target)) {
          cellSelector.element = target;
          return;
        }
      }
    } // No navigation takes place, but the selection still needs to know if a UI event happened.


    if (isNotMove) {
      if (event) {
        me.onCellNavigate && me.onCellNavigate(me, null, me._focusedCell, event, doSelect);
      }

      return cellSelector;
    }

    if (lastCell) {
      lastCell.classList.remove('b-focused');
    } // DomHelper.focusWithoutScrolling means "Don't try to scroll this element into view"
    // because browsers try to move the element into view.
    // But the grid itself needs to scroll the cell into view.


    const testCell = cell || me.getCell({
      row: me.rowManager.topIndex,
      columnId: cellSelector.columnId
    }),
          subGridRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(subGrid.element),
          bodyRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(me.bodyContainer),
          cellRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(testCell).moveTo(null, subGridRect.y);

    if (scroll === false) {
      options = Object.assign({}, options, disableScrolling);
    } else {
      options = Object.assign({}, options, scroll); // If the test cell is larger than the subGrid, in any dimension, disable scrolling

      if (cellRect.width > subGridRect.width || cellRect.height > bodyRect.height) {
        options.x = options.y = false;
      } // Else ask for the column to be scrolled into view
      else {
        options.column = cellSelector.columnId;
      }

      me.scrollRowIntoView(cellSelector.id, options);
    } // If active element is not a part of the grid body,
    // and the grid does not own the widget which is represented by the active element
    // (for example header element), focus the cell without scrolling


    if (activeElement !== me.focusElement && !me.focusElement.contains(activeElement) && ((_Widget$fromElement = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(activeElement)) === null || _Widget$fromElement === void 0 ? void 0 : _Widget$fromElement.owner) !== me) {
      me._initialFocusedCellContext = {
        cellSelector,
        options
      };
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].focusWithoutScrolling(me.focusElement); // If focusing didn't work right away, clear the cached value, so onGridElementFocus is not affected by the value.
      // Does not work in IE11 because focus in IE asynchronous. Just ignore it.

      if (!me.isLocationEqual(cellSelector, me._focusedCell) && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
        me._initialFocusedCellContext = null;
      }

      return;
    } // Get the newly visible cell *after* it has been scrolled into view.
    // With buffered rendering, it may not have existed before the scroll.


    cell = me.getCell(cellSelector);

    if (cell) {
      cellSelector.element = cell;
      cell.classList.add('b-focused');
    } //Remember


    me._focusedCell = cellSelector;
    me.onCellNavigate && me.onCellNavigate(me, lastFocusedCell, me._focusedCell, event, doSelect);
    me.trigger('navigate', {
      lastFocusedCell,
      focusedCell: me._focusedCell,
      event
    }); //TODO: should be able to cancel selectcell from listeners

    return cellSelector;
  }

  isLocationEqual(cellSelector, otherCellSelector) {
    return cellSelector && otherCellSelector && cellSelector.id === otherCellSelector.id && cellSelector.columnId === otherCellSelector.columnId && ( // Normalized cellSelectors are not required to have an element, only compare elements if both selectors
    // have it specified
    !cellSelector.element || !otherCellSelector.element || cellSelector.element === otherCellSelector.element);
  }

  blurCell(cellSelector) {
    const me = this,
          cell = me.getCell(cellSelector);

    if (cell) {
      cell.classList.remove('b-focused');
    }
  }

  clearFocus(fullClear) {
    const me = this;

    if (me._focusedCell) {
      // set last to have focus return to previous cell when alt tabbing
      me.lastFocusedCell = fullClear ? null : me._focusedCell;
      me.blurCell(me._focusedCell);
      me._focusedCell = null;
    }
  }
  /**
   * Selects the cell before or after currently focused cell.
   * @private
   * @param next Specify true to select the next cell, false to select the previous
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object} Used cell selector
   */


  internalNextPrevCell(next = true, event) {
    const me = this,
          cellSelector = me._focusedCell;

    if (cellSelector) {
      return me.focusCell({
        id: cellSelector.id,
        columnId: me.columns.getAdjacentVisibleLeafColumn(cellSelector.columnId, next, true).id
      }, {
        doSelect: true,
        event
      });
    }

    return null;
  }
  /**
   * Select the cell after the currently focused one.
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object} Cell selector
   */


  navigateRight(event) {
    return this.internalNextPrevCell(true, event);
  }
  /**
   * Select the cell before the currently focused one.
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object} Cell selector
   */


  navigateLeft(event) {
    return this.internalNextPrevCell(false, event);
  } //endregion
  //region Row

  /**
   * Selects the next or previous record in relation to the current selection. Scrolls into view if outside.
   * @private
   * @param next Next record (true) or previous (false)
   * @param {Boolean} skipSpecialRows True to not return specialRows like headers
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object|Boolean} Selection context for the focused row (& cell) or false if no selection was made
   */


  internalNextPrevRow(next, skipSpecialRows = true, event, moveToHeader = true) {
    const me = this,
          cell = me._focusedCell;
    if (!cell) return false;
    const record = me.store[`get${next ? 'Next' : 'Prev'}`](cell.id, false, skipSpecialRows);

    if (record) {
      return me.focusCell({
        id: record.id,
        columnId: cell.columnId,
        scroll: {
          x: false
        }
      }, {
        doSelect: true,
        event
      });
    } else if (!next && moveToHeader) {
      this.clearFocus();
      return this.getHeaderElement(cell.columnId).focus();
    }
  }
  /**
   * Navigates to the cell below the currently focused cell
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object} Selector for focused row (& cell)
   */


  navigateDown(event) {
    return this.internalNextPrevRow(true, false, event);
  }
  /**
   * Navigates to the cell above the currently focused cell
   * @param {Event} [event] Optionally, the UI event which caused navigation.
   * @returns {Object} Selector for focused row (& cell)
   */


  navigateUp(event) {
    return this.internalNextPrevRow(false, false, event);
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridResponsive.js":
/*!***********************************************!*\
  !*** ./lib/Grid/view/mixin/GridResponsive.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Grid/view/mixin/GridResponsive
 */

/**
 * Simplifies making grid responsive. Supply levels as {@link #config-responsiveLevels} config, default levels are:
 * <dl>
 * <dt>small <dd>< 400px,
 * <dt>medium <dd>< 600px
 * <dt>large <dd>> 600px
 * </dl>
 *
 * Columns can define configs per level to be resized etc:
 *
 * ```
 * let grid = new Grid({
 *   responsiveLevels: {
 *     small: 300,
 *     medium: 400,
 *     large: '*' // everything above 400
 *   },
 *
 *   columns: [
 *     {
 *       field: 'name',
 *       text: 'Name',
 *       responsiveLevels: {
 *         small: { hidden: true },
 *         '*': { hidden: false } // all other levels
 *       }
 *     },
 *     { field: 'xx', ... }
 *   ]
 * });
 * ```
 *
 * It is also possible to give a [Grid state](#Grid/view/mixin/GridState) object instead of a level width, but in that
 * case the object must contain a `levelWidth` property:
 *
 * ```
 * let grid = new Grid({
 *   responsiveLevels: {
 *     small: {
 *       // Width is required
 *       levelWidth : 400,
 *       // Other configs are optional, see GridState for available options
 *       rowHeight  : 30
 *     },
 *     medium : {
 *       levelWidth : 600,
 *       rowHeight  : 40
 *     },
 *     large: {
 *       levelWidth : '*', // everything above 300
 *       rowHeight  : 45
 *     }
 *   }
 * });
 * ```
 *
 * @demo Grid/responsive
 * @inlineexample Grid/view/mixin/Responsive.js
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridResponsive extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridResponsive';
  }

  static get defaultConfig() {
    return {
      /**
       * "Break points" for which responsive config to use for columns and css.
       * @config {Object}
       * @category Misc
       * @default { small : 400, medium : 600, large : '*' }
       */
      responsiveLevels: Object.freeze({
        small: 400,
        medium: 600,
        large: '*'
      })
    };
  }
  /**
   * Find closes bigger level, aka level we want to use.
   * @private
   * @category Misc
   */


  getClosestBiggerLevel(width) {
    const me = this,
          levels = Object.keys(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, me.responsiveLevels));
    let useLevel = null,
        minDelta = 99995,
        biggestLevel = null;
    levels.forEach(level => {
      let levelSize = me.responsiveLevels[level]; // responsiveLevels can contains config objects, in which case we should use width from it

      if (!['number', 'string'].includes(typeof levelSize)) {
        levelSize = levelSize.levelWidth;
      }

      if (levelSize === '*') {
        biggestLevel = level;
      } else if (width < levelSize) {
        const delta = levelSize - width;

        if (delta < minDelta) {
          minDelta = delta;
          useLevel = level;
        }
      }
    });
    return useLevel || biggestLevel;
  }
  /**
   * Get currently used responsive level (as string)
   * @property {String}
   * @readonly
   * @category Misc
   */


  get responsiveLevel() {
    return this.getClosestBiggerLevel(this.width);
  }
  /**
   * Check if resize lead to a new responsive level and take appropriate actions
   * @private
   * @fires responsive
   * @param width
   * @param oldWidth
   * @category Misc
   */


  updateResponsive(width, oldWidth) {
    const me = this,
          oldLevel = me.getClosestBiggerLevel(oldWidth),
          level = me.getClosestBiggerLevel(width); // On first render oldWidth is 0, in such case we need to apply level anyway

    if (oldWidth === 0 || oldLevel !== level) {
      // Level might be a state object
      const levelConfig = me.responsiveLevels[level];

      if (!['number', 'string'].includes(typeof levelConfig)) {
        me.applyState(levelConfig);
      } // check columns for responsive config


      me.columns.forEach(column => {
        const levels = column.responsiveLevels;

        if (levels) {
          if (levels[level]) {
            // using state to apply responsive config, since it already does what we want...
            column.applyState(levels[level]);
          } else if (levels['*']) {
            column.applyState(levels['*']);
          }
        }
      });
      me.element.classList.remove('b-responsive-' + oldLevel);
      me.element.classList.add('b-responsive-' + level);
      /**
       * Grid resize lead to a new responsive level being applied
       * @event responsive
       * @param {Grid.view.Grid} grid Grid that was resized
       * @param {String} level New responsive level (small, large, etc)
       * @param {Number} width New width in px
       * @param {String} oldLevel Old responsive level
       * @param {Number} oldWidth Old width in px
       */

      me.trigger('responsive', {
        level,
        width,
        oldLevel,
        oldWidth
      });
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridSelection.js":
/*!**********************************************!*\
  !*** ./lib/Grid/view/mixin/GridSelection.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';




const validIdTypes = {
  string: 1,
  number: 1
},
      isDataLoadAction = {
  dataset: 1,
  batch: 1
};
/**
 * @module Grid/view/mixin/GridSelection
 */

/**
 * A mixin for Grid that handles row and cell selection. See {@link #config-selectionMode} for details on how to control what should be selected (rows or cells)
 *
 * @example
 * // select a row
 * grid.selectedRow = 7;
 *
 * // select a cell
 * grid.selectedCell = { id: 5, columnId: 'column1' }
 *
 * // select a record
 * grid.selectedRecord = grid.store.last;
 *
 * // select multiple records by ids
 * grid.selectedRecords = [1, 2, 4, 6]
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridSelection extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridSelection';
  }

  static get defaultConfig() {
    return {
      /**
       * The selection settings, where you can set these boolean flags to control what is selected. Options below:
       * @config {Object} selectionMode
       * @param {Boolean} selectionMode.row select rows
       * @param {Boolean} selectionMode.cell select cells
       * @param {Boolean} selectionMode.rowCheckboxSelection select rows only when clicking in the checkbox column
       * @param {Boolean} selectionMode.multiSelect Allow multiple selection
       * @param {Boolean|Object} selectionMode.checkbox Set to true to add a checkbox selection column to the grid,
       * or pass a config object for the {@link Grid.column.CheckColumn}
       * @param {Boolean} selectionMode.showCheckAll  true to add a checkbox to the selection column header to select/deselect all rows
       * @param {Boolean} selectionMode.deselectFilteredOutRecords true to deselect rows that are filtered out
       * @param {Boolean} selectionMode.includeChildren true to also select/deselect child nodes when a parent node is selected
       * @param {Boolean} selectionMode.preserveSelectionOnPageChange This flag controls whether the Grid should preserve
       * its selection when loading a new page of a paged data store
       * @param {Boolean} selectionMode.preserveSelectionOnDatasetChange This flag controls whether the Grid should preserve
       * its selection of cells / rows when loading a new dataset (assuming the selected records are included in
       * the newly loaded dataset)
       * @default
       * @category Selection
       */
      selectionMode: {
        row: true,
        cell: true,
        rowCheckboxSelection: false,
        multiSelect: true,
        checkbox: false,
        showCheckAll: false,
        deselectFilteredOutRecords: false,
        includeChildren: false,
        preserveSelectionOnPageChange: false,
        preserveSelectionOnDatasetChange: true
      },
      selectedRecordCollection: {}
    };
  } //region Init


  afterConfigure() {
    const me = this; // Inject our CheckColumn into the ColumnStore

    if (me.selectionMode.checkbox) {
      const checkColumnClass = _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_3__["default"].getColumnClass('check'),
            config = me.selectionMode.checkbox === true ? null : me.selectionMode.checkbox;

      if (!checkColumnClass) {
        throw new Error('CheckColumn must be imported for checkbox selection mode to work');
      }

      const col = me.checkboxSelectionColumn = new checkColumnClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
        id: `${me.id}-selection-column`,
        width: '4em',
        minWidth: '4em',
        // Misaligned on IE11 without, since 4em is below columns default minWidth
        field: null,
        cellCls: 'b-checkbox-selection',
        // Always put the checkcolumn in the first region
        region: me.items[0].region,
        showCheckAll: me.selectionMode.showCheckAll
      }, config), me.columns);
      col.isSelectionColumn = true;
      col.meta.depth = 0; // This is assigned in Column.js for normal columns

      col._grid = me; // Override renderer to inject the rendered record's selected status into the value

      const checkboxRenderer = col.renderer;

      col.renderer = renderData => {
        renderData.value = me.isSelected(renderData.record);
        checkboxRenderer.call(col, renderData);
      };

      col.on({
        toggle: 'onCheckChange',
        toggleAll: 'onCheckAllChange',
        thisObj: me
      }); // Insert the checkbox after any rownumber column. If not there, -1 means in at 0.

      const insertIndex = me.columns.indexOf(me.columns.findRecord('type', 'rownumber')) + 1;
      me.columns.insert(insertIndex, col);
    }

    super.afterConfigure();
  }

  bindStore(store) {
    var _super$bindStore;

    this.detachListeners('selectionStoreFilter');
    store.on({
      name: 'selectionStoreFilter',
      filter: 'onStoreFilter',
      thisObj: this
    });
    (_super$bindStore = super.bindStore) === null || _super$bindStore === void 0 ? void 0 : _super$bindStore.call(this, store);
  }

  unbindStore(oldStore) {
    this.detachListeners('selectionStoreFilter');
    super.unbindStore(oldStore);
  } //endregion
  //region Events


  onStoreFilter({
    records
  }) {
    if (this.selectionMode.deselectFilteredOutRecords) {
      const {
        filtersFunction
      } = this.store,
            filteredOutRecords = this.selectedRecordCollection.values.filter(rec => !filtersFunction(rec));
      this.selectedRecordCollection.remove(filteredOutRecords);
    }
  }
  /**
   * Triggered from Grid view when the id of a record has changed.
   * Update the collection indices.
   * @private
   * @category Selection
   */


  onStoreRecordIdChange({
    record,
    oldValue
  }) {
    // If the next mixin up the inheritance chain has an implementation, call it
    super.onStoreRecordIdChange && super.onStoreRecordIdChange(...arguments);
    const item = this.selectedRecordCollection.get(oldValue); // having the record registered by the oldValue means we need to rebuild indices

    if (item === record) {
      this.selectedRecordCollection.rebuildIndices();
    }
  }
  /**
   * The selection has been changed.
   * @event selectionChange
   * @param {String} action `'select'`/`'deselect'`
   * @param {String} mode `'row'`/`'cell'`
   * @param {Grid.view.Grid} source
   * @param {Core.data.Model[]|Object} deselected The records or cells (depending on the `mode`) deselected in this operation.
   * @param {Core.data.Model[]|Object} selected The records or cells (depending on the `mode`) selected in this operation.
   * @param {Core.data.Model[]|Object} selection  The records or cells (depending on the `mode`) in the new selection.
   */

  /**
   * Responds to mutations of the underlying storage Collection
   * @param {Object} event
   * @private
   */


  onSelectedRecordCollectionChange({
    source: selectedRecordCollection,
    action,
    added = [],
    removed
  }) {
    const me = this;

    if (me._selectedCell && !me.isSelectable(me._selectedCell)) {
      me.deselectCell(me._selectedCell);
    } // Filter out unselectable rows


    added = added.filter(row => me.isSelectable(row));
    me.triggerChangeEvent({
      mode: 'row',
      action: added.length ? 'select' : 'deselect',
      selection: me.selectedRecords,
      selected: added,
      deselected: removed
    }, me.silent);
  }

  onCheckChange({
    source: column,
    checked,
    record
  }) {
    const me = this,
          {
      selectionMode,
      store
    } = me,
          children = selectionMode.includeChildren && selectionMode.multiSelect !== false && !record.isLeaf && record.allChildren,
          records = [record, ...(children || [])];

    if (checked) {
      me.selectRows(records, selectionMode.multiSelect !== false);

      if (column.headerCheckbox && me.selectedRecords.length === store.count - (store.groupRecords ? store.groupRecords.length : 0)) {
        column.suspendEvents();
        column.headerCheckbox.checked = true;
        column.resumeEvents();
      }
    } else {
      me.deselectRows(records);

      if (column.headerCheckbox) {
        column.suspendEvents();
        column.headerCheckbox.checked = false;
        column.resumeEvents();
      }
    }
  }

  onCheckAllChange({
    checked
  }) {
    this[checked ? 'selectAll' : 'deselectAll'](this.store.isPaged && this.selectionMode.preserveSelectionOnPageChange);
  } //endregion
  //region Selection collection


  set selectedRecordCollection(selectedRecordCollection) {
    if (!(selectedRecordCollection instanceof _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"])) {
      selectedRecordCollection = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](selectedRecordCollection);
    }

    this._selectedRecordCollection = selectedRecordCollection; // Fire row change events from onSelectedRecordCollectionChange

    selectedRecordCollection.on({
      change: 'onSelectedRecordCollectionChange',
      thisObj: this
    });
  }

  get selectedRecordCollection() {
    return this._selectedRecordCollection;
  }
  /**
   * Removes and adds records to/from the selection at the same time. Analogous
   * to the `Array` `splice` method.
   *
   * Note that if items that are specified for removal are also in the `toAdd` array,
   * then those items are *not* removed then appended. They remain in the same position
   * relative to all remaining items.
   *
   * @param {Number} index Index at which to remove a block of items. Only valid if the
   * second, `toRemove` argument is a number.
   * @param {Object[]|Number} toRemove Either the number of items to remove starting
   * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
   * @param  {Object[]|Object} toAdd An item, or an array of items to add.
   */


  spliceSelectedRecords(index, toRemove, toAdd) {
    this._selectedRecordCollection.splice(index, toRemove, toAdd);
  } //endregion
  //region Cell & row

  /**
   * Checks whether or not a cell or row is selected.
   * @param {Object|String|Number|Core.data.Model} cellSelectorOrId Cell selector { id: x, column: xx } or row id, or record
   * @returns {Boolean} true if cell or row is selected, otherwise false
   * @category Selection
   */


  isSelected(cellSelectorOrId) {
    var _cellSelectorOrId;

    const me = this; // A record passed
    // HACK: replaces instanceof check with this because it makes GridSelection test in Edge more stable

    if ((_cellSelectorOrId = cellSelectorOrId) !== null && _cellSelectorOrId !== void 0 && _cellSelectorOrId.isModel) {
      cellSelectorOrId = cellSelectorOrId.id;
    }

    if (validIdTypes[typeof cellSelectorOrId]) {
      return me.selectedRecordCollection.includes(cellSelectorOrId);
    } else {
      return me._selectedCell && me._selectedCell.id == cellSelectorOrId.id && me._selectedCell.columnId === cellSelectorOrId.columnId;
    }
  }
  /**
   * Checks whether or not a cell or row can be selected.
   * @param {Core.data.Model|Object|String|Number} recordCellOrId Record or cell or record id
   * @returns {Boolean} true if cell or row can be selected, otherwise false
   * @category Selection
   */


  isSelectable(recordCellOrId) {
    // Selection disabled for undefined record, special row (group header / footer) and
    // record which was already removed from store
    if (!recordCellOrId) {
      return false;
    }

    const row = this.store.getById(recordCellOrId.id || recordCellOrId);
    return row && !(row.meta && row.isSpecialRow);
  }
  /**
   * Cell selector for selected cell, set to select a cell or use {@link #function-selectCell()}.
   * @property {Object}
   * @category Selection
   */


  get selectedCell() {
    return this._selectedCell;
  }

  set selectedCell(cellSelector) {
    this.selectCell(cellSelector);
  }

  set selectionMode(mode) {
    if (mode !== null && mode !== void 0 && mode.rowCheckboxSelection) {
      mode.row = true;
      mode.checkbox = mode.checkbox || true;
      mode.cell = false;
    }

    this._selectionMode = mode;
  }

  get selectionMode() {
    return this._selectionMode;
  }
  /**
   * The last selected record. Set to select a row or use Grid#selectRow. Set to null to
   * deselect all
   * @property {Core.data.Model}
   * @category Selection
   */


  get selectedRecord() {
    return this.selectedRecordCollection.last || null;
  }

  set selectedRecord(record) {
    this.selectRow({
      record
    });
  }
  /**
   * Selected records.
   *
   * Can be set as array of ids:
   *
   * ```javascript
   * grid.selectedRecords = [1, 2, 4, 6]
   * ```
   *
   * @property {Core.data.Model[]}
   * @accepts {Core.data.Model[]|Number[]}
   * @category Selection
   */


  get selectedRecords() {
    return this.selectedRecordCollection.values;
  }

  set selectedRecords(selectedRecords) {
    this.selectRows(selectedRecords);
  }
  /**
   * CSS selector for the currently selected cell. Format is "[data-index=index] [data-column-id=column]".
   * @type {String}
   * @category Selection
   * @readonly
   */


  get selectedCellCSSSelector() {
    const me = this,
          cell = me._selectedCell,
          row = cell && me.getRowById(cell.id);
    if (!cell || !row) return '';
    return `[data-index=${row.dataIndex}] [data-column-id=${cell.columnId}]`;
  }
  /**
   * Selects a row (without selecting a cell).
   * @param {Object|Core.data.Model} options A record to select or an config object describing the selection
   * @param {Core.data.Model|String|Number} options.record Record or record id, specifying null will deselect all
   * @param {Grid.column.Column} options.column The column to scroll into view if `scrollIntoView` is not specified as `false`. Defaults to the grid's first column.
   * @param {Boolean} [options.scrollIntoView] Specify `false` to prevent row from being scrolled into view
   * @param {Boolean} [options.addToSelection] Specify `true` to add to selection, defaults to `false` which replaces
   * @fires selectionChange
   * @category Selection
   */


  selectRow({
    record,
    column = this.columns.visibleColumns[0],
    scrollIntoView = true,
    addToSelection = false
  }) {
    const me = this;

    if (arguments[0].isModel) {
      record = arguments[0];
    } else {
      record = me.store.getById(record);
    }

    if (record) {
      me.selectCell({
        id: record.id,
        column
      }, scrollIntoView, addToSelection);
    } else {
      me.deselectAll();
    }
  }
  /**
   * Selects a cell and/or its row (depending on {@link #config-selectionMode})
   * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
   * @param {Boolean} scrollIntoView Specify `false` to prevent row from being scrolled into view
   * @param {Boolean} addToSelection Specify `true` to add to selection, defaults to `false` which replaces
   * @param {Boolean} silent Specify `true` to not trigger any events when selecting the cell
   * @returns {Object} Cell selector
   * @fires selectionChange
   * @category Selection
   */


  selectCell(cellSelector, scrollIntoView = false, addToSelection = false, silent = false) {
    const me = this,
          {
      selectedRecordCollection,
      selectionMode
    } = me,
          selector = me.normalizeCellContext(cellSelector),
          record = selector.record || me.store.getById(selector.id); // Clear selection if row is not selectable

    if (!me.isSelectable(record)) {
      me.deselectAll();
      return;
    }

    if (scrollIntoView) {
      me.scrollRowIntoView(selector.id, {
        column: selector.columnId
      });
    } // Row selection (both sides if locked columns)


    if (selectionMode.row) {
      if (silent) {
        me.silent = (me.silent || 0) + 1;
      }

      if (addToSelection) {
        selectedRecordCollection.add(record);
      } // Clear all others
      else {
        selectedRecordCollection.splice(0, selectedRecordCollection.count, record);
      }

      if (silent) {
        me.silent--;
      } // When starting a selection, register the start cell


      if (me.selectedRecordCollection.count === 1) {
        me.startCell = selector;
        me.lastRange = null;
      }
    } // Cell selection


    if (selectionMode.cell && (selector.columnId || selector.column) && !me.isSelected(selector)) {
      const deselected = me._selectedCell ? [me._selectedCell] : []; //Remember

      me._selectedCell = selector;
      me.triggerChangeEvent({
        mode: 'cell',
        action: 'select',
        selected: [selector],
        deselected,
        selection: [selector]
      }, silent);
    }

    return selector;
  }
  /**
   * Selects all rows. If store is filtered, this will merge the selection of all visible rows with any selection made prior to filtering
   * @category Selection
   */


  selectAll() {
    const me = this,
          {
      store
    } = me;

    if (store.isFiltered && !me.selectionMode.deselectFilteredOutRecords) {
      me.selectedRecordCollection.add(...(store.isGrouped ? store.allRecords : store.records).filter(r => !r.isSpecialRow));
    } else {
      me.selectRows(store.allRecords.filter(r => !r.isSpecialRow), true);
    }
  }
  /**
   * Deselects all selected rows and cells. If store is filtered, this will unselect all visible rows only. Any
   * selections made prior to filtering remains.
   * @param {Boolean} [removeCurrentRecordsOnly] Pass `false` to clear all selected records, and `true` to only
   * clear selected records in the current set of records
   * @category Selection
   */


  deselectAll(removeCurrentRecordsOnly = false) {
    const me = this;

    if (removeCurrentRecordsOnly) {
      me.selectedRecordCollection.remove(...me.store.records);
    } else {
      me.selectedRecordCollection.clear();
    }

    if (me._selectedCell) {
      me.deselectCell(me._selectedCell);
    }
  }
  /**
   * Deselect a row
   * @param {Core.data.Model|String|Number} recordOrId Record or an id for a record
   * @category Selection
   */


  deselectRow(record) {
    this.deselectRows(record);
  }
  /**
   * Select one or more rows
   * @param {Core.data.Model|String|Number|Core.data.Model[]|String[]|Number[]} recordOrIds An array of records or ids for a record
   * @param {Boolean} [addToSelection] `false` clears existing selections first, `true` adds to existing selection
   * @category Selection
   */


  selectRows(recordsOrIds, addToSelection = false) {
    const {
      store
    } = this,
          toSelect = [];
    recordsOrIds = Array.isArray(recordsOrIds) ? recordsOrIds : recordsOrIds == null ? [] : [recordsOrIds];

    for (let record of recordsOrIds) {
      record = store.getById(record);

      if (record) {
        toSelect.push(record);
      }
    }

    if (addToSelection) {
      this.selectedRecordCollection.add(toSelect);
    } else {
      this.selectedRecordCollection.splice(0, this.selectedRecordCollection.count, toSelect);
    }
  }
  /**
   * Deselect one or more rows
   * @param {Core.data.Model|String|Number|Core.data.Model[]|String[]|Number[]} recordOrIds An array of records or ids for a record
   * @category Selection
   */


  deselectRows(recordsOrIds) {
    recordsOrIds = Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds];
    const records = recordsOrIds.map(recordOrId => this.store.getById(recordOrId));
    this.selectedRecordCollection.remove(records);
  }
  /**
   * Deselect a cell/row, depending on settings in Grid#selectionMode
   * @param {Object} cellSelector
   * @returns {Object} Normalized cell selector
   * @category Selection
   */


  deselectCell(cellSelector) {
    const me = this,
          selector = me.normalizeCellContext(cellSelector),
          selMode = me.selectionMode,
          record = selector.record || me.store.getById(selector.id),
          selectedCell = me._selectedCell; // Row selection (both sides if locked columns)

    if (selMode.row) {
      me.selectedRecordCollection.remove(record);
    } // Cell selection


    if (selMode.cell && selector.columnId && selectedCell) {
      if (selectedCell.id === selector.id && selectedCell.columnId === selector.columnId) {
        me._selectedCell = null;
        me.triggerChangeEvent({
          mode: 'cell',
          action: 'deselect',
          selected: [],
          deselected: [selector],
          selection: []
        });
      }
    }

    return selector;
  } //endregion
  //region Record

  /**
   * Selects rows corresponding to a range of records (from fromId to toId)
   * @param {String|Number} fromId
   * @param {String|Number} toId
   * @category Selection
   */


  selectRange(fromId, toId) {
    const {
      store,
      selectedRecordCollection
    } = this,
          fromIndex = store.indexOf(fromId),
          toIndex = store.indexOf(toId),
          startIndex = Math.min(fromIndex, toIndex),
          endIndex = Math.max(fromIndex, toIndex);

    if (startIndex === -1 || endIndex === -1) {
      throw new Error('Record not found in selectRange');
    }

    selectedRecordCollection.splice(0, selectedRecordCollection.count, store.getRange(startIndex, endIndex + 1, false));
  }
  /**
   * Triggered from Grid view when records get removed from the store.
   * Deselects all records which have been removed.
   * @private
   * @category Selection
   */


  onStoreRemove(event) {
    // If the next mixin up the inheritance chain has an implementation, call it
    super.onStoreRemove && super.onStoreRemove(event);

    if (!event.isCollapse) {
      this.selectedRecordCollection.remove(event.records);
    }
  }
  /**
   * Triggered from Grid view when the store changes. This might happen
   * if store events are batched and then resumed.
   * Deselects all records which have been removed.
   * @private
   * @category Selection
   */


  onStoreDataChange({
    action,
    source: store
  }) {
    const me = this,
          {
      selectionMode,
      checkboxSelectionColumn,
      selectedRecordCollection
    } = me; // If the next mixin up the inheritance chain has an implementation, call it

    super.onStoreDataChange && super.onStoreDataChange(...arguments);

    if (action === 'pageLoad') {
      if (!selectionMode.preserveSelectionOnPageChange) {
        // For paged grid scenario, we need to update the check-all checkbox in the checkbox column header
        // as we move between store pages
        me.deselectAll();
      }

      checkboxSelectionColumn === null || checkboxSelectionColumn === void 0 ? void 0 : checkboxSelectionColumn.updateCheckAllState(!store.find(record => !selectedRecordCollection.includes(record)));
    } else if (isDataLoadAction[action]) {
      const toRemove = [];

      if (selectionMode.preserveSelectionOnDatasetChange === false) {
        me.deselectAll();
      } else {
        // Update selected records collection
        selectedRecordCollection.forEach(record => {
          const newRecord = store.getById(record.id); // If record still exists after reload, update selectedRecordCollection with a reference to the new task version

          if (newRecord) {
            const index = selectedRecordCollection.indexOf(record);
            selectedRecordCollection.splice(index, 1, newRecord);
          } else {
            toRemove.push(record);
          }
        }); // Remove in one go to fire a single selectionChange event

        selectedRecordCollection.remove(toRemove);
      }
    }
  }
  /**
   * Triggered from Grid view when all records get removed from the store.
   * Deselects all records.
   * @private
   * @category Selection
   */


  onStoreRemoveAll() {
    // If the next mixin up the inheritance chain has an implementation, call it
    super.onStoreRemoveAll && super.onStoreRemoveAll();
    this.deselectAll();
  } //endregion
  //region Handle multiSelect

  /**
   * Handles multi selection using the mouse. Called from GridElementEvents on mousedown in a cell and
   * simultaneously pressing a modifier key.
   * @param cellData
   * @param event
   * @private
   * @category Selection
   */


  handleMouseMultiSelect(cellData, event) {
    const me = this,
          id = cellData.id;

    function mergeRange(fromId, toId) {
      const {
        store,
        selectedRecordCollection
      } = me,
            fromIndex = store.indexOf(fromId),
            toIndex = store.indexOf(toId),
            startIndex = Math.min(fromIndex, toIndex),
            endIndex = Math.max(fromIndex, toIndex);

      if (startIndex === -1 || endIndex === -1) {
        throw new Error('Record not found in selectRange');
      }

      const newRange = store.getRange(startIndex, endIndex + 1, false).filter(row => me.isSelectable(row));
      selectedRecordCollection.splice(0, me.lastRange || 0, newRange);
      me.lastRange = newRange;
    }

    if ((event.metaKey || event.ctrlKey) && me.isSelected(id)) {
      // ctrl/cmd deselects row if selected
      me.deselectRow(id);
    } else if (me.selectionMode.multiSelect) {
      if (event.shiftKey && me.startCell) {
        // shift appends selected range (if we have previously focused cell)
        mergeRange(me.startCell.id, id);
      } else if (event.ctrlKey || event.metaKey) {
        // ctrl/cmd adds to selection if using multiselect (and not selected)
        me.selectRow({
          record: id,
          scrollIntoView: false,
          addToSelection: true
        });
      }
    }
  } //endregion
  //region Navigation

  /**
   * Triggered from GridNavigation when focus is moved to another cell within the grid. Selects the cell unless
   * modifier keys are pressed, in which case it has already been handled
   * @private
   * @category Selection
   */


  onCellNavigate(me, fromCellSelector, toCellSelector, event, doSelect = true) {
    // CheckColumn events are handled by the CheckColumn itself.
    if (me.columns.getById(toCellSelector.columnId) === me.checkboxSelectionColumn || me.selectionMode.rowCheckboxSelection) {
      return;
    } // 1.do not affect selection if focus is returning to the grid from some widget
    // 2. don't select when left clicking expander icon in a tree


    if (!doSelect || me.returningFocus || event && event.button === 0 && event.target.closest('.b-tree-expander')) {
      return;
    }

    const isSameRecord = fromCellSelector && toCellSelector.id === fromCellSelector.id,
          isMouse = event && event.type === 'mousedown',
          isMouseCtrl = isMouse && event.ctrlKey; // SHIFT for keyboard / mouse and CTRL for mouse events indicate multiselect

    if (event && (!event.button || event.button === 2) && (event.shiftKey || isMouseCtrl)) {
      me.handleMouseMultiSelect(toCellSelector, event);
    } else {
      const clickedSameRecordWithModifierKey = isSameRecord && (!event || event.shiftKey || event.ctrlKey),
            clickedAlreadySelectedRecord = event && me.isSelected(toCellSelector.id),
            clickedWithModifierKey = isMouseCtrl; // We intentionally do not clear existing selection here if clicking a selected record,
      // it's done in onCellClick where we know current interaction is not a drag drop operation

      me.selectCell(toCellSelector, false, clickedSameRecordWithModifierKey || clickedWithModifierKey || clickedAlreadySelectedRecord);
    } // Remember last cell with ctrl pressed


    if (!me.startCell || isMouseCtrl) {
      me.startCell = toCellSelector;
      me.lastRange = null;
    }
  }
  /**
   * Keeps the UI synced with the selectionChange event before firing it out.
   * Event is not fired if the `silent` parameter is truthy.
   * @param {Object} selectionChangeEvent The change event to sync the UI to, and to possibly fire.
   * @param {Boolean} silent Specify `true` to not trigger any the passed.
   * @private
   * @category Selection
   */


  triggerChangeEvent(selectionChangeEvent, silent) {
    const me = this,
          {
      mode,
      selected,
      deselected
    } = selectionChangeEvent,
          {
      checkboxSelectionColumn
    } = me;
    let i, len, row, cell; // Keep the UI up to date with the triggered changes.
    // A mode: 'row' change selects and/or deselects records.

    if (mode === 'row') {
      for (i = 0, len = selected.length; i < len; i++) {
        row = me.getRowFor(selected[i]);

        if (row) {
          row.addCls('b-selected');

          if (checkboxSelectionColumn && !checkboxSelectionColumn.hidden && !selected[i].isSpecialRow) {
            row.getCell(checkboxSelectionColumn.id).widget.checked = true;
          }
        }
      }

      for (i = 0, len = deselected.length; i < len; i++) {
        row = me.getRowFor(deselected[i]);

        if (row) {
          row.removeCls('b-selected');

          if (checkboxSelectionColumn && !checkboxSelectionColumn.hidden && !deselected[i].isSpecialRow) {
            row.getCell(checkboxSelectionColumn.id).widget.checked = false;
          }
        }
      }
    } // A mode: 'cell' change selects and/or deselects *one* cell right now.
    // But we always use an array for future-proofing.
    else if (mode === 'cell') {
      for (i = 0, len = selected.length; i < len; i++) {
        cell = me.getCell(selected[i]);

        if (cell) {
          cell.classList.add('b-selected');
        }
      }

      for (i = 0, len = deselected.length; i < len; i++) {
        cell = me.getCell(deselected[i]);

        if (cell) {
          cell.classList.remove('b-selected');
        }
      }
    }

    if (!silent) {
      me.trigger('selectionChange', selectionChangeEvent);
    }
  }

  onCellClick({
    event,
    record
  }) {
    const me = this;

    if (!me.selectionMode.checkbox && me.selectionMode.multiSelect && !event.shiftKey && !event.metaKey && !event.ctrlKey) {
      me.deselectRows(me.selectedRecords.filter(rec => rec !== record));
    }
  } //endregion
  //region Getters/setters


  doDestroy() {
    var _this$selectedRecordC;

    (_this$selectedRecordC = this.selectedRecordCollection) === null || _this$selectedRecordC === void 0 ? void 0 : _this$selectedRecordC.destroy();
    super.doDestroy();
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {} //endregion


});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridState.js":
/*!******************************************!*\
  !*** ./lib/Grid/view/mixin/GridState.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
 // TODO: prevent multiple rerenders

/**
 * @module Grid/view/mixin/GridState
 */

const suspendStoreEvents = subGrid => subGrid.columns.suspendEvents(),
      resumeStoreEvents = subGrid => subGrid.columns.resumeEvents(),
      fillSubGridColumns = subGrid => {
  subGrid.columns.clearCaches();
  subGrid.columns.fillFromMaster();
},
      compareStateSortIndex = (a, b) => a.stateSortIndex - b.stateSortIndex;
/**
 * Mixin for Grid that handles state. It serializes the following grid properties:
 *
 * * rowHeight
 * * readOnly
 * * selectedCell
 * * selectedRecords
 * * columns (order, widths, visibility)
 * * store (sorters, groupers, filters)
 * * scroll position
 *
 * See {@link Core.mixin.State} for more information on state.
 *
 * @demo Grid/state
 * @inlineexample Grid/view/mixin/GridState.js
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class GridState extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridState';
  }
  /**
   * Gets or sets grid's state. Check out {@link Grid.view.mixin.GridState GridState} mixin for details.
   * @member {Object} state
   */

  /**
   * Get grid's current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
   * selectedRecordId, column states and store state etc.
   * @returns {Object} State object to be serialized
   * @private
   */


  getState() {
    const me = this,
          style = me.element.style.cssText,
          state = {
      rowHeight: me.rowHeight,
      readOnly: me.readOnly
    };

    if (style) {
      state.style = style;
    }

    if (me.selectedCell) {
      // TODO: Create wrapper class to avoid JSON.stringify recursion in state.selectedCell.
      const {
        id,
        columnId
      } = me.selectedCell;
      state.selectedCell = {
        id,
        columnId
      };
    }

    state.selectedRecords = me.selectedRecords.map(entry => entry.id);
    state.columns = me.columns.map(column => column.getState());
    state.store = me.store.state;
    state.scroll = me.storeScroll();
    state.subGrids = {};
    me.eachSubGrid(subGrid => {
      var _subGrid$collapsed;

      const config = state.subGrids[subGrid.region] = state.subGrids[subGrid.region] || {};

      if (subGrid.flex == null) {
        config.width = subGrid.width;
      }

      config.collapsed = (_subGrid$collapsed = subGrid.collapsed) !== null && _subGrid$collapsed !== void 0 ? _subGrid$collapsed : false; // Part of a collapsed SubGrid's state is the state to restore to when expanding again.

      if (config.collapsed) {
        config._beforeCollapseState = subGrid._beforeCollapseState;
      }
    });
    return state;
  }
  /**
   * Apply previously stored state.
   * @param {Object} state
   * @private
   */


  applyState(state) {
    const me = this; // Do this first since it might perform full rendering of contents, recreating filterbar header fields

    if ('columns' in state) {
      let columnsChanged = false,
          needSort = false; // We're going to renderContents anyway, so stop the ColumnStores from updating the UI

      me.columns.suspendEvents();
      me.eachSubGrid(suspendStoreEvents); // each column triggers rerender at least once...

      state.columns.forEach((columnState, index) => {
        const column = me.columns.getById(columnState.id);

        if (column) {
          const columnGeneration = column.generation;
          column.applyState(columnState);
          columnsChanged = columnsChanged || column.generation !== columnGeneration; // In case a sort is needed, stamp in the ordinal position.

          column.stateSortIndex = index; // If we find one out of order, only then do we need to sort

          if (column.allIndex !== index) {
            needSort = columnsChanged = true;
          }
        }
      });

      if (columnsChanged) {
        me.eachSubGrid(fillSubGridColumns);
      }

      if (needSort) {
        me.eachSubGrid(subGrid => {
          subGrid.columns.records.sort(compareStateSortIndex);
          subGrid.columns.allRecords.sort(compareStateSortIndex);
        });
        me.columns.sort({
          fn: compareStateSortIndex,
          // always sort ascending
          ascending: true
        });
      } // If we have been painted, and column restoration changed the column layout, refresh contents


      if (me.isPainted && columnsChanged) {
        me.renderContents();
      } // Allow ColumnStores to update the UI again


      me.columns.resumeEvents();
      me.eachSubGrid(resumeStoreEvents);
    }

    if ('subGrids' in state) {
      me.eachSubGrid(subGrid => {
        if (subGrid.region in state.subGrids) {
          const subGridState = state.subGrids[subGrid.region];

          if ('width' in subGridState) {
            subGrid.width = subGridState.width;
          }

          if ('collapsed' in subGridState) {
            subGrid.collapsed = subGridState.collapsed;
            subGrid._beforeCollapseState = subGridState._beforeCollapseState;
          }
        }
      });
    }

    if ('readOnly' in state) {
      me.readOnly = state.readOnly;
    }

    if ('rowHeight' in state) {
      me.rowHeight = state.rowHeight;
    }

    if ('style' in state) {
      me.style = state.style;
    }

    if ('selectedCell' in state) {
      me.selectedCell = state.selectedCell;
    }

    if ('store' in state) {
      me.store.state = state.store;
    }

    if ('selectedRecords' in state) {
      me.selectedRecords = state.selectedRecords;
    }

    if ('scroll' in state) {
      me.restoreScroll(state.scroll);
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridSubGrids.js":
/*!*********************************************!*\
  !*** ./lib/Grid/view/mixin/GridSubGrids.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _GridBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _SubGrid_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../SubGrid.js */ "./lib/Grid/view/SubGrid.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';







/**
 * @module Grid/view/mixin/GridSubGrids
 */

/**
 * Mixin for grid that handles SubGrids. Each SubGrid is scrollable horizontally separately from the other SubGrids.
 * Having two SubGrids allows you to achieve what is usually called locked or frozen columns.
 *
 * By default a Grid has two SubGrids, one named 'locked' and one 'normal'. The `locked` region has fixed width, while
 * the `normal` region grows to fill all available width (flex).
 *
 * Which SubGrid a column belongs to is determined using its {@link Grid.column.Column#config-region} config. For
 * example to put a column into the locked region, specify `{ region: 'locked' }`. For convenience, a column can be put
 * in the locked region using `{ locked: true }`.
 *
 * ```javascript
 * new Grid({
 *   columns : [
 *     // These two columns both end up in the "locked" region
 *     { field: 'name', text: 'Name', locked: true }
 *     { field: 'age', text: 'Age', region: 'locked' }
 *   ]
 * });
 * ```
 *
 * To customize the SubGrids, use {@link Grid.view.Grid#config-subGridConfigs}:
 *
 * ```javascript
 * // change the predefined subgrids
 * new Grid({
 *   subGridConfigs : {
 *       locked : { flex : 1 } ,
 *       normal : { flex : 3 }
 *   }
 * })
 *
 * // or define your own entirely
 * new Grid({
 *   subGridConfigs : {
 *       a : { width : 150 } ,
 *       b : { flex  : 1 },
 *       c : { width : 150 }
 *   },
 *
 *   columns : [
 *       { field : 'name', text : 'Name', region : 'a' },
 *       ...
 *   ]
 * })
 * ```
 *
 * @demo Grid/lockedcolumns
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class GridSubGrids extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'GridSubGrids';
  }

  static get properties() {
    return {
      /**
       * An object containing the {@link Grid.view.SubGrid} region instances, indexed by subGrid id ('locked', normal'...)
       * @member {Object} subGrids
       * @type {Object}
       * @readonly
       * @category Common
       */
      subGrids: {}
    };
  } //region Init


  changeSubGridConfigs(configs) {
    const me = this,
          usedRegions = new Set();

    for (const column of me.columns) {
      const {
        region
      } = column; // Allow specifying regions for undefined subgrids

      if (region) {
        if (!configs[region]) {
          configs[region] = {};
        }

        usedRegions.add(region);
      }
    } // Implementer has provided configs for other subGrids but not normal, put defaults in place


    if (configs.normal && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isEmpty(configs.normal)) {
      configs.normal = _GridBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].defaultConfig.subGridConfigs.normal;
    }

    for (const region of usedRegions) {
      me.createSubGrid(region, configs[region]);
    } // Add them to Grid


    me.items = me.subGrids;
    return configs;
  }

  createSubGrid(region, config = null) {
    const me = this,
          subGridColumns = me.columns.makeChained(column => column.region === region, ['region']),
          subGridConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      type: 'subgrid',
      id: `${me.id}-${region}Subgrid`,
      grid: me,
      region: region,
      headerClass: me.headerClass,
      footerClass: me.footerClass,
      columns: subGridColumns,
      // Sort by region unless weight is explicitly defined
      weight: region
    }, config || me.subGridConfigs[region]);
    let hasCalculatedWidth = false;

    if (!subGridConfig.flex && !subGridConfig.width) {
      subGridConfig.width = subGridColumns.totalFixedWidth;
      hasCalculatedWidth = true;
    } // Subclasses may inject a type property to create custom SubGrids


    const subGrid = me.subGrids[region] = _SubGrid_js__WEBPACK_IMPORTED_MODULE_3__["default"].create(subGridConfig); // Must be set after creation, otherwise reset in SubGrid#set width

    subGrid.hasCalculatedWidth = hasCalculatedWidth;

    if (region === me.regions[0]) {
      // Have already done lookups for this in a couple of places, might as well store it...
      subGrid.isFirstRegion = true;
    }

    return subGrid;
  } // A SubGrid is added to Grid, add its header etc too


  onChildAdd(subGrid) {
    if (subGrid.isSubGrid) {
      const me = this,
            {
        items,
        headerContainer,
        virtualScrollers,
        footerContainer
      } = me,
            // 2 elements per index, actual element + splitter
      index = items.indexOf(subGrid) * 2;

      if (!me.hideHeaders) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(headerContainer, subGrid.headerSplitter, index);
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(headerContainer, subGrid.header.element, index);
      }

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(virtualScrollers, subGrid.scrollerSplitter, index);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(virtualScrollers, subGrid.virtualScrollerElement, index);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(footerContainer, subGrid.footerSplitter, index);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].insertAt(footerContainer, subGrid.footer.element, index); // Show splitter for all except last (new might not sort last, depending on weight)

      items.forEach((subGrid, i) => {
        if (i < items.length - 1) {
          subGrid.showSplitter();
        }
      });
    }

    return super.onChildAdd(subGrid);
  } // A SubGrid is remove from grid, remove its header etc too


  onChildRemove(subGrid) {
    super.onChildRemove(subGrid);

    if (subGrid.isSubGrid) {
      const {
        items
      } = this;
      delete this.subGrids[subGrid.region];
      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].remove(this.regions, subGrid.region);
      subGrid.destroy(); // Make sure the new last splitter is hidden

      if (items.length) {
        items[items.length - 1].hideSplitter();
      }
    }
  }

  doDestroy() {
    this.eachSubGrid(subGrid => subGrid.destroy());
    super.doDestroy();
  } //endregion
  //region Iteration & calling

  /**
   * Iterate over all subGrids, calling the supplied function for each.
   * @param {Function} fn Function to call for each instance
   * @param {Object} thisObj `this` reference to call the function in, defaults to the subGrid itself
   * @category SubGrid
   * @internal
   */


  eachSubGrid(fn, thisObj = null) {
    this.items.forEach((subGrid, i) => {
      subGrid.isSubGrid && fn.call(thisObj || subGrid, subGrid, i++);
    });
  }
  /**
   * Call a function by name for all subGrids (that have the function).
   * @param {String} fnName Name of function to call, uses the subGrid itself as `this` reference
   * @param params Parameters to call the function with
   * @return {*} Return value from first SubGrid is returned
   * @category SubGrid
   * @internal
   */


  callEachSubGrid(fnName, ...params) {
    // TODO: make object { normal: retval, locked: retval } to return? or store. revisit when needed
    let returnValue = null;
    this.items.forEach((subGrid, i) => {
      if (subGrid[fnName]) {
        const partialReturnValue = subGrid[fnName](...params);
        if (i === 0) returnValue = partialReturnValue;
      }
    });
    return returnValue;
  } //endregion
  //region Getters


  get regions() {
    return this.items.map(item => item.region);
  }
  /**
   * This method should return names of the two last regions in the grid as they are visible in the UI. In case
   * `regions` property cannot be trusted, use different approach. Used by SubGrid and RegionResize to figure out
   * which region should collapse or expand.
   * @returns {String[]}
   * @private
   * @category SubGrid
   */


  getLastRegions() {
    const result = this.regions.slice(-2); // ALWAYS return array of length 2 in order to avoid extra conditions. Normally should not be called with 1 region

    return result.length === 2 ? result : [result[0], result[0]];
  }
  /**
   * This method should return right neighbour for passed region, or left neighbour in case last visible region is passed.
   * This method is used to decide which subgrid should take space of the collapsed one.
   * @param {String} region
   * @returns {String}
   * @private
   * @category SubGrid
   */


  getNextRegion(region) {
    const regions = this.regions; // return next region or next to last

    return regions[regions.indexOf(region) + 1] || regions[regions.length - 2];
  }

  getPreviousRegion(region) {
    return this.regions[this.regions.indexOf(region) - 1];
  }
  /**
   * Returns the subGrid for the specified region.
   * @param {String} region Region, eg. locked or normal (per default)
   * @returns {Grid.view.SubGrid} A subGrid
   * @category SubGrid
   */


  getSubGrid(region) {
    return this.subGrids[region];
  }
  /**
   * Get the SubGrid that contains specified column
   * @param {String|Grid.column.Column} column Column "name" or column object
   * @returns {Grid.view.SubGrid}
   * @category SubGrid
   */


  getSubGridFromColumn(column) {
    column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? column : this.columns.getById(column) || this.columns.get(column);
    return this.getSubGrid(column.region);
  } //endregion

  /**
   * Returns splitter element for subgrid
   * @param {Grid.view.SubGrid|String} subGrid
   * @returns {HTMLElement}
   * @private
   * @category SubGrid
   */


  resolveSplitter(subGrid) {
    const regions = this.getLastRegions();
    let region = subGrid instanceof _SubGrid_js__WEBPACK_IMPORTED_MODULE_3__["default"] ? subGrid.region : subGrid;

    if (regions[1] === region) {
      region = regions[0];
    }

    return this.subGrids[region].splitterElement;
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/column/ResourceCollapseColumn.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/column/ResourceCollapseColumn.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceCollapseColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
var productName = 'gantt';


/**
 * @module Scheduler/column/ResourceCollapseColumn
 */

/**
 * A column toggling the resource {@link Scheduler.model.ResourceModel#field-eventLayout} between `none` and `stack`.
 *
 * @inlineexample Scheduler/column/ResourceCollapseColumn.js
 * @classType resourceCollapse
 * @extends Grid/column/Column
 */

class ResourceCollapseColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceCollapseColumn';
  }

  static get type() {
    return 'resourceCollapse';
  }

  static get defaults() {
    return {
      /** @hideconfigs renderer */
      width: '3em',
      align: 'center',
      sortable: false,
      groupable: false,
      editor: false,
      minWidth: 0,
      cellCls: 'b-resourcecollapse-cell',
      renderer: ({
        record
      }) => ({
        tag: 'i',
        class: {
          'b-icon': 1,
          'b-icon-expand-resource': 1,
          'b-flip': record.eventLayout !== 'none'
        }
      })
    };
  }

  onCellClick({
    record,
    event
  }) {
    // Prevent native scrolling on space key press
    event.preventDefault();
    record.eventLayout = record.eventLayout !== 'none' ? 'none' : 'stack';
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ResourceCollapseColumn);
ResourceCollapseColumn._$name = 'ResourceCollapseColumn';

/***/ }),

/***/ "./lib/Scheduler/column/ResourceInfoColumn.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/column/ResourceInfoColumn.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceInfoColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
var productName = 'gantt';





/**
 * @module Scheduler/column/ResourceInfoColumn
 */

/**
 * Displays basic resource information. Defaults to showing an image + name + event count (all configurable).
 *
 * If a resource has no image, you can either provide an icon using `iconCls` in the data (you then need to specify
 * `image === false` in your data) or the resource initials will be shown.
 *
 * Be sure to specify {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} to instruct the
 * column where to look for the images.
 *
 * If a image fails to load or if a resource lacks an image, the resource name initials will be rendered. If the
 * resource has an {@link Scheduler/model/mixin/ResourceModelMixin#field-eventColor} specified, it will be used as the
 * background color of the initials.
 *
 * @inlineexample Scheduler/column/ResourceInfoColumn.js
 * @classType resourceInfo
 * @extends Grid/column/Column
 */

class ResourceInfoColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceInfoColumn';
  }

  static get type() {
    return 'resourceInfo';
  }

  static get fields() {
    return ['showEventCount', 'showRole', 'showMeta', 'showImage', 'validNames', 'autoScaleThreshold', 'useNameAsImageName'];
  }

  static get defaults() {
    return {
      /** @hideconfigs renderer */

      /**
       * Show image. Looks for image name in fields on the resource in the following order: 'imageUrl', 'image',
       * 'name'. Set `showImage` to a field name to use a custom field. Set `Scheduler.resourceImagePath` to
       * specify where to load images from. If no extension found, defaults to
       * {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImageExtension}.
       * @config {Boolean}
       * @default
       */
      showImage: true,

      /**
       * Show number of events assigned to the resource below the name.
       * @config {Boolean}
       * @default
       */
      showEventCount: true,

      /**
       * A template string to render any extra information about the resource below the name
       * @config {Function}
       * @param {Scheduler.model.ResourceModel} resourceRecord The record representing the current row
       */
      showMeta: null,

      /**
       * Show resource role below the name. Specify `true` to display data from the `role` field, or specify a field
       * name to read this value from.
       * @config {Boolean|String}
       * @default
       */
      showRole: false,

      /**
       * Valid image names. Set to `null` to allow all names.
       * @deprecated This will be removed in 6.0
       * @config {String[]}
       */
      validNames: null,

      /**
       * Specify 0 to prevent the column from adapting its content according to the used row height, or specify a
       * a threshold (row height) at which scaling should start.
       * @config {Number}
       * @default
       */
      autoScaleThreshold: 40,
      field: 'name',
      htmlEncode: false,
      width: 140,
      cellCls: 'b-resourceinfo-cell',
      useNameAsImageName: true,
      editor: _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTestEnv ? false : 'text'
    };
  }

  construct(...args) {
    super.construct(...args);
    this.avatarRendering = new _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
      element: this.grid.element
    });
  }

  doDestroy() {
    super.doDestroy();
    this.avatarRendering.destroy();
  }

  getImageURL(imageName) {
    const resourceImagePath = this.grid.resourceImagePath || '',
          parts = resourceImagePath.split('//'),
          urlPart = parts.length > 1 ? parts[1] : resourceImagePath,
          joined = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].joinPaths([urlPart || '', imageName || '']);
    return parts.length > 1 ? parts[0] + '//' + joined : joined;
  }

  template(resourceRecord, value) {
    const me = this,
          {
      showImage,
      showRole,
      showMeta,
      showEventCount,
      grid
    } = me,
          {
      timeAxis,
      resourceImageExtension = '',
      defaultResourceImageName
    } = grid,
          roleField = typeof showRole === 'string' ? showRole : 'role',
          count = showEventCount && resourceRecord.eventStore.getEvents({
      includeOccurrences: grid.enableRecurringEvents,
      resourceRecord,
      startDate: timeAxis.startDate,
      endDate: timeAxis.endDate
    }).length;
    let imageUrl;

    if (showImage && resourceRecord.image !== false) {
      if (resourceRecord.imageUrl) {
        imageUrl = resourceRecord.imageUrl;
      } else {
        // record.image is supposed to be a file name, located at resourceImagePath
        const imageName = typeof showImage === 'string' ? showImage : resourceRecord.image || value && me.useNameAsImageName && value.toLowerCase() + resourceImageExtension || defaultResourceImageName || '';
        imageUrl = imageName && me.getImageURL(imageName); // Image name should have an extension

        if (imageUrl && !imageName.includes('.')) {
          // If validNames is specified, check that imageName is valid
          if (!me.validNames || me.validNames.includes(imageName)) {
            imageUrl += resourceImageExtension;
          }
        }
      }
    }

    value = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(value);
    return {
      class: 'b-resource-info',
      children: [showImage && me.avatarRendering.getResourceAvatar({
        initials: resourceRecord.initials,
        color: resourceRecord.eventColor,
        iconCls: resourceRecord.iconCls,
        imageUrl,
        defaultImageUrl: defaultResourceImageName && this.getImageURL(defaultResourceImageName)
      }), showRole || showEventCount || showMeta ? {
        tag: 'dl',
        children: [{
          tag: 'dt',
          html: value
        }, showRole ? {
          tag: 'dd',
          class: 'b-resource-role',
          html: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(resourceRecord[roleField])
        } : null, showEventCount ? {
          tag: 'dd',
          class: 'b-resource-events',
          html: me.L('L{eventCountText}', count)
        } : null, showMeta ? {
          tag: 'dd',
          class: 'b-resource-meta',
          html: me.showMeta(resourceRecord)
        } : null]
      } : value]
    };
  }

  defaultRenderer({
    grid,
    record,
    cellElement,
    value,
    isExport
  }) {
    let result;

    if (record.isSpecialRow) {
      result = '';
    } else if (isExport) {
      result = value;
    } else {
      if (this.autoScaleThreshold && grid.rowHeight < this.autoScaleThreshold) {
        cellElement.style.fontSize = grid.rowHeight / 40 + 'em';
      } else {
        cellElement.style.fontSize = '';
      }

      result = this.template(record, value);
    }

    return result;
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ResourceInfoColumn);
ResourceInfoColumn._$name = 'ResourceInfoColumn';

/***/ }),

/***/ "./lib/Scheduler/column/TimeAxisColumn.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/column/TimeAxisColumn.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisColumn; });
/* harmony import */ var _Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/WidgetColumn.js */ "./lib/Grid/column/WidgetColumn.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../view/HorizontalTimeAxis.js */ "./lib/Scheduler/view/HorizontalTimeAxis.js");
/* harmony import */ var _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../view/ResourceHeader.js */ "./lib/Scheduler/view/ResourceHeader.js");
var productName = 'gantt';





/**
 * @module Scheduler/column/TimeAxisColumn
 */

/**
 * A column containing the timeline "viewport", in which events, dependencies etc are drawn.
 * Normally you do not need to interact with or create this column, it is handled by Scheduler.
 *
 * If you wish to output custom contents inside the time axis row cells, you can provide your custom column configuration
 * using the {@link #config-renderer} like so:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *    appendTo         : document.body
 *    columns          : [
 *       { text : 'Name', field : 'name', width : 130 },
 *       {
 *           type : 'timeAxis',
 *           renderer({ record, cellElement }) {
 *               return '<div class="cool-chart"></div>';
 *           }
 *       }
 *    ]
 * });
 * ```
 * @extends Grid/column/WidgetColumn
 */

class TimeAxisColumn extends Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  // region Events

  /**
   * DEPRECATED: Listen to this event on the Scheduler / Gantt component owning this column
   * @deprecated 4.1.1
   * @event timeAxisHeaderClick
   * @param {Scheduler.column.TimeAxisColumn} column The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */

  /**
   * DEPRECATED: Listen to this event on the Scheduler / Gantt component owning this column
   * @deprecated 4.1.1
   * @event timeAxisHeaderDblClick
   * @param {Scheduler.column.TimeAxisColumn} column The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */

  /**
   * DEPRECATED: Listen to this event on the Scheduler / Gantt component owning this column
   * @deprecated 4.1.1
   * @event timeAxisHeaderContextMenu
   * @param {Scheduler.column.TimeAxisColumn} column The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */
  //endregion
  //region Config
  static get fields() {
    return ['mode'];
  }

  static get defaults() {
    return {
      /**
       * Set to false to prevent this column header from being dragged.
       * @config {Boolean} draggable
       * @category Interaction
       * @default false
       */
      draggable: false,

      /**
       * Set to false to prevent grouping by this column.
       * @config {Boolean} groupable
       * @category Interaction
       * @default false
       */
      groupable: false,

      /**
       * Allow column visibility to be toggled through UI.
       * @config {Boolean} hideable
       * @default false
       * @category Interaction
       */
      hideable: false,

      /**
       * Show column picker for the column.
       * @config {Boolean} showColumnPicker
       * @default false
       * @category Menu
       */
      showColumnPicker: false,

      /**
       * Allow filtering data in the column (if Filter feature is enabled)
       * @config {Boolean} filterable
       * @default false
       * @category Interaction
       */
      filterable: false,

      /**
       * Allow sorting of data in the column
       * @config {Boolean} sortable
       * @category Interaction
       * @default false
       */
      sortable: false,

      /**
       * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
       * @config {Boolean} resizable
       * @default false
       * @category Interaction
       */
      resizable: false,

      /**
       * Allow searching in the column (respected by QuickFind and Search features)
       * @config {Boolean} searchable
       * @default false
       * @category Interaction
       */
      searchable: false,

      /**
       * @config {String} editor
       * @hide
       */
      editor: false,

      /**
       * Set to `true` to show a context menu on the cell elements in this column
       * @config {Boolean} enableCellContextMenu
       * @default false
       * @category Menu
       */
      enableCellContextMenu: false,

      /**
       * @config {Function|Boolean} tooltipRenderer
       * @hide
       */
      tooltipRenderer: false,

      /**
       * CSS class added to the header of this column
       * @config {String} cls
       * @category Rendering
       * @default 'b-sch-timeaxiscolumn'
       */
      cls: 'b-sch-timeaxiscolumn',
      // needs to have width specified, flex-basis messes measurements up
      needWidth: true,
      mode: null,
      region: 'normal',
      exportable: false,
      htmlEncode: false
    };
  }

  static get type() {
    return 'timeAxis';
  } //region Init


  construct(config) {
    const me = this;
    super.construct(...arguments);
    me.thisObj = me;
    me.timeAxisViewModel = me.grid.timeAxisViewModel; // A bit hacky, because mode is a field and not a config
    // eslint-disable-next-line no-self-assign

    me.mode = me.mode;
    me.grid.on({
      paint: 'onTimelinePaint',
      thisObj: me,
      once: true
    });
  }

  static get autoExposeFields() {
    return true;
  } // endregion


  doDestroy() {
    var _this$resourceColumns, _this$timeAxisView;

    (_this$resourceColumns = this.resourceColumns) === null || _this$resourceColumns === void 0 ? void 0 : _this$resourceColumns.destroy();
    (_this$timeAxisView = this.timeAxisView) === null || _this$timeAxisView === void 0 ? void 0 : _this$timeAxisView.destroy();
    super.doDestroy();
  }

  set mode(mode) {
    const me = this,
          {
      grid
    } = me;
    me.set('mode', mode); // In horizontal mode this column has a time axis header on top, with timeline ticks

    if (mode === 'horizontal') {
      me.timeAxisView = new _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        model: me.timeAxisViewModel,
        compactCellWidthThreshold: me.compactCellWidthThreshold,
        owner: me.grid,
        client: me.grid
      });
    } // In vertical mode, it instead displays resources at top
    else if (mode === 'vertical') {
      // TODO: Most other vertical stuff is handled in VerticalRendering, move there?
      me.resourceColumns = _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
        column: me,
        resourceStore: grid.resourceStore,
        imagePath: grid.resourceImagePath,
        imageExtension: grid.resourceImageExtension,
        defaultImageName: grid.defaultResourceImageName
      }, grid.resourceColumns || {});
      me.relayEvents(me.resourceColumns, ['resourceheaderclick', 'resourceheaderdblclick', 'resourceheadercontextmenu']);
    }
  }

  get mode() {
    return this.get('mode');
  } // TODO: define all configs as fields and set below to false...
  //region Events


  onViewModelUpdate({
    source: viewModel
  }) {
    const me = this;

    if (me.mode === 'horizontal') {
      // render the time axis view into the column header element
      me.refreshHeader(true);
      me.width = viewModel.totalSize;
      me.grid.refresh(); // When width is set above, that ends up on a columnsResized listener, but the refreshing of the fake
      // scrollers to accommodate the new width is not done in this timeframe, so the upcoming centering related
      // to preset change cannot work. So we have to refresh the fake scrollers now

      me.subGrid.refreshFakeScroll();
    } else if (me.mode === 'vertical') {
      // Refresh to rerender cells, in the process updating the vertical timeaxis to reflect view model changes
      me.grid.refreshRows();
    }
  } // Called on paint. SubGrid has its width so this is the earliest time to configure the TimeAxisViewModel with
  // correct width


  onTimelinePaint({
    firstPaint
  }) {
    const me = this;

    if (!me.subGrid.insertRowsBefore) {
      return;
    }

    if (firstPaint) {
      me.subGridElement.classList.add('b-timeline-subgrid');

      if (me.mode === 'vertical') {
        var _me$grid;

        me.refreshHeader(); // The above operation can cause height change.

        (_me$grid = me.grid) === null || _me$grid === void 0 ? void 0 : _me$grid.onHeightChange();
      }
    }
  } //endregion
  //region Rendering

  /**
   * Refreshes the columns header contents (which is either a HorizontalTimeAxis or a ResourceHeader). Useful if you
   * have rendered some extra meta data that depends on external data such as the EventStore or ResourceStore.
   */


  refreshHeader(internal) {
    const me = this,
          {
      element
    } = me;

    if (element) {
      if (me.mode === 'horizontal') {
        // Force timeAxisViewModel to regenerate its column config, which calls header renderers etc.
        !internal && me.timeAxisViewModel.update(undefined, undefined, true);

        if (!me.timeAxisView.rendered) {
          // Do not need the normal header markup
          element.innerHTML = '';
          me.timeAxisView.render(element);
        } else {
          // Force rebuild of cells in case external data has changed (cheap since it still syncs to DOM)
          me.timeAxisView.refresh(true);
        }
      } else if (me.mode === 'vertical') {
        if (!me.resourceColumns.currentElement) {
          // Do not need the normal header markup
          element.innerHTML = '';
          me.resourceColumns.render(element);
        } // Vertical's resourceColumns is redrawn with the events, no need here

      }
    }
  }

  internalRenderer(renderData) {
    // No drawing of events before engines initial commit
    if (this.grid.project.isInitialCommitPerformed) {
      this.grid.currentOrientation.renderer(renderData);
      return super.internalRenderer(renderData);
    }
  } //endregion


  get timeAxisViewModel() {
    return this._timeAxisViewModel;
  }

  set timeAxisViewModel(timeAxisViewModel) {
    this.detachListeners('tavm');
    timeAxisViewModel === null || timeAxisViewModel === void 0 ? void 0 : timeAxisViewModel.on({
      name: 'tavm',
      update: 'onViewModelUpdate',
      prio: -10000,
      thisObj: this
    });
    this._timeAxisViewModel = timeAxisViewModel;

    if (this.timeAxisView) {
      this.timeAxisView.model = timeAxisViewModel;
    }
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(TimeAxisColumn);
TimeAxisColumn._$name = 'TimeAxisColumn';

/***/ }),

/***/ "./lib/Scheduler/column/VerticalTimeAxisColumn.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/column/VerticalTimeAxisColumn.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalTimeAxisColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../view/VerticalTimeAxis.js */ "./lib/Scheduler/view/VerticalTimeAxis.js");
var productName = 'gantt';



/**
 * @module Scheduler/column/VerticalTimeAxisColumn
 */

/**
 * A column containing the time axis labels for vertical mode. Normally you do not need to interact with or
 * create this column, it is handled by Scheduler/Gantt.
 *
 * @extends Grid/column/Column
 */

class VerticalTimeAxisColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'verticalTimeAxis';
  }

  static get defaults() {
    return {
      /**
       * Set to false to prevent this column header from being dragged.
       * @config {Boolean} draggable
       * @category Interaction
       * @default false
       * @hide
       */
      draggable: false,

      /**
       * Set to false to prevent grouping by this column.
       * @config {Boolean} groupable
       * @category Interaction
       * @default false
       * @hide
       */
      groupable: false,

      /**
       * Allow column visibility to be toggled through UI.
       * @config {Boolean} hideable
       * @default false
       * @category Interaction
       * @hide
       */
      hideable: false,

      /**
       * Show column picker for the column.
       * @config {Boolean} showColumnPicker
       * @default false
       * @category Menu
       * @hide
       */
      showColumnPicker: false,

      /**
       * Allow filtering data in the column (if Filter feature is enabled)
       * @config {Boolean} filterable
       * @default false
       * @category Interaction
       * @hide
       */
      filterable: false,

      /**
       * Allow sorting of data in the column
       * @config {Boolean} sortable
       * @category Interaction
       * @default false
       * @hide
       */
      sortable: false,
      // /**
      //  * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
      //  * @config {Boolean} resizable
      //  * @default false
      //  * @category Interaction
      //  * @hide
      //  */
      // resizable : false,

      /**
       * Allow searching in the column (respected by QuickFind and Search features)
       * @config {Boolean} searchable
       * @default false
       * @category Interaction
       * @hide
       */
      searchable: false,

      /**
       * Specifies if this column should be editable, and define which editor to use for editing cells in the column (if CellEdit feature is enabled)
       * @config {String} editor
       * @default false
       * @category Interaction
       * @hide
       */
      editor: false,

      /**
       * Set to `true` to show a context menu on the cell elements in this column
       * @config {Boolean} enableCellContextMenu
       * @default false
       * @category Menu
       * @hide
       */
      enableCellContextMenu: false,

      /**
       * @config {Function} tooltipRenderer
       * @hide
       */
      tooltipRenderer: false,

      /**
       * Column minimal width. If value is Number then minimal width is in pixels
       * @config {Number|String} minWidth
       * @default 0
       * @category Layout
       */
      minWidth: 0,
      resizable: false,
      cellCls: 'b-verticaltimeaxiscolumn',
      flex: 1
    };
  }

  get isFocusable() {
    return false;
  }

  construct(data) {
    super.construct(...arguments);
    this.view = new _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      model: this.grid.timeAxisViewModel,
      client: this.grid
    });
  }

  renderer({
    cellElement,
    size
  }) {
    this.view.render(cellElement);
    size.height = this.view.height;
  }

}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(VerticalTimeAxisColumn);
VerticalTimeAxisColumn._$name = 'VerticalTimeAxisColumn';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManager.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManager.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractCrudManager; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';




/**
 * @module Scheduler/crud/AbstractCrudManager
 */

/**
 * This is an abstract class serving as the base for the {@link Scheduler.data.CrudManager} class.
 * It implements basic mechanisms to organize batch communication with a server.
 * Yet it does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes by consuming the appropriate mixins.
 *
 * For example, this is how the class can be used to implement an JSON encoding system:
 *
 * ```javascript
 * // let's make new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {
 *
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 *
 * These are methods that must be provided by subclasses of this class:
 *
 * - [#sendRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-sendRequest)
 * - [#cancelRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-cancelRequest)
 * - [#encode](#Scheduler/crud/AbstractCrudManagerMixin#function-encode)
 * - [#decode](#Scheduler/crud/AbstractCrudManagerMixin#function-decode)
 *
 * @extends Core/Base
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @abstract
 */

class AbstractCrudManager extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Default config

  /**
   * The server revision stamp.
   * The _revision stamp_ is a number which should be incremented after each server-side change.
   * This property reflects the current version of the data retrieved from the server and gets updated after each {@link Scheduler/crud/AbstractCrudManagerMixin#function-load} and {@link Scheduler/crud/AbstractCrudManagerMixin#function-sync} call.
   * @property {Number}
   * @readonly
   */
  get revision() {
    return this.crudRevision;
  }

  set revision(value) {
    this.crudRevision = value;
  }
  /**
   * Get or set data of {@link #property-crudStores} as a JSON string.
   *
   * Get a JSON string:
   * ```javascript
   *
   * const jsonString = scheduler.crudManager.json;
   *
   * // returned jsonString:
   * '{"eventsData":[...],"resourcesData":[...],...}'
   *
   * // object representation of the returned jsonString:
   * {
   *     resourcesData    : [...],
   *     eventsData       : [...],
   *     assignmentsData  : [...],
   *     dependenciesData : [...],
   *     timeRangesData   : [...],
   *     // data from other stores
   * }
   * ```
   *
   * Set a JSON string (to populate the CrudManager stores):
   *
   * ```javascript
   * scheduler.crudManager.json = '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * @property {String}
   */


  get json() {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].safeJsonStringify(this);
  }

  set json(json) {
    if (typeof json === 'string') {
      json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].safeJsonParse(json);
    }

    this.forEachCrudStore(store => {
      const dataName = `${store.storeId}Data`;

      if (json[dataName]) {
        store.data = json[dataName];
      }
    });
  }

  static get defaultConfig() {
    return {
      /**
       * Sets the list of stores controlled by the CRUD manager.
       *
       * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
       * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
       *
       * Store can be provided by itself, its storeId or an object having the following structure:
       * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
       * @property {Core.data.Store} stores.store The store itself.
       * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
       * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
       * @config {Core.data.Store[]|String[]|Object[]}
       */
      stores: null
      /**
       * Encodes request to the server.
       * @function encode
       * @param {Object} request The request to encode.
       * @returns {String} The encoded request.
       * @abstract
       */

      /**
       * Decodes response from the server.
       * @function decode
       * @param {String} response The response to decode.
       * @returns {Object} The decoded response.
       * @abstract
       */

    };
  } //endregion
  //region Init


  construct(config = {}) {
    if (config.stores) {
      config.crudStores = config.stores;
      delete config.stores;
    }

    super.construct(config);
  } //endregion
  //region inline data

  /**
   * Returns the data from all CrudManager `crudStores` in a format that can be consumed by `inlineData`.
   *
   * Used by JSON.stringify to correctly convert this CrudManager to json.
   *
   * The returned data is identical to what {@link Scheduler/crud/AbstractCrudManager#property-inlineData} contains.
   *
   * ```javascript
   *
   * const json = scheduler.crudManager.toJSON();
   *
   * // json:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...],
   *     timeRangesData : [...],
   *     resourceTimeRangesData : [...],
   *     // ... other stores data
   * }
   * ```
   *
   * Output can be consumed by `inlineData`.
   *
   * ```javascript
   * const json = scheduler.crudManager.toJSON();
   *
   * // Plug it back in later
   * scheduler.crudManager.inlineData = json;
   * ```
   *
   * @function toJSON
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    // Collect data from crudStores
    const result = {};
    this.forEachCrudStore((store, storeId) => result[`${storeId}Data`] = store.toJSON());
    return result;
  }
  /**
   * Get or set data of CrudManager stores. The returned data is identical to what
   * {@link Scheduler/crud/AbstractCrudManager#function-toJSON} returns:
   *
   * ```javascript
   *
   * const data = scheduler.crudManager.inlineData;
   *
   * // data:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...],
   *     timeRangesData : [...],
   *     resourceTimeRangesData : [...],
   *     ... other stores data
   * }
   *
   *
   * // Plug it back in later
   * scheduler.crudManager.inlineData = data;
   * ```
   *
   * @property {Object}
   */


  get inlineData() {
    return this.toJSON();
  }

  set inlineData(data) {
    this.json = data;
  } //endregion
  //region Store collection (add, remove, get & iterate)


  set stores(stores) {
    if (stores !== this.crudStores) {
      this.crudStores = stores;
    }
  }
  /**
   * A list of registered stores whose server communication will be collected into a single batch.
   * Each store is represented by a _store descriptor_, an object having following structure:
   * @member {Object[]} stores
   * @property {String} stores.storeId Unique store identifier.
   * @property {Core.data.Store} stores.store Store itself.
   * @property {String} [stores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
   * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
   */


  get stores() {
    return this.crudStores;
  } //endregion

  /**
   * Returns true if the crud manager is currently loading data
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isLoading() {
    return this.isCrudManagerLoading;
  }
  /**
   * DEPRECATED in favor of {@link #function-acceptChanges}
   */


  commit() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', 'commit is deprecated, in favor of acceptChanges');
    this.commitCrudStores();
  }
  /**
   * DEPRECATED in favor of {@link #function-revertChanges}
   */


  reject() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', 'reject is deprecated, in favor of revertChanges');
    this.revertChanges();
  }
  /**
   * Adds a store to the collection.
   *
   *```javascript
   * // append stores to the end of collection
   * crudManager.addStore([
   *     store1,
   *     // storeId
   *     'bar',
   *     // store descriptor
   *     {
   *         storeId : 'foo',
   *         store   : store3
   *     },
   *     {
   *         storeId         : 'bar',
   *         store           : store4,
   *         // to write all fields of modified records
   *         writeAllFields  : true
   *     }
   * ]);
   *```
   *
   * **Note:** Order in which stores are kept in the collection is very essential sometimes.
   * Exactly in this order the loaded data will be put into each store.
   *
   * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
   * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
   *
   * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
   * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
   * The _store descriptor_ is an object having following properties:
   * @param {String} store.storeId The store identifier that will be used as a key in requests.
   * @param {Core.data.Store} store.store The store itself.
   * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
   * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
   * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
   * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
   * If not specified then store(s) will be appended to the end of collection.
   * Otherwise it will be just a position in stores collection.
   *
   * ```javascript
   * // insert stores store4, store5 to the start of collection
   * crudManager.addStore([ store4, store5 ], 0);
   * ```
   *
   * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link Scheduler/crud/AbstractCrudManagerMixin#function-getStoreDescriptor} call).
   *
   * ```javascript
   * // insert store6 just before a store having storeId equal to 'foo'
   * crudManager.addStore(store6, 0, 'foo');
   *
   * // insert store7 just after store3 store
   * crudManager.addStore(store7, 1, store3);
   * ```
   */


  addStore(...args) {
    return this.addCrudStore(...args);
  }

  removeStore(...args) {
    return this.removeCrudStore(...args);
  }

  getStore(...args) {
    return this.getCrudStore(...args);
  }

  hasChanges(...args) {
    return this.crudStoreHasChanges(...args);
  }

  loadData(...args) {
    return this.loadCrudManagerData(...args);
  }

}
AbstractCrudManager._$name = 'AbstractCrudManager';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManagerMixin.js ***!
  \********************************************************/
/*! exports provided: AbstractCrudManagerError, CrudManagerRequestError, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerError", function() { return AbstractCrudManagerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrudManagerRequestError", function() { return CrudManagerRequestError; });
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/AbstractCrudManagerValidation.js */ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';










/**
 * @module Scheduler/crud/AbstractCrudManagerMixin
 */

class AbstractCrudManagerError extends Error {}
class CrudManagerRequestError extends AbstractCrudManagerError {
  constructor(cfg = {}) {
    var _cfg$request, _this$request;

    super(cfg.message || cfg.request && _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize((_cfg$request = cfg.request) === null || _cfg$request === void 0 ? void 0 : _cfg$request.type) + ' failed' || 'Crud Manager request failed');
    Object.assign(this, cfg);
    this.action = (_this$request = this.request) === null || _this$request === void 0 ? void 0 : _this$request.type;
  }

}

const storeSortFn = function (lhs, rhs, sortProperty) {
  // TODO: get rid of these StoreDescriptors. Just use Stores.
  if (lhs.store) {
    lhs = lhs.store;
  }

  if (rhs.store) {
    rhs = rhs.store;
  }

  lhs = lhs[sortProperty] || 0;
  rhs = rhs[sortProperty] || 0;
  return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
},
      // Sorter function to keep stores in loadPriority order
storeLoadSortFn = function (lhs, rhs) {
  return storeSortFn(lhs, rhs, 'loadPriority');
},
      // Sorter function to keep stores in syncPriority order
storeSyncSortFn = function (lhs, rhs) {
  return storeSortFn(lhs, rhs, 'syncPriority');
};
/**
 * An abstract mixin that supplies most of the CrudManager functionality.
 * It implements basic mechanisms of collecting stores to organize batch communication with a server.
 * It does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes.
 * Out of the box there are mixins implementing {@link Scheduler/crud/transport/AjaxTransport support of AJAX for data transferring}
 * and {@link Scheduler/crud/encoder/JsonEncoder JSON for data encoding system}.
 * For example this is how we make a model that will implement CrudManager protocol and use AJAX/JSON to pass the dada to the server:
 *
 * ```javascript
 * class SystemSettings extends JsonEncode(AjaxTransport(AbstractCrudManagerMixin(Model))) {
 *     ...
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 *
 * These are methods that must be provided by subclasses of this class:
 *
 * - {@link #function-sendRequest}
 * - {@link #function-cancelRequest}
 * - {@link #function-encode}
 * - {@link #function-decode}
 *
 * @mixin
 * @mixes Core/mixin/Delayable
 * @mixes Core/mixin/Events
 * @mixes Scheduler/crud/mixin/AbstractCrudManagerValidation
 * @abstract
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => {
  // Trigger $meta calculation to get up-to-date is "isXXX" flags
  // (kinky construction to avoid production minification faced in Angular https://github.com/bryntum/support/issues/2889)
  Target.$$meta = Target.$meta;
  const mixins = []; // These two mixins are mixed in the Scheduling Engine code ..but in its own way
  // so that Base.mixin() cannot understand that they are already there and applies them 2nd time

  if (!Target.isEvents) {
    mixins.push(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"]);
  }

  if (!Target.isDelayable) {
    mixins.push(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]);
  }

  mixins.push(_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
  return class AbstractCrudManagerMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]).mixin(...mixins) {
    /**
     * Fires before server response gets applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeResponseApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {String} requestType The request type (`sync` or `load`).
     * @param {Object} response The decoded server response object.
     */

    /**
     * Fires before loaded data get applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeLoadApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {Object} response The decoded server response object.
     * @param {Object} options Options provided to the {@link #function-load} method.
     */

    /**
     * Fires before sync response data get applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeSyncApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {Object} response The decoded server response object.
     */
    static get $name() {
      return 'AbstractCrudManagerMixin';
    } //region Default config


    static get defaultConfig() {
      return {
        /**
         * The server revision stamp.
         * The _revision stamp_ is a number which should be incremented after each server-side change.
         * This property reflects the current version of the data retrieved from the server and gets updated after each {@link #function-load} and {@link #function-sync} call.
         * @property {Number}
         * @readonly
         */
        crudRevision: null,

        /**
         * A list of registered stores whose server communication will be collected into a single batch.
         * Each store is represented by a _store descriptor_, an object having following structure:
         * @member {Object[]} crudStores
         * @property {String} crudStores.storeId Unique store identifier.
         * @property {Core.data.Store} crudStores.store Store itself.
         * @property {String} [crudStores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
         * @property {String} [crudStores.idField] id field name, if it's not specified then class will try to get it from a store model.
         */

        /**
         * Sets the list of stores controlled by the CRUD manager.
         *
         * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
         * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
         *
         * Store can be provided by itself, its storeId or an object having the following structure:
         * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
         * @property {Core.data.Store} stores.store The store itself.
         * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
         * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
         * @config {Core.data.Store[]|String[]|Object[]}
         */
        crudStores: [],

        /**
         * Name of a store property to retrieve store identifiers from.
         * Store identifier is used as a container name holding corresponding store data while transferring them to/from the server.
         * By default `storeId` property is used. And in case a container identifier has to differ this config can be used:
         *
         * ```javascript
         * class CatStore extends Store {
         *     // storeId is "meow" but for sending/receiving store data
         *     // we want have "cats" container in JSON, so we create a new property "storeIdForCrud"
         *     storeId          : 'meow',
         *     storeIdForCrud   : 'cats'
         * });
         *
         * class MyCrudManager extends CrudManager {
         *     ...
         *     crudStores           : ['meow'],
         *     // crud manager will get store identifier from "storeIdForCrud" property
         *     storeIdProperty  : 'storeIdForCrud'
         * });
         * ```
         * The `storeIdProperty` property can also be specified directly on a store:
         *
         * ```javascript
         * class CatStore extends Store {
         *     // storeId is "meow" but for sending/receiving store data
         *     // we want have "cats" container in JSON
         *     storeId          : 'meow',
         *     // so we create a new property "storeIdForCrud"..
         *     storeIdForCrud  : 'cats',
         *     // and point CrudManager to use it as the store identifier source
         *     storeIdProperty  : 'storeIdForCrud'
         * });
         *
         * class DogStore extends Store {
         *     // storeId is "dogs" and it will be used as a container name for the store data
         *     storeId          : 'dogs'
         * });
         *
         * class MyCrudManager extends CrudManager {
         *     ...
         *     crudStores           : ['meow', 'dogs']
         * });
         * ```
         * @config {String}
         */
        storeIdProperty: 'storeId',
        // TODO: no support for remote filtering yet
        // /**
        //  * The name of the 'filter' parameter to send in a load request.
        //  * @config {String}
        //  * @default
        //  */
        crudFilterParam: 'filter',

        /**
         * Sends request to the server.
         * @function sendRequest
         * @param {Object} request The request to send. An object having following properties:
         * @param {String} request.data {@link #function-encode Encoded} request.
         * @param {String} request.type Request type, can be either `load` or `sync`
         * @param {Function} request.success Callback to be started on successful request transferring
         * @param {Function} request.failure Callback to be started on request transfer failure
         * @param {Object} request.thisObj `this` reference for the above `success` and `failure` callbacks
         * @return {Promise} The request promise.
         * @abstract
         */

        /**
         * Cancels request to the server.
         * @function cancelRequest
         * @param {Promise} promise The request promise to cancel (a value returned by corresponding {@link #function-sendRequest} call).
         * @param {Function} reject Reject handle of the corresponding promise
         * @abstract
         */

        /**
         * Encodes request to the server.
         * @function encode
         * @param {Object} request The request to encode.
         * @returns {String} The encoded request.
         * @abstract
         */

        /**
         * Decodes response from the server.
         * @function decode
         * @param {String} response The response to decode.
         * @returns {Object} The decoded response.
         * @abstract
         */
        transport: {},

        /**
         * When `true` forces the CRUD manager to process responses depending on their `type` attribute.
         * So `load` request may be responded with `sync` response for example.
         * Can be used for smart server logic allowing the server to decide when it's better to respond with a complete data set (`load` response)
         * or it's enough to return just a delta (`sync` response).
         * @config {Boolean}
         * @default
         */
        trackResponseType: false,

        /**
         * When `true` the Crud Manager does not require
         * all updated and removed records to be mentioned in the *sync* response.
         * In this case response should include only server side changes.
         *
         * **Please note that added records should still be mentioned in response
         * to provide real identifier instead of the phantom one.**
         * @config {Boolean}
         * @default
         */
        supportShortSyncResponse: true,

        /**
         * Field name to be used to transfer a phantom record identifier.
         * @config {String}
         * @default
         */
        phantomIdField: '$PhantomId',

        /**
         * Field name to be used to transfer a phantom parent record identifier.
         * @config {String}
         * @default
         */
        phantomParentIdField: '$PhantomParentId',

        /**
         * `true` to automatically call {@link #function-load} method after creation.
         * @config {Boolean}
         * @default
         */
        autoLoad: false,

        /**
         * The timeout in milliseconds to wait before persisting changes to the server.
         * Used when {@link #config-autoSync} is set to `true`.
         * @config {Number}
         * @default
         */
        autoSyncTimeout: 100,

        /**
         * `true` to automatically persist store changes after edits are made in any of the stores monitored.
         * Please note that sync request will not be invoked immediately but only after {@link #config-autoSyncTimeout} interval.
         * @config {Boolean}
         * @default
         */
        autoSync: false,

        /**
         * `True` to reset identifiers (defined by `idField` config) of phantom records before submitting them to the server.
         * @config {Boolean}
         * @default
         */
        resetIdsBeforeSync: true,

        /**
         * @member {Object[]} syncApplySequence
         * An array of stores presenting an alternative sync responses apply order.
         * Each store is represented by a _store descriptor_, an object having following structure:
         * @property {String} syncApplySequence.storeId Unique store identifier.
         * @property {Core.data.Store} syncApplySequence.store Store itself.
         * @property {String} [syncApplySequence.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
         * @property {String} [syncApplySequence.idField] id field name, if it's not specified then class will try to get it from a store model.
         */

        /**
         * An array of store identifiers sets an alternative sync responses apply order.
         * By default the order in which sync responses are applied to the stores is the same as they registered in.
         * But in case of some tricky dependencies between stores this order can be changed:
         *
         *```javascript
        * class MyCrudManager extends CrudManager {
        *     // register stores (they will be loaded in the same order: 'store1' then 'store2' and finally 'store3')
        *     crudStores : ['store1', 'store2', 'store3'],
        *     // but we apply changes from server to them in an opposite order
        *     syncApplySequence : ['store3', 'store2', 'store1']
        * });
        *```
        * @config {String[]}
        */
        syncApplySequence: [],
        orderedCrudStores: [],

        /**
         * `true` to write all fields from the record to the server.
         * If set to `false` it will only send the fields that
         * were modified.
         * Note that any fields that have {@link Core/data/field/DataField#config-persist} set to `false` will still be ignored and fields
         * having {@link Core/data/field/DataField#config-alwaysWrite} set to `true` will always be included.
         * @config {Boolean}
         * @default
         */
        writeAllFields: false,
        crudIgnoreUpdates: 0,
        autoSyncSuspendCounter: 0,
        // Flag that shows if crud manager performed successful load request
        crudLoaded: false,
        autoSyncTimerId: null,
        applyingLoadResponse: false,
        applyingSyncResponse: false,
        callOnFunctions: true
      };
    }

    get isCrudManager() {
      return true;
    } //endregion
    //region Init


    construct(config = {}) {
      this._requestId = 0;
      this.activeRequests = {};
      this.crudStoresIndex = {};
      super.construct(config);
    }

    afterConstruct() {
      super.afterConstruct();

      if (this.autoLoad) {
        this._autoLoadPromise = this.doAutoLoad();
      }
    } //endregion
    //region Load


    doAutoLoad() {
      return this.load().catch(error => {});
    } //endregion
    //region Store descriptors & index

    /**
     * Returns a registered store descriptor.
     * @param {String|Core.data.Store} storeId The store identifier or registered store instance.
     * @returns {Object} The descriptor of the store.
     */


    getStoreDescriptor(storeId) {
      if (!storeId) return null;
      if (storeId instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) return this.crudStores.find(storeDesc => storeDesc.store === storeId);
      if (typeof storeId === 'object') return this.crudStoresIndex[storeId.storeId];
      return this.crudStoresIndex[storeId] || this.getStoreDescriptor(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(storeId));
    }

    fillStoreDescriptor(descriptor) {
      const {
        store
      } = descriptor,
            {
        storeIdProperty = this.storeIdProperty,
        modelClass
      } = store;

      if (!descriptor.storeId) {
        descriptor.storeId = store[storeIdProperty];
      }

      if (!descriptor.idField) {
        descriptor.idField = modelClass.idField;
      }

      if (!descriptor.phantomIdField) {
        descriptor.phantomIdField = modelClass.phantomIdField;
      }

      if (!descriptor.phantomParentIdField) {
        descriptor.phantomParentIdField = modelClass.phantomParentIdField;
      }

      if (!('writeAllFields' in descriptor)) {
        descriptor.writeAllFields = store.writeAllFields;
      }

      return descriptor;
    }

    updateCrudStoreIndex() {
      const crudStoresIndex = this.crudStoresIndex = {};
      this.crudStores.forEach(store => store.storeId && (crudStoresIndex[store.storeId] = store));
    } //endregion
    //region Store collection (add, remove, get & iterate)

    /**
     * Returns a registered store.
     * @param {String} storeId Store identifier.
     * @returns {Core.data.Store} Found store instance.
     */


    getCrudStore(storeId) {
      const storeDescriptor = this.getStoreDescriptor(storeId);
      return storeDescriptor === null || storeDescriptor === void 0 ? void 0 : storeDescriptor.store;
    }

    forEachCrudStore(fn, thisObj = this) {
      if (!fn) {
        throw new Error('Iterator function must be provided');
      }

      this.crudStores.every(store => fn.call(thisObj, store.store, store.storeId, store) !== false);
    }

    set crudStores(stores) {
      this._crudStores = [];
      this.addCrudStore(stores); // Ensure preconfigured stores stay stable at the start of the array when
      // addPrioritizedStore attempts to insert in order. Only featured gantt/scheduler stores
      // must participate in the ordering. If they were configured in, they must not move.

      for (const store of this._crudStores) {
        store.loadPriority = store.syncPriority = 0;
      }
    }

    get crudStores() {
      return this._crudStores;
    }

    get orderedCrudStores() {
      return this._orderedCrudStores;
    }

    set orderedCrudStores(stores) {
      return this._orderedCrudStores = stores;
    }

    set syncApplySequence(stores) {
      this._syncApplySequence = [];
      this.addStoreToApplySequence(stores);
    }

    get syncApplySequence() {
      return this._syncApplySequence;
    }

    internalAddCrudStore(store) {
      const me = this;
      let storeInfo; // if store instance provided

      if (store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
        storeInfo = {
          store
        };
      } else if (typeof store === 'object') {
        // normalize sub-stores (if any)
        if (store.stores) {
          if (!Array.isArray(store.stores)) {
            store.stores = [store.stores];
          }

          store.stores.forEach((subStore, j) => {
            let subStoreInfo = subStore;

            if (typeof subStore === 'string') {
              subStoreInfo = {
                storeId: subStore
              };
            } // keep reference to the "master" store descriptor


            subStoreInfo.masterStoreInfo = store;
            store.stores[j] = subStoreInfo;
          });
        } else if (!store.store) {
          // not a store descriptor, assume it is a store config
          store = {
            storeId: store.id,
            store: new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"](store)
          };
        }

        storeInfo = store;
      } // if it's a store identifier
      else {
        storeInfo = {
          store: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(store)
        };
      }

      me.fillStoreDescriptor(storeInfo); // store instance

      store = storeInfo.store; // if the store has "setCrudManager" hook - use it

      if (store.setCrudManager) {
        store.setCrudManager(me);
      } // otherwise decorate the store w/ "crudManager" property
      else {
        store.crudManager = me;
      } // Stores have a defaultConfig for pageSize. CrudManager does not support that.
      // TODO: PORT currently no support for paging.


      store.pageSize = null; // Prevent AjaxStores from performing their own CRUD operations

      if (store.load) {
        store.autoCommit = false;
        store.autoLoad = false;
      } // listen to store changes


      me.bindCrudStoreListeners(store);
      return storeInfo;
    }
    /**
     * Adds a store to the collection.
     *
     *```javascript
    * // append stores to the end of collection
    * crudManager.addCrudStore([
    *     store1,
    *     // storeId
    *     'bar',
    *     // store descriptor
    *     {
    *         storeId : 'foo',
    *         store   : store3
    *     },
    *     {
    *         storeId         : 'bar',
    *         store           : store4,
    *         // to write all fields of modified records
    *         writeAllFields  : true
    *     }
    * ]);
    *```
    *
    * **Note:** Order in which stores are kept in the collection is very essential sometimes.
    * Exactly in this order the loaded data will be put into each store.
     *
     * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
     * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
     *
    * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
    * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
    * The _store descriptor_ is an object having following properties:
    * @param {String} store.storeId The store identifier that will be used as a key in requests.
    * @param {Core.data.Store} store.store The store itself.
    * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
    * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
    * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
    * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
    * If not specified then store(s) will be appended to the end of collection.
    * Otherwise it will be just a position in stores collection.
    *
    * ```javascript
    * // insert stores store4, store5 to the start of collection
    * crudManager.addCrudStore([ store4, store5 ], 0);
    * ```
    *
    * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link #function-getStoreDescriptor} call).
    *
    * ```javascript
    * // insert store6 just before a store having storeId equal to 'foo'
    * crudManager.addCrudStore(store6, 0, 'foo');
    *
    * // insert store7 just after store3 store
    * crudManager.addCrudStore(store7, 1, store3);
    * ```
    */


    addCrudStore(store, position, fromStore) {
      if (!store) return;
      if (!Array.isArray(store)) store = [store];
      if (!store.length) return;
      const me = this,
            stores = store.map(me.internalAddCrudStore, me); // if no position specified then append stores to the end

      if (typeof position === 'undefined') {
        me.crudStores.push(...stores);
      } // if position specified
      else {
        // if specified the store relative to which we should insert new one(-s)
        if (fromStore) {
          if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] || typeof fromStore !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

          position += me.crudStores.indexOf(fromStore);
        } // insert new store(-s)
        //me.crudStores.splice.apply(me.crudStores, [].concat([pos, 0], stores));


        me.crudStores.splice(position, 0, ...stores);
      }

      me.orderedCrudStores.push(...stores);
      me.updateCrudStoreIndex();
    } // Adds configured scheduler stores to the store collection ensuring correct order
    // unless they're already registered.


    addPrioritizedStore(store) {
      const me = this;

      if (!me.hasCrudStore(store)) {
        this.addCrudStore(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].findInsertionIndex(store, me.crudStores, storeLoadSortFn));
      }

      if (!me.hasApplySequenceStore(store)) {
        this.addStoreToApplySequence(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].findInsertionIndex(store, me.syncApplySequence, storeSyncSortFn));
      }
    }

    hasCrudStore(store) {
      var _this$crudStores;

      return (_this$crudStores = this.crudStores) === null || _this$crudStores === void 0 ? void 0 : _this$crudStores.some(s => s === store || s.store === store || s.storeId === store);
    }
    /**
     * Removes a store from collection. If the store was registered in alternative sync sequence list
     * it will be removed from there as well.
     *
     * ```javascript
     * // remove store having storeId equal to "foo"
     * crudManager.removeCrudStore("foo");
     *
     * // remove store3
     * crudManager.removeCrudStore(store3);
     * ```
     *
     * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
     */


    removeCrudStore(store) {
      const me = this,
            stores = me.crudStores,
            foundStore = stores.find(s => s === store || s.store === store || s.storeId === store);

      if (foundStore) {
        // unbind store listeners
        me.unbindCrudStoreListeners(foundStore.store);
        delete me.crudStoresIndex[foundStore.storeId];
        _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].remove(stores, foundStore);

        if (me.syncApplySequence) {
          me.removeStoreFromApplySequence(store);
        }
      } else {
        throw new Error('Store not found in stores collection');
      }
    } //endregion
    //region Store listeners


    bindCrudStoreListeners(store) {
      store.on({
        name: store.id,
        // When a tentatively added record gets confirmed as permanent, this signals a change
        addConfirmed: 'onCrudStoreChange',
        change: 'onCrudStoreChange',
        destroy: 'onCrudStoreDestroy',
        thisObj: this
      });
    }

    unbindCrudStoreListeners(store) {
      this.detachListeners(store.id);
    } //endregion
    //region Apply sequence

    /**
     * Adds a store to the alternative sync responses apply sequence.
     * By default the order in which sync responses are applied to the stores is the same as they registered in.
     * But this order can be changes either on construction step using {@link #config-syncApplySequence} option
     * or but calling this method.
     *
     * **Please note**, that if the sequence was not initialized before this method call then
     * you will have to do it yourself like this for example:
     *
     * ```javascript
     * // alternative sequence was not set for this crud manager
     * // so let's fill it with existing stores keeping the same order
     * crudManager.addStoreToApplySequence(crudManager.crudStores);
     *
     * // and now we can add our new store
     *
     * // we will load its data last
     * crudManager.addCrudStore(someNewStore);
     * // but changes to it will be applied first
     * crudManager.addStoreToApplySequence(someNewStore, 0);
     * ```
     * add registered stores to the sequence along with the store(s) you want to add
     *
     * @param {Core.data.Store|Object|Core.data.Store[]|Object[]} store The store to add or its _descriptor_ (or array of stores or descriptors).
     * Where _store descriptor_ is an object having following properties:
     * @param {String} store.storeId The store identifier that will be used as a key in requests.
     * @param {Core.data.Store} store.store The store itself.
     * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
     * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
    * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
    * If not specified then store(s) will be appended to the end of collection.
    * Otherwise it will be just a position in stores collection.
    *
    * ```javascript
    * // insert stores store4, store5 to the start of sequence
    * crudManager.addStoreToApplySequence([ store4, store5 ], 0);
    * ```
    * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or its descriptor (the result of {@link #function-getStoreDescriptor} call).
    *
    * ```javascript
    * // insert store6 just before a store having storeId equal to 'foo'
    * crudManager.addStoreToApplySequence(store6, 0, 'foo');
    *
    * // insert store7 just after store3 store
    * crudManager.addStoreToApplySequence(store7, 1, store3);
    * ```
    */


    addStoreToApplySequence(store, position, fromStore) {
      if (!store) return;
      if (!Array.isArray(store)) store = [store];
      const me = this,
            // loop over list of stores to add
      data = store.reduce((collection, store) => {
        const s = me.getStoreDescriptor(store);
        if (s) collection.push(s);
        return collection;
      }, []); // if no position specified then append stores to the end

      if (typeof position === 'undefined') {
        me.syncApplySequence.push(...data); // if position specified
      } else {
        let pos = position; // if specified the store relative to which we should insert new one(-s)

        if (fromStore) {
          if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] || typeof fromStore !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

          pos += me.syncApplySequence.indexOf(fromStore);
        } // insert new store(-s)
        //me.syncApplySequence.splice.apply(me.syncApplySequence, [].concat([pos, 0], data));


        me.syncApplySequence.splice(pos, 0, ...data);
      }

      const sequenceKeys = me.syncApplySequence.map(({
        storeId
      }) => storeId);
      me.orderedCrudStores = [...me.syncApplySequence];
      me.crudStores.forEach(storeDesc => {
        if (!sequenceKeys.includes(storeDesc.storeId)) {
          me.orderedCrudStores.push(storeDesc);
        }
      });
    }
    /**
     * Removes a store from the alternative sync sequence.
     *
     * ```javascript
     * // remove store having storeId equal to "foo"
     * crudManager.removeStoreFromApplySequence("foo");
     * ```
     *
     * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
     */


    removeStoreFromApplySequence(store) {
      const index = this.syncApplySequence.findIndex(s => s === store || s.store === store || s.storeId === store);

      if (index > -1) {
        this.syncApplySequence.splice(index, 1); // ordered crud stores list starts with syncApplySequence, we can use same index

        this.orderedCrudStores.splice(index, 1);
      }
    }

    hasApplySequenceStore(store) {
      return this.syncApplySequence.some(s => s === store || s.store === store || s.storeId === store);
    } //endregion
    //region Events
    // onNodeRemove(oldParent) {
    //     var treeStore = oldParent && oldParent.getTreeStore();
    //     // "noderemove" event is fired too early and getRemovedRecords() don't not have the removed node yet
    //     // so we wait till tree store "endupdate" event and only then invoke "onCrudStoreChange" method
    //     treeStore && treeStore.on('endupdate', this.onCrudStoreChange, this, { once : true });
    // }
    // onStoreUpdate(store, record, operation, fields) {
    //     if ((!store.isTreeStore || record !== store.getRoot())) {
    //         // If only a single field was changed, make sure it's a persistable field to avoid full scan of the store
    //         // Collapsing/expanding a tree node will trigger this behavior otherwise
    //         var isSingleNonPersistField = fields && fields.length === 1 && record.getField(fields[0]) && !record.getField(fields[0]).persist;
    //
    //         if (!isSingleNonPersistField) {
    //             this.onCrudStoreChange();
    //         }
    //     }
    // }
    // onTreeStoreInsertOrAppend(parent, child) {
    //     if (!child.isRoot()) {
    //         this.onCrudStoreChange();
    //     }
    // }
    // Remove stores that are destroyed, to not try and apply response changes etc to them


    onCrudStoreDestroy({
      source: store
    }) {
      this.removeCrudStore(store);
    }

    onCrudStoreChange() {
      const me = this;

      if (me.crudIgnoreUpdates) {
        return;
      }
      /**
       * Fires when data in any of the registered data stores is changed.
       * ```javascript
       *     crudManager.on('hasChanges', function (crud) {
       *         // enable persist changes button when some store gets changed
       *         saveButton.enable();
       *     });
       * ```
       * @event hasChanges
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
       */


      if (me.crudStoreHasChanges()) {
        me.trigger('hasChanges');

        if (me.autoSync) {
          me.scheduleAutoSync();
        }
      } else {
        me.trigger('noChanges');
      }
    }
    /**
     * Suspends automatic sync upon store changes. Can be called multiple times (it uses an internal counter).
     */


    suspendAutoSync() {
      this.autoSyncSuspendCounter++;
    }
    /**
     * Resumes automatic sync upon store changes. Will trigger commit if the internal counter is 0.
     * @param {Boolean} [doSync=true] Pass `true` to trigger data syncing after resuming (if there are pending changes)
     * and `false` to not persist the changes.
     */


    resumeAutoSync(doSync = true) {
      const me = this;
      me.autoSyncSuspendCounter--;

      if (me.autoSyncSuspendCounter <= 0) {
        me.autoSyncSuspendCounter = 0; // if its told to trigger persisting and there are changes

        if (doSync && me.autoSync && me.crudStoreHasChanges()) {
          me.sync();
        }
      }
    }

    scheduleAutoSync() {
      const me = this; // add deferred call if it's not scheduled yet

      if (!me.autoSyncTimerId && !me.autoSyncSuspendCounter) {
        me.autoSyncTimerId = me.setTimeout(() => {
          me.autoSyncTimerId = null;
          me.sync().catch(error => {});
        }, me.autoSyncTimeout);
      }
    }

    async triggerFailedRequestEvents(request, response, responseText, fetchOptions) {
      const me = this,
            {
        options,
        type: requestType
      } = request;
      /**
       * Fires when a request fails.
       * @event requestFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {String} requestType The request type (`sync` or `load`).
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       */

      me.trigger('requestFail', {
        requestType,
        response,
        responseText,
        responseOptions: fetchOptions
      });
      /**
       * Fires when a {@link #function-load load request} fails.
       * @event loadFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       * @params {Object} options Options provided to the {@link #function-load} method.
       */

      /**
       * Fires when a {@link #function-sync sync request} fails.
       * @event syncFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       */

      me.trigger(requestType + 'Fail', {
        response,
        responseOptions: fetchOptions,
        responseText,
        options
      });
    }

    async internalOnResponse(request, responseText, fetchOptions) {
      const me = this,
            response = responseText ? me.decode(responseText) : null,
            {
        options,
        type: requestType
      } = request;

      if (responseText && !response) {
        console.error('Failed to parse response: ' + responseText);
      }

      if (!response || (me.skipSuccessProperty ? response.success === false : !response.success)) {
        me.triggerFailedRequestEvents(request, response, responseText, fetchOptions);
      } else if (me.trigger('beforeResponseApply', {
        requestType,
        response
      }) !== false && me.trigger('before' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(requestType) + 'Apply', {
        response,
        options
      }) !== false) {
        me.crudRevision = response.revision;
        await me.applyResponse(request, response, options);
        /**
         * Fires on successful request completion after data gets applied to the stores.
         * @event requestDone
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {String} requestType The request type (`sync` or `load`).
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         */

        me.trigger('requestDone', {
          requestType,
          response,
          responseOptions: fetchOptions
        });
        /**
         * Fires on successful {@link #function-load load request} completion after data gets loaded to the stores.
         * @event load
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         * @params {Object} options Options provided to the {@link #load} method.
         */

        /**
         * Fires on successful {@link #function-sync sync request} completion.
         * @event sync
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         */

        me.trigger(requestType, {
          response,
          responseOptions: fetchOptions,
          options
        });

        if (requestType === 'load' || !me.crudStoreHasChanges()) {
          /**
           * Fires when registered stores get into state when they don't have any
           * not persisted change. This happens after {@link #function-load} or {@link #function-sync} request
           * completion. Or this may happen after a record update which turns its fields back to their original state.
           *
           * ```javascript
           * crudManager.on('nochanges', function (crud) {
           *     // disable persist changes button when there is no changes
           *     saveButton.disable();
           * });
           * ```
           *
           * @event noChanges
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           */
          me.trigger('noChanges');

          if (requestType === 'load') {
            me.emitCrudStoreEvents(request.pack.stores, 'afterRequest');
          }
        }
      }

      return response;
    } //endregion
    //region Changes tracking


    suspendChangesTracking() {
      this.crudIgnoreUpdates++;
    }

    resumeChangesTracking(skipChangeCheck) {
      if (this.crudIgnoreUpdates && ! --this.crudIgnoreUpdates && !skipChangeCheck) {
        this.onCrudStoreChange();
      }
    }

    get isBatchingChanges() {
      return this.crudIgnoreUpdates > 0;
    }
    /**
     * Returns `true` if any of registered stores (or some particular store) has non persisted changes.
     *
     * ```javascript
     * // if we have any unsaved changes
     * if (crudManager.crudStoreHasChanges()) {
     *     // persist them
     *     crudManager.sync();
     * // otherwise
     * } else {
     *     alert("There are no unsaved changes...");
     * }
     * ```
     *
     * @param {String|Core.data.Store} [storeId] The store identifier or store instance to check changes for.
     * If not specified then will check changes for all of the registered stores.
     * @returns {Boolean} `true` if there are not persisted changes.
     */


    crudStoreHasChanges(storeId) {
      return storeId ? this.isCrudStoreDirty(this.getCrudStore(storeId)) : this.crudStores.some(this.isCrudStoreDirty);
    }

    isCrudStoreDirty(store) {
      return Boolean(store === null || store === void 0 ? void 0 : store.store.changes);
    } //endregion
    //region Load


    emitCrudStoreEvents(stores, eventName, eventParams) {
      const event = _objectSpread({
        action: 'read' + eventName
      }, eventParams);

      for (const store of this.crudStores) {
        if (stores.includes(store.storeId)) {
          store.store.trigger(eventName, event);
        }
      }
    }

    getLoadPackage(options) {
      const pack = {
        type: 'load',
        requestId: this.requestId
      },
            stores = this.crudStores,
            optionsCopy = Object.assign({}, options); // This is a special option which does not apply to a store.
      // It's used as options to the AjaxTransport#sendRequest method

      delete optionsCopy.request;
      pack.stores = stores.map(store => {
        var _store$store;

        const opts = optionsCopy === null || optionsCopy === void 0 ? void 0 : optionsCopy[store.storeId],
              pageSize = store.pageSize || ((_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.pageSize); // TODO: PORT currently no support for remote filters
        // if the store uses remote filtering
        // if (store.store.remoteFilter && filterParam) {
        //
        //     opts = opts || {};
        //
        //     var filters = [];
        //
        //     store.store.getFilters().each(function(f) {
        //         filters.push(f.serialize());
        //     });
        //
        //     // put filters info into the package
        //     opts[filterParam] = filters;
        // }
        // TODO: PORT currently no support for paging

        if (opts || pageSize) {
          const params = Object.assign({
            storeId: store.storeId,
            page: 1
          }, opts);

          if (pageSize) {
            params.pageSize = pageSize;
          }

          store.currentPage = params.page; // Remove from common request options

          if (opts) {
            delete optionsCopy[store.storeId];
          }

          return params;
        }

        return store.storeId;
      }); // Apply common request options

      Object.assign(pack, optionsCopy);
      return pack;
    }

    loadCrudStore(store, data, options) {
      const rows = data === null || data === void 0 ? void 0 : data.rows;

      if (options !== null && options !== void 0 && options.append || data !== null && data !== void 0 && data.append) {
        store.add(rows);
      } else {
        store.data = rows;
      }

      store.trigger('load', {
        data: rows
      });
    }

    loadDataToCrudStore(storeDesc, data, options) {
      const me = this,
            store = storeDesc.store,
            // nested stores list
      subStores = storeDesc.stores,
            idField = storeDesc.idField || 'id',
            //model && model.meta.idField || 'id',
      isTree = store.tree,
            rows = data === null || data === void 0 ? void 0 : data.rows;
      store.__loading = true;

      if (rows) {
        let subData;

        if (subStores) {
          subData = me.getSubStoresData(rows, subStores, idField, isTree);
        }

        me.loadCrudStore(store, data, options, storeDesc);

        if (subData) {
          // load sub-stores as well (if we have them)
          subData.forEach(sub => {
            me.loadDataToCrudStore(Object.assign({
              store: store.getById(sub.id).get(sub.storeDesc.storeId) // TODO: PORT have to check what this does

            }, sub.storeDesc), sub.data);
          });
        }
      }

      store.__loading = false;
    }
    /**
     * Loads data to the Crud Manager
     * @param {Object} response A simple object representing the data.
     * The object structure matches the decoded `load` response structure:
     *
     * ```js
     * // load static data into crudManager
     * crudManager.loadCrudManagerData({
     *     success   : true,
     *     resources : {
     *         rows : [
     *             { id : 1, name : 'John' },
     *             { id : 2, name : 'Abby' }
     *         ]
     *     }
     * });
     * ```
     * @param {Object} [options] Extra data loading options.
     */


    loadCrudManagerData(response, options = {}) {
      // we don't want to react to store changes during loading of them
      this.suspendChangesTracking(); // we load data to the stores in the order they're kept in this.stores array

      this.crudStores.forEach(storeDesc => {
        const storeId = storeDesc.storeId,
              data = response[storeId];

        if (data) {
          this.loadDataToCrudStore(storeDesc, data, options[storeId]);
        }
      });
      this.resumeChangesTracking(true);
    }
    /**
     * Returns true if the crud manager is currently loading data
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */


    get isCrudManagerLoading() {
      return Boolean(this.activeRequests.load || this.applyingLoadResponse);
    }
    /**
     * Returns true if the crud manager is currently syncing data
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */


    get isCrudManagerSyncing() {
      return Boolean(this.activeRequests.sync || this.applyingSyncResponse);
    }

    get isLoadingOrSyncing() {
      return Boolean(this.isCrudManagerLoading || this.isCrudManagerSyncing);
    }
    /**
     * Loads data to the stores registered in the crud manager. For example:
     *
     * ```javascript
     * crudManager.load(
     *     // here are request parameters
     *     {
     *         store1 : { append : true, page : 3, smth : 'foo' },
     *         store2 : { page : 2, bar : '!!!' }
     *     }
     * ).then(
     *     () => alert('OMG! It works!'),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * ** Note: ** If there is an incomplete load request in progress then system will try to cancel it by calling {@link #function-cancelRequest}.
     * @param {Object|String} [options] The request parameters or a URL.
     * @param {Object} [options.request] An object which contains options to merge
     * into the options which are passed to {@link Scheduler/crud/transport/AjaxTransport#function-sendRequest}.
     * ```javascript
     * {
     *     store1 : { page : 3, append : true, smth : 'foo' },
     *     store2 : { page : 2, bar : '!!!' },
     *     request : {
     *         params : {
     *             startDate : '2021-01-01'
     *         }
     *     }
     * },
     * ```
     *
     * Omitting request arg:
     * ```javascript
     * crudManager.load().then(
     *     () => alert('OMG! It works!'),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * When presented it should be an object where keys are store Ids and values are, in turn, objects
     * of parameters related to the corresponding store. These parameters will be transferred in each
     * store's entry in the `stores` property of the POST data.
     *
     * Additionally for flat stores `append: true` can be specified to add loaded records to the existing records, default is to remove corresponding store's existing records first.
     * **Please note** that for delta loading you can also use an {@link #config-trackResponseType alternative approach}.
     * @param {String} [options.request.type] The request type. Either `load` or `sync`.
     * @param {String} [options.request.url] The URL for the request. Overrides the URL defined in the `transport` object
     * @param {String} [options.request.data] The encoded _Crud Manager_ request data.
     * @param {Object} [options.request.params] An object specifying extra HTTP params to send with the request.
     * @param {Function} [options.request.success] A function to be started on successful request transferring.
     * @param {String} [options.request.success.rawResponse] `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
     * @param {Function} [options.request.failure] A function to be started on request transfer failure.
     * @param {String} [options.request.failure.rawResponse] `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
     * @param {Object} [options.request.thisObj] `this` reference for the above `success` and `failure` functions.
     * @returns {Promise} Promise, which is resolved if request was successful.
     * Both the resolve and reject functions are passed a `state` object. State object has following structure:
     *
     * ```
     * {
     *     cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
     *     rawResponse     : String,  // raw response from ajax request, either response xml or text
     *     rawResponseText : String,  // raw response text as String from ajax request
     *     response        : Object,  // processed response in form of object
     *     options         : Object   // options, passed to load request
     * }
     * ```
     *
     * If promise was rejected by {@link #event-beforeLoad} event, `state` object will have the following structure:
     *
     * ```
     * {
     *     cancelled : true
     * }
     * ```
     *
     */


    load(options) {
      if (typeof options === 'string') {
        options = {
          request: {
            url: options
          }
        };
      }

      const me = this,
            pack = me.getLoadPackage(options);
      return new Promise((resolve, reject) => {
        /**
         * Fires before {@link #function-load load request} is sent. Return `false` to cancel load request.
         * @event beforeLoad
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
         */
        if (me.trigger('beforeLoad', {
          pack
        }) !== false) {
          var _options;

          // if another load request is in progress let's cancel it
          const {
            load
          } = me.activeRequests;

          if (load) {
            me.cancelRequest(load.desc, load.reject);
            me.trigger('loadCanceled', {
              pack
            });
          } // TODO: refactor this


          const request = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
            id: pack.requestId,
            data: me.encode(pack),
            type: 'load',
            success: me.onCrudRequestSuccess,
            failure: me.onCrudRequestFailure,
            thisObj: me
          }, (_options = options) === null || _options === void 0 ? void 0 : _options.request);
          me.activeRequests.load = {
            type: 'load',
            options,
            pack,
            resolve,

            reject(...args) {
              // sendRequest will start a fetch promise, which we cannot reject from here. In fact what we
              // need to do, is to make fetch.then() to not call any real handlers. Which is what we do here.
              request.success = request.failure = null;
              reject(...args);
            },

            id: pack.requestId,
            desc: me.sendRequest(request)
          };
          me.emitCrudStoreEvents(pack.stores, 'loadStart');
          me.trigger('loadStart', {
            pack
          });
        } else {
          /**
           * Fired after {@link #function-load load request} was canceled by some {@link #event-beforeLoad}
           * listener or due to incomplete prior load request.
           * @event loadCanceled
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */
          me.trigger('loadCanceled', {
            pack
          });
          reject({
            cancelled: true
          });
        }
      });
    }

    getActiveCrudManagerRequest(requestType) {
      let request = this.activeRequests[requestType];

      if (!request && this.trackResponseType) {
        request = Object.values(this.activeRequests)[0];
      }

      return request;
    }

    getSubStoresData(rows, subStores, idField, isTree) {
      if (!rows) return;
      const result = [];

      function processRow(row, subStores) {
        subStores.forEach(subStore => {
          const storeId = subStore.storeId; // if row contains data for this sub-store

          if (row[storeId]) {
            // keep them for the later loading
            result.push({
              id: row[idField],
              storeDesc: subStore,
              data: row[storeId]
            }); // and remove reference from the row

            delete row[storeId];
          }
        });
      } // if it's a TreeStore


      if (isTree) {
        // loop over nodes
        rows.forEach(row => {
          processRow(row, subStores); // also let's grab sub-stores from node children

          const childrenSubData = this.getSubStoresData(row.children, subStores, idField, true);

          if (childrenSubData) {
            result.push(...childrenSubData);
          }
        }); // if it's a "flat" store
      } else {
        rows.forEach(row => processRow(row, subStores));
      }

      return result;
    } //endregion
    //region Changes (prepare, process, get)


    prepareAdded(list, storeInfo) {
      const {
        store,
        stores
      } = storeInfo,
            {
        isTree
      } = store,
            phantomIdField = storeInfo.phantomIdField || this.phantomIdField,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField;
      return list.filter(record => record.isValid).map(record => {
        const cls = record.constructor,
              data = Object.assign(record.persistableData, {
          [phantomIdField]: record.id
        });

        if (isTree) {
          const {
            parent
          } = record;

          if (parent && !parent.isRoot && parent.isPhantom) {
            data[phantomParentIdField] = parent.id;
          }
        }

        if (this.resetIdsBeforeSync) delete _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deletePath(data, cls.getFieldDataSource(cls.idField)); // if the store has embedded ones

        if (stores) {
          this.processSubStores(record, data, stores);
        }

        return data;
      });
    }

    prepareUpdated(list, storeInfo) {
      const {
        store,
        stores
      } = storeInfo,
            {
        isTree
      } = store,
            writeAllFields = storeInfo.writeAllFields || storeInfo.writeAllFields !== false && this.writeAllFields,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField; // TODO: root node included into store.modified
      // need to get rid of it since we don't persist it

      if (storeInfo.store.tree) {
        const rootNode = storeInfo.store.rootNode;
        list = list.filter(record => record !== rootNode);
      }

      return list.filter(record => record.isValid).reduce((data, record) => {
        let recordData; // write all fields

        if (writeAllFields) {
          recordData = record.persistableData;
        } else {
          recordData = record.modificationDataToWrite;
        }

        if (isTree) {
          const {
            parent
          } = record;

          if (parent && !parent.isRoot && parent.isPhantom) {
            recordData[phantomParentIdField] = parent.id;
          }
        } // if the store has embedded ones


        if (stores) {
          this.processSubStores(record, recordData, stores);
        } // recordData can be null


        if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEmpty(recordData)) {
          data.push(recordData);
        }

        return data;
      }, []);
    }

    prepareRemoved(list) {
      return list.map(record => {
        const cls = record.constructor;
        return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath({}, cls.getFieldDataSource(cls.idField), record.id);
      });
    }

    processSubStores(record, data, stores) {
      stores.forEach(store => {
        const id = store.storeId,
              subStore = record.get(id); // if embedded store is assigned to the record

        if (subStore) {
          // let's collect its changes as well
          const changes = this.getCrudStoreChanges(Object.assign({
            store: subStore
          }, store));

          if (changes) {
            data[id] = Object.assign(changes, {
              $store: true
            });
          } else {
            delete data[id];
          }
        } else {
          delete data[id];
        }
      });
    }

    getCrudStoreChanges(storeDescriptor) {
      const {
        store
      } = storeDescriptor;
      let {
        added = [],
        modified: updated = [],
        removed = []
      } = store.changes || {},
          // sub-stores
      result;
      if (added.length) added = this.prepareAdded(added, storeDescriptor);
      if (updated.length) updated = this.prepareUpdated(updated, storeDescriptor);
      if (removed.length) removed = this.prepareRemoved(removed); // if this store has changes

      if (added.length || updated.length || removed.length) {
        result = {};
        if (added.length) result.added = added;
        if (updated.length) result.updated = updated;
        if (removed.length) result.removed = removed;
      }

      return result;
    }

    getChangeSetPackage() {
      const changes = this.changes;
      return changes ? Object.assign({
        type: 'sync',
        requestId: this.requestId,
        revision: this.crudRevision
      }, changes) : null;
    } //endregion
    //region Apply

    /**
     * Returns current changes as an object consisting of added/modified/removed arrays of records for every
     * managed store. Returns `null` if no changes exist. Format:
     *
     * ```javascript
     * {
     *     resources : {
     *         added    : [{ name : 'New guy' }],
     *         modified : [{ id : 2, name : 'Mike' }],
     *         removed  : [{ id : 3 }]
     *     },
     *     events : {
     *         modified : [{  id : 12, name : 'Cool task' }]
     *     },
     *     ...
     * }
     * ```
     *
     * @property {Object}
     * @readonly
     * @category CRUD
     */


    get changes() {
      const data = {};
      this.crudStores.forEach(store => {
        const changes = this.getCrudStoreChanges(store);

        if (changes) {
          data[store.storeId] = changes;
        }
      });
      return Object.keys(data).length > 0 ? data : null;
    }

    applyChangesToRecord(record, rawChanges, stores) {
      const me = this,
            modelClass = record.constructor,
            {
        fieldDataSourceMap
      } = modelClass,
            recProto = modelClass.prototype,
            changes = {},
            data = record.data,
            done = {
        [me.phantomIdField]: true
      };
      let hasChanges; // if this store has sub-stores assigned to some fields

      if (stores) {
        // then first we apply changes to that stores
        stores.forEach(store => {
          const name = store.storeId;

          if (Object.prototype.hasOwnProperty.call(rawChanges, name)) {
            // remember that we processed this field
            done[name] = true;
            const subStore = record.get(name);

            if (subStore) {
              me.applyChangesToStore(Object.assign({
                store: subStore
              }, store), rawChanges[name]);
            } else {
              console.log('Can\'t find store for the response sub-package');
            }
          }
        });
      }

      const rawChangesFiltered = {};

      for (const key in rawChanges) {
        if (Object.prototype.hasOwnProperty.call(rawChanges, key) && !done[key]) {
          rawChangesFiltered[key] = rawChanges[key];
        }
      }

      const rowChangesSimplePaths = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].pathifyKeys(rawChangesFiltered); // Collect the changes into a change set for field names.

      for (const dataSource in rowChangesSimplePaths) {
        const field = fieldDataSourceMap[dataSource],
              propName = field ? field.name : dataSource,
              value = modelClass.processField(propName, rowChangesSimplePaths[dataSource]),
              oldValue = dataSource in recProto ? record[propName] : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, dataSource);

        if (!(field !== null && field !== void 0 && field.isEqual ? field.isEqual(oldValue, value) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(oldValue, value))) {
          hasChanges = true;
          changes[propName] = value;
        }
      }

      if (hasChanges) {
        me.suspendChangesTracking(); // Set each field separately until https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.

        for (const fieldName in changes) {
          record[fieldName] = changes[fieldName];
        } // TODO: Re-enable record.set when https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.
        // Set fields one go
        // record.set(changes);


        me.resumeChangesTracking(true);
      }

      me.clearRecordChanges(record, changes);
    }

    clearRecordChanges(record, changes) {
      // Clear changes only for the passed record,
      // not descendant nodes.
      // TODO: they *might* also be genuinely new
      // so might have to stay.
      record.clearChanges(true, false);
    }

    applyRemovals(store, removedEntries, context) {
      const {
        removed: removedStash,
        modelClass
      } = store,
            dataSource = modelClass.getFieldDataSource(modelClass.idField);
      let applied = 0;
      removedEntries === null || removedEntries === void 0 ? void 0 : removedEntries.forEach(removedEntry => {
        const id = removedEntry[dataSource];
        let done = false; // just remove the record from the removed stash

        if (removedStash.includes(id)) {
          removedStash.remove(id);
          done = true; // number of removals applied

          applied++;
        } // if responded removed record isn`t found in store.removed
        // probably don't removed on the client side yet (server driven removal)


        if (!done) {
          const record = store.getById(id);

          if (record) {
            this.suspendChangesTracking();
            record.remove();
            removedStash.remove(record); // number of removals applied

            applied++;
            this.resumeChangesTracking(true);
          } else {
            console.log('Can\'t find record to remove from the response package');
          }
        }
      });
      return applied;
    }

    getRowsToApplyChangesTo({
      store,
      storeId
    }, storeResponse, storePack) {
      var _rows, _removed;

      const me = this,
            {
        modelClass
      } = store,
            idDataSource = modelClass.getFieldDataSource(modelClass.idField),
            // request data
      {
        updated: requestUpdated,
        removed: requestRemoved
      } = storePack || {};
      let rows, removed; // If the response contains the store section

      if (storeResponse) {
        var _storeResponse$rows, _storeResponse$remove;

        const respondedIds = {}; // responded record changes/removals

        rows = ((_storeResponse$rows = storeResponse.rows) === null || _storeResponse$rows === void 0 ? void 0 : _storeResponse$rows.slice()) || [];
        removed = ((_storeResponse$remove = storeResponse.removed) === null || _storeResponse$remove === void 0 ? void 0 : _storeResponse$remove.slice()) || []; // Collect hash w/ identifiers of responded records

        [...rows, ...removed].forEach(responseRecord => {
          const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(responseRecord, idDataSource);
          respondedIds[id] = true;
        }); // If it's told to support providing server changes only in response
        // CrudManager should collect other records to commit from current requested data

        if (me.supportShortSyncResponse) {
          // append records requested to update (if not there already)
          requestUpdated === null || requestUpdated === void 0 ? void 0 : requestUpdated.forEach(data => {
            const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource); // if response doesn't include

            if (!respondedIds[id]) {
              rows.push({
                [idDataSource]: id
              });
            }
          }); // append records requested to remove (if not there already)

          requestRemoved === null || requestRemoved === void 0 ? void 0 : requestRemoved.forEach(data => {
            const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource); // if response doesn't include

            if (!respondedIds[id]) {
              removed.push({
                [idDataSource]: id
              });
            }
          });
        }
      } // If there is no this store section we use records mentioned in the current request
      else if (requestUpdated || requestRemoved) {
        rows = requestUpdated;
        removed = requestRemoved;
      } // return nullish "rows"/"removed" if no entries


      rows = (_rows = rows) !== null && _rows !== void 0 && _rows.length ? rows : null;
      removed = (_removed = removed) !== null && _removed !== void 0 && _removed.length ? removed : null;
      return {
        rows,
        removed
      };
    }

    applyChangesToStore(storeDesc, storeResponse, storePack) {
      const me = this,
            phantomIdField = storeDesc.phantomIdField || me.phantomIdField,
            {
        store,
        stores
      } = storeDesc,
            {
        modelClass
      } = store,
            idDataSource = modelClass.getFieldDataSource(modelClass.idField),
            // collect records we need to process
      {
        rows,
        removed
      } = me.getRowsToApplyChangesTo(storeDesc, storeResponse, storePack); // process added/updated records

      rows === null || rows === void 0 ? void 0 : rows.forEach(data => {
        const phantomId = data[phantomIdField],
              id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource);
        let record = null; // if phantomId is provided then we will use it to find added record

        if (phantomId != null) {
          record = store.getById(phantomId);
        } // if id is provided then we will use it to find updated record
        else if (id != null) {
          record = store.getById(id);
        }

        if (record) {
          me.applyChangesToRecord(record, data, stores, store);
        } else {
          me.suspendChangesTracking(); // create new record in the store

          record = store.add(data)[0];
          me.resumeChangesTracking(true);
          record.clearChanges();
        }
      }); // process removed records

      if (removed && me.applyRemovals(store, removed)) {
        store.trigger('dataChanged', {
          source: store
        });
      }
    }

    applySyncResponse(response, request) {
      const me = this,
            stores = me.orderedCrudStores;
      me.applyingSyncResponse = true;

      for (const store of stores) {
        var _request$pack;

        me.applyChangesToStore(store, response[store.storeId], request === null || request === void 0 ? void 0 : (_request$pack = request.pack) === null || _request$pack === void 0 ? void 0 : _request$pack[store.storeId]);
      }

      me.applyingSyncResponse = false;
    }

    applyLoadResponse(response, options) {
      this.applyingLoadResponse = true;
      this.loadCrudManagerData(response, options);
      this.applyingLoadResponse = false;
    }

    async applyResponse(request, response, options) {
      const me = this,
            // in trackResponseType mode we check response type before deciding how to react on the response
      responseType = me.trackResponseType && response.type || request.type;

      switch (responseType) {
        case 'load':
          if (me.validateResponse) {
            me.validateLoadResponse(response);
          }

          me.applyLoadResponse(response, options);
          break;

        case 'sync':
          if (me.validateResponse) {
            me.validateSyncResponse(response, request);
          }

          me.applySyncResponse(response, request);
          break;
      }
    } //endregion

    /**
     * Generates unique request identifier.
     * @internal
     * @template
     * @return {Number} The request identifier.
     */


    get requestId() {
      return Number.parseInt(`${Date.now()}${this._requestId++}`);
    }
    /**
     * Persists changes made on the registered stores to the server. Usage:
     *
     * ```javascript
     * // persist and run a callback on request completion
     * crud.sync().then(
     *     () => console.log("Changes saved..."),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * ** Note: ** If there is an incomplete sync request in progress then system will queue the call and delay it until previous request completion.
     * In this case {@link #event-syncDelayed} event will be fired.
     *
     * ** Note: ** Please take a look at {@link #config-autoSync} config. This option allows to persist changes automatically after any data modification.
     * @returns {Promise} Promise, which is resolved if request was successful.
     * Both the resolve and reject functions are passed a `state` object. State object has following structure:
     *
     *     {
     *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
     *         rawResponse     : String,  // raw response from ajax request, either response xml or text
     *         rawResponseText : String,  // raw response text as String from ajax request
     *         response        : Object,  // processed response in form of object
     *     }
     *
     * If promise was rejected by {@link #event-beforeSync} event, `state` object will have structure:
     *
     *     {
     *         cancelled : true
     *     }
     *
     */


    sync() {
      const me = this;

      if (me.activeRequests.sync) {
        // let's delay this call and start it only after server response

        /**
         * Fires after {@link #function-sync sync request} was delayed due to incomplete previous one.
         * @event syncDelayed
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} arguments The arguments of {@link #function-sync} call.
         */
        me.trigger('syncDelayed'); // Queue sync request after current one

        return me.activeSyncPromise = me.activeSyncPromise.finally(() => me.sync());
      } // Store current request promise. While this one is pending, all following sync requests will create chain
      // of sequential promises


      return me.activeSyncPromise = new Promise((resolve, reject) => {
        // get current changes set package
        const pack = me.getChangeSetPackage(); // if no data to persist we resolve immediately

        if (!pack) {
          resolve(null);
          return;
        }
        /**
         * Fires before {@link #function-sync sync request} is sent. Return `false` to cancel sync request.
         *
         * ```javascript
         * crudManager.on('beforesync', function() {
         *     // cannot persist changes before at least one record is added
         *     // to the `someStore` store
         *     if (!someStore.getCount()) return false;
         * });
         * ```
         * @event beforeSync
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
         */


        if (me.trigger('beforeSync', {
          pack
        }) !== false) {
          me.trigger('syncStart', {
            pack
          }); // keep active request details

          me.activeRequests.sync = {
            type: 'sync',
            pack,
            resolve,
            reject,
            id: pack.requestId,
            desc: me.sendRequest({
              id: pack.requestId,
              data: me.encode(pack),
              type: 'sync',
              success: me.onCrudRequestSuccess,
              failure: me.onCrudRequestFailure,
              thisObj: me
            })
          };
        } else {
          /**
           * Fires after {@link #function-sync sync request} was canceled by some {@link #event-beforeSync} listener.
           * @event syncCanceled
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */
          me.trigger('syncCanceled', {
            pack
          });
          reject({
            cancelled: true
          });
        }
      }).catch(error => {
        // If the request was not cancelled in beforeSync listener, forward the error so the user's `catch` handler can catch it
        if (error && !error.cancelled) {
          throw error;
        } // Pass the error object as a param to the next `then` chain


        return error;
      });
    }

    async onCrudRequestSuccess(rawResponse, fetchOptions, request) {
      var _request;

      const me = this,
            {
        type: requestType,
        id: requestId
      } = request;
      if (me.isDestroyed) return;
      let responseText = '';
      request = me.activeRequests[requestType]; // we throw exception below to let events trigger first in internalOnResponse() call

      try {
        responseText = await rawResponse.text();
      } catch (e) {} // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime


      if (me.isDestroyed) return; // This situation should never occur.
      // In the load() method, if a load is called while there is a load
      // ongoing, the ongoing Transport request is cancelled and loadCanceled triggered.
      // But having got here, it's too late to cancel a Transport request, so
      // the operation is unregistered below.
      // In the sync() method, if a sync is called while there is a sync
      // ongoing, it waits until completion, before syncing.
      // The activeRequest for any operation should NEVER be able to be
      // replaced while this operation is ongoing, so this must be fatal.

      if (((_request = request) === null || _request === void 0 ? void 0 : _request.id) !== requestId) {
        throw new Error(`Interleaved ${requestType} operation detected`);
      } // Reset the active request info before we enter async code which could allow
      // application code to run which could potentially call another request.
      // It is too late for this request to be canceled - the activeRequest represented
      // the Transport object and that has completed now.


      me.activeRequests[requestType] = null;
      const response = await me.internalOnResponse(request, responseText, fetchOptions); // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime

      if (me.isDestroyed) return;

      if (!response || (me.skipSuccessProperty ? (response === null || response === void 0 ? void 0 : response.success) === false : !(response !== null && response !== void 0 && response.success))) {
        request.reject(new CrudManagerRequestError({
          rawResponse,
          response,
          request
        }));
      } // Successful request type done flag (this.crudLoaded or this.crudSynced)..


      me['crud' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(request.type) + 'ed'] = true;
      request.resolve({
        response,
        rawResponse,
        responseText,
        request
      });
    }

    async onCrudRequestFailure(rawResponse, fetchOptions, request) {
      var _fetchOptions$abortCo;

      if (this.isDestroyed) return;
      request = this.activeRequests[request.type];
      const signal = fetchOptions === null || fetchOptions === void 0 ? void 0 : (_fetchOptions$abortCo = fetchOptions.abortController) === null || _fetchOptions$abortCo === void 0 ? void 0 : _fetchOptions$abortCo.signal,
            wasAborted = Boolean(signal === null || signal === void 0 ? void 0 : signal.aborted);

      if (!wasAborted) {
        let responseText = '';

        try {
          responseText = await rawResponse.text();
        } catch (e) {} // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime


        if (this.isDestroyed) return;
        this.triggerFailedRequestEvents(request, null, responseText, fetchOptions); // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime

        if (this.isDestroyed) return;
        request.reject(new CrudManagerRequestError({
          rawResponse,
          request
        }));
      } // reset the active request info


      this.activeRequests[request.type] = null;
    }
    /**
     * DEPRECATED in favor of {@link #function-acceptChanges}
     * @deprecated
     */


    commitCrudStores() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Scheduler', '5.0.0', 'commitCrudStores is deprecated, in favor of acceptChanges');
      this.acceptChanges();
    }
    /**
     * Commits all changes of all the registered stores.
     */


    acceptChanges() {
      this.crudStores.forEach(store => store.store.acceptChanges());
    }
    /**
     * Reverts all changes in all stores and re-inserts any records that were removed locally. Any new uncommitted
     * records will be removed.
     */


    revertChanges() {
      this.orderedCrudStores.forEach(store => store.store.revertChanges());
    }
    /**
     * DEPRECATED in favor of {@link #function-revertChanges}
     * @deprecated
     */


    rejectCrudStores() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Scheduler', '5.0.0', 'rejectCrudStores is deprecated, in favor of revertChanges');
      this.revertChanges();
    }
    /**
     * Removes all stores and cancels active requests.
     */


    doDestroy() {
      const me = this,
            {
        load,
        sync
      } = me.activeRequests;
      load && me.cancelRequest(load.desc, load.reject);
      sync && me.cancelRequest(sync.desc, sync.reject);

      while (me.crudStores.length > 0) {
        me.removeCrudStore(me.crudStores[0]);
      }

      super.doDestroy && super.doDestroy();
    } // set crudRevision(value) {
    //     debugger
    //     this._crudRevision = value;
    // }
    // get crudRevision() {
    //     return this._crudRevision;
    // }


  };
});

/***/ }),

/***/ "./lib/Scheduler/crud/encoder/JsonEncoder.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/encoder/JsonEncoder.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/crud/encoder/JsonEncoder
 */

/**
 * Implements data encoding functional that should be mixed to a {@link Scheduler.crud.AbstractCrudManager} sub-class.
 * Uses _JSON_ as an encoding system.
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class JsonEncoder extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'JsonEncoder';
  }

  static get defaultConfig() {
    return {
      /**
       * Configuration of the JSON encoder used by the _Crud Manager_.
       *
       * @config {Object}
       * @property {Object} encoder.requestData Static data to send with the data request.
       *
       * ```js
       * new CrudManager({
       *     // add static "foo" property to all requests data
       *     encoder : {
       *         requestData : {
       *             foo : 'Bar'
       *         }
       *     },
       *     ...
       * });
       * ```
       *
       * The above snippet will result adding "foo" property to all requests data:
       *
       * ```json
       *     {
       *         "requestId"   : 756,
       *         "type"        : "load",
       *
       *         "foo"         : "Bar",
       *
       *         "stores"      : [
       *             ...
       * ```
       */
      encoder: {}
    };
  }
  /**
   * Encodes a request object to _JSON_ encoded string. If encoding fails (due to circular structure), it returns null.
   * Supposed to be overridden in case data provided by the _Crud Manager_ has to be transformed into format requested by server.
   * @param {Object} requestData The request to encode.
   * @returns {String} The encoded request.
   */


  encode(requestData) {
    var _this$encoder;

    requestData = Object.assign({}, (_this$encoder = this.encoder) === null || _this$encoder === void 0 ? void 0 : _this$encoder.requestData, requestData);
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].safeJsonStringify(requestData);
  }
  /**
   * Decodes (parses) a _JSON_ response string to an object. If parsing fails, it returns null.
   * Supposed to be overridden in case data provided by server has to be transformed into format requested by the _Crud Manager_.
   * @param {String} responseText The response text to decode.
   * @returns {Object} The decoded response.
   */


  decode(responseText) {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].safeJsonParse(responseText);
  }

});

/***/ }),

/***/ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js":
/*!*******************************************************************!*\
  !*** ./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/**
* @module Scheduler/crud/mixin/AbstractCrudManagerValidation
*/

/**
 * Mixin proving responses validation API to Crud Manager.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AbstractCrudManagerValidation extends Target {
  static get $name() {
    return 'AbstractCrudManagerValidation';
  }

  static get configurable() {
    return {
      /**
       * Config enabling responses structure validation by the Crud Manager.
       * When the config is `true` the Crud Manager checks every parsed response structure for errors
       * and if found dumps them as warnings to the browser console.
       * The config is intended to help developers implementing backend integration.
       *
       * **Please note that this option is intended for development stage only and is recommended to be disabled in production.**
       * @config {Boolean}
       * @default
       */
      validateResponse: false,

      /**
       * When `true` treats parsed responses without `success` property as successful.
       * In this mode a parsed response is treated as invalid if it has explicitly set `success : false`.
       * @config {Boolean}
       * @default
       */
      skipSuccessProperty: true,
      crudLoadValidationWarningPrefix: 'CrudManager load response error(s):',
      crudSyncValidationWarningPrefix: 'CrudManager sync response error(s):',
      supportShortSyncResponseNote: 'Note: Please consider enabling "supportShortSyncResponse" option to allow less detailed sync responses (https://bryntum.com/docs/scheduler/api/Scheduler/crud/AbstractCrudManagerMixin#config-supportShortSyncResponse)',
      disableValidationNote: 'Note: To disable this validation please set the "validateResponse" config to false'
    };
  }

  get crudLoadValidationMandatoryStores() {
    return [];
  }

  getStoreLoadResponseWarnings(storeInfo, responded, expectedResponse) {
    const messages = [],
          {
      storeId
    } = storeInfo,
          mandatoryStores = this.crudLoadValidationMandatoryStores,
          result = {
      [storeId]: {}
    }; // if the store section is responded

    if (responded) {
      if (!responded.rows) {
        messages.push(`- "${storeId}" store section should have a "rows" property with an array of the store records.`);
        result[storeId].rows = ['...'];
      }
    } // if the store is mandatory
    else if (mandatoryStores !== null && mandatoryStores !== void 0 && mandatoryStores.includes(storeId)) {
      messages.push(`- No "${storeId}" store section found. It should contain the store data.`);
      result[storeId].rows = ['...'];
    } // extend expected response w/ this store part


    if (messages.length) {
      Object.assign(expectedResponse, result);
    }

    return messages;
  }

  getLoadResponseWarnings(response) {
    const messages = [],
          expectedResponse = {};

    if (!this.skipSuccessProperty) {
      expectedResponse.success = true;
    } // iterate stores to check properties validity


    this.forEachCrudStore((store, storeId, storeInfo) => {
      messages.push(...this.getStoreLoadResponseWarnings(storeInfo, response === null || response === void 0 ? void 0 : response[storeId], expectedResponse));
    });

    if (messages.length) {
      messages.push('Please adjust your response to look like this:\n' + JSON.stringify(expectedResponse, null, 4).replace(/"\.\.\."/g, '...'));
      messages.push(this.disableValidationNote);
    }

    return messages;
  }

  validateLoadResponse(response) {
    const messages = this.getLoadResponseWarnings(response);

    if (messages.length) {
      console.warn(this.crudLoadValidationWarningPrefix + '\n' + messages.join('\n'));
    }
  }

  getStoreSyncResponseWarnings(storeInfo, requested, responded, expectedResponse) {
    const messages = [],
          missingRows = [],
          missingRemoved = [],
          {
      storeId
    } = storeInfo,
          result = {
      [storeId]: {}
    },
          phantomIdField = storeInfo.phantomIdField || this.phantomIdField,
          {
      modelClass
    } = storeInfo.store,
          idField = modelClass.getFieldDataSource(modelClass.idField),
          respondedRows = (responded === null || responded === void 0 ? void 0 : responded.rows) || [],
          respondedRemoved = (responded === null || responded === void 0 ? void 0 : responded.removed) || [];
    let showSupportShortSyncResponseNote = false; // if added records were passed in the request they should be mentioned in the response

    if (requested !== null && requested !== void 0 && requested.added) {
      missingRows.push(...requested.added.filter(record => {
        return !respondedRows.find(row => row[phantomIdField] == record[phantomIdField]) && !respondedRemoved.find(row => row[phantomIdField] == record[phantomIdField] || row[idField] == record[phantomIdField]);
      }).map(record => ({
        [phantomIdField]: record[phantomIdField],
        [idField]: '...'
      })));

      if (missingRows.length) {
        const missingIds = missingRows.map(row => '#' + row[phantomIdField]).join(', ');
        messages.push(`- "${storeId}" store "rows" section should mention added record(s) ${missingIds} sent in the request. ` + 'It should contain the added records identifiers (both phantom and "real" ones assigned by the backend).');
      }
    } // if short responses are enabled


    if (this.supportShortSyncResponse) {
      // if the data is not object, will return error
      if (!missingRows.length && responded) {
        if (typeof responded !== 'object' || Array.isArray(responded)) {
          messages.push(`- "${storeId}" store section should be an Object.`);
          result[storeId]['...'] = '...';
        } // for request to edit records, if rows is present, it must be an array


        if (responded.rows && !Array.isArray(responded.rows)) {
          messages.push(`- "${storeId}" store "rows" section should be an array`);
          missingRows.push('...');
        } // removed if presented must be an array


        if (responded.removed && !Array.isArray(responded.removed)) {
          messages.push(`- "${storeId}" store "removed" section should be an array:`);
          missingRemoved.push('...');
        }
      }
    } // if short responses are disabled
    else {
      // if updated records were passed in the request they should be mentioned in the response
      if (requested !== null && requested !== void 0 && requested.updated) {
        const missingUpdatedRows = requested.updated.filter(record => !respondedRows.find(row => row[idField] == record[idField])).map(record => ({
          [idField]: record[idField]
        }));
        missingRows.push(...missingUpdatedRows);

        if (missingUpdatedRows.length) {
          const missingIds = missingUpdatedRows.map(row => '#' + row[idField]).join(', ');
          messages.push(`- "${storeId}" store "rows" section should mention updated record(s) ${missingIds} sent in the request. ` + `It should contain the updated record identifiers.`);
          showSupportShortSyncResponseNote = true;
        }
      }

      if (missingRows.length) {
        missingRows.push('...');
      } // if removed records were passed in the request they should be mentioned in the response


      if (requested !== null && requested !== void 0 && requested.removed) {
        missingRemoved.push(...requested.removed.filter(record => !respondedRows.find(row => row[idField] == record[idField])).map(record => ({
          [idField]: record[idField]
        })));

        if (missingRemoved.length) {
          const missingIds = missingRemoved.map(row => '#' + row[idField]).join(', ');
          messages.push(`- "${storeId}" store "removed" section should mention removed record(s) ${missingIds} sent in the request. ` + `It should contain the removed record identifiers.`);
          result[storeId].removed = missingRemoved;
          missingRemoved.push('...');
          showSupportShortSyncResponseNote = true;
        }
      }
    }

    if (missingRows.length) {
      result[storeId].rows = missingRows;
    } // get rid of store section if no rows/removed there


    if (!messages.length) {
      delete result[storeId];
    } // extend expected response w/ this store part


    Object.assign(expectedResponse, result);
    return {
      messages,
      showSupportShortSyncResponseNote
    };
  }

  getSyncResponseWarnings(response, requestDesc) {
    const messages = [],
          expectedResponse = {},
          request = requestDesc.pack;

    if (!this.skipSuccessProperty) {
      expectedResponse.success = true;
    }

    let showSupportShortSyncResponseNote = false; // iterate stores to check properties validity

    this.forEachCrudStore((store, storeId, storeInfo) => {
      const warnings = this.getStoreSyncResponseWarnings(storeInfo, request === null || request === void 0 ? void 0 : request[storeId], response[storeId], expectedResponse);
      showSupportShortSyncResponseNote = showSupportShortSyncResponseNote || warnings.showSupportShortSyncResponseNote;
      messages.push(...warnings.messages);
    });

    if (messages.length) {
      messages.push('Please adjust your response to look like this:\n' + JSON.stringify(expectedResponse, null, 4).replace(/"\.\.\.":\s*"\.\.\."/g, ',,,').replace(/"\.\.\."/g, '...'));

      if (showSupportShortSyncResponseNote) {
        messages.push(this.supportShortSyncResponseNote);
      }

      messages.push(this.disableValidationNote);
    }

    return messages;
  }

  validateSyncResponse(response, request) {
    const messages = this.getSyncResponseWarnings(response, request);

    if (messages.length) {
      console.warn(this.crudSyncValidationWarningPrefix + '\n' + messages.join('\n'));
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/crud/mixin/CrudManagerView.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/crud/mixin/CrudManagerView.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/LoadMaskable.js */ "./lib/Core/mixin/LoadMaskable.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
var productName = 'gantt';
/**
* @module Scheduler/crud/mixin/CrudManagerView
*/



/**
 * Mixin to track Crud Manager requests to the server and mask the view during them. For masking it
 * uses the {@link Core.mixin.LoadMaskable#config-loadMask} and {@link Core.mixin.LoadMaskable#config-syncMask}
 * properties.
 *
 * @mixin
 * @extends Core/mixin/LoadMaskable
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class CrudManagerView extends Target.mixin(_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'CrudManagerView';
  } //region Init


  afterConstruct() {
    super.afterConstruct();
    const {
      crudManager,
      project
    } = this;

    if (this.loadMask && (crudManager || project).isCrudManagerLoading) {
      // Show loadMask if crud manager is already loading
      this.onCrudManagerLoadStart();
    }
  } //endregion

  /**
   * Applies the {@link Scheduler.crud.mixin.CrudManagerView#config-syncMask} as the
   * {@link Core.widget.Widget#config-masked mask} for this widget.
   * @internal
   */


  applySyncMask() {
    const {
      syncMask
    } = this;

    if (syncMask) {
      this.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_1__["default"].mergeConfigs(this.loadMaskDefaults, syncMask);
    }
  }
  /**
   * Hooks up crud manager listeners
   * @private
   * @category Store
   */


  bindCrudManager(crudManager) {
    this.detachListeners('crudManager');
    crudManager === null || crudManager === void 0 ? void 0 : crudManager.on({
      name: 'crudManager',
      loadStart: 'onCrudManagerLoadStart',
      load: 'onCrudManagerLoad',
      loadCanceled: 'onCrudManagerLoadCanceled',
      syncStart: 'onCrudManagerSyncStart',
      sync: 'onCrudManagerSync',
      syncCanceled: 'onCrudManagerSyncCanceled',
      requestFail: 'onCrudManagerRequestFail',
      thisObj: this
    });
  }

  onCrudManagerLoadStart() {
    var _this$toggleEmptyText;

    // Show loadMask before crud manager starts loading
    this.applyLoadMask();
    (_this$toggleEmptyText = this.toggleEmptyText) === null || _this$toggleEmptyText === void 0 ? void 0 : _this$toggleEmptyText.call(this);
  }

  onCrudManagerSyncStart() {
    this.applySyncMask();
  }

  onCrudManagerRequestFinalize(successful = true, requestType, response) {
    const me = this;

    if (successful) {
      var _me$toggleEmptyText;

      me.masked = null;
      (_me$toggleEmptyText = me.toggleEmptyText) === null || _me$toggleEmptyText === void 0 ? void 0 : _me$toggleEmptyText.call(me);
    } else {
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{GridBase.loadFailedMessage}'
      // 'L{GridBase.syncFailedMessage}'
      me.applyMaskError(`<div class="b-grid-load-failure">
                    <div class="b-grid-load-fail">${me.L(`L{GridBase.${requestType}FailedMessage}`)}</div>
                    ${response && response.message ? `<div class="b-grid-load-fail">${me.L('L{CrudManagerView.serverResponseLabel}')} ${response.message}</div>` : ''}
                </div>`);
    }
  }

  onCrudManagerLoadCanceled() {
    this.onCrudManagerRequestFinalize(true, 'load');
  }

  onCrudManagerSyncCanceled() {
    this.onCrudManagerRequestFinalize(true, 'sync');
  }

  onCrudManagerLoad() {
    this.onCrudManagerRequestFinalize(true, 'load');
  }

  onCrudManagerSync() {
    this.onCrudManagerRequestFinalize(true, 'sync'); // Repaint rows to have "b-sch-dirty" class up-to-date on the event elements.
    // Needed when no new changes come from server, and there is nothing to apply back to the records.
    // TODO: when https://github.com/bryntum/support/issues/2720 is done, we can refresh specific rows (note, Calendar has many views)

    this.refresh();
  }

  onCrudManagerRequestFail({
    requestType,
    response
  }) {
    this.onCrudManagerRequestFinalize(false, requestType, response);
  }

  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/crud/transport/AjaxTransport.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/crud/transport/AjaxTransport.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';



/**
 * @module Scheduler/crud/transport/AjaxTransport
 */

/**
 * Implements data transferring functional that can be used for {@link Scheduler.crud.AbstractCrudManager} super classing.
 * Uses the fetch API for transport, https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends AjaxTransport(JsonEncode(AbstractCrudManager)) {}
 *
 * @abstract
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AjaxTransport extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'AjaxTransport';
  }
  /**
   * Configuration of the AJAX requests used by _Crud Manager_ to communicate with a server-side.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // pass extra HTTP request parameter
   *         params    : {
   *             foo : 'bar'
   *         }
   *     },
   *     sync : {
   *         url     : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for requests
   *         headers : {
   *             'Content-Type' : 'application/json'
   *         }
   *     }
   * }
   *```
   * Since the class uses Fetch API you can use
   * any its [Request interface](https://developer.mozilla.org/en-US/docs/Web/API/Request) options:
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url         : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName   : 'data',
   *         // pass few Fetch API options
   *         method      : 'GET',
   *         credentials : 'include',
   *         cache       : 'no-cache'
   *     },
   *     sync : {
   *         url         : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for requests
   *         headers     : {
   *             'Content-Type' : 'application/json'
   *         },
   *         credentials : 'include'
   *     }
   * }
   *```
   *
   * An object where you can set the following possible properties:
   * @config {Object} transport
   * @property {Object} transport.load Load requests configuration:
   * @property {String} transport.load.url URL to request for data loading.
   * @property {String} [transport.load.method='GET'] HTTP method to be used for load requests.
   * @property {String} [transport.load.paramName='data'] Name of the parameter that will contain a serialized `load` request.
   * The value is mandatory for requests using `GET` method (default for `load`) so if the value is not provided `data` string is used as default.
   * This value is optional for HTTP methods like `POST` and `PUT`, the request body will be used for data transferring in these cases.
   * @property {Object} [transport.load.params] An object containing extra HTTP parameters to pass to the server when sending a `load` request.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // pass extra HTTP request parameter
   *         // so resulting URL will look like: http://mycool-server.com/load.php?userId=123456&data=...
   *         params    : {
   *             userId : '123456'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.headers] An object containing headers to pass to each server request.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // specify Content-Type for "load" requests
   *         headers   : {
   *             'Content-Type' : 'application/json'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
   * ```javascript
   * transport : {
   *     load : {
   *         url          : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName    : 'data',
   *         // Fetch API options
   *         method       : 'GET',
   *         credentials  : 'include'
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
   * @property {Object} transport.sync Sync requests (`sync` in further text) configuration:
   * @property {String} transport.sync.url URL to request for `sync`.
   * @property {String} [transport.sync.method='POST'] HTTP request method to be used for `sync`.
   * @property {String} [transport.sync.paramName=undefined] Name of the parameter in which `sync` data will be transferred.
   * This value is optional for requests using methods like `POST` and `PUT`, the request body will be used for data transferring in this case (default for `sync`).
   * And the value is mandatory for requests using `GET` method (if the value is not provided `data` string will be used as fallback).
   * @property {Object} [transport.sync.params] HTTP headers to pass with an HTTP request handling `sync`.
   *
   * ```javascript
   * transport : {
   *     sync : {
   *         url    : 'http://mycool-server.com/sync.php',
   *         // extra HTTP request parameter
   *         params : {
   *             userId : '123456'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.headers] HTTP headers to pass with an HTTP request handling `sync`.
   *
   * ```javascript
   * transport : {
   *     sync : {
   *         url     : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for "sync" requests
   *         headers : {
   *             'Content-Type' : 'application/json'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
   * ```javascript
   * transport : {
   *     sync : {
   *         url         : 'http://mycool-server.com/sync.php',
   *         credentials : 'include'
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
   */


  static get defaultMethod() {
    return {
      load: 'GET',
      sync: 'POST'
    };
  }
  /**
   * Cancels a sent request.
   * @param {Promise} requestPromise The Promise object wrapping the Request to be cancelled.
   * The _requestPromise_ is the value returned from the corresponding {@link #function-sendRequest} call.
   */


  cancelRequest(requestPromise, reject) {
    var _requestPromise$abort;

    (_requestPromise$abort = requestPromise.abort) === null || _requestPromise$abort === void 0 ? void 0 : _requestPromise$abort.call(requestPromise); // TODO fix this

    reject({
      cancelled: true
    });
  }

  shouldUseBodyForRequestData(packCfg, method, paramName) {
    return !(method === 'HEAD' || method === 'GET') && !paramName;
  }
  /**
   * Sends a _Crud Manager_ request to the server.
   * @param {Object}   request The request configuration object having following properties:
   * @param {String}   request.type The request type. Either `load` or `sync`.
   * @param {String}   request.url The URL for the request. Overrides the URL defined in the `transport` object
   * @param {String}   request.data The encoded _Crud Manager_ request data.
   * @param {Object}   request.params An object specifying extra HTTP params to send with the request.
   * @param {Function} request.success A function to be started on successful request transferring.
   * @param {String}   request.success.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
   * @param {Function} request.failure A function to be started on request transfer failure.
   * @param {String}   request.failure.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
   * @param {Object}   request.thisObj `this` reference for the above `success` and `failure` functions.
   * @return {Promise} The fetch Promise object.
   * @fires beforesend
   */


  sendRequest(request) {
    const me = this,
          {
      data
    } = request,
          transportConfig = me.transport[request.type] || {},
          // clone parameters defined for this type of request
    requestConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, transportConfig, transportConfig.requestConfig);

    if (request.url) {
      requestConfig.url = request.url;
    }

    requestConfig.method = requestConfig.method || AjaxTransport.defaultMethod[request.type];
    requestConfig.params = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(requestConfig.params || {}, request.params);
    let {
      paramName
    } = requestConfig; // transfer package in the request body for some types of HTTP requests

    if (me.shouldUseBodyForRequestData(transportConfig, requestConfig.method, paramName)) {
      requestConfig.body = data; // for requests having body we set Content-Type to 'application/json' by default

      requestConfig.headers = requestConfig.headers || {};
      requestConfig.headers['Content-Type'] = requestConfig.headers['Content-Type'] || 'application/json';
    } else {
      // when we don't use body paramName is mandatory so fallback to 'data' as name
      paramName = paramName || 'data';
      requestConfig.params[paramName] = data;
    }

    if (!requestConfig.url) {
      throw new Error('Trying to request without URL specified');
    } // sanitize request config


    delete requestConfig.requestConfig;
    delete requestConfig.paramName;
    /**
     * Fires before a request is sent to the server.
     *
     * ```javascript
     * crudManager.on('beforeSend', function ({ params, type }) {
     *     // let's set "sync" request parameters
     *     if (type == 'sync') {
     *         // dynamically depending on "flag" value
     *         if (flag) {
     *             params.foo = 'bar';
     *         }
     *         else {
     *             params.foo = 'smth';
     *         }
     *     }
     * });
     * ```
     * @event beforeSend
     * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
     * @param {Object} params HTTP request params to be passed in the request URL.
     * @param {String} type CrudManager request type (`load`/`sync`)
     * @param {Object} requestConfig Configuration object for Ajax request call
     */

    me.trigger('beforeSend', {
      params: requestConfig.params,
      type: request.type,
      requestConfig,
      config: request
    }); // AjaxHelper.fetch call it "queryParams"

    requestConfig.queryParams = requestConfig.params;
    delete requestConfig.params;
    let responsePromise,
        cancelled = false;
    const fetchOptions = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, requestConfig, requestConfig.fetchOptions),
          ajaxPromise = _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].fetch(requestConfig.url, fetchOptions);
    ajaxPromise.catch(error => {
      var _fetchOptions$abortCo;

      ajaxPromise.done = true;
      const signal = (_fetchOptions$abortCo = fetchOptions.abortController) === null || _fetchOptions$abortCo === void 0 ? void 0 : _fetchOptions$abortCo.signal;

      if (signal) {
        cancelled = signal.aborted;

        if (!cancelled) {
          console.warn(error);
        }
      }

      return {
        error,
        cancelled
      };
    }).then(response => {
      ajaxPromise.done = true;
      const cb = response !== null && response !== void 0 && response.ok ? request.success : request.failure;
      responsePromise = cb === null || cb === void 0 ? void 0 : cb.call(request.thisObj || me, response, fetchOptions, request);
    }); // TODO: do we really need to wait for responsePromise completion?

    const result = Promise.all([ajaxPromise, responsePromise]);

    result.abort = () => {
      if (!ajaxPromise.done) {
        var _ajaxPromise$abort;

        (_ajaxPromise$abort = ajaxPromise.abort) === null || _ajaxPromise$abort === void 0 ? void 0 : _ajaxPromise$abort.call(ajaxPromise);
      }
    };

    return result;
  }

});

/***/ }),

/***/ "./lib/Scheduler/customElements/TimelineBaseTag.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/customElements/TimelineBaseTag.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimelineBaseTag; });
/* harmony import */ var _Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/customElements/WidgetTag.js */ "./lib/Core/customElements/WidgetTag.js");
var productName = 'gantt';

/**
 * @module Scheduler/customElements/TimelineBaseTag
 */

/**
 * Abstract base class for SchedulerTag, SchedulerProTag and GanttTag.
 *
 * @extends Core/customElements/WidgetTag
 * @abstract
 */

class TimelineBaseTag extends _Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  createInstance(config) {
    const me = this,
          columns = [],
          resources = [],
          events = [],
          assignments = [],
          dependencies = []; // create columns and data

    for (const tag of me.children) {
      if (tag.tagName === 'COLUMN') {
        const columnConfig = Object.assign({}, tag.dataset); // if the column title is provide as the tag text

        if (!columnConfig.text && tag.innerHTML) {
          columnConfig.text = tag.innerHTML;
        }

        if (columnConfig.width) {
          columnConfig.width = parseInt(columnConfig.width);
        }

        if (columnConfig.flex) {
          columnConfig.flex = parseInt(columnConfig.flex);
        } else if (!columnConfig.width) {
          columnConfig.flex = 1;
        }

        columns.push(columnConfig);
      } else if (tag.tagName === 'DATA') {
        for (const storeType of tag.children) {
          for (const record of storeType.children) {
            const {
              tagName
            } = storeType;
            let collection;

            if (tagName === 'EVENTS' || tagName === 'TASKS') {
              collection = events;
            } else if (tagName === 'RESOURCES') {
              collection = resources;
            } else if (tagName === 'DEPENDENCIES') {
              collection = dependencies;
            } else if (tagName === 'ASSIGNMENTS') {
              collection = assignments;
            }

            me.processRecord(record, collection);
          }
        }
      } else if (tag.tagName === 'PROJECT') {
        config.project = new me.projectModelClass({
          autoLoad: true,
          transport: {
            load: {
              url: tag.dataset.loadUrl
            }
          }
        });
      }
    } // Gantt gets mad if both project and inline data is supplied


    if (events.length) {
      config.events = events;
    }

    if (resources.length) {
      config.resources = resources;
    }

    if (dependencies.length) {
      config.dependencies = dependencies;
    }

    return new this.widgetClass(Object.assign(config, {
      columns
    }));
  }

  processRecord(recordTag, output) {
    const row = {};
    Object.assign(row, this.convertDatasetToConfigs(recordTag.dataset, {}, true));

    if (recordTag.children.length) {
      row.children = [];

      for (const child of recordTag.children) {
        this.processRecord(child, row.children);
      }
    }

    output.push(row);
  }

}
TimelineBaseTag._$name = 'TimelineBaseTag';

/***/ }),

/***/ "./lib/Scheduler/data/AssignmentStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/AssignmentStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
/* harmony import */ var _mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Engine/quark/store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
var productName = 'gantt';






const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__["CoreAssignmentStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/AssignmentStore
 */

/**
 * A store representing a collection of assignments between events in the {@link Scheduler.data.EventStore} and resources
 * in the {@link Scheduler.data.ResourceStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.AssignmentModel}.
 *
 * An AssignmentStore is usually connected to a project, which binds it to other related stores (EventStore,
 * ResourceStore and DependencyStore). The project also handles references (event, resource) to related records for the
 * records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * assignmentStore.data = [{ eventId, resourceId }, ...];
 *
 * // references (event, resource) not resolved yet
 *
 * await assignmentStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await assignmentStore.loadDataAsync([{ eventId, resourceId }, ...]);
 *
 * // references (event, resource) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/AssignmentStoreMixin
 * @mixes Scheduler/data/mixin/PartOfProject
 * @extends Core/data/AjaxStore
 */

class AssignmentStore extends Object(_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["default"])(EngineMixin) {
  static get defaultConfig() {
    return {
      modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
AssignmentStore._$name = 'AssignmentStore';

/***/ }),

/***/ "./lib/Scheduler/data/CrudManager.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/data/CrudManager.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CrudManager; });
/* harmony import */ var _ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _EventStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _DependencyStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';











/**
 * @module Scheduler/data/CrudManager
 */

/**
 * The Crud Manager (or "CM") is a class implementing centralized loading and saving of data in multiple stores.
 * Loading the stores and saving all changes is done using a single request. The stores managed by CRUD manager should
 * not be configured with their own CRUD URLs or use {@link Core/data/AjaxStore#config-autoLoad}/{@link Core/data/AjaxStore#config-autoCommit}.
 *
 * This class uses JSON as its data encoding format.
 *
 * ## Scheduler stores
 *
 * The class supports Scheduler specific stores (namely: resource, event, assignment and dependency stores).
 * For these stores, the CM has separate configs ({@link #config-resourceStore}, {@link #config-eventStore},
 * {@link #config-assignmentStore}) to register them.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * ## AJAX request configuration
 *
 * To configure AJAX request parameters please take a look at the
 * {@link Scheduler/crud/transport/AjaxTransport} docs.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore,
 *     eventStore,
 *     assignmentStore,
 *     transport       : {
 *         load    : {
 *             url         : 'php/read.php',
 *             // use GET request
 *             method      : 'GET',
 *             // pass request JSON in "rq" parameter
 *             paramName   : 'rq',
 *             // extra HTTP request parameters
 *             params      : {
 *                 foo     : 'bar'
 *             },
 *             // pass some extra Fetch API option
 *             credentials : 'include'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 * ## Using inline data
 *
 * The CrudManager provides settable property {@link #property-inlineData} that can
 * be used to get data from all {@link #property-crudStores} at once and to set this
 * data as well. Populating the stores this way can be useful if you cannot or you do not want to use CrudManager for
 * server requests but you pull the data by other means and have it ready outside CrudManager. Also, the data from all
 * stores is available in a single assignment statement.
 *
 * ### Getting data
 * ```javascript
 * const data = scheduler.crudManager.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * const data = // your function to pull server data
 *
 * scheduler.crudManager.inlineData = data;
 * ```
 *
 * ## Load order
 *
 * The CM is aware of the proper load order for Scheduler specific stores so you don't need to worry about it.
 * If you provide any extra stores (using {@link #config-stores} config) they will be
 * added to the start of collection before the Scheduler specific stores.
 * If you need a different loading order, you should use {@link #function-addStore} method to
 * register your store:
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     // extra user defined stores will get to the start of collection
 *     // so they will be loaded first
 *     stores          : [ store1, store2 ],
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 *
 * // append store3 to the end so it will be loaded last
 * crudManager.addStore(store3);
 *
 * // now when we registered all the stores let's load them
 * crudManager.load();
 * ```
 *
 * ## Assignment store
 *
 * The Crud Manager is designed to use {@link Scheduler/data/AssignmentStore} for assigning events to one or multiple resources.
 * However if server provides `resourceId` for any of the `events` then the Crud Manager enables backward compatible mode when
 * an event could have a single assignment only. This also disables multiple assignments in Scheduler UI.
 * In order to use multiple assignments server backend should be able to receive/send `assignments` for `load` and `sync` requests.
 *
 * ## Project
 *
 * The Crud Manager automatically consumes stores of the provided project (namely its {@link Scheduler/model/ProjectModel#property-eventStore},
 * {@link Scheduler/model/ProjectModel#property-resourceStore}, {@link Scheduler/model/ProjectModel#property-assignmentStore},
 * {@link Scheduler/model/ProjectModel#property-dependencyStore}, {@link Scheduler/model/ProjectModel#property-timeRangeStore} and
 * {@link Scheduler/model/ProjectModel#property-resourceTimeRangeStore}):
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     // crud manager will get stores from myAppProject project
 *     project   : myAppProject,
 *     transport : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * @mixes Scheduler/data/mixin/ProjectCrudManager
 * @mixes Scheduler/crud/encoder/JsonEncoder
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @extends Scheduler/crud/AbstractCrudManager
 */

class CrudManager extends _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].mixin(_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_5__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_7__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_8__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      projectClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_9__["default"],
      resourceStoreClass: _ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__["default"],
      eventStoreClass: _EventStore_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      assignmentStoreClass: _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      dependencyStoreClass: _DependencyStore_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * A store with resources (or its descriptor).
       * @config {Scheduler.data.ResourceStore|Object}
       */
      resourceStore: {},

      /**
       * A store with events (or its descriptor).
       *
       * ```
       * crudManager : {
       *      eventStore {
       *          storeClass : MyEventStore
       *      }
       * }
       * ```
       * @config {Scheduler.data.EventStore|Object}
       */
      eventStore: {},

      /**
       * A store with assignments (or its descriptor).
       * @config {Scheduler.data.AssignmentStore|Object}
       */
      assignmentStore: {},

      /**
       * A store with dependencies (or its descriptor).
       * @config {Scheduler.data.DependencyStore|Object}
       */
      dependencyStore: {},

      /**
       * A project that holds and links stores
       * @config {Scheduler.model.ProjectModel}
       */
      project: null
    };
  } //endregion


  buildProject() {
    return new this.projectClass(this.buildProjectConfig());
  }

  buildProjectConfig() {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].cleanupProperties({
      eventStore: this.eventStore,
      resourceStore: this.resourceStore,
      assignmentStore: this.assignmentStore,
      dependencyStore: this.dependencyStore,
      resourceTimeRangeStore: this.resourceTimeRangeStore
    });
  } //region Stores


  set project(project) {
    const me = this;

    if (project !== me._project) {
      me.detachListeners('beforeDataReady');
      me.detachListeners('afterDataReady');
      me._project = project;

      if (project) {
        me.eventStore = project.eventStore;
        me.resourceStore = project.resourceStore;
        me.assignmentStore = project.assignmentStore;
        me.dependencyStore = project.dependencyStore;
        me.timeRangeStore = project.timeRangeStore;
        me.resourceTimeRangeStore = project.resourceTimeRangeStore; // When adding multiple events to the store it will trigger multiple change events each of which will
        // call crudManager.hasChanges, which will try to actually get the changeset package. It takes some time
        // and we better skip that part for the dataready event, suspending changes tracking.

        project.on({
          name: 'beforeDataReady',
          dataReady: () => me.suspendChangesTracking(),
          prio: 100,
          thisObj: me
        });
        project.on({
          name: 'afterDataReady',
          dataReady: () => me.resumeChangesTracking(),
          prio: -100,
          thisObj: me
        });
      }

      if (!me.eventStore) {
        me.eventStore = {};
      }

      if (!me.resourceStore) {
        me.resourceStore = {};
      }

      if (!me.assignmentStore) {
        me.assignmentStore = {};
      }

      if (!me.dependencyStore) {
        me.dependencyStore = {};
      }
    }
  }

  get project() {
    return this._project;
  }
  /**
   * Store for {@link Scheduler/feature/TimeRanges timeRanges} feature.
   * @property {Core.data.Store}
   * @deprecated Please use {@link #property-timeRangeStore} property
   * @readonly
   */


  get timeRangesStore() {
    return this.timeRangeStore;
  }
  /**
   * Store for {@link Scheduler/feature/TimeRanges timeRanges} feature.
   * @property {Core.data.Store}
   */


  get timeRangeStore() {
    var _this$_timeRangeStore;

    return (_this$_timeRangeStore = this._timeRangeStore) === null || _this$_timeRangeStore === void 0 ? void 0 : _this$_timeRangeStore.store;
  }

  set timeRangeStore(store) {
    var _this$project;

    this.setFeaturedStore('_timeRangeStore', store, (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.timeRangeStoreClass);
  }
  /**
   * Store for {@link Scheduler/feature/ResourceTimeRanges resourceTimeRanges} feature.
   * @property {Core.data.Store}
   */


  get resourceTimeRangeStore() {
    var _this$_resourceTimeRa;

    return (_this$_resourceTimeRa = this._resourceTimeRangeStore) === null || _this$_resourceTimeRa === void 0 ? void 0 : _this$_resourceTimeRa.store;
  }

  set resourceTimeRangeStore(store) {
    var _this$project2;

    this.setFeaturedStore('_resourceTimeRangeStore', store, (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.resourceTimeRangeStoreClass);
  }
  /**
   * Get/set the resource store bound to the CRUD manager.
   * @property {Scheduler.data.ResourceStore}
   */


  get resourceStore() {
    var _this$_resourceStore;

    return (_this$_resourceStore = this._resourceStore) === null || _this$_resourceStore === void 0 ? void 0 : _this$_resourceStore.store;
  }

  set resourceStore(store) {
    const me = this;
    me.setFeaturedStore('_resourceStore', store, me.resourceStoreClass);
  }
  /**
   * Get/set the event store bound to the CRUD manager.
   * @property {Scheduler.data.EventStore}
   */


  get eventStore() {
    var _this$_eventStore;

    return (_this$_eventStore = this._eventStore) === null || _this$_eventStore === void 0 ? void 0 : _this$_eventStore.store;
  }

  set eventStore(store) {
    const me = this;
    me.setFeaturedStore('_eventStore', store, me.eventStoreClass);
  }
  /**
   * Get/set the assignment store bound to the CRUD manager.
   * @property {Scheduler.data.AssignmentStore}
   */


  get assignmentStore() {
    var _this$_assignmentStor;

    return (_this$_assignmentStor = this._assignmentStore) === null || _this$_assignmentStor === void 0 ? void 0 : _this$_assignmentStor.store;
  }

  set assignmentStore(store) {
    this.setFeaturedStore('_assignmentStore', store, this.assignmentStoreClass);
  }
  /**
   * Get/set the dependency store bound to the CRUD manager.
   * @property {Scheduler.data.DependencyStore}
   */


  get dependencyStore() {
    var _this$_dependencyStor;

    return (_this$_dependencyStor = this._dependencyStore) === null || _this$_dependencyStor === void 0 ? void 0 : _this$_dependencyStor.store;
  }

  set dependencyStore(store) {
    this.setFeaturedStore('_dependencyStore', store, this.dependencyStoreClass);
  }

  setFeaturedStore(property, store, storeClass) {
    var _me$property;

    const me = this,
          oldStore = (_me$property = me[property]) === null || _me$property === void 0 ? void 0 : _me$property.store; // if not the same store

    if (oldStore !== store) {
      var _store;

      // normalize store value (turn it into a storeClass instance if needed)
      store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStore(store, ((_store = store) === null || _store === void 0 ? void 0 : _store.storeClass) || storeClass);

      if (oldStore) {
        me.removeStore(oldStore);
      }

      me[property] = store && {
        store
      } || null; // Adds configured scheduler stores to the store collection ensuring correct order
      // unless they're already registered.

      me.addPrioritizedStore(me[property]);
    }

    return me[property];
  }

  getChangeSetPackage() {
    const pack = super.getChangeSetPackage(); // Remove assignments from changes if using single assignment mode (resourceId)

    if (pack && this.eventStore.usesSingleAssignment) {
      delete pack[this.assignmentStore.storeId]; // No other changes?

      if (!this.crudStores.some(storeInfo => pack[storeInfo.storeId])) {
        return null;
      }
    }

    return pack;
  } //endregion


  get crudLoadValidationMandatoryStores() {
    return [this._eventStore.storeId, this._resourceStore.storeId];
  }

}
;
CrudManager._$name = 'CrudManager';

/***/ }),

/***/ "./lib/Scheduler/data/DependencyStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/DependencyStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'gantt';






const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["CoreDependencyStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/DependencyStore
 */

/**
 * A store representing a collection of dependencies between events in the {@link Scheduler.data.EventStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.DependencyModel}.
 *
 * A DependencyStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and ResourceStore). The project also handles references (fromEvent, toEvent) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * dependencyStore.data = [{ from, to }, ...];
 *
 * // references (fromEvent, toEvent) not resolved yet
 *
 * await dependencyStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await dependencyStore.loadDataAsync([{ from, to }, ...]);
 *
 * // references (fromEvent, toEvent) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/DependencyStoreMixin
 * @extends Core/data/AjaxStore
 */

class DependencyStore extends Object(_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"])(EngineMixin.derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get defaultConfig() {
    return {
      modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
DependencyStore._$name = 'DependencyStore';

/***/ }),

/***/ "./lib/Scheduler/data/EventStore.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/data/EventStore.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony import */ var _mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony import */ var _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony import */ var _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Engine/quark/store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'gantt';








const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_5__["default"])(_Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__["CoreEventStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/EventStore
 */

/**
 * A store holding all the {@link Scheduler.model.EventModel events} to be rendered into a {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.EventModel}.
 *
 * An EventStore is usually connected to a project, which binds it to other related stores (AssignmentStore,
 * ResourceStore and DependencyStore). The project also handles normalization/calculation of the data on the records in
 * the store. For example if a record is added with a `startDate` and an `endDate`, it will calculate the `duration`.
 *
 * The calculations happens async, records are not guaranteed to have up to date data until they are finished. To be
 * certain that calculations have finished, call `await project.commitAsync()` after store actions. Or use one of the
 * `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * eventStore.data = [{ startDate, endDate }, ...];
 *
 * // duration of the record is not yet calculated
 *
 * await eventStore.project.commitAsync();
 *
 * // now it is
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await eventStore.loadDataAsync([{ startDate, endDate }, ...]);
 *
 * // duration is calculated
 * ```
 *
 * ## Using recurring events
 * When recurring events are in the database, **all recurring event definitions** which started before
 * the requested start date, and have not yet finished recurring MUST be loaded into the EventStore.
 *
 * Only the **base** recurring event **definitions** are stored in the EventStore. You do not
 * need to calculate the future occurrence dates of these events. This is all handled by the EventStore.
 *
 * When asked to yield a set of events for a certain date range for creating a UI through
 * {@link #function-getEvents}, the EventStore *automatically* interpolates any occurrences of
 * recurring events into the results. They do not occupy slots in the EventStore for every date
 * in their repetition range (that would be very inefficient, and *might* be infinite).
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/SharedEventStoreMixin
 * @mixes Scheduler/data/mixin/EventStoreMixin
 * @mixes Scheduler/data/mixin/RecurringEventsMixin
 * @extends Core/data/AjaxStore
 */

class EventStore extends EngineMixin.mixin(_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * Class used to represent records
       * @config {Scheduler.model.EventModel}
       * @default
       * @category Common
       */
      modelClass: _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]
    };
  }

}
EventStore._$name = 'EventStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceStore.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/data/ResourceStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceStore; });
/* harmony import */ var _mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony import */ var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'gantt';






const EngineMixin = Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["CoreResourceStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/**
 * @module Scheduler/data/ResourceStore
 */

/**
 * A store holding all the {@link Scheduler.model.ResourceModel resources} to be rendered into a
 * {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.ResourceModel}.
 *
 * A ResourceStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and DependencyStore). The project also handles references (assignments, events) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * resourceStore.data = [{ id }, ...];
 *
 * // references (assignments, events) not resolved yet
 *
 * await resourceStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await resourceStore.loadDataAsync([{ id }, ...]);
 *
 * // references (assignments, events) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/ResourceStoreMixin
 * @extends Core/data/AjaxStore
 */

class ResourceStore extends Object(_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_0__["default"])(EngineMixin) {
  static get defaultConfig() {
    return {
      modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
ResourceStore._$name = 'ResourceStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceTimeRangeStore.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/data/ResourceTimeRangeStore.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
var productName = 'gantt';


/**
 * @module Scheduler/data/ResourceTimeRangeStore
 */

/**
 * A class representing a collection of resource time ranges.
 * Contains a collection of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel} records.
 * The class is used by the {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
 *
 * ## Recurring ranges support
 *
 * By default the class doesn't support recurrence. In order to add its support
 * please use {@link Scheduler.data.mixin.RecurringTimeSpansMixin RecurringTimeSpansMixin} mixin
 * (the store model in turn should be mixed with {@link Scheduler/model/mixin/RecurringTimeSpan RecurringTimeSpan} class):
 *
 * ```js
 * // Mix RecurringTimeSpan (which adds recurrence support) to ResourceTimeRangeModel
 * class MyResourceTimeRange extends RecurringTimeSpan(ResourceTimeRangeModel) {};
 *
 * // Mix RecurringTimeSpansMixin (which adds recurrence support) to ResourceTimeRangeStore
 * class MyResourceTimeRangeStore extends RecurringTimeSpansMixin(ResourceTimeRangeStore) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyResourceTimeRange
 *         };
 *     }
 * };
 *
 * // Make new store that supports time ranges recurrence
 * const store = new MyResourceTimeRangeStore({
 *     data : [{        {
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Coffee break',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 * ```
 *
 * @extends Core/data/AjaxStore
 */

class ResourceTimeRangeStore extends _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 500,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 500,

      /**
       * This store should be linked to a ResourceStore to link the time ranges to resources
       * @config {Scheduler.data.ResourceStore}
       */
      resourceStore: null,
      modelClass: _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      storeId: 'resourceTimeRanges'
    };
  }

  set resourceStore(store) {
    this._resourceStore = store; // If store is assigned after configuration we need to init relations

    if (!this.isConfiguring) {
      this.initRelations(true);
    }
  }

  get resourceStore() {
    return this._resourceStore;
  } // Matching signature in EventStore to allow reusage of SchedulerStores#onInternalEventStoreChange()


  getResourcesForEvent(resourceTimeRange) {
    return [resourceTimeRange.resource];
  }

}
ResourceTimeRangeStore._$name = 'ResourceTimeRangeStore';

/***/ }),

/***/ "./lib/Scheduler/data/TimeAxis.js":
/*!****************************************!*\
  !*** ./lib/Scheduler/data/TimeAxis.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxis; });
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
var productName = 'gantt';





/**
 * @module Scheduler/data/TimeAxis
 */
// Micro-optimized version of TimeSpan for faster reading. Hit a lot and since it is internal fields are guaranteed to
// not be remapped and changes wont be batches, so we can always return raw value from data avoiding all additional
// checks and logic

class Tick extends _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  // Only getters on purpose, we do not support manipulating ticks
  get startDate() {
    return this.data.startDate;
  }

  get endDate() {
    return this.data.endDate;
  }

}
/**
 * A class representing the time axis of the scheduler. The scheduler timescale is based on the ticks generated by this class.
 * This is a pure "data" (model) representation of the time axis and has no UI elements.
 *
 * The time axis can be {@link #config-continuous} or not. In continuous mode, each timespan starts where the previous ended, and in non-continuous mode
 * there can be gaps between the ticks.
 * A non-continuous time axis can be used when want to filter out certain periods of time (like weekends) from the time axis.
 *
 * To create a non-continuous time axis you have 2 options. First, you can create a time axis containing only the time spans of interest.
 * To do that, subclass this class and override the {@link #function-generateTicks} method.
 *
 * The other alternative is to call the {@link #function-filterBy} method, passing a function to it which should return `false` if the time tick should be filtered out.
 * Calling {@link Core.data.mixin.StoreFilter#function-clearFilters} will return you to a full time axis.
 *
 * @extends Core/data/Store
 */


class TimeAxis extends _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Events

  /**
   * Fires before the timeaxis is about to be reconfigured (e.g. new start/end date or unit/increment). Return false to abort the operation.
   * @event beforereconfigure
   * @param {Scheduler.data.TimeAxis} source The time axis instance
   * @param {Date} startDate The new time axis start date
   * @param {Date} endDate The new time axis end date
   */

  /**
   * Event that is triggered when we end reconfiguring and everything UI-related should be done
   * @event endreconfigure
   * @private
   */

  /**
   * Fires when the timeaxis has been reconfigured (e.g. new start/end date or unit/increment)
   * @event reconfigure
   * @param {Scheduler.data.TimeAxis} source The time axis instance
   */

  /**
   * Fires if all the ticks in the timeaxis are filtered out. After firing the filter is cleared to return the time
   * axis to a valid state.
   * @event invalidFilter
   * @param {Scheduler.data.TimeAxis} source The time axis instance
   */
  //endregion
  //region Default config
  static get defaultConfig() {
    return {
      modelClass: Tick,

      /**
       * Set to false if the timeline is not continuous, e.g. the next timespan does not start where the previous ended (for example skipping weekends etc).
       * @config {Boolean}
       * @default
       */
      continuous: true,
      originalContinuous: null,

      /**
       * Include only certain hours or days in the time axis (makes it `continuous : false`). Accepts and object
       * with `day` and `hour` properties:
       * ```
       * const scheduler = new Scheduler({
       *     timeAxis : {
       *         include : {
       *              // Do not display hours after 17 or before 9 (only display 9 - 17). The `to´ value is not
       *              // included in the time axis
       *              hour : {
       *                  from : 9,
       *                  to   : 17
       *              },
       *              // Do not display sunday or saturday
       *              day : [0, 6]
       *         }
       *     }
       * }
       * ```
       * In most cases we recommend that you use Scheduler's workingTime config instead. It is easier to use and
       * makes sure all parts of the Scheduler gets updated.
       * @config {Object}
       */
      include: null,

      /**
       * Automatically adjust the timespan when generating ticks with {@link #function-generateTicks} according to
       * the `viewPreset` configuration. Setting this to false may lead to shifting time/date of ticks.
       * @config {Boolean}
       * @default
       */
      autoAdjust: true,
      unit: null,
      increment: null,
      resolutionUnit: null,
      resolutionIncrement: null,
      weekStartDay: null,
      mainUnit: null,
      shiftUnit: null,
      shiftIncrement: 1,
      //isConfigured : false,
      // in case of `autoAdjust : false`, the 1st and last ticks can be truncated, containing only part of the normal tick
      // these dates will contain adjusted start/end (like if the tick has not been truncated)
      adjustedStart: null,
      adjustedEnd: null,
      // the visible position in the first tick, can actually be > 1 because the adjustment is done by the `mainUnit`
      visibleTickStart: null,
      // the visible position in the first tick, is always ticks count - 1 < value <= ticks count, in case of autoAdjust, always = ticks count
      visibleTickEnd: null,
      defaultSpan: 1,
      tickCache: {},
      viewPreset: null,
      useRawData: {
        disableDuplicateIdCheck: true,
        disableDefaultValue: true,
        disableTypeConversion: true
      }
    };
  } //endregion
  //region Init
  // private


  construct(config) {
    const me = this; // TODO: maybe not needed

    me.generateTicksValidatorFn = () => true;

    super.construct(config);
    me.originalContinuous = me.continuous;
    me.on({
      change: ({
        action
      }) => {
        // If the change was due to filtering, there will be a refresh event
        // arriving next, so do not reconfigure
        if (action !== 'filter') {
          me.trigger('reconfigure', {
            supressRefresh: false
          });
        }
      },
      refresh: () => me.trigger('reconfigure', {
        supressRefresh: false
      }),
      endreconfigure: event => me.trigger('reconfigure', event)
    });

    if (me.startDate) {
      me.internalOnReconfigure();
      me.trigger('reconfigure');
    } else if (me.viewPreset) {
      const range = me.getAdjustedDates(new Date());
      me.startDate = range.startDate;
      me.endDate = range.endDate;
    }
  }

  get isTimeAxis() {
    return true;
  } //endregion
  //region Configuration (reconfigure & consumePreset)

  /**
   * Reconfigures the time axis based on the config object supplied and generates the new 'ticks'.
   * @param {Object} config
   * @param {Boolean} [suppressRefresh]
   * @private
   */


  reconfigure(config, suppressRefresh = false, preventThrow = false) {
    const me = this,
          normalized = me.getAdjustedDates(config.startDate, config.endDate),
          oldConfig = {};

    if (me.trigger('beforeReconfigure', {
      startDate: normalized.startDate,
      endDate: normalized.endDate,
      config
    }) !== false) {
      me.trigger('beginReconfigure');
      me._configuredStartDate = config.startDate;
      me._configuredEndDate = config.endDate; // Collect old values for end event

      for (const propName in config) {
        oldConfig[propName] = me[propName];
      }

      Object.assign(me, config);

      if (me.internalOnReconfigure(preventThrow) === false) {
        return false;
      }

      me.trigger('endReconfigure', {
        suppressRefresh,
        config,
        oldConfig
      });
    }
  }

  internalOnReconfigure(preventThrow = false) {
    const me = this;
    me.isConfigured = true;
    const adjusted = me.getAdjustedDates(me.startDate, me.endDate, true),
          normalized = me.getAdjustedDates(me.startDate, me.endDate),
          start = normalized.startDate,
          end = normalized.endDate;

    if (start >= end) {
      throw new Error(`Invalid start/end dates. Start date must less than end date. Start date: ${start}. End date: ${end}.`);
    }

    const {
      unit,
      increment = 1
    } = me,
          ticks = me.generateTicks(start, end, unit, increment); // Suspending to be able to detect an invalid filter

    me.suspendEvents();
    me.data = ticks;
    const {
      count
    } = me;

    if (count === 0) {
      if (preventThrow) {
        me.resumeEvents();
        return false;
      }

      throw new Error('Invalid time axis configuration or filter, please check your input data.');
    } // start date is cached, update it to fill after generated ticks


    me.startDate = me.first.startDate;
    me.endDate = me.last.endDate;
    me.resumeEvents();

    if (me.isContinuous) {
      me.adjustedStart = adjusted.startDate;
      me.adjustedEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(count > 1 ? ticks[count - 1].startDate : adjusted.startDate, unit, increment, me.weekStartDay);
    } else {
      me.adjustedStart = me.startDate;
      me.adjustedEnd = me.endDate;
    }

    me.updateVisibleTickBoundaries();
    me.updateTickCache(true);
  }

  updateVisibleTickBoundaries() {
    const me = this,
          {
      count,
      unit,
      startDate,
      endDate,
      weekStartDay,
      increment = 1
    } = me; // Denominator is amount of milliseconds in a full tick (unit * increment). Normally we use 30 days in a month
    // and 365 days in a year. But if month is 31 day long or year is a leap one standard formula might calculate
    // wrong value. e.g. if we're rendering 1 day from August, formula goes like (2021-08-31 - 2021-08-02) / 30 = 1
    // and renders full tick which is incorrect. For such cases we need to adjust denominator to a correct one.
    // Thankfully there are only a few of them - month, year and day with DST transition.

    const startDenominator = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNormalizedUnitDuration(startDate, unit) * increment,
          endDenominator = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNormalizedUnitDuration(endDate, unit) * increment; // if visibleTickStart > 1 this means some tick is fully outside of the view - we are not interested in it and want to
    // drop it and adjust "adjustedStart" accordingly

    do {
      me.visibleTickStart = (startDate - me.adjustedStart) / startDenominator; // TODO: Changed from round to floor which seems to work, but this is not needed in ExtScheduler. Need to step and see what is different

      if (me.autoAdjust) me.visibleTickStart = Math.floor(me.visibleTickStart);
      if (me.visibleTickStart >= 1) me.adjustedStart = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(me.adjustedStart, unit, increment, weekStartDay);
    } while (me.visibleTickStart >= 1);

    do {
      me.visibleTickEnd = count - (me.adjustedEnd - endDate) / endDenominator;
      if (count - me.visibleTickEnd >= 1) me.adjustedEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(me.adjustedEnd, unit, -1, weekStartDay);
    } while (count - me.visibleTickEnd >= 1); // This flag indicates that the time axis starts exactly on a tick boundary and finishes on a tick boundary
    // This is used as an optimization flag by TimeAxisViewModel.createHeaderRow


    me.fullTicks = !me.visibleTickStart && me.visibleTickEnd === count;
  }
  /**
   * Get/set currently used preset
   * @property {Scheduler.preset.ViewPreset}
   */


  get viewPreset() {
    return this._viewPreset;
  }

  set viewPreset(preset) {
    const me = this;
    preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPreset(preset);

    if (!(preset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      throw new Error('TimeAxis must be configured with the ViewPreset instance that the Scheduler is using');
    }

    me._viewPreset = preset;
    Object.assign(me, {
      unit: preset.bottomHeader.unit,
      increment: preset.bottomHeader.increment || 1,
      resolutionUnit: preset.timeResolution.unit,
      resolutionIncrement: preset.timeResolution.increment,
      mainUnit: preset.mainHeader.unit,
      shiftUnit: preset.shiftUnit,
      shiftIncrement: preset.shiftIncrement || 1,
      defaultSpan: preset.defaultSpan || 1,
      presetName: preset.id,
      // Weekview columns are updated upon 'datachanged' event on this object.
      // We have to pass headers in order to render them correctly (timeAxisViewModel is incorrect in required time)
      headers: preset.headers
    });
  } //endregion
  //region Getters & setters


  set weekStartDay(day) {
    this._weekStartDay = day;
  }

  get weekStartDay() {
    if (this._weekStartDay == null) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].weekStartDay;
    }

    return this._weekStartDay;
  } // private


  get resolution() {
    return {
      unit: this.resolutionUnit,
      increment: this.resolutionIncrement
    };
  } // private


  set resolution(resolution) {
    this.resolutionUnit = resolution.unit;
    this.resolutionIncrement = resolution.increment;
  }

  get resolutionUnit() {
    return this._resolutionUnit;
  }

  set resolutionUnit(resolutionUnit) {
    this._resolutionUnit = resolutionUnit;
  }

  get resolutionIncrement() {
    return this._resolutionIncrement;
  }

  set resolutionIncrement(resolutionIncrement) {
    this._resolutionIncrement = resolutionIncrement || 1;
  }

  set mainUnit(mainUnit) {
    this._mainUnit = mainUnit;
  }

  get mainUnit() {
    return this._mainUnit;
  }

  set shiftUnit(shiftUnit) {
    this._shiftUnit = shiftUnit;
  } // private


  get shiftUnit() {
    return this._shiftUnit || this._mainUnit;
  }

  set shiftIncrement(shiftIncrement) {
    this._shiftIncrement = shiftIncrement;
  } // private


  get shiftIncrement() {
    return this._shiftIncrement || 1;
  }

  set unit(unit) {
    this._unit = unit;
  } // private


  get unit() {
    return this._unit;
  }

  set increment(increment) {
    this._increment = increment;
  } // private


  get increment() {
    return this._increment;
  }

  get defaultSpan() {
    return this._defaultSpan;
  }

  set defaultSpan(defaultSpan) {
    this._defaultSpan = defaultSpan;
  } //endregion
  //region Timespan & resolution

  /**
   * Changes the time axis timespan to the supplied start and end dates.
   *
   * **Note** This does **not** preserve the temporal scroll position. You may use
   * {@link Scheduler.view.Scheduler#function-setTimeSpan} to set the time axis and
   * maintain temporal scroll position (if possible).
   * @param {Date} newStartDate The new start date
   * @param {Date} newEndDate The new end date
   */


  setTimeSpan(newStartDate, newEndDate, preventThrow = false) {
    // If providing a 0 span range, add default range
    if (newEndDate && newStartDate - newEndDate === 0) {
      newEndDate = null;
    }

    const me = this,
          {
      startDate,
      endDate
    } = me.getAdjustedDates(newStartDate, newEndDate);

    if (me.startDate - startDate !== 0 || me.endDate - endDate !== 0) {
      return me.reconfigure({
        startDate,
        endDate
      }, false, preventThrow);
    }
  }
  /**
   * Moves the time axis by the passed amount and unit.
   *
   * NOTE: When using a filtered TimeAxis the result of `shift()` cannot be guaranteed, it might shift into a
   * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
   * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
   * instead.
   *
   * @param {Number} amount The number of units to jump
   * @param {String} [unit] The unit (Day, Week etc)
   */


  shift(amount, unit = this.shiftUnit) {
    const me = this;
    let {
      startDate,
      endDate
    } = me; // Use unfiltered start and end dates when shifting a filtered time axis, to lessen risk of messing it up.
    // Still not guaranteed to work though

    if (me.isFiltered) {
      startDate = me.allRecords[0].startDate;
      endDate = me.allRecords[me.allCount - 1].endDate;
    } // Hack for filtered time axis, for example if weekend is filtered out and you shiftPrev() day from monday


    let tries = 0;

    do {
      startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, amount, unit);
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(endDate, amount, unit);
    } while (tries++ < 100 && me.setTimeSpan(startDate, endDate, {
      preventThrow: true
    }) === false);
  }
  /**
   * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
   * config of the current view preset.
   *
   * NOTE: When using a filtered TimeAxis the result of `shiftNext()` cannot be guaranteed, it might shift into a
   * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
   * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
   * instead.
   *
   * @param {Number} [amount] The number of units to jump forward
   */


  shiftNext(amount = this.shiftIncrement) {
    this.shift(amount);
  }
  /**
   * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
   *
   * NOTE: When using a filtered TimeAxis the result of `shiftPrev()` cannot be guaranteed, it might shift into a
   * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
   * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
   * instead.
   *
   * @param {Number} [amount] The number of units to jump backward
   */


  shiftPrevious(amount = this.shiftIncrement) {
    this.shift(-amount);
  } //endregion
  //region Filter & continuous

  /**
   * Filter the time axis by a function. The passed function will be called with each tick in time axis.
   * If the function returns true, the 'tick' is included otherwise it is filtered. If all ticks are filtered out
   * the time axis is considered invalid, triggering `invalidFilter` and then removing the filter.
   * @param {Function} fn The function to be called, it will receive an object with startDate/endDate properties, and 'index' of the tick.
   * @param {Object} [thisObj] `this` reference for the function
   */


  filterBy(fn, thisObj = this) {
    const me = this;
    me.filters.clear();
    super.filterBy((tick, index) => fn.call(thisObj, tick.data, index));

    if (me.count === 0) {
      me.trigger('invalidFilter');
      me.clearFilters();
    }
  }

  triggerFilterEvent(event) {
    const me = this;

    if (!event.filters.count) {
      me.continuous = me.originalContinuous;
    } else {
      me.continuous = false;
    } // Filters has been applied (or cleared) but listeners are not informed yet, update tick cache to have start and
    // end dates correct when later redrawing events & header


    me.updateTickCache();
    super.triggerFilterEvent(event);
  }
  /**
   * Returns `true` if the time axis is continuous (will return `false` when filtered)
   * @property {Boolean}
   */


  get isContinuous() {
    return this.continuous !== false && !this.filtered;
  } //endregion
  //region Dates


  getAdjustedDates(startDate, endDate, forceAdjust = false) {
    const me = this; // If providing a 0 span range, add default range

    if (endDate && startDate - endDate === 0) {
      endDate = null;
    }

    startDate = startDate || me.startDate;
    endDate = endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, me.defaultSpan, me.mainUnit);
    return me.autoAdjust || forceAdjust ? {
      startDate: me.floorDate(startDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1),
      endDate: me.ceilDate(endDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1)
    } : {
      startDate: startDate,
      endDate: endDate
    };
  }
  /**
   * Method to get the current start date of the time axis.
   * @property {Date}
   */


  get startDate() {
    // TODO: added _start as caching, might mess something up when reconfiguring? change here if tests fail
    return this._start || (this.first ? new Date(this.first.startDate) : null);
  }

  set startDate(start) {
    this._start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(start);
  }
  /**
   * Method to get a the current end date of the time axis
   * @property {Date}
   */


  get endDate() {
    return this._end || (this.last ? new Date(this.last.endDate) : null);
  }

  set endDate(end) {
    if (end) this._end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(end);
  } // used in performance critical code for comparisons


  get startMS() {
    return this._startMS;
  } // used in performance critical code for comparisons


  get endMS() {
    return this._endMS;
  } // Floors a date and optionally snaps it to one of the following resolutions:
  // 1. 'resolutionUnit'. If param 'resolutionUnit' is passed, the date will simply be floored to this unit.
  // 2. If resolutionUnit is not passed: If date should be snapped relative to the timeaxis start date,
  // the resolutionUnit of the timeAxis will be used, or the timeAxis 'mainUnit' will be used to snap the date
  //
  // returns a copy of the original date
  // private


  floorDate(date, relativeToStart, resolutionUnit, incr) {
    relativeToStart = relativeToStart !== false;

    const me = this,
          relativeTo = relativeToStart ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(me.startDate) : null,
          increment = incr || me.resolutionIncrement,
          unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit),
          snap = (value, increment) => Math.floor(value / increment) * increment;

    if (relativeToStart) {
      const snappedDuration = snap(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].diff(relativeTo, date, unit), increment); // TODO: used to be small unit multiplied with factor (minute = seconds, minutes * 60)

      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(relativeTo, snappedDuration, unit, false);
    }

    const dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(date);

    if (unit === 'week') {
      const day = dt.getDay() || 7,
            startDay = me.weekStartDay || 7;
      _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false), day >= startDay ? startDay - day : -(7 - startDay + day), 'day', false); // Watch out for Brazil DST craziness (see test 028_timeaxis_dst.t.js)

      if (dt.getDay() !== startDay && dt.getHours() === 23) {
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(dt, 1, 'hour', false);
      }
    } else {
      // removes "smaller" units from date (for example minutes; removes seconds and milliseconds)
      _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, unit, false); // day and year are 1-based so need to make additional adjustments

      const modifier = ['day', 'year'].includes(unit) ? 1 : 0,
            useUnit = unit === 'day' ? 'date' : unit,
            snappedValue = snap(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(dt, useUnit) - modifier, increment) + modifier;
      _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(dt, useUnit, snappedValue);
    }

    return dt;
  }
  /**
   * Rounds the date to nearest unit increment
   * @private
   */


  roundDate(date, relativeTo, resolutionUnit = this.resolutionUnit, increment = this.resolutionIncrement || 1) {
    const me = this,
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(date);
    relativeTo = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(relativeTo || me.startDate);

    switch (resolutionUnit) {
      case 'week':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false);
        let distanceToWeekStartDay = dt.getDay() - me.weekStartDay,
            toAdd;

        if (distanceToWeekStartDay < 0) {
          distanceToWeekStartDay = 7 + distanceToWeekStartDay;
        }

        if (Math.round(distanceToWeekStartDay / 7) === 1) {
          toAdd = 7 - distanceToWeekStartDay;
        } else {
          toAdd = -distanceToWeekStartDay;
        }

        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(dt, toAdd, 'day', false);

      case 'month':
        const nbrMonths = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].diff(relativeTo, dt, 'month') + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as('month', dt.getDay() / _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].daysInMonth(dt)),
              //*/DH.as('month', DH.diff(relativeTo, dt)) + (dt.getDay() / DH.daysInMonth(dt)),
        snappedMonths = Math.round(nbrMonths / increment) * increment;
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(relativeTo, snappedMonths, 'month', false);

      case 'quarter':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'month', false);
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(dt, 'month', 3 - dt.getMonth() % 3, false);

      default:
        const duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as(resolutionUnit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].diff(relativeTo, dt)),
              // Need to find the difference of timezone offsets between relativeTo and original dates. 0 if timezone offsets are the same.
        offset = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].as(resolutionUnit, relativeTo.getTimezoneOffset() - dt.getTimezoneOffset(), 'minute'),
              // Need to add the offset to the whole duration, so the divided value will take DST into account
        snappedDuration = Math.round((duration + offset) / increment) * increment; // TODO: used to add one res unit lower * factor, minutes = add seconds, minutes * 60
        // Now when the round is done, we need to subtract the offset, so the result also will take DST into account

        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(relativeTo, snappedDuration - offset, resolutionUnit, false);
    }
  } // private


  ceilDate(date, relativeToStart, resolutionUnit, increment) {
    const me = this;
    relativeToStart = relativeToStart !== false;
    increment = increment || (relativeToStart ? me.resolutionIncrement : 1);
    const unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit),
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(date);
    let doCall = false;

    switch (unit) {
      case 'minute':
        doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isStartOf(dt, 'minute');
        break;

      case 'hour':
        doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isStartOf(dt, 'hour');
        break;

      case 'day':
      case 'date':
        doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isStartOf(dt, 'day');
        break;

      case 'week':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false);
        doCall = dt.getDay() !== me.weekStartDay || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(dt, date);
        break;

      case 'month':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false);
        doCall = dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(dt, date);
        break;

      case 'quarter':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false);
        doCall = dt.getMonth() % 3 !== 0 || dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(dt, date);
        break;

      case 'year':
        _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(dt, 'day', false);
        doCall = dt.getMonth() !== 0 || dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(dt, date);
        break;
    }

    if (doCall) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(dt, unit, increment, me.weekStartDay);
    }

    return dt;
  } //endregion
  //region Ticks


  get include() {
    return this._include;
  }

  set include(include) {
    const me = this;
    me._include = include;
    me.continuous = !include;

    if (!me.isConfiguring) {
      me.startDate = me._configuredStartDate;
      me.endDate = me._configuredEndDate;
      me.internalOnReconfigure();
      me.trigger('includeChange');
    }
  } // Check if a certain date is included based on timeAxis.include rules


  processExclusion(startDate, endDate, unit) {
    const {
      include
    } = this;

    if (include) {
      return Object.entries(include).some(([includeUnit, rule]) => {
        if (!rule) {
          return false;
        }

        const {
          from,
          to
        } = rule; // Including the closest smaller unit with a { from, to} rule should affect start & end of the
        // generated tick. Currently only works for days or smaller.

        if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].compareUnits('day', unit) >= 0 && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getLargerUnit(includeUnit) === unit) {
          if (from) {
            _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(startDate, includeUnit, from);
          }

          if (to) {
            let stepUnit = unit; // Stepping back base on date, not day

            if (unit === 'day') {
              stepUnit = 'date';
            } // Since endDate is not inclusive it points to the next day etc.
            // Turns for example 2019-01-10T00:00 -> 2019-01-09T18:00


            _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(endDate, {
              [stepUnit]: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(endDate, stepUnit) - 1,
              [includeUnit]: to
            });
          }
        } // "Greater" unit being included? Then we need to care about it
        // (for example excluding day will also affect hour, minute etc)


        if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].compareUnits(includeUnit, unit) >= 0) {
          const datePart = includeUnit === 'day' ? startDate.getDay() : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(startDate, includeUnit);

          if (from && datePart < from || to && datePart >= to) {
            return true;
          }
        }
      });
    }

    return false;
  } // Calculate constants used for exclusion when scaling within larger ticks


  initExclusion() {
    Object.entries(this.include).forEach(([unit, rule]) => {
      if (rule) {
        const {
          from,
          to
        } = rule; // For example for hour:
        // 1. Get the next bigger unit -> day, get ratio -> 24
        // 2. to 20 - from 8 = 12 hours visible each day. lengthFactor 24 / 12 = 2 means that each hour used
        // needs to represent 2 hours when drawn (to stretch)
        // |    ████    | -> |  ████████  |

        rule.lengthFactor = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getUnitToBaseUnitRatio(unit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getLargerUnit(unit)) / (to - from); // TODO: Since `to` is exclusive this should be the correct one... but cannot get it to work throughout

        rule.lengthFactorExcl = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getUnitToBaseUnitRatio(unit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getLargerUnit(unit)) / (to - from - 1); // Calculate weighted center to stretch around |   ██x█ |

        rule.center = from + from / (rule.lengthFactor - 1);
      }
    });
  }
  /**
   * Method generating the ticks for this time axis. Should return an array of ticks. Each tick is an object of the following structure:
   * ```
   * {
   *    startDate : ..., // start date
   *    endDate   : ...  // end date
   * }
   * ```
   * Take notice, that this function either has to be called with `start`/`end` parameters, or create those variables.
   *
   * To see it in action please check out our [TimeAxis](https://bryntum.com/examples/scheduler/timeaxis/) example and navigate to "Compressed non-working time" tab.
   *
   * @param {Date} axisStartDate The start date of the interval
   * @param {Date} axisEndDate The end date of the interval
   * @param {String} unit The unit of the time axis
   * @param {Number} increment The increment for the unit specified.
   * @return {Array} ticks The ticks representing the time axis
   */


  generateTicks(axisStartDate, axisEndDate, unit = this.unit, increment = this.increment) {
    const me = this,
          ticks = [],
          usesExclusion = Boolean(me.include);
    let intervalEnd,
        tickEnd,
        isExcluded,
        dstDiff = 0,
        {
      startDate,
      endDate
    } = me.getAdjustedDates(axisStartDate, axisEndDate);
    me.tickCache = {};

    if (usesExclusion) {
      me.initExclusion();
    }

    while (startDate < endDate) {
      intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(startDate, unit, increment, me.weekStartDay);

      if (!me.autoAdjust && intervalEnd > endDate) {
        intervalEnd = endDate;
      } // Handle hourly increments crossing DST boundaries to keep the timescale looking correct
      // Only do this for HOUR resolution currently, and only handle it once per tick generation.


      if (unit === 'hour' && increment > 1 && ticks.length > 0 && dstDiff === 0) {
        const prev = ticks[ticks.length - 1];
        dstDiff = (prev.startDate.getHours() + increment) % 24 - prev.endDate.getHours();

        if (dstDiff !== 0) {
          // A DST boundary was crossed in previous tick, adjust this tick to keep timeaxis "symmetric".
          intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(intervalEnd, dstDiff, 'hour');
        }
      }

      isExcluded = false;

      if (usesExclusion) {
        tickEnd = new Date(intervalEnd.getTime());
        isExcluded = me.processExclusion(startDate, intervalEnd, unit);
      } else {
        tickEnd = intervalEnd;
      }

      if (me.generateTicksValidatorFn(startDate) && !isExcluded) {
        ticks.push({
          id: ticks.length + 1,
          startDate,
          endDate: intervalEnd
        });
        me.tickCache[startDate.getTime()] = ticks.length - 1;
      }

      startDate = tickEnd;
    }

    return ticks;
  }
  /**
   * How many ticks are visible across the TimeAxis.
   *
   * Usually, this is an integer because {@link #config-autoAdjust} means that the start and end
   * dates are adjusted to be on tick boundaries.
   * @property {Number}
   * @internal
   */


  get visibleTickTimeSpan() {
    const me = this;
    return me.isContinuous ? me.visibleTickEnd - me.visibleTickStart : me.count;
  }
  /**
   * Gets a tick "coordinate" representing the date position on the time scale. Returns -1 if the date is not part of the time axis.
   * @param {Date} date the date
   * @return {Number} the tick position on the scale or -1 if the date is not part of the time axis
   */


  getTickFromDate(date) {
    const me = this,
          ticks = me.records,
          dateMS = date.getTime();
    let begin = 0,
        end = ticks.length - 1,
        middle,
        tick,
        tickStart,
        tickEnd; // Quickly eliminate out of range dates or if we have not been set up with a time range yet

    if (!ticks.length || date < ticks[0].startDate || date > ticks[end].endDate) {
      return -1;
    }

    if (me.isContinuous) {
      // TODO: This is the code from ExtScheduler, it is a calculation without iteration so it should perform better,
      //  we should consider using it...
      // if (date - ticks[0].startDate === 0) return this.visibleTickStart;
      // if (date - ticks[end].endDate === 0) return this.visibleTickEnd;
      //
      // const { adjustedStart, adjustedEnd }     = this;
      //
      // let tickIndex       = Math.floor(ticks.length * (date - adjustedStart) / (adjustedEnd - adjustedStart));
      //
      // // for the date == adjustedEnd case
      // if (tickIndex > end) {
      //     tickIndex = end;
      // }
      //
      // const tickStart           = tickIndex === 0 ? adjustedStart : ticks[tickIndex].startDate;
      // const tickEnd             = tickIndex === end ? adjustedEnd : ticks[tickIndex].endDate;
      //
      // tick                = tickIndex + (date - tickStart) / (tickEnd - tickStart);
      //
      // // in case of `autoAdjust : false` the actual visible timespan starts not from 0 tick coordinate, but
      // // from `visibleTickStart` coordinate, this check generally repeats the "quick bailout" check in the beginning of the method,
      // // but still
      // if (tick < this.visibleTickStart || tick > this.visibleTickEnd) {
      //     return -1;
      // }
      //
      // return tick;
      // Chop tick cache in half until we find a match
      while (begin < end) {
        middle = begin + end + 1 >> 1;

        if (dateMS > ticks[middle].endDate.getTime()) {
          begin = middle + 1;
        } else if (dateMS < ticks[middle].startDate.getTime()) {
          end = middle - 1;
        } else {
          begin = middle;
        }
      }

      tick = ticks[begin];
      tickStart = tick.startDate.getTime(); // Part way though, calculate the fraction

      if (dateMS > tickStart) {
        tickEnd = tick.endDate.getTime();
        begin += (dateMS - tickStart) / (tickEnd - tickStart);
      }

      return Math.min(Math.max(begin, me.visibleTickStart), me.visibleTickEnd);
    } else {
      for (let i = 0; i <= end; i++) {
        tickEnd = ticks[i].endDate.getTime();

        if (dateMS <= tickEnd) {
          tickStart = ticks[i].startDate.getTime(); // date < tickStart can occur in filtered case

          tick = i + (dateMS > tickStart ? (dateMS - tickStart) / (tickEnd - tickStart) : 0);
          return tick;
        }
      }
    }
  }
  /**
   * Gets the time represented by a tick "coordinate".
   * @param {Number} tick the tick "coordinate"
   * @param {String} [roundingMethod] The rounding method to use
   * @return {Date} The date to represented by the tick "coordinate", or null if invalid.
   */


  getDateFromTick(tick, roundingMethod) {
    const me = this;

    if (tick === me.visibleTickEnd) {
      return me.endDate;
    }

    const wholeTick = Math.floor(tick),
          fraction = tick - wholeTick,
          t = me.getAt(wholeTick);

    if (!t) {
      return null;
    }

    const start = wholeTick === 0 ? me.adjustedStart : t.startDate,
          // if we've filtered timeaxis using filterBy, then we cannot trust to adjustedEnd property and should use tick end
    end = wholeTick === me.count - 1 && me.isContinuous ? me.adjustedEnd : t.endDate;
    let date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(start, fraction * (end - start), 'millisecond');

    if (roundingMethod) {
      date = me[roundingMethod + 'Date'](date);
    }

    return date;
  }
  /**
   * Returns the ticks of the timeaxis in an array of objects with a "start" and "end" date.
   * @property {Object[]}
   */


  get ticks() {
    return this.records;
  }
  /**
   * Caches ticks and start/end dates for faster processing during rendering of events.
   * @private
   */


  updateTickCache(onlyStartEnd = false) {
    const me = this;

    if (me.count) {
      me._start = me.first.startDate;
      me._end = me.last.endDate;
      me._startMS = me.startDate.getTime();
      me._endMS = me.endDate.getTime();
    } else {
      me._start = me._end = me._startMs = me._endMS = null;
    } // onlyStartEnd is true prior to clearing filters, to get start and end dates correctly during that process.
    // No point in filling tickCache yet in that case, it will be done after the filters are cleared


    if (!onlyStartEnd) {
      me.tickCache = {};
      me.forEach((tick, i) => me.tickCache[tick.startDate.getTime()] = i);
    }
  } //endregion
  //region Axis

  /**
   * Returns true if the passed date is inside the span of the current time axis.
   * @param {Date} date The date to query for
   * @return {Boolean} true if the date is part of the timeaxis
   */


  dateInAxis(date, inclusiveEnd = false) {
    const me = this,
          axisStart = me.startDate,
          axisEnd = me.endDate; // Date is between axis start/end and axis is not continuous - need to perform better lookup

    if (me.isContinuous) {
      return inclusiveEnd ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].betweenLesserEqual(date, axisStart, axisEnd) : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].betweenLesser(date, axisStart, axisEnd);
    } else {
      const length = me.getCount();
      let tickStart, tickEnd, tick;

      for (let i = 0; i < length; i++) {
        tick = me.getAt(i);
        tickStart = tick.startDate;
        tickEnd = tick.endDate;

        if (inclusiveEnd && date <= tickEnd || !inclusiveEnd && date < tickEnd) {
          return date >= tickStart;
        }
      }
    }

    return false;
  }
  /**
   * Returns true if the passed timespan is part of the current time axis (in whole or partially).
   * @param {Date} start The start date
   * @param {Date} end The end date
   * @return {Boolean} true if the timespan is part of the timeaxis
   */


  timeSpanInAxis(start, end) {
    const me = this;

    if (!end || end.getTime() === start.getTime()) {
      return this.dateInAxis(start, true);
    }

    if (me.isContinuous) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].intersectSpans(start, end, me.startDate, me.endDate);
    }

    return start < me.startDate && end > me.endDate || me.getTickFromDate(start) !== me.getTickFromDate(end);
  } // Accepts a TimeSpan model (uses its cached MS values to be a bit faster during rendering)


  isTimeSpanInAxis(timeSpan) {
    const me = this,
          {
      startMS,
      endMS
    } = me,
          {
      startDateMS,
      endDateMS
    } = timeSpan; // only consider fully scheduled ranges

    if (!startDateMS || !endDateMS) return false;

    if (endDateMS === startDateMS) {
      return me.dateInAxis(timeSpan.startDate, true);
    }

    if (me.isContinuous) {
      return endDateMS > startMS && startDateMS < endMS;
    }

    const startTick = me.getTickFromDate(timeSpan.startDate),
          endTick = me.getTickFromDate(timeSpan.endDate); // endDate is not inclusive
    // TODO: Handle in getTickFromDate() somehow?

    if (startTick === me.count && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(timeSpan.startDate, me.last.endDate) || endTick === 0 && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(timeSpan.endDate, me.first.startDate)) {
      return false;
    }

    return (// Spanning entire axis
      startDateMS < startMS && endDateMS > endMS || // Unintentionally 0 wide (ticks excluded or outside)
      startTick !== endTick
    );
  } //endregion
  //region Iteration

  /**
   * Calls the supplied iterator function once per interval. The function will be called with four parameters, startDate endDate, index, isLastIteration.
   * @internal
   * @param {String} unit The unit to use when iterating over the timespan
   * @param {Number} increment The increment to use when iterating over the timespan
   * @param {Function} iteratorFn The function to call
   * @param {Object} [thisObj] `this` reference for the function
   */


  forEachAuxInterval(unit, increment = 1, iteratorFn, thisObj = this) {
    const end = this.endDate;
    let dt = this.startDate,
        i = 0,
        intervalEnd;
    if (dt > end) throw new Error('Invalid time axis configuration');

    while (dt < end) {
      intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(dt, unit, increment, this.weekStartDay), end);
      iteratorFn.call(thisObj, dt, intervalEnd, i, intervalEnd >= end);
      dt = intervalEnd;
      i++;
    }
  } //endregion


}
TimeAxis._$name = 'TimeAxis';

/***/ }),

/***/ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/AssignmentStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/mixin/AssignmentStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing assignments.
 *
 * It is consumed by the regular {@link Scheduler.data.AssignmentStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AssignmentStoreMixin extends Target {
  static get $name() {
    return 'AssignmentStoreMixin';
  }
  /**
   * Add assignments to the store.
   *
   * NOTE: References (event, resource) on the assignments are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [assignment] = assignmentStore.add({ eventId, resourceId });
   * // assignment.event is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [assignment] = assignmentStore.add({ eventId, resourceId });
   * await assignmentStore.project.commitAsync();
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.AssignmentModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add assignments to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added assignments.
   *
   * ```javascript
   * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.AssignmentModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the AssignmentStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (assignments, resources) on the assignments are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * assignmentStore.data = [{ eventId, resourceId }];
   * // assignmentStore.first.event is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * assignmentStore.data = [{ eventId, resourceId  }];
   * await assignmentStore.project.commitAsync();
   * // assignmentStore.first.event is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
   * // assignmentStore.first.event is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the AssignmentStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
   * // assignmentStore.first.event is available
   * ```
   *
   * @param {Object[]} data Array of AssignmentModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 300,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 300,
      storeId: 'assignments'
    };
  }

  add(newAssignments, ...args) {
    if (!Array.isArray(newAssignments)) {
      newAssignments = [newAssignments];
    }

    for (let i = 0; i < newAssignments.length; i++) {
      var _assignment$event;

      let assignment = newAssignments[i];

      if (!(assignment instanceof _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
        newAssignments[i] = assignment = this.createRecord(assignment);
      }

      if (this.storage.findIndex('eventResourceKey', assignment.eventResourceKey, true) !== -1) {
        throw new Error(`Duplicate assignment Event: ${assignment.eventId} to resource: ${assignment.resourceId}`);
      }

      if ((_assignment$event = assignment.event) !== null && _assignment$event !== void 0 && _assignment$event.isCreating) {
        assignment.isCreating = true;
      }
    }

    return super.add(newAssignments, ...args);
  }

  includesAssignment(eventId, resourceId) {
    return this.storage.findIndex('eventResourceKey', `${eventId}-${resourceId}`, true) !== -1;
  }

  setStoreData(data) {
    super.setStoreData(data);
  } //region Init & destroy
  // This index fixes poor performance when you add large number of events to an event store with large number of
  // events - if cache is missing existing records are iterated n² times.
  // https://github.com/bryntum/support/issues/3154#issuecomment-881336588


  set storage(storage) {
    super.storage = storage; // This allows a map based, fast lookup of assignments by their eventResourceKey.
    // This is so that the test for duplicate assignment adding is fast.

    this.storage.addIndex({
      property: 'eventResourceKey'
    });
  }

  get storage() {
    // Micro optimization to avoid expensive super call
    return this._storage || super.storage;
  } //endregion
  //region Stores
  // To not have to do instanceof checks


  get isAssignmentStore() {
    return true;
  } //endregion
  //region Recurrence

  /**
   * Returns a "fake" assignment used to identify a certain occurrence of a recurring event.
   * If passed the original event, it returns `originalAssignment`.
   * @param {Scheduler.model.AssignmentModel} originalAssignment
   * @param {Scheduler.model.EventModel} occurrence
   * @returns {Object} Temporary assignment
   * @internal
   */


  getOccurrence(originalAssignment, occurrence) {
    // Pass along the original assignment for non occurrence related calls
    if (!originalAssignment || !(occurrence !== null && occurrence !== void 0 && occurrence.isOccurrence)) {
      return originalAssignment;
    } // Not for saving chars, needed in fn below


    const me = this;
    return {
      id: `${occurrence.id}:a${originalAssignment.id}`,
      event: occurrence,
      resource: originalAssignment.resource,
      eventId: occurrence.id,
      resourceId: originalAssignment.resource.id,
      isAssignment: true,
      // This field is required to distinguish this fake assignment when event is being removed from UI
      isOccurrenceAssignment: true,

      // Not being an actual record, instanceMeta is stored on the store instead
      instanceMeta(instanceOrId) {
        return me.occurrenceInstanceMeta(this, instanceOrId);
      }

    };
  } // Per fake assignment instance meta, stored on store since fakes are always generated on demand


  occurrenceInstanceMeta(occurrenceAssignment, instanceOrId) {
    const me = this,
          instanceId = instanceOrId.id || instanceOrId,
          {
      id
    } = occurrenceAssignment;
    let {
      occurrenceMeta
    } = me;

    if (!occurrenceMeta) {
      occurrenceMeta = me.occurrenceMeta = {};
    }

    if (!occurrenceMeta[id]) {
      occurrenceMeta[id] = {};
    }

    return occurrenceMeta[id][instanceId] || (occurrenceMeta[id][instanceId] = {});
  } //endregion
  //region Mapping

  /**
   * Maps over event assignments.
   *
   * @param {Scheduler.model.EventModel} event
   * @param {Function} [fn]
   * @param {Function} [filterFn]
   * @return {Scheduler.model.EventModel[]|Array}
   * @category Assignments
   */


  mapAssignmentsForEvent(event, fn, filterFn) {
    event = this.eventStore.getById(event);
    const fnSet = Boolean(fn),
          filterFnSet = Boolean(filterFn);

    if (fnSet || filterFnSet) {
      return event.assignments.reduce((result, assignment) => {
        const mapResult = fnSet ? fn(assignment) : assignment;

        if (!filterFnSet || filterFn(mapResult)) {
          result.push(mapResult);
        }

        return result;
      }, []);
    }

    return event.assignments;
  }
  /**
   * Maps over resource assignments.
   *
   * @param {Scheduler.model.ResourceModel|Number|String} resource
   * @param {Function} [fn]
   * @param {Function} [filterFn]
   * @return {Scheduler.model.ResourceModel[]|Array}
   * @category Assignments
   */


  mapAssignmentsForResource(resource, fn, filterFn) {
    resource = this.resourceStore.getById(resource);
    const fnSet = Boolean(fn),
          filterFnSet = Boolean(filterFn);

    if (fnSet || filterFnSet) {
      return resource.assignments.reduce((result, assignment) => {
        const mapResult = fnSet ? fn(assignment) : assignment;

        if (!filterFnSet || filterFn(mapResult)) {
          result.push(mapResult);
        }

        return result;
      }, []);
    }

    return resource.assignments;
  }
  /**
   * Returns all assignments for a given event.
   *
   * @param {Scheduler.model.TimeSpan} event
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignments
   */


  getAssignmentsForEvent(event) {
    return event.assignments;
  }
  /**
   * Removes all assignments for given event
   *
   * @param {Scheduler.model.TimeSpan} event
   * @category Assignments
   */


  removeAssignmentsForEvent(event) {
    return this.remove(event.assignments);
  }
  /**
   * Returns all assignments for a given resource.
   *
   * @param {Scheduler.model.ResourceModel} resource
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignments
   */


  getAssignmentsForResource(resource) {
    resource = this.resourceStore.getById(resource);
    return resource.assignments;
  }
  /**
   * Removes all assignments for given resource
   *
   * @param {Scheduler.model.ResourceModel|*} resource
   * @category Assignments
   */


  removeAssignmentsForResource(resource) {
    this.remove(this.getAssignmentsForResource(resource));
  }
  /**
   * Returns all resources assigned to an event.
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.ResourceModel[]}
   * @category Assignments
   */


  getResourcesForEvent(event) {
    return event.resources;
  }
  /**
   * Returns all events assigned to a resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Scheduler.model.TimeSpan[]}
   * @category Assignments
   */


  getEventsForResource(resource) {
    resource = this.resourceStore.getById(resource);
    return resource && resource.events;
  }
  /**
   * Creates and adds assignment record(s) for a given event and resource(s).
   *
   * @param {Scheduler.model.TimeSpan} event
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} resources The resource(s) to assign to the event
   * @param {Function} [assignmentSetupFn] A hook function which takes an assignment as its argument and must return an assignment.
   * @param {Boolean} [removeExistingAssignments] `true` to remove assignments for other resources
   * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
   * @category Assign
   */


  assignEventToResource(event, resources, assignmentSetupFn = o => o, removeExistingAssignments = false) {
    var _me$eventStore;

    const me = this,
          toRemove = removeExistingAssignments ? new Set(event.assignments) : null;
    resources = Array.isArray(resources) ? resources : [resources]; // Use same code path as other single assignments if already assigned

    if ((_me$eventStore = me.eventStore) !== null && _me$eventStore !== void 0 && _me$eventStore.usesSingleAssignment && event.assignments.length) {
      if (!me.isEventAssignedToResource(event, resources[0])) {
        event.resource = resources[0];
      }

      return [];
    }

    let newAssignments = [];
    me.suspendAutoCommit(); // Assign

    resources.forEach(resource => {
      const existingAssignment = me.getAssignmentForEventAndResource(event, resource);

      if (!existingAssignment) {
        const assignment = assignmentSetupFn({
          event,
          resource
        });
        newAssignments.push(assignment);
      } else if (removeExistingAssignments) {
        toRemove.delete(existingAssignment);
      }
    });
    newAssignments = me.add(newAssignments);

    if (removeExistingAssignments) {
      me.remove(Array.from(toRemove));
    } // If true, will trigger a commit


    me.resumeAutoCommit();
    return newAssignments;
  }
  /**
   * Removes assignment record for a given event and resource.
   *
   * @param {Scheduler.model.TimeSpan|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} [resources] The resource to unassign the event from. If omitted, all resources of the events will be unassigned
   * @return {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]}
   * @category Assign
   */


  unassignEventFromResource(event, resources) {
    const me = this,
          assignmentsToRemove = [];

    if (!resources) {
      return me.removeAssignmentsForEvent(event);
    }

    if (!Array.isArray(resources)) {
      resources = [resources];
    }

    for (let i = 0; i < resources.length; i++) {
      if (me.isEventAssignedToResource(event, resources[i])) {
        assignmentsToRemove.push(me.getAssignmentForEventAndResource(event, resources[i]));
      }
    }

    return me.remove(assignmentsToRemove);
  }
  /**
   * Checks whether an event is assigned to a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event Event record or id
   * @param {Scheduler.model.ResourceModel|String|Number} resource Resource record or id
   * @return {Boolean}
   * @category Assignments
   */


  isEventAssignedToResource(event, resource) {
    return Boolean(this.getAssignmentForEventAndResource(event, resource));
  }
  /**
   * Returns an assignment record for a given event and resource
   *
   * @param {Scheduler.model.EventModel|String|Number} event The event or its id
   * @param {Scheduler.model.ResourceModel|String|Number} resource The resource or its id
   * @return {Scheduler.model.AssignmentModel}
   * @category Assignments
   */


  getAssignmentForEventAndResource(event, resource) {
    let assignments; // Note: In order to not evaluate conditions which do not have to be evaluated each condition
    // is assigned to a variable within the condition.

    if (!(event = this.eventStore.getById(event)) || !(assignments = event.assignments) || !(resource = this.resourceStore.getById(resource))) {
      return null;
    }

    return this.getOccurrence(assignments.find(a => a.resource === resource), event);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/AttachToProjectMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/**
* @module Scheduler/data/mixin/AttachToProjectMixin
*/

/**
 * Mixin that calls the target class `attachToProject()` function when a new project is assigned to Scheduler/Gantt.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AttachToProjectMixin extends Target {
  static get $name() {
    return 'AttachToProjectMixin';
  }

  async afterConstruct() {
    super.afterConstruct();
    const me = this,
          projectHolder = me.client || me.grid,
          {
      project
    } = projectHolder;
    projectHolder.projectSubscribers.push(me); // Attach to already existing stores

    if (project) {
      me.attachToProject(project);
      me.attachToResourceStore(project.resourceStore);
      me.attachToEventStore(project.eventStore);
      me.attachToAssignmentStore(project.assignmentStore);
      me.attachToDependencyStore(project.dependencyStore);
      me.attachToCalendarManagerStore(project.calendarManagerStore);
    }
  }
  /**
   * Override to take action when the project instance is replaced.
   *
   * @param {Scheduler.model.ProjectModel} project
   */


  attachToProject(project) {
    this.detachListeners('project');
    this._project = project;
  }
  /**
   * Override to take action when the EventStore instance is replaced, either from being replaced on the project or
   * from assigning a new project.
   *
   * @param {Scheduler.data.EventStore} store
   */


  attachToEventStore(store) {
    this.detachListeners('eventStore');
  }
  /**
   * Override to take action when the ResourceStore instance is replaced, either from being replaced on the project
   * or from assigning a new project.
   *
   * @param {Scheduler.data.ResourceStore} store
   */


  attachToResourceStore(store) {
    this.detachListeners('resourceStore');
  }
  /**
   * Override to take action when the AssignmentStore instance is replaced, either from being replaced on the project
   * or from assigning a new project.
   *
   * @param {Scheduler.data.AssignmentStore} store
   */


  attachToAssignmentStore(store) {
    this.detachListeners('assignmentStore');
  }
  /**
   * Override to take action when the DependencyStore instance is replaced, either from being replaced on the project
   * or from assigning a new project.
   *
   * @param {Scheduler.data.DependencyStore} store
   */


  attachToDependencyStore(store) {
    this.detachListeners('dependencyStore');
  } // TODO: Move attachToCalendarMangerStore to Pro somehow

  /**
   * Override to take action when the CalendarManagerStore instance is replaced, either from being replaced on the
   * project or from assigning a new project.
   *
   * @param {Core.data.Store} store
   */


  attachToCalendarManagerStore(store) {
    this.detachListeners('calendarManagerStore');
  }

  get project() {
    return this._project;
  }

  get calendarManagerStore() {
    return this.project.calendarManagerStore;
  }

  get assignmentStore() {
    return this.project.assignmentStore;
  }

  get resourceStore() {
    return this.project.resourceStore;
  }

  get eventStore() {
    return this.project.eventStore;
  }

  get dependencyStore() {
    return this.project.dependencyStore;
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/DependencyStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
var productName = 'gantt';



/**
 * @module Scheduler/data/mixin/DependencyStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing dependencies.
 *
 * It is consumed by the regular {@link Scheduler.data.DependencyStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DependencyStoreMixin extends Target {
  static get $name() {
    return 'DependencyStoreMixin';
  }
  /**
   * Add dependencies to the store.
   *
   * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [dependency] = dependencyStore.add({ from, to });
   * // dependency.fromEvent is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [dependency] = dependencyStore.add({ from, to });
   * await dependencyStore.project.commitAsync();
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [dependency] = await dependencyStore.addAsync({ from, to });
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.DependencyModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add dependencies to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added dependencies.
   *
   * ```javascript
   * const [dependency] = await dependencyStore.addAsync({ from, to });
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.DependencyModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the DependencyStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * dependencyStore.data = [{ from, to }];
   * // dependencyStore.first.fromEvent is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * dependencyStore.data = [{ from, to }];
   * await dependencyStore.project.commitAsync();
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await dependencyStore.loadDataAsync([{ from, to }]);
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the DependencyStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await dependencyStore.loadDataAsync([{ from, to }]);
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * @param {Object[]} data Array of DependencyModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 400,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 400,
      storeId: 'dependencies'
    };
  } // TODO: document


  reduceEventDependencies(event, reduceFn, result, flat = true, depsGetterFn) {
    depsGetterFn = depsGetterFn || (event => this.getEventDependencies(event));

    event = Array.isArray(event) ? event : [event];
    event.reduce((result, event) => {
      if (event.children && !flat) {
        event.traverse(evt => {
          result = depsGetterFn(evt).reduce(reduceFn, result);
        });
      } else {
        result = depsGetterFn(event).reduce(reduceFn, result);
      }
    }, result);
    return result;
  } // TODO: document


  mapEventDependencies(event, fn, filterFn, flat, depsGetterFn) {
    return this.reduceEventDependencies(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat, depsGetterFn);
  } // TODO: document


  mapEventPredecessors(event, fn, filterFn, flat) {
    return this.reduceEventPredecessors(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat);
  } // TODO: document


  mapEventSuccessors(event, fn, filterFn, flat) {
    return this.reduceEventSuccessors(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat);
  }
  /**
   * Returns all dependencies for a certain event (both incoming and outgoing)
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   */


  getEventDependencies(event) {
    return [].concat(event.predecessors || [], event.successors || []);
  }
  /**
   * Returns all incoming dependencies of the given event
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   * @deprecated 5.0.0
   */


  getEventPredecessors(event) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.predecessors`');
    return event.predecessors;
  }
  /**
   * Returns all outgoing dependencies of a event
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   * @deprecated 5.0.0
   */


  getEventSuccessors(event) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.successors`');
    return event.successors;
  } // TODO: document


  removeEventDependencies(event) {
    this.remove(this.getEventDependencies(event));
  } // TODO: document


  removeEventPredecessors(event) {
    this.remove(event.predecessors);
  } // TODO: document


  removeEventSuccessors(event, flat) {
    this.remove(event.successors);
  }

  getBySourceTargetId(key) {
    //TODO: in original code this uses a keymap
    return this.records.find(r => key == this.constructor.makeDependencySourceTargetCompositeKey(r.from, r.to));
  }
  /**
   * Returns dependency model instance linking tasks with given ids. The dependency can be forward (from 1st
   * task to 2nd) or backward (from 2nd to 1st).
   *
   * @param {Scheduler.model.EventModel|String} sourceEvent 1st event
   * @param {Scheduler.model.EventModel|String} targetEvent 2nd event
   * @return {Scheduler.model.DependencyModel}
   */


  getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) {
    sourceEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(sourceEvent);
    targetEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(targetEvent);
    return this.getBySourceTargetId(this.constructor.makeDependencySourceTargetCompositeKey(sourceEvent, targetEvent));
  }
  /**
   * Returns a dependency model instance linking given events if such dependency exists in the store.
   * The dependency can be forward (from 1st event to 2nd) or backward (from 2nd to 1st).
   *
   * @param {Scheduler.model.EventModel|String} sourceEvent
   * @param {Scheduler.model.EventModel|String} targetEvent
   * @return {Scheduler.model.DependencyModel}
   */


  getEventsLinkingDependency(sourceEvent, targetEvent) {
    return this.getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) || this.getDependencyForSourceAndTargetEvents(targetEvent, sourceEvent);
  }
  /**
   * Validation method used to validate a dependency. Override and return `true` to indicate that an
   * existing dependency between two tasks is valid. For a new dependency being created please see
   * {@link #function-isValidDependencyToCreate}.
   *
   * @param {Scheduler.model.DependencyModel|Number|String} dependencyOrFromId The dependency model or from event id
   * @param {Number|String} [toId] To event id if the first parameter is not a dependency model instance
   * @param {Number} [type] Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}  if the first parameter is not a dependency model instance.
   * @return {Boolean}
   */


  isValidDependency(dependencyOrFromId, toId, type) {
    if (arguments.length === 1) {
      toId = dependencyOrFromId.to || dependencyOrFromId.toEvent;
      dependencyOrFromId = dependencyOrFromId.from || dependencyOrFromId.fromEvent;
    } // This condition is supposed to map all model instances to be validated by project. Lowest common ancestor
    // for scheduler event, scheduler pro event and gantt task is TimeSpan


    if (dependencyOrFromId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__["default"] && toId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      // Not asserting dependency type here. Default value should normally suffice.
      return this.project.isValidDependency(dependencyOrFromId, toId, type);
    }

    return dependencyOrFromId != null && toId != null && dependencyOrFromId !== toId;
  }
  /**
   * Validation method used to validate a dependency while creating. Override and return `true` to indicate that
   * a new dependency is valid to be created.
   *
   * @param {Number|String} fromId `From` event id
   * @param {Number|String} toId `To` event id
   * @param {Number} type Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}
   * @return {Boolean}
   */


  isValidDependencyToCreate(fromId, toId, type) {
    return this.isValidDependency(fromId, toId, type);
  }
  /**
   * Returns all dependencies highlighted with the given CSS class
   *
   * @param {String} cls
   * @return {Scheduler.model.DependencyBaseModel[]}
   */


  getHighlightedDependencies(cls) {
    return this.records.reduce((result, dep) => {
      if (dep.isHighlightedWith(cls)) result.push(dep);
      return result;
    }, []);
  }

  static makeDependencySourceTargetCompositeKey(from, to) {
    return `source(${from})-target(${to})`;
  } //region Product neutral


  getTimeSpanDependencies(record) {
    return this.getEventDependencies(record);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/EventStoreMixin.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/data/mixin/EventStoreMixin.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony import */ var _util_EventDayIndex_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/EventDayIndex.js */ "./lib/Scheduler/data/util/EventDayIndex.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';








/**
 * @module Scheduler/data/mixin/EventStoreMixin
 */

const {
  MIDNIGHT
} = _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      returnTrue = () => true,
      notRecurring = event => !event.isRecurring;
/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and the Gantt `TaskStore` classes
 * to allow data sharing between a Gantt chart and a Scheduler.
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class EventStoreMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'EventStoreMixin';
  } //region Init & destroy


  construct(config) {
    super.construct(config);
    this.autoTree = true;
    this.dayIndices = null;
  } //endregion
  //region Indices
  // Override to syncIndices on initial load


  afterLoadData() {
    this.syncIndices('splice', this.storage.allValues); // Babel cannot transpile ?. version of this correctly for some reason

    super.afterLoadData && super.afterLoadData();
  }
  /**
   * Responds to mutations of the underlying storage Collection.
   *
   * Maintain indices for fast finding of events by date.
   * @param {Object} event
   * @private
   */


  onDataChange({
    action,
    added,
    removed,
    replaced
  }) {
    // Indices must be synced before responding to change
    this.syncIndices(action, added, removed, replaced);
    super.onDataChange(...arguments);
  }

  onDataReplaced(action, data) {
    // Indices must be synced before responding to change
    this.syncIndices('clear');
    this.syncIndices('splice', this.storage.values);
    super.onDataReplaced(action, data);
  }

  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    // Ensure by-date indices are up to date.
    if ('startDate' in wasSet || 'endDate' in wasSet) {
      this.syncIndices('reschedule', [record], null, null, wasSet);
    }

    super.onModelChange(...arguments);
  } //endregion
  //region Events records, iteration etc.


  set filtersFunction(filtersFunction) {
    super.filtersFunction = filtersFunction;
  }

  get filtersFunction() {
    // Generate the real filterFn.
    const result = super.filtersFunction; // We always filter *in* records which are being created by the UI.

    if (result && result !== _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].returnTrue) {
      return r => r.meta.isCreating || result(r);
    }

    return result;
  }
  /**
   * Returns events between the supplied start and end date
   *
   * @param {Date} startDate The start date
   * @param {Date} endDate The end date
   * @param {Boolean} allowPartial false to only include events that start and end inside of the span
   * @param {Boolean} onlyAssigned true to only include events that are assigned to a resource
   * @return {Scheduler.model.EventModel[]} the events
   * @category Events
   * @deprecated 4.0.0 Use {@link #function-getEvents}
   */


  getEventsInTimeSpan(startDate, endDate, allowPartial = true, onlyAssigned = false) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Scheduler', '5.0.0', '`getEventsInTimeSpan` method deprecated, in favor of `getEvents`');
    return this.getEvents({
      startDate,
      endDate,
      allowPartial,
      onlyAssigned
    });
  }
  /**
   * Returns all events that starts on the specified day.
   *
   * @param {Date} startDate Start date
   * @returns {Scheduler.model.EventModel[]} Events starting on specified day
   * @category Events
   * @deprecated 4.0.0 Use {@link #function-getEvents}
   */


  getEventsByStartDate(startDate) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Scheduler', '5.0.0', '`getEventsByStartDate` method deprecated, in favor of `getEvents`');
    return this.getEvents({
      startDate,
      startOnly: true
    });
  }
  /**
   * Returns an array of events for the date range specified by the `startDate` and `endDate` options.
   *
   * By default, for any date, this includes any event which *intersects* that date.
   *
   * To only include events that are fully contained *within* the date range, pass the `allowPartial`
   * option as `false`
   *
   * By default, any occurrences of recurring events are included in the resulting array. If that is not
   * required, pass the `includeOccurrences` option as `false`. **Note that if
   * `includeOccurrences` is `true`, the start date and end date options are mandatory. The method
   * must know what range of occurrences needs to be generated and returned.**
   *
   * example:
   *
   * ```javascript
   *  visibleEvents = eventStore.getEvents({
   *      resourceRecord : myResource,
   *      startDate      : scheduler.timeAxis.startDate,
   *      endDate        : scheduler.timeAxis.endDate
   *  });
   * ```
   *
   * @param {Object} options An options object determining which events to return
   * @param {Date} [options.date] If only one date is required, pass this option instead of the
   * `startDate` and `endDate` options.
   * @param {Date} options.startDate The start date for the range of events to include.
   * @param {Date} [options.endDate] The end date for the range of events to include.
   * @param {Scheduler.model.ResourceModel} options.resourceRecord Pass a resource to only return events assigned to
   *   this resource. Not supported when using the `dateMap` option (see below)
   * @param {Function} [options.filter] A function to filter out events which are not required.
   * @param {Boolean} [options.includeOccurrences=true] Occurrences of recurring events are included by default.
   * @param {Boolean} [options.allowPartial=true] Events which start before or after the range, but *intersect* the
   *   range are included by default.
   * @param {Boolean} [options.startOnly] Pass `true` to only include events which *start on* each date in the range.
   * @param {Boolean} [options.onlyAssigned] Pass `true` to only include events that are assigned to a resource
   * @param {Boolean|Map} [options.dateMap] Populates the passed `Map`, or if passed as `true`, creates and
   * returns a new `Map`. The keys are `YYYY-MM-DD` date strings and the entries are arrays of {@link Scheduler.model.EventModel EventModel}s.
   * @returns {Scheduler.model.EventModel[]|Map} Events which match the passed configuration.
   * @category Events
   */


  getEvents({
    filter,
    date,
    startDate,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences,
    // Interpolate occurrences into the returned event set
    allowPartial,
    // Include events which *intersect* the date range
    onlyAssigned = false,
    // Only include events that are assigned to a resource
    dateMap = false,
    // Return a Map keyed by date each value being an array of events
    dayTime = null,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    const me = this,
          options = arguments[0],
          {
      lastDateRange,
      added,
      filtersFunction
    } = me,
          passedFilter = filter; // Add filtering for only assigned events if requested.

    if (onlyAssigned) {
      options.filter = passedFilter ? e => passedFilter(e) && e.resources.length : e => e.resources.length;
    } // Note that we cannot use defaulting in the argument block because we pass
    // the incoming options object down into implementations.


    if (!('startDate' in options)) {
      startDate = options.startDate = date;
    }

    if (!('includeOccurrences' in options)) {
      includeOccurrences = options.includeOccurrences = true;
    }

    if (!('allowPartial' in options)) {
      allowPartial = options.allowPartial = !startOnly;
    } // We can't use me.filtersFunction if reapplyFilterOnAdd is false because there may be newly
    // added events which may not be subject to the filter. Records which are still in
    // the added bag must be tested for presence using indexOf so as to be always in sync
    // with the store being refiltered. Parens help readability.
    // eslint-disable-next-line no-extra-parens


    options.storeFilterFn = me.isFiltered ? me.reapplyFilterOnAdd ? filtersFunction : eventRecord => added.includes(eventRecord) ? me.indexOf(eventRecord) > -1 : filtersFunction(eventRecord) : null; // Default to a one day range if only startDate passed

    if (!endDate) {
      if (startDate) {
        endDate = options.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(startDate);
        endDate.setDate(endDate.getDate() + 1);
      } // If no dates passed, the dateFilter will include all.
      else {
        // We need to know what occurrences to generate.
        if (includeOccurrences) {
          throw new Error('getEvents MUST be passed startDate and endDate if recurring occurrences are requested');
        }

        options.dateFilter = returnTrue;
      }
    }

    if (!options.dateFilter) {
      // Must start in the date range
      if (startOnly) {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate;
          return eventStartDate && !(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(eventStartDate) - startDate);
        };
      } // Any intersection with our date range
      else if (allowPartial) {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate,
                eventEndDate = e.hasBatchedChange('endDate') ? e.get('endDate') : e.endDate || eventStartDate,
                isMilestone = !(eventStartDate - eventEndDate);
          return eventStartDate && (isMilestone ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].betweenLesserEqual(eventStartDate, startDate, endDate) : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(eventStartDate, eventEndDate, startDate, endDate));
        };
      } // Must be wholly contained with the our range
      else {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate,
                eventEndDate = e.hasBatchedChange('endDate') ? e.get('endDate') : e.endDate || eventStartDate;
          return eventStartDate && eventStartDate >= startDate && eventEndDate <= endDate;
        };
      }
    }

    const newDateRange = {
      startDate,
      endDate
    },
          dateRangeChange = !lastDateRange || lastDateRange.startDate - newDateRange.startDate || lastDateRange.endDate - newDateRange.endDate;

    if (dateRangeChange) {
      // Ensure the listeners are present
      me.processConfiguredListeners();
      /**
       * Fired when a range of events is requested from the {@link #function-getEvents} method.
       * @event loadDateRange
       * @param {Scheduler.data.EventStore} source This EventStore
       * @param {Object} old The old date range
       * @param {Date} old.startDate the old start date.
       * @param {Date} old.endDate the old end date.
       * @param {Object} new The new date range
       * @param {Date} new.startDate the new start date.
       * @param {Date} new.endDate the new end date.
       */

      me.trigger('loadDateRange', {
        old: lastDateRange || {},
        new: _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].clone(newDateRange)
      }); // Dates are mutable, so we must keep our own copy.

      me.lastDateRange = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].clone(newDateRange);
    }

    return dateMap ? me.getEventsAsMap(options) : me.getEventsAsArray(options);
  }
  /**
   * Internal implementation for {@link #function-getEvents} to use when not using dateMap.
   * @private
   */


  getEventsAsArray({
    filter,
    date,
    resourceRecord,
    startDate = date,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences = true,
    // Interpolate occurrences into the returned event set
    dayTime = null,
    // Injected by the getEvents master method
    dateFilter,
    storeFilterFn,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    const me = this,
          events = [];

    if (me.count) {
      let candidateEvents = resourceRecord ? me.getEventsForResource(resourceRecord) : null; // If there *was* a resourceRecord, candidateEvents will already be set up using me.getEventsForResource.
      // If no resourceRecord specified, we are gathering by date, so use the indices.

      if (!resourceRecord) {
        const dateIndex = me.useDayIndex(dayTime),
              eventSet = new Set(),
              indexName = startOnly ? 'startDate' : 'date'; // Add all recurring events which started on or before our date range.

        me.recurringEvents.forEach(e => {
          if (dateIndex.dayTime.startOfDay(e.startDate) <= startDate) {
            eventSet.add(e);
          }
        }); // Iterate the date range, using the indices to find qualified events.

        for (const date = new Date(startDate); date < endDate; date.setDate(date.getDate() + 1)) {
          const coincidingEvents = dateIndex.get(getDateIndex ? getDateIndex(date) : indexName, date);
          coincidingEvents === null || coincidingEvents === void 0 ? void 0 : coincidingEvents.forEach(e => eventSet.add(e));
        } // We gathered all events which *coincide* with each date.
        // We also added in all recurring events which started on or before our date range.
        // All these were made unique by the Set.
        // Return it to array form.


        candidateEvents = [...eventSet];
      } // Events found from the date indices won't be filtered.
      // On the other side, when using getEventForResource we will get all events for
      // the resource even if the EventStore is filtered, handle this by excluding "invisible" events here


      if (storeFilterFn) {
        candidateEvents = candidateEvents.filter(storeFilterFn);
      } // Go through candidates.
      // For a recurring event, and we are including recurrences, add date-qualifying occurrences.
      // For a non-recurring event, add it if it's date-qualified.


      for (let i = 0, {
        length
      } = candidateEvents; i < length; i++) {
        const e = candidateEvents[i]; // For recurring events, add date-qualifying occurrences, not the base

        if (includeOccurrences && e.isRecurring) {
          events.push.apply(events, e.getOccurrencesForDateRange(startDate, endDate).filter(dateFilter));
        } // For ordinary events, add if it's date-qualified
        else if (dateFilter(e)) {
          events.push(e);
        }
      }
    }

    return filter ? events.filter(filter) : events;
  }
  /**
   * Internal implementation for {@link #function-getEvents} to use when using dateMap.
   * @private
   */


  getEventsAsMap({
    filter: passedFilter,
    date,
    resourceRecord,
    // Not supported yet. Will add if ever requested.
    startDate = date,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences = true,
    // Interpolate occurrences into the returned event set
    dateMap,
    // Return a Map keyed by date each value being an array of events
    dayTime = null,
    storeFilterFn,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    var _dateMap;

    const me = this; // Convert `true` to a Map.

    if ((_dateMap = dateMap) !== null && _dateMap !== void 0 && _dateMap.clear) {
      dateMap.clear();
    } else {
      dateMap = new Map();
    }

    if (me.count) {
      const dateIndex = me.useDayIndex(dayTime),
            indexName = startOnly ? 'startDate' : 'date',
            recurringEvents = [],
            filter = e => (!passedFilter || passedFilter(e)) && (!storeFilterFn || storeFilterFn(e)),
            baseEventFilter = e => notRecurring(e) && filter(e);

      dayTime = dateIndex.dayTime; // dayTime=null becomes DayTime instance for midnight
      // We can't yet do this for just a resource.

      if (resourceRecord) {
        throw new Error('Querying for events for a resource and returning a date-keyed Map is not supported');
      } else {
        // Add all recurring events which started before the end of our date range.
        me.recurringEvents.forEach(e => {
          if (dayTime.startOfDay(e.startDate) < endDate) {
            recurringEvents.push(e);
          }
        }); // Iterate the date range, using the indices to find qualified events.

        for (const date = new Date(startDate); date < endDate; date.setDate(date.getDate() + 1)) {
          var _coincidingEvents;

          let [coincidingEvents, key] = dateIndex.get(getDateIndex ? getDateIndex(date) : indexName, date, true); // The index entry may be there, but it could be empty.

          if ((_coincidingEvents = coincidingEvents) !== null && _coincidingEvents !== void 0 && _coincidingEvents.size) {
            // Convert Set which index holds into an Array.
            // A recurring event doesn't go into the Map, its occurrences do.
            // Then filter by the passed filter and this Store's filter function
            // because events found from the date indices won't be filtered.
            coincidingEvents = [...coincidingEvents].filter(baseEventFilter); // Only create the entry for the day if there are events found

            if (coincidingEvents.length) {
              (dateMap.get(key) || dateMap.set(key, []).get(key)).push(...coincidingEvents);
            }
          }
        }
      } // Go through matching recurring events.


      for (let i = 0, {
        length
      } = recurringEvents; i < length; i++) {
        const e = recurringEvents[i]; // For each recurring event, add occurrences if we are including occurrences else, add the base.
        // Then filter by the passed filter and this Store's filter function
        // because events found from the date indices won't be filtered.

        const occurrences = (includeOccurrences ? e.getOccurrencesForDateRange(startDate, endDate) : [e]).filter(filter); // Add occurrences to dateMap

        for (let bucket, i = 0, {
          length
        } = occurrences; i < length; i++) {
          const occurrence = occurrences[i],
                date = dayTime.startOfDay(occurrence.startDate),
                indexName = getDateIndex ? getDateIndex(date) : startOnly ? 'startDate' : 'date',
                lastInteresctingDate = indexName === 'startDate' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, 1, 'day') : occurrence.endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(occurrence.startDate, occurrence.duration, occurrence.durationUnit); // Loop through covered dates, adding to dateMap if required

          for (; date < lastInteresctingDate; date.setDate(date.getDate() + 1)) {
            const key = dayTime.dateKey(date);
            (bucket = dateMap.get(key)) || dateMap.set(key, bucket = []);
            bucket.push(occurrence);
          }
        }
      }
    }

    return dateMap;
  }
  /**
   * Calls the supplied iterator function once for every scheduled event, providing these arguments
   * - event : the event record
   * - startDate : the event start date
   * - endDate : the event end date
   *
   * Returning false cancels the iteration.
   *
   * @param {Function} fn iterator function
   * @param {Object} thisObj `this` reference for the function
   * @category Events
   */


  forEachScheduledEvent(fn, thisObj = this) {
    this.forEach(event => {
      const {
        startDate,
        endDate
      } = event;

      if (startDate && endDate) {
        return fn.call(thisObj, event, startDate, endDate);
      }
    });
  }
  /**
   * Returns an object defining the earliest start date and the latest end date of all the events in the store.
   *
   * @return {Object} An object with 'start' and 'end' Date properties (or null values if data is missing).
   * @category Events
   */


  getTotalTimeSpan() {
    let earliest = new Date(9999, 0, 1),
        latest = new Date(0);
    this.forEach(event => {
      if (event.startDate) {
        earliest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].min(event.startDate, earliest);
      }

      if (event.endDate) {
        latest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].max(event.endDate, latest);
      }
    }); // TODO: this will fail in programs designed to work with events in the past (after Jan 1, 1970)

    earliest = earliest < new Date(9999, 0, 1) ? earliest : null;
    latest = latest > new Date(0) ? latest : null; // keep last calculated value to be able to track total timespan changes

    return this.lastTotalTimeSpan = {
      startDate: earliest || null,
      endDate: latest || earliest || null
    };
  }
  /**
   * Checks if given event record is persistable. By default it always is, override EventModels `isPersistable` if you
   * need custom logic.
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Boolean}
   * @category Events
   */


  isEventPersistable(event) {
    return event.isPersistable;
  } //endregion
  //region Resource

  /**
   * Checks if a date range is allocated or not for a given resource.
   * @param {Date} start The start date
   * @param {Date} end The end date
   * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
   * @param {Scheduler.model.ResourceModel} resource The resource
   * @return {Boolean} True if the timespan is available for the resource
   * @category Resource
   */


  isDateRangeAvailable(start, end, excludeEvent, resource) {
    // NOTE: Also exists in TaskStore.js
    // This should be a collection of unique event records
    const allEvents = new Set(this.getEventsForResource(resource)); // In private mode we can pass an AssignmentModel. In this case, we assume that multi-assignment is used.
    // So we need to make sure that other resources are available for this time too.
    // No matter if the event retrieved from the assignment belongs to the target resource or not.
    // We gather all events from from the resources the event is assigned to except of the one from the assignment record.
    // Note, events from the target resource are added above.

    if (excludeEvent !== null && excludeEvent !== void 0 && excludeEvent.isAssignment) {
      const currentEvent = excludeEvent.event,
            resources = currentEvent.resources;
      resources.forEach(resource => {
        // Ignore events for the resource which is passed as an AssignmentModel to excludeEvent
        if (resource.id !== excludeEvent.resourceId) {
          this.getEventsForResource(resource).forEach(event => allEvents.add(event));
        }
      });
    }

    if (excludeEvent) {
      const eventToRemove = excludeEvent.isAssignment ? excludeEvent.event : excludeEvent;
      allEvents.delete(eventToRemove);
    }

    return !Array.from(allEvents).some(event => event.isScheduled && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(start, end, event.startDate, event.endDate));
  }
  /**
   * Filters the events associated with a resource, based on the function provided. An array will be returned for those
   * events where the passed function returns true.
   * @param {Scheduler.model.ResourceModel} resource
   * @param {Function} fn The function
   * @param {Object} [thisObj] `this` reference for the function
   * @return {Scheduler.model.EventModel[]} the events in the time span
   * @private
   * @category Resource
   */


  filterEventsForResource(resource, fn, thisObj = this) {
    return resource.getEvents(this).filter(fn.bind(thisObj));
  }
  /**
   * Returns all resources assigned to an event.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @return {Scheduler.model.ResourceModel[]}
   * @category Resource
   */


  getResourcesForEvent(event) {
    // If we are sent an occurrence, use its parent
    if (event.isOccurrence) {
      event = event.recurringTimeSpan;
    }

    return this.assignmentStore.getResourcesForEvent(event);
  }
  /**
   * Returns all events assigned to a resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource Resource or resource id.
   *   *NOTE:* this does not include occurrences of recurring events. Use the {@link #function-getEvents} API
   *   to include occurrences of recurring events.
   * @return {Scheduler.model.EventModel[]}
   * @category Resource
   */


  getEventsForResource(resource) {
    return this.assignmentStore.getEventsForResource(resource);
  } //endregion
  //region Assignment

  /**
   * Returns all assignments for a given event.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignment
   */


  getAssignmentsForEvent(event) {
    return this.assignmentStore.getAssignmentsForEvent(event) || [];
  }
  /**
   * Returns all assignments for a given resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignment
   */


  getAssignmentsForResource(resource) {
    return this.assignmentStore.getAssignmentsForResource(resource) || [];
  }
  /**
   * Creates and adds assignment record for a given event and a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number|Scheduler.model.ResourceModel[]|String[]|Number[]} resource The resource(s) to assign to the event
   * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
   * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
   * @category Assignment
   */


  assignEventToResource(event, resource, removeExistingAssignments = false) {
    return this.assignmentStore.assignEventToResource(event, resource, undefined, removeExistingAssignments);
  }
  /**
   * Removes assignment record for a given event and a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @category Assignment
   */


  unassignEventFromResource(event, resource) {
    this.assignmentStore.unassignEventFromResource(event, resource);
  }
  /**
   * Reassigns an event from an old resource to a new resource
   *
   * @param {Scheduler.model.EventModel}    event    An event or id of the event to reassign
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} oldResource A resource or id to unassign from
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} newResource A resource or id to assign to
   * @category Assignment
   */


  reassignEventFromResourceToResource(event, oldResource, newResource) {
    const me = this,
          newResourceId = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(newResource),
          assignment = me.assignmentStore.getAssignmentForEventAndResource(event, oldResource);

    if (assignment) {
      assignment.resourceId = newResourceId;
    } else {
      me.assignmentStore.assignEventToResource(event, newResource);
    }
  }
  /**
   * Checks whether an event is assigned to a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Boolean}
   * @category Assignment
   */


  isEventAssignedToResource(event, resource) {
    return this.assignmentStore.isEventAssignedToResource(event, resource);
  }
  /**
   * Removes all assignments for given event
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @category Assignment
   */


  removeAssignmentsForEvent(event) {
    this.assignmentStore.removeAssignmentsForEvent(event);
  }
  /**
   * Removes all assignments for given resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @category Assignment
   */


  removeAssignmentsForResource(resource) {
    this.assignmentStore.removeAssignmentsForResource(resource);
  } //endregion
  //region Indexing

  /**
   * Invalidates associated day indices.
   * @internal
   */


  invalidateDayIndices() {
    var _this$dayIndices;

    (_this$dayIndices = this.dayIndices) === null || _this$dayIndices === void 0 ? void 0 : _this$dayIndices.forEach(dayIndex => dayIndex.invalidate());
  }
  /**
   * Registers a `DayTime` instance, creating an `EventDayIndex` for each distinct `startShift`. This index is
   * maintained until all instances with a matching `startShift` are {@link #function-unregisterDayIndex unregistered}.
   * @param {Core.util.DayTime} dayTime The instance to register.
   * @internal
   * @category Indexing
   */


  registerDayIndex(dayTime) {
    const me = this,
          dayIndices = me.dayIndices || (me.dayIndices = []);
    let dayIndex, i;

    for (i = 0; !dayIndex && i < dayIndices.length; ++i) {
      if (dayIndices[i].matches(dayTime)) {
        (dayIndex = dayIndices[i]).register(dayTime);
      }
    }

    !dayIndex && dayIndices.push(dayIndex = new _util_EventDayIndex_js__WEBPACK_IMPORTED_MODULE_5__["default"](me, dayTime));
    return dayIndex;
  }

  syncIndices(...args) {
    var _this$dayIndices2;

    (_this$dayIndices2 = this.dayIndices) === null || _this$dayIndices2 === void 0 ? void 0 : _this$dayIndices2.forEach(dayIndex => dayIndex.sync(...args));
  }
  /**
   * Removes a registered `DayTime` instance. If this is the last instance registered to an `EventDayIndex`, that
   * index is removed.
   * @param {Core.util.DayTime} dayTime The instance to unregister.
   * @internal
   * @category Indexing
   */


  unregisterDayIndex(dayTime) {
    const me = this,
          {
      dayIndices
    } = me;

    for (let i = dayIndices === null || dayIndices === void 0 ? void 0 : dayIndices.length; i-- > 0;) {
      if (dayIndices[i].matches(dayTime)) {
        if (dayIndices[i].unregister(dayTime)) {
          dayIndices.splice(i, 1);
        }

        break;
      }
    }
  }
  /**
   * Returns the `EventDayIndex` to use for the given `DayTime` instance. This may be the primary instance or a
   * child instance created by {@link #function-registerDayIndex}.
   * @param {Core.util.DayTime} dayTime The `DayTime` of the desired index.
   * @return {Scheduler.data.util.EventDayIndex}
   * @private
   * @category Indexing
   */


  useDayIndex(dayTime) {
    const me = this,
          {
      dayIndices
    } = me;
    dayTime = dayTime || MIDNIGHT;

    for (let i = 0; dayIndices && i < dayIndices.length; ++i) {
      if (dayIndices[i].matches(dayTime)) {
        return dayIndices[i];
      }
    }

    if (dayTime.startShift) {
      throw new Error(`No day index registered for ${dayTime} on ${me.id}`);
    }

    return me.registerDayIndex(MIDNIGHT);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfBaseProject.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfBaseProject.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt'; // Private class that leverages the differences between a core and a basic project

/* harmony default export */ __webpack_exports__["default"] = (Target => class PartOfBaseProject extends Target {
  static get $name() {
    return 'PartOfBaseProject';
  }

  get assignmentStore() {
    return this.project.assignmentStore;
  }

  get calendarManagerStore() {
    return this.project.calendarManagerStore;
  }

  get dependencyStore() {
    return this.project.dependencyStore;
  }

  get eventStore() {
    return this.project.eventStore;
  }

  get resourceStore() {
    return this.project.resourceStore;
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfProject.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfProject.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/mixin/PartOfProject
 */

/**
 * This is a mixin, included in all models and stores of the Scheduler project. It provides a common API for accessing
 * all stores of the project.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class PartOfProject extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  /**
   * Returns the project this entity belongs to.
   *
   * @member {Scheduler.model.ProjectModel} project
   * @readonly
   * @category Project
   */

  /**
   * Returns the event store of the project this entity belongs to.
   *
   * @member {Scheduler.data.EventStore} eventStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the dependency store of the project this entity belongs to.
   *
   * @member {Scheduler.data.DependencyStore} dependencyStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the assignment store of the project this entity belongs to.
   *
   * @member {Scheduler.data.AssignmentStore} assignmentStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the resource store of the project this entity belongs to.
   *
   * @member {Scheduler.data.ResourceStore} resourceStore
   * @readonly
   * @category Project
   */
  static get $name() {
    return 'PartOfProject';
  } // Only called when this is mixed into a Store class.
  // When a record has its isCreating status cleared.


  onIsCreatingToggle(record, isCreating) {
    var _this$project;

    // Base Store class has its say first
    super.onIsCreatingToggle(record, isCreating); // If the owning project is a CrudManager that is autosyncing, sync immediately
    // now that we have a definite new record. May be a chained store with no project.

    if (!record.isCreating && (_this$project = this.project) !== null && _this$project !== void 0 && _this$project.autoSync) {
      this.project.sync();
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ProjectConsumer.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ProjectConsumer.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Scheduler/data/mixin/ProjectConsumer
 */

/**
 * Creates a Project using any configured stores, and sets the stores configured into the project into
 * the host object.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectConsumer extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ProjectConsumer';
  } //region Default config


  static get declarable() {
    return ['projectStores'];
  }

  static get configurable() {
    return {
      projectModelClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      // TODO: move to SchedulerProBase and SchedulerBase to specify different types

      /**
       * The {@link Scheduler.model.ProjectModel} instance, containing the data visualized by the Scheduler.
       *
       * **Note:** In SchedulerPro the project is instance of SchedulerPro.model.ProjectModel class.
       * @member {Scheduler.model.ProjectModel} project
       * @category Data
       */

      /**
       * A {@link Scheduler.model.ProjectModel} instance or a config object. The project holds all Scheduler data.
       * Can be omitted in favor of individual store configs or {@link Scheduler.view.mixin.SchedulerStores#config-crudManager} config.
       *
       * **Note:** This config is **mandatory** in SchedulerPro. See SchedulerPro.model.ProjectModel class.
       * @config {Scheduler.model.ProjectModel|Object} project
       * @category Data
       */
      project: {},

      /**
       * Configure as `true` to destroy the Project and stores when `this` is destroyed.
       * @config {Boolean}
       * @category Data
       */
      destroyStores: null,
      // Will be populated by AttachToProjectMixin which features mix in
      projectSubscribers: []
    };
  } //endregion


  startConfigure(config) {
    // process the project first which ingests any configured data sources,
    this.getConfig('project');
    super.startConfigure(config);
  } //region Project
  // This is where all the ingestion happens.
  // At config time, the changers inject incoming values into the project config object
  // that we are building. At the end we instantiate the project with all incoming
  // config values filled in.


  changeProject(project, oldProject) {
    const me = this,
          {
      projectStoreNames,
      projectDataNames
    } = me.constructor;
    me.projectCallbacks = new Set();

    if (project) {
      // Flag for changes to know what stage we are at
      me.buildingProjectConfig = true;

      if (!project.isModel) {
        // When configuring, prio order:
        // 1. If using an already existing CrudManager, it is assumed to already have the stores we should use,
        //    adopt them as ours.
        // 2. If a supplied store already has a project, it is assumed to be shared with another scheduler and
        //    that project is adopted as ours.
        // 3. Use stores from a supplied project config.
        // 4. Use stores configured on scheduler.
        // + Pass on inline data (events, resources, dependencies, assignments -> xxData on the project config)
        //
        // What happens during project initialization is this:
        // this._project is the project *config* object.
        // changeXxxx methods put incoming values directly into it through this.project
        // to be used as its configuration.
        // So when it is instantiated, it has had all configs injected.
        if (me.isConfiguring) {
          // Set property for changers to put incoming values into
          me._project = project; // crudManager will be a clone of the raw config if it is a raw config.

          const {
            crudManager
          } = me; // Pull in stores from the crudManager config first

          if (crudManager) {
            const {
              isCrudManager
            } = crudManager;

            for (const storeName of projectStoreNames) {
              if (crudManager[storeName]) {
                // We configure the project with the stores, and *not* the CrudManager.
                // The CrudManager ends up having its project set and thereby adopting ours.
                me[storeName] = crudManager[storeName]; // If it's just a config, take the stores out.
                // We will *configure* it with this project and it will ingest
                // its stores from there.

                if (!isCrudManager) {
                  delete crudManager[storeName];
                }
              }
            }
          } // Pull in all our configured stores into the project config object.
          // That also extracts any project into this._sharedProject


          me.getConfig('projectStores'); // Referencing these data configs causes them to be pulled into
          // the _project.xxxData config property if they are present.

          for (const dataName of projectDataNames) {
            me.getConfig(dataName);
          }
        }

        const {
          eventStore
        } = project; // Delay autoLoading until listeners are set up, to be able to inject params

        if (eventStore && !eventStore.isEventStoreMixin && eventStore.autoLoad && !eventStore.count) {
          eventStore.autoLoad = false;
          me.delayAutoLoad = true;
        } // Use sharedProject if found, else instantiate our config.


        project = me._sharedProject || new me.projectModelClass(project); // Clear the property so that the updater is called.

        delete me._project;
      } // In the updater, configs are live


      me.buildingProjectConfig = false;
    }

    return project;
  }
  /**
   * Implement in subclass to take action when project is replaced.
   *
   * __`super.updateProject(...arguments)` must be called first.__
   *
   * @param {Scheduler.model.ProjectModel} project
   */


  updateProject(project, oldProject) {
    const me = this,
          {
      projectListeners,
      crudManager
    } = me;
    me.detachListeners('projectConsumer'); // When we set the crudManager now, it will go through to the CrudManagerVIew

    delete me._crudManager;

    if (project) {
      projectListeners.thisObj = me;
      project.on(projectListeners); // If the project is a CrudManager, use it as such.

      if (project.isCrudManager) {
        me.crudManager = project;
      } // Apply the project to CrudManager, making sure the same stores are used there and here
      else if (crudManager) {
        crudManager.project = project; // CrudManager goes through the changer as usual and is initialized
        // from the Project, not any stores it was originally configured with.

        me.crudManager = crudManager;
      } // Notifies classes that mix AttachToProjectMixin that we have a new project


      me.projectSubscribers.forEach(subscriber => subscriber.attachToProject(project)); // Sets the project's stores into the host object

      for (const storeName of me.constructor.projectStoreNames) {
        me[storeName] = project[storeName];
      } // Listeners are set up, if EventStore was configured with autoLoad now is the time to load


      if (me.delayAutoLoad) {
        // Restore the flag, not needed but to look good on inspection
        project.eventStore.autoLoad = true;
        project.eventStore.load();
      }
    }

    me.trigger('projectChange', {
      project
    });
  } // Implementation here because we need to get first look at it to adopt its stores


  changeCrudManager(crudManager) {
    // Set the property to be scanned for incoming stores.
    // If it's a config, it will be stripped of those stores prior to construction.
    if (this.buildingProjectConfig) {
      this._crudManager = crudManager.isCrudManager ? crudManager : Object.assign({}, crudManager);
    } else {
      return super.changeCrudManager(crudManager);
    }
  } // Called when project changes are committed, after data is written back to records


  onProjectDataReady() {
    if (this.projectCallbacks.size) {
      this.projectCallbacks.forEach(callback => callback());
      this.projectCallbacks.clear();
    }
  }
  /**
   * Accepts a callback that will be called when the underlying project is ready (no commit pending and current commit
   * finalized)
   * @param {Function} callback
   */


  whenProjectReady(callback) {
    // Might already be ready, call directly
    if (this.isEngineReady) {
      callback();
    } else {
      this.projectCallbacks.add(callback);
    }
  }
  /**
   * Returns `true` if engine is in a stable calculated state, `false` otherwise.
   * @property {Boolean}
   */


  get isEngineReady() {
    var _this$project$isEngin, _this$project;

    // NonWorkingTime calls this during destruction, hence the ?.
    return Boolean((_this$project$isEngin = (_this$project = this.project).isEngineReady) === null || _this$project$isEngin === void 0 ? void 0 : _this$project$isEngin.call(_this$project));
  } //endregion
  //region Destroy
  // Cleanup, destroys stores if this.destroyStores is true.


  doDestroy() {
    super.doDestroy();

    if (this.destroyStores) {
      // Shared project might already be destroyed
      !this.project.isDestroyed && this.project.destroy();
    }
  } //endregion


  get projectStores() {
    const {
      projectStoreNames
    } = this.constructor;
    return projectStoreNames.map(storeName => this[storeName]);
  }

  static get projectStoreNames() {
    return Object.keys(this.projectStores);
  }

  static get projectDataNames() {
    return this.projectStoreNames.reduce((result, storeName) => {
      const {
        dataName
      } = this.projectStores[storeName];

      if (dataName) {
        result.push(dataName);
      }

      return result;
    }, []);
  }

  static setupProjectStores(cls, meta) {
    const {
      projectStores
    } = cls;

    if (projectStores) {
      const projectListeners = {
        name: 'projectConsumer',
        dataReady: 'onProjectDataReady',
        change: 'relayProjectDataChange'
      },
            storeConfigs = {
        projectListeners
      }; // Create property for dataName and change and updater for stores

      for (const storeName in projectStores) {
        const {
          dataName
        } = projectStores[storeName]; // Define "eventStore" config

        storeConfigs[storeName] = null; // Define up the "events" property

        if (dataName) {
          // Getter to return store data
          // Setter to update project config or live project
          Object.defineProperty(meta.class.prototype, dataName, {
            get() {
              var _this$project$storeNa;

              // get events() { return this.project.eventStore.records; }
              return (_this$project$storeNa = this.project[storeName]) === null || _this$project$storeNa === void 0 ? void 0 : _this$project$storeNa.records;
            },

            set(data) {
              const {
                project
              } = this;

              if (this.buildingProjectConfig) {
                // Set the property in the project config object.
                // eg project.eventsData = [...]
                project[`${dataName}Data`] = data;
              } else {
                // Live update the project when in use.
                project[storeName].data = data;
              }
            }

          });
        }

        this.createStoreDescriptor(meta, storeName, projectStores[storeName], projectListeners);
      } // Create the projectListeners config.


      this.setupConfigs(meta, storeConfigs);
    }
  }

  static createStoreDescriptor(meta, storeName, {
    listeners
  }, projectListeners) {
    const {
      prototype: clsProto
    } = meta.class,
          storeNameCap = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(storeName); // Set up onProjectEventStoreChange to set this.eventStore

    projectListeners[`${storeName}Change`] = function ({
      store
    }) {
      this[storeName] = store;
    }; // create changeEventStore


    clsProto[`change${storeNameCap}`] = function (store, oldStore) {
      var _store;

      const me = this,
            {
        project
      } = me,
            storeProject = (_store = store) === null || _store === void 0 ? void 0 : _store.project;

      if (me.buildingProjectConfig) {
        // Capture any project found at project config time
        // to use as our shared project
        if (storeProject && storeProject.isProjectModel) {
          me._sharedProject = storeProject;
        } // Set the property in the project config object.
        // Must not go through the updater. It's too early to
        // inform host of store change.


        project[storeName] = store;
        return;
      } // Live update the project when in use.


      if (!me.initializingProject) {
        if (project[storeName] !== store) {
          project[`set${storeNameCap}`](store);
          store = project[storeName];
        }
      } // Implement processing here instead of creating a separate updater.
      // Subclasses can implement updaters.


      if (store !== oldStore) {
        if (listeners) {
          listeners.thisObj = me;
          listeners.name = `${storeName}Listeners`;
          me.detachListeners(listeners.name);
          store.on(listeners);
        } // Notifies classes that mix AttachToProjectMixin that we have a new XxxxxStore


        me.projectSubscribers.forEach(subscriber => {
          var _subscriber$;

          (_subscriber$ = subscriber[`attachTo${storeNameCap}`]) === null || _subscriber$ === void 0 ? void 0 : _subscriber$.call(subscriber, store);
        });
      }

      return store;
    };
  }

  relayProjectDataChange(event) {
    /**
     * Fired when data in any of the projects stores changes.
     *
     * Basically a relayed version of each stores own change event, decorated with which store it originates from.
     * See the {@link Core.data.Store#event-change store change event} documentation for more information.
     *
     * @event dataChange
     * @param {Scheduler.data.mixin.ProjectConsumer} source Owning component
     * @param {Scheduler.model.mixin.ProjectModelMixin} project Project model
     * @param {Core.data.Store} store Affected store
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
     * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
     * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
     */
    return this.trigger('dataChange', _objectSpread(_objectSpread({
      project: event.source
    }, event), {}, {
      source: this
    }));
  } //region WidgetClass
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {} //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ProjectCrudManager.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ProjectCrudManager.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Scheduler/crud/AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';






/**
 * @module Scheduler/data/mixin/ProjectCrudManager
 */

/**
 * This mixin provides Crud Manager functionality supporting loading of scheduling engine projects.
 *
 * @mixin
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @mixes Scheduler/crud/encoder/JsonEncoder
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectCrudManager extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_2__["default"]).mixin(_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_0__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_3__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * A project that holds and links stores
       * @config {Scheduler.model.ProjectModel}
       */
      project: null
    };
  }

  startConfigure(config) {
    // process the project first which ingests any configured data sources,
    this.getConfig('project');
    super.startConfigure(config);
    this._changesToClear = new Map();
  }

  async doAutoLoad() {
    const {
      project
    } = this; // Delay autoLoad to after projects initial commit if configured with a project

    if (project) {
      await project.commitAsync();
    }

    return super.doAutoLoad();
  }

  loadCrudManagerData(response, options = {}) {
    const me = this,
          {
      project
    } = me; // we don't want reacting on store changes during loading of them

    me.suspendChangesTracking();
    super.loadCrudManagerData(...arguments); // if there is the project data provided

    if (response !== null && response !== void 0 && response.project) {
      me.applyingProjectResponse = true;
      Object.assign(project, response.project);
      me.applyingProjectResponse = false;
    }

    me.resumeChangesTracking();
  }

  async sync() {
    const {
      project
    } = this; // Suspend Crud Manager autoSync to not react on changes during commitAsync() call

    this.suspendAutoSync(); // Make sure data is in a calculated state before syncing

    if (project) {
      await project.commitAsync();
    } // resume autoSync silently


    this.resumeAutoSync(false);
    return super.sync();
  }

  async applyResponse(request, response, options) {
    var _me$project;

    const me = this;

    if (me.isDestroyed || (_me$project = me.project) !== null && _me$project !== void 0 && _me$project.isDestroyed) {
      return;
    }

    me.trigger('startApplyResponse'); // clear "added"/"modified" collections on the stores
    // TODO: need to snapshot their state to be able to revert in case of an exception

    me.clearCrudStoresChanges({
      clearRemovedCollection: false
    });
    await super.applyResponse(request, response, options); // clear "removed" collection on the stores

    me.clearCrudStoresChanges({
      removeAddedRecords: false,
      clearAddedCollection: false,
      clearModifiedCollection: false,
      clearRemovedCollection: true
    }); // if there is the project data provided

    if (response !== null && response !== void 0 && response.project) {
      me.applyingProjectResponse = true;
      Object.assign(me, response.project);
      me.applyingProjectResponse = false;
    } // if we have a project


    if (me.project) {
      let requestType = request.type; // response can force its type

      if (me.trackResponseType) {
        requestType = response.type || requestType;
      } // Make a boolean flag indicating what has triggered the propagation ("propagatingLoadChanges" or  "propagatingSyncChanges")


      const propagationFlag = `propagating${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(requestType)}Changes`;
      me[propagationFlag] = true; // Wait till calculation gets done

      await me.project.commitAsync();
      me[propagationFlag] = false; // Accept changes came from the server

      this.commitRespondedChanges();
    }
  }

  commitRespondedChanges() {
    // We silently accept changes came from the server
    this._changesToClear.forEach((changes, record) => {
      Object.entries(changes).forEach(([key, value]) => {
        const field = record.getFieldDefinition(key),
              oldValue = record[key]; // If the field value matches the one responded from the server
        // we silently accept it

        if (field !== null && field !== void 0 && field.isEqual ? field.isEqual(oldValue, value) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isEqual(oldValue, value)) {
          delete record.meta.modified[key];
        }
      });
    });

    this._changesToClear.clear();
  }

  clearRecordChanges(record, changes) {
    super.clearRecordChanges(record, changes);

    if (this.project) {
      // The changes get into graph first but not into a store
      // so record.clearChanges() call (made in above super.clearRecordChanges())
      // does not really clear anything.
      // We need to cleanup the changes after the next propagation is done.
      // So here we just store record changes in a map.
      this._changesToClear.set(record, changes);
    }
  }

  clearCrudStoresChanges(flags = {
    removeAddedRecords: true,
    clearAddedCollection: true,
    clearModifiedCollection: true,
    clearRemovedCollection: true
  }) {
    const {
      removeAddedRecords,
      clearAddedCollection,
      clearModifiedCollection,
      clearRemovedCollection
    } = flags; // TODO: Change when https://app.assembla.com/spaces/bryntum/tickets/8975 is fixed
    // this.crudStores.forEach(store => store.store.clearChanges());

    this.forEachCrudStore(store => {
      if (removeAddedRecords) {
        // remove phantom records
        store.remove(this.added, true);
      }

      if (clearModifiedCollection) {
        store.modified.forEach(r => r.clearChanges(false));
        store.modified.clear();
      }

      if (clearAddedCollection) {
        store.added.clear();
      }

      if (clearRemovedCollection) {
        store.removed.clear();
      }
    });
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringEventsMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");
var productName = 'gantt';


/**
 * @module Scheduler/data/mixin/RecurringEventsMixin
 */

/**
 * This mixin class provides recurring events functionality to the {@link Scheduler.data.EventStore event store}.
 * @extends Scheduler/data/mixin/RecurringTimeSpansMixin
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringEventsMixin extends Object(_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringEventsMixin';
  }
  /**
   * Returns all the recurring events.
   *
   * **An alias for ** {@link Scheduler.data.mixin.RecurringTimeSpansMixin#function-getRecurringTimeSpans} method.
   *
   * @return {Scheduler.model.EventModel[]} Array of recurring events.
   * @category Recurrence
   */


  getRecurringEvents() {
    return this.getRecurringTimeSpans();
  }

  isEventPersistable(event) {
    // occurrences are not persistable
    return super.isEventPersistable(event) && (!event.supportsRecurring || !event.isOccurrence);
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/mixin/RecurringTimeSpansMixin
 */

const emptyArray = Object.freeze([]);
/**
 * This mixin class provides recurring timespans functionality to a store of {@link Scheduler.model.TimeSpan TimeSpan} models.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringTimeSpansMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringTimeSpansMixin';
  }

  construct(...args) {
    const me = this; // We store all generated occurrences keyed by `_generated_${recurringTimeSpan.id}:${occurrenceStartDate}`
    // So that when asked to generate an occurrence for a date, an already generated one can be returned.

    me.globalOccurrences = new Map(); // All recurring events added to the store are accessible through this Set. It's used
    // to generate occurrences.

    me.recurringEvents = new Set();
    super.construct(...args);
  } // Override to refreshRecurringEventsCache on initial load


  afterLoadData() {
    // All cached occurrences are now potentially invalid.
    // A store reload might imply any number of changes which invalidate any occurrence.
    this.globalOccurrences.clear(); // Clear and rebuild the recurring events cache

    this.refreshRecurringEventsCache('clear');
    this.refreshRecurringEventsCache('splice', this.storage.allValues);
    super.afterLoadData && super.afterLoadData();
  }
  /**
   * Responds to mutations of the underlying storage Collection.
   *
   * Maintain indices for fast finding of events by date.
   * @param {Object} event
   * @private
   */


  onDataChange({
    action,
    added,
    removed,
    replaced
  }) {
    // Recurring events cache must be refreshed before responding to change
    this.refreshRecurringEventsCache(action, added, removed, replaced);
    super.onDataChange(...arguments);
  }

  refreshRecurringEventsCache(action, added = emptyArray, removed = emptyArray, replaced) {
    const me = this,
          {
      recurringEvents
    } = me,
          replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;

    switch (action) {
      case 'clear':
        recurringEvents.clear();
        break;
      // Add and remove

      case 'splice':
        // Handle replacement of records by instances with same ID
        if (replacedCount) {
          added = added.slice();
          removed = removed.slice();

          for (let i = 0; i < replacedCount; i++) {
            removed.push(replaced[i][0]);
            added.push(replaced[i][1]);
          }
        }

        const addedCount = added.length,
              removedCount = removed.length; // Track the recurring events we contain

        if (removedCount && recurringEvents.size) {
          for (let i = 0; i < removedCount; i++) {
            const outgoingEvent = removed[i];

            if (outgoingEvent.isRecurring) {
              recurringEvents.delete(outgoingEvent);
            }
          }
        } // Track the recurring events we contain


        if (addedCount) {
          for (let i = 0; i < addedCount; i++) {
            const newEvent = added[i]; // Allow easy access to recurring events

            if (newEvent.isRecurring) {
              recurringEvents.add(newEvent);
            }
          }
        }

        break;
    }
  }

  getById(id) {
    let result = super.getById(id); // If the id is not found in the Store, then it could be one of our generated occurrences

    if (!result) {
      result = this.globalOccurrences.get(this.modelClass.asId(id));
    }

    return result;
  }

  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    const isRecurrenceRelatedFieldChange = this.isRecurrenceRelatedFieldChange(record, wasSet); // If this is the base of a recurring sequence, then any reactors to events from
    // the super call must regenerate occurrences, so must be done at top.
    // If silent is true, occurrences won't be recalculated. Do not remove occurrences from cache in such case.

    if (isRecurrenceRelatedFieldChange && !silent) {
      record.removeOccurrences();
    }

    super.onModelChange(...arguments); // If this is the base of a recurring sequence, then the EventStore must
    // trigger a refresh event so that UIs refresh themselves.
    // This could be at the tail end of the creation of an exception
    // or a new recurring base.

    if (isRecurrenceRelatedFieldChange && !silent) {
      const event = {
        action: 'batch',
        records: this.storage.values
      };
      this.trigger('refresh', event);
      this.trigger('change', event);
    }
  }
  /**
   * The method restricts which field modifications should trigger timespan occurrences building.
   * By default any field change of a recurring timespan causes the rebuilding.
   * @param  {Scheduler.model.TimeSpan} timeSpan The modified timespan.
   * @param  {Object} wasSet Object containing the change set.
   * @return {Boolean} `True` if the fields modification should trigger the timespan occurrences rebuilding.
   * @internal
   * @category Recurrence
   */


  isRecurrenceRelatedFieldChange(timeSpan, wasSet) {
    return timeSpan.isRecurring || 'recurrenceRule' in wasSet;
  }
  /**
   * Builds occurrences for the provided timespan across the provided date range.
   * @private
   * @category Recurrence
   */


  getOccurrencesForTimeSpan(timeSpan, startDate, endDate) {
    const result = [];

    if (timeSpan.isRecurring) {
      timeSpan.recurrence.forEachOccurrence(startDate, endDate, r => result.push(r));
    }

    return result;
  }

  set data(data) {
    // All cached occurrences are now invalid with a new dataset
    this.globalOccurrences.clear();
    super.data = data;
  }
  /**
   * Returns all the recurring timespans.
   * @return {Scheduler.model.TimeSpan[]} Array of recurring events.
   * @category Recurrence
   */


  getRecurringTimeSpans() {
    return [...this.recurringEvents];
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ResourceStoreMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/mixin/ResourceStoreMixin
 */

/**
 * This is a mixin for the ResourceStore functionality. It is consumed by the {@link Scheduler.data.ResourceStore}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ResourceStoreMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ResourceStoreMixin';
  }

  get isResourceStore() {
    return true;
  }
  /**
   * Add resources to the store.
   *
   * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [resource] = resourceStore.add({ id });
   * // resource.events is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [resource] = resourceStore.add({ id });
   * await resourceStore.project.commitAsync();
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [resource] = await resourceStore.addAsync({ id });
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.ResourceModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add resources to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added resources.
   *
   * ```javascript
   * const [resource] = await resourceStore.addAsync({ id });
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.ResourceModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the ResourceStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * resourceStore.data = [{ id }];
   * // resourceStore.first.events is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * resourceStore.data = [{ id }];
   * await resourceStore.project.commitAsync();
   * // resourceStore.first.events is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await resourceStore.loadDataAsync([{ id }]);
   * // resourceStore.first.events is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the ResourceStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await resourceStore.loadDataAsync([{ id }]);
   * // resourceStore.first.events is available
   * ```
   *
   * @param {Object[]} data Array of ResourceModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 200,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 100,
      storeId: 'resources',
      autoTree: true
    };
  }

  construct(config) {
    super.construct(config);

    if (!this.modelClass.isResourceModel) {
      throw new Error('Model for ResourceStore must subclass ResourceModel');
    }
  }

  removeAll() {
    const result = super.removeAll(...arguments); // Removing all resources removes all assignments

    result && this.assignmentStore.removeAll();
    return result;
  } // Apply id changes also to assignments (used to be handled automatically by relations earlier, but engine does not
  // care about ids so needed now)
  // problems:
  // 1. orientation/HorizontalRendering listens to assignment store changes and is trying to refresh view
  // When we update resource id on assignment, listener will be invoked and view will try to refresh. And it will
  // fail, because row is not updated yet. Flag is raised on resource store to make HorizontalRendering to skip
  // refreshing view in this particular case of resource id changing


  onRecordIdChange({
    record,
    oldValue,
    value
  }) {
    super.onRecordIdChange({
      record,
      oldValue,
      value
    });

    if (record.isFieldModified('id')) {
      this.isChangingId = true;
      record.updateAssignmentResourceIds();
      this.isChangingId = false;
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/SharedEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/* eslint-disable no-unused-expressions */

/**
 * @module Scheduler/data/mixin/SharedEventStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SharedEventStoreMixin extends Target {
  static get $name() {
    return 'SharedEventStoreMixin';
  }
  /**
   * Add events to the store.
   *
   * NOTE: Dates, durations and references (assignments, resources) on the events are determined async by a calculation
   * engine. Thus they cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * eventStore.add({ startDate, duration });
   * // endDate is not yet calculated
   * ```
   *
   * To guarantee data is in a calculated state, wait for calculations for finish:
   *
   * ```javascript
   * eventStore.add({ startDate, duration });
   * await eventStore.project.commitAsync();
   * // endDate is calculated
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * await eventStore.addAsync({ startDate, duration });
   * // endDate is calculated
   * ```
   *
   * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.EventModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add events to the store and triggers calculations directly after. Await this function to have up to date data on
   * the added events.
   *
   * ```javascript
   * await eventStore.addAsync({ startDate, duration });
   * // endDate is calculated
   * ```
   *
   * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.EventModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the EventStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: Dates, durations and relations (assignments, resources) on the events are determined async by a calculation
   * engine. Thus they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * eventStore.data = [{ startDate, duration }];
   * // eventStore.first.endDate is not yet calculated
   * ```
   *
   * To guarantee data is in a calculated state, wait for calculations for finish:
   *
   * ```javascript
   * eventStore.data = [{ startDate, duration }];
   * await eventStore.project.commitAsync();
   * // eventStore.first.endDate is calculated
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await eventStore.loadDataAsync([{ startDate, duration }]);
   * // eventStore.first.endDate is calculated
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the EventStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await eventStore.loadDataAsync([{ startDate, duration }]);
   * // eventStore.first.endDate is calculated
   * ```
   *
   * @param {Object[]} data Array of EventModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 100,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 200,
      storeId: 'events',

      /**
       * Configure with `true` to also remove the event when removing the last assignment from the linked
       * AssignmentStore. This config has not effect when using EventStore in legacy `resourceId`-mode.
       * @config {Boolean}
       * @default
       * @category Common
       */
      removeUnassignedEvent: true,

      /**
       * Configure with `true` to force single-resource mode, an event can only be assigned to a single resource.
       * If not provided, the mode will be inferred from
       *
       * 1. presence of an assignment store (i.e. multi-assignment)
       * 2. presence of `resourceId` in the event store data (i.e. single assignment mode)
       * @config {Boolean}
       * @category Common
       */
      singleAssignment: null
    };
  }
  /**
   * Class used to represent records. Defaults to class EventModel.
   * @member {Scheduler.model.EventModel} modelClass
   * @typings {typeof EventModel}
   * @category Records
   */


  construct(config) {
    super.construct(config, true);

    if (this.singleAssignment) {
      this.usesSingleAssignment = true;
    }

    if (!this.modelClass.isEventModel) {
      throw new Error('The model for the EventStore must subclass EventModel');
    }
  }
  /**
   * Appends a new record to the store
   * @param {Scheduler.model.EventModel} record The record to append to the store
   * @category CRUD
   */


  append(record) {
    return this.add(record);
  } //region Project


  get project() {
    return super.project;
  }

  set project(project) {
    super.project = project;
    this.detachListeners('project');

    if (project) {
      var _project$assignmentSt;

      // Project already has AssignmentStore instance? Attach to it.
      if ((_project$assignmentSt = project.assignmentStore) !== null && _project$assignmentSt !== void 0 && _project$assignmentSt.isAssignmentStore) {
        this.attachToAssignmentStore(project.assignmentStore);
      } // Accessing assignmentStore would trigger `assignmentStoreChange` event on the project, so we set up
      // the listener after


      project.on({
        name: 'project',
        assignmentStoreChange: 'onProjectAssignmentStoreChange',
        thisObj: this,
        prio: 200 // Before UI updates

      });
    }
  } //endregion
  //region Single assignment


  processRecords(eventRecords) {
    var _this$stm;

    const {
      assignmentStore
    } = this,
          assignmentsToAdd = []; // Same as on `joinRecordsToStore`, when adding a number of event records CoreEventMixin#joinProject method
    // will clear/rebuild cache in a loop. We raise this flag to skip invalidating assignment store indices for the time
    // we are joining records to the store. When they're added and indices are read, we will invalidate them.

    if (assignmentStore) {
      assignmentStore.skipInvalidateIndices = true;
    }

    eventRecords = super.processRecords(eventRecords, assignmentStore && !((_this$stm = this.stm) !== null && _this$stm !== void 0 && _this$stm.isRestoring) && (eventRecord => {
      // AssignmentStore found, add an assignment to it if this is not a dataset operation
      const resourceId = eventRecord.get('resourceId');

      if (!eventRecord.reassignedFromReplace && resourceId != null) {
        // Check if the event is already assigned to the resource, though it's not in the event store.
        // It could happen when you remove an event, so both event and assignment records are removed,
        // then you "undo" the action and the assignment is restored before the event is restored.
        if (!assignmentStore.includesAssignment(eventRecord.id, resourceId)) {
          // Cannot use `event.assign(resourceId)` since event is not part of store yet
          // Using a bit shorter generated id to not look so ugly in DOM
          assignmentsToAdd.push({
            id: assignmentStore.modelClass.generateId(''),
            resourceId,
            eventId: eventRecord.id
          });
        }
      } // clear flag


      eventRecord.reassignedFromReplace = false;
    }) || undefined);

    if (assignmentStore) {
      assignmentStore.storage.invalidateIndices();
      assignmentStore.skipInvalidateIndices = false;
      assignmentStore.add(assignmentsToAdd);
    }

    return eventRecords;
  }

  joinRecordsToStore(records) {
    const {
      assignmentStore
    } = this;

    if (assignmentStore) {
      // When adding a number of event records CoreEventMixin#joinProject method will clear/rebuild cache in a loop.
      // We raise this flag to skip invalidating assignment store indices for the time we are joining records to
      // the store. When they're added and indices are read, we will invalidate them.
      assignmentStore.skipInvalidateIndices = true;
      super.joinRecordsToStore(records);
      assignmentStore.storage.invalidateIndices();
      assignmentStore.skipInvalidateIndices = false;
    } else {
      super.joinRecordsToStore(records);
    }
  }

  processRecord(eventRecord, isDataset = false) {
    eventRecord = super.processRecord(eventRecord, isDataset);
    const resourceId = eventRecord.get('resourceId');

    if (resourceId != null) {
      const me = this,
            {
        assignmentStore
      } = me,
            existingRecord = me.getById(eventRecord.id),
            isReplacing = existingRecord && existingRecord !== eventRecord && !isDataset; // Replacing an existing event, repoint the resource of its assignment
      // (already repointed to the new event by engine in EventStoreMixin)

      if (isReplacing) {
        // Have to look assignment up on store, removed by engine in super call above
        const assignment = assignmentStore.find(e => e.eventId === eventRecord.id);

        if (assignment) {
          assignment.resource = resourceId;
          eventRecord.reassignedFromReplace = true;
        }
      } // No AssignmentStore assigned yet, need to process when that happens. Or if it is a dataset operation,
      // processing will happen at the end of it to not add individual assignment (bad for performance)
      else {
        me.$processResourceIds = true;
      } // Flag that we have been loaded using resourceId, checked by CrudManager to exclude the internal
      // AssignmentStore from sync


      me.usesSingleAssignment = true;
    }

    return eventRecord;
  }

  processResourceIds() {
    const {
      assignmentStore
    } = this;

    if (this.$processResourceIds && assignmentStore !== null && assignmentStore !== void 0 && assignmentStore.isAssignmentStore) {
      const assignments = []; // resourceIds used during initialization, convert into assignments

      this.forEach(eventRecord => {
        const {
          resourceId,
          id: eventId
        } = eventRecord;

        if (resourceId != null) {
          // Using a bit shorter generated id to not look so ugly in DOM
          assignments.push({
            id: assignmentStore.modelClass.generateId(''),
            resourceId,
            eventId
          });
        }
      }); // Disable as much as possible, since we are in full control of this store when using single assignment mode

      assignmentStore.useRawData = {
        disableDefaultValue: true,
        disableDuplicateIdCheck: true,
        disableTypeConversion: true
      }; // Flag that throws in AssignmentStore if data is loaded some other way when using single assignment

      assignmentStore.usesSingleAssignment = false;
      assignmentStore.data = assignments;
      assignmentStore.usesSingleAssignment = true;
      this.$processResourceIds = false;
    }
  }

  loadData() {
    super.loadData(...arguments);
    this.processResourceIds();
  } // Optionally remove unassigned events


  onBeforeRemoveAssignment({
    records
  }) {
    var _me$stm;

    const me = this;

    if (me.removeUnassignedEvent && !me.isRemoving && !me.isSettingData && !((_me$stm = me.stm) !== null && _me$stm !== void 0 && _me$stm.isRestoring) && !me.usesSingleAssignment) {
      const toRemove = new Set(); // Collect all events that are unassigned after the remove

      records.forEach(assignmentRecord => {
        const {
          event
        } = assignmentRecord; // Assignment might not have an event or the event might already be removed

        if (event && !event.isRemoved && event.assignments.every(a => records.includes(a))) {
          toRemove.add(event);
        }
      }); // And remove them

      if (toRemove.size) {
        me.remove([...toRemove]);
      }
    }
  }

  onProjectAssignmentStoreChange({
    store
  }) {
    this.attachToAssignmentStore(store);
  }

  attachToAssignmentStore(assignmentStore) {
    const me = this;
    me.detachListeners('assignmentStore');

    if (assignmentStore) {
      me.processResourceIds();
      assignmentStore.on({
        name: 'assignmentStore',

        // Adding an assignment in single assignment mode should set events resourceId if needed
        addPreCommit({
          records
        }) {
          if (me.usesSingleAssignment && !me.isSettingData && !me.isAssigning) {
            records.forEach(assignment => {
              const {
                event
              } = assignment;

              if (event !== null && event !== void 0 && event.isEvent && event.resourceId !== assignment.resourceId) {
                event.meta.isAssigning = true;
                event.set('resourceId', assignment.resourceId);
                event.meta.isAssigning = false;
              }
            });
          }
        },

        // Called both for remove and removeAll
        beforeRemove: 'onBeforeRemoveAssignment',

        // Removing an assignment in single assignment mode should set events resourceId to null
        removePreCommit({
          records
        }) {
          if (me.usesSingleAssignment) {
            records.forEach(assignment => {
              var _me$getById;

              // With engine link to event is already broken when we get here, hence the lookup
              (_me$getById = me.getById(assignment.eventId)) === null || _me$getById === void 0 ? void 0 : _me$getById.set('resourceId', null);
            });
          }
        },

        removeAllPreCommit() {
          if (me.usesSingleAssignment && !me.isSettingData) {
            me.allRecords.forEach(eventRecord => eventRecord.set('resourceId', null));
          }
        },

        // Keep events resourceId in sync with assignment on changes in single assignment mode
        update({
          record,
          changes
        }) {
          if (me.usesSingleAssignment && 'resourceId' in changes) {
            const {
              event
            } = record;
            event.meta.isAssigning = true;
            event.set('resourceId', changes.resourceId.value);
            event.meta.isAssigning = false;
          }
        },

        thisObj: me
      });
    }
  }

  set data(data) {
    this.isSettingData = true; // When using single assignment, remove all assignments when loading a new set of events

    if (this.usesSingleAssignment && !this.syncDataOnLoad) {
      this.assignmentStore.removeAll(true);
    }

    super.data = data;
    this.isSettingData = false;
  } // Override trigger to decorate update/change events with a flag if resourceId was the only thing changed, in which
  // case the change most likely can be ignored since the assignment will also change


  trigger(eventName, params) {
    const {
      changes
    } = params || {};

    if (changes && 'resourceId' in changes && Object.keys(changes).length === 1) {
      params.isAssign = true;
    }

    return super.trigger(...arguments);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/util/EventDayIndex.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/data/util/EventDayIndex.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDayIndex; });
/* harmony import */ var _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/util/EventDayIndex
 */

const // Maps an index name that can be requested to its storage property on the EventDayIndex instance:
indexNameMap = {
  date: '_dateIndex',
  startDate: '_startDateIndex'
},
      indexProps = Object.values(indexNameMap),
      emptyArray = Object.freeze([]),
      {
  MILLIS_PER_DAY
} = _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__["default"];
/**
 * This utility class is used by event stores to index events by their day (a "YYYY-MM-DD" value, also known as a
 * "date key"). This key is produced by a {@link Core.util.DayTime} instance. If two `DayTime` instances have a common
 * `startShift`, they can share an index.
 *
 * @internal
 */

class EventDayIndex {
  constructor(store, dayTime) {
    /**
     * The `DayTime` definition for this index. This is set to the initial DayTime instance but can be used for
     * any other {@link #function-register registered} `DayTime` instances since they all posses the same value for
     * `startShift`.
     *
     * This defaults to {@link Core.util.DayTime#property-MIDNIGHT-static}.
     * @member {Core.util.DayTime} dayTime
     * @readonly
     */
    this.dayTime = dayTime || _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__["default"].MIDNIGHT;
    /**
     * The owning store instance of this index.
     * @member {Scheduler.data.EventStore} store
     * @private
     * @readonly
     */

    this.store = store;
    /**
     * The `DayTime` instances {@link #function-register registered} with this index instance. As instances are
     * {@link #function-unregister unregistered} they are removed from this array. Once this array is empty, this
     * index can be discarded.
     * @member {Core.util.DayTime[]} users
     * @private
     */

    this.users = [this.dayTime];
  }
  /**
   * Adds an event record to the specified index (either "startDate" or "date") for a given `date`.
   * @param {String} indexName The index to which the event record is to be added (either "startDate" or "date").
   * @param {Date|Number} date A date for which the event record overlaps. The {@link Core.util.DayTime#function-dateKey}
   * method is used to convert this date to a "YYYY-MM-DD" key for the index.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  add(indexName, date, eventRecord) {
    const index = this[indexNameMap[indexName]],
          key = this.dayTime.dateKey(date),
          entry = index[key] || (index[key] = new Set());
    entry.add(eventRecord);
  }
  /**
   * Adds an event record to all indexes for all dates which the event overlaps.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  addEvent(eventRecord) {
    var _this$dayTime$startOf;

    let dateMS = (_this$dayTime$startOf = this.dayTime.startOfDay(eventRecord.startDate)) === null || _this$dayTime$startOf === void 0 ? void 0 : _this$dayTime$startOf.getTime(),
        endDateMS;

    if (dateMS) {
      var _eventRecord$endDate$, _eventRecord$endDate;

      endDateMS = (_eventRecord$endDate$ = (_eventRecord$endDate = eventRecord.endDate) === null || _eventRecord$endDate === void 0 ? void 0 : _eventRecord$endDate.getTime()) !== null && _eventRecord$endDate$ !== void 0 ? _eventRecord$endDate$ : dateMS;
      this.add('startDate', dateMS, eventRecord);

      do {
        this.add('date', dateMS, eventRecord);
        dateMS += MILLIS_PER_DAY;
      } while (dateMS < endDateMS);
    }
  }
  /**
   * Clear this index.
   */


  clear() {
    indexProps.forEach(name => this[name] = Object.create(null));
  }
  /**
   * Returns an object that has properties named by the {@link Core.util.DayTime#function-dateKey} method, or the
   * array of event records if a `date` is specified, or the event record array and the date key in a 2-element array
   * if `returnKey` is `true`.
   * @param {String} indexName The name of the desired index (either 'date' or 'startDate').
   * @param {Number|Date} date The date as a `Date` or the millisecond UTC epoch. When passed, this method will return
   * the array of event records for this date.
   * @param {Boolean} [returnKey] Specify `true` to return the date key along with the event record array.
   * @returns {Object|Scheduler.model.EventModel[]}
   */


  get(indexName, date, returnKey) {
    // Date indices are created on first usage and after that kept up to date on changes
    !this.initialized && this.initialize();
    let ret = this[indexNameMap[indexName]],
        key;

    if (date) {
      key = this.dayTime.dateKey(date);
      ret = returnKey ? [ret[key], key] : ret[key];
    }

    return ret;
  }
  /**
   * Called when this index is first used. Once called, further store changes will be used to maintain this index.
   * @private
   */


  initialize() {
    this.initialized = true;
    this.clear();
    this.sync('splice', this.store.storage.allValues);
  }

  invalidate() {
    this.initialized = false;
    indexProps.forEach(name => this[name] = null);
  }
  /**
   * Returns `true` if the given `dayTime` matches this index.
   * @param {Core.util.DayTime} dayTime
   * @returns {Boolean}
   */


  matches(dayTime) {
    return this.dayTime.startShift === dayTime.startShift;
  }
  /**
   * Removes an event record from the specified index (either "startDate" or "date") for a given `date`.
   * @param {String} indexName The index to which the event record is to be removed (either "startDate" or "date").
   * @param {Date|Number} date A date for which the event record overlaps. The {@link Core.util.DayTime#function-dateKey}
   * method is used to convert this date to a "YYYY-MM-DD" key for the index.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  remove(indexName, date, eventRecord) {
    const index = this[indexNameMap[indexName]],
          key = this.dayTime.dateKey(date),
          entry = index[key];

    if (entry) {
      entry.delete(eventRecord);
    }
  }
  /**
   * Removes an event record from all indexes for all dates which the event overlaps.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @param {Date} startDate The start date for the event. This may be different from the `startDate` of the given
   * `eventRecord` when the event is rescheduled.
   * @param {Date} endDate The end date for the event. This may be different from the `endDate` of the given
   * `eventRecord` when the event is rescheduled.
   * @private
   */


  removeEvent(eventRecord, startDate, endDate) {
    var _this$dayTime$startOf2;

    let dateMS = (_this$dayTime$startOf2 = this.dayTime.startOfDay(startDate)) === null || _this$dayTime$startOf2 === void 0 ? void 0 : _this$dayTime$startOf2.getTime(),
        endDateMS;

    if (dateMS) {
      var _endDate$getTime;

      endDateMS = (_endDate$getTime = endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== null && _endDate$getTime !== void 0 ? _endDate$getTime : dateMS;
      this.remove('startDate', dateMS, eventRecord);

      do {
        this.remove('date', dateMS, eventRecord);
        dateMS += MILLIS_PER_DAY;
      } while (dateMS < endDateMS);
    }
  } // TODO: Improve Collection indices to handle this
  // Keeps date & startDate indices up to date, used by Calendar and recurrence
  // The indices are initialized lazily on first access, and then kept up to date on changes


  sync(action, added, removed, replaced, wasSet) {
    var _wasSet$startDate, _wasSet$endDate;

    added = added || emptyArray;
    removed = removed || emptyArray;
    const me = this,
          addedCount = added.length,
          removedCount = removed.length,
          replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;
    let i, newEvent, outgoingEvent;

    if (!me.initialized) {
      return;
    }

    switch (action) {
      case 'clear':
        me.clear();
        break;
      // Add and remove

      case 'splice':
        // Handle replacement of records by instances with same ID
        if (replacedCount) {
          added = added.slice();
          removed = removed.slice();

          for (i = 0; i < replacedCount; i++) {
            removed.push(replaced[i][0]);
            added.push(replaced[i][1]);
          }
        } // Remove entries from indices


        if (removedCount) {
          for (i = 0; i < removedCount; i++) {
            outgoingEvent = removed[i];
            me.removeEvent(outgoingEvent, outgoingEvent.startDate, outgoingEvent.endDate);
          }
        } // Add entries to indices


        if (addedCount) {
          for (i = 0; i < addedCount; i++) {
            newEvent = added[i]; // Can only be date-indexed if it's scheduled

            if (newEvent.isScheduled) {
              me.addEvent(newEvent);
            }
          }
        }

        break;
      // invoked when the start or end changes so that the event can be re-indexed.

      case 'reschedule':
        outgoingEvent = added[0];
        me.removeEvent(outgoingEvent, ((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.oldValue) || outgoingEvent.startDate, ((_wasSet$endDate = wasSet.endDate) === null || _wasSet$endDate === void 0 ? void 0 : _wasSet$endDate.oldValue) || outgoingEvent.endDate); // Now process as as splice with an add and no removes.

        me.sync('splice', added);
        break;
    }
  }
  /**
   * This method registers a `dayTime` instance with this index in the `users` array.
   * @param {Core.util.DayTime} dayTime The instance to register.
   */


  register(dayTime) {
    this.users.push(dayTime);
  }
  /**
   * This method unregisters a `dayTime` instance, removing it from the `users` array. This method returns `true` if
   * this was the last registered instance and this index is no longer needed.
   * @param {Core.util.DayTime} dayTime The instance to register.
   * @returns {Boolean}
   */


  unregister(dayTime) {
    const {
      users
    } = this,
          i = users.indexOf(dayTime);

    if (i > -1) {
      users.splice(i, 1);
    }

    return !users.length;
  }

}
; // To avoid shape changes:

const proto = EventDayIndex.prototype;
indexProps.forEach(name => proto[name] = null);
proto.initialized = false;
EventDayIndex._$name = 'EventDayIndex';

/***/ }),

/***/ "./lib/Scheduler/data/util/ModelPersistencyManager.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/data/util/ModelPersistencyManager.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelPersistencyManager; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/data/util/ModelPersistencyManager
 */

/**
 * This class manages model persistency, it listens to model stores' beforesync event and removes all non persistable
 * records from sync operation. The logic has meaning only for CRUD-less sync operations.
 *
 * @private
 */

class ModelPersistencyManager extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // region Event attachers
  set eventStore(newEventStore) {
    const me = this;
    me.eventStoreDetacher && me.eventStoreDetacher();
    me._eventStore = newEventStore;

    if (newEventStore && newEventStore.autoCommit) {
      me.eventStoreDetacher = newEventStore.on({
        beforecommit: me.onEventStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get eventStore() {
    return this._eventStore;
  }

  set resourceStore(newResourceStore) {
    const me = this;
    me.resourceStoreDetacher && me.resourceStoreDetacher();
    me._resourceStore = newResourceStore;

    if (newResourceStore && newResourceStore.autoCommit) {
      me.resourceStoreDetacher = newResourceStore.on({
        beforecommit: me.onResourceStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get resourceStore() {
    return this._resourceStore;
  }

  set assignmentStore(newAssignmentStore) {
    const me = this;
    me.assignmentStoreDetacher && me.assignmentStoreDetacher();
    me._assignmentStore = newAssignmentStore;

    if (newAssignmentStore && newAssignmentStore.autoSync) {
      me.assignmentStoreDetacher = newAssignmentStore.on({
        beforecommit: me.onAssignmentStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get assignmentStore() {
    return this._assignmentStore;
  }

  set dependencyStore(newDependencyStore) {
    const me = this;
    me.dependencyStoreDetacher && me.dependencyStoreDetacher();
    me._dependencyStore = newDependencyStore;

    if (newDependencyStore && newDependencyStore.autoSync) {
      me.dependencyStoreDetacher = newDependencyStore.on({
        beforecommit: me.onDependencyStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get dependencyStore() {
    return this._dependencyStore;
  } // endregion
  // region Event handlers


  onEventStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onResourceStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onAssignmentStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onDependencyStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  } // endregion
  // region Management rules


  removeNonPersistableRecordsToCreate(changes) {
    let recordsToCreate = changes.added || [],
        r,
        i; // We remove from the array we iterate thus we iterate from end to start

    for (i = recordsToCreate.length - 1; i >= 0; --i) {
      r = recordsToCreate[i];

      if (!r.isPersistable) {
        recordsToCreate.splice(recordsToCreate.indexOf(r), 1);
      }
    } // Prevent empty create request


    if (recordsToCreate.length === 0) {
      changes.added.length = 0;
    }
  }

  shallContinueSync(options) {
    return Boolean(options.added && options.added.length > 0 || options.modified && options.modified.length > 0 || options.removed && options.removed.length > 0);
  } // endregion


}
ModelPersistencyManager._$name = 'ModelPersistencyManager';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js":
/*!**************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractRecurrenceIterator; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/data/util/recurrence/AbstractRecurrenceIterator
 * @private
 */

const frequencyToUnitRe = /ly$/i,
      frequencyToUnit = frequency => {
  const result = frequency.replace(frequencyToUnitRe, '');
  return result === 'DAI' ? 'DAY' : result;
},
      fn = (date, counter, isFirst, timeSpan) => timeSpan.buildOccurrence(date, isFirst),
      captureLastOccurrence = date => lastOccurrenceDate = date;

let lastOccurrenceDate;
class AbstractRecurrenceIterator extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static processIterationConfig(config) {
    var _endDate;

    const {
      recurrence
    } = config,
          {
      frequency,
      interval,
      timeSpan,
      endDate: until,
      count
    } = recurrence; // Force the correction of the event to be in sync with its recurrence rule
    // before performing iteration. For example, if the event's configured startDate
    // is 1st January 2020, and the rule dictates that the event will take place
    // monthly, every Monday, then the first event is not until Monday 6th January, 2020.

    if (!config.syncingStartDate && !timeSpan.meta.isSyncedWithRule) {
      // Do not generate occurrences outside of the specified range
      const intervalEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(timeSpan.startDate, interval, frequencyToUnit(frequency)),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(intervalEndDate, config.endDate || intervalEndDate);
      this.forEachDate({
        syncingStartDate: true,
        startDate: timeSpan.startDate,
        endDate,
        recurrence,
        fn
      });
    } // Capture the start after its been synced with its recurrence rule


    const timeSpanStart = timeSpan.startDate; // Extract the endDate from the config, defaulting to the recurrence UNTIL date

    let {
      startDate = timeSpanStart,
      endDate = until
    } = config; // No point in starting the iteration before the event starts

    if (startDate < timeSpanStart) {
      startDate = timeSpanStart;
    } // The recurrence's stop date overrides the configured endDate.


    if (until) {
      if (!endDate || endDate > until) {
        endDate = until;
      }
    } // If we are limiting using count and we are not starting from the
    // first occurrence, then we have to calculate a stop date.
    // This is because for date ranges in the future we cannot calculate how many
    // preceding occurrences there may have been.
    else if (count && startDate > timeSpanStart) {
      // Iterate the occurrences from the start to capture the last one
      this.forEachDate({
        recurrence,
        fn: captureLastOccurrence
      }); // The date of the last occurrence in the count sequence overrides the configured endDate.

      if (!endDate || endDate > lastOccurrenceDate) {
        endDate = lastOccurrenceDate;
      }
    } // Preserve the requested start of requested visits.


    const earliestVisibleDate = startDate; // Unless we are only asked for events which *start* within the time range. we must make
    // a best attempt to include any occurrences which span the start date.
    // So if we are asking for events from the 1st of the month, and there's an event
    // which runs every 2 months from the 15th to the 5th, we must include it. Start the
    // iteration <interval> full frequency quanta before the requested start.
    // This will only cause <interval> extra iterations.
    // We cannot step back to before the event's starting date though.

    if (!config.startOnly) {
      startDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, -interval, frequencyToUnit(frequency)), timeSpanStart));
    }

    return Object.assign({
      extraArgs: [],
      // Only check start date for time spans with 0 duration
      startOnly: !Boolean(timeSpan.durationMS)
    }, config, {
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      endDateMS: (_endDate = endDate) === null || _endDate === void 0 ? void 0 : _endDate.getTime(),
      timeSpanStartMS: timeSpanStart.getTime(),
      earliestVisibleDateMS: earliestVisibleDate.getTime(),
      durationMS: timeSpan.durationMS,
      spansStart: startDate <= timeSpanStart && endDate > timeSpanStart
    });
  }

  static get frequency() {
    return 'NONE';
  }

  static get MAX_OCCURRENCES_COUNT() {
    return 1000000;
  }

  static getOccurrenceIndex(event) {
    if (event.isOccurrence) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].diff(event.recurringTimeSpan.startDate, event.startDate, frequencyToUnit(event.recurringTimeSpan.recurrence.frequency));
    }
  }
  /**
   * Returns Nth occurrence of a week day in the provided period of time.
   * @param  {Date} startDate Period start date.
   * @param  {Date} endDate   Period end date.
   * @param  {Integer} day    Week day (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
   * @param  {Integer} index  Index to find.
   * @return {Date}           Returns the found date or null if there is no `index`th entry.
   * @private
   */


  static getNthDayInPeriod(startDate, endDate, day, index) {
    let result, sign, borderDate;

    if (index) {
      if (index > 0) {
        sign = 1;
        borderDate = startDate;
      } else {
        sign = -1;
        borderDate = endDate;
      } // delta between requested day and border day


      const delta = day - borderDate.getDay(); // if the requested day goes after (before, depending on borderDate used (start/end))
      // we adjust index +/-1

      if (sign * delta < 0) {
        index += sign;
      } // measure "index" weeks forward (or backward) ..take delta into account
      // result = new Date(borderDate.getTime() + ((index - sign) * 7 + delta) * 24*60*60*1000);
      // Per https://github.com/bryntum/support/issues/3413 - don't do that ^^ because DST makes days/week
      // alternatingly shorter or longer depending on going in/out of DST:


      result = new Date(borderDate);
      result.setDate(borderDate.getDate() + (index - sign) * 7 + delta); // if resulting date is outside of the provided range there is no "index"-th entry
      // of the day

      if (result < startDate || result > endDate) {
        result = null;
      }
    }

    return result;
  }

  static buildDate(year, month, date) {
    const dt = new Date(year, month, date);

    if (dt.getFullYear() === year && dt.getMonth() === month && dt.getDate() === date) {
      return dt;
    }
  }

  static isValidPosition(position) {
    return Boolean(position);
  }

  static forEachDateAtPositions(dates, positions, fn, scope) {
    const datesLength = dates.length,
          processed = {};

    for (let i = 0; i < positions.length; i++) {
      const index = positions[i];

      if (this.isValidPosition(index)) {
        const date = index > 0 ? dates[index - 1] : dates[datesLength + index];

        if (date && !processed[date.getTime()]) {
          // remember that we've returned the date
          processed[date.getTime()] = true; // return false if it's time to stop recurring

          if (fn.call(scope, date) === false) {
            return false;
          }
        }
      }
    }
  }

  static isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan) {
    return (startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate) && !timeSpan.hasException(occurrenceDate);
  } // Slightly faster version of ^, used by Daily & Weekly iterators


  static isInViewMS(startOnly, occurenceDate, occurrenceDateMS, earliestVisibleDateMS, durationMS, timeSpan) {
    return (startOnly ? occurrenceDateMS >= earliestVisibleDateMS : occurrenceDateMS + durationMS > earliestVisibleDateMS) && !timeSpan.hasException(occurenceDate);
  }

}
AbstractRecurrenceIterator._$name = 'AbstractRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js":
/*!***********************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DailyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';
/**
* @module Scheduler/data/util/recurrence/DailyRecurrenceIterator
*/



/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class DailyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'DAILY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts a recurring event which matches the passed recurrence rule and overlaps the start and end dates
   * and is not an {@link Scheduler.model.mixin.RecurringTimeSpan#field-exceptionDates exceptionDate}
   * in the recurring event.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      endDateMS,
      timeSpan,
      timeSpanStart,
      earliestVisibleDateMS,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval
    } = recurrence,
          delay = startDate - timeSpanStart,
          // recurrence interval duration in ms (86400000 is a single day duration in ms)
    intervalDuration = interval * 86400000,
          delayInIntervals = Math.floor(delay / intervalDuration);
    let {
      count
    } = recurrence,
        counter = 0,
        occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(timeSpanStart, delayInIntervals * interval, 'day'),
        occurenceDateMS = occurrenceDate.getTime();

    if (!endDate && !count) {
      count = this.MAX_OCCURRENCES_COUNT;
    }

    while (!endDateMS || occurenceDateMS <= endDateMS) {
      const inView = this.isInViewMS(startOnly, occurrenceDate, occurenceDateMS, earliestVisibleDateMS, durationMS, timeSpan);
      counter++;

      if (inView && (endDateMS && occurenceDateMS > endDateMS || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
        break;
      } // shift to the next day


      occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(occurrenceDate, interval, 'day');
      occurenceDateMS = occurrenceDate.getTime();
    }
  }

}
DailyRecurrenceIterator._$name = 'DailyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MonthlyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'gantt';
/**
* @module Scheduler/data/util/recurrence/MonthlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class MonthlyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'MONTHLY';
  }

  static getNthDayOfMonth(date, dayNum) {
    const daysInMonth = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].daysInMonth(date);
    let result = null;

    if (dayNum && Math.abs(dayNum) <= daysInMonth) {
      result = new Date(date.getFullYear(), date.getMonth(), dayNum < 0 ? daysInMonth + dayNum + 1 : dayNum);
    }

    return result;
  }

  static isValidPosition(position) {
    return position && Math.abs(position) > 0 && Math.abs(position) <= 31;
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days,
      count,
      positions
    } = recurrence,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};
    let {
      monthDays
    } = recurrence,
        counter = 0,
        weekDayPosition,
        monthStartDate,
        monthEndDate,
        dates,
        occurrenceDate,
        i; // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(count || interval > 1 ? timeSpanStart : startDate, 'month');
    monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', 1) - 1); // If no month days nor week days are provided let's use event start date month day

    if (!(monthDays && monthDays.length) && !(weekDays && weekDays.length)) {
      monthDays = [timeSpanStart.getDate()];
    }

    if (weekDays && weekDays.length) {
      // Collect hash of positions indexed by week days
      weekDays.forEach(day => {
        if (day[1]) {
          weekDayPosition = weekDayPosition || {};
          weekDayPosition[day[0]] = day[1];
        }
      });
    }

    while ((!endDate || endDate >= monthStartDate) && (!count || counter < count)) {
      dates = [];

      if (weekDays && weekDays.length) {
        weekDays.forEach(day => {
          const weekDay = day[0];
          let from = 1,
              till = 53; // if position provided

          if (day[1]) {
            from = till = day[1];
          }

          for (i = from; i <= till; i++) {
            if (occurrenceDate = this.getNthDayInPeriod(monthStartDate, monthEndDate, weekDay, i)) {
              occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

              if (!processedDate[occurrenceDate.getTime()]) {
                // remember we processed the date
                processedDate[occurrenceDate.getTime()] = true;
                dates.push(occurrenceDate);
              }
            }
          }
        });
        dates.sort((a, b) => a - b);

        if (!hasPositions) {
          for (i = 0; i < dates.length; i++) {
            occurrenceDate = dates[i];

            if (occurrenceDate >= timeSpanStart) {
              const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
              counter++;

              if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                return false;
              }
            }
          }
        }
      } else {
        const sortedMonthDates = [];

        for (i = 0; i < monthDays.length; i++) {
          // check if the date wasn't iterated over yet
          if ((occurrenceDate = this.getNthDayOfMonth(monthStartDate, monthDays[i])) && !processedDate[occurrenceDate.getTime()]) {
            processedDate[occurrenceDate.getTime()] = true;
            sortedMonthDates.push(occurrenceDate);
          }
        } // it's important to sort the dates to iterate over them in the proper order


        sortedMonthDates.sort((a, b) => a - b);

        for (i = 0; i < sortedMonthDates.length; i++) {
          occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(sortedMonthDates[i], timeSpanStart);

          if (hasPositions) {
            dates.push(occurrenceDate);
          } else if (occurrenceDate >= timeSpanStart) {
            const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
            counter++;

            if (inView && ( // eslint-disable-next-line no-labels
            endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
              return;
            }
          }
        }
      }

      if (hasPositions && dates.length) {
        this.forEachDateAtPositions(dates, positions, occurrenceDate => {
          if (occurrenceDate >= timeSpanStart) {
            const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
            counter++; // Ignore dates outside of the [startDate, endDate] range

            if (inView && (!endDate || occurrenceDate <= endDate) && ( // return false if it's time to stop recurring
            fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
              return false;
            }
          }
        });
      } // get next month start


      monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', interval);
      monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', 1) - 1);
    }
  }

}
MonthlyRecurrenceIterator._$name = 'MonthlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDayRuleEncoder; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

const dayParseRegExp = /^([+-]?[0-9])?(SU|MO|TU|WE|TH|FR|SA)$/;
const days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
class RecurrenceDayRuleEncoder extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static decodeDay(rawDay) {
    let parsedDay, result;

    if (parsedDay = dayParseRegExp.exec(rawDay)) {
      result = [days.indexOf(parsedDay[2])]; // optional position number

      if (parsedDay[1]) {
        parsedDay[1] = parseInt(parsedDay[1], 10);
        result.push(parsedDay[1]);
      }
    }

    return result;
  }

  static encodeDay(day) {
    let position; // support decodeDay() result format

    if (Array.isArray(day)) {
      [day, position] = day;
    }

    return (position ? position.toString() : '') + days[day];
  } // Turns days values provided as an array of strings (like [`-1MO`, `SU`, `+3FR`])
  // into an array of [ dayIndex, position ] elements, where:
  //
  // - `dayIndex` - zero-based week day index value (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
  // - `position` - (optional) 1-based position of the day (integer value (can be both positive and negative))


  static decode(rawDays) {
    let result = [],
        parsedDay;

    if (rawDays) {
      for (let i = 0; i < rawDays.length; i++) {
        if (parsedDay = this.decodeDay(rawDays[i])) {
          result.push(parsedDay);
        }
      }
    }

    return result;
  }

  static encode(days) {
    let result = [],
        day;

    if (days) {
      for (let i = 0; i < days.length; i++) {
        if (day = this.encodeDay(days[i])) {
          result.push(day);
        }
      }
    }

    return result;
  }

}
;
RecurrenceDayRuleEncoder._$name = 'RecurrenceDayRuleEncoder';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js":
/*!****************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceLegend; });
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/data/util/recurrence/RecurrenceLegend
 */

/**
 * A static class allowing to get a human readable description of the provided recurrence.
 *
 * ```javascript
 * const event = new EventModel({ startDate : new Date(2018, 6, 3), endDate : new Date(2018, 6, 4) });
 * const recurrence = new RecurrenceModel({ frequency : 'WEEKLY', days : ['MO', 'TU', 'WE'] });
 * event.recurrence = recurrence;
 * // "Weekly on  Mon, Tue and Wed"
 * RecurrenceLegend.getLegend(recurrence);
 * ```
 * @mixes Core/localization/Localizable
 */

class RecurrenceLegend extends Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__["default"])() {
  static get $name() {
    return 'RecurrenceLegend';
  }

  static get allDaysValueAsArray() {
    return ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
  }

  static get allDaysValue() {
    return this.allDaysValueAsArray.join(',');
  }

  static get workingDaysValue() {
    return this.allDaysValueAsArray.filter((day, index) => !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].nonWorkingDays[index]).join(',');
  }

  static get nonWorkingDaysValue() {
    return this.allDaysValueAsArray.filter((day, index) => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].nonWorkingDays[index]).join(',');
  }
  /**
   * Returns the provided recurrence description. The recurrence might be assigned to a timespan model,
   * in this case the timespan start date should be provided in the second argument.
   * @param  {Scheduler.model.RecurrenceModel} recurrence         Recurrence model.
   * @param  {Date}                           [timeSpanStartDate] The recurring timespan start date. Can be omitted if the recurrence is assigned to a timespan model
   *                                                              (and the timespan has {@link Scheduler.model.TimeSpan#field-startDate} filled).
   *                                                              Then start date will be retrieved from the model.
   * @return {String}                                             The recurrence description.
   */


  static getLegend(recurrence, timeSpanStartDate) {
    const me = this,
          {
      timeSpan,
      interval,
      days,
      monthDays,
      months,
      positions
    } = recurrence,
          startDate = timeSpanStartDate || timeSpan.startDate,
          tplData = {
      interval
    };
    let fn;

    switch (recurrence.frequency) {
      case 'DAILY':
        return interval === 1 ? me.L('L{Daily}') : me.L('L{Every {0} days}', tplData);

      case 'WEEKLY':
        if (days && days.length) {
          tplData.days = me.getDaysLegend(days);
        } else if (startDate) {
          tplData.days = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDayName(startDate.getDay());
        }

        return me.L(interval === 1 ? 'L{Weekly on {1}}' : 'L{Every {0} weeks on {1}}', tplData);

      case 'MONTHLY':
        if (days && days.length && positions && positions.length) {
          tplData.days = me.getDaysLegend(days, positions);
        } else if (monthDays && monthDays.length) {
          // sort dates to output in a proper order
          monthDays.sort((a, b) => a - b);
          tplData.days = me.arrayToText(monthDays);
        } else if (startDate) {
          tplData.days = startDate.getDate();
        }

        return me.L(interval === 1 ? 'L{Monthly on {1}}' : 'L{Every {0} months on {1}}', tplData);

      case 'YEARLY':
        if (days && days.length && positions && positions.length) {
          tplData.days = me.getDaysLegend(days, positions);
        } else {
          tplData.days = startDate.getDate();
        }

        if (months && months.length) {
          // sort months to output in a proper order
          months.sort((a, b) => a - b);

          if (months.length > 2) {
            fn = month => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getMonthShortName(month - 1);
          } else {
            fn = month => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getMonthName(month - 1);
          }

          tplData.months = me.arrayToText(months, fn);
        } else {
          tplData.months = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getMonthName(startDate.getMonth());
        }

        return me.L(interval === 1 ? 'L{Yearly on {1} of {2}}' : 'L{Every {0} years on {1} of {2}}', tplData);
    }
  }

  static getDaysLegend(days, positions) {
    const me = this,
          tplData = {
      position: ''
    };
    let fn;

    if (positions && positions.length) {
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{position1}'
      // 'L{position2}'
      // 'L{position3}'
      // 'L{position4}'
      // 'L{position5}'
      // 'L{position-1}'
      tplData.position = me.arrayToText(positions, position => me.L(`L{position${position}}`));
    }

    if (days.length) {
      days.sort((a, b) => _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_1__["default"].decodeDay(a)[0] - _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_1__["default"].decodeDay(b)[0]);

      switch (days.join(',')) {
        case me.allDaysValue:
          tplData.days = me.L('L{day}');
          break;

        case me.workingDaysValue:
          tplData.days = me.L('L{weekday}');
          break;

        case me.nonWorkingDaysValue:
          tplData.days = me.L('L{weekend day}');
          break;

        default:
          if (days.length > 2) {
            fn = day => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDayShortName(_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_1__["default"].decodeDay(day)[0]);
          } else {
            fn = day => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDayName(_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_1__["default"].decodeDay(day)[0]);
          }

          tplData.days = me.arrayToText(days, fn);
      }
    }

    return me.L('L{daysFormat}', tplData);
  } // Converts array of items to a human readable list.
  // For example: [1,2,3,4]
  // to: "1, 2, 3 and 4"


  static arrayToText(array, fn) {
    if (fn) {
      array = array.map(fn);
    }

    return array.join(', ').replace(/,(?=[^,]*$)/, this.L('L{ and }'));
  }

}
RecurrenceLegend._$name = 'RecurrenceLegend';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WeeklyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'gantt';
/**
* @module Scheduler/data/util/recurrence/WeeklyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class WeeklyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'WEEKLY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    var _weekDays;

    const {
      startOnly,
      startDate,
      endDateMS,
      timeSpan,
      timeSpanStart,
      timeSpanStartMS,
      earliestVisibleDateMS,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days
    } = recurrence,
          {
      weekStartDay
    } = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          startHours = timeSpanStart.getHours(),
          startMinutes = timeSpanStart.getMinutes(),
          startSeconds = timeSpanStart.getSeconds(),
          startMS = timeSpanStart.getMilliseconds();
    let counter = 0,
        {
      count
    } = recurrence,
        weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
        weekStartDate,
        occurrenceDate; // "Days" might be skipped then we use the event start day

    if (!((_weekDays = weekDays) !== null && _weekDays !== void 0 && _weekDays.length)) {
      weekDays = [[timeSpanStart.getDay()]];
    } // If week start day is not zero (Sunday)
    // we need to normalize weekDays array since its values are used
    // to calculate real dates as: date = week_start_date + weekDay_entry
    // which does not work when week starts on non-Sunday


    if (weekStartDay > 0) {
      for (let i = 0; i < weekDays.length; i++) {
        if (weekStartDay > weekDays[i][0]) {
          weekDays[i][0] = 7 - weekStartDay - weekDays[i][0];
        } else {
          weekDays[i][0] -= weekStartDay;
        }
      }
    } // days could be provided in any order so it's important to sort them


    weekDays.sort((a, b) => a[0] - b[0]); // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(count || interval > 1 ? timeSpanStart : startDate, 'week', 0);

    if (!endDateMS && !count) {
      count = this.MAX_OCCURRENCES_COUNT;
    }

    while (!endDateMS || weekStartDate.getTime() <= endDateMS) {
      for (let i = 0; i < weekDays.length; i++) {
        // Faster than chaining multiple DateHelper calls
        occurrenceDate = new Date(weekStartDate.getFullYear(), weekStartDate.getMonth(), weekStartDate.getDate() + weekDays[i][0], startHours, startMinutes, startSeconds, startMS);
        const occurrenceDateMS = occurrenceDate.getTime();

        if (occurrenceDateMS >= timeSpanStartMS) {
          const inView = this.isInViewMS(startOnly, occurrenceDate, occurrenceDateMS, earliestVisibleDateMS, durationMS, timeSpan);
          counter++;

          if (inView && (endDateMS && occurrenceDateMS > endDateMS || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
            return;
          }
        }
      } // get next week start


      weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(weekStartDate, 'week', interval);
    }
  }

}
WeeklyRecurrenceIterator._$name = 'WeeklyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return YearlyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'gantt';
/**
* @module Scheduler/data/util/recurrence/YearlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class YearlyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'YEARLY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days,
      count,
      positions
    } = recurrence,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};
    let {
      months
    } = recurrence,
        counter = 0,
        i,
        occurrenceDate,
        dates,
        yearStartDate,
        yearEndDate,
        weekDayPosition; // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(count || interval > 1 ? timeSpanStart : startDate, 'year');
    yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', 1) - 1);
    months && months.sort((a, b) => a - b); // if no months provided let's use the event month

    if (!(months && months.length) && !(weekDays && weekDays.length)) {
      months = [timeSpanStart.getMonth() + 1];
    }

    if (weekDays && weekDays.length) {
      // Collect hash of positions indexed by week days
      weekDays.forEach(day => {
        if (day[1]) {
          weekDayPosition = weekDayPosition || {};
          weekDayPosition[day[0]] = day[1];
        }
      });
    }

    while ((!endDate || endDate >= yearStartDate) && (!count || counter < count)) {
      dates = [];

      if (weekDays && weekDays.length) {
        weekDays.forEach(day => {
          const weekDay = day[0];
          let from = 1,
              till = 53; // if position provided

          if (day[1]) {
            from = till = day[1];
          }

          for (i = from; i <= till; i++) {
            if (occurrenceDate = this.getNthDayInPeriod(yearStartDate, yearEndDate, weekDay, i)) {
              occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

              if (!processedDate[occurrenceDate.getTime()]) {
                // remember we processed the date
                processedDate[occurrenceDate.getTime()] = true;
                dates.push(occurrenceDate);
              }
            }
          }
        });
        dates.sort((a, b) => a - b);

        if (!hasPositions) {
          for (i = 0; i < dates.length; i++) {
            occurrenceDate = dates[i];

            if (occurrenceDate >= timeSpanStart) {
              const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
              counter++;

              if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                return;
              }
            }
          }
        }
      } else {
        for (i = 0; i < months.length; i++) {
          if (occurrenceDate = this.buildDate(yearStartDate.getFullYear(), months[i] - 1, timeSpanStart.getDate())) {
            occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart); // check if the date wasn't iterated over yet

            if (!processedDate[occurrenceDate.getTime()]) {
              processedDate[occurrenceDate.getTime()] = true;

              if (hasPositions) {
                dates.push(occurrenceDate);
              } else if (occurrenceDate >= timeSpanStart) {
                const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
                counter++;

                if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                  return;
                }
              }
            }
          }
        }
      }

      if (hasPositions && dates.length) {
        this.forEachDateAtPositions(dates, positions, occurrenceDate => {
          if (occurrenceDate >= timeSpanStart) {
            const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
            counter++; // Ignore dates outside of the [startDate, endDate] range

            if (inView && (!endDate || occurrenceDate <= endDate)) {
              // return false if it's time to stop recurring
              if (fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count) {
                return false;
              }
            }
          }
        });
      } // get next month start


      yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', interval);
      yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', 1) - 1);
    }
  }

}
YearlyRecurrenceIterator._$name = 'YearlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayout.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayout.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayout; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/eventlayout/HorizontalLayout
 */

/**
 * Base class for horizontal layouts (HorizontalLayoutPack and HorizontalLayoutStack). Should not be used directly,
 * instead specify {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} in Scheduler config (stack,
 * pack or none):
 *
 * @example
 * let scheduler = new Scheduler({
 *   eventLayout: 'stack'
 * });
 *
 * @abstract
 * @private
 */

class HorizontalLayout extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      nbrOfBandsByResource: {},
      bandIndexToPxConvertFn: null,
      bandIndexToPxConvertThisObj: null
    };
  }

  clearCache(resource) {
    if (resource) {
      delete this.nbrOfBandsByResource[resource.id];
    } else {
      this.nbrOfBandsByResource = {};
    }
  }
  /**
   * This method performs layout on an array of event render data and returns amount of _bands_. Band is a multiplier of a
   * configured {@link Scheduler.view.Scheduler#config-rowHeight} to calculate total row height required to fit all
   * events.
   * This method should not be used directly, it is called by the Scheduler during the row rendering process.
   * @param {EventRenderData[]} events
   * @param {Scheduler.model.ResourceModel} resource
   * @return {Number}
   */


  applyLayout(events, resource) {
    const rowEvents = events.slice(),
          // return a number of bands required
    newNbrBands = this.layoutEventsInBands(rowEvents);
    return this.nbrOfBandsByResource[resource.id] = newNbrBands;
  }
  /**
   * This method iterates over events and calculates top position for each of them. Default layouts calculate
   * positions to avoid events overlapping horizontally (except for the 'none' layout). Pack layout will squeeze events to a single
   * row by reducing their height, Stack layout will increase the row height and keep event height intact.
   * This method should not be used directly, it is called by the Scheduler during the row rendering process.
   * @param {EventRenderData[]} events
   */


  layoutEventsInBands(events) {
    throw new Error('Implement in subclass');
  }

}
HorizontalLayout._$name = 'HorizontalLayout';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayoutPack.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayoutPack; });
/* harmony import */ var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./HorizontalLayout.js */ "./lib/Scheduler/eventlayout/HorizontalLayout.js");
/* harmony import */ var _PackMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PackMixin.js */ "./lib/Scheduler/eventlayout/PackMixin.js");
var productName = 'gantt';


/**
 * @module Scheduler/eventlayout/HorizontalLayoutPack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Packs events (adjusts their height) to fit
 * available row height
 *
 * @extends Scheduler/eventlayout/HorizontalLayout
 * @mixes Scheduler/eventlayout/PackMixin
 * @private
 */

class HorizontalLayoutPack extends _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_PackMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'HorizontalLayoutPack';
  }

  static get configurable() {
    return {
      type: 'pack'
    };
  } // Packs the events to consume as little space as possible


  layoutEventsInBands(events) {
    const result = this.packEventsInBands(events, (event, j, slot, slotSize) => {
      event.height = slotSize;
      event.top = slot.start + j * slotSize;
    });
    events.forEach(event => {
      Object.assign(event, this.bandIndexToPxConvertFn.call(this.bandIndexToPxConvertThisObj || this, event.top, event.height, event.eventRecord, event.resourceRecord));
    });
    return result;
  }

}
HorizontalLayoutPack._$name = 'HorizontalLayoutPack';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayoutStack.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayoutStack; });
/* harmony import */ var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./HorizontalLayout.js */ "./lib/Scheduler/eventlayout/HorizontalLayout.js");
var productName = 'gantt';

/**
 * @module Scheduler/eventlayout/HorizontalLayoutStack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Stacks events, increasing row height when to fit
 * all overlapping events.
 *
 * This layout is used by default in horizontal mode.
 *
 * @extends Scheduler/eventlayout/HorizontalLayout
 * @private
 */

class HorizontalLayoutStack extends _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'HorizontalLayoutStack';
  }

  static get configurable() {
    return {
      type: 'stack'
    };
  } // Input: Array of event layout data
  // heightRun is used when pre-calculating row heights, taking a cheaper path


  layoutEventsInBands(events, heightRun = false) {
    let verticalPosition = 0;

    do {
      let eventIndex = 0,
          event = events[0];

      while (event) {
        if (!heightRun) {
          // Apply band height to the event cfg
          event.top = this.bandIndexToPxConvertFn.call(this.bandIndexToPxConvertThisObj || this, verticalPosition, event.eventRecord, event.resourceRecord);
        } // Remove it from the array and continue searching


        events.splice(eventIndex, 1);
        eventIndex = this.findClosestSuccessor(event, events);
        event = events[eventIndex];
      }

      verticalPosition++;
    } while (events.length > 0); // Done!


    return verticalPosition;
  } // TODO: optimize this for better performance with many events per resource


  findClosestSuccessor(eventRenderData, events) {
    const {
      endMS,
      group
    } = eventRenderData,
          isMilestone = eventRenderData.eventRecord && eventRenderData.eventRecord.duration === 0;
    let minGap = Infinity,
        closest,
        gap,
        event;

    for (let i = 0, l = events.length; i < l; i++) {
      event = events[i];
      gap = event.startMS - endMS;

      if (gap >= 0 && gap < minGap && ( // Two milestones should not overlap
      gap > 0 || event.endMS - event.startMS > 0 || !isMilestone)) {
        // Events are sorted by group, so when we find first event with a different group, we can stop iteration
        if (this.grouped && group !== event.group) {
          break;
        }

        closest = i;
        minGap = gap;
      }
    }

    return closest;
  }

}
HorizontalLayoutStack._$name = 'HorizontalLayoutStack';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/PackMixin.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/eventlayout/PackMixin.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/eventlayout/PackMixin
 */

/**
 * Mixin holding functionality shared between HorizontalLayoutPack and VerticalLayout.
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class PackMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'PackMixin';
  }

  static get defaultConfig() {
    return {
      coordProp: 'top',
      sizeProp: 'height',
      inBandCoordProp: 'inBandTop',
      inBandSizeProp: 'inBandHeight'
    };
  }

  isSameGroup(a, b) {
    return this.grouped ? a.group === b.group : true;
  } // Packs the events to consume as little space as possible


  packEventsInBands(events, applyClusterFn) {
    const me = this,
          {
      coordProp,
      sizeProp
    } = me;
    let slot, firstInCluster, cluster, j;

    for (let i = 0, l = events.length; i < l; i++) {
      firstInCluster = events[i];
      slot = me.findStartSlot(events, firstInCluster);
      cluster = me.getCluster(events, i);

      if (cluster.length > 1) {
        firstInCluster[coordProp] = slot.start;
        firstInCluster[sizeProp] = slot.end - slot.start; // If there are multiple slots, and events in the cluster have multiple start dates, group all same-start events into first slot

        j = 1;

        while (j < cluster.length - 1 && cluster[j + 1].start - firstInCluster.start === 0) {
          j++;
        } // See if there's more than 1 slot available for this cluster, if so - first group in cluster consumes the entire first slot


        const nextSlot = me.findStartSlot(events, cluster[j]);

        if (nextSlot && nextSlot.start < 0.8) {
          cluster.length = j;
        }
      }

      const clusterSize = cluster.length,
            slotSize = (slot.end - slot.start) / clusterSize; // Apply fraction values

      for (j = 0; j < clusterSize; j++) {
        applyClusterFn(cluster[j], j, slot, slotSize);
      }

      i += clusterSize - 1;
    }

    return 1;
  }

  findStartSlot(events, event) {
    const {
      inBandSizeProp,
      inBandCoordProp,
      coordProp,
      sizeProp
    } = this,
          priorOverlappers = this.getPriorOverlappingEvents(events, event);
    let i;

    if (priorOverlappers.length === 0) {
      return {
        start: 0,
        end: 1
      };
    }

    for (i = 0; i < priorOverlappers.length; i++) {
      const item = priorOverlappers[i],
            COORD_PROP = inBandCoordProp in item ? inBandCoordProp : coordProp,
            SIZE_PROP = inBandSizeProp in item ? inBandSizeProp : sizeProp;

      if (i === 0 && item[COORD_PROP] > 0) {
        return {
          start: 0,
          end: item[COORD_PROP]
        };
      } else {
        if (item[COORD_PROP] + item[SIZE_PROP] < (i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][COORD_PROP] : 1)) {
          return {
            start: item[COORD_PROP] + item[SIZE_PROP],
            end: i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][COORD_PROP] : 1
          };
        }
      }
    }

    return false;
  }

  getPriorOverlappingEvents(events, event) {
    const start = event.start,
          end = event.end,
          overlappers = [];

    for (let i = 0, l = events.indexOf(event); i < l; i++) {
      const item = events[i];

      if (this.isSameGroup(item, event) && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].intersectSpans(start, end, item.start, item.end)) {
        overlappers.push(item);
      }
    }

    overlappers.sort(this.sortOverlappers.bind(this));
    return overlappers;
  }

  sortOverlappers(e1, e2) {
    const {
      coordProp
    } = this;
    return e1[coordProp] - e2[coordProp];
  }

  getCluster(events, startIndex) {
    const startEvent = events[startIndex],
          result = [startEvent];

    if (startIndex >= events.length - 1) {
      return result;
    }

    let {
      start,
      end
    } = startEvent;

    for (let i = startIndex + 1, l = events.length; i < l; i++) {
      const item = events[i];

      if (!this.isSameGroup(item, startEvent) || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].intersectSpans(start, end, item.start, item.end)) {
        break;
      }

      result.push(item);
      start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(start, item.start);
      end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(item.end, end);
    }

    return result;
  }

});

/***/ }),

/***/ "./lib/Scheduler/eventlayout/VerticalLayout.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/eventlayout/VerticalLayout.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalLayout; });
/* harmony import */ var _PackMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PackMixin.js */ "./lib/Scheduler/eventlayout/PackMixin.js");
var productName = 'gantt';

/**
 * @module Scheduler/eventlayout/VerticalLayout
 */

/**
 * Assists with event layout in vertical mode, handles `eventLayout: none|pack|mixed`
 * @private
 * @mixes Scheduler/eventlayout/PackMixin
 */

class VerticalLayout extends Object(_PackMixin_js__WEBPACK_IMPORTED_MODULE_0__["default"])() {
  static get defaultConfig() {
    return {
      coordProp: 'leftFactor',
      sizeProp: 'widthFactor'
    };
  } // Try to pack the events to consume as little space as possible


  applyLayout(events, columnWidth, resourceMargin, barMargin, columnIndex, eventLayout) {
    const layoutType = eventLayout.type;
    return this.packEventsInBands(events, (tplData, clusterIndex, slot, slotSize) => {
      // Stretch events to fill available width
      if (layoutType === 'none') {
        tplData.width = columnWidth - resourceMargin * 2;
        tplData.left += resourceMargin;
      } else {
        // Fractions of resource column
        tplData.widthFactor = slotSize;
        const leftFactor = tplData.leftFactor = slot.start + clusterIndex * slotSize,
              // Number of "columns" in the current slot
        packColumnCount = Math.round(1 / slotSize),
              // Index among those columns for current event
        packColumnIndex = leftFactor / slotSize,
              // Width with all bar margins subtracted
        availableWidth = columnWidth - resourceMargin * 2 - barMargin * (packColumnCount - 1); // Allowing two events to overlap? Slightly offset the second

        if (layoutType === 'mixed' && packColumnCount === 2) {
          tplData.left += leftFactor * columnWidth / 5 + barMargin;
          tplData.width = columnWidth - leftFactor * columnWidth / 5 - barMargin * 2;
          tplData.zIndex = 5 + packColumnIndex;
        } // Pack by default
        else {
          // Fractional width
          tplData.width = slotSize * availableWidth; // Translate to absolute position

          tplData.left += leftFactor * availableWidth + resourceMargin + barMargin * packColumnIndex;
        }
      }
    });
  }

}
VerticalLayout._$name = 'VerticalLayout';

/***/ }),

/***/ "./lib/Scheduler/feature/AbstractTimeRanges.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/AbstractTimeRanges.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractTimeRanges; });
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
var productName = 'gantt';












/**
 * @module Scheduler/feature/AbstractTimeRanges
 */

/**
 * Abstract base class, you should not use this class directly.
 * @abstract
 * @mixes Core/mixin/Delayable
 * @extends Core/mixin/InstancePlugin
 */

class AbstractTimeRanges extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      // CSS class to apply to range elements
      rangeCls: 'b-sch-range',
      // CSS class to apply to line elements (0-duration time range)
      lineCls: 'b-sch-line',

      /**
       * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
       * A store will be automatically created if none is specified
       * @config {Core.data.Store|Object}
       */
      store: {
        modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__["default"]
      },

      /**
       * Set to `true` to enable dragging and resizing of range elements in the header. Only relevant when {@link #config-showHeaderElements} is true.
       * @config {Boolean}
       * @defaultValue
       */
      enableResizing: false,

      /**
       * A Boolean specifying whether or not to show tooltip while resizing range elements, or a
       * {@link Core.widget.Tooltip} config object which is applied to the tooltip
       * @config {Boolean|Object}
       * @default
       */
      showTooltip: true,

      /**
       * `true` to render range elements into the time axis header
       * @config {Boolean}
       * @default
       */
      showHeaderElements: true,

      /**
       * Template used to generate the tooltip contents when hovering a time range header element.
       * ```
       * const scheduler = new Gantt({
       *   features : {
       *     timeRanges : {
       *       tooltipTemplate({ timeRange }) {
       *         return `${timeRange.name}`
       *       }
       *     }
       *   }
       * });
       * ```
       * @config {Function} tooltipTemplate
       * @param {Object} data Tooltip data
       * @param {Scheduler.model.TimeSpan} data.timeRange
       */
      tooltipTemplate: null,
      dragTipTemplate: data => `
                <div class="b-sch-tip-${data.valid ? 'valid' : 'invalid'}">
                    <div class="b-sch-tip-name">${data.name || ''}</div>
                    ${data.startClockHtml}
                    ${data.endClockHtml || ''}
                </div>
            `,
      baseCls: 'b-sch-timerange',
      // a unique cls used by subclasses to get custom styling of the elements rendered
      cls: '',
      narrowThreshold: 80
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onPaint', 'populateHeaderMenu', // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.
      'populateTimeAxisHeaderMenu']
    };
  } //endregion
  //region Init & destroy


  construct(client, config) {
    const me = this;
    super.construct(client, config);

    if (client.isVertical) {
      client.on({
        renderRows: me.onUIReady,
        thisObj: me,
        once: true
      });
    } // Add a unique cls used by subclasses to get custom styling of the elements rendered
    // This makes sure that each class only removed its own elements from the DOM


    me.cls = me.cls || `b-timerange-${me.constructor.$$name}`;
    me.baseSelector = `.${me.baseCls}.${me.cls}`; // header elements are required for interaction

    if (me.enableResizing) {
      me.showHeaderElements = true;
    }
  }

  doDestroy() {
    var _me$storeDetacher, _me$clockTemplate, _me$tip, _me$drag, _me$resize;

    const me = this;
    (_me$storeDetacher = me.storeDetacher) === null || _me$storeDetacher === void 0 ? void 0 : _me$storeDetacher.call(me);
    me.detachListeners('timeAxisViewModel');
    me.detachListeners('timeAxis');
    (_me$clockTemplate = me.clockTemplate) === null || _me$clockTemplate === void 0 ? void 0 : _me$clockTemplate.destroy();
    (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.destroy();
    (_me$drag = me.drag) === null || _me$drag === void 0 ? void 0 : _me$drag.destroy();
    (_me$resize = me.resize) === null || _me$resize === void 0 ? void 0 : _me$resize.destroy();
    super.doDestroy();
  }

  doDisable(disable) {
    if (this.client.isPainted) {
      this.renderRanges();
    }

    super.doDisable(disable);
  } //endregion
  //region Draw


  onPaint({
    firstPaint
  }) {
    if (firstPaint && this.client.isHorizontal) {
      this.onUIReady();
    }
  }

  onUIReady() {
    const me = this,
          {
      client
    } = me; // If timeAxisViewModel is swapped, re-setup listeners to new instance

    me.client.on({
      timeAxisViewModelChange: me.setupTimeAxisViewModelListeners,
      thisObj: me
    });
    me.setupTimeAxisViewModelListeners();

    if (me.enableResizing && !client.hideHeaders) {
      me.drag = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        name: 'rangeDrag',
        mode: client.isVertical ? 'translateY' : 'translateX',
        constrain: true,
        outerElement: me.headerContainerElement,
        targetSelector: `${me.baseSelector}`,
        isElementDraggable: (el, event) => !client.readOnly && me.isElementDraggable(el, event),
        transitionDuration: client.transitionDuration,
        listeners: {
          dragstart: 'onDragStart',
          drag: 'onDrag',
          drop: 'onDrop',
          abort: 'onInvalidDrop',
          thisObj: me
        }
      });
      me.resize = new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
        direction: client.mode,
        targetSelector: `${me.baseSelector}.b-sch-range`,
        outerElement: me.headerContainerElement,
        isElementResizable: el => !el.closest('.b-dragging'),
        listeners: {
          resizestart: 'onResizeStart',
          resizing: 'onResizeDrag',
          resize: 'onResize',
          cancel: 'onInvalidResize',
          thisObj: me
        }
      });
    }

    me.renderRanges();

    if (me.tooltipTemplate) {
      me.hoverTooltip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
        forElement: me.headerContainerElement,

        getHtml({
          activeTarget
        }) {
          const timeRange = me.getRecordByElement(activeTarget);
          return me.tooltipTemplate({
            timeRange
          });
        },

        forSelector: '.' + me.baseCls + (me.cls ? '.' + me.cls : '')
      });
    }
  }

  setupTimeAxisViewModelListeners() {
    const me = this;
    me.detachListeners('timeAxisViewModel');
    me.detachListeners('timeAxis');
    me.client.timeAxisViewModel.on({
      name: 'timeAxisViewModel',
      update: 'onTimeAxisViewModelUpdate',
      thisObj: me
    });
    me.client.timeAxis.on({
      name: 'timeAxis',
      includeChange: 'renderRanges',
      thisObj: me
    });
  }

  onTimeAxisViewModelUpdate() {
    this.renderRanges();
  }

  renderRanges() {
    const me = this,
          element = me.client.foregroundCanvas; // Scheduler/Gantt might not yet be rendered

    if (element) {
      const {
        headerContainerElement
      } = me; // remove existing timeRanges

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeEachSelector(element, me.baseSelector); // Partnered Scheduler might not have header container element

      if (headerContainerElement) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeEachSelector(headerContainerElement, me.baseSelector);
      }

      if (!me.disabled) {
        const timeRanges = [],
              bodyEls = [],
              headerEls = []; // clear label rotation map cache here
        // cache is used to prevent height calcs for every timeRange entry to speed up adding of recurrences

        me._timeRangesRotationMapCache = {};

        for (const range of me.timeRanges) {
          const result = me.renderRange(range, false);

          if (result) {
            const {
              bodyElement,
              headerElement
            } = result; // collect elements to append all at once

            bodyEls.push(bodyElement);
            headerEls.push(headerElement);
            timeRanges.push({
              elements: {
                bodyElement,
                headerElement
              },
              range
            });
          }
        } // use DomHelper to add elements via documentFragment


        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].append(me.client.foregroundCanvas, bodyEls); // Showing header elements, they do not rotate labels

        if (me.showHeaderElements) {
          headerContainerElement && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].append(headerContainerElement, headerEls);
        } // No header elements, we might need to rotate labels
        else {
          // rotateLabel should be done after adding elements because it checks sizes of elements
          // that is too heavy to do in a loop with DOM updates
          for (const {
            elements,
            range
          } of timeRanges) {
            // check if dom exists, it may be undefined if nothing changed in renderRange()
            elements && me.calculateRotateLabelMap(range, elements);
          }

          for (const {
            elements,
            range
          } of timeRanges) {
            // check if dom exists, it may be undefined if nothing changed in renderRange()
            elements && me.rotateLabel(range, elements);
          }
        }
      }
    }
  }
  /**
   * Returns the TimeRanges in the store.
   * @property {Scheduler.model.TimeSpan[]}
   */


  get timeRanges() {
    return this.store.records;
  }
  /**
   * Based on this method result the feature decides whether the provided range should
   * be rendered or not.
   * The method checks that the range has non-zero {@link Scheduler.model.TimeSpan#field-duration}
   * and lays in the visible timespan.
   *
   * Override the method to implement your custom range rendering vetoing logic.
   * @param {Scheduler.model.TimeSpan} range Range to render.
   * @returns {Boolean} `true` if the range should be rendered and `false` otherwise.
   */


  shouldRenderRange(range) {
    const {
      timeAxis
    } = this.client;
    return range.duration && timeAxis.timeSpanInAxis(range.startDate, range.endDate) || range.startDate && timeAxis.dateInAxis(range.startDate);
  }

  renderRange(timeRange, injectIntoDom) {
    const me = this,
          {
      client
    } = me;

    if (me.shouldRenderRange(timeRange)) {
      const startPos = client.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].max(timeRange.startDate, client.timeAxis.startDate), {
        respectExclusion: true
      }),
            endPos = timeRange.duration && client.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].min(timeRange.endDate, client.timeAxis.endDate), {
        respectExclusion: true,
        isEnd: true
      }),
            size = endPos - startPos,
            icon = timeRange.iconCls && `<i class="${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].encodeHtml(timeRange.iconCls)}"></i>`,
            name = timeRange.name && _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].encodeHtml(timeRange.name),
            labelTpl = name || icon ? `<label>${icon || ''}${name || '&nbsp;'}</label>` : '',
            config = {
        className: {
          [me.baseCls]: 1,
          [me.cls]: me.cls,
          [me.rangeCls]: endPos,
          [me.lineCls]: !endPos,
          [timeRange.cls]: timeRange.cls,
          'b-narrow-range': endPos && size < me.narrowThreshold
        },
        //`${me.baseCls} ${me.cls} ${endPos ? me.rangeCls : me.lineCls} ${range.cls || ''}`,
        dataset: {
          id: timeRange.id
        },
        style: client.isVertical ? `transform: translateY(${startPos}px); ${endPos ? `height:${size}px` : ''};` : `transform: translateX(${startPos}px); ${endPos ? `width:${size}px` : ''};`,
        retainElement: true // To prevent DomHelper.sync from reusing the element

      },
            bodyElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement(Object.assign({}, config, {
        parent: injectIntoDom && client.foregroundCanvas,
        style: config.style + (timeRange.style || ''),
        html: me.showHeaderElements && !me.showLabelInBody ? '' : labelTpl
      }));
      let headerElement;

      if (me.showHeaderElements) {
        headerElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement(Object.assign({
          parent: injectIntoDom && me.headerContainerElement,
          html: !me.showLabelInBody ? labelTpl : ''
        }, config));
      }

      return {
        bodyElement,
        headerElement
      };
    }
  } // Cache label rotation to not have to calculate for each occurrence when using recurring timeranges


  calculateRotateLabelMap(range, {
    bodyElement
  }) {
    // Lines have no label. Do not check label content to do not force DOM layout!
    if (!range.iconCls && !range.name || !range.duration) {
      return;
    }

    const label = bodyElement.firstChild; // Check if label is rendered

    if (!label) {
      return;
    }

    const isOccurrence = Boolean(range.recurringTimeSpan);
    let rotate;

    if (isOccurrence) {
      rotate = this._timeRangesRotationMapCache[range.recurringTimeSpan.id];
    } else {
      rotate = this.client.isVertical ? label.offsetHeight < bodyElement.offsetHeight : label.offsetWidth > bodyElement.offsetWidth;
      this._timeRangesRotationMapCache[range.id] = rotate;
    }

    return rotate;
  }

  rotateLabel(range, {
    bodyElement
  }) {
    var _bodyElement$firstChi;

    // Lines have no label. Do not check label content to do not force DOM layout!
    if (!range.iconCls && !range.name || !range.duration) {
      return;
    }

    const isOccurrence = Boolean(range.recurringTimeSpan),
          rotate = this._timeRangesRotationMapCache[isOccurrence ? range.recurringTimeSpan.id : range.id]; // If it overflows, rotate it or remove rotation class

    (_bodyElement$firstChi = bodyElement.firstChild) === null || _bodyElement$firstChi === void 0 ? void 0 : _bodyElement$firstChi.classList.toggle('b-vertical', rotate);
  } // returns one body el (+ optionally one header el) that represents a time range, or null if timeRanges is not currently rendered


  getElementsByRecord(idOrRecord) {
    var _me$client$foreground, _me$headerContainerEl;

    const me = this,
          id = typeof idOrRecord !== 'object' ? idOrRecord : idOrRecord.id,
          bodyElement = (_me$client$foreground = me.client.foregroundCanvas) === null || _me$client$foreground === void 0 ? void 0 : _me$client$foreground.querySelector(`${me.baseSelector}[data-id="${id}"]`),
          headerElement = (_me$headerContainerEl = me.headerContainerElement) === null || _me$headerContainerEl === void 0 ? void 0 : _me$headerContainerEl.querySelector(`${me.baseSelector}[data-id="${id}"]`);
    return bodyElement ? {
      bodyElement,
      headerElement
    } : null;
  }

  getBodyElementByRecord(idOrRecord) {
    const id = typeof idOrRecord === 'string' ? idOrRecord : idOrRecord.id;
    return this.client.foregroundCanvas.querySelector(`${this.baseSelector}[data-id="${id}"]`);
  }

  getRecordByElement(el) {
    return this.store.getById(el.dataset.id);
  }

  get headerContainerElement() {
    const {
      isVertical,
      timeView,
      timeAxisColumn
    } = this.client;
    let element = null; // Render into the subGrid´s header element or the vertical timeaxis depending on mode

    if (isVertical && timeView.element) {
      element = timeView.element.parentElement;
    } else if (!isVertical) {
      element = timeAxisColumn.element;
    }

    return element;
  } //endregion
  //region Settings

  /**
   * Get/set if header elements should be rendered
   * @property {Boolean}
   */


  get showHeaderElements() {
    return !this.client.hideHeaders && this._showHeaderElements;
  }

  set showHeaderElements(show) {
    this._showHeaderElements = show;
    if (!this.client.isPainted) return;

    if (show) {
      this.client.element.classList.add('b-sch-timeranges-with-headerelements');
    } else {
      this.client.element.classList.remove('b-sch-timeranges-with-headerelements');
    }

    this.renderRanges();
  } //endregion
  //region Menu items
  // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.

  /**
   * Adds menu items for the context menu.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead.
   */


  populateHeaderMenu({
    column,
    items
  }) {
    if (column.type !== 'timeAxis') {
      return;
    }

    this.populateTimeAxisHeaderMenu(...arguments);
  }
  /**
   * Adds menu items for the context menu, and may mutate the menu configuration.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateTimeAxisHeaderMenu({
    column,
    items
  }) {} //endregion
  //region Store


  attachToStore(store) {
    const me = this;
    let renderRanges = false; // if we had some store assigned before we need to detach it

    if (me.storeDetacher) {
      me.storeDetacher(); // then we'll need to render ranges provided by the new store

      renderRanges = true;
    }

    me.storeDetacher = store.on({
      change: 'onStoreChanged',
      refresh: 'onStoreChanged',
      thisObj: me
    }); // render ranges if needed

    renderRanges && me.renderRanges();
  }
  /**
   * Returns the {@link Core.data.Store store} used by this feature
   * @property {Core.data.Store}
   */


  get store() {
    return this._store;
  }

  set store(store) {
    this._store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(store, _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]);
    this.attachToStore(this._store);
  } //endregion
  //region Events


  onStoreChanged(event) {
    const me = this; // https://github.com/bryntum/support/issues/1398 - checking also if scheduler is visible to change elements

    if (me.disabled || !me.client.isVisible || me.isConfiguring || event.type === 'refresh' && event.action !== 'batch') {
      return;
    } // Only animate changes that happen as a result of a pure data change, i.e. not after a drag drop


    if (event.action === 'update') {
      const range = event.record,
            id = event.changes.hasOwnProperty('id') ? event.changes.id.oldValue : range.id,
            existingElements = me.getElementsByRecord(id),
            redrawnElements = me.renderRange(range, !existingElements);

      if (existingElements && !redrawnElements) {
        existingElements.bodyElement.remove();
        existingElements.headerElement && existingElements.headerElement.remove();
      }

      if (!existingElements || !redrawnElements) return;
      me.client.runWithTransition(() => {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(redrawnElements.bodyElement, existingElements.bodyElement);

        if (me.showHeaderElements) {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(redrawnElements.headerElement, existingElements.headerElement);
        } else {
          // Make the label run vertically if it overflows the width
          me.rotateLabel(range, existingElements);
        }
      });
    } else {
      me.renderRanges();
    }
  } //endregion
  //region Drag drop


  showTip(context) {
    const me = this;

    if (me.showTooltip) {
      me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
        scheduler: me.client
      });
      me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_9__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assign({
        id: `${me.client.id}-time-range-tip`,
        cls: 'b-interaction-tooltip',
        align: 'b-t',
        autoShow: true,
        updateContentOnMouseMove: true,
        forElement: context.element,
        getHtml: () => me.getTipHtml(context.record, context.element)
      }, me.showTooltip));
    }
  }

  isElementDraggable(el) {
    el = el.closest(this.baseSelector + ':not(.b-resizing)');
    return el && !el.classList.contains('b-over-resize-handle');
  }

  onDragStart({
    context
  }) {
    const me = this,
          record = me.getRecordByElement(context.element.closest(me.baseSelector)),
          rangeBodyEl = me.getBodyElementByRecord(record),
          timeAxisViewModel = me.client.timeAxisViewModel,
          drag = me.drag;
    Object.assign(context, {
      record,
      rangeBodyEl,
      originRangeX: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getTranslateX(rangeBodyEl),
      originRangeY: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getTranslateY(rangeBodyEl)
    });

    if (me.client.isVertical) {
      drag.minY = 0; // Moving the range, you can drag the start marker down until the end of the range hits the time axis end

      drag.maxY = timeAxisViewModel.totalSize - context.rangeBodyEl.offsetHeight; // Setting min/max for X makes drag right of the header valid, but visually still constrained vertically

      drag.minX = 0;
      drag.maxX = Number.MAX_SAFE_INTEGER;
    } else {
      drag.minX = 0; // Moving the range, you can drag the start marker right until the end of the range hits the time axis end

      drag.maxX = timeAxisViewModel.totalSize - context.rangeBodyEl.offsetWidth; // Setting min/max for Y makes drag below header valid, but visually still constrained horizontally

      drag.minY = 0;
      drag.maxY = Number.MAX_SAFE_INTEGER;
    }

    me.client.element.classList.add('b-dragging-timerange');
    me.showTip(context);
  }

  onDrag({
    context
  }) {
    // sync body element with header element (x + width)
    if (this.client.isVertical) {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateY(context.rangeBodyEl, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getTranslateY(context.element));
    } else {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateX(context.rangeBodyEl, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getTranslateX(context.element));
    }
  }

  onDrop({
    context
  }) {
    if (!context.valid) {
      return this.onInvalidDrop({
        context
      });
    }

    const me = this,
          record = context.record,
          box = context.rangeBodyEl.getBoundingClientRect(),
          newStart = me.client.getDateFromCoordinate(me.client.isVertical ? box.top : box.left, 'round', false),
          wasModified = record.startDate - newStart !== 0;

    if (wasModified) {
      record.setStartDate(newStart);
    } else {
      me.onInvalidDrop();
    }

    if (me.tip) {
      me.tip.destroy();
      me.tip = null;
    }

    me.client.element.classList.remove('b-dragging-timerange');
  }

  onInvalidDrop() {
    const me = this;
    me.drag.reset();
    me.renderRanges();
    me.client.element.classList.remove('b-dragging-timerange');

    if (me.tip) {
      me.tip.destroy();
      me.tip = null;
    }
  } // endregion
  // region Resize


  onResizeStart({
    context
  }) {
    const me = this,
          record = me.getRecordByElement(context.element.closest(me.baseSelector)),
          rangeBodyEl = me.getBodyElementByRecord(record);
    Object.assign(context, {
      record,
      rangeBodyEl
    });
    me.showTip(context);
  }

  onResizeDrag({
    context
  }) {
    const me = this;

    if (me.client.isVertical) {
      if (context.edge === 'top') {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateY(context.rangeBodyEl, context.newY);
      }

      context.rangeBodyEl.style.height = context.newHeight + 'px';
    } else {
      if (context.edge === 'left') {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateX(context.rangeBodyEl, context.newX);
      }

      context.rangeBodyEl.style.width = context.newWidth + 'px';
    }
  }

  onResize({
    context
  }) {
    if (!context.valid) return this.onInvalidDrop({
      context
    });
    const me = this,
          {
      client
    } = me,
          record = context.record,
          box = context.element.getBoundingClientRect(),
          startPos = client.isVertical ? box.top : box.left,
          endPos = client.isVertical ? box.bottom : box.right,
          newStart = client.getDateFromCoordinate(startPos, 'round', false),
          isStart = context.edge === 'left' || context.edge === 'top',
          newEnd = client.getDateFromCoordinate(endPos, 'round', false),
          wasModified = isStart && record.startDate - newStart !== 0 || newEnd && record.endDate - newEnd !== 0;

    if (wasModified && newEnd > newStart) {
      if (isStart) {
        // could be that the drag operation placed the range with start/end outside the axis
        record.setStartDate(newStart, false);
      } else {
        record.setEndDate(newEnd, false);
      }
    } else {
      me.onInvalidResize();
    }

    if (me.tip) {
      me.tip.destroy();
      me.tip = null;
    }
  }

  onInvalidResize() {
    const me = this;
    me.resize.reset();
    me.renderRanges();

    if (me.tip) {
      me.tip.destroy();
      me.tip = null;
    }
  } //endregion
  //region Tooltip

  /**
   * Generates the html to display in the tooltip during drag drop.
   */


  getTipHtml(record, element) {
    const me = this,
          {
      client
    } = me,
          box = element.getBoundingClientRect(),
          startPos = client.isVertical ? box.top : box.left,
          endPos = client.isVertical ? box.bottom : box.right,
          startDate = client.getDateFromCoordinate(startPos, 'round', false),
          endDate = record.endDate && client.getDateFromCoordinate(endPos, 'round', false),
          startText = client.getFormattedDate(startDate),
          endText = endDate && client.getFormattedEndDate(endDate, startDate);
    return me.dragTipTemplate({
      name: record.name || '',
      startDate: startDate,
      endDate: endDate,
      startText: startText,
      endText: endText,
      startClockHtml: me.clockTemplate.template({
        date: startDate,
        text: startText,
        cls: 'b-sch-tooltip-startdate'
      }),
      endClockHtml: endText && me.clockTemplate.template({
        date: endDate,
        text: endText,
        cls: 'b-sch-tooltip-enddate'
      })
    });
  } //endregion


}
AbstractTimeRanges._$name = 'AbstractTimeRanges';

/***/ }),

/***/ "./lib/Scheduler/feature/ColumnLines.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/ColumnLines.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnLines; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';





/**
 * @module Scheduler/feature/ColumnLines
 */

const emptyObject = Object.freeze({});
/**
 * Displays column lines for ticks, with a different styling for major ticks (by default they are darker). If this
 * feature is disabled, no lines are shown. If it's enabled, line are shown for the tick level which is set in current
 * ViewPreset. Please see {@link Scheduler.preset.ViewPreset#field-columnLinesFor} config for details.
 *
 * The lines are drawn as divs, with only visible lines available in DOM. The color and style of the lines are
 * determined the css rules for `.b-column-line` and `.b-column-line-major`.
 *
 * For vertical mode, this features also draws vertical resource column lines if scheduler is configured with
 * `columnLines : true` (which is the default, see {@link Grid.view.GridBase#config-columnLines}).
 *
 * This feature is **enabled** by default
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/ColumnLines.js
 * @classtype columnLines
 * @feature
 */

class ColumnLines extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'ColumnLines';
  }

  static get delayable() {
    return {
      refresh: {
        type: 'raf',
        cancelOutstanding: true
      }
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      after: ['render', 'updateCanvasSize', 'onVisibleDateRangeChange', 'onVisibleResourceRangeChange']
    };
  } //endregion
  //region Init & destroy


  construct(client, config) {
    client.useBackgroundCanvas = true;
    super.construct(client, config);
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (!this.isConfiguring) {
      this.refresh();
    }
  } //endregion
  //region Draw

  /**
   * Draw lines when scheduler/gantt is rendered.
   * @private
   */


  render() {
    this.refresh();
  }
  /**
   * Draw column lines that are in view
   * @private
   */


  refresh() {
    const me = this,
          {
      client
    } = me,
          {
      timeAxis,
      timeAxisViewModel,
      isHorizontal
    } = client,
          {
      columnConfig
    } = timeAxisViewModel,
          {
      startDate,
      endDate
    } = client.visibleDateRange || emptyObject,
          axisStart = timeAxis.startDate; // Early bailout for timeaxis without start date

    if (!axisStart || !startDate) {
      return;
    }

    const linesForLevel = timeAxisViewModel.columnLinesFor,
          majorLinesForLevel = Math.max(linesForLevel - 1, 0),
          start = startDate.getTime(),
          end = endDate.getTime(),
          domConfigs = [],
          dates = new Set(),
          dimension = isHorizontal ? 'X' : 'Y';

    if (!me.element) {
      me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: client.backgroundCanvas,
        className: 'b-column-lines-canvas'
      });
    }

    if (!me.disabled) {
      const addLineConfig = (tick, isMajor) => {
        const tickStart = tick.start.getTime(); // Only start of tick matters.
        // Each tick has an exact calculated start position along the time axis
        // and carries a border on its left, so column lines follow from
        // tick 1 (zero-based) onwards.

        if (tickStart > start && tickStart < end && !dates.has(tickStart)) {
          dates.add(tickStart);
          domConfigs.push({
            className: isMajor ? 'b-column-line-major' : 'b-column-line',
            style: {
              transform: `translate${dimension}(${tick.coord}px)`
            },
            dataset: {
              line: isMajor ? `major-${tick.index}` : `line-${tick.index}`
            }
          });
        }
      }; // Collect configs for major lines


      if (linesForLevel !== majorLinesForLevel) {
        for (let i = 1; i <= columnConfig[majorLinesForLevel].length - 1; i++) {
          addLineConfig(columnConfig[majorLinesForLevel][i], true);
        }
      } // And normal lines, skipping dates already occupied by major lines


      for (let i = 1; i <= columnConfig[linesForLevel].length - 1; i++) {
        addLineConfig(columnConfig[linesForLevel][i], false);
      } // Add vertical resource column lines, if grid is configured to show column lines


      if (!isHorizontal && client.columnLines) {
        const {
          columnWidth,
          firstResource,
          lastResource
        } = client.resourceColumns;

        for (let i = firstResource; i < lastResource + 1; i++) {
          domConfigs.push({
            className: 'b-column-line b-resource-column-line',
            style: {
              transform: `translateX(${(i + 1) * columnWidth - 1}px)`
            },
            dataset: {
              line: `resource-${i}`
            }
          });
        }
      }
    }

    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].sync({
      targetElement: me.element,
      onlyChildren: true,
      domConfig: {
        children: domConfigs,
        syncOptions: {
          // When zooming in and out we risk getting a lot of released lines if we do not limit it
          releaseThreshold: 4
        }
      },
      syncIdField: 'line'
    });
  } //endregion
  //region Events
  // Called when visible date range changes, for example from zooming, scrolling, resizing


  onVisibleDateRangeChange() {
    this.refresh();
  } // Called when visible resource range changes, for example on scroll and resize


  onVisibleResourceRangeChange({
    firstResource,
    lastResource
  }) {
    this.refresh();
  }

  updateCanvasSize() {
    this.refresh();
  } //endregion


}
ColumnLines._$name = 'ColumnLines';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(ColumnLines, true, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/Dependencies.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/Dependencies.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dependencies; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/DependencyCreation.js */ "./lib/Scheduler/feature/mixin/DependencyCreation.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../util/RectangularPathFinder.js */ "./lib/Scheduler/util/RectangularPathFinder.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
var productName = 'gantt';














/**
 * @module Scheduler/feature/Dependencies
 */

const resourceRefreshAllActions = {
  add: 1,
  dataset: 1,
  remove: 1,
  removeAll: 1
},
      fromBoxSide = ['left', 'left', 'right', 'right'],
      toBoxSide = ['left', 'right', 'left', 'right'];
/**
 * Feature that draws dependencies between events Uses a {@link Scheduler.data.DependencyStore DependencyStore} to
 * determine which dependencies to draw, if none is defined one will be created automatically. Dependencies can also be
 * specified as Scheduler#dependencies, see example below.
 *
 * **Note**: In case milestone elements have `iconCls` defined dependency feature will refer to the DOM to get exact
 * element size which might slightly decrease the performance.
 *
 * To customize the dependency tooltip, you can provide the {@link #config-tooltip} config and specify a {@link Core.widget.Tooltip#config-getHtml} function.
 * For example:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         dependencies : {
 *             tooltip : {
 *                 getHtml({ activeTarget }) {
 *                     const dependencyModel = scheduler.resolveDependencyRecord(activeTarget);
 *
 *                     if (!dependencyModel) return null;
 *
 *                     const { fromEvent, toEvent } = dependencyModel;
 *
 *                     return `${fromEvent.name} (${fromEvent.id}) -> ${toEvent.name} (${toEvent.id})`;
 *                 }
 *             }
 *         }
 *     }
 * }
 * ```
 *
 * This feature is **off** by default. It is **not** supported in vertical mode.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @mixes Core/mixin/Delayable
 * @mixes Scheduler/feature/mixin/DependencyCreation
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/dependencies
 * @inlineexample Scheduler/feature/Dependencies.js
 * @classtype dependencies
 * @feature
 */

class Dependencies extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_5__["default"].mixin(_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_9__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_13__["default"], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_12__["default"]) {
  /**
   * Fired when dependencies are rendered
   * @event dependenciesDrawn
   * @param {Boolean} [partial] Optional event parameter. `true` when subset of dependencies is repainted, omitted
   * when all lines were repainted.
   */
  //region Config
  static get $name() {
    return 'Dependencies';
  }

  static get defaultConfig() {
    return {
      /**
       * Path finder instance configuration
       * @config {Object}
       */
      pathFinderConfig: null,

      /**
       * The CSS class to add to a dependency line when hovering over it
       * @config {String}
       * @default
       * @private
       */
      overCls: 'b-sch-dependency-over',

      /**
       * The CSS class applied to dependency lines
       * @config {String}
       * @default
       * @private
       */
      baseCls: 'b-sch-dependency',

      /**
       * The CSS class applied to the too narrow dependency line
       * @config {String}
       * @default
       * @private
       */
      noMarkerCls: 'b-sch-dependency-markerless',
      highlightDependenciesOnEventHover: false,

      /**
       * Set to true to show a tooltip when hovering a dependency line
       * @config {Boolean}
       */
      showTooltip: true,

      /**
       * A tooltip config object that will be applied to the dependency hover tooltip. Can be used to for example
       * customize delay
       * @config {Object}
       */
      tooltip: null,
      bufferSize: 50,
      // Used to determine the size of the cells in the virtual grid used to cache intersecting dependencies
      cacheGridSize: {
        // the width of an intersection cell expressed in timeaxis ticks
        ticks: 25,
        // the height of an intersection cell express in amount of rows
        // (could be named rows, but that wont match if we add support for vertical mode)
        index: 25
      }
    };
  }

  static get properties() {
    return {
      toDrawOnProjectRefresh: new Set(),
      dependenciesToRefresh: new Map(),
      drawnDependencies: [],
      drawnLines: []
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['render', 'renderContents', 'onElementClick', 'onElementDblClick', 'onElementMouseOver', 'onElementMouseOut', 'onProjectRefresh'],
      assign: ['getElementForDependency', 'getElementsForDependency', 'resolveDependencyRecord']
    };
  } //endregion
  //region Init & destroy


  construct(scheduler, config = {}) {
    const me = this;

    if (scheduler.isVertical) {
      throw new Error('Dependencies feature is not supported in vertical mode');
    } // Many things may schedule a draw. Ensure it only happens once, on the next frame.
    // And Ensure it really is on the *next* frame after invocation by passing
    // the cancelOutstanding flag.


    me.doScheduleDraw = me.createOnFrame('draw', [], me, true);
    super.construct(scheduler, config);
    me.pathFinder = new _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_11__["default"](me.pathFinderConfig);
    delete me.pathFinderConfig;
    me.lineDefAdjusters = me.createLineDefAdjusters();
    scheduler.rowManager.on({
      refresh: 'onRefresh',
      thisObj: me
    });
  }

  attachToProject(project) {
    this.detachListeners('dependencyDataReady');
    project.on({
      name: 'dependencyDataReady',
      dataReady: this.onRefresh,
      thisObj: this
    });
    super.attachToProject(project);
  }

  doDestroy() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.destroy();
    super.doDestroy();
  }

  doDisable(disable) {
    const me = this,
          {
      project
    } = me;
    me.updateCreateListeners(); // detach/attach store listeners

    if (project || disable) {
      me.attachToResourceStore(disable ? null : project.resourceStore);
      me.attachToEventStore(disable ? null : project.eventStore);
      me.attachToAssignmentStore(disable ? null : project.assignmentStore);
      me.attachToDependencyStore(disable ? null : project.dependencyStore);
    }

    if (me.client.isPainted) {
      // draw() needs "me.dependencyStore" to be provided
      me.draw();
    }

    super.doDisable(disable);
  } //endregion
  //region Dependency types


  static getLocalizedDependencyType(type) {
    // Do not remove. Assertion strings for Localization sanity check.
    // 'L{DependencyType.SS}'
    // 'L{DependencyType.SF}'
    // 'L{DependencyType.FS}'
    // 'L{DependencyType.FF}'
    // 'L{DependencyType.StartToStart}'
    // 'L{DependencyType.StartToEnd}'
    // 'L{DependencyType.EndToStart}'
    // 'L{DependencyType.EndToEnd}'
    // 'L{DependencyType.long}'
    // 'L{DependencyType.short}'
    return type ? this.L(`L{DependencyType.${type}}`) : '';
  }

  findDependencyIndex(dependencies = [], dependency, assignmentData) {
    return dependencies.findIndex(item => item.dependency === dependency && (item.assignmentData === assignmentData || item.assignmentData && assignmentData && item.assignmentData.from === assignmentData.from && item.assignmentData.to === assignmentData.to));
  }

  includesDependency() {
    return this.findDependencyIndex(...arguments) >= 0;
  } //endregion
  //region Stores


  attachToResourceStore(store) {
    super.attachToResourceStore(store);

    if (store && !this.disabled) {
      store.on({
        name: 'resourceStore',
        changePreCommit: 'onResourceStoreChange',
        refreshPreCommit: 'onResourceStoreRefresh',
        thisObj: this
      });
    }
  }

  attachToDependencyStore(store) {
    const me = this;
    super.attachToDependencyStore(store); // When assigning a new store there is no point in keeping anything cached

    me.resetGridCache();
    me.resetBoundsCache();

    if (store && !me.disabled) {
      // TODO: This is rather doubtful code, investigate it
      // used to store meta per scheduler on models, in case they are used in multiple schedulers
      store.metaMapId = me.client.id;
      store.on({
        name: 'dependencyStore',
        changePreCommit: 'onDependencyChange',
        idChange: 'onDependencyIdChange',
        thisObj: me
      });
    }
  }

  attachToAssignmentStore(store) {
    super.attachToAssignmentStore(store);

    if (store && !this.disabled) {
      store.on({
        name: 'assignmentStore',
        changePreCommit: 'onAssignmentChange',
        refreshPreCommit: 'onAssignmentRefresh',
        thisObj: this
      });
    }
  }

  attachToEventStore(store) {
    super.attachToEventStore(store);

    if (store && !this.disabled) {
      store.on({
        name: 'eventStore',
        changePreCommit: 'onEventChange',
        batchedUpdate: 'onEventBatchedUpdate',
        thisObj: this
      });
    }
  } //endregion
  //region Markers


  createMarkers() {
    const me = this,
          svg = me.client.svgCanvas,
          endMarker = me.endMarker = me.initMarkerElement('arrowEnd', '8', 'M0,0 L0,6 L9,3 z');
    endMarker.setAttribute('orient', 'auto-start-reverse');
    svg.appendChild(endMarker);
  }
  /**
   * Creates SVG marker element (arrow) which is used for all dependency lines
   * @private
   * @param {String} id Id of the marker element
   * @param {String} refX
   * @param {String} arrowPath Path defining arrow
   */


  initMarkerElement(id, refX, arrowPath) {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
      id,
      tag: 'marker',
      className: 'b-sch-dependency-arrow',
      ns: 'http://www.w3.org/2000/svg',
      markerHeight: 11,
      markerWidth: 11,
      refX,
      refY: 3,
      viewBox: '0 0 9 6',
      orient: 'auto',
      markerUnits: 'userSpaceOnUse',
      children: [{
        tag: 'path',
        ns: 'http://www.w3.org/2000/svg',
        d: arrowPath
      }]
    });
  }
  /**
   * Returns an array of functions used to alter path config when no path found.
   * It first tries to shrink arrow margins and secondly hides arrows entirely
   * @private
   * @returns {Function[]}
   */


  createLineDefAdjusters() {
    const scheduler = this.client;

    function shrinkArrowMargins(lineDef) {
      let adjusted = false;

      if (lineDef.startArrowMargin > scheduler.barMargin || lineDef.endArrowMargin > scheduler.barMargin) {
        lineDef.startArrowMargin = lineDef.endArrowMargin = scheduler.barMargin;
        adjusted = true;
      }

      return adjusted ? lineDef : adjusted;
    }

    function resetArrowMargins(lineDef) {
      let adjusted = false;

      if (lineDef.startArrowMargin > 0 || lineDef.endArrowMargin > 0) {
        lineDef.startArrowMargin = lineDef.endArrowMargin = 0;
        adjusted = true;
      }

      return adjusted ? lineDef : adjusted;
    }

    function shrinkHorizontalMargin(lineDef, originalLineDef) {
      let adjusted = false;

      if (lineDef.horizontalMargin > 2) {
        lineDef.horizontalMargin = 1;
        adjusted = true;
        originalLineDef.hideMarker = true;
      }

      return adjusted ? lineDef : adjusted;
    }

    return [shrinkArrowMargins, resetArrowMargins, shrinkHorizontalMargin];
  } //endregion
  //region Elements


  getElementForDependency(dependency, assignmentData = null) {
    return this.getElementsForDependency(dependency, assignmentData)[0];
  }

  getElementsForDependency(dependency, assignmentData = null) {
    // Selector targeting all instances of a dependency
    let selector = `[depId="${dependency.id}"]`; // Optionally narrow it down to a single instance (assignment)

    if (assignmentData) {
      selector += `[fromId="${assignmentData.from.id}"][toId="${assignmentData.to.id}"]`;
    }

    return Array.from(this.client.svgCanvas.querySelectorAll(selector));
  }
  /**
   * Returns the dependency record for a DOM element
   * @param {HTMLElement} element The dependency line element
   * @return {Scheduler.model.DependencyModel} The dependency record
   */


  resolveDependencyRecord(element) {
    // getAttribute return a string or null
    const id = typeof element === 'string' ? element : element.getAttribute('depId');
    return id ? this.dependencyStore.getById(id) : null;
  } //endregion
  //region Events
  //region Events that triggers redraw
  // Refresh dependencies when grid is refreshed


  onRefresh() {
    if (this.client.isEngineReady) {
      this.onProjectRefresh();
    }
  }

  onProjectRefresh() {
    var _me$client;

    const me = this,
          {
      toDrawOnProjectRefresh
    } = me;

    if (!((_me$client = me.client) !== null && _me$client !== void 0 && _me$client.refreshSuspended)) {
      // Mainly for operations involving rows, adding or removing invalidates all resources
      if (me.refreshAllWhenReady) {
        me.resetGridCache();
        me.scheduleDraw(true);
        me.refreshAllWhenReady = false;
      } else if ((toDrawOnProjectRefresh === null || toDrawOnProjectRefresh === void 0 ? void 0 : toDrawOnProjectRefresh.size) > 0) {
        // Check if there is a cache exists. If it does - use it,
        // if not - create one after all records are drawn, this will cache all existing records
        const cache = me._dependencyGridCache;
        cache && toDrawOnProjectRefresh.forEach(dependency => {
          // Previously this code would draw added dependencies here, no matter if in view or not. To not have
          // to have the logic for determining whats in view or not here also, simply do a full draw below.
          // Old approach was especially costly when using CrudManager, which adds on load
          me.addToGridCache(dependency);
        });

        if (!cache) {
          me._thisIsAUsedExpression(me.dependencyGridCache);
        }

        toDrawOnProjectRefresh.clear();
        me.scheduleDraw();
      }
    }
  }

  onToggleNode() {
    // Need to repopulate grid cache
    this.resetGridCache(); // node toggled in tree, can affect resources both above and below, need to redraw all.

    this.scheduleDraw(true);
  }

  onViewportResize() {
    // More or fewer dependencies might be in view, but their locations has not changed so no need to invalidate
    // grid cache
    this.scheduleDraw(true);
  }
  /**
   * Flags for redrawing if a rows height has changed
   * @private
   */


  onTranslateRow({
    row
  }) {
    // a changetotalheight event is fired after translations, if a rowHeight change is detected here it will redraw
    // all dependencies
    if (row.lastTop >= 0 && row.top !== row.lastTop) {
      this.scheduleDraw(true);
    }
  }
  /**
   * Redraws all dependencies if a rows height changed, as detected in onTranslateRow
   * @private
   */


  onChangeTotalHeight() {
    if (this.client.isEngineReady) {
      // redraw all dependencies if the height changes. Could be caused by resource add/remove.
      // in reality not all deps needs to be redrawn, those fully above the row which changed height could be left
      // as is, but determining that would likely require more processing than redrawing
      this.scheduleDraw(true);
    }
  }
  /**
   * Draws dependencies on horizontal scroll
   * @private
   */


  onHorizontalScroll({
    subGrid
  }) {
    // ResizeMonitor triggers scroll during render, make sure we have been drawn some other way before redrawing
    if (this.isDrawn && subGrid === this.client.timeAxisSubGrid) {
      this.scheduleDraw(false);
    }
  }
  /**
   * Draws dependencies on vertical scroll
   * @private
   */


  onVerticalScroll() {
    // ResizeMonitor triggers scroll during render, make sure render is done
    if (this.isDrawn) {
      // Do not invalidate on scroll, if height changes it will be invalidated anyway
      this.scheduleDraw(false);
    }
  }

  onRowsRefresh() {
    this.scheduleDraw(true);
  }

  onResourceStoreChange({
    action
  }) {
    // bail out in case we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener
    if (this.client.project.propagatingLoadChanges) {
      return;
    } // Adding/removing resources affects all dependencies that intersect or are fully below the resources.
    // Instead of determining which those are, do a full redraw when project have been recalculated


    if (resourceRefreshAllActions[action]) {
      this.refreshAllWhenReady = true;
    }
  }
  /**
   * Redraws dependencies when a row has changed
   * @private
   */


  onResourceStoreRefresh({
    action
  }) {
    // bail out in case we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener
    if (this.client.project.propagatingLoadChanges) {
      return;
    }

    switch (action) {
      case 'sort':
      case 'filter':
      case 'batch':
        // Will need to recreate grid cache after sort, filter, and any unspecified
        // set of operations encapsulated by a batch, and redraw everything
        this.resetGridCache();
        this.scheduleDraw(true);
    }
  }
  /**
   * Redraws dependencies when a dependency has changed
   * @private
   */


  async onDependencyChange({
    action,
    record,
    records
  }) {
    const me = this,
          {
      client
    } = me; // bail out in case:
    // - client is not painted yet
    // - client has rendering suspended
    // - or we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener

    if (!client.isPainted || client.suspendRendering || this.client.project.propagatingLoadChanges) {
      return;
    }

    switch (action) {
      case 'dataset':
        me.resetGridCache(); // Allow no records to fall through to clear existing deps

        if (records.length) {
          me.toDrawOnProjectRefresh = new Set(records);
          return;
        }

        break;

      case 'add':
        // Dependency added, draw it on project refresh. Cannot draw it earlier since adding it will have
        // invalidated the graph, making it impossible to determine coords
        records.forEach(record => me.toDrawOnProjectRefresh.add(record));
        return;

      case 'update':
        {
          // Not drawn, either out of view or not properly configured earlier
          if (!me.drawnDependencies.some(d => d.dependency === record)) {
            me.addToGridCache(record);
            me.scheduleDraw();
          } else {
            // Dependency updated. Might have changed source or target, redraw it completely
            return me.scheduleRefreshDependency(record);
          }

          break;
        }

      case 'remove':
        // dependencies removed, release elements and remove from cache
        records.forEach(dependency => {
          me.releaseDependency(dependency, true);
          me.removeFromCache(dependency); // Dependency might got scheduled to be refreshed before it is removed

          me.dependenciesToRefresh.delete(dependency);
        });
        client.trigger('dependenciesDrawn');
        return;
      // Removing all or filtering -> full redraw

      case 'removeall':
      case 'filter':
        me.resetGridCache(); // continue to schedule draw

        break;
    } // other changes (removeall, filter) trigger full redraw


    me.scheduleDraw(true);
  }

  onDependencyIdChange({
    record,
    oldValue
  }) {
    // Dependency has real id now and we should remove cache for phantom id
    this.removeFromCache(record, null, oldValue);
    this.addToGridCache(record);
  }

  onEventBatchedUpdate(event) {
    if (this.client.listenToBatchedUpdates) {
      // EventResize only changes the end point.
      // onEventChange insists that >1 fields are changed unless we pass this flag.
      event.fromBatched = true;
      this.onEventChange(...arguments);
    }
  }
  /**
   * Redraws dependencies when an event has changed
   * @private
   */


  onEventChange({
    action,
    record,
    records,
    changes,
    fromBatched
  }) {
    // TODO : In Gantt this will be the same as the row store, only need one
    const me = this; // bail out in case we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener

    if (me.client.project.propagatingLoadChanges) {
      return;
    }

    switch (action) {
      case 'filter':
        // filtering events, need to redraw all dependencies
        me.scheduleDraw(true);
        break;

      case 'update':
        // Ignore normalization of single field unless it's from a batched update, ie EventResize
        if (!fromBatched && Object.keys(changes).length === 1 && (changes.startDate || changes.endDate || changes.duration)) {
          return;
        }

        if (!record.isEvent) {
          me.drawForTimeSpan(record, true);
        } else {
          // event updated, need to redraw dependencies for all events in its row since it might have changed
          // vertical position (from changing startDate, duration, name or anything if using custom sorter)
          const eventRecords = [record]; // Collect all events for all resources which have this event assigned... they might all be affected

          record.resources.forEach(resourceRecord => eventRecords.push(...resourceRecord.events));

          if (me.client.project.isWritingData) {
            new Set(eventRecords).forEach(rec => rec.dependencies.forEach(dependency => {
              me.scheduleRefreshDependency(dependency);
            }));
          } else {
            new Set(eventRecords).forEach(eventRecord => me.drawForTimeSpan(eventRecord, true));
          }
        }

        break;

      case 'remove':
        records.forEach(eventRecord => {
          const dependencies = me.dependencyStore.query(d => d.fromEvent === eventRecord || d.toEvent === eventRecord);
          dependencies === null || dependencies === void 0 ? void 0 : dependencies.forEach(dependency => {
            me.releaseDependency(dependency, true);
            me.removeFromCache(dependency);
          });
        });
        break;

      case 'removeall':
        me.resetGridCache();
        me.scheduleDraw(true);
        break;
    } // adding event has no effect on dependencies, unless it changes row height. in which case it will be handled
    // by onTranslateRow().
    // updating an event might also change row height, handled the same way.
    // removing events will also remove dependencies, thus handled in onDependencyChange

  }

  onAssignmentRefresh({
    action
  }) {
    // bail out in case we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener
    if (this.client.project.propagatingLoadChanges) {
      return;
    }

    if (action === 'dataset') {
      // Assigning using EventEdit replaces all assignments. Taking the easy way out, throwing cache away
      this.resetGridCache();
      this.scheduleDraw(true);
    }
  }

  onAssignmentChange({
    action,
    record,
    records,
    changes
  }) {
    const me = this; // bail out in case we are finalizing the propagation caused by project loading
    // we've already scheduled dependencies draw in the project "refresh" listener

    if (me.client.project.propagatingLoadChanges) {
      return;
    }

    if (record) {
      records = [record];
    } // Unusual case probably, not worth figuring out which was filtered out


    if (action === 'filter') {
      me.resetGridCache();
      me.scheduleDraw(true);
    }

    if (action === 'add' || action === 'remove' || action === 'update') {
      // Ignore normalization of event & resource
      if (action === 'update' && // Only care about the normalization case, where changes are exactly 2 = event + resource
      Object.keys(changes).length === 2 && // And those changed from not being models
      changes.event && changes.resource && !changes.event.isModel && !changes.resource.isModel) {
        return;
      }

      records.forEach(assignment => {
        const {
          assignmentStore,
          eventStore
        } = me.client,
              // Engine clears assignment.event on remove, have to look it up
        event = eventStore.getById(assignment.eventId); // Event might have been removed with the assignment, if not all its deps might need refreshing

        event && event.dependencies.forEach(dependency => {
          // New assignment added by other means than EventEdit
          if (action === 'add') {
            me.toDrawOnProjectRefresh.add(dependency); //me.scheduleRefreshDependency(dependency);
          } // Event unassigned, remove dep line (directly, nothing is redrawn so engine state can be ignored)
          else if (action === 'remove') {
            let assignments; // Removed source?

            if (dependency.fromEvent === event) {
              // Might point to a multi assigned event, need to remove all lines
              assignments = dependency.toEvent.assignments.map(to => ({
                from: assignment,
                to
              }));
            } // Nope, target
            else {
              // Might point to a multi assigned event, need to remove all lines
              assignments = dependency.fromEvent.assignments.map(from => ({
                from,
                to: assignment
              }));
            }

            assignments.forEach(assignmentData => {
              me.releaseDependency(dependency, assignmentData);
              me.removeFromCache(dependency, assignmentData);
            });
          } // Single assignment updated, redraw lines for it
          else if (action === 'update') {
            me.getDependencyAssignmentsAsFromToArray({
              dependency,
              assignmentStore
            }).filter(a => a.from === record || a.to === record).forEach(assignmentData => {
              me.scheduleRefreshDependency(dependency, assignmentData);
            });
          }
        });
      });
    }
  } // TODO: this function is called often, use cache to avoid searching in store


  getDependencyAssignmentsAsFromToArray({
    dependency,
    assignmentStore
  }) {
    const {
      fromEvent,
      toEvent
    } = dependency,
          assignments = [];

    if (fromEvent && toEvent) {
      const fromAssignments = this.getEventAssignments(fromEvent, assignmentStore),
            toAssignments = this.getEventAssignments(toEvent, assignmentStore);
      fromAssignments.forEach(from => {
        toAssignments.forEach(to => {
          assignments.push({
            from,
            to
          });
        });
      });
    }

    return assignments;
  }

  getEventAssignments(event, assignmentStore) {
    if (!event.isRemoved) {
      return event.assignments;
    } // If event is removed assignments might be either removed or planned to be removed
    else {
      const assignments = assignmentStore.removed.values.filter(assignment => assignment.event === event);

      for (const assignment of assignmentStore.assignmentsForRemoval) {
        if (assignment.event === event) {
          assignments.push(assignment);
        }
      }

      return assignments;
    }
  } //endregion


  onElementClick(event) {
    const me = this;

    if (event.target.matches('.' + me.baseCls)) {
      const dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].get(event.target).dependency,
            eventName = event.type === 'click' ? 'Click' : 'DblClick';
      /**
       * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
       * @event dependencyClick
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.model.DependencyModel} dependency
       * @param {MouseEvent} event
       */

      /**
       * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
       * @event dependencyDblClick
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.model.DependencyModel} dependency
       * @param {MouseEvent} event
       */

      me.client.trigger(`dependency${eventName}`, {
        dependency,
        event
      });
    }
  }

  onElementDblClick(event) {
    return this.onElementClick(event);
  }

  onElementMouseOver(event) {
    const me = this;

    if (event.target.matches('.' + me.baseCls)) {
      const dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].get(event.target).dependency;
      /**
       * Fires on the owning Scheduler/Gantt when the mouse moves over a dependency line.
       * @event dependencyMouseOver
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.model.DependencyModel} dependency
       * @param {MouseEvent} event
       */

      me.client.trigger('dependencyMouseOver', {
        dependency,
        event
      });

      if (me.overCls) {
        me.highlight(dependency, me.overCls);
      }
    }
  }

  onElementMouseOut(event) {
    const me = this;

    if (event.target.matches('.' + me.baseCls)) {
      const dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].get(event.target).dependency;
      /**
       * Fires on the owning Scheduler/Gantt when the mouse moves out of a dependency line.
       * @event dependencyMouseOut
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.model.DependencyModel} dependency
       * @param {MouseEvent} event
       */

      me.client.trigger('dependencyMouseOut', {
        dependency,
        event
      });
      if (me.overCls && !dependency.isRemoved) me.unhighlight(dependency);
    }
  } //endregion
  //region Highlight


  highlight(dependency, cls = this.overCls) {
    const elements = this.getElementsForDependency(dependency);
    elements.forEach(element => {
      element.classList.add(cls);
    });
    dependency.highlight(cls);
  }

  unhighlight(dependency, cls = this.overCls) {
    const elements = this.getElementsForDependency(dependency);
    elements.forEach(element => {
      element.classList.remove(cls);
    });
    dependency.unhighlight(cls);
  }

  highlightEventDependencies(timespan) {
    timespan.dependencies.forEach(dep => this.highlight(dep));
  }

  unhighlightEventDependencies(timespan) {
    timespan.dependencies.forEach(dep => this.unhighlight(dep));
  } //endregion
  //region Determining dependencies to draw
  // Neither resource can be hidden for a dependency to be considered visible


  isDependencyVisible(dependency, assignmentData = null) {
    const me = this,
          {
      assignmentStore,
      resourceStore,
      eventStore
    } = me.client,
          {
      fromEvent,
      toEvent
    } = dependency; // Bail out early in case source or target doesn't exist

    if (!fromEvent || !toEvent) {
      return false;
    }

    let fromResource, toResource; // Using multi-assignment, resource obtained from assignment

    if (assignmentData) {
      const {
        from,
        to
      } = assignmentData;
      fromResource = from.resource;
      toResource = to.resource; // EventStore or AssignmentStore might be filtered, or assignment might opt out of dependency drawing

      if (from.drawDependencies === false || to.drawDependencies === false || eventStore.isFiltered && (!eventStore.includes(fromEvent) || !eventStore.includes(toEvent)) || assignmentStore.isFiltered && (!assignmentStore.includes(from) || !assignmentStore.includes(to))) {
        return false;
      }
    } // Not using assignments, resource obtained from event
    else {
      fromResource = fromEvent.resource;
      toResource = toEvent.resource;
    } // Verify these are real existing Resources and not collapsed away (resource not existing in resource store)


    if (!resourceStore.isAvailable(fromResource) || !resourceStore.isAvailable(toResource)) {
      return false;
    }

    return fromEvent.isModel && !fromResource.instanceMeta(resourceStore).hidden && !toResource.instanceMeta(resourceStore).hidden;
  } // Get the bounding box for either the source or the target event


  getBox(dependency, source, assignmentData = null, roughly = false) {
    const eventRecord = this.getTimeSpanRecordFromDependency(dependency, source);
    let resourceRecord; // Multi-assignment, get resource from assignment

    if (assignmentData) {
      resourceRecord = assignmentData[source ? 'from' : 'to'].resource;
    } // Single, get resource from event
    else {
      resourceRecord = eventRecord.resource;
    }

    const result = this.client.currentOrientation.getResourceEventBox(eventRecord, resourceRecord, true, roughly); // Inner event element is shorter than wrapper by 1 pixel which is done to visually distinguish event elements
    // packed close in the row. But that also creates a 1px difference between inner event element and wrap element

    if (result && !eventRecord.isMilestone) {
      result.width--;
    }

    return result;
  } // Get source or target events resource


  getRowRecordFromDependency(dependency, source, assignmentData) {
    let rowRecord; // Multi-assigned, use assignments resource

    if (assignmentData) {
      rowRecord = assignmentData[source ? 'from' : 'to'].resource;
    } // Not multi-assigned, get events resource
    else {
      rowRecord = this.getTimeSpanRecordFromDependency(dependency, source).resource;
    }

    return rowRecord;
  } // Get from or to event


  getTimeSpanRecordFromDependency(dependency, from = true) {
    return dependency[`${from ? 'from' : 'to'}Event`];
  }

  getMetaId(assignmentData = null) {
    return assignmentData ? `${this.client.id}-ass${assignmentData.from.id}-ass${assignmentData.to.id}` : this.client.id;
  } // Gets the source and target events bounds and unions them to determine the dependency bounds


  getDependencyBounds(dependency, assignmentData, roughly = true) {
    const me = this,
          {
      client
    } = me,
          {
      isGantt
    } = client; // quick bailout for hidden rows

    if (!client.rowManager.rowCount || !me.isDependencyVisible(dependency, assignmentData) || !client.timeAxis.count) {
      return null;
    }

    const ddr = dependency.getDateRange(); // quick bailout in case dependency dates and view dates do not intersect

    if (!(ddr && (ddr.start >= client.startDate && ddr.start < client.endDate || client.startDate >= ddr.start && client.startDate < ddr.end))) {
      return null;
    }

    const metaId = me.getMetaId(assignmentData),
          instanceMeta = dependency.instanceMeta(metaId),
          {
      resourceMap
    } = client.currentOrientation,
          {
      bounds
    } = instanceMeta; // If we are forcing recalculation of dep bounds, or there are no calculated bounds for this dependency
    // or the calculated bounds were based on a "best guess" and we now know better, then recalculate the bounds.

    if ( // Forcing bounds
    me._resetBoundsCache || // No bounds
    !bounds || // Start rect approximated and it can now be properly calculated
    !bounds.startRectangle.layout && resourceMap !== null && resourceMap !== void 0 && resourceMap.has(bounds.startRectangle.resourceId) || // End rect approximated and it can now be properly calculated
    !bounds.endRectangle.layout && resourceMap !== null && resourceMap !== void 0 && resourceMap.has(bounds.endRectangle.resourceId)) {
      const startRectangle = me.getBox(dependency, true, assignmentData, roughly),
            endRectangle = me.getBox(dependency, false, assignmentData, roughly); // Can't draw dependency if either start or end is in collapsed row

      if (!startRectangle || !endRectangle) {
        return null;
      }

      const from = me.getTimeSpanRecordFromDependency(dependency, true),
            to = me.getTimeSpanRecordFromDependency(dependency, false),
            bounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].union(startRectangle, endRectangle);

      if (!isGantt && (from.isMilestone || to.isMilestone)) {
        // Skip fast rendering for milestones in default layout mode. Milestone size will be cached for regular milestones
        // by `getDependencyBounds` method, if we draw dependency too fast, before DOM was actually updated, size will
        // be wrong.
        // If project is not ready i.e. is performing commit, UI is not updated yet and it is too soon to look
        // into the DOM and cache actual milestone size
        // https://github.com/bryntum/support/issues/3473
        if (!client.isEngineReady && client.milestoneLayoutMode === 'default') {
          return null;
        }

        [[from, startRectangle, assignmentData.from], [to, endRectangle, assignmentData.to]].map(([record, rectangle, assignment]) => {
          // When using other milestoneLayoutMode than default milestones should be treated as normal events.
          // Milestones are zero width by default, so we must measure the milestone el's height
          // (or icon el width) and use that as the width. We cannot use the event's calculated height because
          // if there are labels, the milestone diamond will be smaller.
          // If the event doesn't have an element, then it's outside of the rendered block and the exact
          // width doesn't matter.
          if (client.milestoneLayoutMode === 'default' && record.isMilestone) {
            let width; // https://github.com/bryntum/support/issues/3473
            // Always measure width for icon milestones

            if (record.iconCls) {
              const milestoneElement = client.getElementFromAssignmentRecord(assignment);

              if (milestoneElement) {
                width = milestoneElement.offsetWidth;
              }
            } // use cached value for default milestones
            else {
              if (!client.milestoneWidth) {
                const milestoneElement = client.getElementFromAssignmentRecord(assignment);

                if (milestoneElement) {
                  client.milestoneWidth = milestoneElement.offsetWidth; // The line above used to have this, but that does not allow mixin icons with non-icons.
                  // With the new milestone styling, we seem fine without it anyway
                  //record.iconCls ? milestoneElement.offsetWidth : parseInt(window.getComputedStyle(milestoneElement, ':before').fontSize);
                }
              }

              width = client.milestoneWidth;
            } // If it could not be measured due to the event being outside of the rendered block
            // we have to use the calculated height.


            const milestoneWidth = width || rectangle.height;
            rectangle.left -= milestoneWidth / 2;
            rectangle.right += milestoneWidth / 2;
          }
        });
      }

      instanceMeta.bounds = {
        bounds,
        startRectangle,
        endRectangle,
        // Cache whether both rectangles are based on the true layout
        // or a best guess approximation to be recalculated
        // next time through.
        layout: startRectangle.layout && endRectangle.layout
      };
    }

    return dependency.instanceMeta(metaId).bounds;
  } // Grid cache is a virtual grid holding info on which dependencies intersects its virtual cells.
  // Used to determine which dependencies should be considered for drawing, iterating over all dependencies each update
  // gets too costly when count increases (>10000).
  //
  // Illustration shows entire schedule area, dddd is a dependency line, vvv is viewport, xxx virtual cell border:
  //
  // ----------------------------------
  // |     vvvvvxvvvvv                |
  // |     v    x    v                |
  // |     v d  x    v                |
  // |     v d  x    v                |
  // |xxxxxvxdxxx    v                |
  // |     vvdvvxvvvvv                |
  // |       d  x                     |
  // |       d  x                     |
  // |       d  x                     |
  // |xxxxxxxdxxxxxxx                 |
  // |       d  x                     |
  // |       d  x                     |
  // |          x                     |
  // |          x                     |
  // |xxxxxxxxxxxxxxx                 |
  // ----------------------------------
  //
  // The dependency crosses three virtual grid cells [0,0], [0,1] and [0,2]. Stored in a map in cache:
  // {
  //    0 : {
  //      0 : [ d, ... ],
  //      1 : [ d, ... ],
  //      2 : [ d, ... ]
  //    }
  // }
  //
  // Viewport crosses four virtual grid cells [0,0], [1,0], [0,1], [1,1]. Those cells are checked in the cached map to
  // find out which rows should be considered for drawing.
  //
  // This approach minimizes the amount of iteration needed


  get dependencyGridCache() {
    const me = this;

    if (!me._dependencyGridCache) {
      me._dependencyGridCache = {};
      me.dependencyStore.forEach(dependency => me.addToGridCache(dependency));
    }

    return me._dependencyGridCache;
  }

  get dependencyStore() {
    return this.project.dependencyStore;
  }

  getIteratableDependencyAssignments(dependency) {
    return this.assignmentStore ? this.getDependencyAssignmentsAsFromToArray({
      dependency,
      assignmentStore: this.assignmentStore
    }) : [null]; // On purpose, to be iterable
  }

  addToGridCache(dependency) {
    const me = this,
          {
      client
    } = me,
          {
      store
    } = client,
          {
      dependencyGridCache,
      cacheGridSize
    } = me,
          assignmentDataArray = me.getIteratableDependencyAssignments(dependency),
          axisStartMS = client.startDate.getTime(),
          axisEndMS = client.endDate.getTime(),
          cacheGridSizeTicksMS = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].asMilliseconds(client.timeAxis.unit) * cacheGridSize.ticks;
    assignmentDataArray.forEach(assignmentData => {
      const metaId = me.getMetaId(assignmentData),
            meta = dependency.instanceMeta(metaId),
            metaGridCache = meta.gridCache = [],
            // Using index vertically rather than y for reliability with variable row height
      fromIndex = store.indexOf(me.getRowRecordFromDependency(dependency, true, assignmentData)),
            toIndex = store.indexOf(me.getRowRecordFromDependency(dependency, false, assignmentData)),
            // Using dates horizontally rather than x for performance reasons
      dateRange = dependency.getDateRange();

      if (!dateRange) {
        return;
      }

      if (fromIndex !== -1 && toIndex !== -1 && dateRange && dateRange.end > axisStartMS && dateRange.start < axisEndMS) {
        const topIndex = Math.min(fromIndex, toIndex),
              bottomIndex = Math.max(fromIndex, toIndex),
              boxTop = Math.floor(topIndex / cacheGridSize.index),
              boxBottom = Math.floor(bottomIndex / cacheGridSize.index),
              boxLeft = Math.floor(Math.max(dateRange.start - axisStartMS, 0) / cacheGridSizeTicksMS),
              boxRight = Math.floor(Math.max(dateRange.end - axisStartMS, 0) / cacheGridSizeTicksMS),
              key = `${dependency.id}.-.${metaId}`;
        let cacheX, cacheY, cacheYMap, x, y; // Store the dependency in the virtual cells which it intersects

        for (x = boxLeft; x <= boxRight; x++) {
          cacheX = dependencyGridCache[x] || (dependencyGridCache[x] = {});

          for (y = boxTop; y <= boxBottom; y++) {
            cacheY = cacheX[y] || (cacheX[y] = []);
            cacheYMap = cacheY.cached || (cacheY.cached = {}); // Only push to the cache if it is not already there

            if (!cacheYMap[key]) {
              cacheYMap[key] = true;
              cacheY.push({
                dependency,
                assignmentData,
                metaId
              });
            }

            metaGridCache.push([x, y]);
          }
        }

        meta.assignmentData = assignmentData;
      }
    });
  }

  removeFromCache(dependency, assignmentData = null, dependencyId = dependency.id) {
    const me = this,
          {
      _dependencyGridCache
    } = me;
    let assignments; // Single assignment

    if (assignmentData) {
      assignments = [assignmentData];
    } // All assignments
    else {
      const clientDataKeys = Object.keys(dependency.meta.map || {}).filter(key => key.startsWith(me.client.id));
      assignments = clientDataKeys.map(key => {
        const data = dependency.meta.map[key];
        return data.assignmentData;
      });
    }

    assignments.forEach(assignmentData => {
      var _meta$gridCache;

      const metaId = me.getMetaId(assignmentData),
            meta = dependency.instanceMeta(metaId),
            key = `${dependencyId}.-.${metaId}`;
      _dependencyGridCache && ((_meta$gridCache = meta.gridCache) === null || _meta$gridCache === void 0 ? void 0 : _meta$gridCache.forEach(([x, y]) => {
        var _dependencyGridCache$;

        if ((_dependencyGridCache$ = _dependencyGridCache[x]) !== null && _dependencyGridCache$ !== void 0 && _dependencyGridCache$.hasOwnProperty(y)) {
          const entries = me._dependencyGridCache[x][y];

          if (entries !== null && entries !== void 0 && entries.cached[key]) {
            const index = me.findDependencyIndex(entries, dependency, assignmentData);
            delete entries.cached[key]; // Cannot use ArrayHelper#remove since it cannot compare deeply

            if (index > -1) {
              entries.splice(index, 1);
            }
          }
        }
      }));
      meta.bounds = null;
      meta.gridCache = null;
    });
  }

  set dependencyGridCache(cache) {
    this._dependencyGridCache = cache;
  } // Reset cached bounds, not grid cache since it is expensive to create. It is so coarse anyway so should be fine
  // with most changes, except for sorting and similar. Reset on demand instead


  resetBoundsCache() {
    // Not actually resetting here, would just be costly to iterate and reset per dependency, instead flagging to
    // force cached value to be updated
    this._resetBoundsCache = true;
  }

  doResetBoundsCache() {
    const {
      dependencyGridCache
    } = this; // Iterate over the dependency grid cache and clear all cached bounds

    Object.values(dependencyGridCache).forEach(rowCache => {
      Object.values(rowCache).forEach(value => {
        value.forEach(({
          dependency,
          metaId
        }) => {
          dependency.instanceMeta(metaId).bounds = null;
        });
      });
    });
  } // In some cases we do need to reset cache, like when time axis is reconfigured


  resetGridCache() {
    this.dependencyGridCache = null;
  } //endregion
  //region Draw & render
  //region Lines

  /**
   * Generates `otherBoxes` config for rectangular path finder, which push dependency line to the row boundary.
   * It should be enough to return single box with top/bottom taken from row top/bottom and left/right taken from source
   * box, extended by start arrow margin to both sides.
   * @param {Core.helper.util.Rectangle} box Box for which other boxes are required
   * @param {String} side Side of the box where line starts
   * @returns {Object[]}
   * @private
   */


  generateBoundaryBoxes(box, side) {
    const boxes = []; // We need two boxes for the bottom edge, because otherwise path cannot be found. Ideally that shouldn't be
    // necessary. Other solution would be to adjust bottom by -1px, but that would make some dependency lines to take
    // 1px different path on a row boundary, which doesn't look nice (but slightly more performant)

    if (side === 'bottom') {
      boxes.push({
        start: box.left,
        end: box.left + box.width / 2,
        top: box.rowTop,
        bottom: box.rowBottom
      }, {
        start: box.left + box.width / 2,
        end: box.right,
        top: box.rowTop,
        bottom: box.rowBottom
      });
    } else {
      boxes.push({
        start: box.left - this.pathFinder.startArrowMargin,
        end: box.right + this.pathFinder.startArrowMargin,
        top: box.rowTop,
        bottom: box.rowBottom
      });
    }

    return boxes;
  }

  getDependencyStartSide(dependency) {
    const me = this,
          source = me.getTimeSpanRecordFromDependency(dependency, true),
          type = dependency.type;
    let startSide = dependency.fromSide;

    if (!startSide) {
      switch (true) {
        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.StartToEnd:
          startSide = me.getConnectorStartSide(source);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.StartToStart:
          startSide = me.getConnectorStartSide(source);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.EndToStart:
          startSide = me.getConnectorEndSide(source);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.EndToEnd:
          startSide = me.getConnectorEndSide(source);
          break;

        default:
          throw new Error('Invalid dependency type: ' + type);
      }
    }

    return startSide;
  }

  getDependencyEndSide(dependency) {
    const me = this,
          target = me.getTimeSpanRecordFromDependency(dependency, false),
          type = dependency.type;
    let endSide = dependency.toSide; // Fallback to view trait if dependency end side is not given /*or can be obtained from type*/

    if (!endSide) {
      switch (true) {
        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.StartToEnd:
          endSide = me.getConnectorEndSide(target);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.StartToStart:
          endSide = me.getConnectorStartSide(target);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.EndToStart:
          endSide = me.getConnectorStartSide(target);
          break;

        case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_10__["default"].Type.EndToEnd:
          endSide = me.getConnectorEndSide(target);
          break;

        default:
          throw new Error('Invalid dependency type: ' + type);
      }
    }

    return endSide;
  }

  prepareLineDef(dependency, dependencyDrawData, assignmentData = null) {
    const me = this,
          startSide = me.getDependencyStartSide(dependency),
          endSide = me.getDependencyEndSide(dependency),
          {
      startRectangle,
      endRectangle
    } = dependencyDrawData,
          intraRowDependency = startRectangle.rowTop != null && startRectangle.rowTop !== endRectangle.rowTop,
          otherBoxes = []; // Only add otherBoxes if there is a rowTop and those are not equal - which means assignments are is different
    // resources

    if (intraRowDependency) {
      otherBoxes.push(...me.generateBoundaryBoxes(startRectangle, startSide));
    }

    let {
      startArrowMargin,
      verticalMargin
    } = me.pathFinder; // Do not change start arrow margin in case dependency is bidirectional

    if (!dependency.bidirectional) {
      if (/(top|bottom)/.test(startSide)) {
        startArrowMargin = me.client.barMargin / 2;
      }

      verticalMargin = me.client.barMargin / 2;
    }

    return {
      startBox: {
        start: startRectangle.x,
        end: startRectangle.right,
        top: startRectangle.y,
        bottom: startRectangle.bottom
      },
      endBox: {
        start: endRectangle.x,
        end: endRectangle.right,
        top: endRectangle.y,
        bottom: endRectangle.bottom
      },
      otherBoxes,
      startArrowMargin,
      verticalMargin,
      otherVerticalMargin: 0,
      otherHorizontalMargin: 0,
      startSide: startSide,
      endSide: endSide
    };
  } // Draws a single SVG line that represents the dependency


  drawLine(canvas, dependency, points, assignmentData = null, cache = true, hideMarker = false) {
    const metaId = this.getMetaId(assignmentData); // Reuse existing element if possible

    let line = dependency.instanceMeta(metaId).lineElement;

    if (!line || !cache) {
      line = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');

      if (cache) {
        dependency.instanceMeta(metaId).lineElement = line;
      }

      line.setAttribute('depId', dependency.id);

      if (assignmentData) {
        line.setAttribute('fromId', assignmentData.from.id);
        line.setAttribute('toId', assignmentData.to.id);
      }

      canvas.appendChild(line);
    } // TODO: Use DomHelper.syncClassList
    // className is SVGAnimatedString for svg elements, reading attribute instead


    line.classList.length && line.classList.remove.apply(line.classList, line.getAttribute('class').split(' '));
    line.classList.add(this.baseCls);

    if (dependency.cls) {
      line.classList.add(dependency.cls);
    }

    if (dependency.bidirectional) {
      line.classList.add('b-sch-bidirectional-line');
    }

    if (dependency.highlighted) {
      line.classList.add(...dependency.highlighted.split(' '));
    }

    if (hideMarker) {
      line.classList.add(this.noMarkerCls);
    }

    line.setAttribute('points', !points ? '' : points.map((p, i) => i !== points.length - 1 ? `${p.x1},${p.y1}` : `${p.x1},${p.y1} ${p.x2},${p.y2}`).join(' '));
    _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].set(line, {
      dependency
    });
    return line;
  } //endregion

  /**
   * Re-caches and redraws a dependency, for all assignments.
   * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
   */


  refreshDependency(dependency) {
    const me = this,
          assignments = me.getIteratableDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore

    me.releaseDependency(dependency, assignments[0] !== null); // Remove it from grid & bounds cache

    me.removeFromCache(dependency); // Re-add it to grid cache

    me.addToGridCache(dependency); // Draw all assignments

    assignments.forEach(assignmentData => me.drawDependency(dependency, null, assignmentData));
  }
  /**
   * Re-caches and redraws a dependency for given assignment.
   * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
   * @param {Object} assignmentData
   * @param {Scheduler.model.AssignmentModel} assignmentData.from Source assignment
   * @param {Scheduler.model.AssignmentModel} assignmentData.to Target assignment
   * @private
   */


  refreshDependencyAssignment(dependency, assignmentData) {
    const me = this; // In case it was assigned to something not in view/timeline, release the line

    me.releaseDependency(dependency, assignmentData); // Update cache to only contain whats left of it

    me.removeFromCache(dependency, assignmentData);
    me.addToGridCache(dependency); // Draw lines

    me.drawDependency(dependency, null, assignmentData);
  }
  /**
   * Stores all dependencies/assignments that were requested to refresh and schedules repaint on next animation frame
   * @param {Scheduler.model.DependencyModel} dependency Dependency model to refresh
   * @param {Object} [assignmentData] Assignment data
   * @param {Scheduler.model.AssignmentModel} [assignmentData.from] Source assignment
   * @param {Scheduler.model.AssignmentModel} [assignmentData.to] Target assignment
   * @private
   */


  scheduleRefreshDependency(dependency, assignmentData = null) {
    const me = this,
          map = me.dependenciesToRefresh; // Ignore undrawn dependencies, they cannot be refreshed

    if (!me.drawnDependencies.find(d => d.dependency === dependency)) {
      return;
    } // If this method was called once without assignment data - all lines related should be repainted


    if (!assignmentData) {
      map.set(dependency, true);
    } else if (map.has(dependency)) {
      if (map.get(dependency) !== true) {
        map.get(dependency).add(assignmentData);
      }
    } else {
      map.set(dependency, new Set([assignmentData]));
    }

    if (map.size === 1) {
      me.requestAnimationFrame(() => me.refreshDependencyOnFrame());
    }
  }
  /**
   * Implement on subclass when a certain sort order is needed
   * @returns {Map} Dependencies
   * @private
   */


  getSortedDependenciesToRefresh() {
    return this.dependenciesToRefresh;
  }
  /**
   * Repaints scheduled dependencies/assignments
   * @private
   */


  refreshDependencyOnFrame() {
    const me = this,
          map = me.getSortedDependenciesToRefresh();

    if (me.client.isPainted) {
      // First clear cache and release dependencies. This will modify DOM
      map.forEach((assignments, dependency) => {
        if (assignments === true) {
          const assignments = me.getIteratableDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore

          me.releaseDependency(dependency, assignments[0] !== null); // Remove it from grid & bounds cache

          me.removeFromCache(dependency);
        } else {
          assignments.forEach(assignment => {
            // In case it was assigned to something not in view/timeline, release the line
            me.releaseDependency(dependency, assignment); // Update cache to only contain whats left of it

            me.removeFromCache(dependency, assignment);
          });
        }
      }); // Then fill cache before drawing dependencies. This will read the DOM forcing reflow

      map.forEach((assignments, dependency) => {
        // Re-add it to grid cache
        me.addToGridCache(dependency);
      }); // Finally append elements to the DOM

      map.forEach((assignments, dependency) => {
        if (assignments === true) {
          assignments = me.getIteratableDependencyAssignments(dependency);
        }

        assignments.forEach(assignmentData => {
          me.drawDependency(dependency, null, assignmentData);
        });
      }); // Cannot clear `map`, since it is a sorted copy of the actual map.

      me.dependenciesToRefresh.clear();
      me.client.trigger('dependenciesDrawn', {
        partial: true
      });
    }
  }
  /**
   * Draws a single dependency (for a single assignment if using multiple), if in view.
   * @param {Scheduler.model.DependencyModel} dependency Dependency to draw
   */


  drawDependency(dependency, drawData = null, assignmentData = null, canvas = this.client.svgCanvas, cache = true) {
    const me = this,
          {
      drawnDependencies,
      oldDrawnDependencies
    } = me,
          // Determines if a dependency should be drawn, and if so returns the coordinates of its events
    dependencyDrawData = drawData || me.getDependencyBounds(dependency, assignmentData);

    if (!me.disabled && dependencyDrawData) {
      if (!dependencyDrawData.lines) {
        // Build line defs
        dependencyDrawData.lineDef = me.prepareLineDef(dependency, dependencyDrawData);
        dependencyDrawData.lines = me.pathFinder.findPath(dependencyDrawData.lineDef, me.lineDefAdjusters);
      } // If PathFinder doesn't find a path it refers to the `lineDefAdjusters` which may calculate path
      // ignoring the arrow size. In that case we need to let line painter know that marker should not be
      // added


      const {
        hideMarker
      } = dependencyDrawData.lineDef;
      me.drawLine(canvas, dependency, dependencyDrawData.lines, assignmentData, cache, hideMarker); // Do not push dependency to drawn deps if this is a temporary render
      // Cannot use ArrayHelper#include since object wont be the same, only its contents

      if (cache && !this.includesDependency(drawnDependencies, dependency, assignmentData)) {
        drawnDependencies.push({
          dependency,
          assignmentData
        });
      }
    } // Remove from oldDrawnDeps, to not have element removed. Cannot use ArrayHelper#remove as stated above


    const oldIndex = this.findDependencyIndex(oldDrawnDependencies, dependency, assignmentData);

    if (oldIndex >= 0) {
      oldDrawnDependencies.splice(oldIndex, 1);
    }
  }
  /**
   * Draws multiple dependencies, called from drawForEvent() or drawFromTask().
   * @private
   */


  drawForTimeSpan(timeSpanRecord, async = false) {
    const me = this; // If the client is doing an animated update, we must update at end.
    // That will be asynchronous relative to now, so do not pass on the async flag.

    if (me.client.isAnimating) {
      me.client.on({
        transitionend() {
          // Because of asyncness record might be removed during the transition
          !timeSpanRecord.isRemoved && me.drawForTimeSpan(timeSpanRecord, true);
        },

        once: true
      });
    } // Otherwise, schedule the draw for the next frame.
    else {
      me.dependencyStore.getTimeSpanDependencies(timeSpanRecord).forEach(dependency => {
        if (async) {
          me.scheduleRefreshDependency(dependency);
        } else {
          me.refreshDependency(dependency);
        }
      });
    }
  }
  /**
   * Draws all dependencies for the specified event.
   */


  drawForEvent(eventRecord) {
    this.drawForTimeSpan(eventRecord);
  } // Redraw all dependencies for a particular eventRecord, using its current element instead of calculating a box
  // Used to do live redraw while resizing or dragging events


  updateDependenciesForTimeSpan(timeSpanRecord, element, newResource = null) {
    const me = this,
          eventRecord = timeSpanRecord.isAssignment ? timeSpanRecord.event : timeSpanRecord,
          deps = me.dependencyStore.getTimeSpanDependencies(eventRecord),
          metaId = me.getMetaId(),
          scheduler = me.client,
          originalTaskRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, scheduler.timeAxisSubGridElement),
          row = newResource && scheduler.getRowFor(newResource);
    let bounds;
    deps.forEach(dep => {
      const assignments = this.getIteratableDependencyAssignments(dep);
      assignments.forEach(assignmentData => {
        const taskRect = originalTaskRect.clone();
        let startRectangle, endRectangle;

        if (row) {
          taskRect.rowTop = row.top;
          taskRect.rowBottom = row.bottom;
        } // If dragging one multi assigned event the others wont move until it is dropped. Prevent their dep
        // lines from updating by bailing out


        if (assignmentData && assignmentData.from !== timeSpanRecord && assignmentData.to !== timeSpanRecord) {
          return;
        } // Bail out if dependency is not visible (other end might be collapsed)


        if (!me.isDependencyVisible(dep, assignmentData)) {
          return;
        }

        if (me.getTimeSpanRecordFromDependency(dep, true) === eventRecord) {
          startRectangle = taskRect; // try to look into dependency cache first

          if (bounds = dep.instanceMeta(metaId).bounds) {
            endRectangle = bounds.endRectangle;
          } else {
            endRectangle = me.getBox(dep, false, assignmentData);
          }
        } else {
          // try to look into dependency cache first
          if (bounds = dep.instanceMeta(metaId).bounds) {
            startRectangle = bounds.startRectangle;
          } else {
            startRectangle = me.getBox(dep, true, assignmentData);
          }

          endRectangle = taskRect;
        }

        if (startRectangle && endRectangle) {
          me.drawDependency(dep, {
            startRectangle,
            endRectangle
          }, assignmentData);
        }
      });
    });
  }

  scheduleDraw(relayout = false) {
    const me = this;

    if (me.disabled) {
      return;
    } // There may be number of concurrent calls to this method, we need to reset cache if at least
    // once it was called with relayout = true


    if (relayout) {
      me.resetBoundsCache();
    } // If the scheduler/gantt is doing an animated update, schedule the draw
    // for when that's done so that we get correct element boxes.


    if (me.client.isAnimating) {
      if (!me.clientTransitionRemover) {
        me.clientTransitionRemover = me.client.on({
          transitionend() {
            me.clientTransitionRemover();
            me.clientTransitionRemover = null;
            me.draw();
          },

          once: true
        });
      }
    } // Otherwise, schedule the draw for the next frame.
    else {
      me.doScheduleDraw();
    }
  }
  /**
   * Draws all dependencies that overlap the current viewport
   */


  draw(reLayout = false) {
    const me = this,
          scheduler = me.client; // Early bailout if we get here before we have any deps or rows rendered

    if (!me.oldDrawnDependencies && !me.dependencyStore.count || !scheduler.isPainted) {
      return;
    } // if animation is in progress, schedule drawing and skip current one


    if (scheduler.isAnimating) {
      scheduler.on({
        transitionend() {
          me.scheduleDraw(true);
        },

        once: true
      });
      return;
    } // viewBox is the bounds of the current viewport, used to determine which dependencies to draw


    const viewBox = scheduler.timeAxisSubGrid.viewRectangle;

    if (reLayout) {
      me.resetBoundsCache();
    } // If there is no visible area for dependencies to display, we should stop redrawing and keep info about current dependencies.
    // Next time when visible area appears all dependencies will be redrawn.


    if (!viewBox.width || !viewBox.height) {
      return;
    } // For gantt we need to actually remove cached bounds from the dependency records. If we don't do it, they would
    // not be painted correctly. But we only want to remove the bounds cache, not the cache element itself,
    // otherwise we don't know which element to release.
    // https://github.com/bryntum/support/issues/3645


    if (me._resetBoundsCache) {
      me.doResetBoundsCache();
    }

    me.oldDrawnDependencies = me.drawnDependencies;
    me.drawnDependencies = []; // expand viewBox with buffer size

    viewBox.inflate(me.bufferSize);
    const {
      startDate,
      visibleDateRange
    } = scheduler; // Do not draw if no rows or no ticks

    if (!me.disabled && !scheduler.suspendRendering && scheduler.store.count && scheduler.rowManager.rowCount && startDate && visibleDateRange.startDate && visibleDateRange.endDate) {
      // dependencies might start rendering before the 1st propagation which ends up having an empty dependencies cache
      // and thus never rendered dependencies
      if (!scheduler.project.isInitialCommitPerformed) {
        // Restore drawn dependencies, otherwise the unused ones will not be released next time we draw
        me.drawnDependencies = me.oldDrawnDependencies;
        me.refreshAllWhenReady = true;
        return;
      }

      const consideredDependencies = new Set(),
            {
        dependencyGridCache,
        cacheGridSize
      } = me,
            cacheGridSizeTicksMS = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].asMilliseconds(scheduler.timeAxis.unit) * cacheGridSize.ticks,
            visibleStartMS = visibleDateRange.startDate.getTime() - startDate.getTime(),
            visibleEndMS = visibleDateRange.endDate.getTime() - startDate.getTime(),
            viewLeft = Math.floor(visibleStartMS / cacheGridSizeTicksMS),
            viewRight = Math.floor(visibleEndMS / cacheGridSizeTicksMS),
            topIndex = Math.floor(scheduler.rowManager.topRow.dataIndex / cacheGridSize.index),
            bottomIndex = Math.floor(scheduler.rowManager.bottomRow.dataIndex / cacheGridSize.index),
            dependenciesToDraw = [];
      let x, rowIndex, i; // Iterate over virtual dependency grid cells, pushing each dependency that intersects that cell

      for (x = viewLeft; x <= viewRight; x++) {
        for (rowIndex = topIndex; rowIndex <= bottomIndex; rowIndex++) {
          const cacheX = dependencyGridCache[x],
                deps = cacheX === null || cacheX === void 0 ? void 0 : cacheX[rowIndex];

          for (i = 0; deps && i < deps.length; i++) {
            const {
              dependency,
              assignmentData,
              metaId
            } = deps[i],
                  // Unique id for dependency combined with assignment
            flagId = dependency.id + '-' + metaId;

            if (!consideredDependencies.has(flagId)) {
              // Only draw those actually in view
              // pass false for roughly flag to make exact calculations when it's possible
              // fix for https://github.com/bryntum/support/issues/3779
              const bounds = me.getDependencyBounds(dependency, assignmentData, false); // TODO: get rid of this export-specific flag

              if (bounds !== null && bounds !== void 0 && bounds.bounds.intersect(viewBox, true, true) || scheduler.ignoreViewBox) {
                dependenciesToDraw.push([dependency, bounds, assignmentData]);
              }

              consideredDependencies.add(flagId);
            }
          }
        }
      } // Append dependencies to the DOM only after all have been calculated


      dependenciesToDraw.forEach(([dependency, bounds, assignmentData]) => {
        me.drawDependency(dependency, bounds, assignmentData);
      });
    } // Stop forcing recalculation of bounds


    me._resetBoundsCache = false; // Release elements for any dependencies that wasn't drawn

    me.oldDrawnDependencies.forEach(data => me.releaseDependency(data.dependency, data.assignmentData));
    scheduler.trigger('dependenciesDrawn');
    me.isDrawn = true;
  }
  /**
   * Release a dependency that is determined to be no longer visible
   * @param {Scheduler.model.DependencyModel} dependency
   */


  releaseDependency(dependency, assignmentData = null) {
    // Remove for all assignments (related to this client, store might be shared)
    if (assignmentData === true) {
      const clientDataKeys = Object.keys(dependency.meta.map || {}).filter(key => key.startsWith(this.client.id));
      clientDataKeys.forEach(key => {
        const data = dependency.meta.map[key];

        if (data.lineElement) {
          data.lineElement.remove();
          data.lineElement = null;
        }
      });
    } // Remove specific
    else {
      const metaId = this.getMetaId(assignmentData),
            lineElement = dependency.instanceMeta(metaId).lineElement;

      if (lineElement) {
        dependency.instanceMeta(metaId).lineElement = null; // Not reusing elements for other lines currently

        lineElement.remove();
      }
    }
  }

  render() {
    const me = this,
          scheduler = me.client;

    if (me.showTooltip) {
      me.tooltip = me.createTooltip();
    }

    scheduler.timeAxis.on({
      endreconfigure: 'resetGridCache',
      thisObj: me
    });
    scheduler.rowManager.on({
      refresh: 'onRowsRefresh',
      // redraws dependencies after zoom
      changetotalheight: 'onChangeTotalHeight',
      // redrawn dependencies after group collapse
      thisObj: me
    }); // dependencies are drawn on scroll, both horizontal and vertical

    scheduler.on({
      horizontalscroll: 'onHorizontalScroll',
      svgcanvascreated: 'createMarkers',
      togglenode: 'onToggleNode',
      scroll: 'onVerticalScroll',
      timelineviewportresize: 'onViewportResize',
      thisObj: me
    });

    if (me.highlightDependenciesOnEventHover) {
      scheduler.on(scheduler.scheduledEventName + 'MouseEnter', params => me.highlightEventDependencies(params.eventRecord || params.taskRecord));
      scheduler.on(scheduler.scheduledEventName + 'MouseLeave', params => me.unhighlightEventDependencies(params.eventRecord || params.taskRecord));
    }
  }

  renderContents() {
    this.draw();
  } //endregion
  //region Connector sides

  /**
   * Gets displaying item start side
   *
   * @param {Scheduler.model.TimeSpan} timeSpanRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorStartSide(timeSpanRecord) {
    return this.client.currentOrientation.getConnectorStartSide(timeSpanRecord);
  }
  /**
   * Gets displaying item end side
   *
   * @param {Scheduler.model.TimeSpan} timeSpanRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorEndSide(timeSpanRecord) {
    return this.client.currentOrientation.getConnectorEndSide(timeSpanRecord);
  } //endregion
  //region Tooltip


  createTooltip() {
    const me = this,
          scheduler = me.client;
    return _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_7__["default"].new({
      align: 'b-t',
      id: `${scheduler.id}-dependency-tip`,
      //TODO: need some way better to specify this. maybe each feature should be queried?
      forSelector: `.b-timelinebase:not(.b-eventeditor-editing):not(.b-resizing-event):not(.b-dragcreating):not(.b-dragging-event):not(.b-creating-dependency) .${me.baseCls}`,
      forElement: scheduler.timeAxisSubGridElement,
      showOnHover: true,
      hoverDelay: 0,
      hideDelay: 0,
      anchorToTarget: false,
      textContent: false,
      // Skip max-width setting
      trackMouse: false,
      getHtml: me.getHoverTipHtml.bind(me)
    }, me.tooltip || {});
  }
  /**
   * Generates html for the tooltip shown when hovering a dependency
   * @param {Object} tooltipConfig
   * @returns {String} Html to display in the tooltip
   * @private
   */


  getHoverTipHtml({
    activeTarget
  }) {
    const me = this,
          dependency = me.resolveDependencyRecord(activeTarget),
          {
      fromEvent,
      toEvent
    } = dependency;
    return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].tpl`
             <table class="b-sch-dependency-tooltip">
                <tr>
                    <td>${me.L('L{from}')}: </td>
                    <td>${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(fromEvent.name)}</td>
                    <td>
                        <div class="b-sch-box b-${fromBoxSide[dependency.type]}"></div>
                    </td>
                </tr>
                <tr>
                    <td>${me.L('L{to}')}: </td>
                    <td>${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(toEvent.name)}</td>
                    <td><div class="b-sch-box b-${toBoxSide[dependency.type]}"></div></td>
                </tr>
            </table>
        `;
  } //endregion


}
Dependencies._$name = 'Dependencies';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(Dependencies, false, ['Scheduler', 'ResourceHistogram']);
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(Dependencies, true, 'SchedulerPro');

/***/ }),

/***/ "./lib/Scheduler/feature/DependencyEdit.js":
/*!*************************************************!*\
  !*** ./lib/Scheduler/feature/DependencyEdit.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyEdit; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/DisplayField.js */ "./lib/Core/widget/DisplayField.js");
/* harmony import */ var _Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
/* harmony import */ var _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../view/DependencyEditor.js */ "./lib/Scheduler/view/DependencyEditor.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'gantt';
/* eslint-disable no-unused-expressions */










/**
 * @module Scheduler/feature/DependencyEdit
 */

/**
 * Feature that displays a popup containing fields for editing a dependency. Requires the {@link Scheduler.feature.Dependencies Dependencies} feature to be enabled.
 *
 * This feature is **off** by default. It does **not** support vertical mode.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 * @inlineexample Scheduler/feature/Dependencies.js
 * @demo Scheduler/dependencies
 * @classtype dependencyEdit
 * @feature
 */

class DependencyEdit extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__["default"] {
  //region Config
  static get $name() {
    return 'DependencyEdit';
  }

  static get defaultConfig() {
    return {
      /**
       * True to hide this editor if a click is detected outside it (defaults to true)
       * @config {Boolean}
       * @default
       * @category Editor
       */
      autoClose: true,

      /**
       * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
       * @config {Boolean}
       * @default
       * @category Editor
       */
      saveAndCloseOnEnter: true,

      /**
       * True to show a delete button in the form.
       * @config {Boolean}
       * @default
       * @category Editor widgets
       */
      showDeleteButton: true,

      /**
       * The event that shall trigger showing the editor. Defaults to `dependencydblclick`, set to empty string or `null` to disable editing of dependencies.
       * @config {String}
       * @default
       * @category Editor
       */
      triggerEvent: 'dependencydblclick',

      /**
       * True to show the lag field for the dependency
       * @config {Boolean}
       * @default
       * @category Editor widgets
       */
      showLagField: false,
      dependencyRecord: null,

      /**
       * Default editor configuration, used to configure the Popup.
       * @config {Object}
       * @category Editor
       */
      editorConfig: {
        title: 'L{Edit dependency}',
        localeClass: this,
        closable: true,
        defaults: {
          localeClass: this
        },
        items: {
          /**
           * Reference to the from name
           * @member {Core.widget.DisplayField} fromNameField
           * @readonly
           */
          fromNameField: {
            type: 'display',
            label: 'L{From}',
            editable: false
          },

          /**
           * Reference to the to name field
           * @member {Core.widget.DisplayField} toNameField
           * @readonly
           */
          toNameField: {
            type: 'display',
            label: 'L{To}'
          },

          /**
           * Reference to the type field
           * @member {Core.widget.Combo} typeField
           * @readonly
           */
          typeField: {
            type: 'combo',
            label: 'L{Type}',
            name: 'type',
            editable: false,
            valueField: 'id',
            displayField: 'name',
            items: Object.keys(_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_7__["default"].Type).map(type => {
              // Do not remove. Assertion strings for Localization sanity check.
              // 'L{StartToStart}'
              // 'L{StartToEnd}'
              // 'L{EndToStart}'
              // 'L{EndToEnd}'
              return {
                id: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_7__["default"].Type[type],
                name: this.L(type)
              };
            })
          },

          /**
           * Reference to the lag field
           * @member {Core.widget.DurationField} lagField
           * @readonly
           */
          lagField: {
            type: 'duration',
            label: 'L{Lag}',
            name: 'lag',
            allowNegative: true
          }
        },
        bbar: {
          defaults: {
            localeClass: this
          },
          items: {
            foo: {
              type: 'widget',
              cls: 'b-label-filler'
            },

            /**
             * Reference to the save button, if used
             * @member {Core.widget.Button} saveButton
             * @readonly
             */
            saveButton: {
              color: 'b-green',
              text: 'L{Save}'
            },

            /**
             * Reference to the delete button, if used
             * @member {Core.widget.Button} deleteButton
             * @readonly
             */
            deleteButton: {
              color: 'b-gray',
              text: 'L{Delete}'
            },

            /**
             * Reference to the cancel button, if used
             * @member {Core.widget.Button} cancelButton
             * @readonly
             */
            cancelButton: {
              color: 'b-gray',
              text: 'L{Object.Cancel}'
            }
          }
        }
      }
    };
  } //endregion
  //region Init & destroy


  construct(client, config) {
    const me = this;
    client.dependencyEdit = me;
    super.construct(client, config);

    if (!client.features.dependencies) {
      throw new Error('Dependencies feature required when using DependencyEdit');
    }

    me.clientListenersDetacher = client.on({
      [me.triggerEvent]: me.onActivateEditor,
      thisObj: me
    });
  }

  doDestroy() {
    var _this$editor;

    this.clientListenersDetacher();
    (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();
    super.doDestroy();
  } //endregion
  //region Editing


  get editorConfig() {
    return this._editorConfig;
  }

  set editorConfig(editorConfig) {
    const me = this,
          defaultEditorConfig = me.getDefaultConfiguration().editorConfig; // Apply editorConfig to the default editorConfig, allowing users to manipulate for example only bbar

    editorConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, defaultEditorConfig, editorConfig);
    editorConfig.items = editorConfig.items || [];
    me._editorConfig = editorConfig;
  } //endregion
  //region Save


  get isValid() {
    return Object.values(this.editor.widgetMap).every(field => {
      if (!field.name || field.hidden) {
        return true;
      }

      return field.isValid !== false;
    });
  }

  get values() {
    const values = {};
    this.editor.eachWidget(widget => {
      if (!widget.name || widget.hidden) return;
      values[widget.name] = widget.value;
    }, true);
    return values;
  }
  /**
       * Template method, intended to be overridden. Called before the dependency record has been updated.
       * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
       *
       **/


  onBeforeSave(dependencyRecord) {}
  /**
       * Template method, intended to be overridden. Called after the dependency record has been updated.
       * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
       *
       **/


  onAfterSave(dependencyRecord) {}
  /**
       * Updates record being edited with values from the editor
       * @private
       */


  updateRecord(dependencyRecord) {
    const {
      values
    } = this; // Engine does not understand { magnitude, unit } syntax

    if (values.lag) {
      values.lagUnit = values.lag.unit;
      values.lag = values.lag.magnitude;
    } // Type replaces fromSide/toSide, if they are used


    if ('type' in values) {
      dependencyRecord.fromSide != null && (values.fromSide = null);
      dependencyRecord.toSide != null && (values.toSide = null);
    } // Chronograph doesn't filter out undefined fields, it nullifies them instead
    // https://github.com/bryntum/chronograph/issues/11


    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].cleanupProperties(values, true);
    dependencyRecord.set(values);
  } //endregion
  //region Events


  onPopupKeyDown({
    event
  }) {
    if (event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
      // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
      event.preventDefault();
      this.onSaveClick();
    }
  }

  onSaveClick() {
    if (this.save()) {
      this.editor.hide();
    }
  }

  onDeleteClick() {
    this.deleteDependency();
    this.editor.hide();
  }

  onCancelClick() {
    this.editor.hide();
  } //region Editing
  // Called from editDependency() to actually show the editor


  internalShowEditor(dependencyRecord) {
    const me = this,
          scheduler = me.client;
    let showPoint = me.lastPointerDownCoordinate;
    /**
     * Fires on the owning Scheduler before an dependency is displayed in the editor.
     * This may be listened for to allow an application to take over dependency editing duties. Returning `false`
     * stops the default editing UI from being shown.
     * @event beforeDependencyEdit
     * @on-owner
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
     * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
     * @preventable
     */

    if (scheduler.trigger('beforeDependencyEdit', {
      dependencyEdit: me,
      dependencyRecord
    }) === false) {
      return;
    }

    const editor = me.getEditor(dependencyRecord);
    me.loadRecord(dependencyRecord);
    /**
     * Fires on the owning Scheduler when the editor for a dependency is available but before it is shown. Allows
     * manipulating fields before the widget is shown.
     * @event beforeDependencyEditShow
     * @on-owner
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
     * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
     * @param {Core.widget.Popup} editor The editor popup
     */

    scheduler.trigger('beforeDependencyEditShow', {
      dependencyEdit: me,
      dependencyRecord,
      editor
    });

    if (!showPoint) {
      const center = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(me.client.element).center;
      showPoint = [center.x - editor.width / 2, center.y - editor.height / 2];
    }

    editor.showByPoint(showPoint);
  }
  /**
   * Opens a popup to edit the passed dependency.
   * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency to edit
   */


  editDependency(dependencyRecord) {
    if (this.client.readOnly) return;
    this.internalShowEditor(dependencyRecord);
  } //endregion
  //region Save

  /**
   * Gets an editor instance. Creates on first call, reuses on consecutive
   * @internal
   * @returns {Scheduler.view.DependencyEditor} Editor popup
   */


  getEditor() {
    var _me$saveButton, _me$deleteButton, _me$cancelButton;

    const me = this;
    let {
      editor
    } = me;

    if (editor) {
      return editor;
    }

    editor = me.editor = _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_5__["default"].new({
      dependencyEditFeature: me,
      autoShow: false,
      anchor: true,
      scrollAction: 'realign',
      constrainTo: window,
      autoClose: me.autoClose,
      cls: me.cls,
      rootElement: me.client.rootElement,
      listeners: {
        keydown: me.onPopupKeyDown,
        thisObj: me
      }
    }, me.editorConfig);

    if (editor.items.length === 0) {
      console.warn('Editor configured without any `items`');
    } // assign widget refs


    editor.eachWidget(widget => {
      const ref = widget.ref || widget.id; // don't overwrite if already defined

      if (ref && !me[ref]) {
        me[ref] = widget;
      }
    });
    (_me$saveButton = me.saveButton) === null || _me$saveButton === void 0 ? void 0 : _me$saveButton.on('click', me.onSaveClick, me);
    (_me$deleteButton = me.deleteButton) === null || _me$deleteButton === void 0 ? void 0 : _me$deleteButton.on('click', me.onDeleteClick, me);
    (_me$cancelButton = me.cancelButton) === null || _me$cancelButton === void 0 ? void 0 : _me$cancelButton.on('click', me.onCancelClick, me);
    return me.editor;
  } //endregion
  //region Delete

  /**
   * Sets fields values from record being edited
   * @private
   */


  loadRecord(dependency) {
    const me = this;
    me.fromNameField.value = dependency.fromEvent.name;
    me.toNameField.value = dependency.toEvent.name;

    if (me.lagField) {
      me.lagField.value = new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_8__["default"](dependency.lag, dependency.lagUnit);
    }

    me.editor.record = me.dependencyRecord = dependency;
  } //endregion
  //region Stores

  /**
   * Saves the changes (applies them to record if valid, if invalid editor stays open)
   * @private
   * @fires beforeDependencySave
   * @fires beforeDependencyAdd
   * @fires afterDependencySave
   * @returns {*}
   */


  async save() {
    const me = this,
          {
      client,
      dependencyRecord
    } = me;

    if (!dependencyRecord || !me.isValid) {
      return;
    }

    const {
      dependencyStore,
      values
    } = me;
    /**
     * Fires on the owning Scheduler before a dependency is saved
     * @event beforeDependencySave
     * @on-owner
     * @param {Scheduler.view.Scheduler} source The scheduler instance
     * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
     * @param {Object} values The new values
     * @preventable
     */

    if (client.trigger('beforeDependencySave', {
      dependencyRecord,
      values
    }) !== false) {
      var _client$project;

      me.onBeforeSave(dependencyRecord);
      me.updateRecord(dependencyRecord); // Check if this is a new record

      if (dependencyStore && !dependencyRecord.stores.length) {
        /**
         * Fires on the owning Scheduler before a dependency is added
         * @event beforeDependencyAdd
         * @on-owner
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependency edit feature
         * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be added
         * @preventable
         */
        if (client.trigger('beforeDependencyAdd', {
          dependencyRecord,
          dependencyEdit: me
        }) === false) {
          return;
        }

        dependencyStore.add(dependencyRecord);
      }

      await ((_client$project = client.project) === null || _client$project === void 0 ? void 0 : _client$project.commitAsync());
      /**
       * Fires on the owning Scheduler after a dependency is successfully saved
       * @event afterDependencySave
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler instance
       * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
       */

      client.trigger('afterDependencySave', {
        dependencyRecord
      });
      me.onAfterSave(dependencyRecord);
    }

    return dependencyRecord;
  }
  /**
   * Delete dependency being edited
   * @private
   * @fires beforeDependencyDelete
   */


  async deleteDependency() {
    const {
      client,
      editor,
      dependencyRecord
    } = this;
    /**
     * Fires on the owning Scheduler before a dependency is deleted
     * @event beforeDependencyDelete
     * @on-owner
     * @param {Scheduler.view.Scheduler} source The scheduler instance
     * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record about to be deleted
     * @preventable
     */

    if (client.trigger('beforeDependencyDelete', {
      dependencyRecord
    }) !== false) {
      var _client$project2;

      if (editor.containsFocus) {
        editor.revertFocus();
      }

      client.dependencyStore.remove(dependencyRecord);
      await ((_client$project2 = client.project) === null || _client$project2 === void 0 ? void 0 : _client$project2.commitAsync());
      return true;
    }

    return false;
  }

  get dependencyStore() {
    return this.client.dependencyStore;
  } //endregion
  //region Events


  onActivateEditor({
    dependency,
    event
  }) {
    if (!this.disabled) {
      this.lastPointerDownCoordinate = [event.clientX, event.clientY];
      this.editDependency(dependency);
    }
  } //endregion


}
DependencyEdit._$name = 'DependencyEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(DependencyEdit, false);

/***/ }),

/***/ "./lib/Scheduler/feature/EventContextMenu.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/EventContextMenu.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventContextMenu; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _EventMenu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/feature/EventContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.EventMenu EventMenu} feature instead.**
 *
 * Displays a context menu for events. Items are populated by other features and/or application code.
 *
 * This feature is **off** by default in favor of `EventMenu`.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @deprecated 4.0.0
 * @extends Scheduler/feature/EventMenu
 * @classtype eventContextMenu
 * @feature
 */

class EventContextMenu extends _EventMenu_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'EventContextMenu';
  }

  construct(scheduler, config) {
    super.construct(...arguments);
    this.scheduler = scheduler;
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', '`EventContextMenu` feature is deprecated, in favor of `EventMenu` feature. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'); // If this feature is enabled, need to disable EventMenu. They are mutually exclusive.

    if (scheduler.features.eventMenu) {
      scheduler.features.eventMenu.disabled = true;
    }
  } //endregion
  //region Events

  /**
   * This event fires on the owning Scheduler before the context menu is shown for an event. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
   * being shown.
   * @event eventContextMenuBeforeShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to eventMenuBeforeShow
   * @preventable
   * @param {Scheduler.view.Scheduler} source
   * @param {Object} items Menu item configs
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler when an item is selected in the context menu.
   * @event eventContextMenuItem
   * @on-owner
   * @deprecated 4.0.0 Renamed to eventMenuItem
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.MenuItem} item
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler after showing the context menu for an event
   * @event eventContextMenuShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to eventMenuShow
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */
  //endregion


}
EventContextMenu.featureClass = '';
EventContextMenu._$name = 'EventContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(EventContextMenu);
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(EventContextMenu, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventCopyPaste.js":
/*!*************************************************!*\
  !*** ./lib/Scheduler/feature/EventCopyPaste.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventCopyPaste; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/mixin/KeyMap.js */ "./lib/Core/widget/mixin/KeyMap.js");
/* harmony import */ var _ScheduleContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ScheduleContext.js */ "./lib/Scheduler/feature/ScheduleContext.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/EventCopyPaste
 */

/**
 * Allow using [Ctrl/CMD + C/X] and [Ctrl/CMD + V] to copy/cut and paste events. This feature also adds entries
 * to the {@link Scheduler.feature.EventMenu} (see example below for how to configure). You can configure how a newly pasted record
 * is named using {@link #function-generateNewName}
 *
 * This feature is **enabled** by default
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventCopyPaste : true
 *     }
 * });
 * ```
 *
 * ```javascript
 * // Custom copy text + remove cut option from event menu:
 * const scheduler = new Scheduler({
 *     features : {
 *         eventCopyPaste : true,
 *         eventMenu : {
 *             items : {
 *                 copyEvent : {
 *                     text : 'Copy booking'
 *                 },
 *                 cutEvent  : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Keyboard shortcuts
 *
 * By default, this feature will react to Ctrl+C, Ctrl+X and Ctrl+V for standard clipboard actions.
 * You can reconfigure the keys used to trigger these actions, {@link #config-keyMap} for more details.
 *
 * @extends Core/mixin/InstancePlugin
 * @inlineexample Scheduler/feature/EventCopyPaste.js
 * @classtype eventCopyPaste
 * @feature
 */

class EventCopyPaste extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'EventCopyPaste';
  }

  static get pluginConfig() {
    return {
      assign: ['copyEvents', 'pasteEvents'],
      chain: ['onElementKeyDown', 'populateEventMenu', 'populateScheduleMenu', 'onEventDataGenerated']
    };
  }

  static get configurable() {
    return {
      /**
       * The field to use as the name field when updating the name of copied records
       * @config {String}
       * @default
       */
      nameField: 'name',

      /**
       * The feature has the following default key mappings during editing:
       *
       * | Keys        | Action       |
       * |-------------|--------------|
       * | Ctrl+C      | copy         |
       * | Ctrl+X      | cut          |
       * | Ctrl+V      | paste        |
       *
       * You can supply your own key map if you want to change any mapping, or set it to `null` to disable all keyboard
       * shortcuts.
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *    features : {
       *        eventCopyPaste : {
       *            keyMap : {
       *                // disable cut via keyboard
       *                'Ctrl-X' : null
       *            }
       *        }
       *    }
       * });
       * ```
       *
       * @config {Object}
       */
      keyMap: {
        'Ctrl+C': 'copy',
        'Ctrl+X': 'cut',
        'Ctrl+V': 'paste'
      }
    };
  }

  static get properties() {
    return {
      clipboardRecords: []
    };
  }

  construct(scheduler, config) {
    super.construct(scheduler, config); // enable scheduleContext to highlight cell on click to paste

    if (scheduler.features.scheduleContext) {
      scheduler.features.scheduleContext.disabled = false;
    }

    scheduler.on('scheduleclick', this.onSchedulerClick, this);
    this.scheduler = scheduler;
  }

  onEventDataGenerated(eventData) {
    const {
      eventRecord
    } = eventData;
    eventData.cls['b-cut-item'] = eventRecord.meta.isCut;
  }

  onSchedulerClick(context) {
    this._cellClickedContext = context;
  }

  onElementKeyDown(event) {
    const me = this,
          cellEdit = me.client.features.cellEdit; // No action if
    // 1. there is selected text on the page
    // 2. cell editing is active
    // 3. cursor is not in the grid (filter bar etc)

    if (!me.disabled && window.getSelection().toString().length === 0 && (!cellEdit || !cellEdit.isEditing) && event.target.closest('.b-grid-body-container')) {
      me.performKeyMapAction(event);
    }
  }

  copy() {
    this.copyEvents();
  }

  cut() {
    this.copyEvents(undefined, true);
  }

  paste() {
    this.pasteEvents();
  }
  /**
   * Copy events to clipboard to paste later
   * @fires beforeCopy
   * @param {Scheduler.model.EventModel[]} [records] Uses `selectedAssignments` by default, pass other records to copy them
   * @param {Boolean} [isCut] Copies by default, pass `true` to cut
   * @category Edit
   */


  copyEvents(records = this.client.selectedEvents, isCut = false) {
    const me = this,
          {
      scheduler
    } = me;
    /**
     * Fires on the owning Scheduler before a copy action is performed, return `false` to prevent the action
     * @event beforeCopy
     * @preventable
     * @on-owner
     * @param {Scheduler.view.Scheduler} source Owner scheduler
     * @param {Scheduler.model.EventModel[]} records The event records about to be copied
     * @param {Boolean} isCut `true` if this is a cut action
     */

    if (scheduler.readOnly || scheduler.trigger('beforeCopy', {
      records,
      isCut
    }) === false) {
      return;
    }

    me._isCut = isCut; // records is used when call comes from context menu where the current event is the context

    me.clipboardRecords = records;
    scheduler.eventStore.forEach(rec => {
      rec.meta.isCut = me._isCut && me.clipboardRecords.includes(rec);
    }); // refresh to call onEventDataGenerated and reapply the cls for records where the cut was canceled

    scheduler.refreshWithTransition();
  }
  /**
   * Paste events to date/resource to assign
   * @fires beforePaste
   *
   * @param {Date} [date] The date where the event(s) will be pasted
   * @param {Scheduler.model.ResourceModel} [resourceRecord] The resource to assign the pasted event(s) to
   * @category Edit
   */


  pasteEvents(date, resourceRecord) {
    const me = this,
          {
      clipboardRecords,
      scheduler
    } = me;

    if (arguments.length === 0) {
      var _scheduler$selectedAs;

      const context = me._cellClickedContext || {};
      date = context.date; // If user only clicked an event, and no cells - fall back to that assignment´s resource

      resourceRecord = context.resourceRecord || ((_scheduler$selectedAs = scheduler.selectedAssignments[0]) === null || _scheduler$selectedAs === void 0 ? void 0 : _scheduler$selectedAs.resource);
    }
    /**
     * Fires on the owning Scheduler before a paste action is performed, return `false` to prevent the action
     * @event beforePaste
     * @preventable
     * @on-owner
     * @param {Scheduler.view.Scheduler} source Owner scheduler
     * @param {Scheduler.model.EventModel[]} records The records about to be pasted
     * @param {Date} date The date when the pasted events will be scheduled
     * @param {Scheduler.model.ResourceModel} resourceRecord The target resource record, the clipboard
     * event records will be assigned to this resource.
     * @param {Boolean} isCut `true` if this is a cut action
     */


    if (!clipboardRecords.length || scheduler.trigger('beforePaste', {
      records: clipboardRecords,
      resourceRecord,
      date,
      isCut: me._isCut
    }) === false) {
      return;
    }

    clipboardRecords.forEach(clipboardRecord => {
      const recCfg = {};

      if (date) {
        Object.assign(recCfg, {
          startDate: date,
          duration: clipboardRecord.duration,
          durationUnit: clipboardRecord.durationUnit
        });
      }

      if (me._isCut) {
        clipboardRecord.set(recCfg);
        clipboardRecord.meta.isCut = false;
      } else {
        clipboardRecord = clipboardRecord.copy(recCfg);
        clipboardRecord.name = me.generateNewName(clipboardRecord);
        scheduler.eventStore.add(clipboardRecord);
      }

      if (resourceRecord) {
        scheduler.eventStore.assignEventToResource(clipboardRecord, resourceRecord);
      }
    });

    if (me._isCut) {
      // reset clipboard
      me._isCut = false;
      me.clipboardRecords = [];
    }
  }

  populateEventMenu({
    eventRecord,
    items
  }) {
    const me = this;

    if (!me.scheduler.readOnly) {
      items.copyEvent = {
        text: 'L{copyEvent}',
        localeClass: me,
        icon: 'b-icon b-icon-copy',
        weight: 110,
        onItem: () => me.copyEvents([eventRecord], false)
      };
      items.cutEvent = {
        text: 'L{cutEvent}',
        localeClass: me,
        icon: 'b-icon b-icon-cut',
        weight: 120,
        onItem: () => me.copyEvents([eventRecord], true)
      };
    }
  }

  populateScheduleMenu({
    items
  }) {
    const me = this,
          {
      scheduler
    } = me;

    if (!scheduler.readOnly && me.clipboardRecords.length) {
      items.pasteEvent = {
        text: 'L{pasteEvent}',
        localeClass: me,
        icon: 'b-icon b-icon-paste',
        disabled: scheduler.resourceStore.count === 0,
        weight: 110,
        onItem: ({
          date,
          resourceRecord
        }) => me.pasteEvents(date, resourceRecord, scheduler.getRowFor(resourceRecord))
      };
    }
  }
  /**
   * A method used to generate the name for a copy pasted record. By defaults appends "- 2", "- 3" as a suffix.
   *
   * @param {Scheduler.model.EventModel} eventRecord The new eventRecord being pasted
   * @return {String}
   */


  generateNewName(eventRecord) {
    const originalName = eventRecord[this.nameField];
    let counter = 2;

    while (this.client.eventStore.findRecord(this.nameField, `${originalName} - ${counter}`)) {
      counter++;
    }

    return `${originalName} - ${counter}`;
  }

}
EventCopyPaste.featureClass = 'b-event-copypaste';
EventCopyPaste._$name = 'EventCopyPaste';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventCopyPaste, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventDrag.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventDrag.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDrag; });
/* harmony import */ var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
/* eslint-disable no-unused-expressions */







/**
 * @module Scheduler/feature/EventDrag
 */
//TODO: relay events as in Dependencies. (drag -> eventdrag etc)
//TODO: shift to copy
//TODO: dragging of event that starts & ends outside of view

/**
 * Allows user to drag and drop events within the scheduler, to change startDate or resource assignment.
 *
 * This feature is **enabled** by default
 *
 * ## Customizing the drag drop tooltip
 *
 * To show custom HTML in the tooltip, please see the {@link #config-tooltipTemplate} config. Example:
 *
 * ```javascript
 * features: {
 *     eventDrag : {
 *         // A minimal start date tooltip
 *         tooltipTemplate : ({ eventRecord, startDate }) => {
 *             return DateHelper.format(startDate, 'HH:mm');
 *         }
 *     }
 * }
 * ```
 * @example
 * // constrain drag to current resource
 * let scheduler = new Scheduler({
 *   features: {
 *     eventDrag: {
 *       constrainDragToResource: true
 *     }
 *   }
 * });
 *
 * @extends Scheduler/feature/base/DragBase
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/EventDrag.js
 * @classtype eventDrag
 * @feature
 */

class EventDrag extends _base_DragBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'EventDrag';
  }

  static get defaultConfig() {
    return {
      /**
       * Template used to generate drag tooltip contents.
       * ```
       * const scheduler = new Scheduler({
       *   features : {
       *     eventDrag : {
       *       dragTipTemplate({eventRecord, startText}) {
       *         return `${eventRecord.name}: ${startText}`
       *       }
       *     }
       *   }
       * });
       * ```
       * @config {Function} tooltipTemplate
       * @param {Object} data Tooltip data
       * @param {Scheduler.model.EventModel} data.eventRecord
       * @param {Boolean} data.valid Currently over a valid drop target or not
       * @param {Date} data.startDate New start date
       * @param {Date} data.endDate New end date
       * @param {String} data.startText [DEPRECATED] Formatted new start date
       * @param {String} data.endText [DEPRECATED] Formatted new end date
       * @param {String} data.startClockHtml [DEPRECATED] Pre-generated HTML to display startDate as clock/calendar
       * @param {String} data.endClockHtml [DEPRECATED] Pre-generated HTML to display endDate as clock/calendar
       * @param {Object} data.dragData [DEPRECATED] Detailed drag context
       * @returns {String}
       */

      /**
       * Set to true to only allow dragging events within the same resource.
       * @member {Boolean} constrainDragToResource
       */

      /**
       * Set to true to only allow dragging events within the same resource.
       * @config {Boolean}
       * @default
       */
      constrainDragToResource: false,

      /**
       * Set to true to only allow dragging events to different resources, and disallow rescheduling by dragging.
       * @member {Boolean} constrainDragToTimeSlot
       */

      /**
       * Set to true to only allow dragging events to different resources, and disallow rescheduling by dragging.
       * @config {Boolean}
       * @default
       */
      constrainDragToTimeSlot: false,

      /**
       * An empty function by default, but provided so that you can perform custom validation on
       * the item being dragged. This function is called during the drag and drop process and also after the drop is made.
       * Return true if the new position is valid, false to prevent the drag.
       * @param {Object} context A drag drop context object
       * @param {Date} context.startDate New start date
       * @param {Date} context.endDate New end date
       * @param {Scheduler.model.AssignmentModel[]} context.assignmentRecords Assignment records which were dragged
       * @param {Scheduler.model.EventModel[]} context.draggedRecords  **Deprecated** in 4.0. Use `context.eventRecords` instead.
       * @param {Scheduler.model.EventModel[]} context.eventRecords Event records which were dragged
       * @param {Scheduler.model.ResourceModel} context.newResource New resource record
       * @param {Event} event The event object
       * @return {Boolean|Object} `true` if this validation passes, `false` if it does not.
       *
       * Or an object with 2 properties: `valid` -  Boolean `true`/`false` depending on validity,
       * and `message` - String with a custom error message to display when invalid.
       * @config {Function}
       */
      validatorFn: () => {},

      /**
       * The `this` reference for the validatorFn
       * @config {Object}
       */
      validatorFnThisObj: null,

      /**
       * * When the host Scheduler is `{@link Scheduler.view.mixin.EventSelection#config-multiEventSelect multiEventSelect}: true`
       * then, there are two modes of dragging *within the same Scheduler*.
       *
       * Non unified means that all selected events are dragged by the same number of resource rows.
       *
       * Unified means that all selected events are collected together and dragged as one, and are all dropped
       * on the same targeted resource row at the same targeted time.
       * @member {Boolean} unifiedDrag
       */

      /**
       * When the host Scheduler is `{@link Scheduler.view.mixin.EventSelection#config-multiEventSelect multiEventSelect}: true`
       * then, there are two modes of dragging *within the same Scheduler*.
       *
       * Non unified means that all selected events are dragged by the same number of resource rows.
       *
       * Unified means that all selected events are collected together and dragged as one, and are all dropped
       * on the same targeted resource row at the same targeted time.
       * @config {Boolean}
       * @default false
       */
      unifiedDrag: null
    };
  } //endregion
  //region Events

  /**
   * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  scheduler.on('beforeeventdropfinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * Changing record data during drag is not supported.
   *
   * @event beforeEventDropFinalize
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Object} context
   * @param {Boolean} context.async Set true to handle dragdrop asynchronously (e.g. to wait for user confirmation)
   * @param {Scheduler.model.EventModel[]} context.eventRecords Event records being dragged
   * @param {Scheduler.model.AssignmentModel[]} context.assignmentRecords Assignment records being dragged
   * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
   * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
   * @param {Function} context.finalize Call this method to finalize drag drop. This method accepts one
   * argument: pass true to update records, or false, to ignore changes
   */

  /**
   * Fired on the owning Scheduler after event drop
   * @event afterEventDrop
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
   * @param {Scheduler.model.EventModel[]} eventRecords
   * @param {Boolean} valid
   * @param {Object} context
   */

  /**
   * Fired on the owning Scheduler when an event is dropped
   * @event eventDrop
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Scheduler.model.EventModel[]} eventRecords
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
   * @param {Boolean} isCopy
   * @param {Object} context
   * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
   * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
   */

  /**
   * Fired on the owning Scheduler before event dragging starts. Return `false` to prevent the action.
   * @event beforeEventDrag
   * @on-owner
   * @preventable
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel} eventRecord Event record the drag starts from
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record the drag starts from
   * @param {Scheduler.model.EventModel[]} eventRecords Event records being dragged
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords Assignment records being dragged
   * @param {MouseEvent} event Browser event
   * @param {Object} context **Deprecated** in 4.1.1
   */

  /**
   * Fired on the owning Scheduler when event dragging starts
   * @event eventDragStart
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record the drag starts from
   * @param {Scheduler.model.EventModel[]} eventRecords Event records being dragged
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords Assignment records being dragged
   * @param {MouseEvent} event Browser event
   * @param {Object} context **Deprecated** in 4.1.1
   */

  /**
   * Fired on the owning Scheduler when event is dragged
   * @event eventDrag
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel[]} eventRecords Event records being dragged
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords Assignment records being dragged
   * @param {Date} startDate
   * @param {Date} endDate
   * @param {Scheduler.model.ResourceModel} newResource
   * @param {Object} context **Deprecated** in 4.1.1
   */

  /**
   * Fired on the owning Scheduler after an event drag operation has been aborted
   * @event eventDragAbort
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel[]} eventRecords Event records being dragged
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecords Assignment records being dragged
   * @param {Object} context **Deprecated** in 4.1.1
   */
  //endregion
  //region Data layer
  // Deprecated. Use this.client instead


  get scheduler() {
    return this.client;
  } //endregion
  //region Drag events


  isElementDraggable(el, event) {
    const {
      scheduler
    } = this,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(el, scheduler.eventSelector),
          {
      eventResize
    } = scheduler.features;

    if (!eventElement || this.disabled) {
      return false;
    } // displaying something resizable within the event?


    if (el.matches('[class$="-handle"]')) {
      return false;
    }

    const // It is possible to click element for non-existing event. It works like this:
    // 1. you drag create event with eventEdit feature turned on
    // 2. you click event element
    // 3. editor loses focus, removes record from the store, but `remove` event is not triggered until project
    // update
    eventRecord = scheduler.resolveEventRecord(eventElement),
          eventResizable = eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.resizable,
          resizable = eventResizable && // EventResize feature present?
    eventResize && !eventResize.disabled && // Milestones cannot be resized
    !eventRecord.isMilestone && ( // over a virtual handle?
    (eventResizable === true || eventResizable === 'start') && eventResize.isOverStartHandle(event, eventElement) || (eventResizable === true || eventResizable === 'end') && eventResize.isOverEndHandle(event, eventElement));
    return !resizable && !scheduler.readOnly;
  }

  getTriggerParams(dragData) {
    const {
      assignmentRecords,
      eventRecords,
      resourceRecord,
      browserEvent: event
    } = dragData;
    return {
      // `context` to be deprecated
      context: dragData,
      // Backward compatibility, `draggedRecords` is deprecated
      draggedRecords: eventRecords,
      eventRecords,
      resourceRecord,
      assignmentRecords,
      event
    };
  }

  triggerEventDrag(dragData, start) {
    // If there has been a change...
    if (dragData.startDate - start !== 0 || dragData.newResource !== dragData.resourceRecord) {
      this.scheduler.trigger('eventDrag', Object.assign(this.getTriggerParams(dragData), {
        startDate: dragData.startDate,
        endDate: dragData.endDate,
        newResource: dragData.newResource
      }));
    }
  }

  triggerDragStart(dragData) {
    this.drag.startEvent.ignoreNavigation = true;
    this.scheduler.trigger('eventDragStart', this.getTriggerParams(dragData));
  }

  triggerDragAbort(dragData) {
    this.scheduler.trigger('eventDragAbort', this.getTriggerParams(dragData));
  }

  triggerAfterDrop(dragData, valid) {
    this.currentOverClient.trigger('afterEventDrop', Object.assign(this.getTriggerParams(dragData), {
      valid
    }));
  }

  onDragAbort() {
    // Edge cases:
    // 1. If this drag was a no-op, and underlying data was changed while drag was ongoing (e.g. web socket
    // push), we need to manually force a view refresh to ensure a correct render state
    //
    // or
    // 2. Events were removed before we dropped at an invalid point
    const {
      assignmentStore,
      eventStore
    } = this.client,
          needRefresh = this.dragData.initialAssignmentsState.find(({
      resource,
      assignment
    }, i) => {
      var _this$dragData$assign;

      return !assignmentStore.includes(assignment) || !eventStore.includes(assignment.event) || resource.id !== ((_this$dragData$assign = this.dragData.assignmentRecords[i]) === null || _this$dragData$assign === void 0 ? void 0 : _this$dragData$assign.resourceId);
    });

    if (needRefresh) {
      this.client.refresh();
    }

    super.onDragAbort(...arguments);
  } //endregion
  //region Finalization & validation

  /**
   * Checks if an event can be dropped on the specified resource.
   * @private
   * @returns {Boolean} Valid (true) or invalid (false)
   */


  isValidDrop(dragData) {
    const {
      newResource,
      resourceRecord
    } = dragData,
          sourceRecord = dragData.draggedEntities[0]; // Not allowed to drop an event to group header

    if (!newResource || newResource.isSpecialRow) {
      return false;
    } // Not allowed to assign an event twice to the same resource


    if (resourceRecord !== newResource) {
      return !sourceRecord.event.resources.includes(newResource);
    }

    return true;
  }

  checkDragValidity(dragData, event) {
    const me = this,
          scheduler = me.currentOverClient;
    let result = me.dragData.context.valid;

    if (result) {
      // First make sure DragHelper thinks it's a valid drag, then scheduler domain checks
      if (!scheduler.allowOverlap && !scheduler.isDateRangeAvailable(dragData.startDate, dragData.endDate, dragData.draggedEntities[0], dragData.newResource)) {
        result = {
          valid: false,
          message: me.L('L{eventOverlapsExisting}')
        };
      } else {
        result = me.validatorFn.call(me.validatorFnThisObj || me, dragData, event);
      }
    }

    return result;
  } //endregion
  //region Update records

  /**
   * Update events being dragged.
   * @private
   * @param context Drag data.
   * @async
   */


  async updateRecords(context) {
    const me = this,
          fromScheduler = me.scheduler,
          toScheduler = me.currentOverClient,
          copyKeyPressed = false;
    fromScheduler.eventStore.suspendAutoCommit();
    toScheduler.eventStore.suspendAutoCommit();
    const result = await me.updateAssignments(fromScheduler, toScheduler, context, copyKeyPressed);
    fromScheduler.eventStore.resumeAutoCommit();
    toScheduler.eventStore.resumeAutoCommit(); // Tell the world there was a successful drop

    toScheduler.trigger('eventDrop', Object.assign(me.getTriggerParams(context), {
      isCopy: copyKeyPressed,
      event: context.browserEvent,
      targetEventRecord: context.targetEventRecord,
      targetResourceRecord: context.newResource
    }));
    return result;
  }
  /**
   * Update assignments being dragged
   * @private
   * @async
   */


  async updateAssignments(fromScheduler, toScheduler, context, copy) {
    // The code is written to emit as few store events as possible
    const me = this,
          isCrossScheduler = fromScheduler !== toScheduler,
          isVertical = toScheduler.mode === 'vertical',
          {
      assignmentStore: fromAssignmentStore,
      eventStore: fromEventStore,
      resourceStore
    } = fromScheduler,
          {
      assignmentStore: toAssignmentStore,
      eventStore: toEventStore,
      resourceStore: toResourceStore
    } = toScheduler,
          {
      eventRecords,
      assignmentRecords,
      timeDiff,
      initialAssignmentsState,
      resourceRecord: fromResource,
      newResource: toResource
    } = context,
          unifiedDrag = me.unifiedDrag,
          event1Date = me.adjustStartDate(assignmentRecords[0].event.startDate, timeDiff),
          eventsToAdd = [],
          eventsToRemove = [],
          assignmentsToAdd = [],
          assignmentsToRemove = [],
          eventsToCheck = [],
          resourcesToRefresh = new Set(),
          eventsToBatch = new Set();
    fromScheduler.suspendRefresh();
    toScheduler.suspendRefresh();
    let updated = false,
        updatedEvent = false,
        indexDiff; // By how many resource rows has the drag moved.

    if (isCrossScheduler) {
      // The difference in indices via first dragged event will help us to find resources for all the rest events accordingly
      indexDiff = toResourceStore.indexOf(toResource) - resourceStore.indexOf(fromResource);
    } else {
      indexDiff = me.constrainDragToResource ? 0 : resourceStore.indexOf(fromResource) - resourceStore.indexOf(toResource);
    }

    if (isVertical) {
      // TODO : Broken after merge, figure it out
      eventRecords.forEach((draggedEvent, i) => {
        const eventBar = context.eventBarEls[i];
        delete draggedEvent.instanceMeta(fromScheduler).hasTemporaryDragElement; // If it was created by a call to scheduler.currentOrientation.addTemporaryDragElement
        // then release it back to be available to DomSync next time the rendered event block
        // is synced.

        if (eventBar.dataset.transient) {
          eventBar.remove();
        }
      });
    }

    const eventBarEls = context.eventBarEls.slice(); // Using for to support await inside

    for (let i = 0; i < assignmentRecords.length; i++) {
      // Reassigned when dropped on other scheduler, thus not const
      let draggedAssignment = assignmentRecords[i],
          draggedEvent = draggedAssignment.event;

      if (!draggedAssignment.isOccurrenceAssignment && (!fromAssignmentStore.includes(draggedAssignment) || !fromEventStore.includes(draggedEvent))) {
        // Event was removed externally during the drag, just remove element from DOM (DomSync already has
        // tried to clean it up at this point, but could not due to retainElement being set)
        eventBarEls[i].remove();
        eventBarEls.splice(i, 1);
        assignmentRecords.splice(i, 1);
        i--;
        continue;
      }

      const initialState = initialAssignmentsState[i],
            originalEventRecord = draggedEvent,
            originalStartDate = initialState.startDate,
            // grabbing resource early, since after ".copy()" the record won't belong to any store
      // and ".getResources()" won't work. If it's a move to another scheduler, ensure the
      // array still has a length. The process function will do an assign as opposed
      // to a reassign
      originalResourceRecord = initialState.resource,
            // Calculate new startDate (and round it) based on timeDiff up here, might be added to another
      // eventstore below in which case it is invalidated. But this is anyway the target date
      newStartDate = this.constrainDragToTimeSlot ? originalStartDate : unifiedDrag ? event1Date : me.adjustStartDate(originalStartDate, timeDiff);
      resourcesToRefresh.add(originalResourceRecord);

      if (copy) {
        draggedAssignment = draggedAssignment.copy(null);
        assignmentsToAdd.push(draggedAssignment);
      } // Dropped on another scheduler, not sharing assignmentStore
      else if (fromAssignmentStore !== toAssignmentStore) {
        const // Single assignment from a multi assigned event dragged over, event needs to be copied over
        keepEvent = originalEventRecord.assignments.length > 1,
              newAssignment = draggedAssignment.copy(); // Remove assignment from source scheduler

        assignmentsToRemove.push(draggedAssignment); // If it was the last assignment, the event should also be removed

        if (!keepEvent) {
          eventsToRemove.push(originalEventRecord);
        } // If event does not already exist in target scheduler a copy is added


        if (!toEventStore.getById(originalEventRecord.id)) {
          // Clone keeping the same id
          const clonedData = Object.assign({}, originalEventRecord.data, {
            id: originalEventRecord.id,
            // Engine gets mad if not nulled
            calendar: null
          });
          draggedEvent = clonedData;
          eventsToAdd.push(clonedData);
        } // And add it to the target scheduler
        // TODO: Should be handled on the data layer ideally


        if (!toEventStore.usesSingleAssignment) {
          assignmentsToAdd.push(newAssignment);
        }

        draggedAssignment = newAssignment;
      }

      let newResource = toResource;

      if (!unifiedDrag) {
        if (!isCrossScheduler) {
          // If not dragging events as a unified block, distribute each to a new resource
          // using the same offset as the dragged event.
          if (indexDiff !== 0) {
            const newIndex = Math.max(Math.min(resourceStore.indexOf(originalResourceRecord) - indexDiff, resourceStore.count - 1), 0);
            newResource = resourceStore.getAt(newIndex);
          } else {
            newResource = originalResourceRecord;
          }
        } // we have a resource for first dragged event in toResource
        else if (i > 0) {
          const draggedEventResourceIndex = originalResourceRecord.resourceStore.indexOf(originalResourceRecord);
          newResource = newResource.resourceStore.getAt(draggedEventResourceIndex + indexDiff) || newResource;
        }
      }

      resourcesToRefresh.add(newResource); // Cannot rely on assignment generation to detect update, since it might be a new assignment

      if (draggedAssignment.resource !== newResource) {
        draggedAssignment.resource = newResource; // Actual events should be batched, not data for new events when dragging between

        draggedEvent.isEvent && eventsToBatch.add(draggedEvent);
        updated = true; // When dragging an occurrence, the assignment is only temporary. We have to tag the newResource along
        // to be picked up by the occurrence -> event conversion
        // TODO: A hack, figure a better way out

        if (draggedEvent.isOccurrence) {
          draggedEvent.set('newResource', newResource);
        } // TODO: Should be handled on the datalayer somehow, but it is kind of edge casey


        if (isCrossScheduler && toEventStore.usesSingleAssignment) {
          // In single assignment mode, when dragged to another scheduler it will not copy the assignment
          // over but instead set the resourceId of the event. To better match expected behaviour
          draggedEvent.resourceId = newResource.id;
        }
      } // Same for event


      if (!eventsToCheck.find(ev => ev.draggedEvent === draggedEvent) && !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(draggedEvent.startDate, newStartDate)) {
        var _draggedEvent$resourc;

        draggedEvent.startDate = newStartDate;
        eventsToCheck.push({
          draggedEvent,
          originalStartDate
        });
        draggedEvent.isEvent && eventsToBatch.add(draggedEvent);
        updatedEvent = true; // When changing date, all assignments are affected so might need to redraw more resources
        // (might be a clone, no resources then)

        (_draggedEvent$resourc = draggedEvent.resources) === null || _draggedEvent$resourc === void 0 ? void 0 : _draggedEvent$resourc.forEach(resource => resourcesToRefresh.add(resource));
      }
    }

    fromAssignmentStore.remove(assignmentsToRemove);
    fromEventStore.remove(eventsToRemove);
    toAssignmentStore.add(assignmentsToAdd);
    const addedEvents = toEventStore.add(eventsToAdd); // When not constrained to timeline we are dragging a clone and need to manually do some cleanup if
    // dropped in view

    if (!me.constrainDragToTimeline) {
      // go through assignmentRecords again after events has been added to toEventStore (if any)
      // now we have updated assignment ids and can properly reuse event HTML elements
      for (let i = 0; i < assignmentRecords.length; i++) {
        const originalDraggedEvent = assignmentRecords[i].event,
              // try to get dragged event from addedEvents array, it will be there with updated ids
        // if toScheduler is different
        draggedEvent = (addedEvents === null || addedEvents === void 0 ? void 0 : addedEvents.find(r => r.id === originalDraggedEvent.id)) || originalDraggedEvent,
              eventBar = context.eventBarEls[i],
              element = i === 0 ? context.context.element : context.context.relatedElements[i - 1],
              // Determine if in time axis here also, since the records date might be invalidated further below
        inTimeAxis = toScheduler.isInTimeAxis(draggedEvent); // Remove original element properly

        _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].removeChild(fromScheduler.foregroundCanvas, eventBar);

        if (draggedEvent.resource && toScheduler.rowManager.getRowFor(draggedEvent.resource) && inTimeAxis) {
          const elRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(element, toScheduler.foregroundCanvas, true); // Ensure that after inserting the dragged element clone into the toScheduler's foregroundCanvas
          // it's at the same visual position that it was dragged to.

          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(element, elRect.x, elRect.y);
          element.classList.remove('b-sch-event-hover');
          element.classList.remove('b-active');
          element.classList.remove('b-drag-proxy');
          element.classList.remove('b-dragging');
          element.retainElement = false; // Add element properly, so that DomSync will reuse it on next update

          _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].addChild(toScheduler.foregroundCanvas, element, draggedEvent.assignments[0].id);
        }
      }
    }

    addedEvents === null || addedEvents === void 0 ? void 0 : addedEvents.forEach(added => eventsToBatch.add(added)); // addedEvents order is the same with [context.element, ..context.relatedElements]
    // Any added or removed events or assignments => something changed

    if (assignmentsToRemove.length || eventsToRemove.length || assignmentsToAdd.length || eventsToAdd.length) {
      updated = true;
    } // Commit changes to affected projects


    if (updated || updatedEvent) {
      // By batching event changes when using single assignment we avoid two updates, without it there will be one
      // for date change and one when changed assignment updates resourceId on the event
      toEventStore.usesSingleAssignment && eventsToBatch.forEach(eventRecord => eventRecord.beginBatch());
      await Promise.all([toScheduler.project !== fromScheduler.project ? toScheduler.project.commitAsync() : null, fromScheduler.project.commitAsync()]); // End batch in engine friendly way, avoiding to have `set()` trigger another round of calculations

      toEventStore.usesSingleAssignment && eventsToBatch.forEach(eventRecord => eventRecord.endBatch(false, true));
    }

    if (!updated) {
      // Engine might have reverted the date change, in which case this should be considered an invalid op
      updated = eventsToCheck.some(({
        draggedEvent,
        originalStartDate
      }) => !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(draggedEvent.startDate, originalStartDate));
    } // Resumes self twice if not cross scheduler, but was suspended twice above also so all good


    toScheduler.resumeRefresh();
    fromScheduler.resumeRefresh();

    if (assignmentRecords.length > 0) {
      if (!updated) {
        context.valid = false;
      } else {
        // Not doing full refresh above, to allow for animations
        toScheduler.refreshWithTransition();

        if (isCrossScheduler) {
          fromScheduler.refreshWithTransition();
        }
      }
    }
  } //endregion
  //region Drag data


  getProductDragContext(dragData) {
    const targetEventRecord = this.scheduler.resolveEventRecord(dragData.browserEvent.target);
    let newResource;

    if (this.constrainDragToResource) {
      newResource = dragData.resourceRecord;
    } else if (!this.constrainDragToTimeline) {
      // If we're dragging freely on the page, require to drag onto a resource row always
      newResource = this.resolveResource();
    } else {
      newResource = this.resolveResource() || dragData.newResource || dragData.resourceRecord;
    }

    const {
      assignmentRecords,
      eventRecords
    } = dragData;
    return {
      valid: Boolean(newResource && !newResource.isSpecialRow),
      // `draggedRecords` is deprecated
      draggedRecords: eventRecords,
      eventRecords,
      assignmentRecords,
      newResource,
      targetEventRecord
    };
  }

  getMinimalDragData(info) {
    const me = this,
          {
      scheduler
    } = me,
          element = me.getElementFromContext(info),
          eventRecord = scheduler.resolveEventRecord(element),
          resourceRecord = scheduler.resolveResourceRecord(element),
          assignmentRecord = scheduler.resolveAssignmentRecord(element),
          assignmentRecords = assignmentRecord ? [assignmentRecord] : []; // We multi drag other selected events if multiEventSelect is set and
    // (the dragged event is already selected, or the ctrl key is pressed)

    if (scheduler.multiEventSelect && assignmentRecord && (scheduler.isAssignmentSelected(assignmentRecords[0]) || me.drag.startEvent.ctrlKey)) {
      assignmentRecords.push.apply(assignmentRecords, me.getRelatedRecords(assignmentRecord));
    }

    const eventRecords = [...new Set(assignmentRecords.map(assignment => assignment.event))];
    return {
      eventRecord,
      resourceRecord,
      assignmentRecord,
      eventRecords,
      assignmentRecords
    };
  }

  setupProductDragData(info) {
    const me = this,
          {
      scheduler
    } = me,
          element = me.getElementFromContext(info),
          {
      eventRecord,
      resourceRecord,
      assignmentRecord,
      assignmentRecords
    } = me.getMinimalDragData(info),
          eventRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(element),
          eventBarEls = [];

    if (me.constrainDragToResource && !resourceRecord) {
      throw new Error('Resource could not be resolved for event: ' + eventRecord.id);
    }

    const dateConstraints = scheduler.getDateConstraints(me.constrainDragToResource ? resourceRecord : null, eventRecord);

    if (me.constrainDragToTimeline) {
      me.setupConstraints(scheduler.getScheduleRegion(me.constrainDragToResource ? resourceRecord : null, eventRecord), eventRegion, scheduler.timeAxisViewModel.snapPixelAmount, Boolean(dateConstraints));
    } // Collecting all elements to drag


    assignmentRecords.forEach(assignment => {
      let eventBarEl = scheduler.getElementFromAssignmentRecord(assignment);

      if (!eventBarEl) {
        eventBarEl = scheduler.currentOrientation.addTemporaryDragElement(assignment.event, assignment.resource);
        eventBarEl = eventBarEl.innerElement;
      }

      eventBarEls.push(eventBarEl);
    }); // What is dragged is the wrapper.

    eventBarEls.forEach((el, i) => eventBarEls[i] = el.parentNode);
    return {
      record: assignmentRecord,
      draggedEntities: assignmentRecords,
      dateConstraints,
      eventBarEls
    };
  }
  /**
   * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
   * @private
   * @param info
   * @returns {*}
   */


  getDragData(info) {
    const dragData = this.getMinimalDragData(info) || {};
    return _objectSpread(_objectSpread(_objectSpread({}, super.getDragData(info)), dragData), {}, {
      initialAssignmentsState: dragData.assignmentRecords.map(assignment => ({
        startDate: assignment.event.startDate,
        resource: assignment.resource,
        assignment
      }))
    });
  }
  /**
   * Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.
   * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment about to be dragged
   * @return {Scheduler.model.AssignmentModel[]} An array of assignment records to drag together with the original
   */


  getRelatedRecords(assignmentRecord) {
    return this.scheduler.selectedAssignments.filter(selectedRecord => selectedRecord !== assignmentRecord && selectedRecord.event.isDraggable);
  }
  /**
   * Get correct axis coordinate depending on schedulers mode (horizontal -> x, vertical -> y). Also takes milestone
   * layout into account.
   * @private
   * @param {Scheduler.model.EventModel} eventRecord Record being dragged
   * @param {HTMLElement} element Element being dragged
   * @param {Number[]} coord XY coordinates
   * @returns {Number|Number[]} X,Y or XY
   */


  getCoordinate(eventRecord, element, coord) {
    const scheduler = this.currentOverClient;

    if (scheduler.isHorizontal) {
      let x = coord[0]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

      if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
        switch (scheduler.milestoneAlign) {
          case 'center':
            x += element.offsetWidth / 2;
            break;

          case 'end':
            x += element.offsetWidth;
            break;
        }
      }

      return x;
    } else {
      let y = coord[1]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

      if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
        switch (scheduler.milestoneAlign) {
          case 'center':
            y += element.offsetHeight / 2;
            break;

          case 'end':
            y += element.offsetHeight;
            break;
        }
      }

      return y;
    }
  }
  /**
   * Get resource record occluded by the drag proxy.
   * @private
   * @returns {Scheduler.model.ResourceModel}
   */


  resolveResource() {
    const element = this.dragData.dragProxy || this.dragData.context.element,
          client = this.currentOverClient,
          {
      isHorizontal
    } = client,
          {
      context
    } = this.dragData,
          // Page coords for elementFromPoint
    pageRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(element, null, true),
          y = client.isVertical || this.unifiedDrag ? context.clientY : pageRect.center.y,
          // Local coords to resolve resource in vertical
    localRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(element, client.timeAxisSubGridElement, true),
          {
      x: lx,
      y: ly
    } = localRect.center;
    let resource; // This is benchmarked as the fastest way to find a Grid Row from a viewport Y coordinate
    // so use it in preference to elementFromPoint (which causes a forced synchronous layout) in horizontal mode.

    if (isHorizontal) {
      const row = client.rowManager.getRowAt(y);
      resource = row && client.resourceStore.getAt(row.dataIndex);
    } else {
      // In vertical mode, just use the X coordinate to find out which resource we are under.
      // The method requires that a .b-sch-timeaxis-cell element be passed.
      // There is only one in vertical mode, so use that.
      resource = client.resolveResourceRecord(client.timeAxisSubGridElement.querySelector('.b-sch-timeaxis-cell'), [lx, ly]);
    }

    return resource;
  } //endregion
  //region Other stuff


  adjustStartDate(startDate, timeDiff) {
    const scheduler = this.currentOverClient;
    return scheduler.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), scheduler.snapRelativeToEventStartDate ? startDate : false);
  }

  getRecordElement(assignmentRecord) {
    return this.scheduler.getElementFromAssignmentRecord(assignmentRecord, true);
  } //endregion


}
EventDrag._$name = 'EventDrag';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_5__["default"].registerFeature(EventDrag, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_5__["default"].registerFeature(EventDrag, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventDragCreate.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/EventDragCreate.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDragCreate; });
/* harmony import */ var _base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/DragCreateBase.js */ "./lib/Scheduler/feature/base/DragCreateBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/EventDragCreate
 */

/**
 * Feature that allows the user to create new events by dragging in empty parts of the scheduler rows.
 *
 * This feature is **enabled** by default
 *
 * **NOTE:** Incompatible with the {@link Scheduler.feature.EventDragSelect EventDragSelect} and the {@link Scheduler.feature.Pan Pan} features.
 *
 * @extends Scheduler/feature/base/DragCreateBase
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/EventDragCreate.js
 * @classtype eventDragCreate
 * @feature
 */

class EventDragCreate extends _base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'EventDragCreate';
  }

  static get configurable() {
    return {
      /**
       * An empty function by default, but provided so that you can perform custom validation on the event being created.
       * Return true if the new event is valid, false to prevent an event being created.
       * @param {Object} context A drag create context
       * @param {Date} context.startDate Event start date
       * @param {Date} context.endDate Event end date
       * @param {Scheduler.model.EventModel} context.record Event record
       * @param {Scheduler.model.ResourceModel} context.resourceRecord Resource record
       * @param {Event} event The event object
       * @return {Boolean} `true` if this validation passes
       * @config {function}
       */
      validatorFn: () => true,

      /**
       * Locks the layout during drag create, overriding the default behaviour that uses the same rendering
       * pathway for drag creation as for already existing events.
       *
       * This more closely resembles the behaviour of versions prior to 4.2.0.
       *
       * @config {Boolean}
       * @default
       */
      lockLayout: false
    };
  } //endregion
  //region Events

  /**
   * Fires on the owning Scheduler after the new event has been created.
   * @event dragCreateEnd
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Scheduler.model.EventModel} eventRecord The new `EventModel` record.
   * @param {Scheduler.model.EventModel} newEventRecord DEPRECATED: will be removed in 5.0, use `eventRecord` instead.
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource for the row in which the event is being created.
   * @param {MouseEvent} event The ending mouseup event.
   * @param {HTMLElement} eventElement The DOM element representing the newly created event un the UI.
   * @param {HTMLElement} proxyElement DEPRECATED: will be removed in 5.0, use `eventElement` instead.
   */

  /**
   * Fires on the owning Scheduler at the beginning of the drag gesture
   * @event beforeDragCreate
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Date} date The datetime associated with the drag start point.
   */

  /**
   * Fires on the owning Scheduler after the drag start has created a proxy element.
   * @event dragCreateStart
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {HTMLElement} proxyElement The proxy representing the new event.
   */

  /**
   * Fires on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  scheduler.on('beforedragcreatefinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * @event beforeDragCreateFinalize
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {HTMLElement} proxyElement Proxy element, representing future event
   * @param {Object} context
   * @param {Boolean} context.async Set true to handle drag create asynchronously (e.g. to wait for user
   * confirmation)
   * @param {Function} context.finalize Call this method to finalize drag create. This method accepts one
   * argument: pass true to update records, or false, to ignore changes
   */

  /**
   * Fires on the owning Scheduler at the end of the drag create gesture whether or not
   * a new event was created by the gesture.
   * @event afterDragCreate
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
   */
  //endregion
  //region Init


  construct(scheduler, config) {
    this.scheduler = scheduler;
    super.construct(scheduler, config);
  }

  get store() {
    return this.scheduler.eventStore;
  }

  updateLockLayout(lock) {
    this.dragActiveCls = 'b-dragcreating' + (lock ? ' b-dragcreate-lock' : '');
  } //endregion
  //region Scheduler specific implementation


  handleBeforeDragCreate(drag, eventRecord, event) {
    const {
      resourceRecord
    } = drag,
          {
      scheduler
    } = this,
          // For resources with a calendar, ensure the date is inside a working time range
    isWorkingTime = !scheduler.isSchedulerPro || resourceRecord.isWorkingTime(drag.mousedownDate),
          result = isWorkingTime && scheduler.trigger('beforeDragCreate', {
      resourceRecord,
      date: drag.mousedownDate,
      event
    }); // Save date constraints

    this.dateConstraints = scheduler.getDateConstraints(resourceRecord, eventRecord);
    return result;
  }

  dragStart(drag) {
    var _client$onEventCreate;

    const me = this,
          {
      client
    } = me,
          {
      eventStore,
      assignmentStore,
      enableEventAnimations,
      features
    } = client,
          {
      resourceRecord
    } = drag,
          eventRecord = me.createEventRecord(drag),
          eventEditAvailable = Boolean(features.eventEdit && !features.eventEdit.disabled || features.taskEdit && !features.taskEdit.disabled || features.simpleEventEdit && !features.simpleEventEdit.disabled),
          resourceRecords = [resourceRecord];
    eventRecord.set('duration', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(eventRecord.startDate, eventRecord.endDate, eventRecord.durationUnit, true)); // It's only a provisional event if there is an event edit feature available to
    // cancel the add (by removing it). Otherwise it's a definite event creation.

    eventRecord.isCreating = eventEditAvailable; // Flag used by rendering to not draw a zero length event being drag created as a milestone

    eventRecord.meta.isDragCreating = true; // Date to flip around when changing direction

    drag.initialDate = eventRecord.get(this.draggingEnd ? 'startDate' : 'endDate'); // This presents the event to be scheduled for validation at the proposed mouse/date point
    // If rejected, we cancel operation

    if (me.handleBeforeDragCreate(drag, eventRecord, drag.event) === false) {
      return false;
    } // Vetoable beforeEventAdd allows cancel of this operation


    if (client.trigger('beforeEventAdd', {
      eventRecord,
      resourceRecords
    }) === false) {
      assignmentStore.unassignEventFromResource(eventRecord, resourceRecord);
      eventStore.remove(eventRecord);
      return false;
    } // If we're drag-creating in a resource-based view...
    // Assign resource before toggling isCreating to process assignments


    if (resourceRecord) {
      assignmentStore.assignEventToResource(eventRecord, resourceRecord);
    } // When configured to lock layout during drag create, set a flag that HorizontalRendering will pick up to
    // exclude the new event from the layout calculations. It will then be at the topmost position in the "cell"


    if (me.lockLayout) {
      eventRecord.meta.excludeFromLayout = true;
    }

    (_client$onEventCreate = client.onEventCreated) === null || _client$onEventCreate === void 0 ? void 0 : _client$onEventCreate.call(client, eventRecord);
    client.enableEventAnimations = false;
    eventStore.addAsync(eventRecord).then(() => client.enableEventAnimations = enableEventAnimations); // Element must be created synchronously, not after the project's normalizing delays.
    // Overrides the check for isEngineReady in VerticalRendering so that the newly added record
    // will be rendered when we call refreshRows.

    client.isCreating = true;
    client.refreshRows();
    client.isCreating = false; // Set the element we are dragging

    drag.itemElement = drag.element = client.getElementFromEventRecord(eventRecord);
    return super.dragStart(drag);
  }

  checkValidity(context, event) {
    const me = this,
          {
      client
    } = me; // Nicer for users of validatorFn

    context.resourceRecord = me.dragging.resourceRecord;
    return (client.allowOverlap || client.isDateRangeAvailable(context.startDate, context.endDate, context.eventRecord, context.resourceRecord)) && me.createValidatorFn.call(me.validatorFnThisObj || me, context, event);
  } // Determine if resource already has events or not


  isRowEmpty(resourceRecord) {
    const events = this.store.getEventsForResource(resourceRecord);
    return !events || !events.length;
  } //endregion


  triggerBeforeFinalize(event) {
    this.client.trigger(`beforeDragCreateFinalize`, event);
  }
  /**
   * Creates an event by the event object coordinates
   * @param {Object} drag The Bryntum event object
   * @private
   */


  createEventRecord(drag) {
    const me = this,
          {
      client
    } = me,
          dimension = client.isHorizontal ? 'X' : 'Y',
          {
      timeAxis,
      eventStore,
      weekStartDay
    } = client,
          {
      event,
      mousedownDate
    } = drag,
          draggingEnd = me.draggingEnd = event[`page${dimension}`] > drag.startEvent[`page${dimension}`],
          eventConfig = {
      name: eventStore.modelClass.fieldMap.name.defaultValue || me.L('L{Object.newEvent}'),
      startDate: draggingEnd ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].floor(mousedownDate, timeAxis.resolution, null, weekStartDay) : mousedownDate,
      endDate: draggingEnd ? mousedownDate : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].ceil(mousedownDate, timeAxis.resolution, null, weekStartDay)
    }; // if project model has been imported from Gantt, we have to define constraint data directly to correct
    // auto-scheduling while dragCreate

    if (client.project.isGanttProjectMixin) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign(eventConfig, {
        constraintDate: eventConfig.startDate,
        constraintType: 'startnoearlierthan'
      });
    }

    return eventStore.createRecord(eventConfig);
  }

  async finalizeDragCreate(context) {
    // Remove the layout lock flag, event will jump into place as part of the finalization
    delete context.eventRecord.meta.excludeFromLayout; // Also allow new event to become a milestone now

    delete context.eventRecord.meta.isDragCreating;
    return super.finalizeDragCreate(context);
  }

  getTipHtml(...args) {
    const html = super.getTipHtml(...args),
          {
      element
    } = this.tip;
    element.classList.add('b-sch-dragcreate-tooltip');
    element.classList.toggle('b-too-narrow', this.dragging.context.tooNarrow);
    return html;
  }

  onAborted(context) {
    var _this$store$unassignE, _this$store;

    const {
      eventRecord,
      resourceRecord
    } = context; // The product this is being used in may not have resources.

    (_this$store$unassignE = (_this$store = this.store).unassignEventFromResource) === null || _this$store$unassignE === void 0 ? void 0 : _this$store$unassignE.call(_this$store, eventRecord, resourceRecord);
    this.store.remove(eventRecord);
  }

}
EventDragCreate._$name = 'EventDragCreate';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventDragCreate, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventDragCreate, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventDragSelect.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/EventDragSelect.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDragSelect; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';





/**
 * @module Scheduler/feature/EventDragSelect
 */

/**
 * Enables users to click and drag to select events inside the Scheduler's timeline.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * **NOTE:** Incompatible with the {@link Scheduler.feature.EventDragCreate EventDragCreate} and the {@link Scheduler.feature.Pan Pan} features.
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     eventDragSelect      : true,
 *     eventDragCreate      : false
 *   }
 * });
 *
 * @demo Scheduler/dragselection
 * @classtype eventDragSelect
 * @feature
 */

class EventDragSelect extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_4__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  // region Init
  static get $name() {
    return 'EventDragSelect';
  }

  construct(timeline, config) {
    this.timeline = timeline;
    this.onDocumentMouseUp = this.onDocumentMouseUp.bind(this);
    timeline.multiEventSelect = true;
    const targetSelectors = ['.b-timeline-subgrid .b-grid-cell', '.b-timeline-subgrid'];
    this.targetSelector = targetSelectors.join(',');
    super.construct(timeline, config);
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Scheduler.


  static get pluginConfig() {
    return {
      chain: ['onElementMouseDown', 'onElementMouseMove']
    };
  } //endregion


  onElementMouseDown(event) {
    const me = this,
          scheduler = me.client; // only react to mouse input, and left button

    if (event.touches || event.button !== 0 || me.disabled) {
      return;
    } // only react to mousedown directly on grid cell or subgrid element


    if (event.target.matches(me.targetSelector)) {
      me.startX = event.clientX;
      me.startY = event.clientY;
      me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
        tag: 'div',
        className: 'b-dragselect-rect'
      }, true)[0];
      scheduler.floatRoot.appendChild(me.element);
      scheduler.element.classList.add('b-dragselecting'); // Since the dragselect element is in the floatRoot, we want to use viewport-based coordinates, so we pass
      // ignorePageScroll=true when calling Rectangle.from():

      me.eventRectangles = Array.from(scheduler.element.querySelectorAll(scheduler.eventSelector)).map(el => ({
        rectangle: _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(el,
        /* ignorePageScroll = */
        true),
        record: scheduler.resolveEventRecord(el)
      }));
      scheduler.clearEventSelection();
      me.subGridElementRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(scheduler.timeAxisSubGrid.element,
      /* ignorePageScroll = */
      true); // No key processing during drag selection

      scheduler.navigator.disabled = true;
      document.addEventListener('mouseup', me.onDocumentMouseUp);
    }
  }

  onElementMouseMove(event) {
    const me = this;

    if (typeof me.startX === 'number') {
      const x = Math.max(event.clientX, me.subGridElementRect.left),
            y = Math.max(event.clientY, me.subGridElementRect.top),
            left = Math.min(me.startX, x),
            top = Math.min(me.startY, y),
            width = Math.abs(me.startX - x),
            height = Math.abs(me.startY - y),
            rect = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](left, top, width, height).constrainTo(me.subGridElementRect);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(me.element, rect.left, rect.top);
      me.element.style.width = rect.width + 'px';
      me.element.style.height = rect.height + 'px';
      me.rectangle = rect;
      me.updateSelection();
    }
  }

  onDocumentMouseUp(event) {
    var _me$element;

    const me = this,
          client = me.client,
          {
      selectedAssignments,
      navigator
    } = client;
    (_me$element = me.element) === null || _me$element === void 0 ? void 0 : _me$element.remove();
    client.element.classList.remove('b-dragselecting');
    me.startX = me.startY = null; // Navigator will react to the 'click' event which clears selection, bypass this

    navigator.skipNextClick = client.timeAxisSubGridElement.contains(event.target);
    navigator.disabled = false; // If we selected something, focus last selected event so keyboard navigation works

    if (selectedAssignments.length) {
      navigator.skipScrollIntoView = true;
      client.activeAssignment = selectedAssignments[selectedAssignments.length - 1];
      navigator.activeItem.focus();
      navigator.skipScrollIntoView = false;
    }

    document.removeEventListener('mouseup', me.onDocumentMouseUp);
  }

  updateSelection() {
    const me = this,
          renderedEventRects = me.eventRectangles,
          rectangle = me.rectangle;

    for (let i = 0, len = renderedEventRects.length; i < len; i++) {
      const eventData = renderedEventRects[i],
            shouldSelect = rectangle.intersect(eventData.rectangle, true);

      if (shouldSelect && !eventData.selected) {
        eventData.selected = true;
        me.client.selectEvent(eventData.record, true);
      } else if (!shouldSelect && eventData.selected) {
        eventData.selected = false;
        me.client.deselectEvent(eventData.record);
      }
    }
  }

}
EventDragSelect._$name = 'EventDragSelect';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventDragSelect, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventEdit.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventEdit.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventEdit; });
/* harmony import */ var _base_EditBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/EditBase.js */ "./lib/Scheduler/feature/base/EditBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _view_EventEditor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../view/EventEditor.js */ "./lib/Scheduler/view/EventEditor.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/RecurringEventEdit.js */ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js");
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Scheduler/widget/ResourceCombo.js */ "./lib/Scheduler/widget/ResourceCombo.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';














/**
 * @module Scheduler/feature/EventEdit
 */

/**
 * Feature that displays a popup containing widgets for editing event data.
 *
 *  {@inlineexample Scheduler/feature/EventEdit.js}
 *
 * To customize its contents you can:
 *
 * * Reconfigure built in widgets by providing override configs in the {@link Scheduler.feature.base.EditBase#config-items} config.
 * * Change the date format of the date & time fields: {@link Scheduler.feature.base.EditBase#config-dateFormat} and {@link Scheduler.feature.base.EditBase#config-timeFormat }
 * * Configure provided widgets in the editor and add your own in the {@link Scheduler.feature.base.EditBase#config-items} config.
 * * Remove fields related to recurring events configuration (such as `recurrenceCombo`) by setting {@link Scheduler.feature.mixin.RecurringEventEdit#config-showRecurringUI} config to `false`.
 * * Advanced: Reconfigure the whole editor widget using {@link #config-editorConfig}
 *
 * ## Built in widgets
 *
 * The built in widgets are:
 *
 * | Widget ref             | Type                                                                            | Weight | Description                                                    |
 * |------------------------|---------------------------------------------------------------------------------|--------|----------------------------------------------------------------|
 * | `nameField`            | {@link Core.widget.TextField TextField}                                         | 100    | Edit name                                                      |
 * | `resourceField`        | {@link Scheduler.widget.ResourceCombo ResourceCombo}                            | 200    | Pick resource(s)                                               |
 * | `startDateField`       | {@link Core.widget.DateField DateField}                                         | 300    | Edit startDate (date part)                                     |
 * | `startTimeField`       | {@link Core.widget.TimeField TimeField}                                         | 400    | Edit startDate (time part)                                     |
 * | `endDateField`         | {@link Core.widget.DateField DateField}                                         | 500    | Edit endDate (date part)                                       |
 * | `endTimeField`         | {@link Core.widget.TimeField TimeField}                                         | 600    | Edit endDate (time part)                                       |
 * | `recurrenceCombo`      | {@link Scheduler.view.recurrence.field.RecurrenceCombo RecurrenceCombo}         | 700    | Select recurrence rule (only visible if recurrence is used)    |
 * | `editRecurrenceButton` | {@link Scheduler.view.recurrence.RecurrenceLegendButton RecurrenceLegendButton} | 800    | Edit the recurrence rule  (only visible if recurrence is used) |
 *
 * The built in buttons are:
 *
 * | Widget ref             | Type                                                                            | Weight | Description                                                    |
 * |------------------------|---------------------------------------------------------------------------------|--------|----------------------------------------------------------------|
 * | `saveButton`           | {@link Core.widget.Button Button}                                               | 100    | Save event button on the bbar                                  |
 * | `deleteButton`         | {@link Core.widget.Button Button}                                               | 200    | Delete event button on the bbar                                |
 * | `cancelButton`         | {@link Core.widget.Button Button}                                               | 300    | Cancel event editing button on the bbar                        |
 *
 * ## Removing a built in widgets
 *
 * To remove a built in widget, specify its `ref` as `null` in the `items` config:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // Remove the start time field
 *                 startTimeField : null
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * Bottom buttons may be hidden using `bbar` config passed to `editorConfig`:
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             editorConfig : {
 *                 bbar : {
 *                     items : {
 *                         deleteButton : null
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * To remove fields related to recurring events configuration (such as `recurrenceCombo`), set {@link Scheduler.feature.mixin.RecurringEventEdit#config-showRecurringUI} config to `false`.
 *
 * ## Customizing a built in widget
 *
 * To customize a built in widget, use its `ref` as the key in the `items` config and specify the configs you want
 * to change (they will merge with the widgets default configs):
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // ref for an existing field
 *                 nameField : {
 *                     // Change its label
 *                     label : 'Description'
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Adding custom widgets
 *
 * To add a custom widget, add an entry to the `items` config. The `name` property links the input field to a field in
 * the loaded event record:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // Key to use as fields ref (for easier retrieval later)
 *                 color : {
 *                     type  : 'combo',
 *                     label : 'Color',
 *                     items : ['red', 'green', 'blue'],
 *                     // name will be used to link to a field in the event record when loading and saving in the editor
 *                     name  : 'eventColor'
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * For more info on customizing the event editor, please see "Customize event editor" guide.
 *
 * This feature is **enabled** by default
 *
 * @mixes Scheduler/feature/mixin/RecurringEventEdit
 * @extends Scheduler/feature/base/EditBase
 * @demo Scheduler/eventeditor
 * @classtype eventEdit
 * @feature
 */

class EventEdit extends _base_EditBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_6__["default"], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  //region Config
  static get $name() {
    return 'EventEdit';
  }

  static get configurable() {
    return {
      /**
       * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
       * @config {String}
       * @default
       * @category Editor
       */
      triggerEvent: 'eventdblclick',

      /**
       * True to show a combo for picking resource:
       * ```javascript
       * const scheduler = new Scheduler({
       *    features : {
       *       eventEdit : {
       *           // Merged with the provided items
       *           // So we can override any config of any provided field.
       *          items : {
       *              resourceField : {
       *                  hidden : true
       *              }
       *           }
       *        }
       *     }
       * });
       * ```
       * @config {Boolean}
       * @default
       * @category Editor widgets
       * @deprecated 4.0.0 Configure using the `resourceField` property in the `items`
       * of {@link #config-editorConfig}
       */
      showResourceField: true,

      /**
       * Config for the resourceField constructor:
       * ```javascript
       * const scheduler = new Scheduler({
       *    features : {
       *       eventEdit : {
       *           // Merged with the provided items
       *           // So we can override any config of any provided field.
       *          items : {
       *              resourceField : {
       *                  label : 'Calendar
       *              }
       *           }
       *        }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor widgets
       * @deprecated 4.0.0 Configure using the `resourceField` property in the `items`
       * of {@link #config-editorConfig}
       */
      resourceFieldConfig: null,

      /**
       * The data field in the model that defines the eventType.
       * Applied as class (b-eventtype-xx) to the editors element, to allow showing/hiding fields depending on
       * eventType. Dynamic toggling of fields in the editor is activated by adding an `eventTypeField` field to
       * your widget:
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *    features : {
       *       eventEdit : {
       *           items : {
       *               eventTypeField : {
       *                  type  : 'combo',
       *                  name  : 'eventType',
       *                  label : 'Type',
       *                  items : ['Appointment', 'Internal', 'Meeting']
       *               }
       *           }
       *        }
       *     }
       * });
       * ```
       * Note, your event model class also must declare this field:
       * ```javascript
       *  class MyEvent extends EventModel {
       *      static get fields() {
       *          return [
       *              { name : 'eventType' }
       *          ];
       *      }
       *  }
       * ```
       * @config {String}
       * @default
       * @category Editor
       */
      typeField: 'eventType',

      /**
       * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
       * @property {Scheduler.model.EventModel}
       * @readonly
       */
      eventRecord: null,

      /**
       * Specify `true` to put the editor in read only mode.
       * @config {Boolean}
       * @default false
       */
      readOnly: null,

      /**
       * The configuration for the internal editor widget. With this config you can control the *type*
       * of editor (defaults to `Popup`) and which widgets to show,
       * change the items in the `bbar`, or change whether the popup should be modal etc.
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             editorConfig : {
       *                 modal  : true,
       *                 cls    : 'my-editor' // A CSS class,
       *                 items  : {
       *                     owner : {
       *                         weight : -100, // Will sort above system-supplied fields which are weight 100 to 800
       *                         type   : 'usercombo',
       *                         name   : 'owner',
       *                         label  : 'Owner'
       *                     },
       *                     agreement : {
       *                         weight : 1000, // Will sort below system-supplied fields which are weight 100 to 800
       *                         type   : 'checkbox',
       *                         name   : 'agreement',
       *                         label  : 'Agree to terms'
       *                     }
       *                 },
       *                 bbar : {
       *                     items : {
       *                         deleteButton : {
       *                             hidden : true
       *                         }
       *                     }
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * Or to use your own custom editor:
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             editorConfig : {
       *                 type : 'myCustomEditorType'
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor
       */
      editorConfig: {
        type: 'eventeditor',
        title: 'L{EventEdit.Edit event}',
        closable: true,
        localeClass: this,
        defaults: {
          localeClass: this
        },
        items: {
          /**
           * Reference to the name field, if used
           * @member {Core.widget.TextField} nameField
           * @readonly
           */
          nameField: {
            type: 'text',
            label: 'L{Name}',
            clearable: true,
            name: 'name',
            weight: 100,
            required: true
          },

          /**
           * Reference to the resource field, if used
           * @member {Core.widget.Combo} resourceField
           * @readonly
           */
          resourceField: {
            type: 'resourcecombo',
            label: 'L{Resource}',
            name: 'resource',
            editable: true,
            valueField: 'id',
            displayField: 'name',
            highlightExternalChange: false,
            destroyStore: true,
            weight: 200
          },

          /**
           * Reference to the start date field, if used
           * @member {Core.widget.DateField} startDateField
           * @readonly
           */
          startDateField: {
            type: 'date',
            cls: 'b-inline',
            clearable: false,
            required: true,
            label: 'L{Start}',
            name: 'startDate',
            flex: '1 0 60%',
            validateDateOnly: true,
            weight: 300
          },

          /**
           * Reference to the start time field, if used
           * @member {Core.widget.TimeField} startTimeField
           * @readonly
           */
          startTimeField: {
            type: 'time',
            clearable: false,
            required: true,
            name: 'startDate',
            cls: 'b-match-label',
            flex: '1 0 40%',
            weight: 400
          },

          /**
           * Reference to the end date field, if used
           * @member {Core.widget.DateField} endDateField
           * @readonly
           */
          endDateField: {
            type: 'date',
            cls: 'b-inline',
            clearable: false,
            required: true,
            label: 'L{End}',
            name: 'endDate',
            flex: '1 0 60%',
            validateDateOnly: true,
            weight: 500
          },

          /**
           * Reference to the end time field, if used
           * @member {Core.widget.TimeField} endTimeField
           * @readonly
           */
          endTimeField: {
            type: 'time',
            clearable: false,
            required: true,
            name: 'endDate',
            cls: 'b-match-label',
            flex: '1 0 40%',
            weight: 600
          }
        },
        bbar: {
          // When readOnly, child buttons are hidden
          hideWhenEmpty: true,
          defaults: {
            localeClass: this
          },
          items: {
            /**
             * Reference to the save button, if used
             * @member {Core.widget.Button} saveButton
             * @readonly
             */
            saveButton: {
              color: 'b-green',
              text: 'L{Save}',
              weight: 100
            },

            /**
             * Reference to the delete button, if used
             * @member {Core.widget.Button} deleteButton
             * @readonly
             */
            deleteButton: {
              color: 'b-gray',
              text: 'L{Delete}',
              weight: 200
            },

            /**
             * Reference to the cancel button, if used
             * @member {Core.widget.Button} cancelButton
             * @readonly
             */
            cancelButton: {
              color: 'b-gray',
              text: 'L{Object.Cancel}',
              weight: 300
            }
          }
        }
      },
      targetEventElement: null
    };
  }

  static get pluginConfig() {
    return {
      chain: ['populateEventMenu', 'onEventEnterKey', 'editEvent']
    };
  } //endregion
  //region Init & destroy


  construct(scheduler, config) {
    this.scheduler = scheduler; // Default to the scheduler's state, but configs may override

    this.readOnly = scheduler.readOnly;
    super.construct(scheduler, config);
    scheduler.on({
      projectChange: 'onChangeProject',
      readOnly: 'onClientReadOnlyToggle',
      thisObj: this
    });
  } //endregion
  //region Editing

  /**
   * Get/set readonly state
   * @property {Boolean}
   */


  get readOnly() {
    return this.editor ? this.editor.readOnly : this._readOnly;
  }

  updateReadOnly(readOnly) {
    if (this.editor) {
      this.editor.readOnly = readOnly;
    }
  }

  onClientReadOnlyToggle({
    readOnly
  }) {
    this.readOnly = readOnly;
  }
  /**
   * Gets an editor instance. Creates on first call, reuses on consecutive
   * @internal
   * @returns {Core.widget.Popup} Editor popup
   */


  getEditor() {
    var _me$onEditorConstruct, _me$eventTypeField, _me$saveButton, _me$deleteButton, _me$cancelButton;

    const me = this;
    let {
      editor
    } = me;

    if (editor) {
      return editor;
    }

    editor = me.editor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"].create(me.getEditorConfig()); // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to. Must use direct property access because
    // getter consults state of editor.

    editor.readOnly = me._readOnly;

    if (editor.items.length === 0) {
      console.warn('Event Editor configured without any `items`');
    } // add listeners programmatically so users cannot override them accidentally


    editor.on({
      beforehide: 'resetEditingContext',
      beforeshow: 'onBeforeEditorShow',
      keydown: 'onPopupKeyDown',
      thisObj: me
    });
    /**
     * Fired before the editor will load the event record data into its input fields. This is useful if you
     * want to modify the fields before data is loaded (e.g. set some input field to be readonly)
     * @on-owner
     * @event eventEditBeforeSetRecord
     * @param {Core.widget.Container} source The editor widget
     * @param {Scheduler.model.EventModel} record The record
     */

    me.scheduler.relayEvents(editor, ['beforeSetRecord'], 'eventEdit'); // assign widget variables, using widget name: startDate -> me.startDateField
    // widgets with id set use that instead, id -> me.idField

    Object.values(editor.widgetMap).forEach(widget => {
      const ref = widget.ref || widget.id; // don't overwrite if already defined

      if (ref && !me[ref]) {
        me[ref] = widget;

        switch (widget.name) {
          case 'startDate':
          case 'endDate':
            widget.on('change', me.onDatesChange, me);
            break;
        }
      }
    }); // launch onEditorConstructed hook if provided

    (_me$onEditorConstruct = me.onEditorConstructed) === null || _me$onEditorConstruct === void 0 ? void 0 : _me$onEditorConstruct.call(me, editor);
    (_me$eventTypeField = me.eventTypeField) === null || _me$eventTypeField === void 0 ? void 0 : _me$eventTypeField.on('change', me.onEventTypeChange, me);
    (_me$saveButton = me.saveButton) === null || _me$saveButton === void 0 ? void 0 : _me$saveButton.on('click', me.onSaveClick, me);
    (_me$deleteButton = me.deleteButton) === null || _me$deleteButton === void 0 ? void 0 : _me$deleteButton.on('click', me.onDeleteClick, me);
    (_me$cancelButton = me.cancelButton) === null || _me$cancelButton === void 0 ? void 0 : _me$cancelButton.on('click', me.onCancelClick, me);
    return me.editor;
  }

  getEditorConfig() {
    const me = this,
          {
      autoClose,
      cls,
      scheduler
    } = me;
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
      owner: scheduler,
      eventEditFeature: me,
      weekStartDay: me.weekStartDay,
      align: 'b-t',
      id: `${scheduler.id}-event-editor`,
      autoShow: false,
      anchor: true,
      scrollAction: 'realign',
      constrainTo: window,
      autoClose,
      cls
    }, me.editorConfig);
  } // Called from editEvent() to actually show the editor


  internalShowEditor(eventRecord, resourceRecord, align = null) {
    var _align, _align$target, _align2;

    const me = this,
          {
      scheduler
    } = me,
          // Align to the element (b-sch-event) and not the wrapper
    eventElement = ((_align = align) === null || _align === void 0 ? void 0 : (_align$target = _align.target) === null || _align$target === void 0 ? void 0 : _align$target.nodeType) === Element.ELEMENT_NODE ? align.target : _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].down(scheduler.getElementFromEventRecord(eventRecord, resourceRecord), scheduler.eventInnerSelector),
          isPartOfStore = eventRecord.isPartOfStore(scheduler.eventStore);
    align = (_align2 = align) !== null && _align2 !== void 0 ? _align2 : {
      // Align to the element (b-sch-event) and not the wrapper
      target: eventElement,
      anchor: true
    }; // Event not in current TimeAxis - cannot be edited without extending the TimeAxis.
    // If there's no event element and the eventRecord is not in the store, we still
    // edit centered on the Scheduler - we're adding a new event

    if (align.target || !isPartOfStore || eventRecord.isCreating) {
      /**
       * Fires on the owning Scheduler before an event is displayed in an editor.
       * This may be listened for to allow an application to take over event editing duties. Returning `false`
       * stops the default editing UI from being shown.
       * @event beforeEventEdit
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
       * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
       * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
       * is being created, it will not contain a resource, so this parameter specifies the resource the
       * event is being created for.
       * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
       * @preventable
       */
      if (scheduler.trigger('beforeEventEdit', {
        eventEdit: me,
        eventRecord,
        resourceRecord,
        eventElement
      }) === false) {
        scheduler.element.classList.remove('b-eventeditor-editing');
        return false;
      }

      me.resourceRecord = resourceRecord;
      const editor = me.getEditor(eventRecord);
      me.editingContext = {
        eventRecord,
        resourceRecord,
        eventElement,
        editor,
        isPartOfStore
      };
      super.internalShowEditor && super.internalShowEditor(eventRecord, resourceRecord, align);

      if (me.typeField) {
        me.toggleEventType(eventRecord.get(me.typeField));
      }

      me.loadRecord(eventRecord, resourceRecord); // Honour alignment settings "anchor" and "centered" which may be injected from editorConfig.

      if (editor.centered || !editor.anchor) {
        editor.show();
      } else if (eventElement) {
        me.targetEventElement = eventElement;
        editor.showBy(align);
      } // We are adding an unrendered event. Display the editor centered
      else {
        editor.show(); // Must be done after show because show always reverts to its configured centered setting.

        editor.updateCentered(true);
      } // Adjust time field step increment based on timeAxis resolution


      const timeResolution = scheduler.timeAxisViewModel.timeResolution;

      if (timeResolution.unit === 'hour' || timeResolution.unit === 'minute') {
        const step = `${timeResolution.increment}${timeResolution.unit}`;

        if (me.startTimeField) {
          me.startTimeField.step = step;
        }

        if (me.endTimeField) {
          me.endTimeField.step = step;
        }
      } // Might end up here with the old listener still around in monkey test for stress demo in turbo mode.
      // Some action happening during edit, but cannot track down how what is going on


      me.detachListeners('changesWhileEditing');
      scheduler.eventStore.on({
        change: me.onChangeWhileEditing,
        refresh: me.onChangeWhileEditing,
        thisObj: me,
        name: 'changesWhileEditing'
      });
    }
  }

  onChangeWhileEditing() {
    const me = this; // If event was removed, cancel editing

    if (me.isEditing && me.editingContext.isPartOfStore && !me.eventRecord.isPartOfStore(me.scheduler.eventStore)) {
      me.onCancelClick();
    }
  } // Fired in a listener so that it's after the auto-called onBeforeShow listeners so that
  // subscribers to the beforeEventEditShow are called at exactly the correct lifecycle point.


  onBeforeEditorShow() {
    super.onBeforeEditorShow(...arguments);
    /**
     * Fires on the owning Scheduler when the editor for an event is available but before it is populated with
     * data and shown. Allows manipulating fields etc.
     * @event beforeEventEditShow
     * @on-owner
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
     * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
     * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
     * is being created, it will not contain a resource, so this parameter specifies the resource the
     * event is being created for.
     * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
     * @param {Core.widget.Popup} editor The editor
     */

    this.scheduler.trigger('beforeEventEditShow', _objectSpread({
      eventEdit: this
    }, this.editingContext));
  }

  updateTargetEventElement(targetEventElement, oldTargetEventElement) {
    if (targetEventElement) {
      targetEventElement.classList.add('b-editing');
    }

    if (oldTargetEventElement) {
      oldTargetEventElement.classList.remove('b-editing');
    }
  }
  /**
   * Opens an editor for the passed event. This function is exposed on Scheduler and can be called as
   * `scheduler.editEvent()`.
   * @param {Scheduler.model.EventModel} eventRecord Event to edit
   * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
   * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
   * multi assignment.
   * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
   * @on-owner
   */


  editEvent(eventRecord, resourceRecord, element = null) {
    const me = this,
          {
      simpleEventEdit
    } = me.client.features;

    if (me.isEditing) {
      // old editing flow already running, clean it up
      me.resetEditingContext();
    } // If simple edit feature is active, use it when a new event is created


    if (me.disabled || eventRecord.isCreating && simpleEventEdit && !simpleEventEdit.disabled) {
      return;
    } // The Promise being async allows a mouseover to trigger the event tip
    // unless we add the editing class immediately.


    me.scheduler.element.classList.add('b-eventeditor-editing'); // Implementations may be async, so the return value must always be propagated.

    return me.doEditEvent(...arguments);
  }
  /**
   * Returns true if the editor is currently active
   * @readonly
   * @property {Boolean}
   */


  get isEditing() {
    var _this$editor;

    return Boolean((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.isVisible);
  } // editEvent is the single entry point in the base class.
  // Subclass implementations of the action may differ, so are implemented in doEditEvent


  doEditEvent(eventRecord, resourceRecord, element = null) {
    const me = this,
          {
      scheduler
    } = me,
          isNewRecord = eventRecord.isCreating;

    if (!resourceRecord) {
      // Need to handle resourceId for edge case when creating an event with resourceId and editing it before
      // adding it to the EventStore
      resourceRecord = eventRecord.resource || me.resourceStore.getById(eventRecord.resourceId);
    }

    if (isNewRecord) {
      // Ensure temporal data fields are ready when the editor is shown
      _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_9__["default"].prototype.normalize.call(eventRecord);
    } // If element is specified (call triggered by EventDragCreate)
    // Then we can align to that, and no scrolling is necessary.
    // If we are simply being asked to edit a new event which is not
    // yet added, the editor is centered, and no scroll is necessary


    if (element || isNewRecord) {
      me.internalShowEditor(eventRecord, resourceRecord, element ? {
        target: element
      } : null);
    } else {
      // Ensure event is in view before showing the editor.
      // Note that we first need to extend the time axis to include
      // currently out of range events.
      scheduler.scrollResourceEventIntoView(resourceRecord, eventRecord, null, {
        animate: true,
        edgeOffset: 0,
        extendTimeAxis: false
      }).then(() => me.internalShowEditor(eventRecord, resourceRecord), () => scheduler.element.classList.remove('b-eventeditor-editing'));
    }
  }
  /**
   * Sets fields values from record being edited
   * @private
   */


  loadRecord(eventRecord, resourceRecord) {
    this.loadingRecord = true;
    this.internalLoadRecord(eventRecord, resourceRecord);
    this.loadingRecord = false;
  }

  get eventRecord() {
    return this.editor.record;
  }

  internalLoadRecord(eventRecord, resourceRecord) {
    const me = this,
          {
      eventStore
    } = me.client,
          {
      editor
    } = me;
    me.resourceRecord = resourceRecord;
    editor.record = eventRecord;

    if (me.resourceField) {
      const resources = eventStore.getResourcesForEvent(eventRecord); // Flag on parent Container to indicate that initially blank fields are valid

      editor._isSettingValues = true; // If this is an unassigned event, select the resource we've been provided

      if (!eventStore.storage.includes(eventRecord, true) && resourceRecord) {
        me.resourceField.value = resourceRecord[me.resourceField.valueField];
      } else if (me.assignmentStore) {
        me.resourceField.value = resources.map(resource => resource[me.resourceField.valueField]);
      }

      editor._isSettingValues = false;
    }

    super.internalLoadRecord(eventRecord, resourceRecord);
  }

  toggleEventType(eventType) {
    // expose eventType in dataset, for querying and styling
    this.editor.element.dataset.eventType = eventType || '';
    this.editor.eachWidget(widget => {
      var _widget$dataset;

      // need {}'s here so we don't return false and end iteration
      ((_widget$dataset = widget.dataset) === null || _widget$dataset === void 0 ? void 0 : _widget$dataset.eventType) && (widget.hidden = widget.dataset.eventType !== eventType);
    });
  } //endregion
  //region Save


  async finalizeEventSave(eventRecord, resourceRecords, resolve, reject) {
    const me = this,
          {
      scheduler,
      eventStore,
      assignmentStore
    } = me;
    const aborted = false; // Prevent multiple commits from this flow

    assignmentStore.suspendAutoCommit(); // Avoid multiple redraws, from event changes + assignment changes

    scheduler.suspendRefresh();
    me.onBeforeSave(eventRecord);
    eventRecord.beginBatch();
    me.updateRecord(eventRecord);
    eventRecord.endBatch();

    if (!eventRecord.isOccurrence) {
      if (me.resourceField) {
        eventStore.assignEventToResource(eventRecord, resourceRecords, true);
      }
    } // An occurrence event record may have changed only resources value. In that case we'll never get into afterChange() method that
    // apply changed data and make an event "real", because resources is not a field and a record won't be marked as dirty.
    // We used temporary field to save updated resources list and get into afterChange() method.
    else if (resourceRecords) {
      eventRecord.set('resourceRecords', resourceRecords);
    } // If it was a provisional event, passed in here from drag-create or dblclick or contextmenu,
    // it's now it's no longer a provisional event and will not be removed in resetEditingContext
    // Also, when promoted to be permanent, auto syncing will kick in if configured.


    eventRecord.isCreating = false;

    if (!aborted) {
      await scheduler.project.commitAsync();
    }

    assignmentStore.resumeAutoCommit(); // Redraw once

    scheduler.resumeRefresh(true);

    if (!aborted) {
      /**
       * Fires on the owning Scheduler after an event is successfully saved
       * @event afterEventSave
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler instance
       * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
       */
      scheduler.trigger('afterEventSave', {
        eventRecord
      });
      me.onAfterSave(eventRecord);
    }

    resolve(aborted ? false : eventRecord);
  }
  /**
   * Saves the changes (applies them to record if valid, if invalid editor stays open)
   * @private
   * @fires beforeEventSave
   * @fires beforeEventAdd
   * @fires afterEventSave
   * @returns {Promise}
   * @async
   */


  save() {
    return new Promise((resolve, reject) => {
      var _me$resourceField;

      const me = this,
            {
        scheduler,
        eventRecord
      } = me;

      if (!eventRecord || !me.editor.isValid) {
        resolve(false);
        return;
      }

      const {
        eventStore,
        values
      } = me,
            resourceRecords = ((_me$resourceField = me.resourceField) === null || _me$resourceField === void 0 ? void 0 : _me$resourceField.records) || (me.resourceRecord ? [me.resourceRecord] : []),
            resourceRecord = resourceRecords[0]; // Check for potential overlap scenarios before saving. TODO needs to be indicated in the UI

      if (!me.scheduler.allowOverlap && eventStore) {
        const abort = resourceRecords.some(resource => {
          return !eventStore.isDateRangeAvailable(values.startDate, values.endDate, eventRecord, resource);
        });

        if (abort) {
          resolve(false);
          return;
        }
      }

      const context = {
        finalize(saveEvent) {
          try {
            if (saveEvent !== false) {
              me.finalizeEventSave(eventRecord, resourceRecords, resolve, reject);
            } else {
              resolve(false);
            }
          } catch (e) {
            reject(e);
          }
        }

      };
      /**
       * Fires on the owning Scheduler before an event is saved, return `false` to prevent the save.
       * @event beforeEventSave
       * @on-owner
       * @param {Scheduler.view.Scheduler} source The scheduler instance
       * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
       * @param {Scheduler.model.ResourceModel} resourceRecord [DEPRECATED IN FAVOR OF `resourceRecords`] The resource to which the event is assigned
       * @param {Scheduler.model.ResourceModel[]} resourceRecords The resources to which the event is assigned
       * @param {Object} values The new values
       * @param {Object} context Extended save context:
       * @param {Boolean} [context.async] Set this to `true` in a listener to indicate that the listener will asynchronously decide to prevent or not the event save.
       * @param {Function} context.finalize Function to call to finalize the save. Used when `async` is `true`. Provide `false` to the function to prevent the save.
       * @preventable
       */

      if (scheduler.trigger('beforeEventSave', {
        eventRecord,
        resourceRecords,
        resourceRecord,
        values,
        context
      }) === false) {
        resolve(false);
        return;
      } // truthy context.async means than a listener will decide to approve saving asynchronously


      if (!context.async) {
        context.finalize();
      }
    });
  } //endregion
  //region Delete

  /**
   * Delete event being edited
   * @returns {Promise}
   * @fires beforeEventDelete
   * @private
   * @async
   */


  deleteEvent() {
    this.detachListeners('changesWhileEditing');
    return new Promise((resolve, reject) => {
      const me = this,
            {
        eventRecord,
        editor
      } = me;
      me.scheduler.removeEvents([eventRecord], removeRecord => {
        // The reason it does it here is to move focus *before* it gets deleted,
        // and then there's code in the delete to see that it's deleting the focused one,
        // and jump forwards or backwards to move to the next or previous event
        // See 'Should allow key activation' test in tests/view/mixins/EventNavigation.t.js
        if (removeRecord && editor.containsFocus) {
          editor.revertFocus();
        }

        resolve(removeRecord);
      });
    });
  } //endregion
  //region Stores


  onChangeProject() {
    // Release resource store on project change, it will be re-chained on next show
    if (this.resourceField) {
      this.resourceField.store = {}; // Cannot use null
    }
  }

  get eventStore() {
    return this.scheduler.project.eventStore;
  }

  get resourceStore() {
    return this.scheduler.project.resourceStore;
  }

  get assignmentStore() {
    return this.scheduler.project.assignmentStore;
  } //endregion
  //endregion
  //region Events


  onActivateEditor({
    eventRecord,
    resourceRecord,
    eventElement
  }) {
    this.editEvent(eventRecord, resourceRecord, eventElement);
  }

  onDragCreateEnd({
    eventRecord,
    resourceRecord,
    proxyElement
  }) {
    this.editEvent(eventRecord, resourceRecord, proxyElement);
  } // chained from EventNavigation


  onEventEnterKey({
    assignmentRecord,
    eventRecord,
    target
  }) {
    const element = target.closest(this.client.eventInnerSelector);

    if (assignmentRecord) {
      this.editEvent(eventRecord, assignmentRecord.resource, element);
    } else if (eventRecord) {
      this.editEvent(eventRecord, eventRecord.resource, element);
    }
  } // Toggle fields visibility when changing eventType


  onEventTypeChange({
    value
  }) {
    this.toggleEventType(value);
  } //endregion
  //region Context menu


  populateEventMenu({
    eventRecord,
    resourceRecord,
    items
  }) {
    if (!this.scheduler.readOnly) {
      items.editEvent = {
        text: 'L{EventEdit.Edit event}',
        localeClass: this,
        icon: 'b-icon b-icon-edit',
        weight: 100,
        onItem: () => {
          this.editEvent(eventRecord, resourceRecord);
        }
      };
    }
  } //endregion


  resetEditingContext() {
    this.detachListeners('changesWhileEditing');
    super.resetEditingContext(); // Clear to prevent retaining project

    this.resourceRecord = this.editingContext = this.editor._record = null;
  }

}
EventEdit._$name = 'EventEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventEdit, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventEdit, false, ['SchedulerPro', 'ResourceHistogram']);
EventEdit.initClass();

/***/ }),

/***/ "./lib/Scheduler/feature/EventFilter.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/EventFilter.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventFilter; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';


/**
 * @module Scheduler/feature/EventFilter
 */

/**
 * Adds event filter menu items to the timeline header context menu.
 *
 * This feature is **enabled** by default
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     eventFilter : true // `true` by default, set to `false` to disable the feature and remove the menu item from the timeline header
 *   }
 * });
 *
 * @classtype eventFilter
 * @feature
 * @inlineexample Scheduler/feature/EventFilter.js
 */

class EventFilter extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Plugin configuration. This plugin chains some of the functions in Grid.
  static get $name() {
    return 'EventFilter';
  }

  static get pluginConfig() {
    return {
      chain: ['populateHeaderMenu', // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.
      'populateTimeAxisHeaderMenu']
    };
  }

  construct(scheduler, config) {
    super.construct(scheduler, config);
    this.scheduler = scheduler;
  } // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.

  /**
   * Populates the header context menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead
   */


  populateHeaderMenu({
    column,
    items
  }) {
    if (column.type !== 'timeAxis') {
      return;
    }

    this.populateTimeAxisHeaderMenu(...arguments);
  }
  /**
   * Populates the header context menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateTimeAxisHeaderMenu({
    column,
    items
  }) {
    const me = this;
    items.eventsFilter = {
      text: 'L{filterEvents}',
      icon: 'b-fw-icon b-icon-filter',
      disabled: me.disabled,
      localeClass: this,
      weight: 100,
      menu: {
        type: 'popup',
        localeClass: this,
        items: {
          nameFilter: {
            weight: 110,
            type: 'textfield',
            cls: 'b-eventfilter b-last-row',
            clearable: true,
            keyStrokeChangeDelay: 300,
            label: 'L{byName}',
            localeClass: this,
            width: 200,
            listeners: {
              change: me.onEventFilterChange,
              thisObj: me
            }
          }
        },

        onBeforeShow({
          source: menu
        }) {
          const [filterByName] = menu.items,
                filter = me.scheduler.eventStore.filters.getBy('property', 'name');
          filterByName.value = filter && filter.value || '';
        }

      }
    };
  }

  onEventFilterChange({
    value
  }) {
    const me = this;

    if (value !== '') {
      me.scheduler.eventStore.filter('name', value);
    } else {
      me.scheduler.eventStore.removeFilter('name');
    }
  }

}
EventFilter.featureClass = 'b-event-filter';
EventFilter._$name = 'EventFilter';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventFilter, true, ['Scheduler', 'Gantt']);
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventFilter, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventMenu.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventMenu.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventMenu; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/EventMenu
 */

/**
 * Displays a context menu for events. Items are populated by other features and/or application code.
 *
 * ### Default event menu items
 *
 * Here is the list of menu items provided by the feature and populated by the other features:
 *
 * | Reference       | Text           | Weight | Feature                             | Description                                                             |
 * |-----------------|----------------|--------|-------------------------------------|-------------------------------------------------------------------------|
 * | `editEvent`     | Edit event     | 100    | {@link Scheduler.feature.EventEdit} | Open the event editor. Hidden for read-only Scheduler                   |
 * | `deleteEvent`   | Delete event   | 200    | *This feature*                      | Remove the event. Hidden for read-only Scheduler                        |
 * | `unassignEvent` | Unassign event | 300    | *This feature*                      | Unassign the event. Shown when using multi-assignment and not read-only |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Event menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all events:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem({eventRecord}) {
 *                         eventRecord.flagged = true;
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Remove existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 deleteEvent   : false,
 *                 unassignEvent : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 deleteEvent : {
 *                     text : 'Delete booking'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Manipulate existing items for all events or specific events:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             // Process items before menu is shown
 *             processItems({eventRecord, items}) {
 *                  // Push an extra item for conferences
 *                  if (eventRecord.type === 'conference') {
 *                      items.showSessionItem = {
 *                          text : 'Show sessions',
 *                          onItem({eventRecord}) {
 *                              // ...
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for secret events
 *                  if (eventRecord.type === 'secret') {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/base/TimeSpanMenuBase
 * @demo Scheduler/eventmenu
 * @classtype eventMenu
 * @feature
 */

class EventMenu extends _base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'EventMenu';
  }

  static get configurable() {
    return {
      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       * features         : {
       *    eventMenu : {
       *         processItems({ items, eventRecord, assignmentRecord, resourceRecord }) {
       *             // Add or hide existing items here as needed
       *             items.myAction = {
       *                 text   : 'Cool action',
       *                 icon   : 'b-fa b-fa-fw b-fa-ban',
       *                 onItem : () => console.log(`Clicked ${eventRecord.name}`),
       *                 weight : 1000 // Move to end
       *             };
       *
       *            if (!eventRecord.allowDelete) {
       *                 items.deleteEvent.hidden = true;
       *             }
       *         }
       *     }
       * },
       * ```
       * @param {Object} context An object with information about the menu being shown
       * @param {Scheduler.model.EventModel} context.eventRecord The record representing the current event
       * @param {Scheduler.model.ResourceModel} context.resourceRecord The record representing the current resource
       * @param {Scheduler.model.AssignmentModel} context.assignmentRecord The assignment record
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null,
      type: 'event'
      /**
       * This is a preconfigured set of items used to create the default context menu.
       *
       * The `items` provided by this feature are listed below. These are the property names which you may
       * configure:
       *
       * - `deleteEvent` Deletes the context event.
       * - `unassignEvent` Unassigns the context event from the current resource (only added when multi assignment is used).
       *
       * To remove existing items, set corresponding keys to `false`
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventMenu : {
       *             items : {
       *                 deleteEvent   : false,
       *                 unassignEvent : false
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * See the feature config in the above example for details.
       *
       * @config {Object} items
       */

    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateEventMenu');
    return config;
  } //endregion
  //region Events

  /**
   * This event fires on the owning Scheduler before the context menu is shown for an event. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
   * being shown.
   * @event eventMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {Scheduler.view.Scheduler} source
   * @param {Object} items Menu item configs
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   * @param {MouseEvent} [event] Pointer event which triggered the context menu (if any)
   */

  /**
   * This event fires on the owning Scheduler when an item is selected in the context menu.
   * @event eventMenuItem
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.MenuItem} item
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler after showing the context menu for an event
   * @event eventMenuShow
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */
  //endregion


  onElementKeyDown(event) {
    if (!event.handled && event.target.matches(this.client.eventSelector)) {
      if (event.key === ' ') {
        this.internalShowContextMenu(this.createContextMenuEventForElement(event.target));
      }
    }
  }

  getDataFromEvent(event) {
    const data = super.getDataFromEvent(event),
          eventElement = data.targetElement,
          {
      client
    } = this,
          eventRecord = client.resolveEventRecord(eventElement),
          // For vertical mode the resource must be resolved from the event
    resourceRecord = eventRecord && (client.resolveResourceRecord(eventElement) || client.resourceStore.last),
          assignmentRecord = eventRecord && client.resolveAssignmentRecord(eventElement);
    return Object.assign(data, {
      eventElement,
      eventRecord,
      resourceRecord,
      assignmentRecord
    });
  }

  getTargetElementFromEvent({
    target
  }) {
    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(target, this.client.eventSelector) || target;
  }

  shouldShowMenu(eventParams) {
    return eventParams.eventRecord;
  }
  /**
   * Shows context menu for the provided event. If record is not rendered (outside of time span/filtered)
   * menu won't appear.
   * @param {Scheduler.model.EventModel} eventRecord Event record to show menu for.
   * @param {Object} [options]
   * @param {HTMLElement} options.targetElement Element to align context menu to.
   * @param {MouseEvent} options.event Browser event.
   * If provided menu will be aligned according to clientX/clientY coordinates.
   * If omitted, context menu will be centered to event element.
   */


  showContextMenuFor(eventRecord, {
    targetElement,
    event
  } = {}) {
    if (this.disabled) {
      return;
    }

    if (!targetElement) {
      targetElement = this.getElementFromRecord(eventRecord); // If record is not rendered, do nothing

      if (!targetElement) {
        return;
      }
    }

    event = event || this.createContextMenuEventForElement(targetElement);
    this.internalShowContextMenu(event);
  }

  getElementFromRecord(record) {
    return this.client.getElementsFromEventRecord(record)[0];
  }

  populateEventMenu({
    items
  }) {
    const {
      client
    } = this;
    items.deleteEvent = {
      hidden: client.readOnly
    };
    items.unassignEvent = {
      hidden: client.readOnly || client.eventStore.usesSingleAssignment
    };
  } // This generates the fixed, unchanging part of the items and is only called once
  // to generate the baseItems of the feature.
  // The dynamic parts which are set by populateEventMenu have this merged into them.


  changeItems(items) {
    const {
      client
    } = this;
    return _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge({
      deleteEvent: {
        text: 'L{SchedulerBase.Delete event}',
        icon: 'b-icon b-icon-trash',
        weight: 200,

        onItem({
          menu,
          eventRecord
        }) {
          var _menu$focusInEvent;

          // We must synchronously push focus back into the menu's triggering
          // event so that the our beforeRemove handlers can move focus onwards
          // to the closest remaining event.
          // Otherwise, the menu's default hide processing on hide will attempt
          // to move focus back to the menu's triggering event which will
          // by then have been deleted.
          const revertTarget = (_menu$focusInEvent = menu.focusInEvent) === null || _menu$focusInEvent === void 0 ? void 0 : _menu$focusInEvent.relatedTarget;

          if (revertTarget) {
            revertTarget.focus();
            client.navigator.activeItem = revertTarget;
          }

          client.removeEvents(client.isEventSelected(eventRecord) ? client.selectedEvents : [eventRecord]);
        }

      },
      unassignEvent: {
        text: 'L{SchedulerBase.Unassign event}',
        icon: 'b-icon b-icon-unassign',
        weight: 300,

        onItem({
          menu,
          eventRecord,
          resourceRecord
        }) {
          var _menu$focusInEvent2;

          // We must synchronously push focus back into the menu's triggering
          // event so that the our beforeRemove handlers can move focus onwards
          // to the closest remaining event.
          // Otherwise, the menu's default hide processing on hide will attempt
          // to move focus back to the menu's triggering event which will
          // by then have been deleted.
          const revertTarget = (_menu$focusInEvent2 = menu.focusInEvent) === null || _menu$focusInEvent2 === void 0 ? void 0 : _menu$focusInEvent2.relatedTarget;

          if (revertTarget) {
            revertTarget.focus();
            client.navigator.activeItem = revertTarget;
          }

          eventRecord.unassign(resourceRecord);
        }

      }
    }, items);
  }

}
EventMenu.featureClass = '';
EventMenu._$name = 'EventMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(EventMenu, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(EventMenu, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventResize.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/EventResize.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventResize; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony import */ var _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';












/**
 * @module Scheduler/feature/EventResize
 */

const tipAlign = {
  top: 'b-t',
  right: 'b100-t100',
  bottom: 't-b',
  left: 'b100-t100'
};
/**
 * Feature that allows resizing an event by dragging its end.
 *
 * By default it displays a tooltip with the new start and end dates, formatted using
 * {@link Scheduler/view/mixin/TimelineViewPresets#config-displayDateFormat}.
 *
 * ## Customizing the resize tooltip
 *
 * To show custom HTML in the tooltip, please see the {@link #config-tooltipTemplate} config. Example:
 *
 * ```javascript
 * eventResize : {
 *     // A minimal end date tooltip
 *     tooltipTemplate : ({ record, endDate }) => {
 *         return DateHelper.format(endDate, 'MMM D');
 *     }
 * }
 * ```
 * This feature is **enabled** by default
 *
 * This feature is extended with a few overrides by the Gantt's `TaskResize` feature.
 *
 * This feature updates the event's `startDate` or `endDate` live in order to leverage the
 * rendering pathway to always yield a correct appearance. The changes are done in
 * {@link Core.data.Model#function-beginBatch batched} mode so that changes do not become
 * eligible for data synchronization or propagation until the operation is completed.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/EventResize.js
 * @classtype eventResize
 * @feature
 */

class EventResize extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_1__["default"], _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Events

  /**
   * Fired on the owning Scheduler before resizing starts. Return `false` to prevent the action.
   * @event beforeEventResize
   * @on-owner
   * @preventable
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel} eventRecord Event record being resized
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record the resize starts within
   * @param {MouseEvent} event Browser event
   */

  /**
   * Fires on the owning Scheduler when event resizing starts
   * @event eventResizeStart
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel} eventRecord Event record being resized
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record the resize starts within
   * @param {MouseEvent} event Browser event
   */

  /**
   * Fires on the owning Scheduler on each resize move event
   * @event eventPartialResize
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Scheduler.model.EventModel} eventRecord Event record being resized
   * @param {Date} startDate
   * @param {Date} endDate
   * @param {HTMLElement} element
   */

  /**
   * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
   * in the listener, to show a confirmation popup etc
   * ```
   *  scheduler.on('beforeeventresizefinalize', ({context}) => {
   *      context.async = true;
   *      setTimeout(() => {
   *          // async code don't forget to call finalize
   *          context.finalize();
   *      }, 1000);
   *  })
   * ```
   * @event beforeEventResizeFinalize
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Object} context
   * @param {Boolean} context.async Set true to handle resize asynchronously (e.g. to wait for user confirmation)
   * @param {Function} context.finalize Call this method to finalize resize. This method accepts one argument:
   *                   pass `true` to update records, or `false`, to ignore changes
   */

  /**
   * Fires on the owning Scheduler after the resizing gesture has finished.
   * @event eventResizeEnd
   * @on-owner
   * @param {Scheduler.view.Scheduler} source Scheduler instance
   * @param {Boolean} changed Shows if the record has been changed by the resize action
   * @param {Scheduler.model.EventModel} eventRecord Event record being resized
   */
  //endregion
  //region Config
  static get $name() {
    return 'EventResize';
  }

  static get configurable() {
    return {
      draggingItemCls: 'b-sch-event-wrap-resizing',
      resizingItemInnerCls: 'b-sch-event-resizing',

      /**
       * Use left handle when resizing. Only applies when owning client's `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      leftHandle: true,

      /**
       * Use right handle when resizing. Only applies when owning client's `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      rightHandle: true,

      /**
       * Use top handle when resizing. Only applies when owning client's direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      topHandle: true,

      /**
       * Use bottom handle when resizing. Only applies when owning client's `direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      bottomHandle: true,

      /**
       * Resizing handle size
       * @config {Number}
       * @default
       */
      handleSize: 10,

      /**
       * Automatically shrink virtual handles when available space < handleSize. The virtual handles will
       * decrease towards width/height 1, reserving space between opposite handles to for example leave room for
       * dragging. To configure reserved space, see {@link #config-reservedSpace}.
       * @config {Boolean}
       * @default false
       */
      dynamicHandleSize: true,

      /**
       * Set to true to allow resizing to a zero-duration span
       * @config {Boolean}
       * @default false
       */
      allowResizeToZero: null,

      /**
       * Room in px to leave unoccupied by handles when shrinking them dynamically (see
       * {@link #config-dynamicHandleSize}).
       * @config {Number}
       * @default
       */
      reservedSpace: 5,

      /**
       * Resizing handle size on touch devices
       * @config {Number}
       * @default
       */
      touchHandleSize: 30,

      /**
       * The amount of pixels to move pointer/mouse before it counts as a drag operation.
       * @config {Number}
       * @default
       */
      dragThreshold: 0,
      dragTouchStartDelay: 0,
      draggingClsSelector: '.b-timeline-base',

      /**
       * `false` to not show a tooltip while resizing
       * @config {Boolean}
       * @default
       */
      showTooltip: true,

      /**
       * true to see exact event length during resizing
       * @config {Boolean}
       * @default
       */
      showExactResizePosition: false,

      /**
       * An empty function by default, but provided so that you can perform custom validation on
       * the item being resized. Return true if the new duration is valid, false to signal that it is not.
       * @param {Object} context The resize context, contains the record & dates.
       * @param {Scheduler.model.TimeSpan} context.record The record being resized.
       * @param {Date} context.startDate The new start date.
       * @param {Date} context.endDate The new start date.
       * @param {Event} event The browser Event object
       * @return {Boolean}
       * @config {Function}
       */
      validatorFn: () => true,

      /**
       * `this` reference for the validatorFn
       * @config {Object}
       */
      validatorFnThisObj: null,

      /**
       * Setting this property may change the configuration of the {@link #config-tip}, or
       * cause it to be destroyed if `null` is passed.
       *
       * Reading this property returns the Tooltip instance.
       * @member {Core.widget.Tooltip|Object} tip
       */

      /**
       * If a tooltip is required to illustrate the resize, specify this as `true`, or a config
       * object for the {@link Core.widget.Tooltip}.
       * @config {Core.widget.Tooltip|Object}
       */
      tip: {
        $config: ['lazy', 'nullify'],
        value: {
          autoShow: false,
          axisLock: true,
          trackMouse: false,
          updateContentOnMouseMove: true,
          hideDelay: 0
        }
      },

      /**
       * A template function returning the content to show during a resize operation.
       * @param {Object} context A context object
       * @param {Date} context.startDate New start date
       * @param {Date} context.endDate New end date
       * @param {Scheduler.model.TimeSpan} context.record The record being resized
       * @config {Function} tooltipTemplate
       */
      tooltipTemplate: context => `
                <div class="b-sch-tip-${context.valid ? 'valid' : 'invalid'}">
                    ${context.startClockHtml}
                    ${context.endClockHtml}
                    <div class="b-sch-tip-message">${context.message}</div>
                </div>
            `,
      dragActiveCls: 'b-resizing-event'
    };
  }

  static get pluginConfig() {
    return {
      chain: ['render', 'onEventDataGenerated']
    };
  } //endregion
  //region Init & destroy


  render() {
    const me = this,
          {
      client
    } = me; // Only active when in these items

    me.dragSelector = me.dragItemSelector = client.eventSelector; // Set up elements and listeners

    me.dragRootElement = me.dropRootElement = client.timeAxisSubGridElement; // Larger draggable zones on pure touch devices with no mouse

    if (!me.handleSelector && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isHoverableDevice) {
      me.handleSize = me.touchHandleSize;
    }

    me.handleVisibilityThreshold = me.handleVisibilityThreshold || 2 * me.handleSize; // Drag only in time dimension

    me.dragLock = client.isVertical ? 'y' : 'x';
  } // Called for each event during render, allows manipulation of render data.


  onEventDataGenerated({
    eventRecord,
    wrapperCls,
    cls
  }) {
    var _this$dragging, _this$dragging$contex;

    if (eventRecord === ((_this$dragging = this.dragging) === null || _this$dragging === void 0 ? void 0 : (_this$dragging$contex = _this$dragging.context) === null || _this$dragging$contex === void 0 ? void 0 : _this$dragging$contex.eventRecord)) {
      wrapperCls['b-active'] = wrapperCls[this.draggingItemCls] = wrapperCls['b-over-resize-handle'] = cls['b-resize-handle'] = cls[this.resizingItemInnerCls] = 1;
    }
  } // Sneak a first peek at the drag event to put necessary date values into the context


  onDragPointerMove(event) {
    var _dragging$context;

    const {
      client,
      dragging
    } = this,
          {
      visibleDateRange,
      isHorizontal
    } = client,
          dimension = isHorizontal ? 'X' : 'Y',
          pageScroll = window[`page${dimension}Offset`],
          coord = event[`page${dimension}`] + (((_dragging$context = dragging.context) === null || _dragging$context === void 0 ? void 0 : _dragging$context.offset) || 0),
          clientRect = client.timeAxisSubGridElement.getBoundingClientRect(),
          [startCoord, endCoord] = isHorizontal ? [clientRect.left, clientRect.right] : [clientRect.top, clientRect.bottom];
    ; // If we're dragging off the start side, fix at the visible startDate

    if (coord - pageScroll < startCoord) {
      dragging.date = visibleDateRange.startDate;
    } // If we're dragging off the end side, fix at the visible endDate
    else if (coord - pageScroll > endCoord) {
      dragging.date = visibleDateRange.endDate;
    } // Use the value set up in onDragPointerMove
    else {
      dragging.date = client.getDateFromCoordinate(coord, null, false);
    }

    super.onDragPointerMove(event);
  }

  beforeDrag(drag) {
    const {
      client
    } = this;

    if (this.disabled || client.readOnly || super.beforeDrag(drag) === false) {
      return false;
    }

    drag.mousedownDate = drag.date = client.getDateFromCoordinate(drag.event[`page${client.isHorizontal ? 'X' : 'Y'}`], null, false); // trigger beforeEventResize or beforeTaskResize depending on product

    return this.triggerBeforeResize(drag);
  }

  dragStart(drag) {
    var _client$resolveAssign;

    const me = this,
          {
      client,
      tip
    } = me,
          name = client.scheduledEventName,
          eventRecord = client.resolveEventRecord(drag.itemElement),
          {
      isBatchUpdating
    } = eventRecord,
          eventStartDate = isBatchUpdating ? eventRecord.get('startDate') : eventRecord.startDate,
          eventEndDate = isBatchUpdating ? eventRecord.get('endDate') : eventRecord.endDate,
          horizontal = me.dragLock === 'x',
          draggingEnd = me.isOverEndHandle(drag.startEvent, drag.itemElement),
          toSet = draggingEnd ? 'endDate' : 'startDate',
          otherEnd = draggingEnd ? 'startDate' : 'endDate',
          setMethod = draggingEnd ? 'setEndDate' : 'setStartDate',
          setOtherMethod = draggingEnd ? 'setStartDate' : 'setEndDate',
          element = drag.itemElement,
          elRect = element.getBoundingClientRect(),
          startCoord = horizontal ? drag.startEvent.clientX : drag.startEvent.clientY,
          endCoord = draggingEnd ? horizontal ? elRect.right : elRect.bottom : horizontal ? elRect.left : elRect.top,
          timespanRecord = client.resolveTimeSpanRecord(element),
          context = drag.context = {
      eventRecord,
      timespanRecord,
      element,
      taskRecord: eventRecord,
      owner: me,
      valid: true,
      oldValue: draggingEnd ? eventEndDate : eventStartDate,
      startDate: eventStartDate,
      endDate: eventEndDate,
      offset: endCoord - startCoord,
      edge: horizontal ? draggingEnd ? 'right' : 'left' : draggingEnd ? 'bottom' : 'top',
      finalize: me.finalize,
      event: drag.event,
      draggingEnd,
      toSet,
      otherEnd,
      setMethod,
      setOtherMethod
    }; // The record must know that it is being resized.

    eventRecord.meta.isResizing = true;
    client.element.classList.add(...me.dragActiveCls.split(' ')); // During this batch we want the client's UI to update itself using the proposed changes
    // Only if startDrag has not already done it

    if (!client.listenToBatchedUpdates) {
      client.beginListeningForBatchedUpdates();
    } // No changes must get through to data.
    // Only if startDrag has not already started the batch


    if (!isBatchUpdating) {
      eventRecord.beginBatch();
    } // Let products do their specific stuff


    me.setupProductResizeContext(context, drag.startEvent); // Trigger eventResizeStart or taskResizeStart depending on product
    // Subclasses (like EventDragCreate) won't actually fire this event.

    me.triggerEventResizeStart(`${name}ResizeStart`, _objectSpread({
      [`${name}Record`]: eventRecord,
      event: drag.startEvent
    }, me.getResizeStartParams(context))); // Scheduler renders assignments, Gantt renders Tasks

    context.resizedRecord = ((_client$resolveAssign = client.resolveAssignmentRecord) === null || _client$resolveAssign === void 0 ? void 0 : _client$resolveAssign.call(client, context.element)) || eventRecord;

    if (tip) {
      // Tip needs to be shown first for getTooltipTarget to be able to measure anchor size
      tip.show();
      tip.align = tipAlign[drag.context.edge];
      tip.showBy(me.getTooltipTarget(drag));
    }
  } // Subclasses may override this


  triggerBeforeResize(drag) {
    const {
      client
    } = this,
          name = client.scheduledEventName,
          eventRecord = client.resolveTimeSpanRecord(drag.itemElement);
    return client.trigger(`before${client.capitalizedEventName}Resize`, _objectSpread({
      [name + 'Record']: eventRecord,
      event: drag.event
    }, this.getBeforeResizeParams({
      event: drag.startEvent,
      element: drag.itemElement
    })));
  } // Subclasses may override this


  triggerEventResizeStart(eventType, event) {
    this.client.trigger(eventType, event);
  }

  dragEnter(drag) {
    // We only respond to our own DragContexts
    return drag.context.owner === this;
  } // Override the draggable interface so that we can update the bar while dragging outside
  // the Draggable's rootElement (by default it stops notifications when outside rootElement)


  moveDrag(drag) {
    const me = this,
          {
      client,
      tip
    } = me,
          dimension = client.isHorizontal ? 'X' : 'Y',
          name = client.scheduledEventName,
          {
      dependencies
    } = client.features,
          {
      visibleDateRange,
      enableEventAnimations,
      timeAxis,
      weekStartDay
    } = client,
          {
      resolutionUnit,
      resolutionIncrement
    } = timeAxis,
          {
      event,
      context
    } = drag,
          {
      eventRecord,
      offset
    } = context,
          {
      isOccurrence
    } = eventRecord,
          eventStart = eventRecord.get('startDate'),
          eventEnd = eventRecord.get('endDate'),
          horizontal = me.dragLock === 'x',
          coord = event[`client${dimension}`] + offset,
          clientRect = client.timeAxisSubGridElement.getBoundingClientRect(),
          [startCoord, endCoord] = horizontal ? [clientRect.left, clientRect.right] : [clientRect.top, clientRect.bottom];
    context.event = event; // If this is the last move event recycled because of a scroll, refresh the date

    if (event.isScroll) {
      drag.date = client.getDateFromCoordinate(event[`page${dimension}`] + offset, null, false);
    }

    let date,
        crossedOver,
        avoidedZeroSize,
        {
      toSet,
      otherEnd,
      draggingEnd
    } = context; // If we're dragging off the start side, fix at the visible startDate

    if (coord < startCoord) {
      date = drag.date = visibleDateRange.startDate;
    } // If we're dragging off the end side, fix at the visible endDate
    else if (coord > endCoord) {
      date = drag.date = visibleDateRange.endDate;
    } // Use the value set up in onDragPointerMove
    else {
      date = drag.date;
    } // Detect crossover which some subclasses might need to process


    if (toSet === 'endDate') {
      if (date < eventStart) {
        crossedOver = -1;
      }
    } else {
      if (date > eventEnd) {
        crossedOver = 1;
      }
    } // If we dragged the dragged end over to the opposite side of the start end.
    // Some subclasses allow this and need to respond. EventDragCreate does this.


    if (crossedOver && me.onDragEndSwitch) {
      me.onDragEndSwitch(context, date, crossedOver);
      otherEnd = context.otherEnd;
      toSet = context.toSet;
    }

    if (client.snapRelativeToEventStartDate) {
      date = timeAxis.roundDate(date, context.oldValue);
    } // The displayed and eventual data value


    context.snappedDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].round(date, timeAxis.resolution, null, weekStartDay);
    const duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(date, context[otherEnd], resolutionUnit) * (draggingEnd ? -1 : 1); // Narrower than half resolutionIncrement will abort drag creation, set flag to have UI reflect this

    if (me.isEventDragCreate) {
      context.tooNarrow = duration < resolutionIncrement / 2;
    } // The mousepoint date means that the duration is less than resolutionIncrement resolutionUnits.
    // Ensure that the dragged end is at least resolutionIncrement resolutionUnits from the other end.
    else if (duration < resolutionIncrement) {
      // Snap to zero if allowed
      if (me.allowResizeToZero) {
        context.snappedDate = date = context[otherEnd];
      } else {
        const sign = otherEnd === 'startDate' ? 1 : -1;
        context.snappedDate = date = timeAxis.roundDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(eventRecord.get(otherEnd), resolutionIncrement * sign, resolutionUnit));
        avoidedZeroSize = true;
      }
    } // Keep desired date within constraints


    if (context.dateConstraints) {
      date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].constrain(date, context.dateConstraints.start, context.dateConstraints.end);
      context.snappedDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].constrain(context.snappedDate, context.dateConstraints.start, context.dateConstraints.end);
    } // If the mouse move has changed the detected date


    if (!context.date || date - context.date || avoidedZeroSize) {
      context.date = date; // The validityFn needs to see the proposed value.
      // Consult our snap config to see if we should be dragging in snapped mode

      context[toSet] = me.showExactResizePosition || client.timeAxisViewModel.snap ? context.snappedDate : date; // Snapping would take it to zero size - this is not allowed in drag resizing.

      if (!(context[toSet] - context[toSet === 'startDate' ? 'endDate' : 'startDate']) && !me.allowResizeToZero) {
        context.valid = false;
        return;
      } // If the date to push into the record is new...


      if (eventRecord.get(toSet) - context[toSet]) {
        context.valid = me.checkValidity(context, event);
        context.message = '';

        if (context.valid && typeof context.valid !== 'boolean') {
          context.message = context.valid.message;
          context.valid = context.valid.valid;
        } // If users returns nothing, that's interpreted as valid


        context.valid = context.valid !== false; // Only update the event if the validation passed.

        if (context.valid) {
          const partialResizeEvent = {
            [`${name}Record`]: eventRecord,
            startDate: eventStart,
            endDate: eventEnd,
            element: drag.itemElement,
            context
          }; // Update the event we are about to fire and the context *before* we update the record

          partialResizeEvent[toSet] = context[toSet]; // Trigger eventPartialResize or taskPartialResize depending on product

          client.trigger(`${name}PartialResize`, partialResizeEvent); // An occurrence must have a store to announce its batched changes through.
          // They must usually never have a store - they are transient, but we
          // need to update the UI.

          if (isOccurrence) {
            eventRecord.stores.push(client.eventStore);
          } // Update the eventRecord.
          // Use setter rather than accessor so that in a Project, the entity's
          // accessor doesn't propagate the change to the whole project.
          // Scheduler must not animate this.


          client.enableEventAnimations = false;
          eventRecord.set(toSet, context[toSet]);
          client.enableEventAnimations = enableEventAnimations;

          if (isOccurrence) {
            eventRecord.stores.length = 0;
          }

          if (dependencies && !dependencies.isDisabled) {
            dependencies.updateDependenciesForTimeSpan(eventRecord, drag.itemElement);
          }
        } // Flag drag created too narrow events as invalid late, want all code above to execute for them
        // to get the proper size rendered


        if (context.tooNarrow) {
          context.valid = false;
        }
      }
    }

    if (tip) {
      // In case of edge flip (EventDragCreate), the align point may change
      tip.align = tipAlign[drag.context.edge];
      tip.alignTo(me.getTooltipTarget(drag));
    }

    super.moveDrag(drag);
  }

  dragEnd(drag) {
    const {
      context
    } = drag;

    if (context) {
      context.event = drag.event;
    }

    if (drag.aborted) {
      context === null || context === void 0 ? void 0 : context.finalize(false);
    } // 062_resize.t.js specifies that if drag was not started but the mouse has moved,
    // the eventresizestart and eventresizeend must fire
    else if (!this.isEventDragCreate && !drag.started && !_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(drag.event).equals(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(drag.startEvent))) {
      this.dragStart(drag);
      this.cleanup(drag.context, false);
    }
  }

  async dragDrop({
    context,
    event
  }) {
    var _this$tip;

    // Set the start/end date, whichever we were dragging
    // to the correctly rounded value before updating.
    context[context.toSet] = context.snappedDate;
    const {
      client
    } = this,
          {
      startDate,
      endDate
    } = context;
    let modified;
    (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.hide();
    context.valid = startDate && endDate && (this.allowResizeToZero || endDate - startDate > 0) && // Input sanity check
    context[context.toSet] - context.oldValue && // Make sure dragged end end changed
    context.valid !== false;

    if (context.valid) {
      // Seems to be a valid resize operation, ask outside world if anyone wants to take control over the finalizing,
      // to show a confirm dialog prior to applying the new values. Triggers beforeEventResizeFinalize or
      // beforeTaskResizeFinalize depending on product
      client.trigger(`before${client.capitalizedEventName}ResizeFinalize`, {
        context,
        event
      });
      modified = true;
    } // If a handler has set the async flag, it means that they are going to finalize
    // the operation at some time in the future, so we should not call it.


    if (!context.async) {
      await context.finalize(modified);
    }
  } // This is called with a thisObj of the context object
  // We set "me" to the owner, and "context" to the thisObj so that it
  // reads as if it were a method of this class.


  async finalize(updateRecord) {
    const me = this.owner,
          context = this,
          {
      eventRecord,
      oldValue,
      toSet
    } = context,
          {
      snapRelativeToEventStartDate,
      timeAxis
    } = me.client;
    let wasChanged = false;

    if (updateRecord) {
      if (snapRelativeToEventStartDate) {
        context[toSet] = context.snappedDate = timeAxis.roundDate(context.date, oldValue);
      } // Each product updates the record differently


      wasChanged = await me.internalUpdateRecord(context, eventRecord);
    } else {
      // Reverts the changes, a batchedUpdate event will fire which will reset the UI
      eventRecord.cancelBatch(); // Manually trigger redraw of occurrences since they are not part of any stores

      if (eventRecord.isOccurrence) {
        eventRecord.resources.forEach(resource => me.client.repaintEventsForResource(resource));
      }
    }

    me.cleanup(context, wasChanged);
  } // This is always called on drop or abort.


  cleanup(context, changed) {
    var _me$tip;

    const me = this,
          {
      client
    } = me,
          {
      element,
      eventRecord
    } = context,
          {
      dependencies
    } = client.features,
          name = client.scheduledEventName; // The record must know that it is being resized.

    eventRecord.meta.isResizing = false;
    client.endListeningForBatchedUpdates();
    (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.hide();
    me.unHighlightHandle(element);
    client.element.classList.remove(...me.dragActiveCls.split(' '));

    if (dependencies) {
      dependencies.scheduleDraw(true); // When resizing is done and mouse is over element, we show terminals

      if (element.matches(':hover')) {
        dependencies.showTerminals(eventRecord, element);
      }
    } // Triggers eventResizeEnd or taskResizeEnd depending on product


    client.trigger(`${name}ResizeEnd`, _objectSpread({
      changed,
      [`${name}Record`]: eventRecord
    }, me.getResizeEndParams(context)));
  }

  async internalUpdateRecord(context, timespanRecord) {
    const {
      client
    } = this,
          {
      generation
    } = timespanRecord; // Special handling of occurrences, they need normalization since that is not handled by engine at the moment

    if (timespanRecord.isOccurrence) {
      client.endListeningForBatchedUpdates(); // If >1 level deep, just unwind one level.

      timespanRecord[timespanRecord.batching > 1 ? 'endBatch' : 'cancelBatch']();
      timespanRecord.set(_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__["default"].prototype.inSetNormalize.call(timespanRecord, {
        startDate: context.startDate,
        endDate: context.endDate
      }));
    } else {
      const toSet = {
        [context.toSet]: context[context.toSet]
      }; // If we have the SchedulingEngine available, consult it to calculate a corrected duration.
      // Adjust the dragged date point to conform with the calculated duration.

      if (timespanRecord.isEntity) {
        const {
          startDate,
          endDate,
          draggingEnd
        } = context;
        context.duration = toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(startDate, endDate, timespanRecord.durationUnit); // Fix the duration according to the Entity's rules.

        context.duration = toSet.duration = timespanRecord.run('calculateProjectedDuration', startDate, endDate); // Fix the dragged date point according to the Entity's rules.

        toSet[context.toSet] = timespanRecord.run('calculateProjectedXDateWithDuration', draggingEnd ? startDate : endDate, draggingEnd, context.duration);
        const setOtherEnd = !timespanRecord[context.otherEnd]; // Set all values, start and end in case they had never been set
        // ie, we're now scheduling a previously unscheduled event.

        if (setOtherEnd) {
          toSet[context.otherEnd] = context[context.otherEnd];
        } // Update the record to its final correct state using *batched changes*
        // These will *not* be propagated, it's just to force the dragged event bar
        // into its corrected shape before the real changes which will propagate are applied below.
        // We MUST do it like this because the final state may not be a net change if the changes
        // got rejected, and in that case, the engine will not end up firing any change events.


        timespanRecord.set(toSet); // Quit listening for batchedUpdate *before* we cancel the batch so that the
        // change events from the revert do not update the UI.

        client.endListeningForBatchedUpdates();
        timespanRecord.cancelBatch();
        const promisesToWait = []; // Really update the data after cancelling the batch

        if (setOtherEnd) {
          promisesToWait.push(timespanRecord[context.setOtherMethod](toSet[context.otherEnd], false));
        }

        promisesToWait.push(timespanRecord[context.setMethod](toSet[context.toSet], false));
        await Promise.all(promisesToWait);
        timespanRecord.endBatch();
      } else {
        // Collect any changes (except the start/end date) that happened during the resize operation
        const batchChanges = Object.assign({}, timespanRecord.meta.batchChanges);
        delete batchChanges[context.toSet];
        client.endListeningForBatchedUpdates();
        timespanRecord.cancelBatch();
        timespanRecord.set(batchChanges);
        timespanRecord[context.setMethod](toSet[context.toSet], false);
      }
    } // If the record has been changed


    return timespanRecord.generation !== generation;
  }

  onDragItemMouseMove(event) {
    if (event.pointerType !== 'touch' && !this.handleSelector) {
      this.checkResizeHandles(event);
    }
  }
  /**
   * Check if mouse is over a resize handle (virtual). If so, highlight.
   * @private
   * @param {MouseEvent} event
   */


  checkResizeHandles(event) {
    const me = this,
          {
      overItem
    } = me; // mouse over a target element and allowed to resize?

    if (overItem && !me.client.readOnly && (!me.allowResize || me.allowResize(overItem, event))) {
      let over;

      if (me.dragLock === 'x') {
        over = me.isOverLeftHandle(event, overItem) || me.isOverRightHandle(event, overItem);
      } else {
        over = me.isOverTopHandle(event, overItem) || me.isOverBottomHandle(event, overItem);
      }

      if (over) {
        me.highlightHandle(); // over handle
      } else {
        me.unHighlightHandle(); // not over handle
      }
    }
  }

  onDragItemMouseLeave(event, oldOverItem) {
    this.unHighlightHandle(oldOverItem);
  }
  /**
   * Highlights handles (applies css that changes cursor).
   * @private
   */


  highlightHandle() {
    const {
      overItem
    } = this; // over a handle, add cls to change cursor

    overItem.syncIdMap[this.client.scheduledEventName].classList.add('b-resize-handle');
    overItem.classList.add('b-over-resize-handle');
  }
  /**
   * Unhighlight handles (removes css).
   * @private
   */


  unHighlightHandle(item = this.overItem) {
    if (item) {
      var _item$syncIdMap$this$, _item$syncIdMap;

      const inner = (_item$syncIdMap$this$ = (_item$syncIdMap = item.syncIdMap) === null || _item$syncIdMap === void 0 ? void 0 : _item$syncIdMap[this.client.scheduledEventName]) !== null && _item$syncIdMap$this$ !== void 0 ? _item$syncIdMap$this$ : item.querySelector(this.client.eventInnerSelector);
      inner.classList.remove('b-resize-handle');
      inner.classList.remove(this.resizingItemInnerCls);
      item.classList.remove('b-over-resize-handle');
      item.classList.remove(this.draggingItemCls);
    }
  }

  isOverAnyHandle(event, target) {
    return this.isOverStartHandle(event, target) || this.isOverEndHandle(event, target);
  }

  isOverStartHandle(event, target) {
    return this.dragLock === 'x' ? this.isOverLeftHandle(event, target) : this.isOverTopHandle(event, target);
  }

  isOverEndHandle(event, target) {
    return this.dragLock === 'x' ? this.isOverRightHandle(event, target) : this.isOverBottomHandle(event, target);
  }

  getDynamicHandleSize(opposite, offsetWidth) {
    const handleCount = opposite ? 2 : 1,
          {
      handleSize
    } = this; // Shrink handle size when configured to do so, preserving reserved space between handles

    if (this.dynamicHandleSize && handleSize * handleCount > offsetWidth - this.reservedSpace) {
      return Math.max(Math.floor((offsetWidth - this.reservedSpace) / handleCount), 0);
    }

    return handleSize;
  }
  /**
   * Check if over left handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  isOverLeftHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target,
          timespanRecord = me.client.resolveTimeSpanRecord(target),
          resizable = timespanRecord === null || timespanRecord === void 0 ? void 0 : timespanRecord.isResizable;

    if (!me.disabled && me.leftHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize) && (resizable === true || resizable === 'start')) {
      const leftHandle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(target);
      leftHandle.width = me.getDynamicHandleSize(me.rightHandle, offsetWidth);
      return leftHandle.width > 0 && leftHandle.contains(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over right handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  isOverRightHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target,
          timespanRecord = me.client.resolveTimeSpanRecord(target),
          resizable = timespanRecord === null || timespanRecord === void 0 ? void 0 : timespanRecord.isResizable;

    if (!me.disabled && me.rightHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize) && (resizable === true || resizable === 'end')) {
      const rightHandle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(target);
      rightHandle.x = Math.floor(rightHandle.right - me.getDynamicHandleSize(me.leftHandle, offsetWidth));
      return rightHandle.width > 0 && rightHandle.contains(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over top handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over top handle, otherwise false
   */


  isOverTopHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target,
          timespanRecord = me.client.resolveTimeSpanRecord(target),
          resizable = timespanRecord === null || timespanRecord === void 0 ? void 0 : timespanRecord.isResizable;

    if (!me.disabled && me.topHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize) && (resizable === true || resizable === 'start')) {
      const topHandle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(target);
      topHandle.height = me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
      return topHandle.height > 0 && topHandle.contains(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over bottom handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over bottom handle, otherwise false
   */


  isOverBottomHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target,
          timespanRecord = me.client.resolveTimeSpanRecord(target),
          resizable = timespanRecord === null || timespanRecord === void 0 ? void 0 : timespanRecord.isResizable;

    if (!me.disabled && me.bottomHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize) && (resizable === true || resizable === 'end')) {
      const bottomHandle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(target);
      bottomHandle.y = Math.floor(bottomHandle.bottom - me.getDynamicHandleSize(me.bottomHandle, offsetHeight));
      return bottomHandle.height > 0 && bottomHandle.contains(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getPagePoint(event));
    }

    return false;
  }

  setupDragContext(event) {
    const me = this; // Only start a drag if we are over a handle zone.

    if (me.overItem && me.isOverAnyHandle(event, me.overItem) && me.isElementResizable(me.overItem, event)) {
      const result = super.setupDragContext(event);
      result.scrollManager = me.client.scrollManager;
      return result;
    }
  }

  changeTip(tip, oldTip) {
    const me = this;

    if (!me.showTooltip) {
      return null;
    }

    if (tip) {
      if (tip.isTooltip) {
        tip.owner = me;
      } else {
        tip = _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_6__["default"].reconfigure(oldTip, _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_6__["default"].mergeConfigs({
          id: `${me.client.id}-event-resize-tip`
        }, tip, {
          getHtml: me.getTipHtml.bind(me),
          owner: me.client
        }, me.tip), {
          owner: me,
          defaults: {
            type: 'tooltip'
          }
        });
      }

      tip.on({
        innerhtmlupdate: 'updateDateIndicator',
        thisObj: me
      });
      me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
        scheduler: me.client
      });
    } else if (oldTip) {
      var _me$clockTemplate;

      oldTip.destroy();
      (_me$clockTemplate = me.clockTemplate) === null || _me$clockTemplate === void 0 ? void 0 : _me$clockTemplate.destroy();
    }

    return tip;
  } //endregion
  //region Events


  isElementResizable(element, event) {
    const me = this,
          {
      client
    } = me,
          timespanRecord = client.resolveTimeSpanRecord(element);

    if (client.readOnly) {
      return false;
    }

    let resizable = timespanRecord && timespanRecord.isResizable; // go up from "handle" to resizable element

    element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, client.eventSelector); // Not resizable if the mousedown is on a resizing handle of
    // a percent bar.

    const handleHoldingElement = element ? element.firstElementChild : element,
          handleEl = event.target.closest('[class$="-handle"]');

    if (!resizable || handleEl && handleEl !== handleHoldingElement) {
      return false;
    }

    const startsOutside = element.classList.contains('b-sch-event-startsoutside'),
          endsOutside = element.classList.contains('b-sch-event-endsoutside');

    if (resizable === true) {
      if (startsOutside && endsOutside) {
        return false;
      } else if (startsOutside) {
        resizable = 'end';
      } else if (endsOutside) {
        resizable = 'start';
      } else {
        return me.isOverStartHandle(event, element) || me.isOverEndHandle(event, element);
      }
    }

    if (startsOutside && resizable === 'start' || endsOutside && resizable === 'end') {
      return false;
    }

    if (me.isOverStartHandle(event, element) && resizable === 'start' || me.isOverEndHandle(event, element) && resizable === 'end') {
      return true;
    }

    return false;
  }

  updateDateIndicator() {
    const {
      clockTemplate
    } = this,
          {
      eventRecord,
      draggingEnd,
      snappedDate
    } = this.dragging.context,
          startDate = draggingEnd ? eventRecord.get('startDate') : snappedDate,
          endDate = draggingEnd ? snappedDate : eventRecord.get('endDate'),
          {
      element
    } = this.tip;
    clockTemplate.updateDateIndicator(element.querySelector('.b-sch-tooltip-startdate'), startDate);
    clockTemplate.updateDateIndicator(element.querySelector('.b-sch-tooltip-enddate'), endDate);
  }

  getTooltipTarget(drag) {
    const me = this,
          target = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(drag.itemElement, null, true);

    if (me.dragLock === 'x') {
      // Align to the dragged edge of the proxy, and then bump right so that the anchor aligns perfectly.
      if (drag.context.edge === 'right') {
        target.x = target.right - 1;
      }

      target.width = me.tip.anchorSize[0] / 2;
    } else {
      // Align to the dragged edge of the proxy, and then bump bottom so that the anchor aligns perfectly.
      if (drag.context.edge === 'bottom') {
        target.y = target.bottom - 1;
      }

      target.height = me.tip.anchorSize[1] / 2;
    }

    return {
      target
    };
  }

  basicValidityCheck(context, event) {
    return context.startDate && (context.endDate > context.startDate || this.allowResizeToZero) && this.validatorFn.call(this.validatorFnThisObj || this, context, event);
  } //endregion
  //region Tooltip


  getTipHtml({
    tip
  }) {
    const me = this,
          {
      startDate,
      endDate,
      toSet,
      snappedDate,
      valid,
      message = '',
      timespanRecord
    } = me.dragging.context; // Empty string hides the tip - we get called before the Resizer, so first call will be empty

    if (!startDate || !endDate) {
      return tip.html;
    } // Set whichever one we are moving


    const tipData = {
      record: timespanRecord,
      valid,
      message,
      startDate,
      endDate,
      [toSet]: snappedDate
    }; // Format the two ends. This has to be done outside of the object initializer
    // because they use properties that are only in the tipData object.

    tipData.startText = me.client.getFormattedDate(tipData.startDate);
    tipData.endText = me.client.getFormattedDate(tipData.endDate);
    tipData.startClockHtml = me.clockTemplate.template({
      date: tipData.startDate,
      text: tipData.startText,
      cls: 'b-sch-tooltip-startdate'
    });
    tipData.endClockHtml = me.clockTemplate.template({
      date: tipData.endDate,
      text: tipData.endText,
      cls: 'b-sch-tooltip-enddate'
    });
    return me.tooltipTemplate(tipData);
  } //endregion
  //region Product specific, may be overridden in subclasses


  getBeforeResizeParams(context) {
    const {
      client
    } = this;
    return {
      resourceRecord: client.resolveResourceRecord(client.isVertical ? context.event : context.element)
    };
  }

  getResizeStartParams(context) {
    return {
      resourceRecord: context.resourceRecord
    };
  }

  getResizeEndParams(context) {
    return {
      resourceRecord: context.resourceRecord,
      event: context.event
    };
  }

  setupProductResizeContext(context, event) {
    var _client$resolveResour, _client$resolveAssign2;

    const {
      client
    } = this,
          {
      element
    } = context,
          eventRecord = client.resolveEventRecord(element),
          resourceRecord = (_client$resolveResour = client.resolveResourceRecord) === null || _client$resolveResour === void 0 ? void 0 : _client$resolveResour.call(client, element),
          assignmentRecord = (_client$resolveAssign2 = client.resolveAssignmentRecord) === null || _client$resolveAssign2 === void 0 ? void 0 : _client$resolveAssign2.call(client, element);
    Object.assign(context, {
      eventRecord,
      taskRecord: eventRecord,
      resourceRecord,
      assignmentRecord,
      dateConstraints: client.getDateConstraints(resourceRecord, eventRecord)
    });
  }

  checkValidity(context, event) {
    return (this.client.allowOverlap || this.client.isDateRangeAvailable(context.startDate, context.endDate, context.eventRecord, context.resourceRecord)) && this.basicValidityCheck(context, event);
  } //endregion


}
EventResize._$name = 'EventResize';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerFeature(EventResize, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerFeature(EventResize, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/EventTooltip.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/EventTooltip.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventTooltip; });
/* harmony import */ var _base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/feature/EventTooltip
 */

/**
 * Displays a tooltip when hovering events. The template used to render the tooltip can be customized, see {@link #config-template}.
 * Config options are also applied to the tooltip shown, see {@link Core.widget.Tooltip} for available options.
 *
 * ## Showing local data
 * To show a basic "local" tooltip (with data available in the Event record) upon hover:
 * ```javascript
 * new Scheduler({
 *   features : {
 *     eventTooltip : {
 *         // Tooltip configs can be used here
 *         align : 'l-r' // Align left to right,
 *         // A custom HTML template
 *         template : data => `<dl>
 *           <dt>Assigned to:</dt>
 *              <dt>Time:</dt>
 *              <dd>
 *                  ${DateHelper.format(data.eventRecord.startDate, 'LT')} - ${DateHelper.format(data.eventRecord.endDate, 'LT')}
 *              </dd>
 *              ${data.eventRecord.get('note') ? `<dt>Note:</dt><dd>${data.eventRecord.note}</dd>` : ''}
 *
 *              ${data.eventRecord.get('image') ? `<dt>Image:</dt><dd><img class="image" src="${data.eventRecord.get('image')}"/></dd>` : ''}
 *          </dl>`
 *     }
 *   }
 * });
 * ```
 *
 * ## Showing remotely loaded data
 * Loading remote data into the event tooltip is easy. Simply use the {@link #config-template} and return a Promise which yields the content to show.
 * ```javascript
 * new Scheduler({
 *   features : {
 *     eventTooltip : {
 *        template : ({ eventRecord }) => AjaxHelper.get(`./fakeServer?name=${eventRecord.name}`).then(response => response.text())
 *     }
 *   }
 * });
 * ```
 * This feature is **enabled** by default
 *
 * By default, the tooltip {@link Core.widget.Widget#config-scrollAction realigns on scroll}
 * meaning that it will stay aligned with its target should a scroll interaction make the target move.
 *
 * If this is causing performance issues in a Scheduler, such as if there are many dozens of events
 * visible, you can configure this feature with `scrollAction: 'hide'`. This feature's configuration is
 * applied to the tooltip, so that will mean that the tooltip will hide if its target is moved by a
 * scroll interaction.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/EventTooltip.js
 * @classtype eventTooltip
 * @feature
 */

class EventTooltip extends _base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'EventTooltip';
  }

  static get defaultConfig() {
    return {
      /**
       * A function which receives data about the event and returns a string,
       * or a Promise yielding a string (for async tooltips), to be displayed in the tooltip.
       * This method will be called with an object containing the fields below
       * @param {Object} data
       * @param {Scheduler.model.EventModel} data.eventRecord
       * @param {Date} data.startDate
       * @param {Date} data.endDate
       * @param {String} data.startText
       * @param {String} data.endText
       * @config {Function} template
       */
      template: data => `
                ${data.eventRecord.name ? _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].xss`<div class="b-sch-event-title">${data.eventRecord.name}</div>` : ''}
                ${data.startClockHtml}
                ${data.endClockHtml}`,
      cls: 'b-sch-event-tooltip',
      monitorRecordUpdate: true,

      /**
       * Defines what to do if document is scrolled while the tooltip is visible.
       *
       * Valid values: ´null´: do nothing, ´hide´: hide the tooltip or ´realign´: realign to the target if possible.
       *
       * @config {String}
       * @default
       */
      scrollAction: 'hide'
    };
  } //endregion


  construct(client, config) {
    const me = this;
    super.construct(client, config);

    if (typeof me.align === 'string') {
      me.align = {
        align: me.align
      };
    }
  }

  onPaint({
    firstPaint
  }) {
    super.onPaint(...arguments);

    if (firstPaint) {
      const me = this,
            dependencies = me.client.features.dependencies;

      if (dependencies) {
        const configuredOffset = me.align.offset;
        me.tooltip.on('beforeshow', ({
          source: tooltip
        }) => {
          // Don't let dependency terminal interfere with this tooltip
          if (!dependencies.disabled) {
            tooltip.align.offset = [0, 10];
          } else {
            tooltip.align.offset = configuredOffset;
          }
        });
      }
    }
  }

}
EventTooltip._$name = 'EventTooltip';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventTooltip, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(EventTooltip, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/GroupSummary.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/GroupSummary.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GroupSummary; });
/* harmony import */ var _Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GroupSummary.js */ "./lib/Grid/feature/GroupSummary.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';



 // Actions that trigger rerendering of group summary rows

const refreshActions = {
  add: 1,
  remove: 1,
  update: 1,
  removeAll: 1,
  filter: 1
};
/**
 * @module Scheduler/feature/GroupSummary
 */
// noinspection JSClosureCompilerSyntax

/**
 * A special version of the Grid GroupSummary feature that enables summaries within scheduler. To use a single summary
 * it is easiest to configure {@link #config-renderer}, for multiple summaries see {@link #config-summaries}.
 *
 * This feature is <strong>disabled</strong> by default. It is **not** supported in vertical mode.
 *
 * @extends Grid/feature/GroupSummary test
 *
 * @classtype groupSummary
 * @feature
 * @inlineexample Scheduler/feature/GroupSummary.js
 * @demo Scheduler/groupsummary
 * @typings Grid/feature/GroupSummary -> Grid/feature/GridGroupSummary
 */

class GroupSummary extends _Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'GroupSummary';
  }

  static get defaultConfig() {
    return {
      /**
       * Show tooltip containing summary values and labels
       * @config {Boolean}
       * @default
       */
      showTooltip: true,

      /**
       * Array of summary configs which consists of a label and a {@link #config-renderer} function
       * ```
       *  summaries : [
       *      {
       *         label : 'Label',
       *         renderer : ({ startDate, endDate, eventStore, resourceStore, events, resources, groupRecord, groupField, groupValue }) => {
       *             // return display value
       *             returns '<div>Renderer output</div>';
       *         }
       *      }
       *  ]
       *  ```
       * @config {Object[]}
       */
      summaries: null,

      /**
       * Renderer function for a single time axis tick in a group summary row.
       * Should calculate a sum and return HTML as a result.
       *
       * ```javascript
       * new Scheduler({
       *     features : {
       *         groupSummary : {
       *             renderer : ({ startDate, endDate, eventStore, resourceStore, events, resources, groupRecord, groupField, groupValue }) => {
       *                 // return display value
       *                 returns '<div>Renderer output</div>';
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * @param {Date} startDate Tick start date
       * @param {Date} endDate Tick end date
       * @param {Scheduler.model.EventModel[]} events Events which belong to the group
       * @param {Scheduler.model.ResourceModel[]} resources Resources which belong to the group
       * @param {Scheduler.data.EventStore} eventStore Event store
       * @param {Scheduler.data.ResourceStore} resourceStore Resource store
       * @param {Core.data.Model} groupRecord Current groups header row record
       * @param {String} groupField Current groups field name
       * @param {String} groupValue Current groups value
       * @returns {String} Html content
       * @config {Function}
       */
      renderer: null
    };
  }

  static get properties() {
    return {
      footersToUpdate: new Set()
    };
  }

  static get pluginConfig() {
    return {
      chain: ['render']
    };
  } //endregion
  //region Init


  construct(scheduler, config) {
    const me = this;

    if (scheduler.isVertical) {
      throw new Error('GroupSummary feature is not supported in vertical mode');
    }

    me.scheduler = scheduler;
    super.construct(scheduler, config);

    if (!me.summaries && me.renderer) {
      me.summaries = [{
        renderer: me.renderer
      }];
    }

    if (scheduler.isSchedulerBase) {
      scheduler.eventStore.on({
        changePreCommit: me.onEventStoreChange,
        thisObj: me
      });
      scheduler.on({
        timeAxisViewModelUpdate: me.onTimeAxisChange,
        thisObj: me
      });
      scheduler.project.on({
        dataReady: me.onProjectDataReady,
        thisObj: me
      });
    }
  }

  doDestroy() {
    var _this$_tip;

    (_this$_tip = this._tip) === null || _this$_tip === void 0 ? void 0 : _this$_tip.destroy();
    super.doDestroy();
  } //endregion
  //region Events


  onTimeAxisChange() {
    this.scheduler.rowManager.forEach(row => {
      if (row.isGroupFooter) {
        row.render();
      }
    });
  }

  onEventStoreChange({
    action,
    record,
    records,
    changes
  }) {
    // Scheduler does minimal update on event changes, it will not rerender the summary rows.
    // Need to handle that here
    if (refreshActions[action]) {
      var _changes$resourceId;

      const {
        rowManager
      } = this.scheduler,
            events = record ? [record] : records,
            resources = new Set();
      events.forEach(e => e.resources.forEach(r => resources.add(r))); // Include old resource on reassign

      if ((changes === null || changes === void 0 ? void 0 : (_changes$resourceId = changes.resourceId) === null || _changes$resourceId === void 0 ? void 0 : _changes$resourceId.oldValue) != null) {
        const oldResource = this.scheduler.resourceStore.getById(changes.resourceId.oldValue);
        oldResource && resources.add(oldResource);
      } // Collect footers to update


      for (const resourceRecord of resources) {
        let footer = rowManager.getRowFor(resourceRecord); // Resource might not match a row (out of view, filtered out etc)
        // Move down until footer is found or we run out of rows (in case footer is below the buffer)

        while (footer && !footer.isGroupFooter) {
          footer = rowManager.getRow(footer.index + 1);
        }

        footer && this.footersToUpdate.add(footer);
      }
    }
  }

  onProjectDataReady() {
    const {
      footersToUpdate
    } = this; // Re-render only affected footers, once

    if (footersToUpdate.size) {
      for (const footer of footersToUpdate) {
        var _footer$render;

        // Things happen async, footer might have been destroyed
        (_footer$render = footer.render) === null || _footer$render === void 0 ? void 0 : _footer$render.call(footer);
      }

      footersToUpdate.clear();
    }
  } //endregion
  //region Render

  /**
   * Called before rendering row contents, used to reset rows no longer used as group summary rows
   * @private
   */


  onBeforeRenderRow({
    row,
    record
  }) {
    if (row.isGroupFooter && !record.meta.hasOwnProperty('groupFooterFor')) {
      const timeaxisCell = row.elements.normal.querySelector('.b-sch-timeaxis-cell'); // remove summary cells if exist

      if (timeaxisCell) {
        timeaxisCell.innerHTML = '';
      }
    }

    super.onBeforeRenderRow(...arguments);
  }
  /**
   * Called by parent class to fill timeaxis with summary contents. Generates tick "cells" and populates them with
   * summaries.
   * ```
   * <div class="b-timeaxis-group-summary">
   *     <div class="b-timeaxis-tick">
   *         <div class="b-timeaxix-summary-value">x</div>
   *         ...
   *     </div>
   *     ...
   * </div>
   * ```
   * @private
   */


  generateHtml(column, records, cls, groupRecord, groupField, groupValue) {
    // TODO: Use DOM config object instead of strings
    if (column.type === 'timeAxis') {
      const me = this,
            {
        scheduler
      } = me,
            {
        eventStore
      } = scheduler,
            colCfg = scheduler.timeAxisViewModel.columnConfig;
      let html = ''; // group events by ticks info once here to avoid performance lags
      // should be inside `scheduler.isEngineReady` check to make sure all events were calculated
      // https://github.com/bryntum/support/issues/2977

      const eventsByTick = scheduler.getResourcesEventsPerTick(records, ({
        event
      }) => {
        return event.resources.some(resource => records.includes(resource)) && (!eventStore.isFiltered || eventStore.records.includes(event));
      });
      scheduler.timeAxis.forEach((tick, idx) => {
        const groupEvents = eventsByTick[idx] || [],
              // TODO: could turn this into a template
        sumHtml = me.summaries.map(config => {
          // summary renderer used to calculate and format value
          const value = config.renderer({
            startDate: tick.startDate,
            endDate: tick.endDate,
            resourceStore: scheduler.resourceStore,
            events: groupEvents,
            resources: records,
            eventStore,
            groupRecord,
            groupField,
            groupValue
          });
          return `<div class="b-timeaxis-summary-value">${value}</div>`;
        }).join(''); // get width on column index from the last header config

        html += `<div class="b-timeaxis-tick" style="width: ${colCfg[colCfg.length - 1][idx].width}px">${sumHtml}</div>`;
      });
      return `<div class="b-timeaxis-group-summary">${html}</div>`;
    }

    return super.generateHtml(column, records, cls, groupRecord, groupField, groupValue);
  }
  /**
   * Overrides parents function to return correct summary count, used when sizing row
   * @private
   */


  updateSummaryHtml(cellElement, column, records) {
    const count = super.updateSummaryHtml(cellElement, column, records);

    if (column.type === 'timeAxis') {
      const result = {
        count: 0,
        height: 0
      };
      this.summaries.forEach(config => {
        if (config.height) {
          result.height += config.height;
        } else {
          result.count++;
        }
      });
      return result;
    }

    return count;
  }
  /**
   * Generates tooltip contents for hovered summary tick
   * @private
   */


  getTipHtml({
    activeTarget
  }) {
    const me = this,
          index = Array.from(activeTarget.parentElement.children).indexOf(activeTarget),
          tick = me.scheduler.timeAxis.getAt(index);
    let tipHtml = `<header>${me.L('L{Summary.Summary for}', me.scheduler.getFormattedDate(tick.startDate))}</header>`,
        showTip = false;
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEachSelector(activeTarget, '.b-timeaxis-summary-value', (element, i) => {
      const label = me._labels[i],
            text = element.innerText.trim();
      tipHtml += `<label>${label || ''}</label><div class="b-timeaxis-summary-value">${text}</div>`;

      if (element.innerHTML) {
        showTip = true;
      }
    });
    return showTip ? tipHtml : null;
  }
  /**
   * Initialize tooltip on render
   * @private
   */


  render() {
    const me = this,
          {
      scheduler
    } = me;

    if (scheduler.isSchedulerBase) {
      var _me$summaries;

      // if any sum config has a label, init tooltip
      if ((_me$summaries = me.summaries) !== null && _me$summaries !== void 0 && _me$summaries.some(config => config.label) && me.showTooltip && !me._tip) {
        me._labels = me.summaries.map(config => config.label || '');
        me._tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
          id: `${scheduler.id}-groupsummary-tip`,
          cls: 'b-timeaxis-summary-tip',
          hoverDelay: 0,
          hideDelay: 0,
          forElement: scheduler.timeAxisSubGridElement,
          anchorToTarget: true,
          forSelector: '.b-timeaxis-group-summary .b-timeaxis-tick',
          getHtml: me.getTipHtml.bind(me)
        });
      }
    }
  } //endregion


  removeSummaryElements(rowEl) {
    const summaryElement = rowEl.querySelector('.b-timeaxis-group-summary');
    summaryElement === null || summaryElement === void 0 ? void 0 : summaryElement.remove();
    super.removeSummaryElements();
  }

  hasSummary(column) {
    return super.hasSummary(column) || column.isTimeAxisColumn;
  }

} // Override Grids GroupSummary with this improved version

GroupSummary._$name = 'GroupSummary';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(GroupSummary, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/HeaderContextMenu.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/feature/HeaderContextMenu.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderContextMenu; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
var productName = 'gantt';









/**
 * @module Scheduler/feature/HeaderContextMenu
 */

const setTimeSpanOptions = {
  maintainVisibleStart: true
};
/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.TimeAxisHeaderMenu TimeAxisHeaderMenu} feature instead.**
 *
 * Adds scheduler specific menu items to the timeline header context menu.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 * @deprecated 4.0.0
 * @classtype headerContextMenu
 * @feature
 */

class HeaderContextMenu extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'HeaderContextMenu';
  }

  static get defaultConfig() {
    return {
      /**
       * An array of additional items to add to the menu
       * @config {Object[]}
       * @default
       */
      extraItems: null,

      /**
       * A function called before displaying the menu that allows manipulations of its items. Called with a
       * single parameter with format { eventRecord, resourceRecord, eventElement, items }.
       *
       * ```javascript
       * features : {
       *     headerContextMenu : {
       *         processItems({ items }) {
       *             // Add or remove items here as needed
       *             items.push({ text: 'Some action', icon : 'b-fa b-fa-fw b-fa-ban' })
       *         }
       *     }
       * }
       * ```
       *
       * @config {Function}
       */
      processItems: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['populateHeaderMenu']
    };
  }

  construct(scheduler, config) {
    super.construct(scheduler, config);
    this.scheduler = scheduler;
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Scheduler', '5.0.0', '`HeaderContextMenu` feature is deprecated, in favor of `TimeAxisHeaderMenu` feature. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'); // If this feature is enabled, need to disable TimeAxisHeaderMenu. They are mutually exclusive.

    if (scheduler.features.timeAxisHeaderMenu) {
      scheduler.features.timeAxisHeaderMenu.disabled = true;
    } // By default this feature works based on ContextMenu feature.
    // In case new HeaderMenu feature is used, need to make sure it shows menu for timeAxis too


    if (scheduler.features.headerMenu) {
      scheduler.features.headerMenu._showForTimeAxis = true;
    }
  }
  /**
   * Populates the TimeAxis header context menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateHeaderMenu({
    column,
    items,
    menu
  }) {
    const me = this;

    if (column.type !== 'timeAxis') {
      return;
    }

    if (menu) {
      // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
      // The menu should not hide on scroll when for a TimeAxisColumn
      menu.scrollAction = 'realign';
    }

    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge(items, me.defaultItems);
    const arrayOfItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].transformNamedObjectToArray(items);

    if (me.extraItems) {
      arrayOfItems.push(...me.extraItems);
    }

    if (me.processItems) {
      me.processItems({
        items: arrayOfItems
      });
    }

    const namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].transformArrayToNamedObject(arrayOfItems); // replace items in original object with the new items

    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].removeAllProperties(items);
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge(items, namedItems);
  }

  get defaultItems() {
    const me = this,
          {
      scheduler
    } = me,
          {
      timeAxis
    } = scheduler,
          dateStep = {
      magnitude: timeAxis.shiftIncrement,
      unit: timeAxis.shiftUnit
    },
          items = {};
    items.pickZoomLevel = {
      text: 'L{pickZoomLevel}',
      localeClass: this,
      icon: 'b-fw-icon b-icon-search-plus',
      disabled: !scheduler.presets.count || me.disabled,
      menu: {
        type: 'popup',
        items: [{
          type: 'slider',
          minWidth: 130,
          // for IE11
          showValue: false
        }],

        onBeforeShow({
          source: menu
        }) {
          const [zoom] = menu.items;
          zoom.min = scheduler.minZoomLevel;
          zoom.max = scheduler.maxZoomLevel;
          zoom.value = scheduler.zoomLevel; // Default slider value is 50 which causes the above to trigger onZoomSliderChange (when
          // maxZoomLevel < 50) if we add our listener prior to this point.

          me.zoomDetatcher = zoom.on('input', 'onZoomSliderChange', me);
        },

        onHide() {
          if (me.zoomDetatcher) {
            me.zoomDetatcher();
            me.zoomDetatcher = null;
          }
        }

      }
    };
    me.startDateField = new _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      label: me.L('L{startText}'),
      labelWidth: '6em',
      required: true,
      step: dateStep,
      listeners: {
        change: me.onRangeDateFieldChange,
        thisObj: me
      }
    });
    me.endDateField = new _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      label: me.L('L{endText}'),
      labelWidth: '6em',
      required: true,
      step: dateStep,
      listeners: {
        change: me.onRangeDateFieldChange,
        thisObj: me
      }
    });
    items.activeDateRange = {
      text: 'L{activeDateRange}',
      localeClass: this,
      icon: 'b-fw-icon b-icon-calendar',
      disabled: me.disabled,
      menu: {
        type: 'popup',
        width: '20em',
        items: [me.startDateField, me.endDateField, {
          type: 'button',
          cls: 'b-left-nav-btn',
          icon: 'b-icon b-icon-prev',
          color: 'b-blue b-raised',
          flex: 1,
          margin: 0,
          listeners: {
            click: me.onLeftShiftBtnClick,
            thisObj: me
          }
        }, {
          type: 'button',
          cls: 'b-today-nav-btn',
          color: 'b-blue b-raised',
          text: 'L{todayText}',
          localeClass: this,
          flex: 4,
          margin: '0 8',
          listeners: {
            click: me.onTodayBtnClick,
            thisObj: me
          }
        }, {
          type: 'button',
          cls: 'b-right-nav-btn',
          icon: 'b-icon b-icon-next',
          color: 'b-blue b-raised',
          flex: 1,
          listeners: {
            click: me.onRightShiftBtnClick,
            thisObj: me
          }
        }],
        onBeforeShow: () => me.initDates()
      }
    };
    return items;
  }

  onZoomSliderChange({
    value
  }) {
    this.scheduler.zoomLevel = value;
  }

  initDates() {
    const me = this;
    me.startDateField.suspendEvents();
    me.endDateField.suspendEvents(); // The actual scheduler start dates may include time, but our Date field cannot currently handle
    // a time portion and throws it away, so when we need the value from an unchanged field, we need
    // to use the initialValue set from the timeAxis values.
    // Until our DateField can optionally include a time value, this is the solution.

    me.startDateField.value = me.startDateFieldInitialValue = me.scheduler.startDate;
    me.endDateField.value = me.endDateFieldInitialValue = me.scheduler.endDate;
    me.startDateField.resumeEvents();
    me.endDateField.resumeEvents();
  }

  onRangeDateFieldChange({
    source
  }) {
    const me = this,
          startDateChanged = source === me.startDateField,
          {
      client
    } = me,
          {
      timeAxis
    } = client,
          startDate = me.startDateFieldInitialValue && !startDateChanged ? me.startDateFieldInitialValue : me.startDateField.value;
    let endDate = me.endDateFieldInitialValue && startDateChanged ? me.endDateFieldInitialValue : me.endDateField.value; // When either of the fields is changed, we no longer use its initialValue from the timeAxis start or end
    // so that gets nulled to indicate that it's unavailable and the real field value is to be used.

    if (startDateChanged) {
      me.startDateFieldInitialValue = null;
    } else {
      me.endDateFieldInitialValue = null;
    } // Because the start and end dates are exclusive, avoid a zero
    // length time axis by incrementing the end by one tick unit
    // if they are the same.


    if (!(endDate - startDate)) {
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
    } // if start date got bigger than end date set end date to start date plus one tick
    else if (endDate < startDate) {
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
    } // setTimeSpan will try to keep the scroll position the same.


    client.setTimeSpan(startDate, endDate, setTimeSpanOptions);
    me.initDates();
  }

  onLeftShiftBtnClick() {
    const me = this;
    me.scheduler.timeAxis.shiftPrevious();
    me.initDates();
  }

  onTodayBtnClick() {
    const me = this,
          today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date());
    me.scheduler.setTimeSpan(today, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(today, 1, 'day'));
    me.initDates();
  }

  onRightShiftBtnClick() {
    const me = this;
    me.scheduler.timeAxis.shiftNext();
    me.initDates();
  }

}
HeaderContextMenu.featureClass = '';
HeaderContextMenu._$name = 'HeaderContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(HeaderContextMenu);

/***/ }),

/***/ "./lib/Scheduler/feature/HeaderZoom.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/feature/HeaderZoom.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderZoom; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'gantt';





/**
 * @module Scheduler/feature/HeaderZoom
 */

/**
 * Enables users to click and drag to zoom to a date range in Scheduler's header time axis. Only supported in horizontal
 * mode.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     headerZoom : true
 *   }
 * });
 *
 * @classtype headerZoom
 * @feature
 *
 * @inlineexample Scheduler/feature/HeaderZoom.js
 */

class HeaderZoom extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'HeaderZoom';
  } // Plugin configuration. This plugin chains some of the functions in Scheduler.


  static get pluginConfig() {
    return {
      chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
    };
  }

  onElementMouseDown(event) {
    const me = this,
          scheduler = me.client; // only react to mouse input, and left button

    if (event.touches || event.button !== 0 || me.disabled) {
      return;
    } // only react to mousedown directly on timeaxis cell


    if (event.target.closest('.b-sch-header-timeaxis-cell')) {
      const headerEl = scheduler.subGrids.normal.header.headersElement;
      me.startX = event.clientX;
      me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
        parent: headerEl,
        tag: 'div',
        className: 'b-headerzoom-rect'
      });
      me.headerElementRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(headerEl);
    }
  }

  onElementMouseMove(event) {
    const me = this; // Synthetic mousemove event has no button for IE11
    // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

    if (event.buttons === 0 && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari && (!_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 || event.isTrusted)) {
      me.onElementMouseUp(event);
      return;
    }

    if (typeof me.startX === 'number') {
      const x = Math.max(event.clientX, me.headerElementRect.left),
            left = Math.min(me.startX, x),
            width = Math.abs(me.startX - x),
            rect = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"](left - me.headerElementRect.x + me.client.scrollLeft, 0, width, me.headerElementRect.height);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setTranslateX(me.element, rect.left);
      me.element.style.width = rect.width + 'px';
    }
  }

  onElementMouseUp(event) {
    const me = this;

    if (typeof me.startX === 'number') {
      const timeline = me.client,
            rect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(me.element),
            startDate = timeline.getDateFromCoordinate(rect.left, 'round', false),
            endDate = timeline.getDateFromCoordinate(rect.right, 'round', false);
      me.element && me.element.remove();
      me.startX = null;
      me.client.zoomToSpan({
        startDate,
        endDate
      });
    }
  }

}
HeaderZoom._$name = 'HeaderZoom';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(HeaderZoom, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/Labels.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/feature/Labels.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Labels; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
var productName = 'gantt';








/**
 * @module Scheduler/feature/Labels
 */

const sides = ['top', 'left', 'right', 'bottom'],
      editorAlign = {
  top: 'b-b',
  right: 'l-l',
  bottom: 't-t',
  left: 'r-r'
},
      topBottom = {
  top: 1,
  bottom: 1
},
      layoutModes = {
  estimate: 1,
  measure: 1
},
      layoutSides = {
  left: 1,
  right: 1
};
/**
 * Displays labels at positions {@link #config-top}, {@link #config-right}, {@link #config-bottom} and
 * {@link #config-left}.
 *
 * Text in labels can be set from a field on the {@link Scheduler.model.EventModel EventModel} or the
 * {@link Scheduler.model.ResourceModel ResourceModel} or using a custom renderer.
 *
 * Since `top` and `bottom` labels occupy space that would otherwise be used by the event we recommend using bigger
 * rowHeights (>55px for both labels with default styling) and zero barMargins because `top`/`bottom` labels give space
 * around events anyway.
 *
 * To prevent labels from being overlapped by other events, see {@link #config-labelLayoutMode}.
 *
 * This feature is **off** by default. It is **not** supported in vertical mode.
 * For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/labels
 * @inlineexample Scheduler/feature/Labels.js
 * @classtype labels
 * @feature
 */

class Labels extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Labels';
  }

  static get configurable() {
    return {
      /**
       * CSS class to apply to label elements
       * @config {String}
       * @default
       */
      labelCls: 'b-sch-label',

      /**
       * Top label configuration object. May contain the following properties:
       * @param {String} field The name of a field in one of the associated records,
       *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
       *   The record from which the field value is drawn will be ascertained by checking for field definitions by
       *   the specified name.
       * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
       *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
       *   label
       * @param {Object} thisObj The `this` reference to use in the `renderer`.
       * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
       *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
       *   work**.
       * @config {Object}
       * @default
       */
      top: null,

      /**
       * Right label configuration object. May contain the following properties:
       * @param {String} field The name of a field in one of the associated records,
       *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
       *   The record from which the field value is drawn will be ascertained by checking for field definitions by
       *   the specified name.
       * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
       *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
       *   label
       * @param {Object} thisObj The `this` reference to use in the `renderer`.
       * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
       *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
       *   work**.
       * @config {Object}
       * @default
       */
      right: null,

      /**
       * Bottom label configuration object. May contain the following properties:
       * @param {String} field The name of a field in one of the associated records,
       *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
       *   The record from which the field value is drawn will be ascertained by checking for field definitions by
       *   the specified name.
       * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
       *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
       *   label
       * @param {Object} thisObj The `this` reference to use in the `renderer`.
       * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
       *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
       *   work**.
       * @config {Object}
       * @default
       */
      bottom: null,

      /**
       * Left label configuration object. May contain the following properties:
       * @param {String} field The name of a field in one of the associated records,
       *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
       *   The record from which the field value is drawn will be ascertained by checking for field definitions by
       *   the specified name.
       * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
       *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
       *   label
       * @param {Object} thisObj The `this` reference to use in the `renderer`.
       * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
       *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
       *   work**.
       * @config {Object}
       * @default
       */
      left: null,
      thisObj: null,

      /**
       * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
       * May be `'complete'` or `'cancel`'.
       * @config {String}
       * @default
       */
      blurAction: 'cancel',

      /**
       * How to handle labels during event layout. Options are:
       *
       * * default - Labels do not affect event layout, events will overlap labels
       * * estimate - Label width is estimated by multiplying text length with {@link #config-labelCharWidth}
       * * measure - Label width is determined by measuring the label, precise but slow
       *
       * Note that this only applies to the left and right labels, top and bottom labels does not take part in the
       * event layout process.
       *
       * @config {String}
       * @default
       */
      labelLayoutMode: 'default',

      /**
       * Factor representing the average char width in pixels used to determine label width when configured
       * with `labelLayoutMode: 'estimate'`.
       * @config {Number}
       * @default
       */
      labelCharWidth: 7
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onEventDataGenerated']
    };
  } //endregion
  //region Init & destroy


  construct(scheduler, config) {
    const me = this;

    if (scheduler.isVertical) {
      throw new Error('Labels feature is not supported in vertical mode');
    }

    me.scheduler = scheduler;
    super.construct(scheduler, config);

    if (me.top || me.bottom || me.left || me.right) {
      me.updateHostClasslist(); // rowHeight warning, not in use
      //const labelCount = !!me.topLabel + !!me.bottomLabel;
      //if (scheduler.rowHeight < 60 - labelCount * 12) console.log('')
    }
  }

  updateHostClasslist() {
    const {
      top,
      bottom
    } = this,
          {
      classList
    } = this.scheduler.element;
    classList.remove('b-labels-topbottom');
    classList.remove('b-labels-top');
    classList.remove('b-labels-bottom'); // OR is correct. This means that there are labels above OR below.

    if (top || bottom) {
      classList.add('b-labels-topbottom');

      if (top) {
        classList.add('b-labels-top');
      }

      if (bottom) {
        classList.add('b-labels-bottom');
      }
    }
  }

  onLabelDblClick(event) {
    const me = this,
          target = event.target;

    if (target && !me.scheduler.readOnly) {
      const {
        side
      } = target.dataset,
            labelConfig = me[side],
            {
        editor,
        field
      } = labelConfig;

      if (editor) {
        const eventRecord = this.scheduler.resolveEventRecord(event.target);

        if (!(editor instanceof _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_7__["default"])) {
          labelConfig.editor = new _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
            appendTo: me.scheduler.element,
            blurAction: me.blurAction,
            inputField: editor,
            scrollAction: 'realign'
          });
        }

        labelConfig.editor.startEdit({
          target,
          align: editorAlign[side],
          matchSize: false,
          record: eventRecord,
          field
        });
        event.stopImmediatePropagation();
        return false;
      }
    }
  }

  changeTop(top) {
    return this.processLabelSpec(top, 'top');
  }

  updateTop() {
    this.updateHostClasslist();
  }

  changeRight(right) {
    return this.processLabelSpec(right, 'right');
  }

  updateRight() {
    this.updateHostClasslist();
  }

  changeBottom(bottom) {
    return this.processLabelSpec(bottom, 'bottom');
  }

  updateBottom() {
    this.updateHostClasslist();
  }

  changeLeft(left) {
    return this.processLabelSpec(left, 'left');
  }

  updateLeft() {
    this.updateHostClasslist();
  }

  processLabelSpec(labelSpec, side) {
    if (typeof labelSpec === 'function') {
      labelSpec = {
        renderer: labelSpec
      };
    } else if (typeof labelSpec === 'string') {
      labelSpec = {
        field: labelSpec
      };
    } // Allow us to mutate ownProperties in the labelSpec without mutating outside object
    else if (labelSpec) {
      labelSpec = Object.setPrototypeOf({}, labelSpec);
    } // Clear label
    else {
      return null;
    }

    const {
      scheduler
    } = this,
          {
      eventStore,
      resourceStore,
      taskStore,
      id
    } = scheduler,
          {
      field,
      editor
    } = labelSpec; // If there are milestones, and we are changing the available height
    // either by adding a top/bottom label, or adding a top/bottom label
    // then during the next dependency refresh, milestone width must be recalculated.

    if (topBottom[side]) {
      scheduler.milestoneWidth = null;
    }

    if (eventStore && !taskStore) {
      labelSpec.recordType = 'event';
    } else {
      labelSpec.recordType = 'task';
    } // Find the field definition or property from whichever store and cache the type.


    if (field) {
      let fieldDef,
          fieldFound = false;

      if (eventStore && !taskStore) {
        fieldDef = eventStore.modelClass.fieldMap[field];

        if (fieldDef) {
          labelSpec.fieldDef = fieldDef;
          labelSpec.recordType = 'event';
          fieldFound = true;
        } // Check if it references a property
        else if (Reflect.has(eventStore.modelClass.prototype, field)) {
          labelSpec.recordType = 'event';
          fieldFound = true;
        }
      }

      if (!fieldDef && taskStore) {
        fieldDef = taskStore.modelClass.fieldMap[field];

        if (fieldDef) {
          labelSpec.fieldDef = fieldDef;
          labelSpec.recordType = 'task';
          fieldFound = true;
        } // Check if it references a property
        else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
          labelSpec.recordType = 'task';
          fieldFound = true;
        }
      }

      if (!fieldDef && resourceStore) {
        fieldDef = resourceStore.modelClass.fieldMap[field];

        if (fieldDef) {
          labelSpec.fieldDef = fieldDef;
          labelSpec.recordType = 'resource';
          fieldFound = true;
        } // Check if it references a property
        else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
          labelSpec.recordType = 'resource';
          fieldFound = true;
        }
      }

      if (editor) {
        if (typeof editor === 'boolean') {
          scheduler.editor = {
            type: 'textfield'
          };
        } else if (typeof editor === 'string') {
          scheduler.editor = {
            type: editor
          };
        }

        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
          element: scheduler.timeAxisSubGrid.element,
          delegate: '.b-sch-label',
          dblclick: 'onLabelDblClick',
          thisObj: this
        });
      }
    }

    return labelSpec;
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (this.client.isPainted) {
      this.client.refresh();
    }
  } //endregion


  generateLabelConfigs(data) {
    const me = this,
          configs = []; // Insert all configured labels

    for (const side of sides) {
      if (me[side]) {
        const {
          field,
          fieldDef,
          recordType,
          renderer,
          thisObj
        } = me[side],
              domConfig = {
          tag: 'label',
          className: {
            [me.labelCls]: 1,
            [`${me.labelCls}-${side}`]: 1
          },
          dataset: {
            side,
            taskFeature: `label-${side}`
          }
        };
        let value;
        const eventRecordProperty = `${recordType}Record`,
              eventRecord = data[eventRecordProperty]; // If there's a renderer, use that by preference

        if (renderer) {
          value = renderer.call(thisObj || me.thisObj || me, {
            [eventRecordProperty]: eventRecord,
            resourceRecord: data.resourceRecord,
            assignmentRecord: data.assignmentRecord,
            domConfig
          });
        } else {
          value = eventRecord[field]; // If it's a date, format it according to the Scheduler's defaults

          if ((fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.type) === 'date' && !renderer) {
            value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(value, me.client.displayDateFormat);
          } else {
            value = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].encodeHtml(value);
          }
        }

        domConfig.html = value || '\xa0';
        configs.push(domConfig);
      }
    }

    return configs;
  }

  measureLabels(configs, data) {
    const me = this,
          pxPerMS = me.client.timeAxisViewModel.getSingleUnitInPixels('millisecond');

    for (const config of configs) {
      if (layoutSides[config.dataset.side]) {
        let {
          html
        } = config;
        let length = 0; // Calculate length based on string length

        if (me.labelLayoutMode === 'estimate') {
          // Strip tags before estimating
          if (html.includes('<')) {
            html = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].stripTags(html);
          }

          length = html.length * me.labelCharWidth + 18; // 18 = 1.5em, margin from event
        } // Measure
        else {
          const element = me.labelMeasureElement || (me.labelMeasureElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
            className: 'b-sch-event-wrap b-measure-label',
            parent: me.client.foregroundCanvas
          })); // Outer DomSync should not remove

          element.retainElement = true;
          _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync({
            targetElement: element,
            childrenOnly: true,
            domConfig: {
              children: [config]
            }
          });
          length = element.firstElementChild.offsetWidth;
        } // Convert from px to ms


        const ms = length / pxPerMS; // Adjust values used for event layout (not event position)

        switch (config.dataset.side) {
          case 'left':
            data.startMS -= ms;
            break;

          case 'right':
            data.endMS += ms;
            break;
        }
      }
    }
  }

  onEventDataGenerated(data) {
    var _data$eventRecord;

    if (!this.disabled && !((_data$eventRecord = data.eventRecord) !== null && _data$eventRecord !== void 0 && _data$eventRecord.isResourceTimeRange)) {
      const configs = this.generateLabelConfigs(data);

      if (layoutModes[this.labelLayoutMode]) {
        this.measureLabels(configs, data);
      }

      data.wrapperChildren.push(...configs);
    }
  }

  updateLabelLayoutMode() {
    if (!this.isConfiguring) {
      this.client.refreshWithTransition();
    }
  }

  updateLabelCharWidth() {
    if (!this.isConfiguring) {
      this.client.refreshWithTransition();
    }
  }

} // TODO: Refactor the SASS, so that the auto-generated class name of ''b-' + cls.name.toLowerCase() can be used.

Labels.featureClass = 'b-sch-labels';
Labels._$name = 'Labels';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Labels, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/NonWorkingTime.js":
/*!*************************************************!*\
  !*** ./lib/Scheduler/feature/NonWorkingTime.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NonWorkingTime; });
/* harmony import */ var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/NonWorkingTime
 */

/**
 * Feature that allows styling of weekends (and other non working time) by adding timeRanges for those days.
 *
 * By default the basic Scheduler calendar is empty. When enabling this feature it injects Saturday and Sunday weekend
 * intervals if no intervals are encountered.
 *
 * Please note that the feature does not render ranges shorter than the base unit used by the time axis.
 * That is made to reduce the view detailing when zooming out.
 * The behavior can be disabled with {@link #config-hideRangesOnZooming} config.
 * And for some levels the feature bails out rendering ranges completely (see {@link #config-maxTimeAxisUnit} for details).
 *
 * This feature is **off** by default for Scheduler, but **enabled** by default for Scheduler Pro in which case it is
 * attached to the configured calendars and therefore does not show auto-generated weekends as non-working time.
 * For info on enabling it, see {@link Grid/view/mixin/GridFeatures}.
 *
 * @extends Scheduler/feature/AbstractTimeRanges
 * @demo Scheduler/configuration
 * @inlineexample Scheduler/feature/NonWorkingTime.js
 * @classtype nonWorkingTime
 * @feature
 */

class NonWorkingTime extends _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Default config
  static get $name() {
    return 'NonWorkingTime';
  }

  static get defaultConfig() {
    return {
      /**
       * Set to `true` to highlight non working periods of time
       * @config {Boolean}
       * @default
       */
      highlightWeekends: true,
      showHeaderElements: true,
      showLabelInBody: true,
      cls: 'b-sch-nonworkingtime',

      /**
       * The maximum time axis unit to display non working ranges for ('hour' or 'day' etc).
       * When zooming to a view with a larger unit, no non-working time elements will be rendered.
       *
       * **Note:** Be careful with setting this config to big units like 'year'. When doing this,
       * make sure the timeline {@link Scheduler/view/TimelineBase#config-startDate start} and
       * {@link Scheduler/view/TimelineBase#config-endDate end} dates are set tightly.
       * When using a long range (for example many years) with non-working time elements rendered per hour,
       * you will end up with millions of elements, impacting performance.
       * When zooming, use the {@link Scheduler/view/mixin/TimelineZoomable#config-zoomKeepsOriginalTimespan} config.
       * @config {String}
       * @default
       */
      maxTimeAxisUnit: 'week',

      /**
       * The feature by default does not render ranges smaller than the base unit used by the time axis.
       * Set this config to `false` to disable this behavior.
       *
       * **Please mind** another {@link #config-maxTimeAxisUnit} config
       * defining zoom condition to bail out ranges rendering completely.
       * @config {Boolean}
       * @default
       */
      hideRangesOnZooming: true,
      autoGeneratedWeekends: false
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onPaint', 'attachToProject', 'updateLocalization']
    };
  } //endregion
  //region Init & destroy


  doDestroy() {
    this.attachToCalendar(null);
    super.doDestroy();
  } //endregion
  //region Project


  attachToProject(project) {
    super.attachToProject(project);
    this.attachToCalendar(project.effectiveCalendar);
    project.on({
      name: 'project',
      calendarChange: () => this.attachToCalendar(this.project.effectiveCalendar),
      thisObj: this
    });
  } //endregion
  //region TimeAxisViewModel


  onTimeAxisViewModelUpdate() {
    this._timeAxisUnitDurationMs = null;
    return super.onTimeAxisViewModelUpdate();
  } //endregion
  //region Calendar


  updateLocalization() {
    var _super$updateLocaliza;

    (_super$updateLocaliza = super.updateLocalization) === null || _super$updateLocaliza === void 0 ? void 0 : _super$updateLocaliza.call(this);

    if (this.autoGeneratedWeekends && this.calendar) {
      const intervals = this.defaultNonWorkingIntervals,
            hasIntervals = Boolean(intervals.length);
      this.calendar.clearIntervals(hasIntervals); // Update weekends as non-working time

      if (hasIntervals) {
        this.calendar.addIntervals(intervals);
      }
    }
  }

  attachToCalendar(calendar) {
    const me = this,
          {
      project,
      client
    } = me;
    me.detachListeners('calendar');
    me.autoGeneratedWeekends = false;

    if (calendar) {
      if ( // For basic scheduler...
      !client.isSchedulerPro && !client.isGantt && // ...that uses the default calendar...
      calendar === project.defaultCalendar && // ...and has no defined intervals
      !project.defaultCalendar.intervalStore.count) {
        const intervals = me.defaultNonWorkingIntervals; // Add weekends as non-working time

        if (intervals.length) {
          calendar.addIntervals(intervals);
          me.autoGeneratedWeekends = true;
        }
      }

      calendar.intervalStore.on({
        name: 'calendar',
        change: () => me.setTimeout('renderRanges', 1)
      });
    } // On changing calendar we react to a data level event which is triggered after project refresh.
    // Redraw right away


    if (client.isEngineReady) {
      me.renderRanges();
    } // Initially there is no guarantee we are ready to draw, wait for refresh
    else if (!project.isDestroyed) {
      me.detachListeners('initialProjectListener');
      project.on({
        name: 'initialProjectListener',
        refresh: me.renderRanges,
        thisObj: me,
        once: true
      });
    }
  }

  get defaultNonWorkingIntervals() {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].nonWorkingDaysAsArray.map(dayIndex => {
      return {
        recurrentStartDate: `on ${dayNames[dayIndex]} at 0:00`,
        recurrentEndDate: `on ${dayNames[(dayIndex + 1) % 7]} at 0:00`,
        isWorking: false
      };
    });
  }

  get calendar() {
    var _this$project;

    return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.effectiveCalendar;
  } //endregion
  //region Draw


  get timeAxisUnitDurationMs() {
    // calculate and cache duration of the timeAxis unit in milliseconds
    if (!this._timeAxisUnitDurationMs) {
      this._timeAxisUnitDurationMs = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as('ms', 1, this.client.timeAxis.unit);
    }

    return this._timeAxisUnitDurationMs;
  }
  /**
   * Based on this method result the feature decides whether the provided non-working period should
   * be rendered or not.
   * The method checks that the range has non-zero {@link Scheduler.model.TimeSpan#field-duration},
   * lays in the visible timespan and its duration is longer or equal the base timeaxis unit
   * (if {@link #config-hideRangesOnZooming} is `true`).
   *
   * Override the method to implement your custom range rendering vetoing logic.
   * @param {Scheduler.model.TimeSpan} range Range to render.
   * @returns {Boolean} `true` if the range should be rendered and `false` otherwise.
   */


  shouldRenderRange(range) {
    // if the range is longer or equal than one timeAxis unit then render it
    return super.shouldRenderRange(range) && (!this.hideRangesOnZooming || range.durationMS >= this.timeAxisUnitDurationMs);
  }

  renderRanges() {
    const me = this,
          {
      store,
      calendar
    } = me,
          {
      timeAxis,
      foregroundCanvas
    } = me.client; // if not too early (project correctly set up yet etc)

    if (calendar && foregroundCanvas && store && !store.isDestroyed) {
      if (!me.disabled) {
        // checks if we should render ranges for the current zoom level
        const shouldPaint = !me.maxTimeAxisUnit || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].compareUnits(timeAxis.unit, me.maxTimeAxisUnit) <= 0;
        store.removeAll(true);

        if (calendar && me.highlightWeekends && shouldPaint && timeAxis.count) {
          const timeRanges = calendar.getNonWorkingTimeRanges(timeAxis.startDate, timeAxis.endDate).map((r, i) => ({
            name: r.name,
            cls: 'b-nonworkingtime',
            startDate: r.startDate,
            endDate: r.endDate
          })),
                timeRangesMerged = [];
          let prevRange; // intervals returned by the calendar are not merged ..let's combine them

          timeRanges.forEach(range => {
            if (prevRange && range.startDate <= prevRange.endDate && range.name === prevRange.name) {
              prevRange.endDate = range.endDate;
            } else {
              timeRangesMerged.push(range);
              range.id = `nonworking-${timeRangesMerged.length}`;
              prevRange = range;
            }
          });
          store.add(timeRangesMerged, true);
        }
      }

      super.renderRanges();
    }
  } //endregion


}
NonWorkingTime._$name = 'NonWorkingTime';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(NonWorkingTime, false, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(NonWorkingTime, true, ['SchedulerPro', 'Gantt', 'ResourceHistogram']);

/***/ }),

/***/ "./lib/Scheduler/feature/Pan.js":
/*!**************************************!*\
  !*** ./lib/Scheduler/feature/Pan.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pan; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/Pan
 */

/**
 * Makes the scheduler's timeline pannable by dragging with the mouse.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * **NOTE:** Incompatible with the {@link Scheduler.feature.EventDragCreate EventDragCreate} and the {@link Scheduler.feature.EventDragSelect EventDragSelect} features.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable Pan
 * let scheduler = new Scheduler({
 *   features : {
 *     pan : true,
 *     eventDragCreate : false
 *   }
 * });
 *
 * @classtype pan
 * @feature
 */

class Pan extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // region Init
  static get $name() {
    return 'Pan';
  }

  static get defaultConfig() {
    return {
      /**
       * Set to false to not pan horizontally
       * @config {Boolean}
       * @default
       */
      horizontal: true,

      /**
       * Set to false to not pan vertically
       * @config {Boolean}
       * @default
       */
      vertical: true
    };
  }

  construct(timeline, config) {
    this.timeline = timeline;
    const targetSelectors = ['.b-grid-cell', '.b-timeline-subgrid'];
    this.targetSelector = targetSelectors.join(',');
    super.construct(timeline, config);
  } //endregion
  //region Plugin config
  // Plugin configuration. This plugin chains some of the functions in Scheduler.


  static get pluginConfig() {
    return {
      chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
    };
  } //endregion


  onElementMouseDown(event) {
    const me = this,
          timeline = me.timeline,
          dragFeature = Object.values(timeline.features).find(feature => feature instanceof _base_DragBase_js__WEBPACK_IMPORTED_MODULE_3__["default"]),
          enablePanOnEvents = timeline.readOnly || !dragFeature || dragFeature.disabled; // only react to mouse input, and left button

    if (event.touches || event.button !== 0 || me.disabled) {
      return;
    } // only react to mousedown directly on grid cell, subgrid element or if drag is disabled - the events too


    if (event.target.matches(me.targetSelector) || enablePanOnEvents && event.target.closest(timeline.eventSelector)) {
      me.mouseX = event.clientX;
      me.mouseY = event.clientY;
    }
  }

  onElementMouseMove(event) {
    const me = this; // Synthetic mousemove event has no button for IE11
    // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

    if (event.buttons === 0 && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari && (!_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 || event.isTrusted)) {
      me.onElementMouseUp();
      return;
    }

    if (typeof me.mouseX === 'number') {
      const xScroller = me.timeline.subGrids.normal.scrollable,
            yScroller = me.timeline.scrollable,
            x = event.clientX,
            y = event.clientY;
      event.preventDefault();

      if (me.vertical) {
        yScroller.scrollBy(0, me.mouseY - y);
      }

      if (me.horizontal) {
        xScroller.scrollBy(me.mouseX - x);
      }

      me.mouseX = x;
      me.mouseY = y;
    }
  }

  onElementMouseUp(event) {
    this.mouseX = this.mouseY = null;
  } //endregion


}
Pan._$name = 'Pan';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Pan, false, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/ResourceTimeRanges.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/ResourceTimeRanges.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRanges; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base/ResourceTimeRangesBase.js */ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js");
/* harmony import */ var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
var productName = 'gantt';



/**
 * @module Scheduler/feature/ResourceTimeRanges
 */

/**
 * Feature that draws resource time ranges, shaded areas displayed behind events. These zones are similar to events in
 * that they have a start and end date but different in that they do not take part in the event layout and they always
 * occupy full row height.
 *
 * Each time range is represented by an instances of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel}, held in a
 * {@link Scheduler.data.ResourceTimeRangeStore ResourceTimeRangeStore}. Currently the they are readonly UI-wise, but can be manipulated on
 * the data level. To style the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field or use the {@link Scheduler.model.ResourceTimeRangeModel#field-timeRangeColor} field.
 *
 * Data can be provided either using the {@link Scheduler.view.Scheduler#config-resourceTimeRanges resourceTimeRanges} config on the Scheduler config object:
 *
 * ```javascript
 * new Scheduler({
 *     ...
 *    features :  {
 *        resourceTimeRanges : true
 *    },
 *
 *    // Data specified directly on the Scheduler instance
 *    resourceTimeRanges : [
 *        // Either specify startDate & endDate or startDate & duration when defining a range
 *        { startDate : new Date(2019,0,1), endDate : new Date(2019,0,3), name : 'Occupied', timeRangeColor : 'red' },
 *        { startDate : new Date(2019,0,3), duration : 2, durationUnit : 'd', name : 'Available' },
 *    ]
 * })
 * ```
 *
 * or the {@link Scheduler.view.Scheduler#config-resourceTimeRangeStore resourceTimeRangeStore} config on the Scheduler config object:
 *
 * ```javascript
 * new Scheduler({
 *     ...
 *     features :  {
 *         resourceTimeRanges : true
 *     },
 *     resourceTimeRangeStore : new ResourceTimeRangeStore({
 *         readUrl : './resourceTimeRanges/'
 *     })
 * })
 * ```
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * ## Recurring ranges support
 *
 * The feature supports recurring ranges in case the provided store and models
 * have {@link Scheduler.data.mixin.RecurringTimeSpansMixin RecurringTimeSpansMixin} and {@link Scheduler/model/mixin/RecurringTimeSpan RecurringTimeSpan}
 * mixins applied:
 *
 * ```js
 * // We want to use recurring time ranges
 * // so we make a special model extending standard ResourceTimeRangeModel
 * // with RecurringTimeSpan which adds recurrence support
 * class MyResourceTimeRange extends RecurringTimeSpan(ResourceTimeRangeModel) {};
 *
 * // Define a new store extending standard ResourceTimeRangeStore
 * // with RecurringTimeSpansMixin mixin to add recurrence support to the store.
 * // This store will contain time ranges.
 * class MyResourceTimeRangeStore extends RecurringTimeSpansMixin(ResourceTimeRangeStore) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyResourceTimeRange
 *         };
 *     }
 * };
 *
 * // Instantiate store for resourceTimeRanges using our new classes
 * const resourceTimeRangeStore = new MyResourceTimeRangeStore({
 *     data : [{        {
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Lunch',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 *
 * const scheduler = new Scheduler({
 *     ...
 *     features : {
 *         resourceTimeRanges : true
 *     },
 *     // store for "resourceTimeRanges" feature
 *     resourceTimeRangeStore,
 *     ...
 * ```
 *
 * @extends Scheduler/feature/base/ResourceTimeRangesBase
 * @demo Scheduler/resourcetimeranges
 * @inlineexample Scheduler/feature/ResourceTimeRanges.js
 * @classtype resourceTimeRanges
 * @feature
 */

class ResourceTimeRanges extends _base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'ResourceTimeRanges';
  }

  static get defaultConfig() {
    return {
      idPrefix: 'resourcetimerange',
      rangeCls: 'b-sch-resourcetimerange',

      /**
       * Store that holds resource time ranges (using ResourceTimeRangeModel or subclass thereof). A store will be
       * automatically created if none is specified
       * @config {Scheduler.data.ResourceTimeRangeStore}
       * @deprecated 4.0 Define `resourceTimeRangeStore` on Scheduler or its project
       */
      store: false,

      /**
       * Time range definitions (data to ResourceTimeRangeModels). Will be added to store. Can also be specified
       * on Scheduler for convenience
       * @config {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
       * @deprecated 4.0 Define `resourceTimeRanges` on Scheduler or `resourceTimeRangesData` on its project
       */
      resourceTimeRanges: null,

      /**
       * Specify value to use for the tabIndex attribute of resource time range elements
       * @config {Number}
       * @default
       */
      tabIndex: 0
    };
  } //endregion
  //region Init
  // TODO move as much code as possible to attachToResourceTimeRangeStore


  attachToProject(project) {
    const me = this,
          {
      client: scheduler
    } = me;
    super.attachToProject(project);

    if (!project.resourceTimeRangeStore) {
      project.resourceTimeRangeStore = me._store || scheduler.resourceTimeRangeStore || new _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
        owner: me
      });
      const {
        crudManager
      } = scheduler;

      if (crudManager && !crudManager.resourceTimeRangeStore) {
        crudManager.resourceTimeRangeStore = project.resourceTimeRangeStore;
      }
    }

    const store = project.resourceTimeRangeStore;

    if (!me.exposedOnScheduler) {
      // ResourceZones can be set on scheduler or feature, for convenience
      if (scheduler.resourceTimeRanges) {
        store.add(scheduler.resourceTimeRanges);
        delete scheduler.resourceTimeRanges;
      } // expose getter/setter for resourceTimeRanges on scheduler


      Object.defineProperty(scheduler, 'resourceTimeRanges', {
        get: () => store.records,
        set: resourceTimeRanges => store.data = resourceTimeRanges
      });
      me.exposedOnScheduler = true;
    } // Link to projects resourceStore if not already linked to one


    if (!store.resourceStore) {
      store.resourceStore = project.resourceStore;
    }

    me.detachListeners('store');
    store.on({
      name: 'store',
      change: me.onStoreChange,
      thisObj: me
    });
  } // Called by ProjectConsumer after a new store is assigned at runtime
  // TODO move as much code as possible here from attachToProject


  attachToResourceTimeRangeStore(store) {
    this.attachToProject(this.project);
    this.client.refresh();
  }
  /**
   * Called during construction to do product specific store setup
   * @private
   */


  set store(store) {
    // For backwards compatibility, we now want the store on the project
    this._store = store;
  }

  get store() {
    return this.project.resourceTimeRangeStore;
  } //endregion
  // Called on render of resources events to get events to render. Add any ranges
  // (chained function from Scheduler)


  getEventsToRender(resource, events) {
    const {
      timeRanges
    } = resource; // if we have ranges and the feature is enabled

    if (timeRanges !== null && timeRanges !== void 0 && timeRanges.length && !this.disabled) {
      const {
        startDate,
        endDate
      } = this.client;
      timeRanges.forEach(timeRange => {
        // if this a recurring event let's include its visible occurrences
        if (timeRange.isRecurring) {
          events.push(...timeRange.getOccurrencesForDateRange(startDate, endDate));
        } else {
          events.push(timeRange);
        }
      });
    }

    return events;
  }

  shouldInclude(eventRecord) {
    return eventRecord.isResourceTimeRange && !eventRecord.isNonWorking;
  }

  doDestroy() {
    var _this$store;

    if (((_this$store = this.store) === null || _this$store === void 0 ? void 0 : _this$store.owner) === this) {
      this.store.destroy();
    }

    super.doDestroy();
  }

} // No feature based styling needed, do not add a cls to Scheduler

ResourceTimeRanges.featureClass = '';
ResourceTimeRanges._$name = 'ResourceTimeRanges';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ResourceTimeRanges, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleContext.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleContext.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleContext; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
var productName = 'gantt';



/**
 * @module Scheduler/feature/ScheduleContext
 */

/**
 * Allow selecting a schedule "cell" by clicking
 *
 * This feature is **disabled** by default
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleContext : true // `false` by default, set to `true` to enable the feature
 *     }
 * });
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 * @inlineexample Scheduler/feature/ScheduleContext.js
 * @classtype scheduleContext
 * @feature
 */

class ScheduleContext extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ScheduleContext';
  }

  static get pluginConfig() {
    return {
      after: ['render']
    };
  }

  construct(scheduler, config) {
    // required to work
    scheduler.useBackgroundCanvas = true;
    scheduler.on('scheduleclick', this.onSchedulerClick, this);
    this.scheduler = scheduler;
    super.construct(scheduler, config);
  }

  render() {
    const {
      scheduler
    } = this;
    this.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
      parent: scheduler.backgroundCanvas,
      className: 'b-schedule-selected-tick',
      style: `${scheduler.isVertical ? 'height' : 'width'}:${scheduler.tickSize}px;`
    });
  }

  onSchedulerClick(context) {
    const {
      scheduler,
      element
    } = this,
          {
      tickStartDate,
      tickEndDate,
      resourceRecord
    } = context,
          // get the position clicked based on dates
    renderData = scheduler.currentOrientation.getTimeSpanRenderData({
      startDate: tickStartDate,
      endDate: tickEndDate,
      startDateMS: tickStartDate.getTime(),
      endDateMS: tickEndDate.getTime()
    }, resourceRecord);
    let top;

    if (scheduler.isVertical) {
      top = renderData.top; // set the width with the cell width

      element.style.width = renderData.width + 'px';
    } else {
      const row = scheduler.getRowFor(resourceRecord);
      top = row.top; // set the height with the cell height

      element.style.height = row.height + 'px';
    } // move to current cell


    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].setTranslateXY(element, renderData.left, top);
  }

}
ScheduleContext.featureClass = 'b-scheduler-context';
ScheduleContext._$name = 'ScheduleContext';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerFeature(ScheduleContext, false, ['Scheduler']);

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleContextMenu.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleContextMenu.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleContextMenu; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/feature/ScheduleContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.ScheduleMenu ScheduleMenu} feature instead.**
 *
 * Displays a context menu for empty parts of the schedule. Items are populated by other features and/or application code.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @deprecated 4.0.0
 * @extends Scheduler/feature/ScheduleMenu
 * @classtype scheduleContextMenu
 * @feature
 */

class ScheduleContextMenu extends _Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'ScheduleContextMenu';
  }

  construct(scheduler, config) {
    super.construct(scheduler, config);
    this.scheduler = scheduler;
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', '`ScheduleContextMenu` feature is deprecated, in favor of `ScheduleMenu` feature. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'); // If this feature is enabled, need to disable ScheduleMenu. They are mutually exclusive.

    if (scheduler.features.scheduleMenu) {
      scheduler.features.scheduleMenu.disabled = true;
    }
  } //endregion
  //region Events

  /**
   * This event fires on the owning Scheduler before the context menu is shown for an event. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
   * being shown.
   * @event scheduleContextMenuBeforeShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to scheduleMenuBeforeShow
   * @preventable
   * @param {Scheduler.view.Scheduler} source
   * @param {Object} items Menu item configs
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler when an item is selected in the context menu.
   * @event scheduleContextMenuItem
   * @on-owner
   * @deprecated 4.0.0 Renamed to scheduleMenuItem
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.MenuItem} item
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning scheduler after showing the context menu for an event
   * @event scheduleContextMenuShow
   * @on-owner
   * @deprecated 4.0.0 Renamed to eventMenuShow
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */
  //endregion


}
ScheduleContextMenu.featureClass = '';
ScheduleContextMenu._$name = 'ScheduleContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ScheduleContextMenu);

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleMenu.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleMenu.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleMenu; });
/* harmony import */ var _Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/feature/base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/ScheduleMenu
 */

/**
 * Displays a context menu for empty parts of the schedule. Items are populated in the first place
 * by configurations of this Feature, then by other features and/or application code.
 *
 * ### Default scheduler zone menu items
 *
 * The Scheduler menu feature provides only one item:
 *
 * | Reference      | Text      | Weight | Feature        | Description                                                                                                          |
 * |----------------|-----------|--------|----------------|----------------------------------------------------------------------------------------------------------------------|
 * | `addEvent`     | Add event | 100    | *This feature* | Add a new event for the hovered resource starting at the clicked point in time. Hidden if the Scheduler is read-only |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Scheduler menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem({date, resourceRecord, items}) {
 *                         // Custom date based action
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Remove existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 addEvent : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 addEvent : {
 *                     text : 'Create new booking'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Manipulate existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             // Process items before menu is shown
 *             processItems({date, resourceRecord, items}) {
 *                  // Add an extra item for ancient times
 *                  if (date < new Date(2018, 11, 17)) {
 *                      items.modernize = {
 *                          text : 'Modernize',
 *                          ontItem({date}) {
 *                              // Custom date based action
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for Sundays
 *                  if (date.getDay() === 0) {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @demo Scheduler/basic
 * @extends Scheduler/feature/base/TimeSpanMenuBase
 * @classtype scheduleMenu
 * @feature
 */

class ScheduleMenu extends _Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ScheduleMenu';
  }

  static get defaultConfig() {
    return {
      type: 'schedule',

      /**
       * This is a preconfigured set of items used to create the default context menu.
       *
       * The `items` provided by this feature are listed below. These are the predefined property names which you may
       * configure:
       *
       * - `addEvent` Add an event for at the resource and time indicated by the `contextmenu` event.
       *
       * To remove existing items, set corresponding keys to `false`
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         scheduleMenu : {
       *             items : {
       *                 addEvent : false
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object} items
       */
      items: null,

      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       * features         : {
       *    scheduleMenu : {
       *         processItems({ items, date, resourceRecord }) {
       *            // Add or hide existing items here as needed
       *            items.myAction = {
       *                text   : 'Cool action',
       *                icon   : 'b-fa b-fa-cat',
       *                onItem : () => console.log(`Clicked on ${resourceRecord.name} at ${date}`),
       *                weight : 1000 // Move to end
       *            };
       *
       *            if (!resourceRecord.allowAdd) {
       *                items.addEvent.hidden = true;
       *            }
       *        }
       *    }
       * },
       * ```
       * @param {Object} context An object with information about the menu being shown
       * @param {Scheduler.model.ResourceModel} context.resourceRecord The record representing the current resource
       * @param {Date} context.date The clicked date
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null
    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateScheduleMenu');
    return config;
  } //endregion
  //region Events

  /**
   * This event fires on the owning Scheduler before the context menu is shown for an event. Allows manipulation of the items
   * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
   * being shown.
   * @event scheduleMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {Scheduler.view.Scheduler} source
   * @param {Object} items Menu item configs
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler when an item is selected in the context menu.
   * @event scheduleMenuItem
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.MenuItem} item
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */

  /**
   * This event fires on the owning Scheduler after showing the context menu for an event
   * @event scheduleMenuShow
   * @on-owner
   * @param {Scheduler.view.Scheduler} source
   * @param {Core.widget.Menu} menu The menu
   * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
   * @param {HTMLElement} eventElement
   */
  //endregion


  shouldShowMenu(eventParams) {
    const {
      client
    } = this,
          {
      column,
      targetElement,
      resourceRecord
    } = eventParams,
          isTimeAxisColumn = column ? column === client.timeAxisColumn : client.timeAxisSubGrid.element === targetElement;
    return isTimeAxisColumn && !(resourceRecord && resourceRecord.isSpecialRow);
  }

  getDataFromEvent(event) {
    // Process event if it wasn't yet processed
    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isDOMEvent(event)) {
      const {
        client
      } = this,
            cellData = client.getCellDataFromEvent(event),
            date = client.getDateFromDomEvent(event, 'floor'),
            // For vertical mode the resource must be resolved from the event
      resourceRecord = client.resolveResourceRecord(event) || client.isVertical && client.resourceStore.last;
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(super.getDataFromEvent(event), cellData, {
        date,
        resourceRecord
      });
    }

    return event;
  }

  populateScheduleMenu({
    items,
    resourceRecord,
    date
  }) {
    const {
      client
    } = this; // Menu can work for ResourceHistogram which doesn't have event store

    if (!client.readOnly && client.eventStore) {
      items.addEvent = {
        text: 'L{SchedulerBase.Add event}',
        icon: 'b-icon b-icon-add',
        disabled: !resourceRecord || resourceRecord.readOnly || !resourceRecord.isWorkingTime(date),
        weight: 100,

        onItem() {
          client.internalAddEvent(date, resourceRecord, client.getRowFor(resourceRecord));
        }

      };
    }
  }

}
ScheduleMenu.featureClass = '';
ScheduleMenu._$name = 'ScheduleMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(ScheduleMenu, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleTooltip.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleTooltip.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleTooltip; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';





/**
 * @module Scheduler/feature/ScheduleTooltip
 */

/**
 * Feature that displays a tooltip containing the time at the mouse position when hovering empty parts of the schedule.
 * To hide the schedule tooltip, just disable this feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleTooltip : false
 *     }
 * });
 * ```
 *
 * You can also output a message along with the default time indicator (to indicate resource availability etc)
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *    features : {
 *       scheduleTooltip : {
 *           getText(date, event, resource) {
 *               return 'Hovering ' + resource.name;
 *           }
 *       }
 *   }
 * });
 * ```
 *
 * To take full control over the markup shown in the tooltip you can override the {@link #function-generateTipContent} method:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleTooltip : {
 *             generateTipContent({ date, event, resourceRecord }) {
 *                 return `
 *                     <dl>
 *                         <dt>Date</dt><dd>${date}</dd>
 *                         <dt>Resource</dt><dd>${resourceRecord.name}</dd>
 *                     </dl>
 *                 `;
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Configuration properties from the feature are passed down into the resulting {@Link Core.widget.Tooltip} instance.
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleTooltip : {
 *             // Don't show the tip until the mouse has been over the schedule for three seconds
 *             hoverDelay : 3000
 *         }
 *     }
 * });
 * ```
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/basic
 * @inlineexample Scheduler/feature/ScheduleTooltip.js
 * @classtype scheduleTooltip
 * @feature
 */

class ScheduleTooltip extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ScheduleTooltip';
  }

  static get configurable() {
    return {
      messageTemplate: data => `<div class="b-sch-hovertip-msg">${data.message}</div>`,

      /**
       * Set to `true` to hide this tooltip when hovering non-working time. Defaults to `false` for Scheduler,
       * `true` for SchedulerPro
       * @config {Boolean}
       */
      hideForNonWorkingTime: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onPaint']
    };
  } //endregion
  //region Init

  /**
   * Set up drag and drop and hover tooltip.
   * @private
   */


  onPaint({
    firstPaint
  }) {
    if (!firstPaint) {
      return;
    }

    const me = this,
          scheduler = me.client;

    if (scheduler.isSchedulerPro && me.hideForNonWorkingTime === undefined) {
      me.hideForNonWorkingTime = true;
    }

    let reshowListener;
    const tip = me.hoverTip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_2__["default"](_objectSpread(_objectSpread({
      id: `${scheduler.id}-schedule-tip`,
      cls: 'b-sch-scheduletip',
      allowOver: true,
      hoverDelay: 0,
      hideDelay: 100,
      showOnHover: true,
      forElement: scheduler.timeAxisSubGridElement,
      anchorToTarget: false,
      trackMouse: true,
      updateContentOnMouseMove: true,
      // disable text content and monitor resize for tooltip, otherwise it doesn't
      // get sized properly on first appearance
      monitorResize: false,
      textContent: false,
      forSelector: '.b-schedulerbase:not(.b-dragging-event):not(.b-dragcreating) .b-grid-body-container:not(.b-scrolling) .b-timeline-subgrid:not(.b-scrolling) > :not(.b-sch-foreground-canvas):not(.b-group-footer):not(.b-group-row) *',
      // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
      constrainTo: null,
      getHtml: me.getHoverTipHtml.bind(me),

      onDocumentMouseDown(event) {
        // Click on the scheduler hides until the very next
        // non-button-pressed mouse move!
        if (tip.forElement.contains(event.event.target)) {
          reshowListener = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
            element: scheduler.timeAxisSubGridElement,
            mousemove: e => tip.internalOnPointerOver(e),
            capture: true
          });
        }

        const hideAnimation = tip.hideAnimation;
        tip.hideAnimation = false;
        tip.constructor.prototype.onDocumentMouseDown.call(tip, event);
        tip.hideAnimation = hideAnimation;
      }

    }, me.config), {}, {
      listeners: me.configuredListeners
    })); // We have to add our own listener after instantiation because it may conflict with a configured listener

    tip.on({
      pointerover: ({
        event
      }) => {
        const buttonsPressed = 'buttons' in event ? event.buttons > 0 : event.which > 0; // fallback for Safari which doesn't support 'buttons'
        // This is the non-button-pressed mousemove
        // after the document mousedown

        if (!buttonsPressed && reshowListener) {
          reshowListener();
        } // Never any tooltip while interaction is ongoing and a mouse button is pressed


        return !me.disabled && !buttonsPressed;
      }
    });
    const timeAxisScrollable = scheduler.isHorizontal ? scheduler.timeAxisSubGrid.scrollable : scheduler.scrollable; // Update tooltip as time axis is scrolled

    timeAxisScrollable.on({
      scroll: me.updateTip,
      thisObj: me
    }); // Update tooltip after zooming

    scheduler.on({
      timeAxisViewModelUpdate: me.updateTip,
      thisObj: me
    });
    me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      scheduler
    });
  } // leave configuredListeners alone until render time at which they are used on the tooltip


  processConfiguredListeners() {}

  updateTip() {
    if (this.hoverTip.isVisible) {
      this.hoverTip.updateContent();
    }
  }

  doDestroy() {
    this.destroyProperties('clockTemplate', 'hoverTip');
    super.doDestroy();
  } //endregion
  //region Contents

  /**
   * @deprecated Use {@link #function-generateTipContent} instead.
   * Gets html to display in hover tooltip (tooltip displayed on empty parts of scheduler)
   * @private
   */


  getHoverTipHtml({
    tip,
    event
  }) {
    const me = this,
          scheduler = me.client,
          date = event && scheduler.getDateFromDomEvent(event, 'floor', true);
    let html = me.lastHtml; // event.target might be null in the case of being hosted in a web component https://github.com/bryntum/bryntum-suite/pull/4488

    if (date && event.target) {
      const resourceRecord = scheduler.resolveResourceRecord(event); // resourceRecord might be null if user hover over the tooltip, but we shouldn't hide the tooltip in this case

      if (resourceRecord && (date - me.lastTime !== 0 || resourceRecord.id !== me.lastResourceId)) {
        if (me.hideForNonWorkingTime) {
          const isWorkingTime = resourceRecord.isWorkingTime(date);
          tip.element.classList.toggle('b-nonworking-time', !isWorkingTime);
        }

        me.lastResourceId = resourceRecord.id;
        html = me.lastHtml = me.generateTipContent({
          date,
          event,
          resourceRecord
        });
      }
    } else {
      tip.hide();
      me.lastTime = null;
      me.lastResourceId = null;
    }

    return html;
  }
  /**
   * Called as mouse pointer is moved over a new resource or time block. You can override this to show
   * custom HTML in the tooltip.
   * @param {Object} context
   * @param {Date} context.date The date of the hovered point
   * @param {Event} context.event The DOM event that triggered this tooltip to show
   * @param {Scheduler.model.ResourceModel} context.resourceRecord The resource record
   * @returns {String} The HTML contents to show in the tooltip (an empty return value will hide the tooltip)
   */


  generateTipContent({
    date,
    event,
    resourceRecord
  }) {
    const me = this,
          clockHtml = me.clockTemplate.generateContent({
      date: date,
      text: me.client.getFormattedDate(date)
    }),
          messageHtml = me.messageTemplate({
      message: me.getText(date, event, resourceRecord) || ''
    });
    me.lastTime = date;
    return clockHtml + messageHtml;
  }
  /**
   * Override this to render custom text to default hover tip
   * @param {Date} date
   * @param {Event} event Browser event
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @return {String}
   */


  getText(date, event, resourceRecord) {} //endregion


} // TODO: Refactor SASS so that auto-generated class name of 'b-' + cls.name.toLowerCase() can be used.

ScheduleTooltip.featureClass = 'b-scheduletip';
ScheduleTooltip._$name = 'ScheduleTooltip';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(ScheduleTooltip, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/SimpleEventEdit.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/SimpleEventEdit.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SimpleEventEdit; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/SimpleEventEdit
 */

/**
 * Feature that displays a text field to edit the event name. You can control the flow of this by listening to the events relayed by this class from the underlying {@link Core.widget.Editor}.
 * To use this feature, you also need to disable the built-in default editing feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit       : false,
 *         simpleEventEdit : true
 *     }
 * });
 * ```
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/simpleeditor
 * @inlineexample Scheduler/feature/SimpleEventEdit.js
 * @classtype simpleEventEdit
 * @feature
 */

class SimpleEventEdit extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  // region Events

  /**
   * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
   * @event beforeStart
   * @param {Object} value The value to be edited.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   * @preventable
   */

  /**
   * Fired when an edit operation has begun.
   * @event start
   * @param {Object} value The starting value of the field.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   */

  /**
   * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
   * The completion may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeComplete
   * @param {Object} oldValue The original value.
   * @param {Object} value The new value.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   * @preventable
   */

  /**
   * Edit has been completed, and any associated record or element has been updated.
   * @event complete
   * @param {Object} oldValue The original value.
   * @param {Object} value The new value.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   */

  /**
   * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
   * The cancellation may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeCancel
   * @param {Object} oldValue The original value.
   * @param {Object} value The new value.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   * @preventable
   */

  /**
   * Edit has been canceled without updating the associated record or element.
   * @event cancel
   * @param {Object} oldValue The original value.
   * @param {Object} value The value of the field.
   * @param {Core.widget.Editor} source The Editor that triggered the event.
   */
  // endregion
  //region Config
  static get $name() {
    return 'SimpleEventEdit';
  }

  static get defaultConfig() {
    return {
      /**
       * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
       * @config {String}
       * @default
       * @category Editor
       */
      triggerEvent: 'eventdblclick',

      /**
       * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
       * @property {Scheduler.model.EventModel}
       * @readonly
       */
      eventRecord: null,

      /**
       * The {@link Scheduler.model.EventModel} field to edit
       * @config {String}
       * @category Editor
       */
      field: 'name',

      /**
       * The editor configuration, where you can control which widget to show
       * @config {Object}
       * @category Editor
       */
      editorConfig: null
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onEventEnterKey', 'editEvent']
    };
  } //endregion
  //region Editing


  construct(scheduler, config) {
    const me = this;
    me.scheduler = scheduler;
    scheduler.eventEdit = me;
    super.construct(scheduler, config);
    me.clientListenersDetacher = scheduler.on({
      [me.triggerEvent]: ({
        eventRecord,
        eventElement
      }) => me.editEvent(eventRecord, eventRecord.resource, eventElement),
      dragcreateend: me.onDragCreateEnd,
      thisObj: me
    });
  }

  doDestroy() {
    var _this$editor;

    this.clientListenersDetacher();
    (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();
    super.doDestroy();
  }

  get eventStore() {
    return this.scheduler.eventStore;
  } // region Editor

  /**
   * Opens an Editor for the passed event. This function is exposed on Scheduler and can be called as
   * `scheduler.editEvent()`.
   * @param {Scheduler.model.EventModel} eventRecord The Event to edit
   * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
   * @on-owner
   */


  editEvent(eventRecord, resourceRecord, element) {
    const me = this,
          scheduler = me.scheduler,
          {
      eventEdit
    } = me.client.features; // If event edit feature also exists, we use simple edit for new events and eventEdit it for already created events

    if (scheduler.readOnly || me.disabled || eventEdit && !eventEdit.disabled && !eventRecord.isCreating) {
      return;
    } // Want to put editor in inner element (b-sch-event) to get correct font size, but when drag creating the proxy
    // has no inner element


    element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].down(element, scheduler.eventInnerSelector) || element;
    eventRecord = eventRecord.isAssignment ? eventRecord.event : eventRecord;
    me.resource = resourceRecord;
    me.event = eventRecord;
    me.element = element;
    scheduler.element.classList.add('b-eventeditor-editing');

    if (!me.editor) {
      // Editor is contained in, and owned by the TimeAxisSubGrid to avoid focus flipping out and in.
      // The editor is an owned descendant of the SubGrid.
      me.editor = _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_2__["default"].new({
        owner: scheduler.timeAxisSubGrid,
        appendTo: scheduler.timeAxisSubGridElement,
        scrollAction: 'realign',
        align: {
          align: 'c-c'
        },
        cls: 'b-simpleeventeditor',
        listeners: {
          complete: 'onEditorComplete',
          cancel: 'onEditorCancel',
          thisObj: me
        }
      }, me.editorConfig);
      me.relayEvents(me.editor, ['beforestart', 'start', 'beforecomplete', 'complete', 'beforecancel', 'cancel']);
    } // Drag-created records get a "New event" name for cosmetic purposes.
    // Remove just before editing.


    if (eventRecord.isCreating) {
      eventRecord.name = '';
    }

    me.editor.startEdit({
      target: element,
      record: eventRecord,
      field: me.field
    }); // No key navigation during editing

    me.scheduler.navigator.disabled = true;
  }

  onEditorComplete() {
    // Promote event to being permanent so that it is syncable to the server as a new event
    this.event.isCreating = false;
    this.reset();
  }

  onEditorCancel() {
    // Remove the transient event
    if (this.event.isCreating) {
      this.event.remove();
    }

    this.reset();
  }

  reset() {
    this.scheduler.element.classList.remove('b-eventeditor-editing'); // Restore key navigation after editing

    this.scheduler.navigator.disabled = false;
    this.event = null;
    this.resource = null;
  } //endregion
  // chained from EventNavigation


  onEventEnterKey({
    assignmentRecord,
    eventRecord
  }) {
    const element = assignmentRecord ? this.scheduler.getElementFromAssignmentRecord(assignmentRecord) : this.scheduler.getElementFromEventRecord(eventRecord),
          resourceRecord = (assignmentRecord || eventRecord).resource;
    this.editEvent(eventRecord, resourceRecord, element);
  } //endregion


  onDragCreateEnd({
    eventRecord,
    resourceRecord,
    proxyElement
  }) {
    this.element = proxyElement;
    this.editEvent(eventRecord, resourceRecord, proxyElement);
  }

}
SimpleEventEdit._$name = 'SimpleEventEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(SimpleEventEdit, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/StickyEvents.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/StickyEvents.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StickyEvents; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/StickyEvents
 */

const zeroMargins = {
  width: 0,
  height: 0
};
/**
 * This feature causes the inner text of events to stay in view as long as possible while the event's
 * bar is being moved out of view by sliding the content rightwards (or downwards in vertical mode).
 *
 * This feature may need to be be disabled when using complex
 * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventBodyTemplate eventBodyTemplates}
 * (See the "Nested events demo) because it relies on controlling the position of the inner element
 * of the event body.
 *
 * This feature is **enabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 * @classtype stickyEvents
 * @feature
 */

class StickyEvents extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'StickyEvents';
  }

  static get type() {
    return 'stickyEvents';
  } // Plugin configuration. This plugin chains some of the functions in Scheduler.


  static get pluginConfig() {
    return {
      chain: ['onEventDataGenerated']
    };
  }

  construct(scheduler, config) {
    super.construct(scheduler, config);
    this.toUpdate = new Set(); // When the Scheduler fires its scroll events, we check the rowMap cache of
    // rendered events in rows, each of which contains an array of event domConfigs.
    // If any of those event layouts currently owns an element (is not derendered)
    // and have a start that is less than the scroll position, the eventContent is
    // nudged forward so that it remains in view.

    scheduler.on({
      horizontalScroll: 'onSchedulerScroll',
      scroll: 'onSchedulerScroll',
      thisObj: this,
      prio: 10000
    });
  }

  onEventDataGenerated(eventData) {
    this.syncEventContentPosition(eventData, undefined, true);
    this.updateStyles();
  }

  onSchedulerScroll({
    subGrid
  }) {
    const {
      client
    } = this,
          method = client.isHorizontal ? 'horizontalSyncAllEventsContentPosition' : 'verticalSyncAllEventsContentPosition'; // If we're horizontal, and it's not the Scheduler's subgrid scrolling horizontally, do not react.
    // (There is no subgrid on vertical scroll in horizontal mode)

    if (this.disabled || client.isHorizontal && subGrid && !subGrid.isTimeAxisSubGrid) {
      return;
    }

    this[method](client);
  }

  updateStyles() {
    for (const {
      contentEl,
      style
    } of this.toUpdate) {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].applyStyle(contentEl, style);
    }

    this.toUpdate.clear();
  }

  horizontalSyncAllEventsContentPosition(scheduler) {
    const domConfigs = scheduler.currentOrientation.visibleEventDOMConfigs;

    if (domConfigs) {
      for (let i = 0, {
        length
      } = domConfigs; i < length; i++) {
        const domConfig = domConfigs[i];
        this.syncEventContentPosition(domConfig.elementData, domConfig.children[0].children[0]);
      }
    }

    this.toUpdate.size && this.updateStyles();
  }

  verticalSyncAllEventsContentPosition(scheduler) {
    const {
      resourceMap
    } = scheduler.currentOrientation;

    for (const eventsData of resourceMap.values()) {
      for (const {
        renderData,
        elementConfig
      } of Object.values(eventsData)) {
        const args = [renderData];

        if (elementConfig && renderData.eventRecord.isResourceTimeRange) {
          args.push(elementConfig.children[0]);
        }

        this.syncEventContentPosition.apply(this, args);
      }
    }

    this.toUpdate.size && this.updateStyles();
  }

  onEventDrag(eventBar, force) {
    if (this.disabled) {
      return;
    }

    const {
      client
    } = this,
          {
      isHorizontal
    } = client,
          sizeProperty = `offset${isHorizontal ? 'Width' : 'Height'}`,
          scrollPosition = isHorizontal ? client.timeAxisSubGrid.scrollable.x : client.scrollable.y,
          contentEl = eventBar.querySelector('.b-sch-event-content'),
          eventStart = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"][isHorizontal ? 'getTranslateX' : 'getTranslateY'](eventBar),
          eventEnd = eventStart + eventBar[sizeProperty] - 1,
          transformDim = isHorizontal ? 'X' : 'Y',
          barSize = eventBar[sizeProperty],
          contentSize = contentEl === null || contentEl === void 0 ? void 0 : contentEl[sizeProperty];

    if (force || !eventBar.classList.contains('b-milestone-wrap') && contentSize && eventStart < scrollPosition && eventEnd >= scrollPosition) {
      const edgeSize = this.getEventContentMargins(contentEl)[isHorizontal ? 'width' : 'height'],
            justify = contentEl && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getStyleValue(contentEl.parentNode, 'justifyContent'),
            c = justify === 'center' ? (barSize - contentSize) / 2 : 0,
            maxOffset = barSize - contentSize - edgeSize,
            offset = Math.min(scrollPosition - eventStart, maxOffset - 2) - c;

      if (contentEl) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].applyStyle(contentEl, {
          transform: offset > 0 ? `translate${transformDim}(${offset}px)` : ''
        });
      }
    }
  }

  syncEventContentPosition(renderData, eventContent = renderData.eventContent, duringGeneration = false) {
    if (this.disabled || // Allow client disable stickiness for certain events
    renderData.eventRecord.stickyContents === false) {
      return;
    }

    const {
      client
    } = this,
          {
      isHorizontal
    } = client,
          {
      eventRecord,
      resourceRecord
    } = renderData,
          scrollPosition = isHorizontal ? client.timeAxisSubGrid.scrollable.x : client.scrollable.y,
          wrapperEl = duringGeneration ? null : client.getElementFromEventRecord(eventRecord, resourceRecord, true),
          contentEl = wrapperEl && _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].getChild(wrapperEl, 'event.content'),
          start = renderData[isHorizontal ? 'left' : 'top'],
          end = start + renderData[isHorizontal ? 'width' : 'height'],
          meta = eventRecord.instanceMeta(client),
          style = typeof eventContent.style === 'string' ? eventContent.style = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseStyle(eventContent.style) : eventContent.style || (eventContent.style = {}); // Do not process events being dragged

    if (wrapperEl !== null && wrapperEl !== void 0 && wrapperEl.classList.contains('b-dragging')) {
      return;
    } // Only process non-milestones that are partially out of view


    if (start < scrollPosition && end >= scrollPosition && !eventRecord.isMilestone) {
      const contentWidth = contentEl === null || contentEl === void 0 ? void 0 : contentEl.offsetWidth,
            justify = (contentEl === null || contentEl === void 0 ? void 0 : contentEl.parentNode) && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getStyleValue(contentEl.parentNode, 'justifyContent'),
            c = justify === 'center' ? (renderData.width - contentWidth) / 2 : 0,
            eventStart = isHorizontal ? renderData.left + c : renderData.top,
            eventEnd = eventStart + (isHorizontal ? renderData.width : renderData.height) - 1,
            transformDim = isHorizontal ? 'X' : 'Y'; // Only process non-milestone events. Milestones have no width.
      // If there's no offsetWidth, it's still b-released, so we cannot measure it.
      // If the event starts off the left edge, but its right edge is still visible,
      // translate the contentEl to compensate. If not, undo any translation.

      if ((!contentEl || contentWidth) && eventStart < scrollPosition && eventEnd >= scrollPosition) {
        const edgeSizes = this.getEventContentMargins(contentEl),
              maxOffset = contentEl ? (isHorizontal ? renderData.width - contentWidth - edgeSizes.width : renderData.height - contentEl.offsetHeight - edgeSizes.height) - c : Number.MAX_SAFE_INTEGER,
              offset = Math.min(scrollPosition - eventStart, maxOffset - 2);
        style.transform = offset > 0 ? `translate${transformDim}(${offset}px)` : '';
        meta.stuck = true;
      } else {
        style.transform = '';
        meta.stuck = false;
      }

      if (contentEl) {
        this.toUpdate.add({
          contentEl,
          style
        });
      }
    } else if (contentEl && meta.stuck) {
      style.transform = '';
      meta.stuck = false;
      this.toUpdate.add({
        contentEl,
        style
      });
    }
  } // Only measure the margins of an event's contentEl once


  getEventContentMargins(contentEl) {
    if (contentEl !== null && contentEl !== void 0 && contentEl.classList.contains('b-sch-event-content')) {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getEdgeSize(contentEl, 'margin');
    }

    return zeroMargins;
  }

  doDisable() {
    super.doDisable(...arguments);

    if (!this.isConfiguring) {
      this.client.refreshWithTransition();
    }
  }

}
StickyEvents._$name = 'StickyEvents';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(StickyEvents, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(StickyEvents, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/Summary.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/feature/Summary.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Summary; });
/* harmony import */ var _TimelineSummary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimelineSummary.js */ "./lib/Scheduler/feature/TimelineSummary.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/Summary
 */
// noinspection JSClosureCompilerSyntax

/**
 * A special version of the Grid Summary feature. This feature displays a summary row in the grid footer.
 * For regular columns in the locked section - specify type of summary on columns, available types are:
 * <dl class="wide">
 * <dt>sum <dd>Sum of all values in the column
 * <dt>add <dd>Alias for sum
 * <dt>count <dd>Number of rows
 * <dt>countNotEmpty <dd>Number of rows containing a value
 * <dt>average <dd>Average of all values in the column
 * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
 * </dl>
 * Columns can also specify a summaryRender to format the calculated sum.
 *
 * To summarize events, either provide a {@link #config-renderer} or use {@link #config-summaries}
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Scheduler/feature/TimelineSummary
 * @classtype summary
 * @feature
 * @inlineexample Scheduler/feature/Summary.js
 * @demo Scheduler/summary
 * @typings Grid/feature/Summary -> Grid/feature/GridSummary
 */

class Summary extends _TimelineSummary_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Summary';
  }

  static get configurable() {
    return {
      /**
       * Array of summary configs which consists of a label and a {@link #config-renderer} function
       *
       * ```javascript
       * new Scheduler({
       *     features : {
       *         summary : {
       *             summaries : [
       *                 {
       *                     label : 'Label',
       *                     renderer : ({ startDate, endDate, eventStore, resourceStore, events, element }) => {
       *                         // return display value
       *                         returns '<div>Renderer output</div>';
       *                     }
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object[]}
       */
      summaries: null,

      /**
       * Renderer function for a single time axis tick. Should calculate a sum and return HTML as a result.
       *
       * ```javascript
       * new Scheduler({
       *     features : {
       *         summary : {
       *             renderer : ({ startDate, endDate, eventStore, resourceStore, events, element }) => {
       *                 // return display value
       *                 returns '<div>Renderer output</div>';
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * @param {Date} startDate Tick start date
       * @param {Date} endDate Tick end date
       * @param {Scheduler.model.EventModel[]} events Events which belong to the group
       * @param {Scheduler.data.EventStore} eventStore Event store
       * @param {Scheduler.data.ResourceStore} resourceStore Resource store
       * @param {HTMLElement} element Summary tick container
       * @returns {String} Html content
       * @config {Function}
       */
      renderer: null,

      /**
       * A config object for the {@link Grid.column.Column} used to contain the summary bar.
       * @config {Object}
       */
      verticalSummaryColumnConfig: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('bindStore', 'updateEventStore', 'updateResourceStore');
    return config;
  } //endregion
  //region Init


  construct(scheduler, config) {
    const me = this;
    me.scheduler = scheduler;

    if (scheduler.isVertical) {
      scheduler.timeAxisSubGrid.resizable = false;
      config.hideFooters = true;
      scheduler.add(scheduler.createSubGrid('right'));
      me.summaryColumn = scheduler.columns.add(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({
        filterable: null,
        region: 'right',
        cellCls: 'b-grid-footer b-sch-summarybar',
        align: 'center',
        sortable: false,
        groupable: false,
        htmlEncode: false,
        enableHeaderContextMenu: false,
        hidden: me.disabled
      }, me.verticalSummaryColumnConfig))[0];
    }

    super.construct(scheduler, config); // Feature might be run from Grid (in docs), should not crash
    // https://app.assembla.com/spaces/bryntum/tickets/6801/details

    if (scheduler instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
      me.updateEventStore(scheduler.eventStore);
      me.updateResourceStore(scheduler.resourceStore);
    }
  } //endregion
  //region Render


  updateEventStore(eventStore) {
    this.detachListeners('summaryEventStore');
    eventStore.on({
      name: 'summaryEventStore',
      filter: 'updateTimelineSummaries',
      thisObj: this
    });
  }

  updateResourceStore(resourceStore) {
    this.detachListeners('summaryResourceStore');
    resourceStore.on({
      name: 'summaryResourceStore',
      filter: 'updateTimelineSummaries',
      thisObj: this
    });
  }
  /**
   * Updates summaries.
   * @private
   */


  updateTimelineSummaries() {
    const me = this,
          {
      client: timeline
    } = me,
          {
      eventStore,
      timeAxis
    } = timeline,
          summaryContainer = me.summaryBarElement,
          forResources = me.selectedOnly && timeline.selectedRecords.length ? timeline.selectedRecords : timeline.resourceStore.records;

    if (summaryContainer && timeline.isEngineReady) {
      // group events by ticks info once here to avoid performance lags
      // should be inside `scheduler.isEngineReady` check to make sure all events were calculated
      // https://github.com/bryntum/support/issues/2977
      const eventsByTick = timeline.getResourcesEventsPerTick(forResources, ({
        event
      }) => {
        return !eventStore.isFiltered || eventStore.records.includes(event);
      });
      Array.from(summaryContainer.children).forEach((element, i) => {
        const tick = timeAxis.getAt(i),
              events = eventsByTick[i] || [];
        let html = '',
            tipHtml = `<header>${me.L('L{Summary for}', timeline.getFormattedDate(tick.startDate))}</header>`;
        me.summaries.forEach(config => {
          const value = config.renderer({
            startDate: tick.startDate,
            endDate: tick.endDate,
            resourceStore: timeline.resourceStore,
            eventStore,
            events,
            element
          }),
                valueHtml = `<div class="b-timeaxis-summary-value">${value}</div>`;

          if (me.summaries.length > 1 || value !== '') {
            html += valueHtml;
          }

          tipHtml += `<label>${config.label || ''}</label>` + valueHtml;
        });
        element.innerHTML = html;
        element._tipHtml = tipHtml;
      });
    }
  }

} // Override Grids Summary with this improved version

Summary._$name = 'Summary';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(Summary, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/TimeAxisHeaderMenu.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisHeaderMenu; });
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/TimeAxisHeaderMenu
 */

const setTimeSpanOptions = {
  maintainVisibleStart: true
};
/**
 * Adds scheduler specific menu items to the timeline header context menu.
 *
 * ## Default timeaxis header menu items
 *
 * Here is the list of menu items provided by this and other features:
 *
 * | Reference          | Text                  | Weight | Feature                                           | Description                  |
 * |--------------------|-----------------------|--------|---------------------------------------------------|------------------------------|
 * | `eventsFilter`     | Filter tasks          | 100    | {@link Scheduler.feature.EventFilter EventFilter} | Submenu for event filtering  |
 * | \>`nameFilter`     | By name               | 110    | {@link Scheduler.feature.EventFilter EventFilter} | Filter by `name`             |
 * | `zoomLevel`        | Zoom                  | 200    | *This feature*                                    | Submenu for timeline zooming |
 * | \>`zoomSlider`     | -                     | 210    | *This feature*                                    | Changes current zoom level   |
 * | `dateRange`        | Date range            | 300    | *This feature*                                    | Submenu for timeline range   |
 * | \>`startDateField` | Start date            | 310    | *This feature*                                    | Start date for the timeline  |
 * | \>`endDateField`   | End date              | 320    | *This feature*                                    | End date for the timeline    |
 * | \>`leftShiftBtn`   | <                     | 330    | *This feature*                                    | Shift backward               |
 * | \>`todayBtn`       | Today                 | 340    | *This feature*                                    | Go to today                  |
 * | \>`rightShiftBtn`  | \>                    | 350    | *This feature*                                    | Shift forward                |
 * | `currentTimeLine`  | Show current timeline | 400    | {@link Scheduler.feature.TimeRanges TimeRanges}   | Show current time line       |
 *
 * \> - first level of submenu
 *
 * ## Customizing the menu items
 *
 * The menu items in the TimeAxis Header menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * ### Add extra items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem() {
 *                         ...
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ### Remove existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 zoomLevel : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ### Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 zoomLevel : {
 *                     text : 'Scale'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 * ### Customizing submenu items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *      features : {
 *          timeAxisHeaderMenu : {
 *              items : {
 *                  dateRange : {
 *                      menu : {
 *                          items : {
 *                              todayBtn : {
 *                                  text : 'Now'
 *                              }
 *                          }
 *                      }
 *                  }
 *              }
 *          }
 *      }
 * });
 * ```
 *
 * ### Manipulate existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             // Process items before menu is shown
 *             processItems({ items }) {
 *                  // Add an extra item dynamically
 *                 items.coolItem = {
 *                     text : 'Cool action',
 *                     onItem() {
 *                           // ...
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the ["Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu"](#Scheduler/guides/customization/contextmenu.md)
 * guide.
 *
 * This feature is **enabled** by default
 *
 * @extends Grid/feature/HeaderMenu
 * @demo Scheduler/basic
 * @classtype timeAxisHeaderMenu
 * @feature
 * @inlineexample Scheduler/feature/TimeAxisHeaderMenu.js
 */

class TimeAxisHeaderMenu extends _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TimeAxisHeaderMenu';
  }

  static get defaultConfig() {
    return {
      /**
       * A function called before displaying the menu that allows manipulations of its items.
       * Returning `false` from this function prevents the menu being shown.
       *
       * ```javascript
       *   features         : {
       *       timeAxisHeaderMenu : {
       *           processItems({ items }) {
       *               // Add or hide existing items here as needed
       *               items.myAction = {
       *                   text   : 'Cool action',
       *                   icon   : 'b-fa b-fa-fw b-fa-ban',
       *                   onItem : () => console.log('Some coolness'),
       *                   weight : 300 // Move to end
       *               };
       *
       *               // Hide zoom slider
       *               items.zoomLevel.hidden = true;
       *           }
       *       }
       *   },
       * ```
       *
       * @param {Object} context An object with information about the menu being shown
       * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
       * @param {Event} context.event The DOM event object that triggered the show
       * @config {Function}
       * @preventable
       */
      processItems: null,

      /**
       * This is a preconfigured set of items used to create the default context menu.
       *
       * The `items` provided by this feature are listed in the intro section of this class. You can
       * configure existing items by passing a configuration object to the keyed items.
       *
       * To remove existing
       * items, set corresponding keys to `false`
       *
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         timeAxisHeaderMenu : {
       *             items : {
       *                 eventsFilter        : false
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * See the feature config in the above example for details.
       *
       * @config {Object} items
       */
      items: null,
      type: 'timeAxisHeader'
    };
  }

  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateTimeAxisHeaderMenu');
    return config;
  } //endregion
  //region Events

  /**
   * This event fires on the owning Scheduler before the context menu is shown for the time axis header.
   * Allows manipulation of the items to show in the same way as in the {@link #config-processItems}.
   *
   * Returning `false` from a listener prevents the menu from being shown.
   *
   * @event timeAxisHeaderContextMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {Scheduler.view.Scheduler} source The scheduler
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Time axis column
   */

  /**
   * This event fires on the owning Scheduler after the context menu is shown for a header
   * @event timeAxisHeaderContextMenuShow
   * @on-owner
   * @param {Scheduler.view.Scheduler} source The scheduler
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {Grid.column.Column} column Time axis column
   */

  /**
   * This event fires on the owning Scheduler when an item is selected in the header context menu.
   * @event timeAxisHeaderContextMenuItem
   * @on-owner
   * @param {Scheduler.view.Scheduler} source The scheduler
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   * @param {Grid.column.Column} column Time axis column
   */
  //endregion


  construct() {
    super.construct(...arguments);

    if (this.triggerEvent.includes('click') && this.client.zoomOnTimeAxisDoubleClick) {
      this.client.zoomOnTimeAxisDoubleClick = false;
    }
  }

  shouldShowMenu(eventParams) {
    const {
      column
    } = eventParams;
    return column && column.enableHeaderContextMenu !== false && column === this.client.timeAxisColumn;
  }

  showContextMenu(eventParams) {
    super.showContextMenu(...arguments);

    if (this.menu) {
      // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
      // The menu should not hide on scroll when for a TimeAxisColumn
      this.menu.scrollAction = 'realign';
    }
  }

  populateTimeAxisHeaderMenu({
    items
  }) {
    const me = this,
          {
      client
    } = me,
          dateStep = {
      magnitude: client.timeAxis.shiftIncrement,
      unit: client.timeAxis.shiftUnit
    };
    Object.assign(items, {
      zoomLevel: {
        text: 'L{pickZoomLevel}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-search-plus',
        disabled: !client.presets.count || me.disabled,
        weight: 200,
        menu: {
          type: 'popup',
          items: {
            zoomSlider: {
              weight: 210,
              type: 'slider',
              minWidth: 130,
              // for IE11
              showValue: false
            }
          },

          onBeforeShow({
            source: menu
          }) {
            const [zoom] = menu.items;
            zoom.min = client.minZoomLevel;
            zoom.max = client.maxZoomLevel;
            zoom.value = client.zoomLevel; // Default slider value is 50 which causes the above to trigger onZoomSliderChange (when
            // maxZoomLevel < 50) if we add our listener prior to this point.

            me.zoomDetatcher = zoom.on('input', 'onZoomSliderChange', me);
          },

          onHide() {
            if (me.zoomDetatcher) {
              me.zoomDetatcher();
              me.zoomDetatcher = null;
            }
          }

        }
      },
      dateRange: {
        text: 'L{activeDateRange}',
        localeClass: me,
        icon: 'b-fw-icon b-icon-calendar',
        weight: 300,
        menu: {
          type: 'popup',
          width: '20em',
          defaults: {
            localeClass: me
          },
          items: {
            startDateField: {
              type: 'datefield',
              label: 'L{startText}',
              weight: 310,
              labelWidth: '6em',
              required: true,
              step: dateStep,
              listeners: {
                change: me.onRangeDateFieldChange,
                thisObj: me
              }
            },
            endDateField: {
              type: 'datefield',
              label: 'L{endText}',
              weight: 320,
              labelWidth: '6em',
              required: true,
              step: dateStep,
              listeners: {
                change: me.onRangeDateFieldChange,
                thisObj: me
              }
            },
            leftShiftBtn: {
              type: 'button',
              weight: 330,
              cls: 'b-left-nav-btn',
              icon: 'b-icon b-icon-prev',
              color: 'b-blue b-raised',
              flex: 1,
              margin: 0,
              listeners: {
                click: me.onLeftShiftBtnClick,
                thisObj: me
              }
            },
            todayBtn: {
              type: 'button',
              weight: 340,
              cls: 'b-today-nav-btn',
              color: 'b-blue b-raised',
              text: 'L{todayText}',
              flex: 4,
              margin: '0 8',
              listeners: {
                click: me.onTodayBtnClick,
                thisObj: me
              }
            },
            rightShiftBtn: {
              type: 'button',
              weight: 350,
              cls: 'b-right-nav-btn',
              icon: 'b-icon b-icon-next',
              color: 'b-blue b-raised',
              flex: 1,
              listeners: {
                click: me.onRightShiftBtnClick,
                thisObj: me
              }
            }
          },
          listeners: {
            paint: me.initDateRangeFields,
            thisObj: me
          }
        }
      }
    });
  }

  onZoomSliderChange({
    value
  }) {
    const me = this; // Zooming maintains timeline center point by scrolling the newly rerendered timeline to the
    // correct point to maintain the visual center. Temporarily inhibit context menu hide on scroll
    // of its context element.

    me.menu.scrollAction = 'realign';
    me.client.zoomLevel = value;
    me.menu.setTimeout({
      fn: () => me.menu.scrollAction = 'hide',
      delay: 100,
      cancelOutstanding: true
    });
  }

  initDateRangeFields({
    source: dateRange,
    firstPaint
  }) {
    if (firstPaint) {
      const {
        widgetMap
      } = dateRange;
      this.startDateField = widgetMap.startDateField;
      this.endDateField = widgetMap.endDateField;
    }

    this.initDates();
  }

  initDates() {
    const me = this;
    me.startDateField.suspendEvents();
    me.endDateField.suspendEvents(); // The actual scheduler start dates may include time, but our Date field cannot currently handle
    // a time portion and throws it away, so when we need the value from an unchanged field, we need
    // to use the initialValue set from the timeAxis values.
    // Until our DateField can optionally include a time value, this is the solution.

    me.startDateField.value = me.startDateFieldInitialValue = me.client.startDate;
    me.endDateField.value = me.endDateFieldInitialValue = me.client.endDate;
    me.startDateField.resumeEvents();
    me.endDateField.resumeEvents();
  }

  onRangeDateFieldChange({
    source
  }) {
    const me = this,
          startDateChanged = source === me.startDateField,
          {
      client
    } = me,
          {
      timeAxis
    } = client,
          startDate = me.startDateFieldInitialValue && !startDateChanged ? me.startDateFieldInitialValue : me.startDateField.value;
    let endDate = me.endDateFieldInitialValue && startDateChanged ? me.endDateFieldInitialValue : me.endDateField.value; // When either of the fields is changed, we no longer use its initialValue from the timeAxis start or end
    // so that gets nulled to indicate that it's unavailable and the real field value is to be used.

    if (startDateChanged) {
      me.startDateFieldInitialValue = null;
    } else {
      me.endDateFieldInitialValue = null;
    } // Because the start and end dates are exclusive, avoid a zero
    // length time axis by incrementing the end by one tick unit
    // if they are the same.


    if (!(endDate - startDate)) {
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
    } // if start date got bigger than end date set end date to start date plus one tick
    else if (endDate < startDate) {
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
    } // setTimeSpan will try to keep the scroll position the same.


    client.setTimeSpan(startDate, endDate, setTimeSpanOptions);
    me.initDates();
  }

  onLeftShiftBtnClick() {
    this.client.timeAxis.shiftPrevious();
    this.initDates();
  }

  onTodayBtnClick() {
    const today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date());
    this.client.setTimeSpan(today, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(today, 1, 'day'));
    this.initDates();
  }

  onRightShiftBtnClick() {
    this.client.timeAxis.shiftNext();
    this.initDates();
  }

}
TimeAxisHeaderMenu._$name = 'TimeAxisHeaderMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TimeAxisHeaderMenu, true, ['Scheduler', 'Gantt']);
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TimeAxisHeaderMenu, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/Scheduler/feature/TimeRanges.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/feature/TimeRanges.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeRanges; });
/* harmony import */ var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
var productName = 'gantt';





/**
 * @module Scheduler/feature/TimeRanges
 */

/**
 * Feature that renders global ranges of time in the timeline. Use this feature to visualize a `range` like a 1 hr lunch or some important point in time
 * (a `line`, i.e. a range with 0 duration). This feature can also show a current time indicator if you set {@link #config-showCurrentTimeLine} to true. To style
 * the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field of the `TimeSpan` class.
 *
 * Each time range is represented by an instances of {@link Scheduler.model.TimeSpan}, held in a simple {@link Core.data.Store}.
 * The feature uses {@link Scheduler/model/ProjectModel#property-timeRangeStore} defined on the project.
 * The store/persisting loading is handled by Crud Manager (if it's used by the component).
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * ## Showing an icon in the time range header
 *
 * You can use Font Awesome icons easily (or set any other icon using CSS) by using the {@link Scheduler.model.TimeSpan#field-cls cls}
 * field. The JSON data below will show a flag icon:
 *
 * ```json
 * {
 *     "id"        : 5,
 *     "cls"       : "b-fa b-fa-flag",
 *     "name"      : "v5.0",
 *     "startDate" : "2019-02-07 15:45"
 * },
 * ```
 *
 * ## Recurring time ranges
 *
 * The feature supports recurring ranges in case the provided store and models
 * have {@link Scheduler/data/mixin/RecurringTimeSpansMixin} and {@link Scheduler/model/mixin/RecurringTimeSpan}
 * mixins applied:
 *
 * ```javascript
 * // We want to use recurring time ranges so we make a special model extending standard TimeSpan model with
 * // RecurringTimeSpan which adds recurrence support
 * class MyTimeRange extends RecurringTimeSpan(TimeSpan) {}
 *
 * // Define a new store extending standard Store with RecurringTimeSpansMixin mixin to add recurrence support to the
 * // store. This store will contain time ranges.
 * class MyTimeRangeStore extends RecurringTimeSpansMixin(Store) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyTimeRange
 *         };
 *     }
 * };
 *
 * // Instantiate store for timeRanges using our new classes
 * const timeRangeStore = new MyTimeRangeStore({
 *     data : [{
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Lunch',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 *
 * const scheduler = new Scheduler({
 *     ...
 *     features : {
 *         timeRanges : true
 *     },
 *
 *     crudManager : {
 *         // store for "timeRanges" feature
 *         timeRangeStore
 *     }
 * });
 * ```
 *
 * @extends Scheduler/feature/AbstractTimeRanges
 * @classtype timeRanges
 * @feature
 * @demo Scheduler/timeranges
 * @inlineexample Scheduler/feature/TimeRanges.js
 */

class TimeRanges extends _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  //region Config
  static get $name() {
    return 'TimeRanges';
  }

  static get defaultConfig() {
    return {
      /**
       * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
       *
       * A `timeRangeStore` is automatically created on the Scheduler project instance and will be used by
       * default.
       *
       * @config {Object|Core.data.Store}
       * @deprecated 4.0 Define `timeRangeStore` on Scheduler or its project
       */
      store: true,

      /**
       * The interval (as amount of ms) defining how frequently the current timeline will be updated
       * @config {Number}
       * @default
       */
      currentTimeLineUpdateInterval: 10000,

      /**
       * The date format to show in the header for the current time line, see {@link #config-showCurrentTimeLine}
       * @config {String}
       * @default
       */
      currentDateFormat: 'HH:mm',

      /**
       * Range definitions (data to {@link Scheduler.model.TimeSpan} models). Will be added to store.
       * @config {Scheduler.model.TimeSpan[]|Object[]}
       * @deprecated 4.0 Define `timeRanges` on Scheduler or `timeRangesData` on its project
       */
      timeRanges: null,

      /**
       * Show a line indicating current time. Either `true` or `false` or a {@link Scheduler.model.TimeSpan} configuration object to apply to this
       * special time range (allowing you to provide a custom text):
       *
       * ```javascript
       * showCurrentTimeLine : {
       *     name : 'Now'
       * }
       * ```
       *
       * The line carries the CSS class name `b-sch-current-time`, and this may be used to add custom styling to the current time line.
       *
       * @config {Boolean|Object}
       * @default
       */
      showCurrentTimeLine: false
    };
  } //endregion
  //region Init & destroy


  construct(client, config = {}) {
    super.construct(client, config);

    if (!client._timeRangesExposed) {
      // expose getter/setter for timeRanges on scheduler/gantt
      Object.defineProperty(client, 'timeRanges', {
        get: () => this.timeRanges,
        set: timeRanges => client.project.timeRangeStore.data = timeRanges
      });
      client._timeRangesExposed = true;
    } // Pull in the timeRanges config before the store config if it exists.


    this.getConfig('timeRanges');
  }

  set timeRanges(timeRanges) {
    const store = this.getConfig('store');

    if (store) {
      store.data = timeRanges;
    } else {
      this._timeRanges = timeRanges;
    }
  }
  /**
   * Returns the TimeRanges which occur within the client Scheduler's time axis.
   * @property {Scheduler.model.TimeSpan[]}
   */


  get timeRanges() {
    const {
      store
    } = this,
          {
      records
    } = store;

    if (store.recurringEvents) {
      const result = [],
            {
        startDate,
        endDate
      } = this.client.timeAxis; // Collect occurrences for the recurring events in the record set

      records.forEach(timeSpan => {
        if (timeSpan.isRecurring) {
          result.push.apply(result, timeSpan.getOccurrencesForDateRange(startDate, endDate));
        } else {
          result.push(timeSpan);
        }
      });
      return result;
    }

    return records;
  } //endregion
  //region Current time line


  initCurrentTimeLine() {
    const me = this;

    if (me.currentTimeLine || !me.showCurrentTimeLine) {
      return;
    }

    const data = typeof me.showCurrentTimeLine === 'object' ? me.showCurrentTimeLine : {};
    me.currentTimeLine = me.store.modelClass.new({
      // eslint-disable-next-line quote-props
      'id': 'currentTime',
      cls: 'b-sch-current-time'
    }, data);
    me.updateCurrentTimeLine = me.updateCurrentTimeLine.bind(me);
    me.currentTimeInterval = me.setInterval(me.updateCurrentTimeLine, me.currentTimeLineUpdateInterval);
    me.updateCurrentTimeLine();

    if (me.client.isPainted) {
      me.renderRanges();
    }
  }

  updateCurrentTimeLine() {
    const me = this,
          currentTimeRecord = me.currentTimeLine;
    currentTimeRecord.startDate = new Date();

    if (!currentTimeRecord.originalData.name) {
      currentTimeRecord.name = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(currentTimeRecord.startDate, me.currentDateFormat);
    }

    me.onStoreChanged({
      action: 'update',
      record: currentTimeRecord,
      changes: {}
    });
  }

  hideCurrentTimeLine() {
    const me = this;

    if (!me.currentTimeLine) {
      return;
    }

    me.clearInterval(me.currentTimeInterval);
    me.currentTimeLine = null;

    if (me.client.isPainted) {
      me.renderRanges();
    }
  }

  renderRanges() {
    const me = this;
    super.renderRanges();

    if (me.showCurrentTimeLine && !me.disabled) {
      me.renderRange(me.currentTimeLine, true);
    }
  }
  /**
   * Get/set the current time line display state
   * @property {Boolean}
   */


  get showCurrentTimeLine() {
    return this._showCurrentTimeLine;
  }

  set showCurrentTimeLine(show) {
    this._showCurrentTimeLine = show;

    if (show) {
      this.initCurrentTimeLine();
    } else {
      this.hideCurrentTimeLine();
    }
  } //endregion
  //region Menu items
  // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.

  /**
   * Adds a menu item to show/hide current time line.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead
   */


  populateHeaderMenu({
    column,
    items
  }) {
    if (column.type !== 'timeAxis') {
      return;
    }

    this.populateTimeAxisHeaderMenu(...arguments);
  }
  /**
   * Adds a menu item to show/hide current time line.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown
   * @param {Object} options.items A named object to describe menu items
   * @internal
   */


  populateTimeAxisHeaderMenu({
    column,
    items
  }) {
    items.currentTimeLine = {
      weight: 400,
      text: this.L('L{showCurrentTimeLine}'),
      checked: this.showCurrentTimeLine,
      onToggle: ({
        checked
      }) => {
        this.showCurrentTimeLine = checked;
      }
    };
  } //endregion
  //region Disable

  /**
   * Get/set the features disabled state
   * @property {Boolean}
   */


  get disabled() {
    return this._disabled;
  }

  set disabled(disabled) {
    this._disabled = disabled;

    if (this.client.isPainted) {
      this.renderRanges();
    }
  }

  attachToProject(project) {
    // If the client's project has a timeRangeStore, we must use that
    // unless we've configured feature with a store (e.g. with recurrence mixin)
    if (!this.hasOwnStore) {
      this.store = project.timeRangeStore;
    }
  }
  /**
   * Returns the {@link Core.data.Store store} used by this feature
   * @property {Core.data.Store}
   * @deprecated 4.0 Define `timeRangeStore` on Scheduler or its project
   */


  get store() {
    return this.client.project.timeRangeStore;
  }

  set store(store) {
    const me = this,
          {
      client
    } = me,
          {
      project
    } = client;

    if (store === true) {
      store = project.timeRangeStore;
    } else if (store !== project.timeRangeStore) {
      store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStore(store, _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"]);

      if (!store.storeId) {
        store.storeId = 'timeRanges';
      }

      project.timeRangeStore = store;
      me.hasOwnStore = true;
    }

    me.attachToStore(store); // timeRanges can be set on scheduler/gantt or feature, for convenience. Should only be processed by the TimeRanges
    // and not any subclasses

    if (client.timeRanges && !client._timeRangesExposed) {
      store.add(client.timeRanges);
      delete client.timeRanges;
    }

    if (me.timeRanges) {
      store.add(me.timeRanges);
      delete me.timeRanges;
    }
  } // Called by ProjectConsumer after a new store is assigned at runtime


  attachToTimeRangeStore(store) {
    this.store = store;
  } //endregion


}
TimeRanges._$name = 'TimeRanges';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(TimeRanges, false, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/TimelineSummary.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/TimelineSummary.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimelineSummary; });
/* harmony import */ var _Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/Summary.js */ "./lib/Grid/feature/Summary.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'gantt';


/**
 * @module Scheduler/feature/TimelineSummary
 */
// noinspection JSClosureCompilerSyntax

/**
 * Base class, not to be used directly.
 * @extends Grid/feature/Summary
 * @abstract
 */

class TimelineSummary extends _Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TimelineSummary';
  }

  static get configurable() {
    return {
      /**
       * Show tooltip containing summary values and labels
       * @config {Boolean}
       * @default
       */
      showTooltip: true
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['renderRows', 'updateProject']
    };
  } //endregion
  //region Init


  construct(client, config) {
    const me = this;
    super.construct(client, config);

    if (!me.summaries) {
      me.summaries = [{
        renderer: me.renderer
      }];
    } // Feature might be run from Grid (in docs), should not crash
    // https://app.assembla.com/spaces/bryntum/tickets/6801/details


    if (client.isTimelineBase) {
      me.updateProject(client.project);
      client.on({
        timeAxisViewModelUpdate: me.renderRows,
        thisObj: me
      });
    }
  } //endregion
  //region Render


  updateProject(project) {
    this.detachListeners('summaryProject');
    project.on({
      name: 'summaryProject',
      dataReady: 'updateTimelineSummaries',
      thisObj: this
    });
  }

  renderRows() {
    if (this.client.isHorizontal) {
      this.client.timeAxisSubGrid.footer.element.querySelector('.b-grid-footer').classList.add('b-sch-summarybar');
    }

    super.renderRows();

    if (!this.disabled) {
      this.render();
    }
  }

  get summaryBarElement() {
    return this.client.element.querySelector('.b-sch-summarybar');
  }

  render() {
    const me = this,
          {
      client: timeline
    } = me,
          sizeProp = timeline.isHorizontal ? 'width' : 'height',
          colCfg = timeline.timeAxisViewModel.columnConfig,
          summaryContainer = me.summaryBarElement;

    if (summaryContainer) {
      // if any sum config has a label, init tooltip
      if (!me._tip && me.showTooltip && me.summaries.some(config => config.label)) {
        me._tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
          id: `${timeline.id}-summary-tip`,
          cls: 'b-timeaxis-summary-tip',
          hoverDelay: 0,
          hideDelay: 100,
          forElement: summaryContainer,
          anchorToTarget: true,
          trackMouse: false,
          forSelector: '.b-timeaxis-tick',
          getHtml: ({
            activeTarget
          }) => activeTarget._tipHtml
        });
      }

      summaryContainer.innerHTML = colCfg[colCfg.length - 1].map(col => `<div class="b-timeaxis-tick" style="${sizeProp}: ${col.width}px"></div>`).join('');
      me.updateTimelineSummaries();
    }
  } //endregion

  /**
   * Refreshes the summaries
   */


  refresh() {
    super.refresh();
    this.updateTimelineSummaries();
  }

  doDisable(disable) {
    var _this$summaryColumn;

    const {
      isConfiguring
    } = this.client;
    super.doDisable(disable);
    (_this$summaryColumn = this.summaryColumn) === null || _this$summaryColumn === void 0 ? void 0 : _this$summaryColumn.toggle(!disable);

    if (!isConfiguring && !disable) {
      this.render();
    }
  }

  doDestroy() {
    var _this$_tip;

    (_this$_tip = this._tip) === null || _this$_tip === void 0 ? void 0 : _this$_tip.destroy();
    super.doDestroy();
  }

}
TimelineSummary._$name = 'TimelineSummary';

/***/ }),

/***/ "./lib/Scheduler/feature/base/DragBase.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/feature/base/DragBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragBase; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
/* eslint-disable no-unused-expressions */













/**
 * @module Scheduler/feature/base/DragBase
 */
//TODO: shift to copy
//TODO: dragging of event that starts & ends outside of view

/**
 * Base class for EventDrag (Scheduler) and TaskDrag (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

class DragBase extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get defaultConfig() {
    return {
      // documented on Schedulers EventDrag feature and Gantt's TaskDrag
      tooltipTemplate: data => `
                <div class="b-sch-tip-${data.valid ? 'valid' : 'invalid'}">
                    ${data.startClockHtml}
                    ${data.endClockHtml}
                    <div class="b-sch-tip-message">${data.message}</div>
                </div>
            `,

      /**
       * Specifies whether or not to show tooltip while dragging event
       * @config {Boolean}
       * @default
       */
      showTooltip: true,

      /**
       * When enabled, the event being dragged always "snaps" to the exact start date that it will have after drop.
       * @config {Boolean}
       * @default
       */
      showExactDropPosition: false,

      /*
       * The store from which the dragged items are mapped to the UI.
       * In Scheduler's implementation of this base class, this will be
       * an EventStore, in Gantt's implementations, this will be a TaskStore.
       * Because both derive from this base, we must refer to it as this.store.
       * @private
       */
      store: null,

      /**
       * An object used to configure the internal {@link Core.helper.DragHelper} class
       * @config {Object}
       * @default
       */
      dragHelperConfig: null,
      tooltipCls: null
    };
  }

  static get configurable() {
    return {
      /**
       * Set to `false` to allow dragging tasks outside of the client Scheduler.
       * Useful when you want to drag tasks between multiple Scheduler instances
       * @config {Boolean}
       * @default
       */
      constrainDragToTimeline: true,
      // documented on Schedulers EventDrag feature, not used for Gantt
      constrainDragToResource: true
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onPaint']
    };
  } //endregion
  //region Init

  /**
   * Called when scheduler is rendered. Sets up drag and drop and hover tooltip.
   * @private
   */


  onPaint({
    firstPaint
  }) {
    var _me$drag;

    const me = this,
          {
      client,
      constrainDragToTimeline,
      constrainDragToResource,
      constrainDragToTimeSlot,
      dragHelperConfig
    } = me,
          {
      timeAxisViewModel,
      isHorizontal
    } = client,
          lockY = isHorizontal ? constrainDragToResource : constrainDragToTimeSlot,
          lockX = isHorizontal ? constrainDragToTimeSlot : constrainDragToResource;
    (_me$drag = me.drag) === null || _me$drag === void 0 ? void 0 : _me$drag.destroy();
    me.drag = _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].new({
      name: me.constructor.name,
      // useful when debugging with multiple draggers
      mode: 'translateXY',
      lockX,
      lockY,
      minX: true,
      // Allows dropping with start before time axis
      maxX: true,
      // Allows dropping with end after time axis
      constrain: false,
      cloneTarget: !constrainDragToTimeline,
      dragWithin: constrainDragToTimeline ? null : document.body,
      hideOriginalElement: true,
      outerElement: client.timeAxisSubGridElement,
      targetSelector: client.eventSelector,
      scrollManager: constrainDragToTimeline ? client.scrollManager : null,
      transitionDuration: client.transitionDuration,
      snapCoordinates: ({
        element,
        newX,
        newY
      }) => {
        // Snapping not supported when dragging outside a scheduler
        if (me.constrainDragToTimeline && !me.constrainDragToTimeSlot && (me.showExactDropPosition || timeAxisViewModel.snap)) {
          const dd = me.dragData,
                snappedDate = timeAxisViewModel.getDateFromPosition(me.getCoordinate(dd.draggedEntities[0], element, [newX, newY]), 'round'),
                snappedPosition = snappedDate && timeAxisViewModel.getPositionFromDate(snappedDate);

          if (snappedDate && snappedDate >= client.startDate && snappedPosition != null) {
            if (isHorizontal) {
              newX = snappedPosition;
            } else {
              newY = snappedPosition;
            }
          }
        }

        return {
          x: newX,
          y: newY
        };
      },
      listeners: {
        beforedragstart: 'onBeforeDragStart',
        dragstart: 'onDragStart',
        drag: 'onDrag',
        drop: 'onDrop',
        abort: 'onDragAbort',
        reset: 'onDragReset',
        thisObj: me
      }
    }, dragHelperConfig, {
      isElementDraggable: (el, event) => {
        return (!dragHelperConfig || !dragHelperConfig.isElementDraggable || dragHelperConfig.isElementDraggable(el, event)) && me.isElementDraggable(el, event);
      }
    });

    if (firstPaint) {
      client.rowManager.on({
        changeTotalHeight: 'updateYConstraint',
        thisObj: me
      });

      if (me.dragTipTemplate) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].deprecate('Scheduler', '5.0.0', 'Deprecated in favor of `tooltipTemplate`, will be removed in 5.0');
      }
    }

    if (me.showTooltip) {
      me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
        scheduler: client
      });
    }
  }

  doDestroy() {
    var _this$drag, _this$clockTemplate, _this$tip;

    (_this$drag = this.drag) === null || _this$drag === void 0 ? void 0 : _this$drag.destroy();
    (_this$clockTemplate = this.clockTemplate) === null || _this$clockTemplate === void 0 ? void 0 : _this$clockTemplate.destroy();
    (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.destroy();
    super.doDestroy();
  } //endregion
  //region Drag events


  onBeforeDragStart({
    context,
    event
  }) {
    const me = this,
          {
      client
    } = me,
          name = client.scheduledEventName,
          dragData = me.getMinimalDragData(context, event),
          eventRecord = dragData === null || dragData === void 0 ? void 0 : dragData[`${name}Record`];

    if (client.readOnly || me.disabled || !eventRecord || eventRecord.isDraggable === false) {
      return false;
    } // Cache the date corresponding to the drag start point so that on drag, we can always
    // perform the same calculation to then find the time delta without having to calculate
    // the new start end end times from the position that the element is.


    context.pointerStartDate = client.getDateFromXY([context.startClientX, context.startPageY], null, false);
    const result = client.trigger(`before${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].capitalize(name)}Drag`, _objectSpread(_objectSpread({}, dragData), {}, {
      event,
      // to be deprecated
      context: _objectSpread(_objectSpread({}, context), dragData)
    })) !== false;

    if (result) {
      me.updateYConstraint(eventRecord);
    }

    return result;
  }
  /**
   * Triggered when dragging of an event starts. Initializes drag data associated with the event being dragged.
   * @private
   */


  onDragStart({
    context
  }) {
    const me = this,
          {
      client
    } = me;
    me.currentOverClient = client;
    me.onMouseOverNewTimeline(client, true);
    const dragData = me.dragData = me.getDragData(context); // Do not let DomSync reuse the element

    context.element.retainElement = true;

    if (me.showTooltip) {
      const tipTarget = dragData.context.dragProxy ? dragData.context.dragProxy.firstChild : context.element;

      if (!me.tip) {
        me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
          id: `${client.id}-event-drag-tip`,
          align: {
            align: 'b-t',
            allowTargetOut: true
          },
          autoShow: true,
          updateContentOnMouseMove: true,
          forElement: tipTarget,
          getHtml: me.getTipHtml.bind(me),
          // During drag, it must be impossible for the mouse to be over the tip.
          style: 'pointer-events:none',
          cls: me.tooltipCls
        });
        me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
      } else {
        me.tip.showBy(tipTarget);
      }
    } // me.copyKeyPressed = me.isCopyKeyPressed();
    //
    // if (me.copyKeyPressed) {
    //     dragData.refElements.addCls('sch-event-copy');
    //     dragData.originalHidden = true;
    // }


    me.triggerDragStart(dragData);
    const {
      eventMenu,
      taskMenu,
      // TODO: 'eventContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.
      eventContextMenu,
      taskContextMenu
    } = client.features,
          menuFeature = eventMenu || taskMenu || eventContextMenu || taskContextMenu; // If this is a touch action, hide the context menu which may have shown

    menuFeature === null || menuFeature === void 0 ? void 0 : menuFeature.hideContextMenu(false);
  }

  updateDateIndicator() {
    const {
      startDate,
      endDate
    } = this.dragData,
          {
      tip
    } = this,
          endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');
    this.clockTemplate.updateDateIndicator(tip.element, startDate);
    endDateElement && this.clockTemplate.updateDateIndicator(endDateElement, endDate);
  }
  /**
   * Triggered while dragging an event. Updates drag data, validation etc.
   * @private
   */


  onDrag({
    context,
    event
  }) {
    const me = this,
          dd = me.dragData,
          start = dd.startDate;
    let client;

    if (me.constrainDragToTimeline) {
      client = me.client;
    } else {
      var _client;

      let target = event.target; // Can't detect target under a touch event

      if (/^touch/.test(event.type)) {
        const center = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(dd.context.element, null, true).center;
        target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].elementFromPoint(center.x, center.y);
      }

      client = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(target, 'timelinebase'); // Do not allow drops on histogram widgets

      client = (_client = client) !== null && _client !== void 0 && _client.isResourceHistogram ? null : client;
    }

    const depFeature = me.client.features.dependencies;

    if (!client) {
      if (depFeature) {
        depFeature.updateDependenciesForTimeSpan(dd.draggedEntities[0], dd.context.element);
      }

      return;
    }

    if (client !== me.currentOverClient) {
      me.onMouseOverNewTimeline(client);
    } //this.checkShiftChange();


    me.updateDragContext(context, event); // Let product specific implementations trigger drag event (eventDrag, taskDrag)

    me.triggerEventDrag(dd, start);
    let valid = me.checkDragValidity(dd, event);

    if (valid && typeof valid !== 'boolean') {
      context.message = valid.message || '';
      valid = valid.valid;
    }

    context.valid = valid !== false;

    if (me.showTooltip) {
      // If we've an error message to show, force the tip to be visible
      // even if the target is not in view.
      me.tip.lastAlignSpec.allowTargetOut = !valid;
      me.tip.realign();
    }

    if (depFeature) {
      depFeature.updateDependenciesForTimeSpan(dd.draggedEntities[0], dd.context.element, dd.newResource);
    }
  }

  onMouseOverNewTimeline(newTimeline, initial) {
    const me = this,
          {
      drag: {
        lockX,
        lockY
      }
    } = me,
          scrollables = [];
    me.currentOverClient.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName);
    newTimeline.element.classList.add('b-dragging-' + newTimeline.scheduledEventName);

    if (!initial) {
      me.currentOverClient.scrollManager.stopMonitoring();
    }

    if (!lockX) {
      scrollables.push({
        element: newTimeline.timeAxisSubGrid.scrollable.element,
        direction: 'horizontal'
      });
    }

    if (!lockY) {
      scrollables.push({
        element: newTimeline.scrollable.element,
        direction: 'vertical'
      });
    }

    newTimeline.scrollManager.startMonitoring({
      scrollables,
      callback: me.drag.onScrollManagerScrollCallback
    });
    me.currentOverClient = newTimeline;
  }
  /**
   * Triggered when dropping an event. Finalizes the operation.
   * @private
   */


  onDrop({
    context,
    event
  }) {
    var _me$tip;

    const me = this,
          {
      currentOverClient,
      dragData
    } = me;
    let modified = false;
    me.updateDragContext(context, event);
    (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.hide();

    if (context.valid && dragData.startDate && dragData.endDate) {
      dragData.finalize = async (...params) => {
        await me.finalize(...params);
        context.finalize(...params);
      }; // Allow implementer to take control of the flow, by returning false from this listener,
      // to show a confirmation popup etc. This event is documented in EventDrag and TaskDrag


      currentOverClient.trigger(`before${currentOverClient.capitalizedEventName}DropFinalize`, {
        context: dragData,
        event
      });
      context.async = dragData.async; // Internal validation, making sure all dragged records fit inside the view

      if (!context.async && me.isValidDrop(dragData)) {
        modified = dragData.startDate - dragData.origStart !== 0 || dragData.newResource !== dragData.resourceRecord;
      }
    }

    if (!context.async) {
      me.finalize(dragData.valid && context.valid && modified);
    }
  }

  onDragAbort({
    context
  }) {
    var _me$tip2;

    const me = this;
    me.client.currentOrientation.onDragAbort({
      context,
      dragData: me.dragData
    }); // otherwise the event disappears on next refresh (#62)

    me.resetDraggedElements();
    (_me$tip2 = me.tip) === null || _me$tip2 === void 0 ? void 0 : _me$tip2.hide(); // Trigger eventDragAbort / taskDragAbort depending on product

    me.triggerDragAbort(me.dragData);
  } // For the drag across multiple schedulers, tell all involved scroll managers to stop monitoring


  onDragReset({
    source: dragHelper
  }) {
    var _dragHelper$context;

    const me = this,
          {
      dragData
    } = me,
          currentTimeline = me.currentOverClient;
    currentTimeline === null || currentTimeline === void 0 ? void 0 : currentTimeline.scrollManager.stopMonitoring();

    if ((_dragHelper$context = dragHelper.context) !== null && _dragHelper$context !== void 0 && _dragHelper$context.started) {
      me.resetDraggedElements();
    }

    currentTimeline === null || currentTimeline === void 0 ? void 0 : currentTimeline.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName); // Dependencies are updated dynamically during drag, so ensure they are redrawn
    // if the event snaps back with no change after abort or an invalid drop.

    if ((dragData === null || dragData === void 0 ? void 0 : dragData.context.valid) === false && currentTimeline !== null && currentTimeline !== void 0 && currentTimeline.features.dependencies) {
      currentTimeline === null || currentTimeline === void 0 ? void 0 : currentTimeline.features.dependencies.scheduleDraw(true);
    }

    me.dragData = null;
  }

  resetDraggedElements() {
    const {
      dragData
    } = this,
          {
      eventBarEls,
      draggedEntities
    } = dragData;
    this.resumeElementRedrawing(dragData.record);
    draggedEntities.forEach((record, i) => {
      this.resumeElementRedrawing(record);
      eventBarEls[i].classList.remove(this.drag.draggingCls);
      eventBarEls[i].retainElement = false;
      this.updateSticky(true);
    });
    eventBarEls[0].classList.remove('b-drag-main');
  }
  /**
   * Triggered internally on invalid drop.
   * @private
   */


  onInternalInvalidDrop() {
    var _this$tip2;

    (_this$tip2 = this.tip) === null || _this$tip2 === void 0 ? void 0 : _this$tip2.hide();
    this.triggerAfterDrop(this.dragData, false);
    this.drag.abort();
  } //endregion
  //region Finalization & validation

  /**
   * Called on drop to update the record of the event being dropped.
   * @private
   * @param {Boolean} updateRecords Specify true to update the record, false to treat as invalid
   */


  async finalize(updateRecords) {
    const me = this,
          {
      dragData
    } = me; // Drag could've been aborted by window blur event. If it is aborted - we have nothing to finalize.

    if (!dragData) {
      return;
    }

    const {
      context,
      draggedEntities
    } = dragData;
    let result;
    draggedEntities.forEach((record, i) => {
      me.resumeElementRedrawing(record);
      dragData.eventBarEls[i].classList.remove(me.drag.draggingCls);
      dragData.eventBarEls[i].retainElement = false;
    });

    if (updateRecords) {
      // updateRecords may or may not be async.
      // We see if it returns a Promise.
      result = me.updateRecords(dragData); // If updateRecords is async, the calling DragHelper must know this and
      // go into a awaitingFinalization state.

      if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_8__["default"].isPromise(result)) {
        context.async = true;
        await result;
      } // If the finalize handler decided to change the dragData's validity...


      if (!dragData.valid) {
        me.onInternalInvalidDrop();
      } else {
        me.drag.reset();
        me.triggerAfterDrop(dragData, true);
      }
    } else {
      me.onInternalInvalidDrop();
    }

    return result;
  } //endregion
  //region Drag data

  /**
   * Updates drag data's dates and validity (calls #validatorFn if specified)
   * @private
   */


  updateDragContext(info, event) {
    const me = this,
          {
      drag
    } = me,
          dd = me.dragData,
          client = me.currentOverClient,
          {
      isHorizontal
    } = client,
          record = dd.draggedEntities[0],
          eventRecord = record.isAssignment ? record.event : record,
          constrainToTimeSlot = me.constrainDragToTimeSlot || (isHorizontal ? drag.lockX : drag.lockY);
    dd.browserEvent = event;

    if (constrainToTimeSlot) {
      dd.timeDiff = 0;
    } else {
      if (client.timeAxis.isContinuous) {
        const {
          dateConstraints
        } = dd,
              {
          timeAxisSubGrid
        } = client,
              {
          scrollable
        } = timeAxisSubGrid,
              timeAxisRegion = scrollable.viewport,
              timeAxisPosition = client.isHorizontal ? info.pageX - timeAxisRegion.x + scrollable.x : info.pageY - timeAxisRegion.y + scrollable.y,
              // Use the localized coordinates to ask the TimeAxisViewModel what date the mouse is at.
        // Pass allowOutOfRange as true in case we have dragged out of either side of the timeline viewport.
        pointerDate = client.timeAxisViewModel.getDateFromPosition(timeAxisPosition, null, true),
              timeDiff = dd.timeDiff = pointerDate - info.pointerStartDate; // calculate and round new startDate based on actual dd.timeDiff

        dd.startDate = me.adjustStartDate(dd.origStart, timeDiff);

        if (dateConstraints) {
          dd.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].constrain(dd.startDate, dateConstraints.start, new Date(dateConstraints.end - eventRecord.durationMS));
        }

        dd.endDate = new Date(dd.startDate - 0 + dd.duration);
      } else {
        const range = me.resolveStartEndDates(info.element); // if dragging is out of timeAxis rect bounds, we will not be able to get dates

        dd.valid = Boolean(range.startDate && range.endDate);

        if (dd.valid) {
          dd.startDate = range.startDate;
          dd.endDate = range.endDate;
        }
      }

      if (dd.valid) {
        dd.timeDiff = dd.startDate - dd.origStart;
      }
    } // getProductDragContext may switch valid flag, need to keep it here


    Object.assign(dd, me.getProductDragContext(dd));

    if (dd.valid) {
      // If it's fully outside, we don't allow them to drop it - the event would disappear from their control.
      if (dd.endDate <= client.timeAxis.startDate || dd.startDate >= client.timeAxis.endDate) {
        dd.context.valid = false;
        dd.context.message = me.L('L{EventDrag.noDropOutsideTimeline}');
      } else {
        const result = !event || me.checkDragValidity(dd, event);

        if (!result || typeof result === 'boolean') {
          dd.context.valid = result !== false;
          dd.context.message = '';
        } else {
          dd.context.valid = result.valid !== false;
          dd.context.message = result.message;
        }
      }
    } else {
      dd.context.valid = false;
    }

    me.updateSticky();
  }

  updateSticky(force) {
    const me = this,
          dd = me.dragData,
          client = me.currentOverClient,
          {
      stickyEvents
    } = client.features; // Give the sticky event content feature a chance to sync content position.

    if ((dd.context.valid || force) && stickyEvents) {
      dd.eventBarEls.forEach((eventBar, i) => {
        stickyEvents.onEventDrag(eventBar, force);
      });
    }
  }

  suspendElementRedrawing(record, suspend = true) {
    const element = this.getRecordElement(record);

    if (element) {
      element.retainElement = suspend;
    }

    record.instanceMeta(this.client).retainElement = suspend;
  }

  resumeElementRedrawing(record) {
    this.suspendElementRedrawing(record, false);
  }
  /**
   * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
   * @private
   * @param info
   * @returns {*}
   */


  getDragData(info) {
    const me = this,
          {
      client,
      drag
    } = me,
          {
      record,
      dateConstraints,
      eventBarEls,
      draggedEntities
    } = me.setupProductDragData(info),
          {
      startEvent
    } = drag,
          timespan = record.isAssignment ? record.event : record,
          origStart = timespan.startDate,
          origEnd = timespan.endDate,
          timeAxis = client.timeAxis,
          startsOutsideView = origStart < timeAxis.startDate,
          endsOutsideView = origEnd > timeAxis.endDate,
          multiSelect = client.isSchedulerBase ? client.multiEventSelect : client.selectionMode.multiSelect,
          coordinate = me.getCoordinate(timespan, info.element, [info.elementStartX, info.elementStartY]),
          clientCoordinate = me.getCoordinate(timespan, info.element, [info.startClientX, info.startClientY]); // prevent elements from being released when out of view

    draggedEntities.forEach(record => me.suspendElementRedrawing(record)); // Make sure the dragged event is selected (no-op for already selected)
    // Preserve other selected events if ctrl/meta is pressed

    if (record.isAssignment) {
      client.selectAssignment(record, startEvent.ctrlKey && multiSelect);
    } else {
      client.selectEvent(record, startEvent.ctrlKey && multiSelect);
    }

    const dragData = {
      context: info,
      dateConstraints,
      eventBarEls,
      record,
      draggedEntities,
      sourceDate: startsOutsideView ? origStart : client.getDateFromCoordinate(coordinate),
      screenSourceDate: client.getDateFromCoordinate(clientCoordinate, null, false),
      startDate: origStart,
      endDate: origEnd,
      timeDiff: 0,
      origStart,
      origEnd,
      startsOutsideView,
      endsOutsideView,
      duration: origEnd - origStart,
      browserEvent: startEvent // So we can know if SHIFT/CTRL was pressed

    };
    eventBarEls.forEach(el => {
      el.classList.add(drag.draggingCls);
      el.classList.remove('b-sch-event-hover');
      el.classList.remove('b-active');
    });

    if (eventBarEls.length > 1) {
      // RelatedElements are secondary elements moved by the same delta as the grabbed element
      if (!me.constrainDragToTimeline) {
        // Will be dragging a clone, need to do the same for all selected elements
        // TODO: This should be handled by DragHelper! It is basically a copy of code there for the main element
        info.relatedElements = eventBarEls.slice(1).map(eventBar => {
          // TODO: Should be able to simplify this to only use DomSync.addChild
          const offsetX = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getOffsetX(eventBar, drag.dragWithin),
                offsetY = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getOffsetY(eventBar, drag.dragWithin),
                offsetWidth = eventBar.offsetWidth,
                offsetHeight = eventBar.offsetHeight,
                element = drag.createProxy(eventBar); // Match the grabbed element's size and position.

          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(element, offsetX, offsetY);
          element.style.width = `${offsetWidth}px`;
          element.style.height = `${offsetHeight}px`; //element.classList.add(drag.dragProxyCls);

          drag.dragWithin.appendChild(element);
          eventBar.classList.add('b-drag-original');

          if (drag.hideOriginalElement) {
            eventBar.classList.add('b-hidden');
          }

          return element;
        });
      } else {
        info.relatedElements = eventBarEls.slice(1);
      }

      info.relatedElStartPos = [];
      info.relatedElDragFromPos = []; // Move the selected events into a unified cascade.

      if (me.unifiedDrag) {
        // EventBarEls should animate into the cascade
        me.client.isAnimating = true;
        eventBarEls.forEach(el => {
          el.classList.add('b-drag-animation');
        });
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].onTransitionEnd({
          element: eventBarEls[1],
          property: 'transform',

          handler() {
            me.client.isAnimating = false;
            eventBarEls.forEach(el => {
              el.classList.remove('b-drag-animation');
            });
          },

          thisObj: me.client,
          once: true
        }); // Main dragged element should not look different. The relatedElements do.

        eventBarEls[0].classList.add('b-drag-main');
        let [x, y] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getTranslateXY(info.element);
        info.relatedElements.forEach((el, i) => {
          // Cache the start pos for reversion in case of invalid drag
          info.relatedElStartPos[i] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getTranslateXY(el); // Move into cascade and cache the dragFrom pos

          x += 10;
          y += 10;
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(el, x, y);
          info.relatedElDragFromPos[i] = [x, y];
        });
      } else {
        // Start pos and dragFrom pos are the same for non-unified
        info.relatedElements.forEach((el, i) => {
          info.relatedElStartPos[i] = info.relatedElDragFromPos[i] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getTranslateXY(el);
        });
      }
    }

    return dragData;
  } //endregion
  //region Constraints
  // private


  setupConstraints(constrainRegion, elRegion, tickSize, constrained) {
    const me = this,
          xTickSize = !me.showExactDropPosition && tickSize > 1 ? tickSize : 0,
          yTickSize = 0; // If `constrained` is false then we haven't specified getDateConstraint method and should constrain mouse position to scheduling area
    // else we have specified date constraints and so we should limit mouse position to smaller region inside of constrained region using offsets and width.

    if (constrained) {
      me.setXConstraint(constrainRegion.left, constrainRegion.right - elRegion.width, xTickSize);
    } // And if not constrained, release any constraints from the previous drag.
    else {
      // minX being true means allow the start to be before the time axis.
      // maxX being true means allow the end to be after the time axis.
      me.setXConstraint(true, true, xTickSize);
    }

    me.setYConstraint(constrainRegion.top, constrainRegion.bottom - elRegion.height, yTickSize);
  }

  updateYConstraint(eventRecord) {
    const me = this,
          {
      client
    } = me,
          {
      context
    } = me.drag,
          tickSize = client.timeAxisViewModel.snapPixelAmount; // If we're dragging when the vertical size is recalculated by the host grid,
    // we must update our Y constraint unless we are locked in the Y axis.

    if (context && !me.drag.lockY) {
      let constrainRegion; // This calculates a relative region which the DragHelper uses within its outerElement

      if (me.constrainDragToTimeline) {
        constrainRegion = client.getScheduleRegion(null, eventRecord);
      } // Not constraining to timeline.
      // Unusual configuration, but this must mean no Y constraining.
      else {
        me.setYConstraint(null, null, tickSize);
        return;
      }

      me.setYConstraint(constrainRegion.top, constrainRegion.bottom - context.element.offsetHeight, tickSize);
    } else {
      me.setYConstraint(null, null, tickSize);
    }
  }

  setXConstraint(iLeft, iRight, iTickSize) {
    const {
      drag
    } = this;
    drag.leftConstraint = iLeft;
    drag.rightConstraint = iRight;
    drag.minX = iLeft;
    drag.maxX = iRight;
  }

  setYConstraint(iUp, iDown, iTickSize) {
    const {
      drag
    } = this;
    drag.topConstraint = iUp;
    drag.bottomConstraint = iDown;
    drag.minY = iUp;
    drag.maxY = iDown;
  } //endregion
  //region Other stuff


  adjustStartDate(startDate, timeDiff) {
    return this.client.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), this.client.snapRelativeToEventStartDate ? startDate : false);
  }

  resolveStartEndDates(draggedElement) {
    const timeline = this.currentOverClient,
          {
      timeAxis
    } = timeline,
          proxyRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(draggedElement, timeline.timeAxisSubGridElement),
          dd = this.dragData; // Non continuous time axis will return null instead of date for a rectangle outside of the view unless
    // told to estimate date

    let {
      start: startDate,
      end: endDate
    } = timeline.getStartEndDatesFromRectangle(proxyRect, 'round', dd.duration, !timeAxis.isContinuous); // if dragging is out of timeAxis rect bounds, we will not be able to get dates

    if (startDate && endDate) {
      startDate = this.adjustStartDate(startDate, 0);

      if (!dd.startsOutsideView) {
        // Make sure we didn't target a start date that is filtered out, if we target last hour cell (e.g. 21:00) of
        // the time axis, and the next tick is 08:00 following day. Trying to drop at end of 21:00 cell should target start of next cell
        if (!timeline.timeAxis.dateInAxis(startDate, false)) {
          const tick = timeline.timeAxis.getTickFromDate(startDate);

          if (tick >= 0) {
            startDate = timeline.timeAxis.getDateFromTick(tick);
          }
        }

        endDate = startDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, dd.duration, 'ms');
      } else if (!dd.endsOutsideView) {
        startDate = endDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(endDate, -dd.duration, 'ms');
      }
    }

    return {
      startDate,
      endDate
    };
  } //endregion
  //region Dragtip

  /**
   * Gets html to display in tooltip while dragging event. Uses clockTemplate to display start & end dates.
   */


  getTipHtml() {
    const me = this,
          {
      dragData,
      client
    } = me,
          {
      startDate,
      endDate,
      draggedEntities
    } = dragData,
          startText = client.getFormattedDate(startDate),
          endText = client.getFormattedEndDate(endDate, startDate),
          {
      valid,
      message,
      element,
      dragProxy
    } = dragData.context,
          tipTarget = dragProxy ? dragProxy.firstChild : element,
          dragged = draggedEntities[0],
          // Scheduler always drags assignments
    timeSpanRecord = dragged.isTask ? dragged : dragged.event,
          // TODO REMOVE dragTipTemplate FOR 5.0
    tooltipTemplate = me.tooltipTemplate || me.dragTipTemplate; // Keep align target up to date in case of derendering the target when
    // dragged outside render window, and re-entry into the render window.

    me.tip.lastAlignSpec.target = tipTarget;
    return tooltipTemplate({
      valid,
      startDate,
      endDate,
      startText,
      endText,
      dragData,
      message: message || '',
      [client.scheduledEventName + 'Record']: timeSpanRecord,
      startClockHtml: me.clockTemplate.template({
        date: startDate,
        text: startText,
        cls: 'b-sch-tooltip-startdate'
      }),
      endClockHtml: timeSpanRecord.isMilestone ? '' : me.clockTemplate.template({
        date: endDate,
        text: endText,
        cls: 'b-sch-tooltip-enddate'
      })
    });
  } //endregion
  //region Configurable
  // Constrain to time slot means lockX if we're horizontal, otherwise lockY


  set constrainDragToTimeSlot(value) {
    const axis = this.client.isHorizontal ? 'lockX' : 'lockY';
    this._constrainDragToTimeSlot = value;

    if (this.drag) {
      this.drag[axis] = value;
    }
  }

  get constrainDragToTimeSlot() {
    return this._constrainDragToTimeSlot;
  } // Constrain to resource means lockY if we're horizontal, otherwise lockX


  updateConstrainDragToResource(constrainDragToResource) {
    const me = this;

    if (me.drag) {
      const {
        constrainDragToTimeSlot
      } = me,
            {
        isHorizontal
      } = me.client;

      if (constrainDragToResource) {
        me.constrainDragToTimeline = false;
      }

      me.drag.lockY = isHorizontal ? constrainDragToResource : constrainDragToTimeSlot;
      me.drag.lockX = isHorizontal ? constrainDragToTimeSlot : constrainDragToResource;
    }
  }

  updateConstrainDragToTimeline(constrainDragToTimeline) {
    if (!this.isConfiguring) {
      Object.assign(this.drag, {
        cloneTarget: !constrainDragToTimeline,
        dragWithin: constrainDragToTimeline ? null : document.body,
        scrollManager: constrainDragToTimeline ? this.client.scrollManager : null
      });
    }
  } //endregion
  //region Product specific, implemented in subclasses


  getElementFromContext(context) {
    return context.grabbed || context.dragProxy || context.element;
  } // Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.


  getRelatedRecords(record) {
    return [];
  }

  getMinimalDragData(info, event) {
    // Can be overridden in subclass
    return {};
  } // Check if element can be dropped at desired location


  isValidDrop(dragData) {
    throw new Error('Implement in subclass');
  } // Similar to the fn above but also calls validatorFn


  checkDragValidity(dragData) {
    throw new Error('Implement in subclass');
  } // Update records being dragged


  updateRecords(context) {
    throw new Error('Implement in subclass');
  } // Determine if an element can be dragged


  isElementDraggable(el, event) {
    throw new Error('Implement in subclass');
  } // Get coordinate for correct axis


  getCoordinate(record, element, coord) {
    throw new Error('Implement in subclass');
  } // Product specific drag data


  setupProductDragData(info) {
    throw new Error('Implement in subclass');
  } // Product specific data in drag context


  getProductDragContext(dd) {
    throw new Error('Implement in subclass');
  }

  getRecordElement(record) {
    throw new Error('Implement in subclass');
  } //endregion


}
DragBase._$name = 'DragBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/DragCreateBase.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/feature/base/DragCreateBase.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragCreateBase; });
/* harmony import */ var _EventResize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
var productName = 'gantt';




/**
 * @module Scheduler/feature/base/DragCreateBase
 */

const getDragCreateDragDistance = function (event) {
  var _this$source, _this$source$client$f;

  // Do not allow the drag to begin if the taskEdit feature (if present) is in the process
  // of canceling. We must wait for it to have cleaned up its data manipulations before
  // we can add the new, drag-created record
  if ((_this$source = this.source) !== null && _this$source !== void 0 && (_this$source$client$f = _this$source.client.features.taskEdit) !== null && _this$source$client$f !== void 0 && _this$source$client$f._canceling) {
    return false;
  }

  return _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDistanceBetween(this.startEvent, event);
};
/**
 * Base class for EventDragCreate (Scheduler) and TaskDragCreate (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 */


class DragCreateBase extends _EventResize_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get configurable() {
    return {
      /**
       * true to show a time tooltip when dragging to create a new event
       * @config {Boolean}
       * @default
       */
      showTooltip: true,

      /**
       * Number of pixels the drag target must be moved before dragging is considered to have started. Defaults to 2.
       * @config {Number}
       * @default
       */
      dragTolerance: 2,
      // used by gantt to only allow one task per row
      preventMultiple: false,
      dragTouchStartDelay: 300,

      /**
       * `this` reference for the validatorFn
       * @config {Object}
       */
      validatorFnThisObj: null,

      /**
       * CSS class to add to proxy used when creating a new event
       * @config {String}
       * @default
       * @private
       */
      proxyCls: 'b-sch-dragcreator-proxy',
      tipTemplate: data => `
                <div class="b-sch-tip-${data.valid ? 'valid' : 'invalid'}">
                    ${data.startClockHtml}
                    ${data.endClockHtml}
                    <div class="b-sch-tip-message">${data.message}</div>
                </div>
            `,
      dragActiveCls: 'b-dragcreating'
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['render', 'onEventDataGenerated'],
      before: ['onElementContextMenu']
    };
  }

  construct(scheduler, config) {
    if ((config === null || config === void 0 ? void 0 : config.showTooltip) === false) {
      config.tip = null;
    }

    super.construct(...arguments);
  }

  changeValidatorFn(validatorFn) {
    // validatorFn property is used by the EventResize base to validate each mousemove
    // We change the property name to createValidatorFn
    this.createValidatorFn = validatorFn;
  }

  render() {
    const me = this,
          {
      client
    } = me; // Set up elements and listeners

    me.dragRootElement = me.dropRootElement = client.timeAxisSubGridElement; // Drag only in time dimension

    me.dragLock = client.isVertical ? 'y' : 'x';
  }

  onDragEndSwitch(context) {
    const {
      client
    } = this,
          {
      enableEventAnimations
    } = client,
          {
      eventRecord,
      draggingEnd
    } = context,
          horizontal = this.dragLock === 'x',
          {
      initialDate
    } = this.dragging; // Setting the new opposite end should not animate

    client.enableEventAnimations = false; // Zero duration at the moment of the flip

    eventRecord.set({
      startDate: initialDate,
      endDate: initialDate
    }); // We're switching to dragging the start

    if (draggingEnd) {
      Object.assign(context, {
        endDate: initialDate,
        toSet: 'startDate',
        otherEnd: 'endDate',
        setMethod: 'setStartDate',
        edge: horizontal ? 'left' : 'top'
      });
    } else {
      Object.assign(context, {
        startDate: initialDate,
        toSet: 'endDate',
        otherEnd: 'startDate',
        setMethod: 'setEndDate',
        edge: horizontal ? 'right' : 'bottom'
      });
    }

    context.draggingEnd = this.draggingEnd = !draggingEnd;
    client.enableEventAnimations = enableEventAnimations;
  }

  beforeDrag(drag) {
    const result = super.beforeDrag(drag); // Superclass's handler may also veto

    if (result !== false) {
      if (this.preventMultiple && !this.isRowEmpty(drag.rowRecord) || this.disabled) {
        return false;
      }
    }

    return result;
  }

  startDrag(drag) {
    const result = super.startDrag(drag); // Returning false means operation is aborted.

    if (result !== false) {
      this.client.trigger('dragCreateStart', {
        proxyElement: drag.element
      }); // We are always dragging the exact edge of the event element.

      drag.context.offset = 0;
      drag.context.oldValue = drag.mousedownDate;
    }

    return result;
  } // Used by our EventResize superclass to know whether the drag point is the end or the beginning.


  isOverEndHandle() {
    return this.draggingEnd;
  }

  setupDragContext(event) {
    var _event$target$closest, _event$target;

    const {
      client
    } = this; // Only mousedown on an empty cell can initiate drag-create

    if ((_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `.${client.timeAxisColumn.cellCls}`)) {
      const resourceRecord = client.resolveResourceRecord(event); // And there must be a resource backing the cell.

      if (resourceRecord && !resourceRecord.isSpecialRow) {
        // Skip the EventResize's setupDragContext. We want the base one.
        const result = Object(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_3__["default"])().prototype.setupDragContext.call(this, event),
              scrollables = [];

        if (client.isVertical) {
          scrollables.push({
            element: client.scrollable.element,
            direction: 'vertical'
          });
        } else {
          scrollables.push({
            element: client.timeAxisSubGrid.scrollable.element,
            direction: 'horizontal'
          });
        }

        result.scrollManager = client.scrollManager;
        result.monitoringConfig = {
          scrollables
        };
        result.resourceRecord = result.rowRecord = resourceRecord; // We use a special method to get the distance moved.
        // If the TaskEdit feature is still in its canceling phase, then
        // it returns false which inhibits the start of the drag-create
        // until the cancelation is complete.

        result.getDistance = getDragCreateDragDistance;
        return result;
      }
    }
  }

  async dragDrop({
    context,
    event
  }) {
    var _this$tip;

    // Set the start/end date, whichever we were dragging
    // to the correctly rounded value before updating.
    context[context.toSet] = context.snappedDate;
    const {
      client
    } = this,
          {
      startDate,
      endDate,
      eventRecord
    } = context,
          {
      generation
    } = eventRecord;
    let modified;
    (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.hide(); // Handle https://github.com/bryntum/support/issues/3210.
    // The issue arises when the mouseup arrives very quickly and the commit kicked off
    // at event add has not yet completed. If it now completes *after* we finalize
    // the drag, it will reset the event to its initial state.
    // If that commit has in fact finished, this will be a no-op

    await client.project.commitAsync(); // If the above commit in fact reset the event back to the initial state, we have to
    // force the event rendering to bring it back to the currently known context state.

    if (eventRecord.generation !== generation) {
      context.eventRecord[context.toSet] = context.oldValue;
      context.eventRecord[context.toSet] = context[context.toSet];
    }

    context.valid = startDate && endDate && endDate - startDate > 0 && // Input sanity check
    context[context.toSet] - context.oldValue && // Make sure dragged end end changed
    context.valid !== false;

    if (context.valid) {
      // Seems to be a valid drag-create operation, ask outside world if anyone wants to take control over the finalizing,
      // to show a confirm dialog prior to finalizing the create.
      client.trigger('beforeDragCreateFinalize', {
        context,
        event,
        proxyElement: context.element
      });
      modified = true;
    } // If a handler has set the async flag, it means that they are going to finalize
    // the operation at some time in the future, so we should not call it.


    if (!context.async) {
      await context.finalize(modified);
    }
  }

  updateDragTolerance(dragTolerance) {
    this.dragThreshold = dragTolerance;
  } //region Tooltip


  changeTip(tip, oldTip) {
    return super.changeTip(!tip || tip.isTooltip ? tip : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
      id: `${this.client.id}-drag-create-tip`
    }, tip), oldTip);
  } //endregion
  //region Finalize (create EventModel)


  async finalize(doCreate) {
    const me = this.owner,
          context = this,
          completeFinalization = () => {
      if (!me.isDestroyed) {
        me.client.trigger('afterDragCreate', {
          proxyElement: context.element
        });
        me.cleanup(context);
      }
    };

    if (doCreate) {
      // Call product specific implementation
      await me.finalizeDragCreate(context);
      completeFinalization();
    } // Aborting without going ahead with create - we must deassign and remove the event
    else {
      var _me$onAborted;

      (_me$onAborted = me.onAborted) === null || _me$onAborted === void 0 ? void 0 : _me$onAborted.call(me, context);
      completeFinalization();
    }
  }

  async finalizeDragCreate(context) {
    // EventResize base class applies final changes to the event record
    await this.internalUpdateRecord(context, context.eventRecord);
    this.client.trigger('dragCreateEnd', {
      eventRecord: context.eventRecord,
      newEventRecord: context.eventRecord,
      resourceRecord: context.resourceRecord,
      event: context.event,
      eventElement: context.element,
      proxyElement: context.element
    });
  }

  cleanup(context) {
    var _this$tip2;

    const {
      client
    } = this,
          {
      eventRecord
    } = context; // Base class's cleanup is not called, we have to clear this flag.
    // The isCreating flag is only set if the event is to be handed off to the
    // eventEdit feature and that feature then has responsibility for clearing it.

    eventRecord.meta.isResizing = false;
    client.endListeningForBatchedUpdates();
    (_this$tip2 = this.tip) === null || _this$tip2 === void 0 ? void 0 : _this$tip2.hide();
    client.element.classList.remove(...this.dragActiveCls.split(' '));
  } //endregion
  //region Events

  /**
   * Prevent right click when drag creating
   * @returns {Boolean}
   * @private
   */


  onElementContextMenu() {
    if (this.proxy) {
      return false;
    }
  }

  prepareCreateContextForFinalization(createContext, event, finalize, async = false) {
    return Object.assign({}, createContext, {
      async,
      event,
      finalize
    });
  } // Apply drag create "proxy" styling


  onEventDataGenerated(renderData) {
    var _this$dragging, _this$dragging$contex;

    if (((_this$dragging = this.dragging) === null || _this$dragging === void 0 ? void 0 : (_this$dragging$contex = _this$dragging.context) === null || _this$dragging$contex === void 0 ? void 0 : _this$dragging$contex.eventRecord) === renderData.eventRecord) {
      // Allow custom styling for drag creation "proxy"
      renderData.wrapperCls['b-sch-dragcreating'] = true; // Styling when drag create will be aborted on drop (because it would yield zero duration)

      renderData.wrapperCls['b-too-narrow'] = this.dragging.context.tooNarrow;
    }
  } //endregion
  //region Product specific, implemented in subclasses
  // Empty implementation here. Only base EventResize class triggers this


  triggerBeforeResize() {} // Empty implementation here. Only base EventResize class triggers this


  triggerEventResizeStart() {}

  checkValidity(context, event) {
    throw new Error('Implement in subclass');
  }

  triggerDragCreateEnd(newRecord, context) {
    throw new Error('Implement in subclass');
  }

  handleBeforeDragCreate(dateTime, event) {
    throw new Error('Implement in subclass');
  }

  isRowEmpty(rowRecord) {
    throw new Error('Implement in subclass');
  } //endregion


}
DragCreateBase._$name = 'DragCreateBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/EditBase.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/feature/base/EditBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EditBase; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_Config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/Config.js */ "./lib/Core/Config.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';







/**
 * @module Scheduler/feature/base/EditBase
 */

const DH = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      makeDate = fields => {
  // single field, update record directly
  if (fields.length === 1) return fields[0].value; // two fields, date + time
  else if (fields.length === 2) {
    const [date, time] = fields[0] instanceof _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? fields : fields.reverse(),
          dateValue = DH.parse(date.value);

    if (dateValue) {
      dateValue.setHours(time.value.getHours(), time.value.getMinutes(), time.value.getSeconds(), time.value.getMilliseconds());
    } // Clone to not end up sharing dates


    return dateValue ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(dateValue) : null;
  } // shouldn't happen...

  return null;
},
      copyTime = (dateTo, dateFrom) => {
  const d = new Date(dateTo.getTime());
  d.setHours(dateFrom.getHours(), dateFrom.getMinutes());
  return d;
},
      adjustEndDate = (startDate, startTime, me) => {
  // The end datetime just moves in response to the changed start datetime, keeping the same duration.
  if (startDate && startTime && me.endDateField && me.endTimeField) {
    const newEndDate = DH.add(copyTime(me.startDateField.value, me.startTimeField.value), me.eventRecord.durationMS, 'milliseconds');
    me.endDateField.value = newEndDate;
    me.endTimeField.value = DH.clone(newEndDate);
  }
};
/**
 * Base class for EventEdit (Scheduler) and TaskEdit (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 */


class EditBase extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get configurable() {
    return {
      /**
       * Deprecated. Use the `editorConfig` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             editorConfig : {
       *                 autoClose : false,
       *                 modal     : true
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Boolean}
       * @default
       * @category Editor
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      autoClose: true,

      /**
       * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
       * @config {Boolean}
       * @default
       * @category Editor
       */
      saveAndCloseOnEnter: true,
      triggerEvent: null,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit : {
       *             editorConfig : {
       *                 bbar : {
       *                     items : {
       *                         deleteButton : false
       *                     }
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Boolean}
       * @default
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      showDeleteButton: true,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit : {
       *             items : {
       *                 nameField : {
       *                     hidden : true
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Boolean}
       * @default
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-items}:
       */
      showNameField: true,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit : {
       *             timeFormat : 'HH:mm',
       *             items      : {
       *                 startTimeField : {
       *                     // We use 24 hour clock: use less space
       *                     flex   : '1 0 30%'
       *                 },
       *                 endTimeField : {
       *                     flex   : '1 0 30%'
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      startTimeConfig: null,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit : {
       *             items : {
       *                 startDateField : {
       *                     // Allow click back and forward by 1 day
       *                     step: '1d'
       *                 },
       *                 endDateField : {
       *                     step: '1d'
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      startDateConfig: null,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             timeFormat : 'HH:mm',
       *             items : {
       *                 startTimeField : {
       *                     // We use 24 hour clock: use less space
       *                     flex   : '1 0 30%'
       *                 },
       *                 endTimeField : {
       *                     flex   : '1 0 30%'
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      endTimeConfig: null,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             items : {
       *                 startDateField : {
       *                     // Allow click back and forward by 1 day
       *                     step: '1d'
       *                 },
       *                 endDateField : {
       *                     step: '1d'
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor widgets
       * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
       */
      endDateConfig: null,

      /**
       * This config parameter is passed to the `startDateField` and `endDateField` constructor.
       * @config {String}
       * @default
       * @category Editor widgets
       */
      dateFormat: 'L',
      // date format that uses browser locale

      /**
       * This config parameter is passed to the `startTimeField` and `endTimeField` constructor.
       * @config {String}
       * @default
       * @category Editor widgets
       */
      timeFormat: 'LT',
      // date format that uses browser locale

      /**
       * Default editor configuration, which widgets it shows etc.
       *
       * This is the entry point into configuring any aspect of the editor.
       *
       * The {@link Core.widget.Container#config-items} configuration of a Container
       * is *deeply merged* with its default `items` value. This means that you can specify
       * an `editorConfig` object which configures the editor, or widgets inside the editor:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             editorConfig : {
       *                 autoClose : false,
       *                 modal     : true,
       *                 cls       : 'editor-widget-cls',
       *                 items : {
       *                     resourceField : {
       *                         hidden : true
       *                     },
       *                     // Add our own event owner field at the top of the form.
       *                     // Weight -100 will make it sort top the top.
       *                     ownerField : {
       *                         weight : -100,
       *                         type   : 'usercombo',
       *                         name   : 'owner',
       *                         label  : 'Owner'
       *                     }
       *                 },
       *                 bbar : {
       *                     items : {
       *                         deleteButton : false
       *                     }
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Object}
       * @category Editor
       */
      editorConfig: null,

      /**
       * Deprecated. Use the `items` config:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             items : {
       *                 owner : {
       *                     weight : -100, // Will sort above system-supplied fields which are weight 0
       *                     type   : 'usercombo',
       *                     name   : 'owner',
       *                     label  : 'Owner'
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {String|Object[]}
       * @category Editor widgets
       * @deprecated 4.0.0 Use the {@link #config-items} config
       */
      extraItems: null,

      /**
       * An object to merge with the provided items config of the editor to override the
       * configuration of provided fields, or add new fields.
       *
       * Example:
       * ```javascript
       * const scheduler = new Scheduler({
       *     features : {
       *         eventEdit  : {
       *             items : {
       *                 // Merged with provided config of the resource field
       *                 resourceField : {
       *                     label : 'Calendar'
       *                 },
       *                 owner : {
       *                     weight : -100, // Will sort above system-supplied fields which are weight 0
       *                     type   : 'usercombo',
       *                     name   : 'owner',
       *                     label  : 'Owner'
       *                 }
       *             }
       *         }
       *     }
       * });
       *```
       *
       * The provided fields are called
       *  - `nameField`
       *  - `resourceField`
       *  - `startDateField`
       *  - `startTimeField`
       *  - `endDateField`
       *  - `endTimeField`
       *  - `recurrenceCombo`
       *  - `editRecurrenceButton`
       * @config {Object}
       * @category Editor widgets
       */
      items: null,

      /**
       * The week start day used in all date fields of the feature editor form by default.
       * 0 means Sunday, 6 means Saturday.
       * Defaults to the locale's week start day.
       * @config {Number}
       */
      weekStartDay: null
    };
  } //endregion
  //region Init & destroy


  construct(client, config) {
    const me = this;
    client.eventEdit = me;
    super.construct(client, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
      weekStartDay: client.weekStartDay
    }, config));
    me.clientListenersDetacher = client.on({
      [me.triggerEvent]: 'onActivateEditor',
      dragCreateEnd: 'onDragCreateEnd',
      // Not fired at the Scheduler level.
      // Calendar, which inherits this, implements this event.
      eventAutoCreated: 'onEventAutoCreated',
      thisObj: me
    });
  }

  doDestroy() {
    var _this$editor;

    this.clientListenersDetacher();
    (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();
    super.doDestroy();
  } //endregion
  //region Editing


  changeEditorConfig(editorConfig) {
    // extraItems is deprecated
    const {
      items,
      extraItems
    } = this; // Merge extraItems in either format into a copy of the default editorConfig.

    if (extraItems) {
      editorConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].clone(editorConfig);
      editorConfig = this.insertExtraWidgetsIntoDefaultWidgets(editorConfig);
    } // Merge items which is an Object with the default editorConfig's items
    else if (items) {
      editorConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].clone(editorConfig);
      editorConfig.items = _Core_Config_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge(items, editorConfig.items);
    }

    return editorConfig;
  }

  changeItems(items) {
    this.cleanItemsConfig(items);
    return items;
  } // Remove any items configured as === true which just means default config options


  cleanItemsConfig(items) {
    for (const ref in items) {
      const itemCfg = items[ref];

      if (itemCfg === true) {
        delete items[ref];
      } else if (itemCfg !== null && itemCfg !== void 0 && itemCfg.items) {
        this.cleanItemsConfig(itemCfg.items);
      }
    }
  }
  /**
   * Insert extra fields into default Editor fields according to specific rules:
   * - If no index provided insert them into `extraItems` placeholder (or at the end if not);
   * - If index provided sort ASC and insert one by one, but only after no-index fields are inserted;
   * - If `extraItems` placeholder exists, don't take widgets that go after it into account;
   * @private
   */


  insertExtraWidgetsIntoDefaultWidgets(editorConfig) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Scheduler', '5.0.0', 'extraItems replaced by items in EditFeature.');
    const me = this,
          {
      extraItems
    } = me,
          {
      items
    } = editorConfig,
          extraItemsAsArray = Array.isArray(extraItems) ? extraItems : extraItems && Object.values(extraItems);

    if (!extraItems || !Object.keys(extraItemsAsArray).length) {
      return editorConfig;
    } // If they still use index instead of weight, we honour it for now.


    const hasIndex = Object.values(extraItemsAsArray).some(i => 'index' in i);

    if (hasIndex) {
      const extraItemsAsArray = Array.isArray(extraItems) ? extraItems : extraItems && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformNamedObjectToArray(extraItems);
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Scheduler', '5.0.0', 'index in extraItems replaced by weight to sort editor items'); // items needs to be an array to have extra items inserted at an index.

      let itemsAsArray = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformNamedObjectToArray(items),
          lastItem = itemsAsArray[itemsAsArray.length - 1]; // Find default extra widgets position

      let index = itemsAsArray.findIndex(widget => widget.type === 'extraItems'),
          tail; // If extra widgets placeholder exists

      if (index > -1) {
        // Remove extra widgets placeholder from its position
        itemsAsArray.splice(index, 1); // Backup everything that goes after extra widgets placeholder, like Save/Delete/Cancel buttons

        tail = itemsAsArray.splice(index);
      } // Split extra widgets on 2 parts: those which have index and those which haven't


      const withIndex = extraItemsAsArray.filter(widget => widget.index >= 0),
            withoutIndex = extraItemsAsArray.filter(widget => !(widget.index >= 0)); // Add those without index to the end of the default widgets

      withoutIndex.forEach((item, index) => item.weight = lastItem.weight + index * 100);
      itemsAsArray = itemsAsArray.concat(withoutIndex); // Sort those which have index in ASC order, so we insert fields in series

      withIndex.sort((widgetA, widgetB) => widgetA.index - widgetB.index); // And now insert extra widgets at their individually specified index

      withIndex.forEach(widget => {
        const previousWidget = itemsAsArray[Math.min(widget.index, itemsAsArray.length) - 1];
        widget.weight = previousWidget ? previousWidget.weight + 1 : -100;
        itemsAsArray.splice(widget.index, 0, widget);
      });

      if (tail && tail.length) {
        // Return backuped fields to the end of the widgets
        itemsAsArray = itemsAsArray.concat(tail);
      } // Convert it back to object form.


      editorConfig.items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformArrayToNamedObject(itemsAsArray);
    } // Merge object form of extraItems into editorConfig's items
    else {
      // Default is to append so make high weight
      let weight = 900;

      for (const item of Array.isArray(extraItems) ? extraItems : Object.values(extraItems)) {
        if (!item.ref) {
          item.ref = item.id;
        }

        item.weight = weight += 100;
      }

      editorConfig.items = _objectSpread(_objectSpread({}, items), Array.isArray(extraItems) ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].transformArrayToNamedObject(extraItems) : extraItems);
    }

    return editorConfig;
  }

  onDatesChange(params) {
    const me = this,
          field = params.source,
          value = params.value;

    switch (field.ref) {
      case 'startDateField':
        me.startTimeField && adjustEndDate(value, me.startTimeField.value, me);
        break;

      case 'startTimeField':
        me.startDateField && adjustEndDate(me.startDateField.value, value, me);
        break;
    } // End date can never be less than start date


    if (me.startDateField && me.endDateField) {
      me.endDateField.min = me.startDateField.value;
    }

    if (me.endTimeField) {
      var _me$startDateField, _me$endDateField;

      // If the event starts and ends on the same day, the time fields need
      // to have their min and max set against each other.
      if (DH.isEqual(DH.clearTime((_me$startDateField = me.startDateField) === null || _me$startDateField === void 0 ? void 0 : _me$startDateField.value), DH.clearTime((_me$endDateField = me.endDateField) === null || _me$endDateField === void 0 ? void 0 : _me$endDateField.value))) {
        me.endTimeField.min = me.startTimeField.value;
      } else {
        me.endTimeField.min = null;
      }
    }
  } //endregion
  //region Save


  async save() {
    throw new Error('Implement in subclass');
  }

  get values() {
    const me = this,
          {
      editor
    } = me,
          startFields = [],
          endFields = [],
          values = {};
    editor.eachWidget(widget => {
      var _editor$widgetMap$rec;

      const name = widget.name; // If the widget is part of the recurrence editor, we don't gather it.

      if (!name || widget.hidden || widget.up(w => w === me.recurrenceEditor)) {
        return;
      }

      switch (name) {
        case 'startDate':
          startFields.push(widget);
          break;

        case 'endDate':
          endFields.push(widget);
          break;

        case 'resource':
          values[name] = widget.record;
          break;

        case 'recurrenceRule':
          // If recurrence set to null, completely clear the recurrenceRule.
          // Otherwise it will still be perceived as recurring with the rule 'FREQ=none'
          values[name] = ((_editor$widgetMap$rec = editor.widgetMap.recurrenceCombo) === null || _editor$widgetMap$rec === void 0 ? void 0 : _editor$widgetMap$rec.value) === 'none' ? '' : widget.value;
          break;

        default:
          values[name] = widget.value;
      }
    }, true); // if is changing from not allDay to allDay should consider time fields to not change them on makeDate

    if (values.allDay && !me.eventRecord.allDay) {
      startFields.push(me.startTimeField);
      endFields.push(me.endTimeField);
    } // Handle fields being configured away


    if (startFields.length) {
      values.startDate = makeDate(startFields);
    }

    if (endFields.length) {
      values.endDate = makeDate(endFields);
    } // Since there is no duration field in the editor,
    // we don't need to recalc duration value on each date change.
    // It's enough to return correct duration value in `values`,
    // so the record will get updated with the correct data.


    if ('startDate' in values && 'endDate' in values) {
      values.duration = DH.diff(values.startDate, values.endDate, me.editor.record.durationUnit, true);
    }

    return values;
  }
  /**
   * Template method, intended to be overridden. Called before the event record has been updated.
   * @param {Scheduler.model.EventModel} eventRecord The event record
   *
   **/


  onBeforeSave(eventRecord) {}
  /**
   * Template method, intended to be overridden. Called after the event record has been updated.
   * @param {Scheduler.model.EventModel} eventRecord The event record
   *
   **/


  onAfterSave(eventRecord) {}
  /**
   * Updates record being edited with values from the editor
   * @private
   */


  updateRecord(record) {
    const {
      values
    } = this; // Clean resourceId / resources out of values when using assignment store, it will handle the assignment

    if (this.assignmentStore) {
      delete values.resource;
    }

    return record.set(values);
  } //endregion
  //region Events


  onBeforeEditorShow() {
    const {
      eventRecord,
      editor
    } = this.editingContext,
          {
      nameField
    } = editor.widgetMap; // Editing new event. Make sure user doesn't have to clear the input field.
    // Record field value still should be there because a rendered event block
    // looks bad with no text in it.
    // nameField may have been configured away.

    if (nameField && eventRecord.isCreating) {
      // Avoid initial invalid because required state.
      editor._isSettingValues = true;
      nameField.value = '';
      editor._isSettingValues = false; // Show new event text as a placeholder

      nameField._configuredPlaceholder = nameField.placeholder;
      nameField.placeholder = eventRecord.name;
    }
  }

  resetEditingContext() {
    const me = this,
          {
      eventRecord,
      client
    } = me,
          {
      eventStore
    } = client,
          {
      nameField
    } = me.editor.widgetMap; // This will remove the record from the store, *and* from the added bag, so no sync will take place.

    if (eventRecord.isCreating) {
      // Ensure that during the engine's async processing of the remove, the element is non-interactive.
      // Mousedown on the just-created element itself passes through here, and the immediate mouseup
      // after that instigates a click which will find no corresponding event.
      if (client.isTimelineBase) {
        var _me$editingContext$ev;

        (_me$editingContext$ev = me.editingContext.eventElement) === null || _me$editingContext$ev === void 0 ? void 0 : _me$editingContext$ev.closest('[data-event-id]').classList.add('b-released');
      }

      eventStore.remove(eventRecord); // Clear isCreating *after* removal.
      // Store doesn't register as a removed record if isCreating is set

      eventRecord.isCreating = false;
    } // Revert any placeholder that we may have set
    // nameField may have been configured away.


    if (nameField) {
      nameField.placeholder = nameField._configuredPlaceholder;
    }

    me.targetEventElement = null;
    me.client.element.classList.remove('b-eventeditor-editing');
  }

  onPopupKeyDown({
    event
  }) {
    const me = this;

    if (!me.readOnly && event.key === 'Enter' && me.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
      // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
      event.preventDefault(); // If enter key was hit in an input element of a start field, need to adjust end date fields (the same way as if #onDatesChange handler was called)

      if (event.target.name === 'startDate') {
        adjustEndDate(me.startDateField.value, me.startTimeField.value, me);
      }

      me.onSaveClick();
    }
  }

  async onSaveClick() {
    // TODO add new API on Container: blurFocusedField which manages this scenario
    // of blurring active field just before hiding
    this.editor.focus();
    const saved = await this.save();

    if (saved) {
      this.editor.close();
    }

    return saved;
  }

  async onDeleteClick() {
    const removed = await this.deleteEvent();

    if (removed) {
      // We expect deleteEvent will trigger close if autoClose is true and focus has moved out,
      // otherwise need to call it manually
      if (!this.editor.autoClose || this.editor.containsFocus) {
        this.editor.close();
      }
    }
  }

  onCancelClick() {
    this.editor.close();
  } //endregion


}
EditBase._$name = 'EditBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js":
/*!**************************************************************!*\
  !*** ./lib/Scheduler/feature/base/ResourceTimeRangesBase.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangesBase; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
var productName = 'gantt';


/**
 * @module Scheduler/feature/base/ResourceTimeRangesBase
 */

/**
 * Abstract base class for ResourceTimeRanges and ResourceNonWorkingTime features.
 * You should not use this class directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

class ResourceTimeRangesBase extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Config
  static get configurable() {
    return {
      /**
       * Specify value to use for the tabIndex attribute of range elements
       * @config {Number}
       * @default
       */
      tabIndex: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['getEventsToRender', 'onEventDataGenerated', 'noFeatureElementsInAxis']
    };
  } // Let Scheduler know if we have ResourceTimeRanges in view or not


  noFeatureElementsInAxis() {
    const {
      timeAxis
    } = this.client;
    return !this.needsRefresh && this.store && !this.store.storage.values.some(t => timeAxis.isTimeSpanInAxis(t));
  } //endregion
  //region Init


  doDisable(disable) {
    if (this.client.isPainted) {
      this.client.refresh();
    }

    super.doDisable(disable);
  }

  updateTabIndex() {
    if (!this.isConfiguring) {
      this.client.refresh();
    }
  } //endregion


  getEventsToRender(resource, events) {
    throw new Error('Implement in subclass');
  } // Called for each event during render, allows manipulation of render data. Adjust any resource time ranges
  // (chained function from Scheduler)


  onEventDataGenerated(renderData) {
    const me = this,
          {
      eventRecord,
      iconCls
    } = renderData;

    if (me.shouldInclude(eventRecord)) {
      if (me.client.isVertical) {
        renderData.width = me.client.resourceColumnWidth;
      } else {
        renderData.top = 0;
      } // Flag that we should fill entire row/col


      renderData.fillSize = true; // Add our own cls

      renderData.wrapperCls[me.rangeCls] = 1;
      renderData.wrapperCls[`b-sch-color-${eventRecord.timeRangeColor}`] = eventRecord.timeRangeColor; // Add label

      renderData.eventContent.text = eventRecord.name;
      renderData.children.push(renderData.eventContent); // Allow configuring tabIndex

      renderData.tabIndex = me.tabIndex != null ? String(me.tabIndex) : null; // Add icon

      if ((iconCls === null || iconCls === void 0 ? void 0 : iconCls.length) > 0) {
        renderData.children.unshift({
          tag: 'i',
          className: iconCls.toString()
        });
      } // Event data for DOMSync comparison


      renderData.eventId = me.generateElementId(eventRecord);
    }
  }
  /**
   * Generates ID from the passed time range record
   * @param {Scheduler.model.TimeSpan} record
   * @returns {String} Generated ID for the DOM element
   * @internal
   */


  generateElementId(record) {
    return record.domId;
  }

  shouldInclude(eventRecord) {
    throw new Error('Implement in subclass');
  } // Called when a ResourceTimeRangeModel is manipulated, relays to Scheduler#onInternalEventStoreChange which updates to UI


  onStoreChange(event) {
    // Edge case for scheduler not using any events, it has to refresh anyway to get rid of ResourceTimeRanges
    if (event.action === 'removeall' || event.action === 'dataset') {
      this.needsRefresh = true;
    }

    this.client.onInternalEventStoreChange(event);
    this.needsRefresh = false;
  }

} // No feature based styling needed, do not add a cls to Scheduler

ResourceTimeRangesBase.featureClass = '';
ResourceTimeRangesBase._$name = 'ResourceTimeRangesBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/feature/base/TimeSpanMenuBase.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpanMenuBase; });
/* harmony import */ var _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
var productName = 'gantt';

/**
 * @module Scheduler/feature/base/TimeSpanMenuBase
 */

/**
 * Abstract base class used by other context menu features which show the context menu for TimeAxis.
 * Using this class you can make sure the menu expects the target to disappear,
 * since it can be scroll out of the scheduling zone.
 *
 * Features that extend this class are:
 *  * {@link Scheduler/feature/EventMenu EventMenu};
 *  * {@link Scheduler/feature/ScheduleMenu ScheduleMenu};
 *  * {@link Scheduler/feature/TimeAxisHeaderMenu TimeAxisHeaderMenu};
 *
 * @extends Core/feature/base/ContextMenuBase
 * @abstract
 */

class TimeSpanMenuBase extends _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}
TimeSpanMenuBase._$name = 'TimeSpanMenuBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js":
/*!*********************************************************************!*\
  !*** ./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpanRecordContextMenuBase; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';







/**
 * @module Scheduler/feature/base/TimeSpanRecordContextMenuBase
 */
// This is a version of what Containers do, except that we have to apply our namedItems
// all the way down any configured menu hierarchy, and the resulting structure must
// be available *before* menu instantiation for the processItems method to interrogate.

function applyNamedItems(items, namedItems) {
  for (const ref in items) {
    let item = items[ref];

    if (item) {
      if (ref in namedItems) {
        item = items[ref] = typeof item === 'object' ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(namedItems[ref]), item) : namedItems[ref];
      } // Our namedItems must apply all the way down any descendant menus.
      // Extract menu here because it may have been applied by a namedItem.


      const menu = item.menu;

      if (menu) {
        applyNamedItems('items' in menu ? menu.items : menu, namedItems);
      }
    }
  }
}

;
/**
 * DEPRECATED: This class is deprecated since v4.0.0.
 * It is **not** used by our features anymore and remains here only for backward compatibility.
 * If you already extended this class please re-implement it utilizing our new
 * {@link Scheduler.feature.base.TimeSpanMenuBase } abstract base class.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 * @deprecated 4.0.0
 */

class TimeSpanRecordContextMenuBase extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * This is a preconfigured set of {@link Core.widget.Container#config-namedItems} used to create the default
       * context menu.
       * @config {Object}
       */
      defaultItems: null,

      /**
       * An {@link Core.widget.Menu Menu} items object containing named child menu items
       * to apply to the feature's provided context menu, see {@link #config-defaultItems}.
       *
       * This may add extra items as below, but may also remove any of the {@link #config-defaultItems}
       * by configuring the name of the item as `false`
       *
       * ```javascript
       * features : {
       *     taskMenu : { // use eventMenu in the Scheduler product
       *         // This object is applied to the Feature's predefined defaultItems object
       *         items : {
       *             switchToDog : {
       *                 text : 'Dog',
       *                 icon : 'b-fa b-fa-fw b-fa-dog',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = true;
       *                     contextRecord.cat = false;
       *                 },
       *                 weight : 500     // Make this second from end
       *             },
       *             switchToCat : {
       *                 text : 'Cat',
       *                 icon : 'b-fa b-fa-fw b-fa-cat',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = false;
       *                     contextRecord.cat = true;
       *                 },
       *                 weight : 510     // Make this sink to end
       *             },
       *             add : false // We do not want the "Add" submenu to be available
       *         }
       *     }
       * }
       * ```
       *
       * @config {Object|Object[]}
       */
      items: null,

      /**
       * A function called before displaying the menu that allows manipulations of its items. Called with a
       * single parameter with format { contextRecord, eventElement, items }. Returning `false`
       * from this function prevents the menu from being shown.
       *
       * ```javascript
       * features : {
       *     taskContextMenu : {
       *         processItems({contextRecord, items}) {
       *             // Add or remove items here as needed
       *             if (contextRecord.type === 'Meeting') {
       *                 items.cancel = {
       *                     text   : 'Cancel',
       *                     icon   : 'b-fa b-fa-fw b-fa-ban',
       *                     weight : 200 // Move to end
       *                 };
       *             }
       *
       *             // Hide delete for parents
       *             items.deleteTask.hidden = contextRecord.isParent;
       *         }
       *     }
       * }
       * ```
       *
       * @config {Function}
       */
      processItems: null,

      /**
       * Event which is used to show context menu.
       * Available options are: 'contextmenu', 'click', 'dblclick'.
       * Default value is used from {@link Grid/view/GridBase#config-contextMenuTriggerEvent}
       * @config {String}
       */
      triggerEvent: null
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      assign: ['showEventContextMenu'],
      chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onEventSpaceKey']
    };
  } //endregion
  //region Init


  construct(grid, config) {
    super.construct(grid, config);
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].deprecate('Scheduler', '5.0.0', '`TimeSpanRecordContextMenuBase` feature is deprecated, in favor of `TimeSpanMenuBase` feature. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.');
  }

  doDestroy() {
    if (this.menu) {
      this.menu.destroy();
    }

    super.doDestroy();
  } //endregion
  //region Events


  onElementContextMenu(event) {
    this.triggerEvent === 'contextmenu' && this.showEventContextMenu(event);
  }

  onElementClick(event) {
    this.triggerEvent === 'click' && this.showEventContextMenu(event);
  }

  onElementDblClick(event) {
    this.triggerEvent === 'dblclick' && this.showEventContextMenu(event);
  } // chained from EventNavigation


  onEventSpaceKey(keyEvent) {
    const targetPoint = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(keyEvent.target).center,
          contextmenuEvent = new MouseEvent('contextmenu', Object.assign({
      clientX: targetPoint.x,
      clientY: targetPoint.y
    }, keyEvent));
    Object.defineProperty(contextmenuEvent, 'target', {
      get() {
        return keyEvent.target;
      }

    });
    this.showEventContextMenu(contextmenuEvent);
  } //endregion
  //region Menu handlers

  /**
   * Show event context menu.
   * @param event
   * @internal
   * @on-owner
   */


  showEventContextMenu(event) {
    const me = this,
          client = me.client,
          target = event.target,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(target, client.eventSelector),
          targetElement = eventElement || target;

    if (targetElement) {
      const record = me.resolveRecord(targetElement);

      if (record) {
        event.preventDefault();
        me.showContextMenuFor(record, {
          targetElement,
          eventElement,
          event
        });
      }
    }
  }
  /**
   * A method to retrieve record from its DOM element. Must be implemented in subclasses.
   * @abstract
   */


  resolveRecord() {}
  /**
   * Shows context menu for the provided record. If record is not rendered (outside of time span, or collapsed)
   * menu won't appear.
   * @param {Scheduler.model.TimeSpan} record
   * @param {Object} [options]
   * @param {HTMLElement} options.targetElement Element to align context menu to
   * @param {HTMLElement} options.eventElement Event element if target is an event, otherwise `null`
   * @param {Event} options.event Browser event. If provided menu will be aligned according to clientX/clientY coordinates.
   * If omitted, context menu will be centered to targetElement
   */


  showContextMenuFor(record, options) {} // Implement in subclasses to massage options or veto show.


  beforeContextMenuShow() {} //endregion
  //region Show/Hide

  /**
   * @param {Object} eventParams
   * @param {Object[]} items
   * @internal
   */


  showContextMenu(eventParams) {
    if (this.disabled) {
      return;
    }

    const me = this,
          event = eventParams.event,
          menuType = eventParams.menuType.toLowerCase(),
          eventType = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].uncapitalize(menuType),
          clientGetItemsMethod = `get${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].capitalize(menuType)}MenuItems`,
          {
      client,
      processItems,
      defaultItems,
      namedItems
    } = me,
          point = event ? [event.clientX + 1, event.clientY + 1] : _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(eventParams.targetElement).center,
          items = eventParams.items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEmpty(me.items) ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(defaultItems) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(defaultItems), me.items);
    eventParams.namedItems = namedItems;
    eventParams.selection = client.selectedRecords; // Apply the named items prior to Container's item processing.
    // Our namedItems must cascade to all descendant Menu levels.
    // And they MUST have all been converted prior to the processItems call.

    applyNamedItems(items, namedItems); // Call the chainable method which other features use to add their own menu items.
    // For example getEventMenuItems

    if (client[clientGetItemsMethod]) {
      client[clientGetItemsMethod](eventParams, items);
    } // Allow user a chance at processing the items and preventing the menu from showing


    if ((!processItems || processItems(eventParams) !== false) && !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEmpty(eventParams.items)) {
      // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to
      // preprocess the event.
      if (me.beforeContextMenuShow(eventParams) !== false) {
        // Trigger event that allows preventing menu or manipulating its items
        if (client.trigger(`${eventType}ContextMenuBeforeShow`, eventParams) !== false) {
          me.menu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].showContextMenu(point, {
            owner: client,
            scrollAction: 'hide',
            constrainTo: window,
            items,

            onDestroy() {
              me.menu = null;
            },

            // Load up the item event with the contextual info
            onBeforeItem: itemEvent => {
              Object.assign(itemEvent, eventParams);
            },
            onItem: itemEvent => client.trigger(`${eventType}ContextMenuItem`, itemEvent),
            listeners: {
              show({
                source: menu
              }) {
                eventParams.menu = menu;
                client.trigger(`${eventType}ContextMenuShow`, eventParams);
              }

            }
          });
        }
      }
    }
  }
  /**
   * Hides the context menu
   * @internal
   */


  hideContextMenu(animate) {
    var _this$menu;

    (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.hide(animate);
  } //endregion
  //region Getters/Setters

  /**
   * Provides the default configuration of the context menu.
   *
   * Concrete classes must all provide their own defaultItems value in their defaultConfig blocks
   * @private
   */


  set defaultItems(defaultItems) {
    this._defaultItems = defaultItems;
  }

  get defaultItems() {
    const result = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(this._defaultItems); // Read-only client should have no default items enabled

    if (this.client.readOnly) {
      for (const item in result) {
        result[item] = false;
      }
    }

    return result;
  }

  get triggerEvent() {
    return this._triggerEvent || this.client.contextMenuTriggerEvent;
  }

  set triggerEvent(value) {
    this._triggerEvent = value;
  } //endregion


}
TimeSpanRecordContextMenuBase._$name = 'TimeSpanRecordContextMenuBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TooltipBase.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/base/TooltipBase.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TooltipBase; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';



/**
 * @module Scheduler/feature/base/TooltipBase
 */

/**
 * Base class for `EventTooltip` (Scheduler) and `TaskTooltip` (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @extendsconfigs Core/widget/Tooltip
 */

class TooltipBase extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * Specify true to have tooltip updated when mouse moves, if you for example want to display date at mouse
       * position.
       * @config {Boolean}
       * @default
       * @category Misc
       */
      autoUpdate: false,

      /**
       * The amount of time to hover before showing
       * @config {Number}
       * @default
       */
      hoverDelay: 250,

      /**
       * The time (in milliseconds) for which the Tooltip remains visible when the mouse leaves the target.
       *
       * May be configured as `false` to persist visible after the mouse exits the target element. Configure it
       * as 0 to always retrigger `hoverDelay` even when moving mouse inside `fromElement`
       * @config {Number}
       * @default
       */
      hideDelay: 100,
      // TODO: Rename to tooltipTemplate, deprecate template
      template: null,
      cls: null,
      align: {
        align: 'b-t'
      },
      clockTemplate: null,
      // Set to true to update tooltip contents if record changes while tip is open
      monitorRecordUpdate: null,
      testConfig: {
        hoverDelay: 0
      }
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.


  static get pluginConfig() {
    return {
      chain: ['onPaint']
    };
  } //endregion
  //region Events

  /**
   * Triggered before a tooltip is shown. Return `false` to prevent the action.
   * @preventable
   * @event beforeShow
   * @param {Core.widget.Tooltip} source The tooltip being shown.
   * @param {Scheduler.model.EventModel} source.eventRecord The event record.
   */

  /**
   * Triggered after a tooltip is shown.
   * @event show
   * @param {Core.widget.Tooltip} source The tooltip.
   * @param {Scheduler.model.EventModel} source.eventRecord The event record.
   */
  //endregion
  //region Init


  construct(client, config) {
    const me = this; // process initial config into an actual config object

    config = me.processConfig(config);
    super.construct(client, config); // Default triggering selector is the client's inner element selector

    if (!me.forSelector) {
      me.forSelector = `${client.eventInnerSelector}:not(.b-dragproxy)`;
    }

    me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      scheduler: client
    });
    client.on({
      [`before${client.scheduledEventName}drag`]: () => {
        var _me$tooltip;

        return (_me$tooltip = me.tooltip) === null || _me$tooltip === void 0 ? void 0 : _me$tooltip.hide();
      }
    });
  } // TooltipBase feature handles special config cases, where user can supply a function to use as template
  // instead of a normal config object


  processConfig(config) {
    if (typeof config === 'function') {
      return {
        template: config
      };
    }

    return config;
  } // override setConfig to process config before applying it (used mainly from ReactScheduler)


  setConfig(config) {
    super.setConfig(this.processConfig(config));
  }

  doDestroy() {
    this.destroyProperties('clockTemplate', 'tooltip');
    super.doDestroy();
  }

  doDisable(disable) {
    if (this.tooltip) {
      this.tooltip.disabled = disable;
    }

    super.doDisable(disable);
  } //endregion


  onPaint({
    firstPaint
  }) {
    if (firstPaint) {
      var _me$tooltip2;

      const me = this,
            {
        client
      } = me,
            ignoreSelector = ['.b-dragselecting', '.b-eventeditor-editing', '.b-taskeditor-editing', '.b-resizing-event', '.b-dragcreating', `.b-dragging-${client.scheduledEventName}`, '.b-creating-dependency', '.b-dragproxy'].map(cls => `:not(${cls})`).join('');
      (_me$tooltip2 = me.tooltip) === null || _me$tooltip2 === void 0 ? void 0 : _me$tooltip2.destroy();
      /**
       * A reference to the tooltip instance, which will have a special `eventRecord` property that
       * you can use to get data from the contextual event record to which this tooltip is related.
       * @member {Core.widget.Tooltip} tooltip
       * @readonly
       * @category Misc
       */

      me.tooltip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"](_objectSpread(_objectSpread({
        axisLock: 'flexible',
        id: me.tipId || `${me.client.id}-event-tip`,
        cls: me.tipCls,
        forSelector: `.b-timelinebase${ignoreSelector} .b-grid-body-container:not(.b-scrolling) ${me.forSelector}`,
        scrollAction: 'realign',
        forElement: client.timeAxisSubGridElement,
        showOnHover: true,
        anchorToTarget: true,
        allowOver: Boolean(me.config.items || me.config.tools),
        getHtml: me.getTipHtml.bind(me),
        disabled: me.disabled
      }, me.config), {}, {
        listeners: me.configuredListeners
      }));
      me.tooltip.on({
        innerhtmlupdate: 'updateDateIndicator',
        overtarget: 'onOverNewTarget',
        show: 'onTipShow',
        hide: 'onTipHide',
        thisObj: me
      });
    }
  } //region Listeners
  // leave configuredListeners alone until render time at which they are used on the tooltip


  processConfiguredListeners() {}

  addListener(...args) {
    var _this$tooltip;

    const // Call super method to handle enable/disable feature events
    defaultDetacher = super.addListener(...args),
          // Add listener to the `tooltip` instance
    tooltipDetacher = (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.addListener(...args);

    if (defaultDetacher || tooltipDetacher) {
      return () => {
        defaultDetacher === null || defaultDetacher === void 0 ? void 0 : defaultDetacher();
        tooltipDetacher === null || tooltipDetacher === void 0 ? void 0 : tooltipDetacher();
      };
    }
  }

  removeListener(...args) {
    var _this$tooltip2;

    super.removeListener(...args); // Remove listener from the `tooltip` instance

    (_this$tooltip2 = this.tooltip) === null || _this$tooltip2 === void 0 ? void 0 : _this$tooltip2.removeListener(...args);
  } //endregion


  updateDateIndicator() {
    const me = this,
          tip = me.tooltip,
          endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');

    if (!me.record) {
      return;
    }

    me.clockTemplate.updateDateIndicator(tip.element, me.record.startDate);
    endDateElement && me.clockTemplate.updateDateIndicator(endDateElement, me.record.endDate);
  }

  resolveTimeSpanRecord(forElement) {
    return this.client.resolveTimeSpanRecord(forElement);
  }

  getTipHtml({
    tip,
    activeTarget
  }) {
    const me = this,
          {
      client
    } = me,
          recordProp = me.recordType || `${client.scheduledEventName}Record`,
          timeSpanRecord = me.resolveTimeSpanRecord(activeTarget); // If user has mouseovered a fading away element of a deleted event,
    // an event record will not be found. In this case the tip must hide.
    // Instance of check is to not display while propagating

    if ((timeSpanRecord === null || timeSpanRecord === void 0 ? void 0 : timeSpanRecord.startDate) instanceof Date) {
      const {
        startDate,
        endDate
      } = timeSpanRecord,
            startText = client.getFormattedDate(startDate),
            endDateValue = client.getDisplayEndDate(endDate, startDate),
            endText = client.getFormattedDate(endDateValue);
      tip.eventRecord = timeSpanRecord;
      return me.template({
        tip,
        // eventRecord for Scheduler, taskRecord for Gantt
        [`${recordProp}`]: timeSpanRecord,
        startDate,
        endDate,
        startText,
        endText,
        startClockHtml: me.clockTemplate.template({
          date: startDate,
          text: startText,
          cls: 'b-sch-tooltip-startdate'
        }),
        endClockHtml: timeSpanRecord.isMilestone ? '' : me.clockTemplate.template({
          date: endDateValue,
          text: endText,
          cls: 'b-sch-tooltip-enddate'
        })
      });
    } else {
      tip.hide();
      return '';
    }
  }

  get record() {
    return this.tooltip.eventRecord;
  }

  onTipShow() {
    const me = this;

    if (me.monitorRecordUpdate && !me.updateListener) {
      me.updateListener = me.client.eventStore.on({
        update: me.onRecordUpdate,
        thisObj: me
      });
    }
  }

  onTipHide() {
    var _this$updateListener;

    // To not retain full project when changing project
    this.tooltip.eventRecord = null;
    (_this$updateListener = this.updateListener) === null || _this$updateListener === void 0 ? void 0 : _this$updateListener.call(this);
    this.updateListener = null;
  }

  onOverNewTarget({
    newTarget
  }) {
    this.tooltip.eventRecord = this.resolveTimeSpanRecord(newTarget);
  }

  onRecordUpdate({
    record
  }) {
    // make sure the record we are showing the tip for is still relevant
    if (record === this.record) {
      // Stop aligning at this point
      this.tooltip.alignTo();
      this.tooltip.updateContent();
    }
  }

}
TooltipBase._$name = 'TooltipBase';

/***/ }),

/***/ "./lib/Scheduler/feature/experimental/ExcelExporter.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/feature/experimental/ExcelExporter.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExcelExporter; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Grid/feature/experimental/ExcelExporter.js */ "./lib/Grid/feature/experimental/ExcelExporter.js");
/* harmony import */ var _util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/ScheduleTableExporter.js */ "./lib/Scheduler/util/ScheduleTableExporter.js");
var productName = 'gantt';
/*eslint no-undef: "error"*/




/**
 * @module Scheduler/feature/experimental/ExcelExporter
 */

/**
 * **NOTE**: This class requires a 3rd party library to operate.
 *
 * A plugin that allows exporting Scheduler data to Excel without involving the server. It uses {@link Scheduler.util.ScheduleTableExporter}
 * class as data provider, [zipcelx library](https://www.npmjs.com/package/zipcelx)
 * forked and adjusted to support [column width config](https://github.com/bryntum/zipcelx/tree/column-width-build)
 * and [Microsoft XML specification](https://msdn.microsoft.com/en-us/library/office/documentformat.openxml.spreadsheet.aspx).
 * Zipcelx should be either in global scope (window) or can be provided with {@link #config-zipcelx} config.
 *
 * ```
 * // Global scope
 * <script src="zipcelx.js"></script>
 *
 * // importing from package
 * import zipcelx from 'zipcelx';
 *
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             zipcelx
 *         }
 *     }
 * })
 * ```
 *
 * Here is an example of how to add the feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         excelExporter : {
 *             // Choose the date format for date fields
 *             dateFormat : 'YYYY-MM-DD HH:mm',
 *             exporterConfig : {
 *                 // Choose the Resource fields to include in the exported file
 *                 columns : [{ text : 'Staff', field : 'name' }],
 *
 *                 // Choose the Event fields to include in the exported file
 *                 eventColumns    : [
 *                     { text : 'Task', field : 'name' },
 *                     { text : 'Starts', field : 'startDate', width : 140 },
 *                     { text : 'Ends', field : 'endDate', width : 140 }
 *                 ]
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * And how to call it:
 *
 * ```javascript
 * scheduler.features.excelExporter.export({
 *     filename : 'Export',
 *     exporterConfig : {
 *         columns : [{ text : 'Staff', field : 'name' }]
 *     }
 * })
 * ```
 *
 * @extends Grid/feature/experimental/ExcelExporter
 * @classtype excelExporter
 * @feature
 * @demo Scheduler/exporttoexcel
 * @typings Grid/feature/experimental/ExcelExporter -> Grid/feature/experimental/GridExcelExporter
 */

class ExcelExporter extends _Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ExcelExporter';
  }

  static get defaultConfig() {
    return {
      /**
       * Exporter class. Must subclass {@link Scheduler.util.ScheduleTableExporter}
       * @config {Scheduler.util.ScheduleTableExporter}
       * @typings {typeof ScheduleTableExporter}
       * @default
       */
      exporterClass: _util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * Configuration object for {@link #config-exporterClass exporter class}.
       * @config {Object}
       */
      exporterConfig: null
    };
  }

}
ExcelExporter._$name = 'ExcelExporter';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ExcelExporter, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/export/PdfExport.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/export/PdfExport.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PdfExport; });
/* harmony import */ var _Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Grid/feature/export/PdfExport.js */ "./lib/Grid/feature/export/PdfExport.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../view/export/SchedulerExportDialog.js */ "./lib/Scheduler/view/export/SchedulerExportDialog.js");
/* harmony import */ var _exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exporter/SinglePageExporter.js */ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./exporter/MultiPageExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exporter/MultiPageVerticalExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';







/**
 * @module Scheduler/feature/export/PdfExport
 */

/**
 * Generates PDF/PNG files from the Scheduler component.
 *
 * <img src="Scheduler/export-dialog.png" style="max-width : 300px" alt="Scheduler Export dialog">
 *
 * **NOTE:** Server side is required to make export work!
 *
 * The export server is written in nodejs and it is shipped with our examples. You can find setup instructions in
 * `examples/_shared/server/README.md` and `examples/export/README.md` files.
 *
 * When your server is up and running, it listens to requests. The Export feature sends a request to the specified URL
 * with the HTML fragments. The server generates a PDF (or PNG) file and returns a download link (or binary, depending
 * on {@link #config-sendAsBinary} config). Then the Export feature opens the link in a new tab and the file is
 * automatically downloaded by your browser. This is configurable, see {@link #config-openAfterExport} config.
 *
 * The {@link #config-exportServer} URL must be configured. The URL can be localhost if you start the server locally,
 * or your remote server address.
 *
 * ## Usage
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080' // Required
 *         }
 *     }
 * })
 *
 * // Opens popup allowing to customize export settings
 * scheduler.features.pdfExport.showExportDialog();
 *
 * // Simple export
 * scheduler.features.pdfExport.export({
 *     // Required, set list of column ids to export
 *     columns : scheduler.columns.map(c => c.id)
 * }).then(result => {
 *     // Response instance and response content in JSON
 *     let { response, responseJSON } = result;
 * });
 * ```
 *
 * Appends configs related to exporting time axis: {@link #config-scheduleRange}, {@link #config-rangeStart},
 * {@link #config-rangeEnd}
 *
 * ## Loading resources
 *
 * If you face a problem with loading resources when exporting, the cause might be that the application and the export server are hosted on different servers.
 * This is due to [Cross-Origin Resource Sharing](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) (CORS). There are 2 options how to handle this:
 * - Allow cross origin requests from the server where your export is hosted to the server where your application is hosted;
 * - Copy all resources keeping the folder hierarchy from the server where your application is hosted to the server where your export is hosted
 * and setup paths using {@link Grid.feature.export.PdfExport#config-translateURLsToAbsolute} config and configure the export server to give access to the path:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080',
 *             // '/resources' is hardcoded in WebServer implementation
 *             translateURLsToAbsolute : 'http://localhost:8080/resources'
 *         }
 *     }
 * })
 * ```
 *
 * ```javascript
 * // Following path would be served by this address: http://localhost:8080/resources/
 * node ./src/server.js -h 8080 -r web/application/styles
 * ```
 *
 * where `web/application/styles` is a physical root location of the copied resources, for example:
 *
 * <img src="Grid/export-server-resources.png" style="max-width : 500px" alt="Export server structure with copied resources" />
 *
 * @extends Grid/feature/export/PdfExport
 * @classtype pdfExport
 * @feature
 * @typings Grid/feature/export/PdfExport -> Grid/feature/export/GridPdfExport
 */

class PdfExport extends _Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PdfExport';
  }

  static get defaultConfig() {
    return {
      exporters: [_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_3__["default"], _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_4__["default"], _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_5__["default"]],
      dialogClass: _view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * Specifies how to export time span.
       *  * completeview - Complete configured time span, from scheduler start date to end date
       *  * currentview  - Currently visible time span
       *  * daterange    - Use specific date range, provided additionally in config. See {@link #config-rangeStart}/
       *  {@link #config-rangeEnd}
       * @config {String}
       * @default
       * @category Export file config
       */
      scheduleRange: 'completeview',

      /**
       * Exported time span range start. Used with `daterange` config of the {@link #config-scheduleRange}
       * @config {Date}
       * @category Export file config
       */
      rangeStart: null,

      /**
       * Returns the instantiated export dialog widget as configured by {@link #config-exportDialog}
       * @member {Scheduler.view.export.SchedulerExportDialog} exportDialog
       */

      /**
       * A config object to apply to the {@link Scheduler.view.export.SchedulerExportDialog} widget.
       * @config {Object} exportDialog
       */

      /**
       * Exported time span range end. Used with `daterange` config of the {@link #config-scheduleRange}
       * @config {Date}
       * @category Export file config
       */
      rangeEnd: null
    };
  }

  get defaultExportDialogConfig() {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].copyProperties(super.defaultExportDialogConfig, this, ['scheduleRange']);
  }

  buildExportConfig(config) {
    config = super.buildExportConfig(config);
    const {
      scheduleRange,
      rangeStart,
      rangeEnd
    } = this; // Time axis is filtered from UI, need to append it

    if (config.columns && !config.columns.find(col => col.type === 'timeAxis')) {
      config.columns.push(config.client.timeAxisColumn.id);
    }

    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      scheduleRange,
      rangeStart,
      rangeEnd
    }, config);
  }

}
PdfExport._$name = 'PdfExport';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(PdfExport, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/export/Utils.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/export/Utils.js ***!
  \***********************************************/
/*! exports provided: ScheduleRange */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduleRange", function() { return ScheduleRange; });
var productName = 'gantt';
const ScheduleRange = {
  completeview: 'completeview',
  // completedata : 'completedata',
  currentview: 'currentview',
  daterange: 'daterange'
};

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js":
/*!********************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/MultiPageExporter.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageExporter; });
/* harmony import */ var _Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");
var productName = 'gantt';


class MultiPageExporter extends Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'MultiPageExporter';
  }

  async stateNextPage(config) {
    await super.stateNextPage(config);
    this.exportMeta.eventsBoxes.clear();
  }

  positionRows(rows) {
    const resources = [],
          events = []; // In case of variable row height row vertical position is not guaranteed to increase
    // monotonously. Position row manually instead

    rows.forEach(([html, top, height, eventsHtml]) => {
      resources.push(html);
      eventsHtml && Array.from(eventsHtml.entries()).forEach(([key, [html, box]]) => {
        events.push(html); // Store event box to render dependencies later

        this.exportMeta.eventsBoxes.set(String(key), box);
      });
    });
    return {
      resources,
      events
    };
  }

}
MultiPageExporter._$name = 'MultiPageExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js":
/*!****************************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageVerticalExporter; });
/* harmony import */ var _Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
var productName = 'gantt';



class MultiPageVerticalExporter extends Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'MultiPageVerticalExporter';
  }

  async stateNextPage(config) {
    await super.stateNextPage(config);
    this.exportMeta.eventsBoxes.clear();
  }

  async prepareComponent(config) {
    await super.prepareComponent(config); // Scheduler exporter mixin can update totalWidth, so we need to adjust pages and scale here again

    if (config.scheduleRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_2__["ScheduleRange"].completeview) {
      this.estimateTotalPages(config);
    }
  }

  positionRows(rows) {
    const resources = [],
          events = []; // In case of variable row height row vertical position is not guaranteed to increase
    // monotonously. Position row manually instead

    rows.forEach(([html, top, height, eventsHtml]) => {
      resources.push(html);
      eventsHtml && Array.from(eventsHtml.entries()).forEach(([key, [html, box]]) => {
        events.push(html); // Store event box to render dependencies later

        this.exportMeta.eventsBoxes.set(String(key), box);
      });
    });
    return {
      resources,
      events
    };
  }

}
MultiPageVerticalExporter._$name = 'MultiPageVerticalExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
var productName = 'gantt';





const immediatePromise = Promise.resolve();
/* harmony default export */ __webpack_exports__["default"] = (base => class SchedulerExporterMixin extends base {
  async scrollRowIntoView(client, index) {
    const {
      rowManager,
      scrollable
    } = client,
          oldY = scrollable.y; // If it's a valid index to scroll to, then try it.

    if (index < client.store.count) {
      // Scroll the requested row to the viewport top
      scrollable.scrollTo(null, rowManager.calculateTop(index)); // If that initiated a scroll, we need to wait for the row to be rendered, so return
      // a Promise which resolves when that happens.

      if (scrollable.y !== oldY) {
        // GridBase adds listener to vertical scroll to update rows. Rows might be or might not be updated,
        // but at the end of each scroll grid will trigger `scroll` event. So far this is the only scroll event
        // triggered by the grid itself and it is different from `scroll` event on scrollable.
        return new Promise(resolve => {
          const detacher = client.on({
            scroll({
              scrollTop
            }) {
              // future-proof: only react to scroll event with certain argument
              if (scrollTop != null && rowManager.getRow(index)) {
                detacher();
                resolve();
              }
            }

          });
        });
      }
    } // No scroll occurred. Promise must be resolved immediately


    return immediatePromise;
  }

  async scrollToDate(client, date) {
    let scrollFired = false;
    const promises = []; // Time axis is updated on element scroll, which is async event. We need to synchronize this logic.
    // If element horizontal scroll is changed then sync event is fired. We add listener to that one specific event
    // and remove it right after scrollToDate sync code, keeping listeners clean. If scrolling occurred, we need
    // to wait until time header is updated.

    const detacher = client.timeAxisSubGrid.scrollable.on({
      scrollStart({
        x
      }) {
        if (x != null) {
          scrollFired = true;
        }
      }

    }); // added `block: start` to do scrolling faster
    // it moves data to begin of visible area that is longer section for re-render

    promises.push(client.scrollToDate(date, {
      block: 'start'
    }));
    detacher();

    if (scrollFired) {
      // We have to wait for scrollEnd event before moving forward. When exporting large view we might have to scroll
      // extensively and it might occur that requested scroll position would not be reached because concurrent
      // scrollEnd events would move scroll back.
      // scrollEnd is on a 100ms timer *after* the last scroll event fired, so all necessary
      // updated will have occurred.
      // Covered by Gantt/tests/feature/export/MultiPageVertical.t.js
      promises.push(client.timeAxisSubGrid.header.scrollable.await('scrollEnd', {
        checkLog: false
      }));
    }

    await Promise.all(promises);
  }

  async prepareComponent(config) {
    const me = this,
          {
      client
    } = config,
          {
      currentOrientation
    } = client,
          includeTimeline = client.timeAxisSubGrid.width > 0;

    switch (config.scheduleRange) {
      case _Utils_js__WEBPACK_IMPORTED_MODULE_4__["ScheduleRange"].completeview:
        config.rangeStart = client.startDate;
        config.rangeEnd = client.endDate;
        break;

      case _Utils_js__WEBPACK_IMPORTED_MODULE_4__["ScheduleRange"].currentview:
        const {
          startDate,
          endDate
        } = client.visibleDateRange;
        config.rangeStart = startDate;
        config.rangeEnd = endDate;
        break;
    }

    await client.waitForAnimations(); // Don't change timespan if time axis subgrid is not visible

    if (includeTimeline) {
      // set new timespan before calling parent to get proper scheduler header/content size
      client.setTimeSpan(config.rangeStart, config.rangeEnd); // Access svgCanvas el to create dependency canvas early
      // eslint-disable-next-line no-unused-expressions

      client.svgCanvas;
    } // Disable event animations during export


    me._oldEnableEventAnimations = client.enableEventAnimations;
    client.enableEventAnimations = false; // Add scroll buffer for the horizontal rendering

    if (currentOrientation.isHorizontalRendering) {
      me._oldScrollBuffer = currentOrientation.scrollBuffer;
      me._oldVerticalBuffer = currentOrientation.verticalBufferSize;
      currentOrientation.scrollBuffer = 100;
      currentOrientation.verticalBufferSize = -1;
    } // Raise flag on the client to render all suggested dependencies


    client.ignoreViewBox = true;
    await super.prepareComponent(config);
    const {
      exportMeta,
      element
    } = me,
          fgCanvasEl = element.querySelector('.b-sch-foreground-canvas'),
          timeAxisEl = element.querySelector('.b-horizontaltimeaxis');
    exportMeta.includeTimeline = includeTimeline;

    if (includeTimeline && config.scheduleRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_4__["ScheduleRange"].completeview) {
      // If we are exporting subrange of dates we need to change subgrid size accordingly
      exportMeta.totalWidth -= exportMeta.subGrids.normal.width;
      exportMeta.totalWidth += exportMeta.subGrids.normal.width = client.timeAxisViewModel.getDistanceBetweenDates(config.rangeStart, config.rangeEnd);
      const horizontalPages = Math.ceil(exportMeta.totalWidth / exportMeta.pageWidth),
            totalPages = horizontalPages * exportMeta.verticalPages;
      exportMeta.horizontalPages = horizontalPages;
      exportMeta.totalPages = totalPages; // store left scroll to imitate normal grid/header scroll using margin

      exportMeta.subGrids.normal.scrollLeft = client.getCoordinateFromDate(config.rangeStart);
    }

    exportMeta.timeAxisHeaders = [];
    exportMeta.timeAxisPlaceholders = [];
    exportMeta.headersColleted = false;
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(timeAxisEl, '.b-sch-header-row', headerRow => {
      exportMeta.timeAxisPlaceholders.push(me.createPlaceholder(headerRow));
      exportMeta.timeAxisHeaders.push(new Map());
    }); // Add placeholder for events, clear all event elements, but not the entire elements as it contains svg canvas

    exportMeta.subGrids.normal.eventsPlaceholder = me.createPlaceholder(fgCanvasEl, false);
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].removeEachSelector(fgCanvasEl, '.b-sch-event-wrap,.b-sch-resourcetimerange');
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].removeEachSelector(me.element, '.b-released');
    exportMeta.eventsBoxes = new Map();
    exportMeta.client = client;

    if (client.features.columnLines && !client.features.columnLines.disabled) {
      const columnLinesCanvas = element.querySelector('.b-column-lines-canvas');
      exportMeta.columnLinesPlaceholder = me.createPlaceholder(columnLinesCanvas);
      exportMeta.columnLines = {
        lines: new Map(),
        majorLines: new Map()
      };
    }

    if (client.features.dependencies && !client.features.dependencies.disabled) {
      const svgCanvasEl = element.querySelector(`[id="${client.svgCanvas.getAttribute('id')}"]`); // Same as above, clear only dependency lines, because there might be markers added by user

      if (exportMeta.dependenciesPlaceholder = svgCanvasEl) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].removeEachSelector(svgCanvasEl, '.b-sch-dependency');
      }
    } // We need to scroll component to date to calculate correct start margin


    if (includeTimeline && !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].betweenLesser(config.rangeStart, client.startDate, client.endDate)) {
      await me.scrollToDate(client, config.rangeStart);
    }
  }

  async restoreState(config) {
    let waitForHorizontalScroll = false;
    const {
      client
    } = config,
          promises = []; // If scroll will be changed during restoring state (and it will likely be), raise a flag that exporter should
    // wait for scrollEnd event before releasing control

    const detacher = client.timeAxisSubGrid.scrollable.on({
      scrollStart({
        x
      }) {
        // HACK: scrollStart might actually fire when scroll is set to existing value
        if (this.element.scrollLeft !== x) {
          waitForHorizontalScroll = true;
        }
      }

    });
    promises.push(super.restoreState(config)); // Scroll start will be fired synchronously

    detacher();

    if (waitForHorizontalScroll) {
      promises.push(client.timeAxisSubGrid.header.scrollable.await('scrollEnd', {
        checkLog: false
      }));
    }

    await Promise.all(promises);
  }

  async restoreComponent(config) {
    const {
      client
    } = config,
          {
      currentOrientation
    } = client;
    client.ignoreViewBox = false;
    client.enableEventAnimations = this._oldEnableEventAnimations;

    if (currentOrientation.isHorizontalRendering) {
      currentOrientation.scrollBuffer = this._oldScrollBuffer;
      currentOrientation.verticalBufferSize = this._oldVerticalBuffer;
    }

    await super.restoreComponent(config);
  }

  async onRowsCollected(rows, config) {
    const me = this;
    await super.onRowsCollected(rows); // Only collect this data if timeline is visible

    if (me.exportMeta.includeTimeline) {
      const {
        client
      } = config,
            {
        timeView
      } = client,
            {
        pageRangeStart,
        pageRangeEnd
      } = me.getCurrentPageDateRange(config); // Exported page may not contain timeline view, in which case we need to fall through

      if (pageRangeStart) {
        let rangeProcessed = false;
        await me.scrollToDate(client, pageRangeStart); // Time axis and events are only rendered for the visible time span
        // we need to scroll the view and gather events/timeline elements
        // while (timeView.endDate <= config.rangeEnd) {

        while (!rangeProcessed) {
          me.collectLines(config);
          me.collectHeaders(config);
          me.collectEvents(rows, config);

          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].timeSpanContains(timeView.startDate, timeView.endDate, pageRangeStart, pageRangeEnd)) {
            rangeProcessed = true;
          } else if (timeView.endDate.getTime() >= pageRangeEnd.getTime()) {
            rangeProcessed = true;
          } else {
            const endDate = timeView.endDate;
            await me.scrollToDate(client, timeView.endDate); // If timeview end date is same as before scroll it means client is not able to scroll to date
            // and will go into infinite loop unless we stop it

            if (endDate.getTime() === timeView.endDate.getTime()) {
              throw new Error('Could not scroll to date');
            }
          }
        }
      }

      await me.scrollToDate(client, config.rangeStart);
    }
  }

  getCurrentPageDateRange({
    rangeStart,
    rangeEnd,
    client
  }) {
    const me = this,
          {
      exportMeta
    } = me,
          {
      horizontalPages,
      horizontalPosition,
      pageWidth,
      subGrids
    } = exportMeta;
    let pageRangeStart, pageRangeEnd; // when exporting to multiple pages we only need to scroll sub-range within visible time span

    if (horizontalPages > 1) {
      const pageStartX = horizontalPosition * pageWidth,
            pageEndX = (horizontalPosition + 1) * pageWidth,
            // Assuming normal grid is right next to right side of the locked grid
      // There is also a default splitter
      normalGridX = subGrids.locked.width + subGrids.locked.splitterWidth;

      if (pageEndX <= normalGridX) {
        pageRangeEnd = pageRangeStart = null;
      } else {
        pageRangeStart = client.getDateFromCoordinate(Math.max(pageStartX - normalGridX, 0)); // Extend visible schedule by 20% to cover up possible splitter

        pageRangeEnd = client.getDateFromCoordinate((pageEndX - normalGridX) * 1.2) || rangeEnd;
      }
    } else {
      pageRangeStart = rangeStart;
      pageRangeEnd = rangeEnd;
    }

    return {
      pageRangeStart,
      pageRangeEnd
    };
  }

  prepareExportElement() {
    const {
      element,
      exportMeta
    } = this,
          {
      id,
      headerId,
      footerId,
      scrollLeft
    } = exportMeta.subGrids.normal,
          el = element.querySelector(`[id="${id}"]`);
    ['.b-sch-background-canvas', '.b-sch-foreground-canvas'].forEach(selector => {
      const canvasEl = el.querySelector(selector);

      if (canvasEl) {
        // Align canvases to last exported row bottom. If no such property exists - remove inline height
        if (exportMeta.lastExportedRowBottom) {
          canvasEl.style.height = `${exportMeta.lastExportedRowBottom}px`;
        } else {
          canvasEl.style.height = '';
        } // Simulate horizontal scroll


        if (scrollLeft) {
          canvasEl.style.marginLeft = `-${scrollLeft}px`;
        }
      }
    });

    if (scrollLeft) {
      [headerId, footerId].forEach(id => {
        const el = element.querySelector(`[id="${id}"] .b-widget-scroller`);

        if (el) {
          el.style.marginLeft = `-${scrollLeft}px`;
        }
      });
    }

    return super.prepareExportElement();
  }

  collectRow(row) {
    const me = this,
          {
      subGrids
    } = me.exportMeta;
    Object.entries(row.elements).forEach(([key, value]) => {
      const rowConfig = [value.outerHTML, row.top, row.offsetHeight];

      if (key === 'normal') {
        rowConfig.push(new Map());
      }

      subGrids[key].rows.push(rowConfig);
    });
  }

  collectHeaders(config) {
    const me = this,
          {
      client
    } = config,
          {
      exportMeta
    } = me; // We only need to collect headers once, this flag is raised once they are collected along all exported range

    if (!exportMeta.headersCollected) {
      const timeAxisEl = client.timeView.element,
            timeAxisHeaders = exportMeta.timeAxisHeaders;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(timeAxisEl, '.b-sch-header-row', (headerRow, index, headerRows) => {
        const headersMap = timeAxisHeaders[index];
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(headerRow, '.b-sch-header-timeaxis-cell', el => {
          if (!headersMap.has(el.dataset.tickIndex)) {
            headersMap.set(el.dataset.tickIndex, el.outerHTML);
          }
        });

        if (index === headerRows.length - 1 && headersMap.has(String(client.timeAxis.count - 1))) {
          exportMeta.headersCollected = true;
        }
      });
    }
  }

  collectLines(config) {
    const me = this,
          {
      client
    } = config,
          {
      exportMeta
    } = me,
          {
      columnLines
    } = exportMeta; // We only need to collect headers once, this flag is raised once they are collected along all exported range

    if (!exportMeta.headersCollected && columnLines) {
      const bgCanvas = client.backgroundCanvas;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(bgCanvas, '.b-column-line, .b-column-line-major', lineEl => {
        if (lineEl.classList.contains('b-column-line')) {
          const lineIndex = Number(lineEl.dataset.line.replace(/line-/, ''));
          columnLines.lines.set(lineIndex, lineEl.outerHTML);
        } else {
          const lineIndex = Number(lineEl.dataset.line.replace(/major-/, ''));
          columnLines.majorLines.set(lineIndex, lineEl.outerHTML);
        }
      });
    }
  }

  collectEvents(rows, config) {
    const me = this,
          addedRows = rows.length,
          {
      client
    } = config,
          normalRows = me.exportMeta.subGrids.normal.rows;
    rows.forEach((row, index) => {
      var _resource$events, _resource$timeRanges;

      const rowConfig = normalRows[normalRows.length - addedRows + index],
            resource = client.store.getAt(row.dataIndex),
            eventsMap = rowConfig[3];
      (_resource$events = resource.events) === null || _resource$events === void 0 ? void 0 : _resource$events.forEach(event => {
        if (event.isScheduled) {
          let el = client.getElementFromEventRecord(event, resource);

          if (el && (el = el.parentElement) && !eventsMap.has(event.id)) {
            eventsMap.set(event.id, [el.outerHTML, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(el, el.offsetParent)]);
          }
        }
      });
      (_resource$timeRanges = resource.timeRanges) === null || _resource$timeRanges === void 0 ? void 0 : _resource$timeRanges.forEach(timeRange => {
        var _client$features$reso;

        const elId = ((_client$features$reso = client.features.resourceTimeRanges) === null || _client$features$reso === void 0 ? void 0 : _client$features$reso.generateElementId(timeRange)) || '',
              el = client.foregroundCanvas.syncIdMap[elId];

        if (el && !eventsMap.has(elId)) {
          eventsMap.set(elId, [el.outerHTML, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(el, el.offsetParent)]);
        }
      });
    });
  }

  buildPageHtml() {
    const me = this,
          {
      subGrids,
      timeAxisHeaders,
      timeAxisPlaceholders,
      columnLines,
      columnLinesPlaceholder
    } = me.exportMeta; // Now when rows are collected, we need to add them to exported grid

    let html = me.prepareExportElement();
    Object.values(subGrids).forEach(({
      placeHolder,
      eventsPlaceholder,
      rows
    }) => {
      const placeHolderText = placeHolder.outerHTML,
            // Rows can be repositioned, in which case event related to that row should also be translated
      {
        resources,
        events
      } = me.positionRows(rows);
      html = html.replace(placeHolderText, resources.join(''));

      if (eventsPlaceholder) {
        html = html.replace(eventsPlaceholder.outerHTML, events.join(''));
      }
    });
    timeAxisHeaders.forEach((headers, index) => {
      html = html.replace(timeAxisPlaceholders[index].outerHTML, Array.from(headers.values()).join(''));
    });

    if (columnLines) {
      const lineElements = Array.from(columnLines.lines.values()).concat(Array.from(columnLines.majorLines.values()));
      html = html.replace(columnLinesPlaceholder.outerHTML, lineElements.join(''));
    }

    html = me.buildDependenciesHtml(html);
    return html;
  } // outerHTML is not supported on SVG elements in IE11, using workaround


  getDependenciesOuterHTML() {
    const {
      dependenciesPlaceholder
    } = this.exportMeta;
    let result;

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      const wrapper = document.createElement('div'),
            tmpEl = dependenciesPlaceholder.cloneNode(true);
      wrapper.appendChild(tmpEl);
      result = wrapper.innerHTML;
    } else {
      result = dependenciesPlaceholder.outerHTML;
    }

    return result;
  }

  renderDependencies() {
    const me = this,
          {
      client,
      dependenciesPlaceholder,
      eventsBoxes
    } = me.exportMeta,
          {
      dependencies
    } = client,
          dependencyFeature = client.features.dependencies,
          eventsInView = Array.from(eventsBoxes.keys());
    dependencies.filter(r => eventsInView.includes(String(r.from)) || eventsInView.includes(String(r.to))).forEach(dependency => {
      let fromBox = eventsBoxes.get(String(dependency.from)),
          toBox = eventsBoxes.get(String(dependency.to));
      const assignments = dependencyFeature.getIteratableDependencyAssignments(dependency),
            {
        fromEvent,
        toEvent
      } = dependency;
      assignments.forEach(assignmentData => {
        var _fromBox, _toBox;

        // In case of single page export from/to boxes will always be present, also we cannot trust boxes from cache
        // because single page exporter can possible change row/event vertical position
        // In case of multipage we will get box from the dependency feature
        if (!fromBox) {
          if (fromEvent) {
            const box = dependencyFeature.getBox(dependency, true, assignmentData);

            if (box) {
              fromBox = box instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? box : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top);
            }
          }
        }

        if (!toBox) {
          if (toEvent) {
            const box = dependencyFeature.getBox(dependency, false, assignmentData);

            if (box) {
              toBox = box instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? box : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top);
            }
          }
        } // Gantt dependencies feature modifies box size to point arrow to the top, clone box to keep original size


        const drawData = {
          startRectangle: (_fromBox = fromBox) === null || _fromBox === void 0 ? void 0 : _fromBox.clone(),
          endRectangle: (_toBox = toBox) === null || _toBox === void 0 ? void 0 : _toBox.clone()
        };

        if (fromBox && toBox) {
          dependencyFeature.drawDependency(dependency, drawData, assignmentData, dependenciesPlaceholder, false);
        }
      });
    });
    const result = me.getDependenciesOuterHTML();
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].removeEachSelector(dependenciesPlaceholder, '.b-sch-dependency');
    return result;
  }

  buildDependenciesHtml(html) {
    const {
      dependenciesPlaceholder,
      includeTimeline
    } = this.exportMeta;

    if (dependenciesPlaceholder && includeTimeline) {
      const placeholder = this.getDependenciesOuterHTML();
      html = html.replace(placeholder, this.renderDependencies());
    }

    return html;
  }

});

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js":
/*!*********************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/SinglePageExporter.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SinglePageExporter; });
/* harmony import */ var _Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");
var productName = 'gantt';


class SinglePageExporter extends Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SinglePageExporter';
  } // We should not collect dependencies per each page, instead we'd render them once


  collectDependencies() {}

  positionRows(rows) {
    const resources = [],
          events = [],
          translateRe = /translate\((\d+.?\d*)px, (\d+.?\d*)px\)/;
    let currentTop = 0; // In case of variable row height row vertical position is not guaranteed to increase
    // monotonously. Position row manually instead

    rows.forEach(([html, top, height, eventsHtml]) => {
      resources.push(html.replace(translateRe, `translate($1px, ${currentTop}px)`));
      const rowTopDelta = currentTop - top;
      eventsHtml && Array.from(eventsHtml.entries()).forEach(([key, [html, box]]) => {
        // Fix event vertical position according to the row top
        box.translate(0, rowTopDelta); // Store event box to render dependencies later

        this.exportMeta.eventsBoxes.set(String(key), box);
        events.push(html.replace(translateRe, `translate($1px, ${box.y}px)`));
      });
      currentTop += height;
    });
    return {
      resources,
      events
    };
  }

}
SinglePageExporter._$name = 'SinglePageExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/mixin/DependencyCreation.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/feature/mixin/DependencyCreation.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';







/**
 * @module Scheduler/feature/mixin/DependencyCreation
 */
// TODO: refactor this class using StateChart utility to be implemented in Core/util/StateChart.js or XState library if allowed to be used

/**
 * Mixin for Dependencies feature that handles dependency creation (drag & drop from terminals which are shown on hover).
 * Requires {@link Core.mixin.Delayable} to be mixed in alongside.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DependencyCreation extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DependencyCreation';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * `false` to require a drop on a target event bar side circle to define the dependency type.
       * If dropped on the event bar, the `defaultValue` of the DependencyModel `type` field will be used to
       * determine the target task side.
       *
       * @member {Boolean} allowDropOnEventBar
       */

      /**
       * `false` to require a drop on a target event bar side circle to define the dependency type.
       * If dropped on the event bar, the `defaultValue` of the DependencyModel `type` field will be used to
       * determine the target task side.
       *
       * @config {Boolean}
       * @default
       */
      allowDropOnEventBar: true,

      /**
       * `false` to not show a tooltip while creating a dependency
       * @config {Boolean}
       * @default
       */
      showCreationTooltip: true,

      /**
       * A tooltip config object that will be applied to the dependency creation tooltip
       * @config {Object}
       */
      creationTooltip: null,

      /**
       * CSS class used for terminals
       * @config {String}
       * @default
       */
      terminalCls: 'b-sch-terminal',

      /**
       * Where (at events borders) to display terminals
       * @config {String[]}
       * @default
       */
      terminalSides: ['left', 'top', 'right', 'bottom'],

      /**
       * Set to `false` to not allow creating dependencies
       * @config {Boolean}
       * @default
       */
      allowCreate: true
    };
  } //endregion
  //region Init & destroy


  construct(view, config) {
    super.construct(view, config);
    const me = this;
    me.view = view;
    me.eventName = view.scheduledEventName;
    view.on('readOnly', () => me.updateCreateListeners());
    me.updateCreateListeners();
  }

  doDestroy() {
    var _me$mouseUpMoveDetach, _me$creationTooltip;

    const me = this;
    me.detachListeners('view');
    me.creationData = null;
    (_me$mouseUpMoveDetach = me.mouseUpMoveDetacher) === null || _me$mouseUpMoveDetach === void 0 ? void 0 : _me$mouseUpMoveDetach.call(me);
    (_me$creationTooltip = me.creationTooltip) === null || _me$creationTooltip === void 0 ? void 0 : _me$creationTooltip.destroy();
    super.doDestroy();
  }

  updateCreateListeners() {
    const me = this;

    if (!me.view) {
      return;
    }

    me.detachListeners('view');

    if (me.isCreateAllowed) {
      me.view.on({
        name: 'view',
        [`${me.eventName}mouseenter`]: 'onTimeSpanMouseEnter',
        [`${me.eventName}mouseleave`]: 'onTimeSpanMouseLeave',
        thisObj: me
      });
    }
  }

  set allowCreate(value) {
    this._allowCreate = value;
    this.updateCreateListeners();
  }

  get allowCreate() {
    return this._allowCreate;
  }

  get isCreateAllowed() {
    return this.allowCreate && !this.view.readOnly && !this.disabled;
  } //endregion
  //region Events

  /**
   * Show terminals when mouse enters event/task element
   * @private
   */


  onTimeSpanMouseEnter({
    event,
    source,
    [`${this.eventName}Record`]: record,
    [`${this.eventName}Element`]: element
  }) {
    if (!record.isCreating) {
      const eventBarElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].down(element, source.eventInnerSelector);
      this.showTerminals(record, eventBarElement);

      if (this.creationData && event.target.closest(this.client.eventSelector)) {
        this.creationData.timeSpanElement = eventBarElement;
        this.onOverTargetEventBar(event);
      }
    }
  }
  /**
   * Hide terminals when mouse leaves event/task element
   * @private
   */


  onTimeSpanMouseLeave(event) {
    var _me$creationData;

    const me = this,
          element = event[`${me.eventName}Element`],
          target = event.event.relatedTarget,
          timeSpanElement = (_me$creationData = me.creationData) === null || _me$creationData === void 0 ? void 0 : _me$creationData.timeSpanElement;

    if (!me.creationData || !timeSpanElement || !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isDescendant(timeSpanElement, target)) {
      me.hideTerminals(element);
    }

    if (me.creationData && !me.creationData.finalizing) {
      me.creationData.timeSpanElement = null;
      me.onOverNewTargetWhileCreating();
    }
  }

  onTerminalMouseOver(event) {
    if (this.creationData) {
      this.onOverTargetEventBar(event);
    }
  }
  /**
   * Remove hover styling when mouse leaves terminal. Also hides terminals when mouse leaves one it and not creating a
   * dependency.
   * @private
   */


  onTerminalMouseOut(event) {
    const me = this,
          el = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, me.view.eventSelector);

    if (el && (!me.showingTerminalsFor || !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isDescendant(el, me.showingTerminalsFor)) && (!me.creationData || el !== me.creationData.timeSpanElement)) {
      me.hideTerminals(el);
      me.view.unhover(event);
    }

    if (me.creationData) {
      me.onOverNewTargetWhileCreating(event.relatedTarget, me.creationData.target);
    }
  }
  /**
   * Start creating a dependency when mouse is pressed over terminal
   * @private
   */


  onTerminalMouseDown(event) {
    const me = this; // ignore non-left button clicks

    if (event.button === 0 && !me.creationData) {
      var _scheduler$resolveRes;

      const scheduler = me.view,
            timeAxisSubGridElement = scheduler.timeAxisSubGridElement,
            terminalNode = event.target,
            timeSpanElement = terminalNode.closest(scheduler.eventInnerSelector),
            viewBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(scheduler.element, document.body);
      event.preventDefault();
      event.stopPropagation();
      me.creationData = {
        source: scheduler.resolveTimeSpanRecord(timeSpanElement),
        fromSide: terminalNode.dataset.side,
        startPoint: _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(terminalNode, timeAxisSubGridElement).center,
        startX: event.pageX - viewBounds.x + scheduler.scrollLeft,
        startY: event.pageY - viewBounds.y + scheduler.scrollTop,
        valid: false,
        sourceResource: (_scheduler$resolveRes = scheduler.resolveResourceRecord) === null || _scheduler$resolveRes === void 0 ? void 0 : _scheduler$resolveRes.call(scheduler, timeSpanElement)
      };
      me.mouseUpMoveDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
        mouseup: {
          element: scheduler.rootElement,
          handler: 'onMouseUp'
        },
        mousemove: {
          element: timeAxisSubGridElement,
          handler: 'onMouseMove'
        },
        thisObj: me
      }); // If root element is anything but Document (it could be Document Fragment or regular Node in case of LWC)
      // then we should also add listener to document to cancel dependency creation

      me.documentMouseUpDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
        mouseup: {
          element: document,
          handler: 'onDocumentMouseUp'
        },
        keydown: {
          element: document,
          handler: ({
            key
          }) => {
            if (key === 'Escape') {
              me.abort();
            }
          }
        },
        thisObj: me
      });
    }
  }
  /**
   * Update connector line showing dependency between source and target when mouse moves. Also check if mouse is over
   * a valid target terminal
   * @private
   */


  onMouseMove(event) {
    const me = this,
          {
      view,
      creationData: data
    } = me,
          viewBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(view.element, document.body),
          deltaX = event.pageX - viewBounds.x + view.scrollLeft - data.startX,
          deltaY = event.pageY - viewBounds.y + view.scrollTop - data.startY,
          length = Math.round(Math.sqrt(deltaX * deltaX + deltaY * deltaY)) - 3,
          angle = Math.atan2(deltaY, deltaX);
    let {
      connector
    } = me;

    if (!connector) {
      if (me.onRequestDragCreate(event) === false) {
        return;
      }

      connector = me.connector;
    }

    connector.style.width = `${length}px`;
    connector.style.transform = `rotate(${angle}rad)`;
    me.lastMouseMoveEvent = event;
  }

  onRequestDragCreate(event) {
    const me = this,
          {
      view,
      creationData: data
    } = me;
    /**
     * Fired on the owning Scheduler/Gantt before a dependency creation drag operation starts. Return `false to
     * prevent it
     * @event beforeDependencyCreateDrag
     * @on-owner
     * @param {Object} data [DEPRECATED] in a favor of top level params
     * @param {Scheduler.model.TimeSpan} data.source [DEPRECATED] in favor of the source param
     * @param {Scheduler.model.TimeSpan} source The source task
     */

    if (view.trigger('beforeDependencyCreateDrag', {
      data,
      source: data.source
    }) === false) {
      me.abort();
      return false;
    }

    view.element.classList.add('b-creating-dependency');
    me.connector = me.createConnector(data.startPoint.x, data.startPoint.y);
    /**
     * Fired on the owning Scheduler/Gantt when a dependency creation drag operation starts
     * @event dependencyCreateDragStart
     * @on-owner
     * @param {Object} data [DEPRECATED] in a favor of top level params
     * @param {Scheduler.model.TimeSpan} source The source task
     */

    view.trigger('dependencyCreateDragStart', {
      data,
      source: data.source
    });

    if (me.showCreationTooltip) {
      me.creationTooltip = me.creationTooltip || me.createDragTooltip();
      me.creationTooltip.disabled = false;
      me.creationTooltip.show();
      me.creationTooltip.onMouseMove(event);
    }

    view.scrollManager.startMonitoring({
      scrollables: [{
        element: view.timeAxisSubGrid.scrollable.element,
        direction: 'horizontal'
      }, {
        element: view.scrollable.element,
        direction: 'vertical'
      }],
      callback: () => me.lastMouseMoveEvent && me.onMouseMove(me.lastMouseMoveEvent)
    });
  }

  onOverTargetEventBar({
    target
  }) {
    const me = this,
          {
      view,
      creationData: data,
      allowDropOnEventBar
    } = me,
          overEventRecord = view.resolveTimeSpanRecord(target);

    if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(data.valid) || !allowDropOnEventBar && !target.classList.contains(me.terminalCls)) {
      return;
    }

    if (overEventRecord !== data.source) {
      me.onOverNewTargetWhileCreating(target, overEventRecord);
    }
  }

  async onOverNewTargetWhileCreating(target, overEventRecord) {
    const me = this,
          {
      view,
      creationData: data,
      allowDropOnEventBar,
      connector
    } = me;

    if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(data.valid)) {
      return;
    } // Connector might not exist at this point because `pointerout` on the terminal might fire before `pointermove`
    // on the time axis subgrid. This is difficult to reproduce, so shouldn't be triggered often.
    // https://github.com/bryntum/support/issues/3116#issuecomment-894256799


    if (!connector) {
      return;
    }

    connector.classList.remove('b-valid', 'b-invalid');
    data.timeSpanElement && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].removeClsGlobally(data.timeSpanElement, 'b-sch-terminal-active');

    if (!overEventRecord || overEventRecord === data.source || !allowDropOnEventBar && !target.classList.contains(me.terminalCls)) {
      data.target = data.toSide = null;
      data.valid = false;
      connector.classList.add('b-invalid');
    } else {
      var _data$timeSpanElement;

      let toSide = target.dataset.side;
      data.target = overEventRecord; // If we allow dropping anywhere on a task, resolve target side based on the default type of the
      // dependency model used

      if (allowDropOnEventBar && !target.classList.contains(me.terminalCls)) {
        toSide = me.getTargetSideFromType(me.dependencyStore.modelClass.fieldMap.type.defaultValue || _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.EndToStart);
      }

      if (view.resolveResourceRecord) {
        data.targetResource = view.resolveResourceRecord(target);
      }

      let dependencyType;
      data.toSide = toSide;

      const fromSide = data.fromSide,
            updateValidity = valid => {
        if (!me.isDestroyed) {
          data.valid = valid;
          target.classList.add(valid ? 'b-valid' : 'b-invalid');
          connector.classList.add(valid ? 'b-valid' : 'b-invalid');
          /**
           * Fired on the owning Scheduler/Gantt when asynchronous dependency validation completes
           * @event dependencyValidationComplete
           * @on-owner
           * @param {Object} data [DEPRECATED] in a favor of top level params
           * @param {Scheduler.model.TimeSpan} source The source task
           * @param {Scheduler.model.TimeSpan} target The target task
           * @param {Number} dependencyType The dependency type, see {@link Scheduler.model.DependencyBaseModel#property-Type-static}
           */

          view.trigger('dependencyValidationComplete', {
            data,
            source: data.source,
            target: data.target,
            dependencyType
          });
        }
      }; // NOTE: Top/Bottom sides are not taken into account due to
      //       scheduler doesn't check for type value anyway, whereas
      //       gantt will reject any other dependency types undefined in
      //       DependencyBaseModel.Type enumeration.


      switch (true) {
        case fromSide === 'left' && toSide === 'left':
          dependencyType = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.StartToStart;
          break;

        case fromSide === 'left' && toSide === 'right':
          dependencyType = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.StartToEnd;
          break;

        case fromSide === 'right' && toSide === 'left':
          dependencyType = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.EndToStart;
          break;

        case fromSide === 'right' && toSide === 'right':
          dependencyType = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.EndToEnd;
          break;
      }
      /**
       * Fired on the owning Scheduler/Gantt when asynchronous dependency validation starts
       * @event dependencyValidationStart
       * @on-owner
       * @param {Object} data [DEPRECATED] in a favor of top level params
       * @param {Scheduler.model.TimeSpan} source The source task
       * @param {Scheduler.model.TimeSpan} target The target task
       * @param {Number} dependencyType The dependency type, see {@link Scheduler.model.DependencyBaseModel#property-Type-static}
       */


      view.trigger('dependencyValidationStart', {
        data,
        source: data.source,
        target: data.target,
        dependencyType
      });
      data.valid = me.dependencyStore.isValidDependency(data.source, data.target, dependencyType); // Promise is returned when using the engine

      if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(data.valid)) {
        const asyncValid = await data.valid;
        updateValidity(asyncValid);
      } else {
        updateValidity(data.valid);
      }

      const validityCls = data.valid ? 'b-valid' : 'b-invalid';
      connector.classList.add(validityCls);
      (_data$timeSpanElement = data.timeSpanElement) === null || _data$timeSpanElement === void 0 ? void 0 : _data$timeSpanElement.querySelector(`.b-sch-terminal[data-side=${toSide}]`).classList.add('b-sch-terminal-active', validityCls);
    }

    me.updateTooltip();
  }
  /**
   * Create a new dependency if mouse release over valid terminal. Hides connector
   * @private
   */


  async onMouseUp(event) {
    var _me$mouseUpMoveDetach2;

    const me = this,
          data = me.creationData;
    data.finalizing = true;
    (_me$mouseUpMoveDetach2 = me.mouseUpMoveDetacher) === null || _me$mouseUpMoveDetach2 === void 0 ? void 0 : _me$mouseUpMoveDetach2.call(me);

    if (data.valid) {
      /**
       * Fired on the owning Scheduler/Gantt when a dependency drag creation operation is about to finalize
       *
       * @event beforeDependencyCreateFinalize
       * @on-owner
       * @preventable
       * @async
       * @param {Scheduler.model.TimeSpan} source The source task
       * @param {Scheduler.model.TimeSpan} target The target task
       * @param {String} fromSide The from side (left / right / top / bottom)
       * @param {String} toSide The to side (left / right / top / bottom)
       */
      const result = await me.view.trigger('beforeDependencyCreateFinalize', data);

      if (result === false) {
        data.valid = false;
      } // Await any async validation logic before continuing
      else if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(data.valid)) {
        const valid = await data.valid;
        data.valid = valid;
      }

      if (data.valid) {
        let dependency = me.createDependency(data);

        if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(dependency)) {
          dependency = await dependency;
        }

        data.dependency = dependency;
        /**
         * Fired on the owning Scheduler/Gantt when a dependency drag creation operation succeeds
         * @event dependencyCreateDrop
         * @on-owner
         * @param {Object} data [DEPRECATED] in a favor of top level params
         * @param {Scheduler.model.TimeSpan} source The source task
         * @param {Scheduler.model.TimeSpan} target The target task
         * @param {Scheduler.model.DependencyBaseModel} dependency The created dependency
         */

        me.view.trigger('dependencyCreateDrop', {
          data,
          source: data.source,
          target: data.target,
          dependency
        });
        this.doAfterDependencyDrop(data);
      } else {
        me.doAfterDependencyDrop(data);
      }
    } else {
      data.valid = false;
      me.doAfterDependencyDrop(data);
    }

    this.abort();
  }

  doAfterDependencyDrop(data) {
    /**
     * Fired on the owning Scheduler/Gantt after a dependency drag creation operation finished, no matter to outcome
     * @event afterDependencyCreateDrop
     * @on-owner
     * @param {Object} data [DEPRECATED] in a favor of top level params
     * @param {Scheduler.model.TimeSpan} source The source task
     * @param {Scheduler.model.TimeSpan} target The target task
     * @param {Scheduler.model.DependencyBaseModel} dependency The created dependency
     */
    this.view.trigger('afterDependencyCreateDrop', _objectSpread({
      data
    }, data));
  }

  onDocumentMouseUp({
    target
  }) {
    if (!this.view.timeAxisSubGridElement.contains(target)) {
      this.abort();
    }
  }
  /**
   * Aborts dependency creation, removes proxy and cleans up listeners
   */


  abort() {
    var _me$mouseUpMoveDetach3, _me$documentMouseUpDe;

    const me = this,
          {
      view,
      creationData
    } = me; // Remove terminals from source and target events.

    if (creationData) {
      const {
        source,
        sourceResource,
        target,
        targetResource
      } = creationData;

      if (source) {
        const el = view.getElementFromEventRecord(source, sourceResource);

        if (el) {
          me.hideTerminals(el);
        }
      }

      if (target) {
        const el = view.getElementFromEventRecord(target, targetResource);

        if (el) {
          me.hideTerminals(el);
        }
      }
    }

    if (me.creationTooltip) {
      me.creationTooltip.disabled = true;
    }

    me.creationData = me.lastMouseMoveEvent = null;
    (_me$mouseUpMoveDetach3 = me.mouseUpMoveDetacher) === null || _me$mouseUpMoveDetach3 === void 0 ? void 0 : _me$mouseUpMoveDetach3.call(me);
    (_me$documentMouseUpDe = me.documentMouseUpDetacher) === null || _me$documentMouseUpDe === void 0 ? void 0 : _me$documentMouseUpDe.call(me);
    me.removeConnector();
  } //endregion
  //region Connector

  /**
   * Creates a connector line that visualizes dependency source & target
   * @private
   */


  createConnector(x, y) {
    const me = this,
          view = me.view;
    me.clearTimeout(me.removeConnectorTimeout);
    me.connector = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
      parent: view.timeAxisSubGridElement,
      className: `${me.baseCls}-connector`,
      style: `left:${x}px;top:${y}px`
    });
    view.element.classList.add('b-creating-dependency');
    return me.connector;
  }

  createDragTooltip() {
    const me = this,
          {
      view
    } = me;
    const tooltip = me.creationTooltip = _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
      id: `${view.id}-dependency-drag-tip`,
      cls: 'b-sch-dependency-creation-tooltip',
      loadingMsg: '',
      anchorToTarget: false,
      // Keep tip visible until drag drop operation is finalized
      forElement: view.timeAxisSubGridElement,
      trackMouse: true,
      // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
      constrainTo: null,
      header: {
        dock: 'right'
      },
      listeners: {
        beforeShow: () => {
          // Show initial content immediately
          me.updateTooltip();
        }
      }
    }, me.creationTooltip);
    return tooltip;
  }
  /**
   * Remove connector
   * @private
   */


  removeConnector() {
    const me = this,
          {
      connector,
      view
    } = me;

    if (connector) {
      connector.classList.add('b-removing');
      connector.style.width = '0';
      me.removeConnectorTimeout = me.setTimeout(() => {
        connector.remove();
        me.connector = null;
      }, 200);
    }

    view.element.classList.remove('b-creating-dependency');
    me.creationTooltip && me.creationTooltip.hide();
    view.scrollManager.stopMonitoring();
  } //endregion
  //region Terminals

  /**
   * Show terminals for specified event at sides defined in #terminalSides.
   * @param {Scheduler.model.TimeSpan} timeSpanRecord Event/task to show terminals for
   * @param {HTMLElement} element Event/task element
   */


  showTerminals(timeSpanRecord, element) {
    const me = this;

    if (!me.isCreateAllowed) {
      return;
    }

    const cls = me.terminalCls,
          terminalsVisibleCls = `${cls}s-visible`; // We operate on the event bar, not the wrap

    element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].down(element, me.view.eventInnerSelector); // bail out if terminals already shown or if view is readonly
    // do not draw new terminals if we are resizing event

    if (!element.classList.contains(terminalsVisibleCls) && !this.view.element.classList.contains('b-resizing-event') && !me.view.readOnly) {
      // create terminals for desired sides
      me.terminalSides.forEach(side => {
        const terminal = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
          parent: element,
          className: `${cls} ${cls}-${side}`,
          dataset: {
            side,
            feature: true
          }
        });
        terminal.detacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
          element: terminal,
          mouseover: 'onTerminalMouseOver',
          mouseout: 'onTerminalMouseOut',
          mousedown: {
            handler: 'onTerminalMouseDown',
            capture: true
          },
          thisObj: me
        });
      });
      element.classList.add(terminalsVisibleCls);
      timeSpanRecord.internalCls.add(terminalsVisibleCls);
      me.showingTerminalsFor = element;
    }
  }
  /**
   * Hide terminals for specified event
   * @param {HTMLElement} eventElement Event element
   */


  hideTerminals(eventElement) {
    // remove all terminals
    const me = this,
          eventParams = me.client.getTimeSpanMouseEventParams(eventElement),
          timeSpanRecord = eventParams === null || eventParams === void 0 ? void 0 : eventParams[`${me.eventName}Record`],
          terminalsVisibleCls = `${me.terminalCls}s-visible`;
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEachSelector(eventElement, `.${me.terminalCls}`, terminal => {
      terminal.detacher && terminal.detacher();
      terminal.remove();
    });
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].down(eventElement, me.view.eventInnerSelector).classList.remove(terminalsVisibleCls);
    timeSpanRecord.internalCls.remove(terminalsVisibleCls);
    me.showingTerminalsFor = null;
  } //endregion
  //region Dependency creation

  /**
   * Create a new dependency from source terminal to target terminal
   * @internal
   */


  createDependency(data) {
    const {
      source,
      target,
      fromSide,
      toSide
    } = data,
          type = (fromSide === 'left' ? 0 : 2) + (toSide === 'right' ? 1 : 0);
    return this.dependencyStore.add({
      from: source.id,
      to: target.id,
      type,
      fromSide,
      toSide
    })[0];
  }

  getTargetSideFromType(type) {
    if (type === _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.StartToStart || type === _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_6__["default"].Type.EndToStart) {
      return 'left';
    }

    return 'right';
  } //endregion
  //region Tooltip

  /**
   * Update dependency creation tooltip
   * @private
   */


  updateTooltip() {
    var _data$target$name, _data$target;

    const me = this,
          data = me.creationData,
          {
      valid
    } = data,
          tip = this.creationTooltip,
          {
      classList
    } = tip.element;
    Object.assign(data, {
      fromText: data.source.name,
      toText: (_data$target$name = (_data$target = data.target) === null || _data$target === void 0 ? void 0 : _data$target.name) !== null && _data$target$name !== void 0 ? _data$target$name : '',
      fromSide: data.fromSide,
      toSide: data.toSide || ''
    });
    let tipTitleIconClsSuffix, tipTitleText; // Promise, when using engine

    if (_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPromise(valid)) {
      classList.remove('b-invalid');
      classList.add('b-checking');
      return new Promise(resolve => valid.then(valid => {
        data.valid = valid;

        if (!tip.isDestroyed) {
          resolve(me.updateTooltip());
        }
      }));
    } // Valid
    else if (valid === true) {
      classList.remove('b-invalid');
      classList.remove('b-checking');
      tipTitleIconClsSuffix = 'valid';
      tipTitleText = me.L('L{Dependencies.valid}');
    } // Invalid
    else {
      classList.remove('b-checking');
      classList.add('b-invalid');
      tipTitleIconClsSuffix = 'invalid';
      tipTitleText = me.L('L{Dependencies.invalid}');
    }

    tip.title = `<i class="b-icon b-icon-${tipTitleIconClsSuffix}"></i>${tipTitleText}`;
    tip.html = `<table class="b-sch-dependency-creation-tooltip">
                        <tr><td>${me.L('L{Dependencies.from}')}: </td><td>${data.fromText}</td><td><div class="b-sch-box b-${data.fromSide}"></div></td></tr>
                        <tr><td>${me.L('L{Dependencies.to}')}: </td><td>${data.toText}</td><td><div class="b-sch-box b-${data.toSide}"></div></td></tr>
                    </table>`;
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/feature/mixin/RecurringEventEdit.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");
/* harmony import */ var _view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../view/recurrence/field/RecurrenceCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js");
/* harmony import */ var _view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceLegendButton.js */ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js");
/* harmony import */ var _view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceEditor.js */ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






/**
 * @module Scheduler/feature/mixin/RecurringEventEdit
 */

/**
 * This mixin class provides recurring events functionality to the {@link Scheduler.feature.EventEdit event editor}.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringEventEdit extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'RecurringEventEdit';
  }

  static get configurable() {
    return {
      recurringEventsItems: {
        /**
         * Reference to the `Repeat` event field, if used
         * @member {Scheduler.view.recurrence.field.RecurrenceCombo} recurrenceCombo
         * @readonly
         */
        recurrenceCombo: {
          type: 'recurrencecombo',
          label: 'L{EventEdit.Repeat}',
          ref: 'recurrenceCombo',
          weight: 700
        },

        /**
         * Reference to the button that opens the event repeat settings dialog, if used
         * @member {Scheduler.view.recurrence.RecurrenceLegendButton} editRecurrenceButton
         * @readonly
         */
        editRecurrenceButton: {
          type: 'recurrencelegendbutton',
          ref: 'editRecurrenceButton',
          name: 'recurrenceRule',
          color: 'b-gray',
          flex: '1',
          weight: 800
        }
      },

      /**
       * Set to `false` to hide recurring fields in event editor,
       * even if the {@link Scheduler.view.mixin.RecurringEvents#config-enableRecurringEvents Recurring Events} is `true`
       * and a recurring event is being edited.
       * @config {Boolean}
       * @category Recurring
       */
      showRecurringUI: null
    };
  }

  changeEditorConfig(editorConfig) {
    editorConfig.items = _objectSpread(_objectSpread({}, editorConfig.items), this.recurringEventsItems); // EditBase inserts extraItems *after* all default items are in

    editorConfig = super.changeEditorConfig(editorConfig);
    return editorConfig;
  }

  construct(scheduler, config) {
    const me = this;
    super.construct(scheduler, config);
    me.scheduler.on({
      beforeEventDelete: me.onRecurrableEventBeforeDelete,
      beforeEventSave: me.onRecurrableEventBeforeSave,
      thisObj: me
    });
  }

  doDestroy() {
    this._recurrenceConfirmation && this.recurrenceConfirmation.destroy();
    this._recurrenceEditor && this.recurrenceEditor.destroy();
    super.doDestroy();
  }

  onEditorConstructed(editor) {
    const me = this;
    editor.on({
      hide: me.onRecurringEventEditorHide,
      thisObj: me
    });

    if (me.editRecurrenceButton) {
      me.editRecurrenceButton.menu = me.recurrenceEditor;
    }

    if (me.recurrenceCombo) {
      me.recurrenceCombo.on({
        change: me.onRecurrenceComboChange,
        thisObj: me
      });
    }
  }

  internalShowEditor() {
    this.toggleRecurringFieldsVisibility(this.client.enableRecurringEvents && this.showRecurringUI !== false);
  }

  toggleRecurringFieldsVisibility(show = true) {
    var _this$editRecurrenceB, _this$editRecurrenceB2, _this$recurrenceCombo, _this$recurrenceCombo2;

    const methodName = show ? 'show' : 'hide';
    (_this$editRecurrenceB = this.editRecurrenceButton) === null || _this$editRecurrenceB === void 0 ? void 0 : (_this$editRecurrenceB2 = _this$editRecurrenceB[methodName]) === null || _this$editRecurrenceB2 === void 0 ? void 0 : _this$editRecurrenceB2.call(_this$editRecurrenceB);
    (_this$recurrenceCombo = this.recurrenceCombo) === null || _this$recurrenceCombo === void 0 ? void 0 : (_this$recurrenceCombo2 = _this$recurrenceCombo[methodName]) === null || _this$recurrenceCombo2 === void 0 ? void 0 : _this$recurrenceCombo2.call(_this$recurrenceCombo);
  }

  onRecurringEventEditorHide() {
    var _this$recurrenceEdito, _this$recurrenceConfi;

    if ((_this$recurrenceEdito = this.recurrenceEditor) !== null && _this$recurrenceEdito !== void 0 && _this$recurrenceEdito.isVisible) {
      this.recurrenceEditor.hide();
    }

    if ((_this$recurrenceConfi = this.recurrenceConfirmation) !== null && _this$recurrenceConfi !== void 0 && _this$recurrenceConfi.isVisible) {
      this.recurrenceConfirmation.hide();
    }
  } // Builds RecurrenceModel to load into the recurrenceEditor
  // It builds the model based on either:
  // - recurrence rule string (if provided)
  // - or the event being edited recurrence (if the event is repeating)
  // - or simply make a recurrence model w/ default state (by default means: Frequency=Daily, Interval=1)


  makeRecurrence(rule) {
    const event = this.eventRecord,
          eventCopy = event.copy();
    let recurrence = event.recurrence;

    if (!rule && recurrence) {
      recurrence = recurrence.copy();
    } else {
      recurrence = new event.recurrenceModel(rule ? {
        rule
      } : {});
    } // bind cloned recurrence to the cloned event


    recurrence.timeSpan = eventCopy; // update cloned event w/ start date from the UI field

    eventCopy.setStartDate(this.values.startDate);
    recurrence.suspendTimeSpanNotifying();
    return recurrence;
  }

  onRecurrableEventBeforeSave({
    eventRecord,
    context
  }) {
    const me = this;

    if (eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence)) {
      me.recurrenceConfirmation.confirm({
        actionType: 'update',
        eventRecord,

        changerFn() {
          context.finalize(true);
        },

        cancelFn() {
          context.finalize(false);
        }

      }); // signalizes that we plan to decide save or not asynchronously

      context.async = true;
    }
  }

  showDisplayConfirmationOnEventDelete(eventRecord) {
    return this.isEditing && this.eventRecord === eventRecord && eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence);
  }

  onRecurrableEventBeforeDelete({
    eventRecords,
    context
  }) {
    const eventRecord = eventRecords[0];

    if (this.showDisplayConfirmationOnEventDelete(eventRecord)) {
      this.recurrenceConfirmation.confirm({
        actionType: 'delete',
        eventRecord,

        changerFn() {
          context.finalize(true);
        },

        cancelFn() {
          context.finalize(false);
        }

      });
      return false;
    }
  }

  set recurrenceConfirmation(recurrenceConfirmation) {
    this._recurrenceConfirmation = recurrenceConfirmation;
  }

  get recurrenceConfirmation() {
    const me = this;
    let recurrenceConfirmation = me._recurrenceConfirmation;

    if (!recurrenceConfirmation || !recurrenceConfirmation.$$name) {
      recurrenceConfirmation = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(Object.assign({
        type: 'recurrenceconfirmation',
        owner: me.getEditor()
      }, recurrenceConfirmation));
      me._recurrenceConfirmation = recurrenceConfirmation;
    }

    return recurrenceConfirmation;
  }

  set recurrenceEditor(recurrenceEditor) {
    this._recurrenceEditor = recurrenceEditor;
  }

  get recurrenceEditor() {
    const me = this;
    let recurrenceEditor = me._recurrenceEditor; // Recurrence editor is centered and modal.

    if (!recurrenceEditor || !recurrenceEditor.$$name) {
      recurrenceEditor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(Object.assign({
        type: 'recurrenceeditor',
        autoShow: false,
        centered: true,
        modal: true,
        constrainTo: window,
        anchor: false,
        rootElement: me.rootElement,
        saveHandler: me.recurrenceEditorSaveHandler,
        onBeforeShow: me.onBeforeShowRecurrenceEditor.bind(me),
        thisObj: me
      }, recurrenceEditor));
      me._recurrenceEditor = recurrenceEditor; // Must set *after* construction, otherwise it becomes the default state
      // to reset readOnly back to.  Must use direct property access because
      // getter consults state of editor.

      recurrenceEditor.readOnly = me._readOnly;
    }

    return recurrenceEditor;
  }

  onBeforeShowRecurrenceEditor() {
    const me = this,
          {
      recurrenceEditor,
      eventRecord
    } = me;

    if (recurrenceEditor && eventRecord && eventRecord.supportsRecurring) {
      // if the event has no recurrence yet ..initialize it before showing recurrence editor
      if (!me.recurrence) {
        me.recurrence = me.makeRecurrence();
      } // update the cloned recurrence w/ up to date start date value


      me.recurrence.timeSpan.setStartDate(me.values.startDate); // load RecurrenceModel record into the recurrence editor

      recurrenceEditor.record = me.recurrence; // In case they drag it. Centered falls off if the widget has position set.

      recurrenceEditor.centered = true;
    }
  }

  loadRecurrenceData(recurrence) {
    this.recurrence = recurrence;
    this.updateRecurrenceFields(recurrence);
  }

  updateRecurrenceFields(recurrence) {
    const me = this,
          {
      editRecurrenceButton
    } = me;

    if (me.recurrenceCombo) {
      me.recurrenceCombo.recurrence = recurrence;
    } // update the recurrence legend


    if (editRecurrenceButton) {
      editRecurrenceButton.recurrence = recurrence;
      editRecurrenceButton.value = recurrence ? recurrence.rule : null;

      if (recurrence && me.client.enableRecurringEvents && me.showRecurringUI !== false) {
        editRecurrenceButton.show();
      } else {
        editRecurrenceButton.hide();
      }
    }
  }

  onRecurrenceComboChange({
    source,
    value,
    userAction
  }) {
    const me = this,
          {
      recurrenceEditor
    } = me;

    if (value == source.customValue) {
      // if user picked "Custom" - show recurrence editor
      if (userAction) {
        // This will recurse through the change event into the opposite side
        // of the value test which will call updateRecurrenceFields, where the
        // assignment to the value of the recurrenceCombo will be a non-change.
        // That will sync the state of the recurrenceButton.
        me.recurrenceCombo.recurrence = me.makeRecurrence();

        if (recurrenceEditor.centered) {
          recurrenceEditor.show();
        } else {
          recurrenceEditor.show((me.editRecurrenceButton || source).element);
        }
      }
    } // user has picked some frequency -> make a new recurrence based on it
    else {
      me.loadRecurrenceData(value ? me.makeRecurrence(`FREQ=${value}`) : null);
    }
  }

  recurrenceEditorSaveHandler(editor, recurrence) {
    // apply changes to the kept recurrence
    editor.syncEventRecord(recurrence); // update the recurrence related UI

    this.updateRecurrenceFields(recurrence);
    editor.close();
  }

  onDatesChange(...args) {
    super.onDatesChange(...args);

    if (!this.loadingRecord && this.editRecurrenceButton) {
      const {
        startDate
      } = this.values;

      if (startDate) {
        this.editRecurrenceButton.eventStartDate = startDate;
      }
    }
  }

  internalLoadRecord(eventRecord, resourceRecord) {
    if (eventRecord && eventRecord.supportsRecurring) {
      this.loadRecurrenceData(eventRecord.recurrence ? this.makeRecurrence() : null);
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/localization/En.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/localization/En.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Grid_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/localization/En.js */ "./lib/Grid/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
var productName = 'gantt';
/* eslint-disable quote-props */

 //<umd>



const locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeLocales(_Grid_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"], {
  Object: {
    newEvent: 'New event'
  },
  ResourceInfoColumn: {
    eventCountText: function (data) {
      return data + ' event' + (data !== 1 ? 's' : '');
    }
  },
  Dependencies: {
    from: 'From',
    to: 'To',
    valid: 'Valid',
    invalid: 'Invalid'
  },
  DependencyType: {
    SS: 'SS',
    SF: 'SF',
    FS: 'FS',
    FF: 'FF',
    StartToStart: 'Start-to-Start',
    StartToEnd: 'Start-to-Finish',
    EndToStart: 'Finish-to-Start',
    EndToEnd: 'Finish-to-Finish',
    short: ['SS', 'SF', 'FS', 'FF'],
    long: ['Start-to-Start', 'Start-to-Finish', 'Finish-to-Start', 'Finish-to-Finish']
  },
  DependencyEdit: {
    From: 'From',
    To: 'To',
    Type: 'Type',
    Lag: 'Lag',
    'Edit dependency': 'Edit dependency',
    Save: 'Save',
    Delete: 'Delete',
    Cancel: 'Cancel',
    StartToStart: 'Start to Start',
    StartToEnd: 'Start to End',
    EndToStart: 'End to Start',
    EndToEnd: 'End to End'
  },
  EventEdit: {
    Name: 'Name',
    Resource: 'Resource',
    Start: 'Start',
    End: 'End',
    Save: 'Save',
    Delete: 'Delete',
    Cancel: 'Cancel',
    'Edit event': 'Edit event',
    Repeat: 'Repeat'
  },
  EventDrag: {
    eventOverlapsExisting: 'Event overlaps existing event for this resource',
    noDropOutsideTimeline: 'Event may not be dropped completely outside the timeline'
  },
  SchedulerBase: {
    'Add event': 'Add event',
    'Delete event': 'Delete event',
    'Unassign event': 'Unassign event'
  },
  // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.
  HeaderContextMenu: {
    pickZoomLevel: 'Zoom',
    activeDateRange: 'Date range',
    startText: 'Start date',
    endText: 'End date',
    todayText: 'Today'
  },
  TimeAxisHeaderMenu: {
    pickZoomLevel: 'Zoom',
    activeDateRange: 'Date range',
    startText: 'Start date',
    endText: 'End date',
    todayText: 'Today'
  },
  EventCopyPaste: {
    copyEvent: 'Copy event',
    cutEvent: 'Cut event',
    pasteEvent: 'Paste event'
  },
  EventFilter: {
    filterEvents: 'Filter tasks',
    byName: 'By name'
  },
  TimeRanges: {
    showCurrentTimeLine: 'Show current timeline'
  },
  PresetManager: {
    secondAndMinute: {
      displayDateFormat: 'll LTS'
    },
    minuteAndHour: {
      topDateFormat: 'ddd MM/DD, hA',
      displayDateFormat: 'll LST'
    },
    hourAndDay: {
      topDateFormat: 'ddd MM/DD',
      middleDateFormat: 'LST',
      displayDateFormat: 'll LST'
    },
    weekAndDay: {
      displayDateFormat: 'll LST'
    },
    dayAndWeek: {
      displayDateFormat: 'll LST'
    }
  },
  RecurrenceConfirmationPopup: {
    'delete-title': 'You are deleting an event',
    'delete-all-message': 'Do you want to delete all occurrences of this event?',
    'delete-further-message': 'Do you want to delete this and all future occurrences of this event, or only the selected occurrence?',
    'delete-further-btn-text': 'Delete All Future Events',
    'delete-only-this-btn-text': 'Delete Only This Event',
    'update-title': 'You are changing a repeating event',
    'update-all-message': 'Do you want to change all occurrences of this event?',
    'update-further-message': 'Do you want to change only this occurrence of the event, or this and all future occurrences?',
    'update-further-btn-text': 'All Future Events',
    'update-only-this-btn-text': 'Only This Event',
    Yes: 'Yes',
    Cancel: 'Cancel',
    width: 600
  },
  RecurrenceLegend: {
    ' and ': ' and ',
    // frequency patterns
    Daily: 'Daily',
    // Weekly on Sunday
    // Weekly on Sun, Mon and Tue
    'Weekly on {1}': ({
      days
    }) => `Weekly on ${days}`,
    // Monthly on 16
    // Monthly on the last weekday
    'Monthly on {1}': ({
      days
    }) => `Monthly on ${days}`,
    // Yearly on 16 of January
    // Yearly on the last weekday of January and February
    'Yearly on {1} of {2}': ({
      days,
      months
    }) => `Yearly on ${days} of ${months}`,
    // Every 11 days
    'Every {0} days': ({
      interval
    }) => `Every ${interval} days`,
    // Every 2 weeks on Sunday
    // Every 2 weeks on Sun, Mon and Tue
    'Every {0} weeks on {1}': ({
      interval,
      days
    }) => `Every ${interval} weeks on ${days}`,
    // Every 2 months on 16
    // Every 2 months on the last weekday
    'Every {0} months on {1}': ({
      interval,
      days
    }) => `Every ${interval} months on ${days}`,
    // Every 2 years on 16 of January
    // Every 2 years on the last weekday of January and February
    'Every {0} years on {1} of {2}': ({
      interval,
      days,
      months
    }) => `Every ${interval} years on ${days} of ${months}`,
    // day position translations
    position1: 'the first',
    position2: 'the second',
    position3: 'the third',
    position4: 'the fourth',
    position5: 'the fifth',
    'position-1': 'the last',
    // day options
    day: 'day',
    weekday: 'weekday',
    'weekend day': 'weekend day',
    // {0} - day position info ("the last"/"the first"/...)
    // {1} - day info ("Sunday"/"Monday"/.../"day"/"weekday"/"weekend day")
    // For example:
    //  "the last Sunday"
    //  "the first weekday"
    //  "the second weekend day"
    daysFormat: ({
      position,
      days
    }) => `${position} ${days}`
  },
  RecurrenceEditor: {
    'Repeat event': 'Repeat event',
    Cancel: 'Cancel',
    Save: 'Save',
    Frequency: 'Frequency',
    Every: 'Every',
    DAILYintervalUnit: 'day(s)',
    WEEKLYintervalUnit: 'week(s)',
    MONTHLYintervalUnit: 'month(s)',
    YEARLYintervalUnit: 'year(s)',
    Each: 'Each',
    'On the': 'On the',
    'End repeat': 'End repeat',
    'time(s)': 'time(s)'
  },
  RecurrenceDaysCombo: {
    day: 'day',
    weekday: 'weekday',
    'weekend day': 'weekend day'
  },
  RecurrencePositionsCombo: {
    position1: 'first',
    position2: 'second',
    position3: 'third',
    position4: 'fourth',
    position5: 'fifth',
    'position-1': 'last'
  },
  RecurrenceStopConditionCombo: {
    Never: 'Never',
    After: 'After',
    'On date': 'On date'
  },
  RecurrenceFrequencyCombo: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
  },
  RecurrenceCombo: {
    None: 'None',
    Custom: 'Custom...'
  },
  //region Features
  Summary: {
    'Summary for': date => `Summary for ${date}`
  },
  //endregion
  //region Export
  ScheduleRangeCombo: {
    completeview: 'Complete schedule',
    currentview: 'Visible schedule',
    daterange: 'Date range',
    completedata: 'Complete schedule (for all events)'
  },
  SchedulerExportDialog: {
    'Schedule range': 'Schedule range',
    'Export from': 'From',
    'Export to': 'To'
  },
  ExcelExporter: {
    'No resource assigned': 'No resource assigned'
  },
  //endregion
  CrudManagerView: {
    serverResponseLabel: 'Server response:'
  }
});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/Scheduler/model/AssignmentModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/AssignmentModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
var productName = 'gantt';




const EngineMixin = _Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreAssignmentMixin"];
/**
 * @module Scheduler/model/AssignmentModel
 */

/**
 * This model represent a single assignment of a resource to an event in scheduler, usually added to a
 * {@link Scheduler.data.AssignmentStore}.
 *
 * It is a subclass of {@link Core.data.Model} class. Please refer to the documentation for that class to become
 * familiar with the base interface of this class.
 *
 * ## Fields and references
 *
 * An Assignment has the following fields:
 * - `id` - The id of the assignment
 * - `resourceId` - The id of the resource assigned (optionally replaced with `resource` for load)
 * - `eventId` - The id of the event to which the resource is assigned (optionally replaced with `event` for load)
 *
 * The data source for these fields can be customized by subclassing this class:
 *
 * ```javascript
 * class MyAssignment extends AssignmentModel {
 *   static get fields() {
 *       return [
 *          { name : 'resourceId', dataSource : 'linkedResource' }
 *       ];
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `event` - The linked event record
 * - `resource` - The linked resource record
 *
 * ## Async resolving of references
 *
 * As described above, an assignment links an event to a resource. It holds references to an event record and a resource
 * record. These references are populated async, using the calculation engine of the project that the assignment via
 * its store is a part of. Because of this asyncness, references cannot be used immediately after modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // assignment.resource is not yet available
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // assignment.resource is available
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // assignment.resource is available
 * ```
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/AssignmentModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

class AssignmentModel extends Object(_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  // NOTE: Leave field defs at top to be picked up by jsdoc

  /**
   * Id for event to assign. Can be used as an alternative to `eventId`, but please note that after
   * load it will be populated with the actual event and not its id. This field is not persistable.
   * @field {Scheduler.model.EventModel} event
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Common
   */

  /**
   * Id for resource to assign to. Can be used as an alternative to `resourceId`, but please note that after
   * load it will be populated with the actual resource and not its id. This field is not persistable.
   * @field {Scheduler.model.ResourceModel} resource
   * @accepts {String|Number|Scheduler.model.ResourceModel}
   * @category Common
   */
  static get $name() {
    return 'AssignmentModel';
  }

}
AssignmentModel.exposeProperties();
AssignmentModel._$name = 'AssignmentModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyBaseModel.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/model/DependencyBaseModel.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyBaseModel; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'gantt';




/**
 * @module Scheduler/model/DependencyBaseModel
 */

const canonicalDependencyTypes = ['SS', 'SF', 'FS', 'FF'];
/**
 * Base class used for both Scheduler and Gantt. Not intended to be used directly
 *
 * @extends Core/data/Model
 */

class DependencyBaseModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  static get $name() {
    return 'DependencyBaseModel';
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   **
   * ```javascript
   * dependency.set('from', 2);
   * // dependency.fromEvent is not yet up to date
   *
   * await dependency.setAsync('from', 2);
   * // dependency.fromEvent is up to date
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields

  /**
   * An enumerable object, containing names for the dependency types integer constants.
   * - 0 StartToStart
   * - 1 StartToEnd
   * - 2 EndToStart
   * - 3 EndToEnd
   * @property {Object}
   * @readonly
   * @category Dependency
   */


  static get Type() {
    return {
      StartToStart: 0,
      StartToEnd: 1,
      EndToStart: 2,
      EndToEnd: 3
    };
  }

  static get fields() {
    return [// 3 mandatory fields

    /**
     * From event, id of source event
     * @field {String|Number} from
     * @category Dependency
     */
    {
      name: 'from'
    },
    /**
     * To event, id of target event
     * @field {String|Number} to
     * @category Dependency
     */
    {
      name: 'to'
    },
    /**
     * Dependency type, see static property {@link #property-Type-static}
     * @field {Number} type=2
     * @category Dependency
     */
    {
      name: 'type',
      type: 'int',
      defaultValue: 2
    },
    /**
     * CSS class to apply to lines drawn for the dependency
     * @field {String} cls
     * @category Styling
     */
    {
      name: 'cls',
      defaultValue: ''
    },
    /**
     * Bidirectional, drawn with arrows in both directions
     * @field {Boolean} bidirectional
     * @category Dependency
     */
    {
      name: 'bidirectional',
      type: 'boolean'
    },
    /**
     * Start side on source (top, left, bottom, right)
     * @field {String} fromSide
     * @category Dependency
     */
    {
      name: 'fromSide',
      type: 'string'
    },
    /**
     * End side on target (top, left, bottom, right)
     * @field {String} toSide
     * @category Dependency
     */
    {
      name: 'toSide',
      type: 'string'
    },
    /**
     * The magnitude of this dependency's lag (the number of units).
     * @field {Number} lag
     * @category Dependency
     */
    {
      name: 'lag',
      type: 'number',
      allowNull: true,
      defaultValue: 0
    },
    /**
     * The units of this dependency's lag, defaults to "d" (days). Valid values are:
     *
     * - "ms" (milliseconds)
     * - "s" (seconds)
     * - "m" (minutes)
     * - "h" (hours)
     * - "d" (days)
     * - "w" (weeks)
     * - "M" (months)
     * - "y" (years)
     *
     * This field is readonly after creation, to change `lagUnit` use {@link #function-setLag setLag()}.
     * @field {String} lagUnit
     * @category Dependency
     * @readonly
     */
    {
      name: 'lagUnit',
      type: 'string',
      defaultValue: 'd'
    }];
  } // fromEvent/toEvent defined in CoreDependencyMixin in engine

  /**
   * Gets/sets the source event of the dependency.
   *
   * Accepts multiple formats but always returns an {@link Scheduler.model.EventModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-from} instead.
   *
   * @field {Scheduler.model.EventModel} fromEvent
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Dependency
   */

  /**
   * Gets/sets the target event of the dependency.
   *
   * Accepts multiple formats but always returns an {@link Scheduler.model.EventModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-to} instead.
   *
   * @field {Scheduler.model.EventModel} toEvent
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Dependency
   */

  /**
   * Gets/sets the source event of the dependency
   *
   * @property {Scheduler.model.EventModel}
   * @deprecated 4.0.0 Deprecated in favor of fromEvent
   * @category Dependency
   */


  get sourceEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of fromEvent');
    return this.fromEvent;
  }

  set sourceEvent(event) {
    this.fromEvent = event;
  }
  /**
   * Gets/sets the target event of the dependency
   *
   * @property {Scheduler.model.EventModel}
   * @deprecated 4.0.0 Deprecated in favor of toEvent
   * @category Dependency
   */


  get targetEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of toEvent');
    return this.toEvent;
  }

  set targetEvent(event) {
    this.targetEvent = event;
  } //endregion
  //region Init


  construct(data) {
    const from = data[this.fieldMap.from.dataSource],
          to = data[this.fieldMap.to.dataSource]; // Engine expects fromEvent and toEvent, not from and to. We need to support both

    if (from != null) {
      data.fromEvent = from;
    }

    if (to != null) {
      data.toEvent = to;
    }

    super.construct(...arguments);
  } //endregion


  get eventStore() {
    var _this$unjoinedStores$;

    return this.eventStore || ((_this$unjoinedStores$ = this.unjoinedStores[0]) === null || _this$unjoinedStores$ === void 0 ? void 0 : _this$unjoinedStores$.eventStore);
  }

  set from(value) {
    const {
      fromEvent
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (fromEvent !== null && fromEvent !== void 0 && fromEvent.isModel && fromEvent.id === value) {
      this.set('from', value);
    } else {
      this.fromEvent = value;
    }
  }

  get from() {
    return this.get('from');
  }

  set to(value) {
    const {
      toEvent
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (toEvent !== null && toEvent !== void 0 && toEvent.isModel && toEvent.id === value) {
      this.set('to', value);
    } else {
      this.toEvent = value;
    }
  }

  get to() {
    return this.get('to');
  }
  /**
   * Alias to dependency type, but when set resets {@link #field-fromSide} & {@link #field-toSide} to null as well.
   *
   * @property {Number}
   * @category Dependency
   */


  get hardType() {
    return this.getHardType();
  }

  set hardType(type) {
    this.setHardType(type);
  }
  /**
   * Returns dependency hard type, see {@link #property-hardType}.
   *
   * @return {Number}
   * @category Dependency
   */


  getHardType() {
    return this.get('type');
  }
  /**
   * Sets dependency {@link #field-type} and resets {@link #field-fromSide} and {@link #field-toSide} to null.
   *
   * @param {Number} type
   * @category Dependency
   */


  setHardType(type) {
    let result;

    if (type !== this.hardType) {
      result = this.set({
        type,
        fromSide: null,
        toSide: null
      });
    }

    return result;
  }

  get lag() {
    return this.get('lag');
  }

  set lag(lag) {
    if (typeof lag === 'number') {
      this.set({
        lag
      });
    } else {
      this.setLag(lag);
    }
  }
  /**
   * Sets lag and lagUnit in one go. Only allowed way to change lagUnit, the lagUnit field is readonly after creation
   * @param {Number|String|Object} lag The lag value. May be just a numeric magnitude, or a full string descriptor eg '1d'
   * @param {String} [lagUnit] Unit for numeric lag value, see {@link #field-lagUnit} for valid values
   * @category Dependency
   */


  setLag(lag, lagUnit) {
    // Either they're only setting the magnitude
    // or, if it's a string, parse the full duration.
    if (arguments.length === 1) {
      if (typeof lag === 'number') {
        this.lag = lag;
      } else {
        lag = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(lag);
        this.set({
          lag: lag.magnitude,
          lagUnit: lag.unit
        });
      }

      return;
    } // Must be a number


    lag = parseFloat(lag);
    this.set({
      lag,
      lagUnit
    });
  }

  getLag() {
    if (this.lag) {
      return `${this.lag < 0 ? '-' : '+'}${Math.abs(this.lag)}${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getShortNameOfUnit(this.lagUnit)}`;
    }

    return '';
  }
  /**
   * Property which encapsulates the lag's magnitude and units. An object which contains two properties:
   * @property {Core.data.Duration}
   * @property {Number} fullLag.magnitude The magnitude of the duration
   * @property {String} fullLag.unit The unit in which the duration is measured, eg `'d'` for days
   * @category Dependency
   */


  get fullLag() {
    return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      unit: this.lagUnit,
      magnitude: this.lag
    });
  }

  set fullLag(lag) {
    if (typeof lag === 'string') {
      this.setLag(lag);
    } else {
      this.setLag(lag.magnitude, lag.unit);
    }
  }
  /**
   * Returns true if the linked events have been persisted (e.g. neither of them are 'phantoms')
   *
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isPersistable() {
    const me = this,
          {
      stores,
      unjoinedStores
    } = me,
          store = stores[0];
    let result;

    if (store) {
      const {
        fromEvent,
        toEvent
      } = me,
            crudManager = store.crudManager; // if crud manager is used it can deal with phantom source/target since it persists all records in one batch
      // if no crud manager used we have to wait till source/target are persisted

      result = fromEvent && (crudManager || !fromEvent.hasGeneratedId) && toEvent && (crudManager || !toEvent.hasGeneratedId);
    } else {
      result = Boolean(unjoinedStores[0]);
    }

    return result && super.isPersistable;
  }
  /**
   * Returns the source event of the dependency
   *
   * @return {Scheduler.model.EventModel} The source event of this dependency
   * @category Dependency
   * @deprecated 5.0 Deprecated in favor of `toEvent`
   */


  getSourceEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of fromEvent');
    return this.fromEvent;
  }
  /**
   * Returns the target event of the dependency
   *
   * @return {Scheduler.model.EventModel} The target event of this dependency
   * @category Dependency
   * @deprecated 5.0 Deprecated in favor of `toEvent`
   */


  getTargetEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of toEvent');
    return this.toEvent;
  }

  getDateRange() {
    const {
      fromEvent,
      toEvent
    } = this;

    if (fromEvent !== null && fromEvent !== void 0 && fromEvent.isScheduled && toEvent !== null && toEvent !== void 0 && toEvent.isScheduled) {
      const Type = DependencyBaseModel.Type;
      let sourceDate, targetDate;

      switch (this.type) {
        case Type.StartToStart:
          sourceDate = fromEvent.startDateMS;
          targetDate = toEvent.startDateMS;
          break;

        case Type.StartToEnd:
          sourceDate = fromEvent.startDateMS;
          targetDate = toEvent.endDateMS;
          break;

        case Type.EndToEnd:
          sourceDate = fromEvent.endDateMS;
          targetDate = toEvent.endDateMS;
          break;

        case Type.EndToStart:
          sourceDate = fromEvent.endDateMS;
          targetDate = toEvent.startDateMS;
          break;

        default:
          throw new Error('Invalid dependency type: ' + this.type);
      }

      return {
        start: Math.min(sourceDate, targetDate),
        end: Math.max(sourceDate, targetDate)
      };
    }

    return null;
  }
  /**
   * Applies given CSS class to dependency, the value doesn't persist
   *
   * @param {String} cls
   * @category Dependency
   */


  highlight(cls) {
    const h = this.highlighted ? this.highlighted.split(' ') : [];
    if (!h.includes(cls)) this.highlighted = h.concat(cls).join(' ');
  }
  /**
   * Removes given CSS class from dependency if applied, the value doesn't persist
   *
   * @param {String} cls
   * @category Dependency
   */


  unhighlight(cls) {
    const {
      highlighted
    } = this;

    if (highlighted) {
      const h = highlighted.split(' '),
            idx = h.findIndex(i => i === cls);

      if (idx >= 0) {
        h.splice(idx, 1);
        this.highlighted = h.join(' ');
      }
    }
  }
  /**
   * Checks if the given CSS class is applied to dependency.
   *
   * @param {String} cls
   * @return {Boolean}
   * @category Dependency
   */


  isHighlightedWith(cls) {
    return this.highlighted && this.highlighted.split(' ').includes(cls);
  }

  getConnectorString(raw) {
    const rawValue = canonicalDependencyTypes[this.type];

    if (raw) {
      return rawValue;
    } // FS => empty string; it's the default


    if (this.type === DependencyBaseModel.Type.EndToStart) {
      return '';
    }

    return rawValue;
  } // getConnectorStringFromType(type, raw) {
  //     const rawValue = canonicalDependencyTypes[type];
  //
  //     if (raw) {
  //         return rawValue;
  //     }
  //
  //     // FS => empty string; it's the default
  //     if (type === DependencyBaseModel.Type.EndToStart) {
  //         return '';
  //     }
  //
  //     const locale = LocaleManager.locale;
  //
  //     // See if there is a local version of SS, SF or FF
  //     if (locale) {
  //         const localized = locale.Scheduler && locale.Scheduler[rawValue];
  //         if (localized) {
  //             return localized;
  //         }
  //     }
  //
  //     return rawValue;
  // }
  // getConnectorString(raw) {
  //     return this.getConnectorStringFromType(this.type);
  // }
  // * getConnectorStringGenerator(raw) {
  //     return this.getConnectorStringFromType(yield this.$.type);
  // }


  toString() {
    return `${this.from}${this.getConnectorString()}${this.getLag()}`;
  }
  /**
   * Returns `true` if the dependency is valid. Has valid type and both source and target ids set and not links to itself.
   *
   * @property {Boolean}
   * @typings ignore
   * @category Editing
   */


  get isValid() {
    const {
      from,
      to,
      type
    } = this;
    return typeof type === 'number' && from && from !== '' && to != null && to !== '' && from !== to;
  }

  get fromEventName() {
    var _this$fromEvent;

    return ((_this$fromEvent = this.fromEvent) === null || _this$fromEvent === void 0 ? void 0 : _this$fromEvent.name) || '';
  }

  get toEventName() {
    var _this$toEvent;

    return ((_this$toEvent = this.toEvent) === null || _this$toEvent === void 0 ? void 0 : _this$toEvent.name) || '';
  }

}
DependencyBaseModel.exposeProperties();
DependencyBaseModel._$name = 'DependencyBaseModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/DependencyModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyModel; });
/* harmony import */ var _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
var productName = 'gantt';



const EngineMixin = _Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreDependencyMixin"];
/**
 * @module Scheduler/model/DependencyModel
 */

/**
 * This model represents a dependency between two events, usually added to a {@link Scheduler.data.DependencyStore}.
 *
 * It is a subclass of the {@link Scheduler.model.DependencyBaseModel} class, which in its turn subclasses
 * {@link Core.data.Model}. Please refer to documentation of those classes to become familiar with the base interface of
 * this class.
 *
 * ## Fields and references
 *
 * A Dependency has a few predefined fields, see Fields below.  The name of any fields data source can be customized in
 * the subclass, see the example below. Please also refer to {@link Core.data.Model} for details.
 *
 * ```javascript
 * class MyDependency extends DependencyModel {
 *   static get fields() {
 *     return [
 *       { name: 'to', dataSource: 'targetId' },
 *       { name: 'from', dataSource: 'sourceId' }
 *     ]);
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `fromEvent` - The event on the start side of the dependency
 * - `toEvent` - The event on the end side of the dependency
 *
 * ## Async resolving of references
 *
 * As described above, a dependency has links to events. These references are populated async, using the calculation
 * engine of the project that the resource via its store is a part of. Because of this asyncness, references cannot be
 * used immediately after modifications:
 *
 * ```javascript
 * dependency.from = 2;
 * // dependency.fromEvent is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * dependency.from = 2;
 * await dependency.project.commitAsync();
 * // dependency.fromEvent is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await dependency.setAsync({ from : 2});
 * // dependency.fromEvent is up to date
 * ```
 *
 * @extends Scheduler/model/DependencyBaseModel
 * @uninherit Core/data/mixin/TreeNode
 */

class DependencyModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get $name() {
    return 'DependencyModel';
  } // Determines the type of dependency based on fromSide and toSide


  getTypeFromSides(fromSide, toSide, rtl) {
    const types = _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__["default"].Type,
          startSide = rtl ? 'right' : 'left',
          endSide = rtl ? 'left' : 'right';

    if (fromSide === startSide) {
      return toSide === startSide ? types.StartToStart : types.StartToEnd;
    }

    return toSide === endSide ? types.EndToEnd : types.EndToStart;
  }

}
DependencyModel.exposeProperties();
DependencyModel._$name = 'DependencyModel';

/***/ }),

/***/ "./lib/Scheduler/model/EventModel.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/model/EventModel.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventModel; });
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony import */ var _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
var productName = 'gantt';





const EngineMixin = _Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_4__["SchedulerCoreEvent"];
/**
 * @module Scheduler/model/EventModel
 */

/**
 * This class represent a single event in your schedule, usually added to a {@link Scheduler.data.EventStore}.
 *
 * It is a subclass of the {@link Scheduler.model.TimeSpan}, which is in turn subclass of {@link Core.data.Model}.
 * Please refer to documentation of that class to become familiar with the base interface of the event.
 *
 * ## Async date calculations
 *
 * A record created from an {@link Scheduler/model/EventModel} is normally part of an {@link Scheduler.data.EventStore},
 * which in turn is part of a project. When dates or the duration of an event is changed, the project performs async calculations
 * to normalize the other fields.
 * For example if {@link #field-duration} is changed, it will calculate {@link #field-endDate}.
 *
 * As a result of this being an async operation, the values of other fields are not guaranteed to be up to date
 * immediately after a change. To ensure data is up to date, await the calculations to finish.
 *
 * For example, {@link #field-endDate} is not up to date after this operation:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * // endDate not yet calculated
 * ```
 *
 * But if calculations are awaited it is up to date:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * await eventRecord.project.commitAsync();
 * // endDate is calculated
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await eventRecord.setAsync({ duration : 5});
 * // endDate is calculated
 * ```
 *
 * ## Subclassing the Event model class
 * The Event model has a few predefined fields as seen below. If you want to add new fields or change the options for the existing fields,
 * you can do that by subclassing this class (see example below).
 *
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            // Add new field
 *            { name: 'myField', type : 'number', defaultValue : 0 }
 *         ];
 *     },
 *
 *     myCheckMethod() {
 *         return this.myField > 0
 *     },
 *
 *     ...
 * });
 * ```
 * If you in your data want to use other names for the {@link #field-startDate}, {@link #field-endDate}, {@link #field-resourceId} and name fields you can configure
 * them as seen below:
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            { name: 'startDate', dataSource : 'taskStart' },
 *            { name: 'endDate', dataSource : 'taskEnd', format: 'YYYY-MM-DD' },
 *            { name: 'resourceId', dataSource : 'userId' },
 *            { name: 'name', dataSource : 'taskTitle' },
 *         ];
 *     },
 *     ...
 * });
 * ```
 *
 * Please refer to {@link Core.data.Model} for additional details.
 *
 * @extends Scheduler/model/TimeSpan
 * @mixes Scheduler/model/mixin/RecurringTimeSpan
 * @mixes Scheduler/model/mixin/EventModelMixin
 */

class EventModel extends EngineMixin.derive(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"]).mixin(_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_1__["default"], _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'EventModel';
  }

}
EventModel.exposeProperties();
EventModel._$name = 'EventModel';

/***/ }),

/***/ "./lib/Scheduler/model/ProjectModel.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/model/ProjectModel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony import */ var _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/util/ModelPersistencyManager.js */ "./lib/Scheduler/data/util/ModelPersistencyManager.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js");
var productName = 'gantt';





const EngineMixin = _Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__["SchedulerCoreProjectMixin"];
/**
 * @module Scheduler/model/ProjectModel
 */

/**
 * This class represents a global project of your Scheduler - a central place for all data.
 *
 * It holds and links the stores usually used by Scheduler:
 *
 * - {@link Scheduler.data.EventStore}
 * - {@link Scheduler.data.ResourceStore}
 * - {@link Scheduler.data.AssignmentStore}
 * - {@link Scheduler.data.DependencyStore}
 * - {@link #config-timeRangeStore TimeRangeStore}
 * - {@link Scheduler.data.ResourceTimeRangeStore}
 *
 * The project uses a calculation engine to normalize dates and durations. It is also responsible for
 * handling references between models, for example to link an event via an assignment to a resource. These operations
 * are asynchronous, a fact that is hidden when working in the Scheduler UI but which you must know about when performing
 * more advanced operations on the data level.
 *
 * When there is a change to data that requires something else to be recalculated, the project schedules a calculation (a
 * commit) which happens moments later. It is also possible to trigger these calculations directly. This snippet illustrate
 * the process:
 *
 1. Something changes which requires the project to recalculate, for example adding a new task:
 *
 * ```javascript
 * const [event] = project.eventStore.add({ startDate, endDate });
 * ```
 *
 * 2. A recalculation is scheduled, thus:
 *
 * ```javascript
 * event.duration; // <- Not yet calculated
 * ```
 *
 * 3. Calculate now instead of waiting for the scheduled calculation
 *
 * ```javascript
 * await project.commitAsync();
 *
 * event.duration; // <- Now available
 * ```
 *
 * ## Using inline data
 *
 * The project provides settable property {@link Scheduler.crud.AbstractCrudManager#property-inlineData} that can
 * be used to get data from all its stores at once and to set this data as well. Populating the stores this way can
 * be useful if you cannot or you do not want to use CrudManager for server requests but you pull the data by other
 * means and have it ready outside of ProjectModel. Also, the data from all stores is available in a single
 * assignment statement.
 *
 * ### Getting data
 * ```javascript
 * const data = scheduler.project.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * const data = // your function to pull server data
 *
 * scheduler.project = data;
 * ```
 *
 * ## Monitoring data changes
 *
 * While it is possible to listen for data changes on the projects individual stores, it is sometimes more convenient
 * to have a centralized place to handle all data changes. By listening for the {@link #event-change change event} your
 * code gets notified when data in any of the stores changes. Useful for example to keep an external data model up to
 * date:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     project: {
 *         listeners : {
 *             change({ store, action, records }) {
 *                 const { $name } = store.constructor;
 *
 *                 if (action === 'add') {
 *                     externalDataModel.add($name, records);
 *                 }
 *
 *                 if (action === 'remove') {
 *                     externalDataModel.remove($name, records);
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core.data.stm.StateTrackingManager StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). You can enable it to track all
 * project store changes:
 *
 * ```javascript
 * // Turn on auto recording when you create your Scheduler:
 * const scheduler = new Scheduler({
 *    project : {
 *        stm : {
 *            autoRecord : true
 *        }
 *    }
 * });
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * Check out the `undoredo` demo to see it in action.
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/ProjectModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

class ProjectModel extends Object(_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(EngineMixin) {
  static get $name() {
    return 'ProjectModel';
  } //region Events

  /**
   * Fired when the engine has finished its calculations and the results has been written back to the records.
   *
   * ```javascript
   * scheduler.project.on({
   *     dataReady() {
   *        console.log('Calculations finished');
   *     }
   * });
   *
   * scheduler.eventStore.first.duration = 10;
   *
   * // At some point a bit later it will log 'Calculations finished'
   * ```
   *
   * @event dataReady
   * @param {Scheduler.model.ProjectModel} source The project
   */
  //endregion

  /**
   * Silences propagations caused by the project loading.
   *
   * Applying the loaded data to the project occurs in two basic stages:
   *
   * 1. Data gets into the engine graph which triggers changes propagation
   * 2. The changes caused by the propagation get written to related stores
   *
   * Setting this flag to `true` makes the component perform step 2 silently without triggering events causing reactions on those changes
   * (like sending changes back to the server if `autoSync` is enabled) and keeping stores in unmodified state.
   *
   * This is safe if the loaded data is consistent so propagation doesn't really do any adjustments.
   * By default the system treats the data as consistent so this option is `true`.
   *
   * ```js
   * new Scheduler({
   *     project : {
   *         // We want scheduling engine to recalculate the data properly
   *         // so then we could save it back to the server
   *         silenceInitialCommit : false
   *     }
   *     ...
   * })
   * ```
   *
   * @config {Boolean} silenceInitialCommit
   * @default true
   */


  construct(...args) {
    super.construct(...args);

    if (_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTestEnv) {
      _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.bryntum.testProject = this;
    } // Moved here from EventStore, since project is now the container instead of it


    this.modelPersistencyManager = this.createModelPersistencyManager();
  }
  /**
   * Creates and returns model persistency manager
   *
   * @return {Scheduler.data.util.ModelPersistencyManager}
   * @internal
   */


  createModelPersistencyManager() {
    return new _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      eventStore: this,
      resourceStore: this.resourceStore,
      assignmentStore: this.assignmentStore,
      dependencyStore: this.dependencyStore
    });
  }

  doDestroy() {
    this.modelPersistencyManager.destroy();
    super.doDestroy();
  } // To comply with TaskBoards expectations


  get taskStore() {
    return this.eventStore;
  }

}
ProjectModel.applyConfigs = true;
ProjectModel.initClass();
ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/Scheduler/model/RecurrenceModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/RecurrenceModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/util/recurrence/DailyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../data/util/recurrence/WeeklyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../data/util/recurrence/MonthlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../data/util/recurrence/YearlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js");
var productName = 'gantt';







/**
 * @module Scheduler/model/RecurrenceModel
 */

const recurrenceIterators = {};
[_data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__["default"], _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_4__["default"], _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_5__["default"], _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_6__["default"]].forEach(it => {
  recurrenceIterators[it.frequency] = it;
});

function convertStringOfIntegerItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',').map(item => parseInt(item, 10));
    }
  } else {
    value = null;
  }

  return value;
}

function convertStringOfItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',');
    }
  } else {
    value = null;
  }

  return value;
}

function isEqualAsString(value1, value2) {
  return String(value1) === String(value2);
}

function convertInteger(value) {
  if (this.defaultValue && value === undefined) {
    return this.defaultValue;
  }

  if (this.allowNull && value == null) {
    return null;
  }

  value = parseInt(value);
  return isNaN(value) ? undefined : value;
}
/**
 * This class represents a timespan recurrence settings.
 * It is a subclass of {@link Core.data.Model} class.
 * Please refer to the documentation for that class to become familiar with the base interface of this class.
 *
 * The data source for these fields can be customized by subclassing this class.
 *
 * @extends Core/data/Model
 */


class RecurrenceModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceModel';
  }
  /**
   * Indicates that this is a `RecurrenceModel` class instance
   * (allows to avoid using `instanceof`).
   * @property {Boolean}
   * @readonly
   */


  get isRecurrenceModel() {
    return true;
  } //region Fields


  static get fields() {
    return [
    /**
     * Field defines the recurrence frequency. Supported values are: `DAILY`, `WEEKLY`, `MONTHLY`, `YEARLY`.
     * @field {String} frequency
     */
    {
      name: 'frequency',
      defaultValue: 'DAILY'
    },
    /**
     * Field defines how often the recurrence repeats.
     * For example, if the recurrence is weekly its interval is 2, then the timespan repeats every two weeks.
     * @field {Number} interval
     */
    {
      name: 'interval',
      defaultValue: 1,
      convert: convertInteger
    },
    /**
     * End date of the recurrence. Specifies when the recurrence ends.
     * The value is optional, the recurrence can as well be stopped using {@link #field-count} field value.
     * @field {Date} endDate
     */
    {
      name: 'endDate',
      type: 'date'
    },
    /**
     * Specifies the number of occurrences after which the recurrence ends.
     * The value includes the associated timespan itself so values less than 2 make no sense.
     * The field is optional, the recurrence as well can be stopped using {@link #field-endDate} field value.
     * @field {Number} count
     */
    {
      name: 'count',
      allowNull: true,
      convert: convertInteger
    },
    /**
     * Specifies days of the week on which the timespan should occur.
     * An array of string values `SU`, `MO`, `TU`, `WE`, `TH`, `FR`, `SA`
     * corresponding to Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, and Saturday days of the week.
     * Each value can also be preceded by a positive (+n) or negative (-n) integer.
     * If present, this indicates the nth occurrence of a specific day within the monthly or yearly recurrence.
     *
     * **Not applicable** for daily {@link #field-frequency}.
     * @field {String[]} days
     */
    {
      name: 'days',
      convert: convertStringOfItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * Specifies days of the month on which the timespan should occur.
     * An array of integer values (-31..-1 - +1..+31, negative values mean counting backwards from the month end).
     * **Applicable only** for monthly {@link #field-frequency}.
     * @field {Number[]} monthDays
     */
    {
      name: 'monthDays',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * Specifies months of the year on which the timespan should occur.
     * An array of integer values (1 - 12).
     * **Applicable only** for yearly {@link #field-frequency}.
     * @field {Number[]} months
     */
    {
      name: 'months',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * The positions to include in the recurrence. The values operate on a set of recurrence instances **in one interval** of the recurrence rule.
     * An array of integer values (valid values are 1 to 366 or -366 to -1, negative values mean counting backwards from the end of the built list of occurrences).
     * **Not applicable** for daily {@link #field-frequency}.
     * @field {Number} positions
     */
    {
      name: 'positions',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    }];
  }

  get dateFormat() {
    return this._dateFormat || 'YYYYMMDDTHHmmss';
  }

  set dateFormat(format) {
    this._dateFormat = format;
  }

  get recurrenceIterator() {
    return recurrenceIterators[this.frequency];
  }
  /**
   * The timespan this recurrence is associated with.
   * @property {Scheduler.model.TimeSpan}
   */


  get timeSpan() {
    return this._timeSpan;
  }

  set timeSpan(value) {
    this._timeSpan = value;
  }
  /**
   * The recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
   * @property {String}
   */


  get rule() {
    const me = this,
          result = [];

    if (me.frequency) {
      result.push(`FREQ=${me.frequency}`);

      if (me.interval > 1) {
        result.push(`INTERVAL=${me.interval}`);
      }

      if (me.days && me.days.length) {
        result.push('BYDAY=' + me.days.join(','));
      }

      if (me.monthDays && me.monthDays.length) {
        result.push('BYMONTHDAY=' + me.monthDays.join(','));
      }

      if (me.months && me.months.length) {
        result.push('BYMONTH=' + me.months.join(','));
      }

      if (me.count) {
        result.push(`COUNT=${me.count}`);
      }

      if (me.endDate) {
        result.push('UNTIL=' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(me.endDate, me.dateFormat));
      }

      if (me.positions && me.positions.length) {
        result.push('BYSETPOS=' + me.positions.join(','));
      }
    }

    return result.join(';');
  }

  set rule(rule) {
    const me = this,
          values = {
      frequency: null,
      interval: null,
      count: null,
      endDate: null,
      days: null,
      monthDays: null,
      months: null,
      positions: null
    };
    me.beginBatch();

    if (rule) {
      const parts = rule.split(';');

      for (let i = 0, len = parts.length; i < len; i++) {
        const part = parts[i].split('='),
              value = part[1];

        switch (part[0]) {
          case 'FREQ':
            values.frequency = value;
            break;

          case 'INTERVAL':
            values.interval = value;
            break;

          case 'COUNT':
            values.count = value;
            values.until = null;
            break;

          case 'UNTIL':
            if (value) {
              values.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(value, me.dateFormat);
            } else {
              values.endDate = null;
            }

            values.count = null;
            break;

          case 'BYDAY':
            values.days = value;
            break;

          case 'BYMONTHDAY':
            values.monthDays = value;
            break;

          case 'BYMONTH':
            values.months = value;
            break;

          case 'BYSETPOS':
            values.positions = value;
            break;
        }
      }
    }

    me.set(values);

    if (rule) {
      me.sanitize();
    }

    me.endBatch();
  }

  construct(data = {}) {
    const me = this,
          {
      rule,
      timeSpan
    } = data;
    me._suspendedTimeSpanNotifying = 0;
    delete data.timeSpan;
    delete data.rule;
    super.construct(...arguments);

    if (rule) {
      me.suspendTimeSpanNotifying();
      me.rule = rule;
      me.resumeTimeSpanNotifying();
    }

    me.timeSpan = timeSpan;
  }
  /**
   * Iterate occurrences for the owning timespan across the specified date range. This method can be called even
   * if the timespan is not yet a member of a store, however, the occurrences returned will not be cached across
   * subsequent calls to this method.
   * @param {Date} startDate The start date of the iteration.
   * @param {Date} endDate The end date of the iteration.
   * @param {Function} fn The function to call for each occurrence.
   * @param {Scheduler.model.TimeSpan} fn.occurrence The occurrence.
   * @param {Boolean} fn.first A flag which is `true` for the first occurrence of this recurrence.
   * @param {Number} fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Date} fn.date The occurrence date.
   * @internal
   */


  forEachOccurrence(startDate, endDate, fn) {
    if (this.timeSpan.startDate) {
      this.recurrenceIterator.forEachDate({
        recurrence: this,
        startDate,
        endDate,

        fn(date, counter, first, timeSpan) {
          fn(timeSpan.buildOccurrence(date, first), first, counter, date);
        }

      });
    }
  }
  /**
   * Cleans up fields that do not makes sense for the current {@link #field-frequency} value.
   * @private
   */


  sanitize() {
    var _me$timeSpan, _me$monthDays;

    const me = this,
          timeSpanStartDate = (_me$timeSpan = me.timeSpan) === null || _me$timeSpan === void 0 ? void 0 : _me$timeSpan.startDate,
          values = {};
    me.isSanitizing = true;

    switch (me.frequency) {
      case 'DAILY':
        values.positions = null;
        values.days = null;
        values.monthDays = null;
        values.months = null;
        break;

      case 'WEEKLY':
        values.positions = null;
        values.monthDays = null;
        values.months = null;
        const {
          days
        } = me;

        if (timeSpanStartDate && (days === null || days === void 0 ? void 0 : days.length) == 1 && days[0] == _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeDay(timeSpanStartDate.getDay())) {
          values.days = null;
        }

        break;

      case 'MONTHLY':
        if ((_me$monthDays = me.monthDays) !== null && _me$monthDays !== void 0 && _me$monthDays.length) {
          values.positions = null;
          values.days = null;
        }

        values.months = null;
        const {
          monthDays
        } = me;

        if (timeSpanStartDate && (monthDays === null || monthDays === void 0 ? void 0 : monthDays.length) == 1 && monthDays[0] == timeSpanStartDate.getDate()) {
          values.monthDays = null;
        }

        break;

      case 'YEARLY':
        values.monthDays = null;
        const {
          months
        } = me;

        if (timeSpanStartDate && (months === null || months === void 0 ? void 0 : months.length) == 1 && months[0] == timeSpanStartDate.getMonth() + 1) {
          values.months = null;
        }

        break;
    }

    me.set(values);
    me.isSanitizing = false;
  }

  copy(...args) {
    const result = super.copy(...args);
    result.dateFormat = this.dateFormat;
    result.timeSpan = this.timeSpan;
    return result;
  }

  afterChange(toSet, wasSet, silent) {
    const result = super.afterChange(toSet, wasSet, silent),
          {
      timeSpan
    } = this;

    if (!this.isSanitizing) {
      // cleanup data to match the chosen frequency
      this.sanitize();
    }

    if (timeSpan) {
      timeSpan.sanitizeRecurrenceData(this);

      if (!this.isTimeSpanNotifyingSuspended) {
        timeSpan.onRecurrenceChanged();
      }
    }

    return result;
  }

  set(field, value, ...args) {
    const values = typeof field === 'object' ? field : {
      [field]: value
    }; // reset "endDate" field if "count" is being set

    if (values.count) {
      values.endDate = null;
    } // reset "count" field if "endDate" is being set
    else if (values.endDate) {
      values.count = null;
    }

    super.set(values, undefined, ...args);
  }

  get isTimeSpanNotifyingSuspended() {
    return Boolean(this._suspendedTimeSpanNotifying);
  }

  suspendTimeSpanNotifying() {
    this._suspendedTimeSpanNotifying++;
  }

  resumeTimeSpanNotifying() {
    if (this._suspendedTimeSpanNotifying) this._suspendedTimeSpanNotifying--;
  }

}
RecurrenceModel._$name = 'RecurrenceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceModel.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/model/ResourceModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceModel; });
/* harmony import */ var _Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
var productName = 'gantt';




const EngineMixin = _Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"];
/**
 * @module Scheduler/model/ResourceModel
 */

/**
 * This class represent a single Resource in scheduler, usually added to a {@link Scheduler.data.ResourceStore}.
 *
 * It is a subclass of  {@link Core.data.Model}. Please refer to the documentation for that class to become familiar
 * with the base interface of the resource.
 *
 * ## Fields and references
 *
 * A resource has a few predefined fields, see Fields below. If you want to add more fields with meta data describing
 * your resources then you should subclass this class:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *       // "id" and "name" fields are already provided by the superclass
 *       { name: 'company', type : 'string' }
 *     ];
 *   }
 * });
 * ```
 *
 * If you want to use other names in your data for the id and name fields you can configure them as seen below:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *        { name: 'name', dataSource: 'userName' }
 *     ];
 *   },
 * });
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `assignments` - The linked assignment records
 * - `events` - The linked (through assignments) event records
 *
 * ## Async resolving of references
 *
 * As described above, a resource has links to assignments and events. These references are populated async, using the
 * calculation engine of the project that the resource via its store is a part of. Because of this asyncness, references
 * cannot be used immediately after assignment modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // resource.assignments is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // resource.assignments is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // resource.assignments is up to date
 * ```
 *
 * @extends Grid/data/GridRowModel
 * @mixes Scheduler/model/mixin/ResourceModelMixin
 */

class ResourceModel extends Object(_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  static get $name() {
    return 'ResourceModel';
  }

}
ResourceModel.exposeProperties();
ResourceModel._$name = 'ResourceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceTimeRangeModel.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/model/ResourceTimeRangeModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeModel; });
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';

/**
 * @module Scheduler/model/ResourceTimeRangeModel
 */

/**
 * This class represent a single resource time range in your schedule.
 * To style the rendered elements, use {@link Scheduler.model.TimeSpan#field-cls cls} or {@link #field-timeRangeColor} field.
 * The class is used by the {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
 *
 * ## Recurring ranges support
 *
 * By default the class doesn't support recurrence.
 * In order to add its support please use {@link Scheduler/model/mixin/RecurringTimeSpan RecurringTimeSpan} mixin
 * (the store containing the model should in turn be mixed with {@link Scheduler.data.mixin.RecurringTimeSpansMixin RecurringTimeSpansMixin} class):
 *
 * ```js
 * // Mix RecurringTimeSpan (which adds recurrence support) to ResourceTimeRangeModel
 * class MyResourceTimeRange extends RecurringTimeSpan(ResourceTimeRangeModel) {};
 *
 * // Mix RecurringTimeSpansMixin (which adds recurrence support) to ResourceTimeRangeStore
 * class MyResourceTimeRangeStore extends RecurringTimeSpansMixin(ResourceTimeRangeStore) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyResourceTimeRange
 *         };
 *     }
 * };
 *
 * // Make new store that supports time ranges recurrence
 * const store = new MyResourceTimeRangeStore({
 *     data : [{        {
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Coffee break',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 * ```
 *
 * @extends Scheduler/model/TimeSpan
 */

class ResourceTimeRangeModel extends _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceTimeRangeModel';
  } //region Fields


  static get fields() {
    return [
    /**
     * Id of the resource this time range is associated with
     * @field {String|Number} resourceId
     */
    'resourceId',
    /**
     * Controls this time ranges primary color, defaults to using current themes default time range color.
     * @field {String} timeRangeColor
     */
    'timeRangeColor'];
  }

  static get relationConfig() {
    return [
    /**
     * The associated resource, retrieved using a relation to a ResourceStore determined by the value assigned
     * to `resourceId`. The relation also lets you access all time ranges on a resource through
     * `ResourceModel#timeRanges`.
     * @member {Scheduler.model.ResourceModel} resource
     */
    {
      relationName: 'resource',
      fieldName: 'resourceId',
      store: 'resourceStore',
      collectionName: 'timeRanges',
      nullFieldOnRemove: true
    }];
  }

  get domId() {
    return `${this.constructor.domIdPrefix}-${this.id}`;
  } //endregion
  // Used internally to differentiate between Event and ResourceTimeRange


  get isResourceTimeRange() {
    return true;
  } // To match EventModel API


  get resources() {
    return this.resource ? [this.resource] : [];
  }

}

_defineProperty(ResourceTimeRangeModel, "domIdPrefix", 'resourcetimerange');

ResourceTimeRangeModel._$name = 'ResourceTimeRangeModel';

/***/ }),

/***/ "./lib/Scheduler/model/TimeSpan.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/model/TimeSpan.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpan; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';






/**
 * @module Scheduler/model/TimeSpan
 */

/**
 * This class represent a simple date range. It is being used in various subclasses and plugins which operate on date ranges.
 *
 * Its a subclass of  {@link Core.data.Model}.
 * Please refer to documentation of those classes to become familiar with the base interface of this class.
 *
 * A TimeSpan has the following fields:
 *
 * - {@link #field-startDate}    - start date of the task in the ISO 8601 format
 * - {@link #field-endDate}      - end date of the task in the ISO 8601 format (not inclusive)
 * - {@link #field-duration}     - duration, time between start date and end date
 * - {@link #field-durationUnit} - unit used to express the duration
 * - {@link #field-name}         - an optional name of the range
 * - {@link #field-cls}          - an optional CSS class to be associated with the range.
 *
 * The data source of any field can be customized in the subclass. Please refer to {@link Core.data.Model} for details. To specify
 * another date format:
 *
 * ```javascript
 * class MyTimeSpan extends TimeSpan {
 *   static get fields() {
 *      { name: 'startDate', type: 'date', dateFormat: 'DD/MM/YY' }
 *   }
 * }
 * ```
 *
 * @extends Core/data/Model
 */

class TimeSpan extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TimeSpan';
  } //region Field definitions


  static get fields() {
    return [
    /**
     * The start date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */
    {
      name: 'startDate',
      type: 'date'
    },
    /**
     * The end date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */
    {
      name: 'endDate',
      type: 'date'
    },
    /**
     * The numeric part of the timespan's duration (the number of units).
     * @field {Number} duration
     * @category Scheduling
     */
    {
      name: 'duration',
      type: 'number',
      allowNull: true,
      internal: true
    },
    /**
     * The unit part of the TimeSpan duration, defaults to "d" (days). Valid values are:
     *
     * - "ms" (milliseconds)
     * - "s" (seconds)
     * - "m" (minutes)
     * - "h" (hours)
     * - "d" (days)
     * - "w" (weeks)
     * - "M" (months)
     * - "y" (years)
     *
     * This field is readonly after creation, to change durationUnit use #setDuration().
     * @field {String} durationUnit
     * @category Scheduling
     */
    {
      name: 'durationUnit',
      type: 'string',
      defaultValue: 'd',
      internal: true
    }, {
      name: 'fullDuration',
      persist: false,
      column: {
        type: 'duration'
      },
      internal: true // TODO: remove this when durationcolumn is in Scheduler

    },
    /**
     * An encapsulation of the CSS classes to add to the rendered time span element.
     *
     * Always returns a {@link Core.helper.util.DomClassList}, but may still be treated as a string. For
     * granular control of adding and removing individual classes, it is recommended to use the
     * {@link Core.helper.util.DomClassList} API.
     *
     * @field {Core.helper.util.DomClassList} cls
     * @accepts {Core.helper.util.DomClassList|String|String[]|Object}
     *
     * @category Styling
     */
    {
      name: 'cls',
      defaultValue: '',
      internal: true
    },
    /**
     * CSS class specifying an icon to apply to the rendered time span element.
     * **Note**: In case event is a milestone, using `iconCls` with dependency feature might slightly decrease
     * performance because feature will refer to the DOM to get exact size of the element.
     * @field {String} iconCls
     * @category Styling
     */
    {
      name: 'iconCls',
      internal: true
    },
    /**
     * A CSS style string (applied to `style.cssText`) or object (applied to `style`)
     * ```
     * record.style = 'color: red;font-weight: 800';
     * ```
     *
     * @field {String} style
     * @category Styling
     */
    {
      name: 'style',
      type: 'object',
      internal: true
    },
    /**
     * The name of the time span (or Event / Task)
     * @field {String} name
     * @category Common
     */
    {
      name: 'name',
      type: 'string',
      defaultValue: ''
    }];
  } //endregion
  //region Init


  afterConstruct() {
    super.afterConstruct(); // This should probably be a property setter of some mandatory config, then we would not need an afterConfigure implementation.

    this.normalize();
  }
  /**
   * Returns the event store this event is part of.
   *
   * @property {Scheduler.data.EventStore}
   * @readonly
   */


  get eventStore() {
    const me = this; // If we are an occurrence, return our base recurring event's store

    if (me.isOccurrence) {
      return me.recurringTimeSpan.eventStore;
    }

    if (!me._eventStore) {
      var _me$stores;

      me._eventStore = (_me$stores = me.stores) === null || _me$stores === void 0 ? void 0 : _me$stores.find(s => s.isEventStore);
    }

    return me._eventStore;
  }

  normalize() {
    const me = this,
          {
      startDate,
      endDate,
      duration,
      durationUnit
    } = me,
          hasDuration = duration != null; // need to calculate duration (checking first since seemed most likely to happen)

    if (startDate && endDate && !hasDuration) {
      me.setData('duration', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, durationUnit, true));
    } // need to calculate endDate?
    else if (startDate && !endDate && hasDuration) {
      me.setData('endDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, duration, durationUnit));
    } // need to calculate startDate
    else if (!startDate && endDate && hasDuration) {
      me.setData('startDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, -duration, durationUnit));
    }
  } //endregion
  //region Getters & Setters


  set internalCls(cls) {
    const me = this;

    if (me._cls) {
      me._cls.value = cls;
    } else {
      me._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](cls);
    }

    me.set('cls', me._cls.value);
  }

  get internalCls() {
    const {
      cls
    } = this; // `cls` getter can be overriden so return `cls` value if it is DomClassList or assign it to `this._cls`

    if (cls !== null && cls !== void 0 && cls.isDomClassList) {
      return cls;
    }

    this.internalCls = cls;
    return this._cls;
  }

  get cls() {
    if (!this._cls) {
      this._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](super.get('cls'));
    }

    return this._cls;
  }

  set cls(cls) {
    this.internalCls = cls;
  }

  get startDate() {
    return this.get('startDate');
  }

  set startDate(date) {
    this.setStartDate(date);
  }

  get endDate() {
    return this.get('endDate');
  }

  set endDate(date) {
    this.setEndDate(date);
  }

  get duration() {
    return this.get('duration');
  }

  set duration(duration) {
    this.setDuration(duration, this.durationUnit);
  }

  get durationUnit() {
    return this.get('durationUnit');
  }
  /**
   * Sets duration and durationUnit in one go. Only allowed way to change durationUnit, the durationUnit field is
   * readonly after creation
   * @param {Number} duration Duration value
   * @param {String} durationUnit Unit for specified duration value, see {@link #field-durationUnit} for valid values
   */


  setDuration(duration, durationUnit = this.durationUnit) {
    // Must be a number
    duration = parseFloat(duration);
    const toSet = {
      duration,
      durationUnit
    };

    if (this.startDate) {
      toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.startDate, duration, durationUnit);
    } else if (this.endDate) {
      toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.endDate, -duration, durationUnit);
    }

    this.set(toSet);
  }
  /**
   * Returns duration of the event in given unit. This is a wrapper for {@link Core.helper.DateHelper#function-getDurationInUnit-static}
   * @param {String} unit
   * @param {Boolean} [doNotRound]
   * @private
   * @returns {Number}
   */


  getDurationInUnit(unit, doNotRound) {
    if (this.starDate && this.endDate) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDurationInUnit(this.startDate, this.endDate, unit, doNotRound);
    } else {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(unit, this.duration, this.durationUnit);
    }
  }
  /**
   * Property which encapsulates the duration's magnitude and units.
   * @property {Core.data.Duration}
   */


  get fullDuration() {
    // Used for formatting during export
    return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
      unit: this.durationUnit,
      magnitude: this.duration
    });
  }

  set fullDuration(duration) {
    if (typeof duration === 'string') {
      duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseDuration(duration, true, this.durationUnit);
    }

    this.setDuration(duration.magnitude, duration.unit);
  }
  /**
   * Sets the range start date
   *
   * @param {Date} date The new start date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
   * Defaults to `true`
   */


  setStartDate(date, keepDuration = true) {
    const me = this,
          toSet = {
      startDate: date
    };

    if (date) {
      let calcEndDate;

      if (keepDuration) {
        calcEndDate = me.duration != null;
      } else {
        if (me.endDate) {
          toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(date, me.endDate, me.durationUnit, true);
          if (toSet.duration < 0) throw new Error('Negative duration');
        } else {
          calcEndDate = this.duration != null;
        }
      }

      if (calcEndDate) {
        // Use hours to set end date in order to correctly process DST crossings
        toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, me.getDurationInUnit('h'), 'h');
      }
    } else {
      toSet.duration = null;
    }

    me.set(toSet);
  }
  /**
   * Sets the range end date
   *
   * @param {Date} date The new end date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
   * Defaults to `false`
   */


  setEndDate(date, keepDuration = false) {
    const me = this,
          toSet = {
      endDate: date
    };

    if (date) {
      let calcStartDate;

      if (keepDuration === true) {
        calcStartDate = me.duration != null;
      } else {
        if (me.startDate) {
          toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(me.startDate, date, me.durationUnit, true);
          if (toSet.duration < 0) throw new Error('Negative duration');
        } else {
          calcStartDate = this.duration != null;
        }
      }

      if (calcStartDate) {
        toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, -me.duration, me.durationUnit);
      }
    }

    me.set(toSet);
  }
  /**
   * Sets the event start and end dates
   *
   * @param {Date} start The new start date
   * @param {Date} end The new end date
   * @param {Boolean} [silent] Pass `true` to not trigger events
   */


  setStartEndDate(start, end, silent) {
    this.set({
      startDate: start,
      endDate: end
    }, null, silent);
  }
  /**
   * Returns an array of dates in this range. If the range starts/ends not at the beginning of day, the whole day will be included.
   * @readonly
   * @property {Date[]}
   */


  get dates() {
    const dates = [],
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].startOf(this.startDate, 'day'),
          endDate = this.endDate;

    for (let date = startDate; date < endDate; date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, 1, 'day')) {
      dates.push(date);
    }

    return dates;
  }

  get startDateMS() {
    var _ref;

    return (_ref = this.batching && this.hasBatchedChange('startDate') ? this.get('startDate') : this.startDate) === null || _ref === void 0 ? void 0 : _ref.getTime();
  }

  get endDateMS() {
    var _ref2;

    return (_ref2 = this.batching && this.hasBatchedChange('endDate') ? this.get('endDate') : this.endDate) === null || _ref2 === void 0 ? void 0 : _ref2.getTime();
  }
  /**
   * Returns the duration of this Event in milliseconds.
   * @readonly
   * @property {Number}
   */


  get durationMS() {
    const {
      endDateMS,
      startDateMS
    } = this;

    if (endDateMS && startDateMS) {
      return endDateMS - startDateMS;
    } else {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].asMilliseconds(this.duration || 0, this.durationUnit);
    }
  }
  /**
   * Returns true if record is a milestone.
   * @readonly
   * @property {Boolean}
   */


  get isMilestone() {
    return this.duration === 0;
  }

  inSetNormalize(field) {
    if (typeof field !== 'string') {
      // If user is updating multiple properties in one go using an object, we help out
      // by filling out missing schedule related data
      let {
        startDate,
        endDate,
        duration,
        durationUnit = this.durationUnit
      } = field; // Conversion is usually handled in inSet, but we are normalizing prior to that and have to handle it here

      if (typeof startDate === 'string') {
        startDate = this.getFieldDefinition('startDate').convert(startDate);
      }

      if (typeof endDate === 'string') {
        endDate = this.getFieldDefinition('endDate').convert(endDate);
      }

      if ('duration' in field) {
        if (startDate && !endDate) {
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, duration, durationUnit, true, true);
        }

        if (!startDate && endDate) {
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, -duration, durationUnit, true, true);
        }
      } else if (startDate && endDate) {
        // Calculate duration in hours and covert to target duration unit in order to avoid extra DST conversion
        duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(durationUnit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, 'h', true), 'h');
      }

      startDate && (field.startDate = startDate);
      endDate && (field.endDate = endDate);
      duration != null && (field.duration = duration);
      return field;
    }
  }

  inSet(field, value, silent, fromRelationUpdate, skipAccessors) {
    if (!skipAccessors) {
      field = this.inSetNormalize(field) || field;
    }

    return super.inSet(field, value, silent, fromRelationUpdate, skipAccessors);
  } //endregion
  //region Iteration

  /**
   * Iterates over the {@link #property-dates}
   * @param {Function} func The function to call for each date
   * @param {Object} thisObj `this` reference for the function
   */


  forEachDate(func, thisObj) {
    return this.dates.forEach(func.bind(thisObj));
  } //endregion

  /**
   * Checks if the range record has both start and end dates set and start <= end
   *
   * @property {Boolean}
   */


  get isScheduled() {
    const {
      startDateMS,
      endDateMS
    } = this;
    return endDateMS - startDateMS >= 0;
  } // Simple check if end date is greater than start date


  get isValid() {
    const {
      startDate,
      endDate
    } = this;
    return !startDate || !endDate || endDate - startDate >= 0;
  }
  /**
   * Shift the dates for the date range by the passed amount and unit
   * @param {String} unit The unit to shift by, see {@link Core.helper.DateHelper} for more information on valid formats.
   * @param {Number} amount The amount to shift
   */


  shift(amount, unit = this.durationUnit) {
    // TODO REMOVE FOR 2.0
    if (typeof amount === 'string') {
      const u = amount;
      amount = unit;
      unit = u;
    }

    return this.setStartDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.startDate, amount, unit, true), true);
  }
  /**
   * Returns the WBS code of this model (e.g '2.1.3'). Only relevant when part of a tree store, as in the Gantt chart.
   * @property {String}
   */


  get wbsCode() {
    return this._wbsCode || this.indexPath.join('.');
  }

  set wbsCode(value) {
    // wbsCode needs to be writable to interop w/TaskModel and Baselines which copy this field value
    this._wbsCode = value;
  }

  fullCopy() {
    //NOT PORTED
    return this.copy.apply(this, arguments);
  }

  intersects(timeSpan) {
    return this.intersectsRange(timeSpan.startDate, timeSpan.endDate);
  }

  intersectsRange(start, end) {
    const myStart = this.startDate,
          myEnd = this.endDate;
    return myStart && myEnd && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(myStart, myEnd, start, end);
  }
  /**
   * Splits this event into two pieces at the desired position.
   *
   * @param {Number} splitPoint A number greater than 0 and less than 1, indicating how this event will be split. 0.5 means cut it in half
   * @return {Scheduler.model.TimeSpan} The newly created split section of the timespan
   */


  split(splitPoint = 0.5) {
    const me = this,
          clone = me.copy(),
          {
      eventStore,
      assignmentStore
    } = me,
          ownNewDuration = me.duration * splitPoint,
          cloneDuration = me.duration - ownNewDuration;

    if (splitPoint <= 0 || splitPoint >= 1) {
      throw new Error('Split point must be > 0 and < 1');
    }

    clone.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(me.startDate, ownNewDuration, me.durationUnit);
    clone.duration = cloneDuration;
    me.duration = ownNewDuration;

    if (eventStore) {
      eventStore.add(clone);

      if (assignmentStore && !eventStore.usesSingleAssignment) {
        assignmentStore.add(me.assignments.map(assignment => {
          const clonedData = Object.assign({}, assignment.data, {
            eventId: clone.id,
            // From engine
            event: null,
            resource: null
          });
          delete clonedData.id;
          return clonedData;
        }));
      }
    }

    return clone;
  }

  toICSString(icsEventConfig = {}) {
    if (!this.isScheduled) {
      return '';
    }

    const nowAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(new Date()),
          startAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(this.startDate),
          endAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(this.endDate),
          fullDateFormat = 'YYYYMMDDTHHmmss',
          // To allow testing using a fixed timestamp value
    timestamp = icsEventConfig.DTSTAMP || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(nowAsUTC, fullDateFormat) + 'Z';
    delete icsEventConfig.DTSTAMP;
    let startEnd = {};

    if (this.allDay) {
      const dateFormat = 'YYYYMMDD';
      startEnd = {
        'DTSTART;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(startAsUTC, dateFormat),
        'DTEND;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(endAsUTC, dateFormat)
      };
    } else {
      startEnd = {
        DTSTART: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(startAsUTC, fullDateFormat) + 'Z',
        DTEND: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(endAsUTC, fullDateFormat) + 'Z'
      };
    }

    const version = _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].scheduler && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getVersion('scheduler') || _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].calendar && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getVersion('calendar') || '',
          icsWrapConfig = {
      BEGIN: 'VCALENDAR',
      VERSION: '2.0',
      CALSCALE: 'GREGORIAN',
      PRODID: `-//Bryntum AB//Bryntum Scheduler ${version} //EN`,
      END: 'VCALENDAR'
    },
          eventConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      BEGIN: 'VEVENT',
      UID: this.id + '@bryntum.com',
      CLASS: 'PUBLIC',
      SUMMARY: this.name,
      DTSTAMP: timestamp
    }, startEnd), this.recurrenceRule ? {
      RRULE: this.recurrenceRule
    } : {}), icsEventConfig), {}, {
      END: 'VEVENT'
    }),
          icsItems = Object.keys(icsWrapConfig).map(key => `${key}:${icsWrapConfig[key]}`),
          eventItems = Object.keys(eventConfig).map(key => `${key}:${eventConfig[key]}`); // Inject event details before the closing VCALENDAR entry


    icsItems.splice(icsItems.length - 1, 0, ...eventItems);
    return icsItems.join('\n');
  }
  /**
   * Triggers a download of this time span in ICS format (for import in Outlook etc.)
   *
   * ```javascript
   * timeSpan.downloadAsICS({
   *      LOCATION : timeSpan.location
   *  });
   * ```
   * @param {Object} [icsEventConfig] A config object with properties to be added in to `BEGIN:VEVENT` section of the
   * exported event.
   */


  exportToICS(icsEventConfig) {
    if (this.isScheduled) {
      const blob = new Blob([this.toICSString(icsEventConfig)], {
        type: 'text/calendar'
      });
      _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].downloadBlob(blob, (this.name || 'Event') + '.ics');
    }
  }
  /**
   * Defines if the given event field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines all the event fields as editable.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the model has no such field.
   */


  isEditable(fieldName) {
    // return undefined for unknown fields
    return this.getFieldDefinition(fieldName) ? true : undefined;
  }

  isFieldModified(fieldName) {
    if (fieldName === 'fullDuration') {
      return super.isFieldModified('duration') || super.isFieldModified('durationUnit');
    }

    return super.isFieldModified(fieldName);
  }

}
TimeSpan._$name = 'TimeSpan';

/***/ }),

/***/ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/AssignmentModelMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/**
* @module Scheduler/model/mixin/AssignmentModelMixin
*/

/**
 * Mixin that holds configuration shared between assignments in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AssignmentModelMixin extends Target {
  static get $name() {
    return 'AssignmentModelMixin';
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * ```javascript
   * assignment.set('resourceId', 2);
   * // assignment.resource is not yet resolved
   *
   * await assignment.setAsync('resourceId', 2);
   * // assignment.resource is resolved
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [
    /**
     * Id for the resource to assign to
     * @field {String|Number} resourceId
     * @category Common
     */
    'resourceId',
    /**
     * Id for the event to assign
     * @field {String|Number} eventId
     * @category Common
     */
    'eventId',
    /**
     * Specify `false` to opt out of drawing dependencies from/to this assignment
     * @field {Boolean} drawDependencies
     * @category Common
     */
    {
      name: 'drawDependencies',
      type: 'boolean'
    }, 'event', 'resource'];
  } //endregion


  construct(data, ...args) {
    data = data || {};
    const eventId = data[this.fieldMap.eventId.dataSource],
          resourceId = data[this.fieldMap.resourceId.dataSource]; // Engine expects event and resource, not eventId and resourceId. We need to support both

    if (eventId != null) {
      data.event = eventId;
    }

    if (resourceId != null) {
      data.resource = resourceId;
    }

    super.construct(data, ...args);
  } //region Event & resource

  /**
   * A key made up from the event id and the id of the resource assigned to.
   * @property eventResourceKey
   * @readonly
   * @internal
   */


  get eventResourceKey() {
    const me = this;
    let eventKey, resourceKey;

    if (me.event) {
      eventKey = me.event.isModel ? me.event.id : me.event;
    } else {
      eventKey = me.internalId;
    }

    if (me.resource) {
      resourceKey = me.resource.isModel ? me.resource.id : me.resource;
    } else {
      resourceKey = me.internalId;
    }

    return `${eventKey}-${resourceKey}`;
  }

  set(field, value, ...args) {
    const toSet = this.fieldToKeys(field, value); // If resource was set, store its id as resourceId and announce it

    if ('resource' in toSet) {
      var _toSet$resource;

      if ((_toSet$resource = toSet.resource) !== null && _toSet$resource !== void 0 && _toSet$resource.id) {
        toSet.resourceId = toSet.resource.id;
      }
    } // Same for event


    if ('event' in toSet) {
      var _toSet$event;

      if ((_toSet$event = toSet.event) !== null && _toSet$event !== void 0 && _toSet$event.id) {
        toSet.eventId = toSet.event.id;
      }
    }

    super.set(toSet, null, ...args);
  } // Settings resourceId relays to `resource`. Underlying data will be updated in `afterChange()` above


  set resourceId(value) {
    const {
      resource
    } = this; // When assigning a new id to a resource, it will update the resourceId of the assignment. But the assignments
    // resource is still the same so we need to announce here

    if (resource !== null && resource !== void 0 && resource.isModel && resource.id === value) {
      this.set('resourceId', value);
    } else {
      this.resource = value;
    }
  }

  get resourceId() {
    var _this$resource;

    // If assigned using `resource` and not `resourceId` there will be no resourceId
    return this.get('resourceId') || ((_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id);
  } // Same for event as for resourceId


  set eventId(value) {
    const {
      event
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (event !== null && event !== void 0 && event.isModel && event.id === value) {
      this.set('eventId', value);
    } else {
      this.event = value;
    }
  }

  get eventId() {
    var _this$event;

    // If assigned using `event` and not `eventId` there will be no eventId
    return this.get('eventId') || ((_this$event = this.event) === null || _this$event === void 0 ? void 0 : _this$event.id);
  }
  /**
   * Convenience property to get the name of the associated event.
   * @property {String}
   * @readonly
   */


  get eventName() {
    var _this$event2;

    return (_this$event2 = this.event) === null || _this$event2 === void 0 ? void 0 : _this$event2.name;
  }
  /**
   * Convenience property to get the name of the associated resource.
   * @property {String}
   * @readonly
   */


  get resourceName() {
    var _this$resource2;

    return (_this$resource2 = this.resource) === null || _this$resource2 === void 0 ? void 0 : _this$resource2.name;
  } // TODO : Deprecate in favor of `get resource`

  /**
   * Returns the resource associated with this assignment.
   *
   * @return {Scheduler.model.ResourceModel} Instance of resource
   */


  getResource() {
    return this.resource;
  } //endregion
  // Convenience getter to not have to check `instanceof AssignmentModel`


  get isAssignment() {
    return true;
  }
  /**
   * Returns true if the Assignment can be persisted (e.g. task and resource are not 'phantoms')
   *
   * @property {Boolean}
   */


  get isPersistable() {
    var _this$event3;

    const {
      event,
      resource,
      unjoinedStores,
      assignmentStore
    } = this,
          crudManager = assignmentStore === null || assignmentStore === void 0 ? void 0 : assignmentStore.crudManager;
    let result;

    if (assignmentStore) {
      // If the owning event is not persistable, this assignment is also not persistable.
      // if crud manager is used it can deal with phantom event/resource since it persists all records in one batch
      // if no crud manager used we have to wait till event/resource are persisted
      result = this.isValid && event.isPersistable && (crudManager || !event.hasGeneratedId && !resource.hasGeneratedId);
    } // if we remove the record
    else {
      result = !this.isPhantom && Boolean(unjoinedStores[0]);
    } // Records not yet fully created cannot be persisted


    return result && super.isPersistable && !((_this$event3 = this.event) !== null && _this$event3 !== void 0 && _this$event3.meta.isCreating);
  }

  get isValid() {
    return this.resource != null && this.event != null;
  }
  /**
   * Returns a textual representation of this assignment (e.g. Mike 50%).
   * @return {String}
   */


  toString() {
    if (this.resourceName) {
      return `${this.resourceName} ${Math.round(this.units)}%`;
    }

    return '';
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/EventModelMixin.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/model/mixin/EventModelMixin.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';


const oneDayMS = 1000 * 60 * 60 * 24;
/**
 * @module Scheduler/model/mixin/EventModelMixin
 */

/**
 * Mixin that holds configuration shared between events in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class EventModelMixin extends Target {
  static get $name() {
    return 'EventModelMixin';
  } // Flag checked by EventStore to make sure it uses a valid subclass


  static get isEventModel() {
    return true;
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * ```javascript
   * eventRecord.set('duration', 4);
   * // eventRecord.endDate is not yet calculated
   *
   * await eventRecord.setAsync('duration', 4);
   * // eventRecord.endDate is calculated
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events. If event is recurring, occurrences won't be updated
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [// TODO: below startDate/endDate/duration fields docs copy-paste should be cleaned up after supporting @localdoc & @inheritdoc combination

    /**
     * The start date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The end date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The numeric part of the timespan's duration (the number of units).
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * @field {Number} duration
     * @category Scheduling
     */

    /**
     * Property which encapsulates the duration's magnitude and units.
     * @member {Core.data.Duration} fullDuration
     */

    /**
     * The unique identifier of a task (mandatory)
     * @field {String|Number} id
     * @category Common
     */

    /**
     * Id of the resource this event is associated with (only usable for single assignments). We recommend
     * using assignments in an AssignmentStore over this approach. Internally any Event using `resourceId`
     * will have an assignment in AssignmentStore generated.
     * @field {String|Number} resourceId
     * @category Common
     */
    {
      name: 'resourceId',
      internal: true
    },
    /**
     * The array of {@link Scheduler.model.ResourceModel resources} which are assigned to this event.
     * @field {String|Number} resources
     * @category Common
     */
    {
      name: 'resources',
      column: {
        type: 'resourceassignment'
      },
      persist: false,
      internal: true // TODO: remove this when resourcecolumn is in Scheduler

    },
    /**
     * Specify false to prevent the event from being dragged (if EventDrag feature is used)
     * @field {Boolean} draggable
     * @default true
     * @category Interaction
     */
    {
      name: 'draggable',
      type: 'boolean',
      persist: false,
      defaultValue: true,
      internal: true
    },
    /**
     * Specify `false` to prevent the event from being resized (if EventResize feature is used). You can also
     * specify `'start'` or `'end'` to only allow resizing in one direction
     * @field {Boolean|String} resizable
     * @default true
     * @category Interaction
     */
    {
      name: 'resizable',
      persist: false,
      defaultValue: true,
      internal: true
    }, // true, false, 'start' or 'end'

    /**
     * A field marking event as all day(s) spanning event.
     * For example, a holiday day may be represented by a `startDate`, and the `allDay` flag.
     * @field {Boolean} allDay
     * @category Scheduling
     */
    {
      name: 'allDay',
      type: 'boolean',
      defaultValue: false
    },
    /**
     * Controls this events appearance, see Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for
     * available options.
     * @field {String} eventStyle
     * @category Styling
     */
    {
      name: 'eventStyle',
      internal: true
    },
    /**
     * Controls the primary color of the event, see Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for
     * available colors.
     * @field {String} eventColor
     * @category Styling
     */
    {
      name: 'eventColor',
      internal: true
    },
    /**
     * Width (in px) to use for this milestone when using Scheduler#milestoneLayoutMode 'data'.
     * @field {Number} milestoneWidth
     * @category Styling
     */
    {
      name: 'milestoneWidth',
      internal: true
    }, {
      name: '$highlight',
      persist: false,
      internal: true
    },
    /**
     * Set this field to false to opt out of {@link Scheduler.feature.StickyEvents sticky event content}
     * (keeping event text in view while scrolling).
     * @field {Boolean} stickyContents
     * @category Styling
     */
    {
      name: 'stickyContents',
      internal: true
    }];
  } //endregion
  //region Id change


  updateAssignmentEventIds() {
    this.assigned.forEach(assignment => {
      assignment.eventId = this.id;
    });
  }

  syncId(value) {
    super.syncId(value);
    this.updateAssignmentEventIds();
  } //endregion
  //region Resources

  /**
   * Returns all resources assigned to an event.
   *
   * @property {Scheduler.model.ResourceModel[]}
   * @readonly
   */


  get resources() {
    // Only include valid resources, to not have nulls in the result
    return this.assignments.reduce((resources, assignment) => {
      assignment.resource && resources.push(assignment.resource);
      return resources;
    }, []);
  }

  set resources(resources) {
    if (!Array.isArray(resources)) {
      resources = [resources];
    }

    const me = this,
          newResourceIds = resources.map(me.constructor.asId),
          existingResourceIds = me.assignments.map(a => a.resource.id),
          {
      onlyInA: toAdd,
      onlyInB: toRemove
    } = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].delta(newResourceIds, existingResourceIds); // Add first, remove after. Otherwise event might get removed with its last assignment

    me.assignmentStore.add(toAdd.map(resourceId => ({
      resource: resourceId,
      event: me
    })));
    me.assignmentStore.remove(toRemove.map(resourceId => me.assignments.find(a => a.resource.id === resourceId)));
  }
  /**
   * Iterate over all associated resources
   * @private
   */


  forEachResource(fn, thisObj = this) {
    for (const resource of this.resources) {
      if (fn.call(thisObj, resource) === false) return;
    }
  }
  /**
   * Returns either the resource associated with this event (when called w/o `resourceId`) or resource
   * with specified id.
   *
   * @param {String} [resourceId] To retrieve a specific resource
   * @return {Scheduler.model.ResourceModel}
   */


  getResource(resourceId) {
    if (resourceId == null) {
      return this.resource;
    }

    return this.resourceStore ? this.resourceStore.getById(resourceId) : null;
  } //endregion
  //region Dates


  get startDate() {
    let dt;

    if (this.isOccurrence) {
      dt = this.get('startDate');
    } else {
      var _this$_startDate;

      // Micro optimization to avoid expensive super call. super will be hit in Scheduler Pro
      dt = (_this$_startDate = this._startDate) !== null && _this$_startDate !== void 0 ? _this$_startDate : super.startDate;
    }

    if (this.allDay) {
      dt = this.constructor.getAllDayStartDate(dt);
    }

    return dt;
  }

  set startDate(startDate) {
    if (this.batching) {
      this._startDate = startDate;
      this.set({
        startDate
      });
    } else {
      super.startDate = startDate;
    }
  }

  get endDate() {
    let dt;

    if (this.isOccurrence) {
      dt = this.get('endDate');
    } else {
      var _this$_endDate;

      // Micro optimization to avoid expensive super call. super will be hit in Scheduler Pro
      dt = (_this$_endDate = this._endDate) !== null && _this$_endDate !== void 0 ? _this$_endDate : super.endDate;
    }

    if (this.allDay) {
      dt = this.constructor.getAllDayEndDate(dt);
    }

    return dt;
  }

  set endDate(endDate) {
    if (this.batching) {
      this._endDate = endDate;
      this.set({
        endDate
      });
    } else {
      super.endDate = endDate;
    }
  }
  /**
   * Shift the dates for the date range by the passed amount and unit
   * @param {String} unit The unit to shift by, see {@link Core.helper.DateHelper} for more information on valid formats.
   * @param {Number} amount The amount to shift
   * @returns {Promise} A promise which is resolved when shift calculations are done
   * @async
   * @method shift
   */
  //endregion
  //region Is
  // Used internally to differentiate between Event and ResourceTimeRange


  get isEvent() {
    return true;
  }
  /**
   * Returns true if event can be drag and dropped
   * @property {Boolean}
   */


  get isDraggable() {
    return this.draggable;
  }
  /**
   * Returns true if event can be resized, but can additionally return 'start' or 'end' indicating how this event can be resized.
   * @property {Boolean|String}
   * @readonly
   */


  get isResizable() {
    return !this.isMilestone && this.resizable;
  }
  /**
   * Returns false if the event is not persistable. By default it always is, override this getter if you need
   * custom logic.
   *
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    // Records not yet fully created cannot be persisted
    return super.isPersistable && !this.meta.isCreating;
  }

  endBatch() {
    const {
      isPersistable: wasPersistable,
      meta: {
        batchChanges
      }
    } = this; // Remove cached values
    // https://github.com/bryntum/support/issues/3358

    if (batchChanges) {
      if ('endDate' in batchChanges) {
        delete this._endDate;
      }

      if ('startDate' in batchChanges) {
        delete this._startDate;
      }
    }

    super.endBatch(...arguments); // If this event newly persistable, its assignments are eligible for syncing.

    if (this.isPersistable && !wasPersistable) {
      this.assignments.forEach(assignment => {
        assignment.stores.forEach(s => {
          s.updateModifiedBagForRecord(assignment);
        });
      });
    }
  }

  get isCreating() {
    return super.isCreating;
  }

  set isCreating(value) {
    super.isCreating = value;
    this.assignments.forEach(record => record.isCreating = value);
  } //endregion
  //region Single assignment compatibility


  get usesSingleAssignment() {
    return !this.eventStore || this.eventStore.usesSingleAssignment;
  }
  /**
   * Override persistable getter to prevent sending resourceId when using multiple resource assignment mode
   * https://github.com/bryntum/support/issues/1345
   * @private
   */


  get persistableData() {
    const data = super.persistableData;

    if (!this.usesSingleAssignment) {
      delete data.resourceId;
    }

    return data;
  }
  /**
   * Returns the first assigned resource, or assigns a resource
   * @member {Scheduler.model.ResourceModel} resource
   */


  get resource() {
    const {
      resources
    } = this;
    return resources.length ? resources[0] : null;
  }

  set resource(resourceRecord) {
    // Use the resourceId setter for single assignment
    this.resourceId = this.constructor.asId(resourceRecord);
  }

  get resourceId() {
    var _this$resource;

    return this.usesSingleAssignment ? this.get('resourceId') : (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id;
  }

  set resourceId(resourceId) {
    this.applyResourceId(resourceId);
  }

  applyResourceId(resourceId, fromApplyValue = false) {
    const me = this,
          {
      assignments,
      assignmentStore,
      eventStore
    } = me; // When part of an EventStore, resourceIds are changed to be AssignmentModels

    if (eventStore) {
      if (resourceId != null) {
        if (!me.skipEnforcingSingleAssignment) {
          eventStore.usesSingleAssignment = true;
        } // Reassign if already assigned, only single assignment allowed


        if (assignments !== null && assignments !== void 0 && assignments.length && resourceId !== assignments[0].resourceId) {
          //assignments[0].set('resourceId', resourceId, Boolean(me.eventStore.eventsSuspended));
          // Silent reassign if events are suspended on event store, wont be expecting UI update then
          const eventsSuspended = Boolean(eventStore.eventsSuspended);
          eventsSuspended && assignmentStore.suspendEvents();
          assignments[0].resource = resourceId;
          eventsSuspended && assignmentStore.resumeEvents();
        } // Otherwise assign
        else {
          assignmentStore.assignEventToResource(me, resourceId);
        }
      } else {
        // Setting resourceId to null removes all assignments
        assignmentStore.remove(me.assignments);
      }
    } // Not part of an EventStore, edge case. Set to data unless we are in such operation already
    else if (!fromApplyValue) {
      me.set({
        resourceId
      });
    }
  } // Special handling of setting resourceId, creates assignment


  applyValue(useProp, mapping, value, skipAccessors, field) {
    if (field && field.name === 'resourceId' && !this.meta.isAssigning) {
      const {
        eventStore
      } = this;
      eventStore && (eventStore.isAssigning = true);
      this.applyResourceId(value, true);
      eventStore && (eventStore.isAssigning = false);
    }

    super.applyValue(useProp, mapping, value, skipAccessors, field);
  } //endregion
  //region Assignment

  /**
   * Returns all assignments for the event. Event must be part of the store for this method to work.
   * @property {Scheduler.model.AssignmentModel[]}
   * @readonly
   */


  get assignments() {
    return [...(this.assigned || [])];
  }
  /**
   * Assigns this event to the specified resource.
   *
   * *Note:* The event must be part of an EventStore for this to work. If the EventStore uses single assignment
   * (loaded using resourceId) existing assignments will always be removed.
   *
   * @param {Scheduler.model.ResourceModel|String|Number|Scheduler.model.ResourceModel[]|String[]|Number[]} resource A new resource for this event, either as a full
   *        Resource record or an id (or an array of such).
   * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
   */


  assign(resource, removeExistingAssignments = false) {
    const {
      eventStore
    } = this;

    if (eventStore && !eventStore.usesSingleAssignment) {
      eventStore.assignEventToResource(this, resource, removeExistingAssignments);
    } else {
      // Remember what resource to assign,  directly in single assignment mode or for later when we are joined to
      // an EventStore
      this.resourceId = this.constructor.asId(resource);

      if (!eventStore) {
        // Prevent flagging EventStore as using single assignment when that happens, we cannot know that here
        this.meta.skipEnforcingSingleAssignment = true;
      }
    }
  }
  /**
   * Unassigns this event from the specified resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} [resource] The resource to unassign from.
   */


  unassign(resource, removingResource = false) {
    var _me$eventStore;

    const me = this;
    resource = me.constructor.asId(resource); // If unassigned is caused by removing the resource the UI should be able to find out to not do extra redraws etc.

    me.meta.removingResource = removingResource;
    (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.unassignEventFromResource(me, resource);
    me.meta.removingResource = null;
  }
  /**
   * Reassigns an event from an old resource to a new resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} oldResourceId A resource to unassign from or its id
   * @param {Scheduler.model.ResourceModel|String|Number} newResourceId A resource to assign to or its id
   */


  reassign(oldResourceId, newResourceId) {
    this.eventStore && this.eventStore.reassignEventFromResourceToResource(this, oldResourceId, newResourceId);
  }
  /**
   * Returns true if this event is assigned to a certain resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource The resource to query for
   * @return {Boolean}
   */


  isAssignedTo(resource) {
    const resourceId = this.constructor.asId(resource);
    return this.assignments.some(assignment => assignment.resourceId === resourceId);
  } //endregion
  //region Dependencies

  /**
   * Returns all predecessor dependencies of this event
   *
   * @readonly
   * @property {Scheduler.model.DependencyBaseModel[]}
   */


  get predecessors() {
    return [...this.incomingDeps];
  }
  /**
   * Returns all successor dependencies of this event
   *
   * @readonly
   * @property {Scheduler.model.DependencyBaseModel[]}
   */


  get successors() {
    return [...this.outgoingDeps];
  }

  get dependencies() {
    return [...this.incomingDeps, ...this.outgoingDeps];
  } //endregion


  normalize() {// Normalization handled by SchedulingEngine
  }

  inSetNormalize() {// Normalization handled by SchedulingEngine
  }
  /**
   * The "main" event this model is an occurrence of.
   * Returns `null` for non-occurrences.
   * @property {Scheduler.model.EventModel}
   * @alias #Scheduler.model.mixin.RecurringTimeSpan#property-recurringTimeSpan
   * @readonly
   */


  get recurringEvent() {
    return this.recurringTimeSpan;
  }
  /**
   * Flag which indicates that this event is an interday event. This means that it spans
   * an entire day or multiple days.
   *
   * This is essentially used by the Calendar package to determine if an event should
   * go into the all day zone of a DayView.
   *
   * @property {Boolean}
   * @readonly
   */


  get isInterDay() {
    const {
      durationMS
    } = this; // A full day (86400000 or more) marks as it as interDay,
    // which means it belongs in the all day row of a Calendar DayView

    if (durationMS >= oneDayMS) {
      return true;
    } // Working out whether it crosses midnight is a little more difficult


    const {
      endDate,
      startDate
    } = this,
          eventStartMidnight = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(startDate); // If either is null or NaN, we have to answer falsy

    if (startDate && endDate) {
      eventStartMidnight.setDate(eventStartMidnight.getDate() + 1); // If the endDate is past midnight, it's interDay and goes in the all day row of a Calendar DayView

      return (endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(startDate, durationMS)) > eventStartMidnight;
    }
  } //region All day statics


  static getAllDayStartDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('startDate');
    }

    if (dt) {
      dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(dt, true);
    }

    return dt;
  }

  static getAllDayEndDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('endDate');
    }

    if (dt && (dt.getHours() > 0 || dt.getMinutes() > 0 || dt.getSeconds() > 0 || dt.getMilliseconds() > 0)) {
      dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getNext(dt, 'd', 1);
    }

    return dt;
  }

  static getAllDayDisplayStartDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('startDate');
    }

    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(dt, true);
  }

  static getAllDayDisplayEndDate(startDate, endDate) {
    if (startDate && startDate.isEvent) {
      endDate = startDate.get('endDate');
      startDate = startDate.get('startDate');
    }

    if (endDate) {
      startDate = this.constructor.getAllDayDisplayStartDate(startDate); // If date falls on start of the day - subtract one day to show end date correctly
      // e.g. event starts on 2017-01-01 00:00 and ends on 2017-01-02 00:00, editor should show
      // 2017-01-01 for both start and end

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(endDate, true).valueOf() === endDate.valueOf()) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(endDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].DAY, -1);
      } else if (startDate.valueOf() !== endDate.valueOf()) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(endDate, true);
      }
    }

    return endDate;
  }
  /**
   * Defines if the given event field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines {@link #field-endDate}, {@link #field-duration} and {@link #property-fullDuration} fields
   * editable for leaf events only (in case the event is part of a tree store) and all other fields as editable.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the event has no such field.
   */


  isEditable(fieldName) {
    switch (fieldName) {
      // end/duration is allowed to edit for leafs
      case 'endDate':
      case 'duration':
      case 'fullDuration':
        return this.isLeaf;
    }

    return super.isEditable(fieldName);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ProjectModelMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ProjectModelMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _EventModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _ResourceModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _data_EventStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';














/**
 * @module Scheduler/model/mixin/ProjectModelMixin
 */

/**
 * Mixin that holds configuration shared between projects in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectModelMixin extends (Target || _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ProjectModelMixin';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Configuration options to provide to the STM manager
       *
       * @config {Object|Core.data.stm.StateTrackingManager}
       * @category Advanced
       */
      stm: {},

      /**
       * The constructor of the event model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-eventStore}
       *
       * @config {Scheduler.model.EventModel}
       * @typings {typeof EventModel}
       * @category Models & Stores
       */
      eventModelClass: _EventModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * The constructor of the dependency model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-dependencyStore}
       *
       * @config {Scheduler.model.DependencyModel}
       * @typings {typeof DependencyModel}
       * @category Models & Stores
       */
      dependencyModelClass: _DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      timeRangeModelClass: _TimeSpan_js__WEBPACK_IMPORTED_MODULE_6__["default"],
      resourceTimeRangeModelClass: _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_5__["default"],

      /**
       * The constructor of the resource model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-resourceStore}
       *
       * @config {Scheduler.model.ResourceModel}
       * @typings {typeof ResourceModel}
       * @category Models & Stores
       */
      resourceModelClass: _ResourceModel_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * The constructor of the assignment model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-assignmentStore}
       *
       * @config {Scheduler.model.AssignmentModel}
       * @typings {typeof AssignmentModel}
       * @category Models & Stores
       */
      assignmentModelClass: _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__["default"],

      /**
       * The constructor to create an event store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.EventStore}
       * @config {Scheduler.data.EventStore|Object}
       * @typings {typeof EventStore|object}
       * @category Models & Stores
       */
      eventStoreClass: _data_EventStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.DependencyStore}
       * @config {Scheduler.data.DependencyStore|Object}
       * @typings {typeof DependencyStore|object}
       * @category Models & Stores
       */
      dependencyStoreClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__["default"],

      /**
       * The constructor to create a resource store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.ResourceStore}
       * @config {Scheduler.data.ResourceStore|Object}
       * @typings {typeof ResourceStore|object}
       * @category Models & Stores
       */
      resourceStoreClass: _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__["default"],

      /**
       * The constructor to create an assignment store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.AssignmentStore}
       * @config {Scheduler.data.AssignmentStore|Object}
       * @typings {typeof AssignmentStore|object}
       * @category Models & Stores
       */
      assignmentStoreClass: _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__["default"],

      /**
       * The constructor to create a time range store instance with. Should be a class subclassing the {@link Core.data.Store}
       * @config {Core.data.Store|Object}
       * @typings {typeof Store|object}
       * @category Models & Stores
       */
      timeRangeStoreClass: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__["default"],

      /**
       * The constructor to create a resource time range store instance with. Should be a class subclassing the {@link Scheduler.data.ResourceTimeRangeStore}
       * @config {Scheduler.data.ResourceTimeRangeStore|Object}
       * @typings {typeof ResourceTimeRangeStore|object}
       * @category Models & Stores
       */
      resourceTimeRangeStoreClass: _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__["default"],

      /**
       * The initial data, to fill the {@link #property-eventStore eventStore} with.
       * Should be an array of {@link Scheduler.model.EventModel EventModels} or it's configuration objects.
       *
       * @config {Scheduler.model.EventModel[]} eventsData
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-dependencyStore dependencyStore} with.
       * Should be an array of {@link Scheduler.model.DependencyModel DependencyModels} or it's configuration
       * objects.
       *
       * @config {Scheduler.model.DependencyModel[]} [dependenciesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-resourceStore resourceStore} with.
       * Should be an array of {@link Scheduler.model.ResourceModel ResourceModels} or it's configuration objects.
       *
       * @config {Scheduler.model.ResourceModel[]} [resourcesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-assignmentStore assignmentStore} with.
       * Should be an array of {@link Scheduler.model.AssignmentModel AssignmentModels} or it's configuration objects.
       *
       * @config {Scheduler.model.AssignmentModel[]} [assignmentsData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-timeRangeStore timeRangeStore} with.
       * Should be an array of {@link Scheduler.model.TimeSpan TimeSpan} or it's configuration objects.
       *
       * @config {Scheduler.model.TimeSpan[]} [timeRangesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-resourceTimeRangeStore resourceTimeRangeStore} with.
       * Should be an array of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel} or it's configuration objects.
       *
       * @config {Scheduler.model.ResourceTimeRangeModel[]} [resourceTimeRangesData]
       * @category Inline data
       */
      eventStore: {},
      assignmentStore: {},
      dependencyStore: {},
      resourceStore: {},
      timeRangesData: null
    };
  }

  static get configurable() {
    return {
      /**
       * Project data as a JSON string, used to populate its stores.
       *
       * ```javascript
       * const project = new ProjectModel({
       *     json : '{"eventsData":[...],"resourcesData":[...],...}'
       * }
       * ```
       *
       * @config {String}
       */
      json: null,
      timeRangeStore: {
        value: {},
        $config: 'nullify'
      },
      resourceTimeRangeStore: {
        value: {},
        $config: 'nullify'
      }
    };
  } //endregion
  //region Properties

  /**
   * State tracking manager instance the project relies on
   * @member {Core.data.stm.StateTrackingManager} stm
   */

  /**
   * The {@link Scheduler.data.EventStore store} holding the events information.
   *
   * See also {@link Scheduler.model.EventModel}
   *
   * @member {Scheduler.data.EventStore} eventStore
   * @category Models & Stores
   */

  /**
   * An {@link Scheduler.data.EventStore} instance or a config object.
   * @config {Scheduler.data.EventStore|Object} eventStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.DependencyStore store} holding the dependencies information.
   *
   * See also {@link Scheduler.model.DependencyModel}
   *
   * @member {Scheduler.data.DependencyStore} dependencyStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.DependencyStore} instance or a config object.
   * @config {Scheduler.data.DependencyStore|Object} dependencyStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.ResourceStore store} holding the resources that can be assigned to the events in the event store.
   *
   * See also {@link Scheduler.model.ResourceModel}
   *
   * @member {Scheduler.data.ResourceStore} resourceStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.ResourceStore} instance or a config object.
   * @config {Scheduler.data.ResourceStore|Object} resourceStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.AssignmentStore store} holding the assignments information.
   *
   * See also {@link Scheduler.model.AssignmentModel}
   *
   * @member {Scheduler.data.AssignmentStore} assignmentStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.AssignmentStore} instance or a config object.
   * @config {Scheduler.data.AssignmentStore|Object} assignmentStore
   * @category Models & Stores
   */

  /**
   * Returns current Project changes as an object consisting of added/modified/removed arrays of records for every
   * managed store. Returns `null` if no changes exist. Format:
   *
   * ```javascript
   * {
   *     resources : {
   *         added    : [{ name : 'New guy' }],
   *         modified : [{ id : 2, name : 'Mike' }],
   *         removed  : [{ id : 3 }]
   *     },
   *     events : {
   *         modified : [{  id : 12, name : 'Cool task' }]
   *     },
   *     ...
   * }
   * ```
   *
   * @member {Object} changes
   * @readonly
   * @category Models & Stores
   */

  /**
   * The {@link Core.data.Store store} holding the time ranges information.
   *
   * See also {@link Scheduler.model.TimeSpan}
   *
   * @member {Core.data.Store} timeRangeStore
   * @category Models & Stores
   */

  /**
   * A {@link Core.data.Store} instance or a config object.
   * @config {Core.data.Store|Object} timeRangeStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.ResourceTimeRangeStore store} holding the resource time ranges information.
   *
   * See also {@link Scheduler.model.ResourceTimeRangeModel}
   *
   * @member {Scheduler.data.ResourceTimeRangeStore} resourceTimeRangeStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.ResourceTimeRangeStore} instance or a config object.
   * @config {Scheduler.data.ResourceTimeRangeStore|Object} resourceTimeRangeStore
   * @category Models & Stores
   */

  /**
   * Get or set data of project stores. The returned data is identical to what
   * {@link #function-toJSON} returns:
   *
   * ```javascript
   *
   * const data = scheduler.project.inlineData;
   *
   * // data:
   * {
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     dependenciesData       : [...],
   *     assignmentsData        : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * }
   *
   *
   * // Plug it back in later
   * scheduler.project.inlineData = data;
   * ```
   *
   * @property {Object}
   */


  get inlineData() {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(super.json);
  }

  set inlineData(inlineData) {
    this.json = inlineData;
  } //endregion
  //region Functions

  /**
   * Accepts a "data package" consisting of data for the projects stores, which is then loaded into the stores.
   *
   * The package can hold data for `EventStore`, `AssignmentStore`, `ResourceStore`, `DependencyStore`,
   * `TimeRangeStore` and `ResourceTimeRangeStore`. It uses the same format as when creating a project with inline
   * data:
   *
   * ```javascript
   * await project.loadInlineData({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   * ```
   *
   * After populating the stores it commits the project, starting its calculations. By awaiting `loadInlineData()` you
   * can be sure that project calculations are finished.
   *
   * @function loadInlineData
   * @param {Object} dataPackage A data package as described above
   * @fires load
   * @async
   */

  /**
   * Project changes (CRUD operations to records in its stores) are automatically committed on a buffer to the
   * underlying graph based calculation engine. The engine performs it calculations async.
   *
   * By calling this function, the commit happens right away. And by awaiting it you are sure that project
   * calculations are finished and that references between records are up to date.
   *
   * The returned promise is resolved with an object. If that object has `rejectedWith` set, there has been a conflict and the calculation failed.
   *
   * ```javascript
   * // Move an event in time
   * eventStore.first.shift(1);
   *
   * // Trigger calculations directly and wait for them to finish
   * const result = await project.commitAsync();
   *
   * if (result.rejectedWith) {
   *     // there was a conflict during the scheduling
   * }
   * ```
   *
   * @async
   * @returns {Promise}
   * @function commitAsync
   */
  //endregion
  //region Init


  construct(config = {}) {
    super.construct(...arguments); // These stores are not handled by engine, but still held on project

    const me = this;

    if (config.timeRangesData) {
      me.timeRangeStore.data = config.timeRangesData;
    }

    if (config.resourceTimeRangesData) {
      me.resourceTimeRangeStore.data = config.resourceTimeRangesData;
    }
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this;
    !me.timeRangeStore.stm && me.stm.addStore(me.timeRangeStore);
    !me.resourceTimeRangeStore.stm && me.stm.addStore(me.resourceTimeRangeStore);
  } //endregion
  //region Attaching stores
  // Attach to a store, relaying its change events


  attachStore(store) {
    store === null || store === void 0 ? void 0 : store.on({
      name: store.$$name,
      change: 'relayStoreChange',
      thisObj: this
    });
  } // Detach a store, stop relaying its change events


  detachStore(store) {
    store && this.detachListeners(store.$$name);
  }

  relayStoreChange(event) {
    /**
     * Fired when data in any of the projects stores changes.
     *
     * Basically a relayed version of each stores own change event, decorated with which store it originates from.
     * See the {@link Core.data.Store#event-change store change event} documentation for more information.
     *
     * @event change
     * @param {Scheduler.model.ProjectModel} source This project
     * @param {Core.data.Store} store Affected store
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
     * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
     * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
     */
    return this.trigger('change', _objectSpread(_objectSpread({
      store: event.source
    }, event), {}, {
      source: this
    }));
  }

  updateTimeRangeStore(store, oldStore) {
    this.detachStore(oldStore);
    this.attachStore(store);
  }

  setTimeRangeStore(store) {
    this.timeRangeStore = store;
  }

  changeTimeRangeStore(store) {
    // If it's not being nullified, upgrade a config object to be a full store
    if (store && !store.isStore) {
      store = this.timeRangeStoreClass.new({
        modelClass: this.timeRangeModelClass,
        storeId: 'timeRanges'
      }, store);
    }

    return store;
  }

  updateResourceTimeRangeStore(store, oldStore) {
    this.detachStore(oldStore);
    this.attachStore(store);
  }

  changeResourceTimeRangeStore(store) {
    // If it's not being nullified, upgrade a config object to be a full store
    if (store && !store.isStore) {
      store = this.resourceTimeRangeStoreClass.new({
        modelClass: this.resourceTimeRangeModelClass,
        storeId: 'resourceTimeRanges'
      }, store);
    }

    return store;
  }

  setResourceTimeRangeStore(store) {
    this.resourceTimeRangeStore = store;
  } //endregion
  //region Inline data


  async loadInlineData(data) {
    // Flag reset in super
    this.isLoadingInlineData = true; // Stores not handled by engine

    if (data.resourceTimeRangesData) {
      this.resourceTimeRangeStore.data = data.resourceTimeRangesData;
    }

    if (data.timeRangesData) {
      this.timeRangeStore.data = data.timeRangesData;
    }

    return super.loadInlineData(data);
  } //endregion
  //region JSON

  /**
   * Returns the data from the records of the projects stores, in a format that can be consumed by `loadInlineData()`.
   *
   * Used by JSON.stringify to correctly convert this record to json.
   *
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   *
   * const json = project.toJSON();
   *
   * // json:
   * {
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     dependenciesData       : [...],
   *     assignmentsData        : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * }
   * ```
   *
   * Output can be consumed by `loadInlineData()`:
   *
   * ```javascript
   * const json = project.toJSON();
   *
   * // Plug it back in later
   * project.loadInlineData(json);
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    const me = this,
          result = {
      eventsData: me.eventStore.toJSON(),
      resourcesData: me.resourceStore.toJSON(),
      dependenciesData: me.dependencyStore.toJSON(),
      timeRangesData: me.timeRangeStore.toJSON(),
      resourceTimeRangesData: me.resourceTimeRangeStore.toJSON()
    };

    if (!me.eventStore.usesSingleAssignment) {
      result.assignmentsData = me.assignmentStore.toJSON();
    }

    return result;
  }
  /**
   * Get or set project data (records from its stores) as a JSON string.
   *
   * Get a JSON string:
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   *
   * const jsonString = project.json;
   *
   * // jsonString:
   * '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * Set a JSON string (to populate the project stores):
   *
   * ```javascript
   * project.json = '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * @property {String}
   */


  get json() {
    return super.json;
  }

  changeJson(json) {
    if (typeof json === 'string') {
      json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(json);
    }

    return json;
  }

  updateJson(json) {
    json && this.loadInlineData(json);
  } //endregion


  afterChange(toSet, wasSet) {
    super.afterChange(...arguments);

    if (wasSet.calendar) {
      this.trigger('calendarChange');
    }
  }

  doDestroy() {
    this.timeRangeStore.destroy();
    this.resourceTimeRangeStore.destroy();
    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/RecurringTimeSpan.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../data/util/recurrence/AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
var productName = 'gantt';





function convertExceptionDatesValue(value) {
  const result = {},
        {
    dateFormat
  } = this;

  if (value) {
    value = typeof value == 'string' ? value.split(',') : Array.isArray(value) ? value : [value];
    value.forEach(item => {
      if (typeof item == 'string') {
        item = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(item, dateFormat);
      } // If we've got a valid date out of the incoming item, add an exception key


      if (!isNaN(item)) {
        result[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(item)] = 1;
      }
    });
  }

  return result;
}

function serializeExceptionDatesValue(value) {
  const result = [],
        {
    dateFormat
  } = this;

  for (const date in value) {
    if (value[date]) {
      result.push(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(date), dateFormat));
    }
  }

  return result;
}

const emptyArray = [];
/**
 * @module Scheduler/model/mixin/RecurringTimeSpan
 */

/**
 * This mixin class provides recurrence related fields and methods to a {@link Scheduler.model.TimeSpan timespan model}.
 *
 * The mixin introduces two types of timespans: __recurring timespan__ and its __occurrences__.
 * __Recurring timespan__ is a timespan having {@link #field-recurrenceRule recurrence rule} specified and its __occurrences__ are "fake" dynamically generated timespans.
 * Their set depends on the scheduler visible timespan and changes upon the timespan change.
 *
 * There are few methods allowing to distinguish a recurring event and an occurrence: {@link #property-isRecurring}, {@link #property-isOccurrence}
 * and {@link #property-recurringTimeSpan} (returns the event this record is an occurrence of).
 *
 * The {@link #field-recurrenceRule recurrence rule} defined for the event is parsed and
 * represented with {@link Scheduler.model.RecurrenceModel RecurrenceModel} class (can be changed by setting {@link #property-recurrenceModel} property) instance.
 * See: {@link #property-recurrence} property.
 * @mixin
 * @mixinbase TimeSpan
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringTimeSpan extends (Target || _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringTimeSpan';
  }
  /**
   * Returns `true` if this timespan supports recurring.
   * @property {Boolean}
   */


  get supportsRecurring() {
    return true;
  }

  static get fields() {
    return [
    /**
     * The timespan recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
     * @field {String} recurrenceRule
     * @category Scheduling
     */
    {
      name: 'recurrenceRule',
      internal: true
    },
    /**
     * A string (either a single date or multiple dates separated by comma) or an array of strings containing the timespan exception dates. The dates that must be skipped when generating occurrences for a repeating timespan.
     * This is used to modify only individual occurrences of the timespan so the further regenerations
     * won't create another copy of this occurrence again.
     *
     * ```javascript
     * {
     *     id: 7,
     *     startDate: '2021-10-12T14:00:00',
     *     endDate: '2021-10-12T15:00:00',
     *     name: 'Lunch',
     *     resourceId: 'hotel',
     *     recurrenceRule: 'FREQ=DAILY;COUNT=5',
     *     exceptionDates: ['2021-10-14']
     * }
     * ```
     *
     * Use {@link #function-addExceptionDate} method to add an individual entry to the dates array:
     *
     * ```javascript
     * // Break the link between the occurrence and its base.
     * // This also adds the occurrence date as an exception date
     * // so that the base timespan knows that this date should be skipped when regenerating its occurrences.
     * occurrence.recurringTimeSpan = null;
     *
     * // now the occurrence is an individual record that can be changed & persisted freely
     * occurrence.setStartEndDate(new Date(2018, 6, 2), new Date(2018, 6, 3));
     * ```
     * **Note:** The dates in this field get automatically removed when the event changes its {@link Scheduler.model.TimeSpan#field-startDate start date}.
     *
     * @field {String|String[]} exceptionDates
     * @category Scheduling
     */
    {
      name: 'exceptionDates',
      convert: convertExceptionDatesValue,
      serialize: serializeExceptionDatesValue,
      internal: true
    }];
  }
  /**
   * Override of {@link Core/data/Model}'s method. If an {@link #property-isOccurrence}
   * is passed, it is detached from its parent recurring event. If it still has a recurrence
   * then the recurring event is changed to stop at the occurrence date. If it has no recurrence
   * an exception is added at the occurrence date.
   */


  remove() {
    if (this.isOccurrence) {
      const me = this,
            {
        recurringTimeSpan
      } = me;
      me.cancelBatch();
      recurringTimeSpan.beginBatch();
      me.detachFromRecurringEvent();
      recurringTimeSpan.endBatch();
    } else {
      return super.remove(...arguments);
    }
  }

  get eventStore() {
    var _this$firstStore;

    let result = this.isOccurrence ? this.recurringEvent.eventStore : super.eventStore; // Recurrence methods are called on `eventStore`, but in case we have a regular
    // store with recurrence mixin, we won't event store and should return own
    // store instead

    if (!result && (_this$firstStore = this.firstStore) !== null && _this$firstStore !== void 0 && _this$firstStore.isRecurringTimeSpansMixin) {
      result = this.firstStore;
    }

    return result;
  }
  /**
   * Name of the class representing the recurrence model, defaults to {@link Scheduler.model.RecurrenceModel}
   * @property {String}
   */


  get recurrenceModel() {
    return this._recurrenceModel || _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_1__["default"];
  }

  set recurrenceModel(model) {
    this._recurrenceModel = model;
  }
  /**
   * Sets a recurrence for the timespan with a given frequency, interval, and end.
   * @param {Object|String|Scheduler.model.RecurrenceModel} recurrence A data object for an instance of {@link Scheduler.model.RecurrenceModel RecurrenceModel}.
   * May also be the frequency string: `DAILY`, `WEEKLY`, `MONTHLY`, or `YEARLY`.
   *
   * ```javascript
   * // repeat the event every other week till Jan 2 2039
   * event.setRecurrence({
   *     frequency : "WEEKLY",
   *     interval  : 2,
   *     endDate   : new Date(2039, 0, 2)
   * });
   * ```
   *
   * Also a {@link Scheduler.model.RecurrenceModel recurrence model} can be provided as the only argument for this method:
   *
   * ```javascript
   * const recurrence = new RecurrenceModel({ frequency : 'DAILY', interval : 5 });
   *
   * event.setRecurrence(recurrence);
   * ```
   *
   * or
   *
   * ```javascript
   * event.setRecurrence("WEEKLY", 2, new Date(2039, 0, 2));
   * ```
   * @param {Number} [interval] The interval between occurrences (instances of this recurrence). For example, a daily recurrence with an interval of 2 occurs every other day. Must be greater than 0.
   * @param {Number|Date} [recurrenceEnd] The end of the recurrence. The value can be specified by a date or by a maximum count of occurrences (has to greater than 1, since 1 means the event itself).
   */


  setRecurrence(recurrence, interval, recurrenceEnd) {
    const me = this;
    let recurrenceRule;

    if (recurrence) {
      if (!recurrence.isRecurrenceModel) {
        if (typeof recurrence === 'string') {
          recurrence = {
            frequency: recurrence
          };

          if (interval) {
            recurrence.interval = interval;
          } // If the recurrence is limited


          if (recurrenceEnd) {
            if (recurrenceEnd instanceof Date) {
              recurrence.endDate = recurrenceEnd;
            } else {
              recurrence.count = recurrenceEnd;
            }
          }
        }

        recurrence = new me.recurrenceModel(recurrence);
      } // The RecurrenceModel has a reference to its owning recurring event.
      // It uses this to remove the owning event's exceptions after its new endDate
      // whenever its endDate is changed.


      recurrence.timeSpan = me;
      recurrenceRule = recurrence.rule;
    }

    me.recurrence = recurrence;
    me.recurrenceRule = recurrenceRule;
  }
  /**
   * The recurrence model used for the timespan.
   * @property {Scheduler.model.RecurrenceModel}
   */


  get recurrence() {
    const me = this,
          rule = me.recurrenceRule;

    if (!me._recurrence && rule) {
      me._recurrence = new me.recurrenceModel({
        rule,
        timeSpan: me,
        id: `${me.id}-recurrence`
      });
    }

    return me._recurrence;
  }

  set recurrence(recurrence) {
    const me = this;
    me._recurrence = recurrence;

    if (recurrence) {
      // bind recurrence instance to the model
      recurrence.timeSpan = me;
      me.recurrenceRule = recurrence.rule;
    } else {
      // If this is being done to an occurrence, it's a signal that we are being
      // mutated into an exception. Apply the change immediately, directly to the data.
      if (me.isOccurrence) {
        me.setData('recurrenceRule', null);
      } else {
        me.recurrenceRule = null;
      }
    }
  }
  /**
   * Indicates if the timespan is recurring.
   * @property {Boolean}
   * @readonly
   */


  get isRecurring() {
    // MUST evaluate in this order so that if it is an occurrence,
    // the recurrence getter does not refresh the rule
    return Boolean(!this.isOccurrence && this.recurrence);
  }
  /**
   * Indicates if the timespan is an occurrence of another recurring timespan.
   * @property {Boolean}
   * @readonly
   */


  get isOccurrence() {
    return Boolean(this.recurringTimeSpan);
  }
  /**
   * The "main" timespan this model is an occurrence of. For non-occurrences returns `null`.
   * @property {Scheduler.model.TimeSpan}
   * @readonly
   * @internal
   */


  get recurringTimeSpan() {
    return this._recurringTimeSpan;
  }

  get isPersistable() {
    return super.isPersistable && (!this.supportsRecurring || !this.isOccurrence);
  }

  set recurringTimeSpan(recurringTimeSpan) {
    this._recurringTimeSpan = recurringTimeSpan;
  }
  /**
   * Returns the occurrences of this event over the specified time range. If the first
   * occurrence is in the time range `*this*` record is included in that position.
   * @param {Date} startDate The start date of the range for which to include occurrences.
   * @param {Date} [endDate] The end date of the range for which to include occurrences.
   * Defaults to the startDate.
   * @returns {Scheduler.model.TimeSpan[]} The array of occurrences which occur over the specified range.
   */


  getOccurrencesForDateRange(startDate, endDate = startDate) {
    return this.eventStore.getOccurrencesForTimeSpan(this, startDate, endDate);
  }
  /**
   * Array of this recurring timespan's cached occurrences. __Not including the owning recurring
   * event__.
   *
   * Empty if the timespan is not recurring.
   *
   * __Note that this is an internal accessor and is cleared whenever changes are made to the
   * owning recurring event__.
   * @property {Scheduler.model.TimeSpan[]}
   * @readonly
   * @internal
   */


  get occurrences() {
    if (this.isRecurring) {
      const result = []; // The occurrencesMap contains entries for each occurrence date.

      this.occurrenceMap.forEach(occurrence => {
        if (occurrence !== this) {
          result.push(occurrence);
        }
      });
      return result;
    }

    return emptyArray;
  }
  /**
   * A Map, keyed by each date an occurrence intersects, of occurrences of this event.
   * @property {Map}
   * @readonly
   * @internal
   */


  get occurrenceMap() {
    return this._occurrencesMap || (this._occurrencesMap = new Map());
  }
  /**
   * Removes an occurrence from this recurring timespan's cached occurrences.
   * @param dateOrTimeSpan occurrence date or occurrence TimeSpan
   * @internal
   */


  removeOccurrence(dateOrTimeSpan) {
    var _this$eventStore;

    const date = dateOrTimeSpan.isTimeSpan ? dateOrTimeSpan.occurrenceDate : dateOrTimeSpan; // Clear the occurrences *is* we are in an EventStore.

    (_this$eventStore = this.eventStore) === null || _this$eventStore === void 0 ? void 0 : _this$eventStore.globalOccurrences.delete(this.createRecurrenceKey(date)); // Remove occurrence from its by-startDate cache

    this.occurrenceMap.delete(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date));
  }
  /**
   * Removes all cached occurrences on or after the passed date from this recurring timespan's cached occurrences.
   * @internal
   */


  removeOccurrencesFrom(date) {
    this.occurrenceMap.forEach((occurrence, dateKey) => {
      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(dateKey) >= date) {
        this.removeOccurrence(occurrence);
      }
    });
  }
  /**
   * Removes this recurring timespan's cached occurrences.
   * @internal
   */


  removeOccurrences() {
    // This recurring event must also be removed from the occurrenceMap if it's there
    // So insert it as the first element. Can also be found from the store's global occurrence
    // Map using [...this.eventStore.globalOccurrences.keys()].filter(e => e.startsWith(`_generated:${this.id}`))
    [this, ...this.occurrences].forEach(occurrence => this.removeOccurrence(occurrence));
  }
  /**
   * The method is triggered when the timespan recurrence settings get changed.
   * It updates the {@link #field-recurrenceRule} field in this case.
   * @internal
   */


  onRecurrenceChanged() {
    var _this$recurrence;

    this.recurrenceRule = ((_this$recurrence = this.recurrence) === null || _this$recurrence === void 0 ? void 0 : _this$recurrence.rule) || null;
  }

  sanitizeRecurrenceData(recurrence = this.recurrence) {
    // Remove all exceptionsDates that our owning timeSpan had that are
    // now after our end date and therefore redundant.
    if (recurrence.endDate) {
      const endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(recurrence.endDate),
            {
        exceptionDates
      } = this; // Clear any now-invalid cached occurrences

      this.removeOccurrencesFrom(endDate); // If we had any exceptions on or after this date, remove them.

      if (exceptionDates) {
        for (const dateKey in exceptionDates) {
          const exceptionDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(dateKey);

          if (exceptionDate >= endDate) {
            delete exceptionDates[dateKey];
          }
        }
      }
    }
  }
  /**
   * The original {@lScheduler.model.TimeSpan#field-startDate startDate} of this event before any modifications
   * took place. Used by {@link #function-removeOccurrence} and {@link #function-detachFromRecurringEvent}
   * @internal
   * @readonly
   */


  get occurrenceDate() {
    var _this$meta$modified;

    return ((_this$meta$modified = this.meta.modified) === null || _this$meta$modified === void 0 ? void 0 : _this$meta$modified.startDate) || this.startDate;
  }
  /**
   * If this event is an {@link #property-isOccurrence occurrence} of a recurring event, then this
   * property yields its zero-based occurrence index in the sequence.
   * @property {Number}
   * @readonly
   */


  get occurrenceIndex() {
    return _data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__["default"].getOccurrenceIndex(this);
  }
  /**
   * Builds an occurrence of this recurring event by cloning the timespan data.
   * The method is used internally by the __RecurringTimeSpans__ mixin.
   * Override it if you need to customize the generated occurrences.
   *
   * If the date requested is the start date of the event sequence, `this`
   * record is returned. All runs of recurring events begin with the base record.
   * @param  {Date} occurrenceDate The occurrence start date.
   * @param  {Boolean} isFirst `true` if this is the first occurrence.
   * @return {Scheduler.model.TimeSpan} The occurrence.
   * @internal
   */


  buildOccurrence(occurrenceDate, isFirst) {
    var _me$eventStore;

    const me = this,
          {
      occurrenceMap,
      recurrence,
      meta
    } = me,
          globalOccurrences = (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.globalOccurrences,
          occurrenceKey = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(occurrenceDate),
          id = me.createRecurrenceKey(occurrenceDate, occurrenceKey),
          onStartDate = !(occurrenceDate - me.startDate),
          {
      fieldMap
    } = me.constructor; // An occurrence has a unique ID which identifies it by its base recurring event and its time.

    let occurrence = globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.get(id),
        {
      duration
    } = me; // If there's no duration, or it's an all day event (which makes the event ceil and floor its
    // start and end dates, but does *NOT* as of 27/5/2020 adjust its duration) then
    // we calculate the duration of the occurrence.

    if (me.endDate && (me.allDay || !duration)) {
      duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(me.durationUnit, me.endDate.getTime() - me.startDate.getTime());
    } // Don't let NaN in record data


    const occurrenceEndDate = duration !== undefined ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(occurrenceDate, duration, me.durationUnit) : undefined;

    if (!occurrence) {
      // If this is the first occurrence (start times may not match), or it's right on the start
      // then this recurring event *IS* the occurrence
      if (isFirst || onStartDate) {
        occurrence = me; // We are the first occurrence.
        // But if our start time is not as the rule requires, adjust ourself *silently*

        if (!onStartDate) {
          me.setStartEndDate(occurrenceDate, occurrenceEndDate, true); // Since we've changed the event start date the recurrence "Days"/"MonthDays"/"Months"
          // might get redundant in case the event start date matches the fields values
          // Calling recurrence sanitize() will clean the fields in this case.

          recurrence.suspendTimeSpanNotifying();
          recurrence.sanitize();
          recurrence.resumeTimeSpanNotifying();
        } // Either way, because of adjustment above, or initial correctness, we are in sync
        // with our recurrence rule. A RecurrenceIterator is now able to calculate a correct
        // UNTIL date from a COUNT value. See AbstractRecurrenceIterator#processIterationConfig


        meta.isSyncedWithRule = true;
      } // Generate an occurrence which references this as its parent
      else {
        occurrence = me.copy({
          [fieldMap.id.dataSource]: id,
          [fieldMap.startDate.dataSource]: occurrenceDate,
          [fieldMap.endDate.dataSource]: occurrenceEndDate,
          [fieldMap.duration.dataSource]: duration
        });
        occurrence.recurringTimeSpan = me;
      }

      globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.set(id, occurrence); // A recurring timespan keeps a by-startDate index of occurrences.
      // And itself will be among those.

      occurrenceMap.set(occurrenceKey, occurrence);
    }

    return occurrence;
  }

  createRecurrenceKey(date = this.startDate, dateKey = null) {
    return `_generated:${this.id}:${dateKey || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)}`;
  }

  afterChange(toSet, wasSet, silent, ...args) {
    const me = this,
          {
      eventStore
    } = me; // reset cached recurrence instance in case "recurrenceRule" is changed

    if ('recurrenceRule' in wasSet) {
      me._recurrence = null; // If we are a recurring event, we must be in the recurringEvents cache.
      // If we are *not* a recurring event, we must *not* be in there.
      // An event not yet in a store (eg dragging to create) won't have an eventStore.
      // eslint-disable-next-line no-unused-expressions

      eventStore === null || eventStore === void 0 ? void 0 : eventStore.recurringEvents[wasSet.recurrenceRule.value ? 'add' : 'delete'](me);
    } // Any change to an occurrence adds it to an event store, at which point
    // it ceases to be an occurrence.
    //
    // If it has a recurrenceRule it becomes the start of a new recurring event series,
    // and the old owning recurring event stops on the day before.
    //
    // If it has no recurrenceRule, it becomes an exception to its owning recurring event.


    if (me.isOccurrence) {
      var _wasSet$startDate, _wasSet$resourceRecor;

      const {
        recurringTimeSpan,
        resource,
        occurrenceIndex,
        recurrence
      } = me,
            startDate = ((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.value) || me.startDate,
            count = recurrence && recurringTimeSpan.recurrence.count,
            // resourceRecords is a temporary property of occurrence events to handle cases
      // if only resources has been updated. (change only resources won't mark record as dirty)
      newResource = ((_wasSet$resourceRecor = wasSet.resourceRecords) === null || _wasSet$resourceRecor === void 0 ? void 0 : _wasSet$resourceRecor.value) || me.data.newResource;
      recurringTimeSpan.beginBatch();
      me.detachFromRecurringEvent();
      me.clearChanges(); // Must silently set our own ID, not be the key generated from our parent id and occurrence date.
      // Must not result in the id field being in the modified state.

      me.setData('id', me.generateId(recurringTimeSpan.eventStore));

      if (newResource) {
        // clear resourceId to avoid auto-adding to assignmentStore, it is handled manually bellow
        delete me.data.resourceId;
      } // The impending changes to the former parent recurring event trigger a full refresh.


      recurringTimeSpan.eventStore.add(me, silent);
      me.startDate = startDate; // Ensure that the original count is honoured.
      // If we are the 8th occurrence of 10, OUR repeat count must be 3.

      if (count) {
        me.recurrence.count = count - occurrenceIndex;
      }

      me.assign(newResource || resource); // remove data after apply

      delete me.data.resourceRecords;
      delete wasSet.resourceRecords; // Any change to a recurring events triggers a store refresh event.

      recurringTimeSpan.endBatch();
    } else {
      // Setting a newException date must mark the exceptionDates as modified
      if ('newExceptionDate' in wasSet) {
        me.meta.modified.exceptionDates = true;
        delete me.meta.modified.newExceptionDate; // Remove any occurrence on that date from our by-startDate cache
        // and from the global occurrences cache

        me.removeOccurrence(wasSet.newExceptionDate.value);
      }
    }

    return super.afterChange(toSet, wasSet, silent, ...args);
  }
  /**
   * Detaches an occurrence from its owning recurring event so that it can be added to the eventStore
   * either as an exception, or as the start of a new recurring sequence.
   * @internal
   */


  detachFromRecurringEvent() {
    const me = this,
          // For access further down, breaking the link involves engine if trying to get the occurrenceDate later,
    // resulting in the wrong date
    {
      recurringTimeSpan,
      occurrenceDate,
      startDate
    } = me; // Break the link

    me.recurringTimeSpan = null; // The occurrenceDate is injected into the data when an occurrence is created.
    // the recurringTimeSpan's afterChange will remove any cache occurrence
    // for this date; see above

    recurringTimeSpan.addExceptionDate(occurrenceDate); // If we still have a recurrenceRule, we're being promoted to be a new recurring event.
    // The recurrence setter applies the rule immediately to occurrences, so this will
    // always be correct.

    if (me.recurrenceRule) {
      // The RecurrenceModel removes occurrences and exceptions after this date
      recurringTimeSpan.recurrence.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, -1, 'minute');
    }
  }
  /**
   * The setter used by Model#inSet when {@link #function-addExceptionDate} is called.
   * Adding an exception must trigger change processing in a recurring event, so it must
   * be changed through a {@link Core.data.Model#function-set} call. Also, the change must be batchable
   * with other changes.
   * @private
   * @readonly
   */


  set newExceptionDate(date) {
    if (date) {
      const exceptionDates = this.exceptionDates || (this.exceptionDates = {});
      exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)] = 1;
    }
  }
  /**
   * Adds an exception date that should be skipped when generating occurrences for the timespan.
   * The methods adds an entry to the array kept in {@link #field-exceptionDates} field.
   * @param {Date} date Exception date.
   * @internal
   */


  addExceptionDate(newExceptionDate) {
    return this.set({
      newExceptionDate
    });
  }
  /**
   * Does this recurring event have an exception on the passed date.
   * @param {Date} date The date to find an exception for.
   * @returns {Boolean} `true` if the event has an exception starting on the passed date.
   */


  hasException(date) {
    var _this$exceptionDates;

    return (_this$exceptionDates = this.exceptionDates) === null || _this$exceptionDates === void 0 ? void 0 : _this$exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)];
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ResourceModelMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ResourceModelMixin.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/**
* @module Scheduler/model/mixin/ResourceModelMixin
*/

/**
 * Mixin that holds configuration shared between resources in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ResourceModelMixin extends Target {
  static get $name() {
    return 'ResourceModelMixin';
  } // Flag checked by ResourceStore to make sure it uses a valid subclass


  static get isResourceModel() {
    return true;
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * This does not matter much on the resource itself, but is of importance when manipulating its references:
   *
   * ```javascript
   * assignment.set('resourceId', 2);
   * // resource.assignments is not yet up to date
   *
   * await assignment.setAsync('resourceId', 2);
   * // resource.assignments is up to date
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [
    /**
     * Unique identifier
     * @field {String|Number} id
     * @category Common
     */

    /**
     * Get or set resource name
     * @field {String} name
     * @category Common
     */
    {
      name: 'name',
      type: 'string',
      persist: true
    },
    /**
     * Controls the primary color used for events assigned to this resource. Can be overridden per event using
     * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventColor eventColor config}. See Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for available
     * colors.
     * @field {String} eventColor
     * @category Styling
     */
    'eventColor',
    /**
     * Controls the style used for events assigned to this resource. Can be overridden per event using
     * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventStyle eventStyle config}. See Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for available
     * options.
     * @field {String} eventStyle
     * @category Styling
     */
    'eventStyle',
    /**
     * Fully qualified image URL, used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
     * for the resource.
     * @field {String} imageUrl
     * @category Styling
     */
    'imageUrl',
    /**
     * Image name relative to {@link Scheduler/view/mixin/SchedulerEventRendering#config-resourceImagePath},
     * used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
     * for the resource.
     * @field {String} image
     * @category Styling
     */
    'image',
    /**
     * Margin from rows edge to topmost event bar for this resource, in px.
     * @field {Number} resourceMargin
     * @category Layout
     */
    {
      name: 'resourceMargin',
      type: 'number'
    },
    /**
     * Margin between stacked event bars for this resource, in px.
     * @field {Number} barMargin
     * @category Layout
     */
    {
      name: 'barMargin',
      type: 'number'
    },
    /**
     * Base height of this resource, in px. When unset, Schedulers configured rowHeight is used.
     *
     * This value is used in horizontal mode to determine row height. When stacking, it is used as input for
     * calculating the actual row height:
     *
     * ```javascript
     * row.height = (resource.rowHeight - resourceMargin * 2) * overlap count - barMargin * (overlap count - 1)
     * ```
     *
     * When packing or overlapping, it is used as the actual row height.
     *
     * @field {Number} rowHeight
     * @category Layout
     */

    /**
     * Specify this to use a resource specific event layout in horizontal mode, see
     * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} for options.
     *
     * When unset (the default) Schedulers setting is used.
     *
     * @field {String} eventLayout
     * @category Layout
     */
    'eventLayout'];
  } //endregion
  //region Id change


  updateAssignmentResourceIds() {
    this.assigned.forEach(assignment => {
      assignment.resourceId = this.id;
    });
  }

  syncId(value) {
    super.syncId(value);
    this.updateAssignmentResourceIds();
  } //endregion
  //region Getters

  /**
   * Get associated events
   *
   * @property {Scheduler.model.EventModel[]}
   * @readonly
   */


  get events() {
    return this.assignments.reduce((events, assignment) => {
      if (assignment.event) {
        events.push(assignment.event);
      }

      return events;
    }, []);
  }
  /**
   * Returns all assignments for the resource
   *
   * @property {Scheduler.model.AssignmentModel[]}
   */


  get assignments() {
    return this.assigned ? [...this.assigned] : [];
  }

  set assignments(assignments) {
    // Engine does not allow assigning to `assigned`, handle it here
    assignments.forEach(assignment => {
      assignment.resource = this;
    });
  }
  /**
   * Returns an array of events, associated with this resource
   *
   * @return {Scheduler.model.EventModel[]}
   */


  getEvents() {
    // TODO: Deprecate in favor of .events
    return this.events;
  }
  /**
   * Returns true if the Resource can be persisted.
   * In a flat store, a resource is always considered persistable. In a tree store, a resource is considered
   * persistable if its parent node is persistable.
   *
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    return super.isPersistable && (!this.parent || this.parent.isPersistable);
  } //endregion

  /**
   * Unassigns this Resource from all its Events
   */


  unassignAll() {
    this.assignments && this.assignmentStore.remove(this.assignments);
  }
  /**
   * Returns the initials (first letter of the first & last space-separated word in the name) or an empty string
   * if this resource has no name. You can override this method in a ResourceModel subclass to provide your own implementation
   *
   * @property {String}
   * @readonly
   */


  get initials() {
    const {
      name = ''
    } = this;

    if (!name) {
      return '';
    }

    const names = name.split(' '),
          firstInitial = names[0][0],
          lastInitial = names.length > 1 ? names[names.length - 1][0] : '';
    return firstInitial + lastInitial;
  }

  isWorkingTime(date) {
    var _this$project;

    const calendar = this.effectiveCalendar || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.calendar);
    return !calendar || calendar.isWorkingTime(date);
  }

});

/***/ }),

/***/ "./lib/Scheduler/preset/PresetManager.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/preset/PresetManager.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return pm; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _PresetStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");
var productName = 'gantt';



 // No module tag here. That stops the singleton from being included by the docs.

/**
 * ## Intro
 * This is a global Store of {@link Scheduler.preset.ViewPreset ViewPresets}, required to supply initial data to
 * Scheduler's {@link Scheduler.view.mixin.TimelineViewPresets#config-presets presets}.
 *
 * You can provide new view presets globally or for a specific scheduler.
 *
 * **NOTE:** You **cannot** modify existing records in the PresetManager store. You can either remove
 * preset records from the store or add new records to the store.
 * Also please keep in mind, all changes provided to the PresetManager store are not reflected to the
 * {@link Scheduler.view.mixin.TimelineViewPresets#config-presets presets} of schedulers that already exist!
 *
 * If you want to have just a few presets (also known as zoom levels) in your Scheduler, you can slice corresponding records
 * from the `PresetManager` and apply them to the Scheduler `presets` config.
 * ```javascript
 * const newPresets = PresetManager.records.slice(10, 12);
 *
 * const scheduler = new Scheduler({
 *     presets    : newPresets, // Only 2 zoom levels are available
 *     viewPreset : newPresets[0].id
 * });
 * ```
 *
 * If you want to adjust all default presets and assign to a specific scheduler you are going to create,
 * you can extend them and pass as an array to the Scheduler `presets` config.
 * Here is an example of how to set the same `timeResolution` to all `ViewPresets`.
 * ```javascript
 * const newPresets = PresetManager.map(preset => {
 *     return {
 *         id             : 'my_' + preset.id,
 *         base           : preset.id, // Based on an existing preset
 *         timeResolution : {
 *             unit      : 'day',
 *             increment : 1
 *         }
 *     };
 * });
 *
 * const scheduler = new Scheduler({
 *     presets     : newPresets,
 *     viewPreset : 'my_hourAndDay'
 * });
 * ```
 *
 * If you want to do the same for **all** schedulers which will be created next, you can register new presets in a loop.
 * ```javascript
 * PresetManager.records.forEach(preset => {
 *     // Pass the same ID, so when a new preset is added to the store, it will replace the current one.
 *     PresetManager.registerPreset(preset.id, {
 *        id             : preset.id,
 *        base           : preset.id,
 *        timeResolution : {
 *            unit      : 'day',
 *            increment : 1
 *        }
 *    });
 * });
 * ```
 *
 * Here is an example of how to add a new `ViewPreset` to the global `PresetManager` store and to the already created scheduler `presets`.
 * ```javascript
 * const scheduler = new Scheduler({...});
 *
 * const newGlobalPresets = PresetManager.add({
 *     id              : 'myNewPreset',
 *     base            : 'hourAndDay', // Based on an existing preset
 *     columnLinesFor  : 0,
 *     headers : [                         // Override headers
 *         {
 *             unit       : 'day',
 *             dateFormat : 'DD.MM.YYYY'   // Use different date format for top header 01.10.2020
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'LT'
 *         }
 *     ]
 * });
 *
 * scheduler.presets.add(newGlobalPresets); // Add new presets to the scheduler that has been created before changes to PresetManager are applied
 * ```
 *
 * Predefined presets are:
 *
 * - `secondAndMinute` - creates 2 level header - minute and seconds within it:
 * {@inlineexample Scheduler/preset/secondAndMinute.js}
 * - `minuteAndHour` - creates 2 level header - hour and minutes within it:
 * {@inlineexample Scheduler/preset/minuteAndHour.js}
 * - `hourAndDay` - creates 2 level header - day and hours within it:
 * {@inlineexample Scheduler/preset/hourAndDay.js}
 * - `dayAndWeek` - creates 2 level header - week and days within it:
 * {@inlineexample Scheduler/preset/dayAndWeek.js}
 * - `weekAndDay` - just like `dayAndWeek` but with different formatting:
 * {@inlineexample Scheduler/preset/weekAndDay.js}
 * - `weekAndDayLetter` - creates 2 level header - with weeks and day letters within it:
 * {@inlineexample Scheduler/preset/weekAndDayLetter.js}
 * - `weekAndMonth` - creates 2 level header - month and weeks within it:
 * {@inlineexample Scheduler/preset/weekAndMonth.js}
 * - `weekDateAndMonth` - creates 2 level header - month and weeks within it (weeks shown by first day only):
 * {@inlineexample Scheduler/preset/weekDateAndMonth.js}
 * - `monthAndYear` - creates 2 level header - year and months within it:
 * {@inlineexample Scheduler/preset/monthAndYear.js}
 * - `year` - creates 2 level header - year and quarters within it:
 * {@inlineexample Scheduler/preset/year.js}
 * - `manyYears` - creates 2 level header - 5-years and year within it:
 * {@inlineexample Scheduler/preset/manyYears.js}
 *
 * See the {@link Scheduler.preset.ViewPreset} and {@link Scheduler.preset.ViewPresetHeaderRow} classes for a description of the view preset properties.
 *
 * {@region Localizing View Presets}
 * Bryntum Scheduler uses locales for translations including date formats for view presets.
 *
 * To translate date format for view presets just define the date format for the specified region
 * for your locale file, like this:
 * ```javascript
 * const locale = {
 *
 *     // ... Other translations here ...
 *
 *     PresetManager : {
 *         // Translation for the "weekAndDay" ViewPreset
 *         weekAndDay : {
 *             // Change the date format for the top and middle levels
 *             topDateFormat    : 'MMM',
 *             middleDateFormat : 'D'
 *         },
 *         // Translation for the "dayAndWeek" ViewPreset
 *         dayAndWeek : {
 *             // Change the date format for the top level
 *             topDateFormat : 'MMMM YYYY'
 *         }
 *     }
 * }
 *
 * LocaleManager.extendLocale('En', locale);
 * ```
 *
 * Check the <a target="_blank" href="../examples/localization">localization demo</a> and [this guide](#Scheduler/guides/customization/localization.md) for more details.
 * {@endregion}
 *
 * @singleton
 * @extends Scheduler/preset/PresetStore
 */

class PresetManager extends _PresetStore_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get $name() {
    return 'PresetManager';
  }

  static get defaultConfig() {
    return {
      // To not break CSP demo
      preventSubClassingModel: true,
      basePresets: {
        // Do not remove. Assertion strings for Localization sanity check.
        // 'L{secondAndMinute}'
        // 'L{minuteAndHour}'
        // 'L{hourAndDay}'
        // 'L{dayAndWeek}'
        // 'L{weekAndDay}'
        secondAndMinute: {
          name: 'Seconds',
          tickWidth: 30,
          // Time column width
          tickHeight: 40,
          displayDateFormat: 'll LTS',
          // Controls how dates will be displayed in tooltips etc
          shiftIncrement: 10,
          // Controls how much time to skip when calling shiftNext and shiftPrevious.
          shiftUnit: 'minute',
          // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
          defaultSpan: 24,
          // By default, if no end date is supplied to a view it will show 24 hours
          timeResolution: {
            // Dates will be snapped to this resolution
            unit: 'second',
            // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
            increment: 5
          },
          // This defines your header rows.
          // For each row you can define "unit", "increment", "dateFormat", "renderer", "align", and "thisObj"
          headers: [{
            unit: 'minute',
            dateFormat: 'llll'
          }, {
            unit: 'second',
            increment: 10,
            dateFormat: 'ss'
          }]
        },
        minuteAndHour: {
          name: 'Minutes',
          tickWidth: 60,
          // Time column width
          tickHeight: 60,
          displayDateFormat: 'll LT',
          // Controls how dates will be displayed in tooltips etc
          shiftIncrement: 1,
          // Controls how much time to skip when calling shiftNext and shiftPrevious.
          shiftUnit: 'hour',
          // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
          defaultSpan: 24,
          // By default, if no end date is supplied to a view it will show 24 hours
          timeResolution: {
            // Dates will be snapped to this resolution
            unit: 'minute',
            // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
            increment: 30
          },
          headers: [{
            unit: 'hour',
            dateFormat: 'ddd MM/DD, hA'
          }, {
            unit: 'minute',
            increment: 30,
            dateFormat: 'mm'
          }]
        },
        hourAndDay: {
          name: 'Hours',
          tickWidth: 70,
          tickHeight: 40,
          displayDateFormat: 'll LT',
          shiftIncrement: 1,
          shiftUnit: 'day',
          defaultSpan: 24,
          timeResolution: {
            unit: 'minute',
            increment: 30
          },
          headers: [{
            unit: 'day',
            dateFormat: 'ddd DD/MM' //Mon 01/10

          }, {
            unit: 'hour',
            dateFormat: 'LT'
          }]
        },
        day: {
          name: 'Hours 2',
          displayDateFormat: 'LT',
          shiftIncrement: 1,
          shiftUnit: 'day',
          defaultSpan: 1,
          timeResolution: {
            unit: 'minute',
            increment: 30
          },
          mainHeaderLevel: 0,
          headers: [{
            unit: 'day',
            dateFormat: 'ddd DD/MM',
            // Mon 01/02
            splitUnit: 'day'
          }, {
            unit: 'hour',

            renderer(value) {
              return `
                                    <div class="b-sch-calendarcolumn-ct"><span class="b-sch-calendarcolumn-hours">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(value, 'HH')}</span>
                                    <span class="b-sch-calendarcolumn-minutes">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(value, 'mm')}</span></div>
                                `;
            }

          }]
        },
        week: {
          name: 'Week/hours',
          displayDateFormat: 'LT',
          shiftIncrement: 1,
          shiftUnit: 'week',
          defaultSpan: 24,
          timeResolution: {
            unit: 'minute',
            increment: 30
          },
          mainHeaderLevel: 0,
          headers: [{
            unit: 'week',
            dateFormat: 'D d',
            splitUnit: 'day'
          }, {
            unit: 'hour',
            dateFormat: 'LT',

            // will be overridden by renderer
            renderer(value) {
              return `
                                    <div class="sch-calendarcolumn-ct">
                                    <span class="sch-calendarcolumn-hours">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(value, 'HH')}</span>
                                    <span class="sch-calendarcolumn-minutes">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(value, 'mm')}</span>
                                    </div>
                                `;
            }

          }]
        },
        dayAndWeek: {
          name: 'Days 2',
          tickWidth: 100,
          tickHeight: 80,
          displayDateFormat: 'll LT',
          shiftUnit: 'day',
          shiftIncrement: 1,
          defaultSpan: 5,
          timeResolution: {
            unit: 'hour',
            increment: 1
          },
          headers: [{
            unit: 'week',

            renderer(start) {
              return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getShortNameOfUnit('week') + '.' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(start, 'WW MMM YYYY');
            }

          }, {
            unit: 'day',
            dateFormat: 'dd DD'
          }]
        },
        weekAndDay: {
          name: 'Days',
          tickWidth: 100,
          tickHeight: 80,
          displayDateFormat: 'll hh:mm A',
          shiftUnit: 'week',
          shiftIncrement: 1,
          defaultSpan: 1,
          timeResolution: {
            unit: 'day',
            increment: 1
          },
          mainHeaderLevel: 0,
          headers: [{
            unit: 'week',
            dateFormat: 'YYYY MMMM DD' // 2017 January 01

          }, {
            unit: 'day',
            increment: 1,
            dateFormat: 'DD MMM'
          }]
        },
        weekAndMonth: {
          name: 'Weeks',
          tickWidth: 100,
          tickHeight: 105,
          displayDateFormat: 'll',
          shiftUnit: 'week',
          shiftIncrement: 5,
          defaultSpan: 6,
          timeResolution: {
            unit: 'day',
            increment: 1
          },
          headers: [{
            unit: 'month',
            dateFormat: 'MMM YYYY' //Jan 2017

          }, {
            unit: 'week',
            dateFormat: 'DD MMM'
          }]
        },
        weekAndDayLetter: {
          name: 'Weeks 2',
          tickWidth: 20,
          tickHeight: 50,
          displayDateFormat: 'll',
          shiftUnit: 'week',
          shiftIncrement: 1,
          defaultSpan: 10,
          timeResolution: {
            unit: 'day',
            increment: 1
          },
          mainHeaderLevel: 0,
          headers: [{
            unit: 'week',
            dateFormat: 'ddd DD MMM YYYY',
            verticalColumnWidth: 115
          }, {
            unit: 'day',
            dateFormat: 'd1',
            verticalColumnWidth: 25
          }]
        },
        weekDateAndMonth: {
          name: 'Weeks 3',
          tickWidth: 30,
          tickHeight: 40,
          displayDateFormat: 'll',
          shiftUnit: 'week',
          shiftIncrement: 1,
          defaultSpan: 10,
          timeResolution: {
            unit: 'day',
            increment: 1
          },
          headers: [{
            unit: 'month',
            dateFormat: 'YYYY MMMM'
          }, {
            unit: 'week',
            dateFormat: 'DD'
          }]
        },
        monthAndYear: {
          name: 'Months',
          tickWidth: 110,
          tickHeight: 110,
          displayDateFormat: 'll',
          shiftIncrement: 3,
          shiftUnit: 'month',
          defaultSpan: 12,
          timeResolution: {
            unit: 'day',
            increment: 1
          },
          headers: [{
            unit: 'year',
            dateFormat: 'YYYY' //2017

          }, {
            unit: 'month',
            dateFormat: 'MMM YYYY' //Jan 2017

          }]
        },
        year: {
          name: 'Years',
          tickWidth: 100,
          tickHeight: 100,
          resourceColumnWidth: 100,
          displayDateFormat: 'll',
          shiftUnit: 'year',
          shiftIncrement: 1,
          defaultSpan: 1,
          timeResolution: {
            unit: 'month',
            increment: 1
          },
          headers: [{
            unit: 'year',
            dateFormat: 'YYYY'
          }, {
            unit: 'quarter',

            renderer(start, end, cfg) {
              return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getShortNameOfUnit('quarter').toUpperCase() + (Math.floor(start.getMonth() / 3) + 1);
            }

          }]
        },
        manyYears: {
          name: 'Years 2',
          tickWidth: 40,
          tickHeight: 50,
          displayDateFormat: 'll',
          shiftUnit: 'year',
          shiftIncrement: 1,
          defaultSpan: 1,
          timeResolution: {
            unit: 'year',
            increment: 1
          },
          mainHeaderLevel: 0,
          headers: [{
            unit: 'year',
            dateFormat: 'YYYY',
            increment: 5
          }, {
            unit: 'year',
            dateFormat: 'YY',
            increment: 1
          }]
        }
      },
      // This is a list of bryntum-supplied preset adjustments used to create the Scheduler's
      // default initial set of ViewPresets.
      defaultPresets: [// Years over years
      'manyYears', {
        width: 80,
        increment: 1,
        resolution: 1,
        preset: 'manyYears',
        resolutionUnit: 'YEAR'
      }, // Years over quarters
      'year', {
        width: 30,
        increment: 1,
        resolution: 1,
        preset: 'year',
        resolutionUnit: 'MONTH'
      }, {
        width: 50,
        increment: 1,
        resolution: 1,
        preset: 'year',
        resolutionUnit: 'MONTH'
      }, {
        width: 200,
        increment: 1,
        resolution: 1,
        preset: 'year',
        resolutionUnit: 'MONTH'
      }, // Years over months
      'monthAndYear', // Months over weeks
      'weekDateAndMonth', // Months over weeks
      'weekAndMonth', // Months over weeks
      'weekAndDayLetter', // Weeks over days
      'weekAndDay', {
        width: 54,
        increment: 1,
        resolution: 1,
        preset: 'weekAndDay',
        resolutionUnit: 'HOUR'
      }, // Days over hours
      'hourAndDay', {
        width: 64,
        increment: 6,
        resolution: 30,
        preset: 'hourAndDay',
        resolutionUnit: 'MINUTE'
      }, {
        width: 100,
        increment: 6,
        resolution: 30,
        preset: 'hourAndDay',
        resolutionUnit: 'MINUTE'
      }, {
        width: 64,
        increment: 2,
        resolution: 30,
        preset: 'hourAndDay',
        resolutionUnit: 'MINUTE'
      }, // Hours over minutes
      'minuteAndHour', {
        width: 30,
        increment: 15,
        resolution: 5,
        preset: 'minuteAndHour'
      }, {
        width: 130,
        increment: 15,
        resolution: 5,
        preset: 'minuteAndHour'
      }, {
        width: 60,
        increment: 5,
        resolution: 5,
        preset: 'minuteAndHour'
      }, {
        width: 100,
        increment: 5,
        resolution: 5,
        preset: 'minuteAndHour'
      }, // Minutes over seconds
      'secondAndMinute', {
        width: 60,
        increment: 10,
        resolution: 5,
        preset: 'secondAndMinute'
      }, {
        width: 130,
        increment: 5,
        resolution: 5,
        preset: 'secondAndMinute'
      }],
      listeners: {
        locale: 'updateLocalization'
      }
    };
  }

  set basePresets(basePresets) {
    const presetCache = this._basePresets = {};

    for (const id in basePresets) {
      basePresets[id].id = id;
      presetCache[id] = this.createRecord(basePresets[id]);
    }
  }

  get basePresets() {
    return this._basePresets;
  }

  set defaultPresets(defaultPresets) {
    for (let i = 0, {
      length
    } = defaultPresets; i < length; i++) {
      const presetAdjustment = defaultPresets[i],
            isBase = typeof presetAdjustment === 'string',
            baseType = isBase ? presetAdjustment : presetAdjustment.preset;
      let preset; // The default was just a string, so it's an unmodified instance of a base type.

      if (isBase) {
        preset = this.basePresets[baseType];
      } // If it's an object, it's an adjustment to a base type
      else {
        const config = Object.setPrototypeOf(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(this.basePresets[baseType].data), {
          id: baseType
        }),
              {
          timeResolution
        } = config,
              bottomHeader = config.headers[config.headers.length - 1];
        config.id = undefined;

        if ('width' in presetAdjustment) {
          config.tickWidth = presetAdjustment.width;
        }

        if ('height' in presetAdjustment) {
          config.tickHeight = presetAdjustment.height;
        }

        if ('increment' in presetAdjustment) {
          bottomHeader.increment = presetAdjustment.increment;
        }

        if ('resolution' in presetAdjustment) {
          timeResolution.increment = presetAdjustment.resolution;
        }

        if ('resolutionUnit' in presetAdjustment) {
          timeResolution.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getUnitByName(presetAdjustment.resolutionUnit);
        }

        preset = this.createRecord(config); // Keep id of original preset around, used with localization in PresetStore

        preset.baseId = baseType;
      }

      this.add(preset);
    }
  }

  getById(id) {
    // Look first in the default set, and if it's one of the base types that is not imported into the
    // default set, then look at the bases.
    return super.getById(id) || this.basePresets[id];
  }
  /**
   * Registers a new view preset base to be used by any scheduler grid or tree on the page.
   * @param {String} id The unique identifier for this preset
   * @param {Object} config The configuration properties of the view preset (see {@link Scheduler.preset.ViewPreset} for more information)
   * @returns {Scheduler.preset.ViewPreset} A new ViewPreset based upon the passed configuration.
   */


  registerPreset(id, config) {
    const preset = this.createRecord(Object.assign({
      id
    }, config)),
          existingDuplicate = this.find(p => p.equals(preset));

    if (existingDuplicate) {
      return existingDuplicate;
    }

    if (preset.isValid) {
      this.add(preset);
    } else {
      throw new Error('Invalid preset, please check your configuration');
    }

    return preset;
  }

  getPreset(preset) {
    if (typeof preset === 'number') {
      preset = this.getAt(preset);
    }

    if (typeof preset === 'string') {
      preset = this.getById(preset);
    } else if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
      preset = this.createRecord(preset);
    }

    return preset;
  }
  /**
   * Applies preset customizations or fetches a preset view preset using its name.
   * @param {String|Object} presetOrId Id of a predefined preset or a preset config object
   * @returns {Scheduler.preset.ViewPreset} Resulting ViewPreset instance
   */


  normalizePreset(preset) {
    const me = this;

    if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
      if (typeof preset === 'string') {
        preset = me.getPreset(preset);

        if (!preset) {
          throw new Error('You must define a valid view preset. See PresetManager for reference');
        }
      } else if (typeof preset === 'object') {
        // Look up any existing ViewPreset that it is based upon.
        if (preset.base) {
          const base = this.getById(preset.base);

          if (!base) {
            throw new Error(`ViewPreset base '${preset.base}' does not exist`);
          } // The config is based upon the base's data with the new config object merged in.


          preset = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(base.data), preset);
        } // Ensure the new ViewPreset has a legible, logical id which does not already
        // exist in our store.


        if (preset.id) {
          preset = me.createRecord(preset);
        } else {
          preset = me.createRecord(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, preset));
          preset.id = preset.generateId(preset);
        }
      }
    }

    return preset;
  }
  /**
   * Deletes a view preset
   * @param {String} id The id of the preset, or the preset instance.
   */


  deletePreset(presetOrId) {
    if (typeof presetOrId === 'string') {
      presetOrId = this.getById(presetOrId);
    } else if (typeof presetOrId === 'number') {
      presetOrId = this.getAt(presetOrId);
    }

    if (presetOrId) {
      this.remove(presetOrId); // ALso remove it from our base list

      delete this.basePresets[presetOrId.id];
    }
  }

}

const pm = new PresetManager();


/***/ }),

/***/ "./lib/Scheduler/preset/PresetStore.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/preset/PresetStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PresetStore; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _ViewPreset_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _PresetManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';






/**
 * @module Scheduler/preset/PresetStore
 */

/**
 * A special Store subclass which holds {@link Scheduler.preset.ViewPreset ViewPresets}.
 * Each ViewPreset in this store represents a zoom level. The store data is sorted in special
 * zoom order. That is zoomed out to zoomed in. The first Preset will produce the narrowest event bars
 * the last one will produce the widest event bars.
 *
 * To specify view presets (zoom levels) please provide set of view presets to the scheduler:
 *
 * ```javascript
 * const myScheduler = new Scheduler({
 *     presets : [
 *         {
 *             base : 'hourAndDay',
 *             id   : 'MyHourAndDay',
 *             // other preset configs....
 *         },
 *         {
 *             base : 'weekAndMonth',
 *             id   : 'MyWeekAndMonth',
 *             // other preset configs....
 *         }
 *     ],
 *     viewPreset : 'MyHourAndDay',
 *     // other scheduler configs....
 *     });
 * ```
 *
 * @extends Core/data/Store
 */

class PresetStore extends Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  static get $name() {
    return 'PresetStore';
  }

  static get defaultConfig() {
    return {
      useRawData: true,
      modelClass: _ViewPreset_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * Specifies the sort order of the presets in the store.
       * By default they are in zoomed out to zoomed in order. That is
       * presets which will create widest event bars to presets
       * which will produce narrowest event bars.
       *
       * Configure this as `-1` to reverse this order.
       * @config {Number}
       * @default
       */
      zoomOrder: 1
    };
  }

  set storage(storage) {
    super.storage = storage; // Maintained in order automatically while adding.

    this.storage.addSorter((lhs, rhs) => {
      const leftBottomHeader = lhs.bottomHeader,
            rightBottomHeader = rhs.bottomHeader; // Sort order:
      //  Milliseconds per pixel.
      //  Tick size.
      //  Unit magnitude.
      //  Increment size.

      const order = rhs.msPerPixel - lhs.msPerPixel || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["unitMagnitudes"][leftBottomHeader.unit] - _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["unitMagnitudes"][rightBottomHeader.unit] || leftBottomHeader.increment - rightBottomHeader.increment;
      return order * this.zoomOrder;
    });
  }

  get storage() {
    return super.storage;
  }

  createRecord(data, ...args) {
    if (data.base) {
      const base = this.getById(data.base) || _PresetManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].getById(data.base); // Flatten to set prototype for the full config below, since config system forks etc

      data = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, data);
      Object.setPrototypeOf(data, base.data);
    }

    return super.createRecord(data, ...args);
  }

  updateLocalization() {
    super.updateLocalization();
    const me = this; // Collect presets from store...

    let presets = me.allRecords; // and basePresets if we are the PresetManager

    if (me.isPresetManager) {
      presets = new Set(presets.concat(Object.values(me.basePresets)));
    }

    presets.forEach(preset => {
      let locale = me.optionalL(preset.id); // Default presets generated from base presets use localization of base if they have no own

      if (typeof locale === 'string' && preset.baseId) {
        locale = me.optionalL(preset.baseId);
      } // Apply any custom format defined in locale, or the original format if none exists


      if (locale && typeof locale === 'object') {
        if (!preset.originalDisplayDateFormat) {
          preset.originalDisplayDateFormat = preset.displayDateFormat;
        } // TODO: work around to work topDateFormat for weekAndDay viewPreset localization.
        // it must be fixed on: https://github.com/bryntum/support/issues/1775
        // it there is a topDateFormat but preset.mainHeaderLevel is 0, means the middle header is the top header actually, so convert property to middle (if middle doesn't exists) to localization understand (topDateFormat for weekAndDay for example)
        // topDateFormat doesn't work when mainHeaderLevel is 0 because it doesn't have top config but has top header visually (Check on get headerConfig method in ViewPreset class)


        if (preset.mainHeaderLevel === 0 && locale.topDateFormat) {
          locale.middleDateFormat = locale.middleDateFormat || locale.topDateFormat;
        }

        preset.setData('displayDateFormat', locale.displayDateFormat || preset.originalDisplayDateFormat);
        ['top', 'middle', 'bottom'].forEach(level => {
          const levelConfig = preset.headerConfig[level],
                localeLevelDateFormat = locale[level + 'DateFormat'];

          if (levelConfig) {
            if (!levelConfig.originalDateFormat) {
              levelConfig.originalDateFormat = levelConfig.dateFormat;
            } // if there was defined topDateFormat on locale file for example, use it instead of renderer from basePresets (https://github.com/bryntum/support/issues/1307)


            if (localeLevelDateFormat && levelConfig.renderer) {
              levelConfig.renderer = null;
            }

            levelConfig.dateFormat = localeLevelDateFormat || levelConfig.originalDateFormat;
          }
        });
      }
    });
  }

}
PresetStore._$name = 'PresetStore';

/***/ }),

/***/ "./lib/Scheduler/preset/ViewPreset.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/preset/ViewPreset.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ViewPreset; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';




/**
 * @module Scheduler/preset/ViewPreset
 */

/**
 * A ViewPreset is a record of {@link Scheduler.preset.PresetStore PresetStore} which describes the granularity
 * of the timeline view of a {@link Scheduler.view.Scheduler Scheduler} and the layout and subdivisions of the timeline header.
 *
 * You can create a new instance by specifying all fields:
 * ```javascript
 * const myViewPreset = new ViewPreset({
 *     id   : 'myPreset',              // Unique id value provided to recognize your view preset. Not required, but having it you can simply set new view preset by id: scheduler.viewPreset = 'myPreset'
 *
 *     name : 'My view preset',        // A human-readable name provided to be used in GUI, e.i. preset picker, etc.
 *
 *     tickWidth  : 24,                // Time column width in horizontal mode
 *     tickHeight : 50,                // Time column height in vertical mode
 *     displayDateFormat : 'HH:mm',    // Controls how dates will be displayed in tooltips etc
 *
 *     shiftIncrement : 1,             // Controls how much time to skip when calling shiftNext and shiftPrevious.
 *     shiftUnit      : 'day',         // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
 *     defaultSpan    : 12,            // By default, if no end date is supplied to a view it will show 12 hours
 *
 *     timeResolution : {              // Dates will be snapped to this resolution
 *         unit      : 'minute',       // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
 *         increment : 15
 *     },
 *
 *     headers : [                     // This defines your header rows from top to bottom
 *         {                           // For each row you can define 'unit', 'increment', 'dateFormat', 'renderer', 'align', and 'thisObj'
 *             unit       : 'day',
 *             dateFormat : 'ddd DD/MM'
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'HH:mm'
 *         }
 *     ],
 *
 *     columnLinesFor : 1              // Defines header level column lines will be drawn for. Defaults to the last level.
 * });
 * ```
 *
 * Or you can extend one of view presets registered in {@link Scheduler.preset.PresetManager PresetManager}:
 *
 * ```javascript
 * const myViewPreset2 = new ViewPreset({
 *     id   : 'myPreset',                  // Unique id value provided to recognize your view preset. Not required, but having it you can simply set new view preset by id: scheduler.viewPreset = 'myPreset'
 *     name : 'My view preset',            // A human-readable name provided to be used in GUI, e.i. preset picker, etc.
 *     base : 'hourAndDay',                // Extends 'hourAndDay' view preset provided by PresetManager. You can pick out any of PresetManager's view presets: PresetManager.records
 *
 *     timeResolution : {                  // Override time resolution
 *         unit      : 'minute',
 *         increment : 15                  // Make it increment every 15 mins
 *     },
 *
 *     headers : [                         // Override headers
 *         {
 *             unit       : 'day',
 *             dateFormat : 'DD.MM.YYYY'   // Use different date format for top header 01.10.2020
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'LT'
 *         }
 *     ]
 * });
 * ```
 *
 * See {@link Scheduler.preset.PresetManager PresetManager} for the list of base presets. You may add your own
 * presets to this global list:
 *
 * ```javascript
 * PresetManager.add(myViewPreset);     // Adds new preset to the global scope. All newly created scheduler instances will have it too.
 *
 * const scheduler = new Scheduler({
 *     viewPreset : 'myPreset'
 *     // other configs...
 * });
 * ```
 *
 * Or add them on an individual basis to Scheduler instances:
 *
 * ```javascript
 * const scheduler = new Scheduler({...});
 *
 * scheduler.presets.add(myViewPreset); // Adds new preset to the scheduler instance only. All newly created scheduler instances will **not** have it.
 *
 * scheduler.viewPreset = 'myPreset';
 * ```
 *
 * ## Defining custom header rows
 *
 * You can have any number of header rows by specifying {@link #field-headers}, see {@link Scheduler.preset.ViewPresetHeaderRow}
 * for the config object format and {@link Core.helper.DateHelper} for the supported date formats, or use
 * {@link Scheduler.preset.ViewPresetHeaderRow#config-renderer} to render custom contents into the row cells.
 *
 * ```javascript
 *  headers : [
 *      {
 *          unit       : 'month',
 *          dateFormat : 'MM.YYYY'
 *      },
 *      {
 *          unit       : 'week',
 *          renderer   : ({ startDate }) => `Week ${DateHelper.format(startDate, 'WW')}`
 *      }
 *  ]
 * ```
 *
 * {@inlineexample Scheduler/preset/CustomHeader.js}
 *
 * This live demo shows a custom ViewPreset with AM/PM time format:
 * @inlineexample Scheduler/preset/amPmPreset.js
 * @extends Core/data/Model
 */

class ViewPreset extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get fields() {
    return [
    /**
     * The name of the view preset
     * @field {String} name
     */
    {
      name: 'name',
      type: 'string'
    },
    /**
     * The height of the row in horizontal orientation
     * @field {Number} rowHeight
     * @default
     */
    {
      name: 'rowHeight',
      defaultValue: 24
    },
    /**
     * The width of the time tick column in horizontal orientation
     * @field {Number} tickWidth
     * @default
     */
    {
      name: 'tickWidth',
      defaultValue: 50
    },
    /**
     * The height of the time tick column in vertical orientation
     * @field {Number} tickHeight
     * @default
     */
    {
      name: 'tickHeight',
      defaultValue: 50
    },
    /**
     * Defines how dates will be formatted in tooltips etc
     * @field {String} displayDateFormat
     * @default
     */
    {
      name: 'displayDateFormat',
      defaultValue: 'HH:mm'
    },
    /**
     * The unit to shift when calling shiftNext/shiftPrevious to navigate in the chart.
     * Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
     * @field {String} shiftUnit
     * @default
     */
    {
      name: 'shiftUnit',
      defaultValue: 'hour'
    },
    /**
     * The amount to shift (in shiftUnits)
     * @field {Number} shiftIncrement
     * @default
     */
    {
      name: 'shiftIncrement',
      defaultValue: 1
    },
    /**
     * The amount of time to show by default in a view (in the unit defined by the middle header)
     * @field {Number} defaultSpan
     * @default
     */
    {
      name: 'defaultSpan',
      defaultValue: 12
    },
    /**
     * An object containing a unit identifier and an increment variable. This value means minimal task duration you can create using UI.
     * For example when you drag create a task or drag & drop a task, if increment is 5 and unit is 'minute'
     * that means that you can create a 5 min long task, or move it 5 min forward/backward. This config maps to
     * scheduler's {@link Scheduler.view.mixin.TimelineDateMapper#property-timeResolution} config.
     *
     * ```javascript
     * timeResolution : {
     *   unit      : 'minute',  //Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
     *   increment : 5
     * }
     * ```
     *
     * @field {Object} timeResolution
     */
    'timeResolution',
    /**
     * An array containing one or more {@link Scheduler.preset.ViewPresetHeaderRow} config objects, each of which defines a level of headers for the scheduler.
     * The `main` unit will be the last header's unit, but this can be changed using the {@link #field-mainHeaderLevel} field.
     * @field {Object[]} headers
     */
    'headers',
    /**
     * Index of the {@link #field-headers} array to define which header level is the `main` header.
     * Defaults to the bottom header.
     * @field {Number} mainHeaderLevel
     */
    'mainHeaderLevel',
    /**
     * Index of a header level in the {@link #field-headers} array for which column lines are drawn. See {@link Scheduler.feature.ColumnLines}.
     * Defaults to the bottom header.
     * @field {Number} columnLinesFor
     */
    'columnLinesFor'];
  }

  construct(data) {
    super.construct(...arguments);
    this.normalizeUnits();
  }

  generateId(owner) {
    const me = this,
          {
      headers
    } = me,
          parts = []; // If we were subclassed from a base, use that id as the basis of our.

    let result = Object.getPrototypeOf(me.data).id;

    if (!result) {
      for (let {
        length
      } = headers, i = length - 1; i >= 0; i--) {
        parts.push(i ? headers[i].unit : _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(headers[i].unit));
      } // Use upwards header units at so eg "monthAndYear"


      result = parts.join('And');
    } // If duplicate, make it "hourAndDay-50by80"


    if (owner.includes(result)) {
      result += `-${me.tickWidth}by${me.tickHeight || me.tickWidth}`; // If still duplicate use increment

      if (owner.includes(result)) {
        result += `-${me.bottomHeader.increment}`; // And if STILL duplicate, make it unique with a suffix

        if (owner.includes(result)) {
          result = _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].generateId(`${result}-`);
        }
      }
    }

    return result;
  }

  normalizeUnits() {
    const me = this,
          {
      timeResolution,
      headers
    } = me; // Make sure date "unit" constant specified in the preset are resolved

    for (let i = 0, {
      length
    } = headers; i < length; i++) {
      const header = headers[i];
      header.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(header.unit);

      if (header.splitUnit) {
        header.splitUnit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(header.splitUnit);
      }

      if (!('increment' in header)) {
        headers[i] = Object.assign({
          increment: 1
        }, header);
      }
    }

    if (timeResolution) {
      timeResolution.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(timeResolution.unit);
    }

    if (me.shiftUnit) {
      me.shiftUnit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(me.shiftUnit);
    }
  } // Process legacy columnLines config into a headers array.


  static normalizeHeaderConfig(data) {
    const {
      headerConfig,
      columnLinesFor,
      mainHeaderLevel
    } = data,
          headers = data.headers = [];

    if (headerConfig.top) {
      if (columnLinesFor === 'top') {
        data.columnLinesFor = 0;
      }

      if (mainHeaderLevel === 'top') {
        data.mainHeaderLevel = 0;
      }

      headers[0] = headerConfig.top;
    }

    if (headerConfig.middle) {
      if (columnLinesFor === 'middle') {
        data.columnLinesFor = headers.length;
      }

      if (mainHeaderLevel === 'middle') {
        data.mainHeaderLevel = headers.length;
      }

      headers.push(headerConfig.middle);
    } else {
      throw new Error('ViewPreset.headerConfig must be configured with a middle');
    }

    if (headerConfig.bottom) {
      // Main level is middle when using headerConfig object.
      data.mainHeaderLevel = headers.length - 1; // There *must* be a middle above this bottom header
      // so that is the columnLines one by default.

      if (columnLinesFor == null) {
        data.columnLinesFor = headers.length - 1;
      } else if (columnLinesFor === 'bottom') {
        data.columnLinesFor = headers.length;
      } // There *must* be a middle above this bottom header
      // so that is the main one by default.


      if (mainHeaderLevel == null) {
        data.mainHeaderLevel = headers.length - 1;
      }

      if (mainHeaderLevel === 'bottom') {
        data.mainHeaderLevel = headers.length;
      }

      headers.push(headerConfig.bottom);
    }
  } // These are read-only once configured.


  set() {}

  inSet() {}

  get columnLinesFor() {
    return 'columnLinesFor' in this.data ? this.data.columnLinesFor : this.headers.length - 1;
  }

  get tickSize() {
    return this._tickSize || this.tickWidth;
  }

  get tickWidth() {
    return 'tickWidth' in this.data ? this.data.tickWidth : 50;
  }

  get tickHeight() {
    return 'tickHeight' in this.data ? this.data.tickHeight : 50;
  }

  get headerConfig() {
    // Configured in the legacy manner, just return the configured value.
    if (this.data.headerConfig) {
      return this.data.headerConfig;
    } // Rebuild the object based upon the configured headers array.


    const result = {},
          {
      headers
    } = this,
          {
      length
    } = headers;

    switch (length) {
      case 1:
        result.middle = headers[0];
        break;

      case 2:
        if (this.mainHeaderLevel === 0) {
          result.middle = headers[0];
          result.bottom = headers[1];
        } else {
          result.top = headers[0];
          result.middle = headers[1];
        }

        break;

      case 3:
        result.top = headers[0];
        result.middle = headers[1];
        result.bottom = headers[2];
        break;

      default:
        throw new Error('headerConfig object not supported for >3 header levels');
    }

    return result;
  }

  set mainHeaderLevel(mainHeaderLevel) {
    this.data.mainHeaderLevel = mainHeaderLevel;
  }

  get mainHeaderLevel() {
    if ('mainHeaderLevel' in this.data) {
      return this.data.mainHeaderLevel;
    } // 3 headers, then it's the middle


    if (this.data.headers.length === 3) {
      return 1;
    } // Assume it goes top, middle.
    // If it's middle, top, use mainHeaderLevel : 0


    return this.headers.length - 1;
  }

  get mainHeader() {
    return this.headers[this.mainHeaderLevel];
  }

  get bottomHeader() {
    return this.headers[this.headers.length - 1];
  }

  get leafUnit() {
    return this.bottomHeader.unit;
  }

  get leafIncrement() {
    return this.bottomHeader.increment;
  }

  get mainUnit() {
    return this.mainHeader;
  }

  get msPerPixel() {
    const {
      bottomHeader
    } = this;
    return Math.round(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].asMilliseconds(bottomHeader.increment || 1, bottomHeader.unit) / this.tickWidth);
  }

  get isValid() {
    const me = this;
    let valid = true; // Make sure all date "unit" constants are valid

    for (const header of me.headers) {
      valid = valid && Boolean(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(header.unit));
    }

    if (me.timeResolution) {
      valid = valid && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(me.timeResolution.unit);
    }

    if (me.shiftUnit) {
      valid = valid && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalizeUnit(me.shiftUnit);
    }

    return valid;
  }

}
ViewPreset._$name = 'ViewPreset';

/***/ }),

/***/ "./lib/Scheduler/tooltip/ClockTemplate.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/tooltip/ClockTemplate.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ClockTemplate; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/tooltip/ClockTemplate
 */

/**
 * A template showing a clock, it consumes an object containing a date and a text
 * @private
 */

class ClockTemplate extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      minuteHeight: 8,
      minuteTop: 2,
      hourHeight: 8,
      hourTop: 2,
      handLeft: 10,
      div: document.createElement('div'),
      scheduler: null,

      // may be passed to the constructor if needed
      // `b-sch-clock-day` for calendar icon
      // `b-sch-clock-hour` for clock icon
      template(data) {
        return `<div class="b-sch-clockwrap b-sch-clock-${data.mode || this.mode} ${data.cls || ''}">
                    <div class="b-sch-clock">
                        <div class="b-sch-hour-indicator">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(data.date, 'MMM')}</div>
                        <div class="b-sch-minute-indicator">${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(data.date, 'D')}</div>
                        <div class="b-sch-clock-dot"></div>
                    </div>
                    <span class="b-sch-clock-text">${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(data.text)}</span>
                </div>`;
      }

    };
  }

  generateContent(data) {
    const me = this,
          date = data.date,
          html = me.template(data),
          div = me.div;
    div.innerHTML = html;
    me.updateDateIndicator(div, date);
    return div.innerHTML;
  }

  updateDateIndicator(el, date) {
    const hourIndicatorEl = el === null || el === void 0 ? void 0 : el.querySelector('.b-sch-hour-indicator'),
          minuteIndicatorEl = el === null || el === void 0 ? void 0 : el.querySelector('.b-sch-minute-indicator');

    if (date && hourIndicatorEl && minuteIndicatorEl) {
      if (this.mode === 'hour') {
        hourIndicatorEl.style.transform = `rotate(${date.getHours() % 12 * 30}deg)`;
        minuteIndicatorEl.style.transform = `rotate(${date.getMinutes() * 6}deg)`;
      } else {
        hourIndicatorEl.style.transform = 'none';
        minuteIndicatorEl.style.transform = 'none';
      }
    }
  }

  set mode(mode) {
    this._mode = mode;
  } // `day` mode for calendar icon
  // `hour` mode for clock icon


  get mode() {
    if (this._mode) {
      return this._mode;
    }

    const unitLessThanDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].compareUnits(this.scheduler.timeAxisViewModel.timeResolution.unit, 'day') < 0,
          formatContainsHourInfo = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].formatContainsHourInfo(this.scheduler.displayDateFormat);
    return unitLessThanDay && formatContainsHourInfo ? 'hour' : 'day';
  }

  set template(template) {
    this._template = template;
  }
  /**
   * Get the clock template, which accepts an object of format { date, text }
   * @property {function(*): string}
   */


  get template() {
    return this._template;
  }

}
ClockTemplate._$name = 'ClockTemplate';

/***/ }),

/***/ "./lib/Scheduler/util/RectangularPathFinder.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/util/RectangularPathFinder.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RectangularPathFinder; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/WalkHelper.js */ "./lib/Core/helper/WalkHelper.js");
var productName = 'gantt';

 // Start adjusting if there is system scaling > 130%

const THRESHOLD = Math.min(1 / window.devicePixelRatio, 0.75);

const REDUCER = (result, current) => {
  if (result.length === 0 || current - result[result.length - 1] >= THRESHOLD) {
    result.push(current);
  }

  return result;
};
/**
 * @module Scheduler/util/RectangularPathFinder
 */

/**
 * Class which finds rectangular path, i.e. path with 90 degrees turns, between two boxes.
 * @private
 */


class RectangularPathFinder extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Default start connection side: 'left', 'right', 'top', 'bottom'
       * @config {String|Boolean}
       * @default
       */
      startSide: 'right',

      /**
       * Default start arrow size in pixels
       * @config {Number}
       * @default
       */
      startArrowSize: 0,

      /**
       * Default start arrow staff size in pixels
       * @config {Number}
       * @default
       */
      startArrowMargin: 12,

      /**
       * Default starting connection point shift from box's arrow pointing side middle point
       * @config {Number}
       * @default
       */
      startShift: 0,

      /**
       * Default end arrow pointing direction, possible values are: 'left', 'right', 'top', 'bottom'
       * @config {String|Boolean}
       * @default
       */
      endSide: 'left',

      /**
       * Default end arrow size in pixels
       * @config {Number}
       * @default
       */
      endArrowSize: 0,

      /**
       * Default end arrow staff size in pixels
       * @config {Number}
       * @default
       */
      endArrowMargin: 12,

      /**
       * Default ending connection point shift from box's arrow pointing side middle point
       * @config {Number}
       * @default
       */
      endShift: 0,

      /**
       * Start / End box vertical margin, the amount of pixels from top and bottom line of a box where drawing
       * is prohibited
       * @config {Number}
       * @default
       */
      verticalMargin: 2,

      /**
       * Start / End box horizontal margin, the amount of pixels from left and right line of a box where drawing
       * @config {Number}
       * @default
       */
      horizontalMargin: 5,

      /**
       * Other rectangular areas (obstacles) to search path through
       * @config {Object[]}
       * @default
       */
      otherBoxes: null
    };
  }
  /**
   * Returns list of horizontal and vertical segments connecting two boxes
   * <pre>
   *    |    | |  |    |       |
   *  --+----+----+----*-------*---
   *  --+=>Start  +----*-------*--
   *  --+----+----+----*-------*--
   *    |    | |  |    |       |
   *    |    | |  |    |       |
   *  --*----*-+-------+-------+--
   *  --*----*-+         End <=+--
   *  --*----*-+-------+-------+--
   *    |    | |  |    |       |
   * </pre>
   * Path goes by lines (-=) and turns at intersections (+), boxes depicted are adjusted by horizontal/vertical
   * margin and arrow margin, original boxes are smaller (path can't go at original box borders). Algorithm finds
   * the shortest path with minimum amount of turns. In short it's mix of "Lee" and "Dijkstra pathfinding"
   * with turns amount taken into account for distance calculation.
   *
   * The algorithm is not very performant though, it's O(N^2), where N is amount of
   * points in the grid, but since the maximum amount of points in the grid might be up to 34 (not 36 since
   * two box middle points are not permitted) that might be ok for now.
   *
   * @param {Object} lineDef An object containing any of the class configuration option overrides as well
   *                         as `startBox`, `endBox`, `startHorizontalMargin`, `startVerticalMargin`,
   *                         `endHorizontalMargin`, `endVerticalMargin` properties
   * @param {Object} lineDef.startBox An object containing `start`, `end`, `top`, `bottom` properties
   * @param {Object} lineDef.endBox   An object containing `start`, `end`, `top`, `bottom` properties
   * @param {Number} lineDef.startHorizontalMargin Horizontal margin override for start box
   * @param {Number} lineDef.startVerticalMargin   Vertical margin override for start box
   * @param {Number} lineDef.endHorizontalMargin   Horizontal margin override for end box
   * @param {Number} lineDef.endVerticalMargin     Vertical margin override for end box
   *
   *
   * @return {Object[]|Boolean} Array of line segments or false if path cannot be found
   * @return {Number} return.x1
   * @return {Number} return.y1
   * @return {Number} return.x2
   * @return {Number} return.y2
   */
  //
  //@ignore
  //@privateparam {Function[]|Function} noPathFallbackFn
  //     A function or array of functions which will be tried in case a path can't be found
  //     Each function will be given a line definition it might try to adjust somehow and return.
  //     The new line definition returned will be tried to find a path.
  //     If a function returns false, then next function will be called if any.
  //


  findPath(lineDef, noPathFallbackFn) {
    const me = this,
          originalLineDef = lineDef;
    let lineDefFull, startBox, endBox, startShift, endShift, startSide, endSide, startArrowSize, endArrowSize, startArrowMargin, endArrowMargin, horizontalMargin, verticalMargin, startHorizontalMargin, startVerticalMargin, endHorizontalMargin, endVerticalMargin, otherHorizontalMargin, otherVerticalMargin, otherBoxes, connStartPoint, connEndPoint, pathStartPoint, pathEndPoint, gridStartPoint, gridEndPoint, startGridBox, endGridBox, grid, path, tryNum;

    if (noPathFallbackFn && !Array.isArray(noPathFallbackFn)) {
      noPathFallbackFn = [noPathFallbackFn];
    }

    for (tryNum = 0; lineDef && !path;) {
      lineDefFull = Object.assign(me.config, lineDef);
      startBox = lineDefFull.startBox;
      endBox = lineDefFull.endBox;
      startShift = lineDefFull.startShift;
      endShift = lineDefFull.endShift;
      startSide = lineDefFull.startSide;
      endSide = lineDefFull.endSide;
      startArrowSize = lineDefFull.startArrowSize;
      endArrowSize = lineDefFull.endArrowSize;
      startArrowMargin = lineDefFull.startArrowMargin;
      endArrowMargin = lineDefFull.endArrowMargin;
      horizontalMargin = lineDefFull.horizontalMargin;
      verticalMargin = lineDefFull.verticalMargin;
      startHorizontalMargin = lineDefFull.hasOwnProperty('startHorizontalMargin') ? lineDefFull.startHorizontalMargin : horizontalMargin;
      startVerticalMargin = lineDefFull.hasOwnProperty('startVerticalMargin') ? lineDefFull.startVerticalMargin : verticalMargin;
      endHorizontalMargin = lineDefFull.hasOwnProperty('endHorizontalMargin') ? lineDefFull.endHorizontalMargin : horizontalMargin;
      endVerticalMargin = lineDefFull.hasOwnProperty('endVerticalMargin') ? lineDefFull.endVerticalMargin : verticalMargin;
      otherHorizontalMargin = lineDefFull.hasOwnProperty('otherHorizontalMargin') ? lineDefFull.otherHorizontalMargin : horizontalMargin;
      otherVerticalMargin = lineDefFull.hasOwnProperty('otherVerticalMargin') ? lineDefFull.otherVerticalMargin : verticalMargin;
      otherBoxes = lineDefFull.otherBoxes;
      startSide = me.normalizeSide(startSide);
      endSide = me.normalizeSide(endSide);
      connStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startBox, startSide, startShift);
      connEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endBox, endSide, endShift);
      startGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(startBox, startSide, startArrowSize, startArrowMargin, startHorizontalMargin, startVerticalMargin);
      endGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(endBox, endSide, endArrowSize, endArrowMargin, endHorizontalMargin, endVerticalMargin);

      if (me.shouldLookForPath(startBox, endBox, startGridBox, endGridBox)) {
        var _otherBoxes;

        otherBoxes = (_otherBoxes = otherBoxes) === null || _otherBoxes === void 0 ? void 0 : _otherBoxes.map(box => me.calcGridBaseBoxFromBoxAndDrawParams(box, false, 0, 0, otherHorizontalMargin, otherVerticalMargin));
        pathStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startGridBox, startSide, startShift);
        pathEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endGridBox, endSide, endShift);
        grid = me.buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherBoxes);
        gridStartPoint = me.convertDecartPointToGridPoint(grid, pathStartPoint);
        gridEndPoint = me.convertDecartPointToGridPoint(grid, pathEndPoint);
        path = me.findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide);
      } // Loop if
      // - path is still not found
      // - have no next line definition (which should be obtained from call to one of the functions from noPathFallbackFn array
      // - have noPathFallBackFn array
      // - current try number is less then noPathFallBackFn array length


      for (lineDef = false; !path && !lineDef && noPathFallbackFn && tryNum < noPathFallbackFn.length; tryNum++) {
        lineDef = noPathFallbackFn[tryNum](lineDefFull, originalLineDef);
      }
    }

    if (path) {
      path = me.prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide);
      path = me.appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide);
      path = me.optimizePath(path);
    }

    return path;
  } // Compares boxes relative position in the given direction.
  //  0 - 1 is to the left/top of 2
  //  1 - 1 overlaps with left/top edge of 2
  //  2 - 1 is inside 2
  // -2 - 2 is inside 1
  //  3 - 1 overlaps with right/bottom edge of 2
  //  4 - 1 is to the right/bottom of 2


  static calculateRelativePosition(box1, box2, vertical = false) {
    const startProp = vertical ? 'top' : 'start',
          endProp = vertical ? 'bottom' : 'end';
    let result;

    if (box1[endProp] < box2[startProp]) {
      result = 0;
    } else if (box1[endProp] <= box2[endProp] && box1[endProp] >= box2[startProp] && box1[startProp] < box2[startProp]) {
      result = 1;
    } else if (box1[startProp] >= box2[startProp] && box1[endProp] <= box2[endProp]) {
      result = 2;
    } else if (box1[startProp] < box2[startProp] && box1[endProp] > box2[endProp]) {
      result = -2;
    } else if (box1[startProp] <= box2[endProp] && box1[endProp] > box2[endProp]) {
      result = 3;
    } else {
      result = 4;
    }

    return result;
  } // Checks if relative position of the original and marginized boxes is the same


  static boxOverlapChanged(startBox, endBox, gridStartBox, gridEndBox, vertical = false) {
    const calculateOverlap = RectangularPathFinder.calculateRelativePosition,
          originalOverlap = calculateOverlap(startBox, endBox, vertical),
          finalOverlap = calculateOverlap(gridStartBox, gridEndBox, vertical);
    return originalOverlap !== finalOverlap;
  }

  shouldLookForPath(startBox, endBox, gridStartBox, gridEndBox) {
    let result = true; // Only calculate overlap if boxes are narrow in horizontal direction

    if ( // We refer to the original arrow margins because during lookup those might be nullified and we need some
    // criteria to tell if events are too narrow
    (startBox.end - startBox.start <= this.startArrowMargin || endBox.end - endBox.start <= this.endArrowMargin) && Math.abs(RectangularPathFinder.calculateRelativePosition(startBox, endBox, true)) === 2) {
      result = !RectangularPathFinder.boxOverlapChanged(startBox, endBox, gridStartBox, gridEndBox);
    }

    return result;
  }

  getConnectionCoordinatesFromBoxSideShift(box, side, shift) {
    let coords;

    switch (side) {
      case 'left':
        coords = {
          x: box.start,
          y: (box.top + box.bottom) / 2 + shift
        };
        break;

      case 'right':
        coords = {
          x: box.end,
          y: (box.top + box.bottom) / 2 + shift
        };
        break;

      case 'top':
        coords = {
          x: (box.start + box.end) / 2 + shift,
          y: box.top
        };
        break;

      case 'bottom':
        coords = {
          x: (box.start + box.end) / 2 + shift,
          y: box.bottom
        };
        break;
    }

    return coords;
  }

  calcGridBaseBoxFromBoxAndDrawParams(box, side, arrowSize, arrowMargin, horizontalMargin, verticalMargin) {
    let gridBox;

    switch (side) {
      case 'left':
        gridBox = {
          start: box.start - Math.max(arrowSize + arrowMargin, horizontalMargin),
          end: box.end + horizontalMargin,
          top: box.top - verticalMargin,
          bottom: box.bottom + verticalMargin
        };
        break;

      case 'right':
        gridBox = {
          start: box.start - horizontalMargin,
          end: box.end + Math.max(arrowSize + arrowMargin, horizontalMargin),
          top: box.top - verticalMargin,
          bottom: box.bottom + verticalMargin
        };
        break;

      case 'top':
        gridBox = {
          start: box.start - horizontalMargin,
          end: box.end + horizontalMargin,
          top: box.top - Math.max(arrowSize + arrowMargin, verticalMargin),
          bottom: box.bottom + verticalMargin
        };
        break;

      case 'bottom':
        gridBox = {
          start: box.start - horizontalMargin,
          end: box.end + horizontalMargin,
          top: box.top - verticalMargin,
          bottom: box.bottom + Math.max(arrowSize + arrowMargin, verticalMargin)
        };
        break;

      default:
        gridBox = {
          start: box.start - horizontalMargin,
          end: box.end + horizontalMargin,
          top: box.top - verticalMargin,
          bottom: box.bottom + verticalMargin
        };
    }

    return gridBox;
  }

  buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherGridBoxes) {
    let xs, ys, y, x, ix, iy, xslen, yslen, ib, blen, box, permitted, point;
    const points = {},
          linearPoints = [];
    xs = [startGridBox.start, startSide === 'left' || startSide === 'right' ? (startGridBox.start + startGridBox.end) / 2 : pathStartPoint.x, startGridBox.end, endGridBox.start, endSide === 'left' || endSide === 'right' ? (endGridBox.start + endGridBox.end) / 2 : pathEndPoint.x, endGridBox.end];
    ys = [startGridBox.top, startSide === 'top' || startSide === 'bottom' ? (startGridBox.top + startGridBox.bottom) / 2 : pathStartPoint.y, startGridBox.bottom, endGridBox.top, endSide === 'top' || endSide === 'bottom' ? (endGridBox.top + endGridBox.bottom) / 2 : pathEndPoint.y, endGridBox.bottom];

    if (otherGridBoxes) {
      otherGridBoxes.forEach(box => {
        xs.push(box.start, (box.start + box.end) / 2, box.end);
        ys.push(box.top, (box.top + box.bottom) / 2, box.bottom);
      });
    }

    xs = [...new Set(xs.sort((a, b) => a - b))];
    ys = [...new Set(ys.sort((a, b) => a - b))]; // Iterate over points and merge those which are too close to each other (e.g. if difference is less than one
    // over devicePixelRatio we won't even see this effect in GUI)
    // https://github.com/bryntum/support/issues/3923

    xs = xs.reduce(REDUCER, []);
    ys = ys.reduce(REDUCER, []); // TODO: fastest way to make unique, Set is slower
    // for ( let i = 0, I = array.length; i < I; i++ ) {
    //     if ( ~array.indexOf( array[ i ], i + 1 ) ) {
    //         array.splice( i, 1 );
    //         i--;
    //         I--;
    //     }
    // }

    for (iy = 0, yslen = ys.length; iy < yslen; ++iy) {
      points[iy] = points[iy] || {};
      y = ys[iy];

      for (ix = 0, xslen = xs.length; ix < xslen; ++ix) {
        x = xs[ix];
        permitted = (x <= startGridBox.start || x >= startGridBox.end || y <= startGridBox.top || y >= startGridBox.bottom) && (x <= endGridBox.start || x >= endGridBox.end || y <= endGridBox.top || y >= endGridBox.bottom);

        if (otherGridBoxes) {
          for (ib = 0, blen = otherGridBoxes.length; permitted && ib < blen; ++ib) {
            box = otherGridBoxes[ib];
            permitted = x <= box.start || x >= box.end || y <= box.top || y >= box.bottom || // Allow point if it is a path start/end even if point is inside any box
            x === pathStartPoint.x && y === pathStartPoint.y || x === pathEndPoint.x && y === pathEndPoint.y;
          }
        }

        point = {
          distance: Math.pow(2, 53) - 1,
          // Number.MAX_SAFE_INTEGER (not supported in Opera/IE)
          permitted: permitted,
          x: x,
          y: y,
          ix: ix,
          iy: iy
        };
        points[iy][ix] = point;
        linearPoints.push(point);
      }
    }

    return {
      width: xs.length,
      height: ys.length,
      xs: xs,
      ys: ys,
      points: points,
      linearPoints: linearPoints
    };
  }

  convertDecartPointToGridPoint(grid, point) {
    let x = grid.xs.indexOf(point.x),
        y = grid.ys.indexOf(point.y); // Exact value might be filtered due to subpixel proximity, need to look for closest coordinate.
    // Even though grid is not that big (about ~11 points per dimension) we prefer to try fast `indexOf` first

    if (x === -1) {
      x = grid.xs.findIndex(v => Math.abs(point.x - v) < THRESHOLD);
    }

    if (y === -1) {
      y = grid.ys.findIndex(v => Math.abs(point.y - v) < THRESHOLD);
    }

    return grid.points[y][x];
  }

  findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide) {
    const me = this;
    let path = false;

    if (gridStartPoint.permitted && gridEndPoint.permitted) {
      grid = me.waveForward(grid, gridStartPoint, 0);
      path = me.collectPath(grid, gridEndPoint, endSide);
    }

    return path;
  } // Returns neighbors from Von Neiman ambit (see Lee pathfinding algorithm description)


  getGridPointNeighbors(grid, gridPoint, predicateFn) {
    const ix = gridPoint.ix,
          iy = gridPoint.iy,
          result = [];
    let neighbor; // NOTE:
    // It's important to push bottom neighbors first since this method is used
    // in collectPath(), which recursively collects path from end to start node
    // and if bottom neighbors are pushed first in result array then collectPath()
    // will produce a line which is more suitable (pleasant looking) for our purposes.

    if (iy < grid.height - 1) {
      neighbor = grid.points[iy + 1][ix];
      (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
    }

    if (iy > 0) {
      neighbor = grid.points[iy - 1][ix];
      (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
    }

    if (ix < grid.width - 1) {
      neighbor = grid.points[iy][ix + 1];
      (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
    }

    if (ix > 0) {
      neighbor = grid.points[iy][ix - 1];
      (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
    }

    return result;
  }

  waveForward(grid, gridStartPoint, distance) {
    const me = this; // I use the WalkHelper here because a point on a grid and it's neighbors might be considered as a hierarchy.
    // The point is the parent node, and it's neighbors are the children nodes. Thus the grid here is hierarchical
    // data structure which can be walked. WalkHelper walks non-recursively which is exactly what I need as well.

    _Core_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].preWalkUnordered( // Walk starting point - a node is a grid point and it's distance from the starting point
    [gridStartPoint, distance], // Children query function
    // NOTE: It's important to fix neighbor distance first, before waving to a neighbor, otherwise waving might
    //       get through a neighbor point setting it's distance to a value more then (distance + 1) whereas we,
    //       at the children querying moment in time, already know that the possibly optimal distance is (distance + 1)
    ([point, distance]) => me.getGridPointNeighbors(grid, point, neighborPoint => neighborPoint.permitted && neighborPoint.distance > distance + 1).map(neighborPoint => [neighborPoint, distance + 1] // Neighbor distance fixation
    ), // Walk step iterator function
    ([point, distance]) => point.distance = distance // Neighbor distance applying
    );
    return grid;
  }

  collectPath(grid, gridEndPoint, endSide) {
    const me = this,
          path = [];
    let pathFound = true,
        neighbors,
        lowestDistanceNeighbor,
        xDiff,
        yDiff;

    while (pathFound && gridEndPoint.distance) {
      neighbors = me.getGridPointNeighbors(grid, gridEndPoint, point => point.permitted && point.distance === gridEndPoint.distance - 1);
      pathFound = neighbors.length > 0;

      if (pathFound) {
        // Prefer turnless neighbors first
        neighbors = neighbors.sort((a, b) => {
          let xDiff, yDiff;
          xDiff = a.ix - gridEndPoint.ix;
          yDiff = a.iy - gridEndPoint.iy;
          const resultA = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
          xDiff = b.ix - gridEndPoint.ix;
          yDiff = b.iy - gridEndPoint.iy;
          const resultB = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
          if (resultA > resultB) return 1;
          if (resultA < resultB) return -1; // apply additional sorting to be sure to pick bottom path in IE

          if (resultA === resultB) return a.y > b.y ? -1 : 1;
        });
        lowestDistanceNeighbor = neighbors[0];
        path.push({
          x1: lowestDistanceNeighbor.x,
          y1: lowestDistanceNeighbor.y,
          x2: gridEndPoint.x,
          y2: gridEndPoint.y
        }); // Detecting new side, either xDiff or yDiff must be 0 (but not both)

        xDiff = lowestDistanceNeighbor.ix - gridEndPoint.ix;
        yDiff = lowestDistanceNeighbor.iy - gridEndPoint.iy;

        switch (true) {
          case !yDiff && xDiff > 0:
            endSide = 'left';
            break;

          case !yDiff && xDiff < 0:
            endSide = 'right';
            break;

          case !xDiff && yDiff > 0:
            endSide = 'top';
            break;

          case !xDiff && yDiff < 0:
            endSide = 'bottom';
            break;
        }

        gridEndPoint = lowestDistanceNeighbor;
      }
    }

    return pathFound && path.reverse() || false;
  }

  prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide) {
    let prependSegment, firstSegment;

    if (path.length > 0) {
      firstSegment = path[0];
      prependSegment = {
        x2: firstSegment.x1,
        y2: firstSegment.y1
      };

      switch (startSide) {
        case 'left':
          prependSegment.x1 = connStartPoint.x - startArrowSize;
          prependSegment.y1 = firstSegment.y1;
          break;

        case 'right':
          prependSegment.x1 = connStartPoint.x + startArrowSize;
          prependSegment.y1 = firstSegment.y1;
          break;

        case 'top':
          prependSegment.x1 = firstSegment.x1;
          prependSegment.y1 = connStartPoint.y - startArrowSize;
          break;

        case 'bottom':
          prependSegment.x1 = firstSegment.x1;
          prependSegment.y1 = connStartPoint.y + startArrowSize;
          break;
      }

      path.unshift(prependSegment);
    }

    return path;
  }

  appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide) {
    let appendSegment, lastSegment;

    if (path.length > 0) {
      lastSegment = path[path.length - 1];
      appendSegment = {
        x1: lastSegment.x2,
        y1: lastSegment.y2
      };

      switch (endSide) {
        case 'left':
          appendSegment.x2 = connEndPoint.x - endArrowSize;
          appendSegment.y2 = lastSegment.y2;
          break;

        case 'right':
          appendSegment.x2 = connEndPoint.x + endArrowSize;
          appendSegment.y2 = lastSegment.y2;
          break;

        case 'top':
          appendSegment.x2 = lastSegment.x2;
          appendSegment.y2 = connEndPoint.y - endArrowSize;
          break;

        case 'bottom':
          appendSegment.x2 = lastSegment.x2;
          appendSegment.y2 = connEndPoint.y + endArrowSize;
          break;
      }

      path.push(appendSegment);
    }

    return path;
  }

  optimizePath(path) {
    const optPath = [];
    let prevSegment, curSegment;

    if (path.length > 0) {
      prevSegment = path.shift();
      optPath.push(prevSegment);

      while (path.length > 0) {
        curSegment = path.shift(); // both segments are equal

        if (prevSegment.x1 === curSegment.x1 && prevSegment.y1 === curSegment.y1 && prevSegment.x2 === curSegment.x2 && prevSegment.y2 === curSegment.y2) {
          prevSegment = curSegment;
        } // both segments are horizontal
        else if (prevSegment.y1 - prevSegment.y2 === 0 && curSegment.y1 - curSegment.y2 === 0) {
          prevSegment.x2 = curSegment.x2;
        } // both segments are vertical
        else if (prevSegment.x1 - prevSegment.x2 === 0 && curSegment.x1 - curSegment.x2 === 0) {
          prevSegment.y2 = curSegment.y2;
        } // segments has different orientation (path turn)
        else {
          optPath.push(curSegment);
          prevSegment = curSegment;
        }
      }
    }

    return optPath;
  }

  normalizeSide(side) {
    return RectangularPathFinder.sideToSide[side] || side;
  }

  static get sideToSide() {
    return {
      l: 'left',
      r: 'right',
      t: 'top',
      b: 'bottom'
    };
  }

}
RectangularPathFinder._$name = 'RectangularPathFinder';

/***/ }),

/***/ "./lib/Scheduler/util/ScheduleTableExporter.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/util/ScheduleTableExporter.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleTableExporter; });
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony import */ var _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
var productName = 'gantt';



/**
 * @module Scheduler/util/ScheduleTableExporter
 */

/**
 * This class transforms scheduler component into two arrays: rows and columns. Columns array contains objects with
 * meta information about column: field name, column name, width and type of the rendered value, rows array contains
 * arrays of cell values.
 *
 * ```javascript
 * const exporter = new ScheduleTableExporter({ target : scheduler });
 * exporter.export()
 *
 * // Output
 * {
 *     columns : [
 *         { field : 'name',      value : 'First name', type : 'string',  width : 100 },
 *         { field : 'name',      value : 'Task',       type : 'string',  width : 100, eventColumn : true },
 *         { field : 'startDate', value : 'Starts',     type : 'date',    width : 100, eventColumn : true },
 *         { field : 'endDate',   value : 'Ends',       type : 'date',    width : 100, eventColumn : true }
 *     ],
 *     rows : [
 *         ['Michael', 'Hand out dundies',      Date, Date],
 *         ['Michael', 'Buy condo',             Date, Date],
 *         ['Jim',     'Close sale to library', Date, Date]
 *     ]
 * }
 * ```
 *
 * ## How data is exported
 *
 * Data is exported as in the base class with minor addition: every event is exported on a separate row, like
 * demonstrated above.
 *
 * In case there are unassigned events, by default they will be exported as well
 *
 * ```javascript
 * // output
 * {
 *     rows : [
 *         ['Michael', 'Hand out dundies',      Date, Date],
 *         ['Michael', 'Buy condo',             Date, Date],
 *         ['Jim',     'Close sale to library', Date, Date],
 *         ['',        'No resource assigned'],
 *         ['',        'Halloween prep',        Date, Date],
 *         ['',        'New year prep',         Date, Date]
 *     ]
 * }
 * ```
 *
 * @extends Grid/util/TableExporter
 * @mixes Core/localization/Localizable
 */

class ScheduleTableExporter extends Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__["default"])(_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * Set to `false` to not include unassigned events in the export. `true` by default.
       * @config {Boolean} includeUnassigned
       * @default
       */
      includeUnassigned: true,

      /**
       * An array of Event columns configuration used to specify columns width, headers name, and column fields to get the data from.
       * 'field' config is required. If 'text' is missing, the 'field' config will be used instead.
       *
       * For example:
       * ```javascript
       * eventColumns    : [
       *     { text : 'Task', field : 'name' },
       *     { text : 'Starts', field : 'startDate', width : 140 },
       *     { text : 'Ends', field : 'endDate', width : 140 }
       * ]
       * ```
       *
       * @config {String[]|Object[]} eventColumns
       * @default
       */
      eventColumns: [{
        text: 'Task',
        field: 'name'
      }, {
        text: 'Starts',
        field: 'startDate',
        width: 140
      }, {
        text: 'Ends',
        field: 'endDate',
        width: 140
      }],

      /**
       * Function to sort events for each resource. By default events are sorted in the order of appending to the
       * store.
       * For example:
       * ```javascript
       * // Sorting by start date
       * eventSortFn : (a, b) => a.startDate - b.startDate
       * ```
       * @config {Function}
       * @internal
       */
      eventSortFn: null
    };
  }

  construct(config = {}, ...args) {
    super.construct(config, ...args);

    if (!this.eventSortFn) {
      this.eventSortFn = (a, b) => a.internalId - b.internalId;
    }
  }

  normalizeColumns(config) {
    super.normalizeColumns(config);
    config.eventColumns = config.eventColumns.map(col => {
      if (typeof col === 'string') {
        return {
          field: col
        };
      } else {
        return col;
      }
    });
  }

  generateExportData(config) {
    const me = this,
          isScheduler = this.target instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_2__["default"],
          resourceColumns = me.generateColumns(config),
          eventColumns = isScheduler ? me.generateEventColumns(config) : [],
          columns = resourceColumns.concat(eventColumns),
          rows = me.generateRows(config);
    return {
      columns,
      rows
    };
  }

  generateEventColumns(config) {
    return config.eventColumns.map(column => this.processEventColumn(column, config));
  }

  processEventColumn(column, config) {
    const {
      width,
      minWidth
    } = column,
          {
      defaultColumnWidth
    } = config;
    return {
      field: column.field,
      value: column.text,
      width: Math.max(width || defaultColumnWidth, minWidth || defaultColumnWidth),
      eventColumn: true,
      type: this.getColumnType(column, this.target.eventStore)
    };
  }

  generateRows(config) {
    const me = this,
          {
      target
    } = me;
    let result;

    if (!(target instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
      result = super.generateRows(config);
    } else {
      result = []; // forEach skips group records, summary records etc

      target.resourceStore.map(resourceRecord => {
        // Get all events for resource (including assignment store)
        const events = resourceRecord.events || []; // Events order is not guaranteed, sort by internalId, that is guaranteed to grow with every new record

        events.sort(me.eventSortFn); // Set dummy event to have resource info printed without events

        if (!events.length) {
          events.push('');
        }

        events.forEach(eventRecord => result.push(me.getRowData(config, resourceRecord, eventRecord)));
      });

      if (config.includeUnassigned && config.eventColumns.length) {
        const notAssignedEvents = target.eventStore.query(eventRecord => !eventRecord.resources.length);

        if (notAssignedEvents.length) {
          // Use offset to match first event column
          const cells = new Array(config.columns.length).fill('');
          cells.push(me.L('L{ExcelExporter.No resource assigned}'));
          result.push(cells); // Set dummy resource to have event info printed without resource

          notAssignedEvents.forEach(eventRecord => result.push(me.getRowData(config, null, eventRecord)));
        }
      } // filter out empty rows


      result = result.filter(cells => cells.length);
    }

    return result;
  }

  getRowData(config, resource, event) {
    const {
      columns,
      eventColumns
    } = config,
          cells = [],
          resourceCells = this.processRecord(resource, columns, config); // No cells from group footers (or from group headers if configured to not show them)

    resourceCells && cells.push(...resourceCells);

    if (!resource || !resource.isSpecialRow) {
      const eventCells = this.processRecord(event, eventColumns, config); // No cells from group footers (or from group headers if configured to not show them)

      eventCells && cells.push(...eventCells);
    }

    return cells;
  }

}
ScheduleTableExporter._$name = 'ScheduleTableExporter';

/***/ }),

/***/ "./lib/Scheduler/view/DependencyEditor.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/view/DependencyEditor.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyEditor; });
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/DependencyEditor
 */

/**
 * A dependency editor popup.
 *
 * @extends Core/widget/Popup
 * @private
 */

class DependencyEditor extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DependencyEditor';
  }

  static get defaultConfig() {
    return {
      items: [],
      draggable: {
        handleSelector: ':not(button,.b-field-inner)' // blacklist buttons and field inners

      },
      axisLock: 'flexible'
    };
  }

  processWidgetConfig(widget) {
    const dependencyEditFeature = this.dependencyEditFeature;
    let fieldConfig = {};

    if (widget.ref === 'lagField' && !dependencyEditFeature.showLagField) {
      return false;
    }

    if (widget.ref === 'deleteButton' && !dependencyEditFeature.showDeleteButton) {
      return false;
    }

    Object.assign(widget, fieldConfig);
    return super.processWidgetConfig(widget);
  }

  afterShow(...args) {
    const deleteButton = this.widgetMap.deleteButton; // Only show delete button if the dependency record belongs to a store

    if (deleteButton) {
      deleteButton.hidden = !this.record.isPartOfStore();
    }

    super.afterShow(...args);
  }

  onInternalKeyDown(event) {
    this.trigger('keyDown', {
      event
    });
    super.onInternalKeyDown(event);
  }

}
DependencyEditor._$name = 'DependencyEditor';

/***/ }),

/***/ "./lib/Scheduler/view/EventEditor.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/view/EventEditor.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventEditor; });
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/EventEditor
 */

/**
 * Provided event editor dialog.
 *
 * @extends Core/widget/Popup
 * @private
 */

class EventEditor extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'eventeditor';
  }

  static get $name() {
    return 'EventEditor';
  }

  static get configurable() {
    return {
      items: [],
      draggable: {
        handleSelector: ':not(button,.b-field-inner)' // Ignore buttons and field inners

      },
      axisLock: 'flexible',
      scrollable: {
        // In case editor is very tall or window is small, make it scrollable
        overflowY: true
      },
      readOnly: null,

      /**
       * A Function (or *name* of a function) which produces a customized Panel header based upon the event being edited.
       * @config {Function|String}
       * @param {Scheduler.model.EventModel} eventRecord The record being edited
       * @returns {String} The Panel title.
       */
      titleRenderer: null
    };
  }

  updateLocalization() {
    super.updateLocalization(...arguments); // Use this if there's no titleRenderer

    this.initialTitle = this.title || '';
  }

  chainResourceStore() {
    return this.eventEditFeature.resourceStore.makeChained(record => !record.isSpecialRow, null, {
      // Need to show all records in the combo. Required in case resource store is a tree.
      excludeCollapsedRecords: false
    });
  }

  processWidgetConfig(widget) {
    var _widget$type;

    const {
      eventEditFeature
    } = this;

    if ((_widget$type = widget.type) !== null && _widget$type !== void 0 && _widget$type.includes('date') && widget.weekStartDay == null) {
      widget.weekStartDay = this.weekStartDay;
    }

    if (widget.type === 'extraItems') {
      return false;
    }

    let fieldConfig = {};

    if (widget.ref === 'resourceField') {
      if (!eventEditFeature.showResourceField) {
        return false;
      } // Can't use store directly since it may be grouped and then contains irrelevant group records


      widget.store = this.chainResourceStore(); // When events are loaded with resourceId, we should only support single select

      widget.multiSelect = !eventEditFeature.eventStore.usesSingleAssignment;

      if (eventEditFeature.resourceFieldConfig) {
        fieldConfig = eventEditFeature.resourceFieldConfig;
      }
    }

    if (widget.ref === 'nameField' && !eventEditFeature.showNameField) {
      return false;
    }

    if (widget.ref === 'deleteButton' && !eventEditFeature.showDeleteButton) {
      return false;
    }

    if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'date') {
      fieldConfig.format = eventEditFeature.dateFormat;
    }

    if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'time') {
      fieldConfig.format = eventEditFeature.timeFormat;
    }

    if (eventEditFeature.startDateConfig && widget.name === 'startDate' && widget.type === 'date') {
      fieldConfig = eventEditFeature.startDateConfig;
    }

    if (eventEditFeature.startTimeConfig && widget.name === 'startDate' && widget.type === 'time') {
      fieldConfig = eventEditFeature.startTimeConfig;
    }

    if (eventEditFeature.endDateConfig && widget.name === 'endDate' && widget.type === 'date') {
      fieldConfig = eventEditFeature.endDateConfig;
    }

    if (eventEditFeature.endTimeConfig && widget.name === 'endDate' && widget.type === 'time') {
      fieldConfig = eventEditFeature.endTimeConfig;
    }

    Object.assign(widget, fieldConfig);
    return super.processWidgetConfig(widget);
  }

  show(...args) {
    const {
      resourceField
    } = this.widgetMap; // Updated chained store. It is not done automatically for grouping/trees or when project is replaced

    if (resourceField) {
      resourceField.store = this.chainResourceStore();
    }

    super.show(...args);
  }

  onBeforeShow(...args) {
    const me = this,
          {
      record,
      titleRenderer
    } = me,
          deleteButton = me.widgetMap.deleteButton; // Hide delete button if we are readOnly or the event is in a create phase
    // which means we\re editing a dblclick-created or drag-created event.

    if (deleteButton) {
      deleteButton.hidden = me.readOnly || record.isCreating;
    }

    if (titleRenderer) {
      me.title = me.callback(titleRenderer, me, [record]);
    } else {
      me.title = me.initialTitle;
    }

    super.onBeforeShow && super.onBeforeShow(...args);
  }

  onInternalKeyDown(event) {
    this.trigger('keyDown', {
      event
    });
    super.onInternalKeyDown(event);
  }

  updateReadOnly(readOnly) {
    const {
      deleteButton,
      saveButton,
      cancelButton
    } = this.widgetMap;
    super.updateReadOnly(readOnly);

    if (deleteButton) {
      deleteButton.hidden = readOnly;
    }

    if (saveButton) {
      saveButton.hidden = readOnly;
    }

    if (cancelButton) {
      cancelButton.hidden = readOnly;
    }
  }

} // Register this widget type with its Factory

EventEditor.initClass();
EventEditor._$name = 'EventEditor';

/***/ }),

/***/ "./lib/Scheduler/view/Header.js":
/*!**************************************!*\
  !*** ./lib/Scheduler/view/Header.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Header; });
/* harmony import */ var _Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/view/Header.js */ "./lib/Grid/view/Header.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/Header
 */

/**
 * Custom header subclass which handles the existence of the special TimeAxisColumn
 *
 * @extends Grid/view/Header
 * @private
 */

class Header extends _Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SchedulerHeader';
  }

  refreshContent() {
    var _this$headersElement;

    // Only render contents into the header once as it contains the special rendering of the TimeAxisColumn
    // In case ResizeObserver polyfill is used headers element will have resize monitors inserted and we should
    // take that into account
    // https://github.com/bryntum/support/issues/3444
    if (!((_this$headersElement = this.headersElement) !== null && _this$headersElement !== void 0 && _this$headersElement.querySelector('.b-sch-timeaxiscolumn'))) {
      super.refreshContent();
    }
  }

}
Header._$name = 'Header';

/***/ }),

/***/ "./lib/Scheduler/view/HorizontalTimeAxis.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/view/HorizontalTimeAxis.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalTimeAxis; });
/* harmony import */ var _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeAxisBase.js */ "./lib/Scheduler/view/TimeAxisBase.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/HorizontalTimeAxis
 */

/**
 * A visual horizontal representation of the time axis described in the
 * {@link Scheduler.preset.ViewPreset#field-headers headers}.
 * Normally you should not interact with this class directly.
 *
 * @extends Scheduler/view/TimeAxisBase
 * @private
 */

class HorizontalTimeAxis extends _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'HorizontalTimeAxis';
  }

  static get type() {
    return 'horizontaltimeaxis';
  }

  static get configurable() {
    return {
      model: null,
      sizeProperty: 'width',
      positionProperty: 'left'
    };
  } //endregion


  get width() {
    return this.size;
  }

  onModelUpdate() {
    // Force rebuild when availableSpace has changed, to recalculate width and maybe apply compact styling
    if (this.model.availableSpace !== this.width) {
      this.refresh(true);
    }
  }

  updateModel(timeAxisViewModel) {
    this.detachListeners('tavm');
    timeAxisViewModel === null || timeAxisViewModel === void 0 ? void 0 : timeAxisViewModel.on({
      name: 'tavm',
      update: 'onModelUpdate',
      thisObj: this
    });
  }

}
HorizontalTimeAxis._$name = 'HorizontalTimeAxis';

/***/ }),

/***/ "./lib/Scheduler/view/ResourceHeader.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/view/ResourceHeader.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceHeader; });
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
var productName = 'gantt';







/**
 * @module Scheduler/view/ResourceHeader
 */

/**
 * Header widget that renders resource column headers and acts as the interaction point for resource columns in vertical
 * mode. Note that it uses virtual rendering and element reusage to gain performance, only headers in view are available
 * in DOM. Because of this you should avoid direct element manipulation, any such changes can be discarded at any time.
 *
 * By default it displays resources `name` and also applies its `iconCls` if any, like this:
 *
 * ```
 * <i class="iconCls">name</i>
 * ```
 *
 * If Scheduler is configured with a {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} the
 * header will render miniatures for the resources, using {@link Scheduler.model.mixin.ResourceModelMixin#field-imageUrl} or {@link Scheduler.model.mixin.ResourceModelMixin#field-image} with
 * fallback to {@link Scheduler.model.mixin.ResourceModelMixin#field-name} + {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImageExtension} for unset values.
 *
 * The contents and styling of the resource cells in the header can be customized using {@link #config-headerRenderer}:
 *
 * ```
 * new Scheduler({
 *     mode            : 'vertical',
 *     resourceColumns : {
 *         headerRenderer : ({ resourceRecord }) => `Hello ${resourceRecord.name}`
 *     }
 * }
 *```
 *
 * The width of the resource columns is determined by the {@link #config-columnWidth} config.
 *
 * @extends Core/widget/Widget
 */

class ResourceHeader extends _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ResourceHeader';
  }

  static get type() {
    return 'resourceheader';
  }

  static get defaultConfig() {
    return {
      /**
       * Resource store used to render resource headers. Assigned from Scheduler.
       * @config {Scheduler.data.ResourceStore}
       * @private
       */
      resourceStore: null,
      // TODO: Read this value from CSS as we do with rowHeight?

      /**
       * Width for each resource column
       * @config {Number}
       */
      columnWidth: 150,

      /**
       * Custom header renderer function. Can be used to manipulate the element config used to create the element
       * for the header:
       *
       * ```
       * new Scheduler({
       *   resourceColumns : {
       *     headerRenderer({ elementConfig, resourceRecord }) {
       *       elementConfig.dataset.myExtraData = 'extra';
       *       elementConfig.style.fontWeight = 'bold';
       *     }
       *   }
       * });
       * ```
       *
       * See {@link Core.helper.DomHelper#function-createElement-static DomHelper#createElement()} for more information.
       * Please take care to not break the default configs :)
       *
       * Or as a template by returning HTML from the function:
       *
       * ```
       * new Scheduler({
       *   resourceColumns : {
       *     headerRenderer : ({ resourceRecord }) => `
       *       <div class="my-custom-template">
       *       ${resourceRecord.firstName} {resourceRecord.surname}
       *       </div>
       *     `
       *   }
       * });
       * ```
       *
       * NOTE: When using `headerRenderer` no default internal markup is applied to the resource header cell,
       * `iconCls` and {@link Scheduler.model.mixin.ResourceModelMixin#field-imageUrl} or {@link Scheduler.model.mixin.ResourceModelMixin#field-image}
       * will have no effect unless you supply custom markup for them.
       *
       * @config {Function}
       * @param {Object} params Object containing the params below
       * @param {Scheduler.model.ResourceModel} resourceRecord Resource whose header is being rendered
       * @param {Object} elementConfig A {@link Core.helper.DomHelper#function-createElement-static} config object used to create the element for the resource
       */
      headerRenderer: null,

      /**
       * Automatically resize resource columns to **fill** available width. Set to `false` to always respect the
       * configured `columnWidth`
       * @config {Boolean}
       * @default
       */
      fillWidth: true,

      /**
       * Automatically resize resource columns to always **fit** available width
       * @config {Boolean}
       * @default
       */
      fitWidth: false,
      // Copied from Scheduler#resourceImagePath on creation in TimeAxisColumn.js
      imagePath: null,
      // Copied from Scheduler#resourceImageExtension on creation in TimeAxisColumn.js
      imageExtension: null,
      // Copied from Scheduler#defaultResourceImageName on creation in TimeAxisColumn.js
      defaultImageName: null
    };
  }

  static get configurable() {
    return {
      /**
       * Set to `false` to render just the resource name, `true` to render an avatar (or initials if no image exists)
       * @config {Boolean}
       * @default true
       */
      showAvatars: {
        value: true,
        $config: 'nullify'
      }
    };
  }

  static get properties() {
    return {
      /**
       * An index of the first visible resource in vertical mode
       * @property {Number}
       * @readonly
       * @private
       */
      firstResource: -1,

      /**
       * An index of the last visible resource in vertical mode
       * @property {Number}
       * @readonly
       * @private
       */
      lastResource: -1
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    const me = this;

    if (me.imagePath != null) {
      // Need to increase height a bit when displaying images
      me.element.classList.add('b-has-images');
    }

    _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
      element: me.element,
      delegate: '.b-resourceheader-cell',
      capture: true,
      click: 'onResourceMouseEvent',
      dblclick: 'onResourceMouseEvent',
      contextmenu: 'onResourceMouseEvent',
      thisObj: me
    });
  }

  changeShowAvatars(show) {
    var _this$avatarRendering;

    (_this$avatarRendering = this.avatarRendering) === null || _this$avatarRendering === void 0 ? void 0 : _this$avatarRendering.destroy();

    if (show) {
      this.avatarRendering = new _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
        element: this.element
      });
    }

    return show;
  }

  updateShowAvatars() {
    if (!this.isConfiguring) {
      this.refresh();
    }
  } //endregion
  //region ResourceStore


  set resourceStore(store) {
    const me = this;

    if (store !== me._resourceStore) {
      var _me$resourceStoreDeta;

      (_me$resourceStoreDeta = me.resourceStoreDetacher) === null || _me$resourceStoreDeta === void 0 ? void 0 : _me$resourceStoreDeta.call(me);
      me._resourceStore = store;
      me.resourceStoreDetacher = store.on({
        changePreCommit: 'onResourceStoreDataChange',
        thisObj: me
      }); // Already have data? Update width etc

      if (store.count) {
        me.onResourceStoreDataChange({});
      }
    }
  }

  get resourceStore() {
    return this._resourceStore;
  } // Redraw resource headers on any data change


  onResourceStoreDataChange({
    action
  }) {
    const me = this,
          width = me.resourceStore.count * me.columnWidth;

    if (width !== me.width) {
      me.element.style.width = width + 'px'; // During setup, silently set the width. It will then render correctly. After setup, let the world know...

      me.column.set('width', width, me.column.grid.isConfiguring);
    }

    if (action === 'removeall') {
      // Keep nothing
      me.element.innerHTML = '';
    }

    if (action === 'remove' || action === 'add' || action === 'filter' || me.fitWidth || me.fillWidth) {
      me.refreshWidths();
    }

    me.column.grid.toggleEmptyText();
  } //endregion
  //region Properties


  get columnWidth() {
    return this._columnWidth;
  }

  set columnWidth(width) {
    const me = this;

    if (width !== me._columnWidth) {
      const oldWidth = me._columnWidth;
      me._columnWidth = width; // Flag set in refreshWidths, do not want to create a loop

      if (!me.refreshingWidths) {
        me._originalColumnWidth = width;
        me.refreshWidths();
      }

      if (!me.isConfiguring) {
        me.refresh(); // Cannot trigger with requested width, might have changed because of fit/fill

        me.trigger('columnWidthChange', {
          width: me._columnWidth,
          oldWidth
        });
      }
    }
  }
  /**
   * Assign to toggle resource columns **fill* mode. `true` means they will stretch (grow) to fill viewport, `false`
   * that they will respect their configured `columnWidth`.
   * @property {Boolean}
   */


  get fillWidth() {
    return this._fillWidth;
  }

  set fillWidth(fill) {
    this._fillWidth = fill;
    this.refreshWidths();
  }
  /**
   * Assign to toggle resource columns **fit* mode. `true` means they will grow or shrink to always fit viewport,
   * `false` that they will respect their configured `columnWidth`.
   * @property {Boolean}
   */


  get fitWidth() {
    return this._fitWidth;
  }

  set fitWidth(fit) {
    this._fitWidth = fit;
    this.refreshWidths();
  }

  getImageURL(imageName) {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].joinPaths([this.imagePath || '', imageName || '']);
  }

  get imagePath() {
    return this._imagePath;
  }

  set imagePath(path) {
    this._imagePath = path;
    this.refresh();
  } //endregion
  //region Fit to width


  get availableWidth() {
    return this._availableWidth;
  }

  set availableWidth(width) {
    this._availableWidth = width;
    this.refreshWidths();
  } // Updates the column widths according to fill and fit settings


  refreshWidths() {
    const me = this,
          {
      availableWidth,
      _originalColumnWidth
    } = me,
          count = me.resourceStore && me.resourceStore.count; // Bail out if availableWidth not yet set or resource store not assigned/loaded

    if (!availableWidth || !count) {
      return;
    }

    me.refreshingWidths = true;
    const // Fit width if configured to do so or if configured to fill and used width is less than available width
    fit = me.fitWidth || me.fillWidth && _originalColumnWidth * count < availableWidth,
          useWidth = fit ? Math.floor(availableWidth / count) : _originalColumnWidth,
          shouldAnimate = me.column.grid.enableEventAnimations && Math.abs(me._columnWidth - useWidth) > 30;
    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].addTemporaryClass(me.element, 'b-animating', shouldAnimate ? 300 : 0, me);
    me.columnWidth = useWidth;
    me.refreshingWidths = false;
  } //endregion
  //region Rendering
  // Visual resource range, set by VerticalRendering + its buffer


  set visibleResources({
    firstResource,
    lastResource
  }) {
    this.firstResource = firstResource;
    this.lastResource = lastResource;
    this.refresh();
  }
  /**
   * Refreshes the visible headers
   */


  refresh() {
    const me = this,
          {
      firstResource,
      lastResource
    } = me,
          configs = [];

    if (!me.column.grid.isConfiguring && firstResource > -1 & lastResource > -1 && lastResource < me.resourceStore.count) {
      // Gather element configs for resource headers in view
      for (let i = firstResource; i <= lastResource; i++) {
        const resourceRecord = me.resourceStore.getAt(i),
              elementConfig = {
          // Might look like overkill to use DomClassList here, but can be used in headerRenderer
          className: new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
            'b-resourceheader-cell': 1
          }),
          dataset: {
            resourceId: resourceRecord.id
          },
          style: {
            left: i * me.columnWidth,
            width: me.columnWidth
          },
          children: []
        }; // Let a configured headerRenderer have a go at it before applying

        if (me.headerRenderer) {
          const value = me.headerRenderer({
            elementConfig,
            resourceRecord
          });

          if (value != null) {
            elementConfig.html = value;
          }
        } // No headerRenderer, apply default markup
        else {
          let imageUrl;

          if (resourceRecord.imageUrl) {
            imageUrl = resourceRecord.imageUrl;
          } else {
            if (me.imagePath != null) {
              if (resourceRecord.image !== false) {
                const imageName = resourceRecord.image || resourceRecord.name && resourceRecord.name.toLowerCase() + me.imageExtension;
                imageUrl = me.getImageURL(imageName);
              }
            }
          } // By default showing resource name and optionally avatar


          elementConfig.children.push(me.showAvatars && me.avatarRendering.getResourceAvatar({
            initials: resourceRecord.initials,
            color: resourceRecord.eventColor,
            iconCls: resourceRecord.iconCls,
            defaultImageUrl: me.defaultImageName && me.getImageURL(me.defaultImageName),
            imageUrl
          }), {
            tag: 'span',
            className: 'b-resource-name',
            html: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].encodeHtml(resourceRecord.name)
          });
        }

        configs.push(elementConfig);
      }
    } // Sync changes to the header


    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].sync({
      domConfig: {
        onlyChildren: true,
        children: configs
      },
      targetElement: me.element,
      syncIdField: 'resourceId' // TODO: Add callback here to trigger events when rendering/derendering header cells. Sooner or later
      //  someone is going to ask for a way to render JSX or what not to the header

    });
  } //endregion


  onResourceMouseEvent(event) {
    const resourceCell = event.target.closest('.b-resourceheader-cell'),
          resourceRecord = this.resourceStore.getById(resourceCell.dataset.resourceId);
    this.trigger('resourceHeader' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].capitalize(event.type), {
      resourceRecord,
      event
    });
  }

}
ResourceHeader._$name = 'ResourceHeader';

/***/ }),

/***/ "./lib/Scheduler/view/Scheduler.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/view/Scheduler.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scheduler; });
/* harmony import */ var _SchedulerBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Scheduler/localization/En.js");
/* harmony import */ var _feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony import */ var _feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../feature/EventContextMenu.js */ "./lib/Scheduler/feature/EventContextMenu.js");
/* harmony import */ var _feature_EventCopyPaste_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../feature/EventCopyPaste.js */ "./lib/Scheduler/feature/EventCopyPaste.js");
/* harmony import */ var _feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../feature/EventDrag.js */ "./lib/Scheduler/feature/EventDrag.js");
/* harmony import */ var _feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../feature/EventDragCreate.js */ "./lib/Scheduler/feature/EventDragCreate.js");
/* harmony import */ var _feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../feature/EventEdit.js */ "./lib/Scheduler/feature/EventEdit.js");
/* harmony import */ var _feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony import */ var _feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _feature_EventResize_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony import */ var _feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../feature/EventTooltip.js */ "./lib/Scheduler/feature/EventTooltip.js");
/* harmony import */ var _feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/HeaderContextMenu.js */ "./lib/Scheduler/feature/HeaderContextMenu.js");
/* harmony import */ var _feature_ScheduleContext_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../feature/ScheduleContext.js */ "./lib/Scheduler/feature/ScheduleContext.js");
/* harmony import */ var _feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/ScheduleContextMenu.js */ "./lib/Scheduler/feature/ScheduleContextMenu.js");
/* harmony import */ var _feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony import */ var _feature_StickyEvents_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../feature/StickyEvents.js */ "./lib/Scheduler/feature/StickyEvents.js");
/* harmony import */ var _feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony import */ var _Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Grid/feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony import */ var _Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Grid/feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
var productName = 'gantt';

 // default features


 // TODO: 'eventContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.









 // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.


 // TODO: 'scheduleContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/4.0.0 for more information.




 // Since Scheduler is based on SchedulerBase + GridBase, Grids default features needs to be pulled in here also







 // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/4.0.0 for more information.







 // For checkbox selection mode

/**
 * @module Scheduler/view/Scheduler
 */

/**
 * The Scheduler widget is a very powerful and performant UI component that displays an arbitrary number of "locked"
 * columns with a schedule occupying the remaining space. The schedule has a timeaxis at the top, one row per resource
 * and any number of events per resource.
 *
 * ## Intro
 * The Scheduler widget has a wide range of features and a large API to allow users to work with it efficiently in the
 * browser.
 *
 * The timeaxis displayed at the top of the Scheduler is configured using a {@link Scheduler.view.TimelineBase#config-startDate},
 * {@link Scheduler.view.TimelineBase#config-endDate} and a {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}. The dates
 * determine the outer limits of the range shown in the timeaxis while the {@link Scheduler.preset.ViewPreset} decides
 * the appearance and which dates are actually shown. The Scheduler ships with a selection of predefined view presets,
 * which can be found in {@link Scheduler.preset.PresetManager}. If you want to specify view presets for a specific scheduler only, please
 * see {@link Scheduler.view.mixin.TimelineViewPresets#config-presets} config.
 *
 * The Scheduler uses a {@link Scheduler.data.ResourceStore} to hold resources and an {@link Scheduler.data.EventStore}
 * to hold events. You can use inline data or load data using ajax, see the "Working with data" guides for more
 * information.
 *
 * The simplest schedule configured with inline data would look like this:
 *
 *      let scheduler = new Scheduler({
 *          appendTo : document.body,
 *
 *          startDate  : new Date(2018,4,6),
 *          endDate    : new Date(2018,4,12),
 *          viewPreset : 'dayAndWeek',
 *
 *           columns : [
 *              { field : 'name', text : 'Name', width: 100 }
 *          ],
 *
 *          resources : [
 *              { id : 1, name : 'Bernard' },
 *              { id : 2, name : 'Bianca' }
 *          ],
 *
 *          events : [
 *              { id : 1, resourceId : 1, name : 'Interview', startDate : '2018-05-06', endDate : '2018-05-07' },
 *              { id : 2, resourceId : 1, name : 'Press conference', startDate : '2018-05-08', endDate : '2018-05-09' },
 *              { id : 3, resourceId : 2, name : 'Audition', startDate : '2018-05-06', endDate : '2018-05-08' },
 *              { id : 4, resourceId : 2, name : 'Script deadline', startDate : '2018-05-11', endDate : '2018-05-11' }
 *          ]
 *      });
 *
 * {@inlineexample Scheduler/view/Simplest.js}
 * ## Inheriting from Bryntum Grid
 * Bryntum Scheduler inherits from Bryntum Grid, meaning that most features available for the grid are also available
 * for the scheduler. Common features include columns, cell editing, context menus, row grouping, sorting and more.
 *
 * For more information on configuring columns, filtering, search etc. please see the {@link Grid.view.Grid Grid API docs}.
 * {@region Loading data}
 * As mentioned above Bryntum Scheduler uses an {@link Scheduler.data.EventStore} and a {@link Scheduler.data.ResourceStore}
 * to hold its data. Data is expected to be in JSON format and can be assigned inline (from memory) using the
 * {@link Scheduler.view.mixin.SchedulerStores#config-events} and
 * {@link Scheduler.view.mixin.SchedulerStores#config-resources} shortcuts:
 * ```
 * let scheduler = new Scheduler({
 *    events : myArrayOfEventData,
 *    resources : myArrayOfResourceData
 * });
 * ```
 * If you need to give additional store configuration, you can also specify store configs or instances:
 * ```
 * let resourceStore = new ResourceStore({
 *   // ResourceStore config object
 * })
 *
 * let scheduler = new Scheduler({
 *    // EventStore config object
 *    eventStore : {
 *       ...
 *    },
 *
 *    // Already existing ResourceStore instance
 *    resourceStore
 * });
 * ```
 * To use Ajax to fetch data from a server, specify {@link Core.data.AjaxStore#config-readUrl}:
 * ```
 * let scheduler = new Scheduler({
 *    eventStore : {
 *        readUrl  : 'backend/read_events.php',
 *        autoLoad : true
 *    }
 * });
 * // If you do not specify autoLoad, trigger loading manually:
 * scheduler.eventStore.load();
 * ```
 * For more information, see the "Working with data" guides.
 * {@endregion}
 * {@region Event styling}
 * Bryntum Schedulers appearance can be affected in a few different ways:
 *
 * * Switching themes
 * * Choosing event styles and colors
 * * Using renderer functions
 *
 * ### Switching themes
 * Scheduler ships with four different themes, simply include the css file for the theme you would like to use on your
 * page. The themes are located in the `/build` folder. For example to include the material theme:
 * ```
 * <link rel="stylesheet" href="build/scheduler.material.css" id="bryntum-theme">
 * ```
 * Included themes are (from left to right) classic-light, classic, classic-dark, stockholm and material:
 *
 * <img src="Scheduler/basic/thumb.classic-light.png" alt="Classic-Light theme" width="300" style="margin-right: .5rem">
 * <img src="Scheduler/basic/thumb.classic.png" alt="Classic theme" width="300" style="margin-right: .5rem">
 * <img src="Scheduler/basic/thumb.classic-dark.png" alt="Classic-Dark theme" width="300" style="margin-right: .5rem">
 * <img src="Scheduler/basic/thumb.stockholm.png" alt="Stockholm theme" width="300" style="margin-right: .5rem">
 * <img src="Scheduler/basic/thumb.material.png" alt="Material theme" width="300">
 *
 * ### Choosing event styles and colors
 * The style and color of each event can be changed by assigning to the `eventStyle` and `eventColor` configs. These
 * configs are available at 3 different levels:
 *
 * * Scheduler level, affects all events (see {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle} and {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor}).
 * * Resource level, affects all events assigned to that resource (see {@link Scheduler.model.mixin.ResourceModelMixin#field-eventStyle}
 * and {@link Scheduler.model.mixin.ResourceModelMixin#field-eventColor}).
 * * Event level, affects that event (see {@link Scheduler/model/mixin/EventModelMixin#field-eventStyle} and
 * {@link Scheduler/model/mixin/EventModelMixin#field-eventColor}).
 *
 * {@inlineexample Scheduler/view/Styles.js}
 *
 * For available styles, see {@link Scheduler.view.mixin/TimelineEventRendering#config-eventStyle}. For colors,
 * {@link Scheduler.view.mixin/TimelineEventRendering#config-eventColor}. Also take a look at the
 * <a href="../examples/eventstyles" target="_blank">eventstyles demo</a>.
 *
 *
 * ### Sorting overlapping events
 *
 * The order of overlapping events rendered in a horizontal scheduler can be customized by overriding
 * {@link Scheduler.view.mixin.SchedulerEventRendering#config-horizontalEventSorterFn} function on the scheduler.
 * For example:
 * ```
 * let scheduler = new Scheduler({
 *     horizontalEventSorterFn(a, b) {
 *         return b.startDate.getTime() - a.startDate.getTime();
 *     },
 *     ...
 * });
 * ```
 *
 * {@inlineexample Scheduler/view/SortingOverlappingEvents.js}
 *
 * ### Using render functions
 * Render function can be used to manipulate the rendering of rows (resources) and events. For information on row
 * renderers, see {@link Grid.column.Column#config-renderer}.
 *
 * Event rendering can be manipulated by specifying an {@link Scheduler.view.mixin/SchedulerEventRendering#config-eventRenderer} function. The function is called
 * for each event before it is rendered to DOM. By using its arguments you can add CSS classes, modify styling and
 * determine the contents of the event:
 * ```
 * let scheduler = new Scheduler({
 *
 *   events    : [...],
 *   resources : [...],
 *
 *   ...,
 *
 *   eventRenderer({resourceRecord, eventRecord, renderData}) {
 *      // add css class to the event
 *      renderData.cls.add('my-css-class');
 *
 *      // use an icon
 *      renderData.iconCls = 'b-fa b-fa-some-nice-icon';
 *
 *      // return value is used as events text
 *      return `${resourceRecord.name}: ${eventRecord.name}`;
 *   }
 * });
 * ```
 * {@endregion}
 * {@region Event manipulation}
 * You can programmatically manipulate the events using data operations, see the "Working with data" guides for more
 * information. Events are reactive, changes reflect on the UI automatically. A small example on manipulating events:
 * ```
 * // change startDate of first event
 * scheduler.eventStore.first.startDate = new Date(2018,5,10);
 *
 * // remove last event
 * scheduler.eventStore.last.remove();
 *
 * // reassign an event
 * scheduler.eventStore.getById(10).resourceId = 2;
 * ```
 *
 * You can also allow your users to manipulate the events using the following features:
 *
 * * {@link Scheduler.feature.EventDrag}, drag and drop events within the schedule
 * * {@link Scheduler.feature.EventDragCreate}, create new events by click-dragging an empty area
 * * {@link Scheduler.feature.EventEdit}, show an event editing form
 * * {@link Scheduler.feature.SimpleEventEdit}, edit the event name easily
 * * {@link Scheduler.feature.EventResize}, resize events by dragging resize handles
 *
 * All of the features mentioned above are enabled by default.
 * {@endregion}
 * {@region Default configs}
 * There is a myriad of configs and features available for Scheduler (browse the API docs to find them), some of them on
 * by default and some of them requiring extra configuration. The code below tries to illustrate the major things that
 * are used by default:
 *
 * ```javascript
 * let scheduler = new Scheduler({
 *    // The following features are enabled by default:
 *    features : {
 *        cellEdit            : true, // Cell editing in the columns part
 *        columnLines         : true, // Column lines in the schedule part
 *        columnPicker        : true, // Header context menu item to toggle visible columns
 *        columnReorder       : true, // Reorder columns in grid part using drag and drop
 *        columnResize        : true, // Resize columns in grid part using the mouse
 *        cellMenu            : true, // Context menu for cells in the grid part
 *        eventMenu           : true, // Context menu for events
 *        eventDrag           : true, // Dragging events
 *        eventDragCreate     : true, // Drag creating events
 *        eventEdit           : true, // Event editor dialog
 *        eventFilter         : true, // Filtering events using header context menu
 *        eventCopyPaste      : true, // Allow using [Ctrl/CMD + C/X] and [Ctrl/CMD + V] to copy/cut and paste events
 *        eventResize         : true, // Resizing events using the mouse
 *        eventTooltip        : true, // Tooltips for events
 *        group               : true, // Row grouping
 *        headerMenu          : true, // Context menu for headers in the grid part
 *        timeAxisHeaderMenu  : true, // Header context menu for schedule part
 *        scheduleMenu        : true, // Context menu for empty parts of the schedule
 *        scheduleTooltip     : true, // Tooltip for empty parts of the schedule
 *        sort                : true  // Row sorting
 *    },
 *
 *    // From Grid
 *    animateRemovingRows       : false, // Rows will not slide out on removal
 *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height
 *    columnLines               : true,  // Grid part, themes might override it to hide lines anyway
 *    emptyText                 : 'No rows to display',
 *    enableTextSelection       : false, // Not allowed to select text in cells by default,
 *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
 *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
 *    loadMask                  : 'Loading...',
 *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
 *    responsiveLevels : {
 *      small : 400,
 *      medium : 600,
 *      large : '*'
 *    },
 *    rowHeight                  : 60,    // Scheduler specifies a default rowHeight in pixels
 *    showDirty                  : false, // No indicator for changed cells
 *
 *    // Scheduler specific
 *    autoAdjustTimeAxis             : true,      // startDate & endDate will be adjusted to display a suitable range
 *    allowOverlap                   : true,      // Events are allowed to overlap (overlays, stacks or packs depending on eventLayout)
 *    barMargin                      : 10,        // Space above + below each event
 *    createEventOnDblClick          : true,      // Allow creating new events by double clicking empty space
 *    enableDeleteKey                : true,      // Allow deleting events with delete / backspace keys
 *    enableEventAnimations          : true,      // Animate event changes
 *    eventBarTextField              : 'name',    // Field on EventModel to display in events
 *    eventColor                     : 'green',   // Use green as default color for events
 *    eventLayout                    : 'stack',   // Stack overlapping events by default
 *    eventStyle                     : 'plain',   // Use plain as default style for events
 *    managedEventSizing             : true,      // Calculate event sizes based on rowHeight & barMargin
 *    milestoneCharWidth             : 10,
 *    milestoneLayoutMode            : 'default',
 *    removeUnassignedEvent          : true,      // Remove event when all assignments for it are removed
 *    useInitialAnimation            : true,      // Fade in events initially
 *    viewPreset                     : 'weekAndDayLetter',
 *    zoomOnMouseWheel               : true,
 *    zoomOnTimeAxisDoubleClick      : true
 * });
 * ```
 * {@endregion}
 * {@region Performance}
 * To make scheduler performance as good as possible it only renders the events and resources that are within view (plus
 * an additional buffer). Since adding to and removing from DOM comes with a performance penalty the elements are
 * instead repositioned and reused as you scroll. A side effect of this is that you cannot do direct DOM element
 * manipulation in a reliable way, instead you should use row and event renderer functions to achieve what you want (see
 * the section on event styling above).
 *
 * To put the scheduler to the test, try our <a href="../examples/bigdataset" target="_blank">bigdataset demo</a>.
 * {@endregion}
 *
 * {@region Recurring Events}
 * From 4.0.0, there is no `RecurringEvents` Feature. There is an
 * {@link Scheduler.view.mixin.RecurringEvents#config-enableRecurringEvents enableRecurringEvents}
 * boolean config on the Scheduler. Occurrences of recurring events are provided on a "just in time"
 * basis by a new EventStore API which must now be used when interrogating an EventStore.
 *
 * {@link Scheduler.data.mixin.EventStoreMixin#function-getEvents} is a multipurpose event gathering method
 * which can be asked to return events which match a set of criteria including a date range and a
 * resource. By default, if the requested date range contains occurrences of a recurring event,
 * those occurrences are returned in the result array.
 *
 * ```js
 * myEventStore.getEvents({
 *     resourceRecord : myResourceRecord,
 *     startDate      : myScheduler.startDate,
 *     endDate        : myScheduler.endDate
 * });
 * ```
 *
 * Occurrences are *not* present in the store's data collection.
 *
 * To directly access occurrences of a recurring event which *intersect* a date range, use:
 *
 * ```js
 * recurringEvent.getOccurrencesForDateRange(startDate, endDate);
 * ```
 *
 * The `endDate` argument is optional if the occurrence for one date is required. This method always
 * returns an array. Note that it may be empty if no occurrences intersect the date range.
 *
 * ### Convert an occurrence to an exception
 * To programmatically convert an occurrence to be a single exception to its owner's sequence use:
 *
 * ```
 * myOccurrence.beginBatch();
 * myOccurrence.startDate = DateHelper.add(myOccurrence.startDate, 1, 'day');
 * myOccurrence.name = 'Postponed to next day';
 * myOccurrence.recurrence = null; // This means it does NOT become a new recurring base event.
 * myOccurrence.endBatch();
 * ```
 *
 * That will cause that event to be inserted into the store as a concrete event definition, firing
 * an `add` event as would be expected, and will add an `exceptionDates` to its owning recurring event.
 *
 * When syncing this change back to the server, the `exceptionDates` array for the modified
 * recurring event now contains the exception dates correctly serialized into string form using
 * the `dateFormat` of the field. The system-supplied default value for this is
 * `'YYYY-MM-DDTHH:mm:ssZ'`
 *
 * ### Convert an occurrence to a new recurring event sequence.
 * To programmatically convert an occurrence to be the start of a new recurring sequence, use:
 *
 * ```
 * myOccurrence.beginBatch();
 * myOccurrence.startDate = DateHelper.set(myOccurrence.startDate, 'hour', 14);
 * myOccurrence.name = 'Moved to 2pm from here on';
 * myOccurrence.endBatch();
 * ```
 *
 * That will cause that event to be inserted into the store as a concrete *recurring* event
 * definition, firing an `add` event as would be expected, and will terminate the previous
 * recurring owner of that occurrence on the day before the new event.
 * {@endregion}
 *
 * @extends Scheduler/view/SchedulerBase
 */

class Scheduler extends _SchedulerBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Scheduler';
  } // Factoryable type name


  static get type() {
    return 'scheduler';
  }

} // Register this widget type with its Factory

Scheduler.initClass();
Scheduler._$name = 'Scheduler';

/***/ }),

/***/ "./lib/Scheduler/view/SchedulerBase.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/view/SchedulerBase.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerBase; });
/* harmony import */ var _TimelineBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimelineBase.js */ "./lib/Scheduler/view/TimelineBase.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/CrudManager.js */ "./lib/Scheduler/data/CrudManager.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Scheduler/localization/En.js");
/* harmony import */ var _mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/SchedulerDom.js */ "./lib/Scheduler/view/mixin/SchedulerDom.js");
/* harmony import */ var _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/SchedulerDomEvents.js */ "./lib/Scheduler/view/mixin/SchedulerDomEvents.js");
/* harmony import */ var _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/SchedulerEventRendering.js */ "./lib/Scheduler/view/mixin/SchedulerEventRendering.js");
/* harmony import */ var _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mixin/SchedulerStores.js */ "./lib/Scheduler/view/mixin/SchedulerStores.js");
/* harmony import */ var _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/SchedulerScroll.js */ "./lib/Scheduler/view/mixin/SchedulerScroll.js");
/* harmony import */ var _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/SchedulerRegions.js */ "./lib/Scheduler/view/mixin/SchedulerRegions.js");
/* harmony import */ var _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/SchedulerState.js */ "./lib/Scheduler/view/mixin/SchedulerState.js");
/* harmony import */ var _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixin/EventSelection.js */ "./lib/Scheduler/view/mixin/EventSelection.js");
/* harmony import */ var _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/EventNavigation.js */ "./lib/Scheduler/view/mixin/EventNavigation.js");
/* harmony import */ var _crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony import */ var _orientation_HorizontalRendering_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./orientation/HorizontalRendering.js */ "./lib/Scheduler/view/orientation/HorizontalRendering.js");
/* harmony import */ var _orientation_VerticalRendering_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./orientation/VerticalRendering.js */ "./lib/Scheduler/view/orientation/VerticalRendering.js");
/* harmony import */ var _column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony import */ var _column_VerticalTimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../column/VerticalTimeAxisColumn.js */ "./lib/Scheduler/column/VerticalTimeAxisColumn.js");
/* harmony import */ var _Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");
var productName = 'gantt';


















 // Should always be present in Scheduler


/**
 * @module Scheduler/view/SchedulerBase
 */

/**
 * A thin base class for {@link Scheduler.view.Scheduler}. Does not include any features by default, allowing smaller
 * custom built bundles if used in place of {@link Scheduler.view.Scheduler}.
 *
 * **NOTE:** In most scenarios you do probably want to use Scheduler instead of SchedulerBase.
 *
 * @mixes Scheduler/view/mixin/EventNavigation
 * @mixes Scheduler/view/mixin/EventSelection
 * @mixes Scheduler/view/mixin/SchedulerDom
 * @mixes Scheduler/view/mixin/SchedulerDomEvents
 * @mixes Scheduler/view/mixin/SchedulerEventRendering
 * @mixes Scheduler/view/mixin/SchedulerRegions
 * @mixes Scheduler/view/mixin/SchedulerScroll
 * @mixes Scheduler/view/mixin/SchedulerState
 * @mixes Scheduler/view/mixin/SchedulerStores
 * @mixes Scheduler/view/mixin/TimelineDateMapper
 * @mixes Scheduler/view/mixin/TimelineDomEvents
 * @mixes Scheduler/view/mixin/TimelineEventRendering
 * @mixes Scheduler/view/mixin/TimelineScroll
 * @mixes Scheduler/view/mixin/TimelineViewPresets
 * @mixes Scheduler/view/mixin/TimelineZoomable
 * @mixes Scheduler/crud/mixin/CrudManagerView
 * @mixes Scheduler/data/mixin/ProjectConsumer
 *
 * @features Scheduler/feature/ColumnLines
 * @features Scheduler/feature/Dependencies
 * @features Scheduler/feature/DependencyEdit
 * @features Scheduler/feature/EventContextMenu
 * @features Scheduler/feature/EventCopyPaste
 * @features Scheduler/feature/EventDrag
 * @features Scheduler/feature/EventDragCreate
 * @features Scheduler/feature/EventDragSelect
 * @features Scheduler/feature/EventEdit
 * @features Scheduler/feature/EventFilter
 * @features Scheduler/feature/EventMenu
 * @features Scheduler/feature/EventResize
 * @features Scheduler/feature/EventTooltip
 * @features Scheduler/feature/GroupSummary
 * @features Scheduler/feature/HeaderContextMenu
 * @features Scheduler/feature/HeaderZoom
 * @features Scheduler/feature/Labels
 * @features Scheduler/feature/NonWorkingTime
 * @features Scheduler/feature/Pan
 * @features Scheduler/feature/ResourceTimeRanges
 * @features Scheduler/feature/ScheduleContext
 * @features Scheduler/feature/ScheduleContextMenu
 * @features Scheduler/feature/ScheduleMenu
 * @features Scheduler/feature/ScheduleTooltip
 * @features Scheduler/feature/SimpleEventEdit
 * @features Scheduler/feature/StickyEvents
 * @features Scheduler/feature/Summary
 * @features Scheduler/feature/TimeAxisHeaderMenu
 * @features Scheduler/feature/TimeRanges
 *
 * @features Scheduler/feature/experimental/ExcelExporter
 *
 * @features Scheduler/feature/export/PdfExport
 *
 * @extends Scheduler/view/TimelineBase
 */

class SchedulerBase extends _TimelineBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_14__["default"], _mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"], _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_8__["default"], _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_9__["default"], _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_7__["default"], _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_10__["default"], _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_12__["default"], _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
  //region Config
  static get $name() {
    return 'SchedulerBase';
  } // Factoryable type name


  static get type() {
    return 'schedulerbase';
  }

  static get configurable() {
    return {
      /**
       * Get/set the scheduler's read-only state. When set to `true`, any UIs for modifying data are disabled.
       * @member {Boolean} readOnly
       */

      /**
       * Configure as `true` to make the scheduler read-only, by disabling any UIs for modifying data.
       *
       * __Note that checks MUST always also be applied at the server side.__
       * @config {Boolean} readOnly
       * @default false
       */

      /**
       * The date to display when used as a component of a Calendar.
       *
       * This is required by the Calendar Mode Interface.
       *
       * @config {Date}
       * @category Calendar integration
       */
      date: {
        value: null,
        $config: {
          equal: 'date'
        }
      },

      /**
       * Unit used to control how large steps to take when clicking the previous and next buttons in the Calendar
       * UI. Only applies when used as a component of a Calendar.
       *
       * Suitable units depend on configured {@link #config-range}, a smaller or equal unit is recommended.
       *
       * @config {String}
       * @category Calendar integration
       */
      stepUnit: 'week',

      /**
       * Unit used to set the length of the time axis when used as a component of a Calendar. Suitable units are
       * `'month'`, `'week'` and `'day'`.
       *
       * @config {String}
       * @category Calendar integration
       */
      range: 'week',

      /**
       * When the scheduler is used in a Calendar, this function provides the textual description for the
       * Calendar's toolbar.
       *
       * ```javascript
       *  descriptionRenderer : scheduler => {
       *      const
       *          count = scheduler.eventStore.records.filter(
       *              eventRec => DateHelper.intersectSpans(
       *                  scheduler.startDate, scheduler.endDate,
       *                  eventRec.startDate, eventRec.endDate)).length,
       *          startDate = DateHelper.format(scheduler.startDate, 'DD/MM/YYY'),
       *          endData = DateHelper.format(scheduler.endDate, 'DD/MM/YYY');
       *
       *      return `${startDate} - ${endData}, ${count} event${count === 1 ? '' : 's'}`;
       *  }
       * ```
       * @config {Function}
       * @param {Scheduler.view.SchedulerBase} view The active view.
       * @category Calendar integration
       */
      descriptionRenderer: {
        value: null,
        $config: null,
        default: view => {
          switch (view.range) {
            case 'month':
              return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(view.startDate, 'MMMM, YYYY');

            case 'week':
              return `${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getLocalizedNameOfUnit('Week')} ${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getWeekDescription(view.startDate, view.endDate)}`;

            case 'day':
              return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(view.startDate, 'MMMM D, YYYY');
          }
        }
      },

      /**
       * The time axis column config for vertical {@link Scheduler.view.SchedulerBase#config-mode}.
       *
       * Object with {@link Scheduler.column.VerticalTimeAxisColumn} configuration.
       *
       * This object will be used to configure the vertical time axis column instance.
       *
       * The config allows configuring the `VerticalTimeAxisColumn` instance used in vertical mode with any Column options that apply to it.
       *
       * Example:
       *
       * ```javascript
       * new Scheduler({
       *     mode     : 'vertical',
       *     features : {
       *         filterBar : true
       *     },
       *     verticalTimeAxisColumn : {
       *         text  : 'Filter by event name',
       *         width : 180,
       *         filterable : {
       *             // add a filter field to the vertical column access header
       *             filterField : {
       *                 type        : 'text',
       *                 placeholder : 'Type to search',
       *                 onChange    : ({ value }) => {
       *                     // filter event by name converting to lowerCase to be equal comparison
       *                     scheduler.eventStore.filter({
       *                         filters : event => event.name.toLowerCase().includes(value.toLowerCase()),
       *                         replace : true
       *                     });
       *                 }
       *             }
       *         }
       *     },
       *     ...
       * });
       * ```
       *
       * @config {Object}
       * @category Time axis
       */
      verticalTimeAxisColumn: {},

      /**
       * If true, a new event will be created when user double clicks on a time axis cell (if scheduler is not in read only mode).
       * The duration / durationUnit of the new event will be 1 time axis tick (default),
       * or it can be read from the {@link Scheduler.model.EventModel#field-duration}
       * and {@link Scheduler.model.EventModel#field-durationUnit} fields.
       * Set to false to not create events on double click.
       * @config {Boolean|Object} createEventOnDblClick
       * @param {Boolean} [createEventOnDblClick.useEventModelDefaults] set to true to set default duration based on the defaults
       * specified by the {@link Scheduler.model.EventModel#field-duration} and {@link Scheduler.model.EventModel#field-durationUnit}
       * fields.
       * @default
       * @category Scheduled events
       */
      createEventOnDblClick: true
    };
  }

  static get defaultConfig() {
    return {
      /**
       * Scheduler mode. Supported values: horizontal, vertical
       * @config {String} mode
       * @default
       */
      mode: 'horizontal',

      /**
       * CSS class to add to rendered events
       * @config {String}
       * @category CSS
       * @private
       * @default
       */
      eventCls: 'b-sch-event',

      /**
       * CSS class to add to cells in the timeaxis column
       * @config {String}
       * @category CSS
       * @private
       * @default
       */
      timeCellCls: 'b-sch-timeaxis-cell',
      timeCellSelector: '.b-sch-timeaxis-cell',
      scheduledEventName: 'event',

      /**
       * A CSS class to apply to each event in the view on mouseover (defaults to 'b-sch-event-hover').
       * @config {String}
       * @default
       * @category CSS
       * @private
       */
      overScheduledEventClass: 'b-sch-event-hover',

      /**
       * Set to false if you don't want to allow events overlapping times for any one resource (defaults to true).
       * @config {Boolean}
       * @default
       * @category Scheduled events
       */
      allowOverlap: true,

      /**
       * The height in pixels of Scheduler rows.
       * @config {Number}
       * @default
       */
      rowHeight: 60,

      /**
       * Scheduler overrides Grids default implementation of {@link Grid.view.GridBase#config-getRowHeight} to
       * pre-calculate row heights based on events in the rows.
       *
       * The amount of rows that are pre-calculated is limited for performance reasons. The limit is configurable
       * by specifying the {@link Scheduler.view.SchedulerBase#config-preCalculateHeightLimit} config.
       *
       * The results of the calculation are cached internally.
       *
       * @config {Function} getRowHeight
       * @param {Scheduler.model.ResourceModel} getRowHeight.record Resource record to determine row height for
       * @returns {Number} Desired row height
       * @category Layout
       */

      /**
       * Maximum number of resources for which height is pre-calculated. If you have many events per
       * resource you might want to lower this number to gain some initial rendering performance.
       *
       * Specify a falsy value to opt out of row height pre-calculation.
       *
       * @config {Number}
       * @default
       * @category Layout
       */
      preCalculateHeightLimit: 10000,
      crudManagerClass: _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_3__["default"],
      testConfig: {
        loadMaskError: {
          autoClose: 10,
          showDelay: 0
        }
      }
    };
  }

  static get deprecatedEvents() {
    return {
      eventContextMenuBeforeShow: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`eventContextMenuBeforeShow` event is deprecated, in favor of `eventMenuBeforeShow` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      },
      eventContextMenuShow: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`eventContextMenuShow` event is deprecated, in favor of `eventMenuShow` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      },
      eventContextMenuItem: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`eventContextMenuItem` event is deprecated, in favor of `eventMenuItem` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      },
      scheduleContextMenuBeforeShow: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`scheduleContextMenuBeforeShow` event is deprecated, in favor of `scheduleMenuBeforeShow` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      },
      scheduleContextMenuShow: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`scheduleContextMenuShow` event is deprecated, in favor of `scheduleMenuShow` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      },
      scheduleContextMenuItem: {
        product: 'Scheduler',
        invalidAsOfVersion: '5.0.0',
        message: '`scheduleContextMenuItem` event is deprecated, in favor of `scheduleMenuItem` event. Please see https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.1.0 for more information.'
      }
    };
  } //endregion
  //region Events

  /**
   * Fired after rendering an event, when its element is available in DOM.
   * @event renderEvent
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord The event record
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment record
   * @param {Object} renderData An object containing details about the event rendering, see
   *   {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventRenderer} for details
   * @param {Object} tplData DEPRECATED 4.0: Use renderData instead
   * @param {Boolean} isRepaint `true` if this render is a repaint of the event, updating its existing element
   * @param {Boolean} isReusingElement `true` if this render lead to the event reusing a released events element
   * @param {HTMLElement} element The events element
   */

  /**
   * Fired after releasing an event, useful to cleanup of custom content added on `renderEvent` or in `eventRenderer`.
   * @event releaseEvent
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord The event record
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment record
   * @param {Object} renderData An object containing details about the event rendering
   * @param {HTMLElement} element The events element
   */

  /**
   * Fired when clicking a resource header cell
   * @event resourceHeaderClick
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Event} event The event
   */

  /**
   * Fired when double clicking a resource header cell
   * @event resourceHeaderDblclick
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Event} event The event
   */

  /**
   * Fired when activating context menu on a resource header cell
   * @event resourceHeaderContextmenu
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Event} event The event
   */

  /**
   * Triggered when a keydown event is observed if there are selected events.
   * @event eventKeyDown
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel[]} eventRecord The selected event records
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecord The selected assignment records
   * @param {KeyboardEvent} event Browser event
   */

  /**
   * Triggered when a keyup event is observed if there are selected events.
   * @event eventKeyUp
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel[]} eventRecord The selected event records
   * @param {Scheduler.model.AssignmentModel[]} assignmentRecord The selected assignment records
   * @param {KeyboardEvent} event Browser event
   */
  //endregion
  //region Functions injected by features
  // For documentation & typings purposes

  /**
   * Opens an editor UI to edit the passed event.
   *
   * *NOTE: Only available when the {@link Scheduler/feature/EventEdit EventEdit} feature is enabled.*
   *
   * @function editEvent
   * @param {Scheduler.model.EventModel} eventRecord Event to edit
   * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
   * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
   * multi assignment.
   * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
   * @category Feature shortcuts
   */

  /**
   * Returns the dependency record for a DOM element
   *
   * *NOTE: Only available when the {@link Scheduler/feature/Dependencies Dependencies} feature is enabled.*
   *
   * @function resolveDependencyRecord
   * @param {HTMLElement} element The dependency line element
   * @return {Scheduler.model.DependencyModel} The dependency record
   * @category Feature shortcuts
   */
  //endregion
  //region Init


  afterConstruct() {
    const me = this;
    super.afterConstruct();
    me.on('scroll', me.onVerticalScroll, me);

    if (me.createEventOnDblClick) {
      me.on('scheduledblclick', me.onTimeAxisCellDblClick);
    }
  } //endregion
  //region Config getters/setters
  // Placeholder getter/setter for mixins, please make any changes needed to SchedulerStores#store instead


  get store() {
    return super.store;
  }

  set store(store) {
    super.store = store;
  }
  /**
   * Returns an object defining the range of visible resources
   * @property {Object}
   * @property {Number} visibleResources.first First visible resource
   * @property {Number} visibleResources.last Last visible resource
   * @readonly
   */


  get visibleResources() {
    const me = this;

    if (me.isVertical) {
      return me.currentOrientation.visibleResources;
    }

    return {
      first: me.store.getById(me.firstVisibleRow.id),
      last: me.store.getById(me.lastVisibleRow.id)
    };
  } //endregion
  //region Event handlers


  onLocaleChange() {
    this.currentOrientation.onLocaleChange();
    super.onLocaleChange();
  }

  onTimeAxisCellDblClick({
    date: startDate,
    resourceRecord,
    row
  }) {
    const me = this;

    if (me.readOnly || resourceRecord.isSpecialRow) {
      return;
    }

    me.internalAddEvent(startDate, resourceRecord, row);
  }

  onVerticalScroll({
    scrollTop
  }) {
    this.currentOrientation.updateFromVerticalScroll(scrollTop);
  }
  /**
   * Called when new event is created.
   * Сan be overriden to supply default record values etc.
   * @param {Scheduler.model.EventModel} eventRecord Newly created event
   */


  onEventCreated(eventRecord) {} //endregion
  //region Mode

  /**
   * Checks if scheduler is in horizontal mode
   * @returns {Boolean}
   * @readonly
   * @category Common
   * @private
   */


  get isHorizontal() {
    return this.mode === 'horizontal';
  }
  /**
   * Checks if scheduler is in vertical mode
   * @returns {Boolean}
   * @readonly
   * @category Common
   * @private
   */


  get isVertical() {
    return this.mode === 'vertical';
  }
  /**
   * Get mode (horizontal/vertical)
   * @property {String}
   * @readonly
   * @category Common
   */


  get mode() {
    return this._mode;
  }

  set mode(mode) {
    const me = this;
    me._mode = mode;

    if (!me[mode]) {
      me.element.classList.add(`b-sch-${mode}`);

      if (mode === 'horizontal') {
        me.horizontal = new _orientation_HorizontalRendering_js__WEBPACK_IMPORTED_MODULE_15__["default"](me);

        if (me.isPainted) {
          me.horizontal.init();
        }
      } else if (mode === 'vertical') {
        me.vertical = new _orientation_VerticalRendering_js__WEBPACK_IMPORTED_MODULE_16__["default"](me);

        if (me.rendered) {
          me.vertical.init();
        }
      }
    }
  }

  get currentOrientation() {
    return this[this.mode];
  } //endregion
  //region Dom event dummies
  // this is ugly, but needed since super cannot be called from SchedulerDomEvents mixin...


  onElementKeyDown(event) {
    super.onElementKeyDown(event);
  }

  onElementKeyUp(event) {
    super.onElementKeyUp(event);
  }

  onElementMouseOver(event) {
    super.onElementMouseOver(event);
  }

  onElementMouseOut(event) {
    super.onElementMouseOut(event);
  } //endregion
  //region Feature hooks

  /**
   * Populates the event context menu. Chained in features to add menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown.
   * @param {Scheduler.model.EventModel} options.eventRecord The context event.
   * @param {Scheduler.model.ResourceModel} options.resourceRecord The context resource.
   * @param {Scheduler.model.AssignmentModel} options.assignmentRecord The context assignment if any.
   * @param {Object} options.items A named object to describe menu items.
   * @internal
   */


  populateEventMenu() {}
  /**
   * Populates the time axis context menu. Chained in features to add menu items.
   * @param {Object} options Contains menu items and extra data retrieved from the menu target.
   * @param {Grid.column.Column} options.column Column for which the menu will be shown.
   * @param {Scheduler.model.ResourceModel} options.resourceRecord The context resource.
   * @param {Date} options.date The Date corresponding to the mouse position in the time axis.
   * @param {Object} options.items A named object to describe menu items.
   * @internal
   */


  populateScheduleMenu() {} // Called when visible date range changes


  onVisibleDateRangeChange() {} // Called when visible resource range changes in vertical mode


  onVisibleResourceRangeChange() {} //endregion
  //region Scheduler specific date mapping functions
  // Method is chained by event editing features. Ensure that the event is in the store.


  editEvent(eventRecord, resourceRecord, element) {
    const me = this,
          {
      eventStore,
      assignmentStore,
      features
    } = me,
          {
      eventEdit,
      taskEdit,
      simpleEventEdit
    } = features,
          eventEditAvailable = Boolean(eventEdit && !eventEdit.disabled || taskEdit && !taskEdit.disabled || simpleEventEdit && !simpleEventEdit.disabled); // Abort the chain if no event editing features available

    if (!eventEditAvailable) {
      return false;
    }

    if (eventRecord.eventStore !== eventStore) {
      const {
        enableEventAnimations
      } = me,
            resourceRecords = []; // It's only a provisional event because we are going to edit it which will
      // allow an opportunity to cancel the add (by removing it).

      eventRecord.isCreating = true;
      let assignments = null;

      if (resourceRecord) {
        resourceRecords.push(resourceRecord);
        assignments = assignmentStore.assignEventToResource(eventRecord, resourceRecord);
      } // Vetoable beforeEventAdd allows cancel of this operation
      // TODO REMOVE FOR 5.0 (resources is deprecated)


      if (me.trigger('beforeEventAdd', {
        eventRecord,
        resourceRecords,
        resources: resourceRecords
      }) === false) {
        // Remove any assignment created above, to leave store as it was
        if (assignments) {
          assignmentStore.remove(assignments);
        }

        return false;
      }

      me.enableEventAnimations = false;
      eventStore.add(eventRecord);
      me.project.commitAsync().then(() => me.enableEventAnimations = enableEventAnimations); // Element must be created synchronously, not after the project's normalizing delays.

      me.refreshRows();
    }
  }

  async internalAddEvent(startDate, resourceRecord, row) {
    const me = this,
          {
      enableEventAnimations,
      features,
      eventStore,
      assignmentStore
    } = me,
          resourceRecords = [resourceRecord],
          useEventModelDefaults = me.createEventOnDblClick.useEventModelDefaults,
          defaultDuration = useEventModelDefaults ? eventStore.modelClass.fieldMap.duration.defaultValue : 1,
          defaultDurationUnit = useEventModelDefaults ? eventStore.modelClass.fieldMap.durationUnit.defaultValue : me.timeAxis.unit,
          eventRecord = eventStore.createRecord({
      startDate,
      endDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, defaultDuration, defaultDurationUnit),
      duration: defaultDuration,
      durationUnit: defaultDurationUnit,
      name: me.L('L{Object.newEvent}')
    }),
          eventEditAvailable = Boolean(features.eventEdit && !features.eventEdit.disabled || features.taskEdit && !features.taskEdit.disabled || features.simpleEventEdit && !features.simpleEventEdit.disabled); // It's only a provisional event if there is an event edit feature available to
    // cancel the add (by removing it). Otherwise it's a definite event creation.

    eventRecord.isCreating = eventEditAvailable;
    me.onEventCreated(eventRecord);
    let assignments = null;

    if (assignmentStore) {
      assignments = assignmentStore.assignEventToResource(eventRecord, resourceRecord);
    }
    /**
     * Fires before an event is added. Can be triggered by schedule double click or drag create action.
     * @event beforeEventAdd
     * @param {Scheduler.view.Scheduler} source The Scheduler instance
     * @param {Scheduler.model.EventModel} eventRecord The record about to be added
     * @param {Scheduler.model.ResourceModel[]} resources **Deprecated 4.0** Use `resourceRecords` instead
     * @param {Scheduler.model.ResourceModel[]} resourceRecords Resources that the record is assigned to
     * @preventable
     */


    if (me.trigger('beforeEventAdd', {
      eventRecord,
      resourceRecords,
      resources: resourceRecords
    }) === false) {
      // Remove any assignment created above, to leave store as it was
      if (assignments) {
        assignmentStore.remove(assignments);
      }

      return;
    }

    me.enableEventAnimations = false;
    eventStore.add(eventRecord);
    me.project.commitAsync().then(() => me.enableEventAnimations = enableEventAnimations); // Element must be created synchronously, not after the project's normalizing delays.

    me.refreshRows();

    if (eventEditAvailable) {
      me.editEvent(eventRecord, resourceRecord, me.getEventElement(eventRecord));
    }
  }
  /**
   * Checks if a date range is allocated or not for a given resource.
   * @param {Date} start The start date
   * @param {Date} end The end date
   * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
   * @param {Scheduler.model.ResourceModel} resource The resource
   * @return {Boolean} True if the timespan is available for the resource
   * @category Dates
   */


  isDateRangeAvailable(start, end, excludeEvent, resource) {
    return this.eventStore.isDateRangeAvailable(start, end, excludeEvent, resource);
  } //endregion

  /**
   * Suspends UI refresh on store operations.
   *
   * Multiple calls to `suspendRefresh` stack up, and will require an equal number of `resumeRefresh` calls to
   * actually resume UI refresh.
   *
   * @function suspendRefresh
   */

  /**
   * Resumes UI refresh on store operations.
   *
   * Multiple calls to `suspendRefresh` stack up, and will require an equal number of `resumeRefresh` calls to
   * actually resume UI refresh.
   *
   * Specify `true` as the first param to trigger a refresh if this call unblocked the refresh suspension.
   * If the underlying project is calculating changes, the refresh will be postponed until it is done.
   *
   * @param {Boolean} trigger `true` to trigger a refresh, if this resume unblocks the suspend
   * @returns {Promise}
   */


  async resumeRefresh(trigger) {
    super.resumeRefresh(false);
    const me = this;

    if (!me.refreshSuspended && trigger) {
      // Do not refresh until project is in a valid state
      if (!me.isEngineReady) {
        // Refresh will happen because of the commit, bail out of this one after forcing rendering to consider
        // next one a full refresh
        me.currentOrientation.refreshAllWhenReady = true;
        return me.project.commitAsync();
      } // View could've been destroyed while we waited for engine


      if (!me.isDestroyed) {
        // If it already is, refresh now
        me.refreshWithTransition();
      }
    }
  } //region Appearance
  // Overrides grid to take crudManager loading into account


  toggleEmptyText() {
    const me = this;

    if (me.bodyContainer) {
      var _me$crudManager;

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toggleClasses(me.bodyContainer, 'b-grid-empty', !(me.resourceStore.count > 0 || (_me$crudManager = me.crudManager) !== null && _me$crudManager !== void 0 && _me$crudManager.isLoading));
    }
  } // Overrides Grids base implementation to return a correctly calculated height for the row. Also stores it in
  // RowManagers height map, which is used to calculate total height etc.


  getRowHeight(resourceRecord) {
    if (this.currentOrientation.calculateRowHeight) {
      const height = this.currentOrientation.calculateRowHeight(resourceRecord);
      this.rowManager.storeKnownHeight(resourceRecord.id, height);
      return height;
    }
  } // Calculates the height for specified rows. Call when changes potentially makes its height invalid


  calculateRowHeights(resourceRecords, silent = false) {
    // Array allowed to have nulls in it for easier code when calling this fn
    resourceRecords.forEach(resourceRecord => resourceRecord && this.getRowHeight(resourceRecord));

    if (!silent) {
      this.rowManager.estimateTotalHeight(true);
    }
  } // Calculate heights for all rows (up to the preCalculateHeightLimit)


  calculateAllRowHeights(silent = false) {
    const {
      store,
      rowManager
    } = this,
          count = Math.min(store.count, this.preCalculateHeightLimit); // Allow opt out by specifying falsy value.

    if (count) {
      rowManager.clearKnownHeights();

      for (let i = 0; i < count; i++) {
        // This will both calculate and store the height
        this.getRowHeight(store.getAt(i));
      } // Make sure height is reflected on scroller etc.


      if (!silent) {
        rowManager.estimateTotalHeight(true);
      }
    }
  } //endregion
  //region Calendar Mode Interface
  // These are all internal and match up w/CalendarMixin


  get description() {
    return this.callback(this.descriptionRenderer, this, [this]);
  }

  getEventRecord(target) {
    target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getEventElement(target);
    return this.resolveEventRecord(target);
  }

  getEventElement(eventRecord) {
    return this.getElementFromEventRecord(eventRecord);
  }

  changeRange(unit) {
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].normalizeUnit(unit);
  }

  updateRange(unit) {
    if (!this.isConfiguring) {
      const currentDate = this.date,
            newDate = this.date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(currentDate, unit); // Force a span update if changing the range did not change the date

      if (currentDate.getTime() === newDate.getTime()) {
        this.updateDate(newDate);
      }
    }
  }

  changeStepUnit(unit) {
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].normalizeUnit(unit);
  }

  updateDate(newDate) {
    const me = this,
          start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(newDate, me.range);
    me.setTimeSpan(start, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(start, 1, me.range)); // Cant always use newDate here in case timeAxis is filtered

    me.visibleDate = {
      date: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(newDate, me.timeAxis.startDate),
      block: 'start',
      animate: true
    };
    me.trigger('descriptionChange');
  }

  previous() {
    this.date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(this.date, -1, this.stepUnit);
  }

  next() {
    this.date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(this.date, 1, this.stepUnit);
  } //endregion


} // Register this widget type with its Factory

SchedulerBase.initClass(); // Scheduler version is specified in TimelineBase because Gantt extends it

SchedulerBase._$name = 'SchedulerBase';

/***/ }),

/***/ "./lib/Scheduler/view/TimeAxisBase.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/view/TimeAxisBase.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisBase; });
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';


/**
 * @module Scheduler/view/TimeAxisBase
 */

function isLastLevel(level, levels) {
  return level === levels.length - 1;
}

function isLastCell(level, cell) {
  return cell === level.cells[level.cells.length - 1];
}
/**
 * Base class for HorizontalTimeAxis and VerticalTimeAxis. Contains shared functionality to only render ticks in view,
 * should not be used directly.
 *
 * @extends Core/widget/Widget
 * @private
 * @abstract
 */


class TimeAxisBase extends _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TimeAxisBase';
  } //region Config


  static get configurable() {
    return {
      /**
       * The minimum width for a bottom row header cell to be considered 'compact', which adds a special CSS class
       * to the row (for special styling). Copied from Scheduler/Gantt.
       * @config {Number}
       * @default
       */
      compactCellWidthThreshold: 15,
      // TimeAxisViewModel
      model: null,
      cls: null,

      /**
       * Style property to use as cell size. Either width or height depending on orientation
       * @config {String}
       * @private
       */
      sizeProperty: null,

      /**
       * Style property to use as cells position. Either left or top depending on orientation
       * @config {String}
       * @private
       */
      positionProperty: null
    };
  }

  static get properties() {
    return {
      startDate: null,
      endDate: null,
      levels: [],
      size: null
    };
  } // Set visible date range


  set range({
    startDate,
    endDate
  }) {
    // Only process a change
    if (this.startDate - startDate || this.endDate - endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.refresh(true);
    }
  } //endregion
  //region Html & rendering
  // Generates element configs for all levels defined by the current ViewPreset


  buildCells() {
    var _me$client;

    const me = this,
          {
      sizeProperty
    } = me,
          {
      stickyHeaders,
      isVertical
    } = me.client || {},
          featureHeaderConfigs = [],
          {
      length
    } = me.levels,
          cellConfigs = me.levels.map((level, i) => {
      var _level$cells;

      const stickyHeader = stickyHeaders && (isVertical || i < length - 1);
      return {
        className: {
          'b-sch-header-row': 1,
          [`b-sch-header-row-${level.position}`]: 1,
          'b-sch-header-row-main': i === me.model.viewPreset.mainHeaderLevel,
          'b-lowest': isLastLevel(i, me.levels),
          'b-sticky-header': stickyHeader
        },
        syncOptions: {
          // Keep a maximum of 5 released cells. Might be fine with fewer since ticks are fixed width.
          // Prevents an unnecessary amount of cells from sticking around when switching from narrow to
          // wide tickSizes
          releaseThreshold: 5,
          syncIdField: 'tickIndex'
        },
        dataset: {
          headerFeature: `headerRow${i}`,
          headerPosition: level.position
        },
        // Only include cells in view
        children: (_level$cells = level.cells) === null || _level$cells === void 0 ? void 0 : _level$cells.filter(cell => cell.start < me.endDate && cell.end > me.startDate).map(cell => ({
          className: {
            'b-sch-header-timeaxis-cell': 1,
            [cell.headerCellCls]: cell.headerCellCls,
            [`b-align-${cell.align}`]: cell.align,
            'b-last': isLastCell(level, cell)
          },
          dataset: _objectSpread({
            tickIndex: cell.index
          }, window.DEBUG && {
            date: cell.start.getTime()
          }),
          style: {
            // DomHelper appends px to numeric dimensions
            [me.positionProperty]: cell.coord,
            [sizeProperty]: cell.width,
            [`min-${sizeProperty}`]: cell.width
          },
          children: [{
            tag: 'span',
            className: {
              'b-sch-header-text': 1,
              'b-sticky-header': stickyHeader
            },
            html: cell.value
          }]
        }))
      };
    }); // When tested in isolation there is no client

    (_me$client = me.client) === null || _me$client === void 0 ? void 0 : _me$client.getHeaderDomConfigs(featureHeaderConfigs);
    cellConfigs.push(...featureHeaderConfigs); // noinspection JSSuspiciousNameCombination

    return {
      className: me.widgetClassList,
      syncOptions: {
        // Do not keep entire levels no longer used, for example after switching view preset
        releaseThreshold: 0
      },
      children: cellConfigs
    };
  }

  render(targetElement) {
    super.render(targetElement);
    this.refresh(true);
  }
  /**
   * Refresh the UI
   * @param {Boolean} [rebuild] Specify `true` to force a rebuild of the underlying header level definitions
   */


  refresh(rebuild = !this.levels.length) {
    const me = this,
          {
      columnConfig
    } = me.model,
          {
      levels
    } = me,
          oldLevelsCount = levels.length;

    if (rebuild) {
      levels.length = 0;
      columnConfig.forEach((cells, position) => levels[position] = {
        position,
        cells
      });
      me.size = levels[0].cells.reduce((sum, cell) => sum += cell.width, 0); // TODO clean up when this is fixed: https://app.assembla.com/spaces/bryntum/tickets/8413-horizontaltimeaxis-should-not-completely-overwrite-contents-of-column-el/details#

      const parentEl = me.element.parentElement; // Don't mutate a classList unless necessary. Browsers invalidate the style.

      if (parentEl && (levels.length !== oldLevelsCount || rebuild)) {
        parentEl.classList.remove(`b-sch-timeaxiscolumn-levels-${oldLevelsCount}`);
        parentEl.classList.add(`b-sch-timeaxiscolumn-levels-${levels.length}`);
      }
    }

    if (!me.startDate || !me.endDate) {
      return;
    } // Boil down levels to only show what is in view


    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].sync({
      domConfig: me.buildCells(),
      targetElement: me.element,
      syncIdField: 'headerFeature'
    });
    me.trigger('refresh');
  } //endregion
  // Our widget class doesn't include "base".


  get widgetClass() {
    return 'b-timeaxis';
  }

}
TimeAxisBase._$name = 'TimeAxisBase';

/***/ }),

/***/ "./lib/Scheduler/view/TimeAxisSubGrid.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/view/TimeAxisSubGrid.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisSubGrid; });
/* harmony import */ var _Grid_view_SubGrid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/view/SubGrid.js */ "./lib/Grid/view/SubGrid.js");
/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Header.js */ "./lib/Scheduler/view/Header.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/view/TimeAxisSubGrid
 */

/**
 * Widget that encapsulates the SubGrid part of the scheduler which houses the timeline view.
 * @extends Grid/view/SubGrid
 * @private
 */

class TimeAxisSubGrid extends _Grid_view_SubGrid_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TimeAxisSubGrid';
  } // Factoryable type name


  static get type() {
    return 'timeaxissubgrid';
  }

  static get configurable() {
    return {
      // A Scheduler's SubGrid doesn't accept external columns moving in
      sealedColumns: true,
      // Use Scheduler's Header class
      headerClass: _Header_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

  startConfigure(config) {
    const {
      grid: scheduler
    } = config; // Scheduler references its TimeAxisSubGrid instance through this property.

    scheduler.timeAxisSubGrid = this;
    super.startConfigure(config);

    if (scheduler.isHorizontal) {
      config.header = {
        cls: {
          'b-sticky-headers': scheduler.stickyHeaders
        }
      }; // We don't use what the GridSubGrids mixin tells us to.
      // We use the Sheduler's Header class.

      delete config.headerClass;
    } // If user have not specified a width or flex for scheduler region, default to flex=1


    if (!('flex' in config || 'width' in config)) {
      config.flex = 1;
    }
  }

  changeScrollable() {
    const me = this,
          scrollable = super.changeScrollable(...arguments); // TimeAxisSubGrid's X axis is stretched by its canvas.
    // We don't need the Scroller's default stretching implementation.

    if (scrollable) {
      Object.defineProperty(scrollable, 'scrollWidth', {
        get() {
          var _this$element$scrollW, _this$element;

          return (_this$element$scrollW = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.scrollWidth) !== null && _this$element$scrollW !== void 0 ? _this$element$scrollW : 0;
        },

        set() {
          // Setting the scroll width to be wide just updates the canvas side in Scheduler.
          // We do not need the Scroller's default stretcher element to be added.
          // Note that "me" here is the TimeAxisSubGrid, so we are calling Scheduler.
          me.grid.updateCanvasSize();
        }

      });
    }

    return scrollable;
  }

  syncScrollingPartners(addCls = true) {
    // Swallow scroll syncing calls that happen during view preset changes, that process triggers multiple when
    // it first changes tickWidth, then scrolls to center and then an additional sync on scroll end
    if (!this.grid._viewPresetChanging) {
      super.syncScrollingPartners(addCls);
    }
  }
  /**
   * This is an event handler triggered when the TimeAxisSubGrid changes size.
   * Its height changes when content height changes, and that is not what we are
   * interested in here. If the *width* changes, that means the visible viewport
   * has changed size.
   * @param {HTMLElement} element
   * @param {Number} width
   * @param {Number} height
   * @param {Number} oldWidth
   * @param {Number} oldHeight
   * @private
   */


  onInternalResize(element, width, height, oldWidth, oldHeight) {
    const me = this; // We, as the TimeAxisSubGrid dictate the scheduler viewport width

    if (me.isPainted && width !== oldWidth) {
      const scheduler = me.grid,
            bodyHeight = scheduler._bodyRectangle.height; // Avoid ResizeObserver errors when this operation may create a scrollbar

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollBarWidth && width < oldWidth) {
        me.monitorResize = false;
      }

      scheduler.onSchedulerViewportResize(width, bodyHeight, oldWidth, bodyHeight); // Revert to monitoring on the next animation frame.
      // This is to avoid "ResizeObserver loop completed with undelivered notifications."

      if (!me.monitorResize) {
        me.requestAnimationFrame(() => me.monitorResize = true);
      }
    }

    super.onInternalResize(...arguments);
  }

} // Register this widget type with its Factory

TimeAxisSubGrid.initClass();
TimeAxisSubGrid._$name = 'TimeAxisSubGrid';

/***/ }),

/***/ "./lib/Scheduler/view/TimelineBase.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/view/TimelineBase.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimelineBase; });
/* harmony import */ var _Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/view/GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");
/* harmony import */ var _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./model/TimeAxisViewModel.js */ "./lib/Scheduler/view/model/TimeAxisViewModel.js");
/* harmony import */ var _mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/TimelineDateMapper.js */ "./lib/Scheduler/view/mixin/TimelineDateMapper.js");
/* harmony import */ var _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/TimelineDomEvents.js */ "./lib/Scheduler/view/mixin/TimelineDomEvents.js");
/* harmony import */ var _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/TimelineViewPresets.js */ "./lib/Scheduler/view/mixin/TimelineViewPresets.js");
/* harmony import */ var _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./mixin/TimelineZoomable.js */ "./lib/Scheduler/view/mixin/TimelineZoomable.js");
/* harmony import */ var _mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./mixin/RecurringEvents.js */ "./lib/Scheduler/view/mixin/RecurringEvents.js");
/* harmony import */ var _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./mixin/TimelineEventRendering.js */ "./lib/Scheduler/view/mixin/TimelineEventRendering.js");
/* harmony import */ var _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./mixin/TimelineScroll.js */ "./lib/Scheduler/view/mixin/TimelineScroll.js");
/* harmony import */ var _TimeAxisSubGrid_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./TimeAxisSubGrid.js */ "./lib/Scheduler/view/TimeAxisSubGrid.js");
var productName = 'gantt';





















const timeAxisColumnConfigs = ['viewPreset', 'eventBarTextField', 'eventRenderer', 'eventRendererThisObj', 'eventBodyTemplate'],
      exitTransition = {
  fn: 'exitTransition',
  delay: 0,
  cancelOutstanding: true
},
      emptyObject = {};
/**
 * @module Scheduler/view/TimelineBase
 */

/**
 * Abstract base class used by timeline based components such as Scheduler and Gantt. Based on Grid, supplies a "locked"
 * region for columns and a "normal" for rendering of events etc.
 * @abstract
 *
 * @mixes Scheduler/view/mixin/TimelineDateMapper
 * @mixes Scheduler/view/mixin/TimelineDomEvents
 * @mixes Scheduler/view/mixin/TimelineEventRendering
 * @mixes Scheduler/view/mixin/TimelineScroll
 * @mixes Scheduler/view/mixin/TimelineViewPresets
 * @mixes Scheduler/view/mixin/TimelineZoomable
 * @mixes Scheduler/view/mixin/RecurringEvents
 *
 * @extends Grid/view/Grid
 */

class TimelineBase extends _Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_13__["default"], _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_14__["default"], _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_19__["default"], _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_15__["default"], _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_17__["default"]) {
  //region Config
  static get $name() {
    return 'TimelineBase';
  } // Factoryable type name


  static get type() {
    return 'timelinebase';
  }

  static get configurable() {
    return {
      partnerSharedConfigs: {
        value: ['timeAxisViewModel', 'timeAxis', 'viewPreset'],
        $config: {
          merge: 'distinct'
        }
      },

      /**
       * Get/set startDate. Defaults to current date if none specified.
       *
       * **Note:** If you need to set start and end date at the same time, use {@link #function-setTimeSpan} method.
       * @member {Date} startDate
       * @category Common
       */

      /**
       * The start date of the timeline. If omitted, and a TimeAxis has been set, the start date of the provided
       * {@link Scheduler.data.TimeAxis} will be used. If no TimeAxis has been configured, it'll use the start/end
       * dates of the loaded event dataset. If no date information exists in the event data set, it defaults to
       * the current date and time.
       *
       * If a string is supplied, it will be parsed using
       * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}
       *
       * **Note:** If you need to set start and end date at the same time, use the {@link #function-setTimeSpan} method.
       * @config {Date|String}
       * @category Common
       */
      startDate: {
        $config: {
          equal: 'date'
        },
        value: null
      },

      /**
       * Get/set endDate. Defaults to startDate + default span of the used ViewPreset.
       *
       * **Note:** If you need to set start and end date at the same time, use {@link #function-setTimeSpan} method.
       * @member {Date} endDate
       * @category Common
       */

      /**
       * The end date of the timeline. If omitted, it will be calculated based on the {@link #config-startDate}
       * setting and the 'defaultSpan' property of the current
       * {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}.
       *
       * If a string is supplied, it will be parsed using
       * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}
       *
       * **Note:** If you need to set start and end date at the same time, use the {@link #function-setTimeSpan} method.
       * @config {Date|String}
       * @category Common
       */
      endDate: {
        $config: {
          equal: 'date'
        },
        value: null
      },

      /**
       * When set, the text in the major time axis header sticks in the scrolling viewport as long as possible.
       * @config {Boolean}
       * @default
       */
      stickyHeaders: true,

      /**
       * A date to bring into view initially on the scrollable timeline. Either a date or an object describing
       * the scroll action, see {@link #function-scrollToDate} for reference.
       * @config {Date|Object}
       * @category Common
       */
      visibleDate: null
    };
  }

  static get defaultConfig() {
    return {
      /**
       * A valid JS day index between 0-6 (0: Sunday, 1: Monday etc.) to be considered the start day of the week.
       * When omitted, the week start day is retrieved from the active locale class.
       * @config {Number} weekStartDay
       * @category Time axis
       */

      /**
       * An object with format `{ fromDay, toDay, fromHour, toHour }` that describes the working days and hours.
       * This object will be used to populate TimeAxis {@link Scheduler.data.TimeAxis#config-include} property.
       *
       * Using it results in a non-continuous time axis. Any ticks not covered by the working days and hours will
       * be excluded. Events within larger ticks (for example if using week as the unit for ticks) will be
       * stretched to fill the gap otherwise left by the non working hours.
       *
       * As with end dates, `toDay` and `toHour` are exclusive. Thus `toDay : 6` means that day 6 (saturday) will
       * not be included.
       *
       *
       * **NOTE:** When this feature is enabled {@link Scheduler.view.mixin.TimelineZoomable Zooming feature} is
       * not supported. It's recommended to disable zooming controls:
       *
       * ```javascript
       * new Scheduler({
       *     zoomOnMouseWheel          : false,
       *     zoomOnTimeAxisDoubleClick : false,
       *     ...
       * });
       * ```
       *
       * @config {Object}
       * @category Time axis
       */
      workingTime: null,

      /**
       * A backing data store of 'ticks' providing the input date data for the time axis of timeline panel.
       * @member {Scheduler.data.TimeAxis} timeAxis
       * @readonly
       * @category Time axis
       */

      /**
       * A {@link Scheduler.data.TimeAxis} config object or instance, used to create a backing data store of
       * 'ticks' providing the input date data for the time axis of timeline panel. Created automatically if none
       * supplied.
       * @config {Object|Scheduler.data.TimeAxis}
       * @category Time axis
       */
      timeAxis: null,

      /**
       * The backing view model for the visual representation of the time axis.
       * Either a real instance or a simple config object.
       * @private
       * @config {Scheduler.view.model.TimeAxisViewModel|Object}
       * @category Time axis
       */
      timeAxisViewModel: null,

      /**
       * You can set this option to `false` to make the timeline panel start and end on the exact provided
       * {@link #config-startDate}/{@link #config-endDate} w/o adjusting them.
       * @config {Boolean}
       * @default
       * @category Time axis
       */
      autoAdjustTimeAxis: true,

      /**
       * true to snap to resolution increment while interacting with scheduled events.
       * @config {Boolean}
       * @default
       * @category Scheduled events
       */
      snap: false,

      /**
       * Affects drag drop and resizing of events when {@link #config-snap} is enabled. If set to `true`, dates
       * will be snapped relative to event start. e.g. for a zoom level with timeResolution = { unit: "s",
       * increment: "20" }, an event that starts at 10:00:03 and is dragged would snap its start date to 10:00:23,
       * 10:00:43 etc. When set to `false`, dates will be snapped relative to the timeAxis startDate (tick start)
       * - 10:00:03, 10:00:20, 10:00:40 etc.
       * @config {Boolean}
       * @default
       * @category Scheduled events
       */
      snapRelativeToEventStartDate: false,

      /**
       * Set to `true` to force the time columns to fit to the available space (horizontal or vertical depends on mode).
       * Note that setting {@link #config-suppressFit} on `true`, will disable `forceFit` functionality.
       * @config {Boolean}
       * @default
       * @category Time axis
       */
      forceFit: false,

      /**
       * Set to `true` to prevent auto calculating of a minimal {@link Scheduler.view.mixin.TimelineEventRendering#property-tickSize}
       * to always fit the content to the screen size. Setting this property on `true` will disable {@link #config-forceFit} behaviour.
       * @config {Boolean}
       * @default false
       * @category Time axis
       */
      suppressFit: false,

      /**
       * CSS class to add to rendered events
       * @config {String}
       * @category CSS
       * @private
       */
      eventCls: null,

      /**
       * Returns dates that will constrain resize and drag operations. The method will be called with the
       * Resource, and the event being resized or dragged.
       * @param {Scheduler.model.ResourceModel} resourceRecord The resource row in which the operation is taking place.
       * @param {Scheduler.model.EventModel} eventRecord The event record being moved or resized.
       * @return {Object} Constraining object containing `start` and `end` constraints. Omitting either
       * will mean that end is not constrained. So you can prevent a resize or move from moving *before*
       * a certain time while not constraining the end date.
       * @return {Date} [return.start] Start date
       * @return {Date} [return.end] End date
       * @config {Function}
       * @category Scheduled events
       */
      getDateConstraints: null,

      /**
       * CSS class to add to cells in the timeaxis column
       * @config {String}
       * @category CSS
       * @private
       */
      timeCellCls: null,
      timeCellSelector: null,
      scheduledEventName: null,
      //dblClickTime : 200,

      /**
       * A CSS class to apply to each event in the view on mouseover.
       * @config {String}
       * @category CSS
       * @private
       */
      overScheduledEventClass: null,
      // allow the panel to prevent adding the hover CSS class in some cases - during drag drop operations
      preventOverCls: false,
      // The last hovered over event bar HTML node
      hoveredEventNode: null,
      // This setting is set to true by features that need it
      useBackgroundCanvas: false,

      /**
       * Set to `false` if you don't want event bar DOM updates to animate. Animations are disabled in IE11 by default.
       * @config {Boolean}
       * @default true
       * @category Scheduled events
       */
      enableEventAnimations: !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11,
      disableGridRowModelWarning: true,
      // does not look good with locked columns and also interferes with event animations
      animateRemovingRows: false,

      /**
       * Partners this Timeline panel with another Timeline in order to sync their region sizes (sub-grids like locked, normal will get the same width),
       * start and end dates, view preset, zoom level and scrolling position. All these values will be synced with the timeline defined as the `partner`.
       *
       * - To add a new partner dynamically see {@link #function-addPartner} method.
       * - To remove existing partner see {@link #function-removePartner} method.
       * - To check if timelines are partners see {@link #function-isPartneredWith} method.
       *
       * @config {Scheduler.view.TimelineBase}
       * @category Time axis
       */
      partner: null,
      schedulerRegion: 'normal',
      transitionDuration: 200,
      // internal timer id reference
      animationTimeout: null,

      /**
       * Region to which columns are added when they have none specified
       * @config {String}
       * @default
       * @category Misc
       */
      defaultRegion: 'locked',

      /**
       * Decimal precision used when displaying durations, used by tooltips and DurationColumn.
       * Specify `false` to use raw value
       * @config {Number|Boolean}
       * @default
       * @category Common
       */
      durationDisplayPrecision: 1,
      asyncEventSuffix: 'PreCommit',
      viewportResizeTimeout: 250
      /**
       * An object with configuration for the {@link Scheduler.column.TimeAxisColumn} in horizontal
       * {@link Scheduler.view.SchedulerBase#config-mode}. Object with {@link Scheduler.column.TimeAxisColumn}
       *
       * Example:
       *
       * ```javascript
       * new Scheduler({
       *     timeAxisColumn : {
       *         renderer : ({ record, cellElement }) => {
       *             // output some markup as a layer below the events layer, you can draw a chart for example
       *         }
       *     },
       *     ...
       * });
       * ```
       *
       * @config {Object}
       * @category Time axis
       */

    };
  } //endregion
  //region Init


  construct(config = {}) {
    const me = this;
    super.construct(config);
    me.$firstVerticalOverflow = true;
    me.initDomEvents();
    me.currentOrientation.init();
    me.rowManager.on('refresh', () => {
      me.forceLayout = false;
    });
  } // Override from Grid.view.GridSubGrids


  createSubGrid(region, config = {}) {
    const me = this,
          {
      stickyHeaders
    } = me; // We are creating the TimeAxisSubGrid

    if (region === (me.schedulerRegion || 'normal')) {
      config.type = 'timeaxissubgrid';
    } // The assumption is that if we are in vertical mode, the locked SubGrid
    // is used to house the verticalTimeAxis, and so it must all be overflow:visible
    else if (region === 'locked' && stickyHeaders && me.isVertical) {
      config.scrollable = {
        overflowX: 'visible',
        overflowY: 'visible'
      }; // It's the child of the overflowElement

      me.bodyContainer.classList.add('b-sticky-headers');
    }

    return super.createSubGrid(region, config);
  }

  doDestroy() {
    const me = this,
          {
      partneredWith,
      currentOrientation
    } = me;
    currentOrientation === null || currentOrientation === void 0 ? void 0 : currentOrientation.destroy(); // Break links between this TimeLine and any partners.

    if (partneredWith) {
      partneredWith.forEach(p => {
        me.removePartner(p);
      });
      partneredWith.destroy();
    } else {
      me.timeAxisViewModel.destroy();
      me.timeAxis.destroy();
    }

    super.doDestroy();
  }

  startConfigure(config) {
    super.startConfigure(config); // When the body height changes, we must update the SchedulerViewport's height

    _Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_6__["default"].addResizeListener(this.bodyContainer, this.onBodyResize.bind(this)); // partner needs to be initialized first so that the various shared
    // configs are assigned first before we default them in.

    this.getConfig('partner');
  }

  changeStartDate(startDate) {
    if (typeof startDate === 'string') {
      startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(startDate);
    }

    return startDate;
  }

  onPaint({
    firstPaint
  }) {
    // Upon first paint we need to pass the forceUpdate flag in case we are sharing the TimAxisViewModel
    // with another Timeline which will already have done this.
    if (firstPaint) {
      // subGrid in IE11 doesn't have height at this point, but container element does so we take it from there
      // TODO: make flex element inherit height from parent (min-height: 100% doesn't work)
      const me = this,
            scrollable = me.isHorizontal ? me.timeAxisSubGrid.scrollable : me.scrollable,
            availableSpace = scrollable[me.isHorizontal ? 'clientWidth' : 'clientHeight']; // silent = true if infiniteScroll. If that is set, TimelineScroll.initScroll which is
      // called by the base class's onPaint reconfigures the TAVM when it initializes.

      me.timeAxisViewModel.update(availableSpace, me.infiniteScroll, true);
    }

    super.onPaint(...arguments);
  }

  onSchedulerHorizontalScroll(subGrid, scrollLeft) {
    // rerender cells in scheduler column on horizontal scroll to display events in view
    this.currentOrientation.updateFromHorizontalScroll(scrollLeft);
    super.onSchedulerHorizontalScroll(subGrid, scrollLeft);
  }
  /**
   * Overrides initScroll from Grid, listens for horizontal scroll to do virtual event rendering
   * @private
   */


  initScroll() {
    const me = this;
    let frameCount = 0;
    super.initScroll();
    me.on('horizontalscroll', ({
      subGrid,
      scrollLeft
    }) => {
      if (me.isPainted && subGrid === me.timeAxisSubGrid && !me.isDestroying && !me.refreshSuspended) {
        me.onSchedulerHorizontalScroll(subGrid, scrollLeft);
      }

      frameCount++;
    });

    if (me.testPerformance === 'horizontal') {
      me.setTimeout(() => {
        let start = performance.now(),
            // eslint-disable-line no-undef
        scrollSpeed = 5,
            direction = 1;
        const scrollInterval = me.setInterval(() => {
          scrollSpeed = scrollSpeed + 5;
          me.scrollLeft += (10 + Math.floor(scrollSpeed)) * direction;

          if (direction === 1 && me.scrollLeft > 5500) {
            direction = -1;
            scrollSpeed = 5;
          }

          if (direction === -1 && me.scrollLeft <= 0) {
            const done = performance.now(),
                  // eslint-disable-line no-undef
            elapsed = done - start;
            let timePerFrame = elapsed / frameCount,
                fps = 1000 / timePerFrame;
            fps = Math.round(fps * 10) / 10;
            clearInterval(scrollInterval);
            console.log(me.eventPositionMode, me.eventScrollMode, fps + 'fps');
          }
        }, 0);
      }, 500);
    }
  } //endregion

  /**
   * Calls the specified function (returning its return value) and preserves the timeline center
   * point. This is a useful way of retaining the user's visual context while making updates
   * and changes to the view which require major changes or a full refresh.
   * @param {Function} fn The function to call.
   * @param {Object} thisObj The `this` context for the function.
   * @param {...*} args Parameters to the function.
   */


  preserveViewCenter(fn, thisObj = this, ...args) {
    const me = this,
          centerDate = me.viewportCenterDate,
          result = fn.apply(thisObj, args),
          scroller = me.timelineScroller,
          {
      clientSize
    } = scroller,
          scrollStart = Math.max(Math.floor(me.getCoordinateFromDate(centerDate, true) - clientSize / 2), 0);
    me.scrollingToCenter = true;
    scroller.scrollTo(scrollStart, false).then(() => me.scrollingToCenter = false);
    return result;
  }
  /**
   * Changes this Sheduler's time axis timespan to the supplied start and end dates.
   * @param {Date} newStartDate The new start date
   * @param {Date} newEndDate The new end date
   * @param {Object} [options] An object containing modifiers for the time span change operation.
   * @param {Boolean} [options.maintainVisibleStart] Specify as `true` to keep the visible start date stable.
   * @param {Date} [options.visibleDate] The date inside the range to scroll into view
   */


  setTimeSpan(newStartDate, newEndDate, {
    preventThrow = false,
    // Private, only used by the shift method.
    maintainVisibleStart = false,
    visibleDate
  } = emptyObject) {
    const me = this,
          {
      timeAxis
    } = me,
          {
      startDate,
      endDate
    } = timeAxis.getAdjustedDates(newStartDate, newEndDate),
          startChanged = timeAxis.startDate - startDate !== 0,
          endChanged = timeAxis.endDate - endDate !== 0;

    if (startChanged || endChanged) {
      if (maintainVisibleStart) {
        const {
          timeAxisViewModel
        } = me,
              {
          totalSize
        } = timeAxisViewModel,
              oldTickSize = timeAxisViewModel.tickSize,
              scrollable = me.timelineScroller,
              currentScroll = scrollable.position,
              visibleStart = timeAxisViewModel.getDateFromPosition(currentScroll); // If the current visibleStart is in the new range, maintain it
        // So that there is no visual jump.

        if (visibleStart >= startDate && visibleStart < endDate) {
          // We need to correct the scroll position as soon as the TimeAxisViewModel
          // has updated itself and before any other UI updates which that may trigger.
          timeAxisViewModel.on({
            update() {
              const tickSizeChanged = timeAxisViewModel.tickSize !== oldTickSize; // Ensure the canvas element matches the TimeAxisViewModel's new totalSize.
              // This creates the required scroll range to be able to have the scroll
              // position correct before any further UI updates.

              me.updateCanvasSize(); // If *only* the start moved, we can keep scroll position the same
              // by adjusting it by the amount the start moved.

              if (startChanged && !endChanged && !tickSizeChanged) {
                scrollable.position += timeAxisViewModel.totalSize - totalSize;
              } // If only the end has changed, and tick size is same, we can maintain
              // the same scroll position.
              else if (!startChanged && !tickSizeChanged) {
                scrollable.position = currentScroll;
              } // Fall back to restoring the position by restoring the visible start time
              else {
                scrollable.position = timeAxisViewModel.getPositionFromDate(visibleStart);
              } // Force partners to sync with what we've just done to reset the scroll.
              // We are now in control.


              scrollable.syncPartners(true);
            },

            prio: 10000,
            once: true
          });
        }
      }

      const returnValue = timeAxis.reconfigure({
        startDate,
        endDate
      }, false, preventThrow);

      if (visibleDate) {
        me.scrollToDate(visibleDate.date || visibleDate, visibleDate);
      }

      return returnValue;
    }
  } //region Config getters/setters

  /**
   * Returns `true` if any of the events/tasks or feature injected elements (such as ResourceTimeRanges) are within
   * the {@link #config-timeAxis}
   * @property {Boolean}
   * @readonly
   */


  get hasVisibleEvents() {
    return !this.noFeatureElementsInAxis() || this.eventStore.storage.values.some(t => this.timeAxis.isTimeSpanInAxis(t));
  } // Template function to be chained in features to determine if any elements are in time axis (needed since we cannot
  // currently chain getters). Negated to not break chain. First feature that has elements visible returns false,
  // which prevents other features from being queried.


  noFeatureElementsInAxis() {} // Private getter used to piece together event names such as beforeEventDrag / beforeTaskDrag. Could also be used
  // in templates.


  get capitalizedEventName() {
    if (!this._capitalizedEventName) {
      this._capitalizedEventName = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].capitalize(this.scheduledEventName);
    }

    return this._capitalizedEventName;
  }

  set partner(partner) {
    this._partner = partner;
    this.addPartner(partner);
  }
  /**
   * Partners this Timeline with the passed Timeline in order to sync the horizontal scrolling position and zoom level.
   *
   * - To remove existing partner see {@link #function-removePartner} method.
   * - To get the list of partners see {@link #property-partners} getter.
   *
   * @param {Scheduler.view.TimelineBase} otherTimeline The timeline to partner with
   */


  addPartner(partner) {
    const me = this;

    if (!me.isPartneredWith(partner)) {
      const partneredWith = me.partneredWith || (me.partneredWith = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_7__["default"]()); // Each must know about the other so that they can sync others upon region resize

      partneredWith.add(partner);
      (partner.partneredWith || (partner.partneredWith = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_7__["default"]())).add(me); // Flush through viewPreset initGetter so that the setup in setConfig doesn't
      // take them to be the class's defined getters.

      me.getConfig('viewPreset');
      partner.on({
        presetchange: 'onPartnerPresetChange',
        thisObj: me
      });
      partner.scrollable.on({
        overflowChange: 'onPartnerOverflowChange',
        thisObj: me
      }); // collect configs that are meant to be shared between partners

      const partnerSharedConfig = me.partnerSharedConfigs.reduce((config, configName) => {
        config[configName] = partner[configName];
        return config;
      }, {});
      me.setConfig(partnerSharedConfig);
      me.on({
        presetchange: 'onPartnerPresetChange',
        thisObj: partner
      });
      me.scrollable.on({
        overflowChange: 'onPartnerOverflowChange',
        thisObj: partner
      });

      if (me.isPainted) {
        me.scrollable.addPartner(partner.scrollable, 'x');
        partner.syncPartnerSubGrids();
      } else {
        // When initScroll comes round, make sure it syncs with the partner
        me.initScroll = _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createSequence(me.initScroll, () => {
          me.scrollable.addPartner(partner.scrollable, 'x');
          partner.syncPartnerSubGrids();
        }, me);
      }
    }
  }
  /**
   * Breaks the link between current Timeline and the passed Timeline
   *
   * - To add a new partner see {@link #function-addPartner} method.
   * - To get the list of partners see {@link #property-partners} getter.
   *
   * @param {Scheduler.view.TimelineBase} otherTimeline The timeline to unlink from
   */


  removePartner(partner) {
    const me = this,
          {
      partneredWith
    } = me;

    if (me.isPartneredWith(partner)) {
      partneredWith.remove(partner);
      me.scrollable.removePartner(partner.scrollable);
      me.un({
        presetchange: 'onPartnerPresetChange',
        thisObj: partner
      });
      me.scrollable.un({
        overflowChange: 'onPartnerOverflowChange',
        thisObj: partner
      });
      partner.removePartner(me);
    }
  }
  /**
   * Checks whether the passed timeline is partnered with the current timeline.
   * @param {Scheduler.view.TimelineBase} partner The timeline to check the partnering with
   * @return {Boolean} Returns `true` if the timelines are partnered
   */


  isPartneredWith(partner) {
    var _this$partneredWith;

    return Boolean((_this$partneredWith = this.partneredWith) === null || _this$partneredWith === void 0 ? void 0 : _this$partneredWith.includes(partner));
  }
  /*
   * Called when a partner scheduler changes its overflowing state. The scrollable
   * of a Grid/Scheduler only handles overflowY, so this will mean the addition
   * or removal of a vertical scrollbar.
   *
   * All partners must stay in sync. If another parter has a vertical scrollbar
   * and we do not, we must set our overflowY to 'scroll' so that we show an empty
   * scrollbar to keep widths synchronized.
   * @param {Object} a {@link Core.helper.util.Scroller#event-overflowChange} event
   */


  onPartnerOverflowChange({
    source: otherScrollable,
    y
  }) {
    const {
      scrollable
    } = this,
          ourY = scrollable.hasOverflow('y'); // If we disagree with our partner, the partner which doesn't have
    // overflow, has to become overflowY : scroll

    if (ourY !== y) {
      if (ourY) {
        otherScrollable.overflowY = 'scroll';
      } else {
        otherScrollable.overflowY = true;
        scrollable.overflowY = 'scroll';
        this.refreshVirtualScrollbars();
      }
    } // If we agree with our partner, we can reset ourselves to overflowY : auto
    else {
      scrollable.overflowY = true;
    }
  }

  onPartnerPresetChange({
    preset,
    startDate,
    endDate,
    centerDate
  }) {
    if (!this._viewPresetChanging && this.viewPreset !== preset) {
      // Passed through to the viewPreset changing method
      preset.options = {
        startDate,
        endDate,
        centerDate
      };
      this.viewPreset = preset;
    }
  }

  get partner() {
    return this._partner;
  }
  /**
   * Returns the partnered timelines.
   *
   * - To add a new partner see {@link #function-addPartner} method.
   * - To remove existing partner see {@link #function-removePartner} method.
   *
   * @readonly
   * @member {Scheduler.view.TimelineBase} partners
   * @category Time axis
   */


  get partners() {
    const partners = this.partner ? [this.partner] : [];

    if (this.partneredWith) {
      partners.push.apply(partners, this.partneredWith.allValues);
    }

    return partners;
  }

  get timeAxisColumn() {
    return this.columns && this._timeAxisColumn;
  }

  get columns() {
    // Maintainer. If we do not implement a getter to go along with our setter, this
    // property becomes unreadable at this class level.
    return super.columns;
  }

  set columns(columns) {
    const me = this;
    let timeAxisColumnIndex, timeAxisColumnConfig, timeAxisColumn, value; // No columns means destroy

    if (columns) {
      const isArray = Array.isArray(columns);
      let cols = columns;

      if (!isArray) {
        cols = columns.data;
      }

      timeAxisColumnIndex = cols && cols.length;
      cols.some((col, index) => {
        if (col.type === 'timeAxis') {
          timeAxisColumnIndex = index;
          timeAxisColumnConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assign(col, me.timeAxisColumn);
          return true;
        }

        return false;
      }); // TODO : This is scheduler specific, override `set columns` instead
      // No additional columns allowed in vertical mode, but store the specified set in case we toggle mode later

      if (me.isVertical) {
        me._horizontalColumns = columns;
        cols = [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assign({
          type: 'verticalTimeAxis',
          locked: true
        }, me.verticalTimeAxisColumn), // Make space for a regular TimeAxisColumn after the VerticalTimeAxisColumn
        cols[timeAxisColumnIndex]];
        timeAxisColumnIndex = 1;
      } else {
        // We're going to mutate this array which we do not own, so copy it first.
        cols = cols.slice();
      } // Fix up the timeAxisColumn config in place


      timeAxisColumnConfig = cols[timeAxisColumnIndex] = Object.assign({
        type: 'timeAxis',
        locked: false,
        cellCls: me.timeCellCls,
        mode: me.mode
      }, timeAxisColumnConfig); // Pass these configs into the timeAxisColumnConfig

      timeAxisColumnConfigs.forEach(configName => {
        value = me[configName];

        if (value != null) {
          timeAxisColumnConfig[configName] = value;
        }
      });

      if (isArray) {
        columns = cols;
      } else {
        columns.data = cols;
      }
    } // Invoke Grid's setter. Will create a ColumnStore which is returned by the columns setter.


    super.columns = columns;

    if (columns) {
      timeAxisColumn = me._timeAxisColumn = me.columns.getAt(timeAxisColumnIndex);

      if (me.isVertical) {
        me.verticalTimeAxisColumn = me.columns.getAt(timeAxisColumnIndex - 1);
        me.verticalTimeAxisColumn.relayAll(me);
      } // Set up event relaying early


      timeAxisColumn.relayAll(me);
    }
  }

  onColumnsChanged({
    action,
    changes,
    record: column
  }) {
    const {
      timeAxisColumn,
      columns
    } = this; // If someone replaces the column set, ensure time axis is always added

    if (action === 'dataset' && !columns.includes(timeAxisColumn)) {
      columns.add(timeAxisColumn, true);
    } // TODO: Have ResourceHeader call this directly instead of relying on event?
    else if (column === timeAxisColumn && 'width' in changes) {
      this.updateCanvasSize();
    }

    super.onColumnsChanged(...arguments);
  }

  get timeView() {
    const me = this; // Maintainer, we need to ensure that the columns property is initialized
    // if this getter is called at configuration time before columns have been ingested.

    return me.columns && me.isVertical ? me.verticalTimeAxisColumn && me.verticalTimeAxisColumn.view : me.timeAxisColumn && me.timeAxisColumn.timeAxisView;
  }

  set eventCls(eventCls) {
    const me = this;
    me._eventCls = eventCls;

    if (!me.eventSelector) {
      me.eventSelector = `.${eventCls}-wrap`; // No difference with new rendering, released have 'b-released' only

      me.unreleasedEventSelector = `${me.eventSelector}`;
    }

    if (!me.eventInnerSelector) {
      me.eventInnerSelector = '.' + eventCls;
    }
  }

  get eventCls() {
    return this._eventCls;
  }

  set timeAxisViewModel(timeAxisViewModel) {
    const me = this,
          currentModel = me._timeAxisViewModel,
          tavmListeners = {
      name: 'timeAxisViewModel',
      update: 'onTimeAxisViewModelUpdate',
      prio: 100,
      thisObj: me
    };

    if (me.partner && !timeAxisViewModel || currentModel && currentModel === timeAxisViewModel) {
      return;
    }

    if ((currentModel === null || currentModel === void 0 ? void 0 : currentModel.owner) === me) {
      // We created this model, destroy it
      currentModel.destroy();
    }

    me.detachListeners('timeAxisViewModel'); // Getting rid of instanceof check to allow using code from different bundles

    if (timeAxisViewModel && timeAxisViewModel.isTimeAxisViewModel) {
      timeAxisViewModel.on(tavmListeners);
    } else {
      timeAxisViewModel = Object.assign({
        mode: me._mode,
        snap: me.snap,
        forceFit: me.forceFit,
        timeAxis: me.timeAxis,
        suppressFit: me.suppressFit,
        listeners: tavmListeners,
        owner: me
      }, timeAxisViewModel);
      timeAxisViewModel = new _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_12__["default"](timeAxisViewModel);
    } // Replace in dependent classes relying on the model


    if (!me.isConfiguring) {
      if (me.isHorizontal) {
        me.timeAxisColumn.timeAxisViewModel = timeAxisViewModel;
      } else {
        me.verticalTimeAxisColumn.view.model = timeAxisViewModel;
      }
    }

    me._timeAxisViewModel = timeAxisViewModel;
    me.relayEvents(timeAxisViewModel, ['update'], 'timeAxisViewModel');

    if (currentModel && timeAxisViewModel) {
      me.trigger('timeAxisViewModelChange', {
        timeAxisViewModel
      });
    }
  }
  /**
   * The internal view model, describing the visual representation of the time axis.
   * @property {Scheduler.view.model.TimeAxisViewModel}
   * @readonly
   * @category Time axis
   */


  get timeAxisViewModel() {
    if (!this._timeAxisViewModel) {
      this.timeAxisViewModel = null;
    }

    return this._timeAxisViewModel;
  }

  get suppressFit() {
    var _this$_timeAxisViewMo, _this$_timeAxisViewMo2;

    return (_this$_timeAxisViewMo = (_this$_timeAxisViewMo2 = this._timeAxisViewModel) === null || _this$_timeAxisViewMo2 === void 0 ? void 0 : _this$_timeAxisViewMo2.suppressFit) !== null && _this$_timeAxisViewMo !== void 0 ? _this$_timeAxisViewMo : this._suppressFit;
  }

  set suppressFit(value) {
    if (this._timeAxisViewModel) {
      this.timeAxisViewModel.suppressFit = value;
    } else {
      this._suppressFit = value;
    }
  }

  set timeAxis(timeAxis) {
    const me = this,
          currentTimeAxis = me._timeAxis,
          timeAxisListeners = {
      name: 'timeAxis',

      reconfigure({
        config
      }) {
        /**
         * Fired when the timeaxis has changed, for example by zooming or configuring a new time span.
         * @event timeAxisChange
         * @param {Scheduler.view.Scheduler} source - This Scheduler
         * @param {Object} config Config object used to reconfigure the time axis.
         * @param {Date} config.start New start date (if supplied)
         * @param {Date} config.end New end date (if supplied)
         */
        me.trigger('timeAxisChange', {
          config
        });
      },

      thisObj: me
    };

    if (me.partner && !timeAxis || currentTimeAxis && currentTimeAxis === timeAxis) {
      return;
    }

    if (currentTimeAxis) {
      if (currentTimeAxis.owner === me) {
        // We created this model, destroy it
        currentTimeAxis.destroy();
      }
    }

    me.detachListeners('timeAxis'); // Getting rid of instanceof check to allow using code from different bundles

    if (!(timeAxis && timeAxis.isTimeAxis)) {
      timeAxis = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assign({
        owner: me,
        viewPreset: me.viewPreset,
        autoAdjust: me.autoAdjustTimeAxis,
        mode: 'plain',
        weekStartDay: me.weekStartDay
      }, timeAxis);

      if (me.startDate) {
        timeAxis.startDate = me.startDate;
      }

      if (me.endDate) {
        timeAxis.endDate = me.endDate;
      }

      if (me.workingTime) {
        me.applyWorkingTime(timeAxis);
      }

      timeAxis = new _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_11__["default"](timeAxis);
    } // Inform about reconfiguring the timeaxis, to allow users to react to start & end date changes


    timeAxis.on(timeAxisListeners);
    me._timeAxis = timeAxis;
  }

  get timeAxis() {
    if (!this._timeAxis) {
      this.timeAxis = null;
    }

    return this._timeAxis;
  }
  /**
   * Get/set working time. Assign `null` to stop using working time. See {@link #config-workingTime} config for details.
   * @property {Object}
   */


  set workingTime(config) {
    this._workingTime = config;

    if (!this.isConfiguring) {
      this.applyWorkingTime(this.timeAxis);
    }
  }

  get workingTime() {
    return this._workingTime;
  } // Translates the workingTime configs into TimeAxis#include rules, applies them and then refreshes the header and
  // redraws the events


  applyWorkingTime(timeAxis) {
    const me = this,
          config = me._workingTime;

    if (config) {
      let hour = null; // Only use valid values

      if (config.fromHour >= 0 && config.fromHour < 24 && config.toHour > config.fromHour && config.toHour <= 24 && config.toHour - config.fromHour < 24) {
        hour = {
          from: config.fromHour,
          to: config.toHour
        };
      }

      let day = null; // Only use valid values

      if (config.fromDay >= 0 && config.fromDay < 7 && config.toDay > config.fromDay && config.toDay <= 7 && config.toDay - config.fromDay < 7) {
        day = {
          from: config.fromDay,
          to: config.toDay
        };
      }

      if (hour || day) {
        timeAxis.include = {
          hour,
          day
        };
      } else {
        // No valid rules, restore timeAxis
        timeAxis.include = null;
      }
    } else {
      // No rules, restore timeAxis
      timeAxis.include = null;
    }

    if (me.isPainted) {
      var _me$features$columnLi;

      // Refreshing header, which also recalculate tickSize and header data
      me.timeAxisColumn.refreshHeader(); // Update column lines

      (_me$features$columnLi = me.features.columnLines) === null || _me$features$columnLi === void 0 ? void 0 : _me$features$columnLi.refresh(); // Animate event changes

      me.refreshWithTransition();
    }
  }

  updateStartDate(date) {
    this.setStartDate(date);
  }
  /**
   * Sets the timeline start date.
   *
   * **Note:**
   * - If you need to set start and end date at the same time, use the {@link #function-setTimeSpan} method.
   * - If keepDuration is false and new start date is greater than end date, it will throw an exception.
   *
   * @param {Date} date The new start date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
   * `false` to change the duration ("resize" the timeline). Defaults to `true`.
   */


  setStartDate(date, keepDuration = true) {
    const me = this,
          ta = me._timeAxis,
          {
      startDate,
      endDate,
      mainUnit
    } = ta || emptyObject;

    if (typeof date === 'string') {
      date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(date);
    }

    if (ta && endDate) {
      if (date) {
        let calcEndDate = endDate;

        if (keepDuration && startDate) {
          const diff = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, mainUnit, true);
          calcEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, diff, mainUnit);
        }

        me.setTimeSpan(date, calcEndDate);
      }
    } else {
      me._tempStartDate = date;
    }
  }

  get startDate() {
    const me = this;

    if (me._timeAxis) {
      return me._timeAxis.startDate;
    }

    return me._tempStartDate || new Date();
  }

  changeEndDate(date) {
    if (typeof date === 'string') {
      date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(date);
    }

    this.setEndDate(date);
  }
  /**
   * Sets the timeline end date
   *
   * **Note:**
   * - If you need to set start and end date at the same time, use the {@link #function-setTimeSpan} method.
   * - If keepDuration is false and new end date is less than start date, it will throw an exception.
   *
   * @param {Date} date The new end date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
   * `false` to change the duration ("resize" the timeline). Defaults to `false`.
   */


  setEndDate(date, keepDuration = false) {
    const me = this,
          ta = me._timeAxis,
          {
      startDate,
      endDate,
      mainUnit
    } = ta || emptyObject;

    if (typeof date === 'string') {
      date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(date);
    }

    if (ta && startDate) {
      if (date) {
        let calcStartDate = startDate;

        if (keepDuration && endDate) {
          const diff = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, mainUnit, true);
          calcStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, -diff, mainUnit);
        }

        me.setTimeSpan(calcStartDate, date);
      }
    } else {
      me._tempEndDate = date;
    }
  }

  get endDate() {
    const me = this;

    if (me._timeAxis) {
      return me._timeAxis.endDate;
    }

    return me._tempEndDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(me.startDate, me.viewPreset.defaultSpan, me.viewPreset.mainHeader.unit);
  }

  changeVisibleDate(options) {
    return options instanceof Date ? {
      date: options
    } : options;
  }

  updateVisibleDate(options) {
    const me = this;

    if (!me.isConfiguring) {
      me.scrollToDate(options.date, options);
    } else {
      me.on({
        paint: () => me.scrollToDate(options.date, options),
        once: true
      });
    }
  }

  get features() {
    return super.features;
  } // add region resize by default


  set features(features) {
    features = features === true ? {} : features;

    if (!('regionResize' in features)) {
      features.regionResize = true;
    }

    super.features = features;
  }

  get eventStyle() {
    return this._eventStyle;
  }

  set eventStyle(style) {
    const me = this;
    me._eventStyle = style;

    if (me.isPainted) {
      me.refreshWithTransition();
    }
  }

  get eventColor() {
    return this._eventColor;
  }

  set eventColor(color) {
    const me = this;
    me._eventColor = color;

    if (me.isPainted) {
      me.refreshWithTransition();
    }
  } //endregion
  //region Event handlers


  onLocaleChange() {
    super.onLocaleChange();
    const oldAutoAdjust = this.timeAxis.autoAdjust; // Time axis should rebuild as weekStartDay may have changed

    this.timeAxis.reconfigure({
      autoAdjust: false
    }); // Silently set it back to what the user had for next view refresh

    this.timeAxis.autoAdjust = oldAutoAdjust;
  }
  /**
   * Called when the element which encapsulates the Scheduler's visible height changes size.
   * We only respond to *height* changes here. The TimeAxisSubGrid monitors its own width.
   * @param {HTMLElement} element
   * @param {DOMRect} oldRect
   * @param {DOMRect} newRect
   * @private
   */


  onBodyResize(element, oldRect, {
    width,
    height
  }) {
    // Uncache old value upon element resize, not upon initial sizing
    if (this.isVertical && oldRect && width !== oldRect.width) {
      delete this.timeAxisSubGrid._width;
    }

    const newWidth = this.timeAxisSubGrid.element.offsetWidth; // The Scheduler (The Grid) dictates the viewport height.
    // Don't react on first invocation which will be initial size.

    if (this._bodyRectangle && oldRect && height !== oldRect.height) {
      this.onSchedulerViewportResize(newWidth, height, newWidth, oldRect.height);
    }
  } // Note: This function is throttled in construct(), since it will do a full redraw per call


  onSchedulerViewportResize(width, height, oldWidth, oldHeight) {
    if (this.isPainted) {
      const me = this,
            {
        isHorizontal,
        timeAxisViewModel,
        partneredWith
      } = me;
      me.currentOrientation.onViewportResize(width, height, oldWidth, oldHeight); // Raw width is always correct for horizontal layout because the TimeAxisSubGrid
      // never shows a scrollbar. It's always contained by an owning Grid which shows
      // the vertical scrollbar.

      timeAxisViewModel.availableSpace = isHorizontal ? width : Math.floor(height);

      if (partneredWith && !me.isSyncingFromPartner) {
        me.syncPartnerSubGrids();
      }
      /**
       * Fired when the *scheduler* viewport (not the overall Scheduler element) changes size.
       * This happens when the grid changes height, or when the subgrid which encapsulates the
       * scheduler column changes width.
       * @event timelineViewportResize
       * @param {Core.widget.Widget} source - This Scheduler
       * @param {Number} width The new width
       * @param {Number} height The new height
       * @param {Number} oldWidth The old width
       * @param {Number} oldHeight The old height
       */


      me.trigger('timelineViewportResize', {
        width,
        height,
        oldWidth,
        oldHeight
      });
    }
  }

  onTimeAxisViewModelUpdate() {
    this.updateCanvasSize();
    this.currentOrientation.onTimeAxisViewModelUpdate();
  }

  syncPartnerSubGrids() {
    this.partneredWith.forEach(partner => {
      if (!partner.isSyncingFromPartner) {
        partner.isSyncingFromPartner = true;
        this.eachSubGrid(subGrid => {
          const partnerSubGrid = partner.subGrids[subGrid.region]; // If there is a difference, sync the partner SubGrid state

          if (partnerSubGrid.width !== subGrid.width) {
            if (subGrid.collapsed) {
              partnerSubGrid.collapse();
            } else {
              if (partnerSubGrid.collapsed) {
                partnerSubGrid.expand();
              } // When using flexed subgrid, make sure flex values has prio over width


              if (subGrid.flex) {
                // If flex values match, resize should be fine without changing anything
                if (subGrid.flex !== partnerSubGrid.flex) {
                  partnerSubGrid.flex = subGrid.flex;
                }
              } else {
                partnerSubGrid.width = subGrid.width;
              }
            }
          }
        });
        partner.isSyncingFromPartner = false;
      }
    });
  } //endregion
  //region Mode


  get currentOrientation() {
    throw new Error('Implement in subclass');
  } // Horizontal is the default, overridden in scheduler


  get isHorizontal() {
    return true;
  } //endregion
  //region Canvases and elements


  get backgroundCanvas() {
    return this._backgroundCanvas;
  }

  get foregroundCanvas() {
    return this._foregroundCanvas;
  }

  get svgCanvas() {
    const me = this;

    if (!me._svgCanvas) {
      const svg = me._svgCanvas = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('id', _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].generateId('svg')); // To not be recycled by DomSync

      svg.retainElement = true;
      me.foregroundCanvas.appendChild(svg);
      me.trigger('svgCanvasCreated');
    }

    return me._svgCanvas;
  }
  /**
   * Returns the subGrid containing the time axis
   * @member {Grid.view.SubGrid} timeAxisSubGrid
   * @readonly
   */

  /**
   * Returns the html element for the subGrid containing the time axis
   * @property {HTMLElement}
   * @readonly
   */


  get timeAxisSubGridElement() {
    // We need the TimeAxisSubGrid to exist, so regions must be initialized
    this.getConfig('regions');
    return this.timeAxisColumn && this.timeAxisColumn.subGridElement;
  }

  updateCanvasSize() {
    const me = this,
          {
      totalSize
    } = me.timeAxisViewModel,
          width = me.isHorizontal ? totalSize : me.timeAxisColumn.width;
    let result = false;

    if (me.isVertical) {
      // Ensure vertical scroll range accommodates the TimeAxis
      if (me.isPainted) {
        me.refreshTotalHeight(totalSize, true);
      } // Canvas might need a height in vertical mode, if ticks does not fill height (suppressFit : true)


      if (me.suppressFit) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setLength(me.foregroundCanvas, 'height', totalSize);
      }

      result = true;
    }

    if (width !== me.$canvasWidth) {
      if (me.backgroundCanvas) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setLength(me.backgroundCanvas, 'width', width);
      }

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setLength(me.foregroundCanvas, 'width', width);
      me.$canvasWidth = width;
      result = true;
    }

    return result;
  }
  /**
   * A chainable function which Features may hook to add their own content to the timeaxis header.
   * @param {Array} configs An array of domConfigs, append to it to have the config applied to the header
   */


  getHeaderDomConfigs(configs) {}
  /**
   * A chainable function which Features may hook to add their own content to the foreground canvas
   * @param {Array} configs An array of domConfigs, append to it to have the config applied to the foreground canvas
   */


  getForegroundDomConfigs(configs) {} //endregion
  //region Grid overrides


  async onStoreDataChange({
    action
  }) {
    // When repopulating stores (pro and up on data reload), the engine is not in a valid state until committed.
    // Dont want to commit here, since it might be repopulating multiple stores.
    // Instead delay grids refresh until project is ready
    if (action === 'dataset' && this.project.isRepopulatingStores) {
      await this.project.await('refresh', false);
    }

    super.onStoreDataChange(...arguments);
  }

  refresh(forceLayout = true) {
    const me = this;

    if (me.isPainted && !me.refreshSuspended) {
      if (me.hasVisibleEvents) {
        if (me.isEngineReady) {
          me.refreshRows(false, forceLayout);
        } else {
          me.refreshAfterProjectRefresh = true;
          me.currentOrientation.refreshAllWhenReady = true;
        }
      } // Even if there are no events in our timeline, Features
      // assume there will be a refresh event from the RowManager
      // after a refresh request so fire it here.
      else {
        me.rowManager.trigger('refresh');
      }
    }
  }

  render() {
    const me = this,
          schedulerEl = me.timeAxisSubGridElement;

    if (me.useBackgroundCanvas) {
      me._backgroundCanvas = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
        className: 'b-sch-background-canvas',
        parent: schedulerEl,
        nextSibling: schedulerEl.firstElementChild
      });
    } // The font-size trick is no longer used by scheduler, since it allows per resource margins


    const fgCanvas = me._foregroundCanvas = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
      className: 'b-sch-foreground-canvas',
      style: `font-size:${me.rowHeight - me.resourceMargin * 2}px`,
      parent: schedulerEl
    });
    me.timeAxisSubGrid.insertRowsBefore = fgCanvas; // Size correctly in case ticks does not fill height

    if (me.isVertical && me.suppressFit) {
      me.updateCanvasSize();
    }

    super.render(...arguments);
  } // TODO: refreshRows -> refresh in grid?


  refreshRows(returnToTop = false, reLayoutEvents = true) {
    const me = this;

    if (me.isConfiguring) {
      return;
    }

    me.currentOrientation.refreshRows(reLayoutEvents);
    super.refreshRows(returnToTop);
  } //endregion
  //region Other


  getDateConstraints() {} // duration = false prevents transition


  runWithTransition(fn, duration) {
    const me = this; // Do not attempt to enter animating state if we are not visible

    if (me.isVisible) {
      // Allow calling with true/false to keep code simpler in other places
      if (duration == null || duration === true) {
        duration = me.transitionDuration;
      } // Ask Grid superclass to enter the animated state if requested and enabled.


      if (duration && me.enableEventAnimations) {
        if (!me.hasTimeout('exitTransition')) {
          me.isAnimating = true;
        } // Exit animating state in duration milliseconds.


        exitTransition.delay = duration;
        me.setTimeout(exitTransition);
      }
    }

    fn();
  }

  exitTransition() {
    this.isAnimating = false;
    this.trigger('transitionend');
  } // Awaited by CellEdit to make sure that the editor is not moved until row heights have transitioned, to avoid it
  // ending up misaligned


  async waitForAnimations() {
    // If project is calculating, we should await that too. It might lead to transitions
    if (!this.isEngineReady) {
      await this.project.await('dataReady', false);
    }

    await super.waitForAnimations();
  }
  /**
   * Refreshes the grid with transitions enabled.
   */


  refreshWithTransition(forceLayout, duration) {
    this.runWithTransition(() => this.refresh(forceLayout), duration);
  }
  /**
   * Returns an object representing the visible date range, with `startDate` and `endDate` properties.
   * @deprecated 4.0.0 Deprecated in favor of `get visibleDateRange`
   * @return {Object} The date range
   * @return {Date} return.startDate Start date
   * @return {Date} return.endDate End date
   */


  getVisibleDateRange() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of `get visibleDateRange`');
    return this.visibleDateRange;
  }
  /**
   * Returns an object representing the visible date range
   * @property {Object}
   * @property {Date} visibleDateRange.startDate
   * @property {Date} visibleDateRange.endDate
   * @readonly
   */


  get visibleDateRange() {
    return this.currentOrientation.visibleDateRange;
  } //endregion

  /**
   * Returns a rounded duration value to be displayed in UI (tooltips, labels etc)
   * @param {Number} The raw duration value
   * @param {Number} [nbrDecimals] The number of decimals, defaults to {@link #config-durationDisplayPrecision}
   * @return {Number} The rounded duration
   */


  formatDuration(duration, nbrDecimals = this.durationDisplayPrecision) {
    const multiplier = Math.pow(10, nbrDecimals);
    return Math.round(duration * multiplier) / multiplier;
  }

  beginListeningForBatchedUpdates() {
    this.listenToBatchedUpdates = (this.listenToBatchedUpdates || 0) + 1;
  }

  endListeningForBatchedUpdates() {
    if (this.listenToBatchedUpdates) {
      this.listenToBatchedUpdates -= 1;
    }
  }

} // Register this widget type with its Factory

TimelineBase.initClass(); // Has to be here because Gantt extends TimelineBase

_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setVersion('scheduler', '4.3.5');
TimelineBase._$name = 'TimelineBase';

/***/ }),

/***/ "./lib/Scheduler/view/VerticalTimeAxis.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/view/VerticalTimeAxis.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalTimeAxis; });
/* harmony import */ var _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeAxisBase.js */ "./lib/Scheduler/view/TimeAxisBase.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';

/**
 * @module Scheduler/view/VerticalTimeAxis
 */

/**
 * Widget that renders a vertical time axis. Only renders ticks in view. Used in vertical mode.
 * @extends Core/widget/Widget
 * @private
 */

class VerticalTimeAxis extends _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'VerticalTimeAxis';
  }

  static get configurable() {
    return {
      cls: 'b-verticaltimeaxis',
      sizeProperty: 'height',
      positionProperty: 'top',
      wrapText: true
    };
  } // All cells overlayed in the same space.
  // For future use.


  buildHorizontalCells() {
    const me = this,
          {
      client
    } = me,
          stickyHeaders = client === null || client === void 0 ? void 0 : client.stickyHeaders,
          featureHeaderConfigs = [],
          cellConfigs = me.levels.reduce((result, level, i) => {
      if (level.cells) {
        var _level$cells;

        result.push(...((_level$cells = level.cells) === null || _level$cells === void 0 ? void 0 : _level$cells.filter(cell => cell.start < me.endDate && cell.end > me.startDate).map((cell, j, cells) => ({
          className: {
            'b-sch-header-timeaxis-cell': 1,
            [cell.headerCellCls]: cell.headerCellCls,
            [`b-align-${cell.align}`]: cell.align,
            'b-last': j === cells.length - 1,
            'b-lowest': i === me.levels.length - 1
          },
          dataset: _objectSpread({
            tickIndex: cell.index,
            cellId: `${i}-${cell.index}`,
            headerPosition: i
          }, window.DEBUG && {
            date: cell.start.getTime()
          }),
          style: {
            // DomHelper appends px to numeric dimensions
            top: cell.coord,
            height: cell.width,
            minHeight: cell.width
          },
          children: [{
            className: {
              'b-sch-header-text': 1,
              'b-sticky-header': stickyHeaders
            },
            html: cell.value
          }]
        }))));
      }

      return result;
    }, []); // When tested in isolation there is no client

    client === null || client === void 0 ? void 0 : client.getHeaderDomConfigs(featureHeaderConfigs);
    cellConfigs.push(...featureHeaderConfigs); // noinspection JSSuspiciousNameCombination

    return {
      className: me.widgetClassList,
      dataset: {
        headerFeature: `headerRow0`,
        headerPosition: 0
      },
      syncOptions: {
        // Keep a maximum of 5 released cells. Might be fine with fewer since ticks are fixed width.
        // Prevents an unnecessary amount of cells from sticking around when switching from narrow to
        // wide tickSizes
        releaseThreshold: 5,
        syncIdField: 'cellId'
      },
      children: cellConfigs
    };
  }

  get height() {
    return this.size;
  }

}
VerticalTimeAxis._$name = 'VerticalTimeAxis';

/***/ }),

/***/ "./lib/Scheduler/view/export/SchedulerExportDialog.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/view/export/SchedulerExportDialog.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerExportDialog; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Grid/view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony import */ var _view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../view/export/field/ScheduleRangeCombo.js */ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/export/SchedulerExportDialog
 */

/**
 * Extends the Grid's {@link Grid.view.export.ExportDialog} and adds a few extra fields specific to the scheduler.
 *
 * ## Default widgets
 *
 * The default widgets of this dialog are:
 *
 * | Widget ref             | Type                                     | Weight | Description                                          |
 * |------------------------|------------------------------------------|--------|----------------------------------------------------- |
 * | `columnsField`         | {@link Core.widget.Combo Combo}          | 100    | Choose columns to export                             |
 * | `scheduleRangeField`   | {@link Core.widget.Combo Combo}          | 150    | Choose date range to export                          |
 * | `rangesContainer`      | {@link Core.widget.Container Container}  | 151    | Container for range fields                           |
 * | \>`rangeStartField`    | {@link Core.widget.DateField DateField}  | 10     | Choose date range start                              |
 * | \>`rangeEndField`      | {@link Core.widget.DateField DateField}  | 30     | Choose date range end                                |
 * | `rowsRangeField`       | {@link Core.widget.Combo Combo}          | 200    | Choose which rows to export                          |
 * | `exporterTypeField`    | {@link Core.widget.Combo Combo}          | 300    | Type of the exporter to use                          |
 * | `alignRowsField`       | {@link Core.widget.Checkbox Checkbox}    | 400    | Align row top to the page top on every exported page |
 * | `repeatHeaderField`    | {@link Core.widget.Checkbox Checkbox}    | 500    | Toggle repeating headers on / off                    |
 * | `fileFormatField`      | {@link Core.widget.Combo Combo}          | 600    | Choose file format                                   |
 * | `paperFormatField`     | {@link Core.widget.Combo Combo}          | 700    | Choose paper format                                  |
 * | `orientationField`     | {@link Core.widget.Combo Combo}          | 800    | Choose orientation                                   |
 *
 * The default buttons are:
 *
 * | Widget ref             | Type                                     | Weight | Description                                          |
 * |------------------------|------------------------------------------|--------|------------------------------------------------------|
 * | `exportButton`         | {@link Core.widget.Button Button}        | 100    | Triggers export                                      |
 * | `cancelButton`         | {@link Core.widget.Button Button}        | 200    | Cancel export                                        |
 *
 * *\> nested items*
 *
 * ## Configuring default widgets
 *
 * Widgets can be customized with {@link Scheduler.feature.export.PdfExport#config-exportDialog} config:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 items : {
 *                     // hide the field
 *                     orientationField  : { hidden : true },
 *
 *                     // reorder fields
 *                     exporterTypeField : { weight : 150 },
 *
 *                     // change default format in exporter
 *                     fileFormatField   : { value : 'png' },
 *
 *                     // Configure nested fields
 *                     rangesContainer : {
 *                         items : {
 *                             rangeStartField : { value : new Date() },
 *                             rangeEndField : { value : new Date() }
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 *
 * scheduler.features.pdfExport.showExportDialog();
 * ```
 *
 * ## Using DateTime fields for range start/end
 *
 * This config system is also capable (but not limited to) of changing layout of the container and replacing widget type:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 items : {
 *                     rangesContainer : {
 *                         // DateTime fields are longer, so we better lay them out
 *                         // vertically
 *                         layoutStyle : {
 *                             flexDirection : 'column'
 *                         },
 *                         items : {
 *                             rangeStartField : {
 *                                 // Use DateTime widget for ranges
 *                                 type       : 'datetime',
 *
 *                                 // Sync label width with other fields
 *                                 labelWidth : '12em'
 *                             },
 *                             rangeEndField : {
 *                                 type       : 'datetime',
 *                                 labelWidth : '12em'
 *                             },
 *                             // Add a filler widget that would add a margin at the bottom
 *                             filler : {
 *                                 height : '0.6em',
 *                                 weight : 900
 *                             }
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 *
 * ```
 *
 * ## Configuring default columns
 *
 * By default all visible columns are selected in the export dialog. This is managed by
 * {@link #config-autoSelectVisibleColumns} config. To change default selected columns you should disable this config
 * and set field value. Value should be an array of valid column ids (or column instances). This way you can
 * preselect hidden columns:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     columns : [
 *         { id : 'name', text : 'Name', field : 'name' },
 *         { id : 'age', text : 'Age', field : 'age' },
 *         { id : 'city', text : 'City', field : 'city', hidden : true }
 *     ],
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 autoSelectVisibleColumns : false,
 *                 items : {
 *                     columnsField : { value : ['name', 'city'] }
 *                 }
 *             }
 *         }
 *     }
 * })
 *
 * // This will show export dialog with Name and City columns selected
 * // even though City column is hidden in the UI
 * scheduler.features.pdfExport.showExportDialog();
 * ```
 *
 * ## Adding fields
 *
 * You can add your own fields to the export dialog. To make such field value acessible to the feature it should follow
 * naming pattern - it should have `ref` config ending with `Field`, see other fields for reference - `orientationField`,
 * `columnsField`, etc. Fields not matching this pattern are ignored. When values are collected from the dialog, `Field`
 * part of the widget reference is removed, so `orientationField` becomes `orientation`, `fooField` becomes `foo`, etc.
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportDialog : {
 *                 items : {
 *                     // This field gets into export config
 *                     fooField : {
 *                         type : 'text',
 *                         label : 'Foo',
 *                         value : 'FOO'
 *                     },
 *
 *                     // This one does not, because name doesn't end with `Field`
 *                     bar : {
 *                         type : 'text',
 *                         label : 'Bar',
 *                         value : 'BAR'
 *                     },
 *
 *                     // Add a container widget to wrap some fields together
 *                     myContainer : {
 *                         type : 'container',
 *                         items : {
 *                             // This one gets into config too despite the nesting level
 *                             bazField : {
 *                                 type : 'text',
 *                                 label : 'Baz',
 *                                 value : 'BAZ'
 *                             }
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 *
 * // Assuming export dialog is opened and export triggered with default values
 * // you can receive custom field values here
 * grid.on({
 *     beforeExport({ config }) {
 *         console.log(config.foo) // 'FOO'
 *         console.log(config.bar) // undefined
 *         console.log(config.baz) // 'BAZ'
 *     }
 * });
 * ```
 *
 * ## Configuring widgets at runtime
 *
 * If you don't know column ids before grid instantiation or you want a flexible config, you can change widget values
 * before dialog pops up:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     columns : [
 *         { id : 'name', text : 'Name', field : 'name' },
 *         { id : 'age', text : 'Age', field : 'age' },
 *         { id : 'city', text : 'City', field : 'city', hidden : true }
 *     ],
 *     features : {
 *         pdfExport : true
 *     }
 * });
 *
 * // Such listener would ignore autoSelectVisibleColumns config. Similar to the snippet
 * // above this will show Name and City columns
 * scheduler.features.pdfExport.exportDialog.on({
 *     beforeShow() {
 *         this.widgetMap.columnsField.value = ['age', 'city']
 *     }
 * });
 * ```
 *
 * @extends Grid/view/export/ExportDialog
 */

class SchedulerExportDialog extends _Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'SchedulerExportDialog';
  }

  static get type() {
    return 'schedulerexportdialog';
  }

  static get configurable() {
    return {
      defaults: {
        localeClass: this
      },
      items: {
        scheduleRangeField: {
          type: 'schedulerangecombo',
          label: 'L{Schedule range}',
          value: 'completeview',
          weight: 150,

          onChange({
            value
          }) {
            this.parent.widgetMap.rangesContainer.hidden = value !== _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_2__["ScheduleRange"].daterange;
          }

        },
        rangesContainer: {
          type: 'container',
          flex: '1 0 100%',
          weight: 151,
          hidden: true,
          defaults: {
            localeClass: this
          },
          items: {
            filler: {
              // Filler widget to align date fields
              weight: 0,
              type: 'widget'
            },
            rangeStartField: {
              type: 'datefield',
              label: 'L{Export from}',
              labelWidth: '3em',
              flex: '1 0 25%',
              weight: 10,

              onChange({
                value
              }) {
                this.parent.widgetMap.rangeEndField.min = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(value, 1, 'd');
              }

            },
            filler2: {
              // Another filler to move label further from previous field
              type: 'widget',
              weight: 20,
              width: '0.5em'
            },
            rangeEndField: {
              type: 'datefield',
              label: 'L{Export to}',
              labelWidth: '1em',
              flex: '1 0 25%',
              weight: 30,

              onChange({
                value
              }) {
                this.parent.widgetMap.rangeStartField.max = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(value, -1, 'd');
              }

            }
          }
        }
      }
    };
  } //endregion


  onLocaleChange() {
    const labelWidth = this.L('labelWidth');
    this.width = this.L('L{width}');
    this.items.forEach(widget => {
      if (widget instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
        widget.labelWidth = labelWidth;
      } else if (widget.ref === 'rangesContainer') {
        widget.items[0].width = labelWidth;
      }
    });
  }

  applyInitialValues(config) {
    super.applyInitialValues(config);
    const me = this,
          {
      client,
      scheduleRange
    } = config,
          items = config.items = config.items || {},
          scheduleRangeField = items.scheduleRangeField = items.scheduleRangeField || {},
          rangesContainer = items.rangesContainer = items.rangesContainer || {},
          rangesContainerItems = rangesContainer.items = rangesContainer.items || {},
          filler = rangesContainerItems.filler = rangesContainerItems.filler || {},
          rangeStartField = rangesContainerItems.rangeStartField = rangesContainerItems.rangeStartField || {},
          rangeEndField = rangesContainerItems.rangeEndField = rangesContainerItems.rangeEndField || {};
    filler.width = me.L('labelWidth');
    scheduleRangeField.value = scheduleRangeField.value || scheduleRange;

    if (scheduleRangeField.value === _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_2__["ScheduleRange"].daterange) {
      rangesContainer.hidden = false;
    }

    const rangeStart = rangeStartField.value = rangeStartField.value || client.startDate;
    rangeStartField.max = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].max(client.startDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(client.endDate, -1, 'd'));
    let rangeEnd = rangeEndField.value || client.endDate; // This is the only place where we can validate date range before it gets to export feature

    if (rangeEnd <= rangeStart) {
      rangeEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(rangeStart, 1, 'd');
    }

    rangeEndField.value = rangeEnd;
    rangeEndField.min = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].min(client.endDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(client.startDate, 1, 'd'));
  }

}
SchedulerExportDialog._$name = 'SchedulerExportDialog';

/***/ }),

/***/ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js":
/*!***************************************************************!*\
  !*** ./lib/Scheduler/view/export/field/ScheduleRangeCombo.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleRangeCombo; });
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony import */ var _Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Grid/view/export/field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
var productName = 'gantt';


class ScheduleRangeCombo extends _Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ScheduleRangeCombo';
  } // Factoryable type name


  static get type() {
    return 'schedulerangecombo';
  }

  static get defaultConfig() {
    return {
      editable: false
    };
  }

  buildLocalizedItems() {
    // Do not remove. Assertion strings for Localization sanity check.
    // 'L{completeview}'
    // 'L{currentview}'
    // 'L{daterange}'
    // 'L{completedata}'
    return Object.entries(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_0__["ScheduleRange"]).map(([id, text]) => ({
      id,
      text: this.L(text)
    }));
  }

} // Register this widget type with its Factory

ScheduleRangeCombo.initClass();
ScheduleRangeCombo._$name = 'ScheduleRangeCombo';

/***/ }),

/***/ "./lib/Scheduler/view/mixin/EventNavigation.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/EventNavigation.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'gantt';




/**
 * @module Scheduler/view/mixin/EventNavigation
 */

const preventDefault = e => e.preventDefault();
/**
 * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class EventNavigation extends Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'EventNavigation';
  } //region Default config


  static get configurable() {
    return {
      /**
       * A config object to use when creating the {@link Core.helper.util.Navigator}
       * to use to perform keyboard navigation in the timeline.
       * @config {Object}
       * @default
       * @category Misc
       * @internal
       */
      navigator: {
        allowCtrlKey: true,
        scrollSilently: true,
        keys: {
          Space: 'onEventSpaceKey',
          Enter: 'onEventEnterKey',
          Delete: 'onDeleteKey',
          Backspace: 'onDeleteKey'
        }
      }
    };
  }

  static get defaultConfig() {
    return {
      /**
       * A CSS class name to add to focused events.
       * @config {String}
       * @default
       * @category CSS
       * @private
       */
      focusCls: 'b-active',

      /**
       * Allow using [Delete] and [Backspace] to remove events/assignments
       * @config {Boolean}
       * @default
       * @category Misc
       */
      enableDeleteKey: true,
      // Number in milliseconds to buffer handlers execution. See `Delayable.throttle` function docs.
      onDeleteKeyBuffer: 500,
      navigatePreviousBuffer: 200,
      navigateNextBuffer: 200,
      testConfig: {
        onDeleteKeyBuffer: 1
      }
    };
  } //endregion
  //region Events

  /**
   * Fired when a user gesture causes the active item to change.
   * @event navigate
   * @param {Event} event The browser event which instigated navigation. May be a click or key or focus event.
   * @param {HTMLElement|null} item The newly active item, or `null` if focus moved out.
   * @param {HTMLElement|null} oldItem The previously active item, or `null` if focus is moving in.
   */
  //endregion


  construct(config) {
    const me = this;
    me.isInTimeAxis = me.isInTimeAxis.bind(me);
    me.onDeleteKey = me.throttle(me.onDeleteKey, me.onDeleteKeyBuffer, me);
    super.construct(config);
  }

  changeNavigator(navigator) {
    const me = this;
    me.getConfig('subGridConfigs');
    return new _Core_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_1__["default"](me.constructor.mergeConfigs({
      ownerCmp: me,
      target: me.timeAxisSubGridElement,
      processEvent: me.processEvent,
      itemSelector: `.${me.eventCls}-wrap`,
      focusCls: me.focusCls,
      navigatePrevious: me.throttle(me.navigatePrevious, {
        delay: me.navigatePreviousBuffer,
        throttled: preventDefault
      }),
      navigateNext: me.throttle(me.navigateNext, {
        delay: me.navigateNextBuffer,
        throttled: preventDefault
      })
    }, navigator));
  }

  doDestroy() {
    this.navigator.destroy();
    super.doDestroy();
  }

  isInTimeAxis(record) {
    // If event is hidden by workingTime configs, horizontal mapper would raise a flag on instance meta
    // We still need to check if time span is included in axis
    return !record.instanceMeta(this).excluded && this.timeAxis.isTimeSpanInAxis(record);
  }
  /*
   * Override of GridNavigation#focusCell method to handle the TimeAxisColumn.
   * Not needed until we implement full keyboard accessibility.
   */


  accessibleFocusCell(cellSelector, options) {
    const me = this;
    cellSelector = me.normalizeCellContext(cellSelector);

    if (cellSelector.columnId === me.timeAxisColumn.id) {// const lastFocusedCell        = me.lastFocusedCell = me._focusedCell,
      //     lastFocusedCellElement = lastFocusedCell && me.getCell(lastFocusedCell),
      //     newCell = me.getCell(cellSelector),
      //     // Flag if the lastFocusedCellElement is DOCUMENT_POSITION_FOLLOWING newCell
      //     backwards = !!(lastFocusedCellElement && (newCell.compareDocumentPosition(lastFocusedCellElement) & 4));
      // // Navigating into the Scheduler, need to enable this back (for situations where we know focus was requested as a result of a keyboard input)...
      // let newEvent = me.getRecordFromElement(newCell);
      // me._focusedCell = cellSelector;
      // // Scheduler where row is a Resource which might have many events
      // // TODO: https://app.assembla.com/spaces/bryntum/tickets/6526 this class should
      // // not know about Gantt.
      // if (!newEvent.isTask) {
      //     const resourceEvents = newEvent.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate);
      //     newEvent = resourceEvents[backwards ? resourceEvents.length - 1 : 0];
      // }
      // options.event.eventRecord = newEvent;
      // if (newEvent && me.activeEvent !== newEvent) {
      //     lastFocusedCellElement && lastFocusedCellElement.classList.remove('b-focused');
      //     me.scrollResourceEventIntoView(me.store.getById(cellSelector.id), newEvent, null, {
      //         animate : 100
      //     }).then(() => {
      //         me.activeEvent = newEvent;
      //     });
      // }
    } else {
      return super.focusCell(cellSelector, options);
    }
  } // Interface method to extract the navigated to record from a populated 'navigate' event.
  // Gantt, Scheduler and Calendar handle event differently, adding different properties to it.
  // This method is meant to be overridden to return correct target from event


  normalizeTarget(event) {
    return event.assignmentRecord;
  }

  getPrevious(assignmentRecord, isDelete) {
    const me = this,
          {
      resourceStore
    } = me,
          {
      eventSorter
    } = me.currentOrientation,
          // start/end dates are required to limit time span to look at in case recurrence feature is enabled
    {
      startDate,
      endDate
    } = me.timeAxis,
          eventRecord = assignmentRecord.event,
          resourceEvents = me.eventStore.getEvents({
      resourceRecord: assignmentRecord.resource,
      startDate,
      endDate
    }).filter(this.isInTimeAxis).sort(eventSorter);
    let resourceRecord = assignmentRecord.resource,
        previousEvent = resourceEvents[resourceEvents.indexOf(eventRecord) - 1]; // At first event for resource, traverse up the resource store.

    if (!previousEvent) {
      // If we are deleting an event, skip other instances of the event which we may encounter
      // due to multi-assignment.
      for (let rowIdx = resourceStore.indexOf(resourceRecord) - 1; (!previousEvent || isDelete && previousEvent === eventRecord) && rowIdx >= 0; rowIdx--) {
        resourceRecord = resourceStore.getAt(rowIdx);
        const events = me.eventStore.getEvents({
          resourceRecord,
          startDate,
          endDate
        }).filter(me.isInTimeAxis).sort(eventSorter);
        previousEvent = events.length && events[events.length - 1];
      }
    }

    return me.assignmentStore.getAssignmentForEventAndResource(previousEvent, resourceRecord);
  }

  navigatePrevious(keyEvent) {
    const me = this,
          previousAssignment = me.getPrevious(me.normalizeTarget(keyEvent));
    keyEvent.preventDefault();

    if (previousAssignment) {
      if (!keyEvent.ctrlKey) {
        me.clearEventSelection();
      }

      return me.navigateTo(previousAssignment, keyEvent);
    }
  }

  getNext(assignmentRecord, isDelete) {
    const me = this,
          {
      resourceStore
    } = me,
          {
      eventSorter
    } = me.currentOrientation,
          // start/end dates are required to limit time span to look at in case recurrence feature is enabled
    {
      startDate,
      endDate
    } = me.timeAxis,
          eventRecord = assignmentRecord.event,
          resourceEvents = me.eventStore.getEvents({
      resourceRecord: assignmentRecord.resource,
      // start/end are required to limit time
      startDate,
      endDate
    }).filter(this.isInTimeAxis).sort(eventSorter);
    let resourceRecord = assignmentRecord.resource,
        nextEvent = resourceEvents[resourceEvents.indexOf(eventRecord) + 1]; // At last event for resource, traverse down the resource store

    if (!nextEvent) {
      // If we are deleting an event, skip other instances of the event which we may encounter
      // due to multi-assignment.
      for (let rowIdx = resourceStore.indexOf(resourceRecord) + 1; (!nextEvent || isDelete && nextEvent === eventRecord) && rowIdx < resourceStore.count; rowIdx++) {
        resourceRecord = resourceStore.getAt(rowIdx);
        const events = me.eventStore.getEvents({
          resourceRecord,
          startDate,
          endDate
        }).filter(me.isInTimeAxis).sort(eventSorter);
        nextEvent = events[0];
      }
    }

    return me.assignmentStore.getAssignmentForEventAndResource(nextEvent, resourceRecord);
  }

  navigateNext(keyEvent) {
    const me = this,
          nextAssignment = me.getNext(me.normalizeTarget(keyEvent));
    keyEvent.preventDefault();

    if (nextAssignment) {
      if (!keyEvent.ctrlKey) {
        me.clearEventSelection();
      }

      return me.navigateTo(nextAssignment, keyEvent);
    }
  }

  async navigateTo(targetAssignment, uiEvent = {}) {
    const me = this;

    if (targetAssignment) {
      // No key processing during scroll
      me.navigator.disabled = true;
      await me.scrollAssignmentIntoView(targetAssignment, null, {
        animate: 100
      }); // Panel can be destroyed before promise is resolved.
      // Perform a sanity check to make sure element is still in the DOM (syncIdMap actually).

      if (!me.isDestroyed && this.getElementFromAssignmentRecord(targetAssignment)) {
        me.navigator.disabled = false;
        me.activeAssignment = targetAssignment;
        me.navigator.trigger('navigate', {
          event: uiEvent,
          item: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(me.getElementFromAssignmentRecord(targetAssignment), me.navigator.itemSelector)
        });
      }
    }
  }

  set activeAssignment(assignmentRecord) {
    const assignmentEl = this.getElementFromAssignmentRecord(assignmentRecord);
    this.navigator.activeItem = assignmentEl.parentNode;
  }

  get activeAssignment() {
    const {
      activeItem
    } = this.navigator;

    if (activeItem) {
      return this.resolveAssignmentRecord(activeItem);
    }
  }

  get previousActiveEvent() {
    const {
      previousActiveItem
    } = this.navigator;

    if (previousActiveItem) {
      return this.resolveEventRecord(previousActiveItem);
    }
  }

  processEvent(keyEvent) {
    const me = this,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(keyEvent.target, me.eventSelector);

    if (!me.navigator.disabled && eventElement) {
      keyEvent.assignmentRecord = me.resolveAssignmentRecord(eventElement);
      keyEvent.eventRecord = me.resolveEventRecord(eventElement);
      keyEvent.resourceRecord = me.resolveResourceRecord(eventElement);
    }

    return keyEvent;
  }

  onDeleteKey(keyEvent) {
    const me = this;

    if (!me.readOnly && me.enableDeleteKey) {
      const records = me.eventStore.usesSingleAssignment ? me.selectedEvents : me.selectedAssignments;
      me.removeEvents(records);
    }
  }
  /**
   * Internal utility function to remove events. Used when pressing [DELETE] or [BACKSPACE] or when clicking the
   * delete button in the event editor. Triggers a preventable `beforeEventDelete` or `beforeAssignmentDelete` event.
   * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} eventRecords Records to remove
   * @param {Function} [callback] Optional callback executed after triggering the event but before deletion
   * @returns {Boolean} Returns `false` if the operation was prevented, otherwise `true`
   * @internal
   * @fires beforeEventDelete
   * @fires beforeAssignmentDelete
   */


  removeEvents(eventRecords, callback = null) {
    const me = this;

    if (!me.readOnly && eventRecords.length) {
      const context = {
        finalize(removeRecord = true) {
          if (callback) {
            callback(removeRecord);
          }

          if (removeRecord !== false) {
            if (eventRecords.some(record => {
              var _record$event;

              return record.isOccurrence || ((_record$event = record.event) === null || _record$event === void 0 ? void 0 : _record$event.isOccurrence);
            })) {
              eventRecords.forEach(record => record.isOccurrenceAssignment ? record.event.remove() : record.remove());
            } else {
              const store = eventRecords[0].isAssignment ? me.assignmentStore : me.eventStore;
              store.remove(eventRecords);
            }
          }
        }

      };
      let shouldFinalize;

      if (eventRecords[0].isAssignment) {
        /**
         * Fires before an assignment is removed. Can be triggered by user pressing [DELETE] or [BACKSPACE] or
         * by the event editor. Can for example be used to display a custom dialog to confirm deletion, in which
         * case records should be "manually" removed after confirmation:
         *
         * ```javascript
         * scheduler.on({
         *    beforeAssignmentDelete({ assignmentRecords, context }) {
         *        // Show custom confirmation dialog (pseudo code)
         *        confirm.show({
         *            listeners : {
         *                onOk() {
         *                    // Remove the assignments on confirmation
         *                    context.finalize(true);
         *                },
         *                onCancel() {
         *                    // do not remove the assignments if "Cancel" clicked
         *                    context.finalize(false);
         *                }
         *            }
         *        });
         *
         *        // Prevent default behaviour
         *        return false;
         *    }
         * });
         * ```
         *
         * @event beforeAssignmentDelete
         * @param {Scheduler.view.Scheduler} source  The Scheduler instance
         * @param {Scheduler.model.EventModel[]} eventRecords  The records about to be deleted
         * @param {Object} context  Additional removal context:
         * @param {Function} context.finalize  Function to call to finalize the removal.
         *      Used to asynchronously decide to remove the records or not. Provide `false` to the function to
         *      prevent the removal.
         * @param {Boolean} [context.finalize.removeRecords = true]   Provide `false` to the function to prevent
         *      the removal.
         * @preventable
         */
        shouldFinalize = me.trigger('beforeAssignmentDelete', {
          assignmentRecords: eventRecords,
          context
        });
      } else {
        /**
         * Fires before an event is removed. Can be triggered by user pressing [DELETE] or [BACKSPACE] or by the
         * event editor. Can for example be used to display a custom dialog to confirm deletion, in which case
         * records should be "manually" removed after confirmation:
         *
         * ```javascript
         * scheduler.on({
         *    beforeEventDelete({ eventRecords, context }) {
         *        // Show custom confirmation dialog (pseudo code)
         *        confirm.show({
         *            listeners : {
         *                onOk() {
         *                    // Remove the events on confirmation
         *                    context.finalize(true);
         *                },
         *                onCancel() {
         *                    // do not remove the events if "Cancel" clicked
         *                    context.finalize(false);
         *                }
         *            }
         *        });
         *
         *        // Prevent default behaviour
         *        return false;
         *    }
         * });
         * ```
         *
         * @event beforeEventDelete
         * @param {Scheduler.view.Scheduler} source  The Scheduler instance
         * @param {Scheduler.model.EventModel[]} eventRecords  The records about to be deleted
         * @param {Object} context  Additional removal context:
         * @param {Function} context.finalize  Function to call to finalize the removal.
         *      Used to asynchronously decide to remove the records or not. Provide `false` to the function to
         *      prevent the removal.
         * @param {Boolean} [context.finalize.removeRecords = true]  Provide `false` to the function to prevent
         *      the removal.
         * @preventable
         */
        shouldFinalize = me.trigger('beforeEventDelete', {
          eventRecords,
          context
        });
      }

      if (shouldFinalize !== false) {
        context.finalize();
        return true;
      }
    }

    return false;
  }

  onEventSpaceKey(keyEvent) {// Empty, to be chained by features
  }

  onEventEnterKey(keyEvent) {// Empty, to be chained by features
  }

  get isActionableLocation() {
    // Override from grid if the Navigator's location is an event (or task if we're in Gantt)
    // Being focused on a task/event means that it's *not* actionable. It's not valid to report
    // that we're "inside" the cell in a TimeLine, so ESC must not attempt to focus the cell.
    if (!this.navigator.activeItem) {
      return super.isActionableLocation;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/EventSelection.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/EventSelection.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/view/mixin/EventSelection
 */

/**
 * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class EventSelection extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'EventSelection';
  } //region Default config


  static get configurable() {
    return {
      /**
       * Configure as `true`, or set property to `true` to highlight dependent events as well when selecting an event.
       * @config {Boolean}
       * @default
       * @category Selection
       */
      highlightPredecessors: false,

      /**
       * Configure as `true`, or set property to `true` to highlight dependent events as well when selecting an event.
       * @config {Boolean}
       * @default
       * @category Selection
       */
      highlightSuccessors: false
    };
  }

  static get defaultConfig() {
    return {
      /**
       * Configure as `true` to allow `CTRL+click` to select multiple events in the scheduler.
       * @config {Boolean}
       * @category Selection
       */
      multiEventSelect: false,

      /**
       * Configure as `true`, or set property to `true` to disable event selection.
       * @config {Boolean}
       * @default
       * @category Selection
       */
      eventSelectionDisabled: false,

      /**
       * CSS class to add to selected events.
       * @config {String}
       * @default
       * @category CSS
       * @private
       */
      eventSelectedCls: 'b-sch-event-selected',

      /**
       * Configure as `true` to trigger `selectionChange` when removing a selected event/assignment.
       * @config {Boolean}
       * @default
       * @category Selection
       */
      triggerSelectionChangeOnRemove: false,

      /**
       * This flag controls whether Scheduler should preserve its selection of events when loading a new dataset
       * (if selected event ids are included in the newly loaded dataset).
       * @config {Boolean}
       * @default
       * @category Selection
       */
      maintainSelectionOnDatasetChange: true,

      /**
       * CSS class to add to other instances of a selected event, to highlight them.
       * @config {String}
       * @default
       * @category CSS
       * @private
       */
      eventAssignHighlightCls: 'b-sch-event-assign-selected',

      /**
       * Collection to store selection.
       * @config {Core.util.Collection}
       * @private
       */
      selectedCollection: {}
    };
  } //endregion
  //region Events

  /**
   * Fired any time there is a change to the events selected in the Scheduler.
   * @event eventSelectionChange
   * @param {String} action One of the actions 'select', 'deselect', 'update', 'clear'
   * @param {Scheduler.model.EventModel[]} selected An array of the Events added to the selection.
   * @param {Scheduler.model.EventModel[]} deselected An array of the Event removed from the selection.
   * @param {Scheduler.model.EventModel[]} selection The new selection.
   */

  /**
   * Fired any time there is a change to the assignments selected in the Scheduler.
   * @event assignmentSelectionChange
   * @param {String} action One of the actions 'select', 'deselect', 'update', 'clear'
   * @param {Scheduler.model.AssignmentModel[]} selected An array of the Assignments added to the selection.
   * @param {Scheduler.model.AssignmentModel[]} deselected An array of the Assignments removed from the selection.
   * @param {Scheduler.model.AssignmentModel[]} selection The new selection.
   */
  //endregion
  //region Init


  afterConstruct() {
    var _this$navigator;

    super.afterConstruct();
    (_this$navigator = this.navigator) === null || _this$navigator === void 0 ? void 0 : _this$navigator.on({
      navigate: 'onEventNavigate',
      thisObj: this
    });
  } //endregion
  //region Selected Collection


  set selectedCollection(selectedCollection) {
    if (!(selectedCollection instanceof _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"])) {
      selectedCollection = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](selectedCollection);
    }

    this._selectedCollection = selectedCollection; // Fire row change events from onSelectedCollectionChange

    selectedCollection.on({
      change: 'onSelectedCollectionChange',
      thisObj: this
    });
  }

  get selectedCollection() {
    return this._selectedCollection;
  } //endregion
  //region Modify selection


  getEventsFromAssignments(assignments) {
    return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].unique(assignments.map(assignment => assignment.event));
  }
  /**
   * The {@link Scheduler.model.EventModel events} which are selected.
   * @property {Scheduler.model.EventModel[]}
   * @category Selection
   */


  get selectedEvents() {
    return this.getEventsFromAssignments(this.selectedCollection.values);
  }

  set selectedEvents(events) {
    // Select all assignments
    const assignments = [];

    if (events && !Array.isArray(events)) {
      events = [events];
    }

    events && events.forEach(event => {
      if (this.isEventSelectable(event) !== false) {
        assignments.push(...event.assignments);
      }
    }); // Replace the entire selected collection with the new record set

    this.selectedCollection.splice(0, this.selectedCollection.count, assignments);
  }
  /**
   * The {@link Scheduler.model.AssignmentModel events} which are selected.
   * @property {Scheduler.model.AssignmentModel[]}
   * @category Selection
   */


  get selectedAssignments() {
    return this.selectedCollection.values;
  }

  set selectedAssignments(assignments) {
    // Replace the entire selected collection with the new record set
    this.selectedCollection.splice(0, this.selectedCollection.count, assignments || []);
  }
  /**
   * Returns `true` if the {@link Scheduler.model.EventModel event} is selected.
   * @param {Scheduler.model.EventModel} event The event
   * @return {Boolean} Returns `true` if the event is selected
   * @category Selection
   */


  isEventSelected(event) {
    return this.selectedEvents.includes(event);
  }
  /**
   * A template method (empty by default) allowing you to control if an event can be selected or not.
   *
   * ```javascript
   * new Scheduler({
   *     isEventSelectable(event) {
   *         return event.startDate >= Date.now();
   *     }
   * })
   * ```
   *
   * @param {Scheduler.model.EventModel} event The event record
   * @returns {Boolean} true if event can be selected, otherwise false
   * @category Selection
   */


  isEventSelectable(event) {}
  /**
   * Returns `true` if the {@link Scheduler.model.AssignmentModel assignment} is selected.
   * @param {Scheduler.model.AssignmentModel} assignment The assignment
   * @return {Boolean} Returns `true` if the assignment is selected
   * @category Selection
   */


  isAssignmentSelected(assignment) {
    return this.selectedCollection.includes(assignment);
  }
  /**
   * Selects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
   * *if it is not selected*. Selecting events results in all their assignments being selected.
   * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} eventOrAssignment The event or assignment to select
   * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected events or assignments
   * @category Selection
   */


  select(eventOrAssignment, preserveSelection = false) {
    if (eventOrAssignment.isAssignment) {
      this.selectAssignment(eventOrAssignment, preserveSelection);
    } else {
      this.selectEvent(eventOrAssignment, preserveSelection);
    }
  }
  /**
   * Selects the passed {@link Scheduler.model.EventModel event} *if it is not selected*. Selecting an event will
   * select all its assignments.
   * @param {Scheduler.model.EventModel} event The event select
   * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected events
   * @category Selection
   */


  selectEvent(event, preserveSelection = false) {
    // If the event is already selected, this is a no-op.
    // In this case, selection must not be cleared even in the absence of preserveSelection
    if (!this.isEventSelected(event)) {
      this.selectEvents([event], preserveSelection);
    }
  }
  /**
   * Selects the passed {@link Scheduler.model.AssignmentModel assignment} *if it is not selected*.
   * @param {Scheduler.model.AssignmentModel} assignment The assignment to select
   * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected assignments
   * @category Selection
   */


  selectAssignment(assignment, preserveSelection = false) {
    // If the event is already selected, this is a no-op.
    // In this case, selection must not be cleared even in the absence of preserveSelection
    if (!this.isAssignmentSelected(assignment)) {
      preserveSelection ? this.selectedCollection.add(assignment) : this.selectedAssignments = assignment;
    }
  }
  /**
   * Deselects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
   * *if it is selected*.
   * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} eventOrAssignment The event or assignment to deselect.
   * @category Selection
   */


  deselect(eventOrAssignment) {
    if (eventOrAssignment.isAssignment) {
      this.deselectAssignment(eventOrAssignment);
    } else {
      this.deselectEvent(eventOrAssignment);
    }
  }
  /**
   * Deselects the passed {@link Scheduler.model.EventModel event} *if it is selected*.
   * @param {Scheduler.model.EventModel} event The event to deselect.
   * @category Selection
   */


  deselectEvent(event) {
    if (this.isEventSelected(event)) {
      this.selectedCollection.remove(...event.assignments);
    }
  }
  /**
   * Deselects the passed {@link Scheduler.model.AssignmentModel assignment} *if it is selected*.
   * @param {Scheduler.model.AssignmentModel} assignment The assignment to deselect
   * @category Selection
   */


  deselectAssignment(assignment) {
    if (this.isAssignmentSelected(assignment)) {
      this.selectedCollection.remove(assignment);
    }
  }
  /**
   * Adds {@link Scheduler.model.EventModel events} to the selection.
   * @param {Scheduler.model.EventModel[]} events Events to be selected
   * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected events
   * @category Selection
   */


  selectEvents(events, preserveSelection = false) {
    if (preserveSelection) {
      const assignments = events.reduce((assignments, event) => {
        if (this.isEventSelectable(event) !== false) {
          assignments.push(...event.assignments);
        }

        return assignments;
      }, []);
      this.selectedCollection.add(assignments);
    } else {
      this.selectedEvents = events;
    }
  }
  /**
   * Removes {@link Scheduler.model.EventModel events} from the selection.
   * @param {Scheduler.model.EventModel[]} events Events or assignments  to be deselected
   * @category Selection
   */


  deselectEvents(events) {
    this.selectedCollection.remove(events.reduce((assignments, event) => {
      assignments.push(...event.assignments);
      return assignments;
    }, []));
  }
  /**
   * Adds {@link Scheduler.model.AssignmentModel assignments} to the selection.
   * @param {Scheduler.model.AssignmentModel[]} assignments Assignments to be selected
   * @category Selection
   */


  selectAssignments(assignments) {
    this.selectedCollection.add(assignments);
  }
  /**
   * Removes {@link Scheduler.model.AssignmentModel assignments} from the selection.
   * @param {Scheduler.model.AssignmentModel[]} assignments Assignments  to be deselected
   * @category Selection
   */


  deselectAssignments(assignments) {
    this.selectedCollection.remove(assignments);
  }
  /**
   * Deselects all {@link Scheduler.model.EventModel events} and {@link Scheduler.model.AssignmentModel assignments}.
   * @category Selection
   */


  clearEventSelection() {
    this.selectedAssignments = [];
  } //endregion
  //region Events

  /**
   * Responds to mutations of the underlying selection Collection.
   * Keeps the UI synced, eventSelectionChange and assignmentSelectionChange event is fired when `me.silent` is falsy.
   * @private
   */


  onSelectedCollectionChange({
    added,
    removed
  }) {
    const me = this,
          selection = me.selectedAssignments,
          selected = added || [],
          deselected = removed || [];

    function updateSelection(assignmentRecord, select) {
      const eventRecord = assignmentRecord.event;

      if (eventRecord) {
        const element = me.getElementFromAssignmentRecord(assignmentRecord);
        me.currentOrientation.toggleCls(assignmentRecord, me.eventSelectedCls, select);
        me.getElementsFromEventRecord(eventRecord).forEach(el => {
          if (el !== element) {
            const otherAssignmentRecord = me.resolveAssignmentRecord(el);
            me.currentOrientation.toggleCls(otherAssignmentRecord, me.eventAssignHighlightCls, select);

            if (select) {
              // Need to force a reflow to get the highlightning animation triggered
              el.style.animation = 'none';
              el.offsetHeight;
              el.style.animation = '';
            }

            el.classList[select ? 'add' : 'remove'](me.eventAssignHighlightCls);
          }
        });
      }
    }

    deselected.forEach(record => updateSelection(record, false));
    selected.forEach(record => updateSelection(record, true));

    if (me.highlightSuccessors || me.highlightPredecessors) {
      me.highlightLinkedEvents(me.selectedEvents);
    } // To be able to restore selection after reloading resources (which might lead to regenerated assignments in
    // the single assignment scenario, so cannot rely on records or ids)


    me.$selectedAssignments = selection.map(assignment => ({
      eventId: assignment.eventId,
      resourceId: assignment.resourceId
    }));

    if (!me.silent) {
      const action = selection.length > 0 ? selected.length > 0 && deselected.length > 0 ? 'update' : selected.length > 0 ? 'select' : 'deselect' : 'clear';
      me.trigger('assignmentSelectionChange', {
        action,
        selection,
        selected,
        deselected
      });
      me.trigger('eventSelectionChange', {
        action,
        selection: me.selectedEvents,
        selected: me.getEventsFromAssignments(selected),
        deselected: me.getEventsFromAssignments(deselected)
      });
    }
  }
  /**
   * Assignment change listener to remove events from selection which are no longer in the assignments.
   * @private
   */


  onAssignmentChange({
    action,
    records: assignments
  }) {
    const me = this;
    me.silent = !me.triggerSelectionChangeOnRemove;

    if (action === 'remove') {
      me.deselectAssignments(assignments);
    } else if (action === 'removeall' && !me.eventStore.isSettingData) {
      me.clearEventSelection();
    } else if (action === 'dataset' && me.$selectedAssignments) {
      if (!me.maintainSelectionOnDatasetChange) {
        me.clearEventSelection();
      } else {
        const newAssignments = me.$selectedAssignments.map(selector => assignments.find(a => a.eventId === selector.eventId && a.resourceId === selector.resourceId));
        me.selectedAssignments = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clean(newAssignments);
      }
    }

    me.silent = false;
  }

  onInternalEventStoreChange({
    source,
    action,
    records
  }) {
    // Setting empty event dataset cannot be handled in onAssignmentChange above, no assignments might be affected
    if (!source.isResourceTimeRangeStore && action === 'dataset' && !records.length) {
      this.clearEventSelection();
    }

    super.onInternalEventStoreChange(...arguments);
  }
  /**
   * Mouse listener to update selection.
   * @private
   */


  onAssignmentSelectionClick(event, clickedRecord) {
    const me = this; // Multi selection: CTRL means preserve selection, just add or remove the event.
    // Single selection: CTRL deselects already selected event

    if (me.isAssignmentSelected(clickedRecord)) {
      event.ctrlKey && me.deselectAssignment(clickedRecord, me.multiEventSelect);
    } else if (this.isEventSelectable(clickedRecord.event) !== false) {
      me.selectAssignment(clickedRecord, event.ctrlKey && me.multiEventSelect);
    }
  }
  /**
   * Navigation listener to update selection.
   * @private
   */


  onEventNavigate({
    event,
    item
  }) {
    if (!this.eventSelectionDisabled) {
      const assignment = item && (item.nodeType === Element.ELEMENT_NODE ? this.resolveAssignmentRecord(item) : item);

      if (assignment) {
        this.clearFocus(true);
        this.onAssignmentSelectionClick(event, assignment);
      } // Click outside of an event/assignment;
      else {
        this.clearEventSelection();
      }
    }
  }

  changeHighlightSuccessors(value) {
    return this.changeLinkedEvents(value);
  }

  changeHighlightPredecessors(value) {
    return this.changeLinkedEvents(value);
  }

  changeLinkedEvents(value) {
    const me = this;

    if (value) {
      me.highlighted = me.highlighted || new Set();
      me.highlightLinkedEvents(me.selectedEvents);
    } else if (me.highlighted) {
      me.highlightLinkedEvents();
    }

    return value;
  } // Function that highlights/unhighlights events in a dependency chain


  highlightLinkedEvents(eventRecords = []) {
    const me = this,
          {
      highlighted
    } = me,
          dependenciesFeature = me.features.dependencies;
    me.eventStore.beginBatch(); // Unhighlight previously highlighted records

    highlighted.forEach(eventRecord => {
      if (!eventRecords.includes(eventRecord)) {
        eventRecord.$highlight = false;
        highlighted.delete(eventRecord);

        if (me.eventStore.includes(eventRecord)) {
          eventRecord.dependencies.forEach(dep => dependenciesFeature.unhighlight(dep, 'b-highlight'));
        }
      }
    });
    eventRecords.forEach(eventRecord => {
      const toWalk = [eventRecord]; // Collect all events along the dependency chain

      while (toWalk.length) {
        const record = toWalk.pop();
        highlighted.add(record);

        if (me.highlightSuccessors) {
          record.outgoingDeps.forEach(outgoing => {
            dependenciesFeature.highlight(outgoing, 'b-highlight');
            !highlighted.has(outgoing.toEvent) && toWalk.push(outgoing.toEvent);
          });
        }

        if (me.highlightPredecessors) {
          record.incomingDeps.forEach(incoming => {
            dependenciesFeature.highlight(incoming, 'b-highlight');
            !highlighted.has(incoming.fromEvent) && toWalk.push(incoming.fromEvent);
          });
        }
      } // Highlight them


      highlighted.forEach(record => record.$highlight = true);
    });
    me.eventStore.endBatch();

    if (eventRecords.length > 0) {
      // And flag schedulers element, to fade others out
      me.element.classList.add('b-highlighting');
    } else {
      // Fade all in again
      me.element.classList.remove('b-highlighting');
    }
  }

  onEventDataGenerated(renderData) {
    if (this.highlightSuccessors || this.highlightPredecessors) {
      renderData.cls['b-highlight'] = renderData.eventRecord.$highlight;
    }

    super.onEventDataGenerated(renderData);
  }

  updateProject(project, old) {
    // Clear selection when the whole world shifts :)
    this.clearEventSelection();
    super.updateProject(project, old);
  } //endregion


  doDestroy() {
    var _this$_selectedCollec;

    (_this$_selectedCollec = this._selectedCollection) === null || _this$_selectedCollec === void 0 ? void 0 : _this$_selectedCollec.destroy();
    super.doDestroy();
  } //region Getters/Setters
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {} //endregion


});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/RecurringEvents.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/RecurringEvents.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/mixin/RecurringEvents
 */

/**
 * A mixin that adds recurring events functionality to the Scheduler.
 *
 * The main purpose of the code in here is displaying  a {@link Scheduler.view.recurrence.RecurrenceConfirmationPopup special confirmation}
 * on user mouse dragging/resizing/deleting recurring events and their occurrences.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringEvents extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringEvents';
  }

  static get configurable() {
    return {
      /**
       * Enables showing occurrences of recurring events across the scheduler's time axis.
       *
       * Enables extra recurrence UI fields in the system-provided event editor.
       * @config {Boolean}
       * @default false
       * @category Scheduled events
       */
      enableRecurringEvents: false,
      recurrenceConfirmationPopup: {
        $config: ['lazy'],
        value: {
          type: 'recurrenceconfirmation'
        }
      }
    };
  }

  construct(config) {
    super.construct(config);
    this.on({
      beforeeventdropfinalize: 'onRecurrableBeforeEventDropFinalize',
      beforeeventresizefinalize: 'onRecurrableBeforeEventResizeFinalize',
      beforeEventDelete: 'onRecurrableEventBeforeDelete',
      beforeAssignmentDelete: 'onRecurrableAssignmentBeforeDelete',
      thisObj: this
    });
  }

  changeRecurrenceConfirmationPopup(recurrenceConfirmationPopup, oldRecurrenceConfirmationPopup) {
    // Widget.reconfigure reither reconfigures an existing instance, or creates a new one, or,
    // if the configuration is null, destroys the existing instance.
    const result = this.constructor.reconfigure(oldRecurrenceConfirmationPopup, recurrenceConfirmationPopup, 'recurrenceconfirmation');
    result.owner = this;
    return result;
  }

  findRecurringEventToConfirmDelete(eventRecords) {
    const {
      eventEdit
    } = this.features; // show confirmation if we deal with at least one recurring event (or its occurrence)
    // and if the record is not being edited by event editor (since event editor has its own confirmation)

    return eventRecords.find(eventRecord => eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence) && (!eventEdit || !eventEdit.isEditing || eventEdit.eventRecord !== eventRecord));
  }

  onRecurrableEventBeforeDelete({
    eventRecords,
    context
  }) {
    const eventRecord = this.findRecurringEventToConfirmDelete(eventRecords);

    if (this.enableRecurringEvents && eventRecord) {
      this.recurrenceConfirmationPopup.confirm({
        actionType: 'delete',
        eventRecord,

        changerFn() {
          context.finalize(true);
        },

        cancelFn() {
          context.finalize(false);
        }

      });
      return false;
    }
  }

  onRecurrableAssignmentBeforeDelete({
    assignmentRecords,
    context
  }) {
    const eventRecords = assignmentRecords.map(as => as.event),
          eventRecord = this.findRecurringEventToConfirmDelete(eventRecords);

    if (this.enableRecurringEvents && eventRecord) {
      this.recurrenceConfirmationPopup.confirm({
        actionType: 'delete',
        eventRecord,

        changerFn() {
          context.finalize(true);
        },

        cancelFn() {
          context.finalize(false);
        }

      });
      return false;
    }
  }

  onRecurrableBeforeEventDropFinalize({
    context
  }) {
    if (this.enableRecurringEvents) {
      const {
        eventRecords
      } = context,
            recurringEvents = eventRecords.filter(eventRecord => eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence));

      if (recurringEvents.length) {
        context.async = true;
        this.recurrenceConfirmationPopup.confirm({
          actionType: 'update',
          eventRecord: recurringEvents[0],

          changerFn() {
            context.finalize(true);
          },

          cancelFn() {
            context.finalize(false);
          }

        });
      }
    }
  }

  onRecurrableBeforeEventResizeFinalize({
    context
  }) {
    if (this.enableRecurringEvents) {
      const {
        eventRecord
      } = context,
            isRecurring = eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence);

      if (isRecurring) {
        context.async = true;
        this.recurrenceConfirmationPopup.confirm({
          actionType: 'update',
          eventRecord,

          changerFn() {
            context.finalize(true);
          },

          cancelFn() {
            context.finalize(false);
          }

        });
      }
    }
  }
  /**
   * Returns occurrences of the provided recurring event across the date range of this Scheduler.
   * @param  {Scheduler.model.TimeSpan} recurringEvent Recurring event for which occurrences should be retrieved.
   * @return {Scheduler.model.TimeSpan[]} Array of the provided timespans occurrences.
   *
   * __Empty if the passed event is not recurring, or has no occurrences in the date range.__
   *
   * __If the date range encompasses the start point, the recurring event itself will be the first entry.__
   */


  getOccurrencesFor(recurringEvent) {
    return this.eventStore.getOccurrencesForTimeSpan(recurringEvent, this.timeAxis.startDate, this.timeAxis.endDate);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerDom.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerDom.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/mixin/SchedulerDom
 */

/**
 * Mixin with EventModel and ResourceModel <-> HTMLElement mapping functions
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerDom extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerDom';
  } //region Get

  /**
   * Returns a single HTMLElement representing an event record assigned to a specific resource.
   * @param {Scheduler.model.AssignmentModel} assignmentRecord An assignment record
   * @return {HTMLElement} The element representing the event record
   */


  getElementFromAssignmentRecord(assignmentRecord, returnWrapper = false) {
    return this.currentOrientation.getElementFromAssignmentRecord(assignmentRecord, returnWrapper);
  }
  /**
   * Returns a single HTMLElement representing an event record assigned to a specific resource.
   * @param {Scheduler.model.EventModel} eventRecord An event record
   * @param {Scheduler.model.ResourceModel} resourceRecord A resource record
   * @return {HTMLElement} The element representing the event record
   */


  getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper = false) {
    if (eventRecord.isResourceTimeRange) {
      var _this$foregroundCanva;

      const wrapper = (_this$foregroundCanva = this.foregroundCanvas.syncIdMap) === null || _this$foregroundCanva === void 0 ? void 0 : _this$foregroundCanva[eventRecord.domId];
      return returnWrapper ? wrapper : wrapper === null || wrapper === void 0 ? void 0 : wrapper.syncIdMap.event;
    }

    return this.currentOrientation.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper);
  }
  /**
   * Returns all the HTMLElements representing an event record.
   *
   * @param {Scheduler.model.EventModel} eventRecord An event record
   * @param {Scheduler.model.ResourceModel} [resourceRecord] A resource record
   *
   * @return {HTMLElement[]} The element(s) representing the event record
   */


  getElementsFromEventRecord(eventRecord, resourceRecord, returnWrapper = false) {
    return this.currentOrientation.getElementsFromEventRecord(eventRecord, resourceRecord, returnWrapper);
  } //endregion
  //region Resolve

  /**
   * Resolves the resource based on a dom element or event. In vertical mode, if resolving from an element higher up in
   * the hierarchy than event elements, then it is required to supply an coordinates since resources are virtual
   * columns.
   * @param {HTMLElement|Event} elementOrEvent The HTML element or DOM event to resolve a resource from
   * @param {Number[]} [xy] X and Y coordinates, required in some cases in vertical mode, disregarded in horizontal
   * @return {Scheduler.model.ResourceModel} The resource corresponding to the element, or null if not found.
   */


  resolveResourceRecord(elementOrEvent, xy) {
    return this.currentOrientation.resolveRowRecord(elementOrEvent, xy);
  }
  /**
   * Returns the event record for a DOM element
   * @param {HTMLElement} element The DOM node to lookup
   * @return {Scheduler.model.EventModel} The event record
   */


  resolveEventRecord(element) {
    element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, this.eventSelector);

    if (element) {
      if (element.dataset.eventId) {
        return this.eventStore.getById(element.dataset.eventId);
      }

      if (element.dataset.assignmentId) {
        return this.assignmentStore.getById(element.dataset.assignmentId).event;
      }
    }

    return null;
  } // Used by shared features to resolve an event or task


  resolveTimeSpanRecord(element) {
    return this.resolveEventRecord(element);
  }
  /**
   * Returns an assignment record for a DOM element
   * @param {HTMLElement} element The DOM node to lookup
   * @return {Scheduler.model.AssignmentModel} The assignment record
   */


  resolveAssignmentRecord(element) {
    const eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, this.eventSelector),
          assignmentRecord = eventElement && this.assignmentStore.getById(eventElement.dataset.assignmentId),
          eventRecord = eventElement && this.eventStore.getById(eventElement.dataset.eventId); // When resolving a recurring event, we might be resolving an occurrence

    return this.assignmentStore.getOccurrence(assignmentRecord, eventRecord);
  } //endregion
  // Decide if a record is inside a collapsed tree node, or inside a collapsed group (using grouping feature)


  isRowVisible(resourceRecord) {
    // records in collapsed groups/branches etc are removed from processedRecords
    return this.store.indexOf(resourceRecord) >= 0;
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerDomEvents.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerDomEvents.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/mixin/SchedulerDomEvents
 */

/**
 * Mixin that handles dom events (click etc) for scheduler and rendered events.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerDomEvents extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerDomEvents';
  } //region Events

  /**
   * Triggered when user moves mouse over an empty area in the schedule.
   * @event scheduleMouseMove
   * @param {Scheduler.view.TimelineBase} source This TimelineBase
   * @param {Date} date Date at mouse position
   * @param {Date} tickStartDate The start date of the current time axis tick
   * @param {Date} tickEndDate The end date of the current time axis tick
   * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
   * @param {Number} index Index of clicked resource
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered when user clicks an empty area in the schedule.
   * @event scheduleClick
   * @param {Scheduler.view.TimelineBase} source This TimelineBase
   * @param {Date} date Date at mouse position
   * @param {Date} tickStartDate The start date of the current time axis tick
   * @param {Date} tickEndDate The end date of the current time axis tick
   * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
   * @param {Number} index Index of clicked resource
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered when user clicks an empty area in the schedule.
   * @event scheduleDblClick
   * @param {Scheduler.view.TimelineBase} source This TimelineBase
   * @param {Date} date Date at mouse position
   * @param {Date} tickStartDate The start date of the current time axis tick
   * @param {Date} tickEndDate The end date of the current time axis tick
   * @param {Grid.row.Row} row Double clicked row (in horizontal mode only)
   * @param {Number} index Index of double clicked resource
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered when user right clicks an empty area in the schedule.
   * @event scheduleContextMenu
   * @param {Scheduler.view.TimelineBase} source This TimelineBase
   * @param {Date} date Date at mouse position
   * @param {Date} tickStartDate The start date of the current time axis tick
   * @param {Date} tickEndDate The end date of the current time axis tick
   * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
   * @param {Number} index Index of clicked resource
   * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for mouse down on an event.
   * @event eventMouseDown
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for mouse up on an event.
   * @event eventMouseUp
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for click on an event.
   * @event eventClick
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for double click on an event.
   * @event eventDblClick
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for right click on an event.
   * @event eventContextMenu
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for mouse over on an event.
   * @event eventMouseOver
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */

  /**
   * Triggered for mouse out from an event.
   * @event eventMouseOut
   * @param {Scheduler.view.Scheduler} source This Scheduler
   * @param {Scheduler.model.EventModel} eventRecord Event record
   * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
   * @param {MouseEvent} event Browser event
   */
  //endregion
  //region Event handling


  getTimeSpanMouseEventParams(eventElement, event) {
    // May have hovered a record being removed / faded out
    const eventRecord = this.resolveEventRecord(eventElement);
    return eventRecord && {
      eventRecord,
      resourceRecord: this.resolveResourceRecord(eventElement),
      assignmentRecord: this.resolveAssignmentRecord(eventElement),
      eventElement,
      event
    };
  }

  getScheduleMouseEventParams(cellData, event) {
    const resourceRecord = this.isVertical ? this.resolveResourceRecord(event) : this.store.getById(cellData.id);
    return {
      resourceRecord
    };
  }
  /**
   * Relays keydown events as eventkeydown if we have a selected task.
   * @private
   */


  onElementKeyDown(event) {
    super.onElementKeyDown(event);
    const me = this;

    if (me.selectedEvents.length) {
      me.trigger(me.scheduledEventName + 'KeyDown', {
        eventRecords: me.selectedEvents,
        assignmentRecords: me.selectedAssignments,
        event,
        // TODO REMOVE FOR 5.0
        eventRecord: me.selectedEvents,
        assignmentRecord: me.selectedAssignments
      });
    }
  }
  /**
   * Relays keyup events as eventkeyup if we have a selected task.
   * @private
   */


  onElementKeyUp(event) {
    super.onElementKeyUp(event);
    const me = this;

    if (me.selectedEvents.length) {
      me.trigger(me.scheduledEventName + 'KeyUp', {
        eventRecords: me.selectedEvents,
        assignmentRecords: me.selectedAssignments,
        event,
        // TODO REMOVE FOR 5.0
        eventRecord: me.selectedEvents,
        assignmentRecord: me.selectedAssignments
      });
    }
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerEventRendering.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerEventRendering.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../eventlayout/HorizontalLayoutStack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js");
/* harmony import */ var _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../eventlayout/HorizontalLayoutPack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'gantt';









/**
 * @module Scheduler/view/mixin/SchedulerEventRendering
 */

/**
 * Layout data object used to render an event record.
 * @typedef {Object} EventRenderData
 * @property {Scheduler.model.EventModel} eventRecord Event instance
 * @property {Scheduler.model.ResourceModel} resourceRecord Assigned resource
 * @property {Scheduler.model.AssignmentModel} assignmentRecord Assignment instance
 * @property {Number} startMS Event start date time in milliseconds
 * @property {Number} endMS Event end date in milliseconds
 * @property {Number} height Calculated event element height
 * @property {Number} width Calculated event element width
 * @property {Number} top Calculated event element top position in the row (or column)
 * @property {Number} left Calculated event element left position in the row (or column)
 */

/**
 * Functions to handle event rendering (EventModel -> dom elements).
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerEventRendering extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerEventRendering';
  } //region Default config


  static get configurable() {
    return {
      /**
       * Position of the milestone text, either 'inside' (for short 1-char text) or 'outside' for longer text. Not
       * applicable when using {@link #config-milestoneLayoutMode}.
       * @config {String}
       * @default
       */
      milestoneTextPosition: 'outside',

      /**
       * Get/set overlap mode. See {@link #config-eventLayout} config, valid values are `stack` (horizontal), `pack`, `mixed`
       * (vertical) and `none`
       * @member {String|Object} eventLayout
       * @category Scheduled events
       */

      /**
       * This config defines how to handle overlapping events. Valid values are:
       * - `stack`, adjusts row height (only horizontal)
       * - `pack`, adjusts event height
       * - `mixed`, allows two events to overlap, more packs (only vertical)
       * - `none`, allows events to overlap
       *
       * This config can also accept an object:
       *
       * ```javascript
       * new Scheduler({
       *     eventLayout : { type : 'stack' }
       * })
       * ```
       *
       * @config {String|Object}
       * @default
       * @category Scheduled events
       */
      eventLayout: 'stack',
      internalEventLayout: null
    };
  }

  static get defaultConfig() {
    return {
      /**
       * An empty function by default, but provided so that you can override it. This function is called each time
       * an event is rendered into the schedule to render the contents of the event. It's called with the event,
       * its resource and a `renderData` object which allows you to populate data placeholders inside the event
       * template. **IMPORTANT** You should never modify any data on the EventModel inside this method.
       *
       * By default, the DOM markup of an event bar includes placeholders for 'cls' and 'style'. The cls property
       * is a {@link Core.helper.util.DomClassList} which will be added to the event element. The style property
       * is an inline style declaration for the event element.
       *
       * IMPORTANT: When returning content, be sure to consider how that content should be encoded to avoid XSS
       * (Cross-Site Scripting) attacks. This is especially important when including user-controlled data such as
       * the event's `name`. The function {@link Core.helper.StringHelper#function-encodeHtml-static} as well as
       * {@link Core.helper.StringHelper#function-xss-static} can be helpful in these cases.
       *
       * ```javascript
       *  eventRenderer({ eventRecord, resourceRecord, renderData }) {
       *      renderData.style = 'color:white';                 // You can use inline styles too.
       *
       *      // Property names with truthy values are added to the resulting elements CSS class.
       *      renderData.cls.isImportant = this.isImportant(eventRecord);
       *      renderData.cls.isModified = eventRecord.isModified;
       *
       *      // Remove a class name by setting the property to false
       *      renderData.cls[scheduler.generatedIdCls] = false;
       *
       *      // Or, you can treat it as a string, but this is less efficient, especially
       *      // if your renderer wants to *remove* classes that may be there.
       *      renderData.cls += ' extra-class';
       *
       *      return StringHelper.xss`${DateHelper.format(eventRecord.startDate, 'YYYY-MM-DD')}: ${eventRecord.name}`;
       *  }
       * ```
       *
       * @param {Object} detail An object containing the information needed to render an Event.
       * @param {Scheduler.model.EventModel} detail.eventRecord The event record.
       * @param {Scheduler.model.ResourceModel} detail.resourceRecord The resource record.
       * @param {Scheduler.model.AssignmentModel} detail.assignmentRecord The assignment record.
       * @param {Object} detail.renderData An object containing details about the event rendering.
       * @param {Scheduler.model.EventModel} detail.renderData.event The event record.
       * @param {Core.helper.util.DomClassList|String} detail.renderData.cls An object whose property names
       * represent the CSS class names to be added to the event bar element. Set a property's value to truthy or
       * falsy to add or remove the class name based on the property name. Using this technique, you do not have
       * to know whether the class is already there, or deal with concatenation.
       * @param {Core.helper.util.DomClassList|String} detail.renderData.wrapperCls An object whose property names
       * represent the CSS class names to be added to the event wrapper element. Set a property's value to truthy
       * or falsy to add or remove the class name based on the property name. Using this technique, you do not
       * have to know whether the class is already there, or deal with concatenation.
       * @param {Core.helper.util.DomClassList|String} detail.renderData.iconCls An object whose property names
       * represent the CSS class names to be added to an event icon element.
       *
       * Note that an element carrying this icon class is injected into the event element *after*
       * the renderer completes, *before* the renderer's created content.
       *
       * To disable this if the renderer takes full control and creates content using the iconCls,
       * you can set `renderData.iconCls = null`.
       * @param {Number} detail.renderData.left Vertical offset position (in pixels) on the time axis.
       * @param {Number} detail.renderData.width Width in pixels of the event element.
       * @param {Number} detail.renderData.height Height in pixels of the event element.
       * @param {String} detail.renderData.eventStyle The `eventStyle` of the event. Use this to apply custom
       * styles to the event DOM element
       * @param {String} detail.renderData.eventColor The `eventColor` of the event. Use this to set a custom
       * color for the rendered event
       * @param {Object[]} detail.renderData.children An array of DOM configs used as children to the
       * `b-sch-event` element. Can be populated with additional DOM configs to have more control over contents.
       * @returns {String|Object} A simple string, or a custom object which will be applied to the
       * {@link #config-eventBodyTemplate}, creating the actual HTML
       * @config {function}
       * @category Scheduled events
       */
      eventRenderer: null,

      /**
       * How to align milestones in relation to their startDate. Only applies when using a `milestoneLayoutMode`
       * other than `default`. Valid values are:
       * * start
       * * center (default)
       * * end
       * @config {String}
       * @default
       */
      milestoneAlign: 'center',

      /**
       * Factor representing the average char width in pixels used to determine milestone width when configured
       * with `milestoneLayoutMode: 'estimate'`.
       * @config {Number}
       * @default
       */
      milestoneCharWidth: 10,

      /**
       * How to handle milestones during event layout. Options are:
       * * default - Milestones do not affect event layout
       * * estimate - Milestone width is estimated by multiplying text length with Scheduler#milestoneCharWidth
       * * data - Milestone width is determined by checking EventModel#milestoneWidth
       * * measure - Milestone width is determined by measuring label width
       * Please note that currently text width is always determined using EventModel#name.
       * Also note that only 'default' is supported by eventStyles line, dashed and minimal.
       * @config {String}
       * @default
       * @category Scheduled events
       */
      milestoneLayoutMode: 'default',
      // This is determined by styling, in the future it should be measured
      milestoneMinWidth: 40,

      /**
       * `this` reference for the {@link #config-eventRenderer} function
       * @config {Object}
       * @category Scheduled events
       */
      eventRendererThisObj: null,

      /**
       * The class responsible for the packing horizontal event layout process.
       * Override this to take control over the layout process.
       * @config {Scheduler.eventlayout.HorizontalLayout}
       * @typings {typeof HorizontalLayout}
       * @default
       * @private
       * @category Misc
       */
      horizontalLayoutPackClass: _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * The class name responsible for the stacking horizontal event layout process.
       * Override this to take control over the layout process.
       * @config {Scheduler.eventlayout.HorizontalLayout}
       * @typings {typeof HorizontalLayout}
       * @default
       * @private
       * @category Misc
       */
      horizontalLayoutStackClass: _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * Override this method to provide a custom sort function to sort any overlapping events. By default,
       * overlapping events are laid out based on the start date. If the start date is equal, events with earlier
       * end date go first.
       *
       * Here's a sample sort function, sorting on start- and end date. If this function returns -1, then event a
       * is placed above event b.
       * ```javascript
       * horizontalEventSorterFn(a, b) {
       *
       *   const startA = a.startDate, endA = a.endDate;
       *   const startB = b.startDate, endB = b.endDate;
       *
       *   const sameStart = (startA - startB === 0);
       *
       *   if (sameStart) {
       *     return endA > endB ? -1 : 1;
       *   } else {
       *     return (startA < startB) ? -1 : 1;
       *   }
       * }
       * ```
       * @param  {Scheduler.model.EventModel} a First event
       * @param  {Scheduler.model.EventModel} b Second event
       * @return {Number} Return -1 to display a above b, 1 for b above a
       * @config {function}
       * @category Misc
       */
      horizontalEventSorterFn: null,

      /**
       * Field from EventModel displayed as text in the bar when rendering
       * @config {String}
       * @default
       * @category Scheduled events
       */
      eventBarTextField: 'name',

      /**
       * The template used to generate the markup of your events in the scheduler. To 'populate' the
       * eventBodyTemplate with data, use the {@link #config-eventRenderer} method
       * @config {Function}
       * @category Scheduled events
       */
      eventBodyTemplate: null,
      eventPositionMode: 'translate',
      eventScrollMode: 'move',

      /**
       * Specify `true` to force rendered events to fill entire ticks. This only affects rendering, events retain
       * their set start and end dates on the data level. When enabling this config you should probably also
       * disable EventDrag and EventResize, otherwise their behaviour will not be what a user expects.
       * @config {Boolean}
       * @default
       * @category Scheduled events
       */
      fillTicks: false,

      /**
       * By default scheduler fades events in on load. Specify `false` to prevent this animation or specify one
       * of the available animation types to use it (`true` equals `'fade-in'`):
       * * fade-in (default)
       * * slide-from-left
       * * slide-from-top
       * ```
       * // Slide events in from the left on load
       * scheduler = new Scheduler({
       *     useInitialAnimation : 'slide-from-left'
       * });
       * ```
       * @config {Boolean|String}
       * @default
       * @category Misc
       */
      useInitialAnimation: true,

      /**
       * A config object used to configure the resource columns in vertical mode.
       * See {@link Scheduler.view.ResourceHeader} for more details on available properties.
       *
       * ```
       * new Scheduler({
       *   resourceColumns : {
       *     columnWidth    : 100,
       *     headerRenderer : ({ resourceRecord }) => `${resourceRecord.id} - ${resourceRecord.name}`
       *   }
       * })
       * ```
       * @config {Object}
       * @category Resources
       */
      resourceColumns: null,

      /**
       * Path to load resource images from. Used by the resource header in vertical mode and the
       * {@link Scheduler.column.ResourceInfoColumn} in horizontal mode. Set this to display miniature
       * images for each resource using their `image` or `imageUrl` fields.
       *
       * * `image` represents image name inside the specified `resourceImagePath`,
       * * `imageUrl` represents fully qualified image URL.
       *
       *  If set and a resource has no `imageUrl` or `image` specified it will try show miniature using
       *  the resource's name with {@link #config-resourceImageExtension} appended.
       *
       * **NOTE**: The path should end with a `/`:
       *
       * ```
       * new Scheduler({
       *   resourceImagePath : 'images/resources/'
       * });
       * ```
       * @config {String}
       * @category Resources
       */
      resourceImagePath: null,

      /**
       * Generic resource image, used when provided `imageUrl` or `image` fields or path calculated from resource
       * name are all invalid. If left blank, resource name initials will be shown when no image can be loaded.
       * @default
       * @config {String}
       * @category Resources
       */
      defaultResourceImageName: null,

      /**
       * Resource image extension, used when creating image path from resource name.
       * @default
       * @config {String}
       * @category Resources
       */
      resourceImageExtension: '.jpg',

      /**
       * Controls how much space to leave between stacked event bars in px.
       *
       * Can be configured per resource by setting {@link Scheduler.model.mixin.ResourceModelMixin#field-barMargin resource.barMargin}.
       *
       * @config {Number} barMargin
       * @default
       * @category Scheduled events
       */

      /**
       * Control how much space to leave between the first event/last event and the resources edge (top/bottom
       * margin within the resource row in horizontal mode, left/right margin within the resource column in
       * vertical mode), in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
       *
       * Can be configured per resource by setting {@link Scheduler.model.mixin.ResourceModelMixin#field-resourceMargin resource.resourceMargin}.
       *
       * @config {Number}
       * @category Scheduled events
       */
      resourceMargin: null,
      // Used to animate events on first render
      isFirstRender: true,
      initialAnimationDuration: 2000
    };
  } //endregion
  //region Properties

  /**
   * Specify initial animation at runtime, see {@link #config-useInitialAnimation useInitialAnimation}
   * @member {Boolean|String} useInitialAnimation
   */
  //endregion
  //region Init


  get eventPrefix() {
    return this._eventPrefix;
  }

  set eventPrefix(eventPrefix) {
    this._eventPrefix = eventPrefix || this.id + '-';
  } //endregion
  //region Settings


  changeEventLayout(eventLayout) {
    // Pass layout config to internal config to normalize its form
    this.internalEventLayout = eventLayout; // Return normalized string type

    return this.internalEventLayout.type;
  }

  changeInternalEventLayout(eventLayout) {
    return this.getEventLayout(eventLayout);
  }

  updateInternalEventLayout(eventLayout, oldEventLayout) {
    const me = this;

    if (oldEventLayout) {
      me.element.classList.remove(`b-eventlayout-${oldEventLayout.type}`);
    }

    me.element.classList.add(`b-eventlayout-${eventLayout.type}`);

    if (!me.isConfiguring) {
      me.refreshWithTransition();
    }
  }
  /**
   * Get/set fillTicks setting. If set to true it forces the rendered events to fill entire ticks.
   * @property {String}
   * @category Scheduled events
   */


  get fillTicks() {
    return this._fillTicks;
  }

  set fillTicks(fill) {
    if (fill !== this._fillTicks) {
      this._fillTicks = fill;

      if (!this.isConfiguring) {
        this.refreshWithTransition();
      }
    }
  }
  /**
   * Control how much space to leave between the first event/last event and the resources edge (top/bottom margin
   * within the resource row in horizontal mode, left/right margin within the resource column in vertical mode),
   * in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
   *
   * Can be configured per resource by setting {@link Scheduler.model.mixin.ResourceModelMixin#field-resourceMargin resource.resourceMargin}.
   *
   * @member {Number} resourceMargin
   * @category Scheduled events
   */


  get useInitialAnimation() {
    return this._useInitialAnimation;
  }

  set useInitialAnimation(name) {
    const me = this;

    if (me._useInitialAnimation) {
      me.element.classList.remove(`b-initial-${me._useInitialAnimation}`);
    }

    me._useInitialAnimation = name === true ? 'fade-in' : name;

    if (name) {
      me.element.classList.add(`b-initial-${me._useInitialAnimation}`); // Transition block for FF, to not interfere with animations

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isFirefox) {
        me.element.classList.add('b-prevent-event-transitions');
      }
    }
  }

  set horizontalEventSorterFn(fn) {
    this._horizontalEventSorterFn = fn;

    if (this.rendered) {
      this.refreshWithTransition();
    }
  }

  get horizontalEventSorterFn() {
    return this._horizontalEventSorterFn;
  } //endregion
  //region Layout helpers
  // Wraps string config to object with type


  getEventLayout(value) {
    var _value;

    if ((_value = value) !== null && _value !== void 0 && _value.isModel) {
      value = value.eventLayout || this.internalEventLayout;
    }

    if (typeof value === 'string') {
      value = {
        type: value
      };
    }

    return value;
  }
  /**
   * Get event layout handler. The handler decides the vertical placement of events within a resource.
   * Returns null if no eventLayout is used (if {@link #config-eventLayout} is set to "none")
   * @internal
   * @returns {Scheduler.eventlayout.HorizontalLayout}
   * @readonly
   * @category Scheduled events
   */


  getEventLayoutHandler(eventLayout) {
    const me = this;

    if (!me.isHorizontal) {
      return null;
    }

    const {
      timeAxisViewModel,
      horizontal
    } = me,
          {
      type
    } = eventLayout;

    if (!me.layouts) {
      me.layouts = {};
    }

    switch (type) {
      // stack, adjust row height to fit all events
      case 'stack':
        {
          if (!me.layouts.horizontalStack) {
            me.layouts.horizontalStack = new me.horizontalLayoutStackClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
              scheduler: me,
              timeAxisViewModel,
              bandIndexToPxConvertFn: horizontal.layoutEventVerticallyStack,
              bandIndexToPxConvertThisObj: horizontal
            }, eventLayout));
          }

          return me.layouts.horizontalStack;
        }
      // pack, fit all events in available height by adjusting their height

      case 'pack':
        {
          if (!me.layouts.horizontalPack) {
            me.layouts.horizontalPack = new me.horizontalLayoutPackClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
              scheduler: me,
              timeAxisViewModel,
              bandIndexToPxConvertFn: horizontal.layoutEventVerticallyPack,
              bandIndexToPxConvertThisObj: horizontal
            }, eventLayout));
          }

          return me.layouts.horizontalPack;
        }

      default:
        return null;
    }
  } //endregion
  //region Resource header/columns
  // NOTE: The configs below are initially applied to the resource header in `TimeAxisColumn#set mode`


  set resourceColumns(config) {
    this._resourceColumns = config;
  }
  /**
   * Use it to manipulate resource column properties at runtime.
   * @property {Scheduler.view.ResourceHeader}
   * @readonly
   */


  get resourceColumns() {
    var _this$timeAxisColumn;

    return ((_this$timeAxisColumn = this.timeAxisColumn) === null || _this$timeAxisColumn === void 0 ? void 0 : _this$timeAxisColumn.resourceColumns) || this._resourceColumns;
  }
  /**
   * Get resource column width. Only applies to vertical mode. To set it, assign to
   * `scheduler.resourceColumns.columnWidth`.
   * @property {Number}
   * @readonly
   */


  get resourceColumnWidth() {
    return this.resourceColumns ? this.resourceColumns.columnWidth : null;
  } //endregion
  //region Event rendering
  // Chainable function called with the events to render for a specific resource. Allows features to add/remove.
  // Chained by ResourceTimeRanges


  getEventsToRender(resource, events) {
    return events;
  }
  /**
   * Rerenders events for specified resource (by rerendering the entire row).
   * @param {Scheduler.model.ResourceModel} resourceRecord
   */


  repaintEventsForResource(resourceRecord) {
    this.currentOrientation.repaintEventsForResource(resourceRecord);
  }
  /**
   * Rerenders the events for all resources connected to the specified event
   * @param {Scheduler.model.EventModel} eventRecord
   * @private
   */


  repaintEvent(eventRecord) {
    const resources = this.eventStore.getResourcesForEvent(eventRecord);
    resources.forEach(resourceRecord => this.repaintEventsForResource(resourceRecord));
  } // Returns a resource specific resourceMargin, falling back to Schedulers setting
  // This fn could be made public to allow hooking it as an alternative to only setting this in data


  getResourceMargin(resourceRecord) {
    var _resourceRecord$resou;

    return (_resourceRecord$resou = resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.resourceMargin) !== null && _resourceRecord$resou !== void 0 ? _resourceRecord$resou : this.resourceMargin;
  } // Returns a resource specific barMargin, falling back to Schedulers setting
  // This fn could be made public to allow hooking it as an alternative to only setting this in data


  getBarMargin(resourceRecord) {
    var _resourceRecord$barMa;

    return (_resourceRecord$barMa = resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.barMargin) !== null && _resourceRecord$barMa !== void 0 ? _resourceRecord$barMa : this.barMargin;
  } // Returns a resource specific rowHeight, falling back to Schedulers setting
  // Prio order: Height from record, configured height
  // This fn could be made public to allow hooking it as an alternative to only setting this in data


  getResourceHeight(resourceRecord) {
    var _resourceRecord$rowHe;

    return (_resourceRecord$rowHe = resourceRecord.rowHeight) !== null && _resourceRecord$rowHe !== void 0 ? _resourceRecord$rowHe : this.rowHeight;
  } // Similar to getResourceHeight(), but for usage later in the process to take height set by renderers into account.
  // Cant be used earlier in the process because then the row will grow
  // Prio order: Height requested by renderer, height from record, configured height


  getAppliedResourceHeight(resourceRecord) {
    var _row$maxRequestedHeig;

    const row = this.getRowById(resourceRecord);
    return (_row$maxRequestedHeig = row === null || row === void 0 ? void 0 : row.maxRequestedHeight) !== null && _row$maxRequestedHeig !== void 0 ? _row$maxRequestedHeig : this.getResourceHeight(resourceRecord);
  } // Combined convenience getter for destructuring on calling side


  getResourceLayoutSettings(resourceRecord) {
    return {
      resourceMargin: this.getResourceMargin(resourceRecord),
      barMargin: this.getBarMargin(resourceRecord),
      rowHeight: this.getAppliedResourceHeight(resourceRecord)
    };
  } //endregion
  //region Template

  /**
   * Generates data used in the template when rendering an event. For example which css classes to use. Also applies
   * #eventBodyTemplate and calls the {@link #config-eventRenderer}.
   * @private
   * @param {Scheduler.model.EventModel} eventRecord Event to generate data for
   * @param {Scheduler.model.ResourceModel} resourceRecord Events resource
   * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
   * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
   * which may be outside the rendered zone.
   * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
   * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
   * @returns {Object} Data to use in event template, or `undefined` if the event is outside of the rendered zone.
   */


  generateRenderData(eventRecord, resourceRecord, includeOutside = {
    viewport: true
  }) {
    // TODO: Change this fn to accept an assignment instead of event + resource
    const me = this,
          // generateRenderData calculates layout for events which are outside of the vertical viewport
    // because the RowManager needs to know a row height.
    renderData = me.currentOrientation.getTimeSpanRenderData(eventRecord, resourceRecord, includeOutside),
          {
      isEvent
    } = eventRecord,
          // Dont want events drag created to zero duration to render as milestones
    isMilestone = !eventRecord.meta.isDragCreating && eventRecord.isMilestone,
          assignmentRecord = isEvent && eventRecord.assignments.find(a => a.resourceId === resourceRecord.id),
          // Events inner element, will be populated by renderer and/or eventBodyTemplate
    eventContent = {
      className: 'b-sch-event-content',
      dataset: {
        taskBarFeature: 'content'
      }
    };

    if (renderData) {
      var _renderData$iconCls2;

      renderData.tabIndex = '0';
      let resizable = eventRecord.isResizable;

      if (renderData.startsOutsideView) {
        if (resizable === true) resizable = 'end';else if (resizable === 'start') resizable = false;
      }

      if (renderData.endsOutsideView) {
        if (resizable === true) resizable = 'start';else if (resizable === 'end') resizable = false;
      } // Event record cls properties are now DomClassList instances, so clone them
      // so that they can be manipulated here and by renderers.
      // Truthy value means the key will be added as a class name.
      // ResourceTimeRanges applies custom cls to wrapper.


      const clsListObj = {},
            wrapperClsListObj = {},
            clsList = eventRecord.isResourceTimeRange ? new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"]() : eventRecord.internalCls.clone(),
            wrapperClsList = eventRecord.isResourceTimeRange ? eventRecord.internalCls.clone() : new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
            // Boolean needed here, otherwise DomSync will dig into comparing the modifications
      isDirty = Boolean(eventRecord.hasPersistableChanges || assignmentRecord && assignmentRecord.hasPersistableChanges);
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign(clsListObj, {
        [resourceRecord.cls]: resourceRecord.cls,
        [me.generatedIdCls]: eventRecord.hasGeneratedId,
        [me.dirtyCls]: isDirty,
        [me.committingCls]: eventRecord.isCommitting,
        [me.endsOutsideViewCls]: renderData.endsOutsideView,
        [me.startsOutsideViewCls]: renderData.startsOutsideView,
        'b-clipped-start': renderData.clippedStart,
        'b-clipped-end': renderData.clippedEnd,
        'b-iscreating': eventRecord.isCreating
      });
      wrapperClsListObj[`${me.eventCls}-parent`] = resourceRecord.isParent;
      renderData.wrapperStyle = ''; // mark as wrapper to make sure fire render events for this level only

      renderData.isWrap = true; // Event specifics, things that do not apply to ResourceTimeRanges

      if (isEvent) {
        const selected = assignmentRecord && me.isAssignmentSelected(assignmentRecord);
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign(clsListObj, {
          [me.eventCls]: 1,
          'b-milestone': isMilestone,
          'b-sch-event-narrow': renderData.width < 10,
          [me.fixedEventCls]: eventRecord.isDraggable === false,
          [`b-sch-event-resizable-${resizable}`]: Boolean(me.features.eventResize),
          [me.eventSelectedCls]: selected,
          [me.eventAssignHighlightCls]: me.isEventSelected(eventRecord) && !selected,
          'b-recurring': eventRecord.isRecurring,
          'b-occurrence': eventRecord.isOccurrence,
          'b-inactive': eventRecord.inactive
        });
        renderData.eventId = eventRecord.id;
        const eventStyle = eventRecord.eventStyle || resourceRecord.eventStyle || me.eventStyle,
              eventColor = eventRecord.eventColor || resourceRecord.eventColor || me.eventColor,
              hasAnimation = me.isFirstRender && me.useInitialAnimation;
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign(wrapperClsListObj, {
          [`${me.eventCls}-wrap`]: 1,
          'b-milestone-wrap': isMilestone
        });

        if (hasAnimation) {
          const index = renderData.row ? renderData.row.index : renderData.top / me.tickSize,
                delayMS = index / 20 * 1000;
          renderData.wrapperStyle = `animation-delay: ${delayMS}ms;`;
          me.maxDelay = Math.max(me.maxDelay || 0, delayMS); // Add an extra delay to wait for the most delayed animation to finish
          // before we call stopInitialAnimation. In this way, we allow them all to finish
          // before we remove the b-initial-${me._useInitialAnimation} class.

          if (!me.initialAnimationDetacher) {
            me.initialAnimationDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
              element: me.foregroundCanvas,
              delegate: me.eventSelector,
              // Just listen for the first animation end fired by our event els
              once: true,
              animationend: () => me.setTimeout('stopInitialAnimation', me.maxDelay),
              // Fallback in case animation is interrupted
              expires: {
                alt: 'stopInitialAnimation',
                delay: me.initialAnimationDuration + me.maxDelay
              },
              thisObj: me
            });
          }
        }

        renderData.eventColor = eventColor;
        renderData.eventStyle = eventStyle; // TODO: Deprecate assignment, use assignmentRecord

        renderData.assignmentRecord = renderData.assignment = assignmentRecord;
      } // If not using a wrapping div, this cls will be added to event div for correct rendering


      renderData.wrapperCls = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign(wrapperClsList, wrapperClsListObj);
      renderData.cls = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign(clsList, clsListObj);
      renderData.iconCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](eventRecord.get(me.eventBarIconClsField) || eventRecord.iconCls); // ResourceTimeRanges applies custom style to the wrapper

      if (eventRecord.isResourceTimeRange) {
        renderData.style = '';
        renderData.wrapperStyle += eventRecord.style || '';
      } // Others to inner
      else {
        renderData.style = eventRecord.style || '';
      } // TODO: Deprecate resource in favor of resourceRecord


      renderData.resource = renderData.resourceRecord = resourceRecord;
      renderData.resourceId = renderData.rowId;

      if (isEvent) {
        let childContent = null,
            milestoneLabelConfig = null,
            value;

        if (me.eventRenderer) {
          // User has specified a renderer fn, either to return a simple string, or an object intended for the eventBodyTemplate
          const rendererValue = me.eventRenderer.call(me.eventRendererThisObj || me, {
            eventRecord,
            resourceRecord,
            assignmentRecord: renderData.assignmentRecord,
            tplData: renderData,
            renderData
          }); // If the user's renderer coerced it into a string, recreate a DomClassList.

          if (typeof renderData.cls === 'string') {
            renderData.cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](renderData.cls);
          }

          if (typeof renderData.wrapperCls === 'string') {
            renderData.wrapperCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](renderData.wrapperCls);
          } // Same goes for iconCls


          if (typeof renderData.iconCls === 'string') {
            renderData.iconCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](renderData.iconCls);
          }

          if (me.eventBodyTemplate) {
            value = me.eventBodyTemplate(rendererValue);
          } else {
            value = rendererValue;
          }
        } else if (me.eventBodyTemplate) {
          // User has specified an eventBodyTemplate, but no renderer - just apply the entire event record data.
          value = me.eventBodyTemplate(eventRecord);
        } else if (me.eventBarTextField) {
          // User has specified a field in the data model to read from
          value = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].encodeHtml(eventRecord[me.eventBarTextField] || '');
        }

        if (!me.eventBodyTemplate || Array.isArray(value)) {
          var _renderData$iconCls;

          eventContent.children = []; // Give milestone a dedicated label element so we can use padding

          if (isMilestone && me.milestoneLayoutMode === 'default' && value != null && value !== '') {
            eventContent.children.unshift(milestoneLabelConfig = {
              tag: 'label',
              children: []
            });
          }

          if ((_renderData$iconCls = renderData.iconCls) !== null && _renderData$iconCls !== void 0 && _renderData$iconCls.length) {
            eventContent.children.unshift({
              tag: 'i',
              className: renderData.iconCls
            });
          } // Array, assumed to contain DOM configs for eventContent children (or milestone label)


          if (Array.isArray(value)) {
            (milestoneLabelConfig || eventContent).children.push(...value);
          } // Likely HTML content
          else if (_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isHtml(value)) {
            if (eventContent.children.length) {
              childContent = {
                tag: 'span',
                html: value
              };
            } else {
              eventContent.children = null;
              eventContent.html = value;
            }
          } // DOM config or plain string can be used as is
          else if (typeof value === 'string' || typeof value === 'object') {
            childContent = value;
          } // Other, use string
          else if (value != null) {
            childContent = String(value);
          } // Must allow empty string as valid content


          if (childContent != null) {
            // Milestones have content in their label, other events in their "body"
            (milestoneLabelConfig || eventContent).children.push(childContent);
            renderData.cls.add('b-has-content');
          }

          if (eventContent.html != null || eventContent.children.length) {
            renderData.children.push(eventContent);
          }
        } else {
          eventContent.html = value;
          renderData.children.push(eventContent);
        }

        const {
          eventStyle,
          eventColor
        } = renderData; // Renderers have last say on style & color

        renderData.wrapperCls[`b-sch-style-${eventStyle}`] = eventStyle; // Named colors are applied as a class to the wrapper

        if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isNamedColor(eventColor)) {
          renderData.wrapperCls[`b-sch-color-${eventColor}`] = eventColor;
        } else if (eventColor) {
          const colorProp = eventStyle ? 'color' : 'background-color';
          renderData.style = `${colorProp}:${eventColor};` + renderData.style;
          renderData.wrapperCls['b-sch-custom-color'] = 1;
        } // Milestones has to apply styling to b-sch-event-content


        if (renderData.style && isMilestone && eventContent) {
          eventContent.style = renderData.style;
          delete renderData.style;
        }
      } // If there are any iconCls entries...


      renderData.cls['b-sch-event-withicon'] = (_renderData$iconCls2 = renderData.iconCls) === null || _renderData$iconCls2 === void 0 ? void 0 : _renderData$iconCls2.length; // For comparison in sync, cheaper than comparing DocumentFragments

      renderData.eventContent = eventContent;
      renderData.wrapperChildren = []; // Method which features may chain in to

      me.onEventDataGenerated(renderData);
    }

    return renderData;
  }
  /**
   * A method which may be chained by features. It is called when an event's render
   * data is calculated so that features may update the style, class list or body.
   * @param {Object} eventData
   */


  onEventDataGenerated(eventData) {} //endregion
  //region Animation

  /**
   * Restarts initial events animation with new value {@link #config-useInitialAnimation}.
   * @param {Boolean|String} initialAnimation new initial animation value
   */


  restartInitialAnimation(initialAnimation) {
    var _me$initialAnimationD;

    const me = this;
    (_me$initialAnimationD = me.initialAnimationDetacher) === null || _me$initialAnimationD === void 0 ? void 0 : _me$initialAnimationD.call(me);
    me.initialAnimationDetacher = null;
    me.useInitialAnimation = initialAnimation;
    me.isFirstRender = true;
    me.refresh();
  }

  stopInitialAnimation() {
    const me = this;
    me.initialAnimationDetacher();
    me.isFirstRender = false; // Prevent any further initial animations

    me.useInitialAnimation = false; // Remove transition block for FF a bit later, to not interfere with animations

    if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isFirefox) {
      me.setTimeout(() => me.element.classList.remove('b-prevent-event-transitions'), 100);
    }
  } //endregion
  // region milestones

  /**
   * Determines width of a milestones label. How width is determined is decided by configuring Scheduler#milestoneLayoutMode.
   * Please note that currently text width is always determined using EventModel#name.
   * @param {Scheduler.model.EventModel} eventRecord
   * @returns {Number}
   */


  getMilestoneLabelWidth(eventRecord) {
    const me = this,
          mode = me.milestoneLayoutMode;

    if (mode === 'measure') {
      const element = me.milestoneMeasureElement || (me.milestoneMeasureElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].createElement({
        className: 'b-sch-event-wrap b-milestone-wrap b-measure',
        children: [{
          className: 'b-sch-event b-milestone',
          children: [{
            className: 'b-sch-event-content'
          }]
        }],
        parent: me.foregroundCanvas
      })); // DomSync should not touch

      element.retainElement = true;
      element.firstElementChild.firstElementChild.innerHTML = eventRecord.name;
      return element.offsetWidth;
    }

    if (mode === 'estimate') {
      return Math.max(eventRecord.name.length * me.milestoneCharWidth, me.milestoneMinWidth);
    }

    if (mode === 'data') {
      return Math.max(eventRecord.milestoneWidth, me.milestoneMinWidth);
    }

    return 0;
  }

  set milestoneLayoutMode(mode) {
    this._milestoneLayoutMode = mode;
    this.element.classList[mode !== 'default' ? 'add' : 'remove']('b-sch-layout-milestones');

    if (!this.isConfiguring) {
      this.refreshWithTransition();
    }
  }

  get milestoneLayoutMode() {
    return this._milestoneLayoutMode;
  }

  updateMilestoneTextPosition(position) {
    this.element.classList.toggle('b-sch-layout-milestone-text-position-inside', position === 'inside');
  }
  /**
   * Get/set how to align milestones in relation to their startDate. Only applies when using a `milestoneLayoutMode`
   * other than `default`. Valid values are:
   * * start
   * * center (default)
   * * end
   * @property {String}
   */


  set milestoneAlign(align) {
    this._milestoneAlign = align;

    if (!this.isConfiguring) {
      this.refreshWithTransition();
    }
  }

  get milestoneAlign() {
    return this._milestoneAlign;
  }

  set milestoneCharWidth(width) {
    this._milestoneCharWidth = width;

    if (!this.isConfiguring) {
      this.refreshWithTransition();
    }
  }

  get milestoneCharWidth() {
    return this._milestoneCharWidth;
  } // endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerRegions.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerRegions.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/mixin/SchedulerRegions
 */

/**
 * Functions to get regions (bounding boxes) for scheduler, events etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerRegions extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerRegions';
  } //region Orientation depended regions

  /**
   * Gets the region represented by the schedule and optionally only for a single resource. The view will ask the
   * scheduler for the resource availability by calling getResourceAvailability. By overriding that method you can
   * constrain events differently for different resources.
   * @param {Scheduler.model.ResourceModel} resourceRecord (optional) The resource record
   * @param {Scheduler.model.EventModel} eventRecord (optional) The event record
   * @return {Core.helper.util.Rectangle} The region of the schedule
   */


  getScheduleRegion(resourceRecord, eventRecord, local = true) {
    return this.currentOrientation.getScheduleRegion(resourceRecord, eventRecord, local);
  }
  /**
   * Gets the region representing the passed resource and optionally just for a certain date interval.
   * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
   * @param {Date} startDate A start date constraining the region
   * @param {Date} endDate An end date constraining the region
   * @return {Core.helper.util.Rectangle} A Rectangle which encapsulates the resource time span
   */


  getResourceRegion(resourceRecord, startDate, endDate) {
    return this.currentOrientation.getRowRegion(resourceRecord, startDate, endDate);
  } //endregion
  //region ResourceEventBox


  getAssignmentEventBox(assignmentRecord, includesOutside) {
    return this.getResourceEventBox(assignmentRecord.event, assignmentRecord.resource, includesOutside);
  }
  /**
   * Get the region for a specified resources specified event.
   * @param {Scheduler.model.EventModel} eventRecord
   * @param {Scheduler.model.ResourceModel} resourceRecord
   * @param {Boolean} includeOutside Specify true to get boxes for events outside of the rendered zone in both
   *   dimensions. This option is used when calculating dependency lines, and we need to include routes from events
   *   which may be outside the rendered zone.
   * @returns {Core.helper.util.Rectangle}
   */


  getResourceEventBox(eventRecord, resourceRecord, includeOutside = false, roughly = false) {
    return this.currentOrientation.getResourceEventBox(eventRecord, resourceRecord, includeOutside, roughly);
  } //endregion
  //region Item box

  /**
   * Gets box for displayed item designated by the record. If several boxes are displayed for the given item
   * then the method returns all of them. Box coordinates are in view coordinate system.
   *
   * Boxes outside scheduling view timeaxis timespan and inside collapsed rows (if row defining store is a tree store)
   * will not be returned. Boxes outside scheduling view vertical visible area (i.e. boxes above currently visible
   * top row or below currently visible bottom row) will be calculated approximately.
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Object|Object[]}
   * @return {Boolean} return.isPainted Whether the box was calculated for the rendered scheduled record or was
   *    approximately calculated for the scheduled record outside of the current vertical view area.
   * @return {Number} return.top
   * @return {Number} return.bottom
   * @return {Number} return.start
   * @return {Number} return.end
   * @return {String} return.relPos if the item is not rendered then provides a view relative position one of 'before', 'after'
   * @internal
   */


  getItemBox(event, includeOutside = false) {
    return event.resources.map(resource => this.getResourceEventBox(event, resource, includeOutside));
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerScroll.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerScroll.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/mixin/SchedulerScroll
 */

const immediatePromise = Promise.resolve(),
      defaultScrollOptions = {
  block: 'nearest',
  edgeOffset: 20
},
      unrenderedScrollOptions = {
  highlight: false,
  focus: false
};
/**
 * Functions for scrolling to events, dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerScroll extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerScroll';
  } //region Scroll to event

  /**
   * Scrolls an event record into the viewport.
   * If the resource store is a tree store, this method will also expand all relevant parent nodes to locate the event.
   *
   * This function is not applicable for events with multiple assignments, please use #scrollResourceEventIntoView instead.
   *
   * @param {Scheduler.model.EventModel} eventRecord the event record to scroll into view
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollEventIntoView(eventRecord, options = defaultScrollOptions) {
    const me = this,
          resources = eventRecord.resources || [eventRecord];

    if (resources.length > 1) {
      throw new Error('scrollEventIntoView() is not applicable for events with multiple assignments, please use scrollResourceEventIntoView() instead.');
    }

    if (!resources.length) {
      console.warn('You have asked to scroll to an event which is not assigned to a resource');
      return immediatePromise;
    }

    return me.scrollResourceEventIntoView(resources[0], eventRecord, null, options);
  }
  /**
   * Scrolls an assignment record into the viewport.
   *
   * If the resource store is a tree store, this method will also expand all relevant parent nodes
   * to locate the event.
   *
   * @param {Scheduler.model.AssignmentModel} assignmentRecord A resource record an event record is assigned to
   * @param {Number} index DOM node index, applicable only for weekview
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
   * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.extendTimeAxis=true] By default, if the requested event is outside the time axis, the time axis is extended.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollAssignmentIntoView(assignmentRecord, ...args) {
    return this.scrollResourceEventIntoView(assignmentRecord.resource, assignmentRecord.event, ...args);
  }
  /**
   * Scrolls a resource event record into the viewport.
   *
   * If the resource store is a tree store, this method will also expand all relevant parent nodes
   * to locate the event.
   *
   * @param {Scheduler.model.ResourceModel} resourceRecord A resource record an event record is assigned to
   * @param {Scheduler.model.EventModel} eventRecord An event record to scroll into view
   * @param {Number} index DOM node index, applicable only for weekview
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.extendTimeAxis=true] By default, if the requested event is outside the time axis, the time axis is extended.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollResourceEventIntoView(resourceRecord, eventRecord, index, options = defaultScrollOptions) {
    var _me$expandTo;

    const me = this,
          eventStart = eventRecord.startDate,
          eventEnd = eventRecord.endDate,
          eventIsOutside = eventRecord.isScheduled && eventStart < me.timeAxis.startDate | (eventEnd > me.timeAxis.endDate) << 1;
    let el;

    if (options.edgeOffset == null) {
      options.edgeOffset = 20;
    } // Make sure event is within TimeAxis time span unless extendTimeAxis passed as false.
    // The EventEdit feature passes false because it must not mutate the TimeAxis.
    // Bitwise flag:
    //  1 === start is before TimeAxis start.
    //  2 === end is after TimeAxis end.


    if (eventIsOutside && options.extendTimeAxis !== false) {
      const currentTimeSpanRange = me.timeAxis.endDate - me.timeAxis.startDate; // Event is too wide, expand the range to encompass it.

      if (eventIsOutside === 3) {
        me.setTimeSpan(new Date(eventStart.valueOf() - currentTimeSpanRange / 2), new Date(eventEnd.getTime() + currentTimeSpanRange / 2));
      } // Event is partially or wholly outside but will fit.
      // Move the TimeAxis to include it. That will maintain visual position.
      else {
        // Event starts before
        if (eventIsOutside & 1) {
          me.setTimeSpan(new Date(eventStart), new Date(eventStart.valueOf() + currentTimeSpanRange));
        } // Event ends after
        else {
          me.setTimeSpan(new Date(eventEnd.valueOf() - currentTimeSpanRange), new Date(eventEnd));
        }
      }
    } // If we're a tree, ensure parents are expanded first


    (_me$expandTo = me.expandTo) === null || _me$expandTo === void 0 ? void 0 : _me$expandTo.call(me, resourceRecord); // Establishing element to scroll to

    el = me.getElementFromEventRecord(eventRecord, resourceRecord);

    if (el) {
      // It's usually the event wrapper that holds focus
      if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(el)) {
        el = el.parentNode;
      }

      const scroller = me.timeAxisSubGrid.scrollable; // Force horizontalscroll to be triggered directly on scroll instead of on next frame, to have events
      // already drawn when promise resolves

      me.timeAxisSubGrid.forceScrollUpdate = true; // Scroll into view with animation and highlighting if needed.

      return scroller.scrollIntoView(el, options);
    } else if (eventIsOutside && options.extendTimeAxis === false) {
      console.warn('You have asked to scroll to an event which is outside the current view and extending timeaxis is disabled');
      return immediatePromise;
    } else if (!eventRecord.isOccurrence && !me.eventStore.isAvailable(eventRecord)) {
      console.warn('You have asked to scroll to an event which is not available');
      return immediatePromise;
    } else if (eventRecord.isScheduled) {
      // Event scheduled but not rendered, scroll to calculated location
      return me.scrollUnrenderedEventIntoView(resourceRecord, eventRecord, options);
    } else {
      // Event not scheduled, just scroll resource row into view
      return me.scrollResourceIntoView(resourceRecord, options);
    }
  }
  /**
   * Scrolls an unrendered event into view. Internal function used from #scrollResourceEventIntoView.
   * @private
   */


  scrollUnrenderedEventIntoView(resourceRec, eventRec, options = defaultScrollOptions) {
    // We must only resolve when the event's element has been painted
    // *and* the scroll has fully completed.
    return new Promise(resolve => {
      const me = this,
            // Knock out highlight and focus options. They must be applied after the scroll
      // has fully completed and we have an element. Use a default edgeOffset of 20.
      modifiedOptions = Object.assign({
        edgeOffset: 20
      }, options, unrenderedScrollOptions),
            scroller = me.timeAxisSubGrid.scrollable,
            box = me.getResourceEventBox(eventRec, resourceRec),
            scrollerViewport = scroller.viewport;

      if (!scrollerViewport) {
        resolve();
        return;
      } // In case of subPixel position, scroll the whole pixel into view


      box.x = Math.ceil(box.x);
      box.y = Math.ceil(box.y);

      const targetRect = box.translate(scrollerViewport.x - scroller.x, scrollerViewport.y - scroller.y),
            delta = scroller.getDeltaTo(targetRect, modifiedOptions)[me.isHorizontal ? 'xDelta' : 'yDelta'],
            onEventRender = async ({
        eventRecord,
        element,
        targetElement
      }) => {
        if (eventRecord === eventRec) {
          // Vertical's renderEvent is different to horizontal's
          const el = element || targetElement;
          detacher(); // Don't resolve until the scroll has fully completed.

          await initialScrollPromise; // If we were scrolling rightwards, then because the rectangle was only *estimated*
          // we must now ensure that the scroll position is fully correct for the *element*.
          // TODO: Needed? The position should be correct with the new rendering

          if (delta > 0) {
            await scroller.scrollIntoView(el, {
              edgeOffset: options.edgeOffset
            });
          }

          options.highlight && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].highlight(el);
          options.focus && el.focus();
          resolve();
        }
      },
            // On either paint or repaint of the event, resolve the scroll promise and detach the listeners.
      detacher = me.on({
        renderEvent: onEventRender
      }),
            initialScrollPromise = scroller.scrollIntoView(targetRect, modifiedOptions);
    });
  }
  /**
   * Scrolls the specified resource into view, works for both horizontal and vertical modes.
   * @param {Scheduler.model.ResourceModel} resourceRecord A resource record an event record is assigned to
   * @param {Object} [options] How to scroll.
   * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to (in horizontal mode).
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  scrollResourceIntoView(resourceRecord, options = defaultScrollOptions) {
    if (this.isVertical) {
      return this.currentOrientation.scrollResourceIntoView(resourceRecord, options);
    } else {
      return this.scrollRowIntoView(resourceRecord, options);
    }
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerState.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerState.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/mixin/SchedulerState
 */

const copyProperties = ['eventLayout', 'barMargin', 'mode', 'eventColor', 'eventStyle', 'tickSize', 'fillTicks'];
/**
 * Mixin for Scheduler that handles state. It serializes the following scheduler properties:
 *
 * * eventLayout
 * * barMargin
 * * mode
 * * tickSize
 * * zoomLevel
 * * eventColor
 * * eventStyle
 *
 * See {@link Grid.view.mixin.GridState} and {@link Core.mixin.State} for more information on state.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerState extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerState';
  }
  /**
   * Gets or sets scheduler's state. Check out {@link Scheduler.view.mixin.SchedulerState SchedulerState} mixin for details.
   * @member {Object} state
   */

  /**
   * Get scheduler's current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
   * selectedRecordId, column states and store state etc.
   * @returns {Object} State object to be serialized
   * @private
   */


  getState() {
    const me = this,
          state = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyProperties(super.getState(), me, copyProperties);
    state.zoomLevel = me.zoomLevel;
    state.zoomLevelOptions = {
      startDate: me.startDate,
      endDate: me.endDate,
      viewportCenterDate: me.viewportCenterDate,
      width: me.tickSize
    };
    return state;
  }
  /**
   * Apply previously stored state.
   * @param {Object} state
   * @private
   */


  applyState(state) {
    this.suspendRefresh();

    if (state.zoomLevel) {
      this.zoomToLevel(state.zoomLevel, state.zoomLevelOptions);
    }

    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyProperties(this, state, copyProperties);
    super.applyState(state);
    this.resumeRefresh(true);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerStores.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerStores.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../data/mixin/ProjectConsumer.js */ "./lib/Scheduler/data/mixin/ProjectConsumer.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/mixin/SchedulerStores
 */

/**
 * Functions for store assignment and store event listeners.
 *
 * @mixin
 * @extends Scheduler/data/mixin/ProjectConsumer
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerStores extends Object(_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_4__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerStores';
  } //region Default config
  // This is the static definition of the Stores we consume from the project, and
  // which we must provide *TO* the project if we or our CrudManager is configured
  // with them.
  // The property name is the store name, and within that there is the dataname which
  // is the property which provides static data definition. And there is a listeners
  // definition which specifies the listeners *on this object* for each store.
  //
  // To process incoming stores, implement an updateXxxxxStore method such
  // as `updateEventStore(eventStore)`.
  //
  // To process an incoming Project implement `updateProject`. __Note that
  // `super.updateProject(...arguments)` must be called first.__


  static get projectStores() {
    return {
      resourceStore: {
        dataName: 'resources'
      },
      eventStore: {
        dataName: 'events',
        listeners: {
          batchedUpdate: 'onEventStoreBatchedUpdate',
          changePreCommit: 'onInternalEventStoreChange',
          commitStart: 'onEventCommitStart',
          commit: 'onEventCommit',
          exception: 'onEventException',
          idchange: 'onEventIdChange',
          beforeLoad: 'applyStartEndParameters'
        }
      },
      assignmentStore: {
        dataName: 'assignments',
        listeners: {
          changePreCommit: 'onAssignmentChange',
          // In EventSelection.js
          commitStart: 'onAssignmentCommitStart',
          commit: 'onAssignmentCommit',
          exception: 'onAssignmentException',
          beforeRemove: {
            fn: 'onAssignmentBeforeRemove',
            // We must go last in case an app vetoes a remove
            // by returning false from a handler.
            prio: -1000
          }
        }
      },
      dependencyStore: {
        dataName: 'dependencies'
      },
      calendarManagerStore: {},
      timeRangeStore: {},
      resourceTimeRangeStore: {}
    };
  }

  static get configurable() {
    return {
      /**
       * Inline events, will be loaded into an internally created EventStore.
       * @config {Scheduler.model.EventModel[]|Object[]} events
       * @category Data events
       */

      /**
       * The {@link Scheduler.data.EventStore} holding the events to be rendered into the scheduler (required).
       * @config {Scheduler.data.EventStore|Object} eventStore
       * @category Data
       */

      /**
       * Inline resources, will be loaded into an internally created ResourceStore.
       * @config {Scheduler.model.ResourceModel[]|Object[]} resources
       * @category Data
       */

      /**
       * The {@link Scheduler.data.ResourceStore} holding the resources to be rendered into the scheduler (required).
       * @config {Scheduler.data.ResourceStore|Object} resourceStore
       * @category Data
       */

      /**
       * Inline assignments, will be loaded into an internally created AssignmentStore.
       * @config {Scheduler.model.AssignmentModel[]|Object[]} assignments
       * @category Data
       */

      /**
       * The optional {@link Scheduler.data.AssignmentStore}, holding assignments between resources and events.
       * Required for multi assignments.
       * @config {Scheduler.data.AssignmentStore|Object} assignmentStore
       * @category Data
       */

      /**
       * Inline dependencies, will be loaded into an internally created DependencyStore.
       * @config {Scheduler.model.DependencyModel[]|Object[]} dependencies
       * @category Data
       */

      /**
       * The optional {@link Scheduler.data.DependencyStore}.
       * @config {Scheduler.data.DependencyStore|Object} dependencyStore
       * @category Data
       */

      /**
       * Inline time ranges, will be loaded into an internally created store if {@link Scheduler.feature.TimeRanges TimeRanges}
       * is enabled.
       * @config {Scheduler.model.TimeSpan[]|Object[]}
       * @category Data
       */
      timeRanges: null,

      /**
       * Inline resource time ranges, will be loaded into an internally created store if
       * {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} is enabled.
       * @config {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
       * @category Data
       */
      resourceTimeRanges: null,

      /**
       * Overridden to *not* auto create a store at the Scheduler level.
       * The store is the {@link #config-resourceStore} of the backing project
       * @config {Core.data.Store}
       * @private
       */
      store: null,

      /**
       * The name of the start date parameter that will be passed to in every `eventStore` load request.
       * @config {String}
       * @category Data
       */
      startParamName: 'startDate',

      /**
       * The name of the end date parameter that will be passed to in every `eventStore` load request.
       * @config {String}
       * @category Data
       */
      endParamName: 'endDate',

      /**
       * true to apply start and end dates of the current view to any `eventStore` load requests.
       * @config {Boolean}
       * @category Data
       */
      passStartEndParameters: false,

      /**
       * Configure with `true` to also remove the event when removing the last assignment.
       * @config {Boolean}
       * @default
       * @category Misc
       */
      removeUnassignedEvent: true,

      /**
       * Class that should be used to instantiate a CrudManager in case it's provided as a simple object to
       * {@link #config-crudManager} config.
       * @config {Scheduler.data.CrudManager}
       * @typings {typeof CrudManager}
       * @category Data
       */
      crudManagerClass: null,

      /**
       * Get/set the CrudManager instance
       * @member {Scheduler.data.CrudManager} crudManager
       * @category Data
       */

      /**
       * Supply a {@link Scheduler.data.CrudManager CrudManager} instance or a config object if you want to use
       * CrudManager for handling data.
       * @config {Object|Scheduler.data.CrudManager}
       * @category Data
       */
      crudManager: null
    };
  } //endregion
  //region Project


  updateProject(project, oldProject) {
    super.updateProject(project, oldProject);
    this.detachListeners('schedulerStores');
    project.on({
      name: 'schedulerStores',
      refresh: 'onProjectRefresh',
      thisObj: this
    });
  } // Called when project changes are committed, before data is written back to records (but still ready to render
  // since data is fetched from engine)


  onProjectRefresh({
    isInitialCommit
  }) {
    const me = this;

    if (isInitialCommit) {
      if (me.isVertical) {
        me.refreshAfterProjectRefresh = false;
        me.refreshWithTransition();
      }
    }

    if (me.navigateToAfterRefresh) {
      me.navigateTo(me.navigateToAfterRefresh);
      me.navigateToAfterRefresh = null;
    }

    if (me.refreshAfterProjectRefresh) {
      me.refreshWithTransition(false, !isInitialCommit);
      me.refreshAfterProjectRefresh = false;
    }
  } //endregion
  //region CrudManager


  changeCrudManager(crudManager) {
    const me = this;

    if (crudManager && !crudManager.isCrudManager) {
      // CrudManager injects itself into is Scheduler's _crudManager property
      // because code it triggers needs to access it through its getter.
      crudManager = me.crudManagerClass.new({
        scheduler: me
      }, crudManager);
    } // config setter will veto because of above described behaviour
    // of setting the property early on creation


    me._crudManager = crudManager;
    me.bindCrudManager(crudManager);
  } //endregion
  //region Row store


  get store() {
    // Vertical uses a dummy store
    if (!this._store && this.isVertical) {
      // TODO: Make this store readonly, since we are using single cell approach
      this._store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        data: [{
          // Quoted to avoid commit-hook check:
          'id': 'verticalTimeAxisRow',
          // eslint-disable-line quote-props
          cls: 'b-verticaltimeaxis-row'
        }]
      });
    }

    return super.store;
  }

  set store(store) {
    super.store = store;
  } // Wrap w/ transition refreshFromRowOnStoreAdd() inherited from Grid


  refreshFromRowOnStoreAdd(row, {
    isExpand
  }) {
    const args = arguments;
    this.runWithTransition(() => {
      // Postpone drawing of events for a new resource until the following project refresh. Previously the draw
      // would not happen because engine was not ready, but now when we allow commits and can read values during
      // commit that block is no longer there
      this.currentOrientation.suspended = !isExpand;
      super.refreshFromRowOnStoreAdd(row, ...args);
      this.currentOrientation.suspended = false;
    }, !isExpand);
  }

  onStoreAdd(event) {
    super.onStoreAdd(event);
    this.calculateRowHeights(event.records);
  }

  onStoreUpdateRecord({
    source: store,
    record,
    changes
  }) {
    // Ignore engine changes that do not affect row rendering
    let ignoreCount = 0;

    if ('assigned' in changes) {
      ignoreCount++;
    }

    if ('calendar' in changes) {
      ignoreCount++;
    }

    if (ignoreCount !== Object.keys(changes).length) {
      super.onStoreUpdateRecord(...arguments);
    }
  } //endregion
  //region ResourceStore

  /**
   * Get/set resources, applies to the backing project's ResourceStore.
   * @member {Scheduler.model.ResourceModel[]} resources
   * @accepts {Scheduler.model.ResourceModel[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the resource store instance of the backing project
   * @member {Scheduler.data.ResourceStore} resourceStore
   * @category Data
   */


  updateResourceStore(resourceStore) {
    // Reconfigure grid if resourceStore is backing the rows
    if (resourceStore && this.isHorizontal) {
      resourceStore.metaMapId = this.id;
      this.store = resourceStore;
    }
  } //endregion
  //region EventStore

  /**
   * Get/set events, applies to the backing project's EventStore.
   * @member {Scheduler.model.EventModel[]} events
   * @accepts {Scheduler.model.EventModel[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the event store instance of the backing project.
   * @member {Scheduler.data.EventStore} eventStore
   * @category Data
   */
  //endregion
  //region AssignmentStore

  /**
   * Get/set assignments, applies to the backing project's AssignmentStore.
   * @member {Scheduler.model.AssignmentModel[]} assignments
   * @accepts {Scheduler.model.AssignmentModel[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the event store instance of the backing project.
   * @member {Scheduler.data.AssignmentStore} assignmentStore
   * @category Data
   */
  //endregion
  //region DependencyStore

  /**
   * Get/set dependencies, applies to the backing projects DependencyStore.
   * @member {Scheduler.model.DependencyModel[]} dependencies
   * @accepts {Scheduler.model.DependencyModel[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the dependencies store instance of the backing project.
   * @member {Scheduler.data.DependencyStore} dependencyStore
   * @category Data
   */
  //endregion
  //region CalendarManagerStore
  // TODO: document it when it works. The build process throws with this documented.
  // /**
  //  * Get/set the calendar manager store instance of the backing project
  //  * @member {Engine.store.CalendarManagerStoreMixin} calendarManagerStore
  //  * @category Data
  //  */
  //endregion
  //region Events


  onEventIdChange(params) {
    this.currentOrientation.onEventStoreIdChange && this.currentOrientation.onEventStoreIdChange(params);
  }
  /**
   * Listener to the batchedUpdate event which fires when a field is changed on a record which
   * is batch updating. Occasionally UIs must keep in sync with batched changes.
   * For example, the EventResize feature performs batched updating of the startDate/endDate
   * and it tells its client to listen to batchedUpdate.
   * @private
   */


  onEventStoreBatchedUpdate(event) {
    if (this.listenToBatchedUpdates) {
      return this.onInternalEventStoreChange(event);
    }
  }
  /**
   * Calls appropriate functions for current event layout when the event store is modified.
   * @private
   */
  // Named as Internal to avoid naming collision with wrappers that relay events


  onInternalEventStoreChange(params) {
    // Too early, bail out
    // Also bail out if this is a reassign using resourceId, any updates will be handled by AssignmentStore instead
    if (!this._mode || params.isAssign || this.assignmentStore.isRemovingAssignment) {
      return;
    }

    this.currentOrientation.onEventStoreChange(params);
  }
  /**
   * Refreshes committed events, to remove dirty/committing flag.
   * CSS is added
   * @private
   */


  onEventCommit({
    changes
  }) {
    let resourcesToRepaint = [...changes.added, ...changes.modified].map(eventRecord => this.eventStore.getResourcesForEvent(eventRecord)); // getResourcesForEvent returns an array, so need to flatten resourcesToRepaint

    resourcesToRepaint = Array.prototype.concat.apply([], resourcesToRepaint); // repaint relevant resource rows

    new Set(resourcesToRepaint).forEach(resourceRecord => this.repaintEventsForResource(resourceRecord));
  }
  /**
   * Adds the committing flag to changed events before commit.
   * @private
   */


  onEventCommitStart({
    changes
  }) {
    const {
      currentOrientation,
      committingCls
    } = this; // Committing sets a flag in meta that during event rendering applies a CSS class. But to not mess up drag and
    // drop between resources no redraw is performed before committing, so class is never applied to the element(s).
    // Applying here instead

    [...changes.added, ...changes.modified].forEach(eventRecord => eventRecord.assignments.forEach(assignmentRecord => currentOrientation.toggleCls(assignmentRecord, committingCls, true)));
  } // Clear committing flag


  onEventException({
    action
  }) {
    if (action === 'commit') {
      const {
        changes
      } = this.eventStore;
      [...changes.added, ...changes.modified, ...changes.removed].forEach(eventRecord => this.repaintEvent(eventRecord));
    }
  }

  onAssignmentCommit({
    changes
  }) {
    this.repaintEventsForAssignmentChanges(changes);
  }

  onAssignmentCommitStart({
    changes
  }) {
    const {
      currentOrientation,
      committingCls
    } = this;
    [...changes.added, ...changes.modified].forEach(assignmentRecord => {
      currentOrientation.toggleCls(assignmentRecord, committingCls, true);
    });
  } // Clear committing flag


  onAssignmentException({
    action
  }) {
    if (action === 'commit') {
      this.repaintEventsForAssignmentChanges(this.assignmentStore.changes);
    }
  }

  repaintEventsForAssignmentChanges(changes) {
    const resourcesToRepaint = [...changes.added, ...changes.modified, ...changes.removed].map(assignmentRecord => assignmentRecord.getResource()); // repaint relevant resource rows

    new Set(resourcesToRepaint).forEach(resourceRecord => this.repaintEventsForResource(resourceRecord));
  }

  onAssignmentBeforeRemove({
    source,
    records,
    removingAll
  }) {
    if (removingAll) {
      return;
    }

    const me = this;
    let moveTo; // Deassigning the active assignment

    if (!me.isConfiguring && ( // If we have current active assignment or we scheduled navigating to an assignment, we should check
    // if we're removing that assignment in order to avoid navigating to it
    me.navigateToAfterRefresh || me.activeAssignment && records.includes(me.activeAssignment))) {
      // If next navigation target is removed, clean up the flag
      if (records.includes(me.navigateToAfterRefresh)) {
        me.navigateToAfterRefresh = null;
      } // If being done by a keyboard gesture then look for a close target until we find an existing record, not
      // scheduled for removal. Otherwise, push focus outside of the Scheduler.
      // This condition will react not only on meaningful keyboard action - like pressing DELETE key on selected
      // event - but also in case user started dragging and pressed CTRL (or any other key) in process.
      // https://github.com/bryntum/support/issues/3479


      if (_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__["default"].lastInteractionType === 'key') {
        // Look for a close target until we find an existing record, not scheduled for removal. Provided
        // assignment position in store is arbitrary as well as order of removed records, it does not make much
        // sense trying to apply any specific order to them. Existing assignment next to any removed one is as
        // good as any.
        for (let i = 0, l = records.length; i < l && !moveTo; i++) {
          const assignment = records[i];

          if (assignment.resource && assignment.resource.isModel) {
            // Find next record
            let next = me.getNext(assignment); // If next record is not found or also removed, look for previous. This should not become a
            // performance bottleneck because we only can get to this code if project is committing, if
            // records are removed on a dragdrop listener and user pressed any key after mousedown, or if
            // user is operating with a keyboard and pressed [DELETE] to remove multiple records.

            if (!next || records.includes(next)) {
              next = me.getPrevious(assignment);
            }

            if (next && !records.includes(next)) {
              moveTo = next;
            }
          }
        }
      } // Move focus away from the element which will soon have no backing data.


      if (moveTo) {
        // Although removing records from assignment store will trigger project commit and consequently
        // `refresh` event on the project which will use this record to navigate to, some tests expect
        // immediate navigation
        me.navigateTo(moveTo);
        me.navigateToAfterRefresh = moveTo;
      } // Focus must exit the Scheduler's subgrid, otherwise, if a navigation
      // key gesture is delivered before the outgoing event's element has faded
      // out and been removed, navigation will be attempted from a deleted
      // event. Animated hiding is problematic.
      //
      // We cannot just revertFocus() because that might move focus back to an
      // element in a floating EventEditor which is not yet faded out and
      // been removed. Animated hiding is problematic.
      //
      // We cannot focus scheduler.timeAxisColumn.element because the browser
      // would scroll it in some way if we have horizontal overflow.
      //
      // The only thing we can know about to focus here is the Scheduler itself.
      else {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].focusWithoutScrolling(me.focusElement);
      }
    }
  } // /**
  //  * Repaints affected resources when assignments are removed.
  //  * @private
  //  */
  // onAssignmentRemove({ records }) {
  //     if (this.isHorizontal) {
  //         records.forEach(assignment => {
  //             const resource = assignment.resource;
  //             // Removing a resource removes assignments, if resource is already removed no point in repainting here
  //             resource && !resource.isRemoved && this.repaintEventsForResource(resource);
  //         });
  //     }
  // }
  //
  // /**
  //  * Repaints resources when all assignments are removed.
  //  * @private
  //  */
  // onAssignmentRemoveAll() {
  //     if (this.isHorizontal) {
  //         this.currentOrientation.onAssignmentRemoveAll();
  //     }
  // }
  // /**
  //  * Refreshes scheduler when assignment store is filtered.
  //  */
  // onAssignmentFilter() {
  //     if (this.isHorizontal) {
  //         this.refresh();
  //     }
  // }
  //endregion
  //region TimeRangeStore

  /**
   * Get/set time ranges, applies to the backing project's TimeRangeStore.
   * @member {Scheduler.model.TimeSpan[]} timeRanges
   * @accepts {Scheduler.model.TimeSpan[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the time ranges store instance or config object for {@link Scheduler.feature.TimeRanges TimeRanges} feature.
   * @member {Core.data.Store} timeRangeStore
   * @accepts {Core.data.Store|Object}
   * @category Data
   */

  /**
   * The time ranges store instance for {@link Scheduler.feature.TimeRanges TimeRanges} feature.
   * @config {Core.data.Store|Object} timeRangeStore
   * @category Data
   */
  //endregion
  //region ResourceTimeRangeStore

  /**
   * Get/set time ranges, applies to the backing project's ResourceTimeRangeStore.
   * @member {Scheduler.model.ResourceTimeRangeModel[]} resourceTimeRanges
   * @accepts {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
   * @category Data
   */

  /**
   * Get/set the resource time ranges store instance for {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
   * @member {Scheduler.data.ResourceTimeRangeStore} resourceTimeRangeStore
   * @accepts {Scheduler.data.ResourceTimeRangeStore|Object}
   * @category Data
   */

  /**
   * Resource time ranges store instance or config object for {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
   * @config {Scheduler.data.ResourceTimeRangeStore|Object} resourceTimeRangeStore
   * @category Data
   */
  //endregion
  //region Other functions

  /**
   * Applies the start and end date to each event store request (formatted in the same way as the start date, defined
   * in the EventStore Model class).
   * @category Data
   */


  applyStartEndParameters({
    source: eventStore,
    params
  }) {
    const me = this,
          field = eventStore.modelClass.fieldMap.startDate;

    if (me.passStartEndParameters) {
      params[me.startParamName] = field.print(me.startDate);
      params[me.endParamName] = field.print(me.endDate);
    }
  }
  /**
   * Get events grouped by timeAxis ticks from resources array
   * @category Data
   * @param {Scheduler.model.ResourceModel[]} resources An array of resources to process. If not passed, all resources will be used.
   * @param {Function} filterFn filter function to filter events if required. Optional.
   * @private
   */


  getResourcesEventsPerTick(resources, filterFn) {
    const {
      timeAxis,
      resourceStore
    } = this,
          eventsByTick = [];
    resources = resources || resourceStore.records;
    resources.forEach(resource => {
      resource.events.forEach(event => {
        if (!timeAxis.isTimeSpanInAxis(event) || filterFn && !filterFn.call(this, {
          resource,
          event
        })) {
          return;
        } // getTickFromDate may return float if event starts/ends in a middle of a tick


        let startTick = Math.floor(timeAxis.getTickFromDate(event.startDate)),
            endTick = Math.ceil(timeAxis.getTickFromDate(event.endDate)); // if startDate/endDate of the event is out of timeAxis' bounds, use first/last tick id instead

        if (startTick == -1) {
          startTick = 0;
        }

        if (endTick === -1) {
          endTick = timeAxis.ticks.length;
        }

        do {
          if (!eventsByTick[startTick]) {
            eventsByTick[startTick] = [event];
          } else {
            eventsByTick[startTick].push(event);
          }
        } while (++startTick < endTick);
      });
    });
    return eventsByTick;
  } //endregion
  //region WidgetClass
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {} //endregion


});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineDateMapper.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineDateMapper.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';

 // Used to avoid having to create huge amounts of Date objects

const tempDate = new Date();
/**
 * @module Scheduler/view/mixin/TimelineDateMapper
 */

/**
 * Mixin that contains functionality to convert between coordinates and dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineDateMapper extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TimelineDateMapper';
  } //region Coordinate <-> Date

  /**
   * Gets the date for an X or Y coordinate, either local to the view element or the page based on the 3rd argument.
   * If the coordinate is not in the currently rendered view, null will be returned unless the `allowOutOfRange`
   * parameter is passed a `true`.
   * @param {Number} coordinate The X or Y coordinate
   * @param {String} [roundingMethod] The rounding method to use
   * @param {Boolean} [local] true if the coordinate is local to the scheduler view element
   * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
   * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
   * @returns {Date} The Date corresponding to the X or Y coordinate
   * @category Dates
   */


  getDateFromCoordinate(coordinate, roundingMethod, local = true, allowOutOfRange = false) {
    if (!local) {
      coordinate = this.currentOrientation.translateToScheduleCoordinate(coordinate);
    }

    return this.timeAxisViewModel.getDateFromPosition(coordinate, roundingMethod, allowOutOfRange);
  }
  /**
   * Gets the date for an XY coordinate regardless of the orientation of the time axis.
   * @param {Array} xy The page X and Y coordinates
   * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
   * @param {Boolean} [local] true if the coordinate is local to the scheduler element
   * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
   * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
   * @returns {Date} the Date corresponding to the xy coordinate
   * @category Dates
   */


  getDateFromXY(xy, roundingMethod, local = true, allowOutOfRange = false) {
    return this.currentOrientation.getDateFromXY(xy, roundingMethod, local, allowOutOfRange);
  }
  /**
   * Gets the time for a DOM event such as 'mousemove' or 'click' regardless of the orientation of the time axis.
   * @param {Event} e the Event instance
   * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
   * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
   * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
   * @returns {Date} The date corresponding to the EventObject's position along the orientation of the time axis.
   * @category Dates
   */


  getDateFromDomEvent(e, roundingMethod, allowOutOfRange = false) {
    return this.getDateFromXY([e.pageX, e.pageY], roundingMethod, false, allowOutOfRange);
  }
  /**
   * Gets the start and end dates for an element Region
   * @param {Core.helper.util.Rectangle} rect The rectangle to map to start and end dates
   * @param {String} roundingMethod The rounding method to use
   * @param {Number} duration The duration in MS of the underlying event
   * @returns {Object} an object containing start/end properties
   */


  getStartEndDatesFromRectangle(rect, roundingMethod, duration, allowOutOfRange = false) {
    const me = this,
          {
      isHorizontal
    } = me,
          timeSpanEnd = isHorizontal ? me.timeAxisSubGrid.width : me.timeAxisSubGrid.height,
          startPos = isHorizontal ? rect.x : rect.top,
          endPos = isHorizontal ? rect.right : rect.bottom;
    let start, end; // Element within bounds

    if (startPos >= 0 && endPos < timeSpanEnd) {
      start = me.getDateFromCoordinate(startPos, roundingMethod, true);
      end = me.getDateFromCoordinate(endPos, roundingMethod, true);
    } // Starts before, start is worked backwards from end
    else if (startPos < 0) {
      end = me.getDateFromCoordinate(endPos, roundingMethod, true, allowOutOfRange);
      start = end && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(end, -duration, 'ms');
    } // Ends after, end is calculated from the start
    else {
      start = me.getDateFromCoordinate(startPos, roundingMethod, true, allowOutOfRange);
      end = start && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(start, duration, 'ms');
    }

    return {
      start,
      end
    };
  } //endregion
  //region Date display

  /**
   * Get/set format to use when displaying dates. Usually set by specifying a view preset
   * @property {String}
   * @category Dates
   */


  get displayDateFormat() {
    return this._displayDateFormat;
  }

  set displayDateFormat(format) {
    this._displayDateFormat = format; // Start/EndDateColumn listens for this to change their format to match

    this.trigger('displayDateFormatChange', {
      format
    });
  }
  /**
   * Method to get a formatted display date
   * @private
   * @param {Date} date The date
   * @return {String} The formatted date
   */


  getFormattedDate(date) {
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(date, this.displayDateFormat);
  }
  /**
   * Method to get a displayed end date value, see {@link #function-getFormattedEndDate} for more info.
   * @private
   * @param {Date} endDate The date to format
   * @param {Date} startDate The start date
   * @return {Date} The date value to display
   */


  getDisplayEndDate(endDate, startDate) {
    if ( // If time is midnight,
    endDate.getHours() === 0 && endDate.getMinutes() === 0 && ( // and end date is greater then start date
    !startDate || !(endDate.getYear() === startDate.getYear() && endDate.getMonth() === startDate.getMonth() && endDate.getDate() === startDate.getDate())) && // and UI display format doesn't contain hour info (in this case we'll just display the exact date)
    !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].formatContainsHourInfo(this.displayDateFormat)) {
      // format the date inclusively as 'the whole previous day'.
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(endDate, -1, 'day');
    }

    return endDate;
  }
  /**
   * Method to get a formatted end date for a scheduled event, the grid uses the "displayDateFormat" property defined in the current view preset.
   * End dates are formatted as 'inclusive', meaning when an end date falls on midnight and the date format doesn't involve any hour/minute information,
   * 1ms will be subtracted (e.g. 2010-01-08T00:00:00 will first be modified to 2010-01-07 before being formatted).
   * @private
   * @param {Date} endDate The date to format
   * @param {Date} startDate The start date
   * @return {String} The formatted date
   */


  getFormattedEndDate(endDate, startDate) {
    return this.getFormattedDate(this.getDisplayEndDate(endDate, startDate));
  } //endregion
  //region Other date functions

  /**
   * Gets the x or y coordinate relative to the scheduler element, or page coordinate (based on the 'local' flag)
   * If the coordinate is not in the currently rendered view, -1 will be returned.
   * @param {Date|Number} date the date to query for (or a date as ms)
   * @param {Boolean|Object} options true to return a coordinate local to the scheduler view element (defaults to true),
   * also accepts a config object like { local : true }.
   * @returns {Number} the x or y position representing the date on the time axis
   * @category Dates
   */


  getCoordinateFromDate(date, options = true) {
    const me = this,
          {
      timeAxisViewModel
    } = me,
          {
      isContinuous,
      startMS,
      endMS,
      startDate,
      endDate,
      unit
    } = me.timeAxis,
          dateMS = date.valueOf(); // Avoiding to break the API while allowing passing options through to getPositionFromDate()

    if (options === true) {
      options = {
        local: true
      };
    } else if (!options) {
      options = {
        local: false
      };
    } else if (!('local' in options)) {
      options.local = true;
    }

    let pos; // TODO for 2.0 try to normalize and just use dates as input for this method,
    // then this if-statement would not be needed

    if (!(date instanceof Date)) {
      tempDate.setTime(date);
      date = tempDate;
    } // Shortcut for continuous time axis that is using a unit that can be reliably translated to days (or smaller)


    if (isContinuous && date.getTimezoneOffset() === startDate.getTimezoneOffset() && startDate.getTimezoneOffset() === endDate.getTimezoneOffset() && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getUnitToBaseUnitRatio(unit, 'day') !== -1) {
      if (dateMS < startMS || dateMS > endMS) {
        return -1;
      }

      pos = (dateMS - startMS) / (endMS - startMS) * timeAxisViewModel.totalSize;
    } // Non-continuous or using for example months (vary in length)
    else {
      pos = timeAxisViewModel.getPositionFromDate(date, options);
    }

    if (!options.local) {
      pos = me.currentOrientation.translateToPageCoordinate(pos);
    }

    return pos;
  }
  /**
   * Returns the distance in pixels for the time span in the view.
   * @param {Date} startDate The start date of the span
   * @param {Date} endDate The end date of the span
   * @return {Number} The distance in pixels
   * @category Dates
   */


  getTimeSpanDistance(startDate, endDate) {
    return this.timeAxisViewModel.getDistanceBetweenDates(startDate, endDate);
  }
  /**
   * Returns the center date of the currently visible timespan of scheduler.
   *
   * @property {Date}
   * @readonly
   * @category Dates
   */


  get viewportCenterDate() {
    const me = this,
          {
      isHorizontal,
      timeAxis
    } = me,
          {
      scrollable
    } = isHorizontal ? me.timeAxisSubGrid : me,
          centerX = scrollable.x + scrollable.clientWidth / 2,
          centerY = scrollable.y + scrollable.clientHeight / 2;

    if (timeAxis.isContinuous) {
      // Calculate center pixel in the viewport.
      // Then Calculate how far through the axis range that is.
      const scrollCenter = isHorizontal ? centerX / scrollable.scrollWidth : centerY / scrollable.scrollHeight,
            centerMilli = timeAxis.startMS + (timeAxis.endMS - timeAxis.startMS) * scrollCenter;
      return new Date(centerMilli);
    } else {
      const xy = isHorizontal ? [centerX, 0] : [0, centerY];
      return me.getDateFromXY(xy, null, true);
    }
  }

  get viewportCenterDateCached() {
    return this.cachedCenterDate || (this.cachedCenterDate = this.viewportCenterDate);
  } //endregion
  //region TimeAxis getters/setters

  /**
   * Gets/sets the current time resolution object, which contains a unit identifier and an increment count { unit, increment }.
   * This value means minimal task duration you can create using UI.
   * For example when you drag create a task or drag & drop a task, if increment is 5 and unit is 'minute'
   * that means that you can create a 5 min long task, or move it 5 min forward/backward.
   * This value is taken from viewPreset {@link Scheduler.preset.ViewPreset#field-timeResolution timeResolution} config by default.
   * When supplying a `Number` to the setter only the `increment` is changed and the `unit` value remains untouched.
   *
   * ```javascript
   * timeResolution : {
   *   unit      : 'minute',  //Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
   *   increment : 5
   * }
   * ```
   *
   * @property {Object|Number}
   * @category Dates
   */


  get timeResolution() {
    return this.timeAxis.resolution;
  }

  set timeResolution(resolution) {
    this.timeAxis.resolution = typeof resolution === 'number' ? {
      increment: resolution,
      unit: this.timeAxis.resolution.unit
    } : resolution;
  } //endregion
  //region Snap

  /**
   * Controls whether the scheduler should snap to the resolution when interacting with it
   * @property {Boolean}
   * @category Dates
   */


  set snap(enabled) {
    // timeAxisViewModel is not created yet during configuration
    if (!this.isConfiguring) {
      this.timeAxisViewModel.snap = enabled;
    } else {
      this._snap = enabled;
    }
  }

  get snap() {
    // timeAxisViewModel is not created yet during configuration
    if (this.isConfiguring) {
      return this._snap;
    }

    return this.timeAxisViewModel.snap;
  } //endregion


  onSchedulerHorizontalScroll({
    subGrid,
    scrollLeft
  }) {
    // Invalidate cached center date unless we are scrolling to center on it.
    if (!this.scrollingToCenter) {
      this.cachedCenterDate = null;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineDomEvents.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineDomEvents.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/mixin/TimelineDomEvents
 */

const eventNameMap = {
  mousedown: 'MouseDown',
  mouseup: 'MouseUp',
  click: 'Click',
  dblclick: 'DblClick',
  contextmenu: 'ContextMenu',
  mouseover: 'MouseOver',
  mouseout: 'MouseOut'
};
/**
 * Mixin that handles dom events (click etc) for scheduler and rendered events.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineDomEvents extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  /**
   * Fires after a click on a time axis cell
   * @event timeAxisHeaderClick
   * @param {Scheduler.column.TimeAxisColumn|Scheduler.column.VerticalTimeAxisColumn} source The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */

  /**
   * Fires after a double click on a time axis cell
   * @event timeAxisHeaderDblClick
   * @param {Scheduler.column.TimeAxisColumn|Scheduler.column.VerticalTimeAxisColumn} source The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */

  /**
   * Fires after a right click on a time axis cell
   * @event timeAxisHeaderContextMenu
   * @param {Scheduler.column.TimeAxisColumn|Scheduler.column.VerticalTimeAxisColumn} source The column object
   * @param {Date} startDate The start date of the header cell
   * @param {Date} endDate The end date of the header cell
   * @param {Event} event The event object
   */
  static get $name() {
    return 'TimelineDomEvents';
  } //region Default config


  static get configurable() {
    return {
      // TODO: PORT longpress missing
      scheduledBarEvents: {
        mousedown: 'handleScheduledBarEvent',
        mouseup: 'handleScheduledBarEvent',
        click: 'handleScheduledBarEvent',
        dblclick: 'handleScheduledBarEvent',
        contextmenu: 'handleScheduledBarEvent',
        mouseover: 'handleScheduledBarEvent',
        mouseout: 'handleScheduledBarEvent'
      },
      // TODO: PORT pinch, pinchstart, pinchend missing
      schedulerEvents: {
        click: 'handleScheduleEvent',
        dblclick: 'handleScheduleEvent',
        contextmenu: 'handleScheduleEvent',
        mousemove: 'handleScheduleEvent'
      }
    };
  } //endregion
  //region Init

  /**
   * Adds listeners for DOM events for the scheduler and its events.
   * Which events is specified in Scheduler#scheduledBarEvents and Scheduler#schedulerEvents.
   * @private
   */


  initDomEvents() {
    const me = this; // Set thisObj and element of the configured listener specs.

    me.scheduledBarEvents.element = me.schedulerEvents.element = me.timeAxisSubGridElement;
    me.scheduledBarEvents.thisObj = me.schedulerEvents.thisObj = me; // same listener used for different events

    _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(me.scheduledBarEvents);
    _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(me.schedulerEvents);
  } //endregion
  //region Event handling


  getTimeSpanMouseEventParams(eventElement, event) {
    throw new Error('Implement in subclass');
  }

  getScheduleMouseEventParams(cellData, event) {
    throw new Error('Implement in subclass');
  }
  /**
   * Wraps dom Events for rendered scheduler EventModels and fires prefixed as our events.
   * For example click -> eventclick
   * @private
   * @param event
   */


  handleScheduledBarEvent(event) {
    const me = this,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, me.eventInnerSelector);

    if (eventElement) {
      const eventName = eventNameMap[event.type] || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(event.type);
      me.trigger(me.scheduledEventName + eventName, me.getTimeSpanMouseEventParams(eventElement, event));
    }
  }
  /**
   * Wraps dom Events for the scheduler and fires as our events.
   * For example click -> scheduleClick
   * @private
   * @param event
   */


  handleScheduleEvent(event) {
    const me = this,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, me.eventSelector),
          cellElement = !eventElement && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, '.' + me.timeCellCls),
          eventName = eventNameMap[event.type] || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(event.type);

    if (cellElement) {
      const clickedDate = me.getDateFromDomEvent(event, 'floor');

      if (!clickedDate) {
        return;
      }

      const cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(cellElement),
            index = cellData.row.dataIndex,
            tickIndex = me.timeAxis.getTickFromDate(clickedDate),
            tick = me.timeAxis.getAt(Math.floor(tickIndex));

      if (tick) {
        me.trigger('schedule' + eventName, Object.assign({
          date: clickedDate,
          tickStartDate: tick.startDate,
          tickEndDate: tick.endDate,
          tickParentIndex: tick.parentIndex,
          row: cellData.row,
          index,
          event
        }, me.getScheduleMouseEventParams(cellData, event)));
      }
    }
  }

  onElementMouseButtonEvent(event) {
    const target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, '.b-sch-header-timeaxis-cell');

    if (target) {
      const index = target.dataset.tickIndex,
            position = target.parentElement.dataset.headerPosition,
            columnConfig = this.timeAxisViewModel.columnConfig[position][index],
            contextMenu = this.features.contextMenu; // Skip same events with Grid context menu triggerEvent

      if (!contextMenu || event.type !== contextMenu.triggerEvent) {
        const column = this.isVertical ? this.verticalTimeAxisColumn : this.timeAxisColumn; // TODO 5.0 change to this.trigger

        column.trigger('timeAxisHeader' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(event.type), {
          startDate: columnConfig.start,
          endDate: columnConfig.end,
          event
        });
      }
    }
  }

  onElementClick(event) {
    this.onElementMouseButtonEvent(event);
    super.onElementClick(event);
  }

  onElementDblClick(event) {
    this.onElementMouseButtonEvent(event);
    super.onElementDblClick(event);
  }

  onElementContextMenu(event) {
    this.onElementMouseButtonEvent(event);
    super.onElementContextMenu(event);
  }
  /**
   * Relays mouseover events as eventmouseenter if over rendered event.
   * Also adds Scheduler#overScheduledEventClass to the hovered element.
   * @private
   */


  onElementMouseOver(event) {
    super.onElementMouseOver(event);
    const me = this,
          target = event.target; // We must be over the event bar

    if (target.closest(me.eventInnerSelector)) {
      const eventElement = target.closest(me.eventSelector);
      eventElement.classList.add(me.overScheduledEventClass);

      if (eventElement !== me.hoveredEventNode && !me.preventOverCls) {
        me.hoveredEventNode = eventElement;
        const params = me.getTimeSpanMouseEventParams(eventElement, event);

        if (params) {
          // do not fire this event if model cannot be found
          // this can be the case for "b-sch-dragcreator-proxy" elements for example
          me.trigger(me.scheduledEventName + 'MouseEnter', params);
        }
      }
    } else {
      me.hoveredEventNode = null;
    }
  }
  /**
   * Relays mouseout events as eventmouseleave if out from rendered event.
   * Also removes Scheduler#overScheduledEventClass from the hovered element.
   * @private
   */


  onElementMouseOut(event) {
    super.onElementMouseOut(event);
    const me = this; // We must be over the event bar

    if (event.target.closest(me.eventInnerSelector) && me.resolveTimeSpanRecord(event.target) && me.hoveredEventNode) {
      // out to child shouldn't count...
      if (event.relatedTarget && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isDescendant(event.target.closest(me.eventInnerSelector), event.relatedTarget)) return;
      me.unhover(event);
    }
  }

  unhover(event) {
    const me = this,
          eventElement = me.hoveredEventNode;

    if (eventElement) {
      eventElement.classList.remove(me.overScheduledEventClass);
      me.trigger(me.scheduledEventName + 'MouseLeave', me.getTimeSpanMouseEventParams(eventElement, event));
      me.hoveredEventNode = null;
    }
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineEventRendering.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineEventRendering.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/mixin/TimelineEventRendering
 */

/**
 * Functions to handle event rendering (EventModel -> dom elements).
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineEventRendering extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TimelineEventRendering';
  } //region Default config


  static get defaultConfig() {
    return {
      /**
       * Controls how much space to leave between stacked event bars in px
       * @config {Number}
       * @default
       * @category Scheduled events
       */
      barMargin: 10,
      resourceMargin: null,

      /**
       * True to size events based on the rowHeight and barMargin settings. Set this to false if you want to
       * control height and top properties via CSS instead.
       * @config {Boolean}
       * @default
       * @category Scheduled events
       */
      managedEventSizing: true,

      /**
       * The CSS class added to an event/assignment when it is newly created
       * in the UI and unsynced with the server.
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      generatedIdCls: 'b-sch-dirty-new',

      /**
       * The CSS class added to an event when it has unsaved modifications
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      dirtyCls: 'b-sch-dirty',

      /**
       * The CSS class added to an event when it is currently committing changes
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      committingCls: 'b-sch-committing',

      /**
       * The CSS class added to an event/assignment when it ends outside of the visible time range.
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      endsOutsideViewCls: 'b-sch-event-endsoutside',

      /**
       * The CSS class added to an event/assignment when it starts outside of the visible time range.
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      startsOutsideViewCls: 'b-sch-event-startsoutside',

      /**
       * The CSS class added to an event/assignment when it is not draggable.
       * @config {String}
       * @default
       * @private
       * @category CSS
       */
      fixedEventCls: 'b-sch-event-fixed',

      /**
       * Event style used by default. Events and resources can specify their own style, with priority order being:
       * Event -> Resource -> Scheduler default. Determines the appearance of the event by assigning a CSS class
       * to it. Available styles are:
       *
       * * `'plain'` (default) - flat look
       * * `'border'` - has border in darker shade of events color
       * * `'colored'` - has colored text and wide left border in same color
       * * `'hollow'` - only border + text until hovered
       * * `'line'` - as a line with the text below it
       * * `'dashed'` - as a dashed line with the text below it
       * * `'minimal'` - as a thin line with small text above it
       * * `'rounded'` - minimalistic style with rounded corners
       *
       * In addition, there are two styles intended to be used when integrating with Bryntum Calendar. To match
       * the look of Calendar events, you can use:
       *
       * * `'calendar'` - a variation of the "colored" style matching the default style used by Calendar
       * * `'interday'` - a variation of the "plain" style, for interday events
       *
       * Specify `null` to not apply a default style and take control using custom CSS (easily overridden basic
       * styling will be used).
       *
       * @config {String}
       * @default
       * @category Scheduled events
       */
      eventStyle: 'plain',

      /**
       * Event color used by default. Events and resources can specify their own color, with priority order being:
       * Event -> Resource -> Scheduler default. Available colors are:
       * * red
       * * pink
       * * purple
       * * violet
       * * indigo
       * * blue
       * * cyan
       * * teal
       * * green
       * * lime
       * * yellow
       * * orange
       * * deep-orange
       * * gray
       * * gantt-green (Useful when you want to match the color to the default color in Gantt)
       *
       * Specify `null` to not apply a default color and take control using custom CSS (an easily overridden color
       * will be used to make sure events are still visible).
       *
       * @config {String}
       * @default
       * @category Scheduled events
       */
      eventColor: 'green',

      /**
       * The width/height (depending on vertical / horizontal mode) of all the time columns.
       * @config {Number}
       * @category Scheduled events
       */
      tickSize: null
    };
  } //endregion
  //region Settings

  /**
   * Control how much space to leave between stacked event bars in px. Value will be constrained by half the row height.
   * @property {Number}
   * @category Scheduled events
   */


  get barMargin() {
    return this._barMargin;
  }

  set barMargin(margin) {
    const me = this;
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertNumber(margin, 'barMargin'); // bar margin should not exceed half of the row height

    if (me.isHorizontal && me.rowHeight) {
      margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
    }

    if (me._barMargin !== margin) {
      me._barMargin = margin;

      if (me.rendered) {
        me.currentOrientation.onBeforeRowHeightChange();
        me.refreshWithTransition();
      }
    }
  } // Documented in SchedulerEventRendering to not show up in Gantt docs


  get resourceMargin() {
    return this._resourceMargin == null ? this.barMargin : this._resourceMargin;
  }

  set resourceMargin(margin) {
    const me = this;
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertNumber(margin, 'resourceMargin'); // bar margin should not exceed half of the row height

    if (me.isHorizontal && me.rowHeight) {
      margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
    }

    if (me._resourceMargin !== margin) {
      me._resourceMargin = margin;

      if (me.rendered) {
        me.currentOrientation.onBeforeRowHeightChange();
        me.refreshWithTransition();
      }
    }
  }
  /**
   * Get/set the width/height (depending on mode) of all the time columns to the supplied value.
   * There is a limit for the tick size value. Its minimal allowed value is calculated so ticks would fit the available space.
   * Only applicable when {@link Scheduler.view.TimelineBase#config-forceFit} is set to `false`.
   * To set `tickSize` freely skipping that limitation please set {@link Scheduler.view.TimelineBase#config-suppressFit} to `true`.
   * @property {Number}
   * @category Scheduled events
   */


  set tickSize(width) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertNumber(width, 'tickSize');
    this.timeAxisViewModel.tickSize = width;
  }

  get tickSize() {
    return this.timeAxisViewModel.tickSize;
  }
  /**
   * Predefined event colors, useful in combos etc.
   * @type {String[]}
   * @category Scheduled events
   */


  static get eventColors() {
    return ['red', 'pink', 'purple', 'violet', 'indigo', 'blue', 'cyan', 'teal', 'green', 'lime', 'yellow', 'orange', 'deep-orange', 'gray'];
  }
  /**
   * Predefined event styles , useful in combos etc.
   * @type {String[]}
   * @category Scheduled events
   */


  static get eventStyles() {
    return ['plain', 'border', 'hollow', 'colored', 'line', 'dashed', 'minimal', 'rounded'];
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineScroll.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineScroll.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/mixin/TimelineScroll
 */

const maintainVisibleStart = {
  maintainVisibleStart: true
},
      defaultScrollOptions = {
  block: 'nearest'
};
/**
 * Functions for scrolling to events, dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineScroll extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TimelineScroll';
  }

  static get configurable() {
    return {
      /**
       * This config defines the size of the start and end invisible parts of the timespan when {@link #config-infiniteScroll} set to `true`.
       *
       * It should be provided as a coefficient, which will be multiplied by the size of the scheduling area.
       *
       * For example, if `bufferCoef` is `5` and the panel view width is 200px then the timespan will be calculated to
       * have approximately 1000px (`5 * 200`) to the left and 1000px to the right of the visible area, resulting
       * in 2200px of totally rendered content.
       *
       * @config {Number}
       * @category Infinite scroll
       * @default
       */
      bufferCoef: 5,

      /**
       * This config defines the scroll limit, which, when exceeded will cause a timespan shift.
       * The limit is calculated as the `panelWidth * {@link #config-bufferCoef} * bufferThreshold`. During scrolling, if the left or right side
       * has less than that of the rendered content - a shift is triggered.
       *
       * For example if `bufferCoef` is `5` and the panel view width is 200px and `bufferThreshold` is 0.2, then the timespan
       * will be shifted when the left or right side has less than 200px (5 * 200 * 0.2) of content.
       * @config {Number}
       * @category Infinite scroll
       * @default
       */
      bufferThreshold: 0.2,

      /**
       * True to automatically adjust the panel timespan during scrolling in the time dimension, when the scroller
       * comes close to the start/end edges.
       *
       * The actually rendered timespan in this mode (and thus the amount of HTML in the DOM) is calculated based
       * on the {@link #config-bufferCoef} option. The moment when the timespan shift happens is determined by the {@link #config-bufferThreshold} value.
       * @config {Boolean} infiniteScroll
       * @category Infinite scroll
       * @default
       */
      infiniteScroll: false
    };
  }

  initScroll() {
    const me = this,
          {
      isHorizontal
    } = me;
    super.initScroll();
    const {
      scrollable
    } = isHorizontal ? me.timeAxisSubGrid : me; // A Scroller which scrolls in the TIME axis, whichever that may be.

    me.timelineScroller = new TimelineScroller({
      widget: me,
      scrollable,
      isHorizontal
    });
    scrollable.on({
      scroll: 'onTimelineScroll',
      thisObj: me
    }); // Ensure the TimeAxis starts life at the correct size with buffer zones
    // outside the visible window.

    if (me.infiniteScroll) {
      const {
        visibleDate
      } = me,
            date = visibleDate ? visibleDate.date || visibleDate : me.viewportCenterDate,
            centered = visibleDate && 'block' in visibleDate ? visibleDate.block === 'center' : true,
            {
        startDate,
        endDate
      } = me.timeAxisViewModel.calculateInfiniteScrollingDateRange(date, centered); // Don't ask to maintain visible start - we're initializing - there's no visible start yet.
      // If there's a visibleDate set, it will execute its scroll on paint.

      me.setTimeSpan(startDate, endDate, {
        visibleDate: date
      });
    }
  }

  doDestroy() {
    var _this$timelineScrolle;

    (_this$timelineScrolle = this.timelineScroller) === null || _this$timelineScrolle === void 0 ? void 0 : _this$timelineScrolle.destroy();
    super.doDestroy();
  }

  onTimelineScroll({
    source
  }) {
    // On scroll, check if we are nearing the end to see if the sliding window needs moving.
    // onSchedulerHorizontalScroll is delayed to animationFrame
    if (this.infiniteScroll) {
      this.checkTimeAxisScroll(source[this.isHorizontal ? 'x' : 'y']);
    }
  }

  checkTimeAxisScroll(scrollPos) {
    const me = this,
          scrollable = me.timelineScroller,
          {
      clientSize
    } = scrollable,
          requiredSize = clientSize * me.bufferCoef,
          limit = requiredSize * me.bufferThreshold,
          maxScroll = scrollable.maxPosition,
          {
      style
    } = me.timeAxisSubGrid.virtualScrollerElement; // if scroll violates limits let's shift timespan

    if (maxScroll - scrollPos < limit || scrollPos < limit) {
      // If they were dragging the thumb, this must be a one-time thing. They *must* lose contact
      // with the thumb when the window shift occurs and the thumb zooms back to the center.
      // Changing for a short time to overflow:hidden terminates the thumb drag.
      // They can start again from the center, the reset happens very quickly.
      style.overflow = 'hidden';
      style.pointerEvents = 'none'; // Avoid content height changing when scrollbar disappears

      style.paddingBottom = `${_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth}px`;
      me.setTimeout(() => {
        style.overflow = '';
        style.paddingBottom = '';
        style.pointerEvents = '';
      }, 100);
      me.shiftToDate(me.getDateFromCoordinate(scrollPos, null, true));
    }
  }

  shiftToDate(date, centered) {
    const newRange = this.timeAxisViewModel.calculateInfiniteScrollingDateRange(date, centered); // this will trigger a refresh (`refreshKeepingScroll`) which will perform `restoreScrollState` and sync the scrolling position

    this.setTimeSpan(newRange.startDate, newRange.endDate, maintainVisibleStart);
  } // If we change to infinite scrolling dynamically, it should create the buffer zones.


  updateInfiniteScroll(infiniteScroll) {
    // At construction time, this is handled in initScroll.
    // This is just here to handle dynamic updates.
    if (!this.isConfiguring && infiniteScroll) {
      this.checkTimeAxisScroll(this.timelineScroller.position);
    }
  } //region Scroll to date

  /**
   * Scrolls the time line "tick" encapsulating the passed `Date` into view according to the passed options.
   * @param {Date} date The date to which to scroll the time line
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollToDate(date, options = {}) {
    const me = this,
          {
      timeAxis,
      visibleDateRange,
      infiniteScroll
    } = me,
          {
      unit,
      increment
    } = timeAxis,
          edgeOffset = options.edgeOffset || 0,
          visibleWidth = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].ceil(visibleDateRange.endDate, increment + ' ' + unit) - _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].floor(visibleDateRange.startDate, increment + ' ' + unit),
          direction = date > me.viewportCenterDate ? 1 : -1,
          extraScroll = (infiniteScroll ? visibleWidth * me.bufferCoef * me.bufferThreshold : options.block === 'center' ? visibleWidth / 2 : edgeOffset ? me.getMilliSecondsPerPixelForZoomLevel(me.viewPreset) * edgeOffset : 0) * direction,
          visibleDate = new Date(date.getTime() + extraScroll),
          shiftDirection = visibleDate > timeAxis.endDate ? 1 : visibleDate < timeAxis.startDate ? -1 : 0; // Required visible date outside TimeAxis and infinite scrolling, that has opinions about how
    // much scroll range has to be created after the target date.

    if (shiftDirection && me.infiniteScroll) {
      me.shiftToDate(new Date(date - extraScroll), null, true);
    }

    const scrollerViewport = me.timelineScroller.viewport,
          localCoordinate = me.getCoordinateFromDate(date, true),
          target = me.isHorizontal ? new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](me.getCoordinateFromDate(date, false), scrollerViewport.y, me.timeAxisViewModel.tickSize, scrollerViewport.height) : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](scrollerViewport.x, me.getCoordinateFromDate(date, false), scrollerViewport.width, me.timeAxisViewModel.tickSize);
    return me.scrollToCoordinate(localCoordinate, target, date, options);
  }
  /**
   * Scrolls to current time.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   */


  scrollToNow(options = {}) {
    return this.scrollToDate(new Date(), options);
  }
  /**
   * Used by {@link #function-scrollToDate} to scroll to correct coordinate.
   * @param {Number} localCoordinate Coordinate to scroll to
   * @param {Date} date Date to scroll to, used for reconfiguring the time axis
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin *in pixels* around the tick to bring into view.
   * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
   * @returns {Promise} A Promise which resolves when the scrolling is complete.
   * @private
   */


  async scrollToCoordinate(localCoordinate, target, date, options = {}) {
    const me = this; // Not currently have this date in a timeaxis. Ignore negative scroll in weekview, it can be just 'filtered' with
    // startTime/endTime config

    if (localCoordinate < 0) {
      // adjust the timeaxis first
      const visibleSpan = me.endDate - me.startDate,
            {
        unit,
        increment
      } = me.timeAxis,
            newStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].floor(new Date(date.getTime() - visibleSpan / 2), increment + ' ' + unit),
            newEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(newStartDate, visibleSpan); // We're trying to reconfigure time span to current dates, which means we are as close to center as it
      // could be. Do nothing then.
      // covered by 1102_panel_api

      if (newStartDate - me.startDate !== 0 && newEndDate - me.endDate !== 0) {
        me.setTimeSpan(newStartDate, newEndDate);
        return me.scrollToDate(date, options);
      }

      return;
    }

    await me.timelineScroller.scrollIntoView(target, options); // Horizontal scroll is triggered on next frame in SubGrid.js, view is not up to date yet. Resolve on next frame

    return !me.isDestroyed && me.nextAnimationFrame();
  } //endregion
  //region Relative scrolling
  // These methods are important to users because although they are mixed into the top level Grid/Scheduler,
  // for X scrolling the explicitly target the SubGrid that holds the scheduler.

  /**
   * Get/set horizontal scroll. Applies to the SubGrid that holds the scheduler
   * @property {Number}
   * @category Scrolling
   */


  set scrollLeft(left) {
    this.timeAxisSubGrid.scrollable.x = left;
  }
  /**
   * Get/set vertical scroll
   * @property {Number}
   * @category Scrolling
   */


  set scrollTop(top) {
    this.scrollable.y = top;
  }

  get scrollLeft() {
    return this.timeAxisSubGrid.scrollable.x;
  }

  get scrollTop() {
    return this.scrollable.y;
  }
  /**
   * Horizontal scrolling. Applies to the SubGrid that holds the scheduler
   * @param {Number} x
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  scrollHorizontallyTo(coordinate, options = true) {
    return this.timeAxisSubGrid.scrollable.scrollTo(coordinate, null, options);
  }
  /**
   * Vertical scrolling
   * @param {Number} y
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  scrollVerticallyTo(y, options = true) {
    return this.scrollable.scrollTo(null, y, options);
  }
  /**
   * Scrolls the subgrid that contains the scheduler
   * @param {Number} x
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  scrollTo(x, options = true) {
    return this.timeAxisSubGrid.scrollable.scrollTo(x, null, options);
  } //endregion
  // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

}); // Internal class used to interrogate and manipulate the timeline scroll position.
// This delegates all operations to the appropriate Scroller, horizontal or vertical.

class TimelineScroller extends _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get configurable() {
    return {
      position: null,
      x: null,
      y: null
    };
  } // This class is passive about configuring the element.
  // It has no opinions about *how* the overflow is handled.


  updateOverflowX() {}

  updateOverflowY() {}

  onScroll(e) {
    super.onScroll(e);
    this._position = null;
  }

  syncPartners(force) {
    this.scrollable.syncPartners(force);
  }

  updatePosition(position) {
    this.scrollable[this.isHorizontal ? 'x' : 'y'] = position;
  }

  get viewport() {
    return this.scrollable.viewport;
  }

  get position() {
    return this._position = this.scrollable.element[this.isHorizontal ? 'scrollLeft' : 'scrollTop'];
  }

  get clientSize() {
    return this.scrollable[`client${this.isHorizontal ? 'Width' : 'Height'}`];
  }

  get scrollSize() {
    return this.scrollable[`scroll${this.isHorizontal ? 'Width' : 'Height'}`];
  }

  get maxPosition() {
    return this.scrollable[`max${this.isHorizontal ? 'X' : 'Y'}`];
  }

  scrollTo(position, options) {
    return this.isHorizontal ? this.scrollable.scrollTo(position, null, options) : this.scrollable.scrollTo(null, position, options);
  }

  scrollBy(xDelta = 0, yDelta = 0, options = defaultScrollOptions) {
    // Use the correct delta by default, but if it's zero, accommodate axis error.
    return this.isHorizontal ? this.scrollable.scrollBy(xDelta || yDelta, 0, options) : this.scrollable.scrollBy(0, yDelta || xDelta, options);
  }

  scrollIntoView() {
    return this.scrollable.scrollIntoView(...arguments);
  } // We accommodate mistakes. Setting X and Y sets the appropriate scroll axis position


  changeX(x) {
    this.position = x;
  }

  changeY(y) {
    this.position = y;
  }

  get x() {
    return this.position;
  }

  set x(x) {
    this.scrollable[this.isHorizontal ? 'x' : 'y'] = x;
  }

  get y() {
    return this.position;
  }

  set y(y) {
    this.scroller[this.isHorizontal ? 'x' : 'y'] = y;
  }

  get clientWidth() {
    return this.clientSize;
  }

  get clientHeight() {
    return this.clientSize;
  }

  get scrollWidth() {
    return this.scrollSize;
  }

  get scrollHeight() {
    return this.scrollSize;
  }

  get maxX() {
    return this.maxPosition;
  }

  get maxY() {
    return this.maxPosition;
  }

}

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineViewPresets.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineViewPresets.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../preset/PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/mixin/TimelineViewPresets
 */

const datesDiffer = (d1 = 0, d2 = 0) => d2 - d1;
/**
 * View preset handling.
 *
 * A Scheduler's {@link #config-presets} are loaded with a default set of {@link Scheduler.preset.ViewPreset ViewPresets}
 * which are defined by the system in the {@link Scheduler.preset.PresetManager PresetManager}.
 *
 * The zooming feature works by reconfiguring the Scheduler with a new {@link Scheduler.preset.ViewPreset ViewPreset} selected
 * from the {@link #config-presets} store.
 *
 * {@link Scheduler.preset.ViewPreset ViewPresets} can be added and removed from the store to change the amount of available steps.
 * Range of zooming in/out can be also modified with {@link Scheduler.view.mixin.TimelineZoomable#config-maxZoomLevel} / {@link Scheduler.view.mixin.TimelineZoomable#config-minZoomLevel} properties.
 *
 * This mixin adds additional methods to the column : {@link Scheduler.view.mixin.TimelineZoomable#property-maxZoomLevel}, {@link Scheduler.view.mixin.TimelineZoomable#property-minZoomLevel}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomToLevel}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomIn},
 * {@link Scheduler.view.mixin.TimelineZoomable#function-zoomOut}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomInFull}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomOutFull}.
 *
 * **Notice**: Zooming is not supported when `forceFit` option is set to true for the Scheduler or for filtered timeaxis.
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineViewPresets extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TimelineViewPresets';
  } //region Default config


  static get configurable() {
    return {
      /**
       * A string key used to lookup a predefined {@link Scheduler.preset.ViewPreset} (e.g. 'weekAndDay', 'hourAndDay'),
       * managed by {@link Scheduler.preset.PresetManager}. See {@link Scheduler.preset.PresetManager} for more information.
       * Or a config object for a viewPreset.
       *
       * Options:
       * - 'secondAndMinute'
       * - 'minuteAndHour'
       * - 'hourAndDay'
       * - 'dayAndWeek'
       * - 'weekAndDay'
       * - 'weekAndMonth',
       * - 'monthAndYear'
       * - 'year'
       * - 'manyYears'
       * - 'weekAndDayLetter'
       * - 'weekDateAndMonth'
       * - 'day'
       * - 'week'
       *
       * If passed as a config object, the settings from the viewPreset with the provided `base` property will be used along
       * with any overridden values in your object.
       *
       * To override:
       * ```javascript
       * viewPreset : {
       *   base    : 'hourAndDay',
       *   id      : 'myHourAndDayPreset',
       *   headers : [
       *       {
       *           unit      : "hour",
       *           increment : 12,
       *           renderer  : (startDate, endDate, headerConfig, cellIdx) => {
       *               return "";
       *           }
       *       }
       *   ]
       * }
       * ```
       * or set a new valid preset config if the preset is not registered in the {@link Scheduler.preset.PresetManager}.
       *
       * When you use scheduler in weekview mode, this config is used to pick view preset. If passed view preset is not
       * supported by weekview (only 2 supported by default - 'day' and 'week') default preset will be used - 'week'.
       * @config {String|Object}
       * @default
       * @category Common
       */
      viewPreset: 'weekAndDayLetter'
    };
  }

  static get defaultConfig() {
    return {
      /**
       * Defines how dates will be formatted in tooltips etc. This config has priority over similar config on the
       * view preset. For allowed values see {@link Core.helper.DateHelper#function-format-static}.
       * @config {String}
       * @category Scheduled events
       */
      displayDateFormat: null,

      /**
       * An array of {@link Scheduler.preset.ViewPreset ViewPreset} config objects
       * which describes the available timeline layouts for this scheduler.
       *
       * By default, a predefined set is loaded from the {@link Scheduler.preset.PresetManager PresetManager}.
       *
       * A {@link Scheduler.preset.ViewPreset ViewPreset} describes the granularity of the
       * timeline view and the layout and subdivisions of the timeline header.
       * @config {Object[]} presets
       *
       * @category Common
       */
      presets: true
    };
  } //endregion

  /**
   * Get/set the current view preset
   * @member {Scheduler.preset.ViewPreset|String} viewPreset
   * @param [viewPreset.options]
   * @param {Date} [viewPreset.options.startDate] A new start date for the time axis
   * @param {Date} [viewPreset.options.endDate] A new end date for the time axis
   * @param {Date} [viewPreset.options.centerDate] Where to center the new time axis
   * @category Common
  */
  //region Get/set

  /**
   * Get the {@link Scheduler.preset.PresetStore PresetStore} created for the Scheduler,
   * or set an array of {@link Scheduler.preset.ViewPreset ViewPreset} config objects.
   * @property {Scheduler.preset.PresetStore|Object[]}
   * @category Common
   */


  set presets(presets) {
    if (presets === true) {
      presets = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].allRecords;
    }

    this._presets = new _preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
      owner: this,
      data: presets
    });
  }

  get presets() {
    return this._presets;
  }

  normalizePreset(preset) {
    const me = this,
          input = preset,
          {
      presets
    } = me; // They may have passed a string id, an number index, or ViewPreset config object.

    if (!(preset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
      // A config of a preset, instantiate it based upon any base that may be requested.
      // This may be one that's supplied by Bryntum in the PresetManager, or one that has been
      // previously added to this Scheduler's preset store.
      if (typeof preset === 'object') {
        // Look up any existing ViewPreset that it is based upon.
        if (preset.base) {
          // Look locally first, then in the PresetManager
          const base = presets.getById(preset.base) || _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].getById(preset.base);

          if (!base) {
            throw new Error(`ViewPreset base '${preset.base}' does not exist`);
          } // The config is based upon the base's data with the new Preset type's normalized data object merged in.
          // MUST run the incoming data block through the constructor in order to apply the backward compatibility
          // processing to the data block to be merged with the base.


          preset = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(base.data), _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].createRecord(preset).data);
        } // Ensure the new ViewPreset has a legible, logical id which does not already
        // exist in our store.


        if (preset.id) {
          preset = presets.createRecord(preset);
        } else {
          preset = presets.createRecord(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({}, preset));
          preset.id = preset.generateId(presets);
        }
      } // Must be an index or id
      else {
        if (typeof preset === 'number') {
          preset = presets.getAt(preset);
        } else {
          preset = presets.getById(preset) || _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].getById(preset);
        }
      }

      if (!preset) {
        const validPresets = presets.map(preset => preset.id);
        throw new Error(`Invalid ViewPreset: ${input}. Valid strings are ${validPresets.join(', ')}`);
      }
    } // An instance.
    // If an existing id is used, this will replace it.


    return presets.add(preset)[0];
  }

  changeViewPreset(viewPreset, oldViewPreset) {
    const me = this; // Throw on use of expired deprecated usage.

    if (!(viewPreset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_2__["default"]) && viewPreset.name && !viewPreset.base) {
      throw new Error('ViewPreset name config replaced by base config. See https://bryntum.com/docs/scheduler/guide/Scheduler/upgrades/3.0.0');
    }

    viewPreset = me.normalizePreset(viewPreset);
    const lastOpts = me.lastViewPresetOptions || {},
          options = viewPreset.options || (viewPreset.options = {}),
          event = options.event = {
      startDate: options.startDate,
      endDate: options.endDate,
      from: oldViewPreset,
      to: viewPreset,
      preset: viewPreset
    },
          presetChanged = !me._viewPreset || !me._viewPreset.equals(viewPreset),
          optionsChanged = datesDiffer(options.startDate, lastOpts.startDate) || datesDiffer(options.endDate, lastOpts.endDate) || datesDiffer(options.centerDate, lastOpts.centerDate) || options.startDate && datesDiffer(options.startDate, me.startDate) || options.endDate && datesDiffer(options.endDate, me.endDate); // Only return the value for onward processing if there's a change

    if (presetChanged || optionsChanged) {
      // Bypass the no-change check if the viewPreset is the same and we only got in here
      // because different options were asked for.
      if (!presetChanged) {
        me._viewPreset = null;
      }
      /**
       * Fired before the {@link #config-viewPreset} is changed.
       * @event beforePresetChange
       * @param {Scheduler.view.Scheduler} source This Scheduler instance.
       * @param {Date} startDate The new start date of the timeline.
       * @param {Date} endDate The new end date of the timeline.
       * @param {Scheduler.preset.ViewPreset} from The outgoing ViewPreset.
       * @param {Scheduler.preset.ViewPreset} to The ViewPreset being switched to.
       * @preventable
       */
      // Do not trigger events for the initial preset


      if (me.isConfiguring || me.trigger('beforePresetChange', event) !== false) {
        return viewPreset;
      }
    }
  }

  updateViewPreset(preset) {
    const me = this,
          {
      options
    } = preset,
          {
      event,
      startDate,
      endDate
    } = options,
          {
      isHorizontal,
      _timeAxis: timeAxis,
      // Do not tickle the getter, we are just peeking to see if it's there yet.
      timeAxisViewModel
    } = me;
    let {
      centerDate
    } = options,
        forceUpdate = false; // Raise flag to prevent partner from changing view preset if one is in progress

    me._viewPresetChanging = true; // prefer to use displayDateFormat configured on the panel

    me.displayDateFormat = me.config.displayDateFormat || preset.displayDateFormat;

    if (timeAxis && !me.isConfiguring) {
      // Cache options only when they are applied so that non-change vetoing in changeViewPreset is accurate
      me.lastViewPresetOptions = options; // Timeaxis may already be configured (in case of sharing with the timeline partner), no need to reconfigure it

      if (timeAxis.isConfigured) {
        // None of this reconfiguring should cause a refresh
        me.suspendRefresh();
        const timeAxisCfg = {
          weekStartDay: me.weekStartDay,
          startTime: me.startTime,
          endTime: me.endTime
        };

        if (me.infiniteScroll) {
          Object.assign(timeAxisCfg, timeAxisViewModel.calculateInfiniteScrollingDateRange(centerDate = me.viewportCenterDate, true, preset));
        } // if startDate is provided we use it and the provided endDate
        else if (startDate) {
          timeAxisCfg.startDate = startDate;
          timeAxisCfg.endDate = endDate; // if both dates are provided we can calculate centerDate for the viewport

          if (!centerDate && endDate) {
            centerDate = new Date((startDate.getTime() + endDate.getTime()) / 2);
          } // when no start/end dates are provided we use the current timespan

        } else {
          timeAxisCfg.startDate = timeAxis.startDate;
          timeAxisCfg.endDate = endDate || timeAxis.endDate;

          if (!centerDate) {
            centerDate = me.viewportCenterDate;
          }
        }

        timeAxis.isConfigured = false;
        timeAxis.viewPreset = preset;
        timeAxis.reconfigure(timeAxisCfg, true);
        timeAxisViewModel.reconfigure({
          viewPreset: preset,
          headers: preset.headers,
          // This was hardcoded to 'middle' prior to the Preset refactor.
          // In the old code, the default headers were 'top' and 'middle', which
          // meant that 'middle' meant the lowest header.
          // So this is now length - 1.
          columnLinesFor: preset.columnLinesFor != null ? preset.columnLinesFor : preset.headers.length - 1,
          tickSize: isHorizontal ? preset.tickWidth : preset.tickHeight || preset.tickWidth || 60
        }); // Allow refresh to run after the reconfiguring, without refreshing since we will do that below anyway

        me.resumeRefresh(false);
      }

      me.refresh(); // if view is rendered and scroll is not disabled by "notScroll" option

      if (!options.notScroll && me.isPainted) {
        // and we have centerDate to scroll to
        if (centerDate) {
          // remember the central date we scroll to (it gets reset after user scroll)
          me.cachedCenterDate = centerDate; // setViewPreset method on a partner panels should be executed with same arguments.
          // if one partner was provided with a centerDate, other one has to be too to generate exact
          // header and set same scroll

          event.centerDate = centerDate;
          const viewportSize = me.isHorizontal ? me.timeAxisSubGrid.width : me.scrollable.clientHeight,
                coord = Math.max(me.getCoordinateFromDate(centerDate, true) - viewportSize / 2, 0); // The horizontal scroll handler must not invalidate the cached center
          // when this scroll event rolls round on the next frame.

          me.scrollingToCenter = true; // If preset change does not lead to a scroll we have to "refresh" manually at the end

          if (coord === (me.isHorizontal ? me.scrollLeft : me.scrollTop)) {
            forceUpdate = true;
          } else if (me.isHorizontal) {
            me.scrollHorizontallyTo(coord, false);
          } else {
            me.scrollVerticallyTo(coord, false);
          } // Release the lock on scrolling invalidating the cached center.


          me.setTimeout(() => {
            me.scrollingToCenter = false;
          }, 100);
        } else {
          // If preset change does not lead to a scroll we have to "refresh" manually at the end
          if ((me.isHorizontal ? me.scrollLeft : me.scrollTop) === 0) {
            forceUpdate = true;
          } // If we don't have a center date to scroll to, we reset scroll (this is bw compatible behavior)
          else {
            me.timelineScroller.scrollTo(0);
          }
        }
      }
    } // Update Scheduler element showing what preset is applied


    me.dataset.presetId = preset.id;
    /**
     * Fired after the {@link #config-viewPreset} has changed.
     * @event presetChange
     * @param {Scheduler.view.Scheduler} source This Scheduler instance.
     * @param {Date} startDate The new start date of the timeline.
     * @param {Date} centerDate The new center date of the timeline.
     * @param {Date} endDate The new end date of the timeline.
     * @param {Scheduler.preset.ViewPreset} from The outgoing ViewPreset.
     * @param {Scheduler.preset.ViewPreset} to The ViewPreset being switched to.
     * @preventable
     */

    me.trigger('presetChange', event);
    me._viewPresetChanging = false;

    if (forceUpdate) {
      if (me.isHorizontal) {
        me.currentOrientation.updateFromHorizontalScroll(me.scrollLeft);
      } else {
        me.currentOrientation.updateFromVerticalScroll(me.scrollTop);
      }
    }
  } //endregion


  doDestroy() {
    if (this._presets.owner === this) {
      this._presets.destroy();
    }

    super.doDestroy();
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineZoomable.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineZoomable.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'gantt';



/**
 * @module Scheduler/view/mixin/TimelineZoomable
 */

/**
 * Mixin providing "zooming" functionality.
 *
 * The zoom levels are stored as instances of {@link Scheduler.preset.ViewPreset ViewPreset}s, and are
 * cached centrally in the {@link Scheduler.preset.PresetManager PresetManager}.
 *
 * The default presets are loaded into the {@link Scheduler.view.mixin.TimelineViewPresets#config-presets}
 * store upon Scheduler instantiation. Preset selection is covered in the
 * {@link Scheduler.view.mixin.TimelineViewPresets TimelineViewPresets} mixin.
 *
 * To specify custom zoom levels please provide a set of view presets to the global PresetManager store **before** scheduler creation,
 * or provide a set of view presets to a specific scheduler only:
 *
 * ```javascript
 * const myScheduler = new Scheduler({
 *     presets : [
 *         {
 *             base : 'hourAndDay',
 *             id   : 'MyHourAndDay',
 *             // other preset configs....
 *         },
 *         {
 *             base : 'weekAndMonth',
 *             id   : 'MyWeekAndMonth',
 *             // other preset configs....
 *         }
 *     ],
 *     viewPreset : 'MyHourAndDay',
 *     // other scheduler configs....
 *     });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TimelineZoomable extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TimelineZoomable';
  }

  static get defaultConfig() {
    return {
      /**
       * If true, you can zoom in and out on the the time axis using CTRL-key + mouse wheel.
       * @config {Boolean}
       * @default
       * @category Zoom
       */
      zoomOnMouseWheel: true,

      /**
       * True to zoom to time span when double clicking a time axis cell.
       * @config {Boolean}
       * @default
       * @category Zoom
       */
      zoomOnTimeAxisDoubleClick: true,
      preventScrollZoom: null,

      /**
       * The minimum zoom level to which {@link #function-zoomOut} will work. Defaults to 0 (year ticks)
       * @config {Number}
       * @category Zoom
       * @default
       */
      minZoomLevel: 0,

      /**
       * The maximum zoom level to which {@link #function-zoomIn} will work. Defaults to the number of
       * {@link Scheduler.preset.ViewPreset ViewPresets} available, see {@link Scheduler/view/mixin/TimelineViewPresets#property-presets}
       * for information. Unless you have modified the collection of available presets, the max zoom level is milliseconds.
       * @config {Number}
       * @category Zoom
       * @default 23
       */
      maxZoomLevel: null,

      /**
       * Integer number indicating the size of timespan during zooming. When zooming, the timespan is adjusted to make the scrolling area `visibleZoomFactor` times
       * wider than the timeline area itself. Used in {@link #function-zoomToSpan} and {@link #function-zoomToLevel} functions.
       * @config {Number}
       * @default
       * @category Zoom
       */
      visibleZoomFactor: 5,

      /**
       * Whether the originally rendered timespan should be preserved while zooming. By default it is set to `false`,
       * meaning the timeline panel will adjust the currently rendered timespan to limit the amount of HTML content to render. When setting this option
       * to `true`, be careful not to allow to zoom a big timespan in seconds resolution for example. That will cause **a lot** of HTML content
       * to be rendered and affect performance. You can use {@link #config-minZoomLevel} and {@link #config-maxZoomLevel} config options for that.
       * @config {Boolean}
       * @default
       * @category Zoom
       */
      zoomKeepsOriginalTimespan: null
    };
  }

  construct(config) {
    const me = this;
    super.construct(config);

    if (me.zoomOnMouseWheel) {
      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.timeAxisSubGridElement,
        wheel: 'onWheel',
        // Throttle zooming with the wheel a bit to have greater control of it
        throttled: {
          buffer: 100,

          // Prevent events from slipping through the throttle, causing scroll
          alt(event) {
            if (event.ctrlKey) {
              event.preventDefault();
            }
          }

        },
        thisObj: me,
        capture: true,
        passive: false
      });
    }

    if (me.zoomOnTimeAxisDoubleClick) {
      me.on('timeaxisheaderdblclick', ({
        startDate,
        endDate
      }) => {
        me.zoomToSpan({
          startDate,
          endDate
        });
      });
    }
  }

  get maxZoomLevel() {
    return this._maxZoomLevel || this.presets.count - 1;
  }
  /**
   * Get/set the {@link #config-maxZoomLevel} value
   * @property {Number}
   * @category Zoom
   */


  set maxZoomLevel(level) {
    if (typeof level !== 'number') {
      level = this.presets.count - 1;
    }

    if (level < 0 || level >= this.presets.count) {
      throw new Error('Invalid range for `maxZoomLevel`');
    }

    this._maxZoomLevel = level;
  }

  get minZoomLevel() {
    return this._minZoomLevel;
  }
  /**
   * Sets the {@link #config-minZoomLevel} value
   * @property {Number}
   * @category Zoom
   */


  set minZoomLevel(level) {
    if (typeof level !== 'number') {
      level = 0;
    }

    if (level < 0 || level >= this.presets.count) {
      throw new Error('Invalid range for `minZoomLevel`');
    }

    this._minZoomLevel = level;
  }
  /**
   * Current zoom level, which is equal to the {@link Scheduler.preset.ViewPreset ViewPreset} index
   * in the provided array of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets zoom levels}.
   * @property {Number}
   * @category Zoom
   */


  get zoomLevel() {
    return this.presets.indexOf(this.viewPreset);
  } // noinspection JSAnnotator


  set zoomLevel(level) {
    this.zoomToLevel(level);
  }
  /*
   * @private
   * Returns number of milliseconds per pixel.
   * @param {Object} level Element from array of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets}.
   * @param {Boolean} ignoreActualWidth If true, then density will be calculated using default zoom level settings.
   * Otherwise density will be calculated for actual tick width.
   * @return {Number} Return number of milliseconds per pixel.
   */


  getMilliSecondsPerPixelForZoomLevel(preset, ignoreActualWidth) {
    const {
      bottomHeader
    } = preset,
          // Scheduler uses direction independent tickSize, but presets are allowed to define different sizes for
    // vertical and horizontal -> cant use preset.tickSize here
    width = this.isHorizontal ? preset.tickWidth : preset.tickHeight; // trying to convert the unit + increment to a number of milliseconds
    // this number is not fixed (month can be 28, 30 or 31 day), but at least this conversion
    // will be consistent (should be no DST changes at year 1)

    return Math.round((_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(new Date(1, 0, 1), bottomHeader.increment || 1, bottomHeader.unit) - new Date(1, 0, 1)) / ( // `actualWidth` is a column width after view adjustments applied to it (see `calculateTickWidth`)
    // we use it if available to return the precise index value from `getCurrentZoomLevelIndex`
    ignoreActualWidth ? width : preset.actualWidth || width));
  }
  /**
   * Zooms to passed view preset, saving center date. Method accepts config object as a first argument, which can be
   * reduced to primitive type (string,number) when no additional options required. e.g.:
   * ```
   * // zooming to preset
   * scheduler.zoomTo({ preset : 'hourAndDay' })
   * // shorthand
   * scheduler.zoomTo('hourAndDay')
   *
   * // zooming to level
   * scheduler.zoomTo({ level : 0 })
   * // shorthand
   * scheduler.zoomTo(0)
   * ```
   *
   * It is also possible to zoom to a time span by omitting `preset` and `level` configs, in which case scheduler sets
   * the time frame to a specified range and applies zoom level which allows to fit all columns to this range. The
   * given time span will be centered in the scheduling view (unless `centerDate` config provided). In the same time,
   * the start/end date of the whole time axis will be extended to allow scrolling for user.
   * ```
   * // zooming to time span
   * scheduler.zoomTo({ startDate : new Date(..), endDate : new Date(...) })
   *
   * ```
   *
   * @param {Object|String|Number} config Config object, preset name or zoom level index.
   * @param {String} config.preset Preset name to zoom to. Ignores level config in this case
   * @param {Number} config.level Zoom level to zoom to. Is ignored, if preset config is provided
   * @param {Date} config.startDate New time frame start. If provided along with end, view will be centered in this time
   * interval (unless `centerDate` is present)
   * @param {Date} config.endDate New time frame end
   * @param {Date} config.centerDate Date that should be kept in the center. Has priority over start and end params
   * @param {Number} config.width Lowest tick width. Might be increased automatically
   * @param {Number} [config.leftMargin] Amount of pixels to extend span start on (used, when zooming to span)
   * @param {Number} [config.rightMargin] Amount of pixels to extend span end on (used, when zooming to span)
   * @param {Number} [config.adjustStart] Amount of units to extend span start on (used, when zooming to span)
   * @param {Number} [config.adjustEnd] Amount of units to extend span end on (used, when zooming to span)
   * @category Zoom
   */


  zoomTo(config) {
    const me = this;

    if (typeof config === 'object') {
      if (config.preset) {
        me.zoomToLevel(config.preset, config);
      } else if (config.level != null) {
        me.zoomToLevel(config.level, config);
      } else {
        me.zoomToSpan(config);
      }
    } else {
      me.zoomToLevel(config);
    }
  }
  /**
   * Allows zooming to certain level of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets} array. Automatically limits zooming between {@link #config-maxZoomLevel}
   * and {@link #config-minZoomLevel}. Can also set time axis timespan to the supplied start and end dates.
   *
   * @param {Number} preset Level to zoom to.
   * @param {Object} [options] Object, containing options for this method
   * @param {Date} options.startDate New time frame start. If provided along with end, view will be centered in this time
   * interval, ignoring centerDate config.
   * @param {Date} options.endDate New time frame end.
   * @param {Date} options.centerDate Date that should be kept in center. Is ignored when start and end are provided.
   * @param {Number} options.width Lowest tick width. Might be increased automatically
   * @return {Number|null} level Current zoom level or null if it hasn't changed.
   * @category Zoom
   */


  zoomToLevel(preset, options = {}) {
    // Sanitize numeric zooming.
    if (typeof preset === 'number') {
      preset = Math.min(Math.max(preset, this.minZoomLevel), this.maxZoomLevel);
    }

    const me = this,
          tickSizeProp = me.isVertical ? 'tickHeight' : 'tickWidth',
          newPreset = me.normalizePreset(preset),
          configuredTickSize = newPreset[tickSizeProp],
          startDate = options.startDate ? new Date(options.startDate) : null,
          endDate = options.endDate ? new Date(options.endDate) : null;
    let span = startDate && endDate ? {
      startDate,
      endDate
    } : null;
    const centerDate = options.centerDate || (span ? new Date((startDate.getTime() + endDate.getTime()) / 2) : me.viewportCenterDateCached),
          scrollableViewportSize = me.isVertical ? me.scrollable.clientHeight : me.timeAxisSubGrid.width;

    if (scrollableViewportSize === 0) {
      return null;
    } // Always calculate an optimal date range for the new zoom level


    if (!span) {
      span = me.calculateOptimalDateRange(centerDate, scrollableViewportSize, newPreset);
    } // Temporarily override tick size while reconfiguring the TimeAxisViewModel


    if ('width' in options) {
      newPreset.setData(tickSizeProp, options.width);
    }

    me.isZooming = true; // Passed through to the viewPreset changing method

    newPreset.options = {
      startDate: span.startDate || me.startDate,
      endDate: span.endDate || me.endDate,
      centerDate
    };
    me.viewPreset = newPreset; // after switching the view preset the `width` config of the zoom level may change, because of adjustments
    // we will save the real value in the `actualWidth` property, so that `getCurrentZoomLevelIndex` method
    // will return the exact level index after zooming

    newPreset.actualWidth = me.timeAxisViewModel.tickSize;
    me.isZooming = false; // Restore the tick size because the default presets are shared.

    newPreset.setData(tickSizeProp, configuredTickSize);
    return me.zoomLevel;
  }
  /**
   * Changes the range of the scheduling chart to fit all the events in its event store.
   * @param {Object} [options] Options object for the zooming operation.
   * @param {Number} [options.leftMargin] Defines margin in pixel between the first event start date and first visible date
   * @param {Number} [options.rightMargin] Defines margin in pixel between the last event end date and last visible date
   */


  zoomToFit(options) {
    const eventStore = this.eventStore,
          span = eventStore.getTotalTimeSpan();
    options = Object.assign({
      leftMargin: 0,
      rightMargin: 0
    }, options, span); // Make sure we received a time span, event store might be empty

    if (options.startDate && options.endDate) {
      if (options.endDate > options.startDate) {
        this.zoomToSpan(options);
      } else {
        // If we only had a zero time span, just scroll it into view
        this.scrollToDate(options.startDate);
      }
    }
  }
  /**
   * Sets time frame to specified range and applies zoom level which allows to fit all columns to this range.
   *
   * The given time span will be centered in the scheduling view, in the same time, the start/end date of the whole time axis
   * will be extended in the same way as {@link #function-zoomToLevel} method does, to allow scrolling for user.
   *
   * @param {Object} config The time frame.
   * @param {Date} config.startDate The time frame start.
   * @param {Date} config.endDate The time frame end.
   * @param {Date} [config.centerDate] Date that should be kept in the center. Has priority over start and end params
   * @param {Number} [config.leftMargin] Amount of pixels to extend span start on
   * @param {Number} [config.rightMargin] Amount of pixels to extend span end on
   * @param {Number} [config.adjustStart] Amount of units to extend span start on
   * @param {Number} [config.adjustEnd] Amount of units to extend span end on
   *
   * @return {Number|null} level Current zoom level or null if it hasn't changed.
   * @category Zoom
   */


  zoomToSpan(config = {}) {
    if (config.leftMargin || config.rightMargin) {
      config.adjustStart = 0;
      config.adjustEnd = 0;
    }

    if (!config.leftMargin) config.leftMargin = 0;
    if (!config.rightMargin) config.rightMargin = 0;
    if (!config.startDate || !config.endDate) throw new Error('zoomToSpan: must provide startDate + endDate dates');
    const me = this,
          // this config enables old zoomToSpan behavior which we want to use for zoomToFit in Gantt
    needToAdjust = config.adjustStart >= 0 || config.adjustEnd >= 0;
    let {
      startDate,
      endDate
    } = config;

    if (needToAdjust) {
      startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, -config.adjustStart, me.timeAxis.mainUnit);
      endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(endDate, config.adjustEnd, me.timeAxis.mainUnit);
    }

    if (startDate <= endDate) {
      // get scheduling view width
      const {
        availableSpace
      } = me.timeAxisViewModel,
            presets = me.presets.allRecords,
            diffMS = endDate - startDate || 1; // if potential width of col is less than col width provided by zoom level
      //   - we'll zoom out panel until col width fit into width from zoom level
      // and if width of column is more than width from zoom level
      //   - we'll zoom in until col width fit won't fit into width from zoom level

      let currLevel = me.zoomLevel,
          inc,
          range; // if we zoomed out even more than the highest zoom level - limit it to the highest zoom level

      if (currLevel === -1) currLevel = 0;
      let msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(presets[currLevel], true),
          // increment to get next zoom level:
      // -1 means that given timespan won't fit the available width in the current zoom level, we need to zoom out,
      // so that more content will "fit" into 1 px
      //
      // +1 mean that given timespan will already fit into available width in the current zoom level, but,
      // perhaps if we'll zoom in a bit more, the fitting will be better
      candidateLevel = currLevel + (inc = diffMS / msPerPixel + config.leftMargin + config.rightMargin > availableSpace ? -1 : 1),
          zoomLevel,
          levelToZoom = null; // loop over zoom levels

      while (candidateLevel >= 0 && candidateLevel <= presets.length - 1) {
        // get zoom level
        zoomLevel = presets[candidateLevel];
        msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(zoomLevel, true);
        const spanWidth = diffMS / msPerPixel + config.leftMargin + config.rightMargin; // if zooming out

        if (inc === -1) {
          // if columns fit into available space, then all is fine, we've found appropriate zoom level
          if (spanWidth <= availableSpace) {
            levelToZoom = candidateLevel; // stop searching

            break;
          } // if zooming in

        } else {
          // if columns still fits into available space, we need to remember the candidate zoom level as a potential
          // resulting zoom level, the indication that we've found correct zoom level will be that timespan won't fit
          // into available view
          if (spanWidth <= availableSpace) {
            // if it's not currently active level
            if (currLevel !== candidateLevel - inc) {
              // remember this level as applicable
              levelToZoom = candidateLevel;
            }
          } else {
            // Sanity check to find the following case:
            // If we're already zoomed in at the appropriate level, but the current zoomLevel is "too small" to fit and had to be expanded,
            // there is an edge case where we should actually just stop and use the currently selected zoomLevel
            break;
          }
        }

        candidateLevel += inc;
      } // If we didn't find a large/small enough zoom level, use the lowest/highest level


      levelToZoom = levelToZoom != null ? levelToZoom : candidateLevel - inc; // presets is the array of all ViewPresets this Scheduler is using

      zoomLevel = presets[levelToZoom];
      const unitToZoom = zoomLevel.bottomHeader.unit;

      if (config.leftMargin || config.rightMargin) {
        // time axis doesn't yet know about new view preset (zoom level) so it cannot round/ceil date correctly
        startDate = new Date(startDate.getTime() - msPerPixel * config.leftMargin);
        endDate = new Date(endDate.getTime() + msPerPixel * config.rightMargin);
      }

      const tickCount = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getDurationInUnit(startDate, endDate, unitToZoom, true) / zoomLevel.bottomHeader.increment;

      if (tickCount === 0) {
        return null;
      }

      const customWidth = Math.floor(availableSpace / tickCount),
            centerDate = config.centerDate || new Date((startDate.getTime() + endDate.getTime()) / 2);

      if (needToAdjust) {
        range = {
          startDate,
          endDate
        };
      } else {
        range = me.calculateOptimalDateRange(centerDate, availableSpace, zoomLevel);
      }

      return me.zoomToLevel(levelToZoom, Object.assign(range, {
        width: customWidth,
        centerDate
      }));
    }

    return null;
  }
  /**
   * Zooms in the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom in by this value.
   * Otherwise a value of `1` will be used.
   *
   * @param {Number} levels (optional) amount of levels to zoom in
   *
   * @return {Number|null} currentLevel New zoom level of the panel or null if level hasn't changed.
   * @category Zoom
   */


  zoomIn(levels = 1) {
    const currentZoomLevelIndex = this.zoomLevel;
    if (currentZoomLevelIndex >= this.maxZoomLevel) return null;
    return this.zoomToLevel(currentZoomLevelIndex + levels);
  }
  /**
   * Zooms out the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom out by this value.
   * Otherwise a value of `1` will be used.
   *
   * @param {Number} levels (optional) amount of levels to zoom out
   *
   * @return {Number|null} currentLevel New zoom level of the panel or null if level hasn't changed.
   * @category Zoom
   */


  zoomOut(levels = 1) {
    const currentZoomLevelIndex = this.zoomLevel;
    if (currentZoomLevelIndex <= this.minZoomLevel) return null;
    return this.zoomToLevel(currentZoomLevelIndex - levels);
  }
  /**
   * Zooms in the timeline to the {@link #config-maxZoomLevel} according to the array of zoom levels.
   *
   * @return {Number|null} currentLevel New zoom level of the panel or null if level hasn't changed.
   * @category Zoom
   */


  zoomInFull() {
    return this.zoomToLevel(this.maxZoomLevel);
  }
  /**
   * Zooms out the timeline to the {@link #config-minZoomLevel} according to the array of zoom levels.
   *
   * @return {Number|null} currentLevel New zoom level of the panel or null if level hasn't changed.
   * @category Zoom
   */


  zoomOutFull() {
    return this.zoomToLevel(this.minZoomLevel);
  }
  /*
   * Adjusts the timespan of the panel to the new zoom level. Used for performance reasons,
   * as rendering too many columns takes noticeable amount of time so their number is limited.
   * @category Zoom
   * @private
   */


  calculateOptimalDateRange(centerDate, viewportSize, viewPreset, userProvidedSpan) {
    // this line allows us to always use the `calculateOptimalDateRange` method when calculating date range for zooming
    // (even in case when user has provided own interval)
    // other methods may override/hook into `calculateOptimalDateRange` to insert own processing
    // (infinite scrolling feature does)
    if (userProvidedSpan) return userProvidedSpan;
    const me = this,
          {
      timeAxis
    } = me,
          {
      bottomHeader
    } = viewPreset,
          tickWidth = me.isHorizontal ? viewPreset.tickWidth : viewPreset.tickHeight;

    if (me.zoomKeepsOriginalTimespan) {
      return {
        startDate: timeAxis.startDate,
        endDate: timeAxis.endDate
      };
    }

    const unit = bottomHeader.unit,
          difference = Math.ceil(viewportSize / tickWidth * bottomHeader.increment * me.visibleZoomFactor / 2),
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(centerDate, -difference, unit),
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(centerDate, difference, unit);

    if (me.infiniteScroll) {
      return me.timeAxisViewModel.calculateInfiniteScrollingDateRange(centerDate, true);
    } else {
      return {
        startDate: timeAxis.floorDate(startDate, false, unit, bottomHeader.increment),
        endDate: timeAxis.ceilDate(endDate, false, unit, bottomHeader.increment)
      };
    }
  }

  onWheel(event) {
    const me = this;

    if (event.ctrlKey) {
      event.preventDefault();

      if (!me.preventScrollZoom) {
        if (event.deltaY > 0) {
          me.zoomOut();
        } else if (event.deltaY < 0) {
          me.zoomIn();
        }

        me.preventScrollZoom = true;
        me.setTimeout(() => me.preventScrollZoom = false, 30);
      }
    }
  }
  /**
   * Changes the time axis timespan to the supplied start and end dates.
   * @param {Date} startDate The new start date
   * @param {Date} endDate The new end date. If omitted or equal to startDate, the {@link Scheduler.preset.ViewPreset#field-defaultSpan} property of the current view preset will be used to calculate the new end date.
   */


  setTimeSpan(startDate, endDate) {
    this.timeAxis.setTimeSpan(startDate, endDate);
  }
  /**
   * Moves the time axis by the passed amount and unit.
   *
   * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shift} for more information.
   *
   * @param {Number} amount The number of units to jump
   * @param {String} [unit] The unit (Day, Week etc)
   */


  shift(amount, unit) {
    this.timeAxis.shift(amount, unit);
  }
  /**
   * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
   * config of the current view preset.
   *
   * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftNext} for more information.
   *
   * @param {Number} [amount] The number of units to jump forward
   */


  shiftNext(amount) {
    this.timeAxis.shiftNext(amount);
  }
  /**
   * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
   *
   * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftPrevious} for more information.
   *
   * @param {Number} [amount] The number of units to jump backward
   */


  shiftPrevious(amount) {
    this.timeAxis.shiftPrevious(amount);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/view/model/TimeAxisViewModel.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/view/model/TimeAxisViewModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisViewModel; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");
var productName = 'gantt';





/**
 * @module Scheduler/view/model/TimeAxisViewModel
 */

/**
 * This class is an internal view model class, describing the visual representation of a {@link Scheduler.data.TimeAxis}.
 * The config for the header rows is described in the {@link Scheduler.preset.ViewPreset#field-headers headers}.
 * To calculate the size of each cell in the time axis, this class requires:
 *
 * - availableSpace  - The total width or height available for the rendering
 * - tickSize       - The fixed width or height of each cell in the lowest header row. This value is normally read from the
 * {@link Scheduler.preset.ViewPreset viewPreset} but this can also be updated programmatically using the {@link #property-tickSize} setter
 *
 * Normally you should not interact with this class directly.
 *
 * @extends Core/mixin/Events
 */

class TimeAxisViewModel extends Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])() {
  //region Default config
  // TODO: replace _availableSpace etc with availableSpace in config and make setters work during config phase
  static get defaultConfig() {
    return {
      /**
       * The time axis providing the underlying data to be visualized
       * @config {Scheduler.data.TimeAxis}
       * @internal
       */
      timeAxis: null,

      /**
       * The available width/height, this is normally not known by the consuming UI component using this model
       * class until it has been fully rendered. The consumer of this model should set
       * {@link #property-availableSpace} when its width has changed.
       * @config {Number}
       * @internal
       */
      availableSpace: null,

      /**
       * The "tick width" for horizontal mode or "tick height" for vertical mode, to use for the cells in the
       * bottom most header row.
       * This value is normally read from the {@link Scheduler.preset.ViewPreset viewPreset}
       * @config {Number}
       * @default
       * @internal
       */
      tickSize: 100,

      /**
       * true if there is a requirement to be able to snap events to a certain view resolution.
       * This has implications of the {@link #config-tickSize} that can be used, since all widths must be in even pixels.
       * @config {Boolean}
       * @default
       * @internal
       */
      snap: false,

      /**
       * true if cells in the bottom-most row should be fitted to the {@link #property-availableSpace available space}.
       * @config {Boolean}
       * @default
       * @internal
       */
      forceFit: false,
      headers: null,
      mode: 'horizontal',
      // or 'vertical'
      //used for Exporting. Make sure the tick columns are not recalculated when resizing.
      suppressFit: false,
      // cache of the config currently used.
      columnConfig: [],
      // the view preset name to apply initially
      viewPreset: null,
      // The default header level to draw column lines for
      columnLinesFor: null,
      originalTickSize: null,
      headersDatesCache: []
    };
  } //endregion
  //region Init & destroy


  construct(config) {
    const me = this; // getSingleUnitInPixels results are memoized because of frequent calls during rendering.

    me.unitToPixelsCache = {};
    super.construct(config);
    const viewPreset = me.timeAxis.viewPreset || me.viewPreset;

    if (viewPreset) {
      if (viewPreset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
        me.consumeViewPreset(viewPreset);
      } else {
        const preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPreset(viewPreset);
        preset && me.consumeViewPreset(preset);
      }
    } // When time axis is changed, reconfigure the model


    me.timeAxis.on('reconfigure', me.onTimeAxisReconfigure, me);
    me.configured = true;
  }

  doDestroy() {
    this.timeAxis.un('reconfigure', this.onTimeAxisReconfigure, this);
    super.doDestroy();
  }
  /**
   * Used to calculate the range to extend the TimeAxis to during infinite scroll.
   * @param {Date} date 
   * @param {Boolean} centered 
   * @param {Scheduler.preset.ViewPreset} [preset] Optional, the preset for which to calculate the range.
   * defaults to the currently active ViewPreset
   * @returns {Object} `{ startDate, endDate }`
   * @internal
   */


  calculateInfiniteScrollingDateRange(date, centered, preset = this.viewPreset) {
    const {
      timeAxis,
      availableSpace
    } = this,
          {
      bufferCoef
    } = this.owner,
          {
      leafUnit,
      leafIncrement,
      tickSize
    } = preset; // if provided date is the central point on the timespan

    if (centered) {
      const halfSpan = Math.ceil((availableSpace * bufferCoef + availableSpace / 2) / tickSize);
      return {
        startDate: timeAxis.floorDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, -halfSpan * leafIncrement, leafUnit), false, leafUnit, leafIncrement),
        endDate: timeAxis.ceilDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, halfSpan * leafIncrement, leafUnit), false, leafUnit, leafIncrement)
      };
    } // if provided date is the left coordinate of the visible timespan area
    else {
      const bufferedTicks = Math.ceil(availableSpace * bufferCoef / tickSize);
      return {
        startDate: timeAxis.floorDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, -bufferedTicks * leafIncrement, leafUnit), false, leafUnit, leafIncrement),
        endDate: timeAxis.ceilDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, Math.ceil((availableSpace / tickSize + bufferedTicks) * leafIncrement), leafUnit), false, leafUnit, leafIncrement)
      };
    }
  }
  /**
   * Returns an array representing the headers of the current timeAxis. Each element is an array representing the cells for that level in the header.
   * @return {Object[]} An array of headers, each element being an array representing each cell (with start date and end date) in the timeline representation.
   * @internal
   */


  get columnConfig() {
    return this._columnConfig;
  }

  set columnConfig(config) {
    this._columnConfig = config;
  }

  get headers() {
    return this._headers;
  }

  set headers(headers) {
    if (headers && headers.length && headers[headers.length - 1].cellGenerator) {
      throw new Error('`cellGenerator` cannot be used for the bottom level of your headers. Use TimeAxis#generateTicks() instead.');
    }

    this._headers = headers;
  }

  get isTimeAxisViewModel() {
    return true;
  } //endregion
  //region Events

  /**
   * Fires after the model has been updated.
   * @event update
   * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
   */

  /**
   * Fires after the model has been reconfigured.
   * @event reconfigure
   * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
   */
  //endregion
  //region Mode

  /**
   * Using horizontal mode?
   * @returns {Boolean}
   * @readonly
   * @internal
   */


  get isHorizontal() {
    return this.mode !== 'vertical';
  }
  /**
   * Using vertical mode?
   * @returns {Boolean}
   * @readonly
   * @internal
   */


  get isVertical() {
    return this.mode === 'vertical';
  }
  /**
   * Gets/sets the forceFit value for the model. Setting it will cause it to update its contents and fire the
   * {@link #event-update} event.
   * @property {Boolean}
   * @internal
   */


  set forceFit(value) {
    if (value !== this._forceFit) {
      this._forceFit = value;
      this.update();
    }
  } //endregion
  //region Reconfigure & update


  reconfigure(config) {
    // clear the cached headers
    this.headers = null; // Ensure correct ordering

    this.setConfig(config);
    this.trigger('reconfigure');
  }

  onTimeAxisReconfigure({
    source: timeAxis,
    suppressRefresh
  }) {
    if (this.viewPreset !== timeAxis.viewPreset) {
      this.consumeViewPreset(timeAxis.viewPreset);
    }

    if (!suppressRefresh) {
      this.update();
    }
  }
  /**
   * Updates the view model current timeAxis configuration and available space.
   * @param {Number} [availableSpace] The available space for the rendering of the axis (used in forceFit mode)
   * @param {Boolean} [silent] Pass `true` to suppress the firing of the `update` event.
   * @param {Boolean} [forceUpdate] Pass `true` to fire the `update` event even if the size has not changed.
   * @internal
   */


  update(availableSpace, silent = false, forceUpdate = false) {
    const me = this,
          {
      timeAxis,
      headers
    } = me; // We're in configuration, or no change, quit

    if (me.isConfiguring || me._availableSpace === availableSpace) {
      if (forceUpdate) {
        me.trigger('update');
      }

      return;
    }

    me._availableSpace = Math.max(availableSpace || me.availableSpace || 0, 0);

    if (typeof me.availableSpace !== 'number') {
      throw new Error('Invalid available space provided to TimeAxisModel');
    }

    me.columnConfig = []; // The "column width" is considered to be the width of each tick in the lowest header row and this width
    // has to be same for all cells in the lowest row.

    const tickSize = me._tickSize = me.calculateTickSize(me.originalTickSize);

    if (typeof tickSize !== 'number' || tickSize <= 0) {
      throw new Error('Invalid timeAxis tick size');
    } // getSingleUnitInPixels results are memoized because of frequent calls during rendering.


    me.unitToPixelsCache = {}; // totalSize is cached because of frequent calls which calculate it.

    me._totalSize = null; // Generate the underlying date ranges for each header row, which will provide input to the cell rendering

    for (let pos = 0, {
      length
    } = headers; pos < length; pos++) {
      const header = headers[pos];

      if (header.cellGenerator) {
        const headerCells = header.cellGenerator.call(me, timeAxis.startDate, timeAxis.endDate);
        me.columnConfig[pos] = me.createHeaderRow(pos, header, headerCells);
      } else {
        me.columnConfig[pos] = me.createHeaderRow(pos, header);
      }
    }

    if (!silent) {
      me.trigger('update');
    }
  } //endregion
  //region Date / position mapping

  /**
   * Returns the distance in pixels for a timespan with the given start and end date.
   * @param {Date} start start date
   * @param {Date} end end date
   * @return {Number} The length of the time span
   * @category Date mapping
   */


  getDistanceBetweenDates(start, end) {
    return this.getPositionFromDate(end) - this.getPositionFromDate(start);
  }
  /**
   * Returns the distance in pixels for a time span
   * @param {Number} durationMS Time span duration in ms
   * @return {Number} The length of the time span
   * @category Date mapping
   */


  getDistanceForDuration(durationMs) {
    return this.getSingleUnitInPixels('millisecond') * durationMs;
  }
  /**
   * Gets the position of a date on the projected time axis or -1 if the date is not in the timeAxis.
   * @param {Date} date the date to query for.
   * @returns {Number} the coordinate representing the date
   * @category Date mapping
   */


  getPositionFromDate(date, options = {}) {
    const tick = this.getScaledTick(date, options);

    if (tick === -1) {
      return -1;
    }

    return this.tickSize * (tick - this.timeAxis.visibleTickStart);
  } // Translates a tick along the time axis to facilitate scaling events when excluding certain days or hours


  getScaledTick(date, {
    respectExclusion,
    snapToNextIncluded,
    isEnd,
    min,
    max
  }) {
    const {
      timeAxis
    } = this,
          {
      include,
      unit
    } = timeAxis;
    let tick = timeAxis.getTickFromDate(date);

    if (tick !== -1 && respectExclusion && include) {
      let tickChanged = false; // Stretch if we are using a larger unit than 'hour', except if it is 'day'. If so, it is already handled
      // by a cheaper reconfiguration of the ticks in `generateTicks`

      if (include.hour && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
        const {
          from,
          to,
          lengthFactor,
          center
        } = include.hour,
              // Original hours
        originalHours = date.getHours(),
              // Crop to included hours
        croppedHours = Math.min(Math.max(originalHours, from), to); // If we are not asked to snap (when other part of span is not included) any cropped away hour
        // should be considered excluded

        if (!snapToNextIncluded && croppedHours !== originalHours) {
          return -1;
        }

        const // Should scale hour and smaller units (seconds will hardly affect visible result...)
        fractionalHours = croppedHours + date.getMinutes() / 60,
              // Number of hours from the center    |xxxx|123c----|xxx|
        hoursFromCenter = center - fractionalHours,
              // Step from center to stretch event  |x|112233c----|xxx|
        newHours = center - hoursFromCenter * lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

        date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, newHours - originalHours, 'h');
        tickChanged = true;
      }

      if (include.day && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].compareUnits(unit, 'day') > 0) {
        const {
          from,
          to,
          lengthFactor,
          center
        } = include.day; //region Crop

        let checkDay = date.getDay(); // End date is exclusive, check the day before if at 00:00

        if (isEnd && date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0) {
          if (--checkDay < 0) {
            checkDay = 6;
          }
        }

        let addDays = 0;

        if (checkDay < from || checkDay >= to) {
          // If end date is in view but start date is excluded, snap to next included day
          if (snapToNextIncluded) {
            // Step back to "to-1" (not inclusive) for end date
            if (isEnd) {
              addDays = (to - checkDay - 8) % 7;
            } // Step forward to "from" for start date
            else {
              addDays = (from - checkDay + 7) % 7;
            }

            date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, addDays, 'd');
            date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].startOf(date, 'd', false); // Keep end after start and vice versa

            if (max && date.getTime() >= max || min && date.getTime() <= min) {
              return -1;
            }
          } else {
            // day excluded at not snapping to next
            return -1;
          }
        } //endregion


        const {
          weekStartDay
        } = timeAxis,
              // Center to stretch around, for some reason pre-calculated cannot be used for sundays :)
        fixedCenter = date.getDay() === 0 ? 0 : center,
              // Should scale day and smaller units (minutes will hardly affect visible result...)
        fractionalDay = date.getDay() + date.getHours() / 24,
              //+ dateClone.getMinutes() / (24 * 1440),
        // Number of days from the calculated center
        daysFromCenter = fixedCenter - fractionalDay,
              // Step from center to stretch event
        newDay = fixedCenter - daysFromCenter * lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

        date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(date, newDay - fractionalDay + weekStartDay, 'd');
        tickChanged = true;
      } // Now the date might start somewhere else (fraction of ticks)


      if (tickChanged) {
        // When stretching date might end up outside of time axis, making it invalid to use. Clip it to time axis
        // to circumvent this
        date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].constrain(date, timeAxis.startDate, timeAxis.endDate); // Get a new tick based on the "scaled" date

        tick = timeAxis.getTickFromDate(date);
      }
    }

    return tick;
  }
  /**
   * Gets the date for a position on the time axis
   * @param {Number} position The page X or Y coordinate
   * @param {String} [roundingMethod] The rounding method to use
   * @param {Boolean} [allowOutOfRange=false] By default, this returns `null` if the position is outside
   * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
   * @returns {Date} the Date corresponding to the xy coordinate
   * @category Date mapping
   */


  getDateFromPosition(position, roundingMethod, allowOutOfRange = false) {
    const me = this,
          {
      timeAxis
    } = me,
          tick = me.getScaledPosition(position) / me.tickSize + timeAxis.visibleTickStart;

    if (tick < 0 || tick > timeAxis.count) {
      if (allowOutOfRange) {
        let result; // Subtract the correct number of tick units from the start date

        if (tick < 0) {
          result = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(timeAxis.startDate, tick, timeAxis.unit);
        } else {
          // Add the correct number of tick units to the end date
          result = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(timeAxis.endDate, tick - timeAxis.count, timeAxis.unit);
        } // Honour the rounding requested


        if (roundingMethod) {
          result = timeAxis[roundingMethod + 'Date'](result);
        }

        return result;
      }

      return null;
    }

    return timeAxis.getDateFromTick(tick, roundingMethod);
  } // Translates a position along the time axis to facilitate scaling events when excluding certain days or hours


  getScaledPosition(position) {
    const {
      include,
      unit,
      weekStartDay
    } = this.timeAxis; // Calculations are

    if (include) {
      const dayWidth = this.getSingleUnitInPixels('day'); // Have to calculate day before hour to get end result correct

      if (include.day && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].compareUnits(unit, 'day') > 0) {
        const {
          from,
          lengthFactor
        } = include.day,
              // Scaling happens within a week, determine position within it
        positionInWeek = position % (dayWidth * 7),
              // Store were the week starts to be able to re-add it after scale
        weekStartPosition = position - positionInWeek; // Scale position using calculated length per day factor, adding the width of excluded days

        position = positionInWeek / lengthFactor + (from - weekStartDay) * dayWidth + weekStartPosition;
      } // Hours are not taken into account when viewing days, since the day ticks are reconfigured in
      // `generateTicks` instead


      if (include.hour && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
        const {
          from,
          lengthFactorExcl
        } = include.hour,
              hourWidth = this.getSingleUnitInPixels('hour'),
              // Scaling happens within a day, determine position within it
        positionInDay = position % dayWidth,
              // Store were the day starts to be able to re-add it after scale
        dayStartPosition = position - positionInDay; // Scale position using calculated length per day factor, adding the width of excluded hours

        position = positionInDay / lengthFactorExcl + from * hourWidth + dayStartPosition;
      }
    }

    return position;
  }
  /**
   * Returns the amount of pixels for a single unit
   * @internal
   * @return {Number} The unit in pixel
   */


  getSingleUnitInPixels(unit) {
    const me = this;
    return me.unitToPixelsCache[unit] || (me.unitToPixelsCache[unit] = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getUnitToBaseUnitRatio(me.timeAxis.unit, unit, true) * me.tickSize / me.timeAxis.increment);
  }
  /**
   * [Experimental] Returns the pixel increment for the current view resolution.
   * @internal
   * @return {Number} The increment
   */


  get snapPixelAmount() {
    if (this.snap) {
      const {
        resolution
      } = this.timeAxis;
      return (resolution.increment || 1) * this.getSingleUnitInPixels(resolution.unit);
    } else {
      return 1;
    }
  } //endregion
  //region Sizes

  /**
   * Get/set the current time column size (the width or height of a cell in the bottom-most time axis header row,
   * depending on mode)
   * @internal
   * @property {Number}
   */


  get tickSize() {
    return this._tickSize;
  }

  set tickSize(size) {
    this.setTickSize(size, false);
  }

  setTickSize(size, suppressEvent) {
    this._tickSize = this.originalTickSize = size;
    this.update(undefined, suppressEvent);
  }

  get timeResolution() {
    return this.timeAxis.resolution;
  } // Calculates the time column width/height based on the value defined viewPreset "tickWidth/tickHeight". It also
  // checks for the forceFit view option and the snap, both of which impose constraints on the time column width
  // configuration.


  calculateTickSize(proposedSize) {
    const me = this,
          {
      forceFit,
      timeAxis,
      suppressFit
    } = me,
          timelineUnit = timeAxis.unit;
    let size = 0,
        ratio = 1; //Number.MAX_VALUE;

    if (me.snap) {
      const resolution = timeAxis.resolution;
      ratio = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getUnitToBaseUnitRatio(timelineUnit, resolution.unit) * resolution.increment;
    }

    if (!suppressFit) {
      const fittingSize = me.availableSpace / timeAxis.visibleTickTimeSpan;
      size = forceFit || proposedSize < fittingSize ? fittingSize : proposedSize;

      if (ratio > 0 && (!forceFit || ratio < 1)) {
        size = Math.max(1, ratio * size) / ratio;
      }
    } else {
      size = proposedSize;
    }

    return size;
  }
  /**
   * Returns the total width/height of the time axis representation, depending on mode.
   * @return {Number} The width or height
   * @internal
   * @readonly
   */


  get totalSize() {
    return this._totalSize || (this._totalSize = Math.round(this.tickSize * this.timeAxis.visibleTickTimeSpan));
  }
  /**
   * Get/set the available space for the time axis representation. If size changes it will cause it to update its
   * contents and fire the {@link #event-update} event.
   * @internal
   * @property {Number}
   */


  get availableSpace() {
    return this._availableSpace;
  }

  set availableSpace(space) {
    const me = this; // We should only need to repaint fully if the tick width has changed (which will happen if forceFit is set, or if the full size of the time axis doesn't
    // occupy the available space - and gets stretched

    me._availableSpace = Math.max(0, space);

    if (me._availableSpace > 0) {
      const newTickSize = me.calculateTickSize(me.originalTickSize);

      if (newTickSize > 0 && newTickSize !== me.tickSize) {
        me.update();
      }
    }
  } //endregion
  //region Fitting & snapping

  /**
   * Returns start dates for ticks at the specified level in format { date, isMajor }.
   * @param {Number} level Level in headers array, `0` meaning the topmost...
   * @param {Boolean} useLowestHeader Use lowest level
   * @param getEnd
   * @returns {Array}
   * @internal
   */


  getDates(level = this.columnLinesFor, useLowestHeader = false, getEnd = false) {
    const me = this,
          ticks = [],
          linesForLevel = useLowestHeader ? me.lowestHeader : level,
          majorLevel = me.majorHeaderLevel,
          levelUnit = me.headers && me.headers[level].unit,
          majorUnit = majorLevel != null && me.headers && me.headers[majorLevel].unit,
          validMajor = majorLevel != null && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].doesUnitsAlign(majorUnit, levelUnit),
          hasGenerator = !!(me.headers && me.headers[linesForLevel].cellGenerator);

    if (hasGenerator) {
      const cells = me.columnConfig[linesForLevel];

      for (let i = 1, l = cells.length; i < l; i++) {
        ticks.push({
          date: cells[i].startDate
        });
      }
    } else {
      me.forEachInterval(linesForLevel, (start, end) => {
        ticks.push({
          date: getEnd ? end : start,
          // do not want to consider tick to be major tick, hence the check for majorHeaderLevel
          isMajor: majorLevel !== level && validMajor && me.isMajorTick(getEnd ? end : start)
        });
      });
    }

    return ticks;
  }

  get forceFit() {
    return this._forceFit;
  }
  /**
   * This function fits the time columns into the available space in the time axis column.
   * @param {Boolean} suppressEvent `true` to skip firing the 'update' event.
   * @internal
   */


  fitToAvailableSpace(suppressEvent) {
    const proposedSize = Math.floor(this.availableSpace / this.timeAxis.visibleTickTimeSpan);
    this.setTickSize(proposedSize, suppressEvent);
  }

  get snap() {
    return this._snap;
  }
  /**
   * Gets/sets the snap value for the model. Setting it will cause it to update its contents and fire the
   * {@link #event-update} event.
   * @property {Boolean}
   * @internal
   */


  set snap(value) {
    if (value !== this._snap) {
      this._snap = value;

      if (this.configured) {
        this.update();
      }
    }
  } //endregion
  //region Headers
  // private


  createHeaderRow(position, headerRowConfig, headerCells) {
    const me = this,
          cells = [],
          align = headerRowConfig.align,
          today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(new Date()),
          headerCellCls = headerRowConfig.headerCellCls || '',
          {
      timeAxis
    } = me,
          tickLevel = me.headers.length - 1,
          createCellContext = (start, end, i, isLast, data) => {
      let value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(start, headerRowConfig.dateFormat);
      const // So that we can use shortcut tickSize as the tickLevel cell width.
      // We can do this if the TimeAxis is aligned to start and end on tick boundaries
      // or if it's not the first or last tick.
      // getDistanceBetweenDates is an expensive operation.
      isInteriorTick = i > 0 && !isLast,
            cellData = {
        align,
        start,
        end,
        value: data ? data.header : value,
        headerCellCls,
        width: tickLevel === position && me.owner && (timeAxis.fullTicks || isInteriorTick) ? me.owner.tickSize : me.getDistanceBetweenDates(start, end),
        index: i
      };

      if (cellData.width === 0) {
        return;
      } // Vertical mode uses absolute positioning for header cells


      cellData.coord = size - 1;
      size += cellData.width;
      me.headersDatesCache[position][start.getTime()] = 1;

      if (headerRowConfig.renderer) {
        value = headerRowConfig.renderer.call(headerRowConfig.thisObj || me, start, end, cellData, i);
        cellData.value = value == null ? '' : value;
      } // To be able to style individual day cells, weekends or other important days


      if (headerRowConfig.unit === 'day' && (!headerRowConfig.increment || headerRowConfig.increment === 1)) {
        cellData.headerCellCls += ' b-sch-dayheadercell-' + start.getDay();

        if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(start, true) - today === 0) {
          cellData.headerCellCls += ' b-sch-dayheadercell-today';
        }
      }

      cells.push(cellData);
    };

    let size = 0;
    me.headersDatesCache[position] = {};

    if (headerCells) {
      headerCells.forEach((cellData, i) => createCellContext(cellData.start, cellData.end, i, i === headerCells.length - 1, cellData));
    } else {
      me.forEachInterval(position, createCellContext);
    }

    return cells;
  }

  get mainHeader() {
    return 'mainHeaderLevel' in this ? this.headers[this.mainHeaderLevel] : this.bottomHeader;
  }

  get bottomHeader() {
    return this.headers[this.headers.length - 1];
  }

  get lowestHeader() {
    return this.headers.length - 1;
  }
  /**
   * This method is meant to return the level of the header which 2nd lowest.
   * It is used for {@link #function-isMajorTick} method
   * @return {String}
   * @private
   */


  get majorHeaderLevel() {
    const {
      headers
    } = this;

    if (headers) {
      return Math.max(headers.length - 2, 0);
    }

    return null;
  } //endregion
  //region Ticks

  /**
   * For vertical view (and column lines plugin) we sometimes want to know if current tick starts along with the
   * upper header level.
   * @param {Date} date
   * @return {Boolean}
   * @private
   */


  isMajorTick(date) {
    const nextLevel = this.majorHeaderLevel; // if forceFit is used headersDatesCache won´t have been generated yet on the first call here,
    // since no size is set yet

    return nextLevel != null && this.headersDatesCache[nextLevel] && this.headersDatesCache[nextLevel][date.getTime()] || false;
  }
  /**
   * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
   * Return false to break the iteration.
   * @param {Number} position The index of the header in the headers array.
   * @param {Function} iteratorFn The function to call, will be called with start date, end date and "tick index"
   * @param {Object} [thisObj] `this` reference for the function
   * @internal
   */


  forEachInterval(position, iteratorFn, thisObj = this) {
    const {
      headers,
      timeAxis
    } = this;

    if (headers) {
      // This is the lowest header row, which should be fed the data in the tickStore (or a row above using same unit)
      if (position === headers.length - 1) {
        timeAxis.forEach((r, index) => iteratorFn.call(thisObj, r.startDate, r.endDate, index, index === timeAxis.count - 1));
      } // All other rows
      else {
        const header = headers[position];
        timeAxis.forEachAuxInterval(header.unit, header.increment, iteratorFn, thisObj);
      }
    }
  }
  /**
   * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
   * Return false to break the iteration.
   * @internal
   * @param {Function} iteratorFn The function to call
   * @param {Object} [thisObj] `this` reference for the function
   */


  forEachMainInterval(iteratorFn, thisObj) {
    this.forEachInterval(this.mainHeaderLevel, iteratorFn, thisObj);
  } //endregion
  //region ViewPreset


  consumeViewPreset(preset) {
    const me = this; // clear the cached headers

    me.headers = null;

    me._thisIsAUsedExpression(me.tickSize); // Since we are bypassing the tickSize setter below, ensure that
    // the config initial setter has been removed by referencing the property.
    // We only do this to avoid multiple updates from this. TODO: Fix this issue,
    // and do not bypass setters.


    me.viewPreset = preset;
    Object.assign(me, {
      headers: preset.headers,
      columnLinesFor: preset.columnLinesFor,
      mainHeaderLevel: preset.mainHeaderLevel,
      _tickSize: me.isHorizontal ? preset.tickWidth : preset.tickHeight
    });
    me.originalTickSize = me.tickSize;
  } //endregion


}
TimeAxisViewModel._$name = 'TimeAxisViewModel';

/***/ }),

/***/ "./lib/Scheduler/view/orientation/BaseRendering.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/view/orientation/BaseRendering.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/* harmony default export */ __webpack_exports__["default"] = (Target => class extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  getElementFromAssignmentRecord(assignmentRecord, returnWrapper = false) {
    if (this.scheduler.isPainted && assignmentRecord) {
      var _this$scheduler$foreg, _wrapper$syncIdMap;

      const wrapper = (_this$scheduler$foreg = this.scheduler.foregroundCanvas.syncIdMap) === null || _this$scheduler$foreg === void 0 ? void 0 : _this$scheduler$foreg[assignmentRecord.id]; // Wrapper wont have syncIdMap when saving dragcreated event from editor

      return returnWrapper ? wrapper : wrapper === null || wrapper === void 0 ? void 0 : (_wrapper$syncIdMap = wrapper.syncIdMap) === null || _wrapper$syncIdMap === void 0 ? void 0 : _wrapper$syncIdMap.event;
    }

    return null;
  }

  getElementFromEventRecord(eventRecord, resourceRecord = (() => {
    var _eventRecord$resource;

    return (_eventRecord$resource = eventRecord.resources) === null || _eventRecord$resource === void 0 ? void 0 : _eventRecord$resource[0];
  })(), returnWrapper = false) {
    const assignmentRecord = this.assignmentStore.getAssignmentForEventAndResource(eventRecord, resourceRecord);
    return this.getElementFromAssignmentRecord(assignmentRecord, returnWrapper);
  }

  getElementsFromEventRecord(eventRecord, resourceRecord, returnWrapper = false) {
    const me = this; // Single event instance, as array

    if (resourceRecord) {
      return [me.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper)];
    } // All instances
    else {
      return eventRecord.resources.reduce((result, resourceRecord) => {
        const el = me.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper);
        el && result.push(el);
        return result;
      }, []);
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/view/orientation/HorizontalRendering.js":
/*!***************************************************************!*\
  !*** ./lib/Scheduler/view/orientation/HorizontalRendering.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalRendering; });
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony import */ var _BaseRendering_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./BaseRendering.js */ "./lib/Scheduler/view/orientation/BaseRendering.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';
/* eslint-disable no-unused-expressions */









/**
 * @module Scheduler/view/orientation/HorizontalRendering
 */

const releaseEventActions = {
  releaseElement: 1,
  // Not used at all at the moment
  reuseElement: 1 // Used by some other element

},
      renderEventActions = {
  newElement: 1,
  reuseOwnElement: 1,
  reuseElement: 1
},
      MAX_WIDTH = 9999999,
      heightEventSorter = ({
  startDateMS: lhs
}, {
  startDateMS: rhs
}) => lhs - rhs,
      chronoFields = {
  startDate: 1,
  endDate: 1,
  duration: 1
};

function getStartEnd(scheduler, eventRecord, useEnd) {
  var _eventRecord$hasBatch;

  // Must use Model.get in order to get latest values in case we are inside a batch.
  // EventResize changes the endDate using batching to enable a tentative change
  // via the batchedUpdate event which is triggered when changing a field in a batch.
  // Fall back to accessor if propagation has not populated date fields.
  const {
    timeAxis
  } = scheduler,
        fieldName = useEnd ? 'endDate' : 'startDate',
        date = eventRecord.isBatchUpdating ? eventRecord.get(fieldName) : eventRecord[fieldName],
        hasBatchedChange = (_eventRecord$hasBatch = eventRecord.hasBatchedChange) === null || _eventRecord$hasBatch === void 0 ? void 0 : _eventRecord$hasBatch.call(eventRecord, fieldName),
        // fillTicks shouldn't be used during resizing for changing date for smooth animation.
  // correct date will be applied after resize, when `isResizing` will be falsy
  useTickDates = scheduler.fillTicks && (!eventRecord.meta.isResizing || !hasBatchedChange);

  if (useTickDates) {
    let tick = timeAxis.getTickFromDate(date);

    if (tick >= 0) {
      // If date matches a tick start/end, use the earlier tick
      if (useEnd && tick === Math.round(tick) && tick > 0) {
        tick--;
      }

      const tickIndex = Math.floor(tick),
            tickRecord = timeAxis.getAt(tickIndex);
      return tickRecord[fieldName].getTime();
    }
  }

  return date === null || date === void 0 ? void 0 : date.getTime();
}
/**
 * Handles event rendering in Schedulers horizontal mode. Reacts to project/store changes to keep the UI up to date.
 *
 * @internal
 */


class HorizontalRendering extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_BaseRendering_js__WEBPACK_IMPORTED_MODULE_7__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
  //region Config & Init
  static get configurable() {
    return {
      // It's needed to adjust visible date range in Export. Set to 100 to render additional 100px
      // worth of ticks which helps to scroll faster during export and fixes
      // issue when scrollToDate cannot reach panel end date on exceptionally narrow view
      scrollBuffer: 0,

      /**
       * Amount of pixels to extend the current visible range at both ends with when deciding which events to
       * render. Only applies when using labels or for milestones
       * @config {Number}
       * @default
       */
      bufferSize: 150,
      verticalBufferSize: 150
    };
  }

  static get properties() {
    return {
      // Map with event DOM configs, keyed by resource id
      resourceMap: new Map(),
      // Map with visible events DOM configs, keyed by row instance
      rowMap: new Map(),
      eventConfigs: [],
      // Flag to avoid transitioning on first refresh
      isFirstRefresh: true,
      toDrawOnProjectRefresh: new Set(),
      toDrawOnDataReady: new Set()
    };
  }

  construct(scheduler) {
    const me = this;
    me.client = me.scheduler = scheduler;
    me.eventSorter = me.eventSorter.bind(scheduler); // Catch scroll before renderers are called

    scheduler.scrollable.on({
      scroll: 'onEarlyScroll',
      prio: 1,
      thisObj: me
    });
    scheduler.rowManager.on({
      name: 'rowManager',
      renderDone: 'onRenderDone',
      removeRows: 'onRemoveRows',
      translateRow: 'onTranslateRow',
      beforeRowHeight: 'onBeforeRowHeightChange',
      thisObj: me
    });
    super.construct({});
  }

  init() {}

  updateVerticalBufferSize() {
    const {
      rowManager
    } = this.scheduler;

    if (this.scheduler.isPainted) {
      // Refresh rows when vertical buffer size changes to trigger event repaint. Required for the export feature.
      rowManager.renderRows(rowManager.rows);
    }
  } //endregion
  //region Region, dates & coordinates


  get visibleDateRange() {
    return this._visibleDateRange;
  }

  getDateFromXY(xy, roundingMethod, local, allowOutOfRange = false) {
    let coord = xy[0];

    if (!local) {
      coord = this.translateToScheduleCoordinate(coord);
    }

    return this.scheduler.timeAxisViewModel.getDateFromPosition(coord, roundingMethod, allowOutOfRange);
  }

  translateToScheduleCoordinate(x) {
    // Get rid of fractional pixels, to not end up with negative fractional values for pos
    const pos = x - this.scheduler.timeAxisSubGridElement.getBoundingClientRect().left; // Because we use getBoundingClientRect's left, we have to adjust for page scroll.
    // The vertical counterpart uses the _bodyRectangle which was created with that adjustment.

    return pos + this.scheduler.scrollLeft - window.pageXOffset;
  }

  translateToPageCoordinate(x) {
    const element = this.scheduler.timeAxisSubGridElement;
    return x + element.getBoundingClientRect().left - element.scrollLeft;
  }
  /**
   * Gets the region, relative to the page, represented by the schedule and optionally only for a single resource.
   * This method will call getDateConstraints to allow for additional resource/event based constraints. By overriding
   * that method you can constrain events differently for different resources.
   * @param {Core.data.Model} [rowRecord] (optional) The row record
   * @param {Scheduler.model.EventModel} [eventRecord] (optional) The event record
   * @return {Core.helper.util.Rectangle} The region of the schedule
   */


  getScheduleRegion(rowRecord, eventRecord, local = true) {
    const me = this,
          {
      scheduler
    } = me,
          {
      timeAxisSubGridElement,
      timeAxis
    } = scheduler,
          resourceMargin = scheduler.getResourceMargin(rowRecord);
    let region;

    if (rowRecord) {
      const eventElement = eventRecord && me.getElementsFromEventRecord(eventRecord, rowRecord)[0];
      region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(scheduler.getRowById(rowRecord.id).getElement('normal'));

      if (eventElement) {
        const eventRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(eventElement, timeAxisSubGridElement);
        region.y = eventRegion.y;
        region.bottom = eventRegion.bottom;
      } else {
        region.y = region.y + resourceMargin;
        region.bottom = region.bottom - resourceMargin;
      }
    } else {
      // TODO: This is what the bizarre function that was removed here did.
      // The coordinate space needs to be sorted out here!
      region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(timeAxisSubGridElement).moveTo(null, 0);
      region.width = timeAxisSubGridElement.scrollWidth;
      region.y = region.y + resourceMargin;
      region.bottom = region.bottom - resourceMargin;
    }

    const taStart = timeAxis.startDate,
          taEnd = timeAxis.endDate,
          dateConstraints = scheduler.getDateConstraints(rowRecord, eventRecord) || {
      start: taStart,
      end: taEnd
    };
    let startX = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].max(taStart, dateConstraints.start)),
        endX = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].min(taEnd, dateConstraints.end));

    if (!local) {
      startX = me.translateToPageCoordinate(startX);
      endX = me.translateToPageCoordinate(endX);
    }

    region.left = Math.min(startX, endX);
    region.right = Math.max(startX, endX);
    return region;
  }
  /**
   * Gets the Region, relative to the timeline view element, representing the passed row and optionally just for a
   * certain date interval.
   * @param {Core.data.Model} rowRecord The row record
   * @param {Date} startDate A start date constraining the region
   * @param {Date} endDate An end date constraining the region
   * @return {Core.helper.util.Rectangle} The Rectangle which encapsulates the row
   */


  getRowRegion(rowRecord, startDate, endDate) {
    const {
      scheduler
    } = this,
          {
      timeAxis
    } = scheduler,
          row = scheduler.getRowById(rowRecord.id); // might not be rendered

    if (!row) {
      return null;
    }

    const taStart = timeAxis.startDate,
          taEnd = timeAxis.endDate,
          start = startDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].max(taStart, startDate) : taStart,
          end = endDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].min(taEnd, endDate) : taEnd,
          startX = scheduler.getCoordinateFromDate(start),
          endX = scheduler.getCoordinateFromDate(end, true, true),
          y = row.top,
          x = Math.min(startX, endX),
          bottom = y + row.offsetHeight;
    return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"](x, y, Math.max(startX, endX) - x, bottom - y);
  }

  getResourceEventBox(eventRecord, resourceRecord, includeOutside, roughly = false) {
    const resourceData = this.resourceMap.get(resourceRecord.id);
    let eventLayout = null,
        approx = false;

    if (resourceData) {
      eventLayout = resourceData.eventsData.find(d => d.eventRecord === eventRecord);
    } // Outside of view, layout now if supposed to be included


    if (!eventLayout) {
      eventLayout = this.getTimeSpanRenderData(eventRecord, resourceRecord, {
        viewport: true,
        timeAxis: includeOutside
      });
      approx = true;
    }

    if (eventLayout) {
      // Event layout is relative to row, need to make to absolute before returning
      const rowBox = this.scheduler.rowManager.getRecordCoords(resourceRecord, true, roughly),
            absoluteTop = eventLayout.top + rowBox.top,
            box = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"](eventLayout.left, absoluteTop, eventLayout.width, eventLayout.height); // Flag informing other parts of the code that this box is approximated

      box.layout = !approx;
      box.rowTop = rowBox.top;
      box.rowBottom = rowBox.bottom;
      box.resourceId = resourceRecord.id;
      return box;
    }

    return null;
  } //endregion
  //region Element <-> Record mapping


  resolveRowRecord(elementOrEvent) {
    const me = this,
          {
      scheduler
    } = me,
          element = elementOrEvent.nodeType ? elementOrEvent : elementOrEvent.target,
          // Fix for FF on Linux having text nodes as event.target
    el = element.nodeType === Element.TEXT_NODE ? element.parentElement : element,
          eventNode = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].up(el, scheduler.eventSelector);

    if (eventNode) {
      return me.resourceStore.getById(eventNode.dataset.resourceId);
    }

    return scheduler.getRecordFromElement(el);
  } //endregion
  //region Project


  attachToProject(project) {
    super.attachToProject(project);
    this.refreshAllWhenReady = true; // Perform a full clear when replacing the project, to not leave any references to old project in DOM

    if (!this.scheduler.isConfiguring) {
      this.clearAll({
        clearDom: true
      });
    }

    project === null || project === void 0 ? void 0 : project.on({
      name: 'project',
      refresh: 'onProjectRefresh',
      dataReady: 'onProjectDataReady',
      thisObj: this
    });
  }

  onProjectDataReady() {
    const {
      scheduler,
      toDrawOnDataReady
    } = this;

    if (!scheduler.refreshSuspended) {
      if (toDrawOnDataReady.size) {
        this.clearResources(toDrawOnDataReady);
        this.refreshResources(toDrawOnDataReady);
      }

      toDrawOnDataReady.clear();
    }
  }

  onProjectRefresh() {
    const me = this,
          {
      scheduler,
      toDrawOnProjectRefresh
    } = me;

    if (!scheduler.isConfiguring && !scheduler.refreshSuspended) {
      // Either refresh all rows (on for example dataset)
      if (me.refreshAllWhenReady) {
        scheduler.calculateAllRowHeights(true);
        const {
          rowManager
        } = scheduler; // Rows rendered? Refresh

        if (rowManager.topRow) {
          me.clearAll(); // Refresh only if it won't be refreshed elsewhere (SchedulerStore#onProjectRefresh())

          if (!scheduler.refreshAfterProjectRefresh) {
            // If refresh was suspended when replacing the dataset in a scrolled view we might end up with a
            // topRow outside of available range -> reset it. Call renderRows() to mimic what normally happens
            // when refresh is not suspended
            if (rowManager.topRow.dataIndex >= scheduler.store.count) {
              scheduler.renderRows(false);
            } else {
              scheduler.refreshWithTransition(false, !me.isFirstRefresh);
            }
          }

          me.isFirstRefresh = false;
        } // No rows yet, reinitialize (happens if initial project empty and then non empty project assigned)
        else {
          rowManager.reinitialize();
        }

        me.refreshAllWhenReady = false;
      } // Or only affected rows (if any)
      else if (toDrawOnProjectRefresh.size) {
        //me.clearResources(toDrawOnProjectRefresh);
        me.refreshResources(toDrawOnProjectRefresh);
      }

      toDrawOnProjectRefresh.clear();
    }
  } //endregion
  //region AssignmentStore


  attachToAssignmentStore(assignmentStore) {
    this.refreshAllWhenReady = true;
    super.attachToAssignmentStore(assignmentStore);

    if (assignmentStore) {
      assignmentStore.on({
        name: 'assignmentStore',
        changePreCommit: 'onAssignmentStoreChange',
        refreshPreCommit: 'onAssignmentStoreRefresh',
        thisObj: this
      });
    }
  }

  onAssignmentStoreChange({
    action,
    records: assignmentRecords = [],
    replaced,
    changes
  }) {
    const me = this,
          {
      scheduler
    } = me,
          resourceIds = new Set(assignmentRecords.map(assignmentRecord => assignmentRecord.resourceId)); // Ignore assignment changes caused by removing resources, the remove will redraw things anyway
    // Also ignore case when resource id is changed. In this case row will be refreshed by the grid

    if (me.resourceStore.isRemoving || me.resourceStore.isChangingId) {
      return;
    }

    switch (action) {
      // These operations will invalidate the graph, need to draw later
      case 'dataset':
        {
          // Ignore dataset when using single assignment mode
          if (!me.eventStore.usesSingleAssignment) {
            if (resourceIds.size) {
              me.refreshResourcesWhenReady(resourceIds);
            } else {
              me.clearAll();
              scheduler.refreshWithTransition();
            }
          }

          return;
        }

      case 'add':
      case 'remove':
      case 'updateMultiple':
        // TODO: Dont think updateMultiple is covered by any test...
        me.refreshResourcesWhenReady(resourceIds);
        return;

      case 'removeall':
        me.refreshAllWhenReady = true;
        return;

      case 'replace':
        // Gather resources from both the old record and the new one
        replaced.forEach(([oldAssignment, newAssignment]) => {
          resourceIds.add(oldAssignment.resourceId);
          resourceIds.add(newAssignment.resourceId);
        }); // And refresh them

        me.refreshResourcesWhenReady(resourceIds);
        return;
      // These operations wont invalidate the graph, redraw now

      case 'filter':
        me.clearAll();
        scheduler.calculateAllRowHeights(true);
        scheduler.refreshWithTransition();
        return;

      case 'update':
        {
          if ('eventId' in changes || 'resourceId' in changes || 'id' in changes) {
            // When reassigning, clear old resource also
            if ('resourceId' in changes) {
              resourceIds.add(changes.resourceId.oldValue);
            }

            me.refreshResourcesOnDataReady(resourceIds);
          }
        }
    }
  }

  onAssignmentStoreRefresh({
    action,
    records
  }) {
    if (action === 'batch') {
      this.clearAll();
      this.scheduler.refreshWithTransition();
    }
  } //endregion
  //region EventStore


  attachToEventStore(eventStore) {
    this.refreshAllWhenReady = true;
    super.attachToEventStore(eventStore);

    if (eventStore) {
      eventStore.on({
        name: 'eventStore',
        refreshPreCommit: 'onEventStoreRefresh',
        thisObj: this
      });
    }
  }

  onEventStoreRefresh({
    action
  }) {
    if (action === 'batch') {
      if (this.scheduler.isEngineReady) {
        this.clearAll();
        this.scheduler.refreshWithTransition();
      } // else {
      //     this.refreshAllWhenReady = true;
      // }

    }
  }

  onEventStoreChange({
    action,
    records: eventRecords = [],
    record,
    replaced,
    changes,
    source
  }) {
    const me = this,
          {
      scheduler
    } = me,
          isResourceTimeRange = source.isResourceTimeRangeStore,
          resourceIds = new Set();
    eventRecords.forEach(eventRecord => {
      var _eventRecord$resource;

      // When rendering a Gantt project, the project model also passes through here -> no `resources`
      (_eventRecord$resource = eventRecord.resources) === null || _eventRecord$resource === void 0 ? void 0 : _eventRecord$resource.forEach(resourceRecord => resourceIds.add(resourceRecord.id));
    });

    if (isResourceTimeRange) {
      switch (action) {
        // - dataset cant pass through same path as events, which relies on project being invalidated. and
        // resource time ranges does not pass through engine
        // - removeall also needs special path, since no resources to redraw will be collected
        case 'removeall':
        case 'dataset':
          me.clearAll();
          scheduler.refreshWithTransition();
          return;
      }

      me.refreshResources(resourceIds);
    } else {
      switch (action) {
        // No-ops
        case 'batch': // Handled elsewhere, dont want it to clear again

        case 'sort': // Order in EventStore does not matter, so these actions are no-ops

        case 'group':
        case 'move':
          return;

        case 'remove':
          // Remove is a no-op since assignment will also be removed
          return;

        case 'clearchanges':
          me.clearAll();
          scheduler.refreshWithTransition();
          return;

        case 'dataset':
          me.clearAll();
          me.refreshAllWhenReady = true;
          return;

        case 'add':
        case 'updateMultiple':
          // Just refresh below
          break;

        case 'replace':
          // Gather resources from both the old record and the new one
          replaced.forEach(([, newEvent]) => {
            // Old cleared by changed assignment
            newEvent.resources.map(resourceRecord => resourceIds.add(resourceRecord.id));
          });
          break;

        case 'removeall':
        case 'filter':
          // Filter might be caused by add retriggering filters, in which case we need to refresh later
          if (!scheduler.isEngineReady) {
            me.refreshAllWhenReady = true;
            return;
          } // Clear all when filtering for simplicity. If that turns out to give bad performance, one would need to
          // figure out which events was filtered out and only clear their resources.


          me.clearAll();
          scheduler.calculateAllRowHeights(true);
          scheduler.refreshWithTransition();
          return;

        case 'update':
          {
            // Check if changes are graph related or not
            const allChrono = record.$entity ? !Object.keys(changes).some(name => !record.$entity.getField(name)) : !Object.keys(changes).some(name => !chronoFields[name]);
            let dateChanges = 0;
            'startDate' in changes && dateChanges++;
            'endDate' in changes && dateChanges++;
            'duration' in changes && dateChanges++;

            if ('resourceId' in changes) {
              resourceIds.add(changes.resourceId.oldValue);
            } // Always redraw non chrono changes (name etc) and chrono changes that can affect appearance


            if (!allChrono || // skip case when changed "duration" only (w/o start/end affected)
            dateChanges && !('duration' in changes && dateChanges === 1) || 'percentDone' in changes || 'inactive' in changes) {
              var _me$project, _me$project2;

              // if we are finalizing data loading let's delay the resources refresh till all the
              // propagation results get into stores
              if ((_me$project = me.project) !== null && _me$project !== void 0 && _me$project.propagatingLoadChanges || (_me$project2 = me.project) !== null && _me$project2 !== void 0 && _me$project2.isWritingData) {
                me.refreshResourcesOnDataReady(resourceIds);
              } else {
                me.refreshResources(resourceIds);
              }
            }

            return;
          }
      }

      me.refreshResourcesWhenReady(resourceIds);
    }
  } //endregion
  //region ResourceStore


  attachToResourceStore(resourceStore) {
    this.refreshAllWhenReady = true;
    super.attachToResourceStore(resourceStore);

    if (resourceStore) {
      this.clearAll({
        clearLayoutCache: true
      });
      resourceStore.on({
        name: 'resourceStore',
        changePreCommit: 'onResourceStoreChange',
        thisObj: this
      });
    }
  }

  onResourceStoreChange({
    action,
    isExpand,
    records,
    changes
  }) {
    const me = this,
          resourceIds = records === null || records === void 0 ? void 0 : records.map(r => r.id);

    switch (action) {
      case 'add':
        // #635 Events disappear when toggling other node
        // If we are expanding project won't fire refresh event
        if (!isExpand) {
          me.refreshResourcesWhenReady(resourceIds);
        }

        return;

      case 'update':
        {
          // Ignore changes from project commit, if they affect events they will be redrawn anyway
          // Also ignore explicit transformation of leaf <-> parent
          if (!me.project.isBatchingChanges && !changes.isLeaf) {
            // Resource changes might affect events, refresh
            me.refreshResources(resourceIds);
          }

          return;
        }

      case 'filter':
        // Bail out on filter action. Map was already updated on `refresh` event triggered before this `change`
        // one. And extra records are removed from rowMap by `onRemoveRows`
        return;

      case 'removeall':
        me.clearAll({
          clearLayoutCache: true
        });
        return;
      // We must not clear all resources when whole dataset changes
      // https://github.com/bryntum/support/issues/3292

      case 'dataset':
        return;
    }

    me.clearResources(resourceIds);
  } //endregion
  //region RowManager


  onTranslateRow({
    row
  }) {
    // Newly added rows are translated prior to having an id, rule those out since they will be rendered later
    if (row.id != null) {
      // Event layouts are stored relative to the resource, only need to rerender the row to have its absolute
      // position updated to match new translation
      this.refreshEventsForResource(row, false);
    }
  } // Used to pre-calculate row heights


  calculateRowHeight(resourceRecord) {
    const {
      scheduler
    } = this,
          rowHeight = scheduler.getResourceHeight(resourceRecord),
          eventLayout = scheduler.getEventLayout(resourceRecord),
          layoutType = eventLayout.type;

    if (layoutType === 'stack' && scheduler.isEngineReady && !resourceRecord.isSpecialRow && resourceRecord.assigned.size > 1) {
      const {
        assignmentStore,
        eventStore,
        timeAxis
      } = scheduler,
            {
        barMargin,
        resourceMargin
      } = scheduler.getResourceLayoutSettings(resourceRecord),
            heightPerEvent = rowHeight - resourceMargin * 2,
            // When using an AssignmentStore we will get all events for the resource even if the EventStore is
      // filtered
      eventFilter = (eventStore.isFiltered || assignmentStore.isFiltered) && (eventRecord => eventRecord.assignments.some(a => a.resource === resourceRecord && assignmentStore.includes(a))),
            events = eventStore.getEvents({
        resourceRecord,
        includeOccurrences: scheduler.enableRecurringEvents,
        startDate: timeAxis.startDate,
        endDate: timeAxis.endDate,
        filter: eventFilter
      }).sort(heightEventSorter).map(eventRecord => {
        const // Must use Model.get in order to get latest values in case we are inside a batch.
        // EventResize changes the endDate using batching to enable a tentative change
        // via the batchedUpdate event which is triggered when changing a field in a batch.
        // Fall back to accessor if propagation has not populated date fields.
        startDate = eventRecord.isBatchUpdating ? eventRecord.get('startDate') : eventRecord.startDate,
              endDate = eventRecord.isBatchUpdating ? eventRecord.get('endDate') : eventRecord.endDate || startDate;
        return {
          eventRecord,
          resourceRecord,
          startMS: startDate.getTime(),
          endMS: endDate.getTime()
        };
      }),
            layoutHandler = scheduler.getEventLayoutHandler(eventLayout),
            nbrOfBandsRequired = layoutHandler.layoutEventsInBands(events, true);

      if (layoutHandler.type === 'layoutFn') {
        return nbrOfBandsRequired;
      } else {
        return nbrOfBandsRequired * heightPerEvent + (nbrOfBandsRequired - 1) * barMargin + resourceMargin * 2;
      }
    } else {
      return rowHeight;
    }
  } //endregion
  //region TimeAxis


  doUpdateTimeView() {
    this.updateFromHorizontalScroll(this.scheduler.timeAxisSubGrid.scrollable.x);
  }

  onTimeAxisViewModelUpdate() {
    const me = this,
          {
      scheduler
    } = me;
    me.clearAll(); // If refresh is suspended, update timeView as soon as refresh gets unsuspended

    if (scheduler.refreshSuspended) {
      me.detachListeners('renderingSuspend');
      scheduler.on({
        name: 'renderingSuspend',

        resumeRefresh() {
          // This code will try to refresh rows, but resumeRefresh event doesn't guarantee rowManager rows are
          // in actual state. e.g. if resources were removed during a suspended refresh rowManager won't get a
          // chance to update them until `refresh` event from the project. We can safely update the view only
          // if engine in ready (not committing), otherwise we leave refresh a liability of normal project refresh
          // logic. Covered by SchedulerRendering.t.js
          // https://github.com/bryntum/support/issues/1462
          if (scheduler.isEngineReady) {
            me.doUpdateTimeView();
          }
        },

        thisObj: me,
        once: true
      });
    } // Call update anyway. If refresh is suspended this call will only update visible date range and will not redraw rows


    me.doUpdateTimeView();
  } //endregion
  //region Dependency connectors

  /**
   * Gets displaying item start side
   *
   * @param {Scheduler.model.EventModel} eventRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorStartSide(eventRecord) {
    return 'left';
  }
  /**
   * Gets displaying item end side
   *
   * @param {Scheduler.model.EventModel} eventRecord
   * @return {String} 'left' / 'right' / 'top' / 'bottom'
   */


  getConnectorEndSide(eventRecord) {
    return 'right';
  } //endregion
  //region Scheduler hooks


  refreshRows(reLayoutEvents) {
    if (reLayoutEvents) {
      this.clearAll();
    }
  } // Clear events in case they use date as part of displayed info


  onLocaleChange() {
    this.clearAll();
  } // Called when viewport size changes


  onViewportResize(width, height, oldWidth, oldHeight) {
    // We dont draw events for all rendered rows, "refresh" when height changes to make sure events in previously
    // invisible rows gets displayed
    if (height > oldHeight) {
      this.onRenderDone();
    }
  } // Called from EventDrag


  onDragAbort({
    context,
    dragData
  }) {
    // Aborted a drag in a scrolled scheduler, with origin now out of view. Element is no longer needed
    if (this.resourceStore.indexOf(dragData.record.resource) < this.scheduler.topRow.dataIndex) {
      context.element.remove();
    }
  } // Called from EventSelection


  toggleCls(assignmentRecord, cls, add = true, useWrapper = false) {
    const element = this.getElementFromAssignmentRecord(assignmentRecord, useWrapper),
          // TODO: Should be assignmentRecord.resourceId, but breaks engine. Hoping https://github.com/bryntum/bryntum-suite/pull/1252 will fix it
    resourceData = this.resourceMap.get(assignmentRecord.isModel ? assignmentRecord.get('resourceId') : assignmentRecord.resourceId),
          eventData = resourceData === null || resourceData === void 0 ? void 0 : resourceData.eventsData.find(d => d.eventId === assignmentRecord.eventId); // Update cached config

    if (eventData) {
      eventData[useWrapper ? 'wrapperCls' : 'cls'][cls] = add;
    } // Live update element


    if (element) {
      // Update element
      element.classList[add ? 'add' : 'remove'](cls); // And its DOM config

      element.lastDomConfig.className[cls] = add;
    }
  } // React to rows being removed, refreshes view without any relayouting needed since layout is cached relative to row


  onRemoveRows({
    rows
  }) {
    rows.forEach(row => this.rowMap.delete(row));
    this.onRenderDone();
  } // Reset renderer flag before any renderers are called


  onEarlyScroll() {
    this.rendererCalled = false;
  } // If vertical scroll did not cause a renderer to be called we still want to update since we only draw events in
  // view, "independent" from their rows


  updateFromVerticalScroll() {
    if (!this.rendererCalled) {
      this.onRenderDone();
    }
  } // Update header range on horizontal scroll. No need to draw any tasks, Gantt only cares about vertical scroll


  updateFromHorizontalScroll(scrollLeft) {
    const me = this,
          {
      scheduler,
      // scrollBuffer is an export only thing
      scrollBuffer
    } = me,
          {
      timeAxisSubGrid,
      timeAxis
    } = scheduler,
          width = timeAxisSubGrid.width,
          // If there are few pixels left from the right most position then just render all remaining ticks,
    // there wouldn't be many. It makes end date reachable with more page zoom levels while not having any poor
    // implications.
    // 5px to make TimeViewRangePageZoom test stable in puppeteer.
    returnEnd = timeAxisSubGrid.scrollable.maxX <= Math.round(scrollLeft) + 5,
          startDate = scheduler.getDateFromCoordinate(Math.max(0, scrollLeft - scrollBuffer)),
          endDate = returnEnd ? timeAxis.endDate : scheduler.getDateFromCoordinate(scrollLeft + width + scrollBuffer) || timeAxis.endDate;

    if (startDate && !scheduler._viewPresetChanging) {
      me._visibleDateRange = {
        startDate,
        endDate,
        startMS: startDate.getTime(),
        endMS: endDate.getTime()
      };
      me.viewportCoords = {
        left: scrollLeft - scrollBuffer,
        right: scrollLeft + width + scrollBuffer
      }; // Update timeaxis header making it display the new dates

      const range = scheduler.timeView.range = {
        startDate,
        endDate
      };
      scheduler.onVisibleDateRangeChange(range);
      scheduler.trigger('visibleRangeChange', range); // If refresh is suspended, someone else is responsible for updating the UI later

      if (!scheduler.refreshSuspended && scheduler.rowManager.rows.length) {
        // Gets here too early in Safari for ResourceHistogram. ResizeObserver triggers a scroll before rows are
        // rendered first time. Could not track down why, bailing out
        if (scheduler.rowManager.rows[0].id === null) {
          return;
        }

        scheduler.rowManager.rows.forEach(row => me.refreshEventsForResource(row, false));
        me.onRenderDone();
      }
    }
  } // Called from SchedulerEventRendering


  repaintEventsForResource(resourceRecord) {
    this.refreshResources([resourceRecord.id]);
  }

  onBeforeRowHeightChange() {
    // Row height is cached per resource, all have to be re-laid out
    this.clearAll();
  } //endregion
  //region Refresh resources


  refreshResourcesOnDataReady(resourceIds) {
    resourceIds.forEach(id => this.toDrawOnDataReady.add(id));
  }
  /**
   * Clears resources directly and redraws them on next project refresh
   * @param {Number[]|String[]} resourceIds
   * @private
   */


  refreshResourcesWhenReady(resourceIds) {
    this.clearResources(resourceIds);
    resourceIds.forEach(id => this.toDrawOnProjectRefresh.add(id));
  }
  /**
   * Clears and redraws resources directly. Respects schedulers refresh suspension
   * @param {Number[]|String[]} ids Resource ids
   * @param {Boolean} [transition] Use transition or not
   * @private
   */


  refreshResources(ids, transition = true) {
    const me = this,
          {
      scheduler
    } = me,
          rows = [],
          noRows = [];
    me.clearResources(ids);

    if (!scheduler.refreshSuspended) {
      ids.forEach(id => {
        const row = scheduler.getRowById(id);

        if (row) {
          rows.push(row);
        } else {
          noRows.push(row);
        }
      });
      scheduler.runWithTransition(() => {
        // Rendering rows populates row heights, but not all resources might have a row in view
        scheduler.calculateRowHeights(noRows.map(id => this.resourceStore.getById(id)), true); // Render those that do

        scheduler.rowManager.renderRows(rows);
      }, transition);
    }
  } //endregion
  //region Stack & pack


  layoutEventVerticallyStack(bandIndex, eventRecord, resourceRecord) {
    const {
      barMargin,
      resourceMargin,
      rowHeight
    } = this.scheduler.getResourceLayoutSettings(resourceRecord);
    return bandIndex === 0 ? resourceMargin : resourceMargin + bandIndex * (rowHeight - resourceMargin * 2) + bandIndex * barMargin;
  }

  layoutEventVerticallyPack(topFraction, heightFraction, eventRecord, resourceRecord) {
    const {
      barMargin,
      resourceMargin,
      rowHeight
    } = this.scheduler.getResourceLayoutSettings(resourceRecord),
          // TODO reduce grid row borders when available, https://app.assembla.com/spaces/bryntum/tickets/5840-measure-grid-row-border-at-first-render/details#
    availableHeight = rowHeight - 2 * resourceMargin,
          count = 1 / heightFraction,
          bandIndex = topFraction * count,
          // "y" within row
    height = (availableHeight - (count - 1) * barMargin) * heightFraction,
          top = resourceMargin + bandIndex * height + bandIndex * barMargin;
    return {
      top,
      height
    };
  } //endregion
  //region Render

  /**
   * Used by event drag features to bring into existence event elements that are outside of the rendered block.
   * @param {Scheduler.model.TimeSpan} eventRecord The event to render
   * @param {Scheduler.model.ResourceModel} [resourceRecord] The event to render
   * @private
   */


  addTemporaryDragElement(eventRecord, resourceRecord = eventRecord.resource) {
    const {
      scheduler
    } = this,
          renderData = scheduler.generateRenderData(eventRecord, resourceRecord, {
      timeAxis: true,
      viewport: true
    });
    renderData.absoluteTop = renderData.row ? renderData.top + renderData.row.top : scheduler.getResourceEventBox(eventRecord, resourceRecord, true).top;
    const domConfig = this.renderEvent(renderData),
          {
      dataset
    } = domConfig;
    delete domConfig.tabIndex;
    delete dataset.eventId;
    delete dataset.resourceId;
    delete dataset.assignmentId;
    delete dataset.syncId;
    dataset.transient = true;
    domConfig.parent = this.scheduler.foregroundCanvas; // So that the regular DomSyncing which may happen during scroll does not
    // sweep up and reuse the temporary element.

    domConfig.retainElement = true;
    const result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement(domConfig);
    result.innerElement = result.firstChild;
    eventRecord.instanceMeta(scheduler).hasTemporaryDragElement = true;
    return result;
  } // Earlier start dates are above later tasks
  // If same start date, longer tasks float to top
  // If same start + duration, sort by name
  // Fn can be called with layout date or event records (from EventNavigation)


  eventSorter(a, b) {
    if (this.horizontalEventSorterFn) {
      return this.horizontalEventSorterFn(a.eventRecord || a, b.eventRecord || b);
    }

    const // TODO: Rename startMS -> startDateMS to not have to have isModel check here (and to be consistent)
    startA = a.isModel ? a.startDateMS : a.dataStartMS || a.startMS,
          // dataXX are used if configured with fillTicks
    endA = a.isModel ? a.endDateMS : a.dataEndMS || a.endMS,
          startB = b.isModel ? b.startDateMS : b.dataStartMS || b.startMS,
          endB = b.isModel ? b.endDateMS : b.dataEndMS || b.endMS,
          nameA = a.isModel ? a.name : a.eventRecord.name,
          nameB = b.isModel ? b.name : b.eventRecord.name;
    return startA - startB || endB - endA || (nameA < nameB ? -1 : nameA == nameB ? 0 : 1);
  }
  /**
   * Converts a start/endDate into a MS value used when rendering the event. If scheduler is configured with
   * `fillTicks: true` the value returned will be snapped to tick start/end.
   * @private
   * @param {Scheduler.model.EventModel} eventRecord
   * @returns {Object} Object of format { startMS, endMS, durationMS }
   */


  calculateMS(eventRecord) {
    const me = this,
          {
      scheduler
    } = me,
          {
      timeAxisViewModel
    } = scheduler;
    let startMS = getStartEnd(scheduler, eventRecord, false),
        endMS = getStartEnd(scheduler, eventRecord, true),
        durationMS = endMS - startMS;

    if (scheduler.milestoneLayoutMode !== 'default' && durationMS === 0) {
      const pxPerMinute = timeAxisViewModel.getSingleUnitInPixels('minute'),
            lengthInPx = scheduler.getMilestoneLabelWidth(eventRecord),
            duration = lengthInPx * (1 / pxPerMinute);
      durationMS = duration * 60 * 1000;

      switch (scheduler.milestoneAlign) {
        case 'start':
        case 'left':
          endMS = startMS + durationMS;
          break;

        case 'end':
        case 'right':
          endMS = startMS;
          startMS = endMS - durationMS;
          break;

        default:
          // using center as default
          endMS = startMS + durationMS / 2;
          startMS = endMS - durationMS;
          break;
      }
    }

    return {
      startMS,
      endMS,
      durationMS
    };
  }
  /**
   * Gets timespan coordinates etc. Relative to containing row. If the timespan is outside of the zone in
   * which timespans are rendered, that is outside of the TimeAxis, or outside of the vertical zone in which timespans
   * are rendered, then `undefined` is returned.
   * @private
   * @param {Scheduler.model.TimeSpan} timeSpan TimeSpan record
   * @param {Core.data.Model} rowRecord Row record
   * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
   * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
   * which may be outside the rendered zone.
   * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
   * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
   * @returns {{event/task: *, left: number, width: number, start: (Date), end: (Date), startMS: number, endMS: number, startsOutsideView: boolean, endsOutsideView: boolean}}
   */


  getTimeSpanRenderData(timeSpan, rowRecord, includeOutside = false) {
    const me = this,
          {
      scheduler
    } = me,
          {
      timeAxis,
      timeAxisViewModel
    } = scheduler,
          includeOutsideTimeAxis = includeOutside === true || includeOutside.timeAxis,
          includeOutsideViewport = includeOutside === true || includeOutside.viewport; // If timespan is outside the TimeAxis, give up trying to calculate a layout (Unless we're including timespans
    // outside our zone)

    if (includeOutsideTimeAxis || timeAxis.isTimeSpanInAxis(timeSpan)) {
      const row = scheduler.getRowById(rowRecord);

      if (row || includeOutsideViewport) {
        const pxPerMinute = timeAxisViewModel.getSingleUnitInPixels('minute'),
              // Must use Model.get in order to get latest values in case we are inside a batch.
        // EventResize changes the endDate using batching to enable a tentative change
        // via the batchedUpdate event which is triggered when changing a field in a batch.
        // Fall back to accessor if propagation has not populated date fields.
        timespanStart = timeSpan.isBatchUpdating ? timeSpan.get('startDate') : timeSpan.startDate,
              // Use endDate accessor if duration has not been propagated to create endDate
        timespanEnd = timeSpan.isBatchUpdating ? timeSpan.get('endDate') : timeSpan.endDate || timespanStart,
              // Allow timespans to be rendered even when they are missing an end date
        viewStartMS = timeAxis.startMS,
              viewEndMS = timeAxis.endMS,
              {
          startMS,
          endMS,
          durationMS
        } = me.calculateMS(timeSpan),
              // These flags have two components because includeOutsideViewport
        // means that we can be calculating data for events either side of
        // the TimeAxis.
        // The start is outside of the view if it's before *or after* the TimeAxis range.
        // 1 set means the start is before the TimeAxis
        // 2 set means the start is after the TimeAxis
        // Either way, a truthy value means that the start is outside of the TimeAxis.
        startsOutsideView = startMS < viewStartMS | (startMS > viewEndMS) << 1,
              // The end is outside of the view if it's before *or after* the TimeAxis range.
        // 1 set means the end is after the TimeAxis
        // 2 set means the end is before the TimeAxis
        // Either way, a truthy value means that the end is outside of the TimeAxis.
        endsOutsideView = endMS > viewEndMS | (endMS <= viewStartMS) << 1,
              durationMinutes = durationMS / (1000 * 60),
              width = endsOutsideView ? pxPerMinute * durationMinutes : null;
        let endX = scheduler.getCoordinateFromDate(endMS, {
          local: true,
          respectExclusion: true,
          isEnd: true
        }),
            startX,
            clippedStart = false,
            clippedEnd = false; // If event starts outside of view, estimate where.

        if (startsOutsideView) {
          startX = (startMS - viewStartMS) / (1000 * 60) * pxPerMinute;
        } // Starts in view, calculate exactly
        else {
          // If end date is included in time axis but start date is not (when using time axis exclusions), snap start date to next included data
          startX = scheduler.getCoordinateFromDate(startMS, {
            local: true,
            respectExclusion: true,
            isEnd: false,
            snapToNextIncluded: endX !== -1
          });
          clippedStart = startX === -1;
        }

        if (endsOutsideView) {
          endX = startX + width;
        } else {
          clippedEnd = endX === -1;
        }

        if (clippedEnd && !clippedStart) {
          // We know where to start but not where to end, snap it (the opposite is already handled by the
          // snapToNextIncluded flag when calculating startX above)
          endX = scheduler.getCoordinateFromDate(endMS, {
            local: true,
            respectExclusion: true,
            isEnd: true,
            snapToNextIncluded: true
          });
        } // If the element is very wide there's no point in displaying it all.
        // Indeed the element may not be displayable at extremely large widths.


        if (width > MAX_WIDTH) {
          // The start is before the TimeAxis start
          if (startsOutsideView === 1) {
            // Both ends outside - spans TimeAxis
            if (endsOutsideView === 1) {
              startX = -100;
              endX = scheduler.timeAxisColumn.width + 100;
            } // End is in view
            else {
              startX = endX - MAX_WIDTH;
            }
          } // The end is after, but the start is in view
          else if (endsOutsideView === 1) {
            endX = startX + MAX_WIDTH;
          }
        }

        if (clippedStart && clippedEnd) {
          // Both ends excluded, but there might be some part in between that should be displayed...
          startX = scheduler.getCoordinateFromDate(startMS, {
            local: true,
            respectExclusion: true,
            isEnd: false,
            snapToNextIncluded: true,
            max: endMS
          });
          endX = scheduler.getCoordinateFromDate(endMS, {
            local: true,
            respectExclusion: true,
            isEnd: true,
            snapToNextIncluded: true,
            min: startMS
          });

          if (startX === endX) {
            // Raise flag on instance meta to avoid duplicating this logic
            timeSpan.instanceMeta(scheduler).excluded = true; // Excluded by time axis exclusion rules, render nothing

            return null;
          }
        }

        const {
          resourceMargin,
          rowHeight
        } = scheduler.getResourceLayoutSettings(rowRecord),
              data = {
          eventRecord: timeSpan,
          taskRecord: timeSpan,
          // Helps with using Gantt projects in Scheduler Pro
          left: Math.min(startX, endX),
          // Use min width 1 for normal events, 0 for milestones (wont have width specified at all in the
          // end). During drag create a normal event can get 0 duration, in this case we still want it to
          // get a min width of 1
          width: Math.abs(endX - startX) || (timeSpan.isMilestone && !timeSpan.meta.isDragCreating ? 0 : 1),
          start: timespanStart,
          end: timespanEnd,
          rowId: rowRecord.id,
          children: [],
          startMS,
          endMS,
          startsOutsideView,
          endsOutsideView,
          clippedStart,
          clippedEnd,
          row
        }; // If filling ticks we need to also keep data's MS values, since they are used for sorting timespans

        if (scheduler.fillTicks) {
          data.dataStartMS = data.start.getTime();
          data.dataEndMS = data.end.getTime();
        }

        data.top = Math.max(0, resourceMargin);

        if (scheduler.managedEventSizing) {
          // Timespan height should be at least 1px
          data.height = Math.max(rowHeight - 2 * resourceMargin, 1);
        }

        return data;
      }
    }
  } // Lay out events within a resource, relative to the resource


  layoutResourceEvents(resourceRecord, includeOutside = false) {
    const me = this,
          {
      scheduler
    } = me,
          {
      eventStore,
      assignmentStore,
      timeAxis
    } = scheduler,
          // Events for this resource
    resourceEvents = eventStore.getEvents({
      includeOccurrences: scheduler.enableRecurringEvents,
      resourceRecord,
      startDate: timeAxis.startDate,
      endDate: timeAxis.endDate,
      filter: (assignmentStore.isFiltered || eventStore.isFiltered) && (eventRecord => eventRecord.assignments.some(a => a.resource === resourceRecord && assignmentStore.includes(a)))
    }),
          // Call a chainable template function on scheduler to allow features to add additional "events" to render
    // Currently used by ResourceTimeRanges
    allEvents = scheduler.getEventsToRender(resourceRecord, resourceEvents) || [],
          // Generate layout data
    eventsData = allEvents.reduce((result, eventRecord) => {
      // Only those in time axis (by default)
      if (includeOutside || timeAxis.isTimeSpanInAxis(eventRecord)) {
        const eventBox = scheduler.generateRenderData(eventRecord, resourceRecord, false); // Collect layouts of visible events

        if (eventBox) {
          result.push(eventBox);
        }
      }

      return result;
    }, []); // Ensure the events are rendered in natural order so that navigation works.

    eventsData.sort(me.eventSorter);
    let rowHeight = scheduler.getAppliedResourceHeight(resourceRecord);
    const // Only events and tasks should be considered during layout (not resource time ranges if any, or events
    // being drag created when configured with lockLayout)
    layoutEventData = eventsData.filter(({
      eventRecord
    }) => eventRecord.isEvent && !eventRecord.meta.excludeFromLayout),
          eventLayout = scheduler.getEventLayout(resourceRecord),
          layoutHandler = scheduler.getEventLayoutHandler(eventLayout);

    if (layoutHandler) {
      const {
        barMargin,
        resourceMargin
      } = scheduler.getResourceLayoutSettings(resourceRecord),
            heightPerEvent = rowHeight - resourceMargin * 2,
            bandsRequired = layoutHandler.applyLayout(layoutEventData, resourceRecord) || 1;

      if (layoutHandler.type === 'layoutFn') {
        rowHeight = bandsRequired;
      } else {
        rowHeight = bandsRequired * heightPerEvent + (bandsRequired - 1) * barMargin + resourceMargin * 2;
      }
    }

    return {
      rowHeight,
      eventsData
    };
  } // Generates a DOMConfig for an EventRecord


  renderEvent(data, rowHeight) {
    const {
      scheduler
    } = this,
          {
      resourceRecord,
      assignmentRecord,
      eventRecord
    } = data,
          // Sync using assignment id for events and event id for ResourceTimeRanges. Add eventId for occurrences to make them unique
    syncId = assignmentRecord // Assignment, might be an occurrence
    ? this.assignmentStore.getOccurrence(assignmentRecord, eventRecord).id // Something else, probably a ResourceTimeRange
    : data.eventId,
          // Event element config, applied to existing element or used to create a new one below
    elementConfig = {
      className: data.wrapperCls,
      tabIndex: data.tabIndex,
      children: [{
        className: data.cls,
        style: data.style || '',
        children: data.children,
        dataset: {
          // Each feature putting contents in the event wrap should have this to simplify syncing and
          // element retrieval after sync
          taskFeature: 'event'
        },
        syncOptions: {
          syncIdField: 'taskBarFeature'
        }
      }, ...data.wrapperChildren],
      style: {
        transform: `translate(${data.left}px, ${data.absoluteTop}px)`,
        // ResourceTimeRanges fill row height, cannot be done earlier than this since row height is not
        // known initially
        height: data.fillSize ? rowHeight : data.height,
        // DomHelper appends px to dimensions when using numbers. Ignore width for milestones
        width: data.width > 0 ? data.width : null,
        style: data.wrapperStyle,
        fontSize: data.height + 'px'
      },
      dataset: {
        // assignmentId is set in this function conditionally
        resourceId: resourceRecord.id,
        eventId: data.eventId,
        // Not using eventRecord.id to distinguish between Event and ResourceTimeRange
        syncId
      },
      // Will not be part of DOM, but attached to the element
      elementData: data,
      // Dragging etc. flags element as retained, to not reuse/release it during that operation. Events
      // always use assignments, but ResourceTimeRanges does not
      retainElement: (assignmentRecord === null || assignmentRecord === void 0 ? void 0 : assignmentRecord.instanceMeta(scheduler).retainElement) || eventRecord.instanceMeta(scheduler).retainElement,
      // Options for this level of sync, lower levels can have their own
      syncOptions: {
        syncIdField: 'taskFeature',
        // Remove instead of release when a feature is disabled
        releaseThreshold: 0
      }
    }; // Write back the correct height for elements filling the row, to not derender them later based on wrong height

    if (data.fillSize) {
      data.height = rowHeight;
    } // Some browsers throw warnings on zIndex = ''


    if (data.zIndex) {
      elementConfig.zIndex = data.zIndex;
    } // Do not want to spam dataset with empty prop when not using assignments (ResourceTimeRanges)


    if (assignmentRecord) {
      elementConfig.dataset.assignmentId = assignmentRecord.id;
    }

    data.elementConfig = elementConfig;
    scheduler.trigger('beforeRenderEvent', {
      renderData: data,
      domConfig: elementConfig
    });
    return elementConfig;
  }
  /**
   * Refresh events for resource record (or Row), clearing its cache and forcing DOM refresh.
   * @param {Scheduler.model.ResourceModel} recordOrRow Record or row to refresh
   * @param {Boolean} [force] Specify `false` to prevent clearing cache and forcing DOM refresh
   * @internal
   */


  refreshEventsForResource(recordOrRow, force = true) {
    let row, record;

    if (recordOrRow.isModel) {
      row = this.scheduler.rowManager.getRowFor(recordOrRow);
      record = recordOrRow;
    } else {
      row = recordOrRow;
      record = this.resourceStore.getById(recordOrRow.id);
    }

    if (force) {
      this.clearResources([recordOrRow]);
    }

    if (row && record) {
      this.renderer({
        row,
        record
      });

      if (force) {
        this.onRenderDone();
      }
    }
  } // Called per row in "view", collect configs


  renderer({
    row,
    record: resourceRecord,
    size = {}
  }) {
    var _scheduler$features$l, _scheduler$features$l2;

    // Bail out for group headers/footers
    if (resourceRecord.isSpecialRow) {
      // Clear any cached layout for row retooled to special row, and bail out
      this.rowMap.delete(row);
      return;
    }

    const me = this,
          {
      bufferSize,
      scheduler
    } = me,
          // Left/right labels require using a buffer to not derender too early
    usesLabels = ((_scheduler$features$l = scheduler.features.labels) === null || _scheduler$features$l === void 0 ? void 0 : _scheduler$features$l.left) || ((_scheduler$features$l2 = scheduler.features.labels) === null || _scheduler$features$l2 === void 0 ? void 0 : _scheduler$features$l2.right),
          {
      left,
      right
    } = me.viewportCoords,
          eventDOMConfigs = [];
    let useLeft,
        useRight,
        // Used stored layouts if available
    resourceLayout = me.resourceMap.get(resourceRecord.id);

    if (!resourceLayout || resourceLayout.invalid) {
      // Previously we would bail out here if engine wasn't ready. Now we instead allow drawing in most cases,
      // since data can be read and written during commit (previously it could not)
      if (me.suspended) {
        return;
      }

      resourceLayout = me.layoutResourceEvents(resourceRecord, false);
      me.resourceMap.set(resourceRecord.id, resourceLayout);
    } // Size row


    size.height = resourceLayout.rowHeight; // Only collect configs for those actually in view

    resourceLayout.eventsData.forEach(layout => {
      useLeft = left;
      useRight = right; // Labels/milestones requires keeping events rendered longer

      if (usesLabels || layout.width === 0) {
        useLeft -= bufferSize;
        useRight += bufferSize;
      }

      if (layout.left + layout.width >= useLeft && layout.left <= useRight) {
        layout.absoluteTop = layout.top + row.top;
        eventDOMConfigs.push(me.renderEvent(layout, resourceLayout.rowHeight));
      }
    });
    me.rowMap.set(row, eventDOMConfigs); // Keep track if we need to draw on vertical scroll or not, to not get multiple onRenderDone() calls

    me.rendererCalled = true;
  } // Called when the current row rendering "pass" is complete, sync collected configs to DOM


  onRenderDone() {
    var _scheduler$_scrollTop;

    const {
      scheduler,
      rowMap,
      verticalBufferSize
    } = this,
          visibleEventDOMConfigs = [],
          bodyTop = (_scheduler$_scrollTop = scheduler._scrollTop) !== null && _scheduler$_scrollTop !== void 0 ? _scheduler$_scrollTop : 0,
          viewTop = bodyTop - verticalBufferSize,
          viewBottom = bodyTop + scheduler._bodyRectangle.height + verticalBufferSize,
          unbuffered = verticalBufferSize < 0,
          unmanagedSize = !scheduler.managedEventSizing; // Event configs are collected when rows are rendered, but we do not want to waste resources on rendering
    // events far out of view. Especially with many events per row giving large row heights, rows in the RowManagers
    // buffer might far away -> collect events for rows within viewport + small vertical buffer

    rowMap.forEach((eventDOMConfigs, row) => {
      // Render events "in view". Export specifies a negative verticalBufferSize to disable it
      if (unbuffered || row.bottom > viewTop && row.top < viewBottom) {
        for (let i = 0; i < eventDOMConfigs.length; i++) {
          const config = eventDOMConfigs[i],
                data = config.elementData;

          if (unbuffered || unmanagedSize || data.absoluteTop + data.height > viewTop && data.absoluteTop < viewBottom) {
            visibleEventDOMConfigs.push(config);
          }
        }
      } // We are using cached DomConfigs. When DomSync releases an element, it also flags the config as released.
      // Next time we pass it that very same config, it says it is released and nothing shows up.
      //
      // We are breaching the DomSync contract a bit with the cached approach. DomSync expects new configs on each
      // call, so to facilitate that we clone the configs shallowly (nothing deep is affected by sync releasing).
      // That way we can always pass it fresh unreleased configs.


      for (let i = 0; i < eventDOMConfigs.length; i++) {
        eventDOMConfigs[i] = _objectSpread({}, eventDOMConfigs[i]);
      }
    });
    this.visibleEventDOMConfigs = visibleEventDOMConfigs;
    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_0__["default"].sync({
      domConfig: {
        onlyChildren: true,
        children: visibleEventDOMConfigs
      },
      targetElement: scheduler.foregroundCanvas,
      syncIdField: 'syncId',

      // Called by DomHelper when it creates, releases or reuses elements
      callback({
        action,
        domConfig,
        lastDomConfig,
        targetElement
      }) {
        var _domConfig$elementDat;

        if (action === 'none' || !(domConfig !== null && domConfig !== void 0 && (_domConfig$elementDat = domConfig.elementData) !== null && _domConfig$elementDat !== void 0 && _domConfig$elementDat.isWrap)) {
          return;
        }

        const // Some actions are considered first a release and then a render (reusing another element).
        // This gives clients code a chance to clean up before reusing an element
        isRelease = releaseEventActions[action],
              isRender = renderEventActions[action]; // Trigger release for events (it might be a proxy element, skip those)

        if (isRelease && lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.elementData) {
          const {
            eventRecord,
            resourceRecord,
            assignmentRecord
          } = lastDomConfig.elementData,
                event = {
            renderData: lastDomConfig.elementData,
            element: targetElement,
            eventRecord,
            resourceRecord,
            assignmentRecord
          }; // Some browsers do not blur on set to display:none, so releasing the active element
          // must *explicitly* move focus outwards to the view.

          if (targetElement === _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(targetElement)) {
            scheduler.focusElement.focus();
          } // This event is documented on Scheduler


          scheduler.trigger('releaseEvent', event);
        }

        if (isRender) {
          const {
            eventRecord,
            resourceRecord,
            assignmentRecord
          } = domConfig.elementData,
                event = {
            renderData: domConfig.elementData,
            tplData: domConfig.elementData,
            // DEPRECATED IN 4.0
            element: targetElement,
            isReusingElement: action === 'reuseElement',
            isRepaint: action === 'reuseOwnElement',
            eventRecord,
            resourceRecord,
            assignmentRecord
          }; // This event is documented on Scheduler

          scheduler.trigger('renderEvent', event);
        }
      }

    }); // if (window.brk) console.timeEnd('load');
  } //endregion
  //region Cache
  // Clears cached resource layout


  clearResources(recordsOrIds) {
    if (recordsOrIds instanceof Set) {
      recordsOrIds = Array.from(recordsOrIds);
    } else if (!Array.isArray(recordsOrIds)) {
      recordsOrIds = [recordsOrIds];
    }

    const resourceIds = recordsOrIds.map(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"].asId);
    resourceIds.forEach(resourceId => {
      // Invalidate resourceLayout, keeping it around in case we need it before next refresh
      const cached = this.resourceMap.get(resourceId);

      if (cached) {
        cached.invalid = true;
      }

      const row = this.scheduler.getRowById(resourceId);
      row && this.rowMap.delete(row);
    });
  }

  clearAll({
    clearDom = false,
    clearLayoutCache = false
  } = {}) {
    const {
      layouts
    } = this.scheduler;

    if (clearLayoutCache && layouts) {
      for (const layout in layouts) {
        layouts[layout].clearCache();
      }
    }

    if (clearDom) {
      const {
        foregroundCanvas
      } = this.scheduler; // Start from scratch when replacing the project, to not retain anything in maps or released elements

      foregroundCanvas.syncIdMap = foregroundCanvas.lastDomConfig = null;

      for (const child of foregroundCanvas.children) {
        // child.remove();
        child.lastDomConfig = child.elementData = null;
      }
    }

    this.resourceMap.clear();
    this.rowMap.clear();
  } //endregion


}
HorizontalRendering._$name = 'HorizontalRendering';

/***/ }),

/***/ "./lib/Scheduler/view/orientation/VerticalRendering.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/view/orientation/VerticalRendering.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalRendering; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../eventlayout/VerticalLayout.js */ "./lib/Scheduler/eventlayout/VerticalLayout.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony import */ var _BaseRendering_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./BaseRendering.js */ "./lib/Scheduler/view/orientation/BaseRendering.js");
var productName = 'gantt';










/**
 * @module Scheduler/view/orientation/VerticalRendering
 */

const releaseEventActions = {
  releaseElement: 1,
  // Not used at all at the moment
  reuseElement: 1 // Used by some other element

},
      renderEventActions = {
  newElement: 1,
  reuseOwnElement: 1,
  reuseElement: 1
},
      chronoFields = {
  startDate: 1,
  endDate: 1,
  duration: 1
},
      emptyObject = Object.freeze({});
/**
 * Handles event rendering in Schedulers vertical mode. Reacts to project/store changes to keep the UI up to date.
 *
 * @internal
 */

class VerticalRendering extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"], _BaseRendering_js__WEBPACK_IMPORTED_MODULE_9__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_8__["default"]) {
  //region Config & Init
  static get properties() {
    return {
      eventMap: new Map(),
      resourceMap: new Map(),
      releasedElements: {},
      toDrawOnProjectRefresh: new Set(),
      resourceBufferSize: 1
    };
  }

  construct(scheduler) {
    this.client = this.scheduler = scheduler;
    this.verticalLayout = new _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
      scheduler
    });
    super.construct({});
  }

  init() {
    const me = this,
          {
      scheduler
    } = me; // Resource header/columns

    me.resourceColumns.resourceStore = me.resourceStore;
    me.resourceColumns.on({
      name: 'resourceColumns',
      columnWidthChange: 'onResourceColumnWidthChange',
      thisObj: me
    });
    me.initialized = true;

    if (scheduler.isPainted) {
      me.renderer();
    }

    me.resourceColumns.availableWidth = scheduler.timeAxisSubGridElement.offsetWidth;
  } //endregion
  //region Elements <-> Records


  resolveRowRecord(elementOrEvent, xy) {
    const me = this,
          {
      scheduler
    } = me,
          event = elementOrEvent.nodeType ? null : elementOrEvent,
          element = event ? event.target : elementOrEvent,
          coords = event ? [event.offsetX, event.offsetY] : xy,
          // Fix for FF on Linux having text nodes as event.target
    el = element.nodeType === Element.TEXT_NODE ? element.parentElement : element,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(el, scheduler.eventSelector);

    if (eventElement) {
      return scheduler.resourceStore.getById(eventElement.dataset.resourceId);
    } // Need to be inside schedule at least


    if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(element, '.b-sch-timeaxis-cell')) {
      return null;
    }

    if (!coords) {
      throw new Error(`Vertical mode needs coordinates to resolve this element. Can also be called with a browser
                event instead of element to extract element and coordinates from`);
    }

    const index = Math.floor(coords[0] / me.resourceColumns.columnWidth);
    return scheduler.resourceStore.getAt(index);
  }

  toggleCls(assignmentRecord, cls, add = true, useWrapper = false) {
    var _this$eventMap$get;

    const eventData = (_this$eventMap$get = this.eventMap.get(assignmentRecord.eventId)) === null || _this$eventMap$get === void 0 ? void 0 : _this$eventMap$get[assignmentRecord.resourceId];

    if (eventData) {
      eventData.renderData[useWrapper ? 'wrapperCls' : 'cls'][cls] = add; // Element from the map cannot be trusted, might be reused in which case map is not updated to reflect that.
      // To be safe, retrieve using `getElementFromAssignmentRecord`

      const element = this.getElementFromAssignmentRecord(assignmentRecord, useWrapper);

      if (element) {
        element.classList[add ? 'add' : 'remove'](cls);
      }
    }
  } //endregion
  //region Coordinate <-> Date


  getDateFromXY(xy, roundingMethod, local, allowOutOfRange = false) {
    let coord = xy[1];

    if (!local) {
      coord = this.translateToScheduleCoordinate(coord);
    }

    return this.scheduler.timeAxisViewModel.getDateFromPosition(coord, roundingMethod, allowOutOfRange);
  }

  translateToScheduleCoordinate(y) {
    // We do not have to account for page scroll here because _bodyRectangle was created
    // with that adjustment.
    return y - this.scheduler._bodyRectangle.y + this.scheduler.scrollTop;
  }

  translateToPageCoordinate(y) {
    return y + this.scheduler._bodyRectangle.y - this.scheduler.scrollTop;
  } //endregion
  //region Regions


  getResourceEventBox(event, resource) {
    var _this$eventMap$get2;

    const eventId = event.id,
          resourceId = resource.id;
    let {
      renderData
    } = ((_this$eventMap$get2 = this.eventMap.get(eventId)) === null || _this$eventMap$get2 === void 0 ? void 0 : _this$eventMap$get2[resourceId]) || emptyObject;

    if (!renderData) {
      var _this$eventMap$get3, _this$eventMap$get3$r;

      // Never been in view, lay it out
      this.layoutResource(this.scheduler.resourceStore.getById(resourceId)); // Have another go at getting the layout data

      renderData = (_this$eventMap$get3 = this.eventMap.get(eventId)) === null || _this$eventMap$get3 === void 0 ? void 0 : (_this$eventMap$get3$r = _this$eventMap$get3[resourceId]) === null || _this$eventMap$get3$r === void 0 ? void 0 : _this$eventMap$get3$r.renderData;
    }

    return renderData ? new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"](renderData.left, renderData.top, renderData.width, renderData.bottom - renderData.top) : null;
  }

  getScheduleRegion(resourceRecord, eventRecord, local) {
    const me = this,
          {
      scheduler
    } = me;
    const region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(scheduler.timeAxisSubGridElement);

    if (resourceRecord) {
      // TODO: How to account for eventRecord here?
      region.left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
      region.right = region.left + scheduler.resourceColumnWidth;
    }

    const start = scheduler.timeAxis.startDate,
          end = scheduler.timeAxis.endDate,
          dateConstraints = scheduler.getDateConstraints(resourceRecord, eventRecord) || {
      start,
      end
    },
          startY = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].max(start, dateConstraints.start)),
          endY = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].min(end, dateConstraints.end));

    if (!local) {
      region.top = me.translateToPageCoordinate(startY);
      region.bottom = me.translateToPageCoordinate(endY);
    } else {
      region.top = startY;
      region.bottom = endY;
    }

    return region;
  }

  getRowRegion(resourceRecord, startDate, endDate) {
    const me = this,
          {
      scheduler
    } = me,
          x = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
          taStart = scheduler.timeAxis.startDate,
          taEnd = scheduler.timeAxis.endDate,
          start = startDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].max(taStart, startDate) : taStart,
          end = endDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].min(taEnd, endDate) : taEnd,
          startY = scheduler.getCoordinateFromDate(start),
          endY = scheduler.getCoordinateFromDate(end, true, true),
          y = Math.min(startY, endY),
          height = Math.abs(startY - endY);
    return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"](x, y, scheduler.resourceColumnWidth, height);
  }

  get visibleDateRange() {
    const scheduler = this.scheduler,
          scrollPos = scheduler.scrollable.y,
          height = scheduler.scrollable.clientHeight;
    return {
      startDate: scheduler.getDateFromCoordinate(scrollPos),
      endDate: scheduler.getDateFromCoordinate(scrollPos + height) || scheduler.timeAxis.endDate
    };
  } //endregion
  //region Events
  // Column width changed, rerender fully


  onResourceColumnWidthChange({
    width,
    oldWidth
  }) {
    const me = this,
          {
      scheduler
    } = me; // Fix width of column & header

    me.resourceColumns.width = scheduler.timeAxisColumn.width = me.resourceStore.count * width;
    me.clearAll(); // Only transition large changes, otherwise it is janky when dragging slider in demo

    me.refresh(Math.abs(width - oldWidth) > 30); // Not detected by resizeobserver? Need to call this for virtual scrolling to react to update
    //        scheduler.callEachSubGrid('refreshFakeScroll');
    //        scheduler.refreshVirtualScrollbars();
  } //endregion
  //region Project


  attachToProject(project) {
    super.attachToProject(project);

    if (project) {
      project.on({
        name: 'project',
        refresh: 'onProjectRefresh',
        thisObj: this
      });
    }
  }

  onProjectRefresh() {
    const me = this,
          {
      scheduler,
      toDrawOnProjectRefresh
    } = me;

    if (scheduler.rendered && !scheduler.refreshSuspended) {
      // Either refresh all rows (on for example dataset)
      if (me.refreshAllWhenReady) {
        me.clearAll(); //scheduler.refreshWithTransition();

        me.refresh();
        me.refreshAllWhenReady = false;
      } // Or only affected rows (if any)
      else if (toDrawOnProjectRefresh.size) {
        me.refresh();
      }

      toDrawOnProjectRefresh.clear();
    }
  } //endregion
  //region EventStore


  attachToEventStore(eventStore) {
    super.attachToEventStore(eventStore);
    this.refreshAllWhenReady = true;

    if (eventStore) {
      eventStore.on({
        name: 'eventStore',
        refreshPreCommit: 'onEventStoreRefresh',
        thisObj: this
      });
    }
  }

  onEventStoreRefresh({
    action
  }) {
    if (action === 'batch') {
      this.refreshAllWhenReady = true;
    }
  }

  onEventStoreChange({
    action,
    records: eventRecords = [],
    record,
    replaced,
    changes,
    isAssign
  }) {
    const me = this,
          resourceIds = new Set();
    eventRecords.forEach(eventRecord => {
      eventRecord.resources.forEach(resourceRecord => resourceIds.add(resourceRecord.id));
    });

    switch (action) {
      // No-ops
      case 'sort': // Order in EventStore does not matter, so these actions are no-ops

      case 'group':
      case 'move':
      case 'remove':
        // Remove is a no-op since assignment will also be removed
        return;

      case 'dataset':
        me.refreshAllResourcesWhenReady();
        return;

      case 'add':
      case 'updateMultiple':
        // Just refresh below
        break;

      case 'replace':
        // Gather resources from both the old record and the new one
        replaced.forEach(([, newEvent]) => {
          // Old cleared by changed assignment
          newEvent.resources.map(resourceRecord => resourceIds.add(resourceRecord.id));
        }); // And clear them

        me.clearResources(resourceIds);
        break;

      case 'removeall':
      case 'filter':
        // Clear all when filtering for simplicity. If that turns out to give bad performance, one would need to
        // figure out which events was filtered out and only clear their resources.
        me.clearAll();
        me.refresh();
        return;

      case 'update':
        {
          // Check if changes are graph related or not
          const allChrono = record.$entity ? !Object.keys(changes).some(name => !record.$entity.getField(name)) : !Object.keys(changes).some(name => !chronoFields[name]); // If any one of these in changes, it will affect visuals

          let changeCount = 0;
          if ('startDate' in changes) changeCount++;
          if ('endDate' in changes) changeCount++;
          if ('duration' in changes) changeCount++; // Always redraw non chrono changes (name etc)

          if (!allChrono || changeCount) {
            me.clearResources(resourceIds);
            me.refresh();
          }

          return;
        }
    }

    me.refreshResourcesWhenReady(resourceIds);
  } //endregion
  //region ResourceStore


  attachToResourceStore(resourceStore) {
    const me = this;
    super.attachToResourceStore(resourceStore);
    me.refreshAllWhenReady = true;

    if (me.resourceColumns) {
      me.resourceColumns.resourceStore = resourceStore;
    }

    resourceStore.on({
      name: 'resourceStore',
      changePreCommit: 'onResourceStoreChange',
      refreshPreCommit: 'onResourceStoreRefresh',
      // In vertical, resource store is not the row store but should toggle the load mask
      load: () => me.scheduler.unmaskBody(),
      thisObj: me,
      prio: 1 // Call before others to clear cache before redraw

    });

    if (me.initialized) {
      // Invalidate resource range and events
      me.firstResource = me.lastResource = null;
      me.clearAll();
      me.renderer();
    }
  }

  onResourceStoreChange({
    source: resourceStore,
    action,
    records = [],
    record,
    replaced,
    changes
  }) {
    const me = this,
          // records for add, record for update, replaced [[old, new]] for replace
    resourceRecords = replaced ? replaced.map(r => r[1]) : records,
          resourceIds = new Set(resourceRecords.map(resourceRecord => resourceRecord.id)); // Invalidate resource range

    me.firstResource = me.lastResource = null; // Operation that did not invalidate engine, refresh directly

    if (me.scheduler.isEngineReady) {
      switch (action) {
        case 'update':
          if (changes !== null && changes !== void 0 && changes.id) {
            me.clearResources([changes.id.oldValue, changes.id.value]);
          } else {
            me.clearResources([record.id]);
          } // Only the invalidation above needed


          break;

        case 'filter':
          // All filtered out resources needs clearing and so does those not filtered out since they might have
          // moved horizontally when others hide
          me.clearAll();
          break;
      }

      me.refresh(true);
    } // Operation that did invalidate project, update on project refresh
    else {
      switch (action) {
        case 'dataset':
        case 'remove': // Cannot tell from which index it was removed

        case 'removeall':
          me.refreshAllResourcesWhenReady();
          return;

        case 'replace':
        case 'add':
          {
            // Make sure all existing events following added resources are offset correctly
            const firstIndex = resourceRecords.reduce((index, record) => Math.min(index, resourceStore.indexOf(record)), resourceStore.count);

            for (let i = firstIndex; i < resourceStore.count; i++) {
              resourceIds.add(resourceStore.getAt(i).id);
            }
          }
      }

      me.refreshResourcesWhenReady(resourceIds);
    }
  }

  onResourceStoreRefresh({
    action
  }) {
    const me = this;

    if (action === 'group') {
      throw new Error('Grouping of resources not supported in vertical mode');
    }

    if (action === 'sort') {
      // Invalidate resource range
      me.firstResource = me.lastResource = null;
      me.clearAll();
      me.refresh();
    }
  } //endregion
  //region AssignmentStore


  attachToAssignmentStore(assignmentStore) {
    super.attachToAssignmentStore(assignmentStore);
    this.refreshAllWhenReady = true;

    if (assignmentStore) {
      assignmentStore.on({
        name: 'assignmentStore',
        changePreCommit: 'onAssignmentStoreChange',
        refreshPreCommit: 'onAssignmentStoreRefresh',
        thisObj: this
      });
    }
  }

  onAssignmentStoreChange({
    action,
    records: assignmentRecords = [],
    replaced,
    changes
  }) {
    const me = this,
          resourceIds = new Set(assignmentRecords.map(assignmentRecord => assignmentRecord.resourceId)); // Operation that did not invalidate engine, refresh directly

    if (me.scheduler.isEngineReady) {
      switch (action) {
        case 'filter':
          me.clearAll();
          break;

        case 'update':
          {
            // When reassigning, clear old resource also
            if ('resourceId' in changes) {
              resourceIds.add(changes.resourceId.oldValue);
            } // Ignore engine resolving resourceId -> resource, eventId -> event


            if (!Object.keys(changes).filter(field => field !== 'resource' && field !== 'event').length) {
              return;
            }

            me.clearResources(resourceIds);
          }
      }

      me.refresh(true);
    } // Operation that did invalidate project, update on project refresh
    else {
      if (changes && 'resourceId' in changes) {
        resourceIds.add(changes.resourceId.oldValue);
      }

      switch (action) {
        case 'removeall':
          me.refreshAllResourcesWhenReady();
          return;

        case 'replace':
          // Gather resources from both the old record and the new one
          replaced.forEach(([oldAssignment, newAssignment]) => {
            resourceIds.add(oldAssignment.resourceId);
            resourceIds.add(newAssignment.resourceId);
          });
      }

      me.refreshResourcesWhenReady(resourceIds);
    }
  }

  onAssignmentStoreRefresh({
    action,
    records
  }) {
    if (action === 'batch') {
      this.clearAll();
      this.refreshAllResourcesWhenReady();
    }
  } //endregion
  //region View hooks


  refreshRows(reLayoutEvents) {
    if (reLayoutEvents) {
      this.clearAll();
      this.scheduler.refreshFromRerender = false;
    }
  } // Called from SchedulerEventRendering


  repaintEventsForResource(resourceRecord) {
    this.renderResource(resourceRecord);
  }

  updateFromHorizontalScroll(scrollLeft) {
    if (scrollLeft !== this.prevScrollLeft) {
      this.renderer();
      this.prevScrollLeft = scrollLeft;
    }
  }

  updateFromVerticalScroll() {
    this.renderer();
  }

  scrollResourceIntoView(resourceRecord, options) {
    const {
      scheduler
    } = this,
          x = scheduler.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
    return scheduler.scrollHorizontallyTo(x, options);
  } // Called when viewport size changes


  onViewportResize(width) {
    this.resourceColumns.availableWidth = width;
    this.renderer();
  }

  get resourceColumns() {
    return this.scheduler.timeAxisColumn.resourceColumns;
  } // Clear events in case they use date as part of displayed info


  onLocaleChange() {
    this.clearAll();
  } // No need to do anything special


  onDragAbort() {}

  onBeforeRowHeightChange() {}

  onTimeAxisViewModelUpdate() {}

  updateElementId() {}

  releaseTimeSpanDiv() {} //endregion
  //region Refresh resources

  /**
   * Clears resources directly and redraws them on next project refresh
   * @param {Number[]|String[]} resourceIds
   * @private
   */


  refreshResourcesWhenReady(resourceIds) {
    this.clearResources(resourceIds);
    resourceIds.forEach(id => this.toDrawOnProjectRefresh.add(id));
  }
  /**
   * Clears all resources directly and redraws them on next project refresh
   * @private
   */


  refreshAllResourcesWhenReady() {
    this.clearAll();
    this.refreshAllWhenReady = true;
  } //region Rendering
  // Resources in view + buffer


  get resourceRange() {
    return this.getResourceRange(true);
  } // Resources strictly in view


  get visibleResources() {
    const {
      first,
      last
    } = this.getResourceRange();
    return {
      first: this.resourceStore.getAt(first),
      last: this.resourceStore.getAt(last)
    };
  }

  getResourceRange(withBuffer) {
    const {
      scheduler,
      resourceStore
    } = this;
    let resourceBufferSize = this.resourceBufferSize;

    if (!withBuffer) {
      resourceBufferSize = 0;
    }

    if (!resourceStore || !resourceStore.count) {
      return {
        first: -1,
        last: -1
      };
    }

    return {
      first: Math.max(Math.floor(scheduler.scrollLeft / scheduler.resourceColumnWidth) - resourceBufferSize, 0),
      last: Math.min(Math.floor((scheduler.scrollLeft + scheduler.timeAxisSubGrid.width) / scheduler.resourceColumnWidth) + resourceBufferSize, resourceStore.count - 1)
    };
  } // Dates in view + buffer


  get dateRange() {
    const {
      scheduler
    } = this;
    let bottomDate = scheduler.getDateFromCoordinate(Math.min(scheduler.scrollTop + scheduler.bodyHeight + scheduler.tickSize - 1, (scheduler.virtualScrollHeight || scheduler.scrollable.scrollHeight) - 1)); // Might end up below time axis (out of ticks)
    // TODO: Change call order on refresh to make sure this is not needed?

    if (!bottomDate) {
      bottomDate = scheduler.timeAxis.last.endDate;
    }

    let topDate = scheduler.getDateFromCoordinate(Math.max(scheduler.scrollTop - scheduler.tickSize, 0)); // Might end up above time axis when reconfiguring (since this happens as part of rendering)

    if (!topDate) {
      topDate = scheduler.timeAxis.first.startDate;
      bottomDate = scheduler.getDateFromCoordinate(scheduler.bodyHeight + scheduler.tickSize - 1);
    }

    return {
      topDate,
      bottomDate
    };
  }

  getTimeSpanRenderData(eventRecord, resourceRecord, includeOutside = false) {
    const me = this,
          {
      scheduler
    } = me,
          // Must use Model.get in order to get latest values in case we are inside a batch.
    // EventResize changes the endDate using batching to enable a tentative change
    // via the batchedUpdate event which is triggered when changing a field in a batch.
    // Fall back to accessor if propagation has not populated date fields.
    startDate = eventRecord.isBatchUpdating ? eventRecord.get('startDate') : eventRecord.startDate,
          endDate = eventRecord.isBatchUpdating ? eventRecord.get('endDate') : eventRecord.endDate,
          resourceMargin = scheduler.getResourceMargin(resourceRecord),
          top = scheduler.getCoordinateFromDate(startDate),
          // Preliminary values for left & width, used for proxy. Will be changed on layout
    left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
          width = scheduler.resourceColumnWidth - resourceMargin * 2,
          startDateMS = startDate.getTime(),
          endDateMS = endDate.getTime();
    let bottom = scheduler.getCoordinateFromDate(endDate),
        height = bottom - top; // Below, estimate height

    if (bottom === -1) {
      height = Math.round((endDateMS - startDateMS) * scheduler.timeAxisViewModel.getSingleUnitInPixels('millisecond'));
      bottom = top + height;
    }

    return {
      eventRecord,
      resourceRecord,
      left,
      top,
      bottom,
      width,
      height,
      startDate,
      endDate,
      startDateMS,
      endDateMS,
      children: [],
      // to match horizontal, TODO: should change there
      start: startDate,
      end: endDate,
      startMs: startDateMS,
      endMs: endDateMS
    };
  } // Earlier start dates are above later tasks
  // If same start date, longer tasks float to top
  // If same start + duration, sort by name


  eventSorter(a, b) {
    const startA = a.dataStartMs || a.startDateMS,
          // dataXX are used if configured with fillTicks
    endA = a.dataEndMs || a.endDateMS,
          startB = b.dataStartMs || b.startDateMS,
          endB = b.dataEndMs || b.endDateMS,
          nameA = a.isModel ? a.name : a.eventRecord.name,
          nameB = b.isModel ? b.name : b.eventRecord.name;
    return startA - startB || endB - endA || (nameA < nameB ? -1 : nameA == nameB ? 0 : 1);
  } // Calculate the layout for all events assigned to a resource. Since we are never stacking, the layout of one
  // resource will never affect the others


  layoutResource(resourceRecord) {
    const me = this,
          {
      scheduler
    } = me,
          {
      id: resourceId
    } = resourceRecord,
          // Used in loop, reduce access time a wee bit
    {
      assignmentStore,
      eventStore,
      timeAxis
    } = scheduler,
          // Cache per resource
    cache = me.resourceMap.set(resourceId, {}).get(resourceId),
          // Resource "column"
    resourceIndex = scheduler.resourceStore.indexOf(resourceRecord),
          {
      barMargin,
      resourceMargin
    } = scheduler.getResourceLayoutSettings(resourceRecord); // Events for the resource, minus those that are filtered out by filtering assignments and events

    let events = eventStore.getEvents({
      includeOccurrences: scheduler.enableRecurringEvents,
      resourceRecord,
      startDate: timeAxis.startDate,
      endDate: timeAxis.endDate,
      filter: (assignmentStore.isFiltered || eventStore.isFiltered) && (eventRecord => eventRecord.assignments.some(a => a.resource === resourceRecord && assignmentStore.includes(a)))
    }); // Hook for features to inject additional timespans to render

    events = scheduler.getEventsToRender(resourceRecord, events);
    const layoutData = events.reduce((toLayout, eventRecord) => {
      const renderData = scheduler.generateRenderData(eventRecord, resourceRecord, false),
            // Elements will be appended to eventData during syncing
      eventData = {
        renderData
      },
            eventResources = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getMapPath(me.eventMap, renderData.eventId, {}); // Cache per event, { e1 : { r1 : { xxx }, r2 : ... }, e2 : ... }
      // Uses renderData.eventId in favor of eventRecord.id to work with ResourceTimeRanges

      eventResources[resourceId] = eventData; // Cache per resource

      cache[renderData.eventId] = eventData; // Position ResourceTimeRanges directly, they do not affect the layout of others

      if (renderData.fillSize) {
        renderData.left = resourceIndex * scheduler.resourceColumnWidth;
        renderData.width = scheduler.resourceColumnWidth;
      } // Anything not flagged with `fillSize` should take part in layout
      else {
        toLayout.push(renderData);
      }

      return toLayout;
    }, []); // Ensure the events are rendered in natural order so that navigation works.

    layoutData.sort(me.eventSorter); // Apply per resource event layout (pack, overlap or mixed)

    me.verticalLayout.applyLayout(layoutData, scheduler.resourceColumnWidth, resourceMargin, barMargin, resourceIndex, scheduler.getEventLayout(resourceRecord));
    return cache;
  }
  /**
   * Used by event drag features to bring into existence event elements that are outside of the rendered block.
   * @param {Scheduler.model.TimeSpan} eventRecord The event to render
   * @private
   */


  addTemporaryDragElement(eventRecord) {
    const {
      scheduler
    } = this,
          renderData = scheduler.generateRenderData(eventRecord, eventRecord.resource, {
      timeAxis: true,
      viewport: true
    });
    renderData.top = renderData.row ? renderData.top + renderData.row.top : scheduler.getResourceEventBox(eventRecord, eventRecord.resource, true).top;
    const domConfig = this.renderEvent({
      renderData
    }),
          {
      dataset
    } = domConfig;
    delete domConfig.tabIndex;
    delete dataset.eventId;
    delete dataset.resourceId;
    delete dataset.assignmentId;
    delete dataset.syncId;
    dataset.transient = true;
    domConfig.parent = this.scheduler.foregroundCanvas; // So that the regular DomSyncing which may happen during scroll does not
    // sweep up and reuse the temporary element.

    domConfig.retainElement = true;
    const result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement(domConfig);
    result.innerElement = result.firstChild;
    eventRecord.instanceMeta(scheduler).hasTemporaryDragElement = true;
    return result;
  } // TODO: Pretty much identical to HorizontalRendering#renderEvent. Make shared base class
  // Render a single event, aborting if already in DOM. To update an event, first release its element and then render
  // it again. The element will be reused and updated. Keeps code simpler


  renderEvent(eventData) {
    // No point in rendering event that already has an element
    const data = eventData.renderData,
          {
      resourceRecord,
      assignmentRecord,
      eventRecord
    } = data,
          // Event element config, applied to existing element or used to create a new one below
    elementConfig = {
      className: data.wrapperCls,
      tabIndex: '0',
      children: [{
        className: data.cls,
        style: (data.internalStyle || '') + (data.style || ''),
        children: data.children,
        dataset: {
          // Each feature putting contents in the event wrap should have this to simplify syncing and
          // element retrieval after sync
          taskFeature: 'event'
        },
        syncOptions: {
          syncIdField: 'taskBarFeature'
        }
      }, ...data.wrapperChildren],
      style: {
        transform: `translate(${data.left}px, ${data.top}px)`,
        // DomHelper appends px to dimensions when using numbers
        height: data.height,
        width: data.width,
        style: data.wrapperStyle || ''
      },
      dataset: {
        // assignmentId is set in this function conditionally
        resourceId: resourceRecord.id,
        eventId: data.eventId,
        // Not using eventRecord.id to distinguish between Event and ResourceTimeRange
        // Sync using assignment id for events and event id for ResourceTimeRanges
        syncId: assignmentRecord ? this.assignmentStore.getOccurrence(assignmentRecord, eventRecord).id : data.eventId
      },
      // Will not be part of DOM, but attached to the element
      elementData: eventData,
      // Dragging etc. flags element as retained, to not reuse/release it during that operation. Events
      // always use assignments, but ResourceTimeRanges does not
      retainElement: (assignmentRecord || eventRecord).instanceMeta(this.scheduler).retainElement,
      // Options for this level of sync, lower levels can have their own
      syncOptions: {
        syncIdField: 'taskFeature',
        // Remove instead of release when a feature is disabled
        releaseThreshold: 0
      }
    }; // Some browsers throw warnings on zIndex = ''

    if (data.zIndex) {
      elementConfig.zIndex = data.zIndex;
    } // Do not want to spam dataset with empty prop when not using assignments (ResourceTimeRanges)


    if (assignmentRecord) {
      elementConfig.dataset.assignmentId = assignmentRecord.id;
    }

    this.scheduler.trigger('beforeRenderEvent', {
      renderData: data,
      domConfig: elementConfig
    }); // Allows access to the used config later, for example to retrieve element

    eventData.elementConfig = elementConfig;
    return elementConfig;
  }

  renderResource(resourceRecord) {
    const me = this,
          // Date at top and bottom for determining which events to include
    {
      topDateMS,
      bottomDateMS
    } = me,
          // Will hold element configs
    syncConfigs = [];
    let resourceEntry = me.resourceMap.get(resourceRecord.id); // Layout all events for the resource unless already done

    if (!resourceEntry) {
      resourceEntry = me.layoutResource(resourceRecord);
    } // Iterate over all events for the resource


    for (const eventId in resourceEntry) {
      const eventData = resourceEntry[eventId],
            {
        endDateMS,
        startDateMS,
        eventRecord
      } = eventData.renderData;

      if ( // Only collect configs for those actually in view
      endDateMS >= topDateMS && startDateMS <= bottomDateMS && // And not being dragged, those has a temporary element already
      !eventRecord.instanceMeta(me.scheduler).hasTemporaryDragElement) {
        syncConfigs.push(me.renderEvent(eventData));
      }
    }

    return syncConfigs;
  }

  isEventElement(domConfig) {
    const className = domConfig && domConfig.className;
    return className && className[this.scheduler.eventCls + '-wrap'];
  } // Single cell so only one call to this renderer, determine which events are in view and draw them.
  // Drawing on scroll is triggered by `updateFromVerticalScroll()` and `updateFromHorizontalScroll()`


  renderer() {
    const me = this,
          {
      scheduler
    } = me,
          {
      resourceStore
    } = scheduler,
          // Determine resource range to draw events for
    {
      first: firstResource,
      last: lastResource
    } = me.resourceRange,
          // Date at top and bottom for determining which events to include
    {
      topDate,
      bottomDate
    } = me.dateRange,
          syncConfigs = [],
          featureDomConfigs = []; // If scheduler is creating a new event, the render needs to be synchronous, so
    // we cannot wait for the engine to normalize - the new event will have correct data set.

    if (!me.initialized || !scheduler.isEngineReady && !scheduler.isCreating) {
      return;
    } // Update current time range, reflecting the change on the vertical time axis header


    if (!_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isEqual(topDate, me.topDate) || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isEqual(bottomDate, me.bottomDate)) {
      // Calculated values used by `renderResource()`
      me.topDate = topDate;
      me.bottomDate = bottomDate;
      me.topDateMS = topDate.getTime();
      me.bottomDateMS = bottomDate.getTime();
      const range = me.timeView.range = {
        startDate: topDate,
        endDate: bottomDate
      };
      scheduler.onVisibleDateRangeChange(range);
      scheduler.trigger('visibleRangeChange', range);
    }

    if (firstResource !== -1 && lastResource !== -1) {
      // Collect all events for resources in view
      for (let i = firstResource; i <= lastResource; i++) {
        syncConfigs.push.apply(syncConfigs, me.renderResource(resourceStore.getAt(i)));
      }
    }

    scheduler.getForegroundDomConfigs(featureDomConfigs);
    syncConfigs.push.apply(syncConfigs, featureDomConfigs);
    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync({
      domConfig: {
        onlyChildren: true,
        children: syncConfigs
      },
      targetElement: scheduler.foregroundCanvas,
      syncIdField: 'syncId',

      // Called by DomHelper when it creates, releases or reuses elements
      callback({
        action,
        domConfig,
        lastDomConfig,
        targetElement
      }) {
        // If element is an event wrap, trigger appropriate events
        if (me.isEventElement(domConfig)) {
          const // Some actions are considered first a release and then a render (reusing another element).
          // This gives clients code a chance to clean up before reusing an element
          isRelease = releaseEventActions[action],
                isRender = renderEventActions[action]; // If we are reusing an element that was previously released we should not trigger again

          if (isRelease && me.isEventElement(lastDomConfig) && !lastDomConfig.isReleased) {
            const data = lastDomConfig.elementData.renderData,
                  event = {
              renderData: data,
              assignmentRecord: data.assignmentRecord,
              eventRecord: data.eventRecord,
              resourceRecord: data.resourceRecord,
              element: targetElement
            }; // Some browsers do not blur on set to display:none, so releasing the active element
            // must *explicitly* move focus outwards to the view.

            if (targetElement === _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(targetElement)) {
              scheduler.focusElement.focus();
            } // This event is documented on Scheduler


            scheduler.trigger('releaseEvent', event);
          }

          if (isRender) {
            const data = domConfig.elementData.renderData,
                  event = {
              renderData: data,
              tplData: data,
              // DEPRECATED IN 4.0
              assignmentRecord: data.assignmentRecord,
              eventRecord: data.eventRecord,
              resourceRecord: data.resourceRecord,
              element: targetElement,
              isReusingElement: action === 'reuseElement',
              isRepaint: action === 'reuseOwnElement'
            };
            event.reusingElement = action === 'reuseElement'; // This event is documented on Scheduler

            scheduler.trigger('renderEvent', event);
          }
        }
      }

    }); // Change in displayed resources?

    if (me.firstResource !== firstResource || me.lastResource !== lastResource) {
      // Update header to match
      const range = me.resourceColumns.visibleResources = {
        firstResource,
        lastResource
      }; // Store which resources are currently in view

      me.firstResource = firstResource;
      me.lastResource = lastResource;
      scheduler.onVisibleResourceRangeChange(range);
      scheduler.trigger('resourceRangeChange', range);
    }
  }

  refresh(transition) {
    this.scheduler.runWithTransition(() => this.renderer(), transition);
  } // To match horizontals API, used from EventDrag


  refreshResources(resourceIds) {
    this.clearResources(resourceIds);
    this.refresh();
  } //endregion
  //region Other


  get timeView() {
    return this.scheduler.timeView;
  } //endregion
  //region Cache
  // Clears cached resource layout


  clearResources(resourceIds) {
    const {
      resourceMap,
      eventMap
    } = this;
    resourceIds.forEach(resourceId => {
      if (resourceMap.has(resourceId)) {
        // The *keys* of an Object are strings, so we must iterate the values
        // and use the original eventId to look up in the Map which preserves key type.
        Object.values(resourceMap.get(resourceId)).forEach(({
          renderData: {
            eventId
          }
        }) => {
          delete eventMap.get(eventId)[resourceId];
        });
        resourceMap.delete(resourceId);
      }
    });
  }

  clearAll() {
    this.resourceMap.clear();
    this.eventMap.clear();
  } //endregion


}
VerticalRendering._$name = 'VerticalRendering';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js":
/*!**********************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceConfirmationPopup; });
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/recurrence/RecurrenceConfirmationPopup
 */

/**
 * Confirmation dialog showing up before modifying a recurring event or some of its occurrences.
 * For recurring events the dialog notifies user that the event change/removal will cause all its occurrences
 * change/removal and asks to confirm the action.
 *
 * And for occurrences the dialog allows to choose if user wants to affect all further occurrences, this occurrence only or cancel the change.
 *
 * Usage example:
 *
 * ```javascript
 * const confirmation = new RecurrenceConfirmationPopup();
 *
 * confirmation.confirm({
 *     eventRecord : recurringEvent,
 *     actionType  : "delete",
 *     changerFn   : () => recurringEvent.remove(event)
 * });
 * ```
 *
 * @classType recurrenceconfirmation
 * @extends Core/widget/Popup
 */

class RecurrenceConfirmationPopup extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceConfirmationPopup';
  } // Factoryable type name


  static get type() {
    return 'recurrenceconfirmation';
  }

  static get defaultConfig() {
    return {
      localizableProperties: [],
      align: 'b-t',
      autoShow: false,
      autoClose: false,
      closeAction: 'onRecurrenceClose',
      modal: true,
      centered: true,
      scrollAction: 'realign',
      constrainTo: window,
      draggable: true,
      closable: true,
      floating: true,
      eventRecord: null,
      cls: 'b-sch-recurrenceconfirmation',
      bbar: {
        defaults: {
          localeClass: this
        },
        items: {
          changeMultipleButton: {
            weight: 100,
            color: 'b-green',
            text: 'L{Object.Yes}',
            onClick: 'up.onChangeMultipleButtonClick'
          },
          changeSingleButton: {
            weight: 200,
            color: 'b-gray',
            text: 'L{update-only-this-btn-text}',
            onClick: 'up.onChangeSingleButtonClick'
          },
          cancelButton: {
            weight: 300,
            color: 'b-gray',
            text: 'L{Object.Cancel}',
            onClick: 'up.onCancelButtonClick'
          }
        }
      }
    };
  }
  /**
   * Reference to the "Apply changes to multiple occurrences" button, if used
   * @property {Core.widget.Button}
   * @readonly
   */


  get changeMultipleButton() {
    return this.widgetMap.changeMultipleButton;
  }
  /**
   * Reference to the button that causes changing of the event itself only, if used
   * @property {Core.widget.Button}
   * @readonly
   */


  get changeSingleButton() {
    return this.widgetMap.changeSingleButton;
  }
  /**
   * Reference to the cancel button, if used
   * @property {Core.widget.Button}
   * @readonly
   */


  get cancelButton() {
    return this.widgetMap.cancelButton;
  }
  /**
   * Handler for "Apply changes to multiple occurrences" {@link #property-changeMultipleButton button}.
   * It calls {@link #function-processMultipleRecords} and then hides the dialog.
   */


  onChangeMultipleButtonClick() {
    this.processMultipleRecords();
    this.hide();
  }
  /**
   * Handler for the {@link #property-changeSingleButton button} that causes changing of the event itself only.
   * It calls {@link #function-processSingleRecord} and then hides the dialog.
   */


  onChangeSingleButtonClick() {
    this.processSingleRecord();
    this.hide();
  }
  /**
   * Handler for {@link #property-cancelButton cancel button}.
   * It calls `cancelFn` provided to {@link #function-confirm} call and then hides the dialog.
   */


  onCancelButtonClick() {
    this.cancelFn && this.cancelFn.call(this.thisObj);
    this.hide();
  }

  onRecurrenceClose() {
    if (this.cancelFn) {
      this.cancelFn.call(this.thisObj);
    }

    this.hide();
  }
  /**
   * Displays the confirmation.
   * Usage example:
   *
   * ```javascript
   * const popup = new RecurrenceConfirmationPopup();
   *
   * popup.confirm({
   *     eventRecord,
   *     actionType : "delete",
   *     changerFn  : () => eventStore.remove(record)
   * });
   * ```
   *
   * @param {Object}                     config               The following config options are supported:
   * @param {Scheduler.model.EventModel} config.eventRecord   Event being modified.
   * @param {String}                     config.actionType    Type of modification to be applied to the event. Can be either "update" or "delete".
   * @param {Function}                   config.changerFn     A function that should be called to apply the change to the event upon user choice.
   * @param {Function}                   [config.thisObj]     `changerFn` and `cancelFn` functions scope.
   * @param {Function}                   [config.cancelFn]    Function called on `Cancel` button click.
   */


  confirm(config = {}) {
    const me = this;
    ['actionType', 'eventRecord', 'title', 'html', 'changerFn', 'cancelFn', 'thisObj'].forEach(prop => {
      if (prop in config) me[prop] = config[prop];
    });
    me.updatePopupContent();
    return super.show(config);
  }

  updatePopupContent() {
    const me = this,
          {
      changeMultipleButton,
      changeSingleButton,
      cancelButton
    } = me.widgetMap,
          {
      eventRecord,
      actionType = 'update'
    } = me,
          isMaster = eventRecord && eventRecord.isRecurring; // Do not remove. Assertion strings for Localization sanity check.
    // 'L{delete-further-message}'
    // 'L{update-further-message}'
    // 'L{delete-all-message}'
    // 'L{update-all-message}'
    // 'L{delete-further-btn-text}'
    // 'L{update-further-btn-text}'
    // 'L{delete-only-this-btn-text}'
    // 'L{update-only-this-btn-text}'

    if (isMaster) {
      changeMultipleButton.text = me.L('L{Object.Yes}');
      me.html = me.L(`${actionType}-all-message`);
    } else {
      changeMultipleButton.text = me.L(`${actionType}-further-btn-text`);
      me.html = me.L(`${actionType}-further-message`);
    }

    changeSingleButton.text = me.L(`${actionType}-only-this-btn-text`);
    cancelButton.text = me.L('L{Object.Cancel}'); // TODO: so far we hide 'Only this event' option for a recurring event itself until this case is supported

    if (isMaster) {
      changeSingleButton.hide();
    } else {
      changeSingleButton.show();
    }

    me.width = me.L('L{width}'); // the following lines are added to satisfy the 904_unused localization test
    // to let it know that these locales are used:
    // this.L('L{delete-title}') not found
    // this.L('L{update-title}') not found

    me.title = me.L(`${actionType}-title`);
  }
  /**
   * Applies changes to multiple occurrences as reaction on "Apply changes to multiple occurrences"
   * {@link #property-changeMultipleButton button} click.
   */


  processMultipleRecords() {
    const {
      eventRecord,
      changerFn,
      thisObj
    } = this;
    eventRecord.beginBatch(); // Apply changes to the occurrence.
    // It is not joined to any stores, so this has no consequence.

    this.callback(changerFn, thisObj, [eventRecord]); // afterChange will promote it to being an new recurring base because there's still recurrence

    eventRecord.endBatch();
  }
  /**
   * Applies changes to a single record by making it a "real" event and adding an exception to the recurrence.
   * The method is called as reaction on clicking the {@link #property-changeSingleButton button} that causes changing of the event itself only.
   */


  processSingleRecord() {
    const {
      eventRecord,
      changerFn,
      thisObj
    } = this;
    eventRecord.beginBatch(); // When the changes apply, because there's no recurrence, it will become an exception

    eventRecord.recurrence = null; // Apply changes to the occurrence.
    // It is not joined to any stores, so this has no consequence.

    this.callback(changerFn, thisObj, [eventRecord]); // Must also change after the callback in case the callback sets the rule.
    // This will update the batch update data block to prevent it being set back to recurring.

    eventRecord.recurrenceRule = null; // afterChange will promote it to being an exception because there's no recurrence

    eventRecord.endBatch();
  }

  updateLocalization() {
    this.updatePopupContent();
    super.updateLocalization();
  }

}
; // Register this widget type with its Factory

RecurrenceConfirmationPopup.initClass();
RecurrenceConfirmationPopup._$name = 'RecurrenceConfirmationPopup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceEditor.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceEditor; });
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./field/RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");
/* harmony import */ var _field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./field/RecurrenceDaysCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js");
/* harmony import */ var _field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./field/RecurrenceDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js");
/* harmony import */ var _field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./field/RecurrenceMonthDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js");
/* harmony import */ var _field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./field/RecurrenceMonthsButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js");
/* harmony import */ var _field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./field/RecurrenceStopConditionCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js");
/* harmony import */ var _field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./field/RecurrencePositionsCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js");
var productName = 'gantt';














/**
 * @module Scheduler/view/recurrence/RecurrenceEditor
 */

/**
 * Class implementing a dialog to edit {@link Scheduler.model.RecurrenceModel Recurrence model}.
 * The class is used by the {@link Scheduler.view.mixin.RecurringEvents recurring events} feature and you don't need to instantiate it normally.
 * Before showing the dialog need to use {@link Core.widget.Container#property-record} to load a {@link Scheduler.model.RecurrenceModel Recurrence model}
 * data into the editor fields. For example:
 *
 * ```javascript
 * // make the editor instance
 * const editor = new RecurrenceEditor();
 * // load recurrence model into it
 * editor.record = new RecurrenceModel({ frequency : "WEEKLY" });
 * // display the editor
 * editor.show();
 * ```
 *
 * @extends Core/widget/Popup
 * @classType recurrenceeditor
 */

class RecurrenceEditor extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'RecurrenceEditor';
  } // Factoryable type name


  static get type() {
    return 'recurrenceeditor';
  }

  static get configurable() {
    return {
      draggable: true,
      closable: true,
      floating: true,
      cls: 'b-recurrenceeditor',
      title: 'L{Repeat event}',
      autoClose: true,
      width: 470,
      defaults: {
        localeClass: this
      },
      items: {
        frequencyField: {
          type: 'recurrencefrequencycombo',
          name: 'frequency',
          label: 'L{Frequency}',
          weight: 10,
          onChange: 'up.onFrequencyFieldChange'
        },
        intervalField: {
          type: 'numberfield',
          weight: 15,
          name: 'interval',
          label: 'L{Every}',
          min: 1,
          required: true
        },
        daysButtonField: {
          type: 'recurrencedaysbuttongroup',
          weight: 20,
          name: 'days',
          forFrequency: 'WEEKLY'
        },
        // the radio button enabling "monthDaysButtonField" in MONTHLY mode
        monthDaysRadioField: {
          type: 'checkbox',
          weight: 30,
          toggleGroup: 'radio',
          forFrequency: 'MONTHLY',
          label: 'L{Each}',
          checked: true,
          onChange: 'up.onMonthDaysRadioFieldChange'
        },
        monthDaysButtonField: {
          type: 'recurrencemonthdaysbuttongroup',
          weight: 40,
          name: 'monthDays',
          forFrequency: 'MONTHLY'
        },
        monthsButtonField: {
          type: 'recurrencemonthsbuttongroup',
          weight: 50,
          name: 'months',
          forFrequency: 'YEARLY'
        },
        // the radio button enabling positions & days combos in MONTHLY & YEARLY modes
        positionAndDayRadioField: {
          type: 'checkbox',
          weight: 60,
          toggleGroup: 'radio',
          forFrequency: 'MONTHLY|YEARLY',
          label: 'L{On the}',
          onChange: 'up.onPositionAndDayRadioFieldChange'
        },
        positionsCombo: {
          type: 'recurrencepositionscombo',
          weight: 80,
          name: 'positions',
          forFrequency: 'MONTHLY|YEARLY'
        },
        daysCombo: {
          type: 'recurrencedayscombo',
          weight: 90,
          name: 'days',
          forFrequency: 'MONTHLY|YEARLY',
          flex: 1
        },
        stopRecurrenceField: {
          type: 'recurrencestopconditioncombo',
          weight: 100,
          label: 'L{End repeat}',
          onChange: 'up.onStopRecurrenceFieldChange'
        },
        countField: {
          type: 'numberfield',
          weight: 110,
          name: 'count',
          min: 2,
          required: true,
          disabled: true,
          label: ' '
        },
        endDateField: {
          type: 'datefield',
          weight: 120,
          name: 'endDate',
          hidden: true,
          disabled: true,
          label: ' ',
          required: true
        }
      },
      bbar: {
        defaults: {
          localeClass: this
        },
        items: {
          foo: {
            type: 'widget',
            cls: 'b-label-filler',
            weight: 100
          },
          saveButton: {
            color: 'b-green',
            text: 'L{Save}',
            onClick: 'up.onSaveClick',
            weight: 200
          },
          cancelButton: {
            color: 'b-gray',
            text: 'L{Object.Cancel}',
            onClick: 'up.onCancelClick',
            weight: 300
          }
        }
      }
    };
  }

  updateReadOnly(readOnly) {
    super.updateReadOnly(readOnly); // No save or cancel buttons. It's purely for information display when in readOnly mode

    this.bbar.hidden = readOnly;
  }

  updateRecord(record) {
    super.updateRecord(record);
    const me = this,
          event = record.timeSpan,
          startDate = event && event.startDate,
          {
      daysButtonField,
      monthDaysButtonField,
      monthsButtonField,
      monthDaysRadioField,
      positionAndDayRadioField,
      stopRecurrenceField
    } = me.widgetMap; // some fields default values are calculated based on event "startDate" value

    if (startDate) {
      // if no "days" value provided
      if (!record.days || !record.days.length) {
        daysButtonField.value = [_data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeDay(startDate.getDay())];
      } // if no "monthDays" value provided


      if (!record.monthDays || !record.monthDays.length) {
        monthDaysButtonField.value = startDate.getDate();
      } // if no "months" value provided


      if (!record.months || !record.months.length) {
        monthsButtonField.value = startDate.getMonth() + 1;
      }
    } // if the record has both "days" & "positions" fields set check "On the" checkbox


    if (record.days && record.positions) {
      positionAndDayRadioField.check(); // TODO: if toggleGroup members are not painted automatic unchecking doesn't work

      if (!me.isPainted) {
        monthDaysRadioField.uncheck();
      }
    } else {
      monthDaysRadioField.check(); // TODO: if toggleGroup members are not painted automatic unchecking doesn't work

      if (!me.isPainted) {
        positionAndDayRadioField.uncheck();
      }
    }

    stopRecurrenceField.recurrence = record;
  }

  onSaveClick() {
    const me = this;

    if (me.saveHandler) {
      me.saveHandler.call(me.thisObj || me, me, me.record);
    } else {
      me.syncEventRecord();
      me.close();
    }
  }

  onCancelClick() {
    const me = this;

    if (me.cancelHandler) {
      me.cancelHandler.call(me.thisObj || me, me, me.record);
    } else {
      me.close();
    }
  }
  /**
   * Updates the provided recurrence model with the contained form data.
   * If recurrence model is not provided updates the last loaded recurrence model.
   */


  syncEventRecord(recurrence) {
    // get values relevant to the RecurrenceModel (from enabled fields only)
    const values = this.getValues(w => w.name in recurrence && !w.disabled);
    recurrence.set(values);
  }

  toggleStopFields() {
    const me = this,
          {
      countField,
      endDateField
    } = me.widgetMap;

    switch (me.widgetMap.stopRecurrenceField.value) {
      case 'count':
        countField.show();
        countField.enable();
        endDateField.hide();
        endDateField.disable();
        break;

      case 'date':
        countField.hide();
        countField.disable();
        endDateField.show();
        endDateField.enable();
        break;

      default:
        countField.hide();
        endDateField.hide();
        countField.disable();
        endDateField.disable();
    }
  }

  onMonthDaysRadioFieldChange({
    checked
  }) {
    const {
      monthDaysButtonField
    } = this.widgetMap;
    monthDaysButtonField.disabled = !checked || !this.isWidgetAvailableForFrequency(monthDaysButtonField);
  }

  onPositionAndDayRadioFieldChange({
    checked
  }) {
    const {
      daysCombo,
      positionsCombo
    } = this.widgetMap; // toggle day & positions combos

    daysCombo.disabled = positionsCombo.disabled = !checked || !this.isWidgetAvailableForFrequency(daysCombo);
  }

  onStopRecurrenceFieldChange() {
    this.toggleStopFields();
  }

  isWidgetAvailableForFrequency(widget, frequency = this.widgetMap.frequencyField.value) {
    return !widget.forFrequency || widget.forFrequency.indexOf(frequency) > -1;
  }

  onFrequencyFieldChange({
    value,
    valid
  }) {
    const me = this,
          items = me.queryAll(w => 'forFrequency' in w);

    if (valid && value) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (me.isWidgetAvailableForFrequency(item, value)) {
          item.show();
          item.enable();
        } else {
          item.hide();
          item.disable();
        }
      } // The following lines are added to satisfy the 904_unused localization test
      // to let it know that these locales are used:
      // this.L('L{DAILYintervalUnit}')
      // this.L('L{WEEKLYintervalUnit}')
      // this.L('L{MONTHLYintervalUnit}')
      // this.L('L{YEARLYintervalUnit}')


      me.widgetMap.intervalField.hint = me.L(`${value}intervalUnit`);
      me.toggleFieldsState();
    }
  }

  toggleFieldsState() {
    const me = this,
          {
      widgetMap
    } = this;
    me.onMonthDaysRadioFieldChange({
      checked: widgetMap.monthDaysRadioField.checked
    });
    me.onPositionAndDayRadioFieldChange({
      checked: widgetMap.positionAndDayRadioField.checked
    });
    me.onStopRecurrenceFieldChange();
  }

  updateLocalization() {
    // do extra labels translation (not auto-translated yet)
    const {
      countField,
      intervalField,
      frequencyField
    } = this.widgetMap;
    countField.hint = this.L('L{time(s)}');

    if (frequencyField.value) {
      intervalField.hint = this.L(`${frequencyField.value}intervalUnit`);
    }

    super.updateLocalization();
  }

} // Register this widget type with its Factory

RecurrenceEditor.initClass();
RecurrenceEditor._$name = 'RecurrenceEditor';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js":
/*!*****************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceLegendButton; });
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../data/util/recurrence/RecurrenceLegend.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/recurrence/RecurrenceLegendButton
 */

/**
 * Class implementing a button which text displays the associated recurrence info in a human readable form.
 * @extends Core/widget/Button
 * @classType recurrencelegendbutton
 */

class RecurrenceLegendButton extends _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceLegendButton';
  } // Factoryable type name


  static get type() {
    return 'recurrencelegendbutton';
  }

  static get defaultConfig() {
    return {
      localizableProperties: [],
      recurrence: null
    };
  }
  /**
   * Sets / gets the recurrence to display description for.
   * @property {Scheduler.model.RecurrenceModel}
   */


  set recurrence(recurrence) {
    this._recurrence = recurrence;
    this.updateLegend();
  }

  get recurrence() {
    return this._recurrence;
  }

  set eventStartDate(eventStartDate) {
    this._eventStartDate = eventStartDate;
    this.updateLegend();
  }

  get eventStartDate() {
    return this._eventStartDate;
  }

  updateLegend() {
    const me = this,
          {
      recurrence
    } = me;
    me.text = recurrence ? _data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_1__["default"].getLegend(recurrence, me.eventStartDate) : '';
  }

  onLocaleChange() {
    // on locale switch we update the button text to use proper language
    this.updateLegend();
  }

  updateLocalization() {
    this.onLocaleChange();
    super.updateLocalization();
  }

} // Register this widget type with its Factory

RecurrenceLegendButton.initClass();
RecurrenceLegendButton._$name = 'RecurrenceLegendButton';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js":
/*!****************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceCombo; });
/* harmony import */ var _RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");
var productName = 'gantt';

/**
 * @module Scheduler/view/recurrence/field/RecurrenceCombo
 */

/**
 * A combobox field displaying the recurrence by either mode: `Daily`, `Weekly`, `Monthly` or `Yearly` if the recurrence
 * has no other non-default settings, or `Custom...` if the recurrence has custom setting applied.
 *
 * @extends Scheduler/view/recurrence/field/RecurrenceFrequencyCombo
 * @classType recurrencecombo
 */

class RecurrenceCombo extends _RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceCombo';
  } // Factoryable type name


  static get type() {
    return 'recurrencecombo';
  }

  static get defaultConfig() {
    return {
      customValue: 'custom',
      placeholder: 'None',
      // TODO: draw a splitting line
      splitCls: 'b-recurrencecombo-split',
      items: true,
      highlightExternalChange: false
    };
  }

  buildLocalizedItems() {
    const me = this;
    return [{
      value: 'none',
      text: me.L('L{None}')
    }, ...super.buildLocalizedItems(), {
      value: me.customValue,
      text: me.L('L{Custom}'),
      cls: me.splitCls
    }];
  }

  set value(value) {
    // Use 'none' instead of falsy value
    value = value || 'none';
    super.value = value;
  }

  get value() {
    return super.value;
  }

  set recurrence(recurrence) {
    const me = this;

    if (recurrence) {
      me.value = me.isCustomRecurrence(recurrence) ? me.customValue : recurrence.frequency;
    } else {
      me.value = null;
    }
  }

  isCustomRecurrence(recurrence) {
    const {
      interval,
      days,
      monthDays,
      months
    } = recurrence;
    return Boolean(interval > 1 || days && days.length || monthDays && monthDays.length || months && months.length);
  }

}
; // Register this widget type with its Factory

RecurrenceCombo.initClass();
RecurrenceCombo._$name = 'RecurrenceCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js":
/*!**************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDaysButtonGroup; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'gantt';



/**
 * @module Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup
 */

/**
 * A segmented button field allowing to pick days for the "Weekly" mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

class RecurrenceDaysButtonGroup extends _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'RecurrenceDaysButtonGroup';
  } // Factoryable type name


  static get type() {
    return 'recurrencedaysbuttongroup';
  }

  static get defaultConfig() {
    return {
      defaults: {
        cls: 'b-raised',
        toggleable: true
      }
    };
  }

  construct(config = {}) {
    const me = this;
    config.columns = 7;
    config.items = me.buildItems();
    super.construct(config);
  }

  updateItemText(item) {
    const day = _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decodeDay(item.value)[0];
    item.text = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getDayName(day).substring(0, 3);
  }

  buildItems() {
    const me = this;

    if (!me.__items) {
      const weekStartDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].weekStartDay;
      const dayNames = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getDayNames().map((text, index) => ({
        text: text.substring(0, 3),
        value: _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeDay(index)
      })); // we should start week w/ weekStartDay

      me.__items = dayNames.slice(weekStartDay).concat(dayNames.slice(0, weekStartDay));
    }

    return me.__items;
  }

  set value(value) {
    if (value && Array.isArray(value)) {
      value = value.join(',');
    }

    super.value = value;
  }

  get value() {
    let value = super.value;

    if (value && Array.isArray(value)) {
      value = value.join(',');
    }

    return value; // return value ? value.split(',') : [];
  }

  onLocaleChange() {
    // update button texts on locale switch
    this.items.forEach(this.updateItemText, this);
  }

  updateLocalization() {
    this.onLocaleChange();
    super.updateLocalization();
  }

  get widgetClassList() {
    const classList = super.widgetClassList; // to look more like a real field

    classList.push('b-field');
    return classList;
  }

}
; // Register this widget type with its Factory

RecurrenceDaysButtonGroup.initClass();
RecurrenceDaysButtonGroup._$name = 'RecurrenceDaysButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js":
/*!********************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDaysCombo; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
var productName = 'gantt';




/**
 * @module Scheduler/view/recurrence/field/RecurrenceDaysCombo
 */

/**
 * A combobox field allowing to pick days for the `Monthly` and `Yearly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencedayscombo
 */

class RecurrenceDaysCombo extends Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'RecurrenceDaysCombo';
  } // Factoryable type name


  static get type() {
    return 'recurrencedayscombo';
  }

  static get defaultConfig() {
    const allDaysValueAsArray = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'],
          allDaysValue = allDaysValueAsArray.join(',');
    return {
      allDaysValue,
      editable: false,
      defaultValue: allDaysValue,
      workingDaysValue: allDaysValueAsArray.filter((day, index) => !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].nonWorkingDays[index]).join(','),
      nonWorkingDaysValue: allDaysValueAsArray.filter((day, index) => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].nonWorkingDays[index]).join(','),
      splitCls: 'b-recurrencedays-split',
      displayField: 'text',
      valueField: 'value'
    };
  }

  buildLocalizedItems() {
    const me = this;
    me._weekDays = null;
    return me.weekDays.concat([{
      value: me.allDaysValue,
      text: me.L('L{day}'),
      cls: me.splitCls
    }, {
      value: me.workingDaysValue,
      text: me.L('L{weekday}')
    }, {
      value: me.nonWorkingDaysValue,
      text: me.L('L{weekend day}')
    }]);
  }

  get weekDays() {
    const me = this;

    if (!me._weekDays) {
      const weekStartDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].weekStartDay;
      const dayNames = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getDayNames().map((text, index) => ({
        text,
        value: _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeDay(index)
      })); // we should start week w/ weekStartDay

      me._weekDays = dayNames.slice(weekStartDay).concat(dayNames.slice(0, weekStartDay));
    }

    return me._weekDays;
  }

  set value(value) {
    const me = this;

    if (value && Array.isArray(value)) {
      value = value.join(',');
    } // if the value has no matching option in the store we need to use default value


    if (!value || !me.store.findRecord('value', value)) {
      value = me.defaultValue;
    }

    super.value = value;
  }

  get value() {
    let value = super.value;

    if (value && Array.isArray(value)) {
      value = value.join(',');
    }

    return value;
  }

} // Register this widget type with its Factory

RecurrenceDaysCombo.initClass();
RecurrenceDaysCombo._$name = 'RecurrenceDaysCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceFrequencyCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/recurrence/field/RecurrenceFrequencyCombo
 */

/**
 * A combobox field allowing to pick frequency in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencefrequencycombo
 */

class RecurrenceFrequencyCombo extends Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurrenceFrequencyCombo';
  } // Factoryable type name


  static get type() {
    return 'recurrencefrequencycombo';
  }

  static get defaultConfig() {
    return {
      editable: false,
      displayField: 'text',
      valueField: 'value'
    };
  }

  buildLocalizedItems() {
    return [{
      value: 'DAILY',
      text: this.L('L{Daily}')
    }, {
      value: 'WEEKLY',
      text: this.L('L{Weekly}')
    }, {
      value: 'MONTHLY',
      text: this.L('L{Monthly}')
    }, {
      value: 'YEARLY',
      text: this.L('L{Yearly}')
    }];
  }

}
; // Register this widget type with its Factory

RecurrenceFrequencyCombo.initClass();
RecurrenceFrequencyCombo._$name = 'RecurrenceFrequencyCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js":
/*!*******************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceMonthDaysButtonGroup; });
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
var productName = 'gantt';

/**
 * A segmented button field allowing to pick month days for the `Monthly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

class RecurrenceMonthDaysButtonGroup extends _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceMonthDaysButtonGroup';
  } // Factoryable type name


  static get type() {
    return 'recurrencemonthdaysbuttongroup';
  }

  static get defaultConfig() {
    return {
      defaults: {
        toggleable: true,
        cls: 'b-raised'
      }
    };
  }

  get minValue() {
    return 1;
  }

  get maxValue() {
    return 31;
  }

  construct(config = {}) {
    const me = this;
    config.columns = 7;
    config.items = me.buildItems();
    super.construct(config);
  }

  buildItems() {
    const me = this,
          items = [];

    for (let value = me.minValue; value <= me.maxValue; value++) {
      // button config
      items.push({
        text: value + '',
        value
      });
    }

    return items;
  }

  get widgetClassList() {
    const classList = super.widgetClassList; // to look more like a real field

    classList.push('b-field');
    return classList;
  }

}
; // Register this widget type with its Factory

RecurrenceMonthDaysButtonGroup.initClass();
RecurrenceMonthDaysButtonGroup._$name = 'RecurrenceMonthDaysButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js":
/*!****************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceMonthsButtonGroup; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
var productName = 'gantt';


/**
 * A segmented button field allowing to pick months for the `Yearly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

class RecurrenceMonthsButtonGroup extends _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'RecurrenceMonthsButtonGroup';
  } // Factoryable type name


  static get type() {
    return 'recurrencemonthsbuttongroup';
  }

  static get defaultConfig() {
    return {
      defaults: {
        toggleable: true,
        cls: 'b-raised'
      }
    };
  }

  construct(config = {}) {
    const me = this;
    config.columns = 4;
    config.items = me.buildItems();
    super.construct(config);
  }

  buildItems() {
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getMonthNames().map((item, index) => ({
      text: item.substring(0, 3),
      value: index + 1 // 1-based

    }));
  }

  updateItemText(item) {
    item.text = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getMonthName(item.value - 1).substring(0, 3);
  }

  onLocaleChange() {
    // update button texts on locale switch
    this.items.forEach(this.updateItemText, this);
  }

  updateLocalization() {
    this.onLocaleChange();
    super.updateLocalization();
  }

  get widgetClassList() {
    const classList = super.widgetClassList; // to look more like a real field

    classList.push('b-field');
    return classList;
  }

}
; // Register this widget type with its Factory

RecurrenceMonthsButtonGroup.initClass();
RecurrenceMonthsButtonGroup._$name = 'RecurrenceMonthsButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrencePositionsCombo; });
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
var productName = 'gantt';



/**
 * @module Scheduler/view/recurrence/field/RecurrencePositionsCombo
 */

/**
 * A combobox field allowing to specify day positions in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence editor}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencepositionscombo
 */

class RecurrencePositionsCombo extends Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'RecurrencePositionsCombo';
  } // Factoryable type name


  static get type() {
    return 'recurrencepositionscombo';
  }

  static get defaultConfig() {
    return {
      editable: false,
      splitCls: 'b-sch-recurrencepositions-split',
      displayField: 'text',
      valueField: 'value',
      defaultValue: 1,
      maxPosition: 5
    };
  }

  buildLocalizedItems() {
    const me = this;
    return me.buildDayNumbers().concat([// the following lines are added to satisfy the 904_unused localization test
    // to let it know that these locales are used:
    // this.L('L{position-1}')
    {
      value: '-1',
      text: me.L('L{position-1}'),
      cls: me.splitCls
    }]);
  }

  buildDayNumbers() {
    const me = this; // the following lines are added to satisfy the 904_unused localization test
    // to let it know that these locales are used:
    // this.L('L{position1}')
    // this.L('L{position2}')
    // this.L('L{position3}')
    // this.L('L{position4}')
    // this.L('L{position5}')

    return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].populate(me.maxPosition, i => ({
      value: i + 1,
      text: me.L(`position${i + 1}`)
    }));
  }

  set value(value) {
    const me = this;

    if (value && Array.isArray(value)) {
      value = value.join(',');
    } // if the value has no matching option in the store we need to use default value


    if (!value || !me.store.findRecord('value', value)) {
      value = me.defaultValue;
    }

    super.value = value;
  }

  get value() {
    const value = super.value;
    return value ? `${value}`.split(',').map(item => parseInt(item, 10)) : [];
  }

}
; // Register this widget type with its Factory

RecurrencePositionsCombo.initClass();
RecurrencePositionsCombo._$name = 'RecurrencePositionsCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js":
/*!*****************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceStopConditionCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
var productName = 'gantt';


/**
 * @module Scheduler/view/recurrence/field/RecurrenceStopConditionCombo
 */

/**
 * A combobox field allowing to choose stop condition for the recurrence in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencestopconditioncombo
 */

class RecurrenceStopConditionCombo extends Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurrenceStopConditionCombo';
  } // Factoryable type name


  static get type() {
    return 'recurrencestopconditioncombo';
  }

  static get defaultConfig() {
    return {
      editable: false,
      placeholder: 'Never',
      displayField: 'text',
      valueField: 'value'
    };
  }

  buildLocalizedItems() {
    return [{
      value: 'never',
      text: this.L('L{Never}')
    }, {
      value: 'count',
      text: this.L('L{After}')
    }, {
      value: 'date',
      text: this.L('L{On date}')
    }];
  }

  set value(value) {
    // Use 'never' instead of falsy value
    value = value || 'never';
    super.value = value;
  }

  get value() {
    return super.value;
  }

  get recurrence() {
    return this._recurrence;
  }

  set recurrence(recurrence) {
    let value = null;

    if (recurrence.endDate) {
      value = 'date';
    } else if (recurrence.count) {
      value = 'count';
    }

    this._recurrence = recurrence;
    this.value = value;
  }

}
; // Register this widget type with its Factory

RecurrenceStopConditionCombo.initClass();
RecurrenceStopConditionCombo._$name = 'RecurrenceStopConditionCombo';

/***/ }),

/***/ "./lib/Scheduler/widget/ResourceCombo.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/widget/ResourceCombo.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'gantt';


/**
 * @module Scheduler/widget/ResourceCombo
 */

/**
 * Combo subclass which selects resources, highlighting the `eventColor` of each resource in
 * the picker and in the input area.
 *
 * @extends Core/widget/Combo
 * @classType resourceCombo
 */

class ResourceCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceCombo';
  } // Factoryable type name


  static get type() {
    return 'resourcecombo';
  }

  static get configurable() {
    return {
      showEventColor: false,
      picker: {
        cls: 'b-resourcecombo-picker',

        itemIconTpl(record, i) {
          const {
            eventColor
          } = record,
                isStyleColor = !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNamedColor(eventColor),
                style = eventColor ? isStyleColor ? ` style="color:${eventColor}"` : '' : ' style="display:none"',
                colorClass = !eventColor || isStyleColor ? '' : ` b-sch-foreground-${eventColor}`;
          return `<div class="b-icon b-icon-square${colorClass}"${style}></div>`;
        }

      }
    };
  }

  changeShowEventColor(showEventColor) {
    return Boolean(showEventColor);
  }

  updateShowEventColor(showEventColor) {
    const {
      _picker
    } = this,
          methodName = showEventColor ? 'add' : 'remove';
    this.element.classList[methodName]('b-show-event-color');
    _picker === null || _picker === void 0 ? void 0 : _picker.element.classList[methodName]('b-show-event-color');
  }

  changePicker(picker, oldPicker) {
    var _picker2;

    picker = super.changePicker(picker, oldPicker);
    (_picker2 = picker) === null || _picker2 === void 0 ? void 0 : _picker2.element.classList[this.showEventColor ? 'add' : 'remove']('b-show-event-color');
    return picker;
  } // Implementation needed at this level because it has two inner elements in its inputWrap


  get innerElements() {
    return [{
      class: 'b-icon b-resource-icon b-icon-square b-hide-display',
      reference: 'resourceIcon'
    }, this.inputElement];
  }

  syncInputFieldValue() {
    var _me$selected$eventCol, _me$selected;

    const me = this,
          {
      resourceIcon,
      lastResourceIconCls
    } = me,
          {
      classList
    } = resourceIcon,
          eventColor = (_me$selected$eventCol = (_me$selected = me.selected) === null || _me$selected === void 0 ? void 0 : _me$selected.eventColor) !== null && _me$selected$eventCol !== void 0 ? _me$selected$eventCol : '';
    super.syncInputFieldValue(); // Remove last colour whichever way it was done

    resourceIcon.style.color = '';
    lastResourceIconCls && classList.remove(lastResourceIconCls);
    me.lastResourceIconCls = null;

    if (eventColor) {
      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNamedColor(eventColor)) {
        me.lastResourceIconCls = `b-sch-foreground-${eventColor}`;
        classList.add(me.lastResourceIconCls);
      } else {
        resourceIcon.style.color = eventColor;
      }

      classList.remove('b-hide-display');
    } else {
      classList.add('b-hide-display');
    }
  }

} // Register this widget type with its Factory

ResourceCombo.initClass();
ResourceCombo._$name = 'ResourceCombo';

/***/ }),

/***/ "./lib/Scheduler/widget/ResourceFilter.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/widget/ResourceFilter.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceFilter; });
/* harmony import */ var _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';





/**
 * @module Scheduler/widget/ResourceFilter
 */

/**
 * A List which allows selection of resources to filter a specified eventStore to only show
 * events for the selected resources.
 *
 * Because this widget maintains a state that can be changed through the UI, it offers some of the
 * API of an input field. It has a read only {@link #property-value} property, and it fires a
 * {@link #event-change} event.
 *
 * @extends Core/widget/List
 * @classType resourceFilter
 */

class ResourceFilter extends _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceFilter';
  } // Factoryable type name


  static get type() {
    return 'resourcefilter';
  }

  static get delayable() {
    return {
      applyFilter: 'raf'
    };
  }

  static get configurable() {
    return {
      /**
       * The {@link Scheduler.data.EventStore EventStore} to filter.
       * Events for resources which are deselected in this List will be filtered out.
       * @config {Scheduler.data.EventStore}
       */
      eventStore: null,
      multiSelect: true,
      toggleAllIfCtrlPressed: true,
      itemTpl: record => _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(record.name || ''),

      /**
       * An optional filter function to apply when loading resources from the project's
       * resource store. Defaults to loading all resources.
       *
       * **This is called using this `ResourceFilter` as the `this` object.**
       * @config {Function}
       * @default
       */
      masterFilter: () => true
    };
  }

  itemIconTpl(record, i) {
    const {
      eventColor
    } = record,
          // Named colors are applied using CSS
    cls = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isNamedColor(eventColor) ? ` b-sch-foreground-${eventColor}` : '',
          // CSS style color is used as is
    style = !cls && eventColor ? ` style="color:${eventColor}"` : '';
    return this.multiSelect ? `<div class="b-selected-icon b-icon${cls}"${style}></div>` : '';
  }

  updateEventStore(eventStore) {
    var _this$store;

    const {
      resourceStore
    } = eventStore,
          // HACK: Temp workaround until List's store is dynamically updatable
    chainedStoreConfig = this.initialConfig.store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? this.initialConfig.store.initialConfig : (_this$store = this.store) === null || _this$store === void 0 ? void 0 : _this$store.config; // Allow configuration of the filter for loading records from the master store.

    this.store = resourceStore.chain(this.masterFilter, null, _objectSpread(_objectSpread({}, chainedStoreConfig), {}, {
      syncOrder: true
    }));

    if (!resourceStore.count) {
      resourceStore.project.on({
        name: 'project',
        refresh: 'initFilter',
        thisObj: this
      });
    } else {
      this.initFilter();
    }
  }

  changeMasterFilter(masterFilter) {
    // Cannot use bind, otherwise fillFromMaster's check for whether its a filter function fails.
    const me = this;
    return function (r) {
      return masterFilter.call(me, r);
    };
  }

  initFilter() {
    const {
      eventStore
    } = this;

    if (eventStore.count && eventStore.resourceStore.count) {
      this.selected.add(this.store.getRange());
      this.detachListeners('project');
    }
  }

  onSelectionChange({
    source: selected,
    added,
    removed
  }) {
    // Filter disabled if all resources selected
    const me = this,
          disabled = selected.count === me.eventStore.resourceStore.count;
    super.onSelectionChange(...arguments); // If this is the first selection change triggered from the first project refresh
    // in which all the resources are selected, then we don't need to apply the filters.
    // because all resources are selected

    if (!me.resourceFilter) {
      // Our client EventStore is filtered to only show events for our selected resources.
      // Events without an associated resource are filtered into visibility.
      // The addFilter function with silent param adds the filter but don't reevaluate filtering.
      me.resourceFilter = me.eventStore.addFilter({
        id: `${me.id}-filter-instance`,
        filterBy: e => !e.resource || me.selected.includes(e.resources),
        disabled
      }, true);
      return;
    } // Filter disabled if all resources selected


    me.resourceFilter.disabled = disabled; // Have the client EventStore refresh its filtering but after a small delay so the List UI updates immediately.

    me.applyFilter();

    if (me.eventListeners.change) {
      const value = selected.values,
            oldValue = value.concat(removed);
      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].remove(oldValue, added);
      /**
       * Fired when this widget's selection changes
       * @event change
       * @param {String} value - This field's value
       * @param {String} oldValue - This field's previous value
       * @param {Core.widget.Field} source - This ResourceFilter
       */

      me.triggerFieldChange({
        value,
        oldValue
      });
    }
  }
  /**
   * An array encapsulating the currently selected resources.
   * @member {Scheduler.model.ResourceModel[]}
   * @readonly
   */


  get value() {
    return this.selected.values;
  }

  applyFilter() {
    this.eventStore.filter();
  }

} // Register this widget type with its Factory

ResourceFilter.initClass();
ResourceFilter._$name = 'ResourceFilter';

/***/ }),

/***/ "./lib/Scheduler/widget/UndoRedo.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/widget/UndoRedo.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UndoRedo; });
/* harmony import */ var _Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/base/UndoRedoBase.js */ "./lib/Core/widget/base/UndoRedoBase.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';


/**
 * @module Scheduler/widget/UndoRedo
 */

const isProjectConsumer = w => w.isProjectConsumer;
/**
 * A widget which encapsulates undo/redo functionality for the {@link Scheduler.model.ProjectModel project}
 * of a scheduling widget (`Scheduler`, `Gantt` or `Calendar`).
 *
 * To make use of this, the project must be configured with a
 * {@link Scheduler.model.mixin.ProjectModelMixin#config-stm State Tracking Manager}.
 *
 * If inserted into a scheduling widget (such as into a `tbar`, or `bbar`, or as an item in a context menu),
 * the project of the encapsulating scheduling widget will be used.
 *
 * If this widget is to be used "standalone" (rendered into the DOM outside of a scheduling widget),
 * this must be configured with a reference to the project, or the scheduling widget which is
 * using the project.
 *
 * There are three child widgets encapsulated which may be referenced through the {@link Core.widget.Container#property-widgetMap}:
 *
 * - `undoBtn` - The button which operates the undo operation
 * - `transactionsCombo` - A combobox into which is pushed the list of transactions,
 * - `redoBtn` - The button which operates the redo operation
 *
 * The transactionsCombo may be configured away if only the buttons are required:
 *
 * ```javascript
 * {
 *     type      : 'undoredo',
 *     items     : {
 *         transactionsCombo : null
 *     }
 * }
 * ```
 * The example below illustrated how to embed an `undoredo` widget in the top toolbar of a Scheduler.
 * @extends Core/widget/base/UndoRedoBase
 * @classType undoredo
 * @demo Scheduler/undoredo
 * @inlineexample Scheduler/widget/UndoRedo.js
 */


class UndoRedo extends _Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'UndoRedo';
  }

  static get type() {
    return 'undoredo';
  }

  static get configurable() {
    return {
      /**
       * The Scheduling Widget (or its `id`) whose transaction to track.
       *
       * This may be a `Scheduler`, a `Gantt` or a `Calendar`.
       *
       * ```javascript
       *     {
       *         type      : 'undoredo',
       *         scheduler : myCalendar
       *     }
       * ```
       * @config {Core.widget.Widget|String}
       */
      scheduler: null,

      /**
       * The Scheduling {@link Scheduler.model.ProjectModel project}'s whose
       * transaction to track.
       *
       * ```javascript
       *     {
       *         type    : 'undoredo',
       *         project : scheduler.project
       *     }
       * ```
       * @config {Scheduler.model.ProjectModel}
       */
      project: null
    };
  }

  construct() {
    super.construct(...arguments); // Look up a Project owner in our ancestors.

    if (!this.stm) {
      this.scheduler = this.up(isProjectConsumer);
    }
  }

  changeScheduler(scheduler) {
    return scheduler.isProjectConsumer ? scheduler : UndoRedo.getById(scheduler);
  }

  updateScheduler(scheduler) {
    const {
      crudManager
    } = scheduler;

    if (crudManager) {
      crudManager.on({
        load: 'onCrudManagerLoad',
        thisObj: this
      });
    } // No CrudManager, so it must be inline data, so we can start immediately
    else {
      this.onCrudManagerLoad();
    }

    this.stm = scheduler.project.stm;
  }

  async onCrudManagerLoad() {
    // Do not want normalization changes to be tracked by STM, wait until they are finished before enabling
    await this.scheduler.project.commitAsync(); // Widget could be destroyed during async project commit

    if (!this.isDestroyed) {
      this.stm.enable();
      this.fillUndoRedoCombo();
    }
  }

}
UndoRedo.initClass();
UndoRedo._$name = 'UndoRedo';

/***/ }),

/***/ "./lib/SchedulerPro/column/DurationColumn.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/column/DurationColumn.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DurationColumn; });
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/column/NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/column/DurationColumn
 */

/**
 * A column showing the task {@link Scheduler/model/TimeSpan#property-fullDuration duration}. Please note, this column
 * is preconfigured and expects its field to be of the {@link Core.data.Duration} type.
 *
 * The default editor is a {@link Core.widget.DurationField DurationField}. It parses time units, so you can enter "4d"
 * indicating 4 days duration, or "4h" indicating 4 hours, etc. The numeric magnitude can be either an integer or a
 * float value. Both "," and "." are valid decimal separators. For example, you can enter "4.5d" indicating 4.5 days
 * duration, or "4,5h" indicating 4.5 hours.
 *
 * {@inlineexample SchedulerPro/column/DurationColumn.js}
 * @extends Grid/column/NumberColumn
 * @classType duration
 */

class DurationColumn extends _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'DurationColumn';
  }

  static get type() {
    return 'duration';
  }

  static get isGanttColumn() {
    return true;
  }

  static get fields() {
    return [
    /**
     * Precision of displayed duration, defaults to use {@link SchedulerPro.view.SchedulerPro#config-durationDisplayPrecision}.
     * Specify an integer value to override that setting, or `false` to use raw value
     * @config {Number|Boolean} decimalPrecision
     */
    {
      name: 'decimalPrecision',
      defaultValue: 1
    }];
  }

  static get defaults() {
    return {
      /**
       * Min value
       * @config {Number}
       */
      min: null,

      /**
       * Max value
       * @config {Number}
       */
      max: null,

      /**
       * Step size for spin button clicks.
       * @member {Number} step
       */

      /**
       * Step size for spin button clicks. Also used when pressing up/down keys in the field.
       * @config {Number}
       * @default
       */
      step: 1,

      /**
       * Large step size, defaults to 10 * `step`. Applied when pressing SHIFT and stepping either by click or
       * using keyboard.
       * @config {Number}
       * @default 10
       */
      largeStep: 0,
      field: 'fullDuration',
      text: 'L{Duration}',
      instantUpdate: true,
      // Undocumented, used by Filter feature to get type of the filter field
      filterType: 'duration',

      sortable(durationEntity1, durationEntity2) {
        const ms1 = durationEntity1[this.field],
              ms2 = durationEntity2[this.field];
        return ms1 - ms2;
      }

    };
  }

  construct() {
    super.construct(...arguments);
    const sortFn = this.sortable;

    this.sortable = (...args) => sortFn.call(this, ...args);
  }

  get defaultEditor() {
    const {
      max,
      min,
      step,
      largeStep
    } = this; // Remove any undefined configs, to allow config system to use default values instead

    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].cleanupProperties({
      type: 'duration',
      name: this.field,
      max,
      min,
      step,
      largeStep
    });
  } //endregion
  //region Internal


  get durationUnitField() {
    return `${this.field}Unit`;
  }

  formatValue(duration, durationUnit) {
    if (duration instanceof _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      durationUnit = duration.unit;
      duration = duration.magnitude;
    }

    const nbrDecimals = typeof this.grid.durationDisplayPrecision === 'number' ? this.grid.durationDisplayPrecision : this.decimalPrecision,
          multiplier = Math.pow(10, nbrDecimals),
          rounded = Math.round(duration * multiplier) / multiplier;
    return rounded + ' ' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getLocalizedNameOfUnit(durationUnit, duration !== 1);
  } // * reactiveRenderer() {
  //     const { column : me, record } = this;
  //
  //     return me.formatValue(yield record.$.duration, yield record.$.durationUnit);
  // }
  //endregion
  //region Render


  defaultRenderer({
    record,
    isExport
  }) {
    const value = record[this.field],
          type = typeof value,
          durationValue = type === 'number' ? value : value === null || value === void 0 ? void 0 : value.magnitude,
          durationUnit = type === 'number' ? record[this.durationUnitField] : value === null || value === void 0 ? void 0 : value.unit; // in case of bad input (for instance NaN, undefined or NULL value)

    if (typeof durationValue !== 'number') {
      return isExport ? '' : null;
    }

    return this.formatValue(durationValue, durationUnit);
  } //endregion


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerColumnType(DurationColumn);
DurationColumn._$name = 'DurationColumn';

/***/ }),

/***/ "./lib/SchedulerPro/column/ResourceCalendarColumn.js":
/*!***********************************************************!*\
  !*** ./lib/SchedulerPro/column/ResourceCalendarColumn.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceCalendarColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony import */ var _widget_CalendarField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widget/CalendarField.js */ "./lib/SchedulerPro/widget/CalendarField.js");
var productName = 'gantt';




/**
 * @module SchedulerPro/column/ResourceCalendarColumn
 */

/**
 * A column that displays (and allows user to update) the current {@link SchedulerPro.model.CalendarModel calendar} of
 * the resource.
 *
 * Default editor is a {@link SchedulerPro.widget.CalendarField CalendarField}.
 *
 * {@inlineexample SchedulerPro/column/ResourceCalendarColumn.js}
 * @mixes Scheduler/data/mixin/AttachToProjectMixin
 * @extends Grid/column/Column
 * @classType resourceCalendar
 */

class ResourceCalendarColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'ResourceCalendarColumn';
  }

  static get type() {
    return 'resourceCalendar';
  }

  static get defaults() {
    return {
      field: 'calendar',
      text: 'Calendar',
      editor: {
        type: _widget_CalendarField_js__WEBPACK_IMPORTED_MODULE_3__["default"].type,
        clearable: true,
        allowInvalid: false
      }
    };
  } //endregion
  //region Init


  attachToProject(project) {
    if (project) {
      // Store default calendar to filter out this value
      this.defaultCalendar = project.defaultCalendar;
      this.editor.store = project.calendarManagerStore;
    }
  }

  attachToResourceStore(resourceStore) {
    super.attachToResourceStore(resourceStore);

    if (resourceStore) {
      resourceStore.on({
        name: 'resourceStore',
        update: 'onResourceUpdate',
        thisObj: this
      });
    }
  } //endregion
  //region Events
  // Event rendering does not update cells when engine updates a resource, instead we do a minimal update here


  onResourceUpdate({
    record,
    changes
  }) {
    const change = changes[this.field];

    if (change) {
      var _change$value;

      // Ignore "normalization" of id -> instance, wont affect our appearance
      if (typeof change.oldValue === 'string' && ((_change$value = change.value) === null || _change$value === void 0 ? void 0 : _change$value.id) === change.oldValue) {
        return;
      }

      this.refreshCell(record);
    }
  } //endregion
  //region Render


  renderer({
    value
  }) {
    if (value === this.defaultCalendar) {
      return '';
    } else if (value && value.id) {
      const record = this.editor.store.getById(value.id);
      return record && record[this.editor.displayField] || '';
    } else {
      return '';
    }
  } //endregion


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ResourceCalendarColumn);
ResourceCalendarColumn._$name = 'ResourceCalendarColumn';

/***/ }),

/***/ "./lib/SchedulerPro/column/ScaleColumn.js":
/*!************************************************!*\
  !*** ./lib/SchedulerPro/column/ScaleColumn.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScaleColumn; });
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/graph/Scale.js */ "./lib/Core/widget/graph/Scale.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/column/ScaleColumn
 */

/**
 * A specialised column showing a graduated scale from a defined array of values
 * and labels. This column is used in the {@link SchedulerPro.view.ResourceHistogram} and is not editable. Normally
 * you should not need to interact with this class directly.
 *
 * @extends Grid/column/Column
 * @classType scale
 */

class ScaleColumn extends _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ScaleColumn';
  }

  static get type() {
    return 'scale';
  }

  static get isScaleColumn() {
    return true;
  }

  static get fields() {
    return ['scalePoints'];
  }

  static get defaults() {
    return {
      text: '\xa0',
      width: 40,
      minWidth: 40,
      cellCls: 'b-scale-cell',
      editor: false,
      sortable: false,
      groupable: false,
      filterable: false,
      scalePoints: [{
        value: 4
      }, {
        value: 8,
        text: 8
      }]
    };
  } //endregion
  //region Constructor/Destructor


  onDestroy() {
    this.scaleWidget.destroy();
  } //endregion
  //region Internal


  set width(width) {
    super.width = width;
    this.scaleWidget.width = width;
  }

  get width() {
    return super.width;
  }

  applyValue(useProp, key, value) {
    // pass value to scaleWidget
    if (key === 'scalePoints') {
      this.scaleWidget[key] = value;
    }

    return super.applyValue(...arguments);
  }

  buildScaleWidget() {
    const me = this;
    const scaleWidget = new _Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      owner: me.grid,
      appendTo: me.grid.floatRoot,
      cls: 'b-hide-offscreen',
      align: 'right',
      scalePoints: me.scalePoints,
      monitorResize: false
    });
    Object.defineProperties(scaleWidget, {
      width: {
        get() {
          return me.width;
        },

        set(width) {
          this.element.style.width = `${width}px`;
          this._width = me.width;
        }

      },
      height: {
        get() {
          return this._height;
        },

        set(height) {
          this.element.style.height = `${height}px`;
          this._height = height;
        }

      }
    });
    scaleWidget.width = me.width;
    return scaleWidget;
  }

  get scaleWidget() {
    const me = this;

    if (!me._scaleWidget) {
      me._scaleWidget = me.buildScaleWidget();
    }

    return me._scaleWidget;
  } //endregion
  //region Render


  renderer({
    cellElement,
    scaleWidget = this.scaleWidget
  }) {
    scaleWidget.height = this.grid.rowHeight;
    scaleWidget.refresh(); // Clone the scale widget element since every row is supposed to have
    // the same scale settings

    const scaleCloneElement = scaleWidget.element.cloneNode(true);
    scaleCloneElement.removeAttribute('id');
    scaleCloneElement.classList.remove('b-hide-offscreen');
    cellElement.innerHTML = '';
    cellElement.appendChild(scaleCloneElement);
  } //endregion


}
_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerColumnType(ScaleColumn);
ScaleColumn._$name = 'ScaleColumn';

/***/ }),

/***/ "./lib/SchedulerPro/data/AssignmentStore.js":
/*!**************************************************!*\
  !*** ./lib/SchedulerPro/data/AssignmentStore.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/data/mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/SchedulerPro/model/AssignmentModel.js");
/* harmony import */ var _Engine_quark_store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoAssignmentStoreMixin.js */ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/data/AssignmentStore
 */

/**
 * A store representing a collection of assignments between events in the {@link SchedulerPro.data.EventStore} and resources
 * in the {@link SchedulerPro.data.ResourceStore}.
 *
 * This store only accepts a model class inheriting from {@link SchedulerPro.model.AssignmentModel}.
 *
 * An AssignmentStore is usually connected to a project, which binds it to other related stores (EventStore,
 * ResourceStore and DependencyStore). The project also handles references (event, resource) to related records for the
 * records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * assignmentStore.data = [{ eventId, resourceId }, ...];
 *
 * // references (event, resource) not resolved yet
 *
 * await assignmentStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await assignmentStore.loadDataAsync([{ eventId, resourceId }, ...]);
 *
 * // references (event, resource) are resolved
 * ```
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/AssignmentStoreMixin
 * @extends Core/data/AjaxStore
 *
 * @typings Scheduler/data/AssignmentStore -> Scheduler/data/SchedulerAssignmentStore
 */

class AssignmentStore extends Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoAssignmentStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  static get defaultConfig() {
    return {
      modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_2__["default"]
    };
  }

}
AssignmentStore._$name = 'AssignmentStore';

/***/ }),

/***/ "./lib/SchedulerPro/data/CalendarManagerStore.js":
/*!*******************************************************!*\
  !*** ./lib/SchedulerPro/data/CalendarManagerStore.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarManagerStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony import */ var _model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/CalendarModel.js */ "./lib/SchedulerPro/model/CalendarModel.js");
/* harmony import */ var _Engine_quark_store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js");
var productName = 'gantt';




/**
 * @module SchedulerPro/data/CalendarManagerStore
 */

/**
 * A class representing the tree of calendars in the SchedulerPro chart. An individual calendar is represented as an instance of the
 * {@link SchedulerPro.model.CalendarModel} class. The store expects the data loaded to be hierarchical. Each parent node should
 * contain its children in a property called 'children'.
 *
 * Please refer to the [calendars guide](#SchedulerPro/guides/basics/calendars.md) for details
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 *
 * @extends Core/data/AjaxStore
 */

class CalendarManagerStore extends Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoCalendarManagerStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  //region Config
  static get defaultConfig() {
    return {
      tree: true,
      modelClass: _model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 100,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 100,
      storeId: 'calendars'
    };
  } //endregion


}
;
CalendarManagerStore._$name = 'CalendarManagerStore';

/***/ }),

/***/ "./lib/SchedulerPro/data/DependencyStore.js":
/*!**************************************************!*\
  !*** ./lib/SchedulerPro/data/DependencyStore.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/data/mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/SchedulerPro/model/DependencyModel.js");
/* harmony import */ var _Engine_quark_store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoDependencyStoreMixin.js */ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/data/DependencyStore
 */

/**
 * A store representing a collection of dependencies between events in the {@link SchedulerPro.data.EventStore}.
 *
 * This store only accepts a model class inheriting from {@link SchedulerPro.model.DependencyModel}.
 *
 * A DependencyStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and ResourceStore). The project also handles references (fromEvent, toEvent) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * dependencyStore.data = [{ from, to }, ...];
 *
 * // references (fromEvent, toEvent) not resolved yet
 *
 * await dependencyStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await dependencyStore.loadDataAsync([{ from, to }, ...]);
 *
 * // references (fromEvent, toEvent) are resolved
 * ```
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/DependencyStoreMixin
 * @extends Core/data/AjaxStore
 *
 * @typings Scheduler/data/DependencyStore -> Scheduler/data/SchedulerDependencyStore
 */

class DependencyStore extends Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoDependencyStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  static get defaultConfig() {
    return {
      modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__["default"]
    };
  }

}
DependencyStore._$name = 'DependencyStore';

/***/ }),

/***/ "./lib/SchedulerPro/data/EventStore.js":
/*!*********************************************!*\
  !*** ./lib/SchedulerPro/data/EventStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/data/mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony import */ var _Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/data/mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony import */ var _Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Scheduler/data/mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony import */ var _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model/EventModel.js */ "./lib/SchedulerPro/model/EventModel.js");
/* harmony import */ var _Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';







/**
 * @module SchedulerPro/data/EventStore
 */

/**
 * A store holding all the {@link SchedulerPro.model.EventModel events} to be rendered into a {@link SchedulerPro.view.SchedulerPro Scheduler Pro}.
 *
 * This store only accepts a model class inheriting from {@link SchedulerPro.model.EventModel}.
 *
 * An EventStore is usually connected to a project, which binds it to other related stores (AssignmentStore,
 * ResourceStore and DependencyStore). The project also handles normalization/calculation of the data on the records in
 * the store. For example if a record is added with a `startDate` and an `endDate`, it will calculate the `duration`.
 *
 * The calculations happens async, records are not guaranteed to have up to date data until they are finished. To be
 * certain that calculations have finished, call `await project.commitAsync()` after store actions. Or use one of the
 * `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * eventStore.data = [{ startDate, endDate }, ...];
 *
 * // duration of the record is not yet calculated
 *
 * await eventStore.project.commitAsync();
 *
 * // now it is
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await eventStore.loadDataAsync([{ startDate, endDate }, ...]);
 *
 * // duration is calculated
 * ```
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/SharedEventStoreMixin
 * @mixes Scheduler/data/mixin/EventStoreMixin
 * @mixes Scheduler/data/mixin/RecurringEventsMixin
 * @extends Core/data/AjaxStore
 *
 * @typings Scheduler/data/EventStore -> Scheduler/data/SchedulerEventStore
 */

class EventStore extends Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_6__["default"])(Object(_Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__["ChronoEventStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]))))) {
  //region Config
  static get defaultConfig() {
    return {
      modelClass: _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]
    };
  } //endregion


}
EventStore._$name = 'EventStore';

/***/ }),

/***/ "./lib/SchedulerPro/data/ResourceStore.js":
/*!************************************************!*\
  !*** ./lib/SchedulerPro/data/ResourceStore.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/data/mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony import */ var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/ResourceModel.js */ "./lib/SchedulerPro/model/ResourceModel.js");
/* harmony import */ var _Engine_quark_store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoResourceStoreMixin.js */ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/data/ResourceStore
 */

/**
 * A store holding all the {@link SchedulerPro.model.ResourceModel resources} to be rendered into a
 * {@link SchedulerPro.view.SchedulerPro Scheduler Pro}.
 *
 * This store only accepts a model class inheriting from {@link SchedulerPro.model.ResourceModel}.
 *
 * A ResourceStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and DependencyStore). The project also handles references (assignments, events) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * resourceStore.data = [{ id }, ...];
 *
 * // references (assignments, events) not resolved yet
 *
 * await resourceStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await resourceStore.loadDataAsync([{ id }, ...]);
 *
 * // references (assignments, events) are resolved
 * ```
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/ResourceStoreMixin
 * @extends Core/data/AjaxStore
 *
 * @typings Scheduler/data/ResourceStore -> Scheduler/data/SchedulerResourceStore
 */

class ResourceStore extends Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["ChronoResourceStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  static get defaultConfig() {
    return {
      modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_2__["default"]
    };
  }

}
ResourceStore._$name = 'ResourceStore';

/***/ }),

/***/ "./lib/SchedulerPro/data/mixin/PartOfProject.js":
/*!******************************************************!*\
  !*** ./lib/SchedulerPro/data/mixin/PartOfProject.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';
 // TODO: Compare with Schedulers ProjectModel, make similar

/**
 * @module SchedulerPro/data/mixin/PartOfProject
 */

const throwIfNotTheSameStore = (oldStore, newStore) => {
  if (oldStore !== newStore) {
    throw new Error('Store set is prohibited for Scheduler Pro entity!');
  }
};
/**
 * This is a mixin, included in all models and stores of the Scheduler Pro project. It provides a common API for accessing
 * all stores of the project.
 *
 * @typings Scheduler/data/mixin/PartOfProject -> Scheduler/data/mixin/SchedulerPartOfProject
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class PartOfProject extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'PartOfProject';
  }
  /**
   * Returns the project this entity belongs to.
   *
   * @member {SchedulerPro.model.ProjectModel} project
   * @readonly
   */

  /**
   * An {@link SchedulerPro.data.EventStore} instance or a config object.
   * @config {SchedulerPro.data.EventStore|Object} taskStore
   * @category Project
   */

  /**
   * The {@link SchedulerPro.data.EventStore store} holding the events information.
   *
   * @member {SchedulerPro.data.EventStore}
   * @category Project
   * @readonly
   */


  get taskStore() {
    return this.eventStore;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set taskStore(store) {
    this.eventStore = store;
  }
  /**
   * Returns the task store of the project this entity belongs to.
   *
   * @property {SchedulerPro.data.EventStore}
   * @category Project
   * @readonly
   * @typings Scheduler/model/mixin/ProjectModelMixin:eventStore -> {Scheduler.data.EventStore|SchedulerPro.data.EventStore}
   */


  get eventStore() {
    var _this$project;

    return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.eventStore;
  }

  get leftProjectEventStore() {
    const project = this.leftProject;
    return (project === null || project === void 0 ? void 0 : project.getEventStore()) || null;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set eventStore(store) {
    throwIfNotTheSameStore(this.eventStore, store);
  }
  /**
   * Returns the dependency store of the project this entity belongs to.
   *
   * @property {SchedulerPro.data.DependencyStore}
   * @category Project
   * @readonly
   * @typings Scheduler/model/mixin/ProjectModelMixin:dependencyStore -> {Scheduler.data.DependencyStore|SchedulerPro.data.DependencyStore}
   */


  get dependencyStore() {
    var _this$project2;

    return (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.dependencyStore;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set dependencyStore(store) {
    throwIfNotTheSameStore(this.dependencyStore, store);
  }
  /**
   * Returns the assignment store of the project this entity belongs to.
   *
   * @property {SchedulerPro.data.AssignmentStore}
   * @readonly
   * @category Project
   * @typings Scheduler/model/mixin/ProjectModelMixin:assignmentStore -> {Scheduler.data.AssignmentStore|SchedulerPro.data.AssignmentStore}
   */


  get assignmentStore() {
    var _this$project3;

    return (_this$project3 = this.project) === null || _this$project3 === void 0 ? void 0 : _this$project3.assignmentStore;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set assignmentStore(store) {
    throwIfNotTheSameStore(this.assignmentStore, store);
  }
  /**
   * Returns the resource store of the project this entity belongs to.
   *
   * @property {SchedulerPro.data.ResourceStore}
   * @readonly
   * @category Project
   * @typings Scheduler/model/mixin/ProjectModelMixin:resourceStore -> {Scheduler.data.ResourceStore|SchedulerPro.data.ResourceStore}
   */


  get resourceStore() {
    var _this$project4;

    return (_this$project4 = this.project) === null || _this$project4 === void 0 ? void 0 : _this$project4.resourceStore;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set resourceStore(store) {
    throwIfNotTheSameStore(this.resourceStore, store);
  }
  /**
   * Returns the calendar manager store of the project this entity belongs to.
   *
   * @property {SchedulerPro.data.CalendarManagerStore}
   * @readonly
   * @category Project
   */


  get calendarManagerStore() {
    var _this$project5;

    return (_this$project5 = this.project) === null || _this$project5 === void 0 ? void 0 : _this$project5.calendarManagerStore;
  } // this setter actually does nothing, intentionally, setting the stores on other stores is deprecated


  set calendarManagerStore(store) {
    throwIfNotTheSameStore(this.calendarManagerStore, store);
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/data/mixin/ProjectCrudManager.js":
/*!***********************************************************!*\
  !*** ./lib/SchedulerPro/data/mixin/ProjectCrudManager.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Scheduler/data/mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/data/mixin/ProjectCrudManager
 */
// the order of the @mixes tags is important below, as the "AbstractCrudManagerMixin"
// contains the abstract methods, which are then overwritten by the concrete
// implementation in the AjaxTransport and JsonEncoder

/**
 * This mixin provides Crud manager functionality to a Scheduler Pro project.
 * The mixin turns the provided project model into a Crud manager instance.
 *
 * @mixin
 * @mixes Scheduler/data/mixin/ProjectCrudManager
 * @typings Scheduler/data/mixin/ProjectCrudManager -> Scheduler/data/mixin/SchedulerProjectCrudManager
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectCrudManager extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"]).mixin(_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get properties() {
    return {
      // TODO: remove this in Gantt 4.2.0
      deprecatedProjectCalendarProperties: ['hoursPerDay', 'daysPerWeek', 'daysPerMonth']
    };
  }

  static get configurable() {
    return {
      crudLoadValidationWarningPrefix: 'Project load response error(s):',
      crudSyncValidationWarningPrefix: 'Project sync response error(s):'
    };
  }

  construct(...args) {
    const me = this;
    super.construct(...args); // add the Engine specific stores to the crud manager

    me.addPrioritizedStore(me.calendarManagerStore);
    me.addPrioritizedStore(me.assignmentStore);
    me.addPrioritizedStore(me.dependencyStore);
    me.addPrioritizedStore(me.resourceStore);
    me.addPrioritizedStore(me.eventStore);

    if (me.timeRangeStore) {
      me.addPrioritizedStore(me.timeRangeStore);
    }

    if (me.resourceTimeRangeStore) {
      me.addPrioritizedStore(me.resourceTimeRangeStore);
    }
  } // TODO: remove this in Gantt 4.2.0


  adjustDeprecatedResponse(response) {
    const projectResponse = response === null || response === void 0 ? void 0 : response.project,
          projectResponseCalendar = projectResponse === null || projectResponse === void 0 ? void 0 : projectResponse.calendar,
          {
      deprecatedProjectCalendarProperties
    } = this; // Some properties were move from the CalendarModel to the ProjectModel class
    // we are going to support old properties location for a while
    // to not force customers to update their backends in rush

    if (deprecatedProjectCalendarProperties && projectResponseCalendar && response.calendars) {
      var _response$calendars$r;

      // array of responded calendars to iterate
      const toProcess = ((_response$calendars$r = response.calendars.rows) === null || _response$calendars$r === void 0 ? void 0 : _response$calendars$r.slice()) || [];
      let calendarEntry;

      while (calendarEntry = toProcess.shift()) {
        // if that's the project calendar
        if (calendarEntry.id == projectResponseCalendar) {
          // copy its deprecated properties to the "project"
          deprecatedProjectCalendarProperties.forEach(property => {
            if (!projectResponse[property] && calendarEntry[property]) {
              projectResponse[property] = calendarEntry[property];
            }
          });
          break;
        } // add children to the list to be iterated


        calendarEntry.children && toProcess.push(...calendarEntry.children);
      }
    }

    return response;
  }

  get project() {
    return this;
  }

  set project(value) {
    super.project = value;
  }

  async applyResponse(request, response, options) {
    if (!this.isDestroyed) {
      // adjust response to support some outdated properties location
      response = this.adjustDeprecatedResponse(response);
      return super.applyResponse(request, response, options);
    }
  }

  get crudLoadValidationMandatoryStores() {
    return [this.getStoreDescriptor(this.eventStore).storeId];
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/eventlayout/ProHorizontalLayout.js":
/*!*************************************************************!*\
  !*** ./lib/SchedulerPro/eventlayout/ProHorizontalLayout.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';


const sortFn = (a, b) => {
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  } else {
    return 0;
  }
};
/**
 * @module SchedulerPro/eventlayout/ProHorizontalLayout
 */

/**
 * Mixin for SchedulerPro horizontal layouts ({@link SchedulerPro.eventlayout.ProHorizontalLayoutPack} and
 * {@link SchedulerPro.eventlayout.ProHorizontalLayoutStack}). Should not be used directly, instead specify
 * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} in the SchedulerPro config (`stack`, `pack`
 * or `none`):
 *
 * ```javascript
 * new SchedulerPro({
 *   eventLayout: 'stack'
 * });
 * ```
 *
 * ## Grouping events
 *
 * By default events are not grouped and are laid out inside the row using start and end dates. Using
 * {@link #config-groupBy} config you can group events inside the resource row. Every group will be laid out on its own
 * band, as if layout was applied to each group of events separately.
 *
 * {@inlineexample SchedulerPro/eventlayout/ProHorizontalLayout.js}
 *
 * ### By field value
 *
 * You can specify field name to group events by. The following snippet would put *high* prio events at the top:
 *
 * ```javascript
 * new SchedulerPro({
 *     eventLayout : {
 *         type    : 'stack',
 *         groupBy : 'prio'
 *     },
 *     project : {
 *         eventsData : [
 *             { id : 1, startDate : '2017-02-08', duration : 1, prio : 'low' },
 *             { id : 2, startDate : '2017-02-09', duration : 1, prio : 'high' },
 *             { id : 3, startDate : '2017-02-10', duration : 1, prio : 'high' },
 *         ],
 *         resourcesData : [
 *             { id : 1, name : 'Resource 1' }
 *         ],
 *         assignmentsData : [
 *             { id : 1, resource : 1, event : 1 },
 *             { id : 2, resource : 1, event : 2 },
 *             { id : 3, resource : 1, event : 3 }
 *         ]
 *     }
 * })
 * ```
 *
 * ### Order of groups
 *
 * Groups are **always** sorted ascending. In the example above *high* prio events are above *low* prio events because:
 *
 * ```javascript
 * 'high' < 'low' // true
 * ```
 *
 * If you want to group events in a specific order, you can define it in a
 * special {@link #config-weights} config:
 *
 * ```javascript
 * new SchedulerPro({
 *     eventLayout : {
 *         type    : 'stack',
 *         weights : {
 *             low  : 100,
 *             high : 200
 *         },
 *         groupBy : 'prio'
 *     }
 * });
 * ```
 *
 * This will put *low* prio events at the top.
 *
 * The weight value defaults to `Infinity` unless specified in the weights config explicitly.
 *
 * ### Using a function
 *
 * You can use a custom function to group events. The group function receives an event record as a single argument and
 * is expected to return a non-null value for the group. This allows you to arrange events in any order you like,
 * including grouping by multiple properties at once.
 *
 * The snippet below groups events by duration and priority by creating 4 weights:
 *
 * |       | high prio | low prio |
 * |-------|-----------|----------|
 * | long  |     2     |    10    |
 * | short |     3     |    15    |
 *
 * ```javascript
 * new SchedulerPro({
 *     eventLayout : {
 *         type    : 'stack',
 *         groupBy : event => {
 *             return (event.duration > 2 ? 2 : 3) * (event.prio === 'high' ? 1 : 5);
 *         }
 *     }
 * })
 * ```
 *
 * This will divide events into 4 groups as seen in this demo:
 *
 * {@inlineexample SchedulerPro/eventlayout/ProHorizontalLayout2.js}
 *
 * ## Manual event layout
 *
 * You can provide a custom function to layout events inside the row and set the row size as required using
 * {@link #config-layoutFn}. The function is called with an array of {@link EventRenderData render data} objects. The
 * custom function can iterate over those objects and position them inside the row using `top` and `height` attributes.
 * The function should return the total row height in pixels.
 *
 * Please note that using a custom layout function makes {@link SchedulerPro.view.SchedulerPro#config-rowHeight}
 * obsolete.
 *
 * {@inlineexample SchedulerPro/eventlayout/ProHorizontalLayoutFn.js}
 *
 * ```javascript
 * new SchedulerPro({
 *     eventLayout : {
 *         layoutFn : items => {
 *             // Put event element at random top position
 *             item.top = 100 * Math.random();
 *         }
 *     }
 * });
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class ProHorizontalLayout extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * Type of horizontal layout. Supported values are `stack`, `pack` and `none`.
       * @config {String}
       */
      type: null,

      /**
       * The weights config allows you to specify order of the event groups inside the row. Higher weights are
       * placed further down in the row. If field value is not specified in the weights object, it will be
       * assigned `Infinity` value and pushed to the bottom.
       *
       * Only applicable when {@link #config-groupBy} config is not a function:
       *
       * ```javascript
       * new SchedulerPro({
       *     eventLayout : {
       *         type    : 'stack',
       *         weights : {
       *             // Events with high prio will be placed at the top, then medium,
       *             // then low prio events.
       *             high   : 100,
       *             medium : 150,
       *             low    : 200
       *         },
       *         groupBy : 'prio'
       *     }
       * });
       * ```
       *
       * Only explicitly defined groups are put in separate bands inside the row:
       *
       * ```javascript
       * new SchedulerPro({
       *     eventLayout : {
       *         // Pack layout is supported too
       *         type : 'pack',
       *         weights : {
       *             // Events with high prio will be placed at the top. All other
       *             // events will be put to the same group at the bottom
       *             high : 100
       *         },
       *         groupBy : 'prio'
       *     }
       * });
       * ```
       * @config {Object}
       */
      weights: null,

      /**
       * Specifies a way to group events inside the row. Can accept either a model field name or a function which
       * is provided with event record as a single argument and is expected to return group for the event.
       *
       * @config {String|Function}
       */
      groupBy: null,
      groupByThisObj: null,

      /**
       * Supply a function to manually layout events. It accepts event layout data and should set `top`
       * and `height` for every provided data item (left and width are calculated according to the event start
       * date and duration). The function should return the total row height in pixels.
       *
       * For example, we can arrange events randomly in the row:
       * ```javascript
       * new SchedulerPro({
       *     eventLayout : {
       *         layoutFn : items => {
       *             item.top = Math.round(Math.random() * 100);
       *             item.height = Math.round(Math.random() * 100);
       *
       *             return 50;
       *         }
       *     }
       * })
       * ```
       *
       * @config {Function}
       * @param {EventRenderData[]} events Array of event render data.
       * @returns {Number} Returns total row height
       */
      layoutFn: null
    };
  }
  /**
   * This method performs layout on an array of event render data and returns amount of _bands_. Band is a multiplier of a
   * configured {@link Scheduler.view.Scheduler#config-rowHeight} to calculate total row height required to fit all
   * events.
   * This method should not be used directly, it is called by the Scheduler during the row rendering process.
   * @method applyLayout
   * @param {EventRenderData[]} events
   * @param {Scheduler.model.ResourceModel} resource
   * @return {Number}
   */

  /**
   * This method iterates over events and calculates top position for each of them. Default layouts calculate
   * positions to avoid events overlapping horizontally (except for the 'none' layout). Pack layout will squeeze events to a single
   * row by reducing their height, Stack layout will increase the row height and keep event height intact.
   * This method should not be used directly, it is called by the Scheduler during the row rendering process.
   * @method layoutEventsInBands
   * @param {EventRenderData[]} events
   */

  /**
   * Returns `true` if event {@link #config-groupBy grouper} is defined.
   * @type {Boolean}
   * @readonly
   */


  get grouped() {
    return Boolean(this.groupBy);
  }
  /**
   * Returns group for the passed event render data.
   * @param {EventRenderData} layoutData
   * @return {*}
   */


  getGroupValue(layoutData) {
    let result;

    if (layoutData.group != null) {
      result = layoutData.group;
    } else {
      const {
        groupBy,
        weights,
        groupByThisObj = this
      } = this,
            {
        eventRecord
      } = layoutData;

      if (typeof groupBy === 'function') {
        result = groupBy.call(groupByThisObj, eventRecord);
      } else {
        result = eventRecord[groupBy];

        if (weights) {
          var _weights$result;

          // If record value is null or undefined, use infinite weight to move record to the bottom
          result = (_weights$result = weights[result]) !== null && _weights$result !== void 0 ? _weights$result : Infinity;
        }
      }

      layoutData.group = result;
    }

    return result;
  }
  /**
   * Sorts events by group and returns ordered array of groups, or empty array if events are not grouped.
   * @param {EventRenderData[]} events
   * @return {String[]}
   */


  getEventGroups(events) {
    // If group fn is defined, we need to sort events array according to groups
    if (this.grouped) {
      const groups = new Set();
      events.sort((a, b) => {
        const aValue = this.getGroupValue(a),
              bValue = this.getGroupValue(b);
        groups.add(aValue);
        groups.add(bValue);
        return sortFn(aValue, bValue);
      });
      return Array.from(groups).sort(sortFn);
    } else {
      return [];
    }
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/eventlayout/ProHorizontalLayoutPack.js":
/*!*****************************************************************!*\
  !*** ./lib/SchedulerPro/eventlayout/ProHorizontalLayoutPack.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProHorizontalLayoutPack; });
/* harmony import */ var _ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProHorizontalLayout.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayout.js");
/* harmony import */ var _Scheduler_eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/eventlayout/HorizontalLayoutPack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/eventlayout/ProHorizontalLayoutPack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Packs events (adjusts their height) to fit
 * available row height.
 *
 * This layout supports grouping events inside the resource row. See
 * {@link SchedulerPro.eventlayout.ProHorizontalLayout} for more info.
 *
 * @mixes SchedulerPro/eventlayout/ProHorizontalLayout
 */

class ProHorizontalLayoutPack extends _Scheduler_eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ProHorizontalLayoutPack';
  }
  /**
   * @hideconfigs type, weights, groupBy, layoutFn
   */


  layoutEventsInBands(events) {
    const groups = this.getEventGroups(events),
          // If we don't have any groups, treat it like we have a single group including all events
    groupCount = groups.length || 1;
    const result = this.packEventsInBands(events, (event, j, slot, slotSize) => {
      const size = slotSize / groupCount,
            groupIndex = groupCount === 1 ? 0 : groups.indexOf(event.group),
            adjustedSlotStart = groupIndex / groupCount; // This height and top are used to position event in the grouped row

      event.height = size;
      event.top = adjustedSlotStart + slot.start / groupCount + j * size; // This height and top are used to layout events in the same band. They emulate a single row which is what
      // pack logic expects

      event.inBandHeight = slotSize;
      event.inBandTop = slot.start + j * slotSize;
    });
    events.forEach(event => {
      Object.assign(event, this.bandIndexToPxConvertFn.call(this.bandIndexToPxConvertThisObj || this, event.top, event.height, event.eventRecord, event.resourceRecord));
    });
    return result;
  }

}
ProHorizontalLayoutPack._$name = 'ProHorizontalLayoutPack';

/***/ }),

/***/ "./lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js":
/*!******************************************************************!*\
  !*** ./lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProHorizontalLayoutStack; });
/* harmony import */ var _ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProHorizontalLayout.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayout.js");
/* harmony import */ var _Scheduler_eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/eventlayout/HorizontalLayoutStack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/eventlayout/ProHorizontalLayoutStack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Stacks events, increasing row height to fit
 * all overlapping events.
 *
 * This layout is used by default in horizontal mode.
 *
 * This layout supports grouping events inside the resource row. See
 * {@link SchedulerPro.eventlayout.ProHorizontalLayout} for more info.
 *
 * @mixes SchedulerPro/eventlayout/ProHorizontalLayout
 */

class ProHorizontalLayoutStack extends _Scheduler_eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ProHorizontalLayoutStack';
  }
  /**
   * @hideconfigs type, weights, groupBy, layoutFn
   */
  // heightRun is used when pre-calculating row heights, taking a cheaper path


  layoutEventsInBands(events, heightRun = false) {
    this.getEventGroups(events);
    return super.layoutEventsInBands(events, heightRun);
  }

}
ProHorizontalLayoutStack._$name = 'ProHorizontalLayoutStack';

/***/ }),

/***/ "./lib/SchedulerPro/feature/EventResize.js":
/*!*************************************************!*\
  !*** ./lib/SchedulerPro/feature/EventResize.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventResize; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/feature/EventResize
 */

/**
 * Feature that allows resizing an event by dragging its end.
 *
 * By default it displays a tooltip with the new start and end dates, formatted using
 * {@link Scheduler.view.mixin.TimelineViewPresets#config-displayDateFormat}.
 *
 * This feature is **enabled** by default
 *
 * @inlineexample SchedulerPro/feature/EventResize.js
 * @extends Scheduler/feature/EventResize
 * @typings Scheduler/feature/EventResize -> Scheduler/feature/SchedulerEventResize
 * @classtype eventResize
 * @feature
 */

class EventResize extends _Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'EventResize';
  }

}
EventResize._$name = 'EventResize';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(EventResize, true, 'SchedulerPro');

/***/ }),

/***/ "./lib/SchedulerPro/feature/PercentBar.js":
/*!************************************************!*\
  !*** ./lib/SchedulerPro/feature/PercentBar.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PercentBar; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/feature/PercentBar
 */
//region Static

function cls(classes) {
  return `b-task-percent-bar${classes[0] ? `-${classes[0]}` : ''}`;
} //endregion

/**
 * This feature visualizes the {@link SchedulerPro.model.mixin.PercentDoneMixin#field-percentDone percentDone} field as a
 * progress bar on the event elements. Each progress bar also optionally has a drag handle which users can drag can
 * change the value.
 * You can customize data source for the feature with {@link #config-valueField} and {@link #config-displayField} configs.
 *
 * {@inlineexample SchedulerPro/feature/PercentBar.js}
 *
 * This feature is **enabled** by default in Gantt, but **off** by default in Scheduler Pro.
 *
 * @extends Core/mixin/InstancePlugin
 * @classtype percentBar
 * @feature
 * @demo SchedulerPro/percent-done
 */


class PercentBar extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'PercentBar';
  }

  static get configurable() {
    return {
      /**
       * `true` to allow drag drop resizing to set the % done
       * @config {Boolean}
       * @default
       */
      allowResize: true,

      /**
       * `true` to allow show a small % done label within the event while drag changing its value
       * @config {Boolean}
       * @default
       */
      showPercentage: true,

      /**
       * Field name to use as the data source
       * @config {String}
       * @default
       */
      valueField: 'percentDone',

      /**
       * Field name to use to display the value
       * @config {String}
       * @default
       */
      displayField: 'renderedPercentDone'
    };
  }

  static get pluginConfig() {
    return {
      chain: ['onPaint', 'onTaskDataGenerated', 'onEventDataGenerated']
    };
  } //endregion
  //region Init

  /**
   * Called when scheduler is painted. Sets up drag and drop and hover tooltip.
   * @private
   */


  onPaint({
    firstPaint
  }) {
    if (firstPaint) {
      const me = this,
            {
        client
      } = me;
      me.drag = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
        name: 'percentBarHandle',
        mode: 'translateX',
        // Handle is not draggable for parents
        targetSelector: `${client.eventSelector}:not(.${client.eventCls}-parent) .b-task-percent-bar-handle`,
        dragThreshold: 1,
        outerElement: client.timeAxisSubGridElement,
        listeners: {
          beforeDragStart: 'onBeforeDragStart',
          dragStart: 'onDragStart',
          drag: 'onDrag',
          drop: 'onDrop',
          abort: 'onDragAbort',
          thisObj: me
        }
      });
      me.detachListeners('view');
      me.client.on({
        name: 'view',
        [`${client.scheduledEventName}mouseenter`]: 'onTimeSpanMouseEnter',
        [`${client.scheduledEventName}mouseleave`]: 'onTimeSpanMouseLeave',
        thisObj: me
      });
    }
  }

  updateAllowResize(value) {
    this.client.element.classList[value ? 'remove' : 'add'](cls`drag-disabled`);
  }

  updateShowPercentage(value) {
    this.client.element.classList[value ? 'add' : 'remove'](cls`show-percentage`);
  }

  doDestroy() {
    this.drag && this.drag.destroy();
    super.doDestroy();
  }

  doDisable(disable) {
    // Redraw to toggle percent bars
    if (this.client.isPainted) {
      this.client.refresh();
    }

    super.doDisable(disable);
  } //endregion
  //region Contents


  cleanup(context) {
    const me = this,
          taskEl = context.element.closest(me.client.eventSelector);
    taskEl.classList.remove(cls`resizing`);
    me.client.element.classList.remove(cls`resizing-task`); // Remove handle if operation ended outside of the event

    if (!me.isMouseInsideEvent) {
      me.handle.remove();
      me.handle = null;
    }
  }

  appendDOMConfig(taskRecord, children) {
    if ((taskRecord.isEvent || taskRecord.isTask) && !taskRecord.isMilestone && !this.disabled) {
      children.unshift({
        className: cls`outer`,
        dataset: {
          taskBarFeature: 'percentBar'
        },
        children: [{
          className: cls``,
          dataset: {
            percent: taskRecord[this.displayField]
          },
          style: {
            width: taskRecord[this.valueField] + '%'
          }
        }]
      });
    }
  } // For Scheduler Pro


  onEventDataGenerated(eventData) {
    this.appendDOMConfig(eventData.eventRecord, eventData.children);
  } // For Gantt


  onTaskDataGenerated(taskData) {
    this.appendDOMConfig(taskData.task, taskData.children);
  } //endregion
  //region Events
  // Inject handle on mouse over


  onTimeSpanMouseEnter(event) {
    const me = this,
          record = event[`${me.client.scheduledEventName}Record`];

    if (record.isMilestone || me.disabled) {
      return;
    } // No ongoing drag


    if (!me.drag.context) {
      const element = event[`${me.client.scheduledEventName}Element`],
            parent = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(element, me.client.scheduledEventName); // Add handle if not already there

      if (!me.handle) {
        me.handle = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
          parent,
          className: cls`handle`,
          style: {
            left: record[me.valueField] + '%'
          },
          dataset: {
            percent: record[me.valueField]
          }
        });
      } // Mouse is inside event, used later to not remove handle


      me.isMouseInsideEvent = true;
    } // Ongoing drag, mouse coming back into active event
    else if (record === me.drag.context.taskRecord) {
      // Mouse is inside event, used later to not remove handle
      me.isMouseInsideEvent = true;
    }
  } // Remove handle on mouse leave, if not dragging


  onTimeSpanMouseLeave() {
    const me = this;

    if (!me.drag.context && me.handle) {
      me.handle.remove();
      me.handle = null;
    }

    me.isMouseInsideEvent = false;
  }

  onBeforeDragStart({
    source,
    context
  }) {
    const percentBarOuter = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(context.element.parentElement, 'percentBar'),
          percentBar = percentBarOuter.firstElementChild,
          initialX = percentBar.offsetWidth,
          outerWidth = percentBarOuter.offsetWidth,
          taskRecord = this.client.resolveEventRecord(context.element);
    source.minX = -initialX;
    source.maxX = outerWidth - initialX;
    Object.assign(context, {
      percentBar,
      initialX,
      outerWidth,
      taskRecord
    });
  }

  onDragStart({
    context
  }) {
    const {
      client
    } = this,
          taskEl = context.element.closest(client.eventSelector);
    taskEl.classList.add(cls`resizing`);
    client.element.classList.add(cls`resizing-task`);
    context.element.retainElement = true;
  }

  onDrag({
    context
  }) {
    const percent = Math.round((context.initialX + context.newX) / context.outerWidth * 100); // TODO : Live updating, requires some more effort to make it good
    //context.taskRecord.percentDone = percent;

    context.percent = context.percentBar.dataset.percent = context.element.dataset.percent = percent;
    context.percentBar.style.width = percent + '%';
  }

  onDragAbort({
    context
  }) {
    // Reset percentBar width on abort
    context.percentBar.style.width = context.taskRecord[this.valueField] + '%';
    this.cleanup(context);
  }

  onDrop({
    context
  }) {
    context.taskRecord[this.valueField] = context.percent; // Fully overwrite handle style to get rid of translate also

    context.element.style.cssText = `left: ${context.percent}%`;
    this.cleanup(context);
  } //endregion
  // No classname on Scheduler's/Gantt's element


  get featureClass() {}

}
PercentBar._$name = 'PercentBar';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(PercentBar, false, 'SchedulerPro');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerFeature(PercentBar, true, 'Gantt');

/***/ }),

/***/ "./lib/SchedulerPro/feature/ResourceNonWorkingTime.js":
/*!************************************************************!*\
  !*** ./lib/SchedulerPro/feature/ResourceNonWorkingTime.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceNonWorkingTime; });
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/base/ResourceTimeRangesBase.js */ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js");
/* harmony import */ var _Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'gantt';




/**
 * @module SchedulerPro/feature/ResourceNonWorkingTime
 */

/**
 * Feature that highlights non-working time periods for resources according to their {@link SchedulerPro.model.ResourceModel#field-calendar}.
 * If no calenar for a resource defined, an active project's calendar will be used.
 *
 * This feature is **off** by default. For info on enabling it, see {@link Grid.view.mixin.GridFeatures}.
 *
 * *data.json* example:
 * ```javascript
 * {
 *   "success"   : true,
 *   "calendars" : {
 *       "rows" : [
 *           {
 *               "id"                       : "day",
 *               "name"                     : "Day shift",
 *               "unspecifiedTimeIsWorking" : false,
 *               "intervals"                : [
 *                   {
 *                       "recurrentStartDate" : "at 8:00",
 *                       "recurrentEndDate"   : "at 17:00",
 *                       "isWorking"          : true
 *                   }
 *               ]
 *           }
 *    ],
 *    "resources" : {
 *       "rows" : [
 *           {
 *               "id"         : 1,
 *               "name"       : "George",
 *               "calendar"   : "day",
 *               "role"       : "Office",
 *               "eventColor" : "blue"
 *           },
 *           {
 *               "id"         : 2,
 *               "name"       : "Rob",
 *               "calendar"   : "day",
 *               "role"       : "Office",
 *               "eventColor" : "blue"
 *           }
 *        ]
 *   [...]
 * ```
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *   // A Project holding the data and the calculation engine for Scheduler Pro. It also acts as a CrudManager, allowing
 *   // loading data into all stores at once
 *   project : {
 *       autoLoad  : true,
 *       transport : {
 *           load : {
 *               url : './data/data.json'
 *           }
 *       }
 *   },
 *   features : {
 *       resourceNonWorkingTime : true
 *   },
 *   [...]
 * }):
 * ```
 *
 * Resource non-working time ranges can be recurring. You can find an example showing how to achieve this in the [Resource Non-Working Time Demo](../examples/resource-non-working-time/).
 *
 * @extends Scheduler/feature/base/ResourceTimeRangesBase
 * @demo SchedulerPro/resource-non-working-time
 * @classtype resourceNonWorkingTime
 * @feature
 */

class ResourceNonWorkingTime extends _Scheduler_feature_base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'ResourceNonWorkingTime';
  }

  static get configurable() {
    return {
      rangeCls: 'b-sch-resourcetimerange b-sch-resourcenonworkingtime',

      /**
       * The largest time axis unit to display non working ranges for ('hour' or 'day' etc).
       * When zooming to a view with a larger unit, no non-working time elements will be rendered.
       *
       * **Note:** Be careful with setting this config to big units like 'year'. When doing this,
       * make sure the timeline {@link Scheduler.view.TimelineBase#config-startDate start} and
       * {@link Scheduler.view.TimelineBase#config-endDate end} dates are set tightly.
       * When using a long range (for example many years) with non-working time elements rendered per hour,
       * you will end up with millions of elements, impacting performance.
       * When zooming, use the {@link Scheduler.view.mixin.TimelineZoomable#config-zoomKeepsOriginalTimespan} config.
       * @config {String}
       * @default
       */
      maxTimeAxisUnit: 'hour',

      /**
       * The Model class to use for representing a {@link Scheduler.model.ResourceTimeRangeModel}
       * @config {Function}
       */
      resourceTimeRangeModelClass: _Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_2__["default"]
    };
  }

  static get properties() {
    return {
      resourceMap: new Map()
    };
  } //endregion
  //region Constructor


  construct() {
    var _class, _temp;

    super.construct(...arguments);
    this.resourceTimeRangeModelClass = (_temp = _class = class ResourceNonWorkingTimeModel extends this.resourceTimeRangeModelClass {
      static get $name() {
        return 'ResourceNonWorkingTimeModel';
      }

    }, _defineProperty(_class, "domIdPrefix", 'resourcenonworkingtimemodel'), _temp);
    this.client.timeAxis.on({
      name: 'timeAxis',
      reconfigure: 'onTimeAxisReconfigure',
      // should trigger before event rendering chain
      prio: 100,
      thisObj: this
    });
  } //endregion
  //region Init


  attachToResourceStore(resourceStore) {
    super.attachToResourceStore(resourceStore);
    resourceStore === null || resourceStore === void 0 ? void 0 : resourceStore.on({
      name: 'resourceStore',
      changePreCommit: 'onResourceChange',
      thisObj: this
    });
  }

  attachToCalendarManagerStore(calendarManagerStore) {
    super.attachToCalendarManagerStore(calendarManagerStore);
    calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.on({
      name: 'calendarManagerStore',
      changePreCommit: 'onCalendarChange',
      thisObj: this
    });
  } //endregion
  //region Events


  onTimeAxisReconfigure() {
    // reset ranges cache on timeAxis change
    this.resourceMap.clear();
  }

  onResourceChange({
    action,
    records,
    record,
    changes
  }) {
    const me = this; // Might need to redraw on update

    if (action === 'update') {
      var _change$value;

      const change = changes.calendar; // Ignore calendar normalization

      if (change && (typeof change.oldValue !== 'string' || ((_change$value = change.value) === null || _change$value === void 0 ? void 0 : _change$value.id) !== change.oldValue)) {
        me.resourceMap.delete(record.id); // Redraw row in case calendar change did not affect any events

        me.client.runWithTransition(() => {
          me.client.currentOrientation.refreshEventsForResource(record);
        });
      }
    } // Keep map up to date on removals (adds are handled through rendering in getEventsToRender)


    if (action === 'remove') {
      records.forEach(record => me.resourceMap.delete(record.id));
    }

    if (action === 'removeall') {
      me.resourceMap.clear();
    }
  }

  onCalendarChange({
    action,
    records,
    record,
    changes
  }) {// TODO
  } //endregion
  //region Internal
  // Called on render of resources events to get events to render. Add any ranges
  // (chained function from Scheduler)


  getEventsToRender(resource, events) {
    const me = this,
          {
      resourceMap,
      client
    } = me,
          {
      timeAxis
    } = client,
          shouldPaint = !me.maxTimeAxisUnit || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].compareUnits(timeAxis.unit, me.maxTimeAxisUnit) <= 0;

    if (!me.disabled && shouldPaint && resource.effectiveCalendar) {
      if (!resourceMap.has(resource.id)) {
        const ranges = resource.effectiveCalendar.getNonWorkingTimeRanges(client.startDate, client.endDate),
              records = ranges.map((range, i) => new me.resourceTimeRangeModelClass({
          id: `r${resource.id}i${i}`,
          startDate: range.startDate,
          endDate: range.endDate,
          resourceId: resource.id,
          isNonWorking: true
        }));
        resourceMap.set(resource.id, records);
      }

      events.push(...resourceMap.get(resource.id));
    }

    return events;
  }

  shouldInclude({
    isNonWorking
  }) {
    return isNonWorking;
  } //endregion


} // No feature based styling needed, do not add a cls to Scheduler

ResourceNonWorkingTime.featureClass = '';
ResourceNonWorkingTime._$name = 'ResourceNonWorkingTime';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerFeature(ResourceNonWorkingTime, false, 'SchedulerPro');

/***/ }),

/***/ "./lib/SchedulerPro/feature/TaskEdit.js":
/*!**********************************************!*\
  !*** ./lib/SchedulerPro/feature/TaskEdit.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEdit; });
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_ProTaskEditStm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/ProTaskEditStm.js */ "./lib/SchedulerPro/feature/mixin/ProTaskEditStm.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _widget_GanttTaskEditor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../widget/GanttTaskEditor.js */ "./lib/SchedulerPro/widget/GanttTaskEditor.js");
/* harmony import */ var _widget_SchedulerTaskEditor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../widget/SchedulerTaskEditor.js */ "./lib/SchedulerPro/widget/SchedulerTaskEditor.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';













/**
 * @module SchedulerPro/feature/TaskEdit
 */

/**
 * Feature that displays a {@link SchedulerPro.widget.SchedulerTaskEditor Task editor}, allowing users to edit task data.
 * The Task editor is a popup containing tabs with fields for editing task data.
 *
 * {@inlineexample SchedulerPro/feature/TaskEdit.js}
 *
 * ## Customizing tabs and their widgets
 *
 * To customize tabs you can:
 *
 * * Reconfigure built in tabs by providing override configs in the {@link #config-items items} config.
 * * Remove existing tabs or add your own in the {@link #config-items items} config.
 * * Advanced: Reconfigure the whole editor widget using {@link #config-editorConfig} or replace the whole editor using {@link #config-editorClass}.
 *
 * To add extra items to a tab you need to specify {@link Core.widget.Container#config-items items} for the tab container.
 *
 * {@inlineexample SchedulerPro/feature/TaskEditExtraItems.js}
 *
 * {@region Expand to see Default tabs and fields}
 *
 * The {@link SchedulerPro.widget.SchedulerTaskEditor Task editor} contains tabs by default. Each tab contains built in widgets: text fields, grids, etc.
 *
 * | Tab ref           | Type                                                                             | Text         | Weight | Description                                                                          |
 * |-------------------|----------------------------------------------------------------------------------|--------------|--------|--------------------------------------------------------------------------------------|
 * | `generalTab`      | {@link SchedulerPro.widget.taskeditor.SchedulerGeneralTab SchedulerGeneralTab}   | General      | 100    | Shows basic configuration: name, resources, start/end dates, duration, percent done. |
 * | `predecessorsTab` | {@link SchedulerPro.widget.taskeditor.PredecessorsTab PredecessorsTab}           | Predecessors | 200    | Shows a grid with incoming dependencies                                              |
 * | `successorsTab`   | {@link SchedulerPro.widget.taskeditor.SuccessorsTab SuccessorsTab}               | Successors   | 300    | Shows a grid with outgoing dependencies                                              |
 * | `advancedTab`     | {@link SchedulerPro.widget.taskeditor.SchedulerAdvancedTab SchedulerAdvancedTab} | Advanced     | 500    | Shows advanced configuration: constraints and manual scheduling mode                 |
 * | `notesTab`        | {@link SchedulerPro.widget.taskeditor.NotesTab NotesTab}                         | Notes        | 600    | Shows a text area to add notes to the selected task                                  |
 *
 * ### General tab
 *
 * General tab contains fields for basic configurations
 *
 * | Field ref          | Type                                            | Text       | Weight | Description                                           |
 * |--------------------|-------------------------------------------------|------------|--------|-------------------------------------------------------|
 * | `nameField`        | {@link Core.widget.TextField TextField}         | Name       | 100    | Task name                                             |
 * | `resourcesField`   | {@link Core.widget.Combo Combo}                 | Resources  | 200    | Shows a list of available resources for this task     |
 * | `startDateField`   | {@link Core.widget.DateTimeField DateTimeField} | Start      | 300    | Shows when the task begins                            |
 * | `endDateField`     | {@link Core.widget.DateTimeField DateTimeField} | Finish     | 400    | Shows when the task ends                              |
 * | `durationField`    | {@link Core.widget.DurationField DurationField} | Duration   | 500    | Shows how long the task is                            |
 * | `percentDoneField` | {@link Core.widget.NumberField NumberField}     | % Complete | 600    | Shows what part of task is done already in percentage |
 *
 * ### Predecessors tab
 *
 * Predecessors tab contains a grid with incoming dependencies and controls to remove/add dependencies
 *
 * | Widget ref | Type                                | Weight | Description                                                                                      |
 * |------------|-------------------------------------|--------|--------------------------------------------------------------------------------------------------|
 * | `grid`     | {@link Grid.view.Grid Grid}         | 100    | Shows predecessors task name, dependency type and lag                                            |
 * | `toolbar`  | {@link Core.widget.Toolbar Toolbar} | 200    | Shows control buttons                                                                            |
 * | \>`add`    | {@link Core.widget.Button Button}   | 210    | Adds a new dummy predecessor. Then need to select a task from the list in the name column editor |
 * | \>`remove` | {@link Core.widget.Button Button}   | 220    | Removes selected incoming dependency                                                             |
 *
 * \> - nested items
 *
 * ### Successors tab
 *
 * Successors tab contains a grid with outgoing dependencies and controls to remove/add dependencies
 *
 * | Widget ref | Type                                | Weight | Description                                                                                    |
 * |------------|-------------------------------------|--------|------------------------------------------------------------------------------------------------|
 * | `grid`     | {@link Grid.view.Grid Grid}         | 100    | Shows successors task name, dependency type and lag                                            |
 * | `toolbar`  | {@link Core.widget.Toolbar Toolbar} | 200    | Shows control buttons                                                                          |
 * | \>`add`    | {@link Core.widget.Button Button}   | 210    | Adds a new dummy successor. Then need to select a task from the list in the name column editor |
 * | \>`remove` | {@link Core.widget.Button Button}   | 220    | Removes selected outgoing dependency                                                           |
 *
 * \> - nested items
 *
 * ### Advanced tab
 *
 * Advanced tab contains additional task scheduling options
 *
 * | Field ref                | Type                                                                  | Weight | Description                                                                             |
 * |--------------------------|-----------------------------------------------------------------------|--------|-----------------------------------------------------------------------------------------|
 * | `calendarField`          | {@link SchedulerPro.widget.CalendarField CalendarField}               | 100    | Shows a list of available calendars for this task. Shown when calendars are downloaded. |
 * | `constraintTypeField`    | {@link SchedulerPro.widget.ConstraintTypePicker ConstraintTypePicker} | 200    | Shows a list of available constraints for this task                                     |
 * | `constraintDateField`    | {@link Core.widget.DateField DateField}                               | 300    | Shows a date for the selected constraint type                                           |
 * | `manuallyScheduledField` | {@link Core.widget.Checkbox Checkbox}                                 | 400    | If checked, the task is not considered in scheduling                                    |
 *
 * ### Notes tab
 *
 * Notes tab contains a text area to show notes
 *
 * | Field ref   | Type                                            | Weight | Description                                     |
 * |-------------|-------------------------------------------------|--------|-------------------------------------------------|
 * | `noteField` | {@link Core.widget.TextAreaField TextAreaField} | 100    | Shows a text area to add text notes to the task |
 *
 * {@endregion}
 *
 * ## Removing a built in item
 *
 * To remove a built in tab or field, specify its `ref` as `false` in the `items` config:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab      : {
 *                     items : {
 *                         // Remove "Duration" and "% Complete" fields in the "General" tab
 *                         durationField    : false,
 *                         percentDoneField : false
 *                     }
 *                 },
 *                 // Remove all tabs except the "General" tab
 *                 notesTab        : false,
 *                 predecessorsTab : false,
 *                 successorsTab   : false,
 *                 advancedTab     : false
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Customizing a built in item
 *
 * To customize a built in tab or field, use its `ref` as the key in the `items` config and specify the configs you want
 * to change (they will be merged with the tabs or fields default configs correspondingly):
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab      : {
 *                     // Rename "General" tab
 *                     title : 'Main',
 *                     items : {
 *                         // Rename "% Complete" field
 *                         percentDoneField : {
 *                             label : 'Status'
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Adding a custom item
 *
 * To add a custom tab or field, add an entry to the `items` config. When you add a field,
 * the `name` property links the input field to a field in the loaded task record:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     features : {
 *         taskEdit : {
 *             items : {
 *                 generalTab : {
 *                     items : {
 *                         // Add new field to the last position
 *                         newGeneralField : {
 *                             type   : 'textfield',
 *                             weight : 610,
 *                             label  : 'New field in General Tab',
 *                             // Name of the field matches data field name, so value is loaded/saved automatically
 *                             name   : 'custom'
 *                         }
 *                     }
 *                 },
 *                 // Add a custom tab to the first position
 *                 newTab     : {
 *                     // Tab is a FormTab by default
 *                     title  : 'New tab',
 *                     weight : 90,
 *                     items  : {
 *                         newTabField : {
 *                             type   : 'textfield',
 *                             weight : 10,
 *                             label  : 'New field in New Tab',
 *                             // Name of the field matches data field name, so value is loaded/saved automatically.
 *                             // In this case it is equal to the Task "name" field.
 *                             name   : 'name'
 *                         }
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * To turn off the Task Editor just simple disable the feature.
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     features : {
 *         taskEdit : false
 *     }
 * })
 * ```
 *
 * By default predecessors and successors in successorsTab and predecessorsTab are displayed using task id and a name.
 *  The id part is configurable, any task field may be used instead (for example wbsCode or sequence number)
 * by Gantt `dependencyIdField` property, to set it globally, or using
 *  taskEdit config {@link SchedulerPro/widget/TaskEditorBase#config-dependencyIdField} to set format only for taskEditor.
 * ```javascript
 * const gantt = new Gantt({
 *    dependencyIdField: 'wbsCode', // for global format
 *
 *    project,
 *    columns : [
 *        { type : 'name', width : 250 }
 *    ],
 *    features : {
 *         taskEdit : {
 *             editorConfig : {
 *                 dependencyIdField : 'wbsCode' // set only for taskEditor
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * For more info on customizing the Task Editor, please see Guides/Customization/Customize task editor
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes SchedulerPro/feature/mixin/ProTaskEditStm
 * @mixes Core/mixin/Delayable
 * @demo SchedulerPro/taskeditor
 * @classtype taskEdit
 * @feature
 */

class TaskEdit extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_2__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"], _mixin_ProTaskEditStm_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Events

  /**
   * Fires on the owning Scheduler instance before a task is displayed in the editor.
   * This may be listened to in order to take over the task editing flow. Returning `false`
   * stops the default editing UI from being shown.
   * @event beforeTaskEdit
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance
   * @param {SchedulerPro.feature.TaskEdit} taskEdit The taskEdit feature
   * @param {SchedulerPro.model.EventModel} taskRecord The task about to be shown in the editor.
   * @param {HTMLElement} taskElement The element which represents the task
   * @preventable
   */

  /**
   * Fires on the owning Scheduler when the editor for an event is available but before it is shown. Allows
   * manipulating fields etc.
   * @event beforeTaskEditShow
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The SchedulerPro instance
   * @param {SchedulerPro.feature.TaskEdit} taskEdit The taskEdit feature
   * @param {SchedulerPro.model.EventModel} taskRecord The task about to be shown in the editor.
   * @param {HTMLElement} eventElement The element which represents the task
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor
   */

  /**
   * Fires on the owning Scheduler Pro instance before a task is saved
   * @event beforeTaskSave
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance
   * @param {SchedulerPro.model.EventModel} taskRecord The task about to be saved
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   * @preventable
   */

  /**
   * Fires on the owning Scheduler Pro instance after a task is saved
   * @event afterTaskSave
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance
   * @param {SchedulerPro.model.EventModel} taskRecord The task about to be saved
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   */

  /**
   * Fires on the owning Scheduler Pro before a task is deleted, return `false` to prevent it.
   * @event beforeTaskDelete
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance.
   * @param {SchedulerPro.model.EventModel} taskRecord The record about to be deleted
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   * @preventable
   */

  /**
   * Fires on the owning Scheduler Pro instance before an event record is saved
   * @event beforeEventSave
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance
   * @param {SchedulerPro.model.EventModel} eventRecord The event record about to be saved
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   * @preventable
   */

  /**
   * Fires on the owning Scheduler Pro instance after an event record is saved
   * @event afterEventSave
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance
   * @param {SchedulerPro.model.EventModel} eventRecord The event record about to be saved
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   */

  /**
   * Fires on the owning Scheduler Pro before an event record is deleted, return `false` to prevent it.
   * @event beforeEventDelete
   * @on-owner
   * @param {SchedulerPro.view.SchedulerPro} source The Scheduler Pro instance.
   * @param {SchedulerPro.model.EventModel} eventRecord The event record about to be deleted
   * @param {SchedulerPro.widget.TaskEditorBase} editor The editor widget
   * @preventable
   */
  //endregion
  //region Config
  static get $name() {
    return 'TaskEdit';
  }

  static get pluginConfig() {
    return {
      chain: ['getEventMenuItems', 'onEventEnterKey'],
      assign: ['editEvent']
    };
  }

  static get defaultConfig() {
    return {
      /**
       * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
       * @config {String}
       * @default
       * @category Editor
       */
      triggerEvent: 'eventdblclick',

      /**
       * Project type to editor class map. Editor will be used depending on project, not on product.
       *
       * @config {Object}
       * @internal
       * @category Editor
       */
      editorClassMap: {
        [_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_11__["ProjectType"].SchedulerBasic]: 'schedulertaskeditor',
        [_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_11__["ProjectType"].SchedulerPro]: 'schedulertaskeditor',
        [_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_11__["ProjectType"].Gantt]: 'gantttaskeditor'
      },
      // TODO: deprecate it in favor of `editorConfig : { type : 'xxx' }`

      /**
       * Class to use as the editor. By default it picks editor class depending on the project type.
       * It can be either {@link SchedulerPro.widget.SchedulerTaskEditor SchedulerTaskEditor} or
       * {@link SchedulerPro.widget.GanttTaskEditor GanttTaskEditor}.
       * By specifying your own `editorClass` you override this.
       * @config {Core.widget.Widget}
       * @typings {typeof Widget}
       * @category Editor
       */
      editorClass: null,

      /**
       * A configuration object applied to the internal {@link SchedulerPro.widget.TaskEditorBase TaskEditor}.
       * Useful to for example change the title of the editor or to set its dimensions in code:
       *
       * ```javascript
       * features : {
       *     taskEdit : {
       *         editorConfig : {
       *             title : 'My title',
       *             height : 300
       *         }
       *     }
       * }
       * ```
       *
       * NOTE: The easiest approach to affect editor contents is to use the {@link #config-items items config}.
       *
       *  @config {Object}
       */
      editorConfig: null,

      /**
       * Deprecated, use {@link #config-editorConfig} instead:
       * ```javascript
       * const scheduler = new SchedulerPro({
       *     features : {
       *         taskEdit : {
       *             editorConfig : {
       *                 bbar : {
       *                     items : {
       *                         deleteButton : false
       *                     }
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       * @config {Boolean}
       * @default
       * @category Editor widgets
       * @deprecated 5.0.0 Removed in favor of using {@link #config-editorConfig}
       */
      showDeleteButton: null,

      /**
       * True to show a confirmation dialog before deleting the event
       * @config {Boolean}
       * @default
       * @category Editor widgets
       */
      confirmDelete: true,

      /**
       * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
       * @config {Boolean}
       * @default
       * @category Editor
       */
      saveAndCloseOnEnter: true,

      /**
       * The week start day used in all date fields of the feature editor form by default.
       * 0 means Sunday, 6 means Saturday.
       * Defaults to the locale's week start day.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * Set to false to not scroll event into view when invoking edit action (e.g. if event is only partially visible)
       * @config {Boolean}
       * @default
       */
      scrollIntoView: true
    };
  }

  static get configurable() {
    return {
      /**
       * A configuration object used to customize the contents of the task editor. Supply a config object or
       * boolean per tab (listed below) to either affects its contents or toggle it on/off.
       *
       * Supplied config objects will be merged with the tabs predefined configs.
       *
       * Built-in tab names are:
       *  * generalTab
       *  * predecessorsTab
       *  * successorsTab
       *  * advancedTab
       *  * notesTab
       *
       *  ```
       *  features : {
       *      taskEdit : {
       *          items : {
       *              // Custom settings and additional items for the general tab
       *              generalTab : {
       *                  title : 'Common',
       *                  items : {
       *                      durationField : false,
       *                      myCustomField : {
       *                          type : 'text',
       *                          name : 'color'
       *                      }
       *                  }
       *              },
       *              // Hide the advanced tab
       *              advancedTab : false
       *          }
       *      }
       *  }
       *  ```
       *
       *  Please see the `taskeditor` demo for a customized editor in action.
       *  @config {Object}
       */
      items: null
    };
  } //endregion
  //region Constructor/Destructor


  construct(scheduler, config) {
    scheduler.taskEdit = this;
    super.construct(scheduler, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].assign({
      weekStartDay: scheduler.weekStartDay
    }, config));
    scheduler.on({
      [this.triggerEvent]: 'onActivateEditor',
      readOnly: 'onClientReadOnlyToggle',
      dragCreateEnd: 'onDragCreateEnd',
      thisObj: this
    });
  }

  doDestroy() {
    var _this$editor;

    this.detachFromProject();
    (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();

    if (this.deleteConfirmationPromise) {
      _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_6__["default"].hide();
    }

    super.doDestroy();
  } //endregion
  //region Internal


  onClientReadOnlyToggle({
    readOnly
  }) {
    if (this.editor) {
      this.editor.readOnly = readOnly;
    }
  }

  get scheduler() {
    return this.client;
  }

  getElementFromTaskRecord(taskRecord, resourceRecord) {
    return this.client.getElementFromEventRecord(taskRecord, resourceRecord);
  }

  scrollEventIntoView(eventRecord, resourceRecord) {
    this.client.scrollResourceEventIntoView(resourceRecord, eventRecord);
  }

  get isValid() {
    return this.editor.eachWidget(widget => {
      if (widget.isValid === true || widget.hidden || widget.disabled || widget instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__["default"] && !widget.name) {
        return true;
      }

      return widget.isValid !== false;
    }, true);
  } //endregion
  //region Project


  get project() {
    return this.scheduler.project;
  }

  attachToProject() {
    this.detachFromProject();
    this.project.on({
      name: 'project',
      loadstart: () => this.save(),
      dataReady: 'onDataReady',
      thisObj: this
    });
  }

  detachFromProject() {
    this.detachListeners('project');
  } //endregion


  onDataReady() {
    const {
      record
    } = this; // Record could've been removed from project

    if (record !== null && record !== void 0 && record.project && this.scheduler.taskStore.includes(record)) {
      this.load(record, true);
    } else {
      this.editor.close();
    }
  } //region Editor

  /**
   * Returns true if the editor is currently active
   * @readonly
   * @property {Boolean}
   */


  get isEditing() {
    return !!this._editing;
  }

  onActivateEditor({
    eventRecord,
    resourceRecord,
    eventElement
  }) {
    this.editEvent(eventRecord, resourceRecord, eventElement);
  }
  /**
   * Shows a {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or {@link SchedulerPro.widget.GanttTaskEditor gantt task editor}
   * to edit the passed task. This function is exposed on the Scheduler Pro instance and can be called as `scheduler.editTask()`.
   * @param {SchedulerPro.model.EventModel|Function} taskRecord Task to edit or a function returning a task to edit,
   * the function will be executed within an STM transaction which will be canceled in case user presses Cancel button
   * or closes editor w/o hitting Save.
   * @param {SchedulerPro.model.ResourceModel} [resourceRecord] The Resource record for the event. This parameter is
   * required if the event is newly created for a resource and has not been assigned, or when using multi assignment.
   * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
   * @return {Promise} Promise which resolves after the editor is shown
   * @async
   */


  async editEvent(taskRecord, resourceRecord = null, element = null) {
    const me = this,
          {
      scheduler
    } = me; // If we are editing, cancel the edit.

    if (me.isEditing) {
      me.cancel();
    } // We may have just canceled the edit above, or some other user gesture may
    // have begun canceling prior to that.
    // Either way, we must wait for it to cancel before the new edit can begin.


    if (me._canceling) {
      await me._canceling;
    }

    if (!resourceRecord) {
      var _taskRecord$resources;

      // In case of assignments, take the first resource
      resourceRecord = taskRecord.resource || ((_taskRecord$resources = taskRecord.resources) === null || _taskRecord$resources === void 0 ? void 0 : _taskRecord$resources[0]);
    }

    if (!me.disabled) {
      const {
        taskStore
      } = scheduler;
      me._editing = true;
      me.captureStm();
      me.startStmTransaction();
      scheduler.project.suspendAutoSync();

      if (typeof taskRecord === 'function') {
        taskRecord = taskRecord();
      } // If this is a new record, add it to the store and assign to a resource only after we have started a transaction
      // which can be rolled back in case of Cancel button press


      if (!taskRecord.isOccurrence && !taskStore.includes(taskRecord) && !taskRecord.isCreating) {
        taskRecord.isCreating = true;
        taskStore.add(taskRecord);

        if (resourceRecord) {
          scheduler.assignmentStore.assignEventToResource(taskRecord, resourceRecord);
        }

        await scheduler.project.commitAsync();
      } // For programmatic edit calls for an event not currently in view, scroll it into view first


      if (me.scrollIntoView && !element && taskStore.includes(taskRecord) && (resourceRecord || scheduler.isGantt)) {
        await me.scrollEventIntoView(taskRecord, resourceRecord);
      }

      const taskElement = element || _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].down(me.getElementFromTaskRecord(taskRecord, resourceRecord), scheduler.eventInnerSelector),
            editor = me.getEditor(taskRecord);

      if (scheduler.trigger('beforeTaskEdit', {
        taskEdit: me,
        taskRecord,
        taskElement
      }) !== false) {
        // The Promise being async allows a mouseover to trigger the event tip
        // unless we add the editing class immediately.
        scheduler.element.classList.add('b-taskeditor-editing');
        me.load(taskRecord);
        scheduler.trigger('beforeTaskEditShow', {
          taskEdit: me,
          taskRecord,
          taskElement,
          editor
        });

        if (editor.widgetMap.deleteButton) {
          editor.widgetMap.deleteButton.hidden = scheduler.readOnly || taskRecord.isCreating || me.showDeleteButton === false;
        }

        me.attachToProject();

        if (editor.centered) {
          await editor.show();
        } else {
          if (taskElement) {
            await editor.showBy({
              target: taskElement,
              anchor: true,
              offset: -5
            });
          } else {
            // Display the editor centered in the Scheduler
            await editor.showBy({
              target: scheduler.element,
              anchor: false,
              // For records not part of the store (new ones, or filtered out ones) - center the editor
              align: 'c-c'
            });
          }
        }
      } else {
        await me.rejectStmTransaction();
        me.disableStm();
        me.freeStm();
        me._editing = false;
      }
    }
  }

  getEditor(taskRecord = this.record) {
    const me = this;

    if (!me.editor) {
      var _me$editorConfig, _me$editor;

      const config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].merge({
        eventEditFeature: me,
        weekStartDay: me.weekStartDay,
        saveAndCloseOnEnter: me.saveAndCloseOnEnter,
        owner: me.client,
        dependencyIdField: ((_me$editorConfig = me.editorConfig) === null || _me$editorConfig === void 0 ? void 0 : _me$editorConfig.dependencyIdField) || me.client.dependencyIdField,
        project: me.project,
        durationDisplayPrecision: me.client.durationDisplayPrecision,
        tabPanelItems: me.items,
        listeners: {
          cancel: 'onCancel',
          delete: 'onDelete',
          save: 'onSave',
          thisObj: me
        },
        // For backward compatibility
        tabsConfig: me.tabsConfig
      }, me.editorConfig);
      (_me$editor = me.editor) === null || _me$editor === void 0 ? void 0 : _me$editor.destroy(); // Configured type should always win

      if (me.editorClass && !config.type) {
        me.editor = me.editorClass.new(config);
      } else {
        const // Editor will be used depending on project, not on product
        project = (taskRecord === null || taskRecord === void 0 ? void 0 : taskRecord.project) || me.project,
              projectType = project.getType();
        me.editor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__["default"].create(Object.assign({
          type: me.editorClassMap[projectType] || 'schedulertaskeditor'
        }, config));
      }
    } // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to


    me.editor.readOnly = me.client.readOnly;
    return me.editor;
  } //endregion
  //region Actions


  load(taskRecord, highlightChanges) {
    const me = this,
          editor = me.getEditor(taskRecord);
    me._loading = true;
    me.record = taskRecord;
    editor.loadEvent(taskRecord, highlightChanges);
    me._loading = false;
  }

  async save() {
    const me = this,
          {
      scheduler,
      record: taskRecord
    } = me;

    if (me.isEditing) {
      const editor = me.getEditor();

      if (!me.isValid || me.trigger('beforeTaskSave', {
        taskRecord,
        editor: editor
      }) === false) {
        return;
      }

      me.detachFromProject();
      editor.beforeSave(); // Turn a newly created record into a permanent one (no-op for others)

      taskRecord.isCreating = false;
      me.commitStmTransaction();
      me.freeStm();
      me._editing = false; // afterSave to happen only after the editor is fully invisible.

      await editor.close();
      scheduler.project.resumeAutoSync(true);
      scheduler.element.classList.remove('b-taskeditor-editing');
      me.trigger('afterTaskSave', {
        taskRecord,
        editor
      });
      editor.afterSave();
      scheduler.trigger('afterTaskEdit', {
        taskRecord,
        editor
      });
    }
  } // This is called by the TaskEditor's hide method prior to the super call,
  // so however it gets hidden, it will signal a cancel.


  async doCancel() {
    const me = this,
          {
      scheduler
    } = me;

    if (me.isEditing) {
      me._editing = false;
      me.detachFromProject();
      const taskRecord = me.record,
            project = me.project,
            editor = me.getEditor();
      editor.beforeCancel(); // the feature could get destroyed asynchronously

      if (me.isDestroyed) {
        return;
      }

      await me.rejectStmTransaction(); // the feature could get destroyed asynchronously

      if (me.isDestroyed) {
        return;
      }

      me.disableStm();
      await project.propagateAsync(); // the feature could get destroyed asynchronously

      if (me.isDestroyed) {
        return;
      }

      me.freeStm();
      editor.afterCancel();
      scheduler.project.resumeAutoSync(false);
      me.scheduler.element.classList.remove('b-taskeditor-editing');
      scheduler.trigger('taskEditCanceled', {
        taskRecord,
        editor
      });
      scheduler.trigger('afterTaskEdit', {
        taskRecord,
        editor
      });
    }
  }

  async cancel() {
    const me = this; // Newly created records are already in TaskStore, must be removed on cancel

    if (me.record.isCreating) {
      return me.delete();
    }

    return me._canceling || (me._canceling = me.doCancel().finally(() => me._canceling = undefined));
  }

  async delete() {
    const me = this,
          {
      editor,
      scheduler,
      record: taskRecord
    } = me;

    if (me.trigger('beforeTaskDelete', {
      taskRecord,
      editor
    }) === false) {
      return;
    }

    me.detachFromProject();
    editor.beforeDelete();
    taskRecord.remove();
    me.freeStm();
    await me.project.commitAsync(); // the feature could get destroyed asynchronously

    if (me.isDestroyed) {
      return;
    } // Resume and sync, unless we are removing a newly created record (via cancel)


    me.project.resumeAutoSync(!taskRecord.isCreating);
    me._editing = false;
    editor.close();
    editor.afterDelete();
    scheduler.element.classList.remove('b-taskeditor-editing');
    scheduler.trigger('afterTaskEdit', {
      editor
    });
  } //endregion
  //region Events


  onSave() {
    // There's might be propagation requested, so we giving the chance to start propagating
    // before we're doing save commit procedure.
    this.requestAnimationFrame(() => this.save());
  }

  onCancel() {
    this.cancel();
  }

  async onDelete() {
    const me = this;

    if (me.confirmDelete) {
      // TODO: Ask nige about a better solution to prevent popup from closing when showing dialog
      const {
        editor
      } = me,
            autoClose = editor.autoClose;
      editor.autoClose = false;
      me.deleteConfirmationPromise = _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_6__["default"].confirm({
        title: 'L{TaskEdit.ConfirmDeletionTitle}',
        message: 'L{TaskEdit.ConfirmDeletionMessage}',
        okButton: 'L{TaskEditorBase.Delete}',
        rootElement: me.rootElement
      });
      const result = await me.deleteConfirmationPromise;
      editor.autoClose = autoClose;
      me.deleteConfirmationPromise = null;

      if (result === _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_6__["default"].yesButton) {
        me.delete();
      }
    } else {
      // There's might be propagation requested, so we giving the chance to start propagating
      // before we're doing cancel rejection procedure.
      me.requestAnimationFrame(() => me.delete());
    }
  }

  onDragCreateEnd({
    eventRecord,
    resourceRecord,
    proxyElement
  }) {
    // Only edit if it a real create. If it is a drag to schedule an already existing
    // event in gantt, then we do not offer the edit UI.
    if (!this.disabled && eventRecord.isCreating) {
      this.editEvent(eventRecord, resourceRecord);
    }
  } //endregion
  //region Context menu


  getEventMenuItems({
    eventRecord,
    resourceRecord,
    items
  }) {
    if (!this.scheduler.readOnly) {
      items.editEvent = {
        text: 'L{Edit task}',
        localeClass: this,
        icon: 'b-icon b-icon-edit',
        weight: -200,
        disabled: this.disabled,
        onItem: () => this.editEvent(eventRecord, resourceRecord)
      };
    }
  } // chained from EventNavigation


  onEventEnterKey({
    assignmentRecord,
    eventRecord
  }) {
    if (assignmentRecord) {
      this.editEvent(eventRecord, assignmentRecord.resource);
    } else if (eventRecord) {
      this.editEvent(eventRecord, eventRecord.resource);
    }
  } //endregion
  // Fire 2 events with param / event name using 'task' + 'event'


  trigger(name, params) {
    if (/task/i.test(name)) {
      const returnValTaskRecord = this.scheduler.trigger(...arguments),
            eventEvent = name.replace(/task/, 'event').replace(/Task/, 'Event');
      params.eventRecord = params.taskRecord; // RecurringEvents mixin expects there to be 'eventRecords' in the beforeEventDelete event

      params.eventRecords = [params.taskRecord];
      const returnValEventRecord = this.scheduler.trigger(eventEvent, params);
      return returnValTaskRecord && returnValEventRecord;
    }

    return super.trigger(...arguments);
  }

  get showDeleteButton() {
    return this._showDeleteButton;
  }

  set showDeleteButton(showDeleteButton) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].deprecate('SchedulerPro', '5.0.0', '`showDeleteButton` config is deprecated, in favor of `editorConfig`. Please see https://bryntum.com/docs/scheduler-pro/guide/SchedulerPro/upgrades/4.0.4 for more information.');
    this._showDeleteButton = showDeleteButton;
  }

}
TaskEdit._$name = 'TaskEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(TaskEdit, true, 'SchedulerPro'); //, 'EventEdit');

_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerFeature(TaskEdit, false, 'ResourceHistogram');

/***/ }),

/***/ "./lib/SchedulerPro/feature/mixin/ProTaskEditStm.js":
/*!**********************************************************!*\
  !*** ./lib/SchedulerPro/feature/mixin/ProTaskEditStm.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/feature/mixin/ProTaskEditStm
 */

/**
 * Mixin adding STM transactable behavior to TaskEdit feature.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TaskEditStm extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TaskEditStm';
  }

  captureStm() {
    const me = this,
          project = me.project,
          stm = project.getStm();
    me.stmInitiallyDisabled = stm.disabled;
    me.stmInitiallyAutoRecord = stm.autoRecord;

    if (me.stmInitiallyDisabled) {
      stm.enable(); // it seems this branch has never been exercised by tests
      // but the intention is to stop the auto-recording while
      // task editor is active (all editing is one manual transaction)

      stm.autoRecord = false;
    } else {
      if (me.stmInitiallyAutoRecord) {
        stm.autoRecord = false;
      }

      if (stm.isRecording) {
        stm.stopTransaction();
      }
    }
  }

  startStmTransaction() {
    // TODO: Create title: "Editing event/task 'name'"
    this.project.getStm().startTransaction();
  }

  commitStmTransaction() {
    const me = this,
          stm = me.project.getStm();
    stm.stopTransaction();

    if (me.stmInitiallyDisabled) {
      stm.resetQueue();
    }
  }

  async rejectStmTransaction() {
    var _stm$transaction;

    const stm = this.project.getStm(),
          {
      client
    } = this;

    if ((_stm$transaction = stm.transaction) !== null && _stm$transaction !== void 0 && _stm$transaction.length) {
      client.suspendRefresh();
      stm.forEachStore(s => s.beginBatch());
      stm.rejectTransaction();
      stm.forEachStore(s => s.endBatch());
      await client.resumeRefresh(true);
    } else {
      stm.stopTransaction();
    }
  }

  enableStm() {
    this.project.getStm().enable();
  }

  disableStm() {
    this.project.getStm().disable();
  }

  freeStm() {
    const me = this,
          stm = me.project.getStm();
    stm.disabled = me.stmInitiallyDisabled;
    stm.autoRecord = me.stmInitiallyAutoRecord;
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/localization/En.js":
/*!*********************************************!*\
  !*** ./lib/SchedulerPro/localization/En.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Scheduler_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/localization/En.js */ "./lib/Scheduler/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
var productName = 'gantt';
 //<umd>



const locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeLocales(_Scheduler_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"], {
  ConstraintTypePicker: {
    none: 'None',
    muststarton: 'Must start on',
    mustfinishon: 'Must finish on',
    startnoearlierthan: 'Start no earlier than',
    startnolaterthan: 'Start no later than',
    finishnoearlierthan: 'Finish no earlier than',
    finishnolaterthan: 'Finish no later than'
  },
  CalendarField: {
    'Default calendar': 'Default calendar'
  },
  TaskEditorBase: {
    Information: 'Information',
    Save: 'Save',
    Cancel: 'Cancel',
    Delete: 'Delete',
    calculateMask: 'Calculating...',
    saveError: 'Can\'t save, please correct errors first'
  },
  TaskEdit: {
    'Edit task': 'Edit task',
    ConfirmDeletionTitle: 'Confirm deletion',
    ConfirmDeletionMessage: 'Are you sure you want to delete the event?'
  },
  GanttTaskEditor: {
    editorWidth: '44em'
  },
  SchedulerTaskEditor: {
    editorWidth: '32em'
  },
  SchedulerGeneralTab: {
    labelWidth: '6em',
    General: 'General',
    Name: 'Name',
    Resources: 'Resources',
    '% complete': '% complete',
    Duration: 'Duration',
    Start: 'Start',
    Finish: 'Finish'
  },
  GeneralTab: {
    labelWidth: '6.5em',
    General: 'General',
    Name: 'Name',
    '% complete': '% complete',
    Duration: 'Duration',
    Start: 'Start',
    Finish: 'Finish',
    Effort: 'Effort',
    Dates: 'Dates'
  },
  SchedulerAdvancedTab: {
    labelWidth: '13em',
    Calendar: 'Calendar',
    Advanced: 'Advanced',
    'Manually scheduled': 'Manually scheduled',
    'Constraint type': 'Constraint type',
    'Constraint date': 'Constraint date',
    Inactive: 'Inactive'
  },
  AdvancedTab: {
    labelWidth: '11.5em',
    Advanced: 'Advanced',
    Calendar: 'Calendar',
    'Scheduling mode': 'Scheduling mode',
    'Effort driven': 'Effort driven',
    'Manually scheduled': 'Manually scheduled',
    'Constraint type': 'Constraint type',
    'Constraint date': 'Constraint date',
    Constraint: 'Constraint',
    Rollup: 'Rollup',
    Inactive: 'Inactive'
  },
  DependencyTab: {
    Predecessors: 'Predecessors',
    Successors: 'Successors',
    ID: 'ID',
    Name: 'Name',
    Type: 'Type',
    Lag: 'Lag',
    cyclicDependency: 'Cyclic dependency',
    invalidDependency: 'Invalid dependency'
  },
  NotesTab: {
    Notes: 'Notes'
  },
  ResourcesTab: {
    unitsTpl: ({
      value
    }) => `${value}%`,
    Resources: 'Resources',
    Resource: 'Resource',
    Units: 'Units'
  },
  SchedulingModePicker: {
    Normal: 'Normal',
    'Fixed Duration': 'Fixed Duration',
    'Fixed Units': 'Fixed Units',
    'Fixed Effort': 'Fixed Effort'
  },
  ResourceHistogram: {
    barTipInRange: '<b>{resource}</b> {startDate} - {endDate}<br><span class="{cls}">{allocated} of {available}</span> allocated',
    barTipOnDate: '<b>{resource}</b> on {startDate}<br><span class="{cls}">{allocated} of {available}</span> allocated',
    groupBarTipAssignment: '<b>{resource}</b> - <span class="{cls}">{allocated} of {available}</span>',
    groupBarTipInRange: '{startDate} - {endDate}<br><span class="{cls}">{allocated} of {available}</span> allocated:<br>{assignments}',
    groupBarTipOnDate: 'On {startDate}<br><span class="{cls}">{allocated} of {available}</span> allocated:<br>{assignments}',
    plusMore: '+{value} more'
  },
  DurationColumn: {
    Duration: 'Duration'
  }
});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/SchedulerPro/model/AssignmentModel.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/model/AssignmentModel.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/model/mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_pro_SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProAssignmentMixin.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';




/**
 * @module SchedulerPro/model/AssignmentModel
 */

/**
 * This class represent a single assignment of a resource to an event in Scheduler Pro. It has a lot in common with
 * Schedulers AssignmentModel, they are separate models but they share much functionality using the
 * {@link Scheduler.model.mixin.AssignmentModelMixin AssignmentModelMixin} mixin.
 *
 * It is a subclass of {@link Core.data.Model} class. Please refer to the documentation for that class to become
 * familiar with the base interface of this class.
 *
 * ## Fields and references
 *
 * An Assignment has the following fields:
 * - `id` - The id of the assignment
 * - `resourceId` - The id of the resource assigned (optionally replaced with `resource` for load)
 * - `eventId` - The id of the event to which the resource is assigned (optionally replaced with `event` for load)
 *
 * The data source for these fields can be customized by subclassing this class:
 *
 * ```javascript
 * class MyAssignment extends AssignmentModel {
 *   static get fields() {
 *       return [
 *          { name : 'resourceId', dataSource : 'linkedResource' }
 *       ];
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `event` - The linked event record
 * - `resource` - The linked resource record
 *
 * ## Async resolving of references
 *
 * As described above, an assignment links an event to a resource. It holds references to an event record and a resource
 * record. These references are populated async, using the calculation engine of the project that the assignment via
 * its store is a part of. Because of this asyncness, references cannot be used immediately after modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // assignment.resource is not yet available
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // assignment.resource is available
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // assignment.resource is available
 * ```
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/AssignmentModelMixin
 * @uninherit Core/data/mixin/TreeNode
 * @typings Scheduler/model/AssignmentModel -> Scheduler/model/SchedulerAssignmentModel
 */

class AssignmentModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_model_scheduler_pro_SchedulerProAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_2__["SchedulerProAssignmentMixin"].derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  // NOTE: Leave field defs at top to be picked up by jsdoc

  /**
   * Id for event to assign. Can be used as an alternative to `eventId`, but please note that after
   * load it will be populated with the actual event and not its id. This field is not persistable.
   * @field {SchedulerPro.model.EventModel} event
   * @accepts {String|Number|SchedulerPro.model.EventModel}
   * @typings {String|Number|SchedulerPro.model.EventModel|Core.model.Model}
   * @category Common
   */

  /**
   * Id for resource to assign to. Can be used as an alternative to `resourceId`, but please note that after
   * load it will be populated with the actual resource and not its id. This field is not persistable.
   * @field {SchedulerPro.model.ResourceModel} resource
   * @accepts {String|Number|SchedulerPro.model.ResourceModel}
   * @category Common
   */
  //region Config
  static get $name() {
    return 'AssignmentModel';
  }

  static get isProAssignmentModel() {
    return true;
  } //endregion


}
AssignmentModel._$name = 'AssignmentModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/CalendarIntervalModel.js":
/*!*********************************************************!*\
  !*** ./lib/SchedulerPro/model/CalendarIntervalModel.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarIntervalModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/calendar/CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/model/CalendarIntervalModel
 */

/**
 * This is a documentation-only class, representing an interval in the {@link SchedulerPro/model/CalendarModel calendar}
 *
 * Please refer to the [calendars guide](#SchedulerPro/guides/basics/calendars.md) for details
 */

class CalendarIntervalModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIntervalMixin"].derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  // NOTE: Leave field defs at top to be picked up by jsdoc
  //region Fields

  /**
   * The start date of the fixed (not recurrent) time interval.
   *
   * @field {Date} startDate
   */

  /**
   * The end date of the fixed (not recurrent) time interval.
   *
   * @field {Date} endDate
   */

  /**
   * The start date of the recurrent time interval. Should be specified as any expression, recognized
   * by the excellent [later](http://bunkat.github.io/later/) library.
   *
   * @field {String} recurrentStartDate
   */

  /**
   * The end date of the recurrent time interval. Should be specified as any expression, recognized
   * by the excellent [later](http://bunkat.github.io/later/) library.
   *
   * @field {String} recurrentEndDate
   */

  /**
   * The "is working" flag, which defines what kind of interval this is - either working or non-working. Default value is `false`,
   * denoting non-working intervals.
   *
   * @field {Boolean} isWorking
   * @default false
   */
  //endregion
  //region Methods

  /**
   * Whether this interval is recurrent (both `recurrentStartDate` and `recurrentEndDate` are present and parsed correctly
   * by the `later` library).
   *
   * @method isRecurrent
   * @returns {Boolean}
   */

  /**
   * Whether this interval is static - both `startDate` and `endDate` are present.
   *
   * @method isStatic
   * @returns {Boolean}
   */

  /**
   * Returns an internal representation of the recurrent start date from the `later` library.
   *
   * @method getStartDateSchedule
   * @returns {Object}
   */

  /**
   * Returns an internal representation of the recurrent end date from the `later` library.
   *
   * @method getEndDateSchedule
   * @returns {Object}
   */
  //endregion
  //region Config
  static get $name() {
    return 'CalendarIntervalModel';
  } //endregion


}
CalendarIntervalModel._$name = 'CalendarIntervalModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/CalendarModel.js":
/*!*************************************************!*\
  !*** ./lib/SchedulerPro/model/CalendarModel.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CalendarIntervalModel.js */ "./lib/SchedulerPro/model/CalendarIntervalModel.js");
var productName = 'gantt';




/**
 * @module SchedulerPro/model/CalendarModel
 */

/**
 * This class represents a calendar in the Scheduler Pro project. It contains a collection of the {@link SchedulerPro.model.CalendarIntervalModel}.
 * Every interval can be either recurrent (regularly repeating in time) or static.
 *
 * Please refer to the [calendars guide](#SchedulerPro/guides/basics/calendars.md) for details
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 *
 * @extends Core/data/Model
 */

class CalendarModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__["BaseCalendarMixin"].derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  //region Config
  static get $name() {
    return 'CalendarModel';
  }
  /**
   * Returns the earliest point at which a working period of time starts, following the given date.
   * Can be the date itself, if it occurs during working time.
   * @method skipNonWorkingTime
   * @param {Date} date The date after which to skip the non-working time
   * @param {Boolean} [isForward=true] Whether the "following" means forward in time or backward
   * @returns {Date} The earliest available date
   */

  /**
   * This method adds a single {@link SchedulerPro.model.CalendarIntervalModel} to the internal collection of the calendar
   * @method addInterval
   * @param {SchedulerPro.model.CalendarIntervalModel|Object} interval {@link SchedulerPro.model.CalendarIntervalModel} record or an object with data used to create a new record
   * @returns {SchedulerPro.model.CalendarIntervalModel[]} Added intervals
   */

  /**
   * This method adds an array of {@link SchedulerPro.model.CalendarIntervalModel} to the internal collection of the calendar
   * @method addIntervals
   * @param {SchedulerPro.model.CalendarIntervalModel[]|Object[]} intervals An array of {@link SchedulerPro.model.CalendarIntervalModel} records or an array of objects with data used to create new records
   * @returns {SchedulerPro.model.CalendarIntervalModel[]} Added intervals
   */

  /**
   * This method removes all intervals from the internal collection of the calendar
   * @method clearIntervals
   * @param {Boolean} [silent] Do not trigger events
   */

  /**
   * Calculate the working time duration for specific interval, in milliseconds.
   * @method calculateDurationMs
   * @param {Date} startDate Start of the interval
   * @param {Date} endDate End of the interval
   * @returns {Number} Returns working time in milliseconds
   */

  /**
   * Checks if there is a working time interval in the provided time range
   * @method isWorkingTime
   * @param {Date} startDate Start of the interval
   * @param {Date} endDate End of the interval
   * @returns {Boolean} Returns `true` if the interval contains working time
   */


  static get fields() {
    return [
      /**
       * The calendar name.
       * @field {String} name
       */

      /**
       * The flag, indicating, whether the "unspecified" time (time that does not belong to any interval
       * is working (`true`) or not (`false`).
       *
       * @field {Boolean} unspecifiedTimeIsWorking
       * @default true
       */

      /**
       * {@link SchedulerPro.model.CalendarIntervalModel Intervals} collection of the calendar
       * @field {SchedulerPro.model.CalendarIntervalModel[]} intervals
       */
    ];
  } //endregion


  toString() {
    return this.name || '';
  }

  static get defaultConfig() {
    return {
      calendarIntervalModelClass: _CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_3__["default"]
    };
  }

}
CalendarModel._$name = 'CalendarModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/DependencyModel.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/model/DependencyModel.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyModel; });
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony import */ var _Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony import */ var _Engine_quark_model_scheduler_pro_SchedulerProDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_pro/SchedulerProDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProDependencyMixin.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/model/DependencyModel
 */

/**
 * This model represents a dependency between two events, usually added to a {@link SchedulerPro.data.DependencyStore}.
 *
 * It is a subclass of the {@link Scheduler.model.DependencyBaseModel} class, which in its turn subclasses
 * {@link Core.data.Model}. Please refer to documentation of those classes to become familiar with the base interface of
 * this class.
 *
 * ## Fields and references
 *
 * A Dependency has a few predefined fields, see Fields below.  The name of any fields data source can be customized in
 * the subclass, see the example below. Please also refer to {@link Core.data.Model} for details.
 *
 * ```javascript
 * class MyDependency extends DependencyModel {
 *   static get fields() {
 *     return [
 *       { name: 'to', dataSource: 'targetId' },
 *       { name: 'from', dataSource: 'sourceId' }
 *     ]);
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `fromEvent` - The event on the start side of the dependency
 * - `toEvent` - The event on the end side of the dependency
 *
 * ## Async resolving of references
 *
 * As described above, a dependency has links to events. These references are populated async, using the calculation
 * engine of the project that the resource via its store is a part of. Because of this asyncness, references cannot be
 * used immediately after modifications:
 *
 * ```javascript
 * dependency.from = 2;
 * // dependency.fromEvent is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * dependency.from = 2;
 * await dependency.project.commitAsync();
 * // dependency.fromEvent is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await dependency.setAsync({ from : 2});
 * // dependency.fromEvent is up to date
 * ```
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @extends Scheduler/model/DependencyBaseModel
 *
 * @typings Scheduler/model/DependencyModel -> Scheduler/model/SchedulerDependencyModel
 */

class DependencyModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(_Engine_quark_model_scheduler_pro_SchedulerProDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__["SchedulerProDependencyMixin"].derive(_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_1__["default"])) {
  // NOTE: Leave field defs at top to be picked up by jsdoc

  /**
   * The calendar of the dependency used to take `lag` duration into account.
   * @field {SchedulerPro.model.CalendarModel} calendar
   */

  /**
   * Set to false to ignore this dependency in scheduling
   * @field {Boolean} active
   * @category Dependency
   */
  //region Config
  static get $name() {
    return 'DependencyModel';
  }

  static get isProDependencyModel() {
    return true;
  } //endregion


}
DependencyModel._$name = 'DependencyModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/EventModel.js":
/*!**********************************************!*\
  !*** ./lib/SchedulerPro/model/EventModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventModel; });
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/PercentDoneMixin.js */ "./lib/SchedulerPro/model/mixin/PercentDoneMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_pro_SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_pro/SchedulerProEvent.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProEvent.js");
/* harmony import */ var _Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Scheduler/model/mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Scheduler/model/mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/model/EventModel
 */

/**
 * This class represent a single event in your schedule, usually added to a {@link SchedulerPro.data.EventStore}.
 *
 * It is a subclass of the {@link Scheduler.model.TimeSpan}, which is in turn subclass of {@link Core.data.Model}.
 * Please refer to documentation of that class to become familiar with the base interface of the event.
 *
 * ## Async date calculations
 *
 * A record created from an `EventModel` is normally part of an `EventStore`, which in turn is part of a project. When
 * dates or the duration of an event is changed, the project performs async calculations to normalize the other fields.
 * For example if `duration` is change, it will calculate `endDate`.
 *
 * As a result of this being an async operation, the values of other fields are not guaranteed to be up to date
 * immediately after a change. To ensure data is up to date, await the calculations to finish.
 *
 * For example, `endDate` is not up to date after this operation:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * // endDate not yet calculated
 * ```
 *
 * But if calculations are awaited it is up to date:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * await eventRecord.project.commitAsync();
 * // endDate is calculated
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await eventRecord.setAsync({ duration : 5});
 * // endDate is calculated
 * ```
 *
 * ## Subclassing the Event model class
 * The Event model has a few predefined fields as seen below. If you want to add new fields or change the options for
 * the existing fields, you can do that by subclassing this class (see example below).
 *
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            // Add new field
 *            { name: 'myField', type : 'number', defaultValue : 0 }
 *         ];
 *     },
 *
 *     myCheckMethod() {
 *         return this.myField > 0
 *     },
 *
 *     ...
 * });
 * ```
 * If you in your data want to use other names for the startDate, endDate, resourceId and name fields you can configure
 * them as seen below:
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            { name: 'startDate', dataSource 'taskStart' },
 *            { name: 'endDate', dataSource 'taskEnd', format: 'YYYY-MM-DD' },
 *            { name: 'resourceId', dataSource 'userId' },
 *            { name: 'name', dataSource 'taskTitle' },
 *         ];
 *     },
 *     ...
 * });
 * ```
 *
 * Please refer to {@link Core.data.Model} for additional details.
 *
 * @extends Scheduler/model/TimeSpan
 * @mixes Scheduler/model/mixin/RecurringTimeSpan
 * @mixes Scheduler/model/mixin/EventModelMixin
 * @mixes SchedulerPro/model/mixin/PercentDoneMixin
 * @mixes SchedulerPro/data/mixin/PartOfProject
 *
 * @typings Scheduler/model/EventModel -> Scheduler/model/SchedulerEventModel
 */

class EventModel extends _Engine_quark_model_scheduler_pro_SchedulerProEvent_js__WEBPACK_IMPORTED_MODULE_2__["SchedulerProEvent"].derive(_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_4__["default"]).mixin(_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_5__["default"], _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_0__["default"], _Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  /**
   * Returns the event store this event is part of.
   *
   * @member {SchedulerPro.data.EventStore} eventStore
   * @readonly
   * @typings Scheduler/model/TimeSpan:eventStore -> {Scheduler.data.EventStore|SchedulerPro.data.EventStore}
   */

  /**
   * If given resource is assigned to this event, returns a {@link SchedulerPro.model.AssignmentModel} record.
   * Otherwise returns `null`
   *
   * @method getAssignmentFor
   * @param {SchedulerPro.model.ResourceModel} resource The instance of {@link SchedulerPro.model.ResourceModel}
   *
   * @return {SchedulerPro.model.AssignmentModel|null}
   */

  /**
   * This method assigns a resource to this event.
   *
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method assign
   * @param {SchedulerPro.model.ResourceModel} resource The instance of {@link SchedulerPro.model.ResourceModel}
   * @param {Number} [units=100] The `units` field of the new assignment
   *
   * @returns {Promise}
   * @propagating
   */

  /**
   * This method unassigns a resource from this event.
   *
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method unassign
   * @param {SchedulerPro.model.ResourceModel} resource The instance of {@link SchedulerPro.model.ResourceModel}
   *
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the calendar of the event. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setCalendar
   * @param {SchedulerPro.model.CalendarModel} calendar The new calendar. Provide `null` to fall back to the project calendar.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Returns the event calendar.
   *
   * @method getCalendar
   * @returns {SchedulerPro.model.CalendarModel} The event calendar.
   */

  /**
   * Either activates or deactivates the task depending on the passed value.
   * Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setInactive
   * @param {boolean} inactive `true` to deactivate the task, `false` to activate it.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the start date of the event. Will cause the schedule to be updated - returns a `Promise`
   *
   * Note, that the actually set start date may be adjusted, according to the calendar, by skipping the non-working time forward.
   *
   * @method setStartDate
   * @param {Date} date The new start date.
   * @param {Boolean} [keepDuration=true] Whether to keep the duration (and update the end date), while changing the start date, or vice-versa.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the end date of the event. Will cause the schedule to be updated - returns a `Promise`
   *
   * Note, that the actually set end date may be adjusted, according to the calendar, by skipping the non-working time backward.
   *
   * @method setEndDate
   * @param {Date} date The new end date.
   * @param {Boolean} [keepDuration=false] Whether to keep the duration (and update the start date), while changing the end date, or vice-versa.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Updates the duration (and optionally unit) of the event. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setDuration
   * @param {Number} duration New duration value
   * @param {String} [unit] New duration unit
   * @returns {Promise}
   * @propagating
   */

  /**
   * Updates the effort (and optionally unit) of the event. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setEffort
   * @param {Number} effort New effort value
   * @param {String} [unit] New effort unit
   * @returns {Promise}
   * @propagating
   */

  /**
   * Sets the constraint type and (optionally) constraining date to the event.
   *
   * @method setConstraint
   * @param {String} constraintType Constraint type, please refer to the {@link SchedulerPro.model.EventModel#field-constraintType} for the valid values.
   * @param {Date}   [constraintDate] Constraint date.
   * @returns {Promise}
   * @propagating
   */
  //region Config
  static get $name() {
    return 'EventModel';
  }

  static get isProEventModel() {
    return true;
  }

  static get fields() {
    return [
    /**
     * The current status of a task, expressed as the percentage completed (integer from 0 to 100)
     *
     * UI fields representing this data field are disabled for summary events.
     * See {@link #function-isEditable} for details.
     *
     * @field {Number} percentDone
     * @category Scheduling
     */

    /**
     * The start date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The end date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The numeric part of the timespan's duration (the number of units).
     *
     * UI fields representing this data field are disabled for summary events
     * except the {@link #field-manuallyScheduled manually scheduled} events.
     * See {@link #function-isEditable} for details.
     *
     * @field {Number} duration
     * @category Scheduling
     */

    /**
     * The numeric part of the event effort (the number of units). The effort of the "parent" events will be automatically set to the sum
     * of efforts of their "child" events
     * @field {Number} effort
     * @category Scheduling
     */

    /**
     * The unit part of the event's effort, defaults to "h" (hours). Valid values are:
     *
     * - "millisecond" - Milliseconds
     * - "second" - Seconds
     * - "minute" - Minutes
     * - "hour" - Hours
     * - "day" - Days
     * - "week" - Weeks
     * - "month" - Months
     * - "quarter" - Quarters
     * - "year"- Years
     *
     * This field is readonly after creation, to change it use the {@link #function-setEffort} call.
     * @field {String} effortUnit
     * @default "hour"
     * @category Scheduling
     */

    /**
     * Field storing the event constraint alias or NULL if not constraint set.
     * Valid values are:
     * - "finishnoearlierthan"
     * - "finishnolaterthan"
     * - "mustfinishon"
     * - "muststarton"
     * - "startnoearlierthan"
     * - "startnolaterthan"
     *
     * @field {String} constraintType
     * @category Scheduling
     */

    /**
     * Field defining the constraint boundary date, if applicable.
     * @field {Date} constraintDate
     * @category Scheduling
     */

    /**
     * When set to `true`, the `startDate` of the event will not be changed by any of its incoming dependencies
     * or constraints.
     *
     * @field {Boolean} manuallyScheduled
     * @category Scheduling
     */

    /**
     * When set to `true` the event becomes inactive and stops taking part in the project scheduling (doesn't
     * affect linked events and affect its assigned resources allocation).
     *
     * @field {Boolean} inactive
     * @category Scheduling
     */

    /**
     * A calculated field storing the _early start date_ of the event.
     * The _early start date_ is the earliest possible date the event can start.
     * This value is calculated based on the earliest dates of the event predecessors and the event own constraints.
     * If the event has no predecessors nor other constraints, its early start date matches the project start date.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} earlyStartDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * A calculated field storing the _early end date_ of the event.
     * The _early end date_ is the earliest possible date the event can finish.
     * This value is calculated based on the earliest dates of the event predecessors and the event own constraints.
     * If the event has no predecessors nor other constraints, its early end date matches the project start date plus the event duration.
     *
     * UI fields representing this data field are naturally disabled since the field is readonly.
     * See {@link #function-isEditable} for details.
     *
     * @field {Date} earlyEndDate
     * @calculated
     * @readonly
     * @category Scheduling
     */

    /**
     * The calendar, assigned to the entity. Allows you to set the time when entity can perform the work.
     *
     * All entities are by default assigned to the project calendar, provided as the {@link SchedulerPro.model.ProjectModel#property-calendar} option.
     *
     * @field {SchedulerPro.model.CalendarModel} calendar
     * @category Scheduling
     */

    /**
     * Set this to true if this task should be shown in the Timeline widget
     * @field {Boolean} showInTimeline
     * @category Common
     */
    {
      name: 'showInTimeline',
      type: 'boolean'
    },
    /**
     * Note about the event
     * @field {String} note
     * @category Common
     */
    'note'];
  } //endregion

  /**
   * Defines if the given event field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines:
   * - {@link #field-earlyStartDate}, {@link #field-earlyEndDate} as not editable;
   * - {@link #field-endDate}, {@link #field-duration} and {@link #property-fullDuration} fields
   *   as not editable for summary events except the {@link #field-manuallyScheduled manually scheduled} ones;
   * - {@link #field-percentDone} as not editable for summary events.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the event has no such field.
   */


  isEditable(fieldName) {
    switch (fieldName) {
      // r/o fields
      case 'earlyStartDate':
      case 'earlyEndDate':
        return false;
      // disable percentDone editing for summary tasks

      case 'percentDone':
      case 'renderedPercentDone':
        return this.isLeaf;
      // end/duration is allowed to edit for leafs and manually scheduled summaries

      case 'endDate':
      case 'duration':
      case 'fullDuration':
        return this.isLeaf || this.manuallyScheduled;
    }

    return super.isEditable(fieldName);
  }

}
EventModel._$name = 'EventModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/ProjectModel.js":
/*!************************************************!*\
  !*** ./lib/SchedulerPro/model/ProjectModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var _Engine_quark_model_scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js");
/* harmony import */ var _Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/model/mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony import */ var _data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/mixin/ProjectCrudManager.js */ "./lib/SchedulerPro/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AssignmentModel.js */ "./lib/SchedulerPro/model/AssignmentModel.js");
/* harmony import */ var _CalendarModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CalendarModel.js */ "./lib/SchedulerPro/model/CalendarModel.js");
/* harmony import */ var _DependencyModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./DependencyModel.js */ "./lib/SchedulerPro/model/DependencyModel.js");
/* harmony import */ var _EventModel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EventModel.js */ "./lib/SchedulerPro/model/EventModel.js");
/* harmony import */ var _ResourceModel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ResourceModel.js */ "./lib/SchedulerPro/model/ResourceModel.js");
/* harmony import */ var _data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../data/CalendarManagerStore.js */ "./lib/SchedulerPro/data/CalendarManagerStore.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/DependencyStore.js */ "./lib/SchedulerPro/data/DependencyStore.js");
/* harmony import */ var _data_EventStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../data/EventStore.js */ "./lib/SchedulerPro/data/EventStore.js");
/* harmony import */ var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/ResourceStore.js */ "./lib/SchedulerPro/data/ResourceStore.js");
/* harmony import */ var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../data/AssignmentStore.js */ "./lib/SchedulerPro/data/AssignmentStore.js");
var productName = 'gantt';













/**
 * @module SchedulerPro/model/ProjectModel
 */

/**
 * Scheduler Pro Project model class - a central place for all data.
 *
 * It holds and links the stores usually used by Scheduler Pro:
 *
 * - {@link SchedulerPro/data/EventStore}
 * - {@link SchedulerPro/data/ResourceStore}
 * - {@link SchedulerPro/data/AssignmentStore}
 * - {@link SchedulerPro/data/DependencyStore}
 * - {@link SchedulerPro/data/CalendarManagerStore}
 * - {@link Scheduler/data/ResourceTimeRangeStore}
 * - {@link #config-timeRangeStore TimeRangeStore}
 *
 * The project uses a scheduling engine to calculate dates, durations and such. It is also responsible for
 * handling references between models, for example to link an event via an assignment to a resource. These operations
 * are asynchronous, a fact that is hidden when working in the Scheduler Pro UI but which you must know about when
 * performing operations on the data level.
 *
 * When there is a change to data that requires something else to be recalculated, the project schedules a calculation
 * (a commit) which happens moments later. It is also possible to trigger these calculations directly. This flow
 * illustrates the process:
 *
 * 1. Something changes which requires the project to recalculate, for example adding a new task:
 *
 * ```javascript
 * const [event] = project.eventStore.add({ startDate, endDate });
 * ```
 *
 * 2. A recalculation is scheduled, thus:
 *
 * ```javascript
 * event.duration; // <- Not yet calculated
 * ```
 *
 * 3. Calculate now instead of waiting for the scheduled calculation
 *
 * ```javascript
 * await project.commitAsync();
 *
 * event.duration; // <- Now available
 * ```
 *
 * Please refer to [this guide](#SchedulerPro/guides/basics/project_data.md) for more information.
 *
 * ## Built in CrudManager
 *
 * Scheduler Pro's project has a {@link Scheduler/crud/AbstractCrudManagerMixin CrudManager} built in. Using it is the recommended
 * way of syncing data between Scheduler Pro and a backend. Example usage:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     project : {
 *         // Configure urls used by the built in CrudManager
 *         transport : {
 *             load : {
 *                 url : 'php/load.php'
 *             },
 *             sync : {
 *                 url : 'php/sync.php'
 *             }
 *         }
 *     }
 * });
 *
 * // Load data from the backend
 * scheduler.project.load()
 * ```
 *
 * For more information on CrudManager, see Schedulers docs on {@link Scheduler/data/CrudManager}.
 * For a detailed description of the protocol used by CrudManager, see the [Crud manager guide](#Scheduler/guides/data/crud_manager.md)
 *
 * You can access the current Project data changes anytime using the {@link #property-changes} property.
 *
 * ## Working with inline data
 *
 * The project provides an {@link #property-inlineData} getter/setter that can
 * be used to manage data from all Project stores at once. Populating the stores this way can
 * be useful if you do not want to use the CrudManager for server communication but instead load data using Axios
 * or similar.
 *
 * ### Getting data
 * ```javascript
 * const data = scheduler.project.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * // Get data from server manually
 * const data = await axios.get('/project?id=12345');
 *
 * // Feed it to the project
 * scheduler.project.inlineData = data;
 * ```
 *
 * See also {@link #function-loadInlineData}
 *
 * ### Getting changed records
 *
 * You can access the changes in the current Project dataset anytime using the {@link #property-changes} property. It
 * returns an object with all changes:
 * ```
 * const changes = project.changes;
 *
 * console.log(changes);
 *
 * > {
 *   tasks : {
 *       updated : [{
 *           name : 'My task',
 *           id   : 12
 *       }]
 *   },
 *   assignments : {
 *       added : [{
 *           event      : 12,
 *           resource   : 7,
 *           units      : 100,
 *           $PhantomId : 'abc123'
 *       }]
 *     }
 * };
 * ```
 *
 * ## Monitoring data changes
 *
 * While it is possible to listen for data changes on the projects individual stores, it is sometimes more convenient
 * to have a centralized place to handle all data changes. By listening for the {@link #event-change change event} your
 * code gets notified when data in any of the stores changes. Useful for example to keep an external data model up to
 * date:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *     project: {
 *         listeners : {
 *             change({ store, action, records }) {
 *                 const { $name } = store.constructor;
 *
 *                 if (action === 'add') {
 *                     externalDataModel.add($name, records);
 *                 }
 *
 *                 if (action === 'remove') {
 *                     externalDataModel.remove($name, records);
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Processing the data loaded from the server
 *
 * If you want to process the data received from the server after loading, you can use
 * the {@link #event-beforeLoadApply} or {@link #event-beforeSyncApply} events:
 *
 * ```javascript
 * const gantt = new Gantt({
 *     project: {
 *         listeners : {
 *             beforeLoadApply({ response }) {
 *                 // do something with load-response object before data is fed to the stores
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core/data/stm/StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). By default, it is only used while
 * editing tasks using the task editor, the editor updates tasks live and uses STM to rollback changes if canceled. But
 * you can enable it to track all project store changes:
 *
 * ```javascript
 * // Enable automatic transaction creation and start recording
 * project.stm.autoRecord = true;
 * project.stm.enable();
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * Check out the `undoredo` demo to see it in action.
 *
 * @mixes SchedulerPro/data/mixin/PartOfProject
 * @mixes SchedulerPro/data/mixin/ProjectCrudManager
 * @mixes Core/mixin/Events
 *
 * @extends Scheduler/model/mixin/ProjectModelMixin
 *
 * @typings Scheduler/model/ProjectModel -> Scheduler/model/SchedulerProjectModel
 */

class ProjectModel extends Object(_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_model_scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_0__["SchedulerProProjectMixin"])) {
  //region Events

  /**
   * Fired when the engine has finished its calculations and the results has been written back to the records.
   *
   * ```javascript
   * scheduler.project.on({
   *     dataReady() {
   *        console.log('Calculations finished');
   *     }
   * });
   *
   * scheduler.eventStore.first.duration = 10;
   *
   * // At some point a bit later it will log 'Calculations finished'
   * ```
   *
   * @event dataReady
   * @param {SchedulerPro.model.ProjectModel} source The project
   */
  //endregion
  //region Config
  static get $name() {
    return 'ProjectModel';
  }
  /**
   * Silences propagations caused by the project loading.
   *
   * Applying the loaded data to the project occurs in two basic stages:
   *
   * 1. Data gets into the engine graph which triggers changes propagation
   * 2. The changes caused by the propagation get written to related stores
   *
   * Setting this flag to `true` makes the component perform step 2 silently without triggering events causing reactions on those changes
   * (like sending changes back to the server if `autoSync` is enabled) and keeping stores in unmodified state.
   *
   * This is safe if the loaded data is consistent so propagation doesn't really do any adjustments.
   * By default the system treats the data as consistent so this option is `true`.
   *
   * ```js
   * new SchedulerPro{
   *     project : {
   *         // We want scheduling engine to recalculate the data properly
   *         // so then we could save it back to the server
   *         silenceInitialCommit : false,
   *         ...
   *     }
   *     ...
   * })
   * ```
   *
   * @config {Boolean} silenceInitialCommit
   * @default true
   */

  /**
   * This config manages DST correction in the scheduling engine. It only has effect when DST transition hour is
   * working time. Usually DST transition occurs on Sunday, so with non working weekends the DST correction logic
   * is not involved.
   *
   * If **true**, it will add/remove one hour when calculating end date. For example:
   * Assume weekends are working and on Sunday, 2020-10-25 at 03:00 clocks are set back 1 hour. Assume there is an event:
   *
   * ```javascript
   * {
   *     startDate    : '2020-10-20',
   *     duration     : 10 * 24 + 1,
   *     durationUnit : 'hour'
   * }
   * ```
   * It will end on 2020-10-30 01:00 (which is wrong) but duration will be reported correctly. Because of the DST
   * transition the SchedulerPro project will add one more hour when calculating the end date.
   *
   * Also this may occur when day with DST transition is working but there are non-working intervals between that day
   * and event end date.
   *
   * ```javascript
   * {
   *     calendar         : 1,
   *     calendarsData    : [
   *         {
   *             id           : 1,
   *             startDate    : '2020-10-26',
   *             endDate      : '2020-10-27',
   *             isWorking    : false
   *         }
   *     ],
   *     eventsData       : [
   *         {
   *             id           : 1,
   *             startDate    : '2020-10-20',
   *             endDate      : '2020-10-30'
   *         },
   *         {
   *             id           : 2,
   *             startDate    : '2020-10-20',
   *             duration     : 10 * 24 + 1,
   *             durationUnit : 'hour'
   *         }
   *     ]
   * }
   * ```
   *
   * Event 1 duration will be incorrectly reported as 9 days * 24 hours, missing 1 extra hour added by DST transition.
   * Event 2 end date will be calculated to 2020-10-30 01:00, adding one extra hour.
   *
   * If **false**, the SchedulerPro project will not add DST correction which fixes the quirk mentioned above.
   * Event 1 duration will be correctly reported as 9 days * 24 hours + 1 hour. Event 2 end date will be calculated
   * to 2020-10-30.
   *
   * Also, for those events days duration will be a floating point number due to extra (or missing) hour:
   *
   * ```javascript
   * eventStore.getById(1).getDuration('day')  // 10.041666666666666
   * eventStore.getById(1).getDuration('hour') // 241
   * ```
   *
   * @config {Boolean} adjustDurationToDST
   * @default false
   * @private
   */
  // TODO: This config is introduced only to make behavior transition smooth. If nobody complains about it for
  // a couple of releases, it should be removed

  /**
   * The number of hours per day (is used when converting the duration from one unit to another).
   * @field {Number} hoursPerDay
   * @default 24
   */

  /**
   * The number of days per week (is used when converting the duration from one unit to another).
   * @field {Number} daysPerWeek
   * @default 7
   */

  /**
   * The number of days per month (is used when converting the duration from one unit to another).
   * @field {Number} daysPerMonth
   * @default 30
   */

  /**
   * The scheduling direction of the project events.
   * Possible values are `Forward` and `Backward`. The `Forward` direction corresponds to the As-Soon-As-Possible scheduling (ASAP),
   * `Backward` - to As-Late-As-Possible (ALAP).
   * @field {String} direction
   * @default 'Forward'
   */

  /**
   * The source of the calendar for dependencies (the calendar used for taking dependencies lag into account).
   * Possible values are:
   *
   * - `ToEvent` - successor calendar will be used (default);
   * - `FromEvent` - predecessor calendar will be used;
   * - `Project` - the project calendar will be used.
   *
   * @field {String} dependenciesCalendar
   * @default 'ToEvent'
   */

  /**
   * The project calendar.
   * @config {String|Object|SchedulerPro.model.CalendarModel} calendar
   */

  /**
   * The project calendar.
   * @field {SchedulerPro.model.CalendarModel} calendar
   */

  /**
   * The project calendar.
   * @member {SchedulerPro.model.CalendarModel} calendar
   */

  /**
   * Project changes (CRUD operations to records in its stores) are automatically committed on a buffer to the
   * underlying graph based calculation engine. The engine performs it calculations async.
   *
   * By calling this function, the commit happens right away. And by awaiting it you are sure that project
   * calculations are finished and that references between records are up to date.
   *
   * The returned promise is resolved with an object. If that object has `rejectedWith` set, there has been a conflict and the calculation failed.
   *
   * ```javascript
   * // Move an event in time
   * eventStore.first.shift(1);
   *
   * // Trigger calculations directly and wait for them to finish
   * const result = await project.commitAsync();
   *
   * if (result.rejectedWith) {
   *     // there was a conflict during the scheduling
   * }
   * ```
   *
   * @async
   * @returns {Promise}
   * @function commitAsync
   */

  /**
   * DEPRECATED. Use {@link #function-commitAsync} instead.
   * @deprecated
   * @returns {Promise}
   * @function propagate
   */

  /**
   * Collection of the project calendars.
   * @member {SchedulerPro.data.CalendarManagerStore} calendarManagerStore
   */

  /**
   * Set to `true` to enable calculation progress notifications.
   * When enabled the project fires {@link #event-progress progress} event.
   *
   * **Note**: Enabling progress notifications will impact calculation performance, since it needs to pause calculations to allow redrawing the UI.
   * @config {Boolean} enableProgressNotifications
   * @category Engine
   */

  /**
   * Enables/disables the calculation progress notifications.
   * @member {Boolean} enableProgressNotifications
   * @category Engine
   */

  /**
   * Fired during the Engine calculation if {@link #config-enableProgressNotifications enableProgressNotifications} config is `true`
   * @event progress
   * @param {Number} total The total number of operations
   * @param {Number} remaining The number of remaining operations
   * @param {String} phase The phase of the calculation, either 'storePopulation' when data is getting loaded, or 'propagating' when data is getting calculated
   */


  static get defaultConfig() {
    return {
      /**
       * The constructor of the calendar model class, to be used in the project. Will be set as the {@link Core.data.Store#config-modelClass modelClass}
       * property of the {@link #property-calendarManagerStore}
       *
       * @config {SchedulerPro.model.CalendarModel} [calendarModelClass]
       * @typings {typeof CalendarModel}
       * @category Models & Stores
       */
      calendarModelClass: _CalendarModel_js__WEBPACK_IMPORTED_MODULE_4__["default"],

      /**
       * The constructor of the dependency model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-dependencyStore}
       *
       * @config {SchedulerPro.model.DependencyModel}
       * @typings {typeof DependencyModel}
       * @category Models & Stores
       */
      dependencyModelClass: _DependencyModel_js__WEBPACK_IMPORTED_MODULE_5__["default"],

      /**
       * The constructor of the event model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-eventStore}
       *
       * @config {SchedulerPro.model.EventModel}
       * @typings {typeof EventModel}
       * @category Models & Stores
       */
      eventModelClass: _EventModel_js__WEBPACK_IMPORTED_MODULE_6__["default"],

      /**
       * The constructor of the assignment model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-assignmentStore}
       *
       * @config {SchedulerPro.model.AssignmentModel}
       * @typings {typeof AssignmentModel}
       * @category Models & Stores
       */
      assignmentModelClass: _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * The constructor of the resource model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-resourceStore}
       *
       * @config {SchedulerPro.model.ResourceModel}
       * @typings {typeof ResourceModel}
       * @category Models & Stores
       */
      resourceModelClass: _ResourceModel_js__WEBPACK_IMPORTED_MODULE_7__["default"],

      /**
       * The constructor to create a calendar store instance with. Should be a class, subclassing the
       * {@link SchedulerPro.data.CalendarManagerStore}
       * @config {SchedulerPro.data.CalendarManagerStore|Object}
       * @typings {typeof CalendarManagerStore|object}
       * @category Models & Stores
       */
      calendarManagerStoreClass: _data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_8__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the
       * {@link SchedulerPro.data.DependencyStore}
       * @config {SchedulerPro.data.DependencyStore|Object}
       * @typings {typeof DependencyStore|object}
       * @category Models & Stores
       */
      dependencyStoreClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],

      /**
       * The constructor to create an event store instance with. Should be a class, subclassing the
       * {@link SchedulerPro.data.EventStore}
       * @config {SchedulerPro.data.EventStore|Object}
       * @typings {typeof EventStore|object}
       * @category Models & Stores
       */
      eventStoreClass: _data_EventStore_js__WEBPACK_IMPORTED_MODULE_10__["default"],

      /**
       * The constructor to create an assignment store instance with. Should be a class, subclassing the
       * {@link SchedulerPro.data.AssignmentStore}
       * @config {SchedulerPro.data.AssignmentStore|Object}
       * @typings {typeof AssignmentStore|object}
       * @category Models & Stores
       */
      assignmentStoreClass: _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__["default"],

      /**
       * The constructor to create a resource store instance with. Should be a class, subclassing the
       * {@link SchedulerPro.data.ResourceStore}
       * @config {SchedulerPro.data.ResourceStore|Object}
       * @typings {typeof ResourceStore|object}
       * @category Models & Stores
       */
      resourceStoreClass: _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__["default"],

      /**
       * The initial data, to fill the {@link #property-calendarManagerStore} with.
       * Should be an array of {@link SchedulerPro.model.CalendarModel} or it's configuration objects.
       *
       * @config {SchedulerPro.model.CalendarModel[]}
       * @category Inline data
       */
      calendarsData: null,

      /**
       * Set to `true` to reset the undo/redo queues of the internal {@link Core.data.stm.StateTrackingManager}
       * after the Project has loaded. Defaults to `false`
       * @config {Boolean} resetUndoRedoQueuesAfterLoad
       */
      supportShortSyncResponseNote: 'Note: Please consider enabling "supportShortSyncResponse" option to allow less detailed sync responses (https://bryntum.com/docs/scheduler-pro/api/SchedulerPro/model/ProjectModel#config-supportShortSyncResponse)'
    };
  } //endregion


}
ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/ResourceModel.js":
/*!*************************************************!*\
  !*** ./lib/SchedulerPro/model/ResourceModel.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceModel; });
/* harmony import */ var _Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/model/mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_pro_SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
var productName = 'gantt';




/**
 * @module SchedulerPro/model/ResourceModel
 */

/**
 * This class represent a single Resource in Scheduler Pro, usually added to a {@link SchedulerPro.data.ResourceStore}.
 *
 * It is a subclass of  {@link Core.data.Model}. Please refer to the documentation for that class to become familiar
 * with the base interface of the resource.
 *
 * ## Fields and references
 *
 * A resource has a few predefined fields, see Fields below. If you want to add more fields with meta data describing
 * your resources then you should subclass this class:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *       // "id" and "name" fields are already provided by the superclass
 *       { name: 'company', type : 'string' }
 *     ];
 *   }
 * });
 * ```
 *
 * If you want to use other names in your data for the id and name fields you can configure them as seen below:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *        { name: 'name', dataSource: 'userName' }
 *     ];
 *   },
 * });
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `assignments` - The linked assignment records
 * - `events` - The linked (through assignments) event records
 *
 * ## Async resolving of references
 *
 * As described above, a resource has links to assignments and events. These references are populated async, using the
 * calculation engine of the project that the resource via its store is a part of. Because of this asyncness, references
 * cannot be used immediately after assignment modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // resource.assignments is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // resource.assignments is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // resource.assignments is up to date
 * ```
 *
 * @extends Grid/data/GridRowModel
 * @mixes Scheduler/model/mixin/ResourceModelMixin
 *
 * @typings Scheduler/model/ResourceModel -> Scheduler/model/SchedulerResourceModel
 */

class ResourceModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Engine_quark_model_scheduler_pro_SchedulerProResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__["SchedulerProResourceMixin"].derive(_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  //region Calendar

  /**
   * Sets the calendar of the task. Will cause the schedule to be updated - returns a `Promise`
   *
   * @method setCalendar
   * @param {SchedulerPro.model.CalendarModel} calendar The new calendar. Provide `null` to use the project calendar.
   * @returns {Promise}
   * @propagating
   */

  /**
   * Returns the resource calendar.
   *
   * @method getCalendar
   * @returns {SchedulerPro.model.CalendarModel} The resource calendar.
   */

  /**
   * The calendar, assigned to the entity. Allows you to set the time when entity can perform the work.
   *
   * @field {SchedulerPro.model.CalendarModel} calendar
   * @category Scheduling
   */
  //endregion
  //region Config
  static get $name() {
    return 'ResourceModel';
  } //endregion


}
ResourceModel._$name = 'ResourceModel';

/***/ }),

/***/ "./lib/SchedulerPro/model/mixin/PercentDoneMixin.js":
/*!**********************************************************!*\
  !*** ./lib/SchedulerPro/model/mixin/PercentDoneMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'gantt';
/**
* @module SchedulerPro/model/mixin/PercentDoneMixin
*/

/**
 * PercentDone mixin to get the current status of a task.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class PercentDoneMixin extends Target {
  static get $name() {
    return 'PercentDoneMixin';
  }
  /**
   * The current status of a task, expressed as the percentage completed (integer from 0 to 100)
   * @field {Number} percentDone
   * @category Scheduling
   */
  // Field defined in Engine

  /**
   * Indicates if the task is started (its {@link #field-percentDone percent completion} is greater than zero).
   * @property {Boolean}
   */


  get isStarted() {
    return this.percentDone > 0;
  }
  /**
   * Indicates if the task is complete (its {@link #field-percentDone percent completion} is 100% (or greater)).
   * @property {Boolean}
   */


  get isCompleted() {
    return this.percentDone >= 100;
  }
  /**
   * Indicates if the task is in progress (its {@link #field-percentDone percent completion} is greater than zero and less than 100%).
   * @property {Boolean}
   */


  get isInProgress() {
    return this.isStarted && !this.isCompleted;
  } // Reset % done value when copying a task


  copy() {
    const copy = super.copy(...arguments);
    copy.percentDone = 0;
    copy.clearChanges();
    return copy;
  }
  /**
   * Human-friendly rounding. When task is completed < 99%, it rounds the value. It floors value between 99 and 100, to not
   * show task as completed when it is for example 99.51% done.
   * @property {Number}
   */


  get renderedPercentDone() {
    const value = typeof this.percentDone === 'number' && !isNaN(this.percentDone) ? this.percentDone : 0;
    return this.getFormattedPercentDone(value);
  }

  getFormattedPercentDone(value = 0) {
    if (value <= 99) {
      return Math.round(value);
    }

    return Math.floor(value);
  }

  set renderedPercentDone(value) {
    this.percentDone = value;
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/view/ResourceHistogram.js":
/*!****************************************************!*\
  !*** ./lib/SchedulerPro/view/ResourceHistogram.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceHistogram; });
/* harmony import */ var _SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SchedulerProBase.js */ "./lib/SchedulerPro/view/SchedulerProBase.js");
/* harmony import */ var _column_ScaleColumn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../column/ScaleColumn.js */ "./lib/SchedulerPro/column/ScaleColumn.js");
/* harmony import */ var _Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/feature/NonWorkingTime.js */ "./lib/Scheduler/feature/NonWorkingTime.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../localization/En.js */ "./lib/SchedulerPro/localization/En.js");
/* harmony import */ var _Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony import */ var _Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Grid/feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony import */ var _Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");
/* harmony import */ var _Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/graph/Histogram.js */ "./lib/Core/widget/graph/Histogram.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
var productName = 'gantt';




 // Always required features








/**
 * @module SchedulerPro/view/ResourceHistogram
 */

/**
 * This widget displays a read-only timeline report of the workload for the resources in a
 * {@link SchedulerPro/model/ProjectModel project}. The resource allocation is visualized as bars along the time axis
 * with an optional line indicating the maximum available time for each resource. A {@link SchedulerPro/column/ScaleColumn}
 * is also added automatically.
 *
 * To create a standalone histogram, simply configure it with a Project instance:
 *
 * ```js
 * const project = new ProjectModel({
 *    autoLoad  : true,
 *    transport : {
 *        load : {
 *            url : 'examples/schedulerpro/view/data.json'
 *        }
 *    }
 * });
 *
 * const histogram = new ResourceHistogram({
 *    project,
 *    appendTo    : 'targetDiv',
 *    rowHeight   : 60,
 *    minHeight   : '20em',
 *    flex        : '1 1 50%',
 *    showBarTip  : true,
 *    columns     : [
 *        {
 *            width : 200,
 *            field : 'name',
 *            text  : 'Resource'
 *        }
 *    ]
 * });
 * ```
 *
 * You can also pair the histogram with other timeline views such as the Gantt or Scheduler, using the {@link Scheduler/view/TimelineBase#config-partner} config.
 *
 * You can configure (or hide completely) the built-in scale column easily:
 *
 * ```js
 * const histogram = new ResourceHistogram({
 *    project,
 *    appendTo    : 'targetDiv',
 *    columns     : [
 *        {
 *            width : 200,
 *            field : 'name',
 *            text  : 'Resource'
 *        },
 *        // Hide the scale column (or add any other column configs)
 *        {
 *            type   : 'scale',
 *            hidden : true
 *        }
 *    ]
 * });
 * ```
 *
 * {@inlineexample SchedulerPro/view/ResourceHistogram.js}
 * @extends SchedulerPro/view/SchedulerProBase
 * @classtype resourcehistogram
 */

class ResourceHistogram extends _SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ResourceHistogram';
  }

  static get type() {
    return 'resourcehistogram';
  }

  static get configurable() {
    return {
      rowHeight: 50,

      /**
       * Default time unit to display resources effort values.
       * The value is used as default when displaying effort in tooltips and bars text.
       * Yet the effective time unit used might change dynamically when zooming in the histogram
       * so its ticks unit gets smaller than the default unit.
       * Please use {@link #config-barTipEffortUnit} to customize default units for tooltips only
       * and {@link #config-barTextEffortUnit} to customize default units in bar texts.
       * @config {String}
       * @default hour
       */
      effortUnit: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Hour,

      /**
       * Default time unit used for displaying resources effort in bars.
       * Yet the effective time unit used might change dynamically when zooming in the histogram
       * so its ticks unit gets smaller than the default unit.
       * Please use {@link #config-barTipEffortUnit} to customize default units for tooltips
       * (or {@link #config-effortUnit} to customize both texts and tooltips default units).
       * @config {String}
       * @default hour
       */
      barTextEffortUnit: null,

      /**
       * Default time unit used when displaying resources effort in tooltips.
       * Yet the effective time unit used might change dynamically when zooming in the histogram
       * so its ticks unit gets smaller than the default unit.
       * Please use {@link #config-barTextEffortUnit} to customize default units for bar texts
       * (or {@link #config-effortUnit} to customize both texts and tooltips default units).
       * @config {String}
       * @default hour
       */
      barTipEffortUnit: null,

      /**
       * Set to `true` if you want to display the maximum resource allocation line.
       * @config {Boolean}
       * @default
       */
      showMaxEffort: true,

      /**
       * Set to `true` if you want to display resources effort values in bars
       * (for example: `24h`, `7d`, `60min` etc.).
       * The text contents can be changed by providing {@link #config-getBarText} function.
       * @config {Boolean}
       * @default
       */
      showBarText: false,

      /**
       * Set to `true` if you want to display a tooltip when hovering an allocation bar.
       * Please use {@link #config-getBarTip} function to customize the tooltip contents.
       * @config {Boolean}
       * @default
       */
      showBarTip: false,
      series: {
        maxEffort: {
          type: 'outline',
          field: 'maxEffort'
        },
        effort: {
          type: 'bar',
          field: 'effort'
        }
      },

      /**
       * A Function which returns a CSS class name to add to a rectangle element.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getRectClass: null,

      /**
       * A Function which returns the tooltip text to display when hovering a bar.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarTip: null,

      /**
       * A Function which returns the text to render inside a bar.
       * The following parameters are passed:
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarText: null,
      groupBarTipAssignmentLimit: 5,
      histogramWidgetClass: _Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_7__["default"],

      /**
       * Set to `true` to include inactive tasks allocation and `false` to not take such tasks into account.
       * @config {Boolean}
       * @default
       */
      includeInactiveEvents: false,
      fixedRowHeight: true
    };
  } //endregion
  //region Constructor/Destructor


  construct(config) {
    const me = this;
    me.allocationReportByResource = new Map();
    me.resourceGroupsToUpdate = new Set();
    me.resourceGroupsAllocation = new Map();
    super.construct(config); // debounce refreshRows calls

    me.scheduleRefreshRows = me.createOnFrame(me.refreshRows, [], me, true); // TODO: hack to get rid of "Horizontal" store tracking approach.
    // It seems there is no need to use 99% of the "Horizontal" mode for the histogram
    // so ideally we need to make a special class for it.

    me.horizontal.refreshResourcesWhenReady = me.horizontal.onAssignmentStoreChange = me.horizontal.renderer = function () {};

    me.rowManager.on({
      beforeRowHeight: 'onBeforeRowHeight',
      renderRow: 'onRowManagerRenderRow',
      thisObj: me
    });
    me.timeAxis.on({
      endReconfigure: 'onTimeAxisEndReconfigure',
      thisObj: this
    });
  }

  onRowManagerRenderRow({
    record
  }) {
    // render group level histogram and scale
    if (record.isSpecialRow) {
      this.renderGroupHistogram(record);
      this.renderGroupScale(record);
    }
  }

  onDestroy() {
    var _this$_histogramWidge, _this$_groupHistogram;

    (_this$_histogramWidge = this._histogramWidget) === null || _this$_histogramWidge === void 0 ? void 0 : _this$_histogramWidge.destroy();
    (_this$_groupHistogram = this._groupHistogramWidget) === null || _this$_groupHistogram === void 0 ? void 0 : _this$_groupHistogram.destroy();
  } //endregion
  //region Project


  updateProject(project) {
    const me = this;
    me.detachListeners('resourceHistogramProject'); // No partial rendering until project is ready (which it is when onProjectRefresh is called)
    // me.suspendRendering = true;

    me._project = project;
    project.on({
      name: 'resourceHistogramProject',
      startApplyResponse: 'onProjectStartApplyResponse',
      refresh: 'internalOnProjectRefresh',
      repopulateReplica: 'onRepopulateReplica',
      thisObj: me
    });
    this.store = project.resourceStore;
  } //endregion
  //region Internal


  scheduleRefreshRows() {} // TODO: hack to get rid of "HorizontalRendering" events rendering logic


  getEventsToRender() {}

  getRowHeight() {
    return this.rowHeight;
  }

  get scaleColumn() {
    return this.columns.query(column => column.isScaleColumn)[0];
  }

  get scalePoints() {
    return this._scalePoints;
  }

  set scalePoints(scalePoints) {
    const {
      project,
      histogramWidget,
      scaleColumn
    } = this,
          lastPoint = scalePoints[scalePoints.length - 1],
          {
      value: scaleMax,
      unit: scaleUnit
    } = lastPoint;
    this.scaleUnit = scaleUnit;
    this._scalePoints = scalePoints;
    let maxInScaleUnits = scaleMax;

    if (scaleColumn) {
      const {
        scaleWidget
      } = scaleColumn;
      maxInScaleUnits += scaleWidget.scaleMaxPadding * scaleMax;
    } // Applying new maximum value to the histogram.
    // We have to convert scale units to milliseconds since allocation report provides values in milliseconds.


    histogramWidget.topValue = project.convertDuration(maxInScaleUnits, scaleUnit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Millisecond); // Applying new points to the scale column

    if (scaleColumn) {
      scaleColumn.scalePoints = scalePoints;
    }
  }

  buildScalePointText(scalePoint) {
    return `${scalePoint.value}${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getShortNameOfUnit(scalePoint.unit)}`;
  }

  generateScalePoints(unit, scaleMax) {
    const {
      project,
      timeAxis
    } = this,
          scalePoints = [];

    if (!unit) {
      unit = timeAxis.unit;
      scaleMax = timeAxis.increment;
    }

    let scaleStep; // If the ticks are defined as 1 unit let's break it down to smaller units

    if (scaleMax === 1) {
      // getting timeaxis tick sub-unit and number of them in a tick
      unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getSmallerUnit(unit);
      scaleMax = Math.round(project.convertDuration(scaleMax, timeAxis.unit, unit));
    } // Let's try to guess how many points in the scale will work nicely


    for (const factor of [7, 5, 4, 3, 2]) {
      // unitsNumber is multiple of "factor" -> we generate "factor"-number of points
      if (!(scaleMax % factor)) {
        scaleStep = scaleMax / factor;
        break;
      }
    } // fallback to a single point equal to maximum value


    if (!scaleStep) {
      scaleStep = scaleMax;
    }

    for (let value = scaleStep; value <= scaleMax; value += scaleStep) {
      scalePoints.push({
        value
      });
    }

    const lastPoint = scalePoints[scalePoints.length - 1]; // put unit and label to the last point

    lastPoint.unit = unit;
    lastPoint.text = this.buildScalePointText(lastPoint);
    return scalePoints;
  }

  updateViewPreset(viewPreset) {
    const me = this; // Set a flag indicating that we're inside of `updateViewPreset` so our `onTimeAxisEndReconfigure` will skip its call.
    // We call it here later.

    me._updatingViewPreset = true;
    super.updateViewPreset(...arguments);
    me._updatingViewPreset = false; // In `super,updateViewPreset` function `this.render` is called which checks if the engine is not dirty
    // ..and we modify `ticksIdentifier` atom in `onTimeAxisEndReconfigure`
    // so the engine state gets dirty and rendering gets delayed which ends up an exception.
    // So we call `onTimeAxisEndReconfigure` after super `updateViewPreset` code
    // to keep the engine non-dirty while zooming/setting a preset.
    // This scenario is covered w/ SchedulerPro/tests/pro/view/ResourceHistogramZoom.t.js

    if (me.project.isInitialCommitPerformed && me.isPainted) {
      me.onTimeAxisEndReconfigure();
    }
  }

  onRepopulateReplica() {
    this.ticksIdentifier = null;
    this.allocationReportByResource.clear();
  }

  buildTicksIdentifier() {
    const me = this,
          graph = me.project.getGraph();

    if (!me.ticksIdentifier) {
      me.ticksIdentifier = graph.addIdentifier(_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_9__["CalculatedValueGen"].new());
    }

    me.ticksIdentifier.writeToGraph(graph, new _Engine_quark_model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_11__["BaseCalendarMixin"]({
      unspecifiedTimeIsWorking: false,
      intervals: me.timeAxis.ticks.map(tick => {
        return {
          startDate: tick.startDate,
          endDate: tick.endDate,
          isWorking: true
        };
      })
    })); // process ticks to detect if their widths are monotonous
    // or some tick has a different width value

    me.collectTicksWidth();
    return me.ticksIdentifier;
  }

  collectTicksWidth() {
    const {
      ticks
    } = this.timeAxis,
          prevDuration = ticks[0].endDate - ticks[0].startDate,
          tickDurations = {
      0: prevDuration
    };
    let totalDuration = prevDuration,
        isMonotonous = true;

    for (let i = 1, {
      length
    } = ticks; i < length; i++) {
      const tick = ticks[i],
            duration = tick.endDate - tick.startDate; // the ticks width is different -> reset isMonotonous flag

      if (prevDuration !== duration) {
        isMonotonous = false;
      }

      totalDuration += duration;
      tickDurations[i] = duration;
    } // if the ticks widths are not monotonous we need to calculate
    // each bar width to provide it to the histogram widget later


    if (!isMonotonous) {
      const ticksWidth = {};

      for (let i = 0, {
        length
      } = ticks; i < length; i++) {
        ticksWidth[i] = tickDurations[i] / totalDuration;
      }

      this.ticksWidth = ticksWidth;
    } else {
      this.ticksWidth = null;
    }
  }

  resumeRefresh(trigger) {
    super.resumeRefresh(false);

    if (!this.refreshSuspended && trigger) {
      if (!this.rowManager.topRow) {
        // TODO: investigate why we need this
        this.rowManager.reinitialize(); // To clear histogram when no rows to refresh

        this.histogramWidget.data = [];
        this.histogramWidget.refresh();
      } else {
        this.refreshWithTransition();
      }
    }
  }

  internalOnProjectRefresh() {
    const me = this;

    if (!me.ticksIdentifier) {
      me.onTimeAxisEndReconfigure();
    }

    me.resumeRefresh(!me.rowManager.topRow);
  }

  get columns() {
    return super.columns;
  }

  set columns(columns) {
    const me = this;
    super.columns = columns;

    if (!me.isDestroying) {
      me.timeAxisColumn.renderer = me.renderResourceHistogram;
      me.timeAxisColumn.cellCls = 'b-resourcehistogram-cell'; // Unless provided from outside, insert the scale column in the correct place

      if (!columns.some(col => col.type === 'scale')) {
        me.columns.rootNode.insertChild({
          type: 'scale'
        }, me.timeAxisColumn);
      }
    }
  }

  onProjectStartApplyResponse() {
    this.suspendRefresh();
  }

  buildHistogramWidget(config) {
    var _me$timeAxisColumn;

    const me = this;
    return this.histogramWidgetClass.new({
      owner: me,
      appendTo: me.element,
      cls: 'b-hide-offscreen b-resourcehistogram-histogram',
      height: me.rowHeight,
      width: ((_me$timeAxisColumn = me.timeAxisColumn) === null || _me$timeAxisColumn === void 0 ? void 0 : _me$timeAxisColumn.width) || 0,
      omitZeroHeightBars: true,
      data: [],
      getRectClass: me.getRectClass || me.getRectClassDefault,
      getBarText: me.getBarText || me.getBarTextDefault,
      getBarTip: me.getBarTip || me.getBarTipDefault,
      series: me.series
    }, config);
  }

  get histogramWidget() {
    const me = this;

    if (!me._histogramWidget) {
      const series = me.series;

      if (!me.showMaxEffort && series.maxEffort) {
        series.maxEffort = false;
      }

      me._histogramWidget = me.buildHistogramWidget();
    }

    return me._histogramWidget;
  } // Injectable method.


  getRectClassDefault(series, rectConfig, datum, index) {
    if (series.id === 'effort') {
      switch (true) {
        case datum.isOverallocated:
          return 'b-overallocated';

        case datum.isUnderallocated:
          return 'b-underallocated';
      }
    }

    return '';
  }

  getEffortText(effort, unit) {
    const {
      scaleUnit,
      project
    } = this;
    unit = unit || scaleUnit;
    const localizedUnit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getShortNameOfUnit(unit),
          effortInUnits = project.convertDuration(effort, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Millisecond, unit);
    return `${parseFloat(effortInUnits.toFixed(1))}${localizedUnit}`;
  }

  getBarTipEffortUnit(series, rectConfig, datum, index) {
    const {
      effortUnit,
      barTipEffortUnit,
      timeAxis
    } = this,
          defaultUnit = barTipEffortUnit || effortUnit;
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, defaultUnit) < 0 ? timeAxis.unit : defaultUnit;
  }

  getGroupBarTip(series, rectConfig, datum, index) {
    const me = this,
          {
      showBarTip,
      timeAxis
    } = me;
    let result = '';

    if (showBarTip && datum.effort) {
      const unit = me.getBarTipEffortUnit(...arguments),
            allocated = me.getEffortText(datum.effort, unit),
            available = me.getEffortText(datum.maxEffort, unit),
            assignmentTpl = me.L('L{groupBarTipAssignment}');
      let dateFormat = 'L',
          resultFormat = me.L('L{groupBarTipInRange}'),
          assignmentsSuffix = '';

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Day) == 0) {
        resultFormat = me.L('L{groupBarTipOnDate}');
      } else if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Second) <= 0) {
        dateFormat = 'HH:mm:ss A';
      } else if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Hour) <= 0) {
        dateFormat = 'LT';
      }

      let assignmentsArray = [...datum.resourceAllocation.entries()].filter(([resource, data]) => data.effort).sort(([key1, value1], [key2, value2]) => value1.effort > value2.effort ? -1 : 1);

      if (assignmentsArray.length > me.groupBarTipAssignmentLimit) {
        assignmentsSuffix = '<br>' + me.L('L{plusMore}').replace('{value}', assignmentsArray.length - me.groupBarTipAssignmentLimit);
        assignmentsArray = assignmentsArray.slice(0, this.groupBarTipAssignmentLimit);
      }

      const assignments = assignmentsArray.map(([resource, info]) => {
        return assignmentTpl.replace('{resource}', resource.name).replace('{allocated}', me.getEffortText(info.effort, unit)).replace('{available}', me.getEffortText(info.maxEffort, unit)).replace('{cls}', info.isOverallocated ? 'b-overallocated' : info.isUnderallocated ? 'b-underallocated' : '');
      }).join('<br>') + assignmentsSuffix; // TODO: we need smth like sprintf("has {0} of {1} items", cnt, total)
      // to be able to test localizable strings

      result = resultFormat.replace('{assignments}', assignments).replace('{startDate}', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(datum.tick.startDate, dateFormat)).replace('{endDate}', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(datum.tick.endDate, dateFormat)).replace('{allocated}', allocated).replace('{available}', available).replace('{cls}', datum.isOverallocated ? 'b-overallocated' : datum.isUnderallocated ? 'b-underallocated' : '');
      result = `<div class="b-histogram-bar-tooltip">${result}</div>`;
    }

    return result;
  }

  getResourceBarTip(series, rectConfig, datum, index) {
    const me = this,
          {
      showBarTip,
      timeAxis
    } = me;
    let result = '';

    if (showBarTip && datum.effort) {
      const unit = me.getBarTipEffortUnit(...arguments),
            allocated = me.getEffortText(datum.effort, unit),
            available = me.getEffortText(datum.maxEffort, unit);
      let dateFormat = 'L',
          resultFormat = me.L('L{barTipInRange}');

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Day) == 0) {
        resultFormat = me.L('L{barTipOnDate}');
      } else if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Second) <= 0) {
        dateFormat = 'HH:mm:ss A';
      } else if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Hour) <= 0) {
        dateFormat = 'LT';
      } // TODO: we need smth like sprintf("has {0} of {1} items", cnt, total)
      // to be able to test localizable strings


      result = resultFormat.replace('{resource}', datum.resource.name).replace('{startDate}', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(datum.tick.startDate, dateFormat)).replace('{endDate}', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(datum.tick.endDate, dateFormat)).replace('{allocated}', allocated).replace('{available}', available).replace('{cls}', datum.isOverallocated ? 'b-overallocated' : datum.isUnderallocated ? 'b-underallocated' : '');
      result = `<div class="b-histogram-bar-tooltip">${result}</div>`;
    }

    return result;
  } // Injectable method.


  getBarTipDefault(series, rectConfig, datum, index) {
    const resourceHistogram = this.owner,
          {
      showBarTip
    } = resourceHistogram;
    let result = '';

    if (showBarTip && datum.effort) {
      if (datum.isGroup) {
        result = resourceHistogram.getGroupBarTip(...arguments);
      } else {
        result = resourceHistogram.getResourceBarTip(...arguments);
      }
    }

    return result;
  }

  getBarTextEffortUnit(series, rectConfig, datum, index) {
    const {
      effortUnit,
      barTextEffortUnit,
      timeAxis
    } = this,
          defaultUnit = barTextEffortUnit || effortUnit;
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(timeAxis.unit, defaultUnit) < 0 ? timeAxis.unit : defaultUnit;
  } // Injectable method.


  getBarTextDefault(datum, index) {
    const {
      showBarText
    } = this.owner;
    let result = '';

    if (showBarText && datum.effort) {
      const unit = this.owner.getBarTextEffortUnit(...arguments);
      result = this.owner.getEffortText(datum.effort, unit);
    }

    return result;
  }

  updateShowBarText(value) {
    this.scheduleRefreshRows(); // this.refreshRows();
  }

  updateShowBarTip(value) {
    this.scheduleRefreshRows(); // this.refreshRows();
  }

  updateShowMaxEffort(value) {
    const me = this;
    me._showMaxEffort = value;
    let needsRefresh = false;
    [me._histogramWidget, me._groupHistogramWidget].forEach(widget => {
      // bail out in case there is no widget constructed yet
      if (!widget) return;
      const {
        series
      } = widget;

      if (!value) {
        if (series.maxEffort) {
          widget._seriesMaxEffort = series.maxEffort;
          delete series.maxEffort;
        }
      } else {
        if (typeof value === 'object') {
          series.maxEffort = value;
        } else if (typeof widget._seriesMaxEffort === 'object') {
          series.maxEffort = widget._seriesMaxEffort;
        } else {
          series.maxEffort = {
            type: 'outline',
            field: 'maxEffort'
          };
          series.maxEffort.id = 'maxEffort';
        }
      }

      needsRefresh = true;
    });

    if (needsRefresh) {
      me.scheduleRefreshRows();
    }
  }

  updateIncludeInactiveEvents(value) {
    // update collected reports wih new includeInactiveEvents flag state
    this.allocationReportByResource.forEach(allocationReport => allocationReport.includeInactiveEvents = value);
  } //endregion
  //region Events


  onTimeAxisEndReconfigure() {
    // Skip call triggered by viewPreset setting we have `updateViewPreset` method overridden where we call `onTimeAxisEndReconfigure` later
    if (!this._updatingViewPreset) {
      const {
        unit,
        increment
      } = this.timeAxis; // re-generate scale point on zooming in/out

      if (unit !== this._lastTimeAxisUnit || increment !== this._lastTimeAxisIncrement) {
        // remember last used unit & increment to distinguish zooming from timespan changes
        this._lastTimeAxisUnit = unit;
        this._lastTimeAxisIncrement = increment;
        this._generatedScalePoints = this.scalePoints = this.generateScalePoints();
      }

      this.buildTicksIdentifier();
    }
  }

  onBeforeRowHeight({
    height
  }) {
    // TODO: histogramWidget getter requests timeAxisColumn column too early which causes an infinite cycle
    if (this._timeAxisColumn) {
      for (const widget of [this._histogramWidget, this._groupHistogramWidget]) {
        if (!widget) continue;
        widget.height = height;
        widget.onElementResize(widget.element);
      }
    }
  }

  onTimeAxisViewModelUpdate() {
    for (const widget of [this._histogramWidget, this._groupHistogramWidget]) {
      if (!widget) continue;
      widget.width = this.timeAxisViewModel.totalSize;
      widget.onElementResize(widget.element);
    }
  } //endregion
  //region Render


  renderResourceAllocationInfo(allocation, cellElement, histogramWidget = null) {
    // if ticks widths are not monotonous
    // we provide width for each bar since in that case the histogram widget won't be able to calculate widths properly
    if (this.ticksWidth) {
      for (let i = 0, {
        length
      } = allocation; i < length; i++) {
        allocation[i].width = this.ticksWidth[i];
      }
    } // histogram pattern


    histogramWidget = histogramWidget || this.histogramWidget;
    histogramWidget.data = allocation;
    histogramWidget.refresh();
    const histogramCloneElement = histogramWidget.element.cloneNode(true);
    histogramCloneElement.removeAttribute('id');
    histogramCloneElement.classList.remove('b-hide-offscreen');
    cellElement.innerHTML = '';
    cellElement.appendChild(histogramCloneElement);
  }

  renderRows() {
    const me = this;

    if (!me.ticksIdentifier && me.project.isInitialCommitPerformed) {
      // If we render rows but have no ticksIdentifier means data loading and 1st commit
      // happened before the histogram was created.
      // Handle timeaxis settings to build ticksIdentifier and scale column points.
      me.onTimeAxisEndReconfigure(); // If timeView range is not defined then the timeaxis header looks empty so fill it in here (it triggers the column refresh)

      if (!me.timeView.startDate || !me.timeView.endDate) {
        me.timeView.range = {
          startDate: me.startDate,
          endDate: me.endDate
        };
      }
    }

    return super.renderRows(...arguments);
  }

  buildResourceAllocationReport(resource) {
    return this.project.resourceAllocationInfoClass.new({
      includeInactiveEvents: this.includeInactiveEvents,
      ticks: this.ticksIdentifier,
      resource
    });
  }

  renderResourceHistogram({
    grid: histogram,
    cellElement,
    record: resource
  }) {
    const {
      project
    } = histogram; // No drawing before engine's initial commit
    // Skip special rows, e.g. group records

    if (project.isInitialCommitPerformed && !resource.isSpecialRow) {
      const {
        allocationReportByResource
      } = histogram,
            allocationReport = allocationReportByResource.get(resource); // If we have no allocation report built for the resource yet
      // let's initialize it here

      if (!allocationReport) {
        const graph = project.getGraph(),
              allocationReport = histogram.buildResourceAllocationReport(resource),
              {
          observers,
          entities
        } = resource; // store resource allocation report reference

        allocationReportByResource.set(resource, allocationReport);
        graph.addEntity(allocationReport);
        entities.add(allocationReport); // trigger rendering on allocation report changes

        observers.add(graph.observe(function* () {
          return yield allocationReport.$.allocation;
        }, allocation => {
          if (!histogram.isDestroying) {
            const cell = histogram.getCell({
              id: resource.id,
              columnId: histogram.timeAxisColumn.id
            });

            if (cell) {
              histogram.renderResourceAllocationInfo(allocation, cell);
            } // announce resource allocation got calculated


            histogram.trigger('allocationChange', {
              resource,
              allocation
            });
            const groupParent = histogram.getResourceGroupParent(resource);

            if (groupParent) {
              // reset cached allocation for the resource group
              histogram.resourceGroupsAllocation.delete(groupParent); // schedule updating of resource group histograms

              histogram.scheduleGroupRender(groupParent);
            }
          }
        }));
      } // rendering was triggered by not allocation report change so we render based on existing "resource.allocation"
      else if (allocationReport.allocation) {
        if (allocationReport.graph) {
          histogram.renderResourceAllocationInfo(allocationReport.allocation, cellElement);
        } // allocation data had left the graph probably after the resource was removed
        else {
          allocationReportByResource.delete(resource);
        }

        const groupParent = histogram.getResourceGroupParent(resource); // if grouped - schedule updating of the resource group histograms

        if (groupParent && histogram.store.includes(groupParent)) {
          histogram.scheduleGroupRender(groupParent);
        }
      }
    }
  }

  renderScheduledGroups() {
    // Clone set to avoid infinite cycle when we add new entry to this.resourceGroupsToUpdate
    // in this.renderGroupHistogram() call
    for (const groupParent of Array.from(this.resourceGroupsToUpdate)) {
      this.renderGroupHistogram(groupParent);
    }

    this.clearTimeout(this.renderScheduledGroupTimer);
  }

  scheduleGroupRender(groupParent) {
    this.resourceGroupsToUpdate.add(groupParent);
    this.renderScheduledGroupTimer = this.setTimeout({
      fn: 'renderScheduledGroups',
      delay: 10,
      cancelOutstanding: true
    });
  }

  getResourceGroupParent(resource) {
    const instanceMeta = resource.instanceMeta(this.project.resourceStore.id);
    return instanceMeta === null || instanceMeta === void 0 ? void 0 : instanceMeta.groupParent;
  }

  calculateResourceGroupAllocation(groupParent) {
    var _allocationReports$, _allocationReports$$a;

    const me = this,
          {
      allocationReportByResource
    } = me,
          {
      groupChildren
    } = groupParent,
          allocationReports = groupChildren.map(resource => allocationReportByResource.get(resource)),
          newAllocationLength = (_allocationReports$ = allocationReports[0]) === null || _allocationReports$ === void 0 ? void 0 : (_allocationReports$$a = _allocationReports$.allocation) === null || _allocationReports$$a === void 0 ? void 0 : _allocationReports$$a.length; // All child resource allocations should be equal

    if (allocationReports.every(allocationReport => allocationReport && allocationReport.allocation && allocationReport.allocation.length === newAllocationLength)) {
      const combinedAllocation = []; // Iterate over the group resources
      // and aggregate resource allocations to show the group level histogram

      allocationReports.forEach(({
        allocation
      }) => {
        // iterate over ticks
        allocation.forEach((a, index) => {
          let combined = combinedAllocation[index];

          if (!combined) {
            combined = combinedAllocation[index] = {
              tick: a.tick,
              effort: 0,
              maxEffort: 0,
              units: 0,
              isGroup: true,
              resourceAllocation: new Map()
            };
          }

          combined.resourceAllocation.set(a.resource, {
            effort: a.effort,
            maxEffort: a.maxEffort,
            units: a.units,
            isOverallocated: a.effort > a.maxEffort,
            isUnderallocated: a.effort < a.maxEffort
          });
          combined.isOverallocated = combined.isOverallocated || a.isOverallocated;
          combined.isUnderallocated = combined.isUnderallocated || a.isUnderallocated;
          combined.effort += a.effort;
          combined.maxEffort += a.maxEffort;

          if (a.assignments) {
            if (combined.assignments) {
              a.assignments.forEach(assignment => combined.assignments.add(assignment));
            } else {
              combined.assignments = new Set(a.assignments);
            }
          }
        });
      });
      return combinedAllocation;
    }
  }

  renderGroupHistogram(groupParent) {
    const me = this;
    me.resourceGroupsToUpdate.delete(groupParent); // if the group is not in the store

    if (!me.store.includes(groupParent)) {
      me.resourceGroupsAllocation.delete(groupParent);
    }

    const combinedAllocation = me.resourceGroupsAllocation.get(groupParent) || me.calculateResourceGroupAllocation(groupParent);

    if (combinedAllocation) {
      var _me$scaleColumn;

      // cache calculated allocation
      me.resourceGroupsAllocation.set(groupParent, combinedAllocation);
      const {
        groupChildren
      } = groupParent,
            cellElement = me.getCell({
        id: groupParent.id,
        columnId: me.timeAxisColumn.id
      }),
            scalePoints = me.generateScalePoints(me.timeAxis.unit, me.timeAxis.increment * groupChildren.length),
            lastPoint = scalePoints[scalePoints.length - 1],
            scaleMax = me.project.convertDuration(lastPoint.value, lastPoint.unit, _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_8__["TimeUnit"].Millisecond),
            topValue = scaleMax + (((_me$scaleColumn = me.scaleColumn) === null || _me$scaleColumn === void 0 ? void 0 : _me$scaleColumn.scaleWidget.scaleMaxPadding) || 0) * scaleMax,
            widget = me._groupHistogramWidget || me.buildHistogramWidget({
        topValue
      }); // if we have group level histogram widget cached - update its topValue

      if (me._groupHistogramWidget) {
        widget.topValue = topValue;
      } // cache constructed histogram widget
      else {
        me._groupHistogramWidget = widget;
      } // render the group histogram


      if (cellElement) {
        me.renderResourceAllocationInfo(combinedAllocation, cellElement, widget);
        me.trigger('groupRendered', {
          groupParent
        });
      }
    } // if some allocations are not recalculated yet - reschedule this group update
    else if (me.store.includes(groupParent)) {
      me.scheduleGroupRender(groupParent);
    }
  }

  renderGroupScale(groupParent) {
    const me = this,
          {
      scaleColumn
    } = me; // Render scale only if scale column is there

    if (scaleColumn) {
      const {
        groupChildren
      } = groupParent,
            scalePoints = me.generateScalePoints(me.timeAxis.unit, me.timeAxis.increment * groupChildren.length),
            cellElement = me.getCell({
        id: groupParent.id,
        columnId: scaleColumn.id
      });
      let scaleWidget = me._groupScaleWidget;

      if (!scaleWidget) {
        scaleWidget = me._groupScaleWidget = scaleColumn.buildScaleWidget();
      }

      scaleWidget.scalePoints = scalePoints;
      return scaleColumn.renderer({
        cellElement,
        scaleWidget
      });
    }
  } //endregion
  //region Localization


  updateLocalization() {
    // Translate scale points if we have them (update localization on construction step is called too early)
    // and the scale points is generated by the histogram which means their labels use localized unit abbreviations
    if (this._generatedScalePoints === this.scalePoints && this.scalePoints) {
      this.scalePoints.forEach(scalePoint => {
        // if the point is labeled let's rebuild its text using new locale
        if (scalePoint.text && scalePoint.unit) {
          scalePoint.text = this.buildScalePointText(scalePoint);
        }
      });
    }

    super.updateLocalization(...arguments);
  } //endregion


}
ResourceHistogram.initClass();
ResourceHistogram._$name = 'ResourceHistogram';

/***/ }),

/***/ "./lib/SchedulerPro/view/SchedulerPro.js":
/*!***********************************************!*\
  !*** ./lib/SchedulerPro/view/SchedulerPro.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerPro; });
/* harmony import */ var _SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SchedulerProBase.js */ "./lib/SchedulerPro/view/SchedulerProBase.js");
/* harmony import */ var _Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony import */ var _Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/feature/Dependencies.js */ "./lib/Scheduler/feature/Dependencies.js");
/* harmony import */ var _Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Scheduler/feature/DependencyEdit.js */ "./lib/Scheduler/feature/DependencyEdit.js");
/* harmony import */ var _Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/feature/EventDrag.js */ "./lib/Scheduler/feature/EventDrag.js");
/* harmony import */ var _Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Scheduler/feature/EventDragCreate.js */ "./lib/Scheduler/feature/EventDragCreate.js");
/* harmony import */ var _Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Scheduler/feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony import */ var _Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Scheduler/feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Scheduler/feature/EventTooltip.js */ "./lib/Scheduler/feature/EventTooltip.js");
/* harmony import */ var _Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Scheduler/feature/NonWorkingTime.js */ "./lib/Scheduler/feature/NonWorkingTime.js");
/* harmony import */ var _Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony import */ var _Scheduler_feature_StickyEvents_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Scheduler/feature/StickyEvents.js */ "./lib/Scheduler/feature/StickyEvents.js");
/* harmony import */ var _Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Scheduler/feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony import */ var _Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Grid/feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony import */ var _feature_EventResize_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../feature/EventResize.js */ "./lib/SchedulerPro/feature/EventResize.js");
/* harmony import */ var _feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../feature/TaskEdit.js */ "./lib/SchedulerPro/feature/TaskEdit.js");
var productName = 'gantt';
 // Since SchedulerPro is based on thin XXBase classes, default features needs to be pulled in here

























 // For checkbox selection mode




/**
 * @module SchedulerPro/view/SchedulerPro
 */

/**
 * ## Intro
 *
 * The Scheduler Pro is an extension of the [Bryntum Scheduler](#Scheduler/view/Scheduler), and combines the visualisation capabilities
 * of the Scheduler with the powerful scheduling engine from the Gantt. This means it can manage {@link SchedulerPro/model/ProjectModel project} data composed by
 * tasks, dependencies, resources, assignments and calendars (for working / non-working time). If you have inter-task dependencies,
 * task updates will be propagated to any successors after a task is moved. The engine will reschedule tasks
 * according to the constraints, dependencies and calendars defined in the project. To familiarize yourself with the various APIs and data structures
 * of the Scheduler Pro, we recommend starting with these resources:
 *
 * * [Getting started guide](#SchedulerPro/guides/getting_started.md)
 * * [Project data model guide](#SchedulerPro/guides/basics/project_data.md)
 * * [Bryntum Scheduler API docs](#Scheduler/view/Scheduler)
 * * [Bryntum Grid API docs](#Grid/view/Grid)
 * * [Localization](#Scheduler/guides/customization/localization.md)
 *
 * ## Basic setup
 *
 * To create an instance of this class, simply configure it with:
 *
 * * The {@link Grid/column/Column columns} you want
 * * The {@link Grid/view/Grid#config-features} you want, quite a lot to choose from, and you can build your own too
 * * A {@link SchedulerPro/model/ProjectModel Project} instance:
 * * A {@link Scheduler/preset/ViewPreset viewPreset} identifier, specifying the granularity of the time axis.
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *    // A Project holds the data and the calculation engine for Scheduler Pro. It also acts as a CrudManager, allowing
 *    // loading data into all stores at once
 *    project : {
 *        autoLoad  : true,
 *        transport : {
 *            load : {
 *                url : './data/data.json'
 *            }
 *       }
 *    },
 *
 *    adopt             : 'container',
 *    startDate         : '2020-05-01',
 *    endDate           : '2020-09-30',
 *    resourceImagePath : '../_shared/images/users/',
 *    viewPreset        : 'dayAndWeek'
 *    features : {
 *       columnLines  : false,
 *       dependencies : true
 *   },
 *
 *   columns : [
 *       {
 *           type           : 'resourceInfo',
 *           text           : 'Worker',
 *           showEventCount : true
 *       }
 *   ]
 * });
 * ```
 * {@inlineexample SchedulerPro/view/SchedulerPro.js}
 *
 * ## Customisation
 *
 * You can style any aspect of the Scheduler using plain CSS or modify our themes using our built-in SASS variables.
 * Using the {@link Scheduler/view/mixin/SchedulerEventRendering#config-eventRenderer} you can customize the HTML output for
 * each event bar. The Scheduler comes with a few different {@link #config-eventStyle event styles} which you can
 * define globally on the Scheduler, in the resource data, or on individual events.
 *
 * {@inlineexample SchedulerPro/view/EventStyles.js}
 *
 * For more information about styling, please refer to the [styling guide](#Scheduler/guides/customization/styling.md).
 *
 * ## Partnering with other timeline widgets
 *
 * You can also pair the Scheduler Pro with other timeline based widgets such as the {@link SchedulerPro/view/ResourceHistogram histogram widget}
 * to view resource allocation levels, using the {@link #config-partner} config.
 *
 * {@inlineexample SchedulerPro/view/ResourceHistogram.js}
 *
 *
 * ### Differences between Scheduler and Scheduler Pro
 * Scheduler Pro extends Scheduler and schedules tasks based on the Project, Resource and Event calendars, while also taking into account
 * dependencies and constraints. Scheduler Pro also comes with more demos showing off advanced use cases. Below is a list
 * of technical differences between the two versions:
 *
 * - Scheduler uses an EventStore, ResourceStore (optionally an AssignmentStore and a DependencyStore), whereas Scheduler Pro always
 * uses an AssignmentStore to manage event assignments.
 * - Scheduler Pro uses the same data model as the Gantt and can visualise a Project side by side with the Gantt.
 * - Scheduler supports showing dependencies but they are just visual elements, they do not impact scheduling. In Scheduler Pro,
 * adding a dependency between two tasks will affect the scheduling of the successor task.
 * - Scheduler Pro supports visualising a task completion progress bar.
 * - Scheduler Pro includes a Timeline widget and a Resource Histogram widget.
 *
 * @extends SchedulerPro/view/SchedulerProBase
 */

class SchedulerPro extends _SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'SchedulerPro';
  }

  static get type() {
    return 'schedulerpro';
  } //endregion


}
SchedulerPro.initClass();
SchedulerPro._$name = 'SchedulerPro';

/***/ }),

/***/ "./lib/SchedulerPro/view/SchedulerProBase.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/view/SchedulerProBase.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerProBase; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/ProjectModel.js */ "./lib/SchedulerPro/model/ProjectModel.js");
/* harmony import */ var _mixin_SchedulerProEventRendering_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/SchedulerProEventRendering.js */ "./lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js");
/* harmony import */ var _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Scheduler/view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../localization/En.js */ "./lib/SchedulerPro/localization/En.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/view/SchedulerProBase
 */

/**
 * A thin base class for {@link SchedulerPro.view.SchedulerPro}. Includes fewer features by default, allowing smaller
 * custom built bundles if used in place of {@link SchedulerPro.view.SchedulerPro}.
 *
 * **NOTE:** In most scenarios you should use SchedulerPro instead of SchedulerProBase.
 *
 * @mixes SchedulerPro/view/mixin/SchedulerProEventRendering
 *
 * @features SchedulerPro/feature/EventResize
 * @features SchedulerPro/feature/PercentBar
 * @features SchedulerPro/feature/ResourceNonWorkingTime
 * @features SchedulerPro/feature/TaskEdit
 *
 * @extends Scheduler/view/SchedulerBase
 */

class SchedulerProBase extends _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_4__["default"].mixin(_mixin_SchedulerProEventRendering_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get $name() {
    return 'SchedulerProBase';
  }

  static get type() {
    return 'schedulerprobase';
  }

  static get configurable() {
    return {
      projectModelClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * A task field (id, wbsCode, sequenceNumber etc) that will be used when displaying and editing linked tasks.
       * @config {String} dependencyIdField
       * @default 'id'
       */
      dependencyIdField: 'id'
    };
  }

  static get isSchedulerPro() {
    return true;
  } //endregion
  //region Internal
  // Overrides grid to take project loading into account


  toggleEmptyText() {
    const me = this;

    if (me.bodyContainer) {
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].toggleClasses(me.bodyContainer, 'b-grid-empty', !(me.rowManager.rowCount || me.project.isLoadingOrSyncing));
    }
  } // Needed to work with Gantt features


  get taskStore() {
    return this.project.eventStore;
  } //endregion


  internalAddEvent(startDate, resourceRecord, row) {
    // For resources with a calendar, ensure the date is inside a working time range
    if (!resourceRecord.isWorkingTime(startDate)) {
      return;
    } // If task editor is active dblclick will trigger number of async actions:
    // store add which would schedule project commit
    // editor cancel on next animation frame
    // editor hide
    // rejecting previous transaction
    // and there is also dependency feature listening to transitionend on scheduler to draw lines after
    // It can happen that user dblclicks too fast, then event will be added, then dependency will schedule itself
    // to render, and then event will be removed as part of transaction rejection from editor. So we cannot add
    // event before active transaction is done.


    if (this.taskEdit && this.taskEdit.isEditing) {
      this.on({
        aftertaskedit: () => super.internalAddEvent(startDate, resourceRecord, row),
        once: true
      });
    } else {
      return super.internalAddEvent(startDate, resourceRecord, row);
    }
  }

}
SchedulerProBase.initClass();
_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setVersion('schedulerpro', '4.3.5');
SchedulerProBase._$name = 'SchedulerProBase';

/***/ }),

/***/ "./lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js":
/*!*******************************************************************!*\
  !*** ./lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _eventlayout_ProHorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../eventlayout/ProHorizontalLayoutStack.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js");
/* harmony import */ var _eventlayout_ProHorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../eventlayout/ProHorizontalLayoutPack.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayoutPack.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/view/mixin/SchedulerProEventRendering
 */

/**
 * Config for event layout
 * @typedef {Object} EventLayoutConfig
 * @property {String} type Event layout type. Possible values for horizontal mode are `stack`, `pack` and `none`.
 * For vertical mode: `pack`, `mixed` and `none`.
 * @property {Function} layoutFn Horizontal mode only. This function allows to manually position events inside the row.
 * @property {Object} weights Horizontal mode only. Specifies groups order.
 * @property {String|Function} groupBy Horizontal mode only. Specifies a way to group events inside a row.
 */

/**
 * Functions to handle event rendering in Scheduler Pro (EventModel -> dom elements).
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SchedulerProEventRendering extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'SchedulerProEventRendering';
  }

  static get configurable() {
    return {
      /**
       * Get/set overlap mode. See {@link #config-eventLayout} config, valid values are `stack` (horizontal), `pack`, `mixed`
       * (vertical) and `none`
       * @member {String} eventLayout
       * @accepts {String|Object}
       * @category Scheduled events
       */

      /**
       * This config defines how to handle overlapping events. Valid values are:
       * - `stack`, adjusts row height (only horizontal)
       * - `pack`, adjusts event height
       * - `mixed`, allows two events to overlap, more packs (only vertical)
       * - `none`, allows events to overlap
       *
       * You can also provide a configuration object accepted by
       * {@link SchedulerPro.eventlayout.ProHorizontalLayout} to group events or even take control over the
       * layout (i.e. vertical position and height):
       *
       * To group events:
       *
       * ```javascript
       * new SchedulerPro({
       *     eventLayout : {
       *         type    : 'stack',
       *         weights : {
       *             high   : 100,
       *             normal : 150,
       *             low    : 200
       *         },
       *         groupBy : 'prio'
       *     }
       * });
       * ```
       *
       * To take control over the layout:
       *
       * ```javascript
       * new SchedulerPro({
       *     eventLayout : {
       *         layoutFn : items => {
       *             items.forEach(item => {
       *                 item.top = 100 * Math.random();
       *                 item.height = 100 * Math.random();
       *             });
       *
       *             return 100;
       *         }
       *     }
       * });
       * ```
       *
       * For more info on grouping and layout please refer to {@link SchedulerPro.eventlayout.ProHorizontalLayout}
       * doc article.
       *
       * @config {String|EventLayoutConfig}
       * @default
       * @category Scheduled events
       */
      eventLayout: 'stack',

      /**
       * The class responsible for the packing horizontal event layout process.
       * Override this to take control over the layout process.
       * @config {Scheduler.eventlayout.HorizontalLayout}
       * @typings {typeof HorizontalLayout}
       * @default
       * @private
       * @category Misc
       */
      horizontalLayoutPackClass: _eventlayout_ProHorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_2__["default"],

      /**
       * The class name responsible for the stacking horizontal event layout process.
       * Override this to take control over the layout process.
       * @config {Scheduler.eventlayout.HorizontalLayout}
       * @typings {typeof HorizontalLayout}
       * @default
       * @private
       * @category Misc
       */
      horizontalLayoutStackClass: _eventlayout_ProHorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  } //region Config


  updateInternalEventLayout(eventLayout, oldEventLayout) {
    const me = this;

    if (!me.isConfiguring) {
      me.clearLayouts();
    }

    super.updateInternalEventLayout(eventLayout, oldEventLayout);
  } //endregion


  getEventLayout(config) {
    config = super.getEventLayout(config);

    if ('layoutFn' in config) {
      config.type = 'layoutFn';
    }

    return config;
  }

  clearLayouts() {
    const me = this;

    if (me.layouts) {
      for (const key in me.layouts) {
        me.layouts[key].destroy();
        delete me.layouts[key];
      }
    }
  }
  /**
   * Get event layout handler. The handler decides the vertical placement of events within a resource.
   * Returns null if no eventLayout is used (if {@link #config-eventLayout} is set to "none")
   * @internal
   * @returns {Scheduler.eventlayout.HorizontalLayout}
   * @readonly
   * @category Scheduled events
   */


  getEventLayoutHandler(eventLayout) {
    const me = this;

    if (!me.isHorizontal) {
      return null;
    }

    const {
      timeAxisViewModel,
      horizontal
    } = me;

    if (!me.layouts) {
      me.layouts = {};
    }

    const {
      layouts
    } = me;

    switch (eventLayout.type) {
      // stack, adjust row height to fit all events
      case 'stack':
        {
          if (!layouts.horizontalStack) {
            layouts.horizontalStack = me.horizontalLayoutStackClass.new({
              scheduler: me,
              timeAxisViewModel,
              bandIndexToPxConvertFn: horizontal.layoutEventVerticallyStack,
              bandIndexToPxConvertThisObj: horizontal,
              groupByThisObj: me
            }, eventLayout);
          }

          return layouts.horizontalStack;
        }
      // pack, fit all events in available height by adjusting their height

      case 'pack':
        {
          if (!layouts.horizontalPack) {
            layouts.horizontalPack = me.horizontalLayoutPackClass.new({
              scheduler: me,
              timeAxisViewModel,
              bandIndexToPxConvertFn: horizontal.layoutEventVerticallyPack,
              bandIndexToPxConvertThisObj: horizontal,
              groupByThisObj: me
            }, eventLayout);
          }

          return layouts.horizontalPack;
        }

      case 'layoutFn':
        {
          // Both methods are called on a layout
          return {
            type: 'layoutFn',
            applyLayout: eventLayout.layoutFn,
            layoutEventsInBands: eventLayout.layoutFn
          };
        }

      default:
        return null;
    }
  }

});

/***/ }),

/***/ "./lib/SchedulerPro/widget/CalendarField.js":
/*!**************************************************!*\
  !*** ./lib/SchedulerPro/widget/CalendarField.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarField; });
/* harmony import */ var _ModelCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ModelCombo.js */ "./lib/SchedulerPro/widget/ModelCombo.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/CalendarField
 */

/**
 * A combo used to select the calendar for an event. This field can be seen in the {@link SchedulerPro.widget.taskeditor.AdvancedTab}
 * {@inlineexample SchedulerPro/widget/CalendarField.js}
 * @extends SchedulerPro/widget/ModelCombo
 * @classtype calendarfield
 */

class CalendarField extends _ModelCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'CalendarField';
  } // Factoryable type name


  static get type() {
    return 'calendarfield';
  }

  static get defaultConfig() {
    return {
      valueField: 'id',
      displayField: 'name',
      editable: false,

      /**
       * The store containing the calendars
       * @config {SchedulerPro.data.CalendarManagerStore}
       */
      store: null,
      listItemTpl: calendar => {
        return calendar.name || this.L('L{Default calendar}');
      },
      displayValueRenderer: c => {
        return c ? c.name : this.L('L{Default calendar}');
      }
    };
  } //endregion
  //region Internal


  get value() {
    return super.value;
  }

  set value(v) {
    if (v && v.isDefault && v.isDefault()) {
      v = null;
    }

    super.value = v;
  } //endregion


} // Register this widget type with its Factory

CalendarField.initClass();
CalendarField._$name = 'CalendarField';

/***/ }),

/***/ "./lib/SchedulerPro/widget/ConstraintTypePicker.js":
/*!*********************************************************!*\
  !*** ./lib/SchedulerPro/widget/ConstraintTypePicker.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ConstraintTypePicker; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/widget/ConstraintTypePicker
 */

/**
 * Combo box preconfigured with possible constraint type values.
 * This picker doesn't support {@link Core/widget/Combo#config-multiSelect multiSelect}.
 *
 * This field can be used as an editor for a {@link Grid/column/Column}.
 * It is used as the default editor for the `ConstraintTypeColumn` in the Gantt chart.
 *
 * {@inlineexample SchedulerPro/widget/ConstraintTypePicker.js}
 * @extends Core/widget/Combo
 * @classType constrainttypepicker
 */

class ConstraintTypePicker extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ConstraintTypePicker';
  } // Factoryable type name


  static get type() {
    return 'constrainttypepicker';
  }

  static get configurable() {
    return {
      valueField: 'id'
    };
  } //endregion
  //region Localization


  updateLocalization() {
    super.updateLocalization(); // rebuild newly translated options

    this.store.data = this.buildStoreData();
  } //endregion
  //region Internal


  buildStoreData() {
    const me = this;
    /* eslint-disable quote-props */

    return [{
      'id': 'none',
      text: me.L('L{none}')
    }, {
      'id': 'muststarton',
      text: me.L('L{muststarton}')
    }, {
      'id': 'mustfinishon',
      text: me.L('L{mustfinishon}')
    }, {
      'id': 'startnoearlierthan',
      text: me.L('L{startnoearlierthan}')
    }, {
      'id': 'startnolaterthan',
      text: me.L('L{startnolaterthan}')
    }, {
      'id': 'finishnoearlierthan',
      text: me.L('L{finishnoearlierthan}')
    }, {
      'id': 'finishnolaterthan',
      text: me.L('L{finishnolaterthan}')
    }];
    /* eslint-enable quote-props */
  }

  set value(value) {
    super.value = value;
  }

  get value() {
    const value = super.value;
    return value === 'none' ? null : value;
  }

  get store() {
    if (!this._store) {
      this.store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        data: this.buildStoreData(),
        allowNullId: true
      });
    }

    return this._store;
  }

  set store(store) {
    super.store = store;
  } //endregion


} // Register this widget type with its Factory

ConstraintTypePicker.initClass();
ConstraintTypePicker._$name = 'ConstraintTypePicker';

/***/ }),

/***/ "./lib/SchedulerPro/widget/DependencyTypePicker.js":
/*!*********************************************************!*\
  !*** ./lib/SchedulerPro/widget/DependencyTypePicker.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyTypePicker; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/widget/DependencyTypePicker
 */

const buildItems = items => items.map((item, index) => [index, item]);
/**
 * A combo box field used to select the link type for a {@link SchedulerPro.model.DependencyModel Dependency} between two tasks.
 *
 * {@inlineexample SchedulerPro/widget/DependencyTypePicker.js}
 * @extends Core/widget/Combo
 * @classType dependencytypepicker
 */


class DependencyTypePicker extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'DependencyTypePicker';
  } // Factoryable type name


  static get type() {
    return 'dependencytypepicker';
  } //endregion
  //region Constructor


  construct(config) {
    super.construct(config); // Update when changing locale

    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
      locale: () => {
        this.items = buildItems(this.L('L{DependencyType.long}'));
      },
      thisObj: this
    });
  } //endregion
  //region Internal


  get store() {
    if (!this._items) {
      this.items = this._items = buildItems(this.L('L{DependencyType.long}'));
    }

    return super.store;
  }

  set store(store) {
    super.store = store;
  } //endregion


} // Register this widget type with its Factory

DependencyTypePicker.initClass();
DependencyTypePicker._$name = 'DependencyTypePicker';

/***/ }),

/***/ "./lib/SchedulerPro/widget/EffortField.js":
/*!************************************************!*\
  !*** ./lib/SchedulerPro/widget/EffortField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffortField; });
/* harmony import */ var _Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/EffortField
 */
// NOTE: class is created mostly for localization reasons
//       effort field invalidText might differ from duration field one.

/**
 * A specialized field allowing a user to also specify duration unit when editing the effort value.
 *
 * {@inlineexample SchedulerPro/widget/EffortField.js}
 * @extends Core/widget/DurationField
 * @classType effort
 */

class EffortField extends _Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'EffortField';
  } // Factoryable type name


  static get type() {
    return 'effort';
  } // Factoryable type name


  static get alias() {
    return 'effortfield';
  }

} // Register this widget type with its Factory

EffortField.initClass();
EffortField._$name = 'EffortField';

/***/ }),

/***/ "./lib/SchedulerPro/widget/EndDateField.js":
/*!*************************************************!*\
  !*** ./lib/SchedulerPro/widget/EndDateField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EndDateField; });
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/widget/EndDateField
 */

/**
 * Date field widget (text field + date picker) to be used together with Scheduling Engine.
 * This field adjusts time to the latest possible time of the day based on either:
 *
 * - the event calendars (which is a combination of its own calendar and assigned resources ones) - if {@link #config-eventRecord} is provided.
 * - the project {@link SchedulerPro.model.ProjectModel#property-calendar calendar} - if {@link #config-project} is provided.
 *
 * **Please note, that either {@link #config-eventRecord} or {@link #config-project} value must be provided.**
 *
 * This field can be used as an editor for a {@link Grid.column.Column Column}.
 * It is used as the default editor for the `EndDateColumn`.
 *
 * {@inlineexample SchedulerPro/widget/EndDateField.js}
 * @extends Core/widget/DateField
 * @classType enddatefield
 */

class EndDateField extends _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'EndDateField';
  } // Factoryable type name


  static get type() {
    return 'enddatefield';
  } // Factoryable alias name


  static get alias() {
    return 'enddate';
  }

  static get defaultConfig() {
    return {
      /**
       * Project model calendar of which should be used by the field.
       * @config {SchedulerPro.model.ProjectModel}
       */
      project: null,

      /**
       * The Event model defining the calendar to be used by the field.
       * @config {SchedulerPro.model.EventModel}
       */
      eventRecord: null
    };
  } //endregion
  //region Internal


  get min() {
    var _this$eventRecord;

    let min = this._min;
    const eventStartDate = (_this$eventRecord = this.eventRecord) === null || _this$eventRecord === void 0 ? void 0 : _this$eventRecord.startDate;

    if (eventStartDate) {
      min = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(min || eventStartDate, eventStartDate);
    }

    return min;
  }

  set min(value) {
    super.min = value;
  }

  get calendarProvider() {
    return this.eventRecord || this.project;
  }

  get backShiftDate() {
    const me = this;
    let result = me.calendarProvider.run('skipWorkingTime', me.value, false, me._step.magnitude, me._step.unit); // Need to skip non working time
    // since after the above step "result" can be set at 08:00 for example (for business calendar)

    result = result && me.calendarProvider.run('skipNonWorkingTime', result, false);
    return result;
  }

  get forwardShiftDate() {
    const me = this;
    return me.calendarProvider.run('skipWorkingTime', me.value, true, me._step.magnitude, me._step.unit);
  }

  transformTimeValue(value) {
    const {
      calendarProvider,
      keepTime
    } = this;

    if (calendarProvider && keepTime !== 'entered') {
      const startOfTheDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(value),
            startOfNextDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startOfTheDay, 1, 'day'),
            // search for the latest available time for this day
      latestTime = calendarProvider.run('skipNonWorkingTime', startOfNextDay, false); // if it's the same day, the latest time is found, use it

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isValidDate(latestTime) && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(latestTime, startOfTheDay, 'day')) {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(startOfTheDay, latestTime);
      }
    } // if keepTime==false means we reset time info ..make sure we do not violate "min" value in that case


    if (!keepTime && value && this.min && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(value, false) < this.min) {
      return this.min;
    }

    return super.transformTimeValue(value);
  } //endregion


} // Register this widget type with its Factory

EndDateField.initClass();
EndDateField._$name = 'EndDateField';

/***/ }),

/***/ "./lib/SchedulerPro/widget/GanttTaskEditor.js":
/*!****************************************************!*\
  !*** ./lib/SchedulerPro/widget/GanttTaskEditor.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GanttTaskEditor; });
/* harmony import */ var _TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskEditorBase.js */ "./lib/SchedulerPro/widget/TaskEditorBase.js");
/* harmony import */ var _taskeditor_GeneralTab_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./taskeditor/GeneralTab.js */ "./lib/SchedulerPro/widget/taskeditor/GeneralTab.js");
/* harmony import */ var _taskeditor_SuccessorsTab_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./taskeditor/SuccessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js");
/* harmony import */ var _taskeditor_PredecessorsTab_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./taskeditor/PredecessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js");
/* harmony import */ var _taskeditor_ResourcesTab_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./taskeditor/ResourcesTab.js */ "./lib/SchedulerPro/widget/taskeditor/ResourcesTab.js");
/* harmony import */ var _taskeditor_AdvancedTab_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./taskeditor/AdvancedTab.js */ "./lib/SchedulerPro/widget/taskeditor/AdvancedTab.js");
/* harmony import */ var _taskeditor_NotesTab_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./taskeditor/NotesTab.js */ "./lib/SchedulerPro/widget/taskeditor/NotesTab.js");
/* harmony import */ var _Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/TabPanel.js */ "./lib/Core/widget/TabPanel.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';
/**
* @module SchedulerPro/widget/GanttTaskEditor
*/










/**
 * A subclass of {@link SchedulerPro.widget.TaskEditorBase} for Gantt projects which SchedulerPro can handle as well.
 *
 * @extends SchedulerPro/widget/TaskEditorBase
 */

class GanttTaskEditor extends _TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'gantttaskeditor';
  } //region Config


  static get $name() {
    return 'GanttTaskEditor';
  }

  static get defaultConfig() {
    return {
      items: [{
        type: 'tabpanel',
        defaultType: 'formtab',
        ref: 'tabs',
        flex: '1 0 100%',
        autoHeight: true,
        layoutConfig: {
          alignItems: 'stretch',
          alignContent: 'stretch'
        },
        items: {
          generalTab: {
            type: 'generaltab',
            weight: 100
          },
          predecessorsTab: {
            type: 'predecessorstab',
            weight: 200
          },
          successorsTab: {
            type: 'successorstab',
            weight: 300
          },
          resourcesTab: {
            type: 'resourcestab',
            weight: 400
          },
          advancedTab: {
            type: 'advancedtab',
            weight: 500
          },
          notesTab: {
            type: 'notestab',
            weight: 600
          }
        }
      }]
    };
  }

  processWidgetConfig(widgetConfig) {
    // Backward compatibility, see base class
    if (widgetConfig.ref === 'tabs' && this.extraItems) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Gantt', '5.0.0', '`extraItems` config is deprecated, in favor of `items` config. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0 for more information.');
    }

    return super.processWidgetConfig(widgetConfig);
  }

  startConfigure(config) {
    // Backward compatibility, see base class
    if (config.tabsConfig) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Gantt', '5.0.0', '`tabsConfig` config is deprecated, in favor of `items` config. Please see https://bryntum.com/docs/gantt/guide/Gantt/upgrades/4.0.0 for more information.');
    }

    super.startConfigure(config);
  } //endregion


} // Register this widget type with its Factory

GanttTaskEditor.initClass();
GanttTaskEditor._$name = 'GanttTaskEditor';

/***/ }),

/***/ "./lib/SchedulerPro/widget/ModelCombo.js":
/*!***********************************************!*\
  !*** ./lib/SchedulerPro/widget/ModelCombo.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/ModelCombo
 */

/**
 * A special {@link Core.widget.Combo} subclass returning a {@link Core.data.Model} instance from its store as the value
 * @extends Core/widget/Combo
 * @classType modelcombo
 */

class ModelCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ModelCombo';
  } // Factoryable type name


  static get type() {
    return 'modelcombo';
  } //endregion
  //region Internal


  get value() {
    const superValue = super.value,
          model = this.store.getById(superValue);
    return model || superValue;
  }

  set value(v) {
    super.value = v;
  } //endregion


} // Register this widget type with its Factory

ModelCombo.initClass();
ModelCombo._$name = 'ModelCombo';

/***/ }),

/***/ "./lib/SchedulerPro/widget/SchedulerTaskEditor.js":
/*!********************************************************!*\
  !*** ./lib/SchedulerPro/widget/SchedulerTaskEditor.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerTaskEditor; });
/* harmony import */ var _TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskEditorBase.js */ "./lib/SchedulerPro/widget/TaskEditorBase.js");
/* harmony import */ var _taskeditor_SchedulerGeneralTab_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./taskeditor/SchedulerGeneralTab.js */ "./lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js");
/* harmony import */ var _taskeditor_SuccessorsTab_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./taskeditor/SuccessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js");
/* harmony import */ var _taskeditor_PredecessorsTab_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./taskeditor/PredecessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js");
/* harmony import */ var _taskeditor_ResourcesTab_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./taskeditor/ResourcesTab.js */ "./lib/SchedulerPro/widget/taskeditor/ResourcesTab.js");
/* harmony import */ var _taskeditor_SchedulerAdvancedTab_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./taskeditor/SchedulerAdvancedTab.js */ "./lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js");
/* harmony import */ var _taskeditor_NotesTab_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./taskeditor/NotesTab.js */ "./lib/SchedulerPro/widget/taskeditor/NotesTab.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'gantt';
/**
* @module SchedulerPro/widget/SchedulerTaskEditor
*/









/**
 * {@link SchedulerPro/widget/TaskEditorBase} subclass for simplified SchedulerPro projects.
 *
 * Provides a UI to edit tasks in a dialog. To append Widgets to any of the built-in tabs, use the `items` config.
 *
 * The Task editor contains tabs by default. Each tab contains built in widgets: text fields, grids, etc.
 *
 * | Tab ref           | Text                                                                             | Weight | Description                                                                          |
 * |-------------------|----------------------------------------------------------------------------------|--------|--------------------------------------------------------------------------------------|
 * | `generalTab`      | {@link SchedulerPro.widget.taskeditor.SchedulerGeneralTab SchedulerGeneralTab}   | 100    | Shows basic configuration: name, resources, start/end dates, duration, percent done. |
 * | `predecessorsTab` | {@link SchedulerPro.widget.taskeditor.PredecessorsTab PredecessorsTab}           | 200    | Shows a grid with incoming dependencies                                              |
 * | `successorsTab`   | {@link SchedulerPro.widget.taskeditor.SuccessorsTab SuccessorsTab}               | 300    | Shows a grid with outgoing dependencies                                              |
 * | `advancedTab`     | {@link SchedulerPro.widget.taskeditor.SchedulerAdvancedTab SchedulerAdvancedTab} | 500    | Shows advanced configuration: constraints and manual scheduling mode                 |
 * | `notesTab`        | {@link SchedulerPro.widget.taskeditor.NotesTab NotesTab}                         | 600    | Shows a text area to add notes to the selected task                                  |
 *
 * ## Task editor customization example
 *
 * {@inlineexample SchedulerPro/feature/TaskEditExtraItems.js}
 *
 * @inlineexample SchedulerPro/widget/SchedulerTaskEditor.js
 * @extends SchedulerPro/widget/TaskEditorBase
 */

class SchedulerTaskEditor extends _TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'schedulertaskeditor';
  } //region Config


  static get $name() {
    return 'SchedulerTaskEditor';
  }

  static get defaultConfig() {
    return {
      items: [{
        type: 'tabpanel',
        defaultType: 'formtab',
        ref: 'tabs',
        flex: '1 0 100%',
        autoHeight: true,
        layoutConfig: {
          alignItems: 'stretch',
          alignContent: 'stretch'
        },
        items: {
          generalTab: {
            type: 'schedulergeneraltab',
            weight: 100
          },
          predecessorsTab: {
            type: 'predecessorstab',
            weight: 200
          },
          successorsTab: {
            type: 'successorstab',
            weight: 300
          },
          // Replaced with combo on general tab
          //{ type : 'resourcestab', weight : 400 },
          advancedTab: {
            type: 'scheduleradvancedtab',
            weight: 500
          },
          notesTab: {
            type: 'notestab',
            weight: 600
          }
        }
      }]
    };
  }

  processWidgetConfig(widgetConfig) {
    // Backward compatibility, see base class
    if (widgetConfig.ref === 'tabs' && this.extraItems) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].deprecate('SchedulerPro', '5.0.0', '`extraItems` config is deprecated, in favor of `items` config. Please see https://bryntum.com/docs/scheduler-pro/guide/SchedulerPro/upgrades/4.0.0 for more information.');
    }

    return super.processWidgetConfig(widgetConfig);
  }

  startConfigure(config) {
    // Backward compatibility, see base class
    if (config.tabsConfig) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].deprecate('SchedulerPro', '5.0.0', '`tabsConfig` config is deprecated, in favor of `items` config. Please see https://bryntum.com/docs/scheduler-pro/guide/SchedulerPro/upgrades/4.0.0 for more information.');
    }

    super.startConfigure(config);
  } //endregion


} // Register this widget type with its Factory

SchedulerTaskEditor.initClass();
SchedulerTaskEditor._$name = 'SchedulerTaskEditor';

/***/ }),

/***/ "./lib/SchedulerPro/widget/SchedulingModePicker.js":
/*!*********************************************************!*\
  !*** ./lib/SchedulerPro/widget/SchedulingModePicker.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulingModePicker; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/widget/SchedulingModePicker
 */

/**
 * Combo box preconfigured with possible scheduling mode values.
 *
 * This field can be used as an editor for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the `SchedulingModeColumn`.
 *
 * {@inlineexample SchedulerPro/widget/SchedulingModePicker.js}
 * @extends Core/widget/Combo
 * @classType schedulingmodecombo
 */

class SchedulingModePicker extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    //region Config
    return 'SchedulingModePicker';
  } // Factoryable type name


  static get type() {
    return 'schedulingmodecombo';
  } //endregion
  //region Internal


  buildStoreData() {
    return [{
      id: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].Normal,
      text: this.L('L{Normal}')
    }, {
      id: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedDuration,
      text: this.L('L{Fixed Duration}')
    }, {
      id: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedUnits,
      text: this.L('L{Fixed Units}')
    }, {
      id: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_2__["SchedulingMode"].FixedEffort,
      text: this.L('L{Fixed Effort}')
    }];
  }

  get store() {
    if (!this._store) {
      this.store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        data: this.buildStoreData()
      });
    }

    return this._store;
  }

  set store(store) {
    super.store = store;
  }

  updateLocalization() {
    super.updateLocalization(); // rebuild newly translated options

    this.store.data = this.buildStoreData();
  } //endregion


} // Register this widget type with its Factory

SchedulingModePicker.initClass();
SchedulingModePicker._$name = 'SchedulingModePicker';

/***/ }),

/***/ "./lib/SchedulerPro/widget/StartDateField.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/widget/StartDateField.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StartDateField; });
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/widget/StartDateField
 */

/**
 * Date field widget (text field + date picker) to be used together with Scheduling Engine.
 * This field adjusts time to the earliest possible time of the day based on either:
 *
 * - the event calendars (which is a combination of its own calendar and assigned resources ones) - if {@link #config-eventRecord} is provided.
 * - the project {@link SchedulerPro.model.ProjectModel#property-calendar calendar} - if {@link #config-project} is provided.
 *
 * **Please note, that either {@link #config-eventRecord} or {@link #config-project} value must be provided.**
 *
 * This field can be used as an editor for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the `StartDateColumn`.
 *
 * {@inlineexample SchedulerPro/widget/StartDateField.js}
 * @extends Core/widget/DateField
 * @classType startdatefield
 */

class StartDateField extends _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'StartDateField';
  } // Factoryable type name


  static get type() {
    return 'startdatefield';
  } // Factoryable type alias


  static get alias() {
    return 'startdate';
  }

  static get defaultConfig() {
    return {
      /**
       * Project model calendar of which should be used by the field.
       * @config {SchedulerPro.model.ProjectModel}
       */
      project: null,

      /**
       * Event model calendars of which should be used by the field.
       * @config {SchedulerPro.model.EventModel}
       */
      eventRecord: null
    };
  } //endregion
  //region Internal


  get calendarProvider() {
    return this.eventRecord || this.project;
  }

  get backShiftDate() {
    const me = this;
    return me.calendarProvider.run('skipWorkingTime', me.value, false, me._step.magnitude, me._step.unit);
  }

  get forwardShiftDate() {
    const me = this;
    let result = me.calendarProvider.run('skipWorkingTime', me.value, true, me._step.magnitude, me._step.unit); // Need to skip non working time
    // since after the above step "result" can be set at 17:00 for example (for business calendar)

    result = result && me.calendarProvider.run('skipNonWorkingTime', result, true);
    return result;
  }

  transformTimeValue(value) {
    const {
      calendarProvider,
      keepTime
    } = this;

    if (calendarProvider && keepTime !== 'entered') {
      const startOfTheDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(value),
            // search for the earliest available time for this day
      earliestTime = calendarProvider.run('skipNonWorkingTime', startOfTheDay); // if it's the same day, the earliest time is found, use it

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isValidDate(earliestTime) && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(earliestTime, startOfTheDay, 'day')) {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(startOfTheDay, earliestTime);
      }
    }

    return super.transformTimeValue(value);
  } //endregion


} // Register this widget type with its Factory

StartDateField.initClass();
StartDateField._$name = 'StartDateField';

/***/ }),

/***/ "./lib/SchedulerPro/widget/TaskEditorBase.js":
/*!***************************************************!*\
  !*** ./lib/SchedulerPro/widget/TaskEditorBase.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEditorBase; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _widget_taskeditor_mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../widget/taskeditor/mixin/ReadyStatePropagator.js */ "./lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../localization/En.js */ "./lib/SchedulerPro/localization/En.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/widget/TaskEditorBase
 */

/**
 * Abstract base class for Scheduler and Gantt task editors
 *
 * @extends Core/widget/Popup
 * @abstract
 */

class TaskEditorBase extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_widget_taskeditor_mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  //region Config
  static get $name() {
    return 'TaskEditorBase';
  }

  static get type() {
    return 'taskeditorbase';
  }

  static get configurable() {
    return {
      localizableProperties: ['width'],
      title: 'L{Information}',
      cls: 'b-schedulerpro-taskeditor',
      closable: true,
      layout: 'fit',
      draggable: {
        handleSelector: ':not(button,.b-field-inner)' // blacklist buttons and field inners

      },
      items: null,
      // overridden in subclasses
      bbar: {
        // When readOnly, child buttons are hidden
        hideWhenEmpty: true,
        defaults: {
          localeClass: this
        },
        items: {
          saveButton: {
            text: 'L{Save}',
            color: 'b-green',
            weight: 100
          },
          deleteButton: {
            text: 'L{Delete}',
            color: 'b-gray',
            weight: 200
          },
          cancelButton: {
            text: 'L{Object.Cancel}',
            color: 'b-gray',
            weight: 300
          }
        }
      },
      width: {
        $config: {
          localeKey: 'L{editorWidth}'
        }
      }
    };
  }

  static get defaultConfig() {
    return {
      axisLock: 'flexible',
      autoClose: true,
      onChange: null,
      onCancel: null,
      onSave: null,
      autoShow: false,
      scrollAction: 'realign',

      /**
       * The decimal precision to use for Duration field / columns, normally provided by the owning Scheduler´s {@link SchedulerPro.view.SchedulerPro#config-durationDisplayPrecision}
       * @config {Number}
       */
      durationDisplayPrecision: 1,

      /**
       * Config object specifying widgets for tabs in task editor. Every tab accepts array of widgets or widget configs.
       *
       * @config {Object}
       * @deprecated 5.0.0 Use `items` instead
       */
      extraItems: null,

      /**
       * A configuration object used to configure the built-in tabs or to add custom tab(s).
       * The individual configuration objects of the tabs contained in `tabsConfig`
       * are keyed by tab names and are merged with the default built-in configurations.
       *
       * @config {Object}
       * @deprecated 5.0.0 Use `items` instead
       */
      tabsConfig: null,
      tabPanelItems: null,
      defaultTabs: null,

      /**
       * A message to be shown when Engine is performing task scheduling. Localizable text is 'L{calculateMask}'. Disabled by default.
       * @config {String|null}
       * @default
       */
      calculateMask: null,

      /**
       * A delay before the {@link #config-calculateMask mask} becomes visible. This config is needed to avoid UI blinking when calculating is relatively fast.
       * Note, the mask is applied immediately and blocks the content anyway. However if the delay is set, it will be transparent. If `null`, the mask is visible immediately.
       * @config {Number|null}
       * @default
       */
      calculateMaskDelay: 100,
      localizableProperties: ['calculateMask'],
      project: null,

      /**
       * A task field (id, wbsCode, sequenceNumber etc) that will be used when displaying and editing linked tasks. Defaults to Gantt `dependencyIdField`
       * @config {String} dependencyIdField
       */
      dependencyIdField: null
    };
  } //endregion
  //region Internal
  // This method is called for every child widget in the task editor


  processWidgetConfig(widgetConfig) {
    var _widgetConfig$type;

    if ((_widgetConfig$type = widgetConfig.type) !== null && _widgetConfig$type !== void 0 && _widgetConfig$type.includes('date') && widgetConfig.weekStartDay == null) {
      widgetConfig.weekStartDay = this.weekStartDay;
    } // Backward compatibility


    if (widgetConfig.ref === 'tabs' && this.extraItems) {
      const preparedItems = {};

      for (const key in this.extraItems) {
        // Lower-cased "tab" is not supported anymore
        const preparedKey = key.replace('tab', 'Tab');
        preparedItems[preparedKey] = {
          items: Array.isArray(this.extraItems[key]) ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].transformArrayToNamedObject(this.extraItems[key]) : this.extraItems[key]
        };
      }

      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(widgetConfig.items, preparedItems);
    }

    return widgetConfig;
  }

  changeItems(items) {
    const // NOTE: tabsConfig is deprecated
    {
      tabsConfig,
      tabPanelItems = {}
    } = this,
          // Clone to not pollute config
    clonedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(items),
          tabPanel = clonedItems.find(w => w.ref === 'tabs'); // Backward compatibility

    if (tabsConfig) {
      for (const ref in tabsConfig) {
        // Lower-cased "tab" is not supported anymore
        const preparedKey = ref.replace('tab', 'Tab');
        tabPanelItems[preparedKey] = tabsConfig[ref];
      }
    }

    this.cleanItemsConfig(tabPanelItems);
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(tabPanel.items, tabPanelItems);
    return super.changeItems(clonedItems);
  } // Remove any items configured as === true which just means default config options


  cleanItemsConfig(items) {
    for (const ref in items) {
      const itemCfg = items[ref];

      if (itemCfg === true) {
        delete items[ref];
      } else if (itemCfg !== null && itemCfg !== void 0 && itemCfg.items) {
        this.cleanItemsConfig(itemCfg.items);
      }
    }
  }

  afterConfigure() {
    var _me$bbar;

    const me = this,
          widgetMap = me.widgetMap,
          {
      tabs
    } = me.widgetMap,
          {
      cancelButton,
      deleteButton,
      saveButton
    } = ((_me$bbar = me.bbar) === null || _me$bbar === void 0 ? void 0 : _me$bbar.widgetMap) || {};
    saveButton === null || saveButton === void 0 ? void 0 : saveButton.on('click', me.onSaveClick, me);
    cancelButton === null || cancelButton === void 0 ? void 0 : cancelButton.on('click', me.onCancelClick, me);
    deleteButton === null || deleteButton === void 0 ? void 0 : deleteButton.on('click', me.onDeleteClick, me);
    Object.values(widgetMap).forEach(widget => {
      if (widget.isDurationField) {
        widget.decimalPrecision = this.durationDisplayPrecision;
      } else if (widget.ref === 'startDate' || widget.ref === 'endDate') {
        widget.project = this.project;
      } else if (widget.ref === 'predecessorsTab' || widget.ref === 'successorsTab') {
        widget.grid.durationDisplayPrecision = this.durationDisplayPrecision;
        widget.dependencyIdField = widget.dependencyIdField || me.dependencyIdField;
      }

      if (widget.isReadyStatePropagator) {
        widget.on('readystatechange', me.onReadyStateChange, me);
      }
    }); // override standard Container's method to pick the right record and make possible
    // to reflect record update on programmatically field value change
    // TODO: may be removed after merged https://github.com/bryntum/support/issues/2920

    tabs.onFieldChange = ({
      source
    }) => {
      const {
        name,
        isValid,
        value
      } = source;

      if (me.loadedRecord && name && isValid) {
        me.loadedRecord[name] = value;
      }
    };
  }

  get canSave() {
    let canSave = true; // If widget report it can't both save and cancel then there's no reason to walk through others

    Object.values(this.widgetMap).forEach(w => {
      if (w.isReadyStatePropagator) {
        canSave = canSave && w.canSave;
      }
    });
    return canSave;
  } // Close, Cancel and clicking outside all lead here


  async hide() {
    this.detachListeners('project');
    this.detachListeners('eventStore');
    this._delayedAction = null; // Let editing feature know to cancel

    this.trigger('cancel');
    return super.hide();
  } // Iterates over contained fields and disables them based on the loaded record isEditable(fielName) result


  toggleFieldsDisabled(record) {
    this.eachWidget(widget => {
      if (widget.isField && widget.name) {
        const isFieldEditable = record.isEditable(widget.name); // skip unknown fields

        if (isFieldEditable !== undefined) {
          widget.disabled = !record.isEditable(widget.name);
        }
      }
    });
  }
  /**
   * Loads a task model into the editor
   *
   * @param {SchedulerPro.model.EventModel} record
   */


  loadEvent(record, highlightChanges = false) {
    const me = this; // iterate over fields and disable them by name

    me.toggleFieldsDisabled(record);
    me.callWidgetHook('loadEvent', record, highlightChanges);
    me.detachListeners('project'); // Not using .record to not trigger containers record behaviour
    // TODO: Why not rely on that?

    me.loadedRecord = record;
    record.project.on({
      name: 'project',
      beforeCommit: 'onProjectBeforeCommit',
      dataReady: 'onProjectDataReady',
      thisObj: me
    });
    me.detachListeners('eventStore');
    record.project.eventStore.on({
      name: 'eventStore',
      remove: 'onTaskRemove',
      thisObj: me
    });
  }

  callWidgetHook(name, ...args) {
    this.eachWidget(w => {
      if (typeof w[name] === 'function') {
        w[name](...args);
      }
    });
  } //endregion
  //region Events


  onDocumentMouseDown(params) {
    const me = this,
          activeCellEditing = Object.values(me.widgetMap).some(w => w._activeCellEdit);
    let action = null;

    if (activeCellEditing) {
      const {
        event
      } = params,
            {
        saveButton,
        cancelButton,
        deleteButton
      } = me.widgetMap,
            clickedButtonEl = event.target.closest('button'); // When there is a grid in a TaskEditor tab, and cell editing of the grid is in progress,
      // and you click on one of the action buttons below (save/cancel/delete), the cell editing feature catches
      // 'globaltap' event which is fired on global 'mousedown' and finishes the editing.
      // When new data is applied to the record, a new propagation begins. The task editor adds calculating mask
      // to protect the UI. Then 'click' event is fired. At this time the buttons are hovered with
      // the calculating mask and button's handlers are never called.
      // So, if tap out happens, and cell editing is in progress, and the target is one of the action buttons,
      // need to foresee the situation when the mask can block the buttons. Though closing the cell editing
      // does not guarantee that the propagation will start and the mask will appear. Therefore we clean up
      // the flags inside the handlers.

      if (clickedButtonEl) {
        switch (clickedButtonEl) {
          case saveButton === null || saveButton === void 0 ? void 0 : saveButton.element:
            action = me.onSaveClick;
            break;

          case cancelButton === null || cancelButton === void 0 ? void 0 : cancelButton.element:
            action = me.onCancelClick;
            break;

          case deleteButton === null || deleteButton === void 0 ? void 0 : deleteButton.element:
            action = me.onDeleteClick;
            break;
        }
      }
    }

    me._delayedAction = action;
    super.onDocumentMouseDown(params);
  }

  onSaveClick() {
    const me = this;
    me._delayedAction = null;

    if (me.canSave) {
      me.trigger('save');
    } else {
      _Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__["default"].show({
        rootElement: me.rootElement,
        html: me.L('L{saveError}')
      });
    }
  }

  onCancelClick() {
    this.close();
  }

  onDeleteClick() {
    this._delayedAction = null;
    this.trigger('delete');
  }

  onPropagationRequested() {
    this.trigger('requestPropagation');
  }

  onReadyStateChange({
    source,
    canSave
  }) {
    this.requestReadyStateChange();

    if (!source.couldSaveTitle) {
      source.couldSaveTitle = source.title;
    }

    if (source.parent === this.widgetMap.tabs) {
      if (canSave) {
        source.tab.element.classList.remove('b-invalid');
        source.tab.icon = null;
        source.title = source.couldSaveTitle;
        source.couldSaveTitle = null;
      } else {
        source.tab.element.classList.add('b-invalid');
        source.tab.icon = 'b-icon-warning';
        source.title = source.couldSaveTitle;
      }
    }
  }

  onTaskRemove() {
    this.afterDelete();
  }

  onProjectBeforeCommit() {
    if (this.calculateMask) {
      this.mask({
        text: this.calculateMask,
        showDelay: this.calculateMaskDelay
      });
    }
  }

  onProjectDataReady({
    records
  }) {
    var _me$_delayedAction;

    const me = this;

    if (me.calculateMask) {
      me.unmask();
    }

    if (records.has(me.loadedRecord)) {
      me.callWidgetHook('afterProjectChange');
    }

    (_me$_delayedAction = me._delayedAction) === null || _me$_delayedAction === void 0 ? void 0 : _me$_delayedAction.call(me);
  }

  beforeSave() {
    this.callWidgetHook('beforeSave');
  }

  afterSave() {
    this.loadedRecord = undefined;
    this.callWidgetHook('afterSave');
  }

  beforeCancel() {
    this.callWidgetHook('beforeCancel');
  }

  afterCancel() {
    this.loadedRecord = undefined;
    this.callWidgetHook('afterCancel');
  }

  beforeDelete() {
    this.callWidgetHook('beforeDelete');
  }

  afterDelete() {
    this.loadedRecord = undefined;
    this.callWidgetHook('afterDelete');
  }

  onInternalKeyDown(event) {
    if (event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
      if (event.target.matches('input')) {
        // Enter might have been pressed right after field editing so we need to process the changes (Fix for #166)
        const field = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].fromElement(event.target);

        if (field !== null && field !== void 0 && field.internalOnChange) {
          field.internalOnChange();
        }
      } // this prevents field events so the new value would not be processed without above call to internalOnChange
      // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden


      event.preventDefault();
      this.onSaveClick();
    }

    super.onInternalKeyDown(event);
  } //endregion


  updateReadOnly(readOnly) {
    const {
      deleteButton,
      saveButton,
      cancelButton,
      tabs
    } = this.widgetMap,
          {
      items: childTabs
    } = tabs;
    super.updateReadOnly(readOnly);

    if (deleteButton) {
      deleteButton.hidden = readOnly;
    }

    if (saveButton) {
      saveButton.hidden = readOnly;
    }

    if (cancelButton) {
      cancelButton.hidden = readOnly;
    } // All tabs are readOnly if we are readOnly


    for (let i = 0, {
      length
    } = childTabs; i < length; i++) {
      childTabs[i].readOnly = readOnly;
    }
  }

} // Register this widget type with its Factory

TaskEditorBase.initClass();
TaskEditorBase._$name = 'TaskEditorBase';

/***/ }),

/***/ "./lib/SchedulerPro/widget/Timeline.js":
/*!*********************************************!*\
  !*** ./lib/SchedulerPro/widget/Timeline.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Timeline; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony import */ var _Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Scheduler/feature/TimeRanges.js */ "./lib/Scheduler/feature/TimeRanges.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _lib_Engine_quark_model_scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js */ "./lib/Engine/quark/model/scheduler_pro/SchedulerProProjectMixin.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/widget/Timeline
 */

/**
 * A visual component showing an overview timeline of events having the {@link SchedulerPro.model.EventModel#field-showInTimeline showInTimeline}
 * field set to true. The timeline component subclasses the {@link Scheduler.view.Scheduler Scheduler} and to use it,
 * simply provide it with a {@link SchedulerPro.model.ProjectModel}:
 *
 * ```javascript
 * const timeline = new Timeline({
 *     appendTo  : 'container',
 *     project   : project
 * });
 * ```
 *
 *
 * {@inlineexample SchedulerPro/widget/Timeline.js}
 *
 * @extends Scheduler/view/Scheduler
 * @classType timeline
 */

class Timeline extends _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'Timeline';
  } // Factoryable type name


  static get type() {
    return 'timeline';
  }

  static get defaultConfig() {
    return {
      /**
       * Project config object or a Project instance
       *
       * @config {SchedulerPro.model.ProjectModel|Object} project
       */
      height: '13em',
      eventLayout: 'pack',
      barMargin: 1,
      // We need timeline width to be exact, because with `overflow: visible` content will look awful.
      // Flow is like this:
      // 1. zoomToFit is trying to set timespan to eventStore total time span. Assume start in on tuesday and end is on friday
      // 2. zooming mixin is calculating tick width, which is e.g. 37px to fit all the ticks to the available space
      // 3. timeAxis is configured with this new time span. By default it adjusts start and end to monday.
      // 4. since timespan was increased, it now overflows with original tick size of 37. It requires smth smaller, like 34.
      // 5. timeAxisViewModel is calculating fitting size. Which is correct value of 34, but value is ignored unless `forceFit` is true
      // But apparently forceFit + zoomToSpan IS NOT SUPPORTED. So alternative approach is to disable autoAdjust
      // on time axis to prevent increased size in #3. But then time axis start/end won't be even date, it could be
      // smth random like `Thu Feb 07 2019 22:13:20`.
      //
      // On the other hand, without force-fit content might overflow and timeline is styled to show overflowing content.
      // And that would require more additional configs
      forceFit: true,
      timeAxis: {
        autoAdjust: false
      },
      readOnly: true,
      zoomOnMouseWheel: false,
      zoomOnTimeAxisDoubleClick: false,
      eventColor: null,
      eventStyle: null,
      rowHeight: 48,
      displayDateFormat: 'L',
      // Despite the fact Timeline extends SchedulerBase, we still need to disable all those features.
      // Because in case timeline gets into the same scope as scheduler or gantt, some features might be enabled
      // by default. SchedulerBase jut means that we don't import anything extra. But other components might.
      features: {
        cellEdit: false,
        cellMenu: false,
        columnAutoWidth: false,
        columnLines: false,
        columnPicker: false,
        columnReorder: false,
        columnResize: false,
        contextMenu: false,
        eventContextMenu: false,
        eventDrag: false,
        eventDragCreate: false,
        eventEdit: false,
        eventFilter: false,
        eventMenu: false,
        eventResize: false,
        eventTooltip: false,
        group: false,
        headerMenu: false,
        regionResize: false,
        scheduleContextMenu: false,
        scheduleMenu: false,
        scheduleTooltip: false,
        sort: false,
        timeAxisHeaderMenu: false,
        timeRanges: {
          showCurrentTimeLine: true
        }
      },
      // A fake resource
      resources: [{
        id: 1
      }],
      columns: []
    };
  }

  static get delayable() {
    return {
      fillFromTaskStore: 100
    };
  }

  construct(config) {
    const me = this;
    me.startDateLabel = document.createElement('label');
    me.startDateLabel.className = 'b-timeline-startdate';
    me.endDateLabel = document.createElement('label');
    me.endDateLabel.className = 'b-timeline-enddate';
    let initialCommitPerformed = true;

    if ('project' in config) {
      if (!config.project) {
        throw new Error('You need to configure the Timeline with a Project');
      } // In case instance of project is provided, just take store right away and delete config, falling back to
      // default
      else if (config.project instanceof _lib_Engine_quark_model_scheduler_pro_SchedulerProProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__["SchedulerProProjectMixin"]) {
        me.taskStore = config.project.eventStore;

        if (!config.project.isInitialCommitPerformed) {
          initialCommitPerformed = false; // For schedulerpro it is important to listen to first project commit

          config.project.on({
            refresh({
              isInitialCommit
            }) {
              if (isInitialCommit) {
                this.fillFromTaskStore();
              }
            },

            once: true,
            thisObj: this
          });
        }

        delete config.project;
      }
    }

    super.construct(config);

    if (me.features.timeRanges) {
      // We don't want to show timeRanges relating to Project
      me.features.timeRanges.store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_3__["default"]();
    } // If original project is not committed by this time, we should not try to fill timeline from the task store,
    // because project listener will do it itself. And also to not do extra suspendRefresh which would break project
    // refresh event listener behavior.
    // https://github.com/bryntum/support/issues/2665


    initialCommitPerformed && me.fillFromTaskStore.now();
    me.taskStore.on({
      refreshPreCommit: me.fillFromTaskStore,
      changePreCommit: me.onTaskStoreChange,
      thisObj: me
    });
    me.on({
      resize: me.onSizeChanged,
      thisObj: me
    });
    me.bodyContainer.appendChild(me.startDateLabel);
    me.bodyContainer.appendChild(me.endDateLabel);
  }

  onSizeChanged({
    width,
    oldWidth
  }) {
    this.suspendRefresh();
    this.updateRowHeight();
    this.resumeRefresh();

    if (width !== oldWidth) {
      this.fitTimeline();
    }
  }

  updateRowHeight() {
    if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isOrphaned(this.bodyContainer)) {
      this.rowHeight = this.bodyContainer.offsetHeight;
    }
  }

  fitTimeline() {
    if (this.eventStore.count > 0) {
      this.zoomToFit({
        leftMargin: 50,
        rightMargin: 50
      });
    }

    this.updateStartEndLabels();
  }

  updateStartEndLabels() {
    const me = this;
    me.startDateLabel.innerHTML = me.getFormattedDate(me.startDate);
    me.endDateLabel.innerHTML = me.getFormattedDate(me.endDate);
  }

  async onTaskStoreChange({
    action,
    record,
    records,
    changes,
    isCollapse
  }) {
    const me = this,
          eventStore = me.eventStore;
    let needsFit;

    switch (action) {
      case 'add':
        records.forEach(task => {
          if (task.showInTimeline) {
            eventStore.add(me.cloneTask(task));
            needsFit = true;
          }
        });
        break;

      case 'remove':
        if (!isCollapse) {
          records.forEach(task => {
            if (task.showInTimeline) {
              eventStore.remove(task.id);
              needsFit = true;
            }
          });
        }

        break;

      case 'removeall':
        me.fillFromTaskStore();
        break;

      case 'update':
        {
          const task = record;

          if (changes.showInTimeline) {
            // Add or remove from our eventStore
            if (task.showInTimeline) {
              eventStore.add(me.cloneTask(task));
            } else {
              eventStore.remove(eventStore.getById(task.id));
            }

            needsFit = true;
          } else if (task.showInTimeline) {
            // Just sync with existing clone
            const clone = eventStore.getById(task.id);

            if (clone) {
              const filteredData = Object.assign({}, task.data); // Not allowed to set 'expanded' flat

              delete filteredData.expanded; // When duration is provided project will try to calculate end date from it. We don't need that
              // because timeline project doesn't have any calendars. We just trust start/end from task.

              delete filteredData.duration;
              delete filteredData.durationUnit; // delete calendar instance

              delete filteredData.calendar;
              clone.set(filteredData);
              needsFit = true;
            }
          }

          break;
        }
    }

    if (needsFit) {
      me.fitTimeline();
    }
  }

  cloneTask(task) {
    return {
      id: task.id,
      resourceId: 1,
      name: task.name,
      startDate: task.startDate,
      endDate: task.endDate,
      cls: task.cls
    };
  }

  render() {
    super.render(...arguments);
    this.updateRowHeight();
  }

  async fillFromTaskStore() {
    const me = this,
          timelineTasks = [];
    me.taskStore.traverse(task => {
      if (task.showInTimeline && task.isScheduled) {
        timelineTasks.push(me.cloneTask(task));
      }
    });
    me.suspendRefresh();
    me.events = timelineTasks;
    await me.project.commitAsync();
    if (me.isDestroyed) return;
    me.resumeRefresh(true);
    me.fitTimeline();
  }

  onLocaleChange() {
    this.updateStartEndLabels();
    super.onLocaleChange();
  }

}
; // Register this widget type with its Factory

Timeline.initClass();
Timeline._$name = 'Timeline';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/AdvancedTab.js":
/*!***********************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/AdvancedTab.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AdvancedTab; });
/* harmony import */ var _FormTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony import */ var _CalendarField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CalendarField.js */ "./lib/SchedulerPro/widget/CalendarField.js");
/* harmony import */ var _ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ConstraintTypePicker.js */ "./lib/SchedulerPro/widget/ConstraintTypePicker.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SchedulingModePicker.js */ "./lib/SchedulerPro/widget/SchedulingModePicker.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/widget/taskeditor/AdvancedTab
 */

/**
 * Advanced task options {@link SchedulerPro/widget/SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro/widget/GanttTaskEditor gantt task editor} tab.
 *
 * | Field ref                | Type                                             | Weight | Description                                                                                                                  |
 * |--------------------------|--------------------------------------------------|--------|------------------------------------------------------------------------------------------------------------------------------|
 * | `calendarField`          | {@link Core/widget/Combo}                        | 100    | Shows a list of available calendars for this task                                                                            |
 * | `manuallyScheduledField` | {@link Core/widget/Checkbox}                     | 200    | If checked, the task is not considered in scheduling                                                                         |
 * | `schedulingModeField`    | {@link SchedulerPro/widget/SchedulingModePicker} | 300    | Shows a list of available scheduling modes for this task                                                                     |
 * | `effortDrivenField`      | {@link Core/widget/Checkbox}                     | 400    | If checked, the effort of the task is kept intact, and the duration is updated. Works when scheduling mode is "Fixed Units". |
 * | `divider`                | {@link Core/widget/Widget}                       | 500    | Visual splitter between 2 groups of fields                                                                                   |
 * | `constraintTypeField`    | {@link SchedulerPro/widget/ConstraintTypePicker} | 600    | Shows a list of available constraints for this task                                                                          |
 * | `constraintDateField`    | {@link Core/widget/DateField}                    | 700    | Shows a date for the selected constraint type                                                                                |
 * | `rollupField`            | {@link Core/widget/Checkbox}                     | 800    | If checked, shows a bar below the parent task. Works when the "Rollup" feature is enabled.                                   |
 * | `inactiveField`          | {@link Core/widget/Checkbox}                     | 900    | Allows to inactivate the task so it won;t take part in the scheduling process.                                               |
 *
 * @extends SchedulerPro/widget/taskeditor/FormTab
 * @classtype advancedtab
 */

class AdvancedTab extends _FormTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AdvancedTab';
  } // Factoryable type name


  static get type() {
    return 'advancedtab';
  }

  static get defaultConfig() {
    return {
      localeClass: this,
      title: 'L{Advanced}',
      cls: 'b-advanced-tab',
      defaults: {
        localeClass: this
      },
      items: {
        calendarField: {
          type: 'calendarfield',
          weight: 100,
          ref: '',
          name: 'calendar',
          label: 'L{Calendar}',
          flex: '1 0 50%',
          cls: 'b-inline'
        },
        manuallyScheduledField: {
          type: 'checkbox',
          weight: 200,
          name: 'manuallyScheduled',
          label: 'L{Manually scheduled}',
          flex: '1 0 50%'
        },
        schedulingModeField: {
          type: 'schedulingmodecombo',
          weight: 300,
          name: 'schedulingMode',
          label: 'L{Scheduling mode}',
          flex: '1 0 50%',
          cls: 'b-inline'
        },
        effortDrivenField: {
          type: 'checkbox',
          weight: 400,
          name: 'effortDriven',
          label: 'L{Effort driven}',
          flex: '1 0 50%'
        },
        divider: {
          weight: 500,
          html: '',
          dataset: {
            text: this.L('L{Constraint}')
          },
          cls: 'b-divider',
          flex: '1 0 100%'
        },
        constraintTypeField: {
          type: 'constrainttypepicker',
          weight: 600,
          name: 'constraintType',
          label: 'L{Constraint type}',
          pickerWidth: '14em',
          clearable: true,
          flex: '1 0 50%',
          cls: 'b-inline'
        },
        constraintDateField: {
          type: 'date',
          weight: 700,
          name: 'constraintDate',
          label: 'L{Constraint date}',
          flex: '1 0 50%',
          cls: 'b-inline'
        },
        rollupField: {
          type: 'checkbox',
          weight: 800,
          name: 'rollup',
          label: 'L{Rollup}',
          flex: '1 0 50%',
          cls: 'b-inline'
        },
        inactiveField: {
          type: 'checkbox',
          weight: 900,
          name: 'inactive',
          label: 'L{Inactive}',
          flex: '1 0 50%',
          cls: 'b-inline'
        }
      }
    };
  }

  get calendarField() {
    return this.widgetMap.calendarField;
  }

  get constraintTypeField() {
    return this.widgetMap.constraintTypeField;
  }

  get constraintDateField() {
    return this.widgetMap.constraintDateField;
  }

  get effortDrivenField() {
    return this.widgetMap.effortDrivenField;
  }

  get manuallyScheduledField() {
    return this.widgetMap.manuallyScheduledField;
  }

  get rollupField() {
    return this.widgetMap.rollupField;
  }

  get schedulingModeField() {
    return this.widgetMap.schedulingModeField;
  }

  loadEvent(eventRecord) {
    const me = this,
          firstLoad = !me.record;
    const {
      calendarField,
      constraintTypeField
    } = me;

    if (calendarField && firstLoad) {
      calendarField.store = eventRecord.project.calendarManagerStore;
    }

    if (constraintTypeField !== null && constraintTypeField !== void 0 && constraintTypeField.isConstraintTypePicker) {
      const {
        store: typesStore
      } = constraintTypeField;
      typesStore.removeFilter('constraintTypeApplicable');
      typesStore.filter({
        // Dodge pre-commit hook by quoting property
        'id': 'constraintTypeApplicable',
        // eslint-disable-line quote-props
        filterBy: r => eventRecord.run('isConstraintTypeApplicable', r.id)
      });
    }

    super.loadEvent(eventRecord);
  }

  afterDelete() {
    const {
      constraintTypeField
    } = this; // remove the constraint type combo store filter
    // otherwise eventRecord.run(...) will cause an exception since the record is no longer in the graph

    if (constraintTypeField !== null && constraintTypeField !== void 0 && constraintTypeField.isConstraintTypePicker) {
      constraintTypeField.store.removeFilter('constraintTypeApplicable');
    }

    super.afterDelete(...arguments);
  }

} // Register this widget type with its Factory

AdvancedTab.initClass();
AdvancedTab._$name = 'AdvancedTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/DependencyTab.js":
/*!*************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/DependencyTab.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyTab; });
/* harmony import */ var _EditorTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./EditorTab.js */ "./lib/SchedulerPro/widget/taskeditor/EditorTab.js");
/* harmony import */ var _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _DependencyTypePicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../DependencyTypePicker.js */ "./lib/SchedulerPro/widget/DependencyTypePicker.js");
/* harmony import */ var _column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../column/DurationColumn.js */ "./lib/SchedulerPro/column/DurationColumn.js");
/* harmony import */ var _ModelCombo_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ModelCombo.js */ "./lib/SchedulerPro/widget/ModelCombo.js");
/* harmony import */ var _Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Grid/view/Grid.js */ "./lib/Grid/view/Grid.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/widget/taskeditor/DependencyTab
 */

const markDependencyValid = (dep, grid) => {
  dep.instanceMeta(grid).valid = true;
},
      markDependencyInvalid = (dep, grid) => {
  dep.instanceMeta(grid).valid = false;
},
      isDependencyMarkedValid = (dep, grid) => dep.instanceMeta(grid).valid !== false;
/**
 * Abstract base class for SuccessorsTab and PredecessorsTab.
 *
 * @extends SchedulerPro/widget/taskeditor/EditorTab
 * @abstract
 */


class DependencyTab extends _EditorTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'DependencyTab';
  }

  static get type() {
    return 'dependencytab';
  }

  static get configurable() {
    return {
      /**
       * A task field (`id`, `wbsCode`, `sequenceNumber` etc) that will be used when displaying and editing linked
       * tasks. Defaults to Gantt `dependencyIdField`.
       * @config {String} dependencyIdField
       */
      dependencyIdField: null,
      layoutStyle: {
        flexFlow: 'column nowrap'
      },
      // Documented in subclasses
      sortField: null,

      /**
       * A task field (`id`, `wbsCode`, `sequenceNumber` etc) to sort tasks in the task combo by
       * @config {String}
       * @default
       */
      taskComboSortField: 'name',
      items: {
        grid: {
          type: 'grid',
          weight: 100,
          flex: '1 1 auto',
          emptyText: '',
          asyncEventSuffix: 'PreCommit',
          disableGridRowModelWarning: true,
          features: {
            group: false
          },
          columns: {
            data: {
              id: {
                localeClass: this,
                text: 'L{ID}',
                flex: 1,
                editor: false,
                htmlEncode: false,
                hidden: true,

                sortable(dependency1, dependency2) {
                  var _dependency1$directio, _dependency2$directio;

                  const {
                    dependencyIdField,
                    direction
                  } = this.grid.parent,
                        id1 = (_dependency1$directio = dependency1[direction]) === null || _dependency1$directio === void 0 ? void 0 : _dependency1$directio[dependencyIdField],
                        id2 = (_dependency2$directio = dependency2[direction]) === null || _dependency2$directio === void 0 ? void 0 : _dependency2$directio[dependencyIdField];

                  if (id1 === id2) {
                    return 0;
                  }

                  return id1 < id2 ? -1 : 1;
                },

                renderer: ({
                  record: dependency,
                  row,
                  grid,
                  column
                }) => {
                  let html;
                  const {
                    direction
                  } = grid.parent,
                        linkedEvent = dependency[direction];

                  if (linkedEvent && isDependencyMarkedValid(dependency, grid)) {
                    const idField = grid.parent.dependencyIdField,
                          id = linkedEvent[idField];

                    if (idField === 'id') {
                      html = !linkedEvent || linkedEvent.hasGeneratedId ? '*' : linkedEvent.id;
                    } else {
                      html = id;
                    }
                  } else {
                    row.addCls('b-invalid');
                    html = '<div class="b-icon b-icon-warning"></div>';
                  }

                  return html;
                }
              },
              name: {
                localeClass: this,
                text: 'L{Name}',
                flex: 5,
                renderer: ({
                  value: event,
                  grid,
                  cellElement
                }) => {
                  if (event) {
                    // indicate inactive tasks
                    cellElement.classList.toggle('b-inactive', event.inactive);
                    const id = event[grid.parent.dependencyIdField];
                    return event.name + (id != null && !event.hasGeneratedId ? ` (${id})` : '');
                  }

                  return '';
                },
                finalizeCellEdit: 'up.finalizeLinkedTaskCellEdit',
                editor: {
                  type: 'modelcombo',
                  displayField: 'name',
                  valueField: 'id',
                  filterOperator: '*',
                  allowInvalid: true,

                  listItemTpl(event) {
                    if (!this._dependencyTab) {
                      this._dependencyTab = this.up('dependencytab', true);
                    }

                    let id = event[this._dependencyTab.dependencyIdField];
                    id = id != null && !event.hasGeneratedId ? `(${id})` : '';
                    return `${event.name} ${id}`;
                  }

                }
              },
              type: {
                localeClass: this,
                text: 'L{Type}',
                field: 'type',
                flex: 3,
                sortable: false,
                editor: 'dependencytypepicker',

                renderer({
                  value
                }) {
                  return this.L('L{DependencyType.long}')[value];
                }

              },
              lag: {
                localeClass: this,
                text: 'L{Lag}',
                type: 'duration',
                field: 'fullLag',
                flex: 2,
                editor: {
                  allowNegative: true
                }
              }
            }
          }
        },
        toolbar: {
          type: 'toolbar',
          dock: 'bottom',
          cls: 'b-compact-bbar',
          items: {
            add: {
              type: 'button',
              weight: 210,
              cls: 'b-add-button b-green',
              icon: 'b-icon b-icon-add',
              onAction: 'up.onAddClick'
            },
            remove: {
              type: 'button',
              weight: 220,
              cls: 'b-remove-button b-red',
              icon: 'b-icon b-icon-trash',
              disabled: true,
              onAction: 'up.onRemoveClick'
            }
          }
        }
      }
    };
  } //endregion
  // Triggered before applying cell editing result to the dependency


  async finalizeLinkedTaskCellEdit({
    grid,
    value: linkedTask,
    record: dependency
  }) {
    const {
      project
    } = grid.store.masterStore,
          isSuccessor = this.direction === 'toEvent',
          source = isSuccessor ? dependency.fromEvent : linkedTask,
          target = isSuccessor ? linkedTask : dependency.toEvent,
          validationResult = await project.validateDependency(source, target, dependency.type, dependency);

    switch (validationResult) {
      // no error
      case 0:
        return true;
      // cycle

      case 1:
        return 'L{DependencyTab.cyclicDependency}';
    }

    return 'L{DependencyTab.invalidDependency}';
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this,
          grid = me.grid = me.widgetMap.grid;
    grid.on({
      selectionChange: 'onGridSelectionChange',
      startCellEdit: 'onGridStartCellEdit',
      finishCellEdit: 'onGridFinishCellEdit',
      cancelCellEdit: 'onGridCancelCellEdit',
      thisObj: me
    });
  }

  updateReadOnly(readOnly) {
    const {
      add,
      remove
    } = this.widgetMap;
    super.updateReadOnly(...arguments); // Buttons hide when we are readOnly

    add.hidden = remove.hidden = readOnly;
  }

  get taskCombo() {
    const {
      grid
    } = this,
          from = grid === null || grid === void 0 ? void 0 : grid.columns.get(this.direction);
    return from === null || from === void 0 ? void 0 : from.editor;
  }

  loadEvent(eventRecord) {
    const me = this,
          {
      grid
    } = me,
          firstLoad = !grid.store.isChained,
          recordChange = !firstLoad && eventRecord !== me.record;
    super.loadEvent(eventRecord);
    const taskCombo = me.taskCombo,
          {
      dependencyStore,
      eventStore
    } = me.project; // On first load, populate the chained stores.
    // Our grid store will contain only the direction of dependencies
    // this tab is interested in.
    // Our taskCombo only contains all events other than our event.
    // An event can't depend upon itself.

    if (firstLoad) {
      // Cache the mutation generation of the underlying data collection
      // so that we know when we need to refill the chained stores.
      me.depStoreGeneration = dependencyStore.storage.generation;
      me.eventStoreGeneration = eventStore.storage.generation;
      grid.store = dependencyStore.makeChained(d => d[me.negDirection] === me.record, null);
      taskCombo.store = eventStore.makeChained( // Remove original record from chained store, but keep those records that are already selected in the dependency grid
      e => e !== me.record, null, {
        doRelayToMaster: [],
        // Need to show all records in the combo
        excludeCollapsedRecords: false
      });
      taskCombo.store.sort(me.taskComboSortField); // Post process chained store and exclude records that are already selected in the dependency grid.
      // It's needed to be a separate filtering because otherwise when cell editor opens combo and sets initial value,
      // it cannot find it in the storage and adds new record.

      taskCombo.store.filterBy(e => !grid.store.find(d => {
        const dep = d[me.direction],
              activeEdit = me._activeCellEdit,
              isDepEditing = activeEdit && dep === activeEdit.record[me.direction]; // checking !isDepEditing will keep as combo option the current record

        return dep === e && !isDepEditing;
      }));
      taskCombo.on({
        thisObj: me,
        change: 'onGridCellEditChange'
      });
    } else {
      // Only repopulate the chained stores if the master stores have changed
      // or if this is being loaded with a different record.
      if (recordChange || dependencyStore.storage.generation !== me.depStoreGeneration) {
        grid.store.fillFromMaster();
        me.depStoreGeneration = dependencyStore.storage.generation;
      } // If not changed, the details within the store may have changed
      // (for example undo on edit cancel), so refresh the grid.
      else {
        grid.refreshRows();
      }

      if (recordChange || eventStore.storage.generation !== me.eventStoreGeneration) {
        taskCombo.store.fillFromMaster();
        me.eventStoreGeneration = eventStore.storage.generation;
      }
    }

    if (recordChange) {
      me.grid.store.sort(me.sortField);
    }

    me.requestReadyStateChange();
  }

  async insertNewDependency() {
    const me = this,
          {
      grid
    } = me,
          depStore = grid.store,
          projectDepStore = me.project.dependencyStore; // This call will be relayed to project dependency store.

    const [newDep] = depStore.insert(0, {
      type: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__["DependencyType"].EndToStart,
      lag: 0,
      lagUnit: _Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__["TimeUnit"].Day,
      [me.negDirection]: me.record
    }); // Reset the dependency store mutation monitor when we add a dependency

    me.depStoreGeneration = projectDepStore.storage.generation;
    grid.features.cellEdit.startEditing({
      field: me.direction,
      id: newDep.id
    });
    markDependencyInvalid(newDep, grid);
    return newDep;
  }

  onAddClick() {
    this.insertNewDependency();
  }

  onRemoveClick() {
    const me = this,
          grid = me.grid,
          toRemove = grid.selectedRecords;
    me.project.dependencyStore.remove(toRemove);
    grid.selectedRecord = grid.store.getNext(toRemove[0]);
    me.taskCombo.store.fillFromMaster();
  }

  onGridSelectionChange({
    selection
  }) {
    const removeButton = this.widgetMap.remove;

    if (selection !== null && selection !== void 0 && selection.length && !this.up(w => w.readOnly)) {
      removeButton.enable();
    } else {
      removeButton.disable();
    }
  }

  clearActiveEditorErrors() {
    const me = this,
          activeCellEdit = me._activeCellEdit;

    if (activeCellEdit && activeCellEdit.column.field === me.direction) {
      activeCellEdit.editor.inputField.clearError(); // clears all errors
    }
  }

  onGridCellEditChange() {
    // Since we deposit some errors on the editor during startEdit (see onGridStartCellEdit), we must also clear
    // them eventually or the editor will refuse to accept any value. Since validation will still take place, we
    // don't need to worry about preventing the editor from dismissing nor could we realistically since validation
    // is async (see onGridFinishCellEdit).
    this.clearActiveEditorErrors();
  }

  onGridStartCellEdit({
    editorContext
  }) {
    const me = this,
          dep = me._editingDependency = editorContext.record,
          {
      grid
    } = me,
          dir = me.direction;
    me._activeCellEdit = editorContext;

    if (editorContext.column.field === dir) {
      if (!isDependencyMarkedValid(dep, grid)) {
        if (!dep[dir]) {
          editorContext.editor.inputField.setError('L{DependencyTab.invalidDependency}');
        } else {
          editorContext.editor.inputField.setError('L{DependencyTab.cyclicDependency}');
        }
      } else {
        me.clearActiveEditorErrors();
      } //dep.shadow();

    }
  }

  async onGridFinishCellEdit({
    editorContext
  }) {
    const me = this,
          {
      record: dependency,
      column
    } = editorContext,
          {
      grid,
      direction
    } = me; // Other dependency end

    if (column.field === direction) {
      markDependencyValid(dependency, grid);
      me.taskCombo.store.fillFromMaster();
    } // Type and Lag
    else {
      me.redrawDependencyRow(dependency);
    }

    me._activeCellEdit = me._editingDependency = null;
    me.requestReadyStateChange();
  }

  afterCancel() {
    // After task editor is closed by clicking "Cancel"
    // let's cancel cell editing if it's in progress (could happen if cell editor has a validation error)
    if (this._activeCellEdit) {
      this.grid.features.cellEdit.cancelEditing(true);
    }
  }

  onGridCancelCellEdit(data) {
    const me = this,
          dependency = me._editingDependency;

    if (dependency) {
      if (!dependency[me.direction]) {
        markDependencyInvalid(dependency, me.grid);
        me.redrawDependencyRow(dependency);
      }

      me._activeCellEdit = me._editingDependency = null;
    }

    me.requestReadyStateChange();
  }

  redrawDependencyRow(dependency) {
    // TODO: Redraw dependency directly instead of row
    const {
      grid
    } = this,
          row = grid.rowManager.getRowById(dependency); // Might be out of view

    if (row) {
      const recordIndex = grid.store.indexOf(dependency); // the record could no longer be in the store if we click remove button while cell editing is in progress

      if (recordIndex >= 0) {
        row.render(grid.store.indexOf(dependency), dependency);
      }
    }
  }

  get canSave() {
    const {
      grid
    } = this;
    return grid.store.reduce((r, d) => r && isDependencyMarkedValid(d, grid), true);
  }

}
DependencyTab._$name = 'DependencyTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/EditorTab.js":
/*!*********************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/EditorTab.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EditorTab; });
/* harmony import */ var _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _mixin_EventLoader_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/EventLoader.js */ "./lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js");
/* harmony import */ var _mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ReadyStatePropagator.js */ "./lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js");
var productName = 'gantt';



/**
 * @module SchedulerPro/widget/taskeditor/EditorTab
 */

/**
 * Base class for tabs that **do not contain fields** (non-form tabs) in {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor}, such as Successors, Predecessors or Resources.
 *
 * @extends Core/widget/Container
 * @mixes SchedulerPro/widget/taskeditor/mixin/EventLoader
 */

class EditorTab extends _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_EventLoader_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'EditorTab';
  }

  static get type() {
    return 'editortab';
  }

  static get configurable() {
    return {
      title: null
    };
  }

}
EditorTab._$name = 'EditorTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/FormTab.js":
/*!*******************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/FormTab.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FormTab; });
/* harmony import */ var _EditorTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./EditorTab.js */ "./lib/SchedulerPro/widget/taskeditor/EditorTab.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/taskeditor/FormTab
 */

/**
 * Base class for tabs that **contain fields** (form-like tabs) in {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor}, such as General or Notes.
 *
 * @extends SchedulerPro/widget/taskeditor/EditorTab
 */

class FormTab extends _EditorTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FormTab';
  }

  static get type() {
    return 'formtab';
  }

  static get defaultConfig() {
    return {
      layoutStyle: {
        flexFlow: 'row wrap',
        alignItems: 'flex-start',
        alignContent: 'flex-start'
      },
      autoUpdateRecord: true
    };
  } // onWidgetValueChange({ source, value, valid, userAction }) {
  //     const
  //         me                  = this,
  //         { project, record } = me,
  //         { name }            = source;
  //
  //     valid = valid !== undefined ? valid : (typeof source.isValid === 'function') ? source.isValid() : source.isValid;
  //
  //     if (!me._loading && valid && project/* && !project.isPropagating()*/ && userAction) {
  //         if (name in record) {
  //             record[name] = value;
  //         }
  //         else if (record.$[name]) {
  //             debugger;
  //             record.$[name].put(value);
  //         }
  //     }
  // }


  onFieldChange({
    source,
    valid,
    userAction
  }) {
    if (userAction) {
      valid = valid !== undefined ? valid : typeof source.isValid === 'function' ? source.isValid() : source.isValid;

      if (valid) {
        super.onFieldChange(...arguments);
      }
    }
  }

}
FormTab.initClass();
FormTab._$name = 'FormTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/GeneralTab.js":
/*!**********************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/GeneralTab.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GeneralTab; });
/* harmony import */ var _FormTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony import */ var _widget_StartDateField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/StartDateField.js */ "./lib/SchedulerPro/widget/StartDateField.js");
/* harmony import */ var _widget_EndDateField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../widget/EndDateField.js */ "./lib/SchedulerPro/widget/EndDateField.js");
/* harmony import */ var _widget_EffortField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../widget/EffortField.js */ "./lib/SchedulerPro/widget/EffortField.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
var productName = 'gantt';





/**
 * @module SchedulerPro/widget/taskeditor/GeneralTab
 */

/**
 * A tab inside the {@link SchedulerPro/widget/SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro/widget/GanttTaskEditor gantt task editor} showing the general information for a task.
 *
 * | Field ref     | Type                                       | Text       | Weight | Description                                                        |
 * |---------------|--------------------------------------------|------------|--------|--------------------------------------------------------------------|
 * | `name`        | {@link Core/widget/TextField}              | Name       | 100    | Task name                                                          |
 * | `percentDone` | {@link Core/widget/NumberField}            | % Complete | 200    | Shows what part of task is done already in percentage              |
 * | `effort`      | {@link SchedulerPro/widget/EffortField}    | Effort     | 300    | Shows how much working time is required to complete the whole task |
 * | `divider`     | {@link Core/widget/Widget}                 |            | 400    | Visual splitter between 2 groups of fields                         |
 * | `startDate`   | {@link SchedulerPro/widget/StartDateField} | Start      | 500    | Shows when the task begins                                         |
 * | `endDate`     | {@link SchedulerPro/widget/EndDateField}   | Finish     | 600    | Shows when the task ends                                           |
 * | `duration`    | {@link Core/widget/DurationField}          | Duration   | 700    | Shows how long the task is                                         |
 *
 * @extends SchedulerPro/widget/taskeditor/FormTab
 * @classtype generaltab
 */

class GeneralTab extends _FormTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'GeneralTab';
  } // Factoryable type name


  static get type() {
    return 'generaltab';
  }

  static get defaultConfig() {
    return {
      title: 'L{General}',
      cls: 'b-general-tab',
      defaults: {
        localeClass: this
      },
      items: {
        name: {
          type: 'text',
          weight: 100,
          required: true,
          label: 'L{Name}',
          clearable: true,
          name: 'name',
          cls: 'b-name'
        },
        percentDone: {
          type: 'number',
          weight: 200,
          label: 'L{% complete}',
          name: 'renderedPercentDone',
          cls: 'b-percent-done b-inline',
          flex: '1 0 50%',
          min: 0,
          max: 100
        },
        effort: {
          type: 'effort',
          weight: 300,
          label: 'L{Effort}',
          name: 'fullEffort',
          flex: '1 0 50%'
        },
        divider: {
          html: '',
          weight: 400,
          dataset: {
            text: this.L('L{Dates}')
          },
          cls: 'b-divider',
          flex: '1 0 100%'
        },
        startDate: {
          type: 'startdate',
          weight: 500,
          label: 'L{Start}',
          name: 'startDate',
          cls: 'b-start-date b-inline',
          flex: '1 0 50%'
        },
        endDate: {
          type: 'enddate',
          weight: 600,
          label: 'L{Finish}',
          name: 'endDate',
          cls: 'b-end-date',
          flex: '1 0 50%'
        },
        duration: {
          type: 'durationfield',
          weight: 700,
          label: 'L{Duration}',
          name: 'fullDuration',
          flex: '.5 0',
          cls: 'b-inline'
        }
      }
    };
  }

  loadEvent(record) {
    const step = {
      unit: record.durationUnit,
      magnitude: 1
    },
          {
      startDate,
      endDate,
      effort
    } = this.widgetMap;

    if (startDate) {
      startDate.step = step;
      startDate.eventRecord = record;
    }

    if (endDate) {
      endDate.step = step;
      endDate.eventRecord = record;
    }

    if (effort) {
      effort.unit = record.effortUnit;
    }

    super.loadEvent(record);
  }

} // Register this widget type with its Factory

GeneralTab.initClass();
GeneralTab._$name = 'GeneralTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/NotesTab.js":
/*!********************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/NotesTab.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NotesTab; });
/* harmony import */ var _FormTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony import */ var _Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
var productName = 'gantt';


/**
 * @module SchedulerPro/widget/taskeditor/NotesTab
 */

/**
 * A tab inside the {@link SchedulerPro/widget/SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro/widget/GanttTaskEditor gantt task editor} showing the notes for an event or task.
 *
 * | Field ref   | Type                              | Weight | Description                                     |
 * |-------------|-----------------------------------|--------|-------------------------------------------------|
 * | `noteField` | {@link Core/widget/TextAreaField} | 100    | Shows a text area to add text notes to the task |
 *
 * @extends SchedulerPro/widget/taskeditor/FormTab
 * @classtype notestab
 */

class NotesTab extends _FormTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NotesTab';
  } // Factoryable type name


  static get type() {
    return 'notestab';
  }

  static get configurable() {
    return {
      cls: 'b-notes-tab',
      title: this.L('L{Notes}'),
      tab: {
        icon: 'b-icon-note',
        titleProperty: 'tooltip'
      },
      layoutConfig: {
        alignItems: 'flex-start',
        alignContent: 'stretch'
      },
      items: {
        noteField: {
          weight: 100,
          type: 'textareafield',
          cls: 'b-taskeditor-notes-field',
          name: 'note'
        }
      }
    };
  }

} // Register this widget type with its Factory

NotesTab.initClass();
NotesTab._$name = 'NotesTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js":
/*!***************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PredecessorsTab; });
/* harmony import */ var _DependencyTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DependencyTab.js */ "./lib/SchedulerPro/widget/taskeditor/DependencyTab.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/taskeditor/PredecessorsTab
 */

/**
 * A tab inside the {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor} showing the predecessors of an event or task.
 *
 * The tab has the following contents by default:
 *
 * | Widget ref  | Type                                | Weight | Description                                       |
 * |-------------|-------------------------------------|--------|---------------------------------------------------|
 * | `grid`      | {@link Grid.view.Grid Grid}         | 100    | Shows predecessors  name, dependency type and lag |
 * | \> `id`*    | {@link Grid.column.Column Column}   | -      | Id column                                         |
 * | \> `name`*  | {@link Grid.column.Column Column}   | -      | Name column, linked task                          |
 * | \> `type`*  | {@link Grid.column.Column Column}   | -      | Dependency type column                            |
 * | \> `lag`*   | {@link SchedulerPro.column.DurationColumn DurationColumn} | - | Duration column                  |
 * | `toolbar`   | {@link Core.widget.Toolbar Toolbar} | -      | Control buttons in a toolbar docked to bottom     |
 * | \> `add`    | {@link Core.widget.Button Button}   | 210    | Adds a new predecessor                            |
 * | \> `remove` | {@link Core.widget.Button Button}   | 220    | Removes selected incoming dependency              |
 *
 * <sup>*</sup>Columns are kept in the grids column store, they can be customized in a similar manner as other widgets in the
 * editor:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *   features : {
 *     taskEdit : {
 *       items : {
 *          predecessorsTab : {
 *            items : {
 *              grid : {
 *                columns : {
 *                  // Columns are held in a store, thus it uses `data`
 *                  // instead of `items`
 *                  data : {
 *                    name : {
 *                      // Change header text for the name column
 *                      text : 'Linked to'
 *                    }
 *                  }
 *                }
 *              }
 *            }
 *          }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @extends SchedulerPro/widget/taskeditor/DependencyTab
 * @classtype predecessorstab
 */

class PredecessorsTab extends _DependencyTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PredecessorsTab';
  } // Factoryable type name


  static get type() {
    return 'predecessorstab';
  }

  static get configurable() {
    return {
      cls: 'b-predecessors-tab',
      direction: 'fromEvent',
      negDirection: 'toEvent',
      title: 'L{DependencyTab.Predecessors}',

      /**
       * Dependency field to sort predecessors by
       * @private
       * @config {String}
       * @default
       */
      sortField: 'fromEventName',
      items: {
        grid: {
          columns: {
            data: {
              name: {
                field: 'fromEvent'
              }
            }
          }
        }
      }
    };
  }

} // Register this widget type with its Factory

PredecessorsTab.initClass();
PredecessorsTab._$name = 'PredecessorsTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/ResourcesTab.js":
/*!************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/ResourcesTab.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourcesTab; });
/* harmony import */ var _Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Grid/view/Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony import */ var _EditorTab_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EditorTab.js */ "./lib/SchedulerPro/widget/taskeditor/EditorTab.js");
/* harmony import */ var _Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Grid/column/NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
var productName = 'gantt';



/**
 * @module Gantt/widget/taskeditor/ResourcesTab
 */

/**
 * A tab inside the {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor} showing the assigned resources for an event or task.
 *
 * The tab has the following contents by default:
 *
 * | Widget ref     | Type                                          | Weight | Description                            |
 * |----------------|-----------------------------------------------|--------|----------------------------------------|
 * | `grid`         | {@link Grid.view.Grid Grid}                   | 100    | Shows resource name and assigned units |
 * | \> `resource`* | {@link Grid.column.Column Column}             | -      | Name column, linked task               |
 * | \> `units`*    | {@link Grid.column.NumberColumn NumberColumn} | -      | Dependency type column                 |
 * | `toolbar`      | {@link Core.widget.Toolbar Toolbar}           | -      | Toolbar docked to bottom               |
 * | \> `add`       | {@link Core.widget.Button Button}             | 210    | Adds a new assignment                  |
 * | \> `remove`    | {@link Core.widget.Button Button}             | 220    | Removes selected assignment            |
 *
 * <sup>*</sup>Columns are kept in the grids column store, they can be customized in a similar manner as other widgets
 * in the editor:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *   features : {
 *     taskEdit : {
 *       items : {
 *         resourcesTab : {
 *           items : {
 *             grid : {
 *               columns : {
 *                 // Columns are held in a store, thus it uses `data`
 *                 // instead of `items`
 *                 data : {
 *                   resource : {
 *                     // Change header text for the resource column
 *                     text : 'Machine'
 *                   }
 *                 }
 *               }
 *             }
 *           }
 *         }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @extends SchedulerPro/widget/taskeditor/EditorTab
 */

class ResourcesTab extends _EditorTab_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get $name() {
    return 'ResourcesTab';
  } // Factoryable type name


  static get type() {
    return 'resourcestab';
  }

  static get configurable() {
    return {
      title: 'L{Resources}',
      cls: 'b-resources-tab',
      layoutStyle: {
        flexFlow: 'column nowrap'
      },
      items: {
        grid: {
          type: 'grid',
          weight: 100,
          flex: '1 1 auto',
          columns: {
            data: {
              resource: {
                localeClass: this,
                text: 'L{Resource}',
                field: 'resource',
                flex: 7,
                renderer: ({
                  value
                }) => (value === null || value === void 0 ? void 0 : value.name) || '',
                editor: {
                  type: 'modelcombo',
                  displayField: 'name',
                  valueField: 'id'
                }
              },
              units: {
                type: 'number',
                localeClass: this,
                text: 'L{Units}',
                field: 'units',
                flex: 3,
                renderer: data => this.L('L{unitsTpl}', data),
                min: 0,
                max: 100,
                step: 10
              }
            }
          },
          disableGridRowModelWarning: true,
          asyncEventSuffix: 'PreCommit'
        },
        toolbar: {
          type: 'toolbar',
          dock: 'bottom',
          cls: 'b-compact-bbar',
          items: {
            add: {
              type: 'button',
              weight: 210,
              cls: 'b-add-button b-green',
              icon: 'b-icon b-icon-add'
            },
            remove: {
              type: 'button',
              weight: 220,
              cls: 'b-remove-button b-red',
              icon: 'b-icon b-icon-trash',
              disabled: true
            }
          }
        }
      }
    };
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this,
          addButton = me.addButton = me.widgetMap.add,
          removeButton = me.removeButton = me.widgetMap.remove,
          grid = me.grid = me.widgetMap.grid;
    addButton === null || addButton === void 0 ? void 0 : addButton.on('click', me.onAddClick, me);
    removeButton === null || removeButton === void 0 ? void 0 : removeButton.on('click', me.onRemoveClick, me);
    grid.on({
      selectionChange: 'onGridSelectionChange',
      startCellEdit: 'onGridStartCellEdit',
      finishCellEdit: 'onGridFinishCellEdit',
      cancelCellEdit: 'onGridCancelCellEdit',
      thisObj: me
    });
  }

  updateReadOnly(readOnly) {
    const {
      add,
      remove
    } = this.widgetMap;
    super.updateReadOnly(...arguments); // Buttons hide when we are readOnly

    add.hidden = remove.hidden = readOnly;
  }

  get resourceCombo() {
    var _this$grid;

    const from = (_this$grid = this.grid) === null || _this$grid === void 0 ? void 0 : _this$grid.columns.get('resource');
    return from === null || from === void 0 ? void 0 : from.editor;
  }

  loadEvent(eventRecord) {
    const me = this,
          {
      grid
    } = me,
          firstLoad = !grid.store.isChained,
          recordChange = !firstLoad && eventRecord !== me.record;
    super.loadEvent(eventRecord);
    const {
      resourceCombo
    } = me,
          {
      assignmentStore,
      resourceStore
    } = me.project; // Pro does not use units on assignments

    if (!eventRecord.isTask) {
      grid.columns.get('units').hide();
    }

    if (firstLoad) {
      // Cache the mutation generation of the underlying data collection
      // so that we know when we need to refill the chained stores.
      me.assignmentStoreGeneration = assignmentStore.storage.generation;
      me.resourceStoreGeneration = resourceStore.storage.generation;
      grid.store = assignmentStore.makeChained(a => me.record && a.event === me.record, null);
      resourceCombo.store = resourceStore.makeChained(resource => {
        return !resource.isSpecialRow && me.record && !me.record.isAssignedTo(resource) || !me.activeAssignment || me.activeAssignment.resource === resource;
      }, null, {
        groupers: resourceStore.groupers
      });
    } else {
      // Only repopulate the chained stores if the master stores have changed
      // or if this is being loaded with a different record.
      if (recordChange || assignmentStore.storage.generation !== me.assignmentStoreGeneration) {
        grid.store.fillFromMaster();
      }

      if (recordChange || resourceStore.storage.generation !== me.resourceStoreGeneration) {
        resourceCombo.store.fillFromMaster();
      }
    }
  } // Returns the assignment row currently being edited


  get activeAssignment() {
    return this.grid.features.cellEdit.activeRecord;
  }

  async insertNewAssignment() {
    const me = this,
          {
      project,
      grid
    } = me,
          assignmentStore = project.assignmentStore;
    const [newAssignment] = assignmentStore.insert(0, {
      event: me.record,
      resource: null,
      units: 100
    }); // Reset the assignment store mutation monitor when we add an assignment

    me.assignmentStoreGeneration = assignmentStore.storage.generation;
    grid.features.cellEdit.startEditing({
      field: 'resource',
      id: newAssignment.id
    });
    return newAssignment;
  }

  beforeSave() {
    this.pruneInvalidAssignments();
  }

  onAddClick() {
    this.insertNewAssignment();
  }

  onRemoveClick() {
    const me = this,
          {
      grid
    } = me;
    grid.store.remove(grid.selectedRecords);
    grid.selectedRecords = null;
    me.removeButton.disable();
  }

  onGridSelectionChange({
    selection
  }) {
    this.removeButton.disabled = !(selection !== null && selection !== void 0 && selection.length);
  }

  onGridStartCellEdit({
    editorContext
  }) {
    if (editorContext.column.field === 'resource') {
      this.resourceCombo.store.fillFromMaster();
      this._editingAssignment = editorContext.record;
      this._activeCellEdit = editorContext;
    }
  }

  onGridFinishCellEdit() {
    this._activeCellEdit = this._editingAssignment = null;
  }

  onGridCancelCellEdit() {
    this._activeCellEdit = this._editingAssignment = null;
  }

  pruneInvalidAssignments() {
    const {
      store
    } = this.grid;
    store.remove(store.query(a => !a.isValid));
  }

} // Register this widget type with its Factory

ResourcesTab.initClass();
ResourcesTab._$name = 'ResourcesTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js":
/*!********************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerAdvancedTab; });
/* harmony import */ var _FormTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony import */ var _CalendarField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CalendarField.js */ "./lib/SchedulerPro/widget/CalendarField.js");
/* harmony import */ var _ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ConstraintTypePicker.js */ "./lib/SchedulerPro/widget/ConstraintTypePicker.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SchedulingModePicker.js */ "./lib/SchedulerPro/widget/SchedulingModePicker.js");
var productName = 'gantt';






/**
 * @module SchedulerPro/widget/taskeditor/SchedulerAdvancedTab
 */

/**
 * Advanced task options for {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor} tab.
 *
 * Contains the following fields by default (with their default weight):
 *
 * | Field ref                | Type                                             | Weight | Description                                         |
 * |--------------------------|--------------------------------------------------|--------|-----------------------------------------------------|
 * | `calendarField`          | {@link SchedulerPro/widget/CalendarField}        | 100    | List of available calendars , if calendars are used |
 * | `constraintTypeField`    | {@link SchedulerPro/widget/ConstraintTypePicker} | 200    | Shows a list of available constraints for this task |
 * | `constraintDateField`    | {@link Core/widget/DateField}                    | 300    | Shows a date for the selected constraint type       |
 * | `manuallyScheduledField` | {@link Core/widget/Checkbox}                     | 400    | When checked, task is not considered in scheduling  |
 * | `inactiveField`          | {@link Core/widget/Checkbox}                     | 500    | Allows inactivating the task so it won't take part in the scheduling process. |
 *
 * @extends  SchedulerPro/widget/taskeditor/FormTab
 * @classtype scheduleradvancedtab
 */

class SchedulerAdvancedTab extends _FormTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SchedulerAdvancedTab';
  }

  static get type() {
    return 'scheduleradvancedtab';
  }

  static get configurable() {
    return {
      cls: 'b-advanced-tab',
      tab: {
        icon: 'b-icon-advanced',
        tooltip: 'L{SchedulerAdvancedTab.Advanced}'
      },
      defaults: {
        localeClass: this
      },
      items: {
        calendarField: {
          type: 'calendarfield',
          name: 'calendar',
          label: 'L{Calendar}',
          weight: 100
        },
        constraintTypeField: {
          type: 'constrainttypepicker',
          name: 'constraintType',
          label: 'L{Constraint type}',
          clearable: true,
          weight: 200
        },
        constraintDateField: {
          type: 'date',
          name: 'constraintDate',
          label: 'L{Constraint date}',
          weight: 300
        },
        manuallyScheduledField: {
          type: 'checkbox',
          name: 'manuallyScheduled',
          label: 'L{Manually scheduled}',
          weight: 400
        },
        inactiveField: {
          type: 'checkbox',
          weight: 500,
          name: 'inactive',
          label: 'L{Inactive}'
        }
      }
    };
  }

  get calendarField() {
    return this.widgetMap.calendarField;
  }

  get constraintTypeField() {
    return this.widgetMap.constraintTypeField;
  }

  get constraintDateField() {
    return this.widgetMap.constraintDateField;
  }

  get manuallyScheduledField() {
    return this.widgetMap.manuallyScheduledField;
  }

  loadEvent(eventRecord) {
    const me = this,
          firstLoad = !me.record,
          {
      calendarField
    } = me;

    if (calendarField) {
      calendarField.store = eventRecord.project.calendarManagerStore;
      calendarField.hidden = !eventRecord.project.calendarManagerStore.count;
    }

    super.loadEvent(...arguments);
  }

}
SchedulerAdvancedTab.initClass();
SchedulerAdvancedTab._$name = 'SchedulerAdvancedTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js":
/*!*******************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerGeneralTab; });
/* harmony import */ var _FormTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _CalendarField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../CalendarField.js */ "./lib/SchedulerPro/widget/CalendarField.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/widget/DateTimeField.js */ "./lib/Core/widget/DateTimeField.js");
/* harmony import */ var _StartDateField_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../StartDateField.js */ "./lib/SchedulerPro/widget/StartDateField.js");
/* harmony import */ var _EndDateField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../EndDateField.js */ "./lib/SchedulerPro/widget/EndDateField.js");
var productName = 'gantt';







/**
 * @module SchedulerPro/widget/taskeditor/SchedulerGeneralTab
 */

/**
 * A tab inside the {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} showing the general
 * information for an event from a simplified scheduler project.
 *
 * Contains the following fields by default:
 *
 * | Field ref          | Type                                            | Text       | Weight | Description                                                        |
 * |--------------------|-------------------------------------------------|------------|--------|--------------------------------------------------------------------|
 * | `nameField`        | {@link Core.widget.TextField TextField}         | Name       | 100    | Task name                                                          |
 * | `resourcesField`   | {@link Core.widget.Combo Combo}                 | Resources  | 200    | Shows a list of available resources for this task                  |
 * | `startDateField`   | {@link Core.widget.DateTimeField DateTimeField} | Start      | 300    | Shows when the task begins                                         |
 * | `endDateField`     | {@link Core.widget.DateTimeField DateTimeField} | Finish     | 400    | Shows when the task ends                                           |
 * | `durationField`    | {@link Core.widget.DurationField DurationField} | Duration   | 500    | Shows how long the task is                                         |
 * | `percentDoneField` | {@link Core.widget.NumberField NumberField}     | % Complete | 600    | Shows what part of task is done already in percentage              |
 *
 * To customize the tab or its fields:
 *
 * ```javascript
 * features : {
 *     taskEdit : {
 *         items : {
 *             generalTab : {
 *                 // Custom title
 *                 title: 'Common',
 *                 // Customized items
 *                 items : {
 *                     // Hide the duration field
 *                     durationField : null,
 *                     // Customize the name field
 *                     nameField : {
 *                         label : 'Title'
 *                     },
 *                     // Add a custom field
 *                     colorField : {
 *                         type   : 'text',
 *                         label  : 'Color',
 *                         // name maps to a field on the event record
 *                         name   : 'eventColor',
 *                         // place at top
 *                         weight : 0
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * }
 * ```
 *
 * @extends SchedulerPro/widget/taskeditor/FormTab
 * @classtype schedulergeneraltab
 */

class SchedulerGeneralTab extends _FormTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SchedulerGeneralTab';
  } // Factoryable type name


  static get type() {
    return 'schedulergeneraltab';
  }

  static get defaultConfig() {
    return {
      title: 'L{General}',
      cls: 'b-general-tab',
      defaults: {
        localeClass: this,
        // New fields at the end
        weight: 10
      },
      items: {
        nameField: {
          type: 'text',
          required: true,
          label: 'L{Name}',
          clearable: true,
          name: 'name',
          cls: 'b-name',
          weight: 100
        },
        // TODO: Prevent removing last, or prevent event from being removed while editing
        resourcesField: {
          type: 'combo',
          label: 'L{Resources}',
          name: 'resources',
          editable: true,
          valueField: 'id',
          displayField: 'name',
          highlightExternalChange: false,
          cls: 'b-resources',
          weight: 200
        },
        startDateField: {
          type: 'datetime',
          label: 'L{Start}',
          name: 'startDate',
          cls: 'b-start-date',
          flex: '1 0 100%',
          weight: 300,
          dateField: {
            type: 'startdatefield'
          }
        },
        endDateField: {
          type: 'datetime',
          label: 'L{Finish}',
          name: 'endDate',
          cls: 'b-end-date',
          flex: '1 0 100%',
          weight: 400,
          dateField: {
            type: 'enddatefield'
          }
        },
        durationField: {
          type: 'durationfield',
          label: 'L{Duration}',
          name: 'fullDuration',
          flex: '1 0 50%',
          cls: 'b-duration b-inline',
          weight: 500
        },
        percentDoneField: {
          type: 'number',
          label: 'L{% complete}',
          name: 'renderedPercentDone',
          cls: 'b-percent-done',
          flex: '1 0 50%',
          min: 0,
          max: 100,
          weight: 600
        }
      }
    };
  }

  loadEvent(record) {
    const me = this,
          step = {
      unit: record.durationUnit,
      magnitude: 1
    },
          {
      isParent,
      project
    } = record,
          {
      durationField,
      percentDoneField,
      startDateField,
      endDateField,
      resourcesField
    } = me.widgetMap,
          firstLoad = !me.record; // Editing duration, percentDone & endDate disallowed for parent tasks

    if (durationField) {
      durationField.disabled = isParent;

      if (!percentDoneField) {
        durationField.element.classList.remove('b-inline');
      }
    }

    if (percentDoneField) {
      percentDoneField.disabled = isParent;
    }

    if (startDateField) {
      startDateField.dateField.eventRecord = record;

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].compareUnits(step.unit, 'hour') > 0) {
        startDateField.dateField.step = step;
      } else {
        startDateField.timeField.step = step;
      }
    }

    if (endDateField) {
      endDateField.dateField.eventRecord = record;

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].compareUnits(step.unit, 'hour') > 0) {
        endDateField.dateField.step = step;
      } else {
        endDateField.timeField.step = step;
      }

      endDateField.disabled = isParent;
    }

    if (resourcesField) {
      var _resourcesField$confi;

      resourcesField.multiSelect = (_resourcesField$confi = resourcesField.config.multiSelect) !== null && _resourcesField$confi !== void 0 ? _resourcesField$confi : !project.eventStore.usesSingleAssignment; // TODO here we should set label based on multiSelect value
      // https://github.com/bryntum/support/issues/1528

      if (firstLoad) {
        // Can't use store directly since it may be grouped and then contains irrelevant group records
        resourcesField.store = new project.resourceStore.constructor({
          chained: true,
          masterStore: project.resourceStore,
          chainedFilterFn: record => !record.isSpecialRow
        });
      }
    }

    super.loadEvent(...arguments);
  }

  onFieldChange({
    source,
    valid,
    userAction,
    value
  }) {
    if (userAction && valid) {
      const {
        eventStore
      } = this.record,
            resourceUnassigned = source.name === 'resources' && value.length === 0 && this.autoUpdateRecord && eventStore.removeUnassignedEvent;

      if (resourceUnassigned) {
        // Do not remove unassigned event if all resources are removed, we will do it after
        eventStore.removeUnassignedEvent = false;
      }

      super.onFieldChange(...arguments);

      if (resourceUnassigned) {
        eventStore.removeUnassignedEvent = true;
      }
    }
  }

  beforeSave() {
    // We skipped removing event on field change, if resource is still empty before save - remove record
    if (this.record.resources.length === 0 && this.record.eventStore.removeUnassignedEvent) {
      this.record.remove();
    }

    super.beforeSave();
  }

} // Register this widget type with its Factory

SchedulerGeneralTab.initClass();
SchedulerGeneralTab._$name = 'SchedulerGeneralTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js":
/*!*************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SuccessorsTab; });
/* harmony import */ var _DependencyTab_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DependencyTab.js */ "./lib/SchedulerPro/widget/taskeditor/DependencyTab.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/taskeditor/SuccessorsTab
 */

/**
 * A tab inside the {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor} showing the successors of an event or task.
 *
 * The tab has the following contents by default:
 *
 * | Widget ref  | Type                                | Weight | Description                                         |
 * |-------------|-------------------------------------|--------|-----------------------------------------------------|
 * | `grid`      | {@link Grid.view.Grid Grid}         | 100    | Shows successors task name, dependency type and lag |
 * | \> `id`*    | {@link Grid.column.Column Column}   | -      | Id column                                           |
 * | \> `name`*  | {@link Grid.column.Column Column}   | -      | Name column, linked task                            |
 * | \> `type`*  | {@link Grid.column.Column Column}   | -      | Dependency type column                              |
 * | \> `lag` *  | {@link SchedulerPro.column.DurationColumn DurationColumn} | - | Duration column                    |
 * | `toolbar`   | {@link Core.widget.Toolbar Toolbar} | -      | Control buttons in a toolbar docked to bottom       |
 * | \> `add`    | {@link Core.widget.Button Button}   | 210    | Adds a new successor                                |
 * | \> `remove` | {@link Core.widget.Button Button}   | 220    | Removes selected outgoing dependency                |
 *
 * <sup>*</sup>Columns are kept in the grids column store, they can be customized in a similar manner as other widgets in the
 * editor:
 *
 * ```javascript
 * const scheduler = new SchedulerPro({
 *   features : {
 *     taskEdit : {
 *       items : {
 *         successorsTab : {
 *           items : {
 *             grid : {
 *               columns : {
 *                 // Columns are held in a store, thus it uses `data`
 *                 // instead of `items`
 *                 data : {
 *                   name : {
 *                     // Change header text for the name column
 *                     text : 'Linked to'
 *                   }
 *                 }
 *               }
 *             }
 *           }
 *         }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @extends SchedulerPro/widget/taskeditor/DependencyTab
 * @classtype successorstab
 */

class SuccessorsTab extends _DependencyTab_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SuccessorsTab';
  } // Factoryable type name


  static get type() {
    return 'successorstab';
  }

  static get configurable() {
    return {
      cls: 'b-successors-tab',
      direction: 'toEvent',
      negDirection: 'fromEvent',
      title: 'L{DependencyTab.Successors}',

      /**
       * Dependency field to sort successors by
       * @private
       * @config {String}
       * @default
       */
      sortField: 'toEventName',
      items: {
        grid: {
          columns: {
            data: {
              name: {
                field: 'toEvent'
              }
            }
          }
        }
      }
    };
  }

} // Register this widget type with its Factory

SuccessorsTab.initClass();
SuccessorsTab._$name = 'SuccessorsTab';

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js":
/*!*****************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/widget/Container.js */ "./lib/Core/widget/Container.js");
var productName = 'gantt';

/**
 * @module SchedulerPro/widget/taskeditor/mixin/EventLoader
 */

/**
 * Mixin class for task editor widgets which require record loading functionality
 *
 * @mixin
 * @mixinbase Container
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class extends (Target || _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  get project() {
    var _this$record;

    return (_this$record = this.record) === null || _this$record === void 0 ? void 0 : _this$record.project;
  }

  loadEvent(record, highlightChanges) {
    this.setRecord(record, highlightChanges);
  }

  resetData() {
    this.record = null;
  }

  beforeSave() {}

  afterSave() {
    this.resetData();
  }

  beforeCancel() {}

  afterCancel() {
    this.resetData();
  }

  beforeDelete() {}

  afterDelete() {
    this.resetData();
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js":
/*!**************************************************************************!*\
  !*** ./lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
var productName = 'gantt';


/* harmony default export */ __webpack_exports__["default"] = (Target => class extends (Target || Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  get isReadyStatePropagator() {
    return true;
  }

  get canSave() {
    return true;
  }

  requestReadyStateChange() {
    this.trigger('readystatechange', {
      canSave: this.canSave
    });
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./webpack/webpack.core.entry.js":
/*!***************************************!*\
  !*** ./webpack/webpack.core.entry.js ***!
  \***************************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, Model, Store, ArrayDataField, BooleanDataField, DataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, StoreChained, StoreCRUD, StoreFilter, StoreGroup, StoreProxy, StoreRelation, StoreSearch, StoreSort, StoreState, StoreSum, StoreSync, StoreTree, TreeNode, ActionBase, ModelStm, StateBase, StateTrackingManager, StoreStm, Transaction, ContextMenuBase, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, XMLHelper, DataGenerator, DemoBot, DomClassList, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, RandomGenerator, Rectangle, Scroller, LocaleHelper, LocaleManager, Localizable, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, Identifiable, InstancePlugin, LoadMaskable, Override, Pluggable, State, Animator, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, ScrollManager, DragContext, DragProxy, DragTipProxy, DynamicObject, DayTime, Month, Parser, UndoRedoBase, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, Label, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, PanelCollapser, PanelCollapserOverlay, CollapseTool, PasswordField, PickerField, Popup, Renderable, Ripple, Slider, SlideToggle, Splitter, Tab, TabBar, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, Layout, Badge, Responsive, Rotatable, Styleable, Toolable, Histogram, Scale, AvatarRendering, TrialButton, TrialPanel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Core/Base.js */ "./lib/Core/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/Core/Config.js */ "./lib/Core/Config.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/Core/data/Duration.js */ "./lib/Core/data/Duration.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _lib_Core_data_field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/Core/data/field/ArrayDataField.js */ "./lib/Core/data/field/ArrayDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayDataField", function() { return _lib_Core_data_field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/Core/data/field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/Core/data/field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/Core/data/field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/Core/data/field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/Core/data/field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/Core/data/field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/Core/data/field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/Core/data/field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreChained.js */ "./lib/Core/data/mixin/StoreChained.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreChained", function() { return _lib_Core_data_mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreCRUD.js */ "./lib/Core/data/mixin/StoreCRUD.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreCRUD", function() { return _lib_Core_data_mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreFilter.js */ "./lib/Core/data/mixin/StoreFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreFilter", function() { return _lib_Core_data_mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreGroup.js */ "./lib/Core/data/mixin/StoreGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreGroup", function() { return _lib_Core_data_mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreProxy.js */ "./lib/Core/data/mixin/StoreProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreProxy", function() { return _lib_Core_data_mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreRelation.js */ "./lib/Core/data/mixin/StoreRelation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreRelation", function() { return _lib_Core_data_mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSearch.js */ "./lib/Core/data/mixin/StoreSearch.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSearch", function() { return _lib_Core_data_mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSort.js */ "./lib/Core/data/mixin/StoreSort.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSort", function() { return _lib_Core_data_mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreState.js */ "./lib/Core/data/mixin/StoreState.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreState", function() { return _lib_Core_data_mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSum.js */ "./lib/Core/data/mixin/StoreSum.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSum", function() { return _lib_Core_data_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSync.js */ "./lib/Core/data/mixin/StoreSync.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSync", function() { return _lib_Core_data_mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreTree.js */ "./lib/Core/data/mixin/StoreTree.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreTree", function() { return _lib_Core_data_mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../lib/Core/data/mixin/TreeNode.js */ "./lib/Core/data/mixin/TreeNode.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return _lib_Core_data_mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _lib_Core_data_stm_action_ActionBase_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../lib/Core/data/stm/action/ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionBase", function() { return _lib_Core_data_stm_action_ActionBase_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _lib_Core_data_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../lib/Core/data/stm/mixin/ModelStm.js */ "./lib/Core/data/stm/mixin/ModelStm.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelStm", function() { return _lib_Core_data_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _lib_Core_data_stm_state_StateBase_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../lib/Core/data/stm/state/StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return _lib_Core_data_stm_state_StateBase_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../lib/Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _lib_Core_data_stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../lib/Core/data/stm/mixin/StoreStm.js */ "./lib/Core/data/stm/mixin/StoreStm.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreStm", function() { return _lib_Core_data_stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../lib/Core/data/stm/Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _lib_Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../lib/Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBase", function() { return _lib_Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../lib/Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../lib/Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../lib/Core/helper/AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../lib/Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../lib/Core/helper/CSSHelper.js */ "./lib/Core/helper/CSSHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../lib/Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../lib/Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../lib/Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../lib/Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../lib/Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../lib/Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../lib/Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../lib/Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../lib/Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../lib/Core/helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../lib/Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../lib/Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../lib/Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../lib/Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _lib_Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../lib/Core/helper/XMLHelper.js */ "./lib/Core/helper/XMLHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XMLHelper", function() { return _lib_Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../lib/Core/helper/util/DataGenerator.js */ "./lib/Core/helper/util/DataGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../lib/Core/helper/util/DemoBot.js */ "./lib/Core/helper/util/DemoBot.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../lib/Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../lib/Core/helper/util/Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../lib/Core/helper/util/Fullscreen.js */ "./lib/Core/helper/util/Fullscreen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../lib/Core/helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../lib/Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../lib/Core/helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../lib/Core/helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../lib/Core/helper/util/RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../lib/Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../lib/Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../lib/Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../lib/Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../lib/Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony import */ var _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../lib/Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../lib/Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../lib/Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../lib/Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../lib/Core/mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../lib/Core/mixin/Featureable.js */ "./lib/Core/mixin/Featureable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../lib/Core/mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../lib/Core/mixin/Hoverable.js */ "./lib/Core/mixin/Hoverable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _lib_Core_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../lib/Core/mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifiable", function() { return _lib_Core_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../lib/Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony import */ var _lib_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../lib/Core/mixin/LoadMaskable.js */ "./lib/Core/mixin/LoadMaskable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadMaskable", function() { return _lib_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../lib/Core/mixin/Override.js */ "./lib/Core/mixin/Override.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../lib/Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });

/* harmony import */ var _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../lib/Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });

/* harmony import */ var _lib_Core_util_Animator_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../lib/Core/util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Animator", function() { return _lib_Core_util_Animator_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../lib/Core/util/Bag.js */ "./lib/Core/util/Bag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../lib/Core/util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });

/* harmony import */ var _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../lib/Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../lib/Core/util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../lib/Core/util/CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });

/* harmony import */ var _lib_Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../lib/Core/util/ScrollManager.js */ "./lib/Core/util/ScrollManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _lib_Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../lib/Core/util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../lib/Core/util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../lib/Core/util/drag/DragTipProxy.js */ "./lib/Core/util/drag/DragTipProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });

/* harmony import */ var _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../lib/Core/util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_96__["default"]; });

/* harmony import */ var _lib_Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../lib/Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DayTime", function() { return _lib_Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_97__["default"]; });

/* harmony import */ var _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../lib/Core/util/Month.js */ "./lib/Core/util/Month.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_98__["default"]; });

/* harmony import */ var _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../lib/Core/util/Parser.js */ "./lib/Core/util/Parser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_99__["default"]; });

/* harmony import */ var _lib_Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../lib/Core/widget/base/UndoRedoBase.js */ "./lib/Core/widget/base/UndoRedoBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedoBase", function() { return _lib_Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_100__["default"]; });

/* harmony import */ var _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../lib/Core/widget/BooleanCombo.js */ "./lib/Core/widget/BooleanCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_101__["default"]; });

/* harmony import */ var _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../lib/Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_102__["default"]; });

/* harmony import */ var _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ../lib/Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_103__["default"]; });

/* harmony import */ var _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ../lib/Core/widget/CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_104__["default"]; });

/* harmony import */ var _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ../lib/Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_105__["default"]; });

/* harmony import */ var _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ../lib/Core/widget/ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_106__["default"]; });

/* harmony import */ var _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ../lib/Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_107__["default"]; });

/* harmony import */ var _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ../lib/Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_108__["default"]; });

/* harmony import */ var _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ../lib/Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_109__["default"]; });

/* harmony import */ var _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ../lib/Core/widget/DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_110__["default"]; });

/* harmony import */ var _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ../lib/Core/widget/DateTimeField.js */ "./lib/Core/widget/DateTimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_111__["default"]; });

/* harmony import */ var _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(/*! ../lib/Core/widget/DisplayField.js */ "./lib/Core/widget/DisplayField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_112__["default"]; });

/* harmony import */ var _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(/*! ../lib/Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_113__["default"]; });

/* harmony import */ var _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(/*! ../lib/Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_114__["default"]; });

/* harmony import */ var _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(/*! ../lib/Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_115__["default"]; });

/* harmony import */ var _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(/*! ../lib/Core/widget/FileField.js */ "./lib/Core/widget/FileField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_116__["default"]; });

/* harmony import */ var _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(/*! ../lib/Core/widget/FilePicker.js */ "./lib/Core/widget/FilePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_117__["default"]; });

/* harmony import */ var _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(/*! ../lib/Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_118__["default"]; });

/* harmony import */ var _lib_Core_widget_Label_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(/*! ../lib/Core/widget/Label.js */ "./lib/Core/widget/Label.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _lib_Core_widget_Label_js__WEBPACK_IMPORTED_MODULE_119__["default"]; });

/* harmony import */ var _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(/*! ../lib/Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_120__["default"]; });

/* harmony import */ var _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(/*! ../lib/Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_121__["default"]; });

/* harmony import */ var _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(/*! ../lib/Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_122__["default"]; });

/* harmony import */ var _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(/*! ../lib/Core/widget/MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_123__["default"]; });

/* harmony import */ var _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(/*! ../lib/Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_124__["default"]; });

/* harmony import */ var _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(/*! ../lib/Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_125__["default"]; });

/* harmony import */ var _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(/*! ../lib/Core/widget/PagingToolbar.js */ "./lib/Core/widget/PagingToolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_126__["default"]; });

/* harmony import */ var _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(/*! ../lib/Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_127__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(/*! ../lib/Core/widget/panel/PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapser", function() { return _lib_Core_widget_panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_128__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_PanelCollapserOverlay_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(/*! ../lib/Core/widget/panel/PanelCollapserOverlay.js */ "./lib/Core/widget/panel/PanelCollapserOverlay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapserOverlay", function() { return _lib_Core_widget_panel_PanelCollapserOverlay_js__WEBPACK_IMPORTED_MODULE_129__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_CollapseTool_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(/*! ../lib/Core/widget/panel/CollapseTool.js */ "./lib/Core/widget/panel/CollapseTool.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseTool", function() { return _lib_Core_widget_panel_CollapseTool_js__WEBPACK_IMPORTED_MODULE_130__["default"]; });

/* harmony import */ var _lib_Core_widget_PasswordField_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(/*! ../lib/Core/widget/PasswordField.js */ "./lib/Core/widget/PasswordField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return _lib_Core_widget_PasswordField_js__WEBPACK_IMPORTED_MODULE_131__["default"]; });

/* harmony import */ var _lib_Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(/*! ../lib/Core/widget/PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerField", function() { return _lib_Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_132__["default"]; });

/* harmony import */ var _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(/*! ../lib/Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_133__["default"]; });

/* harmony import */ var _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(/*! ../lib/Core/widget/Renderable.js */ "./lib/Core/widget/Renderable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_134__["default"]; });

/* harmony import */ var _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(/*! ../lib/Core/widget/Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_135__["default"]; });

/* harmony import */ var _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(/*! ../lib/Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_136__["default"]; });

/* harmony import */ var _lib_Core_widget_SlideToggle_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(/*! ../lib/Core/widget/SlideToggle.js */ "./lib/Core/widget/SlideToggle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideToggle", function() { return _lib_Core_widget_SlideToggle_js__WEBPACK_IMPORTED_MODULE_137__["default"]; });

/* harmony import */ var _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(/*! ../lib/Core/widget/Splitter.js */ "./lib/Core/widget/Splitter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_138__["default"]; });

/* harmony import */ var _lib_Core_widget_Tab_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(/*! ../lib/Core/widget/Tab.js */ "./lib/Core/widget/Tab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _lib_Core_widget_Tab_js__WEBPACK_IMPORTED_MODULE_139__["default"]; });

/* harmony import */ var _lib_Core_widget_TabBar_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(/*! ../lib/Core/widget/TabBar.js */ "./lib/Core/widget/TabBar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _lib_Core_widget_TabBar_js__WEBPACK_IMPORTED_MODULE_140__["default"]; });

/* harmony import */ var _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(/*! ../lib/Core/widget/TabPanel.js */ "./lib/Core/widget/TabPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_141__["default"]; });

/* harmony import */ var _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(/*! ../lib/Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_142__["default"]; });

/* harmony import */ var _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(/*! ../lib/Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_143__["default"]; });

/* harmony import */ var _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(/*! ../lib/Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_144__["default"]; });

/* harmony import */ var _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(/*! ../lib/Core/widget/TimePicker.js */ "./lib/Core/widget/TimePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_145__["default"]; });

/* harmony import */ var _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(/*! ../lib/Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_146__["default"]; });

/* harmony import */ var _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(/*! ../lib/Core/widget/Tool.js */ "./lib/Core/widget/Tool.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_147__["default"]; });

/* harmony import */ var _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(/*! ../lib/Core/widget/Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_148__["default"]; });

/* harmony import */ var _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(/*! ../lib/Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_149__["default"]; });

/* harmony import */ var _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(/*! ../lib/Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_150__["default"]; });

/* harmony import */ var _lib_Core_widget_layout_Layout_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(/*! ../lib/Core/widget/layout/Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return _lib_Core_widget_layout_Layout_js__WEBPACK_IMPORTED_MODULE_151__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_152__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Responsive.js */ "./lib/Core/widget/mixin/Responsive.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Responsive", function() { return _lib_Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_153__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotatable", function() { return _lib_Core_widget_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_154__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Styleable.js */ "./lib/Core/widget/mixin/Styleable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Styleable", function() { return _lib_Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_155__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolable", function() { return _lib_Core_widget_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_156__["default"]; });

/* harmony import */ var _lib_Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(/*! ../lib/Core/widget/graph/Histogram.js */ "./lib/Core/widget/graph/Histogram.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Histogram", function() { return _lib_Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_157__["default"]; });

/* harmony import */ var _lib_Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(/*! ../lib/Core/widget/graph/Scale.js */ "./lib/Core/widget/graph/Scale.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return _lib_Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_158__["default"]; });

/* harmony import */ var _lib_Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(/*! ../lib/Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AvatarRendering", function() { return _lib_Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_159__["default"]; });

/* harmony import */ var _lib_Core_widget_trial_TrialButton_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(/*! ../lib/Core/widget/trial/TrialButton.js */ "./lib/Core/widget/trial/TrialButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialButton", function() { return _lib_Core_widget_trial_TrialButton_js__WEBPACK_IMPORTED_MODULE_160__["default"]; });

/* harmony import */ var _lib_Core_widget_trial_TrialPanel_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(/*! ../lib/Core/widget/trial/TrialPanel.js */ "./lib/Core/widget/trial/TrialPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialPanel", function() { return _lib_Core_widget_trial_TrialPanel_js__WEBPACK_IMPORTED_MODULE_161__["default"]; });

var productName = 'gantt';

if (window && !window.bryntum) {
  window.bryntum = {};
} //region Core
// core




 // data





 // data field









 // data mixin













 // data stm






 // feature

 // helper




















 // helper util












 // localization



 // mixin














 // util














 // widget



















































 // widget layout

 // widget mixin





 // widget graph


 // widget util

 // widget trial


 //endregion

/***/ }),

/***/ "./webpack/webpack.core.entry.wc.js":
/*!******************************************!*\
  !*** ./webpack/webpack.core.entry.wc.js ***!
  \******************************************/
/*! exports provided: WidgetTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Core/customElements/WidgetTag.js */ "./lib/Core/customElements/WidgetTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _lib_Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

var productName = 'gantt'; // region WebComponents

 // endregion

/***/ }),

/***/ "./webpack/webpack.entry.engine.gantt.js":
/*!***********************************************!*\
  !*** ./webpack/webpack.entry.engine.gantt.js ***!
  \***********************************************/
/*! exports provided: GanttProjectMixin, ConstrainedByParentMixin, ConstrainedLateEventMixin, GanttAssignmentMixin, GanttEvent, GanttHasAssignmentsMixin, HasCriticalPathsMixin, EffortVar, UnitsVar, effortFormula, unitsFormula, endDateByEffortFormula, startDateByEffortFormula, SEDWUDispatcher, SEDWUDispatcherIdentifier, HasEffortMixin, HasSchedulingModeMixin, ScheduledByDependenciesLateEventMixin, fixedDurationSEDWUGraphDescription, fixedDurationSEDWUForwardNonEffortDriven, fixedDurationSEDWUForwardEffortDriven, fixedDurationSEDWUBackwardNonEffortDriven, fixedDurationSEDWUBackwardEffortDriven, FixedDurationMixin, fixedEffortSEDWUGraphDescription, fixedEffortSEDWUForward, fixedEffortSEDWUBackward, FixedEffortMixin, fixedUnitsSEDWUGraphDescription, fixedUnitsSEDWUForwardNonEffortDriven, fixedUnitsSEDWUForwardEffortDriven, fixedUnitsSEDWUBackwardNonEffortDriven, fixedUnitsSEDWUBackwardEffortDriven, FixedUnitsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Engine_quark_model_gantt_GanttProjectMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/GanttProjectMixin.js */ "./lib/Engine/quark/model/gantt/GanttProjectMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttProjectMixin", function() { return _lib_Engine_quark_model_gantt_GanttProjectMixin_js__WEBPACK_IMPORTED_MODULE_0__["GanttProjectMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_ConstrainedByParentMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/ConstrainedByParentMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedByParentMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstrainedByParentMixin", function() { return _lib_Engine_quark_model_gantt_ConstrainedByParentMixin_js__WEBPACK_IMPORTED_MODULE_1__["ConstrainedByParentMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ConstrainedLateEventMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstrainedLateEventMixin", function() { return _lib_Engine_quark_model_gantt_ConstrainedLateEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["ConstrainedLateEventMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/GanttAssignmentMixin.js */ "./lib/Engine/quark/model/gantt/GanttAssignmentMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttAssignmentMixin", function() { return _lib_Engine_quark_model_gantt_GanttAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__["GanttAssignmentMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_GanttEvent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/GanttEvent.js */ "./lib/Engine/quark/model/gantt/GanttEvent.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttEvent", function() { return _lib_Engine_quark_model_gantt_GanttEvent_js__WEBPACK_IMPORTED_MODULE_4__["GanttEvent"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js */ "./lib/Engine/quark/model/gantt/GanttHasAssignmentsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttHasAssignmentsMixin", function() { return _lib_Engine_quark_model_gantt_GanttHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_5__["GanttHasAssignmentsMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_HasCriticalPathsMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/HasCriticalPathsMixin.js */ "./lib/Engine/quark/model/gantt/HasCriticalPathsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasCriticalPathsMixin", function() { return _lib_Engine_quark_model_gantt_HasCriticalPathsMixin_js__WEBPACK_IMPORTED_MODULE_6__["HasCriticalPathsMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/HasEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/HasEffortDispatcher.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffortVar", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["EffortVar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitsVar", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["UnitsVar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "effortFormula", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["effortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unitsFormula", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["unitsFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endDateByEffortFormula", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["endDateByEffortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startDateByEffortFormula", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["startDateByEffortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcher", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["SEDWUDispatcher"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcherIdentifier", function() { return _lib_Engine_quark_model_gantt_HasEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_7__["SEDWUDispatcherIdentifier"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/HasEffortMixin.js */ "./lib/Engine/quark/model/gantt/HasEffortMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasEffortMixin", function() { return _lib_Engine_quark_model_gantt_HasEffortMixin_js__WEBPACK_IMPORTED_MODULE_8__["HasEffortMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js */ "./lib/Engine/quark/model/gantt/HasSchedulingModeMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasSchedulingModeMixin", function() { return _lib_Engine_quark_model_gantt_HasSchedulingModeMixin_js__WEBPACK_IMPORTED_MODULE_9__["HasSchedulingModeMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js */ "./lib/Engine/quark/model/gantt/ScheduledByDependenciesLateEventMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduledByDependenciesLateEventMixin", function() { return _lib_Engine_quark_model_gantt_ScheduledByDependenciesLateEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["ScheduledByDependenciesLateEventMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationDispatcher.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUGraphDescription", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__["fixedDurationSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardNonEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__["fixedDurationSEDWUForwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__["fixedDurationSEDWUForwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardNonEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__["fixedDurationSEDWUBackwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationDispatcher_js__WEBPACK_IMPORTED_MODULE_11__["fixedDurationSEDWUBackwardEffortDriven"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedDurationMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedDurationMixin", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedDurationMixin_js__WEBPACK_IMPORTED_MODULE_12__["FixedDurationMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortDispatcher.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUGraphDescription", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_13__["fixedEffortSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUForward", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_13__["fixedEffortSEDWUForward"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUBackward", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortDispatcher_js__WEBPACK_IMPORTED_MODULE_13__["fixedEffortSEDWUBackward"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedEffortMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedEffortMixin", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedEffortMixin_js__WEBPACK_IMPORTED_MODULE_14__["FixedEffortMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsDispatcher.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsDispatcher.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUGraphDescription", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__["fixedUnitsSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardNonEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__["fixedUnitsSEDWUForwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__["fixedUnitsSEDWUForwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardNonEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__["fixedUnitsSEDWUBackwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardEffortDriven", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsDispatcher_js__WEBPACK_IMPORTED_MODULE_15__["fixedUnitsSEDWUBackwardEffortDriven"]; });

/* harmony import */ var _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsMixin.js */ "./lib/Engine/quark/model/gantt/scheduling_modes/FixedUnitsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedUnitsMixin", function() { return _lib_Engine_quark_model_gantt_scheduling_modes_FixedUnitsMixin_js__WEBPACK_IMPORTED_MODULE_16__["FixedUnitsMixin"]; });

var productName = 'gantt'; //region Engine

















 //endregion

/***/ }),

/***/ "./webpack/webpack.entry.engine.js":
/*!*****************************************!*\
  !*** ./webpack/webpack.entry.engine.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Engine_vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Engine/vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "later", function() { return _lib_Engine_vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["later"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/CycleResolver.js */ "./lib/ChronoGraph/chrono/CycleResolver.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInputChrono", function() { return _lib_ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_1__["CycleResolutionInputChrono"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BreakCurrentStackExecution", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["BreakCurrentStackExecution"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Effect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["Effect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedOrPreviousSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPrevious", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedOrPrevious"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RejectSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["RejectSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RejectEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["RejectEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Reject", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["Reject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransactionSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["TransactionSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GetTransaction", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["GetTransaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OwnQuarkSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["OwnQuarkSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OwnQuark", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["OwnQuark"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifierSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["OwnIdentifierSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifier", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["OwnIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WriteSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["WriteSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WriteEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["WriteEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Write", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["Write"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["WriteSeveralSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["WriteSeveralEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WriteSeveral", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["WriteSeveral"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["PreviousValueOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["PreviousValueOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["PreviousValueOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedValueOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedValueOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedValueOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["HasProposedValueSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["HasProposedValueEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasProposedValue", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["HasProposedValue"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedOrPreviousValueOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedOrPreviousValueOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedOrPreviousValueOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedArgumentsOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedArgumentsOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["ProposedArgumentsOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafeProposedOrPreviousValueOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafeProposedOrPreviousValueOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafeProposedOrPreviousValueOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfSymbol", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafePreviousValueOfSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfEffect", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafePreviousValueOfEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOf", function() { return _lib_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_2__["UnsafePreviousValueOf"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Graph.js */ "./lib/ChronoGraph/chrono/Graph.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CommitZero", function() { return _lib_ChronoGraph_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_3__["CommitZero"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Listener", function() { return _lib_ChronoGraph_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_3__["Listener"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoGraph", function() { return _lib_ChronoGraph_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_3__["ChronoGraph"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Levels", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["Levels"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Meta", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["Meta"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifier", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["Identifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdentifierC", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["IdentifierC"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuarkSync", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["QuarkSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuarkGen", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["QuarkGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Variable", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["Variable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VariableC", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["VariableC"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSync", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["CalculatedValueSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSyncC", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["CalculatedValueSyncC"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGen", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["CalculatedValueGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGenC", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["CalculatedValueGenC"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwUnknownIdentifier", function() { return _lib_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_4__["throwUnknownIdentifier"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EdgeType", function() { return _lib_ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_5__["EdgeType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Quark", function() { return _lib_ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_5__["Quark"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TombStone", function() { return _lib_ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_5__["TombStone"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Revision", function() { return _lib_ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_6__["Revision"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/Transaction.js */ "./lib/ChronoGraph/chrono/Transaction.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EdgeTypeNormal", function() { return _lib_ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_7__["EdgeTypeNormal"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EdgeTypePast", function() { return _lib_ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_7__["EdgeTypePast"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoTransaction", function() { return _lib_ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_7__["Transaction"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js */ "./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComputationCycle", function() { return _lib_ChronoGraph_chrono_TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_8__["ComputationCycle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransactionCycleDetectionWalkContext", function() { return _lib_ChronoGraph_chrono_TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_8__["TransactionCycleDetectionWalkContext"]; });

/* harmony import */ var _lib_ChronoGraph_chrono_TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/ChronoGraph/chrono/TransactionWalkDepth.js */ "./lib/ChronoGraph/chrono/TransactionWalkDepth.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransactionWalkDepth", function() { return _lib_ChronoGraph_chrono_TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_9__["TransactionWalkDepth"]; });

/* harmony import */ var _lib_ChronoGraph_class_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/ChronoGraph/class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoBase", function() { return _lib_ChronoGraph_class_Base_js__WEBPACK_IMPORTED_MODULE_10__["Base"]; });

/* harmony import */ var _lib_ChronoGraph_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/ChronoGraph/class/RequiredProperty.js */ "./lib/ChronoGraph/class/RequiredProperty.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "required", function() { return _lib_ChronoGraph_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_11__["required"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "validateRequiredProperties", function() { return _lib_ChronoGraph_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_11__["validateRequiredProperties"]; });

/* harmony import */ var _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/ChronoGraph/collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "split", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["split"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "inBatchesBySize", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["inBatchesBySize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["filter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["drop"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "every", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["every"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "some", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["some"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "map", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["map"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["reduce"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "uniqueOnly", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["uniqueOnly"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "uniqueOnlyBy", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["uniqueOnlyBy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reverse", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["reverse"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["takeWhile"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeUntilIncluding", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["takeUntilIncluding"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeUntilExcluding", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["takeUntilExcluding"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["concat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatIterable", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["concatIterable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChainedIteratorClass", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["ChainedIteratorClass"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChainedIterator", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["ChainedIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CI", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["CI"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MemoizedIteratorClass", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["MemoizedIteratorClass"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MemoizedIterator", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["MemoizedIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MI", function() { return _lib_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["MI"]; });

/* harmony import */ var _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculateProposed", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["CalculateProposed"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formula", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["Formula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VariableWalkContext", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["VariableWalkContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormulasCache", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["FormulasCache"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CycleDescription", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["CycleDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CycleResolution", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["CycleResolution"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VariableInputState", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["VariableInputState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInput", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["CycleResolutionInput"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WalkState", function() { return _lib_ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_13__["WalkState"]; });

/* harmony import */ var _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/ChronoGraph/graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OnCycleAction", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["OnCycleAction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WalkSource", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["WalkSource"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NOT_VISITED", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["NOT_VISITED"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VISITED_TOPOLOGICALLY", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["VISITED_TOPOLOGICALLY"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WalkContext", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["WalkContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cycleInfo", function() { return _lib_ChronoGraph_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["cycleInfo"]; });

/* harmony import */ var _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/ChronoGraph/primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextSync", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["ContextSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextGen", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["ContextGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculationGen", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["CalculationGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SynchronousCalculationStarted", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["SynchronousCalculationStarted"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculationSync", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["CalculationSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "runGeneratorSyncWithEffect", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["runGeneratorSyncWithEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "runGeneratorAsyncWithEffect", function() { return _lib_ChronoGraph_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_15__["runGeneratorAsyncWithEffect"]; });

/* harmony import */ var _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Entity", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["Entity"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createEntityOnPrototype", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["createEntityOnPrototype"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ensureEntityOnPrototype", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["ensureEntityOnPrototype"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generic_field", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["generic_field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "field", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "calculate", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["calculate"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "write", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["write"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "build_proposed", function() { return _lib_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_16__["build_proposed"]; });

/* harmony import */ var _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../lib/ChronoGraph/replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FieldIdentifier", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["FieldIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierSync", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["MinimalFieldIdentifierSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierGen", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["MinimalFieldIdentifierGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldVariable", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["MinimalFieldVariable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EntityIdentifier", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["EntityIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalEntityIdentifier", function() { return _lib_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_17__["MinimalEntityIdentifier"]; });

/* harmony import */ var _lib_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../lib/ChronoGraph/replica/Reference.js */ "./lib/ChronoGraph/replica/Reference.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceField", function() { return _lib_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_18__["ReferenceField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reference", function() { return _lib_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_18__["reference"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceIdentifier", function() { return _lib_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_18__["ReferenceIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceIdentifier", function() { return _lib_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_18__["MinimalReferenceIdentifier"]; });

/* harmony import */ var _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../lib/ChronoGraph/replica/ReferenceBucket.js */ "./lib/ChronoGraph/replica/ReferenceBucket.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketField", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["ReferenceBucketField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bucket", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["bucket"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketQuark", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["ReferenceBucketQuark"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketQuark", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["MinimalReferenceBucketQuark"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketIdentifier", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["ReferenceBucketIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketIdentifier", function() { return _lib_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_19__["MinimalReferenceBucketIdentifier"]; });

/* harmony import */ var _lib_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../lib/ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReadMode", function() { return _lib_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_20__["ReadMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Replica", function() { return _lib_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_20__["Replica"]; });

/* harmony import */ var _lib_ChronoGraph_schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../lib/ChronoGraph/schema/EntityMeta.js */ "./lib/ChronoGraph/schema/EntityMeta.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EntityMeta", function() { return _lib_ChronoGraph_schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_21__["EntityMeta"]; });

/* harmony import */ var _lib_ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../lib/ChronoGraph/schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoField", function() { return _lib_ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_22__["Field"]; });

/* harmony import */ var _lib_ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../lib/ChronoGraph/schema/Schema.js */ "./lib/ChronoGraph/schema/Schema.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Schema", function() { return _lib_ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_23__["Schema"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "entityDecoratorBody", function() { return _lib_ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_23__["entityDecoratorBody"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "entity", function() { return _lib_ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_23__["entity"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarIteratorResult", function() { return _lib_Engine_calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_24__["CalendarIteratorResult"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarCache", function() { return _lib_Engine_calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_24__["CalendarCache"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarCacheInterval.js */ "./lib/Engine/calendar/CalendarCacheInterval.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheInterval", function() { return _lib_Engine_calendar_CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_25__["CalendarCacheInterval"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarCacheIntervalMultiple.js */ "./lib/Engine/calendar/CalendarCacheIntervalMultiple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheIntervalMultiple", function() { return _lib_Engine_calendar_CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_26__["CalendarCacheIntervalMultiple"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarCacheMultiple.js */ "./lib/Engine/calendar/CalendarCacheMultiple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheMultiple", function() { return _lib_Engine_calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_27__["CalendarCacheMultiple"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineCalendars", function() { return _lib_Engine_calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_27__["combineCalendars"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarCacheSingle.js */ "./lib/Engine/calendar/CalendarCacheSingle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheSingle", function() { return _lib_Engine_calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_28__["CalendarCacheSingle"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalMixin", function() { return _lib_Engine_calendar_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_29__["CalendarIntervalMixin"]; });

/* harmony import */ var _lib_Engine_calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../lib/Engine/calendar/CalendarIntervalStore.js */ "./lib/Engine/calendar/CalendarIntervalStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalStore", function() { return _lib_Engine_calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_30__["CalendarIntervalStore"]; });

/* harmony import */ var _lib_Engine_calendar_IntervalCache_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../lib/Engine/calendar/IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntervalCache", function() { return _lib_Engine_calendar_IntervalCache_js__WEBPACK_IMPORTED_MODULE_31__["IntervalCache"]; });

/* harmony import */ var _lib_Engine_calendar_SortedMap_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../lib/Engine/calendar/SortedMap.js */ "./lib/Engine/calendar/SortedMap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IndexPosition", function() { return _lib_Engine_calendar_SortedMap_js__WEBPACK_IMPORTED_MODULE_32__["IndexPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SortedMap", function() { return _lib_Engine_calendar_SortedMap_js__WEBPACK_IMPORTED_MODULE_32__["SortedMap"]; });

/* harmony import */ var _lib_Engine_calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../lib/Engine/calendar/UnspecifiedTimeIntervalModel.js */ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnspecifiedTimeIntervalModel", function() { return _lib_Engine_calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_33__["UnspecifiedTimeIntervalModel"]; });

/* harmony import */ var _lib_Engine_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../lib/Engine/chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoModelMixin", function() { return _lib_Engine_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_34__["ChronoModelMixin"]; });

/* harmony import */ var _lib_Engine_chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../lib/Engine/chrono/Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConflictSymbol", function() { return _lib_Engine_chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_35__["ConflictSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConflictResolutionResult", function() { return _lib_Engine_chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_35__["ConflictResolutionResult"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConflictEffect", function() { return _lib_Engine_chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_35__["ConflictEffect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConflictResolution", function() { return _lib_Engine_chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_35__["ConflictResolution"]; });

/* harmony import */ var _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../lib/Engine/chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KEEP_TRYING_TO_RESOLVE", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["KEEP_TRYING_TO_RESOLVE"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isSerializableEqual", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["isSerializableEqual"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelField", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ModelField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelReferenceField", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ModelReferenceField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelBucketField", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ModelBucketField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsChronoModelSymbol", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["IsChronoModelSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoModelFieldIdentifier", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ChronoModelFieldIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldQuark", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ChronoModelReferenceFieldQuark"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldIdentifier", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ChronoModelReferenceFieldIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceBucketFieldIdentifier", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ChronoModelReferenceBucketFieldIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierSync", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["MinimalChronoModelFieldIdentifierSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierGen", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["MinimalChronoModelFieldIdentifierGen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldVariable", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["MinimalChronoModelFieldVariable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "model_field", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["model_field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "injectStaticFieldsProperty", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["injectStaticFieldsProperty"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getDecoratedModelFields", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["getDecoratedModelFields"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dateConverter", function() { return _lib_Engine_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["dateConverter"]; });

/* harmony import */ var _lib_Engine_chrono_Replica_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../lib/Engine/chrono/Replica.js */ "./lib/Engine/chrono/Replica.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EngineRevision", function() { return _lib_Engine_chrono_Replica_js__WEBPACK_IMPORTED_MODULE_37__["EngineRevision"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EngineTransaction", function() { return _lib_Engine_chrono_Replica_js__WEBPACK_IMPORTED_MODULE_37__["EngineTransaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EngineReplica", function() { return _lib_Engine_chrono_Replica_js__WEBPACK_IMPORTED_MODULE_37__["EngineReplica"]; });

/* harmony import */ var _lib_Engine_quark_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../lib/Engine/quark/AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectGenericMixin", function() { return _lib_Engine_quark_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_38__["AbstractPartOfProjectGenericMixin"]; });

/* harmony import */ var _lib_Engine_quark_ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../lib/Engine/quark/ChronoPartOfProjectGenericMixin.js */ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectGenericMixin", function() { return _lib_Engine_quark_ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_39__["ChronoPartOfProjectGenericMixin"]; });

/* harmony import */ var _lib_Engine_quark_CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../lib/Engine/quark/CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectGenericMixin", function() { return _lib_Engine_quark_CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_40__["CorePartOfProjectGenericMixin"]; });

/* harmony import */ var _lib_Engine_quark_Types_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../lib/Engine/quark/Types.js */ "./lib/Engine/quark/Types.js");
/* harmony import */ var _lib_Engine_quark_Types_js__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_lib_Engine_quark_Types_js__WEBPACK_IMPORTED_MODULE_41__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _lib_Engine_quark_Types_js__WEBPACK_IMPORTED_MODULE_41__) if(["default","EdgeTypeNormal","EdgeTypePast","ChronoTransaction","ChronoBase","ChronoField","later","CycleResolutionInputChrono","BreakCurrentStackExecution","Effect","ProposedOrPreviousSymbol","ProposedOrPrevious","RejectSymbol","RejectEffect","Reject","TransactionSymbol","GetTransaction","OwnQuarkSymbol","OwnQuark","OwnIdentifierSymbol","OwnIdentifier","WriteSymbol","WriteEffect","Write","WriteSeveralSymbol","WriteSeveralEffect","WriteSeveral","PreviousValueOfSymbol","PreviousValueOfEffect","PreviousValueOf","ProposedValueOfSymbol","ProposedValueOfEffect","ProposedValueOf","HasProposedValueSymbol","HasProposedValueEffect","HasProposedValue","ProposedOrPreviousValueOfSymbol","ProposedOrPreviousValueOfEffect","ProposedOrPreviousValueOf","ProposedArgumentsOfSymbol","ProposedArgumentsOfEffect","ProposedArgumentsOf","UnsafeProposedOrPreviousValueOfSymbol","UnsafeProposedOrPreviousValueOfEffect","UnsafeProposedOrPreviousValueOf","UnsafePreviousValueOfSymbol","UnsafePreviousValueOfEffect","UnsafePreviousValueOf","CommitZero","Listener","ChronoGraph","Levels","Meta","Identifier","IdentifierC","QuarkSync","QuarkGen","Variable","VariableC","CalculatedValueSync","CalculatedValueSyncC","CalculatedValueGen","CalculatedValueGenC","throwUnknownIdentifier","EdgeType","Quark","TombStone","Revision","ComputationCycle","TransactionCycleDetectionWalkContext","TransactionWalkDepth","required","validateRequiredProperties","split","inBatchesBySize","filter","drop","every","some","map","reduce","uniqueOnly","uniqueOnlyBy","reverse","takeWhile","takeUntilIncluding","takeUntilExcluding","concat","concatIterable","ChainedIteratorClass","ChainedIterator","CI","MemoizedIteratorClass","MemoizedIterator","MI","CalculateProposed","Formula","VariableWalkContext","FormulasCache","CycleDescription","CycleResolution","VariableInputState","CycleResolutionInput","WalkState","OnCycleAction","WalkSource","NOT_VISITED","VISITED_TOPOLOGICALLY","WalkContext","cycleInfo","ContextSync","ContextGen","CalculationGen","SynchronousCalculationStarted","CalculationSync","runGeneratorSyncWithEffect","runGeneratorAsyncWithEffect","Entity","createEntityOnPrototype","ensureEntityOnPrototype","generic_field","field","calculate","write","build_proposed","FieldIdentifier","MinimalFieldIdentifierSync","MinimalFieldIdentifierGen","MinimalFieldVariable","EntityIdentifier","MinimalEntityIdentifier","ReferenceField","reference","ReferenceIdentifier","MinimalReferenceIdentifier","ReferenceBucketField","bucket","ReferenceBucketQuark","MinimalReferenceBucketQuark","ReferenceBucketIdentifier","MinimalReferenceBucketIdentifier","ReadMode","Replica","EntityMeta","Schema","entityDecoratorBody","entity","CalendarIteratorResult","CalendarCache","CalendarCacheInterval","CalendarCacheIntervalMultiple","CalendarCacheMultiple","combineCalendars","CalendarCacheSingle","CalendarIntervalMixin","CalendarIntervalStore","IntervalCache","IndexPosition","SortedMap","UnspecifiedTimeIntervalModel","ChronoModelMixin","ConflictSymbol","ConflictResolutionResult","ConflictEffect","ConflictResolution","KEEP_TRYING_TO_RESOLVE","isSerializableEqual","ModelField","ModelReferenceField","ModelBucketField","IsChronoModelSymbol","ChronoModelFieldIdentifier","ChronoModelReferenceFieldQuark","ChronoModelReferenceFieldIdentifier","ChronoModelReferenceBucketFieldIdentifier","MinimalChronoModelFieldIdentifierSync","MinimalChronoModelFieldIdentifierGen","MinimalChronoModelFieldVariable","model_field","injectStaticFieldsProperty","getDecoratedModelFields","dateConverter","EngineRevision","EngineTransaction","EngineReplica","AbstractPartOfProjectGenericMixin","ChronoPartOfProjectGenericMixin","CorePartOfProjectGenericMixin"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _lib_Engine_quark_Types_js__WEBPACK_IMPORTED_MODULE_41__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _lib_Engine_quark_model_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../lib/Engine/quark/model/AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarMixin", function() { return _lib_Engine_quark_model_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_42__["AbstractCalendarMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../lib/Engine/quark/model/AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractHasAssignmentsMixin", function() { return _lib_Engine_quark_model_AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_43__["AbstractHasAssignmentsMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../lib/Engine/quark/model/AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return _lib_Engine_quark_model_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_44__["EventsWrapper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return _lib_Engine_quark_model_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_44__["DelayableWrapper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractProjectMixin", function() { return _lib_Engine_quark_model_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_44__["AbstractProjectMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectModelMixin", function() { return _lib_Engine_quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_45__["AbstractPartOfProjectModelMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectModelMixin", function() { return _lib_Engine_quark_model_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_46__["ChronoPartOfProjectModelMixin"]; });

/* harmony import */ var _lib_Engine_quark_model_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectModelMixin", function() { return _lib_Engine_quark_model_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_47__["CorePartOfProjectModelMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../lib/Engine/quark/store/AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractAssignmentStoreMixin", function() { return _lib_Engine_quark_store_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_48__["AbstractAssignmentStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarManagerStoreMixin", function() { return _lib_Engine_quark_store_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__["AbstractCalendarManagerStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../lib/Engine/quark/store/AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractDependencyStoreMixin", function() { return _lib_Engine_quark_store_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_50__["AbstractDependencyStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../lib/Engine/quark/store/AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractEventStoreMixin", function() { return _lib_Engine_quark_store_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__["AbstractEventStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../lib/Engine/quark/store/AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractResourceStoreMixin", function() { return _lib_Engine_quark_store_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_52__["AbstractResourceStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../lib/Engine/quark/store/ChronoAssignmentStoreMixin.js */ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoAssignmentStoreMixin", function() { return _lib_Engine_quark_store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_53__["ChronoAssignmentStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoCalendarManagerStoreMixin", function() { return _lib_Engine_quark_store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_54__["ChronoCalendarManagerStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../lib/Engine/quark/store/ChronoDependencyStoreMixin.js */ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoDependencyStoreMixin", function() { return _lib_Engine_quark_store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_55__["ChronoDependencyStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../lib/Engine/quark/store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoEventStoreMixin", function() { return _lib_Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_56__["ChronoEventStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoEventTreeStoreMixin", function() { return _lib_Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_56__["ChronoEventTreeStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../lib/Engine/quark/store/ChronoResourceStoreMixin.js */ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoResourceStoreMixin", function() { return _lib_Engine_quark_store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_57__["ChronoResourceStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../lib/Engine/quark/store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentStoreMixin", function() { return _lib_Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_58__["CoreAssignmentStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarManagerStoreMixin", function() { return _lib_Engine_quark_store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_59__["CoreCalendarManagerStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../lib/Engine/quark/store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyStoreMixin", function() { return _lib_Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_60__["CoreDependencyStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../lib/Engine/quark/store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoreEventStoreMixin", function() { return _lib_Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_61__["CoreEventStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../lib/Engine/quark/store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoreResourceStoreMixin", function() { return _lib_Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_62__["CoreResourceStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectStoreMixin", function() { return _lib_Engine_quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_63__["AbstractPartOfProjectStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectStoreMixin", function() { return _lib_Engine_quark_store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_64__["ChronoPartOfProjectStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_mixin_ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../lib/Engine/quark/store/mixin/ChronoStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChronoStoreMixin", function() { return _lib_Engine_quark_store_mixin_ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_65__["ChronoStoreMixin"]; });

/* harmony import */ var _lib_Engine_quark_store_mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectStoreMixin", function() { return _lib_Engine_quark_store_mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_66__["CorePartOfProjectStoreMixin"]; });

/* harmony import */ var _lib_Engine_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../lib/Engine/scheduling/DateInterval.js */ "./lib/Engine/scheduling/DateInterval.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateInterval", function() { return _lib_Engine_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_67__["DateInterval"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EMPTY_INTERVAL", function() { return _lib_Engine_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_67__["EMPTY_INTERVAL"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "intersectIntervals", function() { return _lib_Engine_scheduling_DateInterval_js__WEBPACK_IMPORTED_MODULE_67__["intersectIntervals"]; });

/* harmony import */ var _lib_Engine_scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../lib/Engine/scheduling/DurationConverterMixin.js */ "./lib/Engine/scheduling/DurationConverterMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationConverterMixin", function() { return _lib_Engine_scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_68__["DurationConverterMixin"]; });

/* harmony import */ var _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../lib/Engine/scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeUnit", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["TimeUnit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstraintType", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["ConstraintType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulingMode", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["SchedulingMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyValidationResult", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["DependencyValidationResult"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyType", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["DependencyType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependenciesCalendar", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["DependenciesCalendar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectType", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["ProjectType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Direction", function() { return _lib_Engine_scheduling_Types_js__WEBPACK_IMPORTED_MODULE_69__["Direction"]; });

/* harmony import */ var _lib_Engine_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../lib/Engine/util/BinarySearch.js */ "./lib/Engine/util/BinarySearch.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return _lib_Engine_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_70__["binarySearch"]; });

/* harmony import */ var _lib_Engine_util_Constants_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../lib/Engine/util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIN_DATE", function() { return _lib_Engine_util_Constants_js__WEBPACK_IMPORTED_MODULE_71__["MIN_DATE"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAX_DATE", function() { return _lib_Engine_util_Constants_js__WEBPACK_IMPORTED_MODULE_71__["MAX_DATE"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isDateFinite", function() { return _lib_Engine_util_Constants_js__WEBPACK_IMPORTED_MODULE_71__["isDateFinite"]; });

/* harmony import */ var _lib_Engine_util_Functions_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../lib/Engine/util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isNotNumber", function() { return _lib_Engine_util_Functions_js__WEBPACK_IMPORTED_MODULE_72__["isNotNumber"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CIFromSetOrArrayOrValue", function() { return _lib_Engine_util_Functions_js__WEBPACK_IMPORTED_MODULE_72__["CIFromSetOrArrayOrValue"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return _lib_Engine_util_Functions_js__WEBPACK_IMPORTED_MODULE_72__["delay"]; });

/* harmony import */ var _lib_Engine_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../lib/Engine/util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "stripDuplicates", function() { return _lib_Engine_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_73__["stripDuplicates"]; });

/* harmony import */ var _lib_Engine_util_Types_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../lib/Engine/util/Types.js */ "./lib/Engine/util/Types.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EdgeInclusion", function() { return _lib_Engine_util_Types_js__WEBPACK_IMPORTED_MODULE_74__["EdgeInclusion"]; });

var productName = 'gantt'; //region 3-rd party

 // endregion
// region ChronoGraph
// chrono









 // class


 // collection

 // cycle_resolver

 // graph

 // primitives

 // replica





 // schema



 // endregion
//region Engine
// calendar










 // chrono




 // quark




 // quark/model



 // quark/model/mixin



 // quark/store















 // quark/store/mixin




 // scheduling



 // util





 //endregion

/***/ }),

/***/ "./webpack/webpack.entry.js":
/*!**********************************!*\
  !*** ./webpack/webpack.entry.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.core.entry.js */ "./webpack/webpack.core.entry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Base"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Config"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["GlobalEvents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomDataStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Duration"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Store"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["IntegerDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreChained", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreChained"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreCRUD", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreCRUD"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreFilter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreGroup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreRelation", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreRelation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSearch", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSearch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSort", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSort"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreState", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSum", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSum"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSync", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreTree", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreTree"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TreeNode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ActionBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelStm", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateTrackingManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreStm", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Transaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ContextMenuBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AsyncHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BrowserHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CSSHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FunctionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["IdHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeMonitor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TemplateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["VersionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["WidgetHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XMLHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["XMLHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DemoBot"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomClassList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Formatter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Fullscreen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Objects"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Point"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Promissory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["RandomGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rectangle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scroller"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Localizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Delayable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Draggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Droppable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Events"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Factoryable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Featureable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Finalizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Hoverable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifiable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Identifiable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["InstancePlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadMaskable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LoadMaskable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Override"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Pluggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["State"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Animator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Animator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Bag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ClickRepeater"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Collection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionSorter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ScrollManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragTipProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DynamicObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DayTime", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DayTime"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Month"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Parser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedoBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["UndoRedoBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Button"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CalendarPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Checkbox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ChipView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Combo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Container"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DatePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateTimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DisplayField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DurationField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Editor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FileField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Label"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["List"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Mask"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Menu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["MenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["MessageDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PagingToolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Panel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapser", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapserOverlay", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapserOverlay"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseTool", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollapseTool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PasswordField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PickerField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Popup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Renderable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Ripple"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Slider"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideToggle", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["SlideToggle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Splitter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabBar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextAreaField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toast"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Widget"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Layout"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Badge"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Responsive", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Responsive"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotatable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rotatable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Styleable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Styleable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Histogram", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Histogram"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scale"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AvatarRendering", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AvatarRendering"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialButton", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialPanel"]; });

/* harmony import */ var _webpack_entry_engine_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./webpack.entry.engine.js */ "./webpack/webpack.entry.engine.js");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _webpack_entry_engine_js__WEBPACK_IMPORTED_MODULE_1__) if(["default","ActionColumn","AggregateColumn","CheckColumn","Column","DateColumn","NumberColumn","PercentColumn","RatingColumn","RowNumberColumn","TemplateColumn","TimeColumn","TreeColumn","WidgetColumn","ColumnStore","GridRowModel","GridCellEdit","CellMenu","CellTooltip","ColumnAutoWidth","ColumnDragToolbar","ColumnPicker","ColumnReorder","ColumnResize","ContextMenu","Filter","FilterBar","GridFeatureManager","Group","GridGroupSummary","HeaderMenu","QuickFind","RegionResize","RowCopyPaste","RowReorder","Search","Sort","StickyCells","Stripe","GridSummary","Tree","ExportDialog","Exporter","ExportOrientationCombo","ExportRowsCombo","LocalizableCombo","GridMultiPageExporter","GridMultiPageVerticalExporter","GridPdfExport","GridSinglePageExporter","FileFormat","Orientation","PaperFormat","RowsRange","GridExcelExporter","TableExporter","Row","Bar","Footer","Grid","GridBase","Header","RowManager","SubGrid","TreeGrid","GridElementEvents","GridFeatures","GridResponsive","GridSelection","GridState","GridSubGrids","AbstractCrudManager","AbstractCrudManagerMixin","AbstractCrudManagerValidation","AjaxTransport","JsonEncoder","CrudManagerView","SchedulerAssignmentStore","CrudManager","SchedulerDependencyStore","SchedulerEventStore","SchedulerResourceStore","ResourceTimeRangeStore","TimeAxis","AssignmentStoreMixin","AttachToProjectMixin","DependencyStoreMixin","EventStoreMixin","PartOfBaseProject","SchedulerPartOfProject","ProjectConsumer","SchedulerProjectCrudManager","RecurringEventsMixin","RecurringTimeSpansMixin","ResourceStoreMixin","SharedEventStoreMixin","DragCreateBase","EditBase","ResourceTimeRangesBase","TimeSpanMenuBase","TimeSpanRecordContextMenuBase","TooltipBase","DragBase","AbstractTimeRanges","ColumnLines","SchedulerDependencies","SchedulerDependencyEdit","EventContextMenu","EventCopyPaste","EventDrag","EventDragCreate","EventDragSelect","EventEdit","EventFilter","EventMenu","SchedulerEventResize","EventTooltip","GroupSummary","HeaderContextMenu","HeaderZoom","SchedulerLabels","NonWorkingTime","Pan","ResourceTimeRanges","ScheduleContext","ScheduleContextMenu","ScheduleMenu","ScheduleTooltip","SimpleEventEdit","StickyEvents","SchedulerSummary","TimelineSummary","TimeAxisHeaderMenu","TimeRanges","DependencyCreation","RecurringEventEdit","SchedulerMultiPageExporter","SchedulerMultiPageVerticalExporter","SchedulerPdfExport","ScheduleRangeCombo","SchedulerExportDialog","SchedulerSinglePageExporter","ScheduleRange","ExcelExporter","ResourceCollapseColumn","ResourceInfoColumn","SchedulerTimeAxisColumn","SchedulerAssignmentModel","DependencyBaseModel","SchedulerDependencyModel","SchedulerEventModel","SchedulerProjectModel","RecurrenceModel","SchedulerResourceModel","ResourceTimeRangeModel","TimeSpan","AssignmentModelMixin","EventModelMixin","ProjectModelMixin","RecurringTimeSpan","ResourceModelMixin","PresetManager","PresetStore","ViewPreset","RectangularPathFinder","ScheduleTableExporter","HorizontalTimeAxis","TimeAxisSubGrid","Scheduler","SchedulerBase","TimeAxisViewModel","TimelineBase","ResourceHeader","EventNavigation","EventSelection","RecurringEvents","SchedulerDom","SchedulerDomEvents","SchedulerEventRendering","SchedulerRegions","SchedulerScroll","SchedulerState","SchedulerStores","TimelineDateMapper","TimelineDomEvents","TimelineEventRendering","TimelineScroll","TimelineViewPresets","TimelineZoomable","RecurrenceCombo","RecurrenceConfirmationPopup","RecurrenceDaysButtonGroup","RecurrenceDaysCombo","RecurrenceEditor","RecurrenceFrequencyCombo","RecurrenceLegendButton","RecurrenceMonthDaysButtonGroup","RecurrenceMonthsButtonGroup","RecurrencePositionsCombo","RecurrenceStopConditionCombo","ResourceCombo","ResourceFilter","UndoRedo","TimelineBaseTag","SchedulerProAssignmentStore","SchedulerProCalendarManagerStore","SchedulerProDependencyStore","EventStore","SchedulerProResourceStore","PartOfProject","ProjectCrudManager","SchedulerProAssignmentModel","SchedulerProCalendarIntervalModel","SchedulerProCalendarModel","SchedulerProDependencyModel","EventModel","SchedulerProProjectModel","SchedulerProResourceModel","PercentDoneMixin","DurationColumn","ResourceCalendarColumn","ScaleColumn","ProTaskEditStm","CalendarField","ConstraintTypePicker","DependencyTypePicker","EffortField","EndDateField","GanttTaskEditor","ModelCombo","SchedulerTaskEditor","SchedulingModePicker","StartDateField","TaskEditorBase","Timeline","AdvancedTab","DependencyTab","EditorTab","FormTab","GeneralTab","NotesTab","PredecessorsTab","ResourcesTab","SchedulerAdvancedTab","SchedulerGeneralTab","SuccessorsTab","EventLoader","ReadyStatePropagator","EventResize","PercentBar","ResourceNonWorkingTime","SchedulerProTaskEdit","Summary","ProHorizontalLayout","ProHorizontalLayoutStack","SchedulerProEventRendering","ResourceHistogram","SchedulerProBase","SchedulerPro","AddNewColumn","AllColumns","CalendarColumn","ConstraintDateColumn","ConstraintTypeColumn","DeadlineDateColumn","DependencyColumn","EarlyEndDateColumn","EarlyStartDateColumn","EffortColumn","EndDateColumn","EventModeColumn","GanttDateColumn","InactiveColumn","LateEndDateColumn","LateStartDateColumn","ManuallyScheduledColumn","MilestoneColumn","NameColumn","NoteColumn","PercentDoneColumn","PredecessorColumn","ResourceAssignmentColumn","ResourceAssignmentGridResourceColumn","RollupColumn","SchedulingModeColumn","SequenceColumn","ShowInTimelineColumn","StartDateColumn","SuccessorColumn","TimeAxisColumn","TotalSlackColumn","WBSColumn","AssignmentsManipulationStore","AssignmentStore","CalendarManagerStore","DependencyStore","ResourceStore","TaskStore","Wbs","WbsField","Baselines","CellEdit","CriticalPaths","Dependencies","DependencyEdit","Indicators","Labels","ProgressLine","ProjectLines","Rollups","TaskContextMenu","TaskCopyPaste","TaskDrag","TaskDragCreate","TaskEdit","TaskMenu","TaskResize","TaskTooltip","MultiPageExporter","MultiPageVerticalExporter","PdfExport","SinglePageExporter","AssignmentModel","Baseline","CalendarIntervalModel","CalendarModel","DependencyModel","ProjectModel","ResourceModel","TaskModel","ProjectGenerator","ResourceAssignmentParser","AssignmentField","AssignmentGrid","AssignmentPicker","CalendarPicker","DependencyField","TaskEditor","GanttMspExport","MspExport","GanttDom","GanttRegions","GanttScroll","GanttState","GanttStores","GanttTimelineDateMapper","TaskNavigation","Gantt","GanttBase","Base","Config","GlobalEvents","AjaxStore","DomDataStore","Duration","Model","Store","ArrayDataField","BooleanDataField","DataField","DateDataField","IntegerDataField","ModelDataField","NumberDataField","ObjectDataField","StringDataField","StoreChained","StoreCRUD","StoreFilter","StoreGroup","StoreProxy","StoreRelation","StoreSearch","StoreSort","StoreState","StoreSum","StoreSync","StoreTree","TreeNode","ActionBase","ModelStm","StateBase","StateTrackingManager","StoreStm","Transaction","ContextMenuBase","AjaxHelper","ArrayHelper","AsyncHelper","BrowserHelper","CSSHelper","DateHelper","DomHelper","DomSync","DragHelper","EventHelper","FunctionHelper","IdHelper","ObjectHelper","ResizeHelper","ResizeMonitor","StringHelper","TemplateHelper","VersionHelper","WidgetHelper","XMLHelper","DataGenerator","DemoBot","DomClassList","Formatter","Fullscreen","NumberFormat","Objects","Point","Promissory","RandomGenerator","Rectangle","Scroller","LocaleHelper","LocaleManager","Localizable","Delayable","Draggable","Droppable","Events","Factoryable","Featureable","Finalizable","Hoverable","Identifiable","InstancePlugin","LoadMaskable","Override","Pluggable","State","Animator","Bag","ClickRepeater","Collection","CollectionFilter","CollectionSorter","ScrollManager","DragContext","DragProxy","DragTipProxy","DynamicObject","DayTime","Month","Parser","UndoRedoBase","BooleanCombo","Button","ButtonGroup","CalendarPanel","Checkbox","ChipView","Combo","Container","DateField","DatePicker","DateTimeField","DisplayField","DurationField","Editor","Field","FileField","FilePicker","FilterField","Label","List","Mask","Menu","MenuItem","MessageDialog","NumberField","PagingToolbar","Panel","PanelCollapser","PanelCollapserOverlay","CollapseTool","PasswordField","PickerField","Popup","Renderable","Ripple","Slider","SlideToggle","Splitter","Tab","TabBar","TabPanel","TextAreaField","TextField","TimeField","TimePicker","Toast","Tool","Toolbar","Tooltip","Widget","Layout","Badge","Responsive","Rotatable","Styleable","Toolable","Histogram","Scale","AvatarRendering","TrialButton","TrialPanel"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _webpack_entry_engine_js__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./webpack.entry.engine.gantt.js */ "./webpack/webpack.entry.engine.gantt.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttProjectMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["GanttProjectMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstrainedByParentMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["ConstrainedByParentMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstrainedLateEventMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["ConstrainedLateEventMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttAssignmentMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["GanttAssignmentMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttEvent", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["GanttEvent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttHasAssignmentsMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["GanttHasAssignmentsMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasCriticalPathsMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["HasCriticalPathsMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffortVar", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["EffortVar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitsVar", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["UnitsVar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "effortFormula", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["effortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unitsFormula", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["unitsFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endDateByEffortFormula", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["endDateByEffortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startDateByEffortFormula", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["startDateByEffortFormula"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcher", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["SEDWUDispatcher"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SEDWUDispatcherIdentifier", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["SEDWUDispatcherIdentifier"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasEffortMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["HasEffortMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HasSchedulingModeMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["HasSchedulingModeMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduledByDependenciesLateEventMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["ScheduledByDependenciesLateEventMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUGraphDescription", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedDurationSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardNonEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedDurationSEDWUForwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUForwardEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedDurationSEDWUForwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardNonEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedDurationSEDWUBackwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedDurationSEDWUBackwardEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedDurationSEDWUBackwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedDurationMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["FixedDurationMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUGraphDescription", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedEffortSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUForward", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedEffortSEDWUForward"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedEffortSEDWUBackward", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedEffortSEDWUBackward"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedEffortMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["FixedEffortMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUGraphDescription", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedUnitsSEDWUGraphDescription"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardNonEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedUnitsSEDWUForwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUForwardEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedUnitsSEDWUForwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardNonEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedUnitsSEDWUBackwardNonEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fixedUnitsSEDWUBackwardEffortDriven", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["fixedUnitsSEDWUBackwardEffortDriven"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FixedUnitsMixin", function() { return _webpack_entry_engine_gantt_js__WEBPACK_IMPORTED_MODULE_2__["FixedUnitsMixin"]; });

/* harmony import */ var _lib_Grid_column_ActionColumn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/Grid/column/ActionColumn.js */ "./lib/Grid/column/ActionColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionColumn", function() { return _lib_Grid_column_ActionColumn_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _lib_Grid_column_AggregateColumn_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/Grid/column/AggregateColumn.js */ "./lib/Grid/column/AggregateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AggregateColumn", function() { return _lib_Grid_column_AggregateColumn_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckColumn", function() { return _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/Grid/column/DateColumn.js */ "./lib/Grid/column/DateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateColumn", function() { return _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _lib_Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/Grid/column/NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberColumn", function() { return _lib_Grid_column_NumberColumn_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/Grid/column/PercentColumn.js */ "./lib/Grid/column/PercentColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentColumn", function() { return _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/Grid/column/RatingColumn.js */ "./lib/Grid/column/RatingColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingColumn", function() { return _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/Grid/column/RowNumberColumn.js */ "./lib/Grid/column/RowNumberColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowNumberColumn", function() { return _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/Grid/column/TemplateColumn.js */ "./lib/Grid/column/TemplateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateColumn", function() { return _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/Grid/column/TimeColumn.js */ "./lib/Grid/column/TimeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeColumn", function() { return _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/Grid/column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeColumn", function() { return _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/Grid/column/WidgetColumn.js */ "./lib/Grid/column/WidgetColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetColumn", function() { return _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnStore", function() { return _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../lib/Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridRowModel", function() { return _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../lib/Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridCellEdit", function() { return _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../lib/Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellMenu", function() { return _lib_Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../lib/Grid/feature/CellTooltip.js */ "./lib/Grid/feature/CellTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellTooltip", function() { return _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../lib/Grid/feature/ColumnAutoWidth.js */ "./lib/Grid/feature/ColumnAutoWidth.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnAutoWidth", function() { return _lib_Grid_feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../lib/Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnDragToolbar", function() { return _lib_Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../lib/Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnPicker", function() { return _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../lib/Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnReorder", function() { return _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../lib/Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnResize", function() { return _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../lib/Grid/feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../lib/Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../lib/Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterBar", function() { return _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../lib/Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridFeatureManager", function() { return _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../lib/Grid/feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _lib_Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../lib/Grid/feature/GroupSummary.js */ "./lib/Grid/feature/GroupSummary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridGroupSummary", function() { return _lib_Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _lib_Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../lib/Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderMenu", function() { return _lib_Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../lib/Grid/feature/QuickFind.js */ "./lib/Grid/feature/QuickFind.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuickFind", function() { return _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../lib/Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegionResize", function() { return _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _lib_Grid_feature_RowCopyPaste_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../lib/Grid/feature/RowCopyPaste.js */ "./lib/Grid/feature/RowCopyPaste.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowCopyPaste", function() { return _lib_Grid_feature_RowCopyPaste_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../lib/Grid/feature/RowReorder.js */ "./lib/Grid/feature/RowReorder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowReorder", function() { return _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../lib/Grid/feature/Search.js */ "./lib/Grid/feature/Search.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Search", function() { return _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../lib/Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sort", function() { return _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _lib_Grid_feature_StickyCells_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../lib/Grid/feature/StickyCells.js */ "./lib/Grid/feature/StickyCells.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StickyCells", function() { return _lib_Grid_feature_StickyCells_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../lib/Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stripe", function() { return _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _lib_Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../lib/Grid/feature/Summary.js */ "./lib/Grid/feature/Summary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSummary", function() { return _lib_Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../lib/Grid/feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _lib_Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../lib/Grid/view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportDialog", function() { return _lib_Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_Exporter_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../lib/Grid/feature/export/exporter/Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Exporter", function() { return _lib_Grid_feature_export_exporter_Exporter_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../lib/Grid/view/export/field/ExportOrientationCombo.js */ "./lib/Grid/view/export/field/ExportOrientationCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportOrientationCombo", function() { return _lib_Grid_view_export_field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../lib/Grid/view/export/field/ExportRowsCombo.js */ "./lib/Grid/view/export/field/ExportRowsCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportRowsCombo", function() { return _lib_Grid_view_export_field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../lib/Grid/view/export/field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableCombo", function() { return _lib_Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../lib/Grid/feature/export/exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageExporter", function() { return _lib_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageVerticalExporter", function() { return _lib_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../lib/Grid/feature/export/PdfExport.js */ "./lib/Grid/feature/export/PdfExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridPdfExport", function() { return _lib_Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../lib/Grid/feature/export/exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSinglePageExporter", function() { return _lib_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../lib/Grid/feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileFormat", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_52__["FileFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Orientation", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_52__["Orientation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PaperFormat", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_52__["PaperFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowsRange", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_52__["RowsRange"]; });

/* harmony import */ var _lib_Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../lib/Grid/feature/experimental/ExcelExporter.js */ "./lib/Grid/feature/experimental/ExcelExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridExcelExporter", function() { return _lib_Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _lib_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../lib/Grid/util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableExporter", function() { return _lib_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _lib_Grid_row_Row_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../lib/Grid/row/Row.js */ "./lib/Grid/row/Row.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return _lib_Grid_row_Row_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _lib_Grid_view_Bar_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../lib/Grid/view/Bar.js */ "./lib/Grid/view/Bar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bar", function() { return _lib_Grid_view_Bar_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _lib_Grid_view_Footer_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../lib/Grid/view/Footer.js */ "./lib/Grid/view/Footer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return _lib_Grid_view_Footer_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../lib/Grid/view/Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _lib_Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../lib/Grid/view/GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridBase", function() { return _lib_Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _lib_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../lib/Grid/view/Header.js */ "./lib/Grid/view/Header.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return _lib_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../lib/Grid/row/RowManager.js */ "./lib/Grid/row/RowManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowManager", function() { return _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _lib_Grid_view_SubGrid_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../lib/Grid/view/SubGrid.js */ "./lib/Grid/view/SubGrid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SubGrid", function() { return _lib_Grid_view_SubGrid_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../lib/Grid/view/TreeGrid.js */ "./lib/Grid/view/TreeGrid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeGrid", function() { return _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridElementEvents.js */ "./lib/Grid/view/mixin/GridElementEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridElementEvents", function() { return _lib_Grid_view_mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridFeatures.js */ "./lib/Grid/view/mixin/GridFeatures.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridFeatures", function() { return _lib_Grid_view_mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridResponsive.js */ "./lib/Grid/view/mixin/GridResponsive.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridResponsive", function() { return _lib_Grid_view_mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridSelection.js */ "./lib/Grid/view/mixin/GridSelection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSelection", function() { return _lib_Grid_view_mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridState_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridState.js */ "./lib/Grid/view/mixin/GridState.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridState", function() { return _lib_Grid_view_mixin_GridState_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _lib_Grid_view_mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../lib/Grid/view/mixin/GridSubGrids.js */ "./lib/Grid/view/mixin/GridSubGrids.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSubGrids", function() { return _lib_Grid_view_mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../lib/Scheduler/crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function() { return _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../lib/Scheduler/crud/AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerMixin", function() { return _lib_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js */ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerValidation", function() { return _lib_Scheduler_crud_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../lib/Scheduler/crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxTransport", function() { return _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../lib/Scheduler/crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonEncoder", function() { return _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../lib/Scheduler/crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManagerView", function() { return _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../lib/Scheduler/data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerAssignmentStore", function() { return _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../lib/Scheduler/data/CrudManager.js */ "./lib/Scheduler/data/CrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManager", function() { return _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../lib/Scheduler/data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDependencyStore", function() { return _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../lib/Scheduler/data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerEventStore", function() { return _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../lib/Scheduler/data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerResourceStore", function() { return _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../lib/Scheduler/data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function() { return _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony import */ var _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../lib/Scheduler/data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxis", function() { return _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStoreMixin", function() { return _lib_Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AttachToProjectMixin", function() { return _lib_Scheduler_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStoreMixin", function() { return _lib_Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStoreMixin", function() { return _lib_Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PartOfBaseProject", function() { return _lib_Scheduler_data_mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerPartOfProject", function() { return _lib_Scheduler_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/ProjectConsumer.js */ "./lib/Scheduler/data/mixin/ProjectConsumer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectConsumer", function() { return _lib_Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectCrudManager", function() { return _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventsMixin", function() { return _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpansMixin", function() { return _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStoreMixin", function() { return _lib_Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SharedEventStoreMixin", function() { return _lib_Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/DragCreateBase.js */ "./lib/Scheduler/feature/base/DragCreateBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragCreateBase", function() { return _lib_Scheduler_feature_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_EditBase_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/EditBase.js */ "./lib/Scheduler/feature/base/EditBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditBase", function() { return _lib_Scheduler_feature_base_EditBase_js__WEBPACK_IMPORTED_MODULE_96__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/ResourceTimeRangesBase.js */ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangesBase", function() { return _lib_Scheduler_feature_base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_97__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanMenuBase", function() { return _lib_Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_98__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanRecordContextMenuBase", function() { return _lib_Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_99__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TooltipBase", function() { return _lib_Scheduler_feature_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_100__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../lib/Scheduler/feature/base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragBase", function() { return _lib_Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_101__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../lib/Scheduler/feature/AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractTimeRanges", function() { return _lib_Scheduler_feature_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_102__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ../lib/Scheduler/feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnLines", function() { return _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_103__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ../lib/Scheduler/feature/Dependencies.js */ "./lib/Scheduler/feature/Dependencies.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDependencies", function() { return _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_104__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ../lib/Scheduler/feature/DependencyEdit.js */ "./lib/Scheduler/feature/DependencyEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDependencyEdit", function() { return _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_105__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventContextMenu.js */ "./lib/Scheduler/feature/EventContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventContextMenu", function() { return _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_106__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventCopyPaste_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventCopyPaste.js */ "./lib/Scheduler/feature/EventCopyPaste.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventCopyPaste", function() { return _lib_Scheduler_feature_EventCopyPaste_js__WEBPACK_IMPORTED_MODULE_107__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventDrag.js */ "./lib/Scheduler/feature/EventDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDrag", function() { return _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_108__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventDragCreate.js */ "./lib/Scheduler/feature/EventDragCreate.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragCreate", function() { return _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_109__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventDragSelect.js */ "./lib/Scheduler/feature/EventDragSelect.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragSelect", function() { return _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_110__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventEdit.js */ "./lib/Scheduler/feature/EventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventEdit", function() { return _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_111__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventFilter", function() { return _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_112__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventMenu", function() { return _lib_Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_113__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerEventResize", function() { return _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_114__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(/*! ../lib/Scheduler/feature/EventTooltip.js */ "./lib/Scheduler/feature/EventTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventTooltip", function() { return _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_115__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(/*! ../lib/Scheduler/feature/GroupSummary.js */ "./lib/Scheduler/feature/GroupSummary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GroupSummary", function() { return _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_116__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(/*! ../lib/Scheduler/feature/HeaderContextMenu.js */ "./lib/Scheduler/feature/HeaderContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderContextMenu", function() { return _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_117__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(/*! ../lib/Scheduler/feature/HeaderZoom.js */ "./lib/Scheduler/feature/HeaderZoom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderZoom", function() { return _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_118__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(/*! ../lib/Scheduler/feature/Labels.js */ "./lib/Scheduler/feature/Labels.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerLabels", function() { return _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_119__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(/*! ../lib/Scheduler/feature/NonWorkingTime.js */ "./lib/Scheduler/feature/NonWorkingTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NonWorkingTime", function() { return _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_120__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(/*! ../lib/Scheduler/feature/Pan.js */ "./lib/Scheduler/feature/Pan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pan", function() { return _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_121__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(/*! ../lib/Scheduler/feature/ResourceTimeRanges.js */ "./lib/Scheduler/feature/ResourceTimeRanges.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRanges", function() { return _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_122__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleContext_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(/*! ../lib/Scheduler/feature/ScheduleContext.js */ "./lib/Scheduler/feature/ScheduleContext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleContext", function() { return _lib_Scheduler_feature_ScheduleContext_js__WEBPACK_IMPORTED_MODULE_123__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(/*! ../lib/Scheduler/feature/ScheduleContextMenu.js */ "./lib/Scheduler/feature/ScheduleContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleContextMenu", function() { return _lib_Scheduler_feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_124__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(/*! ../lib/Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleMenu", function() { return _lib_Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_125__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(/*! ../lib/Scheduler/feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTooltip", function() { return _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_126__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(/*! ../lib/Scheduler/feature/SimpleEventEdit.js */ "./lib/Scheduler/feature/SimpleEventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleEventEdit", function() { return _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_127__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_StickyEvents_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(/*! ../lib/Scheduler/feature/StickyEvents.js */ "./lib/Scheduler/feature/StickyEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StickyEvents", function() { return _lib_Scheduler_feature_StickyEvents_js__WEBPACK_IMPORTED_MODULE_128__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(/*! ../lib/Scheduler/feature/Summary.js */ "./lib/Scheduler/feature/Summary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerSummary", function() { return _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_129__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_TimelineSummary_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(/*! ../lib/Scheduler/feature/TimelineSummary.js */ "./lib/Scheduler/feature/TimelineSummary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineSummary", function() { return _lib_Scheduler_feature_TimelineSummary_js__WEBPACK_IMPORTED_MODULE_130__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(/*! ../lib/Scheduler/feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisHeaderMenu", function() { return _lib_Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_131__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(/*! ../lib/Scheduler/feature/TimeRanges.js */ "./lib/Scheduler/feature/TimeRanges.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeRanges", function() { return _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_132__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(/*! ../lib/Scheduler/feature/mixin/DependencyCreation.js */ "./lib/Scheduler/feature/mixin/DependencyCreation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyCreation", function() { return _lib_Scheduler_feature_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_133__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(/*! ../lib/Scheduler/feature/mixin/RecurringEventEdit.js */ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventEdit", function() { return _lib_Scheduler_feature_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_134__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(/*! ../lib/Scheduler/feature/export/exporter/MultiPageExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerMultiPageExporter", function() { return _lib_Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_135__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(/*! ../lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerMultiPageVerticalExporter", function() { return _lib_Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_136__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(/*! ../lib/Scheduler/feature/export/PdfExport.js */ "./lib/Scheduler/feature/export/PdfExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerPdfExport", function() { return _lib_Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_137__["default"]; });

/* harmony import */ var _lib_Scheduler_view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(/*! ../lib/Scheduler/view/export/field/ScheduleRangeCombo.js */ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRangeCombo", function() { return _lib_Scheduler_view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_138__["default"]; });

/* harmony import */ var _lib_Scheduler_view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(/*! ../lib/Scheduler/view/export/SchedulerExportDialog.js */ "./lib/Scheduler/view/export/SchedulerExportDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerExportDialog", function() { return _lib_Scheduler_view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_139__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(/*! ../lib/Scheduler/feature/export/exporter/SinglePageExporter.js */ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerSinglePageExporter", function() { return _lib_Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_140__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(/*! ../lib/Scheduler/feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRange", function() { return _lib_Scheduler_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_141__["ScheduleRange"]; });

/* harmony import */ var _lib_Scheduler_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(/*! ../lib/Scheduler/feature/experimental/ExcelExporter.js */ "./lib/Scheduler/feature/experimental/ExcelExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExcelExporter", function() { return _lib_Scheduler_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_142__["default"]; });

/* harmony import */ var _lib_Scheduler_column_ResourceCollapseColumn_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(/*! ../lib/Scheduler/column/ResourceCollapseColumn.js */ "./lib/Scheduler/column/ResourceCollapseColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceCollapseColumn", function() { return _lib_Scheduler_column_ResourceCollapseColumn_js__WEBPACK_IMPORTED_MODULE_143__["default"]; });

/* harmony import */ var _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(/*! ../lib/Scheduler/column/ResourceInfoColumn.js */ "./lib/Scheduler/column/ResourceInfoColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceInfoColumn", function() { return _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_144__["default"]; });

/* harmony import */ var _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(/*! ../lib/Scheduler/column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerTimeAxisColumn", function() { return _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_145__["default"]; });

/* harmony import */ var _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(/*! ../lib/Scheduler/model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerAssignmentModel", function() { return _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_146__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(/*! ../lib/Scheduler/model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function() { return _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_147__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(/*! ../lib/Scheduler/model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDependencyModel", function() { return _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_148__["default"]; });

/* harmony import */ var _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(/*! ../lib/Scheduler/model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerEventModel", function() { return _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_149__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(/*! ../lib/Scheduler/model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectModel", function() { return _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_150__["default"]; });

/* harmony import */ var _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(/*! ../lib/Scheduler/model/RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceModel", function() { return _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_151__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(/*! ../lib/Scheduler/model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerResourceModel", function() { return _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_152__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(/*! ../lib/Scheduler/model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function() { return _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_153__["default"]; });

/* harmony import */ var _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(/*! ../lib/Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpan", function() { return _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_154__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModelMixin", function() { return _lib_Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_155__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModelMixin", function() { return _lib_Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_156__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModelMixin", function() { return _lib_Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_157__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpan", function() { return _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_158__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModelMixin", function() { return _lib_Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_159__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(/*! ../lib/Scheduler/preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetManager", function() { return _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_160__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(/*! ../lib/Scheduler/preset/PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetStore", function() { return _lib_Scheduler_preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_161__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(/*! ../lib/Scheduler/preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ViewPreset", function() { return _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_162__["default"]; });

/* harmony import */ var _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(/*! ../lib/Scheduler/util/RectangularPathFinder.js */ "./lib/Scheduler/util/RectangularPathFinder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RectangularPathFinder", function() { return _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_163__["default"]; });

/* harmony import */ var _lib_Scheduler_util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(/*! ../lib/Scheduler/util/ScheduleTableExporter.js */ "./lib/Scheduler/util/ScheduleTableExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTableExporter", function() { return _lib_Scheduler_util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_164__["default"]; });

/* harmony import */ var _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(/*! ../lib/Scheduler/view/HorizontalTimeAxis.js */ "./lib/Scheduler/view/HorizontalTimeAxis.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HorizontalTimeAxis", function() { return _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_165__["default"]; });

/* harmony import */ var _lib_Scheduler_view_TimeAxisSubGrid_js__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(/*! ../lib/Scheduler/view/TimeAxisSubGrid.js */ "./lib/Scheduler/view/TimeAxisSubGrid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisSubGrid", function() { return _lib_Scheduler_view_TimeAxisSubGrid_js__WEBPACK_IMPORTED_MODULE_166__["default"]; });

/* harmony import */ var _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(/*! ../lib/Scheduler/view/Scheduler.js */ "./lib/Scheduler/view/Scheduler.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_167__["default"]; });

/* harmony import */ var _lib_Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(/*! ../lib/Scheduler/view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerBase", function() { return _lib_Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_168__["default"]; });

/* harmony import */ var _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(/*! ../lib/Scheduler/view/model/TimeAxisViewModel.js */ "./lib/Scheduler/view/model/TimeAxisViewModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisViewModel", function() { return _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_169__["default"]; });

/* harmony import */ var _lib_Scheduler_view_TimelineBase_js__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(/*! ../lib/Scheduler/view/TimelineBase.js */ "./lib/Scheduler/view/TimelineBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineBase", function() { return _lib_Scheduler_view_TimelineBase_js__WEBPACK_IMPORTED_MODULE_170__["default"]; });

/* harmony import */ var _lib_Scheduler_view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(/*! ../lib/Scheduler/view/ResourceHeader.js */ "./lib/Scheduler/view/ResourceHeader.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceHeader", function() { return _lib_Scheduler_view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_171__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/EventNavigation.js */ "./lib/Scheduler/view/mixin/EventNavigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventNavigation", function() { return _lib_Scheduler_view_mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_172__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/EventSelection.js */ "./lib/Scheduler/view/mixin/EventSelection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventSelection", function() { return _lib_Scheduler_view_mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_173__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/RecurringEvents.js */ "./lib/Scheduler/view/mixin/RecurringEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEvents", function() { return _lib_Scheduler_view_mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_174__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerDom.js */ "./lib/Scheduler/view/mixin/SchedulerDom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDom", function() { return _lib_Scheduler_view_mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_175__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerDomEvents.js */ "./lib/Scheduler/view/mixin/SchedulerDomEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerDomEvents", function() { return _lib_Scheduler_view_mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_176__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerEventRendering.js */ "./lib/Scheduler/view/mixin/SchedulerEventRendering.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerEventRendering", function() { return _lib_Scheduler_view_mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_177__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerRegions.js */ "./lib/Scheduler/view/mixin/SchedulerRegions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerRegions", function() { return _lib_Scheduler_view_mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_178__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerScroll.js */ "./lib/Scheduler/view/mixin/SchedulerScroll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerScroll", function() { return _lib_Scheduler_view_mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_179__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerState.js */ "./lib/Scheduler/view/mixin/SchedulerState.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerState", function() { return _lib_Scheduler_view_mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_180__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/SchedulerStores.js */ "./lib/Scheduler/view/mixin/SchedulerStores.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerStores", function() { return _lib_Scheduler_view_mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_181__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineDateMapper.js */ "./lib/Scheduler/view/mixin/TimelineDateMapper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineDateMapper", function() { return _lib_Scheduler_view_mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_182__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineDomEvents.js */ "./lib/Scheduler/view/mixin/TimelineDomEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineDomEvents", function() { return _lib_Scheduler_view_mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_183__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineEventRendering.js */ "./lib/Scheduler/view/mixin/TimelineEventRendering.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineEventRendering", function() { return _lib_Scheduler_view_mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_184__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineScroll.js */ "./lib/Scheduler/view/mixin/TimelineScroll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineScroll", function() { return _lib_Scheduler_view_mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_185__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineViewPresets.js */ "./lib/Scheduler/view/mixin/TimelineViewPresets.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineViewPresets", function() { return _lib_Scheduler_view_mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_186__["default"]; });

/* harmony import */ var _lib_Scheduler_view_mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(/*! ../lib/Scheduler/view/mixin/TimelineZoomable.js */ "./lib/Scheduler/view/mixin/TimelineZoomable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineZoomable", function() { return _lib_Scheduler_view_mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_187__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_188__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceConfirmationPopup", function() { return _lib_Scheduler_view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_189__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_190__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_191__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/RecurrenceEditor.js */ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceEditor", function() { return _lib_Scheduler_view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_192__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceFrequencyCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_193__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/RecurrenceLegendButton.js */ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceLegendButton", function() { return _lib_Scheduler_view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_194__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthDaysButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_195__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_196__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthsButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_196__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_197__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrencePositionsCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_197__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_198__ = __webpack_require__(/*! ../lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceStopConditionCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_198__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_199__ = __webpack_require__(/*! ../lib/Scheduler/widget/ResourceCombo.js */ "./lib/Scheduler/widget/ResourceCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceCombo", function() { return _lib_Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_199__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_ResourceFilter_js__WEBPACK_IMPORTED_MODULE_200__ = __webpack_require__(/*! ../lib/Scheduler/widget/ResourceFilter.js */ "./lib/Scheduler/widget/ResourceFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceFilter", function() { return _lib_Scheduler_widget_ResourceFilter_js__WEBPACK_IMPORTED_MODULE_200__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_201__ = __webpack_require__(/*! ../lib/Scheduler/widget/UndoRedo.js */ "./lib/Scheduler/widget/UndoRedo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedo", function() { return _lib_Scheduler_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_201__["default"]; });

/* harmony import */ var _lib_Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_202__ = __webpack_require__(/*! ../lib/Scheduler/customElements/TimelineBaseTag.js */ "./lib/Scheduler/customElements/TimelineBaseTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineBaseTag", function() { return _lib_Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_202__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_203__ = __webpack_require__(/*! ../lib/SchedulerPro/data/AssignmentStore.js */ "./lib/SchedulerPro/data/AssignmentStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProAssignmentStore", function() { return _lib_SchedulerPro_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_203__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_204__ = __webpack_require__(/*! ../lib/SchedulerPro/data/CalendarManagerStore.js */ "./lib/SchedulerPro/data/CalendarManagerStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProCalendarManagerStore", function() { return _lib_SchedulerPro_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_204__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_205__ = __webpack_require__(/*! ../lib/SchedulerPro/data/DependencyStore.js */ "./lib/SchedulerPro/data/DependencyStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProDependencyStore", function() { return _lib_SchedulerPro_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_205__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_EventStore_js__WEBPACK_IMPORTED_MODULE_206__ = __webpack_require__(/*! ../lib/SchedulerPro/data/EventStore.js */ "./lib/SchedulerPro/data/EventStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStore", function() { return _lib_SchedulerPro_data_EventStore_js__WEBPACK_IMPORTED_MODULE_206__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_207__ = __webpack_require__(/*! ../lib/SchedulerPro/data/ResourceStore.js */ "./lib/SchedulerPro/data/ResourceStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProResourceStore", function() { return _lib_SchedulerPro_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_207__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_208__ = __webpack_require__(/*! ../lib/SchedulerPro/data/mixin/PartOfProject.js */ "./lib/SchedulerPro/data/mixin/PartOfProject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PartOfProject", function() { return _lib_SchedulerPro_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_208__["default"]; });

/* harmony import */ var _lib_SchedulerPro_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_209__ = __webpack_require__(/*! ../lib/SchedulerPro/data/mixin/ProjectCrudManager.js */ "./lib/SchedulerPro/data/mixin/ProjectCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCrudManager", function() { return _lib_SchedulerPro_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_209__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_210__ = __webpack_require__(/*! ../lib/SchedulerPro/model/AssignmentModel.js */ "./lib/SchedulerPro/model/AssignmentModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProAssignmentModel", function() { return _lib_SchedulerPro_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_210__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_211__ = __webpack_require__(/*! ../lib/SchedulerPro/model/CalendarIntervalModel.js */ "./lib/SchedulerPro/model/CalendarIntervalModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProCalendarIntervalModel", function() { return _lib_SchedulerPro_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_211__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_212__ = __webpack_require__(/*! ../lib/SchedulerPro/model/CalendarModel.js */ "./lib/SchedulerPro/model/CalendarModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProCalendarModel", function() { return _lib_SchedulerPro_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_212__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_213__ = __webpack_require__(/*! ../lib/SchedulerPro/model/DependencyModel.js */ "./lib/SchedulerPro/model/DependencyModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProDependencyModel", function() { return _lib_SchedulerPro_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_213__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_EventModel_js__WEBPACK_IMPORTED_MODULE_214__ = __webpack_require__(/*! ../lib/SchedulerPro/model/EventModel.js */ "./lib/SchedulerPro/model/EventModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModel", function() { return _lib_SchedulerPro_model_EventModel_js__WEBPACK_IMPORTED_MODULE_214__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_215__ = __webpack_require__(/*! ../lib/SchedulerPro/model/ProjectModel.js */ "./lib/SchedulerPro/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProProjectModel", function() { return _lib_SchedulerPro_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_215__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_216__ = __webpack_require__(/*! ../lib/SchedulerPro/model/ResourceModel.js */ "./lib/SchedulerPro/model/ResourceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProResourceModel", function() { return _lib_SchedulerPro_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_216__["default"]; });

/* harmony import */ var _lib_SchedulerPro_model_mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_217__ = __webpack_require__(/*! ../lib/SchedulerPro/model/mixin/PercentDoneMixin.js */ "./lib/SchedulerPro/model/mixin/PercentDoneMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentDoneMixin", function() { return _lib_SchedulerPro_model_mixin_PercentDoneMixin_js__WEBPACK_IMPORTED_MODULE_217__["default"]; });

/* harmony import */ var _lib_SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_218__ = __webpack_require__(/*! ../lib/SchedulerPro/column/DurationColumn.js */ "./lib/SchedulerPro/column/DurationColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationColumn", function() { return _lib_SchedulerPro_column_DurationColumn_js__WEBPACK_IMPORTED_MODULE_218__["default"]; });

/* harmony import */ var _lib_SchedulerPro_column_ResourceCalendarColumn_js__WEBPACK_IMPORTED_MODULE_219__ = __webpack_require__(/*! ../lib/SchedulerPro/column/ResourceCalendarColumn.js */ "./lib/SchedulerPro/column/ResourceCalendarColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceCalendarColumn", function() { return _lib_SchedulerPro_column_ResourceCalendarColumn_js__WEBPACK_IMPORTED_MODULE_219__["default"]; });

/* harmony import */ var _lib_SchedulerPro_column_ScaleColumn_js__WEBPACK_IMPORTED_MODULE_220__ = __webpack_require__(/*! ../lib/SchedulerPro/column/ScaleColumn.js */ "./lib/SchedulerPro/column/ScaleColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScaleColumn", function() { return _lib_SchedulerPro_column_ScaleColumn_js__WEBPACK_IMPORTED_MODULE_220__["default"]; });

/* harmony import */ var _lib_SchedulerPro_feature_mixin_ProTaskEditStm_js__WEBPACK_IMPORTED_MODULE_221__ = __webpack_require__(/*! ../lib/SchedulerPro/feature/mixin/ProTaskEditStm.js */ "./lib/SchedulerPro/feature/mixin/ProTaskEditStm.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProTaskEditStm", function() { return _lib_SchedulerPro_feature_mixin_ProTaskEditStm_js__WEBPACK_IMPORTED_MODULE_221__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_CalendarField_js__WEBPACK_IMPORTED_MODULE_222__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/CalendarField.js */ "./lib/SchedulerPro/widget/CalendarField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarField", function() { return _lib_SchedulerPro_widget_CalendarField_js__WEBPACK_IMPORTED_MODULE_222__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_223__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/ConstraintTypePicker.js */ "./lib/SchedulerPro/widget/ConstraintTypePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstraintTypePicker", function() { return _lib_SchedulerPro_widget_ConstraintTypePicker_js__WEBPACK_IMPORTED_MODULE_223__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_DependencyTypePicker_js__WEBPACK_IMPORTED_MODULE_224__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/DependencyTypePicker.js */ "./lib/SchedulerPro/widget/DependencyTypePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyTypePicker", function() { return _lib_SchedulerPro_widget_DependencyTypePicker_js__WEBPACK_IMPORTED_MODULE_224__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_EffortField_js__WEBPACK_IMPORTED_MODULE_225__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/EffortField.js */ "./lib/SchedulerPro/widget/EffortField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffortField", function() { return _lib_SchedulerPro_widget_EffortField_js__WEBPACK_IMPORTED_MODULE_225__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_EndDateField_js__WEBPACK_IMPORTED_MODULE_226__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/EndDateField.js */ "./lib/SchedulerPro/widget/EndDateField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EndDateField", function() { return _lib_SchedulerPro_widget_EndDateField_js__WEBPACK_IMPORTED_MODULE_226__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_GanttTaskEditor_js__WEBPACK_IMPORTED_MODULE_227__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/GanttTaskEditor.js */ "./lib/SchedulerPro/widget/GanttTaskEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttTaskEditor", function() { return _lib_SchedulerPro_widget_GanttTaskEditor_js__WEBPACK_IMPORTED_MODULE_227__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_ModelCombo_js__WEBPACK_IMPORTED_MODULE_228__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/ModelCombo.js */ "./lib/SchedulerPro/widget/ModelCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelCombo", function() { return _lib_SchedulerPro_widget_ModelCombo_js__WEBPACK_IMPORTED_MODULE_228__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_SchedulerTaskEditor_js__WEBPACK_IMPORTED_MODULE_229__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/SchedulerTaskEditor.js */ "./lib/SchedulerPro/widget/SchedulerTaskEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerTaskEditor", function() { return _lib_SchedulerPro_widget_SchedulerTaskEditor_js__WEBPACK_IMPORTED_MODULE_229__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_230__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/SchedulingModePicker.js */ "./lib/SchedulerPro/widget/SchedulingModePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulingModePicker", function() { return _lib_SchedulerPro_widget_SchedulingModePicker_js__WEBPACK_IMPORTED_MODULE_230__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_StartDateField_js__WEBPACK_IMPORTED_MODULE_231__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/StartDateField.js */ "./lib/SchedulerPro/widget/StartDateField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StartDateField", function() { return _lib_SchedulerPro_widget_StartDateField_js__WEBPACK_IMPORTED_MODULE_231__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_232__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/TaskEditorBase.js */ "./lib/SchedulerPro/widget/TaskEditorBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEditorBase", function() { return _lib_SchedulerPro_widget_TaskEditorBase_js__WEBPACK_IMPORTED_MODULE_232__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_Timeline_js__WEBPACK_IMPORTED_MODULE_233__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/Timeline.js */ "./lib/SchedulerPro/widget/Timeline.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Timeline", function() { return _lib_SchedulerPro_widget_Timeline_js__WEBPACK_IMPORTED_MODULE_233__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_AdvancedTab_js__WEBPACK_IMPORTED_MODULE_234__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/AdvancedTab.js */ "./lib/SchedulerPro/widget/taskeditor/AdvancedTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvancedTab", function() { return _lib_SchedulerPro_widget_taskeditor_AdvancedTab_js__WEBPACK_IMPORTED_MODULE_234__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_DependencyTab_js__WEBPACK_IMPORTED_MODULE_235__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/DependencyTab.js */ "./lib/SchedulerPro/widget/taskeditor/DependencyTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyTab", function() { return _lib_SchedulerPro_widget_taskeditor_DependencyTab_js__WEBPACK_IMPORTED_MODULE_235__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_EditorTab_js__WEBPACK_IMPORTED_MODULE_236__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/EditorTab.js */ "./lib/SchedulerPro/widget/taskeditor/EditorTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorTab", function() { return _lib_SchedulerPro_widget_taskeditor_EditorTab_js__WEBPACK_IMPORTED_MODULE_236__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_FormTab_js__WEBPACK_IMPORTED_MODULE_237__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/FormTab.js */ "./lib/SchedulerPro/widget/taskeditor/FormTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormTab", function() { return _lib_SchedulerPro_widget_taskeditor_FormTab_js__WEBPACK_IMPORTED_MODULE_237__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_GeneralTab_js__WEBPACK_IMPORTED_MODULE_238__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/GeneralTab.js */ "./lib/SchedulerPro/widget/taskeditor/GeneralTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GeneralTab", function() { return _lib_SchedulerPro_widget_taskeditor_GeneralTab_js__WEBPACK_IMPORTED_MODULE_238__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_NotesTab_js__WEBPACK_IMPORTED_MODULE_239__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/NotesTab.js */ "./lib/SchedulerPro/widget/taskeditor/NotesTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NotesTab", function() { return _lib_SchedulerPro_widget_taskeditor_NotesTab_js__WEBPACK_IMPORTED_MODULE_239__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_PredecessorsTab_js__WEBPACK_IMPORTED_MODULE_240__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/PredecessorsTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PredecessorsTab", function() { return _lib_SchedulerPro_widget_taskeditor_PredecessorsTab_js__WEBPACK_IMPORTED_MODULE_240__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_ResourcesTab_js__WEBPACK_IMPORTED_MODULE_241__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/ResourcesTab.js */ "./lib/SchedulerPro/widget/taskeditor/ResourcesTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourcesTab", function() { return _lib_SchedulerPro_widget_taskeditor_ResourcesTab_js__WEBPACK_IMPORTED_MODULE_241__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_SchedulerAdvancedTab_js__WEBPACK_IMPORTED_MODULE_242__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js */ "./lib/SchedulerPro/widget/taskeditor/SchedulerAdvancedTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerAdvancedTab", function() { return _lib_SchedulerPro_widget_taskeditor_SchedulerAdvancedTab_js__WEBPACK_IMPORTED_MODULE_242__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_SchedulerGeneralTab_js__WEBPACK_IMPORTED_MODULE_243__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js */ "./lib/SchedulerPro/widget/taskeditor/SchedulerGeneralTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerGeneralTab", function() { return _lib_SchedulerPro_widget_taskeditor_SchedulerGeneralTab_js__WEBPACK_IMPORTED_MODULE_243__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_SuccessorsTab_js__WEBPACK_IMPORTED_MODULE_244__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js */ "./lib/SchedulerPro/widget/taskeditor/SuccessorsTab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SuccessorsTab", function() { return _lib_SchedulerPro_widget_taskeditor_SuccessorsTab_js__WEBPACK_IMPORTED_MODULE_244__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_mixin_EventLoader_js__WEBPACK_IMPORTED_MODULE_245__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js */ "./lib/SchedulerPro/widget/taskeditor/mixin/EventLoader.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventLoader", function() { return _lib_SchedulerPro_widget_taskeditor_mixin_EventLoader_js__WEBPACK_IMPORTED_MODULE_245__["default"]; });

/* harmony import */ var _lib_SchedulerPro_widget_taskeditor_mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_246__ = __webpack_require__(/*! ../lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js */ "./lib/SchedulerPro/widget/taskeditor/mixin/ReadyStatePropagator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReadyStatePropagator", function() { return _lib_SchedulerPro_widget_taskeditor_mixin_ReadyStatePropagator_js__WEBPACK_IMPORTED_MODULE_246__["default"]; });

/* harmony import */ var _lib_SchedulerPro_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_247__ = __webpack_require__(/*! ../lib/SchedulerPro/feature/EventResize.js */ "./lib/SchedulerPro/feature/EventResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventResize", function() { return _lib_SchedulerPro_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_247__["default"]; });

/* harmony import */ var _lib_SchedulerPro_feature_PercentBar_js__WEBPACK_IMPORTED_MODULE_248__ = __webpack_require__(/*! ../lib/SchedulerPro/feature/PercentBar.js */ "./lib/SchedulerPro/feature/PercentBar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentBar", function() { return _lib_SchedulerPro_feature_PercentBar_js__WEBPACK_IMPORTED_MODULE_248__["default"]; });

/* harmony import */ var _lib_SchedulerPro_feature_ResourceNonWorkingTime_js__WEBPACK_IMPORTED_MODULE_249__ = __webpack_require__(/*! ../lib/SchedulerPro/feature/ResourceNonWorkingTime.js */ "./lib/SchedulerPro/feature/ResourceNonWorkingTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceNonWorkingTime", function() { return _lib_SchedulerPro_feature_ResourceNonWorkingTime_js__WEBPACK_IMPORTED_MODULE_249__["default"]; });

/* harmony import */ var _lib_SchedulerPro_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_250__ = __webpack_require__(/*! ../lib/SchedulerPro/feature/TaskEdit.js */ "./lib/SchedulerPro/feature/TaskEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProTaskEdit", function() { return _lib_SchedulerPro_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_250__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Summary_js__WEBPACK_IMPORTED_MODULE_251__ = __webpack_require__(/*! ../lib/Gantt/feature/Summary.js */ "./lib/Gantt/feature/Summary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Summary", function() { return _lib_Gantt_feature_Summary_js__WEBPACK_IMPORTED_MODULE_251__["default"]; });

/* harmony import */ var _lib_SchedulerPro_eventlayout_ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_252__ = __webpack_require__(/*! ../lib/SchedulerPro/eventlayout/ProHorizontalLayout.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayout.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProHorizontalLayout", function() { return _lib_SchedulerPro_eventlayout_ProHorizontalLayout_js__WEBPACK_IMPORTED_MODULE_252__["default"]; });

/* harmony import */ var _lib_SchedulerPro_eventlayout_ProHorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_253__ = __webpack_require__(/*! ../lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js */ "./lib/SchedulerPro/eventlayout/ProHorizontalLayoutStack.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProHorizontalLayoutStack", function() { return _lib_SchedulerPro_eventlayout_ProHorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_253__["default"]; });

/* harmony import */ var _lib_SchedulerPro_view_mixin_SchedulerProEventRendering_js__WEBPACK_IMPORTED_MODULE_254__ = __webpack_require__(/*! ../lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js */ "./lib/SchedulerPro/view/mixin/SchedulerProEventRendering.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProEventRendering", function() { return _lib_SchedulerPro_view_mixin_SchedulerProEventRendering_js__WEBPACK_IMPORTED_MODULE_254__["default"]; });

/* harmony import */ var _lib_SchedulerPro_view_ResourceHistogram_js__WEBPACK_IMPORTED_MODULE_255__ = __webpack_require__(/*! ../lib/SchedulerPro/view/ResourceHistogram.js */ "./lib/SchedulerPro/view/ResourceHistogram.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceHistogram", function() { return _lib_SchedulerPro_view_ResourceHistogram_js__WEBPACK_IMPORTED_MODULE_255__["default"]; });

/* harmony import */ var _lib_SchedulerPro_view_SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_256__ = __webpack_require__(/*! ../lib/SchedulerPro/view/SchedulerProBase.js */ "./lib/SchedulerPro/view/SchedulerProBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProBase", function() { return _lib_SchedulerPro_view_SchedulerProBase_js__WEBPACK_IMPORTED_MODULE_256__["default"]; });

/* harmony import */ var _lib_SchedulerPro_view_SchedulerPro_js__WEBPACK_IMPORTED_MODULE_257__ = __webpack_require__(/*! ../lib/SchedulerPro/view/SchedulerPro.js */ "./lib/SchedulerPro/view/SchedulerPro.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerPro", function() { return _lib_SchedulerPro_view_SchedulerPro_js__WEBPACK_IMPORTED_MODULE_257__["default"]; });

/* harmony import */ var _lib_Gantt_column_AddNewColumn_js__WEBPACK_IMPORTED_MODULE_258__ = __webpack_require__(/*! ../lib/Gantt/column/AddNewColumn.js */ "./lib/Gantt/column/AddNewColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AddNewColumn", function() { return _lib_Gantt_column_AddNewColumn_js__WEBPACK_IMPORTED_MODULE_258__["default"]; });

/* harmony import */ var _lib_Gantt_column_AllColumns_js__WEBPACK_IMPORTED_MODULE_259__ = __webpack_require__(/*! ../lib/Gantt/column/AllColumns.js */ "./lib/Gantt/column/AllColumns.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AllColumns", function() { return _lib_Gantt_column_AllColumns_js__WEBPACK_IMPORTED_MODULE_259__["default"]; });

/* harmony import */ var _lib_Gantt_column_CalendarColumn_js__WEBPACK_IMPORTED_MODULE_260__ = __webpack_require__(/*! ../lib/Gantt/column/CalendarColumn.js */ "./lib/Gantt/column/CalendarColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarColumn", function() { return _lib_Gantt_column_CalendarColumn_js__WEBPACK_IMPORTED_MODULE_260__["default"]; });

/* harmony import */ var _lib_Gantt_column_ConstraintDateColumn_js__WEBPACK_IMPORTED_MODULE_261__ = __webpack_require__(/*! ../lib/Gantt/column/ConstraintDateColumn.js */ "./lib/Gantt/column/ConstraintDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstraintDateColumn", function() { return _lib_Gantt_column_ConstraintDateColumn_js__WEBPACK_IMPORTED_MODULE_261__["default"]; });

/* harmony import */ var _lib_Gantt_column_ConstraintTypeColumn_js__WEBPACK_IMPORTED_MODULE_262__ = __webpack_require__(/*! ../lib/Gantt/column/ConstraintTypeColumn.js */ "./lib/Gantt/column/ConstraintTypeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConstraintTypeColumn", function() { return _lib_Gantt_column_ConstraintTypeColumn_js__WEBPACK_IMPORTED_MODULE_262__["default"]; });

/* harmony import */ var _lib_Gantt_column_DeadlineDateColumn_js__WEBPACK_IMPORTED_MODULE_263__ = __webpack_require__(/*! ../lib/Gantt/column/DeadlineDateColumn.js */ "./lib/Gantt/column/DeadlineDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DeadlineDateColumn", function() { return _lib_Gantt_column_DeadlineDateColumn_js__WEBPACK_IMPORTED_MODULE_263__["default"]; });

/* harmony import */ var _lib_Gantt_column_DependencyColumn_js__WEBPACK_IMPORTED_MODULE_264__ = __webpack_require__(/*! ../lib/Gantt/column/DependencyColumn.js */ "./lib/Gantt/column/DependencyColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyColumn", function() { return _lib_Gantt_column_DependencyColumn_js__WEBPACK_IMPORTED_MODULE_264__["default"]; });

/* harmony import */ var _lib_Gantt_column_EarlyEndDateColumn_js__WEBPACK_IMPORTED_MODULE_265__ = __webpack_require__(/*! ../lib/Gantt/column/EarlyEndDateColumn.js */ "./lib/Gantt/column/EarlyEndDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EarlyEndDateColumn", function() { return _lib_Gantt_column_EarlyEndDateColumn_js__WEBPACK_IMPORTED_MODULE_265__["default"]; });

/* harmony import */ var _lib_Gantt_column_EarlyStartDateColumn_js__WEBPACK_IMPORTED_MODULE_266__ = __webpack_require__(/*! ../lib/Gantt/column/EarlyStartDateColumn.js */ "./lib/Gantt/column/EarlyStartDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EarlyStartDateColumn", function() { return _lib_Gantt_column_EarlyStartDateColumn_js__WEBPACK_IMPORTED_MODULE_266__["default"]; });

/* harmony import */ var _lib_Gantt_column_EffortColumn_js__WEBPACK_IMPORTED_MODULE_267__ = __webpack_require__(/*! ../lib/Gantt/column/EffortColumn.js */ "./lib/Gantt/column/EffortColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffortColumn", function() { return _lib_Gantt_column_EffortColumn_js__WEBPACK_IMPORTED_MODULE_267__["default"]; });

/* harmony import */ var _lib_Gantt_column_EndDateColumn_js__WEBPACK_IMPORTED_MODULE_268__ = __webpack_require__(/*! ../lib/Gantt/column/EndDateColumn.js */ "./lib/Gantt/column/EndDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EndDateColumn", function() { return _lib_Gantt_column_EndDateColumn_js__WEBPACK_IMPORTED_MODULE_268__["default"]; });

/* harmony import */ var _lib_Gantt_column_EventModeColumn_js__WEBPACK_IMPORTED_MODULE_269__ = __webpack_require__(/*! ../lib/Gantt/column/EventModeColumn.js */ "./lib/Gantt/column/EventModeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModeColumn", function() { return _lib_Gantt_column_EventModeColumn_js__WEBPACK_IMPORTED_MODULE_269__["default"]; });

/* harmony import */ var _lib_Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_270__ = __webpack_require__(/*! ../lib/Gantt/column/GanttDateColumn.js */ "./lib/Gantt/column/GanttDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttDateColumn", function() { return _lib_Gantt_column_GanttDateColumn_js__WEBPACK_IMPORTED_MODULE_270__["default"]; });

/* harmony import */ var _lib_Gantt_column_InactiveColumn_js__WEBPACK_IMPORTED_MODULE_271__ = __webpack_require__(/*! ../lib/Gantt/column/InactiveColumn.js */ "./lib/Gantt/column/InactiveColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InactiveColumn", function() { return _lib_Gantt_column_InactiveColumn_js__WEBPACK_IMPORTED_MODULE_271__["default"]; });

/* harmony import */ var _lib_Gantt_column_LateEndDateColumn_js__WEBPACK_IMPORTED_MODULE_272__ = __webpack_require__(/*! ../lib/Gantt/column/LateEndDateColumn.js */ "./lib/Gantt/column/LateEndDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LateEndDateColumn", function() { return _lib_Gantt_column_LateEndDateColumn_js__WEBPACK_IMPORTED_MODULE_272__["default"]; });

/* harmony import */ var _lib_Gantt_column_LateStartDateColumn_js__WEBPACK_IMPORTED_MODULE_273__ = __webpack_require__(/*! ../lib/Gantt/column/LateStartDateColumn.js */ "./lib/Gantt/column/LateStartDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LateStartDateColumn", function() { return _lib_Gantt_column_LateStartDateColumn_js__WEBPACK_IMPORTED_MODULE_273__["default"]; });

/* harmony import */ var _lib_Gantt_column_ManuallyScheduledColumn_js__WEBPACK_IMPORTED_MODULE_274__ = __webpack_require__(/*! ../lib/Gantt/column/ManuallyScheduledColumn.js */ "./lib/Gantt/column/ManuallyScheduledColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ManuallyScheduledColumn", function() { return _lib_Gantt_column_ManuallyScheduledColumn_js__WEBPACK_IMPORTED_MODULE_274__["default"]; });

/* harmony import */ var _lib_Gantt_column_MilestoneColumn_js__WEBPACK_IMPORTED_MODULE_275__ = __webpack_require__(/*! ../lib/Gantt/column/MilestoneColumn.js */ "./lib/Gantt/column/MilestoneColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MilestoneColumn", function() { return _lib_Gantt_column_MilestoneColumn_js__WEBPACK_IMPORTED_MODULE_275__["default"]; });

/* harmony import */ var _lib_Gantt_column_NameColumn_js__WEBPACK_IMPORTED_MODULE_276__ = __webpack_require__(/*! ../lib/Gantt/column/NameColumn.js */ "./lib/Gantt/column/NameColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NameColumn", function() { return _lib_Gantt_column_NameColumn_js__WEBPACK_IMPORTED_MODULE_276__["default"]; });

/* harmony import */ var _lib_Gantt_column_NoteColumn_js__WEBPACK_IMPORTED_MODULE_277__ = __webpack_require__(/*! ../lib/Gantt/column/NoteColumn.js */ "./lib/Gantt/column/NoteColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NoteColumn", function() { return _lib_Gantt_column_NoteColumn_js__WEBPACK_IMPORTED_MODULE_277__["default"]; });

/* harmony import */ var _lib_Gantt_column_PercentDoneColumn_js__WEBPACK_IMPORTED_MODULE_278__ = __webpack_require__(/*! ../lib/Gantt/column/PercentDoneColumn.js */ "./lib/Gantt/column/PercentDoneColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentDoneColumn", function() { return _lib_Gantt_column_PercentDoneColumn_js__WEBPACK_IMPORTED_MODULE_278__["default"]; });

/* harmony import */ var _lib_Gantt_column_PredecessorColumn_js__WEBPACK_IMPORTED_MODULE_279__ = __webpack_require__(/*! ../lib/Gantt/column/PredecessorColumn.js */ "./lib/Gantt/column/PredecessorColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PredecessorColumn", function() { return _lib_Gantt_column_PredecessorColumn_js__WEBPACK_IMPORTED_MODULE_279__["default"]; });

/* harmony import */ var _lib_Gantt_column_ResourceAssignmentColumn_js__WEBPACK_IMPORTED_MODULE_280__ = __webpack_require__(/*! ../lib/Gantt/column/ResourceAssignmentColumn.js */ "./lib/Gantt/column/ResourceAssignmentColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceAssignmentColumn", function() { return _lib_Gantt_column_ResourceAssignmentColumn_js__WEBPACK_IMPORTED_MODULE_280__["default"]; });

/* harmony import */ var _lib_Gantt_column_ResourceAssignmentGridResourceColumn_js__WEBPACK_IMPORTED_MODULE_281__ = __webpack_require__(/*! ../lib/Gantt/column/ResourceAssignmentGridResourceColumn.js */ "./lib/Gantt/column/ResourceAssignmentGridResourceColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceAssignmentGridResourceColumn", function() { return _lib_Gantt_column_ResourceAssignmentGridResourceColumn_js__WEBPACK_IMPORTED_MODULE_281__["default"]; });

/* harmony import */ var _lib_Gantt_column_RollupColumn_js__WEBPACK_IMPORTED_MODULE_282__ = __webpack_require__(/*! ../lib/Gantt/column/RollupColumn.js */ "./lib/Gantt/column/RollupColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RollupColumn", function() { return _lib_Gantt_column_RollupColumn_js__WEBPACK_IMPORTED_MODULE_282__["default"]; });

/* harmony import */ var _lib_Gantt_column_SchedulingModeColumn_js__WEBPACK_IMPORTED_MODULE_283__ = __webpack_require__(/*! ../lib/Gantt/column/SchedulingModeColumn.js */ "./lib/Gantt/column/SchedulingModeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulingModeColumn", function() { return _lib_Gantt_column_SchedulingModeColumn_js__WEBPACK_IMPORTED_MODULE_283__["default"]; });

/* harmony import */ var _lib_Gantt_column_SequenceColumn_js__WEBPACK_IMPORTED_MODULE_284__ = __webpack_require__(/*! ../lib/Gantt/column/SequenceColumn.js */ "./lib/Gantt/column/SequenceColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SequenceColumn", function() { return _lib_Gantt_column_SequenceColumn_js__WEBPACK_IMPORTED_MODULE_284__["default"]; });

/* harmony import */ var _lib_Gantt_column_ShowInTimelineColumn_js__WEBPACK_IMPORTED_MODULE_285__ = __webpack_require__(/*! ../lib/Gantt/column/ShowInTimelineColumn.js */ "./lib/Gantt/column/ShowInTimelineColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ShowInTimelineColumn", function() { return _lib_Gantt_column_ShowInTimelineColumn_js__WEBPACK_IMPORTED_MODULE_285__["default"]; });

/* harmony import */ var _lib_Gantt_column_StartDateColumn_js__WEBPACK_IMPORTED_MODULE_286__ = __webpack_require__(/*! ../lib/Gantt/column/StartDateColumn.js */ "./lib/Gantt/column/StartDateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StartDateColumn", function() { return _lib_Gantt_column_StartDateColumn_js__WEBPACK_IMPORTED_MODULE_286__["default"]; });

/* harmony import */ var _lib_Gantt_column_SuccessorColumn_js__WEBPACK_IMPORTED_MODULE_287__ = __webpack_require__(/*! ../lib/Gantt/column/SuccessorColumn.js */ "./lib/Gantt/column/SuccessorColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SuccessorColumn", function() { return _lib_Gantt_column_SuccessorColumn_js__WEBPACK_IMPORTED_MODULE_287__["default"]; });

/* harmony import */ var _lib_Gantt_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_288__ = __webpack_require__(/*! ../lib/Gantt/column/TimeAxisColumn.js */ "./lib/Gantt/column/TimeAxisColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisColumn", function() { return _lib_Gantt_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_288__["default"]; });

/* harmony import */ var _lib_Gantt_column_TotalSlackColumn_js__WEBPACK_IMPORTED_MODULE_289__ = __webpack_require__(/*! ../lib/Gantt/column/TotalSlackColumn.js */ "./lib/Gantt/column/TotalSlackColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TotalSlackColumn", function() { return _lib_Gantt_column_TotalSlackColumn_js__WEBPACK_IMPORTED_MODULE_289__["default"]; });

/* harmony import */ var _lib_Gantt_column_WBSColumn_js__WEBPACK_IMPORTED_MODULE_290__ = __webpack_require__(/*! ../lib/Gantt/column/WBSColumn.js */ "./lib/Gantt/column/WBSColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WBSColumn", function() { return _lib_Gantt_column_WBSColumn_js__WEBPACK_IMPORTED_MODULE_290__["default"]; });

/* harmony import */ var _lib_Gantt_data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_291__ = __webpack_require__(/*! ../lib/Gantt/data/AssignmentsManipulationStore.js */ "./lib/Gantt/data/AssignmentsManipulationStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentsManipulationStore", function() { return _lib_Gantt_data_AssignmentsManipulationStore_js__WEBPACK_IMPORTED_MODULE_291__["default"]; });

/* harmony import */ var _lib_Gantt_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_292__ = __webpack_require__(/*! ../lib/Gantt/data/AssignmentStore.js */ "./lib/Gantt/data/AssignmentStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStore", function() { return _lib_Gantt_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_292__["default"]; });

/* harmony import */ var _lib_Gantt_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_293__ = __webpack_require__(/*! ../lib/Gantt/data/CalendarManagerStore.js */ "./lib/Gantt/data/CalendarManagerStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarManagerStore", function() { return _lib_Gantt_data_CalendarManagerStore_js__WEBPACK_IMPORTED_MODULE_293__["default"]; });

/* harmony import */ var _lib_Gantt_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_294__ = __webpack_require__(/*! ../lib/Gantt/data/DependencyStore.js */ "./lib/Gantt/data/DependencyStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStore", function() { return _lib_Gantt_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_294__["default"]; });

/* harmony import */ var _lib_Gantt_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_295__ = __webpack_require__(/*! ../lib/Gantt/data/ResourceStore.js */ "./lib/Gantt/data/ResourceStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return _lib_Gantt_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_295__["default"]; });

/* harmony import */ var _lib_Gantt_data_TaskStore_js__WEBPACK_IMPORTED_MODULE_296__ = __webpack_require__(/*! ../lib/Gantt/data/TaskStore.js */ "./lib/Gantt/data/TaskStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskStore", function() { return _lib_Gantt_data_TaskStore_js__WEBPACK_IMPORTED_MODULE_296__["default"]; });

/* harmony import */ var _lib_Gantt_data_Wbs_js__WEBPACK_IMPORTED_MODULE_297__ = __webpack_require__(/*! ../lib/Gantt/data/Wbs.js */ "./lib/Gantt/data/Wbs.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Wbs", function() { return _lib_Gantt_data_Wbs_js__WEBPACK_IMPORTED_MODULE_297__["default"]; });

/* harmony import */ var _lib_Gantt_data_field_WbsField_js__WEBPACK_IMPORTED_MODULE_298__ = __webpack_require__(/*! ../lib/Gantt/data/field/WbsField.js */ "./lib/Gantt/data/field/WbsField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WbsField", function() { return _lib_Gantt_data_field_WbsField_js__WEBPACK_IMPORTED_MODULE_298__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Baselines_js__WEBPACK_IMPORTED_MODULE_299__ = __webpack_require__(/*! ../lib/Gantt/feature/Baselines.js */ "./lib/Gantt/feature/Baselines.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Baselines", function() { return _lib_Gantt_feature_Baselines_js__WEBPACK_IMPORTED_MODULE_299__["default"]; });

/* harmony import */ var _lib_Gantt_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_300__ = __webpack_require__(/*! ../lib/Gantt/feature/CellEdit.js */ "./lib/Gantt/feature/CellEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellEdit", function() { return _lib_Gantt_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_300__["default"]; });

/* harmony import */ var _lib_Gantt_feature_CriticalPaths_js__WEBPACK_IMPORTED_MODULE_301__ = __webpack_require__(/*! ../lib/Gantt/feature/CriticalPaths.js */ "./lib/Gantt/feature/CriticalPaths.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CriticalPaths", function() { return _lib_Gantt_feature_CriticalPaths_js__WEBPACK_IMPORTED_MODULE_301__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_302__ = __webpack_require__(/*! ../lib/Gantt/feature/Dependencies.js */ "./lib/Gantt/feature/Dependencies.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Dependencies", function() { return _lib_Gantt_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_302__["default"]; });

/* harmony import */ var _lib_Gantt_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_303__ = __webpack_require__(/*! ../lib/Gantt/feature/DependencyEdit.js */ "./lib/Gantt/feature/DependencyEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyEdit", function() { return _lib_Gantt_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_303__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Indicators_js__WEBPACK_IMPORTED_MODULE_304__ = __webpack_require__(/*! ../lib/Gantt/feature/Indicators.js */ "./lib/Gantt/feature/Indicators.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Indicators", function() { return _lib_Gantt_feature_Indicators_js__WEBPACK_IMPORTED_MODULE_304__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Labels_js__WEBPACK_IMPORTED_MODULE_305__ = __webpack_require__(/*! ../lib/Gantt/feature/Labels.js */ "./lib/Gantt/feature/Labels.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Labels", function() { return _lib_Gantt_feature_Labels_js__WEBPACK_IMPORTED_MODULE_305__["default"]; });

/* harmony import */ var _lib_Gantt_feature_ProgressLine_js__WEBPACK_IMPORTED_MODULE_306__ = __webpack_require__(/*! ../lib/Gantt/feature/ProgressLine.js */ "./lib/Gantt/feature/ProgressLine.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressLine", function() { return _lib_Gantt_feature_ProgressLine_js__WEBPACK_IMPORTED_MODULE_306__["default"]; });

/* harmony import */ var _lib_Gantt_feature_ProjectLines_js__WEBPACK_IMPORTED_MODULE_307__ = __webpack_require__(/*! ../lib/Gantt/feature/ProjectLines.js */ "./lib/Gantt/feature/ProjectLines.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectLines", function() { return _lib_Gantt_feature_ProjectLines_js__WEBPACK_IMPORTED_MODULE_307__["default"]; });

/* harmony import */ var _lib_Gantt_feature_Rollups_js__WEBPACK_IMPORTED_MODULE_308__ = __webpack_require__(/*! ../lib/Gantt/feature/Rollups.js */ "./lib/Gantt/feature/Rollups.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rollups", function() { return _lib_Gantt_feature_Rollups_js__WEBPACK_IMPORTED_MODULE_308__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskContextMenu_js__WEBPACK_IMPORTED_MODULE_309__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskContextMenu.js */ "./lib/Gantt/feature/TaskContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskContextMenu", function() { return _lib_Gantt_feature_TaskContextMenu_js__WEBPACK_IMPORTED_MODULE_309__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskCopyPaste_js__WEBPACK_IMPORTED_MODULE_310__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskCopyPaste.js */ "./lib/Gantt/feature/TaskCopyPaste.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskCopyPaste", function() { return _lib_Gantt_feature_TaskCopyPaste_js__WEBPACK_IMPORTED_MODULE_310__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_311__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskDrag.js */ "./lib/Gantt/feature/TaskDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDrag", function() { return _lib_Gantt_feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_311__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskDragCreate_js__WEBPACK_IMPORTED_MODULE_312__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskDragCreate.js */ "./lib/Gantt/feature/TaskDragCreate.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDragCreate", function() { return _lib_Gantt_feature_TaskDragCreate_js__WEBPACK_IMPORTED_MODULE_312__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_313__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskEdit.js */ "./lib/Gantt/feature/TaskEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEdit", function() { return _lib_Gantt_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_313__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_314__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskMenu.js */ "./lib/Gantt/feature/TaskMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskMenu", function() { return _lib_Gantt_feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_314__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskResize_js__WEBPACK_IMPORTED_MODULE_315__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskResize.js */ "./lib/Gantt/feature/TaskResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskResize", function() { return _lib_Gantt_feature_TaskResize_js__WEBPACK_IMPORTED_MODULE_315__["default"]; });

/* harmony import */ var _lib_Gantt_feature_TaskTooltip_js__WEBPACK_IMPORTED_MODULE_316__ = __webpack_require__(/*! ../lib/Gantt/feature/TaskTooltip.js */ "./lib/Gantt/feature/TaskTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskTooltip", function() { return _lib_Gantt_feature_TaskTooltip_js__WEBPACK_IMPORTED_MODULE_316__["default"]; });

/* harmony import */ var _lib_Gantt_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_317__ = __webpack_require__(/*! ../lib/Gantt/feature/export/exporter/MultiPageExporter.js */ "./lib/Gantt/feature/export/exporter/MultiPageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageExporter", function() { return _lib_Gantt_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_317__["default"]; });

/* harmony import */ var _lib_Gantt_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_318__ = __webpack_require__(/*! ../lib/Gantt/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Gantt/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageVerticalExporter", function() { return _lib_Gantt_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_318__["default"]; });

/* harmony import */ var _lib_Gantt_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_319__ = __webpack_require__(/*! ../lib/Gantt/feature/export/PdfExport.js */ "./lib/Gantt/feature/export/PdfExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PdfExport", function() { return _lib_Gantt_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_319__["default"]; });

/* harmony import */ var _lib_Gantt_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_320__ = __webpack_require__(/*! ../lib/Gantt/feature/export/exporter/SinglePageExporter.js */ "./lib/Gantt/feature/export/exporter/SinglePageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SinglePageExporter", function() { return _lib_Gantt_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_320__["default"]; });

/* harmony import */ var _lib_Gantt_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_321__ = __webpack_require__(/*! ../lib/Gantt/model/AssignmentModel.js */ "./lib/Gantt/model/AssignmentModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModel", function() { return _lib_Gantt_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_321__["default"]; });

/* harmony import */ var _lib_Gantt_model_Baseline_js__WEBPACK_IMPORTED_MODULE_322__ = __webpack_require__(/*! ../lib/Gantt/model/Baseline.js */ "./lib/Gantt/model/Baseline.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Baseline", function() { return _lib_Gantt_model_Baseline_js__WEBPACK_IMPORTED_MODULE_322__["default"]; });

/* harmony import */ var _lib_Gantt_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_323__ = __webpack_require__(/*! ../lib/Gantt/model/CalendarIntervalModel.js */ "./lib/Gantt/model/CalendarIntervalModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalModel", function() { return _lib_Gantt_model_CalendarIntervalModel_js__WEBPACK_IMPORTED_MODULE_323__["default"]; });

/* harmony import */ var _lib_Gantt_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_324__ = __webpack_require__(/*! ../lib/Gantt/model/CalendarModel.js */ "./lib/Gantt/model/CalendarModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarModel", function() { return _lib_Gantt_model_CalendarModel_js__WEBPACK_IMPORTED_MODULE_324__["default"]; });

/* harmony import */ var _lib_Gantt_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_325__ = __webpack_require__(/*! ../lib/Gantt/model/DependencyModel.js */ "./lib/Gantt/model/DependencyModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyModel", function() { return _lib_Gantt_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_325__["default"]; });

/* harmony import */ var _lib_Gantt_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_326__ = __webpack_require__(/*! ../lib/Gantt/model/ProjectModel.js */ "./lib/Gantt/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModel", function() { return _lib_Gantt_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_326__["default"]; });

/* harmony import */ var _lib_Gantt_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_327__ = __webpack_require__(/*! ../lib/Gantt/model/ResourceModel.js */ "./lib/Gantt/model/ResourceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModel", function() { return _lib_Gantt_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_327__["default"]; });

/* harmony import */ var _lib_Gantt_model_TaskModel_js__WEBPACK_IMPORTED_MODULE_328__ = __webpack_require__(/*! ../lib/Gantt/model/TaskModel.js */ "./lib/Gantt/model/TaskModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskModel", function() { return _lib_Gantt_model_TaskModel_js__WEBPACK_IMPORTED_MODULE_328__["default"]; });

/* harmony import */ var _lib_Gantt_util_ProjectGenerator_js__WEBPACK_IMPORTED_MODULE_329__ = __webpack_require__(/*! ../lib/Gantt/util/ProjectGenerator.js */ "./lib/Gantt/util/ProjectGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectGenerator", function() { return _lib_Gantt_util_ProjectGenerator_js__WEBPACK_IMPORTED_MODULE_329__["default"]; });

/* harmony import */ var _lib_Gantt_util_ResourceAssignmentParser_js__WEBPACK_IMPORTED_MODULE_330__ = __webpack_require__(/*! ../lib/Gantt/util/ResourceAssignmentParser.js */ "./lib/Gantt/util/ResourceAssignmentParser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceAssignmentParser", function() { return _lib_Gantt_util_ResourceAssignmentParser_js__WEBPACK_IMPORTED_MODULE_330__["default"]; });

/* harmony import */ var _lib_Gantt_widget_AssignmentField_js__WEBPACK_IMPORTED_MODULE_331__ = __webpack_require__(/*! ../lib/Gantt/widget/AssignmentField.js */ "./lib/Gantt/widget/AssignmentField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentField", function() { return _lib_Gantt_widget_AssignmentField_js__WEBPACK_IMPORTED_MODULE_331__["default"]; });

/* harmony import */ var _lib_Gantt_widget_AssignmentGrid_js__WEBPACK_IMPORTED_MODULE_332__ = __webpack_require__(/*! ../lib/Gantt/widget/AssignmentGrid.js */ "./lib/Gantt/widget/AssignmentGrid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentGrid", function() { return _lib_Gantt_widget_AssignmentGrid_js__WEBPACK_IMPORTED_MODULE_332__["default"]; });

/* harmony import */ var _lib_Gantt_widget_AssignmentPicker_js__WEBPACK_IMPORTED_MODULE_333__ = __webpack_require__(/*! ../lib/Gantt/widget/AssignmentPicker.js */ "./lib/Gantt/widget/AssignmentPicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentPicker", function() { return _lib_Gantt_widget_AssignmentPicker_js__WEBPACK_IMPORTED_MODULE_333__["default"]; });

/* harmony import */ var _lib_Gantt_widget_CalendarPicker_js__WEBPACK_IMPORTED_MODULE_334__ = __webpack_require__(/*! ../lib/Gantt/widget/CalendarPicker.js */ "./lib/Gantt/widget/CalendarPicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPicker", function() { return _lib_Gantt_widget_CalendarPicker_js__WEBPACK_IMPORTED_MODULE_334__["default"]; });

/* harmony import */ var _lib_Gantt_widget_DependencyField_js__WEBPACK_IMPORTED_MODULE_335__ = __webpack_require__(/*! ../lib/Gantt/widget/DependencyField.js */ "./lib/Gantt/widget/DependencyField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyField", function() { return _lib_Gantt_widget_DependencyField_js__WEBPACK_IMPORTED_MODULE_335__["default"]; });

/* harmony import */ var _lib_Gantt_widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_336__ = __webpack_require__(/*! ../lib/Gantt/widget/TaskEditor.js */ "./lib/Gantt/widget/TaskEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEditor", function() { return _lib_Gantt_widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_336__["default"]; });

/* harmony import */ var _lib_Gantt_feature_export_MspExport_js__WEBPACK_IMPORTED_MODULE_337__ = __webpack_require__(/*! ../lib/Gantt/feature/export/MspExport.js */ "./lib/Gantt/feature/export/MspExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttMspExport", function() { return _lib_Gantt_feature_export_MspExport_js__WEBPACK_IMPORTED_MODULE_337__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MspExport", function() { return _lib_Gantt_feature_export_MspExport_js__WEBPACK_IMPORTED_MODULE_337__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttDom_js__WEBPACK_IMPORTED_MODULE_338__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttDom.js */ "./lib/Gantt/view/mixin/GanttDom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttDom", function() { return _lib_Gantt_view_mixin_GanttDom_js__WEBPACK_IMPORTED_MODULE_338__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttRegions_js__WEBPACK_IMPORTED_MODULE_339__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttRegions.js */ "./lib/Gantt/view/mixin/GanttRegions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttRegions", function() { return _lib_Gantt_view_mixin_GanttRegions_js__WEBPACK_IMPORTED_MODULE_339__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttScroll_js__WEBPACK_IMPORTED_MODULE_340__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttScroll.js */ "./lib/Gantt/view/mixin/GanttScroll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttScroll", function() { return _lib_Gantt_view_mixin_GanttScroll_js__WEBPACK_IMPORTED_MODULE_340__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttState_js__WEBPACK_IMPORTED_MODULE_341__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttState.js */ "./lib/Gantt/view/mixin/GanttState.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttState", function() { return _lib_Gantt_view_mixin_GanttState_js__WEBPACK_IMPORTED_MODULE_341__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttStores_js__WEBPACK_IMPORTED_MODULE_342__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttStores.js */ "./lib/Gantt/view/mixin/GanttStores.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttStores", function() { return _lib_Gantt_view_mixin_GanttStores_js__WEBPACK_IMPORTED_MODULE_342__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_GanttTimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_343__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/GanttTimelineDateMapper.js */ "./lib/Gantt/view/mixin/GanttTimelineDateMapper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttTimelineDateMapper", function() { return _lib_Gantt_view_mixin_GanttTimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_343__["default"]; });

/* harmony import */ var _lib_Gantt_view_mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_344__ = __webpack_require__(/*! ../lib/Gantt/view/mixin/TaskNavigation.js */ "./lib/Gantt/view/mixin/TaskNavigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskNavigation", function() { return _lib_Gantt_view_mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_344__["default"]; });

/* harmony import */ var _lib_Gantt_view_Gantt_js__WEBPACK_IMPORTED_MODULE_345__ = __webpack_require__(/*! ../lib/Gantt/view/Gantt.js */ "./lib/Gantt/view/Gantt.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Gantt", function() { return _lib_Gantt_view_Gantt_js__WEBPACK_IMPORTED_MODULE_345__["default"]; });

/* harmony import */ var _lib_Gantt_view_GanttBase_js__WEBPACK_IMPORTED_MODULE_346__ = __webpack_require__(/*! ../lib/Gantt/view/GanttBase.js */ "./lib/Gantt/view/GanttBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttBase", function() { return _lib_Gantt_view_GanttBase_js__WEBPACK_IMPORTED_MODULE_346__["default"]; });

var productName = 'gantt'; //region Core
// File is symlinked with "grunt symlink" task

 //endregion
// region Engine
// Files are symlinked with "grunt symlink" task


 // endregion
//region Grid
// column













 // data


 // feature

























 // export feature










 // feature experimental

 // util

 // row

 // view








 // view mixin






 //endregion
//region Scheduler
// crud





 // crud mixin

 // data







 // data mixin












 // feature base






 // feature base

 // feature































 // feature mixin


 // export







 // features experimental

 // columns



 // model









 // model mixin





 // preset



 // util


 //view







 //view mixin
















 //view recurrence











 // widget



 // customElements

 //endregion
//region SchedulerPro
// data





 // data mixin


 // model







 // model mixin

 // column



 // mixin

 // widget












 // widget taskeditor











 // widget taskeditor mixin


 // feature





 // pro event layout


 // view mixin

 // view



 //endregion
//region Gantt
// column

































 //data








 // feature


















 //export




 // model








 // util


 // widget






 // feature experimental
// TODO: Remove GanttMspExport export alias for 5.0


 // view mixin







 // view


 //endregion

/***/ }),

/***/ "./webpack/webpack.entry.umd.js":
/*!**************************************!*\
  !*** ./webpack/webpack.entry.umd.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.entry.js */ "./webpack/webpack.entry.js");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./webpack.entry.wc.js */ "./webpack/webpack.entry.wc.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__["WidgetTag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineBaseTag", function() { return _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__["TimelineBaseTag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttTag", function() { return _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__["GanttTag"]; });

var productName = 'gantt'; // Export library

 // Export WebComponents

 // UMD inject anchor. Do not edit ot remove this last line.

/***/ }),

/***/ "./webpack/webpack.entry.wc.js":
/*!*************************************!*\
  !*** ./webpack/webpack.entry.wc.js ***!
  \*************************************/
/*! exports provided: WidgetTag, TimelineBaseTag, GanttTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_core_entry_wc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.core.entry.wc.js */ "./webpack/webpack.core.entry.wc.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _webpack_core_entry_wc_js__WEBPACK_IMPORTED_MODULE_0__["WidgetTag"]; });

/* harmony import */ var _lib_Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/Scheduler/customElements/TimelineBaseTag.js */ "./lib/Scheduler/customElements/TimelineBaseTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimelineBaseTag", function() { return _lib_Scheduler_customElements_TimelineBaseTag_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _lib_Gantt_customElements_GanttTag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/Gantt/customElements/GanttTag.js */ "./lib/Gantt/customElements/GanttTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GanttTag", function() { return _lib_Gantt_customElements_GanttTag_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

var productName = 'gantt'; // File is symlinked with "grunt symlink" task

 // region WebComponents


 // endregion

/***/ })

/******/ });
});
//# sourceMappingURL=gantt.umd.js.map